/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1264);
	module.exports = __webpack_require__(224);


/***/ },
/* 1 */
[1674, 91],
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(13), __webpack_require__(1), __webpack_require__(22)) :
		typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
		(factory((global.mobxReact = {}),global.mobx,global.React,global.ReactDOM));
	}(this, (function (exports,mobx,React,reactDom) { 'use strict';
	
	var React__default = 'default' in React ? React['default'] : React;
	
	// These functions can be stubbed out in specific environments
	var unstable_batchedUpdates$1 = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var EventEmitter = function () {
	    function EventEmitter() {
	        classCallCheck(this, EventEmitter);
	        this.listeners = [];
	    }
	
	    createClass(EventEmitter, [{
	        key: "on",
	        value: function on(cb) {
	            var _this = this;
	
	            this.listeners.push(cb);
	            return function () {
	                var index = _this.listeners.indexOf(cb);
	                if (index !== -1) _this.listeners.splice(index, 1);
	            };
	        }
	    }, {
	        key: "emit",
	        value: function emit(data) {
	            this.listeners.forEach(function (fn) {
	                return fn(data);
	            });
	        }
	    }]);
	    return EventEmitter;
	}();
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty$1 = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty$1(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};
	
	// Copied from React.PropTypes
	function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	            rest[_key - 6] = arguments[_key];
	        }
	
	        return mobx.untracked(function () {
	            componentName = componentName || "<<anonymous>>";
	            propFullName = propFullName || propName;
	            if (props[propName] == null) {
	                if (isRequired) {
	                    var actual = props[propName] === null ? "null" : "undefined";
	                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
	                }
	                return null;
	            } else {
	                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	            }
	        });
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	}
	
	// Copied from React.PropTypes
	function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === "symbol") {
	        return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue["@@toStringTag"] === "Symbol") {
	        return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === "function" && propValue instanceof Symbol) {
	        return true;
	    }
	
	    return false;
	}
	
	// Copied from React.PropTypes
	function getPropType(propValue) {
	    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
	    if (Array.isArray(propValue)) {
	        return "array";
	    }
	    if (propValue instanceof RegExp) {
	        // Old webkits (at least until Android 4.0) return 'function' rather than
	        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	        // passes PropTypes.object.
	        return "object";
	    }
	    if (isSymbol(propType, propValue)) {
	        return "symbol";
	    }
	    return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// Copied from React.PropTypes
	function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === "object") {
	        if (propValue instanceof Date) {
	            return "date";
	        } else if (propValue instanceof RegExp) {
	            return "regexp";
	        }
	    }
	    return propType;
	}
	
	function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        return mobx.untracked(function () {
	            if (allowNativeType) {
	                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
	            }
	            var mobxChecker = void 0;
	            switch (mobxType) {
	                case "Array":
	                    mobxChecker = mobx.isObservableArray;
	                    break;
	                case "Object":
	                    mobxChecker = mobx.isObservableObject;
	                    break;
	                case "Map":
	                    mobxChecker = mobx.isObservableMap;
	                    break;
	                default:
	                    throw new Error("Unexpected mobxType: " + mobxType);
	            }
	            var propValue = props[propName];
	            if (!mobxChecker(propValue)) {
	                var preciseType = getPreciseType(propValue);
	                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
	                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
	            }
	            return null;
	        });
	    });
	}
	
	function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	            rest[_key2 - 5] = arguments[_key2];
	        }
	
	        return mobx.untracked(function () {
	            if (typeof typeChecker !== "function") {
	                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
	            }
	            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
	            if (error instanceof Error) return error;
	            var propValue = props[propName];
	            for (var i = 0; i < propValue.length; i++) {
	                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
	                if (error instanceof Error) return error;
	            }
	            return null;
	        });
	    });
	}
	
	var observableArray = createObservableTypeCheckerCreator(false, "Array");
	var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
	var observableMap = createObservableTypeCheckerCreator(false, "Map");
	var observableObject = createObservableTypeCheckerCreator(false, "Object");
	var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
	var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
	var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");
	
	
	
	var propTypes = Object.freeze({
		observableArray: observableArray,
		observableArrayOf: observableArrayOf,
		observableMap: observableMap,
		observableObject: observableObject,
		arrayOrObservableArray: arrayOrObservableArray,
		arrayOrObservableArrayOf: arrayOrObservableArrayOf,
		objectOrObservableObject: objectOrObservableObject
	});
	
	function isStateless(component) {
	    // `function() {}` has prototype, but `() => {}` doesn't
	    // `() => {}` via Babel has prototype too.
	    return !(component.prototype && component.prototype.render);
	}
	
	var injectorContextTypes = {
	    mobxStores: objectOrObservableObject
	};
	Object.seal(injectorContextTypes);
	
	var proxiedInjectorProps = {
	    contextTypes: {
	        get: function get$$1() {
	            return injectorContextTypes;
	        },
	        set: function set$$1(_) {
	            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
	        },
	        configurable: true,
	        enumerable: false
	    },
	    isMobxInjector: {
	        value: true,
	        writable: true,
	        configurable: true,
	        enumerable: true
	    }
	
	    /**
	     * Store Injection
	     */
	};function createStoreInjector(grabStoresFn, component, injectNames) {
	    var _class, _temp2;
	
	    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
	    if (injectNames) displayName += "-with-" + injectNames;
	
	    var Injector = (_temp2 = _class = function (_Component) {
	        inherits(Injector, _Component);
	
	        function Injector() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            classCallCheck(this, Injector);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
	                _this.wrappedInstance = instance;
	            }, _temp), possibleConstructorReturn(_this, _ret);
	        }
	
	        createClass(Injector, [{
	            key: "render",
	            value: function render() {
	                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
	                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
	                // See this test: 'using a custom injector is not too reactive' in inject.js
	                var newProps = {};
	                for (var key in this.props) {
	                    if (this.props.hasOwnProperty(key)) {
	                        newProps[key] = this.props[key];
	                    }
	                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
	                for (var _key2 in additionalProps) {
	                    newProps[_key2] = additionalProps[_key2];
	                }
	
	                if (!isStateless(component)) {
	                    newProps.ref = this.storeRef;
	                }
	
	                return React.createElement(component, newProps);
	            }
	        }]);
	        return Injector;
	    }(React.Component), _class.displayName = displayName, _temp2);
	
	    // Static fields from component should be visible on the generated Injector
	
	    hoistNonReactStatics(Injector, component);
	
	    Injector.wrappedComponent = component;
	    Object.defineProperties(Injector, proxiedInjectorProps);
	
	    return Injector;
	}
	
	function grabStoresByName(storeNames) {
	    return function (baseStores, nextProps) {
	        storeNames.forEach(function (storeName) {
	            if (storeName in nextProps // prefer props over stores
	            ) return;
	            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
	            nextProps[storeName] = baseStores[storeName];
	        });
	        return nextProps;
	    };
	}
	
	/**
	 * higher order component that injects stores to a child.
	 * takes either a varargs list of strings, which are stores read from the context,
	 * or a function that manually maps the available stores from the context to props:
	 * storesToProps(mobxStores, props, context) => newProps
	 */
	function inject() /* fn(stores, nextProps) or ...storeNames */{
	    var grabStoresFn = void 0;
	    if (typeof arguments[0] === "function") {
	        grabStoresFn = arguments[0];
	        return function (componentClass) {
	            var injected = createStoreInjector(grabStoresFn, componentClass);
	            injected.isMobxInjector = false; // supress warning
	            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
	            // see #111
	            injected = observer(injected);
	            injected.isMobxInjector = true; // restore warning
	            return injected;
	        };
	    } else {
	        var storeNames = [];
	        for (var i = 0; i < arguments.length; i++) {
	            storeNames[i] = arguments[i];
	        }grabStoresFn = grabStoresByName(storeNames);
	        return function (componentClass) {
	            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
	        };
	    }
	}
	
	/**
	 * dev tool support
	 */
	var isDevtoolsEnabled = false;
	
	var isUsingStaticRendering = false;
	
	var warnedAboutObserverInjectDeprecation = false;
	
	// WeakMap<Node, Object>;
	var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
	var renderReporter = new EventEmitter();
	
	function findDOMNode$2(component) {
	    if (reactDom.findDOMNode) {
	        try {
	            return reactDom.findDOMNode(component);
	        } catch (e) {
	            // findDOMNode will throw in react-test-renderer, see:
	            // See https://github.com/mobxjs/mobx-react/issues/216
	            // Is there a better heuristic?
	            return null;
	        }
	    }
	    return null;
	}
	
	function reportRendering(component) {
	    var node = findDOMNode$2(component);
	    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);
	
	    renderReporter.emit({
	        event: "render",
	        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
	        totalTime: Date.now() - component.__$mobRenderStart,
	        component: component,
	        node: node
	    });
	}
	
	function trackComponents() {
	    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
	    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
	}
	
	function useStaticRendering(useStaticRendering) {
	    isUsingStaticRendering = useStaticRendering;
	}
	
	/**
	 * Errors reporter
	 */
	
	var errorsReporter = new EventEmitter();
	
	/**
	 * Utilities
	 */
	
	function patch(target, funcName) {
	    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var base = target[funcName];
	    var mixinFunc = reactiveMixin[funcName];
	    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
	        mixinFunc.apply(this, arguments);
	        base.apply(this, arguments);
	    } : function () {
	        base.apply(this, arguments);
	        mixinFunc.apply(this, arguments);
	    };
	
	    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
	    // ...but that breaks react-hot-loader, see #231...
	    target[funcName] = f;
	}
	
	function shallowEqual(objA, objB) {
	    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (is(objA, objB)) return true;
	    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
	        return false;
	    }
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length) return false;
	    for (var i = 0; i < keysA.length; i++) {
	        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function is(x, y) {
	    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (x === y) {
	        return x !== 0 || 1 / x === 1 / y;
	    } else {
	        return x !== x && y !== y;
	    }
	}
	
	/**
	 * ReactiveMixin
	 */
	var reactiveMixin = {
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        if (isUsingStaticRendering === true) return;
	        // Generate friendly name for debugging
	        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
	        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;
	
	        /**
	         * If props are shallowly modified, react will render anyway,
	         * so atom.reportChanged() should not result in yet another re-render
	         */
	        var skipRender = false;
	        /**
	         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
	         * so detect these changes
	         */
	        var isForcingUpdate = false;
	
	        function makePropertyObservableReference(propName) {
	            var valueHolder = this[propName];
	            var atom = new mobx.Atom("reactive " + propName);
	            Object.defineProperty(this, propName, {
	                configurable: true,
	                enumerable: true,
	                get: function get$$1() {
	                    atom.reportObserved();
	                    return valueHolder;
	                },
	                set: function set$$1(v) {
	                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
	                        valueHolder = v;
	                        skipRender = true;
	                        atom.reportChanged();
	                        skipRender = false;
	                    } else {
	                        valueHolder = v;
	                    }
	                }
	            });
	        }
	
	        // make this.props an observable reference, see #124
	        makePropertyObservableReference.call(this, "props");
	        // make state an observable reference
	        makePropertyObservableReference.call(this, "state");
	
	        // wire up reactive render
	        var baseRender = this.render.bind(this);
	        var reaction = null;
	        var isRenderingPending = false;
	
	        var initialRender = function initialRender() {
	            reaction = new mobx.Reaction(initialName + "#" + rootNodeID + ".render()", function () {
	                if (!isRenderingPending) {
	                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
	                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
	                    // See #85 / Pull #44
	                    isRenderingPending = true;
	                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
	                    if (_this.__$mobxIsUnmounted !== true) {
	                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
	                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
	                        // However, people also claim this migth happen during unit tests..
	                        var hasError = true;
	                        try {
	                            isForcingUpdate = true;
	                            if (!skipRender) React.Component.prototype.forceUpdate.call(_this);
	                            hasError = false;
	                        } finally {
	                            isForcingUpdate = false;
	                            if (hasError) reaction.dispose();
	                        }
	                    }
	                }
	            });
	            reaction.reactComponent = _this;
	            reactiveRender.$mobx = reaction;
	            _this.render = reactiveRender;
	            return reactiveRender();
	        };
	
	        var reactiveRender = function reactiveRender() {
	            isRenderingPending = false;
	            var exception = undefined;
	            var rendering = undefined;
	            reaction.track(function () {
	                if (isDevtoolsEnabled) {
	                    _this.__$mobRenderStart = Date.now();
	                }
	                try {
	                    rendering = mobx.extras.allowStateChanges(false, baseRender);
	                } catch (e) {
	                    exception = e;
	                }
	                if (isDevtoolsEnabled) {
	                    _this.__$mobRenderEnd = Date.now();
	                }
	            });
	            if (exception) {
	                errorsReporter.emit(exception);
	                throw exception;
	            }
	            return rendering;
	        };
	
	        this.render = initialRender;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        if (isUsingStaticRendering === true) return;
	        this.render.$mobx && this.render.$mobx.dispose();
	        this.__$mobxIsUnmounted = true;
	        if (isDevtoolsEnabled) {
	            var node = findDOMNode$2(this);
	            if (node && componentByNodeRegistery) {
	                componentByNodeRegistery.delete(node);
	            }
	            renderReporter.emit({
	                event: "destroy",
	                component: this,
	                node: node
	            });
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (isUsingStaticRendering) {
	            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
	        }
	        // update on any state changes (as is the default)
	        if (this.state !== nextState) {
	            return true;
	        }
	        // update if props are shallowly not equal, inspired by PureRenderMixin
	        // we could return just 'false' here, and avoid the `skipRender` checks etc
	        // however, it is nicer if lifecycle events are triggered like usually,
	        // so we return true here if props are shallowly modified.
	        return !shallowEqual(this.props, nextProps);
	    }
	
	    /**
	     * Observer function / decorator
	     */
	};function observer(arg1, arg2) {
	    if (typeof arg1 === "string") {
	        throw new Error("Store names should be provided as array");
	    }
	    if (Array.isArray(arg1)) {
	        // component needs stores
	        if (!warnedAboutObserverInjectDeprecation) {
	            warnedAboutObserverInjectDeprecation = true;
	            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
	        }
	        if (!arg2) {
	            // invoked as decorator
	            return function (componentClass) {
	                return observer(arg1, componentClass);
	            };
	        } else {
	            return inject.apply(null, arg1)(observer(arg2));
	        }
	    }
	    var componentClass = arg1;
	
	    if (componentClass.isMobxInjector === true) {
	        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
	    }
	
	    // Stateless function component:
	    // If it is function but doesn't seem to be a react class constructor,
	    // wrap it to a react class automatically
	    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React.Component.isPrototypeOf(componentClass)) {
	        var _class, _temp;
	
	        return observer((_temp = _class = function (_Component) {
	            inherits(_class, _Component);
	
	            function _class() {
	                classCallCheck(this, _class);
	                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	            }
	
	            createClass(_class, [{
	                key: "render",
	                value: function render() {
	                    return componentClass.call(this, this.props, this.context);
	                }
	            }]);
	            return _class;
	        }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
	    }
	
	    if (!componentClass) {
	        throw new Error("Please pass a valid component to 'observer'");
	    }
	
	    var target = componentClass.prototype || componentClass;
	    mixinLifecycleEvents(target);
	    componentClass.isMobXReactObserver = true;
	    return componentClass;
	}
	
	function mixinLifecycleEvents(target) {
	    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
	        patch(target, funcName);
	    });
	    if (!target.shouldComponentUpdate) {
	        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
	    }
	}
	
	// TODO: support injection somehow as well?
	var Observer = observer(function (_ref) {
	    var children = _ref.children,
	        observerInject = _ref.inject,
	        render = _ref.render;
	
	    var component = children || render;
	    if (typeof component === "undefined") {
	        return null;
	    }
	    if (!observerInject) {
	        return component();
	    }
	    var InjectComponent = inject(observerInject)(component);
	    return React__default.createElement(InjectComponent, null);
	});
	
	Observer.displayName = "Observer";
	
	var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
	    var extraKey = key === "children" ? "render" : "children";
	    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
	        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
	    }
	
	    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
	        return;
	    }
	    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
	};
	
	Observer.propTypes = {
	    render: ObserverPropsCheck,
	    children: ObserverPropsCheck
	};
	
	var _class;
	var _temp;
	
	var specialReactKeys = { children: true, key: true, ref: true };
	
	var Provider = (_temp = _class = function (_Component) {
	    inherits(Provider, _Component);
	
	    function Provider() {
	        classCallCheck(this, Provider);
	        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
	    }
	
	    createClass(Provider, [{
	        key: "render",
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }, {
	        key: "getChildContext",
	        value: function getChildContext() {
	            var stores = {};
	            // inherit stores
	            var baseStores = this.context.mobxStores;
	            if (baseStores) for (var key in baseStores) {
	                stores[key] = baseStores[key];
	            }
	            // add own stores
	            for (var _key in this.props) {
	                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
	            }return {
	                mobxStores: stores
	            };
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            // Maybe this warning is too aggressive?
	            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
	            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
	                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
	            }
	        }
	    }]);
	    return Provider;
	}(React.Component), _class.contextTypes = {
	    mobxStores: objectOrObservableObject
	}, _class.childContextTypes = {
	    mobxStores: objectOrObservableObject.isRequired
	}, _temp);
	
	if (!React.Component) throw new Error("mobx-react requires React to be available");
	if (!mobx.extras) throw new Error("mobx-react requires mobx to be available");
	
	if (typeof reactDom.unstable_batchedUpdates === "function") mobx.extras.setReactionScheduler(reactDom.unstable_batchedUpdates);else if (typeof unstable_batchedUpdates$1 === "function") mobx.extras.setReactionScheduler(unstable_batchedUpdates$1);
	
	var onError = function onError(fn) {
	    return errorsReporter.on(fn);
	};
	
	/* DevTool support */
	// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js
	
	if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
	    var mobx$1 = { spy: mobx.spy, extras: mobx.extras };
	    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
	}
	
	exports.propTypes = propTypes;
	exports.PropTypes = propTypes;
	exports.onError = onError;
	exports.observer = observer;
	exports.Observer = Observer;
	exports.renderReporter = renderReporter;
	exports.componentByNodeRegistery = componentByNodeRegistery;
	exports.trackComponents = trackComponents;
	exports.useStaticRendering = useStaticRendering;
	exports.Provider = Provider;
	exports.inject = inject;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(1036)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = translate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	function translate(key) {
	  return function (Component) {
	    var TranslationComponent = function (_React$Component) {
	      _inherits(TranslationComponent, _React$Component);
	
	      function TranslationComponent() {
	        _classCallCheck(this, TranslationComponent);
	
	        return _possibleConstructorReturn(this, (TranslationComponent.__proto__ || Object.getPrototypeOf(TranslationComponent)).apply(this, arguments));
	      }
	
	      _createClass(TranslationComponent, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          // Get the current translation data
	          var SessionStore = this.props.store.SessionStore;
	
	          if (!SessionStore.translationLoaded) {
	            SessionStore.getTranslation(SessionStore.locale);
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var SessionStore = this.props.store.SessionStore;
	
	
	          if (SessionStore.translation) {
	            // Return the translation for the provided component (key)
	            var translation = SessionStore.translation[key];
	            return _react2.default.createElement(Component, Object.assign({}, this.props, { translation: translation }));
	          } else {
	            return null;
	          }
	        }
	      }]);
	
	      return TranslationComponent;
	    }(_react2.default.Component);
	
	    return (0, _mobxReact.observer)(TranslationComponent);
	  };
	}

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.focusable = exports.OS_USER_AGENT_NAMES = exports.testGetUserMedia = exports.openExamDirect = exports.openExam = undefined;
	
	var _regenerator = __webpack_require__(56);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	// Store
	
	
	// Dependencies
	
	
	var openExam = exports.openExam = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e, exam, userData, examSession, redirect) {
	    var _this = this;
	
	    var installSid, examSid, sessionSid, url, data, win, int;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.prev = 0;
	            installSid = userData.installSid;
	            examSid = exam.sid;
	            sessionSid = examSession.sid || exam.examSession.sid;
	
	            url = function () {
	              var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        return _context.abrupt('return', _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/onboard').then(function (response) {
	                          console.log(response);
	                          return response.data;
	                        }).catch(function (e) {
	                          console.error(e);
	                        }));
	
	                      case 1:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this);
	              }));
	
	              return function url() {
	                return _ref2.apply(this, arguments);
	              };
	            }();
	
	            _context2.next = 7;
	            return url();
	
	          case 7:
	            data = _context2.sent;
	
	            console.log(data);
	
	            e.preventDefault();
	            if (data.version === "old") {
	              win = window.open(data.redirectUrl);
	              int = setInterval(function () {
	                try {
	                  if (win.location.href && win.location.href === _config.config.sessionEndRedirectUrl) {
	                    if (redirect) {
	                      window.location.href = '/';
	                      clearInterval(int);
	                    } else {
	                      window.location.reload();
	                      clearInterval(int);
	                    }
	                  } else if (win === null || win.closed) {
	                    if (redirect) {
	                      window.location.href = '/';
	                      clearInterval(int);
	                    } else {
	                      window.location.reload();
	                      clearInterval(int);
	                    }
	                  }
	                } catch (e) {}
	              }, 1000);
	            } else {
	              window.location.href = data.redirectUrl;
	            }
	            _context2.next = 16;
	            break;
	
	          case 13:
	            _context2.prev = 13;
	            _context2.t0 = _context2['catch'](0);
	
	            console.warn(_context2.t0);
	
	          case 16:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this, [[0, 13]]);
	  }));
	
	  return function openExam(_x, _x2, _x3, _x4, _x5) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var openExamDirect = exports.openExamDirect = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(installSid, examSid, sessionSid) {
	    var _this2 = this;
	
	    var url;
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            url = function () {
	              var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                  while (1) {
	                    switch (_context3.prev = _context3.next) {
	                      case 0:
	                        return _context3.abrupt('return', _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/onboard').then(function (response) {
	                          return response.data;
	                        }).catch(function (e) {
	                          console.error(e);
	                        }));
	
	                      case 1:
	                      case 'end':
	                        return _context3.stop();
	                    }
	                  }
	                }, _callee3, _this2);
	              }));
	
	              return function url() {
	                return _ref4.apply(this, arguments);
	              };
	            }();
	
	            _context4.next = 3;
	            return url();
	
	          case 3:
	            return _context4.abrupt('return', _context4.sent);
	
	          case 4:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function openExamDirect(_x6, _x7, _x8) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * Check if getUserMedia is supported
	 */
	var testGetUserMedia = exports.testGetUserMedia = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(errorCallback) {
	    var supported, testMedia, constraints, details;
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            supported = true;
	
	            if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
	              _context6.next = 10;
	              break;
	            }
	
	            testMedia = function () {
	              var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	                var stream;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                  while (1) {
	                    switch (_context5.prev = _context5.next) {
	                      case 0:
	                        _context5.prev = 0;
	                        _context5.next = 3;
	                        return navigator.mediaDevices.getUserMedia(constraints);
	
	                      case 3:
	                        stream = _context5.sent;
	
	                        console.log('Got media stream');
	
	                        if (!(stream.getTracks().length === 0)) {
	                          _context5.next = 9;
	                          break;
	                        }
	
	                        console.error('Got media stream, but no tracks exist!');
	
	                        if (errorCallback) {
	                          errorCallback(details);
	                        }
	
	                        return _context5.abrupt('return', false);
	
	                      case 9:
	
	                        stream.getTracks().forEach(function (track) {
	                          console.table(track);
	                        });
	
	                        stream.getTracks().forEach(function (track) {
	                          return track.stop();
	                        });
	
	                        return _context5.abrupt('return', true);
	
	                      case 14:
	                        _context5.prev = 14;
	                        _context5.t0 = _context5['catch'](0);
	
	                        console.error(_context5.t0);
	                        console.error('Could not get media stream!');
	
	                        if (errorCallback) {
	                          errorCallback(details);
	                        }
	
	                        return _context5.abrupt('return', false);
	
	                      case 20:
	                      case 'end':
	                        return _context5.stop();
	                    }
	                  }
	                }, _callee5, this, [[0, 14]]);
	              }));
	
	              return function testMedia() {
	                return _ref6.apply(this, arguments);
	              };
	            }();
	
	            // Safari on iOS (as of the 11 release) claims to support
	            // getUserMedia but chokes the constraints for some reason
	            // so we need to test setting up a stream and catch any errors
	            constraints = {
	              audio: true,
	              video: true
	            };
	            details = {
	              body: 'In order to use SmarterProctoring Automated, you need to allow webcam and microphone access.',
	              link: 'How do I allow access?',
	              linkUrl: 'https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=en&oco=0'
	            };
	            _context6.next = 7;
	            return testMedia();
	
	          case 7:
	            supported = _context6.sent;
	            _context6.next = 11;
	            break;
	
	          case 10:
	            // Definitely not supported
	            supported = false;
	
	          case 11:
	            return _context6.abrupt('return', supported);
	
	          case 12:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function testGetUserMedia(_x9) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	/*
	 * Handle custom keyboard interactions for Switch Inputs.
	 * Only for use for elements where className="switch-input" and type="checkbox".
	 */
	
	
	exports.removeEmptyQueryParams = removeEmptyQueryParams;
	exports.feeCurrencyFormatter = feeCurrencyFormatter;
	exports.toggleDrawer = toggleDrawer;
	exports.closeDrawer = closeDrawer;
	exports.startPayment = startPayment;
	exports.submitPayment = submitPayment;
	exports.closePayment = closePayment;
	exports.checkValidity = checkValidity;
	exports.toHours = toHours;
	exports.toTop = toTop;
	exports.confirm = confirm;
	exports.promptUser = promptUser;
	exports.roundTime = roundTime;
	exports.extractTime = extractTime;
	exports.getMapUrl = getMapUrl;
	exports.getURLSegment = getURLSegment;
	exports.pushHrefToRouting = pushHrefToRouting;
	exports.getParam = getParam;
	exports.getPath = getPath;
	exports.findAncestor = findAncestor;
	exports.flagPortrait = flagPortrait;
	exports.isLocalStorageSupported = isLocalStorageSupported;
	exports.getCookie = getCookie;
	exports.deleteCookie = deleteCookie;
	exports.launchVTC = launchVTC;
	exports.checkInput = checkInput;
	exports.inIframe = inIframe;
	exports.getInstructorAsProctor = getInstructorAsProctor;
	exports.formatTime = formatTime;
	exports.convertObjToQuery = convertObjToQuery;
	exports.approvalScope = approvalScope;
	exports.appliesTo = appliesTo;
	exports.handleSwitchInputKeys = handleSwitchInputKeys;
	exports.isDescendant = isDescendant;
	exports.sumValues = sumValues;
	exports.distanceToTop = distanceToTop;
	exports.atBottom = atBottom;
	exports.scrollToTop = scrollToTop;
	exports.formatQuery = formatQuery;
	exports.generateGuid = generateGuid;
	exports.versionCompare = versionCompare;
	exports.getCurrentOS = getCurrentOS;
	exports.getDesktopAppConfigForPlatform = getDesktopAppConfigForPlatform;
	exports.downloadURI = downloadURI;
	exports.dataURLtoFile = dataURLtoFile;
	exports.getOverlap = getOverlap;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(9);
	
	var _stores = __webpack_require__(100);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _customProtocolDetection = __webpack_require__(963);
	
	var _customProtocolDetection2 = _interopRequireDefault(_customProtocolDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function removeEmptyQueryParams(queryString) {
	  if (!queryString) return '';
	
	  // Check if the string starts with '?' and remove it temporarily.
	  var hasQuestionMark = queryString.startsWith('?');
	  var qs = hasQuestionMark ? queryString.slice(1) : queryString;
	
	  // Split the query string into individual parameters and filter out empty ones.
	  var filteredParams = qs.split('&').filter(function (param) {
	    var _param$split = param.split('='),
	        _param$split2 = _slicedToArray(_param$split, 2),
	        value = _param$split2[1];
	    // Keep the parameter if there's no '=' (i.e. a flag) or if the value is non-empty.
	
	
	    return value !== '';
	  });
	
	  // Reassemble the query string, preserving the leading '?' if it was present.
	  return hasQuestionMark ? '?' + filteredParams.join('&') : filteredParams.join('&');
	}
	
	function feeCurrencyFormatter(amount, currencyCode) {
	
	  var formattedValue = '';
	
	  switch (currencyCode) {
	    case 'USD':
	      formattedValue = '$' + amount;
	      break;
	    case 'CAD':
	      formattedValue = '$' + amount + ' ' + currencyCode;
	      break;
	    default:
	      formattedValue = amount;
	      break;
	  }
	  return formattedValue;
	}
	
	function toggleDrawer(e, component, drawerContent) {
	  if (e) {
	    e.preventDefault();
	  }
	
	  component.setState({
	    drawerOpen: true,
	    drawerContent: drawerContent
	  }, function () {
	    var drawer = document.querySelector('.drawer');
	
	    if (drawer) {
	      drawer.focus();
	    }
	  });
	}
	
	function closeDrawer(e, component, closePath, callback) {
	  if (e) {
	    e.preventDefault();
	  }
	
	  document.querySelector('body').classList.remove('drawer-open');
	
	  // Wait for the drawer to slide out before updating the URL
	  // or running a function
	  setTimeout(function () {
	    component.setState({
	      drawerOpen: false,
	      drawerContent: null
	    });
	
	    if (closePath) {
	      component.props.routing.push(closePath);
	    }
	
	    if (callback) {
	      callback();
	    }
	
	    // Make sure the close button will show up the next time a drawer opens
	    _stores2.default.SessionStore.hideDrawerClose = false;
	  }, 250);
	
	  // Focus the main content
	  setTimeout(function () {
	    var content = document.querySelector('#main-content');
	
	    if (content) {
	      content.focus();
	    }
	  });
	}
	
	function startPayment(e, component) {
	  _stores2.default.SessionStore.startPayment();
	}
	
	function submitPayment(e, component) {
	  _stores2.default.SessionStore.submitPayment();
	}
	
	function closePayment() {
	  setTimeout(function () {
	    _stores2.default.SessionStore.closePayment();
	  }, 1000);
	}
	
	// Check form validity before submission
	function checkValidity(e, submitFunction, selector, invalidCallback) {
	  e.preventDefault();
	
	  var form = null;
	
	  if (selector) {
	    form = document.querySelector(selector);
	  } else {
	    form = e.target;
	  }
	
	  form.classList.add('submitted');
	
	  var ie = false;
	  var oldMoz = false;
	  var safari = false;
	  var edge = false;
	  var puffin = false;
	  var invalidFields = [];
	
	  if (document.querySelector('html').className.indexOf('ie-true') > -1) {
	    ie = true;
	  }
	
	  if (navigator.userAgent.indexOf('Firefox') && parseInt(navigator.userAgent.slice(-4), 10) < 51) {
	    oldMoz = true;
	  }
	
	  if (navigator.userAgent.indexOf('Safari')) {
	    safari = true;
	  }
	
	  if (navigator.userAgent.indexOf('Edge/14') > -1 || navigator.userAgent.indexOf('Edge/15') > -1 || navigator.userAgent.indexOf('Edge/16') > -1 || navigator.userAgent.indexOf('Edge/17') > -1) {
	    edge = true;
	  }
	
	  if (navigator.userAgent.indexOf('Puffin') > -1) {
	    puffin = true;
	  }
	
	  // Old versions of Firefox and IE don’t support one of the invalid selectors used below
	  if (!ie && !oldMoz && !edge && !puffin && !safari) {
	    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], input[aria-invalid="true"]:not(:placeholder-shown)');
	  } else if (edge) {
	    invalidFields = form.querySelectorAll('input[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"]');
	  } else {
	    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"]');
	  }
	
	  if (!invalidFields.length) {
	    if (submitFunction) {
	      submitFunction(e);
	    }
	
	    // Remove error message
	    var existingErrorMsg = form.querySelector('.note--error');
	
	    if (existingErrorMsg) {
	      existingErrorMsg.parentNode.removeChild(existingErrorMsg);
	    }
	  } else {
	    var _existingErrorMsg = form.querySelector('.note--error');
	
	    if (!_existingErrorMsg) {
	      var errorMsg = document.createElement('SPAN');
	      errorMsg.className = 'note note--prominent note--error';
	      errorMsg.innerHTML = 'Sorry, your form contained errors. Please correct the problems before submitting.';
	      var fields = form.querySelector('.fields:first-child');
	      var fieldsParent = fields.parentNode;
	      fieldsParent.insertBefore(errorMsg, fields);
	    }
	
	    if (invalidCallback) {
	      invalidCallback();
	    }
	
	    window.scrollTo(0, 0);
	  }
	}
	
	// Convert minutes to hours
	function toHours(time, isFirst, textOnly, unabbreviated) {
	  var hours = 'hr';
	  var minutes = 'min';
	
	  if (unabbreviated) {
	    hours = ' hour';
	    minutes = ' minute';
	  }
	
	  if (time >= 60) {
	    if (isFirst) {
	      if (textOnly) {
	        return time / 60;
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          time / 60
	        );
	      }
	    } else {
	      if (parseInt(time / 60, 10) > 1 && unabbreviated) {
	        hours = ' hours';
	      }
	
	      if (unabbreviated) {
	        minutes = 'minutes';
	      }
	
	      if (textOnly) {
	        var minuteText = time % 60 > 0 ? ' ' + time % 60 + ' ' + minutes : '';
	
	        return parseInt(time / 60, 10) + hours + minuteText;
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          parseInt(time / 60, 10),
	          ' ',
	          hours,
	          time % 60 > 0 && ' ' + time % 60 + ' ' + minutes
	        );
	      }
	    }
	  } else {
	    if (isFirst) {
	      if (textOnly) {
	        return time;
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          time
	        );
	      }
	    } else {
	      if (time > 1) {
	        minutes = ' minutes';
	      }
	
	      if (textOnly) {
	        return time + ' ' + minutes;
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          time,
	          ' ',
	          minutes
	        );
	      }
	    }
	  }
	}
	
	// Scroll to top of element
	function toTop(element) {
	  if (element) {
	    element.scrollTop = 0;
	  } else {
	    window.scrollTo(0, 0);
	  }
	}
	
	// Confirm
	function confirm(msg, func) {
	  var SessionStore = _stores2.default.SessionStore;
	
	  SessionStore.showConfirm(msg, func);
	}
	
	// Prompt
	function promptUser(msg, selectFunc, callback, text) {
	  var SessionStore = _stores2.default.SessionStore;
	
	  SessionStore.showPrompt(msg, selectFunc, callback, text);
	}
	
	// Round time
	function roundTime(time) {
	  if (time && time.minute() !== 0 && time.minute() !== 30) {
	    var remainder = 30 - time.minute() % 30;
	    return _moment2.default.utc(time).local().add('minutes', remainder).format('HH:mm');
	  }
	
	  return _moment2.default.utc(time).local().format('HH:mm');
	}
	
	// Extract time from date
	function extractTime(time) {
	  var userTimezone = _stores2.default.SessionStore.userTimezone;
	
	
	  if ((0, _moment2.default)(time, _moment2.default.ISO_8601).isValid()) {
	    return _moment2.default.utc(time).tz(userTimezone).format('HH:mm');
	  } else {
	    return '';
	  }
	}
	
	/**
	 * Get static map url from google maps API for a given <latitude, longitude> pair
	 * @export
	 * @param {number} latitude
	 * @param {number} longitude
	 * @returns {string}
	 */
	function getMapUrl(latitude, longitude) {
	  return 'https://maps.googleapis.com/maps/api/staticmap?center=' + latitude + ',' + longitude + ('&zoom=16&scale=2&size=400x250&maptype=roadmap&key=' + _config.config.mapsApiKey) + ('&format=png&visual_refresh=true&markers=icon:' + _config.config.domain + '/static/img/marker.png?v=1%7C' + latitude + ',' + longitude);
	}
	
	/**
	 * Get URL segments
	 * @export
	 * @param {Component} component
	 * @param {number} segment
	 */
	function getURLSegment(component, segment) {
	  var pathname = component.props.routing.location.pathname;
	
	
	  var pathArray = pathname.split('/');
	
	  if (pathArray[0] === '') {
	    pathArray.splice(0, 1);
	  }
	
	  return pathArray[segment - 1];
	}
	
	/**
	 * Push the href, usually received from a html element event, to routing history
	 * @export
	 * @param {string} href
	 * @param {Component} component
	 */
	function pushHrefToRouting(href, component) {
	  // Regex to grab the domain name part of url
	  // For example grab 'http://www.url.com/' from 'http://www.url.com/page'
	  var domainRegex = /^(?:\/\/|[^\/]+)*\//;
	
	  // Replace the domain name and the '#' with empty string because the react router excludes them from path
	  // For example 'http://www.url.com/#/page' becomes '/page'
	  var path = href.replace(domainRegex, '').replace('#', '');
	
	  // Push the path to routing if it's not there already
	  if (component.props.routing.location.pathname !== path) {
	    component.props.routing.push(path);
	  }
	}
	
	/**
	 * Get query params from a string
	 * @export
	 * @param {name} string
	 * @param {url} string
	 */
	function getParam(name, url) {
	  name = name.replace(/[\[\]]/g, '\\$&');
	  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	  var results = regex.exec(url);
	
	  if (!results) {
	    return null;
	  }
	
	  if (!results[2]) {
	    return '';
	  }
	
	  return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}
	
	/**
	 * Get url path and query from a string
	 * @export
	 * @param {url} string
	 */
	function getPath(url) {
	  var parser = document.createElement('a');
	  parser.href = url;
	  var pathname = parser.pathname;
	  var search = parser.search;
	
	  return pathname + search;
	}
	
	/**
	 * Find ancestor by class
	 * @export
	 * @param {el} string
	 * @param {className} string
	 */
	function findAncestor(el, className) {
	  while (el.parentNode) {
	    el = el.parentNode;
	
	    if (el && el.classList.contains(className)) {
	      return el;
	    }
	  }
	
	  return null;
	}
	
	/**
	 * Flag portrait oriented image
	 * @export
	 * @param {e} string
	 * @param {src} string
	 */
	function flagPortrait(e, src) {
	  var img = new Image();
	  var imgEl = e.target;
	  var width = 0;
	  var height = 0;
	
	  img.onload = function () {
	    width = img.width;
	    height = img.height;
	
	    if (height > width) {
	      imgEl.className += ' portrait';
	    }
	  };
	
	  img.src = src;
	}
	
	/**
	 * Check if sessionStorage is available
	 * @export
	 */
	function isLocalStorageSupported() {
	  var testKey = 'test';
	  var storage = window.sessionStorage;
	
	  try {
	    storage.setItem(testKey, '1');
	    storage.removeItem(testKey);
	    return true;
	  } catch (error) {
	    return false;
	  }
	}
	
	/**
	 * Get cookie by name
	 * @export
	 * @param {name} string
	 */
	function getCookie(name) {
	  var match = document.cookie.match(new RegExp(name + '=([^;]+)'));
	
	  if (match) {
	    return match[1];
	  }
	}
	
	/**
	 * Delete cookie by name
	 * @export
	 * @param {name} string
	 */
	function deleteCookie(name) {
	  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}
	
	/**
	 * Launch VTC session or show download options
	 * @export
	 * @param {accessCode} string
	 */
	function launchVTC(accessCode, failCallback) {
	  (0, _customProtocolDetection2.default)('vtc://' + accessCode, failCallback);
	
	  var docClass = document.querySelector('html').className;
	
	  if (docClass && docClass.indexOf('safari') >= 0) {
	    // Protocol check fallback for Safari
	    var launchTimeout = setTimeout(function () {
	      failCallback();
	    }, 200);
	
	    window.addEventListener('blur', function () {
	      window.clearTimeout(launchTimeout);
	    });
	
	    window.location = 'vtc://' + accessCode;
	  }
	}
	
	/**
	 * Check if input type is supported
	 * @export
	 * @param {type} string
	 */
	function checkInput(type) {
	  var input = document.createElement('input');
	  input.setAttribute('type', type);
	  return input.type === type;
	}
	
	/**
	 * Check if document is in an iframe
	 * @export
	 */
	function inIframe() {
	  try {
	    return window.self !== window.top;
	  } catch (e) {
	    return true;
	  }
	}
	
	/**
	 * Get correct instructor as proctor settings
	 * @export
	 * @param {instructorAsProctor} array
	 * @param {instructorProctorSid} string
	 */
	function getInstructorAsProctor(instructorAsProctor, instructorProctorSid) {
	  var selectedIAP = null;
	
	  instructorAsProctor.forEach(function (setting) {
	    if (setting.sid === instructorProctorSid) {
	      selectedIAP = setting;
	    }
	  });
	
	  return selectedIAP;
	}
	
	/**
	 * Format time as 00:00:00
	 * @export
	 * @param {s} integer
	 */
	function formatTime(s) {
	  var seconds = Math.floor(s % 60);
	  var minutes = Math.floor(s / 60);
	  var hours = Math.floor(s / 360 / 60);
	
	  if (seconds < 10) {
	    seconds = '0' + seconds;
	  }
	
	  if (minutes < 10) {
	    minutes = '0' + minutes;
	  }
	
	  if (hours < 10) {
	    hours = '0' + hours;
	  }
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    hours,
	    ':',
	    minutes,
	    ':',
	    seconds
	  );
	}
	
	/**
	 * Convert object to query string
	 * @param {obj} object
	 **/
	function convertObjToQuery(obj) {
	  var _obj = obj ? obj : {};
	  var keys = Object.keys(_obj);
	
	  // Make sure we’re only using keys with a value
	  for (var i = 0; i < keys.length; i++) {
	    if (!_obj[keys[i]]) {
	      keys.splice(i, 1);
	      i--;
	    }
	  }
	
	  // Join all keys and values
	  var query = keys.map(function (x) {
	    return x + '=' + _obj[x];
	  }).join('&');
	
	  return keys.length === 0 ? '' : '?' + query;
	}
	
	/**
	 * Render proctor approval scope
	 * @param {approval} object
	 * @param {translation} object
	 **/
	function approvalScope(approval, translation) {
	  var scope = null;
	  var scopeData = null;
	  var appliesToData = {};
	
	  Object.keys(approval.appliesTo).forEach(function (prop) {
	    if (approval.appliesTo[prop]) {
	      scope = prop;
	      scopeData = approval.appliesTo[prop];
	    }
	  });
	
	  switch (scope) {
	    case 'applicationInstall':
	      appliesToData.title = translation.appliesTo.installation;
	      break;
	
	    case 'course':
	      appliesToData.title = translation.appliesTo.course;
	      appliesToData.course = scopeData.title;
	      break;
	
	    case 'enrollment':
	      appliesToData.title = translation.appliesTo.enrollment;
	      appliesToData.student = scopeData.firstName + ' ' + scopeData.lastName;
	      appliesToData.course = scopeData.courseTitle;
	      break;
	
	    case 'exam':
	      appliesToData.title = translation.appliesTo.exam;
	      appliesToData.exam = scopeData.title;
	      appliesToData.course = scopeData.courseTitle;
	      break;
	
	    case 'examSession':
	      appliesToData.title = translation.appliesTo.exam_session;
	      appliesToData.student = approval.requestedByUser.firstName + ' ' + approval.requestedByUser.lastName;
	      break;
	
	    case 'instructorUser':
	      appliesToData.title = translation.appliesTo.instructor;
	      appliesToData.instructor = scopeData.firstName + ' ' + scopeData.lastName;
	      break;
	
	    case 'studentUser':
	      appliesToData.title = translation.appliesTo.student;
	      appliesToData.student = scopeData.firstName + ' ' + scopeData.lastName;
	      break;
	
	    default:
	      appliesToData = {};
	      break;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'strong',
	      { className: 'table-note' },
	      appliesToData.title
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'table-list' },
	      Object.keys(appliesToData).map(function (key, i) {
	        if (key !== 'title') {
	          return _react2.default.createElement(
	            'li',
	            { key: i },
	            appliesToData[key]
	          );
	        }
	
	        return null;
	      })
	    )
	  );
	}
	
	/**
	 * Get proctor approval appliesTo
	 * @param {approval} object
	 **/
	function appliesTo(approval) {
	  var scope = null;
	
	  Object.keys(approval.appliesTo).forEach(function (prop) {
	    if (approval.appliesTo[prop]) {
	      scope = prop;
	    }
	  });
	
	  switch (scope) {
	    case 'applicationInstall':
	      scope = 'install';
	      break;
	
	    case 'examSession':
	      scope = 'session';
	      break;
	
	    case 'instructorUser':
	      scope = 'instructor';
	      break;
	
	    case 'studentUser':
	      scope = 'student';
	      break;
	
	    default:
	      break;
	  }
	
	  return scope;
	}function handleSwitchInputKeys(e) {
	  var keyCode = e.keyCode || e.which;
	  var ENTER_KEY = 13;
	  var LEFT_ARROW = 37;
	  var RIGHT_ARROW = 39;
	  var SPACE = 32;
	
	  switch (keyCode) {
	    case ENTER_KEY:
	      e.preventDefault();
	      e.target.click();
	      break;
	
	    case LEFT_ARROW:
	      e.preventDefault();
	      if (e.target.checked) {
	        e.target.click();
	      }
	      break;
	
	    case RIGHT_ARROW:
	      e.preventDefault();
	      if (!e.target.checked) {
	        e.target.click();
	      }
	      break;
	
	    case SPACE:
	      e.preventDefault();
	      e.target.click();
	      break;
	
	    default:
	      break;
	  }
	}
	
	/**
	 * isDescendant - Checks if an element is a descendant of a given parent
	 * @export
	 * @param {parent} element
	 * @param {child} element
	 * @return boolean
	 */
	function isDescendant(parent, child) {
	  var node = child.parentNode;
	
	  while (node !== null) {
	    if (node === parent) {
	      return true;
	    }
	
	    node = node.parentNode;
	  }
	
	  return false;
	}
	
	/**
	 * sumValues - Get the sum of a property value in an array of objects
	 * @param {array} array
	 * @param {string} key
	 */
	function sumValues(array, key) {
	  return array.reduce(function (a, b) {
	    return a + (b[key] || 0);
	  }, 0);
	}
	
	/**
	 * distanceToTop - Returns an element's distance from the top of the window
	 * @export
	 * @param {*} element
	 */
	function distanceToTop(element) {
	  return Math.floor(element.getBoundingClientRect().top);
	}
	
	/**
	 * atBottom - Returns a boolean, calculates if the window is scrolled to the bottom
	 * @export
	 */
	function atBottom() {
	  return window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
	}
	
	/**
	 * scrollToTop - Scrolls to the top of an element or window, sets programmatic focus
	 * @param {*} element
	 */
	function scrollToTop(event, element) {
	  var supported = 'scrollBehavior' in document.documentElement.style;
	  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	  var allowed = supported && !prefersReducedMotion;
	
	  event.preventDefault();
	
	  if (element) {
	    if (allowed) {
	      window.scroll({
	        top: element.offsetTop - 15,
	        left: 0,
	        behavior: 'smooth'
	      });
	      // Callback to set keyboard focus after scrolling is done.
	      // Use a buffer of 15 at the top of the element so that it
	      // doesn't look cramped.
	      var done = setInterval(function () {
	        if (distanceToTop(element) === 15 || atBottom()) {
	          element.tabIndex = '-1';
	          element.focus();
	          clearInterval(done);
	        }
	      }, 100);
	    } else {
	      element.tabIndex = '-1';
	      element.focus();
	    }
	  } else {
	    window.scrollTo(0, 0);
	  }
	}
	
	/**
	 * formatQuery - Takes an object and returns it as URL query parameters
	 * @param {object} query
	 */
	function formatQuery(query) {
	  var queryString = '';
	
	  for (var key in query) {
	    // Check to make sure the value in the key is defined
	    if (query[key]) {
	      if (!queryString) {
	        // If this is the first key, add a ?
	        queryString += '?';
	      } else {
	        // Otherwise, add a &
	        queryString += '&';
	      }
	
	      queryString += key + '=' + query[key];
	    }
	  }
	
	  return queryString;
	}
	
	/**
	 * Generate a random GUID
	 *
	 * @export
	 * @function generateGuid
	 * @returns {string}
	 */
	function generateGuid() {
	  var guid = '';
	
	  for (var i = 0; i < 32; i++) {
	    if (i === 8 || i === 12 || i === 16 || i === 20) {
	      guid += '-';
	    }
	
	    var digit = Math.floor(Math.random() * 16).toString(16).toUpperCase();
	
	    guid += digit;
	  }
	
	  return guid;
	}
	
	/*
	 * version Compare
	 * @param v1 - version like "17.0.1"
	 * @param v2 - version like "16.2.13"
	 * @param options
	 * @returns {number} - Returns 0 if equal, -1 if v1 < v2 and 1 if v1 > v2
	 */
	function versionCompare(v1, v2, options) {
	  var lexicographical = options && options.lexicographical,
	      zeroExtend = options && options.zeroExtend,
	      v1parts = v1.split('.'),
	      v2parts = v2.split('.');
	
	  function isValidPart(x) {
	    return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
	  }
	
	  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
	    return NaN;
	  }
	
	  if (zeroExtend) {
	    while (v1parts.length < v2parts.length) {
	      v1parts.push('0');
	    }while (v2parts.length < v1parts.length) {
	      v2parts.push('0');
	    }
	  }
	
	  if (!lexicographical) {
	    v1parts = v1parts.map(Number);
	    v2parts = v2parts.map(Number);
	  }
	
	  for (var i = 0; i < v1parts.length; ++i) {
	    if (v2parts.length === i) {
	      return 1;
	    }
	
	    if (v1parts[i] === v2parts[i]) {
	      continue;
	    } else if (v1parts[i] > v2parts[i]) {
	      return 1;
	    } else {
	      return -1;
	    }
	  }
	
	  if (v1parts.length !== v2parts.length) {
	    return -1;
	  }
	
	  return 0;
	}
	
	/**
	 * Names of the operating systems found in the navigator.userAgent
	 * @type {{linux: string, chromebook: string, windows: string, mac: string, unknown: string}}
	 */
	var OS_USER_AGENT_NAMES = exports.OS_USER_AGENT_NAMES = {
	  windows: 'Windows',
	  mac: 'Mac',
	  chromebook: 'CrOS',
	  linux: 'Linux',
	  unknown: 'Unknown'
	};
	
	/**
	 * Get OS Name
	 * @returns {string}
	 */
	function getCurrentOS() {
	  var currentOS = OS_USER_AGENT_NAMES.unknown;
	
	  if (navigator.appVersion.indexOf(OS_USER_AGENT_NAMES.windows) !== -1) {
	    currentOS = OS_USER_AGENT_NAMES.windows;
	  }
	
	  if (navigator.appVersion.indexOf(OS_USER_AGENT_NAMES.mac) !== -1) {
	    currentOS = OS_USER_AGENT_NAMES.mac;
	  }
	
	  if (navigator.appVersion.indexOf(OS_USER_AGENT_NAMES.chromebook) !== -1) {
	    currentOS = OS_USER_AGENT_NAMES.chromebook;
	  }
	
	  if (navigator.appVersion.indexOf(OS_USER_AGENT_NAMES.linux) !== -1) {
	    currentOS = OS_USER_AGENT_NAMES.linux;
	  }
	
	  return currentOS;
	}
	
	/**
	 * Get the proper download url for the platform
	 * @returns {string}
	 */
	function getDesktopAppConfigForPlatform() {
	  var os = getCurrentOS();
	  if (os === OS_USER_AGENT_NAMES.mac) {
	    return _config.config.desktopAppInfo.mac;
	  } else {
	    return _config.config.desktopAppInfo.widows;
	  }
	}
	
	/**
	 * When called it will initiate a download of the file
	 * @param uri
	 * @param name
	 */
	function downloadURI(uri, name) {
	  var link = document.createElement('a');
	  link.target = '_blank';
	  link.download = name;
	  link.href = uri;
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);
	  link.remove();
	}
	
	/**
	 * Selector for any HTML element that can receive keyboard focus
	 *
	 * @exports
	 */
	var focusable = exports.focusable = "a[href]:not([tabindex='-1']),area[href]:not([tabindex='-1']),input:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),textarea:not([disabled]):not([tabindex='-1']),button:not([disabled]):not([tabindex='-1']),iframe:not([tabindex='-1']),[tabindex]:not([tabindex='-1'])";
	
	/**
	* convert dataurl to file
	* @ param {string} dataurl - dataurl address
	* @ param {string} file name - file name
	*/
	// Create Blob file from URL
	
	function dataURLtoFile(dataUrl, fileName) {
	  var arr = dataUrl.split(','),
	      mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]),
	      n = bstr.length,
	      u8arr = new Uint8Array(n);
	  while (n--) {
	    u8arr[n] = bstr.charCodeAt(n);
	  }
	  return new File([u8arr], fileName, { type: mime });
	}
	
	function getOverlap(exam, record) {
	  if ((0, _moment2.default)(exam.examOpenDate).isBetween(record.weekStart, record.weekEnd) || (0, _moment2.default)(exam.examCloseDate).isBetween(record.weekStart, record.weekEnd) || (0, _moment2.default)(record.weekStart).isBetween(exam.examOpenDate, exam.examCloseDate) || (0, _moment2.default)(record.weekEnd).isBetween(exam.examOpenDate, exam.examCloseDate)) {
	    return true;
	  } else {
	    return false;
	  }
	}

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.iconAccess = iconAccess;
	exports.iconApple = iconApple;
	exports.iconArchive = iconArchive;
	exports.iconArrow = iconArrow;
	exports.iconBarChart = iconBarChart;
	exports.iconBadgeCheck = iconBadgeCheck;
	exports.iconCalendar = iconCalendar;
	exports.iconCalendarPlus = iconCalendarPlus;
	exports.iconCalendarTimes = iconCalendarTimes;
	exports.iconCamera = iconCamera;
	exports.iconCap = iconCap;
	exports.iconChainBroken = iconChainBroken;
	exports.iconCheck = iconCheck;
	exports.iconCheckCircle = iconCheckCircle;
	exports.iconCheckSquare = iconCheckSquare;
	exports.iconChevronDown = iconChevronDown;
	exports.iconChevronLeft = iconChevronLeft;
	exports.iconChevronRight = iconChevronRight;
	exports.iconChevronUp = iconChevronUp;
	exports.iconCircleRight = iconCircleRight;
	exports.iconCircleUp = iconCircleUp;
	exports.iconClipboardDisable = iconClipboardDisable;
	exports.iconClock = iconClock;
	exports.iconCloudDownload = iconCloudDownload;
	exports.iconCoffee = iconCoffee;
	exports.iconComment = iconComment;
	exports.iconContrast = iconContrast;
	exports.iconDashboard = iconDashboard;
	exports.iconDesktop = iconDesktop;
	exports.iconDesktopFullscreen = iconDesktopFullscreen;
	exports.iconDesktopRecord = iconDesktopRecord;
	exports.iconDesktopOne = iconDesktopOne;
	exports.iconDownload = iconDownload;
	exports.iconEdit = iconEdit;
	exports.iconEnvelope = iconEnvelope;
	exports.iconEraser = iconEraser;
	exports.iconExclamation = iconExclamation;
	exports.iconExtensionBlock = iconExtensionBlock;
	exports.iconDesktopAppCheck = iconDesktopAppCheck;
	exports.iconExternal = iconExternal;
	exports.iconEye = iconEye;
	exports.iconEyeSlash = iconEyeSlash;
	exports.iconFiles = iconFiles;
	exports.iconFolder = iconFolder;
	exports.iconFont = iconFont;
	exports.iconGraph = iconGraph;
	exports.iconHourglass = iconHourglass;
	exports.iconID = iconID;
	exports.iconIDBack = iconIDBack;
	exports.iconImport = iconImport;
	exports.iconInbox = iconInbox;
	exports.iconInfo = iconInfo;
	exports.iconLaptop = iconLaptop;
	exports.iconLightbulb = iconLightbulb;
	exports.iconLink = iconLink;
	exports.iconList = iconList;
	exports.iconLock = iconLock;
	exports.iconMicrophone = iconMicrophone;
	exports.iconMinus = iconMinus;
	exports.iconMobile = iconMobile;
	exports.iconMoon = iconMoon;
	exports.iconNo = iconNo;
	exports.iconPage = iconPage;
	exports.iconPaper = iconPaper;
	exports.iconPaperclip = iconPaperclip;
	exports.iconPause = iconPause;
	exports.iconPencil = iconPencil;
	exports.iconPencilPaper = iconPencilPaper;
	exports.iconPhone = iconPhone;
	exports.iconPlay = iconPlay;
	exports.iconPlus = iconPlus;
	exports.iconPower = iconPower;
	exports.iconPrint = iconPrint;
	exports.iconPrintDisable = iconPrintDisable;
	exports.iconQuestion = iconQuestion;
	exports.iconRandom = iconRandom;
	exports.iconRedo = iconRedo;
	exports.iconRefresh = iconRefresh;
	exports.iconReply = iconReply;
	exports.iconRightClickDisable = iconRightClickDisable;
	exports.iconScale = iconScale;
	exports.iconSettings = iconSettings;
	exports.iconStop = iconStop;
	exports.iconTabsClose = iconTabsClose;
	exports.iconTabsOne = iconTabsOne;
	exports.iconTimes = iconTimes;
	exports.iconTimesCircle = iconTimesCircle;
	exports.iconTrash = iconTrash;
	exports.iconUndo = iconUndo;
	exports.iconUnlock = iconUnlock;
	exports.iconUniversity = iconUniversity;
	exports.iconUpload = iconUpload;
	exports.iconUser = iconUser;
	exports.iconUsers = iconUsers;
	exports.iconVideoCamera = iconVideoCamera;
	exports.iconVideoCamera360 = iconVideoCamera360;
	exports.iconVolumeOff = iconVolumeOff;
	exports.iconVolumeUp = iconVolumeUp;
	exports.iconWifi = iconWifi;
	exports.iconWindows = iconWindows;
	exports.iconAttended = iconAttended;
	exports.iconUnattended = iconUnattended;
	exports.iconIndividual = iconIndividual;
	exports.iconInstructor = iconInstructor;
	exports.iconTestingCenters = iconTestingCenters;
	exports.iconCentersIndivuals = iconCentersIndivuals;
	exports.iconExamity = iconExamity;
	exports.iconProctorU = iconProctorU;
	exports.icon_injured = icon_injured;
	exports.icon_technical = icon_technical;
	exports.icon_space = icon_space;
	exports.icon_outside_help = icon_outside_help;
	exports.icon_non_permitted_items = icon_non_permitted_items;
	exports.icon_noisy = icon_noisy;
	exports.icon_ill = icon_ill;
	exports.icon_time = icon_time;
	exports.icon_other = icon_other;
	exports.icon_file = icon_file;
	exports.icon_image = icon_image;
	exports.icon_pdf = icon_pdf;
	exports.icon_text = icon_text;
	exports.icon_spreadsheet = icon_spreadsheet;
	exports.icon_video = icon_video;
	exports.icon_audio = icon_audio;
	exports.icon_zip = icon_zip;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function iconAccess() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-access", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-access-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-access-title" },
	      "Access"
	    ),
	    _react2.default.createElement("path", { d: "M1374 657q-6-26-28.5-39.5t-48.5-7.5q-261 62-401 62t-401-62q-26-6-48.5 7.5t-28.5 39.5 7.5 48.5 39.5 28.5q194 46 303 58-2 158-15.5 269t-26.5 155.5-41 115.5l-9 21q-10 25 1 49t36 34q9 4 23 4 44 0 60-41l8-20q54-139 71-259h42q17 120 71 259l8 20q16 41 60 41 14 0 23-4 25-10 36-34t1-49l-9-21q-28-71-41-115.5t-26.5-155.5-15.5-269q109-12 303-58 26-6 39.5-28.5t7.5-48.5zm-350-145q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm576 384q0 143-55.5 273.5t-150 225-225 150-273.5 55.5-273.5-55.5-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5zm-704-768q-156 0-298 61t-245 164-164 245-61 298 61 298 164 245 245 164 298 61 298-61 245-164 164-245 61-298-61-298-164-245-245-164-298-61zm896 768q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z" })
	  );
	}
	
	function iconApple() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-apple", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-apple-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-apple-title" },
	      "Apple"
	    ),
	    _react2.default.createElement("path", { d: "M1585 1215q-39 125-123 250-129 196-257 196-49 0-140-32-86-32-151-32-61 0-142 33-81 34-132 34-152 0-301-259-147-261-147-503 0-228 113-374 113-144 284-144 72 0 177 30 104 30 138 30 45 0 143-34 102-34 173-34 119 0 213 65 52 36 104 100-79 67-114 118-65 94-65 207 0 124 69 223t158 126zm-376-1173q0 61-29 136-30 75-93 138-54 54-108 72-37 11-104 17 3-149 78-257 74-107 250-148 1 3 2.5 11t2.5 11q0 4 .5 10t.5 10z" })
	  );
	}
	
	function iconArchive() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-archive", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-archive-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-archive-title" },
	      "Archive"
	    ),
	    _react2.default.createElement("path", { d: "M1088 832q0-26-19-45t-45-19h-256q-26 0-45 19t-19 45 19 45 45 19h256q26 0 45-19t19-45zm576-192v960q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-960q0-26 19-45t45-19h1408q26 0 45 19t19 45zm64-448v256q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1536q26 0 45 19t19 45z" })
	  );
	}
	
	function iconArrow() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-arrow", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-arrow-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-arrow-title" },
	      "Arrow"
	    ),
	    _react2.default.createElement("path", { d: "M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z" })
	  );
	}
	
	function iconBarChart() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-bar-chart", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-bar-chart-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-bar-chart-title" },
	      "Bar Chart"
	    ),
	    _react2.default.createElement("path", { d: "M640 896v512h-256v-512h256zm384-512v1024h-256v-1024h256zm1024 1152v128h-2048v-1536h128v1408h1920zm-640-896v768h-256v-768h256zm384-384v1152h-256v-1152h256z" })
	  );
	}
	
	function iconBadgeCheck() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-badge-check", xmlns: "http://www.w3.org/2000/svg", width: "128", height: "128", viewBox: "0 0 128 128", "aria-labelledby": "icn-badge-check-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-badge-check-title" },
	      "Badge check"
	    ),
	    _react2.default.createElement("path", { d: "M75.2372 7.50677L64 0L52.7628 7.50677L39.5083 4.87171L31.9992 16.1074L18.7452 18.7452L16.1074 31.9992L4.87171 39.5083L7.50677 52.7628L0 64L7.50677 75.2372L4.87171 88.4917L16.1074 96.0008L18.7452 109.255L31.9992 111.893L39.5083 123.128L52.7628 120.493L64 128L75.2372 120.493L88.4917 123.128L96.0008 111.893L109.255 109.255L111.893 96.0008L123.128 88.4917L120.493 75.2372L128 64L120.493 52.7628L123.128 39.5083L111.893 31.9992L109.255 18.7452L96.0008 16.1074L88.4917 4.87171L75.2372 7.50677ZM55.7487 71.6413L87.9221 39.468L97.2029 48.7487L65.0295 80.9221L55.7487 90.2029L31 65.4541L40.2808 56.1734L55.7487 71.6413Z" })
	  );
	}
	
	function iconCalendar() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-calendar", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-calendar-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-calendar-title" },
	      "Calendar"
	    ),
	    _react2.default.createElement("path", { d: "M192 1664h288v-288h-288v288zm352 0h320v-288h-320v288zm-352-352h288v-320h-288v320zm352 0h320v-320h-320v320zm-352-384h288v-288h-288v288zm736 736h320v-288h-320v288zm-384-736h320v-288h-320v288zm768 736h288v-288h-288v288zm-384-352h320v-320h-320v320zm-352-864v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm736 864h288v-320h-288v320zm-384-384h320v-288h-320v288zm384 0h288v-288h-288v288zm32-480v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm384-64v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z" })
	  );
	}
	
	function iconCalendarPlus() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-calendar-plus", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-calendar-plus-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-calendar-plus-title" },
	      "Calendar Plus"
	    ),
	    _react2.default.createElement("path", { d: "M1536 256q52 0 90 38t38 90v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128zm-384-96v288q0 14 9 23t23 9h64q14 0 23-9t9-23v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm-768 0v288q0 14 9 23t23 9h64q14 0 23-9t9-23v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm1152 1504v-1024h-1408v1024h1408zm-640-576h224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-224q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h64q14 0 23 9t9 23v224z" })
	  );
	}
	
	function iconCalendarTimes() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-calendar-times", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-calendar-times-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-calendar-times-title" },
	      "Calendar Times"
	    ),
	    _react2.default.createElement("path", { d: "M1111 1385l-46 46q-9 9-22 9t-23-9l-188-189-188 189q-10 9-23 9t-22-9l-46-46q-9-9-9-22t9-23l189-188-189-188q-9-10-9-23t9-22l46-46q9-9 22-9t23 9l188 188 188-188q10-9 23-9t22 9l46 46q9 9 9 22t-9 23l-188 188 188 188q9 10 9 23t-9 22zm-983 279h1408v-1024h-1408v1024zm384-1216v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zm768 0v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zm384-64v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z" })
	  );
	}
	
	function iconCamera() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-camera", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2000 2000", "aria-labelledby": "icn-camera-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-camera-title" },
	      "Camera"
	    ),
	    _react2.default.createElement("path", { d: "M1024 672q119 0 203.5 84.5t84.5 203.5-84.5 203.5-203.5 84.5-203.5-84.5-84.5-203.5 84.5-203.5 203.5-84.5zm704-416q106 0 181 75t75 181v896q0 106-75 181t-181 75h-1408q-106 0-181-75t-75-181v-896q0-106 75-181t181-75h224l51-136q19-49 69.5-84.5t103.5-35.5h512q53 0 103.5 35.5t69.5 84.5l51 136h224zm-704 1152q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z" })
	  );
	}
	
	function iconCap() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-cap", xmlns: "http://www.w3.org/2000/svg", width: "2300", height: "1792", viewBox: "0 0 2300 1792", "aria-labelledby": "icn-cap-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-cap-title" },
	      "Cap"
	    ),
	    _react2.default.createElement("path", { transform: "translate(-20, 0)", d: "M1774 836l18 316q4 69-82 128t-235 93.5-323 34.5-323-34.5-235-93.5-82-128l18-316 574 181q22 7 48 7t48-7zm530-324q0 23-22 31l-1120 352q-4 1-10 1t-10-1l-652-206q-43 34-71 111.5t-34 178.5q63 36 63 109 0 69-58 107l58 433q2 14-8 25-9 11-24 11h-192q-15 0-24-11-10-11-8-25l58-433q-58-38-58-107 0-73 65-111 11-207 98-330l-333-104q-22-8-22-31t22-31l1120-352q4-1 10-1t10 1l1120 352q22 8 22 31z" })
	  );
	}
	
	function iconChainBroken() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chain-broken", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chain-broken-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chain-broken-title" },
	      "Chain Broken"
	    ),
	    _react2.default.createElement("path", { d: "M503 1271l-256 256q-10 9-23 9-12 0-23-9-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zm169 41v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm-224-224q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm1264 128q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zm-617-724l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zm633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm-544-544v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z" })
	  );
	}
	
	function iconCheck() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-check", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-check-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-check-title" },
	      "Check"
	    ),
	    _react2.default.createElement("path", { d: "M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" })
	  );
	}
	
	function iconCheckCircle() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-check-circle", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-check-circle-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-check-circle-title" },
	      "Check"
	    ),
	    _react2.default.createElement("path", { d: "M1299 813l-422 422q-19 19-45 19t-45-19l-294-294q-19-19-19-45t19-45l102-102q19-19 45-19t45 19l147 147 275-275q19-19 45-19t45 19l102 102q19 19 19 45t-19 45zm141 83q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconCheckSquare() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-check-square", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-check-square-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-check-square-title" },
	      "Check"
	    ),
	    _react2.default.createElement("path", { d: "M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z" })
	  );
	}
	
	function iconChevronDown() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chevron-down", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chevron-down-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chevron-down-title" },
	      "Chevron Down"
	    ),
	    _react2.default.createElement("path", { d: "M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z" })
	  );
	}
	
	function iconChevronLeft() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chevron-left", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chevron-left-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chevron-left-title" },
	      "Chevron Left"
	    ),
	    _react2.default.createElement("path", { d: "M1427 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z" })
	  );
	}
	
	function iconChevronRight() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chevron-right", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chevron-right-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chevron-right-title" },
	      "Chevron Right"
	    ),
	    _react2.default.createElement("path", { d: "M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z" })
	  );
	}
	
	function iconChevronUp() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chevron-up", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chevron-up-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chevron-up-title" },
	      "Chevron Up"
	    ),
	    _react2.default.createElement("path", { d: "M1683 1331l-166 165q-19 19-45 19t-45-19l-531-531-531 531q-19 19-45 19t-45-19l-166-165q-19-19-19-45.5t19-45.5l742-741q19-19 45-19t45 19l742 741q19 19 19 45.5t-19 45.5z" })
	  );
	}
	
	function iconCircleRight() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-circleRight", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-circleRight-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-circleRight-title" },
	      "Circle Right"
	    ),
	    _react2.default.createElement("path", { d: "M1413 896q0-27-18-45l-91-91-362-362q-18-18-45-18t-45 18l-91 91q-18 18-18 45t18 45l189 189h-502q-26 0-45 19t-19 45v128q0 26 19 45t45 19h502l-189 189q-19 19-19 45t19 45l91 91q18 18 45 18t45-18l362-362 91-91q18-18 18-45zm251 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconCircleUp() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-circleUp", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-circleUp-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-circleUp-title" },
	      "Circle Up"
	    ),
	    _react2.default.createElement("path", { d: "M1412 895q0-27-18-45l-362-362-91-91q-18-18-45-18t-45 18l-91 91-362 362q-18 18-18 45t18 45l91 91q18 18 45 18t45-18l189-189v502q0 26 19 45t45 19h128q26 0 45-19t19-45v-502l189 189q19 19 45 19t45-19l91-91q18-18 18-45zm252 1q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconClipboardDisable() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-clipboard-disable", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-clipboard-disable-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-clipboard-disable-title" },
	      "Clipboard Disable"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M61.4903 148.51L152 58L236 142H1138.36C1160.8 142 1179.87 149.854 1195.58 165.562C1211.29 181.271 1219.14 200.345 1219.14 222.786V498.804C1230.92 506.097 1241.02 513.951 1249.44 522.366L1592.78 865.705C1608.49 881.414 1621.95 902.732 1633.17 929.661C1644.39 956.589 1650 981.274 1650 1003.71V1556L1733 1639L1642.49 1729.51L1600.49 1687.51L1601 1687L120 206L119.49 206.51L61.4903 148.51ZM142 409.019V1353.79C142 1376.23 149.854 1395.3 165.562 1411.01C181.271 1426.72 200.345 1434.57 222.786 1434.57H680.571V1569.21C680.571 1591.65 688.426 1610.73 704.134 1626.44C719.842 1642.15 738.917 1650 761.357 1650H1382.98L1275.27 1542.29H788.286V1055.31L142 409.019ZM359.737 265.737L451.429 357.429H976.786C984.079 357.429 990.39 354.764 995.72 349.434C1001.05 344.105 1003.71 337.793 1003.71 330.5V276.643C1003.71 269.35 1001.05 263.038 995.72 257.709C990.39 252.379 984.079 249.714 976.786 249.714H384.357C377.064 249.714 370.753 252.379 365.423 257.709C362.957 260.175 361.062 262.851 359.737 265.737ZM788.286 694.286L1542.29 1448.29V1003.71H1192.21C1169.77 1003.71 1150.7 995.86 1134.99 980.152C1119.28 964.443 1111.43 945.369 1111.43 922.929V572.857H788.286V694.286ZM1219.14 896H1470.76L1219.14 644.386V896Z" })
	  );
	}
	
	function iconClock() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-clock", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-clock-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-clock-title" },
	      "Clock"
	    ),
	    _react2.default.createElement("path", { d: "M1024 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconCloudDownload() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-cloud-download", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2000 2000", "aria-labelledby": "icn-cloud-download-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-cloud-download-title" },
	      "Cloud Download"
	    ),
	    _react2.default.createElement("path", { d: "M1344 928q0-14-9-23t-23-9h-224v-352q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v352h-224q-13 0-22.5 9.5t-9.5 22.5q0 14 9 23l352 352q9 9 23 9t23-9l351-351q10-12 10-24zm640 224q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-130 70-240t188-165q-2-30-2-43 0-212 150-362t362-150q156 0 285.5 87t188.5 231q71-62 166-62 106 0 181 75t75 181q0 76-41 138 130 31 213.5 135.5t83.5 238.5z" })
	  );
	}
	
	function iconCoffee() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-coffee", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2000 2000", "aria-labelledby": "icn-coffee-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-coffee-title" },
	      "Coffee"
	    ),
	    _react2.default.createElement("path", { d: "M1728 640q0-80-56-136t-136-56h-64v384h64q80 0 136-56t56-136zm-1664 768h1792q0 106-75 181t-181 75h-1280q-106 0-181-75t-75-181zm1856-768q0 159-112.5 271.5t-271.5 112.5h-64v32q0 92-66 158t-158 66h-704q-92 0-158-66t-66-158v-736q0-26 19-45t45-19h1152q159 0 271.5 112.5t112.5 271.5z" })
	  );
	}
	
	function iconComment() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-comment", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-comment-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-comment-title" },
	      "Comment"
	    ),
	    _react2.default.createElement("path", { d: "M1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22-17 2-30.5-9t-17.5-29v-1q-3-4-.5-12t2-10 4.5-9.5l6-9 7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-130 71-248.5t191-204.5 286-136.5 348-50.5q244 0 450 85.5t326 233 120 321.5z" })
	  );
	}
	
	function iconContrast() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-contrast", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-contrast-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-contrast-title" },
	      "Contrast"
	    ),
	    _react2.default.createElement("path", { d: "M896 1440v-1088q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73zm768-544q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconDashboard() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-dashboard", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-dashboard-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-dashboard-title" },
	      "Dashboard"
	    ),
	    _react2.default.createElement("path", { d: "M384 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm192-448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm428 481l101-382q6-26-7.5-48.5t-38.5-29.5-48 6.5-30 39.5l-101 382q-60 5-107 43.5t-63 98.5q-20 77 20 146t117 89 146-20 89-117q16-60-6-117t-72-91zm660-33q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm-640-640q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm448 192q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm320 448q0 261-141 483-19 29-54 29h-1402q-35 0-54-29-141-221-141-483 0-182 71-348t191-286 286-191 348-71 348 71 286 191 191 286 71 348z" })
	  );
	}
	
	function iconDesktop() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-desktop-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-title" },
	      "Desktop"
	    ),
	    _react2.default.createElement("path", { transform: "translate(65, 0)", d: "M1728 992v-832q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v832q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zm128-832v1088q0 66-47 113t-113 47h-544q0 37 16 77.5t32 71 16 43.5q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45q0-14 16-44t32-70 16-78h-544q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1600q66 0 113 47t47 113z" })
	  );
	}
	
	function iconDesktopFullscreen() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop-fullscreen", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-desktop-fullscreen-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-fullscreen-title" },
	      "Desktop"
	    ),
	    _react2.default.createElement("path", { d: "m1668.9 1044.1v-772.51c0-8.047-2.94-15.011-8.82-20.892-5.88-5.88-12.85-8.82-20.89-8.82h-1485.6c-8.047 0-15.011 2.94-20.892 8.82-5.88 5.881-8.82 12.845-8.82 20.892v772.51c0 8.05 2.94 15.01 8.82 20.89 5.881 5.88 12.845 8.82 20.892 8.82h1485.6c8.04 0 15.01-2.94 20.89-8.82s8.82-12.84 8.82-20.89zm118.85-772.51v1010.2c0 40.86-14.55 75.83-43.64 104.93-29.1 29.09-64.07 43.63-104.92 43.63h-505.11c0 22.91 4.95 46.89 14.86 71.96 9.9 25.07 19.81 47.05 29.71 65.93s14.86 32.34 14.86 40.39c0 16.09-5.88 30.02-17.64 41.78-11.77 11.76-25.69 17.64-41.79 17.64h-475.39c-16.094 0-30.021-5.88-41.782-17.64s-17.642-25.69-17.642-41.78c0-8.67 4.952-22.29 14.856-40.86s19.808-40.23 29.712-64.99 14.856-48.9 14.856-72.43h-505.1c-40.854 0-75.828-14.54-104.92-43.63-29.093-29.1-43.639-64.07-43.639-104.93v-1010.2c0-40.854 14.546-75.828 43.639-104.92s64.067-43.639 104.92-43.639h1485.6c40.85 0 75.82 14.546 104.92 43.639 29.09 29.093 43.64 64.067 43.64 104.92zm-317.59 55.5c6.81 0 13.62 0.028 20.43 0.056h0.01c13.6 0.056 27.19 0.113 40.78-0.056 22.6-0.339 30.13 5.542 30.42 27.502 0.34 27.236 0.23 54.472 0.12 81.733v0.019 0.069c-0.06 13.62-0.12 27.247-0.12 40.882 0 10.07-0.71 20.479-11.76 24.964-9.55 3.898-15.87-1.937-22.26-7.843-0.55-0.504-1.1-1.009-1.64-1.508-33.24-30.909-33.26-30.887-65.4 1.29l-0.06 0.064c-6.26 6.258-12.54 12.484-18.83 18.708v4e-3c-14.24 14.103-28.47 28.198-42.35 42.64-12.7 13.37-24.5 14.555-37.53 0.507-10.54-11.381-21.58-22.298-32.84-32.918-13.2-12.439-11.97-23.779 0.47-36.049 10.45-10.314 20.74-20.777 31.04-31.24v-4e-3c15.89-16.148 31.78-32.294 48.21-47.879 12.35-11.762 12.06-20.098-0.59-30.591-8.18-6.71-15.55-14.349-21.96-22.763-9.86-13.117-4.45-25.387 12.01-26.318 16.73-0.801 33.5-0.625 50.34-0.447 7.19 0.075 14.38 0.151 21.59 0.151l-0.08-0.973zm-1239.7 67.655c-0.028 7.264-0.056 14.527-0.056 21.791 0 7.377-0.117 14.759-0.234 22.138v3e-3c-0.262 16.528-0.523 33.039 0.53 49.45 1.185 19.167 14.005 23.948 28.856 11.762 8.221-6.656 15.762-14.111 22.51-22.256 10.282-12.651 18.152-10.831 28.814 0.297 13.664 14.327 27.81 28.233 41.937 42.121l2e-3 1e-3 1e-3 2e-3c11.989 11.785 23.964 23.556 35.617 35.559 13.497 13.836 25.81 15.275 39.477 0.635 10.197-10.832 20.436-21.41 31.352-31.31 14.09-12.863 13.202-24.88 0-37.573-19.167-18.49-38.291-37.319-56.824-56.57-3.535-3.719-7.864-7.198-12.2-10.683-9.676-7.777-19.386-15.58-20.38-26.128-0.848-9.079 7.888-16.078 16.756-23.183 4.4-3.525 8.832-7.076 12.143-10.92l0.23-0.268c5.596-6.512 11.222-13.059 7.048-22.2-3.724-7.997-11.594-9.52-19.717-9.52h-133.03c-15.866-0.042-23.102 7.405-22.89 23.272 0.169 14.526 0.113 29.053 0.056 43.58zm1328.6 477.05v67.698c0 13.963-6.94 20.86-20.69 20.902h-135.4c-8.25 0-15.57-2.327-19.38-10.239s0.51-14.851 6.14-20.733c0.32-0.355 0.67-0.69 1.01-1.047 0.14-0.154 0.29-0.311 0.42-0.476 3.29-4.081 7.81-7.734 12.27-11.343 8.54-6.904 16.89-13.649 16-22.929-0.9-8.206-9.73-15.606-18.47-22.936v-1e-3c-3.61-3.026-7.2-6.039-10.22-9.093-2.11-2.142-4.22-4.285-6.33-6.429l-0.01-0.015c-17.65-17.918-35.3-35.849-53.36-53.342-13.84-13.413-15.49-25.598 0-39.053 11.09-9.798 21.65-20.194 31.61-31.142 12.69-13.92 24.11-13.878 37.36-0.211 11.27 11.633 22.86 22.957 34.44 34.274 14.11 13.791 28.22 27.571 41.72 41.886 12.9 13.794 22.89 16.925 35.03 0.423 4.07-4.883 8.54-9.413 13.37-13.539 0.81-0.776 1.61-1.58 2.41-2.387 6.2-6.235 12.57-12.642 22.98-7.472 9.99 4.978 9.84 14.209 9.68 23.423-0.01 0.811-0.03 1.622-0.03 2.43v61.224l-0.55 0.127zm-1261.4 88.797c7.278 0.028 14.555 0.057 21.833 0.057v0.338h69.729c8.293 0 15.486-1.988 18.913-10.451 3.047-7.785-0.719-13.709-5.754-18.998-7.024-7.912-14.512-15.401-22.425-22.425-11.636-9.731-10.155-17.22 0.254-27.333 16.815-16.345 33.243-33.109 49.682-49.884 10.201-10.409 20.405-20.822 30.709-31.142 11.594-11.594 12.652-22.764 0.551-34.569-12.102-11.805-24.583-24.286-35.669-36.134-11.086-11.847-21.452-11.339-32.538 0-19.745 20.112-39.688 40.041-59.828 59.786-3.23 3.171-6.394 6.822-9.572 10.489-8.142 9.398-16.376 18.899-26.054 20.695-9.023 1.674-16.049-7.156-23.207-16.153-3.516-4.419-7.064-8.878-10.896-12.153-0.262-0.224-0.523-0.448-0.785-0.672-6.366-5.453-12.617-10.807-21.64-6.987-9.393 3.977-10.155 12.651-10.155 21.41v131.16c-0.085 15.74 7.108 23.314 23.187 23.018 14.555-0.17 29.11-0.113 43.665-0.057z", clipRule: "evenodd", fillRule: "evenodd" })
	  );
	}
	
	function iconDesktopRecord() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop-record", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-desktop-record-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-record-title" },
	      "Record Desktop"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1663.87 148.56V921.069C1663.87 929.116 1660.93 936.08 1655.05 941.961C1649.17 947.841 1642.2 950.781 1634.16 950.781H148.56C140.513 950.781 133.549 947.841 127.668 941.961C121.788 936.08 118.848 929.116 118.848 921.069V148.56C118.848 140.513 121.788 133.549 127.668 127.668C133.549 121.788 140.513 118.848 148.56 118.848H1634.16C1642.2 118.848 1649.17 121.788 1655.05 127.668C1660.93 133.549 1663.87 140.513 1663.87 148.56ZM1782.72 1158.76V148.56C1782.72 107.706 1768.17 72.7323 1739.08 43.6394C1709.98 14.5464 1675.01 -2.28882e-05 1634.16 -2.28882e-05H148.56C107.706 -2.28882e-05 72.7323 14.5464 43.6394 43.6394C14.5465 72.7323 0 107.706 0 148.56V1158.76C0 1199.62 14.5465 1234.59 43.6394 1263.68C72.7323 1292.78 107.706 1307.32 148.56 1307.32H653.662C653.662 1330.85 648.71 1354.99 638.806 1379.75C628.902 1404.51 618.998 1426.17 609.094 1444.74C599.19 1463.31 594.238 1476.93 594.238 1485.6C594.238 1501.69 600.119 1515.62 611.88 1527.38C623.641 1539.14 637.568 1545.02 653.662 1545.02H1129.05C1145.15 1545.02 1159.07 1539.14 1170.84 1527.38C1182.6 1515.62 1188.48 1501.69 1188.48 1485.6C1188.48 1477.55 1183.52 1464.09 1173.62 1445.21C1163.72 1426.33 1153.81 1404.35 1143.91 1379.28C1134 1354.21 1129.05 1330.23 1129.05 1307.32H1634.16C1675.01 1307.32 1709.98 1292.78 1739.08 1263.68C1768.17 1234.59 1782.72 1199.62 1782.72 1158.76ZM1241 756.5V331.5C1241 320.563 1235.92 312.88 1225.77 308.453C1222.38 307.151 1219.12 306.5 1216 306.5C1208.97 306.5 1203.11 308.974 1198.42 313.922L1041 470.953V406.5C1041 375.51 1030 349.013 1007.99 327.008C985.987 305.003 959.49 294 928.5 294H653.5C622.51 294 596.013 305.003 574.008 327.008C552.003 349.013 541 375.51 541 406.5V681.5C541 712.49 552.003 738.987 574.008 760.992C596.013 782.997 622.51 794 653.5 794H928.5C959.49 794 985.987 782.997 1007.99 760.992C1030 738.987 1041 712.49 1041 681.5V616.656L1198.42 774.078C1203.11 779.026 1208.97 781.5 1216 781.5C1219.12 781.5 1222.38 780.849 1225.77 779.547C1235.92 775.12 1241 767.437 1241 756.5Z" })
	  );
	}
	
	function iconDesktopOne() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop-one", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-desktop-one-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-one-title" },
	      "Only One Display"
	    ),
	    _react2.default.createElement("path", { d: "m1188.7 1169.4v-548c0-5.709-2.08-10.649-6.25-14.82-4.17-4.172-9.11-6.257-14.81-6.257h-1053.3c-5.705 0-10.643 2.085-14.812 6.257-4.1694 4.171-6.2541 9.111-6.2541 14.82v548c0 5.71 2.0847 10.65 6.2541 14.82 4.1692 4.18 9.1072 6.26 14.812 6.26h1053.3c5.7 0 10.64-2.08 14.81-6.26 4.17-4.17 6.25-9.11 6.25-14.82zm84.27-548v716.62c0 28.98-10.31 53.79-30.94 74.43s-45.43 30.95-74.39 30.95h-358.14c0 16.25 3.511 33.27 10.534 51.05 7.022 17.78 14.044 33.37 21.066 46.76 7.023 13.4 10.534 22.95 10.534 28.66 0 11.41-4.17 21.29-12.509 29.64-8.339 8.34-18.214 12.51-29.625 12.51h-337.07c-11.411 0-21.286-4.17-29.625-12.51-8.339-8.35-12.509-18.23-12.509-29.64 0-6.15 3.511-15.81 10.534-28.98 7.022-13.18 14.044-28.55 21.066-46.11 7.023-17.56 10.534-34.69 10.534-51.38h-358.13c-28.966 0-53.764-10.31-74.391-30.95-20.628-20.64-30.942-45.45-30.942-74.43v-716.62c0-28.981 10.314-53.79 30.942-74.428 20.628-20.638 45.425-30.957 74.391-30.957h1053.3c28.96 0 53.76 10.319 74.39 30.957s30.94 45.447 30.94 74.428zm-845 134.41l62.797-62.797 150.2 150.2 150.2-150.2 62.797 62.797-150.2 150.2 150.2 150.2-62.797 62.8-150.2-150.2-150.2 150.2-62.797-62.8 150.2-150.2-150.2-150.2z", clipRule: "evenodd", fillRule: "evenodd" }),
	    _react2.default.createElement("path", { d: "m1696.7 285.38v548c0 5.708-2.08 10.648-6.25 14.819-4.17 4.172-9.11 6.258-14.81 6.258h-455.67v353.54h-272.77c-5.93 11.58-8.895 20.2-8.895 25.85 0 11.41 4.17 21.29 12.509 29.64 8.339 8.34 18.214 12.51 29.625 12.51h337.06c11.41 0 21.29-4.17 29.63-12.51 8.34-8.35 12.51-18.23 12.51-29.64 0-5.71-3.51-15.26-10.54-28.66-7.02-13.39-14.04-28.98-21.06-46.76-7.03-17.78-10.54-34.8-10.54-51.05h358.14c28.96 0 53.76-10.31 74.39-30.95s30.94-45.45 30.94-74.43v-716.62c0-28.981-10.31-53.79-30.94-74.428s-45.43-30.957-74.39-30.957h-1053.3c-28.966 0-53.764 10.319-74.391 30.957-20.628 20.638-30.942 45.447-30.942 74.428v308.62h84.267v-308.62c0-5.709 2.084-10.649 6.254-14.82 4.169-4.172 9.107-6.257 14.812-6.257h1053.3c5.7 0 10.64 2.085 14.81 6.257 4.17 4.171 6.25 9.111 6.25 14.82z", clipRule: "evenodd", fillRule: "evenodd" })
	  );
	}
	
	function iconDownload() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-download", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-download-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-download-title" },
	      "Download"
	    ),
	    _react2.default.createElement("path", { d: "M1344 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zm-325-569q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z" })
	  );
	}
	
	function iconEdit() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-edit", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-edit-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-edit-title" },
	      "Edit"
	    ),
	    _react2.default.createElement("path", { d: "M888 1184l116-116-152-152-116 116v56h96v96h56zm440-720q-16-16-33 1l-350 350q-17 17-1 33t33-1l350-350q17-17 1-33zm80 594v190q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-14 14-32 8-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-126q0-13 9-22l64-64q15-15 35-7t20 29zm-96-738l288 288-672 672h-288v-288zm444 132l-92 92-288-288 92-92q28-28 68-28t68 28l152 152q28 28 28 68t-28 68z" })
	  );
	}
	
	function iconEnvelope() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-envelope", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-envelope-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-envelope-title" },
	      "Envelope"
	    ),
	    _react2.default.createElement("path", { d: "M1664 1504v-768q-32 36-69 66-268 206-426 338-51 43-83 67t-86.5 48.5-102.5 24.5h-2q-48 0-102.5-24.5t-86.5-48.5-83-67q-158-132-426-338-37-30-69-66v768q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zm0-1051v-24.5l-.5-13-3-12.5-5.5-9-9-7.5-14-2.5h-1472q-13 0-22.5 9.5t-9.5 22.5q0 168 147 284 193 152 401 317 6 5 35 29.5t46 37.5 44.5 31.5 50.5 27.5 43 9h2q20 0 43-9t50.5-27.5 44.5-31.5 46-37.5 35-29.5q208-165 401-317 54-43 100.5-115.5t46.5-131.5zm128-37v1088q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1472q66 0 113 47t47 113z" })
	  );
	}
	
	function iconEraser() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-eraser", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-eraser-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-eraser-title" },
	      "Eraser"
	    ),
	    _react2.default.createElement("path", { d: "M1710.66 956.391C1773.78 893.294 1773.78 790.992 1710.66 727.895L1171.91 189.324C1108.79 126.227 1006.46 126.224 943.337 189.324L81.3384 1051.04C18.2205 1114.14 18.2205 1216.44 81.3384 1279.53L404.588 1602.68C434.9 1632.98 476.01 1650 518.877 1650H1717.59C1739.91 1650 1758 1631.91 1758 1609.61V1474.96C1758 1452.66 1739.91 1434.57 1717.59 1434.57H1232.33L1710.66 956.391V956.391ZM691.66 745.584L1154.22 1207.99L927.562 1434.57H541.195L271.82 1165.29L691.66 745.584V745.584Z" })
	  );
	}
	
	function iconExclamation() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-exclamation", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-exclamation-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-exclamation-title" },
	      "Exclamation"
	    ),
	    _react2.default.createElement("path", { d: "M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z" })
	  );
	}
	
	function iconExtensionBlock() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-extension", width: "1566", height: "1565", viewBox: "0 0 1566 1565", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": "icn-extension-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-extension-title" },
	      "Blocked Extension"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M91.5391 0L0.769531 90.7695L1475 1565L1565.77 1474.23L1368.86 1277.32C1368.95 1275.12 1369 1272.92 1369 1270.7V1019.05H1354.89C1262.76 1019.05 1188.08 944.371 1188.08 852.245C1188.08 760.119 1262.76 685.436 1354.89 685.436H1369V433.791C1369 350.948 1301.84 283.791 1219 283.791H926.829V229.474C926.829 137.348 852.146 62.665 760.02 62.665C667.893 62.665 593.21 137.348 593.21 229.474V283.791H375.33L91.5391 0ZM159 433.791C159 429.651 159.168 425.551 159.497 421.497L1158.7 1420.7H926.829V1406.59C926.829 1314.46 852.146 1239.78 760.02 1239.78C667.894 1239.78 593.21 1314.46 593.21 1406.59V1420.7H309C226.157 1420.7 159 1353.54 159 1270.7V1019.05H173.112C265.238 1019.05 339.921 944.371 339.921 852.245C339.921 760.119 265.238 685.436 173.112 685.436H159V433.791Z" })
	  );
	}
	
	function iconDesktopAppCheck() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop-app-check", width: "288", height: "288", viewBox: "0 0 288 288", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": "icn-desktop-app-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-app-title" },
	      "SecureSession Utility App"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M156 51H171C178.992 51 183.012 60.708 177.36 66.36L150.36 93.36C148.608 95.124 146.304 96 144 96C141.696 96 139.392 95.124 137.64 93.36L110.64 66.36C104.988 60.708 109.008 51 117 51H132V12C132 5.376 137.376 0 144 0C150.624 0 156 5.376 156 12V51ZM84 120C84 133.236 94.764 144 108 144H180C193.236 144 204 133.236 204 120V108C204 101.376 198.624 96 192 96C185.376 96 180 101.376 180 108V120H108V108C108 101.376 102.624 96 96 96C89.376 96 84 101.376 84 108V120ZM201.696 48H267C278.58 48 288 57.42 288 69V231C288 242.58 278.58 252 267 252H174.948C176.436 258.024 180.276 267.78 190.248 277.752C191.952 279.468 192.468 282.048 191.544 284.292C190.62 286.536 188.424 288 186 288H102C99.576 288 97.38 286.536 96.456 284.292C95.52 282.048 96.036 279.468 97.752 277.752C107.748 267.768 111.48 258.012 112.896 252H21C9.42 252 0 242.58 0 231V69C0 57.42 9.42 48 21 48H86.304C83.208 55.896 83.328 64.416 86.304 72H24V204H264V72H201.696C204.66 64.416 204.78 55.896 201.696 48Z" })
	  );
	}
	
	function iconExternal() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-external", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-external-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-external-title" },
	      "External Link"
	    ),
	    _react2.default.createElement("path", { d: "M1408 928v320q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-320q0-14 9-23t23-9h64q14 0 23 9t9 23zm384-864v512q0 26-19 45t-45 19-45-19l-176-176-652 652q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l652-652-176-176q-19-19-19-45t19-45 45-19h512q26 0 45 19t19 45z" })
	  );
	}
	
	function iconEye() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-eye", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-eye-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-eye-title" },
	      "Eye"
	    ),
	    _react2.default.createElement("path", { d: "M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z" })
	  );
	}
	
	function iconEyeSlash() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-eye-slash", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-eye-slash-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-eye-slash-title" },
	      "Eye Slash"
	    ),
	    _react2.default.createElement("path", { d: "M555 1335l78-141q-87-63-136-159t-49-203q0-121 61-225-229 117-381 353 167 258 427 375zm389-759q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm363-191q0 7-1 9-106 189-316 567t-315 566l-49 89q-10 16-28 16-12 0-134-70-16-10-16-28 0-12 44-87-143-65-263.5-173t-208.5-245q-20-31-20-69t20-69q153-235 380-371t496-136q89 0 180 17l54-97q10-16 28-16 5 0 18 6t31 15.5 33 18.5 31.5 18.5 19.5 11.5q16 10 16 27zm37 447q0 139-79 253.5t-209 164.5l280-502q8 45 8 84zm448 128q0 35-20 69-39 64-109 145-150 172-347.5 267t-419.5 95l74-132q212-18 392.5-137t301.5-307q-115-179-282-294l63-112q95 64 182.5 153t144.5 184q20 34 20 69z" })
	  );
	}
	
	function iconFiles() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-files", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-files-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-files-title" },
	      "Files"
	    ),
	    _react2.default.createElement("path", { d: "M1696 384q40 0 68 28t28 68v1216q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-288h-544q-40 0-68-28t-28-68v-672q0-40 20-88t48-76l408-408q28-28 76-48t88-20h416q40 0 68 28t28 68v328q68-40 128-40h416zm-544 213l-299 299h299v-299zm-640-384l-299 299h299v-299zm196 647l316-316v-416h-384v416q0 40-28 68t-68 28h-416v640h512v-256q0-40 20-88t48-76zm956 804v-1152h-384v416q0 40-28 68t-68 28h-416v640h896z" })
	  );
	}
	
	function iconFolder() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-folder", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-folder-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-folder-title" },
	      "Folder"
	    ),
	    _react2.default.createElement("path", { d: "M1943 952q0 31-31 66l-336 396q-43 51-120.5 86.5t-143.5 35.5h-1088q-34 0-60.5-13t-26.5-43q0-31 31-66l336-396q43-51 120.5-86.5t143.5-35.5h1088q34 0 60.5 13t26.5 43zm-343-344v160h-832q-94 0-197 47.5t-164 119.5l-337 396-5 6q0-4-.5-12.5t-.5-12.5v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158z" })
	  );
	}
	
	function iconFont() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-font", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-font-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-font-title" },
	      "Font"
	    ),
	    _react2.default.createElement("path", { d: "M789 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zm-725 1105l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h128q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 5-.5 13.5t-.5 12.5q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z" })
	  );
	}
	
	function iconGraph() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-graph", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-graph-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-graph-title" },
	      "Graph"
	    ),
	    _react2.default.createElement("path", { d: "M512 896v512h-256v-512h256zm384-512v1024h-256v-1024h256zm1024 1152v128h-2048v-1536h128v1408h1920zm-640-896v768h-256v-768h256zm384-384v1152h-256v-1152h256z" })
	  );
	}
	
	function iconHourglass() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-hourglass", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-hourglass-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-hourglass-title" },
	      "Hourglass"
	    ),
	    _react2.default.createElement("path", { d: "M1536 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zm-128 0h-1024q0 206 85 384h854q85-178 85-384zm-57 1216q-54-141-145.5-241.5t-194.5-142.5h-230q-103 42-194.5 142.5t-145.5 241.5h910z" })
	  );
	}
	
	function iconID() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-id", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2020 2020", "aria-labelledby": "icn-id-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-id-title" },
	      "ID"
	    ),
	    _react2.default.createElement("path", { d: "M896 1212q0 55-31.5 93.5t-75.5 38.5h-426q-44 0-75.5-38.5t-31.5-93.5q0-54 7.5-100.5t24.5-90 51-68.5 81-25q64 64 156 64t156-64q47 0 81 25t51 68.5 24.5 90 7.5 100.5zm-128-444q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 416v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zm-384-256v64q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h320q14 0 23 9t9 23zm384 0v64q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h192q14 0 23 9t9 23zm0-256v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zm128 832v-1120h-1792v1120q0 13 9.5 22.5t22.5 9.5h1728q13 0 22.5-9.5t9.5-22.5zm128-1216v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z" })
	  );
	}
	
	function iconIDBack() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-id-back", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2020 2020", "aria-labelledby": "icn-id-back-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-id-back-title" },
	      "ID Back"
	    ),
	    _react2.default.createElement("path", { d: "M1824 128q66 0 113 47t47 113v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600zm-1600 128q-13 0-22.5 9.5t-9.5 22.5v224h1664v-224q0-13-9.5-22.5t-22.5-9.5h-1600zm1600 1280q13 0 22.5-9.5t9.5-22.5v-608h-1664v608q0 13 9.5 22.5t22.5 9.5h1600zm-1504-128v-128h256v128h-256zm384 0v-128h384v128h-384z" })
	  );
	}
	
	function iconImport() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-import", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2020 2020", "aria-labelledby": "icn-import-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-import-title" },
	      "Import"
	    ),
	    _react2.default.createElement("path", { d: "M1344 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zm-325-569q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z" })
	  );
	}
	
	function iconInbox() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-inbox", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-inbox-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-inbox-title" },
	      "Inbox"
	    ),
	    _react2.default.createElement("path", { d: "M1151 960h316q-1-3-2.5-8.5t-2.5-7.5l-212-496h-708l-212 496q-1 3-2.5 8.5t-2.5 7.5h316l95 192h320zm513 30v482q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-482q0-62 25-123l238-552q10-25 36.5-42t52.5-17h832q26 0 52.5 17t36.5 42l238 552q25 61 25 123z" })
	  );
	}
	
	function iconInfo() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-info", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-info-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-info-title" },
	      "Info"
	    ),
	    _react2.default.createElement("path", { d: "M1216 1344v128q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h64v-384h-64q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h384q26 0 45 19t19 45v576h64q26 0 45 19t19 45zm-128-1152v192q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-192q0-26 19-45t45-19h256q26 0 45 19t19 45z" })
	  );
	}
	
	function iconLaptop() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-laptop", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1970 1970", "aria-labelledby": "icn-laptop-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-laptop-title" },
	      "Online"
	    ),
	    _react2.default.createElement("path", { d: "M480 1280q-66 0-113-47t-47-113v-704q0-66 47-113t113-47h1088q66 0 113 47t47 113v704q0 66-47 113t-113 47h-1088zm-32-864v704q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5v-704q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5zm1376 928h160v96q0 40-47 68t-113 28h-1600q-66 0-113-28t-47-68v-96h1760zm-720 96q16 0 16-16t-16-16h-160q-16 0-16 16t16 16h160z" })
	  );
	}
	
	function iconLightbulb() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-lightbulb", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-lightbulb-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-lightbulb-title" },
	      "Lightbulb"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M896 7C876.67 7 861 22.67 861 42V222C861 241.33 876.67 257 896 257C915.33 257 931 241.33 931 222V42C931 22.67 915.33 7 896 7ZM1078.24 741.435C1083.62 736.058 1086.31 729.691 1086.31 722.333C1086.31 692.903 1075.69 667.434 1054.45 645.927C1033.21 624.42 1008.57 609.139 980.536 600.083C952.499 591.028 924.32 586.5 896 586.5C888.637 586.5 882.265 589.188 876.884 594.565C871.503 599.942 868.812 606.309 868.812 613.667C868.812 621.024 871.503 627.391 876.884 632.768C882.265 638.145 888.637 640.833 896 640.833C925.453 640.833 955.473 647.908 986.059 662.057C1016.64 676.207 1031.94 696.299 1031.94 722.333C1031.94 729.691 1034.63 736.058 1040.01 741.435C1045.39 746.812 1051.76 749.5 1059.12 749.5C1066.49 749.5 1072.86 746.812 1078.24 741.435ZM1192.94 608.573C1212.48 643.663 1222.25 681.583 1222.25 722.333C1222.25 779.497 1202.99 830.434 1164.48 875.146C1158.81 881.372 1150.17 890.71 1138.56 903.161C1126.95 915.613 1118.31 924.951 1112.65 931.177C1040.15 1017.77 1000.22 1102.1 992.855 1184.17H799.145C791.781 1102.1 751.85 1017.77 679.35 931.177C673.686 924.951 665.048 915.613 653.437 903.161C641.825 890.71 633.188 881.372 627.523 875.146C589.008 830.434 569.75 779.497 569.75 722.333C569.75 681.583 579.521 643.663 599.062 608.573C618.603 573.483 644.091 544.76 675.526 522.404C706.962 500.048 741.796 482.503 780.028 469.768C818.261 457.034 856.918 450.667 896 450.667C935.082 450.667 973.739 457.034 1011.97 469.768C1050.2 482.503 1085.04 500.048 1116.47 522.404C1147.91 544.76 1173.4 573.483 1192.94 608.573ZM1243.49 949.854C1301.83 885.899 1331 810.059 1331 722.333C1331 666.302 1318.4 614.091 1293.19 565.701C1267.99 517.31 1234.85 477.126 1193.79 445.148C1152.72 413.171 1106.28 387.985 1054.45 369.591C1002.63 351.197 949.809 342 896 342C842.191 342 789.374 351.197 737.548 369.591C685.722 387.985 639.276 413.171 598.212 445.148C557.147 477.126 524.013 517.31 498.808 565.701C473.603 614.091 461 666.302 461 722.333C461 810.059 490.17 885.899 548.51 949.854C573.998 977.587 595.097 1002.21 611.806 1023.71C628.515 1045.22 645.365 1072.25 662.357 1104.79C679.35 1137.33 688.979 1167.75 691.244 1196.05C664.623 1211.9 651.312 1235.1 651.312 1265.67C651.312 1286.61 658.393 1304.72 672.553 1320C658.393 1335.28 651.312 1353.39 651.312 1374.33C651.312 1403.76 664.057 1426.69 689.545 1443.1C682.182 1456.12 678.5 1469.42 678.5 1483C678.5 1509.03 687.421 1529.13 705.263 1543.28C723.104 1557.43 745.053 1564.5 771.107 1564.5C782.436 1589.4 799.428 1609.21 822.084 1623.93C844.74 1638.64 869.379 1646 896 1646C922.621 1646 947.26 1638.64 969.916 1623.93C992.572 1609.21 1009.56 1589.4 1020.89 1564.5C1046.95 1564.5 1068.9 1557.43 1086.74 1543.28C1104.58 1529.13 1113.5 1509.03 1113.5 1483C1113.5 1469.42 1109.82 1456.12 1102.46 1443.1C1127.94 1426.69 1140.69 1403.76 1140.69 1374.33C1140.69 1353.39 1133.61 1335.28 1119.45 1320C1133.61 1304.72 1140.69 1286.61 1140.69 1265.67C1140.69 1235.1 1127.38 1211.9 1100.76 1196.05C1103.02 1167.75 1112.65 1137.33 1129.64 1104.79C1146.63 1072.25 1163.49 1045.22 1180.19 1023.71C1196.9 1002.21 1218 977.587 1243.49 949.854ZM184 789C164.67 789 149 773.33 149 754C149 734.67 164.67 719 184 719H364C383.33 719 399 734.67 399 754C399 773.33 383.33 789 364 789H184ZM1393 754C1393 773.33 1408.67 789 1428 789H1608C1627.33 789 1643 773.33 1643 754C1643 734.67 1627.33 719 1608 719H1428C1408.67 719 1393 734.67 1393 754ZM367.791 275.289C354.123 261.62 354.123 239.46 367.791 225.791C381.46 212.123 403.62 212.123 417.289 225.791L544.568 353.07C558.236 366.739 558.236 388.9 544.568 402.568C530.9 416.236 508.739 416.236 495.07 402.568L367.791 275.289ZM1247.43 1105.43C1233.76 1119.1 1233.76 1141.26 1247.43 1154.93L1374.71 1282.21C1388.38 1295.88 1410.54 1295.88 1424.21 1282.21C1437.88 1268.54 1437.88 1246.38 1424.21 1232.71L1296.93 1105.43C1283.26 1091.76 1261.1 1091.76 1247.43 1105.43ZM417.289 1282.21C403.62 1295.88 381.46 1295.88 367.791 1282.21C354.123 1268.54 354.123 1246.38 367.791 1232.71L495.07 1105.43C508.739 1091.76 530.9 1091.76 544.568 1105.43C558.236 1119.1 558.236 1141.26 544.568 1154.93L417.289 1282.21ZM1247.43 402.568C1261.1 416.236 1283.26 416.236 1296.93 402.568L1424.21 275.289C1437.88 261.62 1437.88 239.46 1424.21 225.791C1410.54 212.123 1388.38 212.123 1374.71 225.791L1247.43 353.07C1233.76 366.739 1233.76 388.9 1247.43 402.568Z" })
	  );
	}
	
	function iconLink() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-link", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-link-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-link-title" },
	      "Link"
	    ),
	    _react2.default.createElement("path", { d: "M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z" })
	  );
	}
	
	function iconList() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-list", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-list-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-list-title" },
	      "List"
	    ),
	    _react2.default.createElement("path", { d: "M256 1312v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm-1536-1152v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5z" })
	  );
	}
	
	function iconLock() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-lock", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-lock-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-lock-title" },
	      "Lock"
	    ),
	    _react2.default.createElement("path", { d: "M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z" })
	  );
	}
	
	function iconMicrophone() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-microphone", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-microphone-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-microphone-title" },
	      "Microphone"
	    ),
	    _react2.default.createElement("path", { d: "M1472 704v128q0 221-147.5 384.5t-364.5 187.5v132h256q26 0 45 19t19 45-19 45-45 19h-640q-26 0-45-19t-19-45 19-45 45-19h256v-132q-217-24-364.5-187.5t-147.5-384.5v-128q0-26 19-45t45-19 45 19 19 45v128q0 185 131.5 316.5t316.5 131.5 316.5-131.5 131.5-316.5v-128q0-26 19-45t45-19 45 19 19 45zm-256-384v512q0 132-94 226t-226 94-226-94-94-226v-512q0-132 94-226t226-94 226 94 94 226z" })
	  );
	}
	
	function iconMinus() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-minus", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-minus-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-minus-title" },
	      "Minus"
	    ),
	    _react2.default.createElement("path", { d: "M1344 960v-128q0-26-19-45t-45-19h-768q-26 0-45 19t-19 45v128q0 26 19 45t45 19h768q26 0 45-19t19-45zm320-64q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconMobile() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-mobile", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-mobile-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-mobile-title" },
	      "Mobile"
	    ),
	    _react2.default.createElement("path", { d: "M976 1408q0-33-23.5-56.5t-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5 56.5-23.5 23.5-56.5zm208-160v-704q0-13-9.5-22.5t-22.5-9.5h-512q-13 0-22.5 9.5t-9.5 22.5v704q0 13 9.5 22.5t22.5 9.5h512q13 0 22.5-9.5t9.5-22.5zm-192-848q0-16-16-16h-160q-16 0-16 16t16 16h160q16 0 16-16zm288-16v1024q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-1024q0-52 38-90t90-38h512q52 0 90 38t38 90z" })
	  );
	}
	
	function iconMoon() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-moon", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-moon-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-moon-title" },
	      "Moon"
	    ),
	    _react2.default.createElement("path", { d: "M1390 1303q-54 9-110 9-182 0-337-90t-245-245-90-337q0-192 104-357-201 60-328.5 229t-127.5 384q0 130 51 248.5t136.5 204 204 136.5 248.5 51q144 0 273.5-61.5t220.5-171.5zm203-85q-94 203-283.5 324.5t-413.5 121.5q-156 0-298-61t-245-164-164-245-61-298q0-153 57.5-292.5t156-241.5 235.5-164.5 290-68.5q44-2 61 39 18 41-15 72-86 78-131.5 181.5t-45.5 218.5q0 148 73 273t198 198 273 73q118 0 228-51 41-18 72 13 14 14 17.5 34t-4.5 38z" })
	  );
	}
	
	function iconNo() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-no", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-no-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-no-title" },
	      "No"
	    ),
	    _react2.default.createElement("path", { d: "M1440 893q0-161-87-295l-754 753q137 89 297 89 111 0 211.5-43.5t173.5-116.5 116-174.5 43-212.5zm-999 299l755-754q-135-91-300-91-148 0-273 73t-198 199-73 274q0 162 89 299zm1223-299q0 157-61 300t-163.5 246-245 164-298.5 61-298.5-61-245-164-163.5-246-61-300 61-299.5 163.5-245.5 245-164 298.5-61 298.5 61 245 164 163.5 245.5 61 299.5z" })
	  );
	}
	
	function iconPage() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-page", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-page-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-page-title" },
	      "Page"
	    ),
	    _react2.default.createElement("path", { d: "M1596 476q14 14 28 36h-472v-472q22 14 36 28zm-476 164h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544q0 40 28 68t68 28zm160 736v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23z" })
	  );
	}
	
	function iconPaper() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-paper", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-paper-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-paper-title" },
	      "Paper"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280z" })
	  );
	}
	
	function iconPaperclip() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-paperclip", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-paperclip-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-paperclip-title" },
	      "Paperclip"
	    ),
	    _react2.default.createElement("path", { d: "M1596 1385q0 117-79 196t-196 79q-135 0-235-100l-777-776q-113-115-113-271 0-159 110-270t269-111q158 0 273 113l605 606q10 10 10 22 0 16-30.5 46.5t-46.5 30.5q-13 0-23-10l-606-607q-79-77-181-77-106 0-179 75t-73 181q0 105 76 181l776 777q63 63 145 63 64 0 106-42t42-106q0-82-63-145l-581-581q-26-24-60-24-29 0-48 19t-19 48q0 32 25 59l410 410q10 10 10 22 0 16-31 47t-47 31q-12 0-22-10l-410-410q-63-61-63-149 0-82 57-139t139-57q88 0 149 63l581 581q100 98 100 235z" })
	  );
	}
	
	function iconPause() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-pause", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-pause-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-pause-title" },
	      "Pause"
	    ),
	    _react2.default.createElement("path", { d: "M1664 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45zm-896 0v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45z" })
	  );
	}
	
	function iconPencil() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-pencil", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-pencil-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-pencil-title" },
	      "Pencil"
	    ),
	    _react2.default.createElement("path", { d: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z" })
	  );
	}
	
	function iconPencilPaper() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-pencil-paper", xmlns: "http://www.w3.org/2000/svg", width: "384", height: "512", viewBox: "0 0 384 512", "aria-labelledby": "icn-pencil-paper-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-pencil-paper-title" },
	      "Written"
	    ),
	    _react2.default.createElement("path", { d: "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zM219.2 247.2l29.6 29.6c1.8 1.8 1.8 4.6 0 6.4L136.4 395.6l-30.1 4.3c-5.9.8-11-4.2-10.2-10.2l4.3-30.1 112.4-112.4c1.8-1.8 4.6-1.8 6.4 0zm64.4 1.2l-16.4 16.4c-1.8 1.8-4.6 1.8-6.4 0l-29.6-29.6c-1.8-1.8-1.8-4.6 0-6.4l16.4-16.4c5.9-5.9 15.4-5.9 21.2 0l14.8 14.8c5.9 5.8 5.9 15.3 0 21.2z" })
	  );
	}
	
	function iconPhone() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-phone", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-phone-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-phone-title" },
	      "Phone"
	    ),
	    _react2.default.createElement("path", { d: "M1600 1240q0 27-10 70.5t-21 68.5q-21 50-122 106-94 51-186 51-27 0-52.5-3.5t-57.5-12.5-47.5-14.5-55.5-20.5-49-18q-98-35-175-83-128-79-264.5-215.5t-215.5-264.5q-48-77-83-175-3-9-18-49t-20.5-55.5-14.5-47.5-12.5-57.5-3.5-52.5q0-92 51-186 56-101 106-122 25-11 68.5-21t70.5-10q14 0 21 3 18 6 53 76 11 19 30 54t35 63.5 31 53.5q3 4 17.5 25t21.5 35.5 7 28.5q0 20-28.5 50t-62 55-62 53-28.5 46q0 9 5 22.5t8.5 20.5 14 24 11.5 19q76 137 174 235t235 174q2 1 19 11.5t24 14 20.5 8.5 22.5 5q18 0 46-28.5t53-62 55-62 50-28.5q14 0 28.5 7t35.5 21.5 25 17.5q25 15 53.5 31t63.5 35 54 30q70 35 76 53 3 7 3 21z" })
	  );
	}
	
	function iconPlay() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-play", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-play-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-play-title" },
	      "Play"
	    ),
	    _react2.default.createElement("path", { d: "M1576 927l-1328 738q-23 13-39.5 3t-16.5-36v-1472q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z" })
	  );
	}
	
	function iconPlus() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-plus", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-plus-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-plus-title" },
	      "Plus"
	    ),
	    _react2.default.createElement("path", { d: "M1344 960v-128q0-26-19-45t-45-19h-256v-256q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v256h-256q-26 0-45 19t-19 45v128q0 26 19 45t45 19h256v256q0 26 19 45t45 19h128q26 0 45-19t19-45v-256h256q26 0 45-19t19-45zm320-64q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconPower() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-power", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-power-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-power-title" },
	      "Power"
	    ),
	    _react2.default.createElement("path", { d: "M1664 896q0 156-61 298t-164 245-245 164-298 61-298-61-245-164-164-245-61-298q0-182 80.5-343t226.5-270q43-32 95.5-25t83.5 50q32 42 24.5 94.5t-49.5 84.5q-98 74-151.5 181t-53.5 228q0 104 40.5 198.5t109.5 163.5 163.5 109.5 198.5 40.5 198.5-40.5 163.5-109.5 109.5-163.5 40.5-198.5q0-121-53.5-228t-151.5-181q-42-32-49.5-84.5t24.5-94.5q31-43 84-50t95 25q146 109 226.5 270t80.5 343zm-640-768v640q0 52-38 90t-90 38-90-38-38-90v-640q0-52 38-90t90-38 90 38 38 90z" })
	  );
	}
	
	function iconPrint() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-print", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-print-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-print-title" },
	      "Print"
	    ),
	    _react2.default.createElement("path", { d: "M448 1536h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z" })
	  );
	}
	
	function iconPrintDisable() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-print-disable", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-print-disable-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-print-disable-title" },
	      "Print Disable"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M115 201L205.51 110.49L320 224.981V224C320 197.333 329.333 174.667 348 156C366.667 137.333 389.333 128 416 128H1088C1114.67 128 1144 134.667 1176 148C1208 161.333 1233.33 177.333 1252 196L1404 348C1422.67 366.667 1438.67 392 1452 424C1465.33 456 1472 485.333 1472 512V768H1536C1588.67 768 1633.83 786.833 1671.5 824.5C1709.17 862.167 1728 907.333 1728 960V1376C1728 1384.67 1724.83 1392.17 1718.5 1398.5C1712.17 1404.83 1704.67 1408 1696 1408H1503.02L1726.51 1631.49L1636 1722L1577 1663L1472 1558L1344 1430L1194 1280L810 896L448 534L320 406L140.51 226.51L115 201ZM320 587.019V768H256C203.333 768 158.167 786.833 120.5 824.5C82.8333 862.167 64 907.333 64 960V1376C64 1384.67 67.1667 1392.17 73.5 1398.5C79.8333 1404.83 87.3333 1408 96 1408H320V1568C320 1594.67 329.333 1617.33 348 1636C366.667 1654.67 389.333 1664 416 1664H1376C1382.66 1664 1389.07 1663.42 1395.23 1662.25L1268.98 1536H448V1280H1012.98L628.981 896H448V715.019L320 587.019ZM448 352.981L991.019 896H1344V512H1184C1157.33 512 1134.67 502.667 1116 484C1097.33 465.333 1088 442.667 1088 416V256H448V352.981ZM1600 960C1600 942.667 1593.67 927.667 1581 915C1568.33 902.333 1553.33 896 1536 896C1518.67 896 1503.67 902.333 1491 915C1478.33 927.667 1472 942.667 1472 960C1472 977.333 1478.33 992.333 1491 1005C1503.67 1017.67 1518.67 1024 1536 1024C1553.33 1024 1568.33 1017.67 1581 1005C1593.67 992.333 1600 977.333 1600 960Z" })
	  );
	}
	
	function iconQuestion() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-question", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-question-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-question-title" },
	      "Question"
	    ),
	    _react2.default.createElement("path", { d: "M1024 1376v-192q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v192q0 14 9 23t23 9h192q14 0 23-9t9-23zm256-672q0-88-55.5-163t-138.5-116-170-41q-243 0-371 213-15 24 8 42l132 100q7 6 19 6 16 0 25-12 53-68 86-92 34-24 86-24 48 0 85.5 26t37.5 59q0 38-20 61t-68 45q-63 28-115.5 86.5t-52.5 125.5v36q0 14 9 23t23 9h192q14 0 23-9t9-23q0-19 21.5-49.5t54.5-49.5q32-18 49-28.5t46-35 44.5-48 28-60.5 12.5-81zm384 192q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconRandom() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-random", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-random-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-random-title" },
	      "Random"
	    ),
	    _react2.default.createElement("path", { d: "M666 481q-60 92-137 273-22-45-37-72.5t-40.5-63.5-51-56.5-63-35-81.5-14.5h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224q250 0 410 225zm1126 799q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192q-32 0-85 .5t-81 1-73-1-71-5-64-10.5-63-18.5-58-28.5-59-40-55-53.5-56-69.5q59-93 136-273 22 45 37 72.5t40.5 63.5 51 56.5 63 35 81.5 14.5h256v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23zm0-896q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192h-256q-48 0-87 15t-69 45-51 61.5-45 77.5q-32 62-78 171-29 66-49.5 111t-54 105-64 100-74 83-90 68.5-106.5 42-128 16.5h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224q48 0 87-15t69-45 51-61.5 45-77.5q32-62 78-171 29-66 49.5-111t54-105 64-100 74-83 90-68.5 106.5-42 128-16.5h256v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23z" })
	  );
	}
	
	function iconRedo() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-redo", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-redo-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-redo-title" },
	      "Redo"
	    ),
	    _react2.default.createElement("path", { d: "M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z" })
	  );
	}
	
	function iconRefresh() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-refresh", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-refresh-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-refresh-title" },
	      "Refresh"
	    ),
	    _react2.default.createElement("path", { d: "M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z" })
	  );
	}
	
	function iconReply() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-reply", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-reply-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-reply-title" },
	      "Reply"
	    ),
	    _react2.default.createElement("path", { d: "M1792 1120q0 166-127 451-3 7-10.5 24t-13.5 30-13 22q-12 17-28 17-15 0-23.5-10t-8.5-25q0-9 2.5-26.5t2.5-23.5q5-68 5-123 0-101-17.5-181t-48.5-138.5-80-101-105.5-69.5-133-42.5-154-21.5-175.5-6h-224v256q0 26-19 45t-45 19-45-19l-512-512q-19-19-19-45t19-45l512-512q19-19 45-19t45 19 19 45v256h224q713 0 875 403 53 134 53 333z" })
	  );
	}
	
	function iconRightClickDisable() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-right-click-disable", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-right-click-disable-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-right-click-disable-title" },
	      "Right Click Disable"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1782.12 613.235C1779.11 591.349 1758.93 576.047 1737.05 579.056L1600.33 597.852C1578.45 600.861 1563.15 621.042 1566.15 642.928C1569.16 664.813 1589.34 680.116 1611.23 677.107L1747.94 658.31C1769.83 655.301 1785.13 635.12 1782.12 613.235ZM730.588 383.39C889.269 220.006 1143.28 205.168 1319.21 341.408L1017.39 652.173L1089.12 721.844L1390.94 411.078C1532.26 582.954 1524.85 837.288 1366.17 1000.67L1232.4 1138.4L1691 1597L1601 1687L120 206L210 116L605.838 511.838L730.588 383.39ZM427.964 694.984L269.806 857.829C99.3485 1033.34 103.444 1313.8 278.954 1484.26C454.464 1654.72 734.927 1650.62 905.384 1475.11L1054.53 1321.55L427.964 694.984ZM1701.56 878.206C1719.16 891.554 1722.61 916.644 1709.27 934.247C1695.92 951.851 1670.83 955.3 1653.22 941.953L1543.26 858.573C1525.66 845.225 1522.21 820.134 1535.56 802.531C1548.9 784.928 1573.99 781.478 1591.6 794.826L1701.56 878.206ZM1625.33 323.795C1607.73 310.448 1582.64 313.897 1569.29 331.5L1485.91 441.463C1472.57 459.066 1476.02 484.157 1493.62 497.504C1511.22 510.852 1536.31 507.402 1549.66 489.799L1633.04 379.837C1646.39 362.233 1642.94 337.143 1625.33 323.795Z" })
	  );
	}
	
	function iconScale() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-scale", xmlns: "http://www.w3.org/2000/svg", width: "2304", height: "1792", viewBox: "0 0 2304 1792", "aria-labelledby": "icn-scale-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-scale-title" },
	      "Scale"
	    ),
	    _react2.default.createElement("path", { d: "M1728 448l-384 704h768zm-1280 0l-384 704h768zm821-192q-14 40-45.5 71.5t-71.5 45.5v1291h608q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1344q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h608v-1291q-40-14-71.5-45.5t-45.5-71.5h-491q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h491q21-57 70-92.5t111-35.5 111 35.5 70 92.5h491q14 0 23 9t9 23v64q0 14-9 23t-23 9h-491zm-181 16q33 0 56.5-23.5t23.5-56.5-23.5-56.5-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5zm1088 880q0 73-46.5 131t-117.5 91-144.5 49.5-139.5 16.5-139.5-16.5-144.5-49.5-117.5-91-46.5-131q0-11 35-81t92-174.5 107-195.5 102-184 56-100q18-33 56-33t56 33q4 7 56 100t102 184 107 195.5 92 174.5 35 81zm-1280 0q0 73-46.5 131t-117.5 91-144.5 49.5-139.5 16.5-139.5-16.5-144.5-49.5-117.5-91-46.5-131q0-11 35-81t92-174.5 107-195.5 102-184 56-100q18-33 56-33t56 33q4 7 56 100t102 184 107 195.5 92 174.5 35 81z" })
	  );
	}
	
	function iconSettings() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-settings", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-settings-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-settings-title" },
	      "Settings"
	    ),
	    _react2.default.createElement("path", { d: "M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm512-109v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z" })
	  );
	}
	
	function iconStop() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-stop", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-stop-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-stop-title" },
	      "Stop"
	    ),
	    _react2.default.createElement("path", { d: "M1664 192v1408q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h1408q26 0 45 19t19 45z" })
	  );
	}
	
	function iconTabsClose() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-tabs-close", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-tabs-close-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-tabs-close-title" },
	      "Close Tabs"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M134 284C78.7715 284 34 328.772 34 384V1408C34 1463.23 78.7715 1508 134 1508H1658C1713.23 1508 1758 1463.23 1758 1408V384C1758 328.772 1713.23 284 1658 284H134ZM214 554C186.386 554 164 576.386 164 604V1328C164 1355.61 186.386 1378 214 1378H1578C1605.61 1378 1628 1355.61 1628 1328V604C1628 576.386 1605.61 554 1578 554H214ZM1682 421C1682 458.003 1652 488 1615 488C1578 488 1548 458.003 1548 421C1548 383.997 1578 354 1615 354C1652 354 1682 383.997 1682 421ZM1425 488C1462 488 1492 458.003 1492 421C1492 383.997 1462 354 1425 354C1388 354 1358 383.997 1358 421C1358 458.003 1388 488 1425 488ZM1302 421C1302 458.003 1272 488 1235 488C1198 488 1168 458.003 1168 421C1168 383.997 1198 354 1235 354C1272 354 1302 383.997 1302 421ZM745.797 773L683 835.797L833.203 986L683 1136.2L745.797 1199L896 1048.8L1046.2 1199L1109 1136.2L958.797 986L1109 835.797L1046.2 773L896 923.203L745.797 773Z" })
	  );
	}
	
	function iconTabsOne() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-tabs-one", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-tabs-one-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-tabs-one-title" },
	      "Disable New Tabs"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M517 379C517 323.772 561.772 279 617 279H1681C1736.23 279 1781 323.772 1781 379V1076.41C1781 1131.64 1736.23 1176.41 1681 1176.41H1273V1412.41C1273 1467.64 1228.23 1512.41 1173 1512.41H109C53.7715 1512.41 9 1467.64 9 1412.41V715C9 659.772 53.7715 615 109 615H517V379ZM517 812.958V813H612.313V812.958H1127.69C1155.3 812.958 1177.69 835.344 1177.69 862.958V1367.1C1177.69 1394.71 1155.3 1417.1 1127.69 1417.1H154.313C126.699 1417.1 104.313 1394.71 104.313 1367.1V862.958C104.313 835.344 126.699 812.958 154.313 812.958H517ZM612.313 615V526.958C612.313 499.344 634.699 476.958 662.313 476.958H1635.69C1663.3 476.958 1685.69 499.344 1685.69 526.958V1031.1C1685.69 1058.71 1663.3 1081.1 1635.69 1081.1H1273V715C1273 659.772 1228.23 615 1173 615H612.313ZM1676.16 428.568C1703.29 428.568 1725.28 406.575 1725.28 379.445C1725.28 352.316 1703.29 330.322 1676.16 330.322C1649.03 330.322 1627.03 352.316 1627.03 379.445C1627.03 406.575 1649.03 428.568 1676.16 428.568ZM1585.97 379.445C1585.97 406.575 1563.98 428.568 1536.85 428.568C1509.72 428.568 1487.73 406.575 1487.73 379.445C1487.73 352.316 1509.72 330.322 1536.85 330.322C1563.98 330.322 1585.97 352.316 1585.97 379.445ZM1397.55 428.568C1424.68 428.568 1446.67 406.575 1446.67 379.445C1446.67 352.316 1424.68 330.322 1397.55 330.322C1370.42 330.322 1348.42 352.316 1348.42 379.445C1348.42 406.575 1370.42 428.568 1397.55 428.568ZM1168.16 764.568C1195.29 764.568 1217.28 742.575 1217.28 715.445C1217.28 688.316 1195.29 666.322 1168.16 666.322C1141.03 666.322 1119.03 688.316 1119.03 715.445C1119.03 742.575 1141.03 764.568 1168.16 764.568ZM1077.97 715.445C1077.97 742.575 1055.98 764.568 1028.85 764.568C1001.72 764.568 979.729 742.575 979.729 715.445C979.729 688.316 1001.72 666.322 1028.85 666.322C1055.98 666.322 1077.97 688.316 1077.97 715.445ZM889.548 764.568C916.677 764.568 938.67 742.575 938.67 715.445C938.67 688.316 916.677 666.322 889.548 666.322C862.418 666.322 840.425 688.316 840.425 715.445C840.425 742.575 862.418 764.568 889.548 764.568ZM484.833 1019.57L530.874 973.524L641 1083.65L751.126 973.524L797.167 1019.57L687.041 1129.69L797.167 1239.82L751.126 1285.86L641 1175.73L530.874 1285.86L484.833 1239.82L594.959 1129.69L484.833 1019.57Z" })
	  );
	}
	
	function iconTimes() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-times", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-times-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-times-title" },
	      "Times"
	    ),
	    _react2.default.createElement("path", { d: "M895.97,818.548l452.548,-452.548l141.421,141.421l-452.548,452.549l452.548,452.548l-141.421,141.421l-452.548,-452.548l-452.549,452.548l-141.421,-141.421l452.548,-452.548l-452.548,-452.549l141.421,-141.421l452.549,452.548Z" })
	  );
	}
	
	function iconTimesCircle() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-times-circle", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-times-circle-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-times-circle-title" },
	      "Times Circle"
	    ),
	    _react2.default.createElement("path", { d: "M1277 1122q0-26-19-45l-181-181 181-181q19-19 19-45 0-27-19-46l-90-90q-19-19-46-19-26 0-45 19l-181 181-181-181q-19-19-45-19-27 0-46 19l-90 90q-19 19-19 46 0 26 19 45l181 181-181 181q-19 19-19 45 0 27 19 46l90 90q19 19 46 19 26 0 45-19l181-181 181 181q19 19 45 19 27 0 46-19l90-90q19-19 19-46zm387-226q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconTrash() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-trash", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-trash-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-trash-title" },
	      "Trash"
	    ),
	    _react2.default.createElement("path", { d: "M704 736v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zm256 0v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zm256 0v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zm128 724v-948h-896v948q0 22 7 40.5t14.5 27 10.5 8.5h832q3 0 10.5-8.5t14.5-27 7-40.5zm-672-1076h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z" })
	  );
	}
	
	function iconUndo() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-undo", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-undo-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-undo-title" },
	      "Undo"
	    ),
	    _react2.default.createElement("path", { d: "M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z" })
	  );
	}
	
	function iconUnlock() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-unlock", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-unlock-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-unlock-title" },
	      "Unlock"
	    ),
	    _react2.default.createElement("path", { d: "M1728 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z" })
	  );
	}
	
	function iconUniversity() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-university", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-university-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-university-title" },
	      "University"
	    ),
	    _react2.default.createElement("path", { d: "M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zm-704 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zm1595 960q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z" })
	  );
	}
	
	function iconUpload() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-upload", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-upload-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-upload-title" },
	      "Upload"
	    ),
	    _react2.default.createElement("path", { d: "M1344 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zm-325-648q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z" })
	  );
	}
	
	function iconUser() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-user", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-user-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-user-title" },
	      "User"
	    ),
	    _react2.default.createElement("path", { d: "M1600 1405q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q9 0 42 21.5t74.5 48 108 48 133.5 21.5 133.5-21.5 108-48 74.5-48 42-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-320-893q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z" })
	  );
	}
	
	function iconUsers() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-users", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-users-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-users-title" },
	      "Users"
	    ),
	    _react2.default.createElement("path", { transform: "translate(65, 0)", d: "M529 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zm1071 637q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-1024-1277q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zm704 384q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zm576 225q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zm-128-609q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z" })
	  );
	}
	
	function iconVideoCamera() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-video-camera", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-video-camera-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-video-camera-title" },
	      "Video Camera"
	    ),
	    _react2.default.createElement("path", { d: "M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z" })
	  );
	}
	
	function iconVideoCamera360() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-video-camera-360", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-video-camera-360-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-video-camera-360-title" },
	      "Video Camera Spin"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1246 933.5V508.5C1246 497.562 1240.92 489.88 1230.77 485.453C1227.38 484.151 1224.12 483.5 1221 483.5C1213.97 483.5 1208.11 485.974 1203.42 490.922L1046 647.953V583.5C1046 552.51 1035 526.013 1012.99 504.008C990.987 482.003 964.49 471 933.5 471H658.5C627.51 471 601.013 482.003 579.008 504.008C557.003 526.013 546 552.51 546 583.5V858.5C546 889.49 557.003 915.987 579.008 937.992C601.013 959.997 627.51 971 658.5 971H933.5C964.49 971 990.987 959.997 1012.99 937.992C1035 915.987 1046 889.49 1046 858.5V793.656L1203.42 951.078C1208.11 956.026 1213.97 958.5 1221 958.5C1224.12 958.5 1227.38 957.849 1230.77 956.547C1240.92 952.12 1246 944.438 1246 933.5ZM751.165 1135.23C794.202 1143.95 805.058 1124.37 803.023 1090.06C802.911 1088.1 802.691 1086.03 802.464 1083.9C801.308 1073.03 799.995 1060.69 812.231 1055.26C823.602 1050.21 831.346 1057.87 838.69 1065.12C840.799 1067.2 842.874 1069.25 844.993 1070.96C861.011 1083.9 876.93 1097.06 892.872 1110.25L892.885 1110.26L892.89 1110.26C915.531 1128.99 938.22 1147.76 961.309 1165.95C983.118 1183.3 984.475 1197.07 961.309 1215.1C931.503 1238.56 902.433 1263 873.401 1287.41L873.383 1287.42C861.635 1297.3 849.893 1307.17 838.111 1316.97C815.624 1335.68 800.115 1330.64 803.507 1301.46C809.905 1247.28 782.28 1238.26 735.657 1235.74C580.569 1227.41 426.741 1211.8 276.403 1171.09C210.878 1153.26 145.742 1133.87 88.6499 1095.39C6.06571 1039.75 6.16263 975.584 90.6854 921.497C170.943 870.125 262.639 848.994 354.141 828.542C354.36 828.493 354.582 828.443 354.807 828.392C355.118 828.321 355.434 828.249 355.754 828.176C364.377 826.207 375.936 823.568 378.761 835.23C379.787 844.666 377.748 854.182 372.945 862.37C366.238 876.269 352.929 879.254 339.702 882.222L339.701 882.222C337.062 882.814 334.426 883.405 331.847 884.082C329.31 884.755 326.772 885.425 324.233 886.095C279.93 897.791 235.566 909.502 196.145 933.614C142.155 966.473 142.446 1002.24 197.599 1034.52C257.988 1069.96 325.907 1083.27 393.281 1096.48C395.55 1096.92 397.818 1097.37 400.085 1097.81C517.564 1120.88 636.788 1129.12 751.165 1135.23ZM1016.07 1185.73C1007.02 1134.37 1043.87 1133.03 1077.62 1131.8L1078.91 1131.76L1079.37 1131.74C1213.37 1128.24 1346.61 1110.33 1476.78 1078.33C1511.08 1069.32 1544.62 1057.65 1577.1 1043.43L1577.84 1043.11C1603.84 1031.75 1633.53 1018.78 1634.68 984.599C1635.84 951.434 1610.55 939.545 1586.77 928.368L1586.77 928.368C1582.75 926.478 1578.77 924.609 1574.97 922.66C1540.62 905.033 1503.33 895.386 1466.08 885.747L1466.06 885.741C1459.48 884.04 1452.9 882.338 1446.35 880.593C1443.33 879.779 1439.88 879.209 1436.32 878.62C1420.81 876.051 1403.2 873.135 1409.9 848.218C1416.51 823.571 1435.62 827.884 1453.75 831.975L1453.76 831.978C1455.31 832.326 1456.84 832.673 1458.37 833C1538.72 851.611 1618.59 871.772 1690.51 914.421C1788.7 971.901 1790.93 1043.14 1693.9 1101.11C1578.27 1169.64 1448.48 1190.87 1319.17 1210.25C1268.51 1217.81 1217.36 1222.23 1166.19 1226.65L1166.19 1226.65C1132.1 1229.6 1098.01 1232.55 1064.05 1236.42C1023.83 1240.78 1010.55 1223.63 1016.07 1185.73Z" })
	  );
	}
	
	function iconVolumeOff() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-volume-off", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", preserveAspectRatio: "xMinYMin meet", "aria-labelledby": "icn-volume-off-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-volume-off-title" },
	      "Volume Off"
	    ),
	    _react2.default.createElement("path", { d: "M1280 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45z" })
	  );
	}
	
	function iconVolumeUp() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-volume-up", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-volume-up-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-volume-up-title" },
	      "Volume Up"
	    ),
	    _react2.default.createElement("path", { d: "M832 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zm384 544q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-36 12-56.5-12-56.5-29-36-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142zm256 0q0 153-85 282.5t-225 188.5q-13 5-25 5-27 0-46-19t-19-45q0-39 39-59 56-29 76-44 74-54 115.5-135.5t41.5-173.5-41.5-173.5-115.5-135.5q-20-15-76-44-39-20-39-59 0-26 19-45t45-19q13 0 26 5 140 59 225 188.5t85 282.5zm256 0q0 230-127 422.5t-338 283.5q-13 5-26 5-26 0-45-19t-19-45q0-36 39-59 7-4 22.5-10.5t22.5-10.5q46-25 82-51 123-91 192-227t69-289-69-289-192-227q-36-26-82-51-7-4-22.5-10.5t-22.5-10.5q-39-23-39-59 0-26 19-45t45-19q13 0 26 5 211 91 338 283.5t127 422.5z" })
	  );
	}
	
	function iconWifi() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-wifi", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2000 2000", "aria-labelledby": "icn-wifi-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-windows-title" },
	      "Windows"
	    ),
	    _react2.default.createElement("path", { d: "M1024 1523q-20 0-93-73.5t-73-93.5q0-32 62.5-54t103.5-22 103.5 22 62.5 54q0 20-73 93.5t-93 73.5zm270-271q-2 0-40-25t-101.5-50-128.5-25-128.5 25-101 50-40.5 25q-18 0-93.5-75t-75.5-93q0-13 10-23 78-77 196-121t233-44 233 44 196 121q10 10 10 23 0 18-75.5 93t-93.5 75zm273-272q-11 0-23-8-136-105-252-154.5t-268-49.5q-85 0-170.5 22t-149 53-113.5 62-79 53-31 22q-17 0-92-75t-75-93q0-12 10-22 132-132 320-205t380-73 380 73 320 205q10 10 10 22 0 18-75 93t-92 75zm271-271q-11 0-22-9-179-157-371.5-236.5t-420.5-79.5-420.5 79.5-371.5 236.5q-11 9-22 9-17 0-92.5-75t-75.5-93q0-13 10-23 187-186 445-288t527-102 527 102 445 288q10 10 10 23 0 18-75.5 93t-92.5 75z" })
	  );
	}
	
	function iconWindows() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-windows", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-windows-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-windows-title" },
	      "Windows"
	    ),
	    _react2.default.createElement("path", { d: "M746 1006v651l-682-94v-557h682zm0-743v659h-682v-565zm982 743v786l-907-125v-661h907zm0-878v794h-907v-669z" })
	  );
	}
	
	// Custom Proctor Type Icons
	function iconAttended() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-attended", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 121 121", "aria-labelledby": "icn-attended-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-attended-title" },
	      "Attended Virtual"
	    ),
	    _react2.default.createElement(
	      "g",
	      { fillRule: "evenodd" },
	      _react2.default.createElement("path", { d: "m113.93,78.28l0,-60.32872c0,-2.26579 -1.83927,-4.10128 -4.10813,-4.10128l-98.24374,0c-2.26032,0 -4.10813,1.8362 -4.10813,4.10128l0,60.32872l-6.22,0c-0.27377,-0.01371 -0.54116,0.08557 -0.73966,0.27461c-0.19849,0.18904 -0.31068,0.45128 -0.31034,0.72539c-0.11978,1.94226 -0.09972,3.89062 0.06,5.83c0.24,3.61 4.98,6.61 12.16,6.61l93.12,0c12.68,0 15.27,-3.98 15.27,-7.33l0,-5.11c0,-0.55228 -0.44772,-1 -1,-1l-5.88,0zm-5.91,0l0,-57.71993c0,-0.55912 -0.44907,-1.00007 -1.00304,-1.00007l-93.03392,0c-0.55816,0 -1.00304,0.44775 -1.00304,1.00007l0,57.71993l95.04,0zm-45.73,-67.34835c2.20071,-0.67844 3.8,-2.72828 3.8,-5.15165c0,-2.97681 -2.41319,-5.39 -5.39,-5.39c-2.97681,0 -5.39,2.41319 -5.39,5.39c0,2.42337 1.59929,4.47321 3.8,5.15165l0,1.33835l-4.89,0l0,1.58l12.96,0l0,-1.58l-4.89,0l0,-1.33835zm-1.59,-2.89165c1.24816,0 2.26,-1.01184 2.26,-2.26c0,-1.24816 -1.01184,-2.26 -2.26,-2.26c-1.24816,0 -2.26,1.01184 -2.26,2.26c0,1.24816 1.01184,2.26 2.26,2.26zm25.81,70.24l-51.86,0c0,0 0.04333,-4.31333 0.13,-5.52c0.10148,-1.34169 0.27507,-2.67696 0.52,-4c0.2448,-1.35392 0.57886,-2.69017 1,-4c0.401,-1.24812 0.93051,-2.45124 1.58,-3.59c0.61027,-1.10542 1.37834,-2.11604 2.28,-3c0.90925,-0.86606 1.97942,-1.54554 3.15,-2c1.31058,-0.50542 2.70544,-0.75656 4.11,-0.74c0.56314,0.16 1.08964,0.42835 1.55,0.79l2.72,1.78c1.25342,0.75619 2.59741,1.35091 4,1.77c3.19174,1.05506 6.63826,1.05506 9.83,0c1.40244,-0.41949 2.74638,-1.01419 4,-1.77l2.74,-1.77c0.4605,-0.36143 0.98696,-0.62976 1.55,-0.79c1.40454,-0.01632 2.79936,0.23482 4.11,0.74c1.17047,0.4547 2.24059,1.13414 3.15,2c0.90166,0.88397 1.66973,1.89458 2.28,3c0.64911,1.13895 1.17859,2.34203 1.58,3.59c0.42066,1.30997 0.75472,2.64619 1,4c0.24493,1.32304 0.41852,2.65831 0.52,4c0.04,1.23333 0.06,2.5 0.06,3.8l0,1.71zm-15.93,-44.6c2.65269,2.65189 4.14302,6.2491 4.14302,10c0,3.7509 -1.49033,7.34811 -4.14302,10c-2.65189,2.65269 -6.2491,4.14302 -10,4.14302c-3.7509,0 -7.34811,-1.49033 -10,-4.14302c-2.65269,-2.65189 -4.14302,-6.2491 -4.14302,-10c0,-3.7509 1.49033,-7.34811 4.14302,-10c2.65189,-2.65269 6.2491,-4.14302 10,-4.14302c3.7509,0 7.34811,1.49033 10,4.14302l0,0z" })
	    )
	  );
	}
	
	function iconUnattended() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-unattended", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 120 120", "aria-labelledby": "icn-unattended-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-unattended-title" },
	      "Unattended Virtual"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", d: "m113.93,78.28l0,-60.328725c0,-2.265783 -1.839271,-4.101275 -4.108126,-4.101275l-98.243748,0c-2.260313,0 -4.108126,1.836203 -4.108126,4.101275l0,60.328725l-6.22,0l0,0c-0.273769,-0.013706 -0.541161,0.085569 -0.739656,0.274611c-0.198494,0.189043 -0.310687,0.451278 -0.310344,0.725389c-0.119776,1.942259 -0.099724,3.890617 0.06,5.83c0.24,3.61 4.98,6.61 12.16,6.61l93.12,0c12.68,0 15.27,-3.98 15.27,-7.33l0,-5.11c0,-0.552285 -0.447715,-1 -1,-1l-5.88,0zm-5.91,0l0,-57.719932c0,-0.559121 -0.449075,-1.000068 -1.003038,-1.000068l-93.033924,0c-0.558155,0 -1.003038,0.447746 -1.003038,1.000068l0,57.719932l95.04,0zm-45.73,-67.348354c2.200712,-0.678438 3.8,-2.728275 3.8,-5.151646c0,-2.976815 -2.413185,-5.39 -5.39,-5.39c-2.976815,0 -5.39,2.413185 -5.39,5.39c0,2.423371 1.599288,4.473208 3.8,5.151646l0,1.338354l-4.89,0l0,1.58l12.96,0l0,-1.58l-4.89,0l0,-1.338354zm-1.59,-2.891646c1.248163,0 2.26,-1.011836 2.26,-2.26c0,-1.248164 -1.011837,-2.26 -2.26,-2.26c-1.248164,0 -2.26,1.011836 -2.26,2.26c0,1.248164 1.011836,2.26 2.26,2.26z" })
	  );
	}
	
	function iconIndividual() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-individual", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 100 100", "aria-labelledby": "icn-individual-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-individual-title" },
	      "Individual"
	    ),
	    _react2.default.createElement("path", { d: "m83,75.31c0,4.666667 -1.426667,8.366667 -4.28,11.1c-2.853333,2.733333 -6.64,4.09 -11.36,4.07l-51.16,0c-4.726667,0 -8.513333,-1.356667 -11.36,-4.07c-2.846667,-2.713333 -4.273333,-6.413333 -4.28,-11.1c0,-2.066667 0.066667,-4.086667 0.2,-6.06c0.158423,-2.139863 0.432154,-4.269624 0.82,-6.38c0.376568,-2.148427 0.894357,-4.269693 1.55,-6.35c0.640068,-1.985438 1.484598,-3.899035 2.52,-5.71c0.973526,-1.747811 2.196353,-3.34456 3.63,-4.74c1.447386,-1.358398 3.145737,-2.421565 5,-3.13c2.082755,-0.800645 4.298827,-1.197705 6.53,-1.17c0.898809,0.244768 1.741218,0.662575 2.48,1.23c1.286667,0.84 2.74,1.776667 4.36,2.81c1.989574,1.203451 4.123106,2.15094 6.35,2.82c5.078024,1.679774 10.561976,1.679774 15.64,0c2.219321,-0.667965 4.345962,-1.61202 6.33,-2.81c1.6,-1.033333 3.043333,-1.973333 4.33,-2.82c0.730522,-0.575569 1.566043,-1.003518 2.46,-1.26c2.231153,-0.027462 4.447179,0.36959 6.53,1.17c1.85392,0.709124 3.552144,1.772212 5,3.13c1.433221,1.395818 2.655998,2.992502 3.63,4.74c1.035402,1.810965 1.879932,3.724562 2.52,5.71c0.659148,2.08682 1.180274,4.21475 1.56,6.37c0.387846,2.110376 0.661577,4.240137 0.82,6.38c0.12,1.98 0.18,4.003333 0.18,6.07l0,0zm-25.31,-68.2c4.294957,4.160565 6.679797,9.910962 6.59,15.89c0.092571,5.982495 -2.29249,11.737042 -6.59,15.9c-4.162958,4.29751 -9.917505,6.682571 -15.9,6.59c-5.982495,0.092571 -11.737042,-2.29249 -15.9,-6.59c-4.29751,-4.162958 -6.682571,-9.917505 -6.59,-15.9c-0.092571,-5.982495 2.29249,-11.737042 6.59,-15.9c4.162958,-4.29751 9.917505,-6.682571 15.9,-6.59c5.983986,-0.089959 11.738754,2.298813 15.9,6.6l0,0z" })
	  );
	}
	
	function iconInstructor() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-instructor", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 100 100", "aria-labelledby": "icn-instructor-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-instructor-title" },
	      "Instructor"
	    ),
	    _react2.default.createElement("path", { d: "m81.48,88.48l-68,0c-1.622538,-0.016347 -3.037216,-1.135228 -3.429258,-2.720124l-7.681434,-30.285724c-0.276351,-1.075327 -0.040317,-2.214764 0.638536,-3.089322c0.678853,-0.874558 1.724141,-1.385833 2.831251,-1.38483l83.330905,0c1.103372,0.000228 2.145168,0.509417 2.823334,1.380035c0.678165,0.870618 0.916898,2.005351 0.647027,3.075423l-7.689632,30.298546c-0.396368,1.601957 -1.827765,2.723863 -3.472027,2.725997l0.001298,-0.000001zm0.001298,1.999999c2.562843,-0.003325 4.793903,-1.751995 5.409432,-4.239825l7.688541,-30.294178c0.421004,-1.669333 0.048902,-3.437994 -1.008128,-4.794992c-1.057029,-1.356997 -2.680834,-2.150649 -4.400936,-2.151004l-83.330207,0c-1.724702,-0.001562 -3.353949,0.795341 -4.412049,2.158479c-1.058101,1.363139 -1.425997,3.139132 -0.996478,4.81043l7.679219,30.276939c0.609626,2.464589 2.814626,4.208543 5.359265,4.234102l68.010043,0.00005l0.001298,-0.000001zm-66.811298,-41.479999c0,-1.327247 0.046667,-2.654493 0.14,-3.98174c0.104032,-1.40559 0.284295,-2.804557 0.54,-4.190781c0.240849,-1.410665 0.574907,-2.80398 1,-4.170873c0.41976,-1.294218 0.972694,-2.541814 1.65,-3.722927c0.641162,-1.145138 1.446258,-2.191345 2.39,-3.105757c0.955491,-0.890752 2.076446,-1.587305 3.3,-2.050596c1.371568,-0.524502 2.830817,-0.784617 4.3,-0.766485c0.588832,0.167927 1.139107,0.44857 1.62,0.826211l2.9,1.8316c1.306907,0.78552 2.70791,1.404231 4.17,1.841555c3.344242,1.101078 6.955758,1.101078 10.3,0c1.458525,-0.438398 2.856088,-1.057073 4.16,-1.841555l2.86,-1.841554c0.481032,-0.377426 1.031262,-0.658047 1.62,-0.826211c1.469183,-0.018132 2.928432,0.241982 4.3,0.766485c1.223325,0.463749 2.344195,1.16025 3.3,2.050596c0.94353,0.9146 1.748601,1.960774 2.39,3.105757c0.686966,1.176759 1.249955,2.421023 1.68,3.712972c0.424619,1.367023 0.75867,2.760306 1,4.170873c0.255705,1.386224 0.435968,2.785191 0.54,4.190781c0.093333,1.294066 0.14,2.621313 0.14,3.98174l-54.3,0.019909zm62.646195,-16.546566c-0.385313,0.114872 -0.793549,0.176566 -1.216195,0.176566c-2.34721,0 -4.25,-1.90279 -4.25,-4.25c0,-2.34721 1.90279,-4.25 4.25,-4.25c2.34721,0 4.25,1.90279 4.25,4.25c0,1.204601 -0.501156,2.292151 -1.306344,3.065524l4.790362,8.221015l0.131719,0.22605l0.004138,0.261594l0.14,8.85l-1.99975,0.031634l-0.14,-8.85l0.135857,0.487644l-4.789787,-8.220027zm-25.016195,-27.953434c2.837694,2.748383 4.40909,6.550147 4.34,10.5c-0.016535,8.16924 -6.640745,14.784504 -14.81,14.79c-8.177062,0.005534 -14.813449,-6.612953 -14.83,-14.79c-0.005312,-3.935706 1.555104,-7.711889 4.337133,-10.495793c2.782028,-2.783905 6.557159,-4.346866 10.492867,-4.344207c3.939486,-0.060753 7.72879,1.50998 10.47,4.34l0,0z" })
	  );
	}
	
	function iconTestingCenters() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-testing-centers", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 100 100", "aria-labelledby": "icn-testing-centers-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-testing-centers-title" },
	      "Testing Centers"
	    ),
	    _react2.default.createElement("path", { d: "m24.15,91l-18.103814,0c-1.867581,0 -3.381554,-1.392394 -3.381554,-3.11l0,-65.28c0,-1.717606 1.513973,-3.11 3.381554,-3.11l13.754549,0l0,-2l-13.754549,0c-3.068597,0 -5.556186,2.287825 -5.556186,5.11l0,65.28c0,2.822175 2.487589,5.11 5.556186,5.11l18.103814,0l0,-2l0,0zm-0.72,2l35.57,0c2.822175,0 5.11,-2.287825 5.11,-5.11l0,-82.2c0,-2.822175 -2.287825,-5.11 -5.11,-5.11l-35.57,0c-2.822175,0 -5.11,2.287825 -5.11,5.11l0,86.31l0,1l1,0l4.11,0l0,0zm0,-2l-4.11,0l1,1l0,-86.31c0,-1.717606 1.392394,-3.11 3.11,-3.11l35.57,0c1.717606,0 3.11,1.392394 3.11,3.11l0,82.2c0,1.717606 -1.392394,3.11 -3.11,3.11l-35.57,0l0,0zm16.77,-16.67l0,17.67l2,0l0,-17.67l-2,0l0,0zm-34.87,-48.14l9.88,0l0,9.88l-9.88,0l0,-9.88zm0,15.73l9.88,0l0,9.88l-9.88,0l0,-9.88zm0,15.74l9.88,0l0,9.88l-9.88,0l0,-9.88zm0,15.73l9.88,0l0,9.88l-9.88,0l0,-9.88zm17.12,-63.14l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.94l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.93l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.94l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-5.89,17.27l21.66,0l-1,-1l0,17.33l1,-1l-21.66,0l1,1l0,-17.33l-1,1l0,0zm0,-2l-1,0l0,1l0,17.33l0,1l1,0l21.66,0l1,0l0,-1l0,-17.33l0,-1l-1,0l-21.66,0l0,0z" })
	  );
	}
	
	function iconCentersIndivuals() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-centers-individuals", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 100 100", "aria-labelledby": "icn-centers-individuals-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-centers-individuals-title" },
	      "Testing Centers and Individuals"
	    ),
	    _react2.default.createElement("path", { d: "m2.32,5.395257c0,-1.716208 1.391547,-3.105257 3.115894,-3.105257l35.518212,0c1.717928,0 3.115894,1.396503 3.115894,3.105257l0,82.209486c0,1.716208 -1.391547,3.105257 -3.115894,3.105257l-35.518212,0c-1.717928,0 -3.115894,-1.396503 -3.115894,-3.105257l0,-82.209486l0,0zm-2,82.209486c0,2.813793 2.293865,5.105257 5.115894,5.105257l35.518212,0c2.828113,0 5.115894,-2.283674 5.115894,-5.105257l0,-82.209486c0,-2.813793 -2.293865,-5.105257 -5.115894,-5.105257l-35.518212,0c-2.828113,0 -5.115894,2.283674 -5.115894,5.105257l0,82.209486zm4.13,-77.654743l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.94l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.94l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.93l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-5.89,17.28l21.66,0l-1,-1l0,17.33l1,-1l-21.66,0l1,1l0,-17.33l-1,1l0,0zm0,-2l-1,0l0,1l0,17.33l0,1l1,0l21.66,0l1,0l0,-1l0,-17.33l0,-1l-1,0l-21.66,0zm9.83,1l0,17.66l2,0l0,-17.66l-2,0zm67.15,15.87c-2.073744,1.876381 -4.80659,2.854452 -7.6,2.72c0,0 -23.364112,-0.036478 -34.394054,-0.055995c-4.028229,-0.007127 -6.535261,0.000001 -5.534413,0.000001c1.79689,0 3.447571,-2.038971 3.674927,-2.525299c0.496025,-1.20282 0.57354,-2.177202 0.57354,-2.177202l0,-27.061505c0,0 3.001606,-0.828942 4.52,-0.81c0.599396,0.170026 1.159864,0.455355 1.65,0.84l2.92,1.88c1.325681,0.801386 2.746814,1.433001 4.23,1.88c3.396252,1.122937 7.063748,1.122937 10.46,0c1.483075,-0.447297 2.904173,-1.078896 4.23,-1.88l2.92,-1.85c0.490274,-0.384428 1.050698,-0.669735 1.65,-0.84c1.492935,-0.019288 2.975927,0.245411 4.37,0.78c1.242486,0.475726 2.380359,1.18902 3.35,2.1c0.95923,0.933422 1.777777,2.001239 2.43,3.17c0.694086,1.21138 1.260459,2.491583 1.69,3.82c0.425697,1.393333 0.759744,2.813034 1,4.25c0.259988,1.412407 0.443588,2.837812 0.55,4.27c0.113333,1.326667 0.17,2.68 0.17,4.06c0.144768,2.770389 -0.895037,5.471701 -2.86,7.43zm-14.09,-53.07c2.833533,2.815717 4.426902,6.645357 4.426902,10.64c0,3.994643 -1.593369,7.824283 -4.426902,10.64c-4.286057,4.35465 -10.785107,5.674357 -16.430187,3.33634c-5.645081,-2.338017 -9.30785,-7.866434 -9.259813,-13.97634c-0.048037,-6.109906 3.614732,-11.638323 9.259813,-13.97634c5.64508,-2.338017 12.14413,-1.01831 16.430187,3.33634l0,0z" })
	  );
	}
	
	function iconExamity() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-examity", xmlns: "http://www.w3.org/2000/svg", width: "369", height: "413", viewBox: "0 0 369 413", "aria-labelledby": "icn-examity-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-examity-title" },
	      "Examity"
	    ),
	    _react2.default.createElement(
	      "g",
	      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement("path", { d: "M0,0 L369,0 L369,245.000561 C369,245.000561 366.378906,281.325473 346.394531,298.860669 C326.410156,316.395866 184.5,413.290009 184.5,413.290009 C184.5,413.290009 41.9213646,316.951358 21.9345703,298.860669 C1.94777598,280.76998 0,245.000561 0,245.000561 L0,0 Z", fill: "#F99500" }),
	      _react2.default.createElement("path", { d: "M345,21 L345,233 C345,233 346.260742,269.49707 322.394531,286.859985 C298.52832,304.2229 184.5,384.289062 184.5,384.289062 L184.5,21 L345,21 Z", fill: "#FEB130" }),
	      _react2.default.createElement("path", { d: "M165.5,205 L115.490833,205 C106.107055,205 98.5,212.609095 98.5,222 C98.5,231.388841 106.113054,239 115.490833,239 L175.75,239 L167,239 L171.921312,216.361967 C167.989025,213.611282 165.5,209.541321 165.5,205 Z M184.5,190.005372 L184.5,164 L115.490833,164 C106.107055,164 98.5,171.609095 98.5,181 C98.5,190.388841 106.113054,198 115.490833,198 L167.633773,198 C170.7356,193.242196 176.900826,190 184,190 C184.167194,190 184.33387,190.001798 184.5,190.005372 Z M184.5,246 L184.5,280 L115.490833,280 C106.113054,280 98.5,272.388841 98.5,263 C98.5,253.609095 106.107055,246 115.490833,246 L184.5,246 Z", fill: "#E7E7E9" }),
	      _react2.default.createElement("path", { d: "M202.5,205 L253.509167,205 C262.892945,205 270.5,212.609095 270.5,222 C270.5,231.388841 262.886946,239 253.509167,239 L192.75,239 L201,239 L196.078688,216.361967 C200.010975,213.611282 202.5,209.541321 202.5,205 Z M200.366218,198 L253.509167,198 C262.886946,198 270.5,190.388841 270.5,181 C270.5,171.609095 262.892945,164 253.509167,164 L184.5,164 L184.5,190.005372 C191.387873,190.153556 197.337453,193.354249 200.366218,198 Z M184.5,246 L253.509167,246 C262.892945,246 270.5,253.609095 270.5,263 C270.5,272.388841 262.886946,280 253.509167,280 L184.5,280 L184.5,246 Z", fill: "#FFFFFF" }),
	      _react2.default.createElement("path", { d: "M150,158 L128,158 L128,166.5 L128,122 C128,92.7289083 151.735198,69 181.007127,69 L186.992873,69 C216.267901,69 240,92.7224724 240,122 L240,166.5 L240,158 L218,158 L218,149.955357 L218,123.732143 C218,106.203111 203.791587,92 186.264622,92 L181.735378,92 C164.213622,92 150,106.206964 150,123.732143 L150,149.955357 L150,158 Z", fill: "#E7E7E9" }),
	      _react2.default.createElement("path", { d: "M128,162 L128,166.5 L128,162 L128,162 Z M184.5,69 L186.992873,69 C216.267901,69 240,92.7224724 240,122 L240,166.5 L240,158 L218,158 L218,149.955357 L218,123.732143 C218,106.203111 203.791587,92 186.264622,92 L184.5,92 L184.5,69 Z", fill: "#FFFFFF" })
	    )
	  );
	}
	
	function iconProctorU() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-proctoru", xmlns: "http://www.w3.org/2000/svg", width: "56", height: "89", viewBox: "0 0 56 89", "aria-labelledby": "icn-proctoru-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-proctoru-title" },
	      "ProctorU"
	    ),
	    _react2.default.createElement(
	      "g",
	      { stroke: "none", fillRule: "nonzero", fill: "#00B2E3" },
	      _react2.default.createElement("path", { d: "M54.4,84.1 C52.3,83.7 51.3,81.8 51.2,78.3 L51.2,36.2 L42,36.2 L42,62.6 C42.1127672,67.3637433 40.3118817,71.9740102 37,75.4 C34.0836635,78.2267451 30.1607863,79.7743021 26.1,79.7 C17.2,79.6 10.7,72.2 10.7,62.1 L10.7,42.3 C10.6835833,38.8826577 7.91734235,36.1164167 4.5,36.1 L1.5,36.1 L1.5,62.5 C1.36209305,69.7762934 4.21818418,76.7899855 9.4,81.9 C13.9454313,86.3240817 20.05739,88.7688652 26.4,88.7 L27.1,88.7 C32.9,88.5 37.3,86.6 42.1,82 C42.3009589,83.3904082 42.9301113,84.6836658 43.9,85.7 C45.435538,87.3469725 47.6637748,88.1639926 49.9,87.9 C51.8811342,87.7836371 53.6939423,86.7477468 54.8,85.1 L55.4,84.1 L54.4,84.1 Z" }),
	      _react2.default.createElement("path", { d: "M14.4,25 C17.7137085,25 20.4,22.3137085 20.4,19 C20.4,15.6862915 17.7137085,13 14.4,13 C11.0862915,13 8.4,15.6862915 8.4,19 C8.4,22.3137085 11.0862915,25 14.4,25 L14.4,25 Z" }),
	      _react2.default.createElement("path", { d: "M14.4,32.9 C17.3532259,32.9093841 20.230077,31.9621283 22.6,30.2 L25.7,34 C25.8891647,34.1816809 26.1379796,34.2883159 26.4,34.3 C26.6659703,34.3071418 26.9217438,34.1975245 27.1,34 L30.2,30.2 C32.569923,31.9621283 35.4467741,32.9093841 38.4,32.9 C42.0889521,32.9079877 45.6291144,31.4460927 48.2376036,28.8376036 C50.8460927,26.2291144 52.3079877,22.6889521 52.3,19 C52.3125218,15.264544 50.7947419,11.6869199 48.1,9.1 L51.6,5 C52.1906073,4.11849265 52.4394876,3.05186283 52.3,2 C52.3,0.6 52.1,-0.3 51,0.1 C51,0.1 34.3,7.3 26.3,7.3 C18.3,7.3 1.6,0.1 1.6,0.1 C0.5,-0.3 0.3,0.6 0.3,2 C0.172248407,3.05125881 0.420184084,4.11384028 1,5 L4.5,9.1 C1.80525811,11.6869199 0.287478185,15.264544 0.3,19 C0.446526091,26.6930833 6.70560851,32.8633844 14.4,32.9 Z M38.3,9.3 C42.2232838,9.3 45.7602558,11.6633291 47.2616315,15.2879707 C48.7630072,18.9126123 47.9331163,23.0847552 45.1589358,25.8589358 C42.3847552,28.6331163 38.2126123,29.4630072 34.5879707,27.9616315 C30.9633291,26.4602558 28.6,22.9232838 28.6,19 C28.605512,13.6451227 32.9451227,9.30551197 38.3,9.3 L38.3,9.3 Z M26.4,26.1 L26.4,31.3 C26.4053603,31.4004141 26.3387857,31.4905356 26.2412311,31.5149242 C26.1436764,31.5393129 26.042524,31.4911232 26,31.4 L23.9,28.9 C24.836032,28.063705 25.6746743,27.1244256 26.4,26.1 L26.4,26.1 Z M14.4,9.3 C19.7571621,9.3 24.1,13.6428379 24.1,19 C24.1,24.3571621 19.7571621,28.7 14.4,28.7 C9.04283793,28.7 4.7,24.3571621 4.7,19 C4.70551197,13.6451227 9.04512272,9.30551197 14.4,9.3 L14.4,9.3 Z" }),
	      _react2.default.createElement("path", { d: "M38.3,25 C41.6137085,25 44.3,22.3137085 44.3,19 C44.3,15.6862915 41.6137085,13 38.3,13 C34.9862915,13 32.3,15.6862915 32.3,19 C32.3,22.3137085 34.9862915,25 38.3,25 L38.3,25 Z" })
	    )
	  );
	}
	
	// Incident type icons
	function icon_injured() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-injured", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-injured-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-injured-title" },
	      "Injured"
	    ),
	    _react2.default.createElement("path", { d: "M1280 1120v-192q0-14-9-23t-23-9h-224v-224q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v224h-224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h224v224q0 14 9 23t23 9h192q14 0 23-9t9-23v-224h224q14 0 23-9t9-23zm-640-736h512v-128h-512v128zm-384 0v1280h-32q-92 0-158-66t-66-158v-832q0-92 66-158t158-66h32zm1184 0v1280h-1088v-1280h160v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h160zm352 224v832q0 92-66 158t-158 66h-32v-1280h32q92 0 158 66t66 158z" })
	  );
	}
	
	function icon_technical() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-technical", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-technical-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-technical-title" },
	      "Technical"
	    ),
	    _react2.default.createElement("path", { d: "M352 1280q-66 0-113-47t-47-113v-704q0-66 47-113t113-47h1088q66 0 113 47t47 113v704q0 66-47 113t-113 47h-1088zm-32-864v704q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5v-704q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5zm1376 928h160v96q0 40-47 68t-113 28h-1600q-66 0-113-28t-47-68v-96h1760zm-720 96q16 0 16-16t-16-16h-160q-16 0-16 16t16 16h160z" })
	  );
	}
	
	function icon_space() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-space", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-space-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-space-title" },
	      "space"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-1024-864q0-14 9-23t23-9h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64zm736 224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704zm0 256q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704z" })
	  );
	}
	
	function icon_outside_help() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-outside-help", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-outside-help-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-outside-help-title" },
	      "Outside Help"
	    ),
	    _react2.default.createElement("path", { transform: "translate(65, 0)", d: "M529 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zm1071 637q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-1024-1277q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zm704 384q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zm576 225q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zm-128-609q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z" })
	  );
	}
	
	function icon_non_permitted_items() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-items", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-items-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-items-title" },
	      "Non-permitted Items"
	    ),
	    _react2.default.createElement("path", { d: "M1703 478q40 57 18 129l-275 906q-19 64-76.5 107.5t-122.5 43.5h-923q-77 0-148.5-53.5t-99.5-131.5q-24-67-2-127 0-4 3-27t4-37q1-8-3-21.5t-3-19.5q2-11 8-21t16.5-23.5 16.5-23.5q23-38 45-91.5t30-91.5q3-10 .5-30t-.5-28q3-11 17-28t17-23q21-36 42-92t25-90q1-9-2.5-32t.5-28q4-13 22-30.5t22-22.5q19-26 42.5-84.5t27.5-96.5q1-8-3-25.5t-2-26.5q2-8 9-18t18-23 17-21q8-12 16.5-30.5t15-35 16-36 19.5-32 26.5-23.5 36-11.5 47.5 5.5l-1 3q38-9 51-9h761q74 0 114 56t18 130l-274 906q-36 119-71.5 153.5t-128.5 34.5h-869q-27 0-38 15-11 16-1 43 24 70 144 70h923q29 0 56-15.5t35-41.5l300-987q7-22 5-57 38 15 59 43zm-1064 2q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5zm-83 256q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5z" })
	  );
	}
	
	function icon_noisy() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-noisy-help", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-noisy-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-noisy-title" },
	      "Noisy"
	    ),
	    _react2.default.createElement("path", { d: "M832 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zm384 544q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-35.5 12-57-12-57-29-35.5-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142zm256 0q0 153-85 282.5t-225 188.5q-13 5-25 5-27 0-46-19t-19-45q0-39 39-59 56-29 76-44 74-54 115.5-135.5t41.5-173.5-41.5-173.5-115.5-135.5q-20-15-76-44-39-20-39-59 0-26 19-45t45-19q13 0 26 5 140 59 225 188.5t85 282.5zm256 0q0 230-127 422.5t-338 283.5q-13 5-26 5-26 0-45-19t-19-45q0-36 39-59 7-4 22.5-10.5t22.5-10.5q46-25 82-51 123-91 192-227t69-289-69-289-192-227q-36-26-82-51-7-4-22.5-10.5t-22.5-10.5q-39-23-39-59 0-26 19-45t45-19q13 0 26 5 211 91 338 283.5t127 422.5z" })
	  );
	}
	
	function icon_ill() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-ill", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-ill-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-ill-title" },
	      "Ill"
	    ),
	    _react2.default.createElement("path", { transform: "translate(65, 0)", d: "M576 1408q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm-384-512h384v-256h-158q-14 2-22 9l-195 195q-7 12-9 22v30zm1280 512q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm128-672v-192q0-14-9-23t-23-9h-224v-224q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v224h-224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h224v224q0 14 9 23t23 9h192q14 0 23-9t9-23v-224h224q14 0 23-9t9-23zm256-544v1152q0 26-19 45t-45 19h-192q0 106-75 181t-181 75-181-75-75-181h-384q0 106-75 181t-181 75-181-75-75-181h-128q-26 0-45-19t-19-45 19-45 45-19v-416q0-26 13-58t32-51l198-198q19-19 51-32t58-13h160v-320q0-26 19-45t45-19h1152q26 0 45 19t19 45z" })
	  );
	}
	
	function icon_time() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-time", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-time-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-time-title" },
	      "Time"
	    ),
	    _react2.default.createElement("path", { d: "M1024 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function icon_other() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-other", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-other-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-other-title" },
	      "Other"
	    ),
	    _react2.default.createElement("path", { d: "M576 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zm512 0v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zm512 0v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68z" })
	  );
	}
	
	// File types
	function icon_file() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-file", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-file-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-file-title" },
	      "File"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280z" })
	  );
	}
	
	function icon_image() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-image", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-image-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-image-title" },
	      "Image"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-128-448v320h-1024v-192l192-192 128 128 384-384zm-832-192q-80 0-136-56t-56-136 56-136 136-56 136 56 56 136-56 136-136 56z" })
	  );
	}
	
	function icon_pdf() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-pdf", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-pdf-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-pdf-title" },
	      "PDF"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-514-593q33 26 84 56 59-7 117-7 147 0 177 49 16 22 2 52 0 1-1 2l-2 2v1q-6 38-71 38-48 0-115-20t-130-53q-221 24-392 83-153 262-242 262-15 0-28-7l-24-12q-1-1-6-5-10-10-6-36 9-40 56-91.5t132-96.5q14-9 23 6 2 2 2 4 52-85 107-197 68-136 104-262-24-82-30.5-159.5t6.5-127.5q11-40 42-40h22q23 0 35 15 18 21 9 68-2 6-4 8 1 3 1 8v30q-2 123-14 192 55 164 146 238zm-576 411q52-24 137-158-51 40-87.5 84t-49.5 74zm398-920q-15 42-2 132 1-7 7-44 0-3 7-43 1-4 4-8-1-1-1-2-1-2-1-3-1-22-13-36 0 1-1 2v2zm-124 661q135-54 284-81-2-1-13-9.5t-16-13.5q-76-67-127-176-27 86-83 197-30 56-45 83zm646-16q-24-24-140-24 76 28 124 28 14 0 18-1 0-1-2-3z" })
	  );
	}
	
	function icon_text() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-text", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-text-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-text-title" },
	      "Text"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-1024-864q0-14 9-23t23-9h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64zm736 224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704zm0 256q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704z" })
	  );
	}
	
	function icon_spreadsheet() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-spreadsheet", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-spreadsheet-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-spreadsheet-title" },
	      "Spreadsheet"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-979-234v106h281v-106h-75l103-161q5-7 10-16.5t7.5-13.5 3.5-4h2q1 4 5 10 2 4 4.5 7.5t6 8 6.5 8.5l107 161h-76v106h291v-106h-68l-192-273 195-282h67v-107h-279v107h74l-103 159q-4 7-10 16.5t-9 13.5l-2 3h-2q-1-4-5-10-6-11-17-23l-106-159h76v-107h-290v107h68l189 272-194 283h-68z" })
	  );
	}
	
	function icon_video() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-video", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-video-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-video-title" },
	      "Video"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-640-896q52 0 90 38t38 90v384q0 52-38 90t-90 38h-384q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h384zm492 2q20 8 20 30v576q0 22-20 30-8 2-12 2-14 0-23-9l-265-266v-90l265-266q9-9 23-9 4 0 12 2z" })
	  );
	}
	
	function icon_audio() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-audio", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-audio-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-audio-title" },
	      "Audio"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-788-814q20 8 20 30v544q0 22-20 30-8 2-12 2-12 0-23-9l-166-167h-131q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h131l166-167q16-15 35-7zm417 689q31 0 50-24 129-159 129-363t-129-363q-16-21-43-24t-47 14q-21 17-23.5 43.5t14.5 47.5q100 123 100 282t-100 282q-17 21-14.5 47.5t23.5 42.5q18 15 40 15zm-211-148q27 0 47-20 87-93 87-219t-87-219q-18-19-45-20t-46 17-20 44.5 18 46.5q52 57 52 131t-52 131q-19 20-18 46.5t20 44.5q20 17 44 17z" })
	  );
	}
	
	function icon_zip() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-zip", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-zip-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-zip-title" },
	      "Zip"
	    ),
	    _react2.default.createElement("path", { d: "M768 384v-128h-128v128h128zm128 128v-128h-128v128h128zm-128 128v-128h-128v128h128zm128 128v-128h-128v128h128zm700-388q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-128v128h-128v-128h-512v1536h1280zm-627-721l107 349q8 27 8 52 0 83-72.5 137.5t-183.5 54.5-183.5-54.5-72.5-137.5q0-25 8-52 21-63 120-396v-128h128v128h79q22 0 39 13t23 34zm-141 465q53 0 90.5-19t37.5-45-37.5-45-90.5-19-90.5 19-37.5 45 37.5 45 90.5 19z" })
	  );
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1660)();
	}


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1042)();
	}


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.instructorProctorTypeSid = exports.getSmarterElementsInstance = exports.coreApi = exports.sidApi = exports.api = exports.config = undefined;
	exports.setToken = setToken;
	
	var _axios = __webpack_require__(211);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Using global SmarterElements from CDN script instead of import
	var SmarterElementsInstance = null;
	
	var config = exports.config = {
	  //apiUrl: 'http://localhost:8011/v1',
	  apiUrl: 'https://api.dev.smarterproctoring.com/v1',
	  // sidUrl: 'http://localhost:8012/v1',
	  sidUrl: 'https://api-stage.smarterid.com/v1',
	  // coreApiUrl: 'http://localhost:8010/v1',
	  coreApiUrl: 'https://api.dev.smarterservices.com/v1',
	  domain: 'http://localhost:3000',
	  ltiUrl: 'https://signon-stage.smarterservices.com',
	  supportScriptUrl: 'https://help.dev.smarterservices.com/embed/in-app-widget.js',
	  classCalcApiKey: 'sqlKeyMsCJsqCUPny8jIm27ZeJrPSrU_',
	  mapsApiKey: 'AIzaSyBXUGDThYYVJOIcfKhKiUCbkQJz8LDVvXg',
	  stripeApiKey: 'pk_test_KFciYfyySlhwTkFPpDmJEDYi',
	  rbRedirect: 'http://localhost:3000/#/rb-complete',
	  agreementUISrc: 'https://s3.amazonaws.com/smarterservices-static-staging/agreements-ui/js/agreements.min.js',
	  instructorProctorTypeSid: 'TSc93c23e553ba4e2f9758e3f0649b667b',
	  automatedProctorTypeSids: ['TS5f74ea3587a04a79b1a8e0697673f942', 'TSe466bdd1eef94acaaa50e0df7cccceb3', 'TS63dda27a6ba54c218449b934b7bb1ba8', 'TS9531c6b112f145018dae3cd2a9f60c4c', 'TS0f0c14b6fb734ff199afa93af8054ee2', 'TS6d6011935f4646848ea4f7a29b4f61a5', 'TS4b894875d26194988853e490dfb9bc41', 'TSc93c23e553ba4e2f9758e3f0653ba4e2'],
	  defaultAutomatedPreset: 'MP5cf5b6711f784d5e810cf529cf21096f',
	  playbackUrl: 'https://playback.dev.smarterproctoring.com',
	  ldApiKey: '59edfdfd082f980b153ac148',
	  logRocket: 'bkdp5p/smarterproctoring-stage',
	  docsDomain: 'https://smarterproctoring.zendesk.com/hc/en-us/',
	  gaCourse: 'UA-42156997-4',
	  gaAdmin: 'UA-42156997-2',
	  extensionId: 'njmamkocphdenkffaliamlfabafhmpjl',
	  extensionUrl: 'https://chrome.google.com/webstore/detail/smarterproctoring/jojmghhfemggnfdmnpihldicgpjhigja',
	  extensionManifestUrl: 'https://smarterproctoring-extension.s3.amazonaws.com/test/config/manifest.json',
	  sessionEndRedirectUrl: 'http://localhost:3000/#/automated/end-session',
	  averageBrightnessMin: 0,
	  desktopAppInfo: {
	    widows: {
	      downloadName: "SmarterServicesUtility_Setup.exe",
	      url: 'http://localhost:5000/SmarterServicesUtility_latest_Setup.exe'
	    },
	    mac: {
	      downloadName: "SmarterServicesUtility_Setup.dmg",
	      url: 'http://localhost:5000/SmarterServicesUtility_latest_Setup.dmg'
	    }
	  },
	  // URL of the webserver running inside the
	  // desktop utility app - doesnt change across environments
	  desktopAppBaseUrl: 'http://localhost:58729',
	  // TEMP: Hard-code DMV installSids so we can
	  // get the right agreement packages for them.
	  dmvInstallSids: ['AI57d06cf3a5c44181ab5f141bf46e7ac4', 'AIbde9a05b551d4e169a98d40bc1e59064']
	};
	
	// Flag local development so we can disable Atatus locally
	if (false) {
	  sessionStorage.setItem('local', true);
	}
	
	if (true) {
	  config.apiUrl =  true ? 'https://api.smarterproctoring.com/v1' : 'https://api-b.smarterproctoring.com/v1';
	  config.sidUrl = 'https://api.smarterid.com/v1';
	  config.domain = 'https://app.smarterproctoring.com';
	  config.ltiUrl = 'https://signon.smarterservices.com';
	  config.coreApiUrl = 'https://api.smarterservices.com/v1';
	  config.supportScriptUrl = 'https://help.smarterservices.com/embed/in-app-widget.js';
	  config.rbRedirect =  true ? 'https://app.smarterproctoring.com/#/rb-complete' : 'https://app-b.smarterproctoring.com/#/rb-complete';
	  config.agreementUISrc = 'https://s3.amazonaws.com/cdn.smarterservices.com/agreements/js/agreements.min.js';
	  config.instructorProctorTypeSid = 'TSc93c23e553ba4e2f9758e3f0649b667b';
	  config.automatedProctorTypeSids = ['TS63dda27a6ba54c218449b934b7bb1ba8', 'TS9531c6b112f145018dae3cd2a9f60c4c', 'TS6d6011935f4646848ea4f7a29b4f61a5', 'TS4b894875d26194988853e490dfb9bc41'];
	  config.defaultAutomatedPreset = 'MPc14acb87c9284cf1bc6572979f77fad2';
	  config.playbackUrl =  true ? 'https://playback.smarterproctoring.com' : 'https://playback-b.smarterproctoring.com';
	  config.stripeApiKey = 'pk_live_A0FO1fJ61RdG68kSIPf9eNlG';
	  config.ldApiKey = '55b25a2f133767270f000092';
	  config.logRocket = 'bkdp5p/smarterproctoring-production';
	  config.sessionEndRedirectUrl =  true ? 'https://app.smarterproctoring.com/#/automated/end-session' : 'https://app-b.smarterproctoring.com/#/automated/end-session';
	  config.desktopAppInfo = {
	    widows: {
	      downloadName: "SmarterServicesUtility_Setup.exe",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases/windows/latest/SmarterServicesUtility_latest_Setup.exe'
	    },
	    mac: {
	      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
	    }
	  };
	}
	
	if (false) {
	  config.apiUrl = 'http://localhost:8011/v1';
	  config.coreApiUrl = 'http://localhost:8010/v1';
	  config.sidUrl = 'https://api-stage.smarterid.com/v1';
	  config.domain = 'http://localhost:3000';
	  config.rbRedirect = 'http://localhost:3000/#/rb-complete';
	  config.sessionEndRedirectUrl = 'http://localhost:3000/#/automated/end-session';
	}
	
	if (false) {
	  config.apiUrl = 'https://api.dev.smarterproctoring.com/v1';
	  config.coreApiUrl = 'https://api.dev.smarterservices.com/v1';
	  config.sidUrl = 'https://api-stage.smarterid.com/v1';
	  config.domain = 'https://app.dev.smarterproctoring.com';
	  config.rbRedirect = 'https://app.dev.smarterproctoring.com/#/rb-complete';
	  config.sessionEndRedirectUrl = 'https://app.dev.smarterproctoring.com/#/automated/end-session';
	  config.desktopAppInfo = {
	    widows: {
	      downloadName: "SmarterServicesUtility_Setup.exe",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/windows/latest/SmarterServicesUtility_latest_Setup.exe'
	    },
	    mac: {
	      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
	    }
	  };
	}
	
	if (false) {
	  config.apiUrl = 'https://api.sub.smarterproctoring.com/v1';
	  config.sidUrl = 'https://api-stage.smarterid.com/v1';
	  config.domain = 'https://app.sub.smarterproctoring.com';
	  config.rbRedirect = 'https://app.sub.smarterproctoring.com/#/rb-complete';
	  config.sessionEndRedirectUrl = 'https://app.sub.smarterproctoring.com/#/automated/end-session';
	  config.desktopAppInfo = {
	    widows: {
	      downloadName: "SmarterServicesUtility_Setup.exe",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/windows/latest/SmarterServicesUtility_latest_Setup.exe'
	    },
	    mac: {
	      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
	    }
	  };
	}
	
	if (false) {
	  config.apiUrl = 'https://api.stage.smarterproctoring.com/v1';
	  config.coreApiUrl = 'https://api.dev.smarterservices.com/v1';
	  config.sidUrl = 'https://api.stage.smarterid.com/v1';
	  config.domain = 'https://app.stage.smarterproctoring.com';
	  config.rbRedirect = 'https://app.stage.smarterproctoring.com/#/rb-complete';
	  config.playbackUrl = 'https://playback.stage.smarterproctoring.com';
	  config.sessionEndRedirectUrl = 'https://app.stage.smarterproctoring.com/#/automated/end-session';
	  config.desktopAppInfo = {
	    widows: {
	      downloadName: "SmarterServicesUtility_Setup.exe",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/windows/latest/SmarterServicesUtility_latest_Setup.exe'
	    },
	    mac: {
	      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
	    }
	  };
	}
	
	if (false) {
	  config.apiUrl = 'https://api-qa.smarterproctoring.com/v1';
	  config.sidUrl = 'https://api.smarterid.com/v1';
	  config.domain = 'https://app-qa.smarterproctoring.com/';
	  config.ltiUrl = 'https://signon.smarterservices.com';
	  config.rbRedirect = 'https://app-qa.smarterproctoring.com/#/rb-complete';
	  config.agreementUISrc = 'https://s3.amazonaws.com/cdn.smarterservices.com/agreements/js/agreements.min.js';
	  config.ldApiKey = '55b25a2f133767270f000092';
	  config.instructorProctorTypeSid = 'TSc93c23e553ba4e2f9758e3f0649b667b';
	  config.automatedProctorTypeSids = ['TS63dda27a6ba54c218449b934b7bb1ba8', 'TS9531c6b112f145018dae3cd2a9f60c4c', 'TS6d6011935f4646848ea4f7a29b4f61a5'];
	  config.defaultAutomatedPreset = 'MPc14acb87c9284cf1bc6572979f77fad2';
	  config.playbackUrl = 'https://playback-qa.smarterproctoring.com';
	  config.sessionEndRedirectUrl = 'https://app-qa.smarterproctoring.com/#/automated/end-session';
	  config.desktopAppInfo = {
	    widows: {
	      downloadName: "SmarterServicesUtility_Setup.exe",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/windows/latest/SmarterServicesUtility_latest_Setup.exe'
	    },
	    mac: {
	      downloadName: "SmarterServicesUtility_latest_Setup.dmg",
	      url: 'https://smarterproctoring-utility-app-builds.s3.amazonaws.com/releases-stage/mac/latest/SmarterServicesUtility_latest_Setup.dmg'
	    }
	  };
	}
	
	var api = exports.api = _axios2.default.create({
	  baseURL: config.apiUrl
	});
	
	var sidApi = exports.sidApi = _axios2.default.create({
	  baseURL: config.sidUrl
	});
	
	var coreApi = exports.coreApi = _axios2.default.create({
	  baseURL: config.coreApiUrl
	});
	
	// Initial sessionTimeout check (set to 120 so that it checks on load)
	var sessionTimeout = 120;
	var timeoutHandler = null;
	
	// Make sure the timer doesn’t get created multiple times
	var timerSet = false;
	
	function setToken(token, skipTtl) {
	  exports.api = api = _axios2.default.create({
	    baseURL: config.apiUrl,
	    headers: { token: token }
	  });
	
	  exports.sidApi = sidApi = _axios2.default.create({
	    baseURL: config.sidUrl,
	    headers: { token: token }
	  });
	
	  exports.coreApi = coreApi = _axios2.default.create({
	    baseURL: config.coreApiUrl,
	    headers: { token: token }
	  });
	
	  if (!skipTtl) {
	    api.interceptors.response.use(function (config) {
	      if (!timerSet) {
	        // Create a new timer for session timeout
	        createNewTimer(sessionTimeout / 1000, token);
	      }
	
	      return config;
	    });
	  }
	}
	
	// Create new session timeout timer
	function createNewTimer(timeInSecond, token) {
	  timerSet = true;
	
	  setTimeout(function () {
	    // Check how much time is left
	    checkTtl(token).then(function (res) {
	      if (res <= 120 && res > 10) {
	        // If 2 minutes or less remain, show the warning
	        _SessionStore2.default.showExpireWarning();
	
	        // Also start a new timer to expire the session if the user doesn’t extend
	        timeoutHandler = createNewTimer(res + 120, token);
	      } else if (res <= 10) {
	        // If the session times out, expire it
	        _SessionStore2.default.expireSession();
	      } else {
	        // Otherwise, create a new timer with the ttl response
	        clearTimeout(timeoutHandler);
	        _SessionStore2.default.removeExpireWarning();
	        timeoutHandler = createNewTimer(res, token);
	      }
	    }).catch(function (error) {
	      console.log(error);
	    });
	  }, (timeInSecond - 120) * 1000);
	}
	
	// Check how much time is left
	function checkTtl(token) {
	  return new Promise(function (resolve, reject) {
	    var headers = {
	      token: token
	    };
	
	    // axios.get(`./json/ttl.json`)
	    //  .then(response => {
	    //    return resolve(response.data.ttl)
	    //  })
	    //  .catch(error => {
	    //    return resolve(-2)
	    //  });
	
	    api.get('/ttl', { headers: headers }).then(function (response) {
	      return resolve(response.data.ttl);
	    }).catch(function (error) {
	      return resolve(-2);
	    });
	  });
	}
	
	var getSmarterElementsInstance = exports.getSmarterElementsInstance = function getSmarterElementsInstance() {
	  if (!SmarterElementsInstance) {
	    // set the environment based on where we are running. Switch through them
	    var environment = 'local';
	    switch (("production")) {
	      case 'local':
	        environment = 'local';
	        break;
	      case 'dev':
	        environment = 'development';
	        break;
	      case 'stage':
	        environment = 'stage';
	        break;
	      case 'sub':
	        environment = 'subenvironment';
	        break;
	      case 'production':
	        environment = 'production';
	        break;
	      default:
	        environment = 'local';
	        break;
	    }
	
	    // Use the global SmarterElements variable from the CDN script
	    if (window && window.SmarterElements) {
	      try {
	        SmarterElementsInstance = new window.SmarterElements({
	          environment: environment
	        });
	      } catch (e) {
	        console.error(e);
	      }
	    } else {
	      console.error('SmarterElements not found. Make sure the CDN script is loaded properly.');
	    }
	  }
	  return SmarterElementsInstance;
	};
	
	var instructorProctorTypeSid = exports.instructorProctorTypeSid = 'TSc93c23e553ba4e2f9758e3f0649b667b';

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.LEGEND_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = undefined;
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isString2 = __webpack_require__(681);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isObject2 = __webpack_require__(77);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(27);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DataUtils = __webpack_require__(16);
	
	var _PureRender = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRESENTATION_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = {
	  alignmentBaseline: _propTypes2.default.string,
	  angle: _propTypes2.default.number,
	  baselineShift: _propTypes2.default.string,
	  clip: _propTypes2.default.string,
	  clipPath: _propTypes2.default.string,
	  clipRule: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  colorInterpolation: _propTypes2.default.string,
	  colorInterpolationFilters: _propTypes2.default.string,
	  colorProfile: _propTypes2.default.string,
	  colorRendering: _propTypes2.default.string,
	  cursor: _propTypes2.default.string,
	  direction: _propTypes2.default.oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes2.default.string,
	  dominantBaseline: _propTypes2.default.string,
	  enableBackground: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  fillOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  fillRule: _propTypes2.default.oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes2.default.string,
	  floodColor: _propTypes2.default.string,
	  floodOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  font: _propTypes2.default.string,
	  fontFamily: _propTypes2.default.string,
	  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontSizeAdjust: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontStretch: _propTypes2.default.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes2.default.oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes2.default.oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes2.default.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes2.default.string,
	  glyphOrientationVertical: _propTypes2.default.string,
	  imageRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  letterSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  lightingColor: _propTypes2.default.string,
	  markerEnd: _propTypes2.default.string,
	  markerMid: _propTypes2.default.string,
	  markerStart: _propTypes2.default.string,
	  mask: _propTypes2.default.string,
	  opacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  overflow: _propTypes2.default.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes2.default.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes2.default.string,
	  stopOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  stroke: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeDasharray: _propTypes2.default.string,
	  strokeDashoffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeLinecap: _propTypes2.default.oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes2.default.oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes2.default.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes2.default.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes2.default.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  writingMode: _propTypes2.default.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  dx: _propTypes2.default.number,
	  dy: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  r: _propTypes2.default.number
	};
	
	var EVENT_ATTRIBUTES = exports.EVENT_ATTRIBUTES = {
	  onClick: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  onMouseMove: _propTypes2.default.func,
	  onMouseOut: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func
	};
	
	var LEGEND_TYPES = exports.LEGEND_TYPES = ['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	var getDisplayName = exports.getDisplayName = function getDisplayName(Comp) {
	  if (!Comp) {
	    return '';
	  }
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	var findAllByType = exports.findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	var findChildByType = exports.findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	
	  return result && result[0];
	};
	
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	var withoutType = exports.withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types = void 0;
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	var getPresentationAttributes = exports.getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	  return out;
	};
	
	/**
	 * get all the event attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	var filterEventAttributes = exports.filterEventAttributes = function filterEventAttributes(el) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	  return out;
	};
	
	var getEventHandler = function getEventHandler(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	
	    return null;
	  };
	};
	
	var filterEventsOfChild = exports.filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction3.default)(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandler(props[i], data, index);
	    }
	  }
	  return out;
	};
	
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	var validateWidthHeight = exports.validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	var isSsr = exports.isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	var filterSvgElements = exports.filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react2.default.Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString3.default)(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	
	var isSingleChildEqual = exports.isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil3.default)(nextChild) && (0, _isNil3.default)(prevChild)) {
	    return true;
	  } else if (!(0, _isNil3.default)(nextChild) && !(0, _isNil3.default)(prevChild)) {
	    return (0, _PureRender.shallowEqual)(nextChild.props, prevChild.props);
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	var isChildrenEqual = exports.isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	  if (count === 1) {
	    return isSingleChildEqual(nextChildren, prevChildren);
	  }
	
	  for (var i = 0; i < count; i++) {
	    var nextChild = nextChildren[i];
	    var prevChild = prevChildren[i];
	
	    if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function shouldComponentUpdate(props, state) {
	  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
	}
	
	function pureRenderDecorator(component) {
	  // eslint-disable-next-line no-param-reassign
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}

/***/ },
/* 13 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
	 *
	 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
	 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
	 */
	var BaseAtom = /** @class */ (function () {
	    /**
	     * Create a new atom. For debugging purposes it is recommended to give it a name.
	     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	     */
	    function BaseAtom(name) {
	        if (name === void 0) { name = "Atom@" + getNextId(); }
	        this.name = name;
	        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.NOT_TRACKING;
	    }
	    BaseAtom.prototype.onBecomeUnobserved = function () {
	        // noop
	    };
	    /**
	     * Invoke this method to notify mobx that your atom has been used somehow.
	     */
	    BaseAtom.prototype.reportObserved = function () {
	        reportObserved(this);
	    };
	    /**
	     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
	     */
	    BaseAtom.prototype.reportChanged = function () {
	        startBatch();
	        propagateChanged(this);
	        endBatch();
	    };
	    BaseAtom.prototype.toString = function () {
	        return this.name;
	    };
	    return BaseAtom;
	}());
	var Atom = /** @class */ (function (_super) {
	    __extends(Atom, _super);
	    /**
	     * Create a new atom. For debugging purposes it is recommended to give it a name.
	     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	     */
	    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
	        if (name === void 0) { name = "Atom@" + getNextId(); }
	        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
	        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
	        var _this = _super.call(this, name) || this;
	        _this.name = name;
	        _this.onBecomeObservedHandler = onBecomeObservedHandler;
	        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
	        _this.isPendingUnobservation = false; // for effective unobserving.
	        _this.isBeingTracked = false;
	        return _this;
	    }
	    Atom.prototype.reportObserved = function () {
	        startBatch();
	        _super.prototype.reportObserved.call(this);
	        if (!this.isBeingTracked) {
	            this.isBeingTracked = true;
	            this.onBecomeObservedHandler();
	        }
	        endBatch();
	        return !!globalState.trackingDerivation;
	        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
	        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
	    };
	    Atom.prototype.onBecomeUnobserved = function () {
	        this.isBeingTracked = false;
	        this.onBecomeUnobservedHandler();
	    };
	    return Atom;
	}(BaseAtom));
	var isAtom = createInstanceofPredicate("Atom", BaseAtom);
	
	function hasInterceptors(interceptable) {
	    return interceptable.interceptors && interceptable.interceptors.length > 0;
	}
	function registerInterceptor(interceptable, handler) {
	    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
	    interceptors.push(handler);
	    return once(function () {
	        var idx = interceptors.indexOf(handler);
	        if (idx !== -1)
	            interceptors.splice(idx, 1);
	    });
	}
	function interceptChange(interceptable, change) {
	    var prevU = untrackedStart();
	    try {
	        var interceptors = interceptable.interceptors;
	        if (interceptors)
	            for (var i = 0, l = interceptors.length; i < l; i++) {
	                change = interceptors[i](change);
	                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
	                if (!change)
	                    break;
	            }
	        return change;
	    }
	    finally {
	        untrackedEnd(prevU);
	    }
	}
	
	function hasListeners(listenable) {
	    return listenable.changeListeners && listenable.changeListeners.length > 0;
	}
	function registerListener(listenable, handler) {
	    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
	    listeners.push(handler);
	    return once(function () {
	        var idx = listeners.indexOf(handler);
	        if (idx !== -1)
	            listeners.splice(idx, 1);
	    });
	}
	function notifyListeners(listenable, change) {
	    var prevU = untrackedStart();
	    var listeners = listenable.changeListeners;
	    if (!listeners)
	        return;
	    listeners = listeners.slice();
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](change);
	    }
	    untrackedEnd(prevU);
	}
	
	function isSpyEnabled() {
	    return !!globalState.spyListeners.length;
	}
	function spyReport(event) {
	    if (!globalState.spyListeners.length)
	        return;
	    var listeners = globalState.spyListeners;
	    for (var i = 0, l = listeners.length; i < l; i++)
	        listeners[i](event);
	}
	function spyReportStart(event) {
	    var change = objectAssign({}, event, { spyReportStart: true });
	    spyReport(change);
	}
	var END_EVENT = { spyReportEnd: true };
	function spyReportEnd(change) {
	    if (change)
	        spyReport(objectAssign({}, change, END_EVENT));
	    else
	        spyReport(END_EVENT);
	}
	function spy(listener) {
	    globalState.spyListeners.push(listener);
	    return once(function () {
	        var idx = globalState.spyListeners.indexOf(listener);
	        if (idx !== -1)
	            globalState.spyListeners.splice(idx, 1);
	    });
	}
	
	function iteratorSymbol() {
	    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
	}
	var IS_ITERATING_MARKER = "__$$iterating";
	function arrayAsIterator(array) {
	    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
	    // yet it is quite convenient to be able to use the response both as array directly and as iterator
	    // it is suboptimal, but alas...
	    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
	    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
	    var idx = -1;
	    addHiddenFinalProp(array, "next", function next() {
	        idx++;
	        return {
	            done: idx >= this.length,
	            value: idx < this.length ? this[idx] : undefined
	        };
	    });
	    return array;
	}
	function declareIterator(prototType, iteratorFactory) {
	    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
	}
	
	var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
	// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
	var safariPrototypeSetterInheritanceBug = (function () {
	    var v = false;
	    var p = {};
	    Object.defineProperty(p, "0", {
	        set: function () {
	            v = true;
	        }
	    });
	    Object.create(p)["0"] = 1;
	    return v === false;
	})();
	/**
	 * This array buffer contains two lists of properties, so that all arrays
	 * can recycle their property definitions, which significantly improves performance of creating
	 * properties on the fly.
	 */
	var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
	// Typescript workaround to make sure ObservableArray extends Array
	var StubArray = /** @class */ (function () {
	    function StubArray() {
	    }
	    return StubArray;
	}());
	function inherit(ctor, proto) {
	    if (typeof Object["setPrototypeOf"] !== "undefined") {
	        Object["setPrototypeOf"](ctor.prototype, proto);
	    }
	    else if (typeof ctor.prototype.__proto__ !== "undefined") {
	        ctor.prototype.__proto__ = proto;
	    }
	    else {
	        ctor["prototype"] = proto;
	    }
	}
	inherit(StubArray, Array.prototype);
	// Weex freeze Array.prototype
	// Make them writeable and configurable in prototype chain
	// https://github.com/alibaba/weex/pull/1529
	if (Object.isFrozen(Array)) {
	    
	    [
	        "constructor",
	        "push",
	        "shift",
	        "concat",
	        "pop",
	        "unshift",
	        "replace",
	        "find",
	        "findIndex",
	        "splice",
	        "reverse",
	        "sort"
	    ].forEach(function (key) {
	        Object.defineProperty(StubArray.prototype, key, {
	            configurable: true,
	            writable: true,
	            value: Array.prototype[key]
	        });
	    });
	}
	var ObservableArrayAdministration = /** @class */ (function () {
	    function ObservableArrayAdministration(name, enhancer, array, owned) {
	        this.array = array;
	        this.owned = owned;
	        this.values = [];
	        this.lastKnownLength = 0;
	        this.interceptors = null;
	        this.changeListeners = null;
	        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
	    }
	    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
	        if (this.dehancer !== undefined)
	            return values.map(this.dehancer);
	        return values;
	    };
	    ObservableArrayAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        if (fireImmediately) {
	            listener({
	                object: this.array,
	                type: "splice",
	                index: 0,
	                added: this.values.slice(),
	                addedCount: this.values.length,
	                removed: [],
	                removedCount: 0
	            });
	        }
	        return registerListener(this, listener);
	    };
	    ObservableArrayAdministration.prototype.getArrayLength = function () {
	        this.atom.reportObserved();
	        return this.values.length;
	    };
	    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
	        if (typeof newLength !== "number" || newLength < 0)
	            throw new Error("[mobx.array] Out of range: " + newLength);
	        var currentLength = this.values.length;
	        if (newLength === currentLength)
	            return;
	        else if (newLength > currentLength) {
	            var newItems = new Array(newLength - currentLength);
	            for (var i = 0; i < newLength - currentLength; i++)
	                newItems[i] = undefined; // No Array.fill everywhere...
	            this.spliceWithArray(currentLength, 0, newItems);
	        }
	        else
	            this.spliceWithArray(newLength, currentLength - newLength);
	    };
	    // adds / removes the necessary numeric properties to this object
	    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
	        if (oldLength !== this.lastKnownLength)
	            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
	        this.lastKnownLength += delta;
	        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
	            reserveArrayBuffer(oldLength + delta + 1);
	    };
	    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this.atom);
	        var length = this.values.length;
	        if (index === undefined)
	            index = 0;
	        else if (index > length)
	            index = length;
	        else if (index < 0)
	            index = Math.max(0, length + index);
	        if (arguments.length === 1)
	            deleteCount = length - index;
	        else if (deleteCount === undefined || deleteCount === null)
	            deleteCount = 0;
	        else
	            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
	        if (newItems === undefined)
	            newItems = [];
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removedCount: deleteCount,
	                added: newItems
	            });
	            if (!change)
	                return EMPTY_ARRAY;
	            deleteCount = change.removedCount;
	            newItems = change.added;
	        }
	        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
	        var lengthDelta = newItems.length - deleteCount;
	        this.updateArrayLength(length, lengthDelta); // create or remove new entries
	        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
	        if (deleteCount !== 0 || newItems.length !== 0)
	            this.notifyArraySplice(index, newItems, res);
	        return this.dehanceValues(res);
	    };
	    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
	        if (newItems.length < MAX_SPLICE_SIZE) {
	            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
	        }
	        else {
	            var res = this.values.slice(index, index + deleteCount);
	            this.values = this.values
	                .slice(0, index)
	                .concat(newItems, this.values.slice(index + deleteCount));
	            return res;
	        }
	        var _a;
	    };
	    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "update",
	                index: index,
	                newValue: newValue,
	                oldValue: oldValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        this.atom.reportChanged();
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removed: removed,
	                added: added,
	                removedCount: removed.length,
	                addedCount: added.length
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        this.atom.reportChanged();
	        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    return ObservableArrayAdministration;
	}());
	var ObservableArray = /** @class */ (function (_super) {
	    __extends(ObservableArray, _super);
	    function ObservableArray(initialValues, enhancer, name, owned) {
	        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
	        if (owned === void 0) { owned = false; }
	        var _this = _super.call(this) || this;
	        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
	        addHiddenFinalProp(_this, "$mobx", adm);
	        if (initialValues && initialValues.length) {
	            _this.spliceWithArray(0, 0, initialValues);
	        }
	        if (safariPrototypeSetterInheritanceBug) {
	            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
	            // defined on the instance. After that it works fine, even if this property is deleted.
	            Object.defineProperty(adm.array, "0", ENTRY_0);
	        }
	        return _this;
	    }
	    ObservableArray.prototype.intercept = function (handler) {
	        return this.$mobx.intercept(handler);
	    };
	    ObservableArray.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        return this.$mobx.observe(listener, fireImmediately);
	    };
	    ObservableArray.prototype.clear = function () {
	        return this.splice(0);
	    };
	    ObservableArray.prototype.concat = function () {
	        var arrays = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            arrays[_i] = arguments[_i];
	        }
	        this.$mobx.atom.reportObserved();
	        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
	    };
	    ObservableArray.prototype.replace = function (newItems) {
	        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
	    };
	    /**
	     * Converts this array back to a (shallow) javascript structure.
	     * For a deep clone use mobx.toJS
	     */
	    ObservableArray.prototype.toJS = function () {
	        return this.slice();
	    };
	    ObservableArray.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableArray.prototype.peek = function () {
	        this.$mobx.atom.reportObserved();
	        return this.$mobx.dehanceValues(this.$mobx.values);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        var idx = this.findIndex.apply(this, arguments);
	        return idx === -1 ? undefined : this.get(idx);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        var items = this.peek(), l = items.length;
	        for (var i = fromIndex; i < l; i++)
	            if (predicate.call(thisArg, items[i], i, this))
	                return i;
	        return -1;
	    };
	    /*
	     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
	     * since these functions alter the inner structure of the array, the have side effects.
	     * Because the have side effects, they should not be used in computed function,
	     * and for that reason the do not call dependencyState.notifyObserved
	     */
	    ObservableArray.prototype.splice = function (index, deleteCount) {
	        var newItems = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            newItems[_i - 2] = arguments[_i];
	        }
	        switch (arguments.length) {
	            case 0:
	                return [];
	            case 1:
	                return this.$mobx.spliceWithArray(index);
	            case 2:
	                return this.$mobx.spliceWithArray(index, deleteCount);
	        }
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.push = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(adm.values.length, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.pop = function () {
	        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
	    };
	    ObservableArray.prototype.shift = function () {
	        return this.splice(0, 1)[0];
	    };
	    ObservableArray.prototype.unshift = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(0, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.reverse = function () {
	        // reverse by default mutates in place before returning the result
	        // which makes it both a 'derivation' and a 'mutation'.
	        // so we deviate from the default and just make it an dervitation
	        var clone = this.slice();
	        return clone.reverse.apply(clone, arguments);
	    };
	    ObservableArray.prototype.sort = function (compareFn) {
	        // sort by default mutates in place before returning the result
	        // which goes against all good practices. Let's not change the array in place!
	        var clone = this.slice();
	        return clone.sort.apply(clone, arguments);
	    };
	    ObservableArray.prototype.remove = function (value) {
	        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
	        if (idx > -1) {
	            this.splice(idx, 1);
	            return true;
	        }
	        return false;
	    };
	    ObservableArray.prototype.move = function (fromIndex, toIndex) {
	        function checkIndex(index) {
	            if (index < 0) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
	            }
	            var length = this.$mobx.values.length;
	            if (index >= length) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
	            }
	        }
	        checkIndex.call(this, fromIndex);
	        checkIndex.call(this, toIndex);
	        if (fromIndex === toIndex) {
	            return;
	        }
	        var oldItems = this.$mobx.values;
	        var newItems;
	        if (fromIndex < toIndex) {
	            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex + 1));
	        }
	        else {
	            // toIndex < fromIndex
	            newItems = oldItems.slice(0, toIndex).concat([
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
	        }
	        this.replace(newItems);
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.get = function (index) {
	        var impl = this.$mobx;
	        if (impl) {
	            if (index < impl.values.length) {
	                impl.atom.reportObserved();
	                return impl.dehanceValue(impl.values[index]);
	            }
	            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
	                .values
	                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
	        }
	        return undefined;
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.set = function (index, newValue) {
	        var adm = this.$mobx;
	        var values = adm.values;
	        if (index < values.length) {
	            // update at index in range
	            checkIfStateModificationsAreAllowed(adm.atom);
	            var oldValue = values[index];
	            if (hasInterceptors(adm)) {
	                var change = interceptChange(adm, {
	                    type: "update",
	                    object: this,
	                    index: index,
	                    newValue: newValue
	                });
	                if (!change)
	                    return;
	                newValue = change.newValue;
	            }
	            newValue = adm.enhancer(newValue, oldValue);
	            var changed = newValue !== oldValue;
	            if (changed) {
	                values[index] = newValue;
	                adm.notifyArrayChildUpdate(index, newValue, oldValue);
	            }
	        }
	        else if (index === values.length) {
	            // add a new item
	            adm.spliceWithArray(index, 0, [newValue]);
	        }
	        else {
	            // out of bounds
	            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
	        }
	    };
	    return ObservableArray;
	}(StubArray));
	declareIterator(ObservableArray.prototype, function () {
	    return arrayAsIterator(this.slice());
	});
	Object.defineProperty(ObservableArray.prototype, "length", {
	    enumerable: false,
	    configurable: true,
	    get: function () {
	        return this.$mobx.getArrayLength();
	    },
	    set: function (newLength) {
	        this.$mobx.setArrayLength(newLength);
	    }
	});
	[
	    "every",
	    "filter",
	    "forEach",
	    "indexOf",
	    "join",
	    "lastIndexOf",
	    "map",
	    "reduce",
	    "reduceRight",
	    "slice",
	    "some",
	    "toString",
	    "toLocaleString"
	].forEach(function (funcName) {
	    var baseFunc = Array.prototype[funcName];
	    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
	    addHiddenProp(ObservableArray.prototype, funcName, function () {
	        return baseFunc.apply(this.peek(), arguments);
	    });
	});
	/**
	 * We don't want those to show up in `for (const key in ar)` ...
	 */
	makeNonEnumerable(ObservableArray.prototype, [
	    "constructor",
	    "intercept",
	    "observe",
	    "clear",
	    "concat",
	    "get",
	    "replace",
	    "toJS",
	    "toJSON",
	    "peek",
	    "find",
	    "findIndex",
	    "splice",
	    "spliceWithArray",
	    "push",
	    "pop",
	    "set",
	    "shift",
	    "unshift",
	    "reverse",
	    "sort",
	    "remove",
	    "move",
	    "toString",
	    "toLocaleString"
	]);
	// See #364
	var ENTRY_0 = createArrayEntryDescriptor(0);
	function createArrayEntryDescriptor(index) {
	    return {
	        enumerable: false,
	        configurable: false,
	        get: function () {
	            // TODO: Check `this`?, see #752?
	            return this.get(index);
	        },
	        set: function (value) {
	            this.set(index, value);
	        }
	    };
	}
	function createArrayBufferItem(index) {
	    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
	}
	function reserveArrayBuffer(max) {
	    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
	        createArrayBufferItem(index);
	    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
	}
	reserveArrayBuffer(1000);
	var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
	function isObservableArray(thing) {
	    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
	}
	
	var UNCHANGED = {};
	var ObservableValue = /** @class */ (function (_super) {
	    __extends(ObservableValue, _super);
	    function ObservableValue(value, enhancer, name, notifySpy) {
	        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
	        if (notifySpy === void 0) { notifySpy = true; }
	        var _this = _super.call(this, name) || this;
	        _this.enhancer = enhancer;
	        _this.hasUnreportedChange = false;
	        _this.dehancer = undefined;
	        _this.value = enhancer(value, undefined, name);
	        if (notifySpy && isSpyEnabled()) {
	            // only notify spy if this is a stand-alone observable
	            spyReport({ type: "create", object: _this, newValue: _this.value });
	        }
	        return _this;
	    }
	    ObservableValue.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableValue.prototype.set = function (newValue) {
	        var oldValue = this.value;
	        newValue = this.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            if (notifySpy) {
	                spyReportStart({
	                    type: "update",
	                    object: this,
	                    newValue: newValue,
	                    oldValue: oldValue
	                });
	            }
	            this.setNewValue(newValue);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableValue.prototype.prepareNewValue = function (newValue) {
	        checkIfStateModificationsAreAllowed(this);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this,
	                type: "update",
	                newValue: newValue
	            });
	            if (!change)
	                return UNCHANGED;
	            newValue = change.newValue;
	        }
	        // apply modifier
	        newValue = this.enhancer(newValue, this.value, this.name);
	        return this.value !== newValue ? newValue : UNCHANGED;
	    };
	    ObservableValue.prototype.setNewValue = function (newValue) {
	        var oldValue = this.value;
	        this.value = newValue;
	        this.reportChanged();
	        if (hasListeners(this)) {
	            notifyListeners(this, {
	                type: "update",
	                object: this,
	                newValue: newValue,
	                oldValue: oldValue
	            });
	        }
	    };
	    ObservableValue.prototype.get = function () {
	        this.reportObserved();
	        return this.dehanceValue(this.value);
	    };
	    ObservableValue.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableValue.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately)
	            listener({
	                object: this,
	                type: "update",
	                newValue: this.value,
	                oldValue: undefined
	            });
	        return registerListener(this, listener);
	    };
	    ObservableValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ObservableValue.prototype.toString = function () {
	        return this.name + "[" + this.value + "]";
	    };
	    ObservableValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ObservableValue;
	}(BaseAtom));
	ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
	var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
	
	var messages = {
	    m001: "It is not allowed to assign new values to @action fields",
	    m002: "`runInAction` expects a function",
	    m003: "`runInAction` expects a function without arguments",
	    m004: "autorun expects a function",
	    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
	    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
	    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
	    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
	    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
	    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
	    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
	    m012: "computed takes one or two arguments if used as function",
	    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
	    m014: "extendObservable expected 2 or more arguments",
	    m015: "extendObservable expects an object as first argument",
	    m016: "extendObservable should not be used on maps, use map.merge instead",
	    m017: "all arguments of extendObservable should be objects",
	    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
	    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
	    m020: "modifiers can only be used for individual object properties",
	    m021: "observable expects zero or one arguments",
	    m022: "@observable can not be used on getters, use @computed instead",
	    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
	    m025: "whyRun can only be used on reactions and computed values",
	    m026: "`action` can only be invoked on functions",
	    m028: "It is not allowed to set `useStrict` when a derivation is running",
	    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
	    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
	    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
	    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
	    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
	    m033: "`observe` doesn't support the fire immediately property for observable maps.",
	    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
	    m035: "Cannot make the designated object observable; it is not extensible",
	    m036: "It is not possible to get index atoms from arrays",
	    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
	    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
	};
	function getMessage(id) {
	    return messages[id];
	}
	
	function createAction(actionName, fn) {
	    invariant(typeof fn === "function", getMessage("m026"));
	    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
	    var res = function () {
	        return executeAction(actionName, fn, this, arguments);
	    };
	    res.originalFn = fn;
	    res.isMobxAction = true;
	    return res;
	}
	function executeAction(actionName, fn, scope, args) {
	    var runInfo = startAction(actionName, fn, scope, args);
	    try {
	        return fn.apply(scope, args);
	    }
	    finally {
	        endAction(runInfo);
	    }
	}
	function startAction(actionName, fn, scope, args) {
	    var notifySpy = isSpyEnabled() && !!actionName;
	    var startTime = 0;
	    if (notifySpy) {
	        startTime = Date.now();
	        var l = (args && args.length) || 0;
	        var flattendArgs = new Array(l);
	        if (l > 0)
	            for (var i = 0; i < l; i++)
	                flattendArgs[i] = args[i];
	        spyReportStart({
	            type: "action",
	            name: actionName,
	            fn: fn,
	            object: scope,
	            arguments: flattendArgs
	        });
	    }
	    var prevDerivation = untrackedStart();
	    startBatch();
	    var prevAllowStateChanges = allowStateChangesStart(true);
	    return {
	        prevDerivation: prevDerivation,
	        prevAllowStateChanges: prevAllowStateChanges,
	        notifySpy: notifySpy,
	        startTime: startTime
	    };
	}
	function endAction(runInfo) {
	    allowStateChangesEnd(runInfo.prevAllowStateChanges);
	    endBatch();
	    untrackedEnd(runInfo.prevDerivation);
	    if (runInfo.notifySpy)
	        spyReportEnd({ time: Date.now() - runInfo.startTime });
	}
	function useStrict(strict) {
	    invariant(globalState.trackingDerivation === null, getMessage("m028"));
	    globalState.strictMode = strict;
	    globalState.allowStateChanges = !strict;
	}
	function isStrictModeEnabled() {
	    return globalState.strictMode;
	}
	function allowStateChanges(allowStateChanges, func) {
	    // TODO: deprecate / refactor this function in next major
	    // Currently only used by `@observer`
	    // Proposed change: remove first param, rename to `forbidStateChanges`,
	    // require error callback instead of the hardcoded error message now used
	    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
	    var prev = allowStateChangesStart(allowStateChanges);
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        allowStateChangesEnd(prev);
	    }
	    return res;
	}
	function allowStateChangesStart(allowStateChanges) {
	    var prev = globalState.allowStateChanges;
	    globalState.allowStateChanges = allowStateChanges;
	    return prev;
	}
	function allowStateChangesEnd(prev) {
	    globalState.allowStateChanges = prev;
	}
	
	/**
	 * Constructs a decorator, that normalizes the differences between
	 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
	 * values during instance creation to properties that have a getter setter.
	 *
	 * - Sigh -
	 *
	 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
	 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
	 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
	 */
	function createClassPropertyDecorator(
	/**
	 * This function is invoked once, when the property is added to a new instance.
	 * When this happens is not strictly determined due to differences in TS and Babel:
	 * Typescript: Usually when constructing the new instance
	 * Babel, sometimes Typescript: during the first get / set
	 * Both: when calling `runLazyInitializers(instance)`
	 */
	onInitialize, get, set, enumerable, 
	/**
	 * Can this decorator invoked with arguments? e.g. @decorator(args)
	 */
	allowCustomArguments) {
	    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
	        if (argLen === void 0) { argLen = 0; }
	        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
	        if (!descriptor) {
	            // typescript (except for getter / setters)
	            var newDescriptor = {
	                enumerable: enumerable,
	                configurable: true,
	                get: function () {
	                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
	                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
	                    return get.call(this, key);
	                },
	                set: function (v) {
	                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
	                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
	                    }
	                    else {
	                        set.call(this, key, v);
	                    }
	                }
	            };
	            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
	                // Typescript target is ES3, so it won't define property for us
	                // or using Reflect.decorate polyfill, which will return no descriptor
	                // (see https://github.com/mobxjs/mobx/issues/333)
	                Object.defineProperty(target, key, newDescriptor);
	            }
	            return newDescriptor;
	        }
	        else {
	            // babel and typescript getter / setter props
	            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
	                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
	                );
	            }
	            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
	            target.__mobxLazyInitializers.push(function (instance) {
	                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
	            });
	            return {
	                enumerable: enumerable,
	                configurable: true,
	                get: function () {
	                    if (this.__mobxDidRunLazyInitializers !== true)
	                        runLazyInitializers(this);
	                    return get.call(this, key);
	                },
	                set: function (v) {
	                    if (this.__mobxDidRunLazyInitializers !== true)
	                        runLazyInitializers(this);
	                    set.call(this, key, v);
	                }
	            };
	        }
	    }
	    if (allowCustomArguments) {
	        /** If custom arguments are allowed, we should return a function that returns a decorator */
	        return function () {
	            /** Direct invocation: @decorator bla */
	            if (quacksLikeADecorator(arguments))
	                return classPropertyDecorator.apply(null, arguments);
	            /** Indirect invocation: @decorator(args) bla */
	            var outerArgs = arguments;
	            var argLen = arguments.length;
	            return function (target, key, descriptor) {
	                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
	            };
	        };
	    }
	    return classPropertyDecorator;
	}
	function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
	    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
	        addHiddenProp(instance, "__mobxInitializedProps", {});
	    instance.__mobxInitializedProps[key] = true;
	    onInitialize(instance, key, v, customArgs, baseDescriptor);
	}
	function runLazyInitializers(instance) {
	    if (instance.__mobxDidRunLazyInitializers === true)
	        return;
	    if (instance.__mobxLazyInitializers) {
	        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
	        instance.__mobxDidRunLazyInitializers &&
	            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
	    }
	}
	function quacksLikeADecorator(args) {
	    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
	}
	
	var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
	    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
	    var wrappedAction = action(actionName, value);
	    addHiddenProp(target, key, wrappedAction);
	}, function (key) {
	    return this[key];
	}, function () {
	    invariant(false, getMessage("m001"));
	}, false, true);
	var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
	    defineBoundAction(target, key, value);
	}, function (key) {
	    return this[key];
	}, function () {
	    invariant(false, getMessage("m001"));
	}, false, false);
	var action = function action(arg1, arg2, arg3, arg4) {
	    if (arguments.length === 1 && typeof arg1 === "function")
	        return createAction(arg1.name || "<unnamed action>", arg1);
	    if (arguments.length === 2 && typeof arg2 === "function")
	        return createAction(arg1, arg2);
	    if (arguments.length === 1 && typeof arg1 === "string")
	        return namedActionDecorator(arg1);
	    return namedActionDecorator(arg2).apply(null, arguments);
	};
	action.bound = function boundAction(arg1, arg2, arg3) {
	    if (typeof arg1 === "function") {
	        var action_1 = createAction("<not yet bound action>", arg1);
	        action_1.autoBind = true;
	        return action_1;
	    }
	    return boundActionDecorator.apply(null, arguments);
	};
	function namedActionDecorator(name) {
	    return function (target, prop, descriptor) {
	        if (descriptor && typeof descriptor.value === "function") {
	            // TypeScript @action method() { }. Defined on proto before being decorated
	            // Don't use the field decorator if we are just decorating a method
	            descriptor.value = createAction(name, descriptor.value);
	            descriptor.enumerable = false;
	            descriptor.configurable = true;
	            return descriptor;
	        }
	        if (descriptor !== undefined && descriptor.get !== undefined) {
	            throw new Error("[mobx] action is not expected to be used with getters");
	        }
	        // bound instance methods
	        return actionFieldDecorator(name).apply(this, arguments);
	    };
	}
	function runInAction(arg1, arg2, arg3) {
	    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
	    var fn = typeof arg1 === "function" ? arg1 : arg2;
	    var scope = typeof arg1 === "function" ? arg2 : arg3;
	    invariant(typeof fn === "function", getMessage("m002"));
	    invariant(fn.length === 0, getMessage("m003"));
	    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
	    return executeAction(actionName, fn, scope, undefined);
	}
	function isAction(thing) {
	    return typeof thing === "function" && thing.isMobxAction === true;
	}
	function defineBoundAction(target, propertyName, fn) {
	    var res = function () {
	        return executeAction(propertyName, fn, target, arguments);
	    };
	    res.isMobxAction = true;
	    addHiddenProp(target, propertyName, res);
	}
	
	var toString = Object.prototype.toString;
	function deepEqual(a, b) {
	    return eq(a, b);
	}
	// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
	// Internal recursive comparison function for `isEqual`.
	function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b)
	        return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null)
	        return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a)
	        return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== "function" && type !== "object" && typeof b != "object")
	        return false;
	    return deepEq(a, b, aStack, bStack);
	}
	// Internal recursive comparison function for `isEqual`.
	function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    a = unwrap(a);
	    b = unwrap(b);
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b))
	        return false;
	    switch (className) {
	        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	        case "[object RegExp]":
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	        case "[object String]":
	            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	            // equivalent to `new String("5")`.
	            return "" + a === "" + b;
	        case "[object Number]":
	            // `NaN`s are equivalent, but non-reflexive.
	            // Object(NaN) is equivalent to NaN.
	            if (+a !== +a)
	                return +b !== +b;
	            // An `egal` comparison is performed for other numeric values.
	            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	        case "[object Date]":
	        case "[object Boolean]":
	            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	            // millisecond representations. Note that invalid dates with millisecond representations
	            // of `NaN` are not equivalent.
	            return +a === +b;
	        case "[object Symbol]":
	            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
	    }
	    var areArrays = className === "[object Array]";
	    if (!areArrays) {
	        if (typeof a != "object" || typeof b != "object")
	            return false;
	        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	        // from different frames are.
	        var aCtor = a.constructor, bCtor = b.constructor;
	        if (aCtor !== bCtor &&
	            !(typeof aCtor === "function" &&
	                aCtor instanceof aCtor &&
	                typeof bCtor === "function" &&
	                bCtor instanceof bCtor) &&
	            ("constructor" in a && "constructor" in b)) {
	            return false;
	        }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	        // Linear search. Performance is inversely proportional to the number of
	        // unique nested structures.
	        if (aStack[length] === a)
	            return bStack[length] === b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	        // Compare array lengths to determine if a deep comparison is necessary.
	        length = a.length;
	        if (length !== b.length)
	            return false;
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (length--) {
	            if (!eq(a[length], b[length], aStack, bStack))
	                return false;
	        }
	    }
	    else {
	        // Deep compare objects.
	        var keys = Object.keys(a), key;
	        length = keys.length;
	        // Ensure that both objects contain the same number of properties before comparing deep equality.
	        if (Object.keys(b).length !== length)
	            return false;
	        while (length--) {
	            // Deep compare each member
	            key = keys[length];
	            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack)))
	                return false;
	        }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	}
	function unwrap(a) {
	    if (isObservableArray(a))
	        return a.peek();
	    if (isObservableMap(a))
	        return a.entries();
	    if (isES6Map(a))
	        return iteratorToArray(a.entries());
	    return a;
	}
	function has(a, key) {
	    return Object.prototype.hasOwnProperty.call(a, key);
	}
	
	function identityComparer(a, b) {
	    return a === b;
	}
	function structuralComparer(a, b) {
	    return deepEqual(a, b);
	}
	function defaultComparer(a, b) {
	    return areBothNaN(a, b) || identityComparer(a, b);
	}
	var comparer = {
	    identity: identityComparer,
	    structural: structuralComparer,
	    default: defaultComparer
	};
	
	function autorun(arg1, arg2, arg3) {
	    var name, view, scope;
	    if (typeof arg1 === "string") {
	        name = arg1;
	        view = arg2;
	        scope = arg3;
	    }
	    else {
	        name = arg1.name || "Autorun@" + getNextId();
	        view = arg1;
	        scope = arg2;
	    }
	    invariant(typeof view === "function", getMessage("m004"));
	    invariant(isAction(view) === false, getMessage("m005"));
	    if (scope)
	        view = view.bind(scope);
	    var reaction = new Reaction(name, function () {
	        this.track(reactionRunner);
	    });
	    function reactionRunner() {
	        view(reaction);
	    }
	    reaction.schedule();
	    return reaction.getDisposer();
	}
	function when(arg1, arg2, arg3, arg4) {
	    var name, predicate, effect, scope;
	    if (typeof arg1 === "string") {
	        name = arg1;
	        predicate = arg2;
	        effect = arg3;
	        scope = arg4;
	    }
	    else {
	        name = "When@" + getNextId();
	        predicate = arg1;
	        effect = arg2;
	        scope = arg3;
	    }
	    var disposer = autorun(name, function (r) {
	        if (predicate.call(scope)) {
	            r.dispose();
	            var prevUntracked = untrackedStart();
	            effect.call(scope);
	            untrackedEnd(prevUntracked);
	        }
	    });
	    return disposer;
	}
	function autorunAsync(arg1, arg2, arg3, arg4) {
	    var name, func, delay, scope;
	    if (typeof arg1 === "string") {
	        name = arg1;
	        func = arg2;
	        delay = arg3;
	        scope = arg4;
	    }
	    else {
	        name = arg1.name || "AutorunAsync@" + getNextId();
	        func = arg1;
	        delay = arg2;
	        scope = arg3;
	    }
	    invariant(isAction(func) === false, getMessage("m006"));
	    if (delay === void 0)
	        delay = 1;
	    if (scope)
	        func = func.bind(scope);
	    var isScheduled = false;
	    var r = new Reaction(name, function () {
	        if (!isScheduled) {
	            isScheduled = true;
	            setTimeout(function () {
	                isScheduled = false;
	                if (!r.isDisposed)
	                    r.track(reactionRunner);
	            }, delay);
	        }
	    });
	    function reactionRunner() {
	        func(r);
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	function reaction(expression, effect, arg3) {
	    if (arguments.length > 3) {
	        fail(getMessage("m007"));
	    }
	    if (isModifierDescriptor(expression)) {
	        fail(getMessage("m008"));
	    }
	    var opts;
	    if (typeof arg3 === "object") {
	        opts = arg3;
	    }
	    else {
	        opts = {};
	    }
	    opts.name =
	        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
	    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
	    opts.delay = opts.delay || 0;
	    opts.compareStructural = opts.compareStructural || opts.struct || false;
	    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
	    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
	    if (opts.context) {
	        expression = expression.bind(opts.context);
	    }
	    var firstTime = true;
	    var isScheduled = false;
	    var value;
	    var equals = opts.equals
	        ? opts.equals
	        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
	    var r = new Reaction(opts.name, function () {
	        if (firstTime || opts.delay < 1) {
	            reactionRunner();
	        }
	        else if (!isScheduled) {
	            isScheduled = true;
	            setTimeout(function () {
	                isScheduled = false;
	                reactionRunner();
	            }, opts.delay);
	        }
	    });
	    function reactionRunner() {
	        if (r.isDisposed)
	            return;
	        var changed = false;
	        r.track(function () {
	            var nextValue = expression(r);
	            changed = firstTime || !equals(value, nextValue);
	            value = nextValue;
	        });
	        if (firstTime && opts.fireImmediately)
	            effect(value, r);
	        if (!firstTime && changed === true)
	            effect(value, r);
	        if (firstTime)
	            firstTime = false;
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	
	/**
	 * A node in the state dependency root that observes other nodes, and can be observed itself.
	 *
	 * ComputedValue will remember the result of the computation for the duration of the batch, or
	 * while being observed.
	 *
	 * During this time it will recompute only when one of its direct dependencies changed,
	 * but only when it is being accessed with `ComputedValue.get()`.
	 *
	 * Implementation description:
	 * 1. First time it's being accessed it will compute and remember result
	 *    give back remembered result until 2. happens
	 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
	 * 3. When it's being accessed, recompute if any shallow dependency changed.
	 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
	 *    go to step 2. either way
	 *
	 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
	 */
	var ComputedValue = /** @class */ (function () {
	    /**
	     * Create a new computed value based on a function expression.
	     *
	     * The `name` property is for debug purposes only.
	     *
	     * The `equals` property specifies the comparer function to use to determine if a newly produced
	     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
	     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
	     * Structural comparison can be convenient if you always produce an new aggregated object and
	     * don't want to notify observers if it is structurally the same.
	     * This is useful for working with vectors, mouse coordinates etc.
	     */
	    function ComputedValue(derivation, scope, equals, name, setter) {
	        this.derivation = derivation;
	        this.scope = scope;
	        this.equals = equals;
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = null; // during tracking it's an array with new observed observers
	        this.isPendingUnobservation = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.runId = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.value = new CaughtException(null);
	        this.isComputing = false; // to check for cycles
	        this.isRunningSetter = false;
	        this.isTracing = TraceMode.NONE;
	        this.name = name || "ComputedValue@" + getNextId();
	        if (setter)
	            this.setter = createAction(name + "-setter", setter);
	    }
	    ComputedValue.prototype.onBecomeStale = function () {
	        propagateMaybeChanged(this);
	    };
	    ComputedValue.prototype.onBecomeUnobserved = function () {
	        clearObserving(this);
	        this.value = undefined;
	    };
	    /**
	     * Returns the current value of this computed value.
	     * Will evaluate its computation first if needed.
	     */
	    ComputedValue.prototype.get = function () {
	        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
	        if (globalState.inBatch === 0) {
	            // This is an minor optimization which could be omitted to simplify the code
	            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
	            // tracking as it will never be called again inside this batch.
	            startBatch();
	            if (shouldCompute(this)) {
	                if (this.isTracing !== TraceMode.NONE) {
	                    console.log("[mobx.trace] '" + this
	                        .name + "' is being read outside a reactive context and doing a full recompute");
	                }
	                this.value = this.computeValue(false);
	            }
	            endBatch();
	        }
	        else {
	            reportObserved(this);
	            if (shouldCompute(this))
	                if (this.trackAndCompute())
	                    propagateChangeConfirmed(this);
	        }
	        var result = this.value;
	        if (isCaughtException(result))
	            throw result.cause;
	        return result;
	    };
	    ComputedValue.prototype.peek = function () {
	        var res = this.computeValue(false);
	        if (isCaughtException(res))
	            throw res.cause;
	        return res;
	    };
	    ComputedValue.prototype.set = function (value) {
	        if (this.setter) {
	            invariant(!this.isRunningSetter, "The setter of computed value '" + this
	                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
	            this.isRunningSetter = true;
	            try {
	                this.setter.call(this.scope, value);
	            }
	            finally {
	                this.isRunningSetter = false;
	            }
	        }
	        else
	            invariant(false, "[ComputedValue '" + this
	                .name + "'] It is not possible to assign a new value to a computed value.");
	    };
	    ComputedValue.prototype.trackAndCompute = function () {
	        if (isSpyEnabled()) {
	            spyReport({
	                object: this.scope,
	                type: "compute",
	                fn: this.derivation
	            });
	        }
	        var oldValue = this.value;
	        var wasSuspended = 
	        /* see #1208 */ this.dependenciesState === exports.IDerivationState.NOT_TRACKING;
	        var newValue = (this.value = this.computeValue(true));
	        return (wasSuspended ||
	            isCaughtException(oldValue) ||
	            isCaughtException(newValue) ||
	            !this.equals(oldValue, newValue));
	    };
	    ComputedValue.prototype.computeValue = function (track) {
	        this.isComputing = true;
	        globalState.computationDepth++;
	        var res;
	        if (track) {
	            res = trackDerivedFunction(this, this.derivation, this.scope);
	        }
	        else {
	            try {
	                res = this.derivation.call(this.scope);
	            }
	            catch (e) {
	                res = new CaughtException(e);
	            }
	        }
	        globalState.computationDepth--;
	        this.isComputing = false;
	        return res;
	    };
	    ComputedValue.prototype.observe = function (listener, fireImmediately) {
	        var _this = this;
	        var firstTime = true;
	        var prevValue = undefined;
	        return autorun(function () {
	            var newValue = _this.get();
	            if (!firstTime || fireImmediately) {
	                var prevU = untrackedStart();
	                listener({
	                    type: "update",
	                    object: _this,
	                    newValue: newValue,
	                    oldValue: prevValue
	                });
	                untrackedEnd(prevU);
	            }
	            firstTime = false;
	            prevValue = newValue;
	        });
	    };
	    ComputedValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ComputedValue.prototype.toString = function () {
	        return this.name + "[" + this.derivation.toString() + "]";
	    };
	    ComputedValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    ComputedValue.prototype.whyRun = function () {
	        var isTracking = Boolean(globalState.trackingDerivation);
	        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
	        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
	        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
	            ? "[active] the value of this computation is needed by a reaction"
	            : this.isComputing
	                ? "[get] The value of this computed was requested outside a reaction"
	                : "[idle] not running at the moment") + "\n" +
	            (this.dependenciesState === exports.IDerivationState.NOT_TRACKING
	                ? getMessage("m032")
	                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
	                    ? " (... or any observable accessed during the remainder of the current run)"
	                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
	    };
	    return ComputedValue;
	}());
	ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
	var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
	
	var ObservableObjectAdministration = /** @class */ (function () {
	    function ObservableObjectAdministration(target, name) {
	        this.target = target;
	        this.name = name;
	        this.values = {};
	        this.changeListeners = null;
	        this.interceptors = null;
	    }
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
	        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
	        return registerListener(this, callback);
	    };
	    ObservableObjectAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableObjectAdministration;
	}());
	function asObservableObject(target, name) {
	    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
	        return target.$mobx;
	    invariant(Object.isExtensible(target), getMessage("m035"));
	    if (!isPlainObject(target))
	        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
	    if (!name)
	        name = "ObservableObject@" + getNextId();
	    var adm = new ObservableObjectAdministration(target, name);
	    addHiddenFinalProp(target, "$mobx", adm);
	    return adm;
	}
	function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
	    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
	        // already observable property
	        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
	        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
	        return;
	    }
	    // not yet observable property
	    if ("value" in descriptor) {
	        // not a computed value
	        if (isModifierDescriptor(descriptor.value)) {
	            // x : ref(someValue)
	            var modifierDescriptor = descriptor.value;
	            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
	        }
	        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
	            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
	        }
	        else if (isComputedValue(descriptor.value)) {
	            // x: computed(someExpr)
	            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
	        }
	        else {
	            // x: someValue
	            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
	        }
	    }
	    else {
	        // get x() { return 3 } set x(v) { }
	        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
	    }
	}
	function defineObservableProperty(adm, propName, newValue, enhancer) {
	    assertPropertyConfigurable(adm.target, propName);
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            object: adm.target,
	            name: propName,
	            type: "add",
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
	    newValue = observable.value; // observableValue might have changed it
	    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
	    notifyPropertyAddition(adm, adm.target, propName, newValue);
	}
	function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
	    if (asInstanceProperty)
	        assertPropertyConfigurable(adm.target, propName);
	    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
	    if (asInstanceProperty) {
	        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
	    }
	}
	function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
	    var name = adm.name + "." + propName;
	    computedValue.name = name;
	    if (!computedValue.scope)
	        computedValue.scope = adm.target;
	    adm.values[propName] = computedValue;
	    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
	}
	var observablePropertyConfigs = {};
	var computedPropertyConfigs = {};
	function generateObservablePropConfig(propName) {
	    return (observablePropertyConfigs[propName] ||
	        (observablePropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return this.$mobx.values[propName].get();
	            },
	            set: function (v) {
	                setPropertyValue(this, propName, v);
	            }
	        }));
	}
	function generateComputedPropConfig(propName) {
	    return (computedPropertyConfigs[propName] ||
	        (computedPropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return this.$mobx.values[propName].get();
	            },
	            set: function (v) {
	                return this.$mobx.values[propName].set(v);
	            }
	        }));
	}
	function setPropertyValue(instance, name, newValue) {
	    var adm = instance.$mobx;
	    var observable = adm.values[name];
	    // intercept
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            type: "update",
	            object: instance,
	            name: name,
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    newValue = observable.prepareNewValue(newValue);
	    // notify spy & observers
	    if (newValue !== UNCHANGED) {
	        var notify = hasListeners(adm);
	        var notifySpy = isSpyEnabled();
	        var change = notify || notifySpy
	            ? {
	                type: "update",
	                object: instance,
	                oldValue: observable.value,
	                name: name,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        observable.setNewValue(newValue);
	        if (notify)
	            notifyListeners(adm, change);
	        if (notifySpy)
	            spyReportEnd();
	    }
	}
	function notifyPropertyAddition(adm, object, name, newValue) {
	    var notify = hasListeners(adm);
	    var notifySpy = isSpyEnabled();
	    var change = notify || notifySpy
	        ? {
	            type: "add",
	            object: object,
	            name: name,
	            newValue: newValue
	        }
	        : null;
	    if (notifySpy)
	        spyReportStart(change);
	    if (notify)
	        notifyListeners(adm, change);
	    if (notifySpy)
	        spyReportEnd();
	}
	var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
	function isObservableObject(thing) {
	    if (isObject(thing)) {
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        runLazyInitializers(thing);
	        return isObservableObjectAdministration(thing.$mobx);
	    }
	    return false;
	}
	
	/**
	 * Returns true if the provided value is reactive.
	 * @param value object, function or array
	 * @param property if property is specified, checks whether value.property is reactive.
	 */
	function isObservable(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableArray(value) || isObservableMap(value))
	            throw new Error(getMessage("m019"));
	        else if (isObservableObject(value)) {
	            var o = value.$mobx;
	            return o.values && !!o.values[property];
	        }
	        return false;
	    }
	    // For first check, see #701
	    return (isObservableObject(value) ||
	        !!value.$mobx ||
	        isAtom(value) ||
	        isReaction(value) ||
	        isComputedValue(value));
	}
	
	function createDecoratorForEnhancer(enhancer) {
	    invariant(!!enhancer, ":(");
	    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
	        assertPropertyConfigurable(target, name);
	        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
	        var adm = asObservableObject(target, undefined);
	        defineObservableProperty(adm, name, baseValue, enhancer);
	    }, function (name) {
	        var observable = this.$mobx.values[name];
	        if (observable === undefined // See #505
	        )
	            return undefined;
	        return observable.get();
	    }, function (name, value) {
	        setPropertyValue(this, name, value);
	    }, true, false);
	}
	
	function extendObservable(target) {
	    var properties = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        properties[_i - 1] = arguments[_i];
	    }
	    return extendObservableHelper(target, deepEnhancer, properties);
	}
	function extendShallowObservable(target) {
	    var properties = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        properties[_i - 1] = arguments[_i];
	    }
	    return extendObservableHelper(target, referenceEnhancer, properties);
	}
	function extendObservableHelper(target, defaultEnhancer, properties) {
	    invariant(arguments.length >= 2, getMessage("m014"));
	    invariant(typeof target === "object", getMessage("m015"));
	    invariant(!isObservableMap(target), getMessage("m016"));
	    properties.forEach(function (propSet) {
	        invariant(typeof propSet === "object", getMessage("m017"));
	        invariant(!isObservable(propSet), getMessage("m018"));
	    });
	    var adm = asObservableObject(target);
	    var definedProps = {};
	    // Note could be optimised if properties.length === 1
	    for (var i = properties.length - 1; i >= 0; i--) {
	        var propSet = properties[i];
	        for (var key in propSet)
	            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
	                definedProps[key] = true;
	                if (target === propSet && !isPropertyConfigurable(target, key))
	                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
	                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
	                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
	            }
	    }
	    return target;
	}
	
	var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
	var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
	var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
	var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
	var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
	/**
	 * Turns an object, array or function into a reactive structure.
	 * @param v the value which should become observable.
	 */
	function createObservable(v) {
	    if (v === void 0) { v = undefined; }
	    // @observable someProp;
	    if (typeof arguments[1] === "string")
	        return deepDecorator.apply(null, arguments);
	    invariant(arguments.length <= 1, getMessage("m021"));
	    invariant(!isModifierDescriptor(v), getMessage("m020"));
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    var res = deepEnhancer(v, undefined, undefined);
	    // this value could be converted to a new observable data structure, return it
	    if (res !== v)
	        return res;
	    // otherwise, just box it
	    return observable.box(v);
	}
	var observableFactories = {
	    box: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("box");
	        return new ObservableValue(value, deepEnhancer, name);
	    },
	    shallowBox: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowBox");
	        return new ObservableValue(value, referenceEnhancer, name);
	    },
	    array: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("array");
	        return new ObservableArray(initialValues, deepEnhancer, name);
	    },
	    shallowArray: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowArray");
	        return new ObservableArray(initialValues, referenceEnhancer, name);
	    },
	    map: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("map");
	        return new ObservableMap(initialValues, deepEnhancer, name);
	    },
	    shallowMap: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowMap");
	        return new ObservableMap(initialValues, referenceEnhancer, name);
	    },
	    object: function (props, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("object");
	        var res = {};
	        // convert to observable object
	        asObservableObject(res, name);
	        // add properties
	        extendObservable(res, props);
	        return res;
	    },
	    shallowObject: function (props, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowObject");
	        var res = {};
	        asObservableObject(res, name);
	        extendShallowObservable(res, props);
	        return res;
	    },
	    ref: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(referenceEnhancer, arguments[0]);
	        }
	        else {
	            return refDecorator.apply(null, arguments);
	        }
	    },
	    shallow: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(shallowEnhancer, arguments[0]);
	        }
	        else {
	            return shallowDecorator.apply(null, arguments);
	        }
	    },
	    deep: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(deepEnhancer, arguments[0]);
	        }
	        else {
	            return deepDecorator.apply(null, arguments);
	        }
	    },
	    struct: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
	        }
	        else {
	            return deepStructDecorator.apply(null, arguments);
	        }
	    }
	};
	var observable = createObservable;
	// weird trick to keep our typings nicely with our funcs, and still extend the observable function
	Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
	observable.deep.struct = observable.struct;
	observable.ref.struct = function () {
	    if (arguments.length < 2) {
	        return createModifierDescriptor(refStructEnhancer, arguments[0]);
	    }
	    else {
	        return refStructDecorator.apply(null, arguments);
	    }
	};
	function incorrectlyUsedAsDecorator(methodName) {
	    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
	}
	
	function isModifierDescriptor(thing) {
	    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
	}
	function createModifierDescriptor(enhancer, initialValue) {
	    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
	    return {
	        isMobxModifierDescriptor: true,
	        initialValue: initialValue,
	        enhancer: enhancer
	    };
	}
	function deepEnhancer(v, _, name) {
	    if (isModifierDescriptor(v))
	        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return observable.array(v, name);
	    if (isPlainObject(v))
	        return observable.object(v, name);
	    if (isES6Map(v))
	        return observable.map(v, name);
	    return v;
	}
	function shallowEnhancer(v, _, name) {
	    if (isModifierDescriptor(v))
	        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
	    if (v === undefined || v === null)
	        return v;
	    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
	        return v;
	    if (Array.isArray(v))
	        return observable.shallowArray(v, name);
	    if (isPlainObject(v))
	        return observable.shallowObject(v, name);
	    if (isES6Map(v))
	        return observable.shallowMap(v, name);
	    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
	}
	function referenceEnhancer(newValue) {
	    // never turn into an observable
	    return newValue;
	}
	function deepStructEnhancer(v, oldValue, name) {
	    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
	    // more suited for immutable objects
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return new ObservableArray(v, deepStructEnhancer, name);
	    if (isES6Map(v))
	        return new ObservableMap(v, deepStructEnhancer, name);
	    if (isPlainObject(v)) {
	        var res = {};
	        asObservableObject(res, name);
	        extendObservableHelper(res, deepStructEnhancer, [v]);
	        return res;
	    }
	    return v;
	}
	function refStructEnhancer(v, oldValue, name) {
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    return v;
	}
	
	/**
	 * During a transaction no views are updated until the end of the transaction.
	 * The transaction will be run synchronously nonetheless.
	 *
	 * @param action a function that updates some reactive state
	 * @returns any value that was returned by the 'action' parameter.
	 */
	function transaction(action, thisArg) {
	    if (thisArg === void 0) { thisArg = undefined; }
	    startBatch();
	    try {
	        return action.apply(thisArg);
	    }
	    finally {
	        endBatch();
	    }
	}
	
	var ObservableMapMarker = {};
	var ObservableMap = /** @class */ (function () {
	    function ObservableMap(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer; }
	        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
	        this.enhancer = enhancer;
	        this.name = name;
	        this.$mobx = ObservableMapMarker;
	        this._data = Object.create(null);
	        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
	        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
	        this.interceptors = null;
	        this.changeListeners = null;
	        this.dehancer = undefined;
	        this.merge(initialData);
	    }
	    ObservableMap.prototype._has = function (key) {
	        return typeof this._data[key] !== "undefined";
	    };
	    ObservableMap.prototype.has = function (key) {
	        if (!this.isValidKey(key))
	            return false;
	        key = "" + key;
	        if (this._hasMap[key])
	            return this._hasMap[key].get();
	        return this._updateHasMapEntry(key, false).get();
	    };
	    ObservableMap.prototype.set = function (key, value) {
	        this.assertValidKey(key);
	        key = "" + key;
	        var hasKey = this._has(key);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: hasKey ? "update" : "add",
	                object: this,
	                newValue: value,
	                name: key
	            });
	            if (!change)
	                return this;
	            value = change.newValue;
	        }
	        if (hasKey) {
	            this._updateValue(key, value);
	        }
	        else {
	            this._addValue(key, value);
	        }
	        return this;
	    };
	    ObservableMap.prototype.delete = function (key) {
	        var _this = this;
	        this.assertValidKey(key);
	        key = "" + key;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                name: key
	            });
	            if (!change)
	                return false;
	        }
	        if (this._has(key)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: this._data[key].value,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(change);
	            transaction(function () {
	                _this._keys.remove(key);
	                _this._updateHasMapEntry(key, false);
	                var observable$$1 = _this._data[key];
	                observable$$1.setNewValue(undefined);
	                _this._data[key] = undefined;
	            });
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
	        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
	        var entry = this._hasMap[key];
	        if (entry) {
	            entry.setNewValue(value);
	        }
	        else {
	            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
	        }
	        return entry;
	    };
	    ObservableMap.prototype._updateValue = function (name, newValue) {
	        var observable$$1 = this._data[name];
	        newValue = observable$$1.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: this,
	                    oldValue: observable$$1.value,
	                    name: name,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(change);
	            observable$$1.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableMap.prototype._addValue = function (name, newValue) {
	        var _this = this;
	        transaction(function () {
	            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
	            newValue = observable$$1.value; // value might have been changed
	            _this._updateHasMapEntry(name, true);
	            _this._keys.push(name);
	        });
	        var notifySpy = isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                type: "add",
	                object: this,
	                name: name,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableMap.prototype.get = function (key) {
	        key = "" + key;
	        if (this.has(key))
	            return this.dehanceValue(this._data[key].get());
	        return this.dehanceValue(undefined);
	    };
	    ObservableMap.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableMap.prototype.keys = function () {
	        return arrayAsIterator(this._keys.slice());
	    };
	    ObservableMap.prototype.values = function () {
	        return arrayAsIterator(this._keys.map(this.get, this));
	    };
	    ObservableMap.prototype.entries = function () {
	        var _this = this;
	        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
	    };
	    ObservableMap.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
	    };
	    /** Merge another object into this object, returns this. */
	    ObservableMap.prototype.merge = function (other) {
	        var _this = this;
	        if (isObservableMap(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            if (isPlainObject(other))
	                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
	            else if (Array.isArray(other))
	                other.forEach(function (_a) {
	                    var key = _a[0], value = _a[1];
	                    return _this.set(key, value);
	                });
	            else if (isES6Map(other))
	                other.forEach(function (value, key) { return _this.set(key, value); });
	            else if (other !== null && other !== undefined)
	                fail("Cannot initialize map from " + other);
	        });
	        return this;
	    };
	    ObservableMap.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                _this.keys().forEach(_this.delete, _this);
	            });
	        });
	    };
	    ObservableMap.prototype.replace = function (values) {
	        var _this = this;
	        transaction(function () {
	            // grab all the keys that are present in the new map but not present in the current map
	            // and delete them from the map, then merge the new map
	            // this will cause reactions only on changed values
	            var newKeys = getMapLikeKeys(values);
	            var oldKeys = _this.keys();
	            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
	            missingKeys.forEach(function (k) { return _this.delete(k); });
	            _this.merge(values);
	        });
	        return this;
	    };
	    Object.defineProperty(ObservableMap.prototype, "size", {
	        get: function () {
	            return this._keys.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a shallow non observable object clone of this map.
	     * Note that the values might still be observable. For a deep clone use mobx.toJS.
	     */
	    ObservableMap.prototype.toJS = function () {
	        var _this = this;
	        var res = {};
	        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
	        return res;
	    };
	    ObservableMap.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableMap.prototype.isValidKey = function (key) {
	        if (key === null || key === undefined)
	            return false;
	        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
	            return true;
	        return false;
	    };
	    ObservableMap.prototype.assertValidKey = function (key) {
	        if (!this.isValidKey(key))
	            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
	    };
	    ObservableMap.prototype.toString = function () {
	        var _this = this;
	        return (this.name +
	            "[{ " +
	            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
	            " }]");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableMap.prototype.observe = function (listener, fireImmediately) {
	        invariant(fireImmediately !== true, getMessage("m033"));
	        return registerListener(this, listener);
	    };
	    ObservableMap.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableMap;
	}());
	declareIterator(ObservableMap.prototype, function () {
	    return this.entries();
	});
	function map(initialValues) {
	    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
	    return observable.map(initialValues);
	}
	/* 'var' fixes small-build issue */
	var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
	
	var EMPTY_ARRAY = [];
	Object.freeze(EMPTY_ARRAY);
	function getGlobal() {
	    return typeof window !== "undefined" ? window : global;
	}
	function getNextId() {
	    return ++globalState.mobxGuid;
	}
	function fail(message, thing) {
	    invariant(false, message, thing);
	    throw "X"; // unreachable
	}
	function invariant(check, message, thing) {
	    if (!check)
	        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
	}
	/**
	 * Prints a deprecation message, but only one time.
	 * Returns false if the deprecated message was already printed before
	 */
	var deprecatedMessages = [];
	function deprecated(msg) {
	    if (deprecatedMessages.indexOf(msg) !== -1)
	        return false;
	    deprecatedMessages.push(msg);
	    console.error("[mobx] Deprecated: " + msg);
	    return true;
	}
	/**
	 * Makes sure that the provided function is invoked at most once.
	 */
	function once(func) {
	    var invoked = false;
	    return function () {
	        if (invoked)
	            return;
	        invoked = true;
	        return func.apply(this, arguments);
	    };
	}
	var noop = function () { };
	function unique(list) {
	    var res = [];
	    list.forEach(function (item) {
	        if (res.indexOf(item) === -1)
	            res.push(item);
	    });
	    return res;
	}
	function joinStrings(things, limit, separator) {
	    if (limit === void 0) { limit = 100; }
	    if (separator === void 0) { separator = " - "; }
	    if (!things)
	        return "";
	    var sliced = things.slice(0, limit);
	    return "" + sliced.join(separator) + (things.length > limit
	        ? " (... and " + (things.length - limit) + "more)"
	        : "");
	}
	function isObject(value) {
	    return value !== null && typeof value === "object";
	}
	function isPlainObject(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	function objectAssign() {
	    var res = arguments[0];
	    for (var i = 1, l = arguments.length; i < l; i++) {
	        var source = arguments[i];
	        for (var key in source)
	            if (hasOwnProperty(source, key)) {
	                res[key] = source[key];
	            }
	    }
	    return res;
	}
	var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwnProperty(object, propName) {
	    return prototypeHasOwnProperty.call(object, propName);
	}
	function makeNonEnumerable(object, propNames) {
	    for (var i = 0; i < propNames.length; i++) {
	        addHiddenProp(object, propNames[i], object[propNames[i]]);
	    }
	}
	function addHiddenProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function isPropertyConfigurable(object, prop) {
	    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
	    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
	}
	function assertPropertyConfigurable(object, prop) {
	    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
	}
	function createInstanceofPredicate(name, clazz) {
	    var propName = "isMobX" + name;
	    clazz.prototype[propName] = true;
	    return function (x) {
	        return isObject(x) && x[propName] === true;
	    };
	}
	function areBothNaN(a, b) {
	    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
	}
	/**
	 * Returns whether the argument is an array, disregarding observability.
	 */
	function isArrayLike(x) {
	    return Array.isArray(x) || isObservableArray(x);
	}
	function isES6Map(thing) {
	    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
	        return true;
	    return false;
	}
	function getMapLikeKeys(map$$1) {
	    if (isPlainObject(map$$1))
	        return Object.keys(map$$1);
	    if (Array.isArray(map$$1))
	        return map$$1.map(function (_a) {
	            var key = _a[0];
	            return key;
	        });
	    if (isES6Map(map$$1))
	        return Array.from(map$$1.keys());
	    if (isObservableMap(map$$1))
	        return map$$1.keys();
	    return fail("Cannot get keys from " + map$$1);
	}
	function iteratorToArray(it) {
	    var res = [];
	    while (true) {
	        var r = it.next();
	        if (r.done)
	            break;
	        res.push(r.value);
	    }
	    return res;
	}
	function primitiveSymbol() {
	    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
	}
	function toPrimitive(value) {
	    return value === null ? null : typeof value === "object" ? "" + value : value;
	}
	
	/**
	 * These values will persist if global state is reset
	 */
	var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
	var MobXGlobals = /** @class */ (function () {
	    function MobXGlobals() {
	        /**
	         * MobXGlobals version.
	         * MobX compatiblity with other versions loaded in memory as long as this version matches.
	         * It indicates that the global state still stores similar information
	         */
	        this.version = 5;
	        /**
	         * Currently running derivation
	         */
	        this.trackingDerivation = null;
	        /**
	         * Are we running a computation currently? (not a reaction)
	         */
	        this.computationDepth = 0;
	        /**
	         * Each time a derivation is tracked, it is assigned a unique run-id
	         */
	        this.runId = 0;
	        /**
	         * 'guid' for general purpose. Will be persisted amongst resets.
	         */
	        this.mobxGuid = 0;
	        /**
	         * Are we in a batch block? (and how many of them)
	         */
	        this.inBatch = 0;
	        /**
	         * Observables that don't have observers anymore, and are about to be
	         * suspended, unless somebody else accesses it in the same batch
	         *
	         * @type {IObservable[]}
	         */
	        this.pendingUnobservations = [];
	        /**
	         * List of scheduled, not yet executed, reactions.
	         */
	        this.pendingReactions = [];
	        /**
	         * Are we currently processing reactions?
	         */
	        this.isRunningReactions = false;
	        /**
	         * Is it allowed to change observables at this point?
	         * In general, MobX doesn't allow that when running computations and React.render.
	         * To ensure that those functions stay pure.
	         */
	        this.allowStateChanges = true;
	        /**
	         * If strict mode is enabled, state changes are by default not allowed
	         */
	        this.strictMode = false;
	        /**
	         * Used by createTransformer to detect that the global state has been reset.
	         */
	        this.resetId = 0;
	        /**
	         * Spy callbacks
	         */
	        this.spyListeners = [];
	        /**
	         * Globally attached error handlers that react specifically to errors in reactions
	         */
	        this.globalReactionErrorHandlers = [];
	    }
	    return MobXGlobals;
	}());
	var globalState = new MobXGlobals();
	var shareGlobalStateCalled = false;
	var runInIsolationCalled = false;
	var warnedAboutMultipleInstances = false;
	{
	    var global_1 = getGlobal();
	    if (!global_1.__mobxInstanceCount) {
	        global_1.__mobxInstanceCount = 1;
	    }
	    else {
	        global_1.__mobxInstanceCount++;
	        setTimeout(function () {
	            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
	                warnedAboutMultipleInstances = true;
	                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
	            }
	        }, 1);
	    }
	}
	function isolateGlobalState() {
	    runInIsolationCalled = true;
	    getGlobal().__mobxInstanceCount--;
	}
	function shareGlobalState() {
	    // TODO: remove in 4.0; just use peer dependencies instead.
	    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
	    shareGlobalStateCalled = true;
	    var global = getGlobal();
	    var ownState = globalState;
	    /**
	     * Backward compatibility check
	     */
	    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
	        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
	    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
	        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
	    if (global.__mobxGlobal)
	        globalState = global.__mobxGlobal;
	    else
	        global.__mobxGlobal = ownState;
	}
	function getGlobalState() {
	    return globalState;
	}
	
	/**
	 * For testing purposes only; this will break the internal state of existing observables,
	 * but can be used to get back at a stable state after throwing errors
	 */
	function resetGlobalState() {
	    globalState.resetId++;
	    var defaultGlobals = new MobXGlobals();
	    for (var key in defaultGlobals)
	        if (persistentKeys.indexOf(key) === -1)
	            globalState[key] = defaultGlobals[key];
	    globalState.allowStateChanges = !globalState.strictMode;
	}
	
	function getAtom(thing, property) {
	    if (typeof thing === "object" && thing !== null) {
	        if (isObservableArray(thing)) {
	            invariant(property === undefined, getMessage("m036"));
	            return thing.$mobx.atom;
	        }
	        if (isObservableMap(thing)) {
	            var anyThing = thing;
	            if (property === undefined)
	                return getAtom(anyThing._keys);
	            var observable = anyThing._data[property] || anyThing._hasMap[property];
	            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        runLazyInitializers(thing);
	        if (property && !thing.$mobx)
	            thing[property]; // See #1072 // TODO: remove in 4.0
	        if (isObservableObject(thing)) {
	            if (!property)
	                return fail("please specify a property");
	            var observable = thing.$mobx.values[property];
	            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
	            return thing;
	        }
	    }
	    else if (typeof thing === "function") {
	        if (isReaction(thing.$mobx)) {
	            // disposer function
	            return thing.$mobx;
	        }
	    }
	    return fail("Cannot obtain atom from " + thing);
	}
	function getAdministration(thing, property) {
	    invariant(thing, "Expecting some object");
	    if (property !== undefined)
	        return getAdministration(getAtom(thing, property));
	    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
	        return thing;
	    if (isObservableMap(thing))
	        return thing;
	    // Initializers run lazily when transpiling to babel, so make sure they are run...
	    runLazyInitializers(thing);
	    if (thing.$mobx)
	        return thing.$mobx;
	    invariant(false, "Cannot obtain administration from " + thing);
	}
	function getDebugName(thing, property) {
	    var named;
	    if (property !== undefined)
	        named = getAtom(thing, property);
	    else if (isObservableObject(thing) || isObservableMap(thing))
	        named = getAdministration(thing);
	    else
	        named = getAtom(thing); // valid for arrays as well
	    return named.name;
	}
	
	function getDependencyTree(thing, property) {
	    return nodeToDependencyTree(getAtom(thing, property));
	}
	function nodeToDependencyTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (node.observing && node.observing.length > 0)
	        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
	    return result;
	}
	function getObserverTree(thing, property) {
	    return nodeToObserverTree(getAtom(thing, property));
	}
	function nodeToObserverTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (hasObservers(node))
	        result.observers = getObservers(node).map(nodeToObserverTree);
	    return result;
	}
	
	function hasObservers(observable) {
	    return observable.observers && observable.observers.length > 0;
	}
	function getObservers(observable) {
	    return observable.observers;
	}
	function addObserver(observable, node) {
	    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
	    // invariantObservers(observable);
	    var l = observable.observers.length;
	    if (l) {
	        // because object assignment is relatively expensive, let's not store data about index 0.
	        observable.observersIndexes[node.__mapid] = l;
	    }
	    observable.observers[l] = node;
	    if (observable.lowestObserverState > node.dependenciesState)
	        observable.lowestObserverState = node.dependenciesState;
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
	}
	function removeObserver(observable, node) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
	    // invariantObservers(observable);
	    if (observable.observers.length === 1) {
	        // deleting last observer
	        observable.observers.length = 0;
	        queueForUnobservation(observable);
	    }
	    else {
	        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
	        var list = observable.observers;
	        var map = observable.observersIndexes;
	        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
	        if (filler !== node) {
	            // otherwise node was the last element, which already got removed from array
	            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
	            if (index) {
	                // map store all indexes but 0, see comment in `addObserver`
	                map[filler.__mapid] = index;
	            }
	            else {
	                delete map[filler.__mapid];
	            }
	            list[index] = filler;
	        }
	        delete map[node.__mapid];
	    }
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
	}
	function queueForUnobservation(observable) {
	    if (!observable.isPendingUnobservation) {
	        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
	        observable.isPendingUnobservation = true;
	        globalState.pendingUnobservations.push(observable);
	    }
	}
	/**
	 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
	 * During a batch `onBecomeUnobserved` will be called at most once per observable.
	 * Avoids unnecessary recalculations.
	 */
	function startBatch() {
	    globalState.inBatch++;
	}
	function endBatch() {
	    if (--globalState.inBatch === 0) {
	        runReactions();
	        // the batch is actually about to finish, all unobserving should happen here.
	        var list = globalState.pendingUnobservations;
	        for (var i = 0; i < list.length; i++) {
	            var observable = list[i];
	            observable.isPendingUnobservation = false;
	            if (observable.observers.length === 0) {
	                observable.onBecomeUnobserved();
	                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
	            }
	        }
	        globalState.pendingUnobservations = [];
	    }
	}
	function reportObserved(observable) {
	    var derivation = globalState.trackingDerivation;
	    if (derivation !== null) {
	        /**
	         * Simple optimization, give each derivation run an unique id (runId)
	         * Check if last time this observable was accessed the same runId is used
	         * if this is the case, the relation is already known
	         */
	        if (derivation.runId !== observable.lastAccessedBy) {
	            observable.lastAccessedBy = derivation.runId;
	            derivation.newObserving[derivation.unboundDepsCount++] = observable;
	        }
	    }
	    else if (observable.observers.length === 0) {
	        queueForUnobservation(observable);
	    }
	}
	/**
	 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
	 * It will propagate changes to observers from previous run
	 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
	 * Hopefully self reruning autoruns aren't a feature people should depend on
	 * Also most basic use cases should be ok
	 */
	// Called by Atom when its value changes
	function propagateChanged(observable) {
	    // invariantLOS(observable, "changed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	        d.dependenciesState = exports.IDerivationState.STALE;
	    }
	    // invariantLOS(observable, "changed end");
	}
	// Called by ComputedValue when it recalculate and its value changed
	function propagateChangeConfirmed(observable) {
	    // invariantLOS(observable, "confirmed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.POSSIBLY_STALE)
	            d.dependenciesState = exports.IDerivationState.STALE;
	        else if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
	        )
	            observable.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	    }
	    // invariantLOS(observable, "confirmed end");
	}
	// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
	function propagateMaybeChanged(observable) {
	    // invariantLOS(observable, "maybe start");
	    if (observable.lowestObserverState !== exports.IDerivationState.UP_TO_DATE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.POSSIBLY_STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            d.dependenciesState = exports.IDerivationState.POSSIBLY_STALE;
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	    }
	    // invariantLOS(observable, "maybe end");
	}
	function logTraceInfo(derivation, observable) {
	    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
	    if (derivation.isTracing === TraceMode.BREAK) {
	        var lines = [];
	        printDepTree(getDependencyTree(derivation), lines, 1);
	        // prettier-ignore
	        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
	    }
	}
	function printDepTree(tree, lines, depth) {
	    if (lines.length >= 1000) {
	        lines.push("(and many more)");
	        return;
	    }
	    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
	    if (tree.dependencies)
	        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
	}
	
	(function (IDerivationState) {
	    // before being run or (outside batch and not being observed)
	    // at this point derivation is not holding any data about dependency tree
	    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
	    // no shallow dependency changed since last computation
	    // won't recalculate derivation
	    // this is what makes mobx fast
	    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
	    // some deep dependency changed, but don't know if shallow dependency changed
	    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
	    // currently only ComputedValue will propagate POSSIBLY_STALE
	    //
	    // having this state is second big optimization:
	    // don't have to recompute on every dependency change, but only when it's needed
	    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
	    // A shallow dependency has changed since last computation and the derivation
	    // will need to recompute when it's needed next.
	    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
	})(exports.IDerivationState || (exports.IDerivationState = {}));
	var TraceMode;
	(function (TraceMode) {
	    TraceMode[TraceMode["NONE"] = 0] = "NONE";
	    TraceMode[TraceMode["LOG"] = 1] = "LOG";
	    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
	})(TraceMode || (TraceMode = {}));
	var CaughtException = /** @class */ (function () {
	    function CaughtException(cause) {
	        this.cause = cause;
	        // Empty
	    }
	    return CaughtException;
	}());
	function isCaughtException(e) {
	    return e instanceof CaughtException;
	}
	/**
	 * Finds out whether any dependency of the derivation has actually changed.
	 * If dependenciesState is 1 then it will recalculate dependencies,
	 * if any dependency changed it will propagate it by changing dependenciesState to 2.
	 *
	 * By iterating over the dependencies in the same order that they were reported and
	 * stopping on the first change, all the recalculations are only called for ComputedValues
	 * that will be tracked by derivation. That is because we assume that if the first x
	 * dependencies of the derivation doesn't change then the derivation should run the same way
	 * up until accessing x-th dependency.
	 */
	function shouldCompute(derivation) {
	    switch (derivation.dependenciesState) {
	        case exports.IDerivationState.UP_TO_DATE:
	            return false;
	        case exports.IDerivationState.NOT_TRACKING:
	        case exports.IDerivationState.STALE:
	            return true;
	        case exports.IDerivationState.POSSIBLY_STALE: {
	            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
	            var obs = derivation.observing, l = obs.length;
	            for (var i = 0; i < l; i++) {
	                var obj = obs[i];
	                if (isComputedValue(obj)) {
	                    try {
	                        obj.get();
	                    }
	                    catch (e) {
	                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
	                        untrackedEnd(prevUntracked);
	                        return true;
	                    }
	                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
	                    // and `derivation` is an observer of `obj`
	                    if (derivation.dependenciesState === exports.IDerivationState.STALE) {
	                        untrackedEnd(prevUntracked);
	                        return true;
	                    }
	                }
	            }
	            changeDependenciesStateTo0(derivation);
	            untrackedEnd(prevUntracked);
	            return false;
	        }
	    }
	}
	function isComputingDerivation() {
	    return globalState.trackingDerivation !== null; // filter out actions inside computations
	}
	function checkIfStateModificationsAreAllowed(atom) {
	    var hasObservers$$1 = atom.observers.length > 0;
	    // Should never be possible to change an observed observable from inside computed, see #798
	    if (globalState.computationDepth > 0 && hasObservers$$1)
	        fail(getMessage("m031") + atom.name);
	    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
	    if (!globalState.allowStateChanges && hasObservers$$1)
	        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
	}
	/**
	 * Executes the provided function `f` and tracks which observables are being accessed.
	 * The tracking information is stored on the `derivation` object and the derivation is registered
	 * as observer of any of the accessed observables.
	 */
	function trackDerivedFunction(derivation, f, context) {
	    // pre allocate array allocation + room for variation in deps
	    // array will be trimmed by bindDependencies
	    changeDependenciesStateTo0(derivation);
	    derivation.newObserving = new Array(derivation.observing.length + 100);
	    derivation.unboundDepsCount = 0;
	    derivation.runId = ++globalState.runId;
	    var prevTracking = globalState.trackingDerivation;
	    globalState.trackingDerivation = derivation;
	    var result;
	    try {
	        result = f.call(context);
	    }
	    catch (e) {
	        result = new CaughtException(e);
	    }
	    globalState.trackingDerivation = prevTracking;
	    bindDependencies(derivation);
	    return result;
	}
	/**
	 * diffs newObserving with observing.
	 * update observing to be newObserving with unique observables
	 * notify observers that become observed/unobserved
	 */
	function bindDependencies(derivation) {
	    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
	    var prevObserving = derivation.observing;
	    var observing = (derivation.observing = derivation.newObserving);
	    var lowestNewObservingDerivationState = exports.IDerivationState.UP_TO_DATE;
	    // Go through all new observables and check diffValue: (this list can contain duplicates):
	    //   0: first occurrence, change to 1 and keep it
	    //   1: extra occurrence, drop it
	    var i0 = 0, l = derivation.unboundDepsCount;
	    for (var i = 0; i < l; i++) {
	        var dep = observing[i];
	        if (dep.diffValue === 0) {
	            dep.diffValue = 1;
	            if (i0 !== i)
	                observing[i0] = dep;
	            i0++;
	        }
	        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
	        // not hitting the condition
	        if (dep.dependenciesState > lowestNewObservingDerivationState) {
	            lowestNewObservingDerivationState = dep.dependenciesState;
	        }
	    }
	    observing.length = i0;
	    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
	    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
	    //   0: it's not in new observables, unobserve it
	    //   1: it keeps being observed, don't want to notify it. change to 0
	    l = prevObserving.length;
	    while (l--) {
	        var dep = prevObserving[l];
	        if (dep.diffValue === 0) {
	            removeObserver(dep, derivation);
	        }
	        dep.diffValue = 0;
	    }
	    // Go through all new observables and check diffValue: (now it should be unique)
	    //   0: it was set to 0 in last loop. don't need to do anything.
	    //   1: it wasn't observed, let's observe it. set back to 0
	    while (i0--) {
	        var dep = observing[i0];
	        if (dep.diffValue === 1) {
	            dep.diffValue = 0;
	            addObserver(dep, derivation);
	        }
	    }
	    // Some new observed derivations may become stale during this derivation computation
	    // so they have had no chance to propagate staleness (#916)
	    if (lowestNewObservingDerivationState !== exports.IDerivationState.UP_TO_DATE) {
	        derivation.dependenciesState = lowestNewObservingDerivationState;
	        derivation.onBecomeStale();
	    }
	}
	function clearObserving(derivation) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
	    var obs = derivation.observing;
	    derivation.observing = [];
	    var i = obs.length;
	    while (i--)
	        removeObserver(obs[i], derivation);
	    derivation.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	}
	function untracked(action) {
	    var prev = untrackedStart();
	    var res = action();
	    untrackedEnd(prev);
	    return res;
	}
	function untrackedStart() {
	    var prev = globalState.trackingDerivation;
	    globalState.trackingDerivation = null;
	    return prev;
	}
	function untrackedEnd(prev) {
	    globalState.trackingDerivation = prev;
	}
	/**
	 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
	 *
	 */
	function changeDependenciesStateTo0(derivation) {
	    if (derivation.dependenciesState === exports.IDerivationState.UP_TO_DATE)
	        return;
	    derivation.dependenciesState = exports.IDerivationState.UP_TO_DATE;
	    var obs = derivation.observing;
	    var i = obs.length;
	    while (i--)
	        obs[i].lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	}
	
	function log(msg) {
	    console.log(msg);
	    return msg;
	}
	function whyRun(thing, prop) {
	    deprecated("`whyRun` is deprecated in favor of `trace`");
	    thing = getAtomFromArgs(arguments);
	    if (!thing)
	        return log(getMessage("m024"));
	    if (isComputedValue(thing) || isReaction(thing))
	        return log(thing.whyRun());
	    return fail(getMessage("m025"));
	}
	function trace() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var enterBreakPoint = false;
	    if (typeof args[args.length - 1] === "boolean")
	        enterBreakPoint = args.pop();
	    var derivation = getAtomFromArgs(args);
	    if (!derivation) {
	        return fail("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
	    }
	    if (derivation.isTracing === TraceMode.NONE) {
	        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
	    }
	    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
	}
	function getAtomFromArgs(args) {
	    switch (args.length) {
	        case 0:
	            return globalState.trackingDerivation;
	        case 1:
	            return getAtom(args[0]);
	        case 2:
	            return getAtom(args[0], args[1]);
	    }
	}
	
	var Reaction = /** @class */ (function () {
	    function Reaction(name, onInvalidate) {
	        if (name === void 0) { name = "Reaction@" + getNextId(); }
	        this.name = name;
	        this.onInvalidate = onInvalidate;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = [];
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.diffValue = 0;
	        this.runId = 0;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.isDisposed = false;
	        this._isScheduled = false;
	        this._isTrackPending = false;
	        this._isRunning = false;
	        this.isTracing = TraceMode.NONE;
	    }
	    Reaction.prototype.onBecomeStale = function () {
	        this.schedule();
	    };
	    Reaction.prototype.schedule = function () {
	        if (!this._isScheduled) {
	            this._isScheduled = true;
	            globalState.pendingReactions.push(this);
	            runReactions();
	        }
	    };
	    Reaction.prototype.isScheduled = function () {
	        return this._isScheduled;
	    };
	    /**
	     * internal, use schedule() if you intend to kick off a reaction
	     */
	    Reaction.prototype.runReaction = function () {
	        if (!this.isDisposed) {
	            startBatch();
	            this._isScheduled = false;
	            if (shouldCompute(this)) {
	                this._isTrackPending = true;
	                this.onInvalidate();
	                if (this._isTrackPending && isSpyEnabled()) {
	                    // onInvalidate didn't trigger track right away..
	                    spyReport({
	                        object: this,
	                        type: "scheduled-reaction"
	                    });
	                }
	            }
	            endBatch();
	        }
	    };
	    Reaction.prototype.track = function (fn) {
	        startBatch();
	        var notify = isSpyEnabled();
	        var startTime;
	        if (notify) {
	            startTime = Date.now();
	            spyReportStart({
	                object: this,
	                type: "reaction",
	                fn: fn
	            });
	        }
	        this._isRunning = true;
	        var result = trackDerivedFunction(this, fn, undefined);
	        this._isRunning = false;
	        this._isTrackPending = false;
	        if (this.isDisposed) {
	            // disposed during last run. Clean up everything that was bound after the dispose call.
	            clearObserving(this);
	        }
	        if (isCaughtException(result))
	            this.reportExceptionInDerivation(result.cause);
	        if (notify) {
	            spyReportEnd({
	                time: Date.now() - startTime
	            });
	        }
	        endBatch();
	    };
	    Reaction.prototype.reportExceptionInDerivation = function (error) {
	        var _this = this;
	        if (this.errorHandler) {
	            this.errorHandler(error, this);
	            return;
	        }
	        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
	        var messageToUser = getMessage("m037");
	        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
	        /** If debugging brought you here, please, read the above message :-). Tnx! */
	        if (isSpyEnabled()) {
	            spyReport({
	                type: "error",
	                message: message,
	                error: error,
	                object: this
	            });
	        }
	        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
	    };
	    Reaction.prototype.dispose = function () {
	        if (!this.isDisposed) {
	            this.isDisposed = true;
	            if (!this._isRunning) {
	                // if disposed while running, clean up later. Maybe not optimal, but rare case
	                startBatch();
	                clearObserving(this);
	                endBatch();
	            }
	        }
	    };
	    Reaction.prototype.getDisposer = function () {
	        var r = this.dispose.bind(this);
	        r.$mobx = this;
	        r.onError = registerErrorHandler;
	        return r;
	    };
	    Reaction.prototype.toString = function () {
	        return "Reaction[" + this.name + "]";
	    };
	    Reaction.prototype.whyRun = function () {
	        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
	        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
	            ? "stopped"
	            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
	            ? " (... or any observable accessed during the remainder of the current run)"
	            : "") + "\n\t" + getMessage("m038") + "\n";
	    };
	    Reaction.prototype.trace = function (enterBreakPoint) {
	        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
	        trace(this, enterBreakPoint);
	    };
	    return Reaction;
	}());
	function registerErrorHandler(handler) {
	    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
	    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
	    this.$mobx.errorHandler = handler;
	}
	function onReactionError(handler) {
	    globalState.globalReactionErrorHandlers.push(handler);
	    return function () {
	        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
	        if (idx >= 0)
	            globalState.globalReactionErrorHandlers.splice(idx, 1);
	    };
	}
	/**
	 * Magic number alert!
	 * Defines within how many times a reaction is allowed to re-trigger itself
	 * until it is assumed that this is gonna be a never ending loop...
	 */
	var MAX_REACTION_ITERATIONS = 100;
	var reactionScheduler = function (f) { return f(); };
	function runReactions() {
	    // Trampolining, if runReactions are already running, new reactions will be picked up
	    if (globalState.inBatch > 0 || globalState.isRunningReactions)
	        return;
	    reactionScheduler(runReactionsHelper);
	}
	function runReactionsHelper() {
	    globalState.isRunningReactions = true;
	    var allReactions = globalState.pendingReactions;
	    var iterations = 0;
	    // While running reactions, new reactions might be triggered.
	    // Hence we work with two variables and check whether
	    // we converge to no remaining reactions after a while.
	    while (allReactions.length > 0) {
	        if (++iterations === MAX_REACTION_ITERATIONS) {
	            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
	                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
	            allReactions.splice(0); // clear reactions
	        }
	        var remainingReactions = allReactions.splice(0);
	        for (var i = 0, l = remainingReactions.length; i < l; i++)
	            remainingReactions[i].runReaction();
	    }
	    globalState.isRunningReactions = false;
	}
	var isReaction = createInstanceofPredicate("Reaction", Reaction);
	function setReactionScheduler(fn) {
	    var baseScheduler = reactionScheduler;
	    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
	}
	
	function asReference(value) {
	    deprecated("asReference is deprecated, use observable.ref instead");
	    return observable.ref(value);
	}
	function asStructure(value) {
	    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
	    return observable.struct(value);
	}
	function asFlat(value) {
	    deprecated("asFlat is deprecated, use observable.shallow instead");
	    return observable.shallow(value);
	}
	function asMap(data) {
	    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
	    return observable.map(data || {});
	}
	
	function createComputedDecorator(equals) {
	    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
	        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
	        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
	        var adm = asObservableObject(target, "");
	        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
	    }, function (name) {
	        var observable = this.$mobx.values[name];
	        if (observable === undefined // See #505
	        )
	            return undefined;
	        return observable.get();
	    }, function (name, value) {
	        this.$mobx.values[name].set(value);
	    }, false, false);
	}
	var computedDecorator = createComputedDecorator(comparer.default);
	var computedStructDecorator = createComputedDecorator(comparer.structural);
	/**
	 * Decorator for class properties: @computed get value() { return expr; }.
	 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
	 */
	var computed = function computed(arg1, arg2, arg3) {
	    if (typeof arg2 === "string") {
	        return computedDecorator.apply(null, arguments);
	    }
	    invariant(typeof arg1 === "function", getMessage("m011"));
	    invariant(arguments.length < 3, getMessage("m012"));
	    var opts = typeof arg2 === "object" ? arg2 : {};
	    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
	    var equals = opts.equals
	        ? opts.equals
	        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
	    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
	};
	computed.struct = computedStructDecorator;
	computed.equals = createComputedDecorator;
	
	function isComputed(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableObject(value) === false)
	            return false;
	        if (!value.$mobx.values[property])
	            return false;
	        var atom = getAtom(value, property);
	        return isComputedValue(atom);
	    }
	    return isComputedValue(value);
	}
	
	function observe(thing, propOrCb, cbOrFire, fireImmediately) {
	    if (typeof cbOrFire === "function")
	        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
	    else
	        return observeObservable(thing, propOrCb, cbOrFire);
	}
	function observeObservable(thing, listener, fireImmediately) {
	    return getAdministration(thing).observe(listener, fireImmediately);
	}
	function observeObservableProperty(thing, property, listener, fireImmediately) {
	    return getAdministration(thing, property).observe(listener, fireImmediately);
	}
	
	function intercept(thing, propOrHandler, handler) {
	    if (typeof handler === "function")
	        return interceptProperty(thing, propOrHandler, handler);
	    else
	        return interceptInterceptable(thing, propOrHandler);
	}
	function interceptInterceptable(thing, handler) {
	    return getAdministration(thing).intercept(handler);
	}
	function interceptProperty(thing, property, handler) {
	    return getAdministration(thing, property).intercept(handler);
	}
	
	/**
	 * expr can be used to create temporarily views inside views.
	 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
	 *
	 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
	 * instead it will only rerenders when the current todo is (de)selected.
	 *
	 * reactiveComponent((props) => {
	 *     const todo = props.todo;
	 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
	 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
	 * });
	 *
	 */
	function expr(expr, scope) {
	    if (!isComputingDerivation())
	        console.warn(getMessage("m013"));
	    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
	    return computed(expr, { context: scope }).get();
	}
	
	function toJS(source, detectCycles, __alreadySeen) {
	    if (detectCycles === void 0) { detectCycles = true; }
	    if (__alreadySeen === void 0) { __alreadySeen = []; }
	    // optimization: using ES6 map would be more efficient!
	    // optimization: lift this function outside toJS, this makes recursion expensive
	    function cache(value) {
	        if (detectCycles)
	            __alreadySeen.push([source, value]);
	        return value;
	    }
	    if (isObservable(source)) {
	        if (detectCycles && __alreadySeen === null)
	            __alreadySeen = [];
	        if (detectCycles && source !== null && typeof source === "object") {
	            for (var i = 0, l = __alreadySeen.length; i < l; i++)
	                if (__alreadySeen[i][0] === source)
	                    return __alreadySeen[i][1];
	        }
	        if (isObservableArray(source)) {
	            var res = cache([]);
	            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
	            res.length = toAdd.length;
	            for (var i = 0, l = toAdd.length; i < l; i++)
	                res[i] = toAdd[i];
	            return res;
	        }
	        if (isObservableObject(source)) {
	            var res = cache({});
	            for (var key in source)
	                res[key] = toJS(source[key], detectCycles, __alreadySeen);
	            return res;
	        }
	        if (isObservableMap(source)) {
	            var res_1 = cache({});
	            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
	            return res_1;
	        }
	        if (isObservableValue(source))
	            return toJS(source.get(), detectCycles, __alreadySeen);
	    }
	    return source;
	}
	
	function createTransformer(transformer, onCleanup) {
	    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
	    // Memoizes: object id -> reactive view that applies transformer to the object
	    var objectCache = {};
	    // If the resetId changes, we will clear the object cache, see #163
	    // This construction is used to avoid leaking refs to the objectCache directly
	    var resetId = globalState.resetId;
	    // Local transformer class specifically for this transformer
	    var Transformer = /** @class */ (function (_super) {
	        __extends(Transformer, _super);
	        function Transformer(sourceIdentifier, sourceObject) {
	            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
	            _this.sourceIdentifier = sourceIdentifier;
	            _this.sourceObject = sourceObject;
	            return _this;
	        }
	        Transformer.prototype.onBecomeUnobserved = function () {
	            var lastValue = this.value;
	            _super.prototype.onBecomeUnobserved.call(this);
	            delete objectCache[this.sourceIdentifier];
	            if (onCleanup)
	                onCleanup(lastValue, this.sourceObject);
	        };
	        return Transformer;
	    }(ComputedValue));
	    return function (object) {
	        if (resetId !== globalState.resetId) {
	            objectCache = {};
	            resetId = globalState.resetId;
	        }
	        var identifier = getMemoizationId(object);
	        var reactiveTransformer = objectCache[identifier];
	        if (reactiveTransformer)
	            return reactiveTransformer.get();
	        // Not in cache; create a reactive view
	        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
	        return reactiveTransformer.get();
	    };
	}
	function getMemoizationId(object) {
	    if (typeof object === "string" || typeof object === "number")
	        return object;
	    if (object === null || typeof object !== "object")
	        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
	    var tid = object.$transformId;
	    if (tid === undefined) {
	        tid = getNextId();
	        addHiddenProp(object, "$transformId", tid);
	    }
	    return tid;
	}
	
	function interceptReads(thing, propOrHandler, handler) {
	    var target;
	    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
	        target = getAdministration(thing);
	    }
	    else if (isObservableObject(thing)) {
	        if (typeof propOrHandler !== "string")
	            return fail("InterceptReads can only be used with a specific property, not with an object in general");
	        target = getAdministration(thing, propOrHandler);
	    }
	    else {
	        return fail("Expected observable map, object or array as first array");
	    }
	    if (target.dehancer !== undefined)
	        return fail("An intercept reader was already established");
	    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
	    return function () {
	        target.dehancer = undefined;
	    };
	}
	
	/**
	 * (c) Michel Weststrate 2015 - 2016
	 * MIT Licensed
	 *
	 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
	 * this is a good place to start:
	 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
	 *
	 * Source folders:
	 * ===============
	 *
	 * - api/     Most of the public static methods exposed by the module can be found here.
	 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
	 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
	 * - utils/   Utility stuff.
	 *
	 */
	var extras = {
	    allowStateChanges: allowStateChanges,
	    deepEqual: deepEqual,
	    getAtom: getAtom,
	    getDebugName: getDebugName,
	    getDependencyTree: getDependencyTree,
	    getAdministration: getAdministration,
	    getGlobalState: getGlobalState,
	    getObserverTree: getObserverTree,
	    interceptReads: interceptReads,
	    isComputingDerivation: isComputingDerivation,
	    isSpyEnabled: isSpyEnabled,
	    onReactionError: onReactionError,
	    reserveArrayBuffer: reserveArrayBuffer,
	    resetGlobalState: resetGlobalState,
	    isolateGlobalState: isolateGlobalState,
	    shareGlobalState: shareGlobalState,
	    spyReport: spyReport,
	    spyReportEnd: spyReportEnd,
	    spyReportStart: spyReportStart,
	    setReactionScheduler: setReactionScheduler
	};
	var everything = {
	    Reaction: Reaction,
	    untracked: untracked,
	    Atom: Atom,
	    BaseAtom: BaseAtom,
	    useStrict: useStrict,
	    isStrictModeEnabled: isStrictModeEnabled,
	    spy: spy,
	    comparer: comparer,
	    asReference: asReference,
	    asFlat: asFlat,
	    asStructure: asStructure,
	    asMap: asMap,
	    isModifierDescriptor: isModifierDescriptor,
	    isObservableObject: isObservableObject,
	    isBoxedObservable: isObservableValue,
	    isObservableArray: isObservableArray,
	    ObservableMap: ObservableMap,
	    isObservableMap: isObservableMap,
	    map: map,
	    transaction: transaction,
	    observable: observable,
	    computed: computed,
	    isObservable: isObservable,
	    isComputed: isComputed,
	    extendObservable: extendObservable,
	    extendShallowObservable: extendShallowObservable,
	    observe: observe,
	    intercept: intercept,
	    autorun: autorun,
	    autorunAsync: autorunAsync,
	    when: when,
	    reaction: reaction,
	    action: action,
	    isAction: isAction,
	    runInAction: runInAction,
	    expr: expr,
	    toJS: toJS,
	    createTransformer: createTransformer,
	    whyRun: whyRun,
	    isArrayLike: isArrayLike,
	    extras: extras
	};
	var warnedAboutDefaultExport = false;
	var _loop_1 = function (p) {
	    var val = everything[p];
	    Object.defineProperty(everything, p, {
	        get: function () {
	            if (!warnedAboutDefaultExport) {
	                warnedAboutDefaultExport = true;
	                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
	                    "and won’t work in mobx@4.0.0\n" +
	                    "Use `import * as mobx from 'mobx'` instead");
	            }
	            return val;
	        }
	    });
	};
	for (var p in everything) {
	    _loop_1(p);
	}
	if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
	}
	
	exports.extras = extras;
	exports['default'] = everything;
	exports.Reaction = Reaction;
	exports.untracked = untracked;
	exports.Atom = Atom;
	exports.BaseAtom = BaseAtom;
	exports.useStrict = useStrict;
	exports.isStrictModeEnabled = isStrictModeEnabled;
	exports.spy = spy;
	exports.comparer = comparer;
	exports.asReference = asReference;
	exports.asFlat = asFlat;
	exports.asStructure = asStructure;
	exports.asMap = asMap;
	exports.isModifierDescriptor = isModifierDescriptor;
	exports.isObservableObject = isObservableObject;
	exports.isBoxedObservable = isObservableValue;
	exports.isObservableArray = isObservableArray;
	exports.ObservableMap = ObservableMap;
	exports.isObservableMap = isObservableMap;
	exports.map = map;
	exports.transaction = transaction;
	exports.observable = observable;
	exports.computed = computed;
	exports.isObservable = isObservable;
	exports.isComputed = isComputed;
	exports.extendObservable = extendObservable;
	exports.extendShallowObservable = extendShallowObservable;
	exports.observe = observe;
	exports.intercept = intercept;
	exports.autorun = autorun;
	exports.autorunAsync = autorunAsync;
	exports.when = when;
	exports.reaction = reaction;
	exports.action = action;
	exports.isAction = isAction;
	exports.runInAction = runInAction;
	exports.expr = expr;
	exports.toJS = toJS;
	exports.createTransformer = createTransformer;
	exports.whyRun = whyRun;
	exports.trace = trace;
	exports.isArrayLike = isArrayLike;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(38);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(73);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(282);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(116);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1251);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(592);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1247);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1262);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1248);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1249);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(594);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1250);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(283);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1260);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(599);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1253);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1254);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1258);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(596);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.truncateByDomain = exports.findPositionOfBar = exports.getValueByDataKey = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getBandSizeOfAxis = exports.validateCoordinateInRange = exports.parseSpecifiedDomain = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = undefined;
	
	var _get2 = __webpack_require__(678);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _sortBy2 = __webpack_require__(684);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isArray2 = __webpack_require__(27);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNaN2 = __webpack_require__(1648);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isNumber2 = __webpack_require__(680);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _isString2 = __webpack_require__(681);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _d3Scale = __webpack_require__(158);
	
	var d3Scales = _interopRequireWildcard(_d3Scale);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mathSign = exports.mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	var isPercent = exports.isPercent = function isPercent(value) {
	  return (0, _isString3.default)(value) && value.indexOf('%') === value.length - 1;
	};
	
	var isNumber = exports.isNumber = function isNumber(value) {
	  return (0, _isNumber3.default)(value) && !(0, _isNaN3.default)(value);
	};
	
	var isNumOrStr = exports.isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString3.default)(value);
	};
	
	var idCounter = 0;
	var uniqueId = exports.uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	
	  return '' + (prefix || '') + id;
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	var getPercentValue = exports.getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString3.default)(percent)) {
	    return defaultValue;
	  }
	
	  var value = void 0;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if (isNaN(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([\d]+)$/;
	var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([\d]+)$/;
	
	var parseSpecifiedDomain = exports.parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray3.default)(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	
	  if (isNumber(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	
	    domain[0] = dataDomain[0] - value;
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if (isNumber(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else {
	    domain[1] = dataDomain[1];
	  }
	
	  return domain;
	};
	
	var validateCoordinateInRange = exports.validateCoordinateInRange = function validateCoordinateInRange(coordinate, scale) {
	  if (!scale) {
	    return false;
	  }
	
	  var range = scale.range();
	  var first = range[0];
	  var last = range[range.length - 1];
	  var isValidate = first <= last ? coordinate >= first && coordinate <= last : coordinate >= last && coordinate <= first;
	
	  return isValidate;
	};
	
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	var getBandSizeOfAxis = exports.getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy3.default)(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	
	var getAnyElementOfObject = exports.getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	var hasDuplicate = exports.hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray3.default)(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	var combineEventHandlers = exports.combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler = void 0;
	
	  if ((0, _isFunction3.default)(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction3.default)(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction3.default)(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction3.default)(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	
	      if ((0, _isFunction3.default)(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {String}   options.scale The specified scale type
	 * @param  {String}   options.type  The type of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	var parseScale = exports.parseScale = function parseScale(_ref, chartType) {
	  var scale = _ref.scale,
	      type = _ref.type;
	
	  if (scale === 'auto') {
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return d3Scales.scalePoint();
	    } else if (type === 'category') {
	      return d3Scales.scaleBand();
	    }
	
	    return d3Scales.scaleLinear();
	  } else if ((0, _isString3.default)(scale)) {
	    var name = 'scale' + scale.slice(0, 1).toUpperCase() + scale.slice(1);
	
	    return (d3Scales[name] || d3Scales.scalePoint)();
	  }
	
	  return (0, _isFunction3.default)(scale) ? scale : d3Scales.scalePoint();
	};
	var EPS = 1e-4;
	var checkDomainOfScale = exports.checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	var getValueByDataKey = exports.getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil3.default)(obj) || (0, _isNil3.default)(dataKey)) {
	    return defaultValue;
	  }
	
	  if (isNumOrStr(dataKey)) {
	    return (0, _get3.default)(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction3.default)(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	
	var findPositionOfBar = exports.findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	var truncateByDomain = exports.truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !isNumber(domain[0]) || !isNumber(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	
	  var result = [value[0], value[1]];
	  if (!isNumber(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!isNumber(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.identify = exports.getAllFeatureFlags = exports.FeatureFlag = exports.LaunchDarkly = undefined;
	
	var _utils = __webpack_require__(572);
	
	Object.defineProperty(exports, "getAllFeatureFlags", {
	  enumerable: true,
	  get: function get() {
	    return _utils.getAllFeatureFlags;
	  }
	});
	Object.defineProperty(exports, "identify", {
	  enumerable: true,
	  get: function get() {
	    return _utils.identify;
	  }
	});
	
	var _LaunchDarkly2 = __webpack_require__(1138);
	
	var _LaunchDarkly3 = _interopRequireDefault(_LaunchDarkly2);
	
	var _FeatureFlag2 = __webpack_require__(570);
	
	var _FeatureFlag3 = _interopRequireDefault(_FeatureFlag2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LaunchDarkly = _LaunchDarkly3.default;
	exports.FeatureFlag = _FeatureFlag3.default;

/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 20 */
[1758, 76, 77],
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1087);


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Layer
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ['children', 'className']);
	
	  var layerClass = (0, _classnames2.default)('recharts-layer', className);
	
	  return _react2.default.createElement(
	    'g',
	    _extends({ className: layerClass }, others),
	    children
	  );
	}
	
	Layer.propTypes = propTypes;
	
	exports.default = Layer;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(56);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _iamReactClient = __webpack_require__(689);
	
	var _iamReactClient2 = _interopRequireDefault(_iamReactClient);
	
	var _axios = __webpack_require__(211);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mobx = __webpack_require__(13);
	
	var _index = __webpack_require__(224);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _browserUpdate = __webpack_require__(400);
	
	var _browserUpdate2 = _interopRequireDefault(_browserUpdate);
	
	var _logrocket = __webpack_require__(111);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SettingsStore = __webpack_require__(152);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var obx = (0, _mobx.observable)({
	  modalContent: null,
	  modalLoaded: false,
	  modalSmall: false,
	  lastFocused: null,
	  locale: 'en',
	  logRocketInit: false,
	  highContrast: false,
	  dyslexic: false,
	  hideHeader: false,
	  hideFooter: false,
	  translation: null,
	  translationLoaded: false,
	  userData: {},
	  courseData: {},
	  iam: {},
	  profile: {},
	  impersonateProfile: {},
	  failedCalls: [],
	  loadingCalls: [],
	  loading: false,
	  loadingMessage: null,
	  loadingClass: '',
	  tallyLoad: false,
	  tallySteps: [],
	  hideDrawerClose: false,
	  accountCss: null,
	  validateKey: '',
	  validater: null,
	  backgroundLoadingCalls: [],
	  backgroundLoading: false,
	  hideMsg: false,
	  hasSessionStorage: (0, _helpers.isLocalStorageSupported)(),
	  proctorApproved: false,
	  proctorConnected: false,
	  removeLocalStorage: (0, _mobx.action)(function () {
	    sessionStorage.removeItem('registerData');
	    sessionStorage.removeItem('userData');
	  }),
	  browserUnsupported: false,
	  checkBrowser: (0, _mobx.action)(function () {
	    // Check if browser is supported
	    var _this = this;
	
	    (0, _browserUpdate2.default)({
	      notify: {
	        e: -1,
	        i: 11,
	        f: -1,
	        o: -1,
	        s: -1,
	        c: -1
	      },
	      reminder: 0,
	      unsupported: true,
	      onshow: function onshow() {
	        obx.browserUnsupported = true;
	      }
	    });
	  }),
	  createLoginUrl: (0, _mobx.action)(function (host) {
	    return obx.getParameterByName('account');
	  }),
	  getInstall: (0, _mobx.action)(function (account) {
	    return _config.api.get('/installs/' + account);
	  }),
	  setUserData: (0, _mobx.action)(function (obj) {
	    obx.userData = obj;
	    // Hide Messages icon for Admins & Instructors
	    if (obj && obj.role) {
	      var role = String(obj.role).toLowerCase();
	      obx.hideMsg = role === 'administrator' || role === 'instructor';
	    }
	  }),
	  login: (0, _mobx.action)(function (username, password, callback) {
	    obx.startLoading('Loading…', 'Login');
	    var payload = {
	      username: username, password: password
	    };
	    _config.api.get('/installs/' + obx.createLoginUrl(window.location.host)).then(function (res) {
	      return _config.coreApi.post('/installs/' + res.data.installSid + '/login', payload);
	    }).then(function (response) {
	      obx.userData = response.data;
	
	      if (response.data.requiresMFASetup) {
	        sessionStorage.setItem('mfaUserSid', response.data.userSid);
	        sessionStorage.setItem('mfaInstallSid', response.data.installSid);
	        var account = obx.getParameterByName('account');
	        if (account) {
	          sessionStorage.setItem('mfaAccount', account);
	        }
	        obx.finishLoading('Login');
	        _index.routingStore.push('/account/mfa-setup');
	        return;
	      }
	
	      if (response.data.mfa && response.data.mfa.tempToken) {
	        sessionStorage.setItem('mfaTempToken', response.data.mfa.tempToken);
	        sessionStorage.setItem('mfaInstallSid', response.data.installSid);
	        obx.finishLoading('Login');
	        _index.routingStore.push('/account/mfa-challenge');
	        return;
	      }
	
	      if (response.data.authenticationData) {
	        if (obx.hasSessionStorage) {
	          sessionStorage.setItem('token', response.data.authenticationData.token);
	          sessionStorage.setItem('iam', JSON.stringify(response.data.authenticationData));
	        } else {
	          document.cookie = 'token=' + response.data.authenticationData.token;
	          document.cookie = 'iam=' + JSON.stringify(response.data.authenticationData);
	        }
	      }
	
	      if (obx.hasSessionStorage) {
	        sessionStorage.setItem('userData', JSON.stringify(obx.userData));
	      } else {
	        document.cookie = 'userData=' + JSON.stringify(obx.userData);
	      }
	
	      sessionStorage.removeItem('registerData');
	
	      obx.finishLoading('Login');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  setupMFA: (0, _mobx.action)(function (userSid, installSid, callback) {
	    var payload = { type: 'totp' };
	    _config.coreApi.post('/installs/' + installSid + '/users/' + userSid + '/mfa/setup', payload).then(function (response) {
	      if (callback) {
	        callback(null, response.data);
	      }
	    }).catch(function (error) {
	      if (callback) {
	        callback(error);
	      }
	    });
	  }),
	  verifyMFASetup: (0, _mobx.action)(function (userSid, installSid, code, callback) {
	    var payload = { type: 'totp', code: code };
	    _config.coreApi.post('/installs/' + installSid + '/users/' + userSid + '/mfa/verify', payload).then(function (response) {
	      obx.userData = response.data;
	
	      if (response.data.authenticationData) {
	        if (obx.hasSessionStorage) {
	          sessionStorage.setItem('token', response.data.authenticationData.token);
	          sessionStorage.setItem('iam', JSON.stringify(response.data.authenticationData));
	        } else {
	          document.cookie = 'token=' + response.data.authenticationData.token;
	          document.cookie = 'iam=' + JSON.stringify(response.data.authenticationData);
	        }
	
	        (0, _config.setToken)(response.data.authenticationData.token);
	      }
	
	      if (callback) {
	        callback(null, response.data);
	      }
	    }).catch(function (error) {
	      if (callback) {
	        callback(error);
	      }
	    });
	  }),
	  verifyMFAChallenge: (0, _mobx.action)(function (tempToken, installSid, code, callback) {
	    var payload = { tempToken: tempToken, type: 'totp', code: code };
	    _config.coreApi.post('/installs/' + installSid + '/login/verify', payload).then(function (response) {
	      obx.userData = response.data;
	
	      if (response.data.authenticationData) {
	        if (obx.hasSessionStorage) {
	          sessionStorage.setItem('token', response.data.authenticationData.token);
	          sessionStorage.setItem('iam', JSON.stringify(response.data.authenticationData));
	        } else {
	          document.cookie = 'token=' + response.data.authenticationData.token;
	          document.cookie = 'iam=' + JSON.stringify(response.data.authenticationData);
	        }
	
	        (0, _config.setToken)(response.data.authenticationData.token);
	      }
	
	      if (obx.hasSessionStorage) {
	        sessionStorage.setItem('userData', JSON.stringify(obx.userData));
	      } else {
	        document.cookie = 'userData=' + JSON.stringify(obx.userData);
	      }
	
	      if (callback) {
	        callback(null, response.data);
	      }
	    }).catch(function (error) {
	      if (callback) {
	        callback(error);
	      }
	    });
	  }),
	  logout: (0, _mobx.action)(function () {
	    _config.api.get('logout').then(function (response) {
	      window.location.href = '/#/signed-out';
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  getParameterByName: function getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	  },
	  startLoading: (0, _mobx.action)(function (message, request) {
	    obx.loading = true;
	    obx.loadingMessage = message;
	    obx.loadingCalls.push(request);
	  }),
	  setValidateKey: (0, _mobx.action)(function (key) {
	    obx.validateKey = key;
	  }),
	  createValidate: (0, _mobx.action)(function (key, iam) {
	    if (key !== obx.validateKey) {
	      obx.setValidateKey(key);
	      obx.validater = new _iamReactClient2.default({ iam: iam });
	    }
	  }),
	  alternateModalClose: (0, _mobx.action)(function () {
	    obx.modalContent = null;
	    obx.modalLoaded = false;
	    obx.modalSmall = false;
	    obx.modalShort = false;
	    obx.modalMediumShort = false;
	    obx.modalHeader = null;
	    obx.hideTimes = false;
	
	    // Focus last element (if there was) when closing modal
	    if (obx.lastFocused) {
	      obx.lastFocused.focus();
	      obx.lastFocused = null;
	    }
	  }),
	
	  finishLoading: (0, _mobx.action)(function (request) {
	    var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var requestIndex = obx.loadingCalls.indexOf(request);
	
	    if (failed) {
	      obx.failedCalls.push(request);
	    }
	
	    if (requestIndex >= 0) {
	      obx.loadingCalls.splice(requestIndex, 1);
	    } else {
	      obx.loadingCalls.length = 0;
	    }
	
	    if (obx.loadingCalls.length === 0 || typeof request === 'undefined') {
	      obx.loadingClass = 'leave';
	      obx.loading = false;
	
	      // Wait for loader to fade out before removing
	      setTimeout(function () {
	        obx.loadingClass = '';
	        obx.loadingMessage = null;
	      }, 250);
	    }
	  }),
	  startBackgroundLoading: (0, _mobx.action)(function (request) {
	    obx.backgroundLoading = true;
	    obx.backgroundLoadingCalls.push(request);
	  }),
	  finishBackgroundLoading: (0, _mobx.action)(function (request) {
	    var requestIndex = obx.backgroundLoadingCalls.indexOf(request);
	
	    if (requestIndex >= 0) {
	      obx.backgroundLoadingCalls.splice(requestIndex, 1);
	    } else {
	      obx.backgroundLoadingCalls.length = 0;
	    }
	
	    if (obx.backgroundLoadingCalls.length === 0 || typeof request === 'undefined') {
	      obx.backgroundLoading = false;
	    }
	  }),
	  // Time zones
	  timezoneList: [],
	  userTimezone: 'America/Chicago',
	  getTimezones: (0, _mobx.action)(function (data) {
	    obx.startLoading('Loading…', 'TimeZones');
	
	    _config.api.get('/timeZones').then(function (response) {
	      obx.timezoneList = response.data.results;
	
	      if (obx.profile && obx.profile.timeZoneSid) {
	        obx.getUserTimezone();
	      }
	
	      obx.finishLoading('TimeZones');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  getUserTimezone: (0, _mobx.action)(function () {
	    var filteredTZ = obx.timezoneList.filter(function (tz) {
	      return tz.sid === obx.profile.timeZoneSid;
	    });
	
	    obx.userTimezone = filteredTZ[0].name;
	    obx.userOffset = _moment2.default.tz.zone(obx.userTimezone).utcOffset((0, _moment2.default)());
	    obx.machineTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	
	    if (obx.machineTimezone) {
	      obx.machineOffset = _moment2.default.tz.zone(obx.machineTimezone).utcOffset((0, _moment2.default)());
	
	      obx.filteredMachineTimezone = obx.timezoneList.filter(function (tz) {
	        return tz.name === obx.machineTimezone;
	      });
	
	      if (obx.machineOffset !== obx.userOffset) {
	        obx.notice = true;
	        obx.noticeContent.body = 'Your time zone is set to ' + obx.userTimezone + ', but it looks like you are in ' + obx.machineTimezone + '.';
	        obx.noticeContent.linkText = 'Update Time Zone';
	        obx.noticeContent.linkUrl = '#update-timezone';
	      } else {
	        obx.notice = false;
	      }
	    }
	  }),
	  // Current time
	  currentTime: null,
	  getCurrentTime: (0, _mobx.action)(function (backgroundLoad) {
	    if (!backgroundLoad) {
	      obx.startLoading('Loading…', 'CurrentTime');
	    }
	
	    _config.api.get('/currentTime').then(function (response) {
	      obx.currentTime = response.data.currentTime;
	
	      if (!backgroundLoad) {
	        obx.finishLoading('CurrentTime');
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  returnCurrentTime: (0, _mobx.action)(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	    var response;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _config.api.get('/currentTime');
	
	          case 2:
	            response = _context.sent;
	            return _context.abrupt('return', response.data.currentTime);
	
	          case 4:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }))),
	  // Currencies
	  currencyList: [],
	  getCurrencies: (0, _mobx.action)(function (data) {
	    obx.startLoading('Loading…', 'Currencies');
	
	    _config.api.get('/currencies').then(function (response) {
	      obx.currencyList = response.data.results;
	      obx.finishLoading('Currencies');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  accountList: [],
	  getAccounts: (0, _mobx.action)(function (data) {
	    obx.startLoading('Loading…', 'Accounts');
	
	    _config.api.get('/accounts').then(function (response) {
	      obx.accountList = response.data.results;
	      obx.finishLoading('Accounts');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  proctorTypeList: [],
	  getProctorTypes: (0, _mobx.action)(function () {
	    obx.startLoading('Loading…', 'ProctorTypes');
	
	    _config.api.get('/proctors/categories?selfSelection=all').then(function (response) {
	      obx.proctorTypeList = response.data.results;
	      obx.finishLoading('ProctorTypes');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  proctorGroupTypes: [],
	  getProctorGroupTypes: (0, _mobx.action)(function () {
	    // Get proctor types that are assigned to proctor groups
	    obx.startLoading('Loading…', 'GetProctorGroupTypes');
	
	    var assignedTypes = [];
	
	    _config.api.get('installs/' + obx.userData.installSid + '/proctorGroup').then(function (response) {
	      response.data.results.forEach(function (group) {
	        if (group.proctorTypes.length > 0) {
	          group.proctorTypes.forEach(function (typeSid) {
	            assignedTypes.push(typeSid);
	          });
	        }
	      });
	
	      // Remove duplicates and assign the array to the store
	      obx.proctorGroupTypes = assignedTypes.filter(function (item, index) {
	        return assignedTypes.indexOf(item) === index;
	      });
	
	      obx.finishLoading('GetProctorGroupTypes');
	
	      obx.getFilteredProctorTypes(true);
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  getFilteredProctorTypes: (0, _mobx.action)(function (filterByProctorGroup) {
	    obx.startLoading('Loading…', 'FilteredProductTypes');
	
	    // Get allowed proctor types from install settings
	    var allowedTypes = [];
	
	    _config.api.get('installs/' + obx.userData.installSid + '/settings').then(function (response) {
	      response.data.proctorTypes.forEach(function (type) {
	        if (type.proctorTypeSubCategorySid) {
	          var typeObject = {
	            sid: type.proctorTypeSubCategorySid,
	            status: type.status
	          };
	
	          allowedTypes.push(typeObject);
	        }
	      });
	
	      obx.filterProctors(allowedTypes, filterByProctorGroup);
	      obx.finishLoading('FilteredProductTypes');
	    });
	  }),
	  // Get all proctor types and filter to only get allowed ones
	  filterProctors: (0, _mobx.action)(function (allowedTypes, filterByProctorGroup) {
	    obx.startLoading('Loading…', 'AllProctorTypes');
	
	    _config.api.get('/proctors/categories?selfSelection=all').then(function (response) {
	      doFilter(response.data.results, allowedTypes);
	      obx.finishLoading('AllProctorTypes');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	
	    function doFilter(allTypes, allowedTypes) {
	      var filteredTypes = [];
	
	      allTypes.map(function (key, i) {
	        key.subCategories.filter(function (obj) {
	          for (var k = 0; k < allowedTypes.length; k++) {
	            if (allowedTypes[k].sid === obj.sid) {
	              return true;
	            }
	          }
	
	          return false;
	        }).map(function (subKey, j) {
	          if (filteredTypes.indexOf(key) < 0) {
	            key.subCategories = [];
	            filteredTypes.push(key);
	          }
	
	          for (var k = 0; k < allowedTypes.length; k++) {
	            if (allowedTypes[k].sid === subKey.sid) {
	              subKey.status = allowedTypes[k].status;
	            }
	          }
	
	          var keyIndex = filteredTypes.indexOf(key);
	          filteredTypes[keyIndex].subCategories.push(subKey);
	
	          return true;
	        });
	
	        return true;
	      });
	
	      // If specified, filter the results further to only show those that are
	      // assigned to a proctor group
	      if (filterByProctorGroup) {
	        filteredTypes.forEach(function (parentType) {
	          if (parentType.subCategories.length > 0) {
	            parentType.subCategories.forEach(function (subType) {
	              var subTypeIndex = parentType.subCategories.indexOf(subType);
	
	              if (obx.proctorGroupTypes.indexOf(subType.sid) <= -1) {
	                parentType.subCategories.splice(subTypeIndex, 1);
	              }
	            });
	          }
	        });
	      }
	
	      obx.proctorTypeList = filteredTypes;
	    }
	  }),
	
	  sessionConfigurations: [],
	  getSessionConfigurations: (0, _mobx.action)(function () {
	    obx.startLoading('Loading…', 'SessionConfigurations');
	
	    _config.api.get('installs/' + obx.userData.installSid + '/sessionConfigurations').then(function (response) {
	      obx.sessionConfigurations = response.data.results;
	      obx.finishLoading('SessionConfigurations');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	
	  updateLocale: (0, _mobx.action)(function (locale) {
	    obx.locale = locale;
	    obx.getTranslation(locale);
	  }),
	  dialog: false,
	  dialogContent: {
	    heading: null,
	    body: null,
	    button: null
	  },
	  dialogCallback: null,
	  confirm: false,
	  confirmContent: {
	    heading: null,
	    body: null,
	    data: null,
	    cancel: null,
	    button: null
	  },
	  confirmCallback: null,
	  prompt: false,
	  promptContent: {
	    heading: null,
	    body: null,
	    options: null,
	    button: null
	  },
	  promptSelectFunc: null,
	  promptCallback: null,
	  throwError: (0, _mobx.action)(function (error) {
	    obx.finishLoading();
	    obx.finishBackgroundLoading();
	
	    console.error(error);
	
	    if (typeof error.response !== 'undefined') {
	      // API errors will return an error object with a response
	      // which means we have a message for them
	      obx.showError(error.response.data);
	    } else {
	      // If there’s no response with the error, it’s a server
	      // connection error (i.e. axios can’t reach the URL)
	      obx.showError();
	    }
	
	    obx.tallyLoad = false;
	    obx.tallySteps = [];
	  }),
	  notice: false,
	  noticeContent: {
	    body: null,
	    linkText: null,
	    linkUrl: null
	  },
	  expireWarning: false,
	  expireSession: (0, _mobx.action)(function () {
	    window.location.href = '/#/session-expired';
	  }),
	  showExpireWarning: (0, _mobx.action)(function () {
	    obx.expireWarning = true;
	  }),
	  removeExpireWarning: (0, _mobx.action)(function () {
	    obx.expireWarning = false;
	  }),
	  extendSession: (0, _mobx.action)(function (callback) {
	    var headers = {};
	
	    if (obx.hasSessionStorage) {
	      headers = {
	        'token': sessionStorage.getItem('token')
	      };
	    } else {
	      headers = {
	        'token': (0, _helpers.getCookie)('token')
	      };
	    }
	
	    _config.api.get('/check', { headers: headers }).then(function (response) {
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  showDialog: (0, _mobx.action)(function (content) {
	    if (content) {
	      obx.dialogContent = content;
	    }
	
	    obx.dialog = true;
	
	    // Focus the confirmation dialog for screen readers
	    setTimeout(function () {
	      var dialogMsg = document.querySelector('.dialog__msg');
	
	      if (dialogMsg) {
	        dialogMsg.focus();
	      }
	    });
	  }),
	  showError: (0, _mobx.action)(function (data) {
	    obx.dialog = true;
	    obx.dialogContent.heading = obx.translation.Errors.heading;
	    obx.dialogContent.button = obx.translation.Errors.button;
	
	    // Server error (no data present because API didn’t return anything)
	    if (!data) {
	      obx.dialogContent.body = obx.translation.Errors[1301].message;
	    } else {
	      // API returned data
	      if (typeof obx.translation.Errors[data.code] !== 'undefined') {
	        if (data.code !== '1380') {
	          obx.dialogContent.body = obx.translation.Errors[data.code].message;
	        } else {
	          var startDate = data.message.match(/'(.*?)'/g)[0];
	          var endDate = data.message.match(/'(.*?)'/g)[1];
	
	          obx.dialogContent.body = obx.translation.Errors[data.code].message.replace('%startDate%', (0, _moment2.default)(startDate).tz(obx.userTimezone).format('M/D/YYYY [at] h:mma z')).replace('%endDate%', (0, _moment2.default)(endDate).tz(obx.userTimezone).format('M/D/YYYY [at] h:mma z'));
	        }
	      } else {
	        console.warn('Error code not present in translation file. Falling back to API response message');
	        obx.dialogContent.body = data.message;
	      }
	    }
	
	    if (data && data.code === '5002') {
	      window.location.href = '/#/session-expired';
	    }
	  }),
	  showConfirm: (0, _mobx.action)(function (msg, func) {
	    obx.confirm = true;
	    obx.confirmContent.heading = msg.heading;
	    obx.confirmContent.body = msg.body;
	
	    if (msg.data) {
	      obx.confirmContent.data = msg.data;
	    }
	
	    if (msg.cancel) {
	      obx.confirmContent.cancel = msg.cancel;
	    }
	
	    obx.confirmContent.button = msg.button;
	    obx.confirmCallback = func;
	
	    // Focus the confirmation dialog for screen readers
	    setTimeout(function () {
	      var dialogMsg = document.querySelector('.dialog__msg');
	
	      if (dialogMsg) {
	        dialogMsg.focus();
	      }
	    });
	  }),
	  showPrompt: (0, _mobx.action)(function (msg, selectFunc, callback, text) {
	    obx.prompt = true;
	    obx.promptContent.heading = msg.heading;
	    obx.promptContent.body = msg.body;
	    obx.promptContent.options = msg.options;
	    obx.promptContent.button = msg.button;
	    obx.promptSelectFunc = selectFunc;
	    obx.promptCallback = callback;
	
	    if (msg.input) {
	      obx.promptContent.input = msg.input;
	    }
	
	    if (text) {
	      obx.promptText = text;
	    }
	
	    // Focus the prompt dialog for screen readers
	    setTimeout(function () {
	      var dialogMsg = document.querySelector('.dialog__msg');
	
	      if (dialogMsg) {
	        dialogMsg.focus();
	      }
	    });
	  }),
	  closeDialog: (0, _mobx.action)(function () {
	    obx.expireWarning = false;
	    obx.dialog = false;
	    obx.confirm = false;
	    obx.confirmContent.data = null;
	    obx.confirmContent.cancel = null;
	    obx.prompt = false;
	    obx.promptContent.options = null;
	
	    // Focus the confirmation main content element
	    setTimeout(function () {
	      var main = document.querySelector('#main-content');
	
	      if (main) {
	        main.focus();
	      }
	    });
	
	    // If a dialog callback has been defined
	    if (obx.dialogCallback) {
	      obx.dialogCallback();
	      obx.dialogCallback = null;
	    }
	  }),
	  confirmFunc: (0, _mobx.action)(function () {
	    obx.confirm = false;
	    if (obx.confirmCallback) {
	      obx.confirmCallback();
	    }
	  }),
	  promptFunc: (0, _mobx.action)(function () {
	    obx.prompt = false;
	    if (obx.promptCallback) {
	      obx.promptCallback();
	    }
	  }),
	  getTranslation: (0, _mobx.action)(function (locale) {
	    obx.translationLoaded = true;
	
	    var timestamp = new Date().getTime();
	
	    _axios2.default.get('./json/' + locale + '.json?t=' + timestamp).then(function (response) {
	      obx.translation = response.data.content;
	    });
	  }),
	  checkToken: (0, _mobx.action)(function () {
	    obx.startLoading('Loading…', 'CheckToken');
	
	    var headers = {};
	
	    if (obx.hasSessionStorage) {
	      headers = {
	        'token': sessionStorage.getItem('token')
	      };
	    } else {
	      headers = {
	        'token': (0, _helpers.getCookie)('token')
	      };
	    }
	
	    Promise.all([_config.api.get('/check', { headers: headers }), _config.api.get('/permissions', { headers: headers })]).then(function (arr) {
	      if (obx.hasSessionStorage) {
	        sessionStorage.setItem('userData', JSON.stringify(arr[0].data));
	        sessionStorage.setItem('iam', JSON.stringify(arr[1].data));
	      } else {
	        document.cookie = 'userData=' + JSON.stringify(arr[0].data);
	        document.cookie = 'iam=' + JSON.stringify(arr[1].data);
	      }
	
	      obx.userData = arr[0].data;
	      // Hide Messages icon for Admins & Instructors
	      if (obx.userData && obx.userData.role) {
	        var role = String(obx.userData.role).toLowerCase();
	        obx.hideMsg = role === 'administrator' || role === 'instructor';
	      }
	      obx.iam = arr[1].data;
	
	      if (obx.userData && obx.userData.role && obx.userData.role.toLowerCase() !== 'administrator') {
	        obx.getCourseData();
	      }
	
	      obx.getSettings();
	      obx.finishLoading('CheckToken');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  getCourseData: (0, _mobx.action)(function (sid, backgroundLoad) {
	    if (!backgroundLoad) {
	      obx.startLoading('Loading…', 'GetCourseData');
	    } else {
	      obx.startBackgroundLoading('GetCourseData');
	    }
	
	    var courseSid = null;
	
	    if (sid) {
	      courseSid = sid;
	    } else {
	      courseSid = obx.userData.courseSid;
	    }
	
	    _config.api.get('/installs/' + obx.userData.installSid + '/courses/' + courseSid).then(function (response) {
	      obx.courseData = response.data;
	
	      if (obx.hasSessionStorage) {
	        sessionStorage.setItem('courseData', JSON.stringify(response.data));
	      } else {
	        document.cookie = 'courseData=' + JSON.stringify(response.data);
	      }
	
	      if (!backgroundLoad) {
	        obx.finishLoading('GetCourseData');
	      } else {
	        obx.finishBackgroundLoading('GetCourseData');
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  getProfile: (0, _mobx.action)(function (sid, impersonate, component, callback) {
	    obx.startLoading('Loading…', 'GetProfile');
	
	    var userSid = obx.userData.userSid;
	
	    if (sid) {
	      userSid = sid;
	    }
	
	    _config.api.get('/installs/' + obx.userData.installSid + '/users/' + userSid + '/profile').then(function (response) {
	      obx.finishLoading('GetProfile');
	      if (!impersonate) {
	        var gtag = function gtag() {
	          window.dataLayer.push(arguments);
	        };
	
	        obx.profile = response.data;
	
	        _SettingsStore2.default.userSettings = response.data;
	
	        // Set LogRocket identity data
	        if (obx.userData.enrollmentSid) {
	          // Enrollment data (student or instructor)
	          _logrocket2.default.identify(obx.userData.enrollmentSid, {
	            name: obx.profile.lastName + ', ' + obx.profile.firstName,
	            email: obx.profile.email,
	            role: obx.userData.role,
	            userSid: obx.userData.userSid,
	            enrollmentSid: obx.userData.enrollmentSid,
	            courseSid: obx.userData.courseSid,
	            installSid: obx.userData.installSid,
	            integrationSid: obx.userData.integrationSid,
	            deploymentSid: obx.userData.deploymentSid,
	            appInstallName: obx.userData.smarterProctoring.appInstallName,
	            applicationSid: obx.userData.applicationSid || obx.userData.smarterProctoring.applicationSid
	          });
	        } else {
	          // User data (admin)
	          _logrocket2.default.identify(obx.userData.userSid, {
	            name: obx.profile.lastName + ', ' + obx.profile.firstName,
	            email: obx.profile.email,
	            role: obx.userData.role,
	            userSid: obx.userData.userSid,
	            installSid: obx.userData.installSid,
	            integrationSid: obx.userData.integrationSid,
	            deploymentSid: obx.userData.deploymentSid
	            // appInstallName: obx.userData.smarterProctoring.appInstallName,
	            // applicationSid: obx.userData.smarterProctoring.applicationSid
	          });
	        }
	
	        // Set Cobrowse identity data
	        if (window.CobrowseIO && ("production")) {
	          window.CobrowseIO.customData = {
	            name: obx.profile.lastName + ', ' + obx.profile.firstName,
	            user_email: obx.profile.email,
	            role: obx.userData.role,
	            userSid: obx.userData.userSid,
	            installSid: obx.userData.installSid,
	            integrationSid: obx.userData.integrationSid,
	            deploymentSid: obx.userData.deploymentSid,
	            enrollmentSid: obx.userData.enrollmentSid ? obx.userData.enrollmentSid : 'N/A'
	          };
	        }
	
	        // Set up Google Analytics
	        var gaTrackingId = null;
	
	        if (obx.userData.enrollmentSid) {
	          // Course tracking
	          gaTrackingId = _config.config.gaCourse;
	        } else {
	          // Admin tracking
	          gaTrackingId = _config.config.gaAdmin;
	        }
	
	        var gaScript = document.createElement('script');
	        gaScript.id = 'ga-script';
	        gaScript.type = 'text/javascript';
	        gaScript.async = true;
	        gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaTrackingId;
	
	        // Append Google Analytics script
	        document.body.appendChild(gaScript);
	
	        // Config Google Analtyics
	        window.dataLayer = window.dataLayer || [];
	
	        gtag('js', new Date());
	
	        // Add installSid dimension
	        gtag('config', gaTrackingId, {
	          'custom_map': { 'dimension1': 'installSid' }
	        });
	
	        gtag('event', 'installSid', { 'installSid': obx.userData.installSid });
	
	        // Add role dimension
	        gtag('config', gaTrackingId, {
	          'custom_map': { 'dimension2': 'role' }
	        });
	
	        gtag('event', 'role', { 'role': obx.userData.role });
	
	        // Initialize Google Analytics
	        gtag('config', gaTrackingId);
	
	        // Create tracker
	        var gaDelay = setInterval(function () {
	          if (window.ga) {
	            clearInterval(gaDelay);
	            window.ga('create', gaTrackingId, 'auto');
	          }
	        }, 100);
	
	        // Set up Countly
	        if (obx.userData.role && obx.userData.role.toLowerCase() === 'administrator') {
	          var ctScript = document.createElement('script');
	          ctScript.id = 'countly-script';
	          ctScript.type = 'text/javascript';
	          ctScript.async = true;
	          ctScript.src = 'https://cdn.jsdelivr.net/npm/countly-sdk-web@latest/lib/countly.min.js';
	
	          ctScript.onload = function () {
	            var Countly = window.Countly;
	
	            Countly.init({
	              app_key: 'eb3a5afccf801c45e82fd2366688f490df0b9df5',
	              url: '//try.count.ly'
	            });
	
	            Countly.track_sessions();
	            Countly.track_pageview();
	
	            Countly.q.push(['user_details', {
	              'name': obx.profile.firstName + ' ' + obx.profile.lastName,
	              'email': obx.profile.email,
	              'organization': obx.userData.smarterProctoring ? obx.userData.smarterProctoring.appInstallName : obx.userData.installSid,
	              'phone': obx.profile.mobilePhone || '',
	              'custom': {
	                'installSid': obx.userData.installSid,
	                'userSid': obx.userData.userSid,
	                'role': obx.userData.role,
	                'deploymentSid': obx.userData.deploymentSid,
	                'enrollmentSid': obx.userData.enrollmentSid || '',
	                'integrationSid': obx.userData.integrationSid,
	                'courseSid': obx.userData.courseSid || '',
	                'timeZone': obx.userData.userTimezone
	              }
	            }]);
	
	            Countly.q.push(['track_pageview', location.pathname + location.hash]);
	
	            window.addEventListener('hashchange', function () {
	              Countly.q.push(['track_pageview', location.pathname + location.hash]);
	            });
	          };
	
	          document.body.appendChild(ctScript);
	        }
	      } else {
	        obx.impersonateProfile = response.data;
	
	        if (component) {
	          var _location = {
	            latitude: response.data.latitude,
	            longitude: response.data.longitude
	          };
	
	          component.setState({
	            location: _location
	          });
	
	          if (callback) {
	            callback();
	          }
	        }
	      }
	
	      // if(response.data.smarterId === null && obx.userData.role.toLowerCase() === 'learner' && obx.settings.smarterIdEnabled) {
	      //   // If SmarterID value is null, create new user in SmarterID
	      //   SmarterIDStore.createSIDUser();
	      // } else if(obx.userData.role.toLowerCase() === 'learner' && obx.settings.smarterIdEnabled) {
	      //   // Check if the user has an enrollment in SmarterID
	      //   SmarterIDStore.checkSIDEnrollment();
	      // }
	
	      if (obx.userData.role.toLowerCase() === 'instructor') {
	        // If this is an instructor, get and store the integration data
	        // so it can be used to impersonate students
	        _SettingsStore2.default.getIntegration(obx.userData.integrationSid);
	      } else if (obx.userData.role.toLowerCase() === 'administrator') {
	        // Otherwise, if this is an administrator, check how many
	        // integrations there are. If there is only one, store
	        // the data so it can be used to impersonate students
	        var _callback = function _callback(response) {
	          if (response.data.results.length === 1) {
	            _SettingsStore2.default.integration = response.data.results[0];
	          }
	        };
	
	        _SettingsStore2.default.getIntegrations(_callback);
	      }
	
	      // If user is an administrator or instructor, get the institution settings
	      if (obx.userData.role.toLowerCase() === 'administrator' || obx.userData.role.toLowerCase() === 'instructor') {
	        _SettingsStore2.default.getInstituteSettings();
	      }
	
	      // Get list of time zones
	      obx.getTimezones();
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  // Get install settings to check if SmarterID is enabled
	  settings: {},
	  getSettings: (0, _mobx.action)(function () {
	    obx.startLoading('Loading…', 'GetInstallSettings');
	
	    _config.api.get('/installs/' + obx.userData.installSid + '/settings').then(function (response) {
	      obx.settings = response.data;
	      obx.finishLoading('GetInstallSettings');
	      obx.getProfile();
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  checkProfile: (0, _mobx.action)(function () {
	    // If this is a student and they do not have all of their
	    // required profile information completed, redirect them
	    var sessionInstallSid = sessionStorage.getItem('installSid');
	    var isDMV = _config.config.dmvInstallSids.includes(sessionInstallSid);
	
	    if (typeof obx.userData.role !== 'undefined' && obx.userData.role.toLowerCase() === 'learner' && (!obx.profile.latitude || !obx.profile.longitude || !obx.profile.timeZoneSid || !obx.profile.currencyCode) && _index.routingStore.location.pathname !== '/enroll' && _index.routingStore.location.pathname !== '/session-start' && _index.routingStore.location.pathname !== '/session-start/' && isDMV !== true) {
	      _index.routingStore.push({
	        pathname: '/enroll'
	      });
	    }
	
	    // If there is an entry point in the user data,
	    // check if the entry point has already been stored.
	    // If it has not, redirect to the entry point.
	    if (obx.userData.ui && (obx.userData.ui.entry_point || obx.userData.ui.entryPoint)) {
	      var storedEntryPoint = null;
	      var entryPoint = null;
	
	      if (obx.userData.ui.entry_point) {
	        entryPoint = obx.userData.ui.entry_point;
	      } else {
	        entryPoint = obx.userData.ui.entryPoint;
	      }
	
	      if (obx.hasSessionStorage) {
	        storedEntryPoint = sessionStorage.getItem('entryPoint');
	      } else {
	        storedEntryPoint = (0, _helpers.getCookie)('entryPoint');
	      }
	
	      if (!storedEntryPoint && _index.routingStore.location.pathname !== '/enroll') {
	        // Redirect if enrollment is not required
	        obx.redirectToEntryPoint(entryPoint);
	      } else if (!storedEntryPoint && _index.routingStore.location.pathname === '/enroll') {
	        // Otherwise, if enrollment is required, redirect afterward
	        obx.afterEnroll = entryPoint;
	      }
	    }
	  }),
	  afterEnroll: '/',
	  redirectToEntryPoint: (0, _mobx.action)(function (entryPoint) {
	    if (obx.hasSessionStorage) {
	      sessionStorage.setItem('entryPoint', entryPoint);
	    } else {
	      document.cookie = 'entryPoint=' + entryPoint;
	    }
	
	    switch (entryPoint) {
	      case 'choose_exam':
	        if (obx.userData.ui.sid) {
	          _index.routingStore.push({
	            pathname: 'schedule-session/group/' + obx.userData.ui.sid
	          });
	        }
	
	        break;
	
	      default:
	        if (obx.userData.ui.sid) {
	          _index.routingStore.push({
	            pathname: 'schedule-session/group/' + obx.userData.ui.sid
	          });
	        }
	
	        break;
	    }
	  }),
	  unreadCount: 0,
	  getUnreadCount: (0, _mobx.action)(function (backgroundLoad, notify, content, link) {
	    if (!backgroundLoad) {
	      obx.startLoading('Loading…', 'GetUnreadCount');
	    }
	
	    if (obx.userData.courseSid) {
	      _config.api.get('/messages/counts?userSid=' + obx.userData.userSid + '&courseSid=' + obx.userData.courseSid).then(function (response) {
	        var newCount = parseInt(response.data.unread, 10);
	
	        if (notify === true && newCount > obx.unreadCount) {
	          obx.showNotification(content, link);
	        }
	
	        obx.unreadCount = newCount;
	
	        if (!backgroundLoad) {
	          obx.finishLoading('GetUnreadCount');
	        }
	      }).catch(function (error) {
	        obx.throwError(error);
	      });
	    } else {
	      _config.api.get('/messages/counts?userSid=' + obx.userData.userSid).then(function (response) {
	        var newCount = parseInt(response.data.unread, 10);
	
	        if (notify === true && newCount > obx.unreadCount) {
	          obx.showNotification(content, link);
	        }
	
	        obx.unreadCount = newCount;
	
	        if (!backgroundLoad) {
	          obx.finishLoading('GetUnreadCount');
	        }
	      }).catch(function (error) {
	        obx.throwError(error);
	      });
	    }
	  }),
	  notification: false,
	  notificationContent: null,
	  notificationLink: null,
	  notificationClass: null,
	  notificationDuration: 10000,
	  showNotification: (0, _mobx.action)(function (content, link) {
	    if (content) {
	      obx.notificationContent = content;
	    }
	
	    if (link) {
	      obx.notificationLink = link;
	    }
	
	    obx.notification = true;
	  }),
	  closeNotification: (0, _mobx.action)(function () {
	    obx.notification = false;
	    obx.notificationContent = null;
	    obx.notificationLink = null;
	    obx.notificationDuration = 10000;
	  }),
	  showToaster: (0, _mobx.action)(function (content, type) {
	    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	    var modifier = arguments[3];
	
	    if (content) {
	      obx.notificationContent = content;
	    }
	
	    if (type === 'success') {
	      obx.notificationClass = 'notify--success';
	    }
	    if (type === 'warning') {
	      obx.notificationClass = 'notify--warning';
	    }
	    if (type === 'error') {
	      obx.notificationClass = 'notify--error';
	    }
	
	    if (modifier) {
	      obx.notificationClass += ' ' + modifier;
	    }
	
	    obx.notificationDuration = duration;
	    obx.notification = true;
	  }),
	
	  /**
	   * getExtensionInfo
	   */
	  extensionInfo: null,
	
	  getExtensionInfo: (0, _mobx.action)(function () {
	    var timestamp = new Date().getTime();
	    _axios2.default.get(_config.config.extensionManifestUrl + '?t=' + timestamp).then(function (response) {
	      obx.extensionInfo = response.data;
	
	      if (localStorage.getItem('extensionId')) {
	        obx.extensionInfo.extensionId = localStorage.getItem('extensionId');
	      } else if (_config.config.extensionId) {
	        obx.extensionInfo.extensionId = _config.config.extensionId;
	      }
	    });
	  }),
	
	  /**
	   * Boolean to check if we connected to the desktop app
	   */
	  desktopAppConnected: false,
	
	  /**
	   * Boolean to check if we connected to the desktop app
	   */
	  desktopAppRequestLoading: false,
	
	  /**
	   * Post to the desktop app the exam session info
	   */
	  connectWithDesktopApp: (0, _mobx.action)(function (token, sessionSid, installSid, examSid) {
	    // Set we are loading so we do not request multiple
	    obx.desktopAppRequestLoading = true;
	    _axios2.default.post(_config.config.desktopAppBaseUrl + '/accept/' + token + '/' + sessionSid + '/' + installSid + '/' + examSid).then(function (response) {
	      console.log('response', response);
	      obx.desktopAppConnected = true;
	    }).catch(function (e) {
	      console.log('desktop app error', e);
	      obx.desktopAppRequestLoading = false;
	    });
	  }),
	
	  /**
	   * Post to the desktop app to close all the running apps
	   */
	  desktopAppCloseBlockedApps: (0, _mobx.action)(function (done) {
	    // Using the callback to set the loading in the component state
	    // when i was trying to use a property of the store and updating that did not seem to work
	    _axios2.default.post(_config.config.desktopAppBaseUrl + '/close-blocked-applications').then(function (response) {
	      done();
	    }).catch(function (e) {
	      console.log('desktopAppCloseBlockedApps error');
	      console.error(e.message);
	      done();
	    });
	  }),
	
	  /**
	   * Calculator type (controls ClassCalc rendering)
	   */
	  calculator: null
	});
	
	exports.default = obx;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _AddAccount = __webpack_require__(830);
	
	var _AddAccount2 = _interopRequireDefault(_AddAccount);
	
	var _AddFundingRule = __webpack_require__(789);
	
	var _AddFundingRule2 = _interopRequireDefault(_AddFundingRule);
	
	var _FundingRules = __webpack_require__(353);
	
	var _FundingRules2 = _interopRequireDefault(_FundingRules);
	
	var _ApproveProctor = __webpack_require__(761);
	
	var _ApproveProctor2 = _interopRequireDefault(_ApproveProctor);
	
	var _AssignProctor = __webpack_require__(762);
	
	var _AssignProctor2 = _interopRequireDefault(_AssignProctor);
	
	var _ExamException = __webpack_require__(787);
	
	var _ExamException2 = _interopRequireDefault(_ExamException);
	
	var _EnrollmentException = __webpack_require__(784);
	
	var _EnrollmentException2 = _interopRequireDefault(_EnrollmentException);
	
	var _EditProctor = __webpack_require__(763);
	
	var _EditProctor2 = _interopRequireDefault(_EditProctor);
	
	var _ProctorDetails = __webpack_require__(765);
	
	var _ProctorDetails2 = _interopRequireDefault(_ProctorDetails);
	
	var _IncidentReport = __webpack_require__(764);
	
	var _IncidentReport2 = _interopRequireDefault(_IncidentReport);
	
	var _ScheduleOnline = __webpack_require__(865);
	
	var _ScheduleOnline2 = _interopRequireDefault(_ScheduleOnline);
	
	var _ScheduleHybrid = __webpack_require__(862);
	
	var _ScheduleHybrid2 = _interopRequireDefault(_ScheduleHybrid);
	
	var _ScheduleInstructor = __webpack_require__(863);
	
	var _ScheduleInstructor2 = _interopRequireDefault(_ScheduleInstructor);
	
	var _ScheduleRB = __webpack_require__(866);
	
	var _ScheduleRB2 = _interopRequireDefault(_ScheduleRB);
	
	var _ScheduleMessaging = __webpack_require__(864);
	
	var _ScheduleMessaging2 = _interopRequireDefault(_ScheduleMessaging);
	
	var _ScheduleVTC = __webpack_require__(867);
	
	var _ScheduleVTC2 = _interopRequireDefault(_ScheduleVTC);
	
	var _ScheduleAutomated = __webpack_require__(372);
	
	var _ScheduleAutomated2 = _interopRequireDefault(_ScheduleAutomated);
	
	var _SessionDetail = __webpack_require__(368);
	
	var _SessionDetail2 = _interopRequireDefault(_SessionDetail);
	
	var _SessionStartAutomated = __webpack_require__(220);
	
	var _SessionStartAutomated2 = _interopRequireDefault(_SessionStartAutomated);
	
	var _SessionStartBV = __webpack_require__(868);
	
	var _SessionStartBV2 = _interopRequireDefault(_SessionStartBV);
	
	var _SessionStartExamity = __webpack_require__(869);
	
	var _SessionStartExamity2 = _interopRequireDefault(_SessionStartExamity);
	
	var _SessionStartHybrid = __webpack_require__(844);
	
	var _SessionStartHybrid2 = _interopRequireDefault(_SessionStartHybrid);
	
	var _SessionStartProctorU = __webpack_require__(870);
	
	var _SessionStartProctorU2 = _interopRequireDefault(_SessionStartProctorU);
	
	var _SessionStartVTC = __webpack_require__(871);
	
	var _SessionStartVTC2 = _interopRequireDefault(_SessionStartVTC);
	
	var _StepIn = __webpack_require__(883);
	
	var _StepIn2 = _interopRequireDefault(_StepIn);
	
	var _Review = __webpack_require__(374);
	
	var _Review2 = _interopRequireDefault(_Review);
	
	var _SupportTicketDetail = __webpack_require__(875);
	
	var _SupportTicketDetail2 = _interopRequireDefault(_SupportTicketDetail);
	
	var _AddSupportTicket = __webpack_require__(874);
	
	var _AddSupportTicket2 = _interopRequireDefault(_AddSupportTicket);
	
	var _VoucherList = __webpack_require__(376);
	
	var _VoucherList2 = _interopRequireDefault(_VoucherList);
	
	var _AddVoucher = __webpack_require__(375);
	
	var _AddVoucher2 = _interopRequireDefault(_AddVoucher);
	
	var _EditVoucher = __webpack_require__(885);
	
	var _EditVoucher2 = _interopRequireDefault(_EditVoucher);
	
	var _LocateProctor = __webpack_require__(354);
	
	var _LocateProctor2 = _interopRequireDefault(_LocateProctor);
	
	var _SelectProctor = __webpack_require__(797);
	
	var _SelectProctor2 = _interopRequireDefault(_SelectProctor);
	
	var _ReportFilter = __webpack_require__(824);
	
	var _ReportFilter2 = _interopRequireDefault(_ReportFilter);
	
	var _MessageThread = __webpack_require__(355);
	
	var _MessageThread2 = _interopRequireDefault(_MessageThread);
	
	var _EditAdmin = __webpack_require__(733);
	
	var _EditAdmin2 = _interopRequireDefault(_EditAdmin);
	
	var _EditCourseOffering = __webpack_require__(759);
	
	var _EditCourseOffering2 = _interopRequireDefault(_EditCourseOffering);
	
	var _UserDetails = __webpack_require__(809);
	
	var _UserDetails2 = _interopRequireDefault(_UserDetails);
	
	var _OAuth = __webpack_require__(794);
	
	var _OAuth2 = _interopRequireDefault(_OAuth);
	
	var _Roles = __webpack_require__(795);
	
	var _Roles2 = _interopRequireDefault(_Roles);
	
	var _Sync = __webpack_require__(796);
	
	var _Sync2 = _interopRequireDefault(_Sync);
	
	var _EditBlackoutDate = __webpack_require__(743);
	
	var _EditBlackoutDate2 = _interopRequireDefault(_EditBlackoutDate);
	
	var _Enrollments = __webpack_require__(826);
	
	var _Enrollments2 = _interopRequireDefault(_Enrollments);
	
	var _TallyLoader = __webpack_require__(345);
	
	var _TallyLoader2 = _interopRequireDefault(_TallyLoader);
	
	var _SessionManage = __webpack_require__(766);
	
	var _SessionManage2 = _interopRequireDefault(_SessionManage);
	
	var _StudentAssignment = __webpack_require__(807);
	
	var _StudentAssignment2 = _interopRequireDefault(_StudentAssignment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var Drawer = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Drawer, _React$Component);
	
	  function Drawer() {
	    _classCallCheck(this, Drawer);
	
	    return _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).apply(this, arguments));
	  }
	
	  _createClass(Drawer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          content = _props.content,
	          isOpen = _props.isOpen,
	          translation = _props.translation;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          ScheduleStore = _props$store.ScheduleStore;
	      var pathname = this.props.routing.location.pathname;
	
	      var closeBtnClass = null;
	      var closePath = null;
	      var callback = null;
	
	      if (this.props.callback) {
	        callback = this.props.callback;
	      }
	
	      var DrawerComponents = {
	        AddSelfManagedAccount: _AddAccount2.default,
	        AddFundingRule: _AddFundingRule2.default,
	        FundingRules: _FundingRules2.default,
	        ApproveProctor: _ApproveProctor2.default,
	        AssignProctor: _AssignProctor2.default,
	        ExamException: _ExamException2.default,
	        EditExamException: _ExamException2.default,
	        EditScheduledExamException: _ExamException2.default,
	        ViewExamException: _ExamException2.default,
	        EnrollmentException: _EnrollmentException2.default,
	        EditEnrollmentException: _EnrollmentException2.default,
	        EditProctor: _EditProctor2.default,
	        ProctorDetails: _ProctorDetails2.default,
	        IncidentReport: _IncidentReport2.default,
	        ScheduleOnline: _ScheduleOnline2.default,
	        ScheduleHybrid: _ScheduleHybrid2.default,
	        ScheduleInstructor: _ScheduleInstructor2.default,
	        ScheduleRB: _ScheduleRB2.default,
	        ScheduleMessaging: _ScheduleMessaging2.default,
	        SessionStartAutomated: _SessionStartAutomated2.default,
	        SessionStartHybrid: _SessionStartHybrid2.default,
	        ScheduleVTC: _ScheduleVTC2.default,
	        ScheduleAutomated: _ScheduleAutomated2.default,
	        SessionDetail: _SessionDetail2.default,
	        SessionDetailStudent: _SessionDetail2.default,
	        SessionStartBV: _SessionStartBV2.default,
	        SessionStartExamity: _SessionStartExamity2.default,
	        SessionStartProctorU: _SessionStartProctorU2.default,
	        SessionStartVTC: _SessionStartVTC2.default,
	        StepIn: _StepIn2.default,
	        VTCReview: _Review2.default,
	        SupportTicketDetail: _SupportTicketDetail2.default,
	        AddSupportTicket: _AddSupportTicket2.default,
	        VoucherList: _VoucherList2.default,
	        AddVoucher: _AddVoucher2.default,
	        EditVoucher: _EditVoucher2.default,
	        LocateProctor: _LocateProctor2.default,
	        SelectProctor: _SelectProctor2.default,
	        ReportFilter: _ReportFilter2.default,
	        MessageThread: _MessageThread2.default,
	        EditAdmin: _EditAdmin2.default,
	        EditCourseOffering: _EditCourseOffering2.default,
	        UserDetails: _UserDetails2.default,
	        OAuth: _OAuth2.default,
	        Roles: _Roles2.default,
	        Sync: _Sync2.default,
	        EditBlackoutDate: _EditBlackoutDate2.default,
	        Enrollments: _Enrollments2.default,
	        SessionManage: _SessionManage2.default,
	        StudentAssignment: _StudentAssignment2.default
	      };
	
	      if (content === 'AddSelfManagedAccount') {
	        closePath = 'self-managed-proctors';
	      }
	
	      if (content === 'ExamException' || content === 'AssignProctor' || content === 'EditProctor' || content === 'SessionDetail' || content === 'Enrollments') {
	        closePath = (0, _helpers.getURLSegment)(this, 1) + '/' + (0, _helpers.getURLSegment)(this, 2);
	      }
	
	      if (content === 'ExamException' && this.props.approval) {
	        closePath = (0, _helpers.getURLSegment)(this, 1);
	      }
	
	      if (content === 'SupportTicketDetail' || content === 'AddSupportTicket' || content === 'AddFundingRule' || content === 'EditVoucher' || content === 'AddSelfManagedAccount' || content === 'EditAdmin' || content === 'EditCourseOffering' || content === 'UserDetails' || content === 'OAuth' || content === 'Sync' || content === 'Roles' || content === 'EditBlackoutDate') {
	        closePath = (0, _helpers.getURLSegment)(this, 1);
	      }
	
	      if (content === 'IncidentReport' || content === 'FundingRules') {
	        closePath = pathname.split('?')[0];
	      }
	
	      if (content === 'StepIn' || content === 'VTCReview') {
	        closeBtnClass = ' drawer__close--inverted';
	      }
	
	      if (content === 'SessionDetailStudent' || content === 'MessageThread' || content === 'SessionStartBV' || content === 'SessionStartExamity' || content === 'SessionStartProctorU' || content === 'SessionStartVTC') {
	        callback = null;
	      }
	
	      if (content === 'ScheduleOnline' || content === 'ScheduleHybrid') {
	        callback = function callback() {
	          var examSid = (0, _helpers.getURLSegment)(_this2, 3);
	          var sessionSid = (0, _helpers.getURLSegment)(_this2, 5);
	
	          if (ScheduleStore.externalReservedAppointmentId) {
	            ScheduleStore.cancelReservation(examSid, sessionSid);
	          }
	        };
	      }
	
	      if (isOpen) {
	        setTimeout(function () {
	          document.querySelector('body').className += ' drawer-open';
	        });
	      } else {
	        document.querySelector('body').classList.remove('drawer-open');
	      }
	
	      if (this.props.closePath) {
	        closePath = this.props.closePath;
	      }
	
	      if ((closePath === this.props.routing.location.pathname || '/' + closePath === this.props.routing.location.pathname) && !this.props.routing.location.search) {
	        closePath = null;
	      }
	
	      if (content) {
	        var DrawerComponent = DrawerComponents[content];
	
	        return _react2.default.createElement(
	          'aside',
	          { id: content, className: 'drawer', tabIndex: '0' },
	          _react2.default.createElement(DrawerComponent, Object.assign({}, this.props, {
	            drawer: true,
	            setClosePath: function setClosePath(path) {
	              return closePath = path;
	            }
	          })),
	          SessionStore.tallyLoad && _react2.default.createElement(
	            'div',
	            { className: 'drawer__content' },
	            _react2.default.createElement(_TallyLoader2.default, { store: this.props.store, routing: this.props.router })
	          ),
	          !SessionStore.hideDrawerClose && _react2.default.createElement(
	            'button',
	            { className: 'drawer__close ' + closeBtnClass, onClick: function onClick(e) {
	                (0, _helpers.closeDrawer)(e, _this2.props.parent, closePath, callback);
	              } },
	            _react2.default.createElement(icons.iconTimes, null),
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.close
	            )
	          )
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return Drawer;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Drawer')(Drawer);

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var DOMProperty = __webpack_require__(114);
	var ReactDOMComponentFlags = __webpack_require__(548);
	
	var invariant = __webpack_require__(10);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(908);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(906);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(153);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(153);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(319)
	  , core      = __webpack_require__(317)
	  , hide      = __webpack_require__(661)
	  , redefine  = __webpack_require__(1532)
	  , ctx       = __webpack_require__(1526)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(905);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(402);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 35 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;(function(factory) {
	    'use strict';
	    /* global window: false, define: false, module: false */
	    var root = typeof window === 'undefined' ? null : window;
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){ return factory(root); }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined') {
	        module.exports = factory(root);
	    } else {
	        root.DOMPurify = factory(root);
	    }
	}(function factory(window) {
	    'use strict';
	
	    var DOMPurify = function(window) {
	        return factory(window);
	    };
	
	    /**
	     * Version label, exposed for easier checks
	     * if DOMPurify is up to date or not
	     */
	    DOMPurify.version = '0.8.9';
	
	    /**
	     * Array of elements that DOMPurify removed during sanitation.
	     * Empty if nothing was removed.
	     */
	    DOMPurify.removed = [];
	
	    if (!window || !window.document || window.document.nodeType !== 9) {
	        // not running in a browser, provide a factory function
	        // so that you can pass your own Window
	        DOMPurify.isSupported = false;
	        return DOMPurify;
	    }
	
	    var document = window.document;
	    var originalDocument = document;
	    var DocumentFragment = window.DocumentFragment;
	    var HTMLTemplateElement = window.HTMLTemplateElement;
	    var Node = window.Node;
	    var NodeFilter = window.NodeFilter;
	    var NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap;
	    var Text = window.Text;
	    var Comment = window.Comment;
	    var DOMParser = window.DOMParser;
	    var useDOMParser = false; // See comment below
	
	    // As per issue #47, the web-components registry is inherited by a
	    // new document created via createHTMLDocument. As per the spec
	    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
	    // a new empty registry is used when creating a template contents owner
	    // document, so we use that as our parent document to ensure nothing
	    // is inherited.
	    if (typeof HTMLTemplateElement === 'function') {
	        var template = document.createElement('template');
	        if (template.content && template.content.ownerDocument) {
	            document = template.content.ownerDocument;
	        }
	    }
	    var implementation = document.implementation;
	    var createNodeIterator = document.createNodeIterator;
	    var getElementsByTagName = document.getElementsByTagName;
	    var createDocumentFragment = document.createDocumentFragment;
	    var importNode = originalDocument.importNode;
	
	    var hooks = {};
	
	    /**
	     * Expose whether this browser supports running the full DOMPurify.
	     */
	    DOMPurify.isSupported =
	        typeof implementation.createHTMLDocument !== 'undefined' &&
	        document.documentMode !== 9;
	
	    /* Add properties to a lookup table */
	    var _addToSet = function(set, array) {
	        var l = array.length;
	        while (l--) {
	            if (typeof array[l] === 'string') {
	                array[l] = array[l].toLowerCase();
	            }
	            set[array[l]] = true;
	        }
	        return set;
	    };
	
	    /* Shallow clone an object */
	    var _cloneObj = function(object) {
	        var newObject = {};
	        var property;
	        for (property in object) {
	            if (object.hasOwnProperty(property)) {
	                newObject[property] = object[property];
	            }
	        }
	        return newObject;
	    };
	
	    /**
	     * We consider the elements and attributes below to be safe. Ideally
	     * don't add any new ones but feel free to remove unwanted ones.
	     */
	
	    /* allowed element names */
	    var ALLOWED_TAGS = null;
	    var DEFAULT_ALLOWED_TAGS = _addToSet({}, [
	
	        // HTML
	        'a','abbr','acronym','address','area','article','aside','audio','b',
	        'bdi','bdo','big','blink','blockquote','body','br','button','canvas',
	        'caption','center','cite','code','col','colgroup','content','data',
	        'datalist','dd','decorator','del','details','dfn','dir','div','dl','dt',
	        'element','em','fieldset','figcaption','figure','font','footer','form',
	        'h1','h2','h3','h4','h5','h6','head','header','hgroup','hr','html','i',
	        'img','input','ins','kbd','label','legend','li','main','map','mark',
	        'marquee','menu','menuitem','meter','nav','nobr','ol','optgroup',
	        'option','output','p','pre','progress','q','rp','rt','ruby','s','samp',
	        'section','select','shadow','small','source','spacer','span','strike',
	        'strong','style','sub','summary','sup','table','tbody','td','template',
	        'textarea','tfoot','th','thead','time','tr','track','tt','u','ul','var',
	        'video','wbr',
	
	        // SVG
	        'svg','altglyph','altglyphdef','altglyphitem','animatecolor',
	        'animatemotion','animatetransform','circle','clippath','defs','desc',
	        'ellipse','filter','font','g','glyph','glyphref','hkern','image','line',
	        'lineargradient','marker','mask','metadata','mpath','path','pattern',
	        'polygon','polyline','radialgradient','rect','stop','switch','symbol',
	        'text','textpath','title','tref','tspan','view','vkern',
	
	        // SVG Filters
	        'feBlend','feColorMatrix','feComponentTransfer','feComposite',
	        'feConvolveMatrix','feDiffuseLighting','feDisplacementMap',
	        'feFlood','feFuncA','feFuncB','feFuncG','feFuncR','feGaussianBlur',
	        'feMerge','feMergeNode','feMorphology','feOffset',
	        'feSpecularLighting','feTile','feTurbulence',
	
	        //MathML
	        'math','menclose','merror','mfenced','mfrac','mglyph','mi','mlabeledtr',
	        'mmuliscripts','mn','mo','mover','mpadded','mphantom','mroot','mrow',
	        'ms','mpspace','msqrt','mystyle','msub','msup','msubsup','mtable','mtd',
	        'mtext','mtr','munder','munderover',
	
	        //Text
	        '#text'
	    ]);
	
	    /* Allowed attribute names */
	    var ALLOWED_ATTR = null;
	    var DEFAULT_ALLOWED_ATTR = _addToSet({}, [
	
	        // HTML
	        'accept','action','align','alt','autocomplete','background','bgcolor',
	        'border','cellpadding','cellspacing','checked','cite','class','clear','color',
	        'cols','colspan','coords','datetime','default','dir','disabled',
	        'download','enctype','face','for','headers','height','hidden','high','href',
	        'hreflang','id','ismap','label','lang','list','loop', 'low','max',
	        'maxlength','media','method','min','multiple','name','noshade','novalidate',
	        'nowrap','open','optimum','pattern','placeholder','poster','preload','pubdate',
	        'radiogroup','readonly','rel','required','rev','reversed','role','rows',
	        'rowspan','spellcheck','scope','selected','shape','size','span',
	        'srclang','start','src','step','style','summary','tabindex','title',
	        'type','usemap','valign','value','width','xmlns',
	
	        // SVG
	        'accent-height','accumulate','additivive','alignment-baseline',
	        'ascent','attributename','attributetype','azimuth','basefrequency',
	        'baseline-shift','begin','bias','by','clip','clip-path','clip-rule',
	        'color','color-interpolation','color-interpolation-filters','color-profile',
	        'color-rendering','cx','cy','d','dx','dy','diffuseconstant','direction',
	        'display','divisor','dur','edgemode','elevation','end','fill','fill-opacity',
	        'fill-rule','filter','flood-color','flood-opacity','font-family','font-size',
	        'font-size-adjust','font-stretch','font-style','font-variant','font-weight',
	        'fx', 'fy','g1','g2','glyph-name','glyphref','gradientunits','gradienttransform',
	        'image-rendering','in','in2','k','k1','k2','k3','k4','kerning','keypoints',
	        'keysplines','keytimes','lengthadjust','letter-spacing','kernelmatrix',
	        'kernelunitlength','lighting-color','local','marker-end','marker-mid',
	        'marker-start','markerheight','markerunits','markerwidth','maskcontentunits',
	        'maskunits','max','mask','mode','min','numoctaves','offset','operator',
	        'opacity','order','orient','orientation','origin','overflow','paint-order',
	        'path','pathlength','patterncontentunits','patterntransform','patternunits',
	        'points','preservealpha','r','rx','ry','radius','refx','refy','repeatcount',
	        'repeatdur','restart','result','rotate','scale','seed','shape-rendering',
	        'specularconstant','specularexponent','spreadmethod','stddeviation','stitchtiles',
	        'stop-color','stop-opacity','stroke-dasharray','stroke-dashoffset','stroke-linecap',
	        'stroke-linejoin','stroke-miterlimit','stroke-opacity','stroke','stroke-width',
	        'surfacescale','targetx','targety','transform','text-anchor','text-decoration',
	        'text-rendering','textlength','u1','u2','unicode','values','viewbox',
	        'visibility','vert-adv-y','vert-origin-x','vert-origin-y','word-spacing',
	        'wrap','writing-mode','xchannelselector','ychannelselector','x','x1','x2',
	        'y','y1','y2','z','zoomandpan',
	
	        // MathML
	        'accent','accentunder','bevelled','close','columnsalign','columnlines',
	        'columnspan','denomalign','depth','display','displaystyle','fence',
	        'frame','largeop','length','linethickness','lspace','lquote',
	        'mathbackground','mathcolor','mathsize','mathvariant','maxsize',
	        'minsize','movablelimits','notation','numalign','open','rowalign',
	        'rowlines','rowspacing','rowspan','rspace','rquote','scriptlevel',
	        'scriptminsize','scriptsizemultiplier','selection','separator',
	        'separators','stretchy','subscriptshift','supscriptshift','symmetric',
	        'voffset',
	
	        // XML
	        'xlink:href','xml:id','xlink:title','xml:space','xmlns:xlink'
	    ]);
	
	    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
	    var FORBID_TAGS = null;
	
	    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
	    var FORBID_ATTR = null;
	
	    /* Decide if ARIA attributes are okay */
	    var ALLOW_ARIA_ATTR = true;
	
	    /* Decide if custom data attributes are okay */
	    var ALLOW_DATA_ATTR = true;
	
	    /* Decide if unknown protocols are okay */
	    var ALLOW_UNKNOWN_PROTOCOLS = false;
	
	    /* Output should be safe for jQuery's $() factory? */
	    var SAFE_FOR_JQUERY = false;
	
	    /* Output should be safe for common template engines.
	     * This means, DOMPurify removes data attributes, mustaches and ERB
	     */
	    var SAFE_FOR_TEMPLATES = false;
	
	    /* Specify template detection regex for SAFE_FOR_TEMPLATES mode */
	    var MUSTACHE_EXPR = /\{\{[\s\S]*|[\s\S]*\}\}/gm;
	    var ERB_EXPR = /<%[\s\S]*|[\s\S]*%>/gm;
	
	    /* Decide if document with <html>... should be returned */
	    var WHOLE_DOCUMENT = false;
	
	    /* Decide if all elements (e.g. style, script) must be children of
	     * document.body. By default, browsers might move them to document.head */
	    var FORCE_BODY = false;
	
	    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html string.
	     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
	     */
	    var RETURN_DOM = false;
	
	    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html string */
	    var RETURN_DOM_FRAGMENT = false;
	
	    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
	     * `Node` is imported into the current `Document`. If this flag is not enabled the
	     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
	     * DOMPurify. */
	    var RETURN_DOM_IMPORT = false;
	
	    /* Output should be free from DOM clobbering attacks? */
	    var SANITIZE_DOM = true;
	
	    /* Keep element content when removing element? */
	    var KEEP_CONTENT = true;
	
	    /* Tags to ignore content of when KEEP_CONTENT is true */
	    var FORBID_CONTENTS = _addToSet({}, [
	        'audio', 'head', 'math', 'script', 'style', 'template', 'svg', 'video'
	    ]);
	
	    /* Tags that are safe for data: URIs */
	    var DATA_URI_TAGS = _addToSet({}, [
	        'audio', 'video', 'img', 'source', 'image'
	    ]);
	
	    /* Attributes safe for values like "javascript:" */
	    var URI_SAFE_ATTRIBUTES = _addToSet({}, [
	        'alt','class','for','id','label','name','pattern','placeholder',
	        'summary','title','value','style','xmlns'
	    ]);
	
	    /* Keep a reference to config to pass to hooks */
	    var CONFIG = null;
	
	    /* Ideally, do not touch anything below this line */
	    /* ______________________________________________ */
	
	    var formElement = document.createElement('form');
	
	    /**
	     * _parseConfig
	     *
	     * @param  optional config literal
	     */
	    var _parseConfig = function(cfg) {
	        /* Shield configuration object from tampering */
	        if (typeof cfg !== 'object') {
	            cfg = {};
	        }
	
	        /* Set configuration parameters */
	        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ?
	            _addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
	        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ?
	            _addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
	        FORBID_TAGS = 'FORBID_TAGS' in cfg ?
	            _addToSet({}, cfg.FORBID_TAGS) : {};
	        FORBID_ATTR = 'FORBID_ATTR' in cfg ?
	            _addToSet({}, cfg.FORBID_ATTR) : {};
	        ALLOW_ARIA_ATTR     = cfg.ALLOW_ARIA_ATTR     !== false; // Default true
	        ALLOW_DATA_ATTR     = cfg.ALLOW_DATA_ATTR     !== false; // Default true
	        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
	        SAFE_FOR_JQUERY     = cfg.SAFE_FOR_JQUERY     ||  false; // Default false
	        SAFE_FOR_TEMPLATES  = cfg.SAFE_FOR_TEMPLATES  ||  false; // Default false
	        WHOLE_DOCUMENT      = cfg.WHOLE_DOCUMENT      ||  false; // Default false
	        RETURN_DOM          = cfg.RETURN_DOM          ||  false; // Default false
	        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT ||  false; // Default false
	        RETURN_DOM_IMPORT   = cfg.RETURN_DOM_IMPORT   ||  false; // Default false
	        FORCE_BODY          = cfg.FORCE_BODY          ||  false; // Default false
	        SANITIZE_DOM        = cfg.SANITIZE_DOM        !== false; // Default true
	        KEEP_CONTENT        = cfg.KEEP_CONTENT        !== false; // Default true
	
	        if (SAFE_FOR_TEMPLATES) {
	            ALLOW_DATA_ATTR = false;
	        }
	
	        if (RETURN_DOM_FRAGMENT) {
	            RETURN_DOM = true;
	        }
	
	        /* Merge configuration parameters */
	        if (cfg.ADD_TAGS) {
	            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
	                ALLOWED_TAGS = _cloneObj(ALLOWED_TAGS);
	            }
	            _addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
	        }
	        if (cfg.ADD_ATTR) {
	            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
	                ALLOWED_ATTR = _cloneObj(ALLOWED_ATTR);
	            }
	            _addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
	        }
	        if (cfg.ADD_URI_SAFE_ATTR) {
	            _addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
	        }
	
	        /* Add #text in case KEEP_CONTENT is set to true */
	        if (KEEP_CONTENT) { ALLOWED_TAGS['#text'] = true; }
	
	        // Prevent further manipulation of configuration.
	        // Not available in IE8, Safari 5, etc.
	        if (Object && 'freeze' in Object) { Object.freeze(cfg); }
	
	        CONFIG = cfg;
	    };
	
	   /**
	     * _forceRemove
	     *
	     * @param  a DOM node
	     */
	    var _forceRemove = function(node) {
	        DOMPurify.removed.push({element: node});
	        try {
	            node.parentNode.removeChild(node);
	        } catch (e) {
	            node.outerHTML = '';
	        }
	    };
	
	   /**
	     * _removeAttribute
	     *
	     * @param  an Attribute name
	     * @param  a DOM node
	     */
	    var _removeAttribute = function(name, node) {
	        DOMPurify.removed.push({
	            attribute: node.getAttributeNode(name),
	            from: node
	        });
	        node.removeAttribute(name);
	    };
	
	   /**
	     * _initDocument
	     *
	     * @param  a string of dirty markup
	     * @return a DOM, filled with the dirty markup
	     */
	    var _initDocument = function(dirty) {
	        /* Create a HTML document */
	        var doc, body;
	
	        /* Fill body with bogus element */
	        if (FORCE_BODY) {
	            dirty = '<remove></remove>' + dirty;
	        }
	
	        /* Use DOMParser to workaround Firefox bug (see comment below) */
	        if (useDOMParser) {
	            try {
	                doc = new DOMParser().parseFromString(dirty, 'text/html');
	            } catch (e) {}
	        }
	
	        /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
	           Safari (see comment below) */
	        if (!doc || !doc.documentElement) {
	            doc = implementation.createHTMLDocument('');
	            body = doc.body;
	            body.parentNode.removeChild(body.parentNode.firstElementChild);
	            body.outerHTML = dirty;
	        }
	
	        /* Work on whole document or just its body */
	        return getElementsByTagName.call(doc,
	            WHOLE_DOCUMENT ? 'html' : 'body')[0];
	    };
	
	    // Safari 10.1+ (unfixed as of time of writing) has a catastrophic bug in
	    // its implementation of DOMParser such that the following executes the
	    // JavaScript:
	    //
	    // new DOMParser()
	    //   .parseFromString('<svg onload=alert(document.domain)>', 'text/html');
	    //
	    // However, Firefox uses a different parser for innerHTML rather than
	    // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
	    // which means that you *must* use DOMParser, otherwise the output may
	    // not be safe if used in a document.write context later.
	    //
	    // So we feature detect the Firefox bug and use the DOMParser if necessary.
	    if (DOMPurify.isSupported) {
	        (function () {
	            var doc = _initDocument('<svg><p><style><img src="</style><img src=x onerror=alert(1)//">');
	            if (doc.querySelector('svg img')) {
	                useDOMParser = true;
	            }
	        }());
	    }
	
	    /**
	     * _createIterator
	     *
	     * @param  document/fragment to create iterator for
	     * @return iterator instance
	     */
	    var _createIterator = function(root) {
	        return createNodeIterator.call(root.ownerDocument || root,
	            root,
	            NodeFilter.SHOW_ELEMENT
	            | NodeFilter.SHOW_COMMENT
	            | NodeFilter.SHOW_TEXT,
	            function() { return NodeFilter.FILTER_ACCEPT; },
	            false
	        );
	    };
	
	    /**
	     * _isClobbered
	     *
	     * @param  element to check for clobbering attacks
	     * @return true if clobbered, false if safe
	     */
	    var _isClobbered = function(elm) {
	        if (elm instanceof Text || elm instanceof Comment) {
	            return false;
	        }
	        if (  typeof elm.nodeName !== 'string'
	           || typeof elm.textContent !== 'string'
	           || typeof elm.removeChild !== 'function'
	           || !(elm.attributes instanceof NamedNodeMap)
	           || typeof elm.removeAttribute !== 'function'
	           || typeof elm.setAttribute !== 'function'
	        ) {
	            return true;
	        }
	        return false;
	    };
	
	    /**
	     * _isNode
	     *
	     * @param object to check whether it's a DOM node
	     * @return true is object is a DOM node
	     */
	    var _isNode = function(obj) {
	        return (
	            typeof Node === "object" ? obj instanceof Node : obj
	                && typeof obj === "object" && typeof obj.nodeType === "number"
	                && typeof obj.nodeName==="string"
	        );
	    };
	
	    /**
	     * _sanitizeElements
	     *
	     * @protect nodeName
	     * @protect textContent
	     * @protect removeChild
	     *
	     * @param   node to check for permission to exist
	     * @return  true if node was killed, false if left alive
	     */
	    var _sanitizeElements = function(currentNode) {
	        var tagName, content;
	
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeElements', currentNode, null);
	
	        /* Check if element is clobbered or can clobber */
	        if (_isClobbered(currentNode)) {
	            _forceRemove(currentNode);
	            return true;
	        }
	
	        /* Now let's check the element's type and name */
	        tagName = currentNode.nodeName.toLowerCase();
	
	        /* Execute a hook if present */
	        _executeHook('uponSanitizeElement', currentNode, {
	            tagName: tagName,
	            allowedTags: ALLOWED_TAGS
	        });
	
	        /* Remove element if anything forbids its presence */
	        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
	            /* Keep content except for black-listed elements */
	            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]
	                    && typeof currentNode.insertAdjacentHTML === 'function') {
	                try {
	                    currentNode.insertAdjacentHTML('AfterEnd', currentNode.innerHTML);
	                } catch (e) {}
	            }
	            _forceRemove(currentNode);
	            return true;
	        }
	
	        /* Convert markup to cover jQuery behavior */
	        if (SAFE_FOR_JQUERY && !currentNode.firstElementChild &&
	                (!currentNode.content || !currentNode.content.firstElementChild) &&
	                /</g.test(currentNode.textContent)) {
	            DOMPurify.removed.push({element: currentNode.cloneNode()});
	            currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
	        }
	
	        /* Sanitize element content to be template-safe */
	        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
	            /* Get the element's text content */
	            content = currentNode.textContent;
	            content = content.replace(MUSTACHE_EXPR, ' ');
	            content = content.replace(ERB_EXPR, ' ');
	            if (currentNode.textContent !== content) {
	                DOMPurify.removed.push({element: currentNode.cloneNode()});
	                currentNode.textContent = content;
	            }
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeElements', currentNode, null);
	
	        return false;
	    };
	
	    var DATA_ATTR = /^data-[\-\w.\u00B7-\uFFFF]/;
	    var ARIA_ATTR = /^aria-[\-\w]+$/;
	    var IS_ALLOWED_URI = /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;
	    var IS_SCRIPT_OR_DATA = /^(?:\w+script|data):/i;
	    /* This needs to be extensive thanks to Webkit/Blink's behavior */
	    var ATTR_WHITESPACE = /[\x00-\x20\xA0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
	
	    /**
	     * _sanitizeAttributes
	     *
	     * @protect attributes
	     * @protect nodeName
	     * @protect removeAttribute
	     * @protect setAttribute
	     *
	     * @param   node to sanitize
	     * @return  void
	     */
	    var _sanitizeAttributes = function(currentNode) {
	        var attr, name, value, lcName, idAttr, attributes, hookEvent, l;
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeAttributes', currentNode, null);
	
	        attributes = currentNode.attributes;
	
	        /* Check if we have attributes; if not we might have a text node */
	        if (!attributes) { return; }
	
	        hookEvent = {
	            attrName: '',
	            attrValue: '',
	            keepAttr: true,
	            allowedAttributes: ALLOWED_ATTR
	        };
	        l = attributes.length;
	
	        /* Go backwards over all attributes; safely remove bad ones */
	        while (l--) {
	            attr = attributes[l];
	            name = attr.name;
	            value = attr.value.trim();
	            lcName = name.toLowerCase();
	
	            /* Execute a hook if present */
	            hookEvent.attrName = lcName;
	            hookEvent.attrValue = value;
	            hookEvent.keepAttr = true;
	            _executeHook('uponSanitizeAttribute', currentNode, hookEvent );
	            value = hookEvent.attrValue;
	
	            /* Remove attribute */
	            // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
	            // remove a "name" attribute from an <img> tag that has an "id"
	            // attribute at the time.
	            if (lcName === 'name'  &&
	                    currentNode.nodeName === 'IMG' && attributes.id) {
	                idAttr = attributes.id;
	                attributes = Array.prototype.slice.apply(attributes);
	                _removeAttribute('id', currentNode);
	                _removeAttribute(name, currentNode);
	                if (attributes.indexOf(idAttr) > l) {
	                    currentNode.setAttribute('id', idAttr.value);
	                }
	            } else if (
	                  // This works around a bug in Safari, where input[type=file]
	                  // cannot be dynamically set after type has been removed
	                  currentNode.nodeName === 'INPUT' && lcName === 'type' &&
	                  value === 'file' && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
	                  continue;
	            } else {
	                // This avoids a crash in Safari v9.0 with double-ids.
	                // The trick is to first set the id to be empty and then to
	                // remove the attribute
	                if (name === 'id') {
	                    currentNode.setAttribute(name, '');
	                }
	                _removeAttribute(name, currentNode);
	            }
	
	            /* Did the hooks approve of the attribute? */
	            if (!hookEvent.keepAttr) {
	                continue;
	            }
	
	            /* Make sure attribute cannot clobber */
	            if (SANITIZE_DOM &&
	                    (lcName === 'id' || lcName === 'name') &&
	                    (value in window || value in document || value in formElement)) {
	                continue;
	            }
	
	            /* Sanitize attribute content to be template-safe */
	            if (SAFE_FOR_TEMPLATES) {
	                value = value.replace(MUSTACHE_EXPR, ' ');
	                value = value.replace(ERB_EXPR, ' ');
	            }
	
	            /* Allow valid data-* attributes: At least one character after "-"
	               (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
	               XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
	               We don't need to check the value; it's always URI safe. */
	            if (ALLOW_DATA_ATTR && DATA_ATTR.test(lcName)) {
	                // This attribute is safe
	            }
	            else if (ALLOW_ARIA_ATTR && ARIA_ATTR.test(lcName)) {
	                // This attribute is safe
	            }
	            /* Otherwise, check the name is permitted */
	            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
	                continue;
	            }
	            /* Check value is safe. First, is attr inert? If so, is safe */
	            else if (URI_SAFE_ATTRIBUTES[lcName]) {
	                // This attribute is safe
	            }
	            /* Check no script, data or unknown possibly unsafe URI
	               unless we know URI values are safe for that attribute */
	            else if (IS_ALLOWED_URI.test(value.replace(ATTR_WHITESPACE,''))) {
	                // This attribute is safe
	            }
	            /* Keep image data URIs alive if src/xlink:href is allowed */
	            else if (
	                (lcName === 'src' || lcName === 'xlink:href') &&
	                value.indexOf('data:') === 0 &&
	                DATA_URI_TAGS[currentNode.nodeName.toLowerCase()]) {
	                // This attribute is safe
	            }
	            /* Allow unknown protocols: This provides support for links that
	               are handled by protocol handlers which may be unknown ahead of
	               time, e.g. fb:, spotify: */
	            else if (
	                ALLOW_UNKNOWN_PROTOCOLS &&
	                !IS_SCRIPT_OR_DATA.test(value.replace(ATTR_WHITESPACE,''))) {
	                // This attribute is safe
	            }
	            /* Check for binary attributes */
	            else if (!value) {
	                // binary attributes are safe at this point
	            }
	            /* Anything else, presume unsafe, do not add it back */
	            else {
	                continue;
	            }
	
	            /* Handle invalid data-* attribute set by try-catching it */
	            try {
	                currentNode.setAttribute(name, value);
	                DOMPurify.removed.pop();
	            } catch (e) {}
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeAttributes', currentNode, null);
	    };
	
	    /**
	     * _sanitizeShadowDOM
	     *
	     * @param  fragment to iterate over recursively
	     * @return void
	     */
	    var _sanitizeShadowDOM = function(fragment) {
	        var shadowNode;
	        var shadowIterator = _createIterator(fragment);
	
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeShadowDOM', fragment, null);
	
	        while ( (shadowNode = shadowIterator.nextNode()) ) {
	            /* Execute a hook if present */
	            _executeHook('uponSanitizeShadowNode', shadowNode, null);
	
	            /* Sanitize tags and elements */
	            if (_sanitizeElements(shadowNode)) {
	                continue;
	            }
	
	            /* Deep shadow DOM detected */
	            if (shadowNode.content instanceof DocumentFragment) {
	                _sanitizeShadowDOM(shadowNode.content);
	            }
	
	            /* Check attributes, sanitize if necessary */
	            _sanitizeAttributes(shadowNode);
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeShadowDOM', fragment, null);
	    };
	
	    /**
	     * _executeHook
	     * Execute user configurable hooks
	     *
	     * @param  {String} entryPoint  Name of the hook's entry point
	     * @param  {Node} currentNode
	     */
	    var _executeHook = function(entryPoint, currentNode, data) {
	        if (!hooks[entryPoint]) { return; }
	
	        hooks[entryPoint].forEach(function(hook) {
	            hook.call(DOMPurify, currentNode, data, CONFIG);
	        });
	    };
	
	    /**
	     * sanitize
	     * Public method providing core sanitation functionality
	     *
	     * @param {String|Node} dirty string or DOM node
	     * @param {Object} configuration object
	     */
	    DOMPurify.sanitize = function(dirty, cfg) {
	        var body, importedNode, currentNode, oldNode, nodeIterator, returnNode;
	        /* Make sure we have a string to sanitize.
	           DO NOT return early, as this will return the wrong type if
	           the user has requested a DOM object rather than a string */
	        if (!dirty) {
	            dirty = '<!-->';
	        }
	
	        /* Stringify, in case dirty is an object */
	        if (typeof dirty !== 'string' && !_isNode(dirty)) {
	            if (typeof dirty.toString !== 'function') {
	                throw new TypeError('toString is not a function');
	            } else {
	                dirty = dirty.toString();
	            }
	        }
	
	        /* Check we can run. Otherwise fall back or ignore */
	        if (!DOMPurify.isSupported) {
	            if (typeof window.toStaticHTML === 'object'
	                || typeof window.toStaticHTML === 'function') {
	                if (typeof dirty === 'string') {
	                    return window.toStaticHTML(dirty);
	                } else if (_isNode(dirty)) {
	                    return window.toStaticHTML(dirty.outerHTML);
	                }
	            }
	            return dirty;
	        }
	
	        /* Assign config vars */
	        _parseConfig(cfg);
	
	        /* Clean up removed elements */
	        DOMPurify.removed = [];
	
	        if (dirty instanceof Node) {
	            /* If dirty is a DOM element, append to an empty document to avoid
	               elements being stripped by the parser */
	            body = _initDocument('<!-->');
	            importedNode = body.ownerDocument.importNode(dirty, true);
	            if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
	                /* Node is already a body, use as is */
	                body = importedNode;
	            } else {
	                body.appendChild(importedNode);
	            }
	        } else {
	            /* Exit directly if we have nothing to do */
	            if (!RETURN_DOM && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
	                return dirty;
	            }
	
	            /* Initialize the document to work on */
	            body = _initDocument(dirty);
	
	            /* Check we have a DOM node from the data */
	            if (!body) {
	                return RETURN_DOM ? null : '';
	            }
	        }
	
	        /* Remove first element node (ours) if FORCE_BODY is set */
	        if (FORCE_BODY) {
	            _forceRemove(body.firstChild);
	        }
	
	        /* Get node iterator */
	        nodeIterator = _createIterator(body);
	
	        /* Now start iterating over the created document */
	        while ( (currentNode = nodeIterator.nextNode()) ) {
	
	            /* Fix IE's strange behavior with manipulated textNodes #89 */
	            if (currentNode.nodeType === 3 && currentNode === oldNode) {
	                continue;
	            }
	
	            /* Sanitize tags and elements */
	            if (_sanitizeElements(currentNode)) {
	                continue;
	            }
	
	            /* Shadow DOM detected, sanitize it */
	            if (currentNode.content instanceof DocumentFragment) {
	                _sanitizeShadowDOM(currentNode.content);
	            }
	
	            /* Check attributes, sanitize if necessary */
	            _sanitizeAttributes(currentNode);
	
	            oldNode = currentNode;
	        }
	
	        /* Return sanitized string or DOM */
	        if (RETURN_DOM) {
	
	            if (RETURN_DOM_FRAGMENT) {
	                returnNode = createDocumentFragment.call(body.ownerDocument);
	
	                while (body.firstChild) {
	                    returnNode.appendChild(body.firstChild);
	                }
	            } else {
	                returnNode = body;
	            }
	
	            if (RETURN_DOM_IMPORT) {
	                /* adoptNode() is not used because internal state is not reset
	                   (e.g. the past names map of a HTMLFormElement), this is safe
	                   in theory but we would rather not risk another attack vector.
	                   The state that is cloned by importNode() is explicitly defined
	                   by the specs. */
	                returnNode = importNode.call(originalDocument, returnNode, true);
	            }
	
	            return returnNode;
	        }
	
	        return WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
	    };
	
	    /**
	     * addHook
	     * Public method to add DOMPurify hooks
	     *
	     * @param {String} entryPoint
	     * @param {Function} hookFunction
	     */
	    DOMPurify.addHook = function(entryPoint, hookFunction) {
	        if (typeof hookFunction !== 'function') { return; }
	        hooks[entryPoint] = hooks[entryPoint] || [];
	        hooks[entryPoint].push(hookFunction);
	    };
	
	    /**
	     * removeHook
	     * Public method to remove a DOMPurify hook at a given entryPoint
	     * (pops it from the stack of hooks if more are present)
	     *
	     * @param {String} entryPoint
	     * @return void
	     */
	    DOMPurify.removeHook = function(entryPoint) {
	        if (hooks[entryPoint]) {
	            hooks[entryPoint].pop();
	        }
	    };
	
	    /**
	     * removeHooks
	     * Public method to remove all DOMPurify hooks at a given entryPoint
	     *
	     * @param  {String} entryPoint
	     * @return void
	     */
	    DOMPurify.removeHooks = function(entryPoint) {
	        if (hooks[entryPoint]) {
	            hooks[entryPoint] = [];
	        }
	    };
	
	    /**
	     * removeAllHooks
	     * Public method to remove all DOMPurify hooks
	     *
	     * @return void
	     */
	    DOMPurify.removeAllHooks = function() {
	        hooks = {};
	    };
	
	    return DOMPurify;
	}));


/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(3),__webpack_require__(1),__webpack_require__(1141),__webpack_require__(22)):"function"==typeof define&&define.amd?define(["moment","react","react-onclickoutside","react-dom"],e):"object"==typeof exports?exports.DatePicker=e(require("moment"),require("react"),require("react-onclickoutside"),require("react-dom")):t.DatePicker=e(t.moment,t.React,t.onClickOutside,t.ReactDOM)}(this,function(t,e,n,o){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={exports:{},id:o,loaded:!1};return t[o].call(r.exports,r,r.exports,e),r.loaded=!0,r.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function r(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var i=n(1),a=o(i),s=n(5),l=o(s),p=n(3),d=o(p),h=n(16),c=o(h),u=n(8),f=o(u),m=n(4),g=n(2),v=o(g),y=n(9),D=o(y),b="react-datepicker-ignore-onclickoutside",w=(0,D.default)(l.default),C=d.default.createClass({displayName:"DatePicker",getDefaultProps:function(){return{dateFormatCalendar:"MMMM YYYY",onChange:function(){},disabled:!1,disableDateAutoCorrection:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},popoverAttachment:"top left",popoverTargetAttachment:"bottom left",popoverTargetOffset:"10px 0",tetherConstraints:[{to:"window",attachment:"together"}],utcOffset:(0,v.default)().utcOffset(),monthsShown:1,withPortal:!1}},getInitialState:function(){var t=this.props.openToDate?(0,v.default)(this.props.openToDate):this.props.selectsEnd&&this.props.startDate?(0,v.default)(this.props.startDate):this.props.selectsStart&&this.props.endDate?(0,v.default)(this.props.endDate):(0,v.default)(),e=(0,m.getEffectiveMinDate)(this.props),n=(0,m.getEffectiveMaxDate)(this.props),o=e&&t.isBefore(e)?e:n&&t.isAfter(n)?n:t;return{open:!1,preventFocus:!1,preSelection:this.props.selected?(0,v.default)(this.props.selected):o}},componentWillUnmount:function(){this.clearPreventFocusTimeout()},clearPreventFocusTimeout:function(){this.preventFocusTimeout&&clearTimeout(this.preventFocusTimeout)},setFocus:function(){this.refs.input.focus()},setOpen:function(t){this.setState({open:t,preSelection:t&&this.state.open?this.state.preSelection:this.getInitialState().preSelection})},handleFocus:function(t){this.state.preventFocus||(this.props.onFocus(t),this.setOpen(!0))},cancelFocusInput:function(){clearTimeout(this.inputFocusTimeout),this.inputFocusTimeout=null},deferFocusInput:function(){var t=this;this.cancelFocusInput(),this.inputFocusTimeout=window.setTimeout(function(){return t.setFocus()},1)},handleDropdownFocus:function(){this.cancelFocusInput()},handleBlur:function(t){this.state.open?this.deferFocusInput():this.props.onBlur(t)},handleCalendarClickOutside:function(t){this.setOpen(!1),this.props.onClickOutside(t),this.props.withPortal&&t.preventDefault()},handleSelect:function(t,e){var n=this;this.setState({preventFocus:!0},function(){return n.preventFocusTimeout=setTimeout(function(){return n.setState({preventFocus:!1})},50),n.preventFocusTimeout}),this.setSelected(t,e),this.setOpen(!1)},setSelected:function(t,e){var n=t;null!==n&&(0,m.isDayDisabled)(n,this.props)||((0,m.isSameDay)(this.props.selected,n)&&!this.props.disableDateAutoCorrection||(null!==n&&(this.props.selected&&(n=(0,v.default)(n).set({hour:this.props.selected.hour(),minute:this.props.selected.minute(),second:this.props.selected.second()})),this.setState({preSelection:n})),this.props.onChange(n,e)),this.props.onSelect(n,e))},setPreSelection:function(t){var e="undefined"!=typeof this.props.minDate&&"undefined"!=typeof this.props.maxDate,n=!e||!t||(0,m.isDayInRange)(t,this.props.minDate,this.props.maxDate);n&&this.setState({preSelection:t})},onInputClick:function(){this.props.disabled||this.setOpen(!0)},onInputKeyDown:function(t){if(!this.state.open&&!this.props.inline)return void(/^Arrow/.test(t.key)&&this.onInputClick());var e=(0,v.default)(this.state.preSelection);if("Enter"===t.key?(t.preventDefault(),this.handleSelect(e,t)):"Escape"===t.key?(t.preventDefault(),this.setOpen(!1)):"Tab"===t.key&&this.setOpen(!1),!this.props.disabledKeyboardNavigation){var n=void 0;switch(t.key){case"ArrowLeft":t.preventDefault(),n=e.subtract(1,"days");break;case"ArrowRight":t.preventDefault(),n=e.add(1,"days");break;case"ArrowUp":t.preventDefault(),n=e.subtract(1,"weeks");break;case"ArrowDown":t.preventDefault(),n=e.add(1,"weeks");break;case"PageUp":t.preventDefault(),n=e.subtract(1,"months");break;case"PageDown":t.preventDefault(),n=e.add(1,"months");break;case"Home":t.preventDefault(),n=e.subtract(1,"years");break;case"End":t.preventDefault(),n=e.add(1,"years")}this.setPreSelection(n)}},onClearClick:function(t){t.preventDefault(),this.props.onChange(null,t)},renderCalendar:function(){return this.props.inline||this.state.open&&!this.props.disabled?d.default.createElement(w,{ref:"calendar",locale:this.props.locale,dateFormat:this.props.dateFormatCalendar,dropdownMode:this.props.dropdownMode,selected:this.props.selected,preSelection:this.state.preSelection,onSelect:this.handleSelect,openToDate:this.props.openToDate,minDate:this.props.minDate,maxDate:this.props.maxDate,selectsStart:this.props.selectsStart,selectsEnd:this.props.selectsEnd,startDate:this.props.startDate,endDate:this.props.endDate,excludeDates:this.props.excludeDates,filterDate:this.props.filterDate,onClickOutside:this.handleCalendarClickOutside,highlightDates:this.props.highlightDates,includeDates:this.props.includeDates,inline:this.props.inline,peekNextMonth:this.props.peekNextMonth,showMonthDropdown:this.props.showMonthDropdown,showWeekNumbers:this.props.showWeekNumbers,showYearDropdown:this.props.showYearDropdown,forceShowMonthNavigation:this.props.forceShowMonthNavigation,scrollableYearDropdown:this.props.scrollableYearDropdown,todayButton:this.props.todayButton,utcOffset:this.props.utcOffset,outsideClickIgnoreClass:b,fixedHeight:this.props.fixedHeight,monthsShown:this.props.monthsShown,onDropdownFocus:this.handleDropdownFocus,onMonthChange:this.props.onMonthChange,className:this.props.calendarClassName},this.props.children):null},renderDateInput:function(){var t=(0,f.default)(this.props.className,r({},b,this.state.open));return d.default.createElement(a.default,{ref:"input",disableDateAutoCorrection:this.props.disableDateAutoCorrection,id:this.props.id,name:this.props.name,autoFocus:this.props.autoFocus,date:this.props.selected,locale:this.props.locale,minDate:this.props.minDate,maxDate:this.props.maxDate,excludeDates:this.props.excludeDates,includeDates:this.props.includeDates,filterDate:this.props.filterDate,dateFormat:this.props.dateFormat,onFocus:this.handleFocus,onBlur:this.handleBlur,onClick:this.onInputClick,onChangeRaw:this.props.onChangeRaw,onKeyDown:this.onInputKeyDown,onChangeDate:this.setSelected,placeholder:this.props.placeholderText,disabled:this.props.disabled,autoComplete:this.props.autoComplete,className:t,title:this.props.title,readOnly:this.props.readOnly,required:this.props.required,tabIndex:this.props.tabIndex,customInput:this.props.customInput})},renderClearButton:function(){return this.props.isClearable&&null!=this.props.selected?d.default.createElement("a",{className:"react-datepicker__close-icon",href:"#",onClick:this.onClearClick}):null},render:function(){var t=this.renderCalendar();return this.props.inline&&!this.props.withPortal?t:this.props.withPortal?d.default.createElement("div",null,this.props.inline?null:d.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?d.default.createElement("div",{className:"react-datepicker__portal"},t):null):d.default.createElement(c.default,{classPrefix:"react-datepicker__tether",attachment:this.props.popoverAttachment,targetAttachment:this.props.popoverTargetAttachment,targetOffset:this.props.popoverTargetOffset,renderElementTo:this.props.renderCalendarTo,constraints:this.props.tetherConstraints},d.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),t)}});t.exports=C},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function r(t,e){var n={};for(var o in t)e.indexOf(o)>=0||Object.prototype.hasOwnProperty.call(t,o)&&(n[o]=t[o]);return n}var i=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},a=n(2),s=o(a),l=n(3),p=o(l),d=n(4),h=p.default.createClass({displayName:"DateInput",getDefaultProps:function(){return{dateFormat:"L",disableDateAutoCorrection:!1}},getInitialState:function(){return{value:this.safeDateFormat(this.props)}},componentWillReceiveProps:function(t){(0,d.isSameDay)(t.date,this.props.date)&&(0,d.isSameUtcOffset)(t.date,this.props.date)&&t.locale===this.props.locale&&t.dateFormat===this.props.dateFormat||(!this.props.disableDateAutoCorrection||t.date&&t.date.isValid())&&this.setState({value:this.safeDateFormat(t)})},handleChange:function(t){this.props.onChange&&this.props.onChange(t),this.props.onChangeRaw&&this.props.onChangeRaw(t),t.defaultPrevented||this.handleChangeDate(t.target.value)},handleChangeDate:function(t){if(this.props.onChangeDate){var e=(0,s.default)(t.trim(),this.props.dateFormat,this.props.locale||s.default.locale(),!0);e.isValid()&&!(0,d.isDayDisabled)(e,this.props)?this.props.onChangeDate(e):""===t?this.props.onChangeDate(null):this.props.disableDateAutoCorrection&&!e.isValid()&&this.props.onChangeDate(null)}this.setState({value:t})},safeDateFormat:function(t){return t.date&&t.date.clone().locale(t.locale||s.default.locale()).format(Array.isArray(t.dateFormat)?t.dateFormat[0]:t.dateFormat)||""},handleBlur:function(t){var e=this.safeDateFormat(this.props);this.props.disableDateAutoCorrection&&""===e||this.setState({value:e}),this.props.onBlur&&this.props.onBlur(t)},focus:function(){this.refs.input.focus()},render:function(){var t=this.props,e=t.customInput,n=(t.date,t.disableDateAutoCorrection,t.locale,t.minDate,t.maxDate,t.excludeDates,t.includeDates,t.filterDate,t.dateFormat,t.onChangeDate,t.onChangeRaw,r(t,["customInput","date","disableDateAutoCorrection","locale","minDate","maxDate","excludeDates","includeDates","filterDate","dateFormat","onChangeDate","onChangeRaw"]));return e?p.default.cloneElement(e,i({},n,{ref:"input",value:this.state.value,onBlur:this.handleBlur,onChange:this.handleChange})):p.default.createElement("input",i({ref:"input",type:"text"},n,{value:this.state.value,onBlur:this.handleBlur,onChange:this.handleChange}))}});t.exports=h},function(e,n){e.exports=t},function(t,n){t.exports=e},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function r(t,e){return t&&e?t.isSame(e,"day"):!t&&!e}function i(t,e){return t&&e?t.utcOffset()===e.utcOffset():!t&&!e}function a(t,e,n){var o=e.clone().startOf("day").subtract(1,"seconds"),r=n.clone().startOf("day").add(1,"seconds");return t.clone().startOf("day").isBetween(o,r)}function s(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.minDate,o=e.maxDate,i=e.excludeDates,a=e.includeDates,s=e.filterDate;return n&&t.isBefore(n,"day")||o&&t.isAfter(o,"day")||i&&i.some(function(e){return r(t,e)})||a&&!a.some(function(e){return r(t,e)})||s&&!s(t.clone())||!1}function l(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=n.minDate,r=n.includeDates,i=t.clone().subtract(1,e);return o&&i.isBefore(o,e)||r&&r.every(function(t){return i.isBefore(t,e)})||!1}function p(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=n.maxDate,r=n.includeDates,i=t.clone().add(1,e);return o&&i.isAfter(o,e)||r&&r.every(function(t){return i.isAfter(t,e)})||!1}function d(t){var e=t.minDate,n=t.includeDates;return n&&e?u.default.min(n.filter(function(t){return e.isSameOrBefore(t,"day")})):n?u.default.min(n):e}function h(t){var e=t.maxDate,n=t.includeDates;return n&&e?u.default.max(n.filter(function(t){return e.isSameOrAfter(t,"day")})):n?u.default.max(n):e}Object.defineProperty(e,"__esModule",{value:!0}),e.isSameDay=r,e.isSameUtcOffset=i,e.isDayInRange=a,e.isDayDisabled=s,e.allDaysDisabledBefore=l,e.allDaysDisabledAfter=p,e.getEffectiveMinDate=d,e.getEffectiveMaxDate=h;var c=n(2),u=o(c)},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}var r=n(2),i=o(r),a=n(6),s=o(a),l=n(10),p=o(l),d=n(12),h=o(d),c=n(3),u=o(c),f=n(8),m=o(f),g=n(4),v=["react-datepicker__year-select","react-datepicker__month-select"],y=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=(t.className||"").split(/\s+/);return v.some(function(t){return e.indexOf(t)>=0})},D=u.default.createClass({displayName:"Calendar",defaultProps:{onDropdownFocus:function(){}},getDefaultProps:function(){return{utcOffset:i.default.utc().utcOffset(),monthsShown:1,forceShowMonthNavigation:!1}},getInitialState:function(){return{date:this.localizeMoment(this.getDateInView()),selectingDate:null}},componentWillReceiveProps:function(t){t.preSelection&&!(0,g.isSameDay)(t.preSelection,this.props.preSelection)?this.setState({date:this.localizeMoment(t.preSelection)}):t.openToDate&&!(0,g.isSameDay)(t.openToDate,this.props.openToDate)&&this.setState({date:this.localizeMoment(t.openToDate)})},handleClickOutside:function(t){this.props.onClickOutside(t)},handleDropdownFocus:function(t){y(t.target)&&this.props.onDropdownFocus()},getDateInView:function(){var t=this.props,e=t.preSelection,n=t.selected,o=t.openToDate,r=t.utcOffset,a=(0,g.getEffectiveMinDate)(this.props),s=(0,g.getEffectiveMaxDate)(this.props),l=i.default.utc().utcOffset(r),p=e||n;return p?p:a&&s&&o&&o.isBetween(a,s)?o:a&&o&&o.isAfter(a)?o:a&&a.isAfter(l)?a:s&&o&&o.isBefore(s)?o:s&&s.isBefore(l)?s:o?o:l},localizeMoment:function(t){return t.clone().locale(this.props.locale||i.default.locale())},increaseMonth:function(){var t=this;this.setState({date:this.state.date.clone().add(1,"month")},function(){return t.handleMonthChange(t.state.date)})},decreaseMonth:function(){var t=this;this.setState({date:this.state.date.clone().subtract(1,"month")},function(){return t.handleMonthChange(t.state.date)})},handleDayClick:function(t,e){this.props.onSelect(t,e)},handleDayMouseEnter:function(t){this.setState({selectingDate:t})},handleMonthMouseLeave:function(){this.setState({selectingDate:null})},handleMonthChange:function(t){this.props.onMonthChange&&this.props.onMonthChange(t)},changeYear:function(t){this.setState({date:this.state.date.clone().set("year",t)})},changeMonth:function(t){var e=this;this.setState({date:this.state.date.clone().set("month",t)},function(){return e.handleMonthChange(e.state.date)})},header:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.state.date,e=t.clone().startOf("week"),n=[];return this.props.showWeekNumbers&&n.push(u.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},"#")),n.concat([0,1,2,3,4,5,6].map(function(t){var n=e.clone().add(t,"days");return u.default.createElement("div",{key:t,className:"react-datepicker__day-name"},n.localeData().weekdaysMin(n))}))},renderPreviousMonthButton:function(){if(this.props.forceShowMonthNavigation||!(0,g.allDaysDisabledBefore)(this.state.date,"month",this.props))return u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--previous",onClick:this.decreaseMonth})},renderNextMonthButton:function(){if(this.props.forceShowMonthNavigation||!(0,g.allDaysDisabledAfter)(this.state.date,"month",this.props))return u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--next",onClick:this.increaseMonth})},renderCurrentMonth:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.state.date,e=["react-datepicker__current-month"];return this.props.showYearDropdown&&e.push("react-datepicker__current-month--hasYearDropdown"),this.props.showMonthDropdown&&e.push("react-datepicker__current-month--hasMonthDropdown"),u.default.createElement("div",{className:e.join(" ")},t.format(this.props.dateFormat))},renderYearDropdown:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(this.props.showYearDropdown&&!t)return u.default.createElement(s.default,{dropdownMode:this.props.dropdownMode,onChange:this.changeYear,minDate:this.props.minDate,maxDate:this.props.maxDate,year:this.state.date.year(),scrollableYearDropdown:this.props.scrollableYearDropdown})},renderMonthDropdown:function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(this.props.showMonthDropdown)return u.default.createElement(p.default,{dropdownMode:this.props.dropdownMode,locale:this.props.locale,onChange:this.changeMonth,month:this.state.date.month()})},renderTodayButton:function(){var t=this;if(this.props.todayButton)return u.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return t.props.onSelect(i.default.utc().utcOffset(t.props.utcOffset).startOf("date"),e)}},this.props.todayButton)},renderMonths:function(){for(var t=[],e=0;e<this.props.monthsShown;++e){var n=this.state.date.clone().add(e,"M"),o="month-"+e;t.push(u.default.createElement("div",{key:o,className:"react-datepicker__month-container"},u.default.createElement("div",{className:"react-datepicker__header"},this.renderCurrentMonth(n),u.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--"+this.props.dropdownMode,onFocus:this.handleDropdownFocus},this.renderMonthDropdown(0!==e),this.renderYearDropdown(0!==e)),u.default.createElement("div",{className:"react-datepicker__day-names"},this.header(n))),u.default.createElement(h.default,{day:n,onDayClick:this.handleDayClick,onDayMouseEnter:this.handleDayMouseEnter,onMouseLeave:this.handleMonthMouseLeave,minDate:this.props.minDate,maxDate:this.props.maxDate,excludeDates:this.props.excludeDates,highlightDates:this.props.highlightDates,selectingDate:this.state.selectingDate,includeDates:this.props.includeDates,inline:this.props.inline,fixedHeight:this.props.fixedHeight,filterDate:this.props.filterDate,preSelection:this.props.preSelection,selected:this.props.selected,selectsStart:this.props.selectsStart,selectsEnd:this.props.selectsEnd,showWeekNumbers:this.props.showWeekNumbers,startDate:this.props.startDate,endDate:this.props.endDate,peekNextMonth:this.props.peekNextMonth,utcOffset:this.props.utcOffset})))}return t},render:function(){return u.default.createElement("div",{className:(0,m.default)("react-datepicker",this.props.className)},u.default.createElement("div",{className:"react-datepicker__triangle"}),this.renderPreviousMonthButton(),this.renderNextMonthButton(),this.renderMonths(),this.renderTodayButton(),this.props.children)}});t.exports=D},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}var r=n(3),i=o(r),a=n(7),s=o(a),l=n(9),p=o(l),d=(0,p.default)(s.default),h=i.default.createClass({displayName:"YearDropdown",getInitialState:function(){return{dropdownVisible:!1}},renderSelectOptions:function(){for(var t=this.props.minDate?this.props.minDate.year():1900,e=this.props.maxDate?this.props.maxDate.year():2100,n=[],o=t;o<=e;o++)n.push(i.default.createElement("option",{key:o,value:o},o));return n},onSelectChange:function(t){this.onChange(t.target.value)},renderSelectMode:function(){return i.default.createElement("select",{value:this.props.year,className:"react-datepicker__year-select",onChange:this.onSelectChange},this.renderSelectOptions())},renderReadView:function(t){return i.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:this.toggleDropdown},i.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),i.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},this.props.year))},renderDropdown:function(){return i.default.createElement(d,{key:"dropdown",ref:"options",year:this.props.year,onChange:this.onChange,onCancel:this.toggleDropdown,scrollableYearDropdown:this.props.scrollableYearDropdown})},renderScrollMode:function(){var t=this.state.dropdownVisible,e=[this.renderReadView(!t)];return t&&e.unshift(this.renderDropdown()),e},onChange:function(t){this.toggleDropdown(),t!==this.props.year&&this.props.onChange(t)},toggleDropdown:function(){this.setState({dropdownVisible:!this.state.dropdownVisible})},render:function(){var t=void 0;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode()}return i.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--"+this.props.dropdownMode},t)}});t.exports=h},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function r(t,e){for(var n=[],o=0;o<2*e;o++)n.push(t+e-o);return n}var i=n(3),a=o(i),s=n(8),l=o(s),p=a.default.createClass({displayName:"YearDropdownOptions",getInitialState:function(){return{yearsList:this.props.scrollableYearDropdown?r(this.props.year,10):r(this.props.year,5)}},renderOptions:function(){var t=this,e=this.props.year,n=this.state.yearsList.map(function(n){return a.default.createElement("div",{className:"react-datepicker__year-option",key:n,ref:n,onClick:t.onChange.bind(t,n)},e===n?a.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",n)});return n.unshift(a.default.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:this.incrementYears},a.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),n.push(a.default.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:this.decrementYears},a.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),n},onChange:function(t){this.props.onChange(t)},handleClickOutside:function(){this.props.onCancel()},shiftYears:function(t){var e=this.state.yearsList.map(function(e){return e+t});this.setState({yearsList:e})},incrementYears:function(){return this.shiftYears(1)},decrementYears:function(){return this.shiftYears(-1)},render:function(){var t=(0,l.default)({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return a.default.createElement("div",{className:t},this.renderOptions())}});t.exports=p},function(t,e,n){var o,r;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
	!function(){"use strict";function n(){for(var t=[],e=0;e<arguments.length;e++){var o=arguments[e];if(o){var r=typeof o;if("string"===r||"number"===r)t.push(o);else if(Array.isArray(o))t.push(n.apply(null,o));else if("object"===r)for(var a in o)i.call(o,a)&&o[a]&&t.push(a)}}return t.join(" ")}var i={}.hasOwnProperty;"undefined"!=typeof t&&t.exports?t.exports=n:(o=[],r=function(){return n}.apply(e,o),!(void 0!==r&&(t.exports=r)))}()},function(t,e){t.exports=n},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}var r=n(3),i=o(r),a=n(11),s=o(a),l=n(9),p=o(l),d=n(2),h=o(d),c=(0,p.default)(s.default),u=i.default.createClass({displayName:"MonthDropdown",getInitialState:function(){return{dropdownVisible:!1}},renderSelectOptions:function(t){return t.map(function(t,e){return i.default.createElement("option",{key:e,value:e},t)})},renderSelectMode:function(t){var e=this;return i.default.createElement("select",{value:this.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},this.renderSelectOptions(t))},renderReadView:function(t,e){return i.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:this.toggleDropdown},i.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},e[this.props.month]),i.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}))},renderDropdown:function(t){return i.default.createElement(c,{key:"dropdown",ref:"options",month:this.props.month,monthNames:t,onChange:this.onChange,onCancel:this.toggleDropdown})},renderScrollMode:function(t){var e=this.state.dropdownVisible,n=[this.renderReadView(!e,t)];return e&&n.unshift(this.renderDropdown(t)),n},onChange:function(t){this.toggleDropdown(),t!==this.props.month&&this.props.onChange(t)},toggleDropdown:function(){this.setState({dropdownVisible:!this.state.dropdownVisible})},render:function(){var t=h.default.localeData(this.props.locale),e=[0,1,2,3,4,5,6,7,8,9,10,11].map(function(e){return t.months((0,h.default)({M:e}))}),n=void 0;switch(this.props.dropdownMode){case"scroll":n=this.renderScrollMode(e);break;case"select":n=this.renderSelectMode(e)}return i.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--"+this.props.dropdownMode},n)}});t.exports=u},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}var r=n(3),i=o(r),a=i.default.createClass({displayName:"MonthDropdownOptions",renderOptions:function(){var t=this,e=this.props.month,n=this.props.monthNames.map(function(n,o){return i.default.createElement("div",{className:"react-datepicker__month-option",key:n,ref:n,onClick:t.onChange.bind(t,o)},e===o?i.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",n)});return n},onChange:function(t){this.props.onChange(t)},handleClickOutside:function(){this.props.onCancel()},render:function(){return i.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}});t.exports=a},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}var r=n(3),i=o(r),a=n(8),s=o(a),l=n(13),p=o(l),d=6,h=i.default.createClass({displayName:"Month",handleDayClick:function(t,e){this.props.onDayClick&&this.props.onDayClick(t,e)},handleDayMouseEnter:function(t){this.props.onDayMouseEnter&&this.props.onDayMouseEnter(t)},handleMouseLeave:function(){this.props.onMouseLeave&&this.props.onMouseLeave()},isWeekInMonth:function(t){var e=this.props.day,n=t.clone().add(6,"days");return t.isSame(e,"month")||n.isSame(e,"month")},renderWeeks:function(){for(var t=[],e=this.props.fixedHeight,n=this.props.day.clone().startOf("month").startOf("week"),o=0,r=!1;;){if(t.push(i.default.createElement(p.default,{key:o,day:n,month:this.props.day.month(),onDayClick:this.handleDayClick,onDayMouseEnter:this.handleDayMouseEnter,minDate:this.props.minDate,maxDate:this.props.maxDate,excludeDates:this.props.excludeDates,includeDates:this.props.includeDates,inline:this.props.inline,highlightDates:this.props.highlightDates,selectingDate:this.props.selectingDate,filterDate:this.props.filterDate,preSelection:this.props.preSelection,selected:this.props.selected,selectsStart:this.props.selectsStart,selectsEnd:this.props.selectsEnd,showWeekNumber:this.props.showWeekNumbers,startDate:this.props.startDate,endDate:this.props.endDate,utcOffset:this.props.utcOffset})),r)break;o++,n=n.clone().add(1,"weeks");var a=e&&o>=d,s=!e&&!this.isWeekInMonth(n);if(a||s){if(!this.props.peekNextMonth)break;r=!0}}return t},getClassNames:function(){var t=this.props,e=t.selectingDate,n=t.selectsStart,o=t.selectsEnd;return(0,s.default)("react-datepicker__month",{"react-datepicker__month--selecting-range":e&&(n||o)})},render:function(){return i.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox"},this.renderWeeks())}});t.exports=h},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}var r=n(3),i=o(r),a=n(14),s=o(a),l=n(15),p=o(l),d=i.default.createClass({displayName:"Week",handleDayClick:function(t,e){this.props.onDayClick&&this.props.onDayClick(t,e)},handleDayMouseEnter:function(t){this.props.onDayMouseEnter&&this.props.onDayMouseEnter(t)},renderDays:function(){var t=this,e=this.props.day.clone().startOf("week"),n=[];return this.props.showWeekNumber&&n.push(i.default.createElement(p.default,{key:"W",weekNumber:parseInt(e.format("w"),10)})),n.concat([0,1,2,3,4,5,6].map(function(n){var o=e.clone().add(n,"days");return i.default.createElement(s.default,{key:n,day:o,month:t.props.month,onClick:t.handleDayClick.bind(t,o),onMouseEnter:t.handleDayMouseEnter.bind(t,o),minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,includeDates:t.props.includeDates,inline:t.props.inline,highlightDates:t.props.highlightDates,selectingDate:t.props.selectingDate,filterDate:t.props.filterDate,preSelection:t.props.preSelection,selected:t.props.selected,selectsStart:t.props.selectsStart,selectsEnd:t.props.selectsEnd,startDate:t.props.startDate,endDate:t.props.endDate,utcOffset:t.props.utcOffset})}))},render:function(){return i.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}});t.exports=d},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}var r=n(2),i=o(r),a=n(3),s=o(a),l=n(8),p=o(l),d=n(4),h=s.default.createClass({displayName:"Day",getDefaultProps:function(){return{utcOffset:i.default.utc().utcOffset()}},handleClick:function(t){!this.isDisabled()&&this.props.onClick&&this.props.onClick(t)},handleMouseEnter:function(t){!this.isDisabled()&&this.props.onMouseEnter&&this.props.onMouseEnter(t)},isSameDay:function(t){return(0,d.isSameDay)(this.props.day,t)},isKeyboardSelected:function(){return!this.props.inline&&!this.isSameDay(this.props.selected)&&this.isSameDay(this.props.preSelection)},isDisabled:function(){return(0,d.isDayDisabled)(this.props.day,this.props)},isHighlighted:function(){var t=this.props,e=t.day,n=t.highlightDates;return!!n&&n.some(function(t){return(0,d.isSameDay)(e,t)})},isInRange:function(){var t=this.props,e=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&(0,d.isDayInRange)(e,n,o)},isInSelectingRange:function(){var t=this.props,e=t.day,n=t.selectsStart,o=t.selectsEnd,r=t.selectingDate,i=t.startDate,a=t.endDate;return!(!n&&!o||!r||this.isDisabled())&&(n&&a&&r.isSameOrBefore(a)?(0,d.isDayInRange)(e,r,a):!!(o&&i&&r.isSameOrAfter(i))&&(0,d.isDayInRange)(e,i,r))},isSelectingRangeStart:function(){if(!this.isInSelectingRange())return!1;var t=this.props,e=t.day,n=t.selectingDate,o=t.startDate,r=t.selectsStart;return r?(0,d.isSameDay)(e,n):(0,d.isSameDay)(e,o)},isSelectingRangeEnd:function(){if(!this.isInSelectingRange())return!1;var t=this.props,e=t.day,n=t.selectingDate,o=t.endDate,r=t.selectsEnd;return r?(0,d.isSameDay)(e,n):(0,d.isSameDay)(e,o)},isRangeStart:function(){var t=this.props,e=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&(0,d.isSameDay)(n,e)},isRangeEnd:function(){var t=this.props,e=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&(0,d.isSameDay)(o,e)},isWeekend:function(){var t=this.props.day.day();return 0===t||6===t},isOutsideMonth:function(){return void 0!==this.props.month&&this.props.month!==this.props.day.month()},getClassNames:function(){return(0,p.default)("react-datepicker__day",{"react-datepicker__day--disabled":this.isDisabled(),"react-datepicker__day--selected":this.isSameDay(this.props.selected),"react-datepicker__day--keyboard-selected":this.isKeyboardSelected(),"react-datepicker__day--highlighted":this.isHighlighted(),"react-datepicker__day--range-start":this.isRangeStart(),"react-datepicker__day--range-end":this.isRangeEnd(),"react-datepicker__day--in-range":this.isInRange(),"react-datepicker__day--in-selecting-range":this.isInSelectingRange(),"react-datepicker__day--selecting-range-start":this.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":this.isSelectingRangeEnd(),"react-datepicker__day--today":this.isSameDay(i.default.utc().utcOffset(this.props.utcOffset)),"react-datepicker__day--weekend":this.isWeekend(),"react-datepicker__day--outside-month":this.isOutsideMonth()})},render:function(){return s.default.createElement("div",{className:this.getClassNames(),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-"+this.props.day.date(),role:"option"},this.props.day.date())}});t.exports=h},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}var r=n(3),i=o(r),a=i.default.createClass({displayName:"WeekNumber",render:function(){return i.default.createElement("div",{className:"react-datepicker__week-number","aria-label":"week-"+this.props.weekNumber},this.props.weekNumber)}});t.exports=a},function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function r(t,e){var n={};for(var o in t)e.indexOf(o)>=0||Object.prototype.hasOwnProperty.call(t,o)&&(n[o]=t[o]);return n}var i=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},a=n(3),s=o(a),l=n(17),p=o(l),d=n(18),h=o(d),c=s.default.createClass({displayName:"TetherComponent",getDefaultProps:function(){return{renderElementTag:"div",renderElementTo:null}},componentDidMount:function(){this._targetNode=p.default.findDOMNode(this),this._update()},componentDidUpdate:function(){this._update()},componentWillUnmount:function(){this._destroy()},disable:function(){this._tether.disable()},enable:function(){this._tether.enable()},position:function(){this._tether.position()},_destroy:function(){this._elementParentNode&&(p.default.unmountComponentAtNode(this._elementParentNode),this._elementParentNode.parentNode.removeChild(this._elementParentNode)),this._tether&&this._tether.destroy(),this._elementParentNode=null,this._tether=null},_update:function(){var t=this,e=this.props,n=e.children,o=e.renderElementTag,r=e.renderElementTo,i=n[1];if(!i)return void(this._tether&&this._destroy());if(!this._elementParentNode){this._elementParentNode=document.createElement(o);var a=r||document.body;a.appendChild(this._elementParentNode)}p.default.unstable_renderSubtreeIntoContainer(this,i,this._elementParentNode,function(){t._updateTether()})},_updateTether:function(){var t=this.props,e=(t.renderElementTag,t.renderElementTo,r(t,["renderElementTag","renderElementTo"])),n=i({target:this._targetNode,element:this._elementParentNode},e);this._tether?this._tether.setOptions(n):this._tether=new h.default(n),this._tether.position()},render:function(){var t=this.props.children,e=null;return a.Children.forEach(t,function(t,n){if(0===n)return e=t,!1}),e}});t.exports=c},function(t,e){t.exports=o},function(t,e,n){var o,r;/*! tether 1.4.0 */
	!function(i,a){o=a,r="function"==typeof o?o.call(e,n,e,t):o,!(void 0!==r&&(t.exports=r))}(this,function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t){var e=t.getBoundingClientRect(),n={};for(var o in e)n[o]=e[o];if(t.ownerDocument!==document){var i=t.ownerDocument.defaultView.frameElement;if(i){var a=r(i);n.top+=a.top,n.bottom+=a.top,n.left+=a.left,n.right+=a.left}}return n}function i(t){var e=getComputedStyle(t)||{},n=e.position,o=[];if("fixed"===n)return[t];for(var r=t;(r=r.parentNode)&&r&&1===r.nodeType;){var i=void 0;try{i=getComputedStyle(r)}catch(t){}if("undefined"==typeof i||null===i)return o.push(r),o;var a=i,s=a.overflow,l=a.overflowX,p=a.overflowY;/(auto|scroll)/.test(s+p+l)&&("absolute"!==n||["relative","absolute","fixed"].indexOf(i.position)>=0)&&o.push(r)}return o.push(t.ownerDocument.body),t.ownerDocument!==document&&o.push(t.ownerDocument.defaultView),o}function a(){E&&document.body.removeChild(E),E=null}function s(t){var e=void 0;t===document?(e=document,t=document.documentElement):e=t.ownerDocument;var n=e.documentElement,o=r(t),i=M();return o.top-=i.top,o.left-=i.left,"undefined"==typeof o.width&&(o.width=document.body.scrollWidth-o.left-o.right),"undefined"==typeof o.height&&(o.height=document.body.scrollHeight-o.top-o.bottom),o.top=o.top-n.clientTop,o.left=o.left-n.clientLeft,o.right=e.body.clientWidth-o.width-o.left,o.bottom=e.body.clientHeight-o.height-o.top,o}function l(t){return t.offsetParent||document.documentElement}function p(){if(x)return x;var t=document.createElement("div");t.style.width="100%",t.style.height="200px";var e=document.createElement("div");d(e.style,{position:"absolute",top:0,left:0,pointerEvents:"none",visibility:"hidden",width:"200px",height:"150px",overflow:"hidden"}),e.appendChild(t),document.body.appendChild(e);var n=t.offsetWidth;e.style.overflow="scroll";var o=t.offsetWidth;n===o&&(o=e.clientWidth),document.body.removeChild(e);var r=n-o;return x={width:r,height:r}}function d(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0],e=[];return Array.prototype.push.apply(e,arguments),e.slice(1).forEach(function(e){if(e)for(var n in e)({}).hasOwnProperty.call(e,n)&&(t[n]=e[n])}),t}function h(t,e){if("undefined"!=typeof t.classList)e.split(" ").forEach(function(e){e.trim()&&t.classList.remove(e)});else{var n=new RegExp("(^| )"+e.split(" ").join("|")+"( |$)","gi"),o=f(t).replace(n," ");m(t,o)}}function c(t,e){if("undefined"!=typeof t.classList)e.split(" ").forEach(function(e){e.trim()&&t.classList.add(e)});else{h(t,e);var n=f(t)+(" "+e);m(t,n)}}function u(t,e){if("undefined"!=typeof t.classList)return t.classList.contains(e);var n=f(t);return new RegExp("(^| )"+e+"( |$)","gi").test(n)}function f(t){return t.className instanceof t.ownerDocument.defaultView.SVGAnimatedString?t.className.baseVal:t.className}function m(t,e){t.setAttribute("class",e)}function g(t,e,n){n.forEach(function(n){e.indexOf(n)===-1&&u(t,n)&&h(t,n)}),e.forEach(function(e){u(t,e)||c(t,e)})}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function v(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function y(t,e){var n=arguments.length<=2||void 0===arguments[2]?1:arguments[2];return t+n>=e&&e>=t-n}function D(){return"undefined"!=typeof performance&&"undefined"!=typeof performance.now?performance.now():+new Date}function b(){for(var t={top:0,left:0},e=arguments.length,n=Array(e),o=0;o<e;o++)n[o]=arguments[o];return n.forEach(function(e){var n=e.top,o=e.left;"string"==typeof n&&(n=parseFloat(n,10)),"string"==typeof o&&(o=parseFloat(o,10)),t.top+=n,t.left+=o}),t}function w(t,e){return"string"==typeof t.left&&t.left.indexOf("%")!==-1&&(t.left=parseFloat(t.left,10)/100*e.width),"string"==typeof t.top&&t.top.indexOf("%")!==-1&&(t.top=parseFloat(t.top,10)/100*e.height),t}function C(t,e){return"scrollParent"===e?e=t.scrollParents[0]:"window"===e&&(e=[pageXOffset,pageYOffset,innerWidth+pageXOffset,innerHeight+pageYOffset]),e===document&&(e=e.documentElement),"undefined"!=typeof e.nodeType&&!function(){var t=e,n=s(e),o=n,r=getComputedStyle(e);if(e=[o.left,o.top,n.width+o.left,n.height+o.top],t.ownerDocument!==document){var i=t.ownerDocument.defaultView;e[0]+=i.pageXOffset,e[1]+=i.pageYOffset,e[2]+=i.pageXOffset,e[3]+=i.pageYOffset}$.forEach(function(t,n){t=t[0].toUpperCase()+t.substr(1),"Top"===t||"Left"===t?e[n]+=parseFloat(r["border"+t+"Width"]):e[n]-=parseFloat(r["border"+t+"Width"])})}(),e}var _=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),k=void 0;"undefined"==typeof k&&(k={modules:[]});var E=null,S=function(){var t=0;return function(){return++t}}(),O={},M=function(){var t=E;t&&document.body.contains(t)||(t=document.createElement("div"),t.setAttribute("data-tether-id",S()),d(t.style,{top:0,left:0,position:"absolute"}),document.body.appendChild(t),E=t);var e=t.getAttribute("data-tether-id");return"undefined"==typeof O[e]&&(O[e]=r(t),T(function(){delete O[e]})),O[e]},x=null,N=[],T=function(t){N.push(t)},A=function(){for(var t=void 0;t=N.pop();)t()},F=function(){function t(){o(this,t)}return _(t,[{key:"on",value:function(t,e,n){var o=!(arguments.length<=3||void 0===arguments[3])&&arguments[3];"undefined"==typeof this.bindings&&(this.bindings={}),"undefined"==typeof this.bindings[t]&&(this.bindings[t]=[]),this.bindings[t].push({handler:e,ctx:n,once:o})}},{key:"once",value:function(t,e,n){this.on(t,e,n,!0)}},{key:"off",value:function(t,e){if("undefined"!=typeof this.bindings&&"undefined"!=typeof this.bindings[t])if("undefined"==typeof e)delete this.bindings[t];else for(var n=0;n<this.bindings[t].length;)this.bindings[t][n].handler===e?this.bindings[t].splice(n,1):++n}},{key:"trigger",value:function(t){if("undefined"!=typeof this.bindings&&this.bindings[t]){for(var e=0,n=arguments.length,o=Array(n>1?n-1:0),r=1;r<n;r++)o[r-1]=arguments[r];for(;e<this.bindings[t].length;){var i=this.bindings[t][e],a=i.handler,s=i.ctx,l=i.once,p=s;"undefined"==typeof p&&(p=this),a.apply(p,o),l?this.bindings[t].splice(e,1):++e}}}}]),t}();k.Utils={getActualBoundingClientRect:r,getScrollParents:i,getBounds:s,getOffsetParent:l,extend:d,addClass:c,removeClass:h,hasClass:u,updateClasses:g,defer:T,flush:A,uniqueId:S,Evented:F,getScrollBarSize:p,removeUtilElements:a};var P=function(){function t(t,e){var n=[],o=!0,r=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(o=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);o=!0);}catch(t){r=!0,i=t}finally{try{!o&&s.return&&s.return()}finally{if(r)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),_=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),B=function(t,e,n){for(var o=!0;o;){var r=t,i=e,a=n;o=!1,null===r&&(r=Function.prototype);var s=Object.getOwnPropertyDescriptor(r,i);if(void 0!==s){if("value"in s)return s.value;var l=s.get;if(void 0===l)return;return l.call(a)}var p=Object.getPrototypeOf(r);if(null===p)return;t=p,e=i,n=a,o=!0,s=p=void 0}};if("undefined"==typeof k)throw new Error("You must include the utils.js file before tether.js");var I=k.Utils,i=I.getScrollParents,s=I.getBounds,l=I.getOffsetParent,d=I.extend,c=I.addClass,h=I.removeClass,g=I.updateClasses,T=I.defer,A=I.flush,p=I.getScrollBarSize,a=I.removeUtilElements,W=function(){if("undefined"==typeof document)return"";for(var t=document.createElement("div"),e=["transform","WebkitTransform","OTransform","MozTransform","msTransform"],n=0;n<e.length;++n){var o=e[n];if(void 0!==t.style[o])return o}}(),Y=[],R=function(){Y.forEach(function(t){t.position(!1)}),A()};!function(){var t=null,e=null,n=null,o=function o(){return"undefined"!=typeof e&&e>16?(e=Math.min(e-16,250),void(n=setTimeout(o,250))):void("undefined"!=typeof t&&D()-t<10||(null!=n&&(clearTimeout(n),n=null),t=D(),R(),e=D()-t))};"undefined"!=typeof window&&"undefined"!=typeof window.addEventListener&&["resize","scroll","touchmove"].forEach(function(t){window.addEventListener(t,o)})}();var j={center:"center",left:"right",right:"left"},L={middle:"middle",top:"bottom",bottom:"top"},V={top:0,left:0,middle:"50%",center:"50%",bottom:"100%",right:"100%"},z=function(t,e){var n=t.left,o=t.top;return"auto"===n&&(n=j[e.left]),"auto"===o&&(o=L[e.top]),{left:n,top:o}},H=function(t){var e=t.left,n=t.top;return"undefined"!=typeof V[t.left]&&(e=V[t.left]),"undefined"!=typeof V[t.top]&&(n=V[t.top]),{left:e,top:n}},X=function(t){var e=t.split(" "),n=P(e,2),o=n[0],r=n[1];return{top:o,left:r}},U=X,q=function(t){function e(t){var n=this;o(this,e),B(Object.getPrototypeOf(e.prototype),"constructor",this).call(this),this.position=this.position.bind(this),Y.push(this),this.history=[],this.setOptions(t,!1),k.modules.forEach(function(t){"undefined"!=typeof t.initialize&&t.initialize.call(n)}),this.position()}return v(e,t),_(e,[{key:"getClass",value:function(){var t=arguments.length<=0||void 0===arguments[0]?"":arguments[0],e=this.options.classes;return"undefined"!=typeof e&&e[t]?this.options.classes[t]:this.options.classPrefix?this.options.classPrefix+"-"+t:t}},{key:"setOptions",value:function(t){var e=this,n=arguments.length<=1||void 0===arguments[1]||arguments[1],o={offset:"0 0",targetOffset:"0 0",targetAttachment:"auto auto",classPrefix:"tether"};this.options=d(o,t);var r=this.options,a=r.element,s=r.target,l=r.targetModifier;if(this.element=a,this.target=s,this.targetModifier=l,"viewport"===this.target?(this.target=document.body,this.targetModifier="visible"):"scroll-handle"===this.target&&(this.target=document.body,this.targetModifier="scroll-handle"),["element","target"].forEach(function(t){if("undefined"==typeof e[t])throw new Error("Tether Error: Both element and target must be defined");"undefined"!=typeof e[t].jquery?e[t]=e[t][0]:"string"==typeof e[t]&&(e[t]=document.querySelector(e[t]))}),c(this.element,this.getClass("element")),this.options.addTargetClasses!==!1&&c(this.target,this.getClass("target")),!this.options.attachment)throw new Error("Tether Error: You must provide an attachment");this.targetAttachment=U(this.options.targetAttachment),this.attachment=U(this.options.attachment),this.offset=X(this.options.offset),this.targetOffset=X(this.options.targetOffset),"undefined"!=typeof this.scrollParents&&this.disable(),"scroll-handle"===this.targetModifier?this.scrollParents=[this.target]:this.scrollParents=i(this.target),this.options.enabled!==!1&&this.enable(n)}},{key:"getTargetBounds",value:function(){if("undefined"==typeof this.targetModifier)return s(this.target);if("visible"===this.targetModifier){if(this.target===document.body)return{top:pageYOffset,left:pageXOffset,height:innerHeight,width:innerWidth};var t=s(this.target),e={height:t.height,width:t.width,top:t.top,left:t.left};return e.height=Math.min(e.height,t.height-(pageYOffset-t.top)),e.height=Math.min(e.height,t.height-(t.top+t.height-(pageYOffset+innerHeight))),e.height=Math.min(innerHeight,e.height),e.height-=2,e.width=Math.min(e.width,t.width-(pageXOffset-t.left)),e.width=Math.min(e.width,t.width-(t.left+t.width-(pageXOffset+innerWidth))),e.width=Math.min(innerWidth,e.width),e.width-=2,e.top<pageYOffset&&(e.top=pageYOffset),e.left<pageXOffset&&(e.left=pageXOffset),e}if("scroll-handle"===this.targetModifier){var t=void 0,n=this.target;n===document.body?(n=document.documentElement,t={left:pageXOffset,top:pageYOffset,height:innerHeight,width:innerWidth}):t=s(n);var o=getComputedStyle(n),r=n.scrollWidth>n.clientWidth||[o.overflow,o.overflowX].indexOf("scroll")>=0||this.target!==document.body,i=0;r&&(i=15);var a=t.height-parseFloat(o.borderTopWidth)-parseFloat(o.borderBottomWidth)-i,e={width:15,height:.975*a*(a/n.scrollHeight),left:t.left+t.width-parseFloat(o.borderLeftWidth)-15},l=0;a<408&&this.target===document.body&&(l=-11e-5*Math.pow(a,2)-.00727*a+22.58),this.target!==document.body&&(e.height=Math.max(e.height,24));var p=this.target.scrollTop/(n.scrollHeight-a);return e.top=p*(a-e.height-l)+t.top+parseFloat(o.borderTopWidth),this.target===document.body&&(e.height=Math.max(e.height,24)),e}}},{key:"clearCache",value:function(){this._cache={}}},{key:"cache",value:function(t,e){return"undefined"==typeof this._cache&&(this._cache={}),"undefined"==typeof this._cache[t]&&(this._cache[t]=e.call(this)),this._cache[t]}},{key:"enable",value:function(){var t=this,e=arguments.length<=0||void 0===arguments[0]||arguments[0];this.options.addTargetClasses!==!1&&c(this.target,this.getClass("enabled")),c(this.element,this.getClass("enabled")),this.enabled=!0,this.scrollParents.forEach(function(e){e!==t.target.ownerDocument&&e.addEventListener("scroll",t.position)}),e&&this.position()}},{key:"disable",value:function(){var t=this;h(this.target,this.getClass("enabled")),h(this.element,this.getClass("enabled")),this.enabled=!1,"undefined"!=typeof this.scrollParents&&this.scrollParents.forEach(function(e){e.removeEventListener("scroll",t.position)})}},{key:"destroy",value:function(){var t=this;this.disable(),Y.forEach(function(e,n){e===t&&Y.splice(n,1)}),0===Y.length&&a()}},{key:"updateAttachClasses",value:function(t,e){var n=this;t=t||this.attachment,e=e||this.targetAttachment;var o=["left","top","bottom","right","middle","center"];"undefined"!=typeof this._addAttachClasses&&this._addAttachClasses.length&&this._addAttachClasses.splice(0,this._addAttachClasses.length),"undefined"==typeof this._addAttachClasses&&(this._addAttachClasses=[]);var r=this._addAttachClasses;t.top&&r.push(this.getClass("element-attached")+"-"+t.top),t.left&&r.push(this.getClass("element-attached")+"-"+t.left),e.top&&r.push(this.getClass("target-attached")+"-"+e.top),e.left&&r.push(this.getClass("target-attached")+"-"+e.left);var i=[];o.forEach(function(t){i.push(n.getClass("element-attached")+"-"+t),i.push(n.getClass("target-attached")+"-"+t)}),T(function(){"undefined"!=typeof n._addAttachClasses&&(g(n.element,n._addAttachClasses,i),n.options.addTargetClasses!==!1&&g(n.target,n._addAttachClasses,i),delete n._addAttachClasses)})}},{key:"position",value:function(){var t=this,e=arguments.length<=0||void 0===arguments[0]||arguments[0];if(this.enabled){this.clearCache();var n=z(this.targetAttachment,this.attachment);this.updateAttachClasses(this.attachment,n);var o=this.cache("element-bounds",function(){return s(t.element)}),r=o.width,i=o.height;if(0===r&&0===i&&"undefined"!=typeof this.lastSize){var a=this.lastSize;r=a.width,i=a.height}else this.lastSize={width:r,height:i};var d=this.cache("target-bounds",function(){return t.getTargetBounds()}),h=d,c=w(H(this.attachment),{width:r,height:i}),u=w(H(n),h),f=w(this.offset,{width:r,height:i}),m=w(this.targetOffset,h);c=b(c,f),u=b(u,m);for(var g=d.left+u.left-c.left,v=d.top+u.top-c.top,y=0;y<k.modules.length;++y){var D=k.modules[y],C=D.position.call(this,{left:g,top:v,targetAttachment:n,targetPos:d,elementPos:o,offset:c,targetOffset:u,manualOffset:f,manualTargetOffset:m,scrollbarSize:O,attachment:this.attachment});if(C===!1)return!1;"undefined"!=typeof C&&"object"==typeof C&&(v=C.top,g=C.left)}var _={page:{top:v,left:g},viewport:{top:v-pageYOffset,bottom:pageYOffset-v-i+innerHeight,left:g-pageXOffset,right:pageXOffset-g-r+innerWidth}},E=this.target.ownerDocument,S=E.defaultView,O=void 0;return S.innerHeight>E.documentElement.clientHeight&&(O=this.cache("scrollbar-size",p),_.viewport.bottom-=O.height),S.innerWidth>E.documentElement.clientWidth&&(O=this.cache("scrollbar-size",p),_.viewport.right-=O.width),["","static"].indexOf(E.body.style.position)!==-1&&["","static"].indexOf(E.body.parentElement.style.position)!==-1||(_.page.bottom=E.body.scrollHeight-v-i,_.page.right=E.body.scrollWidth-g-r),"undefined"!=typeof this.options.optimizations&&this.options.optimizations.moveElement!==!1&&"undefined"==typeof this.targetModifier&&!function(){var e=t.cache("target-offsetparent",function(){return l(t.target)}),n=t.cache("target-offsetparent-bounds",function(){return s(e)}),o=getComputedStyle(e),r=n,i={};if(["Top","Left","Bottom","Right"].forEach(function(t){i[t.toLowerCase()]=parseFloat(o["border"+t+"Width"])}),n.right=E.body.scrollWidth-n.left-r.width+i.right,n.bottom=E.body.scrollHeight-n.top-r.height+i.bottom,_.page.top>=n.top+i.top&&_.page.bottom>=n.bottom&&_.page.left>=n.left+i.left&&_.page.right>=n.right){var a=e.scrollTop,p=e.scrollLeft;_.offset={top:_.page.top-n.top+a-i.top,left:_.page.left-n.left+p-i.left}}}(),this.move(_),this.history.unshift(_),this.history.length>3&&this.history.pop(),e&&A(),!0}}},{key:"move",value:function(t){var e=this;if("undefined"!=typeof this.element.parentNode){var n={};for(var o in t){n[o]={};for(var r in t[o]){for(var i=!1,a=0;a<this.history.length;++a){var s=this.history[a];if("undefined"!=typeof s[o]&&!y(s[o][r],t[o][r])){i=!0;break}}i||(n[o][r]=!0)}}var p={top:"",left:"",right:"",bottom:""},h=function(t,n){var o="undefined"!=typeof e.options.optimizations,r=o?e.options.optimizations.gpu:null;if(r!==!1){var i=void 0,a=void 0;if(t.top?(p.top=0,i=n.top):(p.bottom=0,i=-n.bottom),t.left?(p.left=0,a=n.left):(p.right=0,a=-n.right),window.matchMedia){var s=window.matchMedia("only screen and (min-resolution: 1.3dppx)").matches||window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 1.3)").matches;s||(a=Math.round(a),i=Math.round(i))}p[W]="translateX("+a+"px) translateY("+i+"px)","msTransform"!==W&&(p[W]+=" translateZ(0)")}else t.top?p.top=n.top+"px":p.bottom=n.bottom+"px",t.left?p.left=n.left+"px":p.right=n.right+"px"},c=!1;if((n.page.top||n.page.bottom)&&(n.page.left||n.page.right)?(p.position="absolute",h(n.page,t.page)):(n.viewport.top||n.viewport.bottom)&&(n.viewport.left||n.viewport.right)?(p.position="fixed",h(n.viewport,t.viewport)):"undefined"!=typeof n.offset&&n.offset.top&&n.offset.left?!function(){p.position="absolute";var o=e.cache("target-offsetparent",function(){return l(e.target)});l(e.element)!==o&&T(function(){e.element.parentNode.removeChild(e.element),o.appendChild(e.element)}),h(n.offset,t.offset),c=!0}():(p.position="absolute",h({top:!0,left:!0},t.page)),!c)if(this.options.bodyElement)this.options.bodyElement.appendChild(this.element);else{for(var u=!0,f=this.element.parentNode;f&&1===f.nodeType&&"BODY"!==f.tagName;){if("static"!==getComputedStyle(f).position){u=!1;break}f=f.parentNode}u||(this.element.parentNode.removeChild(this.element),this.element.ownerDocument.body.appendChild(this.element))}var m={},g=!1;for(var r in p){var v=p[r],D=this.element.style[r];D!==v&&(g=!0,m[r]=v)}g&&T(function(){d(e.element.style,m),e.trigger("repositioned")})}}}]),e}(F);q.modules=[],k.position=R;var K=d(q,k),P=function(){function t(t,e){var n=[],o=!0,r=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(o=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);o=!0);}catch(t){r=!0,i=t}finally{try{!o&&s.return&&s.return()}finally{if(r)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),I=k.Utils,s=I.getBounds,d=I.extend,g=I.updateClasses,T=I.defer,$=["left","top","right","bottom"];k.modules.push({position:function(t){var e=this,n=t.top,o=t.left,r=t.targetAttachment;if(!this.options.constraints)return!0;var i=this.cache("element-bounds",function(){return s(e.element)}),a=i.height,l=i.width;if(0===l&&0===a&&"undefined"!=typeof this.lastSize){var p=this.lastSize;l=p.width,a=p.height}var h=this.cache("target-bounds",function(){return e.getTargetBounds()}),c=h.height,u=h.width,f=[this.getClass("pinned"),this.getClass("out-of-bounds")];this.options.constraints.forEach(function(t){var e=t.outOfBoundsClass,n=t.pinnedClass;e&&f.push(e),n&&f.push(n)}),f.forEach(function(t){["left","top","right","bottom"].forEach(function(e){f.push(t+"-"+e)})});var m=[],v=d({},r),y=d({},this.attachment);return this.options.constraints.forEach(function(t){var i=t.to,s=t.attachment,p=t.pin;"undefined"==typeof s&&(s="");var d=void 0,h=void 0;if(s.indexOf(" ")>=0){var f=s.split(" "),g=P(f,2);h=g[0],d=g[1]}else d=h=s;var D=C(e,i);"target"!==h&&"both"!==h||(n<D[1]&&"top"===v.top&&(n+=c,v.top="bottom"),n+a>D[3]&&"bottom"===v.top&&(n-=c,v.top="top")),"together"===h&&("top"===v.top&&("bottom"===y.top&&n<D[1]?(n+=c,v.top="bottom",n+=a,y.top="top"):"top"===y.top&&n+a>D[3]&&n-(a-c)>=D[1]&&(n-=a-c,v.top="bottom",y.top="bottom")),"bottom"===v.top&&("top"===y.top&&n+a>D[3]?(n-=c,v.top="top",n-=a,y.top="bottom"):"bottom"===y.top&&n<D[1]&&n+(2*a-c)<=D[3]&&(n+=a-c,v.top="top",y.top="top")),"middle"===v.top&&(n+a>D[3]&&"top"===y.top?(n-=a,y.top="bottom"):n<D[1]&&"bottom"===y.top&&(n+=a,y.top="top"))),"target"!==d&&"both"!==d||(o<D[0]&&"left"===v.left&&(o+=u,v.left="right"),o+l>D[2]&&"right"===v.left&&(o-=u,v.left="left")),"together"===d&&(o<D[0]&&"left"===v.left?"right"===y.left?(o+=u,v.left="right",o+=l,y.left="left"):"left"===y.left&&(o+=u,v.left="right",o-=l,y.left="right"):o+l>D[2]&&"right"===v.left?"left"===y.left?(o-=u,v.left="left",o-=l,y.left="right"):"right"===y.left&&(o-=u,v.left="left",o+=l,y.left="left"):"center"===v.left&&(o+l>D[2]&&"left"===y.left?(o-=l,y.left="right"):o<D[0]&&"right"===y.left&&(o+=l,y.left="left"))),"element"!==h&&"both"!==h||(n<D[1]&&"bottom"===y.top&&(n+=a,y.top="top"),n+a>D[3]&&"top"===y.top&&(n-=a,y.top="bottom")),"element"!==d&&"both"!==d||(o<D[0]&&("right"===y.left?(o+=l,y.left="left"):"center"===y.left&&(o+=l/2,y.left="left")),o+l>D[2]&&("left"===y.left?(o-=l,y.left="right"):"center"===y.left&&(o-=l/2,y.left="right"))),"string"==typeof p?p=p.split(",").map(function(t){return t.trim()}):p===!0&&(p=["top","left","right","bottom"]),p=p||[];var b=[],w=[];n<D[1]&&(p.indexOf("top")>=0?(n=D[1],b.push("top")):w.push("top")),n+a>D[3]&&(p.indexOf("bottom")>=0?(n=D[3]-a,b.push("bottom")):w.push("bottom")),o<D[0]&&(p.indexOf("left")>=0?(o=D[0],b.push("left")):w.push("left")),o+l>D[2]&&(p.indexOf("right")>=0?(o=D[2]-l,b.push("right")):w.push("right")),b.length&&!function(){var t=void 0;t="undefined"!=typeof e.options.pinnedClass?e.options.pinnedClass:e.getClass("pinned"),m.push(t),b.forEach(function(e){m.push(t+"-"+e)})}(),w.length&&!function(){var t=void 0;t="undefined"!=typeof e.options.outOfBoundsClass?e.options.outOfBoundsClass:e.getClass("out-of-bounds"),m.push(t),w.forEach(function(e){m.push(t+"-"+e)})}(),(b.indexOf("left")>=0||b.indexOf("right")>=0)&&(y.left=v.left=!1),(b.indexOf("top")>=0||b.indexOf("bottom")>=0)&&(y.top=v.top=!1),v.top===r.top&&v.left===r.left&&y.top===e.attachment.top&&y.left===e.attachment.left||(e.updateAttachClasses(y,v),e.trigger("update",{attachment:y,targetAttachment:v}))}),T(function(){e.options.addTargetClasses!==!1&&g(e.target,m,f),g(e.element,m,f)}),{top:n,left:o}}});var I=k.Utils,s=I.getBounds,g=I.updateClasses,T=I.defer;k.modules.push({position:function(t){var e=this,n=t.top,o=t.left,r=this.cache("element-bounds",function(){return s(e.element)}),i=r.height,a=r.width,l=this.getTargetBounds(),p=n+i,d=o+a,h=[];n<=l.bottom&&p>=l.top&&["left","right"].forEach(function(t){var e=l[t];e!==o&&e!==d||h.push(t)}),o<=l.right&&d>=l.left&&["top","bottom"].forEach(function(t){var e=l[t];e!==n&&e!==p||h.push(t)});var c=[],u=[],f=["left","top","right","bottom"];return c.push(this.getClass("abutted")),f.forEach(function(t){c.push(e.getClass("abutted")+"-"+t)}),h.length&&u.push(this.getClass("abutted")),h.forEach(function(t){u.push(e.getClass("abutted")+"-"+t)}),T(function(){e.options.addTargetClasses!==!1&&g(e.target,u,c),g(e.element,u,c)}),!0}});var P=function(){function t(t,e){var n=[],o=!0,r=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(o=(a=s.next()).done)&&(n.push(a.value),!e||n.length!==e);o=!0);}catch(t){r=!0,i=t}finally{try{!o&&s.return&&s.return()}finally{if(r)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();return k.modules.push({position:function(t){var e=t.top,n=t.left;if(this.options.shift){var o=this.options.shift;"function"==typeof this.options.shift&&(o=this.options.shift.call(this,{top:e,left:n}));var r=void 0,i=void 0;if("string"==typeof o){o=o.split(" "),o[1]=o[1]||o[0];var a=o,s=P(a,2);r=s[0],i=s[1],r=parseFloat(r,10),i=parseFloat(i,10)}else r=o.top,i=o.left;return e+=r,n+=i,{top:e,left:n}}}}),K})}])});

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduceCssCalc = __webpack_require__(1662);
	
	var _reduceCssCalc2 = _interopRequireDefault(_reduceCssCalc);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DataUtils = __webpack_require__(16);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DOMUtils = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(/\s+/) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return { word: word, width: (0, _DOMUtils.getStringSize)(word, props.style).width };
	    });
	
	    var spaceWidth = (0, _DOMUtils.getStringSize)('\xA0', props.style).width;
	
	    return { wordsWithComputedWidth: wordsWithComputedWidth, spaceWidth: spaceWidth };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text = (_temp2 = _class = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Text);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      wordsByLines: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Text, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
	      this.updateWordsByLines(nextProps, needCalculate);
	    }
	  }, {
	    key: 'updateWordsByLines',
	    value: function updateWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	
	
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            this.updateWordsWithoutCalculate(props);
	
	            return;
	          }
	        }
	
	        var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	        this.setState({ wordsByLines: wordsByLines });
	      } else {
	        this.updateWordsWithoutCalculate(props);
	      }
	    }
	  }, {
	    key: 'updateWordsWithoutCalculate',
	    value: function updateWordsWithoutCalculate(props) {
	      var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(/\s+/) : [];
	      this.setState({ wordsByLines: [{ words: words }] });
	    }
	  }, {
	    key: 'calculateWordsByLines',
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	
	      return wordsWithComputedWidth.reduce(function (result, _ref2) {
	        var word = _ref2.word,
	            width = _ref2.width;
	
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = { words: [word], width: width };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          dx = _props.dx,
	          dy = _props.dy,
	          textAnchor = _props.textAnchor,
	          verticalAnchor = _props.verticalAnchor,
	          scaleToFit = _props.scaleToFit,
	          angle = _props.angle,
	          lineHeight = _props.lineHeight,
	          capHeight = _props.capHeight,
	          className = _props.className,
	          textProps = _objectWithoutProperties(_props, ['dx', 'dy', 'textAnchor', 'verticalAnchor', 'scaleToFit', 'angle', 'lineHeight', 'capHeight', 'className']);
	
	      var wordsByLines = this.state.wordsByLines;
	
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	
	      var startDy = void 0;
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + capHeight + ')');
	          break;
	        case 'middle':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) / 2 + ' * -' + lineHeight + ' + (' + capHeight + ' / 2))');
	          break;
	        default:
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) + ' * -' + lineHeight + ')');
	          break;
	      }
	
	      var transforms = [];
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push('scale(' + this.props.width / lineWidth + ')');
	      }
	      if (angle) {
	        transforms.push('rotate(' + angle + ', ' + x + ', ' + y + ')');
	      }
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react2.default.createElement(
	        'text',
	        _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), {
	          x: x,
	          y: y,
	          className: (0, _classnames2.default)('recharts-text', className),
	          textAnchor: textAnchor
	        }),
	        wordsByLines.map(function (line, index) {
	          return _react2.default.createElement(
	            'tspan',
	            { x: x, dy: index === 0 ? startDy : lineHeight, key: index },
	            line.words.join(' ')
	          );
	        })
	      );
	    }
	  }]);
	
	  return Text;
	}(_react.Component), _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes2.default.bool,
	  angle: _propTypes2.default.number,
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end']),
	  style: _propTypes2.default.object
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em', // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' }, _temp2);
	exports.default = Text;

/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(342);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var React = __webpack_require__(1)
	var metadata = __webpack_require__(416)
	
	var Input = __webpack_require__(1146).default
	
	var Phone = function Phone(props)
	{
	   var properties = Object.keys(props).reduce(function(reduced, property)
	   {
	   	reduced[property] = props[property]
	   	return reduced
	   },
	   { metadata: metadata })
	
		return React.createElement(Input, properties)
	}
	
	exports = module.exports = Phone
	
	var custom = __webpack_require__(418)
	
	exports.parse_phone_number = function parse()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.parse.apply(this, parameters)
	}
	
	exports.format_phone_number = function format()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.format.apply(this, parameters)
	}
	
	exports.is_valid_phone_number = function is_valid_number()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.isValidNumber.apply(this, parameters)
	}
	
	// camelCase aliases
	exports.parsePhoneNumber   = exports.parse_phone_number
	exports.formatPhoneNumber  = exports.format_phone_number
	exports.isValidPhoneNumber = exports.is_valid_phone_number
	
	module.exports['default'] = Phone


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.translateStyle = exports.AnimateGroup = exports.configBezier = exports.configSpring = undefined;
	
	var _Animate = __webpack_require__(601);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	var _easing = __webpack_require__(602);
	
	var _util = __webpack_require__(179);
	
	var _AnimateGroup = __webpack_require__(1270);
	
	var _AnimateGroup2 = _interopRequireDefault(_AnimateGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.configSpring = _easing.configSpring;
	exports.configBezier = _easing.configBezier;
	exports.AnimateGroup = _AnimateGroup2.default;
	exports.translateStyle = _util.translateStyle;
	exports.default = _Animate2.default;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Tooltip
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _DefaultTooltipContent = __webpack_require__(1519);
	
	var _DefaultTooltipContent2 = _interopRequireDefault(_DefaultTooltipContent);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DataUtils = __webpack_require__(16);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EPS = 1;
	
	var propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  active: _propTypes2.default.bool,
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  offset: _propTypes2.default.number,
	
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  wrapperStyle: _propTypes2.default.object,
	  cursor: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element, _propTypes2.default.object]),
	
	  coordinate: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  position: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes2.default.func
	};
	
	var defaultProps = {
	  active: false,
	  offset: 10,
	  viewBox: { x1: 0, x2: 0, y1: 0, y2: 0 },
	  coordinate: { x: 0, y: 0 },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  itemSorter: function itemSorter() {
	    return -1;
	  }
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultTooltipContent2.default, props);
	};
	
	var Tooltip = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          isAnimationActive = _props.isAnimationActive,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing;
	
	      var hasPayload = payload && payload.length && payload.filter(function (entry) {
	        return !(0, _isNil3.default)(entry.value);
	      }).length;
	      var _props2 = this.props,
	          content = _props2.content,
	          viewBox = _props2.viewBox,
	          coordinate = _props2.coordinate,
	          position = _props2.position,
	          active = _props2.active,
	          offset = _props2.offset,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	      var translateX = void 0,
	          translateY = void 0;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _state2 = this.state,
	            boxWidth = _state2.boxWidth,
	            boxHeight = _state2.boxHeight;
	
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = position && (0, _DataUtils.isNumber)(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);
	
	          translateY = position && (0, _DataUtils.isNumber)(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	        transform: 'translate(' + translateX + 'px, ' + translateY + 'px)'
	      }));
	
	      if (isAnimationActive && active) {
	        outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	          transition: 'transform ' + animationDuration + 'ms ' + animationEasing
	        }));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-tooltip-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component), _class2.displayName = 'Tooltip', _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _temp2)) || _class;
	
	exports.default = Tooltip;

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	var LoadMore = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(LoadMore, _React$Component);
	
	  function LoadMore() {
	    _classCallCheck(this, LoadMore);
	
	    var _this2 = _possibleConstructorReturn(this, (LoadMore.__proto__ || Object.getPrototypeOf(LoadMore)).call(this));
	
	    _this2.cleanUrl = function (url) {
	      return url.replace('/v1', '').replace('&appointmentDate=null', '');
	    };
	
	    _this2.loadFunction = _this2.loadFunction.bind(_this2);
	    _this2.cleanUrl = _this2.cleanUrl.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(LoadMore, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        clicked: false,
	        url: this.props.url || null,
	        done: false
	      };
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (!this.state.url) {
	        this.setState({
	          url: nextProps.url
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.url !== this.state.url) {
	        this.setState({
	          url: nextProps.url
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (!nextProps.url || nextProps.url === this.state.url && nextProps.url !== nextState.url) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'loadFunction',
	    value: function loadFunction() {
	      var _this3 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	      var _props = this.props,
	          onLoad = _props.onLoad,
	          resultsName = _props.resultsName;
	
	      if (!this.state.done) {
	        _config.api.get(this.state.url).then(function (response) {
	          if (!_this3.props.dataFormat) {
	            Array.prototype.push.apply(_this3.props.group, resultsName ? response.data[resultsName].results : response.data.results);
	            if (onLoad) {
	              onLoad(_this3.props.group);
	            }
	          } else {
	            _this3.props.dataSet(_this3.props.dataFormat(response.data.results));
	          }
	
	          _this3.setState({
	            clicked: false
	          });
	          if (resultsName) {
	            if (response.data[resultsName].next) {
	              var nextUrl = _this3.cleanUrl((0, _helpers.getPath)(response.data[resultsName].next));
	
	              if (nextUrl !== _this3.state.url) {
	                _this3.setState({
	                  url: nextUrl
	                });
	              } else {
	                _this3.setState({
	                  url: null
	                });
	              }
	            } else {
	              _this3.setState({
	                url: null,
	                done: true
	              });
	            }
	          } else {
	            if (response.data.next) {
	              // API returns a url with a different domain for the next link
	              // so create an anchor element and set its href to the next link
	              // and then grab the pathname and query from that
	              console.log(response.data.next);
	              var _nextUrl = _this3.cleanUrl((0, _helpers.getPath)(response.data.next));
	
	              if (_nextUrl !== _this3.state.url) {
	                _this3.setState({
	                  url: _nextUrl
	                });
	              } else {
	                _this3.setState({
	                  url: null
	                });
	              }
	            } else {
	              _this3.setState({
	                url: null,
	                done: true
	              });
	            }
	          }
	        }).catch(function (error) {
	          SessionStore.throwError(error);
	        });
	      }
	    }
	  }, {
	    key: 'isVisible',
	    value: function isVisible() {
	      if (this.refs.button) {
	        var button = _reactDom2.default.findDOMNode(this.refs.button).getBoundingClientRect();
	
	        return button.top <= window.innerHeight;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (!this.props.drawer && !this.props.wrapper) {
	        window.addEventListener('scroll', function () {
	          if (_this.isVisible()) {
	            _this.setState({
	              clicked: true
	            }, function () {
	              _this.loadFunction();
	            });
	          }
	        });
	      } else if (this.props.wrapper) {
	        var _this4 = this;
	        var wrapper = null;
	
	        setTimeout(function () {
	          wrapper = document.querySelector(_this4.props.wrapper);
	
	          if (wrapper) {
	            wrapper.addEventListener('scroll', function () {
	              if (_this4.isVisible()) {
	                _this4.setState({
	                  clicked: true
	                }, function () {
	                  _this4.loadFunction();
	                });
	              }
	            });
	          }
	        });
	      } else if (this.props.tableContainer) {
	
	        var tableContainer = document.querySelector('.table-container');
	
	        if (tableContainer) {
	          tableContainer.addEventListener('scroll', function () {
	
	            if (_this.isVisible()) {
	
	              _this.setState({
	                clicked: true
	              }, function () {
	                _this.loadFunction();
	              });
	            }
	          });
	        }
	      } else if (this.props.drawer) {
	        var drawer = document.querySelector('.drawer');
	
	        if (drawer) {
	          drawer.addEventListener('scroll', function () {
	            if (_this.isVisible()) {
	              _this.setState({
	                clicked: true
	              }, function () {
	                _this.loadFunction();
	              });
	            }
	          });
	        }
	      }
	
	      if (!SessionStore.loading) {
	        if (this.state.url && !this.state.done) {
	          if (!this.state.clicked) {
	            return _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--more',
	                onClick: this.loadFunction,
	                ref: 'button'
	              },
	              this.props.text
	            );
	          } else {
	            return _react2.default.createElement(
	              'span',
	              { className: 'loader-bar' },
	              'Loading\u2026'
	            );
	          }
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return LoadMore;
	}(_react2.default.Component));
	
	exports.default = LoadMore;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(234)('wks');
	var uid = __webpack_require__(156);
	var Symbol = __webpack_require__(69).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(17);
	
	var CallbackQueue = __webpack_require__(546);
	var PooledClass = __webpack_require__(86);
	var ReactFeatureFlags = __webpack_require__(554);
	var ReactReconciler = __webpack_require__(87);
	var Transaction = __webpack_require__(166);
	
	var invariant = __webpack_require__(10);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 53 */
27,
/* 54 */
27,
/* 55 */
[1745, 671],
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(901);


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var PooledClass = __webpack_require__(86);
	
	var emptyFunction = __webpack_require__(38);
	var warning = __webpack_require__(14);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 58 */
[1745, 582],
/* 59 */
27,
/* 60 */
[1745, 611],
/* 61 */
[1745, 630],
/* 62 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Surface
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ['children', 'width', 'height', 'viewBox', 'className', 'style']);
	
	  var svgView = viewBox || { width: width, height: height, x: 0, y: 0 };
	  var layerClass = (0, _classnames2.default)('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({}, attrs, {
	      className: layerClass,
	      width: width,
	      height: height,
	      style: style,
	      viewBox: svgView.x + ' ' + svgView.y + ' ' + svgView.width + ' ' + svgView.height,
	      version: '1.1'
	    }),
	    children
	  );
	}
	
	Surface.propTypes = propTypes;
	
	exports.default = Surface;

/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RADIAN = exports.RADIAN = Math.PI / 180;
	
	var polarToCartesian = exports.polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	var getMaxRadius = exports.getMaxRadius = function getMaxRadius(width, height) {
	  var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0, right: 0, bottom: 0, left: 0
	  };
	  return Math.min(Math.abs(width - (margin.left || 0) - (margin.right || 0)), Math.abs(height - (margin.left || 0) - (margin.right || 0))) / 2;
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Step = function (_React$Component) {
	  _inherits(Step, _React$Component);
	
	  function Step() {
	    _classCallCheck(this, Step);
	
	    var _this = _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).call(this));
	
	    _this.isComplete = _this.isComplete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Step, [{
	    key: 'isComplete',
	    value: function isComplete(step) {
	      if (this.props.step > step) {
	        return 'complete';
	      } else if (this.props.step === step) {
	        return 'active';
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          skippable = _props.skippable;
	
	
	      if (skippable) {
	        return _react2.default.createElement(
	          'ol',
	          { className: 'step' },
	          data.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'a',
	                { href: '#exam-details', className: 'step__point tooltip ' + _this2.isComplete(i + 1), onClick: function onClick(e) {
	                    _this2.props.setStep(e, i + 1);
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tooltip__body', role: 'tooltip' },
	                  data[i]
	                )
	              )
	            );
	          })
	        );
	      } else {
	        return _react2.default.createElement(
	          'ol',
	          { className: 'step' },
	          data.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'span',
	                { className: 'step__point tooltip ' + _this2.isComplete(i + 1) },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tooltip__body', role: 'tooltip' },
	                  data[i]
	                )
	              )
	            );
	          })
	        );
	      }
	    }
	  }]);
	
	  return Step;
	}(_react2.default.Component);
	
	exports.default = Step;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(384);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(102)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(69);
	var core = __webpack_require__(35);
	var ctx = __webpack_require__(227);
	var hide = __webpack_require__(103);
	var has = __webpack_require__(84);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 69 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(83);
	var IE8_DOM_DEFINE = __webpack_require__(389);
	var toPrimitive = __webpack_require__(236);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(67) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var accounting = __webpack_require__(704)
	var assign = __webpack_require__(17)
	var localeCurrency = __webpack_require__(1025)
	var currencies = __webpack_require__(1009)
	var localeFormats = __webpack_require__(1010)
	
	var defaultCurrency = {
	  symbol: '',
	  thousandsSeparator: ',',
	  decimalSeparator: '.',
	  symbolOnLeft: true,
	  spaceBetweenAmountAndSymbol: false,
	  decimalDigits: 2
	}
	
	var defaultLocaleFormat = {}
	
	var formatMapping = [
	  {
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    format: {
	      pos: '%s%v',
	      neg: '-%s%v',
	      zero: '%s%v'
	    }
	  },
	  {
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    format: {
	      pos: '%s %v',
	      neg: '-%s %v',
	      zero: '%s %v'
	    }
	  },
	  {
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    format: {
	      pos: '%v%s',
	      neg: '-%v%s',
	      zero: '%v%s'
	    }
	  },
	  {
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    format: {
	      pos: '%v %s',
	      neg: '-%v %s',
	      zero: '%v %s'
	    }
	  }
	]
	
	function format(value, options) {
	  var code = options.code || (options.locale && localeCurrency.getCurrency(options.locale))
	  var localeFormat = localeFormats[options.locale] || defaultLocaleFormat
	  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat)
	  
	  var symbolOnLeft = currency.symbolOnLeft
	  var spaceBetweenAmountAndSymbol = currency.spaceBetweenAmountAndSymbol
	
	  var format = formatMapping.filter(function(f) {
	    return f.symbolOnLeft == symbolOnLeft && f.spaceBetweenAmountAndSymbol == spaceBetweenAmountAndSymbol
	  })[0].format
	
	  return accounting.formatMoney(value, {
	    symbol: isUndefined(options.symbol)
	              ? currency.symbol
	              : options.symbol,
	
	    decimal: isUndefined(options.decimal)
	              ? currency.decimalSeparator
	              : options.decimal,
	
	    thousand: isUndefined(options.thousand)
	              ? currency.thousandsSeparator
	              : options.thousand,
	
	    precision: typeof options.precision === 'number'
	              ? options.precision
	              : currency.decimalDigits,
	
	    format: ['string', 'object'].indexOf(typeof options.format) > -1
	              ? options.format
	              : format
	  })
	}
	
	function findCurrency (currencyCode) {
	  return currencies[currencyCode]
	}
	
	function isUndefined (val) {
	  return typeof val === 'undefined'
	}
	
	module.exports = {
	  defaultCurrency: defaultCurrency,
	  get currencies() {
	    // In favor of backwards compatibility, the currencies map is converted to an array here
	    return Object.keys(currencies).map(function(key) {
	      return currencies[key]
	    })
	  },
	  findCurrency: findCurrency,
	  format: format
	}

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _calculateNodeHeight2 = __webpack_require__(1493);
	
	var _calculateNodeHeight3 = _interopRequireDefault(_calculateNodeHeight2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <TextareaAutosize />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var noop = function noop() {};
	
	var TextareaAutosize = function (_React$Component) {
	  _inherits(TextareaAutosize, _React$Component);
	
	  function TextareaAutosize(props) {
	    _classCallCheck(this, TextareaAutosize);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._onRootDOMNode = function (node) {
	      _this._rootDOMNode = node;
	      if (_this.props.inputRef) _this.props.inputRef(node);
	    };
	
	    _this._onChange = function (event) {
	      if (!_this._controlled) {
	        _this._resizeComponent();
	      }
	      var _this$props = _this.props,
	          valueLink = _this$props.valueLink,
	          onChange = _this$props.onChange;
	
	      if (valueLink) {
	        valueLink.requestChange(event.target.value);
	      } else {
	        onChange(event);
	      }
	    };
	
	    _this._resizeComponent = function () {
	      if (!_this._rootDOMNode) {
	        return;
	      }
	
	      var _calculateNodeHeight = (0, _calculateNodeHeight3.default)(_this._rootDOMNode, _this.props.useCacheForDOMMeasurements, _this.props.rows || _this.props.minRows, _this.props.maxRows),
	          height = _calculateNodeHeight.height,
	          minHeight = _calculateNodeHeight.minHeight,
	          maxHeight = _calculateNodeHeight.maxHeight;
	
	      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
	        _this.setState({ height: height, minHeight: minHeight, maxHeight: maxHeight });
	      }
	    };
	
	    _this.state = {
	      height: props.style && props.style.height || 0,
	      minHeight: -Infinity,
	      maxHeight: Infinity
	    };
	
	    _this._controlled = typeof props.value === 'string';
	    return _this;
	  }
	
	  TextareaAutosize.prototype.render = function render() {
	    var _props = this.props,
	        valueLink = _props.valueLink,
	        _minRows = _props.minRows,
	        _maxRows = _props.maxRows,
	        _onHeightChange = _props.onHeightChange,
	        _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements,
	        _inputRef = _props.inputRef,
	        props = _objectWithoutProperties(_props, ['valueLink', 'minRows', 'maxRows', 'onHeightChange', 'useCacheForDOMMeasurements', 'inputRef']);
	
	    if ((typeof valueLink === 'undefined' ? 'undefined' : _typeof(valueLink)) === 'object') {
	      props.value = valueLink.value;
	    }
	
	    props.style = _extends({}, props.style, {
	      height: this.state.height
	    });
	
	    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);
	
	    if (maxHeight < this.state.height) {
	      props.style.overflow = 'hidden';
	    }
	
	    return _react2.default.createElement('textarea', _extends({}, props, {
	      onChange: this._onChange,
	      ref: this._onRootDOMNode
	    }));
	  };
	
	  TextareaAutosize.prototype.componentDidMount = function componentDidMount() {
	    this._resizeComponent();
	    window.addEventListener('resize', this._resizeComponent);
	  };
	
	  TextareaAutosize.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    // Re-render with the new content then recalculate the height as required.
	    this._clearNextFrame();
	    this._onNextFrameActionId = onNextFrame(this._resizeComponent);
	  };
	
	  TextareaAutosize.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // Invoke callback when old height does not equal to new one.
	    if (this.state.height !== prevState.height) {
	      this.props.onHeightChange(this.state.height);
	    }
	  };
	
	  TextareaAutosize.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Remove any scheduled events to prevent manipulating the node after it's
	    // been unmounted.
	    this._clearNextFrame();
	    window.removeEventListener('resize', this._resizeComponent);
	  };
	
	  TextareaAutosize.prototype._clearNextFrame = function _clearNextFrame() {
	    if (this._onNextFrameActionId) {
	      clearNextFrameAction(this._onNextFrameActionId);
	    }
	  };
	
	  /**
	   * Put focus on a <textarea /> DOM element.
	   */
	  TextareaAutosize.prototype.focus = function focus() {
	    this._rootDOMNode.focus();
	  };
	
	  /**
	   * Shifts focus away from a <textarea /> DOM element.
	   */
	
	
	  TextareaAutosize.prototype.blur = function blur() {
	    this._rootDOMNode.blur();
	  };
	
	  _createClass(TextareaAutosize, [{
	    key: 'value',
	
	
	    /**
	     * Read the current value of <textarea /> from DOM.
	     */
	    get: function get() {
	      return this._rootDOMNode.value;
	    }
	
	    /**
	     * Set the current value of <textarea /> DOM node.
	     */
	    ,
	    set: function set(val) {
	      this._rootDOMNode.value = val;
	    }
	
	    /**
	     * Read the current selectionStart of <textarea /> from DOM.
	     */
	
	  }, {
	    key: 'selectionStart',
	    get: function get() {
	      return this._rootDOMNode.selectionStart;
	    }
	
	    /**
	     * Set the current selectionStart of <textarea /> DOM node.
	     */
	    ,
	    set: function set(selectionStart) {
	      this._rootDOMNode.selectionStart = selectionStart;
	    }
	
	    /**
	     * Read the current selectionEnd of <textarea /> from DOM.
	     */
	
	  }, {
	    key: 'selectionEnd',
	    get: function get() {
	      return this._rootDOMNode.selectionEnd;
	    }
	
	    /**
	     * Set the current selectionEnd of <textarea /> DOM node.
	     */
	    ,
	    set: function set(selectionEnd) {
	      this._rootDOMNode.selectionEnd = selectionEnd;
	    }
	  }]);
	
	  return TextareaAutosize;
	}(_react2.default.Component);
	
	TextareaAutosize.propTypes = {
	  /**
	   * Current textarea value.
	   */
	  value: _propTypes2.default.string,
	
	  /**
	   * Callback on value change.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * Callback on height changes.
	   */
	  onHeightChange: _propTypes2.default.func,
	
	  /**
	   * Try to cache DOM measurements performed by component so that we don't
	   * touch DOM when it's not needed.
	   *
	   * This optimization doesn't work if we dynamically style <textarea />
	   * component.
	   */
	  useCacheForDOMMeasurements: _propTypes2.default.bool,
	
	  /**
	   * Minimal numbder of rows to show.
	   */
	  rows: _propTypes2.default.number,
	
	  /**
	   * Alias for `rows`.
	   */
	  minRows: _propTypes2.default.number,
	
	  /**
	   * Maximum number of rows to show.
	   */
	  maxRows: _propTypes2.default.number,
	
	  /**
	   * Allows an owner to retrieve the DOM node.
	   */
	  inputRef: _propTypes2.default.func
	};
	TextareaAutosize.defaultProps = {
	  onChange: noop,
	  onHeightChange: noop,
	  useCacheForDOMMeasurements: false
	};
	exports.default = TextareaAutosize;
	
	
	function onNextFrame(cb) {
	  if (window.requestAnimationFrame) {
	    return window.requestAnimationFrame(cb);
	  }
	  return window.setTimeout(cb, 1);
	}
	
	function clearNextFrameAction(nextFrameId) {
	  if (window.cancelAnimationFrame) {
	    window.cancelAnimationFrame(nextFrameId);
	  } else {
	    window.clearTimeout(nextFrameId);
	  }
	}

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Dot
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Dot, _Component);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          r = _props.r,
	          className = _props.className;
	
	      var layerClass = (0, _classnames2.default)('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react2.default.createElement('circle', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.Component), _class2.displayName = 'Dot', _class2.propTypes = {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  r: _propTypes2.default.number
	}, _temp)) || _class;
	
	exports.default = Dot;

/***/ },
/* 76 */
[1695, 143, 1604, 1632],
/* 77 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PermittedItems = __webpack_require__(219);
	
	var _PermittedItems2 = _interopRequireDefault(_PermittedItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	// import { toggleDrawer, toHours } from '../../helpers/helpers.js'
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExamDetails = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamDetails, _React$Component);
	
	  function ExamDetails() {
	    _classCallCheck(this, ExamDetails);
	
	    return _possibleConstructorReturn(this, (ExamDetails.__proto__ || Object.getPrototypeOf(ExamDetails)).apply(this, arguments));
	  }
	
	  _createClass(ExamDetails, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          exam = _props.exam,
	          hideDates = _props.hideDates,
	          hideType = _props.hideType,
	          translation = _props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var _props$store$SessionS = this.props.store.SessionStore,
	          userData = _props$store$SessionS.userData,
	          userTimezone = _props$store$SessionS.userTimezone;
	
	      var role = userData.role.toLowerCase();
	      var defaultScheduleClose = false;
	
	      var configuration = exam.examSession && exam.examSession.examConfiguration ? exam.examSession.examConfiguration : exam.configuration;
	
	      var scheduleCloseDate = configuration.scheduleCloseDate;
	
	      if ((0, _moment2.default)(scheduleCloseDate).format('M-D-YYYY') === '1-1-2070' || (0, _moment2.default)(scheduleCloseDate).diff((0, _moment2.default)(configuration.examCloseDate)) >= 0) {
	        // If there’s no scheduling window set, use the exam close date
	        scheduleCloseDate = configuration.examCloseDate;
	        defaultScheduleClose = true;
	      }
	
	      var scheduleOpenDate = configuration.scheduleOpenDate;
	
	      if ((0, _moment2.default)(scheduleOpenDate).format('M-D-YYYY') === '1-1-2000') {
	        // If there’s no scheduling window set, use the exam close date
	        scheduleOpenDate = configuration.createdDate;
	      }
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'panel__section' },
	        !this.props.compact && _react2.default.createElement(
	          'h2',
	          { className: 'panel__heading' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: this.props.compact ? 'data--alt' : 'data' },
	          !hideType && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: this.props.compact ? '' : 'strong-bold' },
	              translation.type
	            ),
	            exam.type === ("Online" || "Live Online") ? translation.online_exam : exam.type
	          ),
	          !hideDates && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: this.props.compact ? '' : 'strong-bold' },
	              translation.opens
	            ),
	            _moment2.default.utc(configuration.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	          ),
	          !hideDates && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: this.props.compact ? '' : 'strong-bold' },
	              translation.closes
	            ),
	            _moment2.default.utc(configuration.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: this.props.compact ? '' : 'strong-bold' },
	              translation.exam_duration
	            ),
	            (0, _helpers.toHours)(configuration.duration, false, false, true)
	          ),
	          !hideDates && this.props.scheduleWindow && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: this.props.compact ? '' : 'strong-bold' },
	              translation.scheduling_opens
	            ),
	            _moment2.default.utc(scheduleOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	          ),
	          !hideDates && this.props.scheduleWindow && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: this.props.compact ? '' : 'strong-bold' },
	              translation.scheduling_closes
	            ),
	            (!defaultScheduleClose || role !== 'learner') && _moment2.default.utc(scheduleCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'),
	            defaultScheduleClose && role === 'learner' && _moment2.default.utc(scheduleCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	          ),
	          _react2.default.createElement(_PermittedItems2.default, Object.assign({
	            configuration: configuration,
	            listItem: true,
	            pushLeft: true,
	            dashboardView: true
	          }, this.props))
	        ),
	        configuration.studentNotes && SessionStore.userData.role.toLowerCase() === 'learner' && _react2.default.createElement(
	          'div',
	          { className: 'text-block text-block--alt' },
	          _react2.default.createElement(
	            'strong',
	            null,
	            translation.notes,
	            ':'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            configuration.studentNotes
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExamDetails;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamDetails')(ExamDetails);

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeSelect2 = function (_React$Component) {
	  _inherits(TimeSelect2, _React$Component);
	
	  function TimeSelect2() {
	    _classCallCheck(this, TimeSelect2);
	
	    return _possibleConstructorReturn(this, (TimeSelect2.__proto__ || Object.getPrototypeOf(TimeSelect2)).apply(this, arguments));
	  }
	
	  _createClass(TimeSelect2, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setTimeSlots(this.props.startTime, this.props.endTime);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.startTime !== this.props.startTime || nextProps.endTime !== this.props.endTime) {
	        this.setTimeSlots(nextProps.startTime, nextProps.endTime);
	      }
	    }
	  }, {
	    key: 'setTimeSlots',
	    value: function setTimeSlots(startTime, endTime) {
	      var timeSlots = [];
	      var time = '00:00';
	      var ampm = 'am';
	      var pastStartTime = true;
	      var beforeEndTime = true;
	
	      if (startTime) {
	        pastStartTime = false;
	      }
	
	      for (var i = 0; i < 48; i++) {
	        var thisTime = void 0;
	        var label = void 0;
	
	        if (i !== 0) {
	          var hr = Number(time.split(':')[0]);
	          var min = Number(time.split(':')[1]);
	
	          if (min === 30) {
	            hr++;
	            min = '00';
	          } else if (min === 0) {
	            min = 30;
	          }
	
	          hr = hr.toString();
	          min = min.toString();
	
	          if (hr.length === 1) {
	            hr = '0' + hr;
	          }
	
	          thisTime = hr + ':' + min;
	
	          time = thisTime;
	
	          if (Number(hr) > 11) {
	            ampm = 'pm';
	          }
	
	          label = '' + time + ampm;
	
	          if (Number(hr) > 12) {
	            label = hr - 12 + ':' + min + ampm;
	          } else if (Number(hr) === 0) {
	            label = '12:' + min + ampm;
	          }
	        } else {
	          label = '12:00am';
	        }
	
	        if (startTime && time === startTime) {
	          pastStartTime = true;
	        }
	
	        if (endTime && time === endTime) {
	          beforeEndTime = false;
	        }
	
	        var timeSlot = {
	          value: time,
	          label: label
	        };
	
	        if (startTime && endTime) {
	          if (pastStartTime && beforeEndTime) {
	            timeSlots.push(timeSlot);
	          }
	        } else if (startTime && pastStartTime) {
	          timeSlots.push(timeSlot);
	        } else if (endTime && beforeEndTime) {
	          timeSlots.push(timeSlot);
	        } else if (!startTime && !endTime) {
	          timeSlots.push(timeSlot);
	        }
	      }
	
	      this.setState({
	        timeSlots: timeSlots
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'optgroup',
	        null,
	        this.state.timeSlots.map(function (slot, i) {
	          return _react2.default.createElement(
	            'option',
	            { key: i, value: slot.value },
	            slot.label
	          );
	        })
	      );
	    }
	  }]);
	
	  return TimeSelect2;
	}(_react2.default.Component);
	
	exports.default = TimeSelect2;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(912), __esModule: true };

/***/ },
/* 82 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 84 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 86 */
[1675, 19],
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1107);
	var ReactInstrumentation = __webpack_require__(44);
	
	var warning = __webpack_require__(14);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 88 */
[1719, 1301, 1326],
/* 89 */
78,
/* 90 */
[1719, 1402, 1432],
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var ReactChildren = __webpack_require__(1500);
	var ReactComponent = __webpack_require__(304);
	var ReactPureComponent = __webpack_require__(1505);
	var ReactClass = __webpack_require__(1501);
	var ReactDOMFactories = __webpack_require__(1502);
	var ReactElement = __webpack_require__(119);
	var ReactPropTypes = __webpack_require__(1503);
	var ReactVersion = __webpack_require__(1506);
	
	var onlyChild = __webpack_require__(1507);
	var warning = __webpack_require__(14);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Legend
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DefaultLegendContent = __webpack_require__(1518);
	
	var _DefaultLegendContent2 = _interopRequireDefault(_DefaultLegendContent);
	
	var _DataUtils = __webpack_require__(16);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultLegendContent2.default, props);
	};
	
	var EPS = 1;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Legend, _Component);
	
	  function Legend() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legend.__proto__ || Object.getPrototypeOf(Legend)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Legend, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'getBBox',
	    value: function getBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return { width: boxWidth, height: boxHeight };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getDefaultPosition',
	    value: function getDefaultPosition(style) {
	      var _props = this.props,
	          layout = _props.layout,
	          align = _props.align,
	          verticalAlign = _props.verticalAlign,
	          margin = _props.margin,
	          chartWidth = _props.chartWidth,
	          chartHeight = _props.chartHeight;
	
	      var hPos = void 0,
	          vPos = void 0;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || { width: 0 };
	          hPos = { left: ((chartWidth || 0) - box.width) / 2 };
	        } else {
	          hPos = align === 'right' ? { right: margin && margin.right || 0 } : { left: margin && margin.left || 0 };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || { height: 0 };
	          vPos = { top: ((chartHeight || 0) - _box.height) / 2 };
	        } else {
	          vPos = verticalAlign === 'bottom' ? { bottom: margin && margin.bottom || 0 } : { top: margin && margin.top || 0 };
	        }
	      }
	
	      return _extends({}, hPos, vPos);
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          boxWidth = _state2.boxWidth,
	          boxHeight = _state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        (function () {
	          var box = _this2.wrapperNode.getBoundingClientRect();
	
	          if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	            _this2.setState({
	              boxWidth: box.width,
	              boxHeight: box.height
	            }, function () {
	              if (onBBoxUpdate) {
	                onBBoxUpdate(box);
	              }
	            });
	          }
	        })();
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          content = _props2.content,
	          width = _props2.width,
	          height = _props2.height,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), wrapperStyle);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-legend-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this3.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }], [{
	    key: 'getWithHeight',
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      } else if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  wrapperStyle: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    left: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onBBoxUpdate: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	}, _temp2)) || _class;
	
	exports.default = Legend;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(27);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(240);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed, curveBasisOpen: _d3Shape.curveBasisOpen, curveBasis: _d3Shape.curveBasis, curveLinearClosed: _d3Shape.curveLinearClosed, curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX, curveMonotoneY: _d3Shape.curveMonotoneY, curveNatural: _d3Shape.curveNatural, curveStep: _d3Shape.curveStep, curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	var getX = function getX(p) {
	  return p.x;
	};
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction3.default)(type)) {
	    return type;
	  }
	
	  var name = 'curve' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES['' + name + (layout === 'vertical' ? 'Y' : 'X')];
	  }
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Curve, _Component);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: 'getPath',
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          type = _props.type,
	          points = _props.points,
	          baseLine = _props.baseLine,
	          layout = _props.layout,
	          connectNulls = _props.connectNulls;
	
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction = void 0;
	
	      if ((0, _isArray3.default)(baseLine)) {
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _extends({}, entry, { base: baseLine[index] });
	        });
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	        lineFunction.defined(defined).curve(curveFactory);
	
	        return lineFunction(areaPoints);
	      } else if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          points = _props2.points,
	          pathRef = _props2.pathRef;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-curve', className),
	        d: this.getPath(),
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.Component), _class2.displayName = 'Curve', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  connectNulls: _propTypes2.default.bool,
	  pathRef: _propTypes2.default.func
	}), _class2.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	}, _temp)) || _class;
	
	exports.default = Curve;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Rectangle
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var sign = height >= 0 ? 1 : -1;
	  var clockWise = height >= 0 ? 1 : 0;
	  var path = void 0;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = 'M' + x + ',' + (y + sign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += 'A ' + newRadius[0] + ',' + newRadius[0] + ',0,0,' + clockWise + ',' + (x + newRadius[0]) + ',' + y;
	    }
	
	    path += 'L ' + (x + width - newRadius[1]) + ',' + y;
	
	    if (newRadius[1] > 0) {
	      path += 'A ' + newRadius[1] + ',' + newRadius[1] + ',0,0,' + clockWise + ',\n        ' + (x + width) + ',' + (y + sign * newRadius[1]);
	    }
	    path += 'L ' + (x + width) + ',' + (y + height - sign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += 'A ' + newRadius[2] + ',' + newRadius[2] + ',0,0,' + clockWise + ',\n        ' + (x + width - newRadius[2]) + ',' + (y + height);
	    }
	    path += 'L ' + (x + newRadius[3]) + ',' + (y + height);
	
	    if (newRadius[3] > 0) {
	      path += 'A ' + newRadius[3] + ',' + newRadius[3] + ',0,0,' + clockWise + ',\n        ' + x + ',' + (y + height - sign * newRadius[3]);
	    }
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = 'M ' + x + ',' + (y + sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + _newRadius) + ',' + y + '\n            L ' + (x + width - _newRadius) + ',' + y + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width) + ',' + (y + sign * _newRadius) + '\n            L ' + (x + width) + ',' + (y + height - sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width - _newRadius) + ',' + (y + height) + '\n            L ' + (x + _newRadius) + ',' + (y + height) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + x + ',' + (y + height - sign * _newRadius) + ' Z';
	  } else {
	    path = 'M ' + x + ',' + y + ' h ' + width + ' v ' + height + ' h ' + -width + ' Z';
	  }
	
	  return path;
	};
	
	var Rectangle = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Rectangle, _Component);
	
	  function Rectangle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      totalLength: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Rectangle, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        var totalLength = this.node.getTotalLength();
	
	        if (totalLength) {
	          this.setState({
	            totalLength: totalLength
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          radius = _props.radius,
	          className = _props.className;
	      var totalLength = this.state.totalLength;
	      var _props2 = this.props,
	          animationEasing = _props2.animationEasing,
	          animationDuration = _props2.animationDuration,
	          animationBegin = _props2.animationBegin,
	          isAnimationActive = _props2.isAnimationActive,
	          isUpdateAnimationActive = _props2.isUpdateAnimationActive;
	
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          canBegin: totalLength > 0,
	          from: { width: width, height: height, x: x, y: y },
	          to: { width: width, height: height, x: x, y: y },
	          duration: animationDuration,
	          animationEasing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref2) {
	          var currWidth = _ref2.width,
	              currHeight = _ref2.height,
	              currX = _ref2.x,
	              currY = _ref2.y;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              canBegin: totalLength > 0,
	              from: '0px ' + (totalLength === -1 ? 1 : totalLength) + 'px',
	              to: totalLength + 'px 0px',
	              attributeName: 'strokeDasharray',
	              begin: animationBegin,
	              duration: animationDuration,
	              isActive: isAnimationActive,
	              easing: animationEasing
	            },
	            _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	              className: layerClass,
	              d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	              ref: function ref(node) {
	                _this2.node = node;
	              }
	            }))
	          );
	        }
	      );
	    }
	  }]);
	
	  return Rectangle;
	}(_react.Component), _class2.displayName = 'Rectangle', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = Rectangle;

/***/ },
/* 95 */
[1719, 1573, 1607],
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(334);
	
	var warning = __webpack_require__(14);
	var canDefineProperty = __webpack_require__(337);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(335);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactSimpleDropdown = __webpack_require__(178);
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Dependencies
	
	
	var FauxSelect = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(FauxSelect, _React$Component);
	
	  function FauxSelect() {
	    _classCallCheck(this, FauxSelect);
	
	    var _this = _possibleConstructorReturn(this, (FauxSelect.__proto__ || Object.getPrototypeOf(FauxSelect)).call(this));
	
	    _this.checkKey = _this.checkKey.bind(_this);
	    _this.showFauxSelect = _this.showFauxSelect.bind(_this);
	    _this.hideFauxSelect = _this.hideFauxSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(FauxSelect, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        default: this.props.default || 'Select…',
	        highlighted: -1,
	        showing: false
	
	        // Make sure we’re not duplicating the event listener
	      };document.removeEventListener('keydown', this.checkKey);
	
	      // We need to add an event listener to allow using the up and down arrows
	      // to move through the select options
	      document.addEventListener('keydown', this.checkKey);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Remove the event listener when the select element is destroyed
	      document.removeEventListener('keydown', this.checkKey);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // const dropdowns = document.querySelectorAll('.dropdown, .dropdown__content');
	      // dropdowns.forEach(function(dropdown){
	      //   if(dropdown) {
	      //     dropdown.setAttribute('tabindex', '0');
	      //   }
	      // });
	    }
	  }, {
	    key: 'clickOption',
	    value: function clickOption(e, index) {
	      var _props = this.props,
	          onClick = _props.onClick,
	          parent = _props.parent,
	          skipText = _props.skipText;
	
	      // Unless otherwise specified, update the text of the dropdown selection
	
	      if (!skipText) {
	        this.setState({
	          default: e.target.getAttribute('data-label')
	        });
	      }
	
	      if (parent) {
	        parent.setState({
	          action: e.target.getAttribute('data-action')
	        });
	      }
	
	      if (onClick) {
	        onClick(e, this.props, index);
	      }
	
	      // Hide the options
	      var dropdowns = [];
	      dropdowns.push(this.refs.fauxSelect);
	      for (var i = 0; i < dropdowns.length; i++) {
	        if (typeof dropdowns[i] !== 'undefined') {
	          dropdowns[i].hide();
	        }
	      }
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip(key) {
	      if (key.helper) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'tooltip tooltip--right', onClick: function onClick(e) {
	              e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            'span',
	            { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	            '(?)'
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: key.action + '-tooltip', className: 'tooltip__body', role: 'tooltip' },
	            key.helper
	          )
	        );
	      }
	
	      return '';
	    }
	  }, {
	    key: 'checkKey',
	    value: function checkKey(e) {
	      // Prevent scrolling when up or down key are pressed
	      if (this.state.showing && (e.keyCode === 40 || e.keyCode === 38)) {
	        e.preventDefault();
	      }
	
	      if (this.state.showing && (e.keyCode === 40 || e.keyCode === 38 || e.keyCode === 9 && !e.shiftKey)) {
	        // Down key or tab key
	        if ((e.keyCode === 40 || e.keyCode === 9) && this.state.highlighted < this.props.options.length - 1) {
	          e.preventDefault();
	
	          this.setState({
	            highlighted: this.state.highlighted + 1
	          });
	        } else if (e.keyCode === 9 && !e.shiftKey && this.state.highlighted >= this.props.options.length - 1) {
	          // If tabbing through and at the end, hide the dropdown
	          this.refs.fauxSelect.hide();
	        }
	
	        // Up key or shift + tab key
	        if ((e.keyCode === 38 || e.keyCode === 9 && e.shiftKey) && this.state.highlighted > 0) {
	          e.preventDefault();
	
	          this.setState({
	            highlighted: this.state.highlighted - 1
	          });
	        }
	
	        // Focus the button with the highlighted index
	        if (this.refs['option-' + this.state.highlighted]) {
	          this.refs['option-' + this.state.highlighted].focus();
	        }
	      }
	    }
	  }, {
	    key: 'showFauxSelect',
	    value: function showFauxSelect(e) {
	      this.setState({
	        showing: true
	      });
	
	      if (e && e.target) {
	        var options = e.target.querySelector('.faux-select__options');
	        var footer = document.querySelector('.site-foot');
	
	        if (options) {
	          var docHeight = document.body.clientHeight;
	          var footerHeight = footer.clientHeight;
	          var optionsHeight = options.clientHeight;
	          var optionsTop = this.topOffset(options);
	
	          if (docHeight - footerHeight - (optionsTop + optionsHeight) < 150 && options.className.indexOf('bottom') < 0) {
	            options.className += ' bottom';
	          }
	        }
	      }
	    }
	  }, {
	    key: 'topOffset',
	    value: function topOffset(element) {
	      var topPos = 0;
	
	      while (element) {
	        topPos += element.offsetTop - element.scrollTop + element.clientTop;
	        element = element.offsetParent;
	      }
	
	      return topPos;
	    }
	  }, {
	    key: 'hideFauxSelect',
	    value: function hideFauxSelect() {
	      this.setState({
	        highlighted: -1,
	        showing: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var options = this.props.options;
	
	      var focus = false;
	
	      function blurDropdown() {
	        if (focus) {
	          document.querySelector('.faux-select:focus').blur();
	        }
	
	        focus = !focus;
	      }
	
	      function focusButton(e) {
	        var el = e.target.parentElement;
	
	        while (el) {
	          if (el.classList.contains('dropdown')) {
	            el.className += ' dropdown--active';
	            return el;
	          } else {
	            el = el.parentElement;
	          }
	        }
	      }
	
	      function blurButton(e) {
	        var el = e.target.parentElement;
	
	        while (el) {
	          if (el.classList.contains('dropdown')) {
	            el.classList.remove('dropdown--active');
	            return el;
	          } else {
	            el = el.parentElement;
	          }
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'faux-select',
	          tabIndex: '0',
	          onFocus: this.showFauxSelect
	        },
	        _react2.default.createElement(
	          _reactSimpleDropdown2.default,
	          {
	            ref: 'fauxSelect',
	            onShow: function onShow(e) {
	              return _this2.showFauxSelect(e);
	            },
	            onHide: this.hideFauxSelect
	          },
	          _react2.default.createElement(
	            _reactSimpleDropdown.DropdownTrigger,
	            {
	              className: 'faux-select__selected',
	              onClick: blurDropdown
	            },
	            this.state.default
	          ),
	          this.props.store ? _react2.default.createElement(
	            this.props.store.validater,
	            null,
	            _react2.default.createElement(
	              _reactSimpleDropdown.DropdownContent,
	              null,
	              _react2.default.createElement(
	                'ul',
	                {
	                  className: '\n                  faux-select__options dropdown__menu\n                  ' + (this.props.noTooltip ? '' : 'has-tooltip') + '\n                '
	                },
	                options.map(function (key, i) {
	                  if (key.iamAction && key.iamResource) {
	                    return _react2.default.createElement(
	                      'li',
	                      {
	                        iamAction: key.iamAction,
	                        iamResource: key.iamResource,
	                        key: i,
	                        className: '' + (key.helper ? 'has-tooltip' : '')
	                      },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'faux-select__btn ' + (_this2.state.highlighted === i ? 'highlighted' : ''),
	                          onClick: function onClick(e, i) {
	                            _this2.clickOption(e, i);
	                          },
	                          'data-label': key.title,
	                          'data-action': key.action,
	                          tabIndex: '0',
	                          onFocus: function onFocus(e) {
	                            focusButton(e);
	                          },
	                          onBlur: function onBlur(e) {
	                            blurButton(e);
	                          },
	                          'aria-labelledby': key.action + '-tooltip',
	                          ref: 'option-' + i
	                        },
	                        key.title,
	                        key.subTitle && _react2.default.createElement(
	                          'span',
	                          { className: 'faux-select__subtitle', 'data-label': key.title },
	                          key.subTitle
	                        )
	                      ),
	                      _this2.renderTooltip(key)
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      'li',
	                      {
	                        key: i,
	                        className: '' + (key.helper ? 'has-tooltip' : '')
	                      },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'faux-select__btn ' + (_this2.state.highlighted === i ? 'highlighted' : ''),
	                          onClick: function onClick(e) {
	                            _this2.clickOption(e, i);
	                          },
	                          'data-label': key.title,
	                          'data-action': key.action,
	                          tabIndex: '0',
	                          onFocus: function onFocus(e) {
	                            focusButton(e);
	                          },
	                          onBlur: function onBlur(e) {
	                            blurButton(e);
	                          },
	                          'aria-labelledby': key.action + '-tooltip',
	                          ref: 'option-' + i
	                        },
	                        key.title,
	                        key.subTitle && _react2.default.createElement(
	                          'span',
	                          { className: 'faux-select__subtitle', 'data-label': key.title },
	                          key.subTitle
	                        )
	                      ),
	                      _this2.renderTooltip(key)
	                    );
	                  }
	                })
	              )
	            )
	          ) : _react2.default.createElement(
	            _reactSimpleDropdown.DropdownContent,
	            null,
	            _react2.default.createElement(
	              'ul',
	              {
	                className: '\n                  faux-select__options dropdown__menu\n                  ' + (this.props.noTooltip ? '' : 'has-tooltip') + '\n                '
	              },
	              options.map(function (key, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i, className: '' + (key.helper ? 'has-tooltip' : '') },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'faux-select__btn ' + (_this2.state.highlighted === i ? 'highlighted' : ''),
	                      onClick: function onClick(e) {
	                        _this2.clickOption(e, i);
	                      },
	                      'data-label': key.title,
	                      'data-action': key.action,
	                      tabIndex: '0',
	                      onFocus: function onFocus(e) {
	                        focusButton(e);
	                      },
	                      onBlur: function onBlur(e) {
	                        blurButton(e);
	                      },
	                      'aria-labelledby': key.action + '-tooltip',
	                      ref: 'option-' + i
	                    },
	                    key.title,
	                    key.subTitle && _react2.default.createElement(
	                      'span',
	                      { className: 'faux-select__subtitle', 'data-label': key.title },
	                      key.subTitle
	                    )
	                  ),
	                  _this2.renderTooltip(key)
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FauxSelect;
	}(_react2.default.Component));
	
	exports.default = FauxSelect;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Toolbar = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Toolbar, _React$Component);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
	  }
	
	  _createClass(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'toolbar ' + (this.props.selectedRows.length === 0 ? 'exiting' : '') },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn--outline btn--negative',
	            onClick: this.props.deleteFunction
	          },
	          _react2.default.createElement(icons.iconTrash, null),
	          this.props.deleteText
	        )
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Toolbar')(Toolbar);

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var Payments = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Payments, _React$Component);
	
	  function Payments() {
	    _classCallCheck(this, Payments);
	
	    return _possibleConstructorReturn(this, (Payments.__proto__ || Object.getPrototypeOf(Payments)).apply(this, arguments));
	  }
	
	  _createClass(Payments, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        paymentClass: null
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      //TODO: This needs to move to a settings/config file.
	      var stripe = window.Stripe(_config.config.stripeApiKey);
	      var elements = stripe.elements();
	      var _this = this;
	
	      this.props.store.PaymentStore.paymentToken = {};
	
	      // Create and card field
	      var style = {
	        base: {
	          color: '#526069',
	          fontFamily: '"Roboto", sans-serif',
	          fontSize: '14px',
	          lineHeight: '35px',
	          '::placeholder': {
	            color: '#a8bbc2'
	          }
	        },
	        invalid: {
	          color: '#e9595b'
	        }
	      };
	      var card = elements.create('card', { style: style });
	      card.mount('#payment-card');
	
	      // Listen for errors
	      var errorHolder = document.querySelector('#payment-errors');
	
	      card.addEventListener('change', function (event) {
	        if (event.error) {
	          console.log(event.error);
	          errorHolder.textContent = event.error.message;
	        } else {
	          errorHolder.textContent = '';
	        }
	      });
	
	      // Submit payment
	      var form = document.querySelector('#payment-form');
	
	      form.addEventListener('submit', function (e) {
	        e.preventDefault();
	
	        if (form.className.indexOf('submitted') < 0) {
	          form.className += ' submitted';
	
	          stripe.createToken(card).then(function (result) {
	            if (result.error) {
	              // Let the user know there was an error
	              errorHolder.textContent = result.error.message;
	              form.classList.remove('submitted');
	            } else {
	              // Send token
	              stripeTokenHandler(result.token);
	            }
	          });
	        }
	      });
	
	      function stripeTokenHandler(token) {
	        // Insert the token id into the form and submit
	        var tokenInput = document.querySelector('#payment-token');
	        tokenInput.value = token.id;
	        // form.submit();
	
	        _this.props.store.PaymentStore.paymentToken = token;
	
	        _this.props.submit();
	        // _this.props.store.SessionStore.submitPayment();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'payment' },
	        _react2.default.createElement(
	          'form',
	          { id: 'payment-form', className: 'payment__form' },
	          _react2.default.createElement('input', { id: 'payment-token', type: 'hidden' }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'payment-name' },
	                translation.name
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                id: 'payment-name',
	                className: '_lr-hide',
	                placeholder: translation.name_helper,
	                autoFocus: true
	              })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'payment-card' },
	                translation.card
	              ),
	              _react2.default.createElement('div', { id: 'payment-card', className: 'payment__fields inspectlet-sensitive _lr-hide' })
	            )
	          ),
	          _react2.default.createElement('div', { id: 'payment-errors', className: 'errors' }),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'btn' },
	            translation.submit
	          )
	        )
	      );
	    }
	  }]);
	
	  return Payments;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Payments')(Payments);

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AdminStore = __webpack_require__(377);
	
	var _AdminStore2 = _interopRequireDefault(_AdminStore);
	
	var _BlackoutStore = __webpack_require__(888);
	
	var _BlackoutStore2 = _interopRequireDefault(_BlackoutStore);
	
	var _CourseStore = __webpack_require__(889);
	
	var _CourseStore2 = _interopRequireDefault(_CourseStore);
	
	var _EnrollmentStore = __webpack_require__(890);
	
	var _EnrollmentStore2 = _interopRequireDefault(_EnrollmentStore);
	
	var _ExamStore = __webpack_require__(223);
	
	var _ExamStore2 = _interopRequireDefault(_ExamStore);
	
	var _FundingRuleStore = __webpack_require__(891);
	
	var _FundingRuleStore2 = _interopRequireDefault(_FundingRuleStore);
	
	var _HelpStore = __webpack_require__(892);
	
	var _HelpStore2 = _interopRequireDefault(_HelpStore);
	
	var _LocationStore = __webpack_require__(893);
	
	var _LocationStore2 = _interopRequireDefault(_LocationStore);
	
	var _ManagerStore = __webpack_require__(378);
	
	var _ManagerStore2 = _interopRequireDefault(_ManagerStore);
	
	var _MessageStore = __webpack_require__(894);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _PaymentStore = __webpack_require__(379);
	
	var _PaymentStore2 = _interopRequireDefault(_PaymentStore);
	
	var _ProctorStore = __webpack_require__(151);
	
	var _ProctorStore2 = _interopRequireDefault(_ProctorStore);
	
	var _RegisterStore = __webpack_require__(895);
	
	var _RegisterStore2 = _interopRequireDefault(_RegisterStore);
	
	var _ReportStore = __webpack_require__(380);
	
	var _ReportStore2 = _interopRequireDefault(_ReportStore);
	
	var _ScheduleStore = __webpack_require__(381);
	
	var _ScheduleStore2 = _interopRequireDefault(_ScheduleStore);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _SettingsStore = __webpack_require__(152);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _SmarterIDStore = __webpack_require__(896);
	
	var _SmarterIDStore2 = _interopRequireDefault(_SmarterIDStore);
	
	var _StepInStore = __webpack_require__(897);
	
	var _StepInStore2 = _interopRequireDefault(_StepInStore);
	
	var _StudentStore = __webpack_require__(382);
	
	var _StudentStore2 = _interopRequireDefault(_StudentStore);
	
	var _SyncStore = __webpack_require__(898);
	
	var _SyncStore2 = _interopRequireDefault(_SyncStore);
	
	var _TicketStore = __webpack_require__(899);
	
	var _TicketStore2 = _interopRequireDefault(_TicketStore);
	
	var _VoucherStore = __webpack_require__(900);
	
	var _VoucherStore2 = _interopRequireDefault(_VoucherStore);
	
	var _UserStore = __webpack_require__(383);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Combine stores
	// Import stores
	var store = {
	  AdminStore: _AdminStore2.default,
	  BlackoutStore: _BlackoutStore2.default,
	  CourseStore: _CourseStore2.default,
	  EnrollmentStore: _EnrollmentStore2.default,
	  ExamStore: _ExamStore2.default,
	  FundingRuleStore: _FundingRuleStore2.default,
	  HelpStore: _HelpStore2.default,
	  LocationStore: _LocationStore2.default,
	  ManagerStore: _ManagerStore2.default,
	  MessageStore: _MessageStore2.default,
	  PaymentStore: _PaymentStore2.default,
	  ProctorStore: _ProctorStore2.default,
	  RegisterStore: _RegisterStore2.default,
	  ReportStore: _ReportStore2.default,
	  ScheduleStore: _ScheduleStore2.default,
	  SessionStore: _SessionStore2.default,
	  SettingsStore: _SettingsStore2.default,
	  SmarterIDStore: _SmarterIDStore2.default,
	  StepInStore: _StepInStore2.default,
	  StudentStore: _StudentStore2.default,
	  SyncStore: _SyncStore2.default,
	  TicketStore: _TicketStore2.default,
	  VoucherStore: _VoucherStore2.default,
	  UserStore: _UserStore2.default
	};
	
	exports.default = store;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(384);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 102 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(70);
	var createDesc = __webpack_require__(125);
	module.exports = __webpack_require__(67) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 104 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(390);
	var defined = __webpack_require__(228);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(228);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(72);
	
	var _Actions = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 109 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.get_phone_code = get_phone_code;
	exports.get_national_number_pattern = get_national_number_pattern;
	exports.get_formats = get_formats;
	exports.get_national_prefix = get_national_prefix;
	exports.get_national_prefix_formatting_rule = get_national_prefix_formatting_rule;
	exports.get_national_prefix_for_parsing = get_national_prefix_for_parsing;
	exports.get_national_prefix_transform_rule = get_national_prefix_transform_rule;
	exports.get_national_prefix_is_optional_when_formatting = get_national_prefix_is_optional_when_formatting;
	exports.get_leading_digits = get_leading_digits;
	exports.get_format_pattern = get_format_pattern;
	exports.get_format_format = get_format_format;
	exports.get_format_leading_digits_patterns = get_format_leading_digits_patterns;
	exports.get_format_national_prefix_formatting_rule = get_format_national_prefix_formatting_rule;
	exports.get_format_national_prefix_is_optional_when_formatting = get_format_national_prefix_is_optional_when_formatting;
	exports.get_format_national_prefix_is_mandatory_when_formatting = get_format_national_prefix_is_mandatory_when_formatting;
	exports.get_format_uses_national_prefix = get_format_uses_national_prefix;
	exports.get_format_international_format = get_format_international_format;
	exports.get_metadata_by_country_phone_code = get_metadata_by_country_phone_code;
	exports.get_types = get_types;
	exports.get_type_fixed_line = get_type_fixed_line;
	exports.get_type_mobile = get_type_mobile;
	exports.get_type_toll_free = get_type_toll_free;
	exports.get_type_premium_rate = get_type_premium_rate;
	exports.get_type_personal_number = get_type_personal_number;
	exports.get_type_voice_mail = get_type_voice_mail;
	exports.get_type_uan = get_type_uan;
	exports.get_type_pager = get_type_pager;
	exports.get_type_voip = get_type_voip;
	exports.get_type_shared_cost = get_type_shared_cost;
	exports.get_country_phone_code = get_country_phone_code;
	function get_phone_code(country_metadata) {
		return country_metadata[0];
	}
	
	function get_national_number_pattern(country_metadata) {
		return country_metadata[1];
	}
	
	function get_formats(country_metadata) {
		return country_metadata[2] || [];
	}
	
	function get_national_prefix(country_metadata) {
		return country_metadata[3];
	}
	
	function get_national_prefix_formatting_rule(country_metadata) {
		return country_metadata[4];
	}
	
	function get_national_prefix_for_parsing(country_metadata) {
		var national_prefix_for_parsing = country_metadata[5];
	
		// If `national_prefix_for_parsing` is not set explicitly,
		// then infer it from `national_prefix` (if any)
		if (!national_prefix_for_parsing) {
			national_prefix_for_parsing = get_national_prefix(country_metadata);
		}
	
		return national_prefix_for_parsing;
	}
	
	function get_national_prefix_transform_rule(country_metadata) {
		return country_metadata[6];
	}
	
	function get_national_prefix_is_optional_when_formatting(country_metadata) {
		return country_metadata[7];
	}
	
	function get_leading_digits(country_metadata) {
		return country_metadata[8];
	}
	
	function get_format_pattern(format_array) {
		return format_array[0];
	}
	
	function get_format_format(format_array) {
		return format_array[1];
	}
	
	function get_format_leading_digits_patterns(format_array) {
		return format_array[2] || [];
	}
	
	function get_format_national_prefix_formatting_rule(format_array, country_metadata) {
		return format_array[3] || get_national_prefix_formatting_rule(country_metadata);
	}
	
	function get_format_national_prefix_is_optional_when_formatting(format_array, country_metadata) {
		return format_array[4] || get_national_prefix_is_optional_when_formatting(country_metadata);
	}
	
	function get_format_national_prefix_is_mandatory_when_formatting(format_array, country_metadata) {
		var national_prefix_formatting_rule = get_format_national_prefix_formatting_rule(format_array, country_metadata);
	
		// National prefix is omitted if there's no national prefix formatting rule
		// set for this country, or when the national prefix formatting rule
		// contains no national prefix itself, or when this rule is set but
		// national prefix is optional for this phone number format
		// (and it is not enforced explicitly)
		return national_prefix_formatting_rule &&
		// Check that national prefix formatting rule is not a dummy one.
		// Check that national prefix formatting rule actually has national prefix digit(s).
		get_format_uses_national_prefix(national_prefix_formatting_rule) &&
		// Or maybe national prefix is optional for this format
		!get_format_national_prefix_is_optional_when_formatting(format_array, country_metadata);
	}
	
	// Checks whether national prefix formatting rule contains national prefix
	function get_format_uses_national_prefix(national_prefix_formatting_rule) {
		// Check that national prefix formatting rule is not a dummy one
		return national_prefix_formatting_rule !== '$1' &&
		// Check that national prefix formatting rule actually has national prefix digit(s)
		/\d/.test(national_prefix_formatting_rule.replace('$1', ''));
	}
	
	function get_format_international_format(format_array) {
		return format_array[5] || get_format_format(format_array);
	}
	
	// Formatting information for regions which share
	// a country calling code is contained by only one region
	// for performance reasons. For example, for NANPA region
	// ("North American Numbering Plan Administration",
	//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
	// it will be contained in the metadata for `US`.
	function get_metadata_by_country_phone_code(country_phone_code, metadata) {
		var country_code = metadata.country_phone_code_to_countries[country_phone_code][0];
		return metadata.countries[country_code];
	}
	
	function get_types(country_metadata) {
		return country_metadata[9];
	}
	
	function get_type(country_metadata, index) {
		return get_types(country_metadata) ? get_types(country_metadata)[index] : undefined;
	}
	
	function get_type_fixed_line(country_metadata) {
		return get_type(country_metadata, 0);
	}
	
	function get_type_mobile(country_metadata) {
		return get_type(country_metadata, 1);
	}
	
	function get_type_toll_free(country_metadata) {
		return get_type(country_metadata, 2);
	}
	
	function get_type_premium_rate(country_metadata) {
		return get_type(country_metadata, 3);
	}
	
	function get_type_personal_number(country_metadata) {
		return get_type(country_metadata, 4);
	}
	
	function get_type_voice_mail(country_metadata) {
		return get_type(country_metadata, 5);
	}
	
	function get_type_uan(country_metadata) {
		return get_type(country_metadata, 6);
	}
	
	function get_type_pager(country_metadata) {
		return get_type(country_metadata, 7);
	}
	
	function get_type_voip(country_metadata) {
		return get_type(country_metadata, 8);
	}
	
	function get_type_shared_cost(country_metadata) {
		return get_type(country_metadata, 9);
	}
	
	function get_country_phone_code(country, country_metadata) {
		return get_phone_code(country_metadata[country]);
	}
	//# sourceMappingURL=metadata.js.map

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DIGIT_MAPPINGS = exports.VALID_PUNCTUATION = exports.VALID_DIGITS = exports.PLUS_CHARS = undefined;
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(385);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(81);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = parse;
	exports.normalize = normalize;
	exports.replace_characters = replace_characters;
	exports.is_viable_phone_number = is_viable_phone_number;
	exports.extract_formatted_phone_number = extract_formatted_phone_number;
	exports.parse_phone_number = parse_phone_number;
	exports.parse_phone_number_and_country_phone_code = parse_phone_number_and_country_phone_code;
	exports.strip_national_prefix = strip_national_prefix;
	exports.find_country_code = find_country_code;
	
	var _common = __webpack_require__(162);
	
	var _metadata = __webpack_require__(109);
	
	var _format = __webpack_require__(248);
	
	var _types = __webpack_require__(249);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The maximum length of the country calling code.
	// This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	
	var MAX_LENGTH_COUNTRY_CODE = 3;
	
	// The minimum length of the national significant number.
	var MIN_LENGTH_FOR_NSN = 2;
	
	// The ITU says the maximum length should be 15,
	// but one can find longer numbers in Germany.
	var MAX_LENGTH_FOR_NSN = 17;
	
	// We don't allow input strings for parsing to be longer than 250 chars.
	// This prevents malicious input from consuming CPU.
	var MAX_INPUT_STRING_LENGTH = 250;
	
	var PLUS_CHARS = exports.PLUS_CHARS = '+\uFF0B';
	
	// Digits accepted in phone numbers
	// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
	var VALID_DIGITS = exports.VALID_DIGITS = '0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9';
	
	// `DASHES` will be right after the opening square bracket of the "character class"
	var DASHES = '-\u2010-\u2015\u2212\u30FC\uFF0D';
	var SLASHES = '\uFF0F/';
	var DOTS = '\uFF0E.';
	var WHITESPACE = ' \xA0\xAD\u200B\u2060\u3000';
	var BRACKETS = '()\uFF08\uFF09\uFF3B\uFF3D\\[\\]';
	var TILDES = '~\u2053\u223C\uFF5E';
	
	// Regular expression of acceptable punctuation found in phone numbers. This
	// excludes punctuation found as a leading character only. This consists of dash
	// characters, white space characters, full stops, slashes, square brackets,
	// parentheses and tildes. Full-width variants are also present.
	var VALID_PUNCTUATION = exports.VALID_PUNCTUATION = '' + DASHES + SLASHES + DOTS + WHITESPACE + BRACKETS + TILDES;
	
	// Pattern to capture digits used in an extension.
	// Places a maximum length of '7' for an extension.
	var CAPTURING_EXTN_DIGITS = '([' + VALID_DIGITS + ']{1,7})';
	
	// The RFC 3966 format for extensions.
	var RFC3966_EXTN_PREFIX = ';ext=';
	
	/**
	 * Regexp of all possible ways to write extensions, for use when parsing. This
	 * will be run as a case-insensitive regexp match. Wide character versions are
	 * also provided after each ASCII version. There are three regular expressions
	 * here. The first covers RFC 3966 format, where the extension is added using
	 * ';ext='. The second more generic one starts with optional white space and
	 * ends with an optional full stop (.), followed by zero or more spaces/tabs
	 * /commas and then the numbers themselves. The other one covers the special
	 * case of American numbers where the extension is written with a hash at the
	 * end, such as '- 503#'. Note that the only capturing groups should be around
	 * the digits that you want to capture as part of the extension, or else parsing
	 * will fail! We allow two options for representing the accented o - the
	 * character itself, and one in the unicode decomposed form with the combining
	 * acute accent.
	 */
	var EXTN_PATTERNS_FOR_PARSING = RFC3966_EXTN_PREFIX + CAPTURING_EXTN_DIGITS + '|' + '[ \xA0\\t,]*' + '(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|' + '[;,x\uFF58#\uFF03~\uFF5E]|int|anexo|\uFF49\uFF4E\uFF54)' + '[:\\.\uFF0E]?[ \xA0\\t,-]*' + CAPTURING_EXTN_DIGITS + '#?|' + '[- ]+([' + VALID_DIGITS + ']{1,5})#';
	
	// Regexp of all known extension prefixes used by different regions followed by
	// 1 or more valid digits, for use when parsing.
	var EXTN_PATTERN = new RegExp('(?:' + EXTN_PATTERNS_FOR_PARSING + ')$', 'i');
	
	//  Regular expression of viable phone numbers. This is location independent.
	//  Checks we have at least three leading digits, and only valid punctuation,
	//  alpha characters and digits in the phone number. Does not include extension
	//  data. The symbol 'x' is allowed here as valid punctuation since it is often
	//  used as a placeholder for carrier codes, for example in Brazilian phone
	//  numbers. We also allow multiple '+' characters at the start.
	//
	//  Corresponds to the following:
	//  [digits]{minLengthNsn}|
	//  plus_sign*
	//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
	//
	//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
	//  they are entered as "15" etc, but only if there is no punctuation in them.
	//  The second expression restricts the number of digits to three or more, but
	//  then allows them to be in international form, and to have alpha-characters
	//  and punctuation. We split up the two reg-exes here and combine them when
	//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
	//  with ^ and append $ to each branch.
	//
	//  "Note VALID_PUNCTUATION starts with a -,
	//   so must be the first in the range" (c) Google devs.
	//  (wtf did they mean by saying that; probably nothing)
	//
	var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}';
	//
	// And this is the second reg-exp:
	// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
	//
	var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';
	
	// The combined regular expression for valid phone numbers:
	//
	var VALID_PHONE_NUMBER_PATTERN = new RegExp(
	// Either a short two-digit-only phone number
	'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' +
	// Or a longer fully parsed phone number (min 3 characters)
	'^' + VALID_PHONE_NUMBER +
	// Phone number extensions
	'(?:' + EXTN_PATTERNS_FOR_PARSING + ')?' + '$', 'i');
	
	// This consists of the plus symbol, digits, and arabic-indic digits.
	var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']');
	
	// Regular expression of trailing characters that we want to remove.
	var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + ']+$');
	
	var LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+');
	
	// These mappings map a character (key) to a specific digit that should
	// replace it for normalization purposes. Non-European digits that
	// may be used in phone numbers are mapped to a European equivalent.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	var DIGIT_MAPPINGS = exports.DIGIT_MAPPINGS = {
		'0': '0',
		'1': '1',
		'2': '2',
		'3': '3',
		'4': '4',
		'5': '5',
		'6': '6',
		'7': '7',
		'8': '8',
		'9': '9',
		'\uFF10': '0', // Fullwidth digit 0
		'\uFF11': '1', // Fullwidth digit 1
		'\uFF12': '2', // Fullwidth digit 2
		'\uFF13': '3', // Fullwidth digit 3
		'\uFF14': '4', // Fullwidth digit 4
		'\uFF15': '5', // Fullwidth digit 5
		'\uFF16': '6', // Fullwidth digit 6
		'\uFF17': '7', // Fullwidth digit 7
		'\uFF18': '8', // Fullwidth digit 8
		'\uFF19': '9', // Fullwidth digit 9
		'\u0660': '0', // Arabic-indic digit 0
		'\u0661': '1', // Arabic-indic digit 1
		'\u0662': '2', // Arabic-indic digit 2
		'\u0663': '3', // Arabic-indic digit 3
		'\u0664': '4', // Arabic-indic digit 4
		'\u0665': '5', // Arabic-indic digit 5
		'\u0666': '6', // Arabic-indic digit 6
		'\u0667': '7', // Arabic-indic digit 7
		'\u0668': '8', // Arabic-indic digit 8
		'\u0669': '9', // Arabic-indic digit 9
		'\u06F0': '0', // Eastern-Arabic digit 0
		'\u06F1': '1', // Eastern-Arabic digit 1
		'\u06F2': '2', // Eastern-Arabic digit 2
		'\u06F3': '3', // Eastern-Arabic digit 3
		'\u06F4': '4', // Eastern-Arabic digit 4
		'\u06F5': '5', // Eastern-Arabic digit 5
		'\u06F6': '6', // Eastern-Arabic digit 6
		'\u06F7': '7', // Eastern-Arabic digit 7
		'\u06F8': '8', // Eastern-Arabic digit 8
		'\u06F9': '9' // Eastern-Arabic digit 9
	};
	
	var default_options = {
		country: {}
	
		// `options`:
		//  {
		//    country:
		//    {
		//      restrict - (a two-letter country code)
		//                 the phone number must be in this country
		//
		//      default - (a two-letter country code)
		//                default country to use for phone number parsing and validation
		//                (if no country code could be derived from the phone number)
		//    }
		//  }
		//
		// Returns `{ country, number }`
		//
		// Example use cases:
		//
		// ```js
		// parse('8 (800) 555-35-35', 'RU')
		// parse('8 (800) 555-35-35', 'RU', metadata)
		// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
		// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
		// parse('+7 800 555 35 35')
		// parse('+7 800 555 35 35', metadata)
		// ```
		//
	};function parse(arg_1, arg_2, arg_3) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3),
		    text = _sort_out_arguments.text,
		    options = _sort_out_arguments.options,
		    metadata = _sort_out_arguments.metadata;
	
		// Validate country codes
	
		// Validate `default` country
	
	
		if (options.country.default && !metadata.countries[options.country.default]) {
			throw new Error('Unknown country code: ' + options.country.default);
		}
	
		// Validate `restrict` country
		if (options.country.restrict && !metadata.countries[options.country.restrict]) {
			throw new Error('Unknown country code: ' + options.country.restrict);
		}
	
		// Parse the phone number
	
		var formatted_phone_number = void 0;
		var extension = void 0;
	
		// Parse RFC 3966 phone number URI.
		if (text && text.indexOf('tel:') === 0) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = (0, _getIterator3.default)(text.split(';')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var part = _step.value;
	
					var _part$split = part.split(':'),
					    _part$split2 = (0, _slicedToArray3.default)(_part$split, 2),
					    name = _part$split2[0],
					    value = _part$split2[1];
	
					switch (name) {
						case 'tel':
							formatted_phone_number = value;
							break;
						case 'ext':
							extension = value;
							break;
						case 'phone-context':
							// Domain contexts are ignored.
							if (value[0] === '+') {
								formatted_phone_number = value + formatted_phone_number;
							}
							break;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		} else {
			formatted_phone_number = extract_formatted_phone_number(text);
		}
	
		// If the phone number is not viable, then abort.
		if (!is_viable_phone_number(formatted_phone_number)) {
			return {};
		}
	
		// Attempt to parse extension first, since it doesn't require region-specific
		// data and we want to have the non-normalised number here.
		var with_extension_stripped = strip_extension(formatted_phone_number);
	
		if (with_extension_stripped.extension) {
			formatted_phone_number = with_extension_stripped.number, extension = with_extension_stripped.extension;
		}
	
		var _parse_phone_number_a = parse_phone_number_and_country_phone_code(formatted_phone_number, metadata),
		    country_phone_code = _parse_phone_number_a.country_phone_code,
		    number = _parse_phone_number_a.number;
	
		// Maybe invalid country phone code encountered
	
	
		if (!number) {
			return {};
		}
	
		var country = void 0;
		var country_metadata = void 0;
	
		// Whether the phone number is formatted as an international phone number
		var is_international = false;
	
		if (country_phone_code) {
			is_international = true;
	
			// Check country restriction
			if (options.country.restrict && country_phone_code !== (0, _metadata.get_phone_code)(metadata.countries[options.country.restrict])) {
				return {};
			}
	
			// Formatting information for regions which share
			// a country calling code is contained by only one region
			// for performance reasons. For example, for NANPA region
			// ("North American Numbering Plan Administration",
			//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
			// it will be contained in the metadata for `US`.
			country_metadata = (0, _metadata.get_metadata_by_country_phone_code)(country_phone_code, metadata);
	
			// `country` will be set later,
			// because, for example, for NANPA countries
			// there are several countries corresponding
			// to the same `1` country phone code.
			// Therefore, to reliably determine the exact country,
			// national (significant) number should be parsed first.
		} else if (options.country.restrict || options.country.default) {
			country = options.country.restrict || options.country.default;
			country_metadata = metadata.countries[country];
	
			number = normalize(formatted_phone_number);
		}
	
		if (!country_metadata) {
			return {};
		}
	
		var national_number = number;
	
		// Only strip national prefixes for non-international phone numbers
		// because national prefixes can't be present in international phone numbers.
		// Otherwise, while forgiving, it would parse a NANPA number `+1 1877 215 5230`
		// first to `1877 215 5230` and then, stripping the leading `1`, to `877 215 5230`,
		// and then it would assume that's a valid number which it isn't.
		// So no forgiveness for grandmas here.
		// The issue asking for this fix:
		// https://github.com/catamphetamine/libphonenumber-js/issues/159
		if (!is_international) {
			national_number = strip_national_prefix(number, country_metadata);
		}
	
		var did_have_national_prefix = national_number !== number;
	
		// https://github.com/catamphetamine/libphonenumber-js/issues/67
		// if (!is_international && !did_have_national_prefix &&
		// 		is_national_prefix_required(national_number, country_metadata))
		// {
		// 	return {}
		// }
	
		// Sometimes there are several countries
		// corresponding to the same country phone code
		// (e.g. NANPA countries all having `1` country phone code).
		// Therefore, to reliably determine the exact country,
		// national (significant) number should have been parsed first.
		//
		if (!country) {
			// When `metadata.json` is generated, all "ambiguous" country phone codes
			// get their countries populated with the full set of
			// "phone number type" regular expressions.
			country = find_country_code(country_phone_code, national_number, metadata);
	
			// Just in case there appears to be a bug in Google's metadata
			// and the exact country could not be extracted from the phone number.
			/* istanbul ignore if */
			if (!country) {
				return {};
			}
	
			// Update metadata to be for this specific country
			country_metadata = metadata.countries[country];
		}
	
		// Validate national (significant) number length.
		//
		// A sidenote:
		//
		// They say that sometimes national (significant) numbers
		// can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
		// https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
		// Such numbers will just be discarded.
		//
		if (national_number.length > MAX_LENGTH_FOR_NSN) {
			return {};
		}
	
		// National number pattern is different for each country,
		// even for those ones which are part of the "NANPA" group.
		var national_number_rule = new RegExp((0, _metadata.get_national_number_pattern)(country_metadata));
	
		// Check if national phone number pattern matches the number
		if (!(0, _common.matches_entirely)(national_number, national_number_rule)) {
			return {};
		}
	
		var result = {
			country: country,
			phone: national_number
		};
	
		if (extension) {
			result.ext = extension;
		}
	
		return result;
	}
	
	// Normalizes a string of characters representing a phone number.
	// This converts wide-ascii and arabic-indic numerals to European numerals,
	// and strips punctuation and alpha characters.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	function normalize(number) {
		return replace_characters(number, DIGIT_MAPPINGS);
	}
	
	// For any character not being part of `replacements`
	// it is removed from the phone number.
	function replace_characters(text, replacements) {
		var replaced = '';
	
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;
	
		try {
			for (var _iterator2 = (0, _getIterator3.default)(text), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var character = _step2.value;
	
				var replacement = replacements[character.toUpperCase()];
	
				if (replacement !== undefined) {
					replaced += replacement;
				}
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}
	
		return replaced;
	}
	
	// Checks to see if the string of characters could possibly be a phone number at
	// all. At the moment, checks to see that the string begins with at least 2
	// digits, ignoring any punctuation commonly found in phone numbers. This method
	// does not require the number to be normalized in advance - but does assume
	// that leading non-number symbols have been removed, such as by the method
	// `extract_possible_number`.
	//
	function is_viable_phone_number(number) {
		return number.length >= MIN_LENGTH_FOR_NSN && (0, _common.matches_entirely)(number, VALID_PHONE_NUMBER_PATTERN);
	}
	
	function extract_formatted_phone_number(text) {
		if (!text || text.length > MAX_INPUT_STRING_LENGTH) {
			return '';
		}
	
		// Attempt to extract a possible number from the string passed in
	
		var starts_at = text.search(PHONE_NUMBER_START_PATTERN);
	
		if (starts_at < 0) {
			return '';
		}
	
		return text
		// Trim everything to the left of the phone number
		.slice(starts_at)
		// Remove trailing non-numerical characters
		.replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
	}
	
	// Parses a formatted phone number.
	function parse_phone_number(number) {
		if (!number) {
			return '';
		}
	
		var is_international = LEADING_PLUS_CHARS_PATTERN.test(number);
	
		// Remove non-digits
		// (and strip the possible leading '+')
		number = normalize(number);
	
		if (is_international) {
			return '+' + number;
		}
	
		return number;
	}
	
	// Parses a formatted phone number
	// and returns `{ country_phone_code, number }`
	// where `number` is the national (significant) phone number.
	//
	// (aka `maybeExtractCountryPhoneCode`)
	//
	function parse_phone_number_and_country_phone_code(number, metadata) {
		number = parse_phone_number(number);
	
		if (!number) {
			return {};
		}
	
		// If this is not an international phone number,
		// then don't extract country phone code.
		if (number[0] !== '+') {
			return { number: number };
		}
	
		// Strip the leading '+' sign
		number = number.slice(1);
	
		// Fast abortion: country codes do not begin with a '0'
		if (number[0] === '0') {
			return {};
		}
	
		// The thing with country phone codes
		// is that they are orthogonal to each other
		// i.e. there's no such country phone code A
		// for which country phone code B exists
		// where B starts with A.
		// Therefore, while scanning digits,
		// if a valid country code is found,
		// that means that it is the country code.
		//
		var i = 1;
		while (i <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
			var country_phone_code = number.slice(0, i);
	
			if (metadata.country_phone_code_to_countries[country_phone_code]) {
				return { country_phone_code: country_phone_code, number: number.slice(i) };
			}
	
			i++;
		}
	
		return {};
	}
	
	// Strips any national prefix (such as 0, 1) present in the number provided
	function strip_national_prefix(number, country_metadata) {
		var national_prefix_for_parsing = (0, _metadata.get_national_prefix_for_parsing)(country_metadata);
	
		if (!number || !national_prefix_for_parsing) {
			return number;
		}
	
		// Attempt to parse the first digits as a national prefix
		var national_prefix_pattern = new RegExp('^(?:' + national_prefix_for_parsing + ')');
		var national_prefix_matcher = national_prefix_pattern.exec(number);
	
		// If no national prefix is present in the phone number,
		// but if the national prefix is optional for this country,
		// then consider this phone number valid.
		//
		// Google's reference `libphonenumber` implementation
		// wouldn't recognize such phone numbers as valid,
		// but I think it would perfectly make sense
		// to consider such phone numbers as valid
		// because if a national phone number was originally
		// formatted without the national prefix
		// then it must be parseable back into the original national number.
		// In other words, `parse(format(number))`
		// must always be equal to `number`.
		//
		if (!national_prefix_matcher) {
			return number;
		}
	
		var national_significant_number = void 0;
	
		// `national_prefix_for_parsing` capturing groups
		// (used only for really messy cases: Argentina, Brazil, Mexico, Somalia)
		var any_groups_were_captured = national_prefix_matcher[national_prefix_matcher.length - 1];
		var national_prefix_transform_rule = (0, _metadata.get_national_prefix_transform_rule)(country_metadata);
	
		// If the national number tranformation is needed then do it
		if (national_prefix_transform_rule && any_groups_were_captured) {
			national_significant_number = number.replace(national_prefix_pattern, national_prefix_transform_rule);
		}
		// Else, no transformation is necessary,
		// and just strip the national prefix.
		else {
				national_significant_number = number.slice(national_prefix_matcher[0].length);
			}
	
		// Verify the parsed national (significant) number for this country
		var national_number_rule = new RegExp((0, _metadata.get_national_number_pattern)(country_metadata));
	
		// If the original number (before stripping national prefix) was viable,
		// and the resultant number is not, then prefer the original phone number.
		// This is because for some countries (e.g. Russia) the same digit could be both
		// a national prefix and a leading digit of a valid national phone number,
		// like `8` is the national prefix for Russia and both
		// `8 800 555 35 35` and `800 555 35 35` are valid numbers.
		if ((0, _common.matches_entirely)(number, national_number_rule) && !(0, _common.matches_entirely)(national_significant_number, national_number_rule)) {
			return number;
		}
	
		// Return the parsed national (significant) number
		return national_significant_number;
	}
	
	function find_country_code(country_phone_code, national_phone_number, metadata) {
		// Is always non-empty, because `country_phone_code` is always valid
		var possible_countries = metadata.country_phone_code_to_countries[country_phone_code];
	
		// If there's just one country corresponding to the country code,
		// then just return it, without further phone number digits validation.
		if (possible_countries.length === 1) {
			return possible_countries[0];
		}
	
		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;
	
		try {
			for (var _iterator3 = (0, _getIterator3.default)(possible_countries), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var country_code = _step3.value;
	
				var country = metadata.countries[country_code];
	
				// Leading digits check would be the simplest one
				if ((0, _metadata.get_leading_digits)(country)) {
					if (national_phone_number && national_phone_number.search((0, _metadata.get_leading_digits)(country)) === 0) {
						return country_code;
					}
				}
				// Else perform full validation with all of those bulky
				// fixed-line/mobile/etc regular expressions.
				else if ((0, _types2.default)({ phone: national_phone_number, country: country_code }, metadata)) {
						return country_code;
					}
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}
	}
	
	// export function is_national_prefix_required(national_number, country_metadata)
	// {
	// 	const format = choose_format_for_number(get_formats(country_metadata), national_number)
	//
	// 	if (format)
	// 	{
	// 		return get_format_national_prefix_is_mandatory_when_formatting(format, country_metadata)
	// 	}
	// }
	
	// Sort out arguments
	function sort_out_arguments(arg_1, arg_2, arg_3) {
		var text = void 0;
		var options = void 0;
		var metadata = void 0;
	
		// Normalize numerical `value`.
		// https://github.com/catamphetamine/libphonenumber-js/issues/142
		// `parse(88005553535, ...)`.
		if (typeof arg_1 === 'number') {
			arg_1 = String(arg_1);
		}
	
		// If the phone number is passed as a string.
		// `parse('88005553535', ...)`.
		if (typeof arg_1 === 'string') {
			text = arg_1;
		}
	
		// If "resrict country" argument is being passed
		// then convert it to an `options` object.
		// `parse('88005553535', 'RU', [options], metadata)`.
		if (typeof arg_2 === 'string') {
			options = { country: { restrict: arg_2 } };
			metadata = arg_3;
		}
		// No "resrict country" argument is being passed.
		// International phone number is passed.
		// `parse('+78005553535', [options], metadata)`.
		else {
				if (arg_3) {
					options = arg_2;
					metadata = arg_3;
				} else {
					metadata = arg_2;
				}
			}
	
		// Metadata is required.
		if (!metadata || !metadata.countries) {
			throw new Error('Metadata is required');
		}
	
		// Apply default options.
		if (options) {
			options = (0, _extends3.default)({}, default_options, options);
		} else {
			options = default_options;
		}
	
		return { text: text, options: options, metadata: metadata };
	}
	
	// Strips any extension (as in, the part of the number dialled after the call is
	// connected, usually indicated with extn, ext, x or similar) from the end of
	// the number, and returns it.
	function strip_extension(number) {
		var start = number.search(EXTN_PATTERN);
		if (start < 0) {
			return {};
		}
	
		// If we find a potential extension, and the number preceding this is a viable
		// number, we assume it is an extension.
		var number_without_extension = number.slice(0, start);
		/* istanbul ignore if - seems a bit of a redundant check */
		if (!is_viable_phone_number(number_without_extension)) {
			return {};
		}
	
		var matches = number.match(EXTN_PATTERN);
		var i = 1;
		while (i < matches.length) {
			if (matches[i] != null && matches[i].length > 0) {
				return {
					number: number_without_extension,
					extension: matches[i]
				};
			}
			i++;
		}
	}
	//# sourceMappingURL=parse.js.map

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 8);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapValues;
	function mapValues(obj, f) {
	  if (obj == null) {
	    return {};
	  }
	
	  var res = {};
	  Object.keys(obj).forEach(function (key) {
	    res[key] = f(obj[key]);
	  });
	  return res;
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setActive = setActive;
	exports.default = registerXHR;
	
	var _mapValues = __webpack_require__(0);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _enhanceFunc = __webpack_require__(2);
	
	var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isActive = true;
	
	function setActive(shouldBeActive) {
	  isActive = shouldBeActive;
	}
	
	var currentXHRId = 0;
	function registerXHR(_ref) {
	  var addRequest = _ref.addRequest,
	      addResponse = _ref.addResponse;
	
	  var _XHR = XMLHttpRequest;
	  var xhrMap = new WeakMap();
	  var unsubscribedFromXhr = false;
	  // const LOGROCKET_XHR_LABEL = 'logrocket_xhr';
	  var LOGROCKET_XHR_LABEL = 'xhr-';
	
	  window._lrXMLHttpRequest = XMLHttpRequest;
	
	  // eslint-disable-next-line no-native-reassign
	  XMLHttpRequest = function XMLHttpRequest(mozAnon, mozSystem) {
	    var xhrObject = new _XHR(mozAnon, mozSystem);
	    if (!isActive) {
	      return xhrObject;
	    }
	
	    xhrMap.set(xhrObject, {
	      xhrId: ++currentXHRId,
	      headers: {}
	    });
	
	    // ..., 'open', (method, url, async, username, password) => {
	    (0, _enhanceFunc2.default)(xhrObject, 'open', function (method, url) {
	      if (unsubscribedFromXhr) return;
	      var currentXHR = xhrMap.get(xhrObject);
	      currentXHR.method = method;
	      currentXHR.url = url;
	    });
	
	    (0, _enhanceFunc2.default)(xhrObject, 'send', function (data) {
	      if (unsubscribedFromXhr) return;
	      var currentXHR = xhrMap.get(xhrObject);
	      if (!currentXHR) return;
	
	      var request = {
	        url: currentXHR.url,
	        method: currentXHR.method && currentXHR.method.toUpperCase(),
	        headers: (0, _mapValues2.default)(currentXHR.headers || {}, function (headerValues) {
	          return headerValues.join(', ');
	        }),
	        body: data
	      };
	      addRequest('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, request);
	    });
	
	    (0, _enhanceFunc2.default)(xhrObject, 'setRequestHeader', function (header, value) {
	      if (unsubscribedFromXhr) return;
	      var currentXHR = xhrMap.get(xhrObject);
	      if (!currentXHR) return;
	
	      currentXHR.headers = currentXHR.headers || {};
	      currentXHR.headers[header] = currentXHR.headers[header] || [];
	      currentXHR.headers[header].push(value);
	    });
	
	    var xhrListeners = {
	      readystatechange: function readystatechange() {
	        if (unsubscribedFromXhr) return;
	
	        if (xhrObject.readyState === 4) {
	          var currentXHR = xhrMap.get(xhrObject);
	          if (!currentXHR) return;
	
	          var headerString = xhrObject.getAllResponseHeaders();
	
	          var headers = headerString.split(/[\r\n]+/).reduce(function (previous, current) {
	            var next = previous;
	            var headerParts = current.split(': ');
	            if (headerParts.length > 0) {
	              var key = headerParts.shift(); // first index of the array
	              var value = headerParts.join(': '); // rest of the array repaired
	              if (previous[key]) {
	                next[key] += ', ' + value;
	              } else {
	                next[key] = value;
	              }
	            }
	            return next;
	          }, {});
	
	          var body = void 0;
	
	          // IE 11 sometimes throws when trying to access a large responses:
	          // https://connect.microsoft.com/IE/Feedback/Details/1053110
	          try {
	            switch (xhrObject.responseType) {
	              case 'json':
	              case 'arraybuffer':
	              case 'blob':
	                {
	                  body = xhrObject.response;
	                  break;
	                }
	              case 'document':
	                {
	                  body = xhrObject.responseXML;
	                  break;
	                }
	              case 'text':
	              case '':
	                {
	                  body = xhrObject.responseText;
	                  break;
	                }
	              default:
	                {
	                  body = '';
	                }
	            }
	          } catch (err) {
	            body = 'LogRocket: Error accessing response.';
	          }
	
	          var response = {
	            url: currentXHR.url,
	            status: xhrObject.status,
	            headers: headers,
	            body: body,
	            method: (currentXHR.method || '').toUpperCase()
	          };
	
	          addResponse('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, response);
	        }
	      }
	      // // Unused Event Listeners
	      // loadstart: () => {},
	      // progress: () => {},
	      // abort: () => {},
	      // error: () => {},
	      // load: () => {},
	      // timeout: () => {},
	      // loadend: () => {},
	    };
	
	    Object.keys(xhrListeners).forEach(function (key) {
	      xhrObject.addEventListener(key, xhrListeners[key]);
	    });
	
	    return xhrObject;
	  };
	
	  // this allows "instanceof XMLHttpRequest" to work
	  XMLHttpRequest.prototype = _XHR.prototype;
	
	  // Persist the static variables.
	  ['UNSENT', 'OPENED', 'HEADERS_RECEIVED', 'LOADING', 'DONE'].forEach(function (variable) {
	    XMLHttpRequest[variable] = _XHR[variable];
	  });
	
	  return function () {
	    unsubscribedFromXhr = true;
	    // eslint-disable-next-line no-native-reassign
	    XMLHttpRequest = _XHR;
	  };
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = enhanceFunc;
	/* eslint no-param-reassign: ["error", { "props": false }] */
	
	function enhanceFunc(obj, method, handler) {
	  var original = obj[method];
	
	  function shim() {
	    var res = void 0;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (original) {
	      res = original.apply(this, args);
	    }
	
	    handler.apply(this, args);
	    return res;
	  }
	
	  obj[method] = shim;
	
	  return function () {
	    obj[method] = original;
	  };
	}
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Capture = exports.registerExceptions = undefined;
	
	var _registerExceptions = __webpack_require__(16);
	
	var _registerExceptions2 = _interopRequireDefault(_registerExceptions);
	
	var _Capture = __webpack_require__(6);
	
	var Capture = _interopRequireWildcard(_Capture);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.registerExceptions = _registerExceptions2.default;
	exports.Capture = Capture;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1, eval)("this");
	} catch (e) {
		// This works if the window reference is available
		if (typeof window === "object") g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {/* eslint-disable */
	
	
	
	/*
	 TraceKit - Cross brower stack traces - github.com/occ/TraceKit
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	    collectWindowErrors: true,
	    debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
	
	function getLocationHref() {
	    if (typeof document === 'undefined' || typeof document.location === 'undefined') return '';
	
	    return document.location.href;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }
	
	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	            return;
	        }
	        for (var i in handlers) {
	            if (handlers.hasOwnProperty(i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;
	
	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex) {
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };
	
	            var name = undefined;
	            var msg = message; // must be new var or will modify original `arguments`
	            var groups;
	            if ({}.toString.call(message) === '[object String]') {
	                var groups = message.match(ERROR_TYPES_RE);
	                if (groups) {
	                    name = groups[1];
	                    msg = groups[2];
	                }
	            }
	
	            location.func = UNKNOWN_FUNCTION;
	
	            stack = {
	                'name': name,
	                'message': msg,
	                'url': getLocationHref(),
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    function installGlobalHandler() {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = _window.onerror;
	        _window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    function uninstallGlobalHandler() {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        _window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }
	
	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	                processLastException();
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, stack.incomplete ? 2000 : 0);
	
	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}();
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = function computeStackTraceWrapper() {
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if (parts = chrome.exec(lines[i])) {
	                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
	                element = {
	                    'url': !isNative ? parts[2] : null,
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': isNative ? [parts[2]] : [],
	                    'line': parts[3] ? +parts[3] : null,
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if (parts = winjs.exec(lines[i])) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': [],
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if (parts = gecko.exec(lines[i])) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : [],
	                    'line': parts[4] ? +parts[4] : null,
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	
	            stack.push(element);
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = UNKNOWN_FUNCTION;
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if (parts = functionName.exec(curr.toString())) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	                try {
	                    item.func = parts.input.substring(0, parts.input.indexOf('{'));
	                } catch (e) {}
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            } else {
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = depth == null ? 0 : +depth;
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref()
	        };
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	    return computeStackTrace;
	}();
	
	module.exports = TraceKit;
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable no-param-reassign */
	
	
	exports.captureMessage = captureMessage;
	exports.captureException = captureException;
	
	var _TraceKit = __webpack_require__(5);
	
	var _TraceKit2 = _interopRequireDefault(_TraceKit);
	
	var _stackTraceFromError = __webpack_require__(18);
	
	var _stackTraceFromError2 = _interopRequireDefault(_stackTraceFromError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isScalar(value) {
	  return (/boolean|number|string/.test(typeof value === 'undefined' ? 'undefined' : _typeof(value))
	  );
	}
	
	function scrub(data, options) {
	  if (options) {
	    var optionalScalars = [
	    // Valid values for 'level' are 'fatal', 'error', 'warning', 'info',
	    // and 'debug'. Defaults to 'error'.
	    'level', 'logger'];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = optionalScalars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var field = _step.value;
	
	        var value = options[field];
	
	        if (isScalar(value)) {
	          data[field] = value.toString();
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var optionalMaps = ['tags', 'extra'];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = optionalMaps[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var _field = _step2.value;
	
	        var dirty = options[_field] || {};
	        var scrubbed = {};
	
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = Object.keys(dirty)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var key = _step3.value;
	
	            var _value = dirty[key];
	
	            if (isScalar(_value)) {
	              scrubbed[key.toString()] = _value.toString();
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	
	        data[_field] = scrubbed;
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	}
	
	function captureMessage(logger, message) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var isConsole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  var data = {
	    exceptionType: isConsole ? 'CONSOLE' : 'MESSAGE',
	    message: message,
	    browserHref: window.location.href
	  };
	
	  scrub(data, options);
	
	  logger.addEvent('lr.core.Exception', function () {
	    return data;
	  });
	}
	
	function captureException(logger, exception) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var trace = preppedTrace || _TraceKit2.default.computeStackTrace(exception);
	
	  var data = {
	    exceptionType: 'WINDOW',
	    errorType: trace.name,
	    message: trace.message,
	    browserHref: window.location.href
	  };
	
	  scrub(data, options);
	
	  var addEventOptions = {
	    _stackTrace: (0, _stackTraceFromError2.default)(trace)
	  };
	
	  logger.addEvent('lr.core.Exception', function () {
	    return data;
	  }, addEventOptions);
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports,"__esModule",{value:true});var dateNow=Date.now.bind(Date);var loadTime=dateNow();exports.default=typeof performance!=='undefined'&&performance.now?performance.now.bind(performance):function(){return dateNow()-loadTime;};module.exports=exports['default'];
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(9);
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _setup = __webpack_require__(10);
	
	var _setup2 = _interopRequireDefault(_setup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instance = (0, _setup2.default)();
	
	exports.default = instance;
	module.exports = exports['default'];
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setup;
	
	var _makeLogRocket = __webpack_require__(11);
	
	var _makeLogRocket2 = _interopRequireDefault(_makeLogRocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function setup() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var enterpriseServer = _ref.enterpriseServer,
	      opts = _objectWithoutProperties(_ref, ['enterpriseServer']);
	
	  var sdkServer = opts.sdkServer || enterpriseServer;
	  var ingestServer = opts.ingestServer || enterpriseServer;
	
	  var instance = (0, _makeLogRocket2.default)(function () {
	    var script = document.createElement('script');
	
	    if (ingestServer) {
	      if (typeof window.__SDKCONFIG__ === 'undefined') {
	        window.__SDKCONFIG__ = {};
	      }
	
	      window.__SDKCONFIG__.serverURL = ingestServer + '/i';
	      window.__SDKCONFIG__.statsURL = ingestServer + '/s';
	    }
	
	    if (sdkServer) {
	      script.src = sdkServer + '/logger.min.js';
	    } else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) {
	      script.src = window.__SDKCONFIG__.loggerURL;
	    } else if (window._lrAsyncScript) {
	      script.src = window._lrAsyncScript;
	    } else {
	      script.src = undefined === 'staging' ? 'https://cdn-staging.logrocket.io/logger.min.js' : 'https://cdn.logrocket.io/logger.min.js';
	    }
	
	    script.async = true;
	    document.head.appendChild(script);
	    script.onload = function () {
	      instance.onLogger(new window._LRLogger({
	        sdkVersion: "0.6.21" // eslint-disable-line no-undef
	      }));
	    };
	    script.onerror = function () {
	      console.warn('LogRocket: script could not load. Check that you have a valid network connection.');
	      instance.uninstall();
	    };
	  });
	
	  return instance;
	}
	module.exports = exports['default'];
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeLogRocket;
	
	var _LogRocket = __webpack_require__(12);
	
	var _LogRocket2 = _interopRequireDefault(_LogRocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REACT_NATIVE_NOTICE = 'LogRocket does not yet support React Native.';
	var makeNoopPolyfill = function makeNoopPolyfill() {
	  return {
	    init: function init() {},
	    uninstall: function uninstall() {},
	    log: function log() {},
	    info: function info() {},
	    warn: function warn() {},
	    error: function error() {},
	    debug: function debug() {},
	    addEvent: function addEvent() {},
	    identify: function identify() {},
	    start: function start() {},
	
	
	    get threadID() {
	      return null;
	    },
	    get recordingID() {
	      return null;
	    },
	    get recordingURL() {
	      return null;
	    },
	
	    reduxEnhancer: function reduxEnhancer() {
	      return function (store) {
	        return function () {
	          return store.apply(undefined, arguments);
	        };
	      };
	    },
	    reduxMiddleware: function reduxMiddleware() {
	      return function () {
	        return function (next) {
	          return function (action) {
	            return next(action);
	          };
	        };
	      };
	    },
	    track: function track() {},
	    getSessionURL: function getSessionURL() {},
	    getVersion: function getVersion() {},
	    startNewSession: function startNewSession() {},
	    onLogger: function onLogger() {},
	    setClock: function setClock() {},
	    captureMessage: function captureMessage() {},
	    captureException: function captureException() {}
	  };
	};
	
	function makeLogRocket() {
	  var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    throw new Error(REACT_NATIVE_NOTICE);
	  }
	
	  if (typeof window !== 'undefined') {
	    if (window._disableLogRocket) {
	      return makeNoopPolyfill();
	    }
	
	    if (window.MutationObserver) {
	      // Save window globals that we rely on.
	      window._lrMutationObserver = window.MutationObserver;
	
	      var instance = new _LogRocket2.default();
	      getLogger(instance);
	      return instance;
	    }
	  }
	
	  return makeNoopPolyfill();
	}
	module.exports = exports['default'];
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MAX_QUEUE_SIZE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _logrocketNetwork = __webpack_require__(13);
	
	var _logrocketNetwork2 = _interopRequireDefault(_logrocketNetwork);
	
	var _logrocketExceptions = __webpack_require__(3);
	
	var _logrocketConsole = __webpack_require__(19);
	
	var _logrocketConsole2 = _interopRequireDefault(_logrocketConsole);
	
	var _logrocketRedux = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MAX_QUEUE_SIZE = exports.MAX_QUEUE_SIZE = 1000;
	
	var considerIngestServerOption = function considerIngestServerOption() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var ingestServer = _ref.ingestServer,
	      options = _objectWithoutProperties(_ref, ['ingestServer']);
	
	  if (ingestServer) {
	    return _extends({
	      serverURL: ingestServer + '/i',
	      statsURL: ingestServer + '/s'
	    }, options);
	  }
	
	  return options;
	};
	
	var LogRocket = function () {
	  function LogRocket() {
	    var _this = this;
	
	    _classCallCheck(this, LogRocket);
	
	    this._buffer = [];
	
	    // TODO: tests for these exposed methods.
	    ['log', 'info', 'warn', 'error', 'debug'].forEach(function (method) {
	      _this[method] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this.addEvent('lr.core.LogEvent', function () {
	          var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
	            _logrocketExceptions.Capture.captureMessage(_this, args[0], {}, true);
	          }
	
	          return {
	            logLevel: method.toUpperCase(),
	            args: args
	          };
	        }, { shouldCaptureStackTrace: true });
	      };
	    });
	    this._isInitialized = false;
	    this._installed = [];
	  }
	
	  _createClass(LogRocket, [{
	    key: 'addEvent',
	    value: function addEvent(type, getMessage) {
	      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var time = Date.now();
	      this._run(function (logger) {
	        logger.addEvent(type, getMessage, _extends({}, opts, {
	          timeOverride: time
	        }));
	      });
	    }
	  }, {
	    key: 'onLogger',
	    value: function onLogger(logger) {
	      this._logger = logger;
	
	      while (this._buffer.length > 0) {
	        var f = this._buffer.shift();
	        f(this._logger);
	      }
	    }
	  }, {
	    key: '_run',
	    value: function _run(f) {
	      if (this._isDisabled) {
	        return;
	      }
	
	      if (this._logger) {
	        f(this._logger);
	      } else {
	        if (this._buffer.length >= MAX_QUEUE_SIZE) {
	          this._isDisabled = true;
	          console.warn('LogRocket: script did not load. Check that you have a valid network connection.');
	          this.uninstall();
	          return;
	        }
	
	        this._buffer.push(f.bind(this));
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init(appID, opts) {
	      if (!this._isInitialized) {
	        this._installed.push((0, _logrocketExceptions.registerExceptions)(this));
	        this._installed.push((0, _logrocketNetwork2.default)(this));
	        this._installed.push((0, _logrocketConsole2.default)(this));
	
	        this._isInitialized = true;
	
	        this._run(function (logger) {
	          logger.init(appID, considerIngestServerOption(opts));
	        });
	      }
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this._run(function (logger) {
	        logger.start();
	      });
	    }
	  }, {
	    key: 'uninstall',
	    value: function uninstall() {
	      this._installed.forEach(function (f) {
	        return f();
	      });
	      this._buffer = [];
	
	      this._run(function (logger) {
	        logger.uninstall();
	      });
	    }
	  }, {
	    key: 'identify',
	    value: function identify(id, opts) {
	      this._run(function (logger) {
	        logger.identify(id, opts);
	      });
	    }
	  }, {
	    key: 'startNewSession',
	    value: function startNewSession() {
	      this._run(function (logger) {
	        logger.startNewSession();
	      });
	    }
	  }, {
	    key: 'track',
	    value: function track(customEventName) {
	      this._run(function (logger) {
	        logger.track(customEventName);
	      });
	    }
	  }, {
	    key: 'getSessionURL',
	    value: function getSessionURL(cb) {
	      if (typeof cb !== 'function') {
	        throw new Error('LogRocket: must pass callback to getSessionURL()');
	      }
	
	      this._run(function (logger) {
	        if (logger.getSessionURL) {
	          logger.getSessionURL(cb);
	        } else {
	          cb(logger.recordingURL);
	        }
	      });
	    }
	  }, {
	    key: 'getVersion',
	    value: function getVersion(cb) {
	      this._run(function (logger) {
	        cb(logger.version);
	      });
	    }
	  }, {
	    key: 'startTransaction',
	    value: function startTransaction(transactionID) {
	      this.addEvent('lr.transaction.Start', function () {
	        return { id: transactionID };
	      });
	    }
	  }, {
	    key: 'endTransaction',
	    value: function endTransaction(transactionID) {
	      this.addEvent('lr.transaction.End', function () {
	        return { id: transactionID };
	      });
	    }
	  }, {
	    key: 'captureMessage',
	    value: function captureMessage(message) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _logrocketExceptions.Capture.captureMessage(this, message, options);
	    }
	  }, {
	    key: 'captureException',
	    value: function captureException(exception) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _logrocketExceptions.Capture.captureException(this, exception, options);
	    }
	  }, {
	    key: 'reduxEnhancer',
	    value: function reduxEnhancer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return (0, _logrocketRedux.createEnhancer)(this, options);
	    }
	  }, {
	    key: 'reduxMiddleware',
	    value: function reduxMiddleware() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return (0, _logrocketRedux.createMiddleware)(this, options);
	    }
	  }, {
	    key: 'version',
	    get: function get() {
	      return this._logger && this._logger.version;
	    }
	  }, {
	    key: 'sessionURL',
	    get: function get() {
	      return this._logger && this._logger.recordingURL;
	    }
	  }, {
	    key: 'recordingURL',
	    get: function get() {
	      return this._logger && this._logger.recordingURL;
	    }
	  }, {
	    key: 'recordingID',
	    get: function get() {
	      return this._logger && this._logger.recordingID;
	    }
	  }, {
	    key: 'threadID',
	    get: function get() {
	      return this._logger && this._logger.threadID;
	    }
	  }, {
	    key: 'tabID',
	    get: function get() {
	      return this._logger && this._logger.tabID;
	    }
	  }]);
	
	  return LogRocket;
	}();
	
	exports.default = LogRocket;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	// import registerWebSocket from './registerWebSocket';
	
	
	exports.default = registerNetwork;
	
	var _registerFetch = __webpack_require__(14);
	
	var _registerFetch2 = _interopRequireDefault(_registerFetch);
	
	var _registerXHR = __webpack_require__(1);
	
	var _registerXHR2 = _interopRequireDefault(_registerXHR);
	
	var _mapValues = __webpack_require__(0);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerNetwork(logger) {
	  var ignoredNetwork = {};
	
	  // truncate if > 4MB in size
	  var truncate = function truncate(data) {
	    var limit = 1024 * 1000 * 4;
	    var str = data;
	
	    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data != null) {
	      var proto = Object.getPrototypeOf(data);
	
	      if (proto === Object.prototype || proto === null) {
	        // plain object - jsonify for the size check
	        str = JSON.stringify(data);
	      }
	    }
	
	    if (str && str.length && str.length > limit && typeof str === 'string') {
	      var beginning = str.substring(0, 1000);
	      return beginning + ' ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference#network';
	    }
	
	    return data;
	  };
	
	  var addRequest = function addRequest(reqId, request) {
	    var method = request.method;
	    logger.addEvent('lr.network.RequestEvent', function () {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$isEnabled = _ref.isEnabled,
	          isEnabled = _ref$isEnabled === undefined ? true : _ref$isEnabled,
	          _ref$requestSanitizer = _ref.requestSanitizer,
	          requestSanitizer = _ref$requestSanitizer === undefined ? function (f) {
	        return f;
	      } : _ref$requestSanitizer;
	
	      if (!isEnabled) {
	        return null;
	      }
	      var sanitized = null;
	      try {
	        // only try catch user defined functions
	        sanitized = requestSanitizer(request);
	      } catch (err) {
	        console.error(err);
	      }
	      if (sanitized) {
	        // Writing and then reading from an a tag turns a relative
	        // url into an absolute one.
	        var a = document.createElement('a');
	        a.href = sanitized.url;
	
	        return {
	          reqId: reqId, // default
	          url: a.href, // sanitized
	          headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
	            // sanitized
	            return '' + headerValue;
	          }),
	          body: truncate(sanitized.body), // sanitized
	          method: method, // default
	          referrer: sanitized.referrer || undefined, // sanitized
	          mode: sanitized.mode || undefined, // sanitized
	          credentials: sanitized.credentials || undefined // sanitized
	        };
	      }
	      ignoredNetwork[reqId] = true;
	      return null;
	    });
	  };
	
	  var addResponse = function addResponse(reqId, response) {
	    var method = response.method,
	        status = response.status;
	
	    logger.addEvent('lr.network.ResponseEvent', function () {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$isEnabled = _ref2.isEnabled,
	          isEnabled = _ref2$isEnabled === undefined ? true : _ref2$isEnabled,
	          _ref2$responseSanitiz = _ref2.responseSanitizer,
	          responseSanitizer = _ref2$responseSanitiz === undefined ? function (f) {
	        return f;
	      } : _ref2$responseSanitiz;
	
	      if (!isEnabled) {
	        return null;
	      } else if (ignoredNetwork[reqId]) {
	        delete ignoredNetwork[reqId];
	        return null;
	      }
	      var sanitized = null;
	
	      try {
	        // only try catch user defined functions
	        sanitized = responseSanitizer(response);
	      } catch (err) {
	        console.error(err);
	        // fall through to redacted log
	      }
	      if (sanitized) {
	        return {
	          reqId: reqId, // default
	          status: sanitized.status, // sanitized
	          headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
	            // sanitized
	            return '' + headerValue;
	          }),
	          body: truncate(sanitized.body), // sanitized
	          method: method // default
	        };
	      }
	      return {
	        reqId: reqId, // default
	        status: status, // default
	        headers: {}, // redacted
	        body: null, // redacted
	        method: method // default
	      };
	    });
	  };
	
	  var unsubFetch = (0, _registerFetch2.default)({ addRequest: addRequest, addResponse: addResponse });
	  var unsubXHR = (0, _registerXHR2.default)({ addRequest: addRequest, addResponse: addResponse });
	  // const unsubWebSocket = registerWebSocket(logger);
	
	  return function () {
	    unsubFetch();
	    unsubXHR();
	    // unsubWebSocket();
	  };
	}
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = registerFetch;
	
	var _mapValues = __webpack_require__(0);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _fetchIntercept = __webpack_require__(15);
	
	var _fetchIntercept2 = _interopRequireDefault(_fetchIntercept);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeObjectFromHeaders(headers) {
	  // If using real fetch, we must stringify the Headers object.
	  if (headers == null || typeof headers.forEach !== 'function') {
	    return headers;
	  }
	
	  var result = {};
	  headers.forEach(function (value, key) {
	    if (result[key]) {
	      result[key] = result[key] + ',' + value;
	    } else {
	      result[key] = '' + value;
	    }
	  });
	  return result;
	}
	
	// XHR specification is unclear of what types to allow in value so using toString method for now
	var stringifyHeaders = function stringifyHeaders(headers) {
	  return (0, _mapValues2.default)(makeObjectFromHeaders(headers), function (value) {
	    return '' + value;
	  });
	};
	
	function pluckFetchFields() {
	  var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    url: arg.url,
	    headers: stringifyHeaders(arg.headers),
	    method: arg.method && arg.method.toUpperCase(),
	    referrer: arg.referrer || undefined,
	    mode: arg.mode || undefined,
	    credentials: arg.credentials || undefined
	  };
	}
	
	function registerFetch(_ref) {
	  var addRequest = _ref.addRequest,
	      addResponse = _ref.addResponse;
	
	  var LOGROCKET_XHR_LABEL = 'fetch-';
	  var fetchMethodMap = {};
	
	  var unregister = _fetchIntercept2.default.register({
	    request: function request(fetchId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var p = void 0;
	
	      if (typeof Request !== 'undefined' && args[0] instanceof Request) {
	        p = args[0].clone().text().then(function (body) {
	          return _extends({}, pluckFetchFields(args[0]), {
	            body: body
	          });
	        });
	      } else {
	        p = Promise.resolve(_extends({}, pluckFetchFields(args[1]), {
	          url: '' + args[0],
	          body: (args[1] || {}).body
	        }));
	      }
	
	      return p.then(function (req) {
	        fetchMethodMap[fetchId] = req.method;
	        addRequest('' + LOGROCKET_XHR_LABEL + fetchId, req);
	        return args;
	      });
	    },
	    requestError: function requestError(fetchId, error) {
	      return Promise.reject(error);
	    },
	    response: function response(fetchId, _response) {
	      var clonedText = void 0;
	
	      try {
	        // TODO: enhance function on original response and future clones for:
	        // text(), json(), blob(), formdata(), arraybuffer()
	        clonedText = _response.clone().text();
	      } catch (err) {
	        // safari has a bug where cloning can fail
	        clonedText = Promise.resolve('LogRocket fetch error: ' + err.message);
	      }
	
	      return clonedText.then(function (data) {
	        var responseHash = {
	          url: _response.url,
	          status: _response.status,
	          headers: stringifyHeaders(_response.headers),
	          body: data,
	          method: fetchMethodMap[fetchId]
	        };
	        delete fetchMethodMap[fetchId];
	        addResponse('' + LOGROCKET_XHR_LABEL + fetchId, responseHash);
	        return _response;
	      });
	    },
	    responseError: function responseError(fetchId, error) {
	      var response = {
	        url: undefined,
	        status: 0,
	        headers: {},
	        body: '' + error
	      };
	      addResponse('' + LOGROCKET_XHR_LABEL + fetchId, response);
	      return Promise.reject(error);
	    }
	  });
	
	  return unregister;
	}
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registerXHR = __webpack_require__(1);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var interceptors = [];
	
	function makeInterceptor(fetch, fetchId) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
	    return [interceptor].concat(array);
	  }, []);
	  var promise = Promise.resolve(args);
	
	  // Register request interceptors
	  reversedInterceptors.forEach(function (_ref) {
	    var request = _ref.request,
	        requestError = _ref.requestError;
	
	    if (request || requestError) {
	      promise = promise.then(function (args) {
	        return request.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
	      }, function (args) {
	        return requestError.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
	      });
	    }
	  });
	
	  promise = promise.then(function (args) {
	    (0, _registerXHR.setActive)(false);
	
	    var res = void 0;
	    var err = void 0;
	    try {
	      res = fetch.apply(undefined, _toConsumableArray(args));
	    } catch (_err) {
	      err = _err;
	    }
	
	    (0, _registerXHR.setActive)(true);
	
	    if (err) {
	      throw err;
	    }
	    return res;
	  });
	
	  reversedInterceptors.forEach(function (_ref2) {
	    var response = _ref2.response,
	        responseError = _ref2.responseError;
	
	    if (response || responseError) {
	      promise = promise.then(function (res) {
	        return response(fetchId, res);
	      }, function (err) {
	        return responseError && responseError(fetchId, err);
	      });
	    }
	  });
	
	  return promise;
	}
	
	function attach(env) {
	  if (!env.fetch || !env.Promise) {
	    // Make sure fetch is avaibale in the given environment. If it's not, then
	    // default to using XHR intercept.
	    return;
	  }
	
	  var isPolyfill = env.fetch.polyfill;
	
	  // eslint-disable-next-line no-param-reassign
	  env.fetch = function (fetch) {
	    var fetchId = 0;
	
	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return makeInterceptor.apply(undefined, [fetch, fetchId++].concat(args));
	    };
	  }(env.fetch);
	
	  // Forward the polyfill propery from fetch (set by github/whatwg-fetch).
	  if (isPolyfill) {
	    // eslint-disable-next-line no-param-reassign
	    env.fetch.polyfill = isPolyfill;
	  }
	}
	
	// TODO: React Native
	//   attach(global);
	
	var didAttach = false;
	
	exports.default = {
	  register: function register(interceptor) {
	    if (!didAttach) {
	      didAttach = true;
	      attach(window);
	    }
	
	    interceptors.push(interceptor);
	    return function () {
	      var index = interceptors.indexOf(interceptor);
	
	      if (index >= 0) {
	        interceptors.splice(index, 1);
	      }
	    };
	  },
	  clear: function clear() {
	    interceptors = [];
	  }
	};
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerCore;
	
	var _raven = __webpack_require__(17);
	
	var _raven2 = _interopRequireDefault(_raven);
	
	var _Capture = __webpack_require__(6);
	
	var Capture = _interopRequireWildcard(_Capture);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerCore(logger) {
	  var raven = new _raven2.default({
	    captureException: function captureException(errorReport) {
	      Capture.captureException(logger, null, null, errorReport);
	    }
	  });
	
	  var rejectionHandler = function rejectionHandler(evt) {
	    // http://2ality.com/2016/04/unhandled-rejections.html
	    logger.addEvent('lr.core.Exception', function () {
	      return {
	        exceptionType: 'UNHANDLED_REJECTION',
	        message: evt.reason || 'Unhandled Promise rejection'
	      };
	    });
	  };
	
	  window.addEventListener('unhandledrejection', rejectionHandler);
	
	  return function () {
	    window.removeEventListener('unhandledrejection', rejectionHandler);
	    raven.uninstall();
	  };
	}
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */
	
	var _TraceKit = __webpack_require__(5);
	
	var _TraceKit2 = _interopRequireDefault(_TraceKit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var objectPrototype = Object.prototype;
	
	function isUndefined(what) {
	  return what === void 0;
	}
	
	function isFunction(what) {
	  return typeof what === 'function';
	}
	
	function each(obj, callback) {
	  var i, j;
	
	  if (isUndefined(obj.length)) {
	    for (i in obj) {
	      if (hasKey(obj, i)) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  } else {
	    j = obj.length;
	    if (j) {
	      for (i = 0; i < j; i++) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  }
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	  return objectPrototype.hasOwnProperty.call(object, key);
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}
	
	var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _document = _window.document;
	
	var Handler = function () {
	  function Handler(_ref) {
	    var captureException = _ref.captureException;
	
	    _classCallCheck(this, Handler);
	
	    this._errorHandler = this._errorHandler.bind(this);
	
	    this._ignoreOnError = 0;
	    this._wrappedBuiltIns = [];
	    this.captureException = captureException;
	    _TraceKit2.default.report.subscribe(this._errorHandler);
	    this._instrumentTryCatch();
	  }
	
	  _createClass(Handler, [{
	    key: 'uninstall',
	    value: function uninstall() {
	      _TraceKit2.default.report.unsubscribe(this._errorHandler);
	
	      // restore any wrapped builtins
	      var builtin;
	      while (this._wrappedBuiltIns.length) {
	        builtin = this._wrappedBuiltIns.shift();
	
	        var obj = builtin[0],
	            name = builtin[1],
	            orig = builtin[2];
	
	        obj[name] = orig;
	      }
	    }
	  }, {
	    key: '_errorHandler',
	    value: function _errorHandler(report) {
	      if (!this._ignoreOnError) {
	        this.captureException(report);
	      }
	    }
	  }, {
	    key: '_ignoreNextOnError',
	    value: function _ignoreNextOnError() {
	      var _this = this;
	
	      this._ignoreOnError += 1;
	      setTimeout(function () {
	        // onerror should trigger before setTimeout
	        _this._ignoreOnError -= 1;
	      });
	    }
	
	    /*
	     * Wrap code within a context so Handler can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	
	  }, {
	    key: 'context',
	    value: function context(options, func, args) {
	      if (isFunction(options)) {
	        args = func || [];
	        func = options;
	        options = undefined;
	      }
	
	      return this.wrap(options, func).apply(this, args);
	    }
	  }, {
	    key: 'wrap',
	
	
	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	    value: function wrap(options, func, _before) {
	      var self = this;
	      // 1 argument has been passed, and it's not a function
	      // so just return it
	      if (isUndefined(func) && !isFunction(options)) {
	        return options;
	      }
	
	      // options is optional
	      if (isFunction(options)) {
	        func = options;
	        options = undefined;
	      }
	
	      // At this point, we've passed along 2 arguments, and the second one
	      // is not a function either, so we'll just return the second argument.
	      if (!isFunction(func)) {
	        return func;
	      }
	
	      // We don't wanna wrap it twice!
	      try {
	        if (func.__lr__) {
	          return func;
	        }
	
	        // If this has already been wrapped in the past, return that
	        if (func.__lr_wrapper__) {
	          return func.__lr_wrapper__;
	        }
	      } catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see lr-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return func;
	      }
	
	      function wrapped() {
	        var args = [],
	            i = arguments.length,
	            deep = !options || options && options.deep !== false;
	
	        if (_before && isFunction(_before)) {
	          _before.apply(this, arguments);
	        }
	
	        // Recursively wrap all of a function's arguments that are
	        // functions themselves.
	        while (i--) {
	          args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	        }try {
	          // Attempt to invoke user-land function. This is part of the LogRocket SDK.
	          // If you're seeing this frame in a stack trace, it means that LogRocket caught
	          // an unhandled error thrown by your application code, reported it, then bubbled
	          // it up. This is expected behavior and is not a bug with LogRocket.
	          return func.apply(this, args);
	        } catch (e) {
	          self._ignoreNextOnError();
	          self.captureException(_TraceKit2.default.computeStackTrace(e), options);
	          throw e;
	        }
	      }
	
	      // copy over properties of the old function
	      for (var property in func) {
	        if (hasKey(func, property)) {
	          wrapped[property] = func[property];
	        }
	      }
	      wrapped.prototype = func.prototype;
	
	      func.__lr_wrapper__ = wrapped;
	      // Signal that this function has been wrapped already
	      // for both debugging and to prevent it to being wrapped twice
	      wrapped.__lr__ = true;
	      wrapped.__inner__ = func;
	
	      return wrapped;
	    }
	  }, {
	    key: '_instrumentTryCatch',
	
	
	    /**
	     * Install any queued plugins
	     */
	    value: function _instrumentTryCatch() {
	      var self = this;
	
	      var wrappedBuiltIns = self._wrappedBuiltIns;
	
	      function wrapTimeFn(orig) {
	        return function (fn, t) {
	          // preserve arity
	          // Make a copy of the arguments to prevent deoptimization
	          // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	          var args = new Array(arguments.length);
	          for (var i = 0; i < args.length; ++i) {
	            args[i] = arguments[i];
	          }
	          var originalCallback = args[0];
	          if (isFunction(originalCallback)) {
	            args[0] = self.wrap(originalCallback);
	          }
	
	          // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	          // also supports only two arguments and doesn't care what this is, so we
	          // can just call the original function directly.
	          if (orig.apply) {
	            return orig.apply(this, args);
	          } else {
	            return orig(args[0], args[1]);
	          }
	        };
	      }
	
	      function wrapEventTarget(global) {
	        var proto = _window[global] && _window[global].prototype;
	        if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	          fill(proto, 'addEventListener', function (orig) {
	            return function (evtName, fn, capture, secure) {
	              // preserve arity
	              try {
	                if (fn && fn.handleEvent) {
	                  fn.handleEvent = self.wrap(fn.handleEvent);
	                }
	              } catch (err) {}
	              // can sometimes get 'Permission denied to access property "handle Event'
	
	
	              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	              // so that we don't have more than one wrapper function
	              var before;
	
	              return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
	            };
	          }, wrappedBuiltIns);
	          fill(proto, 'removeEventListener', function (orig) {
	            return function (evt, fn, capture, secure) {
	              try {
	                fn = fn && (fn.__lr_wrapper__ ? fn.__lr_wrapper__ : fn);
	              } catch (e) {
	                // ignore, accessing __lr_wrapper__ will throw in some Selenium environments
	              }
	              return orig.call(this, evt, fn, capture, secure);
	            };
	          }, wrappedBuiltIns);
	        }
	      }
	
	      fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	      fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	      if (_window.requestAnimationFrame) {
	        fill(_window, 'requestAnimationFrame', function (orig) {
	          return function (cb) {
	            return orig(self.wrap(cb));
	          };
	        }, wrappedBuiltIns);
	      }
	
	      // event targets borrowed from bugsnag-js:
	      // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
	      for (var i = 0; i < eventTargets.length; i++) {
	        wrapEventTarget(eventTargets[i]);
	      }
	
	      var $ = _window.jQuery || _window.$;
	      if ($ && $.fn && $.fn.ready) {
	        fill($.fn, 'ready', function (orig) {
	          return function (fn) {
	            return orig.call(this, self.wrap(fn));
	          };
	        }, wrappedBuiltIns);
	      }
	    }
	  }]);
	
	  return Handler;
	}();
	
	exports.default = Handler;
	;
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stackTraceFromError;
	function stackTraceFromError(errorReport) {
	  function makeNotNull(val) {
	    return val === null ? undefined : val;
	  }
	
	  return errorReport.stack ? errorReport.stack.map(function (frame) {
	    return {
	      lineNumber: makeNotNull(frame.line),
	      columnNumber: makeNotNull(frame.column),
	      fileName: makeNotNull(frame.url),
	      functionName: makeNotNull(frame.func)
	    };
	  }) : undefined;
	}
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registerConsole = __webpack_require__(20);
	
	var _registerConsole2 = _interopRequireDefault(_registerConsole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _registerConsole2.default;
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = registerConsole;
	
	var _enhanceFunc = __webpack_require__(2);
	
	var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);
	
	var _logrocketExceptions = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerConsole(logger) {
	  var unsubFunctions = [];
	  var methods = ['log', 'warn', 'info', 'error', 'debug'];
	
	  methods.forEach(function (method) {
	    unsubFunctions.push((0, _enhanceFunc2.default)(console, method, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      logger.addEvent('lr.core.LogEvent', function () {
	        var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var isEnabled = consoleOptions.isEnabled;
	
	        if ((typeof isEnabled === 'undefined' ? 'undefined' : _typeof(isEnabled)) === 'object' && isEnabled[method] === false || isEnabled === false) {
	          return null;
	        }
	
	        if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
	          _logrocketExceptions.Capture.captureMessage(logger, args[0], {}, true);
	        }
	
	        return {
	          logLevel: method.toUpperCase(),
	          args: args
	        };
	      });
	    }));
	  });
	
	  return function () {
	    unsubFunctions.forEach(function (unsubFunction) {
	      return unsubFunction();
	    });
	  };
	}
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createEnhancer = exports.createMiddleware = undefined;
	
	var _createEnhancer = __webpack_require__(22);
	
	var _createEnhancer2 = _interopRequireDefault(_createEnhancer);
	
	var _createMiddleware = __webpack_require__(23);
	
	var _createMiddleware2 = _interopRequireDefault(_createMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createMiddleware = _createMiddleware2.default;
	exports.createEnhancer = _createEnhancer2.default;
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createEnhancer;
	
	var _now = __webpack_require__(7);
	
	var _now2 = _interopRequireDefault(_now);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storeIdCounter = 0;
	
	function createEnhancer(logger) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stateSanitizer = _ref.stateSanitizer,
	      stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$stateSanitizer,
	      _ref$actionSanitizer = _ref.actionSanitizer,
	      actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$actionSanitizer;
	
	  // an enhancer is a function that returns a Store
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var originalDispatch = store.dispatch;
	      var storeId = storeIdCounter++;
	      logger.addEvent('lr.redux.InitialState', function () {
	        var sanitizedState = void 0;
	        try {
	          // only try catch user defined functions
	          sanitizedState = stateSanitizer(store.getState());
	        } catch (err) {
	          console.error(err.toString());
	        }
	
	        return {
	          state: sanitizedState,
	          storeId: storeId
	        };
	      });
	
	      var dispatch = function dispatch(action) {
	        var start = (0, _now2.default)();
	
	        var err = void 0;
	        var res = void 0;
	        try {
	          res = originalDispatch(action);
	        } catch (_err) {
	          err = _err;
	        } finally {
	          var duration = (0, _now2.default)() - start;
	
	          logger.addEvent('lr.redux.ReduxAction', function () {
	            var sanitizedState = null;
	            var sanitizedAction = null;
	
	            try {
	              // only try catch user defined functions
	              sanitizedState = stateSanitizer(store.getState());
	              sanitizedAction = actionSanitizer(action);
	            } catch (err) {
	              console.error(err.toString());
	            }
	
	            if (sanitizedState && sanitizedAction) {
	              return {
	                storeId: storeId,
	                action: sanitizedAction,
	                duration: duration,
	                stateDelta: sanitizedState
	              };
	            }
	            return null;
	          });
	        }
	
	        if (err) {
	          throw err;
	        }
	
	        return res;
	      };
	
	      return _extends({}, store, {
	        dispatch: dispatch
	      });
	    };
	  };
	}
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMiddleware;
	
	var _now = __webpack_require__(7);
	
	var _now2 = _interopRequireDefault(_now);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storeIdCounter = 0;
	
	function createMiddleware(logger) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stateSanitizer = _ref.stateSanitizer,
	      stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$stateSanitizer,
	      _ref$actionSanitizer = _ref.actionSanitizer,
	      actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$actionSanitizer;
	
	  return function (store) {
	    var storeId = storeIdCounter++;
	    logger.addEvent('lr.redux.InitialState', function () {
	      var sanitizedState = void 0;
	      try {
	        // only try catch user defined functions
	        sanitizedState = stateSanitizer(store.getState());
	      } catch (err) {
	        console.error(err.toString());
	      }
	
	      return {
	        state: sanitizedState,
	        storeId: storeId
	      };
	    });
	
	    return function (next) {
	      return function (action) {
	        var start = (0, _now2.default)();
	
	        var err = void 0;
	        var res = void 0;
	        try {
	          res = next(action);
	        } catch (_err) {
	          err = _err;
	        } finally {
	          var duration = (0, _now2.default)() - start;
	
	          logger.addEvent('lr.redux.ReduxAction', function () {
	            var sanitizedState = null;
	            var sanitizedAction = null;
	
	            try {
	              // only try catch user defined functions
	              sanitizedState = stateSanitizer(store.getState());
	              sanitizedAction = actionSanitizer(action);
	            } catch (err) {
	              console.error(err.toString());
	            }
	
	            if (sanitizedState && sanitizedAction) {
	              return {
	                storeId: storeId,
	                action: sanitizedAction,
	                duration: duration,
	                stateDelta: sanitizedState
	              };
	            }
	            return null;
	          });
	        }
	
	        if (err) {
	          throw err;
	        }
	
	        return res;
	      };
	    };
	  };
	}
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 10);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) {
	    return [];
	};
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;
	
	  var isValidElement = function isValidElement(object) {
	    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(9)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(8)();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(2);
	  var warning = __webpack_require__(4);
	  var ReactPropTypesSecret = __webpack_require__(3);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error === 'undefined' ? 'undefined' : _typeof(error));
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	var ReactPropTypesSecret = __webpack_require__(3);
	
	module.exports = function () {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var emptyFunction = __webpack_require__(1);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(4);
	
	var ReactPropTypesSecret = __webpack_require__(3);
	var checkPropTypes = __webpack_require__(7);
	
	module.exports = function (isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (!manualPropTypeCallCache[cacheKey] &&
	          // Avoid spamming the console because they are often not actionable except for lib authors
	          manualPropTypeWarningCount < 3) {
	            warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName);
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(false, 'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' + 'received %s at index %s.', getPostfixForTypeWarning(checker), i);
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue)) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @constant types
	 * @type {{mount: string, unmounted: string}}
	 */
	var types = {
	  MOUNT: 'mount',
	  UNMOUNT: 'unmount'
	};
	
	/**
	 * @class ReactDelayed
	 * @extends {Component}
	 */
	
	var ReactDelayed = function (_Component) {
	  _inherits(ReactDelayed, _Component);
	
	  function ReactDelayed() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactDelayed);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactDelayed.__proto__ || Object.getPrototypeOf(ReactDelayed)).call.apply(_ref, [this].concat(args))), _this), _this.state = { mounted: typeof window === 'undefined' ? _this.props.mounted : false, deferred: null }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * @constant state
	   * @type {{mounted: boolean}}
	   */
	
	
	  /**
	   * @constant propTypes
	   * @type {{mountAfter: function, unmountAfter: function}}
	   */
	
	
	  /**
	   * @constant defaultProps
	   * @type {{mountAfter: number, unmountAfter: number}}
	   */
	
	
	  _createClass(ReactDelayed, [{
	    key: 'componentDidMount',
	
	
	    /**
	     * @method componentDidMount
	     * @return {void}
	     */
	    value: function componentDidMount() {
	      this.isComponentMounted = true;
	      this.props.mounted === true && this.handleVisibility(types.MOUNT);
	    }
	
	    /**
	     * @method componentWillUnmount
	     * @return {void}
	     */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isComponentMounted = false;
	    }
	
	    /**
	     * @method componentWillReceiveProps
	     * @param {Object} nextProps
	     * @return {void}
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.props.mounted === false && nextProps.mounted === true && this.handleVisibility(types.MOUNT);
	      this.props.mounted === true && nextProps.mounted === false && this.handleVisibility(types.UNMOUNT);
	    }
	
	    /**
	     * @method handleVisibility
	     * @param {String} type
	     * @return {void}
	     */
	
	  }, {
	    key: 'handleVisibility',
	    value: function handleVisibility(type) {
	      var _this2 = this;
	
	      var mounted = type === types.MOUNT;
	      var timeout = this.props[type + 'After'];
	      var invoker = timeout === 0 ? function (fn) {
	        return fn();
	      } : setTimeout;
	
	      clearTimeout(this.state.deferred);
	      var deferred = invoker(function () {
	        return _this2.isComponentMounted && _this2.setState({ mounted: mounted });
	      }, timeout);
	      this.setState({ deferred: deferred });
	    }
	
	    /**
	     * @method render
	     * @return {XML}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var isFunction = typeof this.props.children === 'function';
	      return this.state.mounted ? isFunction ? this.props.children() : this.props.children : _react2.default.createElement(this.props.nodeName, null);
	    }
	  }]);
	
	  return ReactDelayed;
	}(_react.Component);
	
	ReactDelayed.propTypes = {
	  mounted: _propTypes2.default.bool.isRequired,
	  mountAfter: _propTypes2.default.number.isRequired,
	  unmountAfter: _propTypes2.default.number.isRequired,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]).isRequired,
	  nodeName: _propTypes2.default.string.isRequired
	};
	ReactDelayed.defaultProps = {
	  mounted: false,
	  mountAfter: 0,
	  unmountAfter: 0,
	  children: _react2.default.createElement('span', null),
	  nodeName: 'span'
	};
	exports.default = ReactDelayed;
	
	/***/ })
	/******/ ]);

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(254);
	var setInnerHTML = __webpack_require__(168);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(262);
	var setTextContent = __webpack_require__(568);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(10);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 115 */
[1719, 1169, 1193],
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 118 */
[1695, 181, 1323, 1350],
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(62);
	
	var warning = __webpack_require__(14);
	var canDefineProperty = __webpack_require__(643);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(641);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 120 */
19,
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = function (WrappedComponent) {
	  var _class, _temp2;
	
	  var AnimationDecorator = (_temp2 = _class = function (_Component) {
	    _inherits(AnimationDecorator, _Component);
	
	    function AnimationDecorator() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, AnimationDecorator);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimationDecorator.__proto__ || Object.getPrototypeOf(AnimationDecorator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        animationId: 0
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AnimationDecorator, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var animationId = this.state.animationId;
	
	
	        if (this.props.data !== nextProps.data) {
	          this.setState({
	            animationId: animationId + 1
	          });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { animationId: this.state.animationId }));
	      }
	    }]);
	
	    return AnimationDecorator;
	  }(_react.Component), _class.displayName = 'AnimationDecorator(' + (0, _ReactUtils.getDisplayName)(WrappedComponent) + ')', _class.propTypes = _extends({}, WrappedComponent.propTypes, {
	    data: _propTypes2.default.array
	  }), _class.WrappedComponent = WrappedComponent, _class.defaultProps = WrappedComponent.defaultProps, _temp2);
	
	
	  return AnimationDecorator;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/***/ },
/* 122 */
[1759, 76, 78],
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _currencyFormatter = __webpack_require__(71);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	//import * as icons from '../Icons/Icons';
	
	var Pricing = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Pricing, _React$Component);
	
	  function Pricing() {
	    _classCallCheck(this, Pricing);
	
	    var _this2 = _possibleConstructorReturn(this, (Pricing.__proto__ || Object.getPrototypeOf(Pricing)).call(this));
	
	    _this2.handleVoucher = _this2.handleVoucher.bind(_this2);
	    _this2.applyVoucher = _this2.applyVoucher.bind(_this2);
	    _this2.removeVoucher = _this2.removeVoucher.bind(_this2);
	    _this2.toggleVoucher = _this2.toggleVoucher.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Pricing, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        showVoucher: false,
	        voucherCode: null
	      };
	    }
	  }, {
	    key: 'cleanQuery',
	    value: function cleanQuery(query) {
	      if (!query) return '';
	      // Remove any existing voucher code parameters
	      if (query.indexOf('&voucherCode') > -1) {
	        var queryParams = query.split('&');
	
	        for (var i = 0; i < queryParams.length; i++) {
	          if (queryParams[i].indexOf('voucherCode') > -1) {
	            queryParams.splice(i, 1);
	          }
	        }
	
	        return queryParams.join('&');
	      } else if (query.indexOf('?voucherCode') > -1) {
	        return '';
	      }
	
	      return query;
	    }
	  }, {
	    key: 'handleVoucher',
	    value: function handleVoucher() {
	      var _props$store = this.props.store,
	          ProctorStore = _props$store.ProctorStore,
	          ScheduleStore = _props$store.ScheduleStore;
	
	      var voucherCode = this.voucher_code.value;
	
	      this.setState({
	        voucherCode: voucherCode
	      });
	
	      var query = this.cleanQuery(ProctorStore.searchQuery);
	
	      // Add the new voucher code as a parameter
	      if (!query) {
	        query = '?voucherCode=' + voucherCode;
	      } else {
	        query += '&voucherCode=' + voucherCode;
	      }
	      if (this.props.scheduler.state) {
	        query += '&examSessionSid=' + [this.props.scheduler.state.sessionSid];
	        query += '&proctorLocationSids=' + [this.props.scheduler.state.proctorLocationSid];
	      }
	      if (ScheduleStore.appointmentDate) {
	        query += '&appointmentDate=' + ScheduleStore.appointmentDate;
	      }
	
	      // Perform a new search to get the fees
	      var _this = this;
	
	      setTimeout(function () {
	        ProctorStore.searchProctors(query, _this.applyVoucher, 0, true);
	      });
	    }
	  }, {
	    key: 'applyVoucher',
	    value: function applyVoucher(i, proctors) {
	      this.props.store.ScheduleStore.voucherCode = this.state.voucherCode || null;
	
	      var voucherCode = null;
	
	      if (proctors[0].fees.voucherApplied) {
	        voucherCode = this.state.voucherCode;
	      } else {
	        this.props.store.SessionStore.showDialog(this.props.translation.voucher_invalid_dialog);
	      }
	
	      this.props.scheduler.setState({
	        fees: proctors[0].fees,
	        voucherCode: voucherCode
	      });
	    }
	  }, {
	    key: 'removeVoucher',
	    value: function removeVoucher() {
	      var ProctorStore = this.props.store.ProctorStore;
	
	
	      var query = this.cleanQuery(ProctorStore.searchQuery);
	
	      // Perform a new search to remove the voucher
	      ProctorStore.searchProctors(query, this.applyVoucher, 0, true);
	    }
	  }, {
	    key: 'toggleVoucher',
	    value: function toggleVoucher() {
	      this.setState({
	        showVoucher: !this.state.showVoucher
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          fees = _props.fees,
	          translation = _props.translation;
	      var _props$store2 = this.props.store,
	          SessionStore = _props$store2.SessionStore,
	          PaymentStore = _props$store2.PaymentStore;
	
	
	      if (fees) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__title' },
	            translation.title
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'pricing' },
	            _react2.default.createElement(
	              'li',
	              { className: 'pricing__discount' },
	              _react2.default.createElement(
	                'span',
	                { className: 'pricing__item' },
	                translation.session
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'pricing__price' },
	                _currencyFormatter2.default.format(fees.preFundingRuleTotal, { code: fees.currencyCode }),
	                ' ',
	                fees.currencyCode
	              )
	            ),
	            PaymentStore.schedulingRuleInformation.map(function (rule) {
	              return _react2.default.createElement(
	                'li',
	                { className: 'pricing__discount' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pricing__item' },
	                  rule.name
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pricing__price' },
	                  _currencyFormatter2.default.format(rule.feeAmount, { code: fees.currencyCode }),
	                  ' ',
	                  fees.currencyCode
	                )
	              );
	            }),
	            fees.voucherSid && _react2.default.createElement(
	              'li',
	              { className: 'pricing__discount' },
	              _react2.default.createElement(
	                'span',
	                { className: 'pricing__item' },
	                translation.voucher
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'pricing__price' },
	                '-',
	                _currencyFormatter2.default.format(fees.voucherTotal, { code: fees.currencyCode }),
	                ' ',
	                fees.currencyCode
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'pricing__total' },
	              _react2.default.createElement(
	                'span',
	                { className: 'pricing__item' },
	                translation.total
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'pricing__price' },
	                _currencyFormatter2.default.format(fees.userTotal, { code: fees.currencyCode }),
	                ' ',
	                fees.currencyCode
	              )
	            )
	          ),
	          fees.voucherSid && fees.remainingVoucherTotal > 0 && _react2.default.createElement(
	            'p',
	            { className: 'note' },
	            translation.voucher_remaining,
	            ' ',
	            _currencyFormatter2.default.format(fees.remainingVoucherTotal, { code: fees.currencyCode }),
	            ' ',
	            fees.currencyCode
	          ),
	          !fees.voucherSid && !this.state.showVoucher && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn--link pricing-adjust',
	              onClick: this.toggleVoucher
	            },
	            translation.initiate_voucher
	          ),
	          !fees.voucherSid && this.state.showVoucher && _react2.default.createElement(
	            'form',
	            {
	              className: 'pricing-form form-inline ' + (SessionStore.backgroundLoadingCalls.length > 0 ? 'working' : ''),
	              onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this3.handleVoucher);
	              },
	              noValidate: true
	            },
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'meta', htmlFor: 'voucher-code' },
	                  translation.voucher_code
	                ),
	                _react2.default.createElement('input', {
	                  id: 'voucher-code',
	                  type: 'text',
	                  placeholder: translation.voucher_code,
	                  ref: function ref(input) {
	                    _this3.voucher_code = input;
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--outline',
	                type: 'submit'
	              },
	              translation.apply
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn--link', onClick: this.toggleVoucher },
	              'Cancel'
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Pricing;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Pricing')(Pricing);

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(395);
	var enumBugKeys = __webpack_require__(229);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 125 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var EventPluginRegistry = __webpack_require__(255);
	var EventPluginUtils = __webpack_require__(256);
	var ReactErrorUtils = __webpack_require__(260);
	
	var accumulateInto = __webpack_require__(563);
	var forEachAccumulated = __webpack_require__(564);
	var invariant = __webpack_require__(10);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(126);
	var EventPluginUtils = __webpack_require__(256);
	
	var accumulateInto = __webpack_require__(563);
	var forEachAccumulated = __webpack_require__(564);
	var warning = __webpack_require__(14);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(57);
	
	var getEventTarget = __webpack_require__(265);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 130 */
[1695, 170, 1190, 1218],
/* 131 */
77,
/* 132 */
78,
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(8);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 134 */
[1685, 61],
/* 135 */
[1695, 134, 1429, 1458],
/* 136 */
[1755, 635, 303],
/* 137 */
77,
/* 138 */
78,
/* 139 */
[1759, 135, 138],
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cross
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cell = (_temp = _class = function (_Component) {
	  _inherits(Cell, _Component);
	
	  function Cell() {
	    _classCallCheck(this, Cell);
	
	    return _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).apply(this, arguments));
	  }
	
	  _createClass(Cell, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Cell;
	}(_react.Component), _class.displayName = 'Cell', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES), _temp);
	exports.default = Cell;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _CartesianUtils = __webpack_require__(201);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * ComposedDataDecorator is a wrapper component that calculates expensive,
	 * reusable data like ticks of an axis, stores it in state on this component,
	 * and passes it in as props to the wrapped component.
	 */
	exports.default = function (_ref) {
	  var getComposedData = _ref.getComposedData,
	      ChildComponent = _ref.ChildComponent;
	  return function (WrappedComponent) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_Component) {
	      _inherits(ComposedDataDecorator, _Component);
	
	      function ComposedDataDecorator() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ComposedDataDecorator);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ComposedDataDecorator.__proto__ || Object.getPrototypeOf(ComposedDataDecorator)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.calculateExpensiveState({ props: _this.props }), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      // static WrappedComponent = WrappedComponent;
	
	      _createClass(ComposedDataDecorator, [{
	        key: 'calculateExpensiveState',
	
	
	        /**
	         * @param {Object} props The props object to operate on
	         * @return {Object} returnObj
	         *  returnObj {Array} axisTicks Used by renderCursor and anything
	         *          else that needs the ticks of the axisTicks
	         *  returObj {Array} allComposedData An array or arrays.
	         *          Each top-level element is the composedData {points, baseLine, layout}
	         *          for a given child(graphcalItem) of the overall Chart
	         */
	        value: function calculateExpensiveState(_ref3) {
	          var props = _ref3.props;
	          var children = props.children,
	              graphicalItems = props.graphicalItems,
	              xAxisMap = props.xAxisMap,
	              yAxisMap = props.yAxisMap,
	              stackGroups = props.stackGroups,
	              layout = props.layout,
	              offset = props.offset,
	              barSize = props.barSize,
	              barGap = props.barGap,
	              barCategoryGap = props.barCategoryGap,
	              globalMaxBarSize = props.maxBarSize;
	
	          // Some charts pre-filter their items into the graphicalItems prop,
	          // others filter it in render of the children
	
	          var items = graphicalItems || (0, _ReactUtils.findAllByType)(children, ChildComponent);
	
	          var sizeList = (0, _CartesianUtils.getBarSizeList)({ barSize: barSize, stackGroups: stackGroups });
	
	          var axisTicks = void 0;
	          var allComposedData = [];
	          items.forEach(function (item) {
	            var _item$props = item.props,
	                xAxisId = _item$props.xAxisId,
	                yAxisId = _item$props.yAxisId,
	                dataKey = _item$props.dataKey,
	                childMaxBarSize = _item$props.maxBarSize;
	
	            var xAxis = void 0,
	                yAxis = void 0,
	                xTicks = void 0,
	                yTicks = void 0,
	                barPosition = void 0,
	                stackedData = void 0,
	                bandSize = void 0;
	
	            if (xAxisMap || yAxisMap) {
	
	              xAxis = xAxisMap[xAxisId];
	              yAxis = yAxisMap[yAxisId];
	
	              xTicks = (0, _CartesianUtils.getTicksOfAxis)(xAxis);
	              yTicks = (0, _CartesianUtils.getTicksOfAxis)(yAxis);
	
	              // axisTicks is more global - only need to set once
	              axisTicks = axisTicks || (layout === 'horizontal' ? xTicks : yTicks);
	
	              var numericAxisId = layout === 'horizontal' ? yAxisId : xAxisId;
	              var cateAxisId = layout === 'horizontal' ? xAxisId : yAxisId;
	              var cateAxis = layout === 'horizontal' ? xAxis : yAxis;
	              var cateTicks = layout === 'horizontal' ? xTicks : yTicks;
	
	              stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _CartesianUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	
	              bandSize = (0, _DataUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	              var maxBarSize = (0, _isNil3.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	              barPosition = (0, _CartesianUtils.getBarPosition)({
	                barGap: barGap, barCategoryGap: barCategoryGap, bandSize: bandSize, sizeList: sizeList[cateAxisId], maxBarSize: maxBarSize
	              });
	            }
	
	            var composedData = getComposedData && getComposedData({ props: props,
	              xAxis: xAxis, yAxis: yAxis, xTicks: xTicks, yTicks: yTicks, dataKey: dataKey, item: item, bandSize: bandSize, barPosition: barPosition, offset: offset, stackedData: stackedData
	            }) || {};
	            allComposedData.push(composedData);
	          });
	
	          return { axisTicks: axisTicks, allComposedData: allComposedData };
	        }
	        /*
	        * Update the state of the composedData if anything relevant changed
	        */
	        /* eslint-disable no-unused-vars */
	
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          var graphicalItems = nextProps.graphicalItems,
	              children = nextProps.children,
	              chartX = nextProps.chartX,
	              chartY = nextProps.chartY,
	              activeTooltipIndex = nextProps.activeTooltipIndex,
	              activeLabel = nextProps.activeLabel,
	              activeCoordinate = nextProps.activeCoordinate,
	              activePayload = nextProps.activePayload,
	              isTooltipActive = nextProps.isTooltipActive,
	              restNextProps = _objectWithoutProperties(nextProps, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);
	
	          var _props = this.props,
	              graphicalItemsOld = _props.graphicalItems,
	              childrenOld = _props.children,
	              chartXOld = _props.chartX,
	              chartYOld = _props.chartY,
	              aTIOld = _props.activeTooltipIndex,
	              aLOld = _props.activeLabel,
	              aCOld = _props.activeCoordinate,
	              aPOld = _props.activePayload,
	              iTAOld = _props.isTooltipActive,
	              restOldProps = _objectWithoutProperties(_props, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);
	
	          /* eslint-enable no-unused-vars */
	
	
	          if (!(0, _PureRender.shallowEqual)(graphicalItems, graphicalItemsOld) || !(0, _PureRender.shallowEqual)(children, childrenOld) || !(0, _PureRender.shallowEqual)(restNextProps, restOldProps)) {
	            this.setState(this.calculateExpensiveState({ props: nextProps }));
	          }
	        }
	        /*
	         * Ignore the state generated by calculateExpensiveState when determining
	         * whether to update
	         */
	
	      }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(_ref4, nextState) {
	          var graphicalItems = _ref4.graphicalItems,
	              restProps = _objectWithoutProperties(_ref4, ['graphicalItems']);
	
	          // props.graphicalItems is sometimes generated every time -
	          // check that specially as object equality is likely to fail
	          var _props2 = this.props,
	              graphicalItemsOld = _props2.graphicalItems,
	              restPropsOld = _objectWithoutProperties(_props2, ['graphicalItems']);
	
	          return !(0, _PureRender.shallowEqual)(graphicalItems, graphicalItemsOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(nextState, this.state);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state));
	        }
	      }]);
	
	      return ComposedDataDecorator;
	    }(_react.Component), _class.displayName = 'ComposedDataDecorator(' + (0, _ReactUtils.getDisplayName)(WrappedComponent) + ')', _class.propTypes = _extends({}, WrappedComponent.propTypes, {
	      chartX: _propTypes2.default.number,
	      chartY: _propTypes2.default.number,
	      data: _propTypes2.default.array
	    }), _class.defaultProps = WrappedComponent.defaultProps, _temp2;
	  };
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ReactUtils = __webpack_require__(11);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return value + 'px';
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	
	  return formatStrs.join('');
	}
	
	var getStyleString = exports.getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return '' + result + camelToMiddleLine(s) + ':' + autoCompleteStyle(s, style[s]) + ';';
	  }, '');
	};
	
	var getStringSize = exports.getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return { width: 0, height: 0 };
	  }
	
	  var str = '' + text;
	  var styleString = getStyleString(style);
	  var cacheKey = str + '-' + styleString;
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    }
	
	    measurementSpan.setAttribute('style', getStyleString(_extends({}, SPAN_STYLE, style)));
	    measurementSpan.textContent = str;
	
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = { width: rect.width, height: rect.height };
	
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return { width: 0, height: 0 };
	  }
	};
	
	var getOffset = exports.getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = { top: 0, left: 0 };
	
	  // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	var calculateChartCoordinate = exports.calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};

/***/ },
/* 143 */
[1685, 55],
/* 144 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 145 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var BlackoutList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(BlackoutList, _React$Component);
	
	  function BlackoutList() {
	    _classCallCheck(this, BlackoutList);
	
	    return _possibleConstructorReturn(this, (BlackoutList.__proto__ || Object.getPrototypeOf(BlackoutList)).apply(this, arguments));
	  }
	
	  _createClass(BlackoutList, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          BlackoutStore = _props$store.BlackoutStore,
	          SessionStore = _props$store.SessionStore;
	      var blackoutDates = BlackoutStore.blackoutDates;
	      var userTimezone = SessionStore.userTimezone;
	
	
	      if (blackoutDates.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'note note--full' },
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.heading
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            blackoutDates.map(function (blackoutDate, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                (0, _moment2.default)(blackoutDate.startDate).tz(userTimezone).format('M/D/YYYY h:mma'),
	                '\u2013',
	                (0, _moment2.default)(blackoutDate.endDate).tz(userTimezone).format('M/D/YYYY h:mma')
	              );
	            })
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return BlackoutList;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('BlackoutList')(BlackoutList);

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dialog = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Dialog, _React$Component);
	
	  function Dialog() {
	    _classCallCheck(this, Dialog);
	
	    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this));
	
	    _this.confirmKey = _this.confirmKey.bind(_this);
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dialog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('keydown', this.confirmKey, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.confirmKey, false);
	    }
	  }, {
	    key: 'confirmKey',
	    value: function confirmKey(e) {
	      e.preventDefault();
	
	      if (e.keyCode && (e.keyCode === 13 || e.keyCode === 32)) {
	        this.closeDialog(e);
	      }
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dialog__content' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'dialog__msg', tabIndex: '0' },
	            SessionStore.dialogContent.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            SessionStore.dialogContent.body
	          ),
	          SessionStore.dialogContent.link_text && SessionStore.dialogContent.link_url && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: SessionStore.dialogContent.link_url,
	                target: '_blank'
	              },
	              SessionStore.dialogContent.link_text
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '#app', className: 'btn', onClick: function onClick(e) {
	                return _this2.closeDialog(e);
	              } },
	            SessionStore.dialogContent.button
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dialog;
	}(_react2.default.Component));
	
	exports.default = Dialog;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Loader, _React$Component);
	
	  function Loader() {
	    _classCallCheck(this, Loader);
	
	    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
	  }
	
	  _createClass(Loader, [{
	    key: 'render',
	    value: function render() {
	      var store = this.props.store;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'loader ' + store.SessionStore.loadingClass },
	        _react2.default.createElement(
	          'strong',
	          { className: 'loader__msg' },
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            store.SessionStore.loadingMessage
	          )
	        )
	      );
	    }
	  }]);
	
	  return Loader;
	}(_react2.default.Component));
	
	exports.default = Loader;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var Map = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Map, _React$Component);
	
	  function Map() {
	    _classCallCheck(this, Map);
	
	    return _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).apply(this, arguments));
	  }
	
	  _createClass(Map, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var hideMap = true;
	
	      if (this.props.locationSet) {
	        hideMap = false;
	      }
	
	      this.state = {
	        mapRendered: false,
	        hideMap: hideMap
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.store.LocationStore.locationSid) {
	        this.setState({
	          mapRendered: true
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (this.state.hideMap && !nextState.hideMap) {
	        return true;
	      }
	
	      if (this.state.mapRendered) {
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // If the update is due to a location being
	      // selected, stop what we’re doing
	      if (!this.state.hideMap && prevState.hideMap) {
	        return true;
	      }
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	      var google = window.google;
	      var map = void 0;
	      var _this = this;
	
	      function initMap() {
	        map = new google.maps.Map(document.getElementById('map'), {
	          center: _this.props.center,
	          zoom: _this.props.zoom,
	          streetViewControl: false,
	          mapTypeControl: false,
	          scrollwheel: false,
	          clickableIcons: false,
	          fullscreenControl: false
	        });
	
	        var name = null;
	        var address1 = null;
	        var address2 = null;
	        var city = null;
	        var region = null;
	        var country = null;
	        var postalCode = null;
	        var lat = null;
	        var lng = null;
	        var lastPosition = null;
	
	        // Custom marker
	        var pin = {
	          anchor: new google.maps.Point(10, 30),
	          path: 'm14.955742,10.044257q0,-2.051987 -1.451878,-3.503865t-3.503865,-1.451878t-3.503865,1.451878t-1.451878,3.503865t1.451878,3.503866t3.503865,1.451878t3.503865,-1.451878t1.451878,-3.503866zm4.955743,0q0,2.110063 -0.638826,3.465149l-7.046447,14.98338q-0.309734,0.638826 -0.919523,1.006635t-1.30669,0.367809t-1.30669,-0.367809t-0.900164,-1.006635l-7.065806,-14.98338q-0.638826,-1.355086 -0.638826,-3.465149q0,-4.103975 2.903756,-7.007731t7.007731,-2.903756t7.007731,2.903756t2.903756,7.007731z',
	          fillColor: '#9d80d8',
	          fillOpacity: 1,
	          strokeColor: '#7f59cc',
	          strokeWeight: 1,
	          scale: 1.25
	
	          // Create marker
	        };var marker = new google.maps.Marker({
	          map: map,
	          icon: pin,
	          draggable: true
	        });
	
	        // Create drag radius
	        var radius = new google.maps.Circle({
	          // strokeColor: '#ff0000',
	          strokeOpacity: 0,
	          // strokeWeight: 1,
	          clickable: false,
	          fillOpacity: 0,
	          map: map,
	          radius: 100
	        });
	
	        // If a center is provided, drop the marker and the radius
	        if (_this.props.dropPin) {
	          marker.setPosition(_this.props.center);
	          radius.setCenter(_this.props.center);
	        }
	
	        marker.addListener('dragend', function () {
	          var markerPosition = marker.getPosition();
	          lat = markerPosition.lat();
	          lng = markerPosition.lng();
	
	          _this.props.setLocation(name, address1, address2, city, region, country, postalCode, lat, lng, true);
	        });
	
	        // Limit marker drag to location bounds
	        marker.addListener('drag', function () {
	          var position = marker.getPosition();
	          var bounds = radius.getBounds();
	          if (bounds.contains(position)) {
	            lastPosition = position;
	          } else {
	            marker.setPosition(lastPosition);
	          }
	        });
	
	        // Places autocomplete
	        var input = document.querySelector('#map-search');
	
	        if (input) {
	          var options = {
	            types: [],
	            fields: ['address_components', 'name', 'geometry.location', 'place_id', 'formatted_address']
	          };
	
	          var autocomplete = new google.maps.places.Autocomplete(input, options);
	
	          // Bind the map’s bounds to the autocomplete object
	
	          autocomplete.bindTo('bounds', map);
	
	          input.addEventListener('keydown', function (e) {
	            if (e.keyCode === 13) {
	              e.preventDefault();
	            }
	          });
	
	          autocomplete.addListener('place_changed', function () {
	            marker.setVisible(false);
	            var place = autocomplete.getPlace();
	
	            // Reset address variables
	            name = null;
	            address1 = null;
	            address2 = null;
	            city = null;
	            region = null;
	            country = null;
	            postalCode = null;
	            lat = null;
	            lng = null;
	
	            if (!place.geometry) {
	              // The user entered the name of a place that wasn’t suggested
	              // and pressed the Enter key, or the request failed
	              // window.alert(`No details available for “${place.name}”`);
	              var suggestions = document.querySelector('.pac-container');
	
	              setTimeout(function () {
	                suggestions.style.display = 'block';
	              });
	
	              var dialogContent = translation.no_place;
	
	              _this.props.store.SessionStore.showDialog(dialogContent);
	
	              input.value = '';
	
	              return;
	            } else {
	              // Set the name
	              name = place.name;
	
	              // Loop through address components to get data
	              for (var i = 0; i < place.address_components.length; i++) {
	                // Address 1 number
	                if (place.address_components[i].types.indexOf('street_number') > -1) {
	                  address1 = place.address_components[i].short_name;
	                }
	
	                // Address 1 street
	                if (place.address_components[i].types.indexOf('route') > -1) {
	                  if (address1) {
	                    address1 += ' ' + place.address_components[i].short_name;
	                  } else {
	                    address1 = place.address_components[i].short_name;
	                  }
	                }
	
	                // Address 2
	                if (place.address_components[i].types.indexOf('subpremise') > -1) {
	                  address2 = place.address_components[i].short_name;
	                }
	
	                // City
	                if (place.address_components[i].types.indexOf('locality') > -1) {
	                  city = place.address_components[i].short_name;
	                } else if (place.address_components[i].types.indexOf('sublocality') > -1) {
	                  city = place.address_components[i].short_name;
	                }
	
	                // Region
	                if (place.address_components[i].types.indexOf('administrative_area_level_1') > -1) {
	                  region = place.address_components[i].short_name;
	                }
	
	                // Country
	                if (place.address_components[i].types.indexOf('country') > -1) {
	                  country = place.address_components[i].long_name;
	                }
	
	                // Postal code
	                if (place.address_components[i].types.indexOf('postal_code') > -1) {
	                  postalCode = place.address_components[i].short_name;
	                }
	              }
	
	              // Check if address components contained a city
	              // and alert the user if it didn’t
	              if (!city) {
	                input.value = '';
	                var _dialogContent = translation.city_required;
	                SessionStore.showDialog(_dialogContent);
	                return false;
	              }
	
	              // Check if address components contained a street address
	              // and parse the formatted address if it didn’t
	              if (!address1) {
	                var addr_arr = place.formatted_address.split(',');
	
	                if (addr_arr.length > 3) {
	                  address1 = addr_arr[0];
	
	                  if (addr_arr.length > 4) {
	                    address2 = addr_arr[1].replace(' ', '');
	                  }
	                }
	              }
	
	              // If we’re requiring a street address, make sure one
	              // has been found
	              if (_this.props.requireAddress && !address1) {
	                input.value = '';
	                var _dialogContent2 = translation.address_required;
	                SessionStore.showDialog(_dialogContent2);
	                return false;
	              }
	
	              lat = place.geometry.location.lat();
	              lng = place.geometry.location.lng();
	
	              _this.props.setLocation(name, address1, address2, city, region, country, postalCode, lat, lng);
	            }
	
	            // Move the map
	            map.setCenter(place.geometry.location);
	            map.setZoom(17);
	
	            _this.showMap();
	
	            // Set marker drag bounds
	            radius.setCenter(place.geometry.location);
	
	            // bounds = new google.maps.LatLngBounds();
	            // console.log(bounds);
	
	            // Drop a marker
	            marker.setPosition(place.geometry.location);
	            marker.setVisible(true);
	          });
	        }
	      }
	
	      // If it’s a new location, initialize the map
	      if (this.props.store.LocationStore.renderMap && !this.props.store.LocationStore.locationSid) {
	        initMap();
	      }
	
	      // If it’s an exisiting location, wait for data and then initialize the map
	      if (this.props.store.LocationStore.locationSid && this.props.store.LocationStore.locationData.name) {
	        this.setState({
	          mapRendered: true
	        });
	
	        if (!_this.state.mapRendered) {
	          initMap();
	        }
	      }
	    }
	  }, {
	    key: 'showMap',
	    value: function showMap() {
	      this.setState({
	        hideMap: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'map' },
	        _react2.default.createElement(
	          'div',
	          { className: 'map__search' },
	          _react2.default.createElement(
	            'label',
	            { className: 'meta', htmlFor: 'map-search' },
	            translation.location.label
	          ),
	          !this.props.locationSid && !this.props.default && _react2.default.createElement('input', {
	            type: 'text',
	            id: 'map-search',
	            placeholder: translation.location.helper,
	            required: true,
	            'aria-required': 'true'
	          }),
	          this.props.default && _react2.default.createElement('input', {
	            type: 'text',
	            id: 'map-search',
	            placeholder: translation.location.helper,
	            defaultValue: this.props.default,
	            required: true,
	            'aria-required': 'true'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'location__map-wrap' },
	          _react2.default.createElement('div', { id: 'map', className: 'location__map' }),
	          this.state.hideMap && _react2.default.createElement(
	            'div',
	            { className: 'location__map-overlay' },
	            _react2.default.createElement(
	              'div',
	              { className: 'copy' },
	              _react2.default.createElement(
	                'span',
	                { className: 'yes-results' },
	                translation.helper.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.helper.body
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Map;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Map')(Map);

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _FrameHeadshot = __webpack_require__(878);
	
	var _FrameHeadshot2 = _interopRequireDefault(_FrameHeadshot);
	
	var _FrameID = __webpack_require__(879);
	
	var _FrameID2 = _interopRequireDefault(_FrameID);
	
	var _helpers = __webpack_require__(5);
	
	var _compressorjs = __webpack_require__(960);
	
	var _compressorjs2 = _interopRequireDefault(_compressorjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	//Helpers
	
	
	var Webcam = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Webcam, _React$Component);
	
	  function Webcam() {
	    _classCallCheck(this, Webcam);
	
	    var _this2 = _possibleConstructorReturn(this, (Webcam.__proto__ || Object.getPrototypeOf(Webcam)).call(this));
	
	    _this2.capturePhoto = _this2.capturePhoto.bind(_this2);
	    _this2.retakePhoto = _this2.retakePhoto.bind(_this2);
	    _this2.savePhoto = _this2.savePhoto.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Webcam, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        captured: false,
	        track: null,
	        showFrame: false,
	        recordFinished: false
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initWebcam();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.killWebcam();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var webcam = this.props.webcam;
	
	      // Change webcam
	
	      if (webcam !== prevProps.webcam) {
	        this.initWebcam();
	      }
	    }
	  }, {
	    key: 'killWebcam',
	    value: function killWebcam() {
	      // Kill the camera stream on unmount
	      if (this.stream && this.stream.getTracks) {
	        this.stream.getTracks().forEach(function (track) {
	          track.stop();
	        });
	      }
	    }
	  }, {
	    key: 'initWebcam',
	    value: function initWebcam() {
	      var _this = this;
	      var _props = this.props,
	          allowCapture = _props.allowCapture,
	          disableFullScreen = _props.disableFullScreen,
	          webcam = _props.webcam;
	
	
	      this.killWebcam();
	
	      var constraints = {
	        audio: false,
	        video: {
	          facingMode: this.props.camera
	        }
	      };
	
	      if (webcam) {
	        constraints.video.deviceId = webcam;
	      }
	
	      if (!disableFullScreen) {
	        constraints.width = window.innerWidth;
	        constraints.height = window.innerHeight;
	      }
	
	      navigator.mediaDevices.getUserMedia(constraints).then(function (media) {
	        _this.stream = media;
	
	        // Stream the media to the video element
	        var videoEl = document.querySelector('.webcam__stream');
	        videoEl.srcObject = media;
	        videoEl.onloadedmetadata = function (e) {
	          videoEl.play();
	
	          // Show the frame
	          _this.setState({
	            showFrame: true
	          });
	        };
	
	        // Get blank canvas dataUrl
	        if (allowCapture) {
	          var canvas = document.querySelector('.webcam__canvas');
	
	          _this.setState({
	            blankCanvas: canvas.toDataURL('image/jpg')
	          });
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'capturePhoto',
	    value: function capturePhoto() {
	      var _this = this;
	
	      // Flash
	      var webcam = document.querySelector('.webcam');
	      webcam.className += ' webcam--flash';
	
	      // Draw captured image to a canvas
	      var canvas = document.querySelector('.webcam__canvas');
	      var ctx = canvas.getContext('2d');
	      this.stream = document.querySelector('.webcam__stream');
	      ctx.drawImage(this.stream, 0, 0, canvas.width, canvas.height);
	
	      // Mark the photo as captured
	      _this.setState({
	        captured: true
	      });
	
	      // Remove the flash
	      setTimeout(function () {
	        webcam.className = webcam.className.replace('webcam--flash', '');
	      }, 100);
	
	      // These two processes slow down rendering so they’re on a 200ms delay
	      // so that the flash works correctly
	      // setTimeout(function(){
	
	      // Convert the photo to an image
	      var photo = new Image();
	      photo.src = canvas.toDataURL('image/jpg');
	
	      // Convert image base64 to file for compression
	      var photoFile = (0, _helpers.dataURLtoFile)(canvas.toDataURL('image/jpg', 'student_ID_verification'));
	      // New copy of photo to compress
	      var compressedPhoto = new Image();
	
	      // Compress Image for faster uploading
	      new _compressorjs2.default(photoFile, {
	        quality: 0.6,
	        maxWidth: 246,
	        maxHeight: 328,
	        // What type to convert file to
	        convertTypes: 'image/jpeg',
	        // Byte threshold to convert to jpeg (5kb)
	        convertSize: 5000,
	
	        success: function success(result) {
	          var blob = result;
	          var reader = new FileReader();
	
	          reader.readAsDataURL(blob);
	          reader.onloadend = function () {
	            var base64String = reader.result;
	
	            compressedPhoto.src = base64String;
	          };
	        }
	      });
	
	      var existingPreview = document.querySelector('.webcam__preview');
	
	      if (existingPreview) {
	        existingPreview.remove();
	      }
	
	      var preview = document.createElement('div');
	      preview.className = 'webcam__preview';
	      preview.style.cssText = 'background-image: url(' + photo.src + ')';
	
	      webcam.append(preview);
	
	      if (photo.src !== _this.state.blankCanvas) {
	        _this.props.parent.setState(_defineProperty({}, _this.props.name, compressedPhoto));
	
	        // Stop getting the user’s media
	        if (_this.stream.srcObject) {
	          var tracks = _this.stream.srcObject.getTracks();
	
	          tracks.forEach(function (track) {
	            track.stop();
	          });
	        }
	      } else {
	        _this.setState({
	          captured: false
	        });
	      }
	      // }, 500);
	    }
	  }, {
	    key: 'retakePhoto',
	    value: function retakePhoto() {
	      var canvas = document.querySelector('.webcam__canvas');
	      var ctx = canvas.getContext('2d');
	      ctx.clearRect(0, 0, canvas.width, canvas.height);
	
	      var preview = document.querySelector('.webcam__preview');
	      preview.style.cssText = '';
	
	      this.setState({
	        captured: false,
	        showFrame: false
	      });
	
	      this.initWebcam();
	    }
	  }, {
	    key: 'savePhoto',
	    value: function savePhoto() {
	      this.props.callback();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          allowCapture = _props2.allowCapture,
	          allowRecord = _props2.allowRecord,
	          onCapture = _props2.onCapture,
	          onAccept = _props2.onAccept,
	          callback = _props2.callback,
	          complete = _props2.complete,
	          completeText = _props2.completeText,
	          hideTools = _props2.hideTools,
	          name = _props2.name,
	          recordStart = _props2.recordStart,
	          recordStop = _props2.recordStop,
	          verifying = _props2.verifying,
	          translation = _props2.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.caption && !complete && _react2.default.createElement(
	          'strong',
	          { className: 'webcam__caption' },
	          this.props.caption
	        ),
	        _react2.default.createElement(
	          'figure',
	          { className: 'webcam webcam--' + this.props.camera },
	          _react2.default.createElement('video', { className: 'webcam__stream' }),
	          allowCapture && _react2.default.createElement('canvas', {
	            className: 'webcam__canvas',
	            width: this.stream && this.stream.getVideoTracks ? this.stream.getVideoTracks()[0].getSettings().width : window.innerWidth,
	            height: this.stream && this.stream.getVideoTracks ? this.stream.getVideoTracks()[0].getSettings().height : window.innerHeight
	          }),
	          this.props.type === 'portrait' && this.state.showFrame && _react2.default.createElement(_FrameHeadshot2.default, null),
	          this.props.type === 'landscape' && this.state.showFrame && _react2.default.createElement(_FrameID2.default, null),
	          !hideTools && !this.state.recordFinished && _react2.default.createElement(
	            'div',
	            { className: 'webcam__tools' },
	            allowCapture && !this.state.captured && _react2.default.createElement(
	              'div',
	              { className: 'webcam__capture--captured' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick() {
	                    if (onCapture) {
	                      onCapture(name);
	                    }
	                    _this3.capturePhoto();
	                  }
	                },
	                translation.take_photo
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'webcam__capture--captured' },
	              allowCapture && this.state.captured && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn webcam__confirm',
	                  onClick: this.retakePhoto
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.retake
	                )
	              ),
	              allowCapture && this.state.captured && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn webcam__confirm',
	                  onClick: function onClick() {
	                    if (onAccept) {
	                      onAccept(name);
	                    }
	                    _this3.savePhoto();
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.confirm
	                )
	              )
	            ),
	            allowRecord && !this.state.captured && _react2.default.createElement(
	              'div',
	              { className: 'webcam__capture--captured' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick() {
	                    if (recordStart) {
	                      recordStart();
	                    }
	                    _this3.setState({ captured: true });
	                  }
	                },
	                translation.start_recording
	              )
	            ),
	            allowRecord && this.state.captured && _react2.default.createElement(
	              'div',
	              { className: 'webcam__capture--captured' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick() {
	                    if (recordStop) {
	                      recordStop();
	                    }
	                    _this3.setState({ recordFinished: true });
	                    if (callback) {
	                      callback();
	                    }
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.stop_scan
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.finish_recording
	                )
	              )
	            )
	          ),
	          verifying && _react2.default.createElement(
	            'div',
	            { className: 'webcam__complete' },
	            _react2.default.createElement(
	              'div',
	              { className: 'webcam__complete-msg' },
	              complete && _react2.default.createElement(
	                'span',
	                { className: 'tally__status tally__status--alt completed' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  'Complete'
	                )
	              ),
	              completeText
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Webcam;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Webcam')(Webcam);

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// Helpers
	
	
	// Components
	
	
	var obx = (0, _mobx.observable)({
	  proctorSid: null,
	  proctor: [],
	  proctorLocationSid: null,
	  // Get proctor data
	  getProctor: (0, _mobx.action)(function (sid, component, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'GetProctorData');
	    obx.proctorSid = null;
	    obx.proctor = [];
	
	    _config.api.get('/proctors/' + sid).then(function (response) {
	      obx.proctor = response.data;
	      obx.proctorSid = response.data.sid;
	
	      if (component) {
	        component.setState({
	          accountData: response.data
	        });
	      }
	
	      if (callback) {
	        callback(response.data);
	      }
	
	      _SessionStore2.default.finishLoading('GetProctorData');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  proctorGroups: [],
	  // Get proctor groups
	  getProctorGroups: (0, _mobx.action)(function (component, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'GetProctorGroups');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/proctorGroup').then(function (response) {
	      obx.proctorGroups = response.data.results;
	      _SessionStore2.default.finishLoading('GetProctorGroups');
	
	      if (component) {
	        component.setState({
	          groups: response.data.results
	        });
	      }
	
	      if (response.data.results.length === 0 && callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get session proctor groups
	  getSessionProctorGroups: (0, _mobx.action)(function (examSid, sessionSid, component, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'GetProctorGroups');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/proctorGroups').then(function (response) {
	      obx.proctorGroups = response.data.results;
	
	      if (component) {
	        component.setState({
	          groups: response.data.results
	        });
	      }
	
	      if (callback) {
	        callback(response.data.results);
	      }
	
	      _SessionStore2.default.finishLoading('GetProctorGroups');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get all proctor categories
	  proctorTypeCategories: [],
	  getProctorTypes: (0, _mobx.action)(function (component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetProctorTypes');
	
	    _config.api.get('/proctors/categories?selfSelection=all').then(function (response) {
	      // Store an array of category sids
	      response.data.results.forEach(function (group) {
	        group.subCategories.forEach(function (category) {
	          obx.proctorCategories.push(category.sid);
	          return true;
	        });
	
	        return true;
	      });
	
	      // Also store an array of objects with sid and title
	      response.data.results.forEach(function (group) {
	        group.subCategories.forEach(function (category) {
	          var catObj = {
	            sid: category.sid,
	            title: category.title
	          };
	
	          obx.proctorTypeCategories.push(catObj);
	
	          return true;
	        });
	
	        return true;
	      });
	
	      _SessionStore2.default.finishLoading('GetProctorTypes');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get proctor group categories
	  proctorCategories: [],
	  getProctorGroupCategories: (0, _mobx.action)(function (examSid, sessionSid, groupSid, callback, component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetProctorGroupCategories');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/proctorGroups').then(function (response) {
	      response.data.results.forEach(function (group) {
	        if (group.sid === groupSid) {
	          obx.proctorCategories = group.proctorTypes;
	          return true;
	        }
	      });
	
	      _SessionStore2.default.finishLoading('GetProctorGroupCategories');
	
	      if (callback) {
	        callback(component);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	
	    // api.get(`/installs/${SessionStore.userData.installSid}/proctorGroup/${groupSid}`)
	    //   .then(response => {
	    //     obx.proctorCategories = response.data.proctorTypes;
	    //     SessionStore.finishLoading('GetProctorGroupCategories');
	    //
	    //     if(callback) {
	    //       callback(component);
	    //     }
	    //   })
	    //   .catch(error => {
	    //     SessionStore.throwError(error);
	    //   });
	  }),
	  // Update proctor groups
	  updateProctorGroups: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateProctorGroups');
	
	    // Remove unnecessary data
	    data.forEach(function (group) {
	      if (group) {
	        delete group.createdDate;
	        delete group.editDate;
	        delete group.sortOrder;
	
	        // These properties are used in the UI state
	        // and are not allowed by the API
	        delete group.locations;
	        delete group.gotLocations;
	        delete group.proctorLocations;
	        delete group.proctorLocationDetails;
	      }
	    });
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/proctorGroup', data).then(function (response) {
	      obx.proctorGroups = response.data.results;
	      _SessionStore2.default.finishLoading('UpdateProctorGroups');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  selfManagedAccounts: [],
	  // Get all self-managed accounts
	  listSelfManagedAccount: (0, _mobx.action)(function listSelfManagedAccount() {
	    _SessionStore2.default.startLoading('Loading…', 'ListSelfManagedAccount');
	
	    obx.proctorSid = null;
	
	    // Take deploymentOwnerSid from userData
	    var deploymentOwnerSid = _SessionStore2.default.userData.deploymentSid;
	
	    _config.api.get('/proctorAccounts/' + deploymentOwnerSid).then(function (response) {
	      obx.selfManagedAccounts = response.data.results;
	      _SessionStore2.default.finishLoading('ListSelfManagedAccount');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Add self-managed account
	  addSelfManagedAccount: (0, _mobx.action)(function addSelfManagedAccount(data, callback, component) {
	    _SessionStore2.default.startLoading('Loading…', 'AddSelfManagedAccounts');
	
	    data.deploymentOwnerSid = _SessionStore2.default.userData.deploymentSid;
	    data.type = 'individual-proctor';
	
	    // Delete phone because we don't have delete field in api
	    if (data.phone) {
	      delete data.phone;
	    }
	
	    _config.api.post('/proctors', data).then(function (response) {
	      obx.proctor = response.data;
	      obx.proctorSid = response.data.sid;
	      obx.proctor.proctorTypes = [];
	
	      if (component) {
	        component.setState({
	          accountData: obx.proctor,
	          mode: 'edit'
	        });
	      }
	
	      setTimeout(function () {
	        _SessionStore2.default.finishLoading('AddSelfManagedAccounts');
	        callback();
	      });
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update self-managed account
	  updateSelfManagedAccount: (0, _mobx.action)(function updateSelfManagedAccount(proctorSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateSelfManagedAccounts');
	
	    delete data.sid;
	    delete data.createdDate;
	    delete data.editDate;
	    delete data.verificationDate;
	    delete data.verifiedBy;
	    delete data.deploymentOwnerSid;
	    delete data.authentication;
	    delete data.type;
	    delete data.active;
	    delete data.metadata;
	    delete data.timeZoneSid;
	
	    if (!data.accountName) {
	      data.accountName = '';
	    }
	
	    _config.api.put('/proctors/' + proctorSid, data).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateSelfManagedAccounts');
	      callback();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Search proctors
	  proctors: [],
	  proctorsTotal: 0,
	  searchQuery: null,
	  proctorsNext: null,
	  resetProctors: (0, _mobx.action)(function () {
	    obx.proctors = [];
	    obx.searchQuery = null;
	  }),
	  searchProctors: (0, _mobx.action)(function (query, callback, i, backgroundLoad, appendResult) {
	    var noUpdate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	    if (!backgroundLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'SearchProctors');
	    } else {
	      _SessionStore2.default.startBackgroundLoading('SearchProctors');
	    }
	
	    if (!appendResult && !noUpdate) {
	      obx.resetProctors();
	    }
	
	    var currencyCode = null;
	
	    if (_SessionStore2.default.profile && _SessionStore2.default.profile.currencyCode) {
	      currencyCode = _SessionStore2.default.profile.currencyCode;
	    } else {
	      currencyCode = 'USD';
	    }
	
	    if (typeof query === 'undefined' || !query) {
	      query = '?currencyCode=' + currencyCode;
	    } else if (query.indexOf('currencyCode') < 0) {
	      query += '&currencyCode=' + currencyCode;
	    }
	
	    // clean up the empty query params
	    query = (0, _helpers.removeEmptyQueryParams)(query);
	
	    if (!noUpdate) {
	      obx.searchQuery = query;
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/proctors/search' + query).then(function (response) {
	      if (callback) {
	        callback(i, response.data.results);
	      }
	
	      if (!noUpdate) {
	        if (appendResult) {
	          Array.prototype.push.apply(obx.proctors, response.data.results);
	        } else {
	          obx.proctors = response.data.results;
	        }
	      }
	
	      if (!backgroundLoad) {
	        _SessionStore2.default.finishLoading('SearchProctors');
	      } else {
	        _SessionStore2.default.finishBackgroundLoading('SearchProctors');
	      }
	
	      if (!noUpdate) {
	        if (response.data.next) {
	          // API returns a url with a different domain for the next link
	          // so create an anchor element and set its href to the next link
	          // and then grab the pathname and query from that
	          var nextUrl = (0, _helpers.getPath)(response.data.next);
	          nextUrl = nextUrl.replace('/v1', '').replace('&appointmentDate=null', '');
	          obx.proctorsNext = nextUrl;
	        } else {
	          obx.proctorsNext = null;
	        }
	        obx.proctorsTotal = response.data.total;
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  // Get proctor group location details
	  getLocationDetails: (0, _mobx.action)(function (locationSids, i, component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetLocationDetails');
	
	    // Make an API call for each locationSid
	
	    var _loop = function _loop(j) {
	      var query = '?proctorLocationSids=' + locationSids[j];
	
	      _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/proctors/search' + query).then(function (response) {
	        obx.proctorLocation = response.data.results[0];
	
	        if (i || i === 0) {
	          var groups = [].concat(_toConsumableArray(component.state.groups));
	
	          if (groups) {
	            if (!groups[i].proctorLocationDetails) {
	              groups[i].proctorLocationDetails = {};
	            }
	
	            groups[i].proctorLocationDetails[locationSids[j]] = response.data.results[0];
	
	            component.setState({
	              groups: groups
	            });
	          }
	        }
	
	        _SessionStore2.default.finishLoading('GetLocationDetails');
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    };
	
	    for (var j = 0; j < locationSids.length; j++) {
	      _loop(j);
	    }
	  }),
	  // Request approval
	  requestApproval: (0, _mobx.action)(function (data, isAdmin, forStudent) {
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/approvals', data).then(function (response) {
	      if (isAdmin) {
	        var _data = {
	          reviewedByUserSid: _SessionStore2.default.profile.sid,
	          status: 'allow',
	          applyTo: 'install'
	        };
	
	        if (forStudent) {
	          _data.applyTo = 'student';
	        }
	
	        obx.updatePendingApprovals(response.data.sid, _data);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Administrator create approval
	  createApproval: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateApproval');
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/approve', data).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateApproval');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Proctor approvals
	  pendingApprovals: [],
	  getPendingApprovals: (0, _mobx.action)(function (query) {
	    _SessionStore2.default.startLoading('Loading…', 'GetPendingApprovals');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/approvals' + query).then(function (response) {
	      obx.pendingApprovals = response.data.results;
	      _SessionStore2.default.finishLoading('GetPendingApprovals');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get single proctor’s approval history
	  getSingleApproval: (0, _mobx.action)(function (component, proctorSid) {
	    _SessionStore2.default.startBackgroundLoading('getSingleApproval');
	
	    var query = '?sortOrder=DESC&proctorSid=' + proctorSid + '&status=allow&status=deny';
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/approvals' + query).then(function (response) {
	      if (component) {
	        component.setState({
	          approvals: response.data.results
	        });
	      }
	
	      _SessionStore2.default.finishBackgroundLoading('getSingleApproval');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Approve or deny
	  updatePendingApprovals: (0, _mobx.action)(function (approvalSid, data, callback, showLoader) {
	    if (showLoader) {
	      _SessionStore2.default.startLoading('Loading…', 'updatePendingApprovals');
	    }
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/approvals/' + approvalSid, data).then(function (response) {
	      // obx.pendingApprovals = response.data.results;
	
	      if (showLoader) {
	        _SessionStore2.default.finishLoading('updatePendingApprovals');
	      }
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete approval
	  deleteProctorApproval: (0, _mobx.action)(function (approvalSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteProctorApproval');
	
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/approvals/' + approvalSid).then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteProctorApproval');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get course data for approval
	  approvalCourseData: {},
	  getApprovalCourseData: (0, _mobx.action)(function (approvalSid, courseSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetApprovalCourseData');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + courseSid).then(function (response) {
	      obx.approvalCourseData[approvalSid] = response.data;
	      _SessionStore2.default.finishLoading('GetApprovalCourseData');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  /**
	  * provisionOnlineSession
	  * @param {object} data
	  * @param {function} callback
	  */
	  provisionOnlineSession: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('provisionOnlineSession');
	
	    var examSid = data.examSid,
	        installSid = data.installSid,
	        sessionSid = data.sessionSid;
	
	
	    _config.api.patch('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/provisionExam').then(function (response) {
	      if (callback) {
	        callback(response.data.interoadsProvisionedExamUrl);
	      }
	
	      _SessionStore2.default.finishLoading('provisionOnlineSession');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	exports.default = obx;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  settings: {},
	  defaultCurrencyCode: undefined,
	  getInstituteSettings: (0, _mobx.action)(function (component) {
	    _SessionStore2.default.startLoading('Loading…', 'InstitutionSettings');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/settings').then(function (response) {
	      obx.settings = response.data;
	
	      // API returns empty hide permitted items array as [""] for some reason
	      // so loop through array and remove any empty strings
	      obx.settings.hidePermittedItemFields.forEach(function (field, i) {
	        if (!field) {
	          obx.settings.hidePermittedItemFields.splice(i, 1);
	        }
	      });
	
	      if (component) {
	        component.setState({
	          settings: obx.settings
	        });
	      }
	
	      _SessionStore2.default.finishLoading('InstitutionSettings');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  putInstituteSettings: (0, _mobx.action)(function (data, component, func) {
	    _SessionStore2.default.startLoading('Loading…', 'PutInstitutionSettings');
	
	    if (data.hidePermittedItemFields[0] === '') {
	      data.hidePermittedItemFields = [];
	    }
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/settings', data).then(function (response) {
	      obx.settings = response.data;
	      component.setState({
	        settings: obx.settings
	      });
	      _SessionStore2.default.finishLoading('PutInstitutionSettings');
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  userSettings: {},
	  // Get user settings
	  getUserSettings: (0, _mobx.action)(function (component) {
	    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	    _SessionStore2.default.startLoading('Loading…', 'GetUserSettings');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + _SessionStore2.default.userData.userSid + '/profile').then(function (response) {
	      _SessionStore2.default.finishLoading('GetUserSettings');
	      obx.userSettings = response.data;
	
	      var ie = false;
	
	      if (document.querySelector('html').className.indexOf('ie-true') > -1) {
	        ie = true;
	      }
	
	      // wrapping in a try/catch to avoid any potential issues getting the browser timezone...
	      try {
	        if (mode === "enroll") {
	          var browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	          var match = _SessionStore2.default.timezoneList.find(function (tz) {
	            return tz.name === browserTimezone;
	          });
	          if (match) {
	            response.data.timeZoneSid = match.sid;
	          }
	        }
	      } catch (e) {
	        // NO-OP, this is for safety...
	      }
	
	      if (component && !ie) {
	        component.setState({
	          homePhone: response.data.homePhone,
	          mobilePhone: response.data.mobilePhone,
	          currencyCode: response.data.currencyCode,
	          timeZoneSid: response.data.timeZoneSid
	        });
	      } else if (component && ie) {
	        component.setState({
	          homePhone: response.data.homePhone,
	          mobilePhone: response.data.mobilePhone
	        });
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  // Update user settings data
	  updateUserData: (0, _mobx.action)(function (data) {
	    var newData = null;
	
	    for (var key in data) {
	      if (key) {
	        newData = data[key];
	        obx.userSettings[key] = newData;
	      }
	    }
	  }),
	  // Update user settings API call
	  updateUserSettings: (0, _mobx.action)(function (func, dialogMsg, isEnrolling) {
	    if (isEnrolling) {
	      _SessionStore2.default.startBackgroundLoading('UpdateUserSettings');
	    } else {
	      _SessionStore2.default.startLoading('Loading…', 'UpdateUserSettings');
	    }
	
	    // Remove unnecessary data
	    Object.keys(obx.userSettings).map(function (key) {
	      if (key !== 'mobilePhone' && key !== 'homePhone' && key !== 'latitude' && key !== 'longitude' && key !== 'maxTravelDistance' && key !== 'maxTravelDistanceUnits' && key !== 'currencyCode' && key !== 'timeZoneSid' && key !== 'address' && key !== 'preferredEmail') {
	        delete obx.userSettings[key];
	      }
	
	      return true;
	    });
	
	    if (!obx.userSettings.latitude && _SessionStore2.default.userData.role.toLowerCase() === 'learner') {
	      _SessionStore2.default.finishLoading();
	      _SessionStore2.default.showDialog(dialogMsg);
	      return false;
	    }
	
	    if (!obx.userSettings.preferredEmail) {
	      obx.userSettings.preferredEmail = _SessionStore2.default.profile.email;
	    }
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + _SessionStore2.default.userData.userSid + '/profile', obx.userSettings).then(function (response) {
	      _SessionStore2.default.profile = response.data;
	      _SessionStore2.default.getUserTimezone();
	
	      setTimeout(function () {
	        if (isEnrolling) {
	          _SessionStore2.default.finishBackgroundLoading('UpdateUserSettings');
	        } else {
	          _SessionStore2.default.finishLoading('UpdateUserSettings');
	        }
	
	        func();
	      });
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get installation integrations
	  integrations: [],
	  getIntegrations: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'GetIntegrations');
	
	    obx.integrations = [];
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/integrations').then(function (response) {
	      obx.integrations = response.data.results;
	
	      if (callback) {
	        callback(response);
	      }
	
	      _SessionStore2.default.finishLoading('GetIntegrations');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get single installation integration
	  integration: {},
	  getIntegration: (0, _mobx.action)(function (integrationSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'GetIntegration');
	
	    obx.integration = {};
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/integrations/' + integrationSid).then(function (response) {
	      obx.integration = response.data;
	
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('GetIntegration');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update integration data
	  updateIntegrationData: (0, _mobx.action)(function (data) {
	    var newData = null;
	
	    for (var key in data) {
	      if (key) {
	        newData = data[key];
	        obx.integration[key] = newData;
	      }
	    }
	  }),
	  // Update integration
	  updateIntegration: (0, _mobx.action)(function (integrationSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateIntegration');
	
	    var data = obx.integration;
	
	    if (data && data.systemName.toLowerCase() === 'desire2learn') {
	      data.oAuthPostAuthRedirectUri = window.location.href + '&saved=true';
	    }
	
	    delete data.accessKey;
	    delete data.apiUserExternalIdAttribute;
	    delete data.apiUserLmsIdAttribute;
	    delete data.apiUserSisIdAttribute;
	    delete data.applicationInstallSid;
	    delete data.createdDate;
	    delete data.enabled;
	    delete data.failedAuthRedirect;
	    delete data.lastModifiedDate;
	    delete data.ltiCourseApiIdAttribute;
	    delete data.ltiUserExternalIdAttribute;
	    delete data.ltiUserLmsIdAttribute;
	    delete data.ltiUserSisIdAttribute;
	    delete data.name;
	    delete data.primaryAccountApiAttribute;
	    delete data.primaryAccountLtiAttribute;
	    delete data.secret;
	    delete data.sid;
	    delete data.successfulAuthRedirect;
	    delete data.syncEnrollmentsCaseSensitivity;
	    delete data.syncEnrollmentsIdentifier;
	    delete data.systemModstamp;
	    delete data.systemName;
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/integrations/' + integrationSid, data).then(function (response) {
	      obx.integration = response.data;
	
	      _SessionStore2.default.finishLoading('UpdateIntegration');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get custom lti roles
	  customRoles: [],
	  getCustomRoles: (0, _mobx.action)(function (integrationSid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetCustomRoles');
	
	    obx.customRoles = [];
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/integrations/' + integrationSid + '/roles').then(function (response) {
	      obx.customRoles = response.data.results;
	
	      component.setState({
	        roles: response.data.results
	      });
	
	      _SessionStore2.default.finishLoading('GetCustomRoles');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  updateCustomRoles: (0, _mobx.action)(function (integrationSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateCustomRoles');
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/integrations/' + integrationSid + '/roles', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('UpdateCustomRoles');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update password
	  updatePassword: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdatePassword');
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + _SessionStore2.default.userData.userSid + '/password', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('UpdatePassword');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(910);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(909);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 155 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 156 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(939)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(391)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(964), __webpack_require__(965), __webpack_require__(967), __webpack_require__(966), __webpack_require__(404), __webpack_require__(969), __webpack_require__(403)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    var d = domain(),
	        i = d.length - 1,
	        n = count == null ? 10 : count,
	        start = d[0],
	        stop = d[i],
	        step = d3Array.tickStep(start, stop, n);
	
	    if (step) {
	      step = d3Array.tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	      d[0] = Math.floor(start / step) * step;
	      d[i] = Math.ceil(stop / step) * step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var Base64 = __webpack_require__(703);
	
	// See http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
	function btoa(s) {
	  return Base64.btoa(unescape(encodeURIComponent(s)));
	}
	
	function base64URLEncode(s) {
	  return btoa(s)
	  .replace(/=/g, '')
	  .replace(/\+/g, '-')
	  .replace(/\//g, '_');
	}
	
	function clone(obj) {
	  return JSON.parse(JSON.stringify(obj));
	}
	
	function modifications(oldObj, newObj) {
	  var mods = {};
	  if (!oldObj || !newObj) { return {}; }
	  for (var prop in oldObj) {
	    if (oldObj.hasOwnProperty(prop)) {
	      if (newObj[prop] !== oldObj[prop]) {
	        mods[prop] = {previous: oldObj[prop], current: newObj[prop]};
	      }
	    }
	  }
	  
	  return mods;
	}
	
	module.exports = {
	  btoa: btoa,
	  base64URLEncode: base64URLEncode,
	  clone: clone,
	  modifications: modifications
	};


/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.matches_entirely = matches_entirely;
	// Checks whether the entire input sequence can be matched
	// against the regular expression.
	function matches_entirely() {
		var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var regular_expression = arguments[1];
	
		if (typeof regular_expression === 'string') {
			regular_expression = '^(?:' + regular_expression + ')$';
		}
	
		var matched_groups = text.match(regular_expression);
		return matched_groups !== null && matched_groups[0].length === text.length;
	}
	//# sourceMappingURL=common.js.map

/***/ },
/* 163 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var EventPluginRegistry = __webpack_require__(255);
	var ReactEventEmitterMixin = __webpack_require__(1100);
	var ViewportMetrics = __webpack_require__(562);
	
	var getVendorPrefixedEventName = __webpack_require__(1132);
	var isEventSupported = __webpack_require__(267);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(129);
	var ViewportMetrics = __webpack_require__(562);
	
	var getEventModifierState = __webpack_require__(264);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(10);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	var DOMNamespaces = __webpack_require__(254);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(262);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 169 */
[1678, 1204, 1205, 1206, 1207, 1208],
/* 170 */
[1685, 58],
/* 171 */
[1689, 278],
/* 172 */
[1717, 1201],
/* 173 */
[1742, 115],
/* 174 */
[1749, 176],
/* 175 */
[1755, 590, 279],
/* 176 */
[1759, 130, 132],
/* 177 */
[1761, 1157, 1171, 175],
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropdownContent = exports.DropdownTrigger = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dropdownTrigger = __webpack_require__(1269);
	
	var _dropdownTrigger2 = _interopRequireDefault(_dropdownTrigger);
	
	var _dropdownContent = __webpack_require__(1268);
	
	var _dropdownContent2 = _interopRequireDefault(_dropdownContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  _createClass(Dropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('click', this._onWindowClick);
	      window.addEventListener('touchstart', this._onWindowClick);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('click', this._onWindowClick);
	      window.removeEventListener('touchstart', this._onWindowClick);
	    }
	  }]);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dropdown).call(this, props));
	
	    _this.state = {
	      active: false
	    };
	
	    _this._onWindowClick = _this._onWindowClick.bind(_this);
	    _this._onToggleClick = _this._onToggleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: 'isActive',
	    value: function isActive() {
	      return typeof this.props.active === 'boolean' ? this.props.active : this.state.active;
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      var _this2 = this;
	
	      this.setState({
	        active: false
	      }, function () {
	        if (_this2.props.onHide) {
	          _this2.props.onHide();
	        }
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this3 = this;
	
	      this.setState({
	        active: true
	      }, function () {
	        if (_this3.props.onShow) {
	          _this3.props.onShow();
	        }
	      });
	    }
	  }, {
	    key: '_onWindowClick',
	    value: function _onWindowClick(event) {
	      var dropdownElement = (0, _reactDom.findDOMNode)(this);
	      if (event.target !== dropdownElement && !dropdownElement.contains(event.target) && this.isActive()) {
	        this.hide();
	      }
	    }
	  }, {
	    key: '_onToggleClick',
	    value: function _onToggleClick(event) {
	      event.preventDefault();
	      if (this.isActive()) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this,
	          _arguments = arguments;
	
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var disabled = _props.disabled;
	      var removeElement = _props.removeElement;
	      // create component classes
	
	      var active = this.isActive();
	      var dropdownClasses = (0, _classnames2.default)({
	        dropdown: true,
	        'dropdown--active': active,
	        'dropdown--disabled': disabled
	      });
	      // stick callback on trigger element
	      var boundChildren = _react2.default.Children.map(children, function (child) {
	        if (child.type === _dropdownTrigger2.default) {
	          (function () {
	            var originalOnClick = child.props.onClick;
	            child = (0, _react.cloneElement)(child, {
	              ref: 'trigger',
	              onClick: function onClick(event) {
	                if (!disabled) {
	                  _this4._onToggleClick(event);
	                  if (originalOnClick) {
	                    originalOnClick.apply(child, _arguments);
	                  }
	                }
	              }
	            });
	          })();
	        } else if (child.type === _dropdownContent2.default && removeElement && !active) {
	          child = null;
	        }
	        return child;
	      });
	      var cleanProps = _extends({}, this.props);
	      delete cleanProps.active;
	      delete cleanProps.onShow;
	      delete cleanProps.onHide;
	      delete cleanProps.removeElement;
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, cleanProps, {
	          className: dropdownClasses + ' ' + className }),
	        boundChildren
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(_react.Component);
	
	Dropdown.propTypes = {
	  disabled: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  onHide: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  removeElement: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	};
	
	Dropdown.defaultProps = {
	  className: ''
	};
	
	exports.DropdownTrigger = _dropdownTrigger2.default;
	exports.DropdownContent = _dropdownContent2.default;
	exports.default = Dropdown;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = undefined;
	
	var _intersection2 = __webpack_require__(1368);
	
	var _intersection3 = _interopRequireDefault(_intersection2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = exports.getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection3.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	var identity = exports.identity = function identity(param) {
	  return param;
	};
	
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	var getDashCase = exports.getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return '-' + v.toLowerCase();
	  });
	};
	
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, IN_LINE_PREFIX_LIST[i] + '$1');
	    }
	
	    return _extends({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	var log = exports.log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	var debug = exports.debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	
	    return item;
	  };
	};
	
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	var debugf = exports.debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(undefined, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = '(' + args.map(JSON.stringify).join(', ') + ')';
	
	    log(name + ': ' + argNames + ' => ' + JSON.stringify(res));
	
	    return res;
	  };
	};
	
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	var mapObject = exports.mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	var translateStyle = exports.translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _extends({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	var compose = exports.compose = function compose() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var getTransitionVal = exports.getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return getDashCase(prop) + ' ' + duration + 'ms ' + easing;
	  }).join(',');
	};
	
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ },
/* 180 */
[1678, 1336, 1337, 1338, 1339, 1340],
/* 181 */
[1685, 60],
/* 182 */
[1689, 617],
/* 183 */
[1717, 1333],
/* 184 */
[1742, 88],
/* 185 */
[1749, 293],
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrayMove = arrayMove;
	exports.omit = omit;
	exports.closest = closest;
	exports.limit = limit;
	exports.getElementMargin = getElementMargin;
	exports.provideDisplayName = provideDisplayName;
	function arrayMove(arr, previousIndex, newIndex) {
	  var array = arr.slice(0);
	  if (newIndex >= array.length) {
	    var k = newIndex - array.length;
	    while (k-- + 1) {
	      array.push(undefined);
	    }
	  }
	  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
	  return array;
	}
	
	function omit(obj) {
	  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    keysToOmit[_key - 1] = arguments[_key];
	  }
	
	  return Object.keys(obj).reduce(function (acc, key) {
	    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
	    return acc;
	  }, {});
	}
	
	var events = exports.events = {
	  start: ['touchstart', 'mousedown'],
	  move: ['touchmove', 'mousemove'],
	  end: ['touchend', 'touchcancel', 'mouseup']
	};
	
	var vendorPrefix = exports.vendorPrefix = function () {
	  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
	  // fix for:
	  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  //    window.getComputedStyle() returns null inside an iframe with display: none
	  // in this case return an array with a fake mozilla style in it.
	  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
	  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];
	
	  switch (pre) {
	    case 'ms':
	      return 'ms';
	    default:
	      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
	  }
	}();
	
	function closest(el, fn) {
	  while (el) {
	    if (fn(el)) return el;
	    el = el.parentNode;
	  }
	}
	
	function limit(min, max, value) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	function getCSSPixelValue(stringValue) {
	  if (stringValue.substr(-2) === 'px') {
	    return parseFloat(stringValue);
	  }
	  return 0;
	}
	
	function getElementMargin(element) {
	  var style = window.getComputedStyle(element);
	
	  return {
	    top: getCSSPixelValue(style.marginTop),
	    right: getCSSPixelValue(style.marginRight),
	    bottom: getCSSPixelValue(style.marginBottom),
	    left: getCSSPixelValue(style.marginLeft)
	  };
	}
	
	function provideDisplayName(prefix, Component) {
	  var componentName = Component.displayName || Component.name;
	
	  return componentName ? prefix + '(' + componentName + ')' : prefix;
	}

/***/ },
/* 187 */
[1678, 1444, 1445, 1446, 1447, 1448],
/* 188 */
[1689, 301],
/* 189 */
[1717, 1441],
/* 190 */
[1742, 90],
/* 191 */
[1749, 139],
/* 192 */
144,
/* 193 */
[1761, 1390, 1404, 136],
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactDom = __webpack_require__(22);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'Tab',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    focus: _propTypes2.default.bool,
	    selected: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    activeTabClassName: _propTypes2.default.string,
	    disabledTabClassName: _propTypes2.default.string,
	    panelId: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      focus: false,
	      selected: false,
	      id: null,
	      panelId: null,
	      activeTabClassName: 'ReactTabs__Tab--selected',
	      disabledTabClassName: 'ReactTabs__Tab--disabled'
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.checkFocus();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.checkFocus();
	  },
	  checkFocus: function checkFocus() {
	    if (this.props.selected && this.props.focus) {
	      (0, _reactDom.findDOMNode)(this).focus();
	    }
	  },
	  render: function render() {
	    var _cx;
	
	    var _props = this.props,
	        selected = _props.selected,
	        disabled = _props.disabled,
	        panelId = _props.panelId,
	        activeTabClassName = _props.activeTabClassName,
	        disabledTabClassName = _props.disabledTabClassName,
	        className = _props.className,
	        children = _props.children,
	        id = _props.id,
	        attributes = _objectWithoutProperties(_props, ['selected', 'disabled', 'panelId', 'activeTabClassName', 'disabledTabClassName', 'className', 'children', 'id']);
	
	    delete attributes.focus;
	
	    return _react2.default.createElement(
	      'li',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__Tab', className, (_cx = {}, _defineProperty(_cx, activeTabClassName, selected), _defineProperty(_cx, disabledTabClassName, disabled), _cx)),
	        role: 'tab',
	        id: id,
	        'aria-selected': selected ? 'true' : 'false',
	        'aria-disabled': disabled ? 'true' : 'false',
	        'aria-controls': panelId,
	        tabIndex: selected ? '0' : null
	      }),
	      children
	    );
	  }
	});

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabPanel = exports.Tab = exports.TabList = exports.Tabs = undefined;
	
	var _Tabs = __webpack_require__(1488);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabList = __webpack_require__(637);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _Tab = __webpack_require__(194);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabPanel = __webpack_require__(1487);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tabs = _Tabs2.default;
	exports.TabList = _TabList2.default;
	exports.Tab = _Tab2.default;
	exports.TabPanel = _TabPanel2.default;
	
	// For bc we also export a default object, remove in 1.0
	
	exports.default = {
	  Tabs: _Tabs2.default,
	  TabList: _TabList2.default,
	  Tab: _Tab2.default,
	  TabPanel: _TabPanel2.default
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Render a group of error bar
	                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorBar = (_temp = _class = function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, (ErrorBar.__proto__ || Object.getPrototypeOf(ErrorBar)).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: 'renderErrorBars',
	    value: function renderErrorBars() {
	      var _props = this.props,
	          offset = _props.offset,
	          layout = _props.layout,
	          width = _props.width,
	          dataKey = _props.dataKey,
	          data = _props.data,
	          dataPointFormatter = _props.dataPointFormatter,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          others = _objectWithoutProperties(_props, ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis']);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid = void 0,
	            yMid = void 0,
	            xMin = void 0,
	            yMin = void 0,
	            xMax = void 0,
	            yMax = void 0,
	            scale = void 0,
	            coordsTop = void 0,
	            coordsMid = void 0,
	            coordsBot = void 0,
	            lowBound = void 0,
	            highBound = void 0;
	
	        if (Array.isArray(errorVal)) {
	          lowBound = errorVal[0];
	          highBound = errorVal[1];
	        } else {
	          lowBound = errorVal;
	          highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = { x1: xMax, y1: yMin, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMin, y1: yMid, x2: xMax, y2: yMid };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMin, y2: yMax };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = { x1: xMin, y1: yMax, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMid, y1: yMin, x2: xMid, y2: yMax };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMax, y2: yMin };
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({ className: 'recharts-errorBar', key: i }, props),
	          _react2.default.createElement('line', coordsTop),
	          ';',
	          _react2.default.createElement('line', coordsMid),
	          ';',
	          _react2.default.createElement('line', coordsBot),
	          ';'
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-errorBars' },
	        this.renderErrorBars()
	      );
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component), _class.propTypes = {
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  data: _propTypes2.default.array,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  layout: _propTypes2.default.string,
	  dataPointFormatter: _propTypes2.default.func,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  offset: _propTypes2.default.number
	}, _class.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	}, _temp);
	exports.default = ErrorBar;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DataUtils = __webpack_require__(16);
	
	var _Rectangle = __webpack_require__(94);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceArea = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceArea, _Component);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, (ReferenceArea.__proto__ || Object.getPrototypeOf(ReferenceArea)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: 'getRect',
	    value: function getRect(hasX, hasY) {
	      var _props = this.props,
	          xValue1 = _props.x1,
	          xValue2 = _props.x2,
	          yValue1 = _props.y1,
	          yValue2 = _props.y2,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var xOffset = xScale.bandwidth ? xScale.bandwidth() / 2 : 0;
	      var yOffset = yScale.bandwidth ? yScale.bandwidth() / 2 : 0;
	      var xRange = xScale.range();
	      var yRange = yScale.range();
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0;
	
	      if (hasX && (0, _DataUtils.isNumOrStr)(xValue1)) {
	        x1 = xScale(xValue1) + xOffset;
	      } else if (hasY) {
	        x1 = xRange[0];
	      }
	      if (hasX && (0, _DataUtils.isNumOrStr)(xValue2)) {
	        x2 = xScale(xValue2) + xOffset;
	      } else if (hasY) {
	        x2 = xRange[1];
	      }
	      if (hasY && (0, _DataUtils.isNumOrStr)(yValue1)) {
	        y1 = yScale(yValue1) + yOffset;
	      } else if (hasX) {
	        y1 = yRange[0];
	      }
	      if (hasY && (0, _DataUtils.isNumOrStr)(yValue2)) {
	        y2 = yScale(yValue2) + yOffset;
	      } else if (hasX) {
	        y2 = yRange[1];
	      }
	
	      if ((0, _DataUtils.validateCoordinateInRange)(x1, xScale) && (0, _DataUtils.validateCoordinateInRange)(x2, xScale) && (0, _DataUtils.validateCoordinateInRange)(y1, yScale) && (0, _DataUtils.validateCoordinateInRange)(y2, yScale)) {
	        return {
	          x: Math.min(x1, x2),
	          y: Math.min(y1, y2),
	          width: Math.abs(x2 - x1),
	          height: Math.abs(y2 - y1)
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(_ref) {
	      var x = _ref.x,
	          y = _ref.y,
	          width = _ref.width,
	          height = _ref.height;
	      var _props2 = this.props,
	          label = _props2.label,
	          stroke = _props2.stroke;
	
	      var props = _extends({}, label, {
	        stroke: 'none',
	        fill: stroke,
	        x: x + width / 2,
	        y: y + height / 2,
	        textAnchor: 'middle'
	      });
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-reference-area-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderRect',
	    value: function renderRect(option, props) {
	      var rect = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rect = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rect = option(props);
	      } else {
	        rect = _react2.default.createElement(_Rectangle2.default, _extends({}, props, {
	          className: 'recharts-reference-area-rect'
	        }));
	      }
	
	      return rect;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          x1 = _props3.x1,
	          x2 = _props3.x2,
	          y1 = _props3.y1,
	          y2 = _props3.y2;
	
	      var hasX = (0, _DataUtils.isNumOrStr)(x1) && (0, _DataUtils.isNumOrStr)(x2);
	      var hasY = (0, _DataUtils.isNumOrStr)(y1) && (0, _DataUtils.isNumOrStr)(y2);
	
	      if (!hasX && !hasY) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX, hasY);
	
	      if (!rect) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-reference-area' },
	        this.renderRect(shape, _extends({}, this.props, rect)),
	        this.renderLabel(rect)
	      );
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.Component), _class2.displayName = 'ReferenceArea', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  x2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceArea;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Dot = __webpack_require__(75);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceDot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceDot, _Component);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, (ReferenceDot.__proto__ || Object.getPrototypeOf(ReferenceDot)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: 'getCoordinate',
	    value: function getCoordinate() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var result = {
	        cx: xScale(x) + (xScale.bandwidth ? xScale.bandwidth() / 2 : 0),
	        cy: yScale(y) + (yScale.bandwidth ? yScale.bandwidth() / 2 : 0)
	      };
	
	      if ((0, _DataUtils.validateCoordinateInRange)(result.cx, xScale) && (0, _DataUtils.validateCoordinateInRange)(result.cy, yScale)) {
	        return result;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(coordinate) {
	      var _props2 = this.props,
	          label = _props2.label,
	          stroke = _props2.stroke;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(label), {
	        stroke: 'none',
	        fill: stroke,
	        x: coordinate.cx,
	        y: coordinate.cy,
	        textAnchor: 'middle',
	        verticalAnchor: 'middle'
	      });
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-reference-dot-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderDot',
	    value: function renderDot(option, props) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: 'recharts-reference-dot-dot'
	        }));
	      }
	
	      return dot;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          x = _props3.x,
	          y = _props3.y;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	
	
	      var dotProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), coordinate);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-reference-dot' },
	        this.renderDot(shape, dotProps),
	        this.renderLabel(coordinate)
	      );
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.Component), _class2.displayName = 'ReferenceDot', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes2.default.number,
	
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	
	  xAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	  yAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceDot;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Reference Line
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderLine = function renderLine(option, props) {
	  var line = void 0;
	
	  if (_react2.default.isValidElement(option)) {
	    line = _react2.default.cloneElement(option, props);
	  } else if ((0, _isFunction3.default)(option)) {
	    line = option(props);
	  } else {
	    line = _react2.default.createElement('line', _extends({}, props, {
	      className: 'recharts-reference-line-line'
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceLine, _Component);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, (ReferenceLine.__proto__ || Object.getPrototypeOf(ReferenceLine)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: 'getEndPoints',
	    value: function getEndPoints(isX, isY) {
	      var _props = this.props,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          viewBox = _props.viewBox;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	
	      if (isY) {
	        var value = this.props.y;
	        var scale = yAxis.scale;
	
	        var offset = scale.bandwidth ? scale.bandwidth() / 2 : 0;
	        var coord = scale(value) + offset;
	
	        if ((0, _DataUtils.validateCoordinateInRange)(coord, scale)) {
	          return yAxis.orientation === 'left' ? [{ x: x, y: coord }, { x: x + width, y: coord }] : [{ x: x + width, y: coord }, { x: x, y: coord }];
	        }
	      } else if (isX) {
	        var _value = this.props.x;
	        var _scale = xAxis.scale;
	
	        var _offset = _scale.bandwidth ? _scale.bandwidth() / 2 : 0;
	        var _coord = _scale(_value) + _offset;
	
	        if ((0, _DataUtils.validateCoordinateInRange)(_coord, _scale)) {
	          return xAxis.orientation === 'top' ? [{ x: _coord, y: y }, { x: _coord, y: y + height }] : [{ x: _coord, y: y + height }, { x: _coord, y: y }];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getLabelProps',
	    value: function getLabelProps(isX, isY) {
	      var _props2 = this.props,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          labelPosition = _props2.labelPosition;
	
	
	      if (isY) {
	        var axis = yAxis;
	
	        if (axis.orientation === 'left' && labelPosition === 'end') {
	          return { dx: 6, dy: 6, textAnchor: 'start' };
	        }
	        if (axis.orientation === 'right' && labelPosition === 'start') {
	          return { dx: 6, dy: 6, textAnchor: 'start' };
	        }
	        return { dx: -6, dy: 6, textAnchor: 'end' };
	      } else if (isX) {
	        var _axis = xAxis;
	
	        if (_axis.orientation === 'top') {
	          return { dy: 6, textAnchor: 'middle' };
	        }
	        return { dy: -6, textAnchor: 'middle' };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(isX, isY, end) {
	      var _props3 = this.props,
	          label = _props3.label,
	          stroke = _props3.stroke;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(label), {
	        stroke: 'none',
	        fill: stroke
	      }, end, this.getLabelProps(isX, isY));
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-reference-line-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          x = _props4.x,
	          y = _props4.y,
	          labelPosition = _props4.labelPosition,
	          shape = _props4.shape;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX && !isY) {
	        return null;
	      }
	
	      var endPoints = this.getEndPoints(isX, isY);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          start = _endPoints[0],
	          end = _endPoints[1];
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: start.x,
	        y1: start.y,
	        x2: end.x,
	        y2: end.y
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-reference-line' },
	        renderLine(shape, props),
	        this.renderLabel(isX, isY, labelPosition === 'start' ? start : end)
	      );
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.Component), _class2.displayName = 'ReferenceLine', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  labelPosition: _propTypes2.default.oneOf(['start', 'end']),
	  shape: _propTypes2.default.func
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1,
	  labelPosition: 'end'
	}, _temp)) || _class;
	
	exports.default = ReferenceLine;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortBy2 = __webpack_require__(684);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _range2 = __webpack_require__(209);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _throttle2 = __webpack_require__(1657);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(63);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Legend = __webpack_require__(92);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _LogUtils = __webpack_require__(316);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _CartesianAxis = __webpack_require__(308);
	
	var _CartesianAxis2 = _interopRequireDefault(_CartesianAxis);
	
	var _CartesianGrid = __webpack_require__(309);
	
	var _CartesianGrid2 = _interopRequireDefault(_CartesianGrid);
	
	var _ReferenceLine = __webpack_require__(199);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceDot = __webpack_require__(198);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceArea = __webpack_require__(197);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _XAxis = __webpack_require__(311);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(312);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _Brush = __webpack_require__(647);
	
	var _Brush2 = _interopRequireDefault(_Brush);
	
	var _DOMUtils = __webpack_require__(142);
	
	var _DataUtils = __webpack_require__(16);
	
	var _CartesianUtils = __webpack_require__(201);
	
	var _PureRender = __webpack_require__(12);
	
	var _Events = __webpack_require__(1522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	
	var originCoordinate = { x: 0, y: 0 };
	
	var generateCategoricalChart = function generateCategoricalChart(ChartComponent, GraphicalChild) {
	  var _class, _temp;
	
	  var CategoricalChartWrapper = (_temp = _class = function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    function CategoricalChartWrapper(props) {
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      var _this = _possibleConstructorReturn(this, (CategoricalChartWrapper.__proto__ || Object.getPrototypeOf(CategoricalChartWrapper)).call(this, props));
	
	      _this.handleLegendBBoxUpdate = function (box) {
	        if (box && _this.legendInstance) {
	          var _this$state = _this.state,
	              dataStartIndex = _this$state.dataStartIndex,
	              dataEndIndex = _this$state.dataEndIndex;
	
	
	          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
	            props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
	          }));
	        }
	      };
	
	      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
	        var _this$props = _this.props,
	            syncId = _this$props.syncId,
	            layout = _this$props.layout;
	
	
	        if (syncId === cId && chartId !== _this.uniqueChartId) {
	          var dataStartIndex = data.dataStartIndex,
	              dataEndIndex = data.dataEndIndex;
	
	
	          if (!(0, _isNil3.default)(data.dataStartIndex) || !(0, _isNil3.default)(data.dataEndIndex)) {
	            _this.setState(_extends({
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex })));
	          } else if (!(0, _isNil3.default)(data.activeTooltipIndex)) {
	            var chartX = data.chartX,
	                chartY = data.chartY,
	                activeTooltipIndex = data.activeTooltipIndex;
	            var _this$state2 = _this.state,
	                offset = _this$state2.offset,
	                tooltipTicks = _this$state2.tooltipTicks;
	
	            if (!offset) {
	              return;
	            }
	            var viewBox = _extends({}, offset, { x: offset.left, y: offset.top });
	            // When a categotical chart is combined with another chart, the value of chartX
	            // and chartY may beyond the boundaries.
	            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	            var activePayload = _this.getTooltipContent(activeTooltipIndex);
	            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	            } : originCoordinate;
	
	            _this.setState(_extends({}, data, { activeLabel: activeLabel, activeCoordinate: activeCoordinate, activePayload: activePayload }));
	          } else {
	            _this.setState(data);
	          }
	        }
	      };
	
	      _this.handleBrushChange = function (_ref) {
	        var startIndex = _ref.startIndex,
	            endIndex = _ref.endIndex;
	
	        // Only trigger changes if the extents of the brush have actually changed
	        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
	          _this.setState(_extends({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: startIndex, dataEndIndex: endIndex })));
	
	          _this.triggerSyncEvent({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          });
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        var mouse = _this.getMouseInfo(e);
	
	        if (mouse) {
	          var nextState = _extends({}, mouse, { isTooltipActive: true });
	          _this.setState(nextState);
	          _this.triggerSyncEvent(nextState);
	
	          if ((0, _isFunction3.default)(onMouseEnter)) {
	            onMouseEnter(nextState, e);
	          }
	        }
	      };
	
	      _this.triggeredAfterMouseMove = function (e) {
	        var onMouseMove = _this.props.onMouseMove;
	
	        var mouse = _this.getMouseInfo(e);
	        var nextState = mouse ? _extends({}, mouse, { isTooltipActive: true }) : { isTooltipActive: false };
	
	        _this.setState(nextState);
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction3.default)(onMouseMove)) {
	          onMouseMove(nextState, e);
	        }
	      };
	
	      _this.handleMouseMove = function (e) {
	        if (e && (0, _isFunction3.default)(e.persist)) {
	          e.persist();
	          _this.triggeredAfterMouseMove(e);
	        }
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	
	        var nextState = { isTooltipActive: false };
	
	        _this.setState(nextState);
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction3.default)(onMouseLeave)) {
	          onMouseLeave(nextState, e);
	        }
	      };
	
	      _this.handleClick = function (e) {
	        var onClick = _this.props.onClick;
	
	
	        if ((0, _isFunction3.default)(onClick)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onClick(mouse, e);
	        }
	      };
	
	      _this.handleMouseDown = function (e) {
	        var onMouseDown = _this.props.onMouseDown;
	
	
	        if ((0, _isFunction3.default)(onMouseDown)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseDown(mouse, e);
	        }
	      };
	
	      _this.handleMouseUp = function (e) {
	        var onMouseUp = _this.props.onMouseUp;
	
	
	        if ((0, _isFunction3.default)(onMouseUp)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseUp(mouse, e);
	        }
	      };
	
	      _this.handleTouchMove = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseMove(e.changedTouches[0]);
	        }
	      };
	
	      _this.verticalCoordinatesGenerator = function (_ref2) {
	        var xAxis = _ref2.xAxis,
	            width = _ref2.width,
	            height = _ref2.height,
	            offset = _ref2.offset;
	        return (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, xAxis, {
	          ticks: (0, _CartesianUtils.getTicksOfAxis)(xAxis, true),
	          viewBox: { x: 0, y: 0, width: width, height: height }
	        })), offset.left, offset.left + offset.width);
	      };
	
	      _this.horizontalCoordinatesGenerator = function (_ref3) {
	        var yAxis = _ref3.yAxis,
	            width = _ref3.width,
	            height = _ref3.height,
	            offset = _ref3.offset;
	        return (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, yAxis, {
	          ticks: (0, _CartesianUtils.getTicksOfAxis)(yAxis, true),
	          viewBox: { x: 0, y: 0, width: width, height: height }
	        })), offset.top, offset.top + offset.height);
	      };
	
	      _this.axesTicksGenerator = function (axis) {
	        return (0, _CartesianUtils.getTicksOfAxis)(axis, true);
	      };
	
	      _this.tooltipTicksGenerator = function (_ref4) {
	        var layout = _ref4.layout,
	            xAxisMap = _ref4.xAxisMap,
	            yAxisMap = _ref4.yAxisMap;
	
	        var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
	        var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	        var tooltipTicks = (0, _CartesianUtils.getTicksOfAxis)(axis, false, true);
	
	        return {
	          tooltipTicks: tooltipTicks,
	          orderedTooltipTicks: (0, _sortBy3.default)(tooltipTicks, function (o) {
	            return o.coordinate;
	          }),
	          tooltipAxis: axis
	        };
	      };
	
	      var defaultState = _this.createDefaultState(props);
	      _this.state = _extends({}, defaultState, { updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: props }, defaultState)));
	      _this.validateAxes();
	      _this.uniqueChartId = (0, _DataUtils.uniqueId)('recharts');
	
	      if (props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle3.default)(_this.triggeredAfterMouseMove, props.throttleDelay);
	      }
	      return _this;
	    }
	
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.addListener();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            data = _props.data,
	            children = _props.children,
	            width = _props.width,
	            height = _props.height,
	            layout = _props.layout,
	            stackOffset = _props.stackOffset,
	            margin = _props.margin;
	
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _PureRender.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.createDefaultState(nextProps);
	          this.setState(_extends({}, defaultState, { updateId: this.state.updateId + 1
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, defaultState))));
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          var _state = this.state,
	              dataStartIndex = _state.dataStartIndex,
	              dataEndIndex = _state.dataEndIndex;
	          // Don't update brush
	
	          var _defaultState = _extends({}, this.createDefaultState(nextProps), { dataEndIndex: dataEndIndex, dataStartIndex: dataStartIndex
	          });
	          this.setState(_extends({}, _defaultState, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, _defaultState))));
	        }
	        // add syncId
	        if ((0, _isNil3.default)(this.props.syncId) && !(0, _isNil3.default)(nextProps.syncId)) {
	          this.addListener();
	        }
	        // remove syncId
	        if (!(0, _isNil3.default)(this.props.syncId) && (0, _isNil3.default)(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.removeListener();
	        }
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: 'getAxisMap',
	      value: function getAxisMap(props, _ref5) {
	        var _ref5$axisType = _ref5.axisType,
	            axisType = _ref5$axisType === undefined ? 'xAxis' : _ref5$axisType,
	            graphicalItems = _ref5.graphicalItems,
	            stackGroups = _ref5.stackGroups,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex;
	        var children = props.children;
	
	        var Axis = axisType === 'xAxis' ? _XAxis2.default : _YAxis2.default;
	        var axisIdKey = axisType === 'xAxis' ? 'xAxisId' : 'yAxisId';
	        // Get all the instance of Axis
	        var axes = (0, _ReactUtils.findAllByType)(children, Axis);
	
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, { axes: axes, graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey,
	            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, { graphicalItems: graphicalItems, Axis: Axis, axisType: axisType, axisIdKey: axisIdKey,
	            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        }
	
	        return axisMap;
	      }
	
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByAxes',
	      value: function getAxisMapByAxes(props, _ref6) {
	        var axes = _ref6.axes,
	            graphicalItems = _ref6.graphicalItems,
	            axisType = _ref6.axisType,
	            axisIdKey = _ref6.axisIdKey,
	            stackGroups = _ref6.stackGroups,
	            dataStartIndex = _ref6.dataStartIndex,
	            dataEndIndex = _ref6.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            data = props.data,
	            stackOffset = props.stackOffset;
	
	        var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
	        var len = displayedData.length;
	        var isCategorial = (0, _CartesianUtils.isCategorialAxis)(layout, axisType);
	
	        // Eliminate duplicated axes
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              scale = _child$props.scale;
	
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            var domain = void 0,
	                duplicateDomain = void 0,
	                categoricalDomain = void 0;
	
	            if (dataKey) {
	              domain = (0, _CartesianUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	                duplicateDomain = duplicate ? domain : null;
	
	                // When category axis has duplicated text, serial numbers are used to generate scale
	                domain = duplicate ? (0, _range3.default)(0, len) : domain;
	              } else if (type === 'category') {
	                // eliminate undefined or null or empty string
	                domain = domain.filter(function (entry) {
	                  return entry !== '' && !(0, _isNil3.default)(entry);
	                });
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _CartesianUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _CartesianUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _CartesianUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (entry) {
	                return entry.props[axisIdKey] === axisId;
	              }), type, true);
	            }
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _CartesianUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	
	              if (child.props.domain) {
	                domain = (0, _DataUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByItems',
	      value: function getAxisMapByItems(props, _ref7) {
	        var graphicalItems = _ref7.graphicalItems,
	            Axis = _ref7.Axis,
	            axisType = _ref7.axisType,
	            axisIdKey = _ref7.axisIdKey,
	            stackGroups = _ref7.stackGroups,
	            dataStartIndex = _ref7.dataStartIndex,
	            dataEndIndex = _ref7.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            data = props.data;
	
	        var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
	        var len = displayedData.length;
	        var isCategorial = (0, _CartesianUtils.isCategorialAxis)(layout, axisType);
	        var index = -1;
	
	        // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain = void 0;
	
	            if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _CartesianUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _CartesianUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _DataUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _CartesianUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (entry) {
	                return entry.props[axisIdKey] === axisId;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _CartesianUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial
	            })));
	          }
	
	          return result;
	        }, {});
	
	        return axisMap;
	      }
	      /**
	       * Calculate the scale function, position, width, height of axes
	       * @param  {Object} props    Latest props
	       * @param  {Object} axisMap  The configuration of axes
	       * @param  {Object} offset   The offset of main part in the svg element
	       * @param  {Object} axisType The type of axes, x-axis or y-axis
	       * @return {Object} Configuration
	       */
	
	    }, {
	      key: 'getFormatAxisMap',
	      value: function getFormatAxisMap(props, axisMap, offset, axisType) {
	        var width = props.width,
	            height = props.height,
	            layout = props.layout;
	
	        var displayName = this.constructor.displayName;
	        var ids = Object.keys(axisMap);
	        var steps = {
	          left: offset.left,
	          leftMirror: offset.left,
	          right: width - offset.right,
	          rightMirror: width - offset.right,
	          top: offset.top,
	          topMirror: offset.top,
	          bottom: height - offset.bottom,
	          bottomMirror: height - offset.bottom
	        };
	
	        return ids.reduce(function (result, id) {
	          var axis = axisMap[id];
	          var orientation = axis.orientation,
	              domain = axis.domain,
	              _axis$padding = axis.padding,
	              padding = _axis$padding === undefined ? {} : _axis$padding,
	              mirror = axis.mirror,
	              reversed = axis.reversed;
	
	          var offsetKey = '' + orientation + (mirror ? 'Mirror' : '');
	
	          var range = void 0,
	              x = void 0,
	              y = void 0,
	              needSpace = void 0;
	
	          if (axisType === 'xAxis') {
	            range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	          } else {
	            range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	          }
	
	          if (reversed) {
	            range = [range[1], range[0]];
	          }
	
	          var scale = (0, _DataUtils.parseScale)(axis, displayName);
	          scale.domain(domain).range(range);
	          (0, _DataUtils.checkDomainOfScale)(scale);
	          var ticks = (0, _CartesianUtils.getTicksOfScale)(scale, axis);
	
	          if (axisType === 'xAxis') {
	            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	            x = offset.left;
	            y = steps[offsetKey] - needSpace * axis.height;
	          } else {
	            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	            x = steps[offsetKey] - needSpace * axis.width;
	            y = offset.top;
	          }
	
	          var finalAxis = _extends({}, axis, ticks, {
	            range: range, x: x, y: y, scale: scale,
	            width: axisType === 'xAxis' ? offset.width : axis.width,
	            height: axisType === 'yAxis' ? offset.height : axis.height
	          });
	          if (!axis.hide && axisType === 'xAxis') {
	            steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	          } else if (!axis.hide) {
	            steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	          }
	
	          return _extends({}, result, _defineProperty({}, id, finalAxis));
	        }, {});
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: 'getMouseInfo',
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var offset = this.state.offset;
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var isIn = e.chartX >= offset.left && e.chartX <= offset.left + offset.width && e.chartY >= offset.top && e.chartY <= offset.top + offset.height;
	
	        if (!isIn) {
	          return null;
	        }
	
	        var layout = this.props.layout;
	        var _state2 = this.state,
	            ticks = _state2.orderedTooltipTicks,
	            axis = _state2.tooltipAxis,
	            tooltipTicks = _state2.tooltipTicks;
	
	        var pos = layout === 'horizontal' ? e.chartX : e.chartY;
	        var activeIndex = (0, _CartesianUtils.calculateActiveTickIndex)(pos, ticks, axis);
	
	        if (activeIndex >= 0) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex);
	          var activeCoordinate = tooltipTicks[activeIndex] ? {
	            x: layout === 'horizontal' ? tooltipTicks[activeIndex].coordinate : e.chartX,
	            y: layout === 'horizontal' ? e.chartY : tooltipTicks[activeIndex].coordinate
	          } : originCoordinate;
	
	          return _extends({}, e, {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel,
	            activePayload: activePayload,
	            activeCoordinate: activeCoordinate
	          });
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: 'getTooltipContent',
	      value: function getTooltipContent(activeIndex) {
	        var _state3 = this.state,
	            dataStartIndex = _state3.dataStartIndex,
	            dataEndIndex = _state3.dataEndIndex,
	            graphicalItems = _state3.graphicalItems;
	
	        var data = this.props.data.slice(dataStartIndex, dataEndIndex + 1);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= data.length) {
	          return null;
	        }
	
	        return graphicalItems.map(function (child) {
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter;
	
	
	          return _extends({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey, unit: unit, formatter: formatter,
	            name: name || dataKey,
	            color: (0, _CartesianUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _DataUtils.getValueByDataKey)(data[activeIndex], dataKey),
	            payload: data[activeIndex]
	          });
	        });
	      }
	
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex The end index of the data series when a brush is applied
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: 'updateStateOfAxisMapsOffsetAndStackGroups',
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
	        var props = _ref8.props,
	            dataStartIndex = _ref8.dataStartIndex,
	            dataEndIndex = _ref8.dataEndIndex;
	        var data = props.data;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({ props: props }) || !data || !data.length) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset;
	
	        var numericIdName = layout === 'horizontal' ? 'yAxis' : 'xAxis';
	        var cateIdName = layout === 'horizontal' ? 'xAxis' : 'yAxis';
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _CartesianUtils.getStackGroupsByAxisId)(data, graphicalItems, numericIdName + 'Id', cateIdName + 'Id', stackOffset);
	
	        var xAxisMap = this.getAxisMap(props, {
	          axisType: 'xAxis',
	          graphicalItems: graphicalItems,
	          stackGroups: numericIdName === 'xAxis' && stackGroups,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	
	        var yAxisMap = this.getAxisMap(props, {
	          axisType: 'yAxis',
	          graphicalItems: graphicalItems,
	          stackGroups: numericIdName === 'yAxis' && stackGroups,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	
	        var offset = this.calculateOffset(props, graphicalItems, xAxisMap, yAxisMap);
	
	        xAxisMap = this.getFormatAxisMap(props, xAxisMap, offset, 'xAxis');
	        yAxisMap = this.getFormatAxisMap(props, yAxisMap, offset, 'yAxis');
	
	        var ticksObj = this.tooltipTicksGenerator({
	          layout: layout, xAxisMap: xAxisMap, yAxisMap: yAxisMap
	        });
	
	        return _extends({ graphicalItems: graphicalItems, xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset, stackGroups: stackGroups }, ticksObj);
	      }
	
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: 'addListener',
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: 'removeListener',
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Returns default, reset state for the categorical chart.
	       * @param {Object} props Props object to use when creating the default state
	       * @return {Object} Whole new state
	       */
	
	    }, {
	      key: 'createDefaultState',
	      value: function createDefaultState(props) {
	        var children = props.children;
	
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	        var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	        var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	        return {
	          chartX: 0,
	          chartY: 0,
	          dataStartIndex: startIndex,
	          dataEndIndex: endIndex,
	          activeTooltipIndex: -1,
	          isTooltipActive: false
	        };
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: 'calculateOffset',
	      value: function calculateOffset(props, graphicalItems, xAxisMap, yAxisMap) {
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, { left: margin.left || 0, right: margin.right || 0 });
	
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, { top: margin.top || 0, bottom: margin.bottom || 0 });
	
	        var offset = _extends({}, offsetV, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush2.default.defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	          offset = (0, _CartesianUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _extends({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	      /**
	       * The handler of mouse entering chart
	       * @param  {Object} e              Event object
	       * @return {Null}                  null
	       */
	
	
	      /**
	       * The handler of mouse moving in chart
	       * @param  {Object} e        Event object
	       * @return {Null} no return
	       */
	
	      /**
	       * The handler if mouse leaving chart
	       * @param {Object} e Event object
	       * @return {Null} no return
	       */
	
	    }, {
	      key: 'validateAxes',
	      value: function validateAxes() {
	        var _props2 = this.props,
	            layout = _props2.layout,
	            children = _props2.children;
	
	        var xAxes = (0, _ReactUtils.findAllByType)(children, _XAxis2.default);
	        var yAxes = (0, _ReactUtils.findAllByType)(children, _YAxis2.default);
	
	        if (layout === 'horizontal' && xAxes && xAxes.length) {
	          xAxes.forEach(function (axis) {
	            (0, _LogUtils.warn)(axis.props.type === 'category' || axis.props.type === 'number' && !(0, _isNil3.default)(axis.props.dataKey), 'x-axis should be a category axis or a number axis which has specifed dataKey\n             when the layout is horizontal');
	          });
	        } else if (layout === 'vertical') {
	          var displayName = this.constructor.displayName;
	
	          (0, _LogUtils.warn)(yAxes && yAxes.length, 'You should add <YAxis type="number" /> in ' + displayName + '.\n           The layout is vertical now, y-axis should be category axis,\n           but y-axis is number axis when no YAxis is added.');
	          (0, _LogUtils.warn)(xAxes && xAxes.length, 'You should add <XAxis /> in ' + displayName + '.\n          The layout is vertical now, x-axis is category when no XAxis is added.');
	
	          if (yAxes && yAxes.length) {
	            yAxes.forEach(function (axis) {
	              (0, _LogUtils.warn)(axis.props.type === 'category' || axis.props.type === 'number' && !(0, _isNil3.default)(axis.props.dataKey), 'y-axis should be a category axis or a number axis which has specifed dataKey\n               when the layout is vertical');
	            });
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: 'triggerSyncEvent',
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	
	        if (!(0, _isNil3.default)(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: 'renderAxes',
	
	
	      /**
	       * Draw axes
	       * @param {Object} axisMap The configuration of all x-axes or y-axes
	       * @param {String} name    The name of axes
	       * @return {ReactElement}  The instance of x-axes
	       */
	      value: function renderAxes(axisMap, name) {
	        var _props3 = this.props,
	            width = _props3.width,
	            height = _props3.height;
	
	        var ids = axisMap && Object.keys(axisMap);
	
	        if (ids && ids.length) {
	          var axes = [];
	
	          for (var i = 0, len = ids.length; i < len; i++) {
	            var axis = axisMap[ids[i]];
	
	            if (!axis.hide) {
	
	              axes.push(_react2.default.createElement(_CartesianAxis2.default, _extends({}, axis, {
	                key: name + '-' + ids[i],
	                viewBox: { x: 0, y: 0, width: width, height: height },
	                ticksGenerator: this.axesTicksGenerator
	              })));
	            }
	          }
	
	          return axes.length ? _react2.default.createElement(
	            _Layer2.default,
	            { key: name + '-layer', className: 'recharts-' + name },
	            axes
	          ) : null;
	        }
	
	        return null;
	      }
	
	      /**
	       * Draw grid
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: 'renderGrid',
	      value: function renderGrid() {
	        var _state4 = this.state,
	            xAxisMap = _state4.xAxisMap,
	            yAxisMap = _state4.yAxisMap,
	            offset = _state4.offset;
	        var _props4 = this.props,
	            children = _props4.children,
	            width = _props4.width,
	            height = _props4.height;
	
	        var gridItem = (0, _ReactUtils.findChildByType)(children, _CartesianGrid2.default);
	
	        if (!gridItem) {
	          return null;
	        }
	
	        var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	        var yAxis = (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	
	        return _react2.default.cloneElement(gridItem, {
	          key: 'grid',
	          x: offset.left,
	          y: offset.top,
	          width: offset.width,
	          height: offset.height,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          offset: offset,
	          chartWidth: width,
	          chartHeight: height,
	          verticalCoordinatesGenerator: this.verticalCoordinatesGenerator,
	          horizontalCoordinatesGenerator: this.horizontalCoordinatesGenerator
	        });
	      }
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	
	    }, {
	      key: 'renderLegend',
	      value: function renderLegend() {
	        var _this2 = this;
	
	        var graphicalItems = this.state.graphicalItems;
	        var _props5 = this.props,
	            children = _props5.children,
	            width = _props5.width,
	            height = _props5.height;
	
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _CartesianUtils.getLegendProps)(children, graphicalItems, legendWidth, legendHeight);
	
	        if (!props) {
	          return null;
	        }
	
	        return _react2.default.createElement(_Legend2.default, _extends({}, props, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this2.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: 'renderTooltip',
	      value: function renderTooltip() {
	        var children = this.props.children;
	
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _state5 = this.state,
	            isTooltipActive = _state5.isTooltipActive,
	            activeCoordinate = _state5.activeCoordinate,
	            activePayload = _state5.activePayload,
	            activeLabel = _state5.activeLabel,
	            offset = _state5.offset;
	
	
	        return _react2.default.cloneElement(tooltipItem, {
	          viewBox: _extends({}, offset, { x: offset.left, y: offset.top }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: 'renderBrush',
	      value: function renderBrush() {
	        var _props6 = this.props,
	            children = _props6.children,
	            margin = _props6.margin,
	            data = _props6.data;
	        var _state6 = this.state,
	            offset = _state6.offset,
	            dataStartIndex = _state6.dataStartIndex,
	            dataEndIndex = _state6.dataEndIndex,
	            updateId = _state6.updateId;
	
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	
	        if (!brushItem) {
	          return null;
	        }
	
	        // TODO: update brush when children update
	        return _react2.default.cloneElement(brushItem, {
	          onChange: (0, _DataUtils.combineEventHandlers)(this.handleBrushChange, null, brushItem.props.onChange),
	          data: data,
	          x: offset.left,
	          y: offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	          width: offset.width,
	          startIndex: dataStartIndex,
	          endIndex: dataEndIndex,
	          updateId: 'brush-' + updateId
	        });
	      }
	    }, {
	      key: 'renderReferenceElements',
	      value: function renderReferenceElements(isFront, Compt) {
	        var children = this.props.children;
	
	        var elements = (0, _ReactUtils.findAllByType)(children, Compt);
	
	        if (!elements || !elements.length) {
	          return null;
	        }
	
	        var _state7 = this.state,
	            xAxisMap = _state7.xAxisMap,
	            yAxisMap = _state7.yAxisMap,
	            offset = _state7.offset;
	
	        var keyPrefix = (0, _ReactUtils.getDisplayName)(Compt) + '-' + (isFront ? 'front' : 'back');
	
	        return elements.filter(function (entry) {
	          return isFront === entry.props.isFront;
	        }).map(function (entry, i) {
	          var _entry$props = entry.props,
	              xAxisId = _entry$props.xAxisId,
	              yAxisId = _entry$props.yAxisId;
	
	
	          return _react2.default.cloneElement(entry, {
	            key: keyPrefix + '-' + i,
	            xAxis: xAxisMap[xAxisId],
	            yAxis: yAxisMap[yAxisId],
	            viewBox: {
	              x: offset.left,
	              y: offset.top,
	              width: offset.width,
	              height: offset.height
	            }
	          });
	        });
	      }
	    }, {
	      key: 'renderChart',
	      value: function renderChart() {
	        var _props7 = this.props,
	            children = _props7.children,
	            width = _props7.width,
	            height = _props7.height,
	            others = _objectWithoutProperties(_props7, ['children', 'width', 'height']);
	
	        var _state8 = this.state,
	            xAxisMap = _state8.xAxisMap,
	            yAxisMap = _state8.yAxisMap;
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	        return _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderGrid(),
	          this.renderReferenceElements(false, _ReferenceArea2.default),
	          this.renderReferenceElements(false, _ReferenceLine2.default),
	          this.renderReferenceElements(false, _ReferenceDot2.default),
	          this.renderAxes(xAxisMap, 'x-axis'),
	          this.renderAxes(yAxisMap, 'y-axis'),
	          _react2.default.createElement(ChartComponent, _extends({}, this.props, this.state)),
	          this.renderReferenceElements(true, _ReferenceArea2.default),
	          this.renderReferenceElements(true, _ReferenceLine2.default),
	          this.renderReferenceElements(true, _ReferenceDot2.default),
	          this.renderBrush(),
	          (0, _ReactUtils.filterSvgElements)(children)
	        );
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var data = this.props.data;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this) || !data || !data.length) {
	          return null;
	        }
	
	        var _props8 = this.props,
	            className = _props8.className,
	            width = _props8.width,
	            height = _props8.height,
	            style = _props8.style,
	            compact = _props8.compact;
	
	
	        var events = {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onClick: this.handleClick,
	          onMouseDown: this.handleMouseDown,
	          onMouseUp: this.handleMouseUp,
	          onTouchMove: this.handleTouchMove
	        };
	
	        // The "compact" mode is mainly used as the panorama within Brush
	        if (compact) {
	          return this.renderChart();
	        }
	
	        return _react2.default.createElement(
	          'div',
	          _extends({
	            className: (0, _classnames2.default)('recharts-wrapper', className),
	            style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	          }, events, {
	            ref: function ref(node) {
	              _this3.container = node;
	            }
	          }),
	          this.renderChart(),
	          this.renderLegend(),
	          this.renderTooltip()
	        );
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component), _class.displayName = (0, _ReactUtils.getDisplayName)(ChartComponent), _class.propTypes = _extends({}, ChartComponent.propTypes, {
	    syncId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    compact: _propTypes2.default.bool,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes2.default.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes2.default.number,
	    margin: _propTypes2.default.shape({
	      top: _propTypes2.default.number,
	      right: _propTypes2.default.number,
	      bottom: _propTypes2.default.number,
	      left: _propTypes2.default.number
	    }),
	    style: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    onClick: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseMove: _propTypes2.default.func
	  }), _class.defaultProps = {
	    layout: 'horizontal',
	    stackOffset: 'none',
	    margin: { top: 5, right: 5, bottom: 5, left: 5 }
	  }, _temp);
	
	
	  return CategoricalChartWrapper;
	};
	
	exports.default = generateCategoricalChart;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getTicksOfScale = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.getDomainOfStackGroups = exports.getDomainOfDataByKey = exports.calculateDomainOfTicks = exports.getStackedDataOfItem = exports.getStackGroupsByAxisId = exports.getStackedData = exports.detectReferenceElementsDomain = exports.offsetSign = undefined;
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(27);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rechartsScale = __webpack_require__(645);
	
	var _d3Shape = __webpack_require__(240);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DataUtils = __webpack_require__(16);
	
	var _ReferenceDot = __webpack_require__(198);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceLine = __webpack_require__(199);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceArea = __webpack_require__(197);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _Legend = __webpack_require__(92);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-param-reassign: 0 */
	var offsetSign = exports.offsetSign = function offsetSign(series) {
	  var n = series.length;
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = isNaN(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	    }
	  }
	};
	
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var detectReferenceElementsDomain = exports.detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine2.default);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot2.default);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea2.default);
	  var idKey = axisType + 'Id';
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    (function () {
	      var key1 = valueKey + '1';
	      var key2 = valueKey + '2';
	
	      finalDomain = areas.reduce(function (result, el) {
	        if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	          var value1 = el.props[key1];
	          var value2 = el.props[key2];
	
	          return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	        }
	        return result;
	      }, finalDomain);
	    })();
	  }
	
	  return finalDomain;
	};
	
	var getStackedData = exports.getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +(0, _DataUtils.getValueByDataKey)(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	
	  return stack(data);
	};
	
	var getStackGroupsByAxisId = exports.getStackGroupsByAxisId = function getStackGroupsByAxisId(data, items, numericAxisId, cateAxisId, offsetType) {
	  var stackGroups = items.reduce(function (result, item) {
	    var stackId = item.props.stackId;
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || { hasStack: false, stackGroups: {} };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: []
	      };
	
	      childGroup.items = [item].concat(childGroup.items);
	
	      parentGroup.hasStack = true;
	
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: [item]
	      };
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	
	        return _extends({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	
	var getStackedDataOfItem = exports.getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	var calculateDomainOfTicks = exports.calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	  }
	
	  return ticks;
	};
	
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	var getDomainOfDataByKey = exports.getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = data.reduce(function (result, entry) {
	    var value = (0, _DataUtils.getValueByDataKey)(entry, key);
	
	    if ((0, _isArray3.default)(value)) {
	      return [].concat(_toConsumableArray(result), _toConsumableArray(value));
	    }
	
	    return [].concat(_toConsumableArray(result), [value]);
	  }, []);
	
	  if (type === 'number') {
	    var domain = flattenData.filter(_DataUtils.isNumber);
	
	    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil3.default)(entry);
	  }) : flattenData;
	
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [Math.min.apply(null, entry.concat([result[0]]).filter(_DataUtils.isNumber)), Math.max.apply(null, entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = exports.getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	var getDomainOfItemsWithSameAxis = exports.getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    return getDomainOfDataByKey(data, item.props.dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {};
	  // Get the union set of category axis
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	
	        result.push(entry[i]);
	      }
	    }
	    return result;
	  }, []);
	};
	
	var isCategorialAxis = exports.isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis';
	};
	/**
	* Calculate the Coordinates of grid
	* @param  {Array} ticks The ticks in axis
	* @param {Number} min   The minimun value of axis
	* @param {Number} max   The maximun value of axis
	* @return {Array}       Coordinates
	*/
	var getCoordinatesOfGrid = exports.getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin = void 0,
	      hasMax = void 0;
	
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	var getTicksOfAxis = exports.getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type;
	
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
	
	  // The ticks setted by user should only affect the ticks adjacent to axis line
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return { coordinate: scale(entry) + offset, value: entry };
	    });
	  }
	
	  // When axis has duplicated text, serial numbers are used to generate scale
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index
	    };
	  });
	};
	
	var calculateActiveTickIndex = exports.calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    for (var i = 0; i < len; i++) {
	      if (i === 0 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i > 0 && i < len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i === len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2) {
	        index = ticks[i].index;
	        break;
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	var getMainColorOfGraphicItem = exports.getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var result = void 0;
	
	  switch (displayName) {
	    case 'Line':
	    case 'Area':
	      result = item.props.stroke;
	      break;
	    default:
	      result = item.props.fill;
	      break;
	  }
	
	  return result;
	};
	
	var getLegendProps = exports.getLegendProps = function getLegendProps(children, graphicItems, width) {
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData = legendItem.props && legendItem.props.payload || graphicItems.map(function (child) {
	    var _child$props = child.props,
	        dataKey = _child$props.dataKey,
	        name = _child$props.name,
	        legendType = _child$props.legendType;
	
	
	    return {
	      dataKey: dataKey,
	      type: legendItem.props.iconType || legendType || 'square',
	      color: getMainColorOfGraphicItem(child),
	      value: name || dataKey,
	      payload: child.props
	    };
	  });
	
	  return _extends({}, legendItem.props, _Legend2.default.getWithHeight(legendItem, width), {
	    payload: legendData
	  });
	};
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	var getTicksOfScale = exports.getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	
	
	  if (opts.scale !== 'auto' && opts.scale !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	
	    return { niceTicks: tickValues };
	  } else if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return { niceTicks: _tickValues };
	  }
	
	  return null;
	};
	
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	var getBarSizeList = exports.getBarSizeList = function getBarSizeList(_ref) {
	  var globalSize = _ref.barSize,
	      _ref$stackGroups = _ref.stackGroups,
	      stackGroups = _ref$stackGroups === undefined ? {} : _ref$stackGroups;
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	
	
	      var barItems = items.filter(function (item) {
	        return item.type.displayName === 'Bar';
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil3.default)(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	var getBarPosition = exports.getBarPosition = function getBarPosition(_ref2) {
	  var barGap = _ref2.barGap,
	      barCategoryGap = _ref2.barCategoryGap,
	      bandSize = _ref2.bandSize,
	      _ref2$sizeList = _ref2.sizeList,
	      sizeList = _ref2$sizeList === undefined ? [] : _ref2$sizeList,
	      maxBarSize = _ref2.maxBarSize;
	
	  var len = sizeList.length;
	  if (len < 1) return null;
	
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result = void 0;
	
	  // whether or not is barSize setted by user
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    (function () {
	      var useFull = false;
	      var fullBarSize = bandSize / len;
	      var sum = sizeList.reduce(function (res, entry) {
	        return res + entry.barSize || 0;
	      }, 0);
	      sum += (len - 1) * realBarGap;
	
	      if (sum >= bandSize) {
	        sum -= (len - 1) * realBarGap;
	        realBarGap = 0;
	      }
	      if (sum >= bandSize && fullBarSize > 0) {
	        useFull = true;
	        fullBarSize *= 0.9;
	        sum = len * fullBarSize;
	      }
	
	      var offset = (bandSize - sum) / 2 >> 0;
	      var prev = { offset: offset - realBarGap, size: 0 };
	
	      result = sizeList.reduce(function (res, entry) {
	        var newRes = [].concat(_toConsumableArray(res), [{
	          item: entry.item,
	          position: {
	            offset: prev.offset + prev.size + realBarGap,
	            size: useFull ? fullBarSize : entry.barSize
	          }
	        }]);
	
	        prev = newRes[newRes.length - 1].position;
	
	        if (entry.stackList && entry.stackList.length) {
	          entry.stackList.forEach(function (item) {
	            newRes.push({ item: item, position: prev });
	          });
	        }
	        return newRes;
	      }, []);
	    })();
	  } else {
	    (function () {
	      var offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	      if (bandSize - 2 * offset - (len - 1) * realBarGap <= 0) {
	        realBarGap = 0;
	      }
	
	      var originalSize = (bandSize - 2 * offset - (len - 1) * realBarGap) / len;
	      if (originalSize > 1) {
	        originalSize >>= 0;
	      }
	      var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	
	      result = sizeList.reduce(function (res, entry, i) {
	        var newRes = [].concat(_toConsumableArray(res), [{
	          item: entry.item,
	          position: {
	            offset: offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	            size: size
	          }
	        }]);
	
	        if (entry.stackList && entry.stackList.length) {
	          entry.stackList.forEach(function (item) {
	            newRes.push({ item: item, position: newRes[newRes.length - 1].position });
	          });
	        }
	        return newRes;
	      }, []);
	    })();
	  }
	
	  return result;
	};
	
	var appendOffsetOfLegend = exports.appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps(children, items, legendWidth, legendHeight);
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _extends({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _extends({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};

/***/ },
/* 202 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 203 */
[1678, 1618, 1619, 1620, 1621, 1622],
/* 204 */
[1689, 329],
/* 205 */
[1717, 1615],
/* 206 */
[1742, 95],
/* 207 */
[1749, 122],
/* 208 */
[1755, 20, 331],
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(1597);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 210 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(709);

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(42);
	var normalizeHeaderName = __webpack_require__(723);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(338);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(338);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)))

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Dependencies
	
	
	var Confirm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Confirm, _React$Component);
	
	  function Confirm() {
	    _classCallCheck(this, Confirm);
	
	    var _this = _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call(this));
	
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    _this.confirmKey = _this.confirmKey.bind(_this);
	    _this.confirmDialog = _this.confirmDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(Confirm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('keydown', this.confirmKey, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.confirmKey, false);
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'confirmKey',
	    value: function confirmKey(e) {
	      if (e.keyCode && (e.keyCode === 13 || e.keyCode === 32)) {
	        this.confirmDialog(e);
	      } else if (e.keyCode && e.keyCode === 27) {
	        this.closeDialog(e);
	      }
	    }
	  }, {
	    key: 'confirmDialog',
	    value: function confirmDialog(e) {
	      if (e) {
	        e.preventDefault();
	      }
	      this.props.store.SessionStore.confirmFunc();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog dialog--confirm' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dialog__content' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'dialog__msg', tabIndex: '0' },
	            SessionStore.confirmContent.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            SessionStore.confirmContent.body
	          ),
	          SessionStore.confirmContent.data && _react2.default.createElement('ul', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(SessionStore.confirmContent.data) } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'dialog__btns' },
	            _react2.default.createElement(
	              'a',
	              {
	                href: '#app',
	                className: 'btn btn--outline',
	                onClick: function onClick(e) {
	                  return _this2.closeDialog(e);
	                }
	              },
	              SessionStore.confirmContent.cancel ? SessionStore.confirmContent.cancel : 'Cancel'
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                href: '#app',
	                className: 'btn',
	                onClick: function onClick(e) {
	                  return _this2.confirmDialog(e);
	                }
	              },
	              SessionStore.confirmContent.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Confirm;
	}(_react2.default.Component));
	
	exports.default = Confirm;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(15);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var Notification = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Notification, _React$Component);
	
	  function Notification() {
	    _classCallCheck(this, Notification);
	
	    var _this2 = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this));
	
	    _this2.autoClose = _this2.autoClose.bind(_this2);
	    _this2.closeNotification = _this2.closeNotification.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Notification, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        closing: false
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      this.autoClose();
	
	      var notify = document.querySelector('.notify');
	
	      // Delay close if hovered
	      notify.addEventListener('mouseenter', function () {
	        clearTimeout(_this.closeTimer);
	      });
	
	      // Restart close timer on mouse leave
	      notify.addEventListener('mouseleave', function () {
	        _this.autoClose();
	      });
	    }
	  }, {
	    key: 'autoClose',
	    value: function autoClose() {
	      var notificationDuration = this.props.store.SessionStore.notificationDuration;
	
	
	      var _this = this;
	
	      this.closeTimer = setTimeout(function () {
	        _this.closeNotification();
	      }, notificationDuration);
	    }
	  }, {
	    key: 'closeNotification',
	    value: function closeNotification(e) {
	      if (e) {
	        e.preventDefault();
	
	        if (e.target.href) {
	          this.props.router.push(e.target.href.replace('#/', ''));
	        }
	      }
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.setState({
	        closing: true
	      });
	
	      clearTimeout(this.closeTimer);
	
	      // Wait for animation to finish before removing
	      setTimeout(function () {
	        SessionStore.closeNotification();
	      }, 250);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: '\n          notify\n          ' + (this.state.closing ? 'notify--closing' : '') + '\n          ' + SessionStore.notificationClass + '\n        '
	        },
	        SessionStore.notificationLink && _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            className: 'notify__msg',
	            to: SessionStore.notificationLink,
	            onClick: function onClick(e) {
	              return _this3.closeNotification(e);
	            }
	          },
	          SessionStore.notificationContent
	        ),
	        !SessionStore.notificationLink && _react2.default.createElement(
	          'span',
	          { className: 'notify__msg' },
	          SessionStore.notificationContent
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: '#app',
	            className: 'notify__close',
	            onClick: function onClick(e) {
	              return _this3.closeNotification(e);
	            }
	          },
	          _react2.default.createElement(icons.iconTimes, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            'Close'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Notification;
	}(_react2.default.Component));
	
	exports.default = Notification;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var Privacy = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Privacy, _React$Component);
	
	  function Privacy() {
	    _classCallCheck(this, Privacy);
	
	    var _this = _possibleConstructorReturn(this, (Privacy.__proto__ || Object.getPrototypeOf(Privacy)).call(this));
	
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Privacy, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        reveal: false
	      };
	    }
	  }, {
	    key: 'privatize',
	    value: function privatize() {
	      var masked = '';
	
	      for (var i = 0; i < this.props.private.length; i++) {
	        masked += '•';
	      }
	
	      return masked;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        reveal: !this.state.reveal
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        {
	          className: '\n          privacy\n          ' + (this.props.className ? this.props.className : '') + '\n          ' + (this.state.reveal ? 'reveal' : '') + '\n        '
	        },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'privacy__toggle privacy__show',
	            onClick: this.toggle,
	            type: 'button',
	            title: this.props.show
	          },
	          _react2.default.createElement(icons.iconEye, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            this.props.show
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'privacy__toggle privacy__hide',
	            onClick: this.toggle,
	            type: 'button',
	            title: this.props.hide
	          },
	          _react2.default.createElement(icons.iconEyeSlash, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            this.props.hide
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'privacy__show' },
	          this.privatize()
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'privacy__hide' },
	          this.props.private
	        )
	      );
	    }
	  }]);
	
	  return Privacy;
	}(_react2.default.Component));
	
	exports.default = Privacy;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	var Prompt = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    var _this2 = _possibleConstructorReturn(this, (Prompt.__proto__ || Object.getPrototypeOf(Prompt)).call(this));
	
	    _this2.closeDialog = _this2.closeDialog.bind(_this2);
	    _this2.confirmDialog = _this2.confirmDialog.bind(_this2);
	    _this2.handleOption = _this2.handleOption.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	
	    _this2.state = {
	      reason: null,
	      memo: null
	    };
	    return _this2;
	  }
	
	  _createClass(Prompt, [{
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'confirmDialog',
	    value: function confirmDialog(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.store.SessionStore.promptFunc();
	    }
	  }, {
	    key: 'handleOption',
	    value: function handleOption() {
	      this.setState({
	        reason: this.option.value
	      });
	
	      // Set the cancellation memo to the option selected or null if it’s other
	      if (this.option.value !== 'other') {
	        this.setState({
	          memo: this.option.value
	        });
	      } else {
	        this.setState({
	          memo: null
	        });
	      }
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      // Cancel session reason
	      if (this.memo) {
	        this.setState({
	          memo: this.memo.value || null
	        });
	      }
	
	      // Export CSV prompt
	      if (this.title) {
	        this.props.store.ReportStore.reportExportTitle = this.title.value;
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      this.props.store.SessionStore.promptSelectFunc(this.state.memo);
	
	      var _this = this;
	      setTimeout(function () {
	        _this.props.store.SessionStore.promptFunc();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog dialog--confirm' },
	        _react2.default.createElement(
	          'form',
	          { className: 'dialog__content', onSubmit: function onSubmit(e) {
	              return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	            }, noValidate: true },
	          _react2.default.createElement(
	            'strong',
	            { className: 'dialog__msg', tabIndex: '0' },
	            SessionStore.promptContent.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            SessionStore.promptContent.body
	          ),
	          SessionStore.promptContent.options && _react2.default.createElement(
	            'label',
	            { className: 'select dialog__select', htmlFor: 'prompt-options' },
	            _react2.default.createElement(
	              'select',
	              {
	                id: 'prompt-options',
	                onChange: this.handleOption,
	                ref: function ref(input) {
	                  _this3.option = input;
	                }
	              },
	              SessionStore.promptContent.options.map(function (option, i) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: i, value: option.value },
	                  option.label
	                );
	              })
	            )
	          ),
	          (!SessionStore.promptContent.options || this.state.reason === 'other') && !SessionStore.promptContent.input && _react2.default.createElement('textarea', {
	            id: 'prompt-other',
	            className: 'dialog__input',
	            ref: function ref(input) {
	              _this3.memo = input;
	            },
	            onChange: this.handleInput,
	            required: true,
	            'aria-required': 'true'
	          }),
	          SessionStore.promptContent.input && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'prompt-input' },
	              SessionStore.promptContent.input
	            ),
	            _react2.default.createElement('input', {
	              type: 'text',
	              id: 'prompt-input',
	              className: 'dialog__input',
	              defaultValue: SessionStore.promptText,
	              ref: function ref(input) {
	                _this3.title = input;
	              },
	              onChange: this.handleInput,
	              required: true,
	              'aria-required': 'true',
	              placeholder: SessionStore.promptContent.input
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dialog__btns' },
	            _react2.default.createElement(
	              'a',
	              { href: '#app', className: 'btn btn--outline', onClick: function onClick(e) {
	                  return _this3.closeDialog(e);
	                } },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                disabled: !this.state.memo && !SessionStore.promptContent.input
	              },
	              SessionStore.promptContent.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Prompt;
	}(_react2.default.Component));
	
	exports.default = Prompt;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toaster = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Toaster, _React$Component);
	
	  function Toaster() {
	    _classCallCheck(this, Toaster);
	
	    var _this = _possibleConstructorReturn(this, (Toaster.__proto__ || Object.getPrototypeOf(Toaster)).call(this));
	
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(Toaster, [{
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'toaster ' + SessionStore.toasterClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'p',
	            null,
	            SessionStore.toasterContent.body
	          )
	        )
	      );
	    }
	  }]);
	
	  return Toaster;
	}(_react2.default.Component));
	
	exports.default = Toaster;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var ExamAttachmentsList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamAttachmentsList, _React$Component);
	
	  function ExamAttachmentsList() {
	    _classCallCheck(this, ExamAttachmentsList);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (ExamAttachmentsList.__proto__ || Object.getPrototypeOf(ExamAttachmentsList)).call(this));
	
	    _this.deleteFile = _this.deleteFile.bind(_this);
	    _this.getExamFile = _this.getExamFile.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExamAttachmentsList, [{
	    key: 'extension',
	    value: function extension(filename) {
	      var ext = filename.substr(filename.lastIndexOf('.') + 1);
	
	      switch (ext) {
	        case 'bmp':
	        case 'jpg':
	        case 'jpeg':
	        case 'png':
	        case 'gif':
	          return _react2.default.createElement(icons.icon_image, null);
	
	        case 'pdf':
	          return _react2.default.createElement(icons.icon_pdf, null);
	
	        case 'doc':
	        case 'docx':
	        case 'txt':
	        case 'rtf':
	          return _react2.default.createElement(icons.icon_text, null);
	
	        case 'xls':
	        case 'xlsx':
	        case 'csv':
	          return _react2.default.createElement(icons.icon_spreadsheet, null);
	
	        case 'wma':
	        case 'mpg':
	        case 'avi':
	        case 'flv':
	          return _react2.default.createElement(icons.icon_video, null);
	
	        case 'mp3':
	        case 'ogg':
	        case 'wav':
	        case 'midi':
	          return _react2.default.createElement(icons.icon_audio, null);
	
	        case 'zip':
	        case 'gz':
	        case 'iso':
	          return _react2.default.createElement(icons.icon_zip, null);
	
	        default:
	          return _react2.default.createElement(icons.icon_file, null);
	      }
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile(file, index, type) {
	      var _this2 = this;
	
	      var _props = this.props,
	          exam = _props.exam,
	          translation = _props.translation;
	      var ExamStore = this.props.store.ExamStore;
	
	      var data = null;
	
	      var msg = {
	        heading: translation.delete_confirm.heading + ' ' + file + '?',
	        body: translation.delete_confirm.body,
	        button: translation.delete_confirm.button
	      };
	
	      if (type === 'written') {
	        msg.body = translation.delete_confirm.body_written;
	
	        data = {
	          examFiles: [file]
	        };
	      } else {
	        data = {
	          attachments: [file]
	        };
	      }
	
	      if (type !== 'written') {
	        (0, _helpers.confirm)(msg, function () {
	          ExamStore.deleteExamAttachments(exam.sid, exam.configuration.sid, data, function () {
	            return _this2.removeFile(index, type);
	          });
	        });
	      } else {
	        (0, _helpers.confirm)(msg, function () {
	          ExamStore.deleteExamAttachments(exam.sid, exam.configuration.sid, data, function () {
	            return _this2.removeFile(index, type);
	          });
	        });
	      }
	    }
	  }, {
	    key: 'removeFile',
	    value: function removeFile(index, type) {
	      if (type !== 'written') {
	        this.props.exam.configuration.attachments.splice(index, 1);
	      } else {
	        this.props.exam.configuration.examFiles.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'getExamFile',
	    value: function getExamFile(fileName) {
	      var ExamStore = this.props.store.ExamStore;
	      var _props2 = this.props,
	          exam = _props2.exam,
	          installSid = _props2.installSid;
	
	      var backgroundLoad = false;
	
	      if (this.props.overview) {
	        backgroundLoad = true;
	      }
	
	      ExamStore.getExamFile(exam.configuration.sid, fileName, installSid, backgroundLoad);
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults(panel) {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          customConfiguration = _props3.customConfiguration,
	          exam = _props3.exam,
	          translation = _props3.translation;
	
	
	      var configuration = exam.configuration;
	
	      // If this is a custom configuration, use that data
	      if (customConfiguration) {
	        configuration = customConfiguration;
	      }
	
	      // Determine whether to use attachments or examFiles
	      var files = null;
	      var type = null;
	
	      if (exam.type.toLowerCase() !== 'written') {
	        files = configuration.attachments;
	        type = 'online';
	      } else {
	        files = configuration.examFiles;
	        type = 'written';
	      }
	
	      if (files && files.length > 0) {
	        return _react2.default.createElement(
	          'ul',
	          { className: 'files ' + (panel ? 'panel__files' : '') },
	          files.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              type === 'online' && _react2.default.createElement(
	                'a',
	                {
	                  className: 'files__title',
	                  href: key.attachmentUrl,
	                  target: '_blank'
	                },
	                _this3.extension(key.attachmentAwsTitle),
	                key.attachmentAwsTitle
	              ),
	              type === 'written' && _react2.default.createElement(
	                'button',
	                {
	                  className: 'files__title btn--link',
	                  href: '#',
	                  onClick: function onClick() {
	                    return _this3.getExamFile(key.attachmentAwsTitle);
	                  }
	                },
	                _this3.extension(key.attachmentAwsTitle),
	                key.attachmentAwsTitle
	              ),
	              !_this3.props.sessionManager && !_this3.props.hideDelete && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--remove',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this3.deleteFile(key.attachmentAwsTitle, i, type);
	                  }
	                },
	                _react2.default.createElement(icons.iconMinus, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.remove,
	                  ' ',
	                  key.attachmentAwsTitle
	                )
	              )
	            );
	          })
	        );
	      } else if (panel) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          exam.type.toLowerCase() !== 'written' && translation.no_results,
	          exam.type.toLowerCase() === 'written' && translation.no_results_written
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          exam.type.toLowerCase() !== 'written' && translation.no_results,
	          exam.type.toLowerCase() === 'written' && translation.no_results_written
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          exam = _props4.exam,
	          overview = _props4.overview,
	          translation = _props4.translation;
	
	
	      if (!overview) {
	        return _react2.default.createElement(
	          'section',
	          { className: 'panel__section' },
	          !this.props.sessionManager && !this.props.hideTitle && _react2.default.createElement(
	            'h2',
	            { className: 'panel__heading' },
	            exam.type.toLowerCase() !== 'written' && translation.heading,
	            exam.type.toLowerCase() === 'written' && translation.heading_written
	          ),
	          this.props.sessionManager && !this.props.hideTitle && _react2.default.createElement(
	            'h4',
	            { className: 'data-heading' },
	            exam.type.toLowerCase() !== 'written' && translation.heading,
	            exam.type.toLowerCase() === 'written' && translation.heading_written
	          ),
	          this.renderResults(true)
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.renderResults(false)
	        );
	      }
	    }
	  }]);
	
	  return ExamAttachmentsList;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamAttachmentsList')(ExamAttachmentsList);

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var PermittedItems = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PermittedItems, _React$Component);
	
	  function PermittedItems() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PermittedItems);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PermittedItems.__proto__ || Object.getPrototypeOf(PermittedItems)).call.apply(_ref, [this].concat(args))), _this), _this.renderCalculator = function (calculatorType) {
	      var SessionStore = _this.props.store.SessionStore;
	
	
	      SessionStore.calculator = calculatorType;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PermittedItems, [{
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this2 = this;
	
	      var _props = this.props,
	          configuration = _props.configuration,
	          exam = _props.exam,
	          pushLeft = _props.pushLeft,
	          translation = _props.translation;
	      var examSession = exam.examSession;
	
	
	      var className = '';
	
	      if (!pushLeft) {
	        className = 'tooltip tooltip--right';
	      } else {
	        className = 'tooltip';
	      }
	
	      return [_react2.default.createElement(
	        'strong',
	        { key: 0, className: this.props.compact ? '' : 'subtitle' },
	        translation.allowed_items
	      ), _react2.default.createElement(
	        'ul',
	        { key: 1, className: 'data--comma' },
	        configuration.permittedBathroomBreak && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            configuration.permittedBathroomBreakInformation && {
	              'aria-describedby': 'bathroom-tooltip'
	            },
	            translation.bathroomBreak,
	            configuration.permittedBathroomBreakInformation && _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'bathroom-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                configuration.permittedBathroomBreakInformation
	              )
	            )
	          )
	        ),
	        configuration.permittedBlankPaper && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            configuration.permittedBlankPaperInformation && {
	              'aria-describedby': 'paper-tooltip'
	            },
	            translation.blankPaper,
	            configuration.permittedBlankPaperInformation && _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'paper-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                configuration.permittedBlankPaperInformation
	              )
	            )
	          )
	        ),
	        configuration.permittedCalculator && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            configuration.permittedCalculatorInformation && {
	              'aria-describedby': 'calculator-tooltip'
	            },
	            translation.calculator,
	            configuration.permittedCalculatorInformation && _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'calculator-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                configuration.permittedCalculatorInformation
	              )
	            ),
	            ' ',
	            configuration.virtualCalculatorType && examSession && (examSession.status === 'Needs Proctor' || examSession.status === 'Scheduled' && examSession.location && (examSession.location.workflowModule === 'automated' || examSession.location.workflowModule === 'hybrid' || examSession.location.workflowModule === 'hybrid-scheduling')) && _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--link',
	                onClick: function onClick() {
	                  return _this2.renderCalculator(configuration.virtualCalculatorType);
	                },
	                type: 'button'
	              },
	              translation.test_calculator
	            )
	          )
	        ),
	        configuration.permittedDictionary && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            configuration.permittedDictionaryInformation && {
	              'aria-describedby': 'dictionary-tooltip'
	            },
	            translation.dictionary,
	            configuration.permittedDictionaryInformation && _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'dictionary-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                configuration.permittedDictionaryInformation
	              )
	            )
	          )
	        ),
	        configuration.permittedEarplugs && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            configuration.permittedEarplugsInformation && {
	              'aria-describedby': 'earplugs-tooltip'
	            },
	            translation.earplugs,
	            configuration.permittedEarplugsInformation && _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'earplugs-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                configuration.permittedEarplugsInformation
	              )
	            )
	          )
	        ),
	        configuration.permittedFormulaSheet && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            configuration.permittedFormulaSheetInformation && {
	              'aria-describedby': 'formula-tooltip'
	            },
	            translation.formulaSheet,
	            configuration.permittedFormulaSheetInformation && _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'formula-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                configuration.permittedFormulaSheetInformation
	              )
	            )
	          )
	        ),
	        configuration.permittedNotes && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            configuration.permittedNotesInformation && {
	              'aria-describedby': 'notes-tooltip'
	            },
	            translation.notes,
	            configuration.permittedNotesInformation && _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'notes-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                configuration.permittedNotesInformation
	              )
	            )
	          )
	        ),
	        configuration.permittedTextbook && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            configuration.permittedTextbookInformation && {
	              'aria-describedby': 'textbook-tooltip'
	            },
	            translation.textbook,
	            configuration.permittedTextbookInformation && _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'textbook-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                configuration.permittedTextbookInformation
	              )
	            )
	          )
	        ),
	        configuration.permittedWebsites && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'span',
	            configuration.permittedWebsitesInformation && {
	              'aria-describedby': 'website-tooltip'
	            },
	            translation.websites,
	            configuration.permittedWebsitesInformation && _react2.default.createElement(
	              'div',
	              { className: className },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'website-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                configuration.permittedWebsitesInformation
	              )
	            )
	          )
	        ),
	        configuration.permittedOtherItems && _react2.default.createElement(
	          'li',
	          { className: 'allow-wrap' },
	          _react2.default.createElement(
	            'span',
	            null,
	            configuration.permittedOtherItems
	          )
	        )
	      )];
	    }
	  }, {
	    key: 'renderDashboardItems',
	    value: function renderDashboardItems() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          configuration = _props2.configuration,
	          exam = _props2.exam,
	          pushLeft = _props2.pushLeft,
	          translation = _props2.translation;
	      var examSession = exam.examSession;
	
	
	      var className = '';
	
	      if (!pushLeft) {
	        className = 'tooltip tooltip--right';
	      } else {
	        className = 'tooltip';
	      }
	
	      return [_react2.default.createElement(
	        'strong',
	        { key: 0, className: 'panel__heading ' + (this.props.compact ? '' : 'strong-bold') },
	        _react2.default.createElement(
	          'span',
	          null,
	          translation.allowed_items
	        )
	      ), _react2.default.createElement(
	        'div',
	        { id: 'permitted-items-panel' },
	        _react2.default.createElement(
	          'ul',
	          { key: 1, className: 'data__list--flex' },
	          configuration.permittedBathroomBreak && _react2.default.createElement(
	            'li',
	            { className: 'data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.bathroomBreak
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                  'p',
	                  { id: 'bathroom-tooltip' },
	                  configuration.permittedBathroomBreakInformation || translation.bathroomBreakInfo
	                )
	              )
	            )
	          ),
	          configuration.permittedBlankPaper && _react2.default.createElement(
	            'li',
	            { className: 'data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.blankPaper
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                  'p',
	                  { id: 'paper-tooltip' },
	                  configuration.permittedBlankPaperInformation || translation.blankPaperInfo
	                )
	              )
	            )
	          ),
	          configuration.permittedCalculator && _react2.default.createElement(
	            'li',
	            { className: 'data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.calculator
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                  'p',
	                  { id: 'calculator-tooltip' },
	                  configuration.permittedCalculatorInformation || translation.calculatorInfo
	                )
	              ),
	              configuration.virtualCalculatorType && examSession && (examSession.status === 'Needs Proctor' || examSession.status === 'Scheduled' && examSession.location && (examSession.location.workflowModule === 'automated' || examSession.location.workflowModule === 'hybrid' || examSession.location.workflowModule === 'hybrid-scheduling')) && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--link',
	                  onClick: function onClick() {
	                    return _this3.renderCalculator(configuration.virtualCalculatorType);
	                  },
	                  type: 'button'
	                },
	                translation.test_calculator
	              )
	            )
	          ),
	          configuration.permittedDictionary && _react2.default.createElement(
	            'li',
	            { className: 'data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.dictionary
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                  'p',
	                  { id: 'dictionary-tooltip' },
	                  configuration.permittedDictionaryInformation || translation.dictionaryInfo
	                )
	              )
	            )
	          ),
	          configuration.permittedEarplugs && _react2.default.createElement(
	            'li',
	            { className: 'data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.earplugs
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                  'p',
	                  { id: 'earplugs-tooltip' },
	                  configuration.permittedEarplugsInformation || translation.earplugInfo
	                )
	              )
	            )
	          ),
	          configuration.permittedFormulaSheet && _react2.default.createElement(
	            'li',
	            { className: 'data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.formulaSheet
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                  'p',
	                  { id: 'formula-tooltip' },
	                  configuration.permittedFormulaSheetInformation || translation.formulaSheetInfo
	                )
	              )
	            )
	          ),
	          configuration.permittedNotes && _react2.default.createElement(
	            'li',
	            { className: 'data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.notes
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                  'div',
	                  { id: 'notes-tooltip' },
	                  configuration.permittedNotesInformation || translation.notesInfo
	                )
	              )
	            )
	          ),
	          configuration.permittedTextbook && _react2.default.createElement(
	            'li',
	            { className: 'data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.textbook
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                  'div',
	                  { id: 'textbook-tooltip' },
	                  configuration.permittedTextbookInformation || translation.textbookInfo
	                )
	              )
	            )
	          ),
	          configuration.permittedWebsites && _react2.default.createElement(
	            'li',
	            { className: 'data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.websites
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: className },
	                _react2.default.createElement(
	                  'div',
	                  { id: 'website-tooltip' },
	                  configuration.permittedWebsitesInformation || translation.websiteInfo
	                )
	              )
	            )
	          ),
	          configuration.permittedOtherItems && _react2.default.createElement(
	            'li',
	            { className: 'allow-wrap data__list-item--flex' },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.otherItems
	              ),
	              configuration.permittedOtherItems && _react2.default.createElement(
	                'div',
	                { className: className },
	                configuration.permittedOtherItems
	              )
	            )
	          )
	        )
	      )];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          configuration = _props3.configuration,
	          listItem = _props3.listItem,
	          dashboardView = _props3.dashboardView;
	
	
	      if (configuration.permittedBathroomBreak || configuration.permittedBlankPaper || configuration.permittedCalculator || configuration.permittedDictionary || configuration.permittedEarplugs || configuration.permittedFormulaSheet || configuration.permittedNotes || configuration.permittedTextbook || configuration.permittedWebsites || configuration.permittedOtherItems) {
	        if (listItem) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'data__list--full-width' },
	            dashboardView ? this.renderDashboardItems() : this.renderItems()
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            this.renderItems()
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return PermittedItems;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PermittedItems')(PermittedItems);

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(56);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _browserUpdate = __webpack_require__(400);
	
	var _browserUpdate2 = _interopRequireDefault(_browserUpdate);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Step = __webpack_require__(65);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _Example = __webpack_require__(838);
	
	var _Example2 = _interopRequireDefault(_Example);
	
	var _Intro = __webpack_require__(840);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _DesktopApp = __webpack_require__(837);
	
	var _DesktopApp2 = _interopRequireDefault(_DesktopApp);
	
	var _Consent = __webpack_require__(836);
	
	var _Consent2 = _interopRequireDefault(_Consent);
	
	var _SystemCheck = __webpack_require__(846);
	
	var _SystemCheck2 = _interopRequireDefault(_SystemCheck);
	
	var _ShareScreen = __webpack_require__(845);
	
	var _ShareScreen2 = _interopRequireDefault(_ShareScreen);
	
	var _IDVerification = __webpack_require__(839);
	
	var _IDVerification2 = _interopRequireDefault(_IDVerification);
	
	var _RoomScan = __webpack_require__(842);
	
	var _RoomScan2 = _interopRequireDefault(_RoomScan);
	
	var _ProctorPause = __webpack_require__(841);
	
	var _ProctorPause2 = _interopRequireDefault(_ProctorPause);
	
	var _Begin = __webpack_require__(835);
	
	var _Begin2 = _interopRequireDefault(_Begin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*global chrome*/
	
	// Config
	
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var SessionStartAutomated = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionStartAutomated, _React$Component);
	
	  function SessionStartAutomated() {
	    _classCallCheck(this, SessionStartAutomated);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (SessionStartAutomated.__proto__ || Object.getPrototypeOf(SessionStartAutomated)).call(this));
	
	    _this2.renderSystemCheck = function (detectFace) {
	      var sessionStartData = _this2.props.store.ExamStore.sessionStartData;
	
	      var examConfiguration = sessionStartData.exam.configuration;
	
	      return _react2.default.createElement(_SystemCheck2.default, Object.assign({}, _this2.props, {
	        parent: _this2,
	        statusClass: _this2.statusClass(3),
	        nextStep: _this2.nextStep,
	        button: _this2.submit,
	        examConfiguration: examConfiguration,
	        webcam: _this2.state.webcam.deviceId,
	        microphone: _this2.state.microphone.deviceId,
	        displayCount: _this2.state.displayCount,
	        setDevice: _this2.setDevice,
	        runFaceCheck: detectFace ? true : false,
	        faceCheck: _this2.checkForFaces
	      }));
	    };
	
	    _this2.checkForExtension = _this2.checkForExtension.bind(_this2);
	    _this2.receiveMessage = _this2.receiveMessage.bind(_this2);
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.previousStep = _this2.previousStep.bind(_this2);
	    _this2.setDevice = _this2.setDevice.bind(_this2);
	    _this2.checkForFaces = _this2.checkForFaces.bind(_this2);
	    _this2.sendMessage = _this2.sendMessage.bind(_this2);
	    _this2.renderManualInstall = _this2.renderManualInstall.bind(_this2);
	    _this2.renderUnsupported = _this2.renderUnsupported.bind(_this2);
	    _this2.restartExtension = _this2.restartExtension.bind(_this2);
	    _this2.checkScreenShare = _this2.checkScreenShare.bind(_this2);
	    _this2.setupSteps = _this2.setupSteps.bind(_this2);
	    _this2.screenSharePopup = _this2.screenSharePopup.bind(_this2);
	    _this2.proctorApproved = _this2.proctorApproved.bind(_this2);
	    _this2.getSessionSyncDoc = _this2.getSessionSyncDoc.bind(_this2);
	
	    _this2.screenError = 'User canceled screen sharing dialog.';
	    _this2.screenPermissionError = 'Permission denied by system';
	    _this2.permissionsError = 'Device permissions not granted.';
	
	    // Set the initial state
	    _this2.state = {
	      late: false,
	      step: 1,
	      next: null,
	      webcam: {},
	      microphone: {},
	      displayCount: null,
	      unsupported: false,
	      unsupportedDetals: null,
	      unsupportedLink: null,
	      syncDocumentData: null,
	      checkingPermissions: false,
	      sessionInProgress: null,
	      orderedSteps: null,
	      skipProctorPause: false,
	      proctorApproved: false
	    };
	    return _this2;
	  }
	  //componentDidUpdate(prevProps, prevState, snapshot) {}
	
	
	  _createClass(SessionStartAutomated, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this3 = this;
	
	        var _this, _props, examSid, sessionSid, _props2, hybrid, translation, uninstall, _props$store, ExamStore, SessionStore, unsupported, getUserMediaSupported, modifiedDate;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this = this;
	                _props = this.props, examSid = _props.examSid, sessionSid = _props.sessionSid;
	                _props2 = this.props, hybrid = _props2.hybrid, translation = _props2.translation, uninstall = _props2.uninstall;
	                _props$store = this.props.store, ExamStore = _props$store.ExamStore, SessionStore = _props$store.SessionStore;
	                unsupported = false;
	                _context.next = 7;
	                return this.getSessionSyncDoc();
	
	              case 7:
	
	                // Adds examSid and sessionSid to session storage for exam provisioning
	                sessionStorage.setItem('examSid', examSid);
	                sessionStorage.setItem('sessionSid', sessionSid);
	
	                // Make sure drawer open class isn’t present
	                if (document.body.className.indexOf('drawer-open') > -1) {
	                  document.body.classList.remove('drawer-open');
	                }
	
	                // If we don’t have the exam session data or we are
	                // in a drawer (in which case we’re probably on the dashboard)
	                // get the session data.
	                if (!ExamStore.examSession.status || this.props.drawer) {
	                  ExamStore.examSession = {};
	
	                  if (!examSid || !sessionSid) {
	                    examSid = (0, _helpers.getParam)('examSid', window.location.href);
	                    sessionSid = (0, _helpers.getParam)('sessionSid', window.location.href);
	                  }
	
	                  ExamStore.getExamSession(examSid, sessionSid);
	                }
	
	                // Check that user has a supported browser
	                // HACK: passing huge version numbers for
	                // any browser other than Chrome, because
	                // we only support Chrome
	                (0, _browserUpdate2.default)({
	                  required: {
	                    c: 74,
	                    f: 1000,
	                    e: 1000,
	                    i: 1000,
	                    o: 1000,
	                    o_a: 1000,
	                    s: 1000,
	                    y: 1000,
	                    v: 1000,
	                    uc: 1000,
	                    ios: 1000,
	                    samsung: 1000
	                  },
	                  reminder: 0,
	                  reminderClosed: 0,
	                  noclose: true,
	                  no_permanent_hide: true,
	                  onshow: function onshow() {
	                    _this.setState({
	                      unsupported: true,
	                      unsupportedDetails: translation.unsupported_msg.browser
	                    });
	
	                    unsupported = true;
	                  }
	                });
	
	                if (navigator.userAgent.indexOf('Edg/') > -1 || navigator.userAgent.indexOf('Edge/') > -1) {
	                  _this.setState({
	                    unsupported: true,
	                    unsupportedDetails: translation.unsupported_msg.browser
	                  });
	
	                  unsupported = true;
	                }
	
	                // Get the exam start data
	                ExamStore.getSessionStart(examSid, sessionSid, hybrid, function (sessionStart) {
	                  var session = sessionStart.session;
	
	
	                  console.log('sessionStart session data:', session);
	
	                  if (session && session.status && session.status.toLowerCase() !== 'scheduled' && session.status.toLowerCase() !== 'checked in' // DMV uses this status
	                  ) {
	                      unsupported = true;
	
	                      _this3.setState({
	                        unsupported: true,
	                        unsupportedDetails: translation.unsupported_msg.session_closed
	                      });
	                    }
	
	                  // Make sure the chrome variable exists
	                  // otherwise, this user is on mobile
	                  if (typeof chrome === 'undefined' || /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	                    unsupported = true;
	
	                    _this3.setState({
	                      unsupported: true,
	                      unsupportedDetails: translation.unsupported_msg.browser
	                    });
	                  }
	
	                  if (!unsupported && chrome.runtime) {
	                    _this3.getDisplayCount(SessionStore.extensionInfo.extensionId);
	
	                    if (!uninstall) {
	                      _this3.checkForExtension(sessionStart);
	                    } else {
	                      // NOTE: This delay is in here to make sure the extension
	                      // has had time to be uninstalled if we are forcing reinstallation.
	                      // It may not be necessary, but if checkForExtension() happens
	                      // to be called before the extension is actually gone, the user
	                      // would be able to proceed.
	                      unsupported = true;
	
	                      _this3.setState({
	                        unsupported: unsupported,
	                        unsupportedDetails: translation.unsupported_msg.extension,
	                        unsupportedLink: _config.config.extensionUrl,
	                        checkingPermissions: false
	                      });
	
	                      setTimeout(function () {
	                        _this3.checkForExtension(sessionStart);
	                      }, 1000);
	                    }
	
	                    _this3.checkForExtension(sessionStart);
	                  } else if (!chrome.runtime) {
	                    _this3.checkForExtension(sessionStart);
	                  }
	
	                  _this3.setupSteps();
	
	                  _this3.checkScreenShare();
	                });
	
	                if (!unsupported) {
	                  _context.next = 16;
	                  break;
	                }
	
	                return _context.abrupt('return');
	
	              case 16:
	
	                // Make sure getUserMedia is supported
	                getUserMediaSupported = (0, _helpers.testGetUserMedia)(function (details) {
	                  _this.setState({
	                    unsupported: true,
	                    unsupportedDetails: details,
	                    unsupportedLink: details.linkUrl,
	                    checkingPermissions: false
	                  });
	                });
	
	
	                if (!getUserMediaSupported) {
	                  this.setState({
	                    next: null
	                  });
	                }
	
	                if (!(this.state.step === 1 && chrome.runtime)) {
	                  _context.next = 23;
	                  break;
	                }
	
	                _context.next = 21;
	                return SessionStore.returnCurrentTime();
	
	              case 21:
	                modifiedDate = _context.sent;
	
	                chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'onboardingStatusChange', data: { modifiedDate: modifiedDate, statusName: "Using Online Proctoring" } });
	
	              case 23:
	                // Listen for messages from the extension
	                window.addEventListener('message', this.receiveMessage, false);
	
	              case 24:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(prevProps, prevState, snapshot) {
	        var SessionStore, modifiedDate, statusName, previousStatus;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                SessionStore = this.props.store.SessionStore;
	
	                if (!(prevState.step !== this.state.step)) {
	                  _context2.next = 8;
	                  break;
	                }
	
	                _context2.next = 4;
	                return SessionStore.returnCurrentTime();
	
	              case 4:
	                modifiedDate = _context2.sent;
	                statusName = this.state.orderedSteps[this.state.step - 1];
	                previousStatus = this.state.orderedSteps[this.state.step - 2];
	
	
	                chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'onboardingStatusChange', data: { modifiedDate: modifiedDate, statusName: statusName, previousStatus: previousStatus } });
	
	              case 8:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidUpdate(_x, _x2, _x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var ExamStore = this.props.store.ExamStore;
	
	
	      ExamStore.sessionStartData = null;
	      this.setState({ sessionInProgress: null });
	    }
	  }, {
	    key: 'setupSteps',
	    value: function setupSteps() {
	      var _props3 = this.props,
	          store = _props3.store,
	          translation = _props3.translation;
	      var ExamStore = store.ExamStore;
	      var sessionStartData = ExamStore.sessionStartData;
	      var modalityOptions = sessionStartData.modalityOptions,
	          exam = sessionStartData.exam;
	      var configuration = exam.configuration;
	
	      var steps = (0, _mobx.toJS)(translation.steps);
	
	      var workflowModule = null;
	
	      if (ExamStore.examSession && ExamStore.examSession.location) {
	        workflowModule = ExamStore.examSession.location.workflowModule;
	      }
	
	      if (!configuration.modalityOptions) {
	        configuration.modalityOptions = sessionStartData.modalityOptions;
	      }
	      // Remove unnecessary steps
	      if (!modalityOptions.recordScreen) {
	        var shareIndex = steps.indexOf('Share Screen');
	        steps.splice(shareIndex, 1);
	      }
	
	      if (!modalityOptions.verifyId) {
	        var idIndex = steps.indexOf('ID Verification');
	        steps.splice(idIndex, 1);
	      }
	
	      if (!modalityOptions.roomScan) {
	        var scanIndex = steps.indexOf('Room Scan');
	        steps.splice(scanIndex, 1);
	      }
	
	      // If this is an automated session we still want to use the proctor pause component
	      // but we aren't waiting for a proctor. This renames the step in the stepper to
	      // something more fitting
	      if (workflowModule === 'automated') {
	        var pauseIndex = steps.indexOf('Proctor Pause');
	        steps.splice(pauseIndex, 1, 'Waiting');
	      }
	
	      if (!modalityOptions.desktopAppCheck) {
	        var _scanIndex = steps.indexOf('SecureSession Utility App Check');
	        steps.splice(_scanIndex, 1);
	      }
	
	      // Store the steps in state
	      this.setState({ orderedSteps: steps });
	    }
	  }, {
	    key: 'checkForExtension',
	    value: function checkForExtension(sessionStart) {
	      var _this4 = this;
	
	      var _this = this;
	      var _props4 = this.props,
	          translation = _props4.translation,
	          sessionSid = _props4.sessionSid,
	          examSid = _props4.examSid;
	      var _props$store2 = this.props.store,
	          ExamStore = _props$store2.ExamStore,
	          SessionStore = _props$store2.SessionStore;
	
	      // If no versions of our extension are installed,
	      // chrome.runtime can end up being undefined. In
	      // that situation, onboarding completely breaks.
	      // So check if chrome.runtime exists and if it
	      // doesn’t, flag it as unsupported and start listening
	      // for the extension to be installed.
	
	      if (!chrome.runtime) {
	        console.log('Chrome runtime not defined... no extension is installed');
	
	        if (!_this.installLoop) {
	          var annotationType = {
	            title: "Whoops!",
	            severity: "green",
	            sessionTime: 0
	          };
	          ExamStore.raiseAnnotation(examSid, sessionSid, annotationType);
	        }
	
	        _this.setState({
	          unsupported: true,
	          unsupportedDetails: translation.unsupported_msg.extension,
	          unsupportedLink: _config.config.extensionUrl,
	          checkingPermissions: false
	        });
	
	        if (!_this.installLoop) {
	          _this.installLoop = setInterval(function () {
	            _this.checkForExtension(sessionStart);
	          }, 1000);
	          if (chrome.runtime) {
	            SessionStore.getCurrentTime();
	            var modifiedDate = SessionStore.currentTime;
	            chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'onboardingStatusChange', data: { modifiedDate: modifiedDate, statusName: "Using Online Proctoring" } });
	          }
	        }
	
	        return;
	      }
	
	      chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'getVersionNumber' }, function (response) {
	        if (!response || (0, _helpers.versionCompare)(response, SessionStore.extensionInfo.version) < 0) {
	          if (!response) {
	            console.log('Extension not installed');
	            if (_this.state.unsupportedDetails !== translation.unsupported_msg.extension) {
	              _this.setState({
	                unsupported: true,
	                unsupportedDetails: translation.unsupported_msg.extension,
	                unsupportedLink: _config.config.extensionUrl,
	                checkingPermissions: false
	              });
	            }
	          } else {
	            console.log('Old extension version installed');
	            if (_this.state.unsupportedDetails !== translation.unsupported_msg.extension_version) {
	              _this.setState({
	                unsupported: true,
	                unsupportedDetails: translation.unsupported_msg.extension_version,
	                unsupportedLink: _config.config.extensionUrl,
	                checkingPermissions: false,
	                unSupportedLinkCallback: function unSupportedLinkCallback(e) {
	                  var href = e.target.href;
	
	                  e.preventDefault();
	                  chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'uninstall' }, function (response) {
	                    if (response && response.status) {
	                      console.log('Did not uninstall');
	                    } else {
	                      window.open(href);
	                    }
	                  });
	                }
	              });
	            }
	          }
	          if (!_this.installLoop) {
	            _this.installLoop = setInterval(function () {
	              _this.checkForExtension(sessionStart);
	            }, 1000);
	          }
	          return;
	        } else {
	          _this4.setState({
	            unsupported: false,
	            unsupportedDetails: null,
	            unsupportedLink: null
	          });
	          chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'checkCurrentSession' }, function (response) {
	            // checkForExtension gets ran twice, because of this
	            // I added a null check (which is sessionInProgress's default value)
	            // so that if sessionInProgress is already defined from the first run
	            // it stays the same
	            if (_this4.state.sessionInProgress === null) {
	              _this4.setState({ sessionInProgress: response });
	            }
	          });
	          _this.getDisplayCount(SessionStore.extensionInfo.extensionId);
	          clearInterval(_this.installLoop);
	          // Check if permissions need to be reset
	          _this4.sendMessage({
	            message: 'permissionsCheckPreOnboarding'
	          }, function (response) {
	            console.log('Checked extension permissions. ' + (response === false ? 'Update' : 'No update') + ' required.');
	            _this4.setState({ checkingPermissions: true });
	            // If the response from this message is false,
	            // it means the extension needs to be reloaded.
	            // We should also reload the UI to make sure
	            // session start gets sent properly.
	            if (response === false && !_this4.restartDelay) {
	              _this4.restartDelay = setInterval(function () {
	                _this4.sendMessage({
	                  message: 'readyForRestart'
	                }, function (ready) {
	                  if (ready) {
	                    clearInterval(_this4.restartDelay);
	                    location.reload();
	                  }
	                });
	              }, 500);
	              return;
	            }
	            // If the response from this message is true,
	            // the extension is good to go, so we need to
	            // send session start message to extension.
	            _this4.sendMessage({
	              message: 'startSession',
	              sessionStart: sessionStart,
	              token: SessionStore.token
	            });
	            _this4.setState({ checkingPermissions: false });
	          });
	          if (ExamStore.sessionStartData) {
	            ExamStore.sessionStartData['sessionEndRedirectUrl'] = _config.config.sessionEndRedirectUrl;
	            _this.sendMessage({
	              message: 'startSession',
	              sessionStart: ExamStore.sessionStartData,
	              token: SessionStore.token
	            });
	          }
	          return;
	        }
	      });
	    }
	  }, {
	    key: 'proctorApproved',
	    value: function proctorApproved(decision) {
	      this.setState({ proctorApproved: decision });
	    }
	  }, {
	    key: 'getSessionSyncDoc',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	        var MessageStore;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                MessageStore = this.props.store.MessageStore;
	                return _context3.abrupt('return', this.sendMessage({ message: 'getSessionSyncDoc' }, function (response) {
	                  if (response.document) {
	                    if (response.document.faceProcessorStarted) {
	                      MessageStore.ghostRunning = true;
	                    }
	                  }
	                }));
	
	              case 2:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function getSessionSyncDoc() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getSessionSyncDoc;
	    }()
	  }, {
	    key: 'getDisplayCount',
	    value: function getDisplayCount(extensionId) {
	      var _this5 = this;
	
	      var _this = this;
	      var ExamStore = this.props.store.ExamStore;
	      var sessionStartData = ExamStore.sessionStartData;
	
	      var modalityOptions = null;
	
	      if (sessionStartData) {
	        modalityOptions = sessionStartData.exam.configuration.modalityOptions;
	      }
	
	      chrome.runtime.sendMessage(extensionId, { message: 'getDisplayCount' }, function (response) {
	        _this5.setState({
	          displayCount: response.displayCount
	        });
	        // For calls not for SystemCheck
	        if (response.displayCount > 1 && modalityOptions && modalityOptions.onlyOneScreen) {
	          setTimeout(function () {
	            _this.getDisplayCount(extensionId);
	          }, 2000);
	        }
	      });
	    }
	  }, {
	    key: 'setDisplays',
	    value: function setDisplays(numberOfDisplays) {
	      this.setState({
	        displayCount: numberOfDisplays
	      });
	    }
	  }, {
	    key: 'receiveMessage',
	    value: function receiveMessage(e) {
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          ExamStore = _props$store3.ExamStore,
	          SessionStore = _props$store3.SessionStore;
	      var sessionStartData = ExamStore.sessionStartData;
	
	      var modalityOptions = null;
	      if (e && e.data && e.data.message && e.data.message === 'syncDocUpdated') {
	        this.setState({ syncDocumentData: e.data.data });
	      }
	
	      if (sessionStartData) {
	        modalityOptions = sessionStartData.exam.configuration.modalityOptions;
	      }
	
	      // Check if e.data even exists before checking for extensionId
	      if (!e.data || !SessionStore.extensionInfo || e.data.extensionId !== SessionStore.extensionInfo.extensionId) {
	        return;
	      }
	
	      // XXX Not sure if this needed
	      if (e.errorMessage && e.errorMessage.includes(this.permissionsError)) {
	        return;
	      }
	
	      // Update display count if message includes count
	      if (e.data.displayCount) {
	        this.setState({
	          displayCount: e.data.displayCount
	        });
	
	        if (e.data.displayCount > 1 && modalityOptions && modalityOptions.onlyOneScreen && this.state.step > 2) {
	          this.setState({
	            unsupported: true,
	            unsupportedDetails: translation.unsupported_msg.displays,
	            checkingPermissions: false
	          });
	        } else {
	          this.setState({
	            unsupported: false,
	            unsupportedDetails: null
	          });
	        }
	      }
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      var _this6 = this;
	
	      var steps = this.state.orderedSteps;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'checkCurrentSession' }, function (response) {
	        _this6.setState({ sessionInProgress: response });
	      });
	
	      if (e) {
	        e.preventDefault();
	      }
	
	      // Increment the step
	      if (this.state.step !== steps.length) {
	        this.setState({
	          step: this.state.step + 1
	        });
	      } else {
	        this.handleSubmit();
	      }
	    }
	  }, {
	    key: 'checkForFaces',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(callback) {
	        var devices;
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                devices = {
	                  audio: this.state.microphone,
	                  video: this.state.webcam
	                };
	
	
	                this.sendMessage({ message: 'detectFaceOnWebcam', devices: devices }, callback);
	
	              case 2:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function checkForFaces(_x4) {
	        return _ref4.apply(this, arguments);
	      }
	
	      return checkForFaces;
	    }()
	  }, {
	    key: 'previousStep',
	    value: function previousStep(e) {
	
	      if (e) {
	        e.preventDefault();
	      }
	
	      // Decrement the step
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'setDevice',
	    value: function setDevice(type, device) {
	      // Device is set as a comma-separated string bc setting
	      // it to an object results in [object, object]
	      var deviceProps = device.split(',');
	      var deviceData = {
	        deviceId: deviceProps[0],
	        name: deviceProps[1]
	      };
	
	      this.setState(_defineProperty({}, type, deviceData));
	    }
	  }, {
	    key: 'restartExtension',
	    value: function restartExtension() {
	      var SessionStore = this.props.store.SessionStore;
	
	      chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'restartExtension' }, function (response) {
	        if (response === 'reloading') {
	          location.reload();
	        }
	      });
	    }
	  }, {
	    key: 'sendMessage',
	    value: function sendMessage(data, callback) {
	      var _this7 = this;
	
	      var translation = this.props.translation;
	      var _props$store4 = this.props.store,
	          SessionStore = _props$store4.SessionStore,
	          ExamStore = _props$store4.ExamStore;
	
	
	      if (!chrome.runtime) {
	        this.checkForExtension(ExamStore.sessionStartData);
	        return;
	      }
	      chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, data, function (response) {
	        if (callback) {
	          callback(typeof response !== 'undefined' ? response : 'no response');
	          return;
	        }
	
	        if (!response.status === 'ERROR' || !response.errorMessage) {
	          return;
	        }
	
	        if (response.errorMessage.includes(_this7.permissionsError)) {
	          // User did not grant access to their camera/mic/etc
	          return;
	        }
	
	        if (response.errorMessage.includes(_this7.screenError)) {
	          // TODO: If user declines, listener stops and will not accept
	          // User declined screen recording, try again
	          _this7.sendMessage(data);
	        } else if (response.errorMessage.includes(_this7.screenPermissionError) && navigator.userAgent.indexOf('Mac') > -1 && navigator.userAgent.indexOf('10_15') > -1) {
	          // User is on Catalina and screen sharing failed
	          // Show an message directing them to help doc
	          SessionStore.showDialog(translation.catalina_error);
	        } else {
	          SessionStore.throwError(response.errorMessage);
	          return;
	        }
	      });
	    }
	  }, {
	    key: 'checkScreenShare',
	    value: function checkScreenShare() {
	      var _this8 = this;
	
	      var _props$store5 = this.props.store,
	          SessionStore = _props$store5.SessionStore,
	          ExamStore = _props$store5.ExamStore;
	
	      if (!chrome.runtime) {
	        this.checkForExtension(ExamStore.sessionStartData);
	        return;
	      }
	
	      var shareIndex = this.state.orderedSteps.indexOf('Share Screen');
	
	      chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'isRecording' }, function (response) {
	        if (response.isScreenRecording === true) {
	          chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'getSessionStart' }, function (response) {
	            if (response.session.sid === sessionStorage.getItem('sessionSid')) {
	              _this8.setState({ step: shareIndex + 2 });
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var ExamStore = this.props.store.ExamStore;
	      var sessionStartData = ExamStore.sessionStartData;
	
	
	      this.sendMessage({
	        message: 'onboardingFinished'
	      });
	
	      window.top.location = sessionStartData.exam.url;
	    }
	  }, {
	    key: 'screenSharePopup',
	    value: function screenSharePopup() {
	      var devices = {
	        audio: this.state.microphone,
	        video: this.state.webcam
	      };
	
	      this.sendMessage({ message: 'startSessionRecording', devices: devices });
	    }
	  }, {
	    key: 'renderManualInstall',
	    value: function renderManualInstall() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.unsupported_msg.extension_manual.body
	        ),
	        this.state.unsupportedDetails.video && _react2.default.createElement(
	          'div',
	          { className: 'vid__wrap vid__wrap--wide' },
	          _react2.default.createElement('iframe', {
	            className: 'vid__video',
	            src: this.state.unsupportedDetails.video,
	            width: '640',
	            height: '488',
	            frameBorder: '0',
	            allow: 'autoplay; fullscreen',
	            allowFullScreen: true
	          })
	        ),
	        this.state.unsupportedDetails.link && _react2.default.createElement(
	          'a',
	          {
	            className: 'btn',
	            href: 'https://smarterproctoring.zendesk.com/hc/en-us/articles/360040636812',
	            target: '_blank'
	          },
	          translation.unsupported_msg.extension_manual.link
	        )
	      );
	    }
	  }, {
	    key: 'renderUnsupported',
	    value: function renderUnsupported() {
	      var _this9 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          this.state.unsupportedDetails.body
	        ),
	        this.state.unsupportedDetails.video && _react2.default.createElement(
	          'div',
	          { className: 'vid__wrap vid__wrap--wide' },
	          _react2.default.createElement('iframe', {
	            className: 'vid__video',
	            src: this.state.unsupportedDetails.video,
	            width: '640',
	            height: '488',
	            frameBorder: '0',
	            allow: 'autoplay; fullscreen',
	            allowFullScreen: true
	          })
	        ),
	        this.state.unsupportedDetails.link && _react2.default.createElement(
	          'a',
	          {
	            className: 'btn',
	            href: this.state.unsupportedDetails.url ? this.state.unsupportedDetails.url : this.state.unsupportedLink,
	            target: '_blank',
	            onClick: function onClick(e) {
	              return _this9.state.unSupportedLinkCallback ? _this9.state.unSupportedLinkCallback(e) : null;
	            }
	          },
	          this.state.unsupportedDetails.link
	        )
	      );
	    }
	
	    /**
	     * Render the system check view and use LaunchDarkly flag
	     * to determine whether or not to do a face check.
	     *
	     * @function renderSystemCheck
	     * @param {boolean} detectFace - LaunchDarkly flag status
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      var _props5 = this.props,
	          external = _props5.external,
	          translation = _props5.translation;
	      var _props$store6 = this.props.store,
	          ExamStore = _props$store6.ExamStore,
	          SessionStore = _props$store6.SessionStore;
	      var orderedSteps = this.state.orderedSteps;
	      var sessionStartData = ExamStore.sessionStartData;
	
	      var workflowModule = void 0;
	      var proctorPausePage = void 0;
	
	      if (orderedSteps) {
	        if (orderedSteps.indexOf('Proctor Pause') === -1) {
	          proctorPausePage = orderedSteps.indexOf('Waiting');
	        } else {
	          proctorPausePage = orderedSteps.indexOf('Proctor Pause');
	        }
	      }
	
	      if (!sessionStartData || !translation || !this.state.orderedSteps) {
	        return null;
	      }
	      if (ExamStore.examSession && ExamStore.examSession.location) {
	        workflowModule = ExamStore.examSession.location.workflowModule;
	      }
	
	      var examSession = sessionStartData.session;
	      var examConfiguration = sessionStartData.exam.configuration;
	      var agreements = sessionStartData.agreements;
	
	      // The session start data doesn’t include workflow module
	      // so we need to get it from the exam session data that’s
	      // stored in the ExamStore.
	
	      if (!examConfiguration.modalityOptions) {
	        examConfiguration.modalityOptions = sessionStartData.modalityOptions;
	      }
	
	      // Remove unnecessary steps
	
	      if (this.state.checkingPermissions) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'panel panel--medium' },
	          _react2.default.createElement(
	            'span',
	            { className: 'no-results' },
	            translation.permissions_check
	          )
	        );
	      }
	
	      if (this.state.unsupported) {
	        return _react2.default.createElement(
	          'div',
	          {
	            className: 'drawer__content' + (external ? ' drawer__content--external' : '')
	          },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                'Start Session'
	              ),
	              external
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page--medium' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--medium' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title panel__title--alt' },
	                translation.unsupported_heading
	              ),
	              this.state.unsupportedDetails.body === translation.unsupported_msg.extension.body && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: 'extension-manual-install',
	                renderFeatureCallback: this.renderManualInstall,
	                renderDefaultCallback: this.renderUnsupported
	              }),
	              this.state.unsupportedDetails.body !== translation.unsupported_msg.extension.body && this.renderUnsupported()
	            )
	          )
	        );
	      } else if (this.state.sessionInProgress) {
	        return _react2.default.createElement(
	          'div',
	          {
	            className: 'drawer__content' + (external ? ' drawer__content--external' : '')
	          },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                'Start Session'
	              ),
	              external
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page--medium' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--medium' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title panel__title--alt' },
	                translation.sessionInProgress.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.sessionInProgress.body
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'note' },
	                translation.sessionInProgress.warning
	              ),
	              _react2.default.createElement(
	                'button',
	                { onClick: this.restartExtension, className: 'btn btn--negative' },
	                translation.sessionInProgress.button
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          {
	            className: 'drawer__content' + (external ? ' drawer__content--external' : '')
	          },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                'Start Session'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'page--medium' },
	            _react2.default.createElement(_Step2.default, {
	              step: this.state.step,
	              setStep: this.setStep,
	              data: this.state.orderedSteps,
	              skippable: false
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'slide-wrap wrap' },
	              _react2.default.createElement(_Example2.default, Object.assign({}, this.props, {
	                parent: this,
	                statusClass: this.statusClass(orderedSteps.indexOf('Welcome') + 1),
	                nextStep: this.nextStep,
	                button: this.submit
	              })),
	              _react2.default.createElement(_Intro2.default, Object.assign({}, this.props, {
	                parent: this,
	                statusClass: this.statusClass(orderedSteps.indexOf('Exam Details') + 1),
	                examConfiguration: examConfiguration,
	                nextStep: this.nextStep,
	                button: this.submit
	              })),
	              _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: 'automated-face-detection',
	                renderFeatureCallback: this.renderSystemCheck,
	                renderDefaultCallback: this.renderSystemCheck
	              }),
	              _react2.default.createElement(_DesktopApp2.default, Object.assign({}, this.props, {
	                parent: this,
	                statusClass: this.statusClass(orderedSteps.indexOf('SecureSession Utility App Check') + 1),
	                nextStep: this.nextStep,
	                button: this.submit,
	                syncDocumentData: this.state.syncDocumentData,
	                sessionStartData: sessionStartData
	              })),
	              _react2.default.createElement(_Consent2.default, Object.assign({}, this.props, {
	                agreements: agreements,
	                parent: this,
	                statusClass: this.statusClass(orderedSteps.indexOf('Consent') + 1),
	                examSession: examSession,
	                nextStep: this.nextStep,
	                button: this.submit,
	                onComplete: function onComplete(devices) {
	                  _this10.sendMessage({ message: 'event_systemCheck' });
	
	                  // Start recording if it has not started yet
	                  // chrome.runtime.sendMessage(
	                  //   SessionStore.extensionInfo.extensionId,
	                  //   { message: 'isRecording' },
	                  //   response => {
	                  //     if (!response.isScreenRecording) {
	                  //       this.sendMessage({ message: 'startSessionRecording', devices });
	                  //     }
	                  //   }
	                  // );
	                }
	              })),
	              _react2.default.createElement(_ShareScreen2.default, Object.assign({}, this.props, {
	                parent: this,
	                statusClass: this.statusClass(orderedSteps.indexOf('Share Screen') + 1),
	                nextStep: this.nextStep,
	                button: this.submit,
	                sessionStartData: sessionStartData,
	                onShowPopup: this.screenSharePopup,
	                step: this.state.step,
	                proctorApproved: this.state.proctorApproved
	              })),
	              _react2.default.createElement(_IDVerification2.default, Object.assign({}, this.props, {
	                parent: this,
	                statusClass: this.statusClass(orderedSteps.indexOf('ID Verification') + 1),
	                nextStep: this.nextStep,
	                button: this.submit,
	                webcam: this.state.webcam.deviceId,
	                sessionStartData: sessionStartData,
	                smarterId: sessionStartData.smarterId && sessionStartData.smarterId.userSid && SessionStore.settings.smarterIdEnabled ? true : false,
	                onCapture: function onCapture(type) {
	                  _this10.sendMessage({ message: 'event_photoTaken', type: type });
	                },
	                onAccept: function onAccept(type, photo) {
	                  _this10.sendMessage({ message: 'event_photoAccepted', type: type });
	
	                  if (photo) _this10.sendMessage({ message: 'receivePhoto', base64: photo });
	                }
	              })),
	              _react2.default.createElement(_RoomScan2.default, Object.assign({}, this.props, {
	                parent: this,
	                statusClass: this.statusClass(orderedSteps.indexOf('Room Scan') + 1),
	                nextStep: this.nextStep,
	                button: this.submit,
	                sessionStartData: sessionStartData,
	                webcam: this.state.webcam.deviceId,
	                onStart: function onStart() {
	                  return _this10.sendMessage({ message: 'event_roomScanStart' });
	                },
	                onStop: function onStop() {
	                  return _this10.sendMessage({ message: 'event_roomScanStop' });
	                }
	              })),
	              _react2.default.createElement(_ProctorPause2.default, Object.assign({}, this.props, {
	                parent: this,
	                statusClass: this.statusClass(proctorPausePage + 1),
	                automated: workflowModule === 'automated',
	                nextStep: this.nextStep,
	                button: this.submit,
	                skipProctorPause: this.state.skipProctorPause,
	                proctorApproved: this.state.proctorApproved,
	                setProctorApproved: this.proctorApproved
	              })),
	              _react2.default.createElement(_Begin2.default, Object.assign({}, this.props, {
	                parent: this,
	                statusClass: this.statusClass(orderedSteps.indexOf('Begin') + 1),
	                nextStep: this.nextStep,
	                button: this.submit
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'drawer__action' },
	            this.state.step > 1 && this.state.step < 5 && _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--outline drawer__back',
	                onClick: this.previousStep
	              },
	              'Back'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                onClick: this.state.next,
	                ref: function ref(button) {
	                  return _this10.submit = button;
	                }
	              },
	              'Continue'
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return SessionStartAutomated;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionStartAutomated')(SessionStartAutomated);
	
	/**
	// Example of getting display count from extension
	var editorExtensionId = "mehgceidjddddencjmonjkbcponoakag";

	// Make a simple request:
	chrome.runtime.sendMessage(editorExtensionId, {message: "getDisplayCount"},
	  function(response) {
	    console.log(response.displayCount)
	  }
	);
	*/

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	var _reactTabs = __webpack_require__(195);
	
	var _Password = __webpack_require__(344);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Map = __webpack_require__(149);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var UserSettings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(UserSettings, _React$Component);
	
	  function UserSettings() {
	    _classCallCheck(this, UserSettings);
	
	    var _this = _possibleConstructorReturn(this, (UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).call(this));
	
	    _this.handleTabs = _this.handleTabs.bind(_this);
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.confirmPassword = _this.confirmPassword.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handlePasswordSubmit = _this.handlePasswordSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    _this.renderLocation = _this.renderLocation.bind(_this);
	    _this.setLocation = _this.setLocation.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserSettings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	      var profile = SessionStore.profile;
	
	
	      SessionStore.getTimezones();
	      SessionStore.getCurrencies();
	
	      this.state = {
	        settings: {
	          proctorTypes: []
	        },
	        homePhone: profile.homePhone,
	        mobilePhone: profile.mobilePhone,
	        currencyCode: '',
	        timeZoneSid: '',
	        activeTab: 1,
	        preferredEmail: ''
	      };
	
	      this.getUserSettings();
	
	      // Select tab if present in url
	      var urlTab = 1;
	
	      switch ((0, _helpers.getURLSegment)(this, 2)) {
	        case 'password':
	          urlTab = 2;
	          break;
	
	        default:
	          urlTab = 1;
	      }
	
	      this.setState({
	        activeTab: urlTab
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // This if statement makes sure settings-main isn't focused when making changes to the settings page
	      if (prevProps !== this.props) {
	        var main = document.getElementById('settings-main');
	        if (main && this.props.enrollment) {
	          setTimeout(function () {
	            return main.focus();
	          }, 250);
	        }
	      }
	    }
	  }, {
	    key: 'getUserSettings',
	    value: function getUserSettings() {
	      this.props.store.SettingsStore.getUserSettings(this, (0, _helpers.getURLSegment)(this, 1));
	    }
	  }, {
	    key: 'handleTabs',
	    value: function handleTabs(index) {
	      this.setState({
	        activeTab: index + 1
	      });
	
	      // Update url
	      var newPath = '/settings/general';
	
	      switch (index + 1) {
	        case 2:
	          newPath = '/settings/password';
	          break;
	
	        default:
	          newPath = '/settings/general';
	      }
	
	      this.props.routing.push(newPath);
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(e, name) {
	      var data = null;
	      var value = null;
	
	      if (name === 'homePhone' || name === 'mobilePhone') {
	        value = e;
	
	        this.setState(_defineProperty({}, name, value));
	      } else {
	        value = e.target.value;
	
	        this.setState(_defineProperty({}, name, value));
	      }
	
	      // Make sure boolean values are boolean
	      if (value === 'true') {
	        value = true;
	      }
	      if (value === 'false') {
	        value = false;
	      }
	
	      data = _defineProperty({}, name, value);
	
	      this.props.store.SettingsStore.updateUserData(data);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var translation = this.props.translation;
	
	      this.props.store.SettingsStore.updateUserSettings(this.complete, translation.location_required, this.props.enrollment);
	    }
	  }, {
	    key: 'confirmPassword',
	    value: function confirmPassword(e) {
	      e.preventDefault();
	
	      // Make sure confirm password matches
	      var newPass = document.querySelector('#password-new');
	      var confirm = document.querySelector('#password-confirm');
	
	      if (newPass.value !== this.confirmPass.value) {
	        confirm.setCustomValidity('Passwords do not match.');
	      } else {
	        confirm.setCustomValidity('');
	      }
	
	      (0, _helpers.checkValidity)(e, this.handlePasswordSubmit);
	    }
	  }, {
	    key: 'handlePasswordSubmit',
	    value: function handlePasswordSubmit() {
	      var newPass = document.querySelector('#password-new');
	
	      var data = {
	        currentPassword: this.currentPass.value,
	        newPassword: newPass.value,
	        confirmNewPassword: this.confirmPass.value
	      };
	
	      this.props.store.SettingsStore.updatePassword(data, this.complete);
	
	      // Reset the password form
	      this.currentPass.value = '';
	      newPass.value = '';
	      this.confirmPass.value = '';
	
	      // Make sure the now empty input fields aren't flagged as invalid
	      var form = document.querySelector('form.submitted');
	
	      if (form) {
	        form.className = form.className.replace('submitted', '');
	      }
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      if (this.props.enrollment) {
	        var prod = false;
	
	        if (true) {
	          prod = true;
	        }
	
	        if (prod) {
	          this.props.routing.push({
	            pathname: '/'
	          });
	        } else {
	          this.props.setStep(null, 6);
	
	          if (this.props.smarterID) {
	            this.props.setDisplayStep(4);
	          } else {
	            this.props.setDisplayStep(3);
	          }
	        }
	      } else {
	        this.props.store.SessionStore.showToaster(this.props.translation.settings_saved, 'success');
	      }
	    }
	  }, {
	    key: 'setLocation',
	    value: function setLocation(name, address1, address2, city, region, country, postalCode, lat, lng, preventRender) {
	      var data = {
	        latitude: lat,
	        longitude: lng,
	        address: document.querySelector('#map-search').value
	      };
	
	      this.props.store.SettingsStore.updateUserData(data);
	    }
	  }, {
	    key: 'renderLocation',
	    value: function renderLocation() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var profile = SessionStore.profile,
	          userData = SessionStore.userData;
	
	      // Default map options
	
	      var center = {
	        lat: profile.latitude || -33.8688,
	        lng: profile.longitude || 151.2195
	      };
	
	      var locationSet = false;
	      var zoom = 13;
	      var dropPin = false;
	
	      if (profile.latitude && profile.longitude) {
	        locationSet = true;
	        zoom = 17;
	        dropPin = true;
	      }
	
	      if (userData.role.toLowerCase() === 'learner') {
	        return _react2.default.createElement(
	          'fieldset',
	          { className: 'form-section' },
	          _react2.default.createElement(
	            'p',
	            { className: 'note' },
	            translation.enrollment_location
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                {
	                  className: 'lbl-required',
	                  htmlFor: 'map-search'
	                },
	                translation.location.label
	              ),
	              _react2.default.createElement(_Map2.default, {
	                locationSet: locationSet,
	                setLocation: this.setLocation,
	                store: this.props.store,
	                center: center,
	                zoom: zoom,
	                dropPin: dropPin,
	                'default': profile.address
	              })
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	      var profile = SessionStore.profile;
	
	      // Don’t use the default tab styles
	
	      _reactTabs.Tabs.setUseDefaultStyles(false);
	
	      if (SessionStore.loadingCalls.indexOf('GetUserSettings') < 0 && SessionStore.loadingCalls.indexOf('TimeZones') < 0 && SessionStore.loadingCalls.indexOf('Currencies') < 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__header' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'panel__title', id: 'settings-main', tabIndex: '0' },
	                _react2.default.createElement(
	                  'legend',
	                  null,
	                  translation.heading
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tabs,
	              {
	                className: 'panel__body',
	                onSelect: this.handleTabs,
	                forceRenderTabPanel: true,
	                selectedIndex: this.state.activeTab - 1
	              },
	              _react2.default.createElement(
	                _reactTabs.TabList,
	                { className: 'tabs-enabled' },
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.general
	                ),
	                SessionStore.userData.role.toLowerCase() === 'administrator' && _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.password
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: function onSubmit(e) {
	                      return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	                    }, noValidate: true },
	                  this.props.enrollment && _react2.default.createElement(
	                    'p',
	                    { className: 'note' },
	                    translation.enrollment_instructions
	                  ),
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'meta' },
	                    translation.general
	                  ),
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: 'form-section' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'field--half' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'profile-fname' },
	                          translation.name.first
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'faux-input' },
	                          profile.firstName
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'field--half' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'profile-lname' },
	                          translation.name.last
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'faux-input' },
	                          profile.lastName
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'profile-email'
	                          },
	                          translation.email.label
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'field-instruction' },
	                          translation.email.instruction
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'email',
	                          ref: function ref(input) {
	                            return _this2.preferredEmail = input;
	                          },
	                          defaultValue: profile.preferredEmail,
	                          required: true,
	                          'aria-required': 'true',
	                          onChange: function onChange(e) {
	                            return _this2.handleInput(e, 'preferredEmail');
	                          },
	                          placeholder: translation.email.helper
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-optional', htmlFor: 'profile-phone' },
	                          translation.home_phone.label
	                        ),
	                        _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                          id: 'profile-phone',
	                          nativeExpanded: true,
	                          flagsPath: './static/img/flags/',
	                          country: (0, _reactPhoneNumberInput.parsePhoneNumber)(profile.homePhone).country || 'US',
	                          value: profile.homePhone,
	                          onChange: function onChange(e) {
	                            _this2.handleInput(e, 'homePhone');
	                          },
	                          'aria-invalid': !(0, _reactPhoneNumberInput.isValidPhoneNumber)(this.state.homePhone),
	                          placeholder: translation.home_phone.label
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-optional', htmlFor: 'profile-mobile' },
	                          translation.mobile.label
	                        ),
	                        _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                          id: 'profile-mobile',
	                          nativeExpanded: true,
	                          flagsPath: './static/img/flags/',
	                          country: (0, _reactPhoneNumberInput.parsePhoneNumber)(profile.mobilePhone).country || 'US',
	                          value: profile.mobilePhone,
	                          onChange: function onChange(e) {
	                            _this2.handleInput(e, 'mobilePhone');
	                          },
	                          'aria-invalid': !(0, _reactPhoneNumberInput.isValidPhoneNumber)(this.state.mobilePhone),
	                          placeholder: translation.mobile.label
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'settings-timezone' },
	                          translation.timezone.label
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select', htmlFor: 'settings-timezone' },
	                          _react2.default.createElement(
	                            'select',
	                            { id: 'settings-timezone',
	                              ref: function ref(input) {
	                                _this2.defaultTimezone = input;
	                              },
	                              value: this.state.timeZoneSid,
	                              required: true,
	                              'aria-required': 'true',
	                              onChange: function onChange(e) {
	                                _this2.handleInput(e, 'timeZoneSid');
	                              }
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.timezone.helper
	                            ),
	                            SessionStore.timezoneList.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.sid },
	                                key.name
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'profile-currency' },
	                          translation.currency.label
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select', htmlFor: 'profile-currency' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'profile-currency',
	                              ref: function ref(input) {
	                                _this2.currency = input;
	                              },
	                              value: this.state.currencyCode,
	                              required: true,
	                              'aria-required': 'true',
	                              onChange: function onChange(e) {
	                                _this2.handleInput(e, 'currencyCode');
	                              }
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.currency.helper
	                            ),
	                            SessionStore.currencyList.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.code },
	                                key.name
	                              );
	                            })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                    flagKey: 'automated-only',
	                    renderFeatureCallback: function renderFeatureCallback() {
	                      // If automated-only, we don’t need the student’s location
	                      // so we will just set it to the GR office
	                      SettingsStore.updateUserData({
	                        latitude: 42.923900,
	                        longitude: -85.585870,
	                        address: '3351 Claystone St SE, Grand Rapids, MI 49546'
	                      });
	
	                      return null;
	                    },
	                    renderDefaultCallback: this.renderLocation
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'panel__actions actions' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'actions__btn actions__btn--primary', type: 'submit' },
	                      translation.save
	                    )
	                  )
	                )
	              ),
	              SessionStore.userData.role.toLowerCase() === 'administrator' && _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'form',
	                  { onSubmit: function onSubmit(e) {
	                      return _this2.confirmPassword(e);
	                    }, noValidate: true },
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'meta' },
	                    translation.password
	                  ),
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: 'form-section' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'password-current' },
	                          translation.password_settings.current
	                        ),
	                        _react2.default.createElement('input', {
	                          id: 'password-current',
	                          type: 'password',
	                          ref: function ref(input) {
	                            _this2.currentPass = input;
	                          },
	                          required: true,
	                          'aria-required': 'true'
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'password-new' },
	                          translation.password_settings.new
	                        ),
	                        _react2.default.createElement(_Password2.default, Object.assign({
	                          id: 'password-new',
	                          parent: this,
	                          name: 'password'
	                        }, this.props))
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'password-confirm' },
	                          translation.password_settings.confirm
	                        ),
	                        _react2.default.createElement('input', {
	                          id: 'password-confirm',
	                          type: 'password',
	                          ref: function ref(input) {
	                            _this2.confirmPass = input;
	                          },
	                          required: true,
	                          'aria-required': 'true'
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'panel__actions actions' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'actions__btn actions__btn--primary', type: 'submit' },
	                      translation.save
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return UserSettings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('UserSettings')(UserSettings);

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var StartVTC = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(StartVTC, _React$Component);
	
	  function StartVTC() {
	    _classCallCheck(this, StartVTC);
	
	    return _possibleConstructorReturn(this, (StartVTC.__proto__ || Object.getPrototypeOf(StartVTC)).apply(this, arguments));
	  }
	
	  _createClass(StartVTC, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var ExamStore = this.props.store.ExamStore;
	
	
	      var accessCode = null;
	
	      if (this.props.accessCode) {
	        accessCode = this.props.accessCode;
	      } else if (this.props.routing.location.pathname.indexOf('launch') >= 0) {
	        accessCode = (0, _helpers.getURLSegment)(this, 2);
	      }
	
	      if (accessCode && accessCode.indexOf('-') < 0) {
	        accessCode = accessCode.slice(0, 3) + '-' + accessCode.slice(3, 6) + '-' + accessCode.slice(6);
	      }
	
	      this.state = {
	        accessCode: accessCode,
	        iframe: (0, _helpers.inIframe)(),
	        useProtocol: true
	
	        // Launch VTC session if we’re not in an iframe.
	        // Otherwise, we’ll show a link to launch a new window.
	      };var launchFallback = function launchFallback() {
	        return _this2.setState({ useProtocol: false });
	      };
	
	      if (!this.state.iframe) {
	        (0, _helpers.launchVTC)(this.state.accessCode, launchFallback);
	      }
	
	      // Check if session exists in store and get it if it doesn’t
	      if (!ExamStore.examSession.status) {
	        ExamStore.getExamSessionByAccessCode(accessCode);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var ExamStore = store.ExamStore,
	          SessionStore = store.SessionStore;
	      var examSession = ExamStore.examSession;
	
	
	      if (!this.state.iframe && !SessionStore.loading && examSession.examConfiguration) {
	        if (this.state.useProtocol) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.launching
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.launching_body
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--link',
	                onClick: function onClick() {
	                  return _this3.setState({ useProtocol: false });
	                }
	              },
	              translation.launch_fail
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.body
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'text-code' },
	              this.state.accessCode
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'block-list block-list__icons' },
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'block-list__block block--link title-link',
	                  href: 'http://virtual-test-center-builds.s3.amazonaws.com/production/SmarterProctoring-Installer.exe'
	                },
	                _react2.default.createElement(icons.iconWindows, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'block-list__sub-title' },
	                  translation.windows
	                )
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'block-list__block block--link title-link',
	                  href: 'http://virtual-test-center-builds.s3.amazonaws.com/production/SmarterProctoring-Installer.dmg'
	                },
	                _react2.default.createElement(icons.iconApple, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'block-list__sub-title' },
	                  translation.mac
	                )
	              )
	            ),
	            !this.props.hideDashboard && _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/', onClick: function onClick(e) {
	                  (0, _helpers.closeDrawer)(e, _this3.props.parent, '/');
	                } },
	              translation.dashboard
	            )
	          );
	        }
	      } else if (this.state.iframe) {
	        var header = document.querySelector('.site-head');
	
	        if (header) {
	          header.setAttribute('style', 'margin-bottom: 0; opacity: 0; visibility: hidden;');
	        }
	
	        return _react2.default.createElement(
	          'a',
	          {
	            className: 'btn btn--success btn--icn-right btn--lg btn--solo',
	            href: '/#/launch/' + this.state.accessCode,
	            target: '_blank'
	          },
	          translation.launch_link,
	          _react2.default.createElement(icons.iconExternal, null)
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return StartVTC;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('StartVTC')(StartVTC);

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(56);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _ManagerStore = __webpack_require__(378);
	
	var _ManagerStore2 = _interopRequireDefault(_ManagerStore);
	
	var _SettingsStore = __webpack_require__(152);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _ProctorStore = __webpack_require__(151);
	
	var _ProctorStore2 = _interopRequireDefault(_ProctorStore);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Helpers
	
	
	// Components
	
	
	// Dependencies
	
	
	var obx = (0, _mobx.observable)({
	  filterParams: {
	    fname: '',
	    lname: '',
	    status: ''
	  },
	  defaultPlatformVersion: 2,
	  setPlatformVersion: (0, _mobx.action)(function (version) {
	    obx.defaultPlatformVersion = version;
	    if (obx.exam) {
	      obx.exam.platformVersion = version;
	    }
	  }),
	  addLocation: (0, _mobx.action)(function () {
	    var location = {
	      location: null,
	      timeType: 'between',
	      startTime: null,
	      endTime: null,
	      capacity: 0
	    };
	    obx.exam.configuration.instructorAsProctor.push(location);
	
	    if (obx.configuration) {
	      obx.configuration.instructorAsProctor.push(location);
	    }
	  }),
	  removeLocation: (0, _mobx.action)(function (index) {
	    obx.exam.configuration.instructorAsProctor.splice(index, 1);
	
	    if (obx.configuration) {
	      obx.configuration.instructorAsProctor.splice(index, 1);
	    }
	  }),
	  updateLocation: (0, _mobx.action)(function (index, location) {
	    obx.exam.configuration.instructorAsProctor[index] = location;
	
	    if (obx.configuration) {
	      obx.configuration.instructorAsProctor[index] = location;
	    }
	  }),
	  exam: {
	    title: '',
	    type: "Online",
	    description: '',
	    useProctorManager: false,
	    requireApproval: false,
	    url: '',
	    enableAppointmentSuggestions: false,
	    platformVersion: 2,
	    configuration: {
	      examOpenDate: '',
	      examCloseDate: '',
	      scheduleOpenDate: '',
	      scheduleCloseDate: '',
	      password: '',
	      duration: 0,
	      attempts: 1,
	      requiredSoftware: '',
	      studentNotes: '',
	      proctorNotes: '',
	      proctorTypes: []
	    }
	  },
	  defaultExam: null,
	  configuration: null,
	  examEnrollments: [],
	  // Reset exam data
	  resetExam: (0, _mobx.action)(function (examType) {
	    obx.configuration = null;
	
	    obx.exam = {
	      title: '',
	      type: examType === 'Written' ? 'Written' : 'Online',
	      description: '',
	      useProctorManager: false,
	      requireApproval: false,
	      url: '',
	      enableAppointmentSuggestions: false,
	      isLimitedScope: false,
	      platformVersion: 2,
	      configuration: {
	        examOpenDate: '',
	        examCloseDate: '',
	        scheduleOpenDate: '',
	        scheduleCloseDate: '',
	        password: '',
	        duration: 0,
	        attempts: 1,
	        requiredSoftware: '',
	        studentNotes: '',
	        proctorNotes: '',
	        proctorTypes: [],
	        permittedBathroomBreak: false,
	        permittedBathroomBreakInformation: '',
	        permittedBlankPaper: false,
	        permittedBlankPaperInformation: '',
	        permittedCalculator: false,
	        permittedCalculatorInformation: '',
	        permittedDictionary: false,
	        permittedDictionaryInformation: '',
	        permittedEarplugs: false,
	        permittedEarplugsInformation: '',
	        permittedFormulaSheet: false,
	        permittedFormulaSheetInformation: '',
	        permittedNotes: false,
	        permittedNotesInformation: '',
	        permittedOtherItems: '',
	        permittedTextbook: false,
	        permittedTextbookInformation: '',
	        permittedWebsites: false,
	        permittedWebsitesInformation: '',
	        instructorAsProctor: []
	      }
	    };
	  }),
	  resetExamSession: (0, _mobx.action)(function () {
	    obx.examSession = {
	      status: '',
	      sessionType: '',
	      appointmentDate: '',
	      dateScheduled: '',
	      dateApproved: '',
	      proctor: {
	        firstName: '',
	        lastName: '',
	        phone: ''
	      },
	      location: {
	        accountName: '',
	        address1: '',
	        address2: '',
	        region: '',
	        country: '',
	        postalCode: '',
	        place: '',
	        latitude: '',
	        longitude: ''
	      }
	    };
	  }),
	  // Get a specific exam
	  getExam: (0, _mobx.action)(function (sid, courseSid) {
	    _SessionStore2.default.startLoading('Loading…', 'Exam');
	    obx.resetExam();
	
	    var course = courseSid;
	
	    if (!course) {
	      course = _SessionStore2.default.userData.courseSid;
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + course + '/exams/' + sid).then(function (response) {
	      obx.exam = response.data;
	      obx.defaultExam = response.data;
	      _SessionStore2.default.finishLoading('Exam');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get written exam file
	  getExamFile: (0, _mobx.action)(function (configurationSid, fileName, installSid, backgroundLoad) {
	    if (!backgroundLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'getExamFile');
	    }
	
	    var install = _SessionStore2.default.userData.installSid;
	
	    if (installSid) {
	      install = installSid;
	    }
	
	    _config.api.get('/installs/' + install + '/examConfigurations/' + configurationSid + '/examFile', {
	      responseType: 'arraybuffer'
	    }).then(function (response) {
	      var tempLink = document.createElement('a');
	      var file = new Blob([response.data], { type: 'application/pdf' });
	
	      if (window.navigator.msSaveOrOpenBlob) {
	        window.navigator.msSaveOrOpenBlob(file, fileName);
	      } else {
	        var fileUrl = URL.createObjectURL(file);
	
	        tempLink.href = fileUrl;
	        tempLink.download = fileName;
	        tempLink.click();
	
	        window.URL.revokeObjectURL(fileUrl);
	      }
	
	      if (!backgroundLoad) {
	        _SessionStore2.default.finishLoading('getExamFile');
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get exam enrollments
	  getEnrollments: (0, _mobx.action)(function (sid, filters, noLoad) {
	
	    if (!noLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'ExamEnrollments');
	    }
	
	    var query = '?limit=50';
	
	    if (filters) {
	      for (var key in filters) {
	        if (filters[key]) {
	          query += '&' + key + '=' + filters[key];
	        }
	      }
	    }
	
	    _config.api.get('/install/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/exams/' + sid + '/enrollments' + query).then(function (response) {
	      obx.examEnrollments = response.data.enrollments.results;
	      if (response.data.enrollments.next) {
	
	        var nextUrl = (0, _helpers.getPath)(response.data.enrollments.next);
	        nextUrl = nextUrl.replace('/v1', '');
	        obx.overviewNext = nextUrl;
	      } else {
	        obx.overviewNext = "";
	      }
	
	      // Loop through enrollments and check for
	      // root school and then get data if needed
	      obx.examEnrollments.forEach(function (enrollment) {
	        if (enrollment.rootAffiliation && enrollment.rootAffiliation.install.sid !== _SessionStore2.default.userData.installSid) {
	          // Get a list of all proctor types
	          if (_ProctorStore2.default.proctorTypeCategories.length === 0 && _SessionStore2.default.loadingCalls.indexOf('GetProctorTypes') < 0) {
	            _ProctorStore2.default.getProctorTypes();
	          }
	
	          var callback = function callback(data) {
	            enrollment.proctorGroups = data;
	
	            enrollment.proctorGroups.forEach(function (proctorGroup) {
	              var typeArr = [];
	
	              proctorGroup.proctorTypes.forEach(function (type) {
	                var typeObj = (0, _mobx.toJS)(_ProctorStore2.default.proctorTypeCategories).filter(function (cat) {
	                  return cat.sid === type;
	                });
	
	                if (typeArr.indexOf(typeObj[0].title) < 0) {
	                  typeArr.push(typeObj[0].title);
	                }
	              });
	
	              proctorGroup.proctorTypes = typeArr;
	            });
	          };
	
	          // Wait until all proctor types are stored
	          // then get proctor groups for this session
	          var catDelay = setInterval(function () {
	            if (_ProctorStore2.default.proctorTypeCategories.length > 0) {
	              clearInterval(catDelay);
	              _ProctorStore2.default.getSessionProctorGroups(sid, enrollment.session.sid, null, callback);
	            }
	          }, 100);
	        }
	      });
	      _SessionStore2.default.finishLoading('ExamEnrollments');
	    }).catch(function (error) {
	      _SessionStore2.default.finishLoading('ExamEnrollments');
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  updateExamAssignment: (0, _mobx.action)(function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(added, removed, examSid) {
	      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	      var payload;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              payload = { added: added, removed: removed };
	              _context.prev = 1;
	              _context.next = 4;
	              return _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/assignment', payload);
	
	            case 4:
	              _context.next = 9;
	              break;
	
	            case 6:
	              _context.prev = 6;
	              _context.t0 = _context['catch'](1);
	
	              _SessionStore2.default.throwError(_context.t0);
	
	            case 9:
	
	              if (callback) {
	                callback();
	              }
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[1, 6]]);
	    }));
	
	    return function (_x2, _x3, _x4) {
	      return _ref.apply(this, arguments);
	    };
	  }()),
	
	  // Create exam
	  createExam: (0, _mobx.action)(function (func, component) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateExam');
	
	    var data = Object.assign({}, obx.exam);
	
	    // If we’ve imported an exam, use that data to fill in any gaps
	    if (obx.importedLmsExam) {
	      if (!data.title) {
	        data.title = obx.importedLmsExam.title;
	      }
	
	      if (obx.importedLmsExam.attemptsAllowed) {
	        data.configuration.attempts = obx.importedLmsExam.attemptsAllowed;
	      }
	
	      if (!data.description) {
	        data.description = obx.importedLmsExam.description;
	      }
	
	      if (!data.configuration.duration) {
	        data.configuration.duration = obx.importedLmsExam.duration;
	      }
	
	      if (!data.configuration.examOpenDate) {
	        data.configuration.examOpenDate = (0, _moment2.default)(obx.importedLmsExam.examOpenDate);
	      }
	
	      if (!data.configuration.examCloseDate) {
	        data.configuration.examCloseDate = (0, _moment2.default)(obx.importedLmsExam.examCloseDate);
	      }
	
	      if (!data.url) {
	        data.url = obx.importedLmsExam.examUrl;
	      }
	
	      if (!data.configuration.password) {
	        data.configuration.password = obx.importedLmsExam.password;
	      }
	
	      if (obx.importedLmsExam && obx.importedLmsExam.examId) {
	        data.configuration.apiExamId = obx.importedLmsExam.examId.toString();
	      }
	    }
	
	    delete data.pendingApprovals;
	    delete data.openSessionEvents;
	
	    data.configuration.instructorAsProctor.forEach(function (el) {
	      delete el.sid;
	    });
	
	    if (!data.configuration.scheduleOpenDate) {
	      data.configuration.scheduleOpenDate = (0, _moment2.default)('1-1-2000 00:00', 'M-D-YYYY HH:mm Z').toISOString();
	    }
	
	    if (!data.configuration.scheduleCloseDate) {
	      data.configuration.scheduleCloseDate = (0, _moment2.default)('1-1-2070 00:00', 'M-D-YYYY HH:mm Z').toISOString();
	    }
	
	    // If proctor approval is required on an
	    // institution level, set it to true
	    if (_SettingsStore2.default.settings && _SettingsStore2.default.settings.requireManagerProctorApproval) {
	      data.requireApproval = true;
	    }
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/exams', data).then(function (response) {
	      component.setState({
	        examSid: response.data.sid
	      }, function () {
	        func(response.data.sid, response.data.configuration.sid);
	      });
	      obx.examSid = response.data.sid;
	
	      _SessionStore2.default.finishLoading('CreateExam');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  /**
	   * updateExamData - Updates obx.exam so that it can be used in all components
	   * through the ExamStore
	   * @param {object} data - New information to be saved
	   * @param {boolean} isConfiguration - Determines if data should go inside of configuration object
	   * @param {string} categorySid - Unique identifier(TS) used for modality options
	   */
	  updateExamData: (0, _mobx.action)(function (data, isConfiguration, categorySid) {
	    var newData = null;
	
	    if (isConfiguration) {
	      for (var key in data.configuration) {
	        if (key) {
	          if (key === 'modalityOptions') {
	            // We don't need to check for categorySid here because
	            // modality options are now always tied to a specific categorySid.
	            // If we have new modality options we have a categorySid as well
	            if (!obx.exam.configuration[key]) {
	              obx.exam.configuration[key] = {};
	            }
	            obx.exam.configuration[key][categorySid] = data.configuration[key][categorySid];
	          } else {
	            newData = data.configuration[key];
	            obx.exam.configuration[key] = newData;
	          }
	
	          // Deletes modality options for a proctor types that aren't in the proctor type array
	          if (key === 'proctorTypes') {
	            for (var subcategorySid in obx.exam.configuration.modalityOptions) {
	              if (!data.configuration.proctorTypes.includes(subcategorySid)) {
	                delete obx.exam.configuration.modalityOptions[subcategorySid];
	
	                // Deletes the modality option object when it will be empty
	                if (Object.keys(obx.exam.configuration.modalityOptions).length === 0) {
	                  delete obx.exam.configuration.modalityOptions;
	                }
	              }
	            }
	          }
	        }
	      }
	    } else {
	      for (var _key in data) {
	        if (_key) {
	          newData = data[_key];
	          obx.exam[_key] = newData;
	        }
	      }
	    }
	  }),
	  // Update exam API call
	  updateExam: (0, _mobx.action)(function (sid, func, skipLoad, courseSid) {
	    if (!skipLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'UpdateExam');
	    }
	
	    var course = courseSid;
	
	    if (!course) {
	      course = _SessionStore2.default.userData.courseSid;
	    }
	
	    var data = Object.assign({}, obx.exam);
	
	    // Remove unnecessary properties
	    delete data.sid;
	    delete data.applicationInstallSid;
	    delete data.courseSid;
	    delete data.createdDate;
	    delete data.editDate;
	    delete data.configuration.sid;
	    delete data.configuration.examSid;
	    delete data.configuration.exam;
	    delete data.configuration.enrollmentSid;
	    delete data.configuration.createdDate;
	    delete data.configuration.editDate;
	    delete data.configuration.approved;
	    delete data.configuration.approvedBy;
	    delete data.summary;
	    delete data.pendingApprovals;
	    delete data.openSessionEvents;
	    delete data.configuration.attachments;
	    delete data.configuration.locked;
	    delete data.configuration.attemptsRemaining;
	    delete data.configuration.examConfigurationSid;
	    delete data.configuration.referenceExamConfigurationSid;
	    delete data.course;
	    delete data.configuration.type;
	    delete data.bVirtualTitle;
	
	    if (data.contactUserSid === null) {
	      delete data.contactUserSid;
	    }
	
	    if (data.configuration.instructorAsProctor) {
	      data.configuration.instructorAsProctor.forEach(function (el) {
	        delete el.createdDate;
	        delete el.editDate;
	
	        if (el.sid === null) {
	          delete el.sid;
	        }
	      });
	    } else {
	      data.configuration.instructorAsProctor = [];
	    }
	
	    // If proctor approval is required on an
	    // institution level, set it to true
	    if (_SettingsStore2.default.settings && _SettingsStore2.default.settings.requireManagerProctorApproval) {
	      data.requireApproval = true;
	    }
	
	    if (data.configuration.password === null) {
	      delete data.configuration.password;
	    }
	
	    if (data.configuration.url === null) {
	      delete data.configuration.url;
	    }
	
	    if (data.type && data.type.toLowerCase() === 'written' && data.configuration.password) {
	      delete data.configuration.password;
	    }
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + course + '/exams/' + sid, data).then(function (response) {
	      if (!skipLoad) {
	        _SessionStore2.default.finishLoading('UpdateExam');
	      }
	
	      if (func) {
	        func(response.data.sid, response.data.configuration.sid);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete exam
	  deleteExam: (0, _mobx.action)(function (examSid, courseSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'deleteExam');
	
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + courseSid + '/exams/' + examSid).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateExam');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Set initial configuration data
	  setConfigurationData: (0, _mobx.action)(function () {
	    obx.configuration = null;
	    obx.configuration = Object.assign({}, obx.defaultExam.configuration);
	
	    if (obx.defaultExam.configuration.instructorAsProctor) {
	      obx.configuration.instructorAsProctor = [].concat(_toConsumableArray(obx.defaultExam.configuration.instructorAsProctor));
	    } else {
	      obx.configuration.instructorAsProctor = [];
	    }
	
	    // Remove unnecessary properties
	    delete obx.configuration.sid;
	    delete obx.configuration.exam;
	    delete obx.configuration.enrollmentSid;
	    delete obx.configuration.createdDate;
	    delete obx.configuration.editDate;
	    delete obx.configuration.approved;
	    delete obx.configuration.approvedBy;
	  }),
	  // Reset custom configuration data
	  resetConfigurationData: (0, _mobx.action)(function () {
	    obx.customConfiguration = null;
	    obx.configuration = {};
	  }),
	  // Get custom configuration data
	  getConfigurationData: (0, _mobx.action)(function (examSid, sid, courseSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'GetConfiguration');
	    obx.resetConfigurationData();
	
	    var course = courseSid;
	
	    if (!course) {
	      course = _SessionStore2.default.userData.courseSid;
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + course + '/exams/' + examSid + '/configurations/' + sid).then(function (response) {
	      obx.configuration = response.data;
	      _SessionStore2.default.finishLoading('GetConfiguration');
	
	      if (callback) {
	        callback(response.data);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  /**
	   * updateConfigurationData - Updates obx.configuration so that it can be used in
	   * all components through the ExamStore
	   * @param {object} data - new information to save
	   * @param {string} categorySid - Unique identifier(TS) used for modality options
	   */
	  updateConfigurationData: (0, _mobx.action)(function (data, categorySid) {
	    var newData = null;
	
	    for (var key in data) {
	      if (key) {
	        if (key === 'modalityOptions') {
	          if (!obx.configuration[key]) {
	            obx.configuration[key] = {};
	          }
	          obx.configuration[key][categorySid] = data[key][categorySid];
	        } else {
	          newData = data[key];
	          obx.configuration[key] = newData;
	        }
	
	        // Deletes modality options for a proctor types that aren't in the proctor type array
	        if (key === 'proctorTypes') {
	          for (var subcategorySid in obx.configuration.modalityOptions) {
	            if (!data.proctorTypes.includes(subcategorySid)) {
	              delete obx.configuration.modalityOptions[subcategorySid];
	
	              // Deletes the modality option object when it will be empty
	              if (Object.keys(obx.configuration.modalityOptions).length === 0) {
	                delete obx.configuration.modalityOptions;
	              }
	            }
	          }
	        }
	      }
	    }
	  }),
	  // Update exam configuration api call
	  updateConfiguration: (0, _mobx.action)(function (examSid, sid, func, courseSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateConfiguration');
	
	    var course = courseSid;
	
	    if (!course) {
	      course = _SessionStore2.default.userData.courseSid;
	    }
	
	    var data = Object.assign({}, obx.configuration);
	
	    var configurationSid = sid;
	
	    // If we’re approving a change request, use that sid
	    if (data.referenceExamConfigurationSid) {
	      configurationSid = data.referenceExamConfigurationSid;
	    }
	
	    // Remove unnecessary properties
	    delete data.sid;
	    delete data.configuration;
	    delete data.exam;
	    delete data.examSid;
	    delete data.enrollmentSid;
	    delete data.createdDate;
	    delete data.editDate;
	    delete data.approved;
	    delete data.approvedBy;
	    delete data.locked;
	    delete data.attemptsRemaining;
	    delete data.type;
	
	    if (data.referenceExamConfigurationSid) {
	      data.refConfigSid = sid;
	      delete data.referenceExamConfigurationSid;
	    }
	
	    if (data.attachments.length === 0 || !data.refConfigSid) {
	      delete data.attachments;
	    }
	
	    if (!data.attachments && data.refConfigSid) {
	      delete data.refConfigSid;
	    }
	
	    if (data.configuration && data.configuration.instructorAsProctor) {
	      data.configuration.instructorAsProctor.forEach(function (el) {
	        delete el.createdDate;
	        delete el.editDate;
	        delete el.sid;
	      });
	    }
	
	    if (data.password === null) {
	      delete data.password;
	    }
	
	    if (data.url === null) {
	      delete data.url;
	    }
	
	    data.instructorAsProctor.forEach(function (el) {
	      delete el.sid;
	      delete el.createdDate;
	      delete el.editDate;
	    });
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + course + '/exams/' + examSid + '/configurations/' + configurationSid, data).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateConfiguration');
	
	      if (func) {
	        func(response.data.examSid, response.data.sid);
	      }
	
	      if (callback) {
	        obx.exam.configuration = response.data;
	
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create exam configuration
	  changeRequestSid: null,
	  createConfiguration: (0, _mobx.action)(function (examSid, enrollmentSid, func, referenceExamConfigurationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateConfiguration');
	
	    var data = Object.assign({}, obx.configuration);
	
	    // Add the enrollment sid
	    if (enrollmentSid) {
	      data.enrollmentSid = enrollmentSid;
	    }
	
	    // Add an existing configurationSid
	    if (referenceExamConfigurationSid) {
	      data.referenceExamConfigurationSid = referenceExamConfigurationSid;
	    } else {
	      delete data.referenceExamConfigurationSid;
	    }
	
	    // Remove unnecessary properties
	    delete data.examSid;
	    delete data.attachments;
	    delete data.locked;
	    delete data.attemptsRemaining;
	    delete data.type;
	
	    data.instructorAsProctor.forEach(function (el) {
	      delete el.createdDate;
	      delete el.editDate;
	      delete el.sid;
	    });
	
	    if (data.password === null) {
	      delete data.password;
	    }
	
	    if (data.url === null) {
	      delete data.url;
	    }
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/exams/' + examSid + '/configurations', data).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateConfiguration');
	
	      if (referenceExamConfigurationSid) {
	        obx.changeRequestSid = response.data.sid;
	      }
	
	      obx.configuration.sid = response.data.sid;
	
	      if (func) {
	        func(response.data.examSid, response.data.sid, response.data.attachments);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  deleteConfiguration: (0, _mobx.action)(function (examSid, sid) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteConfiguration');
	
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/exams/' + examSid + '/configurations/' + sid).then(function (response) {
	      obx.getEnrollments(examSid);
	      _SessionStore2.default.finishLoading('DeleteConfiguration');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  examSession: {
	    status: '',
	    sessionType: '',
	    appointmentDate: '',
	    dateScheduled: '',
	    dateApproved: '',
	    proctor: {
	      firstName: '',
	      lastName: '',
	      phone: ''
	    },
	    location: {
	      accountName: '',
	      address1: '',
	      address2: '',
	      region: '',
	      country: '',
	      postalCode: '',
	      place: '',
	      latitude: '',
	      longitude: ''
	    }
	  },
	  getExamSession: (0, _mobx.action)(function (examSid, sessionSid, callback, scheduled) {
	    _SessionStore2.default.startLoading('Loading…', 'GetExamSession');
	    var installSid = _SessionStore2.default.userData.installSid;
	
	
	    _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid).then(function (response) {
	      obx.examSession = response.data;
	      obx.exam.configuration = response.data.examConfiguration;
	
	      // If we’re requiring a scheduled session, make sure the
	      // status is scheduled and re-run the call if it’s not
	      if (scheduled && response.data.status === 'Needs Proctor') {
	        obx.getExamSession(examSid, sessionSid, callback, scheduled);
	      } else {
	        _SessionStore2.default.finishLoading('GetExamSession');
	      }
	
	      if (callback) {
	        callback(response);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  setExamSessionAsNeedsReview: (0, _mobx.action)(function (examSid, installSid, sessionSid, callback) {
	    var patch_data = { reviewStatus: false };
	
	    _SessionStore2.default.startLoading('Loading…', "setExamSessionAsNeedsReview");
	
	    _config.api.patch('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/reviewStatus', patch_data).then(function (response) {
	      _SessionStore2.default.showToaster("Session marked as Unreviewed!", "success");
	      if (callback) {
	        callback();
	      }
	      _SessionStore2.default.finishLoading('setExamSessionAsNeedsReview');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get exam session by accessCode
	  getExamSessionByAccessCode: (0, _mobx.action)(function (accessCode) {
	    _SessionStore2.default.startLoading('Loading…', 'GetExamSessionByAccessCode');
	
	    _config.api.get('/sessions/' + accessCode).then(function (response) {
	      obx.examSession = response.data;
	      _SessionStore2.default.finishLoading('GetExamSessionByAccessCode');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  examEvents: [],
	  // Get incidents for an exam
	  getExamEvents: (0, _mobx.action)(function (examSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetExamEvents');
	    var installSid = _SessionStore2.default.userData.installSid;
	
	    _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/events?limit=500').then(function (response) {
	      obx.examEvents = response.data.results;
	      _SessionStore2.default.finishLoading('GetExamEvents');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get incidents for a session
	  sessionEvents: [],
	  getSessionEvents: (0, _mobx.action)(function (installSid, examSid, sessionSid, session) {
	    _SessionStore2.default.startLoading('Loading…', 'GetSessionEvents');
	
	    obx.sessionEvents = [];
	
	    var dataInstallSid = installSid;
	
	    if (!dataInstallSid) {
	      dataInstallSid = _SessionStore2.default.userData.installSid;
	    }
	
	    _config.api.get('/installs/' + dataInstallSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events').then(function (response) {
	      obx.sessionEvents = response.data.results;
	
	      // Add session data to each incident
	      if (session) {
	        obx.sessionEvents.forEach(function (incident) {
	          incident.session = session;
	        });
	      }
	
	      _SessionStore2.default.finishLoading('GetSessionEvents');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Reset session incidents
	  resetSessionEvents: (0, _mobx.action)(function () {
	    obx.sessionEvents = [];
	  }),
	  // Get a specific incident
	  incident: {},
	  getSingleSessionEvent: (0, _mobx.action)(function (installSid, examSid, sessionSid, incidentSid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetSpecificEvent');
	
	    obx.incident = {};
	
	    _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events/' + incidentSid).then(function (response) {
	      obx.incident = response.data;
	
	      if (component) {
	        component.setState({
	          incidentData: response.data
	        });
	
	        // Make sure date is the right format
	        var incidentData = Object.assign({}, component.state.incidentData);
	        incidentData.eventTime = response.data.eventTime;
	
	        component.setState({
	          incidentData: incidentData
	        });
	        component.setState({
	          date: (0, _moment2.default)(response.data.eventTime)
	        });
	      }
	
	      _SessionStore2.default.finishLoading('GetSpecificEvent');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  incidentTypes: [],
	  // Get incident types
	  getIncidentTypes: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetIncidentTypes');
	
	    obx.incidentTypes = [];
	
	    _config.api.get('/sessions/events/types').then(function (response) {
	      obx.incidentTypes = response.data.results;
	      _SessionStore2.default.finishLoading('GetIncidentTypes');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Close Incident
	  closeExamEvent: (0, _mobx.action)(function (examSid, event, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CloseExamEvent');
	    var installSid = _SessionStore2.default.userData.installSid;
	
	    var sessionSid = event.examSessionSid;
	    var eventReportSid = event.sid;
	    _config.api.put('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events/' + eventReportSid + '/close').then(function () {
	      _SessionStore2.default.finishLoading('CloseExamEvent');
	      event.status = 'Closed';
	      callback();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create session incident
	  createSessionEvent: (0, _mobx.action)(function (installSid, examSid, sessionSid, data, func) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateSessionEvent');
	
	    delete data.eventType;
	
	    _config.api.post('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events', data).then(function () {
	      obx.getSessionEvents(installSid, examSid, sessionSid);
	      _SessionStore2.default.finishLoading('CreateSessionEvent');
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update session incident
	  updateSessionEvent: (0, _mobx.action)(function (installSid, examSid, sessionSid, eventSid, data, func) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateSessionEvent');
	
	    delete data.sid;
	    delete data.examSessionSid;
	    delete data.createdDate;
	    delete data.eventType;
	
	    _config.api.put('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events/' + eventSid, data).then(function () {
	      obx.getSessionEvents(installSid, examSid, sessionSid);
	      _ManagerStore2.default.incidentSid = null;
	      _SessionStore2.default.finishLoading('UpdateSessionEvent');
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete session incident
	  deleteSessionEvent: (0, _mobx.action)(function (installSid, examSid, sessionSid, eventSid) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteSessionEvent');
	
	    _config.api.delete('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events/' + eventSid).then(function () {
	      _SessionStore2.default.finishLoading('DeleteSessionEvent');
	      obx.getSessionEvents(installSid, examSid, sessionSid);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update attachments
	  examAttachments: null,
	  examFiles: null,
	  updateExamAttachments: (0, _mobx.action)(function (examSid, configurationSid, data, func) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateExamAttachments');
	
	    var _SessionStore$userDat = _SessionStore2.default.userData,
	        installSid = _SessionStore$userDat.installSid,
	        courseSid = _SessionStore$userDat.courseSid;
	
	
	    var formData = new FormData();
	
	    if (data.attachments) {
	      for (var i = 0; i < data.attachments.length; i++) {
	        formData.append('attachments[]', data.attachments[i]);
	      }
	    } else if (data.examFiles) {
	      for (var _i = 0; _i < data.examFiles.length; _i++) {
	        formData.append('examFiles[]', data.examFiles[_i]);
	      }
	    }
	
	    var configSid = configurationSid;
	
	    if (obx.changeRequestSid) {
	      configSid = obx.changeRequestSid;
	    }
	
	    _config.api.put('/installs/' + installSid + '/courses/' + courseSid + '/exams/' + examSid + '/configurations/' + configSid + '/attachments', formData).then(function () {
	      _SessionStore2.default.finishLoading('UpdateExamAttachments');
	
	      obx.changeRequestSid = null;
	
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete exam attachments API call
	  deleteAttachments: [],
	  deleteExamAttachments: (0, _mobx.action)(function (examSid, examConfigSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteExamAttachments');
	
	    var installSid = _SessionStore2.default.userData.installSid;
	    var courseSid = _SessionStore2.default.userData.courseSid;
	
	    _config.api.delete('/installs/' + installSid + '/courses/' + courseSid + '/exams/' + examSid + '/configurations/' + examConfigSid + '/attachments', { data: data }).then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteExamAttachments');
	
	      obx.deleteAttachments = [];
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get exam configurations awaiting approval
	  examApprovals: [],
	  examApprovalsNext: null,
	  getExamApprovals: (0, _mobx.action)(function (filters) {
	    _SessionStore2.default.startLoading('Loading…', 'GetExamApprovals');
	
	    obx.examApprovals = [];
	
	    var query = '?limit=50&sortKeys=examOpenDate';
	
	    if (filters) {
	      for (var key in filters) {
	        if (filters[key]) {
	          query += '&' + key + '=' + filters[key];
	        }
	      }
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/unapprovedConfigurations' + query).then(function (response) {
	      obx.examApprovals = response.data.results;
	
	      // Set pagination next url
	      if (response.data.next) {
	        // API returns a url with a different domain for the next link
	        // so create an anchor element and set its href to the next link
	        // and then grab the pathname and query from that
	        var nextUrl = (0, _helpers.getPath)(response.data.next);
	        nextUrl = nextUrl.replace('/v1', '');
	        obx.examApprovalsNext = nextUrl;
	      } else {
	        obx.examApprovalsNext = null;
	      }
	
	      _SessionStore2.default.finishLoading('GetExamApprovals');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update exam approval
	  updateExamApproval: (0, _mobx.action)(function (examSid, configurationSid, data, callback, courseSid) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateExamApproval');
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + courseSid + '/exams/' + examSid + '/configurations/' + configurationSid + '/status', data).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateExamApproval');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update configuration status
	  updateConfigurationStatus: (0, _mobx.action)(function (examSid, configurationSid, data, callback, backgroundLoad) {
	    if (!backgroundLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'UpdateConfigurationStatus');
	    } else {
	      _SessionStore2.default.startBackgroundLoading('UpdateConfigurationStatus');
	    }
	
	    var query = '';
	
	    if (examSid) {
	      query = '?examSid=' + examSid;
	    }
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/examConfigurations/' + configurationSid + '/status' + query, data).then(function (response) {
	      if (!backgroundLoad) {
	        _SessionStore2.default.finishLoading('UpdateConfigurationStatus');
	      } else {
	        _SessionStore2.default.finishBackgroundLoading('UpdateConfigurationStatus');
	      }
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create communication proxy
	  proxyNumbers: {},
	  createCommProxy: (0, _mobx.action)(function (examSid, sessionSid) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateCommProxy');
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/communicationProxy').then(function (response) {
	      obx.proxyNumbers = response.data;
	      _SessionStore2.default.finishLoading('CreateCommProxy');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get communication proxy
	  getCommProxy: (0, _mobx.action)(function (examSid, sessionSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetCommProxy');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/communicationProxy').then(function (response) {
	      obx.proxyNumbers = response.data;
	      _SessionStore2.default.finishLoading('GetCommProxy');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get exams from LMS (temporarily hard-coded)
	  lmsExams: [],
	  getLMSExams: (0, _mobx.action)(function (failedCallback, passedCallback) {
	    _SessionStore2.default.startLoading('Loading…', 'getLMSExams');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/lms-exams').then(function (response) {
	      obx.lmsExams = response.data.results;
	
	      _SessionStore2.default.finishLoading('getLMSExams');
	
	      // Strip out HTML tags from descriptions
	      for (var i = 0; i < obx.lmsExams.length; i++) {
	        var description = obx.lmsExams[i].description;
	        var div = document.createElement('div');
	        div.innerHTML = description;
	        obx.lmsExams[i].description = div.textContent || div.innerText || '';
	      }
	    }).catch(function (error) {
	      if (failedCallback) {
	        _SessionStore2.default.finishLoading('getLMSExams');
	        failedCallback();
	      } else {
	        _SessionStore2.default.throwError(error);
	      }
	    });
	  }),
	  // Use LMS exam for new exam
	  importedLmsExam: {},
	  selectLMSExam: (0, _mobx.action)(function (i) {
	    obx.importedLmsExam = obx.lmsExams[i];
	  }),
	  // Reset LMS exam data
	  resetLMSExams: (0, _mobx.action)(function () {
	    obx.lmsExams = [];
	    obx.importedLmsExam = {};
	  }),
	  sessionMeta: null,
	  getSessionMeta: (0, _mobx.action)(function (examSid, sessionSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'getSessionMeta');
	    _SessionStore2.default.modalLoaded = false;
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/meta').then(function (response) {
	      obx.sessionMeta = response.data;
	
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.modalLoaded = true;
	
	      _SessionStore2.default.finishLoading('getSessionMeta');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  /**
	   * getAutomatedOptions - Gets all automated exam options
	   */
	  automatedOptions: [],
	
	  getAutomatedOptions: (0, _mobx.action)(function (categorySid) {
	    _config.api.get('/proctors/categories/' + categorySid + '/modalityOptions').then(function (response) {
	      obx.automatedOptions = response.data.optionGroups;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  /**
	   * getModalityPresets - Gets preset configurations for exam modality settings
	   */
	  modalityPresets: [],
	
	  getModalityPresets: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startBackgroundLoading('getModalityPresets');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/modalityPresets').then(function (response) {
	      obx.modalityPresets = response.data.presets;
	
	      _SessionStore2.default.finishBackgroundLoading('getModalityPresets');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  /**
	   * getModalityPreset - Gets an individual modality preset by SID
	   */
	  modalityPreset: null,
	
	  getModalityPreset: (0, _mobx.action)(function (sid, callback) {
	    obx.modalityPresets.forEach(function (preset) {
	      if (preset.sid === sid) {
	        obx.modalityPreset = preset;
	      }
	    });
	
	    if (callback) {
	      callback();
	    }
	  }),
	
	  /**
	   * getSessionStart - Gets exam, course, session, etc. data to send to automated extension
	   * @param {string} examSid
	   * @param {string} sessionSid
	   * @param {boolean} hybrid
	   * @param {function} callback
	   */
	  sessionStartData: null,
	
	  getSessionStart: (0, _mobx.action)(function (examSid, sessionSid, hybrid, callback) {
	    var url = '/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/start';
	
	    if (hybrid) {
	      url += '?hybrid=true';
	    }
	
	    _config.api.get(url).then(function (response) {
	      obx.sessionStartData = response.data;
	
	      if (!obx.sessionStartData.exam.configuration.modalityOptions) {
	        obx.sessionStartData.exam.configuration.modalityOptions = obx.sessionStartData.modalityOptions;
	      }
	
	      if (callback) {
	        callback((0, _mobx.toJS)(obx.sessionStartData));
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  getSessionStartOutside: (0, _mobx.action)(function (examSid, sessionSid, installSid) {
	    var url = '/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/start';
	
	    return _config.api.get(url).then(function (response) {
	      return (0, _mobx.toJS)(response.data);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  /**
	     * examFlags - A "flag" is an Automated Session Annotation of severity "red".
	     * Get all automated "flags" for a given exam.
	     */
	  examFlags: {},
	
	  getExamFlags: (0, _mobx.action)(function (examSid) {
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/annotationsByStudent?severity=red').then(function (response) {
	
	      obx.examFlags = response.data;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  /**
	   * Raise the whoops status annotation when the extension is not installed or is outdated
	   */
	  raiseAnnotation: (0, _mobx.action)(function (examSid, sessionSid, annotationType) {
	
	    var body = {
	      title: annotationType.title,
	      severity: annotationType.severity || "yellow",
	      type: annotationType.type || "manual",
	      sessionTime: annotationType.sessionTime || 0,
	      details: JSON.stringify(annotationType.details) || "",
	      createdBy: "system",
	      status: "pending review"
	    };
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/annotations', body).then(function (response) {
	      console.log(response);
	    }).catch(function (e) {
	      console.log('raise Annotation error', e);
	      console.error(e.message);
	    });
	  }),
	
	  /**
	   * Set the reviewed status of an automated session
	   *
	   * @function updateReviewStatus
	   * @param {object} urlData
	   * @param {object} payload
	   */
	  updateReviewStatus: function updateReviewStatus(urlData, payload) {
	    var examSid = urlData.examSid,
	        sessionSid = urlData.sessionSid;
	
	
	    var url = '/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/reviewStatus';
	
	    _config.api.patch(url, payload).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  },
	  getOnboardingUrl: function getOnboardingUrl(examSid, sessionSid, installSid) {
	
	    _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/onboard').then(function (response) {
	      console.log(response);
	      return response;
	    }).catch(function (e) {
	      console.error(e);
	    });
	  }
	
	});
	
	// Initialize exam.platformVersion with the default value
	obx.exam.platformVersion = obx.defaultPlatformVersion;
	
	exports.default = obx;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routingStore = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobxReactRouter = __webpack_require__(1033);
	
	var _reactRouter = __webpack_require__(15);
	
	var _App = __webpack_require__(734);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _AppLoggedOut = __webpack_require__(735);
	
	var _AppLoggedOut2 = _interopRequireDefault(_AppLoggedOut);
	
	var _NotFound = __webpack_require__(811);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _CloseWindow = __webpack_require__(744);
	
	var _CloseWindow2 = _interopRequireDefault(_CloseWindow);
	
	var _Unauthorized = __webpack_require__(877);
	
	var _Unauthorized2 = _interopRequireDefault(_Unauthorized);
	
	var _Dashboard = __webpack_require__(760);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _ExamDashboard = __webpack_require__(776);
	
	var _ExamDashboard2 = _interopRequireDefault(_ExamDashboard);
	
	var _LocateProctor = __webpack_require__(354);
	
	var _LocateProctor2 = _interopRequireDefault(_LocateProctor);
	
	var _ExamType = __webpack_require__(788);
	
	var _ExamType2 = _interopRequireDefault(_ExamType);
	
	var _ExamEdit = __webpack_require__(786);
	
	var _ExamEdit2 = _interopRequireDefault(_ExamEdit);
	
	var _ExamAttachments = __webpack_require__(785);
	
	var _ExamAttachments2 = _interopRequireDefault(_ExamAttachments);
	
	var _Enroll = __webpack_require__(767);
	
	var _Enroll2 = _interopRequireDefault(_Enroll);
	
	var _EnrollMobile = __webpack_require__(769);
	
	var _EnrollMobile2 = _interopRequireDefault(_EnrollMobile);
	
	var _Transactions = __webpack_require__(731);
	
	var _Transactions2 = _interopRequireDefault(_Transactions);
	
	var _InstitutionTransactions = __webpack_require__(726);
	
	var _InstitutionTransactions2 = _interopRequireDefault(_InstitutionTransactions);
	
	var _MFASetup = __webpack_require__(728);
	
	var _MFASetup2 = _interopRequireDefault(_MFASetup);
	
	var _MFAChallenge = __webpack_require__(727);
	
	var _MFAChallenge2 = _interopRequireDefault(_MFAChallenge);
	
	var _FundingRules = __webpack_require__(353);
	
	var _FundingRules2 = _interopRequireDefault(_FundingRules);
	
	var _Inbox = __webpack_require__(800);
	
	var _Inbox2 = _interopRequireDefault(_Inbox);
	
	var _Reports = __webpack_require__(825);
	
	var _Reports2 = _interopRequireDefault(_Reports);
	
	var _Downloads = __webpack_require__(820);
	
	var _Downloads2 = _interopRequireDefault(_Downloads);
	
	var _Roster = __webpack_require__(827);
	
	var _Roster2 = _interopRequireDefault(_Roster);
	
	var _Users = __webpack_require__(828);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _Admins = __webpack_require__(732);
	
	var _Admins2 = _interopRequireDefault(_Admins);
	
	var _CourseOfferings = __webpack_require__(758);
	
	var _CourseOfferings2 = _interopRequireDefault(_CourseOfferings);
	
	var _Settings = __webpack_require__(853);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _Integrations = __webpack_require__(793);
	
	var _Integrations2 = _interopRequireDefault(_Integrations);
	
	var _ChooseProctorType = __webpack_require__(857);
	
	var _ChooseProctorType2 = _interopRequireDefault(_ChooseProctorType);
	
	var _Vouchers = __webpack_require__(886);
	
	var _Vouchers2 = _interopRequireDefault(_Vouchers);
	
	var _AddVoucher = __webpack_require__(375);
	
	var _AddVoucher2 = _interopRequireDefault(_AddVoucher);
	
	var _SelfManagedAccounts = __webpack_require__(831);
	
	var _SelfManagedAccounts2 = _interopRequireDefault(_SelfManagedAccounts);
	
	var _SupportTickets = __webpack_require__(876);
	
	var _SupportTickets2 = _interopRequireDefault(_SupportTickets);
	
	var _Session = __webpack_require__(729);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _ExamApprovals = __webpack_require__(738);
	
	var _ExamApprovals2 = _interopRequireDefault(_ExamApprovals);
	
	var _SessionExpired = __webpack_require__(834);
	
	var _SessionExpired2 = _interopRequireDefault(_SessionExpired);
	
	var _Maintenance = __webpack_require__(798);
	
	var _Maintenance2 = _interopRequireDefault(_Maintenance);
	
	var _SignOut = __webpack_require__(854);
	
	var _SignOut2 = _interopRequireDefault(_SignOut);
	
	var _SignedOut = __webpack_require__(855);
	
	var _SignedOut2 = _interopRequireDefault(_SignedOut);
	
	var _SessionStart = __webpack_require__(843);
	
	var _SessionStart2 = _interopRequireDefault(_SessionStart);
	
	var _StartVTC = __webpack_require__(222);
	
	var _StartVTC2 = _interopRequireDefault(_StartVTC);
	
	var _ChooseExam = __webpack_require__(856);
	
	var _ChooseExam2 = _interopRequireDefault(_ChooseExam);
	
	var _BlackoutDates = __webpack_require__(742);
	
	var _BlackoutDates2 = _interopRequireDefault(_BlackoutDates);
	
	var _VTCNotice = __webpack_require__(884);
	
	var _VTCNotice2 = _interopRequireDefault(_VTCNotice);
	
	var _SessionEndAutomated = __webpack_require__(833);
	
	var _SessionEndAutomated2 = _interopRequireDefault(_SessionEndAutomated);
	
	var _ProvisionExam = __webpack_require__(887);
	
	var _ProvisionExam2 = _interopRequireDefault(_ProvisionExam);
	
	var _AppOutside = __webpack_require__(736);
	
	var _AppOutside2 = _interopRequireDefault(_AppOutside);
	
	var _AppOutsideOnboard = __webpack_require__(737);
	
	var _AppOutsideOnboard2 = _interopRequireDefault(_AppOutsideOnboard);
	
	var _SessionManager = __webpack_require__(813);
	
	var _SessionManager2 = _interopRequireDefault(_SessionManager);
	
	var _TimeZone = __webpack_require__(814);
	
	var _TimeZone2 = _interopRequireDefault(_TimeZone);
	
	var _stores = __webpack_require__(100);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import SessionDetails from './app/components/Outside/SessionDetails';
	
	// Import stores
	
	
	// External Components
	
	// import InstructorAppointments from './app/components/CourseDashboard/InstructorAppointments';
	// Import React
	var routingStore = exports.routingStore = new _mobxReactRouter.RouterStore();
	// import { createHistory, useBasename } from 'history';
	
	// Import components
	
	
	// Import dependencies
	
	
	var stores = { routing: routingStore, store: _stores2.default };
	
	var history = (0, _mobxReactRouter.syncHistoryWithStore)(_reactRouter.hashHistory, routingStore);
	
	// Add the user agent as an attribute on the document
	var ua = navigator.userAgent;
	document.querySelector('html').setAttribute('data-ua', ua);
	
	// Flag Firefox
	if (ua.indexOf('Firefox') > -1) {
	  document.querySelector('html').className += ' firefox';
	}
	
	// Flag Safari
	if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') < 0) {
	  document.querySelector('html').className += ' safari';
	}
	
	// Flag IE 10
	if (ua.indexOf('MSIE 10.0') > -1) {
	  document.querySelector('html').className += ' ie-true lt-ie11';
	}
	
	// Flag IE 11
	if (!!window.MSInputMethodContext && !!document.documentMode) {
	  document.querySelector('html').className += ' ie-true';
	}
	
	// Flag Edge
	if (ua.indexOf('Edge') > -1) {
	  document.querySelector('html').className += ' ie-true';
	}
	
	// Flag Puffin
	if (ua.indexOf('Puffin') > -1) {
	  document.querySelector('html').className += ' puffin';
	}
	
	// Aids with button focus styles
	document.querySelector('body').addEventListener('click', function (e) {
	  if (e.target.className && typeof e.target.className === 'string') {
	    if (e.target.className.indexOf('btn') > -1 || e.target.className.indexOf('calendar__nav') > -1) {
	      e.target.className += ' btn-clicked';
	
	      e.target.addEventListener('blur', function (e) {
	        e.target.className = e.target.className.replace('btn-clicked', '');
	      });
	    }
	  }
	});
	
	// Detect touch devices
	if ('ontouchstart' in document.documentElement) {
	  document.querySelector('html').className += ' touch';
	}
	
	// Track pageviews
	var gaTimeout = null;
	
	history.listen(function (location) {
	  // Track on route change
	  if (window.ga) {
	    trackPageview(location.pathname + location.search);
	  }
	});
	
	// Track on initial load
	trackPageview(history.getCurrentLocation().pathname + history.getCurrentLocation().search);
	
	function sanitizeUrl(url) {
	  // Make sure there’s a leading slash
	  if (url.charAt(0) !== '/') {
	    url = '/' + url;
	  }
	
	  // Replace sid segments with placeholders
	  if (url.indexOf('/course/CU') > -1) {
	    // Course sid
	    url = url.replace(/(\/course\/)\w+/, '$1{courseSid}');
	  }
	
	  if (url.indexOf('/exam/EX') > -1) {
	    // Exam sid
	    url = url.replace(/(\/exam\/)\w+/, '$1{examSid}');
	  }
	
	  if (url.indexOf('/exams/EX') > -1) {
	    // Exam sid
	    url = url.replace(/(\/exams\/)\w+/, '$1{examSid}');
	  }
	
	  if (url.indexOf('/edit/EX') > -1) {
	    // Edit exam sid
	    url = url.replace(/(\/edit\/)\w+/, '$1{examSid}');
	  }
	
	  if (url.indexOf('/session/ES') > -1) {
	    // Session sid
	    url = url.replace(/(\/session\/)\w+/, '$1{sessionSid}');
	  }
	
	  if (url.indexOf('session=ES') > -1) {
	    // Enrollment sid param
	    url = url.replace(/(session=)\w+/, '$1{sessionSid}');
	  }
	
	  if (url.indexOf('/configuration/EC') > -1) {
	    // Configuration sid
	    url = url.replace(/(\/configuration\/)\w+/, '$1{configurationSid}');
	  }
	
	  if (url.indexOf('accommodation=EC') > -1) {
	    // Configuration sid param
	    url = url.replace(/(accommodation=)\w+/, '$1{configurationSid}');
	  }
	
	  if (url.indexOf('/accommodation/EN') > -1) {
	    // Enrollment sid
	    url = url.replace(/(\/accommodation\/)\w+/, '$1{enrollmentSid}');
	  }
	
	  if (url.indexOf('enrollment=EN') > -1) {
	    // Enrollment sid param
	    url = url.replace(/(enrollment=)\w+/, '$1{enrollmentSid}');
	  }
	
	  if (url.indexOf('/group/PG') > -1) {
	    // Proctor group sid
	    url = url.replace(/(\/group\/)\w+/, '$1{group}');
	  }
	
	  if (url.indexOf('/view/MT') > -1) {
	    // View message thread sid
	    url = url.replace(/(\/view\/)\w+/, '$1{messageThreadSid}');
	  }
	
	  if (url.indexOf('/view/US') > -1) {
	    // View user sid
	    url = url.replace(/(\/view\/)\w+/, '$1{userSid}');
	  }
	
	  if (url.indexOf('/view/ST') > -1) {
	    // View support ticket sid
	    url = url.replace(/(\/view\/)\w+/, '$1{supportTicketSid}');
	  }
	
	  if (url.indexOf('/edit/US') > -1) {
	    // Edit user sid
	    url = url.replace(/(\/edit\/)\w+/, '$1{userSid}');
	  }
	
	  if (url.indexOf('/edit/CO') > -1) {
	    // Edit course offering sid
	    url = url.replace(/(\/edit\/)\w+/, '$1{offeringSid}');
	  }
	
	  if (url.indexOf('/edit/PA') > -1) {
	    // Edit proctor account sid
	    url = url.replace(/(\/edit\/)\w+/, '$1{proctorAccountSid}');
	  }
	
	  if (url.indexOf('/edit/FR') > -1) {
	    // Edit funding rule sid
	    url = url.replace(/(\/edit\/)\w+/, '$1{fundingRuleSid}');
	  }
	
	  if (url.indexOf('/edit/VO') > -1) {
	    // Edit voucher sid
	    url = url.replace(/(\/edit\/)\w+/, '$1{voucherSid}');
	  }
	
	  if (url.indexOf('/edit/BD') > -1) {
	    // Edit blackout date sid
	    url = url.replace(/(\/edit\/)\w+/, '$1{blackoutDateSid}');
	  }
	
	  return url;
	}
	
	function trackPageview(url) {
	  if (url.indexOf('?token=') > -1) {
	    url = '/';
	  }
	
	  // Wait until ga function is available
	  var gaDelay = setInterval(function () {
	    if (window.ga) {
	      clearInterval(gaDelay);
	
	      // Make sure we don't send the event multiple times
	      gaTimeout = setTimeout(function () {
	        clearTimeout(gaTimeout);
	        var cleanUrl = sanitizeUrl(url);
	        window.ga('send', 'pageview', cleanUrl);
	      }, 500);
	    }
	  }, 100);
	}
	
	// Routes
	var router = _react2.default.createElement(
	  _mobxReact.Provider,
	  stores,
	  _react2.default.createElement(
	    _reactRouter.Router,
	    Object.assign({ history: history }, stores),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'account',
	        component: _AppLoggedOut2.default
	      },
	      _react2.default.createElement(_reactRouter.Route, { path: 'sign-in', component: function component(props) {
	          return _react2.default.createElement(_Session2.default, Object.assign({}, stores, { content: 'SignIn' }));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'mfa-setup', component: function component(props) {
	          return _react2.default.createElement(_MFASetup2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'mfa-challenge', component: function component(props) {
	          return _react2.default.createElement(_MFAChallenge2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'enroll',
	        component: _App2.default,
	        feature: 'onboarding'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Enroll2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'enroll-mobile',
	        component: _AppOutside2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_EnrollMobile2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'proctor-search',
	        component: _App2.default,
	        feature: 'proctorSearch'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_LocateProctor2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'schedule-automated',
	        component: _App2.default,
	        feature: 'schedule'
	      },
	      _react2.default.createElement(_reactRouter.Route, {
	        path: 'exam/:examId/session/:sessionId/configuration/:configurationId',
	        component: function component(props) {
	          return _react2.default.createElement(_ChooseProctorType2.default, Object.assign({}, stores, { automatedOnly: true }));
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: 'exam/:examId/session/:sessionId/configuration/:configurationId/scheduleClosed',
	        component: function component(props) {
	          return _react2.default.createElement(_ChooseProctorType2.default, Object.assign({}, stores, { automatedOnly: true, scheduleClosed: true }));
	        }
	      }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'schedule-session',
	        component: _App2.default,
	        feature: 'schedule'
	      },
	      _react2.default.createElement(_reactRouter.Route, { path: 'exam/:examId/session/:sessionId', component: function component(props) {
	          return _react2.default.createElement(_ChooseProctorType2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'exam/:examId/session/:sessionId/configuration/:configurationId', component: function component(props) {
	          return _react2.default.createElement(_ChooseProctorType2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'exam/:examId/session/:sessionId/configuration/:configurationId/search', component: function component(props) {
	          return _react2.default.createElement(_LocateProctor2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'exam/:examId/session/:sessionId/configuration/:configurationId/search/group/:groupId', component: function component(props) {
	          return _react2.default.createElement(_LocateProctor2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'group/:groupId', component: function component(props) {
	          return _react2.default.createElement(_ChooseExam2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'reschedule-session',
	        component: _App2.default,
	        feature: 'reschedule'
	      },
	      _react2.default.createElement(_reactRouter.Route, { path: 'exam/:examId/session/:sessionId', component: function component(props) {
	          return _react2.default.createElement(_ChooseProctorType2.default, Object.assign({ reschedule: true }, stores));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':examId/search', component: function component(props) {
	          return _react2.default.createElement(_LocateProctor2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'exams',
	        component: _App2.default,
	        feature: 'exams'
	      },
	      _react2.default.createElement(_reactRouter.Route, { path: 'type', component: function component(props) {
	          return _react2.default.createElement(_ExamType2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'add', component: function component(props) {
	          return _react2.default.createElement(_ExamEdit2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':examId', component: function component(props) {
	          return _react2.default.createElement(_ExamDashboard2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'edit/:examId', component: function component(props) {
	          return _react2.default.createElement(_ExamEdit2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':examId/attachments', component: function component(props) {
	          return _react2.default.createElement(_ExamAttachments2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':examId/accommodation', component: function component(props) {
	          return _react2.default.createElement(_ExamDashboard2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':examId/accommodation/:enrollmentId', component: function component(props) {
	          return _react2.default.createElement(_ExamDashboard2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'funding-rules',
	        component: _App2.default,
	        feature: 'fundingRules'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_FundingRules2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'add', component: function component(props) {
	          return _react2.default.createElement(_FundingRules2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'edit/:fundingRuleId', component: function component(props) {
	          return _react2.default.createElement(_FundingRules2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'messages',
	        component: _App2.default,
	        feature: 'messages'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Inbox2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'view/:messageId', component: function component(props) {
	          return _react2.default.createElement(_Inbox2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'reports',
	        component: _App2.default,
	        feature: 'reports'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Reports2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'downloads', component: function component(props) {
	          return _react2.default.createElement(_Downloads2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_Reports2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'roster',
	        component: _App2.default,
	        feature: 'roster'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Roster2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'provision',
	        component: _AppOutside2.default,
	        feature: 'provisionExam'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_ProvisionExam2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'admins',
	        component: _App2.default,
	        feature: 'admins'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Admins2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'edit/:userSid', component: function component(props) {
	          return _react2.default.createElement(_Admins2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'users',
	        component: _App2.default,
	        feature: 'users'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Users2.default, Object.assign({ installation: true }, stores));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'view/:userSid', component: function component(props) {
	          return _react2.default.createElement(_Users2.default, Object.assign({ installation: true }, stores));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'course-offerings',
	        component: _App2.default,
	        feature: 'courseOfferings'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_CourseOfferings2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'edit/:offeringSid', component: function component(props) {
	          return _react2.default.createElement(_CourseOfferings2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'self-managed-proctors',
	        component: _App2.default,
	        feature: 'selfManagedProctors'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SelfManagedAccounts2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'add', component: function component(props) {
	          return _react2.default.createElement(_SelfManagedAccounts2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'edit/:proctorId', component: function component(props) {
	          return _react2.default.createElement(_SelfManagedAccounts2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'settings',
	        component: _App2.default,
	        feature: 'settings'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Settings2.default, Object.assign({}, stores, { content: 'User' }));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'institution', component: function component(props) {
	          return _react2.default.createElement(_Settings2.default, Object.assign({}, stores, { content: 'Institution' }));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'institution/*', component: function component(props) {
	          return _react2.default.createElement(_Settings2.default, Object.assign({}, stores, { content: 'Institution' }));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'proctor-groups', component: function component(props) {
	          return _react2.default.createElement(_Settings2.default, Object.assign({}, stores, { content: 'ProctorGroups' }));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_Settings2.default, Object.assign({}, stores, { content: 'User' }));
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'integrations',
	        component: _App2.default,
	        feature: 'integrations'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Integrations2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'support',
	        component: _App2.default,
	        feature: 'support'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SupportTickets2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'view/:ticketId', component: function component(props) {
	          return _react2.default.createElement(_SupportTickets2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'add', component: function component(props) {
	          return _react2.default.createElement(_SupportTickets2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'vouchers',
	        component: _App2.default,
	        feature: 'vouchers'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Vouchers2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'add', component: function component(props) {
	          return _react2.default.createElement(_AddVoucher2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'edit/:voucherId', component: function component(props) {
	          return _react2.default.createElement(_Vouchers2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'exam-approvals',
	        component: _App2.default,
	        feature: 'examApprovals'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_ExamApprovals2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'review/exam/:examId/configuration/:approvalId/course/:courseId', component: function component(props) {
	          return _react2.default.createElement(_ExamApprovals2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'bvirtual-manager',
	        component: _AppOutside2.default,
	        feature: 'bVirtual'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SessionManager2.default, Object.assign({ megameeting: true, multi: true }, stores));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'session-details',
	        component: _AppOutside2.default,
	        feature: 'sessionManager'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SessionManager2.default, Object.assign({ megameeting: false, multi: false }, stores));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'blackout-dates',
	        component: _App2.default,
	        feature: 'blackoutDates'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_BlackoutDates2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'add', component: function component(props) {
	          return _react2.default.createElement(_BlackoutDates2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'edit/:blackoutDateSid', component: function component(props) {
	          return _react2.default.createElement(_BlackoutDates2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'session-start',
	        component: _App2.default,
	        feature: 'sessionStart'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SessionStart2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'session-start-external',
	        component: _AppOutsideOnboard2.default,
	        feature: 'sessionStart'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SessionStart2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'session-expired',
	        component: _AppLoggedOut2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SessionExpired2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'maintenance',
	        component: _AppLoggedOut2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Maintenance2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'unauthorized',
	        component: _AppLoggedOut2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Unauthorized2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'sign-out',
	        component: _AppLoggedOut2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SignOut2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'signed-out',
	        component: _AppLoggedOut2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SignedOut2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'rb-complete',
	        component: _AppOutside2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_CloseWindow2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'launch',
	        component: _AppOutside2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_StartVTC2.default, Object.assign({}, stores, { hideDashboard: true }));
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: ':accessCode', component: function component(props) {
	          return _react2.default.createElement(_StartVTC2.default, Object.assign({}, stores, { hideDashboard: true }));
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'locate-proctor',
	        component: _App2.default,
	        feature: 'locateProctor'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_LocateProctor2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'transactions',
	        component: _App2.default,
	        feature: 'transactions'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Transactions2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'ledger',
	        component: _App2.default,
	        feature: 'ledger'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_InstitutionTransactions2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'instructor-appointments',
	        component: _App2.default,
	        feature: 'instructorAppointments'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Reports2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { path: 'refresh', component: null }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'vtc',
	        component: _AppLoggedOut2.default,
	        feature: 'vtc'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_VTCNotice2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'time-zone',
	        component: _AppOutside2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_TimeZone2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'automated/end-session',
	        component: _AppLoggedOut2.default
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_SessionEndAutomated2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: '/',
	        component: _App2.default,
	        feature: 'dashboard'
	      },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: function component(props) {
	          return _react2.default.createElement(_Dashboard2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: 'index.html', component: function component(props) {
	          return _react2.default.createElement(_Dashboard2.default, stores);
	        } }),
	      _react2.default.createElement(_reactRouter.Route, { path: '*', component: function component(props) {
	          return _react2.default.createElement(_NotFound2.default, stores);
	        } })
	    )
	  )
	);
	
	(0, _reactDom.render)(router, document.querySelector('#app'));

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(917), __esModule: true };

/***/ },
/* 226 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(922);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 228 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 229 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(83);
	var dPs = __webpack_require__(936);
	var enumBugKeys = __webpack_require__(229);
	var IE_PROTO = __webpack_require__(233)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(388)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(927).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 231 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(70).f;
	var has = __webpack_require__(84);
	var TAG = __webpack_require__(50)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(234)('keys');
	var uid = __webpack_require__(156);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(35);
	var global = __webpack_require__(69);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(154) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 235 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(104);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(69);
	var core = __webpack_require__(35);
	var LIBRARY = __webpack_require__(154);
	var wksExt = __webpack_require__(238);
	var defineProperty = __webpack_require__(70).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(50);


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(944);
	var global = __webpack_require__(69);
	var hide = __webpack_require__(103);
	var Iterators = __webpack_require__(105);
	var TO_STRING_TAG = __webpack_require__(50)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(968)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant$1 = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$1(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = Math.abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * Math.sin(ap)),
	            p1 = asin(rp / r1 * Math.sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * Math.cos(a01),
	          y01 = r1 * Math.sin(a01),
	          x10 = r0 * Math.cos(a10),
	          y10 = r0 * Math.sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * Math.cos(a11),
	            y11 = r1 * Math.sin(a11),
	            x00 = r0 * Math.cos(a00),
	            y00 = r0 * Math.sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [Math.cos(a) * r, Math.sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant$1(0),
	      y1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant$1(0),
	      endAngle = constant$1(tau),
	      padAngle = constant$1(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$1(circle),
	      size = constant$1(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var slice = Array.prototype.slice;
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (var j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$1([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 241 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(108);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _DOMStateStorage = __webpack_require__(409);
	
	var _PathUtils = __webpack_require__(72);
	
	var _ExecutionEnvironment = __webpack_require__(243);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 243 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(993);
	
	var _PathUtils = __webpack_require__(72);
	
	var _runTransitionHook = __webpack_require__(245);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(159);
	
	var _LocationUtils = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(81);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.count_occurences = count_occurences;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Counts all occurences of a symbol in a string
	function count_occurences(symbol, string) {
		var count = 0;
	
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = (0, _getIterator3.default)(string), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var character = _step.value;
	
				if (character === symbol) {
					count++;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	
		return count;
	}
	//# sourceMappingURL=helpers.js.map

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64_url_decode = __webpack_require__(1014);
	
	function InvalidTokenError(message) {
	  this.message = message;
	}
	
	InvalidTokenError.prototype = new Error();
	InvalidTokenError.prototype.name = 'InvalidTokenError';
	
	module.exports = function (token,options) {
	  if (typeof token !== 'string') {
	    throw new InvalidTokenError('Invalid token specified');
	  }
	
	  options = options || {};
	  var pos = options.header === true ? 0 : 1;
	  try {
	    return JSON.parse(base64_url_decode(token.split('.')[pos]));
	  } catch (e) {
	    throw new InvalidTokenError('Invalid token specified: ' + e.message);
	  }
	};
	
	module.exports.InvalidTokenError = InvalidTokenError;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FIRST_GROUP_PATTERN = undefined;
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getIterator2 = __webpack_require__(81);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = format;
	exports.format_national_number_using_format = format_national_number_using_format;
	exports.format_national_number = format_national_number;
	exports.choose_format_for_number = choose_format_for_number;
	exports.local_to_international_style = local_to_international_style;
	
	var _common = __webpack_require__(162);
	
	var _parse = __webpack_require__(110);
	
	var _metadata = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_options = {
		formatExtension: function formatExtension(number, extension) {
			return number + ' ext. ' + extension;
		}
	
		// Formats a phone number
		//
		// Example use cases:
		//
		// ```js
		// format('8005553535', 'RU', 'International')
		// format('8005553535', 'RU', 'International', metadata)
		// format({ phone: '8005553535', country: 'RU' }, 'International')
		// format({ phone: '8005553535', country: 'RU' }, 'International', metadata)
		// format('+78005553535', 'National')
		// format('+78005553535', 'National', metadata)
		// ```
		//
	}; // This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	
	function format(arg_1, arg_2, arg_3, arg_4, arg_5) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4, arg_5),
		    input = _sort_out_arguments.input,
		    format_type = _sort_out_arguments.format_type,
		    options = _sort_out_arguments.options,
		    metadata = _sort_out_arguments.metadata;
	
		var country_metadata = void 0;
	
		if (input.country) {
			country_metadata = metadata.countries[input.country];
		}
	
		var _parse_phone_number_a = (0, _parse.parse_phone_number_and_country_phone_code)(input.phone, metadata),
		    country_phone_code = _parse_phone_number_a.country_phone_code,
		    number = _parse_phone_number_a.number;
	
		if (country_phone_code) {
			// Check country restriction
			if (input.country && country_metadata && country_phone_code !== (0, _metadata.get_phone_code)(country_metadata)) {
				return input.phone;
			}
	
			country_metadata = (0, _metadata.get_metadata_by_country_phone_code)(country_phone_code, metadata);
		}
	
		if (!country_metadata) {
			return input.phone;
		}
	
		switch (format_type) {
			case 'International':
				if (!number) {
					return '+' + (0, _metadata.get_phone_code)(country_metadata);
				}
				var national_number = format_national_number(number, 'International', false, country_metadata);
				var international_number = '+' + (0, _metadata.get_phone_code)(country_metadata) + ' ' + national_number;
				if (input.ext || input.ext === 0) {
					return options.formatExtension(international_number, input.ext);
				}
				return international_number;
	
			case 'E.164':
			// "International_plaintext" is deprecated
			case 'International_plaintext':
				// `E.164` doesn't define "phone number extensions".
				return '+' + (0, _metadata.get_phone_code)(country_metadata) + input.phone;
	
			case 'RFC3966':
				return '+' + (0, _metadata.get_phone_code)(country_metadata) + input.phone + (input.ext || input.ext === 0 ? ';ext=' + input.ext : '');
	
			case 'National':
				if (!number) {
					return '';
				}
				var _national_number = format_national_number(number, 'National', false, country_metadata);
				if (input.ext || input.ext === 0) {
					return options.formatExtension(_national_number, input.ext);
				}
				return _national_number;
		}
	}
	
	// This was originally set to $1 but there are some countries for which the
	// first group is not used in the national pattern (e.g. Argentina) so the $1
	// group does not match correctly.  Therefore, we use \d, so that the first
	// group actually used in the pattern will be matched.
	var FIRST_GROUP_PATTERN = exports.FIRST_GROUP_PATTERN = /(\$\d)/;
	
	function format_national_number_using_format(number, format, international, enforce_national_prefix, country_metadata) {
		var format_pattern_matcher = new RegExp((0, _metadata.get_format_pattern)(format));
	
		var national_prefix_formatting_rule = (0, _metadata.get_format_national_prefix_formatting_rule)(format, country_metadata);
	
		// National prefix is omitted if there's no national prefix formatting rule
		// set for this country, or when this rule is set but
		// national prefix is optional for this phone number format
		// (and it is not enforced explicitly)
		var national_prefix_may_be_omitted = !national_prefix_formatting_rule || national_prefix_formatting_rule && (0, _metadata.get_format_national_prefix_is_optional_when_formatting)(format, country_metadata) && !enforce_national_prefix;
	
		if (!international && !national_prefix_may_be_omitted) {
			return number.replace(format_pattern_matcher, (0, _metadata.get_format_format)(format).replace(FIRST_GROUP_PATTERN, national_prefix_formatting_rule));
		}
	
		var formatted_number = number.replace(format_pattern_matcher, international ? (0, _metadata.get_format_international_format)(format) : (0, _metadata.get_format_format)(format));
	
		if (international) {
			return local_to_international_style(formatted_number);
		}
	
		return formatted_number;
	}
	
	function format_national_number(number, format_as, enforce_national_prefix, country_metadata) {
		var format = choose_format_for_number((0, _metadata.get_formats)(country_metadata), number);
	
		if (!format) {
			return number;
		}
	
		return format_national_number_using_format(number, format, format_as === 'International', enforce_national_prefix, country_metadata);
	}
	
	function choose_format_for_number(available_formats, national_number) {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = (0, _getIterator3.default)(available_formats), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var _format = _step.value;
	
				// Validate leading digits
				if ((0, _metadata.get_format_leading_digits_patterns)(_format).length > 0) {
					// The last leading_digits_pattern is used here, as it is the most detailed
					var last_leading_digits_pattern = (0, _metadata.get_format_leading_digits_patterns)(_format)[(0, _metadata.get_format_leading_digits_patterns)(_format).length - 1];
	
					// If leading digits don't match then move on to the next phone number format
					if (national_number.search(last_leading_digits_pattern) !== 0) {
						continue;
					}
				}
	
				// Check that the national number matches the phone number format regular expression
				if ((0, _common.matches_entirely)(national_number, new RegExp((0, _metadata.get_format_pattern)(_format)))) {
					return _format;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}
	
	// Removes brackets and replaces dashes with spaces.
	//
	// E.g. "(999) 111-22-33" -> "999 111 22 33"
	//
	function local_to_international_style(local) {
		return local.replace(new RegExp('[' + _parse.VALID_PUNCTUATION + ']+', 'g'), ' ').trim();
	}
	
	// Sort out arguments
	function sort_out_arguments() {
		var arg_1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var arg_2 = arguments[1];
		var arg_3 = arguments[2];
		var arg_4 = arguments[3];
		var arg_5 = arguments[4];
	
		var input = void 0;
		var format_type = void 0;
		var options = void 0;
		var metadata = void 0;
	
		// Sort out arguments.
	
		// If the phone number is passed as a string.
		// `format('8005553535', ...)`.
		if (typeof arg_1 === 'string') {
			// If country code is supplied.
			// `format('8005553535', 'RU', 'National', [options], metadata)`.
			if (typeof arg_3 === 'string') {
				// Will be `parse()`d later in code
				input = {
					phone: arg_1,
					country: arg_2
				};
	
				format_type = arg_3;
	
				if (arg_5) {
					options = arg_4;
					metadata = arg_5;
				} else {
					metadata = arg_4;
				}
			}
			// Just an international phone number is supplied
			// `format('+78005553535', 'National', [options], metadata)`.
			else {
					// Will be `parse()`d later in code
					input = {
						phone: arg_1
					};
	
					if (typeof arg_2 !== 'string') {
						throw new Error('Format type argument not passed for `format()`');
					}
	
					format_type = arg_2;
	
					if (arg_4) {
						options = arg_3;
						metadata = arg_4;
					} else {
						metadata = arg_3;
					}
				}
		}
		// If the phone number is passed as a parsed number object.
		// `format({ phone: '8005553535', country: 'RU' }, 'National', [options], metadata)`.
		else {
				input = arg_1;
				format_type = arg_2;
	
				if (arg_4) {
					options = arg_3;
					metadata = arg_4;
				} else {
					metadata = arg_3;
				}
			}
	
		// Metadata is required.
		if (!metadata) {
			throw new Error('Metadata is required');
		}
	
		// Validate `format_type`.
		switch (format_type) {
			case 'International':
			case 'E.164':
			// "International_plaintext" is deprecated
			case 'International_plaintext':
			case 'National':
			case 'RFC3966':
				break;
			default:
				throw new Error('Unknown format type argument passed to "format()": "' + format_type + '"');
		}
	
		// Apply default options.
		if (options) {
			options = (0, _extends3.default)({}, default_options, options);
		} else {
			options = default_options;
		}
	
		return { input: input, format_type: format_type, options: options, metadata: metadata };
	}
	//# sourceMappingURL=format.js.map

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = get_number_type;
	exports.is_of_type = is_of_type;
	exports.sort_out_arguments = sort_out_arguments;
	
	var _parse = __webpack_require__(110);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _common = __webpack_require__(162);
	
	var _metadata = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Finds out national phone number type (fixed line, mobile, etc)
	function get_number_type(arg_1, arg_2, arg_3) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3),
		    input = _sort_out_arguments.input,
		    metadata = _sort_out_arguments.metadata;
	
		// When no input was passed
	
	
		if (!input) {
			return;
		}
	
		// When `parse()` returned `{}`
		// meaning that the phone number is not a valid one.
		if (!input.country) {
			return;
		}
	
		var national_number = input.phone;
		var country_metadata = metadata.countries[input.country];
	
		// The following is copy-pasted from the original function:
		// https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
	
		// Is this national number even valid for this country
		if (!is_of_type(national_number, (0, _metadata.get_national_number_pattern)(country_metadata))) {
			return; // 'UNKNOWN'
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_premium_rate)(country_metadata))) {
			return 'PREMIUM_RATE';
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_toll_free)(country_metadata))) {
			return 'TOLL_FREE';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_shared_cost)(country_metadata))) {
			return 'SHARED_COST';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_voip)(country_metadata))) {
			return 'VOIP';
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_personal_number)(country_metadata))) {
			return 'PERSONAL_NUMBER';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_pager)(country_metadata))) {
			return 'PAGER';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_uan)(country_metadata))) {
			return 'UAN';
		}
	
		/* istanbul ignore if */
		if (is_of_type(national_number, (0, _metadata.get_type_voice_mail)(country_metadata))) {
			return 'VOICEMAIL';
		}
	
		// Is it fixed line number
		if (is_of_type(national_number, (0, _metadata.get_type_fixed_line)(country_metadata))) {
			// Because duplicate regular expressions are removed
			// to reduce metadata size, if there's no "mobile" pattern
			// then it means it was removed due to being a duplicate of some other pattern.
			//
			if (!(0, _metadata.get_type_mobile)(country_metadata)) {
				return 'FIXED_LINE_OR_MOBILE';
			}
	
			// Check if the number happens to qualify as both fixed line and mobile.
			// (no such country in the minimal metadata set)
			/* istanbul ignore if */
			if (is_of_type(national_number, (0, _metadata.get_type_mobile)(country_metadata))) {
				return 'FIXED_LINE_OR_MOBILE';
			}
	
			return 'FIXED_LINE';
		}
	
		if (is_of_type(national_number, (0, _metadata.get_type_mobile)(country_metadata))) {
			return 'MOBILE';
		}
	
		// return 'UNKNOWN'
	}
	
	function is_of_type(national_number, type) {
		// // Check if any possible number lengths are present;
		// // if so, we use them to avoid checking
		// // the validation pattern if they don't match.
		// // If they are absent, this means they match
		// // the general description, which we have
		// // already checked before a specific number type.
		// if (get_possible_lengths(type) &&
		// 	get_possible_lengths(type).indexOf(national_number.length) === -1)
		// {
		// 	return false
		// }
	
		// get_type_pattern(type) === type
		return (0, _common.matches_entirely)(national_number, type);
	}
	
	// Sort out arguments
	function sort_out_arguments(arg_1, arg_2, arg_3) {
		var input = void 0;
		var metadata = void 0;
	
		// Normalize numerical `value`.
		// https://github.com/catamphetamine/libphonenumber-js/issues/142
		// `getNumberType(88005553535, ...)`.
		if (typeof arg_1 === 'number') {
			arg_1 = String(arg_1);
		}
	
		// If the phone number is passed as a string.
		// `getNumberType('88005553535', ...)`.
		if (typeof arg_1 === 'string') {
			// If "resrict country" argument is being passed
			// then convert it to an `options` object.
			// `getNumberType('88005553535', 'RU', metadata)`.
			if (typeof arg_2 === 'string' || arg_2 === undefined) {
				metadata = arg_3;
	
				// `parse` extracts phone numbers from raw text,
				// therefore it will cut off all "garbage" characters,
				// while this `validate` function needs to verify
				// that the phone number contains no "garbage"
				// therefore the explicit `is_viable_phone_number` check.
				if ((0, _parse.is_viable_phone_number)(arg_1)) {
					input = (0, _parse2.default)(arg_1, arg_2, metadata);
				}
			}
			// No "resrict country" argument is being passed.
			// International phone number is passed.
			// `getNumberType('+78005553535', metadata)`.
			else {
					metadata = arg_2;
	
					// `parse` extracts phone numbers from raw text,
					// therefore it will cut off all "garbage" characters,
					// while this `validate` function needs to verify
					// that the phone number contains no "garbage"
					// therefore the explicit `is_viable_phone_number` check.
					if ((0, _parse.is_viable_phone_number)(arg_1)) {
						input = (0, _parse2.default)(arg_1, metadata);
					}
				}
		}
		// If the phone number is passed as a parsed phone number.
		// `getNumberType({ phone: '88005553535', country: 'RU' }, ...)`.
		else {
				// The `arg_1` must be a valid phone number
				// as a whole, not just a part of it which gets parsed here.
				if (arg_1 && arg_1.phone && (0, _parse.is_viable_phone_number)(arg_1.phone)) {
					input = arg_1;
				}
	
				metadata = arg_2;
			}
	
		// Metadata is required.
		if (!metadata || !metadata.countries) {
			throw new Error('Metadata is required');
		}
	
		return { input: input, metadata: metadata };
	}
	//# sourceMappingURL=types.js.map

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(82);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Handle = function (_React$Component) {
	  (0, _inherits3["default"])(Handle, _React$Component);
	
	  function Handle() {
	    (0, _classCallCheck3["default"])(this, Handle);
	    return (0, _possibleConstructorReturn3["default"])(this, _React$Component.apply(this, arguments));
	  }
	
	  Handle.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        vertical = _props.vertical,
	        offset = _props.offset,
	        minimumTrackTintColor = _props.minimumTrackTintColor,
	        disabled = _props.disabled,
	        restProps = (0, _objectWithoutProperties3["default"])(_props, ['className', 'vertical', 'offset', 'minimumTrackTintColor', 'disabled']);
	
	    var style = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
	    if (minimumTrackTintColor && !disabled) {
	      style.borderColor = minimumTrackTintColor;
	    }
	    return _react2["default"].createElement('div', (0, _extends3["default"])({}, restProps, { className: className, style: style }));
	  };
	
	  return Handle;
	}(_react2["default"].Component);
	
	exports["default"] = Handle;
	
	
	Handle.propTypes = {
	  className: _react.PropTypes.string,
	  vertical: _react.PropTypes.bool,
	  offset: _react.PropTypes.number,
	  minimumTrackTintColor: _react.PropTypes.string,
	  disabled: _react.PropTypes.bool
	};
	module.exports = exports['default'];

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(386);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.isEventFromHandle = isEventFromHandle;
	exports.isValueOutOfRange = isValueOutOfRange;
	exports.isNotTouchEvent = isNotTouchEvent;
	exports.getClosestPoint = getClosestPoint;
	exports.getPrecision = getPrecision;
	exports.getMousePosition = getMousePosition;
	exports.getTouchPosition = getTouchPosition;
	exports.getHandleCenterPosition = getHandleCenterPosition;
	exports.ensureValueInRange = ensureValueInRange;
	exports.ensureValuePrecision = ensureValuePrecision;
	exports.pauseEvent = pauseEvent;
	
	var _reactDom = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isEventFromHandle(e, handles) {
	  return Object.keys(handles).some(function (key) {
	    return e.target === (0, _reactDom.findDOMNode)(handles[key]);
	  });
	}
	
	function isValueOutOfRange(value, _ref) {
	  var min = _ref.min,
	      max = _ref.max;
	
	  return value < min || value > max;
	}
	
	function isNotTouchEvent(e) {
	  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
	}
	
	function getClosestPoint(val, _ref2) {
	  var marks = _ref2.marks,
	      step = _ref2.step,
	      min = _ref2.min;
	
	  var points = Object.keys(marks).map(parseFloat);
	  if (step !== null) {
	    var closestStep = Math.round((val - min) / step) * step + min;
	    points.push(closestStep);
	  }
	  var diffs = points.map(function (point) {
	    return Math.abs(val - point);
	  });
	  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3["default"])(diffs)))];
	}
	
	function getPrecision(step) {
	  var stepString = step.toString();
	  var precision = 0;
	  if (stepString.indexOf('.') >= 0) {
	    precision = stepString.length - stepString.indexOf('.') - 1;
	  }
	  return precision;
	}
	
	function getMousePosition(vertical, e) {
	  return vertical ? e.clientY : e.pageX;
	}
	
	function getTouchPosition(vertical, e) {
	  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
	}
	
	function getHandleCenterPosition(vertical, handle) {
	  var coords = handle.getBoundingClientRect();
	  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
	}
	
	function ensureValueInRange(val, _ref3) {
	  var max = _ref3.max,
	      min = _ref3.min;
	
	  if (val <= min) {
	    return min;
	  }
	  if (val >= max) {
	    return max;
	  }
	  return val;
	}
	
	function ensureValuePrecision(val, props) {
	  var step = props.step;
	
	  var closestPoint = getClosestPoint(val, props);
	  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
	}
	
	function pauseEvent(e) {
	  e.stopPropagation();
	  e.preventDefault();
	}

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addEventListenerWrap;
	
	var _addDomEventListener = _interopRequireDefault(__webpack_require__(707));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(22));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addEventListenerWrap(target, eventType, cb, option) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
	    _reactDom.default.unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener.default)(target, eventType, callback, option);
	}

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(113);
	var Danger = __webpack_require__(1079);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactInstrumentation = __webpack_require__(44);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(262);
	var setInnerHTML = __webpack_require__(168);
	var setTextContent = __webpack_require__(568);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 254 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactErrorUtils = __webpack_require__(260);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 257 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var React = __webpack_require__(91);
	var ReactPropTypesSecret = __webpack_require__(1105);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: React.PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(10);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      // $FlowFixMe https://github.com/facebook/flow/issues/2336
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactInstanceMap = __webpack_require__(128);
	var ReactInstrumentation = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(51);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 262 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 263 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 264 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 265 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(17);
	
	var ReactCompositeComponent = __webpack_require__(1086);
	var ReactEmptyComponent = __webpack_require__(553);
	var ReactHostComponent = __webpack_require__(555);
	
	var getNextDebugID = __webpack_require__(1130);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 268 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var emptyFunction = __webpack_require__(38);
	var warning = __webpack_require__(14);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(8)):"function"==typeof define&&define.amd?define(["react","prop-types"],t):"object"==typeof exports?exports.Dropzone=t(require("react"),require("prop-types")):e.Dropzone=t(e.React,e.PropTypes)}(this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function c(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),d=n(2),v=r(d),h=n(3),g=n(5),y=r(g),m=function(e){function t(e,n){a(this,t);var r=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,n));return r.renderChildren=function(e,t,n,o){return"function"==typeof e?e(s({},r.state,{isDragActive:t,isDragAccept:n,isDragReject:o})):e},r.composeHandlers=r.composeHandlers.bind(r),r.onClick=r.onClick.bind(r),r.onDocumentDrop=r.onDocumentDrop.bind(r),r.onDragEnter=r.onDragEnter.bind(r),r.onDragLeave=r.onDragLeave.bind(r),r.onDragOver=r.onDragOver.bind(r),r.onDragStart=r.onDragStart.bind(r),r.onDrop=r.onDrop.bind(r),r.onFileDialogCancel=r.onFileDialogCancel.bind(r),r.onInputElementClick=r.onInputElementClick.bind(r),r.setRef=r.setRef.bind(r),r.setRefs=r.setRefs.bind(r),r.isFileDialogActive=!1,r.state={draggedFiles:[],acceptedFiles:[],rejectedFiles:[]},r}return c(t,e),l(t,[{key:"componentDidMount",value:function(){var e=this.props.preventDropOnDocument;this.dragTargets=[],e&&(document.addEventListener("dragover",h.onDocumentDragOver,!1),document.addEventListener("drop",this.onDocumentDrop,!1)),this.fileInputEl.addEventListener("click",this.onInputElementClick,!1),window.addEventListener("focus",this.onFileDialogCancel,!1)}},{key:"componentWillUnmount",value:function(){this.props.preventDropOnDocument&&(document.removeEventListener("dragover",h.onDocumentDragOver),document.removeEventListener("drop",this.onDocumentDrop)),null!=this.fileInputEl&&this.fileInputEl.removeEventListener("click",this.onInputElementClick,!1),window.removeEventListener("focus",this.onFileDialogCancel,!1)}},{key:"composeHandlers",value:function(e){return this.props.disabled?null:e}},{key:"onDocumentDrop",value:function(e){this.node&&this.node.contains(e.target)||(e.preventDefault(),this.dragTargets=[])}},{key:"onDragStart",value:function(e){this.props.onDragStart&&this.props.onDragStart.call(this,e)}},{key:"onDragEnter",value:function(e){var t=this;e.preventDefault(),-1===this.dragTargets.indexOf(e.target)&&this.dragTargets.push(e.target),Promise.resolve(this.props.getDataTransferItems(e)).then(function(e){t.setState({isDragActive:!0,draggedFiles:e})}),this.props.onDragEnter&&this.props.onDragEnter.call(this,e)}},{key:"onDragOver",value:function(e){e.preventDefault(),e.stopPropagation();try{e.dataTransfer.dropEffect=this.isFileDialogActive?"none":"copy"}catch(e){}return this.props.onDragOver&&this.props.onDragOver.call(this,e),!1}},{key:"onDragLeave",value:function(e){var t=this;e.preventDefault(),this.dragTargets=this.dragTargets.filter(function(n){return n!==e.target&&t.node.contains(n)}),this.dragTargets.length>0||(this.setState({isDragActive:!1,draggedFiles:[]}),this.props.onDragLeave&&this.props.onDragLeave.call(this,e))}},{key:"onDrop",value:function(e){var t=this,n=this.props,r=n.onDrop,o=n.onDropAccepted,a=n.onDropRejected,u=n.multiple,c=n.disablePreview,s=n.accept,l=n.getDataTransferItems;e.preventDefault(),this.dragTargets=[],this.isFileDialogActive=!1,this.draggedFiles=null,this.setState({isDragActive:!1,draggedFiles:[]}),Promise.resolve(l(e)).then(function(n){var l=[],f=[];n.forEach(function(e){if(!c)try{e.preview=window.URL.createObjectURL(e)}catch(e){}(0,h.fileAccepted)(e,s)&&(0,h.fileMatchSize)(e,t.props.maxSize,t.props.minSize)?l.push(e):f.push(e)}),u||f.push.apply(f,i(l.splice(1))),r&&r.call(t,l,f,e),f.length>0&&a&&a.call(t,f,e),l.length>0&&o&&o.call(t,l,e)})}},{key:"onClick",value:function(e){var t=this.props,n=t.onClick;t.disableClick||(e.stopPropagation(),n&&n.call(this,e),(0,h.isIeOrEdge)()?setTimeout(this.open.bind(this),0):this.open())}},{key:"onInputElementClick",value:function(e){e.stopPropagation(),this.props.inputProps&&this.props.inputProps.onClick&&this.props.inputProps.onClick()}},{key:"onFileDialogCancel",value:function(){var e=this,t=this.props.onFileDialogCancel;this.isFileDialogActive&&setTimeout(function(){if(null!=e.fileInputEl){e.fileInputEl.files.length||(e.isFileDialogActive=!1)}"function"==typeof t&&t()},300)}},{key:"setRef",value:function(e){this.node=e}},{key:"setRefs",value:function(e){this.fileInputEl=e}},{key:"open",value:function(){this.isFileDialogActive=!0,this.fileInputEl.value=null,this.fileInputEl.click()}},{key:"render",value:function(){var e=this.props,t=e.accept,n=e.acceptClassName,r=e.activeClassName,i=e.children,a=e.disabled,u=e.disabledClassName,c=e.inputProps,l=e.multiple,f=e.name,d=e.rejectClassName,v=o(e,["accept","acceptClassName","activeClassName","children","disabled","disabledClassName","inputProps","multiple","name","rejectClassName"]),g=v.acceptStyle,m=v.activeStyle,b=v.className,D=void 0===b?"":b,x=v.disabledStyle,O=v.rejectStyle,S=v.style,C=o(v,["acceptStyle","activeStyle","className","disabledStyle","rejectStyle","style"]),j=this.state,E=j.isDragActive,w=j.draggedFiles,_=w.length,k=l||_<=1,P=_>0&&(0,h.allFilesAccepted)(w,this.props.accept),A=_>0&&(!P||!k),F=!(D||S||m||g||O||x);E&&r&&(D+=" "+r),P&&n&&(D+=" "+n),A&&d&&(D+=" "+d),a&&u&&(D+=" "+u),F&&(S=y.default.default,m=y.default.active,g=y.default.active,O=y.default.rejected,x=y.default.disabled);var T=s({position:"relative"},S);m&&E&&(T=s({},T,m)),g&&P&&(T=s({},T,g)),O&&A&&(T=s({},T,O)),x&&a&&(T=s({},T,x));var I={accept:t,disabled:a,type:"file",style:s({position:"absolute",top:0,right:0,bottom:0,left:0,opacity:1e-5,pointerEvents:"none"},c.style),multiple:h.supportMultiple&&l,ref:this.setRefs,onChange:this.onDrop,autoComplete:"off"};f&&f.length&&(I.name=f);var M=(C.acceptedFiles,C.preventDropOnDocument,C.disablePreview,C.disableClick,C.onDropAccepted,C.onDropRejected,C.onFileDialogCancel,C.maxSize,C.minSize,C.getDataTransferItems,o(C,["acceptedFiles","preventDropOnDocument","disablePreview","disableClick","onDropAccepted","onDropRejected","onFileDialogCancel","maxSize","minSize","getDataTransferItems"]));return p.default.createElement("div",s({className:D,style:T},M,{onClick:this.composeHandlers(this.onClick),onDragStart:this.composeHandlers(this.onDragStart),onDragEnter:this.composeHandlers(this.onDragEnter),onDragOver:this.composeHandlers(this.onDragOver),onDragLeave:this.composeHandlers(this.onDragLeave),onDrop:this.composeHandlers(this.onDrop),ref:this.setRef,"aria-disabled":a}),this.renderChildren(i,E,P,A),p.default.createElement("input",s({},c,I)))}}]),t}(p.default.Component);t.default=m,m.propTypes={accept:v.default.oneOfType([v.default.string,v.default.arrayOf(v.default.string)]),children:v.default.oneOfType([v.default.node,v.default.func]),disableClick:v.default.bool,disabled:v.default.bool,disablePreview:v.default.bool,preventDropOnDocument:v.default.bool,inputProps:v.default.object,multiple:v.default.bool,name:v.default.string,maxSize:v.default.number,minSize:v.default.number,className:v.default.string,activeClassName:v.default.string,acceptClassName:v.default.string,rejectClassName:v.default.string,disabledClassName:v.default.string,style:v.default.object,activeStyle:v.default.object,acceptStyle:v.default.object,rejectStyle:v.default.object,disabledStyle:v.default.object,getDataTransferItems:v.default.func,onClick:v.default.func,onDrop:v.default.func,onDropAccepted:v.default.func,onDropRejected:v.default.func,onDragStart:v.default.func,onDragEnter:v.default.func,onDragOver:v.default.func,onDragLeave:v.default.func,onFileDialogCancel:v.default.func},m.defaultProps={preventDropOnDocument:!0,disabled:!1,disablePreview:!1,disableClick:!1,inputProps:{},multiple:!0,maxSize:1/0,minSize:0,getDataTransferItems:h.getDataTransferItems},e.exports=t.default},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t,n){"use strict";function r(e){var t=[];if(e.dataTransfer){var n=e.dataTransfer;n.files&&n.files.length?t=n.files:n.items&&n.items.length&&(t=n.items)}else e.target&&e.target.files&&(t=e.target.files);return Array.prototype.slice.call(t)}function o(e,t){return"application/x-moz-file"===e.type||(0,p.default)(e,t)}function i(e,t,n){return e.size<=t&&e.size>=n}function a(e,t){return e.every(function(e){return o(e,t)})}function u(e){e.preventDefault()}function c(e){return-1!==e.indexOf("MSIE")||-1!==e.indexOf("Trident/")}function s(e){return-1!==e.indexOf("Edge/")}function l(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.navigator.userAgent;return c(e)||s(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.supportMultiple=void 0,t.getDataTransferItems=r,t.fileAccepted=o,t.fileMatchSize=i,t.allFilesAccepted=a,t.onDocumentDragOver=u,t.isIeOrEdge=l;var f=n(4),p=function(e){return e&&e.__esModule?e:{default:e}}(f);t.supportMultiple="undefined"==typeof document||!document||!document.createElement||"multiple"in document.createElement("input")},function(e,t){e.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=13)}([function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){var n=e.exports={version:"2.5.0"};"number"==typeof __e&&(__e=n)},function(e,t,n){e.exports=!n(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(32)("wks"),o=n(9),i=n(0).Symbol,a="function"==typeof i;(e.exports=function(e){return r[e]||(r[e]=a&&i[e]||(a?i:o)("Symbol."+e))}).store=r},function(e,t,n){var r=n(0),o=n(2),i=n(8),a=n(22),u=n(10),c=function(e,t,n){var s,l,f,p,d=e&c.F,v=e&c.G,h=e&c.S,g=e&c.P,y=e&c.B,m=v?r:h?r[t]||(r[t]={}):(r[t]||{}).prototype,b=v?o:o[t]||(o[t]={}),D=b.prototype||(b.prototype={});v&&(n=t);for(s in n)l=!d&&m&&void 0!==m[s],f=(l?m:n)[s],p=y&&l?u(f,r):g&&"function"==typeof f?u(Function.call,f):f,m&&a(m,s,f,e&c.U),b[s]!=f&&i(b,s,p),g&&D[s]!=f&&(D[s]=f)};r.core=o,c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,e.exports=c},function(e,t,n){var r=n(16),o=n(21);e.exports=n(3)?function(e,t,n){return r.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t,n){var r=n(24);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,o){return e.call(t,n,r,o)}}return function(){return e.apply(t,arguments)}}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t,n){var r=n(28),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0}},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){if(e&&t){var n=Array.isArray(t)?t:t.split(","),r=e.name||"",o=e.type||"",i=o.replace(/\/.*$/,"");return n.some(function(e){var t=e.trim();return"."===t.charAt(0)?r.toLowerCase().endsWith(t.toLowerCase()):t.endsWith("/*")?i===t.replace(/\/.*$/,""):o===t})}return!0},n(14),n(34)},function(e,t,n){n(15),e.exports=n(2).Array.some},function(e,t,n){"use strict";var r=n(7),o=n(25)(3);r(r.P+r.F*!n(33)([].some,!0),"Array",{some:function(e){return o(this,e,arguments[1])}})},function(e,t,n){var r=n(17),o=n(18),i=n(20),a=Object.defineProperty;t.f=n(3)?Object.defineProperty:function(e,t,n){if(r(e),t=i(t,!0),r(n),o)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){var r=n(1);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t,n){e.exports=!n(3)&&!n(4)(function(){return 7!=Object.defineProperty(n(19)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(1),o=n(0).document,i=r(o)&&r(o.createElement);e.exports=function(e){return i?o.createElement(e):{}}},function(e,t,n){var r=n(1);e.exports=function(e,t){if(!r(e))return e;var n,o;if(t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;if("function"==typeof(n=e.valueOf)&&!r(o=n.call(e)))return o;if(!t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;throw TypeError("Can't convert object to primitive value")}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,n){var r=n(0),o=n(8),i=n(23),a=n(9)("src"),u=Function.toString,c=(""+u).split("toString");n(2).inspectSource=function(e){return u.call(e)},(e.exports=function(e,t,n,u){var s="function"==typeof n;s&&(i(n,"name")||o(n,"name",t)),e[t]!==n&&(s&&(i(n,a)||o(n,a,e[t]?""+e[t]:c.join(String(t)))),e===r?e[t]=n:u?e[t]?e[t]=n:o(e,t,n):(delete e[t],o(e,t,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[a]||u.call(this)})},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){var r=n(10),o=n(26),i=n(27),a=n(12),u=n(29);e.exports=function(e,t){var n=1==e,c=2==e,s=3==e,l=4==e,f=6==e,p=5==e||f,d=t||u;return function(t,u,v){for(var h,g,y=i(t),m=o(y),b=r(u,v,3),D=a(m.length),x=0,O=n?d(t,D):c?d(t,0):void 0;D>x;x++)if((p||x in m)&&(h=m[x],g=b(h,x,y),e))if(n)O[x]=g;else if(g)switch(e){case 3:return!0;case 5:return h;case 6:return x;case 2:O.push(h)}else if(l)return!1;return f?-1:s||l?l:O}}},function(e,t,n){var r=n(5);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(11);e.exports=function(e){return Object(r(e))}},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t,n){var r=n(30);e.exports=function(e,t){return new(r(e))(t)}},function(e,t,n){var r=n(1),o=n(31),i=n(6)("species");e.exports=function(e){var t;return o(e)&&(t=e.constructor,"function"!=typeof t||t!==Array&&!o(t.prototype)||(t=void 0),r(t)&&null===(t=t[i])&&(t=void 0)),void 0===t?Array:t}},function(e,t,n){var r=n(5);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});e.exports=function(e){return o[e]||(o[e]={})}},function(e,t,n){"use strict";var r=n(4);e.exports=function(e,t){return!!e&&r(function(){t?e.call(null,function(){},1):e.call(null)})}},function(e,t,n){n(35),e.exports=n(2).String.endsWith},function(e,t,n){"use strict";var r=n(7),o=n(12),i=n(36),a="".endsWith;r(r.P+r.F*n(38)("endsWith"),"String",{endsWith:function(e){var t=i(this,e,"endsWith"),n=arguments.length>1?arguments[1]:void 0,r=o(t.length),u=void 0===n?r:Math.min(o(n),r),c=String(e);return a?a.call(t,c,u):t.slice(u-c.length,u)===c}})},function(e,t,n){var r=n(37),o=n(11);e.exports=function(e,t,n){if(r(t))throw TypeError("String#"+n+" doesn't accept regex!");return String(o(e))}},function(e,t,n){var r=n(1),o=n(5),i=n(6)("match");e.exports=function(e){var t;return r(e)&&(void 0!==(t=e[i])?!!t:"RegExp"==o(e))}},function(e,t,n){var r=n(6)("match");e.exports=function(e){var t=/./;try{"/./"[e](t)}catch(n){try{return t[r]=!1,!"/./"[e](t)}catch(e){}}return!0}}])},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={rejected:{borderStyle:"solid",borderColor:"#c66",backgroundColor:"#eee"},disabled:{opacity:.5},active:{borderStyle:"solid",borderColor:"#6c6",backgroundColor:"#eee"},default:{width:200,height:200,borderWidth:2,borderColor:"#666",borderStyle:"dashed",borderRadius:5}},e.exports=t.default}])});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1136);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 272 */
[1679, 115, 58],
/* 273 */
[1680, 1209, 1210, 1211, 1212, 1213],
/* 274 */
[1697, 1167, 132],
/* 275 */
[1702, 1172, 1173, 1233, 59, 1235],
/* 276 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 277 */
[1729, 59, 176],
/* 278 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 279 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 280 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(8);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(271);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _getRouteParams = __webpack_require__(1257);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(281);
	
	var _RouteUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 284 */
[1679, 88, 60],
/* 285 */
[1680, 1341, 1342, 1343, 1344, 1345],
/* 286 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 287 */
[1697, 1298, 89],
/* 288 */
[1729, 53, 293],
/* 289 */
144,
/* 290 */
[1755, 621, 291],
/* 291 */
279,
/* 292 */
77,
/* 293 */
[1759, 118, 89],
/* 294 */
[1761, 1285, 1304, 290],
/* 295 */
[1679, 90, 61],
/* 296 */
[1680, 1449, 1450, 1451, 1452, 1453],
/* 297 */
[1693, 628, 191],
/* 298 */
[1702, 1406, 1407, 192, 54, 1479],
/* 299 */
276,
/* 300 */
[1729, 54, 139],
/* 301 */
278,
/* 302 */
[1754, 1399, 138],
/* 303 */
279,
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(120);
	
	var ReactNoopUpdateQueue = __webpack_require__(305);
	
	var canDefineProperty = __webpack_require__(643);
	var emptyObject = __webpack_require__(85);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(14);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(27);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Area
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Curve = __webpack_require__(93);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(75);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Area = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Area, _Component);
	
	  function Area() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Area.__proto__ || Object.getPrototypeOf(Area)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: true }, _this.id = (0, _DataUtils.uniqueId)('recharts-area-'), _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Area, [{
	    key: 'renderCurve',
	    value: function renderCurve() {
	      var _props = this.props,
	          layout = _props.layout,
	          type = _props.type,
	          stroke = _props.stroke,
	          points = _props.points,
	          baseLine = _props.baseLine,
	          connectNulls = _props.connectNulls,
	          isRange = _props.isRange;
	
	
	      return _react2.default.createElement(
	        'g',
	        null,
	        stroke !== 'none' && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: points
	        })),
	        stroke !== 'none' && isRange && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: baseLine
	        })),
	        _react2.default.createElement(_Curve2.default, _extends({}, this.props, {
	          stroke: 'none',
	          className: 'recharts-area-area'
	        }))
	      );
	    }
	  }, {
	    key: 'renderHorizontalRect',
	    value: function renderHorizontalRect(alpha) {
	      var _props2 = this.props,
	          baseLine = _props2.baseLine,
	          points = _props2.points,
	          strokeWidth = _props2.strokeWidth;
	
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = Math.max.apply(null, points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else {
	        maxY = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      return _react2.default.createElement('rect', {
	        x: startX < endX ? startX : startX - width,
	        y: 0,
	        width: width,
	        height: maxY + (strokeWidth || 1)
	      });
	    }
	  }, {
	    key: 'renderVerticalRect',
	    value: function renderVerticalRect(alpha) {
	      var _props3 = this.props,
	          baseLine = _props3.baseLine,
	          points = _props3.points,
	          strokeWidth = _props3.strokeWidth;
	
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = Math.max.apply(null, points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else {
	        maxX = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      return _react2.default.createElement('rect', {
	        x: 0,
	        y: startY < endY ? startY : startY - height,
	        width: maxX + (strokeWidth || 1),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderClipRect',
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: 'renderClipPath',
	    value: function renderClipPath() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          isAnimationActive = _props4.isAnimationActive,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          animationBegin = _props4.animationBegin,
	          animationId = _props4.animationId;
	
	
	      return _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'animationClipPath-' + this.id },
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration,
	              key: animationId,
	              animationBegin: animationBegin,
	              onAnimationStart: this.handleAnimationStart,
	              onAnimationEnd: this.handleAnimationEnd,
	              from: { alpha: 0 },
	              to: { alpha: 1 }
	            },
	            function (_ref2) {
	              var alpha = _ref2.alpha;
	              return _this2.renderClipRect(alpha);
	            }
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-area-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this3 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          dot = _props5.dot,
	          points = _props5.points;
	
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, areaProps, customDotProps, {
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this3.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            key: props.key
	          }, props, {
	            className: 'recharts-area-label'
	          }),
	          (0, _isArray3.default)(value) ? value[1] : value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this4 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          points = _props6.points,
	          label = _props6.label;
	
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = points.map(function (entry, i) {
	        var labelProps = _extends({
	          textAnchor: 'middle'
	        }, entry, areaProps, customLabelProps, {
	          index: i,
	          key: 'label-' + i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this4.renderLabelItem(label, labelProps, entry.value);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          dot = _props7.dot,
	          label = _props7.label,
	          points = _props7.points,
	          className = _props7.className,
	          top = _props7.top,
	          left = _props7.left,
	          xAxis = _props7.xAxis,
	          yAxis = _props7.yAxis,
	          width = _props7.width,
	          height = _props7.height;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint ? this.renderClipPath() : null,
	        !hasSinglePoint ? _react2.default.createElement(
	          _Layer2.default,
	          { clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null },
	          _react2.default.createElement(
	            _Layer2.default,
	            { clipPath: 'url(#animationClipPath-' + this.id + ')' },
	            this.renderCurve()
	          )
	        ) : null,
	        (dot || hasSinglePoint) && this.renderDots(),
	        label && this.renderLabels()
	      );
	    }
	  }]);
	
	  return Area;
	}(_react.Component), _class2.displayName = 'Area', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  connectNulls: _propTypes2.default.bool,
	
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  // dot configuration
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	
	  // have curve configuration
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isRange: _propTypes2.default.bool,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array])
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  label: false,
	  activeDot: true,
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _temp2)) || _class;
	
	exports.default = Area;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(27);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Rectangle = __webpack_require__(94);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ErrorBar = __webpack_require__(196);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(16);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Bar, _Component);
	
	  function Bar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bar.__proto__ || Object.getPrototypeOf(Bar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-bar-'), _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Bar, [{
	    key: 'renderRectangle',
	    value: function renderRectangle(option, props) {
	      var rectangle = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rectangle = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react2.default.createElement(_Rectangle2.default, props);
	      }
	
	      return rectangle;
	    }
	  }, {
	    key: 'renderRectangles',
	    value: function renderRectangles() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          shape = _props.shape,
	          layout = _props.layout,
	          isAnimationActive = _props.isAnimationActive,
	          animationBegin = _props.animationBegin,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing,
	          animationId = _props.animationId;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var getStyle = function getStyle(isBegin) {
	        return {
	          transform: 'scale' + (layout === 'vertical' ? 'X' : 'Y') + '(' + (isBegin ? 0 : 1) + ')'
	        };
	      };
	
	      return data.map(function (entry, index) {
	        var x = entry.x,
	            y = entry.y,
	            width = entry.width,
	            height = entry.height;
	
	        var props = _extends({}, baseProps, entry, { index: index });
	
	        if ((0, _isNil3.default)(entry.value) || !isAnimationActive) {
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({
	              className: 'recharts-bar-rectangle'
	            }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, index), {
	              key: 'rectangle-' + index
	            }),
	            _this2.renderRectangle(shape, props)
	          );
	        }
	
	        var transformOrigin = '';
	
	        if (layout === 'vertical') {
	          transformOrigin = x + 'px ' + (y + height / 2) + 'px';
	        } else {
	          transformOrigin = x + width / 2 + 'px ' + (y + height) + 'px';
	        }
	
	        return _react2.default.createElement(
	          _reactSmooth2.default,
	          {
	            begin: animationBegin,
	            duration: animationDuration,
	            isActive: isAnimationActive,
	            easing: animationEasing,
	            from: getStyle(true),
	            to: getStyle(false),
	            key: 'rectangle-' + index + '-' + animationId,
	            onAnimationEnd: _this2.handleAnimationEnd,
	            onAnimationStart: _this2.handleAnimationStart
	          },
	          _react2.default.createElement(
	            _Layer2.default,
	            _extends({
	              className: 'recharts-bar-rectangle',
	              style: (0, _reactSmooth.translateStyle)({ transformOrigin: transformOrigin })
	            }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, index), {
	              key: 'rectangle-' + index
	            }),
	            _this2.renderRectangle(shape, props)
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = null;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            key: props.key,
	            className: 'recharts-bar-label'
	          }),
	          (0, _isArray3.default)(value) ? value[1] : value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this3 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          data = _props2.data,
	          label = _props2.label,
	          layout = _props2.layout;
	
	      var barProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = data.map(function (entry, i) {
	        var textAnchor = 'middle';
	        var dominantBaseline = 'central';
	        var x = 0;
	        var y = 0;
	
	        if (layout === 'vertical') {
	          textAnchor = entry.width < 0 ? 'end' : 'start';
	          x = entry.x + entry.width + (entry.width < 0 ? -1 : 1) * 5;
	          y = entry.y + entry.height / 2;
	        } else {
	          dominantBaseline = entry.height < 0 ? 'hanging' : 'inherit';
	          x = entry.x + entry.width / 2;
	          y = entry.y - (entry.height < 0 ? -1 : 1) * 5;
	        }
	
	        var labelProps = _extends({
	          dominantBaseline: dominantBaseline,
	          textAnchor: textAnchor
	        }, barProps, entry, customLabelProps, {
	          x: x,
	          y: y,
	          index: i,
	          key: 'label-' + i,
	          payload: entry.payload
	        });
	
	        var labelValue = entry.value;
	        if (label === true && entry.value && labelProps.label) {
	          labelValue = labelProps.label;
	        }
	        return _this3.renderLabelItem(label, labelProps, labelValue);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-bar-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          data = _props3.data,
	          xAxis = _props3.xAxis,
	          yAxis = _props3.yAxis,
	          layout = _props3.layout,
	          children = _props3.children;
	
	      var errorBarItem = (0, _ReactUtils.findChildByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItem) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return _react2.default.cloneElement(errorBarItem, {
	        data: data,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        layout: layout,
	        offset: offset,
	        dataPointFormatter: dataPointFormatter
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          data = _props4.data,
	          className = _props4.className,
	          label = _props4.label,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          left = _props4.left,
	          top = _props4.top,
	          width = _props4.width,
	          height = _props4.height;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        _react2.default.createElement(
	          _Layer2.default,
	          {
	            className: 'recharts-bar-rectangles',
	            clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
	          },
	          this.renderRectangles()
	        ),
	        label && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-bar-rectangle-labels' },
	          this.renderLabels()
	        ),
	        this.renderErrorBar()
	      );
	    }
	  }]);
	
	  return Bar;
	}(_react.Component), _class2.displayName = 'Bar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  layout: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  barSize: _propTypes2.default.number,
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  minPointSize: _propTypes2.default.number,
	  maxBarSize: _propTypes2.default.number,
	
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array])
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _temp2)) || _class;
	
	exports.default = Bar;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cartesian Axis
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _DOMUtils = __webpack_require__(142);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianAxis = (_temp = _class = function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, (CartesianAxis.__proto__ || Object.getPrototypeOf(CartesianAxis)).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ['viewBox']);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _props = this.props,
	          viewBoxOld = _props.viewBox,
	          restPropsOld = _objectWithoutProperties(_props, ['viewBox']);
	
	      return !(0, _PureRender.shallowEqual)(viewBox, viewBoxOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(state, this.state);
	    }
	
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: 'getTickLineCoord',
	    value: function getTickLineCoord(data) {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          width = _props2.width,
	          height = _props2.height,
	          orientation = _props2.orientation,
	          tickSize = _props2.tickSize,
	          mirror = _props2.mirror;
	
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0,
	          tx = void 0,
	          ty = void 0;
	
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = ty = y2 - sign * finalTickSize;
	          tx = tickCoord;
	          break;
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = tx = x2 - sign * finalTickSize;
	          ty = tickCoord;
	          break;
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = tx = x2 + sign * finalTickSize;
	          ty = tickCoord;
	          break;
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = ty = y2 + sign * finalTickSize;
	          tx = tickCoord;
	          break;
	      }
	
	      return { line: { x1: x1, y1: y1, x2: x2, y2: y2 }, tick: { x: tx, y: ty } };
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var _props3 = this.props,
	          orientation = _props3.orientation,
	          mirror = _props3.mirror;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'getTickVerticalAnchor',
	    value: function getTickVerticalAnchor() {
	      var _props4 = this.props,
	          orientation = _props4.orientation,
	          mirror = _props4.mirror;
	
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: 'getLabelProps',
	    value: function getLabelProps() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          orientation = _props5.orientation;
	
	
	      switch (orientation) {
	        case 'left':
	          return { x: x + width, y: y - 6, textAnchor: 'middle' };
	        case 'right':
	          return { x: x, y: y - 6, textAnchor: 'middle' };
	        case 'top':
	          return { x: x + width + 6, y: y + height + 6, textAnchor: 'start' };
	        default:
	          return { x: x + width + 6, y: y + 6, textAnchor: 'start' };
	      }
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          orientation = _props6.orientation,
	          axisLine = _props6.axisLine,
	          mirror = _props6.mirror;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _extends({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _extends({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-cartesian-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-cartesian-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks(ticks) {
	      var _this2 = this;
	
	      var _props7 = this.props,
	          tickLine = _props7.tickLine,
	          stroke = _props7.stroke,
	          tick = _props7.tick,
	          tickFormatter = _props7.tickFormatter;
	
	      var finalTicks = CartesianAxis.getTicks(_extends({}, this.props, { ticks: ticks }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	      var items = finalTicks.map(function (entry, i) {
	        var _getTickLineCoord = _this2.getTickLineCoord(entry),
	            lineCoord = _getTickLineCoord.line,
	            tickCoord = _getTickLineCoord.tick;
	
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, tickCoord, {
	          index: i, payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-cartesian-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-cartesian-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var _props8 = this.props,
	          label = _props8.label,
	          stroke = _props8.stroke,
	          orientation = _props8.orientation,
	          viewBox = _props8.viewBox;
	
	      var presentation = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, _extends({}, presentation, { orientation: orientation, viewBox: viewBox }));
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(this.props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        var props = _extends({}, presentation, {
	          stroke: 'none',
	          fill: stroke
	        }, this.getLabelProps());
	
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-cartesian-axis-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props9 = this.props,
	          axisLine = _props9.axisLine,
	          width = _props9.width,
	          height = _props9.height,
	          ticksGenerator = _props9.ticksGenerator;
	
	      var _props10 = this.props,
	          ticks = _props10.ticks,
	          noTicksProps = _objectWithoutProperties(_props10, ['ticks']);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction3.default)(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-cartesian-axis' },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks(finalTicks),
	        this.renderLabel()
	      );
	    }
	  }], [{
	    key: 'getTicks',
	    value: function getTicks(props) {
	      var ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter;
	
	
	      if (!ticks || !ticks.length) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
	        }, true);
	      } else if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({ ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap });
	    }
	  }, {
	    key: 'getNumberIntervalTicks',
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: 'getTicksStart',
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey];
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _extends({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _extends({}, tail, { isShow: true });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	      for (var i = 0; i < count; i++) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey];
	
	        if (i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: 'getTicksEnd',
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var i = len - 1; i >= 0; i--) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey];
	
	        if (i === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component), _class.displayName = 'CartesianAxis', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  mirror: _propTypes2.default.bool,
	
	  minTickGap: _propTypes2.default.number,
	  ticks: _propTypes2.default.array,
	  tickSize: _propTypes2.default.number,
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  ticksGenerator: _propTypes2.default.func,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: { x: 0, y: 0, width: 0, height: 0 },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  interval: 'preserveEnd'
	}, _temp);
	exports.default = CartesianAxis;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cartesian Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CartesianGrid, _Component);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, (CartesianGrid.__proto__ || Object.getPrototypeOf(CartesianGrid)).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: 'renderLineItem',
	    value: function renderLineItem(option, props) {
	      var lineItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        lineItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ['x1', 'y1', 'x2', 'y2', 'key']);
	
	        lineItem = _react2.default.createElement('line', _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: 'none',
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	
	  }, {
	    key: 'renderHorizontal',
	    value: function renderHorizontal(horizontalPoints) {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          width = _props.width,
	          horizontal = _props.horizontal;
	
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _extends({}, _this2.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this2.renderLineItem(horizontal, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-horizontal' },
	        items
	      );
	    }
	
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: 'renderVertical',
	    value: function renderVertical(verticalPoints) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          y = _props2.y,
	          height = _props2.height,
	          vertical = _props2.vertical;
	
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _extends({}, _this3.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this3.renderLineItem(vertical, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-vertical' },
	        items
	      );
	    }
	
	    /**
	    * Draw vertical grid stripes filled by colors
	    * @param {Array} verticalPoints either passed in as props or generated from function
	    * @return {Group} Vertical stripes
	    */
	
	  }, {
	    key: 'renderVerticalStripes',
	    value: function renderVerticalStripes(verticalPoints) {
	      var verticalFill = this.props.verticalFill;
	
	      if (!verticalFill || !verticalFill.length) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          fillOpacity = _props3.fillOpacity,
	          x = _props3.x,
	          y = _props3.y,
	          width = _props3.width,
	          height = _props3.height;
	
	      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
	        return a - b > 0;
	      });
	
	      if (x !== verticalPointsUpdated[0]) {
	        verticalPointsUpdated.unshift(0);
	      }
	
	      var items = verticalPointsUpdated.map(function (entry, i) {
	        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
	        if (lineWidth <= 0) {
	          return null;
	        }
	        var colorIndex = i % verticalFill.length;
	
	        return _react2.default.createElement('rect', {
	          key: i,
	          x: Math.round(entry + x - x),
	          y: y,
	          width: lineWidth,
	          height: height,
	          stroke: 'none',
	          fill: verticalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: 'recharts-cartesian-grid-bg'
	        });
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-gridstripes-vertical' },
	        items
	      );
	    }
	
	    /**
	    * Draw horizontal grid stripes filled by colors
	    * @param {Array} horizontalPoints either passed in as props or generated from function
	    * @return {Group} Horizontal stripes
	    */
	
	  }, {
	    key: 'renderHorizontalStripes',
	    value: function renderHorizontalStripes(horizontalPoints) {
	      var horizontalFill = this.props.horizontalFill;
	
	      if (!horizontalFill || !horizontalFill.length) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          fillOpacity = _props4.fillOpacity,
	          x = _props4.x,
	          y = _props4.y,
	          width = _props4.width,
	          height = _props4.height;
	
	      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
	        return a - b > 0;
	      });
	      if (y !== horizontalPointsUpdated[0]) {
	        horizontalPointsUpdated.unshift(0);
	      }
	
	      var items = horizontalPointsUpdated.map(function (entry, i) {
	        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
	        if (lineHeight <= 0) {
	          return null;
	        }
	        var colorIndex = i % horizontalFill.length;
	        return _react2.default.createElement('rect', {
	          key: i,
	          y: Math.round(entry + y - y),
	          x: x,
	          height: lineHeight,
	          width: width,
	          stroke: 'none',
	          fill: horizontalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: 'recharts-cartesian-grid-bg'
	        });
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-gridstripes-horizontal' },
	        items
	      );
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _props5 = this.props,
	          fillOpacity = _props5.fillOpacity,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height;
	
	
	      return _react2.default.createElement('rect', {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: 'none',
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: 'recharts-cartesian-grid-bg'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          horizontal = _props6.horizontal,
	          vertical = _props6.vertical,
	          horizontalCoordinatesGenerator = _props6.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _props6.verticalCoordinatesGenerator,
	          xAxis = _props6.xAxis,
	          yAxis = _props6.yAxis,
	          offset = _props6.offset,
	          chartWidth = _props6.chartWidth,
	          chartHeight = _props6.chartHeight;
	
	
	      if (width <= 0 || height <= 0 || x !== +x || y !== +y) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          horizontalPoints = _props7.horizontalPoints,
	          verticalPoints = _props7.verticalPoints;
	
	
	      if ((0, _isFunction3.default)(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({ yAxis: yAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      if ((0, _isFunction3.default)(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({ xAxis: xAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid' },
	        this.renderBackground(),
	        horizontal && this.renderHorizontal(horizontalPoints),
	        vertical && this.renderVertical(verticalPoints),
	        horizontal && this.renderHorizontalStripes(horizontalPoints),
	        vertical && this.renderVerticalStripes(verticalPoints)
	      );
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.Component), _class2.displayName = 'CartesianGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  horizontal: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  vertical: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  horizontalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  verticalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  horizontalCoordinatesGenerator: _propTypes2.default.func,
	  verticalCoordinatesGenerator: _propTypes2.default.func,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number,
	  verticalFill: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  horizontalFill: _propTypes2.default.arrayOf(_propTypes2.default.string)
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	
	  stroke: '#ccc',
	  fill: 'none',
	  // The fill of colors of grid lines
	  verticalFill: [],
	  horizontalFill: []
	}, _temp)) || _class;
	
	exports.default = CartesianGrid;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Line
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Curve = __webpack_require__(93);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(75);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ErrorBar = __webpack_require__(196);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _DataUtils = __webpack_require__(16);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FACTOR = 1.0000001;
	
	var Line = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-line-'), _this.pathRef = function (node) {
	      _this.animate = node;
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Line, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (!isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	
	      this.setState({ totalLength: totalLength });
	    }
	
	    /* eslint-disable  react/no-did-update-set-state */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var animationId = this.props.animationId;
	
	
	      if (animationId !== prevProps.animationId) {
	        var cur = this.getTotalLength();
	        var totalLength = prevState.totalLength;
	        // A hack method to trigger animation
	
	        this.setState({
	          totalLength: cur === totalLength ? cur * FACTOR : cur
	        });
	      }
	    }
	  }, {
	    key: 'getTotalLength',
	    value: function getTotalLength() {
	      var curveDom = this.animate;
	      var totalLength = curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	
	      return totalLength;
	    }
	  }, {
	    key: 'getStrokeDasharray',
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	
	      var remainLines = [];
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	
	      return [].concat(_toConsumableArray(this.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return line + 'px';
	      }).join(', ');
	    }
	  }, {
	    key: 'repeat',
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            key: props.key
	          }, props, {
	            className: 'recharts-line-label'
	          }),
	          value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props = this.props,
	          points = _props.points,
	          label = _props.label;
	
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = points.map(function (entry, i) {
	        var labelProps = _extends({
	          textAnchor: 'middle'
	        }, entry, lineProps, customLabelProps, {
	          index: i,
	          key: 'label-' + i
	        });
	
	        return _this2.renderLabelItem(label, labelProps, entry.value);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          points = _props2.points,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          layout = _props2.layout,
	          children = _props2.children;
	
	      var errorBarItem = (0, _ReactUtils.findChildByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItem) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return _react2.default.cloneElement(errorBarItem, {
	        data: points,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        layout: layout,
	        dataPointFormatter: dataPointFormatter
	      });
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames2.default)('recharts-line-dot', option.className);
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: className }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this3 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props3 = this.props,
	          dot = _props3.dot,
	          points = _props3.points;
	
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, lineProps, customDotProps, {
	          value: entry.value,
	          cx: entry.x, cy: entry.y, index: i, payload: entry.payload
	        });
	
	        return _this3.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-dots', key: 'dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderCurve',
	    value: function renderCurve(needClip) {
	      var _this4 = this;
	
	      var _props4 = this.props,
	          points = _props4.points,
	          strokeDasharray = _props4.strokeDasharray,
	          isAnimationActive = _props4.isAnimationActive,
	          animationBegin = _props4.animationBegin,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          onClick = _props4.onClick,
	          onMouseEnter = _props4.onMouseEnter,
	          onMouseLeave = _props4.onMouseLeave,
	          other = _objectWithoutProperties(_props4, ['points', 'strokeDasharray', 'isAnimationActive', 'animationBegin', 'animationDuration', 'animationEasing', 'onClick', 'onMouseEnter', 'onMouseLeave']);
	
	      var totalLength = this.state.totalLength;
	
	      var animationProps = {
	        isActive: isAnimationActive,
	        begin: animationBegin,
	        canBegin: totalLength > 0,
	        easing: animationEasing,
	        duration: animationDuration,
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart,
	        shouldReAnimate: true,
	        pathRef: this.pathRef
	      };
	      var curveProps = _extends({}, other, {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null,
	        onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, points: points
	      });
	
	      if (!isAnimationActive) {
	        return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, { strokeDasharray: strokeDasharray }));
	      }
	
	      if (strokeDasharray && totalLength) {
	        var _ret2 = function () {
	          var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	            return parseFloat(num);
	          });
	
	          return {
	            v: _react2.default.createElement(
	              _reactSmooth2.default,
	              _extends({}, animationProps, {
	                from: { curveLen: 0 },
	                to: { curveLen: totalLength }
	              }),
	              function (_ref2) {
	                var curveLen = _ref2.curveLen;
	                return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, {
	                  strokeDasharray: _this4.getStrokeDasharray(curveLen, totalLength, lines)
	                }));
	              }
	            )
	          };
	        }();
	
	        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	      } else if (strokeDasharray) {
	        return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, {
	          pathRef: this.pathRef,
	          strokeDasharray: strokeDasharray
	        }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        _extends({}, animationProps, {
	          from: '0px ' + (totalLength === 0 ? 1 : totalLength) + 'px',
	          to: totalLength + 'px 0px',
	          attributeName: 'strokeDasharray'
	        }),
	        _react2.default.createElement(_Curve2.default, curveProps)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          dot = _props5.dot,
	          points = _props5.points,
	          label = _props5.label,
	          className = _props5.className,
	          xAxis = _props5.xAxis,
	          yAxis = _props5.yAxis,
	          top = _props5.top,
	          left = _props5.left,
	          width = _props5.width,
	          height = _props5.height;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint && this.renderCurve(needClip),
	        this.renderErrorBar(),
	        (hasSinglePoint || dot) && this.renderDots(),
	        label && this.renderLabels()
	      );
	    }
	  }]);
	
	  return Line;
	}(_react.Component), _class2.displayName = 'Line', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes2.default.bool,
	
	  // whether have dot in line
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes2.default.number
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _temp2)) || _class;
	
	exports.default = Line;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview X Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var XAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(XAxis, _Component);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, (XAxis.__proto__ || Object.getPrototypeOf(XAxis)).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.Component), _class2.displayName = 'XAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes2.default.number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['top', 'bottom']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  padding: _propTypes2.default.shape({
	    left: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: { left: 0, right: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	}, _temp)) || _class;
	
	exports.default = XAxis;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Y Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(YAxis, _Component);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, (YAxis.__proto__ || Object.getPrototypeOf(YAxis)).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.Component), _class2.displayName = 'YAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes2.default.number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['left', 'right']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    bottom: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: { top: 0, bottom: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	}, _temp)) || _class;
	
	exports.default = YAxis;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polygon
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Polygon, _Component);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          points = _props.points,
	          className = _props.className;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-polygon', className);
	
	      return _react2.default.createElement('polygon', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.Component), _class2.displayName = 'Polygon', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }))
	}), _temp)) || _class;
	
	exports.default = Polygon;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Sector
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _PolarUtils = __webpack_require__(64);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius;
	
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	  var centerAngle = angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
	  // The coordinate of point which is tangent to the circle
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
	  // The coordinate of point which is tangent to the radius line
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), angle);
	
	  return { center: center, circleTangency: circleTangency, lineTangency: lineTangency, theta: theta };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	
	  var angle = getDeltaAngle(startAngle, endAngle);
	
	  // When the angle of sector equals to 360, star point and end point coincide
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	
	  var path = 'M ' + outerStartPoint.x + ',' + outerStartPoint.y + '\n    A ' + outerRadius + ',' + outerRadius + ',0,\n    ' + +(Math.abs(angle) > 180) + ',' + +(startAngle > tempEndAngle) + ',\n    ' + outerEndPoint.x + ',' + outerEndPoint.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += 'L ' + innerEndPoint.x + ',' + innerEndPoint.y + '\n            A ' + innerRadius + ',' + innerRadius + ',0,\n            ' + +(Math.abs(angle) > 180) + ',' + +(startAngle <= tempEndAngle) + ',\n            ' + innerStartPoint.x + ',' + innerStartPoint.y + ' Z';
	  } else {
	    path += 'L ' + cx + ',' + cy + ' Z';
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: startAngle, sign: sign, cornerRadius: cornerRadius
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: endAngle, sign: -sign, cornerRadius: cornerRadius
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    return getSectorPath({
	      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    });
	  }
	
	  var path = 'M ' + solt.x + ',' + solt.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + soct.x + ',' + soct.y + '\n    A' + outerRadius + ',' + outerRadius + ',0,' + +(outerArcAngle > 180) + ',' + +(sign < 0) + ',' + eoct.x + ',' + eoct.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eolt.x + ',' + eolt.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: startAngle, sign: sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: endAngle, sign: -sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return path + 'L' + cx + ',' + cy + 'Z';
	    }
	
	    path += 'L' + eilt.x + ',' + eilt.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eict.x + ',' + eict.y + '\n      A' + innerRadius + ',' + innerRadius + ',0,' + +(innerArcAngle > 180) + ',' + +(sign > 0) + ',' + sict.x + ',' + sict.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + silt.x + ',' + silt.y + 'Z';
	  } else {
	    path += 'L' + cx + ',' + cy + 'Z';
	  }
	
	  return path;
	};
	
	var Sector = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sector, _Component);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, (Sector.__proto__ || Object.getPrototypeOf(Sector)).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          innerRadius = _props.innerRadius,
	          outerRadius = _props.outerRadius,
	          cornerRadius = _props.cornerRadius,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle,
	          className = _props.className;
	
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path = void 0;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          startAngle: startAngle, endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({ cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle });
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.Component), _class2.displayName = 'Sector', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0
	}, _temp)) || _class;
	
	exports.default = Sector;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(240);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle, symbolCross: _d3Shape.symbolCross, symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare, symbolStar: _d3Shape.symbolStar, symbolTriangle: _d3Shape.symbolTriangle, symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = 'symbol' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	    case 'square':
	      return size * size;
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Symbols, _Component);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, (Symbols.__proto__ || Object.getPrototypeOf(Symbols)).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: 'getPath',
	
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          size = _props.size,
	          sizeType = _props.sizeType,
	          type = _props.type;
	
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	
	      return symbol();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          size = _props2.size;
	
	
	      if (cx === +cx && cy === +cy && size === +size) {
	
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames2.default)('recharts-symbols', className),
	          transform: 'translate(' + cx + ', ' + cy + ')',
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.Component), _class2.displayName = 'Symbols', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  size: _propTypes2.default.number,
	  sizeType: _propTypes2.default.oneOf(['area', 'diameter'])
	}), _class2.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	}, _temp)) || _class;
	
	exports.default = Symbols;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        (function () {
	          var args = [a, b, c, d, e, f];
	          var argIndex = 0;
	
	          console.warn(format.replace(/%s/g, function () {
	            return args[argIndex++];
	          }));
	        })();
	      }
	    }
	  }
	};

/***/ },
/* 317 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(202)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 319 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 320 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 321 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 322 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 323 */
[1679, 95, 55],
/* 324 */
[1680, 1623, 1624, 1625, 1626, 1627],
/* 325 */
[1693, 669, 207],
/* 326 */
[1702, 1578, 1579, 144, 27, 1653],
/* 327 */
276,
/* 328 */
[1729, 27, 122],
/* 329 */
278,
/* 330 */
[1754, 1570, 78],
/* 331 */
279,
/* 332 */
[1761, 1561, 1575, 208],
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(145),
	    _assign = __webpack_require__(17);
	
	var ReactNoopUpdateQueue = __webpack_require__(336);
	
	var canDefineProperty = __webpack_require__(337);
	var emptyObject = __webpack_require__(85);
	var invariant = __webpack_require__(10);
	var lowPriorityWarning = __webpack_require__(699);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 335 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(14);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	var settle = __webpack_require__(715);
	var buildURL = __webpack_require__(718);
	var parseHeaders = __webpack_require__(724);
	var isURLSameOrigin = __webpack_require__(722);
	var createError = __webpack_require__(341);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(717);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(720);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 339 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 340 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(714);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 342 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DelayRender = function DelayRender(props) {
		return props.test ? _react2.default.createElement(
			'div',
			null,
			' ',
			props.children,
			' '
		) : _react2.default.createElement('div', null);
	};
	exports.default = (0, _mobxReact.observer)(DelayRender);

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Password = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Password, _React$Component);
	
	  function Password() {
	    _classCallCheck(this, Password);
	
	    return _possibleConstructorReturn(this, (Password.__proto__ || Object.getPrototypeOf(Password)).apply(this, arguments));
	  }
	
	  _createClass(Password, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        valid: false
	      };
	    }
	  }, {
	    key: 'checkPassword',
	    value: function checkPassword(e, callback) {
	      var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;
	
	      if (passwordPattern.test(e.target.value)) {
	        e.target.setCustomValidity('');
	      } else {
	        e.target.setCustomValidity('invalid');
	      }
	
	      this.setState({
	        valid: passwordPattern.test(e.target.value)
	      });
	
	      if (callback) {
	        callback(e, 'password');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-wrap ' + (this.state.valid ? 'valid' : 'invalid') },
	        _react2.default.createElement('input', {
	          type: 'password',
	          id: this.props.id,
	          onChange: function onChange(e) {
	            _this2.checkPassword(e, _this2.props.changeFunction);
	          },
	          required: true,
	          'aria-required': 'true',
	          'aria-describedby': 'password-tooltip'
	        }),
	        _react2.default.createElement(
	          'i',
	          { className: 'password-validity' },
	          this.state.valid && _react2.default.createElement(icons.iconCheckCircle, null),
	          !this.state.valid && _react2.default.createElement(icons.iconNo, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            this.state.valid ? 'Valid' : 'Invalid'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tooltip' },
	          _react2.default.createElement(
	            'div',
	            { id: 'password-tooltip', className: 'tooltip__body', role: 'tooltip' },
	            translation.tooltip_body,
	            _react2.default.createElement(
	              'ul',
	              { className: 'tooltip__list' },
	              translation.requirements.map(function (key, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  key
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Password;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Password')(Password);

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	var TallyLoader = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(TallyLoader, _React$Component);
	
	  function TallyLoader() {
	    _classCallCheck(this, TallyLoader);
	
	    return _possibleConstructorReturn(this, (TallyLoader.__proto__ || Object.getPrototypeOf(TallyLoader)).apply(this, arguments));
	  }
	
	  _createClass(TallyLoader, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store$SessionS = this.props.store.SessionStore,
	          loadingCalls = _props$store$SessionS.loadingCalls,
	          tallySteps = _props$store$SessionS.tallySteps;
	
	
	      var steps = [];
	
	      tallySteps.forEach(function (step) {
	        var stepObj = {
	          title: step,
	          started: loadingCalls.indexOf(step) > -1 ? true : false,
	          completed: false,
	          success: false
	        };
	
	        steps.push(stepObj);
	      });
	
	      this.state = {
	        steps: steps,
	        total: tallySteps.length,
	        complete: false
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var SessionStore = this.props.store.SessionStore;
	      var loadingCalls = SessionStore.loadingCalls,
	          failedCalls = SessionStore.failedCalls,
	          tallyConfirmClose = SessionStore.tallyConfirmClose;
	      var steps = this.state.steps;
	
	      var updatedSteps = [];
	      var total = steps.length;
	      var completed = 0;
	
	      if (prevState.steps === this.state.steps) {
	        steps.forEach(function (step) {
	          // Mark newly started steps
	          if (!step.started && loadingCalls.indexOf(step.title) > -1) {
	            step.started = true;
	          }
	
	          // Mark failed steps
	          if (step.started && loadingCalls.indexOf(step.title) < 0 && failedCalls.indexOf(step.title) > -1) {
	            step.completed = true;
	            completed++;
	          }
	
	          // Mark off completed steps
	          if (step.started && loadingCalls.indexOf(step.title) < 0 && failedCalls.indexOf(step.title) < 0) {
	            step.success = true;
	            step.completed = true;
	            completed++;
	          }
	
	          updatedSteps.push(step);
	        });
	
	        this.setState({
	          steps: updatedSteps
	        });
	
	        if (completed === total) {
	          // Set a small timeout so the transition
	          // from tally loader to next screen
	          // isn’t as jarring
	          if (!tallyConfirmClose) {
	            setTimeout(function () {
	              SessionStore.tallyLoad = false;
	              SessionStore.tallySteps = [];
	            }, 500);
	          } else {
	            var _this = this;
	            setTimeout(function () {
	              _this.setState({ complete: true });
	            }, 500);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var SessionStore = this.props.store.SessionStore;
	
	      SessionStore.tallySteps = [];
	      SessionStore.tallyLoad = false;
	      SessionStore.failedCalls = [];
	      SessionStore.tallyConfirmClose = false;
	    }
	  }, {
	    key: 'closeTally',
	    value: function closeTally() {
	      var _this = this;
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore;
	
	      // Clear out examFiles and examAttachments
	      // since they have already been handled
	
	      ExamStore.examAttachments = null;
	      ExamStore.examFiles = null;
	
	      SessionStore.tallyLoad = false;
	      SessionStore.tallySteps = [];
	      SessionStore.tallyConfirmClose = false;
	
	      // Redirect
	      var newPathname = '';
	      var segment1 = (0, _helpers.getURLSegment)(_this, 1);
	      var segment2 = (0, _helpers.getURLSegment)(_this, 2);
	
	      if (segment2 === 'add') {
	        newPathname = segment1 + '/' + ExamStore.examSid;
	      } else {
	        var examSid = (0, _helpers.getURLSegment)(_this, 3);
	        newPathname = segment1 + '/' + examSid;
	      }
	
	      _this.props.routing.push({
	        pathname: newPathname,
	        search: '?toaster=examSaved'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _this = this;
	      var translation = this.props.translation;
	      var _props$store$SessionS2 = this.props.store.SessionStore,
	          loadingCalls = _props$store$SessionS2.loadingCalls,
	          failedCalls = _props$store$SessionS2.failedCalls;
	      var _state = this.state,
	          steps = _state.steps,
	          complete = _state.complete;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel--brief tally-loader' },
	        !complete && _react2.default.createElement(
	          'ol',
	          { className: 'tally' },
	          steps.map(function (step, i) {
	            var status = '';
	            var title = step.title;
	
	            if (loadingCalls.indexOf(step.title) > -1 && !step.completed) {
	              status = 'in-progress';
	            } else if (step.completed) {
	              if (step.success) {
	                status = 'completed';
	              } else {
	                status = 'failed';
	                title += '_failed';
	              }
	            }
	
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'strong',
	                { className: 'tally__title' },
	                translation[title] || step.title
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'tally__status ' + status
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation[status]
	                )
	              )
	            );
	          })
	        ),
	        complete && _react2.default.createElement(
	          'div',
	          null,
	          failedCalls.length > 0 && _react2.default.createElement(
	            'h2',
	            null,
	            translation.exam_created.roster_fail
	          ),
	          failedCalls.length === 0 && _react2.default.createElement(
	            'h2',
	            null,
	            translation.exam_created.roster_success
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'actions__btn actions__btn--primary',
	              onClick: function onClick() {
	                return _this3.closeTally();
	              }
	            },
	            translation.confirm
	          )
	        )
	      );
	    }
	  }]);
	
	  return TallyLoader;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('TallyLoader')(TallyLoader);

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var Counter = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Counter, _React$Component);
	
	  function Counter() {
	    _classCallCheck(this, Counter);
	
	    var _this2 = _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).call(this));
	
	    _this2.countdown = _this2.countdown.bind(_this2);
	    _this2.onExpire = _this2.onExpire.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Counter, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        counter: null,
	        counterClass: ''
	
	        // Get current server time
	      };this.props.store.SessionStore.getCurrentTime(true);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      var timeDelay = setInterval(function () {
	        if (!SessionStore.loading && SessionStore.currentTime) {
	          clearInterval(timeDelay);
	
	          _this.setState({
	            currentTime: SessionStore.currentTime
	          });
	
	          _this.timer = setInterval(_this.countdown, 1000);
	        }
	      }, 100);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'countdown',
	    value: function countdown() {
	      var now = this.state.currentTime;
	      var expire = (0, _moment2.default)(this.props.endDate).subtract(5, 'seconds');
	      var difference = new _moment2.default.duration(expire.diff(now));
	
	      var newTime = (0, _moment2.default)(now).add(1, 'seconds');
	
	      this.setState({
	        currentTime: newTime
	      });
	
	      // console.log(`Now: ${now}`);
	      // console.log(`Expire: ${expire}`);
	
	      var countdown = {};
	
	      countdown.days = difference.days();
	      countdown.hours = difference.hours();
	      countdown.minutes = difference.minutes();
	      countdown.seconds = difference.seconds();
	
	      // console.log(`Time Remaining: ${countdown.days}:${countdown.hours}:${countdown.minutes}:${countdown.seconds}`);
	
	      if (countdown.days <= 0 && countdown.hours <= 0 && countdown.minutes <= 0) {
	        this.setState({
	          counterClass: 'counter--ending'
	        });
	      } else {
	        this.setState({
	          counterClass: ''
	        });
	      }
	
	      var counter = '';
	
	      Object.keys(countdown).map(function (key, i) {
	        if (countdown[key] < 0) {
	          countdown[key] = 0;
	        }
	
	        if (key === 'days' && countdown.days !== 0 || key === 'hours' && (countdown.days !== 0 || countdown.hours !== 0) || key !== 'days' && key !== 'hours') {
	          if (countdown[key] < 10) {
	            countdown[key] = '0' + countdown[key];
	          }
	          if (counter.length) {
	            counter += ':' + countdown[key];
	          } else {
	            counter += countdown[key];
	          }
	        }
	
	        return true;
	      });
	
	      this.setState({
	        counter: counter
	      });
	
	      // Expire
	      if (countdown.days <= 0 && countdown.hours <= 0 && countdown.minutes <= 0 && countdown.seconds <= 0) {
	        this.onExpire();
	      }
	    }
	  }, {
	    key: 'onExpire',
	    value: function onExpire() {
	      clearInterval(this.timer);
	
	      if (this.props.callback) {
	        this.props.callback();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'counter' },
	        translation.time_remaining,
	        ': ',
	        _react2.default.createElement(
	          'strong',
	          { className: 'counter__time ' + this.state.counterClass },
	          this.state.counter
	        )
	      );
	    }
	  }]);
	
	  return Counter;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Counter')(Counter);

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var EnrollComplete = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EnrollComplete, _React$Component);
	
	  function EnrollComplete() {
	    _classCallCheck(this, EnrollComplete);
	
	    return _possibleConstructorReturn(this, (EnrollComplete.__proto__ || Object.getPrototypeOf(EnrollComplete)).apply(this, arguments));
	  }
	
	  _createClass(EnrollComplete, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var main = document.getElementById('complete-main');
	      if (main && this.props.isActive === 'slide-active') {
	        setTimeout(function () {
	          return main.focus();
	        }, 250);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel panel--brief ' + this.props.isActive },
	        _react2.default.createElement(
	          'h1',
	          { className: 'panel__title', id: 'complete-main', tabIndex: '0' },
	          translation.heading
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.body) } }),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: 'btn btn--icn-right next', to: this.props.store.SessionStore.afterEnroll },
	          translation.button,
	          _react2.default.createElement(icons.iconCircleRight, null)
	        )
	      );
	    }
	  }]);
	
	  return EnrollComplete;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EnrollComplete')(EnrollComplete);

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDropzone = __webpack_require__(270);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _exifJs = __webpack_require__(978);
	
	var _exifJs2 = _interopRequireDefault(_exifJs);
	
	var _EnrollValidate = __webpack_require__(773);
	
	var _EnrollValidate2 = _interopRequireDefault(_EnrollValidate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	// import { checkValidity } from '../../helpers/helpers.js'
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var EnrollPC = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EnrollPC, _React$Component);
	
	  function EnrollPC() {
	    _classCallCheck(this, EnrollPC);
	
	    var _this2 = _possibleConstructorReturn(this, (EnrollPC.__proto__ || Object.getPrototypeOf(EnrollPC)).call(this));
	
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.setStep = _this2.setStep.bind(_this2);
	    _this2.handleDrop = _this2.handleDrop.bind(_this2);
	    _this2.acceptPhoto = _this2.acceptPhoto.bind(_this2);
	    _this2.rejectPhoto = _this2.rejectPhoto.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.handleUploaded = _this2.handleUploaded.bind(_this2);
	    _this2.rotateImage = _this2.rotateImage.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(EnrollPC, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        step: 1,
	        validating: false,
	        idFront: null,
	        idBack: null,
	        headshot: null,
	        pendingPhotos: [],
	        acceptedPhotos: [],
	        uploadedPhotos: [],
	        idFrontUploaded: false,
	        idBackUploaded: false,
	        headshotUploaded: false,
	        rotation: 0
	      };
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'handleDrop',
	    value: function handleDrop(photo, name) {
	      var _setState;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, photo), _defineProperty(_setState, 'pendingPhotos', [name]), _setState));
	    }
	  }, {
	    key: 'acceptPhoto',
	    value: function acceptPhoto(name) {
	      var _this3 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	      var callback = null;
	      var acceptedPhotos = [].concat(_toConsumableArray(this.state.acceptedPhotos));
	      acceptedPhotos.push(name);
	
	      this.setState({
	        acceptedPhotos: acceptedPhotos,
	        pendingPhotos: []
	      });
	
	      // Convert preview image and send it
	      var canvas = document.querySelector('.image-preview__canvas');
	      var image = canvas.toDataURL('image/jpeg', .8);
	
	      // Convert base64 to binary data
	      var binaryString = atob(image.split(',')[1]);
	
	      // Separate mime type
	      var mimeString = image.split(',')[0].split(':')[1].split(';')[0];
	
	      // Write the binary data to an ArrayBuffer
	      var ab = new ArrayBuffer(binaryString.length);
	
	      // Create a view into the buffer
	      var ia = new Uint8Array(ab);
	
	      // Set the binary data of the buffer to the correct values
	      for (var i = 0; i < binaryString.length; i++) {
	        ia[i] = binaryString.charCodeAt(i);
	      }
	
	      // Write the ArrayBuffer to a blob
	      var blob = new Blob([ab], { type: mimeString });
	
	      if (name === 'idFront') {
	        // Submit front of id
	        callback = function callback() {
	          return _this3.handleUploaded('idFrontUploaded');
	        };
	        this.props.store.SmarterIDStore.uploadSIDImage(blob, 'id-front', callback, this);
	      } else if (name === 'idBack') {
	        // Submit back of id
	        callback = function callback() {
	          return _this3.handleUploaded('idBackUploaded');
	        };
	        this.props.store.SmarterIDStore.uploadSIDImage(blob, 'id-back', callback, this);
	      } else {
	        // Submit headshot
	        callback = function callback() {
	          return _this3.handleUploaded('headshotUploaded');
	        };
	        this.props.store.SmarterIDStore.uploadSIDImage(blob, 'selfie', callback, this);
	      }
	
	      // If the last image is still uploading, show the loader
	      if (this.state.idFront && this.state.idBack && this.state.headshot && this.state.uploadedPhotos.length === 2) {
	        SessionStore.startLoading('Loading…', 'UploadedFinalPhoto');
	      }
	    }
	  }, {
	    key: 'rejectPhoto',
	    value: function rejectPhoto(name) {
	      var _setState2;
	
	      var input = null;
	
	      // Reset the hidden input field
	      if (name === 'idFront') {
	        input = document.querySelector('#enroll-id-front');
	      } else if (name === 'idBack') {
	        input = document.querySelector('#enroll-id-back');
	      } else if (name === 'headshot') {
	        input = document.querySelector('#enroll-headshot');
	      }
	
	      input.value = '';
	
	      // Reset the state
	      this.setState((_setState2 = {}, _defineProperty(_setState2, name, null), _defineProperty(_setState2, 'pendingPhotos', []), _setState2));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      this.props.setStep(null, 5);
	      this.props.setDisplayStep(3);
	    }
	  }, {
	    key: 'handleUploaded',
	    value: function handleUploaded(name) {
	      var _setState3;
	
	      var SessionStore = this.props.store.SessionStore;
	
	      var uploadedPhotos = [].concat(_toConsumableArray(this.state.uploadedPhotos));
	      uploadedPhotos.push(name);
	
	      this.setState((_setState3 = {}, _defineProperty(_setState3, name, true), _defineProperty(_setState3, 'uploadedPhotos', uploadedPhotos), _setState3));
	
	      this.nextStep();
	
	      // Hide the loader if all images are uploaded
	      if (this.state.uploadedPhotos.length === 3) {
	        SessionStore.finishLoading('UploadedFinalPhoto');
	
	        this.setState({
	          validating: true
	        });
	      }
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'previewImage',
	    value: function previewImage(rotate, direction) {
	      var _this = this;
	      var image = document.querySelector('.image-preview');
	      var canvas = document.querySelector('.image-preview__canvas');
	      var ctx = canvas.getContext('2d');
	      var orientation = null;
	
	      _exifJs2.default.getData(image, function () {
	        orientation = _exifJs2.default.getTag(this, 'Orientation');
	
	        if (!orientation) {
	          orientation = 1;
	        }
	      });
	
	      var orientationDelay = setInterval(function () {
	        if (orientation) {
	          clearInterval(orientationDelay);
	
	          var img = new Image();
	
	          img.onload = function () {
	            var imgWidth = img.width;
	            var imgHeight = img.height;
	            var ratio = 1;
	            var maxSize = 2000;
	
	            if (imgWidth > imgHeight && imgWidth > maxSize) {
	              ratio = maxSize / imgWidth;
	              imgWidth = maxSize;
	              imgHeight *= ratio;
	            } else if (imgHeight > imgWidth && imgHeight > maxSize) {
	              ratio = maxSize / imgHeight;
	              imgHeight = maxSize;
	              imgWidth *= ratio;
	            }
	
	            // set proper canvas dimensions before transform & export
	            if (orientation > 4 && orientation < 9) {
	              canvas.width = imgHeight;
	              canvas.height = imgWidth;
	            } else {
	              canvas.width = imgWidth;
	              canvas.height = imgHeight;
	            }
	
	            // transform context before drawing image
	            switch (orientation) {
	              case 1:
	                ctx.scale(ratio, ratio);
	                break;
	
	              case 2:
	                ctx.transform(-1, ratio, ratio, 1, imgWidth, 0);
	                break;
	
	              case 3:
	                ctx.scale(ratio, ratio);
	                break;
	
	              case 4:
	                ctx.transform(1, ratio, ratio, -1, 0, imgHeight);
	                break;
	
	              case 5:
	                ctx.transform(0, ratio, ratio, 0, 0, 0);
	                break;
	
	              case 6:
	                ctx.transform(0, ratio, -ratio, 0, imgHeight, 0);
	
	                if (!rotate) {
	                  _this.setState({
	                    rotation: 90
	                  });
	                }
	
	                break;
	
	              case 7:
	                ctx.transform(0, -ratio, -ratio, 0, imgHeight, imgWidth);
	                break;
	
	              case 8:
	                ctx.transform(0, -ratio, ratio, 0, 0, imgWidth);
	
	                if (!rotate) {
	                  _this.setState({
	                    rotation: -90
	                  });
	                }
	
	                break;
	
	              default:
	                break;
	            }
	
	            // draw the image
	            ctx.drawImage(img, 0, 0);
	
	            // If rotate button is clicked
	            if (rotate) {
	              // Clear the canvas
	              ctx.clearRect(0, 0, canvas.width, canvas.height);
	
	              // Make sure we’re rotating form the center
	              ctx.translate(canvas.width / 2, canvas.height / 2);
	
	              // Draw the image
	              if (_this.state.rotation === 90 || _this.state.rotation === 270) {
	                canvas.width = imgHeight;
	                canvas.height = imgWidth;
	
	                ctx.translate(imgHeight / 2, imgWidth / 2);
	              } else {
	                canvas.width = imgWidth;
	                canvas.height = imgHeight;
	
	                ctx.translate(imgWidth / 2, imgHeight / 2);
	              }
	
	              // Rotate the canvas
	              ctx.rotate(_this.state.rotation * Math.PI / 180);
	
	              // Draw the image
	              if (_this.state.rotation === 90 || _this.state.rotation === 270) {
	                ctx.drawImage(img, -imgWidth / 2, -imgHeight / 2, canvas.height, canvas.width);
	              } else {
	                ctx.drawImage(img, -imgWidth / 2, -imgHeight / 2, canvas.width, canvas.height);
	              }
	            }
	          };
	
	          img.src = image.src;
	        }
	      }, 100);
	    }
	  }, {
	    key: 'rotateImage',
	    value: function rotateImage(direction) {
	      var rotation = 0;
	
	      if (direction === 'right') {
	        rotation = this.state.rotation + 90;
	      } else {
	        rotation = this.state.rotation - 90;
	      }
	
	      if (rotation === 360 || rotation === -360) {
	        rotation = 0;
	      }
	
	      this.setState({
	        rotation: rotation
	      });
	
	      var _this = this;
	
	      setTimeout(function () {
	        _this.previewImage(true, direction);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	
	      if (!this.state.validating) {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.isActive },
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.isActive(1) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.id_front_heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.id_front
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'btn', htmlFor: 'enroll-id-front' },
	                translation.id_front_label
	              ),
	              _react2.default.createElement(_reactDropzone2.default, {
	                className: 'file-hidden',
	                onDrop: function onDrop(photo) {
	                  return _this4.handleDrop(photo, 'idFront');
	                },
	                multiple: false,
	                accept: 'image/*',
	                inputProps: { id: 'enroll-id-front', required: true },
	                disabled: this.state.idFront !== null
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.isActive(2) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.id_back_heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.id_back
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'btn', htmlFor: 'enroll-id-back' },
	                translation.id_back_label
	              ),
	              _react2.default.createElement(_reactDropzone2.default, {
	                className: 'file-hidden',
	                onDrop: function onDrop(photo) {
	                  return _this4.handleDrop(photo, 'idBack');
	                },
	                multiple: false,
	                accept: 'image/*',
	                inputProps: { id: 'enroll-id-back', required: true },
	                disabled: this.state.idBack !== null
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.isActive(3) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.headshot_heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.headshot
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'btn', htmlFor: 'enroll-headshot' },
	                translation.headshot_label
	              ),
	              _react2.default.createElement(_reactDropzone2.default, {
	                className: 'file-hidden',
	                onDrop: function onDrop(photo) {
	                  return _this4.handleDrop(photo, 'headshot');
	                },
	                multiple: false,
	                accept: 'image/*',
	                inputProps: { id: 'enroll-headshot', required: true },
	                disabled: this.state.headshot !== null
	              })
	            )
	          ),
	          this.state.pendingPhotos.map(function (name, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i, className: 'modal' },
	              _this4.state[name] && _this4.state.acceptedPhotos.indexOf(name) < 0 && _react2.default.createElement(
	                'div',
	                { className: 'modal__window' },
	                _this4.state[name].map(function (photo, i) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: i, className: 'modal__image-wrap modal__image-wrap--dual' },
	                    _react2.default.createElement(
	                      'figure',
	                      { className: 'modal__image' },
	                      _react2.default.createElement(
	                        'figcaption',
	                        { className: 'modal__caption' },
	                        translation.example
	                      ),
	                      _react2.default.createElement('img', {
	                        src: './static/img/' + name + '.jpg',
	                        alt: 'Example'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'figure',
	                      { className: 'modal__image' },
	                      _react2.default.createElement(
	                        'figcaption',
	                        { className: 'modal__caption' },
	                        translation.yours
	                      ),
	                      _react2.default.createElement('img', {
	                        className: 'image-preview',
	                        onLoad: function onLoad() {
	                          return _this4.previewImage(false);
	                        },
	                        src: photo.preview,
	                        alt: 'Yours'
	                      }),
	                      _react2.default.createElement('canvas', { className: 'image-preview__canvas' }),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'image-tools' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'image-tools__heading' },
	                          translation.rotate
	                        ),
	                        _react2.default.createElement(
	                          'ul',
	                          { className: 'pager' },
	                          _react2.default.createElement(
	                            'li',
	                            { className: 'pager__page' },
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                className: 'btn--link',
	                                onClick: function onClick() {
	                                  return _this4.rotateImage('left');
	                                }
	                              },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'meta' },
	                                translation.rotate_counter
	                              ),
	                              _react2.default.createElement(icons.iconUndo, null)
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'li',
	                            { className: 'pager__page' },
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                className: 'btn--link',
	                                onClick: function onClick() {
	                                  return _this4.rotateImage('right');
	                                }
	                              },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'meta' },
	                                translation.rotate_clockwise
	                              ),
	                              _react2.default.createElement(icons.iconRedo, null)
	                            )
	                          )
	                        )
	                      )
	                    )
	                  );
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'modal__content' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'note' },
	                    translation.instructions[name]
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'modal__btns' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn btn--icn-right',
	                      onClick: function onClick(e) {
	                        return _this4.acceptPhoto(name);
	                      }
	                    },
	                    translation.accept,
	                    _react2.default.createElement(icons.iconCheckCircle, null)
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'preposition--vertical' },
	                    translation.or
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn--link',
	                      onClick: function onClick(e) {
	                        return _this4.rejectPhoto(name);
	                      }
	                    },
	                    translation.retake
	                  )
	                )
	              )
	            );
	          })
	        );
	      } else {
	        return _react2.default.createElement(_EnrollValidate2.default, Object.assign({
	          setPCStep: this.setStep,
	          parent: this
	        }, this.props));
	      }
	    }
	  }]);
	
	  return EnrollPC;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EnrollPC')(EnrollPC);

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTextareaAutosize = __webpack_require__(74);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var EditExamNotes = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditExamNotes, _React$Component);
	
	  function EditExamNotes() {
	    _classCallCheck(this, EditExamNotes);
	
	    return _possibleConstructorReturn(this, (EditExamNotes.__proto__ || Object.getPrototypeOf(EditExamNotes)).apply(this, arguments));
	  }
	
	  _createClass(EditExamNotes, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          exam = _props.exam,
	          customConfiguration = _props.customConfiguration,
	          enrollmentConfig = _props.enrollmentConfig;
	
	
	      if (enrollmentConfig) {
	        if (this.props.configuration) {
	          this.state = {
	            configuration: this.props.configuration
	          };
	        } else {
	          this.state = {
	            configuration: {}
	          };
	        }
	      } else {
	        if (typeof exam !== 'undefined' && exam.sid && !customConfiguration) {
	          this.state = {
	            configuration: exam.configuration
	          };
	        } else if (customConfiguration) {
	          this.state = {
	            configuration: customConfiguration
	          };
	        } else {
	          this.state = {
	            configuration: exam.configuration
	          };
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          automatedOnly = _props2.automatedOnly,
	          translation = _props2.translation;
	
	
	      return _react2.default.createElement(
	        'fieldset',
	        { id: 'notes' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'fields' },
	          _react2.default.createElement(
	            'li',
	            { className: this.props.defaultDiff('studentNotes') },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'exam-student-notes', 'aria-describedby': 'student-notes-tooltip' },
	              translation.for_students.label,
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                  '(?)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'student-notes-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                  translation.for_students.tooltip
	                )
	              )
	            ),
	            _react2.default.createElement(_reactTextareaAutosize2.default, {
	              id: 'exam-student-notes',
	              className: 'textarea-grow',
	              placeholder: translation.for_students.helper,
	              defaultValue: this.state.configuration.studentNotes,
	              onChange: function onChange(e) {
	                _this2.props.handleInput('studentNotes', e, true);
	              },
	              autoFocus: true,
	              disabled: this.props.readonly ? true : false
	            }),
	            this.props.renderDefault('configuration.studentNotes')
	          ),
	          !automatedOnly && _react2.default.createElement(
	            'li',
	            { className: this.props.defaultDiff('proctorNotes') },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'exam-proctor-notes', 'aria-describedby': 'proctor-notes-tooltip' },
	              translation.for_proctors.label,
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                  '(?)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'proctor-notes-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                  translation.for_proctors.tooltip
	                )
	              )
	            ),
	            _react2.default.createElement(_reactTextareaAutosize2.default, {
	              id: 'exam-proctor-notes',
	              className: 'textarea-grow',
	              placeholder: translation.for_proctors.helper,
	              defaultValue: this.state.configuration.proctorNotes,
	              onChange: function onChange(e) {
	                _this2.props.handleInput('proctorNotes', e, true);
	              },
	              disabled: this.props.readonly ? true : false
	            }),
	            this.props.renderDefault('configuration.proctorNotes')
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditExamNotes;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EditExamNotes')(EditExamNotes);

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _LimitTextarea = __webpack_require__(750);
	
	var _LimitTextarea2 = _interopRequireDefault(_LimitTextarea);
	
	var _helpers = __webpack_require__(5);
	
	var _FeatureFlag = __webpack_require__(570);
	
	var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var EditPermittedItems = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditPermittedItems, _React$Component);
	
	  function EditPermittedItems() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EditPermittedItems);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditPermittedItems.__proto__ || Object.getPrototypeOf(EditPermittedItems)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (key, e) {
	      var exam = _this.props.exam;
	
	      var virtualCalcBox = document.querySelector('#permittedCalculator');
	
	      if (key === 'permittedCalculator') {
	        // This will only get triggered when checking the calculator checkbox
	        _this.setState({
	          showCalcOptions: virtualCalcBox.checked
	        });
	
	        delete exam.configuration.virtualCalculatorType;
	      }
	
	      _this.props.handleInput(key, e, true, null, null, true); // This is currently in the onChange attribute and will need to stay
	    }, _this.renderVirtualCalcOpts = function (key) {
	      var translation = _this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'switch-notes', hidden: !_this.state.configuration[key] },
	        _this.state.configuration[key] && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'label',
	            { htmlFor: 'virtual-calc' },
	            translation.virtualCalc
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'select' },
	            _react2.default.createElement(
	              'select',
	              { name: 'virtual-calc',
	                id: 'virtual-calc',
	                onChange: function onChange(e) {
	                  return _this.props.handleInput('virtualCalculatorType', e, true);
	                },
	                defaultValue: _this.state.configuration.virtualCalculatorType
	              },
	              _react2.default.createElement(
	                'option',
	                { value: '' },
	                translation.noVirtualCalc
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'scientific-calc' },
	                translation.scientificCalc
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'graphing-calc' },
	                translation.graphingCalc
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'matrix-calc' },
	                translation.matrixCalc
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'four-function-calc' },
	                translation.fourFunctionCalc
	              )
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EditPermittedItems, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          exam = _props.exam,
	          customConfiguration = _props.customConfiguration,
	          enrollmentConfig = _props.enrollmentConfig;
	
	
	      if (enrollmentConfig) {
	        if (this.props.configuration) {
	          this.state = {
	            configuration: this.props.configuration,
	            showCalcOptions: false
	          };
	        } else {
	          this.state = {
	            configuration: {},
	            showCalcOptions: false
	          };
	        }
	      } else {
	        if (typeof exam !== 'undefined' && exam.sid && !customConfiguration) {
	          this.state = {
	            configuration: exam.configuration,
	            showCalcOptions: false
	          };
	        } else if (customConfiguration) {
	          this.state = {
	            configuration: customConfiguration,
	            showCalcOptions: false
	          };
	        } else {
	          this.state = {
	            configuration: exam.configuration,
	            showCalcOptions: false
	          };
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      var enabledItems = false;
	      var hiddenItems = (0, _mobx.toJS)(this.props.store.SettingsStore.settings.hidePermittedItemFields);
	
	      // Loop through hidden items and edit them to match the permitted items formatting
	      hiddenItems.forEach(function (item, i) {
	        var formattedItem = 'permitted' + item;
	        hiddenItems[i] = formattedItem.toLowerCase();
	      });
	
	      return _react2.default.createElement(
	        'fieldset',
	        { id: 'permitted-items', className: 'fields' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'switch-list' },
	          Object.keys(translation.options).map(function (key) {
	            // Return the input if this item is not in the hidden items array
	            if (hiddenItems.indexOf(key.toLowerCase()) < 0) {
	              enabledItems = true;
	
	              return _react2.default.createElement(
	                'li',
	                { key: key, className: _this2.props.defaultDiff(key + 'Information') },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: key },
	                  translation.options[key]
	                ),
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  id: key,
	                  className: 'switch-input',
	                  defaultChecked: _this2.state.configuration[key],
	                  onChange: function onChange(e) {
	                    return _this2.onChange(key, e);
	                  },
	                  disabled: _this2.props.readonly ? true : false,
	                  onKeyDown: _helpers.handleSwitchInputKeys
	                }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'switch-label', htmlFor: key },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.options[key]
	                  )
	                ),
	                _this2.props.renderDefault('configuration.' + key, null, true, translation.options[key]),
	                _react2.default.createElement(_LimitTextarea2.default, {
	                  id: key + '-notes',
	                  wrapperClass: 'switch-notes',
	                  className: 'textarea-grow',
	                  placeholder: translation.additional_information,
	                  defaultValue: _this2.state.configuration[key + 'Information'],
	                  onChange: function onChange(e) {
	                    _this2.props.handleInput(key + 'Information', e, true);
	                  },
	                  limit: 255,
	                  disabled: _this2.props.readonly ? true : false
	                }),
	                key === 'permittedCalculator' && _this2.props.virtualCalcAllowed && _react2.default.createElement(_FeatureFlag2.default, {
	                  flagKey: 'classcalc',
	                  renderFeatureCallback: function renderFeatureCallback() {
	                    return _this2.renderVirtualCalcOpts(key);
	                  }
	                }),
	                key !== 'permittedCalculator' && _react2.default.createElement(
	                  'span',
	                  { className: 'switch-notes-default' },
	                  _this2.props.renderDefault('configuration.' + key + 'Information')
	                ),
	                key === 'permittedCalculator' && _react2.default.createElement(
	                  'span',
	                  { className: 'switch-notes-default' },
	                  _this2.props.renderDefault('configuration.virtualCalculatorType')
	                )
	              );
	            }
	
	            return null;
	          })
	        ),
	        hiddenItems.indexOf('permittedotherinformation') < 0 && _react2.default.createElement(
	          'ul',
	          { className: 'fields' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'lbl-optional', htmlFor: 'other-items' },
	              translation.permittedOtherItems
	            ),
	            _react2.default.createElement('textarea', {
	              id: 'other-items',
	              placeholder: translation.permittedOtherItems,
	              defaultValue: this.state.configuration.permittedOtherItems,
	              onChange: function onChange(e) {
	                _this2.props.handleInput('permittedOtherItems', e, true);
	              },
	              disabled: this.props.readonly ? true : false
	            }),
	            enabledItems = true
	          )
	        ),
	        !enabledItems && _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_items
	        )
	      );
	    }
	  }]);
	
	  return EditPermittedItems;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EditPermittedItems')(EditPermittedItems);

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var mobx = _interopRequireWildcard(_mobx);
	
	var _config = __webpack_require__(9);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _ScheduleFields = __webpack_require__(806);
	
	var _ScheduleFields2 = _interopRequireDefault(_ScheduleFields);
	
	var _ProctorGroupList = __webpack_require__(360);
	
	var _ProctorGroupList2 = _interopRequireDefault(_ProctorGroupList);
	
	var _AutomatedSettings = __webpack_require__(779);
	
	var _AutomatedSettings2 = _interopRequireDefault(_AutomatedSettings);
	
	var _AutomatedSettingsV = __webpack_require__(780);
	
	var _AutomatedSettingsV2 = _interopRequireDefault(_AutomatedSettingsV);
	
	var _helpers = __webpack_require__(5);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Config variables
	
	
	// Translations
	
	
	// Components
	
	
	// the proctor types V3 is enabled for...
	var V3_PROCTOR_TYPES = ['TS63dda27a6ba54c218449b934b7bb1ba8', // auto
	'TS9531c6b112f145018dae3cd2a9f60c4c', // r&r
	'TS4b894875d26194988853e490dfb9bc41', // live
	'TS6d6011935f4646848ea4f7a29b4f61a5'];
	
	var EditProctorSettings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditProctorSettings, _React$Component);
	
	  function EditProctorSettings() {
	    _classCallCheck(this, EditProctorSettings);
	
	    var _this2 = _possibleConstructorReturn(this, (EditProctorSettings.__proto__ || Object.getPrototypeOf(EditProctorSettings)).call(this));
	
	    _this2.handleEnabledDefault = function (subKey) {
	      var _this2$props = _this2.props,
	          exam = _this2$props.exam,
	          newExam = _this2$props.newExam;
	
	
	      if (!_this2.enabledDefaultChecked && subKey.status === 'enabled-default' && newExam) {
	        exam.configuration.proctorTypes.push(subKey.sid);
	      }
	
	      _this2.enabledDefaultChecked = true;
	    };
	
	    _this2.handleProctorChange = _this2.handleProctorChange.bind(_this2);
	    _this2.renderLocations = _this2.renderLocations.bind(_this2);
	    _this2.enabledDefaultChecked = false;
	    return _this2;
	  }
	
	  _createClass(EditProctorSettings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          exam = _props.exam,
	          customConfiguration = _props.customConfiguration,
	          enrollmentConfig = _props.enrollmentConfig;
	
	
	      if (enrollmentConfig) {
	        if (this.props.configuration.sid) {
	          this.state = {
	            proctorDate: null,
	            proctorTypes: mobx.toJS(this.props.configuration.proctorTypes),
	            configuration: this.props.configuration
	          };
	        } else {
	          this.state = {
	            proctorDate: null,
	            proctorTypes: [],
	            configuration: {
	              proctorTypes: []
	            }
	          };
	        }
	      } else {
	        if (typeof exam !== 'undefined' && exam.sid && !customConfiguration) {
	          this.state = {
	            proctorDate: null,
	            proctorTypes: mobx.toJS(exam.configuration.proctorTypes),
	            configuration: exam.configuration
	          };
	        } else if (customConfiguration) {
	          this.state = {
	            proctorDate: null,
	            proctorTypes: mobx.toJS(customConfiguration.proctorTypes),
	            configuration: customConfiguration
	          };
	        } else {
	          this.state = {
	            proctorDate: null,
	            proctorTypes: [],
	            configuration: exam.configuration
	          };
	        }
	      }
	
	      // Add any required proctor types to the state
	      if (!this.props.crossListed) {
	        this.checkProctorTypes();
	      }
	    }
	  }, {
	    key: 'checkProctorTypes',
	    value: function checkProctorTypes() {
	      var SessionStore = this.props.store.SessionStore;
	      var exam = this.props.exam;
	
	      // Add any required proctor types and remove any proctor types that have been disabled
	
	      var proctorTypes = this.state.proctorTypes;
	
	      SessionStore.proctorTypeList.forEach(function (parentType, i) {
	        // Make sure virtual proctors aren’t allowed for written
	        if (exam && exam.type && exam.type.toLowerCase() === 'written' && parentType.title.toLowerCase().indexOf('virtual') > -1) {
	          return '';
	        }
	
	        parentType.subCategories.forEach(function (subType, j) {
	          if (subType.status === 'required' && proctorTypes.indexOf(subType.sid) < 0) {
	            proctorTypes.push(subType.sid);
	          } else if (subType.status === 'disabled' && proctorTypes.indexOf(subType.sid) >= 0) {
	            proctorTypes.splice(proctorTypes.indexOf(subType.sid), 1);
	          } else if (subType.status === 'enabled-default' && proctorTypes.indexOf(subType.sid) < 0) {
	            proctorTypes.push(subType.sid);
	          }
	        });
	      });
	
	      this.props.handleInput('proctorTypes', null, true, null, null, false, this.state.proctorTypes);
	    }
	  }, {
	    key: 'handleProctorChange',
	    value: function handleProctorChange(date) {
	      this.setState({
	        proctorDate: date
	      });
	    }
	  }, {
	    key: 'handleProctorType',
	    value: function handleProctorType(e) {
	      var proctorTypes = this.state.proctorTypes;
	
	      if (e.target.checked) {
	        proctorTypes.push(e.target.value);
	
	        if (e.target.value === _config.config.instructorProctorTypeSid) {
	          if (this.props.enrollmentConfig) {
	            this.props.store.EnrollmentStore.addLocation();
	          } else {
	            this.props.store.ExamStore.addLocation();
	          }
	        }
	      } else {
	        var index = proctorTypes.indexOf(e.target.value);
	        proctorTypes.splice(index, 1);
	
	        if (e.target.value === _config.config.instructorProctorTypeSid) {
	          if (this.props.enrollmentConfig) {
	            this.props.store.EnrollmentStore.removeLocation();
	          } else {
	            this.props.store.ExamStore.removeLocation();
	          }
	        }
	      }
	
	      this.setState({
	        proctorTypes: proctorTypes
	      });
	
	      this.props.handleInput('proctorTypes', e, true, null, null, false, this.state.proctorTypes);
	    }
	  }, {
	    key: 'renderLocations',
	    value: function renderLocations(render) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          exam = _props2.exam,
	          customConfiguration = _props2.customConfiguration;
	
	
	      if (render && this.state.proctorTypes.indexOf(_config.config.instructorProctorTypeSid) > -1) {
	        if (typeof exam !== 'undefined' && !customConfiguration) {
	          var instructorAsProctor = this.props.store.ExamStore.exam.configuration.instructorAsProctor;
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'schedule-wrap' },
	            instructorAsProctor.map(function (key, i) {
	              return _react2.default.createElement(_ScheduleFields2.default, Object.assign({
	                key: i,
	                index: i,
	                instructorAsProctor: instructorAsProctor,
	                parent: _this3,
	                exam: exam
	              }, _this3.props));
	            })
	          );
	        } else {
	          var _instructorAsProctor = [];
	
	          if (this.props.enrollmentConfig) {
	            _instructorAsProctor = this.props.store.EnrollmentStore.enrollmentConfiguration.instructorAsProctor;
	          } else {
	            _instructorAsProctor = this.props.store.ExamStore.configuration.instructorAsProctor;
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'schedule-wrap' },
	            _instructorAsProctor.map(function (key, i) {
	              return _react2.default.createElement(_ScheduleFields2.default, Object.assign({
	                key: i,
	                index: i
	              }, _this3.props, {
	                instructorAsProctor: _instructorAsProctor,
	                parent: _this3
	              }));
	            })
	          );
	        }
	      }
	
	      return '';
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled() {
	      if (this.props.exception || this.props.readonly) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'renderv3Options',
	    value: function renderv3Options(categorySid) {
	      // Render V3 specific options here
	      return _react2.default.createElement(_AutomatedSettingsV2.default, Object.assign({}, this.props, {
	        categorySid: categorySid
	      }));
	    }
	  }, {
	    key: 'renderAutomatedSettings',
	    value: function renderAutomatedSettings(categorySid) {
	      var _this4 = this;
	
	      if (V3_PROCTOR_TYPES.indexOf(categorySid) > -1 && this.props.store.ExamStore.exam && this.props.store.ExamStore.exam.platformVersion === 3) {
	        if (['TS4b894875d26194988853e490dfb9bc41', 'TS6d6011935f4646848ea4f7a29b4f61a5'].includes(categorySid)) {
	          return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'enable-v-3-for-live',
	            renderFeatureCallback: function renderFeatureCallback(version) {
	              return _this4.renderv3Options(categorySid);
	            },
	            renderDefaultCallback: function renderDefaultCallback() {
	              return _react2.default.createElement(_AutomatedSettings2.default, Object.assign({}, _this4.props, {
	                categorySid: categorySid
	              }));
	            }
	          });
	        } else {
	          return this.renderv3Options(categorySid);
	        }
	      } else {
	        return _react2.default.createElement(_AutomatedSettings2.default, Object.assign({}, this.props, {
	          categorySid: categorySid
	        }));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          automatedOnly = _props3.automatedOnly,
	          translation = _props3.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	      var _this = this;
	      var exam = this.props.exam;
	
	
	      function subCategoryLength(subCategories) {
	        var enabledSubcategories = subCategories.filter(function (subCategory) {
	          if (_this.props.enrollmentConfig) {
	            return subCategory.status !== 'disabled' && subCategory.sid !== _config.config.instructorProctorTypeSid;
	          } else {
	            return subCategory.status !== 'disabled';
	          }
	        });
	
	        if (enabledSubcategories.length > 0) {
	          return true;
	        }
	
	        return false;
	      }
	
	      if (!this.props.crossListed) {
	        if (SessionStore.proctorTypeList.length > 0) {
	          return _react2.default.createElement(
	            'fieldset',
	            { id: 'proctor-settings' },
	            _react2.default.createElement(
	              'p',
	              { className: 'note note--full note--full-alt proctor-type-instructions' },
	              translation.proctor_types.instructions
	            ),
	            SessionStore.proctorTypeList.map(function (key, i) {
	              if (subCategoryLength(key.subCategories)) {
	                // If this is a written exam, don’t show
	                // virtual proctor types
	                if (exam && exam.type && exam.type.toLowerCase() === 'written' && key.title.toLowerCase().indexOf('virtual') > -1) {
	                  return '';
	                }
	
	                // HACK
	                // Handle virtual differently for Itawamba CC
	                if (key.title.toLowerCase().indexOf('virtual') > -1 && SessionStore.userData.installSid === 'AI807436b2359f4debb339111bd4f788c2') {
	                  if (SessionStore.userData.role.toLowerCase() === 'administrator' && _this5.props.exception) {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-subgroup', key: i },
	                      _react2.default.createElement(
	                        'strong',
	                        { className: 'form-subheading proctor-type-heading' },
	                        key.title
	                      ),
	                      subCategoryLength(key.subCategories),
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'switch-list' },
	                        key.subCategories.map(function (subKey, j) {
	                          if (subKey.status === 'disabled' || subKey.sid === _config.config.instructorProctorTypeSid && _this5.props.enrollmentConfig) {
	                            // Return nothing if this type is disabled
	                            // or if this is an enrollment configuration
	                            // and the type is instructor as proctor
	                            return '';
	                          } else {
	                            // Otherwise return a switch field
	                            return _react2.default.createElement(
	                              'li',
	                              { key: j, className: _this5.props.defaultDiff('proctorTypes') + ' ' + (subKey.sid === _config.config.instructorProctorTypeSid ? 'instructor' : '') + ' proctor-type-subcategory' },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: subKey.sid, className: 'proctor-type-subcategory-label' },
	                                subKey.title
	                              ),
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: subKey.sid,
	                                className: 'switch-input',
	                                value: subKey.sid,
	                                defaultChecked: _this5.state.configuration.proctorTypes.indexOf(subKey.sid) > -1 || subKey.status === 'required',
	                                onChange: function onChange(e) {
	                                  _this5.handleProctorType(e);
	                                },
	                                disabled: subKey.status === 'required' || _this5.props.readonly,
	                                onKeyDown: _helpers.handleSwitchInputKeys
	                              }),
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'switch-label', htmlFor: subKey.sid },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'meta' },
	                                  subKey.title
	                                )
	                              ),
	                              _this5.props.renderDefault('configuration.proctorTypes', null, true, subKey.sid),
	                              _this5.renderLocations(subKey.sid === _config.config.instructorProctorTypeSid),
	                              _config.config.automatedProctorTypeSids.indexOf(subKey.sid) > -1 && (_this5.state.configuration.proctorTypes.indexOf(subKey.sid) > -1 || subKey.status === 'required') && _this5.renderAutomatedSettings(subKey.sid)
	                            );
	                          }
	                        })
	                      )
	                    );
	                  }
	
	                  return '';
	                }
	                // End HACK
	
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'form-subgroup', key: i },
	                  !automatedOnly && _react2.default.createElement(
	                    'strong',
	                    { className: 'form-subheading proctor-type-heading' },
	                    key.title
	                  ),
	                  !automatedOnly && subCategoryLength(key.subCategories),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'switch-list' },
	                    key.subCategories.map(function (subKey, j) {
	                      if (subKey.status === 'disabled' || subKey.sid === _config.config.instructorProctorTypeSid && _this5.props.enrollmentConfig || automatedOnly && _config.config.automatedProctorTypeSids.indexOf(subKey.sid) === -1) {
	                        // Return nothing if this type is disabled
	                        // or if this is an enrollment configuration
	                        // and the type is instructor as proctor
	                        return '';
	                      } else {
	                        // Otherwise return a switch field
	                        return _react2.default.createElement(
	                          'li',
	                          { key: j, className: _this5.props.defaultDiff('proctorTypes') + ' ' + (subKey.sid === _config.config.instructorProctorTypeSid ? 'instructor' : '') + ' proctor-type-subcategory' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: subKey.sid, className: 'proctor-type-subcategory-label' },
	                            subKey.title
	                          ),
	                          _this5.handleEnabledDefault(subKey),
	                          _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            id: subKey.sid,
	                            className: 'switch-input',
	                            value: subKey.sid,
	                            defaultChecked: _this5.state.configuration.proctorTypes.indexOf(subKey.sid) > -1 || subKey.status === 'required' || subKey.status === 'enabled-default' && _this5.props.newExam,
	                            onChange: function onChange(e) {
	                              _this5.handleProctorType(e);
	                            },
	                            disabled: subKey.status === 'required' || _this5.props.readonly,
	                            ref: function ref(input) {
	                              return _this5[subKey.sid] = input;
	                            },
	                            onKeyDown: _helpers.handleSwitchInputKeys
	                          }),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'switch-label', htmlFor: subKey.sid },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              subKey.title
	                            )
	                          ),
	                          _this5.props.renderDefault('configuration.proctorTypes', null, true, subKey.sid),
	                          _this5.renderLocations(subKey.sid === _config.config.instructorProctorTypeSid),
	                          _config.config.automatedProctorTypeSids.indexOf(subKey.sid) > -1 && (_this5.state.configuration.proctorTypes.indexOf(subKey.sid) > -1 || subKey.status === 'required') && _this5.renderAutomatedSettings(subKey.sid)
	                        );
	                      }
	                    })
	                  )
	                );
	              }
	
	              return '';
	            })
	          );
	        }
	      } else {
	        // Cross listed students can't have their proctor types edited
	        return _react2.default.createElement(
	          'fieldset',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'note note--prominent' },
	            translation.cross_listed.proctors_note.replace('%school%', this.props.parentSchool.name)
	          ),
	          _react2.default.createElement(_ProctorGroupList2.default, Object.assign({
	            proctorGroups: this.props.parentSchool.proctorGroups,
	            noExpand: true
	          }, this.props))
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return EditProctorSettings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EditProctorSettings')(EditProctorSettings);

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _EditExamDetails = __webpack_require__(783);
	
	var _EditExamDetails2 = _interopRequireDefault(_EditExamDetails);
	
	var _EditPermittedItems = __webpack_require__(350);
	
	var _EditPermittedItems2 = _interopRequireDefault(_EditPermittedItems);
	
	var _EditExamNotes = __webpack_require__(349);
	
	var _EditExamNotes2 = _interopRequireDefault(_EditExamNotes);
	
	var _EditProctorSettings = __webpack_require__(351);
	
	var _EditProctorSettings2 = _interopRequireDefault(_EditProctorSettings);
	
	var _ConfirmExam = __webpack_require__(781);
	
	var _ConfirmExam2 = _interopRequireDefault(_ConfirmExam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var EditSection = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditSection, _React$Component);
	
	  function EditSection() {
	    _classCallCheck(this, EditSection);
	
	    var _this = _possibleConstructorReturn(this, (EditSection.__proto__ || Object.getPrototypeOf(EditSection)).call(this));
	
	    _this.state = {
	      virtualCalcAllowed: false
	    };
	    return _this;
	  }
	
	  _createClass(EditSection, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Checks to see if automated or hybrid is an available workflowModule
	      if (this.props.proctorGroups) {
	        var virtualCalcAllowed = this.props.proctorGroups.some(function (group) {
	          return group.workflowModule === 'automated' || group.workflowModule.includes('hybrid');
	        });
	
	        this.setState({ virtualCalcAllowed: virtualCalcAllowed });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      switch (this.props.step) {
	        case 1:
	          return _react2.default.createElement(_EditExamDetails2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	        case 2:
	          return _react2.default.createElement(_EditPermittedItems2.default, Object.assign({ nextStep: this.props.nextStep, prevStep: this.props.prevStep, virtualCalcAllowed: this.state.virtualCalcAllowed }, this.props));
	
	        case 3:
	          return _react2.default.createElement(_EditExamNotes2.default, Object.assign({ nextStep: this.props.nextStep, prevStep: this.props.prevStep }, this.props));
	
	        case 4:
	          return _react2.default.createElement(_EditProctorSettings2.default, Object.assign({ prevStep: this.props.prevStep }, this.props));
	
	        case 5:
	          return _react2.default.createElement(_ConfirmExam2.default, Object.assign({ prevStep: this.props.prevStep }, this.props));
	
	        // case 5:
	        //   if(!this.props.approval) {
	        //     return <ExamAttachments prevStep={this.props.prevStep} complete={this.props.complete} {...this.props} />;
	        //   } else {
	        //     return <ExamAttachmentsList hideTitle={true} hideDelete={true} prevStep={this.props.prevStep} complete={this.props.complete} {...this.props} />;
	        //   }
	
	        default:
	          return _react2.default.createElement(_EditExamDetails2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	      }
	    }
	  }]);
	
	  return EditSection;
	}(_react2.default.Component));
	
	exports.default = EditSection;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _reactDelayed = __webpack_require__(112);
	
	var _reactDelayed2 = _interopRequireDefault(_reactDelayed);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _FundingRulesList = __webpack_require__(790);
	
	var _FundingRulesList2 = _interopRequireDefault(_FundingRulesList);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Toolbar = __webpack_require__(98);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var FundingRules = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(FundingRules, _React$Component);
	
	  function FundingRules() {
	    _classCallCheck(this, FundingRules);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (FundingRules.__proto__ || Object.getPrototypeOf(FundingRules)).call(this));
	
	    _this2.addRule = _this2.addRule.bind(_this2);
	    _this2.handleAdd = _this2.handleAdd.bind(_this2);
	    _this2.deleteFundingRules = _this2.deleteFundingRules.bind(_this2);
	    _this2.renderAddButton = _this2.renderAddButton.bind(_this2);
	    _this2.renderEditMessage = _this2.renderEditMessage.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(FundingRules, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        fundingRuleSid: null,
	        selectedRows: []
	      };
	    }
	  }, {
	    key: 'getFilteredFundingRules',
	    value: function getFilteredFundingRules(scope, sid) {
	      this.props.store.FundingRuleStore.getFilteredFundingRules(scope, sid);
	    }
	  }, {
	    key: 'getFundingRules',
	    value: function getFundingRules() {
	      this.props.store.FundingRuleStore.getFundingRules(true);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.routing.location.pathname;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (pathname.indexOf('edit') > -1 || pathname.indexOf('add') > -1) {
	        SessionStore.loading = false;
	        (0, _helpers.toggleDrawer)(null, this, 'AddFundingRule');
	      }
	
	      if (pathname.indexOf('edit') > -1) {
	        var fundingRuleSid = pathname.substr(pathname.lastIndexOf('/') + 1);
	
	        if (!fundingRuleSid && this.props.fundingRuleSid) {
	          fundingRuleSid = this.props.fundingRuleSid;
	        }
	
	        this.setState({
	          fundingRuleSid: fundingRuleSid
	        });
	      }
	    }
	  }, {
	    key: 'addRule',
	    value: function addRule() {
	      this.props.parent.setState({
	        drawerContent: 'AddFundingRule'
	      });
	
	      if (this.props.fundingRuleSid && this.props.parent) {
	        this.props.parent.setState({
	          fundingRuleSid: null
	        });
	      }
	    }
	  }, {
	    key: 'handleAdd',
	    value: function handleAdd(e) {
	      e.preventDefault();
	      // If drawer is not open push the event href to routing path
	      if (!this.props.drawer) {
	        (0, _helpers.pushHrefToRouting)(e.target.href, this);
	      } else {
	        this.props.parent.setState({
	          drawerContent: 'AddFundingRule'
	        });
	      }
	    }
	  }, {
	    key: 'deleteFundingRules',
	    value: function deleteFundingRules() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: '' + translation.delete_confirm.heading_singular,
	        body: translation.delete_confirm.body_singular,
	        button: translation.delete_confirm.button
	      };
	
	      if (this.state.selectedRows.length > 1) {
	        msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
	        msg.body = translation.delete_confirm.body_plural;
	      }
	
	      var query = this.props.routing.location.query;
	
	
	      var callback = null;
	
	      if (query.fundingRuleScope && query.scopeSid) {
	        callback = function callback() {
	          return _this3.getFilteredFundingRules(query.fundingRuleScope, query.scopeSid);
	        };
	      } else if (this.props.offeringSid) {
	        callback = function callback() {
	          return _this3.getFilteredFundingRules('courseOfferingSid', _this3.props.offeringSid);
	        };
	      } else {
	        callback = function callback() {
	          return _this3.getFundingRules();
	        };
	      }
	
	      // Loop through all the selected funding rules and send delete API request
	      var _this = this;
	
	      (0, _helpers.confirm)(msg, function () {
	        for (var i = 0; i < _this.state.selectedRows.length; i++) {
	          _this.props.store.FundingRuleStore.deleteFundingRule(_this.state.selectedRows[i], callback);
	        }
	
	        _this.setState({
	          selectedRows: []
	        });
	      });
	    }
	  }, {
	    key: 'renderAddButton',
	    value: function renderAddButton() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          className: 'btn--outline',
	          to: 'funding-rules/add',
	          onClick: function onClick(e) {
	            return _this4.handleAdd(e);
	          }
	        },
	        _react2.default.createElement(icons.iconPlus, null),
	        translation.add_funding_rule
	      );
	    }
	  }, {
	    key: 'renderEditMessage',
	    value: function renderEditMessage() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'cta' },
	        _react2.default.createElement(
	          'strong',
	          { className: 'cta__copy' },
	          translation.edit.heading
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'cta__subcopy' },
	          translation.edit.body
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'cta__btn btn--icn-right',
	            href: 'mailto:sean@smarterservices.com'
	          },
	          translation.edit.button
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      if (this.props.drawer) {
	        var fundingRuleScope = this.props.routing.location.query.fundingRuleScope;
	
	
	        var rulesFor = translation.for_course;
	
	        if (fundingRuleScope === 'examSid') {
	          rulesFor = this.props.exam.title;
	        }
	
	        if (fundingRuleScope === 'enrollmentSid') {
	          rulesFor = this.props.enrollmentName;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.page_title,
	                ' ',
	                translation.rules_for,
	                ' ',
	                rulesFor
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--outline',
	                  onClick: this.addRule
	                },
	                _react2.default.createElement(icons.iconPlus, null),
	                translation.add_funding_rule
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(_FundingRulesList2.default, Object.assign({}, this.props, {
	              parent: this,
	              selectedRows: this.state.selectedRows
	            })),
	            _react2.default.createElement(
	              _reactDelayed2.default,
	              {
	                mounted: this.state.selectedRows.length > 0,
	                unmountAfter: 250
	              },
	              _react2.default.createElement(_Toolbar2.default, Object.assign({
	                selectedRows: this.state.selectedRows,
	                deleteText: translation.delete,
	                deleteFunction: this.deleteFundingRules
	              }, this.props))
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'page__title' },
	                translation.page_title
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'page__actions actions' },
	                _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                  flagKey: 'global-funding-rules',
	                  renderFeatureCallback: this.renderAddButton,
	                  renderDefaultCallback: null
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(_FundingRulesList2.default, Object.assign({
	              selectedRows: this.state.selectedRows,
	              parent: this
	            }, this.props)),
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'global-funding-rules',
	              renderFeatureCallback: function renderFeatureCallback() {
	                return null;
	              },
	              renderDefaultCallback: this.renderEditMessage
	            })
	          ),
	          _react2.default.createElement(_Drawer2.default, Object.assign({
	            content: this.state.drawerContent,
	            isOpen: this.state.drawerOpen,
	            parent: this
	          }, this.props, {
	            fundingRuleSid: this.state.fundingRuleSid
	          })),
	          _react2.default.createElement(
	            _reactDelayed2.default,
	            {
	              mounted: this.state.selectedRows.length > 0,
	              unmountAfter: 250
	            },
	            _react2.default.createElement(_Toolbar2.default, Object.assign({
	              selectedRows: this.state.selectedRows,
	              deleteText: translation.delete,
	              deleteFunction: this.deleteFundingRules
	            }, this.props))
	          )
	        );
	      }
	    }
	  }]);
	
	  return FundingRules;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('FundingRules')(FundingRules);

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Proctor = __webpack_require__(805);
	
	var _Proctor2 = _interopRequireDefault(_Proctor);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	var _Address = __webpack_require__(799);
	
	var _Address2 = _interopRequireDefault(_Address);
	
	var _reactSimpleDropdown = __webpack_require__(178);
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	// Dependencies
	
	
	var LocateProctor = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(LocateProctor, _React$Component);
	
	  function LocateProctor() {
	    _classCallCheck(this, LocateProctor);
	
	    var _this2 = _possibleConstructorReturn(this, (LocateProctor.__proto__ || Object.getPrototypeOf(LocateProctor)).call(this));
	
	    _this2.getBlackoutDates = _this2.getBlackoutDates.bind(_this2);
	    _this2.getProctors = _this2.getProctors.bind(_this2);
	    _this2.setProctorCategories = _this2.setProctorCategories.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.removeDistance = _this2.removeDistance.bind(_this2);
	    _this2.toggleApproved = _this2.toggleApproved.bind(_this2);
	    _this2.handleCategory = _this2.handleCategory.bind(_this2);
	    _this2.removeCategory = _this2.removeCategory.bind(_this2);
	    _this2.categoryName = _this2.categoryName.bind(_this2);
	    _this2.applyFilters = _this2.applyFilters.bind(_this2);
	    _this2.resetFilters = _this2.resetFilters.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(LocateProctor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this = this;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (SessionStore.proctorTypeList.length === 0) {
	        SessionStore.getProctorTypes();
	      }
	
	      this.state = {
	        parents: [],
	        filters: [],
	        activeFilters: [],
	        drawerOpen: false,
	        drawerContent: null,
	        distance: null,
	        activeDistance: null,
	        onlyApproved: false,
	        sortBy: 'distance',
	        proctorSid: null,
	        proctorLocationSid: null,
	        showProctorActions: false,
	        showApprovalHistory: false,
	        messageSid: null,
	        query: null,
	        location: null
	      };
	
	      var examSid = (0, _helpers.getURLSegment)(this, 3);
	      var sessionSid = (0, _helpers.getURLSegment)(this, 5);
	
	      if (sessionSid) {
	        this.setState({
	          showProctorActions: true
	        });
	      }
	
	      // Set the categories
	      if (SessionStore.userData.role.toLowerCase() === 'administrator') {
	        this.props.store.ProctorStore.getProctorTypes();
	        this.getProctors();
	      } else {
	        this.setProctorCategories(examSid, sessionSid);
	      }
	
	      if (examSid && sessionSid) {
	        // Get session data
	        this.props.store.EnrollmentStore.getExamSession(examSid, sessionSid, null, this.getBlackoutDates);
	      }
	
	      if (!sessionSid && SessionStore.userData.role.toLowerCase() === 'administrator') {
	        this.setState({
	          showApprovalHistory: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.ProctorStore.proctorsNext = null;
	    }
	  }, {
	    key: 'getBlackoutDates',
	    value: function getBlackoutDates() {
	      // Check for blackout dates
	      var _props$store = this.props.store,
	          BlackoutStore = _props$store.BlackoutStore,
	          EnrollmentStore = _props$store.EnrollmentStore;
	      var examConfiguration = EnrollmentStore.examSession.examConfiguration;
	
	
	      var query = {
	        startDate: examConfiguration.examOpenDate,
	        endDate: examConfiguration.examCloseDate
	      };
	
	      BlackoutStore.listBlackoutDates(query);
	    }
	  }, {
	    key: 'setProctorCategories',
	    value: function setProctorCategories(examSid, sessionSid) {
	      var groupSid = (0, _helpers.getURLSegment)(this, 10);
	
	      // If the proctor categories aren’t already provided, get them
	      if (this.state.filters.length === 0 && groupSid) {
	        this.props.store.ProctorStore.getProctorGroupCategories(examSid, sessionSid, groupSid, this.getProctors, this);
	      } else {
	        this.getProctors();
	      }
	    }
	  }, {
	    key: 'getProctors',
	    value: function getProctors(component) {
	      var _this = this;
	
	      if (component) {
	        _this = component;
	      }
	
	      var _this$props = _this.props,
	          searchForStudent = _this$props.searchForStudent,
	          translation = _this$props.translation;
	      var _this$props$store = _this.props.store,
	          ProctorStore = _this$props$store.ProctorStore,
	          SessionStore = _this$props$store.SessionStore;
	      var showDialog = SessionStore.showDialog;
	
	      var sessionSid = (0, _helpers.getURLSegment)(_this, 5);
	      var proctorGroupSid = (0, _helpers.getURLSegment)(_this, 10);
	
	      if (!sessionSid && this.props.sessionSid) {
	        sessionSid = this.props.sessionSid;
	      }
	
	      var query = '?';
	
	      ProctorStore.resetProctors();
	
	      _this.setState({
	        filters: ProctorStore.proctorCategories
	      });
	
	      // Add sort and limit parameters
	      query += 'sortKeys=' + _this.state.sortBy + '&sortOrder=ASC&limit=25';
	
	      // Add user id parameter
	      var userData = {};
	
	      if (SessionStore.hasSessionStorage) {
	        userData = JSON.parse(sessionStorage.getItem('userData'));
	      } else {
	        userData = JSON.parse((0, _helpers.getCookie)('userData'));
	      }
	
	      query += '&userSid=' + userData.userSid;
	
	      // Add category filters
	      for (var i = 0; i < ProctorStore.proctorCategories.length; i++) {
	        query += '&proctorSubcategories=' + ProctorStore.proctorCategories[i];
	      }
	
	      // Add proctor group sid
	      if (proctorGroupSid) {
	        query += '&proctorGroupSid=' + proctorGroupSid;
	      }
	
	      // Make sure the profile has been loaded, then get the lat and lng
	      if (!searchForStudent && SessionStore.userData.role.toLowerCase() !== 'administrator') {
	        SessionStore.startLoading('Loading…', 'SearchCheckProfile');
	
	        var checkProfile = setInterval(function () {
	          if (typeof _this.props.store.SessionStore.profile.sid !== 'undefined') {
	            var _ProctorStore = _this.props.store.ProctorStore;
	            var profile = SessionStore.profile;
	
	            SessionStore.finishLoading('SearchCheckProfile');
	
	            if (typeof profile.latitude !== 'undefined' && profile.latitude !== null) {
	              // If the user has a lat and lng, search the proctors
	              query += '&latitude=' + profile.latitude + '&longitude=' + profile.longitude;
	
	              // Add the session sid to the query
	              if (sessionSid) {
	                query += '&examSessionSid=' + sessionSid;
	              }
	
	              // Perform the search
	              _ProctorStore.searchProctors(query);
	
	              // Store the query for later use
	              _this.setState({
	                query: query
	              });
	            } else {
	              // Otherwise, let them know they need to complete their profile
	              // and redirect them when they close the dialog
	              showDialog(translation.location_missing);
	
	              SessionStore.dialogCallback = function () {
	                _this.props.routing.push({
	                  pathname: '/settings'
	                });
	              };
	            }
	
	            clearInterval(checkProfile);
	          }
	        }, 100);
	      } else if (this.props.location) {
	        // If performing a search for a student as another user
	        // we already get the location from elsewhere
	        var location = _this.props.location;
	
	
	        if (location.latitude) {
	          query += '&latitude=' + location.latitude + '&longitude=' + location.longitude;
	        }
	
	        if (sessionSid) {
	          query += '&examSessionSid=' + sessionSid;
	        }
	
	        // Perform the search
	        ProctorStore.searchProctors(query);
	
	        // Store the query for later use
	        _this.setState({
	          query: query
	        });
	      } else if (!this.props.location) {
	        // Otherwise if we’re searching as an administator
	        // search without a query
	        var checkAdminProfile = setInterval(function () {
	          if (typeof _this.props.store.SessionStore.profile.currencyCode !== 'undefined') {
	            var _ProctorStore2 = _this.props.store.ProctorStore;
	
	
	            SessionStore.finishLoading('SearchCheckProfile');
	            _ProctorStore2.searchProctors('');
	
	            clearInterval(checkAdminProfile);
	          }
	        }, 100);
	      }
	    }
	  }, {
	    key: 'applyFilters',
	    value: function applyFilters(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var query = '?';
	      var _props = this.props,
	          searchForStudent = _props.searchForStudent,
	          translation = _props.translation;
	      var _props$store2 = this.props.store,
	          ProctorStore = _props$store2.ProctorStore,
	          SessionStore = _props$store2.SessionStore;
	      var profile = SessionStore.profile,
	          showDialog = SessionStore.showDialog;
	
	      var sessionSid = (0, _helpers.getURLSegment)(this, 5);
	      var proctorGroupSid = (0, _helpers.getURLSegment)(this, 10);
	
	      if (!sessionSid && this.props.sessionSid) {
	        sessionSid = this.props.sessionSid;
	      }
	
	      // Add sort parameter
	      query += 'sortKeys=' + this.state.sortBy + '&sortOrder=ASC';
	
	      // Add user id parameter
	      var userData = {};
	
	      if (SessionStore.hasSessionStorage) {
	        userData = JSON.parse(sessionStorage.getItem('userData'));
	      } else {
	        userData = JSON.parse((0, _helpers.getCookie)('userData'));
	      }
	
	      query += '&userSid=' + userData.userSid;
	
	      if (sessionSid) {
	        query += '&examSessionSid=' + sessionSid;
	      }
	
	      if (this.state.distance) {
	        query += '&maxTravelDistance=' + this.state.distance;
	      }
	
	      if (this.state.filters.length > 0) {
	        for (var i = 0; i < this.state.filters.length; i++) {
	          query += '&proctorSubcategories=' + this.state.filters[i];
	        }
	      }
	
	      if (proctorGroupSid) {
	        query += '&proctorGroupSid=' + proctorGroupSid;
	      }
	
	      if (this.state.onlyApproved) {
	        query += '&onlyApproved=true';
	      }
	
	      if (!searchForStudent && SessionStore.userData.role.toLowerCase() !== 'administrator') {
	        if (typeof profile.latitude !== 'undefined') {
	          query += '&latitude=' + profile.latitude + '&longitude=' + profile.longitude;
	        } else {
	          showDialog(translation.location_missing);
	        }
	      } else if (this.props.location) {
	        // If performing a search for a student as another user
	        // we already get the location from elsewhere
	        var location = this.props.location;
	
	
	        if (location.latitude) {
	          query += '&latitude=' + location.latitude + '&longitude=' + location.longitude;
	        }
	      }
	
	      // If there’s a keyword provided, add that
	      if (this.keyword && this.keyword.value) {
	        query += '&keyword=*' + this.keyword.value + '*';
	      }
	
	      // If a location has been provided, get the lat and lng
	      if (this.state.location && this.state.location.lat && this.state.location.lng) {
	        query += '&latitude=' + this.state.location.lat;
	        query += '&longitude=' + this.state.location.lng;
	      }
	
	      if (this.state.filters === ProctorStore.proctorCategories) {
	        this.setState({
	          activeFilters: [],
	          activeDistance: this.state.distance
	        });
	      } else {
	        this.setState({
	          activeFilters: this.state.filters,
	          activeDistance: this.state.distance
	        });
	      }
	
	      this.props.store.ProctorStore.searchProctors(query);
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      var ProctorStore = this.props.store.ProctorStore;
	
	
	      this.setState({
	        parents: [],
	        filters: ProctorStore.proctorCategories || [],
	        activeFilters: [],
	        distance: null,
	        activeDistance: null,
	        sortBy: 'distance',
	        onlyApproved: false,
	        location: null
	      }, function () {
	        this.getProctors();
	      });
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var sortBy = 'distance';
	
	      if (this.sortBy) {
	        sortBy = this.sortBy.value || 'distance';
	      }
	
	      var distance = null;
	
	      if (this.distance) {
	        distance = parseInt(this.distance.value, 10);
	      }
	
	      this.setState({
	        distance: distance,
	        sortBy: sortBy
	      });
	
	      var _this = this;
	
	      setTimeout(function () {
	        _this.applyFilters();
	      });
	    }
	  }, {
	    key: 'removeDistance',
	    value: function removeDistance() {
	      this.distance.value = '';
	
	      this.setState({
	        distance: null
	      });
	
	      var _this = this;
	
	      setTimeout(function () {
	        _this.applyFilters();
	      });
	    }
	  }, {
	    key: 'toggleApproved',
	    value: function toggleApproved() {
	      this.setState({
	        onlyApproved: !this.state.onlyApproved
	      });
	
	      var _this = this;
	
	      setTimeout(function () {
	        _this.applyFilters();
	      });
	    }
	  }, {
	    key: 'addCat',
	    value: function addCat(val, subcats) {
	      if (subcats.indexOf(val) < 0) {
	        subcats.push(val);
	      }
	    }
	  }, {
	    key: 'removeCat',
	    value: function removeCat(val, subcats, apply) {
	      for (var i = 0; i < subcats.length; i++) {
	        if (subcats[i] === val) {
	          subcats.splice(i, 1);
	        }
	      }
	
	      if (apply) {
	        var _this = this;
	
	        setTimeout(function () {
	          _this.applyFilters();
	        });
	      }
	    }
	  }, {
	    key: 'handleCategory',
	    value: function handleCategory(e, isParent) {
	      var subcats = [].concat(_toConsumableArray(this.state.activeFilters));
	      var parentcats = [].concat(_toConsumableArray(this.state.parents));
	      var thisVal = e.target.value;
	      var _this = this;
	
	      if (!isParent) {
	        if (e.target.checked) {
	          // Add the category to the array on check
	          _this.addCat(thisVal, subcats);
	        } else {
	          // Remove the category from the array on uncheck
	          _this.removeCat(thisVal, subcats);
	
	          // Deselect the parent category
	          var parentVal = e.target.parentElement.parentElement.previousSibling.previousSibling.value;
	          _this.removeCat(parentVal, parentcats);
	        }
	      }
	
	      // If it’s a parent category
	      if (isParent) {
	        if (e.target.checked) {
	          // Select all children
	          var childHolder = e.target.parentElement.querySelector('ul');
	          var children = childHolder.querySelectorAll('input');
	
	          for (var i = 0; i < children.length; i++) {
	            _this.addCat(children[i].value, subcats);
	          }
	
	          _this.addCat(thisVal, parentcats);
	        } else {
	          // Otherwise, deselect all children
	          var _childHolder = e.target.parentElement.querySelector('ul');
	          var _children = _childHolder.querySelectorAll('input');
	
	          for (var _i = 0; _i < _children.length; _i++) {
	            _this.removeCat(_children[_i].value, subcats);
	          }
	
	          _this.removeCat(thisVal, parentcats);
	        }
	      }
	
	      // Make sure the results are at least filtered to the group’s allowed categories
	      if (subcats.length === 0) {
	        subcats = this.props.store.ProctorStore.proctorCategories;
	      }
	
	      this.setState({
	        parents: parentcats,
	        filters: subcats
	      });
	
	      setTimeout(function () {
	        _this.applyFilters();
	      });
	    }
	  }, {
	    key: 'removeCategory',
	    value: function removeCategory(sid, apply) {
	      var subcats = [].concat(_toConsumableArray(this.state.filters));
	      var parentcats = [].concat(_toConsumableArray(this.state.parents));
	
	      // Remove sub category
	      this.removeCat(sid, subcats, apply);
	
	      // Remove parent category
	      var thisEl = document.querySelector('input[value=' + sid + ']');
	      var parentVal = thisEl.parentElement.parentElement.previousSibling.previousSibling.value;
	      this.removeCat(parentVal, parentcats);
	
	      // Make sure the results are at least filtered to the group’s allowed categories
	      if (subcats.length === 0) {
	        subcats = this.props.store.ProctorStore.proctorCategories;
	      }
	
	      this.setState({
	        parents: parentcats,
	        filters: subcats
	      });
	    }
	  }, {
	    key: 'categoryName',
	    value: function categoryName(catKey) {
	      var SessionStore = this.props.store.SessionStore;
	
	      var catName = null;
	
	      // Set the category name if it’s a parent category
	      SessionStore.proctorTypeList.filter(function (obj) {
	        return obj.sid === catKey;
	      }).map(function (key) {
	        catName = 'parent';
	        return true;
	      });
	
	      // If catName is still null, it’s a child category
	      if (!catName) {
	        SessionStore.proctorTypeList.map(function (key) {
	          key.subCategories.filter(function (obj) {
	            return obj.sid === catKey;
	          }).map(function (subKey) {
	            catName = subKey.title;
	            return true;
	          });
	          return true;
	        });
	      }
	
	      return catName;
	    }
	  }, {
	    key: 'renderRequestProctor',
	    value: function renderRequestProctor() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var courseData = SessionStore.courseData,
	          profile = SessionStore.profile,
	          userData = SessionStore.userData;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'cta cta--fixed cta--inline ' + (this.state.hideCta ? 'hidden' : '')
	        },
	        _react2.default.createElement(
	          'span',
	          { className: 'cta__subcopy' },
	          translation.request.body
	        ),
	        '\xA0',
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'btn--link',
	            href: 'https://smarterservices.typeform.com/to/iJvtxI?name=' + profile.firstName + ' ' + profile.lastName + '&email=' + profile.email + '&course=' + courseData.code + '&institution=' + userData.smarterProctoring.appInstallName,
	            target: '_blank'
	          },
	          translation.request.button
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          ProctorStore = _props$store3.ProctorStore,
	          SessionStore = _props$store3.SessionStore;
	      var proctors = ProctorStore.proctors,
	          proctorCategories = ProctorStore.proctorCategories,
	          proctorsNext = ProctorStore.proctorsNext,
	          proctorsTotal = ProctorStore.proctorsTotal;
	
	      var sessionSid = (0, _helpers.getURLSegment)(this, 5);
	
	      if (!sessionSid && this.props.sessionSid) {
	        sessionSid = this.props.sessionSid;
	      }
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        !this.props.drawer && _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          )
	        ),
	        this.props.drawer && _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.page_title
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'filter', onSubmit: function onSubmit(e) {
	              _this3.applyFilters(e);
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'filter__filters' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--inline' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.filter,
	                    ':'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'faux-select hidden' },
	                  _react2.default.createElement(
	                    _reactSimpleDropdown2.default,
	                    { ref: 'pagesDropdown' },
	                    _react2.default.createElement(
	                      _reactSimpleDropdown.DropdownTrigger,
	                      { className: 'faux-select__selected' },
	                      translation.proctor_type.label
	                    ),
	                    _react2.default.createElement(
	                      _reactSimpleDropdown.DropdownContent,
	                      null,
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'faux-select__options dropdown__menu' },
	                        SessionStore.proctorTypeList.map(function (key, i) {
	                          return _react2.default.createElement(
	                            'li',
	                            { key: i, className: 'separator filter-' + key.sid + ' filter-empty' },
	                            _react2.default.createElement('input', { type: 'checkbox', id: key.sid, className: 'checkbox-input', name: 'subcategories', value: key.sid, checked: _this3.state.parents.indexOf(key.sid) > -1, onChange: function onChange(e) {
	                                _this3.handleCategory(e, true);
	                              } }),
	                            _react2.default.createElement(
	                              'label',
	                              { htmlFor: key.sid, className: 'checkbox-label' },
	                              key.title
	                            ),
	                            _react2.default.createElement(
	                              'ul',
	                              null,
	                              key.subCategories.map(function (subKey, j) {
	                                if (proctorCategories.indexOf(subKey.sid) >= 0) {
	                                  var parent = document.querySelector('.filter-' + key.sid);
	                                  var dropdown = document.querySelector('.faux-select.hidden');
	
	                                  if (parent) {
	                                    parent.classList.remove('filter-empty');
	                                    parent.className += ' filter-full';
	                                  }
	
	                                  if (dropdown) {
	                                    dropdown.classList.remove('hidden');
	                                  }
	
	                                  return _react2.default.createElement(
	                                    'li',
	                                    {
	                                      key: j,
	                                      className: j === 0 ? 'separator' : ''
	                                    },
	                                    _react2.default.createElement('input', {
	                                      type: 'checkbox',
	                                      id: subKey.sid,
	                                      className: 'checkbox-input',
	                                      name: 'subcategories',
	                                      value: subKey.sid, checked: _this3.state.activeFilters.indexOf(subKey.sid) > -1,
	                                      onChange: function onChange(e) {
	                                        _this3.handleCategory(e, false);
	                                      }
	                                    }),
	                                    _react2.default.createElement(
	                                      'label',
	                                      { htmlFor: subKey.sid, className: 'checkbox-label' },
	                                      subKey.title
	                                    )
	                                  );
	                                }
	
	                                return '';
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                ),
	                sessionSid && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select' },
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        ref: function ref(input) {
	                          _this3.distance = input;
	                        },
	                        onChange: this.handleInput
	                      },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        translation.distance.label
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 10 },
	                        '10 ',
	                        translation.distance.miles
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 25 },
	                        '25 ',
	                        translation.distance.miles
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 50 },
	                        '50 ',
	                        translation.distance.miles
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 100 },
	                        '100 ',
	                        translation.distance.miles
	                      )
	                    )
	                  )
	                ),
	                !sessionSid && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'meta',
	                      htmlFor: 'filter-keyword'
	                    },
	                    translation.keyword
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'filter-keyword',
	                    placeholder: translation.keyword,
	                    ref: function ref(input) {
	                      _this3.keyword = input;
	                    },
	                    onChange: function onChange(e) {
	                      if (_this3.keyword.value && _this3.keyword.value.length > 2) {
	                        _this3.applyFilters(e);
	                      }
	                    }
	                  })
	                ),
	                !sessionSid && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.sorting,
	                    ':'
	                  )
	                ),
	                !sessionSid && _react2.default.createElement(
	                  'li',
	                  { className: 'filter__lg' },
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'meta',
	                      htmlFor: 'filter-location'
	                    },
	                    translation.location
	                  ),
	                  _react2.default.createElement(_Address2.default, Object.assign({
	                    parent: this,
	                    onSelect: this.applyFilters
	                  }, this.props))
	                )
	              )
	            ),
	            sessionSid && _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                id: 'filter-approved',
	                className: 'switch-input',
	                defaultChecked: this.state.onlyApproved,
	                onChange: this.toggleApproved,
	                onKeyDown: _helpers.handleSwitchInputKeys
	              }),
	              _react2.default.createElement(
	                'label',
	                { className: 'switch-label', htmlFor: 'filter-approved' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.approved
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'switch-label--alt', htmlFor: 'filter-approved' },
	                translation.approved
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--outline',
	                type: 'reset',
	                onClick: this.resetFilters
	              },
	              translation.reset_button
	            )
	          )
	        ),
	        !SessionStore.loading && _react2.default.createElement(
	          'div',
	          { className: 'wrap wrap--md' },
	          proctors.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'active-filters' },
	            proctors.length === 1 && _react2.default.createElement(
	              'strong',
	              { className: 'results' },
	              proctorsTotal,
	              ' ',
	              translation.results_singular
	            ),
	            proctors.length !== 1 && _react2.default.createElement(
	              'strong',
	              { className: 'results' },
	              proctorsTotal,
	              ' ',
	              translation.results_plural
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'tags' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.selected,
	                ':'
	              ),
	              this.state.activeDistance && _react2.default.createElement(
	                'span',
	                { className: 'tag tag--removable', onClick: function onClick() {
	                    return _this3.removeDistance();
	                  } },
	                this.state.activeDistance,
	                ' ',
	                translation.distance.miles
	              ),
	              this.state.activeFilters !== proctorCategories && this.state.activeFilters.map(function (key, i) {
	                if (_this3.categoryName(key) !== 'parent') {
	                  return _react2.default.createElement(
	                    'span',
	                    { key: i, className: 'tag tag--removable', onClick: function onClick() {
	                        return _this3.removeCategory(key, true);
	                      } },
	                    _this3.categoryName(key)
	                  );
	                } else {
	                  return '';
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'sort' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.sorting,
	                ':'
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    ref: function ref(input) {
	                      _this3.sortBy = input;
	                    },
	                    onChange: this.handleInput,
	                    defaultValue: this.state.sortBy
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'distance' },
	                    translation.sorting_opts.distance
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'price' },
	                    translation.sorting_opts.price
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'proctor-list' },
	            proctors.map(function (key, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i, className: 'proctor-list__item' },
	                _react2.default.createElement(_Proctor2.default, Object.assign({
	                  proctor: key,
	                  i: i,
	                  parent: _this3,
	                  showProctorActions: _this3.state.showProctorActions,
	                  showApprovalHistory: _this3.state.showApprovalHistory
	                }, _this3.props))
	              );
	            })
	          ),
	          !this.props.drawer && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'request-new-proctor',
	            renderFeatureCallback: function renderFeatureCallback() {
	              return _this3.renderRequestProctor();
	            }
	          }),
	          proctorsNext && _react2.default.createElement(_LoadMore2.default, Object.assign({
	            clickFunction: this.loadMore,
	            url: proctorsNext,
	            group: proctors,
	            text: 'Load more proctors',
	            store: ProctorStore
	          }, this.props)),
	          proctors.length === 0 && _react2.default.createElement(
	            'span',
	            { className: 'no-results' },
	            translation.no_results
	          )
	        ),
	        !this.props.drawer && _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          sessionRequest: true,
	          examSid: (0, _helpers.getURLSegment)(this, 3),
	          sessionSid: (0, _helpers.getURLSegment)(this, 5),
	          examConfigurationSid: (0, _helpers.getURLSegment)(this, 7),
	          proctorSid: this.state.proctorSid,
	          toUserSid: this.state.proctorSid,
	          contextType: 'examSid',
	          contextId: (0, _helpers.getURLSegment)(this, 3),
	          proctorLocationSid: this.state.proctorLocationSid,
	          examSession: this.props.store.EnrollmentStore.examSession,
	          messageSid: this.state.messageSid,
	          searchPage: true
	        }, this.props))
	      );
	    }
	  }]);
	
	  return LocateProctor;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('LocateProctor')(LocateProctor);

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _MessageForm = __webpack_require__(802);
	
	var _MessageForm2 = _interopRequireDefault(_MessageForm);
	
	var _MessageContext = __webpack_require__(801);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _RequestedDates = __webpack_require__(356);
	
	var _RequestedDates2 = _interopRequireDefault(_RequestedDates);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var MessageThread = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(MessageThread, _React$Component);
	
	  function MessageThread() {
	    _classCallCheck(this, MessageThread);
	
	    var _this2 = _possibleConstructorReturn(this, (MessageThread.__proto__ || Object.getPrototypeOf(MessageThread)).call(this));
	
	    _this2.getThread = _this2.getThread.bind(_this2);
	    _this2.showForm = _this2.showForm.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(MessageThread, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        renderForm: false
	      };
	
	      this.getThread();
	
	      // Get current server time
	      this.props.store.SessionStore.getCurrentTime(true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.MessageStore.confirmedDate = this.props.store.MessageStore.threadObject.confirmedDate;
	      this.props.store.MessageStore.threadObject = {};
	      this.props.store.MessageStore.threadMessages = [];
	      this.props.parent.setState({
	        messageSid: null
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps) {
	      if (nextProps.messageSid !== this.props.messageSid) {
	        this.setState({
	          renderForm: false
	        });
	
	        this.getThread();
	      }
	    }
	  }, {
	    key: 'getThread',
	    value: function getThread() {
	      var messageSid = this.props.messageSid;
	
	
	      this.props.store.MessageStore.getThreads(true);
	
	      if (messageSid) {
	        this.props.store.MessageStore.getThread(messageSid, this.props.preventReload);
	      } else {
	        this.props.store.MessageStore.getThreadId(this.props.toUserSid, this.props.contextType, this.props.contextId, this.props.sessionRequest, this.props.parent, this.props.preventReload, this.props.proctorLocationSid);
	      }
	
	      // Highlight the newly selected thread
	      var prevThread = document.querySelector('.thread.active');
	
	      if (prevThread) {
	        prevThread.classList.remove('active');
	      }
	
	      var thread = null;
	
	      var _this = this;
	      var getThread = setInterval(function () {
	        thread = document.querySelector('#thread-' + messageSid);
	
	        if (thread) {
	          thread.className += ' active';
	          clearInterval(getThread);
	        } else if (!messageSid) {
	          clearInterval(getThread);
	        }
	      }, 100);
	    }
	  }, {
	    key: 'showForm',
	    value: function showForm() {
	      this.setState({
	        renderForm: true
	      });
	    }
	  }, {
	    key: 'initials',
	    value: function initials(name, className) {
	      var names = name.split(' ');
	      var firstInitial = names[0].charAt(0);
	      var secondInitial = names[1].charAt(0);
	
	      if (className) {
	        return '' + firstInitial.toLowerCase();
	      }
	
	      return firstInitial + secondInitial;
	    }
	  }, {
	    key: 'renderContext',
	    value: function renderContext() {
	      var translation = this.props.translation;
	      var threadObject = this.props.store.MessageStore.threadObject;
	      var course = threadObject.course,
	          exam = threadObject.exam,
	          examSession = threadObject.examSession;
	      var _props$store$SessionS = this.props.store.SessionStore,
	          courseData = _props$store$SessionS.courseData,
	          userTimezone = _props$store$SessionS.userTimezone;
	
	
	      var examConfiguration = null;
	
	      if (examSession && examSession.examConfiguration) {
	        examConfiguration = examSession.examConfiguration;
	      }
	
	      var title = null;
	      var subTitle = null;
	      var data = [];
	
	      if (examConfiguration && exam) {
	        title = exam.title;
	
	        if (threadObject.confirmedDate) {
	          data = [{
	            title: translation.context.exam_date,
	            value: '' + _moment2.default.utc(threadObject.confirmedDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	          }, {
	            title: translation.context.duration,
	            value: (0, _helpers.toHours)(examConfiguration.duration, false, false, false)
	          }];
	        } else {
	          data = [{
	            title: translation.context.exam_date,
	            value: _moment2.default.utc(examConfiguration.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma') + ' \u2013 ' + _moment2.default.utc(examConfiguration.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	          }, {
	            title: translation.context.duration,
	            value: (0, _helpers.toHours)(examConfiguration.duration, false, false, false)
	          }];
	        }
	      } else if (threadObject.examSid && exam) {
	        title = exam.title;
	
	        data = [{
	          title: translation.context.exam_date,
	          value: _moment2.default.utc(exam.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma') + ' \u2013 ' + _moment2.default.utc(exam.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	        }, {
	          title: translation.context.duration,
	          value: (0, _helpers.toHours)(exam.duration, false, false, false)
	        }];
	      } else if (threadObject.courseSid) {
	        title = course.title;
	
	        data = [{
	          title: translation.context.course_code,
	          value: course.code
	        }, {
	          title: translation.context.instructor,
	          value: courseData.instructor.firstName + ' ' + courseData.instructor.lastName
	        }];
	      }
	
	      // Add proctor context if it’s a with a proctor
	      if (threadObject.proctorAccountUserSid && threadObject.proctorAccountLocation) {
	        var proctor = this.props.store.ProctorStore.proctor;
	
	        var location = threadObject.proctorAccountLocation;
	        var address = location.address1;
	
	        if (location.address2) {
	          address += ', ' + location.address2;
	        }
	
	        subTitle = translation.context.proctor;
	
	        var proctorData = [{
	          title: translation.context.proctor,
	          value: '' + proctor.accountName
	        }, {
	          title: translation.context.location,
	          value: address + ', ' + location.place + ', ' + location.region + ' ' + location.postalCode + ' ' + location.country
	        }];
	
	        data = data.concat(proctorData);
	      }
	
	      if (title) {
	        return _react2.default.createElement(_MessageContext2.default, Object.assign({
	          title: title,
	          subTitle: subTitle,
	          data: data
	        }, this.props));
	      }
	
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          MessageStore = _props$store.MessageStore,
	          SessionStore = _props$store.SessionStore;
	      var threadMessages = MessageStore.threadMessages,
	          threadObject = MessageStore.threadObject;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var sessionRequest = false;
	
	      if (threadObject.dateOption1 || threadObject.proctorAccountLocationSid && threadObject.initiatingUserSid) {
	        sessionRequest = true;
	      }
	
	      if (!SessionStore.loading) {
	        if (threadMessages.length > 0) {
	          return _react2.default.createElement(
	            'article',
	            { className: 'inbox__thread' },
	            this.props.drawer && _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.message
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'inbox__tools' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.showForm },
	                      _react2.default.createElement(icons.iconReply, null),
	                      translation.reply
	                    )
	                  )
	                )
	              )
	            ),
	            !this.props.drawer && _react2.default.createElement(
	              'header',
	              { className: 'inbox__thread-header' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'inbox__thread-title' },
	                translation.message
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'inbox__tools' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: this.showForm },
	                    _react2.default.createElement(icons.iconReply, null),
	                    translation.reply
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'inbox__thread-body' },
	              this.renderContext(),
	              _react2.default.createElement(
	                'ol',
	                { className: 'conversation' },
	                threadMessages.map(function (message, i) {
	                  var fromUser = null;
	
	                  if (message.fromUser) {
	                    fromUser = message.fromUser;
	                  } else {
	                    fromUser = message.fromProctorAccountUser;
	                  }
	
	                  return _react2.default.createElement(
	                    'li',
	                    { key: i },
	                    _react2.default.createElement(
	                      'blockquote',
	                      { className: 'conversation__message ' + (fromUser.sid === SessionStore.userData.userSid ? 'sent' : 'received') },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'conversation__body' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'conversation__content' },
	                          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(message.content.replace(/\r?\n|\r/g, ' ')) } })
	                        ),
	                        _react2.default.createElement(
	                          'time',
	                          { className: 'conversation__timestamp' },
	                          _moment2.default.utc(message.createdDate).tz(userTimezone).format('M/D/YYYY h:mma')
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'cite',
	                        { className: 'conversation__author conversation__author--sm' },
	                        _react2.default.createElement(
	                          'abbr',
	                          {
	                            className: '\n                                avatar--initials conversation__avatar ' + _this3.initials(fromUser.firstName + ' ' + fromUser.lastName, true) + '\n                              ',
	                            title: fromUser.firstName + ' ' + fromUser.lastName },
	                          fromUser.firstName.charAt(0),
	                          fromUser.lastName.charAt(0)
	                        )
	                      )
	                    )
	                  );
	                })
	              ),
	              (threadObject.dateOption1 || threadObject.confirmedDate) && _react2.default.createElement(_RequestedDates2.default, this.props),
	              _react2.default.createElement(_MessageForm2.default, Object.assign({
	                sessionRequest: sessionRequest,
	                renderForm: this.state.renderForm,
	                showForm: this.showForm,
	                mode: 'reply',
	                threadSid: threadMessages[0].messageThreadSid,
	                threadObject: threadObject,
	                messageCount: threadMessages.length,
	                confirmedDate: threadObject.confirmedDate,
	                confirmedDateExpiration: threadObject.confirmedDateExpiration,
	                parentThread: this,
	                examConfiguration: threadObject.examConfiguration,
	                examSession: threadObject.examSession
	              }, this.props))
	            )
	          );
	        } else if (this.props.drawer) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'drawer__content' },
	            _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.new_message
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap block-form' },
	              _react2.default.createElement(_MessageForm2.default, Object.assign({
	                sessionRequest: this.props.sessionRequest,
	                renderForm: true,
	                showForm: this.showForm,
	                mode: 'create',
	                parentThread: this,
	                messageCount: threadMessages.length,
	                threadObject: threadObject
	              }, this.props))
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return MessageThread;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('MessageThread')(MessageThread);

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var RequestedDates = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(RequestedDates, _React$Component);
	
	  function RequestedDates() {
	    _classCallCheck(this, RequestedDates);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (RequestedDates.__proto__ || Object.getPrototypeOf(RequestedDates)).call(this));
	
	    _this2.cancelRequest = _this2.cancelRequest.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(RequestedDates, [{
	    key: 'initSchedule',
	    value: function initSchedule(e, proctorLocationSid, sessionSid, examSid) {
	      if ((0, _helpers.getURLSegment)(this, 1) === 'schedule-session') {
	        this.props.routing.push('/messages/view/' + this.props.messageSid);
	
	        setTimeout(function () {
	          var scheduleBtn = document.querySelector('.requested-dates .btn--success');
	
	          if (scheduleBtn) {
	            scheduleBtn.click();
	          }
	        }, 1000);
	      }
	
	      this.props.parent.setState({
	        proctorLocationSid: proctorLocationSid,
	        sessionSid: sessionSid,
	        examSid: examSid
	      });
	
	      if (this.props.external) {
	        this.props.parent.setState({
	          confirmedDate: this.props.confirmedDate,
	          messageSid: this.props.messageSid
	        });
	      }
	
	      if (!this.props.drawer) {
	        this.props.toggleDrawer(e, this.props.parent, 'ScheduleMessaging');
	      } else {
	        this.props.parent.setState({
	          drawerContent: 'ScheduleMessaging'
	        });
	      }
	    }
	  }, {
	    key: 'cancelRequest',
	    value: function cancelRequest(e) {
	      var datesEl = (0, _helpers.findAncestor)(e.target, 'requested-dates');
	
	      this.props.store.MessageStore.cancelRequest(this.props.messageSid, datesEl);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var threadObject = this.props.store.MessageStore.threadObject;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var _this = this;
	
	      var confirmedDate = null;
	      var confirmedDateExpiration = null;
	      var proctor = null;
	      var proctorAccountLocationSid = null;
	      var sessionSid = null;
	      var examSid = null;
	
	      if (this.props.external) {
	        // If we’re not in the context of a
	        // message thread (e.g. student exam cards)
	        // we get the  data passed via props
	        confirmedDate = this.props.confirmedDate;
	        confirmedDateExpiration = this.props.confirmedDateExpiration;
	        proctor = this.props.proctor;
	        proctorAccountLocationSid = this.props.proctorAccountLocationSid;
	        sessionSid = this.props.thisSessionSid;
	        examSid = this.props.thisExamSid;
	      } else {
	        // Otherwise if we’re in a message thread
	        // the data comes from the message store
	        confirmedDate = threadObject.confirmedDate;
	        confirmedDateExpiration = threadObject.confirmedDateExpiration;
	        proctorAccountLocationSid = threadObject.proctorAccountLocationSid;
	        sessionSid = threadObject.examSession.sid;
	        examSid = threadObject.examSid;
	      }
	
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	
	      var expired = false;
	      var expirationDate = (0, _moment2.default)(confirmedDateExpiration);
	      var scheduleDiff = _moment2.default.duration(expirationDate.diff(now)).asHours();
	
	      if (scheduleDiff < 0) {
	        expired = true;
	      }
	
	      var past = false;
	      var appointmentDate = (0, _moment2.default)(confirmedDate);
	      var appointmentDiff = _moment2.default.duration(appointmentDate.diff(now)).asHours();
	
	      var expDateAfterApptDate = false;
	      var expApptDiff = _moment2.default.duration(appointmentDate.diff(expirationDate)).asHours();
	
	      if (expApptDiff < 0) {
	        expDateAfterApptDate = true;
	      }
	
	      if (appointmentDiff < 0) {
	        past = true;
	      }
	
	      var dates = [];
	
	      if (threadObject.dateOption1) {
	        dates.push(threadObject.dateOption1);
	      }
	
	      if (threadObject.dateOption2) {
	        dates.push(threadObject.dateOption2);
	      }
	
	      if (threadObject.dateOption3) {
	        dates.push(threadObject.dateOption3);
	      }
	
	      // Proctor has confirmed a date
	      // but student didn’t schedule
	      // in time and now the confirmed
	      // date is in the past
	      if (past) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'requested-dates cta ' + (this.props.external ? 'cta--secondary' : '') },
	          _react2.default.createElement(
	            'strong',
	            { className: 'cta__copy' },
	            translation.missed
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'cta__subcopy' },
	            translation.missed_body.replace('%date%', (0, _moment2.default)(appointmentDate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma'))
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'cta__btn btn--outline btn--negative',
	              onClick: this.cancelRequest
	            },
	            _react2.default.createElement(icons.iconTimesCircle, null),
	            translation.cancel_button
	          )
	        );
	      }
	
	      if (!confirmedDate && !this.props.external) {
	        // Show the requested dates if none have been confirmed yet
	        return _react2.default.createElement(
	          'div',
	          { className: 'thread__dates requested-dates' },
	          _react2.default.createElement(
	            'strong',
	            null,
	            translation.requested_dates
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'date-opts' },
	            dates.map(function (date, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pill pill--lg' },
	                  _moment2.default.utc(date).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn--outline btn--negative',
	              onClick: function onClick(e) {
	                _this3.cancelRequest(e);
	              }
	            },
	            _react2.default.createElement(icons.iconTimesCircle, null),
	            translation.cancel_button
	          )
	        );
	      } else if (confirmedDate && !expired && !past) {
	        // Show the schedule button if there’s a confirmed date and it hasn’t expired
	        return _react2.default.createElement(
	          'div',
	          { className: 'requested-dates cta ' + (this.props.external ? 'cta--secondary' : '') },
	          this.props.external && _react2.default.createElement(
	            'strong',
	            { className: 'cta__copy' },
	            proctor
	          ),
	          this.props.external && _react2.default.createElement(
	            'strong',
	            { className: 'cta__subcopy', 'aria-describedby': 'scheduleby-tooltip' },
	            translation.confirmed_date,
	            ' ',
	            _moment2.default.utc(confirmedDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	          ),
	          !this.props.external && _react2.default.createElement(
	            'strong',
	            { className: 'cta__copy', 'aria-describedby': 'scheduleby-tooltip' },
	            translation.confirmed_date,
	            ' ',
	            _moment2.default.utc(confirmedDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	          ),
	          !expDateAfterApptDate && _react2.default.createElement(
	            'span',
	            { className: 'cta__subcopy' },
	            translation.scheduleby.replace('%date%', _moment2.default.utc(confirmedDateExpiration).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))
	          ),
	          expDateAfterApptDate && _react2.default.createElement(
	            'span',
	            { className: 'cta__subcopy' },
	            translation.schedulebefore
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'cta__btn btn--success',
	              onClick: function onClick(e) {
	                _this3.initSchedule(e, proctorAccountLocationSid, sessionSid, examSid);
	              }
	            },
	            translation.schedule_button
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'cta__btn btn--outline btn--negative',
	              onClick: this.cancelRequest
	            },
	            _react2.default.createElement(icons.iconTimesCircle, null),
	            translation.cancel_button
	          )
	        );
	      } else if (confirmedDate && expired) {
	        // If the confirmed date has expired, show a message
	        return _react2.default.createElement(
	          'div',
	          { className: 'requested-dates cta ' + (this.props.external ? 'cta--secondary' : '') },
	          _react2.default.createElement(
	            'strong',
	            { className: 'cta__copy', 'aria-describedby': 'scheduleby-tooltip' },
	            translation.expired_heading
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return RequestedDates;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('RequestedDates')(RequestedDates);

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Privacy = __webpack_require__(215);
	
	var _Privacy2 = _interopRequireDefault(_Privacy);
	
	var _ProctorTypeList = __webpack_require__(361);
	
	var _ProctorTypeList2 = _interopRequireDefault(_ProctorTypeList);
	
	var _ExamAttachmentsList = __webpack_require__(218);
	
	var _ExamAttachmentsList2 = _interopRequireDefault(_ExamAttachmentsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var ExamDetailedInfo = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamDetailedInfo, _React$Component);
	
	  function ExamDetailedInfo() {
	    _classCallCheck(this, ExamDetailedInfo);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (ExamDetailedInfo.__proto__ || Object.getPrototypeOf(ExamDetailedInfo)).call(this));
	
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExamDetailedInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        expanded: false
	      };
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        expanded: !this.state.expanded
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var exam = this.props.exam;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'panel__section' },
	        _react2.default.createElement(
	          'h2',
	          {
	            className: 'panel__heading panel__heading--expand',
	            onClick: this.toggle
	          },
	          translation.heading,
	          _react2.default.createElement(
	            'button',
	            {
	              className: '\n              btn--expand\n              ' + (this.state.expanded ? 'expanded' : '') + '\n            ',
	              onClick: this.toggle,
	              'aria-controls': 'exam-detailed-info-panel',
	              'aria-expanded': this.state.expanded
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              'View details'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            id: 'exam-detailed-info-panel',
	            className: this.state.expanded ? 'expanded' : 'collapsed'
	          },
	          _react2.default.createElement(
	            'ul',
	            { className: 'data' },
	            exam.type.toLowerCase() !== 'written' && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.url
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  href: exam.url,
	                  title: exam.url
	                },
	                exam.url
	              )
	            ),
	            exam.type.toLowerCase() === 'written' && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.examFile
	              ),
	              _react2.default.createElement(_ExamAttachmentsList2.default, Object.assign({}, this.props, {
	                parent: this,
	                exam: exam,
	                overview: true,
	                hideDelete: true
	              }))
	            ),
	            exam.configuration.password && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.password
	              ),
	              _react2.default.createElement(_Privacy2.default, Object.assign({
	                show: translation.reveal,
	                hide: translation.hide,
	                'private': exam.configuration.password
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.attempts
	              ),
	              exam.configuration.attempts
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'data' },
	            exam.configuration.proctorTypes.length > 0 && _react2.default.createElement(
	              'li',
	              { className: 'data__lg' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.proctor_types
	              ),
	              _react2.default.createElement(_ProctorTypeList2.default, Object.assign({
	                proctorTypes: exam.configuration.proctorTypes
	              }, this.props))
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'data' },
	            exam.configuration.studentNotes && _react2.default.createElement(
	              'li',
	              { className: 'data__lg' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.student_notes
	              ),
	              exam.configuration.studentNotes
	            ),
	            exam.configuration.proctorNotes && _react2.default.createElement(
	              'li',
	              { className: 'data__lg' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.proctor_notes
	              ),
	              exam.configuration.proctorNotes
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExamDetailedInfo;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamDetailedInfo')(ExamDetailedInfo);

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDropzone = __webpack_require__(270);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var FileUpload = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(FileUpload, _React$Component);
	
	  function FileUpload() {
	    _classCallCheck(this, FileUpload);
	
	    var _this = _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call(this));
	
	    _this.handleDrop = _this.handleDrop.bind(_this);
	    _this.handleDragEnter = _this.handleDragEnter.bind(_this);
	    _this.handleDragLeave = _this.handleDragLeave.bind(_this);
	    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
	    _this.removeFile = _this.removeFile.bind(_this);
	    return _this;
	  }
	
	  _createClass(FileUpload, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        attachment: [],
	        dropClass: ''
	      };
	    }
	  }, {
	    key: 'handleDrop',
	    value: function handleDrop(file, rejected) {
	      var SessionStore = this.props.store.SessionStore;
	      var onDrop = this.props.onDrop;
	
	      var size = 0;
	      var maxFileSize = 4194304;
	
	      if (this.props.maxSize) {
	        maxFileSize = this.props.maxSize;
	      }
	
	      if (file.length === 0) {
	
	        var dialogContent = this.props.translation.invalid;
	
	        if (this.props.fileType && this.props.fileType === 'application/pdf') {
	          dialogContent = this.props.translation.invalid_pdf;
	        }
	
	        SessionStore.showDialog(dialogContent);
	
	        this.setState({
	          dropClass: ''
	        });
	      } else {
	        file.forEach(function (file) {
	          if (file.size) {
	            size += file.size;
	          }
	        });
	      }
	
	      if (this.state.attachment.length + file.length <= 5 && size <= maxFileSize) {
	        var attachment = [].concat(_toConsumableArray(this.state.attachment.concat(file)));
	
	        this.setState({
	          attachment: attachment,
	          dropClass: ''
	        });
	
	        if (onDrop) {
	          onDrop(attachment);
	        }
	      } else {
	        var _dialogContent = this.props.translation.limit;
	
	        if (size > 4194304) {
	          _dialogContent = this.props.translation.too_large;
	        }
	
	        SessionStore.showDialog(_dialogContent);
	
	        this.setState({
	          dropClass: ''
	        });
	      }
	    }
	  }, {
	    key: 'handleDragEnter',
	    value: function handleDragEnter() {
	      this.setState({
	        dropClass: 'file-drop--drag-enter'
	      });
	    }
	  }, {
	    key: 'handleDragLeave',
	    value: function handleDragLeave() {
	      this.setState({
	        dropClass: ''
	      });
	    }
	  }, {
	    key: 'handleInputFocus',
	    value: function handleInputFocus(e) {
	      if (e.type === 'focus') {
	        e.target.parentNode.classList.add("dz-input-focus");
	      } else {
	        e.target.parentNode.classList.remove("dz-input-focus");
	      }
	    }
	  }, {
	    key: 'removeFile',
	    value: function removeFile(i) {
	      var attachment = [].concat(_toConsumableArray(this.state.attachment));
	      attachment.splice(i, 1);
	
	      this.setState({
	        attachment: attachment
	      });
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile(file, index) {
	      var ExamStore = this.props.store.ExamStore;
	
	
	      if (this.props.exception && this.props.customConfiguration.sid || !this.props.exception) {
	        ExamStore.deleteAttachments.push(file);
	      }
	
	      this.removeUploadedFile(index);
	    }
	  }, {
	    key: 'removeUploadedFile',
	    value: function removeUploadedFile(index) {
	      var _props = this.props,
	          customConfiguration = _props.customConfiguration,
	          exam = _props.exam,
	          exception = _props.exception;
	
	      var type = exam.type.toLowerCase();
	
	      if (!exception) {
	        if (type !== 'written') {
	          exam.configuration.attachments.splice(index, 1);
	        } else {
	          exam.configuration.examFiles.splice(index, 1);
	
	          console.log((0, _mobx.toJS)(exam.configuration.examFiles));
	        }
	      } else {
	        if (type !== 'written') {
	          customConfiguration.attachments.splice(index, 1);
	        } else {
	          customConfiguration.examFiles.splice(index, 1);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          maxSize = _props2.maxSize,
	          translation = _props2.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var _props3 = this.props,
	          files = _props3.files,
	          fileType = _props3.fileType,
	          single = _props3.single;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          !this.props.readonly && (this.props.single && this.state.attachment.length === 0 && (!files || files.length === 0) || !this.props.single) && _react2.default.createElement(
	            _reactDropzone2.default,
	            {
	              className: 'file-drop ' + this.state.dropClass,
	              onDrop: this.handleDrop,
	              onDragEnter: this.handleDragEnter,
	              onDragLeave: this.handleDragLeave,
	              multiple: single ? false : true,
	              accept: fileType ? fileType : 'audio/*, image/*, text/*, video/*, application/*, application/octet-stream',
	              maxSize: maxSize ? maxSize : 4194304,
	              inputProps: {
	                id: 'dz-input-file-upload',
	                className: 'dz-input',
	                onFocus: this.handleInputFocus,
	                onBlur: this.handleInputFocus
	              }
	            },
	            _react2.default.createElement(
	              'label',
	              { className: 'file-drop__label' },
	              this.props.label ? this.props.label : translation.label
	            ),
	            this.props.helper && _react2.default.createElement(
	              'span',
	              { className: 'file-drop__helper' },
	              this.props.helper
	            )
	          ),
	          (this.state.attachment.length > 0 || files && files.length > 0) && _react2.default.createElement(
	            'ul',
	            { className: 'file-drop__files' },
	            files && files.length > 0 && files.map(function (file, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  file.attachmentAwsTitle
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--remove',
	                    type: 'button',
	                    onClick: function onClick() {
	                      return _this2.deleteFile(file.attachmentAwsTitle, i);
	                    },
	                    disabled: _this2.props.readonly ? true : false
	                  },
	                  _react2.default.createElement(icons.iconMinus, null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.remove,
	                    ' ',
	                    file.name
	                  )
	                )
	              );
	            }),
	            this.state.attachment.map(function (file, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  file.name
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--remove',
	                    type: 'button',
	                    onClick: function onClick() {
	                      return _this2.removeFile(i);
	                    },
	                    disabled: _this2.props.readonly ? true : false
	                  },
	                  _react2.default.createElement(icons.iconMinus, null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.remove,
	                    ' ',
	                    file.name
	                  )
	                )
	              );
	            })
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return FileUpload;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('FileUpload')(FileUpload);

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _SessionDetail = __webpack_require__(368);
	
	var _SessionDetail2 = _interopRequireDefault(_SessionDetail);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Incidents = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Incidents, _React$Component);
	
	  function Incidents() {
	    _classCallCheck(this, Incidents);
	
	    var _this = _possibleConstructorReturn(this, (Incidents.__proto__ || Object.getPrototypeOf(Incidents)).call(this));
	
	    _this.toggleDetails = _this.toggleDetails.bind(_this);
	    _this.toggleClosed = _this.toggleClosed.bind(_this);
	    _this.getStudentName = _this.getStudentName.bind(_this);
	    _this.getSessionDate = _this.getSessionDate.bind(_this);
	    _this.closeIncident = _this.closeIncident.bind(_this);
	    return _this;
	  }
	
	  _createClass(Incidents, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        target: null,
	        closedVisible: false
	
	        // If incidents aren’t provided as a prop, get them for the exam
	      };if (!this.props.events) {
	        this.examSid = this.props.routing.location.query.eventsFor;
	        this.props.store.ExamStore.getExamEvents(this.examSid);
	      } else if (this.props.exam) {
	        this.examSid = this.props.exam.sid;
	      }
	    }
	  }, {
	    key: 'toggleDetails',
	    value: function toggleDetails(e) {
	      e.preventDefault();
	
	      var details = e.target.getAttribute('data-target');
	
	      if (this.state.target !== details) {
	        this.setState({
	          target: details
	        });
	      } else {
	        this.setState({
	          target: null
	        });
	      }
	    }
	  }, {
	    key: 'toggleClosed',
	    value: function toggleClosed() {
	      this.setState({
	        closedVisible: !this.state.closedVisible
	      });
	    }
	  }, {
	    key: 'getStudentName',
	    value: function getStudentName(event) {
	      var student = event.student;
	
	
	      return student ? (student.firstName || '') + ' ' + (student.lastName || '') : '';
	    }
	  }, {
	    key: 'getSessionDate',
	    value: function getSessionDate(event) {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (event.session && event.session.appointmentDate) {
	        var date = (0, _moment2.default)(event.session.appointmentDate);
	        return '' + _moment2.default.utc(date).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z');
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: 'closeIncident',
	    value: function closeIncident(e, examSid, event) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var callback = function callback() {
	        _this2.props.store.SessionStore.showToaster(_this2.props.translation.close_success, 'success');
	      };
	      this.props.store.ExamStore.closeExamEvent(examSid, event, callback);
	    }
	  }, {
	    key: 'showSession',
	    value: function showSession(sessionSid, session, examSid) {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      SessionStore.showModal = true;
	
	      SessionStore.modalContent = _react2.default.createElement(_SessionDetail2.default, Object.assign({}, this.props, {
	        examSid: examSid,
	        sessionSid: sessionSid,
	        modal: true,
	        hideIncidents: true
	      }));
	    }
	  }, {
	    key: 'renderIncident',
	    value: function renderIncident(incident, i, closed) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var userTimezone = SessionStore.userTimezone;
	
	
	      function incidentClass(type) {
	        if (type) {
	          if (type.toLowerCase().indexOf('noisy') > -1) {
	            return 'noisy';
	          }
	
	          if (type.toLowerCase().indexOf('ill') > -1) {
	            return 'ill';
	          }
	
	          if (type.toLowerCase().indexOf('injured') > -1) {
	            return 'injured';
	          }
	
	          if (type.toLowerCase().indexOf('time') > -1) {
	            return 'time';
	          }
	
	          if (type.toLowerCase().indexOf('space') > -1) {
	            return 'space';
	          }
	
	          if (type.toLowerCase().indexOf('technical') > -1) {
	            return 'technical';
	          }
	
	          if (type.toLowerCase().indexOf('non-permitted') > -1) {
	            return 'non-permitted-items';
	          }
	
	          if (type.toLowerCase().indexOf('help') > -1) {
	            return 'outside-help';
	          }
	        }
	
	        return 'other';
	      }
	
	      function incidentIcon(type) {
	        if (type) {
	          if (type.toLowerCase().indexOf('noisy') > -1) {
	            return _react2.default.createElement(icons.icon_noisy, null);
	          }
	
	          if (type.toLowerCase().indexOf('ill') > -1) {
	            return _react2.default.createElement(icons.icon_ill, null);
	          }
	
	          if (type.toLowerCase().indexOf('injured') > -1) {
	            return _react2.default.createElement(icons.icon_injured, null);
	          }
	
	          if (type.toLowerCase().indexOf('time') > -1) {
	            return _react2.default.createElement(icons.icon_time, null);
	          }
	
	          if (type.toLowerCase().indexOf('space') > -1) {
	            return _react2.default.createElement(icons.icon_space, null);
	          }
	
	          if (type.toLowerCase().indexOf('technical') > -1) {
	            return _react2.default.createElement(icons.icon_technical, null);
	          }
	
	          if (type.toLowerCase().indexOf('non-permitted') > -1) {
	            return _react2.default.createElement(icons.icon_non_permitted_items, null);
	          }
	
	          if (type.toLowerCase().indexOf('help') > -1) {
	            return _react2.default.createElement(icons.icon_outside_help, null);
	          }
	        }
	
	        return _react2.default.createElement(icons.icon_other, null);
	      }
	
	      return _react2.default.createElement(
	        'article',
	        {
	          key: i,
	          className: '\n          incident incident--' + incidentClass(incident.eventType.title) + '\n          ' + (incident.status.toLowerCase() === 'closed' ? 'incident--closed' : '') + '\n        '
	        },
	        _react2.default.createElement(
	          'strong',
	          { className: 'incident__title subtitle' },
	          incidentIcon(incident.eventType.title),
	          incident.subject
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'data' },
	          incident.student && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.student
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              this.getStudentName(incident)
	            )
	          ),
	          incident.eventType && incident.eventType.title && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.type
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'capitalize' },
	              incident.eventType.name
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.session_date
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              this.getSessionDate(incident)
	            )
	          ),
	          incident.session && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.session_status
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              incident.session.status
	            )
	          ),
	          !incident.session && this.props.session && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.session_status
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              this.props.session.status
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'incident__tools' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'btn--expand btn--expand-alt ' + (this.state.target === 'details' + i ? 'expanded' : ''),
	                href: '#incident-details-' + i,
	                'data-target': 'details' + i,
	                onClick: this.toggleDetails
	              },
	              this.state.target === 'details' + i && translation.less_information,
	              this.state.target !== 'details' + i && translation.more_information
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '#',
	                onClick: function onClick(e) {
	                  return _this3.closeIncident(e, _this3.examSid, incident);
	                }
	              },
	              _react2.default.createElement(icons.iconTimes, null),
	              ' ',
	              translation.close_incident
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          {
	            id: 'incident-details-' + i,
	            className: 'incident__details',
	            'data-open': this.state.target === 'details' + i
	          },
	          _react2.default.createElement(
	            'h3',
	            { className: 'incident__heading' },
	            translation.incident_information
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'incident__data' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.incident
	              ),
	              _react2.default.createElement(
	                'dl',
	                null,
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  translation.number,
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  incident.sid
	                ),
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  translation.time,
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  _moment2.default.utc(incident.eventTime).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')
	                ),
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  translation.status,
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  incident.status
	                ),
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  translation.direct_witness,
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  incident.directWitness
	                ),
	                _react2.default.createElement(
	                  'dt',
	                  { className: 'body' },
	                  translation.details,
	                  ':'
	                ),
	                _react2.default.createElement('dd', {
	                  className: 'body',
	                  dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(incident.details) }
	                }),
	                incident.potentialDamage && _react2.default.createElement(
	                  'dt',
	                  { className: 'body' },
	                  translation.potential_damage,
	                  ':'
	                ),
	                incident.potentialDamage && _react2.default.createElement(
	                  'dd',
	                  { className: 'body' },
	                  incident.potentialDamage
	                ),
	                incident.correctiveActionDetails && _react2.default.createElement(
	                  'dt',
	                  { className: 'body' },
	                  translation.corrective_action,
	                  ':'
	                ),
	                incident.correctiveActionDetails && _react2.default.createElement(
	                  'dd',
	                  { className: 'body' },
	                  incident.correctiveActionDetails
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              incident.session && incident.session.proctor && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.proctor_info
	                ),
	                _react2.default.createElement(
	                  'dl',
	                  null,
	                  _react2.default.createElement(
	                    'dt',
	                    null,
	                    translation.name,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'dd',
	                    null,
	                    incident.session.proctor.firstName || '',
	                    ' ',
	                    incident.session.proctor.lastName || ''
	                  ),
	                  _react2.default.createElement(
	                    'dt',
	                    null,
	                    translation.phone,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'dd',
	                    null,
	                    incident.session.proctor.phone
	                  ),
	                  _react2.default.createElement(
	                    'dt',
	                    null,
	                    translation.email,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'mailto:' + incident.session.proctor.email },
	                      incident.session.proctor.email
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.contact_info
	              ),
	              _react2.default.createElement(
	                'dl',
	                null,
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  translation.contact_person,
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  incident.contactPerson
	                ),
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  translation.contact_phone,
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  incident.contactPhone
	                ),
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  translation.contact_email,
	                  ':'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  incident.contactEmail
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: function onClick() {
	                return _this3.showSession(incident.examSessionSid, incident.session);
	              }
	            },
	            translation.show_session
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	      var events = [];
	
	      if (this.props.events) {
	        events = this.props.events;
	      } else {
	        events = this.props.store.ExamStore.examEvents;
	      }
	
	      var openEvents = events.filter(function (event) {
	        return event.status === 'Open';
	      });
	
	      var closedEvents = events.filter(function (event) {
	        return event.status === 'Closed';
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel__section' },
	        _react2.default.createElement(
	          'section',
	          { className: 'panel__section' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__heading' },
	            translation.open_heading
	          ),
	          openEvents.map(function (key, i) {
	            return _this4.renderIncident(key, i, false);
	          })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'panel__section ' + (this.state.closedVisible ? '' : 'hidden') },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__heading closed-heading', onClick: this.toggleClosed },
	            translation.closed_heading
	          ),
	          closedEvents.map(function (key, i) {
	            return _this4.renderIncident(key, i, true);
	          })
	        )
	      );
	    }
	  }]);
	
	  return Incidents;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Incidents')(Incidents);

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var ProctorGroupList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProctorGroupList, _React$Component);
	
	  function ProctorGroupList() {
	    _classCallCheck(this, ProctorGroupList);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (ProctorGroupList.__proto__ || Object.getPrototypeOf(ProctorGroupList)).call(this));
	
	    _this.expandGroup = _this.expandGroup.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProctorGroupList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        expanded: []
	      };
	    }
	  }, {
	    key: 'expandGroup',
	    value: function expandGroup(i) {
	      var expanded = [].concat(_toConsumableArray(this.state.expanded));
	      var thisIndex = this.state.expanded.indexOf(i);
	
	      if (thisIndex === -1) {
	        expanded.push(i);
	      } else {
	        expanded.splice(thisIndex, 1);
	      }
	
	      this.setState({
	        expanded: expanded
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          proctorGroups = _props.proctorGroups,
	          translation = _props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        proctorGroups && proctorGroups.map(function (proctorGroup, i) {
	          return _react2.default.createElement(
	            'section',
	            {
	              className: 'block block--sm ' + (_this2.props.noExpand ? 'block--scale' : ''),
	              key: proctorGroup.sid
	            },
	            !_this2.props.noExpand && _react2.default.createElement(
	              'h5',
	              {
	                className: 'block__title block__title--sm',
	                onClick: function onClick() {
	                  return _this2.expandGroup(i);
	                }
	              },
	              proctorGroup.title,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--link',
	                  onClick: function onClick() {
	                    return _this2.expandGroup(i);
	                  }
	                },
	                _this2.state.expanded.indexOf(i) === -1 && _react2.default.createElement(icons.iconChevronDown, null),
	                _this2.state.expanded.indexOf(i) > -1 && _react2.default.createElement(icons.iconChevronUp, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  'Expand'
	                )
	              )
	            ),
	            _this2.props.noExpand && _react2.default.createElement(
	              'h5',
	              {
	                className: 'block__title block__title--sm'
	              },
	              proctorGroup.title
	            ),
	            (_this2.state.expanded.indexOf(i) > -1 || _this2.props.noExpand) && proctorGroup.proctorLocationSids && proctorGroup.proctorLocationSids.length > 0 && _react2.default.createElement(
	              'p',
	              null,
	              proctorGroup.proctorLocationSids.length,
	              '\xA0',
	              proctorGroup.proctorLocationSids.length === 1 && translation.location,
	              proctorGroup.proctorLocationSids.length !== 1 && translation.locations
	            ),
	            (_this2.state.expanded.indexOf(i) > -1 || _this2.props.noExpand) && proctorGroup.proctorTypes && proctorGroup.proctorTypes.length > 0 && _react2.default.createElement(
	              'span',
	              { className: 'title' },
	              translation.types
	            ),
	            (_this2.state.expanded.indexOf(i) > -1 || _this2.props.noExpand) && _react2.default.createElement(
	              'ul',
	              null,
	              proctorGroup.proctorTypes.map(function (proctorType, j) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    className: 'truncate',
	                    key: j,
	                    title: proctorType
	                  },
	                  proctorType
	                );
	              })
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return ProctorGroupList;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProctorGroupList')(ProctorGroupList);

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProctorTypeList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProctorTypeList, _React$Component);
	
	  function ProctorTypeList() {
	    _classCallCheck(this, ProctorTypeList);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (ProctorTypeList.__proto__ || Object.getPrototypeOf(ProctorTypeList)).call(this));
	
	    _this.filterProctorTypes = _this.filterProctorTypes.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProctorTypeList, [{
	    key: 'filterProctorTypes',
	    value: function filterProctorTypes(proctorTypeSids) {
	      var proctorTypeList = this.props.store.SessionStore.proctorTypeList;
	
	
	      var proctorTypes = [];
	
	      proctorTypeList.forEach(function (parentType) {
	        parentType.subCategories.forEach(function (proctorType) {
	          if (proctorTypeSids.indexOf(proctorType.sid) > -1) {
	            proctorTypes.push(proctorType);
	          }
	        });
	      });
	
	      return proctorTypes;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var proctorTypes = this.filterProctorTypes(this.props.proctorTypes);
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'data--comma' },
	        proctorTypes.map(function (proctorType) {
	          return _react2.default.createElement(
	            'li',
	            { key: proctorType.sid },
	            proctorType.title
	          );
	        })
	      );
	    }
	  }]);
	
	  return ProctorTypeList;
	}(_react2.default.Component));
	
	exports.default = ProctorTypeList;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var ScheduleDate = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleDate, _React$Component);
	
	  function ScheduleDate() {
	    _classCallCheck(this, ScheduleDate);
	
	    var _this2 = _possibleConstructorReturn(this, (ScheduleDate.__proto__ || Object.getPrototypeOf(ScheduleDate)).call(this));
	
	    _this2.handleExamChange = _this2.handleExamChange.bind(_this2);
	    _this2.changeTime = _this2.changeTime.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ScheduleDate, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        examDate: null,
	        selectedDate: null,
	        renderCal: true
	      };
	    }
	
	    // componentWillUpdate(nextProps, nextState) {
	    //   /*
	    //     This is really hacky, but there’s a bug with Datepicker
	    //     and it was the only fix documented. Essentially, there
	    //     is a problem where the time zone isn’t necessarily taken
	    //     into account for the maxDate which caused some students
	    //     to be able to select dates that they shouldn’t have been
	    //     able to choose. Providing a selected date fixes the issue
	    //     for some reason. So this will select the end date of the
	    //     exam, then clear the selection.
	    //
	    //     Also, we don’t want this to run until the Datepicker is
	    //     actually in view (i.e. step 2 of scheduling), otherwise
	    //     the fix doesn’t work.
	    //   */
	    //   const _this = this;
	    //   const { selectedDate } = nextState;
	    //   const { step } = nextProps;
	    //   const { examConfiguration } = this.props.store.ExamStore.examSession;
	    //   const { userTimezone } = this.props.store.SessionStore;
	    //
	    //   // Make sure we’re on step 2 and check that
	    //   // no date has already been set (to avoid a loop)
	    //   if(this.props.step === 1 && step === 2 && !selectedDate) {
	    //     this.setState({
	    //       renderCal: true,
	    //       selectedDate: moment(examConfiguration.examCloseDate).subtract(30, 'minutes').subtract(examConfiguration.duration, 'minutes').tz(userTimezone)
	    //     }, function(){
	    //       _this.setState({
	    //         selectedDate: moment(examConfiguration.examCloseDate).tz(userTimezone).add(1, 'days')
	    //       });
	    //
	    //       // Check if there’s a month back button
	    //       // and click it if there is one
	    //       const monthBack = document.querySelector('.schedule-date-form .react-datepicker__navigation--previous');
	    //
	    //       if(monthBack) {
	    //         monthBack.click();
	    //       }
	    //     });
	    //   }
	    // }
	
	  }, {
	    key: 'handleExamChange',
	    value: function handleExamChange(date) {
	      var _this = this;
	      var examConfiguration = this.props.store.ExamStore.examSession.examConfiguration;
	
	
	      this.setState({
	        examDate: date,
	        selectedDate: date
	      }, function () {
	        _this.handleSubmit(examConfiguration.examOpenDate, examConfiguration.examCloseDate);
	      });
	    }
	  }, {
	    key: 'changeTime',
	    value: function changeTime() {
	      this.props.store.ScheduleStore.onlineTimeRange = this.time.value;
	    }
	  }, {
	    key: 'round',
	    value: function round(date, duration, method) {
	      return (0, _moment2.default)(Math[method](+date / +duration) * +duration);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(examOpenDate, examCloseDate) {
	      var _props = this.props,
	          combined = _props.combined,
	          hybrid = _props.hybrid,
	          proctorGroupSid = _props.proctorGroupSid,
	          store = _props.store;
	      var ProctorStore = store.ProctorStore,
	          SessionStore = store.SessionStore,
	          ScheduleStore = store.ScheduleStore;
	      var userTimezone = SessionStore.userTimezone;
	
	      // Make sure the date is after the exam start date
	
	      var chosenDate = (0, _moment2.default)(this.state.examDate);
	      var minDate = (0, _moment2.default)(examOpenDate).tz(userTimezone);
	      var maxDate = (0, _moment2.default)(examCloseDate).tz(userTimezone);
	      var timeDiff = _moment2.default.duration(chosenDate.diff(minDate)).asHours();
	      var closeDiff = _moment2.default.duration(chosenDate.diff(maxDate)).asHours();
	
	      // Round date to the nearest 15 minutes
	      minDate = this.round(minDate, _moment2.default.duration(15, 'minutes'), 'ceil');
	
	      // If the chosen date is before the exam start date, use the exam start date.
	      // This is necessary when the exam starts at a time later than 12:00 midnight
	      // since the datepicker defaults to 12:00 for dates.
	      // Also add 1 second because the API won’t accept the exact same time as the
	      // exam open date.
	      if (timeDiff <= 0) {
	        chosenDate = (0, _moment2.default)(minDate).add(1, 's');
	      }
	
	      // If the chosen date is equal to the exam end date, remove one second because
	      // the API won’t accept the exact same time as the close date.
	      if (closeDiff >= 0) {
	        chosenDate = (0, _moment2.default)(maxDate).subtract(1, 's');
	      }
	
	      // Set the chosen date in the store and re-run the get availability endpoint
	      var dateString = (0, _moment2.default)(chosenDate).format('YYYY-MM-DD HH:mm');
	      var timezoneString = (0, _moment2.default)(chosenDate).tz(userTimezone).format('Z');
	      var newDate = _moment2.default.utc(dateString + ' ' + timezoneString, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
	
	      ScheduleStore.onlineDate = newDate;
	
	      if (hybrid) {
	        var query = {
	          combined: combined,
	          //tiered: true,
	          proctorGroupSids: proctorGroupSid
	        };
	
	        ScheduleStore.getOnlineAvailability(this.props.examSid, this.props.sessionSid, query, this.props.reschedule);
	      } else if (ProctorStore.proctors[0].location.schedulingModule !== 'b-virtual') {
	        ScheduleStore.getOnlineAvailability(this.props.examSid, this.props.sessionSid);
	      } else {
	        ScheduleStore.getBVAvailability(this.props.examSid, this.props.sessionSid);
	      }
	
	      // Reset the form
	      // this.setState({
	      //   examDate: null
	      // });
	      //
	      // document.querySelector('.schedule-date-form').classList.remove('submitted');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var examConfiguration = this.props.store.ExamStore.examSession.examConfiguration;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var minDate = null;
	      var maxDate = (0, _moment2.default)(examConfiguration.examCloseDate).subtract(30, 'minutes').subtract(examConfiguration.duration, 'minutes').tz(userTimezone);
	
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      minDate = (0, _moment2.default)(examConfiguration.examOpenDate);
	      var timeDiff = _moment2.default.duration(minDate.diff(now)).asHours();
	
	      if (timeDiff < 0) {
	        minDate = now;
	      }
	
	      // Make sure the maxDate isn’t before the minDate
	      var maxDiff = _moment2.default.duration(maxDate.diff(minDate)).asMinutes();
	
	      if (maxDiff < 0) {
	        maxDate = (0, _moment2.default)(minDate).add(1, 'minutes').tz(userTimezone);
	      }
	
	      return _react2.default.createElement(
	        'form',
	        {
	          className: 'schedule-date-form',
	          onSubmit: function onSubmit(e) {
	            return (0, _helpers.checkValidity)(e, function () {
	              _this3.handleSubmit(examConfiguration.examOpenDate, examConfiguration.examCloseDate);
	            });
	          },
	          noValidate: true
	        },
	        _react2.default.createElement(
	          'ul',
	          { className: 'fields' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'lbl-required meta' },
	              translation.exam_date
	            ),
	            this.state.renderCal && _react2.default.createElement(_reactDatepicker2.default, {
	              inline: true,
	              calendarClassName: 'react-datepicker--inline',
	              selected: this.state.examDate ? (0, _moment2.default)(this.state.examDate) : null,
	              onChange: this.handleExamChange,
	              minDate: minDate,
	              maxDate: maxDate,
	              placeholderText: 'mm/dd/yyyy',
	              required: true,
	              autoComplete: 'off'
	            })
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'meta', htmlFor: 'schedule-time' },
	              translation.time
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'select' },
	              _react2.default.createElement(
	                'select',
	                {
	                  id: 'schedule-time',
	                  ref: function ref(input) {
	                    return _this3.time = input;
	                  },
	                  onChange: this.changeTime
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: '' },
	                  translation.any
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'morning' },
	                  translation.morning
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'afternoon' },
	                  translation.afternoon
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'evening' },
	                  translation.evening
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ScheduleDate;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleDate')(ScheduleDate);

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ScheduleTable = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleTable, _React$Component);
	
	  function ScheduleTable() {
	    _classCallCheck(this, ScheduleTable);
	
	    var _this2 = _possibleConstructorReturn(this, (ScheduleTable.__proto__ || Object.getPrototypeOf(ScheduleTable)).call(this));
	
	    _this2.renderFeeInformation = function (slot) {
	      var userTimezone = _this2.props.store.SessionStore.userTimezone;
	      var translation = _this2.props.translation;
	
	      var schedulingRuleInfo = [];
	
	      // If we have scheduling rules set them to our variable
	      if (slot.data && slot.data.feeInformation && slot.data.feeInformation.schedulingRuleInformation && slot.data.feeInformation.schedulingRuleInformation) {
	        schedulingRuleInfo = slot.data.feeInformation.schedulingRuleInformation;
	      }
	
	      // Don't add anything to DOM if no rules are present
	      if (schedulingRuleInfo.length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'fee_information' },
	        _react2.default.createElement(
	          'div',
	          { className: 'fee__rules' },
	          schedulingRuleInfo.map(function (item, index) {
	            return item.isShownOnSchedulingCard && _react2.default.createElement(
	              'div',
	              null,
	              index > 0 && _react2.default.createElement(
	                'b',
	                { className: 'bullet' },
	                '●'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip__label info' },
	                  item.name
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip__body', role: 'tooltip' },
	                  item.ruleDescription
	                )
	              )
	            );
	          })
	        ),
	        slot.data && slot.data.dateUntil && _react2.default.createElement(
	          'div',
	          { className: 'date__increase' },
	          (0, _moment2.default)().diff((0, _moment2.default)(slot.data.dateUntil), 'hours') < 48 && slot.data.dateUntil && _react2.default.createElement(
	            'h6',
	            { className: 'total__header' },
	            ' ',
	            (0, _moment2.default)(slot.data.dateUntil).tz(userTimezone).format('[' + translation.premiumSchedulingFeeText.increase + '] dddd [' + translation.premiumSchedulingFeeText.at + '] h:mm A z [' + translation.premiumSchedulingFeeText.to + ' ' + (0, _helpers.feeCurrencyFormatter)(slot.data.dateUntilAmount, slot.data.feeInformation.currencyCode) + '.]')
	          )
	        )
	      );
	    };
	
	    _this2.selectSlotHybrid = function (startTime, endTime, slotData) {
	      var _this2$props = _this2.props,
	          parent = _this2$props.parent,
	          setSlot = _this2$props.setSlot,
	          setStep = _this2$props.setStep,
	          step = _this2$props.step;
	
	
	      parent.setState({
	        startTime: startTime
	      });
	
	      // TODO: when the API returns the scheduling module (aka when RB is allowed in the tiering) we can no longer
	      //  hardcode the scheduling module to set slot, but grab it from the slot
	      setSlot(startTime, endTime, slotData.proctorLocationSid, 'smarter-scheduling', slotData.calendarSid, slotData.feeInformation);
	
	      setStep(null, step + 1 || 4);
	    };
	
	    _this2.selectSlot = function (startTime, endTime, proctorLocationSid, schedulingModule) {
	      // Note: We are currently pass the first
	      // proctorLocationSid from the array returned
	      // by the API for availability.
	
	      var _this2$props2 = _this2.props,
	          parent = _this2$props2.parent,
	          setSlot = _this2$props2.setSlot,
	          setStep = _this2$props2.setStep,
	          step = _this2$props2.step;
	
	
	      parent.setState({
	        startTime: startTime
	      });
	
	      setSlot(startTime, endTime, proctorLocationSid, schedulingModule);
	
	      setStep(null, step + 1 || 4);
	    };
	
	    _this2.refreshSchedule = _this2.refreshSchedule.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ScheduleTable, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	
	      this.state = {
	        time: null,
	        examSid: null,
	        key: new Date().getTime()
	      };
	
	      if (!this.props.reschedule && !this.props.skipUrl) {
	        this.setState({
	          examSid: this.props.getSid(2)
	        });
	      } else {
	        this.setState({
	          examSid: this.props.examSid
	        });
	      }
	
	      // Get availability
	      if (!ScheduleStore.onlineAvailability) {
	        var _this = this;
	
	        setTimeout(function () {
	          ScheduleStore.getOnlineAvailability(_this.state.examSid, _this.props.sessionSid, this.props.combined);
	        });
	      }
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(time) {
	      if (this.props.parent.state.time === time) {
	        return 'selected';
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: 'refreshSchedule',
	    value: function refreshSchedule() {
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	
	      ScheduleStore.getOnlineAvailability(this.state.examSid, this.props.sessionSid, this.props.combined);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var ProctorStore = store.ProctorStore,
	          ScheduleStore = store.ScheduleStore,
	          SessionStore = store.SessionStore;
	      var onlineTimeGroups = ScheduleStore.onlineTimeGroups,
	          onlineTimeRange = ScheduleStore.onlineTimeRange;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      var _this = this;
	
	      if (!SessionStore.backgroundLoading) {
	        if (onlineTimeGroups) {
	          return _react2.default.createElement(
	            'div',
	            { className: this.props.className },
	            _react2.default.createElement(
	              'p',
	              { className: 'note note--prominent' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.note.heading,
	                ' '
	              ),
	              ScheduleStore.examDuration >= 60 && _react2.default.createElement(
	                'span',
	                null,
	                translation.note.body.replace('%duration%', (0, _helpers.toHours)(ScheduleStore.examDuration, false, true, true))
	              ),
	              ScheduleStore.examDuration < 60 && _react2.default.createElement(
	                'span',
	                null,
	                translation.note.body.replace('%duration%', ScheduleStore.examDuration + ' minutes')
	              )
	            ),
	            Object.keys(onlineTimeGroups).map(function (group, i) {
	              return _react2.default.createElement(
	                'div',
	                { key: i },
	                (!onlineTimeRange && onlineTimeGroups[group].morning.length > 0 || onlineTimeRange === 'morning') && _react2.default.createElement(
	                  'section',
	                  { className: 'panel__section block' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'block__title' },
	                    translation.morning
	                  ),
	                  onlineTimeGroups[group].morning.length > 0 && _react2.default.createElement(
	                    'ul',
	                    { key: i, className: 'block-list block-list--alt' },
	                    onlineTimeGroups[group].morning.map(function (slot, j) {
	                      return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { key: j, className: 'block media--alt space__between ' + (slot.data && slot.data.feeInformation && slot.data.feeInformation.schedulingRuleInformation && slot.data.feeInformation.schedulingRuleInformation.length > 0 ? 'wrap ' : '') },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'schedule_main' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'schedule_details' },
	                              _react2.default.createElement(
	                                'h4',
	                                {
	                                  className: 'block__title--alt ' + ((0, _moment2.default)(slot.startDate).tz(userTimezone).format('H') < 5 ? 'negative--alt' : '')
	                                },
	                                (0, _moment2.default)(slot.startDate).tz(userTimezone).format('h:mma'),
	                                '\u2013',
	                                (0, _moment2.default)(slot.startDate).add(ScheduleStore.examDuration, 'minutes').tz(userTimezone).format('h:mma z'),
	                                (0, _moment2.default)(slot.startDate).tz(userTimezone).format('H') < 5 && _react2.default.createElement(
	                                  'div',
	                                  { className: 'tooltip' },
	                                  _react2.default.createElement(
	                                    'span',
	                                    { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                                    _react2.default.createElement(
	                                      'i',
	                                      { className: 'icn--title' },
	                                      _react2.default.createElement(icons.iconMoon, null)
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    'div',
	                                    { id: 'dates-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                                    translation.very_early
	                                  )
	                                )
	                              ),
	                              (0, _moment2.default)(slot.startDate).tz(userTimezone).format('dddd, MMM DD'),
	                              slot.data && slot.data.friendlyName && _react2.default.createElement(
	                                'p',
	                                null,
	                                translation.provided_by,
	                                ' ',
	                                slot.data.friendlyName
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'schedule_items' },
	                              _react2.default.createElement(
	                                'button',
	                                {
	                                  className: 'btn--outline media__action ' + _this3.statusClass(slot.startDate),
	                                  onClick: function onClick() {
	                                    if (slot.data && slot.data.tier >= 0) {
	                                      _this3.selectSlotHybrid(slot.startDate, slot.endDate, slot.data);
	                                    } else {
	                                      _this3.selectSlot(slot.startDate, slot.endDate, slot.proctorLocationSids[0].sid, slot.proctorLocationSids[0].schedulingModule);
	                                    }
	                                  }
	                                },
	                                translation.schedule
	                              ),
	                              slot.data && slot.data.tier >= 0 && _react2.default.createElement(
	                                'h6',
	                                { className: 'total__header' },
	                                translation.total,
	                                ': ',
	                                (0, _helpers.feeCurrencyFormatter)(slot.data.feeInformation.userTotal.toFixed(2), slot.data.feeInformation.currencyCode)
	                              )
	                            )
	                          )
	                        ),
	                        _this3.renderFeeInformation(slot)
	                      );
	                    })
	                  ),
	                  onlineTimeGroups[group].morning.length === 0 && _react2.default.createElement(
	                    'span',
	                    { className: 'no-results' },
	                    translation.no_slots
	                  )
	                ),
	                (!onlineTimeRange && onlineTimeGroups[group].afternoon.length > 0 || onlineTimeRange === 'afternoon') && _react2.default.createElement(
	                  'section',
	                  { className: 'panel__section block' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'block__title' },
	                    translation.afternoon
	                  ),
	                  onlineTimeGroups[group].afternoon.length > 0 && _react2.default.createElement(
	                    'ul',
	                    { key: i, className: 'block-list block-list--alt' },
	                    onlineTimeGroups[group].afternoon.map(function (slot, j) {
	                      return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { key: j, className: 'block media--alt space__between ' + (slot.data && slot.data.feeInformation && slot.data.feeInformation.schedulingRuleInformation && slot.data.feeInformation.schedulingRuleInformation.length > 0 ? 'wrap ' : '') },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'schedule_main' },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'schedule_details' },
	                              _react2.default.createElement(
	                                'h4',
	                                { className: 'block__title--alt' },
	                                (0, _moment2.default)(slot.startDate).tz(userTimezone).format('h:mma'),
	                                '\u2013',
	                                (0, _moment2.default)(slot.startDate).add(ScheduleStore.examDuration, 'minutes').tz(userTimezone).format('h:mma z')
	                              ),
	                              (0, _moment2.default)(slot.startDate).tz(userTimezone).format('dddd, MMM DD'),
	                              slot.data && slot.data.friendlyName && _react2.default.createElement(
	                                'p',
	                                null,
	                                translation.provided_by,
	                                ' ',
	                                slot.data.friendlyName
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'schedule_items' },
	                              _react2.default.createElement(
	                                'button',
	                                {
	                                  className: '\n                                    btn--outline\n                                    media__action' + _this3.statusClass(slot.startDate),
	                                  onClick: function onClick() {
	                                    if (slot.data && slot.data.tier >= 0) {
	                                      _this3.selectSlotHybrid(slot.startDate, slot.endDate, slot.data);
	                                    } else {
	                                      _this3.selectSlot(slot.startDate, slot.endDate, slot.proctorLocationSids[0].sid, slot.proctorLocationSids[0].schedulingModule);
	                                    }
	                                  }
	                                },
	                                translation.schedule
	                              ),
	                              slot.data && slot.data.tier >= 0 && _react2.default.createElement(
	                                'h6',
	                                { className: 'total__header' },
	                                translation.total,
	                                ': ',
	                                (0, _helpers.feeCurrencyFormatter)(slot.data.feeInformation.userTotal.toFixed(2), slot.data.feeInformation.currencyCode)
	                              )
	                            )
	                          )
	                        ),
	                        _this3.renderFeeInformation(slot)
	                      );
	                    })
	                  ),
	                  onlineTimeGroups[group].afternoon.length === 0 && _react2.default.createElement(
	                    'span',
	                    { className: 'no-results' },
	                    translation.no_slots
	                  )
	                ),
	                (!onlineTimeRange && onlineTimeGroups[group].evening.length > 0 || onlineTimeRange === 'evening') && _react2.default.createElement(
	                  'section',
	                  { className: 'panel__section block' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'block__title' },
	                    translation.evening
	                  ),
	                  onlineTimeGroups[group].evening.length > 0 && _react2.default.createElement(
	                    'ul',
	                    { key: i, className: 'block-list block-list--alt' },
	                    onlineTimeGroups[group].evening.map(function (slot, j) {
	                      return _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'li',
	                          { key: j, className: 'block media--alt space__between ' + (slot.data && slot.data.feeInformation && slot.data.feeInformation.schedulingRuleInformation && slot.data.feeInformation.schedulingRuleInformation.length > 0 ? 'wrap ' : '') },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'schedule_details' },
	                            _react2.default.createElement(
	                              'h4',
	                              {
	                                className: '\n                                    block__title--alt\n                                    ' + ((0, _moment2.default)(slot.startDate).tz(userTimezone).format('H') > 22 ? 'negative--alt' : '') + '\n                                  '
	                              },
	                              (0, _moment2.default)(slot.startDate).tz(userTimezone).format('h:mma'),
	                              '\u2013',
	                              (0, _moment2.default)(slot.startDate).add(ScheduleStore.examDuration, 'minutes').tz(userTimezone).format('h:mma z'),
	                              (0, _moment2.default)(slot.startDate).tz(userTimezone).format('H') > 22 && _react2.default.createElement(
	                                'div',
	                                { className: 'tooltip' },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                                  _react2.default.createElement(
	                                    'i',
	                                    { className: 'icn--title' },
	                                    _react2.default.createElement(icons.iconMoon, null)
	                                  )
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { id: 'dates-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                                  translation.very_late
	                                )
	                              )
	                            ),
	                            (0, _moment2.default)(slot.startDate).tz(userTimezone).format('dddd, MMM DD'),
	                            slot.data && slot.data.friendlyName && _react2.default.createElement(
	                              'p',
	                              null,
	                              translation.provided_by,
	                              ' ',
	                              slot.data.friendlyName
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'schedule_items' },
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                className: '\n                                  btn--outline\n                                  media__action\n                                  ' + _this3.statusClass(slot.startDate) + '\n                                ',
	                                onClick: function onClick() {
	                                  if (slot.data && slot.data.tier >= 0) {
	                                    _this3.selectSlotHybrid(slot.startDate, slot.endDate, slot.data);
	                                  } else {
	                                    _this3.selectSlot(slot.startDate, slot.endDate, slot.proctorLocationSids[0].sid, slot.proctorLocationSids[0].schedulingModule);
	                                  }
	                                }
	                              },
	                              translation.schedule
	                            ),
	                            slot.data && slot.data.tier >= 0 && _react2.default.createElement(
	                              'h6',
	                              { className: 'total__header' },
	                              translation.total,
	                              ': ',
	                              (0, _helpers.feeCurrencyFormatter)(slot.data.feeInformation.userTotal.toFixed(2), slot.data.feeInformation.currencyCode)
	                            )
	                          )
	                        ),
	                        _this3.renderFeeInformation(slot)
	                      );
	                    })
	                  ),
	                  onlineTimeGroups[group].evening.length === 0 && _react2.default.createElement(
	                    'span',
	                    { className: 'no-results' },
	                    translation.no_slots
	                  )
	                )
	              );
	            })
	          );
	        } else if (ProctorStore.proctors.length > 0 && ProctorStore.proctors[0].location.schedulingModule) {
	          if (ProctorStore.proctors[0].location.schedulingModule === 'b-virtual') {
	            return _react2.default.createElement(
	              'div',
	              { className: this.props.className },
	              _react2.default.createElement(
	                'div',
	                { className: 'panel--brief' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.chat.headline
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.chat.body
	                ),
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'btn',
	                    target: '_blank',
	                    href: 'https://spsupport.onlineproctornow.com/api/start_session.ns?issue_menu=1&id=104&customer.name=' + SessionStore.profile.firstName + '&c2cjs=1'
	                  },
	                  _react2.default.createElement(icons.iconComment, null),
	                  translation.chat.chat_button
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn--outline',
	                    onClick: this.refreshSchedule
	                  },
	                  _react2.default.createElement(icons.iconRefresh, null),
	                  translation.chat.refresh_button
	                )
	              )
	            );
	          } else {
	            return _react2.default.createElement(
	              'div',
	              { className: this.props.className },
	              _react2.default.createElement(
	                'div',
	                { className: 'panel--brief' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.no_results.headline
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.no_results.body
	                )
	              )
	            );
	          }
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: this.props.className },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel--brief' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.no_results.headline
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.no_results.body
	              )
	            )
	          );
	        }
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.className },
	          _react2.default.createElement(
	            'span',
	            { className: 'loader-bar' },
	            'Loading\u2026'
	          )
	        );
	      }
	    }
	  }]);
	
	  return ScheduleTable;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleTable')(ScheduleTable);

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _BarChart = __webpack_require__(741);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var StudentStatus = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(StudentStatus, _React$Component);
	
	  function StudentStatus() {
	    _classCallCheck(this, StudentStatus);
	
	    return _possibleConstructorReturn(this, (StudentStatus.__proto__ || Object.getPrototypeOf(StudentStatus)).apply(this, arguments));
	  }
	
	  _createClass(StudentStatus, [{
	    key: 'renderAssignmentStatus',
	    value: function renderAssignmentStatus() {
	      var _props = this.props,
	          limitedScope = _props.limitedScope,
	          summary = _props.summary,
	          translation = _props.translation;
	
	      var assignedStudents = 0;
	
	      if (limitedScope) {
	        Object.keys(summary).forEach(function (status) {
	          if (status !== 'Not Assigned') {
	            assignedStudents += summary[status];
	          }
	        });
	        return assignedStudents + ' ' + translation.students;
	      } else {
	        return translation.course_wide;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var summary = this.props.summary;
	
	
	      if (summary.hasOwnProperty('notAssigned')) {
	        delete summary.notAssigned;
	      }
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'panel__section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__heading' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            translation.heading
	          ),
	          _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'create-limited-scope-exam',
	            renderFeatureCallback: function renderFeatureCallback() {
	              return _react2.default.createElement(
	                'h2',
	                null,
	                translation.assigned_to,
	                ' ',
	                _this2.renderAssignmentStatus()
	              );
	            },
	            renderDefaultCallback: function renderDefaultCallback() {
	              return null;
	            }
	          })
	        ),
	        _react2.default.createElement(_BarChart2.default, { data: summary, title: translation.chart_title, i: this.props.i })
	      );
	    }
	  }]);
	
	  return StudentStatus;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('StudentStatus')(StudentStatus);

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	var TimeSelect = function (_React$Component) {
	  _inherits(TimeSelect, _React$Component);
	
	  function TimeSelect() {
	    _classCallCheck(this, TimeSelect);
	
	    var _this2 = _possibleConstructorReturn(this, (TimeSelect.__proto__ || Object.getPrototypeOf(TimeSelect)).call(this));
	
	    _this2.handleChange = _this2.handleChange.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(TimeSelect, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        time: (0, _helpers.extractTime)(this.props.defaultValue)
	      };
	
	      this.props.parent.setState(_defineProperty({}, this.props.stateName, (0, _helpers.extractTime)(this.props.defaultValue)));
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange() {
	      var hour = this.hour.value;
	      var minute = this.minute.value;
	      var ampm = this.ampm.value;
	
	      if (ampm === 'pm' && hour < 12) {
	        hour = parseInt(hour, 10) + 12;
	      } else if (ampm === 'am' && hour >= 12) {
	        hour = parseInt(hour, 10) - 12;
	      }
	
	      if (hour < 10 && hour.toString().length === 1) {
	        hour = '0' + hour;
	      }
	
	      var time = hour + ':' + minute;
	
	      this.fallback.value = time;
	
	      // Trigger an event on the hidden input
	      var event = null;
	
	      try {
	        event = new Event('fallback', { bubbles: true });
	      } catch (e) {
	        event = document.createEvent('Event');
	        event.initEvent('fallback', true, true);
	      }
	
	      var _this = this;
	      var _props = this.props,
	          date = _props.date,
	          handleInput = _props.handleInput,
	          name = _props.name;
	
	
	      this.fallback.addEventListener('fallback', function (e) {
	        handleInput(name, e, true, date, e.target.value);
	      });
	
	      this.fallback.dispatchEvent(event);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var importedLmsExam = this.props.store.ExamStore.importedLmsExam;
	
	      var defaultTime = (0, _helpers.extractTime)(this.props.defaultValue);
	      var defaultHr = defaultTime.split(':')[0];
	      var defaultMin = defaultTime.split(':')[1];
	      var defaultAmpm = 'am';
	
	      if (defaultHr > 11) {
	        defaultAmpm = 'pm';
	      }
	
	      if (defaultHr > 12) {
	        defaultHr = parseInt(defaultHr, 10) - 12;
	      }
	
	      if (defaultHr < 10 && defaultHr.toString().length === 1) {
	        defaultHr = '0' + defaultHr;
	      }
	
	      if (!this.props.defaultValue && Object.keys(importedLmsExam).length > 0) {
	        // This is hacky, but for some reason
	        // when importing an exam, the defaultValue
	        // comes through as null at first which causes
	        // the input to render with no default date
	        // so we’re going to check if the default value is
	        // null and if we are importing an exam. If true,
	        // we’ll return nothing so that the default value
	        // on the time input works as expected.
	        return null;
	      }
	
	      if ((0, _helpers.checkInput)('time')) {
	        // If time inputs are supported by the browser
	        return _react2.default.createElement('input', {
	          type: 'time',
	          id: this.props.id,
	          defaultValue: (0, _helpers.extractTime)(this.props.defaultValue),
	          ref: this.props.reference,
	          onChange: this.props.onChange,
	          placeholder: 'hh:mm',
	          disabled: this.props.disabled ? true : false
	        });
	      } else {
	        // Otherwise, fallback to three selects
	        return _react2.default.createElement(
	          'div',
	          { className: 'inline-wrap' },
	          _react2.default.createElement('input', {
	            type: 'text',
	            id: this.props.id,
	            className: 'inp-hidden',
	            defaultValue: this.state.time,
	            ref: function ref(input) {
	              _this3.fallback = input;
	            },
	            placeholder: 'hh:mm'
	          }),
	          _react2.default.createElement(
	            'label',
	            { className: 'select' },
	            _react2.default.createElement(
	              'select',
	              {
	                ref: function ref(input) {
	                  _this3.hour = input;
	                },
	                onChange: this.handleChange,
	                defaultValue: defaultHr,
	                disabled: this.props.disabled ? true : false
	              },
	              _react2.default.createElement(
	                'option',
	                { value: '12' },
	                '12'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '01' },
	                '1'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '02' },
	                '2'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '03' },
	                '3'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '04' },
	                '4'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '05' },
	                '5'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '06' },
	                '6'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '07' },
	                '7'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '08' },
	                '8'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '09' },
	                '9'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '10' },
	                '10'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '11' },
	                '11'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'preposition' },
	            ':'
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'select' },
	            _react2.default.createElement(
	              'select',
	              {
	                ref: function ref(input) {
	                  _this3.minute = input;
	                },
	                onChange: this.handleChange,
	                defaultValue: defaultMin,
	                disabled: this.props.disabled ? true : false
	              },
	              _react2.default.createElement(
	                'option',
	                { value: '00' },
	                '00'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '01' },
	                '01'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '02' },
	                '02'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '03' },
	                '03'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '04' },
	                '04'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '05' },
	                '05'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '06' },
	                '06'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '07' },
	                '07'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '08' },
	                '08'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '09' },
	                '09'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '10' },
	                '10'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '11' },
	                '11'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '12' },
	                '12'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '13' },
	                '13'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '14' },
	                '14'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '15' },
	                '15'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '16' },
	                '16'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '17' },
	                '17'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '18' },
	                '18'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '19' },
	                '19'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '20' },
	                '20'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '21' },
	                '21'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '22' },
	                '22'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '23' },
	                '23'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '24' },
	                '24'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '25' },
	                '25'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '26' },
	                '26'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '27' },
	                '27'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '28' },
	                '28'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '29' },
	                '29'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '30' },
	                '30'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '31' },
	                '31'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '32' },
	                '32'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '33' },
	                '33'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '34' },
	                '34'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '35' },
	                '35'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '36' },
	                '36'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '37' },
	                '37'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '38' },
	                '38'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '39' },
	                '39'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '40' },
	                '40'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '41' },
	                '41'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '42' },
	                '42'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '43' },
	                '43'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '44' },
	                '44'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '45' },
	                '45'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '46' },
	                '46'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '47' },
	                '47'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '48' },
	                '48'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '49' },
	                '49'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '50' },
	                '50'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '51' },
	                '51'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '52' },
	                '52'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '53' },
	                '53'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '54' },
	                '54'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '55' },
	                '55'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '56' },
	                '56'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '57' },
	                '57'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '58' },
	                '58'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: '59' },
	                '59'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'preposition' },
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'select' },
	            _react2.default.createElement(
	              'select',
	              {
	                ref: function ref(input) {
	                  _this3.ampm = input;
	                },
	                onChange: this.handleChange,
	                defaultValue: defaultAmpm,
	                disabled: this.props.disabled ? true : false
	              },
	              _react2.default.createElement(
	                'option',
	                { value: 'am' },
	                'AM'
	              ),
	              _react2.default.createElement(
	                'option',
	                { value: 'pm' },
	                'PM'
	              )
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return TimeSelect;
	}(_react2.default.Component);
	
	exports.default = TimeSelect;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _reactTextareaAutosize = __webpack_require__(74);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeSelect = __webpack_require__(80);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var IncidentForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(IncidentForm, _React$Component);
	
	  function IncidentForm() {
	    _classCallCheck(this, IncidentForm);
	
	    var _this = _possibleConstructorReturn(this, (IncidentForm.__proto__ || Object.getPrototypeOf(IncidentForm)).call(this));
	
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.handlePhoneInput = _this.handlePhoneInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(IncidentForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        date: null,
	        incidentData: {
	          subject: '',
	          details: '',
	          status: 'Open',
	          eventTime: null,
	          potentialDamage: '',
	          correctiveActionDetails: '',
	          directWitness: '',
	          contactPerson: '',
	          contactPhone: '',
	          contactEmail: '',
	          eventTypeSid: '',
	          eventType: {},
	          draft: true
	        }
	      };
	
	      this.props.store.ExamStore.getIncidentTypes();
	
	      // If we’re editing an incident, get its data
	      if (this.props.store.ManagerStore.incidentSid) {
	        this.props.store.ExamStore.getSingleSessionEvent(this.props.installSid, this.props.examSid, this.props.store.ManagerStore.incidentSession, this.props.store.ManagerStore.incidentSid, this);
	      }
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var incidentData = Object.assign({}, this.state.incidentData);
	
	      incidentData.subject = this.subject.value || '';
	      incidentData.details = this.details.value || '';
	      incidentData.potentialDamage = this.potentialDamage.value || '';
	      incidentData.correctiveActionDetails = this.correctiveActionDetails.value || '';
	      incidentData.directWitness = this.directWitness.value || '';
	      incidentData.contactPerson = this.contactPerson.value || '';
	      incidentData.contactEmail = this.contactEmail.value || '';
	
	      if (this.eventTypeSid) {
	        incidentData.eventTypeSid = this.eventTypeSid.value || '';
	      }
	
	      this.setState({
	        incidentData: incidentData
	      });
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, isDateField) {
	      if (isDateField) {
	        this.setState({
	          date: date
	        });
	      } else {
	        date = this.state.date;
	      }
	
	      var time = this.time.value;
	
	      var incidentData = Object.assign({}, this.state.incidentData);
	      var dateString = (0, _moment2.default)(date).format('YYYY-MM-DD HH:mm Z');
	
	      incidentData.eventTime = _moment2.default.utc(dateString + ' ' + time, 'YYYY-MM-DD Z HH:mm').toISOString();
	
	      this.setState({
	        incidentData: incidentData
	      });
	    }
	  }, {
	    key: 'handlePhoneInput',
	    value: function handlePhoneInput(e) {
	      var incidentData = Object.assign({}, this.state.incidentData);
	      incidentData.contactPhone = e;
	      this.setState({
	        incidentData: incidentData
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      if (this.props.store.ManagerStore.incidentSid) {
	        // If we’re editing an incident, update it
	        this.props.store.ExamStore.updateSessionEvent(this.props.installSid, this.props.examSid, this.props.store.ManagerStore.incidentSession, this.props.store.ManagerStore.incidentSid, this.state.incidentData, this.props.completeIncident);
	      } else {
	        // Otherwise, create a new one
	        this.props.store.ExamStore.createSessionEvent(this.props.installSid, this.props.examSid, this.props.store.ManagerStore.incidentSession, this.state.incidentData, this.props.completeIncident);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      if (!SessionStore.loading && ExamStore.incidentTypes.length > 0) {
	        return _react2.default.createElement(
	          'form',
	          { className: 'incident-form', onSubmit: function onSubmit(e) {
	              return (0, _helpers.checkValidity)(e, _this2.handleSubmit, '.incident-form');
	            }, noValidate: true },
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-subject' },
	                  translation.subject
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'incident-subject',
	                  ref: function ref(input) {
	                    _this2.subject = input;
	                  },
	                  onChange: this.handleInput,
	                  required: true,
	                  'aria-required': 'true',
	                  autoFocus: true,
	                  defaultValue: this.state.incidentData.subject
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'field--auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-type' },
	                  translation.type.label
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'select', htmlFor: 'incident-type' },
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      id: 'incident-type',
	                      ref: function ref(input) {
	                        _this2.eventTypeSid = input;
	                      },
	                      onChange: this.handleInput,
	                      required: true,
	                      'aria-required': 'true',
	                      defaultValue: this.state.incidentData.eventType.sid
	                    },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      translation.type.helper
	                    ),
	                    ExamStore.incidentTypes.map(function (key, i) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: i, value: key.sid },
	                        key.title.charAt(0).toUpperCase() + key.title.slice(1)
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'field--auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-date' },
	                  translation.date.label
	                ),
	                _react2.default.createElement(_reactDatepicker2.default, {
	                  id: 'incident-date',
	                  selected: this.state.date,
	                  onChange: function onChange(date) {
	                    _this2.handleDateChange(date, true);
	                  },
	                  placeholderText: translation.date.helper,
	                  required: true,
	                  'aria-required': 'true',
	                  ref: function ref(input) {
	                    _this2.eventTime = input;
	                  },
	                  autoComplete: 'off'
	                }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'preposition' },
	                  translation.date.at
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'select', htmlFor: 'incident-time' },
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      id: 'incident-time',
	                      ref: function ref(input) {
	                        _this2.time = input;
	                      },
	                      onChange: function onChange() {
	                        return _this2.handleDateChange(null, false);
	                      },
	                      defaultValue: _moment2.default.utc(ExamStore.incident.eventTime).local().format('HH:mm')
	                    },
	                    _react2.default.createElement(_TimeSelect2.default, null)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-optional', htmlFor: 'incident-details' },
	                  translation.details
	                ),
	                _react2.default.createElement(_reactTextareaAutosize2.default, {
	                  id: 'incident-details',
	                  className: 'textarea-grow',
	                  ref: function ref(input) {
	                    _this2.details = input;
	                  },
	                  onChange: this.handleInput,
	                  defaultValue: this.state.incidentData.details
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-optional', htmlFor: 'incident-damage', 'aria-describedby': 'damage-tooltip' },
	                  translation.potential_damage.label,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'damage-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                      translation.potential_damage.tooltip
	                    )
	                  )
	                ),
	                _react2.default.createElement(_reactTextareaAutosize2.default, {
	                  id: 'incident-damage',
	                  className: 'textarea-grow',
	                  ref: function ref(input) {
	                    _this2.potentialDamage = input;
	                  },
	                  onChange: this.handleInput,
	                  defaultValue: this.state.incidentData.potentialDamage
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-optional', htmlFor: 'incident-action' },
	                  translation.corrective_action
	                ),
	                _react2.default.createElement(_reactTextareaAutosize2.default, {
	                  id: 'incident-action',
	                  className: 'textarea-grow',
	                  ref: function ref(input) {
	                    _this2.correctiveActionDetails = input;
	                  },
	                  onChange: this.handleInput,
	                  defaultValue: this.state.incidentData.correctiveActionDetails,
	                  maxLength: '255'
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-witness', 'aria-describedby': 'witness-tooltip' },
	                  translation.direct_witness.label,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'witness-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                      translation.direct_witness.tooltip
	                    )
	                  )
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'incident-subject',
	                  ref: function ref(input) {
	                    _this2.directWitness = input;
	                  },
	                  onChange: this.handleInput,
	                  required: true,
	                  'aria-required': 'true',
	                  defaultValue: this.state.incidentData.directWitness
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-person' },
	                  translation.contact_person
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'incident-person',
	                  ref: function ref(input) {
	                    _this2.contactPerson = input;
	                  },
	                  onChange: this.handleInput,
	                  required: true,
	                  'aria-required': 'true',
	                  defaultValue: this.state.incidentData.contactPerson
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-phone' },
	                  translation.contact_phone
	                ),
	                _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                  id: 'incident-phone-tel',
	                  nativeExpanded: true,
	                  flagsPath: './static/img/flags/',
	                  country: (0, _reactPhoneNumberInput.parsePhoneNumber)(this.state.incidentData.contactPhone).country || 'US',
	                  value: this.state.incidentData.contactPhone,
	                  ref: function ref(input) {
	                    _this2.contactPhone = input;
	                  },
	                  onChange: function onChange(e) {
	                    return _this2.handlePhoneInput(e);
	                  },
	                  required: true,
	                  'aria-required': 'true',
	                  'aria-invalid': !(0, _reactPhoneNumberInput.isValidPhoneNumber)(this.state.incidentData.contactPhone)
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-email' },
	                  translation.contact_email
	                ),
	                _react2.default.createElement('input', {
	                  type: 'email',
	                  id: 'incident-email',
	                  ref: function ref(input) {
	                    _this2.contactEmail = input;
	                  },
	                  onChange: this.handleInput,
	                  required: true,
	                  'aria-required': 'true',
	                  defaultValue: this.state.incidentData.contactEmail
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', type: 'submit' },
	            translation.button
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return IncidentForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('IncidentForm')(IncidentForm);

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTabs = __webpack_require__(195);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Privacy = __webpack_require__(215);
	
	var _Privacy2 = _interopRequireDefault(_Privacy);
	
	var _ExamAttachmentsList = __webpack_require__(218);
	
	var _ExamAttachmentsList2 = _interopRequireDefault(_ExamAttachmentsList);
	
	var _FileUpload = __webpack_require__(358);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Session = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Session, _React$Component);
	
	  function Session() {
	    _classCallCheck(this, Session);
	
	    var _this2 = _possibleConstructorReturn(this, (Session.__proto__ || Object.getPrototypeOf(Session)).call(this));
	
	    _this2.showPassword = _this2.showPassword.bind(_this2);
	    _this2.minimizeSession = _this2.minimizeSession.bind(_this2);
	    _this2.closeSession = _this2.closeSession.bind(_this2);
	    _this2.closeCompletedSession = _this2.closeCompletedSession.bind(_this2);
	    _this2.handleTabs = _this2.handleTabs.bind(_this2);
	    _this2.getRoster = _this2.getRoster.bind(_this2);
	    _this2.getIncidents = _this2.getIncidents.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Session, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          ManagerStore = _props$store.ManagerStore,
	          SessionStore = _props$store.SessionStore;
	      var _props = this.props,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	      var installSid = SessionStore.userData.installSid;
	
	      var courseSid = SessionStore.courseData.sid;
	      var session = this.props.session;
	
	
	      if (!session) {
	        session = ManagerStore.session;
	      }
	
	      this.state = {
	        activeTab: 0,
	        minimize: this.props.minimize,
	        showPassword: false,
	        mmid: null,
	        mmurl: null,
	        hideUpload: false
	
	        // Get the current time
	      };SessionStore.getCurrentTime(true);
	
	      // Hide the upload field if the exam has been returned
	      if (session && session.returnedFile && session.returnedFile.file) {
	        this.setState({
	          hideUpload: true
	        });
	      }
	
	      // Get the megameeting information for B Virtual sessions
	      if (this.props.megameeting) {
	        var _props2 = this.props,
	            _installSid = _props2.installSid,
	            _examSid = _props2.examSid;
	
	        var _sessionSid = this.props.session.sid;
	
	        ManagerStore.getMMId(_installSid, _examSid, _sessionSid, this, true);
	      }
	
	      // Get the session if it isn’t in the props
	      if (!this.props.session) {
	        var callback = function callback() {
	          ManagerStore.getSessionEnrollment(installSid, courseSid, ManagerStore.session.enrollmentSid, null, ManagerStore.session);
	
	          ManagerStore.getSessionExam(installSid, courseSid, examSid, null, ManagerStore.session);
	        };
	        ManagerStore.getExamSession(installSid, examSid, sessionSid, null, null, callback);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        minimize: nextProps.minimize
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var ManagerStore = this.props.store.ManagerStore;
	
	      ManagerStore.sessions = [];
	    }
	  }, {
	    key: 'showPassword',
	    value: function showPassword() {
	      this.setState({
	        showPassword: !this.state.showPassword
	      });
	    }
	  }, {
	    key: 'minimizeSession',
	    value: function minimizeSession(accessKey) {
	      this.setState({
	        minimize: !this.state.minimize
	      });
	
	      var minimized = [].concat(_toConsumableArray(this.props.parent.state.minimized));
	
	      minimized.push(accessKey);
	
	      this.props.parent.setState({
	        minimized: minimized
	      });
	    }
	  }, {
	    key: 'closeSession',
	    value: function closeSession() {
	      var ManagerStore = this.props.store.ManagerStore;
	
	      var sessionSid = null;
	
	      if (this.props.session) {
	        sessionSid = this.props.session.sid;
	      } else {
	        sessionSid = ManagerStore.session.sid;
	      }
	
	      ManagerStore.closeExamSession(sessionSid);
	    }
	  }, {
	    key: 'confirmComplete',
	    value: function confirmComplete(installSid, examSid, sessionSid) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.complete_prompt.heading,
	        body: translation.complete_prompt.body,
	        button: translation.complete_prompt.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return _this3.completeSession(installSid, examSid, sessionSid);
	      });
	    }
	  }, {
	    key: 'completeSession',
	    value: function completeSession(installSid, examSid, sessionSid) {
	      var session = this.props.session;
	      var ManagerStore = this.props.store.ManagerStore;
	
	
	      var callback = null;
	
	      if (session.exam.type.toLowerCase() !== 'written') {
	        callback = this.closeCompletedSession;
	      } else {
	        callback = this.closeWrittenSession;
	      }
	
	      ManagerStore.completeExamSession(installSid, examSid, sessionSid, callback, this.props.session.schedulingModule);
	    }
	  }, {
	    key: 'closeCompletedSession',
	    value: function closeCompletedSession() {
	      var _props3 = this.props,
	          session = _props3.session,
	          translation = _props3.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      session.status = 'Closed';
	
	      SessionStore.showToaster(translation.session_closed, 'success');
	    }
	  }, {
	    key: 'closeWrittenSession',
	    value: function closeWrittenSession() {
	      var _props4 = this.props,
	          session = _props4.session,
	          translation = _props4.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      session.status = 'Closed';
	
	      SessionStore.showToaster(translation.session_closed, 'success');
	    }
	  }, {
	    key: 'confirmCancel',
	    value: function confirmCancel(sessionSid) {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.cancel_confirm_prompt.heading,
	        body: translation.cancel_confirm_prompt.body,
	        button: translation.cancel_confirm_prompt.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return _this4.initCancel(sessionSid);
	      });
	    }
	  }, {
	    key: 'initCancel',
	    value: function initCancel(sessionSid) {
	      var _this = this;
	      var _props5 = this.props,
	          schedulingModule = _props5.schedulingModule,
	          translation = _props5.translation;
	
	
	      var options = [{
	        label: translation.cancel_options.helper,
	        value: ''
	      }, {
	        label: translation.cancel_options.no_show,
	        value: 'no-show'
	      }, {
	        label: translation.cancel_options.changed_time,
	        value: 'changed-time'
	      }, {
	        label: translation.cancel_options.technical_issue,
	        value: 'technical-issue'
	      }, {
	        label: translation.cancel_options.other,
	        value: 'other-reason'
	      }];
	
	      var msg = {
	        heading: translation.cancel_prompt.heading,
	        options: options,
	        button: translation.cancel_prompt.button
	      };
	
	      var setReason = function setReason(memo, selectedReason) {
	        var data = {
	          cancellationMemo: memo,
	          reason: selectedReason,
	          schedulingModule: schedulingModule
	        };
	
	        _this.cancelSession(sessionSid, data);
	      };
	
	      (0, _helpers.promptUser)(msg, setReason, null);
	    }
	  }, {
	    key: 'cancelSession',
	    value: function cancelSession(sessionSid, data) {
	      var _props6 = this.props,
	          installSid = _props6.installSid,
	          session = _props6.session,
	          translation = _props6.translation;
	      var _props$store2 = this.props.store,
	          ManagerStore = _props$store2.ManagerStore,
	          SessionStore = _props$store2.SessionStore;
	
	
	      var callback = function callback() {
	        SessionStore.showToaster(translation.session_cancelled, 'success');
	        session.status = 'Cancelled';
	      };
	
	      ManagerStore.cancelExamSession(installSid, session.exam.sid, sessionSid, data, callback);
	    }
	  }, {
	    key: 'handleTabs',
	    value: function handleTabs(index) {
	      this.setState({
	        activeTab: index
	      });
	    }
	  }, {
	    key: 'permittedItems',
	    value: function permittedItems(examConfiguration) {
	      var translation = this.props.translation;
	
	      if (!examConfiguration) {
	        examConfiguration = this.props.session.examConfiguration;
	      }
	
	      var items = [{
	        item: 'Bathroom Break',
	        permitted: examConfiguration.permittedBathroomBreak,
	        notes: examConfiguration.permittedBathroomBreakInformation
	      }, {
	        item: 'Blank Paper',
	        permitted: examConfiguration.permittedBlankPaper,
	        notes: examConfiguration.permittedBlankPaperInformation
	      }, {
	        item: 'Calculator',
	        permitted: examConfiguration.permittedCalculator,
	        notes: examConfiguration.permittedCalculatorInformation
	      }, {
	        item: 'Dictionary',
	        permitted: examConfiguration.permittedDictionary,
	        notes: examConfiguration.permittedDictionaryInformation
	      }, {
	        item: 'Earplugs',
	        permitted: examConfiguration.permittedEarplugs,
	        notes: examConfiguration.permittedEarplugsInformation
	      }, {
	        item: 'Formula Sheets',
	        permitted: examConfiguration.permittedFormulaSheet,
	        notes: examConfiguration.permittedFormulaSheetInformation
	      }, {
	        item: 'Notes',
	        permitted: examConfiguration.permittedNotes,
	        notes: examConfiguration.permittedNotesInformation
	      }, {
	        item: 'Textbook',
	        permitted: examConfiguration.permittedTextbook,
	        notes: examConfiguration.permittedTextbookInformation
	      }, {
	        item: 'Websites',
	        permitted: examConfiguration.permittedWebsites,
	        notes: examConfiguration.permittedWebsitesInformation
	      }];
	
	      var permittedItems = [];
	
	      for (var i = 0; i < items.length; i++) {
	        if (items[i].permitted) {
	          var permittedItem = _react2.default.createElement('li', { key: '' + i }, _react2.default.createElement('strong', null, items[i].item + ':'), _react2.default.createElement('p', null, items[i].notes || translation.permitted_items.permitted));
	          permittedItems.push(permittedItem);
	        }
	      }
	
	      if (examConfiguration.permittedOtherItems) {
	        var _permittedItem = _react2.default.createElement('li', { key: 'other' }, _react2.default.createElement('strong', null, translation.permitted_items.other_items + ':'), _react2.default.createElement('p', null, examConfiguration.permittedOtherItems));
	        permittedItems.push(_permittedItem);
	      }
	
	      var itemList = _react2.default.createElement('ul', { className: 'data--alt' }, permittedItems);
	
	      if (permittedItems.length > 0) {
	        return itemList;
	      } else {
	        return _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            translation.none
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getRoster',
	    value: function getRoster() {
	      var query = '?limit=25&roles=instructor';
	
	      this.props.store.EnrollmentStore.getCourseRoster(query, this.props.installSid, this.props.courseSid);
	    }
	  }, {
	    key: 'getIncidents',
	    value: function getIncidents() {
	      var _props$store3 = this.props.store,
	          ExamStore = _props$store3.ExamStore,
	          ManagerStore = _props$store3.ManagerStore,
	          SessionStore = _props$store3.SessionStore;
	      ;
	      var installSid = this.props.installSid;
	      var examSid = this.props.examSid;
	
	      var sessionSid = null;
	
	      if (this.props.session) {
	        sessionSid = this.props.session.sid;
	      }
	
	      if (!installSid) {
	        installSid = SessionStore.userData.installSid;
	      }
	
	      if (!examSid) {
	        examSid = ManagerStore.session.examSid;
	      }
	
	      if (!sessionSid) {
	        sessionSid = ManagerStore.session.sid;
	      }
	
	      ExamStore.getSessionEvents(installSid, examSid, sessionSid);
	    }
	  }, {
	    key: 'reportIncident',
	    value: function reportIncident(sessionSid) {
	      var ManagerStore = this.props.store.ManagerStore;
	
	
	      ManagerStore.reportIncident = true;
	      ManagerStore.incidentSession = sessionSid;
	      ManagerStore.incidentSid = null;
	    }
	  }, {
	    key: 'editIncident',
	    value: function editIncident(sessionSid, incidentSid) {
	      var ManagerStore = this.props.store.ManagerStore;
	
	
	      ManagerStore.reportIncident = true;
	      ManagerStore.incidentSession = sessionSid;
	      ManagerStore.incidentSid = incidentSid;
	    }
	  }, {
	    key: 'deleteIncident',
	    value: function deleteIncident(incidentSid) {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	      var _props$store4 = this.props.store,
	          ManagerStore = _props$store4.ManagerStore,
	          SessionStore = _props$store4.SessionStore;
	
	      var installSid = this.props.installSid;
	      var examSid = this.props.examSid;
	
	      var sessionSid = null;
	
	      if (this.props.session) {
	        sessionSid = this.props.session.sid;
	      }
	
	      if (!installSid) {
	        installSid = SessionStore.userData.installSid;
	      }
	
	      if (!examSid) {
	        examSid = ManagerStore.session.examSid;
	      }
	
	      if (!sessionSid) {
	        sessionSid = ManagerStore.session.sid;
	      }
	
	      var msg = {
	        heading: translation.delete_incident.heading + '?',
	        body: translation.delete_incident.body,
	        button: translation.delete_incident.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return _this5.props.store.ExamStore.deleteSessionEvent(installSid, examSid, sessionSid, incidentSid);
	      });
	    }
	  }, {
	    key: 'selectUrl',
	    value: function selectUrl(e) {
	      var input = e.target;
	      input.setSelectionRange(0, 9999);
	    }
	  }, {
	    key: 'getExamFile',
	    value: function getExamFile() {
	      var ManagerStore = this.props.store.ManagerStore;
	      var _props7 = this.props,
	          session = _props7.session,
	          installSid = _props7.installSid;
	
	      var fileName = session.enrollment.firstName + ' ' + session.enrollment.lastName + ' - ' + session.exam.title;
	
	      ManagerStore.getExamFile(installSid, session.examConfiguration.sid, session.sid, fileName);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var translation = this.props.translation;
	      var _props$store5 = this.props.store,
	          EnrollmentStore = _props$store5.EnrollmentStore,
	          ExamStore = _props$store5.ExamStore,
	          ManagerStore = _props$store5.ManagerStore,
	          SessionStore = _props$store5.SessionStore;
	
	
	      var installSid = this.props.installSid;
	      var examSid = this.props.examSid;
	      var session = this.props.session;
	      var schedulingModule = this.props.schedulingModule;
	
	      // If a data isn’t provided as a prop
	      // use the data from the store
	      if (!installSid) {
	        installSid = SessionStore.userData.installSid;
	      }
	
	      if (!examSid && ManagerStore.session) {
	        examSid = ManagerStore.session.examSid;
	      }
	
	      if (!session) {
	        session = ManagerStore.session;
	      }
	
	      if (!schedulingModule && ManagerStore.session) {
	        schedulingModule = ManagerStore.session.schedulingModule;
	      }
	
	      if (!SessionStore.loading || session && session.enrollment && session.exam) {
	        var _session = session,
	            location = _session.location;
	
	        var address = location ? (location.address1 || '') + ' ' + (location.address2 || '') : '';
	
	        // Don’t use the default tab styles
	        _reactTabs.Tabs.setUseDefaultStyles(false);
	
	        // Check if session has started
	        var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	        var appointmentDate = (0, _moment2.default)(session.appointmentDate).local();
	        var appointmentDiff = _moment2.default.duration(appointmentDate.diff(now)).asHours();
	
	        return _react2.default.createElement(
	          'li',
	          { className: 'panel--medium session ' + (this.state.minimize ? 'minimized' : '') },
	          _react2.default.createElement(
	            'article',
	            null,
	            this.props.multi && _react2.default.createElement(
	              'header',
	              { className: 'panel__header session__header' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                session.accessKey
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__tools' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'minimize__btn',
	                    onClick: function onClick() {
	                      _this6.minimizeSession(session.accessKey);
	                    }
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.minimize
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'minimize__btn minimize__btn--close',
	                    onClick: this.closeSession
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.close
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'session__body' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__heading' },
	                session.enrollment.firstName,
	                '\xA0',
	                session.enrollment.lastName
	              ),
	              this.props.megameeting && _react2.default.createElement(
	                'section',
	                { className: 'note session-note' },
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'note__heading' },
	                  translation.student_url
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  value: 'https://meeting.onlineproctornow.com/guest/?id=' + this.state.mmid + '#',
	                  onFocus: function onFocus(e) {
	                    return _this6.selectUrl(e);
	                  },
	                  readOnly: true
	                }),
	                _react2.default.createElement(
	                  'a',
	                  { className: 'btn note__btn', href: this.state.mmurl, target: '_blank' },
	                  translation.open_meeting
	                )
	              ),
	              !this.props.noInteract && session.status.toLowerCase() !== 'closed' && session.status.toLowerCase() !== 'cancelled' && session.exam.type.toLowerCase() !== 'written' && appointmentDiff <= -.25 && _react2.default.createElement(
	                'section',
	                { className: 'session__section' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'meta' },
	                  translation.exam_details.heading
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'btn-group' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn btn--outline',
	                      onClick: function onClick() {
	                        return _this6.confirmComplete(installSid, examSid, session.sid);
	                      }
	                    },
	                    _react2.default.createElement(icons.iconCheck, null),
	                    translation.actions.button
	                  )
	                )
	              ),
	              session.exam.type.toLowerCase() === 'written' && session.status.toLowerCase() !== 'closed' && session.status.toLowerCase() !== 'cancelled' && session.examFile && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  href: session.examFile.attachmentUrl,
	                  onClick: function onClick() {
	                    return _this6.getExamFile();
	                  },
	                  type: 'button'
	                },
	                _react2.default.createElement(icons.iconDownload, null),
	                translation.download_exam.button
	              ),
	              !this.props.noInteract && session.exam.type.toLowerCase() === 'written' && appointmentDiff <= -.25 && _react2.default.createElement(
	                'section',
	                { className: 'session__section' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'meta' },
	                  translation.upload_exam.heading
	                ),
	                session.returnedFile && session.returnedFile.file && _react2.default.createElement(
	                  'div',
	                  { className: 'text-block text-block--push' },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      className: 'files__title',
	                      target: '_blank',
	                      href: session.returnedFile.file
	                    },
	                    _react2.default.createElement(icons.icon_pdf, null),
	                    translation.returned_file,
	                    ' (',
	                    _moment2.default.utc(session.returnedFile.createdDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma'),
	                    ')'
	                  ),
	                  this.state.hideUpload && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn--link files__new',
	                      onClick: function onClick() {
	                        return _this6.setState({ hideUpload: false });
	                      }
	                    },
	                    translation.upload_exam.new
	                  )
	                ),
	                !this.state.hideUpload && _react2.default.createElement(_FileUpload2.default, Object.assign({}, this.props, {
	                  label: translation.upload_exam.label,
	                  helper: translation.upload_exam.helper,
	                  onDrop: function onDrop(attachments) {
	                    return ManagerStore.returnFiles = attachments;
	                  },
	                  files: this.state.returnFiles,
	                  single: true,
	                  fileType: 'application/pdf',
	                  maxSize: 10000000
	                })),
	                ManagerStore.returnFiles.length > 0 && _react2.default.createElement(
	                  'div',
	                  { className: 'btn-group file__submit' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn',
	                      onClick: function onClick() {
	                        _this6.setState({ hideUpload: true, returnFiles: [] });
	                        ManagerStore.returnExam(installSid, examSid, session.sid, null, session);
	                      }
	                    },
	                    _react2.default.createElement(icons.iconUpload, null),
	                    (!session.returnedFile || !session.returnedFile.file) && translation.upload_exam.button,
	                    session.returnedFile && session.returnedFile.file && translation.upload_exam.new_button
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.Tabs,
	                {
	                  className: 'panel__tabs',
	                  onSelect: this.handleTabs
	                },
	                _react2.default.createElement(
	                  _reactTabs.TabList,
	                  { className: 'tabs-enabled' },
	                  _react2.default.createElement(
	                    _reactTabs.Tab,
	                    null,
	                    translation.tabs.exam_details
	                  ),
	                  _react2.default.createElement(
	                    _reactTabs.Tab,
	                    null,
	                    translation.tabs.location
	                  ),
	                  _react2.default.createElement(
	                    _reactTabs.Tab,
	                    null,
	                    translation.tabs.notes
	                  ),
	                  _react2.default.createElement(
	                    _reactTabs.Tab,
	                    { onClick: this.getRoster },
	                    translation.tabs.faculty
	                  ),
	                  !this.props.noInteract && _react2.default.createElement(
	                    _reactTabs.Tab,
	                    { onClick: this.getIncidents },
	                    translation.tabs.incidents
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactTabs.TabPanel,
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'meta' },
	                    translation.exam_details.heading
	                  ),
	                  _react2.default.createElement(
	                    'section',
	                    { className: 'session__section' },
	                    _react2.default.createElement(
	                      'h4',
	                      { className: 'data-heading' },
	                      translation.exam_details.heading
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'data--alt session__data' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          translation.exam_details.date,
	                          ':'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _moment2.default.utc(session.appointmentDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          translation.exam_details.duration,
	                          ':'
	                        ),
	                        session.examConfiguration.duration >= 60 && _react2.default.createElement(
	                          'p',
	                          null,
	                          (0, _helpers.toHours)(session.examConfiguration.duration, false, false, true)
	                        ),
	                        session.examConfiguration.duration < 60 && _react2.default.createElement(
	                          'p',
	                          null,
	                          session.examConfiguration.duration,
	                          ' ',
	                          translation.exam_details.minutes
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          translation.exam_details.title,
	                          ':'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          session.exam.title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          translation.exam_details.type,
	                          ':'
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          session.exam.type
	                        )
	                      ),
	                      session.exam.type.toLowerCase() !== 'written' && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'session-url' },
	                            translation.exam_details.url,
	                            ':'
	                          )
	                        ),
	                        _react2.default.createElement('input', {
	                          id: 'session-url',
	                          type: 'text',
	                          defaultValue: session.exam.url,
	                          readOnly: true,
	                          onFocus: function onFocus(e) {
	                            return e.target.setSelectionRange(0, 9999);
	                          }
	                        })
	                      ),
	                      session.exam.type.toLowerCase() !== 'written' && session.examConfiguration.password && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          translation.exam_details.password,
	                          ':'
	                        ),
	                        _react2.default.createElement(_Privacy2.default, Object.assign({
	                          className: 'faux-input faux-input--enabled',
	                          show: translation.reveal_password,
	                          hide: translation.hide_password,
	                          'private': session.examConfiguration.password
	                        }, this.props))
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'section',
	                    { className: 'session__section' },
	                    _react2.default.createElement(
	                      'h4',
	                      { className: 'data-heading' },
	                      translation.permitted_items.heading
	                    ),
	                    this.permittedItems(session.examConfiguration)
	                  ),
	                  session.examConfiguration.attachments && session.examConfiguration.attachments.length > 0 && _react2.default.createElement(
	                    'section',
	                    { className: 'session__section' },
	                    _react2.default.createElement(_ExamAttachmentsList2.default, Object.assign({
	                      parent: this,
	                      examDashboard: false
	                    }, this.props, {
	                      exam: session.exam,
	                      examConfiguration: session.examConfiguration,
	                      sessionManager: true
	                    }))
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactTabs.TabPanel,
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'meta' },
	                    translation.location_information.heading
	                  ),
	                  _react2.default.createElement(
	                    'section',
	                    { className: 'session__section' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'session-detail__location' },
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'data--alt vcard' },
	                        _react2.default.createElement(
	                          'li',
	                          null,
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            translation.location_information.address
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'adr' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'street-address' },
	                              address
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'locality' },
	                              location.place
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'region' },
	                              location.region ? ', ' + location.region : ''
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'postal-code' },
	                              ' ',
	                              location.postalCode
	                            ),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'country' },
	                              location.country
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement('img', {
	                        className: 'map--static session-detail__map',
	                        width: '400', height: '250',
	                        src: (0, _helpers.getMapUrl)(location.latitude, location.longitude),
	                        alt: 'A map of the location'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactTabs.TabPanel,
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    translation.notes.proctor_notes
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: session.examConfiguration.proctorNotes ? '' : 'empty' },
	                    session.examConfiguration.proctorNotes || 'No proctor notes provided.'
	                  ),
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    translation.notes.student_notes
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: session.examConfiguration.studentNotes ? '' : 'empty' },
	                    session.examConfiguration.studentNotes || 'No student notes provided.'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactTabs.TabPanel,
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'meta' },
	                    translation.faculty.heading
	                  ),
	                  EnrollmentStore.courseRoster.length > 0 && _react2.default.createElement(
	                    'table',
	                    null,
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'subtitle', scope: 'col' },
	                          translation.faculty.name
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'subtitle', scope: 'col' },
	                          translation.faculty.role
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'subtitle', scope: 'col' },
	                          translation.faculty.email
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      EnrollmentStore.courseRoster.map(function (key, i) {
	                        return _react2.default.createElement(
	                          'tr',
	                          { key: i },
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            key.lastName,
	                            ', ',
	                            key.firstName
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            { className: 'capitalize' },
	                            key.role
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            key.email
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  EnrollmentStore.courseRoster.length === 0 && _react2.default.createElement(
	                    'span',
	                    { className: 'no-results' },
	                    translation.faculty.no_results
	                  )
	                ),
	                !this.props.noInteract && _react2.default.createElement(
	                  _reactTabs.TabPanel,
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'meta' },
	                    translation.incidents.heading
	                  ),
	                  ExamStore.sessionEvents.length > 0 && _react2.default.createElement(
	                    'table',
	                    null,
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'subtitle', scope: 'col' },
	                          translation.incidents.type
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'subtitle', scope: 'col' },
	                          translation.incidents.subject
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          { className: 'subtitle', scope: 'col' },
	                          'Actions'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      ExamStore.sessionEvents.map(function (key, i) {
	                        return _react2.default.createElement(
	                          'tr',
	                          { key: i },
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            key.eventType.title
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            null,
	                            key.subject
	                          ),
	                          _react2.default.createElement(
	                            'td',
	                            { className: 'actions' },
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                className: 'btn--outline',
	                                onClick: function onClick() {
	                                  _this6.editIncident(session.sid, key.sid);
	                                }
	                              },
	                              _react2.default.createElement(icons.iconEdit, null),
	                              translation.incidents.edit
	                            ),
	                            _react2.default.createElement(
	                              'button',
	                              {
	                                className: 'btn--outline btn--negative',
	                                onClick: function onClick() {
	                                  _this6.deleteIncident(key.sid);
	                                }
	                              },
	                              _react2.default.createElement(icons.iconTrash, null),
	                              translation.incidents.delete
	                            )
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  ExamStore.sessionEvents.length === 0 && _react2.default.createElement(
	                    'span',
	                    { className: 'no-results' },
	                    translation.incidents.no_results
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn btn--negative',
	                      onClick: function onClick() {
	                        return _this6.reportIncident(session.sid);
	                      }
	                    },
	                    translation.incidents.report_incident
	                  )
	                )
	              ),
	              !this.props.noInteract && session.status.toLowerCase() !== 'closed' && session.status.toLowerCase() !== 'cancelled' && _react2.default.createElement(
	                'div',
	                { className: 'panel__section' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--link negative',
	                    onClick: function onClick() {
	                      return _this6.confirmCancel(session.sid);
	                    }
	                  },
	                  translation.actions.cancel_button
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Session;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Session')(Session);

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Review = __webpack_require__(374);
	
	var _Review2 = _interopRequireDefault(_Review);
	
	var _BVReview = __webpack_require__(848);
	
	var _BVReview2 = _interopRequireDefault(_BVReview);
	
	var _ExamityReview = __webpack_require__(849);
	
	var _ExamityReview2 = _interopRequireDefault(_ExamityReview);
	
	var _ProctorUReview = __webpack_require__(850);
	
	var _ProctorUReview2 = _interopRequireDefault(_ProctorUReview);
	
	var _AutomatedReview = __webpack_require__(847);
	
	var _AutomatedReview2 = _interopRequireDefault(_AutomatedReview);
	
	var _Incidents = __webpack_require__(359);
	
	var _Incidents2 = _interopRequireDefault(_Incidents);
	
	var _PermittedItems = __webpack_require__(219);
	
	var _PermittedItems2 = _interopRequireDefault(_PermittedItems);
	
	var _ExamMeta = __webpack_require__(804);
	
	var _ExamMeta2 = _interopRequireDefault(_ExamMeta);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	// import StepIn from '../VTC/StepIn';
	
	
	var SessionDetail = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionDetail, _React$Component);
	
	  function SessionDetail() {
	    _classCallCheck(this, SessionDetail);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (SessionDetail.__proto__ || Object.getPrototypeOf(SessionDetail)).call(this));
	
	    _this2.initPhoneRequest = _this2.initPhoneRequest.bind(_this2);
	    _this2.settingsRedirect = _this2.settingsRedirect.bind(_this2);
	    _this2.requestPhone = _this2.requestPhone.bind(_this2);
	    _this2.renderWithProxyPhone = _this2.renderWithProxyPhone.bind(_this2);
	    _this2.renderWithoutProxyPhone = _this2.renderWithoutProxyPhone.bind(_this2);
	    _this2.showMeta = _this2.showMeta.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(SessionDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // Get the exam sid from the URL
	      var examSid = (0, _helpers.getURLSegment)(this, 2);
	      var sessionSid = this.props.routing.location.query.session;
	
	      if (!examSid || examSid.substring(0, 2).toLowerCase() !== 'ex') {
	        examSid = this.props.examSid;
	      }
	
	      if (!examSid) {
	        examSid = this.props.routing.location.query.eventsFor;
	      }
	
	      if (!sessionSid || sessionSid.substring(0, 2).toLowerCase() !== 'es') {
	        sessionSid = this.props.sessionSid;
	      }
	
	      if (!sessionSid) {
	        (0, _helpers.closeDrawer)(null, this.props.parent);
	        this.props.routing.goBack();
	        this.props.store.SessionStore.throwError(new Error("No active session found for enrollment"));
	      }
	
	      // Get currencies
	      this.props.store.SessionStore.getCurrencies();
	
	      // If exam session is closed, get incidents
	      var _this = this;
	
	      var callback = function callback(response) {
	        _this.props.store.SessionStore.modalLoaded = true;
	
	        if (response.data.status.toLowerCase() === 'closed' || response.data.status.toLowerCase() === 'cancelled') {
	          _this.props.store.ExamStore.getSessionEvents(null, examSid, sessionSid, response.data);
	
	          if (response.data.status.toLowerCase() === 'closed') {
	            var urlData = {
	              examSid: examSid,
	              sessionSid: sessionSid
	            };
	
	            var payload = {
	              reviewStatus: true
	            };
	
	            _this.props.store.ExamStore.updateReviewStatus(urlData, payload);
	          }
	        } else if (response.data.status.toLowerCase() === 'scheduled' && response.data.schedulingModule === 'messaging') {
	          var locations = [response.data.location.sid];
	
	          _this.props.store.ProctorStore.getLocationDetails(locations);
	        }
	      };
	
	      // Get exam session
	      this.props.store.ExamStore.getExamSession(examSid, sessionSid, callback);
	
	      // Get course data
	      this.props.store.SessionStore.getCourseData(this.props.courseSid);
	
	      // Get proxy phone numbers
	      this.props.store.ExamStore.getCommProxy(examSid, sessionSid);
	
	      // Store sids in state
	      this.state = {
	        examSid: examSid,
	        sessionSid: sessionSid,
	        showAllFiles: false
	      };
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.ExamStore.resetSessionEvents();
	    }
	  }, {
	    key: 'initPhoneRequest',
	    value: function initPhoneRequest() {
	      var translation = this.props.translation;
	      var mobilePhone = this.props.store.SessionStore.profile.mobilePhone;
	
	      // Check user’s profile for mobile phone number
	
	      if (!mobilePhone) {
	        // If user doesn’t have a mobile phone number,
	        // tell them they need one and then send them
	        // to their settings page
	        (0, _helpers.confirm)(translation.phone_dialog_unavailable, this.settingsRedirect);
	      } else {
	        // Otherwise, send the API request
	        (0, _helpers.confirm)(translation.phone_dialog, this.requestPhone);
	      }
	    }
	  }, {
	    key: 'settingsRedirect',
	    value: function settingsRedirect() {
	      var _this = this;
	      var callback = function callback() {
	        _this.props.routing.push({
	          pathname: '/settings'
	        });
	      };
	
	      (0, _helpers.closeDrawer)(null, this.props.parent, null, callback);
	    }
	  }, {
	    key: 'requestPhone',
	    value: function requestPhone() {
	      this.props.store.ExamStore.createCommProxy(this.state.examSid, this.state.sessionSid);
	    }
	  }, {
	    key: 'showMeta',
	    value: function showMeta() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      var examSid = this.props.examSid;
	      var sessionSid = this.props.sessionSid;
	
	      if (!examSid) {
	        examSid = (0, _helpers.getURLSegment)(this, 2);
	      }
	
	      if (!examSid) {
	        examSid = (0, _helpers.getParam)('eventsFor', window.location.href);
	      }
	
	      if (!sessionSid) {
	        sessionSid = this.props.routing.location.query.session;
	      }
	
	      var content = _react2.default.createElement(_ExamMeta2.default, Object.assign({}, this.props, {
	        examSid: examSid,
	        sessionSid: sessionSid
	      }));
	
	      SessionStore.showModal = true;
	      SessionStore.modalSmall = true;
	      SessionStore.modalContent = content;
	    }
	
	    // Proxy phone feature flag enabled
	
	  }, {
	    key: 'renderWithProxyPhone',
	    value: function renderWithProxyPhone() {
	      var translation = this.props.translation;
	      var proxyNumbers = this.props.store.ExamStore.proxyNumbers;
	
	      var session = this.props.store.ExamStore.examSession;
	      var location = session.location,
	          proctor = session.proctor;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      var name = '';
	
	      if (location && location.accountName) {
	        name = location.accountName;
	      } else if (proctor && proctor.firstName) {
	        name = proctor.firstName;
	      }
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'data--alt' },
	        session.schedulingModule !== 'proctoru' && session.schedulingModule !== 'examity' && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            { className: 'subtitle' },
	            translation.proctor_information.name
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            name,
	            ' \xA0',
	            session.schedulingModule === 'register-blast' && SessionStore.userData.role.toLowerCase() !== 'learner' && _react2.default.createElement(
	              'button',
	              {
	                onClick: this.showMeta,
	                className: 'btn--link'
	              },
	              translation.meta
	            )
	          )
	        ),
	        session.schedulingModule === 'proctoru' && SessionStore.userData.role.toLowerCase() !== 'learner' && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            { className: 'subtitle' },
	            translation.proctor_information.platform
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'ProctorU \xA0',
	            _react2.default.createElement(
	              'button',
	              {
	                onClick: this.showMeta,
	                className: 'btn--link'
	              },
	              translation.meta
	            )
	          )
	        ),
	        session.schedulingModule === 'examity' && SessionStore.userData.role.toLowerCase() !== 'learner' && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            { className: 'subtitle' },
	            translation.proctor_information.platform
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Examity \xA0',
	            _react2.default.createElement(
	              'button',
	              {
	                onClick: this.showMeta,
	                className: 'btn--link'
	              },
	              translation.meta
	            )
	          )
	        ),
	        session.schedulingModule === 'messaging' && !proxyNumbers.proxyProctorProxyPhoneNumber && session.status.toLowerCase() !== 'closed' && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            { className: 'subtitle' },
	            translation.proctor_information.phone
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn--link',
	              onClick: this.initPhoneRequest
	            },
	            translation.proctor_information.request_phone
	          )
	        ),
	        session.schedulingModule === 'messaging' && proxyNumbers.proxyProctorProxyPhoneNumber && session.status.toLowerCase() !== 'closed' && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            { className: 'subtitle' },
	            translation.proctor_information.phone
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _reactPhoneNumberInput.formatPhoneNumber)(proxyNumbers.proxyProctorProxyPhoneNumber, 'National')
	          )
	        )
	      );
	    }
	
	    // Proxy phone feature flag disabled
	
	  }, {
	    key: 'renderWithoutProxyPhone',
	    value: function renderWithoutProxyPhone() {
	      var translation = this.props.translation;
	
	      var session = this.props.store.ExamStore.examSession;
	      var location = session.location,
	          proctor = session.proctor;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      var name = '';
	
	      if (location && location.accountName) {
	        name = location.accountName;
	      } else if (proctor && proctor.firstName) {
	        name = proctor.firstName;
	      }
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'data--alt' },
	        session.schedulingModule !== 'proctoru' && session.schedulingModule !== 'examity' && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            { className: 'subtitle' },
	            translation.proctor_information.name
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            name,
	            ' \xA0',
	            session.schedulingModule === 'register-blast' && SessionStore.userData.role.toLowerCase() !== 'learner' && _react2.default.createElement(
	              'button',
	              {
	                onClick: this.showMeta,
	                className: 'btn--link'
	              },
	              translation.meta
	            )
	          )
	        ),
	        session.schedulingModule === 'proctoru' && SessionStore.userData.role.toLowerCase() !== 'learner' && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            { className: 'subtitle' },
	            translation.proctor_information.platform
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'ProctorU \xA0',
	            _react2.default.createElement(
	              'button',
	              {
	                onClick: this.showMeta,
	                className: 'btn--link'
	              },
	              translation.meta
	            )
	          )
	        ),
	        session.schedulingModule === 'examity' && SessionStore.userData.role.toLowerCase() !== 'learner' && _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'strong',
	            { className: 'subtitle' },
	            translation.proctor_information.platform
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Examity \xA0',
	            _react2.default.createElement(
	              'button',
	              {
	                onClick: this.showMeta,
	                className: 'btn--link'
	              },
	              translation.meta
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          exam = _props.exam,
	          translation = _props.translation;
	      var workflowModule = this.props.workflowModule;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          ProctorStore = _props$store.ProctorStore;
	
	      var session = this.props.store.ExamStore.examSession;
	      var location = session.location;
	
	      // if we do not pass in the workflowModule from props, we need to get it from the location
	
	      if (!workflowModule) {
	        workflowModule = location.workflowModule;
	      }
	
	      var latitude = null;
	      var longitude = null;
	
	      if (location) {
	        latitude = location.latitude;
	        longitude = location.longitude;
	      }
	
	      var address = location ? (location.address1 || '') + ' ' + (location.address2 || '') : '';
	
	      var instructor = this.props.store.SessionStore.courseData.instructor;
	      var sessionEvents = this.props.store.ExamStore.sessionEvents;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	      var examConfiguration = session.examConfiguration;
	
	      // Check if browser supports VTC live-view
	
	      var stepInSupported = true;
	
	      if (document.querySelector('html').className.indexOf('ie-true') > -1) {
	        stepInSupported = false;
	      }
	
	      if (!SessionStore.loading || SessionStore.loading && SessionStore.loadingCalls.length === 1 && SessionStore.loadingCalls.indexOf('BVData') >= 0 || SessionStore.loading && SessionStore.loadingCalls.length === 1 && SessionStore.loadingCalls.indexOf('getSessionMeta') >= 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          !this.props.modal && _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap session-detail' },
	            session.schedulingModule === 'vtc' && session.status.toLowerCase() !== 'closed' && !stepInSupported && _react2.default.createElement(
	              'div',
	              { className: 'cta' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'cta__copy' },
	                translation.not_supported.heading
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'cta_subcopy' },
	                translation.not_supported.body
	              )
	            ),
	            session.schedulingModule === 'vtc' && session.status.toLowerCase() === 'closed' && _react2.default.createElement(_Review2.default, Object.assign({}, this.props, {
	              accessCode: session.accessKey
	            })),
	            exam && exam.type.toLowerCase() === 'written' && session.status.toLowerCase() === 'closed' && session.returnedFile && _react2.default.createElement(
	              'div',
	              { className: 'panel__files' },
	              _react2.default.createElement(
	                'section',
	                { className: 'panel__section' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__heading' },
	                  translation.returned_files.heading
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'files' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        className: 'files__title',
	                        href: session.returnedFile.file,
	                        target: '_blank'
	                      },
	                      _react2.default.createElement(icons.icon_pdf, null),
	                      _moment2.default.utc(session.returnedFile.createdDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                    )
	                  )
	                ),
	                session.returnedFile.otherFiles && session.returnedFile.otherFiles.length > 0 && _react2.default.createElement(
	                  'span',
	                  { className: 'panel__expand' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: '\n                          btn--expand\n                          ' + (this.state.showAllFiles ? 'expanded' : '') + '\n                        ',
	                      onClick: function onClick() {
	                        return _this3.setState({ showAllFiles: !_this3.state.showAllFiles });
	                      }
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      !this.state.showAllFiles && translation.returned_files.more,
	                      this.state.showAllFiles && translation.returned_files.less
	                    )
	                  ),
	                  !this.state.showAllFiles && translation.returned_files.more,
	                  this.state.showAllFiles && translation.returned_files.less
	                ),
	                this.state.showAllFiles && _react2.default.createElement(
	                  'ul',
	                  { className: 'files' },
	                  session.returnedFile.otherFiles.map(function (file, i) {
	                    return _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        {
	                          className: 'files__title',
	                          href: file.file,
	                          target: '_blank'
	                        },
	                        _react2.default.createElement(icons.icon_pdf, null),
	                        _moment2.default.utc(file.createdDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            session.schedulingModule !== 'automated' && workflowModule !== 'hybrid-scheduling' && _react2.default.createElement(
	              'section',
	              {
	                className: 'panel__section ' + (session.schedulingModule !== 'vtc' ? 'panel__section--half' : '')
	              },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__heading' },
	                translation.general_information.heading
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'data--alt' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.general_information.status
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    session.status
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.general_information.exam_type
	                  ),
	                  exam.type && _react2.default.createElement(
	                    'p',
	                    { className: 'capitalize' },
	                    exam.type === ("Online" || "Live Online") ? translation.general_information.online_exam : exam.type
	                  ),
	                  session.schedulingModule === 'vtc' && _react2.default.createElement(
	                    'p',
	                    { className: 'capitalize' },
	                    'Virtual Testing Center'
	                  )
	                ),
	                session.schedulingModule !== 'vtc' && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.general_information.appointment_date
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _moment2.default.utc(session.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    {
	                      className: 'subtitle'
	                    },
	                    translation.general_information.duration
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    (0, _helpers.toHours)(examConfiguration.duration, false, false, true)
	                  )
	                ),
	                _react2.default.createElement(_PermittedItems2.default, Object.assign({
	                  configuration: examConfiguration,
	                  listItem: true
	                }, this.props))
	              )
	            ),
	            session.schedulingModule !== 'vtc' && session.schedulingModule !== 'automated' && workflowModule !== 'hybrid-scheduling' && _react2.default.createElement(
	              'section',
	              { className: 'panel__section panel__section--half' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__heading' },
	                translation.proctor_information.heading
	              ),
	              session.schedulingModule !== 'instructor-as-proctor' && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: 'proxy-phone-number',
	                renderFeatureCallback: this.renderWithProxyPhone,
	                renderDefaultCallback: this.renderWithoutProxyPhone
	              }),
	              session.schedulingModule === 'instructor-as-proctor' && typeof instructor !== 'undefined' && _react2.default.createElement(
	                'ul',
	                { className: 'data--alt' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.proctor_information.name
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    instructor.firstName,
	                    ' ',
	                    instructor.lastName,
	                    ' (',
	                    translation.instructor,
	                    ')'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.proctor_information.email
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    instructor.email
	                  )
	                )
	              )
	            ),
	            (session.schedulingModule === 'automated' || workflowModule === 'hybrid-scheduling' || workflowModule === 'hybrid') && (session.status.toLowerCase() === 'closed' || session.status.toLowerCase() === 'cancelled' || session.status.toLowerCase() === 'in progress' || session.status.toLowerCase() === 'onboarding' || session.status.toLowerCase() === 'disconnected') && _react2.default.createElement(_AutomatedReview2.default, Object.assign({}, this.props, {
	              examSid: this.state.examSid,
	              sessionSid: this.state.sessionSid
	            })),
	            session.schedulingModule === 'examity' && session.status.toLowerCase() === 'closed' && _react2.default.createElement(_ExamityReview2.default, Object.assign({}, this.props, {
	              sessionSid: this.state.sessionSid,
	              examSid: this.state.examSid
	            })),
	            session.schedulingModule === 'proctoru' && session.status.toLowerCase() === 'closed' && _react2.default.createElement(_ProctorUReview2.default, Object.assign({}, this.props, {
	              sessionSid: this.state.sessionSid,
	              examSid: this.state.examSid
	            })),
	            session.schedulingModule === 'b-virtual' && (session.status.toLowerCase() === 'closed' || session.status.toLowerCase() === 'cancelled') && _react2.default.createElement(_BVReview2.default, Object.assign({}, this.props, {
	              sessionSid: this.state.sessionSid,
	              examSid: this.state.examSid
	            })),
	            sessionEvents.length > 0 && SessionStore.userData.role.toLowerCase() !== 'learner' && session.schedulingModule !== 'vtc' && !this.props.hideIncidents && _react2.default.createElement(_Incidents2.default, Object.assign({
	              events: sessionEvents,
	              session: session,
	              embedded: true
	            }, this.props)),
	            session.schedulingModule !== 'automated' && session.schedulingModule !== 'vtc' && session.schedulingModule !== 'examity' && session.schedulingModule !== 'proctoru' && workflowModule !== 'hybrid-scheduling' && _react2.default.createElement(
	              'section',
	              { className: 'panel__section session-detail__location' },
	              session.schedulingModule !== 'b-virtual' && _react2.default.createElement(
	                'h2',
	                { className: 'panel__heading' },
	                translation.location_information.heading
	              ),
	              session.schedulingModule !== 'instructor-as-proctor' && session.schedulingModule !== 'b-virtual' && _react2.default.createElement('img', {
	                className: 'map--static session-detail__map',
	                width: '400', height: '250',
	                src: (0, _helpers.getMapUrl)(latitude, longitude),
	                alt: 'A map of the location' }),
	              session.schedulingModule !== 'instructor-as-proctor' && session.schedulingModule !== 'b-virtual' && location && _react2.default.createElement(
	                'ul',
	                { className: 'data--alt vcard' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.location_information.address
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'adr' },
	                    ProctorStore.proctorLocation && ProctorStore.proctorLocation.location && _react2.default.createElement(
	                      'span',
	                      null,
	                      ProctorStore.proctorLocation.location.name
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'street-address' },
	                      address
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'locality' },
	                      location.place
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'region' },
	                      location.region ? ', ' + location.region : ''
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'postal-code' },
	                      location.postalCode
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'country' },
	                      location.country
	                    )
	                  )
	                ),
	                ProctorStore.proctorLocation && ProctorStore.proctorLocation.location && ProctorStore.proctorLocation.location.parkingInformation && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.location_information.parking
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    ProctorStore.proctorLocation.location.parkingInformation
	                  )
	                )
	              ),
	              session.schedulingModule === 'instructor-as-proctor' && _react2.default.createElement(
	                'ul',
	                { className: 'data--alt vcard' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.location_information.address
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'adr' },
	                    session.location.address1
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SessionDetail;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionDetail')(SessionDetail);

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _ExamDetails = __webpack_require__(79);
	
	var _ExamDetails2 = _interopRequireDefault(_ExamDetails);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var AutomatedExamCard = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AutomatedExamCard, _React$Component);
	
	  function AutomatedExamCard() {
	    _classCallCheck(this, AutomatedExamCard);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (AutomatedExamCard.__proto__ || Object.getPrototypeOf(AutomatedExamCard)).call(this));
	
	    _this.messageInstructor = _this.messageInstructor.bind(_this);
	    return _this;
	  }
	
	  _createClass(AutomatedExamCard, [{
	    key: 'messageInstructor',
	    value: function messageInstructor(sid) {
	      this.props.parent.setState({
	        examSid: sid,
	        messageSid: null
	      });
	
	      (0, _helpers.toggleDrawer)(null, this.props.parent, 'MessageThread');
	    }
	  }, {
	    key: 'startButton',
	    value: function startButton(exam, examSession, examConfiguration, retake) {
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation,
	          schedulingClosed = _props.schedulingClosed;
	      var ScheduleStore = store.ScheduleStore;
	
	      var url = '/#/schedule-automated/exam/' + exam.sid + '/session/' + examSession.sid + '/configuration/' + examConfiguration.sid + (schedulingClosed ? '/scheduleClosed' : '');
	
	      if (!retake) {
	        return _react2.default.createElement(
	          'a',
	          {
	            className: 'btn btn--success btn--icn-right ',
	            href: url,
	            rel: 'opener'
	          },
	          translation.start,
	          _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	        );
	      } else {
	        return _react2.default.createElement(
	          'a',
	          {
	            className: 'btn btn--success btn--icn-right ',
	            href: url,
	            rel: 'opener',
	            onClick: function onClick(e) {
	              e.preventDefault();
	
	              ScheduleStore.retakeSession(exam.sid, examSession.sid, url);
	            }
	          },
	          translation.retake,
	          _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          exam = _props2.exam,
	          store = _props2.store,
	          translation = _props2.translation,
	          schedulingClosed = _props2.schedulingClosed;
	      var examSession = exam.examSession;
	      var examConfiguration = examSession.examConfiguration;
	      var attemptsRemaining = examConfiguration.attemptsRemaining;
	      var SessionStore = store.SessionStore;
	      var userTimezone = SessionStore.userTimezone;
	
	
	      var status = void 0;
	
	      if (examSession) {
	        status = examSession.status.toLowerCase();
	      }
	
	      var now = (0, _moment2.default)(SessionStore.currentTime);
	      var examOpenDate = (0, _moment2.default)(examConfiguration.examOpenDate);
	      var openDateFormatted = _moment2.default.utc(examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z');
	      var examCloseDate = (0, _moment2.default)(examConfiguration.examCloseDate);
	      var closeDateFormatted = _moment2.default.utc(examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z');
	
	      var examOpen = false;
	      var examClosed = false;
	
	      // Check if the exam is open
	      if (_moment2.default.duration(examOpenDate.diff(now)).asMinutes() <= 0) {
	        examOpen = true;
	      }
	
	      // Check if the exam is closed
	      if (_moment2.default.duration(examCloseDate.diff(now)).asMinutes() <= 0) {
	        examClosed = true;
	      }
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'panel' },
	        _react2.default.createElement(
	          'header',
	          {
	            className: 'panel__header' + (status === 'closed' || status === 'processing' ? ' panel__header--closed' : ' panel__header--ready')
	          },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'i',
	              { className: 'panel__icn' },
	              _react2.default.createElement(icons.iconLaptop, null)
	            ),
	            exam.title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          (status === 'closed' || status === 'processing') && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.completed.heading
	            ),
	            attemptsRemaining > 0 && !examClosed && _react2.default.createElement(
	              'span',
	              { className: 'cta__subcopy' },
	              attemptsRemaining === 1 ? translation.completed.attempt : translation.completed.attempts.replace('%attemptCount%', attemptsRemaining)
	            ),
	            attemptsRemaining > 0 && !examClosed && this.startButton(exam, examSession, examConfiguration, true),
	            attemptsRemaining === 0 && _react2.default.createElement(
	              'span',
	              { className: 'cta__subcopy' },
	              translation.completed.no_attempts
	            )
	          ),
	          (!examOpen || !examConfiguration.approved) && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.not_open.heading
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'cta__subcopy' },
	              translation.not_open.body.replace('%openDate%', openDateFormatted).replace('%closeDate%', closeDateFormatted)
	            )
	          ),
	          examClosed && status !== 'closed' && status !== 'processing' && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.closed.heading
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'cta__subcopy' },
	              translation.closed.body
	            )
	          ),
	          examOpen && !examClosed && status !== 'closed' && status !== 'processing' && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              '' + (schedulingClosed ? translation.open.scheduling_closed.replace('%closeDate%', closeDateFormatted) : translation.open.heading.replace('%closeDate%', closeDateFormatted))
	            ),
	            (attemptsRemaining > 0 || status === 'scheduled') && _react2.default.createElement(
	              'span',
	              { className: 'cta__subcopy' },
	              translation.open.body
	            ),
	            attemptsRemaining === 0 && status !== 'scheduled' && _react2.default.createElement(
	              'span',
	              { className: 'cta__subcopy' },
	              translation.completed.no_attempts
	            ),
	            (attemptsRemaining > 0 || status === 'scheduled') && this.startButton(exam, examSession, examConfiguration)
	          ),
	          examConfiguration.approved && status !== 'closed' && status !== 'processing' && _react2.default.createElement(_ExamDetails2.default, Object.assign({}, this.props, {
	            hideType: true,
	            hideDates: true
	          }))
	        )
	      );
	    }
	  }]);
	
	  return AutomatedExamCard;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AutomatedExamCard')(AutomatedExamCard);

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var ExamityRequirements = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamityRequirements, _React$Component);
	
	  function ExamityRequirements() {
	    _classCallCheck(this, ExamityRequirements);
	
	    return _possibleConstructorReturn(this, (ExamityRequirements.__proto__ || Object.getPrototypeOf(ExamityRequirements)).apply(this, arguments));
	  }
	
	  _createClass(ExamityRequirements, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'text-block' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          translation.chromebook_warning
	        )
	      );
	    }
	  }]);
	
	  return ExamityRequirements;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamityRequirements')(ExamityRequirements);

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var ProctorURequirements = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProctorURequirements, _React$Component);
	
	  function ProctorURequirements() {
	    _classCallCheck(this, ProctorURequirements);
	
	    return _possibleConstructorReturn(this, (ProctorURequirements.__proto__ || Object.getPrototypeOf(ProctorURequirements)).apply(this, arguments));
	  }
	
	  _createClass(ProctorURequirements, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'text-block' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            translation.heading
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.chromebook_warning
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://guardian.meazurelearning.com',
	                target: '_blank'
	              },
	              translation.extension
	            )
	          ),
	          translation.requirements.map(function (requirement, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              requirement
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            translation.record_reminder
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://test-it-out.proctoru.com/',
	              target: '_blank'
	            },
	            translation.test
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProctorURequirements;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProctorURequirements')(ProctorURequirements);

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _helpers = __webpack_require__(5);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Pricing = __webpack_require__(123);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	var _Payments = __webpack_require__(99);
	
	var _Payments2 = _interopRequireDefault(_Payments);
	
	var _SessionStartAutomated = __webpack_require__(220);
	
	var _SessionStartAutomated2 = _interopRequireDefault(_SessionStartAutomated);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Helpers
	
	
	// Components
	
	
	var ScheduleAutomated = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleAutomated, _React$Component);
	
	  function ScheduleAutomated() {
	    _classCallCheck(this, ScheduleAutomated);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (ScheduleAutomated.__proto__ || Object.getPrototypeOf(ScheduleAutomated)).call(this));
	
	    _this2.renderStart = function (hybrid) {
	      var exam = _this2.props.store.ExamStore.exam;
	
	
	      return _react2.default.createElement(_SessionStartAutomated2.default, Object.assign({}, _this2.props, {
	        exam: exam,
	        hybrid: hybrid
	      }));
	    };
	
	    _this2.setFees = _this2.setFees.bind(_this2);
	    _this2.renderPricingButton = _this2.renderPricingButton.bind(_this2);
	    _this2.submitSchedule = _this2.submitSchedule.bind(_this2);
	    _this2.showConfirmation = _this2.showConfirmation.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ScheduleAutomated, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      var _props = this.props,
	          automatedOnly = _props.automatedOnly,
	          store = _props.store,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	      var PaymentStore = store.PaymentStore,
	          ProctorStore = store.ProctorStore,
	          SessionStore = store.SessionStore;
	      var installSid = SessionStore.userData.installSid;
	
	      // If this is an automated-only session, hide the header and footer
	      // because the scheduling flow is in its own tab
	
	      if (automatedOnly) {
	        SessionStore.hideHeader = true;
	        SessionStore.hideFooter = true;
	      }
	
	      this.state = {
	        fees: null,
	        voucherCode: null,
	        accessCode: null,
	        examUrl: ''
	      };
	
	      if (this.props.status.toLowerCase() !== 'scheduled') {
	        this.setState({
	          step: 1
	        });
	      } else {
	        this.setState({
	          step: 4
	        });
	      }
	
	      if (this.props.accessCode) {
	        this.setState({
	          accessCode: this.props.accessCode
	        });
	      }
	
	      (0, _helpers.openExamDirect)(installSid, examSid, sessionSid).then(function (response) {
	        return _this3.setState({ examUrl: response.redirectUrl });
	      });
	
	      // Set payment callback
	      PaymentStore.setAfterPayment(function (event) {
	        return _this3.nextStep(event);
	      });
	
	      // Get the pricing data
	      var _this = this;
	      setTimeout(function () {
	        var query = '?proctorLocationSids=' + _this.props.proctorLocationSid + '&examSessionSid=' + _this.props.sessionSid;
	
	        ProctorStore.searchProctors(query, _this.setFees, null);
	      });
	
	      this.props.store.SessionStore.getCurrentTime();
	    }
	  }, {
	    key: 'setFees',
	    value: function setFees(i, data) {
	      this.setState({
	        fees: data[0].fees
	      });
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      var _props2 = this.props,
	          automatedOnly = _props2.automatedOnly,
	          setClosePath = _props2.setClosePath;
	
	
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      }, function () {
	        if (!automatedOnly) {
	          setClosePath('/');
	        }
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'renderPricingButton',
	    value: function renderPricingButton() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	
	      if (this.state.fees) {
	        if (this.state.fees.userTotal > 0) {
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: function onClick(e) {
	                _this4.nextStep(e);
	              }
	            },
	            translation.next
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'submitSchedule',
	    value: function submitSchedule() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          store = _props3.store,
	          proctorTypeSubCategorySid = _props3.proctorTypeSubCategorySid;
	      var ExamStore = store.ExamStore,
	          ScheduleStore = store.ScheduleStore;
	
	
	      var data = {
	        amount: this.state.fees.userTotal,
	        currency: this.state.fees.currencyCode,
	        type: 'automated',
	        appointmentDateTime: (0, _moment2.default)(ExamStore.examSession.examConfiguration.examCloseDate).subtract(1, 'minutes').toISOString(),
	        proctorLocationSid: this.props.proctorLocationSid,
	        proctorTypeSubCategorySid: proctorTypeSubCategorySid
	      };
	
	      if (!this.state.scheduleSubmitted) {
	        this.setState({
	          scheduleSubmitted: true
	        }, function () {
	          ScheduleStore.createAppointment(_this5.props.examSid, _this5.props.sessionSid, data, _this5.showConfirmation);
	        });
	      }
	    }
	  }, {
	    key: 'showConfirmation',
	    value: function showConfirmation(response) {
	      this.setStep(null, 4);
	
	      this.setState({
	        accessCode: response.data.accessKey
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      var examOpen = true;
	
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      var openDate = (0, _moment2.default)(ExamStore.examSession.examConfiguration.examOpenDate);
	      var openDiff = _moment2.default.duration(openDate.diff(now)).asHours();
	
	      if (openDiff >= 0) {
	        examOpen = false;
	      }
	
	      if (!SessionStore.backgroundLoading && this.state.step !== 5) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief ' + this.statusClass(1) },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.requirements.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.requirements.body_pre
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.requirements.body_post
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              translation.requirements.requirement_list.map(function (requirement, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  requirement
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                onClick: function onClick(e) {
	                  _this6.nextStep(e);
	                }
	              },
	              _react2.default.createElement(icons.iconCalendarPlus, null),
	              translation.requirements.button
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief ' + this.statusClass(2) },
	            this.state.fees && this.state.fees.userTotal !== 0 && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Pricing2.default, Object.assign({ fees: this.state.fees, scheduler: this }, this.props)),
	              this.renderPricingButton(),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition--vertical' },
	                translation.pricing.or
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--link',
	                  onClick: function onClick(e) {
	                    _this6.prevStep(e);
	                  }
	                },
	                translation.go_back
	              )
	            ),
	            this.state.fees && this.state.fees.userTotal === 0 && _react2.default.createElement(
	              'div',
	              null,
	              this.state.step === 2 && this.submitSchedule(),
	              _react2.default.createElement(
	                'span',
	                { className: 'loader-bar' },
	                'Loading\u2026'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief ' + this.statusClass(3) },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.payment.heading
	            ),
	            _react2.default.createElement(_Payments2.default, Object.assign({ submit: this.submitSchedule }, this.props))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief ' + this.statusClass(4) },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.confirmed.heading
	            ),
	            examOpen && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirmed.body_open
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actions panel__actions' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'btn actions__btn',
	                    target: '_top',
	                    rel: 'opener',
	                    href: this.state.examUrl
	                  },
	                  translation.confirmed.start_now
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    className: 'btn btn--outline actions__btn',
	                    to: '/',
	                    onClick: function onClick() {
	                      SessionStore.hideDrawerClose = false;
	                    }
	                  },
	                  translation.confirmed.start_later
	                )
	              )
	            ),
	            !examOpen && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirmed.body_closed
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  className: 'btn--link',
	                  to: '/',
	                  onClick: function onClick() {
	                    SessionStore.hideDrawerClose = false;
	                  }
	                },
	                translation.confirmed.dashboard
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'btn--link',
	                to: '/',
	                onClick: function onClick() {
	                  SessionStore.hideDrawerClose = false;
	                }
	              },
	              translation.confirmed.button
	            )
	          )
	        );
	      } else if (this.state.step === 5) {
	        return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	          flagKey: 'hybrid',
	          renderFeatureCallback: this.renderStart,
	          renderDefaultCallback: this.renderStart
	        });
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScheduleAutomated;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleAutomated')(ScheduleAutomated);

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTextareaAutosize = __webpack_require__(74);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _platform = __webpack_require__(1039);
	
	var _platform2 = _interopRequireDefault(_platform);
	
	var _logrocket = __webpack_require__(111);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// import Dropzone from 'react-dropzone';
	
	// Components
	// import * as icons from '../Icons/Icons';
	
	var TicketForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(TicketForm, _React$Component);
	
	  function TicketForm() {
	    _classCallCheck(this, TicketForm);
	
	    // this.handleDrop = this.handleDrop.bind(this);
	    // this.handleDragEnter = this.handleDragEnter.bind(this);
	    // this.handleDragLeave = this.handleDragLeave.bind(this);
	    // this.removeFile = this.removeFile.bind(this);
	    var _this = _possibleConstructorReturn(this, (TicketForm.__proto__ || Object.getPrototypeOf(TicketForm)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    _this.resolve = _this.resolve.bind(_this);
	    return _this;
	  }
	
	  _createClass(TicketForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        attachment: [],
	        dropClass: '',
	        status: 'open',
	        body: '',
	        formClass: '',
	        logRocketUrl: null
	      };
	
	      if (this.props.newTicket) {
	        if (this.props.store.SessionStore.userData.role.toLowerCase() !== 'administrator') {
	          this.props.store.CourseStore.getExams(null, true);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (SessionStore.logRocketInit) {
	        _logrocket2.default.getSessionURL(function (sessionUrl) {
	          _this2.setState({
	            logRocketUrl: sessionUrl
	          });
	        });
	      }
	    }
	
	    // handleDrop(file) {
	    //   let attachment = [...this.state.attachment.concat(file)];
	    //
	    //   console.log(file);
	    //
	    //   this.setState({
	    //     attachment,
	    //     dropClass: ''
	    //   });
	    // }
	    //
	    // handleDragEnter() {
	    //   this.setState({
	    //     dropClass: 'file-drop--drag-enter'
	    //   });
	    // }
	    //
	    // handleDragLeave() {
	    //   this.setState({
	    //     dropClass: ''
	    //   });
	    // }
	    //
	    // removeFile(i) {
	    //   let attachment = [...this.state.attachment];
	    //   attachment.splice(i, 1);
	    //
	    //   this.setState({
	    //     attachment
	    //   })
	    // }
	
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          TicketStore = _props$store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	
	
	      var data = null;
	
	      if (this.props.newTicket) {
	        data = {
	          subject: this.subject.value,
	          details: this.comment.value,
	          enrollmentSid: SessionStore.userData.enrollmentSid,
	          browserInformation: _platform2.default.toString(),
	          domain: window.location.host
	        };
	
	        if (this.examSid) {
	          data.examSid = this.examSid.value;
	        }
	
	        if (this.state.logRocketUrl && this.state.logRocketUrl.indexOf('http') > -1) {
	          data.clientSessionUrl = this.state.logRocketUrl;
	        }
	
	        TicketStore.postTicket(data, this.complete);
	      } else {
	        data = {
	          body: this.comment.value,
	          userSid: SessionStore.userData.userSid
	        };
	
	        this.comment.value = '';
	
	        this.setState({
	          formClass: 'form-sending'
	        });
	
	        TicketStore.postReply(activeTicket.sid, data, this.complete);
	      }
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      if (this.props.newTicket) {
	        var segment1 = (0, _helpers.getURLSegment)(this, 1);
	
	        (0, _helpers.closeDrawer)(null, this.props.parent, segment1);
	
	        this.props.store.SessionStore.showToaster(this.props.translation.ticket_submitted, 'success');
	      } else {
	        this.setState({
	          formClass: ''
	        });
	
	        // Remove any errors
	        var form = document.querySelector('.reply__form');
	        var fieldset = form.querySelector('fieldset');
	        var error = form.querySelector('.note--error');
	        form.classList.remove('submitted');
	        if (error) {
	          fieldset.removeChild(error);
	        }
	      }
	    }
	  }, {
	    key: 'resolve',
	    value: function resolve(e) {
	      e.preventDefault();
	
	      var TicketStore = this.props.store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	
	
	      TicketStore.updateTicket(activeTicket.sid, 'Resolved');
	
	      if (typeof this.comment !== 'undefined' && this.comment.value) {
	        this.handleSubmit(e);
	      }
	    }
	  }, {
	    key: 'reopen',
	    value: function reopen(e) {
	      e.preventDefault();
	
	      var TicketStore = this.props.store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	
	
	      TicketStore.updateTicket(activeTicket.sid, 'Open');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          activeTicket = _props.activeTicket,
	          newTicket = _props.newTicket,
	          store = _props.store,
	          translation = _props.translation;
	      var exams = store.CourseStore.exams;
	
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'reply__form ' + this.state.formClass, onSubmit: function onSubmit(e) {
	            return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	          }, noValidate: true },
	        (newTicket || typeof activeTicket !== 'undefined' && activeTicket.status.toLowerCase() !== 'closed' && activeTicket.status.toLowerCase() !== 'resolved') && _react2.default.createElement(
	          'div',
	          { className: 'panel--medium' },
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              newTicket && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'ticket-subject' },
	                  translation.subject.label
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'ticket-subject',
	                  placeholder: translation.subject.helper,
	                  ref: function ref(input) {
	                    _this3.subject = input;
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                })
	              ),
	              newTicket && exams.length > 0 && _react2.default.createElement(
	                'li',
	                { className: 'field--auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-optional', htmlFor: 'ticket-exam' },
	                  translation.exam.label
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'select', htmlFor: 'ticket-exam' },
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      ref: function ref(input) {
	                        _this3.examSid = input;
	                      }
	                    },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      translation.exam.helper
	                    ),
	                    exams.map(function (key, i) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: i, value: key.sid },
	                        key.title
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'ticket-comment' },
	                  translation.comments.label
	                ),
	                _react2.default.createElement(_reactTextareaAutosize2.default, {
	                  id: 'ticket-comment',
	                  className: 'textarea-grow',
	                  placeholder: translation.comments.helper,
	                  ref: function ref(input) {
	                    _this3.comment = input;
	                  },
	                  onChange: this.handleInput,
	                  required: true,
	                  'aria-required': 'true'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'em',
	            { className: 'form-note' },
	            translation.note
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', type: 'submit' },
	            translation.submit
	          ),
	          typeof activeTicket !== 'undefined' && activeTicket.status.toLowerCase() !== 'closed' && activeTicket.status.toLowerCase() !== 'resolved' && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--outline',
	              type: 'submit',
	              onClick: function onClick(e) {
	                _this3.resolve(e);
	              }
	            },
	            translation.resolve
	          )
	        ),
	        typeof activeTicket !== 'undefined' && (activeTicket.status.toLowerCase() === 'resolved' || activeTicket.status.toLowerCase() === 'closed') && _react2.default.createElement(
	          'div',
	          { className: 'panel--medium' },
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.resolved_note
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--outline',
	              onClick: function onClick(e) {
	                _this3.reopen(e);
	              }
	            },
	            translation.reopen
	          )
	        )
	      );
	    }
	  }]);
	
	  return TicketForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('TicketForm')(TicketForm);

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VTCReview = (0, _mobxReact.observer)(function (_Component) {
	  _inherits(VTCReview, _Component);
	
	  function VTCReview() {
	    _classCallCheck(this, VTCReview);
	
	    return _possibleConstructorReturn(this, (VTCReview.__proto__ || Object.getPrototypeOf(VTCReview)).apply(this, arguments));
	  }
	
	  _createClass(VTCReview, [{
	    key: 'render',
	    value: function render() {
	      return (
	        // Dynamic access key
	        _react2.default.createElement('iframe', {
	          className: 'vtc-review',
	          src: 'https://s3.amazonaws.com/smarterservices-static/virtual-test-center-session-playback/index.html?session=' + this.props.accessCode.replace(/-/g, '')
	        })
	      );
	    }
	  }]);
	
	  return VTCReview;
	}(_react.Component));
	
	exports.default = VTCReview;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	var AddVoucher = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AddVoucher, _React$Component);
	
	  function AddVoucher() {
	    _classCallCheck(this, AddVoucher);
	
	    var _this = _possibleConstructorReturn(this, (AddVoucher.__proto__ || Object.getPrototypeOf(AddVoucher)).call(this));
	
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    return _this;
	  }
	
	  _createClass(AddVoucher, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.state = {
	        voucherData: {
	          amount: 0,
	          currency: null,
	          number: 0,
	          tag: null
	        }
	      };
	
	      SessionStore.getCurrencies();
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var voucherData = Object.assign({}, this.state.voucherData);
	
	      voucherData.amount = this.amount.value || null;
	      voucherData.currency = this.currency.value || null;
	      voucherData.number = this.number.value || null;
	      voucherData.tag = this.tag.value || null;
	      if (this.nonTransferable) {
	        voucherData.nonTransferable = this.nonTransferable.checked;
	      }
	
	      this.setState({
	        voucherData: voucherData
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      this.props.store.VoucherStore.createVoucher(this.state.voucherData, this.complete);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      (0, _helpers.closeDrawer)(null, this.props.parent);
	
	      this.props.store.SessionStore.showToaster(this.props.translation.voucher_saved, 'success');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.page_title
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form' },
	          _react2.default.createElement(
	            'form',
	            { onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	              }, noValidate: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel--medium' },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'lbl-required',
	                        htmlFor: 'vouchers-amount'
	                      },
	                      translation.amount.label
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'number',
	                      id: 'vouchers-amount',
	                      placeholder: '0',
	                      ref: function ref(input) {
	                        return _this2.amount = input;
	                      },
	                      onChange: this.handleInput,
	                      step: '.01',
	                      required: true,
	                      'aria-required': 'true'
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          ref: function ref(input) {
	                            return _this2.currency = input;
	                          },
	                          onChange: this.handleInput
	                        },
	                        SessionStore.currencyList.map(function (key, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: i, value: key.code },
	                            key.name
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-optional', htmlFor: 'vouchers-number' },
	                      translation.number.label
	                    ),
	                    _react2.default.createElement('input', { type: 'number',
	                      min: '1',
	                      id: 'vouchers-number',
	                      placeholder: '0',
	                      ref: function ref(input) {
	                        _this2.number = input;
	                      },
	                      onChange: this.handleInput })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-optional', htmlFor: 'vouchers-tag', 'aria-describedby': 'vouchers-tag-tooltip' },
	                      translation.tag.label,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'vouchers-tag-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                          translation.tag.tooltip
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('input', { type: 'text',
	                      id: 'vouchers-tag',
	                      ref: function ref(input) {
	                        _this2.tag = input;
	                      },
	                      onChange: this.handleInput })
	                  ),
	                  this.props.single && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-optional', htmlFor: 'vouchers-notransfer', 'aria-describedby': 'vouchers-notransfer-tooltip' },
	                      translation.non_transferable.label,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'vouchers-notransfer-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                          translation.non_transferable.tooltip
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'vouchers-notransfer',
	                      className: 'switch-input',
	                      value: '1',
	                      ref: function ref(input) {
	                        _this2.nonTransferable = input;
	                      },
	                      onChange: this.handleInput,
	                      onKeyDown: _helpers.handleSwitchInputKeys,
	                      checked: this.state.voucherData.nonTransferable }),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'switch-label', htmlFor: 'vouchers-notransfer' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.non_transferable.label
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel__actions actions' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'actions__btn actions__btn--primary' },
	                    translation.button
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddVoucher;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AddVoucher')(AddVoucher);

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _currencyFormatter = __webpack_require__(71);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var VoucherList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(VoucherList, _React$Component);
	
	  function VoucherList() {
	    _classCallCheck(this, VoucherList);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (VoucherList.__proto__ || Object.getPrototypeOf(VoucherList)).call(this));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.applyFilters = _this.applyFilters.bind(_this);
	    _this.resetFilters = _this.resetFilters.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      sortOrder: 'ASC'
	    };
	    return _this;
	  }
	
	  _createClass(VoucherList, [{
	    key: 'handleEdit',
	    value: function handleEdit(e, voucherSid) {
	      e.preventDefault();
	
	      this.props.routing.push('/vouchers/edit/' + voucherSid);
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(e, sid) {
	      var selectedRows = [].concat(_toConsumableArray(this.props.selectedRows));
	      var rowIndex = -1;
	
	      if (e.target.checked) {
	        selectedRows.push(sid);
	      } else {
	        rowIndex = selectedRows.indexOf(sid);
	        selectedRows.splice(rowIndex, 1);
	      }
	
	      this.props.parent.setState({
	        selectedRows: selectedRows
	      });
	    }
	  }, {
	    key: 'applyFilters',
	    value: function applyFilters(e) {
	      var VoucherStore = this.props.store.VoucherStore;
	
	
	      if (e) {
	        e.preventDefault();
	      }
	
	      var filters = {};
	
	      var status = this.status.value;
	      var tag = this.tag.value;
	      var memo = this.memo.value;
	      var code = this.code.value;
	      var sortOrder = this.state.sortOrder;
	
	      if (status) {
	        filters.status = status;
	      }
	
	      if (tag) {
	        filters.tag = '*' + tag + '*';
	      }
	
	      if (memo) {
	        filters.memo = '*' + memo + '*';
	      }
	
	      if (code) {
	        filters.voucherCode = '*' + code + '*';
	      }
	
	      if (sortOrder) {
	        filters.sortOrder = sortOrder;
	      }
	
	      VoucherStore.filters = filters;
	
	      if (Object.keys(filters).length > 0) {
	        VoucherStore.getVouchers();
	      } else {
	        this.resetFilters();
	      }
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      var VoucherStore = this.props.store.VoucherStore;
	
	
	      this.status.value = '';
	      this.tag.value = '';
	      this.memo.value = '';
	      this.code.value = '';
	
	      VoucherStore.filters = {};
	      VoucherStore.getVouchers();
	    }
	  }, {
	    key: 'renderVouchers',
	    value: function renderVouchers() {
	      var _this2 = this;
	
	      var _props = this.props,
	          translation = _props.translation,
	          vouchers = _props.vouchers;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          VoucherStore = _props$store.VoucherStore;
	      var userTimezone = SessionStore.userTimezone;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'form',
	          {
	            className: 'filter',
	            onSubmit: this.applyFilters
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--inline' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.filter,
	                    ':'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select' },
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        defaultValue: VoucherStore.filters.status,
	                        ref: function ref(input) {
	                          _this2.status = input;
	                        }
	                      },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        translation.filters.all
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'pending-activation' },
	                        translation.filters.pending
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'activated' },
	                        translation.filters.activated
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'redeemed' },
	                        translation.filters.redeemed
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-code' },
	                    translation.code
	                  ),
	                  _react2.default.createElement('input', {
	                    id: 'filter-code',
	                    type: 'text',
	                    placeholder: translation.code,
	                    defaultValue: VoucherStore.filters.code ? VoucherStore.filters.code.replace(/^\*/, '') : '',
	                    ref: function ref(input) {
	                      return _this2.code = input;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-tag' },
	                    translation.tag
	                  ),
	                  _react2.default.createElement('input', {
	                    id: 'filter-tag',
	                    type: 'text',
	                    placeholder: translation.tag,
	                    defaultValue: VoucherStore.filters.tag ? VoucherStore.filters.tag.replace(/^\*/, '') : '',
	                    ref: function ref(input) {
	                      return _this2.tag = input;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-memo' },
	                    translation.memo
	                  ),
	                  _react2.default.createElement('input', {
	                    id: 'filter-memo',
	                    type: 'text',
	                    placeholder: translation.memo,
	                    defaultValue: VoucherStore.filters.memo ? VoucherStore.filters.memo.replace(/^\*/, '') : '',
	                    ref: function ref(input) {
	                      return _this2.memo = input;
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'actions' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  type: 'submit'
	                },
	                translation.filter
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--outline',
	                  type: 'reset',
	                  onClick: this.resetFilters
	                },
	                translation.reset
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          vouchers.length > 0 && _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-select', scope: 'col' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    'Select'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-code', className: 'subtitle', scope: 'col' },
	                  translation.code
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-amount', className: 'subtitle', scope: 'col' },
	                  translation.amount
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-balance', className: 'subtitle', scope: 'col' },
	                  translation.balance
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-assigned', className: 'subtitle', scope: 'col' },
	                  translation.assigned
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-status', className: 'subtitle', scope: 'col' },
	                  translation.status
	                ),
	                _react2.default.createElement(
	                  'th',
	                  {
	                    id: 'heading-purchased',
	                    className: 'subtitle' + (this.state.sortOrder === 'ASC' ? ' sort--asc' : ' sort--desc'),
	                    scope: 'col',
	                    onClick: function onClick() {
	                      _this2.setState({ sortOrder: _this2.state.sortOrder === 'ASC' ? 'DESC' : 'ASC' }, function () {
	                        _this2.applyFilters();
	                      });
	                    }
	                  },
	                  translation.purchased_date
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-details', className: 'subtitle', scope: 'col' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.details
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              vouchers.map(function (key, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  {
	                    className: _this2.props.selectedRows.indexOf(key.sid) >= 0 ? 'selected' : '',
	                    key: i
	                  },
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'check-col', 'aria-labelledby': 'heading-select' },
	                    _react2.default.createElement('input', {
	                      id: 'select-' + key.sid,
	                      className: 'checkbox-input',
	                      type: 'checkbox',
	                      onChange: function onChange(e) {
	                        return _this2.handleSelect(e, key.sid);
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'checkbox-label checkbox-label--solo', htmlFor: 'select-' + key.sid
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        'Select ',
	                        key.title
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-code' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      {
	                        to: '/vouchers/edit/' + key.sid,
	                        onClick: function onClick(e) {
	                          _this2.handleEdit(e, key.sid);
	                        },
	                        title: 'Edit ' + key.voucherCode
	                      },
	                      key.voucherCode
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-amount', className: 'number' },
	                    _currencyFormatter2.default.format(key.amount, { code: key.currency }),
	                    ' ',
	                    key.currency
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-balance', className: 'number' },
	                    _currencyFormatter2.default.format(key.amountRemaining, { code: key.currency })
	                  ),
	                  key.assignedToSid && _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-assigned', className: 'checked' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      translation.assigned
	                    ),
	                    _react2.default.createElement(icons.iconCheck, null)
	                  ),
	                  !key.assignedToSid && _react2.default.createElement('td', { 'aria-labelledby': 'heading-assigned' }),
	                  key.status && _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-status', className: key.status },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'capitalize' },
	                      key.status.replace('-', ' ')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-purchased', className: 'number' },
	                    (0, _moment2.default)(key.datePurchased).tz(userTimezone).format('M/D/YYYY h:mma')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-details', className: 'number' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      {
	                        to: '/vouchers/edit/' + key.sid,
	                        onClick: function onClick(e) {
	                          _this2.handleEdit(e, key.sid);
	                        }
	                      },
	                      translation.details
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          vouchers.length === 0 && _react2.default.createElement(
	            'span',
	            { className: 'no-results' },
	            translation.no_results
	          ),
	          vouchers.length === 0 && this.status && !this.status.value && !this.tag.value && !this.code.value && !this.memo.value && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.no_vouchers.heading
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'cta__btn btn--icn-right',
	                onClick: function onClick(e) {
	                  _this2.props.toggleDrawer(e, _this2.props.parent, 'AddVoucher');
	                }
	              },
	              translation.no_vouchers.button,
	              _react2.default.createElement(icons.iconPlus, { className: 'icon' })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      if (this.props.drawer) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          this.renderVouchers()
	        );
	      } else {
	        return this.renderVouchers();
	      }
	    }
	  }]);
	
	  return VoucherList;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('VoucherList')(VoucherList);

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _ReportStore = __webpack_require__(380);
	
	var _ReportStore2 = _interopRequireDefault(_ReportStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var obx = (0, _mobx.observable)({
	  transactionsNext: null,
	  transactions: [],
	  summary: {},
	  examConfigurations: [],
	  courseOfferings: [],
	  stats: [],
	  configurationCount: 0,
	  // Get install exam configurations
	  getExamConfigurations: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'Configuration');
	
	    var headers = {};
	
	    if (_SessionStore2.default.hasSessionStorage) {
	      headers = {
	        'token': sessionStorage.getItem('token')
	      };
	    } else {
	      headers = {
	        'token': (0, _helpers.getCookie)('token')
	      };
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/unapprovedConfigurations', { headers: headers }).then(function (response) {
	      obx.examConfigurations = response.data;
	      obx.configurationCount = response.data.total;
	      _SessionStore2.default.finishLoading('Configuration');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get installation proctor approvals
	  approvalsNext: null,
	  approvals: [],
	  approvalCount: 0,
	  approvalsFilter: {},
	  getInstallApprovals: (0, _mobx.action)(function (type) {
	    _SessionStore2.default.startLoading('Loading…', 'getInstallApprovals');
	
	    var headers = {};
	
	    if (_SessionStore2.default.hasSessionStorage) {
	      headers = { 'token': sessionStorage.getItem('token') };
	    } else {
	      headers = { 'token': (0, _helpers.getCookie)('token') };
	    }
	
	    var query = '?limit=25';
	
	    if (Object.keys(obx.approvalsFilter).length > 0) {
	      for (var key in obx.approvalsFilter) {
	        if (obx.approvalsFilter[key]) {
	          query += '&' + key + '=' + obx.approvalsFilter[key];
	        }
	      }
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/approvals' + query, { headers: headers }).then(function (response) {
	      obx.approvals = response.data.results;
	      obx.approvalCount = response.data.total;
	
	      // Set pagination next url
	      if (response.data.next) {
	        // API returns a url with a different domain for the next link
	        // so create an anchor element and set its href to the next link
	        // and then grab the pathname and query from that
	        var nextUrl = (0, _helpers.getPath)(response.data.next);
	        nextUrl = nextUrl.replace('/v1', '');
	        obx.approvalsNext = nextUrl;
	      } else {
	        obx.approvalsNext = null;
	      }
	
	      _SessionStore2.default.finishLoading('getInstallApprovals');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get installation overview stats
	  getOverviewStats: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'getOverviewStats');
	
	    var headers = {};
	
	    if (_SessionStore2.default.hasSessionStorage) {
	      headers = { 'token': sessionStorage.getItem('token') };
	    } else {
	      headers = { 'token': (0, _helpers.getCookie)('token') };
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/reports/aggregatedStats', { headers: headers }).then(function (response) {
	      obx.stats = response.data.results.map(function (x) {
	        return x.data;
	      });
	      _SessionStore2.default.finishLoading('getOverviewStats');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get installation course offerings
	  getCourseOfferings: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'courseOfferings');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courseOfferings').then(function (response) {
	      obx.courseOfferings = response.data.results;
	      _SessionStore2.default.finishLoading('courseOfferings');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get institution settings
	  institutionSettings: {},
	  getDefaultCourseOffering: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'getDefaultCourseOffering');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/settings').then(function (response) {
	      obx.institutionSettings = response.data;
	
	      _SessionStore2.default.finishLoading('getDefaultCourseOffering');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get installation transactions
	  ledgerFilters: {},
	  getTransactions: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'Ledger');
	
	    var query = '?limit=25';
	
	    if (Object.keys(obx.ledgerFilters).length > 0) {
	      for (var key in obx.ledgerFilters) {
	        if (obx.ledgerFilters[key]) {
	          query += '&' + key + '=' + obx.ledgerFilters[key];
	        }
	      }
	    }
	
	    // Store the report URL so we can use it to generate a CSV if we need to
	    _ReportStore2.default.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/ledger' + query;
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/ledger' + query).then(function (response) {
	      obx.transactions = response.data.results;
	      obx.summary = response.data.summary;
	
	      // Set pagination next url
	      if (response.data.next) {
	        // API returns a url with a different domain for the next link
	        // so create an anchor element and set its href to the next link
	        // and then grab the pathname and query from that
	        var nextUrl = (0, _helpers.getPath)(response.data.next);
	        nextUrl = nextUrl.replace('/v1', '');
	        obx.transactionsNext = nextUrl;
	      } else {
	        obx.transactionsNext = null;
	      }
	
	      // Store the formatting in case we need to generate a CSV
	      _ReportStore2.default.reportDefinition = {
	        "Date": "{{createdDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	        "Voucher Code": "{% if voucher %}{{voucher.code | customEscape}}{% endif %}",
	        "Voucher Amount": "{% if voucher %}{{voucher.amount | customEscape}} {{voucher.currency | customEscape}}{% endif %}",
	        "Funding Rule": "{% if fundingRule %}{{fundingRule.title | customEscape}}{% endif %}",
	        "Funding Rule Type": "{% if fundingRule %}{{fundingRule.appliesTo | customEscape}}{% endif %}",
	        "Funding Rule Amount": "{% if fundingRule %}{{fundingRule.amount | customEscape}}{% if fundingRule.units == '%'%}%{% else %} {{fundingRule.currency | customEscape}}{% endif %}{% endif %}",
	        "Exam Session": "{% if examSession %}{{exam.title | customEscape}}; {{course.title | customEscape}}{% endif %}",
	        "Exam Session ID": "{% if examSession %}{{examSession.sid | customEscape}}{% endif %}",
	        "Exam Session Status": "{% if examSession %}{{examSession.status | customEscape}}{% endif %}",
	        "Exam Session Date": "{{examSession.appointmentDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	        "Student": "{% if student %}{{student.firstName | customEscape}} {{student.lastName | customEscape}}{% endif %}",
	        "Student address": "{% if student %}{{student.address | customEscape}}{% endif %}",
	        "Student latitude": "{% if student %}{{student.latitude | customEscape}}{% endif %}",
	        "Student longitude": "{% if student %}{{student.longitude | customEscape}}{% endif %}",
	        "Charge": "{{amount | customEscape}}",
	        "Currency": "{{currency | customEscape}}"
	      };
	
	      _SessionStore2.default.finishLoading('Ledger');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Helpers
	exports.default = obx;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  sessions: [],
	  multi: false,
	  addSession: false,
	  reportIncident: false,
	  incidentSession: null,
	  incidentSid: null,
	  // Get session
	  getSession: (0, _mobx.action)(function (accessKey, component, dialogContent) {
	    // Check if the session is already being viewed
	    var session = obx.sessions.filter(function (key) {
	      return key.accessKey === accessKey;
	    })[0];
	
	    if (typeof session === 'undefined') {
	      _SessionStore2.default.startLoading('Loading…', 'GetManagerSession');
	
	      _config.api.get('/sessions/' + accessKey).then(function (response) {
	        obx.sessions.push(response.data);
	        _SessionStore2.default.finishLoading('GetManagerSession');
	
	        var _response$data = response.data,
	            installSid = _response$data.installSid,
	            courseSid = _response$data.courseSid,
	            enrollmentSid = _response$data.enrollmentSid,
	            examConfiguration = _response$data.examConfiguration,
	            examSid = _response$data.examSid,
	            sid = _response$data.sid,
	            schedulingModule = _response$data.schedulingModule;
	
	
	        component.setState({
	          installSid: installSid,
	          courseSid: courseSid,
	          examSid: examSid,
	          schedulingModule: schedulingModule
	        });
	
	        obx.getSessionEnrollment(installSid, courseSid, enrollmentSid, sid);
	        obx.getSessionExam(installSid, courseSid, examSid, sid, null, enrollmentSid, examConfiguration.sid);
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    } else {
	      obx.addSession = false;
	      _SessionStore2.default.showDialog(dialogContent);
	    }
	  }),
	  // Get the session details
	  session: null,
	  getExamSession: (0, _mobx.action)(function (installSid, examSid, sessionSid, dialogContent, component, callback) {
	    // Check if the session is already being viewed
	    var session = obx.sessions.filter(function (key) {
	      return key.sid === sessionSid;
	    })[0];
	
	    if (typeof session === 'undefined') {
	      _SessionStore2.default.startLoading('Loading…', 'GetManagerExamSession');
	
	      _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid).then(function (response) {
	        obx.sessions.push(response.data);
	        obx.session = response.data;
	
	        if (callback) {
	          callback();
	        }
	
	        // Get enrollment and exam data
	        var _response$data2 = response.data,
	            courseSid = _response$data2.courseSid,
	            enrollmentSid = _response$data2.enrollmentSid,
	            examConfiguration = _response$data2.examConfiguration,
	            examSid = _response$data2.examSid,
	            sid = _response$data2.sid;
	
	        obx.getSessionEnrollment(installSid, courseSid, enrollmentSid, sid);
	        obx.getSessionExam(installSid, courseSid, examSid, sid, null, enrollmentSid, examConfiguration.sid);
	
	        // Add the courseSid to the parent state so we can use it later
	        if (component) {
	          component.setState({
	            courseSid: courseSid
	          });
	        }
	
	        // Finish loading
	        _SessionStore2.default.finishLoading('GetManagerExamSession');
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    } else {
	      obx.addSession = false;
	      _SessionStore2.default.showDialog(dialogContent);
	    }
	  }),
	  // Get the session enrollment
	  getSessionEnrollment: (0, _mobx.action)(function (installSid, courseSid, enrollmentSid, sessionSid, sessionObj) {
	    _SessionStore2.default.startLoading('Loading…', 'GetManagerExamEnrollment');
	
	    _config.api.get('/installs/' + installSid + '/courses/' + courseSid + '/enrollments').then(function (response) {
	      // Filter the response to only the current enrollment
	      var enrollment = response.data.results.filter(function (key) {
	        return key.enrollmentSid === enrollmentSid;
	      })[0];
	
	      if (!sessionObj) {
	        // Get this session from the array
	        var session = obx.sessions.filter(function (key) {
	          return key.sid === sessionSid;
	        })[0];
	
	        // Add the enrollment data to this session
	        session.enrollment = enrollment;
	      } else {
	        sessionObj.enrollment = enrollment;
	      }
	
	      // Finish loading
	      _SessionStore2.default.finishLoading('GetManagerExamEnrollment');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get the session exam data
	  getSessionExam: (0, _mobx.action)(function (installSid, courseSid, examSid, sessionSid, sessionObj, enrollmentSid, configurationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetManagerExamData');
	
	    _config.api.get('/installs/' + installSid + '/courses/' + courseSid + '/exams/' + examSid).then(function (response) {
	      if (!sessionObj) {
	        // Get this session from the array
	        var session = obx.sessions.filter(function (key) {
	          return key.sid === sessionSid;
	        })[0];
	
	        // Add the exam data to this session
	        session.exam = response.data;
	
	        // Get the exam configuration because not all
	        // of the data (e.g. exam files) is returned for some reason
	        obx.getExamConfiguration(installSid, configurationSid, examSid, sessionSid, sessionObj);
	      } else {
	        sessionObj.exam = response.data;
	      }
	
	      // Finish loading
	      _SessionStore2.default.finishLoading('GetManagerExamData');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  getExamConfiguration: (0, _mobx.action)(function (installSid, configurationSid, examSid, sessionSid, sessionObj) {
	    _SessionStore2.default.startLoading('Loading…', 'getExamConfiguration');
	    _config.api.get('/installs/' + installSid + '/examConfigurations/' + configurationSid + '?examSid=' + examSid).then(function (response) {
	      if (!sessionObj) {
	        // Get this session from the array
	        var session = obx.sessions.filter(function (key) {
	          return key.sid === sessionSid;
	        })[0];
	
	        session.exam.configuration = response.data;
	        session.examConfiguration = response.data;
	
	        if (response.data.examFiles) {
	          session.examFile = response.data.examFiles[0];
	        }
	      } else {
	        sessionObj.exam.configuration = response.data;
	        sessionObj.examConfiguration = response.data;
	
	        if (response.data.examFiles) {
	          sessionObj.examFile = response.data.examFiles[0];
	        }
	      }
	
	      _SessionStore2.default.finishLoading('getExamConfiguration');
	    }).catch(function (error) {
	      if (error.response.status !== 404) {
	        _SessionStore2.default.throwError(error);
	      } else {
	        _SessionStore2.default.finishLoading('getExamConfiguration');
	      }
	    });
	  }),
	  // Get written exam file
	  getExamFile: (0, _mobx.action)(function (installSid, configurationSid, sessionSid, fileName) {
	    _SessionStore2.default.startLoading('Loading…', 'getExamFile');
	
	    _config.api.get('/installs/' + installSid + '/examConfigurations/' + configurationSid + '/examFile?sessionSid=' + sessionSid, {
	      responseType: 'arraybuffer'
	    }).then(function (response) {
	      var tempLink = document.createElement('a');
	      var file = new Blob([response.data], { type: 'application/pdf' });
	
	      if (window.navigator.msSaveOrOpenBlob) {
	        window.navigator.msSaveOrOpenBlob(file, fileName);
	      } else {
	        var fileUrl = URL.createObjectURL(file);
	
	        tempLink.href = fileUrl;
	        tempLink.download = fileName;
	        tempLink.click();
	
	        window.URL.revokeObjectURL(fileUrl);
	      }
	
	      _SessionStore2.default.finishLoading('getExamFile');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Close a session
	  closeExamSession: (0, _mobx.action)(function (sessionSid) {
	    obx.sessions = obx.sessions.filter(function (key) {
	      return key.sid !== sessionSid;
	    });
	  }),
	  // Complete a session
	  completeExamSession: (0, _mobx.action)(function (installSid, examSid, sessionSid, callback, schedulingModule) {
	    _SessionStore2.default.startLoading('Loading…', 'CloseManagerSession');
	
	    var data = {
	      type: schedulingModule,
	      reason: 'exam-completed'
	    };
	
	    _config.api.post('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/close', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('CloseManagerSession');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get MegaMeeting ID
	  getMMId: (0, _mobx.action)(function (installSid, examSid, sessionSid, component, getUrl) {
	    _SessionStore2.default.startLoading('Loading…', 'GetMMId');
	
	    _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/meetingRoom').then(function (response) {
	      if (component) {
	        component.setState({
	          mmid: response.data.meetId
	        });
	      }
	
	      _SessionStore2.default.finishLoading('GetMMId');
	
	      if (getUrl) {
	        obx.getMMUrl(installSid, examSid, sessionSid, component);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get MegaMeeting host url
	  getMMUrl: (0, _mobx.action)(function (installSid, examSid, sessionSid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetMMUrl');
	
	    _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/hostSession').then(function (response) {
	      if (component) {
	        component.setState({
	          mmurl: response.data.url
	        });
	      }
	
	      _SessionStore2.default.finishLoading('GetMMUrl');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Cancel session
	  cancelExamSession: (0, _mobx.action)(function (installSid, examSid, sessionSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'cancelExamSession');
	
	    _config.api.delete('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid, { data: data }).then(function (response) {
	      _SessionStore2.default.finishLoading('cancelExamSession');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Return written files
	  returnFiles: [],
	  returnExam: (0, _mobx.action)(function (installSid, examSid, sessionSid, callback, session) {
	    _SessionStore2.default.startLoading('Loading…', 'returnExam');
	
	    var formData = new FormData();
	
	    for (var i = 0; i < obx.returnFiles.length; i++) {
	      formData.append('returnFiles[]', obx.returnFiles[i]);
	    }
	
	    _config.api.put('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/returnFile', formData).then(function (response) {
	      obx.returnFiles = [];
	
	      session.returnedFile = {
	        createdDate: response.data.dateCreated,
	        file: response.data.url
	      };
	
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('returnExam');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var obx = (0, _mobx.observable)({
	  paymentToken: {},
	  submitPayment: (0, _mobx.action)(function () {
	    if (obx.afterPayment) {
	      obx.afterPayment();
	    }
	  }),
	  afterPayment: null,
	  setAfterPayment: (0, _mobx.action)(function (func) {
	    obx.afterPayment = func;
	  }),
	  schedulingRuleInformation: []
	});
	
	exports.default = obx;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _AdminStore = __webpack_require__(377);
	
	var _AdminStore2 = _interopRequireDefault(_AdminStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	
	
	// Helpers
	var obx = (0, _mobx.observable)({
	  defaultQuery: '?limit=25',
	  defaultCourseOffering: true,
	  reportFilters: {},
	  reportFilterMap: {},
	  reportData: null,
	  reportTotal: null,
	  reportFormat: null,
	  reportNext: null,
	  headers: {},
	  // Export data
	  reportMethod: 'GET',
	  reportUrl: null,
	  reportDefinition: null,
	  reportExportTitle: null,
	  // Create load more url
	  getNextUrl: (0, _mobx.action)(function (url) {
	    var nextUrl = (0, _helpers.getPath)(url);
	    return nextUrl.replace('/v1', '');
	  }),
	  // Append data to report
	  appendReportData: (0, _mobx.action)(function (data) {
	    obx.reportData = obx.reportData.concat(data);
	  }),
	  // Apply filters to query
	  applyFilters: (0, _mobx.action)(function (skipCourseOffering, skipLimit) {
	    var query = obx.defaultQuery;
	
	    // If there is a default course offering,
	    // add it as a default filter for reports
	    if (_AdminStore2.default.institutionSettings && _AdminStore2.default.institutionSettings.defaultCourseOfferingSid && !skipCourseOffering && obx.defaultCourseOffering) {
	      obx.reportFilters.courseOfferingSid = _AdminStore2.default.institutionSettings.defaultCourseOfferingSid;
	    }
	
	    // Create the query string
	    if (Object.keys(obx.reportFilters).length > 0) {
	      for (var key in obx.reportFilters) {
	        if (obx.reportFilters[key]) {
	          if (!Array.isArray((0, _mobx.toJS)(obx.reportFilters[key]))) {
	            query += '&' + key + '=' + obx.reportFilters[key];
	          } else {
	            for (var i = 0; i < obx.reportFilters[key].length; i++) {
	              query += '&' + key + '=' + obx.reportFilters[key][i];
	            }
	          }
	        }
	      }
	    }
	
	    if (skipLimit) {
	      query = query.replace('limit=25&', '');
	      query = query.replace('limit=25', '');
	    }
	
	    return query;
	  }),
	  // Update a query parameter
	  updateQueryParam: function updateQueryParam(url, key, value) {
	    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
	    var separator = url.indexOf('?') !== -1 ? '&' : '?';
	
	    if (url.match(re)) {
	      return url.replace(re, '$1' + key + '=' + value + '$2');
	    } else {
	      return '' + url + separator + key + '=' + value;
	    }
	  },
	
	  // Generic function to get report data
	  getReportData: (0, _mobx.action)(function (report) {
	    // Set token header
	    if (_SessionStore2.default.hasSessionStorage) {
	      obx.headers = { 'token': sessionStorage.getItem('token') };
	    } else {
	      obx.headers = { 'token': (0, _helpers.getCookie)('token') };
	    }
	
	    // Determine which report to get
	    switch (report) {
	      case 'appointments':
	        obx.getAppointmentsReport();
	        break;
	
	      case 'approvals':
	        obx.getApprovalsReport();
	        break;
	
	      case 'automated-proctoring':
	        obx.getAutomatedReport();
	        break;
	
	      case 'churn':
	        obx.getChurnReport();
	        break;
	
	      case 'course':
	        obx.getCourseReport();
	        break;
	
	      case 'exams-by-week':
	        obx.getExamsByWeekReport();
	        break;
	
	      case 'exam-detail':
	        obx.getExamReport('detail');
	        break;
	
	      case 'exam-overview':
	        obx.getExamReport('overview');
	        break;
	
	      case 'exam-volume':
	        obx.getExamVolumeReport();
	        break;
	
	      case 'incidents':
	        obx.getIncidentsReport();
	        break;
	
	      case 'instructor-appointments':
	        obx.getAppointmentsReport(true);
	        break;
	
	      case 'peak-exam':
	        obx.getPeakExamReport();
	        break;
	
	      case 'session-requests':
	        obx.getSessionRequestsReport();
	        break;
	
	      case 'unscheduled-learners':
	        obx.getUnscheduledLearnersReport();
	        break;
	
	      case 'written-audit':
	        obx.getWrittenExamsReport();
	        break;
	
	      case 'modality':
	        obx.getModalityGraphs();
	        break;
	
	      default:
	        return null;
	    }
	  }),
	  // Report API call
	  reportApiCall: (0, _mobx.action)(function (url) {
	    var passAllData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var headers = obx.headers;
	
	    _SessionStore2.default.startLoading('Loading…', 'getReportData');
	
	    _config.api.get(url, { headers: headers }).then(function (response) {
	      if (!passAllData) {
	        obx.reportData = obx.reportFormat(response.data.results);
	      } else {
	        obx.reportData = obx.reportFormat(response.data);
	      }
	
	      obx.reportTotal = response.data.count;
	
	      // Set pagination next url
	      if (response.data.next) {
	        obx.reportNext = obx.getNextUrl(response.data.next);
	      } else {
	        obx.reportNext = null;
	      }
	
	      _SessionStore2.default.finishLoading('getReportData');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  /*-------------------------------------------
	    Report: Appointments
	  -------------------------------------------*/
	  // Format general appointments
	  formatAppointmentsReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      // Proctor object
	      var proctor = {};
	
	      if (record.schedulingModule === 'instructor-as-proctor') {
	        proctor.type = 'Instructor';
	      } else if (record.schedulingModule === 'b-virtual') {
	        proctor.type = 'B Virtual';
	      } else if (record.schedulingModule === 'examity') {
	        proctor.type = 'Examity';
	      } else if (record.schedulingModule === 'proctoru') {
	        proctor.type = 'ProctorU';
	      } else if (record.proctor && record.proctor.firstName === null) {
	        proctor.type = '';
	      } else if (record.proctor) {
	        proctor.name = record.proctor.firstName + ' ' + record.proctor.lastName;
	        proctor.email = {
	          title: record.proctor.email,
	          url: 'mailto:' + record.proctor.email,
	          mailto: true
	        };
	      }
	
	      // Student object
	      var student = null;
	
	      if (record.enrollment) {
	        student = {
	          name: record.enrollment.lastName + ', ' + record.enrollment.firstName,
	          email: {
	            title: record.enrollment.email,
	            url: 'mailto:' + record.enrollment.email,
	            mailto: true
	          }
	        };
	      }
	
	      // Details link
	      var details = null;
	
	      if (record.status.toLowerCase() === 'scheduled' || record.status.toLowerCase() === 'closed') {
	        details = {
	          url: '?exam=' + record.examSid + '&session=' + record.sid + '&course=' + record.course.sid,
	          title: 'View details',
	          class: 'btn--outline',
	          action: 'SessionDetail',
	          actionType: 'drawer',
	          skipCSV: true
	        };
	      }
	
	      var newRow = {
	        student: student,
	        exam: {
	          title: record.exam.title,
	          examType: record.exam.type
	        },
	        course: record.course.title,
	        status: record.status,
	        appointmentDate: record.appointmentDate,
	        proctor: proctor,
	        details: details
	      };
	
	      formattedData.push(newRow);
	    });
	
	    obx.reportDefinition = {
	      "Student": "{{enrollment.lastName | customEscape}}, {{enrollment.firstName | customEscape}}",
	      "Student Email": "{{enrollment.email | customEscape}}",
	      "Exam Title": "{{exam.title | customEscape}}",
	      "Exam Type": "{{exam.type | customEscape}}",
	      "Course": "{{course.title | customEscape}}",
	      "Session ID": "{{sid | customEscape}}",
	      "Status": "{{status | customEscape}}",
	      "Session Type": "{{sessionType | customEscape}}",
	      "Scheduling Module": "{{schedulingModule | customEscape}}",
	      "Appointment Date": "{{appointmentDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Proctor": "{% if proctor %}{{proctor.lastName | customEscape}}, {{proctor.firstName | customEscape}}{% endif %}",
	      "Proctor Email": "{% if proctor %}{{proctor.email | customEscape}}{% endif %}",
	      "Company": "{% if location %}{{location.proctorCompany | customEscape}}{% endif %}",
	      "Location Name": "{% if location %}{{location.name | customEscape}}{% endif %}",
	      "Address 1": "{% if location %}{{location.address1 | customEscape}}{% endif %}",
	      "Address 2": "{% if location %}{{location.address2 | customEscape}}{% endif %}",
	      "Region": "{% if location %}{{location.region | customEscape}}{% endif %}",
	      "City": "{% if location %}{{location.place | customEscape}}{% endif %}",
	      "Postal Code": "{% if location %}{{location.postalCode | customEscape}}{% endif %}",
	      "Country": "{% if location %}{{location.country | customEscape}}{% endif %}"
	    };
	
	    return formattedData;
	  }),
	  // Format instructor report
	  formatInstructorAppointmentsReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      var newRow = {
	        student: record.enrollment.lastName + ', ' + record.enrollment.firstName,
	        exam: {
	          url: '/exams/' + record.exam.sid,
	          title: record.exam.title,
	          target: '_self'
	        },
	        appointmentDate: record.appointmentDate,
	        status: record.status,
	        details: {
	          url: '/instructor-appointments?exam=' + record.exam.sid + '&session=' + record.sid + '&course=' + record.course.sid,
	          title: 'View details',
	          class: 'btn--outline',
	          action: 'SessionManage',
	          actionType: 'drawer',
	          skipCSV: true
	        }
	      };
	
	      if (record.examConfiguration && record.examConfiguration.instructorAsProctor && record.instructorProctorSid) {
	        newRow.location = '<pre>' + record.location.address1 + '</pre>';
	      }
	
	      formattedData.push(newRow);
	    });
	
	    return formattedData;
	  }),
	  // Get appointments report
	  getAppointmentsReport: (0, _mobx.action)(function (instructor) {
	    // If this is the instructor’s appointment report, only get instructor appointments
	    if (instructor) {
	      obx.reportFilters.type = 'instructor-as-proctor';
	      obx.reportFilters.courseSid = _SessionStore2.default.userData.courseSid;
	      obx.reportFilters.appointmentAfter = (0, _moment2.default)().toISOString();
	      obx.defaultCourseOffering = false;
	      delete obx.reportFilters.courseOfferingSid;
	    }
	
	    var query = obx.applyFilters();
	
	    if (!instructor) {
	      obx.reportFormat = obx.formatAppointmentsReport;
	    } else {
	      obx.reportFormat = obx.formatInstructorAppointmentsReport;
	    }
	
	    // Set up the filter options
	    if (!instructor) {
	      obx.reportFilterMap = {
	        status: ['Needs Proctor', 'Scheduled', 'Cancelled', 'In Progress', 'Closed'],
	        type: ['examity', 'proctoru', 'b-virtual', 'register-blast', 'instructor-as-proctor', 'messaging', 'ad-hoc'],
	        learnerFirstName: '',
	        learnerLastName: '',
	        learnerEmail: '',
	        learnerSid: '',
	        courseTitle: '',
	        examTitle: '',
	        appointmentAfter: 'date',
	        appointmentBefore: 'date'
	      };
	    } else {
	      obx.reportFilterMap = {
	        learnerFirstName: '',
	        learnerLastName: '',
	        examTitle: ''
	      };
	    }
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/reports/appointments' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('/installs/' + _SessionStore2.default.userData.installSid + '/reports/appointments' + query);
	  }),
	  /*-------------------------------------------
	    Report: Proctor approvals
	  -------------------------------------------*/
	  formatApprovalsReport: (0, _mobx.action)(function (data) {
	    var formattedData = data;
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Proctor": "{{proctorAccount.accountName | customEscape}}",
	      "Status": "{{status | customEscape}}",
	      "Installation Scope": "{{appliesTo.applicationInstall.name | customEscape}}",
	      "Course Scope": "{{appliesTo.course.title | customEscape}}",
	      "Enrollment Scope": "{% if appliesTo.enrollment %}{{appliesTo.enrollment.lastName | customEscape}}, {{appliesTo.enrollment.firstName | customEscape}}{% endif %}",
	      "Exam Scope": "{{appliesTo.exam.title | customEscape}}",
	      "Exam Session Scope": "{{appliesTo.examSession.sid | customEscape}}",
	      "Instructor Scope": "{% if appliesTo.instructorUser %}{{appliesTo.instructorUser.lastName | customEscape}}, {{appliesTo.instructorUser.firstName | customEscape}}{% endif %}",
	      "Student Scope": "{% if appliesTo.studentUser %}{{appliesTo.studentUser.lastName | customEscape}}, {{appliesTo.studentUser.firstName | customEscape}}{% endif %}"
	    };
	
	    return formattedData;
	  }),
	  getApprovalsReport: (0, _mobx.action)(function () {
	    delete obx.reportFilters.courseOfferingSid;
	
	    var query = obx.applyFilters(true);
	
	    obx.reportFormat = obx.formatApprovalsReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      status: ['allow', 'deny', 'requested'],
	      titleFilter: '',
	      courseTitle: '',
	      examTitle: '',
	      requestedByUser: '',
	      reviewedByUser: '',
	      reviewStartDate: 'date',
	      reviewEndDate: 'date'
	    };
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/approvals' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('/installs/' + _SessionStore2.default.userData.installSid + '/approvals' + query);
	  }),
	  /*-------------------------------------------
	    Report: Automated proctoring
	  -------------------------------------------*/
	  formatAutomatedReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      var reviewByDate = null;
	
	      if (record.reviewByDate) {
	        reviewByDate = _moment2.default.utc(record.reviewByDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z');
	      }
	
	      var reviewCompletedDate = null;
	
	      if (record.reviewCompletedDate) {
	        reviewCompletedDate = _moment2.default.utc(record.reviewCompletedDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z');
	      }
	
	      var newRow = {
	        student: record.enrollment.lastName + ', ' + record.enrollment.firstName,
	        exam: {
	          title: record.exam.title,
	          examType: record.exam.type
	        },
	        course: record.course.title,
	        reviewByDate: reviewByDate,
	        reviewCompletedDate: reviewCompletedDate,
	        reviewRequired: record.reviewRequired ? 'Review Required' : '',
	        details: {
	          url: '?exam=' + record.examSid + '&session=' + record.sid + '&course=' + record.course.sid,
	          title: 'View details',
	          class: 'btn--outline',
	          action: 'SessionDetail',
	          actionType: 'drawer',
	          skipCSV: true
	        }
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Student": "{{enrollment.lastName | customEscape}}, {{enrollment.firstName | customEscape}}",
	      "Exam Title": "{{exam.title | customEscape}}",
	      "Exam Type": "{{exam.type | customEscape}}",
	      "Course": "{{course.title | customEscape}}",
	      "Review By": "{{reviewByDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Reviewed On": "{{reviewCompletedDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Review Required": "{{reviewRequired | customEscape}}"
	    };
	
	    return formattedData;
	  }),
	  getAutomatedReport: (0, _mobx.action)(function () {
	    obx.reportFilters.type = 'automated';
	
	    var query = obx.applyFilters();
	
	    obx.reportFormat = obx.formatAutomatedReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      'status': ['Needs Proctor', 'Scheduled', 'Cancelled', 'In Progress', 'Closed'],
	      'reviewStatus': ['pending', 'complete', 'not-required']
	    };
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/reports/appointments' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('/installs/' + _SessionStore2.default.userData.installSid + '/reports/appointments' + query);
	  }),
	  /*-------------------------------------------
	    Report: Churn
	  -------------------------------------------*/
	  formatChurnReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      var newRow = {
	        student: {
	          name: record.lastName + ', ' + record.firstName,
	          email: {
	            title: record.preferredEmail ? record.preferredEmail : record.email,
	            url: 'mailto:' + (record.preferredEmail ? record.preferredEmail : record.email),
	            mailto: true
	          }
	        },
	        exam: {
	          examTitle: record.examTitle,
	          examType: record.examType,
	          courseTitle: record.courseTitle
	        },
	        currentStatus: record.currentStatus,
	        timesCancelled: record.cancelled
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Student": "{{lastName | customEscape}}, {{firstName | customEscape}}",
	      "Student Email": "{{email | customEscape}}",
	      "Exam Title": "{{examTitle | customEscape}}",
	      "Exam Type": "{{examType | customEscape}}",
	      "Course Title": "{{courseTitle | customEscape}}",
	      "Current Status": "{{currentStatus | customEscape}}",
	      "Times Cancelled": "{{cancelled | customEscape}}"
	    };
	
	    return formattedData;
	  }),
	  getChurnReport: (0, _mobx.action)(function () {
	    var query = obx.applyFilters();
	
	    obx.reportFormat = obx.formatChurnReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      courseTitle: '',
	      examTitle: '',
	      firstName: '',
	      lastName: '',
	      email: '',
	      status: ['Needs Proctor', 'Scheduled', 'Cancelled', 'In Progress', 'Closed'],
	      examOpenDate: 'date',
	      examCloseDate: 'date',
	      courseOfferingSid: '',
	      hasClosed: true,
	      hasCancelled: true
	    };
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/reports/churn' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('installs/' + _SessionStore2.default.userData.installSid + '/reports/churn' + query);
	  }),
	  /*-------------------------------------------
	    Report: Course overview
	  -------------------------------------------*/
	  formatCourseReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    // Get token (used for course links)
	    var token = null;
	
	    if (_SessionStore2.default.hasSessionStorage) {
	      token = sessionStorage.getItem('token');
	    } else {
	      token = (0, _helpers.getCookie)('token');
	    }
	
	    // Format the data
	    data.forEach(function (record) {
	      var newRow = {
	        course: {
	          title: {
	            title: record.title,
	            url: '?token=' + token + '&courseSid=' + record.sid
	          }
	        },
	        'Course Id': record.code,
	        Instructor: record.instructor.firstName + ' ' + record.instructor.lastName,
	        'Create Date': record.createdDate,
	        activeExams: record.activeExams.length,
	        learners: parseInt(record.learnerCount, 10),
	        details: {
	          url: '/reports/course?course=' + record.sid,
	          title: 'View learners',
	          class: 'btn--outline',
	          action: 'Enrollments',
	          actionType: 'drawer',
	          skipCSV: true
	        }
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Course": "{{title | customEscape}}",
	      "Course ID": "{{code | customEscape}}",
	      "Instructor": "{{instructor.lastName | customEscape}}, {{instructor.firstName | customEscape}}",
	      "Created Date": "{{createdDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Active Exams": "{{activeExams.length | customEscape}}",
	      "Students": "{{learnerCount | customEscape}}"
	    };
	
	    return formattedData;
	  }),
	  getCourseReport: (0, _mobx.action)(function () {
	    var query = obx.applyFilters();
	
	    obx.reportFormat = obx.formatCourseReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      courseOfferingSid: '',
	      hasActiveExam: true,
	      titleSearchText: '',
	      codeSearchText: ''
	    };
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/courses' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('/installs/' + _SessionStore2.default.userData.installSid + '/courses' + query);
	  }),
	  /*-------------------------------------------
	    Report: Exam detail
	  -------------------------------------------*/
	  formatExamDetailReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    // Get token (used for course links)
	    var token = null;
	
	    if (_SessionStore2.default.hasSessionStorage) {
	      token = sessionStorage.getItem('token');
	    } else {
	      token = (0, _helpers.getCookie)('token');
	    }
	
	    // Format the data
	    data.forEach(function (record) {
	      var permittedItems = [];
	
	      var lockStatus = {
	        button: true,
	        title: 'Locked',
	        class: 'btn--link report-locked',
	        action: 'toggleLock',
	        helper: 'Click to unlock',
	        sids: {
	          examSid: record.sid,
	          configurationSid: record.configuration.sid
	        }
	      };
	
	      if (!record.configuration.locked) {
	        lockStatus.title = 'Unlocked';
	        lockStatus.class = 'btn--link report-unlocked';
	        lockStatus.helper = 'Click to lock';
	      }
	
	      if (record.configuration.permittedBathroomBreak) {
	        permittedItems.push('Bathroom Break');
	      }if (record.configuration.permittedBlankPaper) {
	        permittedItems.push('Blank Paper');
	      }if (record.configuration.permittedCalculator) {
	        permittedItems.push('Calculator');
	      }if (record.configuration.permittedDictionary) {
	        permittedItems.push('Dictionary');
	      }if (record.configuration.permittedEarplugs) {
	        permittedItems.push('Earplugs');
	      }if (record.configuration.permittedFormulaSheet) {
	        permittedItems.push('Formula Sheet');
	      }if (record.configuration.permittedNotes) {
	        permittedItems.push('Notes');
	      }if (record.configuration.permittedTextbook) {
	        permittedItems.push('Textbook');
	      }if (record.configuration.permittedWebsites) {
	        permittedItems.push('Websites');
	      }if (record.configuration.permittedOtherItems) {
	        permittedItems.push(record.configuration.permittedOtherItems);
	      }
	
	      var newRow = {
	        course: {
	          title: {
	            title: record.course.title,
	            url: '?token=' + token + '&courseSid=' + record.course.sid
	          }
	        },
	        instructor: record.course.instructor.firstName ? record.course.instructor.lastName + ', ' + record.course.instructor.firstName : 'Not yet set',
	        exam: record.title,
	        examType: record.type,
	        status: lockStatus,
	        duration: {
	          raw: record.configuration.duration,
	          formatted: (0, _helpers.toHours)(record.configuration.duration, false, true, true)
	        },
	        password: record.configuration.password,
	        attempts: record.configuration.attempts,
	        examOpenDate: _moment2.default.utc(record.configuration.examOpenDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z'),
	        examCloseDate: _moment2.default.utc(record.configuration.examCloseDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z'),
	        permittedItems: permittedItems,
	        url: record.url,
	        studentNotes: record.configuration.studentNotes,
	        proctorNotes: record.configuration.proctorNotes,
	        scheduleOpenDate: record.configuration.scheduleOpenDate === '2000-01-01T05:00:00.000Z' ? '' : _moment2.default.utc(record.configuration.scheduleOpenDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z'),
	        scheduleCloseDate: record.configuration.scheduleCloseDate === '2070-01-01T05:00:00.000Z' ? '' : _moment2.default.utc(record.configuration.scheduleCloseDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z')
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Course": "{{course.title | customEscape}}",
	      "Instructor": "{% if course.instructor.firstName %}{{course.instructor.lastName | customEscape}}, {{course.instructor.firstName | customEscape}}{% else %}Not yet set{% endif %}",
	      "Exam": "{{title | customEscape}}",
	      "Type": "{{type | customEscape}}",
	      "Locked": "{{configuration.locked | customEscape}}",
	      "Duration": "{{configuration.duration | customEscape}}",
	      "Password": "{{configuration.password | customEscape}}",
	      "Opens": "{{configuration.examOpenDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Closes": "{{configuration.examCloseDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Bathroom Break Permitted": "{% if configuration.permittedBathroomBreak %}Yes{% endif %}",
	      "Blank Paper Permitted": "{% if configuration.permittedBlankPaper %}Yes{% endif %}",
	      "Calculator Permitted": "{% if configuration.permittedCalculator %}Yes{% endif %}",
	      "Dictionary Permitted": "{% if configuration.permittedDictionary %}Yes{% endif %}",
	      "Earplugs Permitted": "{% if configuration.permittedEarplugs %}Yes{% endif %}",
	      "Formula Sheets Permitted": "{% if configuration.permittedFormulaSheet %}Yes{% endif %}",
	      "Notes Permitted": "{% if configuration.permittedNotes %}Yes{% endif %}",
	      "Textbook Permitted": "{% if configuration.permittedTextbook %}Yes{% endif %}",
	      "Websites Permitted": "{% if configuration.permittedWebsites %}Yes{% endif %}",
	      "Other Permitted Items": "{{configuration.permittedOtherItems | customEscape}}",
	      "URL": "{{url}}",
	      "Student Notes": "{{configuration.studentNotes | customEscape}}",
	      "Proctor Notes": "{{configuration.proctorNotes | customEscape}}",
	      "Scheduling Opens": "{% if configuration.scheduleOpenDate == '2000-01-01T05:00:00.000Z' %}{% else %}{{configuration.scheduleOpenDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}{% endif %}",
	      "Scheduling Closes": "{% if configuration.scheduleCloseDate == '2070-01-01T05:00:00.000Z' %}{% else %}{{configuration.scheduleCloseDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}{% endif %}"
	    };
	
	    return formattedData;
	  }),
	  /*-------------------------------------------
	    Report: Exam overview
	  -------------------------------------------*/
	  formatExamOverviewReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    // Get token (used for course links)
	    var token = null;
	
	    if (_SessionStore2.default.hasSessionStorage) {
	      token = sessionStorage.getItem('token');
	    } else {
	      token = (0, _helpers.getCookie)('token');
	    }
	
	    // Format the data
	    data.forEach(function (record) {
	      var instructor = record.course.instructor;
	
	      var newRow = {
	        course: {
	          title: {
	            title: record.course.title,
	            url: '?token=' + token + '&courseSid=' + record.course.sid
	          },
	          instructor: instructor.firstName ? instructor.firstName + ' ' + instructor.lastName : 'Not yet set'
	        },
	        exam: {
	          title: record.title,
	          examType: record.type,
	          examStatus: (0, _moment2.default)().isAfter(record.configuration.scheduleOpenDate) && (0, _moment2.default)().isBefore(record.configuration.scheduleCloseDate) ? 'Open' : 'Closed'
	        },
	        selectionDate: {
	          scheduleOpenDate: record.configuration.scheduleOpenDate === '2000-01-01T05:00:00.000Z' ? '' : _moment2.default.utc(record.configuration.scheduleOpenDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z'),
	          scheduleCloseDate: record.configuration.scheduleCloseDate === '2070-01-01T05:00:00.000Z' ? '' : _moment2.default.utc(record.configuration.scheduleCloseDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z')
	        },
	        examDate: {
	          examOpenDate: (0, _moment2.default)(record.configuration.examOpenDate),
	          examCloseDate: (0, _moment2.default)(record.configuration.examCloseDate)
	        },
	        incident: record.summary.incident,
	        closed: record.summary.closed,
	        needsProctor: record.summary.needsProctor,
	        scheduled: record.summary.scheduled
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Course": "{{course.title | customEscape}}",
	      "Exam": "{{title | customEscape}}",
	      "Type": "{{type | customEscape}}",
	      "Opens": "{{configuration.examOpenDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Closes": "{{configuration.examCloseDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Scheduling Opens": "{% if configuration.scheduleOpenDate == '2000-01-01T05:00:00.000Z' %}{% else %}{{configuration.scheduleOpenDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}{% endif %}",
	      "Scheduling Closes": "{% if configuration.scheduleCloseDate == '2070-01-01T05:00:00.000Z' %}{% else %}{{configuration.scheduleCloseDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}{% endif %}",
	      "Incident": "{{summary.incident | customEscape}}",
	      "Closed": "{{summary.closed | customEscape}}",
	      "Needs Proctor": "{{summary.needsProctor | customEscape}}",
	      "Scheduled": "{{summary.scheduled | customEscape}}"
	    };
	
	    return formattedData;
	  }),
	  /*-------------------------------------------
	    Report: Exam
	    (used for overview and detail reports)
	  -------------------------------------------*/
	  getExamReport: (0, _mobx.action)(function (report) {
	    // Default to sorting by exam title
	    if (!obx.reportFilters.sortBy) {
	      obx.reportFilters.sortBy = 'examTitle';
	    }
	
	    var query = obx.applyFilters();
	
	    if (report === 'overview') {
	      obx.reportFormat = obx.formatExamOverviewReport;
	    } else {
	      obx.reportFormat = obx.formatExamDetailReport;
	    }
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      courseOfferingSid: '',
	      courseTitle: '',
	      courseCode: '',
	      examTitle: '',
	      instructorFirstName: '',
	      instructorLastName: '',
	      examOpenDate: 'date',
	      examCloseDate: 'date',
	      sortBy: ['examTitle', 'examOpenDate', 'examCloseDate', 'examScheduleOpenDate', 'examScheduleCloseDate']
	    };
	
	    if (report === 'overview') {
	      obx.reportFilterMap.needsProctor = true;
	    }
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/reports/examOverview' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('/installs/' + _SessionStore2.default.userData.installSid + '/reports/examOverview' + query);
	  }),
	  /*-------------------------------------------
	    Report: Exams by week
	  -------------------------------------------*/
	  formatExamsByWeekReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	    var weeks = [];
	    /*
	    Alright since we've decided to return exams instead of weeks here's what I'm doing:
	     1. Grabbing the start and end of the weeks for the filter and just enumerating through those weeks until I reach the end date  and throwing those weeks into an array
	     2. From there the weeks array is now similar to the records in the previous data that was being returned. I have a helper function to check overlap and return the exam if it overlaps with that week at any point.
	        moment mutates the original value with some of their functions so that's why I'm cloning start/end of week in the while loop
	     */
	
	    var startDate = (0, _moment2.default)(data.startDate);
	    var endDate = (0, _moment2.default)(data.endDate);
	    var enumeratedWeek = startDate.startOf('week');
	
	    while (enumeratedWeek.isAfter(endDate) === false) {
	      var startOfWeek = enumeratedWeek.clone();
	      var endOfWeek = enumeratedWeek.clone();
	
	      weeks.push({
	        weekStart: startOfWeek.startOf('week'),
	        weekEnd: endOfWeek.endOf('week')
	      });
	      enumeratedWeek.add(1, 'weeks');
	    }
	    weeks.forEach(function (record) {
	      var newRow = {
	        start: record.weekStart.format('M/D/YYYY'),
	        end: (0, _moment2.default)(record.weekEnd).format('M/D/YYYY'),
	        exams: data.results.filter(function (exam) {
	          return (0, _helpers.getOverlap)(exam.configuration, record);
	        }).map(function (exam) {
	          return {
	            examByWeekCourse: exam.courseName,
	            examByWeekExam: exam.title,
	            examByWeekType: exam.type,
	            examByWeekOpenDate: exam.configuration ? exam.configuration.examOpenDate : '',
	            examByWeekCloseDate: exam.configuration ? exam.configuration.examCloseDate : '',
	            examByWeekInstructor: exam.instructorName,
	            examByWeekDuration: (0, _helpers.toHours)(exam.configuration.duration, false, true, true),
	            examByWeekStatus: exam.status.charAt(0).toUpperCase() + exam.status.slice(1),
	            examByWeekStudents: {
	              scheduled: 'Scheduled: ' + (exam.totalSessions - exam.needsProctorSessions),
	              needsProctor: 'Needs Proctor: ' + (exam.needsProctorSessions || 0),
	              total: 'Total: ' + (exam.totalSessions || 0)
	            }
	          };
	        })
	      };
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Active Window": "{{configuration.examOpenDate | date: '%m/%d/%Y'}} to {{configuration.examCloseDate | date: '%m/%d/%Y'}}",
	      "Course": "{{courseName | customEscape}}",
	      "Exam": "{{title | customEscape}}",
	      "Type": "{{type | customEscape}}",
	      "Opens": "{{configuration.examOpenDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Closes": "{{configuration.examCloseDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Instructor": "{{instructorName | customEscape}}",
	      "Duration": "{{configuration.duration | customEscape}}",
	      "Status": "{{status | customEscape}}",
	      "Scheduled": "{{totalSessions - needsProctorSessions | customEscape}}",
	      "Needs Proctor": "{% if needsProctorSessions != null %}{{needsProctorSessions | customEscape}}{% else %}0{% endif %}"
	    };
	
	    return formattedData;
	  }),
	  getExamsByWeekReport: (0, _mobx.action)(function () {
	    obx.reportFormat = obx.formatExamsByWeekReport;
	
	    var query = obx.applyFilters();
	    query = query.replace('limit=25', 'limit=50000');
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    // Set the report URL so we can use it to generate a CSV
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/examsByWeek' + reportQuery + '&startDate=' + obx.examsByWeekStart + '&endDate=' + obx.examsByWeekEnd;
	
	    // Make the API call
	    obx.reportApiCall('/installs/' + _SessionStore2.default.userData.installSid + '/examsByWeek' + query + '&startDate=' + obx.examsByWeekStart + '&endDate=' + obx.examsByWeekEnd, true);
	  }),
	  /*-------------------------------------------
	    Report: Exam volume
	  -------------------------------------------*/
	  formatExamVolumeReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    // Format the data
	    data.forEach(function (record) {
	      var newRow = {
	        course: record.courseTitle,
	        examDetail: {
	          title: record.examTitle,
	          examType: record.examType,
	          examStatus: (0, _moment2.default)().isAfter(record.scheduleOpenDate) && (0, _moment2.default)().isBefore(record.scheduleCloseDate) ? 'Open' : 'Closed'
	        },
	        examDate: {
	          examOpenDate: (0, _moment2.default)(record.examOpenDate),
	          examCloseDate: (0, _moment2.default)(record.examCloseDate)
	        },
	        selectionDate: {
	          scheduleOpenDate: record.scheduleOpenDate === '2000-01-01T05:00:00.000Z' ? '' : _moment2.default.utc(record.scheduleOpenDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z'),
	          scheduleCloseDate: record.scheduleCloseDate === '2070-01-01T05:00:00.000Z' ? '' : _moment2.default.utc(record.scheduleCloseDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z')
	        },
	        students: record.enrollment,
	        unscheduled: record.unscheduledRemaining
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Course": "{{courseTitle | customEscape}}",
	      "Exam": "{{examTitle | customEscape}}",
	      "Type": "{{examType | customEscape}}",
	      "Opens": "{{examOpenDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Closes": "{{examCloseDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Scheduling Opens": "{% if scheduleOpenDate == '2000-01-01T05:00:00.000Z' %}{% else %}{{scheduleOpenDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}{% endif %}",
	      "Scheduling Closes": "{% if scheduleCloseDate == '2070-01-01T05:00:00.000Z' %}{% else %}{{scheduleCloseDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}{% endif %}",
	      "Students": "{{enrollment | customEscape }}",
	      "Unscheduled": "{{unscheduledRemaining | customEscape }}"
	    };
	
	    return formattedData;
	  }),
	
	  getExamVolumeReport: (0, _mobx.action)(function () {
	    obx.reportFormat = obx.formatExamVolumeReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      courseOfferingSid: '',
	      examOpenDate: 'date',
	      examCloseDate: 'date'
	    };
	
	    var query = obx.applyFilters();
	    query = query.replace('limit=25', 'limit=50000');
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    // Set the report URL so we can use it to generate a CSV
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/examVolume' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('/installs/' + _SessionStore2.default.userData.installSid + '/examVolume' + query);
	  }),
	
	  /*-------------------------------------------
	    Report: Incidents
	  -------------------------------------------*/
	  formatIncidentsReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      var newRow = {
	        status: record.status,
	        student: {
	          name: record.lastName + ', ' + record.firstName,
	          email: {
	            title: record.email,
	            url: 'mailto:' + record.email,
	            mailto: true
	          }
	        },
	        exam: {
	          title: record.examTitle,
	          examType: record.examType,
	          courseTitle: record.courseTitle
	        },
	        incidentType: record.title,
	        incidentDetails: record.details,
	        potentialDamage: record.potentialDamage,
	        correctiveActions: record.correctiveActionDetails,
	        contact: {
	          name: record.contactPerson,
	          email: {
	            title: record.contactEmail,
	            url: 'mailto:' + record.contactEmail,
	            mailto: true
	          },
	          phone: record.contactPhone
	        }
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Status": "{{status | customEscape}}",
	      "Student": "{{lastName | customEscape}}, {{firstName | customEscape}}",
	      "Student Email": "{{email | customEscape}}",
	      "Exam Title": "{{examTitle | customEscape}}",
	      "Exam Type": "{{examType | customEscape}}",
	      "Course Title": "{{courseTitle | customEscape}}",
	      "Session Type": "{{sessionType | customEscape}}",
	      "Session Status": "{{sessionStatus | customEscape}}",
	      "Incident Subject": "{{subject | customEscape}} - {{title | customEscape}}",
	      "Incident Details": "{{details | customEscape}}",
	      "Potential Damage": "{{potentialDamage | customEscape}}",
	      "Witness": "{{directWitness | customEscape}}",
	      "Corrective Actions": "{{correctiveActionDetails | customEscape}}",
	      "Contact Person": "{{contactPerson | customEscape}}",
	      "Contact Email": "{{contactEmail | customEscape}}",
	      "Contact Phone": "{{contactPhone | customEscape}}"
	    };
	
	    return formattedData;
	  }),
	  getIncidentsReport: (0, _mobx.action)(function () {
	    var query = obx.applyFilters();
	
	    obx.reportFormat = obx.formatIncidentsReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      courseTitle: '',
	      examTitle: '',
	      studentFirstName: '',
	      studentLastName: '',
	      instructorFirstName: '',
	      instructorLastName: '',
	      eventTypeSid: ['ETf871d52029204b64a12762deece92cc0', 'ETa628f7235bf54a54b336cfd94b512341', 'ETcbfeb85c295242de8e6dc2203f254245', 'ET1a955ec8200845ae8fcd8f3425fa0f57', 'ET53ab7b51441b4dfc86b017db86d02b86', 'ET5a46e96cca3a41ee996570c910ea251f', 'ET03842b6586e6485e805e343909370887', 'ET7122411fa2544ce690637118b33b7673', 'ET0342e95534af42afa27d03f86e32c29d'],
	      sessionEventStatus: ['Open', 'Closed']
	    };
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/reports/examSessionEvents' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('installs/' + _SessionStore2.default.userData.installSid + '/reports/examSessionEvents' + query);
	  }),
	  /*-------------------------------------------
	    Report: Peak Exam
	  -------------------------------------------*/
	  formatPeakExamReport: (0, _mobx.action)(function (data) {
	    var dayOfWeekData = [];
	    var hourData = [];
	    var dateData = [];
	
	    // Add day of week data
	    data.dayOfWeek.forEach(function (record) {
	      var newRow = {
	        name: record.day,
	        value: record.volume
	      };
	
	      dayOfWeekData.push(newRow);
	    });
	
	    obx.graphs.push({ data: dayOfWeekData, title: 'by_day_of_week' });
	
	    // Add hour data by looping through
	    // all hours of the day
	    var dataAdded = false;
	
	    var _loop = function _loop(i) {
	      var value = 0;
	
	      // Check if any record exists for this hour
	      // and if it does, set the value to that
	      var record = data.perHour.filter(function (time) {
	        return time.hour === i;
	      })[0];
	
	      if (record) {
	        value = record.volume;
	        dataAdded = true;
	      }
	
	      console.log(dataAdded);
	
	      // Push the data to the array
	      var newRow = {
	        name: (0, _moment2.default)(i, 'H').format('h a'),
	        value: value
	      };
	
	      hourData.push(newRow);
	
	      console.log(hourData);
	
	      if (i === 23 && !dataAdded) {
	        hourData.length = 0;
	      }
	    };
	
	    for (var i = 0; i < 24; i++) {
	      _loop(i);
	    }
	
	    obx.graphs.push({ data: hourData, title: 'by_hour' });
	
	    // Add date data
	    data.perDay.forEach(function (record) {
	      var newRow = {
	        name: (0, _moment2.default)(record.day).format('M/D/YYYY'),
	        value: record.volume
	      };
	
	      dateData.push(newRow);
	    });
	
	    obx.graphs.push({ data: dateData, title: 'by_date' });
	  }),
	  getPeakExamReport: (0, _mobx.action)(function () {
	    var query = obx.applyFilters(false, true);
	
	    obx.reportFormat = obx.formatPeakExamReport;
	
	    obx.graphs = [];
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      courseOfferingSid: '',
	      appointmentDateRangeStart: 'date',
	      appointmentDateRangeEnd: 'date'
	    };
	
	    // Make the API call
	    obx.reportApiCall('installs/' + _SessionStore2.default.userData.installSid + '/reports/appointmentVolume' + query, true);
	  }),
	  /*-------------------------------------------
	    Report: Session requests
	  -------------------------------------------*/
	  formatSessionRequestsReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      var student = null;
	      var studentEmail = null;
	
	      if (record.user) {
	        student = record.user.lastName + ', ' + record.user.firstName;
	        studentEmail = record.user.email;
	      }
	
	      var proctor = null;
	      var proctorEmail = null;
	
	      if (record.proctorAccountUser) {
	        proctor = record.proctorAccountUser.firstName + ' ' + record.proctorAccountUser.lastName;
	        proctorEmail = record.proctorAccountUser.email;
	      }
	
	      var newRow = {
	        student: {
	          name: student,
	          email: {
	            title: studentEmail,
	            url: 'mailto:' + studentEmail,
	            mailto: true
	          }
	        },
	        proctor: {
	          name: proctor,
	          email: {
	            title: proctorEmail,
	            url: 'mailto:' + proctorEmail,
	            mailto: true
	          }
	        },
	        requestedDates: [_moment2.default.utc(record.dateOption1).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z'), _moment2.default.utc(record.dateOption2).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z'), _moment2.default.utc(record.dateOption3).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z')],
	        exam: {
	          title: record.exam.title,
	          examType: record.exam.type
	        },
	        course: {
	          name: record.course.title,
	          code: record.course.code
	        }
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Student": "{{user.lastName | customEscape}}, {{user.firstName | customEscape}}",
	      "Student Email": "{{user.email | customEscape}}",
	      "Proctor": "{{proctorAccountUser.lastName | customEscape}}, {{proctorAccountUser.firstName | customEscape}}",
	      "Proctor Email": "{{proctorAccountUser.email | customEscape}}",
	      "Requested Date 1": "{{dateOption1 | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Requested Date 2": "{{dateOption2 | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Requested Date 3": "{{dateOption3 | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Exam Title": "{{exam.title | customEscape}}",
	      "Exam Type": "{{exam.type | customEscape}}",
	      "Course": "{{course.title | customEscape}}",
	      "Course Code": "{{course.code | customEscape}}"
	    };
	
	    return formattedData;
	  }),
	  getSessionRequestsReport: (0, _mobx.action)(function () {
	    obx.defaultCourseOffering = false;
	    delete obx.reportFilters.courseOfferingSid;
	
	    var query = obx.applyFilters();
	
	    obx.reportFormat = obx.formatSessionRequestsReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      courseTitle: '',
	      courseCode: '',
	      courseSid: '',
	      examTitle: '',
	      learnerFirstName: '',
	      learnerLastName: '',
	      learnerEmail: '',
	      proctorFirstName: '',
	      proctorLastName: '',
	      proctorEmail: ''
	    };
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/reports/sessionRequests' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('installs/' + _SessionStore2.default.userData.installSid + '/reports/sessionRequests' + query);
	  }),
	  /*-------------------------------------------
	    Report: Unscheduled learners
	  -------------------------------------------*/
	  formatUnscheduledLearnerReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      var examCloseDate = null;
	
	      if (record.exam.configuration) {
	        examCloseDate = _moment2.default.utc(record.exam.configuration.examCloseDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z');
	      }
	
	      var newRow = {
	        student: {
	          name: record.lastName + ', ' + record.firstName,
	          email: {
	            title: record.email,
	            url: 'mailto:' + record.email,
	            mailto: true
	          }
	        },
	        exam: {
	          title: record.exam.title,
	          examType: record.exam.type
	        },
	        course: {
	          name: record.course.title,
	          code: record.course.code
	        },
	        examCloses: examCloseDate
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Student": "{{lastName | customEscape}}, {{firstName | customEscape}}",
	      "Student Email": "{{email | customEscape}}",
	      "Exam Title": "{{exam.title | customEscape}}",
	      "Exam Type": "{{exam.type | customEscape}}",
	      "Course": "{{course.title | customEscape}}",
	      "Exam Close Date": "{{exam.configuration.examCloseDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}"
	    };
	
	    return formattedData;
	  }),
	  getUnscheduledLearnersReport: (0, _mobx.action)(function () {
	    var query = obx.applyFilters();
	
	    obx.reportFormat = obx.formatUnscheduledLearnerReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      courseTitle: '',
	      courseCode: '',
	      examTitle: '',
	      learnerFirstName: '',
	      learnerLastName: '',
	      learnerEmail: ''
	    };
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/reports/unscheduledLearners' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('installs/' + _SessionStore2.default.userData.installSid + '/reports/unscheduledLearners' + query);
	  }),
	  /*-------------------------------------------
	    Report: Written exams
	  -------------------------------------------*/
	  formatWrittenExamsReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      var newRow = {
	        exam: record.examTitle,
	        course: {
	          name: record.courseTitle,
	          code: record.courseCode
	        },
	        instructor: {
	          name: record.instructorFirstName + ' ' + record.instructorLastName,
	          email: {
	            title: record.instructorEmail,
	            url: 'mailto:' + record.instructorEmail,
	            mailto: true
	          }
	        },
	        configurationType: record.configurationType,
	        examOpenDate: _moment2.default.utc(record.examOpenDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z'),
	        examCloseDate: _moment2.default.utc(record.examCloseDate).tz(_SessionStore2.default.userTimezone).format('M/D/YYYY [at] h:mma z')
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Exam": "{{examTitle | customEscape}}",
	      "Course Title": "{{courseTitle | customEscape}}",
	      "Course Code": "{{courseCode | customEscape}}",
	      "Instructor": "{{instructorLastName | customEscape}}, {{instructorFirstName | customEscape}}",
	      "Instructor Email": "{{instructorEmail | customEscape}}",
	      "Configuration Type": "{{configurationType | customEscape}}",
	      "Opens": "{{examOpenDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Closes": "{{examCloseDate | time_zone: '" + _SessionStore2.default.userTimezone + "', 'M/D/YYYY [at] h:mma z'}}"
	    };
	
	    return formattedData;
	  }),
	  getWrittenExamsReport: (0, _mobx.action)(function () {
	    var query = obx.applyFilters();
	
	    obx.reportFormat = obx.formatWrittenExamsReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      courseOfferingSid: '',
	      examOpenDate: 'date',
	      examCloseDate: 'date'
	    };
	
	    // Set the report URL so we can use it to generate a CSV
	    var reportQuery = obx.updateQueryParam(query, 'limit', 100);
	
	    obx.reportUrl = '/installs/' + _SessionStore2.default.userData.installSid + '/reports/audit' + reportQuery;
	
	    // Make the API call
	    obx.reportApiCall('installs/' + _SessionStore2.default.userData.installSid + '/reports/audit' + query);
	  }),
	  // Generate CSV file
	  exportData: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'ExportData');
	
	    var urlBase = 'https://api.dev.smarterproctoring.com/v1';
	
	    if (false) {
	      urlBase = 'https://api.stage.smarterproctoring.com/v1';
	    }
	
	    if (true) {
	      urlBase = 'https://api.smarterproctoring.com/v1';
	    }
	
	    var data = {
	      postMetadata: {
	        method: obx.reportMethod,
	        url: encodeURI('' + urlBase + obx.reportUrl),
	        headers: {
	          token: _SessionStore2.default.token
	        }
	      },
	      exportDocumentProperties: {
	        definition: obx.reportDefinition
	      },
	      title: obx.reportExportTitle
	    };
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + _SessionStore2.default.userData.userSid + '/exports', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('ExportData');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  /*-------------------------------------------
	    Report: Modality
	  -------------------------------------------*/
	  graphs: [],
	  graphFilters: {},
	
	  getModalityGraphs: (0, _mobx.action)(function (filters, backgroundLoad) {
	    var userData = _SessionStore2.default.userData;
	
	
	    if (!backgroundLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'getModalityGraphs');
	      obx.graphs = [];
	    } else {
	      _SessionStore2.default.startBackgroundLoading('getModalityGraphs');
	    }
	
	    var query = '';
	
	    if (userData && userData.role && userData.role.toLowerCase() === 'instructor' && userData.courseSid) {
	      query = '?courseSid=' + userData.courseSid;
	
	      if (filters) {
	        Object.keys(filters).forEach(function (key) {
	          query += '&' + key + '=' + filters[key];
	        });
	      }
	    } else if (filters) {
	      query = '?';
	
	      Object.keys(filters).forEach(function (key) {
	        query += key + '=' + filters[key];
	      });
	    }
	
	    if (filters) {
	      obx.graphFilters = filters;
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/reports/modalityDistribution' + query).then(function (response) {
	      var graphData = {
	        type: 'institution',
	        data: []
	      };
	
	      function groupName(group) {
	        var name = '';
	
	        switch (group) {
	          case 'ad-hoc':
	            name = 'Self-managed';
	            break;
	
	          case 'automated':
	            name = 'Automated';
	            break;
	
	          case 'b-virtual':
	            name = 'B Virtual';
	            break;
	
	          case 'examity':
	            name = 'Examity';
	            break;
	
	          case 'instructor-as-proctor':
	            name = 'Instructor';
	            break;
	
	          case 'messaging':
	            name = 'Messaging';
	            break;
	
	          case 'proctoru':
	            name = 'ProctorU';
	            break;
	
	          case 'register-blast':
	            name = 'RegisterBlast';
	            break;
	
	          case 'smarter-scheduling':
	            name = 'SmarterScheduling';
	            break;
	
	          case 'vtc':
	            name = 'VTC';
	            break;
	
	          default:
	            break;
	        }
	
	        return name;
	      }
	
	      if (backgroundLoad) {
	        obx.graphs = [];
	      }
	
	      Object.keys(response.data).forEach(function (group) {
	        graphData.data.push({
	          name: groupName(group),
	          total: response.data[group].total,
	          scheduled: response.data[group].Scheduled,
	          closed: response.data[group].Closed
	        });
	      });
	
	      obx.graphs.push(graphData);
	
	      if (!backgroundLoad) {
	        _SessionStore2.default.finishLoading('getModalityGraphs');
	      } else {
	        _SessionStore2.default.finishBackgroundLoading('getModalityGraphs');
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get all generated CSV files
	  downloads: [],
	  getDownloads: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetDownloads');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + _SessionStore2.default.userData.userSid + '/exports').then(function (response) {
	      obx.downloads = response.data.results;
	      _SessionStore2.default.finishLoading('GetDownloads');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Dependencies
	exports.default = obx;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(56);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _ExamStore = __webpack_require__(223);
	
	var _ExamStore2 = _interopRequireDefault(_ExamStore);
	
	var _PaymentStore = __webpack_require__(379);
	
	var _PaymentStore2 = _interopRequireDefault(_PaymentStore);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _StudentStore = __webpack_require__(382);
	
	var _StudentStore2 = _interopRequireDefault(_StudentStore);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _logrocket = __webpack_require__(111);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Components
	
	
	// Dependencies
	
	
	// Helpers
	
	
	var obx = (0, _mobx.observable)({
	  examSessionSid: null,
	  timeZone: null,
	  examDuration: null,
	  examStartDate: null,
	  examEndDate: null,
	  externalReservedAppointmentExpires: null,
	  externalReservedAppointmentId: null,
	  appointmentDate: null,
	  voucherCode: null,
	  // Reset data
	  resetData: (0, _mobx.action)(function () {
	    // Session data
	    obx.appointmentDate = null;
	    obx.examDuration = null;
	    obx.examEndDate = null;
	    obx.examSessionSid = null;
	    obx.examStartDate = null;
	    obx.externalReservedAppointmentExpires = null;
	    obx.externalReservedAppointmentId = null;
	
	    _ExamStore2.default.externalReservedAppointmentId = null;
	
	    // Payment data
	    obx.voucherCode = null;
	    _PaymentStore2.default.paymentToken = {};
	
	    // Availability data
	    obx.onlineAvailability = [];
	    obx.onlineDate = null;
	    obx.onlineLocation = null;
	    obx.onlineTimeGroups = null;
	    obx.onlineTimeRange = '';
	    // User data
	    obx.timeZone = null;
	  }),
	
	  /**
	   * Reset session-specific data after scheduling
	   *
	   * @function resetSessionData
	   */
	  resetSessionData: (0, _mobx.action)(function () {
	    obx.externalReservedAppointmentExpires = null;
	    obx.externalReservedAppointmentId = null;
	    obx.voucherCode = null;
	
	    _PaymentStore2.default.paymentToken = {};
	  }),
	
	  // Get B Virtual Availability
	  getBVAvailability: (0, _mobx.action)(function (examSid, sessionSid) {
	    _SessionStore2.default.startBackgroundLoading('getBVAvailability');
	
	    var query = '';
	
	    if (obx.onlineDate) {
	      query = '?date=' + obx.onlineDate;
	    }
	
	    // Reset grouped times
	    obx.onlineTimeGroups = null;
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/exams/' + examSid + '/enrollments/' + _SessionStore2.default.userData.enrollmentSid + '/availability/bvirtual' + query).then(function (response) {
	      obx.onlineAvailability = response.data.availability;
	      obx.examSessionSid = sessionSid;
	      obx.timeZone = _SessionStore2.default.userTimezone;
	      obx.examDuration = _ExamStore2.default.examSession.examConfiguration.duration;
	      obx.examStartDate = _ExamStore2.default.examSession.examConfiguration.examOpenDate;
	      obx.examEndDate = _ExamStore2.default.examSession.examConfiguration.examCloseDate;
	
	      // Group times
	      obx.groupOnlineTimes(response.data.availability);
	
	      _SessionStore2.default.finishBackgroundLoading('getBVAvailability');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get online availability
	  onlineDate: null,
	  onlineLocation: null,
	  onlineAvailability: [],
	  onlineTimeGroups: null,
	  onlineTimeRange: '',
	  getOnlineAvailability: (0, _mobx.action)(function (examSid, sessionSid, query) {
	    var isReschedule = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    var queryString = '';
	
	    _SessionStore2.default.startBackgroundLoading('getOnlineAvailability');
	
	    if (query) {
	      queryString = (0, _helpers.formatQuery)(query);
	    } else {
	      if (obx.onlineLocation) {
	        queryString += '?proctorLocationSids=' + obx.onlineLocation;
	      }
	    }
	
	    if (obx.onlineDate) {
	      queryString += '&startDate=' + obx.onlineDate;
	      queryString += '&endDate=' + (0, _moment2.default)(obx.onlineDate).tz(_SessionStore2.default.userTimezone).endOf('day').toISOString();
	    }
	    if (isReschedule) {
	      queryString += '&reschedule=true';
	    }
	
	    // Reset grouped times
	    obx.onlineTimeGroups = null;
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/availability' + queryString).then(function (response) {
	      if (response.data.combined) {
	        obx.onlineAvailability = response.data.combined.availability;
	      } else {
	        obx.onlineAvailability = response.data[obx.onlineLocation].availability;
	      }
	
	      obx.examSessionSid = sessionSid;
	      obx.timeZone = _SessionStore2.default.userTimezone;
	      obx.examDuration = _ExamStore2.default.examSession.examConfiguration.duration;
	      obx.examStartDate = _ExamStore2.default.examSession.examConfiguration.examOpenDate;
	      obx.examEndDate = _ExamStore2.default.examSession.examConfiguration.examCloseDate;
	
	      // Make sure start date is named startDate
	      obx.onlineAvailability.forEach(function (time) {
	        if (!time.startDate && time.start) {
	          time.startDate = time.start;
	          delete time.start;
	        }
	      });
	
	      // Group times
	      obx.groupOnlineTimes(obx.onlineAvailability);
	
	      _SessionStore2.default.finishBackgroundLoading('getOnlineAvailability');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Group online availability times
	  groupOnlineTimes: (0, _mobx.action)(function (times) {
	    times.forEach(function (time) {
	      var date = (0, _moment2.default)(time.startDate).tz(_SessionStore2.default.userTimezone).format('MMDDYYYY');
	      var hour = parseInt((0, _moment2.default)(time.startDate).tz(_SessionStore2.default.userTimezone).format('H'), 10);
	
	      if (!time.endDate) {
	        time.endDate = (0, _moment2.default)(time.startDate).add(obx.examDuration, 'minutes').toISOString();
	      }
	
	      if (obx.onlineLocation) {
	        time.proctorLocationSids = [obx.onlineLocation];
	      }
	
	      // Convert online times to object
	      if (!obx.onlineTimeGroups) {
	        obx.onlineTimeGroups = {};
	      }
	
	      // If an object doesn’t already exist for this date, create one
	      if (!obx.onlineTimeGroups[date]) {
	        obx.onlineTimeGroups[date] = {
	          morning: [],
	          afternoon: [],
	          evening: []
	        };
	      }
	
	      if (hour < 12) {
	        obx.onlineTimeGroups[date].morning.push(time);
	      } else if (hour < 18) {
	        obx.onlineTimeGroups[date].afternoon.push(time);
	      } else {
	        obx.onlineTimeGroups[date].evening.push(time);
	      }
	    });
	  }),
	  // Check if a B Virtual reservation exists
	  checkOnlineReservation: (0, _mobx.action)(function (examSid, sessionSid, func, component) {
	    _SessionStore2.default.startLoading('Loading…', 'checkOnlineReservation');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid).then(function (response) {
	      _SessionStore2.default.finishLoading('checkOnlineReservation');
	
	      obx.examSessionSid = response.data.sid;
	
	      _ExamStore2.default.examSession = response.data;
	
	      // If a session is already reserved, check if the reservation is expired
	      if (response.data.externalReservedAppointmentId) {
	        if ((0, _moment2.default)(response.data.externalReservedAppointmentExpires).isAfter(_SessionStore2.default.currentTime)) {
	          // If it’s not expired, skip to the confirmation step
	          obx.externalReservedAppointmentExpires = response.data.externalReservedAppointmentExpires;
	
	          func();
	
	          if (component) {
	            component.setState({
	              appointmentStartDate: response.data.appointmentDate
	            });
	          }
	        } else {
	          // Otherwise, expire the reservation
	          var callback = function callback() {
	            component.setStep(null, 8);
	          };
	
	          obx.resetData();
	          obx.cancelReservation(examSid, sessionSid, callback);
	        }
	      } else {
	        if (component) {
	          component.setStep(null, 1);
	        }
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Cancel session
	  cancellationMemo: null,
	  cancelSession: (0, _mobx.action)(function (examSid, sessionSid, schedulingModule, memo) {
	    _SessionStore2.default.startLoading('Loading…', 'CancelExamSession');
	
	    var data = {
	      type: schedulingModule,
	      cancellationMemo: obx.cancellationMemo
	    };
	
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid, { data: data }).then(function (response) {
	      _SessionStore2.default.finishLoading('CancelExamSession');
	      _StudentStore2.default.getOrderedStudentExams();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Cancel reservation
	  cancelReservation: (0, _mobx.action)(function (examSid, sessionSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CancelReservation');
	
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/reserve').then(function (response) {
	      _SessionStore2.default.finishLoading('CancelReservation');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Reserve session slot
	  createReservation: (0, _mobx.action)(function (data, examSid, sessionSid, func) {
	    _SessionStore2.default.startLoading('Loading…', 'ReserveSession');
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/reserve', data).then(function (response) {
	      _SessionStore2.default.finishLoading('ReserveSession');
	      obx.externalReservedAppointmentId = response.data.externalReservedAppointmentId;
	      obx.externalReservedAppointmentExpires = response.data.externalReservedAppointmentExpires;
	      obx.appointmentDate = response.data.appointmentDate;
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create a session appointment
	  createAppointment: (0, _mobx.action)(function (examSid, sessionSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateAppointment');
	
	    data.cardToken = _PaymentStore2.default.paymentToken.id;
	
	    if (obx.voucherCode) {
	      data.voucherCode = obx.voucherCode;
	    }
	
	    if (data.sid && data.type === 'ad-hoc') {
	      delete data.sid;
	    }
	
	    if (data.amount === null) {
	      data.amount = 0;
	    }
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid, data).then(function (response) {
	      _ExamStore2.default.examSession = response.data;
	
	      if (callback) {
	        callback(response);
	      }
	
	      obx.resetSessionData();
	
	      _SessionStore2.default.finishLoading('CreateAppointment');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  // Check if able to schedule before a redirect
	  verifyAbilityToScheduleHybrid: (0, _mobx.action)(function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(examSid, sessionSid, appointmentStartDate) {
	      var appointmentDate, queryString, response;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _SessionStore2.default.startLoading('Loading…', 'VerifyAbilityToSchedule');
	              appointmentDate = new Date(appointmentStartDate).toISOString();
	              queryString = '?appointmentDateTime=' + appointmentDate;
	              _context.next = 5;
	              return _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/hybrid/abilityToSchedule' + queryString);
	
	            case 5:
	              response = _context.sent;
	
	
	              _SessionStore2.default.finishLoading('VerifyAbilityToSchedule');
	              return _context.abrupt('return', response.data);
	
	            case 8:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function (_x2, _x3, _x4) {
	      return _ref.apply(this, arguments);
	    };
	  }()),
	  // Reschedule appointment
	  rescheduleAppointment: (0, _mobx.action)(function (examSid, sessionSid, data, callback, refreshCallback) {
	    _SessionStore2.default.startLoading('Loading…', 'RescheduleAppointment');
	
	    delete data.proctorLocationSid;
	
	    if (data.locationLatitude) {
	      data.locationLatitude = data.locationLatitude.toString();
	    }
	
	    if (data.locationLongitude) {
	      data.locationLongitude = data.locationLongitude.toString();
	    }
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid, data, data).then(function (response) {
	      _SessionStore2.default.finishLoading('RescheduleAppointment');
	      _StudentStore2.default.getOrderedStudentExams(true);
	      obx.externalReservedAppointmentId = null;
	      obx.externalReservedAppointmentExpires = null;
	
	      if (response.status === 205 && refreshCallback) {
	        refreshCallback();
	      } else if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Initiate retake
	  retakeSession: (0, _mobx.action)(function (examSid, sessionSid, redirectUrl, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'RetakeSession');
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/retake').then(function (response) {
	      _SessionStore2.default.finishLoading('RetakeSession');
	
	      if (redirectUrl) {
	        window.location.href = redirectUrl.replace(sessionSid, response.data.sid);
	      }
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get scheduling token
	  schedulingURL: null,
	  getSchedulingToken: (0, _mobx.action)(function (examSid, sessionSid, locationSid, appointmentDateTime) {
	    _SessionStore2.default.startBackgroundLoading('GetSchedulingToken');
	
	    var queryString = '?locationSid=' + locationSid;
	
	    if (appointmentDateTime) {
	      queryString += '&appointmentDateTime=' + appointmentDateTime;
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/schedulingToken' + queryString).then(function (response) {
	      obx.schedulingURL = response.data.redirectUri + '?token=' + response.data.token;
	      _SessionStore2.default.finishBackgroundLoading('GetSchedulingToken');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	      _logrocket2.default.captureException('Missing RegisterBlast campus key');
	    });
	  }),
	  // Start online session
	  startOnlineSession: (0, _mobx.action)(function (examSid, sessionSid, callback, sessionWindow) {
	    _SessionStore2.default.startBackgroundLoading('startOnlineSession');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/start').then(function (response) {
	      _SessionStore2.default.finishBackgroundLoading('startOnlineSession');
	
	      if (callback) {
	        callback(response.data.redirect);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	
	      if (sessionWindow) {
	        sessionWindow.close();
	      }
	    });
	  }),
	
	  /**
	   * uploadSessionPhoto
	   * @param {string} examSid
	   * @param {string} sessionSid
	   * @param {object} data
	   * @param {function} errorCallback
	   */
	  uploadSessionPhoto: (0, _mobx.action)(function (examSid, sessionSid, data, errorCallback, responseCallback, photo) {
	    _SessionStore2.default.startBackgroundLoading('uploadSessionPhoto');
	
	    var formData = new FormData();
	
	    formData.append('type', data.type);
	    formData.append('photo', data.photo);
	
	    console.log('===== Data =====');
	    console.log(data);
	
	    console.log('===== Form Data =====');
	    console.log(formData);
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/photos', formData).then(function (response) {
	      // If 1st photo, just submit
	      if (photo === 1) {
	        _SessionStore2.default.finishBackgroundLoading('uploadSessionPhoto');
	      }
	      // If api call is successful, allow user to pass
	      if (photo === 2 && responseCallback && response.status === 200) {
	        _SessionStore2.default.finishBackgroundLoading('uploadSessionPhoto');
	        responseCallback(true);
	        //Otherwise, go back to start of ID verification
	      } else if (photo === 2 && responseCallback && response.status !== 200) {
	        responseCallback(false);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	
	      if (errorCallback) {
	        errorCallback();
	      }
	    });
	  })
	});
	
	exports.default = obx;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _SettingsStore = __webpack_require__(152);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _ScheduleStore = __webpack_require__(381);
	
	var _ScheduleStore2 = _interopRequireDefault(_ScheduleStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Helpers
	var obx = (0, _mobx.observable)({
	  examSlots: null,
	  resetExamSlots: (0, _mobx.action)(function () {
	    obx.examSlots = null;
	  }),
	  exams: [],
	  // Reset exam data
	  resetExams: (0, _mobx.action)(function () {
	    obx.exams = [];
	  }),
	  // Get student exams
	  getStudentExams: (0, _mobx.action)(function (getFullConfig) {
	    _SessionStore2.default.startLoading('Loading…', 'StudentExams');
	    obx.resetExams();
	
	    _config.api.get('/install/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/enrollments/' + _SessionStore2.default.userData.enrollmentSid + '/exams').then(function (response) {
	      obx.exams = response.data.results;
	
	      if (response.data.results.length === 0) {
	        _SessionStore2.default.hideMsg = true;
	      } else {
	        _SessionStore2.default.hideMsg = false;
	      }
	
	      if (getFullConfig) {
	        obx.exams.forEach(function (exam) {
	          obx.getStudentExamConfiguration(exam.sid, exam.examSession.examConfiguration.sid, exam);
	        });
	      }
	
	      _SessionStore2.default.finishLoading('StudentExams');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  /**
	   * Get student exams, ordered and grouped by status
	   * 
	   * @function getOrderedStudentExams
	   * @param {boolean} getFullConfig
	   */
	  getOrderedStudentExams: (0, _mobx.action)(function (getFullConfig) {
	    var sessionSid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    _SessionStore2.default.startLoading('Loading…', 'getOrderedStudentExams');
	
	    _config.api.get('/install/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/enrollments/' + _SessionStore2.default.userData.enrollmentSid + '/exams/ordered').then(function (response) {
	      obx.orderedExams = response.data.exams;
	      var _response$data$exams = response.data.exams,
	          active = _response$data$exams.active,
	          closed = _response$data$exams.closed,
	          upcoming = _response$data$exams.upcoming;
	
	
	      if (active.length === 0 && closed.length === 0 && upcoming.length === 0) {
	        _SessionStore2.default.hideMsg = true;
	      } else {
	        _SessionStore2.default.hideMsg = false;
	      }
	
	      if (getFullConfig) {
	        active.forEach(function (exam) {
	          obx.getStudentExamConfiguration(exam.sid, exam.examSession.examConfiguration.sid, exam);
	        });
	
	        closed.forEach(function (exam) {
	          obx.getStudentExamConfiguration(exam.sid, exam.examSession.examConfiguration.sid, exam);
	        });
	
	        upcoming.forEach(function (exam) {
	          obx.getStudentExamConfiguration(exam.sid, exam.examSession.examConfiguration.sid, exam);
	        });
	      }
	
	      // If a sessionSid was passed in we just attempted to scheduled a session. Show a toast with schedule status 
	      if (sessionSid) {
	        active.forEach(function (exam) {
	          if (exam.examSession.sid === sessionSid && exam.examSession.schedulingModule === 'register-blast') {
	            if (exam.examSession.status === 'Scheduled') {
	              _SessionStore2.default.showToaster('Session scheduled successfully', 'success');
	            }
	          } else if (exam.examSession.sid === sessionSid && exam.examSession.status !== 'Scheduled') {
	            _SessionStore2.default.showToaster('Session was not scheduled', 'warning');
	          }
	        });
	        _ScheduleStore2.default.resetData();
	      }
	
	      _SessionStore2.default.finishLoading('getOrderedStudentExams');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get student exam configuration
	  getStudentExamConfiguration: (0, _mobx.action)(function (examSid, configurationSid, exam) {
	    _SessionStore2.default.startLoading('Loading…', 'StudentExamConfiguration');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/exams/' + examSid + '/configurations/' + configurationSid).then(function (response) {
	      // Hold onto the session’s attempts remaining count
	      // because this endpoint doesn’t take session status
	      // into account
	      var attemptsRemaining = exam.examSession.examConfiguration.attemptsRemaining;
	
	      if (exam) {
	        exam.examSession.examConfiguration = response.data;
	        exam.examSession.examConfiguration.attemptsRemaining = attemptsRemaining;
	      }
	
	      _SessionStore2.default.finishLoading('StudentExamConfiguration');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get single proctor group
	  getProctorGroup: (0, _mobx.action)(function (proctorGroupSid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetProctorGroup');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/proctorGroup').then(function (response) {
	      var proctorGroup = {};
	
	      for (var i = 0; i < response.data.results.length; i++) {
	        if (response.data.results[i].sid === proctorGroupSid) {
	          proctorGroup = response.data.results[i];
	        }
	      }
	
	      if (component) {
	        component.setState({
	          proctorGroup: proctorGroup
	        });
	      }
	
	      _SessionStore2.default.finishLoading('GetProctorGroup');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Log in as student
	  impersonate: (0, _mobx.action)(function (enrollmentSid, accessKey, studentWindow, userSid, integrationSid) {
	    if (_SessionStore2.default.userData.integrationSid || integrationSid) {
	      var integration = integrationSid;
	
	      if (!integration) {
	        integration = _SessionStore2.default.userData.integrationSid;
	      }
	
	      // Access key has been provided, so launch the impersonation
	      if (!studentWindow) {
	        studentWindow = window.open('', '_blank');
	      }
	
	      studentWindow.location.href = 'https://signon.smarterservices.com/v1/applications/smarterproctoring/impersonate?redirect=true&enrollmentSid=' + enrollmentSid + '&userSid=' + userSid + '&installIntegrationSid=' + integration + '&token=' + _SessionStore2.default.token;
	    } else {
	      // No access key provided, so it's probably an admin
	      // Need to ask which integration they need
	      var options = [{
	        label: "Select an integration…",
	        value: ''
	      }];
	
	      _SettingsStore2.default.integrations.forEach(function (integration) {
	        if (integration) {
	          var option = {
	            label: integration.name,
	            value: integration.sid
	          };
	
	          options.push(option);
	        }
	      });
	
	      var msg = {
	        heading: "Which integration?",
	        options: options,
	        button: "Select"
	      };
	
	      var selectFunc = function selectFunc(integration) {
	        studentWindow = window.open('', '_blank');
	        obx.impersonate(enrollmentSid, null, studentWindow, userSid, integration);
	      };
	
	      if (_SettingsStore2.default.integrations.length === 1) {
	        selectFunc(_SettingsStore2.default.integrations[0].sid);
	      } else {
	        (0, _helpers.promptUser)(msg, selectFunc);
	      }
	    }
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  transactions: [],
	  getTransactions: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'Ledger');
	    _config.api.get('/install/' + _SessionStore2.default.userData.installSid + '/users/' + _SessionStore2.default.userData.userSid + '/ledger').then(function (response) {
	      obx.transactions = response.data.results;
	      _SessionStore2.default.finishLoading('Ledger');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  blockedUser: false,
	  liveProctoringBlocked: false,
	  handleBlockedUser: (0, _mobx.action)(function (fullBlock) {
	    obx.liveProctoringBlocked = true;
	    if (fullBlock) {
	      obx.blockedUser = true;
	      window.location.href = '/#/unauthorized';
	    }
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(916), __esModule: true };

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(904);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(81);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(903);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(226);
	var TAG = __webpack_require__(50)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(104);
	var document = __webpack_require__(69).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(67) && !__webpack_require__(102)(function () {
	  return Object.defineProperty(__webpack_require__(388)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(226);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(154);
	var $export = __webpack_require__(68);
	var redefine = __webpack_require__(397);
	var hide = __webpack_require__(103);
	var Iterators = __webpack_require__(105);
	var $iterCreate = __webpack_require__(931);
	var setToStringTag = __webpack_require__(232);
	var getPrototypeOf = __webpack_require__(394);
	var ITERATOR = __webpack_require__(50)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(155);
	var createDesc = __webpack_require__(125);
	var toIObject = __webpack_require__(106);
	var toPrimitive = __webpack_require__(236);
	var has = __webpack_require__(84);
	var IE8_DOM_DEFINE = __webpack_require__(389);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(67) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(395);
	var hiddenKeys = __webpack_require__(229).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(84);
	var toObject = __webpack_require__(107);
	var IE_PROTO = __webpack_require__(233)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(84);
	var toIObject = __webpack_require__(106);
	var arrayIndexOf = __webpack_require__(924)(false);
	var IE_PROTO = __webpack_require__(233)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(68);
	var core = __webpack_require__(35);
	var fails = __webpack_require__(102);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(103);


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(235);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(387);
	var ITERATOR = __webpack_require__(50)('iterator');
	var Iterators = __webpack_require__(105);
	module.exports = __webpack_require__(35).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	//(c)2019, MIT Style License <browser-update.org/LICENSE.txt>
	//it is recommended to directly link to this file because we update the detection code
	"use strict";
	
	var $bu_= new function() {
	    var s=this;
	    this.version="3.3.40npm";
	    this.vsakt = {c:"103",f:"102",s:"15.4",e:"103",i:"12",ios:"15.2",samsung:"17.0.7",o:"89",e_a:"100",o_a:"66.2",y:"22.7.0",v:"5.4",uc:"13.4.0"};
	    //severely insecure below(!) this version, insecure means remote code execution that is actively being exploited
	    this.vsinsecure_below = {c:"88.0.4324.150",f:76,s:"11.1.1",e:16,i:11,ios:"12.3",samsung:12.0,o:62,o_a:52,y:"20",v:"2.7",uc:"13.1"};
	    this.vsdefault = {c:-3,f:-3,s:-1,e:17,i:11,ios:10,samsung:9.9,o:-3,o_a:-3,y:20.4,v:2.6,uc:13.0,a:535};
	    this.names={c:"Chrome",f:'Firefox',s:'Safari',e:"Edge",i:'Internet Explorer',ios:"iOS",samsung:"Samsung Internet",o:'Opera',o_a:'Opera', e_a:"Edge", y:"Yandex Browser",v:"Vivaldi",uc:"UC Browser",a:"Android Browser",x:"Other",silk:"Silk"};
	
	    this.get_browser = function(ua) {
	    var n,ua=(ua||navigator.userAgent).replace("_","."),r={n:"x",v:0,t:"other browser",age_years:undefined,no_device_update:false,available:s.vsakt};
	    function ignore(reason,pattern){if (new RegExp(pattern,"i").test(ua)) return reason;return false}
	    r.other=ignore("bot","Pagespeed|pingdom|Preview|ktxn|dynatrace|Ruxit|PhantomJS|Headless|Lighthouse|bot|spider|archiver|transcoder|crawl|checker|monitoring|prerender|screenshot|python-|php|uptime|validator|fetcher|facebook|slurp|google|yahoo|node|mail.ru|github|cloudflare|addthis|thumb|proxy|feed|fetch|favicon|link|http|scrape|seo|page|search console|AOLBuild|Teoma|Expeditor")||
	        ignore("TV","SMART-TV|SmartTV") ||
	        ignore("niche browser","motorola edge|Comodo.Dragon|OculusBrowser|Falkon|Brave|Classic Browser|Dorado|LBBROWSER|Focus|waterfox|Firefox/56.2|Firefox/56.3|Whale|MIDP|k-meleon|sparrow|wii|Chromium|Puffin|Opera Mini|maxthon|maxton|dolfin|dolphin|seamonkey|opera mini|netfront|moblin|maemo|arora|kazehakase|epiphany|konqueror|rekonq|symbian|webos|PaleMoon|Basilisk|QupZilla|Otter|Midori|qutebrowser|slimjet") ||
	        ignore("mobile without upgrade path or landing page","OPR/44.12.2246|cros|kindle|tizen|silk|blackberry|bb10|RIM|PlayBook|meego|nokia|ucweb|ZuneWP7|537.85.10");
	//        ignore("android(chrome) web view","; wv");
	    r.embedded=/"QtWebEngine|Teams|Electron/i.test(ua);
	    r.mobile=(/iphone|ipod|ipad|android|mobile|phone|ios|iemobile/i.test(ua));
	    r.discontinued=(/netscape|greenbrowser|camino|flot|fennec|galeon|coolnovo/i.test(ua));
	
	    var pats=[
	        ["CriOS.VV","c",'ios'],
	        ["FxiOS.VV","f",'ios'],
	        ["Trident.*rv:VV","i",'i'],
	        ["Trident.VV","i",'i'],
	        ["UCBrowser.VV","uc",'c'],
	        ["MSIE.VV","i",'i'],
	        ["Edge.VV","e",'e'],
	        ["Edg.VV","e",'c'],
	        ["EdgA.VV","e_a",'c'],
	        ["Vivaldi.VV","v",'c'],
	        ["Android.*OPR.VV","o_a",'c'],
	        ["OPR.VV","o",'c'],
	        ["YaBrowser.VV","y",'c'],
	        ["SamsungBrowser.VV","samsung",'c'],
	        ["Silk.VV","silk",'c'],
	        ["Chrome.VV","c",'c'],
	        ["Firefox.VV","f",'f'],
	        [" OS.VV.*Safari","ios",'ios'],
	        ["Version.VV.*Safari","s",'s'],
	        ["Safari.VV","s",'s'],
	        ["Opera.*Version.VV","o"],
	        ["Opera.VV","o"]
	    ];
	    var VV="(\\d+\\.?\\d+\\.?\\d*\\.?\\d*)";
	    for (var i=0; i < pats.length; i++) {
	        if (ua.match(new RegExp(pats[i][0].replace("VV",VV),"i"))) {
	            r.n=pats[i][1];
	            r.engine=pats[i][2];
	            break;
	        }        
	    }
	    r.fullv=RegExp.$1;
	    r.v=parseFloat(r.fullv);
	
	    // Special treatment of some systems
	    //do not notify old systems since there is no up-to-date browser available
	    if (/windows.nt.5|windows.nt.4|windows.nt.6.0|windows.95|windows.98|os x 10.2|os x 10.3|os x 10.4|os x 10.5/i.test(ua)) {
	        r.no_device_update=true;
	        r.available={}
	    }
	    //Safari on iOS 13 in Desktop mode
	    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
	        r.n="ios";
	        r.engine='ios';
	        r.fullv=r.v=13;
	        r.no_device_update=true;//For now, never show a message, TODO!
	    }
	    //iOS
	    if (/iphone|ipod|ipad|ios/i.test(ua)) {
	        ua.match(new RegExp("OS."+VV,"i"));
	        r.n="ios";
	        r.fullv=RegExp.$1;
	        r.v=parseFloat(r.fullv);
	        r.engine='ios';
	        var av=s.available_ios(ua,r.v);
	        /*
	        var newmap={10:"10.3.4",11:"12.4.3",12:"12.4.3",13:s.vsakt["ios"]};
	        if (av in newmap)
	            av=newmap[av];
	        */
	        if (av < 12 && Math.round(r.v)===11)// all devices with ios 11 support ios 12
	            av=12
	        r.available = {"ios": av};
	        if (parseFloat(r.available.ios)<11)
	            r.no_device_update=true;
	    }
	    //winxp/vista/2003
	    if (/windows.nt.5.1|windows.nt.5.2|windows.nt.6.0/i.test(ua)) {
	        r.available={"c":49.9,"f":52.9}
	        r.no_device_update=true;
	    }
	    //old mac
	    if (/os x 10.6/i.test(ua)) {
	        r.available = {"s": "5.1.10", "c": 49.9, "f": 48}
	        r.no_device_update=true;
	    }
	
	    if (/os x 10.7|os x 10.8/i.test(ua)) {
	        r.available = {"s": "6.2.8", "c": 49.9, "f": 48}
	        r.no_device_update=true;
	    }
	    if (/os x 10.9/i.test(ua))
	        r.available.s="9.1.3"
	
	    if (/os x 10.10/i.test(ua))
	        r.available.s="10.1.2"
	
	    //check for android stock browser
	    if (ua.indexOf('Android')>-1 && r.n==="s") {
	        var v=parseInt((/WebKit\/([0-9]+)/i.exec(ua) || 0)[1],10) || 2000;
	        if (v <= 534) {
	            r.n="a";
	            r.fullv=r.v=v;
	            r.is_insecure=true;
	        }
	    }
	
	    r.t=s.names[r.n]+" "+r.v;
	    r.is_supported=r.is_latest= !s.vsakt[r.n] ? undefined : s.less(r.fullv,s.vsakt[r.n])<=0;
	    
	    r.vmaj=Math.round(r.v);
	
	    r.is_insecure= r.is_insecure|| !s.vsinsecure_below[r.n] ? undefined :  s.less(r.fullv,s.vsinsecure_below[r.n])===1;
	    
	    if ((r.n==="f" && (r.vmaj===91)) || (r.n==="i" && r.vmaj===11)) {
	        r.is_supported=true;
	        r.is_insecure=false;
	        if (r.n==="f")
	            r.esr=true;
	    }
	    if (r.n==="ios" && r.v>10.3)
	        r.is_supported=true;
	    if (r.n==="a" || r.n==="x")
	        r.t=s.names[r.n];
	    if (r.n==="e") {
	        r.t = s.names[r.n] + " " + r.vmaj;
	        r.is_supported = s.less(r.fullv, "18.15063") != 1
	    }
	    if (r.n in ["c","f","o","e"] && s.less(r.fullv,parseFloat(s.vsakt[r.n])-1)<=0)
	        r.is_supported=true; //mark also the version before the current version as supported to make the transitions smoother
	
	    var releases_per_year={'f':7,'c':8,'o':8,'i':1,'e':1,'s':1}//,'v':1}
	    if (releases_per_year[r.n]) {
	        r.age_years=Math.round(((s.vsakt[r.n]-r.v)/releases_per_year[r.n])*10)/10 || 0
	    }
	    var engines={e:"Edge.VV",c:"Chrome.VV",f:"Firefox.VV",s:"Version.VV",i:"MSIE.VV","ios":" OS.VV"}
	    if (r.engine) {
	        ua.match(new RegExp(engines[r.engine].replace("VV",VV),"i"))
	        r.engine_version=parseFloat(RegExp.$1)
	    }    
	    return r
	}
	this.semver = function(vstr) {
	    if (vstr instanceof Array)
	        return vstr
	    var x = (vstr+(".0.0.0")).split('.')
	    return [parseInt(x[0]) || 0, parseInt(x[1]) || 0, parseInt(x[2]) || 0, parseInt(x[3]) || 0]
	}
	this.less= function(v1,v2) {
	    //semantic version comparison: returns 1 if v1<v2 , 0 if equal, -1 if v1>v2
	    v1=s.semver(v1)
	    v2=s.semver(v2)
	    for (var i=0; ;i++) {
	        if (i>=v1.length) return i>=v2.length ? 0 : 1;
	        if (i>=v2.length) return -1;
	        var diff = v2[i]-v1[i]
	        if (diff) return diff>0 ? 1 : -1;
	    }
	}
	this.available_ios=function(ua,v) {
	    //https://support.apple.com/de-de/guide/iphone/iphe3fa5df43/ios
	    var h = Math.max(window.screen.height, window.screen.width),pr = window.devicePixelRatio
	    if (/ipad/i.test(ua)) {
	        if (h == 1024 && pr == 2) // iPad 3 (iOS 9), 4, 5, Mini 2, Mini 3, Mini 4, Air, Air 2, Pro 9.7
	            return 10//? only ipad 4 has ios 10, all other can have ios 11
	        if (h == 1112)// iPad Pro 10.5
	            return 15;
	        if (h == 1366)//iPad Pro 12.9, Pro 12.9 (2nd Gen)
	            return 15
	        if (h == 1024 && v < 6)
	            return 5 // iPad
	        return 9 // iPad 2, iPad Mini
	    }
	    if (pr == 1)// 1/3G/3GS
	        return 6//for 3GS
	    if (pr == 3)
	        return 15
	    if (h == 812)// X
	        return 15
	    if ((h == 736 || h == 667))// && pr == 3)// 6+/6s+/7+ and 8+ or // 6+/6s+/7+ and 8+ in zoom mode + // 6/6s/7 and 8
	        return 15//slightly wrong as latest version for iphone 6 is 12
	    if (h == 568) // 5/5C/5s/SE or 6/6s/7 and 8 in zoom mode
	        return 10
	    if (h == 480) // i4/4s
	        return 7
	    return 6
	}
	/*
	this.sub= function(v,minus) {
	    //semantic version subtraction
	    v=s.semver(v)
	    minus=s.semver(minus)
	    for (var i=0; ;i++) {
	        if (i>=v.length||i>minus.length) break;
	        v[i]-=v[minus];
	    }
	    return v.join('.')
	}
	*/
	}
	
	window.$bu_getBrowser=$bu_.get_browser;
	
	var $buo = function(op,test) {
	var n = window.navigator,b;
	op=window._buorgres=op||{};
	var ll = op.l||(n.languages ? n.languages[0] : null) || n.language || n.browserLanguage || n.userLanguage||document.documentElement.getAttribute("lang")||"en";
	op.llfull=ll.replace("_","-").toLowerCase().substr(0,5);
	op.ll=op.llfull.substr(0,2);
	op.domain=op.domain!==undefined?op.domain:(/file:/.test(location.href)?"https:":"")+"//browser-update.org";
	op.apiver=op.api||op.c||-1;
	op.jsv=$bu_.version;
	
	var required_min=(op.apiver<2018&&{i:10,f:11,o:21,s:8,c:30})||{};
	
	var vs=op.notify||op.vs||{};//legacy config: maximum version to notify
	vs.e=vs.e||vs.i;
	vs.i=vs.i||vs.e;
	var required=op.required||{};//minimum browser versions needed
	required.e=required.e||required.i;
	if (!required.i) {
	    required.i=required.e;
	    $bu_.vsakt.i=$bu_.vsakt.e;
	}
	
	for (b in $bu_.vsdefault) {
	    if (vs[b]) {//legacy style config: browsers to notify
	        if ($bu_.less(vs[b],0)>=0) // required <= 0
	            required[b]= parseFloat($bu_.vsakt[b])+parseFloat(vs[b])+0.01
	        else
	            required[b] = parseFloat(vs[b]) + 0.01
	    }
	    if (!(b in required) || required[b]==null)
	        required[b]=$bu_.vsdefault[b]
	    if ($bu_.less(required[b],0)>=0) // case for required <= 0 --> relative to latest version
	        required[b]=parseFloat($bu_.vsakt[b])+parseFloat(required[b]) // TODO: make it work for string version
	    if (required_min[b] && $bu_.less(required[b],required_min[b])===1) // required < required_min
	        required[b]=required_min[b]
	}
	required.ios=required.ios||required.s;
	
	if (required.i<79 && required.i>65)
	    required.i=required.i-60
	if (required.e<79 && required.e>65)
	    required.e=required.e-60
	op.required=required;
	op.reminder=op.reminder<0.1 ? 0 : op.reminder||(24*7);
	op.reminderClosed=op.reminderClosed<1 ? 0 : op.reminderClosed||(24*7);
	op.onshow = op.onshow||function(o){};
	op.onclick = op.onclick||function(o){};
	op.onclose = op.onclose||function(o){};
	op.pageurl = op.pageurl || location.hostname || "x";
	op.newwindow=(op.newwindow!==false);
	
	op.test=test||op.test||(location.hash==="#test-bu")||false;
	op.ignorecookie=op.ignorecookie||location.hash==="#ignorecookie-bu";
	
	op.reasons=[];
	op.hide_reasons=[];
	function check_show(op) {
	    var bb=op.browser=$bu_.get_browser(op.override_ua);
	    op.is_below_required = required[bb.n] && $bu_.less(bb.fullv,required[bb.n])===1; //bb.fullv<required
	    if (bb.other!==false)
	        op.hide_reasons.push("is other browser:" + bb.other)
	    if (bb.embedded!==false)
	        op.hide_reasons.push("is embedded browser:" + bb.embedded)
	    if ( bb.esr && !op.notify_esr)// || (bb.is_supported && !op.notify_also_supported))
	        op.hide_reasons.push("Extended support (ESR)")
	    if (bb.mobile&&op.mobile===false)
	        op.hide_reasons.push("do not notify mobile")
	    if (bb.is_latest)//the latest versions of a browser can not be notified
	            op.hide_reasons.push("is latest version of the browser")
	    if (bb.no_device_update)
	        op.hide_reasons.push("no device update")
	    if (op.is_below_required)
	        op.reasons.push("below required")
	    if ((op.insecure||op.unsecure) && bb.is_insecure)
	        op.reasons.push("insecure")
	    if (op.unsupported && !bb.is_supported)
	        op.reasons.push("no vendor support")
	    if (op.hide_reasons.length>0)
	        return false
	    if (op.reasons.length>0)
	        return true
	    return false
	 }
	
	op.notified=check_show(op);
	
	op.already_shown=document.cookie.indexOf("browserupdateorg=pause")>-1 && !op.ignorecookie;
	
	if (!op.test && (!op.notified || op.already_shown))
	    return;
	
	op.setCookie=function(hours) { //sets a cookie that the user has already seen the notification, closed it or permanently wants to hide it. No information on the user is stored.
	    document.cookie = 'browserupdateorg=pause; expires='+(new Date(new Date().getTime()+3600000*hours)).toGMTString()+'; path=/; SameSite=Lax'+(/https:/.test(location.href)?'; Secure':'')
	}
	
	if (op.already_shown && (op.ignorecookie || op.test))
	    op.setCookie(-10)// remove old cookies if in test mode
	
	if (op.reminder>0)
	    op.setCookie(op.reminder);
	
	if (op.nomessage) {
	    op.onshow(op);
	    return;
	}
	
	$buo_show();
	};
	
	
	if( true ) {
	    module.exports = $buo;
	}
	
	
	
	"use strict";
	var $buo_show = function () {
	    var op = window._buorgres;
	    var bb = $bu_getBrowser();
	    var burl = op.burl || ("http" + (/MSIE/i.test(navigator.userAgent) ? "" : "s") + "://browser-update.org/");
	    if (!op.url) {
	        op.url = burl + ((op.l && (op.l + "/")) || "") + "update-browser.html" + (op.test ? "?force_outdated=true" : "") + "#" + op.jsv + ":" + op.pageurl;
	    }
	    op.url_permanent_hide=op.url_permanent_hide || (burl + "block-ignore-browser-update-warning.html");
	    /*
	     if (Math.random()*1000<1 && !op.test && !op.betatest) {
	     var i = new Image();
	     var txt=op["text_"+ll]||op.text||"";
	     var extra=encodeURIComponent("frac="+frac+"&txt="+txt+"&apiver="+op.apiver);
	     i.src="https://browser-update.org/cnt?what=noti&from="+bb.n+"&fromv="+bb.v + "&ref="+ escape(op.pageurl) + "&jsv="+op.jsv+"&tv="+op.style+"&extra="+extra;
	     }
	     */
	    function busprintf() {
	        var args = arguments;
	        var data = args[0];
	        for (var k = 1; k < args.length; ++k) {
	            data = data.replace(/%s/, args[k]);
	        }
	        return data;
	    }
	
	
	var t = {}, ta;
	t.en= {'msg': 'Your web browser ({brow_name}) is out of date.', 'msgmore': 'Update your browser for more security, speed and the best experience on this site.', 'bupdate': 'Update browser', 'bignore': 'Ignore','remind': 'You will be reminded in {days} days.','bnever': 'Never show again'}
	t.ar= {'msg': 'متصفح الإنترنت الخاص بك ({brow_name}) غير مُحدّث.','msgmore': 'قم بتحديث المتصفح الخاص بك لمزيد من الأمان والسرعة ولأفضل تجربة على هذا الموقع.','bupdate': 'تحديث المتصفح','bignore': 'تجاهل', 'remind': 'سيتم تذكيرك في غضون {days} أيام.', 'bnever': 'لا تظهر مرة أخرى'}
	t.bg= {'msg': 'Вашият уеб браузър ({brow_name}) е остарял.','msgmore': 'Актуализирайте браузъра си за повече сигурност, бързина и най-доброто изживяване на този сайт.','bupdate': 'Актуализиране на браузъра','bignore': 'игнорирай', 'remind': 'Ще ви бъде напомнено след {days} дни.', 'bnever': 'Никога повече да не се показва'}
	t.ca= {'msg': 'El teu navegador ({brow_name}) està desactualitzat.','msgmore': 'Actualitzeu el vostre navegador per obtenir més seguretat, velocitat i una millor experiència en aquest lloc.','bupdate': 'Actualitza el navegador','bignore': 'Ignorar', 'remind': 'T\'ho recordarem d\'aquí a {days} dies.', 'bnever': 'No ho tornis a mostrar'}
	t.cs= {'msg': 'Váš prohlížeč ({brow_name}) je zastaralý.','msgmore': 'Aktualizujte prohlížeč pro lepší zabezpečení, rychlost a nejlepší zážitek z tohoto webu.','bupdate': 'Aktualizovat prohlížeč','bignore': 'Ignorovat', 'remind': 'Znovu budete upozorněni za {days} dnů.', 'bnever': 'Již nezobrazovat'}
	t.cy= {'msg': 'Mae eich porwr gwe ({brow_name}) angen ei ddiweddaru.','msgmore': 'Diweddarwch eich porwr i gael mwy o ddiogelwch, cyflymder a\'r profiad gorau ar y safle hwn.','bupdate': 'Diweddaru porwr','bignore': 'Anwybyddu', 'remind': 'Byddwn yn eich atgoffa mewn {days} diwrnod.', 'bnever': 'Peidiwch â dangos eto'}
	t.da= {'msg': 'Din web browser ({brow_name}) er forældet','msgmore': 'Opdater din browser for mere sikkerhed, hastighed og den bedste oplevelse på denne side.','bupdate': 'Opdater browser','bignore': 'Ignorer', 'remind': 'Du vil blive påmindet om {days} dage.', 'bnever': 'Vis aldrig igen'}
	t.de= {'msg': 'Ihr Webbrowser ({brow_name}) ist veraltet.','msgmore': 'Aktualisieren Sie Ihren Browser für mehr Sicherheit, Geschwindigkeit und den besten Komfort auf dieser Seite.','bupdate': 'Browser aktualisieren','bignore': 'Ignorieren', 'remind': 'Sie werden in {days} Tagen wieder erinnert.', 'bnever': 'Nie wieder anzeigen'}
	t.el= {'msg': 'Το πρόγραμμα περιήγησής σας ({brow_name}) είναι απαρχαιωμένο.','msgmore': 'Ενημερώστε το πρόγραμμα περιήγησής σας για περισσότερη ασφάλεια, ταχύτητα και την καλύτερη εμπειρία σ\' αυτόν τον ιστότοπο.','bupdate': 'Ενημερώστε το πρόγραμμα περιήγησης','bignore': 'Αγνοήστε', 'remind': 'Θα σας το υπενθυμίσουμε σε {days} ημέρες.', 'bnever': 'Να μην εμφανιστεί ξανά'}
	t.es= {'msg': 'Su navegador web ({brow_name}) está desactualizado.','msgmore': 'Actualice su navegador para obtener más seguridad, velocidad y para disfrutar de la mejor experiencia en este sitio.','bupdate': 'Actualizar navegador','bignore': 'Ignorar', 'remind': 'Se le recordará en {days} días.', 'bnever': 'No mostrar de nuevo'}
	t.et= {'msg': 'Teie veebilehitseja ({brow_name}) on vananenud.','msgmore': 'Veebilehitseja uuendamisega kaasneb nii parem turvalisus, kiirus kui ka kasutusmugavus.','bupdate': 'Uuenda veebilehitsejat','bignore': 'Eira', 'remind': 'Uus meeldetuletus {days} päeva pärast.', 'bnever': 'Ära kunagi enam näita'}
	t.fa= {'msg': 'مرورگر شما ({brow_name}) قدیمی است.','msgmore': 'برای ایمنی، سرعت و تجربه بهتر مرورگر خود را به‌روز کنید.','bupdate': 'به‌روزرسانی مرورگر','bignore': 'نادیده گرفتن', 'remind': 'به شما تا {days} روز دیگر دوباره یاد‌آوری خواهد شد.', 'bnever': 'هرگز نمایش نده'}
	t.fi= {'msg': 'Selaimesi ({brow_name}) on vanhentunut.','msgmore': 'Päivitä selaimesi saadaksesi tietoturvapäivityksiä, nopeutta sekä parhaan käyttökokemuksen sivustolla.','bupdate': 'Päivitä selain','bignore': 'Ohita', 'remind': 'Saat uuden muistutuksen {days} päivän päästä.', 'bnever': 'Älä näytä uudestaan'}
	t.fr= {'msg': 'Votre navigateur Web ({brow_name}) n\'est pas à jour.','msgmore': 'Mettez à jour votre navigateur pour plus de sécurité et de rapidité et une meilleure expérience sur ce site.','bupdate': 'Mettre à jour le navigateur','bignore': 'Ignorer', 'remind': 'Vous serez rappelé dans {days} jours.', 'bnever': 'Ne plus afficher'}
	t.gl= {'msg': 'Tá an líonléitheoir agat ({brow_name}) as dáta.','msgmore': 'Actualiza o teu navegador para obter máis seguridade, rapidez e mellor experiencia neste sitio.','bupdate': 'Actualizar navegador web','bignore': 'Ignorar', 'remind': 'Lembraralle en {days} días.', 'bnever': 'Non volver mostrar máis'}
	t.he= {'msg': 'דפדפן ({brow_name}) שלך אינו מעודכן.','msgmore': 'עדכן/י את הדפדפן שלך לשיפור האבטחה והמהירות וכדי ליהנות מהחוויה הטובה ביותר באתר זה.','bupdate': 'עדכן דפדפן','bignore': 'התעלם', 'remind': 'תקבל/י תזכורת בעוד  {days} ימים.', 'bnever': 'אל תציג שוב'}
	t.hi= {'msg': 'आपका वेब ब्राउज़र ({brow_name}) पुराना है।','msgmore': 'इस साइट पर अधिक सुरक्षा, गति और सर्वोत्तम अनुभव करने के लिए अपने ब्राउज़र को अपडेट करें ।','bupdate': 'ब्राउज़र अपडेट करें','bignore': 'नजरअंदाज करें', 'remind': 'आपको {days} दिनों में याद दिलाया जाएगा।', 'bnever': 'फिर कभी मत दिखाना'}
	t.hu= {'msg': 'Az Ön webböngészője ({brow_name}) elavult.','msgmore': 'Frissítse böngészőjét a nagyobb biztonság, sebesség és élmény érdekében!','bupdate': 'Böngésző frissítése','bignore': 'Mellőzés', 'remind': 'Újra emlékeztetünk {days} napon belül.', 'bnever': 'Ne mutassa többet'}
	t.id= {'msg': 'Peramban web ({brow_name}) Anda sudah usang.','msgmore': 'Perbarui peramban Anda untuk pengalaman terbaik, lebih aman, dan cepat di situs ini.','bupdate': 'Perbarui peramban','bignore': 'Abaikan', 'remind': 'Anda akan diingatkan kembali dalam {days} hari.', 'bnever': 'Jangan pernah tampilkan lagi'}
	t.it= {'msg': 'Il tuo browser ({brow_name}) non è aggiornato.','msgmore': 'Aggiorna il browser per una maggiore sicurezza, velocità e la migliore esperienza su questo sito.','bupdate': 'Aggiorna browser','bignore': 'Ignora', 'remind': 'Riceverai un promemoria tra {days} giorni.', 'bnever': 'Non mostrare di nuovo'}
	t.ja= {'msg': 'お使いのブラウザ（{brow_name}）は最新版ではありません。','msgmore': 'セキュリティ、スピード、そしてこのサイトでの最良の体験のためにお使いのブラウザを更新してください。','bupdate': 'ブラウザを更新する','bignore': '無視する', 'remind': '{days} 日後にもう一度お知らせします。', 'bnever': '次回から表示しない'}
	t.ko= {'msg': '귀하의 웹 브라우저({brow_name})는 오래되었습니다.','msgmore': '이 사이트에서 보안, 속도와 최상의 경험을 얻으려면 브라우저를 업데이트하십시오.','bupdate': '브라우저 업데이트하기','bignore': '무시하기', 'remind': '{days}일 후에 알려 드립니다.', 'bnever': '다시 표시하지 않기'}
	t.lt= {'msg': 'Jūsų naršyklė ({brow_name}) yra pasenusi.','msgmore': 'Atsinaujinkite savo naršyklę norėdami gauti daugiau saugumo, greičio ir pačių geriausių patirčių šioje svetainėje.','bupdate': 'Atnaujinti naršyklę','bignore': 'Nepaisyti', 'remind': 'Jums bus priminta po {days} dienų.', 'bnever': 'Daugiau niekada nerodyti'}
	t.lv= {'msg': 'Jūsu pārlūkprogramma ({brow_name}) ir novecojusi.','msgmore': 'Atjaunojiet savu pārlūkprogrammu lielākai drošībai, ātrumam un labākai pieredzei ar šo vietni.','bupdate': 'Atjaunināt pārlūkprogrammu','bignore': 'Ignorēt', 'remind': 'Jums tiks parādīts atgādinājums pēc {days} dienām.', 'bnever': 'Vairs nerādīt'}
	t.ms= {'msg': 'Pelayar web anda ({brow_name}) sudah lapuk.','msgmore': 'Kemas kini pelayar anda untuk lebih keselamatan, kelajuan dan pengalaman terbaik di laman web ini.','bupdate': 'Kemas kini pelayar','bignore': 'Abaikan', 'remind': 'Anda akan diingatkan dalam {days} hari.', 'bnever': 'Jangan tunjukkan lagi'}
	t.nl= {'msg': 'Uw webbrowser ({brow_name}) is verouderd.','msgmore': 'Update uw browser voor meer veiligheid, snelheid en om deze site optimaal te kunnen gebruiken.','bupdate': 'Browser updaten','bignore': 'Negeren', 'remind': 'We zullen u er in {days} dagen aan herinneren.', 'bnever': 'Nooit meer tonen'}
	t.no=t.nn=t.nb= {'msg': 'Nettleseren din ({brow_name}) er utdatert.','msgmore': 'Oppdater nettleseren din for økt sikkerhet, hastighet og den beste opplevelsen på dette nettstedet.','bupdate': 'Oppdater nettleser','bignore': 'Ignorer', 'remind': 'Du vil få en påminnelse om {days} dager.', 'bnever': 'Aldri vis igjen'}
	t.pl= {'msg': 'Twoja przeglądarka ({brow_name}) jest nieaktualna.','msgmore': 'Zaktualizuj przeglądarkę, by korzystać z tej strony bezpieczniej, szybciej i po prostu sprawniej.','bupdate': 'Aktualizuj przeglądarkę','bignore': 'Ignoruj', 'remind': 'Przypomnimy o tym za {days} dni.', 'bnever': 'Nie pokazuj więcej'}
	t.pt= {'msg': 'Seu navegador da web ({brow_name}) está desatualizado.','msgmore': 'Atualize seu navegador para ter mais segurança e velocidade, além da melhor experiência neste site.','bupdate': 'Atualizar navegador','bignore': 'Ignorar', 'remind': 'Você será relembrado em {days} dias.', 'bnever': 'Não mostrar novamente'}
	t.ro= {'msg': 'Browserul tău ({brow_name}) nu este actualizat.','msgmore': 'Actualizează browserul pentru o mai mare siguranță, viteză și cea mai bună experiență pe acest site.','bupdate': 'Actualizează browser','bignore': 'Ignoră', 'remind': 'Ți se va reaminti peste {days} zile.', 'bnever': 'Nu mai arăta'}
	t.ru= {'msg': 'Ваш браузер ({brow_name}) устарел.','msgmore': 'Обновите ваш браузер для повышения уровня безопасности, скорости и комфорта использования этого сайта.','bupdate': 'Обновить браузер','bignore': 'Игнорировать', 'remind': 'Вы получите напоминание через {days} дней.', 'bnever': 'Больше не показывать '}
	t.sk= {'msg': 'Váš internetový prehliadač ({brow_name}) je zastaraný.','msgmore': 'Pre väčšiu bezpečnosť, rýchlosť a lepšiu skúsenosť s touto stránkou si aktualizujte svoj prehliadač.','bupdate': 'Aktualizovať prehliadač','bignore': 'Ignorovať', 'remind': 'Bude vám to pripomenuté o {days} dní.', 'bnever': 'Už nikdy viac neukazovať'}
	t.sl= {'msg': 'Vaš spletni brskalnik ({brow_name}) je zastarel.','msgmore': 'Posodobite svoj brskalnik za dodatno varnost, hitrost in najboljšo izkušnjo na tem spletnem mestu.','bupdate': 'Posodobi brskalnik','bignore': 'Prezri', 'remind': 'Opomnik boste prejeli čez toliko dni: {days}.', 'bnever': 'Ne prikaži več'}
	t.sq= {'msg': 'Shfletuesi juaj ({brow_name}) është i vjetruar.','msgmore': 'Përditësoni shfletuesin tuaj për më tepër siguri, shpejtësi dhe për më të mirin e funksionimeve në këtë sajt.','bupdate': 'Përditëso shfletuesin','bignore': 'Shpërfille', 'remind': 'Do t’ju rikujtohet pas {days} ditësh.', 'bnever': 'Mos e shfaq kurrë më'}
	t.sr= {'msg': 'Vaš pretraživač ({brow_name}) je zastareo.','msgmore': 'Ima poznate sigurnosne probleme i najverovatnije neće prikazati sve funkcionalnisti ovog i drugih sajtova.','bupdate': 'Nadogradi pretraživač','bignore': 'Ignorisi', 'remind': 'Zaboravićete za {days} dana.', 'bnever': 'Ne prikazuj opet'}
	t.sv= {'msg': 'Din webbläsare ({brow_name}) är föråldrad. ','msgmore': 'Uppdatera din webbläsare för mer säkerhet, hastighet och den bästa upplevelsen på den här sajten. ','bupdate': 'Uppdatera webbläsaren','bignore': 'Ignorera', 'remind': 'Du får en påminnelse om {days} dagar.', 'bnever': 'Visa aldrig igen'}
	t.th= {'msg': 'เว็บเบราว์เซอร์ของคุณ ({brow_name}) ล้าสมัยแล้ว','msgmore': 'อัปเดทเบราว์เซอร์เพื่อเพิ่มความปลอดภัย, ความเร็ว และประสบการณ์ที่ดีที่สุดบนเว็บไซต์นี้','bupdate': 'อัปเดทเบราว์เซอร์','bignore': 'ข้าม', 'remind': 'คุณจะได้รับการแจ้งเตือนใน {days} วัน', 'bnever': 'ไม่ต้องแสดงอีก'}
	t.tr= {'msg': 'Web tarayıcınız ({brow_name}) güncel değil.','msgmore': 'Daha fazla güvenlik ve hız ile bu sitede en iyi deneyim için tarayıcınızı güncelleyin.','bupdate': 'Tarayıcıyı güncelle','bignore': 'Yok say', 'remind': '{days} gün sonra bir hatırlatma alacaksınız.', 'bnever': 'Bir daha gösterme'}
	t.uk= {'msg': 'Ваш браузер ({brow_name}) застарілий.','msgmore': 'Оновіть свій браузер для більшої безпеки, швидкості та повноцінної роботи цього сайту.','bupdate': 'Оновити браузер','bignore': 'Пропустити', 'remind': 'Ви отримаєте нагадування через {days} днів.', 'bnever': 'Більше не показувати'}
	t.uz= {'msg': 'Sizning ({brow_name}) veb-brauzeringiz eskirgan','msgmore': 'Xavfsizlik, tezkorlik va ushbu sayt imkoniyatlaridan to`liq foydalanish uchun brauzeringizni yangilang.','bupdate': 'Brauzeringizni yangilang','bignore': 'E’tibor bermaslik', 'remind': 'Sizga {days} kundan so`ng eslatammiz.', 'bnever': 'Hech qachon qayta ko\'rsatmang'}
	t.vi= {'msg': 'Trình duyệt web của bạn ({brow_name}) đã lỗi thời.','msgmore': 'Cập nhật trình duyệt của bạn để có thêm bảo mật, tốc độ và trải nghiệm tốt nhất trên trang web này.','bupdate': 'Cập nhật trình duyệt','bignore': 'Bỏ qua', 'remind': 'Bạn sẽ được nhắc nhở sau {days} ngày.', 'bnever': 'Không bao giờ hiển thị lại'}
	t.zh= {'msg': '您的网页浏览器（{brow_name}）已过期。','msgmore': '更新您的浏览器，以便在该网站上获得更安全、更快速和最好的体验。','bupdate': '更新浏览器','bignore': '忽略', 'remind': '会在{days}天后提醒您。', 'bnever': '不再显示'}
	t["zh-tw"]= t["zh-hans-cn"] ={'msg': '您的網路瀏覽器（{brow_name}）已過舊。','msgmore': '更新您的瀏覽器以獲得更佳的安全性、速度以及在此網站的最佳體驗。','bupdate': '更新瀏覽器','bignore': '忽略', 'remind': '您將在 {days} 天後收到提醒。', 'bnever': '不要再顯示'}
	
	var custom_text = op["text_for_"  + bb.n + "_in_" + op.ll] || op["text_for_" + bb.n] || op["text_" + op.llfull] || op["text_in_" + op.ll] || op["text_" + op.ll]  ||   op.text
	t = ta = t[op.llfull] || t[op.ll] || t.en;
	if (custom_text) {
	    if (typeof custom_text === 'string')
	        t=ta=custom_text;
	    else {
	        for (var i in custom_text) {
	            ta[i] = custom_text[i]
	        }
	    }
	}
	if (ta.msg)
	    t = '<b class="buorg-mainmsg">' + t.msg + '</b> <span class="buorg-moremsg">' + t.msgmore + '</span> <span class="buorg-buttons"><a{up_but}>' + t.bupdate + '</a> <a{ignore_but}>' + t.bignore + '</a></span>'
	
	var tar = "";
	if (op.newwindow)
	    tar = ' target="_blank" rel="noopener"';
	
	var div = op.div = document.createElement("div");
	div.id = div.className= "buorg";
	
	var style = '<style>.buorg-icon {width: 22px; height: 16px; vertical-align: middle; position: relative; top: -0.05em; display: inline-block; background: no-repeat 0px center url(https://browser-update.org/static/img/small/' + bb.n + '.png);}</style>';
	var style2 = '<style>.buorg {position:absolute;position:fixed;z-index:111111; width:100%; top:0px; left:0px; border-bottom:1px solid #A29330; text-align:center;  color:#000; background-color: #fff8ea; font: 18px Calibri,Helvetica,sans-serif; box-shadow: 0 0 5px rgba(0,0,0,0.2);animation: buorgfly 1s ease-out 0s;}'
	    + '.buorg-pad { padding: 9px;  line-height: 1.7em; }'
	    + '.buorg-buttons { display: block; text-align: center; }'
	    + '#buorgig,#buorgul,#buorgpermanent { color: #fff; text-decoration: none; cursor:pointer; box-shadow: 0 0 2px rgba(0,0,0,0.4); padding: 1px 10px; border-radius: 4px; font-weight: normal; background: #5ab400;    white-space: nowrap;    margin: 0 2px; display: inline-block;}'
	    + '#buorgig { background-color: #edbc68;}'
	    + '@media only screen and (max-width: 700px){.buorg div { padding:5px 12px 5px 9px; line-height: 1.3em;}}'
	    + '@keyframes buorgfly {from {opacity:0;transform:translateY(-50px)} to {opacity:1;transform:translateY(0px)}}'
	    + '.buorg-fadeout {transition: visibility 0s 8.5s, opacity 8s ease-out .5s;}</style>';
	if (ta.msg && (op.ll=="ar"||op.ll=="he"||op.ll=="fa"))
	    style2+='<style>.buorg {direction:RTL; unicode-bidi:embed;}</style>';
	if (!ta.msg && t.indexOf && t.indexOf("%s") !== -1) {//legacy style
	    t = busprintf(t, bb.t, ' id="buorgul" href="' + op.url + '"' + tar);
	
	    style += '<style>.buorg {position:absolute;position:fixed;z-index:111111; width:100%; top:0px; left:0px; border-bottom:1px solid #A29330; text-align:left; cursor:pointer; color:#000; font: 13px Arial,sans-serif;color:#000;}'
	        + '.buorg div { padding:5px 36px 5px 40px; }'
	        + '.buorg>div>a,.buorg>div>a:visited{color:#E25600; text-decoration: underline;}'
	        + '#buorgclose{position:absolute;right:6px;top:0px;height:20px;width:12px;font:18px bold;padding:0;}'
	        + '#buorga{display:block;}'
	        + '@media only screen and (max-width: 700px){.buorg div { padding:5px 15px 5px 9px; }}</style>';
	    div.innerHTML = '<div>' + t + '<div id="buorgclose"><a id="buorga">&times;</a></div></div>' + style;
	    op.addmargin = true;
	}
	else {
	    if (op.style === "bottom") {
	        style2 += '<style>.buorg {bottom:0; top:auto; border-top:1px solid #A29330; } @keyframes buorgfly {from {opacity:0;transform:translateY(50px)} to {opacity:1;transform:translateY(0px)}}</style>';
	    }
	    else if (op.style === "corner") {
	        style2 += '<style> .buorg { text-align: left; width:300px; top:50px; right:50px; left:auto; border:1px solid #A29330; } .buorg-buttons, .buorg-mainmsg, .buorg-moremsg { display: block; } .buorg-buttons a {margin: 4px 2px;} .buorg-icon {display: none;}</style>';
	    }
	    else {
	        op.addmargin = true;
	    }
	    t = t.replace("{brow_name}", bb.t).replace("{up_but}", ' id="buorgul" href="' + op.url + '"' + tar).replace("{ignore_but}", ' id="buorgig" role="button" tabindex="0"');
	    div.innerHTML = '<div class="buorg-pad" role="status" aria-live="polite"><span class="buorg-icon"> </span>' + t + '</div>' + style + style2;
	}
	
	op.text = t;
	if (op.container) {
	    op.container.appendChild(div);
	    op.addmargin = false;
	}
	else
	    document.body.insertBefore(div, document.body.firstChild);
	
	var updatebutton=document.getElementById("buorgul");
	if (updatebutton) {
	    updatebutton.onclick = function (e) {
	        div.onclick = null;
	        op.onclick(op);
	        if (op.noclose)
	            return
	        op.setCookie(op.reminderClosed);
	        if (!op.noclose) {
	            div.style.display = "none";
	            if (op.addmargin && op.shift_page_down !== false)
	                hm.style.marginTop = op.bodymt;
	        }
	    };
	}
	if (!custom_text) {//make whole bar clickable except if custom text is set
	    div.style.cursor="pointer";
	    div.onclick = function () {
	        if (op.newwindow)
	            window.open(op.url, "_blank");
	        else
	            window.location.href = op.url;
	        op.setCookie(op.reminderClosed);
	        op.onclick(op);
	    };
	}
	
	if (op.addmargin && op.shift_page_down !== false) {
	    var hm = document.getElementsByTagName("html")[0] || document.body;
	    op.bodymt = hm.style.marginTop;
	    hm.style.marginTop = (div.clientHeight) + "px";
	}
	var ignorebutton = document.getElementById("buorga") || document.getElementById("buorgig");
	if (ignorebutton) {
	    ignorebutton.onclick = function (e) {
	        div.onclick = null;
	        op.onclose(op);
	        if (op.addmargin && op.shift_page_down !== false)
	            hm.style.marginTop = op.bodymt;
	        op.setCookie(op.reminderClosed);
	        if (!op.no_permanent_hide && ta.bnever && ta.remind) {
	            op.div.innerHTML = '<div class="buorg-pad"><span class="buorg-moremsg">' + (op.reminderClosed > 24 ? ta.remind.replace("{days}", Math.round(op.reminderClosed/24)):"") + '</span> <span class="buorg-buttons"><a id="buorgpermanent" role="button" tabindex="0" href="' + op.url_permanent_hide +'"' + tar + '>' + ta.bnever + '</a></span></div>' + style + style2;
	            div.className = "buorg buorg-fadeout";
	            document.getElementById("buorgpermanent").onclick = function (e) {
	                op.setCookie(24 * 365);
	                op.div.style.display = "none";
	            }
	            op.div.style.opacity = 0;
	            op.div.style.visibility = "hidden";
	            return false;
	        }
	        op.div.style.display = "none";
	        return false;
	    }
	    if (op.noclose || op.reminderClosed==0) {
	        ignorebutton.parentNode.removeChild(ignorebutton)
	    }
	}
	
	
	op.onshow(op);
	
	if (op.test && !op.dont_show_debuginfo) {
	    var e = document.createElement("script");
	    e.src = op.domain + "/update.test.js";
	    document.body.appendChild(e);
	}
	
	};
	
	


/***/ },
/* 401 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.4.1 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex = /^#([0-9a-f]{3,8})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  copy: function(channels) {
	    return Object.assign(new this.constructor, this, channels);
	  },
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: color_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: color_formatHex,
	  formatHsl: color_formatHsl,
	  formatRgb: color_formatRgb,
	  toString: color_formatRgb
	});
	
	function color_formatHex() {
	  return this.rgb().formatHex();
	}
	
	function color_formatHsl() {
	  return hslConvert(this).formatHsl();
	}
	
	function color_formatRgb() {
	  return this.rgb().formatRgb();
	}
	
	function color(format) {
	  var m, l;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
	      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
	      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
	      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
	      : null) // invalid hex
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (-0.5 <= this.r && this.r < 255.5)
	        && (-0.5 <= this.g && this.g < 255.5)
	        && (-0.5 <= this.b && this.b < 255.5)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: rgb_formatHex,
	  formatRgb: rgb_formatRgb,
	  toString: rgb_formatRgb
	}));
	
	function rgb_formatHex() {
	  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	}
	
	function rgb_formatRgb() {
	  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	  return (a === 1 ? "rgb(" : "rgba(")
	      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	      + (a === 1 ? ")" : ", " + a + ")");
	}
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  formatHsl: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "hsl(" : "hsla(")
	        + (this.h || 0) + ", "
	        + (this.s || 0) * 100 + "%, "
	        + (this.l || 0) * 100 + "%"
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) return hcl2lab(o);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	function hcl2lab(o) {
	  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	  var h = o.h * deg2rad;
	  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return hcl2lab(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.cubehelix = cubehelix;
	exports.gray = gray;
	exports.hcl = hcl;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.lch = lch;
	exports.rgb = rgb;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
	  }
	
	  interval.floor = function(date) {
	    return floori(date = new Date(+date)), date;
	  };
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds());
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 405 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(38);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 407 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 408 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(245);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1045);
	
	var _runTransitionHook = __webpack_require__(245);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(108);
	
	var _PathUtils = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = format;
	
	var _templateFormatter = __webpack_require__(415);
	
	var _templateFormatter2 = _interopRequireDefault(_templateFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Formats `value` value preserving `caret` at the same character.
	//
	// `{ value, caret }` attribute is the result of `parse()` function call.
	//
	// Returns `{ text, caret }` where the new `caret` is the caret position
	// inside `text` text corresponding to the original `caret` position inside `value`.
	//
	// `formatter(value)` is a function returning `{ text, template }`.
	//
	// `text` is the `value` value formatted using `template`.
	// It may either cut off the non-filled right part of the `template`
	// or it may fill the non-filled character placeholders
	// in the right part of the `template` with `spacer`
	// which is a space (' ') character by default.
	//
	// `template` is the template used to format the `value`.
	// It can be either a full-length template or a partial template.
	//
	// `formatter` can also be a string — a `template`
	// where character placeholders are denoted by 'x'es.
	// In this case `formatter` function is automatically created.
	//
	// Example:
	//
	// `value` is '880',
	// `caret` is `2` (before the first `0`)
	//
	// `formatter` is `'880' =>
	//   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
	//
	// The result is `{ text: '8 (80 )', caret: 4 }`.
	//
	function format(value, caret, formatter) {
		if (typeof formatter === 'string') {
			formatter = (0, _templateFormatter2.default)(formatter);
		}
	
		var _ref = formatter(value) || {},
		    text = _ref.text,
		    template = _ref.template;
	
		if (text === undefined) {
			text = value;
		}
	
		if (template) {
			if (caret === undefined) {
				caret = text.length;
			} else {
				var index = 0;
				var found = false;
	
				var possibly_last_input_character_index = -1;
	
				while (index < text.length && index < template.length) {
					// Character placeholder found
					if (text[index] !== template[index]) {
						if (caret === 0) {
							found = true;
							caret = index;
							break;
						}
	
						possibly_last_input_character_index = index;
	
						caret--;
					}
	
					index++;
				}
	
				// If the caret was positioned after last input character,
				// then the text caret index is just after the last input character.
				if (!found) {
					caret = possibly_last_input_character_index + 1;
				}
			}
		}
	
		return { text: text, caret: caret };
	}
	//# sourceMappingURL=format.js.map

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(66);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _edit = __webpack_require__(1002);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _parse2 = __webpack_require__(414);
	
	var _parse3 = _interopRequireDefault(_parse2);
	
	var _format = __webpack_require__(412);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _dom = __webpack_require__(1001);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Input_controller = function () {
		function Input_controller(get_input_element, parse, format, on_change) {
			(0, _classCallCheck3.default)(this, Input_controller);
	
			_initialiseProps.call(this);
	
			if (typeof get_input_element !== 'function') {
				(function () {
					var element = get_input_element;
					get_input_element = function get_input_element() {
						return element;
					};
				})();
			}
	
			this.get_input_element = get_input_element;
			this.parse = parse;
			this.format = format;
			this.on_change = on_change;
		}
	
		// Special handling for "Cut" event because
		// it wouldn't copy to clipboard otherwise.
	
	
		// Intercepts "Delete" and "Backspace" keys
		// (hitting "Delete" or "Backspace"
		//  at any caret position should always result in
		//  erasing a digit)
	
	
		(0, _createClass3.default)(Input_controller, [{
			key: 'erase_selection',
	
	
			// Erases the selected text inside an `<input/>`
			value: function erase_selection(input, selection) {
				var text = input.value;
				text = text.slice(0, selection.start) + text.slice(selection.end);
	
				input.value = text;
				(0, _dom.setCaretPosition)(input, selection.start);
	
				return this.format_input_text();
			}
	
			// Formats <input/> textual value as a phone number
	
		}, {
			key: 'getParsedValue',
	
	
			// Parses `<input/>` text
			value: function getParsedValue() {
				// <input/> DOM element
				var input = this.get_input_element();
	
				return (0, _parse3.default)(input.value, undefined, this.parse);
			}
		}]);
		return Input_controller;
	}();
	
	var _initialiseProps = function _initialiseProps() {
		var _this = this;
	
		this.onCut = function (event) {
			setTimeout(_this.format_input_text, 0);
		};
	
		this.onPaste = function (event) {
			var input = _this.get_input_element();
	
			var selection = (0, _dom.getSelection)(input);
	
			// If selection is made,
			// just erase the selected text
			// prior to pasting
			if (selection) {
				_this.erase_selection(input, selection);
			}
	
			_this.format_input_text();
		};
	
		this.onChange = function (event) {
			_this.format_input_text();
		};
	
		this.onKeyDown = function (event) {
			var operation = (0, _dom.getOperation)(event);
	
			switch (operation) {
				case 'Delete':
				case 'Backspace':
					// Intercept this operation and perform it manually.
					event.preventDefault();
	
					var input = _this.get_input_element();
	
					var selection = (0, _dom.getSelection)(input);
	
					// If selection is made,
					// just erase the selected text,
					// and don't apply any more operations to it.
					if (selection) {
						_this.erase_selection(input, selection);
						return _this.format_input_text();
					}
	
					// Else, perform the (character erasing) operation manually
					return _this.format_input_text(operation);
			}
		};
	
		this.format_input_text = function (operation) {
			// <input/> DOM element
			var input = _this.get_input_element();
	
			var _parse = (0, _parse3.default)(input.value, (0, _dom.getCaretPosition)(input), _this.parse),
			    value = _parse.value,
			    caret = _parse.caret;
	
			// Apply the pending operation to the <input/> textual value (if any)
	
	
			if (operation) {
				var edit_result = (0, _edit2.default)(value, caret, operation);
	
				value = edit_result.value;
				caret = edit_result.caret;
			}
	
			// Format the <input/> textual value as a phone number
			// (and reposition the caret accordingly)
	
			var format_result = (0, _format2.default)(value, caret, _this.format);
	
			var text = format_result.text;
			caret = format_result.caret;
	
			// Set <input/> textual value manually to also set caret position
			// and prevent React from resetting the caret position later
			// inside subsequent `render()`.
			// Doesn't work for custom `inputComponent`s for some reason.
			input.value = text;
			// Set caret position (with the neccessary adjustments)
			(0, _dom.setCaretPosition)(input, caret);
	
			// <input/> textual value may have been changed,
			// so `value` may have been changed too.
			_this.on_change(value);
		};
	};
	
	exports.default = Input_controller;
	//# sourceMappingURL=input controller.js.map

/***/ },
/* 414 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = parse;
	// Parses the `text`.
	//
	// Returns `{ value, caret }` where `caret` is
	// the caret position inside `value`
	// corresponding to the `caret_position` inside `text`.
	//
	// The `text` is parsed by feeding each character sequentially to
	// `parse_character(character, value)` function
	// and appending the result (if it's not `undefined`) to `value`.
	//
	// Example:
	//
	// `text` is `8 (800) 555-35-35`,
	// `caret_position` is `4` (before the first `0`).
	// `parse_character` is `(character, value) =>
	//   if (character >= '0' && character <= '9') { return character }`.
	//
	// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
	//
	function parse(text, caret_position, parse_character) {
		var value = '';
	
		var focused_input_character_index = 0;
	
		var index = 0;
		while (index < text.length) {
			var character = parse_character(text[index], value);
	
			if (character !== undefined) {
				value += character;
	
				if (caret_position !== undefined) {
					if (caret_position === index) {
						focused_input_character_index = value.length - 1;
					} else if (caret_position > index) {
						focused_input_character_index = value.length;
					}
				}
			}
	
			index++;
		}
	
		// If caret position wasn't specified
		if (caret_position === undefined) {
			// Then set caret position to "after the last input character"
			focused_input_character_index = value.length;
		}
	
		var result = {
			value: value,
			caret: focused_input_character_index
		};
	
		return result;
	}
	//# sourceMappingURL=parse.js.map

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(81);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = template_formatter;
	
	var _helpers = __webpack_require__(246);
	
	var _closeBraces = __webpack_require__(1000);
	
	var _closeBraces2 = _interopRequireDefault(_closeBraces);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Takes a `template` where character placeholders
	// are denoted by 'x'es (e.g. 'x (xxx) xxx-xx-xx').
	//
	// Returns a function which takes `value` characters
	// and returns the `template` filled with those characters.
	// If the `template` can only be partially filled
	// then it is cut off.
	//
	// If `should_close_braces` is `true`,
	// then it will also make sure all dangling braces are closed,
	// e.g. "8 (8" -> "8 (8  )" (iPhone style phone number input).
	//
	function template_formatter(template) {
		var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
		var should_close_braces = arguments[2];
	
		if (!template) {
			return function (value) {
				return { text: value };
			};
		}
	
		var characters_in_template = (0, _helpers.count_occurences)(placeholder, template);
	
		return function (value) {
			if (!value) {
				return { text: '', template: template };
			}
	
			var value_character_index = 0;
			var filled_in_template = '';
	
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = (0, _getIterator3.default)(template), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var character = _step.value;
	
					if (character !== placeholder) {
						filled_in_template += character;
						continue;
					}
	
					filled_in_template += value[value_character_index];
					value_character_index++;
	
					// If the last available value character has been filled in,
					// then return the filled in template
					// (either trim the right part or retain it,
					//  if no more character placeholders in there)
					if (value_character_index === value.length) {
						// If there are more character placeholders
						// in the right part of the template
						// then simply trim it.
						if (value.length < characters_in_template) {
							break;
						}
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
	
			if (should_close_braces) {
				filled_in_template = (0, _closeBraces2.default)(filled_in_template, template);
			}
	
			return { text: filled_in_template, template: template };
		};
	}
	//# sourceMappingURL=template formatter.js.map

/***/ },
/* 416 */
/***/ function(module, exports) {

	module.exports = {
		"country_phone_code_to_countries": {
			"1": [
				"US",
				"AG",
				"AI",
				"AS",
				"BB",
				"BM",
				"BS",
				"CA",
				"DM",
				"DO",
				"GD",
				"GU",
				"JM",
				"KN",
				"KY",
				"LC",
				"MP",
				"MS",
				"PR",
				"SX",
				"TC",
				"TT",
				"VC",
				"VG",
				"VI"
			],
			"7": [
				"RU",
				"KZ"
			],
			"20": [
				"EG"
			],
			"27": [
				"ZA"
			],
			"30": [
				"GR"
			],
			"31": [
				"NL"
			],
			"32": [
				"BE"
			],
			"33": [
				"FR"
			],
			"34": [
				"ES"
			],
			"36": [
				"HU"
			],
			"39": [
				"IT",
				"VA"
			],
			"40": [
				"RO"
			],
			"41": [
				"CH"
			],
			"43": [
				"AT"
			],
			"44": [
				"GB",
				"GG",
				"IM",
				"JE"
			],
			"45": [
				"DK"
			],
			"46": [
				"SE"
			],
			"47": [
				"NO",
				"SJ"
			],
			"48": [
				"PL"
			],
			"49": [
				"DE"
			],
			"51": [
				"PE"
			],
			"52": [
				"MX"
			],
			"53": [
				"CU"
			],
			"54": [
				"AR"
			],
			"55": [
				"BR"
			],
			"56": [
				"CL"
			],
			"57": [
				"CO"
			],
			"58": [
				"VE"
			],
			"60": [
				"MY"
			],
			"61": [
				"AU",
				"CC",
				"CX"
			],
			"62": [
				"ID"
			],
			"63": [
				"PH"
			],
			"64": [
				"NZ"
			],
			"65": [
				"SG"
			],
			"66": [
				"TH"
			],
			"81": [
				"JP"
			],
			"82": [
				"KR"
			],
			"84": [
				"VN"
			],
			"86": [
				"CN"
			],
			"90": [
				"TR"
			],
			"91": [
				"IN"
			],
			"92": [
				"PK"
			],
			"93": [
				"AF"
			],
			"94": [
				"LK"
			],
			"95": [
				"MM"
			],
			"98": [
				"IR"
			],
			"211": [
				"SS"
			],
			"212": [
				"MA",
				"EH"
			],
			"213": [
				"DZ"
			],
			"216": [
				"TN"
			],
			"218": [
				"LY"
			],
			"220": [
				"GM"
			],
			"221": [
				"SN"
			],
			"222": [
				"MR"
			],
			"223": [
				"ML"
			],
			"224": [
				"GN"
			],
			"225": [
				"CI"
			],
			"226": [
				"BF"
			],
			"227": [
				"NE"
			],
			"228": [
				"TG"
			],
			"229": [
				"BJ"
			],
			"230": [
				"MU"
			],
			"231": [
				"LR"
			],
			"232": [
				"SL"
			],
			"233": [
				"GH"
			],
			"234": [
				"NG"
			],
			"235": [
				"TD"
			],
			"236": [
				"CF"
			],
			"237": [
				"CM"
			],
			"238": [
				"CV"
			],
			"239": [
				"ST"
			],
			"240": [
				"GQ"
			],
			"241": [
				"GA"
			],
			"242": [
				"CG"
			],
			"243": [
				"CD"
			],
			"244": [
				"AO"
			],
			"245": [
				"GW"
			],
			"246": [
				"IO"
			],
			"247": [
				"AC"
			],
			"248": [
				"SC"
			],
			"249": [
				"SD"
			],
			"250": [
				"RW"
			],
			"251": [
				"ET"
			],
			"252": [
				"SO"
			],
			"253": [
				"DJ"
			],
			"254": [
				"KE"
			],
			"255": [
				"TZ"
			],
			"256": [
				"UG"
			],
			"257": [
				"BI"
			],
			"258": [
				"MZ"
			],
			"260": [
				"ZM"
			],
			"261": [
				"MG"
			],
			"262": [
				"RE",
				"YT"
			],
			"263": [
				"ZW"
			],
			"264": [
				"NA"
			],
			"265": [
				"MW"
			],
			"266": [
				"LS"
			],
			"267": [
				"BW"
			],
			"268": [
				"SZ"
			],
			"269": [
				"KM"
			],
			"290": [
				"SH",
				"TA"
			],
			"291": [
				"ER"
			],
			"297": [
				"AW"
			],
			"298": [
				"FO"
			],
			"299": [
				"GL"
			],
			"350": [
				"GI"
			],
			"351": [
				"PT"
			],
			"352": [
				"LU"
			],
			"353": [
				"IE"
			],
			"354": [
				"IS"
			],
			"355": [
				"AL"
			],
			"356": [
				"MT"
			],
			"357": [
				"CY"
			],
			"358": [
				"FI",
				"AX"
			],
			"359": [
				"BG"
			],
			"370": [
				"LT"
			],
			"371": [
				"LV"
			],
			"372": [
				"EE"
			],
			"373": [
				"MD"
			],
			"374": [
				"AM"
			],
			"375": [
				"BY"
			],
			"376": [
				"AD"
			],
			"377": [
				"MC"
			],
			"378": [
				"SM"
			],
			"380": [
				"UA"
			],
			"381": [
				"RS"
			],
			"382": [
				"ME"
			],
			"385": [
				"HR"
			],
			"386": [
				"SI"
			],
			"387": [
				"BA"
			],
			"389": [
				"MK"
			],
			"420": [
				"CZ"
			],
			"421": [
				"SK"
			],
			"423": [
				"LI"
			],
			"500": [
				"FK"
			],
			"501": [
				"BZ"
			],
			"502": [
				"GT"
			],
			"503": [
				"SV"
			],
			"504": [
				"HN"
			],
			"505": [
				"NI"
			],
			"506": [
				"CR"
			],
			"507": [
				"PA"
			],
			"508": [
				"PM"
			],
			"509": [
				"HT"
			],
			"590": [
				"GP",
				"BL",
				"MF"
			],
			"591": [
				"BO"
			],
			"592": [
				"GY"
			],
			"593": [
				"EC"
			],
			"594": [
				"GF"
			],
			"595": [
				"PY"
			],
			"596": [
				"MQ"
			],
			"597": [
				"SR"
			],
			"598": [
				"UY"
			],
			"599": [
				"CW",
				"BQ"
			],
			"670": [
				"TL"
			],
			"672": [
				"NF"
			],
			"673": [
				"BN"
			],
			"674": [
				"NR"
			],
			"675": [
				"PG"
			],
			"676": [
				"TO"
			],
			"677": [
				"SB"
			],
			"678": [
				"VU"
			],
			"679": [
				"FJ"
			],
			"680": [
				"PW"
			],
			"681": [
				"WF"
			],
			"682": [
				"CK"
			],
			"683": [
				"NU"
			],
			"685": [
				"WS"
			],
			"686": [
				"KI"
			],
			"687": [
				"NC"
			],
			"688": [
				"TV"
			],
			"689": [
				"PF"
			],
			"690": [
				"TK"
			],
			"691": [
				"FM"
			],
			"692": [
				"MH"
			],
			"800": [
				"001"
			],
			"808": [
				"001"
			],
			"850": [
				"KP"
			],
			"852": [
				"HK"
			],
			"853": [
				"MO"
			],
			"855": [
				"KH"
			],
			"856": [
				"LA"
			],
			"870": [
				"001"
			],
			"878": [
				"001"
			],
			"880": [
				"BD"
			],
			"881": [
				"001"
			],
			"882": [
				"001"
			],
			"883": [
				"001"
			],
			"886": [
				"TW"
			],
			"888": [
				"001"
			],
			"960": [
				"MV"
			],
			"961": [
				"LB"
			],
			"962": [
				"JO"
			],
			"963": [
				"SY"
			],
			"964": [
				"IQ"
			],
			"965": [
				"KW"
			],
			"966": [
				"SA"
			],
			"967": [
				"YE"
			],
			"968": [
				"OM"
			],
			"970": [
				"PS"
			],
			"971": [
				"AE"
			],
			"972": [
				"IL"
			],
			"973": [
				"BH"
			],
			"974": [
				"QA"
			],
			"975": [
				"BT"
			],
			"976": [
				"MN"
			],
			"977": [
				"NP"
			],
			"979": [
				"001"
			],
			"992": [
				"TJ"
			],
			"993": [
				"TM"
			],
			"994": [
				"AZ"
			],
			"995": [
				"GE"
			],
			"996": [
				"KG"
			],
			"998": [
				"UZ"
			]
		},
		"countries": {
			"AC": [
				"247",
				"[46]\\d{4}|[01589]\\d{5}"
			],
			"AD": [
				"376",
				"[16]\\d{5,8}|[37-9]\\d{5}",
				[
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"[137-9]|6[0-8]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"180",
							"180[02]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"690"
						]
					]
				]
			],
			"AE": [
				"971",
				"[2-79]\\d{7,8}|800\\d{2,9}",
				[
					[
						"([2-4679])(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-4679][2-8]"
						]
					],
					[
						"(5\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"5"
						]
					],
					[
						"([479]00)(\\d)(\\d{5})",
						"$1 $2 $3",
						[
							"[479]00"
						],
						"$1"
					],
					[
						"([68]00)(\\d{2,9})",
						"$1 $2",
						[
							"[68]00"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"AF": [
				"93",
				"[2-7]\\d{8}",
				[
					[
						"([2-7]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-7]"
						]
					]
				],
				"0",
				"0$1"
			],
			"AG": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"268"
			],
			"AI": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"264"
			],
			"AL": [
				"355",
				"[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}",
				[
					[
						"(4)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"4[0-6]"
						]
					],
					[
						"(6\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"6"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2358][2-5]|4[7-9]"
						]
					],
					[
						"(\\d{3})(\\d{3,5})",
						"$1 $2",
						[
							"[235][16-9]|[79]|8[016-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"AM": [
				"374",
				"[1-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"1|47"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"4[1349]|[5-7]|88|9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[23]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"8|90"
						],
						"0 $1"
					]
				],
				"0",
				"(0$1)"
			],
			"AO": [
				"244",
				"[29]\\d{8}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				]
			],
			"AR": [
				"54",
				"11\\d{8}|[2368]\\d{9}|9\\d{10}",
				[
					[
						"([68]\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[68]"
						]
					],
					[
						"(9)(11)(\\d{4})(\\d{4})",
						"$2 15-$3-$4",
						[
							"911"
						],
						null,
						null,
						"$1 $2 $3-$4"
					],
					[
						"(9)(\\d{3})(\\d{3})(\\d{4})",
						"$2 15-$3-$4",
						[
							"9(?:2[2-4689]|3[3-8])",
							"9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"
						],
						null,
						null,
						"$1 $2 $3-$4"
					],
					[
						"(9)(\\d{4})(\\d{2})(\\d{4})",
						"$2 15-$3-$4",
						[
							"9[23]"
						],
						null,
						null,
						"$1 $2 $3-$4"
					],
					[
						"(11)(\\d{4})(\\d{4})",
						"$1 $2-$3",
						[
							"11"
						],
						null,
						"true"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"
						],
						null,
						"true"
					],
					[
						"(\\d{4})(\\d{2})(\\d{4})",
						"$1 $2-$3",
						[
							"[23]"
						],
						null,
						"true"
					]
				],
				"0",
				"0$1",
				"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?",
				"9$1"
			],
			"AS": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"684"
			],
			"AT": [
				"43",
				"[1-9]\\d{3,12}",
				[
					[
						"(116\\d{3})",
						"$1",
						[
							"116"
						],
						"$1"
					],
					[
						"(1)(\\d{3,12})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(5\\d)(\\d{3,5})",
						"$1 $2",
						[
							"5[079]"
						]
					],
					[
						"(5\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"5[079]"
						]
					],
					[
						"(5\\d)(\\d{4})(\\d{4,7})",
						"$1 $2 $3",
						[
							"5[079]"
						]
					],
					[
						"(\\d{3})(\\d{3,10})",
						"$1 $2",
						[
							"(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:[28]0|32)|[89]"
						]
					],
					[
						"(\\d{4})(\\d{3,9})",
						"$1 $2",
						[
							"2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:[24][1-8]|35|[5-79])"
						]
					]
				],
				"0",
				"0$1"
			],
			"AU": [
				"61",
				"1\\d{4,9}|[2-578]\\d{8}",
				[
					[
						"([2378])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"14|[45]"
						],
						"0$1"
					],
					[
						"(16)(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(16)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[389]0",
							"1(?:[38]0|9)0"
						]
					],
					[
						"(180)(2\\d{3})",
						"$1 $2",
						[
							"180",
							"1802"
						]
					],
					[
						"(19\\d)(\\d{3})",
						"$1 $2",
						[
							"19[13]"
						]
					],
					[
						"(19\\d{2})(\\d{4})",
						"$1 $2",
						[
							"19[679]"
						]
					],
					[
						"(13)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"13[1-9]"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"[237]\\d{8}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|[6-8]\\d{4}|9(?:[02-9]\\d{3}|1(?:[0-57-9]\\d{2}|6[0135-9]\\d)))\\d{3}",
					"14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12457-9]|9[017-9])\\d{6}",
					"180(?:0\\d{3}|2)\\d{3}",
					"19(?:0[0126]\\d|[679])\\d{5}",
					"500\\d{6}",
					null,
					null,
					"16\\d{3,7}",
					"550\\d{6}",
					"13(?:00\\d{3}|45[0-4]|\\d)\\d{3}"
				]
			],
			"AW": [
				"297",
				"[25-9]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"AX": [
				"358",
				"1\\d{5,11}|[35]\\d{5,9}|2\\d{4,9}|4\\d{5,10}|6\\d{7,9}|7\\d{4,9}|8\\d{6,9}",
				[
					[
						"(\\d{3})(\\d{3,7})",
						"$1 $2",
						[
							"(?:[1-3]0|[6-8])0"
						]
					],
					[
						"(75\\d{3})",
						"$1",
						[
							"75[12]"
						]
					],
					[
						"(116\\d{3})",
						"$1",
						[
							"116"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{4,10})",
						"$1 $2",
						[
							"[14]|2[09]|50|7[135]"
						]
					],
					[
						"(\\d)(\\d{4,11})",
						"$1 $2",
						[
							"[25689][1-8]|3"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"18[1-8]\\d{3,9}",
					"4\\d{5,10}|50\\d{4,8}",
					"800\\d{4,7}",
					"[67]00\\d{5,6}",
					null,
					null,
					"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})"
				]
			],
			"AZ": [
				"994",
				"[1-9]\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"1[28]|2(?:[0-36]|[45]2)|365"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[4-8]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"9"
						],
						"0$1"
					]
				],
				"0",
				"(0$1)"
			],
			"BA": [
				"387",
				"[3-9]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2-$3",
						[
							"[3-5]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6[1-356]|[7-9]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"6[047]"
						]
					]
				],
				"0",
				"0$1"
			],
			"BB": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"246"
			],
			"BD": [
				"880",
				"[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}",
				[
					[
						"(2)(\\d{7,8})",
						"$1-$2",
						[
							"2"
						]
					],
					[
						"(\\d{2})(\\d{4,6})",
						"$1-$2",
						[
							"[3-79]1"
						]
					],
					[
						"(\\d{4})(\\d{3,6})",
						"$1-$2",
						[
							"1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"
						]
					],
					[
						"(\\d{3})(\\d{3,7})",
						"$1-$2",
						[
							"[3-79][2-9]|8"
						]
					]
				],
				"0",
				"0$1"
			],
			"BE": [
				"32",
				"[1-9]\\d{7,8}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"4[6-9]"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]|4[23]|9[2-4]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[156]|7[018]|8(?:0[1-9]|[1-79])"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"(?:80|9)0"
						]
					]
				],
				"0",
				"0$1"
			],
			"BF": [
				"226",
				"[25-7]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"BG": [
				"359",
				"[23567]\\d{5,7}|[489]\\d{6,8}",
				[
					[
						"(2)(\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"2"
						]
					],
					[
						"(2)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"43[124-7]|70[1-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"43[124-7]|70[1-9]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[78]00"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"99[69]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"48|8[7-9]|9[08]"
						]
					]
				],
				"0",
				"0$1"
			],
			"BH": [
				"973",
				"[136-9]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"BI": [
				"257",
				"[267]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"BJ": [
				"229",
				"[2689]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2689]"
						]
					]
				]
			],
			"BL": [
				"590",
				"[56]\\d{8}",
				[
					[
						"([56]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2-$3",
						[
							"590|69[01]"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"590(?:2[7-9]|5[12]|87)\\d{4}",
					"69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}"
				]
			],
			"BM": [
				"1",
				"[4589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"441"
			],
			"BN": [
				"673",
				"[2-578]\\d{6}",
				[
					[
						"([2-578]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[2-578]"
						]
					]
				]
			],
			"BO": [
				"591",
				"[23467]\\d{7}|8\\d{8}",
				[
					[
						"([234])(\\d{7})",
						"$1 $2",
						[
							"[2-4]"
						]
					],
					[
						"([67]\\d{7})",
						"$1",
						[
							"[67]"
						]
					],
					[
						"(800)(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"800"
						]
					]
				],
				"0",
				null,
				"0(1\\d)?"
			],
			"BQ": [
				"599",
				"[347]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[13-7]"
						]
					],
					[
						"(9)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}",
					"(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"
				]
			],
			"BR": [
				"55",
				"[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"300|40[02]",
							"300|40(?:0|20)"
						]
					],
					[
						"([3589]00)(\\d{2,3})(\\d{4})",
						"$1 $2 $3",
						[
							"[3589]00"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2-$3",
						[
							"[1-9][1-9]"
						],
						"($1)"
					],
					[
						"(\\d{2})(\\d{5})(\\d{4})",
						"$1 $2-$3",
						[
							"[1-9][1-9]9"
						],
						"($1)"
					]
				],
				"0",
				null,
				"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
				"$2"
			],
			"BS": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"242"
			],
			"BT": [
				"975",
				"[1-8]\\d{6,7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"1|77"
						]
					],
					[
						"([2-8])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-68]|7[246]"
						]
					]
				]
			],
			"BW": [
				"267",
				"[2-79]\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-6]"
						]
					],
					[
						"(7\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7"
						]
					],
					[
						"(90)(\\d{5})",
						"$1 $2",
						[
							"90"
						]
					]
				]
			],
			"BY": [
				"375",
				"[1-4]\\d{8}|8(?:0(?:0\\d{3,7}|[13]\\d{7})|(?:10|20\\d)\\d{7})|9\\d{9,10}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"17[0-3589]|2[4-9]|[34]",
							"17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"
						],
						"8 0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])",
							"1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"
						],
						"8 0$1"
					],
					[
						"(\\d{4})(\\d{2})(\\d{3})",
						"$1 $2-$3",
						[
							"1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
							"1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
						],
						"8 0$1"
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8[01]|9"
						],
						"8 $1"
					],
					[
						"(82\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"82"
						],
						"8 $1"
					],
					[
						"(800)(\\d{3})",
						"$1 $2",
						[
							"800"
						],
						"8 $1"
					],
					[
						"(800)(\\d{2})(\\d{2,4})",
						"$1 $2 $3",
						[
							"800"
						],
						"8 $1"
					]
				],
				"8",
				null,
				"8?0?"
			],
			"BZ": [
				"501",
				"[2-8]\\d{6}|0\\d{10}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[2-8]"
						]
					],
					[
						"(0)(800)(\\d{4})(\\d{3})",
						"$1-$2-$3-$4",
						[
							"080",
							"0800"
						]
					]
				]
			],
			"CA": [
				"1",
				"[2-9]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				null,
				[
					"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
					null,
					"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
					"900[2-9]\\d{6}",
					"5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}"
				]
			],
			"CC": [
				"61",
				"[1458]\\d{5,9}",
				[
					[
						"([2378])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"14|[45]"
						],
						"0$1"
					],
					[
						"(16)(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(16)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[389]0",
							"1(?:[38]0|9)0"
						]
					],
					[
						"(180)(2\\d{3})",
						"$1 $2",
						[
							"180",
							"1802"
						]
					],
					[
						"(19\\d)(\\d{3})",
						"$1 $2",
						[
							"19[13]"
						]
					],
					[
						"(19\\d{2})(\\d{4})",
						"$1 $2",
						[
							"19[679]"
						]
					],
					[
						"(13)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"13[1-9]"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:08|22|68)|4[29]8|62\\d|70[23]|959))\\d{3}",
					"14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}",
					"180(?:0\\d{3}|2)\\d{3}",
					"19(?:0[0126]\\d|[679])\\d{5}",
					"500\\d{6}",
					null,
					null,
					null,
					"550\\d{6}",
					"13(?:00\\d{2})?\\d{4}"
				]
			],
			"CD": [
				"243",
				"[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"12"
						]
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8[0-2459]|9"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"88"
						]
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[1-6]"
						]
					]
				],
				"0",
				"0$1"
			],
			"CF": [
				"236",
				"[278]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"CG": [
				"242",
				"[028]\\d{8}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"801"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[02]"
						]
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"800"
						]
					]
				]
			],
			"CH": [
				"41",
				"[2-9]\\d{8}|860\\d{9}",
				[
					[
						"([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-7]|[89]1"
						]
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8[047]|90"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"860"
						]
					]
				],
				"0",
				"0$1"
			],
			"CI": [
				"225",
				"[02-8]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"CK": [
				"682",
				"[2-8]\\d{4}",
				[
					[
						"(\\d{2})(\\d{3})",
						"$1 $2"
					]
				]
			],
			"CL": [
				"56",
				"1230\\d{7}|[2-46-9]\\d{8,10}|5[1-3578]\\d{7}",
				[
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[23]"
						],
						"($1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[357]|4[1-35]|6[13-57]"
						],
						"($1)"
					],
					[
						"(9)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					],
					[
						"(44)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"44"
						]
					],
					[
						"([68]00)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[68]00"
						],
						"$1"
					],
					[
						"(600)(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"600"
						],
						"$1"
					],
					[
						"(1230)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"123",
							"1230"
						],
						"$1"
					],
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"219"
						],
						"($1)"
					]
				],
				"0",
				"0$1",
				"0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))"
			],
			"CM": [
				"237",
				"[2368]\\d{7,8}",
				[
					[
						"([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"[26]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]|88"
						]
					]
				]
			],
			"CN": [
				"86",
				"[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}",
				[
					[
						"([48]00)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[48]00"
						]
					],
					[
						"(\\d{2})(\\d{5,6})",
						"$1 $2",
						[
							"(?:10|2\\d)[19]",
							"(?:10|2\\d)(?:10|9[56])",
							"(?:10|2\\d)(?:100|9[56])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"[3-9]",
							"[3-9]\\d\\d[19]",
							"[3-9]\\d\\d(?:10|9[56])"
						],
						"0$1"
					],
					[
						"(21)(\\d{4})(\\d{4,6})",
						"$1 $2 $3",
						[
							"21"
						],
						"0$1",
						"true"
					],
					[
						"([12]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"10[1-9]|2[02-9]",
							"10[1-9]|2[02-9]",
							"10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"
						],
						"0$1",
						"true"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"
						],
						"0$1",
						"true"
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"
						],
						"0$1",
						"true"
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"807",
							"8078"
						],
						"0$1",
						"true"
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[3-57-9]|66)"
						]
					],
					[
						"(10800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"108",
							"1080",
							"10800"
						]
					],
					[
						"(\\d{3})(\\d{7,8})",
						"$1 $2",
						[
							"950"
						]
					]
				],
				"0",
				null,
				"(1(?:[129]\\d{3}|79\\d{2}))|0"
			],
			"CO": [
				"57",
				"(?:[13]\\d{0,3}|[24-8])\\d{7}",
				[
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"1(?:[2-7]|8[2-9]|9[0-3])|[24-8]",
							"1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"
						],
						"($1)"
					],
					[
						"(\\d{3})(\\d{7})",
						"$1 $2",
						[
							"3"
						]
					],
					[
						"(1)(\\d{3})(\\d{7})",
						"$1-$2-$3",
						[
							"1(?:80|9[04])",
							"1(?:800|9(?:0[01]|4[78]))"
						],
						"0$1",
						null,
						"$1 $2 $3"
					]
				],
				"0",
				null,
				"0([3579]|4(?:44|56))?"
			],
			"CR": [
				"506",
				"[24-9]\\d{7,9}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[24-7]|8[3-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[89]0"
						]
					]
				],
				null,
				null,
				"(19(?:0[012468]|1[09]|20|66|77|99))"
			],
			"CU": [
				"53",
				"[2-57]\\d{5,7}",
				[
					[
						"(\\d)(\\d{6,7})",
						"$1 $2",
						[
							"7"
						]
					],
					[
						"(\\d{2})(\\d{4,6})",
						"$1 $2",
						[
							"[2-4]"
						]
					],
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"5"
						],
						"0$1"
					]
				],
				"0",
				"(0$1)"
			],
			"CV": [
				"238",
				"[259]\\d{6}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"CW": [
				"599",
				"[134679]\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[13-7]"
						]
					],
					[
						"(9)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}",
					"9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}",
					null,
					null,
					null,
					null,
					null,
					"955\\d{5}",
					null,
					"60[0-2]\\d{4}"
				]
			],
			"CX": [
				"61",
				"[1458]\\d{5,9}",
				[
					[
						"([2378])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"14|[45]"
						],
						"0$1"
					],
					[
						"(16)(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(16)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[389]0",
							"1(?:[38]0|9)0"
						]
					],
					[
						"(180)(2\\d{3})",
						"$1 $2",
						[
							"180",
							"1802"
						]
					],
					[
						"(19\\d)(\\d{3})",
						"$1 $2",
						[
							"19[13]"
						]
					],
					[
						"(19\\d{2})(\\d{4})",
						"$1 $2",
						[
							"19[679]"
						]
					],
					[
						"(13)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"13[1-9]"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:21|49|78|81)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
					"14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}",
					"180(?:0\\d{3}|2)\\d{3}",
					"19(?:0[0126]\\d|[679])\\d{5}",
					"500\\d{6}",
					null,
					null,
					null,
					"550\\d{6}",
					"13(?:00\\d{2})?\\d{4}"
				]
			],
			"CY": [
				"357",
				"[257-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2"
					]
				]
			],
			"CZ": [
				"420",
				"[2-8]\\d{8}|9\\d{8,11}",
				[
					[
						"([2-9]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-8]|9[015-7]"
						]
					],
					[
						"(96\\d)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"96"
						]
					],
					[
						"(9\\d)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"9[36]"
						]
					]
				]
			],
			"DE": [
				"49",
				"[1-35-9]\\d{3,14}|4(?:[0-8]\\d{3,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})",
				[
					[
						"(1\\d{2})(\\d{7,8})",
						"$1 $2",
						[
							"1[67]"
						]
					],
					[
						"(15\\d{3})(\\d{6})",
						"$1 $2",
						[
							"15[0568]"
						]
					],
					[
						"(1\\d{3})(\\d{7})",
						"$1 $2",
						[
							"15"
						]
					],
					[
						"(\\d{2})(\\d{3,11})",
						"$1 $2",
						[
							"3[02]|40|[68]9"
						]
					],
					[
						"(\\d{3})(\\d{3,11})",
						"$1 $2",
						[
							"2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)"
						]
					],
					[
						"(\\d{4})(\\d{2,11})",
						"$1 $2",
						[
							"[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|[7-9](?:0[1-9]|[1-9])",
							"[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[1346]|8[13568])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|[7-9](?:0[1-9]|[1-9])"
						]
					],
					[
						"(3\\d{4})(\\d{1,10})",
						"$1 $2",
						[
							"3"
						]
					],
					[
						"(800)(\\d{7,12})",
						"$1 $2",
						[
							"800"
						]
					],
					[
						"(\\d{3})(\\d)(\\d{4,10})",
						"$1 $2 $3",
						[
							"1(?:37|80)|900",
							"1(?:37|80)|900[1359]"
						]
					],
					[
						"(1\\d{2})(\\d{5,11})",
						"$1 $2",
						[
							"181"
						]
					],
					[
						"(18\\d{3})(\\d{6})",
						"$1 $2",
						[
							"185",
							"1850",
							"18500"
						]
					],
					[
						"(18\\d{2})(\\d{7})",
						"$1 $2",
						[
							"18[68]"
						]
					],
					[
						"(18\\d)(\\d{8})",
						"$1 $2",
						[
							"18[2-579]"
						]
					],
					[
						"(700)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"700"
						]
					],
					[
						"(138)(\\d{4})",
						"$1 $2",
						[
							"138"
						]
					],
					[
						"(15[013-68])(\\d{2})(\\d{8})",
						"$1 $2 $3",
						[
							"15[013-68]"
						]
					],
					[
						"(15[279]\\d)(\\d{2})(\\d{7})",
						"$1 $2 $3",
						[
							"15[279]"
						]
					],
					[
						"(1[67]\\d)(\\d{2})(\\d{7,8})",
						"$1 $2 $3",
						[
							"1(?:6[023]|7)"
						]
					]
				],
				"0",
				"0$1"
			],
			"DJ": [
				"253",
				"[27]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"DK": [
				"45",
				"[2-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"DM": [
				"1",
				"[57-9]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"767"
			],
			"DO": [
				"1",
				"[589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"8[024]9"
			],
			"DZ": [
				"213",
				"(?:[1-4]|[5-9]\\d)\\d{7}",
				[
					[
						"([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[1-4]"
						]
					],
					[
						"([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[5-8]"
						]
					],
					[
						"(9\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"9"
						]
					]
				],
				"0",
				"0$1"
			],
			"EC": [
				"593",
				"1\\d{9,10}|[2-8]\\d{7}|9\\d{8}",
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"[247]|[356][2-8]"
						],
						null,
						null,
						"$1-$2-$3"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					],
					[
						"(1800)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"180",
							"1800"
						],
						"$1"
					]
				],
				"0",
				"(0$1)"
			],
			"EE": [
				"372",
				"[3-9]\\d{6,7}|800\\d{6,7}",
				[
					[
						"([3-79]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]",
							"[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"
						]
					],
					[
						"(70)(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"70"
						]
					],
					[
						"(8000)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"800",
							"8000"
						]
					],
					[
						"([458]\\d{3})(\\d{3,4})",
						"$1 $2",
						[
							"40|5|8(?:00|[1-5])",
							"40|5|8(?:00[1-9]|[1-5])"
						]
					]
				]
			],
			"EG": [
				"20",
				"1\\d{4,9}|[24-6]\\d{8}|3\\d{7}|[89]\\d{8,9}",
				[
					[
						"(\\d)(\\d{7,8})",
						"$1 $2",
						[
							"[23]"
						]
					],
					[
						"(\\d{2})(\\d{6,7})",
						"$1 $2",
						[
							"1(?:3|5[239])|[4-6]|[89][2-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[0-25]|[89]00"
						]
					]
				],
				"0",
				"0$1"
			],
			"EH": [
				"212",
				"[5-9]\\d{8}",
				[
					[
						"([5-7]\\d{2})(\\d{6})",
						"$1-$2",
						[
							"5(?:2[015-7]|3[0-4])|[67]"
						]
					],
					[
						"([58]\\d{3})(\\d{5})",
						"$1-$2",
						[
							"5(?:2[2-489]|3[5-9]|92)|892",
							"5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"
						]
					],
					[
						"(5\\d{4})(\\d{4})",
						"$1-$2",
						[
							"5(?:29|38)",
							"5(?:29|38)[89]"
						]
					],
					[
						"([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5(?:4[067]|5[03])"
						]
					],
					[
						"(8[09])(\\d{7})",
						"$1-$2",
						[
							"8(?:0|9[013-9])"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				"528[89]"
			],
			"ER": [
				"291",
				"[178]\\d{6}",
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				],
				"0",
				"0$1"
			],
			"ES": [
				"34",
				"[5-9]\\d{8}",
				[
					[
						"([89]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[89]00"
						]
					],
					[
						"([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[568]|[79][0-8]"
						]
					]
				]
			],
			"ET": [
				"251",
				"[1-59]\\d{8}",
				[
					[
						"([1-59]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-59]"
						]
					]
				],
				"0",
				"0$1"
			],
			"FI": [
				"358",
				"1\\d{4,11}|[2-9]\\d{4,10}",
				[
					[
						"(\\d{3})(\\d{3,7})",
						"$1 $2",
						[
							"(?:[1-3]0|[6-8])0"
						]
					],
					[
						"(75\\d{3})",
						"$1",
						[
							"75[12]"
						]
					],
					[
						"(116\\d{3})",
						"$1",
						[
							"116"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{4,10})",
						"$1 $2",
						[
							"[14]|2[09]|50|7[135]"
						]
					],
					[
						"(\\d)(\\d{4,11})",
						"$1 $2",
						[
							"[25689][1-8]|3"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"1(?:[3569][1-8]\\d{3,9}|[47]\\d{5,10})|2[1-8]\\d{3,9}|3(?:[1-8]\\d{3,9}|9\\d{4,8})|[5689][1-8]\\d{3,9}",
					"4(?:[0-8]\\d{4,9}|9\\d{3,8})|50\\d{4,8}",
					"800\\d{4,7}",
					"[67]00\\d{5,6}",
					null,
					null,
					"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{3,7})"
				]
			],
			"FJ": [
				"679",
				"[2-9]\\d{6}|0\\d{10}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-9]"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0"
						]
					]
				]
			],
			"FK": [
				"500",
				"[2-7]\\d{4}"
			],
			"FM": [
				"691",
				"[39]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"FO": [
				"298",
				"[2-9]\\d{5}",
				[
					[
						"(\\d{6})",
						"$1"
					]
				],
				null,
				null,
				"(10(?:01|[12]0|88))"
			],
			"FR": [
				"33",
				"[1-9]\\d{8}",
				[
					[
						"([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"[1-79]"
						]
					],
					[
						"(8\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0 $1"
					]
				],
				"0",
				"0$1"
			],
			"GA": [
				"241",
				"0?\\d{7}",
				[
					[
						"(\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-7]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"0"
						]
					]
				]
			],
			"GB": [
				"44",
				"\\d{7,10}",
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-57-9]|62)",
							"7(?:[1-57-9]|624)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[02-9]1|1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:(?:38|69)7|5(?:24|39)|768|946)",
							"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"(800)(\\d{6})",
						"$1 $2",
						[
							"800"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d)\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}",
					"7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}",
					"80(?:0(?:1111|\\d{6,7})|8\\d{7})",
					"(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}",
					"70\\d{8}",
					null,
					"(?:3[0347]|55)\\d{8}",
					"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",
					"56\\d{8}",
					"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"
				]
			],
			"GD": [
				"1",
				"[4589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"473"
			],
			"GE": [
				"995",
				"[34578]\\d{8}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[348]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5"
						]
					]
				],
				"0"
			],
			"GF": [
				"594",
				"[56]\\d{8}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"0",
				"0$1"
			],
			"GG": [
				"44",
				"[135789]\\d{6,9}",
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-57-9]|62)",
							"7(?:[1-57-9]|624)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[02-9]1|1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:(?:38|69)7|5(?:24|39)|768|946)",
							"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"(800)(\\d{6})",
						"$1 $2",
						[
							"800"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"1481[25-9]\\d{5}",
					"7(?:781\\d|839\\d|911[17])\\d{5}",
					"80(?:0(?:1111|\\d{6,7})|8\\d{7})",
					"(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}",
					"70\\d{8}",
					null,
					"(?:3[0347]|55)\\d{8}",
					"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",
					"56\\d{8}",
					"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"
				]
			],
			"GH": [
				"233",
				"[235]\\d{8}|8\\d{7}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[235]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"GI": [
				"350",
				"[256]\\d{7}",
				[
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"2"
						]
					]
				]
			],
			"GL": [
				"299",
				"[1-689]\\d{5}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"GM": [
				"220",
				"[2-9]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"GN": [
				"224",
				"[367]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"3"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[67]"
						]
					]
				]
			],
			"GP": [
				"590",
				"[56]\\d{8}",
				[
					[
						"([56]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2-$3",
						[
							"590|69[01]"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}",
					"69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}"
				]
			],
			"GQ": [
				"240",
				"[23589]\\d{8}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[235]"
						]
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"[89]"
						]
					]
				]
			],
			"GR": [
				"30",
				"[26-9]\\d{9}",
				[
					[
						"([27]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"21|7"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2[2-9]1|[689]"
						]
					],
					[
						"(2\\d{3})(\\d{6})",
						"$1 $2",
						[
							"2[2-9][02-9]"
						]
					]
				]
			],
			"GT": [
				"502",
				"[2-7]\\d{7}|1[89]\\d{9}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2-7]"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				]
			],
			"GU": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"671"
			],
			"GW": [
				"245",
				"(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"44|9[5-7]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"40"
						]
					]
				]
			],
			"GY": [
				"592",
				"[2-46-9]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"HK": [
				"852",
				"[2-7]\\d{7}|8[0-3]\\d{6,7}|9\\d{4,10}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2-7]|[89](?:0[1-9]|[1-9])"
						]
					],
					[
						"(800)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"800"
						]
					],
					[
						"(900)(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"900"
						]
					],
					[
						"(900)(\\d{2,5})",
						"$1 $2",
						[
							"900"
						]
					]
				]
			],
			"HN": [
				"504",
				"[237-9]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1-$2"
					]
				]
			],
			"HR": [
				"385",
				"[1-7]\\d{5,8}|[89]\\d{6,8}",
				[
					[
						"(1)(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"([2-5]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-5]"
						]
					],
					[
						"(9\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"9"
						]
					],
					[
						"(6[01])(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"6[01]"
						]
					],
					[
						"([67]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[67]"
						]
					],
					[
						"(80[01])(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"80[01]"
						]
					],
					[
						"(80[01])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"80[01]"
						]
					]
				],
				"0",
				"0$1"
			],
			"HT": [
				"509",
				"[2-489]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3"
					]
				]
			],
			"HU": [
				"36",
				"[1-9]\\d{7,8}",
				[
					[
						"(1)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-9]"
						]
					]
				],
				"06",
				"($1)"
			],
			"ID": [
				"62",
				"(?:[1-79]\\d{6,10}|8\\d{7,11})",
				[
					[
						"(\\d{2})(\\d{5,8})",
						"$1 $2",
						[
							"2[124]|[36]1"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{5,8})",
						"$1 $2",
						[
							"2[035-9]|[36][02-9]|[4579]"
						],
						"(0$1)"
					],
					[
						"(8\\d{2})(\\d{3,4})(\\d{3})",
						"$1-$2-$3",
						[
							"8[1-35-9]"
						]
					],
					[
						"(8\\d{2})(\\d{4})(\\d{4,5})",
						"$1-$2-$3",
						[
							"8[1-35-9]"
						]
					],
					[
						"(1)(500)(\\d{3})",
						"$1 $2 $3",
						[
							"150",
							"1500"
						],
						"$1"
					],
					[
						"(177)(\\d{6,8})",
						"$1 $2",
						[
							"177"
						]
					],
					[
						"(800)(\\d{5,7})",
						"$1 $2",
						[
							"800"
						]
					],
					[
						"(804)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"804"
						]
					],
					[
						"(80\\d)(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"80[79]"
						]
					]
				],
				"0",
				"0$1"
			],
			"IE": [
				"353",
				"[124-9]\\d{6,9}",
				[
					[
						"(1)(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"2[24-9]|47|58|6[237-9]|9[35-9]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"40[24]|50[45]"
						]
					],
					[
						"(48)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"48"
						]
					],
					[
						"(818)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"818"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[24-69]|7[14]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"76|8[35-9]"
						],
						"0$1"
					],
					[
						"(8\\d)(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"8[35-9]5"
						],
						"0$1"
					],
					[
						"(700)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"700"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:5|8[059])",
							"1(?:5|8[059]0)"
						],
						"$1"
					]
				],
				"0",
				"(0$1)"
			],
			"IL": [
				"972",
				"1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}",
				[
					[
						"([2-489])(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[2-489]"
						],
						"0$1"
					],
					[
						"([57]\\d)(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[57]"
						],
						"0$1"
					],
					[
						"(153)(\\d{1,2})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"153"
						]
					],
					[
						"(1)([7-9]\\d{2})(\\d{3})(\\d{3})",
						"$1-$2-$3-$4",
						[
							"1[7-9]"
						]
					],
					[
						"(1255)(\\d{3})",
						"$1-$2",
						[
							"125",
							"1255"
						]
					],
					[
						"(1200)(\\d{3})(\\d{3})",
						"$1-$2-$3",
						[
							"120",
							"1200"
						]
					],
					[
						"(1212)(\\d{2})(\\d{2})",
						"$1-$2-$3",
						[
							"121",
							"1212"
						]
					],
					[
						"(1599)(\\d{6})",
						"$1-$2",
						[
							"159",
							"1599"
						]
					],
					[
						"(151)(\\d{1,2})(\\d{3})(\\d{4})",
						"$1-$2 $3-$4",
						[
							"151"
						]
					],
					[
						"(\\d{4})",
						"*$1",
						[
							"[2-689]"
						]
					]
				],
				"0"
			],
			"IM": [
				"44",
				"[135789]\\d{6,9}",
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-57-9]|62)",
							"7(?:[1-57-9]|624)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[02-9]1|1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:(?:38|69)7|5(?:24|39)|768|946)",
							"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"(800)(\\d{6})",
						"$1 $2",
						[
							"800"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"1624[5-8]\\d{5}",
					"7(?:4576|[59]24\\d|624[0-4689])\\d{5}",
					"808162\\d{4}",
					"(?:872299|90[0167]624)\\d{4}",
					"70\\d{8}",
					null,
					"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}",
					null,
					"56\\d{8}",
					"8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}"
				]
			],
			"IN": [
				"91",
				"008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}",
				[
					[
						"(\\d{8})",
						"$1",
						[
							"561",
							"5616",
							"56161"
						],
						"$1"
					],
					[
						"(\\d{5})(\\d{5})",
						"$1 $2",
						[
							"6(?:[09]0|2[03689]|3[05-9])|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9",
							"6(?:[09]0|2(?:0[01]|39|60|8[0-2]|9[04])|3(?:0[01]|5[0-2]|60|7[05]|81|9[03-5]))|7(?:[07]|19[0-5]|2(?:[0235-9]|[14][017-9])|3(?:[025-9]|[134][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02-46-9]|[15][017-9])|6(?:[02-9]|1[0-257-9])|8(?:[0-79]|8[0189])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:[014][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9",
							"6(?:[09]0|2(?:0[01]|39|60|8[0-2]|9[04])|3(?:0[01]|5[0-2]|60|7[05]|81|9[03-5]))|7(?:0|19[0-5]|2(?:[0235-79]|[14][017-9]|8(?:[0-69]|[78][089]))|3(?:[05-8]|1(?:[0189]|7[5-9])|2(?:[0-49][089]|[5-8])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2-5][089]|7[0189]))|4(?:[056]|1(?:[0135-9]|[24][089])|[29](?:[0-7][089]|[89])|3(?:[0-8][089]|9)|[47](?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389]))|5(?:[0346-9]|[15][017-9]|2(?:[03-9]|[12][089]))|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[05-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:0(?:[089]|7[02])|[14](?:[089]|7[02-8])|[235-9])|3(?:[03-57-9]|1(?:[089]|7[02-6])|2(?:[09]|77|8[0-689])|6(?:[089]|7[02-7]))|[45]|6(?:[02457-9]|[136](?:[089]|7[02-8]))|7(?:0[07-9]|[1-69]|[78](?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-68]))|9(?:[02-9]|1(?:[0289]|7[2-6])))|9"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"11|2[02]|33|4[04]|79[1-9]|80[2-46]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68][1-9]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:[23579]|[468][1-9])|[2-8]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"008"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"140"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"160",
							"1600"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{4,5})",
						"$1 $2",
						[
							"180",
							"1800"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{2,4})(\\d{4})",
						"$1 $2 $3",
						[
							"180",
							"1800"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"186",
							"1860"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"18[06]"
						],
						"$1"
					]
				],
				"0",
				"0$1",
				null,
				null,
				true
			],
			"IO": [
				"246",
				"3\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"IQ": [
				"964",
				"[1-7]\\d{7,9}",
				[
					[
						"(1)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"([2-6]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-6]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"0",
				"0$1"
			],
			"IR": [
				"98",
				"[1-8]\\d{5,9}|9(?:[0-4]\\d{8}|9\\d{8})",
				[
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-8]"
						]
					],
					[
						"(\\d{2})(\\d{4,5})",
						"$1 $2",
						[
							"[1-8]"
						]
					],
					[
						"(\\d{4,5})",
						"$1",
						[
							"96"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				"0",
				"0$1"
			],
			"IS": [
				"354",
				"[4-9]\\d{6}|38\\d{7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[4-9]"
						]
					],
					[
						"(3\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				]
			],
			"IT": [
				"39",
				"[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})",
				[
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[26]|55"
						]
					],
					[
						"(0[26])(\\d{4})(\\d{5})",
						"$1 $2 $3",
						[
							"0[26]"
						]
					],
					[
						"(0[26])(\\d{4,6})",
						"$1 $2",
						[
							"0[26]"
						]
					],
					[
						"(0\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][0159]"
						]
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"0[13-57-9][0159]|8(?:03|4[17]|9[245])",
							"0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
						]
					],
					[
						"(0\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(0\\d{3})(\\d{2,6})",
						"$1 $2",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[13]|8(?:00|4[08]|9[59])",
							"[13]|8(?:00|4[08]|9(?:5[5-9]|9))"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"894",
							"894[5-9]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})",
					"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})",
					"80(?:0\\d{6}|3\\d{3})",
					"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})",
					"1(?:78\\d|99)\\d{6}",
					null,
					null,
					null,
					"55\\d{8}",
					"84(?:[08]\\d{6}|[17]\\d{3})"
				]
			],
			"JE": [
				"44",
				"[135789]\\d{6,9}",
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-57-9]|62)",
							"7(?:[1-57-9]|624)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[02-9]1|1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:(?:38|69)7|5(?:24|39)|768|946)",
							"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"(800)(\\d{6})",
						"$1 $2",
						[
							"800"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"1534[0-24-8]\\d{5}",
					"7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}",
					"80(?:07(?:35|81)|8901)\\d{4}",
					"(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
					"701511\\d{4}",
					null,
					"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}",
					"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",
					"56\\d{8}",
					"8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}"
				]
			],
			"JM": [
				"1",
				"[589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"876"
			],
			"JO": [
				"962",
				"[235-9]\\d{7,8}",
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2356]|87"
						],
						"(0$1)"
					],
					[
						"(7)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"7[457-9]"
						]
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"70"
						]
					],
					[
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"8[0158]|9"
						]
					]
				],
				"0",
				"0$1"
			],
			"JP": [
				"81",
				"[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1-$2-$3",
						[
							"(?:12|57|99)0"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"800"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"[2579]0|80[1-9]"
						]
					],
					[
						"(\\d{4})(\\d)(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)",
							"1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])",
							"1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"2(?:[34]7|[56]9|74|9[14-79])|82|993"
						]
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"3|4(?:2[09]|7[01])|6[1-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[2479][1-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"KE": [
				"254",
				"20\\d{6,7}|[4-9]\\d{6,9}",
				[
					[
						"(\\d{2})(\\d{5,7})",
						"$1 $2",
						[
							"[24-6]"
						]
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				],
				"0",
				"0$1",
				"005|0"
			],
			"KG": [
				"996",
				"[235-8]\\d{8,9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[25-7]|31[25]"
						]
					],
					[
						"(\\d{4})(\\d{5})",
						"$1 $2",
						[
							"3(?:1[36]|[2-9])"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d)(\\d{3})",
						"$1 $2 $3 $4",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"KH": [
				"855",
				"[1-9]\\d{7,9}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"1\\d[1-9]|[2-9]"
						],
						"0$1"
					],
					[
						"(1[89]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[89]0",
							"1[89]00"
						]
					]
				],
				"0"
			],
			"KI": [
				"686",
				"[2458]\\d{4}|3\\d{4,7}|[67]\\d{7}",
				[],
				null,
				null,
				"0"
			],
			"KM": [
				"269",
				"[3478]\\d{6}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"KN": [
				"1",
				"[589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"869"
			],
			"KP": [
				"850",
				"1\\d{9}|[28]\\d{7}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"KR": [
				"82",
				"00(?:3\\d{8,9}|7\\d{9,11})|[1-7]\\d{4,9}|8\\d{8}",
				[
					[
						"(\\d{2})(\\d{3,4})",
						"$1-$2",
						[
							"(?:3[1-3]|[46][1-4]|5[1-5])1"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"1(?:5[246-9]|6[046-8]|8[03579])",
							"1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"
						],
						"$1"
					],
					[
						"(\\d{5})",
						"$1",
						[
							"1[016-9]1",
							"1[016-9]11",
							"1[016-9]114"
						]
					],
					[
						"(\\d)(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"2[1-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"60[2-9]|80"
						]
					],
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"[57]0"
						]
					]
				],
				"0",
				"0$1",
				"0(8[1-46-8]|85\\d{2})?"
			],
			"KW": [
				"965",
				"[12569]\\d{6,7}",
				[
					[
						"(\\d{4})(\\d{3,4})",
						"$1 $2",
						[
							"[16]|2(?:[0-35-9]|4[0-35-9])|52[25]|9[024-9]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"244|5(?:[015]|6[56])"
						]
					]
				]
			],
			"KY": [
				"1",
				"[3589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"345"
			],
			"KZ": [
				"7",
				"(?:33\\d|7\\d{2}|80[089])\\d{7}",
				[
					[
						"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"[3489]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"8",
				null,
				null,
				null,
				null,
				null,
				[
					"33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}",
					"7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}",
					"800\\d{7}",
					"809\\d{7}",
					"808\\d{7}",
					null,
					null,
					null,
					"751\\d{7}"
				]
			],
			"LA": [
				"856",
				"[2-8]\\d{7,9}",
				[
					[
						"(20)(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"20"
						]
					],
					[
						"([2-8]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2[13]|3[14]|[4-8]"
						]
					],
					[
						"(30)(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"30"
						]
					]
				],
				"0",
				"0$1"
			],
			"LB": [
				"961",
				"[13-9]\\d{6,7}",
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
						],
						"0$1"
					],
					[
						"([7-9]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7(?:[01]|6[013-9]|8[89]|9[1-3])|[89][01]"
						]
					]
				],
				"0"
			],
			"LC": [
				"1",
				"[5789]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"758"
			],
			"LI": [
				"423",
				"6\\d{8}|[23789]\\d{6}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[237-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6[56]"
						]
					],
					[
						"(69)(7\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"697"
						]
					]
				],
				"0",
				null,
				"0|10(?:01|20|66)"
			],
			"LK": [
				"94",
				"[1-9]\\d{8}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[1-689]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"0",
				"0$1"
			],
			"LR": [
				"231",
				"2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}",
				[
					[
						"(2\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([4-5])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[45]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[23578]"
						]
					]
				],
				"0",
				"0$1"
			],
			"LS": [
				"266",
				"[2568]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"LT": [
				"370",
				"[3-9]\\d{7}",
				[
					[
						"([34]\\d)(\\d{6})",
						"$1 $2",
						[
							"37|4(?:1|5[45]|6[2-4])"
						]
					],
					[
						"([3-6]\\d{2})(\\d{5})",
						"$1 $2",
						[
							"3[148]|4(?:[24]|6[09])|528|6"
						]
					],
					[
						"([7-9]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[7-9]"
						],
						"8 $1"
					],
					[
						"(5)(2\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"52[0-79]"
						]
					]
				],
				"8",
				"(8-$1)",
				"[08]",
				null,
				true
			],
			"LU": [
				"352",
				"[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})",
				[
					[
						"(\\d{2})(\\d{3})",
						"$1 $2",
						[
							"[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"20"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4",
						[
							"2(?:[0367]|4[3-8])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"20"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4 $5",
						[
							"2(?:[0367]|4[3-8])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})",
						"$1 $2 $3 $4",
						[
							"2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:0[2-9]|[1-9])|9(?:0[2-46-9]|[1-9])"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"70|80[01]|90[015]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6"
						]
					]
				],
				null,
				null,
				"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)"
			],
			"LV": [
				"371",
				"[2689]\\d{7}",
				[
					[
						"([2689]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2689]"
						]
					]
				]
			],
			"LY": [
				"218",
				"[25679]\\d{8}",
				[
					[
						"([25-79]\\d)(\\d{7})",
						"$1-$2",
						[
							"[25-79]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MA": [
				"212",
				"[5-9]\\d{8}",
				[
					[
						"([5-7]\\d{2})(\\d{6})",
						"$1-$2",
						[
							"5(?:2[015-7]|3[0-4])|[67]"
						]
					],
					[
						"([58]\\d{3})(\\d{5})",
						"$1-$2",
						[
							"5(?:2[2-489]|3[5-9]|92)|892",
							"5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"
						]
					],
					[
						"(5\\d{4})(\\d{4})",
						"$1-$2",
						[
							"5(?:29|38)",
							"5(?:29|38)[89]"
						]
					],
					[
						"([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5(?:4[067]|5[03])"
						]
					],
					[
						"(8[09])(\\d{7})",
						"$1-$2",
						[
							"8(?:0|9[013-9])"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				null,
				[
					"5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}",
					"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[07]))\\d{6}",
					"80\\d{7}",
					"89\\d{7}",
					null,
					null,
					null,
					null,
					"5924[01]\\d{4}"
				]
			],
			"MC": [
				"377",
				"[34689]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[39]"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"4"
						]
					],
					[
						"(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"6"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"8"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"MD": [
				"373",
				"[235-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"22|3"
						]
					],
					[
						"([25-7]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"2[13-9]|[5-7]"
						]
					],
					[
						"([89]\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[89]"
						]
					]
				],
				"0",
				"0$1"
			],
			"ME": [
				"382",
				"[2-9]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-57-9]|6[036-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MF": [
				"590",
				"[56]\\d{8}",
				[
					[
						"([56]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2-$3",
						[
							"590|69[01]"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				null,
				[
					"590(?:0[079]|13|2[79]|30|43|5[0-268]|7[79]|87)\\d{4}",
					"69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}"
				]
			],
			"MG": [
				"261",
				"[23]\\d{8}",
				[
					[
						"([23]\\d)(\\d{2})(\\d{3})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MH": [
				"692",
				"[2-6]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2"
					]
				],
				"1"
			],
			"MK": [
				"389",
				"[2-578]\\d{7}",
				[
					[
						"(2)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([347]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[347]"
						]
					],
					[
						"([58]\\d{2})(\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[58]"
						]
					]
				],
				"0",
				"0$1"
			],
			"ML": [
				"223",
				"[246-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[246-9]"
						]
					]
				]
			],
			"MM": [
				"95",
				"[178]\\d{5,7}|[24-6]\\d{5,8}|9(?:[279]\\d{0,2}|5|[34]\\d{1,2}|6(?:\\d{1,2})?|8(?:\\d{2})?)\\d{6}",
				[
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"1|2[245]"
						]
					],
					[
						"(2)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"251"
						]
					],
					[
						"(\\d)(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"16|2"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"432|67|81"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[4-8]"
						]
					],
					[
						"(9)(\\d{3})(\\d{4,6})",
						"$1 $2 $3",
						[
							"9(?:2[0-4]|[35-9]|4[137-9])"
						]
					],
					[
						"(9)([34]\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"9(?:3[0-36]|4[0-57-9])"
						]
					],
					[
						"(9)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"92[56]"
						]
					],
					[
						"(9)(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"93"
						]
					]
				],
				"0",
				"0$1"
			],
			"MN": [
				"976",
				"[12]\\d{7,9}|[57-9]\\d{7}",
				[
					[
						"([12]\\d)(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[12]1"
						]
					],
					[
						"([12]2\\d)(\\d{5,6})",
						"$1 $2",
						[
							"[12]2[1-3]"
						]
					],
					[
						"([12]\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[12](?:27|[3-5])",
							"[12](?:27|[3-5]\\d)2"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[57-9]"
						],
						"$1"
					],
					[
						"([12]\\d{4})(\\d{4,5})",
						"$1 $2",
						[
							"[12](?:27|[3-5])",
							"[12](?:27|[3-5]\\d)[4-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MO": [
				"853",
				"[268]\\d{7}",
				[
					[
						"([268]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[268]"
						]
					]
				]
			],
			"MP": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"670"
			],
			"MQ": [
				"596",
				"[56]\\d{8}",
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"0",
				"0$1"
			],
			"MR": [
				"222",
				"[2-48]\\d{7}",
				[
					[
						"([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-48]"
						]
					]
				]
			],
			"MS": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"664"
			],
			"MT": [
				"356",
				"[2357-9]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"MU": [
				"230",
				"[2-9]\\d{6,7}",
				[
					[
						"([2-46-9]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[2-46-9]"
						]
					],
					[
						"(5\\d{3})(\\d{4})",
						"$1 $2",
						[
							"5"
						]
					]
				]
			],
			"MV": [
				"960",
				"[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[3467]|9(?:0[1-9]|[1-9])"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]00"
						]
					]
				]
			],
			"MW": [
				"265",
				"(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}",
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(2\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[17-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MX": [
				"52",
				"[1-9]\\d{9,10}",
				[
					[
						"([358]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"33|55|81"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"
						]
					],
					[
						"(1)([358]\\d)(\\d{4})(\\d{4})",
						"044 $2 $3 $4",
						[
							"1(?:33|55|81)"
						],
						"$1",
						null,
						"$1 $2 $3 $4"
					],
					[
						"(1)(\\d{3})(\\d{3})(\\d{4})",
						"044 $2 $3 $4",
						[
							"1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"
						],
						"$1",
						null,
						"$1 $2 $3 $4"
					]
				],
				"01",
				"01 $1",
				"0[12]|04[45](\\d{10})",
				"1$1",
				true
			],
			"MY": [
				"60",
				"[13-9]\\d{7,9}",
				[
					[
						"([4-79])(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"[4-79]"
						],
						"0$1"
					],
					[
						"(3)(\\d{4})(\\d{4})",
						"$1-$2 $3",
						[
							"3"
						],
						"0$1"
					],
					[
						"([18]\\d)(\\d{3})(\\d{3,4})",
						"$1-$2 $3",
						[
							"1[02-46-9][1-9]|8"
						],
						"0$1"
					],
					[
						"(1)([36-8]00)(\\d{2})(\\d{4})",
						"$1-$2-$3-$4",
						[
							"1[36-8]0",
							"1[36-8]00"
						]
					],
					[
						"(11)(\\d{4})(\\d{4})",
						"$1-$2 $3",
						[
							"11"
						],
						"0$1"
					],
					[
						"(15[49])(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"15[49]"
						],
						"0$1"
					]
				],
				"0"
			],
			"MZ": [
				"258",
				"[28]\\d{7,8}",
				[
					[
						"([28]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2|8[2-7]"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"80"
						]
					]
				]
			],
			"NA": [
				"264",
				"[68]\\d{7,8}",
				[
					[
						"(8\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8[1-35]"
						]
					],
					[
						"(6\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"6"
						]
					],
					[
						"(88)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"88"
						]
					],
					[
						"(870)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"870"
						]
					]
				],
				"0",
				"0$1"
			],
			"NC": [
				"687",
				"[2-57-9]\\d{5}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1.$2.$3",
						[
							"[2-46-9]|5[0-4]"
						]
					]
				]
			],
			"NE": [
				"227",
				"[0289]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"09|[289]"
						]
					],
					[
						"(08)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"08"
						]
					]
				]
			],
			"NF": [
				"672",
				"[13]\\d{5}",
				[
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(\\d)(\\d{5})",
						"$1 $2",
						[
							"3"
						]
					]
				]
			],
			"NG": [
				"234",
				"[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}",
				[
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[12]|9(?:0[3-9]|[1-9])"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[3-6]|7(?:0[1-9]|[1-79])|8[2-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"70|8[01]|90[235-9]"
						]
					],
					[
						"([78]00)(\\d{4})(\\d{4,5})",
						"$1 $2 $3",
						[
							"[78]00"
						]
					],
					[
						"([78]00)(\\d{5})(\\d{5,6})",
						"$1 $2 $3",
						[
							"[78]00"
						]
					],
					[
						"(78)(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"78"
						]
					]
				],
				"0",
				"0$1"
			],
			"NI": [
				"505",
				"[125-8]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"NL": [
				"31",
				"1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}",
				[
					[
						"([1-578]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"
						]
					],
					[
						"([1-5]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
						]
					],
					[
						"(6)(\\d{8})",
						"$1 $2",
						[
							"6[0-57-9]"
						]
					],
					[
						"(66)(\\d{7})",
						"$1 $2",
						[
							"66"
						]
					],
					[
						"(14)(\\d{3,4})",
						"$1 $2",
						[
							"14"
						],
						"$1"
					],
					[
						"([89]0\\d)(\\d{4,7})",
						"$1 $2",
						[
							"[89]0"
						]
					]
				],
				"0",
				"0$1"
			],
			"NO": [
				"47",
				"0\\d{4}|[2-9]\\d{7}",
				[
					[
						"([489]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[489]"
						]
					],
					[
						"([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[235-7]"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
					"(?:4[015-8]|5[89]|87|9\\d)\\d{6}",
					"80[01]\\d{5}",
					"82[09]\\d{5}",
					"880\\d{5}",
					null,
					"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",
					null,
					"85[0-5]\\d{5}",
					"810(?:0[0-6]|[2-8]\\d)\\d{3}"
				]
			],
			"NP": [
				"977",
				"[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})",
				[
					[
						"(1)(\\d{7})",
						"$1-$2",
						[
							"1[2-6]"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1-$2",
						[
							"1[01]|[2-8]|9(?:[1-69]|7[15-9])"
						]
					],
					[
						"(9\\d{2})(\\d{7})",
						"$1-$2",
						[
							"9(?:6[013]|7[245]|8)"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"NR": [
				"674",
				"[458]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"NU": [
				"683",
				"[1-5]\\d{3}"
			],
			"NZ": [
				"64",
				"6[235-9]\\d{6}|[2-57-9]\\d{7,9}",
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"240|[346]|7[2-57-9]|9[1-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"21"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,5})",
						"$1 $2 $3",
						[
							"2(?:1[1-9]|[69]|7[0-35-9])|70|86"
						]
					],
					[
						"(2\\d)(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[028]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"90"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2(?:10|74)|5|[89]0"
						]
					]
				],
				"0",
				"0$1"
			],
			"OM": [
				"968",
				"(?:5|[279]\\d)\\d{6}|800\\d{5,6}",
				[
					[
						"(2\\d)(\\d{6})",
						"$1 $2",
						[
							"2"
						]
					],
					[
						"([79]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[79]"
						]
					],
					[
						"([58]00)(\\d{4,6})",
						"$1 $2",
						[
							"[58]00"
						]
					]
				]
			],
			"PA": [
				"507",
				"[1-9]\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[1-57-9]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"6"
						]
					]
				]
			],
			"PE": [
				"51",
				"[14-9]\\d{7,8}",
				[
					[
						"(1)(\\d{7})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"([4-8]\\d)(\\d{6})",
						"$1 $2",
						[
							"[4-7]|8[2-4]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"80"
						]
					],
					[
						"(9\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						],
						"$1"
					]
				],
				"0",
				"(0$1)"
			],
			"PF": [
				"689",
				"4\\d{5,7}|8\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"4[09]|8[79]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"44"
						]
					]
				]
			],
			"PG": [
				"675",
				"[1-9]\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[13-689]|27"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"20|7"
						]
					]
				]
			],
			"PH": [
				"63",
				"1\\d{10,12}|2\\d{5,7}|[3-7]\\d{8}|8\\d{7,9}|9\\d{9}",
				[
					[
						"(2)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						],
						"(0$1)"
					],
					[
						"(2)(\\d{5})",
						"$1 $2",
						[
							"2"
						],
						"(0$1)"
					],
					[
						"(\\d{4})(\\d{4,6})",
						"$1 $2",
						[
							"3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])",
							"3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
						],
						"(0$1)"
					],
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"346|4(?:27|9[35])|883",
							"3469|4(?:279|9(?:30|56))|8834"
						],
						"(0$1)"
					],
					[
						"([3-8]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[3-8]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"81|9"
						],
						"0$1"
					],
					[
						"(1800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"180",
							"1800"
						]
					],
					[
						"(1800)(\\d{1,2})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"180",
							"1800"
						]
					]
				],
				"0"
			],
			"PK": [
				"92",
				"1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,10}|2\\d(?:111\\d{6}|\\d{3,7}))",
				[
					[
						"([89]00)(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"[89]00"
						],
						"0$1"
					],
					[
						"(1\\d{3})(\\d{5})",
						"$1 $2",
						[
							"1"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{7,8})",
						"$1 $2",
						[
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
						]
					],
					[
						"(\\d{3})(\\d{6,7})",
						"$1 $2",
						[
							"2[349]|45|54|60|72|8[2-5]|9[2-469]",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-469])\\d[2-9]"
						]
					],
					[
						"(58\\d{3})(\\d{5})",
						"$1 $2",
						[
							"58[126]"
						]
					],
					[
						"(3\\d{2})(\\d{7})",
						"$1 $2",
						[
							"3"
						],
						"0$1"
					],
					[
						"(\\d{2})(111)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1",
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11",
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"
						]
					],
					[
						"(\\d{3})(111)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"2[349]|45|54|60|72|8[2-5]|9[2-9]",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"
						]
					]
				],
				"0",
				"(0$1)"
			],
			"PL": [
				"48",
				"[1-57-9]\\d{6,8}|6\\d{5,8}",
				[
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"11[68]|64"
						]
					],
					[
						"(\\d{5})",
						"$1",
						[
							"19"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"64"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"26|39|45|5[0137]|6[0469]|7[02389]|8[08]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"
						]
					]
				]
			],
			"PM": [
				"508",
				"[45]\\d{5}",
				[
					[
						"([45]\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[45]"
						]
					]
				],
				"0",
				"0$1"
			],
			"PR": [
				"1",
				"[5789]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"787|939"
			],
			"PS": [
				"970",
				"1\\d{9}|[24589]\\d{7,8}",
				[
					[
						"([2489])(2\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[2489]2"
						]
					],
					[
						"(5[69]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"5[69]"
						]
					],
					[
						"(1[78]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[78]0",
							"1[78]00"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"PT": [
				"351",
				"[2-46-9]\\d{8}",
				[
					[
						"(2\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2[12]"
						]
					],
					[
						"([2-46-9]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2[3-9]|[346-9]"
						]
					]
				]
			],
			"PW": [
				"680",
				"[2-8]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"PY": [
				"595",
				"5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}",
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"[2-9]0"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"870",
							"8700"
						]
					],
					[
						"(\\d{3})(\\d{4,5})",
						"$1 $2",
						[
							"[2-8][1-9]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-8][1-9]"
						],
						"0$1"
					]
				],
				"0"
			],
			"QA": [
				"974",
				"[2-8]\\d{6,7}",
				[
					[
						"([28]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[28]"
						]
					],
					[
						"([3-7]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[3-7]"
						]
					]
				]
			],
			"RE": [
				"262",
				"[268]\\d{8}",
				[
					[
						"([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[268]"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				null,
				"262|69|8"
			],
			"RO": [
				"40",
				"[23]\\d{5,8}|[7-9]\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[23]1"
						]
					],
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[23]1"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[23][3-7]|[7-9]"
						]
					],
					[
						"(2\\d{2})(\\d{3})",
						"$1 $2",
						[
							"2[3-6]"
						]
					]
				],
				"0",
				"0$1"
			],
			"RS": [
				"381",
				"[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})",
				[
					[
						"([23]\\d{2})(\\d{4,9})",
						"$1 $2",
						[
							"(?:2[389]|39)0"
						]
					],
					[
						"([1-3]\\d)(\\d{5,10})",
						"$1 $2",
						[
							"1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"
						]
					],
					[
						"(6\\d)(\\d{6,8})",
						"$1 $2",
						[
							"6"
						]
					],
					[
						"([89]\\d{2})(\\d{3,9})",
						"$1 $2",
						[
							"[89]"
						]
					],
					[
						"(7[26])(\\d{4,9})",
						"$1 $2",
						[
							"7[26]"
						]
					],
					[
						"(7[08]\\d)(\\d{4,9})",
						"$1 $2",
						[
							"7[08]"
						]
					]
				],
				"0",
				"0$1"
			],
			"RU": [
				"7",
				"[347-9]\\d{9}",
				[
					[
						"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"[3489]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"8",
				"8 ($1)",
				null,
				null,
				true,
				null,
				[
					"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
					"9\\d{9}",
					"80[04]\\d{7}",
					"80[39]\\d{7}",
					"808\\d{7}"
				]
			],
			"RW": [
				"250",
				"[027-9]\\d{7,8}",
				[
					[
						"(2\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([7-9]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[7-9]"
						],
						"0$1"
					],
					[
						"(0\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"0"
						]
					]
				],
				"0"
			],
			"SA": [
				"966",
				"1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}",
				[
					[
						"([1-467])(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-467]"
						]
					],
					[
						"(1\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[1-467]"
						]
					],
					[
						"(5\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"5"
						]
					],
					[
						"(92\\d{2})(\\d{5})",
						"$1 $2",
						[
							"92"
						],
						"$1"
					],
					[
						"(800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"800"
						],
						"$1"
					],
					[
						"(811)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"811"
						]
					]
				],
				"0",
				"0$1"
			],
			"SB": [
				"677",
				"[1-9]\\d{4,6}",
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[7-9]"
						]
					]
				]
			],
			"SC": [
				"248",
				"[24689]\\d{5,6}",
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[246]"
						]
					]
				]
			],
			"SD": [
				"249",
				"[19]\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3"
					]
				],
				"0",
				"0$1"
			],
			"SE": [
				"46",
				"[1-35-9]\\d{5,11}|4\\d{6,8}",
				[
					[
						"(8)(\\d{2,3})(\\d{2,3})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"8"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"([1-469]\\d)(\\d{3})(\\d{2})",
						"$1-$2 $3",
						[
							"[12][136]|3[356]|4[0246]|6[03]|90"
						],
						null,
						null,
						"$1 $2 $3"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"(\\d{3})(\\d{2,3})(\\d{2})",
						"$1-$2 $3",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						],
						null,
						null,
						"$1 $2 $3"
					],
					[
						"(7\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"7"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"(77)(\\d{2})(\\d{2})",
						"$1-$2$3",
						[
							"77"
						],
						null,
						null,
						"$1 $2 $3"
					],
					[
						"(20)(\\d{2,3})(\\d{2})",
						"$1-$2 $3",
						[
							"20"
						],
						null,
						null,
						"$1 $2 $3"
					],
					[
						"(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})",
						"$1-$2 $3 $4",
						[
							"9[034]"
						],
						null,
						null,
						"$1 $2 $3 $4"
					],
					[
						"(9[034]\\d)(\\d{4})",
						"$1-$2",
						[
							"9[034]"
						],
						null,
						null,
						"$1 $2"
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4 $5",
						[
							"25[245]|67[3-6]"
						],
						null,
						null,
						"$1 $2 $3 $4 $5"
					]
				],
				"0",
				"0$1"
			],
			"SG": [
				"65",
				"[36]\\d{7}|[17-9]\\d{7,10}",
				[
					[
						"([3689]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[369]|8[1-9]"
						]
					],
					[
						"(1[89]00)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[89]0",
							"1[89]00"
						]
					],
					[
						"(7000)(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"700",
							"7000"
						]
					],
					[
						"(800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"800"
						]
					]
				]
			],
			"SH": [
				"290",
				"[256]\\d{4}|8\\d{3}",
				[],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"2(?:[0-57-9]\\d|6[4-9])\\d{2}",
					"[56]\\d{4}",
					null,
					null,
					null,
					null,
					null,
					null,
					"262\\d{2}"
				]
			],
			"SI": [
				"386",
				"[1-7]\\d{6,7}|[89]\\d{4,7}",
				[
					[
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[12]|[34][24-8]|5[2-8]|7[3-8]"
						],
						"(0$1)"
					],
					[
						"([3-7]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[37][01]|4[0139]|51|6"
						]
					],
					[
						"([89][09])(\\d{3,6})",
						"$1 $2",
						[
							"[89][09]"
						]
					],
					[
						"([58]\\d{2})(\\d{5})",
						"$1 $2",
						[
							"59|8[1-3]"
						]
					]
				],
				"0",
				"0$1"
			],
			"SJ": [
				"47",
				"0\\d{4}|[45789]\\d{7}",
				[
					[
						"([489]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[489]"
						]
					],
					[
						"([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[235-7]"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"79\\d{6}",
					"(?:4[015-8]|5[89]|9\\d)\\d{6}",
					"80[01]\\d{5}",
					"82[09]\\d{5}",
					"880\\d{5}",
					null,
					"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",
					null,
					"85[0-5]\\d{5}",
					"810(?:0[0-6]|[2-8]\\d)\\d{3}"
				]
			],
			"SK": [
				"421",
				"(?:[2-68]\\d{5,8}|9\\d{6,8})",
				[
					[
						"(2)(1[67])(\\d{3,4})",
						"$1 $2 $3",
						[
							"21[67]"
						]
					],
					[
						"([3-5]\\d)(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[3-5]"
						]
					],
					[
						"(2)(\\d{3})(\\d{3})(\\d{2})",
						"$1/$2 $3 $4",
						[
							"2"
						]
					],
					[
						"([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1/$2 $3 $4",
						[
							"[3-5]"
						]
					],
					[
						"([689]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[689]"
						]
					],
					[
						"(9090)(\\d{3})",
						"$1 $2",
						[
							"909",
							"9090"
						]
					]
				],
				"0",
				"0$1"
			],
			"SL": [
				"232",
				"[2-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2"
					]
				],
				"0",
				"(0$1)"
			],
			"SM": [
				"378",
				"[05-7]\\d{7,9}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[5-7]"
						]
					],
					[
						"(0549)(\\d{6})",
						"$1 $2",
						[
							"054",
							"0549"
						],
						null,
						null,
						"($1) $2"
					],
					[
						"(\\d{6})",
						"0549 $1",
						[
							"[89]"
						],
						null,
						null,
						"(0549) $1"
					]
				],
				null,
				null,
				"([89]\\d{5})",
				"0549$1"
			],
			"SN": [
				"221",
				"[3789]\\d{8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[379]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						]
					]
				]
			],
			"SO": [
				"252",
				"[1-9]\\d{5,8}",
				[
					[
						"(\\d{6})",
						"$1",
						[
							"[134]"
						]
					],
					[
						"(\\d)(\\d{6})",
						"$1 $2",
						[
							"[13-5]|2[0-79]"
						]
					],
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"24|[67]"
						]
					],
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"8[125]"
						]
					],
					[
						"(\\d{2})(\\d{5,7})",
						"$1 $2",
						[
							"15|28|6[1-35-9]|799|9[2-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"3[59]|4[89]|6[24-6]|79|8[08]|90"
						]
					]
				],
				"0"
			],
			"SR": [
				"597",
				"[2-8]\\d{5,6}",
				[
					[
						"(\\d{3})(\\d{3})",
						"$1-$2",
						[
							"[2-4]|5[2-58]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1-$2-$3",
						[
							"56"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[6-8]"
						]
					]
				]
			],
			"SS": [
				"211",
				"[19]\\d{8}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						null,
						"0$1"
					]
				],
				"0"
			],
			"ST": [
				"239",
				"[29]\\d{6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"SV": [
				"503",
				"[267]\\d{7}|[89]\\d{6}(?:\\d{4})?",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[267]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[89]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				]
			],
			"SX": [
				"1",
				"[5789]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"721"
			],
			"SY": [
				"963",
				"[1-59]\\d{7,8}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[1-5]"
						]
					],
					[
						"(9\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				"0",
				"0$1",
				null,
				null,
				true
			],
			"SZ": [
				"268",
				"[027]\\d{7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[027]"
						]
					]
				]
			],
			"TA": [
				"290",
				"8\\d{3}",
				[],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"8\\d{3}"
				]
			],
			"TC": [
				"1",
				"[5689]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"649"
			],
			"TD": [
				"235",
				"[2679]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"TG": [
				"228",
				"[279]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[279]"
						]
					]
				]
			],
			"TH": [
				"66",
				"1\\d{8,9}|[2-9]\\d{7,8}",
				[
					[
						"(2)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([13-9]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"14|[3-9]"
						]
					],
					[
						"(1[89]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[89]0",
							"1[89]00"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"TJ": [
				"992",
				"[3-57-9]\\d{8}",
				[
					[
						"([349]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[34]7|91[78]"
						]
					],
					[
						"([457-9]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"4[148]|[578]|9(?:[0235-9]|1[59])"
						]
					],
					[
						"(331700)(\\d)(\\d{2})",
						"$1 $2 $3",
						[
							"331",
							"3317",
							"33170",
							"331700"
						]
					],
					[
						"(\\d{4})(\\d)(\\d{4})",
						"$1 $2 $3",
						[
							"3[1-5]",
							"3(?:[1245]|3(?:[02-9]|1[0-589]))"
						]
					]
				],
				"8",
				null,
				null,
				null,
				true
			],
			"TK": [
				"690",
				"[2-47]\\d{3,6}"
			],
			"TL": [
				"670",
				"[2-489]\\d{6}|7\\d{6,7}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-489]|70"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"7[3-8]"
						]
					]
				]
			],
			"TM": [
				"993",
				"[1-6]\\d{7}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"12"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"6"
						],
						"8 $1"
					],
					[
						"(\\d{3})(\\d)(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"13|[2-5]"
						]
					]
				],
				"8",
				"(8 $1)"
			],
			"TN": [
				"216",
				"[2-57-9]\\d{7}",
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				]
			],
			"TO": [
				"676",
				"[02-8]\\d{4,6}",
				[
					[
						"(\\d{2})(\\d{3})",
						"$1-$2",
						[
							"[1-6]|7[0-4]|8[05]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"7[5-9]|8[47-9]"
						]
					],
					[
						"(\\d{4})(\\d{3})",
						"$1 $2",
						[
							"0"
						]
					]
				]
			],
			"TR": [
				"90",
				"[2-589]\\d{9}|444\\d{4}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]|4(?:[0-35-9]|4[0-35-9])"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5[02-69]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"51|[89]"
						],
						"0$1"
					],
					[
						"(444)(\\d{1})(\\d{3})",
						"$1 $2 $3",
						[
							"444"
						]
					]
				],
				"0",
				null,
				null,
				null,
				true
			],
			"TT": [
				"1",
				"[589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"868"
			],
			"TV": [
				"688",
				"[279]\\d{4,6}"
			],
			"TW": [
				"886",
				"2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}",
				[
					[
						"(20)(\\d)(\\d{4})",
						"$1 $2 $3",
						[
							"202"
						]
					],
					[
						"([258]0)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"20[013-9]|50[0-46-9]|80[0-79]"
						]
					],
					[
						"([2-8])(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"[25][2-8]|[346]|[78][1-9]"
						]
					],
					[
						"(9\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						]
					],
					[
						"(70)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"70"
						]
					]
				],
				"0",
				"0$1"
			],
			"TZ": [
				"255",
				"\\d{9}",
				[
					[
						"([24]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[24]"
						]
					],
					[
						"([67]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[67]"
						]
					],
					[
						"([89]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				],
				"0",
				"0$1"
			],
			"UA": [
				"380",
				"[3-9]\\d{8}",
				[
					[
						"([3-9]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[38]9|4(?:[45][0-5]|87)|5(?:0|[67][37])|6[36-8]|7|9[1-9]",
							"[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"
						]
					],
					[
						"([3-689]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90",
							"3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90"
						]
					],
					[
						"([3-6]\\d{3})(\\d{5})",
						"$1 $2",
						[
							"3(?:[1-46-8]|5[013-9])|4(?:[137][013-9]|[45][6-9]|6|8[4-6])|5(?:[1245][013-9]|3|6[0135689]|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])",
							"3(?:[1-46-8](?:[013-9]|22)|5[013-9])|4(?:[137][013-9]|[45][6-9]|6(?:[013-9]|22)|8[4-6])|5(?:[1245][013-9]|3|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])"
						]
					]
				],
				"0",
				"0$1"
			],
			"UG": [
				"256",
				"\\d{9}",
				[
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"20[0-8]|4(?:6[45]|[7-9])|[7-9]",
							"20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"
						]
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"3|4(?:[1-5]|6[0-36-9])"
						]
					],
					[
						"(2024)(\\d{5})",
						"$1 $2",
						[
							"202",
							"2024"
						]
					]
				],
				"0",
				"0$1"
			],
			"US": [
				"1",
				"[2-9]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				true,
				null,
				[
					"(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
					null,
					"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
					"900[2-9]\\d{6}",
					"5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}"
				]
			],
			"UY": [
				"598",
				"[2489]\\d{6,7}",
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[24]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[89]0"
						],
						"0$1"
					]
				],
				"0"
			],
			"UZ": [
				"998",
				"[679]\\d{8}",
				[
					[
						"([679]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[679]"
						]
					]
				],
				"8",
				"8 $1"
			],
			"VA": [
				"39",
				"(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))",
				[
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[26]|55"
						]
					],
					[
						"(0[26])(\\d{4})(\\d{5})",
						"$1 $2 $3",
						[
							"0[26]"
						]
					],
					[
						"(0[26])(\\d{4,6})",
						"$1 $2",
						[
							"0[26]"
						]
					],
					[
						"(0\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][0159]"
						]
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"0[13-57-9][0159]|8(?:03|4[17]|9[245])",
							"0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
						]
					],
					[
						"(0\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(0\\d{3})(\\d{2,6})",
						"$1 $2",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[13]|8(?:00|4[08]|9[59])",
							"[13]|8(?:00|4[08]|9(?:5[5-9]|9))"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"894",
							"894[5-9]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				],
				null,
				null,
				null,
				null,
				null,
				null,
				[
					"06698\\d{5}",
					"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})",
					"80(?:0\\d{6}|3\\d{3})",
					"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})",
					"1(?:78\\d|99)\\d{6}",
					null,
					null,
					null,
					"55\\d{8}",
					"84(?:[08]\\d{6}|[17]\\d{3})"
				]
			],
			"VC": [
				"1",
				"[5789]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"784"
			],
			"VE": [
				"58",
				"[24589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{7})",
						"$1-$2"
					]
				],
				"0",
				"0$1"
			],
			"VG": [
				"1",
				"[2589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"284"
			],
			"VI": [
				"1",
				"[3589]\\d{9}",
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						null,
						null,
						null,
						"$1-$2-$3"
					]
				],
				"1",
				null,
				null,
				null,
				null,
				"340"
			],
			"VN": [
				"84",
				"1\\d{6,9}|2\\d{9}|6\\d{6,7}|7\\d{6}|8\\d{6,8}|9\\d{8}",
				[
					[
						"([17]99)(\\d{4})",
						"$1 $2",
						[
							"[17]99"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[48]"
						]
					],
					[
						"(80)(\\d{5})",
						"$1 $2",
						[
							"80"
						]
					],
					[
						"(69\\d)(\\d{4,5})",
						"$1 $2",
						[
							"69"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"2[0-35-79]"
						]
					],
					[
						"([89]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8(?:8|9[89])|9"
						]
					],
					[
						"(1[2689]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[26]|8[68]|99)"
						]
					],
					[
						"(86[89])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"86[89]"
						]
					],
					[
						"(1[89]00)(\\d{4,6})",
						"$1 $2",
						[
							"1[89]0",
							"1[89]00"
						],
						"$1"
					]
				],
				"0",
				"0$1",
				null,
				null,
				true
			],
			"VU": [
				"678",
				"[2-57-9]\\d{4,6}",
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[579]"
						]
					]
				]
			],
			"WF": [
				"681",
				"[4-8]\\d{5}",
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"WS": [
				"685",
				"[2-8]\\d{4,6}",
				[
					[
						"(8\\d{2})(\\d{3,4})",
						"$1 $2",
						[
							"8"
						]
					],
					[
						"(7\\d)(\\d{5})",
						"$1 $2",
						[
							"7"
						]
					],
					[
						"(\\d{5})",
						"$1",
						[
							"[2-6]"
						]
					]
				]
			],
			"YE": [
				"967",
				"[1-7]\\d{6,8}",
				[
					[
						"([1-7])(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[1-6]|7[24-68]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7[0137]"
						]
					]
				],
				"0",
				"0$1"
			],
			"YT": [
				"262",
				"[268]\\d{8}",
				[
					[
						"([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[268]"
						]
					]
				],
				"0",
				null,
				null,
				null,
				null,
				"269|63"
			],
			"ZA": [
				"27",
				"[1-79]\\d{8}|8\\d{4,8}",
				[
					[
						"(860)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"860"
						]
					],
					[
						"(\\d{2})(\\d{3,4})",
						"$1 $2",
						[
							"8[1-4]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"8[1-4]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-79]|8(?:[0-57]|6[1-9])"
						]
					]
				],
				"0",
				"0$1"
			],
			"ZM": [
				"260",
				"[289]\\d{8}",
				[
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						null,
						"$1"
					],
					[
						"([1-8])(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-8]"
						],
						"$1"
					],
					[
						"([29]\\d)(\\d{7})",
						"$1 $2",
						[
							"[29]"
						]
					],
					[
						"(800)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"800"
						]
					]
				],
				"0",
				"0$1"
			],
			"ZW": [
				"263",
				"2(?:[0-57-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-69]\\d{4,9}|7\\d{8}|8[06]\\d{5,8}",
				[
					[
						"([49])(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"4|9[2-9]"
						]
					],
					[
						"(7\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					],
					[
						"(86\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"86[24]"
						]
					],
					[
						"([2356]\\d{2})(\\d{3,5})",
						"$1 $2",
						[
							"2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|7[1569]|8[37])|5[15][78]|6(?:[29]8|37|[68][78]|75)"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"
						]
					],
					[
						"([1-356]\\d)(\\d{3,5})",
						"$1 $2",
						[
							"1[3-9]|2[02569]|3[0-69]|5[05689]|6"
						]
					],
					[
						"([235]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[23]9|54"
						]
					],
					[
						"([25]\\d{3})(\\d{3,5})",
						"$1 $2",
						[
							"(?:25|54)8",
							"258[23]|5483"
						]
					],
					[
						"(8\\d{3})(\\d{6})",
						"$1 $2",
						[
							"86"
						]
					],
					[
						"(80\\d)(\\d{4})",
						"$1 $2",
						[
							"80"
						]
					]
				],
				"0",
				"0$1"
			],
			"001": [
				"979",
				"\\d{9}",
				[
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3"
					]
				]
			]
		}
	};

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DIGIT_PLACEHOLDER = undefined;
	
	var _getIterator2 = __webpack_require__(81);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(66);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.close_dangling_braces = close_dangling_braces;
	exports.count_occurences = count_occurences;
	exports.repeat = repeat;
	
	var _metadata = __webpack_require__(109);
	
	var _parse = __webpack_require__(110);
	
	var _format = __webpack_require__(248);
	
	var _common = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Used in phone number format template creation.
	// Could be any digit, I guess.
	// This is an enhanced port of Google Android `libphonenumber`'s
	// `asyoutypeformatter.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/blob/8d21a365061de2ba0675c878a710a7b24f74d2ae/javascript/i18n/phonenumbers/asyoutypeformatter.js
	
	var DUMMY_DIGIT = '9';
	var DUMMY_DIGIT_MATCHER = new RegExp(DUMMY_DIGIT, 'g');
	// I don't know why is it exactly `15`
	var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15;
	// Create a phone number consisting only of the digit 9 that matches the
	// `number_pattern` by applying the pattern to the "longest phone number" string.
	var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH);
	
	// The digits that have not been entered yet will be represented by a \u2008,
	// the punctuation space.
	var DIGIT_PLACEHOLDER = exports.DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)
	var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
	var DIGIT_PLACEHOLDER_MATCHER_GLOBAL = new RegExp(DIGIT_PLACEHOLDER, 'g');
	
	// A pattern that is used to match character classes in regular expressions.
	// An example of a character class is "[1-4]".
	var CHARACTER_CLASS_PATTERN = /\[([^\[\]])*\]/g;
	
	// Any digit in a regular expression that actually denotes a digit. For
	// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
	// (8 and 0) are standalone digits, but the rest are not.
	// Two look-aheads are needed because the number following \\d could be a
	// two-digit number, since the phone number can be as long as 15 digits.
	var STANDALONE_DIGIT_PATTERN = /\d(?=[^,}][^,}])/g;
	
	// A pattern that is used to determine if a `format` is eligible
	// to be used by the "as you type formatter".
	// It is eligible when the `format` contains groups of the dollar sign
	// followed by a single digit, separated by valid phone number punctuation.
	// This prevents invalid punctuation (such as the star sign in Israeli star numbers)
	// getting into the output of the "as you type formatter".
	var ELIGIBLE_FORMAT_PATTERN = new RegExp('^' + '[' + _parse.VALID_PUNCTUATION + ']*' + '(\\$\\d[' + _parse.VALID_PUNCTUATION + ']*)+' + '$');
	
	// This is the minimum length of the leading digits of a phone number
	// to guarantee the first "leading digits pattern" for a phone number format
	// to be preemptive.
	var MIN_LEADING_DIGITS_LENGTH = 3;
	
	var VALID_INCOMPLETE_PHONE_NUMBER = '[' + _parse.PLUS_CHARS + ']{0,1}' + '[' + _parse.VALID_PUNCTUATION + _parse.VALID_DIGITS + ']*';
	
	var VALID_INCOMPLETE_PHONE_NUMBER_PATTERN = new RegExp('^' + VALID_INCOMPLETE_PHONE_NUMBER + '$', 'i');
	
	var as_you_type = function () {
		function as_you_type(country_code, metadata) {
			(0, _classCallCheck3.default)(this, as_you_type);
	
			// Metadata is required.
			if (!metadata || !metadata.countries) {
				throw new Error('Metadata is required');
			}
	
			if (country_code && metadata.countries[country_code]) {
				this.default_country = country_code;
			}
	
			this.metadata = metadata;
	
			this.reset();
		}
	
		(0, _createClass3.default)(as_you_type, [{
			key: 'input',
			value: function input(text) {
				// Parse input
	
				var extracted_number = (0, _parse.extract_formatted_phone_number)(text);
	
				// Special case for a lone '+' sign
				// since it's not considered a possible phone number.
				if (!extracted_number) {
					if (text && text.indexOf('+') >= 0) {
						extracted_number = '+';
					}
				}
	
				// Validate possible first part of a phone number
				if (!(0, _common.matches_entirely)(extracted_number, VALID_INCOMPLETE_PHONE_NUMBER_PATTERN)) {
					return this.current_output;
				}
	
				return this.process_input((0, _parse.parse_phone_number)(extracted_number));
			}
		}, {
			key: 'process_input',
			value: function process_input(input) {
				// If an out of position '+' sign detected
				// (or a second '+' sign),
				// then just drop it from the input.
				if (input[0] === '+') {
					if (!this.parsed_input) {
						this.parsed_input += '+';
	
						// If a default country was set
						// then reset it because an explicitly international
						// phone number is being entered
						this.reset_countriness();
					}
	
					input = input.slice(1);
				}
	
				// Raw phone number
				this.parsed_input += input;
	
				// // Reset phone number validation state
				// this.valid = false
	
				// Add digits to the national number
				this.national_number += input;
	
				// Try to format the parsed input
	
				if (this.is_international()) {
					if (!this.country_phone_code) {
						// If one looks at country phone codes
						// then he can notice that no one country phone code
						// is ever a (leftmost) substring of another country phone code.
						// So if a valid country code is extracted so far
						// then it means that this is the country code.
	
						// If no country phone code could be extracted so far,
						// then just return the raw phone number,
						// because it has no way of knowing
						// how to format the phone number so far.
						if (!this.extract_country_phone_code()) {
							// Return raw phone number
							return this.parsed_input;
						}
	
						// Initialize country-specific data
						this.initialize_phone_number_formats_for_this_country_phone_code();
						this.reset_format();
						this.determine_the_country();
					}
					// `this.country` could be `undefined`,
					// for instance, when there is ambiguity
					// in a form of several different countries
					// each corresponding to the same country phone code
					// (e.g. NANPA: USA, Canada, etc),
					// and there's not enough digits entered
					// to reliably determine the country
					// the phone number belongs to.
					// Therefore, in cases of such ambiguity,
					// each time something is input,
					// try to determine the country
					// (if it's not determined yet).
					else if (!this.country) {
							this.determine_the_country();
						}
				} else {
					// Some national prefixes are substrings of other national prefixes
					// (for the same country), therefore try to extract national prefix each time
					// because a longer national prefix might be available at some point in time.
	
					var previous_national_prefix = this.national_prefix;
					this.national_number = this.national_prefix + this.national_number;
	
					// Possibly extract a national prefix
					this.extract_national_prefix();
	
					if (this.national_prefix !== previous_national_prefix) {
						// National number has changed
						// (due to another national prefix been extracted)
						// therefore national number has changed
						// therefore reset all previous formatting data.
						// (and leading digits matching state)
						this.matching_formats = this.available_formats;
						this.reset_format();
					}
				}
	
				if (!this.should_format()) {
					return this.format_as_non_formatted_number();
				}
	
				// Check the available phone number formats
				// based on the currently available leading digits.
				this.match_formats_by_leading_digits();
	
				// Format the phone number (given the next digits)
				var formatted_national_phone_number = this.format_national_phone_number(input);
	
				// If the phone number could be formatted,
				// then return it, possibly prepending with country phone code
				// (for international phone numbers only)
				if (formatted_national_phone_number) {
					return this.full_phone_number(formatted_national_phone_number);
				}
	
				// If the phone number couldn't be formatted,
				// then just fall back to the raw phone number.
				return this.parsed_input;
			}
		}, {
			key: 'format_as_non_formatted_number',
			value: function format_as_non_formatted_number() {
				if (this.is_international() && this.country_phone_code) {
					if (this.national_number) {
						// For convenience, the public `.template` property
						// contains the whole international number
						// if the phone number being input is international:
						// 'x' for the '+' sign, 'x'es for the country phone code,
						// a spacebar and then the template for the national number digits.
						this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.country_phone_code.length) + ' ' + repeat(DIGIT_PLACEHOLDER, this.national_number.length);
	
						return '+' + this.country_phone_code + ' ' + this.national_number;
					}
	
					return '+' + this.country_phone_code;
				}
	
				return this.parsed_input;
			}
		}, {
			key: 'format_national_phone_number',
			value: function format_national_phone_number(next_digits) {
				// Format the next phone number digits
				// using the previously chosen phone number format.
				//
				// This is done here because if `attempt_to_format_complete_phone_number`
				// was placed before this call then the `template`
				// wouldn't reflect the situation correctly (and would therefore be inconsistent)
				//
				var national_number_formatted_with_previous_format = void 0;
				if (this.chosen_format) {
					national_number_formatted_with_previous_format = this.format_next_national_number_digits(next_digits);
				}
	
				// See if the input digits can be formatted properly already. If not,
				// use the results from format_next_national_number_digits(), which does formatting
				// based on the formatting pattern chosen.
	
				var formatted_number = this.attempt_to_format_complete_phone_number();
	
				// Just because a phone number doesn't have a suitable format
				// that doesn't mean that the phone is invalid
				// because phone number formats only format phone numbers,
				// they don't validate them and some (rare) phone numbers
				// are meant to stay non-formatted.
				if (formatted_number) {
					// if (this.country)
					// {
					// 	this.valid = true
					// }
	
					return formatted_number;
				}
	
				// For some phone number formats national prefix
	
				// If the previously chosen phone number format
				// didn't match the next (current) digit being input
				// (leading digits pattern didn't match).
				if (this.choose_another_format()) {
					// And a more appropriate phone number format
					// has been chosen for these `leading digits`,
					// then format the national phone number (so far)
					// using the newly selected phone number pattern.
	
					// Will return `undefined` if it couldn't format
					// the supplied national number
					// using the selected phone number pattern.
	
					return this.reformat_national_number();
				}
	
				// If could format the next (current) digit
				// using the previously chosen phone number format
				// then return the formatted number so far.
	
				// If no new phone number format could be chosen,
				// and couldn't format the supplied national number
				// using the selected phone number pattern,
				// then it will return `undefined`.
	
				return national_number_formatted_with_previous_format;
			}
		}, {
			key: 'reset',
			value: function reset() {
				// Input stripped of non-phone-number characters.
				// Can only contain a possible leading '+' sign and digits.
				this.parsed_input = '';
	
				this.current_output = '';
	
				// This contains the national prefix that has been extracted. It contains only
				// digits without formatting.
				this.national_prefix = '';
	
				this.national_number = '';
	
				this.reset_countriness();
	
				this.reset_format();
	
				// this.valid = false
	
				return this;
			}
		}, {
			key: 'reset_country',
			value: function reset_country() {
				if (this.default_country && !this.is_international()) {
					this.country = this.default_country;
				} else {
					this.country = undefined;
				}
			}
		}, {
			key: 'reset_countriness',
			value: function reset_countriness() {
				this.reset_country();
	
				if (this.default_country && !this.is_international()) {
					this.country_metadata = this.metadata.countries[this.default_country];
					this.country_phone_code = (0, _metadata.get_phone_code)(this.country_metadata);
	
					this.initialize_phone_number_formats_for_this_country_phone_code();
				} else {
					this.country_metadata = undefined;
					this.country_phone_code = undefined;
	
					this.available_formats = [];
					this.matching_formats = this.available_formats;
				}
			}
		}, {
			key: 'reset_format',
			value: function reset_format() {
				this.chosen_format = undefined;
				this.template = undefined;
				this.partially_populated_template = undefined;
				this.last_match_position = -1;
			}
	
			// Format each digit of national phone number (so far)
			// using the newly selected phone number pattern.
	
		}, {
			key: 'reformat_national_number',
			value: function reformat_national_number() {
				// Format each digit of national phone number (so far)
				// using the selected phone number pattern.
				return this.format_next_national_number_digits(this.national_number);
			}
		}, {
			key: 'initialize_phone_number_formats_for_this_country_phone_code',
			value: function initialize_phone_number_formats_for_this_country_phone_code() {
				// Get all "eligible" phone number formats for this country
				this.available_formats = (0, _metadata.get_formats)(this.country_metadata).filter(function (format) {
					return ELIGIBLE_FORMAT_PATTERN.test((0, _metadata.get_format_international_format)(format));
				});
	
				this.matching_formats = this.available_formats;
			}
		}, {
			key: 'match_formats_by_leading_digits',
			value: function match_formats_by_leading_digits() {
				var leading_digits = this.national_number;
	
				// "leading digits" pattern list starts with
				// one of a maximum length of 3 digits,
				// and then with each additional digit
				// a more precise "leading digits" pattern is specified.
	
				var index_of_leading_digits_pattern = leading_digits.length - MIN_LEADING_DIGITS_LENGTH;
	
				if (index_of_leading_digits_pattern < 0) {
					index_of_leading_digits_pattern = 0;
				}
	
				this.matching_formats = this.matching_formats.filter(function (format) {
					var leading_digits_pattern_count = (0, _metadata.get_format_leading_digits_patterns)(format).length;
	
					// Keep everything that isn't restricted by leading digits.
					if (leading_digits_pattern_count === 0) {
						return true;
					}
	
					var leading_digits_pattern_index = Math.min(index_of_leading_digits_pattern, leading_digits_pattern_count - 1);
					var leading_digits_pattern = (0, _metadata.get_format_leading_digits_patterns)(format)[leading_digits_pattern_index];
	
					// Brackets are required for `^` to be applied to
					// all or-ed (`|`) parts, not just the first one.
					return new RegExp('^(' + leading_digits_pattern + ')').test(leading_digits);
				});
	
				// If there was a phone number format chosen
				// and it no longer holds given the new leading digits then reset it.
				// The test for this `if` condition is marked as:
				// "Reset a chosen format when it no longer holds given the new leading digits".
				if (this.chosen_format && this.matching_formats.indexOf(this.chosen_format) === -1) {
					this.reset_format();
				}
			}
		}, {
			key: 'should_format',
			value: function should_format() {
				// Start matching any formats at all when the national number
				// entered so far is at least 3 digits long,
				// otherwise format matching would give false negatives
				// like when the digits entered so far are `2`
				// and the leading digits pattern is `21` –
				// it's quite obvious in this case that the format could be the one
				// but due to the absence of further digits it would give false negative.
				//
				// Google could have provided leading digits patterns starting
				// with a single digit but they chose not to (for whatever reasons).
				//
				return this.national_number >= MIN_LEADING_DIGITS_LENGTH;
			}
	
			// Check to see if there is an exact pattern match for these digits. If so, we
			// should use this instead of any other formatting template whose
			// leadingDigitsPattern also matches the input.
	
		}, {
			key: 'attempt_to_format_complete_phone_number',
			value: function attempt_to_format_complete_phone_number() {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = (0, _getIterator3.default)(this.matching_formats), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var format = _step.value;
	
						var matcher = new RegExp('^(?:' + (0, _metadata.get_format_pattern)(format) + ')$');
	
						if (!matcher.test(this.national_number)) {
							continue;
						}
	
						if (!this.validate_format(format)) {
							continue;
						}
	
						// To leave the formatter in a consistent state
						this.reset_format();
						this.chosen_format = format;
	
						var formatted_number = (0, _format.format_national_number_using_format)(this.national_number, format, this.is_international(), this.national_prefix.length > 0, this.country_metadata);
	
						// Set `this.template` and `this.partially_populated_template`.
						//
						// `else` case doesn't ever happen
						// with the current metadata,
						// but just in case.
						//
						/* istanbul ignore else */
						if (this.create_formatting_template(format)) {
							// Populate `this.partially_populated_template`
							this.reformat_national_number();
						} else {
							// Prepend `+CountryCode` in case of an international phone number
							var full_number = this.full_phone_number(formatted_number);
							this.template = full_number.replace(/[\d\+]/g, DIGIT_PLACEHOLDER);
							this.partially_populated_template = full_number;
						}
	
						return formatted_number;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
	
			// Prepends `+CountryCode` in case of an international phone number
	
		}, {
			key: 'full_phone_number',
			value: function full_phone_number(formatted_national_number) {
				if (this.is_international()) {
					return '+' + this.country_phone_code + ' ' + formatted_national_number;
				}
	
				return formatted_national_number;
			}
	
			// Extracts the country calling code from the beginning
			// of the entered `national_number` (so far),
			// and places the remaining input into the `national_number`.
	
		}, {
			key: 'extract_country_phone_code',
			value: function extract_country_phone_code() {
				if (!this.national_number) {
					return;
				}
	
				var _parse_phone_number_a = (0, _parse.parse_phone_number_and_country_phone_code)(this.parsed_input, this.metadata),
				    country_phone_code = _parse_phone_number_a.country_phone_code,
				    number = _parse_phone_number_a.number;
	
				if (!country_phone_code) {
					return;
				}
	
				this.country_phone_code = country_phone_code;
				this.national_number = number;
	
				return this.country_metadata = (0, _metadata.get_metadata_by_country_phone_code)(country_phone_code, this.metadata);
			}
		}, {
			key: 'extract_national_prefix',
			value: function extract_national_prefix() {
				this.national_prefix = '';
	
				if (!this.country_metadata) {
					return;
				}
	
				var national_number = (0, _parse.strip_national_prefix)(this.national_number, this.country_metadata);
	
				if (national_number !== this.national_number) {
					this.national_prefix = this.national_number.slice(0, this.national_number.length - national_number.length);
					this.national_number = national_number;
				}
	
				return this.national_prefix;
			}
		}, {
			key: 'choose_another_format',
			value: function choose_another_format() {
				// When there are multiple available formats, the formatter uses the first
				// format where a formatting template could be created.
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = (0, _getIterator3.default)(this.matching_formats), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var format = _step2.value;
	
						// If this format is currently being used
						// and is still possible, then stick to it.
						if (this.chosen_format === format) {
							return;
						}
	
						// If this `format` is suitable for "as you type",
						// then extract the template from this format
						// and use it to format the phone number being input.
	
						if (!this.validate_format(format)) {
							continue;
						}
	
						if (!this.create_formatting_template(format)) {
							continue;
						}
	
						this.chosen_format = format;
	
						// With a new formatting template, the matched position
						// using the old template needs to be reset.
						this.last_match_position = -1;
	
						return true;
					}
	
					// No format matches the phone number,
					// therefore set `country` to `undefined`
					// (or to the default country).
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				this.reset_country();
	
				// No format matches the national phone number entered
				this.reset_format();
			}
		}, {
			key: 'validate_format',
			value: function validate_format(format) {
				// If national prefix is mandatory for this phone number format
				// and the user didn't input the national prefix,
				// then this phone number format isn't suitable.
				if (!this.is_international() && !this.national_prefix && (0, _metadata.get_format_national_prefix_is_mandatory_when_formatting)(format, this.country_metadata)) {
					return;
				}
	
				return true;
			}
		}, {
			key: 'create_formatting_template',
			value: function create_formatting_template(format) {
				// The formatter doesn't format numbers when numberPattern contains '|', e.g.
				// (20|3)\d{4}. In those cases we quickly return.
				// (Though there's no such format in current metadata)
				/* istanbul ignore if */
				if ((0, _metadata.get_format_pattern)(format).indexOf('|') >= 0) {
					return;
				}
	
				// Get formatting template for this phone number format
				var template = this.get_template_for_phone_number_format_pattern(format);
	
				// If the national number entered is too long
				// for any phone number format, then abort.
				if (!template) {
					return;
				}
	
				// This one is for national number only
				this.partially_populated_template = template;
	
				// For convenience, the public `.template` property
				// contains the whole international number
				// if the phone number being input is international:
				// 'x' for the '+' sign, 'x'es for the country phone code,
				// a spacebar and then the template for the formatted national number.
				if (this.is_international()) {
					this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.country_phone_code.length) + ' ' + template;
				}
				// For local numbers, replace national prefix
				// with a digit placeholder.
				else {
						this.template = template.replace(/\d/g, DIGIT_PLACEHOLDER);
					}
	
				// This one is for the full phone number
				return this.template;
			}
	
			// Generates formatting template for a phone number format
	
		}, {
			key: 'get_template_for_phone_number_format_pattern',
			value: function get_template_for_phone_number_format_pattern(format) {
				var national_prefix_formatting_rule = (0, _metadata.get_format_national_prefix_formatting_rule)(format, this.country_metadata);
	
				// A very smart trick by the guys at Google
				var number_pattern = (0, _metadata.get_format_pattern)(format)
				// Replace anything in the form of [..] with \d
				.replace(CHARACTER_CLASS_PATTERN, '\\d')
				// Replace any standalone digit (not the one in `{}`) with \d
				.replace(STANDALONE_DIGIT_PATTERN, '\\d');
	
				// This match will always succeed,
				// because the "longest dummy phone number"
				// has enough length to accomodate any possible
				// national phone number format pattern.
				var dummy_phone_number_matching_format_pattern = LONGEST_DUMMY_PHONE_NUMBER.match(number_pattern)[0];
	
				// If the national number entered is too long
				// for any phone number format, then abort.
				if (this.national_number.length > dummy_phone_number_matching_format_pattern.length) {
					return;
				}
	
				// Prepare the phone number format
				var number_format = this.get_format_format(format, national_prefix_formatting_rule);
	
				// Get a formatting template which can be used to efficiently format
				// a partial number where digits are added one by one.
	
				// Below `strict_pattern` is used for the
				// regular expression (with `^` and `$`).
				// This wasn't originally in Google's `libphonenumber`
				// and I guess they don't really need it
				// because they're not using "templates" to format phone numbers
				// but I added `strict_pattern` after encountering
				// South Korean phone number formatting bug.
				//
				// Non-strict regular expression bug demonstration:
				//
				// this.national_number : `111111111` (9 digits)
				//
				// number_pattern : (\d{2})(\d{3,4})(\d{4})
				// number_format : `$1 $2 $3`
				// dummy_phone_number_matching_format_pattern : `9999999999` (10 digits)
				//
				// '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
				//
				// template : xx xxxx xxxx
				//
				// But the correct template in this case is `xx xxx xxxx`.
				// The template was generated incorrectly because of the
				// `{3,4}` variability in the `number_pattern`.
				//
				// The fix is, if `this.national_number` has already sufficient length
				// to satisfy the `number_pattern` completely then `this.national_number` is used
				// instead of `dummy_phone_number_matching_format_pattern`.
	
				var strict_pattern = new RegExp('^' + number_pattern + '$');
				var national_number_dummy_digits = this.national_number.replace(/\d/g, DUMMY_DIGIT);
	
				// If `this.national_number` has already sufficient length
				// to satisfy the `number_pattern` completely then use it
				// instead of `dummy_phone_number_matching_format_pattern`.
				if (strict_pattern.test(national_number_dummy_digits)) {
					dummy_phone_number_matching_format_pattern = national_number_dummy_digits;
				}
	
				// Generate formatting template for this phone number format
				return dummy_phone_number_matching_format_pattern
				// Format the dummy phone number according to the format
				.replace(new RegExp(number_pattern), number_format)
				// Replace each dummy digit with a DIGIT_PLACEHOLDER
				.replace(DUMMY_DIGIT_MATCHER, DIGIT_PLACEHOLDER);
			}
		}, {
			key: 'format_next_national_number_digits',
			value: function format_next_national_number_digits(digits) {
				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;
	
				try {
					for (var _iterator3 = (0, _getIterator3.default)(digits), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var digit = _step3.value;
	
						// If there is room for more digits in current `template`,
						// then set the next digit in the `template`,
						// and return the formatted digits so far.
	
						// If more digits are entered than the current format could handle
						if (this.partially_populated_template.slice(this.last_match_position + 1).search(DIGIT_PLACEHOLDER_MATCHER) === -1) {
							// Reset the current format,
							// so that the new format will be chosen
							// in a subsequent `this.choose_another_format()` call
							// later in code.
							this.chosen_format = undefined;
							this.template = undefined;
							this.partially_populated_template = undefined;
							return;
						}
	
						this.last_match_position = this.partially_populated_template.search(DIGIT_PLACEHOLDER_MATCHER);
						this.partially_populated_template = this.partially_populated_template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
					}
	
					// Return the formatted phone number so far
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
	
				return close_dangling_braces(this.partially_populated_template, this.last_match_position + 1).replace(DIGIT_PLACEHOLDER_MATCHER_GLOBAL, ' ');
			}
		}, {
			key: 'is_international',
			value: function is_international() {
				return this.parsed_input && this.parsed_input[0] === '+';
			}
		}, {
			key: 'get_format_format',
			value: function get_format_format(format, national_prefix_formatting_rule) {
				var number_format = this.is_international() ? (0, _metadata.get_format_international_format)(format) : (0, _metadata.get_format_format)(format);
	
				// If national prefix formatting rule is set
				// for this phone number format
				if (national_prefix_formatting_rule) {
					// If the user did input the national prefix
					// (or if the national prefix formatting rule does not require national prefix)
					// then maybe make it part of the phone number template
					if (this.national_prefix || !(0, _metadata.get_format_uses_national_prefix)(national_prefix_formatting_rule)) {
						// Make the national prefix part of the phone number template
						number_format = number_format.replace(_format.FIRST_GROUP_PATTERN, national_prefix_formatting_rule);
					}
				}
	
				if (this.is_international()) {
					return (0, _format.local_to_international_style)(number_format);
				}
	
				return number_format;
			}
	
			// Determines the country of the phone number
			// entered so far based on the country phone code
			// and the national phone number.
	
		}, {
			key: 'determine_the_country',
			value: function determine_the_country() {
				this.country = (0, _parse.find_country_code)(this.country_phone_code, this.national_number, this.metadata);
			}
		}]);
		return as_you_type;
	}();
	
	exports.default = as_you_type;
	function close_dangling_braces(template, cut_before) {
		var retained_template = template.slice(0, cut_before);
	
		var opening_braces = count_occurences('(', retained_template);
		var closing_braces = count_occurences(')', retained_template);
	
		var dangling_braces = opening_braces - closing_braces;
	
		while (dangling_braces > 0 && cut_before < template.length) {
			if (template[cut_before] === ')') {
				dangling_braces--;
			}
			cut_before++;
		}
	
		return template.slice(0, cut_before);
	}
	
	// Counts all occurences of a symbol in a string
	function count_occurences(symbol, string) {
		var count = 0;
	
		var _iteratorNormalCompletion4 = true;
		var _didIteratorError4 = false;
		var _iteratorError4 = undefined;
	
		try {
			for (var _iterator4 = (0, _getIterator3.default)(string), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
				var character = _step4.value;
	
				if (character === symbol) {
					count++;
				}
			}
		} catch (err) {
			_didIteratorError4 = true;
			_iteratorError4 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion4 && _iterator4.return) {
					_iterator4.return();
				}
			} finally {
				if (_didIteratorError4) {
					throw _iteratorError4;
				}
			}
		}
	
		return count;
	}
	
	// Repeats a string (or a symbol) N times.
	// http://stackoverflow.com/questions/202605/repeat-string-javascript
	function repeat(string, times) {
		if (times < 1) {
			return '';
		}
	
		var result = '';
	
		while (times > 1) {
			if (times & 1) {
				result += string;
			}
	
			times >>= 1;
			string += string;
		}
	
		return result + string;
	}
	//# sourceMappingURL=AsYouType.js.map

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	exports = module.exports = {}
	
	exports.parse             = __webpack_require__(110).default
	exports.DIGITS            = __webpack_require__(110).DIGIT_MAPPINGS
	exports.format            = __webpack_require__(248).default
	exports.getNumberType     = __webpack_require__(249).default
	exports.isValidNumber     = __webpack_require__(1023).default
	exports.AsYouType         = __webpack_require__(417).default
	exports.DIGIT_PLACEHOLDER = __webpack_require__(417).DIGIT_PLACEHOLDER
	
	// `get_number_type` name is deprecated
	exports.get_number_type = exports.getNumberType
	// `is_valid_number` name is deprecated
	exports.is_valid_number = exports.isValidNumber
	// `as_you_type` name is deprecated
	exports.as_you_type = exports.AsYouType
	// `asYouType` name is deprecated
	exports.asYouType = exports.AsYouType
	
	var get_phone_code = __webpack_require__(109).get_phone_code
	
	exports.getPhoneCode = function(country, metadata)
	{
		if (!metadata.countries[country])
		{
			throw new Error('Unknown country: "' + country + '"')
		}
	
		return get_phone_code(metadata.countries[country])
	}
	
	// exports['default'] = ...

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 534 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * Quill Editor v1.3.7
	 * https://quilljs.com/
	 * Copyright (c) 2014, Jason Chen
	 * Copyright (c) 2013, salesforce.com
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Quill"] = factory();
		else
			root["Quill"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 109);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var format_1 = __webpack_require__(18);
	var leaf_1 = __webpack_require__(19);
	var scroll_1 = __webpack_require__(45);
	var inline_1 = __webpack_require__(46);
	var block_1 = __webpack_require__(47);
	var embed_1 = __webpack_require__(48);
	var text_1 = __webpack_require__(49);
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var store_1 = __webpack_require__(31);
	var Registry = __webpack_require__(1);
	var Parchment = {
	    Scope: Registry.Scope,
	    create: Registry.create,
	    find: Registry.find,
	    query: Registry.query,
	    register: Registry.register,
	    Container: container_1.default,
	    Format: format_1.default,
	    Leaf: leaf_1.default,
	    Embed: embed_1.default,
	    Scroll: scroll_1.default,
	    Block: block_1.default,
	    Inline: inline_1.default,
	    Text: text_1.default,
	    Attributor: {
	        Attribute: attributor_1.default,
	        Class: class_1.default,
	        Style: style_1.default,
	        Store: store_1.default,
	    },
	};
	exports.default = Parchment;
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ParchmentError = /** @class */ (function (_super) {
	    __extends(ParchmentError, _super);
	    function ParchmentError(message) {
	        var _this = this;
	        message = '[Parchment] ' + message;
	        _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _this.constructor.name;
	        return _this;
	    }
	    return ParchmentError;
	}(Error));
	exports.ParchmentError = ParchmentError;
	var attributes = {};
	var classes = {};
	var tags = {};
	var types = {};
	exports.DATA_KEY = '__blot';
	var Scope;
	(function (Scope) {
	    Scope[Scope["TYPE"] = 3] = "TYPE";
	    Scope[Scope["LEVEL"] = 12] = "LEVEL";
	    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
	    Scope[Scope["BLOT"] = 14] = "BLOT";
	    Scope[Scope["INLINE"] = 7] = "INLINE";
	    Scope[Scope["BLOCK"] = 11] = "BLOCK";
	    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
	    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
	    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
	    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
	    Scope[Scope["ANY"] = 15] = "ANY";
	})(Scope = exports.Scope || (exports.Scope = {}));
	function create(input, value) {
	    var match = query(input);
	    if (match == null) {
	        throw new ParchmentError("Unable to create " + input + " blot");
	    }
	    var BlotClass = match;
	    var node = 
	    // @ts-ignore
	    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
	    return new BlotClass(node, value);
	}
	exports.create = create;
	function find(node, bubble) {
	    if (bubble === void 0) { bubble = false; }
	    if (node == null)
	        return null;
	    // @ts-ignore
	    if (node[exports.DATA_KEY] != null)
	        return node[exports.DATA_KEY].blot;
	    if (bubble)
	        return find(node.parentNode, bubble);
	    return null;
	}
	exports.find = find;
	function query(query, scope) {
	    if (scope === void 0) { scope = Scope.ANY; }
	    var match;
	    if (typeof query === 'string') {
	        match = types[query] || attributes[query];
	        // @ts-ignore
	    }
	    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
	        match = types['text'];
	    }
	    else if (typeof query === 'number') {
	        if (query & Scope.LEVEL & Scope.BLOCK) {
	            match = types['block'];
	        }
	        else if (query & Scope.LEVEL & Scope.INLINE) {
	            match = types['inline'];
	        }
	    }
	    else if (query instanceof HTMLElement) {
	        var names = (query.getAttribute('class') || '').split(/\s+/);
	        for (var i in names) {
	            match = classes[names[i]];
	            if (match)
	                break;
	        }
	        match = match || tags[query.tagName];
	    }
	    if (match == null)
	        return null;
	    // @ts-ignore
	    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
	        return match;
	    return null;
	}
	exports.query = query;
	function register() {
	    var Definitions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        Definitions[_i] = arguments[_i];
	    }
	    if (Definitions.length > 1) {
	        return Definitions.map(function (d) {
	            return register(d);
	        });
	    }
	    var Definition = Definitions[0];
	    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
	        throw new ParchmentError('Invalid definition');
	    }
	    else if (Definition.blotName === 'abstract') {
	        throw new ParchmentError('Cannot register abstract class');
	    }
	    types[Definition.blotName || Definition.attrName] = Definition;
	    if (typeof Definition.keyName === 'string') {
	        attributes[Definition.keyName] = Definition;
	    }
	    else {
	        if (Definition.className != null) {
	            classes[Definition.className] = Definition;
	        }
	        if (Definition.tagName != null) {
	            if (Array.isArray(Definition.tagName)) {
	                Definition.tagName = Definition.tagName.map(function (tagName) {
	                    return tagName.toUpperCase();
	                });
	            }
	            else {
	                Definition.tagName = Definition.tagName.toUpperCase();
	            }
	            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
	            tagNames.forEach(function (tag) {
	                if (tags[tag] == null || Definition.className == null) {
	                    tags[tag] = Definition;
	                }
	            });
	        }
	    }
	    return Definition;
	}
	exports.register = register;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var diff = __webpack_require__(51);
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	var op = __webpack_require__(20);
	
	
	var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()
	
	
	var Delta = function (ops) {
	  // Assume we are given a well formed ops
	  if (Array.isArray(ops)) {
	    this.ops = ops;
	  } else if (ops != null && Array.isArray(ops.ops)) {
	    this.ops = ops.ops;
	  } else {
	    this.ops = [];
	  }
	};
	
	
	Delta.prototype.insert = function (text, attributes) {
	  var newOp = {};
	  if (text.length === 0) return this;
	  newOp.insert = text;
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype['delete'] = function (length) {
	  if (length <= 0) return this;
	  return this.push({ 'delete': length });
	};
	
	Delta.prototype.retain = function (length, attributes) {
	  if (length <= 0) return this;
	  var newOp = { retain: length };
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype.push = function (newOp) {
	  var index = this.ops.length;
	  var lastOp = this.ops[index - 1];
	  newOp = extend(true, {}, newOp);
	  if (typeof lastOp === 'object') {
	    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
	      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
	      return this;
	    }
	    // Since it does not matter if we insert before or after deleting at the same index,
	    // always prefer to insert first
	    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
	      index -= 1;
	      lastOp = this.ops[index - 1];
	      if (typeof lastOp !== 'object') {
	        this.ops.unshift(newOp);
	        return this;
	      }
	    }
	    if (equal(newOp.attributes, lastOp.attributes)) {
	      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
	        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
	        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      }
	    }
	  }
	  if (index === this.ops.length) {
	    this.ops.push(newOp);
	  } else {
	    this.ops.splice(index, 0, newOp);
	  }
	  return this;
	};
	
	Delta.prototype.chop = function () {
	  var lastOp = this.ops[this.ops.length - 1];
	  if (lastOp && lastOp.retain && !lastOp.attributes) {
	    this.ops.pop();
	  }
	  return this;
	};
	
	Delta.prototype.filter = function (predicate) {
	  return this.ops.filter(predicate);
	};
	
	Delta.prototype.forEach = function (predicate) {
	  this.ops.forEach(predicate);
	};
	
	Delta.prototype.map = function (predicate) {
	  return this.ops.map(predicate);
	};
	
	Delta.prototype.partition = function (predicate) {
	  var passed = [], failed = [];
	  this.forEach(function(op) {
	    var target = predicate(op) ? passed : failed;
	    target.push(op);
	  });
	  return [passed, failed];
	};
	
	Delta.prototype.reduce = function (predicate, initial) {
	  return this.ops.reduce(predicate, initial);
	};
	
	Delta.prototype.changeLength = function () {
	  return this.reduce(function (length, elem) {
	    if (elem.insert) {
	      return length + op.length(elem);
	    } else if (elem.delete) {
	      return length - elem.delete;
	    }
	    return length;
	  }, 0);
	};
	
	Delta.prototype.length = function () {
	  return this.reduce(function (length, elem) {
	    return length + op.length(elem);
	  }, 0);
	};
	
	Delta.prototype.slice = function (start, end) {
	  start = start || 0;
	  if (typeof end !== 'number') end = Infinity;
	  var ops = [];
	  var iter = op.iterator(this.ops);
	  var index = 0;
	  while (index < end && iter.hasNext()) {
	    var nextOp;
	    if (index < start) {
	      nextOp = iter.next(start - index);
	    } else {
	      nextOp = iter.next(end - index);
	      ops.push(nextOp);
	    }
	    index += op.length(nextOp);
	  }
	  return new Delta(ops);
	};
	
	
	Delta.prototype.compose = function (other) {
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var ops = [];
	  var firstOther = otherIter.peek();
	  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
	    var firstLeft = firstOther.retain;
	    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
	      firstLeft -= thisIter.peekLength();
	      ops.push(thisIter.next());
	    }
	    if (firstOther.retain - firstLeft > 0) {
	      otherIter.next(firstOther.retain - firstLeft);
	    }
	  }
	  var delta = new Delta(ops);
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else if (thisIter.peekType() === 'delete') {
	      delta.push(thisIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (typeof otherOp.retain === 'number') {
	        var newOp = {};
	        if (typeof thisOp.retain === 'number') {
	          newOp.retain = length;
	        } else {
	          newOp.insert = thisOp.insert;
	        }
	        // Preserve null when composing with a retain, otherwise remove it for inserts
	        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
	        if (attributes) newOp.attributes = attributes;
	        delta.push(newOp);
	
	        // Optimization if rest of other is just retain
	        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
	          var rest = new Delta(thisIter.rest());
	          return delta.concat(rest).chop();
	        }
	
	      // Other op should be delete, we could be an insert or retain
	      // Insert + delete cancels out
	      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
	        delta.push(otherOp);
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.concat = function (other) {
	  var delta = new Delta(this.ops.slice());
	  if (other.ops.length > 0) {
	    delta.push(other.ops[0]);
	    delta.ops = delta.ops.concat(other.ops.slice(1));
	  }
	  return delta;
	};
	
	Delta.prototype.diff = function (other, index) {
	  if (this.ops === other.ops) {
	    return new Delta();
	  }
	  var strings = [this, other].map(function (delta) {
	    return delta.map(function (op) {
	      if (op.insert != null) {
	        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
	      }
	      var prep = (delta === other) ? 'on' : 'with';
	      throw new Error('diff() called ' + prep + ' non-document');
	    }).join('');
	  });
	  var delta = new Delta();
	  var diffResult = diff(strings[0], strings[1], index);
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  diffResult.forEach(function (component) {
	    var length = component[1].length;
	    while (length > 0) {
	      var opLength = 0;
	      switch (component[0]) {
	        case diff.INSERT:
	          opLength = Math.min(otherIter.peekLength(), length);
	          delta.push(otherIter.next(opLength));
	          break;
	        case diff.DELETE:
	          opLength = Math.min(length, thisIter.peekLength());
	          thisIter.next(opLength);
	          delta['delete'](opLength);
	          break;
	        case diff.EQUAL:
	          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
	          var thisOp = thisIter.next(opLength);
	          var otherOp = otherIter.next(opLength);
	          if (equal(thisOp.insert, otherOp.insert)) {
	            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
	          } else {
	            delta.push(otherOp)['delete'](opLength);
	          }
	          break;
	      }
	      length -= opLength;
	    }
	  });
	  return delta.chop();
	};
	
	Delta.prototype.eachLine = function (predicate, newline) {
	  newline = newline || '\n';
	  var iter = op.iterator(this.ops);
	  var line = new Delta();
	  var i = 0;
	  while (iter.hasNext()) {
	    if (iter.peekType() !== 'insert') return;
	    var thisOp = iter.peek();
	    var start = op.length(thisOp) - iter.peekLength();
	    var index = typeof thisOp.insert === 'string' ?
	      thisOp.insert.indexOf(newline, start) - start : -1;
	    if (index < 0) {
	      line.push(iter.next());
	    } else if (index > 0) {
	      line.push(iter.next(index));
	    } else {
	      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
	        return;
	      }
	      i += 1;
	      line = new Delta();
	    }
	  }
	  if (line.length() > 0) {
	    predicate(line, {}, i);
	  }
	};
	
	Delta.prototype.transform = function (other, priority) {
	  priority = !!priority;
	  if (typeof other === 'number') {
	    return this.transformPosition(other, priority);
	  }
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
	      delta.retain(op.length(thisIter.next()));
	    } else if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (thisOp['delete']) {
	        // Our delete either makes their delete redundant or removes their retain
	        continue;
	      } else if (otherOp['delete']) {
	        delta.push(otherOp);
	      } else {
	        // We retain either their retain or insert
	        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.transformPosition = function (index, priority) {
	  priority = !!priority;
	  var thisIter = op.iterator(this.ops);
	  var offset = 0;
	  while (thisIter.hasNext() && offset <= index) {
	    var length = thisIter.peekLength();
	    var nextType = thisIter.peekType();
	    thisIter.next();
	    if (nextType === 'delete') {
	      index -= Math.min(length, index - offset);
	      continue;
	    } else if (nextType === 'insert' && (offset < index || !priority)) {
	      index += length;
	    }
	    offset += length;
	  }
	  return index;
	};
	
	
	module.exports = Delta;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWLINE_LENGTH = 1;
	
	var BlockEmbed = function (_Parchment$Embed) {
	  _inherits(BlockEmbed, _Parchment$Embed);
	
	  function BlockEmbed() {
	    _classCallCheck(this, BlockEmbed);
	
	    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
	  }
	
	  _createClass(BlockEmbed, [{
	    key: 'attach',
	    value: function attach() {
	      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
	      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
	    }
	  }, {
	    key: 'delta',
	    value: function delta() {
	      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
	      if (attribute != null) {
	        this.attributes.attribute(attribute, value);
	      }
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      this.format(name, value);
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (typeof value === 'string' && value.endsWith('\n')) {
	        var block = _parchment2.default.create(Block.blotName);
	        this.parent.insertBefore(block, index === 0 ? this : this.next);
	        block.insertAt(0, value.slice(0, -1));
	      } else {
	        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	    }
	  }]);
	
	  return BlockEmbed;
	}(_parchment2.default.Embed);
	
	BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
	// It is important for cursor behavior BlockEmbeds use tags that are block level elements
	
	
	var Block = function (_Parchment$Block) {
	  _inherits(Block, _Parchment$Block);
	
	  function Block(domNode) {
	    _classCallCheck(this, Block);
	
	    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
	
	    _this2.cache = {};
	    return _this2;
	  }
	
	  _createClass(Block, [{
	    key: 'delta',
	    value: function delta() {
	      if (this.cache.delta == null) {
	        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
	          if (leaf.length() === 0) {
	            return delta;
	          } else {
	            return delta.insert(leaf.value(), bubbleFormats(leaf));
	          }
	        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
	      }
	      return this.cache.delta;
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
	      this.cache = {};
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length <= 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	        if (index + length === this.length()) {
	          this.format(name, value);
	        }
	      } else {
	        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
	      if (value.length === 0) return;
	      var lines = value.split('\n');
	      var text = lines.shift();
	      if (text.length > 0) {
	        if (index < this.length() - 1 || this.children.tail == null) {
	          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
	        } else {
	          this.children.tail.insertAt(this.children.tail.length(), text);
	        }
	        this.cache = {};
	      }
	      var block = this;
	      lines.reduce(function (index, line) {
	        block = block.split(index, true);
	        block.insertAt(0, line);
	        return line.length;
	      }, index + text.length);
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      var head = this.children.head;
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
	      if (head instanceof _break2.default) {
	        head.remove();
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      if (this.cache.length == null) {
	        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
	      }
	      return this.cache.length;
	    }
	  }, {
	    key: 'moveChildren',
	    value: function moveChildren(target, ref) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
	      this.cache = {};
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
	      this.cache = {};
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
	      this.cache = {};
	    }
	  }, {
	    key: 'split',
	    value: function split(index) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
	        var clone = this.clone();
	        if (index === 0) {
	          this.parent.insertBefore(clone, this);
	          return this;
	        } else {
	          this.parent.insertBefore(clone, this.next);
	          return clone;
	        }
	      } else {
	        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
	        this.cache = {};
	        return next;
	      }
	    }
	  }]);
	
	  return Block;
	}(_parchment2.default.Block);
	
	Block.blotName = 'block';
	Block.tagName = 'P';
	Block.defaultChild = 'break';
	Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];
	
	function bubbleFormats(blot) {
	  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (blot == null) return formats;
	  if (typeof blot.formats === 'function') {
	    formats = (0, _extend2.default)(formats, blot.formats());
	  }
	  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
	    return formats;
	  }
	  return bubbleFormats(blot.parent, formats);
	}
	
	exports.bubbleFormats = bubbleFormats;
	exports.BlockEmbed = BlockEmbed;
	exports.default = Block;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.overload = exports.expandConfig = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(50);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _editor = __webpack_require__(14);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _selection = __webpack_require__(15);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill');
	
	var Quill = function () {
	  _createClass(Quill, null, [{
	    key: 'debug',
	    value: function debug(limit) {
	      if (limit === true) {
	        limit = 'log';
	      }
	      _logger2.default.level(limit);
	    }
	  }, {
	    key: 'find',
	    value: function find(node) {
	      return node.__quill || _parchment2.default.find(node);
	    }
	  }, {
	    key: 'import',
	    value: function _import(name) {
	      if (this.imports[name] == null) {
	        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
	      }
	      return this.imports[name];
	    }
	  }, {
	    key: 'register',
	    value: function register(path, target) {
	      var _this = this;
	
	      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (typeof path !== 'string') {
	        var name = path.attrName || path.blotName;
	        if (typeof name === 'string') {
	          // register(Blot | Attributor, overwrite)
	          this.register('formats/' + name, path, target);
	        } else {
	          Object.keys(path).forEach(function (key) {
	            _this.register(key, path[key], target);
	          });
	        }
	      } else {
	        if (this.imports[path] != null && !overwrite) {
	          debug.warn('Overwriting ' + path + ' with', target);
	        }
	        this.imports[path] = target;
	        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
	          _parchment2.default.register(target);
	        } else if (path.startsWith('modules') && typeof target.register === 'function') {
	          target.register();
	        }
	      }
	    }
	  }]);
	
	  function Quill(container) {
	    var _this2 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Quill);
	
	    this.options = expandConfig(container, options);
	    this.container = this.options.container;
	    if (this.container == null) {
	      return debug.error('Invalid Quill container', container);
	    }
	    if (this.options.debug) {
	      Quill.debug(this.options.debug);
	    }
	    var html = this.container.innerHTML.trim();
	    this.container.classList.add('ql-container');
	    this.container.innerHTML = '';
	    this.container.__quill = this;
	    this.root = this.addContainer('ql-editor');
	    this.root.classList.add('ql-blank');
	    this.root.setAttribute('data-gramm', false);
	    this.scrollingContainer = this.options.scrollingContainer || this.root;
	    this.emitter = new _emitter4.default();
	    this.scroll = _parchment2.default.create(this.root, {
	      emitter: this.emitter,
	      whitelist: this.options.formats
	    });
	    this.editor = new _editor2.default(this.scroll);
	    this.selection = new _selection2.default(this.scroll, this.emitter);
	    this.theme = new this.options.theme(this, this.options);
	    this.keyboard = this.theme.addModule('keyboard');
	    this.clipboard = this.theme.addModule('clipboard');
	    this.history = this.theme.addModule('history');
	    this.theme.init();
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
	      if (type === _emitter4.default.events.TEXT_CHANGE) {
	        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
	      var range = _this2.selection.lastRange;
	      var index = range && range.length === 0 ? range.index : undefined;
	      modify.call(_this2, function () {
	        return _this2.editor.update(null, mutations, index);
	      }, source);
	    });
	    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
	    this.setContents(contents);
	    this.history.clear();
	    if (this.options.placeholder) {
	      this.root.setAttribute('data-placeholder', this.options.placeholder);
	    }
	    if (this.options.readOnly) {
	      this.disable();
	    }
	  }
	
	  _createClass(Quill, [{
	    key: 'addContainer',
	    value: function addContainer(container) {
	      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (typeof container === 'string') {
	        var className = container;
	        container = document.createElement('div');
	        container.classList.add(className);
	      }
	      this.container.insertBefore(container, refNode);
	      return container;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.selection.setRange(null);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length, source) {
	      var _this3 = this;
	
	      var _overload = overload(index, length, source);
	
	      var _overload2 = _slicedToArray(_overload, 4);
	
	      index = _overload2[0];
	      length = _overload2[1];
	      source = _overload2[3];
	
	      return modify.call(this, function () {
	        return _this3.editor.deleteText(index, length);
	      }, source, index, -1 * length);
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this.enable(false);
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.scroll.enable(enabled);
	      this.container.classList.toggle('ql-disabled', !enabled);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var scrollTop = this.scrollingContainer.scrollTop;
	      this.selection.focus();
	      this.scrollingContainer.scrollTop = scrollTop;
	      this.scrollIntoView();
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var _this4 = this;
	
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        var range = _this4.getSelection(true);
	        var change = new _quillDelta2.default();
	        if (range == null) {
	          return change;
	        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
	        } else if (range.length === 0) {
	          _this4.selection.format(name, value);
	          return change;
	        } else {
	          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
	        }
	        _this4.setSelection(range, _emitter4.default.sources.SILENT);
	        return change;
	      }, source);
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length, name, value, source) {
	      var _this5 = this;
	
	      var formats = void 0;
	
	      var _overload3 = overload(index, length, name, value, source);
	
	      var _overload4 = _slicedToArray(_overload3, 4);
	
	      index = _overload4[0];
	      length = _overload4[1];
	      formats = _overload4[2];
	      source = _overload4[3];
	
	      return modify.call(this, function () {
	        return _this5.editor.formatLine(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length, name, value, source) {
	      var _this6 = this;
	
	      var formats = void 0;
	
	      var _overload5 = overload(index, length, name, value, source);
	
	      var _overload6 = _slicedToArray(_overload5, 4);
	
	      index = _overload6[0];
	      length = _overload6[1];
	      formats = _overload6[2];
	      source = _overload6[3];
	
	      return modify.call(this, function () {
	        return _this6.editor.formatText(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var bounds = void 0;
	      if (typeof index === 'number') {
	        bounds = this.selection.getBounds(index, length);
	      } else {
	        bounds = this.selection.getBounds(index.index, index.length);
	      }
	      var containerBounds = this.container.getBoundingClientRect();
	      return {
	        bottom: bounds.bottom - containerBounds.top,
	        height: bounds.height,
	        left: bounds.left - containerBounds.left,
	        right: bounds.right - containerBounds.left,
	        top: bounds.top - containerBounds.top,
	        width: bounds.width
	      };
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload7 = overload(index, length);
	
	      var _overload8 = _slicedToArray(_overload7, 2);
	
	      index = _overload8[0];
	      length = _overload8[1];
	
	      return this.editor.getContents(index, length);
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (typeof index === 'number') {
	        return this.editor.getFormat(index, length);
	      } else {
	        return this.editor.getFormat(index.index, index.length);
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(blot) {
	      return blot.offset(this.scroll);
	    }
	  }, {
	    key: 'getLength',
	    value: function getLength() {
	      return this.scroll.length();
	    }
	  }, {
	    key: 'getLeaf',
	    value: function getLeaf(index) {
	      return this.scroll.leaf(index);
	    }
	  }, {
	    key: 'getLine',
	    value: function getLine(index) {
	      return this.scroll.line(index);
	    }
	  }, {
	    key: 'getLines',
	    value: function getLines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      if (typeof index !== 'number') {
	        return this.scroll.lines(index.index, index.length);
	      } else {
	        return this.scroll.lines(index, length);
	      }
	    }
	  }, {
	    key: 'getModule',
	    value: function getModule(name) {
	      return this.theme.modules[name];
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (focus) this.focus();
	      this.update(); // Make sure we access getRange with editor in consistent state
	      return this.selection.getRange()[0];
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload9 = overload(index, length);
	
	      var _overload10 = _slicedToArray(_overload9, 2);
	
	      index = _overload10[0];
	      length = _overload10[1];
	
	      return this.editor.getText(index, length);
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return this.selection.hasFocus();
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      var _this7 = this;
	
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
	
	      return modify.call(this, function () {
	        return _this7.editor.insertEmbed(index, embed, value);
	      }, source, index);
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text, name, value, source) {
	      var _this8 = this;
	
	      var formats = void 0;
	
	      var _overload11 = overload(index, 0, name, value, source);
	
	      var _overload12 = _slicedToArray(_overload11, 4);
	
	      index = _overload12[0];
	      formats = _overload12[2];
	      source = _overload12[3];
	
	      return modify.call(this, function () {
	        return _this8.editor.insertText(index, text, formats);
	      }, source, index, text.length);
	    }
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return !this.container.classList.contains('ql-disabled');
	    }
	  }, {
	    key: 'off',
	    value: function off() {
	      return this.emitter.off.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'on',
	    value: function on() {
	      return this.emitter.on.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'once',
	    value: function once() {
	      return this.emitter.once.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'pasteHTML',
	    value: function pasteHTML(index, html, source) {
	      this.clipboard.dangerouslyPasteHTML(index, html, source);
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length, source) {
	      var _this9 = this;
	
	      var _overload13 = overload(index, length, source);
	
	      var _overload14 = _slicedToArray(_overload13, 4);
	
	      index = _overload14[0];
	      length = _overload14[1];
	      source = _overload14[3];
	
	      return modify.call(this, function () {
	        return _this9.editor.removeFormat(index, length);
	      }, source, index);
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView() {
	      this.selection.scrollIntoView(this.scrollingContainer);
	    }
	  }, {
	    key: 'setContents',
	    value: function setContents(delta) {
	      var _this10 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        var length = _this10.getLength();
	        var deleted = _this10.editor.deleteText(0, length);
	        var applied = _this10.editor.applyDelta(delta);
	        var lastOp = applied.ops[applied.ops.length - 1];
	        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
	          _this10.editor.deleteText(_this10.getLength() - 1, 1);
	          applied.delete(1);
	        }
	        var ret = deleted.compose(applied);
	        return ret;
	      }, source);
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(index, length, source) {
	      if (index == null) {
	        this.selection.setRange(null, length || Quill.sources.API);
	      } else {
	        var _overload15 = overload(index, length, source);
	
	        var _overload16 = _slicedToArray(_overload15, 4);
	
	        index = _overload16[0];
	        length = _overload16[1];
	        source = _overload16[3];
	
	        this.selection.setRange(new _selection.Range(index, length), source);
	        if (source !== _emitter4.default.sources.SILENT) {
	          this.selection.scrollIntoView(this.scrollingContainer);
	        }
	      }
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      var delta = new _quillDelta2.default().insert(text);
	      return this.setContents(delta, source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
	      this.selection.update(source);
	      return change;
	    }
	  }, {
	    key: 'updateContents',
	    value: function updateContents(delta) {
	      var _this11 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        return _this11.editor.applyDelta(delta, source);
	      }, source, true);
	    }
	  }]);
	
	  return Quill;
	}();
	
	Quill.DEFAULTS = {
	  bounds: null,
	  formats: null,
	  modules: {},
	  placeholder: '',
	  readOnly: false,
	  scrollingContainer: null,
	  strict: true,
	  theme: 'default'
	};
	Quill.events = _emitter4.default.events;
	Quill.sources = _emitter4.default.sources;
	// eslint-disable-next-line no-undef
	Quill.version =  false ? 'dev' : "1.3.7";
	
	Quill.imports = {
	  'delta': _quillDelta2.default,
	  'parchment': _parchment2.default,
	  'core/module': _module2.default,
	  'core/theme': _theme2.default
	};
	
	function expandConfig(container, userConfig) {
	  userConfig = (0, _extend2.default)(true, {
	    container: container,
	    modules: {
	      clipboard: true,
	      keyboard: true,
	      history: true
	    }
	  }, userConfig);
	  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
	    userConfig.theme = _theme2.default;
	  } else {
	    userConfig.theme = Quill.import('themes/' + userConfig.theme);
	    if (userConfig.theme == null) {
	      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
	    }
	  }
	  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
	  [themeConfig, userConfig].forEach(function (config) {
	    config.modules = config.modules || {};
	    Object.keys(config.modules).forEach(function (module) {
	      if (config.modules[module] === true) {
	        config.modules[module] = {};
	      }
	    });
	  });
	  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
	  var moduleConfig = moduleNames.reduce(function (config, name) {
	    var moduleClass = Quill.import('modules/' + name);
	    if (moduleClass == null) {
	      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
	    } else {
	      config[name] = moduleClass.DEFAULTS || {};
	    }
	    return config;
	  }, {});
	  // Special case toolbar shorthand
	  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
	    userConfig.modules.toolbar = {
	      container: userConfig.modules.toolbar
	    };
	  }
	  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
	  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
	    if (typeof userConfig[key] === 'string') {
	      userConfig[key] = document.querySelector(userConfig[key]);
	    }
	  });
	  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
	    if (userConfig.modules[name]) {
	      config[name] = userConfig.modules[name];
	    }
	    return config;
	  }, {});
	  return userConfig;
	}
	
	// Handle selection preservation and TEXT_CHANGE emission
	// common to modification APIs
	function modify(modifier, source, index, shift) {
	  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
	    return new _quillDelta2.default();
	  }
	  var range = index == null ? null : this.getSelection();
	  var oldDelta = this.editor.delta;
	  var change = modifier();
	  if (range != null) {
	    if (index === true) index = range.index;
	    if (shift == null) {
	      range = shiftRange(range, change, source);
	    } else if (shift !== 0) {
	      range = shiftRange(range, index, shift, source);
	    }
	    this.setSelection(range, _emitter4.default.sources.SILENT);
	  }
	  if (change.length() > 0) {
	    var _emitter;
	
	    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
	    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	    if (source !== _emitter4.default.sources.SILENT) {
	      var _emitter2;
	
	      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	    }
	  }
	  return change;
	}
	
	function overload(index, length, name, value, source) {
	  var formats = {};
	  if (typeof index.index === 'number' && typeof index.length === 'number') {
	    // Allow for throwaway end (used by insertText/insertEmbed)
	    if (typeof length !== 'number') {
	      source = value, value = name, name = length, length = index.length, index = index.index;
	    } else {
	      length = index.length, index = index.index;
	    }
	  } else if (typeof length !== 'number') {
	    source = value, value = name, name = length, length = 0;
	  }
	  // Handle format being object, two format name/value strings or excluded
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    formats = name;
	    source = value;
	  } else if (typeof name === 'string') {
	    if (value != null) {
	      formats[name] = value;
	    } else {
	      source = name;
	    }
	  }
	  // Handle optional source
	  source = source || _emitter4.default.sources.API;
	  return [index, length, formats, source];
	}
	
	function shiftRange(range, index, length, source) {
	  if (range == null) return null;
	  var start = void 0,
	      end = void 0;
	  if (index instanceof _quillDelta2.default) {
	    var _map = [range.index, range.index + range.length].map(function (pos) {
	      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
	    });
	
	    var _map2 = _slicedToArray(_map, 2);
	
	    start = _map2[0];
	    end = _map2[1];
	  } else {
	    var _map3 = [range.index, range.index + range.length].map(function (pos) {
	      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
	      if (length >= 0) {
	        return pos + length;
	      } else {
	        return Math.max(index, pos + length);
	      }
	    });
	
	    var _map4 = _slicedToArray(_map3, 2);
	
	    start = _map4[0];
	    end = _map4[1];
	  }
	  return new _selection.Range(start, end - start);
	}
	
	exports.expandConfig = expandConfig;
	exports.overload = overload;
	exports.default = Quill;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Inline = function (_Parchment$Inline) {
	  _inherits(Inline, _Parchment$Inline);
	
	  function Inline() {
	    _classCallCheck(this, Inline);
	
	    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
	  }
	
	  _createClass(Inline, [{
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
	        var blot = this.isolate(index, length);
	        if (value) {
	          blot.wrap(name, value);
	        }
	      } else {
	        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
	      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
	        var parent = this.parent.isolate(this.offset(), this.length());
	        this.moveChildren(parent);
	        parent.wrap(this);
	      }
	    }
	  }], [{
	    key: 'compare',
	    value: function compare(self, other) {
	      var selfIndex = Inline.order.indexOf(self);
	      var otherIndex = Inline.order.indexOf(other);
	      if (selfIndex >= 0 || otherIndex >= 0) {
	        return selfIndex - otherIndex;
	      } else if (self === other) {
	        return 0;
	      } else if (self < other) {
	        return -1;
	      } else {
	        return 1;
	      }
	    }
	  }]);
	
	  return Inline;
	}(_parchment2.default.Inline);
	
	Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
	// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
	Inline.order = ['cursor', 'inline', // Must be lower
	'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
	];
	
	exports.default = Inline;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBlot = function (_Parchment$Text) {
	  _inherits(TextBlot, _Parchment$Text);
	
	  function TextBlot() {
	    _classCallCheck(this, TextBlot);
	
	    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
	  }
	
	  return TextBlot;
	}(_parchment2.default.Text);
	
	exports.default = TextBlot;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _eventemitter = __webpack_require__(54);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:events');
	
	var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];
	
	EVENTS.forEach(function (eventName) {
	  document.addEventListener(eventName, function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
	      // TODO use WeakMap
	      if (node.__quill && node.__quill.emitter) {
	        var _node$__quill$emitter;
	
	        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
	      }
	    });
	  });
	});
	
	var Emitter = function (_EventEmitter) {
	  _inherits(Emitter, _EventEmitter);
	
	  function Emitter() {
	    _classCallCheck(this, Emitter);
	
	    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
	
	    _this.listeners = {};
	    _this.on('error', debug.error);
	    return _this;
	  }
	
	  _createClass(Emitter, [{
	    key: 'emit',
	    value: function emit() {
	      debug.log.apply(debug, arguments);
	      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
	    }
	  }, {
	    key: 'handleDOM',
	    value: function handleDOM(event) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      (this.listeners[event.type] || []).forEach(function (_ref) {
	        var node = _ref.node,
	            handler = _ref.handler;
	
	        if (event.target === node || node.contains(event.target)) {
	          handler.apply(undefined, [event].concat(args));
	        }
	      });
	    }
	  }, {
	    key: 'listenDOM',
	    value: function listenDOM(eventName, node, handler) {
	      if (!this.listeners[eventName]) {
	        this.listeners[eventName] = [];
	      }
	      this.listeners[eventName].push({ node: node, handler: handler });
	    }
	  }]);
	
	  return Emitter;
	}(_eventemitter2.default);
	
	Emitter.events = {
	  EDITOR_CHANGE: 'editor-change',
	  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
	  SCROLL_OPTIMIZE: 'scroll-optimize',
	  SCROLL_UPDATE: 'scroll-update',
	  SELECTION_CHANGE: 'selection-change',
	  TEXT_CHANGE: 'text-change'
	};
	Emitter.sources = {
	  API: 'api',
	  SILENT: 'silent',
	  USER: 'user'
	};
	
	exports.default = Emitter;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Module = function Module(quill) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  _classCallCheck(this, Module);
	
	  this.quill = quill;
	  this.options = options;
	};
	
	Module.DEFAULTS = {};
	
	exports.default = Module;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var levels = ['error', 'warn', 'log', 'info'];
	var level = 'warn';
	
	function debug(method) {
	  if (levels.indexOf(method) <= levels.indexOf(level)) {
	    var _console;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
	  }
	}
	
	function namespace(ns) {
	  return levels.reduce(function (logger, method) {
	    logger[method] = debug.bind(console, method, ns);
	    return logger;
	  }, {});
	}
	
	debug.level = namespace.level = function (newLevel) {
	  level = newLevel;
	};
	
	exports.default = namespace;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(52);
	var isArguments = __webpack_require__(53);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var Attributor = /** @class */ (function () {
	    function Attributor(attrName, keyName, options) {
	        if (options === void 0) { options = {}; }
	        this.attrName = attrName;
	        this.keyName = keyName;
	        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
	        if (options.scope != null) {
	            // Ignore type bits, force attribute bit
	            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
	        }
	        else {
	            this.scope = Registry.Scope.ATTRIBUTE;
	        }
	        if (options.whitelist != null)
	            this.whitelist = options.whitelist;
	    }
	    Attributor.keys = function (node) {
	        return [].map.call(node.attributes, function (item) {
	            return item.name;
	        });
	    };
	    Attributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        node.setAttribute(this.keyName, value);
	        return true;
	    };
	    Attributor.prototype.canAdd = function (node, value) {
	        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
	        if (match == null)
	            return false;
	        if (this.whitelist == null)
	            return true;
	        if (typeof value === 'string') {
	            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
	        }
	        else {
	            return this.whitelist.indexOf(value) > -1;
	        }
	    };
	    Attributor.prototype.remove = function (node) {
	        node.removeAttribute(this.keyName);
	    };
	    Attributor.prototype.value = function (node) {
	        var value = node.getAttribute(this.keyName);
	        if (this.canAdd(node, value) && value) {
	            return value;
	        }
	        return '';
	    };
	    return Attributor;
	}());
	exports.default = Attributor;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Code = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Code = function (_Inline) {
	  _inherits(Code, _Inline);
	
	  function Code() {
	    _classCallCheck(this, Code);
	
	    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
	  }
	
	  return Code;
	}(_inline2.default);
	
	Code.blotName = 'code';
	Code.tagName = 'CODE';
	
	var CodeBlock = function (_Block) {
	  _inherits(CodeBlock, _Block);
	
	  function CodeBlock() {
	    _classCallCheck(this, CodeBlock);
	
	    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(CodeBlock, [{
	    key: 'delta',
	    value: function delta() {
	      var _this3 = this;
	
	      var text = this.domNode.textContent;
	      if (text.endsWith('\n')) {
	        // Should always be true
	        text = text.slice(0, -1);
	      }
	      return text.split('\n').reduce(function (delta, frag) {
	        return delta.insert(frag).insert('\n', _this3.formats());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (name === this.statics.blotName && value) return;
	
	      var _descendant = this.descendant(_text2.default, this.length() - 1),
	          _descendant2 = _slicedToArray(_descendant, 1),
	          text = _descendant2[0];
	
	      if (text != null) {
	        text.deleteAt(text.length() - 1, 1);
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length === 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
	        return;
	      }
	      var nextNewline = this.newlineIndex(index);
	      if (nextNewline < 0 || nextNewline >= index + length) return;
	      var prevNewline = this.newlineIndex(index, true) + 1;
	      var isolateLength = nextNewline - prevNewline + 1;
	      var blot = this.isolate(prevNewline, isolateLength);
	      var next = blot.next;
	      blot.format(name, value);
	      if (next instanceof CodeBlock) {
	        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
	      }
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return;
	
	      var _descendant3 = this.descendant(_text2.default, index),
	          _descendant4 = _slicedToArray(_descendant3, 2),
	          text = _descendant4[0],
	          offset = _descendant4[1];
	
	      text.insertAt(offset, value);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      var length = this.domNode.textContent.length;
	      if (!this.domNode.textContent.endsWith('\n')) {
	        return length + 1;
	      }
	      return length;
	    }
	  }, {
	    key: 'newlineIndex',
	    value: function newlineIndex(searchIndex) {
	      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!reverse) {
	        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
	        return offset > -1 ? searchIndex + offset : -1;
	      } else {
	        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      if (!this.domNode.textContent.endsWith('\n')) {
	        this.appendChild(_parchment2.default.create('text', '\n'));
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
	        next.optimize(context);
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
	      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
	        var blot = _parchment2.default.find(node);
	        if (blot == null) {
	          node.parentNode.removeChild(node);
	        } else if (blot instanceof _parchment2.default.Embed) {
	          blot.remove();
	        } else {
	          blot.unwrap();
	        }
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
	      domNode.setAttribute('spellcheck', false);
	      return domNode;
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return CodeBlock;
	}(_block2.default);
	
	CodeBlock.blotName = 'code-block';
	CodeBlock.tagName = 'PRE';
	CodeBlock.TAB = '  ';
	
	exports.Code = Code;
	exports.default = CodeBlock;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ASCII = /^[ -~]*$/;
	
	var Editor = function () {
	  function Editor(scroll) {
	    _classCallCheck(this, Editor);
	
	    this.scroll = scroll;
	    this.delta = this.getDelta();
	  }
	
	  _createClass(Editor, [{
	    key: 'applyDelta',
	    value: function applyDelta(delta) {
	      var _this = this;
	
	      var consumeNextNewline = false;
	      this.scroll.update();
	      var scrollLength = this.scroll.length();
	      this.scroll.batchStart();
	      delta = normalizeDelta(delta);
	      delta.reduce(function (index, op) {
	        var length = op.retain || op.delete || op.insert.length || 1;
	        var attributes = op.attributes || {};
	        if (op.insert != null) {
	          if (typeof op.insert === 'string') {
	            var text = op.insert;
	            if (text.endsWith('\n') && consumeNextNewline) {
	              consumeNextNewline = false;
	              text = text.slice(0, -1);
	            }
	            if (index >= scrollLength && !text.endsWith('\n')) {
	              consumeNextNewline = true;
	            }
	            _this.scroll.insertAt(index, text);
	
	            var _scroll$line = _this.scroll.line(index),
	                _scroll$line2 = _slicedToArray(_scroll$line, 2),
	                line = _scroll$line2[0],
	                offset = _scroll$line2[1];
	
	            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
	            if (line instanceof _block2.default) {
	              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
	                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
	                  leaf = _line$descendant2[0];
	
	              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
	            }
	            attributes = _op2.default.attributes.diff(formats, attributes) || {};
	          } else if (_typeof(op.insert) === 'object') {
	            var key = Object.keys(op.insert)[0]; // There should only be one key
	            if (key == null) return index;
	            _this.scroll.insertAt(index, key, op.insert[key]);
	          }
	          scrollLength += length;
	        }
	        Object.keys(attributes).forEach(function (name) {
	          _this.scroll.formatAt(index, length, name, attributes[name]);
	        });
	        return index + length;
	      }, 0);
	      delta.reduce(function (index, op) {
	        if (typeof op.delete === 'number') {
	          _this.scroll.deleteAt(index, op.delete);
	          return index;
	        }
	        return index + (op.retain || op.insert.length || 1);
	      }, 0);
	      this.scroll.batchEnd();
	      return this.update(delta);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length) {
	      this.scroll.deleteAt(index, length);
	      return this.update(new _quillDelta2.default().retain(index).delete(length));
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length) {
	      var _this2 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      this.scroll.update();
	      Object.keys(formats).forEach(function (format) {
	        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
	        var lines = _this2.scroll.lines(index, Math.max(length, 1));
	        var lengthRemaining = length;
	        lines.forEach(function (line) {
	          var lineLength = line.length();
	          if (!(line instanceof _code2.default)) {
	            line.format(format, formats[format]);
	          } else {
	            var codeIndex = index - line.offset(_this2.scroll);
	            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
	            line.formatAt(codeIndex, codeLength, format, formats[format]);
	          }
	          lengthRemaining -= lineLength;
	        });
	      });
	      this.scroll.optimize();
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length) {
	      var _this3 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      Object.keys(formats).forEach(function (format) {
	        _this3.scroll.formatAt(index, length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents(index, length) {
	      return this.delta.slice(index, index + length);
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta() {
	      return this.scroll.lines().reduce(function (delta, line) {
	        return delta.concat(line.delta());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var lines = [],
	          leaves = [];
	      if (length === 0) {
	        this.scroll.path(index).forEach(function (path) {
	          var _path = _slicedToArray(path, 1),
	              blot = _path[0];
	
	          if (blot instanceof _block2.default) {
	            lines.push(blot);
	          } else if (blot instanceof _parchment2.default.Leaf) {
	            leaves.push(blot);
	          }
	        });
	      } else {
	        lines = this.scroll.lines(index, length);
	        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
	      }
	      var formatsArr = [lines, leaves].map(function (blots) {
	        if (blots.length === 0) return {};
	        var formats = (0, _block.bubbleFormats)(blots.shift());
	        while (Object.keys(formats).length > 0) {
	          var blot = blots.shift();
	          if (blot == null) return formats;
	          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
	        }
	        return formats;
	      });
	      return _extend2.default.apply(_extend2.default, formatsArr);
	    }
	  }, {
	    key: 'getText',
	    value: function getText(index, length) {
	      return this.getContents(index, length).filter(function (op) {
	        return typeof op.insert === 'string';
	      }).map(function (op) {
	        return op.insert;
	      }).join('');
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      this.scroll.insertAt(index, embed, value);
	      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text) {
	      var _this4 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      this.scroll.insertAt(index, text);
	      Object.keys(formats).forEach(function (format) {
	        _this4.scroll.formatAt(index, text.length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'isBlank',
	    value: function isBlank() {
	      if (this.scroll.children.length == 0) return true;
	      if (this.scroll.children.length > 1) return false;
	      var block = this.scroll.children.head;
	      if (block.statics.blotName !== _block2.default.blotName) return false;
	      if (block.children.length > 1) return false;
	      return block.children.head instanceof _break2.default;
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length) {
	      var text = this.getText(index, length);
	
	      var _scroll$line3 = this.scroll.line(index + length),
	          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
	          line = _scroll$line4[0],
	          offset = _scroll$line4[1];
	
	      var suffixLength = 0,
	          suffix = new _quillDelta2.default();
	      if (line != null) {
	        if (!(line instanceof _code2.default)) {
	          suffixLength = line.length() - offset;
	        } else {
	          suffixLength = line.newlineIndex(offset) - offset + 1;
	        }
	        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
	      }
	      var contents = this.getContents(index, length + suffixLength);
	      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
	      var delta = new _quillDelta2.default().retain(index).concat(diff);
	      return this.applyDelta(delta);
	    }
	  }, {
	    key: 'update',
	    value: function update(change) {
	      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      var oldDelta = this.delta;
	      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
	        // Optimization for character changes
	        var textBlot = _parchment2.default.find(mutations[0].target);
	        var formats = (0, _block.bubbleFormats)(textBlot);
	        var index = textBlot.offset(this.scroll);
	        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
	        var oldText = new _quillDelta2.default().insert(oldValue);
	        var newText = new _quillDelta2.default().insert(textBlot.value());
	        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
	        change = diffDelta.reduce(function (delta, op) {
	          if (op.insert) {
	            return delta.insert(op.insert, formats);
	          } else {
	            return delta.push(op);
	          }
	        }, new _quillDelta2.default());
	        this.delta = oldDelta.compose(change);
	      } else {
	        this.delta = this.getDelta();
	        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
	          change = oldDelta.diff(this.delta, cursorIndex);
	        }
	      }
	      return change;
	    }
	  }]);
	
	  return Editor;
	}();
	
	function combineFormats(formats, combined) {
	  return Object.keys(combined).reduce(function (merged, name) {
	    if (formats[name] == null) return merged;
	    if (combined[name] === formats[name]) {
	      merged[name] = combined[name];
	    } else if (Array.isArray(combined[name])) {
	      if (combined[name].indexOf(formats[name]) < 0) {
	        merged[name] = combined[name].concat([formats[name]]);
	      }
	    } else {
	      merged[name] = [combined[name], formats[name]];
	    }
	    return merged;
	  }, {});
	}
	
	function normalizeDelta(delta) {
	  return delta.reduce(function (delta, op) {
	    if (op.insert === 1) {
	      var attributes = (0, _clone2.default)(op.attributes);
	      delete attributes['image'];
	      return delta.insert({ image: op.attributes.image }, attributes);
	    }
	    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
	      op = (0, _clone2.default)(op);
	      if (op.attributes.list) {
	        op.attributes.list = 'ordered';
	      } else {
	        op.attributes.list = 'bullet';
	        delete op.attributes.bullet;
	      }
	    }
	    if (typeof op.insert === 'string') {
	      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      return delta.insert(text, op.attributes);
	    }
	    return delta.push(op);
	  }, new _quillDelta2.default());
	}
	
	exports.default = Editor;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Range = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill:selection');
	
	var Range = function Range(index) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  _classCallCheck(this, Range);
	
	  this.index = index;
	  this.length = length;
	};
	
	var Selection = function () {
	  function Selection(scroll, emitter) {
	    var _this = this;
	
	    _classCallCheck(this, Selection);
	
	    this.emitter = emitter;
	    this.scroll = scroll;
	    this.composing = false;
	    this.mouseDown = false;
	    this.root = this.scroll.domNode;
	    this.cursor = _parchment2.default.create('cursor', this);
	    // savedRange is last non-null range
	    this.lastRange = this.savedRange = new Range(0, 0);
	    this.handleComposition();
	    this.handleDragging();
	    this.emitter.listenDOM('selectionchange', document, function () {
	      if (!_this.mouseDown) {
	        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
	      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
	        _this.update(_emitter4.default.sources.SILENT);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
	      if (!_this.hasFocus()) return;
	      var native = _this.getNativeRange();
	      if (native == null) return;
	      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
	      // TODO unclear if this has negative side effects
	      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
	        try {
	          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
	        } catch (ignored) {}
	      });
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
	      if (context.range) {
	        var _context$range = context.range,
	            startNode = _context$range.startNode,
	            startOffset = _context$range.startOffset,
	            endNode = _context$range.endNode,
	            endOffset = _context$range.endOffset;
	
	        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
	      }
	    });
	    this.update(_emitter4.default.sources.SILENT);
	  }
	
	  _createClass(Selection, [{
	    key: 'handleComposition',
	    value: function handleComposition() {
	      var _this2 = this;
	
	      this.root.addEventListener('compositionstart', function () {
	        _this2.composing = true;
	      });
	      this.root.addEventListener('compositionend', function () {
	        _this2.composing = false;
	        if (_this2.cursor.parent) {
	          var range = _this2.cursor.restore();
	          if (!range) return;
	          setTimeout(function () {
	            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
	          }, 1);
	        }
	      });
	    }
	  }, {
	    key: 'handleDragging',
	    value: function handleDragging() {
	      var _this3 = this;
	
	      this.emitter.listenDOM('mousedown', document.body, function () {
	        _this3.mouseDown = true;
	      });
	      this.emitter.listenDOM('mouseup', document.body, function () {
	        _this3.mouseDown = false;
	        _this3.update(_emitter4.default.sources.USER);
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.hasFocus()) return;
	      this.root.focus();
	      this.setRange(this.savedRange);
	    }
	  }, {
	    key: 'format',
	    value: function format(_format, value) {
	      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
	      this.scroll.update();
	      var nativeRange = this.getNativeRange();
	      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
	      if (nativeRange.start.node !== this.cursor.textNode) {
	        var blot = _parchment2.default.find(nativeRange.start.node, false);
	        if (blot == null) return;
	        // TODO Give blot ability to not split
	        if (blot instanceof _parchment2.default.Leaf) {
	          var after = blot.split(nativeRange.start.offset);
	          blot.parent.insertBefore(this.cursor, after);
	        } else {
	          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
	        }
	        this.cursor.attach();
	      }
	      this.cursor.format(_format, value);
	      this.scroll.optimize();
	      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
	      this.update();
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var scrollLength = this.scroll.length();
	      index = Math.min(index, scrollLength - 1);
	      length = Math.min(index + length, scrollLength - 1) - index;
	      var node = void 0,
	          _scroll$leaf = this.scroll.leaf(index),
	          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
	          leaf = _scroll$leaf2[0],
	          offset = _scroll$leaf2[1];
	      if (leaf == null) return null;
	
	      var _leaf$position = leaf.position(offset, true);
	
	      var _leaf$position2 = _slicedToArray(_leaf$position, 2);
	
	      node = _leaf$position2[0];
	      offset = _leaf$position2[1];
	
	      var range = document.createRange();
	      if (length > 0) {
	        range.setStart(node, offset);
	
	        var _scroll$leaf3 = this.scroll.leaf(index + length);
	
	        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
	
	        leaf = _scroll$leaf4[0];
	        offset = _scroll$leaf4[1];
	
	        if (leaf == null) return null;
	
	        var _leaf$position3 = leaf.position(offset, true);
	
	        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
	
	        node = _leaf$position4[0];
	        offset = _leaf$position4[1];
	
	        range.setEnd(node, offset);
	        return range.getBoundingClientRect();
	      } else {
	        var side = 'left';
	        var rect = void 0;
	        if (node instanceof Text) {
	          if (offset < node.data.length) {
	            range.setStart(node, offset);
	            range.setEnd(node, offset + 1);
	          } else {
	            range.setStart(node, offset - 1);
	            range.setEnd(node, offset);
	            side = 'right';
	          }
	          rect = range.getBoundingClientRect();
	        } else {
	          rect = leaf.domNode.getBoundingClientRect();
	          if (offset > 0) side = 'right';
	        }
	        return {
	          bottom: rect.top + rect.height,
	          height: rect.height,
	          left: rect[side],
	          right: rect[side],
	          top: rect.top,
	          width: 0
	        };
	      }
	    }
	  }, {
	    key: 'getNativeRange',
	    value: function getNativeRange() {
	      var selection = document.getSelection();
	      if (selection == null || selection.rangeCount <= 0) return null;
	      var nativeRange = selection.getRangeAt(0);
	      if (nativeRange == null) return null;
	      var range = this.normalizeNative(nativeRange);
	      debug.info('getNativeRange', range);
	      return range;
	    }
	  }, {
	    key: 'getRange',
	    value: function getRange() {
	      var normalized = this.getNativeRange();
	      if (normalized == null) return [null, null];
	      var range = this.normalizedToRange(normalized);
	      return [range, normalized];
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return document.activeElement === this.root;
	    }
	  }, {
	    key: 'normalizedToRange',
	    value: function normalizedToRange(range) {
	      var _this4 = this;
	
	      var positions = [[range.start.node, range.start.offset]];
	      if (!range.native.collapsed) {
	        positions.push([range.end.node, range.end.offset]);
	      }
	      var indexes = positions.map(function (position) {
	        var _position = _slicedToArray(position, 2),
	            node = _position[0],
	            offset = _position[1];
	
	        var blot = _parchment2.default.find(node, true);
	        var index = blot.offset(_this4.scroll);
	        if (offset === 0) {
	          return index;
	        } else if (blot instanceof _parchment2.default.Container) {
	          return index + blot.length();
	        } else {
	          return index + blot.index(node, offset);
	        }
	      });
	      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
	      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
	      return new Range(start, end - start);
	    }
	  }, {
	    key: 'normalizeNative',
	    value: function normalizeNative(nativeRange) {
	      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
	        return null;
	      }
	      var range = {
	        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
	        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
	        native: nativeRange
	      };
	      [range.start, range.end].forEach(function (position) {
	        var node = position.node,
	            offset = position.offset;
	        while (!(node instanceof Text) && node.childNodes.length > 0) {
	          if (node.childNodes.length > offset) {
	            node = node.childNodes[offset];
	            offset = 0;
	          } else if (node.childNodes.length === offset) {
	            node = node.lastChild;
	            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
	          } else {
	            break;
	          }
	        }
	        position.node = node, position.offset = offset;
	      });
	      return range;
	    }
	  }, {
	    key: 'rangeToNative',
	    value: function rangeToNative(range) {
	      var _this5 = this;
	
	      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
	      var args = [];
	      var scrollLength = this.scroll.length();
	      indexes.forEach(function (index, i) {
	        index = Math.min(scrollLength - 1, index);
	        var node = void 0,
	            _scroll$leaf5 = _this5.scroll.leaf(index),
	            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
	            leaf = _scroll$leaf6[0],
	            offset = _scroll$leaf6[1];
	        var _leaf$position5 = leaf.position(offset, i !== 0);
	
	        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
	
	        node = _leaf$position6[0];
	        offset = _leaf$position6[1];
	
	        args.push(node, offset);
	      });
	      if (args.length < 2) {
	        args = args.concat(args);
	      }
	      return args;
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView(scrollingContainer) {
	      var range = this.lastRange;
	      if (range == null) return;
	      var bounds = this.getBounds(range.index, range.length);
	      if (bounds == null) return;
	      var limit = this.scroll.length() - 1;
	
	      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
	          _scroll$line2 = _slicedToArray(_scroll$line, 1),
	          first = _scroll$line2[0];
	
	      var last = first;
	      if (range.length > 0) {
	        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
	
	        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
	
	        last = _scroll$line4[0];
	      }
	      if (first == null || last == null) return;
	      var scrollBounds = scrollingContainer.getBoundingClientRect();
	      if (bounds.top < scrollBounds.top) {
	        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
	      } else if (bounds.bottom > scrollBounds.bottom) {
	        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
	      }
	    }
	  }, {
	    key: 'setNativeRange',
	    value: function setNativeRange(startNode, startOffset) {
	      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
	      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
	      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
	      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
	        return;
	      }
	      var selection = document.getSelection();
	      if (selection == null) return;
	      if (startNode != null) {
	        if (!this.hasFocus()) this.root.focus();
	        var native = (this.getNativeRange() || {}).native;
	        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
	
	          if (startNode.tagName == "BR") {
	            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
	            startNode = startNode.parentNode;
	          }
	          if (endNode.tagName == "BR") {
	            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
	            endNode = endNode.parentNode;
	          }
	          var range = document.createRange();
	          range.setStart(startNode, startOffset);
	          range.setEnd(endNode, endOffset);
	          selection.removeAllRanges();
	          selection.addRange(range);
	        }
	      } else {
	        selection.removeAllRanges();
	        this.root.blur();
	        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
	      }
	    }
	  }, {
	    key: 'setRange',
	    value: function setRange(range) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      if (typeof force === 'string') {
	        source = force;
	        force = false;
	      }
	      debug.info('setRange', range);
	      if (range != null) {
	        var args = this.rangeToNative(range);
	        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
	      } else {
	        this.setNativeRange(null);
	      }
	      this.update(source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var oldRange = this.lastRange;
	
	      var _getRange = this.getRange(),
	          _getRange2 = _slicedToArray(_getRange, 2),
	          lastRange = _getRange2[0],
	          nativeRange = _getRange2[1];
	
	      this.lastRange = lastRange;
	      if (this.lastRange != null) {
	        this.savedRange = this.lastRange;
	      }
	      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
	        var _emitter;
	
	        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
	          this.cursor.restore();
	        }
	        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
	        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	        if (source !== _emitter4.default.sources.SILENT) {
	          var _emitter2;
	
	          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	        }
	      }
	    }
	  }]);
	
	  return Selection;
	}();
	
	function contains(parent, descendant) {
	  try {
	    // Firefox inserts inaccessible nodes around video elements
	    descendant.parentNode;
	  } catch (e) {
	    return false;
	  }
	  // IE11 has bug with Text nodes
	  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	  if (descendant instanceof Text) {
	    descendant = descendant.parentNode;
	  }
	  return parent.contains(descendant);
	}
	
	exports.Range = Range;
	exports.default = Selection;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Break = function (_Parchment$Embed) {
	  _inherits(Break, _Parchment$Embed);
	
	  function Break() {
	    _classCallCheck(this, Break);
	
	    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
	  }
	
	  _createClass(Break, [{
	    key: 'insertInto',
	    value: function insertInto(parent, ref) {
	      if (parent.children.length === 0) {
	        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
	      } else {
	        this.remove();
	      }
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return 0;
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }], [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  return Break;
	}(_parchment2.default.Embed);
	
	Break.blotName = 'break';
	Break.tagName = 'BR';
	
	exports.default = Break;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var linked_list_1 = __webpack_require__(44);
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var ContainerBlot = /** @class */ (function (_super) {
	    __extends(ContainerBlot, _super);
	    function ContainerBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.build();
	        return _this;
	    }
	    ContainerBlot.prototype.appendChild = function (other) {
	        this.insertBefore(other);
	    };
	    ContainerBlot.prototype.attach = function () {
	        _super.prototype.attach.call(this);
	        this.children.forEach(function (child) {
	            child.attach();
	        });
	    };
	    ContainerBlot.prototype.build = function () {
	        var _this = this;
	        this.children = new linked_list_1.default();
	        // Need to be reversed for if DOM nodes already in order
	        [].slice
	            .call(this.domNode.childNodes)
	            .reverse()
	            .forEach(function (node) {
	            try {
	                var child = makeBlot(node);
	                _this.insertBefore(child, _this.children.head || undefined);
	            }
	            catch (err) {
	                if (err instanceof Registry.ParchmentError)
	                    return;
	                else
	                    throw err;
	            }
	        });
	    };
	    ContainerBlot.prototype.deleteAt = function (index, length) {
	        if (index === 0 && length === this.length()) {
	            return this.remove();
	        }
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.deleteAt(offset, length);
	        });
	    };
	    ContainerBlot.prototype.descendant = function (criteria, index) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if ((criteria.blotName == null && criteria(child)) ||
	            (criteria.blotName != null && child instanceof criteria)) {
	            return [child, offset];
	        }
	        else if (child instanceof ContainerBlot) {
	            return child.descendant(criteria, offset);
	        }
	        else {
	            return [null, -1];
	        }
	    };
	    ContainerBlot.prototype.descendants = function (criteria, index, length) {
	        if (index === void 0) { index = 0; }
	        if (length === void 0) { length = Number.MAX_VALUE; }
	        var descendants = [];
	        var lengthLeft = length;
	        this.children.forEachAt(index, length, function (child, index, length) {
	            if ((criteria.blotName == null && criteria(child)) ||
	                (criteria.blotName != null && child instanceof criteria)) {
	                descendants.push(child);
	            }
	            if (child instanceof ContainerBlot) {
	                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
	            }
	            lengthLeft -= length;
	        });
	        return descendants;
	    };
	    ContainerBlot.prototype.detach = function () {
	        this.children.forEach(function (child) {
	            child.detach();
	        });
	        _super.prototype.detach.call(this);
	    };
	    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.formatAt(offset, length, name, value);
	        });
	    };
	    ContainerBlot.prototype.insertAt = function (index, value, def) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if (child) {
	            child.insertAt(offset, value, def);
	        }
	        else {
	            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	            this.appendChild(blot);
	        }
	    };
	    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
	        if (this.statics.allowedChildren != null &&
	            !this.statics.allowedChildren.some(function (child) {
	                return childBlot instanceof child;
	            })) {
	            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
	        }
	        childBlot.insertInto(this, refBlot);
	    };
	    ContainerBlot.prototype.length = function () {
	        return this.children.reduce(function (memo, child) {
	            return memo + child.length();
	        }, 0);
	    };
	    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
	        this.children.forEach(function (child) {
	            targetParent.insertBefore(child, refNode);
	        });
	    };
	    ContainerBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        if (this.children.length === 0) {
	            if (this.statics.defaultChild != null) {
	                var child = Registry.create(this.statics.defaultChild);
	                this.appendChild(child);
	                child.optimize(context);
	            }
	            else {
	                this.remove();
	            }
	        }
	    };
	    ContainerBlot.prototype.path = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
	        var position = [[this, index]];
	        if (child instanceof ContainerBlot) {
	            return position.concat(child.path(offset, inclusive));
	        }
	        else if (child != null) {
	            position.push([child, offset]);
	        }
	        return position;
	    };
	    ContainerBlot.prototype.removeChild = function (child) {
	        this.children.remove(child);
	    };
	    ContainerBlot.prototype.replace = function (target) {
	        if (target instanceof ContainerBlot) {
	            target.moveChildren(this);
	        }
	        _super.prototype.replace.call(this, target);
	    };
	    ContainerBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = this.clone();
	        this.parent.insertBefore(after, this.next);
	        this.children.forEachAt(index, this.length(), function (child, offset, length) {
	            child = child.split(offset, force);
	            after.appendChild(child);
	        });
	        return after;
	    };
	    ContainerBlot.prototype.unwrap = function () {
	        this.moveChildren(this.parent, this.next);
	        this.remove();
	    };
	    ContainerBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        var addedNodes = [];
	        var removedNodes = [];
	        mutations.forEach(function (mutation) {
	            if (mutation.target === _this.domNode && mutation.type === 'childList') {
	                addedNodes.push.apply(addedNodes, mutation.addedNodes);
	                removedNodes.push.apply(removedNodes, mutation.removedNodes);
	            }
	        });
	        removedNodes.forEach(function (node) {
	            // Check node has actually been removed
	            // One exception is Chrome does not immediately remove IFRAMEs
	            // from DOM but MutationRecord is correct in its reported removal
	            if (node.parentNode != null &&
	                // @ts-ignore
	                node.tagName !== 'IFRAME' &&
	                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	                return;
	            }
	            var blot = Registry.find(node);
	            if (blot == null)
	                return;
	            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
	                blot.detach();
	            }
	        });
	        addedNodes
	            .filter(function (node) {
	            return node.parentNode == _this.domNode;
	        })
	            .sort(function (a, b) {
	            if (a === b)
	                return 0;
	            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
	                return 1;
	            }
	            return -1;
	        })
	            .forEach(function (node) {
	            var refBlot = null;
	            if (node.nextSibling != null) {
	                refBlot = Registry.find(node.nextSibling);
	            }
	            var blot = makeBlot(node);
	            if (blot.next != refBlot || blot.next == null) {
	                if (blot.parent != null) {
	                    blot.parent.removeChild(_this);
	                }
	                _this.insertBefore(blot, refBlot || undefined);
	            }
	        });
	    };
	    return ContainerBlot;
	}(shadow_1.default));
	function makeBlot(node) {
	    var blot = Registry.find(node);
	    if (blot == null) {
	        try {
	            blot = Registry.create(node);
	        }
	        catch (e) {
	            blot = Registry.create(Registry.Scope.INLINE);
	            [].slice.call(node.childNodes).forEach(function (child) {
	                // @ts-ignore
	                blot.domNode.appendChild(child);
	            });
	            if (node.parentNode) {
	                node.parentNode.replaceChild(blot.domNode, node);
	            }
	            blot.attach();
	        }
	    }
	    return blot;
	}
	exports.default = ContainerBlot;
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var store_1 = __webpack_require__(31);
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var FormatBlot = /** @class */ (function (_super) {
	    __extends(FormatBlot, _super);
	    function FormatBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.attributes = new store_1.default(_this.domNode);
	        return _this;
	    }
	    FormatBlot.formats = function (domNode) {
	        if (typeof this.tagName === 'string') {
	            return true;
	        }
	        else if (Array.isArray(this.tagName)) {
	            return domNode.tagName.toLowerCase();
	        }
	        return undefined;
	    };
	    FormatBlot.prototype.format = function (name, value) {
	        var format = Registry.query(name);
	        if (format instanceof attributor_1.default) {
	            this.attributes.attribute(format, value);
	        }
	        else if (value) {
	            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
	                this.replaceWith(name, value);
	            }
	        }
	    };
	    FormatBlot.prototype.formats = function () {
	        var formats = this.attributes.values();
	        var format = this.statics.formats(this.domNode);
	        if (format != null) {
	            formats[this.statics.blotName] = format;
	        }
	        return formats;
	    };
	    FormatBlot.prototype.replaceWith = function (name, value) {
	        var replacement = _super.prototype.replaceWith.call(this, name, value);
	        this.attributes.copy(replacement);
	        return replacement;
	    };
	    FormatBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        _super.prototype.update.call(this, mutations, context);
	        if (mutations.some(function (mutation) {
	            return mutation.target === _this.domNode && mutation.type === 'attributes';
	        })) {
	            this.attributes.build();
	        }
	    };
	    FormatBlot.prototype.wrap = function (name, value) {
	        var wrapper = _super.prototype.wrap.call(this, name, value);
	        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
	            this.attributes.move(wrapper);
	        }
	        return wrapper;
	    };
	    return FormatBlot;
	}(container_1.default));
	exports.default = FormatBlot;
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var LeafBlot = /** @class */ (function (_super) {
	    __extends(LeafBlot, _super);
	    function LeafBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LeafBlot.value = function (domNode) {
	        return true;
	    };
	    LeafBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node ||
	            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	            return Math.min(offset, 1);
	        }
	        return -1;
	    };
	    LeafBlot.prototype.position = function (index, inclusive) {
	        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
	        if (index > 0)
	            offset += 1;
	        return [this.parent.domNode, offset];
	    };
	    LeafBlot.prototype.value = function () {
	        var _a;
	        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
	    };
	    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
	    return LeafBlot;
	}(shadow_1.default));
	exports.default = LeafBlot;
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	
	
	var lib = {
	  attributes: {
	    compose: function (a, b, keepNull) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = extend(true, {}, b);
	      if (!keepNull) {
	        attributes = Object.keys(attributes).reduce(function (copy, key) {
	          if (attributes[key] != null) {
	            copy[key] = attributes[key];
	          }
	          return copy;
	        }, {});
	      }
	      for (var key in a) {
	        if (a[key] !== undefined && b[key] === undefined) {
	          attributes[key] = a[key];
	        }
	      }
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    diff: function(a, b) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
	        if (!equal(a[key], b[key])) {
	          attributes[key] = b[key] === undefined ? null : b[key];
	        }
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    transform: function (a, b, priority) {
	      if (typeof a !== 'object') return b;
	      if (typeof b !== 'object') return undefined;
	      if (!priority) return b;  // b simply overwrites us without priority
	      var attributes = Object.keys(b).reduce(function (attributes, key) {
	        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	  },
	
	  iterator: function (ops) {
	    return new Iterator(ops);
	  },
	
	  length: function (op) {
	    if (typeof op['delete'] === 'number') {
	      return op['delete'];
	    } else if (typeof op.retain === 'number') {
	      return op.retain;
	    } else {
	      return typeof op.insert === 'string' ? op.insert.length : 1;
	    }
	  }
	};
	
	
	function Iterator(ops) {
	  this.ops = ops;
	  this.index = 0;
	  this.offset = 0;
	};
	
	Iterator.prototype.hasNext = function () {
	  return this.peekLength() < Infinity;
	};
	
	Iterator.prototype.next = function (length) {
	  if (!length) length = Infinity;
	  var nextOp = this.ops[this.index];
	  if (nextOp) {
	    var offset = this.offset;
	    var opLength = lib.length(nextOp)
	    if (length >= opLength - offset) {
	      length = opLength - offset;
	      this.index += 1;
	      this.offset = 0;
	    } else {
	      this.offset += length;
	    }
	    if (typeof nextOp['delete'] === 'number') {
	      return { 'delete': length };
	    } else {
	      var retOp = {};
	      if (nextOp.attributes) {
	        retOp.attributes = nextOp.attributes;
	      }
	      if (typeof nextOp.retain === 'number') {
	        retOp.retain = length;
	      } else if (typeof nextOp.insert === 'string') {
	        retOp.insert = nextOp.insert.substr(offset, length);
	      } else {
	        // offset should === 0, length should === 1
	        retOp.insert = nextOp.insert;
	      }
	      return retOp;
	    }
	  } else {
	    return { retain: Infinity };
	  }
	};
	
	Iterator.prototype.peek = function () {
	  return this.ops[this.index];
	};
	
	Iterator.prototype.peekLength = function () {
	  if (this.ops[this.index]) {
	    // Should never return 0 if our index is being managed correctly
	    return lib.length(this.ops[this.index]) - this.offset;
	  } else {
	    return Infinity;
	  }
	};
	
	Iterator.prototype.peekType = function () {
	  if (this.ops[this.index]) {
	    if (typeof this.ops[this.index]['delete'] === 'number') {
	      return 'delete';
	    } else if (typeof this.ops[this.index].retain === 'number') {
	      return 'retain';
	    } else {
	      return 'insert';
	    }
	  }
	  return 'retain';
	};
	
	Iterator.prototype.rest = function () {
	  if (!this.hasNext()) {
	    return [];
	  } else if (this.offset === 0) {
	    return this.ops.slice(this.index);
	  } else {
	    var offset = this.offset;
	    var index = this.index;
	    var next = this.next();
	    var rest = this.ops.slice(this.index);
	    this.offset = offset;
	    this.index = index;
	    return [next].concat(rest);
	  }
	};
	
	
	module.exports = lib;
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	var clone = (function() {
	'use strict';
	
	function _instanceof(obj, type) {
	  return type != null && obj instanceof type;
	}
	
	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}
	
	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}
	
	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
	 *    should be cloned as well. Non-enumerable properties on the prototype
	 *    chain will be ignored. (optional - false by default)
	*/
	function clone(parent, circular, depth, prototype, includeNonEnumerable) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    includeNonEnumerable = circular.includeNonEnumerable;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth === 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      child = new nativeMap();
	    } else if (_instanceof(parent, nativeSet)) {
	      child = new nativeSet();
	    } else if (_instanceof(parent, nativePromise)) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else if (_instanceof(parent, Error)) {
	      child = Object.create(parent);
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      parent.forEach(function(value, key) {
	        var keyChild = _clone(key, depth - 1);
	        var valueChild = _clone(value, depth - 1);
	        child.set(keyChild, valueChild);
	      });
	    }
	    if (_instanceof(parent, nativeSet)) {
	      parent.forEach(function(value) {
	        var entryChild = _clone(value, depth - 1);
	        child.add(entryChild);
	      });
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
	        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
	          continue;
	        }
	        child[symbol] = _clone(parent[symbol], depth - 1);
	        if (!descriptor.enumerable) {
	          Object.defineProperty(child, symbol, {
	            enumerable: false
	          });
	        }
	      }
	    }
	
	    if (includeNonEnumerable) {
	      var allPropertyNames = Object.getOwnPropertyNames(parent);
	      for (var i = 0; i < allPropertyNames.length; i++) {
	        var propertyName = allPropertyNames[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
	        if (descriptor && descriptor.enumerable) {
	          continue;
	        }
	        child[propertyName] = _clone(parent[propertyName], depth - 1);
	        Object.defineProperty(child, propertyName, {
	          enumerable: false
	        });
	      }
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isLine(blot) {
	  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
	}
	
	var Scroll = function (_Parchment$Scroll) {
	  _inherits(Scroll, _Parchment$Scroll);
	
	  function Scroll(domNode, config) {
	    _classCallCheck(this, Scroll);
	
	    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
	
	    _this.emitter = config.emitter;
	    if (Array.isArray(config.whitelist)) {
	      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
	        whitelist[format] = true;
	        return whitelist;
	      }, {});
	    }
	    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
	    _this.domNode.addEventListener('DOMNodeInserted', function () {});
	    _this.optimize();
	    _this.enable();
	    return _this;
	  }
	
	  _createClass(Scroll, [{
	    key: 'batchStart',
	    value: function batchStart() {
	      this.batch = true;
	    }
	  }, {
	    key: 'batchEnd',
	    value: function batchEnd() {
	      this.batch = false;
	      this.optimize();
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      var _line = this.line(index),
	          _line2 = _slicedToArray(_line, 2),
	          first = _line2[0],
	          offset = _line2[1];
	
	      var _line3 = this.line(index + length),
	          _line4 = _slicedToArray(_line3, 1),
	          last = _line4[0];
	
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
	      if (last != null && first !== last && offset > 0) {
	        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
	          this.optimize();
	          return;
	        }
	        if (first instanceof _code2.default) {
	          var newlineIndex = first.newlineIndex(first.length(), true);
	          if (newlineIndex > -1) {
	            first = first.split(newlineIndex + 1);
	            if (first === last) {
	              this.optimize();
	              return;
	            }
	          }
	        } else if (last instanceof _code2.default) {
	          var _newlineIndex = last.newlineIndex(0);
	          if (_newlineIndex > -1) {
	            last.split(_newlineIndex + 1);
	          }
	        }
	        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
	        first.moveChildren(last, ref);
	        first.remove();
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.domNode.setAttribute('contenteditable', enabled);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, format, value) {
	      if (this.whitelist != null && !this.whitelist[format]) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
	      this.optimize();
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
	      if (index >= this.length()) {
	        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
	          var blot = _parchment2.default.create(this.statics.defaultChild);
	          this.appendChild(blot);
	          if (def == null && value.endsWith('\n')) {
	            value = value.slice(0, -1);
	          }
	          blot.insertAt(0, value, def);
	        } else {
	          var embed = _parchment2.default.create(value, def);
	          this.appendChild(embed);
	        }
	      } else {
	        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
	        var wrapper = _parchment2.default.create(this.statics.defaultChild);
	        wrapper.appendChild(blot);
	        blot = wrapper;
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
	    }
	  }, {
	    key: 'leaf',
	    value: function leaf(index) {
	      return this.path(index).pop() || [null, -1];
	    }
	  }, {
	    key: 'line',
	    value: function line(index) {
	      if (index === this.length()) {
	        return this.line(index - 1);
	      }
	      return this.descendant(isLine, index);
	    }
	  }, {
	    key: 'lines',
	    value: function lines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      var getLines = function getLines(blot, index, length) {
	        var lines = [],
	            lengthLeft = length;
	        blot.children.forEachAt(index, length, function (child, index, length) {
	          if (isLine(child)) {
	            lines.push(child);
	          } else if (child instanceof _parchment2.default.Container) {
	            lines = lines.concat(getLines(child, index, lengthLeft));
	          }
	          lengthLeft -= length;
	        });
	        return lines;
	      };
	      return getLines(this, index, length);
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.batch === true) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
	      }
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations) {
	      if (this.batch === true) return;
	      var source = _emitter2.default.sources.USER;
	      if (typeof mutations === 'string') {
	        source = mutations;
	      }
	      if (!Array.isArray(mutations)) {
	        mutations = this.observer.takeRecords();
	      }
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
	      }
	    }
	  }]);
	
	  return Scroll;
	}(_parchment2.default.Scroll);
	
	Scroll.blotName = 'scroll';
	Scroll.className = 'ql-editor';
	Scroll.tagName = 'DIV';
	Scroll.defaultChild = 'block';
	Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
	
	exports.default = Scroll;
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHORTKEY = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:keyboard');
	
	var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
	
	var Keyboard = function (_Module) {
	  _inherits(Keyboard, _Module);
	
	  _createClass(Keyboard, null, [{
	    key: 'match',
	    value: function match(evt, binding) {
	      binding = normalize(binding);
	      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
	        return !!binding[key] !== evt[key] && binding[key] !== null;
	      })) {
	        return false;
	      }
	      return binding.key === (evt.which || evt.keyCode);
	    }
	  }]);
	
	  function Keyboard(quill, options) {
	    _classCallCheck(this, Keyboard);
	
	    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
	
	    _this.bindings = {};
	    Object.keys(_this.options.bindings).forEach(function (name) {
	      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
	        return;
	      }
	      if (_this.options.bindings[name]) {
	        _this.addBinding(_this.options.bindings[name]);
	      }
	    });
	    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
	    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
	    if (/Firefox/i.test(navigator.userAgent)) {
	      // Need to handle delete and backspace for Firefox in the general case #1171
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
	    } else {
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
	    }
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
	    _this.listen();
	    return _this;
	  }
	
	  _createClass(Keyboard, [{
	    key: 'addBinding',
	    value: function addBinding(key) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var binding = normalize(key);
	      if (binding == null || binding.key == null) {
	        return debug.warn('Attempted to add invalid keyboard binding', binding);
	      }
	      if (typeof context === 'function') {
	        context = { handler: context };
	      }
	      if (typeof handler === 'function') {
	        handler = { handler: handler };
	      }
	      binding = (0, _extend2.default)(binding, context, handler);
	      this.bindings[binding.key] = this.bindings[binding.key] || [];
	      this.bindings[binding.key].push(binding);
	    }
	  }, {
	    key: 'listen',
	    value: function listen() {
	      var _this2 = this;
	
	      this.quill.root.addEventListener('keydown', function (evt) {
	        if (evt.defaultPrevented) return;
	        var which = evt.which || evt.keyCode;
	        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
	          return Keyboard.match(evt, binding);
	        });
	        if (bindings.length === 0) return;
	        var range = _this2.quill.getSelection();
	        if (range == null || !_this2.quill.hasFocus()) return;
	
	        var _quill$getLine = _this2.quill.getLine(range.index),
	            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
	            line = _quill$getLine2[0],
	            offset = _quill$getLine2[1];
	
	        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
	            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
	            leafStart = _quill$getLeaf2[0],
	            offsetStart = _quill$getLeaf2[1];
	
	        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
	            _ref2 = _slicedToArray(_ref, 2),
	            leafEnd = _ref2[0],
	            offsetEnd = _ref2[1];
	
	        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
	        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
	        var curContext = {
	          collapsed: range.length === 0,
	          empty: range.length === 0 && line.length() <= 1,
	          format: _this2.quill.getFormat(range),
	          offset: offset,
	          prefix: prefixText,
	          suffix: suffixText
	        };
	        var prevented = bindings.some(function (binding) {
	          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
	          if (binding.empty != null && binding.empty !== curContext.empty) return false;
	          if (binding.offset != null && binding.offset !== curContext.offset) return false;
	          if (Array.isArray(binding.format)) {
	            // any format is present
	            if (binding.format.every(function (name) {
	              return curContext.format[name] == null;
	            })) {
	              return false;
	            }
	          } else if (_typeof(binding.format) === 'object') {
	            // all formats must match
	            if (!Object.keys(binding.format).every(function (name) {
	              if (binding.format[name] === true) return curContext.format[name] != null;
	              if (binding.format[name] === false) return curContext.format[name] == null;
	              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
	            })) {
	              return false;
	            }
	          }
	          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
	          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
	          return binding.handler.call(_this2, range, curContext) !== true;
	        });
	        if (prevented) {
	          evt.preventDefault();
	        }
	      });
	    }
	  }]);
	
	  return Keyboard;
	}(_module2.default);
	
	Keyboard.keys = {
	  BACKSPACE: 8,
	  TAB: 9,
	  ENTER: 13,
	  ESCAPE: 27,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46
	};
	
	Keyboard.DEFAULTS = {
	  bindings: {
	    'bold': makeFormatHandler('bold'),
	    'italic': makeFormatHandler('italic'),
	    'underline': makeFormatHandler('underline'),
	    'indent': {
	      // highlight tab or tab at beginning of list, indent or blockquote
	      key: Keyboard.keys.TAB,
	      format: ['blockquote', 'indent', 'list'],
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '+1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      format: ['blockquote', 'indent', 'list'],
	      // highlight tab or tab at beginning of list, indent or blockquote
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '-1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent backspace': {
	      key: Keyboard.keys.BACKSPACE,
	      collapsed: true,
	      shiftKey: null,
	      metaKey: null,
	      ctrlKey: null,
	      altKey: null,
	      format: ['indent', 'list'],
	      offset: 0,
	      handler: function handler(range, context) {
	        if (context.format.indent != null) {
	          this.quill.format('indent', '-1', _quill2.default.sources.USER);
	        } else if (context.format.list != null) {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'indent code-block': makeCodeBlockHandler(true),
	    'outdent code-block': makeCodeBlockHandler(false),
	    'remove tab': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      collapsed: true,
	      prefix: /\t$/,
	      handler: function handler(range) {
	        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
	      }
	    },
	    'tab': {
	      key: Keyboard.keys.TAB,
	      handler: function handler(range) {
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	      }
	    },
	    'list empty enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['list'],
	      empty: true,
	      handler: function handler(range, context) {
	        this.quill.format('list', false, _quill2.default.sources.USER);
	        if (context.format.indent) {
	          this.quill.format('indent', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'checklist enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: { list: 'checked' },
	      handler: function handler(range) {
	        var _quill$getLine3 = this.quill.getLine(range.index),
	            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
	            line = _quill$getLine4[0],
	            offset = _quill$getLine4[1];
	
	        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'header enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['header'],
	      suffix: /^$/,
	      handler: function handler(range, context) {
	        var _quill$getLine5 = this.quill.getLine(range.index),
	            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
	            line = _quill$getLine6[0],
	            offset = _quill$getLine6[1];
	
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'list autofill': {
	      key: ' ',
	      collapsed: true,
	      format: { list: false },
	      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
	      handler: function handler(range, context) {
	        var length = context.prefix.length;
	
	        var _quill$getLine7 = this.quill.getLine(range.index),
	            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
	            line = _quill$getLine8[0],
	            offset = _quill$getLine8[1];
	
	        if (offset > length) return true;
	        var value = void 0;
	        switch (context.prefix.trim()) {
	          case '[]':case '[ ]':
	            value = 'unchecked';
	            break;
	          case '[x]':
	            value = 'checked';
	            break;
	          case '-':case '*':
	            value = 'bullet';
	            break;
	          default:
	            value = 'ordered';
	        }
	        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
	      }
	    },
	    'code exit': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['code-block'],
	      prefix: /\n\n$/,
	      suffix: /^\s+$/,
	      handler: function handler(range) {
	        var _quill$getLine9 = this.quill.getLine(range.index),
	            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
	            line = _quill$getLine10[0],
	            offset = _quill$getLine10[1];
	
	        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	      }
	    },
	    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
	    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
	    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
	    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
	  }
	};
	
	function makeEmbedArrowHandler(key, shiftKey) {
	  var _ref3;
	
	  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
	  return _ref3 = {
	    key: key,
	    shiftKey: shiftKey,
	    altKey: null
	  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
	    var index = range.index;
	    if (key === Keyboard.keys.RIGHT) {
	      index += range.length + 1;
	    }
	
	    var _quill$getLeaf3 = this.quill.getLeaf(index),
	        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
	        leaf = _quill$getLeaf4[0];
	
	    if (!(leaf instanceof _parchment2.default.Embed)) return true;
	    if (key === Keyboard.keys.LEFT) {
	      if (shiftKey) {
	        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
	      }
	    } else {
	      if (shiftKey) {
	        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
	      }
	    }
	    return false;
	  }), _ref3;
	}
	
	function handleBackspace(range, context) {
	  if (range.index === 0 || this.quill.getLength() <= 1) return;
	
	  var _quill$getLine11 = this.quill.getLine(range.index),
	      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
	      line = _quill$getLine12[0];
	
	  var formats = {};
	  if (context.offset === 0) {
	    var _quill$getLine13 = this.quill.getLine(range.index - 1),
	        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
	        prev = _quill$getLine14[0];
	
	    if (prev != null && prev.length() > 1) {
	      var curFormats = line.formats();
	      var prevFormats = this.quill.getFormat(range.index - 1, 1);
	      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
	    }
	  }
	  // Check for astral symbols
	  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
	  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
	  }
	  this.quill.focus();
	}
	
	function handleDelete(range, context) {
	  // Check for astral symbols
	  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
	  if (range.index >= this.quill.getLength() - length) return;
	  var formats = {},
	      nextLength = 0;
	
	  var _quill$getLine15 = this.quill.getLine(range.index),
	      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
	      line = _quill$getLine16[0];
	
	  if (context.offset >= line.length() - 1) {
	    var _quill$getLine17 = this.quill.getLine(range.index + 1),
	        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
	        next = _quill$getLine18[0];
	
	    if (next) {
	      var curFormats = line.formats();
	      var nextFormats = this.quill.getFormat(range.index, 1);
	      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
	      nextLength = next.length();
	    }
	  }
	  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
	  }
	}
	
	function handleDeleteRange(range) {
	  var lines = this.quill.getLines(range);
	  var formats = {};
	  if (lines.length > 1) {
	    var firstFormats = lines[0].formats();
	    var lastFormats = lines[lines.length - 1].formats();
	    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
	  }
	  this.quill.deleteText(range, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
	  }
	  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
	  this.quill.focus();
	}
	
	function handleEnter(range, context) {
	  var _this3 = this;
	
	  if (range.length > 0) {
	    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
	  }
	  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
	    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
	      lineFormats[format] = context.format[format];
	    }
	    return lineFormats;
	  }, {});
	  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
	  // Earlier scroll.deleteAt might have messed up our selection,
	  // so insertText's built in selection preservation is not reliable
	  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	  this.quill.focus();
	  Object.keys(context.format).forEach(function (name) {
	    if (lineFormats[name] != null) return;
	    if (Array.isArray(context.format[name])) return;
	    if (name === 'link') return;
	    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
	  });
	}
	
	function makeCodeBlockHandler(indent) {
	  return {
	    key: Keyboard.keys.TAB,
	    shiftKey: !indent,
	    format: { 'code-block': true },
	    handler: function handler(range) {
	      var CodeBlock = _parchment2.default.query('code-block');
	      var index = range.index,
	          length = range.length;
	
	      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
	          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	          block = _quill$scroll$descend2[0],
	          offset = _quill$scroll$descend2[1];
	
	      if (block == null) return;
	      var scrollIndex = this.quill.getIndex(block);
	      var start = block.newlineIndex(offset, true) + 1;
	      var end = block.newlineIndex(scrollIndex + offset + length);
	      var lines = block.domNode.textContent.slice(start, end).split('\n');
	      offset = 0;
	      lines.forEach(function (line, i) {
	        if (indent) {
	          block.insertAt(start + offset, CodeBlock.TAB);
	          offset += CodeBlock.TAB.length;
	          if (i === 0) {
	            index += CodeBlock.TAB.length;
	          } else {
	            length += CodeBlock.TAB.length;
	          }
	        } else if (line.startsWith(CodeBlock.TAB)) {
	          block.deleteAt(start + offset, CodeBlock.TAB.length);
	          offset -= CodeBlock.TAB.length;
	          if (i === 0) {
	            index -= CodeBlock.TAB.length;
	          } else {
	            length -= CodeBlock.TAB.length;
	          }
	        }
	        offset += line.length + 1;
	      });
	      this.quill.update(_quill2.default.sources.USER);
	      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
	    }
	  };
	}
	
	function makeFormatHandler(format) {
	  return {
	    key: format[0].toUpperCase(),
	    shortKey: true,
	    handler: function handler(range, context) {
	      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
	    }
	  };
	}
	
	function normalize(binding) {
	  if (typeof binding === 'string' || typeof binding === 'number') {
	    return normalize({ key: binding });
	  }
	  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
	    binding = (0, _clone2.default)(binding, false);
	  }
	  if (typeof binding.key === 'string') {
	    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
	      binding.key = Keyboard.keys[binding.key.toUpperCase()];
	    } else if (binding.key.length === 1) {
	      binding.key = binding.key.toUpperCase().charCodeAt(0);
	    } else {
	      return null;
	    }
	  }
	  if (binding.shortKey) {
	    binding[SHORTKEY] = binding.shortKey;
	    delete binding.shortKey;
	  }
	  return binding;
	}
	
	exports.default = Keyboard;
	exports.SHORTKEY = SHORTKEY;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cursor = function (_Parchment$Embed) {
	  _inherits(Cursor, _Parchment$Embed);
	
	  _createClass(Cursor, null, [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  function Cursor(domNode, selection) {
	    _classCallCheck(this, Cursor);
	
	    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
	
	    _this.selection = selection;
	    _this.textNode = document.createTextNode(Cursor.CONTENTS);
	    _this.domNode.appendChild(_this.textNode);
	    _this._length = 0;
	    return _this;
	  }
	
	  _createClass(Cursor, [{
	    key: 'detach',
	    value: function detach() {
	      // super.detach() will also clear domNode.__blot
	      if (this.parent != null) this.parent.removeChild(this);
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (this._length !== 0) {
	        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
	      }
	      var target = this,
	          index = 0;
	      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
	        index += target.offset(target.parent);
	        target = target.parent;
	      }
	      if (target != null) {
	        this._length = Cursor.CONTENTS.length;
	        target.optimize();
	        target.formatAt(index, Cursor.CONTENTS.length, name, value);
	        this._length = 0;
	      }
	    }
	  }, {
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.textNode) return 0;
	      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return this._length;
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      return [this.textNode, this.textNode.data.length];
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
	      this.parent = null;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      if (this.selection.composing || this.parent == null) return;
	      var textNode = this.textNode;
	      var range = this.selection.getNativeRange();
	      var restoreText = void 0,
	          start = void 0,
	          end = void 0;
	      if (range != null && range.start.node === textNode && range.end.node === textNode) {
	        var _ref = [textNode, range.start.offset, range.end.offset];
	        restoreText = _ref[0];
	        start = _ref[1];
	        end = _ref[2];
	      }
	      // Link format will insert text outside of anchor tag
	      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
	        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
	      }
	      if (this.textNode.data !== Cursor.CONTENTS) {
	        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
	        if (this.next instanceof _text2.default) {
	          restoreText = this.next.domNode;
	          this.next.insertAt(0, text);
	          this.textNode.data = Cursor.CONTENTS;
	        } else {
	          this.textNode.data = text;
	          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
	          this.textNode = document.createTextNode(Cursor.CONTENTS);
	          this.domNode.appendChild(this.textNode);
	        }
	      }
	      this.remove();
	      if (start != null) {
	        var _map = [start, end].map(function (offset) {
	          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
	        });
	
	        var _map2 = _slicedToArray(_map, 2);
	
	        start = _map2[0];
	        end = _map2[1];
	
	        return {
	          startNode: restoreText,
	          startOffset: start,
	          endNode: restoreText,
	          endOffset: end
	        };
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      if (mutations.some(function (mutation) {
	        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
	      })) {
	        var range = this.restore();
	        if (range) context.range = range;
	      }
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }]);
	
	  return Cursor;
	}(_parchment2.default.Embed);
	
	Cursor.blotName = 'cursor';
	Cursor.className = 'ql-cursor';
	Cursor.tagName = 'span';
	Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
	
	
	exports.default = Cursor;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Parchment$Container) {
	  _inherits(Container, _Parchment$Container);
	
	  function Container() {
	    _classCallCheck(this, Container);
	
	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }
	
	  return Container;
	}(_parchment2.default.Container);
	
	Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];
	
	exports.default = Container;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorAttributor = function (_Parchment$Attributor) {
	  _inherits(ColorAttributor, _Parchment$Attributor);
	
	  function ColorAttributor() {
	    _classCallCheck(this, ColorAttributor);
	
	    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
	  }
	
	  _createClass(ColorAttributor, [{
	    key: 'value',
	    value: function value(domNode) {
	      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
	      if (!value.startsWith('rgb(')) return value;
	      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
	      return '#' + value.split(',').map(function (component) {
	        return ('00' + parseInt(component).toString(16)).slice(-2);
	      }).join('');
	    }
	  }]);
	
	  return ColorAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var ColorStyle = new ColorAttributor('color', 'color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.ColorAttributor = ColorAttributor;
	exports.ColorClass = ColorClass;
	exports.ColorStyle = ColorStyle;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sanitize = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_Inline) {
	  _inherits(Link, _Inline);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }
	
	  _createClass(Link, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
	      value = this.constructor.sanitize(value);
	      this.domNode.setAttribute('href', value);
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
	      value = this.sanitize(value);
	      node.setAttribute('href', value);
	      node.setAttribute('rel', 'noopener noreferrer');
	      node.setAttribute('target', '_blank');
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.getAttribute('href');
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
	    }
	  }]);
	
	  return Link;
	}(_inline2.default);
	
	Link.blotName = 'link';
	Link.tagName = 'A';
	Link.SANITIZED_URL = 'about:blank';
	Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
	
	function _sanitize(url, protocols) {
	  var anchor = document.createElement('a');
	  anchor.href = url;
	  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
	  return protocols.indexOf(protocol) > -1;
	}
	
	exports.default = Link;
	exports.sanitize = _sanitize;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _dropdown = __webpack_require__(107);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var optionsCounter = 0;
	
	function toggleAriaAttribute(element, attribute) {
	  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
	}
	
	var Picker = function () {
	  function Picker(select) {
	    var _this = this;
	
	    _classCallCheck(this, Picker);
	
	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    this.select.style.display = 'none';
	    this.select.parentNode.insertBefore(this.container, this.select);
	
	    this.label.addEventListener('mousedown', function () {
	      _this.togglePicker();
	    });
	    this.label.addEventListener('keydown', function (event) {
	      switch (event.keyCode) {
	        // Allows the "Enter" key to open the picker
	        case _keyboard2.default.keys.ENTER:
	          _this.togglePicker();
	          break;
	
	        // Allows the "Escape" key to close the picker
	        case _keyboard2.default.keys.ESCAPE:
	          _this.escape();
	          event.preventDefault();
	          break;
	        default:
	      }
	    });
	    this.select.addEventListener('change', this.update.bind(this));
	  }
	
	  _createClass(Picker, [{
	    key: 'togglePicker',
	    value: function togglePicker() {
	      this.container.classList.toggle('ql-expanded');
	      // Toggle aria-expanded and aria-hidden to make the picker accessible
	      toggleAriaAttribute(this.label, 'aria-expanded');
	      toggleAriaAttribute(this.options, 'aria-hidden');
	    }
	  }, {
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var _this2 = this;
	
	      var item = document.createElement('span');
	      item.tabIndex = '0';
	      item.setAttribute('role', 'button');
	
	      item.classList.add('ql-picker-item');
	      if (option.hasAttribute('value')) {
	        item.setAttribute('data-value', option.getAttribute('value'));
	      }
	      if (option.textContent) {
	        item.setAttribute('data-label', option.textContent);
	      }
	      item.addEventListener('click', function () {
	        _this2.selectItem(item, true);
	      });
	      item.addEventListener('keydown', function (event) {
	        switch (event.keyCode) {
	          // Allows the "Enter" key to select an item
	          case _keyboard2.default.keys.ENTER:
	            _this2.selectItem(item, true);
	            event.preventDefault();
	            break;
	
	          // Allows the "Escape" key to close the picker
	          case _keyboard2.default.keys.ESCAPE:
	            _this2.escape();
	            event.preventDefault();
	            break;
	          default:
	        }
	      });
	
	      return item;
	    }
	  }, {
	    key: 'buildLabel',
	    value: function buildLabel() {
	      var label = document.createElement('span');
	      label.classList.add('ql-picker-label');
	      label.innerHTML = _dropdown2.default;
	      label.tabIndex = '0';
	      label.setAttribute('role', 'button');
	      label.setAttribute('aria-expanded', 'false');
	      this.container.appendChild(label);
	      return label;
	    }
	  }, {
	    key: 'buildOptions',
	    value: function buildOptions() {
	      var _this3 = this;
	
	      var options = document.createElement('span');
	      options.classList.add('ql-picker-options');
	
	      // Don't want screen readers to read this until options are visible
	      options.setAttribute('aria-hidden', 'true');
	      options.tabIndex = '-1';
	
	      // Need a unique id for aria-controls
	      options.id = 'ql-picker-options-' + optionsCounter;
	      optionsCounter += 1;
	      this.label.setAttribute('aria-controls', options.id);
	
	      this.options = options;
	
	      [].slice.call(this.select.options).forEach(function (option) {
	        var item = _this3.buildItem(option);
	        options.appendChild(item);
	        if (option.selected === true) {
	          _this3.selectItem(item);
	        }
	      });
	      this.container.appendChild(options);
	    }
	  }, {
	    key: 'buildPicker',
	    value: function buildPicker() {
	      var _this4 = this;
	
	      [].slice.call(this.select.attributes).forEach(function (item) {
	        _this4.container.setAttribute(item.name, item.value);
	      });
	      this.container.classList.add('ql-picker');
	      this.label = this.buildLabel();
	      this.buildOptions();
	    }
	  }, {
	    key: 'escape',
	    value: function escape() {
	      var _this5 = this;
	
	      // Close menu and return focus to trigger label
	      this.close();
	      // Need setTimeout for accessibility to ensure that the browser executes
	      // focus on the next process thread and after any DOM content changes
	      setTimeout(function () {
	        return _this5.label.focus();
	      }, 1);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.container.classList.remove('ql-expanded');
	      this.label.setAttribute('aria-expanded', 'false');
	      this.options.setAttribute('aria-hidden', 'true');
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var selected = this.container.querySelector('.ql-selected');
	      if (item === selected) return;
	      if (selected != null) {
	        selected.classList.remove('ql-selected');
	      }
	      if (item == null) return;
	      item.classList.add('ql-selected');
	      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
	      if (item.hasAttribute('data-value')) {
	        this.label.setAttribute('data-value', item.getAttribute('data-value'));
	      } else {
	        this.label.removeAttribute('data-value');
	      }
	      if (item.hasAttribute('data-label')) {
	        this.label.setAttribute('data-label', item.getAttribute('data-label'));
	      } else {
	        this.label.removeAttribute('data-label');
	      }
	      if (trigger) {
	        if (typeof Event === 'function') {
	          this.select.dispatchEvent(new Event('change'));
	        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
	          // IE11
	          var event = document.createEvent('Event');
	          event.initEvent('change', true, true);
	          this.select.dispatchEvent(event);
	        }
	        this.close();
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var option = void 0;
	      if (this.select.selectedIndex > -1) {
	        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
	        option = this.select.options[this.select.selectedIndex];
	        this.selectItem(item);
	      } else {
	        this.selectItem(null);
	      }
	      var isActive = option != null && option !== this.select.querySelector('option[selected]');
	      this.label.classList.toggle('ql-active', isActive);
	    }
	  }]);
	
	  return Picker;
	}();
	
	exports.default = Picker;
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _scroll = __webpack_require__(22);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _clipboard = __webpack_require__(55);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _history = __webpack_require__(42);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_quill2.default.register({
	  'blots/block': _block2.default,
	  'blots/block/embed': _block.BlockEmbed,
	  'blots/break': _break2.default,
	  'blots/container': _container2.default,
	  'blots/cursor': _cursor2.default,
	  'blots/embed': _embed2.default,
	  'blots/inline': _inline2.default,
	  'blots/scroll': _scroll2.default,
	  'blots/text': _text2.default,
	
	  'modules/clipboard': _clipboard2.default,
	  'modules/history': _history2.default,
	  'modules/keyboard': _keyboard2.default
	});
	
	_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
	
	exports.default = _quill2.default;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var ShadowBlot = /** @class */ (function () {
	    function ShadowBlot(domNode) {
	        this.domNode = domNode;
	        // @ts-ignore
	        this.domNode[Registry.DATA_KEY] = { blot: this };
	    }
	    Object.defineProperty(ShadowBlot.prototype, "statics", {
	        // Hack for accessing inherited static methods
	        get: function () {
	            return this.constructor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ShadowBlot.create = function (value) {
	        if (this.tagName == null) {
	            throw new Registry.ParchmentError('Blot definition missing tagName');
	        }
	        var node;
	        if (Array.isArray(this.tagName)) {
	            if (typeof value === 'string') {
	                value = value.toUpperCase();
	                if (parseInt(value).toString() === value) {
	                    value = parseInt(value);
	                }
	            }
	            if (typeof value === 'number') {
	                node = document.createElement(this.tagName[value - 1]);
	            }
	            else if (this.tagName.indexOf(value) > -1) {
	                node = document.createElement(value);
	            }
	            else {
	                node = document.createElement(this.tagName[0]);
	            }
	        }
	        else {
	            node = document.createElement(this.tagName);
	        }
	        if (this.className) {
	            node.classList.add(this.className);
	        }
	        return node;
	    };
	    ShadowBlot.prototype.attach = function () {
	        if (this.parent != null) {
	            this.scroll = this.parent.scroll;
	        }
	    };
	    ShadowBlot.prototype.clone = function () {
	        var domNode = this.domNode.cloneNode(false);
	        return Registry.create(domNode);
	    };
	    ShadowBlot.prototype.detach = function () {
	        if (this.parent != null)
	            this.parent.removeChild(this);
	        // @ts-ignore
	        delete this.domNode[Registry.DATA_KEY];
	    };
	    ShadowBlot.prototype.deleteAt = function (index, length) {
	        var blot = this.isolate(index, length);
	        blot.remove();
	    };
	    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
	        var blot = this.isolate(index, length);
	        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
	            blot.wrap(name, value);
	        }
	        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
	            var parent = Registry.create(this.statics.scope);
	            blot.wrap(parent);
	            parent.format(name, value);
	        }
	    };
	    ShadowBlot.prototype.insertAt = function (index, value, def) {
	        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	        var ref = this.split(index);
	        this.parent.insertBefore(blot, ref);
	    };
	    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
	        if (refBlot === void 0) { refBlot = null; }
	        if (this.parent != null) {
	            this.parent.children.remove(this);
	        }
	        var refDomNode = null;
	        parentBlot.children.insertBefore(this, refBlot);
	        if (refBlot != null) {
	            refDomNode = refBlot.domNode;
	        }
	        if (this.domNode.parentNode != parentBlot.domNode ||
	            this.domNode.nextSibling != refDomNode) {
	            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
	        }
	        this.parent = parentBlot;
	        this.attach();
	    };
	    ShadowBlot.prototype.isolate = function (index, length) {
	        var target = this.split(index);
	        target.split(length);
	        return target;
	    };
	    ShadowBlot.prototype.length = function () {
	        return 1;
	    };
	    ShadowBlot.prototype.offset = function (root) {
	        if (root === void 0) { root = this.parent; }
	        if (this.parent == null || this == root)
	            return 0;
	        return this.parent.children.offset(this) + this.parent.offset(root);
	    };
	    ShadowBlot.prototype.optimize = function (context) {
	        // TODO clean up once we use WeakMap
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY] != null) {
	            // @ts-ignore
	            delete this.domNode[Registry.DATA_KEY].mutations;
	        }
	    };
	    ShadowBlot.prototype.remove = function () {
	        if (this.domNode.parentNode != null) {
	            this.domNode.parentNode.removeChild(this.domNode);
	        }
	        this.detach();
	    };
	    ShadowBlot.prototype.replace = function (target) {
	        if (target.parent == null)
	            return;
	        target.parent.insertBefore(this, target.next);
	        target.remove();
	    };
	    ShadowBlot.prototype.replaceWith = function (name, value) {
	        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
	        replacement.replace(this);
	        return replacement;
	    };
	    ShadowBlot.prototype.split = function (index, force) {
	        return index === 0 ? this : this.next;
	    };
	    ShadowBlot.prototype.update = function (mutations, context) {
	        // Nothing to do by default
	    };
	    ShadowBlot.prototype.wrap = function (name, value) {
	        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
	        if (this.parent != null) {
	            this.parent.insertBefore(wrapper, this.next);
	        }
	        wrapper.appendChild(this);
	        return wrapper;
	    };
	    ShadowBlot.blotName = 'abstract';
	    return ShadowBlot;
	}());
	exports.default = ShadowBlot;
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var Registry = __webpack_require__(1);
	var AttributorStore = /** @class */ (function () {
	    function AttributorStore(domNode) {
	        this.attributes = {};
	        this.domNode = domNode;
	        this.build();
	    }
	    AttributorStore.prototype.attribute = function (attribute, value) {
	        // verb
	        if (value) {
	            if (attribute.add(this.domNode, value)) {
	                if (attribute.value(this.domNode) != null) {
	                    this.attributes[attribute.attrName] = attribute;
	                }
	                else {
	                    delete this.attributes[attribute.attrName];
	                }
	            }
	        }
	        else {
	            attribute.remove(this.domNode);
	            delete this.attributes[attribute.attrName];
	        }
	    };
	    AttributorStore.prototype.build = function () {
	        var _this = this;
	        this.attributes = {};
	        var attributes = attributor_1.default.keys(this.domNode);
	        var classes = class_1.default.keys(this.domNode);
	        var styles = style_1.default.keys(this.domNode);
	        attributes
	            .concat(classes)
	            .concat(styles)
	            .forEach(function (name) {
	            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
	            if (attr instanceof attributor_1.default) {
	                _this.attributes[attr.attrName] = attr;
	            }
	        });
	    };
	    AttributorStore.prototype.copy = function (target) {
	        var _this = this;
	        Object.keys(this.attributes).forEach(function (key) {
	            var value = _this.attributes[key].value(_this.domNode);
	            target.format(key, value);
	        });
	    };
	    AttributorStore.prototype.move = function (target) {
	        var _this = this;
	        this.copy(target);
	        Object.keys(this.attributes).forEach(function (key) {
	            _this.attributes[key].remove(_this.domNode);
	        });
	        this.attributes = {};
	    };
	    AttributorStore.prototype.values = function () {
	        var _this = this;
	        return Object.keys(this.attributes).reduce(function (attributes, name) {
	            attributes[name] = _this.attributes[name].value(_this.domNode);
	            return attributes;
	        }, {});
	    };
	    return AttributorStore;
	}());
	exports.default = AttributorStore;
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function match(node, prefix) {
	    var className = node.getAttribute('class') || '';
	    return className.split(/\s+/).filter(function (name) {
	        return name.indexOf(prefix + "-") === 0;
	    });
	}
	var ClassAttributor = /** @class */ (function (_super) {
	    __extends(ClassAttributor, _super);
	    function ClassAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ClassAttributor.keys = function (node) {
	        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
	            return name
	                .split('-')
	                .slice(0, -1)
	                .join('-');
	        });
	    };
	    ClassAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        this.remove(node);
	        node.classList.add(this.keyName + "-" + value);
	        return true;
	    };
	    ClassAttributor.prototype.remove = function (node) {
	        var matches = match(node, this.keyName);
	        matches.forEach(function (name) {
	            node.classList.remove(name);
	        });
	        if (node.classList.length === 0) {
	            node.removeAttribute('class');
	        }
	    };
	    ClassAttributor.prototype.value = function (node) {
	        var result = match(node, this.keyName)[0] || '';
	        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
	        return this.canAdd(node, value) ? value : '';
	    };
	    return ClassAttributor;
	}(attributor_1.default));
	exports.default = ClassAttributor;
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function camelize(name) {
	    var parts = name.split('-');
	    var rest = parts
	        .slice(1)
	        .map(function (part) {
	        return part[0].toUpperCase() + part.slice(1);
	    })
	        .join('');
	    return parts[0] + rest;
	}
	var StyleAttributor = /** @class */ (function (_super) {
	    __extends(StyleAttributor, _super);
	    function StyleAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StyleAttributor.keys = function (node) {
	        return (node.getAttribute('style') || '').split(';').map(function (value) {
	            var arr = value.split(':');
	            return arr[0].trim();
	        });
	    };
	    StyleAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = value;
	        return true;
	    };
	    StyleAttributor.prototype.remove = function (node) {
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = '';
	        if (!node.getAttribute('style')) {
	            node.removeAttribute('style');
	        }
	    };
	    StyleAttributor.prototype.value = function (node) {
	        // @ts-ignore
	        var value = node.style[camelize(this.keyName)];
	        return this.canAdd(node, value) ? value : '';
	    };
	    return StyleAttributor;
	}(attributor_1.default));
	exports.default = StyleAttributor;
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Theme = function () {
	  function Theme(quill, options) {
	    _classCallCheck(this, Theme);
	
	    this.quill = quill;
	    this.options = options;
	    this.modules = {};
	  }
	
	  _createClass(Theme, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      Object.keys(this.options.modules).forEach(function (name) {
	        if (_this.modules[name] == null) {
	          _this.addModule(name);
	        }
	      });
	    }
	  }, {
	    key: 'addModule',
	    value: function addModule(name) {
	      var moduleClass = this.quill.constructor.import('modules/' + name);
	      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
	      return this.modules[name];
	    }
	  }]);
	
	  return Theme;
	}();
	
	Theme.DEFAULTS = {
	  modules: {}
	};
	Theme.themes = {
	  'default': Theme
	};
	
	exports.default = Theme;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GUARD_TEXT = '\uFEFF';
	
	var Embed = function (_Parchment$Embed) {
	  _inherits(Embed, _Parchment$Embed);
	
	  function Embed(node) {
	    _classCallCheck(this, Embed);
	
	    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
	
	    _this.contentNode = document.createElement('span');
	    _this.contentNode.setAttribute('contenteditable', false);
	    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
	      _this.contentNode.appendChild(childNode);
	    });
	    _this.leftGuard = document.createTextNode(GUARD_TEXT);
	    _this.rightGuard = document.createTextNode(GUARD_TEXT);
	    _this.domNode.appendChild(_this.leftGuard);
	    _this.domNode.appendChild(_this.contentNode);
	    _this.domNode.appendChild(_this.rightGuard);
	    return _this;
	  }
	
	  _createClass(Embed, [{
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.leftGuard) return 0;
	      if (node === this.rightGuard) return 1;
	      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'restore',
	    value: function restore(node) {
	      var range = void 0,
	          textNode = void 0;
	      var text = node.data.split(GUARD_TEXT).join('');
	      if (node === this.leftGuard) {
	        if (this.prev instanceof _text2.default) {
	          var prevLength = this.prev.length();
	          this.prev.insertAt(prevLength, text);
	          range = {
	            startNode: this.prev.domNode,
	            startOffset: prevLength + text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      } else if (node === this.rightGuard) {
	        if (this.next instanceof _text2.default) {
	          this.next.insertAt(0, text);
	          range = {
	            startNode: this.next.domNode,
	            startOffset: text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      }
	      node.data = GUARD_TEXT;
	      return range;
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      mutations.forEach(function (mutation) {
	        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
	          var range = _this2.restore(mutation.target);
	          if (range) context.range = range;
	        }
	      });
	    }
	  }]);
	
	  return Embed;
	}(_parchment2.default.Embed);
	
	exports.default = Embed;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['right', 'center', 'justify']
	};
	
	var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
	var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
	var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
	
	exports.AlignAttribute = AlignAttribute;
	exports.AlignClass = AlignClass;
	exports.AlignStyle = AlignStyle;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackgroundStyle = exports.BackgroundClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _color = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.BackgroundClass = BackgroundClass;
	exports.BackgroundStyle = BackgroundStyle;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['rtl']
	};
	
	var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
	var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
	var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
	
	exports.DirectionAttribute = DirectionAttribute;
	exports.DirectionClass = DirectionClass;
	exports.DirectionStyle = DirectionStyle;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontClass = exports.FontStyle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['serif', 'monospace']
	};
	
	var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
	
	var FontStyleAttributor = function (_Parchment$Attributor) {
	  _inherits(FontStyleAttributor, _Parchment$Attributor);
	
	  function FontStyleAttributor() {
	    _classCallCheck(this, FontStyleAttributor);
	
	    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
	  }
	
	  _createClass(FontStyleAttributor, [{
	    key: 'value',
	    value: function value(node) {
	      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
	    }
	  }]);
	
	  return FontStyleAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var FontStyle = new FontStyleAttributor('font', 'font-family', config);
	
	exports.FontStyle = FontStyle;
	exports.FontClass = FontClass;
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizeStyle = exports.SizeClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['small', 'large', 'huge']
	});
	var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['10px', '18px', '32px']
	});
	
	exports.SizeClass = SizeClass;
	exports.SizeStyle = SizeStyle;
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = {
	  'align': {
	    '': __webpack_require__(76),
	    'center': __webpack_require__(77),
	    'right': __webpack_require__(78),
	    'justify': __webpack_require__(79)
	  },
	  'background': __webpack_require__(80),
	  'blockquote': __webpack_require__(81),
	  'bold': __webpack_require__(82),
	  'clean': __webpack_require__(83),
	  'code': __webpack_require__(58),
	  'code-block': __webpack_require__(58),
	  'color': __webpack_require__(84),
	  'direction': {
	    '': __webpack_require__(85),
	    'rtl': __webpack_require__(86)
	  },
	  'float': {
	    'center': __webpack_require__(87),
	    'full': __webpack_require__(88),
	    'left': __webpack_require__(89),
	    'right': __webpack_require__(90)
	  },
	  'formula': __webpack_require__(91),
	  'header': {
	    '1': __webpack_require__(92),
	    '2': __webpack_require__(93)
	  },
	  'italic': __webpack_require__(94),
	  'image': __webpack_require__(95),
	  'indent': {
	    '+1': __webpack_require__(96),
	    '-1': __webpack_require__(97)
	  },
	  'link': __webpack_require__(98),
	  'list': {
	    'ordered': __webpack_require__(99),
	    'bullet': __webpack_require__(100),
	    'check': __webpack_require__(101)
	  },
	  'script': {
	    'sub': __webpack_require__(102),
	    'super': __webpack_require__(103)
	  },
	  'strike': __webpack_require__(104),
	  'underline': __webpack_require__(105),
	  'video': __webpack_require__(106)
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastChangeIndex = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var History = function (_Module) {
	  _inherits(History, _Module);
	
	  function History(quill, options) {
	    _classCallCheck(this, History);
	
	    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
	
	    _this.lastRecorded = 0;
	    _this.ignoreChange = false;
	    _this.clear();
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
	      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
	      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
	        _this.record(delta, oldDelta);
	      } else {
	        _this.transform(delta);
	      }
	    });
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
	    if (/Win/i.test(navigator.platform)) {
	      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
	    }
	    return _this;
	  }
	
	  _createClass(History, [{
	    key: 'change',
	    value: function change(source, dest) {
	      if (this.stack[source].length === 0) return;
	      var delta = this.stack[source].pop();
	      this.stack[dest].push(delta);
	      this.lastRecorded = 0;
	      this.ignoreChange = true;
	      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
	      this.ignoreChange = false;
	      var index = getLastChangeIndex(delta[source]);
	      this.quill.setSelection(index);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.stack = { undo: [], redo: [] };
	    }
	  }, {
	    key: 'cutoff',
	    value: function cutoff() {
	      this.lastRecorded = 0;
	    }
	  }, {
	    key: 'record',
	    value: function record(changeDelta, oldDelta) {
	      if (changeDelta.ops.length === 0) return;
	      this.stack.redo = [];
	      var undoDelta = this.quill.getContents().diff(oldDelta);
	      var timestamp = Date.now();
	      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	        var delta = this.stack.undo.pop();
	        undoDelta = undoDelta.compose(delta.undo);
	        changeDelta = delta.redo.compose(changeDelta);
	      } else {
	        this.lastRecorded = timestamp;
	      }
	      this.stack.undo.push({
	        redo: changeDelta,
	        undo: undoDelta
	      });
	      if (this.stack.undo.length > this.options.maxStack) {
	        this.stack.undo.shift();
	      }
	    }
	  }, {
	    key: 'redo',
	    value: function redo() {
	      this.change('redo', 'undo');
	    }
	  }, {
	    key: 'transform',
	    value: function transform(delta) {
	      this.stack.undo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	      this.stack.redo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	    }
	  }, {
	    key: 'undo',
	    value: function undo() {
	      this.change('undo', 'redo');
	    }
	  }]);
	
	  return History;
	}(_module2.default);
	
	History.DEFAULTS = {
	  delay: 1000,
	  maxStack: 100,
	  userOnly: false
	};
	
	function endsWithNewlineChange(delta) {
	  var lastOp = delta.ops[delta.ops.length - 1];
	  if (lastOp == null) return false;
	  if (lastOp.insert != null) {
	    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
	  }
	  if (lastOp.attributes != null) {
	    return Object.keys(lastOp.attributes).some(function (attr) {
	      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
	    });
	  }
	  return false;
	}
	
	function getLastChangeIndex(delta) {
	  var deleteLength = delta.reduce(function (length, op) {
	    length += op.delete || 0;
	    return length;
	  }, 0);
	  var changeIndex = delta.length() - deleteLength;
	  if (endsWithNewlineChange(delta)) {
	    changeIndex -= 1;
	  }
	  return changeIndex;
	}
	
	exports.default = History;
	exports.getLastChangeIndex = getLastChangeIndex;
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BaseTooltip = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALIGNS = [false, 'center', 'right', 'justify'];
	
	var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
	
	var FONTS = [false, 'serif', 'monospace'];
	
	var HEADERS = ['1', '2', '3', false];
	
	var SIZES = ['small', false, 'large', 'huge'];
	
	var BaseTheme = function (_Theme) {
	  _inherits(BaseTheme, _Theme);
	
	  function BaseTheme(quill, options) {
	    _classCallCheck(this, BaseTheme);
	
	    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
	
	    var listener = function listener(e) {
	      if (!document.body.contains(quill.root)) {
	        return document.body.removeEventListener('click', listener);
	      }
	      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
	        _this.tooltip.hide();
	      }
	      if (_this.pickers != null) {
	        _this.pickers.forEach(function (picker) {
	          if (!picker.container.contains(e.target)) {
	            picker.close();
	          }
	        });
	      }
	    };
	    quill.emitter.listenDOM('click', document.body, listener);
	    return _this;
	  }
	
	  _createClass(BaseTheme, [{
	    key: 'addModule',
	    value: function addModule(name) {
	      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
	      if (name === 'toolbar') {
	        this.extendToolbar(module);
	      }
	      return module;
	    }
	  }, {
	    key: 'buildButtons',
	    value: function buildButtons(buttons, icons) {
	      buttons.forEach(function (button) {
	        var className = button.getAttribute('class') || '';
	        className.split(/\s+/).forEach(function (name) {
	          if (!name.startsWith('ql-')) return;
	          name = name.slice('ql-'.length);
	          if (icons[name] == null) return;
	          if (name === 'direction') {
	            button.innerHTML = icons[name][''] + icons[name]['rtl'];
	          } else if (typeof icons[name] === 'string') {
	            button.innerHTML = icons[name];
	          } else {
	            var value = button.value || '';
	            if (value != null && icons[name][value]) {
	              button.innerHTML = icons[name][value];
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'buildPickers',
	    value: function buildPickers(selects, icons) {
	      var _this2 = this;
	
	      this.pickers = selects.map(function (select) {
	        if (select.classList.contains('ql-align')) {
	          if (select.querySelector('option') == null) {
	            fillSelect(select, ALIGNS);
	          }
	          return new _iconPicker2.default(select, icons.align);
	        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
	          var format = select.classList.contains('ql-background') ? 'background' : 'color';
	          if (select.querySelector('option') == null) {
	            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
	          }
	          return new _colorPicker2.default(select, icons[format]);
	        } else {
	          if (select.querySelector('option') == null) {
	            if (select.classList.contains('ql-font')) {
	              fillSelect(select, FONTS);
	            } else if (select.classList.contains('ql-header')) {
	              fillSelect(select, HEADERS);
	            } else if (select.classList.contains('ql-size')) {
	              fillSelect(select, SIZES);
	            }
	          }
	          return new _picker2.default(select);
	        }
	      });
	      var update = function update() {
	        _this2.pickers.forEach(function (picker) {
	          picker.update();
	        });
	      };
	      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
	    }
	  }]);
	
	  return BaseTheme;
	}(_theme2.default);
	
	BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        formula: function formula() {
	          this.quill.theme.tooltip.edit('formula');
	        },
	        image: function image() {
	          var _this3 = this;
	
	          var fileInput = this.container.querySelector('input.ql-image[type=file]');
	          if (fileInput == null) {
	            fileInput = document.createElement('input');
	            fileInput.setAttribute('type', 'file');
	            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
	            fileInput.classList.add('ql-image');
	            fileInput.addEventListener('change', function () {
	              if (fileInput.files != null && fileInput.files[0] != null) {
	                var reader = new FileReader();
	                reader.onload = function (e) {
	                  var range = _this3.quill.getSelection(true);
	                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
	                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
	                  fileInput.value = "";
	                };
	                reader.readAsDataURL(fileInput.files[0]);
	              }
	            });
	            this.container.appendChild(fileInput);
	          }
	          fileInput.click();
	        },
	        video: function video() {
	          this.quill.theme.tooltip.edit('video');
	        }
	      }
	    }
	  }
	});
	
	var BaseTooltip = function (_Tooltip) {
	  _inherits(BaseTooltip, _Tooltip);
	
	  function BaseTooltip(quill, boundsContainer) {
	    _classCallCheck(this, BaseTooltip);
	
	    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
	
	    _this4.textbox = _this4.root.querySelector('input[type="text"]');
	    _this4.listen();
	    return _this4;
	  }
	
	  _createClass(BaseTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this5 = this;
	
	      this.textbox.addEventListener('keydown', function (event) {
	        if (_keyboard2.default.match(event, 'enter')) {
	          _this5.save();
	          event.preventDefault();
	        } else if (_keyboard2.default.match(event, 'escape')) {
	          _this5.cancel();
	          event.preventDefault();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.hide();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
	      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.root.classList.remove('ql-hidden');
	      this.root.classList.add('ql-editing');
	      if (preview != null) {
	        this.textbox.value = preview;
	      } else if (mode !== this.root.getAttribute('data-mode')) {
	        this.textbox.value = '';
	      }
	      this.position(this.quill.getBounds(this.quill.selection.savedRange));
	      this.textbox.select();
	      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
	      this.root.setAttribute('data-mode', mode);
	    }
	  }, {
	    key: 'restoreFocus',
	    value: function restoreFocus() {
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.quill.focus();
	      this.quill.scrollingContainer.scrollTop = scrollTop;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var value = this.textbox.value;
	      switch (this.root.getAttribute('data-mode')) {
	        case 'link':
	          {
	            var scrollTop = this.quill.root.scrollTop;
	            if (this.linkRange) {
	              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
	              delete this.linkRange;
	            } else {
	              this.restoreFocus();
	              this.quill.format('link', value, _emitter2.default.sources.USER);
	            }
	            this.quill.root.scrollTop = scrollTop;
	            break;
	          }
	        case 'video':
	          {
	            value = extractVideoUrl(value);
	          } // eslint-disable-next-line no-fallthrough
	        case 'formula':
	          {
	            if (!value) break;
	            var range = this.quill.getSelection(true);
	            if (range != null) {
	              var index = range.index + range.length;
	              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
	              if (this.root.getAttribute('data-mode') === 'formula') {
	                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
	              }
	              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
	            }
	            break;
	          }
	        default:
	      }
	      this.textbox.value = '';
	      this.hide();
	    }
	  }]);
	
	  return BaseTooltip;
	}(_tooltip2.default);
	
	function extractVideoUrl(url) {
	  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
	  if (match) {
	    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
	  }
	  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
	    // eslint-disable-line no-cond-assign
	    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
	  }
	  return url;
	}
	
	function fillSelect(select, values) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value === defaultValue) {
	      option.setAttribute('selected', 'selected');
	    } else {
	      option.setAttribute('value', value);
	    }
	    select.appendChild(option);
	  });
	}
	
	exports.BaseTooltip = BaseTooltip;
	exports.default = BaseTheme;
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedList = /** @class */ (function () {
	    function LinkedList() {
	        this.head = this.tail = null;
	        this.length = 0;
	    }
	    LinkedList.prototype.append = function () {
	        var nodes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            nodes[_i] = arguments[_i];
	        }
	        this.insertBefore(nodes[0], null);
	        if (nodes.length > 1) {
	            this.append.apply(this, nodes.slice(1));
	        }
	    };
	    LinkedList.prototype.contains = function (node) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            if (cur === node)
	                return true;
	        }
	        return false;
	    };
	    LinkedList.prototype.insertBefore = function (node, refNode) {
	        if (!node)
	            return;
	        node.next = refNode;
	        if (refNode != null) {
	            node.prev = refNode.prev;
	            if (refNode.prev != null) {
	                refNode.prev.next = node;
	            }
	            refNode.prev = node;
	            if (refNode === this.head) {
	                this.head = node;
	            }
	        }
	        else if (this.tail != null) {
	            this.tail.next = node;
	            node.prev = this.tail;
	            this.tail = node;
	        }
	        else {
	            node.prev = null;
	            this.head = this.tail = node;
	        }
	        this.length += 1;
	    };
	    LinkedList.prototype.offset = function (target) {
	        var index = 0, cur = this.head;
	        while (cur != null) {
	            if (cur === target)
	                return index;
	            index += cur.length();
	            cur = cur.next;
	        }
	        return -1;
	    };
	    LinkedList.prototype.remove = function (node) {
	        if (!this.contains(node))
	            return;
	        if (node.prev != null)
	            node.prev.next = node.next;
	        if (node.next != null)
	            node.next.prev = node.prev;
	        if (node === this.head)
	            this.head = node.next;
	        if (node === this.tail)
	            this.tail = node.prev;
	        this.length -= 1;
	    };
	    LinkedList.prototype.iterator = function (curNode) {
	        if (curNode === void 0) { curNode = this.head; }
	        // TODO use yield when we can
	        return function () {
	            var ret = curNode;
	            if (curNode != null)
	                curNode = curNode.next;
	            return ret;
	        };
	    };
	    LinkedList.prototype.find = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            var length = cur.length();
	            if (index < length ||
	                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
	                return [cur, index];
	            }
	            index -= length;
	        }
	        return [null, 0];
	    };
	    LinkedList.prototype.forEach = function (callback) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            callback(cur);
	        }
	    };
	    LinkedList.prototype.forEachAt = function (index, length, callback) {
	        if (length <= 0)
	            return;
	        var _a = this.find(index), startNode = _a[0], offset = _a[1];
	        var cur, curIndex = index - offset, next = this.iterator(startNode);
	        while ((cur = next()) && curIndex < index + length) {
	            var curLength = cur.length();
	            if (index > curIndex) {
	                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
	            }
	            else {
	                callback(cur, 0, Math.min(curLength, index + length - curIndex));
	            }
	            curIndex += curLength;
	        }
	    };
	    LinkedList.prototype.map = function (callback) {
	        return this.reduce(function (memo, cur) {
	            memo.push(callback(cur));
	            return memo;
	        }, []);
	    };
	    LinkedList.prototype.reduce = function (callback, memo) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            memo = callback(memo, cur);
	        }
	        return memo;
	    };
	    return LinkedList;
	}());
	exports.default = LinkedList;
	
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var OBSERVER_CONFIG = {
	    attributes: true,
	    characterData: true,
	    characterDataOldValue: true,
	    childList: true,
	    subtree: true,
	};
	var MAX_OPTIMIZE_ITERATIONS = 100;
	var ScrollBlot = /** @class */ (function (_super) {
	    __extends(ScrollBlot, _super);
	    function ScrollBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.scroll = _this;
	        _this.observer = new MutationObserver(function (mutations) {
	            _this.update(mutations);
	        });
	        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
	        _this.attach();
	        return _this;
	    }
	    ScrollBlot.prototype.detach = function () {
	        _super.prototype.detach.call(this);
	        this.observer.disconnect();
	    };
	    ScrollBlot.prototype.deleteAt = function (index, length) {
	        this.update();
	        if (index === 0 && length === this.length()) {
	            this.children.forEach(function (child) {
	                child.remove();
	            });
	        }
	        else {
	            _super.prototype.deleteAt.call(this, index, length);
	        }
	    };
	    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
	        this.update();
	        _super.prototype.formatAt.call(this, index, length, name, value);
	    };
	    ScrollBlot.prototype.insertAt = function (index, value, def) {
	        this.update();
	        _super.prototype.insertAt.call(this, index, value, def);
	    };
	    ScrollBlot.prototype.optimize = function (mutations, context) {
	        var _this = this;
	        if (mutations === void 0) { mutations = []; }
	        if (context === void 0) { context = {}; }
	        _super.prototype.optimize.call(this, context);
	        // We must modify mutations directly, cannot make copy and then modify
	        var records = [].slice.call(this.observer.takeRecords());
	        // Array.push currently seems to be implemented by a non-tail recursive function
	        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
	        while (records.length > 0)
	            mutations.push(records.pop());
	        // TODO use WeakMap
	        var mark = function (blot, markParent) {
	            if (markParent === void 0) { markParent = true; }
	            if (blot == null || blot === _this)
	                return;
	            if (blot.domNode.parentNode == null)
	                return;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [];
	            }
	            if (markParent)
	                mark(blot.parent);
	        };
	        var optimize = function (blot) {
	            // Post-order traversal
	            if (
	            // @ts-ignore
	            blot.domNode[Registry.DATA_KEY] == null ||
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations == null) {
	                return;
	            }
	            if (blot instanceof container_1.default) {
	                blot.children.forEach(optimize);
	            }
	            blot.optimize(context);
	        };
	        var remaining = mutations;
	        for (var i = 0; remaining.length > 0; i += 1) {
	            if (i >= MAX_OPTIMIZE_ITERATIONS) {
	                throw new Error('[Parchment] Maximum optimize iterations reached');
	            }
	            remaining.forEach(function (mutation) {
	                var blot = Registry.find(mutation.target, true);
	                if (blot == null)
	                    return;
	                if (blot.domNode === mutation.target) {
	                    if (mutation.type === 'childList') {
	                        mark(Registry.find(mutation.previousSibling, false));
	                        [].forEach.call(mutation.addedNodes, function (node) {
	                            var child = Registry.find(node, false);
	                            mark(child, false);
	                            if (child instanceof container_1.default) {
	                                child.children.forEach(function (grandChild) {
	                                    mark(grandChild, false);
	                                });
	                            }
	                        });
	                    }
	                    else if (mutation.type === 'attributes') {
	                        mark(blot.prev);
	                    }
	                }
	                mark(blot);
	            });
	            this.children.forEach(optimize);
	            remaining = [].slice.call(this.observer.takeRecords());
	            records = remaining.slice();
	            while (records.length > 0)
	                mutations.push(records.pop());
	        }
	    };
	    ScrollBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (context === void 0) { context = {}; }
	        mutations = mutations || this.observer.takeRecords();
	        // TODO use WeakMap
	        mutations
	            .map(function (mutation) {
	            var blot = Registry.find(mutation.target, true);
	            if (blot == null)
	                return null;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
	                return blot;
	            }
	            else {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
	                return null;
	            }
	        })
	            .forEach(function (blot) {
	            if (blot == null ||
	                blot === _this ||
	                //@ts-ignore
	                blot.domNode[Registry.DATA_KEY] == null)
	                return;
	            // @ts-ignore
	            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
	        });
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY].mutations != null) {
	            // @ts-ignore
	            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
	        }
	        this.optimize(mutations, context);
	    };
	    ScrollBlot.blotName = 'scroll';
	    ScrollBlot.defaultChild = 'block';
	    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
	    ScrollBlot.tagName = 'DIV';
	    return ScrollBlot;
	}(container_1.default));
	exports.default = ScrollBlot;
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	// Shallow object comparison
	function isEqual(obj1, obj2) {
	    if (Object.keys(obj1).length !== Object.keys(obj2).length)
	        return false;
	    // @ts-ignore
	    for (var prop in obj1) {
	        // @ts-ignore
	        if (obj1[prop] !== obj2[prop])
	            return false;
	    }
	    return true;
	}
	var InlineBlot = /** @class */ (function (_super) {
	    __extends(InlineBlot, _super);
	    function InlineBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InlineBlot.formats = function (domNode) {
	        if (domNode.tagName === InlineBlot.tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    InlineBlot.prototype.format = function (name, value) {
	        var _this = this;
	        if (name === this.statics.blotName && !value) {
	            this.children.forEach(function (child) {
	                if (!(child instanceof format_1.default)) {
	                    child = child.wrap(InlineBlot.blotName, true);
	                }
	                _this.attributes.copy(child);
	            });
	            this.unwrap();
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    InlineBlot.prototype.formatAt = function (index, length, name, value) {
	        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
	            var blot = this.isolate(index, length);
	            blot.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    InlineBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        var formats = this.formats();
	        if (Object.keys(formats).length === 0) {
	            return this.unwrap(); // unformatted span
	        }
	        var next = this.next;
	        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
	            next.moveChildren(this);
	            next.remove();
	        }
	    };
	    InlineBlot.blotName = 'inline';
	    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
	    InlineBlot.tagName = 'SPAN';
	    return InlineBlot;
	}(format_1.default));
	exports.default = InlineBlot;
	
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	var BlockBlot = /** @class */ (function (_super) {
	    __extends(BlockBlot, _super);
	    function BlockBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BlockBlot.formats = function (domNode) {
	        var tagName = Registry.query(BlockBlot.blotName).tagName;
	        if (domNode.tagName === tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    BlockBlot.prototype.format = function (name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
	            return;
	        }
	        else if (name === this.statics.blotName && !value) {
	            this.replaceWith(BlockBlot.blotName);
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    BlockBlot.prototype.formatAt = function (index, length, name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    BlockBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
	            // Insert text or inline
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	        else {
	            var after = this.split(index);
	            var blot = Registry.create(value, def);
	            after.parent.insertBefore(blot, after);
	        }
	    };
	    BlockBlot.prototype.update = function (mutations, context) {
	        if (navigator.userAgent.match(/Trident/)) {
	            this.build();
	        }
	        else {
	            _super.prototype.update.call(this, mutations, context);
	        }
	    };
	    BlockBlot.blotName = 'block';
	    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
	    BlockBlot.tagName = 'P';
	    return BlockBlot;
	}(format_1.default));
	exports.default = BlockBlot;
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var EmbedBlot = /** @class */ (function (_super) {
	    __extends(EmbedBlot, _super);
	    function EmbedBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EmbedBlot.formats = function (domNode) {
	        return undefined;
	    };
	    EmbedBlot.prototype.format = function (name, value) {
	        // super.formatAt wraps, which is what we want in general,
	        // but this allows subclasses to overwrite for formats
	        // that just apply to particular embeds
	        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
	    };
	    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
	        if (index === 0 && length === this.length()) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    EmbedBlot.prototype.formats = function () {
	        return this.statics.formats(this.domNode);
	    };
	    return EmbedBlot;
	}(leaf_1.default));
	exports.default = EmbedBlot;
	
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var Registry = __webpack_require__(1);
	var TextBlot = /** @class */ (function (_super) {
	    __extends(TextBlot, _super);
	    function TextBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.text = _this.statics.value(_this.domNode);
	        return _this;
	    }
	    TextBlot.create = function (value) {
	        return document.createTextNode(value);
	    };
	    TextBlot.value = function (domNode) {
	        var text = domNode.data;
	        // @ts-ignore
	        if (text['normalize'])
	            text = text['normalize']();
	        return text;
	    };
	    TextBlot.prototype.deleteAt = function (index, length) {
	        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
	    };
	    TextBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node) {
	            return offset;
	        }
	        return -1;
	    };
	    TextBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null) {
	            this.text = this.text.slice(0, index) + value + this.text.slice(index);
	            this.domNode.data = this.text;
	        }
	        else {
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	    };
	    TextBlot.prototype.length = function () {
	        return this.text.length;
	    };
	    TextBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        this.text = this.statics.value(this.domNode);
	        if (this.text.length === 0) {
	            this.remove();
	        }
	        else if (this.next instanceof TextBlot && this.next.prev === this) {
	            this.insertAt(this.length(), this.next.value());
	            this.next.remove();
	        }
	    };
	    TextBlot.prototype.position = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        return [this.domNode, index];
	    };
	    TextBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = Registry.create(this.domNode.splitText(index));
	        this.parent.insertBefore(after, this.next);
	        this.text = this.statics.value(this.domNode);
	        return after;
	    };
	    TextBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (mutations.some(function (mutation) {
	            return mutation.type === 'characterData' && mutation.target === _this.domNode;
	        })) {
	            this.text = this.statics.value(this.domNode);
	        }
	    };
	    TextBlot.prototype.value = function () {
	        return this.text;
	    };
	    TextBlot.blotName = 'text';
	    TextBlot.scope = Registry.Scope.INLINE_BLOT;
	    return TextBlot;
	}(leaf_1.default));
	exports.default = TextBlot;
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var elem = document.createElement('div');
	elem.classList.toggle('test-class', false);
	if (elem.classList.contains('test-class')) {
	  var _toggle = DOMTokenList.prototype.toggle;
	  DOMTokenList.prototype.toggle = function (token, force) {
	    if (arguments.length > 1 && !this.contains(token) === !force) {
	      return force;
	    } else {
	      return _toggle.call(this, token);
	    }
	  };
	}
	
	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}
	
	if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (searchString, position) {
	    var subjectString = this.toString();
	    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
	      position = subjectString.length;
	    }
	    position -= searchString.length;
	    var lastIndex = subjectString.indexOf(searchString, position);
	    return lastIndex !== -1 && lastIndex === position;
	  };
	}
	
	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, "find", {
	    value: function value(predicate) {
	      if (this === null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return value;
	        }
	      }
	      return undefined;
	    }
	  });
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	  // Disable resizing in Firefox
	  document.execCommand("enableObjectResizing", false, false);
	  // Disable automatic linkifying in IE11
	  document.execCommand("autoUrlDetect", false, false);
	});
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports) {
	
	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;
	
	
	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {Int} cursor_pos Expected edit position in text1 (optional)
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2, cursor_pos) {
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }
	
	  // Check cursor_pos within bounds
	  if (cursor_pos < 0 || text1.length < cursor_pos) {
	    cursor_pos = null;
	  }
	
	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);
	
	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);
	
	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);
	
	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs);
	  if (cursor_pos != null) {
	    diffs = fix_cursor(diffs, cursor_pos);
	  }
	  diffs = fix_emoji(diffs);
	  return diffs;
	};
	
	
	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;
	
	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }
	
	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }
	
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }
	
	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }
	
	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }
	
	  return diff_bisect_(text1, text2);
	};
	
	
	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	
	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};
	
	
	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);
	
	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);
	
	  return diffs.concat(diffsb);
	};
	
	
	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }
	
	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = diff_commonPrefix(longtext.substring(i),
	                                           shorttext.substring(j));
	      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
	                                           shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }
	
	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }
	
	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};
	
	
	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 */
	function diff_cleanupMerge(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }
	
	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	};
	
	
	var diff = diff_main;
	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;
	
	module.exports = diff;
	
	/*
	 * Modify a diff such that the cursor position points to the start of a change:
	 * E.g.
	 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
	 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
	 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
	 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
	 */
	function cursor_normalize_diff (diffs, cursor_pos) {
	  if (cursor_pos === 0) {
	    return [DIFF_EQUAL, diffs];
	  }
	  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
	    var d = diffs[i];
	    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
	      var next_pos = current_pos + d[1].length;
	      if (cursor_pos === next_pos) {
	        return [i + 1, diffs];
	      } else if (cursor_pos < next_pos) {
	        // copy to prevent side effects
	        diffs = diffs.slice();
	        // split d into two diff changes
	        var split_pos = cursor_pos - current_pos;
	        var d_left = [d[0], d[1].slice(0, split_pos)];
	        var d_right = [d[0], d[1].slice(split_pos)];
	        diffs.splice(i, 1, d_left, d_right);
	        return [i + 1, diffs];
	      } else {
	        current_pos = next_pos;
	      }
	    }
	  }
	  throw new Error('cursor_pos is out of bounds!')
	}
	
	/*
	 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
	 *
	 * Case 1)
	 *   Check if a naive shift is possible:
	 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
	 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
	 * Case 2)
	 *   Check if the following shifts are possible:
	 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
	 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
	 *         ^            ^
	 *         d          d_next
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} Array of diff tuples
	 */
	function fix_cursor (diffs, cursor_pos) {
	  var norm = cursor_normalize_diff(diffs, cursor_pos);
	  var ndiffs = norm[1];
	  var cursor_pointer = norm[0];
	  var d = ndiffs[cursor_pointer];
	  var d_next = ndiffs[cursor_pointer + 1];
	
	  if (d == null) {
	    // Text was deleted from end of original string,
	    // cursor is now out of bounds in new string
	    return diffs;
	  } else if (d[0] !== DIFF_EQUAL) {
	    // A modification happened at the cursor location.
	    // This is the expected outcome, so we can return the original diff.
	    return diffs;
	  } else {
	    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
	      // Case 1)
	      // It is possible to perform a naive shift
	      ndiffs.splice(cursor_pointer, 2, d_next, d)
	      return merge_tuples(ndiffs, cursor_pointer, 2)
	    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
	      // Case 2)
	      // d[1] is a prefix of d_next[1]
	      // We can assume that d_next[0] !== 0, since d[0] === 0
	      // Shift edit locations..
	      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
	      var suffix = d_next[1].slice(d[1].length);
	      if (suffix.length > 0) {
	        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
	      }
	      return merge_tuples(ndiffs, cursor_pointer, 3)
	    } else {
	      // Not possible to perform any modification
	      return diffs;
	    }
	  }
	}
	
	/*
	 * Check diff did not split surrogate pairs.
	 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
	 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @return {Array} Array of diff tuples
	 */
	function fix_emoji (diffs) {
	  var compact = false;
	  var starts_with_pair_end = function(str) {
	    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
	  }
	  var ends_with_pair_start = function(str) {
	    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
	  }
	  for (var i = 2; i < diffs.length; i += 1) {
	    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
	        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
	        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
	      compact = true;
	
	      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
	      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];
	
	      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
	    }
	  }
	  if (!compact) {
	    return diffs;
	  }
	  var fixed_diffs = [];
	  for (var i = 0; i < diffs.length; i += 1) {
	    if (diffs[i][1].length > 0) {
	      fixed_diffs.push(diffs[i]);
	    }
	  }
	  return fixed_diffs;
	}
	
	/*
	 * Try to merge tuples with their neigbors in a given range.
	 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
	 *
	 * @param {Array} diffs Array of diff tuples.
	 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
	 * @param {Int} length Number of consecutive elements to check.
	 * @return {Array} Array of merged diff tuples.
	 */
	function merge_tuples (diffs, start, length) {
	  // Check from (start-1) to (start+length).
	  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
	    if (i + 1 < diffs.length) {
	      var left_d = diffs[i];
	      var right_d = diffs[i+1];
	      if (left_d[0] === right_d[1]) {
	        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
	      }
	    }
	  }
	  return diffs;
	}
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports) {
	
	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports) {
	
	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if ('undefined' !== typeof module) {
	  module.exports = EventEmitter;
	}
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend2 = __webpack_require__(3);
	
	var _extend3 = _interopRequireDefault(_extend2);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _align = __webpack_require__(36);
	
	var _background = __webpack_require__(37);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _color = __webpack_require__(26);
	
	var _direction = __webpack_require__(38);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:clipboard');
	
	var DOM_KEY = '__ql-matcher';
	
	var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];
	
	var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var Clipboard = function (_Module) {
	  _inherits(Clipboard, _Module);
	
	  function Clipboard(quill, options) {
	    _classCallCheck(this, Clipboard);
	
	    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
	
	    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
	    _this.container = _this.quill.addContainer('ql-clipboard');
	    _this.container.setAttribute('contenteditable', true);
	    _this.container.setAttribute('tabindex', -1);
	    _this.matchers = [];
	    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          selector = _ref2[0],
	          matcher = _ref2[1];
	
	      if (!options.matchVisual && matcher === matchSpacing) return;
	      _this.addMatcher(selector, matcher);
	    });
	    return _this;
	  }
	
	  _createClass(Clipboard, [{
	    key: 'addMatcher',
	    value: function addMatcher(selector, matcher) {
	      this.matchers.push([selector, matcher]);
	    }
	  }, {
	    key: 'convert',
	    value: function convert(html) {
	      if (typeof html === 'string') {
	        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
	        return this.convert();
	      }
	      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
	      if (formats[_code2.default.blotName]) {
	        var text = this.container.innerText;
	        this.container.innerHTML = '';
	        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
	      }
	
	      var _prepareMatching = this.prepareMatching(),
	          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
	          elementMatchers = _prepareMatching2[0],
	          textMatchers = _prepareMatching2[1];
	
	      var delta = traverse(this.container, elementMatchers, textMatchers);
	      // Remove trailing newline
	      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
	        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
	      }
	      debug.log('convert', this.container.innerHTML, delta);
	      this.container.innerHTML = '';
	      return delta;
	    }
	  }, {
	    key: 'dangerouslyPasteHTML',
	    value: function dangerouslyPasteHTML(index, html) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
	
	      if (typeof index === 'string') {
	        this.quill.setContents(this.convert(index), html);
	        this.quill.setSelection(0, _quill2.default.sources.SILENT);
	      } else {
	        var paste = this.convert(html);
	        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
	        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
	      }
	    }
	  }, {
	    key: 'onPaste',
	    value: function onPaste(e) {
	      var _this2 = this;
	
	      if (e.defaultPrevented || !this.quill.isEnabled()) return;
	      var range = this.quill.getSelection();
	      var delta = new _quillDelta2.default().retain(range.index);
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.container.focus();
	      this.quill.selection.update(_quill2.default.sources.SILENT);
	      setTimeout(function () {
	        delta = delta.concat(_this2.convert()).delete(range.length);
	        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
	        // range.length contributes to delta.length()
	        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
	        _this2.quill.scrollingContainer.scrollTop = scrollTop;
	        _this2.quill.focus();
	      }, 1);
	    }
	  }, {
	    key: 'prepareMatching',
	    value: function prepareMatching() {
	      var _this3 = this;
	
	      var elementMatchers = [],
	          textMatchers = [];
	      this.matchers.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            selector = _pair[0],
	            matcher = _pair[1];
	
	        switch (selector) {
	          case Node.TEXT_NODE:
	            textMatchers.push(matcher);
	            break;
	          case Node.ELEMENT_NODE:
	            elementMatchers.push(matcher);
	            break;
	          default:
	            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
	              // TODO use weakmap
	              node[DOM_KEY] = node[DOM_KEY] || [];
	              node[DOM_KEY].push(matcher);
	            });
	            break;
	        }
	      });
	      return [elementMatchers, textMatchers];
	    }
	  }]);
	
	  return Clipboard;
	}(_module2.default);
	
	Clipboard.DEFAULTS = {
	  matchers: [],
	  matchVisual: true
	};
	
	function applyFormat(delta, format, value) {
	  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
	    return Object.keys(format).reduce(function (delta, key) {
	      return applyFormat(delta, key, format[key]);
	    }, delta);
	  } else {
	    return delta.reduce(function (delta, op) {
	      if (op.attributes && op.attributes[format]) {
	        return delta.push(op);
	      } else {
	        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
	      }
	    }, new _quillDelta2.default());
	  }
	}
	
	function computeStyle(node) {
	  if (node.nodeType !== Node.ELEMENT_NODE) return {};
	  var DOM_KEY = '__ql-computed-style';
	  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
	}
	
	function deltaEndsWith(delta, text) {
	  var endText = "";
	  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
	    var op = delta.ops[i];
	    if (typeof op.insert !== 'string') break;
	    endText = op.insert + endText;
	  }
	  return endText.slice(-1 * text.length) === text;
	}
	
	function isLine(node) {
	  if (node.childNodes.length === 0) return false; // Exclude embed blocks
	  var style = computeStyle(node);
	  return ['block', 'list-item'].indexOf(style.display) > -1;
	}
	
	function traverse(node, elementMatchers, textMatchers) {
	  // Post-order
	  if (node.nodeType === node.TEXT_NODE) {
	    return textMatchers.reduce(function (delta, matcher) {
	      return matcher(node, delta);
	    }, new _quillDelta2.default());
	  } else if (node.nodeType === node.ELEMENT_NODE) {
	    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
	      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
	      if (childNode.nodeType === node.ELEMENT_NODE) {
	        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	      }
	      return delta.concat(childrenDelta);
	    }, new _quillDelta2.default());
	  } else {
	    return new _quillDelta2.default();
	  }
	}
	
	function matchAlias(format, node, delta) {
	  return applyFormat(delta, format, true);
	}
	
	function matchAttributor(node, delta) {
	  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
	  var classes = _parchment2.default.Attributor.Class.keys(node);
	  var styles = _parchment2.default.Attributor.Style.keys(node);
	  var formats = {};
	  attributes.concat(classes).concat(styles).forEach(function (name) {
	    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
	    if (attr != null) {
	      formats[attr.attrName] = attr.value(node);
	      if (formats[attr.attrName]) return;
	    }
	    attr = ATTRIBUTE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	    attr = STYLE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      attr = STYLE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	  });
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  return delta;
	}
	
	function matchBlot(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null) return delta;
	  if (match.prototype instanceof _parchment2.default.Embed) {
	    var embed = {};
	    var value = match.value(node);
	    if (value != null) {
	      embed[match.blotName] = value;
	      delta = new _quillDelta2.default().insert(embed, match.formats(node));
	    }
	  } else if (typeof match.formats === 'function') {
	    delta = applyFormat(delta, match.blotName, match.formats(node));
	  }
	  return delta;
	}
	
	function matchBreak(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}
	
	function matchIgnore() {
	  return new _quillDelta2.default();
	}
	
	function matchIndent(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
	    return delta;
	  }
	  var indent = -1,
	      parent = node.parentNode;
	  while (!parent.classList.contains('ql-clipboard')) {
	    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
	      indent += 1;
	    }
	    parent = parent.parentNode;
	  }
	  if (indent <= 0) return delta;
	  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
	}
	
	function matchNewline(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchSpacing(node, delta) {
	  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
	    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
	    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchStyles(node, delta) {
	  var formats = {};
	  var style = node.style || {};
	  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
	    formats.italic = true;
	  }
	  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
	    formats.bold = true;
	  }
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  if (parseFloat(style.textIndent || 0) > 0) {
	    // Could be 0.5in
	    delta = new _quillDelta2.default().insert('\t').concat(delta);
	  }
	  return delta;
	}
	
	function matchText(node, delta) {
	  var text = node.data;
	  // Word represents empty line with <o:p>&nbsp;</o:p>
	  if (node.parentNode.tagName === 'O:P') {
	    return delta.insert(text.trim());
	  }
	  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
	    return delta;
	  }
	  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
	    // eslint-disable-next-line func-style
	    var replacer = function replacer(collapse, match) {
	      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
	      return match.length < 1 && collapse ? ' ' : match;
	    };
	    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
	    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
	    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
	      text = text.replace(/^\s+/, replacer.bind(replacer, false));
	    }
	    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
	      text = text.replace(/\s+$/, replacer.bind(replacer, false));
	    }
	  }
	  return delta.insert(text);
	}
	
	exports.default = Clipboard;
	exports.matchAttributor = matchAttributor;
	exports.matchBlot = matchBlot;
	exports.matchNewline = matchNewline;
	exports.matchSpacing = matchSpacing;
	exports.matchText = matchText;
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bold = function (_Inline) {
	  _inherits(Bold, _Inline);
	
	  function Bold() {
	    _classCallCheck(this, Bold);
	
	    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
	  }
	
	  _createClass(Bold, [{
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
	      if (this.domNode.tagName !== this.statics.tagName[0]) {
	        this.replaceWith(this.statics.blotName);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return Bold;
	}(_inline2.default);
	
	Bold.blotName = 'bold';
	Bold.tagName = ['STRONG', 'B'];
	
	exports.default = Bold;
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addControls = exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:toolbar');
	
	var Toolbar = function (_Module) {
	  _inherits(Toolbar, _Module);
	
	  function Toolbar(quill, options) {
	    _classCallCheck(this, Toolbar);
	
	    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
	
	    if (Array.isArray(_this.options.container)) {
	      var container = document.createElement('div');
	      addControls(container, _this.options.container);
	      quill.container.parentNode.insertBefore(container, quill.container);
	      _this.container = container;
	    } else if (typeof _this.options.container === 'string') {
	      _this.container = document.querySelector(_this.options.container);
	    } else {
	      _this.container = _this.options.container;
	    }
	    if (!(_this.container instanceof HTMLElement)) {
	      var _ret;
	
	      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
	    }
	    _this.container.classList.add('ql-toolbar');
	    _this.controls = [];
	    _this.handlers = {};
	    Object.keys(_this.options.handlers).forEach(function (format) {
	      _this.addHandler(format, _this.options.handlers[format]);
	    });
	    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
	      _this.attach(input);
	    });
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
	      if (type === _quill2.default.events.SELECTION_CHANGE) {
	        _this.update(range);
	      }
	    });
	    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      var _this$quill$selection = _this.quill.selection.getRange(),
	          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
	          range = _this$quill$selection2[0]; // quill.getSelection triggers update
	
	
	      _this.update(range);
	    });
	    return _this;
	  }
	
	  _createClass(Toolbar, [{
	    key: 'addHandler',
	    value: function addHandler(format, handler) {
	      this.handlers[format] = handler;
	    }
	  }, {
	    key: 'attach',
	    value: function attach(input) {
	      var _this2 = this;
	
	      var format = [].find.call(input.classList, function (className) {
	        return className.indexOf('ql-') === 0;
	      });
	      if (!format) return;
	      format = format.slice('ql-'.length);
	      if (input.tagName === 'BUTTON') {
	        input.setAttribute('type', 'button');
	      }
	      if (this.handlers[format] == null) {
	        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
	          debug.warn('ignoring attaching to disabled format', format, input);
	          return;
	        }
	        if (_parchment2.default.query(format) == null) {
	          debug.warn('ignoring attaching to nonexistent format', format, input);
	          return;
	        }
	      }
	      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
	      input.addEventListener(eventName, function (e) {
	        var value = void 0;
	        if (input.tagName === 'SELECT') {
	          if (input.selectedIndex < 0) return;
	          var selected = input.options[input.selectedIndex];
	          if (selected.hasAttribute('selected')) {
	            value = false;
	          } else {
	            value = selected.value || false;
	          }
	        } else {
	          if (input.classList.contains('ql-active')) {
	            value = false;
	          } else {
	            value = input.value || !input.hasAttribute('value');
	          }
	          e.preventDefault();
	        }
	        _this2.quill.focus();
	
	        var _quill$selection$getR = _this2.quill.selection.getRange(),
	            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
	            range = _quill$selection$getR2[0];
	
	        if (_this2.handlers[format] != null) {
	          _this2.handlers[format].call(_this2, value);
	        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
	          value = prompt('Enter ' + format);
	          if (!value) return;
	          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
	        } else {
	          _this2.quill.format(format, value, _quill2.default.sources.USER);
	        }
	        _this2.update(range);
	      });
	      // TODO use weakmap
	      this.controls.push([format, input]);
	    }
	  }, {
	    key: 'update',
	    value: function update(range) {
	      var formats = range == null ? {} : this.quill.getFormat(range);
	      this.controls.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            format = _pair[0],
	            input = _pair[1];
	
	        if (input.tagName === 'SELECT') {
	          var option = void 0;
	          if (range == null) {
	            option = null;
	          } else if (formats[format] == null) {
	            option = input.querySelector('option[selected]');
	          } else if (!Array.isArray(formats[format])) {
	            var value = formats[format];
	            if (typeof value === 'string') {
	              value = value.replace(/\"/g, '\\"');
	            }
	            option = input.querySelector('option[value="' + value + '"]');
	          }
	          if (option == null) {
	            input.value = ''; // TODO make configurable?
	            input.selectedIndex = -1;
	          } else {
	            option.selected = true;
	          }
	        } else {
	          if (range == null) {
	            input.classList.remove('ql-active');
	          } else if (input.hasAttribute('value')) {
	            // both being null should match (default values)
	            // '1' should match with 1 (headers)
	            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
	            input.classList.toggle('ql-active', isActive);
	          } else {
	            input.classList.toggle('ql-active', formats[format] != null);
	          }
	        }
	      });
	    }
	  }]);
	
	  return Toolbar;
	}(_module2.default);
	
	Toolbar.DEFAULTS = {};
	
	function addButton(container, format, value) {
	  var input = document.createElement('button');
	  input.setAttribute('type', 'button');
	  input.classList.add('ql-' + format);
	  if (value != null) {
	    input.value = value;
	  }
	  container.appendChild(input);
	}
	
	function addControls(container, groups) {
	  if (!Array.isArray(groups[0])) {
	    groups = [groups];
	  }
	  groups.forEach(function (controls) {
	    var group = document.createElement('span');
	    group.classList.add('ql-formats');
	    controls.forEach(function (control) {
	      if (typeof control === 'string') {
	        addButton(group, control);
	      } else {
	        var format = Object.keys(control)[0];
	        var value = control[format];
	        if (Array.isArray(value)) {
	          addSelect(group, format, value);
	        } else {
	          addButton(group, format, value);
	        }
	      }
	    });
	    container.appendChild(group);
	  });
	}
	
	function addSelect(container, format, values) {
	  var input = document.createElement('select');
	  input.classList.add('ql-' + format);
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value !== false) {
	      option.setAttribute('value', value);
	    } else {
	      option.setAttribute('selected', 'selected');
	    }
	    input.appendChild(option);
	  });
	  container.appendChild(input);
	}
	
	Toolbar.DEFAULTS = {
	  container: null,
	  handlers: {
	    clean: function clean() {
	      var _this3 = this;
	
	      var range = this.quill.getSelection();
	      if (range == null) return;
	      if (range.length == 0) {
	        var formats = this.quill.getFormat();
	        Object.keys(formats).forEach(function (name) {
	          // Clean functionality in existing apps only clean inline formats
	          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
	            _this3.quill.format(name, false);
	          }
	        });
	      } else {
	        this.quill.removeFormat(range, _quill2.default.sources.USER);
	      }
	    },
	    direction: function direction(value) {
	      var align = this.quill.getFormat()['align'];
	      if (value === 'rtl' && align == null) {
	        this.quill.format('align', 'right', _quill2.default.sources.USER);
	      } else if (!value && align === 'right') {
	        this.quill.format('align', false, _quill2.default.sources.USER);
	      }
	      this.quill.format('direction', value, _quill2.default.sources.USER);
	    },
	    indent: function indent(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      var indent = parseInt(formats.indent || 0);
	      if (value === '+1' || value === '-1') {
	        var modifier = value === '+1' ? 1 : -1;
	        if (formats.direction === 'rtl') modifier *= -1;
	        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
	      }
	    },
	    link: function link(value) {
	      if (value === true) {
	        value = prompt('Enter link URL:');
	      }
	      this.quill.format('link', value, _quill2.default.sources.USER);
	    },
	    list: function list(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      if (value === 'check') {
	        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        } else {
	          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
	        }
	      } else {
	        this.quill.format('list', value, _quill2.default.sources.USER);
	      }
	    }
	  }
	};
	
	exports.default = Toolbar;
	exports.addControls = addControls;
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorPicker = function (_Picker) {
	  _inherits(ColorPicker, _Picker);
	
	  function ColorPicker(select, label) {
	    _classCallCheck(this, ColorPicker);
	
	    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
	
	    _this.label.innerHTML = label;
	    _this.container.classList.add('ql-color-picker');
	    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
	      item.classList.add('ql-primary');
	    });
	    return _this;
	  }
	
	  _createClass(ColorPicker, [{
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
	      item.style.backgroundColor = option.getAttribute('value') || '';
	      return item;
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      var colorLabel = this.label.querySelector('.ql-color-label');
	      var value = item ? item.getAttribute('data-value') || '' : '';
	      if (colorLabel) {
	        if (colorLabel.tagName === 'line') {
	          colorLabel.style.stroke = value;
	        } else {
	          colorLabel.style.fill = value;
	        }
	      }
	    }
	  }]);
	
	  return ColorPicker;
	}(_picker2.default);
	
	exports.default = ColorPicker;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconPicker = function (_Picker) {
	  _inherits(IconPicker, _Picker);
	
	  function IconPicker(select, icons) {
	    _classCallCheck(this, IconPicker);
	
	    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
	
	    _this.container.classList.add('ql-icon-picker');
	    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
	      item.innerHTML = icons[item.getAttribute('data-value') || ''];
	    });
	    _this.defaultItem = _this.container.querySelector('.ql-selected');
	    _this.selectItem(_this.defaultItem);
	    return _this;
	  }
	
	  _createClass(IconPicker, [{
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      item = item || this.defaultItem;
	      this.label.innerHTML = item.innerHTML;
	    }
	  }]);
	
	  return IconPicker;
	}(_picker2.default);
	
	exports.default = IconPicker;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tooltip = function () {
	  function Tooltip(quill, boundsContainer) {
	    var _this = this;
	
	    _classCallCheck(this, Tooltip);
	
	    this.quill = quill;
	    this.boundsContainer = boundsContainer || document.body;
	    this.root = quill.addContainer('ql-tooltip');
	    this.root.innerHTML = this.constructor.TEMPLATE;
	    if (this.quill.root === this.quill.scrollingContainer) {
	      this.quill.root.addEventListener('scroll', function () {
	        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
	      });
	    }
	    this.hide();
	  }
	
	  _createClass(Tooltip, [{
	    key: 'hide',
	    value: function hide() {
	      this.root.classList.add('ql-hidden');
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
	      // root.scrollTop should be 0 if scrollContainer !== root
	      var top = reference.bottom + this.quill.root.scrollTop;
	      this.root.style.left = left + 'px';
	      this.root.style.top = top + 'px';
	      this.root.classList.remove('ql-flip');
	      var containerBounds = this.boundsContainer.getBoundingClientRect();
	      var rootBounds = this.root.getBoundingClientRect();
	      var shift = 0;
	      if (rootBounds.right > containerBounds.right) {
	        shift = containerBounds.right - rootBounds.right;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.left < containerBounds.left) {
	        shift = containerBounds.left - rootBounds.left;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.bottom > containerBounds.bottom) {
	        var height = rootBounds.bottom - rootBounds.top;
	        var verticalShift = reference.bottom - reference.top + height;
	        this.root.style.top = top - verticalShift + 'px';
	        this.root.classList.add('ql-flip');
	      }
	      return shift;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.root.classList.remove('ql-editing');
	      this.root.classList.remove('ql-hidden');
	    }
	  }]);
	
	  return Tooltip;
	}();
	
	exports.default = Tooltip;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];
	
	var SnowTheme = function (_BaseTheme) {
	  _inherits(SnowTheme, _BaseTheme);
	
	  function SnowTheme(quill, options) {
	    _classCallCheck(this, SnowTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-snow');
	    return _this;
	  }
	
	  _createClass(SnowTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      toolbar.container.classList.add('ql-snow');
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
	      if (toolbar.container.querySelector('.ql-link')) {
	        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
	          toolbar.handlers['link'].call(toolbar, !context.format.link);
	        });
	      }
	    }
	  }]);
	
	  return SnowTheme;
	}(_base2.default);
	
	SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (value) {
	            var range = this.quill.getSelection();
	            if (range == null || range.length == 0) return;
	            var preview = this.quill.getText(range);
	            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
	              preview = 'mailto:' + preview;
	            }
	            var tooltip = this.quill.theme.tooltip;
	            tooltip.edit('link', preview);
	          } else {
	            this.quill.format('link', false);
	          }
	        }
	      }
	    }
	  }
	});
	
	var SnowTooltip = function (_BaseTooltip) {
	  _inherits(SnowTooltip, _BaseTooltip);
	
	  function SnowTooltip(quill, bounds) {
	    _classCallCheck(this, SnowTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
	
	    _this2.preview = _this2.root.querySelector('a.ql-preview');
	    return _this2;
	  }
	
	  _createClass(SnowTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
	        if (_this3.root.classList.contains('ql-editing')) {
	          _this3.save();
	        } else {
	          _this3.edit('link', _this3.preview.textContent);
	        }
	        event.preventDefault();
	      });
	      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
	        if (_this3.linkRange != null) {
	          var range = _this3.linkRange;
	          _this3.restoreFocus();
	          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
	          delete _this3.linkRange;
	        }
	        event.preventDefault();
	        _this3.hide();
	      });
	      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
	        if (range == null) return;
	        if (range.length === 0 && source === _emitter2.default.sources.USER) {
	          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
	              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	              link = _quill$scroll$descend2[0],
	              offset = _quill$scroll$descend2[1];
	
	          if (link != null) {
	            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
	            var preview = _link2.default.formats(link.domNode);
	            _this3.preview.textContent = preview;
	            _this3.preview.setAttribute('href', preview);
	            _this3.show();
	            _this3.position(_this3.quill.getBounds(_this3.linkRange));
	            return;
	          }
	        } else {
	          delete _this3.linkRange;
	        }
	        _this3.hide();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
	      this.root.removeAttribute('data-mode');
	    }
	  }]);
	
	  return SnowTooltip;
	}(_base.BaseTooltip);
	
	SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');
	
	exports.default = SnowTheme;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(29);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _align = __webpack_require__(36);
	
	var _direction = __webpack_require__(38);
	
	var _indent = __webpack_require__(64);
	
	var _blockquote = __webpack_require__(65);
	
	var _blockquote2 = _interopRequireDefault(_blockquote);
	
	var _header = __webpack_require__(66);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _list = __webpack_require__(67);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _background = __webpack_require__(37);
	
	var _color = __webpack_require__(26);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	var _italic = __webpack_require__(68);
	
	var _italic2 = _interopRequireDefault(_italic);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _script = __webpack_require__(69);
	
	var _script2 = _interopRequireDefault(_script);
	
	var _strike = __webpack_require__(70);
	
	var _strike2 = _interopRequireDefault(_strike);
	
	var _underline = __webpack_require__(71);
	
	var _underline2 = _interopRequireDefault(_underline);
	
	var _image = __webpack_require__(72);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _video = __webpack_require__(73);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _formula = __webpack_require__(74);
	
	var _formula2 = _interopRequireDefault(_formula);
	
	var _syntax = __webpack_require__(75);
	
	var _syntax2 = _interopRequireDefault(_syntax);
	
	var _toolbar = __webpack_require__(57);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _bubble = __webpack_require__(108);
	
	var _bubble2 = _interopRequireDefault(_bubble);
	
	var _snow = __webpack_require__(62);
	
	var _snow2 = _interopRequireDefault(_snow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_core2.default.register({
	  'attributors/attribute/direction': _direction.DirectionAttribute,
	
	  'attributors/class/align': _align.AlignClass,
	  'attributors/class/background': _background.BackgroundClass,
	  'attributors/class/color': _color.ColorClass,
	  'attributors/class/direction': _direction.DirectionClass,
	  'attributors/class/font': _font.FontClass,
	  'attributors/class/size': _size.SizeClass,
	
	  'attributors/style/align': _align.AlignStyle,
	  'attributors/style/background': _background.BackgroundStyle,
	  'attributors/style/color': _color.ColorStyle,
	  'attributors/style/direction': _direction.DirectionStyle,
	  'attributors/style/font': _font.FontStyle,
	  'attributors/style/size': _size.SizeStyle
	}, true);
	
	_core2.default.register({
	  'formats/align': _align.AlignClass,
	  'formats/direction': _direction.DirectionClass,
	  'formats/indent': _indent.IndentClass,
	
	  'formats/background': _background.BackgroundStyle,
	  'formats/color': _color.ColorStyle,
	  'formats/font': _font.FontClass,
	  'formats/size': _size.SizeClass,
	
	  'formats/blockquote': _blockquote2.default,
	  'formats/code-block': _code2.default,
	  'formats/header': _header2.default,
	  'formats/list': _list2.default,
	
	  'formats/bold': _bold2.default,
	  'formats/code': _code.Code,
	  'formats/italic': _italic2.default,
	  'formats/link': _link2.default,
	  'formats/script': _script2.default,
	  'formats/strike': _strike2.default,
	  'formats/underline': _underline2.default,
	
	  'formats/image': _image2.default,
	  'formats/video': _video2.default,
	
	  'formats/list/item': _list.ListItem,
	
	  'modules/formula': _formula2.default,
	  'modules/syntax': _syntax2.default,
	  'modules/toolbar': _toolbar2.default,
	
	  'themes/bubble': _bubble2.default,
	  'themes/snow': _snow2.default,
	
	  'ui/icons': _icons2.default,
	  'ui/picker': _picker2.default,
	  'ui/icon-picker': _iconPicker2.default,
	  'ui/color-picker': _colorPicker2.default,
	  'ui/tooltip': _tooltip2.default
	}, true);
	
	exports.default = _core2.default;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndentClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdentAttributor = function (_Parchment$Attributor) {
	  _inherits(IdentAttributor, _Parchment$Attributor);
	
	  function IdentAttributor() {
	    _classCallCheck(this, IdentAttributor);
	
	    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
	  }
	
	  _createClass(IdentAttributor, [{
	    key: 'add',
	    value: function add(node, value) {
	      if (value === '+1' || value === '-1') {
	        var indent = this.value(node) || 0;
	        value = value === '+1' ? indent + 1 : indent - 1;
	      }
	      if (value === 0) {
	        this.remove(node);
	        return true;
	      } else {
	        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
	      }
	    }
	  }, {
	    key: 'canAdd',
	    value: function canAdd(node, value) {
	      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
	    }
	  }, {
	    key: 'value',
	    value: function value(node) {
	      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
	    }
	  }]);
	
	  return IdentAttributor;
	}(_parchment2.default.Attributor.Class);
	
	var IndentClass = new IdentAttributor('indent', 'ql-indent', {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
	});
	
	exports.IndentClass = IndentClass;
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Blockquote = function (_Block) {
	  _inherits(Blockquote, _Block);
	
	  function Blockquote() {
	    _classCallCheck(this, Blockquote);
	
	    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
	  }
	
	  return Blockquote;
	}(_block2.default);
	
	Blockquote.blotName = 'blockquote';
	Blockquote.tagName = 'blockquote';
	
	exports.default = Blockquote;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Block) {
	  _inherits(Header, _Block);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, null, [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return this.tagName.indexOf(domNode.tagName) + 1;
	    }
	  }]);
	
	  return Header;
	}(_block2.default);
	
	Header.blotName = 'header';
	Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
	
	exports.default = Header;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_Block) {
	  _inherits(ListItem, _Block);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name === List.blotName && !value) {
	        this.replaceWith(_parchment2.default.create(this.statics.scope));
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.prev == null && this.next == null) {
	        this.parent.remove();
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
	      }
	    }
	  }, {
	    key: 'replaceWith',
	    value: function replaceWith(name, value) {
	      this.parent.isolate(this.offset(this.parent), this.length());
	      if (name === this.parent.statics.blotName) {
	        this.parent.replaceWith(name, value);
	        return this;
	      } else {
	        this.parent.unwrap();
	        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
	    }
	  }]);
	
	  return ListItem;
	}(_block2.default);
	
	ListItem.blotName = 'list-item';
	ListItem.tagName = 'LI';
	
	var List = function (_Container) {
	  _inherits(List, _Container);
	
	  _createClass(List, null, [{
	    key: 'create',
	    value: function create(value) {
	      var tagName = value === 'ordered' ? 'OL' : 'UL';
	      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
	      if (value === 'checked' || value === 'unchecked') {
	        node.setAttribute('data-checked', value === 'checked');
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'OL') return 'ordered';
	      if (domNode.tagName === 'UL') {
	        if (domNode.hasAttribute('data-checked')) {
	          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
	        } else {
	          return 'bullet';
	        }
	      }
	      return undefined;
	    }
	  }]);
	
	  function List(domNode) {
	    _classCallCheck(this, List);
	
	    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
	
	    var listEventHandler = function listEventHandler(e) {
	      if (e.target.parentNode !== domNode) return;
	      var format = _this2.statics.formats(domNode);
	      var blot = _parchment2.default.find(e.target);
	      if (format === 'checked') {
	        blot.format('list', 'unchecked');
	      } else if (format === 'unchecked') {
	        blot.format('list', 'checked');
	      }
	    };
	
	    domNode.addEventListener('touchstart', listEventHandler);
	    domNode.addEventListener('mousedown', listEventHandler);
	    return _this2;
	  }
	
	  _createClass(List, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (this.children.length > 0) {
	        this.children.tail.format(name, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      // We don't inherit from FormatBlot
	      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot instanceof ListItem) {
	        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
	      } else {
	        var index = ref == null ? this.length() : ref.offset(this);
	        var after = this.split(index);
	        after.parent.insertBefore(blot, after);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      if (target.statics.blotName !== this.statics.blotName) {
	        var item = _parchment2.default.create(this.statics.defaultChild);
	        target.moveChildren(item);
	        this.appendChild(item);
	      }
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
	    }
	  }]);
	
	  return List;
	}(_container2.default);
	
	List.blotName = 'list';
	List.scope = _parchment2.default.Scope.BLOCK_BLOT;
	List.tagName = ['OL', 'UL'];
	List.defaultChild = 'list-item';
	List.allowedChildren = [ListItem];
	
	exports.ListItem = ListItem;
	exports.default = List;
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Italic = function (_Bold) {
	  _inherits(Italic, _Bold);
	
	  function Italic() {
	    _classCallCheck(this, Italic);
	
	    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
	  }
	
	  return Italic;
	}(_bold2.default);
	
	Italic.blotName = 'italic';
	Italic.tagName = ['EM', 'I'];
	
	exports.default = Italic;
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Script = function (_Inline) {
	  _inherits(Script, _Inline);
	
	  function Script() {
	    _classCallCheck(this, Script);
	
	    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
	  }
	
	  _createClass(Script, null, [{
	    key: 'create',
	    value: function create(value) {
	      if (value === 'super') {
	        return document.createElement('sup');
	      } else if (value === 'sub') {
	        return document.createElement('sub');
	      } else {
	        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'SUB') return 'sub';
	      if (domNode.tagName === 'SUP') return 'super';
	      return undefined;
	    }
	  }]);
	
	  return Script;
	}(_inline2.default);
	
	Script.blotName = 'script';
	Script.tagName = ['SUB', 'SUP'];
	
	exports.default = Script;
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Strike = function (_Inline) {
	  _inherits(Strike, _Inline);
	
	  function Strike() {
	    _classCallCheck(this, Strike);
	
	    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
	  }
	
	  return Strike;
	}(_inline2.default);
	
	Strike.blotName = 'strike';
	Strike.tagName = 'S';
	
	exports.default = Strike;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Underline = function (_Inline) {
	  _inherits(Underline, _Inline);
	
	  function Underline() {
	    _classCallCheck(this, Underline);
	
	    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
	  }
	
	  return Underline;
	}(_inline2.default);
	
	Underline.blotName = 'underline';
	Underline.tagName = 'U';
	
	exports.default = Underline;
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _link = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['alt', 'height', 'width'];
	
	var Image = function (_Parchment$Embed) {
	  _inherits(Image, _Parchment$Embed);
	
	  function Image() {
	    _classCallCheck(this, Image);
	
	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }
	
	  _createClass(Image, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        node.setAttribute('src', this.sanitize(value));
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'match',
	    value: function match(url) {
	      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
	      );
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Image;
	}(_parchment2.default.Embed);
	
	Image.blotName = 'image';
	Image.tagName = 'IMG';
	
	exports.default = Image;
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _block = __webpack_require__(4);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['height', 'width'];
	
	var Video = function (_BlockEmbed) {
	  _inherits(Video, _BlockEmbed);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }
	
	  _createClass(Video, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
	      node.setAttribute('frameborder', '0');
	      node.setAttribute('allowfullscreen', true);
	      node.setAttribute('src', this.sanitize(value));
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _link2.default.sanitize(url);
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Video;
	}(_block.BlockEmbed);
	
	Video.blotName = 'video';
	Video.className = 'ql-video';
	Video.tagName = 'IFRAME';
	
	exports.default = Video;
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.FormulaBlot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormulaBlot = function (_Embed) {
	  _inherits(FormulaBlot, _Embed);
	
	  function FormulaBlot() {
	    _classCallCheck(this, FormulaBlot);
	
	    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
	  }
	
	  _createClass(FormulaBlot, null, [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        window.katex.render(value, node, {
	          throwOnError: false,
	          errorColor: '#f00'
	        });
	        node.setAttribute('data-value', value);
	      }
	      return node;
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('data-value');
	    }
	  }]);
	
	  return FormulaBlot;
	}(_embed2.default);
	
	FormulaBlot.blotName = 'formula';
	FormulaBlot.className = 'ql-formula';
	FormulaBlot.tagName = 'SPAN';
	
	var Formula = function (_Module) {
	  _inherits(Formula, _Module);
	
	  _createClass(Formula, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(FormulaBlot, true);
	    }
	  }]);
	
	  function Formula() {
	    _classCallCheck(this, Formula);
	
	    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
	
	    if (window.katex == null) {
	      throw new Error('Formula module requires KaTeX.');
	    }
	    return _this2;
	  }
	
	  return Formula;
	}(_module2.default);
	
	exports.FormulaBlot = FormulaBlot;
	exports.default = Formula;
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CodeToken = exports.CodeBlock = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SyntaxCodeBlock = function (_CodeBlock) {
	  _inherits(SyntaxCodeBlock, _CodeBlock);
	
	  function SyntaxCodeBlock() {
	    _classCallCheck(this, SyntaxCodeBlock);
	
	    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(SyntaxCodeBlock, [{
	    key: 'replaceWith',
	    value: function replaceWith(block) {
	      this.domNode.textContent = this.domNode.textContent;
	      this.attach();
	      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(_highlight) {
	      var text = this.domNode.textContent;
	      if (this.cachedText !== text) {
	        if (text.trim().length > 0 || this.cachedText == null) {
	          this.domNode.innerHTML = _highlight(text);
	          this.domNode.normalize();
	          this.attach();
	        }
	        this.cachedText = text;
	      }
	    }
	  }]);
	
	  return SyntaxCodeBlock;
	}(_code2.default);
	
	SyntaxCodeBlock.className = 'ql-syntax';
	
	var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	var Syntax = function (_Module) {
	  _inherits(Syntax, _Module);
	
	  _createClass(Syntax, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(CodeToken, true);
	      _quill2.default.register(SyntaxCodeBlock, true);
	    }
	  }]);
	
	  function Syntax(quill, options) {
	    _classCallCheck(this, Syntax);
	
	    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
	
	    if (typeof _this2.options.highlight !== 'function') {
	      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
	    }
	    var timer = null;
	    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      clearTimeout(timer);
	      timer = setTimeout(function () {
	        _this2.highlight();
	        timer = null;
	      }, _this2.options.interval);
	    });
	    _this2.highlight();
	    return _this2;
	  }
	
	  _createClass(Syntax, [{
	    key: 'highlight',
	    value: function highlight() {
	      var _this3 = this;
	
	      if (this.quill.selection.composing) return;
	      this.quill.update(_quill2.default.sources.USER);
	      var range = this.quill.getSelection();
	      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
	        code.highlight(_this3.options.highlight);
	      });
	      this.quill.update(_quill2.default.sources.SILENT);
	      if (range != null) {
	        this.quill.setSelection(range, _quill2.default.sources.SILENT);
	      }
	    }
	  }]);
	
	  return Syntax;
	}(_module2.default);
	
	Syntax.DEFAULTS = {
	  highlight: function () {
	    if (window.hljs == null) return null;
	    return function (text) {
	      var result = window.hljs.highlightAuto(text);
	      return result.value;
	    };
	  }(),
	  interval: 1000
	};
	
	exports.CodeBlock = SyntaxCodeBlock;
	exports.CodeToken = CodeToken;
	exports.default = Syntax;
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BubbleTooltip = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];
	
	var BubbleTheme = function (_BaseTheme) {
	  _inherits(BubbleTheme, _BaseTheme);
	
	  function BubbleTheme(quill, options) {
	    _classCallCheck(this, BubbleTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-bubble');
	    return _this;
	  }
	
	  _createClass(BubbleTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
	      this.tooltip.root.appendChild(toolbar.container);
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	    }
	  }]);
	
	  return BubbleTheme;
	}(_base2.default);
	
	BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (!value) {
	            this.quill.format('link', false);
	          } else {
	            this.quill.theme.tooltip.edit();
	          }
	        }
	      }
	    }
	  }
	});
	
	var BubbleTooltip = function (_BaseTooltip) {
	  _inherits(BubbleTooltip, _BaseTooltip);
	
	  function BubbleTooltip(quill, bounds) {
	    _classCallCheck(this, BubbleTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
	
	    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
	      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
	      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
	        _this2.show();
	        // Lock our width so we will expand beyond our offsetParent boundaries
	        _this2.root.style.left = '0px';
	        _this2.root.style.width = '';
	        _this2.root.style.width = _this2.root.offsetWidth + 'px';
	        var lines = _this2.quill.getLines(range.index, range.length);
	        if (lines.length === 1) {
	          _this2.position(_this2.quill.getBounds(range));
	        } else {
	          var lastLine = lines[lines.length - 1];
	          var index = _this2.quill.getIndex(lastLine);
	          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
	          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
	          _this2.position(_bounds);
	        }
	      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
	        _this2.hide();
	      }
	    });
	    return _this2;
	  }
	
	  _createClass(BubbleTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('.ql-close').addEventListener('click', function () {
	        _this3.root.classList.remove('ql-editing');
	      });
	      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
	        // Let selection be restored by toolbar handlers before repositioning
	        setTimeout(function () {
	          if (_this3.root.classList.contains('ql-hidden')) return;
	          var range = _this3.quill.getSelection();
	          if (range != null) {
	            _this3.position(_this3.quill.getBounds(range));
	          }
	        }, 1);
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.show();
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
	      var arrow = this.root.querySelector('.ql-tooltip-arrow');
	      arrow.style.marginLeft = '';
	      if (shift === 0) return shift;
	      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
	    }
	  }]);
	
	  return BubbleTooltip;
	}(_base.BaseTooltip);
	
	BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');
	
	exports.BubbleTooltip = BubbleTooltip;
	exports.default = BubbleTheme;
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(63);
	
	
	/***/ })
	/******/ ])["default"];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(957).Buffer))

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1038)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 537 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Track = function Track(_ref) {
	  var className = _ref.className,
	      included = _ref.included,
	      vertical = _ref.vertical,
	      offset = _ref.offset,
	      length = _ref.length,
	      minimumTrackTintColor = _ref.minimumTrackTintColor,
	      disabled = _ref.disabled;
	
	  var style = {
	    visibility: included ? 'visible' : 'hidden'
	  };
	  if (vertical) {
	    style.bottom = offset + '%';
	    style.height = length + '%';
	  } else {
	    style.left = offset + '%';
	    style.width = length + '%';
	  }
	  if (minimumTrackTintColor && !disabled) {
	    style.backgroundColor = minimumTrackTintColor;
	  }
	  return _react2["default"].createElement('div', { className: className, style: style });
	};
	
	exports["default"] = Track;
	module.exports = exports['default'];

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(82);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports["default"] = createSlider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _addEventListener = __webpack_require__(252);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Steps = __webpack_require__(1058);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Marks = __webpack_require__(1057);
	
	var _Marks2 = _interopRequireDefault(_Marks);
	
	var _Handle = __webpack_require__(250);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _utils = __webpack_require__(251);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function noop() {}
	
	function createSlider(Component) {
	  var _class, _temp;
	
	  return _temp = _class = function (_Component) {
	    (0, _inherits3["default"])(ComponentEnhancer, _Component);
	
	    function ComponentEnhancer(props) {
	      (0, _classCallCheck3["default"])(this, ComponentEnhancer);
	
	      var _this = (0, _possibleConstructorReturn3["default"])(this, _Component.call(this, props));
	
	      _this.onMouseDown = function (e) {
	        if (e.button !== 0) {
	          return;
	        }
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getMousePosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.onStart(position);
	        _this.addDocumentMouseEvents();
	        utils.pauseEvent(e);
	      };
	
	      _this.onTouchStart = function (e) {
	        if (utils.isNotTouchEvent(e)) return;
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getTouchPosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.onStart(position);
	        _this.addDocumentTouchEvents();
	        utils.pauseEvent(e);
	      };
	
	      _this.onMouseMove = function (e) {
	        if (!_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	        var position = utils.getMousePosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.onTouchMove = function (e) {
	        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	
	        var position = utils.getTouchPosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.saveSlider = function (slider) {
	        _this.sliderRef = slider;
	      };
	
	      if (false) {
	        var step = props.step,
	            max = props.max,
	            min = props.min;
	
	        (0, _warning2["default"])(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
	      }
	
	      _this.handlesRefs = {};
	      return _this;
	    }
	
	    ComponentEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (_Component.prototype.componentWillUnmount) _Component.prototype.componentWillUnmount.call(this);
	      this.removeDocumentEvents();
	    };
	
	    ComponentEnhancer.prototype.addDocumentTouchEvents = function addDocumentTouchEvents() {
	      // just work for Chrome iOS Safari and Android Browser
	      this.onTouchMoveListener = (0, _addEventListener2["default"])(document, 'touchmove', this.onTouchMove);
	      this.onTouchUpListener = (0, _addEventListener2["default"])(document, 'touchend', this.onEnd);
	    };
	
	    ComponentEnhancer.prototype.addDocumentMouseEvents = function addDocumentMouseEvents() {
	      this.onMouseMoveListener = (0, _addEventListener2["default"])(document, 'mousemove', this.onMouseMove);
	      this.onMouseUpListener = (0, _addEventListener2["default"])(document, 'mouseup', this.onEnd);
	    };
	
	    ComponentEnhancer.prototype.removeDocumentEvents = function removeDocumentEvents() {
	      /* eslint-disable no-unused-expressions */
	      this.onTouchMoveListener && this.onTouchMoveListener.remove();
	      this.onTouchUpListener && this.onTouchUpListener.remove();
	
	      this.onMouseMoveListener && this.onMouseMoveListener.remove();
	      this.onMouseUpListener && this.onMouseUpListener.remove();
	      /* eslint-enable no-unused-expressions */
	    };
	
	    ComponentEnhancer.prototype.getSliderStart = function getSliderStart() {
	      var slider = this.sliderRef;
	      var rect = slider.getBoundingClientRect();
	
	      return this.props.vertical ? rect.top : rect.left;
	    };
	
	    ComponentEnhancer.prototype.getSliderLength = function getSliderLength() {
	      var slider = this.sliderRef;
	      if (!slider) {
	        return 0;
	      }
	
	      return this.props.vertical ? slider.clientHeight : slider.clientWidth;
	    };
	
	    ComponentEnhancer.prototype.calcValue = function calcValue(offset) {
	      var _props = this.props,
	          vertical = _props.vertical,
	          min = _props.min,
	          max = _props.max;
	
	      var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
	      var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
	      return value;
	    };
	
	    ComponentEnhancer.prototype.calcValueByPos = function calcValueByPos(position) {
	      var pixelOffset = position - this.getSliderStart();
	      var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
	      return nextValue;
	    };
	
	    ComponentEnhancer.prototype.calcOffset = function calcOffset(value) {
	      var _props2 = this.props,
	          min = _props2.min,
	          max = _props2.max;
	
	      var ratio = (value - min) / (max - min);
	      return ratio * 100;
	    };
	
	    ComponentEnhancer.prototype.saveHandle = function saveHandle(index, handle) {
	      this.handlesRefs[index] = handle;
	    };
	
	    ComponentEnhancer.prototype.render = function render() {
	      var _classNames;
	
	      var _props3 = this.props,
	          prefixCls = _props3.prefixCls,
	          className = _props3.className,
	          marks = _props3.marks,
	          dots = _props3.dots,
	          step = _props3.step,
	          included = _props3.included,
	          disabled = _props3.disabled,
	          vertical = _props3.vertical,
	          min = _props3.min,
	          max = _props3.max,
	          children = _props3.children,
	          maximumTrackTintColor = _props3.maximumTrackTintColor,
	          style = _props3.style;
	
	      var _Component$prototype$ = _Component.prototype.render.call(this),
	          tracks = _Component$prototype$.tracks,
	          handles = _Component$prototype$.handles;
	
	      var sliderClassName = (0, _classnames2["default"])((_classNames = {}, (0, _defineProperty3["default"])(_classNames, prefixCls, true), (0, _defineProperty3["default"])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3["default"])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3["default"])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3["default"])(_classNames, className, className), _classNames));
	
	      var trackStyle = maximumTrackTintColor && !disabled ? {
	        backgroundColor: maximumTrackTintColor
	      } : {};
	
	      return _react2["default"].createElement(
	        'div',
	        {
	          ref: this.saveSlider,
	          className: sliderClassName,
	          onTouchStart: disabled ? noop : this.onTouchStart,
	          onMouseDown: disabled ? noop : this.onMouseDown,
	          style: style
	        },
	        _react2["default"].createElement('div', { className: prefixCls + '-rail', style: trackStyle }),
	        tracks,
	        _react2["default"].createElement(_Steps2["default"], {
	          prefixCls: prefixCls,
	          vertical: vertical,
	          marks: marks,
	          dots: dots,
	          step: step,
	          included: included,
	          lowerBound: this.getLowerBound(),
	          upperBound: this.getUpperBound(),
	          max: max,
	          min: min
	        }),
	        handles,
	        _react2["default"].createElement(_Marks2["default"], {
	          className: prefixCls + '-mark',
	          vertical: vertical,
	          marks: marks,
	          included: included,
	          lowerBound: this.getLowerBound(),
	          upperBound: this.getUpperBound(),
	          max: max,
	          min: min
	        }),
	        children
	      );
	    };
	
	    return ComponentEnhancer;
	  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3["default"])({}, Component.propTypes, {
	    min: _react.PropTypes.number,
	    max: _react.PropTypes.number,
	    step: _react.PropTypes.number,
	    marks: _react.PropTypes.object,
	    included: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    prefixCls: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    children: _react.PropTypes.any,
	    onBeforeChange: _react.PropTypes.func,
	    onChange: _react.PropTypes.func,
	    onAfterChange: _react.PropTypes.func,
	    handle: _react.PropTypes.func,
	    dots: _react.PropTypes.bool,
	    vertical: _react.PropTypes.bool,
	    style: _react.PropTypes.object,
	    maximumTrackTintColor: _react.PropTypes.string
	  }), _class.defaultProps = (0, _extends3["default"])({}, Component.defaultProps, {
	    prefixCls: 'rc-slider',
	    className: '',
	    min: 0,
	    max: 100,
	    step: 1,
	    marks: {},
	    handle: function handle(_ref) {
	      var index = _ref.index,
	          restProps = (0, _objectWithoutProperties3["default"])(_ref, ['index']);
	
	      delete restProps.dragging;
	      delete restProps.value;
	      return _react2["default"].createElement(_Handle2["default"], (0, _extends3["default"])({}, restProps, { key: index }));
	    },
	
	    onBeforeChange: noop,
	    onChange: noop,
	    onAfterChange: noop,
	    included: true,
	    disabled: false,
	    dots: false,
	    vertical: false
	  }), _temp;
	}
	module.exports = exports['default'];

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(82);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_Component) {
	  (0, _inherits3['default'])(LazyRenderBox, _Component);
	
	  function LazyRenderBox() {
	    (0, _classCallCheck3['default'])(this, LazyRenderBox);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  };
	
	  LazyRenderBox.prototype.render = function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2['default'].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2['default'].createElement('div', props);
	    }
	
	    return _react2['default'].Children.only(props.children);
	  };
	
	  return LazyRenderBox;
	}(_react.Component);
	
	LazyRenderBox.propTypes = {
	  children: _propTypes2['default'].any,
	  className: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool,
	  hiddenClassName: _propTypes2['default'].string
	};
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getAlignPopupClassName = getAlignPopupClassName;
	exports.saveRef = saveRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isPointsEq(a1, a2, isAlignPoint) {
	  if (isAlignPoint) {
	    return a1[0] === a2[0];
	  }
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3['default'])({}, baseAlign, align);
	}
	
	function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}
	
	function saveRef(name, component) {
	  this[name] = component;
	}

/***/ },
/* 542 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	function contains(root, n) {
	  var node = n;
	
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	
	    node = node.parentNode;
	  }
	
	  return false;
	}

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Subscriber = exports.Broadcast = undefined;
	
	var _Broadcast2 = __webpack_require__(1071);
	
	var _Broadcast3 = _interopRequireDefault(_Broadcast2);
	
	var _Subscriber2 = __webpack_require__(1072);
	
	var _Subscriber3 = _interopRequireDefault(_Subscriber2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Broadcast = _Broadcast3.default;
	exports.Subscriber = _Subscriber3.default;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__(1));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ },
/* 545 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(86);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(114);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactInstrumentation = __webpack_require__(44);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1133);
	var warning = __webpack_require__(14);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 548 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(269);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var LinkedValueUtils = __webpack_require__(258);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactUpdates = __webpack_require__(51);
	
	var warning = __webpack_require__(14);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var ReactUpdates = __webpack_require__(51);
	var Transaction = __webpack_require__(166);
	
	var emptyFunction = __webpack_require__(38);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1074);
	var BeforeInputEventPlugin = __webpack_require__(1076);
	var ChangeEventPlugin = __webpack_require__(1078);
	var DefaultEventPluginOrder = __webpack_require__(1080);
	var EnterLeaveEventPlugin = __webpack_require__(1081);
	var HTMLDOMPropertyConfig = __webpack_require__(1083);
	var ReactComponentBrowserEnvironment = __webpack_require__(1085);
	var ReactDOMComponent = __webpack_require__(1088);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactDOMEmptyComponent = __webpack_require__(1089);
	var ReactDOMTreeTraversal = __webpack_require__(1098);
	var ReactDOMTextComponent = __webpack_require__(1096);
	var ReactDefaultBatchingStrategy = __webpack_require__(551);
	var ReactEventListener = __webpack_require__(1101);
	var ReactInjection = __webpack_require__(1102);
	var ReactReconcileTransaction = __webpack_require__(1106);
	var SVGDOMPropertyConfig = __webpack_require__(1111);
	var SelectEventPlugin = __webpack_require__(1112);
	var SimpleEventPlugin = __webpack_require__(1113);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 553 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 554 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(17);
	
	var invariant = __webpack_require__(10);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1094);
	
	var containsNode = __webpack_require__(983);
	var focusNode = __webpack_require__(407);
	var getActiveElement = __webpack_require__(408);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1124);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var DOMLazyTree = __webpack_require__(113);
	var DOMProperty = __webpack_require__(114);
	var React = __webpack_require__(91);
	var ReactBrowserEventEmitter = __webpack_require__(164);
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactDOMContainerInfo = __webpack_require__(549);
	var ReactDOMFeatureFlags = __webpack_require__(1090);
	var ReactFeatureFlags = __webpack_require__(554);
	var ReactInstanceMap = __webpack_require__(128);
	var ReactInstrumentation = __webpack_require__(44);
	var ReactMarkupChecksum = __webpack_require__(557);
	var ReactReconciler = __webpack_require__(87);
	var ReactUpdateQueue = __webpack_require__(261);
	var ReactUpdates = __webpack_require__(51);
	
	var emptyObject = __webpack_require__(85);
	var instantiateReactComponent = __webpack_require__(266);
	var invariant = __webpack_require__(10);
	var setInnerHTML = __webpack_require__(168);
	var shouldUpdateReactComponent = __webpack_require__(268);
	var warning = __webpack_require__(14);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var React = __webpack_require__(91);
	
	var invariant = __webpack_require__(10);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var PooledClass = __webpack_require__(86);
	var Transaction = __webpack_require__(166);
	var ReactInstrumentation = __webpack_require__(44);
	var ReactServerUpdateQueue = __webpack_require__(1110);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 561 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.4.1';

/***/ },
/* 562 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 564 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(559);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 567 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	var escapeTextContentForBrowser = __webpack_require__(167);
	var setInnerHTML = __webpack_require__(168);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var REACT_ELEMENT_TYPE = __webpack_require__(1099);
	
	var getIteratorFn = __webpack_require__(1129);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(257);
	var warning = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = FeatureFlag;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBroadcast = __webpack_require__(543);
	
	var _LaunchDarkly = __webpack_require__(571);
	
	var _FeatureFlagRenderer = __webpack_require__(1137);
	
	var _FeatureFlagRenderer2 = _interopRequireDefault(_FeatureFlagRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeatureFlag(props) {
	  return _react2.default.createElement(
	    _reactBroadcast.Subscriber,
	    { channel: _LaunchDarkly.BROADCAST_CHANNEL },
	    function (config) {
	      if (config) {
	        return _react2.default.createElement(_FeatureFlagRenderer2.default, _extends({}, config, props));
	      }
	
	      return null;
	    }
	  );
	}

/***/ },
/* 571 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BROADCAST_CHANNEL = exports.BROADCAST_CHANNEL = "launchDarkly";

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocation = getLocation;
	exports.ldClientWrapper = ldClientWrapper;
	exports.ldOverrideFlag = ldOverrideFlag;
	exports.getAllFeatureFlags = getAllFeatureFlags;
	exports.identify = identify;
	
	var _ldclientJs = __webpack_require__(1021);
	
	var _ldclientJs2 = _interopRequireDefault(_ldclientJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = __webpack_require__(1669);
	
	function getLocation() {
	  if (window.location) {
	    return window.location.toString();
	  }
	  return "";
	}
	
	var ldClient = void 0;
	var ldClientReady = false;
	function ldClientWrapper(key, user) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var queue = [];
	
	  if (!ldClient) {
	    ldClient = _ldclientJs2.default.initialize(key, user, options);
	  }
	
	  if (!ldClientReady) {
	    ldClient.on("ready", function () {
	      ldClientReady = true;
	
	      if (queue.length) {
	        queue.forEach(function (callback) {
	          callback();
	        });
	      }
	    });
	  }
	
	  // Create our own implementation of the ldclient-js' `on` function.
	  // Multiple calls with `on('ready')` seem to not fire after the original client has been initialized.
	  // By implementing our own, we can track the initial "ready" fire and decide how to proceed.
	  ldClient.onReady = function (callback) {
	    if (ldClientReady) {
	      callback();
	    } else {
	      queue.push(callback);
	    }
	  };
	
	  return ldClient;
	}
	
	function ldOverrideFlag(flagKey, typeFlagValue) {
	  var override = void 0;
	  /*
	   POST /users?features=send-onboarding-email
	   # Overrides the `send-onboarding-email` boolean feature flag, setting it to `true`
	   GET /users/101?features=show-user-email,user-nicknames,hide-inactive-users
	   # Enables the `show-user-email`, `user-nicknames`, and `hide-inactive-users` feature flags
	   POST /users?features.verify-email=false&features.email-frequency=weekly
	   # Disables the `verify-email` feature flag and sets the `email-frequency` variation to "weekly"
	   */
	  var query = url.parse(exports.getLocation(), true).query;
	  var queryFlag = query["features." + flagKey];
	  var queryFeatures = query["features"];
	
	  if (typeof queryFlag !== "undefined") {
	    if (queryFlag === "") {
	      override = true;
	    } else if (queryFlag === "false") {
	      override = false;
	    } else {
	      override = queryFlag;
	    }
	
	    if (typeFlagValue === "number") {
	      override = parseFloat(override);
	    }
	  } else if (queryFeatures) {
	    queryFeatures.split(",").forEach(function (f) {
	      if (f === flagKey) {
	        override = true;
	      }
	    });
	  }
	  return override;
	}
	
	function getAllFeatureFlags(key, user) {
	  var ldClient = ldClientWrapper(key, user);
	  return new Promise(function (resolve) {
	    ldClient.onReady(function () {
	      resolve(ldClient.allFlags());
	    });
	  });
	}
	
	/*
	
	  https://docs.launchdarkly.com/docs/js-sdk-reference#section-changing-the-user-context
	
	  "The hash parameter is the hash for the new user, assuming that the user's key has changed.
	  It is only required in secure mode-- if secure mode is not enabled,
	  you can pass in `null` for the hash."
	
	*/
	function identify(key, user) {
	  var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var ldClient = ldClientWrapper(key, user);
	  return new Promise(function (resolve) {
	    ldClient.onReady(function () {
	      resolve(ldClient.identify(user, hash));
	    });
	  });
	}

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.notify = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(1140);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var notificationWrapperId = 'notification-wrapper';
	var defaultTimeout = 5000; // ms
	var animationDuration = 300; // ms
	
	/* Colors */
	var colorWhite = 'white';
	var colorError = '#E85742';
	var colorSuccess = '#55CA92';
	var colorWarning = '#F5E273';
	var textColorWarning = '#333333';
	
	/* React Notification Component */
	
	var Toast = function (_React$Component) {
		_inherits(Toast, _React$Component);
	
		function Toast() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Toast);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toast.__proto__ || Object.getPrototypeOf(Toast)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
				styleParent: null
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(Toast, [{
			key: 'getStyles',
			value: function getStyles() {
				var styles = {};
	
				var containerStyle = {
					position: 'fixed',
					width: '50%',
					margin: '0 auto',
					right: '0px',
					top: '-100px',
					left: '0px',
					textAlign: 'center',
					zIndex: '999',
					pointerEvents: 'none',
					transition: 'all ' + animationDuration + 'ms ease',
					transform: 'translateY(0px)',
					// Vendor Prefixes
					msTransition: 'all ' + animationDuration + 'ms ease',
					msTransform: 'translateY(0px)',
					WebkitTransition: 'all ' + animationDuration + 'ms ease',
					WebkitTransform: 'translateY(0px)',
					OTransition: 'all ' + animationDuration + 'ms ease',
					OTransform: 'translateY(0px)',
					MozTransition: 'all ' + animationDuration + 'ms ease',
					MozTransform: 'translateY(0px)'
				};
	
				var contentStyle = {
					cursor: 'pointer',
					display: 'inline',
					width: 'auto',
					borderRadius: '0 0 4px 4px',
					backgroundColor: 'white',
					padding: '10px 30px',
					pointerEvents: 'all'
				};
	
				/* If type is set, merge toast action styles with base */
				switch (this.props.type) {
					case 'success':
						var successStyle = {
							backgroundColor: colorSuccess,
							color: colorWhite
						};
						styles.content = (0, _objectAssign2.default)({}, contentStyle, successStyle);
						break;
	
					case 'error':
						var errorStyle = {
							backgroundColor: colorError,
							color: colorWhite
						};
						styles.content = (0, _objectAssign2.default)({}, contentStyle, errorStyle);
						break;
	
					case 'warning':
						var warningStyle = {
							backgroundColor: colorWarning,
							color: textColorWarning
						};
						styles.content = (0, _objectAssign2.default)({}, contentStyle, warningStyle);
						break;
	
					case 'custom':
						var customStyle = {
							backgroundColor: this.props.color.background,
							color: this.props.color.text
						};
						styles.content = (0, _objectAssign2.default)({}, contentStyle, customStyle);
						break;
	
					default:
						styles.content = (0, _objectAssign2.default)({}, contentStyle);
						break;
				}
	
				styles.container = containerStyle;
	
				return styles;
			}
		}, {
			key: 'getVisibleState',
			value: function getVisibleState(context) {
				var base = this.getStyles().container;
	
				// Show
				var stylesShow = {
					transform: 'translateY(108px)',
					msTransform: 'translateY(108px)',
					WebkitTransform: 'translateY(108px)',
					OTransform: 'translateY(108px)',
					MozTransform: 'translateY(108px)'
				};
	
				setTimeout(function () {
					context.updateStyle(base, stylesShow);
				}, 100); // wait 100ms after the component is called to animate toast.
	
				if (this.props.timeout === -1) {
					return;
				}
	
				// Hide after timeout
				var stylesHide = {
					transform: 'translateY(-108px)',
					msTransform: 'translateY(-108px)',
					WebkitTransform: 'translateY(-108px)',
					OTransform: 'translateY(-108px)',
					MozTransform: 'translateY(-108px)'
				};
	
				setTimeout(function () {
					context.updateStyle(base, stylesHide);
				}, this.props.timeout);
			}
		}, {
			key: 'updateStyle',
			value: function updateStyle(base, update) {
				this.setState({ styleParent: (0, _objectAssign2.default)({}, base, update) });
			}
		}, {
			key: 'getBaseStyle',
			value: function getBaseStyle() {
				this.setState({ styleParent: this.getStyles().container });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.getBaseStyle();
				this.getVisibleState(this);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    text = _props.text,
				    type = _props.type;
	
				var styles = this.getStyles();
				var styleParent = this.state.styleParent;
	
				return _react2.default.createElement(
					'div',
					{ className: 'toast-notification', style: styleParent },
					_react2.default.createElement(
						'span',
						{ className: type, style: styles.content },
						text
					)
				);
			}
		}]);
	
		return Toast;
	}(_react2.default.Component);
	
	/* Private Functions */
	
	/* Render React component */
	
	
	Toast.propTypes = {
		text: _react.PropTypes.string,
		timeout: _react.PropTypes.number,
		type: _react.PropTypes.string,
		color: _react.PropTypes.object,
		style: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.bool])
	};
	function renderToast(text, type, timeout, color) {
		_reactDom2.default.render(_react2.default.createElement(Toast, { text: text, timeout: timeout, type: type, color: color }), document.getElementById(notificationWrapperId));
	}
	
	/* Unmount React component */
	function hideToast() {
		_reactDom2.default.unmountComponentAtNode(document.getElementById(notificationWrapperId));
	}
	
	/* Public functions */
	
	/* Show Animated Toast Message */
	/* Returns true if the toast was shown, or false if show failed due to an existing notification */
	function show(text, type, timeout, color) {
		if (!document.getElementById(notificationWrapperId).hasChildNodes()) {
			var renderTimeout = timeout;
	
			// Use default timeout if not set.
			if (!renderTimeout) {
				renderTimeout = defaultTimeout;
			}
	
			// Render Component with Props.
			renderToast(text, type, renderTimeout, color);
	
			if (timeout === -1) {
				return false;
			}
	
			// Unmount react component after the animation finished.
			setTimeout(function () {
				hideToast();
			}, renderTimeout + animationDuration);
	
			return true;
		}
		return false;
	}
	
	/**
	 * Add to Animated Toast Message Queue
	 * Display immediately if no queue
	 * @param  {Number} initialRecallDelay   If the call to show fails because of an existing
	 *                                       notification, how long to wait until we retry (ms)
	 * @param  {Number} recallDelayIncrement Each time a successive call fails, the recall delay
	 *                                       will be incremented by this (ms)
	 * @return {[type]}                      [description]
	 */
	function createShowQueue() {
		var _this2 = this;
	
		var initialRecallDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
		var recallDelayIncrement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	
		// Array to hold queued messages
		this.msgs = [];
	
		// Is the showNotify function in progress - used so we can call showNotify when a
		// message is added to an empty queue.
		this.isNotifying = false;
	
		this.currentRecallDelay = initialRecallDelay;
	
		// Retrieve the next message from the queue and try to show it
		this.showNotify = function () {
			// If there are no messages in the queue
			if (_this2.msgs.length === 0) {
				_this2.isNotifying = false;
				return;
			}
	
			_this2.isNotifying = true;
	
			var current = _this2.msgs.pop();
	
			// show will now return true if it is able to send the message,
			// or false if there is an existing message
			if (show(current.text, current.type, current.timeout, current.color)) {
				_this2.currentRecallDelay = initialRecallDelay;
				if (current.timeout > 0) {
					setTimeout(function () {
						return _this2.showNotify();
					}, current.timeout + animationDuration);
				}
			} else {
				// If message show failed, re-add the current message to the front of the queue
				_this2.msgs.unshift(current);
				setTimeout(function () {
					return _this2.showNotify();
				}, _this2.currentRecallDelay);
				_this2.currentRecallDelay += recallDelayIncrement;
			}
		};
	
		return function (text) {
			var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
			var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultTimeout;
			var color = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : colorWhite;
	
			_this2.msgs.push({ text: text, type: type, timeout: timeout, color: color });
			if (!_this2.isNotifying) {
				_this2.showNotify();
			}
		};
	}
	
	/* Export notification container */
	
	var _class = function (_React$Component2) {
		_inherits(_class, _React$Component2);
	
		function _class() {
			_classCallCheck(this, _class);
	
			return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
		}
	
		_createClass(_class, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement('div', { id: notificationWrapperId });
			}
		}]);
	
		return _class;
	}(_react2.default.Component);
	
	/* Export notification functions */
	
	
	exports.default = _class;
	var notify = exports.notify = {
		show: show,
		createShowQueue: createShowQueue
	};

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray2 = __webpack_require__(385);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _keys = __webpack_require__(907);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(82);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getIterator2 = __webpack_require__(81);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(225);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(66);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _libphonenumberJs = __webpack_require__(1024);
	
	var _inputFormat = __webpack_require__(1006);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactResponsiveUi = __webpack_require__(1143);
	
	var _countryNames = __webpack_require__(1012);
	
	var _countryNames2 = _interopRequireDefault(_countryNames);
	
	var _internationalIcon = __webpack_require__(1142);
	
	var _internationalIcon2 = _interopRequireDefault(_internationalIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// A list of all country codes
	var all_countries = [];
	
	// Country code to country name map
	
	
	// Not importing here directly from `react-responsive-ui` npm package
	// just to reduce the overall bundle size.
	var default_dictionary = {
		International: 'International'
	};
	
	// Populate `all_countries` and `default_dictionary`
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;
	
	try {
		for (var _iterator = (0, _getIterator3.default)(_countryNames2.default), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var item = _step.value;
	
			var _item = (0, _slicedToArray3.default)(item, 2);
	
			var code = _item[0];
			var name = _item[1];
	
	
			all_countries.push(code.toUpperCase());
			default_dictionary[code.toUpperCase()] = name;
		}
	
		// Allows passing custom `libphonenumber-js` metadata
		// to reduce the overall bundle size.
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
	
	var Input = function (_Component) {
		(0, _inherits3.default)(Input, _Component);
	
		function Input(props) {
			(0, _classCallCheck3.default)(this, Input);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call(this, props));
	
			_initialiseProps.call(_this);
	
			var _this$props = _this.props;
			var countries = _this$props.countries;
			var value = _this$props.value;
			var dictionary = _this$props.dictionary;
			var international = _this$props.international;
			var internationalIcon = _this$props.internationalIcon;
			var flags = _this$props.flags;
			var country = _this.props.country;
	
			// Normalize `country` code
	
			country = normalize_country_code(country);
	
			// Autodetect country if value is set
			// and is international (which it should be)
			if (value && value[0] === '+') {
				// `country` will be left `undefined` in case of non-detection
				country = (0, _libphonenumberJs.parse)(value).country;
			}
	
			// If there will be no "International" option
			// then a `country` must be selected.
			if (!should_add_international_option(_this.props) && !country) {
				country = countries[0];
			}
	
			// Set the currently selected country
			_this.state.country_code = country;
	
			// If a phone number `value` is passed then format it
			if (value) {
				// `this.state.value_property` is the `this.props.value`
				// which corresponding to `this.state.value`.
				// It is being compared in `componentWillReceiveProps()`
				// against `newProps.value` to find out if the new `value` property
				// needs `this.state.value` recalculation.
				_this.state.value_property = value;
				// Set the currently entered `value`.
				// State `value` is either in international plaintext or just plaintext format.
				// (e.g. `+78005553535`, `1234567`)
				_this.state.value = _this.get_input_value_depending_on_the_country_selected(value, country);
			}
	
			// `<Select/>` options
			_this.select_options = [];
	
			// Whether custom country names are supplied
			var using_custom_country_names = false;
	
			// Add a `<Select/>` option for each country
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;
	
			try {
				for (var _iterator2 = (0, _getIterator3.default)(countries), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var country_code = _step2.value;
	
					if (dictionary[country_code]) {
						using_custom_country_names = true;
					}
	
					_this.select_options.push({
						value: country_code,
						label: dictionary[country_code] || default_dictionary[country_code],
						icon: get_country_option_icon(country_code, _this.props)
					});
				}
	
				// Sort the list of countries alphabetically
				// (if `String.localeCompare` is available).
				// https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
				// (Which means: IE >= 11, and does not work in Safari as of May 2017)
				//
				// This is only done when custom country names
				// are supplied via `dictionary` property
				// because by default all country names are already sorted.
				//
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
	
			if (using_custom_country_names && String.prototype.localeCompare) {
				_this.select_options.sort(function (a, b) {
					return a.label.localeCompare(b.label);
				});
			}
	
			// Add the "International" option to the country list (if suitable)
			if (should_add_international_option(_this.props)) {
				_this.select_options.unshift({
					label: dictionary['International'] || default_dictionary['International'],
					icon: flags === false ? undefined : internationalIcon
				});
			}
			return _this;
		}
	
		// Determines the text `<input/>` `value`
		// depending on `this.props.value` and the country selected.
		//
		// E.g. when a country is selected and `this.props.value`
		// is in international format for this country
		// then it can be converted to national format
		// (if `convertToNational` is `true`).
		//
	
	
		(0, _createClass3.default)(Input, [{
			key: 'get_input_value_depending_on_the_country_selected',
			value: function get_input_value_depending_on_the_country_selected(value, country_code) {
				var _props = this.props;
				var metadata = _props.metadata;
				var convertToNational = _props.convertToNational;
	
	
				if (!value) {
					return;
				}
	
				// If the country code is specified
				if (country_code) {
					// and the phone is in international format
					// and should convert to national phone number
					if (value[0] === '+' && convertToNational) {
						// If it's a fully-entered phone number
						// that converts into a valid national number for this country
						// then the value is set to be that national number.
	
						var parsed = (0, _libphonenumberJs.parse)(value, metadata);
	
						if (parsed.country === country_code) {
							return this.format(parsed.phone, country_code).text;
						}
					}
				}
				// The country is not set.
				// Must be an international phone number then.
				else if (value[0] !== '+') {
						// The following causes the caret to move the end of the input field
						// but it's unlikely any sane person would like to erase the `+` sign
						// while inputting an international phone number without any country selected.
						return '+' + value;
					}
	
				return value;
			}
		}, {
			key: 'set_country_code_value',
			value: function set_country_code_value(country_code) {
				var onCountryChange = this.props.onCountryChange;
	
	
				if (onCountryChange) {
					onCountryChange(country_code);
				}
	
				this.setState({ country_code: country_code });
			}
	
			// `<select/>` `onChange` handler
	
	
			// `input-format` `parse` character function
			// https://github.com/catamphetamine/input-format
	
	
			// `input-format` `format` function
			// https://github.com/catamphetamine/input-format
	
	
			// Returns `true` if the country is available in the list
	
	
			// Can be called externally
	
	
			// `<input/>` `onKeyDown` handler
	
	
			// `<input/>` `onChange` handler.
			// Updates `this.props.value` (in e.164 phone number format)
			// according to the new `this.state.value`.
			// (keeps them in sync)
	
	
			// This `onBlur` interceptor is a workaround for `redux-form`,
			// so that it gets the parsed `value` in its `onBlur` handler,
			// not the formatted one.
			// A developer is not supposed to pass this `onBlur` property manually.
			// Instead, `redux-form` passes `onBlur` to this component automatically
			// and this component passes this `onBlur` property further to
			// `input-format`'s `<ReactInput/>` which then modifies this `onBlur` handler
			// to return the correct parsed `value` so that it all works with `redux-form`.
	
	
			// When country `<select/>` is toggled
	
	
			// Focuses the `<input/>` field
			// on tab out of the country `<select/>`
	
		}, {
			key: 'can_change_country',
	
	
			// Can a user change the default country or not.
			value: function can_change_country() {
				var countries = this.props.countries;
	
				// If `countries` is empty,
				// then only "International" option is available,
				// so can't switch it.
				//
				// If `countries` is a single allowed country,
				// then cant's switch it.
				//
	
				return countries.length > 1;
			}
	
			// Listen for default country property:
			// if it is set after the page loads
			// and the user hasn't selected a country yet
			// then select the default country.
	
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(new_props) {
				var _props2 = this.props;
				var countries = _props2.countries;
				var value = _props2.value;
	
				// Normalize `country` codes
	
				var country = normalize_country_code(this.props.country);
				var new_country = normalize_country_code(new_props.country);
	
				// If the default country changed
				// (e.g. in case of IP detection)
				if (new_country !== country) {
					// If the phone number input field is currently empty
					// (e.g. not touched yet) then change the selected `country`
					// to the newly passed one (e.g. as a result of a GeoIP query)
					if (!value) {
						// If the passed `country` allowed then update it
						if (countries.indexOf(new_country) !== -1) {
							// Set the new `country`
							this.set_country(new_country, false);
						}
					}
				}
	
				// This code is executed:
				// * after `this.props.onChange(value)` is called
				// * if the `value` was externally set (e.g. cleared)
				if (new_props.value !== value) {
					// `this.state.value_property` is the `this.props.value`
					// which corresponding to `this.state.value`.
					// It is being compared in `componentWillReceiveProps()`
					// against `newProps.value` to find out if the new `value` property
					// needs `this.state.value` recalculation.
					// This is an optimization, it's like `shouldComponentUpdate()`.
					// This is supposed to save some CPU cycles, maybe not much, I didn't check.
					// Or maybe there was some other reason for this I don't remember now.
					if (new_props.value !== this.state.value_property) {
						// Update the `value` because it was externally set
	
						// Country code gets updated too
						var country_code = this.state.country_code;
	
						// Autodetect country if `value` is set
						// and is international (which it should be)
						if (new_props.value && new_props.value[0] === '+') {
							// `parse().country` will be `undefined` in case of non-detection
							country_code = (0, _libphonenumberJs.parse)(new_props.value).country || country_code;
						}
	
						this.setState({
							country_code: country_code,
							value: this.get_input_value_depending_on_the_country_selected(new_props.value, country_code),
							// `this.state.value_property` is the `this.props.value`
							// which corresponding to `this.state.value`.
							// It is being compared in `componentWillReceiveProps()`
							// against `newProps.value` to find out if the new `value` property
							// needs `this.state.value` recalculation.
							value_property: new_props.value
						});
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props3 = this.props;
				var saveOnIcons = _props3.saveOnIcons;
				var showCountrySelect = _props3.showCountrySelect;
				var nativeExpanded = _props3.nativeExpanded;
				var disabled = _props3.disabled;
				var autoComplete = _props3.autoComplete;
				var selectTabIndex = _props3.selectTabIndex;
				var selectMaxItems = _props3.selectMaxItems;
				var inputTabIndex = _props3.inputTabIndex;
				var style = _props3.style;
				var selectStyle = _props3.selectStyle;
				var inputStyle = _props3.inputStyle;
				var className = _props3.className;
				var inputClassName = _props3.inputClassName;
				var dictionary = _props3.dictionary;
				var countries = _props3.countries;
				var country = _props3.country;
				var onCountryChange = _props3.onCountryChange;
				var flags = _props3.flags;
				var flagsPath = _props3.flagsPath;
				var international = _props3.international;
				var internationalIcon = _props3.internationalIcon;
				var convertToNational = _props3.convertToNational;
				var metadata = _props3.metadata;
				var input_props = (0, _objectWithoutProperties3.default)(_props3, ['saveOnIcons', 'showCountrySelect', 'nativeExpanded', 'disabled', 'autoComplete', 'selectTabIndex', 'selectMaxItems', 'inputTabIndex', 'style', 'selectStyle', 'inputStyle', 'className', 'inputClassName', 'dictionary', 'countries', 'country', 'onCountryChange', 'flags', 'flagsPath', 'international', 'internationalIcon', 'convertToNational', 'metadata']);
				var _state = this.state;
				var value = _state.value;
				var country_code = _state.country_code;
				var country_select_is_shown = _state.country_select_is_shown;
	
	
				var markup = _react2.default.createElement(
					'div',
					{
						style: style,
						className: (0, _classnames2.default)('react-phone-number-input', className) },
					showCountrySelect && this.can_change_country() && _react2.default.createElement(_reactResponsiveUi.Select, {
						ref: this.store_select_instance,
						value: country_code,
						options: this.select_options,
						onChange: this.set_country,
						disabled: disabled,
						onToggle: this.country_select_toggled,
						onTabOut: this.on_country_select_tab_out,
						nativeExpanded: nativeExpanded,
						autocomplete: true,
						autocompleteShowAll: true,
						maxItems: selectMaxItems,
						concise: true,
						tabIndex: selectTabIndex,
						focusUponSelection: false,
						saveOnIcons: saveOnIcons,
						name: input_props.name ? input_props.name + '__country' : undefined,
						style: selectStyle,
						className: (0, _classnames2.default)('react-phone-number-input__country', {
							'react-phone-number-input__country--native-expanded': nativeExpanded
						}),
						inputClassName: inputClassName }),
					!country_select_is_shown && _react2.default.createElement(_inputFormat.ReactInput, (0, _extends3.default)({}, input_props, {
						ref: this.store_input_instance,
						value: value,
						onChange: this.on_change,
						onBlur: this.on_blur,
						disabled: disabled,
						type: 'tel',
						autoComplete: autoComplete,
						tabIndex: inputTabIndex,
						parse: this.parse_character,
						format: this.format,
						onKeyDown: this.on_key_down,
						style: inputStyle,
						className: (0, _classnames2.default)('rrui__input', 'rrui__input-field', 'react-phone-number-input__phone', inputClassName) }))
				);
	
				return markup;
			}
		}]);
		return Input;
	}(_react.Component);
	
	// Parses a partially entered phone number
	// and returns the national number so far.
	// Not using `libphonenumber-js`'s `parse`
	// function here because `parse` only works
	// when the number is fully entered,
	// and this one is for partially entered number.
	
	
	Input.propTypes = {
		// Phone number `value`.
		// Is a plaintext international phone number
		// (e.g. "+12223333333" for USA)
		value: _propTypes2.default.string,
	
		// This handler is called each time
		// the phone number <input/> changes its textual value.
		onChange: _propTypes2.default.func.isRequired,
	
		// This `onBlur` interceptor is a workaround for `redux-form`,
		// so that it gets the parsed `value` in its `onBlur` handler,
		// not the formatted one.
		// A developer is not supposed to pass this `onBlur` property manually.
		// Instead, `redux-form` passes `onBlur` to this component automatically
		// and this component passes this `onBlur` property further to
		// `input-format`'s `<ReactInput/>` which then modifies this `onBlur` handler
		// to return the correct parsed `value` so that it all works with `redux-form`.
		onBlur: _propTypes2.default.func,
	
		// Set `onKeyDown` handler.
		// Can be used in special cases to handle e.g. enter pressed
		onKeyDown: _propTypes2.default.func,
	
		// Disables both the <input/> and the <select/>
		// (is `false` by default)
		disabled: _propTypes2.default.bool.isRequired,
	
		// Remembers the input and also autofills it
		// with a previously remembered phone number.
		// Default value: "tel".
		//
		// https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
		//
		// "So when should you use autocomplete="off"?
		//  One example is when you've implemented your own version
		//  of autocomplete for search. Another example is any form field
		//  where users will input and submit different kinds of information
		//  where it would not be useful to have the browser remember
		//  what was submitted previously".
		//
		autoComplete: _propTypes2.default.string.isRequired,
	
		// Two-letter country code
		// to be used as the default country
		// for local (non-international) phone numbers.
		country: _propTypes2.default.string,
	
		// Is called when the selected country changes
		// (either by a user manually, or by autoparsing
		//  an international phone number being input).
		// This handler does not need to update the `country` property.
		// It's simply a listener for those who might need that for whatever purpose.
		onCountryChange: _propTypes2.default.func,
	
		// Localization dictionary:
		// `{ International: 'Международный', RU: 'Россия', US: 'США', ... }`
		dictionary: _propTypes2.default.objectOf(_propTypes2.default.string),
	
		// An optional list of allowed countries
		countries: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	
		// Custom national flag icons
		flags: _propTypes2.default.oneOfType([_propTypes2.default.objectOf(_propTypes2.default.element), _propTypes2.default.bool]),
	
		// A base URL path for national flag SVG icons.
		// By default it uses the ones from `flag-icon-css` github repo.
		flagsPath: _propTypes2.default.string.isRequired,
	
		// Whether to use native `<select/>` when expanded
		nativeExpanded: _propTypes2.default.bool.isRequired,
	
		// If set to `false`, then country flags will be shown
		// for all countries in the options list
		// (not just for selected country).
		saveOnIcons: _propTypes2.default.bool.isRequired,
	
		// Whether to show country `<Select/>`
		// (is `true` by default)
		showCountrySelect: _propTypes2.default.bool.isRequired,
	
		// Whether to add the "International" option
		// to the list of countries.
		international: _propTypes2.default.bool,
	
		// Custom "International" phone number type icon.
		internationalIcon: _propTypes2.default.element.isRequired,
	
		// Should the initially passed phone number `value`
		// be converted to a national phone number for its country.
		// (is `true` by default)
		convertToNational: _propTypes2.default.bool.isRequired,
	
		// HTML `tabindex` attribute for the country select
		selectTabIndex: _propTypes2.default.number,
	
		// Defines the height of the dropdown country select list
		selectMaxItems: _propTypes2.default.number,
	
		// HTML `tabindex` attribute for the phone number input
		inputTabIndex: _propTypes2.default.number,
	
		// CSS style object
		style: _propTypes2.default.object,
	
		// Inline CSS styles for country `<select/>`
		selectStyle: _propTypes2.default.object,
	
		// Inline CSS styles for phone number `<input/>`
		inputStyle: _propTypes2.default.object,
	
		// Component CSS class
		className: _propTypes2.default.string,
	
		// `<input/>` CSS class
		inputClassName: _propTypes2.default.string,
	
		// `libphonenumber-js` metadata
		metadata: _propTypes2.default.shape({
			country_phone_code_to_countries: _propTypes2.default.object.isRequired,
			countries: _propTypes2.default.object.isRequired
		}).isRequired
	};
	Input.defaultProps = {
		// Is enabled
		disabled: false,
	
		// Remember (and autofill) as a phone number
		autoComplete: 'tel',
	
		// Include all countries by default
		countries: all_countries,
	
		// By default use the ones from `flag-icon-css` github repo.
		flagsPath: 'https://lipis.github.io/flag-icon-css/flags/4x3/',
	
		// Default international icon (globe)
		internationalIcon: _react2.default.createElement(
			'div',
			{ className: 'react-phone-number-input__icon react-phone-number-input__icon--international' },
			_react2.default.createElement(_internationalIcon2.default, null)
		),
	
		// Custom country names
		dictionary: {},
	
		// Whether to use native `<select/>` when expanded
		nativeExpanded: false,
	
		// Don't show flags for all countries in the options list
		// (show it just for selected country).
		// (to save user's traffic because all flags are about 3 MegaBytes)
		saveOnIcons: true,
	
		// Show country `<Select/>` by default
		showCountrySelect: true,
	
		// Convert the initially passed phone number `value`
		// to a national phone number for its country.
		convertToNational: true
	};
	
	var _initialiseProps = function _initialiseProps() {
		var _this2 = this;
	
		this.state = {};
	
		this.set_country = function (country_code, focus) {
			var metadata = _this2.props.metadata;
	
			// Previously selected country
	
			var previous_country_code = _this2.state.country_code;
	
			_this2.set_country_code_value(country_code);
	
			// Adjust the phone number (`value`)
			// according to the selected `country_code`
	
			var value = _this2.state.value;
	
	
			if (value) {
				// If switching to a country from International
				if (!previous_country_code && country_code) {
					// The value is international plaintext.
	
					// If the international phone number already contains
					// any country phone code then trim the country phone code part.
					value = strip_country_phone_code(value, metadata);
	
					// Else just trim the + sign
					if (value[0] === '+') {
						value = value.slice(1);
					}
				}
	
				// If switching to another country
				if (previous_country_code && country_code) {
					// If the phone number was entered in international format.
					// The phone number entered not necessarily even starts with
					// the previously selected country phone prefix.
					if (value[0] === '+') {
						// If the international phone number already contains
						// any country phone code then trim the country phone code part.
						// (that also could be the newly selected country phone code prefix)
						value = strip_country_phone_code(value, metadata);
	
						// Else just trim the + sign
						if (value[0] === '+') {
							value = value.slice(1);
						}
					}
				}
	
				// If switching to International from a country
				if (previous_country_code && !country_code) {
					// If no leading `+` sign
					if (value[0] !== '+') {
						// Format the local phone number as an international one.
						// The phone number entered not necessarily even starts with
						// the previously selected country phone prefix.
						// Even if the phone number belongs to whole another country
						// it will still be parsed into some national phone number.
						var national_number = parse_partial_number(value, previous_country_code, metadata).national_number;
						value = (0, _libphonenumberJs.format)(national_number, previous_country_code, 'International_plaintext', metadata);
					}
				}
	
				// Update the adjusted `value`
				// and update `this.props.value` (in e.164 phone number format)
				// according to the new `this.state.value`.
				// (keep them in sync)
				_this2.on_change(value, country_code, true);
			}
	
			// Focus the phone number input upon country selection
			// (do it in a timeout because the `<input/>`
			//  is hidden while selecting a country)
			if (focus !== false) {
				setTimeout(_this2.focus, 0);
			}
		};
	
		this.parse_character = function (character, value) {
			var countries = _this2.props.countries;
	
	
			if (character === '+') {
				// Only allow a leading `+`
				if (!value) {
					// If the "International" option is available
					// then allow the leading `+` because it's meant to be this way.
					//
					// Otherwise, the leading `+` will either erase all subsequent digits
					// (if they're not appropriate for the selected country)
					// or the subsequent digits (if any) will join the `+`
					// forming an international phone number. Because a user
					// might be comfortable with entering an international phone number
					// (i.e. with country code) rather than the local one.
					// Therefore such possibility is given.
					//
					return character;
				}
			}
			// For digits
			else if (character >= '0' && character <= '9') {
					var metadata = _this2.props.metadata;
					var country_code = _this2.state.country_code;
	
					// If the "International" option is not available
					// and if the value has a leading `+`
					// then it means that the phone number being entered
					// is an international one, so only allow the country phone code
					// for the selected country to be entered.
	
					if (!should_add_international_option(_this2.props) && value && value[0] === '+') {
						if (!could_phone_number_belong_to_country(value + character, country_code, metadata)) {
							return;
						}
					}
	
					return character;
				}
		};
	
		this.format = function (value) {
			var country_code = arguments.length <= 1 || arguments[1] === undefined ? _this2.state.country_code : arguments[1];
			var metadata = _this2.props.metadata;
	
			// `value` is already parsed input, i.e.
			// either International plaintext phone number
			// or just local phone number digits.
	
			// "As you type" formatter
	
			var formatter = new _libphonenumberJs.as_you_type(country_code, metadata);
	
			// Is used to check if a country code can already be derived
			_this2.formatter = formatter;
	
			// Format phone number
			var text = formatter.input(value);
	
			return { text: text, template: formatter.template };
		};
	
		this.is_selectable_country = function (country_code) {
			var countries = _this2.props.countries;
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;
	
			try {
	
				for (var _iterator3 = (0, _getIterator3.default)(countries), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var available_country_code = _step3.value;
	
					if (available_country_code === country_code) {
						return true;
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
		};
	
		this.focus = function () {
			_reactDom2.default.findDOMNode(_this2.input).focus();
		};
	
		this.on_key_down = function (event) {
			var onKeyDown = _this2.props.onKeyDown;
	
			// Expand country `<select/>`` on "Down arrow" key press
	
			if (event.keyCode === 40) {
				_this2.select.toggle();
			}
	
			if (onKeyDown) {
				onKeyDown(event);
			}
		};
	
		this.on_change = function (value) {
			var country_code = arguments.length <= 1 || arguments[1] === undefined ? _this2.state.country_code : arguments[1];
			var changed_country = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
			var _props4 = _this2.props;
			var metadata = _props4.metadata;
			var onChange = _props4.onChange;
	
			// If the `<input/>` is empty then just exit
	
			if (!value) {
				return _this2.setState({
					// State `value` is the parsed input value
					// (e.g. `+78005553535`, `1234567`).
					// This is not `this.props.value`
					// i.e. it's not neccessarily an international plaintext phone number,
					// it's just the `value` parsed by `input-format`.
					value: value,
					// `this.state.value_property` is the `this.props.value`
					// which corresponding to `this.state.value`.
					// It is being compared in `componentWillReceiveProps()`
					// against `newProps.value` to find out if the new `value` property
					// needs `this.state.value` recalculation.
					value_property: value
				},
				// Write the new `this.props.value`.
				function () {
					return onChange(value);
				});
			}
	
			// For international phone numbers
			if (value[0] === '+') {
				// If an international phone number is being erased up to the first `+` sign
				// or if an international phone number is just starting (with a `+` sign)
				// then unset the current country because it's clear that a user intends to change it.
				if (value.length === 1) {
					// If "International" country option has not been disabled
					// then reset the currently selected country.
					if (should_add_international_option(_this2.props)) {
						country_code = undefined;
						_this2.set_country_code_value(country_code);
					}
				} else {
					// If a phone number is being input as an international one
					// and the country code can already be derived,
					// then switch the country.
					// (`001` is a special "non-geograpical entity" code in `libphonenumber` library)
					if (!changed_country && _this2.formatter.country && _this2.formatter.country !== '001' && _this2.is_selectable_country(_this2.formatter.country)) {
						country_code = _this2.formatter.country;
						_this2.set_country_code_value(country_code);
					}
					// If "International" country option has not been disabled
					// and the international phone number entered doesn't correspond
					// to the currently selected country then reset the currently selected country.
					else if (should_add_international_option(_this2.props) && country_code && value.indexOf((0, _libphonenumberJs.getPhoneCode)(country_code) !== '+'.length)) {
							country_code = undefined;
							_this2.set_country_code_value(country_code);
						}
				}
			}
			// If "International" mode is selected
			// and the `value` doesn't start with a + sign,
			// then prepend it to the `value`.
			else if (!country_code) {
					value = '+' + value;
				}
	
			// `this.state.value_property` is the `this.props.value`
			// which corresponding to `this.state.value`.
			// It is being compared in `componentWillReceiveProps()`
			// against `newProps.value` to find out if the new `value` property
			// needs `this.state.value` recalculation.
			var value_property = void 0;
	
			// `value` equal to `+` makes no sense
			if (value === '+') {
				value_property = undefined;
			}
			// If a phone number is in international format then check
			// that the phone number entered belongs to the selected country.
			else if (country_code && value[0] === '+' && !(value.indexOf('+' + (0, _libphonenumberJs.getPhoneCode)(country_code)) === 0 && value.length > ('+' + (0, _libphonenumberJs.getPhoneCode)(country_code)).length)) {
					value_property = undefined;
				}
				// Should be a most-probably-valid phone number
				else {
						// Convert `value` to E.164 phone number format
						value_property = e164(value, country_code, metadata);
					}
	
			_this2.setState({
				// State `value` is the parsed input value
				// (e.g. `+78005553535`, `1234567`).
				// This is not `this.props.value`
				// i.e. it's not neccessarily an international plaintext phone number,
				// it's just the `value` parsed by `input-format`.
				value: value,
				// `this.state.value_property` is the `this.props.value`
				// which corresponding to `this.state.value`.
				// It is being compared in `componentWillReceiveProps()`
				// against `newProps.value` to find out if the new `value` property
				// needs `this.state.value` recalculation.
				value_property: value_property
			},
			// Write the new `this.props.value`.
			function () {
				return onChange(value_property);
			});
		};
	
		this.on_blur = function (event) {
			var onBlur = _this2.props.onBlur;
			var value_property = _this2.state.value_property;
	
	
			if (!onBlur) {
				return;
			}
	
			var _event = (0, _extends3.default)({}, event, {
				target: (0, _extends3.default)({}, event.target, {
					value: value_property
				})
			});
	
			// For `redux-form` event detection.
			// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
			_event.stopPropagation = event.stopPropagation;
			_event.preventDefault = event.preventDefault;
	
			return onBlur(_event);
		};
	
		this.country_select_toggled = function (is_shown) {
			_this2.setState({ country_select_is_shown: is_shown });
		};
	
		this.on_country_select_tab_out = function (event) {
			event.preventDefault();
	
			// Focus the phone number input upon country selection
			// (do it in a timeout because the `<input/>`
			//  is hidden while selecting a country)
			setTimeout(_this2.focus, 0);
		};
	
		this.store_select_instance = function (instance) {
			_this2.select = instance;
		};
	
		this.store_input_instance = function (instance) {
			_this2.input = instance;
		};
	};
	
	exports.default = Input;
	function parse_partial_number(value, country_code, metadata) {
		// "As you type" formatter
		var formatter = new _libphonenumberJs.as_you_type(country_code, metadata);
	
		// Input partially entered phone number
		formatter.input(value);
	
		// Return the parsed partial phone number
		// (has `.national_number`, `.country`, etc)
		return formatter;
	}
	
	// Converts `value` to E.164 phone number format
	function e164(value, country_code, metadata) {
		if (!value) {
			return undefined;
		}
	
		// If the phone number is being input in an international format
		if (value[0] === '+') {
			// If it's just the `+` sign
			if (value.length === 1) {
				return undefined;
			}
	
			// If there are some digits, the `value` is returned as is
			return value;
		}
	
		// For non-international phone number a country code is required
		if (!country_code) {
			return undefined;
		}
	
		// The phone number is being input in a country-specific format
	
		var partial_national_number = parse_partial_number(value, country_code).national_number;
	
		if (!partial_national_number) {
			return undefined;
		}
	
		// The value is converted to international plaintext
		return (0, _libphonenumberJs.format)(partial_national_number, country_code, 'International_plaintext', metadata);
	}
	
	// Gets country flag element by country code
	function get_country_option_icon(country_code, _ref) {
		var flags = _ref.flags;
		var flagsPath = _ref.flagsPath;
	
		if (flags === false) {
			return undefined;
		}
	
		if (flags && flags[country_code]) {
			return flags[country_code];
		}
	
		return _react2.default.createElement('img', {
			className: 'react-phone-number-input__icon',
			src: '' + flagsPath + country_code.toLowerCase() + '.svg' });
	}
	
	// Whether to add the "International" option to the list of countries
	function should_add_international_option(properties) {
		var countries = properties.countries;
		var international = properties.international;
	
		// If this behaviour is explicitly set, then do as it says.
	
		if (international !== undefined) {
			return international;
		}
	
		// If `countries` is empty,
		// then only "International" option is available, so add it.
		if (countries.length === 0) {
			return true;
		}
	
		// If `countries` is a single allowed country,
		// then don't add the "International" option
		// because it would make no sense.
		if (countries.length === 1) {
			return false;
		}
	
		// Show the "International" option by default
		return true;
	}
	
	// Is it possible that the partially entered  phone number belongs to the given country
	function could_phone_number_belong_to_country(phone_number, country_code, metadata) {
		// Strip the leading `+`
		var phone_number_digits = phone_number.slice(1);
	
		var _iteratorNormalCompletion4 = true;
		var _didIteratorError4 = false;
		var _iteratorError4 = undefined;
	
		try {
			for (var _iterator4 = (0, _getIterator3.default)((0, _keys2.default)(metadata.country_phone_code_to_countries)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
				var country_phone_code = _step4.value;
	
				var possible_country_phone_code = phone_number_digits.substring(0, country_phone_code.length);
				if (country_phone_code.indexOf(possible_country_phone_code) === 0) {
					// This country phone code is possible.
					// Does the given country correspond to this country phone code.
					if (metadata.country_phone_code_to_countries[country_phone_code].indexOf(country_code) >= 0) {
						return true;
					}
				}
			}
		} catch (err) {
			_didIteratorError4 = true;
			_iteratorError4 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion4 && _iterator4.return) {
					_iterator4.return();
				}
			} finally {
				if (_didIteratorError4) {
					throw _iteratorError4;
				}
			}
		}
	}
	
	// If a formatted phone number is an international one
	// then it strips the `+${country_phone_code}` prefix from the formatted number.
	function strip_country_phone_code(formatted_number, metadata) {
		if (!formatted_number || formatted_number[0] !== '+' || formatted_number === '+') {
			return formatted_number;
		}
	
		var _iteratorNormalCompletion5 = true;
		var _didIteratorError5 = false;
		var _iteratorError5 = undefined;
	
		try {
			for (var _iterator5 = (0, _getIterator3.default)((0, _keys2.default)(metadata.country_phone_code_to_countries)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
				var country_phone_code = _step5.value;
	
				if (formatted_number.indexOf(country_phone_code) === '+'.length) {
					return formatted_number.slice('+'.length + country_phone_code.length).trim();
				}
			}
		} catch (err) {
			_didIteratorError5 = true;
			_iteratorError5 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion5 && _iterator5.return) {
					_iterator5.return();
				}
			} finally {
				if (_didIteratorError5) {
					throw _iteratorError5;
				}
			}
		}
	
		return formatted_number;
	}
	
	// Validates country code
	function normalize_country_code(country) {
		// Normalize `country` if it's an empty string
		if (country === '') {
			country = undefined;
		}
	
		// No country is selected ("International")
		if (country === undefined || country === null) {
			return country;
		}
	
		// Check that `country` code exists
		if (default_dictionary[country]) {
			return country;
		}
	
		throw new Error('Unknown country: "' + country + '"');
	}
	//# sourceMappingURL=input.js.map

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/*
	React-Quill v1.0.0
	https://github.com/zenoamaro/react-quill
	*/
	var Quill = __webpack_require__(535);
	var Component = __webpack_require__(1147);
	
	module.exports = Component;
	module.exports.default = Component;
	module.exports.Quill = Quill;
	module.exports.Mixin = __webpack_require__(576);
	module.exports.Toolbar = __webpack_require__(1148);


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Quill = __webpack_require__(535);
	
	var QuillMixin = {
	
		/**
		Creates an editor on the given element. The editor will
		be passed the configuration, have its events bound,
		*/
		createEditor: function($el, config) {
			var editor = new Quill($el, config);
			if (config.tabIndex !== undefined) {
				this.setEditorTabIndex(editor, config.tabIndex);
			}
			this.hookEditor(editor);
			return editor;
		},
	
		hookEditor: function(editor) {
			// Expose the editor on change events via a weaker,
			// unprivileged proxy object that does not allow
			// accidentally modifying editor state.
			var unprivilegedEditor = this.makeUnprivilegedEditor(editor);
	
			this.handleTextChange = function(delta, oldDelta, source) {
				if (this.onEditorChangeText) {
					this.onEditorChangeText(
						editor.root.innerHTML, delta, source,
						unprivilegedEditor
					);
					this.onEditorChangeSelection(
						editor.getSelection(), source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			this.handleSelectionChange = function(range, oldRange, source) {
				if (this.onEditorChangeSelection) {
					this.onEditorChangeSelection(
						range, source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			editor.on('editor-change', function(eventType, rangeOrDelta, oldRangeOrOldDelta, source) {
				if (eventType === Quill.events.SELECTION_CHANGE) {
					this.handleSelectionChange(rangeOrDelta, oldRangeOrOldDelta, source);
				}
				
				if (eventType === Quill.events.TEXT_CHANGE) {
					this.handleTextChange(rangeOrDelta, oldRangeOrOldDelta, source);
				}
			}.bind(this));
		},
	
		unhookEditor: function(editor) {
			editor.off('selection-change');
			editor.off('text-change');
		},
	
		setEditorReadOnly: function(editor, value) {
			value? editor.disable()
			     : editor.enable();
		},
	
		/*
		Replace the contents of the editor, but keep
		the previous selection hanging around so that
		the cursor won't move.
		*/
		setEditorContents: function(editor, value) {
			var sel = editor.getSelection();
	
			if (typeof value === 'string') {
				editor.setContents(editor.clipboard.convert(value));
			} else {
				editor.setContents(value);
			}
	
			if (sel && editor.hasFocus()) this.setEditorSelection(editor, sel);
		},
	
		setEditorSelection: function(editor, range) {
			if (range) {
				// Validate bounds before applying.
				var length = editor.getLength();
				range.index = Math.max(0, Math.min(range.index, length-1));
				range.length = Math.max(0, Math.min(range.length, (length-1) - range.index));
			}
			editor.setSelection(range);
		},
	
		setEditorTabIndex: function(editor, tabIndex) {
			if (editor.editor && editor.editor.scroll && editor.editor.scroll.domNode) {
				editor.editor.scroll.domNode.tabIndex = tabIndex;
			}
		},
	
		/*
		Returns an weaker, unprivileged proxy object that only
		exposes read-only accessors found on the editor instance,
		without any state-modificating methods.
		*/
		makeUnprivilegedEditor: function(editor) {
			var e = editor;
			return {
				getLength:    function(){ return e.getLength.apply(e, arguments); },
				getText:      function(){ return e.getText.apply(e, arguments); },
				getHTML:      function(){ return e.root.innerHTML },
				getContents:  function(){ return e.getContents.apply(e, arguments); },
				getSelection: function(){ return e.getSelection.apply(e, arguments); },
				getBounds:    function(){ return e.getBounds.apply(e, arguments); },
			};
		}
	
	};
	
	module.exports = QuillMixin;


/***/ },
/* 577 */
[1684, 169, 1223, 1224, 1225, 1226, 1227],
/* 578 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 579 */
[1693, 580, 174],
/* 580 */
[1709, 59, 277, 1228, 1242],
/* 581 */
[1713, 1153, 578, 1181],
/* 582 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 583 */
[1731, 131],
/* 584 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 585 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 586 */
[1750, 1185, 1230],
/* 587 */
[1754, 1166, 132],
/* 588 */
[1756, 58, 1238],
/* 589 */
[1757, 274],
/* 590 */
[1758, 130, 131],
/* 591 */
[1760, 1170, 1180, 1217],
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(282);
	
	var _ContextUtils = __webpack_require__(281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 593 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _PatternUtils = __webpack_require__(116);
	
	var _InternalPropTypes = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 595 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(411);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(410);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(998);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(599);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(117);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1255);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1252);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1259);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1256);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1261);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(411);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(410);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(708);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(620);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateManager = __webpack_require__(1272);
	
	var _AnimateManager2 = _interopRequireDefault(_AnimateManager);
	
	var _PureRender = __webpack_require__(1273);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _easing = __webpack_require__(602);
	
	var _configUpdate = __webpack_require__(1274);
	
	var _configUpdate2 = _interopRequireDefault(_configUpdate);
	
	var _util = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Animate = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate(props, context) {
	    _classCallCheck(this, Animate);
	
	    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));
	
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	
	
	    _this.handleStyleChange = _this.handleStyleChange.bind(_this);
	    _this.changeStyle = _this.changeStyle.bind(_this);
	
	    if (!isActive) {
	      _this.state = { style: {} };
	
	      // if children is a function and animation is not active, set style to 'to'
	      if (typeof children === 'function') {
	        _this.state = { style: to };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = { style: steps[0].style };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	
	        return _possibleConstructorReturn(_this);
	      }
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = { style: {} };
	    }
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isActive = _props.isActive,
	          canBegin = _props.canBegin;
	
	
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isActive = nextProps.isActive,
	          canBegin = nextProps.canBegin,
	          attributeName = nextProps.attributeName,
	          shouldReAnimate = nextProps.shouldReAnimate;
	
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        this.setState({
	          style: attributeName ? _defineProperty({}, attributeName, nextProps.to) : nextProps.to
	        });
	
	        return;
	      }
	
	      var animateProps = ['to', 'canBegin', 'isActive'];
	
	      if ((0, _isEqual3.default)(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
	        return;
	      }
	
	      var isTriggered = !this.props.canBegin || !this.props.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;
	
	      this.setState({
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      });
	
	      this.runAnimation(_extends({}, nextProps, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: 'runJSAnimation',
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	
	      var startAnimation = (0, _configUpdate2.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'runStepAnimation',
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === undefined ? 0 : _steps$$duration;
	
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === undefined ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	
	
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return [].concat(_toConsumableArray(sequence), [_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	        var newStyle = _extends({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return [].concat(_toConsumableArray(sequence), [newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: 'runAnimation',
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager2.default)();
	      }
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsFrom = props.from,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	
	
	      var manager = this.manager;
	
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	
	      manager.start([onAnimationStart, begin, _extends({}, to, { transition: transition }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'handleStyleChange',
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: 'changeStyle',
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          begin = _props2.begin,
	          duration = _props2.duration,
	          attributeName = _props2.attributeName,
	          easing = _props2.easing,
	          isActive = _props2.isActive,
	          steps = _props2.steps,
	          from = _props2.from,
	          to = _props2.to,
	          canBegin = _props2.canBegin,
	          onAnimationEnd = _props2.onAnimationEnd,
	          shouldReAnimate = _props2.shouldReAnimate,
	          onAnimationReStart = _props2.onAnimationReStart,
	          others = _objectWithoutProperties(_props2, ['children', 'begin', 'duration', 'attributeName', 'easing', 'isActive', 'steps', 'from', 'to', 'canBegin', 'onAnimationEnd', 'shouldReAnimate', 'onAnimationReStart']);
	
	      var count = _react.Children.count(children);
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === undefined ? {} : _container$props$styl,
	            className = _container$props.className;
	
	
	        var res = (0, _react.cloneElement)(container, _extends({}, others, {
	          style: _extends({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        var onlyChild = _react.Children.only(children);
	
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react.Children.map(children, function (child) {
	          return cloneContainer(child);
	        })
	      );
	    }
	  }]);
	
	  return Animate;
	}(_react.Component), _class2.displayName = 'Animate', _class2.propTypes = {
	  from: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  to: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  attributeName: _propTypes2.default.string,
	  // animation duration
	  duration: _propTypes2.default.number,
	  begin: _propTypes2.default.number,
	  easing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    duration: _propTypes2.default.number.isRequired,
	    style: _propTypes2.default.object.isRequired,
	    easing: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes2.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes2.default.arrayOf('string'),
	    onAnimationEnd: _propTypes2.default.func
	  })),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  isActive: _propTypes2.default.bool,
	  canBegin: _propTypes2.default.bool,
	  onAnimationEnd: _propTypes2.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes2.default.bool,
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationReStart: _propTypes2.default.func
	}, _class2.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	}, _temp)) || _class;
	
	exports.default = Animate;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = undefined;
	
	var _util = __webpack_require__(179);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    var newParams = [].concat(_toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)), [0]);
	
	    return multyTime(newParams, t);
	  };
	};
	
	// calculate cubic-bezier using Newton's method
	var configBezier = exports.configBezier = function configBezier() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      default:
	        (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	
	  return bezier;
	};
	
	var configSpring = exports.configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === undefined ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === undefined ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === undefined ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	
	  return stepper;
	};
	
	var configEasing = exports.configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	      case 'spring':
	        return configSpring();
	      default:
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	
	  return null;
	};

/***/ },
/* 603 */
[1683, 285, 1352, 1353],
/* 604 */
[1684, 180, 1357, 1358, 1359, 1360, 1361],
/* 605 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 606 */
[1693, 609, 185],
/* 607 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 608 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 609 */
[1709, 53, 288, 1363, 1375],
/* 610 */
[1713, 603, 1287, 608],
/* 611 */
582,
/* 612 */
276,
/* 613 */
[1731, 292],
/* 614 */
584,
/* 615 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 616 */
585,
/* 617 */
278,
/* 618 */
[1754, 1297, 89],
/* 619 */
[1756, 60, 1374],
/* 620 */
[1757, 287],
/* 621 */
[1758, 118, 292],
/* 622 */
[1760, 1302, 607, 1349],
/* 623 */
[1684, 187, 1466, 1467, 1468, 1469, 1470],
/* 624 */
286,
/* 625 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 626 */
[1697, 1400, 138],
/* 627 */
607,
/* 628 */
[1709, 54, 300, 1471, 1486],
/* 629 */
[1713, 1385, 1391, 1417],
/* 630 */
582,
/* 631 */
[1731, 137],
/* 632 */
584,
/* 633 */
585,
/* 634 */
[1756, 61, 1482],
/* 635 */
[1758, 135, 137],
/* 636 */
[1760, 1403, 627, 1457],
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Tab = __webpack_require__(194);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function renderChildren(props) {
	  return _react2.default.Children.map(props.children, function (child) {
	    // if child is not a tab we don't need to clone it
	    // since we don't need to add custom props
	
	    if (child.type !== _Tab2.default) {
	      return child;
	    }
	
	    var clonedProps = {
	      activeTabClassName: props.activeTabClassName,
	      disabledTabClassName: props.disabledTabClassName
	    };
	
	    return _react2.default.cloneElement(child, clonedProps);
	  });
	}
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'TabList',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    activeTabClassName: _propTypes2.default.string,
	    disabledTabClassName: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])
	  },
	
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        activeTabClassName = _props.activeTabClassName,
	        disabledTabClassName = _props.disabledTabClassName,
	        children = _props.children,
	        attributes = _objectWithoutProperties(_props, ['className', 'activeTabClassName', 'disabledTabClassName', 'children']);
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__TabList', className),
	        role: 'tablist'
	      }),
	      renderChildren({ activeTabClassName: activeTabClassName, disabledTabClassName: disabledTabClassName, children: children })
	    );
	  }
	});

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(958);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(120);
	
	var ReactCurrentOwner = __webpack_require__(62);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 641 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 644 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getNiceTickValues = __webpack_require__(1509);
	
	Object.defineProperty(exports, 'getTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, 'getNiceTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, 'getTickValuesFixedDomain', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});

/***/ },
/* 646 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = exports.PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(undefined, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(undefined, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	
	      return fn.apply(undefined, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = exports.curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	var range = exports.range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	var map = exports.map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	
	var compose = exports.compose = function compose() {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var reverse = exports.reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  }
	
	  // can be string
	  return arr.split('').reverse.join('');
	};
	
	var memoize = exports.memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	
	  return function () {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(undefined, args);
	
	    return lastResult;
	  };
	};

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(209);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Brush
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(158);
	
	var _DataUtils = __webpack_require__(16);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brush = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Brush, _Component);
	
	  function Brush(props) {
	    _classCallCheck(this, Brush);
	
	    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, 1000);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
	    };
	
	    if (props.data && props.data.length) {
	      _this.updateScale(props);
	    } else {
	      _this.state = {};
	    }
	    return _this;
	  }
	
	  _createClass(Brush, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          x = _props.x,
	          travellerWidth = _props.travellerWidth,
	          updateId = _props.updateId;
	
	
	      if (nextProps.data !== data || nextProps.updateId !== updateId) {
	        this.updateScale(nextProps);
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: 'getIndexInRange',
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.getIndexInRange(this.scaleValues, max);
	
	      return {
	        startIndex: minIndex,
	        endIndex: maxIndex
	      };
	    }
	  }, {
	    key: 'getTextOfTick',
	    value: function getTextOfTick(index) {
	      var _props2 = this.props,
	          data = _props2.data,
	          tickFormatter = _props2.tickFormatter,
	          dataKey = _props2.dataKey;
	
	      var text = (0, _DataUtils.getValueByDataKey)(data[index], dataKey, index);
	
	      return (0, _isFunction3.default)(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: 'handleSlideDrag',
	    value: function handleSlideDrag(e) {
	      var _state = this.state,
	          slideMoveStartX = _state.slideMoveStartX,
	          startX = _state.startX,
	          endX = _state.endX;
	      var _props3 = this.props,
	          x = _props3.x,
	          width = _props3.width,
	          travellerWidth = _props3.travellerWidth,
	          startIndex = _props3.startIndex,
	          endIndex = _props3.endIndex,
	          onChange = _props3.onChange;
	
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerDragStart',
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerMove',
	    value: function handleTravellerMove(e) {
	      var _setState;
	
	      var _state2 = this.state,
	          brushMoveStartX = _state2.brushMoveStartX,
	          movingTravellerId = _state2.movingTravellerId;
	
	      var prevValue = this.state[movingTravellerId];
	      var _props4 = this.props,
	          x = _props4.x,
	          width = _props4.width,
	          travellerWidth = _props4.travellerWidth,
	          onChange = _props4.onChange;
	
	
	      var params = { startX: this.state.startX, endX: this.state.endX };
	      var delta = e.pageX - brushMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	      var newIndex = this.getIndex(params);
	
	      this.setState((_setState = {}, _defineProperty(_setState, movingTravellerId, prevValue + delta), _defineProperty(_setState, 'brushMoveStartX', e.pageX), _setState), function () {
	        if (onChange) {
	          onChange(newIndex);
	        }
	      });
	    }
	  }, {
	    key: 'updateScale',
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	
	
	      if (data && data.length) {
	        var len = data.length;
	        this.scale = (0, _d3Scale.scalePoint)().domain((0, _range3.default)(0, len)).range([x, x + width - travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this3.scale(entry);
	        });
	        this.state = {
	          isTextActive: false,
	          isSlideMoving: false,
	          isTravellerMoving: false,
	          startX: this.scale(startIndex),
	          endX: this.scale(endIndex)
	        };
	      }
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          fill = _props5.fill,
	          stroke = _props5.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: 'renderPanorama',
	    value: function renderPanorama() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          data = _props6.data,
	          children = _props6.children,
	          padding = _props6.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react2.default.cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: 'renderTraveller',
	    value: function renderTraveller(startX, id) {
	      var _props7 = this.props,
	          y = _props7.y,
	          travellerWidth = _props7.travellerWidth,
	          height = _props7.height,
	          stroke = _props7.stroke;
	
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(startX, this.props.x);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: 'recharts-brush-traveller',
	          onMouseEnter: this.handleEnterSlideOrTraveller,
	          onMouseLeave: this.handleLeaveSlideOrTraveller,
	          onMouseDown: this.travellerDragStartHandlers[id],
	          onTouchStart: this.travellerDragStartHandlers[id],
	          style: { cursor: 'col-resize' }
	        },
	        _react2.default.createElement('rect', {
	          x: x,
	          y: y,
	          width: travellerWidth,
	          height: height,
	          fill: stroke,
	          stroke: 'none'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY,
	          x2: x + travellerWidth - 1,
	          y2: lineY,
	          fill: 'none',
	          stroke: '#fff'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY + 2,
	          x2: x + travellerWidth - 1,
	          y2: lineY + 2,
	          fill: 'none',
	          stroke: '#fff'
	        })
	      );
	    }
	  }, {
	    key: 'renderSlide',
	    value: function renderSlide(startX, endX) {
	      var _props8 = this.props,
	          y = _props8.y,
	          height = _props8.height,
	          stroke = _props8.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        className: 'recharts-brush-slide',
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: { cursor: 'move' },
	        stroke: 'none',
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderText',
	    value: function renderText() {
	      var _props9 = this.props,
	          startIndex = _props9.startIndex,
	          endIndex = _props9.endIndex,
	          y = _props9.y,
	          height = _props9.height,
	          travellerWidth = _props9.travellerWidth,
	          stroke = _props9.stroke;
	      var _state3 = this.state,
	          startX = _state3.startX,
	          endX = _state3.endX;
	
	      var offset = 5;
	      var style = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-brush-texts' },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            textAnchor: 'end',
	            verticalAnchor: 'middle',
	            style: style,
	            x: Math.min(startX, endX) - offset,
	            y: y + height / 2
	          },
	          this.getTextOfTick(startIndex)
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            textAnchor: 'start',
	            verticalAnchor: 'middle',
	            style: style,
	            x: Math.max(startX, endX) + travellerWidth + offset,
	            y: y + height / 2
	          },
	          this.getTextOfTick(endIndex)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props10 = this.props,
	          data = _props10.data,
	          className = _props10.className,
	          children = _props10.children;
	      var _state4 = this.state,
	          startX = _state4.startX,
	          endX = _state4.endX,
	          isTextActive = _state4.isTextActive,
	          isSlideMoving = _state4.isSlideMoving,
	          isTravellerMoving = _state4.isTravellerMoving;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-brush', className);
	      var isPanoramic = _react2.default.Children.count(children) === 1;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          onMouseMove: this.handleDrag,
	          onMouseLeave: this.handleLeaveWrapper,
	          onMouseUp: this.handleDragEnd,
	          onTouchEnd: this.handleDragEnd,
	          onTouchMove: this.handleTouchMove
	        },
	        this.renderBackground(),
	        isPanoramic && this.renderPanorama(),
	        this.renderSlide(startX, endX),
	        this.renderTraveller(startX, 'startX'),
	        this.renderTraveller(endX, 'endX'),
	        (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText()
	      );
	    }
	  }]);
	
	  return Brush;
	}(_react.Component), _class2.displayName = 'Brush', _class2.propTypes = {
	  className: _propTypes2.default.string,
	
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  x: _propTypes2.default.number.isRequired,
	  y: _propTypes2.default.number.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  travellerWidth: _propTypes2.default.number,
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  data: _propTypes2.default.array,
	  startIndex: _propTypes2.default.number,
	  endIndex: _propTypes2.default.number,
	  tickFormatter: _propTypes2.default.func,
	
	  children: _propTypes2.default.node,
	
	  onChange: _propTypes2.default.func,
	  updateId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 40,
	  travellerWidth: 5,
	  fill: '#fff',
	  stroke: '#666',
	  padding: { top: 1, right: 1, bottom: 1, left: 1 }
	}, _temp)) || _class;
	
	exports.default = Brush;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of scatters
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _Curve = __webpack_require__(93);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Symbols = __webpack_require__(315);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ErrorBar = __webpack_require__(196);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _DataUtils = __webpack_require__(16);
	
	var _AnimationDecorator = __webpack_require__(121);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scatter = (0, _AnimationDecorator2.default)(_class = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Scatter, _Component);
	
	  function Scatter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scatter.__proto__ || Object.getPrototypeOf(Scatter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { activeIndex: -1, isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-'), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Scatter, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var animationDuration = this.props.animationDuration;
	
	      window.setTimeout(function () {
	        return _this2.setState({ isAnimationFinished: true });
	      }, animationDuration);
	    }
	  }, {
	    key: 'renderSymbolItem',
	    value: function renderSymbolItem(option, props) {
	      var symbol = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        symbol = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react2.default.createElement(_Symbols2.default, _extends({}, props, { type: option }));
	      }
	
	      return symbol;
	    }
	  }, {
	    key: 'renderSymbols',
	    value: function renderSymbols() {
	      var _this3 = this;
	
	      var _props = this.props,
	          points = _props.points,
	          shape = _props.shape,
	          activeShape = _props.activeShape,
	          activeIndex = _props.activeIndex,
	          animationBegin = _props.animationBegin,
	          animationDuration = _props.animationDuration,
	          isAnimationActive = _props.isAnimationActive,
	          animationEasing = _props.animationEasing,
	          animationId = _props.animationId;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return points.map(function (entry, i) {
	        var props = _extends({
	          key: 'symbol-' + i
	        }, baseProps, entry);
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-scatter-symbol'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	            key: 'symbol-' + i
	          }),
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              from: { size: 0 },
	              to: { size: props.size },
	              duration: animationDuration,
	              begin: animationBegin,
	              isActive: isAnimationActive,
	              key: animationId,
	              easing: animationEasing
	            },
	            function (_ref2) {
	              var size = _ref2.size;
	
	              var finalProps = _extends({}, props, { size: size });
	
	              return _this3.renderSymbolItem(activeIndex === i ? activeShape : shape, finalProps);
	            }
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (!this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          points = _props2.points,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          children = _props2.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.y,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.x,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	
	
	        return _react2.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: 'renderLine',
	    value: function renderLine() {
	      var _props3 = this.props,
	          points = _props3.points,
	          line = _props3.line,
	          lineType = _props3.lineType,
	          lineJointType = _props3.lineJointType;
	
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints = void 0,
	          lineItem = void 0;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return { x: entry.cx, y: entry.cy };
	        });
	      }
	      var lineProps = _extends({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react2.default.isValidElement(line)) {
	        lineItem = _react2.default.cloneElement(line, lineProps);
	      } else if ((0, _isFunction3.default)(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react2.default.createElement(_Curve2.default, _extends({}, lineProps, { type: lineJointType }));
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-scatter-line', key: 'recharts-scatter-line' },
	        lineItem
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          points = _props4.points,
	          line = _props4.line,
	          className = _props4.className,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          left = _props4.left,
	          top = _props4.top,
	          width = _props4.width,
	          height = _props4.height;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
	        },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        line && this.renderLine(),
	        this.renderErrorBar(),
	        _react2.default.createElement(
	          _Layer2.default,
	          { key: 'recharts-scatter-symbols' },
	          this.renderSymbols()
	        )
	      );
	    }
	  }]);
	
	  return Scatter;
	}(_react.Component), _class2.displayName = 'Scatter', _class2.propTypes = _extends({}, _ReactUtils.EVENT_ATTRIBUTES, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  line: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  lineType: _propTypes2.default.oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  className: _propTypes2.default.string,
	
	  activeIndex: _propTypes2.default.number,
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes2.default.element, _propTypes2.default.func]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    size: _propTypes2.default.number,
	    node: _propTypes2.default.shape({
	      x: _propTypes2.default.number,
	      y: _propTypes2.default.number,
	      z: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	    }),
	    payload: _propTypes2.default.any
	  })),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	}, _temp2)) || _class) || _class;
	
	exports.default = Scatter;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Z Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ZAxis, _Component);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, (ZAxis.__proto__ || Object.getPrototypeOf(ZAxis)).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.Component), _class2.displayName = 'ZAxis', _class2.propTypes = {
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The range of axis
	  range: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func])
	}, _class2.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto'
	}, _temp)) || _class;
	
	exports.default = ZAxis;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AreaChart = undefined;
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(27);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /**
	                                   * @fileOverview Area Chart
	                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Dot = __webpack_require__(75);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Curve = __webpack_require__(93);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _CartesianUtils = __webpack_require__(201);
	
	var _DataUtils = __webpack_require__(16);
	
	var _generateCategoricalChart = __webpack_require__(200);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Area = __webpack_require__(306);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _AnimationDecorator = __webpack_require__(121);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _ComposedDataDecorator = __webpack_require__(141);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
	  var axis = _ref.axis,
	      ticks = _ref.ticks,
	      bandSize = _ref.bandSize,
	      entry = _ref.entry,
	      index = _ref.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = (0, _DataUtils.getValueByDataKey)(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) : null;
	};
	
	var getBaseValue = function getBaseValue(props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numberAxis.scale.domain();
	
	  if (numberAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	};
	
	/**
	 * Compose the data of each area
	 * @param {Object} props The props that are passed to the component
	 * @param {Object} xAxis       The configuration of x-axis
	 * @param {Object} yAxis       The configuration of y-axis
	 * @param {String} dataKey     The unique key of a group
	 * @param {Array} stackedData If the area is stacked,
	 * the stackedData is an array of min value and max value
	 * @return {Array} Composed data
	 */
	var getComposedData = function getComposedData(_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xTicks = _ref2.xTicks,
	      yTicks = _ref2.yTicks,
	      bandSize = _ref2.bandSize,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData;
	  var layout = props.layout,
	      dataStartIndex = props.dataStartIndex,
	      dataEndIndex = props.dataEndIndex;
	
	  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	
	  var points = data.map(function (entry, index) {
	    var value = void 0;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: getCategoryAxisCoordinate({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value[1]) ? null : xAxis.scale(value[1]),
	      y: getCategoryAxisCoordinate({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	
	  var baseLine = void 0;
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      return {
	        x: layout === 'horizontal' ? entry.x : xAxis.scale(entry && entry.value[0]),
	        y: layout === 'horizontal' ? yAxis.scale(entry && entry.value[0]) : entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return { points: points, baseLine: baseLine, layout: layout, isRange: isRange };
	};
	
	var AreaChart = exports.AreaChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData }), (0, _AnimationDecorator2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AreaChart, _Component);
	
	  function AreaChart() {
	    _classCallCheck(this, AreaChart);
	
	    return _possibleConstructorReturn(this, (AreaChart.__proto__ || Object.getPrototypeOf(AreaChart)).apply(this, arguments));
	  }
	
	  _createClass(AreaChart, [{
	    key: 'renderCursor',
	    value: function renderCursor(_ref3) {
	      var offset = _ref3.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var start = ticks[activeTooltipIndex].coordinate;
	      var x1 = layout === 'horizontal' ? start : offset.left;
	      var y1 = layout === 'horizontal' ? offset.top : start;
	      var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
	      var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
	      var cursorProps = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Curve2.default, _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
	    }
	  }, {
	    key: 'renderActiveDot',
	    value: function renderActiveDot(option, props, childIndex) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, props);
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: 'scale(0)',
	          to: 'scale(1)',
	          duration: 400,
	          key: 'dot-' + childIndex + '-' + props.pointType,
	          attributeName: 'transform'
	        },
	        _react2.default.createElement(
	          _Layer2.default,
	          { style: { transformOrigin: 'center center' } },
	          dot
	        )
	      );
	    }
	
	    /**
	     * Draw the main part of area chart
	     * @param  {Array} items     React elements of Area
	     * @param  {Object} xAxisMap The configuration of all x-axis
	     * @param  {Object} yAxisMap The configuration of all y-axis
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @param  {Array} allComposedData The array of pre-created composedData
	     *                                 {points, basedLine, layout} for each item
	     * @return {ReactComponent} The instances of Area
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, xAxisMap, yAxisMap, offset, allComposedData) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          layout = _props2.layout,
	          isTooltipActive = _props2.isTooltipActive,
	          activeTooltipIndex = _props2.activeTooltipIndex;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      var hasDot = tooltipItem && isTooltipActive;
	      var dotItems = [];
	      var animationId = this.props.animationId;
	
	
	      var areaItems = items.reduce(function (result, child, i) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            activeDot = _child$props.activeDot;
	
	        var currentComposedData = allComposedData[i];
	        var isRange = currentComposedData.isRange;
	
	        var activePoint = currentComposedData.points && currentComposedData.points[activeTooltipIndex];
	        var basePoint = isRange && currentComposedData.baseLine && currentComposedData.baseLine[activeTooltipIndex];
	
	        if (hasDot && activeDot && activePoint) {
	          var dotProps = _extends({
	            index: activeTooltipIndex,
	            dataKey: dataKey,
	            animationId: animationId,
	            cx: activePoint.x, cy: activePoint.y, r: 4,
	            fill: (0, _CartesianUtils.getMainColorOfGraphicItem)(child),
	            strokeWidth: 2, stroke: '#fff',
	            payload: activePoint.payload,
	            value: activePoint.value,
	            pointType: 'activePoint'
	          }, (0, _ReactUtils.getPresentationAttributes)(activeDot));
	
	          dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));
	
	          if (basePoint) {
	            dotItems.push(_this2.renderActiveDot(activeDot, _extends({}, dotProps, {
	              cx: basePoint.x,
	              cy: basePoint.y,
	              pointType: 'basePoint'
	            }), i));
	          }
	        }
	
	        var area = _react2.default.cloneElement(child, _extends({
	          key: child.key || 'area-' + i
	        }, currentComposedData, offset, {
	          animationId: animationId,
	          layout: layout,
	          xAxis: xAxisMap[child.props.xAxisId],
	          yAxis: yAxisMap[child.props.yAxisId]
	        }));
	
	        return [].concat(_toConsumableArray(result), [area]);
	      }, []);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-chart-group' },
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-area-chart-shapes' },
	          areaItems
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-area-chart-dots' },
	          dotItems
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          isComposed = _props3.isComposed,
	          graphicalItems = _props3.graphicalItems,
	          xAxisMap = _props3.xAxisMap,
	          yAxisMap = _props3.yAxisMap,
	          offset = _props3.offset,
	          allComposedData = _props3.allComposedData;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-graphical' },
	        !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
	        this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset, allComposedData)
	      );
	    }
	  }]);
	
	  return AreaChart;
	}(_react.Component), _class2.displayName = 'AreaChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  axisTicks: _propTypes2.default.array,
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _propTypes2.default.number,
	  dataEndIndex: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  isTooltipActive: _propTypes2.default.bool,
	  activeTooltipIndex: _propTypes2.default.number,
	  xAxisMap: _propTypes2.default.object,
	  yAxisMap: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  graphicalItems: _propTypes2.default.array,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  stackGroups: _propTypes2.default.object,
	  baseValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['dataMin', 'dataMax', 'auto'])]),
	  // used internally
	  isComposed: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number
	}, _class2.defaultProps = {
	  baseValue: 'auto'
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(AreaChart, _Area2.default);

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BarChart = undefined;
	
	var _isArray2 = __webpack_require__(27);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Bar Chart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Rectangle = __webpack_require__(94);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _DataUtils = __webpack_require__(16);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _generateCategoricalChart = __webpack_require__(200);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Cell = __webpack_require__(140);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _Bar = __webpack_require__(307);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _AnimationDecorator = __webpack_require__(121);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _ComposedDataDecorator = __webpack_require__(141);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
	  var axis = _ref.axis,
	      ticks = _ref.ticks,
	      offset = _ref.offset,
	      bandSize = _ref.bandSize,
	      entry = _ref.entry,
	      index = _ref.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	
	  var value = (0, _DataUtils.getValueByDataKey)(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	var getBaseValue = function getBaseValue(_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis;
	  var layout = props.layout;
	
	  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numberAxis.scale.domain();
	
	  if (numberAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	/**
	 * Compose the data of each group
	 * @param {Object} props Props for the component
	 * @param {Object} item        An instance of Bar
	 * @param {Array} barPosition The offset and size of each bar
	 * @param {Object} xAxis       The configuration of x-axis
	 * @param {Object} yAxis       The configuration of y-axis
	 * @param {Array} stackedData  The stacked data of a bar item
	 * @return{Array} Composed data
	 */
	var getComposedData = function getComposedData(_ref3) {
	  var props = _ref3.props,
	      item = _ref3.item,
	      barPosition = _ref3.barPosition,
	      bandSize = _ref3.bandSize,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xTicks = _ref3.xTicks,
	      yTicks = _ref3.yTicks,
	      stackedData = _ref3.stackedData;
	  var layout = props.layout,
	      dataStartIndex = props.dataStartIndex,
	      dataEndIndex = props.dataEndIndex;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	
	  var pos = (0, _DataUtils.findPositionOfBar)(barPosition, item);
	  var stackedDomain = stackedData && layout === 'horizontal' ? yAxis.scale.domain() : xAxis.scale.domain();
	
	  if (!pos) {
	    return [];
	  }
	
	  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
	  var baseValue = getBaseValue({ props: props, xAxis: xAxis, yAxis: yAxis });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  return data.map(function (entry, index) {
	    var value = void 0,
	        x = void 0,
	        y = void 0,
	        width = void 0,
	        height = void 0;
	
	    if (stackedData) {
	      value = (0, _DataUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = getCategoryAxisCoordinate({
	        axis: xAxis,
	        ticks: xTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = getCategoryAxisCoordinate({
	        axis: yAxis,
	        ticks: yTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	        width += _delta;
	      }
	    }
	
	    return _extends({}, entry, {
	      x: x, y: y, width: width, height: height, value: stackedData ? value : value[1],
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	};
	
	var BarChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData }), (0, _AnimationDecorator2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(BarChart, _Component);
	
	  function BarChart() {
	    _classCallCheck(this, BarChart);
	
	    return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).apply(this, arguments));
	  }
	
	  _createClass(BarChart, [{
	    key: 'renderCursor',
	    value: function renderCursor(_ref4) {
	      var xAxisMap = _ref4.xAxisMap,
	          yAxisMap = _ref4.yAxisMap,
	          offset = _ref4.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
	      var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var bandSize = (0, _DataUtils.getBandSizeOfAxis)(axis);
	      var start = ticks[activeTooltipIndex].coordinate;
	      var cursorProps = _extends({
	        fill: '#f1f1f1'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        x: layout === 'horizontal' ? start : offset.left + 0.5,
	        y: layout === 'horizontal' ? offset.top + 0.5 : start,
	        width: layout === 'horizontal' ? bandSize : offset.width - 1,
	        height: layout === 'horizontal' ? offset.height - 1 : bandSize
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Rectangle2.default, _extends({}, cursorProps, { className: 'recharts-bar-cursor' }));
	    }
	
	    /**
	     * Draw the main part of bar chart
	     * @param  {Array} items     All the instance of Bar
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @return {ReactComponent}  All the instances of Bar
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, offset) {
	      if (!items || !items.length) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          layout = _props2.layout,
	          xAxisMap = _props2.xAxisMap,
	          yAxisMap = _props2.yAxisMap;
	      var _props3 = this.props,
	          animationId = _props3.animationId,
	          allComposedData = _props3.allComposedData;
	
	
	      return items.map(function (child, i) {
	        return _react2.default.cloneElement(child, _extends({
	          key: child.key || 'bar-' + i,
	          layout: layout,
	          animationId: animationId
	        }, offset, {
	          data: allComposedData[i],
	          xAxis: xAxisMap[child.props.xAxisId],
	          yAxis: yAxisMap[child.props.yAxisId]
	        }));
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          isComposed = _props4.isComposed,
	          graphicalItems = _props4.graphicalItems,
	          xAxisMap = _props4.xAxisMap,
	          yAxisMap = _props4.yAxisMap,
	          offset = _props4.offset;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-bar-graphical' },
	        !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
	        this.renderItems(graphicalItems, offset)
	      );
	    }
	  }]);
	
	  return BarChart;
	}(_react.Component), _class2.displayName = 'BarChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  axisTicks: _propTypes2.default.array,
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _propTypes2.default.number,
	  dataEndIndex: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  isTooltipActive: _propTypes2.default.bool,
	  activeTooltipIndex: _propTypes2.default.number,
	  xAxisMap: _propTypes2.default.object,
	  yAxisMap: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  graphicalItems: _propTypes2.default.array,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  stackGroups: _propTypes2.default.object,
	  barCategoryGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  barGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  barSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  maxBarSize: _propTypes2.default.number,
	  // used internally
	  isComposed: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number
	}, _class2.defaultProps = {
	  barCategoryGap: '10%',
	  barGap: 4
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(BarChart, _Bar2.default);
	exports.BarChart = BarChart;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LineChart = undefined;
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /**
	                                   * @fileOverview Line Chart
	                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Curve = __webpack_require__(93);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(75);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _generateCategoricalChart = __webpack_require__(200);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Line = __webpack_require__(310);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _AnimationDecorator = __webpack_require__(121);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _ComposedDataDecorator = __webpack_require__(141);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
	  var axis = _ref.axis,
	      ticks = _ref.ticks,
	      bandSize = _ref.bandSize,
	      entry = _ref.entry,
	      index = _ref.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = (0, _DataUtils.getValueByDataKey)(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) : null;
	};
	/**
	 * Compose the data of each group
	 * @param {Object} props The props from the component
	 * @param  {Object} xAxis   The configuration of x-axis
	 * @param  {Object} yAxis   The configuration of y-axis
	 * @param  {String} dataKey The unique key of a group
	 * @return {Array}  Composed data
	 */
	var getComposedData = function getComposedData(_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xTicks = _ref2.xTicks,
	      yTicks = _ref2.yTicks,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize;
	  var layout = props.layout,
	      dataStartIndex = props.dataStartIndex,
	      dataEndIndex = props.dataEndIndex;
	
	  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
	
	  return data.map(function (entry, index) {
	    var value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: getCategoryAxisCoordinate({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value) ? null : xAxis.scale(value),
	      y: getCategoryAxisCoordinate({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	};
	
	var LineChart = exports.LineChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData }), (0, _AnimationDecorator2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(LineChart, _Component);
	
	  function LineChart() {
	    _classCallCheck(this, LineChart);
	
	    return _possibleConstructorReturn(this, (LineChart.__proto__ || Object.getPrototypeOf(LineChart)).apply(this, arguments));
	  }
	
	  _createClass(LineChart, [{
	    key: 'renderCursor',
	    value: function renderCursor(_ref3) {
	      var offset = _ref3.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var start = ticks[activeTooltipIndex].coordinate;
	      var x1 = layout === 'horizontal' ? start : offset.left;
	      var y1 = layout === 'horizontal' ? offset.top : start;
	      var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
	      var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
	      var cursorProps = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Curve2.default, _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
	    }
	  }, {
	    key: 'renderActiveDot',
	    value: function renderActiveDot(option, props, childIndex) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        var className = (0, _classnames2.default)('recharts-line-active-dot', option.className);
	        dot = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: className }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: 'scale(0)',
	          to: 'scale(1)',
	          duration: 400,
	          key: 'dot-' + childIndex,
	          attributeName: 'transform'
	        },
	        _react2.default.createElement(
	          _Layer2.default,
	          { style: { transformOrigin: 'center center' } },
	          dot
	        )
	      );
	    }
	    /**
	     * Draw the main part of line chart
	     * @param  {Array} items     All the instance of Line
	     * @param  {Object} xAxisMap The configuration of all x-axes
	     * @param  {Object} yAxisMap The configuration of all y-axes
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @return {ReactComponent}  All the instances of Line
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, xAxisMap, yAxisMap, offset) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          layout = _props2.layout,
	          isTooltipActive = _props2.isTooltipActive,
	          activeTooltipIndex = _props2.activeTooltipIndex,
	          animationId = _props2.animationId,
	          allComposedData = _props2.allComposedData;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      var hasDot = tooltipItem && isTooltipActive;
	      var dotItems = [];
	
	      var lineItems = items.map(function (child, i) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            stroke = _child$props.stroke,
	            activeDot = _child$props.activeDot;
	
	        var points = allComposedData[i];
	        var activePoint = points[activeTooltipIndex];
	
	        if (hasDot && activeDot && activePoint) {
	          var dotProps = _extends({
	            index: activeTooltipIndex,
	            dataKey: dataKey,
	            cx: activePoint.x, cy: activePoint.y, r: 4,
	            fill: stroke, strokeWidth: 2, stroke: '#fff',
	            payload: activePoint.payload,
	            value: activePoint.value
	          }, (0, _ReactUtils.getPresentationAttributes)(activeDot));
	          dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));
	        }
	
	        return _react2.default.cloneElement(child, _extends({
	          key: child.key || 'line-' + i
	        }, offset, {
	          layout: layout,
	          points: points,
	          animationId: animationId,
	          xAxis: xAxisMap[child.props.xAxisId],
	          yAxis: yAxisMap[child.props.yAxisId]
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-chart-wrapper' },
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-line-chart' },
	          lineItems
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-line-chart-dot' },
	          dotItems
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          isComposed = _props3.isComposed,
	          xAxisMap = _props3.xAxisMap,
	          yAxisMap = _props3.yAxisMap,
	          offset = _props3.offset,
	          graphicalItems = _props3.graphicalItems;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-graphical' },
	        !isComposed && this.renderCursor({ offset: offset }),
	        this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset)
	      );
	    }
	  }]);
	
	  return LineChart;
	}(_react.Component), _class2.displayName = 'LineChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  axisTicks: _propTypes2.default.array,
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _propTypes2.default.number,
	  dataEndIndex: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  isTooltipActive: _propTypes2.default.bool,
	  activeTooltipIndex: _propTypes2.default.number,
	  xAxisMap: _propTypes2.default.object,
	  yAxisMap: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  graphicalItems: _propTypes2.default.array,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  // used internally
	  isComposed: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(LineChart, _Line2.default);

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ComposedChart = exports.RadialBarChart = exports.AreaChart = exports.ScatterChart = exports.RadarChart = exports.Sankey = exports.Treemap = exports.PieChart = exports.BarChart = exports.LineChart = exports.ErrorBar = exports.ZAxis = exports.YAxis = exports.XAxis = exports.Scatter = exports.Bar = exports.Area = exports.Line = exports.CartesianGrid = exports.CartesianAxis = exports.ReferenceArea = exports.ReferenceDot = exports.ReferenceLine = exports.Brush = exports.RadialBar = exports.Radar = exports.Pie = exports.PolarAngleAxis = exports.PolarRadiusAxis = exports.PolarGrid = exports.Symbols = exports.Cross = exports.Dot = exports.Polygon = exports.Rectangle = exports.Curve = exports.Sector = exports.Text = exports.Cell = exports.ResponsiveContainer = exports.Tooltip = exports.Legend = exports.Layer = exports.Surface = undefined;
	
	__webpack_require__(1521);
	
	var _Surface2 = __webpack_require__(63);
	
	var _Surface3 = _interopRequireDefault(_Surface2);
	
	var _Layer2 = __webpack_require__(23);
	
	var _Layer3 = _interopRequireDefault(_Layer2);
	
	var _Legend2 = __webpack_require__(92);
	
	var _Legend3 = _interopRequireDefault(_Legend2);
	
	var _Tooltip2 = __webpack_require__(47);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _ResponsiveContainer2 = __webpack_require__(1520);
	
	var _ResponsiveContainer3 = _interopRequireDefault(_ResponsiveContainer2);
	
	var _Cell2 = __webpack_require__(140);
	
	var _Cell3 = _interopRequireDefault(_Cell2);
	
	var _Text2 = __webpack_require__(40);
	
	var _Text3 = _interopRequireDefault(_Text2);
	
	var _Sector2 = __webpack_require__(314);
	
	var _Sector3 = _interopRequireDefault(_Sector2);
	
	var _Curve2 = __webpack_require__(93);
	
	var _Curve3 = _interopRequireDefault(_Curve2);
	
	var _Rectangle2 = __webpack_require__(94);
	
	var _Rectangle3 = _interopRequireDefault(_Rectangle2);
	
	var _Polygon2 = __webpack_require__(313);
	
	var _Polygon3 = _interopRequireDefault(_Polygon2);
	
	var _Dot2 = __webpack_require__(75);
	
	var _Dot3 = _interopRequireDefault(_Dot2);
	
	var _Cross2 = __webpack_require__(660);
	
	var _Cross3 = _interopRequireDefault(_Cross2);
	
	var _Symbols2 = __webpack_require__(315);
	
	var _Symbols3 = _interopRequireDefault(_Symbols2);
	
	var _PolarGrid2 = __webpack_require__(656);
	
	var _PolarGrid3 = _interopRequireDefault(_PolarGrid2);
	
	var _PolarRadiusAxis2 = __webpack_require__(657);
	
	var _PolarRadiusAxis3 = _interopRequireDefault(_PolarRadiusAxis2);
	
	var _PolarAngleAxis2 = __webpack_require__(655);
	
	var _PolarAngleAxis3 = _interopRequireDefault(_PolarAngleAxis2);
	
	var _Pie2 = __webpack_require__(654);
	
	var _Pie3 = _interopRequireDefault(_Pie2);
	
	var _Radar2 = __webpack_require__(658);
	
	var _Radar3 = _interopRequireDefault(_Radar2);
	
	var _RadialBar2 = __webpack_require__(659);
	
	var _RadialBar3 = _interopRequireDefault(_RadialBar2);
	
	var _Brush2 = __webpack_require__(647);
	
	var _Brush3 = _interopRequireDefault(_Brush2);
	
	var _ReferenceLine2 = __webpack_require__(199);
	
	var _ReferenceLine3 = _interopRequireDefault(_ReferenceLine2);
	
	var _ReferenceDot2 = __webpack_require__(198);
	
	var _ReferenceDot3 = _interopRequireDefault(_ReferenceDot2);
	
	var _ReferenceArea2 = __webpack_require__(197);
	
	var _ReferenceArea3 = _interopRequireDefault(_ReferenceArea2);
	
	var _CartesianAxis2 = __webpack_require__(308);
	
	var _CartesianAxis3 = _interopRequireDefault(_CartesianAxis2);
	
	var _CartesianGrid2 = __webpack_require__(309);
	
	var _CartesianGrid3 = _interopRequireDefault(_CartesianGrid2);
	
	var _Line2 = __webpack_require__(310);
	
	var _Line3 = _interopRequireDefault(_Line2);
	
	var _Area2 = __webpack_require__(306);
	
	var _Area3 = _interopRequireDefault(_Area2);
	
	var _Bar2 = __webpack_require__(307);
	
	var _Bar3 = _interopRequireDefault(_Bar2);
	
	var _Scatter2 = __webpack_require__(648);
	
	var _Scatter3 = _interopRequireDefault(_Scatter2);
	
	var _XAxis2 = __webpack_require__(311);
	
	var _XAxis3 = _interopRequireDefault(_XAxis2);
	
	var _YAxis2 = __webpack_require__(312);
	
	var _YAxis3 = _interopRequireDefault(_YAxis2);
	
	var _ZAxis2 = __webpack_require__(649);
	
	var _ZAxis3 = _interopRequireDefault(_ZAxis2);
	
	var _ErrorBar2 = __webpack_require__(196);
	
	var _ErrorBar3 = _interopRequireDefault(_ErrorBar2);
	
	var _LineChart2 = __webpack_require__(652);
	
	var _LineChart3 = _interopRequireDefault(_LineChart2);
	
	var _BarChart2 = __webpack_require__(651);
	
	var _BarChart3 = _interopRequireDefault(_BarChart2);
	
	var _PieChart2 = __webpack_require__(1512);
	
	var _PieChart3 = _interopRequireDefault(_PieChart2);
	
	var _Treemap2 = __webpack_require__(1517);
	
	var _Treemap3 = _interopRequireDefault(_Treemap2);
	
	var _Sankey2 = __webpack_require__(1515);
	
	var _Sankey3 = _interopRequireDefault(_Sankey2);
	
	var _RadarChart2 = __webpack_require__(1513);
	
	var _RadarChart3 = _interopRequireDefault(_RadarChart2);
	
	var _ScatterChart2 = __webpack_require__(1516);
	
	var _ScatterChart3 = _interopRequireDefault(_ScatterChart2);
	
	var _AreaChart2 = __webpack_require__(650);
	
	var _AreaChart3 = _interopRequireDefault(_AreaChart2);
	
	var _RadialBarChart2 = __webpack_require__(1514);
	
	var _RadialBarChart3 = _interopRequireDefault(_RadialBarChart2);
	
	var _ComposedChart2 = __webpack_require__(1511);
	
	var _ComposedChart3 = _interopRequireDefault(_ComposedChart2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Surface = _Surface3.default;
	exports.Layer = _Layer3.default;
	exports.Legend = _Legend3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.ResponsiveContainer = _ResponsiveContainer3.default;
	exports.Cell = _Cell3.default;
	exports.Text = _Text3.default;
	exports.Sector = _Sector3.default;
	exports.Curve = _Curve3.default;
	exports.Rectangle = _Rectangle3.default;
	exports.Polygon = _Polygon3.default;
	exports.Dot = _Dot3.default;
	exports.Cross = _Cross3.default;
	exports.Symbols = _Symbols3.default;
	exports.PolarGrid = _PolarGrid3.default;
	exports.PolarRadiusAxis = _PolarRadiusAxis3.default;
	exports.PolarAngleAxis = _PolarAngleAxis3.default;
	exports.Pie = _Pie3.default;
	exports.Radar = _Radar3.default;
	exports.RadialBar = _RadialBar3.default;
	exports.Brush = _Brush3.default;
	exports.ReferenceLine = _ReferenceLine3.default;
	exports.ReferenceDot = _ReferenceDot3.default;
	exports.ReferenceArea = _ReferenceArea3.default;
	exports.CartesianAxis = _CartesianAxis3.default;
	exports.CartesianGrid = _CartesianGrid3.default;
	exports.Line = _Line3.default;
	exports.Area = _Area3.default;
	exports.Bar = _Bar3.default;
	exports.Scatter = _Scatter3.default;
	exports.XAxis = _XAxis3.default;
	exports.YAxis = _YAxis3.default;
	exports.ZAxis = _ZAxis3.default;
	exports.ErrorBar = _ErrorBar3.default;
	exports.LineChart = _LineChart3.default;
	exports.BarChart = _BarChart3.default;
	exports.PieChart = _PieChart3.default;
	exports.Treemap = _Treemap3.default;
	exports.Sankey = _Sankey3.default;
	exports.RadarChart = _RadarChart3.default;
	exports.ScatterChart = _ScatterChart3.default;
	exports.AreaChart = _AreaChart3.default;
	exports.RadialBarChart = _RadialBarChart3.default;
	exports.ComposedChart = _ComposedChart3.default;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPlainObject2 = __webpack_require__(1649);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render sectors of a pie
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Sector = __webpack_require__(314);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Curve = __webpack_require__(93);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _PolarUtils = __webpack_require__(64);
	
	var _AnimationDecorator = __webpack_require__(121);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pie = (0, _AnimationDecorator2.default)(_class = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Pie, _Component);
	
	  function Pie() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pie.__proto__ || Object.getPrototypeOf(Pie)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-pie-'), _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Pie, [{
	    key: 'getDeltaAngle',
	    value: function getDeltaAngle() {
	      var _props = this.props,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle;
	
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	      return sign * deltaAngle;
	    }
	  }, {
	    key: 'getSectors',
	    value: function getSectors(data) {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          innerRadius = _props2.innerRadius,
	          outerRadius = _props2.outerRadius,
	          cornerRadius = _props2.cornerRadius,
	          startAngle = _props2.startAngle,
	          paddingAngle = _props2.paddingAngle,
	          minAngle = _props2.minAngle,
	          nameKey = _props2.nameKey,
	          valueKey = _props2.valueKey;
	
	      var len = data.length;
	      var deltaAngle = this.getDeltaAngle();
	      var absDeltaAngle = Math.abs(deltaAngle);
	      var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	      var sum = data.reduce(function (result, entry) {
	        return result + (0, _DataUtils.getValueByDataKey)(entry, valueKey, 0);
	      }, 0);
	
	      var sectors = [];
	      var prev = void 0;
	
	      if (sum > 0) {
	        sectors = data.map(function (entry, i) {
	          var percent = (0, _DataUtils.getValueByDataKey)(entry, valueKey, 0) / sum;
	
	          var tempStartAngle = void 0;
	
	          if (i) {
	            tempStartAngle = (deltaAngle < 0 ? prev.endAngle : prev.startAngle) + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	          } else {
	            tempStartAngle = startAngle;
	          }
	
	          var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * (absDeltaAngle - len * minAngle - totalPadingAngle));
	
	          prev = _extends({
	            percent: percent,
	            cornerRadius: cornerRadius
	          }, entry, {
	            cx: cx,
	            cy: cy,
	            innerRadius: innerRadius,
	            outerRadius: outerRadius,
	            name: (0, _DataUtils.getValueByDataKey)(entry, nameKey),
	            value: (0, _DataUtils.getValueByDataKey)(entry, valueKey),
	            startAngle: deltaAngle < 0 ? tempStartAngle : tempEndAngle,
	            endAngle: deltaAngle < 0 ? tempEndAngle : tempStartAngle,
	            midAngle: (tempStartAngle + tempEndAngle) / 2
	          });
	
	          return prev;
	        });
	      }
	
	      return sectors;
	    }
	  }, {
	    key: 'getTextAnchor',
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      } else if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: 'isActiveIndex',
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: 'renderClipPath',
	    value: function renderClipPath() {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy,
	          maxRadius = _props3.maxRadius,
	          startAngle = _props3.startAngle,
	          isAnimationActive = _props3.isAnimationActive,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          animationBegin = _props3.animationBegin,
	          animationId = _props3.animationId;
	
	
	      return _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'clipPath',
	          { id: this.id },
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration,
	              key: animationId,
	              animationBegin: animationBegin,
	              onAnimationEnd: this.handleAnimationEnd,
	              from: {
	                endAngle: startAngle
	              },
	              to: {
	                outerRadius: Math.max(this.props.outerRadius, maxRadius || 0),
	                innerRadius: 0,
	                endAngle: this.props.endAngle
	              }
	            },
	            function (_ref2) {
	              var outerRadius = _ref2.outerRadius,
	                  innerRadius = _ref2.innerRadius,
	                  endAngle = _ref2.endAngle;
	              return _react2.default.createElement(_Sector2.default, {
	                cx: cx,
	                cy: cy,
	                outerRadius: outerRadius,
	                innerRadius: innerRadius,
	                startAngle: startAngle,
	                endAngle: endAngle
	              });
	            }
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderLabelLineItem',
	    value: function renderLabelLineItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Curve2.default, _extends({}, props, { type: 'linear', className: 'recharts-pie-label-line' }));
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      }
	      var label = value;
	      if ((0, _isFunction3.default)(option)) {
	        label = option(props);
	        if (_react2.default.isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react2.default.createElement(
	        _Text2.default,
	        _extends({}, props, {
	          alignmentBaseline: 'middle',
	          className: 'recharts-pie-label-text'
	        }),
	        label
	      );
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props4 = this.props,
	          label = _props4.label,
	          labelLine = _props4.labelLine,
	          valueKey = _props4.valueKey;
	
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	        var labelProps = _extends({}, pieProps, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	        var lineProps = _extends({}, pieProps, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          { key: 'label-' + i },
	          labelLine && _this2.renderLabelLineItem(labelLine, lineProps),
	          _this2.renderLabelItem(label, labelProps, (0, _DataUtils.getValueByDataKey)(entry, valueKey))
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-pie-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderSectorItem',
	    value: function renderSectorItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      } else if ((0, _isPlainObject3.default)(option)) {
	        return _react2.default.createElement(_Sector2.default, _extends({}, props, option));
	      }
	
	      return _react2.default.createElement(_Sector2.default, props);
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors(sectors) {
	      var _this3 = this;
	
	      var activeShape = this.props.activeShape;
	
	
	      return sectors.map(function (entry, i) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-pie-sector'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	            key: 'sector-' + i
	          }),
	          _this3.renderSectorItem(_this3.isActiveIndex(i) ? activeShape : null, entry)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          data = _props5.data,
	          composedData = _props5.composedData,
	          className = _props5.className,
	          label = _props5.label,
	          cx = _props5.cx,
	          cy = _props5.cy,
	          innerRadius = _props5.innerRadius,
	          outerRadius = _props5.outerRadius;
	
	      var pieData = composedData || data;
	
	      if (!pieData || !pieData.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var sectors = this.getSectors(pieData);
	      var layerClass = (0, _classnames2.default)('recharts-pie', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        this.renderClipPath(),
	        _react2.default.createElement(
	          'g',
	          { clipPath: 'url(#' + this.id + ')' },
	          this.renderSectors(sectors)
	        ),
	        label && this.renderLabels(sectors)
	      );
	    }
	  }]);
	
	  return Pie;
	}(_react.Component), _class2.displayName = 'Pie', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  animationId: _propTypes2.default.number,
	  cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  paddingAngle: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  valueKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  composedData: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  minAngle: _propTypes2.default.number,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  maxRadius: _propTypes2.default.number,
	
	  labelLine: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.shape({
	    offsetRadius: _propTypes2.default.number
	  }), _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
	}), _class2.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  nameKey: 'name',
	  valueKey: 'value',
	  labelLine: true,
	  data: [],
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class) || _class;
	
	exports.default = Pie;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Axis of radial direction
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _Dot = __webpack_require__(75);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Polygon = __webpack_require__(313);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PolarUtils = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarAngleAxis, _Component);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, (PolarAngleAxis.__proto__ || Object.getPrototypeOf(PolarAngleAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: 'getTickLineCoord',
	
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          radius = _props.radius,
	          orientation = _props.orientation,
	          tickLine = _props.tickLine;
	
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.angle);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.angle);
	
	      return { x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	
	      var cos = Math.cos(-data.angle * RADIAN);
	      var textAnchor = void 0;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          radius = _props2.radius,
	          axisLine = _props2.axisLine,
	          axisLineType = _props2.axisLineType;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react2.default.createElement(_Dot2.default, _extends({
	          className: 'recharts-polar-angle-axis-line'
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	      var ticks = this.props.ticks;
	
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.angle);
	      });
	
	      return _react2.default.createElement(_Polygon2.default, _extends({ className: 'recharts-polar-angle-axis-line' }, props, { points: points }));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-angle-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          ticks = _props3.ticks,
	          tick = _props3.tick,
	          tickLine = _props3.tickLine,
	          tickFormatter = _props3.tickFormatter,
	          stroke = _props3.stroke;
	
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this2.getTickLineCoord(entry);
	        var textAnchor = _this2.getTickTextAnchor(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i, payload: entry,
	          x: lineCoord.x2, y: lineCoord.y2
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-angle-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-polar-angle-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          radius = _props4.radius,
	          axisLine = _props4.axisLine;
	
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis' },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks()
	      );
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.Component), _class2.displayName = 'PolarAngleAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  hide: _propTypes2.default.bool,
	
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  axisLineType: _propTypes2.default.oneOf(['polygon', 'circle']),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    angle: _propTypes2.default.number
	  })),
	  stroke: _propTypes2.default.string,
	  orientation: _propTypes2.default.oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes2.default.func
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false
	}, _temp)) || _class;
	
	exports.default = PolarAngleAxis;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polar Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _PolarUtils = __webpack_require__(64);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarGrid, _Component);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, (PolarGrid.__proto__ || Object.getPrototypeOf(PolarGrid)).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: 'getPolygonPath',
	    value: function getPolygonPath(radius) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          polarAngles = _props.polarAngles;
	
	
	      var path = '';
	
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += 'L ' + point.x + ',' + point.y;
	        } else {
	          path += 'M ' + point.x + ',' + point.y;
	        }
	      });
	      path += 'Z';
	
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: 'renderPolarAngles',
	    value: function renderPolarAngles() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          innerRadius = _props2.innerRadius,
	          outerRadius = _props2.outerRadius,
	          polarAngles = _props2.polarAngles;
	
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-angle' },
	        polarAngles.map(function (entry, i) {
	          var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	          var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	
	          return _react2.default.createElement('line', _extends({}, props, {
	            key: 'line-' + i,
	            x1: start.x,
	            y1: start.y,
	            x2: end.x,
	            y2: end.y
	          }));
	        })
	      );
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: 'renderConcentricCircle',
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy;
	
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('circle', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-circle',
	        key: 'circle-' + index,
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: 'renderConcentricPolygon',
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('path', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-polygon',
	        key: 'path-' + index,
	        d: this.getPolygonPath(radius)
	      }));
	    }
	
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: 'renderConcentricPath',
	    value: function renderConcentricPath() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          polarRadius = _props4.polarRadius,
	          gridType = _props4.gridType;
	
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-concentric' },
	        polarRadius.map(function (entry, i) {
	          return gridType === 'circle' ? _this2.renderConcentricCircle(entry, i) : _this2.renderConcentricPolygon(entry, i);
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid' },
	        this.renderPolarAngles(),
	        this.renderConcentricPath()
	      );
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.Component), _class2.displayName = 'PolarGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	
	  polarAngles: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  polarRadius: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  gridType: _propTypes2.default.oneOf(['polygon', 'circle'])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	}, _temp)) || _class;
	
	exports.default = PolarGrid;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maxBy2 = __webpack_require__(683);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview The axis of polar coordinate system
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _PolarUtils = __webpack_require__(64);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarRadiusAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarRadiusAxis, _Component);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, (PolarRadiusAxis.__proto__ || Object.getPrototypeOf(PolarRadiusAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: 'getTickValueCoord',
	
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Object} radius The data of a simple tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var radius = _ref.radius;
	      var _props = this.props,
	          angle = _props.angle,
	          cx = _props.cx,
	          cy = _props.cy;
	
	
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	        case 'right':
	          textAnchor = 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          angle = _props2.angle,
	          ticks = _props2.ticks,
	          axisLine = _props2.axisLine,
	          others = _objectWithoutProperties(_props2, ['cx', 'cy', 'angle', 'ticks', 'axisLine']);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.radius), Math.max(result[1], entry.radius)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-polar-radius-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-radius-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          ticks = _props3.ticks,
	          tick = _props3.tick,
	          angle = _props3.angle,
	          tickFormatter = _props3.tickFormatter,
	          stroke = _props3.stroke,
	          others = _objectWithoutProperties(_props3, ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke']);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var items = ticks.map(function (entry, i) {
	        var coord = _this2.getTickValueCoord(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-radius-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var label = this.props.label;
	
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          angle = _props4.angle,
	          stroke = _props4.stroke,
	          others = _objectWithoutProperties(_props4, ['ticks', 'angle', 'stroke']);
	
	      var maxRadiusTick = (0, _maxBy3.default)(ticks, function (entry) {
	        return entry.radius || 0;
	      });
	      var radius = maxRadiusTick.radius || 0;
	      var coord = this.getTickValueCoord({ radius: radius + 10 });
	      var props = _extends({}, others, {
	        stroke: 'none',
	        fill: stroke
	      }, coord, {
	        textAnchor: 'middle',
	        transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
	      });
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-polar-radius-axis-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          ticks = _props5.ticks,
	          axisLine = _props5.axisLine,
	          tick = _props5.tick;
	
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis' },
	        axisLine && this.renderAxisLine(),
	        tick && this.renderTicks(),
	        this.renderLabel()
	      );
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.Component), _class2.displayName = 'PolarRadiusAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  hide: _propTypes2.default.bool,
	
	  angle: _propTypes2.default.number,
	  tickCount: _propTypes2.default.number,
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    radius: _propTypes2.default.value
	  })),
	  orientation: _propTypes2.default.oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _propTypes2.default.func]),
	  allowDataOverflow: _propTypes2.default.bool
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto'
	}, _temp)) || _class;
	
	exports.default = PolarRadiusAxis;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _Polygon = __webpack_require__(313);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Dot = __webpack_require__(75);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(40);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Radar, _Component);
	
	  function Radar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radar.__proto__ || Object.getPrototypeOf(Radar)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    }, _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Radar, [{
	    key: 'renderPolygon',
	    value: function renderPolygon() {
	      /* eslint-disable no-unused-vars */
	      var _props = this.props,
	          shape = _props.shape,
	          points = _props.points,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing,
	          animationBegin = _props.animationBegin,
	          isAnimationActive = _props.isAnimationActive,
	          animationId = _props.animationId,
	          dataKey = _props.dataKey,
	          className = _props.className,
	          others = _objectWithoutProperties(_props, ['shape', 'points', 'animationDuration', 'animationEasing', 'animationBegin', 'isAnimationActive', 'animationId', 'dataKey', 'className']);
	      /* eslint-enable no-unused-vars */
	
	      if (_react2.default.isValidElement(shape)) {
	        return _react2.default.cloneElement(shape, _extends({}, others, { points: points }));
	      } else if ((0, _isFunction3.default)(shape)) {
	        return shape(this.props);
	      }
	
	      var point = points[0];
	      var transformPoints = points.map(function (p) {
	        return { x: p.x - point.cx, y: p.y - point.cy };
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-polygon', transform: 'translate(' + point.cx + ', ' + point.cy + ')' },
	        _react2.default.createElement(
	          _reactSmooth2.default,
	          {
	            from: 'scale(0)',
	            to: 'scale(1)',
	            attributeName: 'transform',
	            isActive: isAnimationActive,
	            begin: animationBegin,
	            easing: animationEasing,
	            duration: animationDuration,
	            key: animationId
	          },
	          _react2.default.createElement(_Polygon2.default, _extends({
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave
	          }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	            points: transformPoints
	          }))
	        )
	      );
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            key: props.key
	          }, props, {
	            className: 'recharts-radar-label'
	          }),
	          value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          points = _props2.points,
	          label = _props2.label;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = points.map(function (entry, i) {
	        var labelProps = _extends({
	          textAnchor: 'middle'
	        }, baseProps, {
	          stroke: 'none',
	          fill: baseProps && baseProps.stroke || '#666'
	        }, customLabelProps, entry, {
	          index: i,
	          key: 'label-' + i,
	          payload: entry
	        });
	
	        return _this2.renderLabelItem(label, labelProps, entry.value);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-radar-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          dot = _props3.dot,
	          points = _props3.points;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, baseProps, customDotProps, {
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          playload: entry
	        });
	
	        return _this3.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          points = _props4.points,
	          label = _props4.label,
	          dot = _props4.dot;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-radar', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        this.renderPolygon(),
	        label && this.renderLabels(),
	        dot && this.renderDots()
	      );
	    }
	  }]);
	
	  return Radar;
	}(_react.Component), _class2.displayName = 'Radar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    angle: _propTypes2.default.number,
	    radius: _propTypes2.default.number,
	    value: _propTypes2.default.number,
	    payload: _propTypes2.default.object
	  })),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.bool]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  dot: false,
	  label: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = Radar;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of radial bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Sector = __webpack_require__(314);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _DOMUtils = __webpack_require__(142);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _PolarUtils = __webpack_require__(64);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIAN = Math.PI / 180;
	
	var RadialBar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadialBar, _Component);
	
	  function RadialBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBar.__proto__ || Object.getPrototypeOf(RadialBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: false
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadialBar, [{
	    key: 'getDeltaAngle',
	    value: function getDeltaAngle() {
	      var _props = this.props,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle;
	
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	      return sign * deltaAngle;
	    }
	  }, {
	    key: 'getSectors',
	    value: function getSectors() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          startAngle = _props2.startAngle,
	          data = _props2.data,
	          minAngle = _props2.minAngle,
	          maxAngle = _props2.maxAngle;
	
	      var maxValue = Math.max.apply(null, data.map(function (entry) {
	        return Math.abs(entry.value);
	      }));
	      var absMinAngle = Math.abs(minAngle);
	      var absMaxAngle = Math.abs(maxAngle);
	      var deltaAngle = this.getDeltaAngle();
	      var gapAngle = Math.min(Math.abs(absMaxAngle - absMinAngle), 360);
	
	      var sectors = data.map(function (entry) {
	        var value = entry.value;
	        var tempEndAngle = maxValue === 0 ? startAngle : startAngle + (0, _DataUtils.mathSign)(value * deltaAngle) * (absMinAngle + gapAngle * Math.abs(entry.value) / maxValue);
	
	        return _extends({}, entry, {
	          cx: cx, cy: cy,
	          startAngle: startAngle,
	          endAngle: tempEndAngle,
	          payload: entry
	        });
	      });
	
	      return sectors;
	    }
	  }, {
	    key: 'getLabelPathArc',
	    value: function getLabelPathArc(data, labelContent, style) {
	      var label = this.props.label;
	
	      var labelProps = _react2.default.isValidElement(label) ? label.props : label;
	      var offsetRadius = labelProps.offsetRadius || 2;
	      var orientation = labelProps.orientation || 'inner';
	      var cx = data.cx,
	          cy = data.cy,
	          innerRadius = data.innerRadius,
	          outerRadius = data.outerRadius,
	          startAngle = data.startAngle,
	          endAngle = data.endAngle;
	
	      var clockWise = this.getDeltaAngle() < 0 && data.value > 0;
	      var radius = clockWise ? innerRadius + offsetRadius : Math.max(outerRadius - offsetRadius, 0);
	
	      if (radius <= 0) {
	        return '';
	      }
	
	      var labelSize = (0, _DOMUtils.getStringSize)(labelContent, style);
	      var deltaAngle = labelSize.width / (radius * RADIAN);
	      var tempStartAngle = void 0,
	          tempEndAngle = void 0;
	
	      if (clockWise) {
	        tempStartAngle = orientation === 'inner' ? Math.min(endAngle + deltaAngle, startAngle) : endAngle;
	        tempEndAngle = tempStartAngle - deltaAngle;
	      } else {
	        tempStartAngle = orientation === 'inner' ? Math.max(endAngle - deltaAngle, startAngle) : endAngle;
	        tempEndAngle = tempStartAngle + deltaAngle;
	      }
	
	      var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, tempStartAngle);
	      var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, tempEndAngle);
	
	      return 'M' + startPoint.x + ',' + startPoint.y + '\n            A' + radius + ',' + radius + ',0,\n            ' + (deltaAngle >= 180 ? 1 : 0) + ',\n            ' + (clockWise ? 1 : 0) + ',\n            ' + endPoint.x + ',' + endPoint.y;
	    }
	  }, {
	    key: 'renderSectorShape',
	    value: function renderSectorShape(shape, props) {
	      var sectorShape = void 0;
	
	      if (_react2.default.isValidElement(shape)) {
	        sectorShape = _react2.default.cloneElement(shape, props);
	      } else if ((0, _isFunction3.default)(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react2.default.createElement(_Sector2.default, props);
	      }
	
	      return sectorShape;
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors(sectors) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          shape = _props3.shape,
	          activeShape = _props3.activeShape,
	          activeIndex = _props3.activeIndex,
	          cornerRadius = _props3.cornerRadius;
	      var _props4 = this.props,
	          animationEasing = _props4.animationEasing,
	          animationDuration = _props4.animationDuration,
	          animationBegin = _props4.animationBegin,
	          isAnimationActive = _props4.isAnimationActive;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return sectors.map(function (entry, i) {
	        var startAngle = entry.startAngle,
	            endAngle = entry.endAngle;
	
	
	        return _react2.default.createElement(
	          _reactSmooth2.default,
	          {
	            from: { angle: startAngle },
	            to: { angle: endAngle },
	            begin: animationBegin,
	            isActive: isAnimationActive,
	            duration: animationDuration,
	            easing: animationEasing,
	            shouldReAnimate: true,
	            key: 'aniamte-' + i,
	            onAnimationStart: _this2.handleAnimationStart,
	            onAnimationEnd: _this2.handleAnimationEnd
	          },
	          function (_ref2) {
	            var angle = _ref2.angle;
	
	            var props = _extends({}, baseProps, {
	              cornerRadius: cornerRadius
	            }, entry, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	              endAngle: angle,
	              key: 'sector-' + i,
	              className: 'recharts-radial-bar-sector'
	            });
	
	            return _this2.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	          }
	        );
	      });
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground(sectors) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          startAngle = _props5.startAngle,
	          endAngle = _props5.endAngle,
	          background = _props5.background,
	          cornerRadius = _props5.cornerRadius;
	
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(background);
	
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            rest = _objectWithoutProperties(entry, ['value']);
	
	        var props = _extends({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	          startAngle: startAngle,
	          endAngle: endAngle,
	          index: i,
	          key: 'sector-' + i,
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this3.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        var id = (0, _DataUtils.uniqueId)('recharts-defs-');
	        var filteredProps = (0, _ReactUtils.getPresentationAttributes)(props);
	        var path = this.getLabelPathArc(props, value, filteredProps);
	
	        labelItem = _react2.default.createElement(
	          'text',
	          _extends({}, filteredProps, { key: props.key, className: 'recharts-radial-bar-label' }),
	          _react2.default.createElement(
	            'defs',
	            null,
	            _react2.default.createElement('path', { id: id, d: path })
	          ),
	          _react2.default.createElement(
	            'textPath',
	            { xlinkHref: '#' + id },
	            value
	          )
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(sectors) {
	      var _this4 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var label = this.props.label;
	
	
	      return sectors.map(function (entry, i) {
	        var props = _extends({
	          fontSize: 10
	        }, entry, (0, _ReactUtils.getPresentationAttributes)(label), {
	          index: i,
	          key: 'label-' + i
	        });
	
	        return _this4.renderLabelItem(label, props, entry.value);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          data = _props6.data,
	          className = _props6.className,
	          background = _props6.background,
	          label = _props6.label;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var sectors = this.getSectors();
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        background && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-background' },
	          this.renderBackground(sectors)
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-sectors' },
	          this.renderSectors(sectors)
	        ),
	        label && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-labels' },
	          this.renderLabels(sectors)
	        )
	      );
	    }
	  }]);
	
	  return RadialBar;
	}(_react.Component), _class2.displayName = 'RadialBar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.number,
	
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  maxAngle: _propTypes2.default.number,
	  minAngle: _propTypes2.default.number,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    innerRadius: _propTypes2.default.number,
	    outerRadius: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object]),
	  background: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	}), _class2.defaultProps = {
	  startAngle: 180,
	  endAngle: 0,
	  maxAngle: 135,
	  minAngle: 0,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = RadialBar;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cross
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(16);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cross = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Cross, _Component);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, (Cross.__proto__ || Object.getPrototypeOf(Cross)).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: 'getPath',
	    value: function getPath(x, y, width, height, top, left) {
	      return 'M' + x + ',' + top + 'v' + height + 'M' + left + ',' + y + 'h' + width;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          top = _props.top,
	          left = _props.left,
	          className = _props.className;
	
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-cross', className),
	        d: this.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }]);
	
	  return Cross;
	}(_react.Component), _class2.displayName = 'Cross', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  className: _propTypes2.default.string
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	}, _temp)) || _class;
	
	exports.default = Cross;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(1530)
	  , createDesc = __webpack_require__(1531);
	module.exports = __webpack_require__(318) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 662 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 663 */
[1684, 203, 1639, 1640, 1641, 1642, 1643],
/* 664 */
286,
/* 665 */
625,
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(122);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 667 */
[1697, 1571, 78],
/* 668 */
607,
/* 669 */
[1709, 27, 328, 1644, 1659],
/* 670 */
[1713, 1556, 1562, 1591],
/* 671 */
582,
/* 672 */
[1728, 329, 208, 327, 77],
/* 673 */
[1731, 77],
/* 674 */
584,
/* 675 */
615,
/* 676 */
585,
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(77),
	    now = __webpack_require__(1652),
	    toNumber = __webpack_require__(685);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 678 */
[1752, 325],
/* 679 */
[1756, 55, 1655],
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(76),
	    isObjectLike = __webpack_require__(78);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(76),
	    isArray = __webpack_require__(27),
	    isObjectLike = __webpack_require__(78);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 682 */
[1760, 1574, 668, 1631],
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(666),
	    baseGt = __webpack_require__(1568),
	    baseIteratee = __webpack_require__(326);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 684 */
[1781, 1564, 1580, 1584, 672],
/* 685 */
[1766, 1590, 77, 122],
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.65c7f257.png";

/***/ },
/* 687 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 688 */
/***/ function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(702);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _openIam = __webpack_require__(1037);
	
	var _openIam2 = _interopRequireDefault(_openIam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValidateConstructor = function ValidateConstructor(config) {
	  return function (_Component) {
	    _inherits(Validate, _Component);
	
	    function Validate() {
	      _classCallCheck(this, Validate);
	
	      return _possibleConstructorReturn(this, (Validate.__proto__ || Object.getPrototypeOf(Validate)).apply(this, arguments));
	    }
	
	    _createClass(Validate, [{
	      key: 'deepMap',
	      value: function deepMap(children, deepMapFn) {
	        var _this2 = this;
	
	        return _react.Children.map(children, function (child) {
	          if (child) {
	            if (child.props && child.props.children && _typeof(child.props.children) === 'object') {
	              // Clone the child that has children and map them too
	              return deepMapFn((0, _react.cloneElement)(child, _extends({}, child.props, {
	                children: _this2.deepMap(child.props.children, deepMapFn)
	              })));
	            }
	            return deepMapFn(child);
	          } else {
	            return child;
	          }
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var localIam = config.iam;
	        var children = null;
	
	        //if action and resource was tagged to validate then it is applyed to every child nested inside
	        if (this.props && this.props.iamAction && this.props.iamResource) {
	          //check auth based on the iam doc action and resource to decide if this child content should be displayed.
	          if (_openIam2.default.authorize(this.props.iamResource, this.props.iamAction, _openIam2.default.processIamData(localIam))) {
	            //set childWithProps to the unaltered children because auth returned true
	            children = this.props.children;
	          } else {
	            //return nothing to display to the dom because authorize returned false
	            children = null;
	          }
	        } else {
	          //else validate will loop its children recursively and look for action/resources tagged to any ui element
	          children = this.deepMap(this.props.children, function (child) {
	            //if this child has action and resource run auth against it
	            if (child.props && child.props.iamAction && child.props.iamResource) {
	              //either return the child or blank based on iam authorize
	              return _openIam2.default.authorize(child.props.iamResource, child.props.iamAction, _openIam2.default.processIamData(localIam)) ? child : '';
	            } else {
	              //no action or resource so its a normal dom element
	              return child;
	            }
	          });
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'none', style: {'display':'inline-block'} },
	          children
	        );
	      }
	    }]);
	
	    return Validate;
	  }(_react.Component);
	};
	
	exports.default = ValidateConstructor;

/***/ },
/* 690 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(145);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var ReactBaseClasses = __webpack_require__(333);
	var ReactChildren = __webpack_require__(693);
	var ReactDOMFactories = __webpack_require__(694);
	var ReactElement = __webpack_require__(96);
	var ReactPropTypes = __webpack_require__(695);
	var ReactVersion = __webpack_require__(696);
	
	var createReactClass = __webpack_require__(697);
	var onlyChild = __webpack_require__(700);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(691);
	var ReactElement = __webpack_require__(96);
	
	var emptyFunction = __webpack_require__(38);
	var traverseAllChildren = __webpack_require__(701);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(96);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(96),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(1041);
	
	module.exports = factory(isValidElement);

/***/ },
/* 696 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(333),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(96),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(336);
	var factory = __webpack_require__(402);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 698 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(145);
	
	var ReactElement = __webpack_require__(96);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(145);
	
	var ReactCurrentOwner = __webpack_require__(334);
	var REACT_ELEMENT_TYPE = __webpack_require__(335);
	
	var getIteratorFn = __webpack_require__(698);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(690);
	var warning = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 702 */
[1674, 692],
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	;(function () {
	
	  var object =  true ? exports : self; // #8: web workers
	  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	  function InvalidCharacterError(message) {
	    this.message = message;
	  }
	  InvalidCharacterError.prototype = new Error;
	  InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	  // encoder
	  // [https://gist.github.com/999166] by [https://github.com/nignag]
	  object.btoa || (
	  object.btoa = function (input) {
	    var str = String(input);
	    for (
	      // initialize result and counter
	      var block, charCode, idx = 0, map = chars, output = '';
	      // if the next str index does not exist:
	      //   change the mapping table to "="
	      //   check if d has no fractional digits
	      str.charAt(idx | 0) || (map = '=', idx % 1);
	      // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	      output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	    ) {
	      charCode = str.charCodeAt(idx += 3/4);
	      if (charCode > 0xFF) {
	        throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
	      }
	      block = block << 8 | charCode;
	    }
	    return output;
	  });
	
	  // decoder
	  // [https://gist.github.com/1020396] by [https://github.com/atk]
	  object.atob || (
	  object.atob = function (input) {
	    var str = String(input).replace(/=+$/, '');
	    if (str.length % 4 == 1) {
	      throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	    }
	    for (
	      // initialize result and counters
	      var bc = 0, bs, buffer, idx = 0, output = '';
	      // get next character
	      buffer = str.charAt(idx++);
	      // character found in table? initialize bit storage and add its ascii value;
	      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	        // and if not first of each 4 characters,
	        // convert the first 8 bits to one ascii character
	        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	    ) {
	      // try to find character in table (0-63, not found => -1)
	      buffer = chars.indexOf(buffer);
	    }
	    return output;
	  });
	
	}());


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * accounting.js v0.4.1
	 * Copyright 2014 Open Exchange Rates
	 *
	 * Freely distributable under the MIT license.
	 * Portions of accounting.js are inspired or borrowed from underscore.js
	 *
	 * Full details and documentation:
	 * http://openexchangerates.github.io/accounting.js/
	 */
	
	(function(root, undefined) {
	
		/* --- Setup --- */
	
		// Create the local library object, to be exported or referenced globally later
		var lib = {};
	
		// Current version
		lib.version = '0.4.1';
	
	
		/* --- Exposed settings --- */
	
		// The library's settings configuration object. Contains default parameters for
		// currency and number formatting
		lib.settings = {
			currency: {
				symbol : "$",		// default currency symbol is '$'
				format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
				decimal : ".",		// decimal point separator
				thousand : ",",		// thousands separator
				precision : 2,		// decimal places
				grouping : 3		// digit grouping (not implemented yet)
			},
			number: {
				precision : 0,		// default precision on numbers is 0
				grouping : 3,		// digit grouping (not implemented yet)
				thousand : ",",
				decimal : "."
			}
		};
	
	
		/* --- Internal Helper Methods --- */
	
		// Store reference to possibly-available ECMAScript 5 methods for later
		var nativeMap = Array.prototype.map,
			nativeIsArray = Array.isArray,
			toString = Object.prototype.toString;
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js
		 */
		function isString(obj) {
			return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
		}
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js, delegates to ECMA5's native Array.isArray
		 */
		function isArray(obj) {
			return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
		}
	
		/**
		 * Tests whether supplied parameter is a true object
		 */
		function isObject(obj) {
			return obj && toString.call(obj) === '[object Object]';
		}
	
		/**
		 * Extends an object with a defaults object, similar to underscore's _.defaults
		 *
		 * Used for abstracting parameter handling from API methods
		 */
		function defaults(object, defs) {
			var key;
			object = object || {};
			defs = defs || {};
			// Iterate over object non-prototype properties:
			for (key in defs) {
				if (defs.hasOwnProperty(key)) {
					// Replace values with defaults only if undefined (allow empty/zero values):
					if (object[key] == null) object[key] = defs[key];
				}
			}
			return object;
		}
	
		/**
		 * Implementation of `Array.map()` for iteration loops
		 *
		 * Returns a new Array as a result of calling `iterator` on each array value.
		 * Defers to native Array.map if available
		 */
		function map(obj, iterator, context) {
			var results = [], i, j;
	
			if (!obj) return results;
	
			// Use native .map method if it exists:
			if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	
			// Fallback for native .map:
			for (i = 0, j = obj.length; i < j; i++ ) {
				results[i] = iterator.call(context, obj[i], i, obj);
			}
			return results;
		}
	
		/**
		 * Check and normalise the value of precision (must be positive integer)
		 */
		function checkPrecision(val, base) {
			val = Math.round(Math.abs(val));
			return isNaN(val)? base : val;
		}
	
	
		/**
		 * Parses a format string or object and returns format obj for use in rendering
		 *
		 * `format` is either a string with the default (positive) format, or object
		 * containing `pos` (required), `neg` and `zero` values (or a function returning
		 * either a string or object)
		 *
		 * Either string or format.pos must contain "%v" (value) to be valid
		 */
		function checkCurrencyFormat(format) {
			var defaults = lib.settings.currency.format;
	
			// Allow function as format parameter (should return string or object):
			if ( typeof format === "function" ) format = format();
	
			// Format can be a string, in which case `value` ("%v") must be present:
			if ( isString( format ) && format.match("%v") ) {
	
				// Create and return positive, negative and zero formats:
				return {
					pos : format,
					neg : format.replace("-", "").replace("%v", "-%v"),
					zero : format
				};
	
			// If no format, or object is missing valid positive value, use defaults:
			} else if ( !format || !format.pos || !format.pos.match("%v") ) {
	
				// If defaults is a string, casts it to an object for faster checking next time:
				return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
					pos : defaults,
					neg : defaults.replace("%v", "-%v"),
					zero : defaults
				};
	
			}
			// Otherwise, assume format was fine:
			return format;
		}
	
	
		/* --- API Methods --- */
	
		/**
		 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
		 * Alias: `accounting.parse(string)`
		 *
		 * Decimal must be included in the regular expression to match floats (defaults to
		 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
		 * separator, provide it as the second argument.
		 *
		 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
		 *
		 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
		 */
		var unformat = lib.unformat = lib.parse = function(value, decimal) {
			// Recursively unformat arrays:
			if (isArray(value)) {
				return map(value, function(val) {
					return unformat(val, decimal);
				});
			}
	
			// Fails silently (need decent errors):
			value = value || 0;
	
			// Return the value as-is if it's already a number:
			if (typeof value === "number") return value;
	
			// Default decimal point comes from settings, but could be set to eg. "," in opts:
			decimal = decimal || lib.settings.number.decimal;
	
			 // Build regex to strip out everything except digits, decimal point and minus sign:
			var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
				unformatted = parseFloat(
					("" + value)
					.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
					.replace(regex, '')         // strip out any cruft
					.replace(decimal, '.')      // make sure decimal point is standard
				);
	
			// This will fail silently which may cause trouble, let's wait and see:
			return !isNaN(unformatted) ? unformatted : 0;
		};
	
	
		/**
		 * Implementation of toFixed() that treats floats more like decimals
		 *
		 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
		 * problems for accounting- and finance-related software.
		 */
		var toFixed = lib.toFixed = function(value, precision) {
			precision = checkPrecision(precision, lib.settings.number.precision);
			var power = Math.pow(10, precision);
	
			// Multiply up by precision, round accurately, then divide and use native toFixed():
			return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
		};
	
	
		/**
		 * Format a number, with comma-separated thousands and custom precision/decimal places
		 * Alias: `accounting.format()`
		 *
		 * Localise by overriding the precision and thousand / decimal separators
		 * 2nd parameter `precision` can be an object matching `settings.number`
		 */
		var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val) {
					return formatNumber(val, precision, thousand, decimal);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(precision) ? precision : {
						precision : precision,
						thousand : thousand,
						decimal : decimal
					}),
					lib.settings.number
				),
	
				// Clean up precision
				usePrecision = checkPrecision(opts.precision),
	
				// Do some calc:
				negative = number < 0 ? "-" : "",
				base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
				mod = base.length > 3 ? base.length % 3 : 0;
	
			// Format the number:
			return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
		};
	
	
		/**
		 * Format a number into currency
		 *
		 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
		 * defaults: (0, "$", 2, ",", ".", "%s%v")
		 *
		 * Localise by overriding the symbol, precision, thousand / decimal separators and format
		 * Second param can be an object matching `settings.currency` which is the easiest way.
		 *
		 * To do: tidy up the parameters
		 */
		var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val){
					return formatMoney(val, symbol, precision, thousand, decimal, format);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero):
				formats = checkCurrencyFormat(opts.format),
	
				// Choose which format to use for this value:
				useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
	
			// Return with currency symbol added:
			return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
		};
	
	
		/**
		 * Format a list of numbers into an accounting column, padding with whitespace
		 * to line up currency symbols, thousand separators and decimals places
		 *
		 * List should be an array of numbers
		 * Second parameter can be an object containing keys that match the params
		 *
		 * Returns array of accouting-formatted number strings of same length
		 *
		 * NB: `white-space:pre` CSS rule is required on the list container to prevent
		 * browsers from collapsing the whitespace in the output strings.
		 */
		lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
			if (!list) return [];
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero), only need pos for now:
				formats = checkCurrencyFormat(opts.format),
	
				// Whether to pad at start of string or after currency symbol:
				padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,
	
				// Store value for the length of the longest string in the column:
				maxLength = 0,
	
				// Format the list according to options, store the length of the longest string:
				formatted = map(list, function(val, i) {
					if (isArray(val)) {
						// Recursively format columns if list is a multi-dimensional array:
						return lib.formatColumn(val, opts);
					} else {
						// Clean up the value
						val = unformat(val);
	
						// Choose which format to use for this value (pos, neg or zero):
						var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,
	
							// Format this value, push into formatted list and save the length:
							fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	
						if (fVal.length > maxLength) maxLength = fVal.length;
						return fVal;
					}
				});
	
			// Pad each number in the list and send back the column of numbers:
			return map(formatted, function(val, i) {
				// Only if this is a string (not a nested array, which would have already been padded):
				if (isString(val) && val.length < maxLength) {
					// Depending on symbol position, pad after symbol or at index 0:
					return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
				}
				return val;
			});
		};
	
	
		/* --- Module Definition --- */
	
		// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
		// Otherwise, just add `accounting` to the global object
		if (true) {
			if (typeof module !== 'undefined' && module.exports) {
				exports = module.exports = lib;
			}
			exports.accounting = lib;
		} else if (typeof define === 'function' && define.amd) {
			// Return the library as an AMD module:
			define([], function() {
				return lib;
			});
		} else {
			// Use accounting.noConflict to restore `accounting` back to its original value.
			// Returns a reference to the library's `accounting` object;
			// e.g. `var numbers = accounting.noConflict();`
			lib.noConflict = (function(oldAccounting) {
				return function() {
					// Reset the value of the root's `accounting` variable:
					root.accounting = oldAccounting;
					// Delete the noConflict method:
					lib.noConflict = undefined;
					// Return reference to the library to re-assign it:
					return lib;
				};
			})(root.accounting);
	
			// Declare `fx` on the root (global/window) object:
			root['accounting'] = lib;
		}
	
		// Root will be `window` in browser or `global` on the server:
	}(this));


/***/ },
/* 705 */
/***/ function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(705);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(17);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(706);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback, option) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    var _ret = (function () {
	      var useCapture = false;
	      if (typeof option === 'object') {
	        useCapture = option.capture || false;
	      } else if (typeof option === 'boolean') {
	        useCapture = option;
	      }
	
	      target.addEventListener(eventType, wrapCallback, option || false);
	
	      return {
	        v: {
	          remove: function remove() {
	            target.removeEventListener(eventType, wrapCallback, useCapture);
	          }
	        }
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 708 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	var bind = __webpack_require__(342);
	var Axios = __webpack_require__(711);
	var defaults = __webpack_require__(212);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(339);
	axios.CancelToken = __webpack_require__(710);
	axios.isCancel = __webpack_require__(340);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(725);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(339);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(212);
	var utils = __webpack_require__(42);
	var InterceptorManager = __webpack_require__(712);
	var dispatchRequest = __webpack_require__(713);
	var isAbsoluteURL = __webpack_require__(721);
	var combineURLs = __webpack_require__(719);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	var transformData = __webpack_require__(716);
	var isCancel = __webpack_require__(340);
	var defaults = __webpack_require__(212);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 714 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(341);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 717 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 719 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 721 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(42);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 725 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _currencyFormatter = __webpack_require__(71);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var InstitutionTransactions = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(InstitutionTransactions, _React$Component);
	
	  function InstitutionTransactions() {
	    _classCallCheck(this, InstitutionTransactions);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (InstitutionTransactions.__proto__ || Object.getPrototypeOf(InstitutionTransactions)).call(this));
	
	    _this.exportReport = _this.exportReport.bind(_this);
	    _this.completeExport = _this.completeExport.bind(_this);
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.resetFilters = _this.resetFilters.bind(_this);
	    return _this;
	  }
	
	  _createClass(InstitutionTransactions, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.store.AdminStore.getTransactions();
	
	      this.state = {
	        startDate: null,
	        endDate: null
	      };
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(amount, highlightPositive) {
	      // if(amount < 0) {
	      //   return 'negative';
	      // } else if(amount > 0 && highlightPositive) {
	      //   return 'positive';
	      // }
	
	      return '';
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      var translation = this.props.translation;
	      var ReportStore = this.props.store.ReportStore;
	
	      // Set the default export title
	
	      ReportStore.reportExportTitle = translation.page_title;
	
	      // Show a dialog to let the user change the title
	      var msg = {
	        heading: translation.csv_prompt.heading,
	        input: translation.csv_prompt.input,
	        button: translation.csv_prompt.button
	      };
	
	      (0, _helpers.promptUser)(msg, this.completeExport, null, ReportStore.reportExportTitle);
	    }
	  }, {
	    key: 'completeExport',
	    value: function completeExport() {
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ReportStore = _props$store.ReportStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      var callback = function callback() {
	        return SessionStore.showToaster(translation.exported, 'success');
	      };
	
	      ReportStore.exportData(callback);
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, name) {
	      var _this2 = this;
	
	      this.setState(_defineProperty({}, name, date), function () {
	        if (_this2.state.startDate && _this2.state.endDate === null) {
	          _this2.endDate.setFocus();
	        } else if (_this2.state.endDate && _this2.state.startDate === null) {
	          _this2.startDate.setFocus();
	        }
	      });
	    }
	  }, {
	    key: 'applyFilters',
	    value: function applyFilters(e) {
	      e.preventDefault();
	
	      var _props$store2 = this.props.store,
	          AdminStore = _props$store2.AdminStore,
	          SessionStore = _props$store2.SessionStore;
	      var userTimezone = SessionStore.userTimezone;
	      var _state = this.state,
	          startDate = _state.startDate,
	          endDate = _state.endDate;
	
	      var type = this.type.value;
	      var examStatus = this.examStatus.value;
	      var filters = {};
	
	      if (startDate) {
	        filters.dateRangeStart = (0, _moment2.default)(startDate).tz(userTimezone).toISOString();
	      }
	
	      if (endDate) {
	        filters.dateRangeEnd = (0, _moment2.default)(endDate).tz(userTimezone).toISOString();
	      }
	
	      if (type) {
	        filters.type = type;
	      }
	
	      if (examStatus) {
	        filters.examStatus = examStatus;
	      }
	
	      AdminStore.ledgerFilters = filters;
	
	      if (Object.keys(filters).length > 0) {
	        AdminStore.getTransactions();
	      } else {
	        this.resetFilters();
	      }
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      var AdminStore = this.props.store.AdminStore;
	
	
	      this.setState({
	        startDate: null,
	        endDate: null
	      });
	
	      this.type.value = '';
	      this.examStatus.value = '';
	
	      AdminStore.ledgerFilters = {};
	
	      AdminStore.getTransactions();
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var _props = this.props,
	          translation = _props.translation,
	          store = _props.store;
	      var _store$AdminStore = store.AdminStore,
	          summary = _store$AdminStore.summary,
	          transactions = _store$AdminStore.transactions;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (transactions.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h4',
	            { className: 'total' },
	            translation.current_balance,
	            ':',
	            _react2.default.createElement(
	              'span',
	              { className: this.highlight(summary.balance, true) },
	              _currencyFormatter2.default.format(summary.balance, { code: transactions[0].currency }),
	              ' ',
	              transactions[0].currency
	            )
	          ),
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle', scope: 'col' },
	                  translation.date
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle', scope: 'col' },
	                  translation.notes
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle number', scope: 'col' },
	                  translation.amount
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              { className: 'panel__body' },
	              transactions.map(function (key, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: i },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _moment2.default.utc(key.createdDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    key.voucherSid && key.voucher && _react2.default.createElement(
	                      'ul',
	                      { className: 'table-list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _currencyFormatter2.default.format(key.voucher.amount, { code: key.currency }),
	                        ' ',
	                        translation.voucher
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.voucher_code,
	                        ': ',
	                        key.voucher.voucherCode
	                      )
	                    ),
	                    key.memo && _react2.default.createElement(
	                      'p',
	                      null,
	                      key.memo
	                    ),
	                    key.fundingRuleSid && key.fundingRule && _react2.default.createElement(
	                      'ul',
	                      { className: 'table-list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.funding_rule,
	                        ':\xA0',
	                        key.fundingRule.title
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.amount,
	                        ':\xA0',
	                        key.fundingRule.units === '%' && key.fundingRule.amount + '%',
	                        key.fundingRule.units === '$' && _currencyFormatter2.default.format(key.fundingRule.amount, { code: key.fundingRule.currency })
	                      )
	                    ),
	                    key.examSessionSid && key.examSession && _react2.default.createElement(
	                      'ul',
	                      { className: 'table-list' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.exam,
	                        ':\xA0',
	                        key.exam.title
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.course,
	                        ':\xA0',
	                        key.course.title
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.student,
	                        ':\xA0',
	                        key.student.lastName,
	                        ', ',
	                        key.student.firstName
	                      ),
	                      key.student.address && _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.address,
	                        ':\xA0',
	                        key.student.address
	                      ),
	                      key.student.latitude && _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.latitude,
	                        ':\xA0',
	                        key.student.latitude
	                      ),
	                      key.student.longitude && _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.longitude,
	                        ':\xA0',
	                        key.student.longitude
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.appointment_date,
	                        ':\xA0',
	                        _moment2.default.utc(key.examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        translation.status,
	                        ':\xA0',
	                        key.examSession.status
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    {
	                      className: 'number ' + _this3.highlight(key.amount, false)
	                    },
	                    _currencyFormatter2.default.format(key.amount, { code: key.currency }),
	                    ' ',
	                    key.currency
	                  )
	                );
	              })
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          this.state.startDate && this.state.endDate && translation.no_results_filtered,
	          (!this.state.startDate || !this.state.endDate) && translation.no_results
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var AdminStore = this.props.store.AdminStore;
	      var transactions = AdminStore.transactions,
	          transactionsNext = AdminStore.transactionsNext;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page__actions actions' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--outline',
	                  onClick: this.exportReport
	                },
	                _react2.default.createElement(icons.iconDownload, null),
	                translation.csv_button
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          {
	            className: 'filter',
	            onSubmit: function onSubmit(e) {
	              return (0, _helpers.checkValidity)(e, function (e) {
	                return _this4.applyFilters(e);
	              });
	            },
	            noValidate: true
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'filter__filters' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--inline' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.filter,
	                    ':'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select' },
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        ref: function ref(input) {
	                          _this4.type = input;
	                        }
	                      },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        translation.filters.type.all
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'fundingRule' },
	                        translation.filters.type.funding_rule
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'voucher' },
	                        translation.filters.type.voucher
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'credit' },
	                        translation.filters.type.credit
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select' },
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        ref: function ref(input) {
	                          _this4.examStatus = input;
	                        }
	                      },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        translation.filters.examStatus.all
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'active' },
	                        translation.filters.examStatus.active
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'draft' },
	                        translation.filters.examStatus.draft
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'deleted' },
	                        translation.filters.examStatus.deleted
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'startDate' },
	                    translation.filters.start_date
	                  ),
	                  _react2.default.createElement(_reactDatepicker2.default, {
	                    id: 'startDate',
	                    selected: this.state.startDate,
	                    maxDate: this.state.endDate,
	                    onChange: function onChange(date) {
	                      return _this4.handleDateChange(date, 'startDate');
	                    },
	                    placeholderText: translation.filters.start_date,
	                    autoComplete: 'off',
	                    required: this.state.endDate,
	                    ref: function ref(input) {
	                      return _this4.startDate = input;
	                    }
	                  }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'preposition' },
	                    '\u2013'
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'endDate' },
	                    translation.filters.end_date
	                  ),
	                  _react2.default.createElement(_reactDatepicker2.default, {
	                    id: 'endDate',
	                    selected: this.state.endDate,
	                    minDate: this.state.startDate,
	                    onChange: function onChange(date) {
	                      return _this4.handleDateChange(date, 'endDate');
	                    },
	                    placeholderText: translation.filters.end_date,
	                    autoComplete: 'off',
	                    required: this.state.startDate,
	                    ref: function ref(input) {
	                      return _this4.endDate = input;
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'actions' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  type: 'submit'
	                },
	                translation.filter
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--outline',
	                  type: 'reset',
	                  onClick: this.resetFilters
	                },
	                translation.reset
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults(),
	          transactionsNext && _react2.default.createElement(_LoadMore2.default, Object.assign({
	            url: transactionsNext,
	            group: transactions,
	            text: 'Load more transactions'
	          }, this.props))
	        )
	      );
	    }
	  }]);
	
	  return InstitutionTransactions;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('InstitutionTransactions')(InstitutionTransactions);

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MFAChallenge = function (_React$Component) {
	  _inherits(MFAChallenge, _React$Component);
	
	  function MFAChallenge() {
	    _classCallCheck(this, MFAChallenge);
	
	    var _this = _possibleConstructorReturn(this, (MFAChallenge.__proto__ || Object.getPrototypeOf(MFAChallenge)).call(this));
	
	    _this.state = {
	      code: '',
	      verifying: false,
	      error: null
	    };
	    _this.handleCodeInput = _this.handleCodeInput.bind(_this);
	    _this.verifyCode = _this.verifyCode.bind(_this);
	    return _this;
	  }
	
	  _createClass(MFAChallenge, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var tempToken = sessionStorage.getItem('mfaTempToken');
	
	      if (!tempToken) {
	        this.props.routing.push('/account/sign-in');
	      }
	    }
	  }, {
	    key: 'handleCodeInput',
	    value: function handleCodeInput(e) {
	      var value = e.target.value.replace(/\D/g, '').slice(0, 6);
	      this.setState({ code: value, error: null });
	    }
	  }, {
	    key: 'verifyCode',
	    value: function verifyCode(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	
	      if (this.state.code.length !== 6) {
	        this.setState({ error: 'Please enter a 6-digit code' });
	        return;
	      }
	
	      var tempToken = sessionStorage.getItem('mfaTempToken');
	      var installSid = sessionStorage.getItem('mfaInstallSid');
	
	      this.setState({ verifying: true, error: null });
	
	      this.props.store.SessionStore.verifyMFAChallenge(tempToken, installSid, this.state.code, function (error) {
	        if (error) {
	          _this2.setState({
	            error: 'Invalid code. Please try again.',
	            verifying: false,
	            code: ''
	          });
	        } else {
	          sessionStorage.removeItem('mfaTempToken');
	          sessionStorage.removeItem('mfaInstallSid');
	          _this2.props.routing.push('/');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          code = _state.code,
	          verifying = _state.verifying,
	          error = _state.error;
	
	      var backgroundImg = 'url(./static/img/bg-sign-up.jpg)';
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'page page--graphic page--pane-right', style: { backgroundImage: backgroundImg } },
	        _react2.default.createElement(
	          'div',
	          { className: 'page--graphic__content wrap' },
	          _react2.default.createElement('img', { src: './static/img/logo-white.png', width: '300', alt: 'SmarterProctoring' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pane pane--right pane--fixed' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pane__content' },
	            _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center', marginBottom: '20px' } },
	              _react2.default.createElement(
	                'i',
	                { className: 'page--error__icon', style: { color: '#2196F3' } },
	                _react2.default.createElement(icons.iconLock, null)
	              )
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'pane__title' },
	              'Multi-Factor Authentication'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'meta', style: { marginBottom: '30px', textAlign: 'center' } },
	              'Enter the verification code from your authenticator app to continue'
	            ),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.verifyCode, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'meta', htmlFor: 'mfa-code' },
	                      'Verification Code'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'mfa-code',
	                      placeholder: '000000',
	                      value: code,
	                      onChange: this.handleCodeInput,
	                      maxLength: '6',
	                      pattern: '[0-9]*',
	                      inputMode: 'numeric',
	                      required: true,
	                      'aria-required': 'true',
	                      autoFocus: true,
	                      disabled: verifying,
	                      style: { textAlign: 'center', fontSize: '18px', letterSpacing: '4px' }
	                    })
	                  )
	                )
	              ),
	              error && _react2.default.createElement(
	                'div',
	                { className: 'notice notice--error', style: { marginBottom: '15px' } },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  error
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn', type: 'submit', disabled: verifying || code.length !== 6 },
	                verifying ? 'Verifying...' : 'Verify & Sign In'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { marginTop: '20px', padding: '15px 20px', background: '#fff3cd', borderLeft: '4px solid #ffc107', borderRadius: '4px' } },
	              _react2.default.createElement(
	                'p',
	                { style: { fontSize: '14px', margin: 0, color: '#664d03', lineHeight: '1.6', fontWeight: '400' } },
	                _react2.default.createElement(
	                  'strong',
	                  { style: { fontWeight: '600' } },
	                  'Need help?'
	                ),
	                ' Lost your device? Contact your administrator for assistance.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MFAChallenge;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('MFAChallenge')(MFAChallenge);

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MFASetup = function (_React$Component) {
	  _inherits(MFASetup, _React$Component);
	
	  function MFASetup() {
	    _classCallCheck(this, MFASetup);
	
	    var _this = _possibleConstructorReturn(this, (MFASetup.__proto__ || Object.getPrototypeOf(MFASetup)).call(this));
	
	    _this.state = {
	      qrCode: null,
	      secret: null,
	      code: '',
	      loading: true,
	      verifying: false,
	      error: null
	    };
	    _this.handleCodeInput = _this.handleCodeInput.bind(_this);
	    _this.verifyCode = _this.verifyCode.bind(_this);
	    return _this;
	  }
	
	  _createClass(MFASetup, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var userSid = sessionStorage.getItem('mfaUserSid');
	      var installSid = sessionStorage.getItem('mfaInstallSid');
	      var account = this.getParameterByName('account') || sessionStorage.getItem('mfaAccount');
	
	      // Store account parameter if present
	      if (account) {
	        sessionStorage.setItem('mfaAccount', account);
	      }
	
	      if (!userSid || !installSid) {
	        this.props.routing.push('/account/sign-in');
	        return;
	      }
	
	      this.props.store.SessionStore.setupMFA(userSid, installSid, function (error, data) {
	        if (error) {
	          _this2.setState({ error: 'Failed to initialize MFA setup. Please try again.', loading: false });
	        } else {
	          _this2.setState({
	            qrCode: data.qrCode,
	            secret: data.secret,
	            loading: false
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getParameterByName',
	    value: function getParameterByName(name, url) {
	      if (!url) url = window.location.href;
	      name = name.replace(/[\[\]]/g, "\\$&");
	      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	          results = regex.exec(url);
	      if (!results) return null;
	      if (!results[2]) return '';
	      return decodeURIComponent(results[2].replace(/\+/g, " "));
	    }
	  }, {
	    key: 'handleCodeInput',
	    value: function handleCodeInput(e) {
	      var value = e.target.value.replace(/\D/g, '').slice(0, 6);
	      this.setState({ code: value, error: null });
	    }
	  }, {
	    key: 'verifyCode',
	    value: function verifyCode(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      if (this.state.code.length !== 6) {
	        this.setState({ error: 'Please enter a 6-digit code' });
	        return;
	      }
	
	      var userSid = sessionStorage.getItem('mfaUserSid');
	      var installSid = sessionStorage.getItem('mfaInstallSid');
	
	      this.setState({ verifying: true, error: null });
	
	      this.props.store.SessionStore.verifyMFASetup(userSid, installSid, this.state.code, function (error) {
	        if (error) {
	          _this3.setState({
	            error: 'Invalid code. Please try again.',
	            verifying: false,
	            code: ''
	          });
	        } else {
	          sessionStorage.removeItem('mfaUserSid');
	          sessionStorage.removeItem('mfaInstallSid');
	          sessionStorage.removeItem('mfaAccount');
	
	          // Redirect to dashboard after successful MFA setup
	          _this3.props.routing.push('/');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          qrCode = _state.qrCode,
	          secret = _state.secret,
	          code = _state.code,
	          loading = _state.loading,
	          verifying = _state.verifying,
	          error = _state.error;
	
	      var backgroundImg = 'url(./static/img/bg-sign-up.jpg)';
	
	      if (loading) {
	        return _react2.default.createElement(
	          'main',
	          { className: 'page page--graphic page--pane-right', style: { backgroundImage: backgroundImg } },
	          _react2.default.createElement(
	            'div',
	            { className: 'page--graphic__content wrap' },
	            _react2.default.createElement('img', { src: './static/img/logo-white.png', width: '300', alt: 'SmarterProctoring' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'pane pane--right pane--fixed' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pane__content' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'pane__title' },
	                'Setting up MFA...'
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'page page--graphic page--pane-right', style: { backgroundImage: backgroundImg } },
	        _react2.default.createElement(
	          'div',
	          { className: 'page--graphic__content wrap' },
	          _react2.default.createElement('img', { src: './static/img/logo-white.png', width: '300', alt: 'SmarterProctoring' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pane pane--right pane--fixed' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pane__content' },
	            _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center', marginBottom: '20px' } },
	              _react2.default.createElement(
	                'i',
	                { className: 'page--error__icon', style: { color: '#4CAF50' } },
	                _react2.default.createElement(icons.iconLock, null)
	              )
	            ),
	            _react2.default.createElement(
	              'h1',
	              { className: 'pane__title', style: { textAlign: 'center' } },
	              'Set Up Multi-Factor Authentication'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'meta', style: { marginBottom: '30px', textAlign: 'center' } },
	              'Enhance your account security by setting up two-factor authentication'
	            ),
	            qrCode && _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center', marginBottom: '30px' } },
	              _react2.default.createElement(
	                'p',
	                { className: 'meta', style: { marginBottom: '15px', fontWeight: '500' } },
	                'Step 1: Scan this QR code with your authenticator app'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'meta', style: { marginBottom: '20px', fontSize: '13px', color: '#666' } },
	                '(Google Authenticator, Authy, Microsoft Authenticator, etc.)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: {
	                    display: 'inline-block',
	                    padding: '20px',
	                    background: '#fff',
	                    border: '2px solid #e0e0e0',
	                    borderRadius: '8px',
	                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
	                  } },
	                _react2.default.createElement('img', { src: qrCode, alt: 'MFA QR Code', style: { width: '200px', height: '200px', display: 'block' } })
	              )
	            ),
	            secret && _react2.default.createElement(
	              'div',
	              { style: { marginBottom: '30px' } },
	              _react2.default.createElement(
	                'p',
	                { className: 'meta', style: { marginBottom: '10px', textAlign: 'center', fontWeight: '500' } },
	                'Or enter this code manually:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: {
	                    padding: '15px',
	                    background: '#f8f9fa',
	                    border: '1px solid #dee2e6',
	                    borderRadius: '4px',
	                    textAlign: 'center',
	                    marginBottom: '10px'
	                  } },
	                _react2.default.createElement(
	                  'code',
	                  { style: {
	                      fontFamily: 'Monaco, Consolas, monospace',
	                      fontSize: '16px',
	                      fontWeight: '600',
	                      letterSpacing: '2px',
	                      color: '#333'
	                    } },
	                  secret
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'form',
	              { onSubmit: this.verifyCode, noValidate: true },
	              _react2.default.createElement(
	                'p',
	                { className: 'meta', style: { marginBottom: '15px', fontWeight: '500', textAlign: 'center' } },
	                'Step 2: Enter the 6-digit code from your app'
	              ),
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'meta', htmlFor: 'mfa-code' },
	                      'Verification Code'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'mfa-code',
	                      placeholder: '000000',
	                      value: code,
	                      onChange: this.handleCodeInput,
	                      maxLength: '6',
	                      pattern: '[0-9]*',
	                      inputMode: 'numeric',
	                      required: true,
	                      'aria-required': 'true',
	                      autoFocus: true,
	                      disabled: verifying,
	                      style: { textAlign: 'center', fontSize: '18px', letterSpacing: '4px' }
	                    })
	                  )
	                )
	              ),
	              error && _react2.default.createElement(
	                'div',
	                { className: 'notice notice--error', style: { marginBottom: '15px' } },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  error
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn', type: 'submit', disabled: verifying || code.length !== 6 },
	                verifying ? 'Verifying...' : 'Verify & Complete Setup'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { marginTop: '20px', padding: '15px 20px', background: '#d1ecf1', borderLeft: '4px solid #0c5460', borderRadius: '4px' } },
	              _react2.default.createElement(
	                'p',
	                { style: { fontSize: '14px', margin: 0, color: '#0c5460', lineHeight: '1.6', fontWeight: '400' } },
	                _react2.default.createElement(
	                  'strong',
	                  { style: { fontWeight: '600' } },
	                  'Tip:'
	                ),
	                ' Keep your authenticator app accessible. You\'ll need it every time you sign in.'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MFASetup;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('MFASetup')(MFASetup);

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DelayRender = __webpack_require__(343);
	
	var _DelayRender2 = _interopRequireDefault(_DelayRender);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _SignIn = __webpack_require__(730);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _config = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	// Components
	
	
	var AccountSession = function (_React$Component) {
	  _inherits(AccountSession, _React$Component);
	
	  function AccountSession() {
	    _classCallCheck(this, AccountSession);
	
	    var _this = _possibleConstructorReturn(this, (AccountSession.__proto__ || Object.getPrototypeOf(AccountSession)).call(this));
	
	    _this.createProctor = _this.createProctor.bind(_this);
	    _this.handleSignup = _this.handleSignup.bind(_this);
	    _this.installSid = '';
	    return _this;
	  }
	
	  _createClass(AccountSession, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        installSid: null,
	        hasLoaded: this.getParameterByName('account') === null ? true : false,
	        error: false,
	        pageContent: null,
	        username: null,
	        password: null
	        // Clear out old session data
	      };this.props.store.SessionStore.removeLocalStorage();
	      if (this.props.content === 'SignIn') {
	        this.setState({
	          pageContent: _react2.default.createElement(_SignIn2.default, Object.assign({}, this.props, { installSid: this.state.installSid, checkValidity: _helpers.checkValidity }))
	        });
	      }
	    }
	  }, {
	    key: 'getParameterByName',
	    value: function getParameterByName(name, url) {
	      if (!url) url = window.location.href;
	      name = name.replace(/[\[\]]/g, "\\$&");
	      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	          results = regex.exec(url);
	      if (!results) return null;
	      if (!results[2]) return '';
	      return decodeURIComponent(results[2].replace(/\+/g, " "));
	    }
	  }, {
	    key: 'createProctor',
	    value: function createProctor() {
	      this.props.store.RegisterStore.createProctor(this.handleSignup);
	    }
	  }, {
	    key: 'getInstall',
	    value: function getInstall(account) {
	      var _this2 = this;
	
	      var cssId = 'accountCss';
	      this.props.store.SessionStore.getInstall(account).then(function (res) {
	        _this2.setState({
	          installSid: res.data.installSid
	        });
	        _this2.setState({
	          hasLoaded: true
	        });
	        if (!document.getElementById(cssId) && res.data.cssUrl) {
	          var head = document.getElementsByTagName('head')[0];
	          var link = document.createElement('link');
	          link.id = cssId;
	          link.rel = 'stylesheet';
	          link.type = 'text/css';
	          link.href = res.data.cssUrl;
	          link.media = 'all';
	          head.appendChild(link);
	        }
	      }).catch(function (e) {
	        _this2.setState({
	          hasLoaded: true
	        });
	        _this2.setState({
	          error: true
	        });
	      });
	    }
	  }, {
	    key: 'handleSignup',
	    value: function handleSignup() {
	      this.props.routing.push('/register');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.getParameterByName('account') && !this.state.installSid && !this.state.error) {
	        this.getInstall(this.getParameterByName('account'));
	      }
	
	      var translation = this.props.translation;
	
	      var backgroundImg = 'url(./static/img/bg-sign-up.jpg)';
	      var isSub = this.getParameterByName('account') && !this.state.error;
	
	      var content = isSub ? _react2.default.createElement(
	        'main',
	        { className: 'page page--graphic page--pane-right', style: { backgroundImage: backgroundImg } },
	        _react2.default.createElement(
	          'div',
	          { className: 'page--graphic__content wrap' },
	          _react2.default.createElement('img', { src: './static/img/logo-white.png', width: '300', alt: 'SmarterProctoring' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pane pane--right pane--fixed' },
	          this.state.pageContent
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'panel--brief', style: { marginTop: "30px" } },
	        _react2.default.createElement(
	          'i',
	          { className: 'page--error__icon' },
	          _react2.default.createElement(icons.iconLock, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.not_configured
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.not_configured_text
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        _DelayRender2.default,
	        { test: this.state.hasLoaded },
	        _react2.default.createElement(
	          _reactLaunchDarkly.LaunchDarkly,
	          { clientId: _config.config.ldApiKey, user: { key: 'anonymous-user', anonymous: true } },
	          _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'maintenance-message',
	            renderFeatureCallback: function renderFeatureCallback(flagValue) {
	              if (flagValue && (typeof flagValue === 'undefined' ? 'undefined' : _typeof(flagValue)) === 'object' && flagValue.message !== undefined) {
	                // Redirect to maintenance page
	                window.location.href = '/#/maintenance';
	                return null;
	              } else {
	                return null;
	              }
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          content
	        )
	      );
	    }
	  }]);
	
	  return AccountSession;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('AccountSession')(AccountSession);

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var SignIn = function (_React$Component) {
	  _inherits(SignIn, _React$Component);
	
	  function SignIn() {
	    _classCallCheck(this, SignIn);
	
	    var _this = _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this));
	
	    _this.handleLoginInput = _this.handleLoginInput.bind(_this);
	    _this.login = _this.login.bind(_this);
	    _this.handleLogin = _this.handleLogin.bind(_this);
	    return _this;
	  }
	
	  _createClass(SignIn, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        username: null,
	        password: null
	      };
	    }
	  }, {
	    key: 'handleLoginInput',
	    value: function handleLoginInput() {
	      this.setState({
	        username: this.username.value,
	        password: this.password.value
	      });
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      this.props.store.SessionStore.login(this.state.username, this.state.password, this.handleLogin);
	    }
	  }, {
	    key: 'handleLogin',
	    value: function handleLogin() {
	      this.props.routing.push('/');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pane__content' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'pane__title' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: function onSubmit(e) {
	              return _this2.props.checkValidity(e, _this2.login);
	            }, noValidate: true },
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'meta', htmlFor: 'signup-username' },
	                  translation.username
	                ),
	                _react2.default.createElement('input', { type: 'text', id: 'signup-username', placeholder: translation.username, required: true, 'aria-required': 'true', onChange: this.handleLoginInput, ref: function ref(input) {
	                    _this2.username = input;
	                  } })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'meta', htmlFor: 'signup-password' },
	                  translation.password
	                ),
	                _react2.default.createElement('input', { type: 'password', id: 'signup-password', placeholder: translation.password, required: true, 'aria-required': 'true', onChange: this.handleLoginInput, ref: function ref(input) {
	                    _this2.password = input;
	                  } })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', type: 'submit' },
	            translation.sign_in
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignIn;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('SignIn')(SignIn);

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _currencyFormatter = __webpack_require__(71);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var Transactions = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Transactions, _React$Component);
	
	  function Transactions() {
	    _classCallCheck(this, Transactions);
	
	    return _possibleConstructorReturn(this, (Transactions.__proto__ || Object.getPrototypeOf(Transactions)).apply(this, arguments));
	  }
	
	  _createClass(Transactions, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.store.UserStore.getTransactions();
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(amount, highlightPositive) {
	      if (amount < 0) {
	        return 'negative';
	      } else if (amount > 0 && highlightPositive) {
	        return 'positive';
	      }
	
	      return '';
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var _props = this.props,
	          translation = _props.translation,
	          store = _props.store;
	      var transactions = store.UserStore.transactions;
	
	
	      if (transactions.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'table',
	            { className: 'panel' },
	            _react2.default.createElement(
	              'thead',
	              { className: 'panel__header' },
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle', scope: 'col' },
	                  translation.date
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle', scope: 'col' },
	                  translation.description
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle', scope: 'col' },
	                  translation.transaction_id
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle number', scope: 'col' },
	                  translation.amount
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              { className: 'panel__body' },
	              transactions.map(function (key, i) {
	                if (key.status.toLowerCase() !== 'deferred') {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _moment2.default)(key.createdDate).tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      key.description
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      key.processorTransactionId
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'number ' + _this2.highlight(key.amount, false) },
	                      _currencyFormatter2.default.format(key.amount, { code: key.currency }),
	                      ' ',
	                      key.currency
	                    )
	                  );
	                } else {
	                  return null;
	                }
	              })
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'page__title' },
	                translation.page_title
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            this.renderResults()
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Transactions;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Transactions')(Transactions);

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactDelayed = __webpack_require__(112);
	
	var _reactDelayed2 = _interopRequireDefault(_reactDelayed);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Toolbar = __webpack_require__(98);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Admins = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Admins, _React$Component);
	
	  function Admins() {
	    _classCallCheck(this, Admins);
	
	    var _this2 = _possibleConstructorReturn(this, (Admins.__proto__ || Object.getPrototypeOf(Admins)).call(this));
	
	    _this2.getAdminUsers = _this2.getAdminUsers.bind(_this2);
	    _this2.addAdmin = _this2.addAdmin.bind(_this2);
	    _this2.handleSelect = _this2.handleSelect.bind(_this2);
	    _this2.deleteAdmins = _this2.deleteAdmins.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Admins, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        userSid: null,
	        selectedRows: []
	      };
	
	      this.getAdminUsers(this.state.filter);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.routing.location.pathname;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (pathname.indexOf('edit') > -1 || pathname.indexOf('add') > -1) {
	        SessionStore.loading = false;
	        (0, _helpers.toggleDrawer)(null, this, 'EditAdmin');
	      }
	
	      if (pathname.indexOf('edit') > -1) {
	        var userSid = pathname.substr(pathname.lastIndexOf('/') + 1);
	
	        this.setState({
	          userSid: userSid
	        });
	      }
	    }
	  }, {
	    key: 'getAdminUsers',
	    value: function getAdminUsers(reload) {
	      if (this.props.store.EnrollmentStore.adminUsers.length === 0 || reload) {
	        this.props.store.EnrollmentStore.getAdminUsers();
	      }
	    }
	  }, {
	    key: 'addAdmin',
	    value: function addAdmin() {
	      this.props.store.EnrollmentStore.admin = {};
	
	      this.setState({
	        drawerOpen: true,
	        drawerContent: 'EditAdmin'
	      });
	    }
	  }, {
	    key: 'handleEdit',
	    value: function handleEdit(e, userSid) {
	      e.preventDefault();
	
	      // Update url
	      var path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');
	
	      if (this.props.routing.location.pathname !== path) {
	        this.props.routing.push(path);
	      }
	
	      this.setState({
	        userSid: userSid
	      });
	
	      (0, _helpers.toggleDrawer)(null, this, 'EditAdmin');
	    }
	  }, {
	    key: 'deleteAdmins',
	    value: function deleteAdmins(admin) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.delete_confirm.heading_singular,
	        body: translation.delete_confirm.body_singular,
	        button: translation.delete_confirm.button
	      };
	
	      if (this.state.selectedRows.length > 1) {
	        msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
	        msg.body = translation.delete_confirm.body_plural;
	      }
	
	      var callback = function callback() {
	        return _this3.getAdminUsers(true);
	      };
	
	      // Loop through all the selected funding rules and send delete API request
	      var _this = this;
	
	      (0, _helpers.confirm)(msg, function () {
	        for (var i = 0; i < _this.state.selectedRows.length; i++) {
	          _this3.props.store.EnrollmentStore.deleteAdminUser(_this.state.selectedRows[i], callback);
	        }
	
	        _this.setState({
	          selectedRows: []
	        });
	      });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(e, sid) {
	      var selectedRows = [].concat(_toConsumableArray(this.state.selectedRows));
	      var rowIndex = -1;
	
	      if (e.target.checked) {
	        selectedRows.push(sid);
	      } else {
	        rowIndex = selectedRows.indexOf(sid);
	        selectedRows.splice(rowIndex, 1);
	      }
	
	      this.setState({
	        selectedRows: selectedRows
	      });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this4 = this;
	
	      var _props$store = this.props.store,
	          EnrollmentStore = _props$store.EnrollmentStore,
	          SessionStore = _props$store.SessionStore;
	      var translation = this.props.translation;
	
	
	      if (EnrollmentStore.adminUsers.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-select', scope: 'col' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  'Select'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                translation.name
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-mobile', className: 'subtitle', scope: 'col' },
	                translation.mobile_phone
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-home', className: 'subtitle', scope: 'col' },
	                translation.home_phone
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-email', className: 'subtitle', scope: 'col' },
	                translation.email
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            EnrollmentStore.adminUsers.map(function (key, i) {
	              return _react2.default.createElement(
	                'tr',
	                {
	                  className: _this4.state.selectedRows.indexOf(key.sid) >= 0 ? 'selected' : '',
	                  key: i
	                },
	                _react2.default.createElement(
	                  'td',
	                  { className: 'check-col', 'aria-labelledby': 'heading-select' },
	                  key.sid !== SessionStore.userData.userSid && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('input', {
	                      id: 'select-' + key.sid,
	                      className: 'checkbox-input',
	                      type: 'checkbox',
	                      onChange: function onChange(e) {
	                        return _this4.handleSelect(e, key.sid);
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'checkbox-label checkbox-label--solo', htmlFor: 'select-' + key.sid
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        'Select ',
	                        key.title
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-name' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                      to: '/admins/edit/' + key.sid,
	                      onClick: function onClick(e) {
	                        _this4.handleEdit(e, key.sid);
	                      },
	                      title: 'Edit ' + key.lastName + ', ' + key.firstName
	                    },
	                    key.lastName,
	                    ', ',
	                    key.firstName
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-mobile' },
	                  key.mobilePhone && (0, _reactPhoneNumberInput.formatPhoneNumber)(key.mobilePhone, (0, _reactPhoneNumberInput.parsePhoneNumber)(key.mobilePhone).country, 'National')
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-home' },
	                  key.homePhone && (0, _reactPhoneNumberInput.formatPhoneNumber)(key.homePhone, (0, _reactPhoneNumberInput.parsePhoneNumber)(key.homePhone).country, 'National')
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-email' },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'title-link', href: 'mailto:' + key.email },
	                    key.email
	                  )
	                )
	              );
	            })
	          )
	        );
	      } else if (!SessionStore.loading && EnrollmentStore.adminUsers.length === 0) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn--outline', onClick: this.addAdmin },
	              _react2.default.createElement(icons.iconPlus, null),
	              translation.create_admin
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        ),
	        _react2.default.createElement(
	          _reactDelayed2.default,
	          {
	            mounted: this.state.selectedRows.length > 0,
	            unmountAfter: 250
	          },
	          _react2.default.createElement(_Toolbar2.default, Object.assign({
	            selectedRows: this.state.selectedRows,
	            deleteText: translation.delete,
	            deleteFunction: this.deleteAdmins
	          }, this.props))
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          userSid: this.state.userSid
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Admins;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Admins')(Admins);

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	var _Password = __webpack_require__(344);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var EditAdmin = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditAdmin, _React$Component);
	
	  function EditAdmin() {
	    _classCallCheck(this, EditAdmin);
	
	    var _this = _possibleConstructorReturn(this, (EditAdmin.__proto__ || Object.getPrototypeOf(EditAdmin)).call(this));
	
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditAdmin, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      SessionStore.getTimezones();
	      SessionStore.getCurrencies();
	
	      if ((0, _helpers.getURLSegment)(this, 2) === 'edit') {
	        var userSid = (0, _helpers.getURLSegment)(this, 3);
	        this.getAdminUser(userSid);
	      }
	    }
	  }, {
	    key: 'getAdminUser',
	    value: function getAdminUser(userSid) {
	      this.props.store.EnrollmentStore.getAdminUser(userSid);
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(e, name) {
	      var data = null;
	      var value = null;
	
	      if (name === 'homePhone' || name === 'mobilePhone') {
	        value = e;
	      } else {
	        value = e.target.value;
	      }
	
	      // Make sure boolean values are boolean
	      if (value === 'true') {
	        value = true;
	      }
	      if (value === 'false') {
	        value = false;
	      }
	
	      data = _defineProperty({}, name, value);
	
	      this.props.store.EnrollmentStore.updateAdminData(data);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var userSid = (0, _helpers.getURLSegment)(this, 3);
	
	      if (userSid) {
	        this.props.store.EnrollmentStore.updateAdmin(userSid, this.complete);
	      } else {
	        this.props.store.EnrollmentStore.createAdmin(this.complete);
	      }
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      (0, _helpers.closeDrawer)(null, this.props.parent, (0, _helpers.getURLSegment)(this, 1));
	      this.props.store.SessionStore.showToaster(this.props.translation.admin_saved, 'success');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          EnrollmentStore = _props$store.EnrollmentStore,
	          SessionStore = _props$store.SessionStore;
	      var admin = EnrollmentStore.admin;
	
	      var userSid = (0, _helpers.getURLSegment)(this, 3);
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              userSid && _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.edit_heading
	              ),
	              !userSid && _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.add_heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'form',
	              { className: 'panel panel--medium', onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--half' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'admin-fname' },
	                      translation.fname.label
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'admin-fname',
	                      ref: function ref(input) {
	                        _this2.firstName = input;
	                      },
	                      onChange: function onChange(e) {
	                        _this2.handleInput(e, 'firstName');
	                      },
	                      defaultValue: admin.firstName,
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--half' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'admin-lname' },
	                      translation.lname.label
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'admin-lname',
	                      ref: function ref(input) {
	                        _this2.lastName = input;
	                      },
	                      onChange: function onChange(e) {
	                        _this2.handleInput(e, 'lastName');
	                      },
	                      defaultValue: admin.lastName,
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'admin-email' },
	                      translation.email.label
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'email',
	                      id: 'admin-email',
	                      ref: function ref(input) {
	                        _this2.email = input;
	                      },
	                      onChange: function onChange(e) {
	                        _this2.handleInput(e, 'email');
	                      },
	                      defaultValue: admin.email,
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'admin-username' },
	                      translation.username.label
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'admin-username',
	                      ref: function ref(input) {
	                        _this2.username = input;
	                      },
	                      onChange: function onChange(e) {
	                        _this2.handleInput(e, 'username');
	                      },
	                      defaultValue: admin.username,
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  ),
	                  !userSid && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'admin-password' },
	                      translation.password.label
	                    ),
	                    _react2.default.createElement(_Password2.default, Object.assign({
	                      id: 'admin-password',
	                      changeFunction: this.handleInput
	                    }, this.props))
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-optional', htmlFor: 'admin-home' },
	                      translation.home_phone.label
	                    ),
	                    _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                      id: 'admin-home',
	                      nativeExpanded: true,
	                      flagsPath: './static/img/flags/',
	                      country: (0, _reactPhoneNumberInput.parsePhoneNumber)(admin.homePhone).country || 'US',
	                      value: admin.homePhone,
	                      onChange: function onChange(e) {
	                        _this2.handleInput(e, 'homePhone');
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-optional', htmlFor: 'admin-mobile' },
	                      translation.mobile_phone.label
	                    ),
	                    _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                      id: 'admin-mobile',
	                      nativeExpanded: true,
	                      flagsPath: './static/img/flags/',
	                      country: (0, _reactPhoneNumberInput.parsePhoneNumber)(admin.mobilePhone).country || 'US',
	                      value: admin.mobilePhone,
	                      onChange: function onChange(e) {
	                        _this2.handleInput(e, 'mobilePhone');
	                      }
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'admin-timezone' },
	                      translation.time_zone.label
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select', htmlFor: 'admin-timezone' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'admin-timezone',
	                          ref: function ref(input) {
	                            _this2.timeZoneSid = input;
	                          },
	                          defaultValue: admin.timeZoneSid,
	                          required: true,
	                          'aria-required': 'true',
	                          onChange: function onChange(e) {
	                            _this2.handleInput(e, 'timeZoneSid');
	                          }
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          translation.time_zone.helper
	                        ),
	                        SessionStore.timezoneList.map(function (key, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: i, value: key.sid },
	                            key.name
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'admin-currency' },
	                      translation.currency.label
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select', htmlFor: 'admin-currency' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'admin-currency',
	                          ref: function ref(input) {
	                            _this2.currency = input;
	                          },
	                          defaultValue: admin.currencyCode,
	                          required: true,
	                          'aria-required': 'true',
	                          onChange: function onChange(e) {
	                            _this2.handleInput(e, 'currencyCode');
	                          }
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          translation.currency.helper
	                        ),
	                        SessionStore.currencyList.map(function (key, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: i, value: key.code },
	                            key.name
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__actions actions' },
	                userSid && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary'
	                  },
	                  translation.edit_button
	                ),
	                !userSid && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary'
	                  },
	                  translation.add_button
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return EditAdmin;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EditAdmin')(EditAdmin);

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _jwtDecode = __webpack_require__(247);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _logrocket = __webpack_require__(111);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	var _Header = __webpack_require__(748);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _DelayRender = __webpack_require__(343);
	
	var _DelayRender2 = _interopRequireDefault(_DelayRender);
	
	var _Footer = __webpack_require__(747);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Loader = __webpack_require__(148);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TallyLoader = __webpack_require__(345);
	
	var _TallyLoader2 = _interopRequireDefault(_TallyLoader);
	
	var _Modal = __webpack_require__(751);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Dialog = __webpack_require__(147);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Confirm = __webpack_require__(213);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Prompt = __webpack_require__(216);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _ExpireWarning = __webpack_require__(746);
	
	var _ExpireWarning2 = _interopRequireDefault(_ExpireWarning);
	
	var _Toaster = __webpack_require__(217);
	
	var _Toaster2 = _interopRequireDefault(_Toaster);
	
	var _Notice = __webpack_require__(752);
	
	var _Notice2 = _interopRequireDefault(_Notice);
	
	var _Notification = __webpack_require__(214);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _Calculator = __webpack_require__(745);
	
	var _Calculator2 = _interopRequireDefault(_Calculator);
	
	var _config = __webpack_require__(9);
	
	var _stores = __webpack_require__(100);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	// Store
	
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
	
	    _this2.checkToken = _this2.checkToken.bind(_this2);
	    _this2.refresh = _this2.refresh.bind(_this2);
	    _this2.renderAgreements = _this2.renderAgreements.bind(_this2);
	    _this2.renderZDChat = _this2.renderZDChat.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(App, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = _stores2.default.SessionStore,
	          HelpStore = _stores2.default.HelpStore;
	
	
	      this.state = {
	        test: false
	      };
	
	      if (window.performance) {
	        if (performance.navigation.type === 1) {
	          console.log('User refreshed.');
	        }
	      }
	
	      // Add token to session storage
	      if (SessionStore.hasSessionStorage) {
	        if (sessionStorage.getItem('token') && this.props.location.query.token) {
	          sessionStorage.removeItem('token');
	        }
	
	        if (!sessionStorage.getItem('token')) {
	          sessionStorage.setItem('token', this.props.location.query.token);
	        }
	      } else {
	        if ((0, _helpers.getCookie)('token') && this.props.location.query.token) {
	          (0, _helpers.deleteCookie)('token');
	        }
	
	        if (!(0, _helpers.getCookie)('token')) {
	          document.cookie = 'token=' + this.props.location.query.token;
	        }
	      }
	
	      // Check authorization. If authorized, hit the check token endpoint.
	      this.checkAuthorization();
	
	      // Set token to api header and store in SessionStore
	      if (SessionStore.hasSessionStorage) {
	        (0, _config.setToken)(sessionStorage.getItem('token'));
	
	        SessionStore.token = sessionStorage.getItem('token');
	      } else {
	        (0, _config.setToken)((0, _helpers.getCookie)('token'));
	
	        SessionStore.token = (0, _helpers.getCookie)('token');
	      }
	
	      // Get translations
	      if (!SessionStore.translationLoaded) {
	        SessionStore.getTranslation(SessionStore.locale);
	      }
	
	      // Get help documents
	      if (!HelpStore.helpLoaded) {
	        HelpStore.getHelp();
	      }
	
	      // Redirect VTC users
	      var userAgent = document.querySelector('html').getAttribute('data-ua');
	
	      if (userAgent.indexOf('VTC') > -1 && this.props.router.pathname !== 'vtc') {
	        this.redirectVTC();
	      }
	    }
	  }, {
	    key: 'redirectVTC',
	    value: function redirectVTC() {
	      this.props.router.push({
	        pathname: 'vtc'
	      });
	    }
	
	    /*
	    componentDidMount() {
	      // Check browser support
	      store.SessionStore.checkBrowser();
	    }
	     */
	
	  }, {
	    key: 'checkAuthorization',
	    value: function checkAuthorization() {
	      var _this = this;
	      var SessionStore = _stores2.default.SessionStore;
	
	      var token = null;
	
	      var tokenInterval = setInterval(function () {
	        if (SessionStore.hasSessionStorage) {
	          token = sessionStorage.getItem('token');
	        } else {
	          token = (0, _helpers.getCookie)('token');
	        }
	
	        if (token && token !== 'undefined') {
	          clearInterval(tokenInterval);
	
	          // Log referrer for debugging
	          console.log('Referrer:');
	          console.log(document.referrer);
	
	          // Log launch url for debugging
	          console.log('Launch URL:');
	          console.log(window.location.href);
	
	          // Log token for debugging
	          console.log('Token:');
	          console.log(token);
	
	          var decodedToken = (0, _jwtDecode2.default)(token);
	
	          if (decodedToken.errorCode === '1110') {
	            // If unauthorized, send to unauthorized page
	            window.location = '/#/unauthorized?token=' + token;
	          } else {
	            // Otherwise hit the check token endpoint
	            _this.checkToken();
	          }
	        }
	      }, 100);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var cssId = 'accountCss';
	      var SessionStore = _stores2.default.SessionStore;
	
	
	      var head = document.getElementsByTagName('head')[0];
	      var link = document.createElement('link');
	
	      if (typeof _stores2.default.SessionStore.profile.firstName !== 'undefined') {
	        SessionStore.checkProfile();
	      }
	
	      if (SessionStore.hasSessionStorage) {
	        if (sessionStorage.getItem('iam')) {
	          SessionStore.createValidate(sessionStorage.getItem('iam'), JSON.parse(sessionStorage.getItem('iam')).iam);
	        }
	
	        if (sessionStorage.getItem('userData') && JSON.parse(sessionStorage.getItem('userData')).cssUrl) {
	          if (!document.getElementById(cssId) && JSON.parse(sessionStorage.getItem('userData')).cssUrl) {
	            link.id = cssId;
	            link.rel = 'stylesheet';
	            link.type = 'text/css';
	            link.href = JSON.parse(sessionStorage.getItem('userData')).cssUrl;
	            link.media = 'all';
	            head.appendChild(link);
	          }
	        }
	      } else {
	        if ((0, _helpers.getCookie)('iam')) {
	          SessionStore.createValidate((0, _helpers.getCookie)('iam'), JSON.parse((0, _helpers.getCookie)('iam')).iam);
	        }
	
	        if ((0, _helpers.getCookie)('userData') && JSON.parse((0, _helpers.getCookie)('userData')).cssUrl) {
	          if (!document.getElementById(cssId) && JSON.parse((0, _helpers.getCookie)('userData')).cssUrl) {
	            link.id = cssId;
	            link.rel = 'stylesheet';
	            link.type = 'text/css';
	            link.href = JSON.parse((0, _helpers.getCookie)('userData')).cssUrl;
	            link.media = 'all';
	            head.appendChild(link);
	          }
	        }
	      }
	
	      // Get current and next url and remove leading and trailing slashes
	      var thisPath = this.props.location.pathname.replace(/^\/|\/$/g, '');
	      var nextPath = nextProps.location.pathname.replace(/^\/|\/$/g, '');
	
	      // If we’re moving to a new URL, focus the main content
	      if (thisPath !== nextPath) {
	        var contentFocus = setInterval(function () {
	          if (document.querySelector('#main-content')) {
	            document.querySelector('#main-content').focus();
	            clearInterval(contentFocus);
	            window.scrollTo(0, 0);
	          }
	        }, 100);
	      }
	
	      // Set the feature in the HelpStore
	      _stores2.default.HelpStore.feature = nextProps.route.feature;
	    }
	  }, {
	    key: 'checkToken',
	    value: function checkToken() {
	      var SessionStore = _stores2.default.SessionStore;
	
	      SessionStore.checkToken();
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var router = this.props.router;
	
	      var thisLocation = this.props.router.location;
	
	      router.replace('/refresh');
	
	      setTimeout(function () {
	        router.replace({ pathname: thisLocation.pathname, query: thisLocation.query });
	      });
	    }
	  }, {
	    key: 'renderAgreements',
	    value: function renderAgreements() {
	      var _this = this;
	      var agrScript = document.querySelector('#agr-ui');
	
	      if (!agrScript) {
	        var agr = document.createElement('script');
	        agr.id = 'agr-ui';
	        agr.type = 'text/javascript';
	        agr.async = true;
	        agr.src = _config.config.agreementUISrc;
	
	        agr.onload = function () {
	          _this.checkAgreements(("production"));
	        };
	
	        document.body.appendChild(agr);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'checkAgreements',
	    value: function checkAgreements(env) {
	      var userData = _stores2.default.SessionStore.userData;
	
	
	      if ((0, _helpers.getParam)('skipAgreements', window.location.href) === 'true') {
	        return;
	      }
	
	      var agrOpts = {
	        mode: 'popup',
	        location: 'general-user-agreements',
	        target: userData.userSid,
	        account: userData.deploymentSid
	      };
	
	      if (env === 'production') {
	        agrOpts.application = 'AP6800b9e2e1794dbbbf6ad866194821d3';
	        window.Agreements.setup(agrOpts);
	      } else {
	        agrOpts.application = 'APfb4f76ee1dc24d058048fdaed04f56f1';
	        window.Agreements.setup(agrOpts);
	      }
	    }
	  }, {
	    key: 'initializeLogRocket',
	    value: function initializeLogRocket() {
	      // Initialize LogRocket if it’s enabled
	      if (true) {
	        if (!_stores2.default.SessionStore.logRocketInit) {
	          console.log('====================');
	          console.log('Starting LogRocket');
	          console.log('====================');
	
	          _logrocket2.default.init(_config.config.logRocket);
	          _stores2.default.SessionStore.logRocketInit = true;
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderZDChat',
	    value: function renderZDChat() {
	      var _store$SessionStore = _stores2.default.SessionStore,
	          profile = _store$SessionStore.profile,
	          userData = _store$SessionStore.userData;
	
	      var zdScript = document.querySelector('#ze-snippet');
	
	      if (!zdScript) {
	        var zdc = document.createElement('script');
	        zdc.id = 'ze-snippet';
	        zdc.type = 'text/javascript';
	        zdc.async = true;
	        zdc.src = 'https://static.zdassets.com/ekr/snippet.js?key=a3206868-bdac-4af5-a921-ee51087a581e';
	
	        zdc.onload = function () {
	          window.zE(function () {
	            window.zE.identify({
	              name: profile.firstName + ' ' + profile.lastName,
	              email: profile.email,
	              organization: userData.smarterProctoring ? userData.smarterProctoring.appInstallName : ''
	            });
	
	            window.zE('webWidget', 'updateSettings', {
	              webWidget: {
	                offset: {
	                  vertical: '44px'
	                }
	              }
	            });
	          });
	        };
	
	        document.body.appendChild(zdc);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'handleBlockedUser',
	    value: function handleBlockedUser(isBlocked) {
	      var fullBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var UserStore = _stores2.default.UserStore;
	
	      if (isBlocked) {
	        UserStore.handleBlockedUser(fullBlock);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'shouldRenderZD',
	    value: function shouldRenderZD() {
	      return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	        flagKey: 'zendesk-chat',
	        renderFeatureCallback: this.renderZDChat
	      });
	    }
	  }, {
	    key: 'renderSFChat',
	    value: function renderSFChat() {
	      var userData = _stores2.default.SessionStore.userData;
	
	      var optionsDefined = !!window.inAppHelpOptions;
	      var token = sessionStorage.getItem('token');
	
	      if (!optionsDefined) {
	        window.inAppHelpOptions = {
	          token: token,
	          application_sid: userData.smarterProctoring.sid,
	          context: userData.role.toLowerCase() === 'administrator' ? 'admin_account' : 'course_account',
	          sids: {
	            course_sid: userData.courseSid,
	            enrollment_sid: userData.enrollmentSid,
	            install_sid: userData.installSid
	          }
	        };
	
	        var script = document.createElement('script');
	        script.src = _config.config.supportScriptUrl;
	        script.type = 'text/javascript';
	        script.onload = function () {
	          return window.initHelpCenter();
	        };
	
	        document.body.appendChild(script);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'handleChromeStoreId',
	    value: function handleChromeStoreId(value) {
	      var SessionStore = _stores2.default.SessionStore;
	
	
	      _config.config.extensionUrl = 'https://chrome.google.com/webstore/detail/smarterproctoring/' + value;
	      _config.config.extensionId = value;
	      _config.config.extensionManifestUrl = 'https://smarterproctoring-extension.s3.amazonaws.com/manifest.' + value + '.json';
	
	      // Get extension info from the manifest
	      SessionStore.getExtensionInfo();
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var SessionStore = _stores2.default.SessionStore;
	
	      var test = null;
	
	      // Environment (used by LaunchDarkly)
	      var environment = 'develop';
	
	      if (true) {
	        environment = 'production';
	      }
	
	      if (false) {
	        environment = 'stage';
	      }
	
	      // Store iam and userData
	      if (SessionStore.hasSessionStorage) {
	        test = sessionStorage.getItem('iam') && sessionStorage.getItem('userData');
	      } else {
	        test = (0, _helpers.getCookie)('iam') && (0, _helpers.getCookie)('userData');
	      }
	
	      // Import styles
	      if (!document.querySelector('link[href*="screen.css"]')) {
	        var _store$SessionStore2 = _stores2.default.SessionStore,
	            highContrast = _store$SessionStore2.highContrast,
	            dyslexic = _store$SessionStore2.dyslexic;
	
	        // Default stylesheet
	
	        var defaultStyles = document.createElement('link');
	        defaultStyles.rel = '' + (highContrast ? 'alternate stylesheet' : 'stylesheet ');
	        defaultStyles.type = 'text/css';
	        defaultStyles.href = './static/css/screen.css';
	
	        if (document.querySelector('html').className.indexOf('firefox') > -1) {
	          defaultStyles.title = 'Default';
	        }
	
	        // High-contrast stylesheet
	        var highContrastStyles = document.createElement('link');
	        highContrastStyles.rel = '' + (highContrast ? 'stylesheet' : 'alternate stylesheet');
	        highContrastStyles.type = 'text/css';
	        highContrastStyles.href = './static/css/hi-c.css';
	
	        if (document.querySelector('html').className.indexOf('firefox') > -1) {
	          highContrastStyles.title = 'High Contrast';
	        }
	
	        // Dyslexic stylesheet
	        var dyslexicStyles = document.createElement('link');
	        dyslexicStyles.rel = '' + (dyslexic ? 'stylesheet' : 'alternate stylesheet');
	        dyslexicStyles.type = 'text/css';
	        dyslexicStyles.href = './static/css/open-dyslexic.css';
	
	        if (document.querySelector('html').className.indexOf('firefox') > -1) {
	          dyslexicStyles.title = 'Open Dyslexic';
	        }
	
	        document.head.appendChild(defaultStyles);
	        document.head.appendChild(highContrastStyles);
	        document.head.appendChild(dyslexicStyles);
	      }
	
	      // Detect touch device
	      var docRoot = document.querySelector('html');
	      if ('ontouchstart' in document.documentElement) {
	        docRoot.classList.add('touch');
	      }
	
	      // Don’t return the app until the user data is set
	      if (typeof _stores2.default.SessionStore.userData.userSid === 'undefined') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'viewport' },
	          _stores2.default.SessionStore.dialog && _react2.default.createElement(_Dialog2.default, { store: _stores2.default })
	        );
	      } else {
	        // LaunchDarkly user config
	        var ldConfig = {
	          key: _stores2.default.SessionStore.userData.userSid,
	          custom: {
	            domain: window.location.hostname,
	            environment: environment,
	            role: SessionStore.userData.role,
	            installSid: SessionStore.userData.installSid,
	            deploymentSid: SessionStore.userData.deploymentSid,
	            enrollmentSid: SessionStore.userData.enrollmentSid,
	            courseSid: SessionStore.userData.courseSid,
	            // offeringSid: SessionStore.userData.offeringSid,
	            integrationSid: SessionStore.userData.integrationSid,
	            userAgent: navigator.userAgent
	          }
	          // We cannot be assured email address is set, so we will do it conditionally...
	        };if (SessionStore.userData && SessionStore.userData.email) {
	          ldConfig.custom.email = SessionStore.userData.email;
	        }
	
	        // Return the view
	        return _react2.default.createElement(
	          _reactLaunchDarkly.LaunchDarkly,
	          { clientId: _config.config.ldApiKey, user: ldConfig },
	          _react2.default.createElement(
	            'div',
	            { className: 'viewport' },
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'maintenance-message',
	              renderFeatureCallback: function renderFeatureCallback(flagValue) {
	                if (flagValue && (typeof flagValue === 'undefined' ? 'undefined' : _typeof(flagValue)) === 'object' && flagValue.message !== undefined) {
	                  // Redirect to maintenance page
	                  window.location.href = '/#/maintenance';
	                  return null;
	                } else {
	                  return null;
	                }
	              }
	            }),
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'block-sp-access',
	              renderFeatureCallback: function renderFeatureCallback(flagVal) {
	                return _this3.handleBlockedUser(flagVal, true);
	              }
	            }),
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'block-live-access',
	              renderFeatureCallback: function renderFeatureCallback(flagVal) {
	                return _this3.handleBlockedUser(flagVal);
	              }
	            }),
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'agreements',
	              renderFeatureCallback: this.renderAgreements
	            }),
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'extension-chrome-store-id',
	              renderFeatureCallback: this.handleChromeStoreId
	            }),
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'log-rocket',
	              renderFeatureCallback: this.initializeLogRocket
	            }),
	            _react2.default.createElement(
	              _DelayRender2.default,
	              { test: test },
	              _stores2.default.SessionStore.notice && _react2.default.createElement(_Notice2.default, { store: _stores2.default }),
	              !_stores2.default.SessionStore.hideHeader && _react2.default.createElement(_Header2.default, Object.assign({ refresh: this.refresh, store: _stores2.default }, this.props)),
	              _react2.default.cloneElement(this.props.children, this.props),
	              !_stores2.default.SessionStore.hideFooter && _react2.default.createElement(_Footer2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.expireWarning && _react2.default.createElement(_ExpireWarning2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.dialog && _react2.default.createElement(_Dialog2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.confirm && _react2.default.createElement(_Confirm2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.prompt && _react2.default.createElement(_Prompt2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.toaster && _react2.default.createElement(_Toaster2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.notification && _react2.default.createElement(_Notification2.default, Object.assign({ store: _stores2.default }, this.props)),
	              _stores2.default.SessionStore.modalContent && _react2.default.createElement(_Modal2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.calculator && _react2.default.createElement(_Calculator2.default, { store: _stores2.default }),
	              (_stores2.default.SessionStore.loading || _stores2.default.SessionStore.loadingClass || _stores2.default.SessionStore.backgroundLoadingCalls.indexOf('getSingleApproval') >= 0) && !_stores2.default.SessionStore.tallyLoad && _react2.default.createElement(_Loader2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.tallyLoad && _react2.default.createElement(_TallyLoader2.default, { store: _stores2.default, routing: this.props.router }),
	              _stores2.default.SessionStore.profile.firstName && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: 'salesforce-chat',
	                renderFeatureCallback: this.renderSFChat,
	                renderDefaultCallback: function renderDefaultCallback() {
	                  return _this3.shouldRenderZD();
	                }
	              })
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	exports.default = (0, _mobxReact.observer)(App);

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Loader = __webpack_require__(148);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Dialog = __webpack_require__(147);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _stores = __webpack_require__(100);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Store
	
	
	var AppLoggedOut = function (_React$Component) {
	  _inherits(AppLoggedOut, _React$Component);
	
	  function AppLoggedOut() {
	    _classCallCheck(this, AppLoggedOut);
	
	    return _possibleConstructorReturn(this, (AppLoggedOut.__proto__ || Object.getPrototypeOf(AppLoggedOut)).apply(this, arguments));
	  }
	
	  _createClass(AppLoggedOut, [{
	    key: 'render',
	    value: function render() {
	      // Import styles
	      if (!document.querySelector('link[href*="screen.css"]')) {
	        var highContrast = _stores2.default.SessionStore.highContrast;
	
	
	        var defaultStyles = document.createElement('link');
	        defaultStyles.rel = '' + (highContrast ? 'alternate stylesheet' : 'stylesheet ');
	        defaultStyles.type = 'text/css';
	        defaultStyles.href = './static/css/screen.css';
	
	        var highContrastStyles = document.createElement('link');
	        highContrastStyles.rel = '' + (highContrast ? 'stylesheet' : 'alternate stylesheet');
	        highContrastStyles.type = 'text/css';
	        highContrastStyles.href = './static/css/hi-c.css';
	
	        document.head.appendChild(defaultStyles);
	        document.head.appendChild(highContrastStyles);
	      }
	
	      // Detect touch device
	      var docRoot = document.querySelector('html');
	      if ('ontouchstart' in document.documentElement) {
	        docRoot.classList.add('touch');
	      }
	
	      document.querySelector('body').classList.add('logged-out');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'viewport' },
	        _react2.default.cloneElement(this.props.children, this.props),
	        _stores2.default.SessionStore.loading && _react2.default.createElement(_Loader2.default, { store: _stores2.default }),
	        _stores2.default.SessionStore.dialog && _react2.default.createElement(_Dialog2.default, { store: _stores2.default })
	      );
	    }
	  }]);
	
	  return AppLoggedOut;
	}(_react2.default.Component);
	
	exports.default = (0, _mobxReact.observer)(AppLoggedOut);

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _logrocket = __webpack_require__(111);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	var _HeaderOutside = __webpack_require__(749);
	
	var _HeaderOutside2 = _interopRequireDefault(_HeaderOutside);
	
	var _Loader = __webpack_require__(148);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Dialog = __webpack_require__(147);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Confirm = __webpack_require__(213);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Toaster = __webpack_require__(217);
	
	var _Toaster2 = _interopRequireDefault(_Toaster);
	
	var _Notification = __webpack_require__(214);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _Prompt = __webpack_require__(216);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _config = __webpack_require__(9);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _stores = __webpack_require__(100);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	// Store
	
	
	var AppOutside = function (_React$Component) {
	  _inherits(AppOutside, _React$Component);
	
	  function AppOutside() {
	    _classCallCheck(this, AppOutside);
	
	    return _possibleConstructorReturn(this, (AppOutside.__proto__ || Object.getPrototypeOf(AppOutside)).apply(this, arguments));
	  }
	
	  _createClass(AppOutside, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = _stores2.default.SessionStore;
	
	      // Add token to session storage
	
	      if (SessionStore.hasSessionStorage) {
	        sessionStorage.setItem('token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjA4MWRlMjUwLTc5NDUtMTFlNy1iMWJmLTE3NGY3MzhmNGRlMSIsInRpbWVvdXQiOjAsImNyZWF0ZV90aW1lIjoxNTAxODcyMzA1Mzk3fQ.UNaZHd7J01DzbnRmLUOOEL_ezw5LfDeVVmRuR5NwTso');
	      } else {
	        document.cookie = 'token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjA4MWRlMjUwLTc5NDUtMTFlNy1iMWJmLTE3NGY3MzhmNGRlMSIsInRpbWVvdXQiOjAsImNyZWF0ZV90aW1lIjoxNTAxODcyMzA1Mzk3fQ.UNaZHd7J01DzbnRmLUOOEL_ezw5LfDeVVmRuR5NwTso';
	      }
	
	      // Remove the token param from the URL
	      // this.props.router.push(this.props.location.pathname);
	
	      // Check the token
	      // this.checkToken();
	
	      // Set token to api header
	      if (SessionStore.hasSessionStorage) {
	        (0, _config.setToken)(sessionStorage.getItem('token'), true);
	      } else {
	        (0, _config.setToken)((0, _helpers.getCookie)('token'), true);
	      }
	
	      // Get translations
	      if (!SessionStore.translationLoaded) {
	        SessionStore.getTranslation(SessionStore.locale);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (true) {
	        if (!_stores2.default.SessionStore.logRocketInit) {
	          _logrocket2.default.init(_config.config.logRocket);
	          _stores2.default.SessionStore.logRocketInit = true;
	        }
	      }
	      window.addEventListener('message', function (event) {
	        if (event.origin === _config.config.domain && event.data === "SpRbScheduled__ConfirmBack") {
	          var sourceWindow = event.source;
	          sourceWindow.postMessage("SpRbScheduled__Confirmed", "*");
	        }
	      });
	    }
	  }, {
	    key: 'checkToken',
	    value: function checkToken() {
	      var SessionStore = _stores2.default.SessionStore;
	
	      SessionStore.checkToken();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Import styles
	      if (!document.querySelector('link[href*="screen.css"]')) {
	        var highContrast = _stores2.default.SessionStore.highContrast;
	
	
	        var defaultStyles = document.createElement('link');
	        defaultStyles.rel = '' + (highContrast ? 'alternate stylesheet' : 'stylesheet ');
	        defaultStyles.type = 'text/css';
	        defaultStyles.href = './static/css/screen.css';
	
	        var highContrastStyles = document.createElement('link');
	        highContrastStyles.rel = '' + (highContrast ? 'stylesheet' : 'alternate stylesheet');
	        highContrastStyles.type = 'text/css';
	        highContrastStyles.href = './static/css/hi-c.css';
	
	        document.head.appendChild(defaultStyles);
	        document.head.appendChild(highContrastStyles);
	      }
	
	      // Detect touch device
	      var docRoot = document.querySelector('html');
	      if ('ontouchstart' in document.documentElement) {
	        docRoot.classList.add('touch');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'viewport' },
	        _react2.default.createElement(
	          _reactLaunchDarkly.LaunchDarkly,
	          { clientId: _config.config.ldApiKey, user: { key: 'anonymous-user', anonymous: true } },
	          _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'maintenance-message',
	            renderFeatureCallback: function renderFeatureCallback(flagValue) {
	              if (flagValue && (typeof flagValue === 'undefined' ? 'undefined' : _typeof(flagValue)) === 'object' && flagValue.message !== undefined) {
	                // Redirect to maintenance page
	                window.location.href = '/#/maintenance';
	                return null;
	              } else {
	                return null;
	              }
	            }
	          })
	        ),
	        _react2.default.createElement(_HeaderOutside2.default, { store: _stores2.default }),
	        _react2.default.cloneElement(this.props.children, this.props),
	        (_stores2.default.SessionStore.loading || _stores2.default.SessionStore.loadingClass) && _react2.default.createElement(_Loader2.default, { store: _stores2.default }),
	        _stores2.default.SessionStore.dialog && _react2.default.createElement(_Dialog2.default, { store: _stores2.default }),
	        _stores2.default.SessionStore.confirm && _react2.default.createElement(_Confirm2.default, { store: _stores2.default }),
	        _stores2.default.SessionStore.prompt && _react2.default.createElement(_Prompt2.default, { store: _stores2.default }),
	        _stores2.default.SessionStore.toaster && _react2.default.createElement(_Toaster2.default, { store: _stores2.default }),
	        _stores2.default.SessionStore.notification && _react2.default.createElement(_Notification2.default, Object.assign({ store: _stores2.default }, this.props))
	      );
	    }
	  }]);
	
	  return AppOutside;
	}(_react2.default.Component);
	
	exports.default = (0, _mobxReact.observer)(AppOutside);

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _jwtDecode = __webpack_require__(247);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _logrocket = __webpack_require__(111);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	var _Loader = __webpack_require__(148);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Dialog = __webpack_require__(147);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Confirm = __webpack_require__(213);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Toaster = __webpack_require__(217);
	
	var _Toaster2 = _interopRequireDefault(_Toaster);
	
	var _Notification = __webpack_require__(214);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _Prompt = __webpack_require__(216);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _stores = __webpack_require__(100);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Config
	
	
	// Dependencies
	
	
	// Components
	
	
	// Store
	
	
	// Helpers
	
	
	var AppOutside = function (_React$Component) {
	  _inherits(AppOutside, _React$Component);
	
	  function AppOutside() {
	    var _ref;
	
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, AppOutside);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = AppOutside.__proto__ || Object.getPrototypeOf(AppOutside)).call.apply(_ref, [this].concat(args))), _this2), _this2.renderZDChat = function () {
	      var userData = _stores2.default.SessionStore.userData;
	
	      var zdScript = document.querySelector('#ze-snippet');
	
	      if (!zdScript) {
	        var zdc = document.createElement('script');
	        zdc.id = 'ze-snippet';
	        zdc.type = 'text/javascript';
	        zdc.async = true;
	        zdc.src = 'https://static.zdassets.com/ekr/snippet.js?key=a3206868-bdac-4af5-a921-ee51087a581e';
	
	        zdc.onload = function () {
	          window.zE(function () {
	            window.zE.identify({
	              organization: userData.installSid
	            });
	
	            window.zE('webWidget', 'updateSettings', {
	              webWidget: {
	                offset: {
	                  vertical: '44px'
	                }
	              }
	            });
	          });
	        };
	
	        document.body.appendChild(zdc);
	      }
	
	      return null;
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  _createClass(AppOutside, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = _stores2.default.SessionStore;
	
	      // Get translations
	
	      if (!SessionStore.translationLoaded) {
	        SessionStore.getTranslation(SessionStore.locale);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var SessionStore = _stores2.default.SessionStore;
	
	
	      var token = (0, _helpers.getParam)('token', window.location.href);
	      if (token && token !== '') {
	        SessionStore.setUserData((0, _jwtDecode2.default)(token));
	      }
	
	      if (true) {
	        if (!_stores2.default.SessionStore.logRocketInit) {
	          _logrocket2.default.init(_config.config.logRocket);
	          _stores2.default.SessionStore.logRocketInit = true;
	        }
	      }
	
	      this.renderAgreements();
	      this.renderZDChat();
	    }
	  }, {
	    key: 'checkToken',
	    value: function checkToken() {
	      var SessionStore = _stores2.default.SessionStore;
	
	      SessionStore.checkToken();
	    }
	  }, {
	    key: 'handleChromeStoreId',
	    value: function handleChromeStoreId(value) {
	      var SessionStore = _stores2.default.SessionStore;
	
	
	      _config.config.extensionUrl = 'https://chrome.google.com/webstore/detail/smarterproctoring/' + value;
	      _config.config.extensionId = value;
	      _config.config.extensionManifestUrl = 'https://smarterproctoring-extension.s3.amazonaws.com/manifest.' + value + '.json';
	
	      // Get extension info from the manifest
	      SessionStore.getExtensionInfo();
	
	      // Since this is called by the LaunchDarkly FeatureFlag
	      // component which is inside the render function, we
	      // need to return either null, a string, or an element
	      // or else React will freak out.
	      return null;
	    }
	  }, {
	    key: 'renderAgreements',
	    value: function renderAgreements() {
	      var _this = this;
	      var agrScript = document.querySelector('#agr-ui');
	
	      if (!agrScript) {
	        var agr = document.createElement('script');
	        agr.id = 'agr-ui';
	        agr.type = 'text/javascript';
	        agr.async = true;
	        agr.src = _config.config.agreementUISrc;
	
	        document.body.appendChild(agr);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Import styles
	      if (!document.querySelector('link[href*="screen.css"]')) {
	        var highContrast = _stores2.default.SessionStore.highContrast;
	
	
	        var defaultStyles = document.createElement('link');
	        defaultStyles.rel = '' + (highContrast ? 'alternate stylesheet' : 'stylesheet ');
	        defaultStyles.type = 'text/css';
	        defaultStyles.href = './static/css/screen.css';
	
	        var highContrastStyles = document.createElement('link');
	        highContrastStyles.rel = '' + (highContrast ? 'stylesheet' : 'alternate stylesheet');
	        highContrastStyles.type = 'text/css';
	        highContrastStyles.href = './static/css/hi-c.css';
	
	        document.head.appendChild(defaultStyles);
	        document.head.appendChild(highContrastStyles);
	      }
	
	      // Detect touch device
	      var docRoot = document.querySelector('html');
	      if ('ontouchstart' in document.documentElement) {
	        docRoot.classList.add('touch');
	      }
	
	      // LaunchDarkly user config
	      var ldConfig = {
	        key: 'External User ' + Date.now(),
	        custom: {
	          installSid: sessionStorage.getItem('installSid') || '',
	          courseSid: sessionStorage.getItem('courseSid') || '',
	          userAgent: navigator.userAgent
	        }
	      };
	
	      return _react2.default.createElement(
	        _reactLaunchDarkly.LaunchDarkly,
	        { clientId: _config.config.ldApiKey, user: ldConfig },
	        _react2.default.createElement(
	          'div',
	          { className: 'viewport' },
	          _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'extension-chrome-store-id',
	            renderFeatureCallback: this.handleChromeStoreId
	          }),
	          _react2.default.cloneElement(this.props.children, this.props),
	          (_stores2.default.SessionStore.loading || _stores2.default.SessionStore.loadingClass) && _react2.default.createElement(_Loader2.default, { store: _stores2.default }),
	          _stores2.default.SessionStore.dialog && _react2.default.createElement(_Dialog2.default, { store: _stores2.default }),
	          _stores2.default.SessionStore.confirm && _react2.default.createElement(_Confirm2.default, { store: _stores2.default }),
	          _stores2.default.SessionStore.prompt && _react2.default.createElement(_Prompt2.default, { store: _stores2.default }),
	          _stores2.default.SessionStore.toaster && _react2.default.createElement(_Toaster2.default, { store: _stores2.default }),
	          _stores2.default.SessionStore.notification && _react2.default.createElement(_Notification2.default, Object.assign({ store: _stores2.default }, this.props))
	        )
	      );
	    }
	  }]);
	
	  return AppOutside;
	}(_react2.default.Component);
	
	exports.default = (0, _mobxReact.observer)(AppOutside);

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExamApprovals = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamApprovals, _React$Component);
	
	  function ExamApprovals() {
	    _classCallCheck(this, ExamApprovals);
	
	    var _this = _possibleConstructorReturn(this, (ExamApprovals.__proto__ || Object.getPrototypeOf(ExamApprovals)).call(this));
	
	    _this.applyFilters = _this.applyFilters.bind(_this);
	    _this.resetFilters = _this.resetFilters.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExamApprovals, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerContent: null,
	        drawerOpen: false,
	        courseSid: null
	      };
	
	      this.props.store.ExamStore.getExamApprovals();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if ((0, _helpers.getURLSegment)(this, 2) === 'review') {
	        (0, _helpers.toggleDrawer)(null, this, 'ExamException');
	      }
	    }
	  }, {
	    key: 'applyFilters',
	    value: function applyFilters(e) {
	      e.preventDefault();
	
	      var filters = {};
	
	      var fname = this.fname.value;
	      var lname = this.lname.value;
	
	      if (fname) {
	        filters.instructorFirstName = fname;
	      }
	
	      if (lname) {
	        filters.instructorLastName = lname;
	      }
	
	      if (fname || lname) {
	        this.props.store.ExamStore.getExamApprovals(filters);
	      } else {
	        this.resetFilters();
	      }
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      this.fname.value = '';
	      this.lname.value = '';
	
	      this.props.store.ExamStore.getExamApprovals();
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (SessionStore.loadingCalls.indexOf('GetExamApprovals') < 0) {
	        if (ExamStore.examApprovals.length > 0) {
	          return _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-title', className: 'subtitle', scope: 'col' },
	                  translation.title
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-course', className: 'subtitle', scope: 'col' },
	                  translation.course
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-instructor', className: 'subtitle', scope: 'col' },
	                  translation.instructor
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-student', className: 'subtitle', scope: 'col' },
	                  translation.student
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-starts', className: 'subtitle', scope: 'col' },
	                  translation.starts
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-ends', className: 'subtitle', scope: 'col' },
	                  translation.ends
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-dates', className: 'subtitle', scope: 'col' },
	                  translation.actions
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              ExamStore.examApprovals.map(function (approval, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: i },
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-title' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      {
	                        to: '/' + (0, _helpers.getURLSegment)(_this2, 1) + '/review/exam/' + approval.examSid + '/configuration/' + approval.sid + '/course/' + approval.course.sid + '?exception=' + (approval.enrollment ? 'true' : 'false'),
	                        title: 'Review ' + approval.exam.title
	                      },
	                      approval.exam.title
	                    ),
	                    approval.referenceExamConfigurationSid && _react2.default.createElement(
	                      'span',
	                      { className: 'title' },
	                      translation.change_request
	                    ),
	                    approval.enrollment && _react2.default.createElement(
	                      'span',
	                      { className: 'title' },
	                      approval.enrollment.user.lastName,
	                      ', ',
	                      approval.enrollment.user.firstName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-course' },
	                    approval.course.title
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-instructor' },
	                    approval.instructor && _react2.default.createElement(
	                      'span',
	                      null,
	                      approval.instructor.firstName,
	                      ' ',
	                      approval.instructor.lastName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-student' },
	                    approval.enrollment && _react2.default.createElement(
	                      'span',
	                      null,
	                      approval.enrollment.user.lastName,
	                      ', ',
	                      approval.enrollment.user.firstName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-starts', className: 'number' },
	                    _moment2.default.utc(approval.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-ends', className: 'number' },
	                    _moment2.default.utc(approval.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      {
	                        className: 'btn--outline',
	                        to: '/' + (0, _helpers.getURLSegment)(_this2, 1) + '/review/exam/' + approval.examSid + '/configuration/' + approval.sid + '/course/' + approval.course.sid + '?exception=' + (approval.enrollment ? 'true' : 'false')
	                      },
	                      _react2.default.createElement(icons.iconEye, null),
	                      translation.review
	                    )
	                  )
	                );
	              })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            { className: 'no-results' },
	            translation.no_results
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store$ExamStor = this.props.store.ExamStore,
	          examApprovals = _props$store$ExamStor.examApprovals,
	          examApprovalsNext = _props$store$ExamStor.examApprovalsNext;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'filter', onSubmit: function onSubmit(e) {
	              _this3.applyFilters(e);
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'filter__filters' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--inline' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.filter_heading,
	                    ':'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-fname' },
	                    translation.instructor_fname
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'filter-fname',
	                    placeholder: translation.instructor_fname,
	                    ref: function ref(input) {
	                      _this3.fname = input;
	                    }
	                    // onBlur={this.applyFilters}
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-lname' },
	                    translation.instructor_lname
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'filter-lname',
	                    placeholder: translation.instructor_lname,
	                    ref: function ref(input) {
	                      _this3.lname = input;
	                    }
	                    // onBlur={this.applyFilters}
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'actions' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  type: 'submit'
	                },
	                translation.filter
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--outline',
	                  type: 'reset',
	                  onClick: this.resetFilters
	                },
	                translation.reset
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        ),
	        examApprovalsNext && _react2.default.createElement(_LoadMore2.default, Object.assign({
	          url: examApprovalsNext,
	          group: examApprovals,
	          text: 'Load more results'
	        }, this.props)),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          approval: true,
	          courseSid: this.state.courseSid
	        }, this.props))
	      );
	    }
	  }]);
	
	  return ExamApprovals;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamApprovals')(ExamApprovals);

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ProctorApproval = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProctorApproval, _React$Component);
	
	  function ProctorApproval() {
	    _classCallCheck(this, ProctorApproval);
	
	    var _this2 = _possibleConstructorReturn(this, (ProctorApproval.__proto__ || Object.getPrototypeOf(ProctorApproval)).call(this));
	
	    _this2.toggleDescription = _this2.toggleDescription.bind(_this2);
	    _this2.updateNote = _this2.updateNote.bind(_this2);
	    _this2.renderNote = _this2.renderNote.bind(_this2);
	    _this2.getLocations = _this2.getLocations.bind(_this2);
	    _this2.approveProctor = _this2.approveProctor.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ProctorApproval, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        action: null,
	        applyTo: null,
	        showDescription: false,
	        showLocation: false,
	        gotLocations: false,
	        submitted: false
	      };
	    }
	  }, {
	    key: 'toggleDescription',
	    value: function toggleDescription() {
	      this.setState({
	        showDescription: !this.state.showDescription
	      });
	    }
	  }, {
	    key: 'updateNote',
	    value: function updateNote() {
	      var action = this.action.value;
	      var applyTo = this.applyTo.value;
	
	      this.setState({
	        action: action,
	        applyTo: applyTo
	      });
	    }
	  }, {
	    key: 'renderNote',
	    value: function renderNote() {
	      var _this = this;
	      var _props$translation$ap = this.props.translation.apply_to,
	          descriptions = _props$translation$ap.descriptions,
	          descriptionsSubmitted = _props$translation$ap.descriptionsSubmitted;
	
	
	      function applyToWho() {
	        switch (_this.state.applyTo) {
	          case 'install':
	            return descriptions.install;
	
	          case 'instructor':
	            return descriptions.instructor;
	
	          case 'course':
	            return descriptions.course;
	
	          case 'exam':
	            return descriptions.exam;
	
	          case 'student':
	            return descriptions.student;
	
	          case 'enrollment':
	            return descriptions.enrollment;
	
	          case 'session':
	            return descriptions.enrollment_exam;
	
	          default:
	            return '';
	        }
	      }
	
	      if (this.state.applyTo && this.state.action) {
	        if (!this.state.submitted) {
	          return _react2.default.createElement(
	            'em',
	            { className: 'actions__note' },
	            this.state.action === 'allow' ? descriptions.approved : descriptions.denied,
	            ' ',
	            applyToWho(),
	            '.'
	          );
	        } else {
	          return _react2.default.createElement(
	            'em',
	            { className: 'actions__note' },
	            this.state.action === 'allow' ? descriptionsSubmitted.approved : descriptionsSubmitted.denied,
	            ' ',
	            applyToWho(),
	            '.'
	          );
	        }
	      }
	
	      return '';
	    }
	  }, {
	    key: 'getLocations',
	    value: function getLocations() {
	      var _props = this.props,
	          approval = _props.approval,
	          store = _props.store;
	
	
	      if (!this.state.gotLocations) {
	        store.LocationStore.getLocations(approval.proctorAccount.sid);
	      }
	
	      if (!this.state.showLocation) {
	        this.setState({
	          showLocation: true,
	          gotLocations: true
	        });
	      } else {
	        this.setState({
	          showLocation: false,
	          gotLocations: true
	        });
	      }
	    }
	  }, {
	    key: 'approveProctor',
	    value: function approveProctor() {
	      var _props2 = this.props,
	          approval = _props2.approval,
	          store = _props2.store;
	      var ProctorStore = store.ProctorStore,
	          SessionStore = store.SessionStore;
	
	
	      var data = {
	        reviewedByUserSid: SessionStore.profile.sid,
	        status: this.state.action,
	        applyTo: this.state.applyTo
	      };
	
	      this.props.approvalCallback();
	
	      ProctorStore.updatePendingApprovals(approval.sid, data);
	
	      // Update the submission status
	      this.setState({
	        submitted: true
	      });
	    }
	  }, {
	    key: 'renderVerificationData',
	    value: function renderVerificationData(data, now, i) {
	      var translation = this.props.translation;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var expireDate = (0, _moment2.default)(data.verificationExpires);
	      var expireDiff = _moment2.default.duration(expireDate.diff(now)).asMinutes();
	
	      if (expireDiff > 0) {
	        return _react2.default.createElement(
	          'i',
	          { className: 'approval__verified', 'aria-describedby': i + '-' + data.sid + '-tooltip' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tooltip tooltip--down' },
	            _react2.default.createElement(
	              'span',
	              { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	              _react2.default.createElement(icons.iconBadgeCheck, null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { id: i + '-' + data.sid + '-tooltip', className: 'tooltip__body', role: 'tooltip' },
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip__copy' },
	                data.verificationNotes && _react2.default.createElement('p', {
	                  dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(data.verificationNotes) }
	                }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.verified.replace('%date%', (0, _moment2.default)(expireDate).tz(userTimezone).format('M/D/YYYY'))
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          approval = _props3.approval,
	          proctor = _props3.proctor,
	          store = _props3.store,
	          translation = _props3.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var locations = store.LocationStore.locations;
	
	      var phone = (0, _reactPhoneNumberInput.parsePhoneNumber)(proctor.phoneNumber);
	      var createdDate = approval.createdDate,
	          requestedByUser = approval.requestedByUser;
	      var _approval$appliesTo = approval.appliesTo,
	          course = _approval$appliesTo.course,
	          exam = _approval$appliesTo.exam,
	          examSession = _approval$appliesTo.examSession,
	          instructorUser = _approval$appliesTo.instructorUser;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var role = SessionStore.userData.role.toLowerCase();
	      var now = (0, _moment2.default)(SessionStore.currentTime);
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'approval' },
	        _react2.default.createElement(
	          'div',
	          { className: 'block' },
	          _react2.default.createElement(
	            'header',
	            { className: 'approval__header' },
	            _react2.default.createElement(
	              'figure',
	              { className: 'media' },
	              proctor.image && _react2.default.createElement(
	                'span',
	                { className: 'proctor__avatar avatar-wrap' },
	                _react2.default.createElement('img', {
	                  className: 'avatar',
	                  src: proctor.image,
	                  alt: '',
	                  onLoad: function onLoad(e) {
	                    (0, _helpers.flagPortrait)(e, proctor.image);
	                  }
	                })
	              ),
	              !proctor.image && _react2.default.createElement(
	                'span',
	                { className: 'proctor__avatar avatar-wrap' },
	                _react2.default.createElement('img', {
	                  className: 'avatar avatar--missing',
	                  src: './static/img/avatar-default.png',
	                  alt: 'No avatar provided',
	                  onLoad: function onLoad(e) {
	                    (0, _helpers.flagPortrait)(e, './static/img/avatar-default.png');
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'figcaption',
	                { className: 'media__copy' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'approval__title fn org' },
	                  proctor.firstName && proctor.firstName + ' ' + proctor.lastName,
	                  !proctor.firstName && proctor.accountName
	                ),
	                proctor.firstName && proctor.accountName && _react2.default.createElement(
	                  'span',
	                  { className: 'approval__account' },
	                  proctor.accountName
	                ),
	                proctor.email && _react2.default.createElement(
	                  'a',
	                  { className: 'approval__email', href: 'mailto:' + proctor.email },
	                  proctor.email
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'approval__details' },
	            proctor.description && _react2.default.createElement(
	              'div',
	              { className: 'approval__description text-block ' + (this.state.showDescription ? 'visible' : '') },
	              _react2.default.createElement(
	                'p',
	                null,
	                proctor.description
	              )
	            ),
	            _react2.default.createElement(
	              'section',
	              { className: 'approval__details-section' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Proctor Type'
	              ),
	              approval.proctorTypes && _react2.default.createElement(
	                'ul',
	                { className: 'approval__category data--comma' },
	                approval.proctorTypes.map(function (proctorType, i) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: i },
	                    proctorType.title,
	                    proctorType.verificationCompletionDate && _this3.renderVerificationData(proctorType, now, i)
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'section',
	              { className: 'approval__details-section' },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Session Details'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'data--alt' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.session_details.requested_by,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    requestedByUser.firstName,
	                    ' ',
	                    requestedByUser.lastName
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.session_details.requested_on,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _moment2.default.utc(createdDate).tz(userTimezone).format('M/D/YYYY [at] h:mma')
	                  )
	                ),
	                course && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.session_details.course,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    course.title,
	                    ' (',
	                    course.code,
	                    ')'
	                  )
	                ),
	                instructorUser && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.session_details.instructor,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    instructorUser.firstName,
	                    ' ',
	                    instructorUser.lastName
	                  )
	                ),
	                exam && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.session_details.exam,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    exam.title
	                  )
	                ),
	                examSession && examSession.examConfiguration && examSession.examConfiguration.duration && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.session_details.exam_duration,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    (0, _helpers.toHours)(examSession.examConfiguration.duration, false, true, true)
	                  )
	                ),
	                examSession && examSession.examConfiguration && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.session_details.exam_dates,
	                    ':'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _moment2.default.utc(examSession.examConfiguration.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma'),
	                    '\u2013',
	                    _moment2.default.utc(examSession.examConfiguration.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  )
	                ),
	                examSession && _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.session_details.appointment_date,
	                    ':'
	                  ),
	                  examSession.appointmentDate && _react2.default.createElement(
	                    'p',
	                    null,
	                    _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  !examSession.appointmentDate && _react2.default.createElement(
	                    'p',
	                    null,
	                    'Not scheduled'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'approval__more', onClick: this.getLocations },
	            !this.state.showLocation && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(icons.iconPlus, null),
	              translation.more_information
	            ),
	            this.state.showLocation && _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(icons.iconMinus, null),
	              translation.less_information
	            )
	          ),
	          _react2.default.createElement(
	            'footer',
	            { className: 'approval__actions actions' },
	            !this.state.submitted && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  { onChange: this.updateNote, ref: function ref(input) {
	                      _this3.action = input;
	                    } },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    translation.action.label
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'allow' },
	                    translation.action.approve
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'deny' },
	                    translation.action.deny
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  { onChange: this.updateNote, ref: function ref(input) {
	                      _this3.applyTo = input;
	                    } },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    translation.apply_to.label
	                  ),
	                  Object.keys(translation.apply_to[role + '_options']).map(function (key) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: key, value: key },
	                      translation.apply_to[role + '_options'][key]
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'actions__btn actions__btn--primary',
	                  onClick: this.approveProctor,
	                  disabled: !this.state.action || !this.state.applyTo
	                },
	                translation.submit
	              ),
	              this.renderNote()
	            ),
	            this.state.submitted && this.renderNote()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'approval__locations slideout ' + (this.state.showLocation ? 'open' : '') },
	          locations.map(function (key, i) {
	            return _react2.default.createElement(
	              'ul',
	              { key: i, className: 'data vcard' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'adr' },
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    key.name
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'street-address' },
	                    key.address1,
	                    ' ',
	                    key.address2
	                  ),
	                  key.place && _react2.default.createElement(
	                    'span',
	                    { className: 'locality' },
	                    key.place,
	                    ', '
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'region' },
	                    key.region,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'postal-code' },
	                    key.postalCode
	                  )
	                ),
	                proctor.phoneNumber && _react2.default.createElement(
	                  'div',
	                  { className: 'tel' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'type' },
	                    'work'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'value' },
	                    (0, _reactPhoneNumberInput.formatPhoneNumber)(phone, 'National')
	                  )
	                ),
	                key.parkingInformation && _react2.default.createElement(
	                  'div',
	                  { className: 'approval__directions' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.parking
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    key.parkingInformation
	                  )
	                )
	              ),
	              (key.hasComputerAvailable || key.hasPrinterAvailable || key.hasCopierAvailable || key.hasFaxAvailable || key.hasElevator || key.hasWheelchairRamp || key.hasAlternativeKeyboards || key.hasScreenEnlarger || key.hasScreenReader || key.hasSpeechRecognition || key.hasTextToSpeech || key.hasDistractionFreeRooms) && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  translation.features_heading
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'approval__features' },
	                  key.hasComputerAvailable && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.computer
	                  ),
	                  key.hasPrinterAvailable && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.printer
	                  ),
	                  key.hasCopierAvailable && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.copier
	                  ),
	                  key.hasFaxAvailable && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.fax
	                  ),
	                  key.hasElevator && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.elevator
	                  ),
	                  key.hasWheelchairRamp && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.wheelchair_ramp
	                  ),
	                  key.hasAlternativeKeyboards && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.alternative_keyboards
	                  ),
	                  key.hasScreenEnlarger && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.screen_enlarger
	                  ),
	                  key.hasScreenReader && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.screen_reader
	                  ),
	                  key.hasSpeechRecognition && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.speech_recognition
	                  ),
	                  key.hasTextToSpeech && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.text_to_speech
	                  ),
	                  key.hasDistractionFreeRooms && _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.features.distraction_free_rooms
	                  )
	                )
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return ProctorApproval;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProctorApproval')(ProctorApproval);

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var AudioRecorder = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AudioRecorder, _React$Component);
	
	  function AudioRecorder() {
	    _classCallCheck(this, AudioRecorder);
	
	    var _this2 = _possibleConstructorReturn(this, (AudioRecorder.__proto__ || Object.getPrototypeOf(AudioRecorder)).call(this));
	
	    _this2.restart = _this2.restart.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(AudioRecorder, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        showRecord: true,
	        showStop: false,
	        audioSrc: null
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      var recordBtn = document.querySelector('.recorder__start');
	      var stopBtn = document.querySelector('.recorder__stop');
	      var canvas = document.querySelector('.recorder__visualizer');
	      var constraints = { audio: true };
	      var chunks = [];
	
	      // Visualizer setup
	      var audioCtx = new window.AudioContext();
	      var canvasCtx = canvas.getContext('2d');
	
	      // Audio recording
	      navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
	        var mediaRecorder = new window.MediaRecorder(stream);
	
	        visualize(stream);
	
	        recordBtn.onclick = function () {
	          _this.props.startRecording();
	          mediaRecorder.start();
	          _this.setState({
	            showRecord: false,
	            showStop: true
	          });
	        };
	
	        stopBtn.onclick = function () {
	          mediaRecorder.stop();
	          _this.setState({
	            showStop: false
	          });
	        };
	
	        mediaRecorder.addEventListener('stop', function () {
	          var blob = new Blob(chunks, { 'type': 'audio/ogg; codecs=opus' });
	          var audioUrl = window.URL.createObjectURL(blob);
	
	          _this.setState({
	            audioSrc: audioUrl
	          });
	
	          _this.props.setRecording(audioUrl);
	        });
	
	        mediaRecorder.ondataavailable = function (e) {
	          chunks.push(e.data);
	        };
	      });
	
	      // Visualizer
	      function visualize(stream) {
	        var source = audioCtx.createMediaStreamSource(stream);
	
	        var analyser = audioCtx.createAnalyser();
	        analyser.fftSize = 2048;
	        var bufferLength = analyser.frequencyBinCount;
	        var dataArray = new Uint8Array(bufferLength);
	
	        source.connect(analyser);
	
	        var WIDTH = canvas.width;
	        var HEIGHT = canvas.height;
	
	        draw();
	
	        function draw() {
	          requestAnimationFrame(draw);
	
	          analyser.getByteTimeDomainData(dataArray);
	
	          canvasCtx.fillStyle = '#f3f7f9';
	          canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);
	
	          canvasCtx.lineWidth = 2;
	          canvasCtx.strokeStyle = '#76838f';
	
	          canvasCtx.beginPath();
	
	          var sliceWidth = WIDTH * 1.0 / bufferLength;
	          var x = 0;
	
	          for (var i = 0; i < bufferLength; i++) {
	            var v = dataArray[i] / 128.0;
	            var y = v * HEIGHT / 2;
	
	            if (i === 0) {
	              canvasCtx.moveTo(x, y);
	            } else {
	              canvasCtx.lineTo(x, y);
	            }
	
	            x += sliceWidth;
	          }
	
	          canvasCtx.lineTo(canvas.width, canvas.height / 2);
	          canvasCtx.stroke();
	        }
	      }
	    }
	  }, {
	    key: 'restart',
	    value: function restart() {
	      this.setState({
	        showRecord: true,
	        audioSrc: null
	      });
	
	      this.props.removeRecording();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'recorder' },
	        _react2.default.createElement('canvas', { className: 'recorder__visualizer ' + (this.state.showStop ? 'show' : 'hide') }),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn recorder__start', disabled: !this.state.showRecord, onClick: this.start },
	          _react2.default.createElement(icons.iconMicrophone, null),
	          translation.button
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn--negative recorder__stop', disabled: !this.state.showStop, onClick: this.stop },
	          _react2.default.createElement(icons.iconStop, null),
	          translation.stop_button
	        ),
	        this.state.audioSrc && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('audio', { className: 'recorder__audio', controls: true, src: this.state.audioSrc }),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn--outline recorder__delete', onClick: this.restart },
	            translation.restart_button
	          )
	        )
	      );
	    }
	  }]);
	
	  return AudioRecorder;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AudioRecorder')(AudioRecorder);

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BarChart = function (_React$Component) {
	  _inherits(BarChart, _React$Component);
	
	  function BarChart() {
	    _classCallCheck(this, BarChart);
	
	    return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).apply(this, arguments));
	  }
	
	  _createClass(BarChart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var barCharts = document.querySelectorAll('.bar-chart--horizontal');
	
	      for (var i = 0; i < barCharts.length; i++) {
	        var el = barCharts[i];
	        var labels = el.querySelectorAll('.bar-chart--horizontal .bar-chart__label');
	        var bars = el.querySelectorAll('.bar-chart--horizontal .bar-chart__bar');
	        var texts = el.querySelectorAll('.bar-chart--horizontal .bar-chart__text');
	        var labelWidth = 0;
	        var barMax = 0;
	
	        for (var j = 0; j < labels.length; j++) {
	          var thisWidth = Math.ceil(labels[j].getBoundingClientRect().width);
	          if (thisWidth > labelWidth) {
	            labelWidth = thisWidth + 50;
	          }
	
	          var thisVal = parseFloat(bars[j].getAttribute('width'));
	          if (thisVal > barMax) {
	            barMax = thisVal;
	          }
	        }
	
	        el.style.paddingLeft = labelWidth;
	
	        for (var k = 0; k < bars.length; k++) {
	          var bar = bars[k];
	          var text = texts[k];
	
	          // Set width to percentage of the max
	          var barWidthAttr = parseFloat(bar.getAttribute('width'));
	          var barWidth = 0;
	
	          // If the bar’s width attribute is greater than 0
	          if (barWidthAttr > 0) {
	            barWidth = parseFloat(bar.getAttribute('width')) / barMax * 100;
	          }
	
	          bar.style.width = barWidth + '%';
	          text.setAttribute('x', barWidth + '%');
	
	          // Timeout to add width inrementally and animate. Commented out because it got annoying.
	          // setTimeout(function(){
	          //   bar.style.width = barWidth + '%';
	          //   text.setAttribute('x', barWidth + '%');
	          // }, 500 + (25 * k));
	        }
	      }
	    }
	
	    // IE10 and Safari don’t like the text-anchor property, so we need to do something else for it
	
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(i, key, ie, safari) {
	      function formatStatus(status) {
	        switch (status) {
	          case 'needsProctor':
	            return 'Needs Proctor';
	
	          case 'pendingApproval':
	            return 'Pending Approval';
	
	          case 'approvalDenied':
	            return 'Approval Denied';
	
	          case 'inProgress':
	            return 'In Progress';
	
	          default:
	            return status;
	        }
	      }
	
	      if (!ie && !safari) {
	        return _react2.default.createElement(
	          'text',
	          { className: 'bar-chart__label', textAnchor: 'end', x: '-10', dy: '1.1em', y: i * 20 + i * 2 },
	          formatStatus(key)
	        );
	      } else {
	        return _react2.default.createElement(
	          'g',
	          null,
	          _react2.default.createElement('rect', { className: 'bar-chart__label-bg', width: '100', height: '20', dy: '1.1em', y: i * 20 + i * 2 }),
	          _react2.default.createElement(
	            'text',
	            { className: 'bar-chart__label', dy: '1.1em', y: i * 20 + i * 2 },
	            formatStatus(key)
	          )
	        );
	      }
	    }
	
	    // IE10 also apparently is no good at rendering the correct height on an SVG
	    // unless it is explicitly set as a style rather than the height attribute
	
	  }, {
	    key: 'sizeChart',
	    value: function sizeChart(data, ie) {
	      var style = null;
	
	      if (ie) {
	        style = {
	          height: Object.keys(data).length * 20 + (Object.keys(data).length - 1) * 2 + 40 + 'px'
	        };
	      }
	
	      return style;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.props.data;
	
	      var total = 0;
	      var ie = false;
	      var safari = false;
	      var barOffset = 0;
	
	      if (data.hasOwnProperty('incident')) {
	        delete data.incident;
	      }
	
	      if (document.querySelector('html').className.indexOf('ie-true') > -1) {
	        ie = true;
	        barOffset = 100;
	      }
	
	      if (document.querySelector('html').className.indexOf('safari') > -1) {
	        safari = true;
	        barOffset = 100;
	      }
	
	      if (data && typeof data !== 'undefined' && !Array.isArray(data)) {
	        // Get the total number of students from the summary
	        Object.keys(data).map(function (key, i) {
	          return total += data[key];
	        });
	
	        // Make sure total is at least 1 to avoid dividing by 0
	        if (total === 0) {
	          total = 1;
	        }
	
	        return _react2.default.createElement(
	          'svg',
	          {
	            className: 'bar-chart bar-chart--horizontal',
	            height: Object.keys(data).length * 20 + (Object.keys(data).length - 1) * 2,
	            role: 'img',
	            'aria-labelledby': 'chart-title-' + this.props.i,
	            'aria-describedby': 'chart-description-' + this.props.i,
	            style: this.sizeChart(data, ie, safari)
	          },
	          _react2.default.createElement(
	            'title',
	            { id: 'chart-title-' + this.props.i },
	            this.props.title
	          ),
	          _react2.default.createElement(
	            'desc',
	            { id: 'chart-description-' + this.props.i },
	            Object.keys(data).map(function (key, i) {
	              return key + ' ' + data[key] + ', ';
	            })
	          ),
	          Object.keys(data).map(function (key, i) {
	            return _react2.default.createElement(
	              'g',
	              { key: i },
	              _react2.default.createElement('rect', {
	                className: 'bar-chart__bar ' + key + ' ',
	                width: (data[key] / total * 100).toFixed(0) + '%',
	                height: '20', y: i * 20 + i * 2,
	                x: barOffset
	              }),
	              _this2.renderLabel(i, key, ie, safari),
	              _react2.default.createElement(
	                'text',
	                { className: 'bar-chart__text', x: '5', dy: '1.1em', y: i * 20 + i * 2 },
	                data[key]
	              )
	            );
	          })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return BarChart;
	}(_react2.default.Component);
	
	exports.default = BarChart;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDelayed = __webpack_require__(112);
	
	var _reactDelayed2 = _interopRequireDefault(_reactDelayed);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Toolbar = __webpack_require__(98);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var BlackoutDates = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(BlackoutDates, _React$Component);
	
	  function BlackoutDates() {
	    _classCallCheck(this, BlackoutDates);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (BlackoutDates.__proto__ || Object.getPrototypeOf(BlackoutDates)).call(this));
	
	    _this2.handleEdit = _this2.handleEdit.bind(_this2);
	    _this2.deleteDates = _this2.deleteDates.bind(_this2);
	
	    // Set the initial state
	    _this2.state = {
	      drawerOpen: false,
	      drawerContent: null,
	      selectedRows: []
	    };
	    return _this2;
	  }
	
	  _createClass(BlackoutDates, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.listBlackoutDates();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var SessionStore = this.props.store.SessionStore;
	      var pathname = this.props.routing.location.pathname;
	
	
	      if (pathname.indexOf('edit') > -1 || pathname.indexOf('add') > -1) {
	        SessionStore.loading = false;
	        (0, _helpers.toggleDrawer)(null, this, 'EditBlackoutDate');
	      }
	
	      if (pathname.indexOf('edit') > -1) {
	        var blackoutDateSid = pathname.substr(pathname.lastIndexOf('/') + 1);
	
	        this.setState({
	          blackoutDateSid: blackoutDateSid
	        });
	      }
	    }
	  }, {
	    key: 'listBlackoutDates',
	    value: function listBlackoutDates() {
	      var BlackoutStore = this.props.store.BlackoutStore;
	
	
	      var query = {
	        limit: 25
	      };
	
	      BlackoutStore.listBlackoutDates(query);
	    }
	  }, {
	    key: 'handleEdit',
	    value: function handleEdit(e, blackoutDateSid) {
	      e.preventDefault();
	
	      // Update url
	      var path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');
	
	      if (this.props.routing.location.pathname !== path) {
	        this.props.routing.push(path);
	      }
	
	      this.setState({
	        drawerContent: 'EditBlackoutDate',
	        blackoutDateSid: blackoutDateSid
	      });
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(e, sid) {
	      var selectedRows = [].concat(_toConsumableArray(this.state.selectedRows));
	      var rowIndex = -1;
	
	      if (e.target.checked) {
	        selectedRows.push(sid);
	      } else {
	        rowIndex = selectedRows.indexOf(sid);
	        selectedRows.splice(rowIndex, 1);
	      }
	
	      this.setState({
	        selectedRows: selectedRows
	      });
	    }
	  }, {
	    key: 'deleteDates',
	    value: function deleteDates() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var BlackoutStore = this.props.store.BlackoutStore;
	
	
	      var msg = {
	        heading: '' + translation.delete_confirm.heading_singular,
	        body: translation.delete_confirm.body_singular,
	        button: translation.delete_confirm.button
	      };
	
	      if (this.state.selectedRows.length > 1) {
	        msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
	        msg.body = translation.delete_confirm.body_plural;
	      }
	
	      var callback = function callback() {
	        _this3.listBlackoutDates();
	
	        _this3.setState({
	          selectedRows: []
	        });
	      };
	
	      // Loop through all the selected blackout dates
	      // and send delete API request
	      var _this = this;
	
	      (0, _helpers.confirm)(msg, function () {
	        for (var i = 0; i < _this.state.selectedRows.length; i++) {
	          BlackoutStore.deleteBlackoutDate(_this.state.selectedRows[i], callback);
	        }
	      });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          BlackoutStore = _props$store.BlackoutStore,
	          SessionStore = _props$store.SessionStore;
	      var blackoutDates = BlackoutStore.blackoutDates;
	      var userTimezone = SessionStore.userTimezone;
	
	
	      if (blackoutDates.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                {
	                  id: 'heading-select',
	                  scope: 'col'
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  'Select'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                {
	                  id: 'heading-edit',
	                  className: 'subtitle',
	                  scope: 'col'
	                },
	                translation.edit
	              ),
	              _react2.default.createElement(
	                'th',
	                {
	                  id: 'heading-start',
	                  className: 'subtitle',
	                  scope: 'col'
	                },
	                translation.start_date
	              ),
	              _react2.default.createElement(
	                'th',
	                {
	                  id: 'heading-end',
	                  className: 'subtitle',
	                  scope: 'col'
	                },
	                translation.end_date
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            blackoutDates.map(function (blackoutDate, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  {
	                    className: 'check-col',
	                    'aria-labelledby': 'heading-select'
	                  },
	                  _react2.default.createElement('input', {
	                    id: 'select-' + blackoutDate.sid,
	                    className: 'checkbox-input',
	                    type: 'checkbox',
	                    onChange: function onChange(e) {
	                      return _this4.handleSelect(e, blackoutDate.sid);
	                    },
	                    checked: _this4.state.selectedRows.indexOf(blackoutDate.sid) > -1
	                  }),
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'checkbox-label checkbox-label--solo',
	                      htmlFor: 'select-' + blackoutDate.sid
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      'Select ',
	                      blackoutDate.sid
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-edit' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                      to: '/blackout-dates/edit/' + blackoutDate.sid,
	                      onClick: function onClick(e) {
	                        _this4.handleEdit(e, blackoutDate.sid);
	                      },
	                      title: 'Edit ' + blackoutDate.title
	                    },
	                    translation.edit
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-start' },
	                  _moment2.default.utc(blackoutDate.startDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-end' },
	                  _moment2.default.utc(blackoutDate.endDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                )
	              );
	            })
	          )
	        );
	      } else if (blackoutDates.length === 0 && !SessionStore.loading) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var BlackoutStore = this.props.store.BlackoutStore;
	      var blackoutDates = BlackoutStore.blackoutDates,
	          blackoutDatesNext = BlackoutStore.blackoutDatesNext;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'btn--outline',
	                to: 'blackout-dates/add'
	              },
	              _react2.default.createElement(icons.iconPlus, null),
	              translation.add
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        ),
	        blackoutDatesNext && _react2.default.createElement(_LoadMore2.default, Object.assign({
	          url: blackoutDatesNext,
	          group: blackoutDates,
	          text: 'Load more results'
	        }, this.props)),
	        _react2.default.createElement(
	          _reactDelayed2.default,
	          {
	            mounted: this.state.selectedRows.length > 0,
	            unmountAfter: 250
	          },
	          _react2.default.createElement(_Toolbar2.default, Object.assign({
	            selectedRows: this.state.selectedRows,
	            deleteText: translation.delete,
	            deleteFunction: this.deleteDates
	          }, this.props))
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this
	        }, this.props, {
	          blackoutDateSid: this.state.blackoutDateSid
	        }))
	      );
	    }
	  }]);
	
	  return BlackoutDates;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('BlackoutDates')(BlackoutDates);

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeSelect = __webpack_require__(365);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var EditBlackoutDate = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditBlackoutDate, _React$Component);
	
	  function EditBlackoutDate() {
	    _classCallCheck(this, EditBlackoutDate);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (EditBlackoutDate.__proto__ || Object.getPrototypeOf(EditBlackoutDate)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      startDate: null,
	      endDate: null,
	      blackoutDate: {
	        startDate: null,
	        endDate: null
	      }
	    };
	    return _this;
	  }
	
	  _createClass(EditBlackoutDate, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var BlackoutStore = this.props.store.BlackoutStore;
	
	
	      var callback = function callback(response) {
	        var blackoutDate = {
	          startDate: response.data.startDate,
	          endDate: response.data.endDate
	        };
	
	        _this2.setState({
	          startDate: response.data.startDate,
	          endDate: response.data.endDate,
	          blackoutDate: blackoutDate
	        });
	      };
	
	      // If we’re editing, get the blackout date
	      if ((0, _helpers.getURLSegment)(this, 2) === 'edit') {
	        BlackoutStore.getBlackoutDate((0, _helpers.getURLSegment)(this, 3), callback);
	      }
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, name) {
	      var time = this.startTime.value;
	
	      if (name === 'endDate') {
	        time = this.endTime.value;
	      }
	
	      this.updateDates(date, time, name);
	    }
	  }, {
	    key: 'handleTimeChange',
	    value: function handleTimeChange(name, e) {
	      var date = this.state.startDate;
	
	      if (name === 'endDate') {
	        date = this.state.endDate;
	      }
	
	      this.updateDates(date, e.target.value, name);
	    }
	  }, {
	    key: 'updateDates',
	    value: function updateDates(date, time, name) {
	      var _setState;
	
	      var SessionStore = this.props.store.SessionStore;
	      var userTimezone = SessionStore.userTimezone;
	      var blackoutDate = this.state.blackoutDate;
	
	
	      var dateString = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      var timezoneString = (0, _moment2.default)(date).tz(userTimezone).format('Z');
	      var dateAndTime = _moment2.default.utc(dateString + ' ' + time + ' ' + timezoneString, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
	
	      blackoutDate[name] = dateAndTime;
	
	      this.setState((_setState = {}, _defineProperty(_setState, name, date), _defineProperty(_setState, 'blackoutDate', blackoutDate), _setState));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          BlackoutStore = _props$store.BlackoutStore,
	          SessionStore = _props$store.SessionStore;
	
	      var callback = null;
	
	      if ((0, _helpers.getURLSegment)(this, 2) === 'edit') {
	        callback = function callback() {
	          SessionStore.showToaster(translation.updated, 'success');
	          (0, _helpers.closeDrawer)(null, _this3, (0, _helpers.getURLSegment)(_this3, 1));
	        };
	
	        BlackoutStore.updateBlackoutDate((0, _helpers.getURLSegment)(this, 3), this.state.blackoutDate, callback);
	      } else {
	        callback = function callback() {
	          SessionStore.showToaster(translation.created, 'success');
	          (0, _helpers.closeDrawer)(null, _this3, (0, _helpers.getURLSegment)(_this3, 1));
	        };
	
	        BlackoutStore.createBlackoutDate(this.state.blackoutDate, callback);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          BlackoutStore = _props$store2.BlackoutStore,
	          SessionStore = _props$store2.SessionStore;
	      var blackoutDate = BlackoutStore.blackoutDate;
	      var userTimezone = SessionStore.userTimezone;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              (0, _helpers.getURLSegment)(this, 2) === 'edit' && _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              ),
	              (0, _helpers.getURLSegment)(this, 2) === 'add' && _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading_add
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'form',
	              {
	                className: 'panel panel--medium',
	                onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this4.handleSubmit);
	                },
	                noValidate: true
	              },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields fields--center' },
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'blackout-start-date' },
	                      translation.starts.label
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      id: 'blackout-start-date',
	                      selected: this.state.startDate ? (0, _moment2.default)(this.state.startDate).tz(userTimezone) : null,
	                      maxDate: this.state.endDate,
	                      onChange: function onChange(date) {
	                        return _this4.handleDateChange(date, 'startDate');
	                      },
	                      placeholderText: translation.starts.helper,
	                      required: true, 'aria-required': 'true',
	                      ref: function ref(input) {
	                        return _this4.startDate = input;
	                      },
	                      defaultValue: blackoutDate ? blackoutDate.startDate : null,
	                      autoComplete: 'off'
	                    }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      translation.starts.at
	                    ),
	                    _react2.default.createElement(_TimeSelect2.default, Object.assign({
	                      id: 'blackout-start-time',
	                      defaultValue: this.state.startDate,
	                      reference: function reference(input) {
	                        return _this4.startTime = input;
	                      },
	                      onChange: function onChange(e) {
	                        return _this4.handleTimeChange('startDate', e);
	                      },
	                      date: this.state.startDate,
	                      name: 'startDate',
	                      stateName: 'startTime'
	                    }, this.props, {
	                      parent: this
	                    })),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      this.state.endDate && _moment2.default.utc(this.state.startDate).tz(userTimezone).format('z'),
	                      !this.state.endDate && (0, _moment2.default)().tz(userTimezone).format('z')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'blackout-end-date' },
	                      translation.ends.label
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      id: 'blackout-end-date',
	                      selected: this.state.endDate ? (0, _moment2.default)(this.state.endDate).tz(userTimezone) : null,
	                      minDate: this.state.startDate,
	                      onChange: function onChange(date) {
	                        return _this4.handleDateChange(date, 'endDate');
	                      },
	                      placeholderText: translation.ends.helper,
	                      required: true, 'aria-required': 'true',
	                      ref: function ref(input) {
	                        return _this4.endDate = input;
	                      },
	                      defaultValue: blackoutDate ? blackoutDate.endDate : null,
	                      autoComplete: 'off'
	                    }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      translation.ends.at
	                    ),
	                    _react2.default.createElement(_TimeSelect2.default, Object.assign({
	                      id: 'blackout-end-time',
	                      defaultValue: this.state.endDate,
	                      reference: function reference(input) {
	                        return _this4.endTime = input;
	                      },
	                      onChange: function onChange(e) {
	                        return _this4.handleTimeChange('endDate', e);
	                      },
	                      date: this.state.endDate,
	                      name: 'endDate',
	                      stateName: 'endTime'
	                    }, this.props, {
	                      parent: this
	                    })),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      this.state.endDate && _moment2.default.utc(this.state.startDate).tz(userTimezone).format('z'),
	                      !this.state.endDate && (0, _moment2.default)().tz(userTimezone).format('z')
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__actions actions' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary'
	                  },
	                  translation.button
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return EditBlackoutDate;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EditBlackoutDate')(EditBlackoutDate);

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var CloseWindow = function (_React$Component) {
	  _inherits(CloseWindow, _React$Component);
	
	  function CloseWindow() {
	    _classCallCheck(this, CloseWindow);
	
	    return _possibleConstructorReturn(this, (CloseWindow.__proto__ || Object.getPrototypeOf(CloseWindow)).apply(this, arguments));
	  }
	
	  _createClass(CloseWindow, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'i',
	            { className: 'icn--blue' },
	            _react2.default.createElement(icons.iconBadgeCheck, null)
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            'All Set!'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Your appointment has been scheduled. Close this tab to return to SmarterProctoring'
	          )
	        )
	      );
	    }
	  }]);
	
	  return CloseWindow;
	}(_react2.default.Component);
	
	exports.default = CloseWindow;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Icons
	
	
	var Calculator = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Calculator, _React$Component);
	
	  function Calculator() {
	    _classCallCheck(this, Calculator);
	
	    // Set the initial state
	    var _this = _possibleConstructorReturn(this, (Calculator.__proto__ || Object.getPrototypeOf(Calculator)).call(this));
	
	    _this.renderCalculator = function () {
	      var classCalcApiKey = _config.config.classCalcApiKey;
	      var _window = window,
	          ClassCalc = _window.ClassCalc;
	      var SessionStore = _this.props.store.SessionStore;
	      var userSid = SessionStore.userData.userSid;
	
	      var calcArray = ['scientific-calc', 'graphing-calc', 'matrix-calc', 'four-function-calc'];
	      var allowedCalcTypeIndex = calcArray.indexOf(SessionStore.calculator);
	
	      if (allowedCalcTypeIndex > -1) {
	        calcArray.splice(allowedCalcTypeIndex, 1);
	      }
	
	      if (ClassCalc) {
	        if (!_this.state.initialized) {
	          ClassCalc.init('calculator', { apiKey: classCalcApiKey, userId: userSid });
	        }
	
	        _this.setState({
	          initialized: true
	        });
	
	        _this.setCalculatorType(calcArray);
	      }
	    };
	
	    _this.setCalculatorType = function (calculatorType) {
	      var _window2 = window,
	          ClassCalc = _window2.ClassCalc;
	
	
	      setTimeout(function () {
	        try {
	          ClassCalc.controller.disableButtons(calculatorType);
	          _this.setState({ render: true });
	        } catch (e) {
	          if (_this.i < _this.retryLimit) {
	            _this.setCalculatorType(calculatorType);
	            _this.i++;
	          } else {
	            console.error('ClassCalc failed to initialize.');
	          }
	        }
	      }, 100);
	    };
	
	    _this.state = {
	      calcType: null,
	      initialized: false,
	      render: false
	    };
	
	    // Limit ClassCalc retries
	    _this.retryLimit = 20;
	    _this.i = 0;
	    return _this;
	  }
	
	  _createClass(Calculator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	      var classCalcScript = document.querySelector('#classCalc-js');
	
	      this.setState({
	        calcType: SessionStore.calculator
	      });
	
	      if (!classCalcScript) {
	        var ccjs = document.createElement('script');
	        ccjs.id = 'classCalc-js';
	        ccjs.src = 'https://app.classcalc.com/api';
	        ccjs.onload = this.renderCalculator;
	
	        document.body.append(ccjs);
	      } else {
	        this.renderCalculator();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (SessionStore.calculator !== this.state.calcType && SessionStore.calculator !== 'none') {
	        this.setState({
	          calcType: SessionStore.calculator,
	          render: false
	        }, function () {
	          _this2.renderCalculator();
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	      var render = this.state.render;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'modal' + (SessionStore.calculator === 'none' ? ' hidden' : '')
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal__window' },
	          _react2.default.createElement(
	            'header',
	            { className: 'modal__head' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'modal__close',
	                onClick: function onClick() {
	                  return SessionStore.calculator = 'none';
	                }
	              },
	              _react2.default.createElement(icons.iconTimes, null),
	              _react2.default.createElement(
	                'span',
	                { className: 'meta' },
	                'Close'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'calc' },
	            _react2.default.createElement('div', {
	              className: 'calc__body ' + (!render ? ' calc__body--hidden' : ''),
	              id: 'calculator'
	            }),
	            !render && _react2.default.createElement('span', { className: 'calc__loader loader-bar' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Calculator;
	}(_react2.default.Component));
	
	exports.default = Calculator;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Counter = __webpack_require__(346);
	
	var _Counter2 = _interopRequireDefault(_Counter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExpireWarning = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExpireWarning, _React$Component);
	
	  function ExpireWarning() {
	    _classCallCheck(this, ExpireWarning);
	
	    var _this = _possibleConstructorReturn(this, (ExpireWarning.__proto__ || Object.getPrototypeOf(ExpireWarning)).call(this));
	
	    _this.confirmKey = _this.confirmKey.bind(_this);
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExpireWarning, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('keydown', this.confirmKey, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.confirmKey, false);
	    }
	  }, {
	    key: 'confirmKey',
	    value: function confirmKey(e) {
	      e.preventDefault();
	
	      if (e.keyCode && (e.keyCode === 13 || e.keyCode === 32)) {
	        this.closeDialog(e);
	      }
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'extendSession',
	    value: function extendSession(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.extendSession(this.closeDialog);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	      var endDate = (0, _moment2.default)().add(2, 'minutes');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog dialog--confirm dialog--expire' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dialog__content' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'dialog__msg', tabIndex: '0' },
	            translation.heading,
	            _react2.default.createElement(_Counter2.default, Object.assign({ endDate: endDate }, this.props))
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.body
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dialog__btns' },
	            _react2.default.createElement(
	              'a',
	              { href: '#app', className: 'btn', onClick: function onClick(e) {
	                  return _this2.extendSession(e);
	                } },
	              translation.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExpireWarning;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExpireWarning')(ExpireWarning);

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var Footer = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'docsLink',
	
	    // changeLocale(locale) {
	    //   if(locale) {
	    //     this.props.store.SessionStore.updateLocale(locale);
	    //   }
	    // }
	
	    value: function docsLink() {
	      var userData = this.props.store.SessionStore.userData;
	
	
	      var href = null;
	
	      if (userData && userData.role) {
	        switch (userData.role.toLowerCase()) {
	          case 'learner':
	            href = 'http://docs.smarterproctoring.com/support/solutions/27000014320';
	            break;
	
	          case 'instructor':
	            href = 'http://docs.smarterproctoring.com/support/solutions/27000033928';
	            break;
	
	          case 'administrator':
	            href = 'http://docs.smarterproctoring.com/support/solutions/27000033927';
	            break;
	
	          default:
	            href = 'https://docs.smarterproctoring.com';
	        }
	      }
	
	      return href;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Hund system status (check on a 100ms interval if anchor is there)
	      // const statusElDelay = setInterval(function(){
	      //   if(document.querySelector('#status') && window.Status && !document.querySelector('.status-widget__led')) {
	      //     new window.Status.Widget({
	      //       hostname: 'status.smarterproctoring.com',
	      //       selector: '#status',
	      //       css: false,
	      //       display: {
	      //         hideOnError: true,
	      //         ledOnly: true,
	      //         panePosition: 'top-left'
	      //       }
	      //     });
	      //
	      //     clearInterval(statusElDelay);
	      //   }
	      // }, 100);
	
	      return _react2.default.createElement(
	        'footer',
	        { className: 'site-foot' },
	        _react2.default.createElement(
	          'div',
	          { className: 'site-foot__copy wrap' },
	          _react2.default.createElement(
	            'span',
	            null,
	            '\xA9 ',
	            new Date().getFullYear(),
	            ' SmarterServices, LLC'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Footer')(Footer);

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(15);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactSimpleDropdown = __webpack_require__(178);
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Help = __webpack_require__(791);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _SmarterDropdown = __webpack_require__(753);
	
	var _SmarterDropdown2 = _interopRequireDefault(_SmarterDropdown);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Header = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this));
	
	    _this.handleLinkClick = _this.handleLinkClick.bind(_this);
	    _this.toggleNav = _this.toggleNav.bind(_this);
	    _this.toggleHighContrast = _this.toggleHighContrast.bind(_this);
	    _this.toggleDyslexic = _this.toggleDyslexic.bind(_this);
	    _this.hideDropdown = _this.hideDropdown.bind(_this);
	    _this.setHighContrast = _this.setHighContrast.bind(_this);
	    _this.newRefresh = _this.newRefresh.bind(_this);
	    _this.navbarKeydown = _this.navbarKeydown.bind(_this);
	    _this.setStudentDropdown = _this.setStudentDropdown.bind(_this);
	    _this.setHelpDropdown = _this.setHelpDropdown.bind(_this);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var doc = document.querySelector('html');
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.state = {
	        navOpen: false,
	        defaultSize: parseInt(window.getComputedStyle(doc).getPropertyValue('font-size'), 10),
	        highContrast: false,
	        studentDropdownOpen: false,
	        helpDropdownOpen: false
	      };
	
	      SessionStore.getUnreadCount();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	      var int = 3600000; // 30 minutes
	      var accessDropdown = document.getElementById('nav-access');
	
	      if (window.localStorage.getItem('high-contrast', true)) {
	        this.toggleHighContrast();
	        this.setState({ highContrast: true });
	      }
	
	      // Check for new messages on an interval
	      setInterval(function () {
	        SessionStore.getUnreadCount(true, true, translation.new_message, '/messages');
	      }, int);
	
	      // Escape key functionality for event listener on accessibility dropdown
	      accessDropdown.addEventListener('keydown', function (e) {
	        if (e.key === 'Escape') {
	          document.getElementById('accessibility-dropdown').click();
	          document.getElementById('accessibility-dropdown').focus();
	        }
	      });
	    }
	  }, {
	    key: 'handleLinkClick',
	    value: function handleLinkClick() {
	      var dropdowns = [];
	      dropdowns.push(this.refs.reportsDropdown);
	      dropdowns.push(this.refs.pagesDropdown);
	      dropdowns.push(this.refs.usersDropdown);
	      dropdowns.push(this.refs.accountDropdown);
	      for (var i = 0; i < dropdowns.length; i++) {
	        if (typeof dropdowns[i] !== 'undefined') {
	          dropdowns[i].hide();
	        }
	      }
	      this.setState({
	        navOpen: false
	      });
	    }
	  }, {
	    key: 'toggleNav',
	    value: function toggleNav(e) {
	      e.preventDefault();
	      this.setState({
	        navOpen: !this.state.navOpen
	      });
	    }
	  }, {
	    key: 'skipToNav',
	    value: function skipToNav(e) {
	      e.preventDefault();
	
	      var nav = document.querySelector('#nav');
	
	      if (nav) {
	        nav.focus();
	      }
	    }
	  }, {
	    key: 'skipToContent',
	    value: function skipToContent(e) {
	      e.preventDefault();
	
	      var content = document.querySelector('#main-content');
	
	      if (content) {
	        content.focus();
	      }
	    }
	  }, {
	    key: 'toggleHighContrast',
	    value: function toggleHighContrast() {
	      this.props.store.SessionStore.highContrast = !this.props.store.SessionStore.highContrast;
	
	      var defaultStyles = document.querySelector('link[href*="screen.css"]');
	      var highContrastStyles = document.querySelector('link[href*="hi-c.css"]');
	
	      if (document.querySelector('html').className.indexOf('firefox') > -1) {
	        if (this.props.store.SessionStore.highContrast) {
	          defaultStyles.disabled = true;
	          highContrastStyles.disabled = false;
	        } else {
	          defaultStyles.disabled = false;
	          highContrastStyles.disabled = true;
	        }
	      } else {
	        if (this.props.store.SessionStore.highContrast) {
	          defaultStyles.setAttribute('rel', 'alternate stylesheet');
	          highContrastStyles.setAttribute('rel', 'stylesheet');
	        } else {
	          defaultStyles.setAttribute('rel', 'stylesheet');
	          highContrastStyles.setAttribute('rel', 'alternate stylesheet');
	        }
	      }
	    }
	  }, {
	    key: 'setHighContrast',
	    value: function setHighContrast() {
	      if (this.state.highContrast) {
	        this.setState({ highContrast: false });
	        localStorage.removeItem('high-contrast');
	      } else if (!this.state.highContrast) {
	        this.setState({ highContrast: !this.state.highContrast });
	        localStorage.setItem('high-contrast', !this.state.highContrast);
	      }
	      this.toggleHighContrast();
	    }
	  }, {
	    key: 'newRefresh',
	    value: function newRefresh() {
	      /*  Old refresh from props was removing high contrast mode
	       so I created this work around*/
	      var refresh = this.props.refresh;
	
	      refresh();
	      if (this.state.highContrast) {
	        this.toggleHighContrast();
	      }
	    }
	  }, {
	    key: 'toggleDyslexic',
	    value: function toggleDyslexic() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      SessionStore.dyslexic = this.dyslexic.checked;
	
	      var dyslexicStyles = document.querySelector('link[href*="open-dyslexic.css"]');
	
	      if (document.querySelector('html').className.indexOf('firefox') > -1) {
	        if (SessionStore.dyslexic) {
	          dyslexicStyles.disabled = false;
	        } else {
	          dyslexicStyles.disabled = true;
	        }
	      } else {
	        if (SessionStore.dyslexic) {
	          dyslexicStyles.setAttribute('rel', 'stylesheet');
	        } else {
	          dyslexicStyles.setAttribute('rel', 'alternate stylesheet');
	        }
	      }
	    }
	  }, {
	    key: 'adjustSize',
	    value: function adjustSize(type) {
	      var doc = document.querySelector('html');
	      var size = parseInt(window.getComputedStyle(doc).getPropertyValue('font-size'), 10);
	
	      if (type === 'increase') {
	        size += 2;
	      } else if (type === 'decrease') {
	        size -= 2;
	      } else {
	        size = this.state.defaultSize;
	      }
	
	      doc.setAttribute('style', 'font-size: ' + size + 'px');
	    }
	  }, {
	    key: 'showDropdown',
	    value: function showDropdown() {
	      var dropdowns = document.querySelectorAll('div.dropdown--active .dropdown__menu');
	      var triggers = document.querySelectorAll('div.dropdown--active .dropdown__trigger');
	
	      for (var i = 0; i < dropdowns.length; i++) {
	        dropdowns[i].setAttribute('aria-hidden', 'false');
	      }
	
	      for (var _i = 0; _i < triggers.length; _i++) {
	        triggers[_i].setAttribute('aria-expanded', 'true');
	      }
	    }
	  }, {
	    key: 'hideDropdown',
	    value: function hideDropdown() {
	      var dropdowns = document.querySelectorAll('div.dropdown:not(.dropdown--active) .dropdown__menu');
	      var triggers = document.querySelectorAll('div.dropdown:not(.dropdown--active) .dropdown__trigger');
	
	      for (var i = 0; i < dropdowns.length; i++) {
	        dropdowns[i].setAttribute('aria-hidden', 'true');
	      }
	
	      for (var _i2 = 0; _i2 < triggers.length; _i2++) {
	        triggers[_i2].setAttribute('aria-expanded', 'false');
	      }
	    }
	  }, {
	    key: 'setStudentDropdown',
	    value: function setStudentDropdown(boolean) {
	      this.setState({
	        studentDropdownOpen: boolean
	      });
	    }
	  }, {
	    key: 'setHelpDropdown',
	    value: function setHelpDropdown(boolean) {
	      this.setState({
	        helpDropdownOpen: boolean
	      });
	    }
	  }, {
	    key: 'navbarKeydown',
	    value: function navbarKeydown(e) {
	      e.preventDefault();
	
	      var closeButton = document.querySelector('a.nav-btn');
	      var examBtn = document.querySelector('a.navbar__item');
	      var messagesBtn = document.getElementById('messages');
	      var studentBtn = document.getElementById('nav-account-trigger');
	      var helpBtn = document.getElementById('help');
	      var navBar = [closeButton, examBtn, messagesBtn, studentBtn, helpBtn];
	
	      var index = Array.prototype.indexOf.call(navBar, e.target);
	
	      var SPACE = ' ';
	
	      switch (e.key) {
	        case 'Enter':
	          e.preventDefault();
	          e.target.click();
	          break;
	
	        case SPACE:
	          e.preventDefault();
	
	          if (e.target === studentBtn) {
	            this.state.studentDropdownOpen ? this.setStudentDropdown(false) : this.setStudentDropdown(true);
	            studentBtn.click();
	            break;
	          }
	          if (e.target === helpBtn) {
	            var _articles = document.getElementById('help__list').querySelectorAll('a');
	
	            e.preventDefault();
	            this.state.helpDropdownOpen ? this.setHelpDropdown(false) : this.setHelpDropdown(true);
	            e.target.click();
	            _articles[0].focus();
	            break;
	          }
	          e.target.click();
	          break;
	
	        case 'Tab':
	          e.preventDefault();
	          // Regular Tab
	          if (!e.shiftKey) {
	            if (this.state.helpDropdownOpen && e.target === helpBtn) {
	              e.preventDefault();
	              helpBtn.click();
	              this.setHelpDropdown(false);
	              helpBtn.focus();
	              break;
	            }
	
	            if (e.target === navBar[navBar.length - 1]) {
	              navBar[0].focus();
	              break;
	            } else {
	              navBar[index + 1].focus();
	              break;
	            }
	            //Shift Tabbing
	          } else if (e.shiftKey) {
	            if (e.target === navBar[0]) {
	              navBar[navBar.length - 1].focus();
	              break;
	            } else {
	              navBar[index - 1].focus();
	              break;
	            }
	          }
	          break;
	        case 'ArrowDown':
	          var articles = document.getElementById('help__list').querySelectorAll('a');
	
	          if (e.target === helpBtn) {
	            articles[0].focus();
	          }
	          break;
	        case 'Escape':
	          e.preventDefault();
	          if (!this.state.studentDropdownOpen && !this.state.helpDropdownOpen) {
	            // Clicks button to close and then sets focus to closed menu btn
	            closeButton.click();
	            closeButton.focus();
	          }
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var profile = SessionStore.profile,
	          userData = SessionStore.userData,
	          courseData = SessionStore.courseData;
	
	
	      var isIns = false;
	      var isAdd = false;
	      var isStudent = false;
	
	      if (SessionStore.hasSessionStorage) {
	        isIns = JSON.parse(sessionStorage.getItem('userData')).role.toLowerCase() === 'instructor';
	        isAdd = JSON.parse(sessionStorage.getItem('userData')).role.toLowerCase() === 'administrator';
	        isStudent = JSON.parse(sessionStorage.getItem('userData')).role.toLowerCase() === 'learner';
	      } else {
	        isIns = JSON.parse((0, _helpers.getCookie)('userData')).role.toLowerCase() === 'instructor';
	        isAdd = JSON.parse((0, _helpers.getCookie)('userData')).role.toLowerCase() === 'administrator';
	        isStudent = JSON.parse((0, _helpers.getCookie)('userData')).role.toLowerCase() === 'learner';
	      }
	
	      var openClass = null;
	      var menuText = 'Menu';
	
	      if (this.state.navOpen) {
	        openClass = 'open';
	        menuText = 'Close';
	        document.querySelector('body').className += ' nav-open';
	      } else {
	        menuText = 'Menu';
	        document.querySelector('body').classList.remove('nav-open');
	      }
	
	      return _react2.default.createElement(
	        'header',
	        { className: 'site-head wrap' },
	        _react2.default.createElement(
	          'a',
	          { className: 'meta', href: '#', onClick: function onClick(e) {
	              _this2.skipToNav(e);
	            } },
	          translation.skip_to_nav
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'meta', href: '#', onClick: function onClick(e) {
	              _this2.skipToContent(e);
	            } },
	          translation.skip_to_main
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: 'meta' },
	          'SmarterProctoring'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: '#nav', className: 'nav-btn ' + openClass, onClick: this.toggleNav, onKeyDown: this.navbarKeydown },
	          menuText
	        ),
	        _react2.default.createElement(
	          'nav',
	          { id: 'nav-app-tools', role: 'navigation', 'aria-label': 'App tools' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'app-tools' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'access-toggle btn--outline',
	                  onClick: this.newRefresh
	                },
	                _react2.default.createElement(icons.iconRefresh, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.refresh
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactSimpleDropdown2.default,
	                {
	                  ref: 'accessibilityDropdown',
	                  onShow: this.showDropdown,
	                  onHide: this.hideDropdown
	                },
	                _react2.default.createElement(
	                  _reactSimpleDropdown.DropdownTrigger,
	                  {
	                    className: 'access-toggle btn btn--outline',
	                    tabIndex: '0',
	                    'aria-controls': '#nav-access',
	                    'aria-haspopup': 'true',
	                    'aria-expanded': 'false',
	                    title: translation.accessibility.heading,
	                    id: 'accessibility-dropdown'
	                  },
	                  _react2.default.createElement(icons.iconAccess, null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.accessibility.heading
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactSimpleDropdown.DropdownContent,
	                  null,
	                  _react2.default.createElement(
	                    'ul',
	                    { id: 'nav-access', className: 'dropdown__menu', role: 'menu', 'aria-hidden': 'true' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'dropdown__item ' + (SessionStore.highContrast ? 'enabled' : ''),
	                          onKeyDown: this.handleAccessKeyDown,
	                          id: 'high-constrast',
	                          onClick: this.setHighContrast
	                        },
	                        _react2.default.createElement(icons.iconContrast, null),
	                        translation.accessibility.high_contrast
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'dropdown__item font-increase',
	                          onClick: function onClick() {
	                            return _this2.adjustSize('increase');
	                          },
	                          id: 'increase-size'
	                        },
	                        _react2.default.createElement(icons.iconFont, null),
	                        translation.accessibility.increase_size
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'dropdown__item font-decrease',
	                          onClick: function onClick() {
	                            return _this2.adjustSize('decrease');
	                          },
	                          id: 'decrease-size'
	                        },
	                        _react2.default.createElement(icons.iconFont, null),
	                        translation.accessibility.decrease_size
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'dropdown__item',
	                          onClick: function onClick() {
	                            return _this2.adjustSize('reset');
	                          },
	                          id: 'reset-size'
	                        },
	                        _react2.default.createElement(icons.iconFont, null),
	                        translation.accessibility.reset_size
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'dropdown__item' },
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        id: 'dyslexic-font',
	                        className: 'switch-input',
	                        defaultChecked: SessionStore.dyslexic,
	                        onChange: this.toggleDyslexic,
	                        ref: function ref(input) {
	                          return _this2.dyslexic = input;
	                        },
	                        onKeyDown: _helpers.handleSwitchInputKeys
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'switch-label',
	                          htmlFor: 'dyslexic-font'
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'meta' },
	                          translation.accessibility.dyslexic_font
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'dyslexic-font' },
	                        translation.accessibility.dyslexic_font
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        this.props.router.location.pathname !== '/enroll' && _react2.default.createElement(
	          'nav',
	          { id: 'nav', className: 'navbar ' + openClass, role: 'navigation', 'aria-labelledby': 'nav-heading', onKeyDown: this.navbarKeydown },
	          _react2.default.createElement(
	            'h2',
	            { id: 'nav-heading', className: 'meta' },
	            translation.navigation.heading
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'navbar__menu' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'navbar__item', tabIndex: '0', to: '/', onClick: this.handleLinkClick },
	                isStudent && _react2.default.createElement(icons.icon_text, null),
	                isStudent && translation.navigation.dashboard_student,
	                !isStudent && _react2.default.createElement(icons.iconDashboard, null),
	                !isStudent && translation.navigation.dashboard
	              )
	            ),
	            _react2.default.createElement(
	              SessionStore.validater,
	              null,
	              _react2.default.createElement(
	                'li',
	                {
	                  iamAction: 'sp:DescribeReports',
	                  iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':report'
	                },
	                _react2.default.createElement(
	                  _SmarterDropdown2.default,
	                  {
	                    ref: 'reportsDropdown',
	                    id: 'nav-reports',
	                    triggerText: _react2.default.createElement(
	                      'span',
	                      null,
	                      _react2.default.createElement(icons.iconGraph, null),
	                      translation.navigation.reports.anchor
	                    )
	                  },
	                  _react2.default.createElement(
	                    'li',
	                    { role: 'menuitem' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'dropdown__item', tabIndex: '0', to: '/reports', onClick: this.handleLinkClick },
	                      translation.navigation.reports.all_reports
	                    )
	                  ),
	                  !isIns && _react2.default.createElement(
	                    'li',
	                    { role: 'menuitem' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'dropdown__item', tabIndex: '0', to: '/reports/downloads', onClick: this.handleLinkClick },
	                      translation.navigation.reports.downloads
	                    )
	                  )
	                )
	              )
	            ),
	            !SessionStore.hideMsg && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'navbar__item notification-anchor', id: 'messages', tabIndex: '0', to: '/messages', onClick: this.handleLinkClick },
	                _react2.default.createElement(icons.iconEnvelope, null),
	                translation.navigation.messages,
	                SessionStore.unreadCount > 0 && _react2.default.createElement(
	                  'span',
	                  { className: 'notification__count badge' },
	                  SessionStore.unreadCount
	                )
	              )
	            ),
	            !isIns && _react2.default.createElement(
	              SessionStore.validater,
	              null,
	              _react2.default.createElement(
	                'li',
	                { iamAction: 'sp:DescribePagesUi', iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':report' },
	                _react2.default.createElement(
	                  _reactSimpleDropdown2.default,
	                  { ref: 'pagesDropdown', onShow: this.showDropdown, onHide: this.hideDropdown },
	                  _react2.default.createElement(
	                    _reactSimpleDropdown.DropdownTrigger,
	                    {
	                      className: 'navbar__item',
	                      role: 'button',
	                      tabIndex: '0',
	                      'aria-controls': 'nav-pages',
	                      'aria-haspopup': 'true',
	                      'aria-expanded': 'false'
	                    },
	                    _react2.default.createElement(icons.iconPage, null),
	                    !isAdd && translation.navigation.pages.anchor,
	                    isAdd && translation.navigation.admin_pages
	                  ),
	                  _react2.default.createElement(
	                    _reactSimpleDropdown.DropdownContent,
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      { id: 'nav-pages', className: 'dropdown__menu', 'aria-hidden': 'true' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/exam-approvals', onClick: this.handleLinkClick },
	                          translation.navigation.pages.exam_approvals
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/course-offerings', onClick: this.handleLinkClick },
	                          translation.navigation.pages.course_offerings
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { iamAction: 'sp:DescribeVouchers', iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':voucher' },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/vouchers', onClick: this.handleLinkClick },
	                          translation.navigation.pages.vouchers
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { iamAction: 'sp:DescribeFundingRule', iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':funding' },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/funding-rules', onClick: this.handleLinkClick },
	                          translation.navigation.pages.funding_rules
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { iamAction: 'sp:CreateProctorAccount', iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':proctors' },
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/self-managed-proctors', onClick: this.handleLinkClick },
	                          translation.navigation.pages.self_managed_accounts
	                        )
	                      ),
	                      isAdd && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/blackout-dates', onClick: this.handleLinkClick },
	                          translation.navigation.pages.blackout_dates
	                        )
	                      ),
	                      isAdd && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { iamAction: 'sp:DescribeAdmins', iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':users', className: 'dropdown__item', to: '/admins', onClick: this.handleLinkClick },
	                          translation.navigation.users.admins
	                        )
	                      ),
	                      isAdd && SessionStore.userData.courseSid && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/roster', onClick: this.handleLinkClick },
	                          translation.navigation.users.roster
	                        )
	                      ),
	                      isAdd && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/users', onClick: this.handleLinkClick },
	                          translation.navigation.users.anchor
	                        )
	                      ),
	                      isAdd && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/proctor-search', onClick: this.handleLinkClick },
	                          translation.navigation.pages.proctor_search
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            !isAdd && !isIns && _react2.default.createElement(
	              SessionStore.validater,
	              null,
	              _react2.default.createElement(
	                'li',
	                { iamAction: 'sp:DescribeUsersUi', iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':users', className: 'dropdown' },
	                _react2.default.createElement(
	                  _reactSimpleDropdown2.default,
	                  { ref: 'usersDropdown', onShow: this.showDropdown, onHide: this.hideDropdown },
	                  _react2.default.createElement(
	                    _reactSimpleDropdown.DropdownTrigger,
	                    {
	                      className: 'navbar__item',
	                      tabIndex: '0',
	                      role: 'button',
	                      'aria-controls': 'nav-users',
	                      'aria-haspopup': 'true',
	                      'aria-expanded': 'false'
	                    },
	                    _react2.default.createElement(icons.iconList, null),
	                    translation.navigation.users.anchor
	                  ),
	                  _react2.default.createElement(
	                    _reactSimpleDropdown.DropdownContent,
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      { id: 'nav-users', className: 'dropdown__menu', 'aria-hidden': 'true' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { className: 'dropdown__item', to: '/roster', onClick: this.handleLinkClick },
	                          translation.navigation.users.roster
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          _reactRouter.Link,
	                          { iamAction: 'sp:DescribeAdmins', iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':users', className: 'dropdown__item', to: '/admins', onClick: this.handleLinkClick },
	                          translation.navigation.users.admins
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            isIns && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'navbar__item', to: '/roster', onClick: this.handleLinkClick },
	                _react2.default.createElement(icons.iconList, null),
	                translation.navigation.users.roster
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'dropdown' },
	              _react2.default.createElement(
	                _SmarterDropdown2.default,
	                { ref: 'accountDropdown', id: 'nav-account', tabIndex: '0', onKeyDown: this.navbarKeydown, studentDropdownState: this.setStudentDropdown, triggerText: typeof profile.firstName !== 'undefined' && _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                      'abbr',
	                      { className: 'avatar--initials ' + profile.firstName.charAt(0).toLowerCase(), title: profile.firstName, 'aria-hidden': 'true' },
	                      profile.firstName.charAt(0)
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'capitalize' },
	                      profile.firstName
	                    )
	                  ) },
	                _react2.default.createElement(
	                  SessionStore.validater,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    {
	                      iamAction: 'sp:DescribeUsers',
	                      iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':user',
	                      role: 'menuitem'
	                    },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'dropdown__item', id: 'student-dropdown', to: '/settings', tabIndex: '0', onClick: this.handleLinkClick },
	                      translation.navigation.account.settings
	                    )
	                  )
	                ),
	                !isIns && !isStudent && _react2.default.createElement(
	                  SessionStore.validater,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    {
	                      iamAction: 'sp:DescribeInstallSettings',
	                      iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':install',
	                      role: 'menuitem'
	                    },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'dropdown__item', to: '/settings/institution/general', onClick: this.handleLinkClick },
	                      translation.navigation.account.institution_settings
	                    )
	                  )
	                ),
	                !isIns && !isStudent && _react2.default.createElement(
	                  SessionStore.validater,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    { role: 'menuitem' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'dropdown__item', to: '/integrations', onClick: this.handleLinkClick },
	                      translation.navigation.account.integration_settings
	                    )
	                  )
	                ),
	                !isIns && !isStudent && _react2.default.createElement(
	                  SessionStore.validater,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    {
	                      iamAction: 'sp:DescribeProctorGroups',
	                      iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':proctorGroup',
	                      role: 'menuitem'
	                    },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'dropdown__item', to: '/settings/proctor-groups', onClick: this.handleLinkClick },
	                      translation.navigation.account.proctor_groups
	                    )
	                  )
	                ),
	                isStudent && _react2.default.createElement(
	                  SessionStore.validater,
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    {
	                      iamAction: 'sp:DescribeUserLedger',
	                      iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':user/' + SessionStore.userData.userSid,
	                      role: 'menuitem'
	                    },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'dropdown__item', to: 'transactions', onClick: this.handleLinkClick },
	                      translation.navigation.account.transactions
	                    )
	                  )
	                ),
	                !isIns && !isStudent && _react2.default.createElement(
	                  'li',
	                  { role: 'menuitem' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { className: 'dropdown__item', to: 'ledger', onClick: this.handleLinkClick },
	                    translation.navigation.account.ledger
	                  )
	                ),
	                isAdd && _react2.default.createElement(
	                  'li',
	                  { className: 'dropdown__separated', role: 'menuitem' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { className: 'dropdown__item', to: '/sign-out', onClick: this.handleLinkClick },
	                    translation.navigation.account.sign_out
	                  )
	                ),
	                isIns && _react2.default.createElement(
	                  'li',
	                  { role: 'menuitem' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { className: 'dropdown__item', to: '/instructor-appointments', onClick: this.handleLinkClick },
	                    translation.navigation.account.appointments
	                  )
	                ),
	                isIns && _react2.default.createElement(
	                  'li',
	                  { role: 'menuitem' },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      className: 'dropdown__item', to: '/proctor-search',
	                      href: 'https://smarterservices.typeform.com/to/iJvtxI?name=' + profile.firstName + ' ' + profile.lastName + '&email=' + profile.email + '&institution=' + userData.smarterProctoring.appInstallName + '&course=' + courseData.code,
	                      target: '_blank',
	                      onClick: this.handleLinkClick
	                    },
	                    translation.navigation.pages.proctor_request
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'navbar__separator' },
	              _react2.default.createElement(_Help2.default, Object.assign({
	                btnClass: 'navbar__item',
	                setHelpDropdown: this.setHelpDropdown
	              }, this.props))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Header')(Header);

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _logo = __webpack_require__(686);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var HeaderOutside = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(HeaderOutside, _React$Component);
	
	  function HeaderOutside() {
	    _classCallCheck(this, HeaderOutside);
	
	    var _this = _possibleConstructorReturn(this, (HeaderOutside.__proto__ || Object.getPrototypeOf(HeaderOutside)).call(this));
	
	    _this.addSession = _this.addSession.bind(_this);
	    return _this;
	  }
	
	  _createClass(HeaderOutside, [{
	    key: 'addSession',
	    value: function addSession() {
	      this.props.store.ManagerStore.addSession = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var ManagerStore = this.props.store.ManagerStore;
	
	
	      return _react2.default.createElement(
	        'header',
	        { className: 'site-head site-head--outside' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap--center' },
	          _react2.default.createElement('img', { className: 'brand', src: _logo2.default, alt: 'SmarterProctoring' }),
	          ManagerStore.sessions.length > 0 && ManagerStore.multi && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--inverse',
	              onClick: this.addSession
	            },
	            _react2.default.createElement(icons.iconPlus, null),
	            'Add a session'
	          )
	        )
	      );
	    }
	  }]);
	
	  return HeaderOutside;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('HeaderOutside')(HeaderOutside);

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTextareaAutosize = __webpack_require__(74);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Dependencies
	
	
	var LimitTextarea = function (_React$Component) {
	  _inherits(LimitTextarea, _React$Component);
	
	  function LimitTextarea() {
	    _classCallCheck(this, LimitTextarea);
	
	    var _this2 = _possibleConstructorReturn(this, (LimitTextarea.__proto__ || Object.getPrototypeOf(LimitTextarea)).call(this));
	
	    _this2.calculate = _this2.calculate.bind(_this2);
	    _this2.highlightClass = _this2.highlightClass.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(LimitTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        remaining: null
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.calculate();
	    }
	  }, {
	    key: 'calculate',
	    value: function calculate() {
	      var _this = this;
	
	      this.setState({
	        remaining: this.props.limit - this.textarea.value.length
	      }, function () {
	        var textarea = document.querySelector('#' + _this.textarea.props.id);
	
	        if (_this.state.remaining < 0) {
	          textarea.setCustomValidity('invalid');
	        } else {
	          textarea.setCustomValidity('');
	        }
	      });
	    }
	  }, {
	    key: 'highlightClass',
	    value: function highlightClass() {
	      var className = '';
	
	      if (this.state.remaining <= 20 && this.state.remaining > 10) {
	        className = 'notify';
	      } else if (this.state.remaining <= 10 && this.state.remaining >= 0) {
	        className = 'warn';
	      } else if (this.state.remaining < 0) {
	        className = 'error';
	      }
	
	      return className;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.wrapperClass || '' },
	        _react2.default.createElement(_reactTextareaAutosize2.default, {
	          id: this.props.id,
	          className: 'limit ' + this.props.className,
	          placeholder: this.props.placeholder,
	          defaultValue: this.props.defaultValue,
	          onChange: this.props.onChange,
	          onInput: this.calculate,
	          ref: function ref(input) {
	            _this3.textarea = input;
	          },
	          required: this.textarea && this.textarea.value.length > 0,
	          'aria-required': this.textarea && this.textarea.value.length > 0,
	          disabled: this.props.disabled ? true : false
	        }),
	        this.textarea && this.textarea.value && _react2.default.createElement(
	          'span',
	          {
	            className: 'limit__left ' + this.highlightClass()
	          },
	          this.state.remaining
	        )
	      );
	    }
	  }]);
	
	  return LimitTextarea;
	}(_react2.default.Component);
	
	exports.default = LimitTextarea;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var Modal = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    _classCallCheck(this, Modal);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this));
	
	    _this.closeModal = _this.closeModal.bind(_this);
	    _this.clickModal = _this.clickModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Focus to close button when mounted
	      var closeBtn = document.getElementById('modal__close');
	      closeBtn.focus();
	
	      document.addEventListener('keydown', this.clickModal);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      //Remove Event Listener on unmount
	      document.removeEventListener('keydown', this.clickModal);
	    }
	
	    // Had to declare function to click so it could properly remove event listener
	
	  }, {
	    key: 'clickModal',
	    value: function clickModal(e) {
	      var closeBtn = document.getElementById('modal__close');
	
	      if (e.key === 'Escape') {
	        closeBtn.click();
	      }
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      SessionStore.modalContent = null;
	      SessionStore.modalLoaded = false;
	      SessionStore.modalSmall = false;
	      SessionStore.modalShort = false;
	      SessionStore.modalMediumShort = false;
	      SessionStore.modalHeader = null;
	      SessionStore.hideTimes = false;
	
	      // Focus last element (if there was) when closing modal
	      if (SessionStore.lastFocused) {
	        SessionStore.lastFocused.focus();
	        SessionStore.lastFocused = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'modal ' + (!SessionStore.modalLoaded ? 'hidden' : '') },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal__window ' + (SessionStore.modalSmall ? 'modal__window--alt' : '') + ' ' + (SessionStore.modalShort ? 'modal__window--short' : '') + '  ' + (SessionStore.modalMediumShort ? 'modal__window--medium-short' : '') },
	          _react2.default.createElement(
	            'header',
	            { className: 'modal__head' },
	            SessionStore.modalHeader && _react2.default.createElement(
	              'h2',
	              null,
	              SessionStore.modalHeader
	            ),
	            !SessionStore.hideTimes && _react2.default.createElement(
	              'button',
	              {
	                className: 'modal__close',
	                onClick: this.closeModal,
	                id: 'modal__close'
	              },
	              _react2.default.createElement(icons.iconTimes, null),
	              _react2.default.createElement(
	                'span',
	                { className: 'meta' },
	                'Close'
	              )
	            )
	          ),
	          SessionStore.modalContent
	        )
	      );
	    }
	  }]);
	
	  return Modal;
	}(_react2.default.Component));
	
	exports.default = Modal;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Notice = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Notice, _React$Component);
	
	  function Notice() {
	    _classCallCheck(this, Notice);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (Notice.__proto__ || Object.getPrototypeOf(Notice)).call(this));
	
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    _this.updateTimeZone = _this.updateTimeZone.bind(_this);
	    return _this;
	  }
	
	  _createClass(Notice, [{
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'updateTimeZone',
	    value: function updateTimeZone() {
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	
	
	      SettingsStore.userSettings.timeZoneSid = SessionStore.filteredMachineTimezone[0].sid;
	
	      SettingsStore.updateUserSettings(SessionStore.getProfile);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'toaster toaster--warning toaster--sm notice' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'p',
	              null,
	              SessionStore.noticeContent.body.replace('%course%', SessionStore.courseData.title),
	              '\xA0',
	              SessionStore.noticeContent.linkText && SessionStore.noticeContent.linkUrl && SessionStore.noticeContent.linkUrl !== '#update-timezone' && _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: SessionStore.noticeContent.linkUrl
	                },
	                SessionStore.noticeContent.linkText
	              ),
	              SessionStore.noticeContent.linkText && SessionStore.noticeContent.linkUrl && SessionStore.noticeContent.linkUrl === '#update-timezone' && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--link',
	                  onClick: this.updateTimeZone
	                },
	                SessionStore.noticeContent.linkText
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Notice;
	}(_react2.default.Component));
	
	exports.default = Notice;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Renders a dropdown menu
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {array} options - Array of objects used to populate the dropdown options
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} triggerText - The text for the dropdown trigger
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// Helpers
	
	
	var SmarterDropdown = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SmarterDropdown, _React$Component);
	
	  function SmarterDropdown() {
	    _classCallCheck(this, SmarterDropdown);
	
	    // Set the initial state
	    var _this = _possibleConstructorReturn(this, (SmarterDropdown.__proto__ || Object.getPrototypeOf(SmarterDropdown)).call(this));
	
	    _this.toggleDropdown = function () {
	      if (_this.state.active) {
	        _this.hide();
	      } else {
	        _this.show();
	      }
	    };
	
	    _this.setFocusToPreviousItem = function (e) {
	      if (e.target === _this.firstItem) {
	        _this.lastItem.focus();
	      } else {
	        var index = Array.prototype.indexOf.call(_this.items, e.target);
	        _this.items[index - 1].focus();
	      }
	    };
	
	    _this.setFocusToNextItem = function (e) {
	      if (e.target === _this.lastItem) {
	        _this.firstItem.focus();
	      } else {
	        var index = Array.prototype.indexOf.call(_this.items, e.target);
	        _this.items[index + 1].focus();
	      }
	    };
	
	    _this.handleButtonKeyDown = function (e) {
	      var DOWN_ARROW = 40;
	      var UP_ARROW = 38;
	
	      switch (e.keyCode) {
	        case DOWN_ARROW:
	          e.preventDefault();
	          if (!_this.state.active) {
	            _this.show();
	          } else {
	            _this.firstItem.focus();
	          }
	          break;
	        case UP_ARROW:
	          e.preventDefault();
	          if (!_this.state.active) {
	            _this.showLast();
	          } else {
	            _this.lastItem.focus();
	          }
	          break;
	        default:
	      }
	    };
	
	    _this.handleContentKeyDown = function (e) {
	      var DOWN_ARROW = 40;
	      var UP_ARROW = 38;
	
	      switch (e.keyCode) {
	        case DOWN_ARROW:
	          e.preventDefault();
	          _this.setFocusToNextItem(e);
	          break;
	        case UP_ARROW:
	          e.preventDefault();
	          _this.setFocusToPreviousItem(e);
	          break;
	        default:
	      }
	    };
	
	    _this.handleCommonKeyDown = function (e) {
	      var ESCAPE = 27;
	      var END = 35;
	      var HOME = 36;
	      var TAB = 9;
	
	      switch (e.keyCode) {
	        case ESCAPE:
	          _this.escape();
	          break;
	        case HOME:
	          if (_this.state.active) {
	            e.preventDefault();
	            _this.firstItem.focus();
	          }
	          break;
	        case END:
	          if (_this.state.active) {
	            e.preventDefault();
	            _this.lastItem.focus();
	          }
	          break;
	        case TAB:
	          e.preventDefault();
	          if (_this.state.active) {
	            _this.hide();
	          }
	          _this.trigger.focus();
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.state = {
	      active: false
	    };
	
	    _this.items = [];
	    _this.firstItem = null;
	    _this.lastItem = null;
	    return _this;
	  }
	
	  _createClass(SmarterDropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Hide when anything else is clicked
	      document.addEventListener('click', function (e) {
	        if (_this2.state.active && !(0, _helpers.isDescendant)(_this2.dropdown, e.target)) {
	          _this2.setState({
	            active: false
	          });
	        }
	      });
	      this.items = this.content.querySelectorAll('a.dropdown__item');
	      this.firstItem = this.items[0];
	      this.lastItem = this.items[this.items.length - 1];
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      var _this3 = this;
	
	      var studentDropdownState = this.props.studentDropdownState;
	
	
	      if (studentDropdownState) {
	        studentDropdownState();
	      }
	
	      this.setState({
	        active: false
	      }, function () {
	        _this3.trigger.focus();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this4 = this;
	
	      this.setState({
	        active: true
	      }, function () {
	        _this4.firstItem.focus();
	      });
	    }
	  }, {
	    key: 'showLast',
	    value: function showLast() {
	      var _this5 = this;
	
	      this.setState({
	        active: true
	      }, function () {
	        _this5.lastItem.focus();
	      });
	    }
	  }, {
	    key: 'escape',
	    value: function escape() {
	      if (this.state.active) {
	        this.hide();
	        this.trigger.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props = this.props,
	          id = _props.id,
	          triggerText = _props.triggerText;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          id: id + '-dropdown',
	          className: 'dropdown ' + (this.state.active ? "dropdown--active" : "dropdown--closed"),
	          ref: function ref(div) {
	            return _this6.dropdown = div;
	          },
	          onKeyDown: this.handleCommonKeyDown
	        },
	        _react2.default.createElement(
	          'button',
	          {
	            id: id + '-trigger',
	            className: 'navbar__item dropdown__trigger',
	            tabIndex: '0',
	            type: 'button',
	            'aria-controls': id + '-content',
	            'aria-haspopup': 'true',
	            'aria-expanded': this.state.active ? true : false,
	            onClick: this.toggleDropdown,
	            onKeyDown: this.handleButtonKeyDown,
	            ref: function ref(button) {
	              return _this6.trigger = button;
	            }
	          },
	          triggerText
	        ),
	        _react2.default.createElement(
	          'ul',
	          {
	            id: id + '-content',
	            role: 'menu',
	            className: 'dropdown__menu',
	            hidden: this.state.active ? false : true,
	            'aria-hidden': this.state.active ? false : true,
	            ref: function ref(ul) {
	              return _this6.content = ul;
	            },
	            onKeyDown: this.handleContentKeyDown
	          },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return SmarterDropdown;
	}(_react2.default.Component));
	
	exports.default = (0, _mobxReact.observer)(SmarterDropdown);

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	var SmarterFauxSelect = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SmarterFauxSelect, _React$Component);
	
	  function SmarterFauxSelect() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SmarterFauxSelect);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmarterFauxSelect.__proto__ || Object.getPrototypeOf(SmarterFauxSelect)).call.apply(_ref, [this].concat(args))), _this), _this.toggle = function (e) {
	      if (_this.state.active) {
	        _this.hide();
	      } else {
	        _this.showFirst(e);
	      }
	    }, _this.showFirst = function (e) {
	      _this.setState({
	        active: true
	      }, function () {
	        _this.focusOption(0);
	      });
	    }, _this.showLast = function (e) {
	      _this.setState({
	        active: true
	      }, function () {
	        _this.focusOption(_this.props.options.length - 1);
	      });
	    }, _this.hide = function () {
	      _this.setState({
	        highlighted: -1,
	        active: false
	      });
	    }, _this.focusOption = function (index) {
	      if (index >= 0) {
	        _this.setState({
	          highlighted: index
	        }, function () {
	          _this.refs['option-' + _this.state.highlighted].focus();
	        });
	      }
	    }, _this.checkKey = function (e) {
	      var first = 0;
	      var last = _this.props.options.length - 1;
	
	      var ESCAPE = 27;
	      var END = 35;
	      var HOME = 36;
	      var TAB = 9;
	      var DOWN_ARROW = 40;
	      var UP_ARROW = 38;
	
	      switch (e.keyCode) {
	        case ESCAPE:
	          _this.hide();
	          _this.refs.trigger.focus();
	          break;
	        case HOME:
	          if (_this.state.active) {
	            e.preventDefault();
	            _this.focusOption(first);
	          }
	          break;
	        case END:
	          if (_this.state.active) {
	            e.preventDefault();
	            _this.focusOption(last);
	          }
	          break;
	        case TAB:
	          if (_this.state.active) {
	            _this.hide();
	          }
	          break;
	        case UP_ARROW:
	          e.preventDefault();
	          if (!_this.state.active) {
	            _this.showLast();
	          } else {
	            if (_this.state.highlighted > 0) {
	              _this.focusOption(_this.state.highlighted - 1);
	            } else {
	              _this.focusOption(last);
	            }
	          }
	          break;
	        case DOWN_ARROW:
	          e.preventDefault();
	          if (!_this.state.active) {
	            _this.showFirst();
	          } else {
	            if (_this.state.highlighted < last) {
	              _this.focusOption(_this.state.highlighted + 1);
	            } else {
	              _this.focusOption(first);
	            }
	          }
	          break;
	        default:
	          break;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SmarterFauxSelect, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        default: this.props.default || 'Select…',
	        highlighted: -1,
	        active: false
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Hide when anything else is clicked
	      document.addEventListener('click', function (e) {
	        if (_this2.state.active && !(0, _helpers.isDescendant)(_this2.refs.fauxSelect, e.target)) {
	          _this2.setState({
	            active: false,
	            highlighted: -1
	          });
	        }
	      });
	    }
	  }, {
	    key: 'clickOption',
	    value: function clickOption(e, index) {
	      var _props = this.props,
	          onClick = _props.onClick,
	          parent = _props.parent,
	          skipText = _props.skipText;
	
	      // Unless otherwise specified, update the text of the dropdown selection
	
	      if (!skipText) {
	        this.setState({
	          default: e.target.getAttribute('data-label')
	        });
	      }
	      if (parent) {
	        parent.setState({
	          action: e.target.getAttribute('data-action')
	        });
	      }
	      if (onClick) {
	        onClick(e, this.props, index);
	      }
	      this.hide();
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip(key) {
	      if (key.helper) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'tooltip tooltip--right', onClick: function onClick(e) {
	              e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            'span',
	            { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	            '(?)'
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: key.action + '-tooltip', className: 'tooltip__body', role: 'tooltip' },
	            key.helper
	          )
	        );
	      }
	
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          options = _props2.options,
	          selectIndex = _props2.selectIndex;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'faux-select ' + (this.state.active ? "dropdown--active" : "dropdown--closed"),
	          ref: 'fauxSelect',
	          onKeyDown: this.checkKey
	        },
	        _react2.default.createElement(
	          'button',
	          {
	            id: 'faux-select__trigger-' + selectIndex,
	            ref: 'trigger',
	            className: 'faux-select__selected',
	            'aria-haspopup': 'true',
	            'aria-controls': 'faux-select__content-' + selectIndex,
	            'aria-expanded': this.state.active ? "true" : "false",
	            onClick: this.toggle
	          },
	          this.state.default
	        ),
	        this.props.store ? _react2.default.createElement(
	          this.props.store.validater,
	          null,
	          _react2.default.createElement(
	            'ul',
	            {
	              id: 'faux-select__content-' + selectIndex,
	              role: 'menu',
	              className: 'faux-select__options dropdown__menu ' + (this.props.noTooltip ? '' : 'has-tooltip'),
	              'aria-labelledby': 'faux-select__trigger-' + selectIndex,
	              hidden: this.state.active ? false : true,
	              'aria-hidden': this.state.active ? false : true
	            },
	            options.map(function (key, i) {
	              if (key.iamAction && key.iamResource) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    iamAction: key.iamAction,
	                    iamResource: key.iamResource,
	                    key: i,
	                    className: '' + (key.helper ? 'has-tooltip' : ''),
	                    role: 'menuitem',
	                    tabIndex: '-1'
	                  },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'faux-select__btn ' + (_this3.state.highlighted === i ? 'highlighted' : ''),
	                      onClick: function onClick(e, i) {
	                        _this3.clickOption(e, i);
	                      },
	                      'data-label': key.title,
	                      'data-action': key.action,
	                      'aria-labelledby': key.action + '-tooltip',
	                      ref: 'option-' + i
	                    },
	                    key.title,
	                    key.subTitle && _react2.default.createElement(
	                      'span',
	                      { className: 'faux-select__subtitle', 'data-label': key.title },
	                      key.subTitle
	                    )
	                  ),
	                  _this3.renderTooltip(key)
	                );
	              } else {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    key: i,
	                    role: 'menuitem',
	                    tabIndex: '-1',
	                    className: '' + (key.helper ? 'has-tooltip' : '')
	                  },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'faux-select__btn ' + (_this3.state.highlighted === i ? 'highlighted' : ''),
	                      onClick: function onClick(e) {
	                        _this3.clickOption(e, i);
	                      },
	                      'data-label': key.title,
	                      'data-action': key.action,
	                      'aria-labelledby': key.action + '-tooltip',
	                      ref: 'option-' + i
	                    },
	                    key.title,
	                    key.subTitle && _react2.default.createElement(
	                      'span',
	                      { className: 'faux-select__subtitle', 'data-label': key.title },
	                      key.subTitle
	                    )
	                  ),
	                  _this3.renderTooltip(key)
	                );
	              }
	            })
	          )
	        ) : _react2.default.createElement(
	          'ul',
	          {
	            id: 'faux-select__content-' + selectIndex,
	            role: 'menu',
	            className: 'faux-select__options dropdown__menu ' + (this.props.noTooltip ? '' : 'has-tooltip'),
	            'aria-labelledby': 'faux-select__trigger-' + selectIndex,
	            hidden: this.state.active ? false : true,
	            'aria-hidden': this.state.active ? false : true
	          },
	          options.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i, className: '' + (key.helper ? 'has-tooltip' : ''), role: 'menuitem', tabIndex: '-1' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'faux-select__btn ' + (_this3.state.highlighted === i ? 'highlighted' : ''),
	                  onClick: function onClick(e) {
	                    _this3.clickOption(e, i);
	                  },
	                  'data-label': key.title,
	                  'data-action': key.action,
	                  'aria-labelledby': key.action + '-tooltip',
	                  ref: 'option-' + i
	                },
	                key.title,
	                key.subTitle && _react2.default.createElement(
	                  'span',
	                  { className: 'faux-select__subtitle', 'data-label': key.title },
	                  key.subTitle
	                )
	              ),
	              _this3.renderTooltip(key)
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return SmarterFauxSelect;
	}(_react2.default.Component));
	
	exports.default = SmarterFauxSelect;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactSimpleDropdown = __webpack_require__(178);
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var SplitButton = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SplitButton, _React$Component);
	
	  function SplitButton() {
	    _classCallCheck(this, SplitButton);
	
	    var _this = _possibleConstructorReturn(this, (SplitButton.__proto__ || Object.getPrototypeOf(SplitButton)).call(this));
	
	    _this.toggleOptions = _this.toggleOptions.bind(_this);
	    return _this;
	  }
	
	  _createClass(SplitButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        showing: false
	      };
	    }
	  }, {
	    key: 'toggleOptions',
	    value: function toggleOptions(e) {
	      this.setState({
	        showing: !this.state.showing
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          options = _props.options,
	          text = _props.text,
	          to = _props.to,
	          translation = _props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'split-btn ' + this.props.className + ' ' + (!this.props.options ? 'split-btn--empty' : '')
	        },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            className: 'split-btn__link cover',
	            to: to
	          },
	          text
	        ),
	        _react2.default.createElement(
	          'span',
	          {
	            className: 'split-btn__text',
	            'aria-hidden': 'true'
	          },
	          icon,
	          text
	        ),
	        this.props.options && _react2.default.createElement(
	          _reactSimpleDropdown2.default,
	          {
	            ref: 'splitButton',
	            onShow: this.toggleOptions,
	            onHide: this.toggleOptions
	          },
	          _react2.default.createElement(
	            _reactSimpleDropdown.DropdownTrigger,
	            {
	              className: 'split-btn__trigger'
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.dropdown
	            )
	          ),
	          _react2.default.createElement(
	            _reactSimpleDropdown.DropdownContent,
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'dropdown__menu' },
	              options.map(function (key, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { className: 'dropdown__item split-btn__option', to: key.to },
	                    key.title
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SplitButton;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SplitButton')(SplitButton);

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(15);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _InstructorExamCard = __webpack_require__(757);
	
	var _InstructorExamCard2 = _interopRequireDefault(_InstructorExamCard);
	
	var _SplitButton = __webpack_require__(755);
	
	var _SplitButton2 = _interopRequireDefault(_SplitButton);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var CourseDashboard = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CourseDashboard, _React$Component);
	
	  function CourseDashboard() {
	    _classCallCheck(this, CourseDashboard);
	
	    var _this2 = _possibleConstructorReturn(this, (CourseDashboard.__proto__ || Object.getPrototypeOf(CourseDashboard)).call(this));
	
	    _this2.unlockExam = function (examSid, configurationSid) {
	      var data = {
	        approved: true,
	        locked: false
	      };
	
	      var callback = function callback() {
	        return _this2.getExams();
	      };
	
	      _this2.props.store.ExamStore.updateConfigurationStatus(examSid, configurationSid, data, callback);
	    };
	
	    _this2.lockExam = function (examSid, configurationSid) {
	      var data = {
	        approved: true,
	        locked: true
	      };
	
	      var callback = function callback() {
	        return _this2.getExams();
	      };
	
	      _this2.props.store.ExamStore.updateConfigurationStatus(examSid, configurationSid, data, callback);
	    };
	
	    _this2.openApprovalsDrawer = _this2.openApprovalsDrawer.bind(_this2);
	    _this2.openEventsDrawer = _this2.openEventsDrawer.bind(_this2);
	    _this2.renderCreateExam = _this2.renderCreateExam.bind(_this2);
	    _this2.renderImportExam = _this2.renderImportExam.bind(_this2);
	    _this2.renderNewExam = _this2.renderNewExam.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(CourseDashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        fundingRuleSid: null,
	        examSid: null
	
	        // Get instructor as proctor sessions
	      };this.getInstructorAppointments(this.props.courseSid);
	
	      // Get course exams
	      this.getExams(this.props.courseSid);
	
	      // Make sure we have a list of proctor types
	      SessionStore.getProctorTypes();
	    }
	  }, {
	    key: 'getInstructorAppointments',
	    value: function getInstructorAppointments(courseSid) {
	      this.props.store.CourseStore.getInstructorAppointments(courseSid);
	    }
	  }, {
	    key: 'getExams',
	    value: function getExams(courseSid) {
	      this.props.store.CourseStore.getOrderedExams(courseSid);
	    }
	  }, {
	    key: 'openApprovalsDrawer',
	    value: function openApprovalsDrawer(e, examSid) {
	      e.preventDefault();
	
	      this.setState({
	        examSid: examSid
	      });
	
	      var _this = this;
	
	      setTimeout(function () {
	        (0, _helpers.toggleDrawer)(null, _this, 'ApproveProctor');
	      });
	    }
	  }, {
	    key: 'openEventsDrawer',
	    value: function openEventsDrawer(e, examSid) {
	      (0, _helpers.toggleDrawer)(e, this, 'IncidentReport');
	      var pathname = this.props.routing.location.pathname;
	
	      pathname += '?eventsFor=' + examSid;
	      this.props.routing.push(pathname);
	    }
	  }, {
	    key: 'getInstructorAsProctor',
	    value: function getInstructorAsProctor(instructorAsProctor, instructorProctorSid) {
	      var selectedIAP = null;
	
	      instructorAsProctor.forEach(function (setting) {
	        if (setting.sid === instructorProctorSid) {
	          selectedIAP = setting;
	        }
	      });
	
	      return selectedIAP;
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          CourseStore = _props$store.CourseStore,
	          SessionStore = _props$store.SessionStore;
	      var orderedExams = CourseStore.orderedExams;
	      var active = orderedExams.active,
	          upcoming = orderedExams.upcoming,
	          closed = orderedExams.closed;
	
	      var examStatuses = ['active', 'upcoming', 'closed'];
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          CourseStore.instructorAppointments && CourseStore.instructorAppointments.length > 0 && _react2.default.createElement(
	            'aside',
	            { className: 'card' },
	            _react2.default.createElement(icons.iconCalendar, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'card__content' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'card__heading' },
	                CourseStore.instructorAppointments.length === 1 && translation.appointments_singular,
	                CourseStore.instructorAppointments.length > 1 && translation.appointments_plural.replace('%count%', CourseStore.instructorAppointments.length)
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'card__btn', to: '/instructor-appointments' },
	                translation.view_appointments
	              )
	            )
	          ),
	          examStatuses.map(function (status) {
	            if (orderedExams[status] && orderedExams[status].length > 0) {
	              return _react2.default.createElement(
	                'section',
	                {
	                  className: 'page__section exam-section',
	                  key: status
	                },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'exam-section__heading' },
	                  translation.exam_sections[status]
	                ),
	                _react2.default.createElement(
	                  'ol',
	                  { className: 'exam-section__list' },
	                  orderedExams[status].map(function (exam) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: exam.sid },
	                      _react2.default.createElement(_InstructorExamCard2.default, Object.assign({}, _this3.props, {
	                        exam: exam,
	                        onLockExam: _this3.lockExam,
	                        onOpenApprovals: _this3.openApprovalsDrawer,
	                        onOpenEvents: _this3.openEventsDrawer,
	                        onUnlockExam: _this3.unlockExam
	                      }))
	                    );
	                  })
	                )
	              );
	            }
	
	            return null;
	          }),
	          (!orderedExams || active.length === 0 && upcoming.length === 0 && closed.length === 0) && _react2.default.createElement(
	            'span',
	            { className: 'no-results' },
	            translation.no_results
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderCreateExam',
	    value: function renderCreateExam() {
	      return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	        flagKey: 'import-exam',
	        renderFeatureCallback: this.renderImportExam,
	        renderDefaultCallback: this.renderNewExam
	      });
	    }
	  }, {
	    key: 'renderImportExam',
	    value: function renderImportExam() {
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          SessionStore = _props$store2.SessionStore,
	          SettingsStore = _props$store2.SettingsStore;
	
	
	      var examOptions = null;
	      var defaultAction = 'exams/type';
	
	      if (SettingsStore.settings.enableWrittenExams) {
	        examOptions = [{
	          title: translation.online_exam,
	          to: 'exams/type'
	        }, {
	          title: translation.written_exam,
	          to: 'exams/add?type=written'
	        }];
	
	        if (SettingsStore.settings.defaultNewExamType.toLowerCase() === 'written') {
	          defaultAction = 'exams/add?type=written';
	        }
	      }
	
	      return _react2.default.createElement(_SplitButton2.default, Object.assign({
	        iamAction: 'sp:CreateExam',
	        iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':course/' + SessionStore.userData.courseSid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam'],
	        className: 'btn--outline',
	        to: defaultAction,
	        icon: _react2.default.createElement(icons.iconPlus, null),
	        text: translation.new_exam_button
	      }, this.props, {
	        options: examOptions
	      }));
	    }
	  }, {
	    key: 'renderNewExam',
	    value: function renderNewExam() {
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          SessionStore = _props$store3.SessionStore,
	          SettingsStore = _props$store3.SettingsStore;
	
	
	      var examOptions = null;
	      var defaultAction = 'exams/add';
	
	      if (SettingsStore.settings.enableWrittenExams) {
	        examOptions = [{
	          title: translation.online_exam,
	          to: 'exams/add'
	        }, {
	          title: translation.written_exam,
	          to: 'exams/add?type=written'
	        }];
	
	        if (SettingsStore.settings.defaultNewExamType.toLowerCase() === 'written') {
	          defaultAction = 'exams/add?type=written';
	        }
	      }
	
	      return _react2.default.createElement(_SplitButton2.default, Object.assign({
	        iamAction: 'sp:CreateExam',
	        iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':course/' + SessionStore.userData.courseSid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam'],
	        className: 'btn--outline',
	        to: defaultAction,
	        icon: _react2.default.createElement(icons.iconPlus, null),
	        text: translation.new_exam_button
	      }, this.props, {
	        options: examOptions
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'main',
	        {
	          className: 'page',
	          id: 'main-content',
	          tabIndex: '0'
	        },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              SessionStore.validater,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'page__actions actions' },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    iamAction: 'sp:DescribeFundingRule', iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':funding',
	                    className: 'btn--outline',
	                    to: '?fundingRuleScope=courseSid&scopeSid=' + SessionStore.courseData.sid,
	                    onClick: function onClick() {
	                      (0, _helpers.toggleDrawer)(null, _this4, 'FundingRules');
	                    }
	                  },
	                  translation.funding_rules
	                ),
	                _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                  flagKey: 'create-exam',
	                  renderFeatureCallback: this.renderCreateExam
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          fundingRuleSid: this.state.fundingRuleSid,
	          examSid: this.state.examSid,
	          preserveDrawer: true
	        }, this.props))
	      );
	    }
	  }]);
	
	  return CourseDashboard;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CourseDashboard')(CourseDashboard);

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(15);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _ExamDetails = __webpack_require__(79);
	
	var _ExamDetails2 = _interopRequireDefault(_ExamDetails);
	
	var _ExamDetailedInfo = __webpack_require__(357);
	
	var _ExamDetailedInfo2 = _interopRequireDefault(_ExamDetailedInfo);
	
	var _StudentStatus = __webpack_require__(364);
	
	var _StudentStatus2 = _interopRequireDefault(_StudentStatus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Dependencies
	
	
	// Components
	
	
	var InstructorExamCard = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(InstructorExamCard, _React$Component);
	
	  function InstructorExamCard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InstructorExamCard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InstructorExamCard.__proto__ || Object.getPrototypeOf(InstructorExamCard)).call.apply(_ref, [this].concat(args))), _this), _this.renderProctorApprovals = function (exam) {
	      var _this$props = _this.props,
	          onOpenApprovals = _this$props.onOpenApprovals,
	          translation = _this$props.translation;
	
	
	      return _react2.default.createElement(
	        'a',
	        {
	          className: 'notification',
	          href: '#ApproveProctor',
	          onClick: function onClick(e) {
	            return onOpenApprovals(e, exam.sid);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'tooltip tooltip--right' },
	          _react2.default.createElement(icons.iconUsers, null),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'tooltip__body tooltip__body--brief',
	              id: 'approve-' + exam.sid + '-tooltip',
	              role: 'tooltip'
	            },
	            translation.pending_approval
	          )
	        ),
	        _react2.default.createElement(
	          'em',
	          { className: 'notification__count' },
	          exam.pendingApprovals
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(InstructorExamCard, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          exam = _props.exam,
	          onLockExam = _props.onLockExam,
	          onOpenEvents = _props.onOpenEvents,
	          onUnlockExam = _props.onUnlockExam,
	          store = _props.store,
	          translation = _props.translation;
	      var SessionStore = store.SessionStore,
	          SettingsStore = store.SettingsStore;
	      var userData = SessionStore.userData;
	      var settings = SettingsStore.settings;
	
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'panel' },
	        _react2.default.createElement(
	          'header',
	          { className: 'panel__header' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'i',
	              { className: 'panel__icn' },
	              exam.type.toLowerCase() === 'online' ? _react2.default.createElement(icons.iconLaptop, null) : _react2.default.createElement(icons.iconPencilPaper, null)
	            ),
	            exam.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__tools' },
	            exam.pendingApprovals > 0 && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'instructor-proctor-approval',
	              renderFeatureCallback: function renderFeatureCallback() {
	                return _this2.renderProctorApprovals(exam);
	              }
	            }),
	            exam.openSessionEvents > 0 && _react2.default.createElement(
	              'a',
	              {
	                className: 'notification notification--warn',
	                href: '#IncidentReport',
	                onClick: function onClick(e) {
	                  return onOpenEvents(e, exam.sid);
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip tooltip--right' },
	                _react2.default.createElement(icons.iconExclamation, null),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'tooltip__body tooltip__body--brief',
	                    id: 'incident-' + exam.sid + '-tooltip',
	                    role: 'tooltip'
	                  },
	                  translation.open_incidents
	                )
	              ),
	              _react2.default.createElement(
	                'em',
	                { className: 'notification__count' },
	                exam.openSessionEvents
	              )
	            ),
	            exam.configuration.locked && _react2.default.createElement(
	              'span',
	              {
	                className: 'notification'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip tooltip--right' },
	                _react2.default.createElement(icons.iconLock, null),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'tooltip__body',
	                    id: 'locked-' + exam.sid + '-tooltip',
	                    role: 'tooltip'
	                  },
	                  translation.exam_locked
	                )
	              )
	            ),
	            exam.configuration.apiExamId && _react2.default.createElement(
	              'span',
	              {
	                className: 'notification'
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip tooltip--right' },
	                _react2.default.createElement(icons.iconCloudDownload, null),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'tooltip__body',
	                    id: 'imported-' + exam.sid + '-tooltip',
	                    role: 'tooltip'
	                  },
	                  translation.exam_imported
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          !exam.configuration.approved && _react2.default.createElement(
	            'div',
	            { className: 'cta cta--negative' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.pending_cta.heading
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'cta__subcopy' },
	              translation.pending_cta.body
	            )
	          ),
	          _react2.default.createElement(_StudentStatus2.default, Object.assign({}, this.props, {
	            i: exam.sid,
	            summary: exam.statusSummary,
	            limitedScope: exam.isLimitedScope
	          })),
	          _react2.default.createElement(_ExamDetails2.default, Object.assign({}, this.props, {
	            exam: exam,
	            scheduleWindow: true
	          })),
	          _react2.default.createElement(_ExamDetailedInfo2.default, Object.assign({}, this.props, {
	            exam: exam
	          })),
	          _react2.default.createElement(
	            'footer',
	            { className: 'panel__actions actions' },
	            _react2.default.createElement(
	              SessionStore.validater,
	              null,
	              exam.configuration.locked && userData.role.toLowerCase() === 'administrator' && _react2.default.createElement(
	                'button',
	                {
	                  className: 'actions__btn actions__btn--secondary',
	                  onClick: function onClick() {
	                    return onUnlockExam(exam.sid, exam.configuration.sid);
	                  }
	                },
	                _react2.default.createElement(icons.iconUnlock, null),
	                translation.unlock
	              ),
	              !exam.configuration.locked && userData.role.toLowerCase() === 'administrator' && settings.requireManagerExamApproval && _react2.default.createElement(
	                'button',
	                {
	                  className: 'actions__btn actions__btn--secondary',
	                  onClick: function onClick() {
	                    return onLockExam(exam.sid, exam.configuration.sid);
	                  }
	                },
	                _react2.default.createElement(icons.iconLock, null),
	                translation.lock
	              ),
	              !exam.configuration.locked && _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  iamAction: 'sp:ModifyExam',
	                  iamResource: ['ssrn:ss:sp:us-east:' + userData.installSid + ':course/' + userData.courseSid, 'ssrn:ss:sp:us-east:' + userData.installSid + ':exam/' + exam.sid],
	                  to: 'exams/edit/' + exam.sid,
	                  className: 'actions__btn actions__btn--secondary'
	                },
	                _react2.default.createElement(icons.iconEdit, null),
	                translation.edit
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  iamAction: 'sp:DescribeExam',
	                  iamResource: ['ssrn:ss:sp:us-east:' + userData.installSid + ':course/' + userData.courseSid, 'ssrn:ss:sp:us-east:' + userData.installSid + ':exam/' + exam.sid],
	                  to: 'exams/' + exam.sid, className: 'actions__btn actions__btn--primary'
	                },
	                _react2.default.createElement(icons.iconEye, null),
	                translation.view
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return InstructorExamCard;
	}(_react2.default.Component));
	
	exports.default = InstructorExamCard;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDelayed = __webpack_require__(112);
	
	var _reactDelayed2 = _interopRequireDefault(_reactDelayed);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Toolbar = __webpack_require__(98);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var CourseOfferings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CourseOfferings, _React$Component);
	
	  function CourseOfferings() {
	    _classCallCheck(this, CourseOfferings);
	
	    var _this2 = _possibleConstructorReturn(this, (CourseOfferings.__proto__ || Object.getPrototypeOf(CourseOfferings)).call(this));
	
	    _this2.getCourseOfferings = _this2.getCourseOfferings.bind(_this2);
	    _this2.addCourseOffering = _this2.addCourseOffering.bind(_this2);
	    _this2.deleteOfferings = _this2.deleteOfferings.bind(_this2);
	    _this2.handleSelect = _this2.handleSelect.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(CourseOfferings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        offeringSid: null,
	        fundingRuleSid: null,
	        selectedRows: []
	      };
	
	      this.getCourseOfferings();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.routing.location.pathname;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (pathname.indexOf('edit') > -1 || pathname.indexOf('add') > -1) {
	        SessionStore.loading = false;
	        (0, _helpers.toggleDrawer)(null, this, 'EditCourseOffering');
	      }
	
	      if (pathname.indexOf('edit') > -1) {
	        var userSid = pathname.substr(pathname.lastIndexOf('/') + 1);
	
	        this.setState({
	          userSid: userSid
	        });
	      }
	    }
	  }, {
	    key: 'getCourseOfferings',
	    value: function getCourseOfferings(reload) {
	      if (this.props.store.CourseStore.courseOfferings.length === 0 || reload) {
	        this.props.store.CourseStore.getCourseOfferings();
	      }
	    }
	  }, {
	    key: 'addCourseOffering',
	    value: function addCourseOffering() {
	      this.props.store.CourseStore.offering = {};
	
	      this.setState({
	        drawerOpen: true,
	        drawerContent: 'EditCourseOffering'
	      });
	    }
	  }, {
	    key: 'handleEdit',
	    value: function handleEdit(e, offeringSid) {
	      e.preventDefault();
	
	      // Update url
	      var path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');
	
	      if (this.props.routing.location.pathname !== path) {
	        this.props.routing.push(path);
	      }
	
	      this.setState({
	        offeringSid: offeringSid
	      });
	
	      (0, _helpers.toggleDrawer)(null, this, 'EditCourseOffering');
	    }
	  }, {
	    key: 'deleteOfferings',
	    value: function deleteOfferings(offering) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.delete_confirm.heading_singular,
	        body: translation.delete_confirm.body_singular,
	        button: translation.delete_confirm.button
	      };
	
	      if (this.state.selectedRows.length > 1) {
	        msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
	        msg.body = translation.delete_confirm.body_plural;
	      }
	
	      var callback = function callback() {
	        return _this3.getCourseOfferings(true);
	      };
	
	      // Loop through all the selected funding rules and send delete API request
	      var _this = this;
	
	      (0, _helpers.confirm)(msg, function () {
	        for (var i = 0; i < _this.state.selectedRows.length; i++) {
	          _this.props.store.CourseStore.deleteCourseOffering(_this.state.selectedRows[i], callback);
	        }
	
	        _this.setState({
	          selectedRows: []
	        });
	      });
	    }
	  }, {
	    key: 'manageFundingRule',
	    value: function manageFundingRule(e, offeringSid) {
	      this.setState({
	        offeringSid: offeringSid
	      });
	
	      (0, _helpers.toggleDrawer)(e, this, 'FundingRules');
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(e, sid) {
	      var selectedRows = [].concat(_toConsumableArray(this.state.selectedRows));
	      var rowIndex = -1;
	
	      if (e.target.checked) {
	        selectedRows.push(sid);
	      } else {
	        rowIndex = selectedRows.indexOf(sid);
	        selectedRows.splice(rowIndex, 1);
	      }
	
	      this.setState({
	        selectedRows: selectedRows
	      });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this4 = this;
	
	      var _props$store = this.props.store,
	          CourseStore = _props$store.CourseStore,
	          SessionStore = _props$store.SessionStore;
	      var translation = this.props.translation;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (CourseStore.courseOfferings.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-select', scope: 'col' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  'Select'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-title', className: 'subtitle', scope: 'col' },
	                translation.title
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-starts', className: 'subtitle', scope: 'col' },
	                translation.starts
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-ends', className: 'subtitle', scope: 'col' },
	                translation.ends
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-rules', className: 'subtitle', scope: 'col' },
	                translation.funding_rules
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            CourseStore.courseOfferings.map(function (offering, i) {
	              return _react2.default.createElement(
	                'tr',
	                {
	                  className: _this4.state.selectedRows.indexOf(offering.sid) >= 0 ? 'selected' : '',
	                  key: i
	                },
	                _react2.default.createElement(
	                  'td',
	                  { className: 'check-col', 'aria-labelledby': 'heading-select' },
	                  _react2.default.createElement('input', {
	                    id: 'select-' + offering.sid,
	                    className: 'checkbox-input',
	                    type: 'checkbox',
	                    onChange: function onChange(e) {
	                      return _this4.handleSelect(e, offering.sid);
	                    },
	                    checked: _this4.state.selectedRows.indexOf(offering.sid) >= 0
	                  }),
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'checkbox-label checkbox-label--solo',
	                      htmlFor: 'select-' + offering.sid
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      'Select ',
	                      offering.title
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-title' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                      to: '/course-offerings/edit/' + offering.sid,
	                      onClick: function onClick(e) {
	                        _this4.handleEdit(e, offering.sid);
	                      },
	                      title: 'Edit ' + offering.title
	                    },
	                    offering.title
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-starts' },
	                  _moment2.default.utc(offering.startDate).tz(userTimezone).format('M/D/YYYY')
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-ends' },
	                  _moment2.default.utc(offering.endDate).tz(userTimezone).format('M/D/YYYY')
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-rules' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn--link',
	                      onClick: function onClick(e) {
	                        _this4.manageFundingRule(e, offering.sid);
	                      }
	                    },
	                    translation.manage_rules
	                  )
	                )
	              );
	            })
	          )
	        );
	      } else if (!SessionStore.loading && CourseStore.courseOfferings.length === 0) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn--outline', onClick: this.addCourseOffering },
	              _react2.default.createElement(icons.iconPlus, null),
	              translation.create_offering
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        ),
	        _react2.default.createElement(
	          _reactDelayed2.default,
	          {
	            mounted: this.state.selectedRows.length > 0,
	            unmountAfter: 250
	          },
	          _react2.default.createElement(_Toolbar2.default, Object.assign({
	            selectedRows: this.state.selectedRows,
	            deleteText: translation.delete,
	            deleteFunction: this.deleteOfferings
	          }, this.props))
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          getCourseOfferings: this.getCourseOfferings,
	          offeringSid: this.state.offeringSid,
	          fundingRuleSid: this.state.fundingRuleSid
	        }, this.props))
	      );
	    }
	  }]);
	
	  return CourseOfferings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CourseOfferings')(CourseOfferings);

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeSelect = __webpack_require__(80);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var EditCourseOffering = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditCourseOffering, _React$Component);
	
	  function EditCourseOffering() {
	    _classCallCheck(this, EditCourseOffering);
	
	    var _this = _possibleConstructorReturn(this, (EditCourseOffering.__proto__ || Object.getPrototypeOf(EditCourseOffering)).call(this));
	
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditCourseOffering, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.state = {
	        startDate: null,
	        endDate: null,
	        matchStrings: null
	      };
	
	      SessionStore.getTimezones();
	      SessionStore.getCurrencies();
	
	      if ((0, _helpers.getURLSegment)(this, 2) === 'edit') {
	        var offeringSid = (0, _helpers.getURLSegment)(this, 3);
	        this.getCourseOffering(offeringSid);
	      }
	    }
	  }, {
	    key: 'getCourseOffering',
	    value: function getCourseOffering(offeringSid) {
	      this.props.store.CourseStore.getCourseOffering(offeringSid, this);
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(e, name) {
	      var data = _defineProperty({}, name, e.target.value);
	
	      if (name === 'matchStrings') {
	        this.setState({
	          matchStrings: e.target.value
	        });
	      }
	
	      this.props.store.CourseStore.updateOfferingData(data);
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, name, isDateField) {
	      var time = null;
	
	      if (!date) {
	        if (name === 'startDate') {
	          date = this.state.startDate;
	        } else {
	          date = this.state.endDate;
	        }
	      }
	
	      if (name === 'startDate') {
	        time = this.startTime.value;
	      } else {
	        time = this.endTime.value;
	      }
	
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var dateString = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      var timezoneString = (0, _moment2.default)(date).tz(userTimezone).format('Z');
	      var newDate = _moment2.default.utc(dateString + ' ' + time + ' ' + timezoneString, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
	
	      var data = _defineProperty({}, name, newDate);
	
	      if (date) {
	        this.setState(_defineProperty({}, name, (0, _moment2.default)(newDate)));
	      }
	
	      this.props.store.CourseStore.updateOfferingData(data);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var offeringSid = (0, _helpers.getURLSegment)(this, 3);
	
	      if (offeringSid) {
	        this.props.store.CourseStore.updateCourseOffering(offeringSid, this.complete);
	      } else {
	        this.props.store.CourseStore.createCourseOffering(this.complete);
	      }
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      (0, _helpers.closeDrawer)(null, this.props.parent, (0, _helpers.getURLSegment)(this, 1));
	      this.props.store.SessionStore.showToaster(this.props.translation.offering_saved, 'success');
	      this.props.getCourseOfferings(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          CourseStore = _props$store.CourseStore,
	          SessionStore = _props$store.SessionStore;
	      var offering = CourseStore.offering;
	
	      var offeringSid = (0, _helpers.getURLSegment)(this, 3);
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              offeringSid && _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.edit_heading
	              ),
	              !offeringSid && _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.add_heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'form',
	              { className: 'panel panel--medium', onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'offering-title' },
	                      translation.title.label
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'offering-title',
	                      ref: function ref(input) {
	                        _this2.title = input;
	                      },
	                      onChange: function onChange(e) {
	                        _this2.handleInput(e, 'title');
	                      },
	                      defaultValue: offering.title,
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'offering-regex' },
	                      translation.regex.label
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'offering-regex',
	                      ref: function ref(input) {
	                        _this2.matchStrings = input;
	                      },
	                      onChange: function onChange(e) {
	                        _this2.handleInput(e, 'matchStrings');
	                      },
	                      defaultValue: offering.matchStrings,
	                      required: true,
	                      'aria-required': 'true',
	                      'aria-invalid': this.state.matchStrings === '*'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'offering-start' },
	                      translation.starts.label
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      id: 'offering-start',
	                      selected: offering.startDate ? (0, _moment2.default)(offering.startDate).tz(userTimezone) : null,
	                      onChange: function onChange(date) {
	                        _this2.handleDateChange(date, 'startDate', true);
	                      },
	                      ref: function ref(input) {
	                        _this2.startDate = input;
	                      },
	                      placeholderText: translation.starts.helper,
	                      required: true,
	                      'aria-required': 'true',
	                      autoComplete: 'off'
	                    }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      'at'
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'offering-start-time',
	                          defaultValue: _moment2.default.utc(offering.startDate).tz(userTimezone).format('HH:mm'),
	                          ref: function ref(input) {
	                            _this2.startTime = input;
	                          },
	                          onChange: function onChange() {
	                            return _this2.handleDateChange(null, 'startDate', false);
	                          }
	                        },
	                        _react2.default.createElement(_TimeSelect2.default, null)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      this.state.startDate && _moment2.default.utc(this.state.startDate).tz(userTimezone).format('z'),
	                      !this.state.startDate && (0, _moment2.default)().tz(userTimezone).format('z')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'offering-end' },
	                      translation.ends.label
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      id: 'offering-end',
	                      selected: offering.endDate ? (0, _moment2.default)(offering.endDate).tz(userTimezone) : null,
	                      onChange: function onChange(date) {
	                        _this2.handleDateChange(date, 'endDate', true);
	                      },
	                      ref: function ref(input) {
	                        _this2.endDate = input;
	                      },
	                      placeholderText: translation.ends.helper,
	                      required: true,
	                      'aria-required': 'true',
	                      autoComplete: 'off'
	                    }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      'at'
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'offering-start-time',
	                          defaultValue: _moment2.default.utc(offering.endDate).tz(userTimezone).format('HH:mm'),
	                          ref: function ref(input) {
	                            _this2.endTime = input;
	                          },
	                          onChange: function onChange() {
	                            return _this2.handleDateChange(null, 'endDate', false);
	                          }
	                        },
	                        _react2.default.createElement(_TimeSelect2.default, null)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      this.state.endDate && _moment2.default.utc(this.state.endDate).tz(userTimezone).format('z'),
	                      !this.state.endDate && (0, _moment2.default)().tz(userTimezone).format('z')
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__actions actions' },
	                offeringSid && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary'
	                  },
	                  translation.edit_button
	                ),
	                !offeringSid && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary'
	                  },
	                  translation.add_button
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return EditCourseOffering;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EditCourseOffering')(EditCourseOffering);

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _InstitutionDashboard = __webpack_require__(792);
	
	var _InstitutionDashboard2 = _interopRequireDefault(_InstitutionDashboard);
	
	var _CourseDashboard = __webpack_require__(756);
	
	var _CourseDashboard2 = _interopRequireDefault(_CourseDashboard);
	
	var _StudentDashboard = __webpack_require__(872);
	
	var _StudentDashboard2 = _interopRequireDefault(_StudentDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Dashboard = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Dashboard, _React$Component);
	
	  function Dashboard() {
	    _classCallCheck(this, Dashboard);
	
	    return _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).apply(this, arguments));
	  }
	
	  _createClass(Dashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var courseSid = this.props.routing.location.query.courseSid;
	
	
	      if (courseSid) {
	        SessionStore.notice = true;
	        SessionStore.noticeContent.body = translation.admin_notice;
	        SessionStore.userData.courseSid = courseSid;
	        SessionStore.getCourseData(courseSid);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	      var role = SessionStore.userData.role;
	      var courseSid = this.props.routing.location.query.courseSid;
	
	
	      if (SessionStore.courseData) {
	        courseSid = SessionStore.courseData.sid;
	      }
	
	      if (role.toLowerCase() === 'learner') {
	        return _react2.default.createElement(_StudentDashboard2.default, this.props);
	      } else if (role.toLowerCase() === 'instructor' || courseSid) {
	        if (courseSid) {
	          return _react2.default.createElement(_CourseDashboard2.default, Object.assign({}, this.props, { courseSid: courseSid }));
	        } else {
	          return _react2.default.createElement(_CourseDashboard2.default, this.props);
	        }
	      } else {
	        return _react2.default.createElement(_InstitutionDashboard2.default, this.props);
	      }
	    }
	  }]);
	
	  return Dashboard;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Dashboard')(Dashboard);

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _ProctorApproval = __webpack_require__(739);
	
	var _ProctorApproval2 = _interopRequireDefault(_ProctorApproval);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var ApproveProctor = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ApproveProctor, _React$Component);
	
	  function ApproveProctor() {
	    _classCallCheck(this, ApproveProctor);
	
	    var _this = _possibleConstructorReturn(this, (ApproveProctor.__proto__ || Object.getPrototypeOf(ApproveProctor)).call(this));
	
	    _this.nextCard = _this.nextCard.bind(_this);
	    _this.prevCard = _this.prevCard.bind(_this);
	    return _this;
	  }
	
	  _createClass(ApproveProctor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.state = {
	        card: 1
	      };
	
	      this.getPendingApprovals();
	
	      SessionStore.getCurrentTime();
	    }
	  }, {
	    key: 'getPendingApprovals',
	    value: function getPendingApprovals() {
	      var query = '?examSid=' + this.props.examSid + '&status=requested';
	
	      if (typeof this.props.examSid === 'undefined') {
	        var segment2 = (0, _helpers.getURLSegment)(this, 2);
	
	        if (typeof segment2 !== 'undefined') {
	          query = '?examSid=' + (0, _helpers.getURLSegment)(this, 2) + '&status=requested';
	        } else {
	          query = '?status=requested';
	        }
	      }
	
	      this.props.store.ProctorStore.getPendingApprovals(query);
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(card) {
	      if (this.state.card === card) {
	        return 'slide-active';
	      } else if (this.state.card > card) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'nextCard',
	    value: function nextCard() {
	      this.setState({
	        card: this.state.card + 1
	      });
	    }
	  }, {
	    key: 'prevCard',
	    value: function prevCard() {
	      this.setState({
	        card: this.state.card - 1
	      });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var ProctorStore = store.ProctorStore,
	          SessionStore = store.SessionStore;
	      var pendingApprovals = ProctorStore.pendingApprovals;
	
	
	      if (pendingApprovals.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'approval-wrap' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'approvals slide-wrap' },
	            pendingApprovals.map(function (key, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i, className: _this2.isActive(i + 1) },
	                _react2.default.createElement(_ProctorApproval2.default, Object.assign({
	                  approval: key,
	                  proctor: key.proctorAccount,
	                  approvalCallback: _this2.nextCard
	                }, _this2.props))
	              );
	            }),
	            _react2.default.createElement(
	              'li',
	              { className: 'panel panel--brief approval__done ' + this.isActive(pendingApprovals.length + 1) },
	              this.state.card > pendingApprovals.length && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.done_heading
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.done_body
	                )
	              )
	            )
	          ),
	          this.state.card !== 1 && this.state.card !== pendingApprovals.length + 1 && _react2.default.createElement(
	            'button',
	            {
	              className: 'approvals__nav approvals__prev',
	              onClick: this.prevCard
	            },
	            _react2.default.createElement(icons.iconChevronLeft, null),
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.prev
	            )
	          ),
	          this.state.card !== pendingApprovals.length && this.state.card !== pendingApprovals.length + 1 && _react2.default.createElement(
	            'button',
	            {
	              className: 'approvals__nav approvals__next',
	              onClick: this.nextCard
	            },
	            _react2.default.createElement(icons.iconChevronRight, null),
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.next
	            )
	          )
	        );
	      } else if (!SessionStore.loading && pendingApprovals.length === 0) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__section' },
	            this.renderResults()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ApproveProctor;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ApproveProctor')(ApproveProctor);

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeSelect = __webpack_require__(80);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	var _Map = __webpack_require__(149);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var AssignProctor = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AssignProctor, _React$Component);
	
	  function AssignProctor() {
	    _classCallCheck(this, AssignProctor);
	
	    var _this2 = _possibleConstructorReturn(this, (AssignProctor.__proto__ || Object.getPrototypeOf(AssignProctor)).call(this));
	
	    _this2.handleDateChange = _this2.handleDateChange.bind(_this2);
	    _this2.updateDates = _this2.updateDates.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.complete = _this2.complete.bind(_this2);
	    _this2.handlePhoneInput = _this2.handlePhoneInput.bind(_this2);
	    _this2.setLocation = _this2.setLocation.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(AssignProctor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        examSid: null,
	        enrollmentSid: null,
	        appointmentDateTime: null,
	        sessionSid: null,
	        proctorData: {}
	      };
	
	      // Make sure default proctorData gets set
	      var proctorData = {
	        firstName: null,
	        lastName: null,
	        company: null,
	        email: null,
	        phone: null,
	        address1: null,
	        address2: null,
	        place: null,
	        region: null,
	        country: null,
	        locationLatitude: null,
	        locationLongitude: null,
	        postalCode: null
	      };
	
	      this.setState({
	        proctorData: proctorData
	      });
	
	      // Get the exam sid from the URL
	      var examSid = (0, _helpers.getURLSegment)(this, 2);
	      var enrollmentSid = this.props.routing.location.query.enrollment;
	      var sessionSid = this.props.routing.location.query.session;
	
	      this.setState({
	        examSid: examSid,
	        enrollmentSid: enrollmentSid,
	        sessionSid: sessionSid
	      });
	
	      var _this = this;
	      setTimeout(function () {
	        _this.getSession();
	      });
	
	      this.props.store.SessionStore.getCurrentTime();
	    }
	  }, {
	    key: 'getSession',
	    value: function getSession() {
	      this.props.store.EnrollmentStore.getExamSession(this.state.examSid, this.state.sessionSid, this);
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var proctorData = Object.assign({}, this.state.proctorData);
	
	      proctorData.firstName = this.firstName.value;
	      proctorData.lastName = this.lastName.value;
	      proctorData.company = this.company.value;
	      proctorData.email = this.email.value;
	
	      this.setState({
	        proctorData: proctorData
	      });
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, isDateField) {
	      if (isDateField) {
	        this.setState({
	          appointmentDateTime: date
	        });
	      } else {
	        date = this.state.appointmentDateTime;
	      }
	
	      var time = this.time.value;
	
	      // Update form data
	      var _this = this;
	
	      setTimeout(function () {
	        _this.updateDates(date, time);
	      });
	    }
	  }, {
	    key: 'updateDates',
	    value: function updateDates(date, time) {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var dateString = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      var timezoneString = (0, _moment2.default)(date).tz(userTimezone).format('Z');
	      var appointmentDateTime = _moment2.default.utc(dateString + ' ' + time + ' ' + timezoneString, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
	
	      var proctorData = Object.assign({}, this.state.proctorData);
	      proctorData.appointmentDateTime = appointmentDateTime;
	
	      this.setState({
	        proctorData: proctorData
	      });
	    }
	  }, {
	    key: 'handlePhoneInput',
	    value: function handlePhoneInput(e) {
	      var proctorData = Object.assign({}, this.state.proctorData);
	      proctorData.phone = e;
	      this.setState({
	        proctorData: proctorData
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var data = this.state.proctorData;
	
	      data.type = 'ad-hoc';
	
	      Object.keys(data).forEach(function (prop) {
	        if (!data[prop]) {
	          delete data[prop];
	        }
	      });
	
	      this.props.store.ScheduleStore.createAppointment(this.state.examSid, this.state.sessionSid, data, this.complete);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      var closePath = (0, _helpers.getURLSegment)(this, 1) + '/' + (0, _helpers.getURLSegment)(this, 2);
	
	      (0, _helpers.closeDrawer)(null, this.props.parent, closePath);
	      this.props.store.SessionStore.showToaster(this.props.translation.proctor_assigned, 'success');
	
	      // Update the roster table
	      this.props.store.ExamStore.getEnrollments((0, _helpers.getURLSegment)(this, 2));
	    }
	  }, {
	    key: 'setLocation',
	    value: function setLocation(name, address1, address2, place, region, country, postalCode, lat, lng, preventRender) {
	      var proctorData = Object.assign({}, this.state.proctorData);
	
	      proctorData.address1 = address1;
	      proctorData.address2 = address2;
	      proctorData.place = place;
	      proctorData.region = region;
	      proctorData.country = country;
	      proctorData.postalCode = postalCode;
	      proctorData.locationLatitude = lat.toString();
	      proctorData.locationLongitude = lng.toString();
	
	      this.setState({
	        proctorData: proctorData
	      });
	    }
	  }, {
	    key: 'renderLocation',
	    value: function renderLocation() {
	      // Default map options
	      var center = {
	        lat: 37.09024,
	        lng: -95.712891
	      };
	
	      var zoom = 4;
	      var dropPin = false;
	
	      return _react2.default.createElement(
	        'fieldset',
	        { className: 'form-section' },
	        _react2.default.createElement(_Map2.default, {
	          setLocation: this.setLocation,
	          store: this.props.store,
	          center: center,
	          zoom: zoom,
	          dropPin: dropPin,
	          requireAddress: true
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var examSession = this.props.store.EnrollmentStore.examSession;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var minDate = null;
	
	      if (examSession.examConfiguration) {
	        var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	        minDate = (0, _moment2.default)(examSession.examConfiguration.examOpenDate);
	        var timeDiff = _moment2.default.duration(minDate.diff(now)).asHours();
	
	        if (timeDiff < 0) {
	          minDate = now;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap block-form' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'panel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel__body' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'note note--prominent' },
	                    translation.directions
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'fields' },
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--half' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-fname' },
	                        'First Name'
	                      ),
	                      _react2.default.createElement('input', { type: 'text',
	                        id: 'proctor-fname',
	                        placeholder: 'The proctor\u2019s first name\u2026',
	                        ref: function ref(input) {
	                          _this3.firstName = input;
	                        },
	                        onChange: this.handleInput,
	                        required: true, autoFocus: true })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--half' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-lname' },
	                        'Last Name'
	                      ),
	                      _react2.default.createElement('input', { type: 'text',
	                        id: 'proctor-lname',
	                        placeholder: 'The proctor\u2019s last name\u2026',
	                        ref: function ref(input) {
	                          _this3.lastName = input;
	                        },
	                        onChange: this.handleInput,
	                        required: true })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-company' },
	                        'Company'
	                      ),
	                      _react2.default.createElement('input', { type: 'text',
	                        id: 'proctor-company',
	                        placeholder: 'The company the proctor works for\u2026',
	                        ref: function ref(input) {
	                          _this3.company = input;
	                        },
	                        onChange: this.handleInput,
	                        required: true })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--half' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-email' },
	                        'Email'
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'email',
	                        id: 'proctor-email',
	                        placeholder: 'email@example.com',
	                        ref: function ref(input) {
	                          _this3.email = input;
	                        },
	                        onChange: this.handleInput,
	                        required: true })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--half' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-phone' },
	                        'Phone'
	                      ),
	                      _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                        id: 'proctor-phone',
	                        nativeExpanded: true,
	                        flagsPath: './static/img/flags/',
	                        country: this.state.proctorData && this.state.proctorData.phone ? (0, _reactPhoneNumberInput.parsePhoneNumber)(this.state.proctorData.phone).country : 'US',
	                        value: this.state.proctorData ? this.state.proctorData.phone : '',
	                        ref: function ref(input) {
	                          _this3.phone = input;
	                        },
	                        onChange: function onChange(e) {
	                          return _this3.handlePhoneInput(e);
	                        },
	                        required: true,
	                        'aria-required': 'true',
	                        'aria-invalid': this.state.proctorData ? !(0, _reactPhoneNumberInput.isValidPhoneNumber)(this.state.proctorData.phone) : 'false'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--auto' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-date' },
	                        'Date and Time'
	                      ),
	                      _react2.default.createElement(_reactDatepicker2.default, {
	                        id: 'proctor-date',
	                        selected: this.state.appointmentDateTime ? (0, _moment2.default)(this.state.appointmentDateTime).tz(userTimezone) : null,
	                        openToDate: (0, _moment2.default)(examSession.examConfiguration.examOpenDate),
	                        minDate: minDate,
	                        maxDate: examSession.examConfiguration.examCloseDate,
	                        onChange: function onChange(date) {
	                          _this3.handleDateChange(date, true);
	                        },
	                        ref: function ref(input) {
	                          _this3.appointmentDateTime = input;
	                        },
	                        placeholderText: 'mm/dd/yyyy',
	                        required: true,
	                        'aria-required': 'true',
	                        autoComplete: 'off'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'preposition' },
	                        'at'
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'select' },
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            id: 'proctor-time',
	                            ref: function ref(input) {
	                              _this3.time = input;
	                            },
	                            onChange: function onChange() {
	                              return _this3.handleDateChange(null, false);
	                            },
	                            defaultValue: _moment2.default.utc(this.state.appointmentDateTime).tz(userTimezone).format('HH:mm')
	                          },
	                          _react2.default.createElement(_TimeSelect2.default, null)
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'preposition' },
	                        this.state.appointmentDateTime && _moment2.default.utc(this.state.appointmentDateTime).tz(userTimezone).format('z'),
	                        !this.state.appointmentDateTime && (0, _moment2.default)().tz(userTimezone).format('z')
	                      )
	                    )
	                  ),
	                  this.renderLocation(),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'panel__actions actions' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'actions__btn actions__btn--primary' },
	                      'Submit'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return AssignProctor;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AssignProctor')(AssignProctor);

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeSelect = __webpack_require__(80);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	var _Map = __webpack_require__(149);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var EditProctor = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditProctor, _React$Component);
	
	  function EditProctor() {
	    _classCallCheck(this, EditProctor);
	
	    var _this2 = _possibleConstructorReturn(this, (EditProctor.__proto__ || Object.getPrototypeOf(EditProctor)).call(this));
	
	    _this2.handleDateChange = _this2.handleDateChange.bind(_this2);
	    _this2.updateDates = _this2.updateDates.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.complete = _this2.complete.bind(_this2);
	    _this2.handlePhoneInput = _this2.handlePhoneInput.bind(_this2);
	    _this2.setLocation = _this2.setLocation.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(EditProctor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        examSid: null,
	        enrollmentSid: null,
	        proctorData: {
	          firstName: '',
	          lastName: '',
	          company: '',
	          email: '',
	          phone: '',
	          appointmentDateTime: null,
	          address1: null,
	          address2: null,
	          place: null,
	          region: null,
	          country: null,
	          locationLatitude: null,
	          locationLongitude: null,
	          postalCode: null
	        }
	      };
	
	      var examSid = (0, _helpers.getURLSegment)(this, 2);
	      var enrollmentSid = this.props.routing.location.query.enrollment;
	      var sessionSid = this.props.routing.location.query.session;
	
	      this.setState({
	        examSid: examSid,
	        enrollmentSid: enrollmentSid,
	        sessionSid: sessionSid
	      });
	
	      var _this = this;
	      setTimeout(function () {
	        _this.getSession();
	      });
	    }
	  }, {
	    key: 'getSession',
	    value: function getSession() {
	      this.props.store.EnrollmentStore.getExamSession(this.state.examSid, this.state.sessionSid, this);
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var proctorData = Object.assign({}, this.state.proctorData);
	
	      proctorData.firstName = this.firstName.value;
	      proctorData.lastName = this.lastName.value;
	      proctorData.company = this.company.value;
	      proctorData.email = this.email.value;
	      // proctorData.phone = this.phone.props.value;
	
	      this.setState({
	        proctorData: proctorData
	      });
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, isDateField) {
	      if (isDateField) {
	        var proctorData = Object.assign({}, this.state.proctorData);
	
	        proctorData.appointmentDateTime = date;
	
	        this.setState({
	          proctorData: proctorData
	        });
	      } else {
	        date = this.state.proctorData.appointmentDateTime;
	      }
	
	      var time = this.time.value;
	
	      // Update form data
	      var _this = this;
	      setTimeout(function () {
	        _this.updateDates(date, time);
	      });
	    }
	  }, {
	    key: 'updateDates',
	    value: function updateDates(date, time) {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var dateString = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      var timezoneString = (0, _moment2.default)(date).tz(userTimezone).format('Z');
	      var appointmentDateTime = _moment2.default.utc(dateString + ' ' + time + ' ' + timezoneString, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
	
	      var proctorData = Object.assign({}, this.state.proctorData);
	      proctorData.appointmentDateTime = appointmentDateTime;
	
	      this.setState({
	        proctorData: proctorData
	      });
	    }
	  }, {
	    key: 'handlePhoneInput',
	    value: function handlePhoneInput(e) {
	      var proctorData = Object.assign({}, this.state.proctorData);
	      proctorData.phone = e;
	      this.setState({
	        proctorData: proctorData
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var data = Object.assign({}, this.state.proctorData);
	
	      data.type = 'ad-hoc';
	
	      Object.keys(data).forEach(function (prop) {
	        if (!data[prop]) {
	          delete data[prop];
	        }
	      });
	
	      delete data.accountName;
	
	      this.props.store.ScheduleStore.rescheduleAppointment(this.state.examSid, this.state.sessionSid, data, this.complete);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      // Get url segments
	      var examSid = (0, _helpers.getURLSegment)(this, 2);
	
	      var closePath = (0, _helpers.getURLSegment)(this, 1) + '/' + examSid;
	
	      (0, _helpers.closeDrawer)(null, this.props.parent, closePath);
	      this.props.store.SessionStore.showToaster(this.props.translation.proctor_assigned, 'success');
	
	      // Update the roster table
	      this.props.store.ExamStore.getEnrollments(examSid);
	    }
	  }, {
	    key: 'setLocation',
	    value: function setLocation(name, address1, address2, place, region, country, postalCode, lat, lng, preventRender) {
	      var proctorData = Object.assign({}, this.state.proctorData);
	
	      proctorData.address1 = address1;
	      proctorData.address2 = address2;
	      proctorData.place = place;
	      proctorData.region = region;
	      proctorData.country = country;
	      proctorData.postalCode = postalCode;
	      proctorData.locationLatitude = lat.toString();
	      proctorData.locationLongitude = lng.toString();
	
	      this.setState({
	        proctorData: proctorData
	      });
	    }
	  }, {
	    key: 'renderLocation',
	    value: function renderLocation() {
	      var proctorData = this.state.proctorData;
	
	      // Default map options
	
	      var center = {
	        lat: this.state.proctorData.locationLatitude || 37.09024,
	        lng: this.state.proctorData.locationLongitude || -95.712891
	      };
	
	      var zoom = 4;
	      var dropPin = false;
	
	      if (this.state.proctorData.locationLatitude && this.state.proctorData.locationLongitude) {
	        zoom = 17;
	        dropPin = true;
	      }
	
	      var location = '';
	
	      if (proctorData.address1) {
	        location = proctorData.address1 + ', ';
	      }
	
	      if (proctorData.address2) {
	        location += proctorData.address2 + ', ';
	      }
	
	      if (proctorData.place) {
	        location += proctorData.place + ', ';
	      }
	
	      if (proctorData.region) {
	        location += proctorData.region + ' ';
	      }
	
	      if (proctorData.postalCode) {
	        location += proctorData.postalCode;
	      }
	
	      return _react2.default.createElement(
	        'fieldset',
	        { className: 'form-section' },
	        _react2.default.createElement(_Map2.default, {
	          setLocation: this.setLocation,
	          store: this.props.store,
	          center: center,
	          zoom: zoom,
	          dropPin: dropPin,
	          'default': location,
	          locationSet: this.state.proctorData.locationLatitude ? true : false,
	          requireAddress: true
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var examSession = this.props.store.EnrollmentStore.examSession;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (typeof examSession.proctor !== 'undefined' && examSession.proctor.company) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap block-form' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                { id: 'exam-details', className: 'panel' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel__body' },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'fields' },
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--half' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-fname' },
	                        'First Name'
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        id: 'proctor-fname',
	                        placeholder: 'The proctor\u2019s first name\u2026',
	                        ref: function ref(input) {
	                          _this3.firstName = input;
	                        },
	                        onChange: this.handleInput,
	                        defaultValue: examSession.proctor.firstName,
	                        required: true,
	                        'aria-required': 'true',
	                        autoFocus: true
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--half' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-lname' },
	                        'Last Name'
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        id: 'proctor-lname',
	                        placeholder: 'The proctor\u2019s last name\u2026',
	                        ref: function ref(input) {
	                          _this3.lastName = input;
	                        },
	                        onChange: this.handleInput,
	                        defaultValue: examSession.proctor.lastName,
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-company' },
	                        'Company'
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        id: 'proctor-company',
	                        placeholder: 'The company the proctor works for\u2026',
	                        ref: function ref(input) {
	                          _this3.company = input;
	                        },
	                        onChange: this.handleInput,
	                        defaultValue: examSession.proctor.company,
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--half' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-email' },
	                        'Email'
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'email',
	                        id: 'proctor-email',
	                        placeholder: 'email@example.com',
	                        ref: function ref(input) {
	                          _this3.email = input;
	                        },
	                        onChange: this.handleInput,
	                        defaultValue: examSession.proctor.email,
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--half' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-phone' },
	                        'Phone'
	                      ),
	                      _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                        id: 'proctor-phone',
	                        nativeExpanded: true,
	                        flagsPath: './static/img/flags/',
	                        value: this.state.proctorData.phone,
	                        ref: function ref(input) {
	                          _this3.phone = input;
	                        },
	                        onChange: function onChange(e) {
	                          return _this3.handlePhoneInput(e);
	                        },
	                        required: true,
	                        'aria-required': 'true',
	                        'aria-invalid': !(0, _reactPhoneNumberInput.isValidPhoneNumber)(this.state.proctorData.phone)
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'field--auto' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'proctor-date' },
	                        'Date and Time'
	                      ),
	                      _react2.default.createElement(_reactDatepicker2.default, {
	                        id: 'proctor-date',
	                        selected: this.state.proctorData.appointmentDateTime ? (0, _moment2.default)(this.state.proctorData.appointmentDateTime).tz(userTimezone) : null,
	                        openToDate: (0, _moment2.default)(examSession.examConfiguration.examOpenDate),
	                        minDate: examSession.examConfiguration.examOpenDate,
	                        maxDate: examSession.examConfiguration.examCloseDate,
	                        onChange: function onChange(date) {
	                          _this3.handleDateChange(date, true);
	                        },
	                        ref: function ref(input) {
	                          _this3.appointmentDateTime = input;
	                        },
	                        placeholderText: 'mm/dd/yyyy',
	                        required: true,
	                        'aria-required': 'true',
	                        autoComplete: 'off'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'preposition' },
	                        'at'
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'select' },
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            id: 'proctor-time',
	                            ref: function ref(input) {
	                              _this3.time = input;
	                            },
	                            onChange: function onChange() {
	                              return _this3.handleDateChange(null, false);
	                            },
	                            value: _moment2.default.utc(this.state.proctorData.appointmentDateTime).tz(userTimezone).format('HH:mm')
	                          },
	                          _react2.default.createElement(_TimeSelect2.default, null)
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'preposition' },
	                        this.state.appointmentDateTime && _moment2.default.utc(this.state.appointmentDateTime).tz(userTimezone).format('z'),
	                        !this.state.appointmentDateTime && (0, _moment2.default)().tz(userTimezone).format('z')
	                      )
	                    )
	                  ),
	                  this.renderLocation(),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'panel__actions actions' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'actions__btn actions__btn--primary' },
	                      'Submit'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return EditProctor;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EditProctor')(EditProctor);

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _ExamDetails = __webpack_require__(79);
	
	var _ExamDetails2 = _interopRequireDefault(_ExamDetails);
	
	var _Incidents = __webpack_require__(359);
	
	var _Incidents2 = _interopRequireDefault(_Incidents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var IncidentReport = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(IncidentReport, _React$Component);
	
	  function IncidentReport() {
	    _classCallCheck(this, IncidentReport);
	
	    return _possibleConstructorReturn(this, (IncidentReport.__proto__ || Object.getPrototypeOf(IncidentReport)).apply(this, arguments));
	  }
	
	  _createClass(IncidentReport, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (typeof this.props.exam === 'undefined') {
	        var examSid = this.props.routing.location.query.eventsFor;
	        this.props.store.ExamStore.getExam(examSid);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      var exam = null;
	
	      if (typeof this.props.exam === 'undefined') {
	        exam = this.props.store.ExamStore.exam;
	      } else {
	        exam = this.props.exam;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(_ExamDetails2.default, Object.assign({ exam: exam }, this.props)),
	          _react2.default.createElement(_Incidents2.default, this.props)
	        )
	      );
	    }
	  }]);
	
	  return IncidentReport;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('IncidentReport')(IncidentReport);

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	var ProctorDetails = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProctorDetails, _React$Component);
	
	  function ProctorDetails() {
	    _classCallCheck(this, ProctorDetails);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (ProctorDetails.__proto__ || Object.getPrototypeOf(ProctorDetails)).call(this));
	
	    _this.proctorTypeDisplayName = _this.proctorTypeDisplayName.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProctorDetails, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          LocationStore = _props$store.LocationStore,
	          ProctorStore = _props$store.ProctorStore;
	      var proctorAccountSid = this.props.proctorAccountSid;
	
	
	      this.state = {
	        proctorTypes: []
	      };
	
	      ProctorStore.getProctor(proctorAccountSid, null, this.proctorTypeDisplayName);
	      LocationStore.getLocations(proctorAccountSid);
	    }
	  }, {
	    key: 'proctorTypeDisplayName',
	    value: function proctorTypeDisplayName(proctor) {
	      var proctorTypeList = this.props.store.SessionStore.proctorTypeList;
	
	
	      var proctorTypes = [].concat(_toConsumableArray(this.state.proctorTypes));
	
	      if (proctor.proctorTypes.length > 0) {
	        proctor.proctorTypes.forEach(function (proctorTypeSid) {
	          proctorTypeList.forEach(function (parentType) {
	            parentType.subCategories.forEach(function (proctorType) {
	              if (proctorTypeSid === proctorType.sid) {
	                proctorTypes.push(proctorType.title);
	              }
	            });
	          });
	        });
	      }
	
	      this.setState({
	        proctorTypes: proctorTypes
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          LocationStore = _props$store2.LocationStore,
	          ProctorStore = _props$store2.ProctorStore,
	          SessionStore = _props$store2.SessionStore;
	      var proctor = ProctorStore.proctor;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel--medium' },
	              _react2.default.createElement(
	                'figure',
	                { className: 'media--alt media--alt-top' },
	                proctor.image && proctor.image !== 'https://s3.amazonaws.com/' && _react2.default.createElement(
	                  'span',
	                  { className: 'proctor__avatar avatar-wrap' },
	                  _react2.default.createElement('img', {
	                    className: 'avatar',
	                    src: proctor.image,
	                    alt: '',
	                    onLoad: function onLoad(e) {
	                      return (0, _helpers.flagPortrait)(e, proctor.image);
	                    }
	                  })
	                ),
	                (!proctor.image || proctor.image === 'https://s3.amazonaws.com/') && _react2.default.createElement(
	                  'span',
	                  { className: 'proctor__avatar avatar-wrap' },
	                  _react2.default.createElement('img', {
	                    className: 'avatar avatar--missing',
	                    src: './static/img/avatar-default.png',
	                    alt: 'No avatar provided',
	                    onLoad: function onLoad(e) {
	                      return (0, _helpers.flagPortrait)(e, './static/img/avatar-default.png');
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'figcaption',
	                  { className: 'media__copy' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'proctor__title fn org' },
	                    proctor.accountName
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'simple-list' },
	                    proctor.email && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:' + proctor.email },
	                        proctor.email
	                      )
	                    ),
	                    proctor.phoneNumber && _react2.default.createElement(
	                      'li',
	                      null,
	                      (0, _reactPhoneNumberInput.formatPhoneNumber)(proctor.phoneNumber, (0, _reactPhoneNumberInput.parsePhoneNumber)(proctor.phoneNumber).country, 'National')
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      this.state.proctorTypes.length > 0 && _react2.default.createElement(
	                        'ul',
	                        { className: 'data--comma' },
	                        this.state.proctorTypes.map(function (proctorType, i) {
	                          return _react2.default.createElement(
	                            'li',
	                            { key: i },
	                            proctorType
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              LocationStore.locations.length > 0 && _react2.default.createElement(
	                'div',
	                { className: 'approval__details' },
	                _react2.default.createElement(
	                  'section',
	                  { className: 'approval__details-section' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Locations'
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'simple-list' },
	                    LocationStore.locations.map(function (location, i) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: i, className: 'adr' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          location.name
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'street-address' },
	                          location.address1,
	                          ' ',
	                          location.address2
	                        ),
	                        location.place && _react2.default.createElement(
	                          'span',
	                          { className: 'locality' },
	                          location.place,
	                          ', '
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'region' },
	                          location.region,
	                          ' '
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'postal-code' },
	                          location.postalCode
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ProctorDetails;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProctorDetails')(ProctorDetails);

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Session = __webpack_require__(367);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _IncidentForm = __webpack_require__(366);
	
	var _IncidentForm2 = _interopRequireDefault(_IncidentForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var SessionManage = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionManage, _React$Component);
	
	  function SessionManage() {
	    _classCallCheck(this, SessionManage);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (SessionManage.__proto__ || Object.getPrototypeOf(SessionManage)).call(this));
	
	    _this.completeIncident = _this.completeIncident.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionManage, [{
	    key: 'completeIncident',
	    value: function completeIncident() {
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ManagerStore = _props$store.ManagerStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      ManagerStore.reportIncident = false;
	      ManagerStore.incidentSession = null;
	      SessionStore.showToaster(translation.incident_saved, 'success');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          ManagerStore = _props$store2.ManagerStore,
	          SessionStore = _props$store2.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: 'block-list session-list' },
	          _react2.default.createElement(_Session2.default, this.props)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'session-interact ' + (ManagerStore.reportIncident ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel--brief' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              translation.report_incident
	            ),
	            ManagerStore.reportIncident && _react2.default.createElement(_IncidentForm2.default, Object.assign({
	              installSid: SessionStore.userData.installSid,
	              examSid: ManagerStore.session.examSid,
	              completeIncident: this.completeIncident
	            }, this.props)),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn--link', onClick: this.cancelAdd },
	              translation.cancel
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SessionManage;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionManager')(SessionManage);

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _StudentEnrollment = __webpack_require__(775);
	
	var _StudentEnrollment2 = _interopRequireDefault(_StudentEnrollment);
	
	var _LegacyEnrollment = __webpack_require__(774);
	
	var _LegacyEnrollment2 = _interopRequireDefault(_LegacyEnrollment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Dependencies
	
	
	// Components
	
	
	var Enroll = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Enroll, _React$Component);
	
	  function Enroll() {
	    _classCallCheck(this, Enroll);
	
	    var _this = _possibleConstructorReturn(this, (Enroll.__proto__ || Object.getPrototypeOf(Enroll)).call(this));
	
	    _this.renderEnrollment = _this.renderEnrollment.bind(_this);
	    _this.renderLegacyEnrollment = _this.renderLegacyEnrollment.bind(_this);
	    return _this;
	  }
	
	  _createClass(Enroll, [{
	    key: 'renderEnrollment',
	    value: function renderEnrollment(featureFlagValue) {
	      // if(this.props.store.SessionStore.settings.smarterIdEnabled) {
	      //   return <StudentEnrollment {...this.props} smarterID={true} />
	      // } else {
	      //   return <StudentEnrollment {...this.props} smarterID={false} />
	      // }
	
	      return _react2.default.createElement(_StudentEnrollment2.default, Object.assign({}, this.props, { smarterID: false }));
	    }
	  }, {
	    key: 'renderLegacyEnrollment',
	    value: function renderLegacyEnrollment() {
	      return _react2.default.createElement(_LegacyEnrollment2.default, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	        flagKey: 'updated-student-enrollment',
	        renderFeatureCallback: this.renderEnrollment,
	        renderDefaultCallback: this.renderLegacyEnrollment
	      });
	    }
	  }]);
	
	  return Enroll;
	}(_react2.default.Component));
	
	exports.default = Enroll;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var EnrollIntro = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EnrollIntro, _React$Component);
	
	  function EnrollIntro() {
	    _classCallCheck(this, EnrollIntro);
	
	    var _this = _possibleConstructorReturn(this, (EnrollIntro.__proto__ || Object.getPrototypeOf(EnrollIntro)).call(this));
	
	    _this.next = _this.next.bind(_this);
	    return _this;
	  }
	
	  _createClass(EnrollIntro, [{
	    key: 'next',
	    value: function next(e) {
	      if (this.props.smarterID) {
	        this.props.nextStep(e);
	        this.props.setDisplayStep(2);
	      } else {
	        this.props.setStep(e, 5);
	        this.props.setDisplayStep(2);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel panel--brief ' + this.props.isActive },
	        _react2.default.createElement(
	          'h1',
	          { className: 'panel__title' },
	          translation.heading
	        ),
	        this.props.smarterID && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.body_sid) } }),
	        !this.props.smarterID && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.body) } }),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn--icn-right next', onClick: function onClick(e) {
	              _this2.next(e);
	            } },
	          translation.button,
	          _react2.default.createElement(icons.iconCircleRight, null)
	        )
	      );
	    }
	  }]);
	
	  return EnrollIntro;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EnrollIntro')(EnrollIntro);

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Webcam = __webpack_require__(150);
	
	var _Webcam2 = _interopRequireDefault(_Webcam);
	
	var _EnrollPC = __webpack_require__(348);
	
	var _EnrollPC2 = _interopRequireDefault(_EnrollPC);
	
	var _EnrollComplete = __webpack_require__(347);
	
	var _EnrollComplete2 = _interopRequireDefault(_EnrollComplete);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var EnrollMobile = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EnrollMobile, _React$Component);
	
	  function EnrollMobile() {
	    _classCallCheck(this, EnrollMobile);
	
	    var _this2 = _possibleConstructorReturn(this, (EnrollMobile.__proto__ || Object.getPrototypeOf(EnrollMobile)).call(this));
	
	    _this2.ready = _this2.ready.bind(_this2);
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.complete = _this2.complete.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(EnrollMobile, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        step: 1,
	        ready: false,
	        idFront: null,
	        idBack: null,
	        headshot: null,
	        getUserMedia: true
	      };
	
	      // Check if getUserMedia is supported
	      this.testGetUserMedia();
	    }
	  }, {
	    key: 'testGetUserMedia',
	    value: function testGetUserMedia() {
	      var _this = this;
	
	      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
	        // Safari on iOS (as of the 11 release) claims to support
	        // getUserMedia but chokes the constraints for some reason
	        // so we need to test setting up a stream and catch any errors
	        var constraints = {
	          audio: false,
	          video: {
	            width: window.innerWidth,
	            height: window.innerHeight,
	            facingMode: this.props.camera
	          }
	        };
	
	        navigator.mediaDevices.getUserMedia(constraints).catch(function (error) {
	          // Basic setup threw an error, so it’s safe to assume
	          // there’s not actually any support for getUserMedia
	          _this.setState({
	            getUserMedia: false
	          });
	        });
	      } else {
	        // Definitely not supported
	        _this.setState({
	          getUserMedia: false
	        });
	      }
	    }
	  }, {
	    key: 'ready',
	    value: function ready() {
	      this.setState({
	        ready: true
	      });
	
	      var html = document.querySelector('html');
	      html.className += ' fullscreen';
	
	      var header = document.querySelector('.site-head--outside');
	      header.className += ' site-head--fullscreen';
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep() {
	      this.setState({
	        step: this.state.step + 1,
	        ready: false
	      });
	
	      var html = document.querySelector('html');
	      html.className = html.className.replace('fullscreen', '');
	
	      var header = document.querySelector('.site-head--outside');
	      header.className = header.className.replace('site-head--fullscreen', '');
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      this.setState({
	        step: 4
	      });
	
	      var html = document.querySelector('html');
	      html.className = html.className.replace('fullscreen', '');
	
	      var header = document.querySelector('.site-head--outside');
	      header.className = header.className.replace('site-head--fullscreen', '');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      if (this.state.getUserMedia && this.state.step !== 4) {
	        // If getUserMedia is supported, we can access the webcam and capture an image from that
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page--webcam' },
	          !this.state.ready && _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel--brief' },
	              this.state.step === 1 && _react2.default.createElement(
	                'div',
	                { className: 'copy-brief' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.id_front_heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.id_front
	                )
	              ),
	              this.state.step === 2 && _react2.default.createElement(
	                'div',
	                { className: 'copy-brief' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.id_back_heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.id_back
	                )
	              ),
	              this.state.step === 3 && _react2.default.createElement(
	                'div',
	                { className: 'copy-brief' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.headshot_heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.headshot
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--icn-right',
	                  onClick: this.ready
	                },
	                translation.continue,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              )
	            )
	          ),
	          this.state.step === 1 && this.state.ready && _react2.default.createElement(_Webcam2.default, Object.assign({
	            allowCapture: true,
	            name: 'idFront',
	            camera: 'environment',
	            type: 'landscape',
	            parent: this,
	            callback: this.nextStep,
	            caption: translation.id_front_heading
	          }, this.props)),
	          this.state.step === 2 && this.state.ready && _react2.default.createElement(_Webcam2.default, Object.assign({
	            allowCapture: true,
	            name: 'idBack',
	            camera: 'environment',
	            type: 'landscape',
	            parent: this,
	            callback: this.nextStep,
	            caption: translation.id_back_heading
	          }, this.props)),
	          this.state.step === 3 && this.state.ready && _react2.default.createElement(_Webcam2.default, Object.assign({
	            allowCapture: true,
	            name: 'headshot',
	            camera: 'user',
	            type: 'portrait',
	            parent: this,
	            callback: this.complete,
	            caption: translation.headshot_heading
	          }, this.props))
	        );
	      } else if (!this.state.getUserMedia && this.state.step !== 4) {
	        // Otherwise, we’ll fall back to standard file inputs
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page wrap' },
	          _react2.default.createElement(_EnrollPC2.default, Object.assign({
	            isMobile: true,
	            complete: this.props.complete
	          }, this.props))
	        );
	      } else if (this.state.step === 4) {
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page wrap' },
	          _react2.default.createElement(_EnrollComplete2.default, this.props)
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return EnrollMobile;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EnrollMobile')(EnrollMobile);

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var EnrollPhone = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EnrollPhone, _React$Component);
	
	  function EnrollPhone() {
	    _classCallCheck(this, EnrollPhone);
	
	    var _this = _possibleConstructorReturn(this, (EnrollPhone.__proto__ || Object.getPrototypeOf(EnrollPhone)).call(this));
	
	    _this.handlePC = _this.handlePC.bind(_this);
	    return _this;
	  }
	
	  _createClass(EnrollPhone, [{
	    key: 'handlePC',
	    value: function handlePC(e) {
	      var _this2 = this;
	
	      var callback = function callback(e) {
	        _this2.props.setStep(e, 4);
	      };
	
	      this.props.store.SmarterIDStore.createSIDEnrollment(callback);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel panel--brief ' + this.props.isActive },
	        _react2.default.createElement(
	          'h1',
	          { className: 'panel__title' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.body
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          translation.phone_requirements.map(function (requirement, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              requirement
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'actions panel__actions' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn actions__btn', onClick: function onClick(e) {
	                _this3.props.setStep(e, 3);
	              } },
	            translation.yes
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn--outline actions__btn', onClick: function onClick(e) {
	                _this3.handlePC(e);
	              } },
	            translation.no
	          )
	        )
	      );
	    }
	  }]);
	
	  return EnrollPhone;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EnrollPhone')(EnrollPhone);

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var EnrollSMS = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EnrollSMS, _React$Component);
	
	  function EnrollSMS() {
	    _classCallCheck(this, EnrollSMS);
	
	    var _this2 = _possibleConstructorReturn(this, (EnrollSMS.__proto__ || Object.getPrototypeOf(EnrollSMS)).call(this));
	
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.advance = _this2.advance.bind(_this2);
	    _this2.back = _this2.back.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(EnrollSMS, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        phone: null,
	        smsStep: 1,
	        photoCount: 0
	      };
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(e) {
	      this.setState({
	        phone: e
	      });
	
	      this.props.store.SmarterIDStore.updateEnrollment(e, 'mobileNumber');
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var SmarterIDStore = this.props.store.SmarterIDStore;
	
	
	      SmarterIDStore.createSIDEnrollment(this.advance);
	
	      // Set an interval to check when the photos have been uploaded
	      var _this = this;
	
	      var checkPhotos = setInterval(function () {
	        if (_this.state.photoCount > 0 && _this.state.smsStep !== 3) {
	          _this.advance();
	        } else if (SmarterIDStore.enrollment.status && SmarterIDStore.enrollment.status.toLowerCase() === 'active') {
	          clearInterval(checkPhotos);
	          _this.props.setStep(null, 5);
	          _this.props.setDisplayStep(3);
	        } else {
	          SmarterIDStore.getSIDEnrollment();
	        }
	      }, 5000);
	    }
	  }, {
	    key: 'advance',
	    value: function advance() {
	      this.setState({
	        smsStep: this.state.smsStep + 1
	      });
	    }
	  }, {
	    key: 'smsStepActive',
	    value: function smsStepActive(step) {
	      if (this.state.smsStep === step) {
	        return 'fade-active';
	      } else {
	        return 'fade-hidden';
	      }
	    }
	  }, {
	    key: 'back',
	    value: function back() {
	      this.setState({
	        smsStep: 1
	      });
	    }
	  }, {
	    key: 'handlePC',
	    value: function handlePC(e) {
	      var _this3 = this;
	
	      var callback = function callback(e) {
	        _this3.props.setStep(e, 4);
	      };
	
	      this.props.store.SmarterIDStore.createSIDEnrollment(callback);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var SmarterIDStore = this.props.store.SmarterIDStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel panel--brief ' + this.props.isActive },
	        _react2.default.createElement(
	          'section',
	          { className: this.smsStepActive(1) },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.body
	          ),
	          _react2.default.createElement(
	            'form',
	            { className: 'form-brief enroll-sms', onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this4.handleSubmit, '.enroll-sms');
	              }, noValidate: true },
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'enroll-phone' },
	                  translation.label
	                ),
	                _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                  id: 'enroll-phone',
	                  nativeExpanded: true,
	                  flagsPath: './static/img/flags/',
	                  country: (0, _reactPhoneNumberInput.parsePhoneNumber)(this.state.phone).country || 'US',
	                  onChange: function onChange(e) {
	                    _this4.handleInput(e, 'phone');
	                  },
	                  'aria-invalid': !(0, _reactPhoneNumberInput.isValidPhoneNumber)(this.state.phone),
	                  required: true,
	                  disabled: this.props.isActive === 'slide-active' ? null : true
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn--icn-right next', disabled: this.props.isActive === 'slide-active' ? null : true },
	              translation.button,
	              _react2.default.createElement(icons.iconCircleRight, null)
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'preposition--vertical' },
	              translation.or
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--link',
	                type: 'button',
	                onClick: function onClick(e) {
	                  _this4.handlePC(e);
	                },
	                disabled: this.props.isActive === 'slide-active' ? null : true
	              },
	              translation.alternative
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: this.smsStepActive(2) },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.sent.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.sent.body
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'text-code' },
	            SmarterIDStore.links.enrollmentUrl
	          ),
	          _react2.default.createElement('img', { src: SmarterIDStore.links.qrCode, width: '150', alt: 'QR code' })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: this.smsStepActive(3) },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.processing.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.processing.body
	          )
	        )
	      );
	    }
	  }]);
	
	  return EnrollSMS;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EnrollSMS')(EnrollSMS);

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _UserSettings = __webpack_require__(221);
	
	var _UserSettings2 = _interopRequireDefault(_UserSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var EnrollSettings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EnrollSettings, _React$Component);
	
	  function EnrollSettings() {
	    _classCallCheck(this, EnrollSettings);
	
	    return _possibleConstructorReturn(this, (EnrollSettings.__proto__ || Object.getPrototypeOf(EnrollSettings)).apply(this, arguments));
	  }
	
	  _createClass(EnrollSettings, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.isActive },
	        _react2.default.createElement(_UserSettings2.default, Object.assign({
	          enrollment: true,
	          setStep: this.props.setStep,
	          setDisplayStep: this.props.setDisplayStep
	        }, this.props))
	      );
	    }
	  }]);
	
	  return EnrollSettings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EnrollSettings')(EnrollSettings);

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var EnrollValidate = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EnrollValidate, _React$Component);
	
	  function EnrollValidate() {
	    _classCallCheck(this, EnrollValidate);
	
	    var _this = _possibleConstructorReturn(this, (EnrollValidate.__proto__ || Object.getPrototypeOf(EnrollValidate)).call(this));
	
	    _this.handleRetry = _this.handleRetry.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    return _this;
	  }
	
	  _createClass(EnrollValidate, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.store.SmarterIDStore.validateEnrollment(this.complete);
	    }
	  }, {
	    key: 'handleRetry',
	    value: function handleRetry() {
	      var validationError = this.props.store.SmarterIDStore.validationError;
	
	      var step = 1;
	
	      if (validationError === '1213' || validationError === '1210') {
	        // confirm.io validation failed and user needs to upload new id photos
	        this.props.parent.setState({
	          acceptedPhotos: [],
	          headshot: null,
	          headshotUploaded: false,
	          idBack: null,
	          idBackUploaded: false,
	          idFront: null,
	          idFrontUploaded: false,
	          pendingPhotos: [],
	          uploadedPhotos: []
	        });
	      } else if (validationError === '1214') {
	        // Facial match failed and user needs to upload new headshot
	        step = 3;
	
	        this.props.parent.setState({
	          acceptedPhotos: ['idFront', 'idBack'],
	          headshot: null,
	          headshotUploaded: false,
	          pendingPhotos: [],
	          uploadedPhotos: ['idFrontUploaded', 'idBackUploaded']
	        });
	      }
	
	      this.props.setPCStep(null, step);
	
	      this.props.parent.setState({
	        validating: false,
	        complete: false
	      });
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      this.props.setStep(null, 5);
	      this.props.setDisplayStep(3);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store$SmarterI = this.props.store.SmarterIDStore,
	          validationError = _props$store$SmarterI.validationError,
	          validationFailed = _props$store$SmarterI.validationFailed;
	
	
	      if (!validationFailed) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'panel panel--brief ' + this.props.isActive },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.body
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'loader--alt' },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              'Loading\u2026'
	            )
	          )
	        );
	      } else if (validationFailed && (validationError === '1213' || validationError === '1210' || validationError === '1214')) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'panel panel--brief ' + this.props.isActive },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation[validationError].heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation[validationError].body
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: this.handleRetry
	            },
	            translation.retake
	          )
	        );
	      } else if (validationFailed) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'panel panel--brief ' + this.props.isActive },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.error.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.error.body
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: this.handleRetry
	            },
	            translation.retake
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return EnrollValidate;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EnrollValidate')(EnrollValidate);

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Step = __webpack_require__(65);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _AudioRecorder = __webpack_require__(740);
	
	var _AudioRecorder2 = _interopRequireDefault(_AudioRecorder);
	
	var _UserSettings = __webpack_require__(221);
	
	var _UserSettings2 = _interopRequireDefault(_UserSettings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Dependencies
	
	
	// Translations
	
	
	// Components
	
	
	var LegacyEnrollment = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(LegacyEnrollment, _React$Component);
	
	  function LegacyEnrollment() {
	    _classCallCheck(this, LegacyEnrollment);
	
	    var _this2 = _possibleConstructorReturn(this, (LegacyEnrollment.__proto__ || Object.getPrototypeOf(LegacyEnrollment)).call(this));
	
	    _this2.setStep = _this2.setStep.bind(_this2);
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.prevStep = _this2.prevStep.bind(_this2);
	    _this2.toggleTextForm = _this2.toggleTextForm.bind(_this2);
	    _this2.startRecording = _this2.startRecording.bind(_this2);
	    _this2.setVoice = _this2.setVoice.bind(_this2);
	    _this2.removeVoice = _this2.removeVoice.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(LegacyEnrollment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        step: 1,
	        textPhone: null,
	        showTextForm: false,
	        textFormSent: false,
	        recordingSupport: navigator.getUserMedia,
	        voiceRecording: null,
	        hasRecorded: false,
	        showVoicePhone: false
	      };
	    }
	  }, {
	    key: 'handlePhoneInput',
	    value: function handlePhoneInput(e) {
	      this.setState({
	        textPhone: e
	      });
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      e.preventDefault();
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'toggleTextForm',
	    value: function toggleTextForm(e) {
	      e.preventDefault();
	      this.setState({
	        showTextForm: !this.state.showTextForm,
	        textFormSent: false
	      });
	    }
	  }, {
	    key: 'sendLink',
	    value: function sendLink(e) {
	      e.preventDefault();
	      this.setState({
	        textFormSent: true,
	        showTextForm: false
	      });
	
	      var _this = this;
	
	      setTimeout(function () {
	        _this.nextStep();
	      }, 5000);
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'startRecording',
	    value: function startRecording() {
	      this.setState({
	        hasRecorded: true
	      });
	    }
	  }, {
	    key: 'setVoice',
	    value: function setVoice(voiceRecording) {
	      this.setState({
	        voiceRecording: voiceRecording
	      });
	    }
	  }, {
	    key: 'removeVoice',
	    value: function removeVoice() {
	      this.setState({
	        voiceRecording: null,
	        hasRecorded: false
	      });
	    }
	  }, {
	    key: 'toggleVoicePhone',
	    value: function toggleVoicePhone(e) {
	      e.preventDefault();
	      this.setState({
	        showVoicePhone: !this.state.showVoicePhone
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	      var prod = false;
	      var steps = translation.steps;
	
	      if (true) {
	        prod = true;
	      }
	
	      if (prod) {
	        steps = ["Welcome", "Settings"];
	      }
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page--brief' },
	          _react2.default.createElement(_Step2.default, { step: this.state.step, setStep: this.setStep, data: steps, skippable: false })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'slide-wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief ' + this.isActive(1) },
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation.welcome.heading
	            ),
	            prod && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.welcome.body) } }),
	            !prod && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.welcome_sid.body) } }),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn--icn-right next', onClick: function onClick(e) {
	                  _this3.nextStep(e);
	                } },
	              translation.welcome.button,
	              _react2.default.createElement(icons.iconCircleRight, null)
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { id: '#id-settings', className: '' + this.isActive(2) },
	            _react2.default.createElement(_UserSettings2.default, Object.assign({ enrollment: true, nextStep: this.nextStep }, this.props))
	          ),
	          !prod && _react2.default.createElement(
	            'section',
	            { id: '#id-options', className: 'panel panel--brief ' + this.isActive(3) },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.photo_id.heading
	            ),
	            !this.state.showTextForm && !this.state.textFormSent && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h5',
	                null,
	                translation.photo_id.sub_heading
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'btn', href: '#text-form', onClick: function onClick(e) {
	                    _this3.toggleTextForm(e);
	                  } },
	                _react2.default.createElement(icons.iconCamera, null),
	                translation.photo_id.button
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition--vertical' },
	                translation.photo_id.or
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-file', htmlFor: 'enrollment-tel-upload' },
	                translation.photo_id.upload
	              ),
	              _react2.default.createElement('input', { type: 'file', id: 'enrollment-tel-upload' })
	            ),
	            this.state.showTextForm && !this.state.textFormSent && _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  _this3.sendLink(e);
	                } },
	              _react2.default.createElement(
	                'ul',
	                { id: 'text-form', className: 'fields' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-long', htmlFor: 'enrollment-tel' },
	                    translation.photo_id.phone.label
	                  ),
	                  _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                    id: 'enrollment-tel',
	                    country: 'US',
	                    nativeExpanded: true,
	                    flagsPath: './static/img/flags/',
	                    onChange: function onChange(e) {
	                      return _this3.handlePhoneInput(e);
	                    },
	                    ref: function ref(input) {
	                      _this3.photoPhone = input;
	                    },
	                    required: true,
	                    'aria-required': 'true',
	                    'aria-invalid': !(0, _reactPhoneNumberInput.isValidPhoneNumber)(this.state.textPhone)
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn', type: 'submit' },
	                _react2.default.createElement(icons.iconLink, null),
	                translation.photo_id.phone.submit
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'cancel', href: '#id-options', onClick: function onClick(e) {
	                    _this3.toggleTextForm(e);
	                  } },
	                translation.cancel
	              )
	            ),
	            this.state.textFormSent && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'action-response action-response--success' },
	                _react2.default.createElement(icons.iconCheck, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.photo_id.phone.success
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.photo_id.phone.success_body
	              ),
	              translation.photo_id.phone.resend_label,
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn--link', onClick: function onClick(e) {
	                    _this3.toggleTextForm(e);
	                  } },
	                translation.photo_id.phone.resend_button
	              ),
	              '.'
	            )
	          ),
	          !prod && _react2.default.createElement(
	            'section',
	            { id: 'voice-options', className: 'panel panel--brief ' + this.isActive(4) },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.voice.heading
	            ),
	            !this.state.hasRecorded && !this.state.showVoicePhone && _react2.default.createElement(
	              'h5',
	              null,
	              translation.voice.sub_heading
	            ),
	            this.state.recordingSupport && _react2.default.createElement(
	              'div',
	              null,
	              this.state.hasRecorded && !this.state.voiceRecording && _react2.default.createElement(
	                'div',
	                { className: 'recorder-passage' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  translation.voice.record.heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.voice.record.passage
	                )
	              ),
	              !this.state.showVoicePhone && _react2.default.createElement(_AudioRecorder2.default, Object.assign({ startRecording: this.startRecording, setRecording: this.setVoice, removeRecording: this.removeVoice }, this.props)),
	              !this.state.hasRecorded && !this.state.showVoicePhone && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'preposition--vertical' },
	                  translation.voice.or
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { href: '#phone-info', onClick: function onClick(e) {
	                      _this3.toggleVoicePhone(e);
	                    } },
	                  translation.voice.phone.button
	                )
	              )
	            ),
	            (this.state.showVoicePhone || !this.state.recordingSupport) && _react2.default.createElement(
	              'div',
	              { id: 'phone-info' },
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.voice.phone.instruction_start,
	                ' (800) 777-7777 ',
	                translation.voice.phone.instruction_end
	              ),
	              _react2.default.createElement(
	                'strong',
	                { className: 'text-code' },
	                'A47BC'
	              ),
	              this.state.recordingSupport && _react2.default.createElement(
	                'a',
	                { className: 'cancel', href: '#voice-options', onClick: function onClick(e) {
	                    _this3.toggleVoicePhone(e);
	                  } },
	                translation.cancel
	              )
	            ),
	            this.state.voiceRecording && _react2.default.createElement(
	              'a',
	              { className: 'btn btn--icn-right next', href: '#', onClick: function onClick(e) {
	                  _this3.nextStep(e);
	                } },
	              translation.continue,
	              _react2.default.createElement(icons.iconCircleRight, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LegacyEnrollment;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('LegacyEnrollment')(LegacyEnrollment);

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Step = __webpack_require__(65);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _EnrollIntro = __webpack_require__(768);
	
	var _EnrollIntro2 = _interopRequireDefault(_EnrollIntro);
	
	var _EnrollPhone = __webpack_require__(770);
	
	var _EnrollPhone2 = _interopRequireDefault(_EnrollPhone);
	
	var _EnrollSMS = __webpack_require__(771);
	
	var _EnrollSMS2 = _interopRequireDefault(_EnrollSMS);
	
	var _EnrollPC = __webpack_require__(348);
	
	var _EnrollPC2 = _interopRequireDefault(_EnrollPC);
	
	var _EnrollSettings = __webpack_require__(772);
	
	var _EnrollSettings2 = _interopRequireDefault(_EnrollSettings);
	
	var _EnrollComplete = __webpack_require__(347);
	
	var _EnrollComplete2 = _interopRequireDefault(_EnrollComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	// import Phone, { isValidPhoneNumber } from 'react-phone-number-input';
	
	// Components
	
	
	var StudentEnrollment = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(StudentEnrollment, _React$Component);
	
	  function StudentEnrollment() {
	    _classCallCheck(this, StudentEnrollment);
	
	    var _this = _possibleConstructorReturn(this, (StudentEnrollment.__proto__ || Object.getPrototypeOf(StudentEnrollment)).call(this));
	
	    _this.setStep = _this.setStep.bind(_this);
	    _this.nextStep = _this.nextStep.bind(_this);
	    _this.prevStep = _this.prevStep.bind(_this);
	    _this.setDisplayStep = _this.setDisplayStep.bind(_this);
	    return _this;
	  }
	
	  _createClass(StudentEnrollment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        step: 1,
	        displayStep: 1,
	        textPhone: null,
	        showTextForm: false,
	        textFormSent: false,
	        recordingSupport: navigator.getUserMedia,
	        voiceRecording: null,
	        hasRecorded: false,
	        showVoicePhone: false
	      };
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'setDisplayStep',
	    value: function setDisplayStep(displayStep) {
	      this.setState({
	        displayStep: displayStep
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	      var steps = translation.steps;
	
	      if (this.props.smarterID) {
	        steps = translation.sid_steps;
	      }
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'page--brief' },
	          _react2.default.createElement(_Step2.default, { step: this.state.displayStep, setStep: this.setStep, data: steps, skippable: false })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'slide-wrap' },
	          _react2.default.createElement(_EnrollIntro2.default, Object.assign({}, this.props, {
	            isActive: this.isActive(1),
	            nextStep: this.nextStep,
	            setStep: this.setStep,
	            setDisplayStep: this.setDisplayStep
	          })),
	          _react2.default.createElement(_EnrollPhone2.default, Object.assign({}, this.props, {
	            isActive: this.isActive(2),
	            setStep: this.setStep,
	            setDisplayStep: this.setDisplayStep
	          })),
	          _react2.default.createElement(_EnrollSMS2.default, Object.assign({}, this.props, {
	            isActive: this.isActive(3),
	            setStep: this.setStep,
	            setDisplayStep: this.setDisplayStep
	          })),
	          _react2.default.createElement(_EnrollPC2.default, Object.assign({}, this.props, {
	            isActive: this.isActive(4),
	            setStep: this.setStep,
	            setDisplayStep: this.setDisplayStep
	          })),
	          _react2.default.createElement(_EnrollSettings2.default, Object.assign({}, this.props, {
	            isActive: this.isActive(5),
	            setStep: this.setStep,
	            setDisplayStep: this.setDisplayStep
	          })),
	          _react2.default.createElement(_EnrollComplete2.default, Object.assign({}, this.props, {
	            isActive: this.isActive(6)
	          }))
	        )
	      );
	    }
	  }]);
	
	  return StudentEnrollment;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('StudentEnrollment')(StudentEnrollment);

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(15);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _ExamStatus = __webpack_require__(778);
	
	var _ExamStatus2 = _interopRequireDefault(_ExamStatus);
	
	var _StudentStatus = __webpack_require__(364);
	
	var _StudentStatus2 = _interopRequireDefault(_StudentStatus);
	
	var _ExamDetails = __webpack_require__(79);
	
	var _ExamDetails2 = _interopRequireDefault(_ExamDetails);
	
	var _ExamDetailedInfo = __webpack_require__(357);
	
	var _ExamDetailedInfo2 = _interopRequireDefault(_ExamDetailedInfo);
	
	var _ExamFlags = __webpack_require__(777);
	
	var _ExamFlags2 = _interopRequireDefault(_ExamFlags);
	
	var _ExamAttachmentsList = __webpack_require__(218);
	
	var _ExamAttachmentsList2 = _interopRequireDefault(_ExamAttachmentsList);
	
	var _StudentOverview = __webpack_require__(808);
	
	var _StudentOverview2 = _interopRequireDefault(_StudentOverview);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExamDashboard = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamDashboard, _React$Component);
	
	  function ExamDashboard() {
	    _classCallCheck(this, ExamDashboard);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (ExamDashboard.__proto__ || Object.getPrototypeOf(ExamDashboard)).call(this));
	
	    _this2.getExam = _this2.getExam.bind(_this2);
	    _this2.syncExam = _this2.syncExam.bind(_this2);
	    _this2.getEnrollments = _this2.getEnrollments.bind(_this2);
	    _this2.getExamFlags = _this2.getExamFlags.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ExamDashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var role = this.props.store.SessionStore.userData.role;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (role.toLowerCase() === 'learner') {
	        this.props.routing.push({
	          pathname: 'unauthorized'
	        });
	      }
	
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        fundingRuleSid: null,
	        enrollmentName: null,
	        location: null,
	        sessionSid: null,
	        userSid: null,
	        changeRequest: false,
	        readonly: false,
	        scheduled: false,
	        crossListed: false,
	        parentSchool: null
	
	        // Get exam sid from URL
	      };var examSid = (0, _helpers.getURLSegment)(this, 2);
	
	      // Get data with the exam sid
	      this.getExam(examSid);
	      this.getEnrollments(examSid);
	      this.getExamFlags(examSid);
	
	      // Make sure we have a list of proctor types
	      SessionStore.getProctorTypes();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var history = this.props.routing.history;
	      var _props$routing$locati = this.props.routing.location,
	          pathname = _props$routing$locati.pathname,
	          query = _props$routing$locati.query;
	      var SessionStore = this.props.store.SessionStore;
	      var translation = this.props.translation;
	
	      // Check if we should display a success message
	
	      if (query.toaster === 'examSaved') {
	        history.push({
	          pathname: pathname,
	          search: null
	        });
	        SessionStore.showToaster(translation.exam_saved, 'success');
	      }
	    }
	  }, {
	    key: 'getExam',
	    value: function getExam(sid) {
	      this.props.store.ExamStore.getExam(sid);
	    }
	  }, {
	    key: 'getEnrollments',
	    value: function getEnrollments(sid) {
	      this.props.store.ExamStore.getEnrollments(sid);
	    }
	  }, {
	    key: 'getExamFlags',
	    value: function getExamFlags(sid) {
	      this.props.store.ExamStore.getExamFlags(sid);
	    }
	  }, {
	    key: 'syncExam',
	    value: function syncExam() {
	      var _this = this;
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore,
	          SyncStore = _props$store.SyncStore;
	      var sid = ExamStore.exam.sid;
	
	
	      var data = {
	        type: 'exams',
	        sid: sid
	      };
	
	      var callback = function callback() {
	        _this.getExam(sid);
	        SessionStore.showToaster(translation.sync_scheduled, 'success');
	      };
	
	      SyncStore.scheduleSync(data, callback);
	    }
	  }, {
	    key: 'deleteExam',
	    value: function deleteExam(exam) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          ExamStore = _props$store2.ExamStore,
	          SessionStore = _props$store2.SessionStore;
	
	
	      var msg = {
	        heading: translation.delete_confirm.heading,
	        body: translation.delete_confirm.body,
	        button: translation.delete_confirm.button
	      };
	
	      var callback = function callback() {
	        SessionStore.showToaster(translation.exam_deleted, 'success');
	        _this3.props.routing.push('/');
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return ExamStore.deleteExam(exam.sid, exam.courseSid, callback);
	      });
	    }
	  }, {
	    key: 'unlockExam',
	    value: function unlockExam(examSid, configurationSid) {
	      var _this4 = this;
	
	      var data = {
	        approved: true,
	        locked: false
	      };
	
	      var callback = function callback() {
	        return _this4.getExam(examSid);
	      };
	
	      this.props.store.ExamStore.updateConfigurationStatus(examSid, configurationSid, data, callback);
	    }
	  }, {
	    key: 'lockExam',
	    value: function lockExam(examSid, configurationSid) {
	      var _this5 = this;
	
	      var data = {
	        approved: true,
	        locked: true
	      };
	
	      var callback = function callback() {
	        return _this5.getExam(examSid);
	      };
	
	      this.props.store.ExamStore.updateConfigurationStatus(examSid, configurationSid, data, callback);
	    }
	  }, {
	    key: 'initChangeRequest',
	    value: function initChangeRequest(configurationSid) {
	      var drawerContent = 'ExamException';
	
	      this.setState({
	        drawerContent: drawerContent,
	        defaultConfigSid: configurationSid,
	        changeRequest: true
	      });
	
	      (0, _helpers.toggleDrawer)(null, this, drawerContent);
	    }
	  }, {
	    key: 'editChangeRequest',
	    value: function editChangeRequest(changeRequestSid) {
	      var pathname = this.props.routing.location.pathname;
	
	      var drawerContent = 'EditExamException';
	
	      // Edit an accommodation
	      pathname += '?changeRequest=' + changeRequestSid;
	      this.props.routing.push(pathname);
	
	      this.setState({
	        drawerContent: drawerContent,
	        configurationSid: changeRequestSid,
	        changeRequest: true
	      });
	
	      (0, _helpers.toggleDrawer)(null, this, drawerContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props$store3 = this.props.store,
	          SessionStore = _props$store3.SessionStore,
	          SettingsStore = _props$store3.SettingsStore;
	      var translation = this.props.translation;
	      var ExamStore = this.props.store.ExamStore;
	      var exam = ExamStore.exam,
	          examEnrollments = ExamStore.examEnrollments,
	          examFlags = ExamStore.examFlags;
	      var _exam$configuration = exam.configuration,
	          apiExamId = _exam$configuration.apiExamId,
	          synchronization = _exam$configuration.synchronization;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      var scheduleCloseDate = exam.configuration.scheduleCloseDate;
	
	      var flags = (0, _mobx.toJS)(examFlags);
	
	      if ((0, _moment2.default)(scheduleCloseDate).local().format('M-D-YYYY') === '1-1-2070') {
	        // If there’s no scheduling window set, use the exam close date
	        scheduleCloseDate = exam.configuration.examCloseDate;
	      }
	
	      if (typeof exam !== 'undefined' && typeof exam.sid !== 'undefined') {
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'page__title' },
	                exam.title
	              ),
	              _react2.default.createElement(
	                SessionStore.validater,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'page__actions actions' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                      iamAction: 'sp:DescribeFundingRules',
	                      iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':funding',
	                      className: 'btn--outline',
	                      to: (0, _helpers.getURLSegment)(this, 1) + '/' + (0, _helpers.getURLSegment)(this, 2) + '?fundingRuleScope=examSid&scopeSid=' + exam.sid,
	                      onClick: function onClick() {
	                        (0, _helpers.toggleDrawer)(null, _this6, 'FundingRules');
	                      }
	                    },
	                    translation.funding_rules
	                  ),
	                  !exam.configuration.locked && _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                      iamAction: 'sp:ModifyExam',
	                      iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':course/' + SessionStore.userData.courseSid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam/' + exam.sid],
	                      to: 'exams/edit/' + exam.sid,
	                      className: 'actions__btn actions__btn--secondary'
	                    },
	                    _react2.default.createElement(icons.iconEdit, null),
	                    translation.edit_exam_button
	                  ),
	                  exam.configuration.locked && SessionStore.userData.role.toLowerCase() !== 'administrator' && !exam.configuration.referenceExamConfigurationSid && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--secondary',
	                      onClick: function onClick() {
	                        _this6.initChangeRequest(exam.configuration.sid);
	                      }
	                    },
	                    _react2.default.createElement(icons.iconEdit, null),
	                    translation.change_request_button
	                  ),
	                  !exam.configuration.locked && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn--outline btn--negative',
	                      onClick: function onClick() {
	                        return _this6.deleteExam(exam);
	                      }
	                    },
	                    _react2.default.createElement(icons.iconTrash, null),
	                    translation.delete_exam_button
	                  ),
	                  exam.configuration.locked && SessionStore.userData.role.toLowerCase() === 'administrator' && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--secondary',
	                      onClick: function onClick() {
	                        _this6.unlockExam(exam.sid, exam.configuration.sid);
	                      }
	                    },
	                    _react2.default.createElement(icons.iconUnlock, null),
	                    translation.unlock
	                  ),
	                  !exam.configuration.locked && SessionStore.userData.role.toLowerCase() === 'administrator' && SettingsStore.settings.requireManagerExamApproval && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--secondary',
	                      onClick: function onClick() {
	                        _this6.lockExam(exam.sid, exam.configuration.sid);
	                      }
	                    },
	                    _react2.default.createElement(icons.iconLock, null),
	                    translation.lock
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'page__data' },
	              apiExamId && synchronization && synchronization.exam && _react2.default.createElement(
	                'div',
	                { className: 'box box--right' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'title' },
	                    translation.last_sync,
	                    ':\xA0',
	                    !synchronization.exam.lastRun && translation.never,
	                    synchronization.exam.lastRun && _moment2.default.utc(synchronization.exam.lastRun).local().tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  synchronization.exam.nextRun && _react2.default.createElement(
	                    'span',
	                    { className: 'title' },
	                    translation.next_sync,
	                    ':\xA0',
	                    _moment2.default.utc(synchronization.exam.nextRun).local().tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn--link',
	                      onClick: this.syncExam
	                    },
	                    translation.sync_now
	                  )
	                )
	              )
	            ),
	            !exam.configuration.approved && _react2.default.createElement(
	              'div',
	              { className: 'cta cta--negative' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'cta__copy' },
	                translation.pending_cta.heading
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'cta__subcopy' },
	                translation.pending_cta.body
	              )
	            ),
	            exam.configuration.referenceExamConfigurationSid && _react2.default.createElement(
	              'div',
	              { className: 'cta cta--negative' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'cta__copy' },
	                translation.request_pending_cta.heading
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'cta__subcopy' },
	                translation.request_pending_cta.body
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'cta__btn btn--outline btn--negative',
	                  onClick: function onClick() {
	                    _this6.editChangeRequest(exam.configuration.referenceExamConfigurationSid);
	                  }
	                },
	                translation.request_pending_cta.button
	              )
	            ),
	            _react2.default.createElement(_ExamStatus2.default, Object.assign({
	              parent: this,
	              locked: exam.configuration.locked,
	              incidents: exam.openSessionEvents,
	              pending: exam.pendingApprovals,
	              flags: flags.timesOccurred
	            }, this.props)),
	            _react2.default.createElement(
	              'article',
	              { className: 'panel' },
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__body' },
	                _react2.default.createElement(_StudentStatus2.default, Object.assign({ summary: exam.summary, i: 0, limitedScope: exam.isLimitedScope }, this.props)),
	                _react2.default.createElement(_ExamDetails2.default, Object.assign({
	                  parent: this,
	                  examDashboard: true,
	                  exam: exam,
	                  scheduleWindow: true,
	                  scheduleCloseDate: scheduleCloseDate
	                }, this.props)),
	                _react2.default.createElement(_ExamAttachmentsList2.default, Object.assign({
	                  parent: this,
	                  examDashboard: true
	                }, this.props, {
	                  exam: exam
	                })),
	                _react2.default.createElement(_ExamDetailedInfo2.default, Object.assign({}, this.props, {
	                  exam: exam
	                })),
	                flags && flags.timesOccurred > 0 && _react2.default.createElement(_ExamFlags2.default, Object.assign({}, this.props, {
	                  parent: this,
	                  flags: flags
	                })),
	                SessionStore.loadingCalls.indexOf('ExamEnrollments') < 0 && _react2.default.createElement(_StudentOverview2.default, Object.assign({
	                  parent: this
	                }, this.props, {
	                  exam: exam,
	                  examEnrollments: examEnrollments,
	                  configurationSid: exam.configuration.sid,
	                  getExam: this.getExam
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(_Drawer2.default, Object.assign({
	            content: this.state.drawerContent,
	            isOpen: this.state.drawerOpen,
	            parent: this,
	            getExam: this.getExam,
	            getEnrollments: this.getEnrollments,
	            exam: exam,
	            fundingRuleSid: this.state.fundingRuleSid,
	            preserveDrawer: true,
	            enrollmentName: this.state.enrollmentName,
	            searchForStudent: true,
	            location: this.state.location,
	            sessionSid: this.state.sessionSid,
	            closePath: (0, _helpers.getURLSegment)(this, 1) + '/' + (0, _helpers.getURLSegment)(this, 2),
	            toUserSid: this.state.userSid,
	            examSid: exam.sid,
	            examConfigurationSid: this.state.configurationSid,
	            defaultConfigSid: this.state.defaultConfigSid,
	            changeRequest: this.state.changeRequest,
	            contextType: 'examSid',
	            contextId: exam.sid,
	            preventReload: true,
	            readonly: this.state.readonly,
	            scheduled: this.state.scheduled,
	            crossListed: this.state.crossListed,
	            parentSchool: this.state.parentSchool,
	            workflowModule: this.state.workflowModule
	          }, this.props))
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ExamDashboard;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamDashboard')(ExamDashboard);

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// helpers
	
	
	var ExamFlags = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamFlags, _React$Component);
	
	  function ExamFlags() {
	    _classCallCheck(this, ExamFlags);
	
	    var _this = _possibleConstructorReturn(this, (ExamFlags.__proto__ || Object.getPrototypeOf(ExamFlags)).call(this));
	
	    _this.toggle = function () {
	      _this.setState({
	        expanded: !_this.state.expanded
	      });
	    };
	
	    _this.state = {
	      expanded: false
	    };
	    return _this;
	  }
	
	  _createClass(ExamFlags, [{
	    key: 'showSession',
	    value: function showSession(e, student) {
	      var pathname = this.props.routing.location.pathname;
	
	
	      (0, _helpers.toggleDrawer)(e, this.props.parent, 'SessionDetail');
	
	      pathname += '?session=' + student.sessionSid;
	      this.props.routing.push(pathname);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          translation = _props.translation,
	          flags = _props.flags;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      return _react2.default.createElement(
	        'section',
	        {
	          id: 'automated-flags-report',
	          className: 'panel__section',
	          tabIndex: '-1'
	        },
	        _react2.default.createElement(
	          'h2',
	          {
	            className: 'panel__heading panel__heading--expand',
	            onClick: this.toggle
	          },
	          translation.heading,
	          _react2.default.createElement(
	            'button',
	            {
	              id: 'automated-flags-report-control',
	              className: '\n              btn--expand\n              ' + (this.state.expanded ? 'expanded' : '') + '\n            ',
	              onClick: this.toggle,
	              'aria-controls': 'automated-flags-report-container',
	              'aria-expanded': this.state.expanded
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.view_details
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            id: 'automated-flags-report-container',
	            className: this.state.expanded ? 'expanded' : 'collapsed'
	          },
	          flags.students.length > 0 && _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'caption',
	              { className: 'meta' },
	              translation.heading
	            ),
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle column-studentName', scope: 'col' },
	                  translation.headings.studentName
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle column-dateSessionClosed', scope: 'col' },
	                  translation.headings.dateClosed
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle column-flags', scope: 'col' },
	                  translation.headings.flags
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle column-flagDetails', scope: 'col' },
	                  translation.headings.flagDetails
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { className: 'subtitle column-action', scope: 'col' },
	                  translation.headings.action
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              flags.students.map(function (row, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: i },
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'column-studentName' },
	                    row.studentName
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'column-dateSessionClosed' },
	                    _moment2.default.utc(row.dateSessionClosed).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'column-flags' },
	                    row.timesOccurred
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'column-flagDetails' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'simple-list' },
	                      row.annotations.map(function (ev, j) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: j },
	                          ev.annotationName + ': ' + ev.timesOccurred
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'actions' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn--outline', onClick: function onClick(e) {
	                          return _this2.showSession(e, row);
	                        } },
	                      translation.show_session
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExamFlags;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamFlags')(ExamFlags);

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExamStatus = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamStatus, _React$Component);
	
	  function ExamStatus() {
	    _classCallCheck(this, ExamStatus);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (ExamStatus.__proto__ || Object.getPrototypeOf(ExamStatus)).call(this));
	
	    _this.openEventsDrawer = _this.openEventsDrawer.bind(_this);
	    _this.renderProctorApprovals = _this.renderProctorApprovals.bind(_this);
	    _this.skipToFlags = _this.skipToFlags.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExamStatus, [{
	    key: 'openEventsDrawer',
	    value: function openEventsDrawer(e) {
	      (0, _helpers.toggleDrawer)(e, this.props.parent, 'IncidentReport');
	
	      var pathname = this.props.routing.location.pathname;
	
	      // Get the exam sid from the URL
	
	      var examSid = (0, _helpers.getURLSegment)(this, 2);
	      pathname += '?eventsFor=' + examSid;
	      this.props.routing.push(pathname);
	    }
	  }, {
	    key: 'renderProctorApprovals',
	    value: function renderProctorApprovals() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'card card--positive' },
	        _react2.default.createElement(icons.iconUsers, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'card__content' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'card__heading' },
	            this.props.pending,
	            ' ',
	            translation.proctors_heading
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'card__btn', href: '#ApproveProctor', onClick: function onClick(e) {
	                (0, _helpers.toggleDrawer)(e, _this2.props.parent, 'ApproveProctor');
	              } },
	            _react2.default.createElement(icons.iconCheck, null),
	            translation.review_button
	          )
	        )
	      );
	    }
	  }, {
	    key: 'skipToFlags',
	    value: function skipToFlags(e) {
	      e.preventDefault();
	
	      var content = document.getElementById('automated-flags-report');
	
	      if (content) {
	        (0, _helpers.scrollToTop)(e, content);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props = this.props,
	          incidents = _props.incidents,
	          locked = _props.locked,
	          pending = _props.pending,
	          flags = _props.flags;
	
	
	      incidents = parseInt(incidents, 10);
	      pending = parseInt(pending, 10);
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'card-list' },
	        locked && _react2.default.createElement(
	          'li',
	          { className: 'card' },
	          _react2.default.createElement(icons.iconLock, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'card__content' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'card__heading' },
	              translation.locked.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'card__body' },
	              translation.locked.body
	            )
	          )
	        ),
	        pending > 0 && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	          flagKey: 'instructor-proctor-approval',
	          renderFeatureCallback: this.renderProctorApprovals
	        }),
	        incidents > 0 && _react2.default.createElement(
	          'li',
	          { className: 'card card--warning' },
	          _react2.default.createElement(icons.iconExclamation, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'card__content' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'card__heading' },
	              this.props.incidents,
	              incidents > 1 && _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                translation.incidents_heading
	              ),
	              incidents === 1 && _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                translation.incidents_heading_singular
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'card__btn',
	                onClick: function onClick(e) {
	                  _this3.openEventsDrawer(e);
	                }
	              },
	              _react2.default.createElement(icons.iconCheck, null),
	              translation.review_button
	            )
	          )
	        ),
	        flags > 0 && _react2.default.createElement(
	          'li',
	          { className: 'card card--warning' },
	          _react2.default.createElement(icons.iconExclamation, null),
	          _react2.default.createElement(
	            'div',
	            { className: 'card__content' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'card__heading' },
	              this.props.flags,
	              flags > 1 && _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                translation.flags_heading
	              ),
	              flags === 1 && _react2.default.createElement(
	                'span',
	                null,
	                ' ',
	                translation.flags_heading_singular
	              )
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '#', onClick: this.skipToFlags },
	              translation.review_flags
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExamStatus;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamStatus')(ExamStatus);

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Config
	
	
	// Translations
	
	
	// Components
	
	
	var AutomatedSettings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AutomatedSettings, _React$Component);
	
	  function AutomatedSettings() {
	    _classCallCheck(this, AutomatedSettings);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (AutomatedSettings.__proto__ || Object.getPrototypeOf(AutomatedSettings)).call(this));
	
	    _this.selectDefault = _this.selectDefault.bind(_this);
	    _this.selectPreset = _this.selectPreset.bind(_this);
	    _this.renderOption = _this.renderOption.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      options: [],
	      preset: ''
	    };
	    return _this;
	  }
	
	  _createClass(AutomatedSettings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ExamStore = this.props.store.ExamStore;
	      var _props = this.props,
	          categorySid = _props.categorySid,
	          exam = _props.exam;
	      var configuration = ExamStore.configuration;
	
	
	      if (!configuration) {
	        configuration = exam.configuration;
	      }
	
	      // If this is a new exam, default to strict
	      if (exam.sid) {
	        ExamStore.getModalityPresets();
	      } else {
	        ExamStore.getModalityPresets(this.selectDefault);
	      }
	
	      if (categorySid) {
	        ExamStore.getAutomatedOptions(categorySid);
	      }
	
	      // Pre-check any selected modality options
	      if (configuration && configuration.modalityOptions && Object.keys(configuration.modalityOptions).length) {
	        var options = [];
	
	        // Loops through all proctorTypes selected and applies the modality options to each proctor type
	        Object.keys(configuration.modalityOptions).forEach(function (proctorTypeSid) {
	          Object.keys(configuration.modalityOptions[proctorTypeSid]).forEach(function (option) {
	            if (proctorTypeSid === categorySid) {
	              options.push(option);
	            }
	          });
	        });
	
	        this.setState({
	          options: options
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props,
	          handleInput = _props2.handleInput,
	          categorySid = _props2.categorySid;
	      var options = this.state.options;
	
	      if (this.state.options !== prevState.options) {
	        var modalityOptions = {
	          recordScreen: {},
	          recordWebcam: {},
	          recordAudio: {}
	        };
	
	        options.forEach(function (option) {
	          modalityOptions[option] = {};
	        });
	
	        handleInput('modalityOptions', null, true, null, null, false, modalityOptions, null, categorySid);
	      }
	    }
	  }, {
	    key: 'renderOptionIcon',
	    value: function renderOptionIcon(id) {
	      var icon = null;
	
	      switch (id) {
	        case 'recordWebcam':
	          icon = _react2.default.createElement(icons.iconVideoCamera, null);
	          break;
	
	        case 'recordScreen':
	          icon = _react2.default.createElement(icons.iconDesktopRecord, null);
	          break;
	
	        case 'recordAudio':
	          icon = _react2.default.createElement(icons.iconMicrophone, null);
	          break;
	
	        case 'roomScan':
	          icon = _react2.default.createElement(icons.iconVideoCamera360, null);
	          break;
	
	        case 'forceFullScreen':
	          icon = _react2.default.createElement(icons.iconDesktopFullscreen, null);
	          break;
	
	        case 'onlyOneScreen':
	          icon = _react2.default.createElement(icons.iconDesktopOne, null);
	          break;
	
	        case 'closeOpenTabs':
	          icon = _react2.default.createElement(icons.iconTabsClose, null);
	          break;
	
	        case 'disableNewTabs':
	          icon = _react2.default.createElement(icons.iconTabsOne, null);
	          break;
	
	        case 'disablePrinting':
	          icon = _react2.default.createElement(icons.iconPrintDisable, null);
	          break;
	
	        case 'disableClipboard':
	          icon = _react2.default.createElement(icons.iconClipboardDisable, null);
	          break;
	
	        case 'disableRightClick':
	          icon = _react2.default.createElement(icons.iconRightClickDisable, null);
	          break;
	
	        case 'clearCache':
	          icon = _react2.default.createElement(icons.iconEraser, null);
	          break;
	
	        case 'verifyId':
	          icon = _react2.default.createElement(icons.iconID, null);
	          break;
	
	        case 'blockedExtensions':
	          icon = _react2.default.createElement(icons.iconExtensionBlock, null);
	          break;
	
	        case 'desktopAppCheck':
	          icon = _react2.default.createElement(icons.iconDesktopAppCheck, null);
	          break;
	
	        default:
	          break;
	      }
	
	      return icon;
	    }
	  }, {
	    key: 'selectDefault',
	    value: function selectDefault() {
	      var _this2 = this;
	
	      this.setState({
	        preset: _config.config.defaultAutomatedPreset
	      }, function () {
	        _this2.selectPreset();
	      });
	    }
	  }, {
	    key: 'selectPreset',
	    value: function selectPreset() {
	      var _this3 = this;
	
	      var ExamStore = this.props.store.ExamStore;
	
	      var presetSid = this.preset.value;
	      var options = [];
	
	      // Get the preset
	      var callback = function callback() {
	        if (ExamStore.modalityPreset && ExamStore.modalityPreset.optionGroups) {
	          ExamStore.modalityPreset.optionGroups.forEach(function (optionGroup) {
	            if (optionGroup.options) {
	              optionGroup.options.forEach(function (option) {
	                options.push(option.id);
	              });
	            }
	
	            _this3.setState({
	              options: options,
	              preset: presetSid
	            });
	          });
	        }
	      };
	
	      ExamStore.getModalityPreset(presetSid, callback);
	    }
	  }, {
	    key: 'toggleOption',
	    value: function toggleOption(option) {
	      var options = [].concat(_toConsumableArray(this.state.options));
	      var optionIndex = options.indexOf(option.id);
	
	      if (optionIndex === -1) {
	        // Add the option if it’s not selected
	        options.push(option.id);
	      } else {
	        // Otherwise, remove it
	        options.splice(optionIndex, 1);
	      }
	
	      this.setState({
	        options: options,
	        preset: ''
	      });
	    }
	
	    // Most of our feature flags use booleans but onboarding version
	    // returns a string of 'new' or 'old'. Because of this we have to render this
	    // feature flag slightly different than the others
	
	  }, {
	    key: 'shouldRenderOption',
	    value: function shouldRenderOption(version, option) {
	      if (version === 'old') {
	        return this.renderOption(option);
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderOptionGroup',
	    value: function renderOptionGroup(optionGroup) {
	      var _this4 = this;
	
	      return optionGroup.options.map(function (option) {
	        if (option.id === 'desktopAppCheck') {
	          return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'smarter-services-utility-app',
	            renderFeatureCallback: function renderFeatureCallback() {
	              return _this4.renderOption(option);
	            }
	          });
	        } else if (option.id === 'closeOpenTabs') {
	          return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'onboarding-version',
	            renderFeatureCallback: function renderFeatureCallback(version) {
	              return _this4.shouldRenderOption(version, option);
	            }
	          });
	        } else {
	          return _this4.renderOption(option);
	        }
	      });
	    }
	  }, {
	    key: 'renderOption',
	    value: function renderOption(option) {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	      var options = this.state.options;
	
	
	      return _react2.default.createElement(
	        'li',
	        {
	          key: option.id,
	          className: 'grid__cell block block--selectable' + (options.indexOf(option.id) > -1 ? ' selected' : '')
	        },
	        this.renderOptionIcon(option.id),
	        option.title,
	        options.indexOf(option.id) > -1 && _react2.default.createElement(
	          'i',
	          { className: 'block__check' },
	          _react2.default.createElement(icons.iconCheck, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            'selected'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'grid__select',
	            type: 'button',
	            onClick: function onClick() {
	              return _this5.toggleOption(option);
	            }
	          },
	          options.indexOf(option.id) > -1 && translation.options.deselect.replace('%option%', option.title),
	          options.indexOf(option.id) === -1 && translation.options.select.replace('%option%', option.title)
	        ),
	        _react2.default.createElement('span', { className: 'grid__select-focus' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props3 = this.props,
	          categorySid = _props3.categorySid,
	          translation = _props3.translation;
	      var ExamStore = this.props.store.ExamStore;
	      var automatedOptions = ExamStore.automatedOptions,
	          modalityPresets = ExamStore.modalityPresets;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'switch-list__settings text-block' },
	        _react2.default.createElement('input', {
	          className: 'inp-hidden',
	          type: 'text',
	          value: this.state.options.toString(),
	          onChange: null,
	          required: true,
	          'aria-required': 'true',
	          ref: function ref(input) {
	            return _this6.emptyGuard = input;
	          }
	        }),
	        this.state.options.length === 0 && _react2.default.createElement(
	          'span',
	          { className: 'note note--prominent note--error' },
	          translation.error_msg
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'meta' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-inline form-inline--alt' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: categorySid + '-preset' },
	            translation.presets.label
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'select form-inline__main' },
	            _react2.default.createElement(
	              'select',
	              {
	                id: categorySid + '-preset',
	                onChange: this.selectPreset,
	                ref: function ref(input) {
	                  return _this6.preset = input;
	                },
	                value: this.state.preset
	              },
	              _react2.default.createElement(
	                'option',
	                { value: '' },
	                translation.presets.custom
	              ),
	              modalityPresets.map(function (preset) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: preset.sid, value: preset.sid },
	                  preset.title
	                );
	              })
	            )
	          )
	        ),
	        automatedOptions.map(function (optionGroup) {
	          return optionGroup.title !== 'Recording Options' && _react2.default.createElement(
	            'section',
	            { key: optionGroup.sid },
	            _react2.default.createElement(
	              'strong',
	              { className: 'grid-separator' },
	              optionGroup.title
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'grid grid__sm' },
	              _this6.renderOptionGroup(optionGroup)
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return AutomatedSettings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AutomatedSettings')(AutomatedSettings);

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mobxReact = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(9);
	
	__webpack_require__(979);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Config
	
	
	// Translations
	
	
	// Components
	
	
	// Proctor Type SIDs for modalities that require camera and audio recording
	var VTC_SID = 'TS6d6011935f4646848ea4f7a29b4f61a5';
	var RR_SID = 'TS9531c6b112f145018dae3cd2a9f60c4c';
	var LIVE_SID = 'TS4b894875d26194988853e490dfb9bc41';
	var AUTOMATED_SID = 'TS63dda27a6ba54c218449b934b7bb1ba8';
	
	var AutomatedSettings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AutomatedSettings, _React$Component);
	
	  function AutomatedSettings() {
	    _classCallCheck(this, AutomatedSettings);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (AutomatedSettings.__proto__ || Object.getPrototypeOf(AutomatedSettings)).call(this));
	
	    _this.selectDefault = _this.selectDefault.bind(_this);
	    _this.selectPreset = _this.selectPreset.bind(_this);
	    _this.renderOption = _this.renderOption.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      options: [],
	      preset: ''
	    };
	    return _this;
	  }
	
	  _createClass(AutomatedSettings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ExamStore = this.props.store.ExamStore;
	      var _props = this.props,
	          categorySid = _props.categorySid,
	          exam = _props.exam;
	      var configuration = ExamStore.configuration;
	
	
	      if (!configuration) {
	        configuration = exam.configuration;
	      }
	
	      // If this is a new exam, default to strict
	      if (exam.sid) {
	        ExamStore.getModalityPresets();
	      } else {
	        ExamStore.getModalityPresets(this.selectDefault);
	      }
	
	      if (categorySid) {
	        ExamStore.getAutomatedOptions(categorySid);
	      }
	
	      var requiresRecording = categorySid === VTC_SID || categorySid === RR_SID || categorySid === LIVE_SID;
	
	      // Pre-check any selected modality options
	      if (configuration && configuration.modalityOptions && Object.keys(configuration.modalityOptions).length) {
	        var options = [];
	
	        // Loops through all proctorTypes selected and applies the modality options to each proctor type
	        Object.keys(configuration.modalityOptions).forEach(function (proctorTypeSid) {
	          Object.keys(configuration.modalityOptions[proctorTypeSid]).forEach(function (option) {
	            if (proctorTypeSid === categorySid) {
	              options.push(option);
	            }
	          });
	        });
	
	        // Force recordWebcam and recordAudio for VTC and R&R
	        if (requiresRecording) {
	          if (options.indexOf('recordWebcam') === -1) {
	            options.push('recordWebcam');
	          }
	          if (options.indexOf('recordAudio') === -1) {
	            options.push('recordAudio');
	          }
	        }
	
	        this.setState({
	          options: options
	        });
	      } else if (requiresRecording) {
	        // If no existing options but VTC or R&R is selected, ensure camera and audio are added
	        this.setState({
	          options: ['recordWebcam', 'recordAudio']
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props,
	          handleInput = _props2.handleInput,
	          categorySid = _props2.categorySid;
	      var options = this.state.options;
	
	      if (this.state.options !== prevState.options) {
	        // these are the options that are required...
	        var modalityOptions = {
	          recordScreen: {}
	        };
	
	        options.forEach(function (option) {
	          modalityOptions[option] = {};
	        });
	
	        handleInput('modalityOptions', null, true, null, null, false, modalityOptions, null, categorySid);
	      }
	    }
	  }, {
	    key: 'selectDefault',
	    value: function selectDefault() {
	      var _this2 = this;
	
	      this.setState({
	        preset: _config.config.defaultAutomatedPreset
	      }, function () {
	        _this2.selectPreset();
	      });
	    }
	  }, {
	    key: 'selectPreset',
	    value: function selectPreset() {
	      var _this3 = this;
	
	      var ExamStore = this.props.store.ExamStore;
	
	      var presetSid = this.preset.value;
	      var options = [];
	
	      // Get the preset
	      var callback = function callback() {
	        if (ExamStore.modalityPreset && ExamStore.modalityPreset.optionGroups) {
	          ExamStore.modalityPreset.optionGroups.forEach(function (optionGroup) {
	            if (optionGroup.options) {
	              optionGroup.options.forEach(function (option) {
	                options.push(option.id);
	              });
	            }
	
	            _this3.setState({
	              options: options,
	              preset: presetSid
	            });
	          });
	        }
	      };
	
	      ExamStore.getModalityPreset(presetSid, callback);
	    }
	  }, {
	    key: 'toggleOption',
	    value: function toggleOption(option) {
	      var _this4 = this;
	
	      var categorySid = this.props.categorySid;
	
	      var options = [].concat(_toConsumableArray(this.state.options));
	      var optionIndex = options.indexOf(option.id);
	
	      var requiresRecording = categorySid === VTC_SID || categorySid === RR_SID || categorySid === LIVE_SID;
	      var isAutomated = categorySid === AUTOMATED_SID;
	
	      // Prevent toggling recordWebcam and recordAudio for VTC, R&R, and Live
	      if (requiresRecording && (option.id === 'recordWebcam' || option.id === 'recordAudio')) {
	        return; // Don't allow toggling these options
	      }
	
	      // For Automated Proctoring: Check if trying to disable camera when dependent features are enabled
	      if (isAutomated && option.id === 'recordWebcam' && optionIndex > -1) {
	        var dependentFeatures = [{ id: 'verifyId', name: 'ID Verification' }, { id: 'roomScan', name: 'Room Scan' }].filter(function (feature) {
	          return options.indexOf(feature.id) > -1;
	        });
	
	        if (dependentFeatures.length > 0) {
	          var featureNames = dependentFeatures.map(function (f) {
	            return f.name;
	          }).join(' and ');
	          var featureIds = dependentFeatures.map(function (f) {
	            return f.id;
	          });
	          var buttonText = dependentFeatures.length > 1 ? 'Disable All' : 'Disable Both';
	
	          var SessionStore = this.props.store.SessionStore;
	
	          SessionStore.showConfirm({
	            heading: 'Camera Recording Required',
	            body: 'Disabling camera recording will also disable ' + featureNames + '.',
	            button: buttonText,
	            cancel: 'Cancel'
	          }, function () {
	            return _this4.handleDisableCameraWithDependencies(['recordWebcam', 'secondCamera'].concat(_toConsumableArray(featureIds)));
	          });
	          return;
	        }
	      }
	
	      if (optionIndex === -1) {
	        // Add the option if it's not selected
	        options.push(option.id);
	      } else {
	        // Otherwise, remove it
	        options.splice(optionIndex, 1);
	      }
	
	      // if recordWebcam is not selected, ensure that secondCamera is not selected
	      if (option.id === 'recordWebcam' && options.indexOf('secondCamera') > -1) {
	        options.splice(options.indexOf('secondCamera'), 1);
	      }
	
	      this.setState({
	        options: options,
	        preset: ''
	      });
	    }
	  }, {
	    key: 'handleDisableCameraWithDependencies',
	    value: function handleDisableCameraWithDependencies(optionsToRemove) {
	      var options = this.state.options.filter(function (option) {
	        return !optionsToRemove.includes(option);
	      });
	
	      this.setState({
	        options: options,
	        preset: ''
	      });
	
	      // Close the dialog
	      var SessionStore = this.props.store.SessionStore;
	
	      SessionStore.closeDialog();
	    }
	
	    // Most of our feature flags use booleans but onboarding version
	    // returns a string of 'new' or 'old'. Because of this we have to render this
	    // feature flag slightly different than the others
	
	  }, {
	    key: 'shouldRenderOption',
	    value: function shouldRenderOption(version, option) {
	      if (version === 'old') {
	        return this.renderOption(option);
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderOptionGroup',
	    value: function renderOptionGroup(optionGroup) {
	      var _this5 = this;
	
	      return optionGroup.options.map(function (option) {
	        if (option.id === 'desktopAppCheck') {
	          return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'smarter-services-utility-app',
	            renderFeatureCallback: function renderFeatureCallback() {
	              return _this5.renderOption(option);
	            }
	          });
	        } else if (option.id === 'secondCamera') {
	          return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'second-camera-modality-option',
	            renderFeatureCallback: function renderFeatureCallback(version) {
	              return _this5.renderOption(option);
	            }
	          });
	        } else if (option.id === 'roomScan') {
	          return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'onboarding-version',
	            renderFeatureCallback: function renderFeatureCallback(version) {
	              return _this5.renderOption(option);
	            }
	          });
	        } else if (option.id === 'closeOpenTabs') {
	          return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'onboarding-version',
	            renderFeatureCallback: function renderFeatureCallback(version) {
	              return _this5.shouldRenderOption(version, option);
	            }
	          });
	        } else if (option.id === 'recordScreen') {
	          return null;
	        } else {
	          return _this5.renderOption(option);
	        }
	      });
	    }
	  }, {
	    key: 'renderLockedOption',
	    value: function renderLockedOption(option, title, description, noticeMessage) {
	      var isSelected = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	      return _react2.default.createElement(
	        'li',
	        {
	          key: option.id,
	          className: 'grid__cell block block--selectable' + (isSelected ? ' selected' : ''),
	          style: { cursor: 'not-allowed' }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'modality_option' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modality_option__title' },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modality_option__description' },
	            description,
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'important_notice' },
	              noticeMessage
	            )
	          )
	        ),
	        isSelected ? _react2.default.createElement(
	          'i',
	          { className: 'block__check' },
	          _react2.default.createElement(icons.iconCheck, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            'selected'
	          )
	        ) : _react2.default.createElement(
	          'i',
	          { className: 'block__check unchecked' },
	          '\xA0'
	        ),
	        _react2.default.createElement('span', { className: 'grid__select-focus' })
	      );
	    }
	  }, {
	    key: 'renderOption',
	    value: function renderOption(option) {
	      var _this6 = this;
	
	      var _props3 = this.props,
	          translation = _props3.translation,
	          categorySid = _props3.categorySid;
	      var options = this.state.options;
	
	      // If recordWebcam is not selected (in options), then don't render secondCamera
	
	      if (option.id === 'secondCamera' && options.indexOf('recordWebcam') === -1) {
	        return null;
	      }
	
	      // Check if current modality requires camera/audio recording
	      var isVTC = categorySid === VTC_SID;
	      var isRR = categorySid === RR_SID;
	      var isLive = categorySid === LIVE_SID;
	      var isAutomated = categorySid === AUTOMATED_SID;
	      var requiresRecording = isVTC || isRR || isLive;
	
	      // Handle recordWebcam (Camera Recording) for VTC and R&R
	      if (option.id === 'recordWebcam' && requiresRecording) {
	        var modalityName = isVTC ? 'Virtual Test Center' : isLive ? 'Live Proctoring' : 'Automated with Review';
	        return this.renderLockedOption(option, option.title, option.description, 'Camera recording is required for ' + modalityName + '.');
	      }
	
	      // Handle recordAudio (Audio Recording) for VTC and R&R
	      if (option.id === 'recordAudio' && requiresRecording) {
	        var _modalityName = isVTC ? 'Virtual Test Center' : isLive ? 'Live Proctoring' : 'Automated with Review';
	        return this.renderLockedOption(option, option.title, option.description, 'Audio recording is required for ' + _modalityName + '.');
	      }
	
	      // output this for live or vtc session and the option is roomScan
	      if (option.id === 'roomScan' && [LIVE_SID, VTC_SID].includes(this.props.categorySid)) {
	        return this.renderLockedOption(option, 'Room Scan', 'If required by your institution, a live proctor will ask the test taker to perform a room or desk scan before or during the exam. Your institution\'s exam settings determine the type of scan and any additional requirements.', 'This setting cannot be changed at the exam level as it is an institution-wide setting.', true);
	      }
	
	      // output this for live or vtc session and the option is verifyId
	      if (option.id === 'verifyId' && [LIVE_SID, VTC_SID, RR_SID].includes(this.props.categorySid)) {
	        return this.renderLockedOption(option, 'Verify ID', 'If required by your institution, a live proctor will ask the test taker to present a photo ID for identity verification before or during the exam. Your institution\'s exam settings determine the type of scan and any additional requirements.', 'This setting cannot be changed at the exam level as it is an institution-wide setting.', true);
	      }
	
	      // For Automated Proctoring: Disable ID verification when camera is not enabled
	      if (option.id === 'verifyId' && isAutomated && options.indexOf('recordWebcam') === -1) {
	        return this.renderLockedOption(option, option.title, option.description, 'ID Verification requires camera recording to be enabled.', false);
	      }
	
	      // For Automated Proctoring: Disable Room Scan when camera is not enabled
	      if (option.id === 'roomScan' && isAutomated && options.indexOf('recordWebcam') === -1) {
	        return this.renderLockedOption(option, option.title, option.description, 'Room Scan requires camera recording to be enabled.', false);
	      }
	
	      // this is the default output...
	
	      return _react2.default.createElement(
	        'li',
	        {
	          key: option.id,
	          className: 'grid__cell block block--selectable' + (options.indexOf(option.id) > -1 ? ' selected' : '')
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'modality_option' },
	          _react2.default.createElement(
	            'div',
	            { className: 'modality_option__title' },
	            option.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modality_option__description' },
	            option.description
	          )
	        ),
	        options.indexOf(option.id) > -1 ? _react2.default.createElement(
	          'i',
	          { className: 'block__check' },
	          _react2.default.createElement(icons.iconCheck, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            'selected'
	          )
	        ) : _react2.default.createElement(
	          'i',
	          { className: 'block__check unchecked' },
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'grid__select',
	            type: 'button',
	            onClick: function onClick() {
	              return _this6.toggleOption(option);
	            }
	          },
	          options.indexOf(option.id) > -1 && translation.options.deselect.replace('%option%', option.title),
	          options.indexOf(option.id) === -1 && translation.options.select.replace('%option%', option.title)
	        ),
	        _react2.default.createElement('span', { className: 'grid__select-focus' })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var _props4 = this.props,
	          categorySid = _props4.categorySid,
	          translation = _props4.translation;
	      var ExamStore = this.props.store.ExamStore;
	      var automatedOptions = ExamStore.automatedOptions,
	          modalityPresets = ExamStore.modalityPresets;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'switch-list__settings text-block' },
	        _react2.default.createElement('input', {
	          className: 'inp-hidden',
	          type: 'text',
	          value: this.state.options.toString(),
	          onChange: null,
	          required: true,
	          'aria-required': 'true',
	          ref: function ref(input) {
	            return _this7.emptyGuard = input;
	          }
	        }),
	        this.state.options.length === 0 && _react2.default.createElement(
	          'span',
	          { className: 'note note--prominent note--error' },
	          translation.error_msg
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'meta' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modality_v3_notice' },
	          'This modality will use the new V3 platform.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form-inline form-inline--alt' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: categorySid + '-preset' },
	            translation.presets.label
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'select form-inline__main' },
	            _react2.default.createElement(
	              'select',
	              {
	                id: categorySid + '-preset',
	                onChange: this.selectPreset,
	                ref: function ref(input) {
	                  return _this7.preset = input;
	                },
	                value: this.state.preset
	              },
	              _react2.default.createElement(
	                'option',
	                { value: '' },
	                translation.presets.custom
	              ),
	              modalityPresets.map(function (preset) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: preset.sid, value: preset.sid },
	                  preset.title
	                );
	              })
	            )
	          )
	        ),
	        automatedOptions.map(function (optionGroup) {
	          return (
	            // If any groups need to be excluded....
	            //optionGroup.title !== 'Recording Options' &&
	            _react2.default.createElement(
	              'section',
	              { key: optionGroup.sid },
	              _react2.default.createElement(
	                'strong',
	                { className: 'grid-separator modality_option_group_title' },
	                optionGroup.title
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'grid grid__modality_options' },
	                _this7.renderOptionGroup(optionGroup)
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return AutomatedSettings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AutomatedSettings')(AutomatedSettings);

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PermittedItems = __webpack_require__(219);
	
	var _PermittedItems2 = _interopRequireDefault(_PermittedItems);
	
	var _ProctorTypeList = __webpack_require__(361);
	
	var _ProctorTypeList2 = _interopRequireDefault(_ProctorTypeList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ConfirmExam = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ConfirmExam, _React$Component);
	
	  function ConfirmExam() {
	    _classCallCheck(this, ConfirmExam);
	
	    return _possibleConstructorReturn(this, (ConfirmExam.__proto__ || Object.getPrototypeOf(ConfirmExam)).apply(this, arguments));
	  }
	
	  _createClass(ConfirmExam, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store$ExamStor = this.props.store.ExamStore,
	          exam = _props$store$ExamStor.exam,
	          examAttachments = _props$store$ExamStor.examAttachments,
	          examFiles = _props$store$ExamStor.examFiles;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var importedLmsExam = this.props.store.ExamStore.importedLmsExam;
	
	      if (!importedLmsExam) {
	        importedLmsExam = {};
	      }
	
	      var configuration = exam.configuration;
	
	      if (this.props.customConfiguration) {
	        configuration = this.props.customConfiguration;
	      }
	
	      var scheduleWindow = false;
	
	      if (configuration.scheduleOpenDate || configuration.scheduleCloseDate) {
	        if ((0, _moment2.default)(configuration.scheduleOpenDate).format('M-D-YYYY') !== '1-1-2000' || (0, _moment2.default)(configuration.scheduleCloseDate).format('M-D-YYYY') !== '1-1-2070') {
	          scheduleWindow = true;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: 'data--alt data--striped' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.exam_name
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              importedLmsExam.title || exam.title
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.duration
	            ),
	            importedLmsExam.duration && _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.toHours)(importedLmsExam.duration, false, false, true)
	            ),
	            !importedLmsExam.duration && _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.toHours)(configuration.duration, false, false, true)
	            )
	          ),
	          exam.type.toLowerCase() !== 'written' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.password
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              importedLmsExam.password || configuration.password
	            )
	          ),
	          exam.type.toLowerCase() !== 'written' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.url
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              importedLmsExam.examUrl || exam.url
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.attempts
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              importedLmsExam.attemptsAllowed || configuration.attempts
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.exam_opens
	            ),
	            importedLmsExam.examOpenDate && _react2.default.createElement(
	              'p',
	              null,
	              _moment2.default.utc(importedLmsExam.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	            ),
	            !importedLmsExam.examOpenDate && _react2.default.createElement(
	              'p',
	              null,
	              _moment2.default.utc(configuration.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.exam_closes
	            ),
	            importedLmsExam.examCloseDate && _react2.default.createElement(
	              'p',
	              null,
	              _moment2.default.utc(importedLmsExam.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	            ),
	            !importedLmsExam.examCloseDate && _react2.default.createElement(
	              'p',
	              null,
	              _moment2.default.utc(configuration.examCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	            )
	          ),
	          scheduleWindow && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.scheduling_opens
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _moment2.default.utc(configuration.scheduleOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	            )
	          ),
	          scheduleWindow && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.scheduling_closes
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _moment2.default.utc(configuration.scheduleCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	            )
	          ),
	          exam.type.toLowerCase() !== 'written' && (examAttachments || configuration.attachments && configuration.attachments.length > 0) && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.attachments
	            ),
	            _react2.default.createElement(
	              'ul',
	              { key: 1, className: 'data--comma' },
	              configuration.attachments && configuration.attachments.map(function (file, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  file.attachmentAwsTitle
	                );
	              }),
	              examAttachments && examAttachments.map(function (file, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  file.name
	                );
	              })
	            )
	          ),
	          exam.type.toLowerCase() === 'written' && (examFiles || configuration.examFiles && configuration.examFiles.length > 0) && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.exam_file
	            ),
	            _react2.default.createElement(
	              'ul',
	              { key: 1, className: 'data--comma' },
	              configuration.examFiles && configuration.examFiles.map(function (file, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  file.attachmentAwsTitle
	                );
	              }),
	              examFiles && examFiles.map(function (file, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  file.name
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(_PermittedItems2.default, Object.assign({
	            configuration: configuration,
	            listItem: true,
	            compact: true
	          }, this.props)),
	          configuration.studentNotes && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.student_notes
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              configuration.studentNotes
	            )
	          ),
	          configuration.proctorNotes && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.proctor_notes
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              configuration.proctorNotes
	            )
	          ),
	          configuration.proctorTypes.length > 0 && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              translation.proctor_types
	            ),
	            _react2.default.createElement(_ProctorTypeList2.default, Object.assign({
	              proctorTypes: configuration.proctorTypes
	            }, this.props))
	          )
	        )
	      );
	    }
	  }]);
	
	  return ConfirmExam;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ConfirmExam')(ConfirmExam);

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _EditPermittedItems = __webpack_require__(350);
	
	var _EditPermittedItems2 = _interopRequireDefault(_EditPermittedItems);
	
	var _EditExamNotes = __webpack_require__(349);
	
	var _EditExamNotes2 = _interopRequireDefault(_EditExamNotes);
	
	var _EditProctorSettings = __webpack_require__(351);
	
	var _EditProctorSettings2 = _interopRequireDefault(_EditProctorSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var EditSection = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditSection, _React$Component);
	
	  function EditSection() {
	    _classCallCheck(this, EditSection);
	
	    return _possibleConstructorReturn(this, (EditSection.__proto__ || Object.getPrototypeOf(EditSection)).apply(this, arguments));
	  }
	
	  _createClass(EditSection, [{
	    key: 'render',
	    value: function render() {
	      switch (this.props.step) {
	        case 1:
	          return _react2.default.createElement(_EditPermittedItems2.default, Object.assign({ nextStep: this.props.nextStep, prevStep: this.props.prevStep }, this.props));
	
	        case 2:
	          return _react2.default.createElement(_EditExamNotes2.default, Object.assign({ nextStep: this.props.nextStep, prevStep: this.props.prevStep }, this.props));
	
	        case 3:
	          return _react2.default.createElement(_EditProctorSettings2.default, Object.assign({ prevStep: this.props.prevStep }, this.props));
	
	        default:
	          return _react2.default.createElement(_EditPermittedItems2.default, Object.assign({ nextStep: this.props.nextStep, prevStep: this.props.prevStep }, this.props));
	      }
	    }
	  }]);
	
	  return EditSection;
	}(_react2.default.Component));
	
	exports.default = EditSection;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeSelect = __webpack_require__(365);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	var _FileUpload = __webpack_require__(358);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	// import Textarea from 'react-textarea-autosize';
	
	// Components
	
	
	var EditExamDetails = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditExamDetails, _React$Component);
	
	  function EditExamDetails() {
	    _classCallCheck(this, EditExamDetails);
	
	    var _this2 = _possibleConstructorReturn(this, (EditExamDetails.__proto__ || Object.getPrototypeOf(EditExamDetails)).call(this));
	
	    _this2.handleDateChange = _this2.handleDateChange.bind(_this2);
	    _this2.toggleScheduleWindow = _this2.toggleScheduleWindow.bind(_this2);
	    _this2.handleDuration = _this2.handleDuration.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(EditExamDetails, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          exam = _props.exam,
	          customConfiguration = _props.customConfiguration;
	      var ExamStore = this.props.store.ExamStore;
	
	
	      if (typeof exam !== 'undefined' && exam.sid && !customConfiguration) {
	        // Editing an exam or default configuration
	        this.state = {
	          startDate: (0, _moment2.default)(exam.configuration.examOpenDate),
	          endDate: (0, _moment2.default)(exam.configuration.examCloseDate),
	          scheduleStartDate: (0, _moment2.default)(exam.configuration.scheduleOpenDate),
	          scheduleEndDate: (0, _moment2.default)(exam.configuration.scheduleCloseDate),
	          isLimitedScope: exam.isLimitedScope,
	          configuration: exam.configuration
	        };
	      } else if (customConfiguration) {
	        // Editing a custom configuration
	        this.state = {
	          startDate: (0, _moment2.default)(customConfiguration.examOpenDate),
	          endDate: (0, _moment2.default)(customConfiguration.examCloseDate),
	          scheduleStartDate: (0, _moment2.default)(customConfiguration.scheduleOpenDate),
	          scheduleEndDate: (0, _moment2.default)(customConfiguration.scheduleCloseDate),
	          isLimitedScope: exam.isLimitedScope,
	          configuration: customConfiguration
	        };
	      } else if (ExamStore.exam.configuration.examOpenDate) {
	        this.state = {
	          startDate: (0, _moment2.default)(ExamStore.exam.configuration.examOpenDate),
	          endDate: (0, _moment2.default)(ExamStore.exam.configuration.examCloseDate),
	          scheduleStartDate: (0, _moment2.default)(ExamStore.exam.configuration.scheduleOpenDate) || (0, _moment2.default)('1-1-2000 00:00', 'M-D-YYYY HH:mm Z').toISOString(),
	          scheduleEndDate: (0, _moment2.default)(ExamStore.exam.configuration.scheduleCloseDate) || (0, _moment2.default)('1-1-2070 00:00', 'M-D-YYYY HH:mm Z').toISOString(),
	          isLimitedScope: exam.isLimitedScope,
	          configuration: exam.configuration
	        };
	      } else {
	        this.state = {
	          startDate: null,
	          endDate: null,
	          scheduleStartDate: null,
	          scheduleEndDate: null,
	          isLimitedScope: exam.isLimitedScope,
	          configuration: exam.configuration
	        };
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      var importedLmsExam = this.props.store.ExamStore.importedLmsExam;
	
	
	      this.duration.addEventListener('durationInput', function (e) {
	        _this.props.handleInput('duration', e, true);
	      });
	
	      if (importedLmsExam.examOpenDate) {
	        this.setState({
	          startDate: (0, _moment2.default)(importedLmsExam.examOpenDate)
	        });
	      }
	
	      if (importedLmsExam.examCloseDate) {
	        this.setState({
	          endDate: (0, _moment2.default)(importedLmsExam.examCloseDate)
	        });
	      }
	
	      if (this.state.configuration.attachments && this.state.configuration.attachments.length > 0) {
	        this.setState({
	          attachments: true
	        });
	      }
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, name, e) {
	      this.setState(_defineProperty({}, name, date));
	
	      if (name === 'startDate') {
	        this.props.handleInput('examOpenDate', e, true, date, this.state.startTime);
	      } else if (name === 'endDate') {
	        this.props.handleInput('examCloseDate', e, true, date, this.state.endTime);
	      } else if (name === 'scheduleStartDate') {
	        this.props.handleInput('scheduleOpenDate', e, true, date, this.state.scheduleStartTime);
	      } else {
	        this.props.handleInput('scheduleCloseDate', e, true, date, this.state.scheduleEndTime);
	      }
	    }
	  }, {
	    key: 'handleTimeChange',
	    value: function handleTimeChange(name, e) {
	      var date = this.state.startDate;
	      var stateName = 'startTime';
	
	      if (name === 'examCloseDate') {
	        date = this.state.endDate;
	        stateName = 'endTime';
	      } else if (name === 'scheduleOpenDate') {
	        date = this.state.scheduleStartDate;
	        stateName = 'scheduleStartTime';
	      } else if (name === 'scheduleCloseDate') {
	        date = this.state.scheduleEndDate;
	        stateName = 'scheduleEndTime';
	      }
	
	      this.setState(_defineProperty({}, stateName, e.target.value));
	
	      this.props.handleInput(name, e, true, date, e.target.value);
	    }
	  }, {
	    key: 'isDisabled',
	    value: function isDisabled(fieldName) {
	      // If this is an exception or it’s completely readonly
	      if (this.props.exception || this.props.readonly) {
	        return true;
	      }
	
	      // Otherwise, if this field was provided in a list of disabled fields
	      if (this.props.disabledFields && this.props.disabledFields.indexOf(fieldName) > -1) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'enableScheduleWindow',
	    value: function enableScheduleWindow() {
	      var schedulingOpens = _moment2.default.utc(this.state.scheduleStartDate).format('M-D-YYYY');
	      var schedulingCloses = _moment2.default.utc(this.state.scheduleEndDate).format('M-D-YYYY');
	
	      if (schedulingOpens === '1-1-2000' && schedulingCloses === '1-1-2070' || this.state.scheduleStartDate === null && this.state.scheduleEndDate === null) {
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'toggleScheduleWindow',
	    value: function toggleScheduleWindow(e) {
	      var _this = this;
	      var ExamStore = this.props.store.ExamStore;
	      var exam = this.props.exam;
	
	      var scheduleStartTime = null;
	      var scheduleEndTime = null;
	
	      if (!e.target.checked) {
	        // If disabling the scheduling window, set an open and close date way in the past and future
	        this.setState({
	          scheduleStartDate: (0, _moment2.default)('1-1-2000 00:00', 'M-D-YYYY HH:mm Z').toISOString(),
	          scheduleEndDate: (0, _moment2.default)('1-1-2070 00:00', 'M-D-YYYY HH:mm Z').toISOString()
	        });
	
	        // Also set the time to midnight
	        scheduleStartTime = '00:00';
	        scheduleEndTime = '00:00';
	
	        // Make sure stored exam is updated
	        if (exam) {
	          setTimeout(function () {
	            ExamStore.exam.configuration.scheduleOpenDate = _this.state.scheduleStartDate;
	            ExamStore.exam.configuration.scheduleCloseDate = _this.state.scheduleEndDate;
	          });
	        }
	      } else {
	        // Otherwise, default to the exam open and close dates
	        this.setState({
	          scheduleStartDate: this.state.startDate ? (0, _moment2.default)(this.state.startDate).subtract(1, 'minute') : '',
	          scheduleEndDate: this.state.endDate || ''
	        });
	
	        // Also set the time
	        setTimeout(function () {
	          if (_this.scheduleStartTime) {
	            scheduleStartTime = _this.scheduleStartTime.value;
	            scheduleEndTime = _this.scheduleEndTime.value;
	          }
	        });
	
	        // Make sure stored exam is updated
	        if (exam) {
	          setTimeout(function () {
	            ExamStore.exam.configuration.scheduleOpenDate = _this.state.scheduleStartDate;
	            ExamStore.exam.configuration.scheduleCloseDate = _this.state.scheduleEndDate;
	          });
	        }
	      }
	
	      setTimeout(function () {
	        _this.props.handleInput('scheduleOpenDate', null, true, _this.state.scheduleStartDate, scheduleStartTime, false, null, true);
	        _this.props.handleInput('scheduleCloseDate', null, true, _this.state.scheduleEndDate, scheduleEndTime, false, null, true);
	      });
	    }
	  }, {
	    key: 'handleDuration',
	    value: function handleDuration() {
	      var hr = parseInt(this.durationHr.value, 10);
	
	      // This stops instructors from adding extra minutes after 8 hours
	      if (hr === 8) {
	        this.durationMin.value = 0;
	      }
	
	      var min = parseInt(this.durationMin.value, 10);
	      var value = hr * 60 + min;
	
	      this.duration.value = value;
	
	      var event = null;
	
	      try {
	        event = new Event('durationInput');
	      } catch (e) {
	        event = document.createEvent('Event');
	        event.initEvent('durationInput', true, true);
	      }
	
	      this.duration.dispatchEvent(event);
	    }
	  }, {
	    key: 'convertDuration',
	    value: function convertDuration(unit) {
	      var importedLmsExam = this.props.store.ExamStore.importedLmsExam;
	
	
	      if (importedLmsExam.title) {
	        if (unit === 'hr') {
	          return Math.floor(importedLmsExam.duration / 60);
	        } else {
	          return importedLmsExam.duration % 60;
	        }
	      } else {
	        if (unit === 'hr') {
	          return Math.floor(this.state.configuration.duration / 60);
	        } else {
	          return this.state.configuration.duration % 60;
	        }
	      }
	    }
	  }, {
	    key: 'validateUrl',
	    value: function validateUrl(e, name) {
	      // const { translation } = this.props;
	
	      var url = e.target.value;
	
	      if (!url.match(/^https?:\/\//)) {
	        e.target.value = 'http://' + url;
	      }
	
	      this.props.handleInput('url', e);
	
	      // if(validUrl.isUri(e.target.value)) {
	      //   e.target.setCustomValidity('');
	      //   this.props.handleInput('url', e);
	      // } else {
	      //   e.target.setCustomValidity('invalid');
	      //   this.props.store.SessionStore.showDialog(translation.invalid_url);
	      // }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          automatedOnly = _props2.automatedOnly,
	          exam = _props2.exam,
	          translation = _props2.translation,
	          scheduled = _props2.scheduled;
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	      var importedLmsExam = ExamStore.importedLmsExam;
	      var userTimezone = SessionStore.userTimezone;
	
	
	      return _react2.default.createElement(
	        'fieldset',
	        { id: 'exam-details' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'fields' },
	          !exam.sid && SettingsStore.settings.enableWrittenExams && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'select' },
	              _react2.default.createElement(
	                'select',
	                {
	                  defaultValue: exam.type,
	                  onChange: function onChange(e) {
	                    return ExamStore.exam.type = e.target.value;
	                  }
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: 'Online' },
	                  translation.exam_type.online
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'Written' },
	                  translation.exam_type.written
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              { className: 'lbl-required', htmlFor: 'exam-name' },
	              translation.exam_name.label
	            ),
	            _react2.default.createElement('input', {
	              type: 'text',
	              id: 'exam-name',
	              placeholder: translation.exam_name.helper,
	              defaultValue: importedLmsExam.title || exam.title,
	              onChange: function onChange(e) {
	                _this3.props.handleInput('title', e);
	              },
	              disabled: this.isDisabled('title'),
	              required: true,
	              'aria-required': 'true',
	              autoFocus: true })
	          ),
	          _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'create-limited-scope-exam',
	            renderFeatureCallback: function renderFeatureCallback() {
	              return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'limited-scope', 'aria-describedby': 'window-tooltip' },
	                  translation.limited_scope.label,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'window-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                      Object.keys(importedLmsExam).length !== 0 ? translation.limited_scope.imported_tooltip : translation.limited_scope.tooltip
	                    )
	                  )
	                ),
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  id: 'limited-scope',
	                  className: 'switch-input',
	                  defaultChecked: _this3.state.isLimitedScope,
	                  onChange: function onChange(e) {
	                    _this3.props.handleInput('isLimitedScope', e, false, false, false, true);
	                  },
	                  disabled: Object.keys(importedLmsExam).length !== 0 || _this3.isDisabled('isLimitedScope'),
	                  onKeyDown: _helpers.handleSwitchInputKeys
	                }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'switch-label', htmlFor: 'limited-scope' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.limited_scope.label
	                  )
	                )
	              );
	            },
	            renderDefaultCallback: function renderDefaultCallback() {
	              return null;
	            }
	          }),
	          _react2.default.createElement(
	            'li',
	            { className: 'field--auto ' + this.props.defaultDiff('duration') + ' time-select' },
	            _react2.default.createElement(
	              'label',
	              { className: 'lbl-required', htmlFor: 'exam-duration-hr' },
	              translation.duration.label
	            ),
	            _react2.default.createElement('input', {
	              className: 'inp-hidden',
	              type: 'number',
	              min: '1',
	              ref: function ref(input) {
	                _this3.duration = input;
	              },
	              defaultValue: importedLmsExam.duration || this.state.configuration.duration,
	              onInput: function onInput(e) {
	                _this3.props.handleInput('duration', e, true);
	              },
	              required: true,
	              'aria-required': 'true'
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'select' },
	              _react2.default.createElement(
	                'select',
	                {
	                  id: 'exam-duration-hr',
	                  required: true,
	                  'aria-required': 'true',
	                  defaultValue: this.convertDuration('hr'),
	                  onChange: this.handleDuration,
	                  ref: function ref(input) {
	                    _this3.durationHr = input;
	                  },
	                  disabled: this.props.readonly || this.props.scheduled || this.props.disabledFields && this.props.disabledFields.indexOf('duration') > -1
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: '0' },
	                  '0'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '1' },
	                  '1'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '2' },
	                  '2'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '3' },
	                  '3'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '4' },
	                  '4'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '5' },
	                  '5'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '6' },
	                  '6'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '7' },
	                  '7'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '8' },
	                  '8'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'exam-duration-hr', className: 'preposition' },
	              translation.duration.hours
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'select' },
	              _react2.default.createElement(
	                'select',
	                {
	                  id: 'exam-duration-min',
	                  required: true,
	                  'aria-required': 'true',
	                  defaultValue: this.convertDuration('min'),
	                  onChange: this.handleDuration,
	                  ref: function ref(input) {
	                    _this3.durationMin = input;
	                  },
	                  disabled: this.props.readonly || this.props.scheduled || this.props.disabledFields && this.props.disabledFields.indexOf('duration') > -1 || (this.durationHr && this.durationHr ? this.durationHr.value === '8' : false)
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: '0' },
	                  '00'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '1' },
	                  '01'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '2' },
	                  '02'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '3' },
	                  '03'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '4' },
	                  '04'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '5' },
	                  '05'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '6' },
	                  '06'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '7' },
	                  '07'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '8' },
	                  '08'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '9' },
	                  '09'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '10' },
	                  '10'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '11' },
	                  '11'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '12' },
	                  '12'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '13' },
	                  '13'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '14' },
	                  '14'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '15' },
	                  '15'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '16' },
	                  '16'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '17' },
	                  '17'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '18' },
	                  '18'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '19' },
	                  '19'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '20' },
	                  '20'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '21' },
	                  '21'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '22' },
	                  '22'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '23' },
	                  '23'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '24' },
	                  '24'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '25' },
	                  '25'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '26' },
	                  '26'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '27' },
	                  '27'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '28' },
	                  '28'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '29' },
	                  '29'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '30' },
	                  '30'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '31' },
	                  '31'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '32' },
	                  '32'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '33' },
	                  '33'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '34' },
	                  '34'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '35' },
	                  '35'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '36' },
	                  '36'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '37' },
	                  '37'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '38' },
	                  '38'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '39' },
	                  '39'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '40' },
	                  '40'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '41' },
	                  '41'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '42' },
	                  '42'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '43' },
	                  '43'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '44' },
	                  '44'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '45' },
	                  '45'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '46' },
	                  '46'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '47' },
	                  '47'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '48' },
	                  '48'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '49' },
	                  '49'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '50' },
	                  '50'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '51' },
	                  '51'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '52' },
	                  '52'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '53' },
	                  '53'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '54' },
	                  '54'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '55' },
	                  '55'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '56' },
	                  '56'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '57' },
	                  '57'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '58' },
	                  '58'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '59' },
	                  '59'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'exam-duration-min', className: 'preposition' },
	              translation.duration.minutes
	            ),
	            this.props.renderDefault('configuration.duration', _helpers.toHours),
	            scheduled && _react2.default.createElement(
	              'p',
	              { className: 'note note--full note--full-alt' },
	              translation.duration.disabled
	            )
	          ),
	          exam.type.toLowerCase() !== 'written' && _react2.default.createElement(
	            'li',
	            { className: this.props.defaultDiff('password') },
	            _react2.default.createElement(
	              'label',
	              {
	                className: 'lbl-required',
	                htmlFor: 'exam-password',
	                'aria-describedby': 'password-tooltip'
	              },
	              translation.password.label,
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip' },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'tooltip__label',
	                    role: 'presentation',
	                    'aria-hidden': 'true'
	                  },
	                  '(?)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    id: 'password-tooltip',
	                    className: 'tooltip__body',
	                    role: 'tooltip'
	                  },
	                  translation.password.tooltip
	                )
	              )
	            ),
	            _react2.default.createElement('input', {
	              type: 'text',
	              id: 'exam-password',
	              placeholder: translation.password.helper,
	              required: true,
	              'aria-required': 'true',
	              defaultValue: importedLmsExam.password || this.state.configuration.password,
	              onChange: function onChange(e) {
	                _this3.props.handleInput('password', e, true);
	              },
	              disabled: this.props.readonly || this.props.disabledFields && this.props.disabledFields.indexOf('password') > -1
	            }),
	            translation.password.notice && _react2.default.createElement(
	              'p',
	              { className: 'note note--full note--full-alt' },
	              translation.password.notice
	            ),
	            this.props.renderDefault('configuration.password')
	          ),
	          exam.type.toLowerCase() !== 'written' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              {
	                className: 'lbl-required',
	                htmlFor: 'exam-url',
	                'aria-describedby': 'url-tooltip'
	              },
	              translation.url.label,
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip' },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'tooltip__label',
	                    role: 'presentation',
	                    'aria-hidden': 'true'
	                  },
	                  '(?)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    id: 'url-tooltip',
	                    className: 'tooltip__body',
	                    role: 'tooltip'
	                  },
	                  translation.url.tooltip
	                )
	              )
	            ),
	            _react2.default.createElement('input', {
	              type: 'url',
	              id: 'exam-url',
	              placeholder: translation.url.helper,
	              defaultValue: importedLmsExam.examUrl || exam.url,
	              onChange: this.props.handleInput.bind(this, 'url'),
	              onBlur: function onBlur(e) {
	                _this3.validateUrl(e, 'url');
	              },
	              required: true,
	              'aria-required': 'true',
	              disabled: this.isDisabled('url')
	            })
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'field--auto ' + this.props.defaultDiff('attempts') },
	            _react2.default.createElement(
	              'label',
	              {
	                className: 'lbl-required',
	                htmlFor: 'exam-attempts',
	                'aria-describedby': 'attempts-tooltip'
	              },
	              translation.attempts.label,
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip' },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'tooltip__label',
	                    role: 'presentation',
	                    'aria-hidden': 'true'
	                  },
	                  '(?)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    id: 'attempts-tooltip',
	                    className: 'tooltip__body',
	                    role: 'tooltip'
	                  },
	                  translation.attempts.tooltip
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'label',
	              { className: 'select' },
	              _react2.default.createElement(
	                'select',
	                {
	                  id: 'exam-attempts',
	                  required: true,
	                  'aria-required': 'true',
	                  defaultValue: importedLmsExam.attemptsAllowed || this.state.configuration.attempts,
	                  onChange: function onChange(e) {
	                    _this3.props.handleInput('attempts', e, true);
	                  },
	                  disabled: this.props.readonly || this.props.disabledFields && this.props.disabledFields.indexOf('attempts') > -1
	                },
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '1'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '2'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '3'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '4'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '5'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '6'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '7'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '8'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '9'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '10'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '11'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '12'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '13'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '14'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '15'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '16'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '17'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '18'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '19'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '20'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '21'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '22'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '23'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '24'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  null,
	                  '25'
	                ),
	                importedLmsExam.attemptsAllowed && _react2.default.createElement(
	                  'option',
	                  null,
	                  importedLmsExam.attemptsAllowed
	                )
	              )
	            ),
	            this.props.renderDefault('configuration.attempts')
	          )
	        ),
	        _react2.default.createElement(
	          'h4',
	          { className: 'form-heading' },
	          translation.date_settings.header
	        ),
	        scheduled && _react2.default.createElement(
	          'p',
	          { className: 'note note--full' },
	          translation.date_settings.disabled
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'fields' },
	          _react2.default.createElement(
	            'li',
	            { className: 'field--auto ' + this.props.defaultDiff('examOpenDate') },
	            _react2.default.createElement(
	              'label',
	              { className: 'lbl-required', htmlFor: 'exam-start-date' },
	              translation.starts.label
	            ),
	            _react2.default.createElement(_reactDatepicker2.default, {
	              id: 'exam-start-date',
	              selected: this.state.startDate ? (0, _moment2.default)(this.state.startDate).tz(userTimezone) : null,
	              maxDate: this.state.endDate,
	              onChange: function onChange(date, e) {
	                _this3.handleDateChange(date, 'startDate', e);
	              },
	              placeholderText: translation.starts.helper,
	              required: true, 'aria-required': 'true',
	              disabled: this.props.readonly || this.props.scheduled || this.props.disabledFields && this.props.disabledFields.indexOf('examOpenDate') > -1,
	              autoComplete: 'off'
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'preposition', htmlFor: 'exam-start-time' },
	              translation.starts.at
	            ),
	            _react2.default.createElement(_TimeSelect2.default, Object.assign({
	              id: 'exam-start-time',
	              defaultValue: this.state.startDate,
	              reference: function reference(input) {
	                _this3.startTime = input;
	              },
	              onChange: function onChange(e) {
	                _this3.handleTimeChange('examOpenDate', e);
	              },
	              date: this.state.startDate,
	              name: 'examOpenDate',
	              stateName: 'startTime'
	            }, this.props, {
	              parent: this,
	              disabled: this.props.readonly || this.props.scheduled || this.props.disabledFields && this.props.disabledFields.indexOf('examOpenDate') > -1
	            })),
	            _react2.default.createElement(
	              'span',
	              { className: 'preposition' },
	              this.state.startDate && _moment2.default.utc(this.state.startDate).tz(userTimezone).format('z'),
	              !this.state.startDate && (0, _moment2.default)().tz(userTimezone).format('z')
	            ),
	            this.props.renderDefault('configuration.examOpenDate', this.props.momentFormat)
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'field--auto ' + this.props.defaultDiff('examCloseDate') },
	            _react2.default.createElement(
	              'label',
	              { className: 'lbl-required', htmlFor: 'exam-end-date' },
	              translation.ends.label
	            ),
	            _react2.default.createElement(_reactDatepicker2.default, {
	              id: 'exam-end-date',
	              selected: this.state.endDate ? (0, _moment2.default)(this.state.endDate).tz(userTimezone) : null,
	              minDate: this.state.startDate,
	              onChange: function onChange(date, e) {
	                _this3.handleDateChange(date, 'endDate', e);
	              },
	              placeholderText: translation.ends.helper,
	              required: true, 'aria-required': 'true',
	              disabled: this.props.readonly || this.props.scheduled || this.props.disabledFields && this.props.disabledFields.indexOf('examCloseDate') > -1,
	              autoComplete: 'off'
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'preposition', htmlFor: 'exam-end-time' },
	              translation.ends.at
	            ),
	            _react2.default.createElement(_TimeSelect2.default, Object.assign({
	              id: 'exam-end-time',
	              defaultValue: this.state.endDate,
	              reference: function reference(input) {
	                _this3.endTime = input;
	              },
	              onChange: function onChange(e) {
	                _this3.handleTimeChange('examCloseDate', e);
	              },
	              date: this.state.endDate,
	              name: 'examCloseDate',
	              stateName: 'endTime'
	            }, this.props, {
	              parent: this,
	              disabled: this.props.readonly || this.props.scheduled || this.props.disabledFields && this.props.disabledFields.indexOf('examCloseDate') > -1
	            })),
	            _react2.default.createElement(
	              'span',
	              { className: 'preposition' },
	              this.state.endDate && _moment2.default.utc(this.state.endDate).tz(userTimezone).format('z'),
	              !this.state.endDate && (0, _moment2.default)().tz(userTimezone).format('z')
	            ),
	            this.props.renderDefault('configuration.examCloseDate', this.props.momentFormat)
	          ),
	          !automatedOnly && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'exam-window', 'aria-describedby': 'window-tooltip' },
	              translation.scheduling_window.label,
	              _react2.default.createElement(
	                'div',
	                { className: 'tooltip' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                  '(?)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'window-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                  translation.scheduling_window.tooltip
	                )
	              )
	            ),
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              id: 'exam-window',
	              className: 'switch-input',
	              defaultChecked: this.enableScheduleWindow(),
	              onChange: function onChange(e) {
	                _this3.toggleScheduleWindow(e);
	              },
	              disabled: this.props.readonly || this.props.scheduled,
	              onKeyDown: _helpers.handleSwitchInputKeys
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'switch-label', htmlFor: 'exam-window' },
	              _react2.default.createElement(
	                'span',
	                { className: 'meta' },
	                translation.scheduling_window.label
	              )
	            )
	          ),
	          !automatedOnly && this.enableScheduleWindow() && _react2.default.createElement(
	            'li',
	            { className: 'field--auto ' + this.props.defaultDiff('scheduleOpenDate') },
	            _react2.default.createElement(
	              'label',
	              { className: 'lbl-required', htmlFor: 'schedule-start-date' },
	              translation.scheduling_starts.label
	            ),
	            _react2.default.createElement(_reactDatepicker2.default, {
	              id: 'schedule-start-date',
	              selected: this.state.scheduleStartDate ? (0, _moment2.default)(this.state.scheduleStartDate).tz(userTimezone) : null,
	              maxDate: this.state.startDate,
	              onChange: function onChange(date, e) {
	                _this3.handleDateChange(date, 'scheduleStartDate', e);
	              },
	              placeholderText: translation.scheduling_starts.helper,
	              required: true,
	              'aria-required': 'true',
	              disabled: this.props.readonly || this.props.scheduled,
	              autoComplete: 'off'
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'preposition', htmlFor: 'schedule-start-time' },
	              translation.starts.at
	            ),
	            _react2.default.createElement(_TimeSelect2.default, Object.assign({
	              id: 'schedule-start-time',
	              defaultValue: this.state.scheduleStartDate,
	              reference: function reference(input) {
	                _this3.scheduleStartTime = input;
	              },
	              onChange: function onChange(e) {
	                _this3.handleTimeChange('scheduleOpenDate', e);
	              },
	              date: this.state.scheduleStartDate,
	              name: 'scheduleOpenDate',
	              stateName: 'scheduleStartTime'
	            }, this.props, {
	              parent: this,
	              disabled: this.props.readonly || this.props.scheduled
	            })),
	            _react2.default.createElement(
	              'span',
	              { className: 'preposition' },
	              this.state.scheduleStartDate && _moment2.default.utc(this.state.scheduleStartDate).tz(userTimezone).format('z'),
	              !this.state.scheduleStartDate && (0, _moment2.default)().tz(userTimezone).format('z')
	            ),
	            this.props.renderDefault('configuration.scheduleOpenDate', this.props.momentFormat)
	          ),
	          !automatedOnly && this.enableScheduleWindow() && _react2.default.createElement(
	            'li',
	            { className: 'field--auto ' + this.props.defaultDiff('scheduleCloseDate') },
	            _react2.default.createElement(
	              'label',
	              { className: 'lbl-required', htmlFor: 'schedule-end-date' },
	              translation.scheduling_ends.label
	            ),
	            _react2.default.createElement(_reactDatepicker2.default, {
	              id: 'schedule-end-date',
	              selected: this.state.scheduleEndDate ? (0, _moment2.default)(this.state.scheduleEndDate).tz(userTimezone) : null,
	              maxDate: this.state.endDate,
	              onChange: function onChange(date, e) {
	                _this3.handleDateChange(date, 'scheduleEndDate', e);
	              },
	              placeholderText: translation.scheduling_ends.helper,
	              required: true,
	              'aria-required': 'true',
	              disabled: this.props.readonly || this.props.scheduled,
	              autoComplete: 'off'
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'preposition', htmlFor: 'schedule-end-time' },
	              translation.starts.at
	            ),
	            _react2.default.createElement(_TimeSelect2.default, Object.assign({
	              id: 'schedule-end-time',
	              defaultValue: this.state.scheduleEndDate,
	              reference: function reference(input) {
	                _this3.scheduleEndTime = input;
	              },
	              onChange: function onChange(e) {
	                _this3.handleTimeChange('scheduleCloseDate', e);
	              },
	              date: this.state.scheduleEndDate,
	              name: 'scheduleCloseDate',
	              stateName: 'scheduleEndTime'
	            }, this.props, {
	              parent: this,
	              disabled: this.props.readonly || this.props.scheduled
	            })),
	            _react2.default.createElement(
	              'span',
	              { className: 'preposition' },
	              this.state.scheduleEndDate && _moment2.default.utc(this.state.scheduleEndDate).tz(userTimezone).format('z'),
	              !this.state.scheduleEndDate && (0, _moment2.default)().tz(userTimezone).format('z')
	            ),
	            this.props.renderDefault('configuration.scheduleCloseDate', this.props.momentFormat)
	          )
	        ),
	        exam.type.toLowerCase() !== 'written' && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h4',
	            { className: 'form-heading' },
	            'Attachments'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_FileUpload2.default, Object.assign({}, this.props, {
	                fileType: 'application/pdf',
	                label: translation.attachments.label,
	                helper: translation.attachments.helper,
	                files: this.state.configuration.attachments,
	                onDrop: function onDrop(attachments) {
	                  return ExamStore.examAttachments = attachments;
	                },
	                onCancel: function onCancel() {
	                  return _this3.setState({ attachments: false });
	                }
	              }))
	            )
	          )
	        ),
	        exam.type.toLowerCase() === 'written' && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h4',
	            { className: 'form-heading' },
	            'Exam File'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_FileUpload2.default, Object.assign({}, this.props, {
	                label: translation.exam_file.label,
	                helper: translation.exam_file.helper,
	                files: this.state.configuration.examFiles,
	                onDrop: function onDrop(attachments) {
	                  return ExamStore.examFiles = attachments;
	                },
	                single: true,
	                fileType: 'application/pdf',
	                onCancel: function onCancel() {
	                  return _this3.setState({ attachments: false });
	                }
	              }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditExamDetails;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EditExamDetails')(EditExamDetails);

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Step = __webpack_require__(65);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _EditEnrollmentSection = __webpack_require__(782);
	
	var _EditEnrollmentSection2 = _interopRequireDefault(_EditEnrollmentSection);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	// Dependencies
	
	
	var EnrollmentException = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EnrollmentException, _React$Component);
	
	  function EnrollmentException() {
	    _classCallCheck(this, EnrollmentException);
	
	    var _this = _possibleConstructorReturn(this, (EnrollmentException.__proto__ || Object.getPrototypeOf(EnrollmentException)).call(this));
	
	    _this.setStep = _this.setStep.bind(_this);
	    _this.nextStep = _this.nextStep.bind(_this);
	    _this.prevStep = _this.prevStep.bind(_this);
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    _this.momentFormat = _this.momentFormat.bind(_this);
	    return _this;
	  }
	
	  _createClass(EnrollmentException, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var configurationSid = this.props.configurationSid;
	
	      this.state = {
	        step: 1,
	        enrollmentSid: this.props.routing.location.query.enrollment,
	        configurationSid: configurationSid,
	        skippable: false
	      };
	
	      this.getFilteredProctorTypes();
	
	      // Get insitution settings so we can only show allowed permitted items
	      this.props.store.SettingsStore.getInstituteSettings(this);
	    }
	  }, {
	    key: 'getFilteredProctorTypes',
	    value: function getFilteredProctorTypes() {
	      this.props.store.SessionStore.getProctorGroupTypes();
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      e.preventDefault();
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep() {
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'renderDefault',
	    value: function renderDefault() {
	      return '';
	    }
	  }, {
	    key: 'defaultDiff',
	    value: function defaultDiff() {
	      return '';
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(name, e, isConfiguration, date, time, isCheckbox, array) {
	      var data = null;
	      var value = null;
	
	      if (e) {
	        value = e.target.value;
	      }
	
	      // Make sure boolean values are boolean
	      if (value === 'true') {
	        value = true;
	      }
	      if (value === 'false') {
	        value = false;
	      }
	
	      // If we’re updating a date, we need to format it
	      if (date) {
	        date = (0, _moment2.default)(date).format('YYYY-MM-DD Z');
	        value = (0, _moment2.default)(date + ' ' + time, 'YYYY-MM-DD Z HH:mm').toISOString();
	      }
	
	      // If it’s a checkbox, get the checked state
	      if (isCheckbox) {
	        value = e.target.checked;
	      }
	
	      // If the data provided is an array
	      if (array) {
	        value = array;
	      }
	
	      data = _defineProperty({}, name, value);
	
	      this.props.store.EnrollmentStore.updateConfigurationData(data);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(exit) {
	      var translation = this.props.translation;
	
	      var configuration = this.props.store.EnrollmentStore.enrollmentConfiguration;
	
	      // Don’t submit until the last step
	      if (this.state.step === translation.steps.length || exit === true) {
	        var callback = this.complete;
	
	        // Make sure at least 1 proctor type has been chosen
	        if (configuration.proctorTypes.length > 0) {
	          if (!this.props.configurationSid) {
	            // If we’re not editing, create a configuration
	            this.props.store.EnrollmentStore.createEnrollmentConfiguration(this.props.userSid, this.props.enrollmentSid, callback);
	          } else {
	            // Otherwise, update the configuration
	            this.props.store.EnrollmentStore.updateEnrollmentConfiguration(this.props.userSid, this.props.enrollmentSid, this.props.configurationSid, callback);
	          }
	        } else {
	          var dialogContent = translation.proctor_warning;
	          this.props.store.SessionStore.showDialog(dialogContent);
	        }
	      } else {
	        this.nextStep();
	      }
	    }
	  }, {
	    key: 'complete',
	    value: function complete(sid) {
	      var translation = this.props.translation;
	
	
	      (0, _helpers.closeDrawer)(null, this.props.parent);
	      this.props.store.SessionStore.showToaster(translation.configuration_saved, 'success');
	    }
	  }, {
	    key: 'momentFormat',
	    value: function momentFormat(date) {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      return _moment2.default.utc(date).tz(userTimezone).format('M/D/YYYY [at] h:mma z');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	      var steps = [].concat(_toConsumableArray(translation.steps));
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap block-form' },
	            _react2.default.createElement(_Step2.default, {
	              step: this.state.step,
	              setStep: this.setStep,
	              data: steps,
	              skippable: this.state.skippable
	            }),
	            _react2.default.createElement(
	              'form',
	              { className: 'exam-form panel', onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this2.handleSubmit, 'form.exam-form');
	                }, noValidate: true },
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__header' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'panel__title' },
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    steps[this.state.step - 1]
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__body' },
	                _react2.default.createElement(_EditEnrollmentSection2.default, Object.assign({
	                  step: this.state.step,
	                  nextStep: this.nextStep,
	                  prevStep: this.prevStep,
	                  renderDefault: this.renderDefault,
	                  defaultDiff: this.defaultDiff
	                }, this.props, {
	                  enrollmentConfig: true,
	                  handleInput: this.handleInput
	                })),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel__actions actions' },
	                  this.state.configurationSid && !this.props.approval && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--secondary actions__btn--offset',
	                      type: 'button',
	                      onClick: function onClick(e) {
	                        return (0, _helpers.checkValidity)(e, function () {
	                          return _this2.handleSubmit(true);
	                        }, 'form.exam-form');
	                      }
	                    },
	                    translation.save_and_exit
	                  ),
	                  this.state.step > 1 && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--secondary',
	                      type: 'button',
	                      onClick: this.prevStep
	                    },
	                    translation.back
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'actions__btn actions__btn--primary' },
	                    translation.continue
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return EnrollmentException;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EnrollmentException')(EnrollmentException);

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDropzone = __webpack_require__(270);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Step = __webpack_require__(65);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExamAttachments = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamAttachments, _React$Component);
	
	  function ExamAttachments() {
	    _classCallCheck(this, ExamAttachments);
	
	    var _this = _possibleConstructorReturn(this, (ExamAttachments.__proto__ || Object.getPrototypeOf(ExamAttachments)).call(this));
	
	    _this.handleDrop = _this.handleDrop.bind(_this);
	    _this.handleDragEnter = _this.handleDragEnter.bind(_this);
	    _this.handleDragLeave = _this.handleDragLeave.bind(_this);
	    _this.removeFile = _this.removeFile.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExamAttachments, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var ExamStore = this.props.store.ExamStore;
	
	
	      this.state = {
	        attachment: [],
	        dropClass: ''
	      };
	
	      if (this.props.customConfiguration && this.props.customConfiguration.sid) {
	        ExamStore.getConfigurationData(this.props.exam.sid, this.props.customConfiguration.sid);
	      } else if (!this.props.exam.configuration.sid) {
	        ExamStore.getExam(this.props.examSid);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'handleDrop',
	    value: function handleDrop(file, rejected) {
	      var SessionStore = this.props.store.SessionStore;
	
	      var size = 0;
	
	      console.log(file);
	
	      if (file.length === 0) {
	        var dialogContent = this.props.translation.invalid;
	        SessionStore.showDialog(dialogContent);
	
	        this.setState({
	          dropClass: ''
	        });
	      } else {
	        file.forEach(function (file) {
	          if (file.size) {
	            size += file.size;
	          }
	        });
	      }
	
	      if (this.state.attachment.length + file.length <= 5 && size <= 4194304) {
	        var attachment = [].concat(_toConsumableArray(this.state.attachment.concat(file)));
	
	        this.setState({
	          attachment: attachment,
	          dropClass: ''
	        });
	      } else {
	        var _dialogContent = this.props.translation.limit;
	
	        if (size > 4194304) {
	          _dialogContent = this.props.translation.too_large;
	        }
	
	        SessionStore.showDialog(_dialogContent);
	
	        this.setState({
	          dropClass: ''
	        });
	      }
	
	      // Convert to binary data
	      // const _this = this;
	      // const newFile = file[0];
	      // const reader = new FileReader();
	      // let attachments = [...this.state.attachments];
	      //
	      // reader.onload = function(){
	      //   attachments.push(reader.result);
	      //   _this.setState({
	      //     attachments
	      //   });
	      // }
	      //
	      // reader.readAsBinaryString(newFile);
	    }
	  }, {
	    key: 'handleDragEnter',
	    value: function handleDragEnter() {
	      this.setState({
	        dropClass: 'file-drop--drag-enter'
	      });
	    }
	  }, {
	    key: 'handleDragLeave',
	    value: function handleDragLeave() {
	      this.setState({
	        dropClass: ''
	      });
	    }
	  }, {
	    key: 'removeFile',
	    value: function removeFile(i) {
	      var attachment = [].concat(_toConsumableArray(this.state.attachment));
	      attachment.splice(i, 1);
	
	      this.setState({
	        attachment: attachment
	      });
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile(file, index) {
	      var _this2 = this;
	
	      var _props = this.props,
	          exam = _props.exam,
	          store = _props.store,
	          translation = _props.translation;
	
	
	      var msg = {
	        heading: translation.delete_confirm.heading + ' ' + file + '?',
	        body: translation.delete_confirm.body,
	        button: translation.delete_confirm.button
	      };
	
	      var data = {
	        attachments: [file]
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return store.ExamStore.deleteExamAttachments(exam.sid, exam.configuration.sid, data, function () {
	          _this2.removeUploadedFile(index);
	        });
	      });
	    }
	  }, {
	    key: 'removeUploadedFile',
	    value: function removeUploadedFile(index) {
	      this.props.exam.configuration.attachments.splice(index, 1);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	
	      if (this.state.attachment.length > 0) {
	        var ExamStore = this.props.store.ExamStore;
	
	        var examSid = this.props.exam.sid;
	        var configurationSid = this.props.exam.configuration.sid;
	
	        if (this.props.customConfiguration) {
	          configurationSid = this.props.customConfiguration.sid;
	        }
	
	        var data = {
	          attachments: this.state.attachment
	        };
	
	        ExamStore.updateExamAttachments(examSid, configurationSid, data, this.props.complete);
	      } else {
	        this.props.complete();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          exam = _props2.exam,
	          translation = _props2.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      var configuration = exam.configuration;
	
	      if (this.props.customConfiguration) {
	        configuration = this.props.customConfiguration;
	      }
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: '' + (this.props.exception ? 'drawer__content' : 'page') },
	          _react2.default.createElement(
	            'header',
	            { className: '' + (this.props.exception ? 'drawer__header' : 'page__header') },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: '' + (this.props.exception ? 'drawer__title' : 'page__title') },
	                this.props.exception && _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.title_exception
	                ),
	                !this.props.exception && _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.title
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap block-form' },
	            _react2.default.createElement(_Step2.default, { step: this.props.step, setStep: this.props.setStep, data: translation.steps, skippable: this.props.skippable }),
	            _react2.default.createElement(
	              'form',
	              { className: 'exam-form panel', onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this3.handleSubmit, 'form.exam-form');
	                }, noValidate: true },
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__header' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'panel__title' },
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.heading
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__body' },
	                _react2.default.createElement(
	                  'fieldset',
	                  null,
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'fields' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      !this.props.readonly && _react2.default.createElement(
	                        _reactDropzone2.default,
	                        {
	                          className: 'file-drop ' + this.state.dropClass,
	                          onDrop: this.handleDrop,
	                          onDragEnter: this.handleDragEnter,
	                          onDragLeave: this.handleDragLeave,
	                          multiple: true,
	                          accept: 'audio/*, image/*, text/*, video/*, application/*, application/octet-stream',
	                          maxSize: 4194304
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'file-drop__label' },
	                          translation.attachment.label
	                        )
	                      ),
	                      configuration.attachments.length > 0 && _react2.default.createElement(
	                        'span',
	                        { className: 'form-subheading attachment-heading' },
	                        translation.existing
	                      ),
	                      configuration.attachments.map(function (file, i) {
	                        return _react2.default.createElement(
	                          'div',
	                          { key: i, className: 'file-drop__files' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            file.attachmentAwsTitle
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              className: 'btn--remove',
	                              type: 'button',
	                              onClick: function onClick() {
	                                _this3.deleteFile(file.attachmentAwsTitle, i);
	                              },
	                              disabled: _this3.props.readonly ? true : false
	                            },
	                            _react2.default.createElement(icons.iconMinus, null),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              translation.attachment.remove,
	                              ' ',
	                              file.attachmentAwsTitle
	                            )
	                          )
	                        );
	                      }),
	                      this.state.attachment.length > 0 && _react2.default.createElement(
	                        'span',
	                        { className: 'form-subheading attachment-heading' },
	                        translation.new
	                      ),
	                      this.state.attachment.map(function (file, i) {
	                        return _react2.default.createElement(
	                          'div',
	                          { key: i, className: 'file-drop__files' },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            file.name
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              className: 'btn--remove',
	                              type: 'button',
	                              onClick: function onClick() {
	                                _this3.removeFile(i);
	                              },
	                              disabled: _this3.props.readonly ? true : false
	                            },
	                            _react2.default.createElement(icons.iconMinus, null),
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              translation.attachment.remove,
	                              ' ',
	                              file.name
	                            )
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                !this.props.readonly && _react2.default.createElement(
	                  'div',
	                  { className: 'panel__actions actions' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--secondary',
	                      type: 'button',
	                      onClick: this.props.complete
	                    },
	                    translation.button_skip
	                  ),
	                  (configuration.attachments.length > 0 || this.state.attachment.length > 0) && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--primary',
	                      disabled: this.state.attachment.length === 0 && configuration.attachments.length === 0
	                    },
	                    translation.button
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ExamAttachments;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamAttachments')(ExamAttachments);

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Step = __webpack_require__(65);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _EditSection = __webpack_require__(352);
	
	var _EditSection2 = _interopRequireDefault(_EditSection);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	// Dependencies
	
	
	var ExamEdit = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamEdit, _React$Component);
	
	  function ExamEdit() {
	    _classCallCheck(this, ExamEdit);
	
	    var _this2 = _possibleConstructorReturn(this, (ExamEdit.__proto__ || Object.getPrototypeOf(ExamEdit)).call(this));
	
	    _this2.flagAutomatedOnly = function (automatedOnly, exam, disabledFields) {
	      return _react2.default.createElement(_EditSection2.default, Object.assign({
	        step: _this2.state.step,
	        nextStep: _this2.nextStep,
	        prevStep: _this2.prevStep,
	        renderDefault: _this2.renderDefault,
	        defaultDiff: _this2.defaultDiff
	      }, _this2.props, {
	        exam: exam,
	        handleInput: _this2.handleInput,
	        disabledFields: disabledFields,
	        submitted: _this2.state.submitted,
	        automatedOnly: automatedOnly,
	        proctorGroups: _this2.state.groups,
	        newExam: _this2.state.examSid === null
	      }));
	    };
	
	    _this2.setStep = _this2.setStep.bind(_this2);
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.prevStep = _this2.prevStep.bind(_this2);
	    _this2.renderDefault = _this2.renderDefault.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.complete = _this2.complete.bind(_this2);
	    _this2.handlePlatformVersion = _this2.handlePlatformVersion.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ExamEdit, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SettingsStore = _props$store.SettingsStore,
	          ProctorStore = _props$store.ProctorStore,
	          CourseStore = _props$store.CourseStore;
	      var pathname = this.props.routing.location.pathname;
	      var role = this.props.store.SessionStore.userData.role;
	
	
	      if (role.toLowerCase() === 'learner') {
	        this.props.routing.push({
	          pathname: 'unauthorized'
	        });
	      }
	
	      this.state = {
	        step: 1,
	        examSid: null,
	        skippable: false,
	        groups: []
	      };
	
	      if (pathname.indexOf('/edit') > -1) {
	        // Get the exam sid from the URL
	        var examSid = (0, _helpers.getURLSegment)(this, 3);
	
	        // Get the exam data with the sid
	        this.getExam(examSid);
	        this.setState({
	          examSid: examSid,
	          skippable: true
	        });
	      } else {
	        this.resetExam();
	      }
	
	      this.getFilteredProctorTypes();
	
	      // Get insitution settings so we can only show allowed permitted items
	      SettingsStore.getInstituteSettings(this);
	
	      // Gets proctor groups to determine whether or not to show virtual calc options 
	      ProctorStore.getProctorGroups(this);
	
	      // Make sure other exam attachments don’t interfere
	      ExamStore.deleteAttachments = [];
	      ExamStore.examAttachments = null;
	
	      // Get exams so we know if this is the first exam of the course
	      CourseStore.getExams(null, true);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.ExamStore.resetLMSExams();
	    }
	  }, {
	    key: 'getExam',
	    value: function getExam(sid) {
	      this.props.store.ExamStore.getExam(sid);
	    }
	  }, {
	    key: 'resetExam',
	    value: function resetExam() {
	      var ExamStore = this.props.store.ExamStore;
	      var type = this.props.routing.location.query.type;
	
	      var examType = 'Online';
	
	      if (type && type === 'written') {
	        examType = 'Written';
	      }
	
	      ExamStore.resetExam(examType);
	    }
	  }, {
	    key: 'getFilteredProctorTypes',
	    value: function getFilteredProctorTypes() {
	      this.props.store.SessionStore.getProctorGroupTypes();
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep() {
	      // if(this.state.step === translation.steps.length) {
	      //   // If we’re on the last step, go back to the exam detail view
	      //   const newPathname = pathname.replace('/edit', '').replace('/exams/add', '');
	      //   this.props.routing.push({
	      //     pathname: newPathname,
	      //     search: '?toaster=examSaved'
	      //   });
	      // } else {
	      // Remove submitted class from form
	      var form = document.querySelector('form.submitted');
	      if (form) {
	        form.classList.remove('submitted');
	      }
	
	      // Go to the next step
	      this.setState({
	        step: this.state.step + 1
	      });
	      // }
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'renderDefault',
	    value: function renderDefault() {
	      return '';
	    }
	  }, {
	    key: 'handlePlatformVersion',
	    value: function handlePlatformVersion(flagValue) {
	      var ExamStore = this.props.store.ExamStore;
	
	
	      if (flagValue && typeof flagValue === 'number') {
	        ExamStore.setPlatformVersion(flagValue);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'defaultDiff',
	    value: function defaultDiff() {
	      return '';
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(name, e, isConfiguration, date, time, isCheckbox, array, skipFormat, categorySid) {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      var data = null;
	      var value = null;
	
	      if (e) {
	        value = e.target.value;
	      }
	      // The API expects null for virtualCalculatorType
	      // if no type is selected, so we need to convert
	      // any empty string value to null.
	      if (!value && name === 'virtualCalculatorType') {
	        value = null;
	      }
	
	      // Make sure boolean values are boolean
	      if (value === 'true') {
	        value = true;
	      }
	      if (value === 'false') {
	        value = false;
	      }
	
	      // If we’re updating a date, we need to format it
	      if (date) {
	        date = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var timezone = (0, _moment2.default)(date + ' ' + time, 'YYYY-MM-DD HH:mm').tz(userTimezone).format('Z');
	        value = (0, _moment2.default)(date + ' ' + time + ' ' + timezone, 'YYYY-MM-DD HH:mm Z').toISOString();
	      } else if (date && skipFormat) {
	        value = date;
	      }
	
	      // If it’s a checkbox, get the checked state
	      if (isCheckbox) {
	        value = e.target.checked;
	      }
	
	      // If the data provided is an array
	      if (array) {
	        value = array;
	      }
	
	      if (isConfiguration) {
	        // If it’s a configuration property
	        if (categorySid) {
	          data = {
	            configuration: _defineProperty({}, name, _defineProperty({}, categorySid, value))
	          };
	        } else {
	          data = {
	            configuration: _defineProperty({}, name, value)
	          };
	        }
	      } else {
	        data = _defineProperty({}, name, value);
	      }
	
	      this.props.store.ExamStore.updateExamData(data, isConfiguration, categorySid);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(exit) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          CourseStore = _props$store2.CourseStore,
	          ExamStore = _props$store2.ExamStore,
	          SessionStore = _props$store2.SessionStore,
	          SettingsStore = _props$store2.SettingsStore,
	          SyncStore = _props$store2.SyncStore;
	      var exam = ExamStore.exam;
	      var configuration = exam.configuration;
	
	      var shouldSyncRoster = false;
	
	      // If sync is enabled and this is the first exam for the course toggle sync tallies
	      if (SettingsStore.integration.syncEnrollments && CourseStore.exams.length === 0) {
	        shouldSyncRoster = true;
	      }
	
	      this.setState({
	        submitted: null
	      });
	
	      // Don’t submit until the last step
	      if (exit === true) {
	        this.setStep(null, translation.steps.length);
	      } else if (this.state.step === translation.steps.length) {
	        var callback = function callback(examSid, configurationSid) {
	          _this3.handleAttachments(examSid, configurationSid, !shouldSyncRoster);
	        };
	
	        // Make sure at least 1 proctor type has been chosen
	        if (configuration.proctorTypes.length > 0) {
	          // Trigger the tally loading view
	          SessionStore.tallyLoad = true;
	
	          if (this.state.examSid) {
	            // If we’re editing, update the exam
	            SessionStore.tallySteps.push('UpdateExam');
	            ExamStore.updateExam(this.state.examSid, callback);
	          } else {
	            // Otherwise post a new exam
	            SessionStore.tallySteps.push('CreateExam');
	            ExamStore.createExam(callback, this);
	          }
	
	          // Add tally step for removed attachments
	          if (ExamStore.deleteAttachments.length > 0) {
	            SessionStore.tallySteps.push('DeleteExamAttachments');
	          }
	
	          // Add tally step for new attachments
	          if (exam.type.toLowerCase() === 'online' && ExamStore.examAttachments || exam.type.toLowerCase() === 'written' && ExamStore.examFiles) {
	            SessionStore.tallySteps.push('UpdateExamAttachments');
	          }
	        } else {
	          // Let the user know that no proctor types are selected
	          var dialogContent = translation.proctor_warning;
	          SessionStore.showDialog(dialogContent);
	        }
	
	        // Sync course roster if necessary
	        if (shouldSyncRoster) {
	          SessionStore.tallySteps.push('scheduleSync');
	          SessionStore.tallySteps.push('scheduleSyncCheck');
	          SessionStore.tallyConfirmClose = true;
	
	          var syncCallback = function syncCallback() {
	            CourseStore.checkLastCourseSync(_moment2.default.utc(), 0);
	          };
	
	          var failCallback = function failCallback() {
	            // Send this at the attempt limit to force red check on tally page
	            CourseStore.checkLastCourseSync(_moment2.default.utc(), 23);
	          };
	          var syncData = { type: 'enrollments', sid: SessionStore.userData.courseSid };
	          SyncStore.scheduleSync(syncData, syncCallback, failCallback, true);
	        }
	      } else {
	        this.nextStep();
	      }
	    }
	  }, {
	    key: 'handleAttachments',
	    value: function handleAttachments(examSid, configurationSid, handleComplete) {
	      var _this4 = this;
	
	      var ExamStore = this.props.store.ExamStore;
	      var exam = ExamStore.exam;
	
	      // Handle new attachments and deleted attachments
	
	      if (ExamStore.deleteAttachments.length > 0) {
	        // New attachments
	        var callback = null;
	
	        if ((exam.type.toLowerCase() === 'online' && !ExamStore.examAttachments || exam.type.toLowerCase() === 'written' && !ExamStore.examFiles) && handleComplete) {
	          // If there aren’t any to update, run
	          // the complete function after uploading
	          callback = this.complete;
	        } else {
	          // Otherwise, run the update endpoint
	          callback = function callback() {
	            return _this4.updateAttachments(examSid, configurationSid, handleComplete);
	          };
	        }
	
	        this.deleteAttachments(examSid, configurationSid, callback);
	      } else if (exam.type.toLowerCase() === 'online' && ExamStore.examAttachments || exam.type.toLowerCase() === 'written' && ExamStore.examFiles) {
	        this.updateAttachments(examSid, configurationSid, handleComplete);
	      } else if (handleComplete) {
	        // Otherwise, just finish
	        this.complete();
	      }
	    }
	  }, {
	    key: 'deleteAttachments',
	    value: function deleteAttachments(examSid, configurationSid, callback) {
	      var ExamStore = this.props.store.ExamStore;
	      var exam = ExamStore.exam;
	
	      // Delete API call
	
	      var deleteData = null;
	
	      // Changes here may need to also be made to ExamException.js, just check it
	
	      if (exam.type.toLowerCase() === 'online') {
	        deleteData = {
	          attachments: ExamStore.deleteAttachments
	        };
	      } else {
	        deleteData = {
	          examFiles: ExamStore.deleteAttachments
	        };
	      }
	
	      ExamStore.deleteExamAttachments(examSid, configurationSid, deleteData, callback);
	    }
	  }, {
	    key: 'updateAttachments',
	    value: function updateAttachments(examSid, configurationSid, handleComplete) {
	      var ExamStore = this.props.store.ExamStore;
	      var exam = ExamStore.exam;
	
	
	      var uploadData = null;
	
	      if (exam.type.toLowerCase() === 'online') {
	        uploadData = {
	          attachments: ExamStore.examAttachments
	        };
	      } else {
	        uploadData = {
	          examFiles: ExamStore.examFiles
	        };
	      }
	
	      ExamStore.updateExamAttachments(examSid, configurationSid, uploadData, handleComplete ? this.complete : null);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      var _this = this;
	      var ExamStore = this.props.store.ExamStore;
	
	      // Clear out examFiles and examAttachments
	      // since they have already been handled
	
	      ExamStore.examAttachments = null;
	      ExamStore.examFiles = null;
	
	      // Set a small timeout so the transition
	      // from tally loader to next screen
	      // isn’t as jarring
	      setTimeout(function () {
	        // Redirect
	        var newPathname = '';
	        var segment1 = (0, _helpers.getURLSegment)(_this, 1);
	        var segment2 = (0, _helpers.getURLSegment)(_this, 2);
	
	        if (segment2 === 'add') {
	          newPathname = segment1 + '/' + _this.state.examSid;
	        } else {
	          var examSid = (0, _helpers.getURLSegment)(_this, 3);
	          newPathname = segment1 + '/' + examSid;
	        }
	
	        _this.props.routing.push({
	          pathname: newPathname,
	          search: '?toaster=examSaved'
	        });
	      }, 500);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          ExamStore = _props$store3.ExamStore,
	          SessionStore = _props$store3.SessionStore,
	          SettingsStore = _props$store3.SettingsStore;
	      var exam = ExamStore.exam,
	          importedLmsExam = ExamStore.importedLmsExam;
	
	
	      if (!SessionStore.loading && SettingsStore.settings && !SessionStore.tallyLoad) {
	        var disabledFields = null;
	
	        if (exam.configuration.apiExamId || Object.keys(importedLmsExam).length > 0) {
	          disabledFields = ['title', 'duration', 'password', 'attempts', 'examOpenDate', 'examCloseDate', 'url', 'isLimitedScope'];
	        }
	
	        var invalidCallback = function invalidCallback() {
	          _this5.setState({
	            submitted: true
	          });
	        };
	
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              (0, _helpers.getURLSegment)(this, 2) === 'add' && _react2.default.createElement(
	                'h1',
	                { className: 'page__title' },
	                translation.page_title_add
	              ),
	              (0, _helpers.getURLSegment)(this, 2) !== 'add' && _react2.default.createElement(
	                'h1',
	                { className: 'page__title' },
	                translation.page_title
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap block-form' },
	            _react2.default.createElement(_Step2.default, {
	              step: this.state.step,
	              setStep: this.setStep,
	              data: translation.steps,
	              skippable: this.state.skippable
	            }),
	            _react2.default.createElement(
	              'form',
	              {
	                className: 'exam-form panel',
	                onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this5.handleSubmit, 'form.exam-form', invalidCallback);
	                },
	                noValidate: true
	              },
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__header' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'panel__title' },
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.steps[this.state.step - 1]
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__body' },
	                _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                  flagKey: 'virtual-test-center-version',
	                  renderFeatureCallback: this.handlePlatformVersion,
	                  renderDefaultCallback: this.handlePlatformVersion
	                }),
	                _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                  flagKey: 'automated-only',
	                  renderFeatureCallback: function renderFeatureCallback(automatedOnly) {
	                    return _this5.flagAutomatedOnly(automatedOnly, exam, disabledFields);
	                  },
	                  renderDefaultCallback: function renderDefaultCallback(automatedOnly) {
	                    return _this5.flagAutomatedOnly(automatedOnly, exam, disabledFields);
	                  }
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel__actions actions' },
	                  this.state.examSid && this.state.step !== translation.steps.length && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--secondary actions__btn--offset',
	                      type: 'button',
	                      onClick: function onClick(e) {
	                        return (0, _helpers.checkValidity)(e, function () {
	                          return _this5.handleSubmit(true);
	                        }, 'form.exam-form');
	                      }
	                    },
	                    translation.save_and_exit
	                  ),
	                  this.state.step > 1 && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--secondary',
	                      type: 'button',
	                      onClick: this.prevStep
	                    },
	                    translation.back
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'actions__btn actions__btn--primary'
	                    },
	                    this.state.step !== translation.steps.length && translation.continue,
	                    this.state.step === translation.steps.length && translation.confirm
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ExamEdit;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamEdit')(ExamEdit);

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var mobx = _interopRequireWildcard(_mobx);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Step = __webpack_require__(65);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _EditSection = __webpack_require__(352);
	
	var _EditSection2 = _interopRequireDefault(_EditSection);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	// Dependencies
	
	
	var ExamException = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamException, _React$Component);
	
	  function ExamException() {
	    _classCallCheck(this, ExamException);
	
	    var _this2 = _possibleConstructorReturn(this, (ExamException.__proto__ || Object.getPrototypeOf(ExamException)).call(this));
	
	    _this2.flagAutomatedOnly = function (automatedOnly, exam, disabledFields, query, configuration) {
	      return _react2.default.createElement(_EditSection2.default, Object.assign({
	        step: _this2.state.step,
	        nextStep: _this2.nextStep,
	        prevStep: _this2.prevStep,
	        renderDefault: _this2.renderDefault,
	        defaultDiff: _this2.defaultDiff,
	        momentFormat: _this2.momentFormat,
	        exception: _this2.props.approval ? query.exception && query.exception === 'true' ? true : false : true
	      }, _this2.props, {
	        exam: exam,
	        handleInput: _this2.handleInput,
	        customConfiguration: configuration,
	        approval: _this2.props.approval,
	        readonly: _this2.props.readonly,
	        disabledFields: disabledFields,
	        submitted: _this2.state.submitted,
	        automatedOnly: automatedOnly,
	        proctorGroups: _this2.state.groups,
	        scheduled: _this2.state.scheduled
	      }));
	    };
	
	    _this2.setStep = _this2.setStep.bind(_this2);
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.prevStep = _this2.prevStep.bind(_this2);
	    _this2.renderDefault = _this2.renderDefault.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.handleApprove = _this2.handleApprove.bind(_this2);
	    _this2.complete = _this2.complete.bind(_this2);
	    _this2.momentFormat = _this2.momentFormat.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ExamException, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SettingsStore = _props$store.SettingsStore,
	          ProctorStore = _props$store.ProctorStore;
	
	      var configurationSid = this.props.routing.location.query.accommodation || this.props.routing.location.query.changeRequest;
	
	      if (this.props.approval) {
	        configurationSid = (0, _helpers.getURLSegment)(this, 6);
	      }
	
	      this.state = {
	        step: 1,
	        enrollmentSid: this.props.routing.location.query.enrollment,
	        configurationSid: configurationSid,
	        examSid: null,
	        scheduled: false,
	        skippable: false,
	        locked: true,
	        groups: []
	
	        // Get the exam sid from the URL
	      };var examSid = null;
	      var sessionSid = null;
	
	      if (this.props.approval) {
	        examSid = (0, _helpers.getURLSegment)(this, 4);
	      } else {
	        examSid = (0, _helpers.getURLSegment)(this, 2);
	        sessionSid = (0, _helpers.getParam)('session', window.location.href);
	      }
	
	      if (examSid && sessionSid) {
	        var callback = function callback(response) {
	          if (response.data.status === 'Scheduled') {
	            _this3.setState({ scheduled: true });
	            ExamStore.resetExamSession();
	          }
	        };
	        ExamStore.getExamSession(examSid, sessionSid, callback);
	      }
	
	      this.setState({
	        examSid: examSid
	      });
	
	      if (typeof this.state.configurationSid !== 'undefined') {
	        // If a configurationSid is present, get that configuration data otherwise remove the data
	        this.getConfiguration(examSid);
	
	        this.setState({
	          skippable: true
	        });
	      } else {
	        // Otherwise use the default exam data
	        ExamStore.setConfigurationData(examSid);
	
	        // If this is a cross listed student, remove proctor types
	        if (this.props.crossListed) {
	          ExamStore.configuration.proctorTypes = [];
	        }
	      }
	
	      this.getFilteredProctorTypes();
	      ProctorStore.getProctorGroups(this);
	
	      // Make sure we have the default exam data
	      if (!this.props.store.ExamStore.exam.title) {
	        var courseSid = (0, _helpers.getURLSegment)(this, 8);
	
	        if (courseSid) {
	          ExamStore.getExam(examSid, courseSid);
	        } else {
	          ExamStore.getExam(examSid);
	        }
	      }
	
	      // Get insitution settings so we can only show allowed permitted items
	      SettingsStore.getInstituteSettings(this);
	
	      // Make sure other exam attachments don’t interfere
	      ExamStore.deleteAttachments = [];
	      ExamStore.examAttachments = null;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.approval) {
	        this.props.store.ExamStore.resetExam();
	      }
	    }
	  }, {
	    key: 'resetConfiguration',
	    value: function resetConfiguration() {
	      this.props.store.ExamStore.resetConfigurationData();
	    }
	  }, {
	    key: 'getConfiguration',
	    value: function getConfiguration(examSid) {
	      var courseSid = (0, _helpers.getURLSegment)(this, 8);
	
	      if (courseSid) {
	        this.props.store.ExamStore.getConfigurationData(examSid, this.state.configurationSid, courseSid);
	      } else {
	        this.props.store.ExamStore.getConfigurationData(examSid, this.state.configurationSid);
	      }
	    }
	  }, {
	    key: 'getFilteredProctorTypes',
	    value: function getFilteredProctorTypes() {
	      this.props.store.SessionStore.getProctorGroupTypes();
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep() {
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(name, e, isConfiguration, date, time, isCheckbox, array, skipFormat, categorySid) {
	      var data = null;
	      var value = null;
	
	      if (e) {
	        value = e.target.value;
	      }
	
	      // Make sure boolean values are boolean
	      if (value === 'true') {
	        value = true;
	      }
	      if (value === 'false') {
	        value = false;
	      }
	
	      // If we’re updating a date, we need to format it
	      if (date) {
	        date = (0, _moment2.default)(date).format('YYYY-MM-DD Z');
	        value = (0, _moment2.default)(date + ' ' + time, 'YYYY-MM-DD Z HH:mm').toISOString();
	      }
	
	      // If it’s a checkbox, get the checked state
	      if (isCheckbox) {
	        value = e.target.checked;
	      }
	
	      // If the data provided is an array
	      if (array) {
	        value = array;
	      }
	
	      if (categorySid) {
	        data = _defineProperty({}, name, _defineProperty({}, categorySid, value));
	      } else {
	        data = _defineProperty({}, name, value);
	      }
	
	      if (isConfiguration) {
	        this.props.store.ExamStore.updateConfigurationData(data, categorySid);
	      } else {
	        this.props.store.ExamStore.updateExamData(data);
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(exit) {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          ExamStore = _props$store2.ExamStore,
	          SessionStore = _props$store2.SessionStore;
	      var configuration = ExamStore.configuration,
	          exam = ExamStore.exam;
	
	
	      this.setState({
	        submitted: null
	      });
	
	      // Don’t submit until the last step
	      if (exit === true) {
	        this.setStep(null, translation.steps.length);
	      } else if (this.state.step === translation.steps.length) {
	        var callback = null;
	
	        callback = function callback(examSid, configurationSid) {
	          _this4.handleAttachments(examSid, configurationSid);
	        };
	
	        // Make sure at least 1 proctor type has been chosen
	        if (configuration.proctorTypes && configuration.proctorTypes.length > 0 || this.props.crossListed) {
	          // Trigger the tally loading view
	          SessionStore.tallyLoad = true;
	
	          if (!this.state.configurationSid) {
	            // If we’re not editing, create a configuration
	            SessionStore.tallySteps.push('CreateConfiguration');
	
	            ExamStore.createConfiguration(this.state.examSid, this.state.enrollmentSid, callback, this.props.defaultConfigSid);
	          } else {
	            // Otherwise, update the configuration
	            SessionStore.tallySteps.push('UpdateConfiguration');
	
	            var courseSid = (0, _helpers.getURLSegment)(this, 8);
	
	            if (courseSid) {
	              var query = this.props.routing.location.query;
	
	              var callback2 = null;
	
	              if (!query.exception || query.exception === 'false') {
	                callback2 = function callback2() {
	                  ExamStore.updateExam(_this4.state.examSid, null, true, courseSid);
	                };
	              }
	
	              ExamStore.updateConfiguration(this.state.examSid, this.state.configurationSid, callback, courseSid, callback2);
	            } else {
	              ExamStore.updateConfiguration(this.state.examSid, this.state.configurationSid, callback);
	            }
	          }
	          // Add tally step for new attachments
	          if (exam.type.toLowerCase() === 'online' && ExamStore.examAttachments || exam.type.toLowerCase() === 'written' && ExamStore.examFiles) {
	            SessionStore.tallySteps.push('UpdateExamAttachments');
	          }
	
	          // Add tally step for removed attachments
	          if (ExamStore.deleteAttachments.length > 0) {
	            SessionStore.tallySteps.push('DeleteExamAttachments');
	          }
	        } else {
	          // Let the user know that no proctor types are selected
	          var dialogContent = translation.proctor_warning;
	          SessionStore.showDialog(dialogContent);
	        }
	      } else {
	        this.nextStep();
	      }
	    }
	  }, {
	    key: 'handleAttachments',
	    value: function handleAttachments(examSid, configurationSid) {
	      var _this5 = this;
	
	      var ExamStore = this.props.store.ExamStore;
	      var exam = ExamStore.exam;
	
	      // Handle new attachments and deleted attachments
	
	      if (exam.type.toLowerCase() === 'online' && ExamStore.examAttachments || exam.type.toLowerCase() === 'written' && ExamStore.examFiles) {
	        // New attachments
	        var callback = null;
	
	        if (ExamStore.deleteAttachments.length === 0) {
	          // If there aren’t any to delete, run
	          // the complete function after uploading
	          if (this.props.approval) {
	            callback = this.handleApprove;
	          } else {
	            callback = this.complete;
	          }
	        } else {
	          // Otherwise, run the delete endpoint
	          callback = function callback() {
	            return _this5.deleteAttachments(examSid, configurationSid);
	          };
	        }
	
	        // Upload API call
	        var uploadData = null;
	
	        if (exam.type.toLowerCase() === 'online') {
	          uploadData = {
	            attachments: ExamStore.examAttachments
	          };
	        } else {
	          uploadData = {
	            examFiles: ExamStore.examFiles
	          };
	        }
	
	        ExamStore.updateExamAttachments(examSid, configurationSid, uploadData, callback);
	      } else if (ExamStore.deleteAttachments.length > 0) {
	        this.deleteAttachments(examSid, configurationSid);
	      } else {
	        // Otherwise, just finish
	        if (this.props.approval) {
	          this.handleApprove();
	        } else {
	          this.complete();
	        }
	      }
	    }
	  }, {
	    key: 'deleteAttachments',
	    value: function deleteAttachments(examSid, configurationSid) {
	      var ExamStore = this.props.store.ExamStore;
	      var exam = ExamStore.exam;
	
	      // Delete API call
	
	      var deleteData = null;
	
	      // Changes here may need to also be made to ExamEdit.js, just check it
	
	      if (exam.type.toLowerCase() === 'online') {
	        deleteData = {
	          attachments: ExamStore.deleteAttachments
	        };
	      } else {
	        deleteData = {
	          examFiles: ExamStore.deleteAttachments
	        };
	      }
	
	      var callback = null;
	
	      if (this.props.approval) {
	        callback = this.handleApprove;
	      } else {
	        callback = this.complete;
	      }
	
	      ExamStore.deleteExamAttachments(examSid, configurationSid, deleteData, callback);
	    }
	  }, {
	    key: 'handleApprove',
	    value: function handleApprove() {
	      var ExamStore = this.props.store.ExamStore;
	
	
	      var data = {
	        "approved": true,
	        "locked": this.state.locked
	      };
	
	      var courseSid = (0, _helpers.getURLSegment)(this, 8);
	
	      ExamStore.updateExamApproval(this.state.examSid, this.state.configurationSid, data, this.complete, courseSid);
	    }
	  }, {
	    key: 'complete',
	    value: function complete(sid) {
	      var _this = this;
	      var pathname = this.props.routing.location.pathname;
	      var translation = this.props.translation;
	
	      // Set a small timeout so the transition
	      // from tally loader to next screen
	      // isn’t as jarring
	
	      setTimeout(function () {
	        _this.props.routing.push({
	          pathname: pathname,
	          search: null
	        });
	
	        if (!_this.props.approval && !_this.props.changeRequest) {
	          (0, _helpers.closeDrawer)(null, _this.props.parent);
	          _this.props.getEnrollments(_this.state.examSid);
	          _this.props.store.SessionStore.showToaster(translation.configuration_saved, 'success');
	        } else if (!_this.props.approval && _this.props.changeRequest) {
	          (0, _helpers.closeDrawer)(null, _this.props.parent);
	          _this.props.getEnrollments(_this.state.examSid);
	          _this.props.getExam(_this.state.examSid);
	          _this.props.store.SessionStore.showToaster(translation.change_request_saved, 'success');
	        } else {
	          (0, _helpers.closeDrawer)(null, _this.props.parent, (0, _helpers.getURLSegment)(_this, 1));
	          _this.props.store.ExamStore.getExamApprovals();
	          _this.props.store.SessionStore.showToaster(translation.configuration_approved, 'success');
	        }
	      }, 500);
	    }
	  }, {
	    key: 'renderDefault',
	    value: function renderDefault(field, format, checkbox, checkboxVal) {
	      var translation = this.props.translation;
	      var ExamStore = this.props.store.ExamStore;
	
	      // Some of the exam properties are nested in
	      // an object called configuration, while others
	      // are not, so we need to figure out which
	      // situation applies to this property
	
	      var obj = ExamStore.exam;
	      var defaultVal = null;
	
	      if (!field) {
	        return obj;
	      }
	
	      var prop = void 0,
	          props = field.split('.');
	
	      for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
	        prop = props[i];
	
	        var candidate = obj[prop];
	        if (candidate !== undefined) {
	          obj = candidate;
	        } else {
	          break;
	        }
	      }
	
	      defaultVal = obj[props[i]];
	
	      // Output the default value
	      if (format) {
	        // If there’s a format specified (e.g. format minute as hours)
	        return _react2.default.createElement(
	          'span',
	          { className: 'fields__default' },
	          'Default: ',
	          format(defaultVal)
	        );
	      } else if (checkbox) {
	        // If the field is a checkbox
	        var checkboxState = translation.disabled;
	        var convertedDefault = mobx.toJS(defaultVal);
	
	        // If the default value is an array, check if this value is included in it
	        // or if it’s a string, check if it is equal to this value
	        if (convertedDefault && (typeof convertedDefault === 'undefined' ? 'undefined' : _typeof(convertedDefault)) === 'object' && convertedDefault.indexOf(checkboxVal) > -1 || typeof convertedDefault === 'string' && convertedDefault === checkboxVal || convertedDefault && typeof convertedDefault === 'boolean') {
	          checkboxState = translation.enabled;
	        }
	
	        return _react2.default.createElement(
	          'span',
	          { className: 'fields__default' },
	          'Default: ',
	          checkboxState
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'fields__default' },
	          'Default: ',
	          defaultVal
	        );
	      }
	    }
	  }, {
	    key: 'momentFormat',
	    value: function momentFormat(date) {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      return _moment2.default.utc(date).tz(userTimezone).format('M/D/YYYY [at] h:mma z');
	    }
	
	    // Add a class to conditionally style fields that differ from the default
	
	  }, {
	    key: 'defaultDiff',
	    value: function defaultDiff(field) {
	      var ExamStore = this.store.ExamStore;
	
	      var examDefault = ExamStore.exam.configuration[field] || '';
	      var configDefault = ExamStore.configuration[field] || '';
	
	      // If the exam configuration value (default value) is different from this configuration value
	      if (examDefault.toString() !== configDefault.toString()) {
	        return 'field--diff';
	      }
	
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          ExamStore = _props$store3.ExamStore,
	          SessionStore = _props$store3.SessionStore;
	      var exam = ExamStore.exam,
	          configuration = ExamStore.configuration;
	      var query = this.props.routing.location.query;
	
	      var steps = [].concat(_toConsumableArray(translation.steps));
	
	      var headingKey = 'heading';
	
	      if (query.exception && query.exception === 'true') {
	        headingKey = 'heading_review_exception';
	      } else if (query.exception && query.exception === 'false') {
	        headingKey = 'heading_review_exam';
	      }
	
	      var invalidCallback = function invalidCallback() {
	        _this6.setState({
	          submitted: true
	        });
	      };
	
	      if (typeof this.state.configurationSid !== 'undefined' && configuration || typeof this.state.configurationSid === 'undefined') {
	        if (!SessionStore.loading && !SessionStore.tallyLoad) {
	          var disabledFields = null;
	
	          if (exam.configuration.apiExamId && this.props.approval && (!query.exception || query.exception === 'false')) {
	            disabledFields = ['title', 'duration', 'password', 'attempts', 'examOpenDate', 'examCloseDate', 'url'];
	          }
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'drawer__content' },
	            _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                !this.props.changeRequest && _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation[headingKey]
	                ),
	                this.props.changeRequest && _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.heading_change
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap block-form' },
	              _react2.default.createElement(_Step2.default, {
	                step: this.state.step,
	                setStep: this.setStep,
	                data: steps,
	                skippable: this.state.skippable
	              }),
	              _react2.default.createElement(
	                'form',
	                {
	                  className: 'exam-form panel',
	                  onSubmit: function onSubmit(e) {
	                    return (0, _helpers.checkValidity)(e, _this6.handleSubmit, 'form.exam-form', invalidCallback);
	                  },
	                  noValidate: true
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel__header' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'panel__title' },
	                    _react2.default.createElement(
	                      'legend',
	                      null,
	                      steps[this.state.step - 1]
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel__body' },
	                  _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                    flagKey: 'automated-only',
	                    renderFeatureCallback: function renderFeatureCallback(automatedOnly) {
	                      return _this6.flagAutomatedOnly(automatedOnly, exam, disabledFields, query, configuration);
	                    },
	                    renderDefaultCallback: function renderDefaultCallback(automatedOnly) {
	                      return _this6.flagAutomatedOnly(automatedOnly, exam, disabledFields, query, configuration);
	                    }
	                  }),
	                  !this.props.readonly && _react2.default.createElement(
	                    'div',
	                    { className: 'panel__actions actions' },
	                    this.state.configurationSid && !this.props.approval && this.state.step !== translation.steps.length && _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'actions__btn actions__btn--secondary actions__btn--offset',
	                        type: 'button',
	                        onClick: function onClick(e) {
	                          return (0, _helpers.checkValidity)(e, function () {
	                            return _this6.handleSubmit(true);
	                          }, 'form.exam-form');
	                        }
	                      },
	                      translation.save_and_exit
	                    ),
	                    this.state.step > 1 && _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'actions__btn actions__btn--secondary',
	                        type: 'button',
	                        onClick: this.prevStep
	                      },
	                      translation.back
	                    ),
	                    (this.props.approval && this.state.step < steps.length || !this.props.approval) && _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'actions__btn actions__btn--primary',
	                        type: 'submit'
	                      },
	                      this.state.step !== translation.steps.length && translation.continue,
	                      this.state.step === translation.steps.length && translation.confirm
	                    ),
	                    this.props.approval && this.state.step === steps.length && _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'actions__btn actions__btn--primary'
	                      },
	                      translation.approve
	                    ),
	                    this.props.approval && this.state.step === steps.length && _react2.default.createElement(
	                      'div',
	                      { className: 'actions__opt' },
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'config-locked' },
	                        translation.lock
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        id: 'config-locked',
	                        className: 'switch-input',
	                        ref: function ref(input) {
	                          _this6.locked = input;
	                        },
	                        onChange: function onChange() {
	                          return _this6.setState({ locked: !_this6.state.locked });
	                        },
	                        onKeyDown: _helpers.handleSwitchInputKeys,
	                        defaultChecked: true
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'switch-label', htmlFor: 'config-locked' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'meta' },
	                          translation.lock
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return ExamException;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamException')(ExamException);

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _FauxSelect = __webpack_require__(97);
	
	var _FauxSelect2 = _interopRequireDefault(_FauxSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var ExamType = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamType, _React$Component);
	
	  function ExamType() {
	    _classCallCheck(this, ExamType);
	
	    var _this2 = _possibleConstructorReturn(this, (ExamType.__proto__ || Object.getPrototypeOf(ExamType)).call(this));
	
	    _this2.selectExam = _this2.selectExam.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ExamType, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this = this;
	
	      var callback = function callback() {
	        _this.props.routing.push('exams/add');
	      };
	
	      this.props.store.ExamStore.resetLMSExams();
	      this.props.store.ExamStore.getLMSExams(callback);
	    }
	  }, {
	    key: 'selectExam',
	    value: function selectExam(e, props, i) {
	      this.props.store.ExamStore.selectLMSExam(i);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore;
	      var lmsExams = ExamStore.lmsExams;
	
	      var actions = [];
	
	      if (!SessionStore.loading) {
	        for (var i = 0; i < lmsExams.length; i++) {
	          // Create option object
	          var action = {
	            title: lmsExams[i].title
	          };
	
	          actions.push(action);
	        }
	
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--medium panel--medium-alt' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'meta' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__sections' },
	              _react2.default.createElement(
	                'section',
	                { className: 'panel__half' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  _react2.default.createElement(icons.iconImport, null),
	                  translation.import.heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.import.body
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'note' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    translation.import.not_showing.description
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    null,
	                    translation.import.not_showing.reasons.map(function (reason) {
	                      return _react2.default.createElement(
	                        'li',
	                        null,
	                        reason
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(_FauxSelect2.default, {
	                  'default': translation.new.select,
	                  options: actions,
	                  onClick: this.selectExam,
	                  noTooltip: true
	                }),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { className: 'btn', to: 'exams/add' },
	                  translation.import.button
	                )
	              ),
	              _react2.default.createElement(
	                'section',
	                { className: 'panel__half' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  _react2.default.createElement(icons.iconPaper, null),
	                  translation.new.heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.new.body
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { className: 'btn', to: 'exams/add' },
	                  translation.new.button
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ExamType;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamType')(ExamType);

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTextareaAutosize = __webpack_require__(74);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeSelect = __webpack_require__(80);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var AddFundingRule = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AddFundingRule, _React$Component);
	
	  function AddFundingRule() {
	    _classCallCheck(this, AddFundingRule);
	
	    var _this2 = _possibleConstructorReturn(this, (AddFundingRule.__proto__ || Object.getPrototypeOf(AddFundingRule)).call(this));
	
	    _this2.handleStartChange = _this2.handleStartChange.bind(_this2);
	    _this2.handleEndChange = _this2.handleEndChange.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.complete = _this2.complete.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(AddFundingRule, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.state = {
	        startDate: null,
	        endDate: null,
	        fundingRuleData: {
	          amount: 0,
	          title: null,
	          description: '',
	          units: '$',
	          currency: null,
	          appliesTo: null,
	          effectiveDate: null,
	          expirationDate: null,
	          courseSid: '',
	          enrollmentSid: '',
	          examSid: '',
	          userSid: '',
	          courseOfferingSid: ''
	        }
	      };
	
	      SessionStore.getCurrencies();
	
	      if (this.props.fundingRuleSid) {
	        // If a funding rule sid is provided, get that rule
	        this.getFundingRule();
	      } else {
	        // Otherwise make sure there’s no rule data in the store
	        this.resetFundingRule();
	      }
	
	      if (this.props.courseSid || this.props.enrollmentSid || this.props.examSid || this.props.userSid || this.props.offeringSid) {
	        var fundingRuleData = Object.assign({}, this.state.fundingRuleData);
	
	        if (this.props.courseSid) {
	          fundingRuleData.courseSid = this.props.courseSid;
	        }
	        if (this.props.enrollmentSid) {
	          fundingRuleData.enrollmentSid = this.props.enrollmentSid;
	        }
	        if (this.props.examSid) {
	          fundingRuleData.examSid = this.props.examSid;
	        }
	        if (this.props.userSid) {
	          fundingRuleData.userSid = this.props.userSid;
	        }
	        if (this.props.offeringSid) {
	          fundingRuleData.courseOfferingSid = this.props.offeringSid;
	        }
	
	        this.setState({
	          fundingRuleData: fundingRuleData
	        });
	      }
	    }
	  }, {
	    key: 'getFundingRule',
	    value: function getFundingRule() {
	      this.props.store.FundingRuleStore.getFundingRule(this.props.fundingRuleSid, this);
	    }
	  }, {
	    key: 'resetFundingRule',
	    value: function resetFundingRule() {
	      this.props.store.FundingRuleStore.resetFundingRule(this.props.fundingRuleSid);
	    }
	  }, {
	    key: 'handleStartChange',
	    value: function handleStartChange(date, isDateField) {
	      if (isDateField) {
	        this.setState({
	          startDate: date
	        });
	      } else {
	        date = this.state.startDate;
	      }
	
	      var time = this.startTime.value;
	
	      // Update form data
	      this.updateDates(date, time, 'effectiveDate');
	    }
	  }, {
	    key: 'handleEndChange',
	    value: function handleEndChange(date, isDateField) {
	      if (isDateField) {
	        this.setState({
	          endDate: date
	        });
	      } else {
	        date = this.state.endDate;
	      }
	
	      var time = this.endTime.value;
	
	      // Update form data
	      this.updateDates(date, time, 'expirationDate');
	    }
	  }, {
	    key: 'updateDates',
	    value: function updateDates(date, time, whichDate) {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var fundingRuleData = Object.assign({}, this.state.fundingRuleData);
	
	      var dateString = (0, _moment2.default)(date).format('YYYY-MM-DD');
	      var timezoneString = (0, _moment2.default)(date).tz(userTimezone).format('Z');
	      fundingRuleData[whichDate] = _moment2.default.utc(dateString + ' ' + time + ' ' + timezoneString, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
	
	      this.setState({
	        fundingRuleData: fundingRuleData
	      });
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(e, checkbox, ref) {
	      var fundingRuleData = Object.assign({}, this.state.fundingRuleData);
	
	      fundingRuleData.amount = this.amount.value || '';
	      fundingRuleData.title = this.title.value || '';
	      fundingRuleData.description = this.description.value || '';
	      fundingRuleData.units = this.units.value || '';
	
	      fundingRuleData.appliesTo = this.appliesTo.value || '';
	
	      if (this.currency) {
	        fundingRuleData.currency = this.currency.value || null;
	      }
	
	      this.setState({
	        fundingRuleData: fundingRuleData
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var FundingRuleStore = this.props.store.FundingRuleStore;
	
	      var _this = this;
	
	      if (this.props.fundingRuleSid) {
	        // Updating an existing rule
	        // If updating, make sure the dates are right since they may not have changed them
	        this.updateDates(this.state.startDate, this.startTime.value, 'effectiveDate');
	
	        setTimeout(function () {
	          _this.updateDates(_this.state.endDate, _this.endTime.value, 'expirationDate');
	
	          FundingRuleStore.updateFundingRule(_this.props.fundingRuleSid, _this.state.fundingRuleData, _this.complete);
	        });
	      } else {
	        // Creating a new rule
	        // If there’s a scope in the URL, grab the SID and add it to the data
	        var _props$routing$locati = this.props.routing.location.query,
	            fundingRuleScope = _props$routing$locati.fundingRuleScope,
	            scopeSid = _props$routing$locati.scopeSid;
	
	
	        if (fundingRuleScope && scopeSid) {
	          var fundingRuleData = Object.assign({}, this.state.fundingRuleData);
	
	          fundingRuleData[fundingRuleScope] = scopeSid;
	
	          this.setState({
	            fundingRuleData: fundingRuleData
	          });
	        }
	
	        // Create the rule
	        setTimeout(function () {
	          FundingRuleStore.createFundingRule(_this.state.fundingRuleData, _this.complete);
	        });
	      }
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      if (!this.props.preserveDrawer) {
	        (0, _helpers.closeDrawer)(null, this.props.parent, (0, _helpers.getURLSegment)(this, 1));
	      } else {
	        this.props.parent.setState({
	          drawerContent: 'FundingRules',
	          fundingRuleSid: null
	        });
	      }
	
	      this.props.store.SessionStore.showToaster(this.props.translation.rule_saved, 'success');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          enrollmentSid = _props.enrollmentSid,
	          translation = _props.translation;
	      var _props$store = this.props.store,
	          FundingRuleStore = _props$store.FundingRuleStore,
	          SessionStore = _props$store.SessionStore;
	      var fundingRuleData = FundingRuleStore.fundingRuleData;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      var _this = this;
	
	      if (this.props.fundingRuleSid && this.state.startDate && SessionStore.currencyList.length > 0 || !this.props.fundingRuleSid) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'form',
	              { className: 'panel panel--medium', onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	                }, noValidate: true },
	              enrollmentSid && _react2.default.createElement('input', {
	                type: 'hidden',
	                ref: function ref(input) {
	                  _this3.enrollmentSid = input;
	                },
	                defaultValue: enrollmentSid
	              }),
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'funding-name' },
	                      translation.name.label
	                    ),
	                    _react2.default.createElement('input', { type: 'text', id: 'funding-name', required: true, 'aria-required': 'true', ref: function ref(input) {
	                        _this3.title = input;
	                      }, onChange: this.handleInput, defaultValue: fundingRuleData.title })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-optional', htmlFor: 'funding-details' },
	                      translation.details.label
	                    ),
	                    _react2.default.createElement(_reactTextareaAutosize2.default, { id: 'funding-details', className: 'textarea-grow', ref: function ref(input) {
	                        _this3.description = input;
	                      }, onChange: this.handleInput, defaultValue: fundingRuleData.description })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'funding-amount' },
	                      translation.amount.label
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'number',
	                      id: 'funding-amount',
	                      defaultValue: fundingRuleData.amount,
	                      ref: function ref(input) {
	                        _this3.amount = input;
	                      },
	                      onChange: this.handleInput,
	                      placeholder: '0',
	                      min: '0',
	                      max: this.state.fundingRuleData.units === '%' ? '100' : '1000000',
	                      required: true,
	                      'aria-required': 'true'
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select', htmlFor: 'funding-unit' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.amount.units
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'funding-unit',
	                          ref: function ref(input) {
	                            _this3.units = input;
	                          },
	                          onChange: this.handleInput,
	                          defaultValue: this.state.fundingRuleData.units
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '$' },
	                          translation.amount.money
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '%' },
	                          translation.amount.percentage
	                        )
	                      )
	                    ),
	                    this.state.fundingRuleData.units === '$' && _react2.default.createElement(
	                      'label',
	                      { className: 'select', htmlFor: 'funding-unit' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.currency.label
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'funding-currency',
	                          ref: function ref(input) {
	                            _this3.currency = input;
	                          },
	                          onChange: this.handleInput,
	                          required: true,
	                          'aria-required': 'true',
	                          defaultValue: this.state.fundingRuleData.currency
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          translation.currency.label
	                        ),
	                        SessionStore.currencyList.map(function (key, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: i, value: key.code },
	                            key.name
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'funding-appliesTo' },
	                      translation.applies_to.label
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select', htmlFor: 'funding-appliesTo' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          ref: function ref(input) {
	                            _this3.appliesTo = input;
	                          },
	                          onChange: this.handleInput,
	                          defaultValue: this.state.fundingRuleData.appliesTo,
	                          required: true,
	                          'aria-required': 'true'
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          translation.applies_to.helper
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'online' },
	                          translation.applies_to.virtual
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'in-person' },
	                          translation.applies_to.in_person
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'funding-start-date' },
	                      translation.starts.label
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      id: 'funding-start-date',
	                      selected: this.state.startDate ? (0, _moment2.default)(this.state.startDate).tz(userTimezone) : null,
	                      onChange: function onChange(date) {
	                        _this3.handleStartChange(date, true);
	                      },
	                      placeholderText: translation.starts.helper,
	                      required: true, 'aria-required': 'true',
	                      ref: function ref(input) {
	                        _this3.effectiveDate = input;
	                      },
	                      defaultValue: fundingRuleData.effectiveDate,
	                      autoComplete: 'off'
	                    }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      translation.starts.at
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select', htmlFor: 'funding-start-time' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'funding-start-time',
	                          ref: function ref(input) {
	                            _this3.startTime = input;
	                          },
	                          onChange: function onChange() {
	                            return _this3.handleStartChange(null, false);
	                          },
	                          defaultValue: _moment2.default.utc(this.state.startDate).tz(userTimezone).format('HH:mm')
	                        },
	                        _react2.default.createElement(_TimeSelect2.default, null)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      this.state.endDate && _moment2.default.utc(this.state.startDate).tz(userTimezone).format('z'),
	                      !this.state.endDate && (0, _moment2.default)().tz(userTimezone).format('z')
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--auto' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'funding-end-date' },
	                      translation.ends.label
	                    ),
	                    _react2.default.createElement(_reactDatepicker2.default, {
	                      id: 'funding-end-date',
	                      selected: this.state.endDate ? (0, _moment2.default)(this.state.endDate).tz(userTimezone) : null,
	                      onChange: function onChange(date) {
	                        _this3.handleEndChange(date, true);
	                      },
	                      placeholderText: translation.ends.helper,
	                      required: true,
	                      'aria-required': 'true',
	                      ref: function ref(input) {
	                        _this3.expirationDate = input;
	                      },
	                      autoComplete: 'off'
	                    }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      translation.ends.at
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select', htmlFor: 'funding-end-time' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'funding-end-time',
	                          ref: function ref(input) {
	                            _this3.endTime = input;
	                          },
	                          onChange: function onChange() {
	                            return _this3.handleEndChange(null, false);
	                          },
	                          defaultValue: _moment2.default.utc(this.state.endDate).tz(userTimezone).format('HH:mm')
	                        },
	                        _react2.default.createElement(_TimeSelect2.default, null)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'preposition' },
	                      this.state.endDate && _moment2.default.utc(this.state.endDate).tz(userTimezone).format('z'),
	                      !this.state.endDate && (0, _moment2.default)().tz(userTimezone).format('z')
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__actions actions' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'actions__btn actions__btn--primary' },
	                  'Submit'
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return AddFundingRule;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AddFundingRule')(AddFundingRule);

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _currencyFormatter = __webpack_require__(71);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var FundingRulesList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(FundingRulesList, _React$Component);
	
	  function FundingRulesList() {
	    _classCallCheck(this, FundingRulesList);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (FundingRulesList.__proto__ || Object.getPrototypeOf(FundingRulesList)).call(this));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.checkSelectTHRender = _this.checkSelectTHRender.bind(_this);
	    return _this;
	  }
	
	  _createClass(FundingRulesList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var query = this.props.routing.location.query;
	
	
	      this.state = {
	        selectedRows: [],
	        showDetails: [],
	        scope: null
	      };
	
	      if (query.fundingRuleScope && query.scopeSid) {
	        this.getFilteredFundingRules(query.fundingRuleScope, query.scopeSid);
	
	        this.setState({
	          scope: query.fundingRuleScope
	        });
	      } else if (this.props.offeringSid) {
	        this.getFilteredFundingRules('courseOfferingSid', this.props.offeringSid);
	
	        this.setState({
	          scope: 'courseOfferingSid'
	        });
	      } else {
	        this.getFundingRules();
	
	        this.setState({
	          scope: 'installSid'
	        });
	      }
	    }
	  }, {
	    key: 'getFilteredFundingRules',
	    value: function getFilteredFundingRules(scope, sid) {
	      this.props.store.FundingRuleStore.getFilteredFundingRules(scope, sid);
	    }
	  }, {
	    key: 'getFundingRules',
	    value: function getFundingRules() {
	      this.props.store.FundingRuleStore.getFundingRules(true);
	    }
	  }, {
	    key: 'toggleDetails',
	    value: function toggleDetails(sid) {
	      var showDetails = [].concat(_toConsumableArray(this.state.showDetails));
	      var sidIndex = showDetails.indexOf(sid);
	
	      if (sidIndex >= 0) {
	        showDetails.splice(sidIndex, 1);
	      } else {
	        showDetails.push(sid);
	      }
	
	      this.setState({
	        showDetails: showDetails
	      });
	    }
	  }, {
	    key: 'handleEdit',
	    value: function handleEdit(e, fundingRuleSid) {
	      e.preventDefault();
	
	      // Update url
	      if (!this.props.drawer) {
	        var path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');
	
	        if (this.props.routing.location.pathname !== path) {
	          this.props.routing.push(path);
	        }
	      } else {
	        this.props.parent.setState({
	          drawerContent: 'AddFundingRule',
	          fundingRuleSid: fundingRuleSid
	        });
	      }
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(e, sid) {
	      var selectedRows = [].concat(_toConsumableArray(this.props.selectedRows));
	      var rowIndex = -1;
	
	      if (e.target.checked) {
	        selectedRows.push(sid);
	      } else {
	        rowIndex = selectedRows.indexOf(sid);
	        selectedRows.splice(rowIndex, 1);
	      }
	
	      this.props.parent.setState({
	        selectedRows: selectedRows
	      });
	    }
	  }, {
	    key: 'renderEdit',
	    value: function renderEdit(key) {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          to: '/funding-rules/edit/' + key.sid,
	          onClick: function onClick(e) {
	            _this2.handleEdit(e, key.sid);
	          },
	          title: 'Edit ' + key.title
	        },
	        key.title
	      );
	    }
	  }, {
	    key: 'checkEditRender',
	    value: function checkEditRender(key) {
	      var _this3 = this;
	
	      if (this.state.scope !== 'installSid') {
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: '/funding-rules/edit/' + key.sid,
	            onClick: function onClick(e) {
	              _this3.handleEdit(e, key.sid);
	            },
	            title: 'Edit ' + key.title
	          },
	          key.title
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          key.title
	        );
	      }
	    }
	  }, {
	    key: 'renderSelectTH',
	    value: function renderSelectTH() {
	      return _react2.default.createElement(
	        'th',
	        { id: 'heading-select', scope: 'col' },
	        _react2.default.createElement(
	          'span',
	          { className: 'meta' },
	          'Select'
	        )
	      );
	    }
	  }, {
	    key: 'checkSelectTHRender',
	    value: function checkSelectTHRender() {
	      if (this.state.scope !== 'installSid') {
	        return _react2.default.createElement(
	          'th',
	          { id: 'heading-select', scope: 'col' },
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            'Select'
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderSelectTD',
	    value: function renderSelectTD(key) {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'td',
	        { className: 'check-col', 'aria-labelledby': 'heading-select' },
	        _react2.default.createElement('input', {
	          id: 'select-' + key.sid,
	          className: 'checkbox-input',
	          type: 'checkbox',
	          onChange: function onChange(e) {
	            return _this4.handleSelect(e, key.sid);
	          }
	        }),
	        _react2.default.createElement(
	          'label',
	          {
	            className: 'checkbox-label checkbox-label--solo', htmlFor: 'select-' + key.sid
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            'Select ',
	            key.title
	          )
	        )
	      );
	    }
	  }, {
	    key: 'checkSelectTDRender',
	    value: function checkSelectTDRender(key) {
	      var _this5 = this;
	
	      if (this.state.scope !== 'installSid') {
	        return _react2.default.createElement(
	          'td',
	          { className: 'check-col', 'aria-labelledby': 'heading-select' },
	          _react2.default.createElement('input', {
	            id: 'select-' + key.sid,
	            className: 'checkbox-input',
	            type: 'checkbox',
	            onChange: function onChange(e) {
	              return _this5.handleSelect(e, key.sid);
	            }
	          }),
	          _react2.default.createElement(
	            'label',
	            {
	              className: 'checkbox-label checkbox-label--solo', htmlFor: 'select-' + key.sid
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              'Select ',
	              key.title
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          FundingRuleStore = _props$store.FundingRuleStore,
	          SessionStore = _props$store.SessionStore;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (!FundingRuleStore.fundingRules.length && !SessionStore.loading) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      } else if (FundingRuleStore.fundingRules.length > 0) {
	        if (this.props.drawer && !SessionStore.loading || !this.props.drawer) {
	          return _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                  flagKey: 'global-funding-rules',
	                  renderFeatureCallback: this.renderSelectTH,
	                  renderDefaultCallback: this.checkSelectTHRender
	                }),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                  translation.name
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-amount', className: 'subtitle number', scope: 'col' },
	                  translation.amount
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-applies', className: 'subtitle', scope: 'col' },
	                  translation.applies_to
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-starts', className: 'subtitle number', scope: 'col' },
	                  translation.starts
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-ends', className: 'subtitle number', scope: 'col' },
	                  translation.ends
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              FundingRuleStore.fundingRules.map(function (key, i) {
	                return [_react2.default.createElement(
	                  'tr',
	                  {
	                    className: _this6.props.selectedRows.indexOf(key.sid) >= 0 ? 'selected' : '',
	                    key: i
	                  },
	                  _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                    flagKey: 'global-funding-rules',
	                    renderFeatureCallback: function renderFeatureCallback() {
	                      return _this6.renderSelectTD(key);
	                    },
	                    renderDefaultCallback: function renderDefaultCallback() {
	                      return _this6.checkSelectTDRender(key);
	                    }
	                  }),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-name' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'cell-wrap' },
	                      _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                        flagKey: 'global-funding-rules',
	                        renderFeatureCallback: function renderFeatureCallback() {
	                          return _this6.renderEdit(key);
	                        },
	                        renderDefaultCallback: function renderDefaultCallback() {
	                          return _this6.checkEditRender(key);
	                        }
	                      }),
	                      key.description && _react2.default.createElement(
	                        'button',
	                        {
	                          className: 'btn--expand ' + (_this6.state.showDetails.indexOf(key.sid) > -1 ? 'expanded' : ''),
	                          title: translation.enrollments,
	                          onClick: function onClick() {
	                            return _this6.toggleDetails(key.sid);
	                          }
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'meta' },
	                          translation.details
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-amount', className: 'number' },
	                    key.units === '$' && _currencyFormatter2.default.format(key.amount, { code: key.currency }) + ' ' + key.currency,
	                    key.units === '%' && key.amount + '%'
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-applies' },
	                    key.appliesTo
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-starts', className: 'number' },
	                    _moment2.default.utc(key.effectiveDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-ends', className: 'number' },
	                    _moment2.default.utc(key.expirationDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  )
	                ), _react2.default.createElement(
	                  'tr',
	                  { className: '\n                      row-collapsed\n                      ' + (_this6.state.showDetails.indexOf(key.sid) > -1 ? 'expanded' : '') + '\n                    ' },
	                  _react2.default.createElement(
	                    'td',
	                    { colSpan: '6' },
	                    _react2.default.createElement(
	                      'table',
	                      null,
	                      _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                          'tr',
	                          null,
	                          _react2.default.createElement(
	                            'td',
	                            { 'aria-labelledby': 'heading-details', className: 'body' },
	                            key.description
	                          )
	                        )
	                      )
	                    )
	                  )
	                )];
	              })
	            )
	          );
	        }
	
	        return null;
	      }
	
	      return null;
	    }
	  }]);
	
	  return FundingRulesList;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('FundingRulesList')(FundingRulesList);

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _config = __webpack_require__(9);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router';
	
	// Translations
	
	
	// Config
	
	
	// Components
	
	
	var Help = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Help, _React$Component);
	
	  function Help() {
	    _classCallCheck(this, Help);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (Help.__proto__ || Object.getPrototypeOf(Help)).call(this));
	
	    _this2.handleClick = _this2.handleClick.bind(_this2);
	    _this2.renderArticles = _this2.renderArticles.bind(_this2);
	    _this2.toggleLinks = _this2.toggleLinks.bind(_this2);
	    _this2.handleContentKeydown = _this2.handleContentKeydown.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Help, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        collapsed: true,
	        docs: [],
	        feature: null
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      var HelpStore = this.props.store.HelpStore;
	
	
	      document.addEventListener('click', this.handleClick);
	
	      // Make sure docs are retreived and then set the state
	      var helpDelay = setInterval(function () {
	        if (HelpStore.helpLoaded) {
	          _this.renderArticles();
	          clearInterval(helpDelay);
	        }
	      }, 100);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('click', this.handleClick);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var help = document.querySelector('.help');
	      var helpBtn = document.querySelector('.help-wrap > button');
	
	      var target = e.target;
	      var collapsed = true;
	
	      while (target.parentNode) {
	        if (target === help || target === helpBtn) {
	          collapsed = false;
	          return true;
	        }
	
	        target = target.parentNode;
	      }
	
	      this.setState({
	        collapsed: collapsed
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var thisFeature = this.state.feature;
	      var nextFeature = nextProps.store.HelpStore.feature;
	
	      if (thisFeature !== nextFeature) {
	        this.renderArticles();
	      }
	
	      return true;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.state.collapsed) {
	        var articles = document.getElementById('help__list').querySelectorAll('#help-articles');
	        var helpArticles = [].concat(_toConsumableArray(articles));
	
	        helpArticles[0].focus();
	      }
	    }
	  }, {
	    key: 'renderArticles',
	    value: function renderArticles() {
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          HelpStore = _props$store.HelpStore;
	      var feature = HelpStore.feature;
	
	      var role = SessionStore.userData.role.toLowerCase();
	      var docs = [];
	
	      // // Get the docs for the current feature
	      // if(HelpStore.help && HelpStore.help[role]) {
	      //   HelpStore.help[role].forEach(article => {
	      //     if(article.features.indexOf(feature) > -1) {
	      //       docs.push(article);
	      //     }
	      //   })
	      // }
	
	      // Get the docs for the current feature
	      if (HelpStore.help && HelpStore.help[feature] && HelpStore.help[feature][role]) {
	        docs = HelpStore.help[feature][role];
	      }
	
	      this.setState({
	        docs: docs,
	        feature: feature
	      });
	    }
	  }, {
	    key: 'toggleLinks',
	    value: function toggleLinks() {
	      this.setState({
	        collapsed: !this.state.collapsed
	      });
	    }
	  }, {
	    key: 'handleContentKeydown',
	    value: function handleContentKeydown(e) {
	      var setHelpDropdown = this.props.setHelpDropdown;
	
	      var articles = document.getElementById('help__list').querySelectorAll('#help-articles');
	      var helpArticles = [].concat(_toConsumableArray(articles));
	      var index = Array.prototype.indexOf.call(helpArticles, e.target);
	
	      switch (e.key) {
	        case 'ArrowDown':
	          if (e.target === helpArticles[helpArticles.length - 1]) {
	            e.preventDefault();
	            helpArticles[0].focus();
	          } else {
	            e.preventDefault();
	            helpArticles[index + 1].focus();
	          }
	          break;
	        case 'ArrowUp':
	          if (e.target === helpArticles[0]) {
	            e.preventDefault();
	            helpArticles[helpArticles.length - 1].focus();
	          } else {
	            e.preventDefault();
	            helpArticles[index - 1].focus();
	          }
	          break;
	        case 'Escape':
	          e.preventDefault();
	          setHelpDropdown(false);
	          this.toggleLinks();
	          this.dropdownBtn.focus();
	          break;
	        case 'Tab':
	          setHelpDropdown(false);
	          this.toggleLinks();
	          this.dropdownBtn.focus();
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      // const { userData } = this.props.store.SessionStore;
	
	      // Get the docs for the current feature
	      // if(HelpStore.help[feature] && HelpStore.help[feature][role]) {
	      //   docs = HelpStore.help[feature][role];
	      // }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'help-wrap' },
	        _react2.default.createElement(
	          'button',
	          {
	            className: this.props.btnClass ? this.props.btnClass : '',
	            onClick: this.toggleLinks,
	            id: 'help',
	            ref: function ref(button) {
	              return _this3.dropdownBtn = button;
	            }
	          },
	          _react2.default.createElement(icons.iconQuestion, null),
	          translation.help
	        ),
	        _react2.default.createElement(
	          'aside',
	          {
	            className: 'help ' + (this.state.collapsed ? 'help--collapsed' : '')
	          },
	          this.state.docs.length > 0 && _react2.default.createElement(
	            'h5',
	            { className: 'help__title' },
	            translation.articles
	          ),
	          this.state.docs.length > 0 && _react2.default.createElement(
	            'ul',
	            { className: 'help__list', id: 'help__list' },
	            this.state.docs.map(function (doc, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'article',
	                    id: 'help-articles',
	                    target: '_blank',
	                    href: '' + (doc.url.indexOf('http') < 0 ? _config.config.docsDomain : '') + doc.url,
	                    onKeyDown: _this3.handleContentKeydown
	                  },
	                  _react2.default.createElement(icons.iconInfo, null),
	                  doc.title
	                )
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Help;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Help')(Help);

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(15);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _recharts = __webpack_require__(653);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var InstitutionDashboard = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(InstitutionDashboard, _React$Component);
	
	  function InstitutionDashboard() {
	    _classCallCheck(this, InstitutionDashboard);
	
	    var _this = _possibleConstructorReturn(this, (InstitutionDashboard.__proto__ || Object.getPrototypeOf(InstitutionDashboard)).call(this));
	
	    _this.showProctorGroupWarning = _this.showProctorGroupWarning.bind(_this);
	    _this.getDashboardInfo = _this.getDashboardInfo.bind(_this);
	    _this.renderResults = _this.renderResults.bind(_this);
	    return _this;
	  }
	
	  _createClass(InstitutionDashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.store.AdminStore.getOverviewStats();
	      this.state = {
	        drawerContent: null,
	        drawerOpen: false
	      };
	
	      this.getDashboardInfo();
	
	      // Get proctor groups so we can show a warning if none exist
	      this.props.store.ProctorStore.getProctorGroups(this, this.showProctorGroupWarning);
	    }
	  }, {
	    key: 'showProctorGroupWarning',
	    value: function showProctorGroupWarning() {
	      var translation = this.props.translation;
	
	      this.props.store.SessionStore.noticeContent.body = translation.no_proctor_groups.body;
	      this.props.store.SessionStore.noticeContent.linkText = translation.no_proctor_groups.link;
	      this.props.store.SessionStore.noticeContent.linkUrl = '/settings/proctor-groups';
	      this.props.store.SessionStore.notice = true;
	    }
	  }, {
	    key: 'getDashboardInfo',
	    value: function getDashboardInfo() {
	      this.props.store.AdminStore.approvalsFilter = {
	        status: 'requested'
	      };
	
	      this.props.store.AdminStore.getExamConfigurations();
	      this.props.store.AdminStore.getInstallApprovals();
	      this.props.store.AdminStore.getOverviewStats();
	      this.props.store.ProctorStore.getProctorTypes();
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          AdminStore = _props$store.AdminStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'card-list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'card' },
	              _react2.default.createElement(icons.icon_text, null),
	              _react2.default.createElement(
	                'div',
	                { className: 'card__content' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'card__heading' },
	                  AdminStore.configurationCount,
	                  ' ',
	                  translation.exam_approvals
	                ),
	                AdminStore.configurationCount > 0 && _react2.default.createElement(
	                  _reactRouter.Link,
	                  { className: 'card__btn', to: 'exam-approvals' },
	                  _react2.default.createElement(icons.iconCheck, null),
	                  translation.review_button
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'card card--positive' },
	              _react2.default.createElement(icons.iconUsers, null),
	              _react2.default.createElement(
	                'div',
	                { className: 'card__content' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'card__heading' },
	                  AdminStore.approvals.length,
	                  ' ',
	                  translation.proctor_approvals
	                ),
	                AdminStore.approvals.length > 0 && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'card__btn',
	                    onClick: function onClick(e) {
	                      (0, _helpers.toggleDrawer)(e, _this2, 'ApproveProctor');
	                    }
	                  },
	                  _react2.default.createElement(icons.iconCheck, null),
	                  translation.review_button
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'chart' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'chart__title' },
	              translation.upcoming_sessions
	            ),
	            _react2.default.createElement(
	              _recharts.ResponsiveContainer,
	              { height: 300 },
	              _react2.default.createElement(
	                _recharts.BarChart,
	                {
	                  data: this.props.store.AdminStore.stats.slice(),
	                  animation: false
	                },
	                _react2.default.createElement(_recharts.XAxis, { dataKey: 'date' }),
	                _react2.default.createElement(_recharts.YAxis, null),
	                _react2.default.createElement(_recharts.Tooltip, null),
	                _react2.default.createElement(_recharts.Bar, {
	                  barSize: 30,
	                  dataKey: 'messaging',
	                  stackId: 'a',
	                  fill: '#bba7e4',
	                  isAnimationActive: false
	                }),
	                _react2.default.createElement(_recharts.Bar, {
	                  barSize: 30,
	                  dataKey: 'ad-hoc',
	                  stackId: 'a',
	                  fill: '#f44c87',
	                  isAnimationActive: false
	                }),
	                _react2.default.createElement(_recharts.Bar, {
	                  barSize: 30,
	                  dataKey: 'instructor-as-proctor',
	                  stackId: 'a', fill: '#47b8c6',
	                  isAnimationActive: false
	                }),
	                _react2.default.createElement(_recharts.Bar, {
	                  barSize: 30,
	                  dataKey: 'register-blast',
	                  stackId: 'a',
	                  fill: '#2cc477',
	                  isAnimationActive: false
	                }),
	                _react2.default.createElement(_recharts.Bar, {
	                  barSize: 30,
	                  dataKey: 'examity',
	                  stackId: 'a',
	                  fill: '#f69432',
	                  isAnimationActive: false
	                }),
	                _react2.default.createElement(_recharts.Bar, {
	                  barSize: 30,
	                  dataKey: 'proctoru',
	                  stackId: 'a',
	                  fill: '#1073af',
	                  isAnimationActive: false
	                })
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          )
	        ),
	        this.renderResults(),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          callback: this.getDashboardInfo,
	          parent: this
	        }, this.props))
	      );
	    }
	  }]);
	
	  return InstitutionDashboard;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('InstitutionDashboard')(InstitutionDashboard);

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _FauxSelect = __webpack_require__(97);
	
	var _FauxSelect2 = _interopRequireDefault(_FauxSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var Integrations = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Integrations, _React$Component);
	
	  function Integrations() {
	    _classCallCheck(this, Integrations);
	
	    var _this = _possibleConstructorReturn(this, (Integrations.__proto__ || Object.getPrototypeOf(Integrations)).call(this));
	
	    _this.selectOption = _this.selectOption.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Integrations, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        integrationSid: null
	      };
	
	      this.props.store.SettingsStore.getIntegrations();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$routing$locati = this.props.routing.location.query,
	          action = _props$routing$locati.action,
	          integrationSid = _props$routing$locati.integrationSid,
	          saved = _props$routing$locati.saved;
	
	
	      if (integrationSid && action) {
	        (0, _helpers.toggleDrawer)(null, this, action);
	
	        this.setState({
	          drawerOpen: true,
	          drawerContent: action,
	          integrationSid: integrationSid
	        });
	      }
	
	      if (saved) {
	        this.complete();
	      }
	    }
	  }, {
	    key: 'actions',
	    value: function actions() {
	      var translation = this.props.translation;
	
	
	      var actions = [{
	        title: translation.action_options.oauth.label,
	        action: 'OAuth'
	      }, {
	        title: translation.action_options.roles.label,
	        action: 'Roles'
	      }, {
	        title: translation.action_options.sync.label,
	        action: 'Sync'
	      }];
	
	      return actions;
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(e, props) {
	      var action = e.target.getAttribute('data-action');
	      var drawerContent = action;
	      var pathname = this.props.routing.location.pathname;
	
	
	      this.setState({
	        integrationSid: props.integrationSid
	      });
	
	      // Update the URL
	      pathname += '?integrationSid=' + props.integrationSid + '&action=' + action;
	      this.props.routing.push(pathname);
	
	      (0, _helpers.toggleDrawer)(e, this, drawerContent);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      this.props.store.SessionStore.showToaster(this.props.translation.settings_saved, 'success');
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	
	
	      if (!SessionStore.loading || SettingsStore.integrations.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-name', style: { width: 300 }, className: 'subtitle', scope: 'col' },
	                translation.id
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                translation.name
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-actions', className: 'subtitle', scope: 'col' },
	                translation.actions
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            SettingsStore.integrations.map(function (integration) {
	              return _react2.default.createElement(
	                'tr',
	                { key: integration.sid },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  integration.sid
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  integration.name
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-action', className: 'actions' },
	                  _react2.default.createElement(_FauxSelect2.default, {
	                    'default': translation.action_select,
	                    options: _this2.actions(),
	                    onClick: _this2.selectOption,
	                    parent: _this2,
	                    skipText: true,
	                    integrationSid: integration.sid
	                  })
	                )
	              );
	            })
	          )
	        );
	      } else if (!SessionStore.loading && SettingsStore.integrations.length === 0) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          integrationSid: this.state.integrationSid,
	          complete: this.complete,
	          parent: this
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Integrations;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Integrations')(Integrations);

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Privacy = __webpack_require__(215);
	
	var _Privacy2 = _interopRequireDefault(_Privacy);
	
	var _config = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var OAuth = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(OAuth, _React$Component);
	
	  function OAuth() {
	    _classCallCheck(this, OAuth);
	
	    var _this = _possibleConstructorReturn(this, (OAuth.__proto__ || Object.getPrototypeOf(OAuth)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    _this.checkIntegration = _this.checkIntegration.bind(_this);
	    return _this;
	  }
	
	  _createClass(OAuth, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        integrationSid: this.props.integrationSid,
	        showAuthBtn: false
	      };
	
	      this.props.store.SettingsStore.getIntegration(this.props.integrationSid, this.checkIntegration);
	    }
	  }, {
	    key: 'checkIntegration',
	    value: function checkIntegration() {
	      // Check to see if the Authenticate button should be shown
	      var integration = this.props.store.SettingsStore.integration;
	
	      // Show d2l authenticate button
	
	      if (integration && integration.systemName && integration.systemName.toLowerCase() === 'desire2learn' && integration.oAuthClientId && integration.oAuthClientSecret && integration.oAuthAuthUri) {
	        this.setState({
	          showAuthBtn: true
	        });
	      }
	
	      // Show Canvas authenticate button
	      if (integration && integration.systemName && integration.systemName.toLowerCase() === 'canvas' && integration.oAuthClientId && integration.oAuthClientSecret && integration.oAuthAuthUri) {
	        this.setState({
	          showAuthBtn: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.SettingsStore.integration = {};
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(name, e) {
	      var data = _defineProperty({}, name, e.target.value);
	
	      this.props.store.SettingsStore.updateIntegrationData(data);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      this.props.store.SettingsStore.updateIntegration(this.state.integrationSid, this.complete);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      var integration = this.props.store.SettingsStore.integration;
	
	
	      if (integration && (integration.systemName.toLowerCase() === 'desire2learn' || integration.systemName.toLowerCase() === 'canvas')) {
	        this.setState({
	          showAuthBtn: true
	        });
	      }
	
	      this.props.complete();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SettingsStore = this.props.store.SettingsStore;
	      var integration = this.props.store.SettingsStore.integration;
	
	      var systemName = '';
	
	      if (integration && integration.systemName) {
	        systemName = integration.systemName.toLowerCase();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading,
	              ' ',
	              integration.name
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form' },
	          SettingsStore.integration.sid && _react2.default.createElement(
	            'form',
	            { className: 'panel', onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	              }, noValidate: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__body' },
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'form-section' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-heading' },
	                  translation.lti_settings
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      translation.launch_url
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'faux-input' },
	                      _config.config.ltiUrl,
	                      '/v1/auth/lti'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      translation.access_key
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'faux-input' },
	                      integration.accessKey
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      null,
	                      translation.secret
	                    ),
	                    _react2.default.createElement(_Privacy2.default, Object.assign({
	                      className: 'faux-input',
	                      show: translation.reveal,
	                      hide: translation.hide,
	                      'private': integration.secret
	                    }, this.props))
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'form-section' },
	                _react2.default.createElement('img', {
	                  className: 'form-heading-img',
	                  src: './static/img/lms/' + systemName + '.png',
	                  width: '200',
	                  alt: systemName + ' logo'
	                }),
	                systemName === 'blackboard' && _react2.default.createElement(
	                  'span',
	                  { className: 'yes-results success' },
	                  'System connected'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'fields' },
	                    systemName !== 'desire2learn' && systemName !== 'blackboard' && systemName !== 'moodle' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'sync-auth' },
	                        translation.authentication_flow
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'select' },
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            id: 'sync-auth',
	                            defaultValue: integration.useAuthenticationFlow,
	                            onChange: function onChange(e) {
	                              _this2.handleInput('useAuthenticationFlow', e);
	                            }
	                          },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            translation.auth.none
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: 'OAuth2' },
	                            translation.auth.oauth
	                          )
	                        )
	                      )
	                    ),
	                    systemName === 'desire2learn' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        translation.trusted_url
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'faux-input' },
	                        _config.config.ltiUrl,
	                        '/v1/auth/d2l/',
	                        this.props.integrationSid
	                      )
	                    ),
	                    systemName !== 'blackboard' && systemName !== 'moodle' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'client-id' },
	                        translation[systemName].client_id
	                      ),
	                      _react2.default.createElement('input', {
	                        id: 'client-id',
	                        type: 'text',
	                        defaultValue: integration.oAuthClientId,
	                        onChange: function onChange(e) {
	                          _this2.handleInput('oAuthClientId', e);
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    systemName !== 'blackboard' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'client-secret' },
	                        translation[systemName].client_secret
	                      ),
	                      _react2.default.createElement('input', {
	                        id: 'client-secret',
	                        type: 'text',
	                        defaultValue: integration.oAuthClientSecret,
	                        onChange: function onChange(e) {
	                          _this2.handleInput('oAuthClientSecret', e);
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    systemName !== 'blackboard' && systemName !== 'moodle' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'client-auth-uri' },
	                        translation[systemName].auth_uri
	                      ),
	                      _react2.default.createElement('input', {
	                        id: 'client-auth-uri',
	                        type: 'url',
	                        defaultValue: integration.oAuthAuthUri,
	                        onChange: function onChange(e) {
	                          _this2.handleInput('oAuthAuthUri', e);
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    systemName === 'canvas' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'client-grant' },
	                        translation[systemName].grant_type
	                      ),
	                      _react2.default.createElement('input', {
	                        id: 'client-grant',
	                        type: 'text',
	                        defaultValue: integration.oAuthGrantType,
	                        onChange: function onChange(e) {
	                          _this2.handleInput('oAuthGrantType', e);
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    systemName === 'canvas' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'client-purpose' },
	                        translation[systemName].auth_purpose
	                      ),
	                      _react2.default.createElement('input', {
	                        id: 'client-purpose',
	                        type: 'text',
	                        defaultValue: integration.oAuthPurpose,
	                        onChange: function onChange(e) {
	                          _this2.handleInput('oAuthPurpose', e);
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    systemName === 'canvas' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'client-redirect' },
	                        translation[systemName].redirect_uri
	                      ),
	                      _react2.default.createElement('input', {
	                        id: 'client-redirect',
	                        type: 'text',
	                        defaultValue: integration.oAuthPostAuthRedirectUri,
	                        onChange: function onChange(e) {
	                          _this2.handleInput('oAuthPostAuthRedirectUri', e);
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    systemName === 'canvas' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-required', htmlFor: 'client-logout' },
	                        translation[systemName].logout_uri
	                      ),
	                      _react2.default.createElement('input', {
	                        id: 'client-logout',
	                        type: 'text',
	                        defaultValue: integration.oAuthLogoutUri,
	                        onChange: function onChange(e) {
	                          _this2.handleInput('oAuthLogoutUri', e);
	                        }
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__actions actions' },
	                this.state.showAuthBtn && integration.systemName.toLowerCase() === 'desire2learn' && _react2.default.createElement(
	                  'a',
	                  {
	                    href: _config.config.ltiUrl + '/v1/auth/d2l/' + this.props.integrationSid,
	                    className: 'actions__btn actions__btn--secondary'
	                  },
	                  translation.authenticate
	                ),
	                this.state.showAuthBtn && integration.systemName.toLowerCase() === 'canvas' && _react2.default.createElement(
	                  'a',
	                  {
	                    href: _config.config.ltiUrl + '/v1/oauth/' + this.props.integrationSid,
	                    className: 'actions__btn actions__btn--secondary'
	                  },
	                  translation.authenticate
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary',
	                    type: 'submit'
	                  },
	                  translation.save
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OAuth;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('OAuth')(OAuth);

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var Roles = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Roles, _React$Component);
	
	  function Roles() {
	    _classCallCheck(this, Roles);
	
	    var _this = _possibleConstructorReturn(this, (Roles.__proto__ || Object.getPrototypeOf(Roles)).call(this));
	
	    _this.addRole = _this.addRole.bind(_this);
	    _this.removeRole = _this.removeRole.bind(_this);
	    _this.handleRoleInput = _this.handleRoleInput.bind(_this);
	    _this.handleRoleSubmit = _this.handleRoleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(Roles, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        integrationSid: this.props.integrationSid,
	        roles: []
	      };
	
	      this.props.store.SettingsStore.getCustomRoles(this.props.integrationSid, this);
	      this.props.store.SettingsStore.getIntegration(this.props.integrationSid);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.SettingsStore.customRoles = [];
	    }
	  }, {
	    key: 'addRole',
	    value: function addRole() {
	      var roles = this.state.roles;
	
	      var newRole = {
	        incomingRole: null,
	        systemRole: 'Learner',
	        caseSensitive: false
	      };
	
	      roles.push(newRole);
	
	      console.log(roles);
	
	      this.setState({
	        roles: roles
	      });
	    }
	  }, {
	    key: 'removeRole',
	    value: function removeRole(index) {
	      var roles = [].concat(_toConsumableArray(this.state.roles));
	
	      roles.splice(index, 1);
	
	      this.setState({
	        roles: roles
	      });
	    }
	  }, {
	    key: 'handleRoleInput',
	    value: function handleRoleInput(e, i, field) {
	      var roles = [].concat(_toConsumableArray(this.state.roles));
	      var editedRole = roles[i];
	
	      if (field === 'incomingRole') {
	        editedRole.incomingRole = e.target.value;
	      } else {
	        editedRole.systemRole = e.target.value;
	      }
	
	      this.setState({
	        roles: roles
	      });
	    }
	  }, {
	    key: 'handleRoleSubmit',
	    value: function handleRoleSubmit() {
	      this.props.store.SettingsStore.updateCustomRoles(this.state.integrationSid, this.state.roles, this.props.complete);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var integration = this.props.store.SettingsStore.integration;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading,
	              ' ',
	              integration.name
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form' },
	          (!SessionStore.loading || this.state.roles.length > 0) && _react2.default.createElement(
	            'form',
	            { className: 'panel', onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this2.handleRoleSubmit);
	              }, noValidate: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__body' },
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'form-section' },
	                this.state.roles.length === 0 && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn--success',
	                    onClick: this.addRole,
	                    type: 'button'
	                  },
	                  _react2.default.createElement(icons.iconPlus, null),
	                  translation.add_first
	                ),
	                this.state.roles.length > 0 && _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-block', htmlFor: 'custom-role-0' },
	                  translation.roles
	                ),
	                this.state.roles.length > 0 && _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  this.state.roles.map(function (key, i) {
	                    return _react2.default.createElement(
	                      'li',
	                      { className: 'form-inline', key: i },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'meta', htmlFor: 'custom-role-' + i },
	                        translation.input
	                      ),
	                      _react2.default.createElement('input', {
	                        id: 'custom-role-' + i,
	                        type: 'text',
	                        placeholder: translation.input,
	                        value: key.incomingRole || '',
	                        onChange: function onChange(e) {
	                          return _this2.handleRoleInput(e, i, 'incomingRole');
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'preposition' },
	                        '='
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'select', htmlFor: 'sp-role-' + i },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'meta' },
	                          translation.select
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            id: 'sp-role-' + i,
	                            value: key.systemRole || '',
	                            onChange: function onChange(e) {
	                              return _this2.handleRoleInput(e, i, 'systemRole');
	                            },
	                            required: true,
	                            'aria-required': 'true'
	                          },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            translation.select,
	                            '\u2026'
	                          ),
	                          Object.keys(translation.options).map(function (option) {
	                            return _react2.default.createElement(
	                              'option',
	                              { value: option, key: option },
	                              translation.options[option]
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'btns' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            className: 'btn--add',
	                            type: 'button',
	                            onClick: _this2.addRole
	                          },
	                          _react2.default.createElement(icons.iconPlus, null),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            translation.add
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            className: 'btn--remove',
	                            type: 'button',
	                            onClick: function onClick() {
	                              return _this2.removeRole(i);
	                            }
	                          },
	                          _react2.default.createElement(icons.iconMinus, null),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            translation.remove
	                          )
	                        )
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__actions actions' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary',
	                    type: 'submit'
	                  },
	                  translation.save
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Roles;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Roles')(Roles);

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	var Sync = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Sync, _React$Component);
	
	  function Sync() {
	    _classCallCheck(this, Sync);
	
	    var _this = _possibleConstructorReturn(this, (Sync.__proto__ || Object.getPrototypeOf(Sync)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(Sync, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        integrationSid: this.props.integrationSid
	      };
	
	      this.props.store.SettingsStore.getIntegration(this.props.integrationSid);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.SettingsStore.integration = {};
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(name, e, checkbox) {
	      var value = e.target.value;
	
	      if (checkbox) {
	        value = e.target.checked;
	      }
	
	      var data = _defineProperty({}, name, value);
	
	      this.props.store.SettingsStore.updateIntegrationData(data);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      this.props.store.SettingsStore.updateIntegration(this.state.integrationSid, this.props.complete);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SettingsStore = this.props.store.SettingsStore;
	      var integration = this.props.store.SettingsStore.integration;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading,
	              ' ',
	              integration.name
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form' },
	          SettingsStore.integration.sid && _react2.default.createElement(
	            'form',
	            { className: 'panel', onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	              }, noValidate: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__body' },
	              _react2.default.createElement(
	                'fieldset',
	                { className: 'form-section' },
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'sync-enrollments' },
	                      translation.sync_enrollments
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'sync-enrollments',
	                      className: 'switch-input',
	                      defaultChecked: integration.syncEnrollments,
	                      onChange: function onChange(e) {
	                        _this2.handleInput('syncEnrollments', e, true);
	                      },
	                      onKeyDown: _helpers.handleSwitchInputKeys
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'switch-label', htmlFor: 'sync-enrollments' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.sync_enrollments
	                      )
	                    )
	                  ),
	                  integration.syncEnrollments && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'sync-enrollments-interval' },
	                      translation.sync_enrollments_interval
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'sync-enrollments-interval',
	                          defaultValue: integration.syncEnrollmentsInterval,
	                          onChange: function onChange(e) {
	                            _this2.handleInput('syncEnrollmentsInterval', e);
	                          }
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: 2 },
	                          '2 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 3 },
	                          '3 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 4 },
	                          '4 ',
	                          translation.hours
	                        )
	                      )
	                    )
	                  ),
	                  integration.syncEnrollments && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'sync-enrollments-expiration' },
	                      translation.sync_enrollment_expiration
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'sync-enrollments-expiration',
	                          defaultValue: integration.syncEnrollmentsExpirationDays,
	                          onChange: function onChange(e) {
	                            _this2.handleInput('syncEnrollmentsExpirationDays', e);
	                          }
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: 15 },
	                          '15 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 30 },
	                          '30 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 45 },
	                          '45 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 60 },
	                          '60 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 90 },
	                          '90 ',
	                          translation.days
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__actions actions' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary',
	                    type: 'submit'
	                  },
	                  translation.save
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Sync;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Sync')(Sync);

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Payments = __webpack_require__(99);
	
	var _Payments2 = _interopRequireDefault(_Payments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var SelectProctor = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SelectProctor, _React$Component);
	
	  function SelectProctor() {
	    _classCallCheck(this, SelectProctor);
	
	    return _possibleConstructorReturn(this, (SelectProctor.__proto__ || Object.getPrototypeOf(SelectProctor)).apply(this, arguments));
	  }
	
	  _createClass(SelectProctor, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'slide-wrap wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.payment_form
	            ),
	            _react2.default.createElement(_Payments2.default, this.props)
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelectProctor;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SelectProctor')(SelectProctor);

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _config = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Maintenance = function (_React$Component) {
	  _inherits(Maintenance, _React$Component);
	
	  function Maintenance() {
	    _classCallCheck(this, Maintenance);
	
	    return _possibleConstructorReturn(this, (Maintenance.__proto__ || Object.getPrototypeOf(Maintenance)).apply(this, arguments));
	  }
	
	  _createClass(Maintenance, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	      // Create a minimal anonymous user for LaunchDarkly
	
	      var anonymousUser = {
	        key: 'anonymous-user',
	        anonymous: true
	      };
	
	      return _react2.default.createElement(
	        _reactLaunchDarkly.LaunchDarkly,
	        { clientId: _config.config.ldApiKey, user: anonymousUser },
	        _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	          flagKey: 'maintenance-message',
	          renderFeatureCallback: function renderFeatureCallback(flagValue) {
	            if (flagValue && (typeof flagValue === 'undefined' ? 'undefined' : _typeof(flagValue)) === 'object' && flagValue.message !== undefined) {
	              return _react2.default.createElement(
	                'main',
	                { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel--brief' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'page--error__icon' },
	                    _react2.default.createElement(icons.iconClock, null)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h1',
	                      { className: 'panel__title' },
	                      flagValue.title || translation.heading
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      flagValue.message || translation.message
	                    )
	                  )
	                )
	              );
	            } else {
	              return _react2.default.createElement(
	                'main',
	                { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel--brief' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'page--error__green__icon' },
	                    _react2.default.createElement(icons.iconBadgeCheck, null)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h1',
	                      { className: 'panel__title' },
	                      translation.up_heading
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      translation.up_message
	                    )
	                  )
	                )
	              );
	            }
	          }
	        })
	      );
	    }
	  }]);
	
	  return Maintenance;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('Maintenance')(Maintenance);

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var Address = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Address, _React$Component);
	
	  function Address() {
	    _classCallCheck(this, Address);
	
	    var _this2 = _possibleConstructorReturn(this, (Address.__proto__ || Object.getPrototypeOf(Address)).call(this));
	
	    _this2.geolocate = _this2.geolocate.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Address, [{
	    key: 'geolocate',
	    value: function geolocate(e) {
	      // To prevent autofilling, the address field is readonly which needs to be changed
	      e.target.removeAttribute('readOnly');
	
	      var _this = this;
	      var google = window.google;
	      var input = document.querySelector('#address-autocomplete');
	      var autocomplete = new google.maps.places.Autocomplete(input, { types: ['geocode'] });
	      autocomplete.addListener('place_changed', function (e) {
	        return updateAddress(e);
	      });
	
	      // Prevent submit on enter
	      google.maps.event.addDomListener(input, 'keydown', function (e) {
	        if (e.keyCode === 13) {
	          e.preventDefault();
	        }
	      });
	
	      function updateAddress() {
	        var place = autocomplete.getPlace();
	
	        var location = {
	          address1: null,
	          address2: null,
	          place: null,
	          region: null,
	          country: null,
	          postalCode: null,
	          lat: null,
	          lng: null
	        };
	
	        if (!place.geometry) {
	          // The user entered the name of a place that wasn’t suggested
	          // and pressed the Enter key, or the request failed
	          // window.alert(`No details available for “${place.name}”`);
	          var suggestions = document.querySelector('.pac-container');
	          setTimeout(function () {
	            suggestions.style.display = 'block';
	          });
	          return;
	        } else {
	          // Loop through address components to get data
	          for (var i = 0; i < place.address_components.length; i++) {
	            // Address 1 number
	            if (place.address_components[i].types.indexOf('street_number') > -1) {
	              location.address1 = place.address_components[i].short_name;
	            }
	
	            // Address 1 street
	            if (place.address_components[i].types.indexOf('route') > -1) {
	              if (location.address1) {
	                location.address1 += ' ' + place.address_components[i].short_name;
	              } else {
	                location.address1 = place.address_components[i].short_name;
	              }
	            }
	
	            // Address 2
	            if (place.address_components[i].types.indexOf('subpremise') > -1) {
	              location.address2 = place.address_components[i].short_name;
	            }
	
	            // City
	            if (place.address_components[i].types.indexOf('locality') > -1) {
	              location.place = place.address_components[i].short_name;
	            }
	
	            // Region
	            if (place.address_components[i].types.indexOf('administrative_area_level_1') > -1) {
	              location.region = place.address_components[i].short_name;
	            }
	
	            // Country
	            if (place.address_components[i].types.indexOf('country') > -1) {
	              location.country = place.address_components[i].short_name;
	            }
	
	            // Postal code
	            if (place.address_components[i].types.indexOf('postal_code') > -1) {
	              location.postalCode = place.address_components[i].short_name;
	            }
	
	            // Lat/lng
	            location.lat = place.geometry.location.lat();
	            location.lng = place.geometry.location.lng();
	          }
	
	          // Check if address components contained a street address
	          // and parse the formatted address if it didn’t
	          if (!location.address1) {
	            var addr_arr = place.formatted_address.split(',');
	
	            if (addr_arr.length > 3) {
	              location.address1 = addr_arr[0];
	
	              if (addr_arr.length > 4) {
	                location.address2 = addr_arr[1].replace(' ', '');
	              }
	            }
	          }
	
	          _this.props.parent.setState({
	            location: location
	          });
	
	          if (_this.props.onSelect) {
	            _this.props.onSelect();
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { className: 'meta', htmlFor: 'autocomplete' },
	          translation.label
	        ),
	        _react2.default.createElement('input', {
	          id: 'address-autocomplete',
	          type: 'text',
	          onFocus: function onFocus(e) {
	            return _this3.geolocate(e);
	          },
	          placeholder: translation.label,
	          required: true,
	          'aria-required': 'true',
	          autoComplete: 'false',
	          readOnly: true
	        })
	      );
	    }
	  }]);
	
	  return Address;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Address')(Address);

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _MessageThread = __webpack_require__(355);
	
	var _MessageThread2 = _interopRequireDefault(_MessageThread);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Inbox = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Inbox, _React$Component);
	
	  function Inbox() {
	    _classCallCheck(this, Inbox);
	
	    var _this2 = _possibleConstructorReturn(this, (Inbox.__proto__ || Object.getPrototypeOf(Inbox)).call(this));
	
	    _this2.toggleNav = _this2.toggleNav.bind(_this2);
	    _this2.viewThread = _this2.viewThread.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Inbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        messageSid: null,
	        showNav: false,
	        drawerOpen: false,
	        drawerContent: null,
	        proctorLocationSid: null,
	        examSid: null,
	        sessionSid: null
	      };
	
	      this.getThreads();
	
	      // Load thread if there’s one in the URL
	      if ((0, _helpers.getURLSegment)(this, 2) === 'view' && (0, _helpers.getURLSegment)(this, 3)) {
	        this.setState({
	          messageSid: (0, _helpers.getURLSegment)(this, 3)
	        });
	      }
	
	      // Add class to aid styling
	      document.body.className += ' inbox-body';
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Remove styling class
	      document.body.className = document.body.className.replace(' inbox-body', '');
	    }
	  }, {
	    key: 'getThreads',
	    value: function getThreads() {
	      var _this = this;
	
	      // Wait until course data exists to get threads
	      var courseDelay = setInterval(function () {
	        if (_this.props.store.SessionStore.courseData.sid) {
	          _this.props.store.MessageStore.getThreads();
	          clearInterval(courseDelay);
	        }
	      }, 100);
	    }
	  }, {
	    key: 'toggleNav',
	    value: function toggleNav() {
	      this.setState({
	        showNav: !this.state.showNav
	      });
	    }
	  }, {
	    key: 'switchMailbox',
	    value: function switchMailbox(e, mailbox) {
	      e.preventDefault();
	
	      // Unhighlight previously selected tab
	      // const prevMailbox = document.querySelectorAll('.threads__switch .selected');
	      //
	      // prevMailbox.forEach(function(mailbox){
	      //   if(mailbox) {
	      //     mailbox.classList.remove('selected');
	      //   }
	      // });
	
	      // Highlight newly selected tab
	      e.target.className += ' selected';
	
	      // Get new mailbox (not included yet since the API doesn’t exist)
	    }
	  }, {
	    key: 'viewThread',
	    value: function viewThread(e, messageSid) {
	      this.setState({
	        messageSid: messageSid
	      });
	
	      this.toggleNav();
	
	      // Unhighlight any previously selected threads and
	      var prevThread = document.querySelector('.thread.active');
	
	      if (prevThread && prevThread.classList) {
	        prevThread.classList.remove('active');
	      }
	
	      var thisThread = document.querySelector('#thread-' + messageSid);
	
	      if (thisThread) {
	        thisThread.classList.remove('thread--unread');
	        thisThread.classList.add('thread--read');
	      }
	    }
	  }, {
	    key: 'renderSubject',
	    value: function renderSubject(thread) {
	      var translation = this.props.translation;
	      var courseData = this.props.store.SessionStore.courseData;
	
	
	      var subject = null;
	
	      if (thread.dateOption1) {
	        subject = translation.subjects.session_request;
	      } else if (thread.proctorApproval) {
	        subject = translation.subjects.proctor_approval;
	      } else if (thread.examSessionEventReport) {
	        subject = translation.subjects.session_incident;
	      } else if (thread.examConfiguration || thread.examSid && thread.exam) {
	        subject = thread.exam.title;
	      } else if (thread.courseSid) {
	        subject = courseData.title;
	      }
	
	      if (subject) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'thread__subject', title: subject },
	          subject
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          MessageStore = _props$store.MessageStore,
	          SessionStore = _props$store.SessionStore;
	      var threads = MessageStore.threads;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      var thisUserSid = SessionStore.userData.userSid;
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header inbox-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'meta' },
	              translation.page_title
	            ),
	            threads.length > 0 && _react2.default.createElement(
	              'button',
	              { className: 'btn--outline inbox-nav-btn', onClick: this.toggleNav },
	              _react2.default.createElement(icons.iconList, null),
	              translation.inbox_nav
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'inbox ' + (this.state.showNav ? 'show-threads' : '') },
	          _react2.default.createElement(
	            'section',
	            { className: 'threads' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'meta' },
	              translation.active_threads
	            ),
	            threads.length > 0 && _react2.default.createElement(
	              'ol',
	              { id: 'active-threads', className: 'thread-list' },
	              threads.map(function (thread, i) {
	                var threadUserUnread = null;
	
	                if (thisUserSid === thread.initiatingUserSid) {
	                  threadUserUnread = 'initiatingUserHasUnread';
	                } else {
	                  threadUserUnread = 'userHasUnread';
	                }
	
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  _react2.default.createElement(
	                    'article',
	                    { id: 'thread-' + thread.sid, className: 'thread ' + (thread[threadUserUnread] ? 'thread--unread' : 'thread--read') },
	                    _react2.default.createElement(
	                      'header',
	                      { id: 'thread-' + i + '-title', className: 'thread__header' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'thread__title' },
	                        thread.recipientFirstName,
	                        ' ',
	                        thread.recipientLastName
	                      ),
	                      _this3.renderSubject(thread)
	                    ),
	                    _react2.default.createElement(
	                      'time',
	                      { className: 'thread__date' },
	                      _moment2.default.utc(thread.lastMessageDate).tz(userTimezone).format('M/D/YYYY')
	                    ),
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      {
	                        className: 'cover',
	                        to: (0, _helpers.getURLSegment)(_this3, 1) + '/view/' + thread.sid,
	                        onClick: function onClick(e) {
	                          _this3.viewThread(e, thread.sid);
	                        },
	                        'aria-describedby': 'thread-' + i + '-title'
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.view_thread
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'inbox__content' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'meta' },
	              translation.inbox_content
	            ),
	            threads.length === 0 && _react2.default.createElement(
	              'span',
	              { className: 'no-results' },
	              translation.no_messages
	            ),
	            threads.length > 0 && this.state.messageSid && _react2.default.createElement(_MessageThread2.default, Object.assign({
	              messageSid: this.state.messageSid,
	              inbox: this,
	              parent: this,
	              toggleDrawer: _helpers.toggleDrawer
	            }, this.props)),
	            threads.length > 0 && !this.state.messageSid && _react2.default.createElement(
	              'span',
	              { className: 'no-results' },
	              translation.choose_thread
	            )
	          )
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          proctorLocationSid: this.state.proctorLocationSid,
	          examSid: this.state.examSid,
	          sessionSid: this.state.sessionSid,
	          messageSid: this.state.messageSid
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Inbox;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Inbox')(Inbox);

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var MessageContext = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(MessageContext, _React$Component);
	
	  function MessageContext() {
	    _classCallCheck(this, MessageContext);
	
	    return _possibleConstructorReturn(this, (MessageContext.__proto__ || Object.getPrototypeOf(MessageContext)).apply(this, arguments));
	  }
	
	  _createClass(MessageContext, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'aside',
	        { className: 'thread__context' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'thread__context__hdg' },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'data--alt' },
	          this.props.data.map(function (data, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'strong',
	                null,
	                data.title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.value
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return MessageContext;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('MessageContext')(MessageContext);

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactQuill = __webpack_require__(575);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _TimeSelect = __webpack_require__(80);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	var _BlackoutList = __webpack_require__(146);
	
	var _BlackoutList2 = _interopRequireDefault(_BlackoutList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var MessageForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(MessageForm, _React$Component);
	
	  function MessageForm() {
	    _classCallCheck(this, MessageForm);
	
	    var _this = _possibleConstructorReturn(this, (MessageForm.__proto__ || Object.getPrototypeOf(MessageForm)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.createThreadCallback = _this.createThreadCallback.bind(_this);
	    return _this;
	  }
	
	  _createClass(MessageForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var threadObject = this.props.threadObject;
	
	
	      this.state = {
	        slot1Date: null,
	        slot2Date: null,
	        slot3Date: null,
	        content: ''
	      };
	
	      if (threadObject.dateOption1) {
	        this.setState({
	          slot1Date: (0, _moment2.default)(threadObject.dateOption1)
	        });
	      }
	
	      if (threadObject.dateOption2) {
	        this.setState({
	          slot2Date: (0, _moment2.default)(threadObject.dateOption2)
	        });
	      }
	
	      if (threadObject.dateOption3) {
	        this.setState({
	          slot3Date: (0, _moment2.default)(threadObject.dateOption3)
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // Auto focus text editor when reply button is clicked
	      if (!prevProps.renderForm && this.props.renderForm) {
	        this.refs.quill.focus();
	      }
	    }
	  }, {
	    key: 'handleSlotChange',
	    value: function handleSlotChange(date, e, slot) {
	      this.setState(_defineProperty({}, slot, date));
	    }
	  }, {
	    key: 'handleContent',
	    value: function handleContent(content) {
	      this.setState({
	        content: content
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _props$store = this.props.store,
	          MessageStore = _props$store.MessageStore,
	          SessionStore = _props$store.SessionStore;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      var date1 = (0, _moment2.default)(this.state.slot1Date).format('YYYY-MM-DD');
	      var timezone1 = (0, _moment2.default)(this.state.slot1Date).tz(userTimezone).format('Z');
	      var date2 = (0, _moment2.default)(this.state.slot2Date).format('YYYY-MM-DD');
	      var timezone2 = (0, _moment2.default)(this.state.slot2Date).tz(userTimezone).format('Z');
	      var date3 = (0, _moment2.default)(this.state.slot3Date).format('YYYY-MM-DD');
	      var timezone3 = (0, _moment2.default)(this.state.slot3Date).tz(userTimezone).format('Z');
	
	      var data = {
	        initiatingUserSid: SessionStore.userData.userSid,
	        courseSid: SessionStore.userData.courseSid,
	        sessionRequest: this.props.sessionRequest || false,
	        content: this.state.content
	      };
	
	      if (this.slot1Time && this.slot2Time && this.slot3Time) {
	        if (this.props.sessionRequest && date1 && date2 && date3) {
	          data.dateOption1 = (0, _moment2.default)(date1 + ' ' + this.slot1Time.value + ' ' + timezone1, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
	          data.dateOption2 = (0, _moment2.default)(date2 + ' ' + this.slot2Time.value + ' ' + timezone2, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
	          data.dateOption3 = (0, _moment2.default)(date3 + ' ' + this.slot3Time.value + ' ' + timezone3, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();
	        }
	      }
	
	      if (this.props.examSid) {
	        data.examSid = this.props.examSid;
	      }
	
	      // if(this.props.examConfigurationSid) {
	      //   data.examConfigurationSid = this.props.examConfigurationSid;
	      // }
	
	      if (this.props.proctorApprovalSid) {
	        data.proctorApprovalSid = this.props.proctorApprovalSid;
	      }
	
	      if (this.props.examSessionEventReportSid) {
	        data.examSessionEventReportSid = this.props.examSessionEventReportSid;
	      }
	
	      if (this.props.proctorSid) {
	        data.toProctorAccountUserSid = this.props.proctorSid;
	      }
	
	      if (this.props.toUserSid && !this.props.proctorSid) {
	        data.toUserSid = this.props.toUserSid;
	      }
	
	      if (this.props.proctorLocationSid) {
	        data.locationSid = this.props.proctorLocationSid;
	      }
	
	      // Send the form data
	      if (data.content) {
	        if (this.props.mode === 'create') {
	          // Creating a new thread
	          MessageStore.createThread(data, this.createThreadCallback);
	        } else {
	          // Replying to an existing thread
	          data.source = 'messenger';
	          data.fromUserSid = data.initiatingUserSid;
	
	          delete data.courseSid;
	          delete data.examSid;
	          delete data.examConfigurationSid;
	          delete data.examSessionEventReportSid;
	          delete data.initiatingUserSid;
	          delete data.proctorApprovalSid;
	          delete data.sessionRequest;
	          delete data.toProctorAccountUserSid;
	          delete data.toUserSid;
	          delete data.locationSid;
	
	          MessageStore.replyToThread(this.props.threadSid, data);
	        }
	
	        // Clear out the content
	        this.setState({
	          content: ''
	        });
	
	        this.props.parentThread.setState({
	          renderForm: false
	        });
	      } else {
	        var editor = document.querySelector('.quill');
	
	        if (editor) {
	          editor.className += ' error';
	        }
	      }
	    }
	  }, {
	    key: 'createThreadCallback',
	    value: function createThreadCallback() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      SessionStore.showToaster(translation.message_sent, 'success');
	      (0, _helpers.closeDrawer)(null, this.props.parent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var examSession = this.props.examSession;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var minDate = null;
	      var absMinDate = null;
	      var maxDate = null;
	      var startTime = '00:00';
	      var endTime = '00:00';
	
	      var examConfiguration = this.props.examConfiguration;
	
	      if (!examConfiguration && examSession) {
	        examConfiguration = examSession.examConfiguration;
	      }
	
	      if (examConfiguration) {
	        var _now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	        minDate = (0, _moment2.default)(examConfiguration.examOpenDate).tz(userTimezone);
	        absMinDate = (0, _moment2.default)(minDate).startOf('hour');
	        maxDate = (0, _moment2.default)(examConfiguration.examCloseDate).endOf('hour').add(1, 'minutes').tz(userTimezone);
	        var timeDiff = _moment2.default.duration(minDate.diff(_now)).asHours();
	
	        if (timeDiff < 0) {
	          minDate = _now;
	        }
	
	        startTime = (0, _moment2.default)(absMinDate).format('HH:mm');
	        endTime = (0, _moment2.default)(maxDate).format('HH:mm');
	      }
	
	      // Quill text editor toolbar options
	      var modules = {
	        toolbar: [['bold', 'italic', 'underline'], [{ 'list': 'bullet' }, { 'list': 'ordered' }]]
	      };
	
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      var expired = false;
	      var expirationDate = (0, _moment2.default)(this.props.confirmedDateExpiration);
	      var scheduleDiff = _moment2.default.duration(expirationDate.diff(now)).asHours();
	
	      if (scheduleDiff < 0) {
	        expired = true;
	      }
	
	      if (this.props.renderForm) {
	        return _react2.default.createElement(
	          'form',
	          { className: 'message-form ' + (SessionStore.backgroundLoading ? 'working' : ''), onSubmit: function onSubmit(e) {
	              return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	            }, noValidate: true },
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_reactQuill2.default, {
	                modules: modules,
	                onChange: function onChange(e) {
	                  _this2.handleContent(e);
	                },
	                ref: 'quill'
	              })
	            )
	          ),
	          this.props.sessionRequest && !this.props.confirmedDate && _react2.default.createElement(
	            'h4',
	            { className: 'form-heading', 'aria-describedby': 'dates-tooltip' },
	            translation.requested_dates,
	            _react2.default.createElement(
	              'div',
	              { className: 'tooltip' },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'dates-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                translation.date_request
	              )
	            )
	          ),
	          this.props.sessionRequest && _react2.default.createElement(_BlackoutList2.default, this.props),
	          this.props.sessionRequest && _react2.default.createElement(
	            'p',
	            { className: 'note' },
	            translation.schedule_note
	          ),
	          (this.props.sessionRequest && !this.props.confirmedDate || this.props.confirmedDate && expired) && _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'slot-1' },
	                translation.slot_1.label
	              ),
	              _react2.default.createElement(_reactDatepicker2.default, {
	                id: 'exam-start-date',
	                placeholderText: translation.slot_1.helper,
	                selected: this.state.slot1Date ? (0, _moment2.default)(this.state.slot1Date) : null,
	                openToDate: (0, _moment2.default)(examConfiguration.examOpenDate).tz(userTimezone),
	                minDate: minDate,
	                maxDate: (0, _moment2.default)(examConfiguration.examCloseDate).tz(userTimezone),
	                onChange: function onChange(date, e) {
	                  _this2.handleSlotChange(date, e, 'slot1Date');
	                },
	                required: true,
	                'aria-required': 'true',
	                autoComplete: 'off'
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition' },
	                translation.slot_at
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    defaultValue: (0, _helpers.roundTime)(this.state.slot1Date),
	                    ref: function ref(input) {
	                      _this2.slot1Time = input;
	                    }
	                  },
	                  _react2.default.createElement(_TimeSelect2.default, {
	                    startTime: (0, _moment2.default)(this.state.slot1Date).isSame(absMinDate, 'day') ? startTime : null,
	                    endTime: (0, _moment2.default)(this.state.slot1Date).isSame(maxDate, 'day') ? endTime : null
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition' },
	                this.state.slot1Date && _moment2.default.utc(this.state.slot1Date).tz(userTimezone).format('z'),
	                !this.state.slot1Date && (0, _moment2.default)().tz(userTimezone).format('z')
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'slot-2' },
	                translation.slot_2.label
	              ),
	              _react2.default.createElement(_reactDatepicker2.default, {
	                id: 'exam-start-date',
	                placeholderText: translation.slot_2.helper,
	                selected: this.state.slot2Date ? (0, _moment2.default)(this.state.slot2Date) : null,
	                openToDate: (0, _moment2.default)(examConfiguration.examOpenDate).tz(userTimezone),
	                minDate: minDate,
	                maxDate: (0, _moment2.default)(examConfiguration.examCloseDate).tz(userTimezone),
	                onChange: function onChange(date, e) {
	                  _this2.handleSlotChange(date, e, 'slot2Date');
	                },
	                required: true,
	                'aria-required': 'true',
	                autoComplete: 'off'
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition' },
	                translation.slot_at
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    defaultValue: (0, _helpers.roundTime)(this.state.slot2Date),
	                    ref: function ref(input) {
	                      _this2.slot2Time = input;
	                    }
	                  },
	                  _react2.default.createElement(_TimeSelect2.default, {
	                    startTime: (0, _moment2.default)(this.state.slot2Date).isSame(absMinDate, 'day') ? startTime : null,
	                    endTime: (0, _moment2.default)(this.state.slot2Date).isSame(maxDate, 'day') ? endTime : null
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition' },
	                this.state.slot2Date && _moment2.default.utc(this.state.slot2Date).tz(userTimezone).format('z'),
	                !this.state.slot2Date && (0, _moment2.default)().tz(userTimezone).format('z')
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'slot-3' },
	                translation.slot_3.label
	              ),
	              _react2.default.createElement(_reactDatepicker2.default, {
	                id: 'exam-start-date',
	                placeholderText: translation.slot_3.helper,
	                selected: this.state.slot3Date ? (0, _moment2.default)(this.state.slot3Date) : null,
	                openToDate: (0, _moment2.default)(examConfiguration.examOpenDate).tz(userTimezone),
	                minDate: minDate,
	                maxDate: (0, _moment2.default)(examConfiguration.examCloseDate).tz(userTimezone),
	                onChange: function onChange(date, e) {
	                  _this2.handleSlotChange(date, e, 'slot3Date');
	                },
	                required: true,
	                'aria-required': 'true',
	                autoComplete: 'off'
	              }),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition' },
	                translation.slot_at
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    defaultValue: (0, _helpers.roundTime)(this.state.slot3Date),
	                    ref: function ref(input) {
	                      _this2.slot3Time = input;
	                    }
	                  },
	                  _react2.default.createElement(_TimeSelect2.default, {
	                    startTime: (0, _moment2.default)(this.state.slot3Date).isSame(absMinDate, 'day') ? startTime : null,
	                    endTime: (0, _moment2.default)(this.state.slot3Date).isSame(maxDate, 'day') ? endTime : null
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition' },
	                this.state.slot3Date && _moment2.default.utc(this.state.slot3Date).tz(userTimezone).format('z'),
	                !this.state.slot3Date && (0, _moment2.default)().tz(userTimezone).format('z')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', type: 'submit' },
	            translation.send
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'inbox__init-reply' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn--link', onClick: this.props.showForm },
	            translation.reply
	          ),
	          ' ',
	          translation.to_message
	        );
	      }
	    }
	  }]);
	
	  return MessageForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('MessageForm')(MessageForm);

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	// Translations
	
	
	// Dependencies
	
	
	var ExamDetailsCompleted = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamDetailsCompleted, _React$Component);
	
	  function ExamDetailsCompleted() {
	    _classCallCheck(this, ExamDetailsCompleted);
	
	    return _possibleConstructorReturn(this, (ExamDetailsCompleted.__proto__ || Object.getPrototypeOf(ExamDetailsCompleted)).apply(this, arguments));
	  }
	
	  _createClass(ExamDetailsCompleted, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var exam = this.props.exam;
	      var _props$store$SessionS = this.props.store.SessionStore,
	          courseData = _props$store$SessionS.courseData,
	          userTimezone = _props$store$SessionS.userTimezone;
	      var location = exam.examSession.location;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'panel__section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__heading' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'data' },
	          exam.examSession.schedulingModule !== 'vtc' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.scheduled.date
	            ),
	            _moment2.default.utc(exam.examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	          ),
	          exam.examSession.schedulingModule === 'b-virtual' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.scheduled.type
	            ),
	            translation.scheduled.b_virtual
	          ),
	          exam.examSession.schedulingModule === 'proctoru' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.scheduled.type
	            ),
	            translation.scheduled.proctoru
	          ),
	          exam.examSession.schedulingModule === 'examity' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.scheduled.type
	            ),
	            translation.scheduled.examity
	          ),
	          exam.examSession.schedulingModule === 'vtc' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.scheduled.type
	            ),
	            translation.scheduled.vtc
	          ),
	          exam.examSession.schedulingModule === 'instructor-as-proctor' && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.scheduled.proctor
	            ),
	            courseData.instructor.firstName,
	            ' ',
	            courseData.instructor.lastName,
	            ' (',
	            translation.scheduled.instructor,
	            ')'
	          ),
	          exam.examSession.schedulingModule !== 'b-virtual' && exam.examSession.schedulingModule !== 'proctoru' && exam.examSession.schedulingModule !== 'examity' && exam.examSession.schedulingModule !== 'vtc' && location && _react2.default.createElement(
	            'li',
	            { className: 'adr' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.scheduled.location
	            ),
	            (location.address1 || location.address2) && _react2.default.createElement(
	              'span',
	              { className: 'street-address' },
	              location.address1,
	              _react2.default.createElement('br', null),
	              location.address2 || ''
	            ),
	            location.place && _react2.default.createElement(
	              'span',
	              { className: 'locality' },
	              location.place,
	              ', '
	            ),
	            location.region && _react2.default.createElement(
	              'span',
	              { className: 'region' },
	              location.region,
	              ' '
	            ),
	            location.postalCode && _react2.default.createElement(
	              'span',
	              { className: 'postal-code' },
	              location.postalCode
	            ),
	            location.country && _react2.default.createElement(
	              'span',
	              { className: 'country' },
	              location.country
	            )
	          ),
	          exam.examSession.schedulingModule !== 'b-virtual' && exam.examSession.schedulingModule !== 'instructor-as-proctor' && exam.examSession.schedulingModule !== 'vtc' && exam.examSession.proctor && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.scheduled.proctor
	            ),
	            exam.examSession.proctor.firstName,
	            ' ',
	            exam.examSession.proctor.lastName
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExamDetailsCompleted;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamDetailsCompleted')(ExamDetailsCompleted);

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	var ExamMeta = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamMeta, _React$Component);
	
	  function ExamMeta() {
	    _classCallCheck(this, ExamMeta);
	
	    return _possibleConstructorReturn(this, (ExamMeta.__proto__ || Object.getPrototypeOf(ExamMeta)).apply(this, arguments));
	  }
	
	  _createClass(ExamMeta, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this = this;
	      var ExamStore = this.props.store.ExamStore;
	      var _props = this.props,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	
	
	      var callback = function callback() {
	        _this.props.store.SessionStore.modalLoaded = true;
	      };
	
	      ExamStore.getSessionMeta(examSid, sessionSid, callback);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.ExamStore.sessionMeta = null;
	    }
	  }, {
	    key: 'renderEncodedHTML',
	    value: function renderEncodedHTML(html) {
	      var txt = document.createElement('textarea');
	      txt.innerHTML = html;
	      return txt.value;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	      var sessionMeta = this.props.store.ExamStore.sessionMeta;
	
	
	      if (sessionMeta && sessionMeta.status && sessionMeta.status.toLowerCase() !== 'cancelled') {
	        if (sessionMeta.type === 'examity') {
	          var appointmentInfo = sessionMeta.metadata.appointmentInfo;
	
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'modal__content--alt' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'data--alt' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.appointment_date
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _moment2.default.utc(appointmentInfo.examDate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.status
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  appointmentInfo.status
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_status
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  appointmentInfo.examStatus
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  appointmentInfo.examName
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_duration
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  (0, _helpers.toHours)(appointmentInfo.examDuration)
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_url
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  appointmentInfo.examURL
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_password
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  appointmentInfo.password
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_id
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  appointmentInfo.examId
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.proctor_instructions
	                ),
	                _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(this.renderEncodedHTML(appointmentInfo.examInstruction)) } })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.course_name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  appointmentInfo.courseName
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.course_id
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  appointmentInfo.courseId
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.transaction_id
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  appointmentInfo.transactionId
	                )
	              )
	            )
	          );
	        } else if (sessionMeta.type === 'proctoru') {
	          var metadata = sessionMeta.metadata;
	
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'modal__content--alt' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'data--alt' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.appointment_date
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _moment2.default.utc(metadata.StartDate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.end_date
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _moment2.default.utc(metadata.EndDate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.status
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.Status
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.Test
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_id
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.examId
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.reservation_number
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.ReservationNo
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.authenticated
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.Authenticated.toString()
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.id_checked
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.CheckID.toString()
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.login_verified
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.LoginVerified.toString()
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.test_submitted
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.TestSubmitted.toString()
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.escalated
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.Escalated.toString()
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.incident_reported
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.IncidentReport.toString()
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.proctor_instructions
	                ),
	                _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(metadata.SchoolNotes) } })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.notes
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  metadata.ProctorNotes
	                )
	              )
	            )
	          );
	        } else if (sessionMeta.type === 'register-blast') {
	          var _metadata = sessionMeta.metadata;
	
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'modal__content--alt' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'data--alt' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.appointment_date
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _moment2.default.unix(_metadata.items[0].examdate).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.status
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _metadata.items[0].status
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _metadata.items[0].examname
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.exam_id
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _metadata.items[0].examid
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.no_show
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _metadata.items[0].noshow.toString()
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.deleted
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _metadata.items[0].deleted.toString()
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.incidents
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _metadata.items[0].incidents.length
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.refund
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _metadata.items[0].refund
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.notes
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _metadata.items[0].notes
	                )
	              )
	            )
	          );
	        }
	      } else if (sessionMeta && sessionMeta.status && sessionMeta.status.toLowerCase() === 'cancelled') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'modal__content--alt' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'data--alt' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.status
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                sessionMeta.status
	              )
	            ),
	            sessionMeta.type && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                translation.type
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'capitalize' },
	                sessionMeta.type.replace('-', ' ')
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ExamMeta;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamMeta')(ExamMeta);

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _currencyFormatter = __webpack_require__(71);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _FauxSelect = __webpack_require__(97);
	
	var _FauxSelect2 = _interopRequireDefault(_FauxSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Proctor = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Proctor, _React$Component);
	
	  function Proctor() {
	    _classCallCheck(this, Proctor);
	
	    var _this = _possibleConstructorReturn(this, (Proctor.__proto__ || Object.getPrototypeOf(Proctor)).call(this));
	
	    _this.requestApproval = _this.requestApproval.bind(_this);
	    _this.scheduleRB = _this.scheduleRB.bind(_this);
	    _this.messageProctor = _this.messageProctor.bind(_this);
	    _this.toggleDescription = _this.toggleDescription.bind(_this);
	    _this.renderApprove = _this.renderApprove.bind(_this);
	    _this.toggleApprovals = _this.toggleApprovals.bind(_this);
	    _this.handleAction = _this.handleAction.bind(_this);
	    return _this;
	  }
	
	  _createClass(Proctor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        showDescription: false,
	        approvals: [],
	        showApprovals: false
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ProctorStore = this.props.store.ProctorStore;
	
	      // Get proctor approval history if necessary
	
	      if (this.props.showApprovalHistory) {
	        ProctorStore.getSingleApproval(this, this.props.proctor.proctor.sid);
	      }
	    }
	  }, {
	    key: 'handleAction',
	    value: function handleAction(e, props) {
	      var action = e.target.getAttribute('data-action');
	
	      if (action === 'adminApprove') {
	        this.adminApprove();
	      } else if (action === 'adminDeny') {
	        this.adminApprove(true);
	      }
	    }
	  }, {
	    key: 'adminApprove',
	    value: function adminApprove(deny) {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ProctorStore = _props$store.ProctorStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      var msg = {
	        heading: translation.admin_approve_confirm.heading,
	        body: translation.admin_approve_confirm.body,
	        button: translation.admin_approve_confirm.button
	      };
	
	      var data = {
	        requestedByUserSid: SessionStore.profile.sid,
	        proctorAccountSid: this.props.proctor.proctor.sid,
	        status: 'allow'
	      };
	
	      if (this.props.approveForStudent) {
	        msg.body = translation.admin_approve_student_confirm.body;
	        data.applyToSid = this.props.userSid;
	        data.applyTo = 'student';
	      } else {
	        data.applyToSid = SessionStore.userData.installSid;
	        data.applyTo = 'install';
	      }
	
	      if (deny) {
	        data.status = 'deny';
	
	        if (this.props.approveForStudent) {
	          msg.heading = translation.admin_deny_student_confirm.heading;
	          msg.body = translation.admin_deny_student_confirm.body;
	          msg.button = translation.admin_deny_student_confirm.button;
	        } else {
	          msg.heading = translation.admin_deny_confirm.heading;
	          msg.body = translation.admin_deny_confirm.body;
	          msg.button = translation.admin_deny_confirm.button;
	        }
	      }
	
	      var callback = function callback() {
	        return _this2.props.store.SessionStore.showToaster(_this2.props.translation.admin_approved, 'success');
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return ProctorStore.createApproval(data, callback);
	      });
	    }
	  }, {
	    key: 'requestApproval',
	    value: function requestApproval(e) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          ProctorStore = _props$store2.ProctorStore,
	          SessionStore = _props$store2.SessionStore;
	
	      var button = e.target;
	
	      var data = {
	        requestedByUserSid: SessionStore.profile.sid,
	        proctorAccountSid: this.props.proctor.proctor.sid,
	        examSessionSid: (0, _helpers.getURLSegment)(this, 5)
	      };
	
	      var msg = {
	        heading: translation.request_confirm.heading,
	        body: translation.request_confirm.body,
	        button: translation.request_confirm.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return ProctorStore.requestApproval(data, _this3.disableButton(button));
	      });
	    }
	  }, {
	    key: 'scheduleSmarterScheduling',
	    value: function scheduleSmarterScheduling(proctorLocationSid) {
	      this.props.parent.setState({
	        proctorLocationSid: proctorLocationSid
	      });
	
	      this.props.store.ProctorStore.proctorLocationSid = proctorLocationSid;
	
	      (0, _helpers.toggleDrawer)(null, this.props.parent, 'ScheduleOnline');
	    }
	  }, {
	    key: 'scheduleRB',
	    value: function scheduleRB(proctorLocationSid) {
	      this.props.parent.setState({
	        proctorLocationSid: proctorLocationSid
	      });
	
	      (0, _helpers.toggleDrawer)(null, this.props.parent, 'ScheduleRB');
	    }
	  }, {
	    key: 'messageProctor',
	    value: function messageProctor(proctorSid, proctorLocationSid) {
	      this.props.parent.setState({
	        proctorSid: proctorSid,
	        proctorLocationSid: proctorLocationSid
	      });
	
	      this.props.store.SessionStore.getCurrentTime();
	
	      (0, _helpers.toggleDrawer)(null, this.props.parent, 'MessageThread');
	    }
	  }, {
	    key: 'disableButton',
	    value: function disableButton(button) {
	      var translation = this.props.translation;
	
	      button.setAttribute('disabled', true);
	      button.textContent = translation.approval_requested;
	      console.log('disable');
	    }
	  }, {
	    key: 'toggleDescription',
	    value: function toggleDescription() {
	      this.setState({
	        showDescription: !this.state.showDescription
	      });
	    }
	  }, {
	    key: 'renderApprove',
	    value: function renderApprove() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var role = SessionStore.userData.role;
	
	
	      var displayApproved = false;
	      var displayDenied = false;
	      var hideActions = false;
	
	      if (this.state && role.toLowerCase() === 'administrator') {
	        // If there are approvals, check if any
	        // apply to the entire install and hide
	        // the button if any do
	        this.state.approvals.forEach(function (approval) {
	          if (approval.status === 'deny' && (approval.appliesTo.applicationInstall || approval.appliesTo.studentUser && approval.appliesTo.studentUser.sid === _this4.props.userSid)) {
	            displayDenied = true;
	            hideActions = true;
	          }
	
	          if (approval.status === 'allow' && (approval.appliesTo.applicationInstall || approval.appliesTo.studentUser && approval.appliesTo.studentUser.sid === _this4.props.userSid)) {
	            displayApproved = true;
	          }
	        });
	      }
	
	      var actions = [];
	
	      if (!this.props.approveForStudent) {
	        actions = [{
	          title: translation.admin_deny,
	          action: 'adminDeny'
	        }];
	
	        if (!displayApproved) {
	          var approveAction = {
	            title: translation.admin_approve,
	            action: 'adminApprove'
	          };
	
	          actions.push(approveAction);
	        }
	      } else {
	        actions = [{
	          title: translation.admin_deny_student,
	          action: 'adminDeny'
	        }];
	
	        if (!displayApproved) {
	          var _approveAction = {
	            title: translation.admin_approve_student,
	            action: 'adminApprove'
	          };
	
	          actions.push(_approveAction);
	        }
	      }
	
	      if (this.state && role.toLowerCase() === 'administrator') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'proctor__session' },
	          !hideActions && _react2.default.createElement(_FauxSelect2.default, {
	            'default': translation.actions,
	            options: actions,
	            onClick: this.handleAction,
	            noTooltip: true
	          }),
	          displayDenied && _react2.default.createElement(
	            'strong',
	            {
	              className: 'proctor__approved denied'
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              translation.denied_proctor
	            )
	          ),
	          displayApproved && _react2.default.createElement(
	            'strong',
	            {
	              className: 'proctor__approved'
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              translation.approved_proctor
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'toggleApprovals',
	    value: function toggleApprovals() {
	      this.setState({
	        showApprovals: !this.state.showApprovals
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	      var backgroundLoadingCalls = SessionStore.backgroundLoadingCalls,
	          userData = SessionStore.userData;
	      var role = userData.role;
	      var _props = this.props,
	          i = _props.i,
	          proctor = _props.proctor,
	          translation = _props.translation;
	
	
	      if (backgroundLoadingCalls.indexOf('getSingleApproval') < 0) {
	        return _react2.default.createElement(
	          'article',
	          { className: 'proctor vcard' },
	          _react2.default.createElement(
	            'header',
	            { className: 'proctor__header' },
	            _react2.default.createElement(
	              'figure',
	              { className: 'media' },
	              proctor.proctor.image && _react2.default.createElement(
	                'span',
	                { className: 'proctor__avatar avatar-wrap' },
	                _react2.default.createElement('img', {
	                  className: 'avatar',
	                  src: proctor.proctor.image,
	                  alt: '',
	                  onLoad: function onLoad(e) {
	                    (0, _helpers.flagPortrait)(e, proctor.proctor.image);
	                  }
	                })
	              ),
	              !proctor.proctor.image && _react2.default.createElement(
	                'span',
	                { className: 'proctor__avatar avatar-wrap' },
	                _react2.default.createElement('img', {
	                  className: 'avatar avatar--missing',
	                  src: './static/img/avatar-default.png',
	                  alt: 'No avatar provided',
	                  onLoad: function onLoad(e) {
	                    (0, _helpers.flagPortrait)(e, './static/img/avatar-default.png');
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'figcaption',
	                { className: 'media__copy' },
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'proctor__title fn org' },
	                  proctor.proctor.accountName
	                ),
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle proctor__subtitle' },
	                  proctor.location.name
	                ),
	                proctor.proctor.approved && _react2.default.createElement(
	                  'strong',
	                  { className: 'proctor__approved' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    translation.approved_proctor
	                  )
	                ),
	                proctor.location && _react2.default.createElement(
	                  'span',
	                  { className: 'proctor__location' },
	                  proctor.location.distance,
	                  ' ',
	                  translation.miles
	                )
	              )
	            ),
	            this.renderApprove(),
	            this.props.showProctorActions && _react2.default.createElement(
	              'div',
	              { className: 'proctor__session' },
	              proctor.fees && proctor.fees.userTotal !== null && proctor.fees.userTotal !== 0 && _react2.default.createElement(
	                'strong',
	                { className: 'proctor__price' },
	                _currencyFormatter2.default.format(proctor.fees.userTotal, { code: proctor.fees.currencyCode }),
	                ' ',
	                proctor.fees.currencyCode,
	                proctor.fees.proctorCollected && _react2.default.createElement(
	                  'span',
	                  { className: 'proctor__price__note', 'aria-labelledby': proctor.proctor.sid + '-fees-tooltip' },
	                  translation.proctor_collected,
	                  proctor.fees.proctorCollectedFeesDetail && _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip tooltip--right' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: proctor.proctor.sid + '-fees-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                      proctor.fees.proctorCollectedFeesDetail
	                    )
	                  )
	                )
	              ),
	              proctor.fees && (!proctor.fees.userTotal || proctor.fees.userTotal === 0) && _react2.default.createElement(
	                'strong',
	                { className: 'proctor__price' },
	                translation.free
	              ),
	              proctor.fees && proctor.fees.hasOwnProperty('lateSchedulingLeadTime') && proctor.fees.lateSchedulingLeadTime !== 0 && _react2.default.createElement(
	                'span',
	                { className: 'proctor__price', 'aria-describedby': 'rush-' + i + '-tooltip' },
	                translation.leadtime.replace('%window%', proctor.fees.lateSchedulingLeadTime),
	                ': ',
	                _currencyFormatter2.default.format(proctor.fees.userTotal + proctor.fees.lateSchedulingFee, { code: proctor.fees.currencyCode }),
	                ' ',
	                proctor.fees.currencyCode,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tooltip tooltip--right' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                    '(?)'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'rush-' + i + '-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                    translation.rush_tooltip.replace('%window%', proctor.fees.lateSchedulingLeadTime).replace('%price%', _currencyFormatter2.default.format(proctor.fees.userTotal + proctor.fees.lateSchedulingFee, { code: proctor.fees.currencyCode }) + ' ' + proctor.fees.currencyCode)
	                  )
	                )
	              ),
	              !proctor.proctor.approved && !proctor.proctor.pendingApproval && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick(e) {
	                    _this5.requestApproval(e);
	                  }
	                },
	                translation.request_approval
	              ),
	              proctor.proctor.approved && !proctor.proctor.pendingApproval && proctor.location.schedulingModule !== 'register-blast' && proctor.location.schedulingModule !== 'smarter-scheduling' && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--success',
	                  onClick: function onClick() {
	                    return _this5.messageProctor(proctor.proctor.primaryUserSid, proctor.location.sid);
	                  }
	                },
	                translation.request_session
	              ),
	              proctor.proctor.pendingApproval && _react2.default.createElement(
	                'span',
	                { className: 'btn disabled' },
	                translation.approval_requested
	              ),
	              proctor.location.schedulingModule === 'register-blast' && proctor.proctor.approved && _react2.default.createElement(
	                'div',
	                { className: 'tooltip tooltip--right proctor__session__icn' },
	                _react2.default.createElement('img', { src: './static/img/icn-registerblast.png', height: '20', alt: 'RegisterBlast', role: 'presentation' }),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'rb-tooltip-' + i, className: 'tooltip__body tooltip__body--brief', role: 'tooltip' },
	                  translation.schedule_rb
	                )
	              ),
	              proctor.location.schedulingModule === 'register-blast' && proctor.proctor.approved && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--success',
	                  onClick: function onClick() {
	                    return _this5.scheduleRB(proctor.location.sid);
	                  },
	                  'aria-describedby': 'rb-tooltip-' + i
	                },
	                translation.request_session
	              ),
	              proctor.location.schedulingModule === 'smarter-scheduling' && proctor.proctor.approved && _react2.default.createElement(
	                'div',
	                { className: 'tooltip tooltip--right proctor__session__icn' },
	                _react2.default.createElement('img', { src: './static/img/icn-lightning.png', height: '20', alt: 'SmarterSchedulingFastScheduling', role: 'presentation' }),
	                _react2.default.createElement(
	                  'div',
	                  { id: 'rb-tooltip-' + i, className: 'tooltip__body tooltip__body--brief', role: 'tooltip' },
	                  translation.schedule_instant
	                )
	              ),
	              proctor.location.schedulingModule === 'smarter-scheduling' && proctor.proctor.approved && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--success',
	                  onClick: function onClick() {
	                    return _this5.scheduleSmarterScheduling(proctor.location.sid);
	                  },
	                  'aria-describedby': 'rb-tooltip-' + i
	                },
	                translation.request_session
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'proctor__details' },
	            proctor.location && _react2.default.createElement(
	              'ul',
	              { className: 'data vcard' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'adr' },
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.location
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'street-address' },
	                    proctor.location.address1,
	                    ' ',
	                    proctor.location.address2
	                  ),
	                  proctor.location.place && _react2.default.createElement(
	                    'span',
	                    { className: 'locality' },
	                    proctor.location.place,
	                    ', '
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'region' },
	                    proctor.location.region,
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'postal-code' },
	                    proctor.location.postalCode
	                  )
	                ),
	                proctor.location.parkingInformation && _react2.default.createElement(
	                  'div',
	                  { className: 'proctor__directions' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.location_type
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    proctor.location.locationType
	                  )
	                ),
	                proctor.location.parkingInformation && _react2.default.createElement(
	                  'div',
	                  { className: 'proctor__directions' },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.parking
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    proctor.location.parkingInformation
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.features_heading
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'proctor__features' },
	                  Object.keys(translation.features).map(function (feature, i) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: i, className: proctor.location[feature] ? 'check' : '' },
	                      translation.features[feature],
	                      proctor.location[feature] && _react2.default.createElement(icons.iconCheck, null)
	                    );
	                  })
	                )
	              )
	            ),
	            proctor.location.notes && _react2.default.createElement(
	              'div',
	              { className: 'proctor__notes text-block' },
	              _react2.default.createElement(
	                'p',
	                null,
	                proctor.location.notes
	              )
	            ),
	            this.state && role.toLowerCase() === 'administrator' && this.state.approvals.length > 0 && _react2.default.createElement(
	              'div',
	              { className: 'proctor__details__approvals' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'subtitle' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: '\n                      btn--expand\n                      ' + (this.state.showApprovals ? 'expanded' : '') + '\n                    ',
	                    onClick: this.toggleApprovals
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    'View details'
	                  )
	                ),
	                translation.approval_history
	              ),
	              this.state.showApprovals && _react2.default.createElement(
	                'table',
	                { className: 'compact' },
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  this.state.approvals.map(function (approval, i) {
	                    return _react2.default.createElement(
	                      'tr',
	                      { key: i },
	                      _react2.default.createElement(
	                        'td',
	                        {
	                          className: approval.status === 'allow' ? 'positive' : 'negative'
	                        },
	                        approval.status
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        (0, _helpers.approvalScope)(approval, translation)
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Proctor;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Proctor')(Proctor);

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactTextareaAutosize = __webpack_require__(74);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(1034);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _TimeSelect = __webpack_require__(80);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ScheduleFields = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleFields, _React$Component);
	
	  function ScheduleFields() {
	    _classCallCheck(this, ScheduleFields);
	
	    var _this = _possibleConstructorReturn(this, (ScheduleFields.__proto__ || Object.getPrototypeOf(ScheduleFields)).call(this));
	
	    _this.handleLocationDateChange = _this.handleLocationDateChange.bind(_this);
	    _this.addLocation = _this.addLocation.bind(_this);
	    _this.removeLocation = _this.removeLocation.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScheduleFields, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          instructorAsProctor = _props.instructorAsProctor,
	          index = _props.index;
	
	
	      if (instructorAsProctor.length > 0 && instructorAsProctor[index].startTime) {
	        this.state = {
	          locationDate: (0, _moment2.default)(instructorAsProctor[index].startTime)
	        };
	      } else {
	        this.state = {
	          locationDate: null
	        };
	      }
	    }
	  }, {
	    key: 'handleLocationDateChange',
	    value: function handleLocationDateChange(date) {
	      this.setState({
	        locationDate: date
	      }, function () {
	        this.updateLocation();
	      });
	    }
	  }, {
	    key: 'addLocation',
	    value: function addLocation(e) {
	      e.preventDefault();
	      this.props.store.ExamStore.addLocation();
	    }
	  }, {
	    key: 'removeLocation',
	    value: function removeLocation(e, i) {
	      e.preventDefault();
	      this.props.store.ExamStore.removeLocation(i);
	
	      // const { instructorAsProctor, index } = this.props;
	      //
	      // this.setState({
	      //   locationDate: moment(instructorAsProctor[index].startTime)
	      // });
	    }
	  }, {
	    key: 'updateLocation',
	    value: function updateLocation() {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      var location = {};
	
	      var startTime = null;
	      var endTime = null;
	
	      if (this.state.locationDate) {
	        var timezone = (0, _moment2.default)(this.state.locationDate).tz(userTimezone).format('Z');
	        var startDate = (0, _moment2.default)(this.state.locationDate).format('YYYY-MM-DD');
	        startTime = (0, _moment2.default)(startDate + ' ' + this.start.value + ' ' + timezone, 'YYYY-MM-DD HH:mm Z').toISOString();
	
	        if (this.range.value === 'between') {
	          var endDate = (0, _moment2.default)(this.state.locationDate).format('YYYY-MM-DD');
	          endTime = (0, _moment2.default)(endDate + ' ' + this.end.value + ' ' + timezone, 'YYYY-MM-DD HH:mm Z').toISOString();
	        }
	      }
	
	      location = {
	        location: this.location.value || null,
	        timeType: this.range.value || 'between',
	        startTime: startTime,
	        endTime: endTime,
	        capacity: 0
	        // capacity: this.capacity.value || 0,
	      };
	
	      if (location.timeType === 'at') {
	        delete location.endTime;
	      }
	
	      this.props.store.ExamStore.updateLocation(this.props.index, location);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          exam = _props2.exam,
	          index = _props2.index,
	          translation = _props2.translation,
	          instructorAsProctor = _props2.instructorAsProctor;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (instructorAsProctor) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields schedule-list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'field--full' },
	              _react2.default.createElement(
	                'div',
	                { className: 'field-wrap' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'exam-location' },
	                  translation.location_helper
	                ),
	                _react2.default.createElement(_reactTextareaAutosize2.default, {
	                  id: 'exam-location',
	                  placeholder: translation.location_helper,
	                  ref: function ref(input) {
	                    _this2.location = input;
	                  },
	                  onChange: function onChange(e) {
	                    return _this2.updateLocation(e);
	                  },
	                  value: instructorAsProctor[index].location || '',
	                  required: true,
	                  'aria-required': 'true',
	                  disabled: this.props.readonly ? true : false
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'schedule-list__date' },
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required' },
	                translation.date
	              ),
	              instructorAsProctor[index].startTime && _react2.default.createElement(_reactDatepicker2.default, {
	                selected: instructorAsProctor[index].startTime ? (0, _moment2.default)(instructorAsProctor[index].startTime).tz(userTimezone) : null,
	                openToDate: (0, _moment2.default)(exam.configuration.examOpenDate),
	                minDate: exam.configuration.examOpenDate,
	                maxDate: exam.configuration.examCloseDate,
	                placeholderText: translation.date_helper,
	                onChange: this.handleLocationDateChange,
	                required: true,
	                'aria-required': 'true',
	                disabled: this.props.readonly ? true : false,
	                autoComplete: 'off'
	              }),
	              !instructorAsProctor[index].startTime && _react2.default.createElement(_reactDatepicker2.default, {
	                selected: this.state.locationDate ? (0, _moment2.default)(this.state.locationDate).tz(userTimezone) : null,
	                openToDate: (0, _moment2.default)(exam.configuration.examOpenDate),
	                minDate: exam.configuration.examOpenDate,
	                maxDate: exam.configuration.examCloseDate,
	                placeholderText: translation.date_helper,
	                onChange: this.handleLocationDateChange,
	                required: true,
	                'aria-required': 'true',
	                disabled: this.props.readonly ? true : false,
	                autoComplete: 'off'
	              })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    ref: function ref(input) {
	                      _this2.range = input;
	                    },
	                    onChange: function onChange(e) {
	                      return _this2.updateLocation(e);
	                    },
	                    value: instructorAsProctor[index].timeType,
	                    disabled: this.props.readonly ? true : false
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'between' },
	                    translation.between
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'at' },
	                    translation.at
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    ref: function ref(input) {
	                      _this2.start = input;
	                    },
	                    onChange: function onChange(e) {
	                      return _this2.updateLocation(e);
	                    },
	                    value: instructorAsProctor[index].startTime ? (0, _moment2.default)(instructorAsProctor[index].startTime).tz(userTimezone).format('HH:mm') : '08:00',
	                    required: true,
	                    'aria-required': 'true',
	                    disabled: this.props.readonly ? true : false
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    translation.start
	                  ),
	                  _react2.default.createElement(_TimeSelect2.default, null)
	                )
	              ),
	              instructorAsProctor[index].timeType !== 'between' && _react2.default.createElement(
	                'span',
	                { className: 'preposition' },
	                this.state.locationDate && _moment2.default.utc(this.state.locationDate).tz(userTimezone).format('z'),
	                !this.state.locationDate && (0, _moment2.default)().tz(userTimezone).format('z')
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: instructorAsProctor[index].timeType === 'between' ? '' : 'disabled' },
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition' },
	                translation.and
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    ref: function ref(input) {
	                      _this2.end = input;
	                    },
	                    onChange: function onChange(e) {
	                      return _this2.updateLocation(e);
	                    },
	                    value: instructorAsProctor[index].endTime ? (0, _moment2.default)(instructorAsProctor[index].endTime).tz(userTimezone).format('HH:mm') || '17:00' : '17:00',
	                    required: instructorAsProctor[index].timeType === 'between',
	                    'aria-required': instructorAsProctor[index].timeType === 'between',
	                    disabled: this.props.readonly ? true : false
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    translation.end
	                  ),
	                  _react2.default.createElement(_TimeSelect2.default, null)
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition' },
	                this.state.locationDate && _moment2.default.utc(this.state.locationDate).tz(userTimezone).format('z'),
	                !this.state.locationDate && (0, _moment2.default)().tz(userTimezone).format('z')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'schedule-buttons' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--add',
	                onClick: function onClick(e) {
	                  return _this2.addLocation(e);
	                },
	                disabled: this.props.readonly ? true : false
	              },
	              _react2.default.createElement(icons.iconPlus, null),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                translation.add_row
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--remove',
	                onClick: function onClick(e) {
	                  return _this2.removeLocation(e, index);
	                },
	                disabled: this.props.readonly ? true : false
	              },
	              _react2.default.createElement(icons.iconMinus, null),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                translation.remove_row
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScheduleFields;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleFields')(ScheduleFields);

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mobxReact = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _mobx = __webpack_require__(13);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentAssignment = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(StudentAssignment, _React$Component);
	
	  function StudentAssignment(props) {
	    _classCallCheck(this, StudentAssignment);
	
	    // Set the initial state
	    var _this = _possibleConstructorReturn(this, (StudentAssignment.__proto__ || Object.getPrototypeOf(StudentAssignment)).call(this));
	
	    _this.state = {
	      examEnrollments: (0, _mobx.toJS)(props.examEnrollments),
	      added: [],
	      removed: []
	
	      // Bind this to functions
	    };_this.verifyChecked = _this.verifyChecked.bind(_this);
	    _this.applyFilters = _this.applyFilters.bind(_this);
	    _this.resetFilters = _this.resetFilters.bind(_this);
	    _this.applyColorIndicator = _this.applyColorIndicator.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(StudentAssignment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ExamStore = this.props.store.ExamStore;
	
	      this.resetFilters();
	      ExamStore.getEnrollments(this.props.exam.sid, null, true);
	    }
	  }, {
	    key: 'onCheck',
	    value: function onCheck(e, key) {
	      var added = this.state.added.includes(key.sid);
	      var removed = this.state.removed.includes(key.sid);
	
	      if (e.target.checked) {
	        // Only assign to exams that are unassigned
	        if (!added && key.session.status === 'Not Assigned') {
	          var updated = [].concat(_toConsumableArray(this.state.added), [key.sid]);
	          this.setState({ added: [].concat(_toConsumableArray(updated)) });
	        }if (removed) {
	          var filtered = this.state.removed.filter(function (sid) {
	            return sid !== key.sid;
	          });
	          this.setState({ removed: filtered });
	        }
	      } else {
	        // only remove from array if it's not assigned
	        if (!removed && key.session.status !== 'Not Assigned') {
	          var _updated = [].concat(_toConsumableArray(this.state.removed), [key.sid]);
	          this.setState({ removed: _updated });
	        } else if (added) {
	          var _filtered = this.state.added.filter(function (sid) {
	            return sid !== key.sid;
	          });
	          this.setState({ added: _filtered });
	        }
	      }
	    }
	  }, {
	    key: 'applyColorIndicator',
	    value: function applyColorIndicator(key) {
	      if (this.state.added.find(function (sid) {
	        return key.sid === sid;
	      })) {
	        return 'added';
	      } else if (this.state.removed.find(function (sid) {
	        return key.sid === sid;
	      })) {
	        return 'removed';
	      }
	    }
	  }, {
	    key: 'applyFilters',
	    value: function applyFilters(e) {
	      var ExamStore = this.props.store.ExamStore;
	
	      var examSid = this.props.exam.sid;
	
	      e.preventDefault();
	
	      var filters = {};
	
	      var name = ExamStore.filterParams.name;
	      var assigned = ExamStore.filterParams.assigned;
	
	      if (name) {
	        filters.name = name;
	      }
	
	      if (assigned) {
	        filters.assigned = assigned;
	      }
	
	      if (assigned || name) {
	        ExamStore.getEnrollments(examSid, filters, true);
	        this.setState({ examEnrollments: ExamStore.examEnrollments });
	      } else {
	        this.resetFilters();
	      }
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      var ExamStore = this.props.store.ExamStore;
	
	      var examSid = this.props.exam.sid;
	
	      ExamStore.filterParams.name = '';
	      ExamStore.filterParams.assigned = '';
	      ExamStore.filterParams.fname = '';
	      ExamStore.filterParams.lname = '';
	      ExamStore.filterParams.status = '';
	      ExamStore.getEnrollments(examSid);
	    }
	  }, {
	    key: 'verifyChecked',
	    value: function verifyChecked(key) {
	      if (key.session.status !== 'Not Assigned') {
	        if (!this.state.removed.includes(key.sid)) {
	          // If orginal status is anything but not assigned and it is not present in the removed array then it should be checked
	          return true;
	        } else {
	          // Included in removed array, return not checked/false
	          return false;
	        }
	      } else if (key.session.status === 'Not Assigned') {
	        if (!this.state.added.includes(key.sid)) {
	          // If original status is not assigned and it's not included in the added array  return unchecked
	          return false;
	        } else {
	          // Included in added array return checked
	          return true;
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore;
	      var translation = this.props.translation;
	      var examEnrollments = ExamStore.examEnrollments;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'flex' },
	        _react2.default.createElement(
	          'div',
	          { className: 'student-assignment-panel' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            translation.studentAssignment
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'filters' },
	            _react2.default.createElement(
	              'label',
	              { className: 'meta', htmlFor: 'filter-name' },
	              translation.name
	            ),
	            _react2.default.createElement('input', {
	              type: 'text',
	              id: 'filter-name',
	              placeholder: translation.name,
	              onChange: function onChange(e) {
	                ExamStore.filterParams.name = e.target.value;_this2.applyFilters(e, true);
	              },
	              value: ExamStore.filterParams.name
	
	            }),
	            _react2.default.createElement(
	              'label',
	              { className: 'select panel__filter', htmlFor: 'filter-status' },
	              _react2.default.createElement(
	                'select',
	                {
	                  id: 'filter-status',
	                  onChange: function onChange(e) {
	                    ExamStore.filterParams.assigned = e.target.value;_this2.applyFilters(e, true);
	                  },
	                  defaultValue: 'All'
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: '' },
	                  translation.filter.status_all
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: true },
	                  translation.assigned
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: false },
	                  translation.not_assigned
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'table-container' },
	            _react2.default.createElement(
	              'table',
	              null,
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                    translation.student
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { id: 'heading-actions', className: 'subtitle table-action', scope: 'col' },
	                    translation.assigned_to_exam
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                examEnrollments.map(function (key, i) {
	                  if (true) {
	                    return [_react2.default.createElement(
	                      'tr',
	                      { key: i, className: _this2.applyColorIndicator(key) },
	                      _react2.default.createElement(
	                        'td',
	                        { 'aria-labelledby': 'heading-name' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'cell-wrap' },
	                          key.lastName,
	                          ', ',
	                          key.firstName
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'number checkbox' },
	                        _react2.default.createElement('input', { id: i + '-checkbox', type: 'checkbox', className: 'checkbox-input', checked: _this2.verifyChecked(key), onChange: function onChange(e) {
	                            return _this2.onCheck(e, key);
	                          } }),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'checkbox-label checkbox-label--solo', htmlFor: i + '-checkbox'
	                          },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            translation.select
	                          )
	                        )
	                      )
	                    )];
	                  }
	
	                  return null;
	                })
	              ),
	              _react2.default.createElement(_LoadMore2.default, Object.assign({
	                tableContainer: true,
	                url: ExamStore.overviewNext,
	                group: ExamStore.examEnrollments,
	                store: ExamStore,
	                resultsName: 'enrollments',
	                text: 'load more',
	                onLoad: function onLoad(examEnrollments) {
	                  _this2.setState({
	                    examEnrollments: examEnrollments
	                  });
	                }
	              }, this.props))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'align-right' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn', disabled: this.state.added.length === 0 && this.state.removed.length === 0, onClick: function onClick() {
	
	                  var studentAssignConfirmation = _react2.default.createElement(
	                    'div',
	                    { className: 'assigned-container' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'heading-info' },
	                      translation.modal.info
	                    ),
	                    _this2.state.added.length > 0 && _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        ' ',
	                        translation.added
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'assigned-list' },
	                        _this2.state.added.map(function (item) {
	                          var enrollment = examEnrollments.find(function (enrollment) {
	                            return enrollment.sid === item;
	                          });
	                          return _react2.default.createElement(
	                            'li',
	                            null,
	                            enrollment.firstName + ' ' + enrollment.lastName
	                          );
	                        })
	                      )
	                    ),
	                    _this2.state.removed.length > 0 && _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        translation.removed
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'assigned-list' },
	                        _this2.state.removed.map(function (item) {
	                          var enrollment = examEnrollments.find(function (enrollment) {
	                            return enrollment.sid === item;
	                          });
	                          return _react2.default.createElement(
	                            'li',
	                            null,
	                            enrollment.firstName + ' ' + enrollment.lastName
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'btn-row' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn--outline', onClick: function onClick() {
	                            SessionStore.alternateModalClose();
	                          } },
	                        translation.cancel
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { className: 'btn', onClick: function onClick() {
	                            var callback = function callback() {
	                              _this2.resetFilters();
	                              ExamStore.getEnrollments(_this2.props.exam.sid, null, true);
	                              _this2.setState({ added: [], removed: [] });
	                              SessionStore.alternateModalClose();
	                            };
	                            ExamStore.updateExamAssignment(_this2.state.added, _this2.state.removed, _this2.props.exam.sid, callback);
	                          } },
	                        translation.confirm
	                      )
	                    )
	                  );
	                  SessionStore.modalContent = studentAssignConfirmation;
	                  SessionStore.hideTimes = true;
	                  SessionStore.showModal = true;
	                  SessionStore.modalSmall = true;
	                  SessionStore.modalHeader = 'Assignment Confirmation';
	                  if (_this2.state.added.length === 0 || _this2.state.removed.length === 0) {
	                    SessionStore.modalShort = true;
	                    SessionStore.modalMediumShort = false;
	                  } else {
	                    SessionStore.modalMediumShort = true;
	                    SessionStore.modalShort = false;
	                  }
	                  SessionStore.modalLoaded = true;
	                } },
	              translation.save
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StudentAssignment;
	}(_react2.default.Component));
	exports.default = (0, _Translate2.default)('StudentAssignment')(StudentAssignment);

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FauxSelect = __webpack_require__(97);
	
	var _FauxSelect2 = _interopRequireDefault(_FauxSelect);
	
	var _ProctorGroupList = __webpack_require__(360);
	
	var _ProctorGroupList2 = _interopRequireDefault(_ProctorGroupList);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var StudentOverview = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(StudentOverview, _React$Component);
	
	  function StudentOverview(props) {
	    _classCallCheck(this, StudentOverview);
	
	    // Set the initial state
	    var _this2 = _possibleConstructorReturn(this, (StudentOverview.__proto__ || Object.getPrototypeOf(StudentOverview)).call(this));
	
	    _this2.state = {
	      examEnrollments: (0, _mobx.toJS)(props.examEnrollments),
	      expanded: [],
	      status: ''
	
	      // Bind this to functions
	    };_this2.applyFilters = _this2.applyFilters.bind(_this2);
	    _this2.resetFilters = _this2.resetFilters.bind(_this2);
	    _this2.selectOption = _this2.selectOption.bind(_this2);
	    _this2.handleAction = _this2.handleAction.bind(_this2);
	    _this2.renderResults = _this2.renderResults.bind(_this2);
	
	    return _this2;
	  }
	
	  _createClass(StudentOverview, [{
	    key: 'selectOption',
	    value: function selectOption(e, props) {
	      var action = e.target.getAttribute('data-action');
	
	      this.handleAction(e, action, props.enrollmentSid, props.userSid, props.sessionSid, props.configurationSid, props.studentName, props.sessionKey, props.crossListed, props.parentSchool, props.workflowModule);
	    }
	  }, {
	    key: 'handleAction',
	    value: function handleAction(e, action, enrollmentSid, userSid, sessionSid, configurationSid, studentName, sessionKey, crossListed, parentSchool, workflowModule) {
	      var _this3 = this;
	
	      var drawerContent = action;
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore,
	          StudentStore = _props$store.StudentStore;
	      var pathname = this.props.routing.location.pathname;
	
	      var examSid = this.props.exam.sid;
	
	      this.setState({
	        enrollmentSid: enrollmentSid,
	        userSid: userSid,
	        sessionSid: sessionSid,
	        configurationSid: configurationSid
	      });
	
	      this.props.parent.setState({
	        changeRequest: false,
	        readonly: false,
	        scheduled: false
	      });
	
	      if (drawerContent && drawerContent !== 'DeleteExamException' && drawerContent !== 'LocateProctor' && drawerContent !== 'UnlockExamException' && drawerContent !== 'Impersonate' && drawerContent !== 'AddAttempt' && drawerContent !== 'NeedsReview') {
	        (0, _helpers.toggleDrawer)(e, this.props.parent, drawerContent);
	      }
	
	      if (drawerContent === 'ExamException' || drawerContent === 'AssignProctor' || drawerContent === 'EditProctor') {
	        pathname += '?enrollment=' + enrollmentSid + '&session=' + sessionSid;
	
	        this.props.parent.setState({
	          crossListed: crossListed,
	          parentSchool: parentSchool
	        });
	
	        this.props.routing.push(pathname);
	      } else if (drawerContent === 'EditExamException') {
	        // Edit an accommodation
	        pathname += '?accommodation=' + configurationSid;
	        this.props.routing.push(pathname);
	      } else if (drawerContent === 'EditScheduledExamException') {
	        // View an accommodation
	        pathname += '?accommodation=' + configurationSid;
	        this.props.routing.push(pathname);
	
	        this.props.parent.setState({
	          scheduled: true
	        });
	      } else if (drawerContent === 'ViewExamException') {
	        // View an accommodation
	        pathname += '?accommodation=' + configurationSid;
	        this.props.routing.push(pathname);
	
	        this.props.parent.setState({
	          readonly: true
	        });
	      } else if (drawerContent === 'UnlockExamException') {
	        // Unlock a locked accommodation
	        var data = {
	          approved: true,
	          locked: false
	        };
	
	        var _this = this;
	
	        var callback = function callback() {
	          ExamStore.getEnrollments(examSid);
	          SessionStore.showToaster(_this.props.translation.accommodation_unlocked, 'success');
	        };
	
	        ExamStore.updateConfigurationStatus(examSid, configurationSid, data, callback);
	      } else if (drawerContent === 'DeleteExamException') {
	        // Delete an accommodation
	        this.deleteConfiguration(configurationSid);
	      } else if (drawerContent === 'SessionDetail') {
	        // Show session details
	        pathname += '?session=' + sessionSid;
	
	        this.props.parent.setState({
	          workflowModule: workflowModule
	        });
	
	        this.props.routing.push(pathname);
	      } else if (drawerContent === 'FundingRules') {
	        // Edit funding rules
	        this.props.parent.setState({
	          enrollmentName: studentName
	        });
	        pathname += '?fundingRuleScope=enrollmentSid&scopeSid=' + enrollmentSid;
	        this.props.routing.push(pathname);
	      } else if (drawerContent === 'VTCReview') {
	        pathname += '?accessKey=' + sessionKey;
	        this.props.routing.push(pathname);
	      }
	
	      if (drawerContent === 'LocateProctor') {
	        // Pass the sessionSid to the parent to be used in the drawer
	        this.props.parent.setState({
	          sessionSid: sessionSid
	        });
	
	        // Get the student’s location and open the drawer
	        SessionStore.getProfile(userSid, true, this.props.parent, function (e) {
	          (0, _helpers.toggleDrawer)(e, _this3.props.parent, drawerContent);
	        });
	      }
	
	      if (drawerContent === 'MessageThread') {
	        this.props.parent.setState({
	          userSid: userSid,
	          configurationSid: configurationSid
	        });
	      }
	
	      // Open a new tab logged in as the student
	      if (drawerContent === 'Impersonate') {
	        var studentWindow = null;
	
	        if (SessionStore.userData.role.toLowerCase() === 'instructor') {
	          studentWindow = window.open('', '_blank');
	        }
	
	        StudentStore.impersonate(enrollmentSid, SettingsStore.integration.accessKey, studentWindow, userSid);
	      }
	
	      // Add an attempt (creates an accommodation with 1 additional attempt)
	      if (drawerContent === 'AddAttempt') {
	        var _this4 = this;
	        var translation = this.props.translation;
	
	
	        var createCallback = function createCallback(examSid, configurationSid) {
	          var edit = function edit() {
	            pathname += '?accommodation=' + configurationSid;
	            _this3.props.routing.push(pathname);
	
	            (0, _helpers.toggleDrawer)(null, _this4.props.parent, 'EditExamException');
	          };
	
	          ExamStore.getEnrollments(examSid);
	
	          var msg = {
	            heading: translation.actions.add_attempt.success_heading,
	            body: translation.actions.add_attempt.success_body,
	            button: translation.actions.add_attempt.success_button,
	            cancel: translation.actions.add_attempt.success_button_no
	          };
	
	          (0, _helpers.confirm)(msg, edit);
	        };
	
	        var _callback = function _callback(data) {
	          var attempts = data.attempts;
	          var attemptsRemaining = data.attemptsRemaining;
	          attempts++;
	          attemptsRemaining++;
	
	          data.attempts = attempts;
	          data.attemptsRemaining = attemptsRemaining;
	
	          ExamStore.configuration = data;
	
	          ExamStore.createConfiguration(examSid, enrollmentSid, createCallback);
	        };
	
	        // get configuration from sid
	        ExamStore.getConfigurationData(examSid, configurationSid, SessionStore.courseData.sid, _callback);
	
	        // get number of attempts for configuration
	        // create new configuration with 1 more attempt
	      }
	
	      if (drawerContent === 'NeedsReview') {
	        var _callback2 = function _callback2() {
	          ExamStore.getEnrollments(examSid);
	        };
	        ExamStore.setExamSessionAsNeedsReview(examSid, SessionStore.userData.installSid, sessionSid, _callback2);
	      }
	    }
	  }, {
	    key: 'deleteConfiguration',
	    value: function deleteConfiguration(configurationSid) {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.delete_confirm.heading,
	        body: translation.delete_confirm.body,
	        button: translation.delete_confirm.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return _this5.props.store.ExamStore.deleteConfiguration(_this5.props.exam.sid, configurationSid);
	      });
	    }
	  }, {
	    key: 'expandRow',
	    value: function expandRow(i) {
	      var expanded = [].concat(_toConsumableArray(this.state.expanded));
	
	      if (expanded.indexOf(i) >= 0) {
	        expanded.splice(expanded.indexOf(i), 1);
	      } else {
	        expanded.push(i);
	      }
	
	      var otherSessions = document.querySelector('#other-sessions-' + i + ' th[tabindex="0"]');
	
	      setTimeout(function () {
	        otherSessions.focus();
	      });
	
	      this.setState({
	        expanded: expanded
	      });
	    }
	  }, {
	    key: 'modalitiesTranslation',
	    value: function modalitiesTranslation(modality, workflowModule) {
	      var translation = this.props.translation;
	
	
	      if (workflowModule === 'hybrid-scheduling' && modality !== 'ad-hoc') {
	        return ' (' + translation.live_virtual + ')';
	      }
	
	      switch (modality) {
	        case 'smarter-scheduling':
	        case 'register-blast':
	          return ' (' + translation.testing_center + ')';
	        case 'automated':
	        case 'vtc':
	          return ' (' + translation.unattended + ')';
	        case 'b-virtual':
	          return ' (' + translation.bvirtual + ')';
	        case 'instructor-as-proctor':
	          return ' (' + translation.instructor + ')';
	        case 'examity':
	          return ' (' + translation.examity + ')';
	        case 'ad-hoc':
	          return ' (' + translation.adhoc_proctor + ')';
	        case 'proctoru':
	          return ' (' + translation.proctoru + ')';
	        case 'messaging':
	          return ' (' + translation.proctoring_professional + ')';
	        default:
	          return '';
	      }
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions(enrollment, otherSession, session) {
	      var _this6 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	      var _props = this.props,
	          exam = _props.exam,
	          translation = _props.translation;
	
	
	      function specialConfigId(enrollment) {
	        if (enrollment.session.examConfiguration) {
	          return enrollment.session.examConfiguration.sid;
	        }
	
	        return exam.configuration.sid;
	      }
	
	      // Determine if the session can be watched live
	      var evaluatedSession = session || enrollment.session;
	      var canLiveWatchSession = (evaluatedSession.schedulingModule === 'automated' || evaluatedSession.workflowModule && evaluatedSession.workflowModule.includes('hybrid')) && evaluatedSession.platformVersion === '3' && (evaluatedSession.status.toLowerCase() === 'disconnected' || evaluatedSession.status.toLowerCase() === 'in progress' || evaluatedSession.status.toLowerCase() === 'checked in' || evaluatedSession.status.toLowerCase() === 'onboarding');
	
	      // Roster actions
	      var actions = [];
	
	      if (!otherSession) {
	        // If this is a live-watchable v3 session, add the watch live option
	        if (canLiveWatchSession) {
	          actions.push({
	            title: translation.actions.view_session_live.label,
	            action: 'SessionDetail',
	            iamAction: 'sp:DescribeExamSession',
	            iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam/' + this.props.exam.sid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':session/' + enrollment.session.sid],
	            helper: translation.actions.view_session_live.helper
	          });
	        }
	        if (enrollment.session.status.toLowerCase() !== 'needs proctor' && (enrollment.session.schedulingModule !== 'automated' && enrollment.session.workflowModule !== 'hybrid-scheduling' || enrollment.session.status.toLowerCase() !== 'scheduled' && enrollment.session.status.toLowerCase() !== 'in progress' && enrollment.session.status.toLowerCase() !== 'processing'
	        // enrollment.session.status.toLowerCase() !== 'cancelled'
	        )) {
	          var scheduledActions = [{
	            title: translation.actions.view_session.label,
	            action: 'SessionDetail',
	            iamAction: 'sp:DescribeExamSession',
	            iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam/' + this.props.exam.sid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':session/' + enrollment.session.sid],
	            helper: translation.actions.view_session.helper
	          }];
	
	          actions = actions.concat(scheduledActions);
	        }
	
	        if (enrollment.session.schedulingModule === 'ad-hoc') {
	          var adHocActions = [{
	            title: translation.actions.edit_proctor.label,
	            action: 'EditProctor',
	            iamAction: 'sp:ModifyExamSession',
	            iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam/' + this.props.exam.sid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':session/' + enrollment.session.sid],
	            helper: translation.actions.edit_proctor.helper
	          }];
	
	          actions = actions.concat(adHocActions);
	        }
	
	        if (enrollment.session.schedulingModule === 'vtc' && enrollment.session.status === 'closed') {
	          var closedActions = [{
	            title: translation.actions.review_session.label,
	            action: 'VTCReview',
	            helper: translation.actions.review_session.helper
	          }];
	
	          actions = actions.concat(closedActions);
	        }
	
	        if (enrollment.session.status.toLowerCase() !== 'scheduled' && enrollment.session.status.toLowerCase() !== 'closed') {
	          var needsProctorActions = [{
	            title: translation.actions.funding_rule.label,
	            action: 'FundingRules',
	            iamAction: 'sp:DescribeFundingRule',
	            iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':funding'],
	            helper: translation.actions.funding_rule.helper
	          }, {
	            title: translation.actions.assign_proctor.label,
	            action: 'AssignProctor',
	            iamAction: 'sp:CreateExamSession',
	            iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam/' + this.props.exam.sid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':session/' + enrollment.session.sid],
	            helper: translation.actions.assign_proctor.helper
	          }, {
	            title: translation.actions.search_proctors.label,
	            action: 'LocateProctor',
	            iamAction: 'sp:SearchProctors',
	            iamResource: 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':proctor',
	            helper: translation.actions.search_proctors.helper
	          }];
	
	          actions = actions.concat(needsProctorActions);
	        }
	
	        if (enrollment.session.examConfiguration && enrollment.session.status.toLowerCase() !== 'scheduled') {
	          // Enrollment has exam configuration and has not scheduled
	          var hasConfigActions = [{
	            title: translation.actions.delete_accommodation.label,
	            action: 'DeleteExamException',
	            iamAction: 'sp:DeleteExamConfiguration',
	            iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam/' + this.props.exam.sid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':course/' + SessionStore.userData.courseSid],
	            helper: translation.actions.delete_accommodation.helper
	          }];
	
	          // If the configuration is not locked, it can also be edited
	          if (!enrollment.session.examConfiguration.locked) {
	            var editConfiguration = {
	              title: translation.actions.edit_accommodation.label,
	              action: 'EditExamException',
	              iamAction: 'sp:ModifyExamConfiguration',
	              iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam/' + this.props.exam.sid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':course/' + SessionStore.userData.courseSid],
	              helper: translation.actions.edit_accommodation.helper
	            };
	
	            hasConfigActions.unshift(editConfiguration);
	          } else {
	            // Enrollment has exam configuration but it’s locked
	            var viewConfiguration = {
	              title: translation.actions.view_accommodation.label,
	              action: 'ViewExamException',
	              iamAction: 'sp:ViewExamConfiguration',
	              iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam/' + this.props.exam.sid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':course/' + SessionStore.userData.courseSid],
	              helper: translation.actions.view_accommodation.helper_locked
	            };
	
	            hasConfigActions.unshift(viewConfiguration);
	          }
	
	          // If the configuration is locked, admins can unlock it
	          if (enrollment.session.examConfiguration.locked && SessionStore.userData.role.toLowerCase() === 'administrator') {
	            var unlockConfiguration = {
	              title: translation.actions.unlock_accommodation.label,
	              action: 'UnlockExamException',
	              helper: translation.actions.edit_accommodation.helper
	            };
	
	            hasConfigActions.unshift(unlockConfiguration);
	          }
	
	          actions = actions.concat(hasConfigActions);
	        } else if (enrollment.session.examConfiguration && enrollment.session.status.toLowerCase() === 'scheduled') {
	          // Enrollment has exam configuration and has scheduled
	          var scheduledConfigActions = [{
	            title: translation.actions.edit_accommodation.label,
	            action: 'EditScheduledExamException',
	            iamAction: 'sp:EditScheduledExamException',
	            iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':exam/' + this.props.exam.sid, 'ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':course/' + SessionStore.userData.courseSid],
	            helper: translation.actions.edit_accommodation.helper
	          }];
	
	          actions = actions.concat(scheduledConfigActions);
	        } else if (enrollment.session.status.toLowerCase() !== 'scheduled' && enrollment.session.status.toLowerCase() !== 'closed' && enrollment.session.status.toLowerCase() !== 'processing' || enrollment.session.status.toLowerCase() === 'scheduled' && (enrollment.session.schedulingModule.toLowerCase() === 'automated' || enrollment.session.workflowModule.toLowerCase() === 'hybrid-scheduling')) {
	          // Enrollment doesn't have exam configuration and has not scheduled
	          // and session status is not closed or the session is scheduled as automated
	          var noConfigActions = [{
	            title: translation.actions.add_accommodation.label,
	            action: 'ExamException',
	            iamAction: 'sp:DescribeMessageThreads',
	            iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':message'],
	            helper: translation.actions.add_accommodation.helper
	          }];
	
	          actions = actions.concat(noConfigActions);
	        }
	
	        if (enrollment.session.status.toLowerCase() === 'closed' && !enrollment.session.examConfiguration) {
	          // Enrollment’s session is closed and doesn't have an accommodation
	          var _closedActions = [{
	            title: translation.actions.add_attempt.label,
	            action: 'AddAttempt',
	            helper: translation.actions.add_attempt.helper
	          }];
	          if (enrollment.session.reviewed === true) {
	            _closedActions.push({
	              title: translation.actions.needs_review.label,
	              action: 'NeedsReview',
	              helper: translation.actions.needs_review.helper
	            });
	          }
	
	          actions = actions.concat(_closedActions);
	        }
	        if (enrollment.session.status.toLowerCase() === 'closed' && enrollment.session.examConfiguration && enrollment.session.reviewed === true) {
	          // Enrollment’s session is closed and does have an accommodation
	          var _closedActions2 = [{
	            title: translation.actions.needs_review.label,
	            action: 'NeedsReview',
	            helper: translation.actions.needs_review.helper
	          }];
	
	          actions = actions.concat(_closedActions2);
	        }
	
	        var globalActions = [];
	
	        var impersonateAction = {
	          title: translation.actions.impersonate.label,
	          action: 'Impersonate',
	          helper: translation.actions.impersonate.helper
	        };
	
	        globalActions.push(impersonateAction);
	
	        actions = actions.concat(globalActions);
	
	        var parentSchool = null;
	
	        if (enrollment.rootAffiliation) {
	          parentSchool = {
	            name: enrollment.rootAffiliation.account.name,
	            installSid: enrollment.rootAffiliation.install.sid
	          };
	        }
	
	        if (enrollment.proctorGroups) {
	          parentSchool.proctorGroups = enrollment.proctorGroups;
	        }
	
	        var crossListed = false;
	
	        if (enrollment.rootAffiliation && enrollment.rootAffiliation.install.sid !== SessionStore.userData.installSid) {
	          crossListed = true;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_FauxSelect2.default, {
	            store: SessionStore,
	            'default': translation.action_select,
	            options: actions,
	            onClick: this.selectOption,
	            key: enrollment,
	            enrollmentSid: enrollment.sid,
	            userSid: enrollment.userSid,
	            sessionSid: enrollment.session.sid,
	            configurationSid: specialConfigId(enrollment),
	            studentName: enrollment.firstName + ' ' + enrollment.lastName,
	            sessionKey: enrollment.session.accessKey,
	            parent: this,
	            skipText: true,
	            crossListed: crossListed,
	            parentSchool: parentSchool,
	            workflowModule: enrollment.session.workflowModule
	          })
	        );
	      } else if (session.status.toLowerCase() !== 'processing' && session.status.toLowerCase() !== 'in progress') {
	        actions = [{
	          title: translation.actions.view_session_live.label,
	          action: 'SessionDetail',
	          helper: translation.actions.view_session_live.helper
	        }];
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_FauxSelect2.default, {
	            'default': translation.action_select,
	            options: actions,
	            onClick: this.selectOption,
	            key: enrollment,
	            enrollmentSid: enrollment.sid,
	            user: enrollment.userSid,
	            sessionSid: session.sid,
	            configurationSid: specialConfigId(enrollment),
	            studentName: enrollment.firstName + ' ' + enrollment.lastName,
	            parent: this,
	            skipText: true,
	            workflowModule: session.workflowModule
	          }),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn--outline',
	              onClick: function onClick(e) {
	                _this6.handleAction(e, _this6.state.action, enrollment.sid, enrollment.userSid, session.sid, specialConfigId(enrollment), enrollment.firstName + ' ' + enrollment.lastName);
	              }
	            },
	            translation.go_button
	          )
	        );
	      }
	    }
	  }, {
	    key: 'applyFilters',
	    value: function applyFilters(e) {
	      var assignment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var ExamStore = this.props.store.ExamStore;
	
	      var examSid = this.props.exam.sid;
	
	      e.preventDefault();
	
	      var filters = {};
	
	      var fname = ExamStore.filterParams.fname;
	      var lname = ExamStore.filterParams.lname;
	      var status = ExamStore.filterParams.status;
	
	      if (fname) {
	        filters.firstName = '' + fname;
	      }
	
	      if (lname) {
	        filters.lastName = '' + lname;
	      }
	
	      if (status) {
	        filters.status = status;
	      }
	
	      if (fname || lname || status) {
	        ExamStore.getEnrollments(examSid, filters);
	        this.setState({ examEnrollments: ExamStore.examEnrollments });
	      } else {
	        console.log('for some reason the filters are being reset');
	        this.resetFilters();
	      }
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      var ExamStore = this.props.store.ExamStore;
	
	      var examSid = this.props.exam.sid;
	
	      ExamStore.filterParams.name = '';
	      ExamStore.filterParams.assigned = '';
	      ExamStore.filterParams.fname = '';
	      ExamStore.filterParams.lname = '';
	      ExamStore.filterParams.status = '';
	      ExamStore.getEnrollments(examSid);
	    }
	  }, {
	    key: 'renderDate',
	    value: function renderDate(date, timeZone) {
	      return _react2.default.createElement(
	        'time',
	        { className: 'pseudo-status-margin' },
	        _moment2.default.utc(date).tz(timeZone).format('M/D/YYYY [at] h:mma z')
	      );
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this7 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	      var translation = this.props.translation;
	      var isLimitedScope = this.props.exam.isLimitedScope;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var examEnrollments = this.state.examEnrollments;
	
	      if (!examEnrollments) {
	        examEnrollments = this.props.examEnrollments;
	      }
	
	      var _this = this;
	
	      function specialConfig(enrollment) {
	        if (enrollment.session.examConfiguration && enrollment.session.examConfiguration.approved) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'table-note' },
	            translation.special_accommodation
	          );
	        } else if (enrollment.session.examConfiguration && !enrollment.session.examConfiguration.approved) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'table-note' },
	            translation.special_accommodation,
	            _react2.default.createElement('br', null),
	            '(',
	            translation.pending,
	            ')'
	          );
	        }
	
	        return '';
	      }
	
	      function showExpand(otherSessions, i) {
	        if (otherSessions.length > 0) {
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn--expand ' + (_this.state.expanded.indexOf(i) >= 0 ? 'expanded' : ''),
	              onClick: function onClick() {
	                _this.expandRow(i);
	              }
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.expand
	            )
	          );
	        }
	
	        return '';
	      }
	
	      function showAttempts(key, i) {
	        if (key.otherSessions.length > 0) {
	          return _react2.default.createElement(
	            'tr',
	            { className: 'row-collapsed ' + (_this.state.expanded.indexOf(i) >= 0 ? 'expanded' : '') },
	            _react2.default.createElement(
	              'td',
	              { colSpan: '4' },
	              _react2.default.createElement(
	                'table',
	                { id: 'other-sessions-' + i },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { id: 'heading-' + i + '-status', scope: 'col', tabIndex: '0' },
	                      translation.status
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { id: 'heading-' + i + '-date', scope: 'col' },
	                      translation.date
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { id: 'heading-' + i + '-actions', scope: 'col' },
	                      translation.action
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  key.otherSessions.map(function (session, j) {
	                    return _react2.default.createElement(
	                      'tr',
	                      { key: j },
	                      _react2.default.createElement(
	                        'td',
	                        { 'aria-labelledby': 'heading-' + i + '-status' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'pill--outside pill--' + session.status.toLowerCase().replace(' ', '-') },
	                          session.status
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { 'aria-labelledby': 'heading-' + i + '-date' },
	                        session.appointmentDate && _react2.default.createElement(
	                          'span',
	                          null,
	                          _moment2.default.utc(session.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                        ),
	                        !session.appointmentDate && _react2.default.createElement(
	                          'span',
	                          { className: 'status-closed' },
	                          translation.not_scheduled
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { 'aria-labelledby': 'heading-' + i + '-actions', className: 'actions' },
	                        _this.renderActions(key, true, session)
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          );
	        }
	
	        return null;
	      }
	
	      if (!examEnrollments || !examEnrollments.length && !SessionStore.loading) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          !this.state.status && translation.no_results,
	          this.state.status && translation.no_results_filtered
	        );
	      } else if (SessionStore.loadingCalls.indexOf('GetProctorGroups') < 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          isLimitedScope && _react2.default.createElement(
	            'h2',
	            { onClick: function onClick(e) {
	                (0, _helpers.toggleDrawer)(e, _this7.props.parent, 'StudentAssignment');
	              } },
	            translation.studentAssignment
	          ),
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                  translation.student
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-notes', className: 'subtitle', scope: 'col' },
	                  translation.notes
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-status', className: 'subtitle', scope: 'col' },
	                  translation.status
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-actions', className: 'subtitle table-action', scope: 'col' },
	                  translation.action
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              examEnrollments.map(function (key, i) {
	                if (!_this.state.status || key.session.status.toLowerCase() === _this.state.status) {
	                  return [_react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    _react2.default.createElement(
	                      'td',
	                      { 'aria-labelledby': 'heading-name' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'cell-wrap' },
	                        key.lastName,
	                        ', ',
	                        key.firstName,
	                        showExpand(key.otherSessions, i)
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'aria-labelledby': 'heading-notes' },
	                      specialConfig(key),
	                      key.session.status.toLowerCase() === 'scheduled' && key.session.schedulingModule === 'ad-hoc' && _react2.default.createElement(
	                        'span',
	                        { className: 'table-note' },
	                        translation.adHoc
	                      ),
	                      key.session.status.toLowerCase() === 'closed' && (key.session.workflowModule.toLowerCase() === 'automated' || key.session.workflowModule.toLowerCase() === 'hybrid-scheduling') && key.session.auditStatus === "Pending Audit" && _react2.default.createElement(
	                        'span',
	                        { className: 'pill pill--processing' },
	                        key.session.auditStatus
	                      ),
	                      key.session.status.toLowerCase() === 'closed' && (key.session.workflowModule.toLowerCase() === 'automated' || key.session.workflowModule.toLowerCase() === 'hybrid-scheduling') && _react2.default.createElement(
	                        'span',
	                        { className: 'pill ' + (key.session.reviewed ? 'pill--resolved' : '') },
	                        key.session.reviewed ? translation.enrollment.reviewed : translation.enrollment.needsReview
	                      ),
	                      key.rootAffiliation && key.rootAffiliation.install.sid !== SessionStore.userData.installSid && _react2.default.createElement(
	                        'span',
	                        { 'aria-describedby': 'visitor-description-' + i },
	                        translation.visiting_student.heading
	                      ),
	                      key.rootAffiliation && key.rootAffiliation.install.sid !== SessionStore.userData.installSid && _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          {
	                            className: 'tooltip__label',
	                            role: 'presentation',
	                            'aria-hidden': 'true'
	                          },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            id: 'visitor-description-' + i,
	                            className: 'tooltip__body',
	                            role: 'tooltip'
	                          },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tooltip__copy' },
	                            _react2.default.createElement(
	                              'strong',
	                              { className: 'subtitle tooltip__title' },
	                              key.rootAffiliation.account.name
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              translation.visiting_student.body
	                            ),
	                            _react2.default.createElement(_ProctorGroupList2.default, Object.assign({
	                              proctorGroups: key.proctorGroups
	                            }, _this7.props))
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'aria-labelledby': 'heading-status' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'pill--outside pill--' + key.session.status.toLowerCase().replace(' ', '-') },
	                        key.session.status,
	                        _this7.modalitiesTranslation(key.session.schedulingModule, key.session.workflowModule)
	                      ),
	                      (key.session.status.toLowerCase() === 'scheduled' || key.session.status.toLowerCase() === 'incident' || key.session.status.toLowerCase() === 'closed') && key.session.schedulingModule !== 'automated' && _this7.renderDate(key.session.appointmentDate, userTimezone),
	                      key.session.schedulingModule === 'automated' && key.session.status.toLowerCase() === 'closed' && _this7.renderDate(key.session.appointmentDate, userTimezone),
	                      key.session.location && key.session.location.friendlyName && _react2.default.createElement(
	                        'p',
	                        { className: 'pseudo-status-margin' },
	                        translation.provider,
	                        ' ',
	                        key.session.location.friendlyName
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'aria-labelledby': 'heading-actions', className: 'actions' },
	                      _this7.renderActions(key)
	                    )
	                  ), showAttempts(key, i)];
	                }
	
	                return null;
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _props$store2 = this.props.store,
	          ExamStore = _props$store2.ExamStore,
	          SessionStore = _props$store2.SessionStore;
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'panel__section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__heading__content' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__heading' },
	            translation.heading
	          ),
	          _react2.default.createElement(
	            'a',
	            { className: 'link--button', onClick: function onClick() {
	                var missingStudentModal = _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'b',
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      translation.modal.heading,
	                      ' '
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    null,
	                    translation.modal.reasons.map(function (item) {
	                      return _react2.default.createElement(
	                        'li',
	                        null,
	                        item
	                      );
	                    })
	                  )
	                );
	
	                SessionStore.showModal = true;
	                SessionStore.modalContent = missingStudentModal;
	                SessionStore.modalSmall = true;
	                SessionStore.modalShort = true;
	                SessionStore.modalLoaded = true;
	              } },
	            translation.modal.link
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'filter', onSubmit: function onSubmit(e) {
	              _this8.applyFilters(e);
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'filter__filters' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--inline' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.filter_heading,
	                    ':'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-fname' },
	                    translation.name
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'filter-fname',
	                    placeholder: translation.name,
	                    onChange: function onChange(e) {
	                      ExamStore.filterParams.fname = e.target.value;
	                    },
	                    value: ExamStore.filterParams.fname
	
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-lname' },
	                    translation.lname
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'filter-lname',
	                    placeholder: translation.lname,
	                    onChange: function onChange(e) {
	                      ExamStore.filterParams.lname = e.target.value;
	                    },
	                    value: ExamStore.filterParams.lname
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select panel__filter', htmlFor: 'filter-status' },
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        id: 'filter-status',
	                        onChange: function onChange(e) {
	                          ExamStore.filterParams.status = e.target.value;
	                        },
	                        defaultValue: ExamStore.filterParams.status
	                      },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        translation.filter.status_all
	                      ),
	                      translation.filter.status_options.map(function (status, i) {
	                        return _react2.default.createElement(
	                          'option',
	                          { value: status.toLowerCase(), key: i },
	                          status
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'actions' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  type: 'submit'
	                },
	                translation.filter_button
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--outline',
	                  type: 'reset',
	                  onClick: this.resetFilters
	                },
	                translation.reset
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('label', { className: 'meta', htmlFor: 'filter-status' }),
	        this.renderResults(),
	        _react2.default.createElement(_LoadMore2.default, Object.assign({
	          tableContainer: true,
	          url: ExamStore.overviewNext,
	          group: ExamStore.examEnrollments,
	          store: ExamStore,
	          resultsName: 'enrollments',
	          text: 'load More',
	          onLoad: function onLoad(examEnrollments) {
	            _this8.setState({
	              examEnrollments: examEnrollments
	            });
	          }
	        }, this.props))
	      );
	    }
	  }]);
	
	  return StudentOverview;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('StudentOverview')(StudentOverview);

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	var UserDetails = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(UserDetails, _React$Component);
	
	  function UserDetails() {
	    _classCallCheck(this, UserDetails);
	
	    return _possibleConstructorReturn(this, (UserDetails.__proto__ || Object.getPrototypeOf(UserDetails)).apply(this, arguments));
	  }
	
	  _createClass(UserDetails, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var userSid = (0, _helpers.getURLSegment)(this, 3);
	
	      this.props.store.EnrollmentStore.getUser(userSid);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var user = this.props.store.EnrollmentStore.user;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                user.lastName,
	                ', ',
	                user.firstName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel--brief' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'data--alt' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.email
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  user.email
	                )
	              ),
	              user.mobilePhone && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.mobile_phone
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  user.mobilePhone
	                )
	              ),
	              user.homePhone && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.home_phone
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  user.homePhone
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.address
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  user.address
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return UserDetails;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('UserDetails')(UserDetails);

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var Video = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Video, _React$Component);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    var _this2 = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this));
	
	    _this2.videoDelay = null;
	
	    _this2.togglePlay = _this2.togglePlay.bind(_this2);
	    _this2.toggleMute = _this2.toggleMute.bind(_this2);
	    _this2.updatePlaybar = _this2.updatePlaybar.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Video, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        currentTime: 0,
	        playing: false,
	        volume: 100,
	        muted: false,
	        duration: 100,
	        ready: false,
	        unsupported: false
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      var delayCount = 0;
	
	      // Wait until video is ready and then get the duration
	      _this.videoDelay = setInterval(function () {
	        delayCount++;
	
	        if (_this.video && _this.video.readyState > 0) {
	          _this.setState({
	            duration: _this.video.duration,
	            ready: true
	          });
	
	          clearInterval(_this.videoDelay);
	        } else if (delayCount >= 100) {
	          // If we’ve tried setting the video enough times,
	          // we can assume it’s still being converted
	          _this.setState({
	            unsupported: true
	          });
	
	          clearInterval(_this.videoDelay);
	        }
	      }, 100);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearInterval(this.timer);
	
	      if (this.state.playing) {
	        this.timer = setInterval(this.updatePlaybar, 1000);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.videoDelay);
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'togglePlay',
	    value: function togglePlay() {
	      if (this.state.playing) {
	        this.video.pause();
	      } else {
	        this.video.play();
	      }
	
	      this.setState({
	        playing: !this.state.playing
	      });
	    }
	  }, {
	    key: 'toggleMute',
	    value: function toggleMute() {
	      if (this.state.muted) {
	        this.video.muted = false;
	      } else {
	        this.video.muted = true;
	      }
	
	      this.setState({
	        muted: !this.state.muted
	      });
	    }
	  }, {
	    key: 'updatePlaybar',
	    value: function updatePlaybar() {
	      this.setState({
	        currentTime: this.video.currentTime
	      });
	    }
	  }, {
	    key: 'track',
	    value: function track(e) {
	      var multiplier = this.progress.value / 100;
	
	      // Set the current time to the total time multiplied by the percent
	      var newTime = multiplier * this.state.duration;
	
	      // Update the video’s current time
	      this.video.currentTime = newTime;
	
	      // Update the state
	      this.setState({
	        currentTime: newTime
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'video' },
	        this.state.unsupported && _react2.default.createElement(
	          'span',
	          { className: 'text-block' },
	          translation.not_supported
	        ),
	        !this.state.unsupported && _react2.default.createElement(
	          'video',
	          {
	            className: this.state.playing ? 'playing' : '',
	            src: this.props.src,
	            autoPlay: this.props.autoplay,
	            ref: function ref(el) {
	              return _this3.video = el;
	            }
	          },
	          _react2.default.createElement(
	            'strong',
	            null,
	            translation.not_supported
	          )
	        ),
	        this.state.ready && this.props.controls && _react2.default.createElement(
	          'div',
	          { className: 'video__controls' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'video__btn video__play btn--reset',
	              onClick: this.togglePlay
	            },
	            this.state.playing ? _react2.default.createElement(icons.iconPause, null) : _react2.default.createElement(icons.iconPlay, null),
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              this.state.playing ? translation.pause : translation.play
	            )
	          ),
	          _react2.default.createElement('input', {
	            type: 'range',
	            className: 'video__progress',
	            defaultValue: this.state.currentTime / this.state.duration * 100,
	            onChange: function onChange(e) {
	              return _this3.track(e);
	            },
	            ref: function ref(input) {
	              return _this3.progress = input;
	            },
	            min: '0',
	            max: '100',
	            step: '1'
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'video__time' },
	            (0, _helpers.formatTime)(this.state.currentTime),
	            ' / ',
	            (0, _helpers.formatTime)(this.state.duration)
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'video__btn video__mute btn--reset ' + (this.state.muted ? 'muted' : ''),
	              onClick: this.toggleMute
	            },
	            _react2.default.createElement(icons.iconVolumeUp, null),
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              this.state.muted ? translation.unmute : translation.mute
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Video;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Video')(Video);

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var NotFound = function (_React$Component) {
	  _inherits(NotFound, _React$Component);
	
	  function NotFound() {
	    _classCallCheck(this, NotFound);
	
	    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	  }
	
	  _createClass(NotFound, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'i',
	            { className: 'page--error__icon' },
	            _react2.default.createElement(icons.iconChainBroken, null)
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            'Page not found'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Sorry, the page you\u2019re trying to reach does not exist. You may have mistyped the URL, or the page may have been removed.'
	          ),
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { className: 'btn--outline', to: '/' },
	            'Return to Dashboard'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NotFound;
	}(_react2.default.Component);
	
	exports.default = NotFound;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	var SessionForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionForm, _React$Component);
	
	  function SessionForm() {
	    _classCallCheck(this, SessionForm);
	
	    var _this = _possibleConstructorReturn(this, (SessionForm.__proto__ || Object.getPrototypeOf(SessionForm)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionForm, [{
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var accessCode = this.key.value;
	
	      this.key.value = '';
	
	      // Add installSid to parent state so we can use it for other endpoints
	      // this.props.parent.setState({
	      //   installSid,
	      //   examSid
	      // });
	
	      // Dialog message in case the session is already there
	      var dialogContent = this.props.translation.already_exists;
	
	      // this.props.store.ManagerStore.getExamSession(installSid, examSid, sessionSid, dialogContent, this.props.parent);
	
	      this.props.store.ManagerStore.getSession(accessCode, this.props.parent, dialogContent);
	      this.props.store.ManagerStore.addSession = false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return (
	        // Will be used when access key endpoint is set up
	        _react2.default.createElement(
	          'form',
	          { className: 'form-inline', onSubmit: function onSubmit(e) {
	              return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	            }, noValidate: true },
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'session-key' },
	                translation.access_key
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                id: 'session-key',
	                ref: function ref(input) {
	                  _this2.key = input;
	                },
	                required: true,
	                'aria-required': 'true',
	                autoFocus: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn--inline', type: 'submit' },
	            'Open Session'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SessionForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionForm')(SessionForm);

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _SessionForm = __webpack_require__(812);
	
	var _SessionForm2 = _interopRequireDefault(_SessionForm);
	
	var _Session = __webpack_require__(367);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _IncidentForm = __webpack_require__(366);
	
	var _IncidentForm2 = _interopRequireDefault(_IncidentForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var SessionManager = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionManager, _React$Component);
	
	  function SessionManager() {
	    _classCallCheck(this, SessionManager);
	
	    var _this2 = _possibleConstructorReturn(this, (SessionManager.__proto__ || Object.getPrototypeOf(SessionManager)).call(this));
	
	    _this2.cancelAdd = _this2.cancelAdd.bind(_this2);
	    _this2.completeIncident = _this2.completeIncident.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(SessionManager, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        minimized: [],
	        installSid: null,
	        examSid: null,
	        courseSid: null,
	        schedulingModule: null,
	        hideForm: true
	
	        // Enable multi-session adding button if it’s allowed
	      };if (this.props.multi) {
	        this.props.store.ManagerStore.multi = true;
	      }
	
	      // If there’s a session sid in the URL, get that session
	      if (this.props.routing.location.query.code) {
	        this.props.store.ManagerStore.getSession(this.props.routing.location.query.code, this);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      // Prevents add session and incident form animations from playing on load
	      setTimeout(function () {
	        _this.setState({
	          hideForm: false
	        });
	      });
	    }
	  }, {
	    key: 'maximize',
	    value: function maximize(accessKey) {
	      var minimized = [].concat(_toConsumableArray(this.state.minimized));
	      var index = minimized.indexOf(accessKey);
	      minimized.splice(index, 1);
	      this.setState({
	        minimized: minimized
	      });
	    }
	  }, {
	    key: 'cancelAdd',
	    value: function cancelAdd() {
	      this.props.store.ManagerStore.addSession = false;
	      this.props.store.ManagerStore.reportIncident = false;
	    }
	  }, {
	    key: 'completeIncident',
	    value: function completeIncident() {
	      var translation = this.props.translation;
	
	
	      this.props.store.ManagerStore.reportIncident = false;
	      this.props.store.ManagerStore.incidentSession = null;
	
	      this.props.store.SessionStore.showToaster(translation.incident_saved, 'success');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ManagerStore = _props$store.ManagerStore,
	          SessionStore = _props$store.SessionStore;
	      var sessions = ManagerStore.sessions;
	
	
	      var sessionSid = null;
	
	      if (this.props.routing.location.query.code) {
	        sessionSid = this.props.routing.location.query.code;
	      }
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page wrap' },
	        !SessionStore.loading && sessions.length === 0 && !sessionSid && _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.page_title
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.intro
	          ),
	          _react2.default.createElement(_SessionForm2.default, Object.assign({ parent: this }, this.props))
	        ),
	        sessions.length > 0 && _react2.default.createElement(
	          'ul',
	          { className: 'block-list session-list' },
	          sessions.map(function (session, i) {
	            if (typeof session.enrollment !== 'undefined' && typeof session.exam !== 'undefined') {
	              return _react2.default.createElement(_Session2.default, Object.assign({
	                key: i,
	                session: session,
	                minimize: _this3.state.minimized.indexOf(session.accessKey) >= 0,
	                parent: _this3,
	                installSid: _this3.state.installSid,
	                courseSid: _this3.state.courseSid,
	                examSid: _this3.state.examSid,
	                schedulingModule: _this3.state.schedulingModule
	              }, _this3.props));
	            }
	
	            return null;
	          })
	        ),
	        this.state.minimized.length > 0 && _react2.default.createElement(
	          'ul',
	          { className: 'minimized' },
	          this.state.minimized.map(function (session, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'article',
	                { className: 'minimized__tab' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'minimized__title' },
	                  session
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'minimize__btn',
	                    onClick: function onClick() {
	                      _this3.maximize(session);
	                    }
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.maximize
	                  )
	                )
	              )
	            );
	          })
	        ),
	        this.props.multi && _react2.default.createElement(
	          'div',
	          { className: 'session-interact ' + (this.state.hideForm ? 'hidden' : '') + ' ' + (ManagerStore.addSession ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel--brief' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              translation.add_session
	            ),
	            ManagerStore.addSession && _react2.default.createElement(_SessionForm2.default, Object.assign({ parent: this }, this.props)),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn--link', onClick: this.cancelAdd },
	              translation.cancel
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'session-interact ' + (this.state.hideForm ? 'hidden' : '') + ' ' + (ManagerStore.reportIncident ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel--brief' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              translation.report_incident
	            ),
	            ManagerStore.reportIncident && _react2.default.createElement(_IncidentForm2.default, Object.assign({
	              installSid: this.state.installSid,
	              examSid: this.state.examSid,
	              completeIncident: this.completeIncident
	            }, this.props)),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn--link', onClick: this.cancelAdd },
	              translation.cancel
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SessionManager;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionManager')(SessionManager);

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Dependencies
	
	
	var TimeZone = function (_React$Component) {
	  _inherits(TimeZone, _React$Component);
	
	  function TimeZone() {
	    _classCallCheck(this, TimeZone);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (TimeZone.__proto__ || Object.getPrototypeOf(TimeZone)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleReset = _this.handleReset.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      convertedTimes: []
	    };
	    return _this;
	  }
	
	  _createClass(TimeZone, [{
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var convertedTimes = [];
	      var timestamp = this.timestamp.value;
	      var timeZones = ['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'US/Alaska', 'US/Hawaii'];
	
	      timeZones.forEach(function (timeZone) {
	        var convertedTime = null;
	
	        if ((0, _moment2.default)(timestamp).isValid()) {
	          convertedTime = '' + (0, _moment2.default)(timestamp).tz(timeZone).format('MM/DD/YYYY [at] h:mma z');
	        } else {
	          // Try converting from epoch if the
	          // provided date wasn’t valid
	          convertedTime = '' + _moment2.default.unix(timestamp).tz(timeZone).format('MM/DD/YYYY [at] h:mma z');
	        }
	
	        convertedTimes.push(convertedTime);
	      });
	
	      this.setState({
	        convertedTimes: convertedTimes
	      });
	    }
	  }, {
	    key: 'handleReset',
	    value: function handleReset() {
	      this.timestamp.value = '';
	
	      this.setState({
	        convertedTimes: []
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            'Time Zone Extractor'
	          ),
	          _react2.default.createElement(
	            'form',
	            { className: 'form-inline', onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	              }, noValidate: true },
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'lbl-required',
	                    htmlFor: 'timestamp'
	                  },
	                  'Timestamp'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'timestamp',
	                  ref: function ref(input) {
	                    return _this2.timestamp = input;
	                  },
	                  required: true,
	                  'aria-required': 'true',
	                  autoFocus: true
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--inline',
	                type: 'submit'
	              },
	              'Submit'
	            )
	          ),
	          this.state.convertedTimes.length > 0 && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'table',
	              { className: 'compact' },
	              _react2.default.createElement(
	                'tbody',
	                null,
	                this.state.convertedTimes.map(function (time, i) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      time
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TimeZone;
	}(_react2.default.Component);
	
	exports.default = TimeZone;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactPhoneNumberInput = __webpack_require__(45);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var GeneralInfo = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(GeneralInfo, _React$Component);
	
	  function GeneralInfo() {
	    _classCallCheck(this, GeneralInfo);
	
	    return _possibleConstructorReturn(this, (GeneralInfo.__proto__ || Object.getPrototypeOf(GeneralInfo)).apply(this, arguments));
	  }
	
	  _createClass(GeneralInfo, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'panel', onSubmit: function onSubmit(e) {
	            return _this2.props.checkValidity(e, function (e) {
	              _this2.props.handleSubmit(e);
	            });
	          }, noValidate: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__header' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'legend',
	              null,
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'fieldset',
	          { className: 'panel__body' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              { className: 'field--half' },
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'register-fname' },
	                translation.fname
	              ),
	              _react2.default.createElement('input', { type: 'text',
	                id: 'register-fname',
	                defaultValue: this.props.accountData.firstName,
	                onChange: function onChange(e) {
	                  return _this2.props.handleInput(e, 'firstName');
	                },
	                placeholder: translation.fname,
	                required: true, 'aria-required': 'true', autoFocus: true })
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'field--half' },
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'register-lname' },
	                translation.lname
	              ),
	              _react2.default.createElement('input', { type: 'text',
	                id: 'register-lname',
	                defaultValue: this.props.accountData.lastName,
	                onChange: function onChange(e) {
	                  return _this2.props.handleInput(e, 'lastName');
	                },
	                placeholder: translation.lname,
	                required: true, 'aria-required': 'true' })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'register-account-name' },
	                translation.account_name
	              ),
	              _react2.default.createElement('input', { type: 'text',
	                id: 'register-account-name',
	                defaultValue: this.props.accountData.accountName,
	                onChange: function onChange(e) {
	                  return _this2.props.handleInput(e, 'accountName');
	                },
	                placeholder: translation.account_name,
	                required: true,
	                'aria-required': 'true'
	              })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'register-email' },
	                translation.email
	              ),
	              _react2.default.createElement('input', { type: 'email',
	                id: 'register-email',
	                defaultValue: this.props.accountData.email,
	                onChange: function onChange(e) {
	                  return _this2.props.handleInput(e, 'email');
	                },
	                placeholder: translation.email,
	                required: true, 'aria-required': 'true' })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'register-phone' },
	                translation.phone.label
	              ),
	              _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                id: 'register-phone',
	                nativeExpanded: true,
	                flagsPath: './static/img/flags/',
	                country: (0, _reactPhoneNumberInput.parsePhoneNumber)(this.props.accountData.phoneNumber).country || 'US',
	                value: this.props.accountData.phoneNumber,
	                onChange: function onChange(e) {
	                  return _this2.props.handleInput(e, 'phoneNumber');
	                },
	                required: true,
	                'aria-required': 'true',
	                'aria-invalid': !(0, _reactPhoneNumberInput.isValidPhoneNumber)(this.props.accountData.phoneNumber)
	              })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'register-account-description' },
	                translation.description
	              ),
	              _react2.default.createElement('input', {
	                type: 'text',
	                id: 'register-account-description',
	                defaultValue: this.props.accountData.description,
	                onChange: function onChange(e) {
	                  return _this2.props.handleInput(e, 'description');
	                },
	                placeholder: translation.description,
	                required: true,
	                'aria-required': 'true'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__actions actions' },
	            _react2.default.createElement(
	              'button',
	              { className: 'actions__btn actions__btn--primary', type: 'submit' },
	              translation.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GeneralInfo;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('GeneralInfo')(GeneralInfo);

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _rcSlider = __webpack_require__(1060);
	
	var _rcSlider2 = _interopRequireDefault(_rcSlider);
	
	var _reactTabs = __webpack_require__(195);
	
	var _reactCheckboxGroup = __webpack_require__(1073);
	
	var _reactRadioGroup = __webpack_require__(1243);
	
	var _reactTextareaAutosize = __webpack_require__(74);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Map = __webpack_require__(149);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	// Slider tooltips
	var createSliderWithTooltip = _rcSlider2.default.createSliderWithTooltip;
	var Range = createSliderWithTooltip(_rcSlider2.default.Range);
	
	var Location = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Location, _React$Component);
	
	  function Location() {
	    _classCallCheck(this, Location);
	
	    var _this2 = _possibleConstructorReturn(this, (Location.__proto__ || Object.getPrototypeOf(Location)).call(this));
	
	    _this2.handlePriceOpts = _this2.handlePriceOpts.bind(_this2);
	    _this2.setLocation = _this2.setLocation.bind(_this2);
	    _this2.updateLocationOpts = _this2.updateLocationOpts.bind(_this2);
	    _this2.updateCurrencies = _this2.updateCurrencies.bind(_this2);
	    _this2.editCurrencies = _this2.editCurrencies.bind(_this2);
	    _this2.addPriceGroup = _this2.addPriceGroup.bind(_this2);
	    _this2.onRangeChange = _this2.onRangeChange.bind(_this2);
	    _this2.addRange = _this2.addRange.bind(_this2);
	    _this2.updateFee = _this2.updateFee.bind(_this2);
	    _this2.handleTabs = _this2.handleTabs.bind(_this2);
	    _this2.handleContinue = _this2.handleContinue.bind(_this2);
	    _this2.handleBack = _this2.handleBack.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleToggle = _this2.handleToggle.bind(_this2);
	    _this2.handleLocationSubmit = _this2.handleLocationSubmit.bind(_this2);
	    _this2.createLocation = _this2.createLocation.bind(_this2);
	    _this2.updateLocation = _this2.updateLocation.bind(_this2);
	    _this2.createLocationAvailability = _this2.createLocationAvailability.bind(_this2);
	    _this2.handleFeesSubmit = _this2.handleFeesSubmit.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Location, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // Default state that we will manipulate and send to the API
	      this.state = {
	        priceGroups: [{
	          title: 'Global',
	          enabled: true,
	          priceModel: 'tiered',
	          currencies: ['USD'],
	          editingCurrencies: false,
	          sessionLength: [0, 480],
	          account: {
	            sid: null,
	            name: null
	          },
	          fees: [{
	            minimumSessionLength: 0,
	            maximumSessionLength: 480,
	            amounts: {
	              USD: {
	                service: 0,
	                late: 0
	              }
	            }
	          }]
	        }],
	        timeZoneSid: null,
	        currencyCode: null,
	        tabs: ['Location', 'Details', 'Pricing'],
	        tabsDisabled: false,
	        activeTab: 1,
	        create: true,
	        locationSid: this.props.locationSid,
	        newLocation: false
	
	        // Get API data for time zones, currencies, and location types
	      };this.props.store.SessionStore.getTimezones();
	      this.props.store.SessionStore.getCurrencies();
	      this.props.store.SessionStore.getAccounts();
	      this.props.store.LocationStore.getLocationTypes();
	
	      // Make sure data from previous locations has been removed
	      this.props.store.LocationStore.resetLocation();
	
	      // If this is the register location form, or the add a new location form,
	      // set newLocation to true since we’re creating a new location
	      if (this.props.routing.location.pathname.indexOf('register') > -1 || this.props.routing.location.pathname.indexOf('add') > -1) {
	
	        this.setState({
	          newLocation: true
	        });
	      }
	
	      // If this is a pre-existing location, get the data
	      if (this.state.locationSid) {
	        this.props.store.LocationStore.getLocation(this.state.locationSid);
	        this.props.store.LocationStore.getLocationAvailability(this);
	
	        // Set create to false since we’re updating
	        this.setState({
	          create: false
	        });
	      } else {
	        // Make sure there isn’t an old locationSid in the LocationStore
	        this.props.store.LocationStore.locationSid = null;
	      }
	    }
	
	    // Format location data and send it to the LocationStore
	
	  }, {
	    key: 'setLocation',
	    value: function setLocation(name, address1, address2, city, region, country, postalCode, lat, lng, preventRender) {
	      var data = {
	        name: name,
	        address1: address1,
	        address2: address2,
	        place: city,
	        region: region,
	        country: country,
	        postalCode: postalCode,
	        locationLatitude: lat,
	        locationLongitude: lng,
	        preventRender: preventRender
	      };
	
	      this.props.store.LocationStore.updateLocationData(data);
	    }
	
	    // Handle price model switching (i.e. flat or tiered)
	
	  }, {
	    key: 'handlePriceOpts',
	    value: function handlePriceOpts(value, index) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	      updatedPriceGroup.priceModel = value;
	
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      // If setting pricing model to flat, remove the extra fee object
	      if (value === 'flat') {
	        updatedPriceGroup.sessionLength = [0, 480];
	        updatedPriceGroup.fees.length = 1;
	        updatedPriceGroup.fees[0].maximumSessionLength = 480;
	      }
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Update late lead time
	
	  }, {
	    key: 'updatePriceGroupData',
	    value: function updatePriceGroupData(i) {
	      var LocationStore = this.props.store.LocationStore;
	
	
	      var data = parseInt(this['leadTime' + i].value, 10) || 0;
	      LocationStore.updateAvailabilityLead(i, data);
	
	      // Update local state
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[i]);
	      updatedPriceGroup.lateSchedulingLeadTime = parseInt(this['leadTime' + i].value, 10) || 0;
	
	      if (data === 0) {
	        updatedPriceGroup.fees.forEach(function (element) {
	          Object.keys(element.amounts).map(function (key) {
	            element.amounts[key].late = 0;
	            return true;
	          });
	        });
	      }
	
	      priceGroups.splice(i, 1, updatedPriceGroup);
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Set default timezone and currency
	
	  }, {
	    key: 'updateLocationOpts',
	    value: function updateLocationOpts() {
	      var timeZoneSid = this.timezone.value || null;
	      var currencyCode = this.defaultCurrency.value || null;
	      var proctorLocationTypeSid = this.locationType.value || null;
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[0]);
	
	      var data = {
	        timeZoneSid: timeZoneSid,
	        currencyCode: currencyCode,
	        proctorLocationTypeSid: proctorLocationTypeSid,
	        preventRender: true
	      };
	
	      var fees = {
	        minimumSessionLength: 0,
	        maximumSessionLength: 480,
	        amounts: _defineProperty({}, currencyCode, {
	          service: 0,
	          late: 0
	        })
	      };
	
	      updatedPriceGroup.fees = [fees];
	      updatedPriceGroup.currencies = [currencyCode];
	      updatedPriceGroup.sessionLength = [0, 480];
	
	      priceGroups.splice(0, 1, updatedPriceGroup);
	
	      this.setState({
	        currencyCode: currencyCode,
	        timeZoneSid: timeZoneSid,
	        proctorLocationTypeSid: proctorLocationTypeSid,
	        priceGroups: priceGroups
	      });
	
	      this.props.store.LocationStore.updateLocationData(data);
	    }
	
	    // Add or remove currencies
	
	  }, {
	    key: 'updateCurrencies',
	    value: function updateCurrencies(value, index) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	      // Add to currencies array
	      updatedPriceGroup.currencies = value;
	
	      // Add new currencies to fees array
	      var updatedFees = [];
	      var updatedAmounts = {};
	
	      for (var i = 0; i < updatedPriceGroup.fees.length; i++) {
	        var _removeOld = function _removeOld(updatedAmounts) {
	          Object.keys(updatedAmounts).map(function (key) {
	            if (updatedPriceGroup.currencies.indexOf(key) === -1) {
	              delete updatedAmounts[key];
	            }
	            return updatedAmounts;
	          });
	        };
	
	        var newFeeObject = {};
	
	        for (var j = 0; j < value.length; j++) {
	          if (j >= updatedPriceGroup.fees.length) {
	            updatedAmounts[value[j]] = {
	              service: 0,
	              late: 0
	            };
	          } else {
	            updatedAmounts = updatedPriceGroup.fees[i].amounts;
	
	            // Remove old currencies
	            _removeOld(updatedAmounts);
	          }
	        }
	
	        newFeeObject.minimumSessionLength = updatedPriceGroup.fees[i].minimumSessionLength;
	        newFeeObject.maximumSessionLength = updatedPriceGroup.fees[i].maximumSessionLength;
	        newFeeObject.amounts = updatedAmounts;
	        updatedFees.push(newFeeObject);
	      }
	
	      updatedPriceGroup.fees = updatedFees;
	
	      // Update state
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Show or hide the currency selector
	
	  }, {
	    key: 'editCurrencies',
	    value: function editCurrencies(index) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	      updatedPriceGroup.editingCurrencies = !updatedPriceGroup.editingCurrencies;
	
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Add new price group (availability)
	
	  }, {
	    key: 'addPriceGroup',
	    value: function addPriceGroup() {
	      // Make API call
	      if (this.priceGroup.value) {
	        this.props.store.LocationStore.createLocationAvailability(this.priceGroup.value, this);
	      }
	
	      // Reset select element
	      this.priceGroup.value = '';
	    }
	
	    // Remove price group (availability)
	
	  }, {
	    key: 'removePriceGroup',
	    value: function removePriceGroup(index, sid) {
	      this.props.store.LocationStore.removeLocationAvailability(sid, this);
	
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      priceGroups.splice(index, 1);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Enable or disable price group (availability)
	
	  }, {
	    key: 'togglePriceGroup',
	    value: function togglePriceGroup(i) {
	      var LocationStore = this.props.store.LocationStore;
	
	      LocationStore.toggleLocationAvailability(i);
	    }
	  }, {
	    key: 'sortNumber',
	    value: function sortNumber(a, b) {
	      return a - b;
	    }
	  }, {
	    key: 'sortObject',
	    value: function sortObject(a, b) {
	      if (a.minimumSessionLength < b.minimumSessionLength) {
	        return -1;
	      } else if (a.minimumSessionLength > b.minimumSessionLength) {
	        return 1;
	      }
	
	      return 0;
	    }
	
	    // Add new range to tiered pricing
	
	  }, {
	    key: 'addRange',
	    value: function addRange(activePriceGroup, index) {
	      var rangeCount = activePriceGroup.sessionLength.length;
	      var upperBound = activePriceGroup.sessionLength[rangeCount - 1];
	      var lowerBound = activePriceGroup.sessionLength[rangeCount - 2];
	      var newBound = (upperBound - lowerBound) / 2 + lowerBound;
	      newBound = Math.ceil(newBound / 30) * 30;
	
	      // Make sure the new range is smaller than the limit
	      if (newBound < upperBound) {
	        var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	        var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	        // Add new session length
	        var sessionLength = [].concat(_toConsumableArray(updatedPriceGroup.sessionLength.concat(newBound)));
	        sessionLength.sort(this.sortNumber);
	        updatedPriceGroup.sessionLength = sessionLength;
	
	        // Add new fees object and modify existing
	        var fees = [].concat(_toConsumableArray(updatedPriceGroup.fees));
	        var lastFees = fees.pop();
	        var newFees = Object.assign({}, lastFees);
	
	        newFees.minimumSessionLength = lowerBound;
	        newFees.maximumSessionLength = newBound;
	        lastFees.minimumSessionLength = newBound;
	
	        updatedPriceGroup.fees = updatedPriceGroup.fees.concat(newFees);
	        updatedPriceGroup.fees.sort(this.sortObject);
	
	        // Update state
	        priceGroups.splice(index, 1, updatedPriceGroup);
	
	        this.setState({
	          priceGroups: priceGroups
	        });
	      }
	    }
	
	    // Remove range from tiered pricing
	
	  }, {
	    key: 'removeRange',
	    value: function removeRange(activePriceGroup, index, i) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	      var sessionLength = [].concat(_toConsumableArray(updatedPriceGroup.sessionLength));
	      var fees = [].concat(_toConsumableArray(updatedPriceGroup.fees));
	      sessionLength.splice(i, 1);
	      fees.splice(i - 1, 1);
	
	      updatedPriceGroup.sessionLength = sessionLength;
	      updatedPriceGroup.fees = fees;
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Update ranges when dragged
	
	  }, {
	    key: 'onRangeChange',
	    value: function onRangeChange(sessionLength, index) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	      // Update session lengths
	      updatedPriceGroup.sessionLength = sessionLength;
	
	      // Update fees objects
	      var fees = [].concat(_toConsumableArray(updatedPriceGroup.fees));
	
	      for (var j = 0; j < fees.length; j++) {
	        var updatedFees = Object.assign({}, fees[j]);
	        var lowerBound = updatedPriceGroup.sessionLength[j];
	        var upperBound = updatedPriceGroup.sessionLength[j + 1];
	
	        updatedFees.minimumSessionLength = lowerBound;
	        updatedFees.maximumSessionLength = upperBound;
	
	        fees[j] = updatedFees;
	      }
	
	      updatedPriceGroup.fees = fees;
	
	      // Update state
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Update fee properties on input
	
	  }, {
	    key: 'updateFee',
	    value: function updateFee(e, priceGroupIndex, currencyIndex, sessionIndex, fieldType, priceType) {
	      var newFee = Number(e.target.value) || 0;
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[priceGroupIndex]);
	      var currencyName = updatedPriceGroup.currencies[currencyIndex];
	
	      // If flat, set the session index to 0 since there is only one fee element
	      if (priceType === 'flat') {
	        sessionIndex = 0;
	      }
	
	      // Update fees objects
	      var fees = [].concat(_toConsumableArray(updatedPriceGroup.fees));
	
	      if (fieldType === 'service') {
	        var amounts = Object.assign({}, fees[sessionIndex].amounts);
	        var currency = Object.assign({}, amounts[currencyName]);
	        var service = Object.assign({}, currency.service);
	
	        for (var i = 0; i < fees.length; i++) {
	          if (i === sessionIndex) {
	            service = newFee;
	            currency.service = service;
	
	            // Make sure late fee is present
	            if (typeof currency.late === 'undefined') {
	              currency.late = 0;
	            }
	
	            amounts[currencyName] = currency;
	            fees[i].amounts = amounts;
	          }
	        }
	      } else {
	        for (var _i = 0; _i < fees.length; _i++) {
	          var _amounts2 = Object.assign({}, fees[_i].amounts);
	          var _currency = Object.assign({}, _amounts2[currencyName]);
	          var late = Object.assign({}, _currency.late);
	
	          late = newFee;
	          _currency.late = late;
	          _amounts2[currencyName] = _currency;
	          fees[_i].amounts = _amounts2;
	        }
	      }
	
	      // Update state
	      priceGroups.splice(priceGroupIndex, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	  }, {
	    key: 'handleTabs',
	    value: function handleTabs(index) {
	      this.setState({
	        activeTab: index + 1
	      });
	    }
	
	    // Decide what to do when tab form is submitted
	
	  }, {
	    key: 'handleContinue',
	    value: function handleContinue(e) {
	      (0, _helpers.toTop)(document.querySelector('.drawer.open'));
	
	      // If it’s the last tab
	      if (this.state.activeTab === this.state.tabs.length) {
	        // If we’re registering, go to next step
	        if (this.props.routing.location.pathname.indexOf('register') > -1) {
	          this.props.nextStep(e);
	        }
	        // Otherwise, close the drawer
	        else {
	            this.props.closeDrawer(null, this.props.parent, (0, _helpers.getURLSegment)(this, 1));
	            this.props.store.SessionStore.showToaster(this.props.translation.success, 'success');
	          }
	      } else {
	        document.querySelector('form.location-form').classList.remove('submitted');
	
	        // Click the next tab if we’re not already on the last one
	        var tabs = document.querySelectorAll('.ReactTabs__Tab');
	        var nextTab = tabs[this.state.activeTab];
	        nextTab.click();
	      }
	    }
	
	    // Decide what to do when the back button is clicked
	
	  }, {
	    key: 'handleBack',
	    value: function handleBack(e) {
	      this.props.store.LocationStore.renderMap = true;
	
	      // If we’re registering and we’re already on the first tab,
	      // go back to the previous step
	      if (this.state.activeTab === 1) {
	        this.props.prevStep(e);
	      } else {
	        // Otherwise go back to the previous tab
	        document.querySelector('form.location-form').classList.remove('submitted');
	        var tabs = document.querySelectorAll('.ReactTabs__Tab');
	        var prevTab = tabs[this.state.activeTab - 2];
	        prevTab.click();
	      }
	    }
	
	    // Update boolean location data (smoke free, technology available, etc.)
	
	  }, {
	    key: 'handleToggle',
	    value: function handleToggle(key) {
	      var LocationStore = this.props.store.LocationStore;
	
	      LocationStore.locationData[key] = !LocationStore.locationData[key];
	      this.handleInput();
	    }
	
	    // Handle location text input
	
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var data = null;
	
	      if (this.state.activeTab === 1) {
	        // We only submit the name and address on the first tab
	        data = {
	          name: this.name.value || null,
	          address1: this.address1.value || null,
	          address2: this.address2.value || null
	        };
	      } else {
	        // Second tab contains more detailed location data
	        data = {
	          notes: this.notes.value || null,
	          smokeFree: this.smokeFree.checked,
	          parkingInformation: this.parkingInformation.value || null,
	          hasComputerAvailable: this.hasComputerAvailable.checked,
	          hasPrinterAvailable: this.hasPrinterAvailable.checked,
	          hasCopierAvailable: this.hasCopierAvailable.checked,
	          hasFaxAvailable: this.hasFaxAvailable.checked,
	          hasElevator: this.hasElevator.checked,
	          hasWheelchairRamp: this.hasWheelchairRamp.checked,
	          hasAlternativeKeyboards: this.hasAlternativeKeyboards.checked,
	          hasScreenEnlarger: this.hasScreenEnlarger.checked,
	          hasScreenReader: this.hasScreenReader.checked,
	          hasSpeechRecognition: this.hasSpeechRecognition.checked,
	          hasTextToSpeech: this.hasTextToSpeech.checked,
	          hasDistractionFreeRooms: this.hasDistractionFreeRooms.checked,
	          timeZoneSid: this.timezone.value || null,
	          currencyCode: this.defaultCurrency.value || null,
	          proctorLocationTypeSid: this.locationType.value || null
	        };
	      }
	
	      // Don’t re-render
	      data.preventRender = true;
	
	      this.props.store.LocationStore.updateLocationData(data);
	    }
	
	    // Decide what to do when a location form is submitted
	
	  }, {
	    key: 'handleLocationSubmit',
	    value: function handleLocationSubmit(e) {
	      if (this.state.create) {
	        // If this is the first submission for the location (i.e. first tab of add form)
	        // create it and set the state create to false so it doesn’t get created again
	        this.createLocation(e);
	        this.setState({
	          create: false
	        });
	      } else {
	        // Otherwise, update it
	        this.updateLocation(e);
	      }
	    }
	  }, {
	    key: 'createLocation',
	    value: function createLocation(e) {
	      this.props.store.LocationStore.createLocation(this.handleContinue, this);
	    }
	  }, {
	    key: 'updateLocation',
	    value: function updateLocation(e) {
	      this.props.store.LocationStore.updateLocation(this.handleContinue, this.state.locationSid);
	    }
	  }, {
	    key: 'createLocationAvailability',
	    value: function createLocationAvailability() {
	      this.props.store.LocationStore.createLocationAvailability();
	    }
	  }, {
	    key: 'handleFeesSubmit',
	    value: function handleFeesSubmit(e) {
	      this.props.store.LocationStore.updateFees(this.state.priceGroups, this.handleContinue);
	    }
	
	    // Main render
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          LocationStore = _props$store.LocationStore,
	          SessionStore = _props$store.SessionStore;
	
	      var center = {
	        lat: LocationStore.locationData.locationLatitude || 37.09024,
	        lng: LocationStore.locationData.locationLongitude || -95.712891
	      };
	
	      var tabClass = '';
	
	      // Disable clicking of tabs if we’re creating a new location
	      if (this.state.newLocation) {
	        tabClass = 'tabs-disabled';
	      } else {
	        tabClass = 'tabs-enabled';
	      }
	
	      // Don’t use the default tab styles
	      _reactTabs.Tabs.setUseDefaultStyles(false);
	
	      // Default map options
	      var zoom = 4;
	      var dropPin = false;
	      var locationClass = null;
	
	      if (LocationStore.locationData.locationLatitude) {
	        // If it’s not a new location, increase the zoom and drop a pin
	        zoom = 17;
	        dropPin = true;
	        locationClass = 'location--selected';
	      } else {
	        // Otherwise, just render the map with the default options
	        LocationStore.renderMap = true;
	      }
	
	      // Default select values
	      var _this = this;
	      function defaultValue(value) {
	        if (_this.state.newLocation) {
	          return '';
	        } else {
	          return value;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__header' },
	          this.state.newLocation && _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'legend',
	              null,
	              translation.add_heading
	            )
	          ),
	          !this.state.newLocation && _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'legend',
	              null,
	              translation.edit_heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          _react2.default.createElement(
	            'article',
	            { className: 'location ' + locationClass },
	            _react2.default.createElement(
	              _reactTabs.Tabs,
	              {
	                onSelect: this.handleTabs
	              },
	              _react2.default.createElement(
	                _reactTabs.TabList,
	                { className: tabClass },
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.location
	                ),
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.details
	                ),
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.pricing
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                { className: 'location__search' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'meta' },
	                  translation.location
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'note note--prominent' },
	                  _react2.default.createElement(icons.iconExclamation, null),
	                  ' ',
	                  translation.disclaimer
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { className: 'location-form', onSubmit: function onSubmit(e) {
	                      e.preventDefault();
	                    }, noValidate: true },
	                  _react2.default.createElement(_Map2.default, { setLocation: this.setLocation, store: this.props.store, center: center, zoom: zoom, dropPin: dropPin, locationSid: this.state.locationSid }),
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: 'location__address' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'map-name' },
	                          'Location Name'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', id: 'map-name', value: LocationStore.locationData.name || '', onChange: this.handleInput, ref: function ref(input) {
	                            _this3.name = input;
	                          }, required: true, 'aria-required': 'true' })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'map-addr1' },
	                          'Address'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', id: 'map-addr1', value: LocationStore.locationData.address1 || '', placeholder: 'Street address (required)', onChange: this.handleInput, ref: function ref(input) {
	                            _this3.address1 = input;
	                          }, required: true, 'aria-required': 'true' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'meta', htmlFor: 'map-addr2' },
	                          'Address line 2'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', id: 'map-addr2', value: LocationStore.locationData.address2 || '', placeholder: 'Apartment, suite, unit, etc. (optional)', onChange: this.handleInput, ref: function ref(input) {
	                            _this3.address2 = input;
	                          } })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'map-city' },
	                          'City'
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'faux-input' },
	                          LocationStore.locationData.place
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'field--third' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'map-region' },
	                          'State/Region'
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'faux-input' },
	                          LocationStore.locationData.region
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'field--third' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'map-postal' },
	                          'Postal Code'
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'faux-input' },
	                          LocationStore.locationData.postalCode
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'field--third' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'map-country' },
	                          'Country'
	                        ),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'faux-input' },
	                          LocationStore.locationData.country
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'meta' },
	                  translation.details
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { className: 'location-form', onSubmit: function onSubmit(e) {
	                      return (0, _helpers.checkValidity)(e, _this3.handleLocationSubmit, 'form.location-form');
	                    }, noValidate: true },
	                  _react2.default.createElement(
	                    'fieldset',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'location-timezone' },
	                          translation.timezone
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'location-timezone',
	                              defaultValue: defaultValue(LocationStore.locationData.timeZoneSid),
	                              onChange: this.updateLocationOpts,
	                              ref: function ref(input) {
	                                _this3.timezone = input;
	                              },
	                              required: true,
	                              'aria-required': 'true'
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.timezone_helper
	                            ),
	                            SessionStore.timezoneList.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.sid },
	                                key.name.replace('_', ' ')
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'location-default-currency' },
	                          translation.default_currency
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'location-default-currency',
	                              defaultValue: defaultValue(LocationStore.locationData.currencyCode),
	                              onChange: this.updateLocationOpts,
	                              ref: function ref(input) {
	                                _this3.defaultCurrency = input;
	                              },
	                              required: true,
	                              'aria-required': 'true'
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.currency_helper
	                            ),
	                            SessionStore.currencyList.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.code },
	                                key.name
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'location-type' },
	                          translation.location_type.heading
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'location-type',
	                              defaultValue: defaultValue(LocationStore.locationData.proctorLocationTypeSid),
	                              onChange: this.updateLocationOpts,
	                              ref: function ref(input) {
	                                _this3.locationType = input;
	                              },
	                              required: true,
	                              'aria-required': 'true'
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.location_type_helper
	                            ),
	                            LocationStore.locationTypesList.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.sid },
	                                key.title
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-optional', htmlFor: 'location-notes' },
	                          translation.notes.label
	                        ),
	                        _react2.default.createElement(_reactTextareaAutosize2.default, { id: 'location-notes', className: 'textarea-grow', onChange: this.handleInput, ref: function ref(input) {
	                            _this3.notes = input;
	                          }, defaultValue: LocationStore.locationData.notes })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: 'location-smoke-free' },
	                          translation.smoke_free
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'checkbox',
	                          id: 'location-smoke-free',
	                          className: 'switch-input',
	                          checked: LocationStore.locationData.smokeFree,
	                          onChange: function onChange() {
	                            _this3.handleToggle('smokeFree');
	                          },
	                          ref: function ref(input) {
	                            _this3.smokeFree = input;
	                          },
	                          onKeyDown: _helpers.handleSwitchInputKeys
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: 'location-smoke-free', className: 'switch-label' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            translation.smoke_free
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-optional', htmlFor: 'location-parking' },
	                          translation.parking_instructions.label
	                        ),
	                        _react2.default.createElement(_reactTextareaAutosize2.default, { id: 'location-parking', className: 'textarea-grow', onChange: this.handleInput, ref: function ref(input) {
	                            _this3.parkingInformation = input;
	                          }, defaultValue: LocationStore.locationData.parkingInformation })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'h4',
	                      { className: 'form-heading' },
	                      translation.technology.heading
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'switch-list' },
	                      Object.keys(translation.technology.options).map(function (key) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: key },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'location-tech-' + key },
	                            translation.technology.options[key].label
	                          ),
	                          _react2.default.createElement('input', { type: 'checkbox', id: 'location-tech-' + key, name: 'tech[]', className: 'switch-input', checked: LocationStore.locationData[key], onChange: function onChange() {
	                              _this3.handleToggle(key);
	                            }, ref: function ref(input) {
	                              _this3[key] = input;
	                            }, onKeyDown: _helpers.handleSwitchInputKeys }),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'switch-label', htmlFor: 'location-tech-' + key },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              translation.technology.options[key].label
	                            )
	                          )
	                        );
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'h4',
	                      { className: 'form-heading' },
	                      translation.accessibility.heading
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'switch-list' },
	                      Object.keys(translation.accessibility.options).map(function (key) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: key },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'location-accessibility-' + key },
	                            translation.accessibility.options[key].label
	                          ),
	                          _react2.default.createElement('input', { type: 'checkbox', id: 'location-accessibility-' + key, name: 'accessibility[]', className: 'switch-input', checked: LocationStore.locationData[key], onChange: function onChange() {
	                              _this3.handleToggle(key);
	                            }, ref: function ref(input) {
	                              _this3[key] = input;
	                            }, onKeyDown: _helpers.handleSwitchInputKeys }),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'switch-label', htmlFor: 'location-accessibility-' + key },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              translation.accessibility.options[key].label
	                            )
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'meta' },
	                  translation.pricing
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { className: 'location-form', onSubmit: function onSubmit(e) {
	                      return (0, _helpers.checkValidity)(e, _this3.handleContinue, 'form.location-form');
	                    }, noValidate: true },
	                  _react2.default.createElement(
	                    'fieldset',
	                    null,
	                    this.renderPriceGroup()
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.state.newLocation && _react2.default.createElement(
	              'div',
	              { className: 'panel__actions actions' },
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--secondary', onClick: function onClick(e) {
	                    return _this3.handleBack(e);
	                  }, type: 'button' },
	                translation.back
	              ),
	              this.state.activeTab !== 2 && this.state.activeTab !== 1 && _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', onClick: function onClick(e) {
	                    return (0, _helpers.checkValidity)(e, _this3.handleFeesSubmit, 'form.location-form');
	                  } },
	                translation.button
	              ),
	              (this.state.activeTab === 2 || this.state.activeTab === 1) && _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', onClick: function onClick(e) {
	                    return (0, _helpers.checkValidity)(e, _this3.handleLocationSubmit, 'form.location-form');
	                  } },
	                translation.button
	              )
	            ),
	            !this.state.newLocation && _react2.default.createElement(
	              'div',
	              { className: 'panel__actions actions' },
	              this.state.activeTab !== 2 && this.state.activeTab !== 1 && _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', onClick: function onClick(e) {
	                    return (0, _helpers.checkValidity)(e, _this3.handleFeesSubmit, 'form.location-form');
	                  } },
	                translation.save
	              ),
	              (this.state.activeTab === 2 || this.state.activeTab === 1) && _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', onClick: function onClick(e) {
	                    return (0, _helpers.checkValidity)(e, _this3.handleLocationSubmit, 'form.location-form');
	                  } },
	                translation.save
	              )
	            )
	          )
	        )
	      );
	    }
	
	    // Render price groups (i.e. availabilities)
	
	  }, {
	    key: 'renderPriceGroup',
	    value: function renderPriceGroup() {
	      var _this4 = this;
	
	      var _props$store2 = this.props.store,
	          LocationStore = _props$store2.LocationStore,
	          SessionStore = _props$store2.SessionStore;
	      var translation = this.props.translation;
	
	
	      if (LocationStore.locationAvailability.length === 0) {
	        return null;
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'fields' },
	          this.state.priceGroups.map(function (key, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i, className: 'price-group' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'form-heading' },
	                _this4.state.priceGroups[i].account && _react2.default.createElement(
	                  'span',
	                  null,
	                  _this4.state.priceGroups[i].account.sid && _this4.state.priceGroups[i].account.name + ' ' + translation.pricing,
	                  _this4.state.priceGroups[i].account.sid && _react2.default.createElement(
	                    'button',
	                    { className: 'btn--link alt-link', onClick: function onClick() {
	                        return _this4.removePriceGroup(i, _this4.state.priceGroups[i].sid);
	                      }, type: 'button' },
	                    translation.remove
	                  )
	                ),
	                !_this4.state.priceGroups[i].account && _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.global,
	                  ' ',
	                  translation.pricing
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'price-group__enabled' },
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'g' + i + '-enabled', className: 'switch-label--alt' },
	                  translation.enabled
	                ),
	                _react2.default.createElement('input', { type: 'checkbox', id: 'g' + i + '-enabled', className: 'switch-input', checked: LocationStore.locationAvailability[i].enabled, onChange: function onChange() {
	                    return _this4.togglePriceGroup(i);
	                  }, onKeyDown: _helpers.handleSwitchInputKeys }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'g' + i + '-enabled', className: 'switch-label' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.enabled
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-optional', htmlFor: 'g' + i + '-lead-time', 'aria-describedby': 'leadtime-tooltip' },
	                    translation.lead_time.label,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'tooltip' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                        '(?)'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { id: 'leadtime-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                        _this4.state.priceGroups[i].lateSchedulingLeadTime !== 0 && _react2.default.createElement(
	                          'span',
	                          null,
	                          translation.lead_time.late_fee_start,
	                          ' ',
	                          _this4.state.priceGroups[i].lateSchedulingLeadTime,
	                          ' ',
	                          translation.lead_time.hours,
	                          ' ',
	                          translation.lead_time.late_fee_end
	                        ),
	                        _this4.state.priceGroups[i].lateSchedulingLeadTime === 0 && _react2.default.createElement(
	                          'span',
	                          null,
	                          translation.lead_time.no_late_fee
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select', htmlFor: 'g' + i + '-lead-time' },
	                    _react2.default.createElement(
	                      'select',
	                      { id: 'g' + i + '-lead-time', defaultValue: _this4.state.priceGroups[i].lateSchedulingLeadTime, onChange: function onChange() {
	                          return _this4.updatePriceGroupData(i);
	                        }, ref: function ref(input) {
	                          _this4['leadTime' + i] = input;
	                        } },
	                      _react2.default.createElement(
	                        'option',
	                        { value: 0 },
	                        '0 ',
	                        translation.lead_time.hours
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 6 },
	                        '6 ',
	                        translation.lead_time.hours
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 12 },
	                        '12 ',
	                        translation.lead_time.hours
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 18 },
	                        '18 ',
	                        translation.lead_time.hours
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 24 },
	                        '24 ',
	                        translation.lead_time.hours
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 30 },
	                        '30 ',
	                        translation.lead_time.hours
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 36 },
	                        '36 ',
	                        translation.lead_time.hours
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 42 },
	                        '42 ',
	                        translation.lead_time.hours
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 48 },
	                        '48 ',
	                        translation.lead_time.hours
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-required' },
	                    translation.price_model
	                  ),
	                  _react2.default.createElement(
	                    _reactRadioGroup.RadioGroup,
	                    {
	                      name: 'price-model' + i,
	                      selectedValue: _this4.state.priceGroups[i].priceModel,
	                      onChange: function onChange(value) {
	                        return _this4.handlePriceOpts(value, i);
	                      }
	                    },
	                    _react2.default.createElement(_reactRadioGroup.Radio, { id: 'g' + i + '-pricing-tiered', value: 'tiered' }),
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'g' + i + '-pricing-tiered' },
	                      translation.tiered
	                    ),
	                    _react2.default.createElement(_reactRadioGroup.Radio, { id: 'g' + i + '-pricing-flat', value: 'flat' }),
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'g' + i + '-pricing-flat' },
	                      translation.flat_rate
	                    )
	                  )
	                )
	              ),
	              _this4.renderPricing(_this4.state.priceGroups[i], i),
	              _react2.default.createElement(
	                _reactCheckboxGroup.CheckboxGroup,
	                { className: 'location__currencies', name: 'currencies', value: _this4.state.priceGroups[i].currencies, onChange: function onChange(value) {
	                    return _this4.updateCurrencies(value, i);
	                  } },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn--link alt-link', onClick: function onClick() {
	                      return _this4.editCurrencies(i);
	                    }, type: 'button' },
	                  !_this4.state.priceGroups[i].editingCurrencies && _react2.default.createElement(
	                    'span',
	                    null,
	                    translation.edit_currencies
	                  ),
	                  _this4.state.priceGroups[i].editingCurrencies && _react2.default.createElement(
	                    'span',
	                    null,
	                    translation.done_editing
	                  )
	                ),
	                _this4.state.priceGroups[i].editingCurrencies && _react2.default.createElement(
	                  'ul',
	                  { id: 'location-currencies', className: 'checklist' },
	                  SessionStore.currencyList.map(function (key, j) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: j },
	                      _react2.default.createElement(_reactCheckboxGroup.Checkbox, { id: 'g' + i + 'c' + j, className: 'switch-input', value: key.code }),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'g' + i + 'c' + j, className: 'switch-label' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'meta' },
	                          key.name
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'g' + i + 'c' + j, className: 'switch-label--alt' },
	                        key.name
	                      )
	                    );
	                  })
	                )
	              )
	            );
	          })
	        );
	      }
	    }
	
	    // Render pricing fields
	
	  }, {
	    key: 'renderPricing',
	    value: function renderPricing(activePriceGroup, index) {
	      var _this5 = this;
	
	      var sessionLoop = [].concat(_toConsumableArray(activePriceGroup.sessionLength));
	      sessionLoop.splice(0, 1);
	
	      var translation = this.props.translation;
	
	
	      if (activePriceGroup.priceModel === 'tiered') {
	        // Render tiered pricing fields
	        return _react2.default.createElement(
	          'div',
	          { className: 'pricing--tiered' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'label-faux' },
	            translation.prices
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'pricing--tiered range' },
	            _react2.default.createElement(
	              'li',
	              { className: 'range__slider' },
	              _react2.default.createElement(
	                'span',
	                null,
	                translation.session_length
	              ),
	              _react2.default.createElement(Range, { min: 0, max: 480, step: 30, dots: true, pushable: true, tipFormatter: function tipFormatter(value) {
	                  return (0, _helpers.toHours)(value);
	                }, value: activePriceGroup.sessionLength, onChange: function onChange(sessionLength) {
	                  return _this5.onRangeChange(sessionLength, index);
	                } }),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn--add', onClick: function onClick() {
	                    return _this5.addRange(activePriceGroup, index);
	                  }, type: 'button' },
	                _react2.default.createElement(icons.iconPlus, null),
	                ' ',
	                translation.add_range
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'range__data' },
	              _react2.default.createElement(
	                'table',
	                { className: 'price-table' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement('td', null),
	                    sessionLoop.map(function (key, i) {
	                      return _this5.renderTHead(key, i, sessionLoop, activePriceGroup, index);
	                    }),
	                    this.state.priceGroups[index].lateSchedulingLeadTime > 0 && _react2.default.createElement(
	                      'th',
	                      { className: 'price-table__last' },
	                      translation.late_fee
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  activePriceGroup.currencies.map(function (key, i) {
	                    return _react2.default.createElement(
	                      'tr',
	                      { key: i },
	                      _react2.default.createElement(
	                        'th',
	                        { scope: 'row' },
	                        key
	                      ),
	                      sessionLoop.map(function (key, j) {
	                        return _react2.default.createElement(
	                          'td',
	                          { key: j, 'data-col': (0, _helpers.toHours)(activePriceGroup.sessionLength[i], true, true) + '\u2013' + (0, _helpers.toHours)(key, false, true) },
	                          _this5.state.priceGroups[index].fees[j].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                            type: 'text',
	                            pattern: '[0-9]+([\\.][0-9]+)?',
	                            placeholder: '0',
	                            onInput: function onInput(e) {
	                              return _this5.updateFee(e, index, i, j, 'service', 'tiered');
	                            },
	                            required: true,
	                            'aria-required': 'true',
	                            defaultValue: _this5.state.priceGroups[index].fees[j].amounts[activePriceGroup.currencies[i]].service.toFixed(2)
	                          }),
	                          !_this5.state.priceGroups[index].fees[j].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                            type: 'text',
	                            pattern: '[0-9]+([\\.][0-9]+)?',
	                            placeholder: '0',
	                            onInput: function onInput(e) {
	                              return _this5.updateFee(e, index, i, j, 'service', 'tiered');
	                            },
	                            required: true,
	                            'aria-required': 'true'
	                          })
	                        );
	                      }),
	                      _this5.state.priceGroups[index].lateSchedulingLeadTime > 0 && _react2.default.createElement(
	                        'td',
	                        { className: 'price-table__last', 'data-col': 'Late Fee' },
	                        _this5.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                          type: 'text',
	                          pattern: '[0-9]+([\\.][0-9]+)?',
	                          placeholder: '0',
	                          onInput: function onInput(e) {
	                            return _this5.updateFee(e, index, i, null, 'late', 'tiered');
	                          },
	                          defaultValue: _this5.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]].late.toFixed(2)
	                        }),
	                        !_this5.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                          type: 'text',
	                          pattern: '[0-9]+([\\.][0-9]+)?',
	                          placeholder: '0',
	                          onInput: function onInput(e) {
	                            return _this5.updateFee(e, index, i, null, 'late', 'tiered');
	                          }
	                        })
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        );
	      } else {
	        // Render flat-rate pricing fields
	        return _react2.default.createElement(
	          'div',
	          { className: 'pricing--flat' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'label-faux' },
	            translation.price
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            activePriceGroup.currencies.map(function (key, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required label-inline', htmlFor: 'g' + index + '-' + key + '-price' },
	                  key,
	                  ' ',
	                  translation.price
	                ),
	                _this5.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                  type: 'text',
	                  pattern: '[0-9]+([\\.][0-9]+)?',
	                  id: 'g' + index + '-' + key + '-price',
	                  placeholder: '0',
	                  onInput: function onInput(e) {
	                    return _this5.updateFee(e, index, i, null, 'service', 'flat');
	                  },
	                  required: true,
	                  'aria-required': 'true',
	                  defaultValue: _this5.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]].service.toFixed(2)
	                }),
	                !_this5.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                  type: 'text',
	                  pattern: '[0-9]+([\\.][0-9]+)?',
	                  id: 'g' + index + '-' + key + '-price',
	                  placeholder: '0',
	                  onInput: function onInput(e) {
	                    return _this5.updateFee(e, index, i, null, 'service', 'flat');
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                }),
	                _this5.state.priceGroups[index].lateSchedulingLeadTime > 0 && _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-required label-inline late', htmlFor: 'g' + index + '-' + key + '-late' },
	                    translation.late_fee
	                  ),
	                  _this5.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                    type: 'text',
	                    pattern: '[0-9]+([\\.][0-9]+)?',
	                    id: 'g' + index + '-' + key + '-late',
	                    placeholder: '0',
	                    onInput: function onInput(e) {
	                      return _this5.updateFee(e, index, i, null, 'late', 'flat');
	                    },
	                    defaultValue: _this5.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]].late.toFixed(2)
	                  }),
	                  !_this5.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                    type: 'text',
	                    pattern: '[0-9]+([\\.][0-9]+)?',
	                    id: 'g' + index + '-' + key + '-late',
	                    placeholder: '0',
	                    onInput: function onInput(e) {
	                      return _this5.updateFee(e, index, i, null, 'late', 'flat');
	                    }
	                  })
	                )
	              );
	            })
	          )
	        );
	      }
	    }
	
	    // Render pricing table
	
	  }, {
	    key: 'renderTHead',
	    value: function renderTHead(key, i, sessionLoop, activePriceGroup, index) {
	      var _this6 = this;
	
	      return _react2.default.createElement(
	        'th',
	        { key: i, scope: 'col', className: 'lbl-required' },
	        (0, _helpers.toHours)(activePriceGroup.sessionLength[i], true),
	        '\u2013',
	        (0, _helpers.toHours)(key, false),
	        sessionLoop.length > 1 && _react2.default.createElement(
	          'button',
	          { className: 'btn--remove', onClick: function onClick() {
	              return _this6.removeRange(activePriceGroup, index, i + 1);
	            }, type: 'button' },
	          _react2.default.createElement(icons.iconMinus, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            'Remove Range'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Location;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Location')(Location);

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	// Helpers
	
	
	var ProctoringInfo = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(RegisterStep02, _React$Component);
	
	  function RegisterStep02() {
	    _classCallCheck(this, RegisterStep02);
	
	    return _possibleConstructorReturn(this, (RegisterStep02.__proto__ || Object.getPrototypeOf(RegisterStep02)).apply(this, arguments));
	  }
	
	  _createClass(RegisterStep02, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // Get enabled proctor types
	      this.props.store.SessionStore.getFilteredProctorTypes();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	      var translation = this.props.translation;
	
	
	      function subCategoryLength(subCategories) {
	        var enabledSubcategories = subCategories.filter(function (subCategory) {
	          return subCategory.status !== 'disabled' && subCategory.allowSelfSelection === true;
	        });
	
	        if (enabledSubcategories.length > 0) {
	          return true;
	        }
	
	        return false;
	      }
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'panel', onSubmit: function onSubmit(e) {
	            return _this2.props.checkValidity(e, _this2.props.handleSubmit(e));
	          }, noValidate: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__header' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'legend',
	              null,
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'fieldset',
	          { className: 'panel__body' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'form-heading' },
	            translation.proctor_type.heading,
	            _react2.default.createElement(
	              'div',
	              { className: 'tooltip' },
	              _react2.default.createElement(
	                'span',
	                { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { id: 'proctor-type-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                translation.proctor_type.tooltip
	              )
	            )
	          ),
	          SessionStore.proctorTypeList.map(function (key, i) {
	            if (subCategoryLength(key.subCategories)) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'form-subgroup', key: i },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'form-subheading' },
	                  key.title
	                ),
	                subCategoryLength(key.subCategories),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'switch-list' },
	                  key.subCategories.filter(function (obj) {
	                    return obj.allowSelfSelection;
	                  }).map(function (subKey, j) {
	                    if (subKey.status === 'disabled') {
	                      // Return nothing if this type is disabled
	                      return '';
	                    } else {
	                      // Otherwise return a switch field
	                      return _react2.default.createElement(
	                        'li',
	                        { key: j },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: 'register-type' + i + '-' + j },
	                          subKey.title
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'checkbox',
	                          id: 'register-type' + i + '-' + j,
	                          name: 'languages[]',
	                          className: 'switch-input',
	                          defaultChecked: _this2.props.accountData.proctorTypes.indexOf(subKey.sid) !== -1 ? true : false,
	                          onChange: function onChange(e) {
	                            return _this2.props.handleToggle(e, "proctorTypes", subKey.sid);
	                          },
	                          onKeyDown: _helpers.handleSwitchInputKeys
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'switch-label', htmlFor: 'register-type' + i + '-' + j },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            subKey.title
	                          )
	                        )
	                      );
	                    }
	                  })
	                )
	              );
	            }
	
	            return '';
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__actions actions' },
	            _react2.default.createElement(
	              'button',
	              { className: 'actions__btn actions__btn--secondary', onClick: this.props.prevStep, type: 'button' },
	              translation.back
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'actions__btn actions__btn--primary', type: 'submit' },
	              translation.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RegisterStep02;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProctoringInfo')(ProctoringInfo);

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Step = __webpack_require__(65);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _RegisterStep = __webpack_require__(819);
	
	var _RegisterStep2 = _interopRequireDefault(_RegisterStep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var RegisterForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(RegisterForm, _React$Component);
	
	  function RegisterForm() {
	    _classCallCheck(this, RegisterForm);
	
	    var _this2 = _possibleConstructorReturn(this, (RegisterForm.__proto__ || Object.getPrototypeOf(RegisterForm)).call(this));
	
	    _this2.setStep = _this2.setStep.bind(_this2);
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.prevStep = _this2.prevStep.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleToggle = _this2.handleToggle.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(RegisterForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          LocationStore = _props$store.LocationStore,
	          ProctorStore = _props$store.ProctorStore;
	
	
	      this.state = {
	        step: this.props.step || 1,
	        mode: 'add',
	        skippable: false,
	        proctorSid: null,
	        locationSid: null,
	        accountData: {}
	
	        // If editing, get the data from store
	      };if ((0, _helpers.getURLSegment)(this, 2) === 'edit') {
	        var proctorSid = (0, _helpers.getURLSegment)(this, 3);
	
	        this.setState({
	          proctorSid: proctorSid,
	          mode: 'edit',
	          skippable: true
	        });
	
	        ProctorStore.getProctor(proctorSid, this);
	        LocationStore.getSelfManagedAccountLocation(proctorSid, this);
	      }
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      e.preventDefault();
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this = this;
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(e, name) {
	      var accountData = Object.assign({}, this.state.accountData);
	
	      // Set name to form field
	      if (name === 'phoneNumber') {
	        accountData[name] = e;
	      } else {
	        accountData[name] = e.target.value;
	      }
	
	      this.setState({
	        accountData: accountData
	      });
	    }
	  }, {
	    key: 'handleToggle',
	    value: function handleToggle(e, name, key) {
	      var accountData = Object.assign({}, this.state.accountData);
	      var index = accountData[name].indexOf(key);
	
	      if (e.target.checked && index === -1) {
	        // If checked, push key in array
	        accountData[name].push(key);
	      } else if (index !== -1) {
	        // If unchecked, remove key from array
	        accountData[name].splice(index, 1);
	      }
	
	      this.setState({
	        accountData: accountData
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var _this3 = this;
	
	      var ProctorStore = this.props.store.ProctorStore;
	
	      var cb = function cb(e) {
	        return _this3.nextStep(e);
	      };
	
	      if (this.state.mode === 'edit') {
	        ProctorStore.updateSelfManagedAccount(ProctorStore.proctorSid, this.state.accountData, cb);
	      } else {
	        ProctorStore.addSelfManagedAccount(this.state.accountData, cb, this);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var SessionStore = store.SessionStore;
	
	
	      if (SessionStore.loadingCalls.indexOf('GetProctorData') < 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form ' + (this.state.step === 3 ? 'block-form--alt' : 'no') },
	          _react2.default.createElement(_Step2.default, { step: this.state.step, setStep: this.setStep, data: translation.steps, skippable: this.state.skippable }),
	          _react2.default.createElement(_RegisterStep2.default, Object.assign({
	            step: this.state.step,
	            nextStep: this.nextStep,
	            prevStep: this.prevStep,
	            checkValidity: _helpers.checkValidity,
	            handleInput: this.handleInput,
	            handleToggle: this.handleToggle,
	            handleSubmit: this.handleSubmit,
	            closeDrawer: _helpers.closeDrawer,
	            accountData: this.state.accountData,
	            proctorSid: this.state.proctorSid,
	            locationSid: this.state.locationSid,
	            parent: this
	          }, this.props))
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return RegisterForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('RegisterForm')(RegisterForm);

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GeneralInfo = __webpack_require__(815);
	
	var _GeneralInfo2 = _interopRequireDefault(_GeneralInfo);
	
	var _ProctoringInfo = __webpack_require__(817);
	
	var _ProctoringInfo2 = _interopRequireDefault(_ProctoringInfo);
	
	var _Location = __webpack_require__(816);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// import ProfilePhoto from './ProfilePhoto';
	// import Activate from './Activate';
	
	var RegisterStep = function (_React$Component) {
	  _inherits(RegisterStep, _React$Component);
	
	  function RegisterStep() {
	    _classCallCheck(this, RegisterStep);
	
	    return _possibleConstructorReturn(this, (RegisterStep.__proto__ || Object.getPrototypeOf(RegisterStep)).apply(this, arguments));
	  }
	
	  _createClass(RegisterStep, [{
	    key: 'render',
	    value: function render() {
	      switch (this.props.step) {
	        case 1:
	          return _react2.default.createElement(_GeneralInfo2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	        case 2:
	          return _react2.default.createElement(_ProctoringInfo2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	        case 3:
	          return _react2.default.createElement(_Location2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	        // case 4:
	        //   return <ProfilePhoto nextStep={this.props.nextStep} {...this.props} />;
	
	        // case 5:
	        //   return <Activate nextStep={this.props.nextStep} {...this.props} />;
	
	        default:
	          return _react2.default.createElement(_GeneralInfo2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	      }
	    }
	  }]);
	
	  return RegisterStep;
	}(_react2.default.Component);
	
	exports.default = RegisterStep;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Downloads = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Downloads, _React$Component);
	
	  function Downloads() {
	    _classCallCheck(this, Downloads);
	
	    return _possibleConstructorReturn(this, (Downloads.__proto__ || Object.getPrototypeOf(Downloads)).apply(this, arguments));
	  }
	
	  _createClass(Downloads, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.store.ReportStore.getDownloads();
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(download) {
	      var className = '';
	
	      if (download.status) {
	        switch (download.status.toLowerCase()) {
	          case 'complete':
	            className = 'success';
	            break;
	
	          default:
	            className = 'pending';
	            break;
	        }
	      }
	
	      return className;
	    }
	  }, {
	    key: 'statusIcon',
	    value: function statusIcon(download) {
	      if (download.status) {
	        if (download.status.toLowerCase() === 'complete') {
	          return _react2.default.createElement(icons.iconCheckCircle, null);
	        } else if (download.status.toLowerCase() === 'exporting') {
	          return _react2.default.createElement(icons.iconHourglass, null);
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ReportStore = _props$store.ReportStore,
	          SessionStore = _props$store.SessionStore;
	      var downloads = ReportStore.downloads;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (!SessionStore.loading) {
	        if (downloads.length > 0) {
	          return _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', id: 'heading-title', className: 'subtitle' },
	                  translation.title
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', id: 'heading-date', className: 'subtitle' },
	                  translation.date
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', id: 'heading-status', className: 'subtitle' },
	                  translation.status
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', id: 'heading-download', className: 'subtitle' },
	                  translation.download
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              downloads.map(function (download) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: download.sid },
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-title' },
	                    download.title
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-date' },
	                    _moment2.default.utc(download.createdDate).tz(userTimezone).format('M/D/YYYY h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-status', className: 'capitalize ' + _this2.statusClass(download) },
	                    _this2.statusIcon(download),
	                    download.status,
	                    download.status && download.status.toLowerCase() === 'exporting' && _react2.default.createElement(
	                      'span',
	                      { className: 'pill pill--alt pill--right' },
	                      download.completionPercentage,
	                      '%'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-download', className: 'actions' },
	                    download.status === 'complete' && _react2.default.createElement(
	                      'a',
	                      {
	                        className: 'btn--outline',
	                        href: 'https://s3.amazonaws.com/' + download.s3Bucket + '/' + download.s3FilePath
	                      },
	                      _react2.default.createElement(icons.iconDownload, null),
	                      translation.download
	                    )
	                  )
	                );
	              })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            { className: 'no-results' },
	            translation.no_results
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        )
	      );
	    }
	  }]);
	
	  return Downloads;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Downloads')(Downloads);

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _recharts = __webpack_require__(653);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var Graph = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Graph, _React$Component);
	
	  function Graph() {
	    _classCallCheck(this, Graph);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (Graph.__proto__ || Object.getPrototypeOf(Graph)).call(this));
	
	    _this.getFilters = _this.getFilters.bind(_this);
	    _this.applyFilters = _this.applyFilters.bind(_this);
	    _this.resetFilters = _this.resetFilters.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      isInstructor: false
	    };
	    return _this;
	  }
	
	  _createClass(Graph, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	      var userData = SessionStore.userData;
	
	
	      if (userData && userData.role && userData.role.toLowerCase() === 'instructor') {
	        this.setState({
	          isInstructor: true
	        }, function () {
	          _this2.getFilters();
	        });
	      } else {
	        this.getFilters();
	      }
	    }
	  }, {
	    key: 'getFilters',
	    value: function getFilters() {
	      var CourseStore = this.props.store.CourseStore;
	
	
	      if (CourseStore.courseOfferings.length === 0 && !this.state.isInstructor) {
	        CourseStore.getCourseOfferings();
	      } else if (!CourseStore.exams.length && this.state.isInstructor) {
	        CourseStore.getExams();
	      }
	    }
	  }, {
	    key: 'applyFilters',
	    value: function applyFilters(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var ReportStore = this.props.store.ReportStore;
	
	      var courseOffering = this.courseOffering ? this.courseOffering.value : '';
	      var exam = this.exam ? this.exam.value : '';
	      var filters = {};
	
	      if (courseOffering) {
	        filters.courseOfferingSid = courseOffering;
	      }
	
	      if (exam) {
	        filters.examSid = exam;
	      }
	
	      if (Object.keys(filters).length > 0) {
	        ReportStore.getModalityGraphs(filters, true);
	      } else {
	        this.resetFilters();
	      }
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      var ReportStore = this.props.store.ReportStore;
	
	
	      if (this.courseOffering) {
	        this.courseOffering.value = '';
	      }
	
	      if (this.exam) {
	        this.exam.value = '';
	      }
	
	      ReportStore.graphFilters = {};
	      ReportStore.getModalityGraphs(null, true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          hideFilterBar = _props.hideFilterBar,
	          title = _props.title,
	          translation = _props.translation;
	      var _props$store = this.props.store,
	          CourseStore = _props$store.CourseStore,
	          ReportStore = _props$store.ReportStore,
	          SessionStore = _props$store.SessionStore;
	
	      var animationDuration = 500;
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          !hideFilterBar && _react2.default.createElement(
	            'form',
	            {
	              className: 'filter',
	              onSubmit: this.applyFilters
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields fields--inline' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'legend',
	                      null,
	                      translation.filter,
	                      ':'
	                    )
	                  ),
	                  !this.state.isInstructor && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          ref: function ref(input) {
	                            _this3.courseOffering = input;
	                          },
	                          defaultValue: ReportStore.graphFilters.courseOfferingSid || ''
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          translation.all_offerings
	                        ),
	                        CourseStore.courseOfferings.map(function (offering, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: i, value: offering.sid },
	                            offering.title
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  this.state.isInstructor && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          ref: function ref(input) {
	                            _this3.exam = input;
	                          },
	                          defaultValue: ReportStore.graphFilters.examSid || ''
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          translation.all_exams
	                        ),
	                        CourseStore.exams.map(function (exam, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: i, value: exam.sid },
	                            exam.title
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actions' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn',
	                    type: 'submit'
	                  },
	                  translation.filter
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn--outline',
	                    type: 'reset',
	                    onClick: this.resetFilters
	                  },
	                  translation.reset
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'chart' },
	              title && _react2.default.createElement(
	                'h3',
	                { className: 'chart__title' },
	                title
	              ),
	              _react2.default.createElement(
	                _recharts.ResponsiveContainer,
	                { height: 300 },
	                _react2.default.createElement(
	                  _recharts.BarChart,
	                  {
	                    data: (0, _mobx.toJS)(data)
	                  },
	                  _react2.default.createElement(_recharts.XAxis, { dataKey: 'name' }),
	                  _react2.default.createElement(_recharts.YAxis, null),
	                  _react2.default.createElement(_recharts.Tooltip, null),
	                  !SessionStore.backgroundLoading && data.length && data[0].hasOwnProperty('value') && _react2.default.createElement(_recharts.Bar, {
	                    animationDuration: animationDuration,
	                    barSize: 20,
	                    dataKey: 'value',
	                    fill: '#0074cc'
	                  }),
	                  !SessionStore.backgroundLoading && data.length && data[0].hasOwnProperty('total') && _react2.default.createElement(_recharts.Bar, {
	                    animationDuration: animationDuration,
	                    barSize: 20,
	                    dataKey: 'total',
	                    fill: '#47b8c6'
	                  }),
	                  !SessionStore.backgroundLoading && data.length && data[0].hasOwnProperty('scheduled') && _react2.default.createElement(_recharts.Bar, {
	                    animationDuration: animationDuration,
	                    barSize: 10,
	                    dataKey: 'scheduled',
	                    fill: '#46be8a'
	                  }),
	                  !SessionStore.backgroundLoading && data.length && data[0].hasOwnProperty('closed') && _react2.default.createElement(_recharts.Bar, {
	                    animationDuration: animationDuration,
	                    barSize: 10,
	                    dataKey: 'closed',
	                    fill: '#0074cc'
	                  })
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Graph;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Graph')(Graph);

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDelayed = __webpack_require__(112);
	
	var _reactDelayed2 = _interopRequireDefault(_reactDelayed);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	var _Toolbar = __webpack_require__(98);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ProctorApprovals = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProctorApprovals, _React$Component);
	
	  function ProctorApprovals() {
	    _classCallCheck(this, ProctorApprovals);
	
	    var _this2 = _possibleConstructorReturn(this, (ProctorApprovals.__proto__ || Object.getPrototypeOf(ProctorApprovals)).call(this));
	
	    _this2.getInstallApprovals = _this2.getInstallApprovals.bind(_this2);
	    _this2.applyFilters = _this2.applyFilters.bind(_this2);
	    _this2.resetFilters = _this2.resetFilters.bind(_this2);
	    _this2.deleteApprovals = _this2.deleteApprovals.bind(_this2);
	    _this2.showDetails = _this2.showDetails.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ProctorApprovals, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.getInstallApprovals();
	
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        proctorAccountSid: null,
	        selectedRows: []
	
	        // Make sure proctor types are in store
	      };SessionStore.getProctorTypes();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var proctorAccountSid = this.props.routing.location.query.proctor;
	
	      if (proctorAccountSid) {
	        this.showDetails(proctorAccountSid);
	      }
	    }
	  }, {
	    key: 'getInstallApprovals',
	    value: function getInstallApprovals(query) {
	      // Clear out any previously returned approvals
	      this.props.store.AdminStore.approvals = [];
	
	      // Set the query object
	      var standardQuery = {
	        status: ['allow', 'deny'],
	        limit: 25
	      };
	
	      var fullQuery = Object.assign(standardQuery, query);
	
	      this.props.store.AdminStore.approvalFilterObj = fullQuery;
	
	      // Perform the API call
	      this.props.store.AdminStore.getInstallApprovals();
	    }
	  }, {
	    key: 'applyFilters',
	    value: function applyFilters(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var query = {};
	
	      // Get the status and keyword filter values
	      var status = this.status.value || '';
	      var keyword = this.keyword.value || '';
	
	      if (status) {
	        query.status = status;
	      }
	
	      if (keyword) {
	        query.titleFilter = '*' + keyword + '*';
	      }
	
	      // Get the scope filter value and apply it to the right property
	      switch (this.scope.value) {
	        case 'install':
	          query.applicationInstallSid = 'AI*';
	          break;
	
	        case 'instructor':
	          query.instructorUserSid = 'US*';
	          break;
	
	        case 'course':
	          query.courseSid = 'CU*';
	          break;
	
	        case 'exam':
	          query.examSid = 'EX*';
	          break;
	
	        case 'student':
	          query.studentUserSid = 'US*';
	          break;
	
	        case 'enrollment':
	          query.enrollmentSid = 'EN*';
	          break;
	
	        case 'session':
	          query.examSessionSid = 'ES*';
	          break;
	
	        default:
	          break;
	      }
	
	      this.getInstallApprovals(query);
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      this.getInstallApprovals();
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(e, sid) {
	      var selectedRows = [].concat(_toConsumableArray(this.state.selectedRows));
	      var rowIndex = -1;
	
	      if (e.target.checked) {
	        selectedRows.push(sid);
	      } else {
	        rowIndex = selectedRows.indexOf(sid);
	        selectedRows.splice(rowIndex, 1);
	      }
	
	      this.setState({
	        selectedRows: selectedRows
	      });
	    }
	  }, {
	    key: 'deleteApprovals',
	    value: function deleteApprovals() {
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ProctorStore = _props$store.ProctorStore,
	          ReportStore = _props$store.ReportStore;
	
	
	      var msg = {
	        heading: translation.delete_confirm.heading_singular,
	        body: translation.delete_confirm.body_singular,
	        button: translation.delete_confirm.button
	      };
	
	      if (this.state.selectedRows.length > 1) {
	        msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
	        msg.body = translation.delete_confirm.body_plural;
	      }
	
	      // Loop through all the selected funding rules and send delete API request
	      var _this = this;
	
	      (0, _helpers.confirm)(msg, function () {
	        for (var i = 0; i < _this.state.selectedRows.length; i++) {
	          var callback = null;
	
	          if (i === _this.state.selectedRows.length - 1) {
	            callback = ReportStore.getReportData('approvals');
	          }
	
	          ProctorStore.deleteProctorApproval(_this.state.selectedRows[i], callback);
	        }
	
	        _this.setState({
	          selectedRows: []
	        });
	      });
	    }
	  }, {
	    key: 'showDetails',
	    value: function showDetails(proctorAccountSid) {
	      var _this = this;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.setState({
	        proctorAccountSid: proctorAccountSid
	      }, function () {
	        SessionStore.loading = false;
	        (0, _helpers.toggleDrawer)(null, this, 'ProctorDetails');
	      });
	    }
	  }, {
	    key: 'editApproval',
	    value: function editApproval(e, approval) {
	      var _this = this;
	      var _props$store2 = this.props.store,
	          ProctorStore = _props$store2.ProctorStore,
	          SessionStore = _props$store2.SessionStore;
	
	      var applyTo = (0, _helpers.appliesTo)(approval);
	      var status = e.target.value;
	
	      var data = {
	        reviewedByUserSid: SessionStore.profile.sid,
	        status: status,
	        applyTo: applyTo
	      };
	
	      var callback = function callback() {
	        approval.status = status;
	        _this['checkbox-' + approval.sid].checked = false;
	      };
	
	      ProctorStore.updatePendingApprovals(approval.sid, data, callback, true);
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults(approvals) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          ReportStore = _props$store3.ReportStore,
	          SessionStore = _props$store3.SessionStore;
	      var appendReportData = ReportStore.appendReportData,
	          reportFormat = ReportStore.reportFormat,
	          reportNext = ReportStore.reportNext;
	      var userTimezone = SessionStore.userTimezone;
	
	
	      var group = null;
	      var concat = false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'table-scrollable' },
	        _react2.default.createElement(
	          'div',
	          { className: 'table-wrap' },
	          _react2.default.createElement(
	            'table',
	            { className: 'report-table' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-select', scope: 'col' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    'Select'
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                  translation.proctor,
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'th-fixed',
	                      'aria-hidden': 'true'
	                    },
	                    translation.proctor
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-status', className: 'subtitle', scope: 'col' },
	                  translation.status,
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'th-fixed',
	                      'aria-hidden': 'true'
	                    },
	                    translation.status
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-date', className: 'subtitle', scope: 'col' },
	                  translation.date,
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'th-fixed',
	                      'aria-hidden': 'true'
	                    },
	                    translation.date
	                  )
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-applies', className: 'subtitle', scope: 'col' },
	                  translation.applies_to,
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'th-fixed',
	                      'aria-hidden': 'true'
	                    },
	                    translation.applies_to
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              approvals.map(function (approval, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: i },
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'check-col', 'aria-labelledby': 'heading-select' },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement('input', {
	                        id: 'select-' + approval.sid,
	                        className: 'checkbox-input',
	                        type: 'checkbox',
	                        onChange: function onChange(e) {
	                          return _this3.handleSelect(e, approval.sid);
	                        }
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'checkbox-label checkbox-label--solo', htmlFor: 'select-' + approval.sid
	                        },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'meta' },
	                          'Select ',
	                          approval.sid
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-name' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn--link',
	                        onClick: function onClick(e) {
	                          return _this3.showDetails(approval.proctorAccount.sid);
	                        }
	                      },
	                      approval.proctorAccount.accountName && approval.proctorAccount.accountName,
	                      !approval.proctorAccount.accountName && approval.proctorAccount.firstName + ' ' + approval.proctorAccount.lastName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    {
	                      'aria-labelledby': 'heading-status',
	                      className: 'capitalize ' + (approval.status === 'allow' ? 'positive' : 'negative')
	                    },
	                    approval.status,
	                    (approval.status === 'allow' || approval.status === 'deny') && _react2.default.createElement(
	                      'label',
	                      { className: 'lbl--edit', htmlFor: 'edit-approval-' + approval.sid },
	                      '(edit)'
	                    ),
	                    (approval.status === 'allow' || approval.status === 'deny') && _react2.default.createElement('input', {
	                      id: 'edit-approval-' + approval.sid,
	                      type: 'checkbox',
	                      ref: function ref(input) {
	                        return _this3['checkbox-' + approval.sid] = input;
	                      }
	                    }),
	                    (approval.status === 'allow' || approval.status === 'deny') && _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          defaultValue: approval.status,
	                          onChange: function onChange(e) {
	                            return _this3.editApproval(e, approval);
	                          }
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'allow' },
	                          'Approve'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'deny' },
	                          'Deny'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-date' },
	                    approval.dateReviewed && (0, _moment2.default)(approval.dateReviewed).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-applies', className: 'body' },
	                    (0, _helpers.approvalScope)(approval, translation)
	                  )
	                );
	              })
	            )
	          ),
	          reportNext && _react2.default.createElement(_LoadMore2.default, Object.assign({
	            url: reportNext,
	            text: 'Load more results',
	            dataFormat: reportFormat,
	            dataSet: appendReportData,
	            concat: concat,
	            group: group,
	            wrapper: '.table-wrap'
	          }, this.props))
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          reportData = _props.reportData,
	          translation = _props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        !reportData.length && !SessionStore.loading && _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        ),
	        reportData.length > 0 && this.renderResults(reportData),
	        _react2.default.createElement(
	          _reactDelayed2.default,
	          {
	            mounted: this.state.selectedRows.length > 0,
	            unmountAfter: 250
	          },
	          _react2.default.createElement(_Toolbar2.default, Object.assign({
	            selectedRows: this.state.selectedRows,
	            deleteText: translation.delete,
	            deleteFunction: this.deleteApprovals
	          }, this.props))
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this
	        }, this.props, {
	          proctorAccountSid: this.state.proctorAccountSid,
	          callback: function callback() {
	            return _this4.setState({ drawerContent: null, drawerOpen: false, proctorAccountSid: null });
	          }
	        }))
	      );
	    }
	  }]);
	
	  return ProctorApprovals;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProctorApprovals')(ProctorApprovals);

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var _reactRouter = __webpack_require__(15);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Report = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Report, _React$Component);
	
	  function Report() {
	    _classCallCheck(this, Report);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).call(this));
	
	    _this2.reportActions = {
	      toggleLock: function toggleLock(sids, e) {
	        var data = {
	          approved: true,
	          locked: true
	        };
	
	        if (e.target.getAttribute('title') === 'Click to lock') {
	          // Exam is currently unlocked, so we’ll lock it
	          e.target.className = e.target.className.replace('report-unlocked', 'report-locked');
	          e.target.innerHTML = 'Locked';
	          e.target.setAttribute('title', 'Click to unlock');
	        } else {
	          // Exam is currently locked, so we’ll unlock it
	          data.locked = false;
	
	          e.target.className = e.target.className.replace('report-locked', 'report-unlocked');
	          e.target.innerHTML = 'Unlocked';
	          e.target.setAttribute('title', 'Click to lock');
	        }
	
	        this.props.store.ExamStore.updateConfigurationStatus(sids.examSid, sids.configurationSid, data, null, true);
	      }
	    };
	    _this2.handleClick = _this2.handleClick.bind(_this2);
	    _this2.reportActions.toggleLock = _this2.reportActions.toggleLock.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Report, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // Apply default course offering filter on mount
	      this.props.store.ReportStore.defaultCourseOffering = true;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e, action, actionType, sids) {
	      if (actionType === 'drawer') {
	        e.preventDefault();
	
	        var _this = this;
	        var url = e.target.href;
	        var examSid = (0, _helpers.getParam)('exam', url);
	        var sessionSid = (0, _helpers.getParam)('session', url);
	        var courseSid = (0, _helpers.getParam)('course', url);
	
	        this.props.parent.setState({
	          examSid: examSid,
	          sessionSid: sessionSid,
	          courseSid: courseSid
	        }, function () {
	          (0, _helpers.toggleDrawer)(null, _this.props.parent, action);
	        });
	      } else {
	        this.reportActions[action](sids, e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	      var _props = this.props,
	          reportData = _props.reportData,
	          translation = _props.translation;
	      var _props$store = this.props.store,
	          ReportStore = _props$store.ReportStore,
	          SessionStore = _props$store.SessionStore;
	      var appendReportData = ReportStore.appendReportData,
	          reportFormat = ReportStore.reportFormat,
	          reportNext = ReportStore.reportNext;
	      var userTimezone = SessionStore.userTimezone;
	
	
	      var group = null;
	      var concat = false;
	
	      function renderData(element, index) {
	        if (element && (typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' && !Array.isArray(element)) {
	          // If it’s an object, check for a URL and title
	          if (element.url && element.title) {
	            // If it’s a link, output an anchor tag
	            if (element.target && element.target === '_self') {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    to: element.url,
	                    className: element.class,
	                    onClick: function onClick(e) {
	                      _this.handleClick(e, element.action, element.actionType);
	                    }
	                  },
	                  element.title
	                )
	              );
	            } else {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: element.url,
	                    target: '_blank',
	                    className: element.class,
	                    onClick: function onClick(e) {
	                      _this.handleClick(e, element.action, element.actionType);
	                    }
	                  },
	                  element.title
	                )
	              );
	            }
	          } else if (element.button) {
	            return _react2.default.createElement(
	              'li',
	              { key: index },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: element.class,
	                  type: 'button',
	                  onClick: function onClick(e) {
	                    _this.handleClick(e, element.action, null, element.sids);
	                  },
	                  title: element.helper
	                },
	                element.title
	              )
	            );
	          } else if (element.raw && element.formatted) {
	            // Otherwise, if it’s raw and formatted data, output the formatted data
	            return element.formatted;
	          } else {
	            // If it’s not a link, loop through the keys
	            return Object.keys(element).map(function (key, i) {
	              if (element[key]) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  key === 'examType' && element[key].toLowerCase() === 'written' && _react2.default.createElement(icons.iconPencilPaper, null),
	                  key === 'examType' && element[key].toLowerCase() === 'online' && _react2.default.createElement(icons.iconLaptop, null),
	                  (0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _react2.default.createElement(
	                    'time',
	                    null,
	                    (0, _moment2.default)(element[key]).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) === 'object' && element[key].url && !element[key].mailto && _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: element[key].url, target: '_blank' },
	                    element[key].title
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) === 'object' && element[key].mailto && _react2.default.createElement(
	                    'a',
	                    { href: element[key].url },
	                    element[key].title
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) === 'object' && element[key].onClick && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn',
	                      onClick: _this[element[key].onClick],
	                      'data-sid': element[key].sid
	                    },
	                    element[key].title
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) === 'object' && !element[key].url && !element[key].onClick && _react2.default.createElement(
	                    'span',
	                    null,
	                    'object'
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) !== 'object' && element[key]
	                );
	              }
	
	              return null;
	            });
	          }
	        } else {
	          return _react2.default.createElement(
	            'li',
	            { key: index },
	            element
	          );
	        }
	      }
	
	      if (!SessionStore.loading) {
	        if (reportData && reportData.length > 0) {
	          if (!this.props.disableScroll) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'table-scrollable' },
	              _react2.default.createElement(
	                'div',
	                { className: 'table-wrap' },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'report-table' },
	                  this.props.caption && _react2.default.createElement(
	                    'caption',
	                    null,
	                    this.props.caption
	                  ),
	                  _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      Object.keys(reportData[0]).map(function (key, i) {
	                        return _react2.default.createElement(
	                          'th',
	                          {
	                            id: 'heading-' + i,
	                            key: i,
	                            scope: 'col',
	                            className: 'subtitle column-' + key
	                          },
	                          translation[key] || key,
	                          _react2.default.createElement(
	                            'div',
	                            {
	                              className: 'th-fixed column-' + key,
	                              'data-direction': 'asc',
	                              'aria-hidden': 'true'
	                            },
	                            translation[key] || key
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    reportData.map(function (key, i) {
	                      return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        Object.keys(reportData[0]).map(function (column, j) {
	                          if (reportData[i][column] && _typeof(reportData[i][column]) === 'object' && !(0, _mobx.isObservableArray)(reportData[i][column]) && !_react2.default.isValidElement(reportData[i][column])) {
	
	                            // If the data is an object, loop through it
	                            return _react2.default.createElement(
	                              'td',
	                              {
	                                'aria-labelledby': 'heading-' + j,
	                                key: j,
	                                'data-col': column,
	                                className: 'column-' + column,
	                                'data-value': reportData[i][column].raw || ''
	                              },
	                              _react2.default.createElement(
	                                'ul',
	                                { className: 'table-list' },
	                                renderData(reportData[i][column])
	                              )
	                            );
	                          } else if ((0, _mobx.isObservableArray)(reportData[i][column])) {
	                            // Otherwise, if it’s an array, loop through that
	                            return _react2.default.createElement(
	                              'td',
	                              {
	                                'aria-labelledby': 'heading-' + j,
	                                key: j,
	                                'data-col': column,
	                                className: 'column-' + column
	                              },
	                              _react2.default.createElement(
	                                'ul',
	                                { className: 'table-list' },
	                                reportData[i][column].map(function (subKey, k) {
	                                  return renderData(subKey, k);
	                                })
	                              )
	                            );
	                          } else if (_react2.default.isValidElement(reportData[i][column])) {
	                            // Otherwise, if it’s an element, output it
	                            return _react2.default.createElement(
	                              'td',
	                              {
	                                'aria-labelledby': 'heading-' + j,
	                                key: j,
	                                'data-col': column,
	                                className: 'column-' + column
	                              },
	                              reportData[i][column]
	                            );
	                          } else {
	                            // Otherwise, just output the data
	                            return _react2.default.createElement(
	                              'td',
	                              {
	                                'aria-labelledby': 'heading-' + j,
	                                key: j,
	                                className: (typeof reportData[i][column] === 'number' ? 'number' : '') + ' column-' + column,
	                                'data-col': column,
	                                'data-value': reportData[i][column]
	                              },
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                column === 'examType' && reportData[i][column].toLowerCase() === 'written' && _react2.default.createElement(icons.iconPencilPaper, null),
	                                column === 'examType' && reportData[i][column].toLowerCase() === 'online' && _react2.default.createElement(icons.iconLaptop, null),
	                                (0, _moment2.default)(reportData[i][column], _moment2.default.ISO_8601).isValid() && _react2.default.createElement(
	                                  'time',
	                                  null,
	                                  (0, _moment2.default)(reportData[i][column]).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                                ),
	                                !(0, _moment2.default)(reportData[i][column], _moment2.default.ISO_8601).isValid() && _react2.default.createElement('div', {
	                                  className: 'capitalize',
	                                  dangerouslySetInnerHTML: {
	                                    __html: _dompurify2.default.sanitize(reportData[i][column])
	                                  }
	                                })
	                              )
	                            );
	                          }
	                        })
	                      );
	                    })
	                  )
	                ),
	                reportNext && _react2.default.createElement(_LoadMore2.default, Object.assign({
	                  url: reportNext,
	                  text: 'Load more results',
	                  dataFormat: reportFormat,
	                  dataSet: appendReportData,
	                  concat: concat,
	                  group: group,
	                  wrapper: '.table-wrap'
	                }, this.props))
	              )
	            );
	          } else {
	            return _react2.default.createElement(
	              'table',
	              { className: 'report-table wrapped-table' },
	              this.props.caption && _react2.default.createElement(
	                'caption',
	                null,
	                this.props.caption
	              ),
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  Object.keys(reportData[0]).map(function (key, i) {
	                    return _react2.default.createElement(
	                      'th',
	                      {
	                        id: 'heading-' + i,
	                        key: i,
	                        scope: 'col',
	                        className: 'column-' + key
	                      },
	                      translation[key] || key
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                reportData.map(function (key, i) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    Object.keys(reportData[0]).map(function (column, j) {
	                      if (reportData[i][column] && _typeof(reportData[i][column]) === 'object' && !(0, _mobx.isObservableArray)(reportData[i][column])) {
	                        // If the data is an object, loop through it
	                        return _react2.default.createElement(
	                          'td',
	                          {
	                            'aria-labelledby': 'heading-' + j,
	                            key: j,
	                            'data-col': column,
	                            className: 'column-' + column,
	                            'data-value': reportData[i][column].raw || ''
	                          },
	                          _react2.default.createElement(
	                            'ul',
	                            { className: 'table-list' },
	                            renderData(reportData[i][column])
	                          )
	                        );
	                      } else if ((0, _mobx.isObservableArray)(reportData[i][column])) {
	                        // Otherwise, if it’s an array, loop through that
	                        return _react2.default.createElement(
	                          'td',
	                          {
	                            'aria-labelledby': 'heading-' + j,
	                            key: j,
	                            'data-col': column,
	                            className: 'column-' + column
	                          },
	                          _react2.default.createElement(
	                            'ul',
	                            { className: 'table-list' },
	                            reportData[i][column].map(function (subKey, k) {
	                              return renderData(subKey, k);
	                            })
	                          )
	                        );
	                      } else {
	                        // Otherwise, just output the data
	                        return _react2.default.createElement(
	                          'td',
	                          {
	                            'aria-labelledby': 'heading-' + j,
	                            key: j,
	                            className: (typeof reportData[i][column] === 'number' ? 'number' : '') + ' column-' + column,
	                            'data-col': column,
	                            'data-value': reportData[i][column]
	                          },
	                          (column === 'examType' || column === 'examByWeekType') && reportData[i][column].toLowerCase() === 'written' && _react2.default.createElement(icons.iconPencilPaper, null),
	                          (column === 'examType' || column === 'examByWeekType') && reportData[i][column].toLowerCase() === 'online' && _react2.default.createElement(icons.iconLaptop, null),
	                          (0, _moment2.default)(reportData[i][column], _moment2.default.ISO_8601).isValid() && _react2.default.createElement(
	                            'time',
	                            null,
	                            (0, _moment2.default)(reportData[i][column]).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                          ),
	                          !(0, _moment2.default)(reportData[i][column], _moment2.default.ISO_8601).isValid() && reportData[i][column]
	                        );
	                      }
	                    })
	                  );
	                })
	              )
	            );
	          }
	        } else {
	          return _react2.default.createElement(
	            'span',
	            { className: 'no-results' },
	            translation.no_results
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return Report;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Report')(Report);

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _mobx = __webpack_require__(13);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	var ReportFilter = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ReportFilter, _React$Component);
	
	  function ReportFilter() {
	    _classCallCheck(this, ReportFilter);
	
	    return _possibleConstructorReturn(this, (ReportFilter.__proto__ || Object.getPrototypeOf(ReportFilter)).apply(this, arguments));
	  }
	
	  _createClass(ReportFilter, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var reportFilters = this.props.store.ReportStore.reportFilters;
	
	
	      this.state = {
	        examOpenDate: null,
	        examCloseDate: null
	      };
	
	      if (reportFilters.examOpenDate) {
	        this.setState({
	          examOpenDate: (0, _moment2.default)(reportFilters.examOpenDate)
	        });
	      }
	
	      if (reportFilters.examCloseDate) {
	        this.setState({
	          examCloseDate: (0, _moment2.default)(reportFilters.examCloseDate)
	        });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(key, value, exact) {
	      var ReportStore = this.props.store.ReportStore;
	      var reportFilters = ReportStore.reportFilters;
	
	
	      if (value) {
	        if (exact) {
	          reportFilters[key] = value;
	        } else {
	          reportFilters[key] = '*' + value + '*';
	        }
	      } else {
	        delete reportFilters[key];
	      }
	
	      if (key === 'courseOfferingSid') {
	        ReportStore.defaultCourseOffering = false;
	      }
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, key) {
	      var reportFilters = this.props.store.ReportStore.reportFilters;
	
	      var formattedDate = (0, _moment2.default)(date).local().toISOString();
	
	      reportFilters[key] = formattedDate;
	
	      // Store the new date in state for display
	      this.setState(_defineProperty({}, key, date));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var ReportStore = this.props.store.ReportStore;
	
	
	      (0, _helpers.closeDrawer)(e, this.props.parent);
	
	      ReportStore.getReportData((0, _helpers.getURLSegment)(this, 2));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          AdminStore = _props$store.AdminStore,
	          ReportStore = _props$store.ReportStore,
	          SessionStore = _props$store.SessionStore;
	      var courseOfferings = AdminStore.courseOfferings;
	      var reportFilters = ReportStore.reportFilters,
	          reportFilterMap = ReportStore.reportFilterMap;
	
	
	      var showOfferingFilter = true;
	
	      if ((0, _helpers.getURLSegment)(this, 1) === 'instructor-appointments' || (0, _helpers.getURLSegment)(this, 2) === 'session-requests') {
	        showOfferingFilter = false;
	      }
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                'Filter Report'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief' },
	            _react2.default.createElement(
	              'form',
	              { className: '', onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, function (e) {
	                    return _this2.handleSubmit(e);
	                  });
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  showOfferingFilter && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { htmlFor: 'courseOfferings' },
	                      translation.course_offering.label
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          defaultValue: reportFilters.courseOfferingSid,
	                          id: 'courseOfferings',
	                          onChange: function onChange(e) {
	                            return _this2.handleChange('courseOfferingSid', e.target.value, true);
	                          }
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          translation.course_offering.helper
	                        ),
	                        courseOfferings.map(function (offering, i) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: offering.sid, key: i },
	                            offering.title
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  Object.keys(reportFilterMap).map(function (key, i) {
	                    var dataType = _typeof(reportFilterMap[key]);
	
	                    if (dataType === 'number' && key !== 'courseOfferingSid') {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i,
	                          className: 'field--select-text'
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key] || key
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            { id: key },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '=' },
	                              translation.number.equals
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: '>' },
	                              translation.number.greater_than
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: '<' },
	                              translation.number.less_than
	                            )
	                          )
	                        ),
	                        _react2.default.createElement('input', { type: 'number', id: '', placeholder: '0' })
	                      );
	                    } else if (typeof reportFilterMap[key] === 'string' && key !== 'courseOfferingSid' && reportFilterMap[key] !== 'date') {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key + '_label'] || key
	                        ),
	                        _react2.default.createElement('input', {
	                          id: key,
	                          type: 'text',
	                          defaultValue: reportFilters[key] ? reportFilters[key].replace(/%20/g, ' ').replace(/^\*/, '').replace(/\*$/, '') : '',
	                          onChange: function onChange(e) {
	                            return _this2.handleChange(key, e.target.value);
	                          }, placeholder: translation[key + '_helper'] || ''
	                        })
	                      );
	                    } else if (typeof reportFilterMap[key] === 'string' && reportFilterMap[key] === 'date') {
	                      var date = null;
	
	                      if (_this2.state[key]) {
	                        date = (0, _moment2.default)(_this2.state[key]);
	                      } else if (reportFilters[key]) {
	                        date = (0, _moment2.default)(reportFilters[key]);
	                      }
	
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key + '_label'] || key
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          id: key,
	                          selected: date,
	                          onChange: function onChange(date, e) {
	                            _this2.handleDateChange(date, key, e);
	                          },
	                          placeholderText: 'mm/dd/yyyy',
	                          autoComplete: 'off',
	                          required: _this2.state.examOpenDate || _this2.state.examCloseDate
	                        })
	                      );
	                    } else if (typeof reportFilterMap[key] === 'boolean') {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key + '_label'] || key
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              defaultValue: reportFilters[key],
	                              id: key,
	                              onChange: function onChange(e) {
	                                _this2.handleChange(key, e.target.value, true);
	                              }
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              '---'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: true },
	                              'True'
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: false },
	                              'False'
	                            )
	                          )
	                        )
	                      );
	                    } else if (Array.isArray((0, _mobx.toJS)(reportFilterMap[key]))) {
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key + '_label'] || key
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: key,
	                              onChange: function onChange(e) {
	                                return _this2.handleChange(key, e.target.value, true);
	                              },
	                              defaultValue: reportFilters[key]
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation[key + '_helper']
	                            ),
	                            reportFilterMap[key].map(function (option, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                {
	                                  value: option,
	                                  key: i
	                                },
	                                translation[option + '_label']
	                              );
	                            })
	                          )
	                        )
	                      );
	                    }
	
	                    return '';
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn', type: 'submit' },
	                translation.button
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ReportFilter;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('FilterReport')(ReportFilter);

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDatepicker = __webpack_require__(39);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Report = __webpack_require__(823);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	var _Graph = __webpack_require__(821);
	
	var _Graph2 = _interopRequireDefault(_Graph);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _ProctorApprovals = __webpack_require__(822);
	
	var _ProctorApprovals2 = _interopRequireDefault(_ProctorApprovals);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Reports = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Reports, _React$Component);
	
	  function Reports() {
	    _classCallCheck(this, Reports);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (Reports.__proto__ || Object.getPrototypeOf(Reports)).call(this));
	
	    _this2.exportReport = _this2.exportReport.bind(_this2);
	    _this2.completeExport = _this2.completeExport.bind(_this2);
	    _this2.getReportData = _this2.getReportData.bind(_this2);
	    return _this2;
	  }
	
	  // if(!getURLSegment(this, 2) && getURLSegment(this, 1) !== 'instructor-appointments') {
	  //   return ()
	  // } else {
	  //   return (
	  //     <main tabIndex="0" id="main-content" className="page">
	  //       <header className="page__header">
	  //         <div className="wrap">
	  //           {getURLSegment(this, 1) !== 'instructor-appointments' &&
	  //             <h1 className="page__title">
	  //               {translation.page_title}: {translation.reports[getURLSegment(this, 2)].title}
	  //             </h1>
	  //           }
	  //
	  //           {getURLSegment(this, 1) === 'instructor-appointments' &&
	  //             <h1 className="page__title">
	  //               {translation.reports.instructor_appointments}
	  //             </h1>
	  //           }
	  //
	  //           <div className="page__actions actions">
	  //             {/* Hide the download button if there are no results */}
	  //             {
	  //               (
	  //                 AdminStore.reportData.length > 0 ||
	  //                 (getURLSegment(this, 2) === 'approvals' && AdminStore.approvals.length > 0)
	  //               ) &&
	  //               <button
	  //                 className="btn--outline"
	  //                 onClick={this.exportReport}
	  //               >
	  //                 <icons.iconDownload />
	  //                 {translation.csv_button}
	  //               </button>
	  //             }
	  //
	  //             {getURLSegment(this, 2) !== 'exam' &&
	  //               <button
	  //                 className="btn"
	  //                 onClick={() => toggleDrawer(null, this, 'ReportFilter')}
	  //               >
	  //                 <icons.iconSettings />
	  //                 {translation.filter_button}
	  //               </button>
	  //             }
	  //           </div>
	  //         </div>
	  //       </header>
	  //
	  //       {getURLSegment(this, 2) !== 'approvals' &&
	  //         <div className="wrap">
	  //           {AdminStore.reportData.length !== 0 &&
	  //             <span className="page__subheading">
	  //               {translation.total}: {AdminStore.reportTotal}
	  //             </span>
	  //           }
	  //
	  //           {
	  //             AdminStore.reportData.length !== 0 &&
	  //             !SessionStore.loading && (getURLSegment(this, 2) !== 'exam') &&
	  //
	  //             <Report
	  //               data={this.props.store.AdminStore.reportData}
	  //               parent={this}
	  //               toggleDrawer={toggleDrawer}
	  //               {...this.props}
	  //             />
	  //           }
	  //           {
	  //             AdminStore.reportData.length !== 0 &&
	  //             !SessionStore.loading &&
	  //             (getURLSegment(this, 2) === 'exam') &&
	  //
	  //             this.props.store.AdminStore.reportData.map((x, i) => {
	  //               return (
	  //                 <Report
	  //                   key={i}
	  //                   data={x.exams}
	  //                   parent={this}
	  //                   toggleDrawer={toggleDrawer}
	  //                   disableScroll={true}
	  //                   caption={`${x.start}—${x.end}`}
	  //                   {...this.props}
	  //                 />
	  //               )
	  //             })
	  //           }
	  //
	  //           {AdminStore.reportData.length === 0 && !SessionStore.loading &&
	  //             <span className="no-results">{translation.no_results}</span>
	  //           }
	  //         </div>
	  //       }
	  //
	  //       {/* The proctor approvals report is quite different from the others, so we’ll use a separate component */}
	  //       {getURLSegment(this, 2) === 'approvals' &&
	  //         <ProctorApprovals {...this.props} />
	  //       }
	  //
	  //       <Drawer
	  //         content={this.state.drawerContent}
	  //         isOpen={this.state.drawerOpen}
	  //         parent={this}
	  //         examSid={this.state.examSid}
	  //         sessionSid={this.state.sessionSid}
	  //         courseSid={this.state.courseSid}
	  //         {...this.props}
	  //       />
	  //     </main>
	  //   )
	  // }
	
	
	  _createClass(Reports, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ReportStore = this.props.store.ReportStore;
	
	      //API call to grab exams ranging from today to 30 days in the future
	
	      if ((0, _helpers.getURLSegment)(this, 2) === 'exams-by-week') {
	        ReportStore.examsByWeekStart = (0, _moment2.default)().format('YYYY-MM-DD');
	        ReportStore.examsByWeekEnd = (0, _moment2.default)().add(30, 'd').format('YYYY-MM-DD');
	        ReportStore.getExamsByWeekReport();
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          AdminStore = _props$store.AdminStore,
	          ReportStore = _props$store.ReportStore;
	
	      var _this = this;
	
	      // Get settings and course offering data
	      if (!AdminStore.institutionSettings.applicationSid) {
	        AdminStore.getDefaultCourseOffering();
	        AdminStore.getCourseOfferings();
	      }
	
	      // Reset report filters and state
	      ReportStore.reportFilters = {};
	
	      this.state = {
	        drawerContent: null,
	        drawerOpen: false,
	        examSid: null,
	        sessionSid: null,
	        courseSid: null,
	        startDate: null,
	        endDate: null
	
	        // Get report data or reset if on landing page
	      };if ((0, _helpers.getURLSegment)(this, 2)) {
	        // Wait until settings have been loaded
	        var settingsDelay = setInterval(function () {
	          if (AdminStore.institutionSettings.applicationSid) {
	            clearInterval(settingsDelay);
	            ReportStore.getReportData((0, _helpers.getURLSegment)(_this, 2));
	          }
	        }, 100);
	      } else if ((0, _helpers.getURLSegment)(this, 1) === 'instructor-appointments') {
	        // Wait until settings have been loaded
	        var _settingsDelay = setInterval(function () {
	          if (AdminStore.institutionSettings.applicationSid) {
	            clearInterval(_settingsDelay);
	            ReportStore.getReportData('instructor-appointments');
	          }
	        }, 100);
	      } else {
	        ReportStore.reportData = [];
	      }
	    }
	  }, {
	    key: 'getReportData',
	    value: function getReportData(e) {
	      var ReportStore = this.props.store.ReportStore;
	      var _state = this.state,
	          startDate = _state.startDate,
	          endDate = _state.endDate;
	
	      var formattedStartDate = startDate.format("YYYY-MM-DD");
	      var formattedEndDate = endDate.format("YYYY-MM-DD");
	
	      e.preventDefault();
	      ReportStore.getExamsByWeekReport(formattedStartDate, formattedEndDate);
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      var translation = this.props.translation;
	      var ReportStore = this.props.store.ReportStore;
	
	      // Set the default export title
	
	      if ((0, _helpers.getURLSegment)(this, 1) === 'instructor-appointments') {
	        ReportStore.reportExportTitle = translation.reports[(0, _helpers.getURLSegment)(this, 1)].title;
	      } else {
	        ReportStore.reportExportTitle = translation.reports[(0, _helpers.getURLSegment)(this, 2)].title;
	      }
	
	      // Show a dialog to let the user change the title
	      var msg = {
	        heading: translation.csv_prompt.heading,
	        input: translation.csv_prompt.input,
	        button: translation.csv_prompt.button
	      };
	
	      (0, _helpers.promptUser)(msg, this.completeExport, null, ReportStore.reportExportTitle);
	    }
	  }, {
	    key: 'completeExport',
	    value: function completeExport() {
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          ReportStore = _props$store2.ReportStore,
	          SessionStore = _props$store2.SessionStore;
	
	
	      var callback = function callback() {
	        return SessionStore.showToaster(translation.exported, 'success');
	      };
	
	      ReportStore.exportData(callback);
	    }
	  }, {
	    key: 'reportList',
	    value: function reportList() {
	      var userData = this.props.store.SessionStore.userData;
	
	
	      var reports = [{
	        url: 'exam-overview',
	        icon: _react2.default.createElement(icons.iconFiles, null)
	      }, {
	        url: 'exam-detail',
	        icon: _react2.default.createElement(icons.icon_text, null)
	      }, {
	        url: 'exam-volume',
	        icon: _react2.default.createElement(icons.iconScale, null)
	      }, {
	        url: 'course',
	        icon: _react2.default.createElement(icons.iconCap, null)
	      }, {
	        url: 'appointments',
	        icon: _react2.default.createElement(icons.iconCalendar, null)
	      }, {
	        url: 'automated-proctoring',
	        icon: _react2.default.createElement(icons.iconUnattended, null)
	      }, {
	        url: 'unscheduled-learners',
	        icon: _react2.default.createElement(icons.iconCalendarTimes, null)
	      }, {
	        url: 'exams-by-week',
	        icon: _react2.default.createElement(icons.iconInbox, null)
	      }, {
	        url: 'approvals',
	        icon: _react2.default.createElement(icons.iconUsers, null)
	      }, {
	        url: 'session-requests',
	        icon: _react2.default.createElement(icons.iconEnvelope, null)
	      }, {
	        url: 'incidents',
	        icon: _react2.default.createElement(icons.iconExclamation, null)
	      }, {
	        url: 'churn',
	        icon: _react2.default.createElement(icons.iconRandom, null)
	      }, {
	        url: 'written-audit',
	        icon: _react2.default.createElement(icons.iconPencil, null)
	      }, {
	        url: 'modality',
	        icon: _react2.default.createElement(icons.iconBarChart, null)
	      }, {
	        url: 'peak-exam',
	        icon: _react2.default.createElement(icons.iconClock, null)
	      }];
	
	      if (userData && userData.role && userData.role.toLowerCase() === 'instructor') {
	        reports = [{
	          url: 'modality',
	          icon: _react2.default.createElement(icons.iconPencil, null)
	        }];
	      }
	
	      return reports;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var ReportStore = this.props.store.ReportStore;
	      var graphs = ReportStore.graphs,
	          reportData = ReportStore.reportData,
	          reportTotal = ReportStore.reportTotal;
	
	      var reportList = this.reportList();
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            (0, _helpers.getURLSegment)(this, 1) !== 'instructor-appointments' && _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title,
	              (0, _helpers.getURLSegment)(this, 2) && ': ' + translation.reports[(0, _helpers.getURLSegment)(this, 2)].title
	            ),
	            (0, _helpers.getURLSegment)(this, 1) === 'instructor-appointments' && _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.reports.instructor_appointments
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page__actions actions' },
	              reportData && reportData.length > 0 && (0, _helpers.getURLSegment)(this, 1) !== 'instructor-appointments' && _react2.default.createElement(
	                'button',
	                { className: 'btn--outline', onClick: this.exportReport },
	                _react2.default.createElement(icons.iconDownload, null),
	                translation.csv_button
	              ),
	              ((0, _helpers.getURLSegment)(this, 2) || (0, _helpers.getURLSegment)(this, 1) === 'instructor-appointments') && (0, _helpers.getURLSegment)(this, 2) && (0, _helpers.getURLSegment)(this, 2) !== 'modality' && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick() {
	                    _this3.setState({
	                      filter: true
	                    }, function () {
	                      (0, _helpers.toggleDrawer)(null, this, 'ReportFilter');
	                    });
	                  }
	                },
	                _react2.default.createElement(icons.iconSettings, null),
	                translation.filter_button
	              ),
	              !(0, _helpers.getURLSegment)(this, 2) && (0, _helpers.getURLSegment)(this, 1) !== 'instructor-appointments' && _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'btn--outline', to: '/reports/downloads' },
	                translation.downloads
	              )
	            )
	          )
	        ),
	        (0, _helpers.getURLSegment)(this, 2) === 'exams-by-week' && _react2.default.createElement(
	          'form',
	          { className: 'filter', onSubmit: this.getReportData },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'filter__filters' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--inline' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'startDate', className: 'form-inline' },
	                    translation.start_date
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(_reactDatepicker2.default, {
	                    selected: this.state.startDate,
	                    onChange: function onChange(date) {
	                      _this3.setState({ startDate: date });
	                      ReportStore.examsByWeekStart = date.format('YYYY-MM-DD');
	                    },
	                    name: 'startDate',
	                    id: 'startDate',
	                    dateFormat: 'YYYY-MM-DD',
	                    autoComplete: 'off'
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'endDate', className: 'form-inline' },
	                    translation.end_date
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(_reactDatepicker2.default, {
	                    selected: this.state.endDate,
	                    minDate: this.state.startDate,
	                    onChange: function onChange(date) {
	                      _this3.setState({ endDate: date });
	                      ReportStore.examsByWeekEnd = date.format('YYYY-MM-DD');
	                    },
	                    name: 'endDate',
	                    id: 'endDate',
	                    dateFormat: 'YYYY-MM-DD',
	                    autoComplete: 'off'
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'actions' },
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary' },
	                translation.get_report
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          !(0, _helpers.getURLSegment)(this, 2) && (0, _helpers.getURLSegment)(this, 1) !== 'instructor-appointments' && _react2.default.createElement(
	            'ul',
	            { className: 'block-list block-list--grid' },
	            reportList.map(function (report, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    className: 'block-list__block block-list__link',
	                    to: (0, _helpers.getURLSegment)(_this3, 1) + '/' + report.url
	                  },
	                  report.icon,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'block-list__title' },
	                    translation.reports[report.url].title
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'block__copy' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      translation.reports[report.url].description
	                    )
	                  )
	                )
	              );
	            })
	          ),
	          (0, _helpers.getURLSegment)(this, 2) && (0, _helpers.getURLSegment)(this, 2) !== 'modality' && (0, _helpers.getURLSegment)(this, 2) !== 'peak-exam' && _react2.default.createElement(
	            'span',
	            { className: 'page__subheading' },
	            translation.total,
	            ': ',
	            reportTotal
	          ),
	          ((0, _helpers.getURLSegment)(this, 2) || (0, _helpers.getURLSegment)(this, 1) === 'instructor-appointments') && reportData && (0, _helpers.getURLSegment)(this, 2) !== 'exams-by-week' && (0, _helpers.getURLSegment)(this, 2) !== 'approvals' && (0, _helpers.getURLSegment)(this, 2) !== 'modality' && (0, _helpers.getURLSegment)(this, 2) !== 'peak-exam' && _react2.default.createElement(_Report2.default, Object.assign({ reportData: reportData, parent: this }, this.props)),
	          (0, _helpers.getURLSegment)(this, 2) && reportData && (0, _helpers.getURLSegment)(this, 2) === 'approvals' && _react2.default.createElement(_ProctorApprovals2.default, Object.assign({ reportData: reportData, parent: this }, this.props)),
	          (0, _helpers.getURLSegment)(this, 2) && reportData && (0, _helpers.getURLSegment)(this, 2) === 'exams-by-week' && reportData.map(function (week, i) {
	            return _react2.default.createElement(_Report2.default, Object.assign({
	              key: i,
	              reportData: week.exams,
	              parent: _this3,
	              disableScroll: true,
	              caption: week.start + '\u2013' + week.end
	            }, _this3.props));
	          })
	        ),
	        (0, _helpers.getURLSegment)(this, 2) && (0, _helpers.getURLSegment)(this, 2) === 'modality' && graphs.length > 0 && graphs.map(function (graph, i) {
	          return _react2.default.createElement(_Graph2.default, Object.assign({}, _this3.props, { key: i, data: graph.data }));
	        }),
	        (0, _helpers.getURLSegment)(this, 2) && (0, _helpers.getURLSegment)(this, 2) === 'peak-exam' && graphs.length > 0 && graphs.map(function (graph, i) {
	          if (graph.data && graph.data.length) {
	            return _react2.default.createElement(_Graph2.default, Object.assign({}, _this3.props, {
	              key: i,
	              data: graph.data,
	              title: translation.graph_titles[graph.title],
	              hideFilterBar: true
	            }));
	          } else if (i === 0) {
	            return _react2.default.createElement(
	              'span',
	              { className: 'no-results', key: i },
	              translation.no_results
	            );
	          }
	
	          return null;
	        }),
	        ((0, _helpers.getURLSegment)(this, 2) !== 'approvals' || this.state.filter) && _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          examSid: this.state.examSid,
	          sessionSid: this.state.sessionSid,
	          courseSid: this.state.courseSid
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Reports;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Reports')(Reports);

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FauxSelect = __webpack_require__(97);
	
	var _FauxSelect2 = _interopRequireDefault(_FauxSelect);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Roster = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Roster, _React$Component);
	
	  function Roster() {
	    _classCallCheck(this, Roster);
	
	    var _this = _possibleConstructorReturn(this, (Roster.__proto__ || Object.getPrototypeOf(Roster)).call(this));
	
	    _this.handleFilter = _this.handleFilter.bind(_this);
	    _this.selectOption = _this.selectOption.bind(_this);
	    _this.handleAction = _this.handleAction.bind(_this);
	    _this.getCourseRoster = _this.getCourseRoster.bind(_this);
	    return _this;
	  }
	
	  _createClass(Roster, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        query: '?limit=25&roles=learner',
	        enrollmentSid: null,
	        enrollmentName: null,
	        fundingRuleSid: null,
	        location: null,
	        action: null,
	        userSid: null
	      };
	
	      this.getCourseRoster(this.state.query);
	      this.props.store.SessionStore.getCourseData(this.props.courseSid);
	    }
	  }, {
	    key: 'getCourseRoster',
	    value: function getCourseRoster() {
	      this.props.store.EnrollmentStore.getCourseRoster(this.state.query, null, this.props.courseSid);
	    }
	  }, {
	    key: 'handleFilter',
	    value: function handleFilter() {
	      var query = '';
	
	      if (this.filter.value || this.status.value) {
	        query = '?limit=25';
	      }
	
	      if (this.filter.value) {
	        query += '&roles=' + JSON.parse(this.filter.value).role;
	      }
	
	      if (this.status.value) {
	        query += '&state=' + this.status.value;
	      }
	
	      this.setState({
	        query: query
	      }, function () {
	        this.getCourseRoster();
	      });
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(e, props) {
	      var action = e.target.getAttribute('data-action');
	      this.handleAction(e, action, props.enrollmentSid, props.userSid, props.studentName);
	    }
	  }, {
	    key: 'handleAction',
	    value: function handleAction(e, action, enrollmentSid, userSid, studentName) {
	      var drawerContent = action;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore,
	          StudentStore = _props$store.StudentStore;
	
	
	      this.setState({
	        enrollmentSid: enrollmentSid,
	        userSid: userSid
	      });
	
	      // Open a new tab logged in as the student
	      if (drawerContent === 'Impersonate') {
	        var studentWindow = null;
	
	        if (SessionStore.userData.role.toLowerCase() === 'instructor') {
	          studentWindow = window.open('', '_blank');
	        }
	
	        StudentStore.impersonate(enrollmentSid, SettingsStore.integration.accessKey, studentWindow, userSid);
	      }
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var _props$store2 = this.props.store,
	          EnrollmentStore = _props$store2.EnrollmentStore,
	          SessionStore = _props$store2.SessionStore;
	      var translation = this.props.translation;
	
	      // Roster actions
	
	      var actions = [];
	
	      var impersonateAction = {
	        title: translation.actions.impersonate.label,
	        action: 'Impersonate',
	        helper: translation.actions.impersonate.helper
	      };
	
	      actions.push(impersonateAction);
	
	      if (EnrollmentStore.courseRoster.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                translation.student
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-role', className: 'subtitle', scope: 'col' },
	                translation.role
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-email', className: 'subtitle', scope: 'col' },
	                translation.email
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-actions', className: 'subtitle table-action', scope: 'col' },
	                translation.action
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            EnrollmentStore.courseRoster.map(function (key, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-name' },
	                  key.lastName,
	                  ', ',
	                  key.firstName
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-role', className: 'capitalize' },
	                  key.role
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-email' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:' + key.email },
	                    key.email
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-actions', className: 'actions' },
	                  key.role.toLowerCase() === 'learner' && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_FauxSelect2.default, {
	                      'default': translation.action_select,
	                      options: actions,
	                      onClick: _this2.selectOption,
	                      studentName: key.firstName + ' ' + key.lastName,
	                      enrollmentSid: key.enrollmentSid,
	                      userSid: key.userSid,
	                      parent: _this2,
	                      skipText: true
	                    })
	                  )
	                )
	              );
	            })
	          )
	        );
	      } else if (!SessionStore.loading && EnrollmentStore.courseRoster.length === 0) {
	        var role = '';
	
	        if (this.filter.value) {
	          role = JSON.parse(this.filter.value).title;
	        }
	
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          this.status.value && translation.no_results_status.replace('%status%', this.status.value).replace('%role%', role),
	          !this.status.value && translation.no_results.replace('%role%', role)
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          EnrollmentStore = _props$store3.EnrollmentStore,
	          SessionStore = _props$store3.SessionStore;
	
	
	      if (SessionStore.courseData) {
	        var synchronization = SessionStore.courseData.synchronization;
	
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.page_title
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            (synchronization && synchronization.enrollment && !synchronization.enrollment.lastRun && !synchronization.enrollment.nextRun || synchronization && !synchronization.enrollment || !synchronization) && _react2.default.createElement(
	              'p',
	              { className: 'note note--alt note--prominent' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Note:'
	              ),
	              translation.sync_not_active
	            ),
	            synchronization && synchronization.enrollment && synchronization.enrollment.lastRun && synchronization.enrollment.nextRun && _react2.default.createElement(
	              'div',
	              { className: 'box box--right' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'title' },
	                  _moment2.default.utc(synchronization.enrollment.lastRun).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'title' },
	                  _moment2.default.utc(synchronization.enrollment.nextRun).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                )
	              )
	            ),
	            this.renderResults(),
	            _react2.default.createElement(_LoadMore2.default, Object.assign({
	              url: EnrollmentStore.rosterNext,
	              group: EnrollmentStore.courseRoster,
	              text: 'Load more enrollments',
	              store: EnrollmentStore
	            }, this.props))
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Roster;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Roster')(Roster);

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _SmarterFauxSelect = __webpack_require__(754);
	
	var _SmarterFauxSelect2 = _interopRequireDefault(_SmarterFauxSelect);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var Roster = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Roster, _React$Component);
	
	  function Roster() {
	    _classCallCheck(this, Roster);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (Roster.__proto__ || Object.getPrototypeOf(Roster)).call(this));
	
	    _this.syncEnrollments = _this.syncEnrollments.bind(_this);
	    _this.handleFilter = _this.handleFilter.bind(_this);
	    _this.selectOption = _this.selectOption.bind(_this);
	    _this.handleAction = _this.handleAction.bind(_this);
	    _this.getCourseRoster = _this.getCourseRoster.bind(_this);
	    _this.resetFilters = _this.resetFilters.bind(_this);
	    return _this;
	  }
	
	  _createClass(Roster, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        query: '?limit=50&sortKeys=lastName&roles=learner&state=active',
	        enrollmentSid: null,
	        enrollmentName: null,
	        fundingRuleSid: null,
	        location: null,
	        action: null,
	        userSid: null
	      };
	
	      if (!this.props.installation) {
	        // Get course enrollments
	        this.getCourseRoster(this.state.query);
	
	        // Also get course data so we can check enrollment sync
	        this.props.store.SessionStore.getCourseData();
	      } else {
	        // Get installation users
	        this.props.store.EnrollmentStore.getUsers();
	      }
	    }
	  }, {
	    key: 'getCourseRoster',
	    value: function getCourseRoster(backgroundLoad) {
	      var EnrollmentStore = this.props.store.EnrollmentStore;
	
	
	      if (this.state.query) {
	        EnrollmentStore.getCourseRoster(this.state.query);
	      } else {
	        EnrollmentStore.getCourseRoster();
	      }
	    }
	  }, {
	    key: 'syncEnrollments',
	    value: function syncEnrollments() {
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          SyncStore = _props$store.SyncStore;
	
	
	      var data = {
	        type: 'enrollments',
	        sid: SessionStore.userData.courseSid
	      };
	
	      var callback = function callback() {
	        SessionStore.getCourseData(null, true);
	        SessionStore.showToaster(translation.sync_scheduled, 'success');
	      };
	
	      SyncStore.scheduleSync(data, callback);
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      var EnrollmentStore = this.props.store.EnrollmentStore;
	
	
	      EnrollmentStore.filterParams.fname = '';
	      EnrollmentStore.filterParams.lname = '';
	
	      this.status.value = '';
	      this.filter.value = '';
	      var query = "?limit=50&sortKeys=lastName";
	
	      this.setState({
	        query: query
	      }, function () {
	        this.getCourseRoster();
	      });
	    }
	  }, {
	    key: 'handleFilter',
	    value: function handleFilter(e) {
	      var EnrollmentStore = this.props.store.EnrollmentStore;
	
	
	      e.preventDefault();
	      var query = '';
	
	      var fname = EnrollmentStore.filterParams.fname;
	      var lname = EnrollmentStore.filterParams.lname;
	
	      if (this.filter.value || this.status.value) {
	        query = '?limit=50&sortKeys=lastName';
	      }
	
	      if (fname) {
	        query += '&firstName=' + fname;
	      }
	
	      if (lname) {
	        query += '&lastName=' + lname;
	      }
	
	      if (this.filter.value) {
	        query += '&roles=' + JSON.parse(this.filter.value).role;
	      }
	
	      if (this.status.value) {
	        query += '&state=' + this.status.value;
	      }
	
	      this.setState({
	        query: query
	      }, function () {
	        this.getCourseRoster();
	      });
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(e, props) {
	      var action = e.target.getAttribute('data-action');
	      this.handleAction(e, action, props.enrollmentSid, props.userSid, props.studentName);
	    }
	  }, {
	    key: 'handleAction',
	    value: function handleAction(e, action, enrollmentSid, userSid, studentName) {
	      var _this2 = this;
	
	      var drawerContent = action;
	      var _props$store2 = this.props.store,
	          SessionStore = _props$store2.SessionStore,
	          SettingsStore = _props$store2.SettingsStore,
	          StudentStore = _props$store2.StudentStore;
	      var pathname = this.props.routing.location.pathname;
	
	
	      this.setState({
	        enrollmentSid: enrollmentSid,
	        userSid: userSid
	      });
	
	      if (drawerContent && drawerContent !== 'LocateProctor' && drawerContent !== 'Impersonate') {
	        (0, _helpers.toggleDrawer)(e, this, drawerContent);
	      }
	
	      if (drawerContent === 'FundingRules') {
	        this.setState({
	          enrollmentName: studentName
	        });
	        pathname += '?fundingRuleScope=enrollmentSid&scopeSid=' + enrollmentSid;
	        this.props.routing.push(pathname);
	      }
	
	      if (drawerContent === 'LocateProctor') {
	        // Get the student’s location
	        SessionStore.getProfile(userSid, true, this, function (e) {
	          (0, _helpers.toggleDrawer)(e, _this2, drawerContent);
	        });
	      }
	
	      // Open a new tab logged in as the student
	      if (drawerContent === 'Impersonate') {
	        var studentWindow = null;
	
	        if (SessionStore.userData.role.toLowerCase() === 'instructor') {
	          studentWindow = window.open('', '_blank');
	        }
	
	        StudentStore.impersonate(enrollmentSid, SettingsStore.integration.accessKey, studentWindow, userSid);
	      }
	    }
	  }, {
	    key: 'deletionText',
	    value: function deletionText(student) {
	      var translation = this.props.translation;
	
	
	      var attempts = 0;
	      var remaining = 4;
	      var syncLabel = 'syncs';
	      var remainingLabel = 'attempts';
	
	      if (student.synchronization) {
	        if (student.synchronization.failure1) {
	          attempts += 1;
	        }
	
	        if (student.synchronization.failure2) {
	          attempts += 1;
	        }
	
	        if (student.synchronization.failure3) {
	          attempts += 1;
	        }
	
	        if (student.synchronization.failure4) {
	          attempts += 1;
	        }
	      }
	
	      remaining -= attempts;
	
	      if (attempts === 1) {
	        syncLabel = 'sync';
	      }
	
	      if (remaining === 1) {
	        remainingLabel = 'attempt';
	      }
	
	      return translation.pending_deletion.helper.replace('%attempts%', attempts).replace('%sync_label%', translation.pending_deletion[syncLabel]).replace('%remaining%', remaining).replace('%attempt_label%', translation.pending_deletion[remainingLabel]);
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var _props$store3 = this.props.store,
	          EnrollmentStore = _props$store3.EnrollmentStore,
	          SessionStore = _props$store3.SessionStore;
	      var translation = this.props.translation;
	
	      // Roster actions
	
	      var actions = [{
	        title: translation.actions.search_proctors.label,
	        action: 'LocateProctor',
	        helper: translation.actions.search_proctors.helper
	      }, {
	        title: translation.actions.message_student.label,
	        action: 'MessageThread',
	        iamAction: 'sp:DescribeMessageThreads',
	        iamResource: ['ssrn:ss:sp:us-east:' + SessionStore.userData.installSid + ':message']
	      }];
	
	      var impersonateAction = {
	        title: translation.actions.impersonate.label,
	        action: 'Impersonate',
	        helper: translation.actions.impersonate.helper
	      };
	
	      actions.push(impersonateAction);
	
	      if (SessionStore.userData.role.toLowerCase() === 'administrator') {
	        var fundingRules = {
	          title: translation.actions.funding_rule.label,
	          action: 'FundingRules',
	          helper: translation.actions.funding_rule.helper
	        };
	
	        actions.push(fundingRules);
	      }
	
	      if (EnrollmentStore.courseRoster.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                translation.student
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-role', className: 'subtitle', scope: 'col' },
	                translation.role
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-email', className: 'subtitle', scope: 'col' },
	                translation.email
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-actions', className: 'subtitle table-action', scope: 'col' },
	                translation.action
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            EnrollmentStore.courseRoster.map(function (key, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-name' },
	                  key.lastName,
	                  ', ',
	                  key.firstName,
	                  key.synchronization && key.synchronization.failure1 && _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip' },
	                    _react2.default.createElement(
	                      'span',
	                      {
	                        className: 'pill pill--negative tooltip__label',
	                        'aria-describedby': 'password-tooltip'
	                      },
	                      translation.pending_deletion.label
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        id: 'password-tooltip',
	                        className: 'tooltip__body',
	                        role: 'tooltip'
	                      },
	                      _this3.deletionText(key)
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-role', className: 'capitalize' },
	                  key.role
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-email' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:' + key.email },
	                    key.email
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-actions', className: 'actions' },
	                  key.role.toLowerCase() === 'learner' && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_SmarterFauxSelect2.default, {
	                      'default': translation.action_select,
	                      options: actions,
	                      onClick: _this3.selectOption,
	                      studentName: key.firstName + ' ' + key.lastName,
	                      enrollmentSid: key.enrollmentSid,
	                      userSid: key.userSid,
	                      parent: _this3,
	                      skipText: true,
	                      selectIndex: i
	                    })
	                  )
	                )
	              );
	            })
	          )
	        );
	      } else if (!SessionStore.loading && EnrollmentStore.courseRoster.length === 0) {
	        var role = '';
	
	        if (this.filter.value) {
	          role = JSON.parse(this.filter.value).title;
	        }
	
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          this.status.value && translation.no_results_status.replace('%status%', this.status.value).replace('%role%', role),
	          !this.status.value && translation.no_results.replace('%role%', role)
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var _props$store4 = this.props.store,
	          EnrollmentStore = _props$store4.EnrollmentStore,
	          SessionStore = _props$store4.SessionStore;
	
	
	      if (SessionStore.courseData) {
	        var synchronization = SessionStore.courseData.synchronization;
	
	
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'page__title' },
	                translation.page_title
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { className: 'filter', onSubmit: function onSubmit(e) {
	                _this4.handleFilter(e);
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields fields--inline' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'legend',
	                      null,
	                      translation.filters.label,
	                      ':'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'meta', htmlFor: 'filter-fname' },
	                      translation.fname
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'filter-fname',
	                      placeholder: translation.fname,
	                      onChange: function onChange(e) {
	                        EnrollmentStore.filterParams.fname = e.target.value;
	                      },
	                      value: EnrollmentStore.filterParams.fname
	
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'meta', htmlFor: 'filter-lname' },
	                      translation.lname
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      id: 'filter-lname',
	                      placeholder: translation.lname,
	                      onChange: function onChange(e) {
	                        EnrollmentStore.filterParams.lname = e.target.value;
	                      },
	                      value: EnrollmentStore.filterParams.lname
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          ref: function ref(input) {
	                            _this4.filter = input;
	                          },
	                          defaultValue: '{"role": "learner", "title": "learners"}'
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          translation.filters.role.all
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '{"role": "learner", "title": "learners"}' },
	                          translation.filters.role.learners
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '{"role": "instructor", "title": "instructors"}' },
	                          translation.filters.role.instructors
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '{"role": "administrator", "title": "administrators"}' },
	                          translation.filters.role.administrators
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '{"role": "teachingAssistant", "title": "teaching assistants"}' },
	                          translation.filters.role.teaching_assistants
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          ref: function ref(input) {
	                            _this4.status = input;
	                          }
	                          //onChange={this.handleFilter}
	                        },
	                        Object.keys(translation.filters.status).map(function (key) {
	                          return _react2.default.createElement(
	                            'option',
	                            { value: key, key: key },
	                            translation.filters.status[key]
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actions' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn',
	                    type: 'submit'
	                  },
	                  translation.filter_button
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn--outline',
	                    type: 'reset',
	                    onClick: this.resetFilters
	                  },
	                  translation.reset
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            (synchronization && synchronization.enrollment && !synchronization.enrollment.lastRun && !synchronization.enrollment.nextRun || synchronization && !synchronization.enrollment || !synchronization) && _react2.default.createElement(
	              'p',
	              { className: 'note note--alt note--prominent' },
	              translation.sync_not_active
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page__data' },
	              EnrollmentStore.rosterTotal >= 0 && _react2.default.createElement(
	                'span',
	                { className: 'page__subheading' },
	                translation.total,
	                ': ',
	                EnrollmentStore.rosterTotal
	              ),
	              synchronization && synchronization.enrollment && synchronization.enrollment.lastRun && synchronization.enrollment.nextRun && _react2.default.createElement(
	                'div',
	                { className: 'box box--right' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'title' },
	                    translation.last_sync,
	                    ': ',
	                    _moment2.default.utc(synchronization.enrollment.lastRun).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'title' },
	                    translation.next_sync,
	                    ': ',
	                    _moment2.default.utc(synchronization.enrollment.nextRun).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn--link',
	                      onClick: this.syncEnrollments
	                    },
	                    translation.sync_now
	                  )
	                )
	              )
	            ),
	            this.renderResults(),
	            _react2.default.createElement(_LoadMore2.default, Object.assign({
	              url: EnrollmentStore.rosterNext,
	              group: EnrollmentStore.courseRoster,
	              text: 'Load more enrollments',
	              store: EnrollmentStore
	            }, this.props))
	          ),
	          _react2.default.createElement(_Drawer2.default, Object.assign({
	            content: this.state.drawerContent,
	            isOpen: this.state.drawerOpen,
	            parent: this,
	            single: true,
	            enrollmentSid: this.state.enrollmentSid,
	            location: this.state.location,
	            fundingRuleSid: this.state.fundingRuleSid,
	            enrollmentName: this.state.enrollmentName,
	            preserveDrawer: true,
	            searchForStudent: true,
	            toUserSid: this.state.userSid,
	            contextType: 'courseSid',
	            contextId: SessionStore.courseData.sid
	          }, this.props))
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Roster;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Roster')(Roster);

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _UsersList = __webpack_require__(829);
	
	var _UsersList2 = _interopRequireDefault(_UsersList);
	
	var _LoadMore = __webpack_require__(49);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Components
	
	
	var Users = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Users, _React$Component);
	
	  function Users() {
	    _classCallCheck(this, Users);
	
	    var _this = _possibleConstructorReturn(this, (Users.__proto__ || Object.getPrototypeOf(Users)).call(this));
	
	    _this.applyFilters = _this.applyFilters.bind(_this);
	    _this.resetFilters = _this.resetFilters.bind(_this);
	    return _this;
	  }
	
	  _createClass(Users, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        showEnrollments: [],
	        enrollmentSid: null,
	        enrollmentName: null,
	        userSid: null,
	        configuration: null,
	        configurationSid: null,
	        fundingRuleSid: null
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if ((0, _helpers.getURLSegment)(this, 2) === 'view') {
	        (0, _helpers.toggleDrawer)(null, this, 'UserDetails');
	      }
	    }
	  }, {
	    key: 'applyFilters',
	    value: function applyFilters(e) {
	      e.preventDefault();
	
	      var filters = {};
	
	      var fname = this.fname.value;
	      var lname = this.lname.value;
	      var email = this.email.value;
	
	      if (fname) {
	        filters.firstName = '*' + fname + '*';
	      }
	
	      if (lname) {
	        filters.lastName = '*' + lname + '*';
	      }
	
	      if (email) {
	        filters.email = email;
	      }
	
	      if (fname || lname || email) {
	        this.props.store.EnrollmentStore.getUsers(filters);
	      } else {
	        this.resetFilters();
	      }
	    }
	  }, {
	    key: 'resetFilters',
	    value: function resetFilters() {
	      this.fname.value = '';
	      this.lname.value = '';
	      this.email.value = '';
	
	      this.props.store.EnrollmentStore.getUsers();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store$Enrollme = this.props.store.EnrollmentStore,
	          installUsers = _props$store$Enrollme.installUsers,
	          usersNext = _props$store$Enrollme.usersNext;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'filter', onSubmit: function onSubmit(e) {
	              _this2.applyFilters(e);
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'filter__filters' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--inline' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.filter_heading,
	                    ':'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-fname' },
	                    translation.fname
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'filter-fname',
	                    placeholder: translation.fname,
	                    ref: function ref(input) {
	                      _this2.fname = input;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-lname' },
	                    translation.lname
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'filter-lname',
	                    placeholder: translation.lname,
	                    ref: function ref(input) {
	                      _this2.lname = input;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'filter-email' },
	                    translation.email
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'filter-email',
	                    placeholder: translation.email,
	                    ref: function ref(input) {
	                      _this2.email = input;
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'actions' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  type: 'submit'
	                },
	                translation.filter
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--outline',
	                  type: 'reset',
	                  onClick: this.resetFilters
	                },
	                translation.reset
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(_UsersList2.default, Object.assign({ parent: this }, this.props)),
	          usersNext && _react2.default.createElement(_LoadMore2.default, Object.assign({
	            url: usersNext,
	            group: installUsers,
	            text: 'Load more users'
	          }, this.props))
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          userSid: this.state.userSid,
	          enrollmentSid: this.state.enrollmentSid,
	          enrollmentName: this.state.enrollmentName,
	          configuration: this.state.configuration,
	          configurationSid: this.state.configurationSid,
	          fundingRuleSid: this.state.fundingRuleSid,
	          preserveDrawer: true,
	          approveForStudent: true
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Users;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Users')(Users);

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _FauxSelect = __webpack_require__(97);
	
	var _FauxSelect2 = _interopRequireDefault(_FauxSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Components
	
	
	var UsersList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(UsersList, _React$Component);
	
	  function UsersList() {
	    _classCallCheck(this, UsersList);
	
	    var _this = _possibleConstructorReturn(this, (UsersList.__proto__ || Object.getPrototypeOf(UsersList)).call(this));
	
	    _this.toggleEnrollments = _this.toggleEnrollments.bind(_this);
	    _this.selectOption = _this.selectOption.bind(_this);
	    _this.deleteConfiguration = _this.deleteConfiguration.bind(_this);
	    return _this;
	  }
	
	  _createClass(UsersList, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        showEnrollments: [],
	        enrollmentSid: null,
	        enrollmentName: null,
	        userSid: null,
	        configuration: null,
	        configurationSid: null,
	        fundingRuleSid: null
	      };
	
	      if ((0, _helpers.getURLSegment)(this, 2) !== 'view') {
	        this.props.store.EnrollmentStore.getUsers();
	      }
	    }
	  }, {
	    key: 'toggleEnrollments',
	    value: function toggleEnrollments(userSid) {
	      var _this2 = this;
	
	      var visibleEnrollments = [].concat(_toConsumableArray(this.state.showEnrollments));
	      var thisIndex = visibleEnrollments.indexOf(userSid);
	
	      if (thisIndex > -1) {
	        // Enrollments are already showing for this user, so hide them
	        visibleEnrollments.splice(thisIndex, 1);
	
	        // Update the state
	        this.updateEnrollments(visibleEnrollments);
	      } else {
	        // Enrollments are not showing yet, so show them
	        visibleEnrollments.push(userSid);
	
	        // Get the enrollments and then update the state
	        this.props.store.EnrollmentStore.getUserEnrollments(userSid, function () {
	          return _this2.updateEnrollments(visibleEnrollments);
	        });
	      }
	    }
	  }, {
	    key: 'updateEnrollments',
	    value: function updateEnrollments(visibleEnrollments) {
	      this.setState({
	        showEnrollments: visibleEnrollments
	      });
	    }
	  }, {
	    key: 'userActions',
	    value: function userActions() {
	      var translation = this.props.translation;
	
	
	      var actions = [{
	        title: translation.actions.funding_rules.label,
	        action: 'UserFundingRules'
	      }];
	
	      return actions;
	    }
	  }, {
	    key: 'enrollmentActions',
	    value: function enrollmentActions(enrollment) {
	      var translation = this.props.translation;
	
	      // Enrollment actions
	
	      var actions = [{
	        title: translation.actions.proctor_approvals.label,
	        action: 'LocateProctor'
	      }, {
	        title: translation.actions.funding_rules.label,
	        action: 'FundingRules'
	      }, {
	        title: translation.actions.impersonate.label,
	        action: 'Impersonate',
	        helper: translation.actions.impersonate.helper
	      }];
	
	      var configActions = [];
	
	      if (enrollment.examConfiguration.sid) {
	        // If the enrollment has an exam configuration
	        configActions = [{
	          title: translation.actions.manage_exam_configuration.label,
	          action: 'EditEnrollmentException'
	        }, {
	          title: translation.actions.delete_exam_configuration.label,
	          action: 'DeleteExamConfiguration'
	        }];
	      } else {
	        // If the enrollment does not have an exam configuration
	        configActions = [{
	          title: translation.actions.add_exam_configuration.label,
	          action: 'EnrollmentException'
	        }];
	      }
	
	      actions = actions.concat(configActions);
	
	      if (enrollment.role.toLowerCase() === 'instructor') {
	        actions = [{
	          title: translation.actions.impersonate.label,
	          action: 'Impersonate',
	          helper: translation.actions.impersonate.helper
	        }];
	      }
	
	      return actions;
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(e, props) {
	      var action = e.target.getAttribute('data-action');
	      var _props$store = this.props.store,
	          SettingsStore = _props$store.SettingsStore,
	          StudentStore = _props$store.StudentStore;
	      var pathname = this.props.routing.location.pathname;
	
	
	      this.props.parent.setState({
	        enrollmentSid: props.enrollmentSid,
	        enrollmentName: props.enrollmentName,
	        userSid: props.userSid,
	        configurationSid: props.configurationSid,
	        configuration: props.configuration
	      });
	
	      if (action === 'DeleteExamConfiguration') {
	        this.deleteConfiguration(props.userSid, props.enrollmentSid, props.configurationSid);
	      } else if (action !== 'UserFundingRules' && action !== 'Impersonate') {
	        var drawerContent = action;
	        (0, _helpers.toggleDrawer)(e, this.props.parent, drawerContent);
	      }
	
	      // Set store enrollment configuration if editing a config
	      if (action === 'EditEnrollmentException') {
	        this.props.store.EnrollmentStore.enrollmentConfiguration = props.configuration;
	      }
	
	      // Add fundingRuleScope and scopeSid if managing funding rules
	
	      // Enrollment funding rules
	      if (action === 'FundingRules') {
	        console.log(props.userSid);
	
	        // Funding rules can either have an enrollmentSid or userSid
	        // not both, so remove the userSid from the state because
	        // it gets passed to the funding rule form
	        this.props.parent.setState({
	          userSid: null
	        });
	
	        pathname += '?fundingRuleScope=enrollmentSid&scopeSid=' + props.enrollmentSid;
	        this.props.routing.push(pathname);
	      }
	
	      // User funding rules
	      if (action === 'UserFundingRules') {
	        (0, _helpers.toggleDrawer)(e, this.props.parent, 'FundingRules');
	
	        // Funding rules can either have an enrollmentSid or userSid
	        // not both, so remove the userSid from the state because
	        // it gets passed to the funding rule form
	        this.props.parent.setState({
	          enrollmentSid: null
	        });
	
	        pathname += '?fundingRuleScope=userSid&scopeSid=' + props.userSid;
	        this.props.routing.push(pathname);
	      }
	
	      // Impersonate student
	      if (action === 'Impersonate') {
	        StudentStore.impersonate(props.enrollmentSid, SettingsStore.integration.accessKey, null, props.userSid);
	      }
	    }
	  }, {
	    key: 'deleteConfiguration',
	    value: function deleteConfiguration(userSid, enrollmentSid, configurationSid) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.delete_confirm.heading,
	        body: translation.delete_confirm.body,
	        button: translation.delete_confirm.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return _this3.props.store.EnrollmentStore.deleteEnrollmentConfiguration(userSid, enrollmentSid, configurationSid);
	      });
	    }
	  }, {
	    key: 'renderEnrollments',
	    value: function renderEnrollments(userSid) {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          EnrollmentStore = _props$store2.EnrollmentStore,
	          SessionStore = _props$store2.SessionStore;
	
	      // Wait until user enrollments and configurations are done loading to render
	
	      if (SessionStore.loadingCalls.indexOf('GetUserEnrollments') < 0 && SessionStore.loadingCalls.indexOf('GetEnrollmentConfigurations') < 0) {
	        return _react2.default.createElement(
	          'tr',
	          { className: '\n          row-collapsed\n          ' + (this.state.showEnrollments.indexOf(userSid) > -1 ? 'expanded' : '') + '\n        ' },
	          _react2.default.createElement(
	            'td',
	            { colSpan: '4' },
	            _react2.default.createElement(
	              'table',
	              { id: 'enrollments-' + userSid },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    { id: 'heading-' + userSid + '-course', scope: 'col' },
	                    translation.course
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { id: 'heading-' + userSid + '-role', scope: 'col', tabIndex: '0' },
	                    translation.role
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { id: 'heading-' + userSid + '-actions', scope: 'col' },
	                    translation.action
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                EnrollmentStore.userEnrollments[userSid] && EnrollmentStore.userEnrollments[userSid].map(function (enrollment, j) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: j },
	                    _react2.default.createElement(
	                      'td',
	                      { 'aria-labelledby': 'heading-' + userSid + '-course' },
	                      enrollment.course.title,
	                      ' (',
	                      enrollment.course.code,
	                      ')'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'aria-labelledby': 'heading-' + userSid + '-role' },
	                      enrollment.role
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { 'aria-labelledby': 'heading-' + userSid + '-actions', className: 'actions' },
	                      (enrollment.role.toLowerCase() === 'learner' || enrollment.role.toLowerCase() === 'instructor') && _react2.default.createElement(_FauxSelect2.default, {
	                        'default': translation.action_select,
	                        options: _this4.enrollmentActions(enrollment),
	                        onClick: _this4.selectOption,
	                        userSid: enrollment.user.sid,
	                        enrollmentSid: enrollment.enrollmentSid,
	                        enrollmentName: enrollment.user.firstName + ' ' + enrollment.user.lastName,
	                        configuration: enrollment.examConfiguration,
	                        configurationSid: enrollment.examConfiguration.sid,
	                        parent: _this4,
	                        skipText: true
	                      })
	                    )
	                  );
	                })
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props$store3 = this.props.store,
	          EnrollmentStore = _props$store3.EnrollmentStore,
	          SessionStore = _props$store3.SessionStore;
	      var translation = this.props.translation;
	
	
	      if (EnrollmentStore.installUsers.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                translation.student
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-email', className: 'subtitle', scope: 'col' },
	                translation.email
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-action', className: 'subtitle', scope: 'col' },
	                translation.action
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            EnrollmentStore.installUsers.map(function (key, i) {
	              return [_react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-name' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'cell-wrap' },
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      {
	                        to: '/users/view/' + key.sid,
	                        title: key.lastName + ', ' + key.firstName + ', ' + translation.view_details
	                      },
	                      key.lastName,
	                      ', ',
	                      key.firstName
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn--expand ' + (_this5.state.showEnrollments.indexOf(key.sid) > -1 ? 'expanded' : ''),
	                        title: translation.enrollments,
	                        onClick: function onClick() {
	                          return _this5.toggleEnrollments(key.sid);
	                        }
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.enrollments
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-email' },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'title-link', href: 'mailto:' + key.email },
	                    key.email
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-action', className: 'actions' },
	                  _react2.default.createElement(_FauxSelect2.default, {
	                    'default': translation.action_select,
	                    options: _this5.userActions(),
	                    onClick: _this5.selectOption,
	                    userSid: key.sid,
	                    parent: _this5,
	                    skipText: true
	                  })
	                )
	              ), _this5.renderEnrollments(key.sid)];
	            })
	          )
	        );
	      } else if (!SessionStore.loading && EnrollmentStore.installUsers.length === 0) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return UsersList;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('UsersList')(UsersList);

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _RegisterForm = __webpack_require__(818);
	
	var _RegisterForm2 = _interopRequireDefault(_RegisterForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var AddSelfManagedAccount = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AddSelfManagedAccount, _React$Component);
	
	  function AddSelfManagedAccount() {
	    _classCallCheck(this, AddSelfManagedAccount);
	
	    return _possibleConstructorReturn(this, (AddSelfManagedAccount.__proto__ || Object.getPrototypeOf(AddSelfManagedAccount)).apply(this, arguments));
	  }
	
	  _createClass(AddSelfManagedAccount, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(_RegisterForm2.default, this.props)
	        )
	      );
	    }
	  }]);
	
	  return AddSelfManagedAccount;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AddSelfManagedAccount')(AddSelfManagedAccount);

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var SelfManagedAccounts = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SelfManagedAccounts, _React$Component);
	
	  function SelfManagedAccounts() {
	    _classCallCheck(this, SelfManagedAccounts);
	
	    return _possibleConstructorReturn(this, (SelfManagedAccounts.__proto__ || Object.getPrototypeOf(SelfManagedAccounts)).apply(this, arguments));
	  }
	
	  _createClass(SelfManagedAccounts, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null
	      };
	      this.props.store.ProctorStore.listSelfManagedAccount();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.routing.location.pathname;
	
	
	      if (pathname.indexOf('/add') > -1 || pathname.indexOf('/edit') > -1) {
	        (0, _helpers.toggleDrawer)(null, this, 'AddSelfManagedAccount');
	      }
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ProctorStore = _props$store.ProctorStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      if (ProctorStore.selfManagedAccounts.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-name', className: 'subtitle', scope: 'col' },
	                translation.name
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-org', className: 'subtitle', scope: 'col' },
	                translation.organization
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-email', className: 'subtitle', scope: 'col' },
	                translation.email
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            ProctorStore.selfManagedAccounts.map(function (key, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-name' },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                      to: (0, _helpers.getURLSegment)(_this2, 1) + '/edit/' + key.sid,
	                      title: 'Edit ' + key.lastName + ', ' + key.firstName
	                    },
	                    key.lastName,
	                    ', ',
	                    key.firstName
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-org' },
	                  key.company
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-email' },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'title-link', href: 'mailto:' + key.email },
	                    key.email
	                  )
	                )
	              );
	            })
	          )
	        );
	      } else if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page__actions actions' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: 'self-managed-proctors/add', className: 'btn--outline' },
	                _react2.default.createElement(icons.iconPlus, null),
	                translation.button
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({ content: this.state.drawerContent, isOpen: this.state.drawerOpen, parent: this, single: true, vouchers: this.state.vouchers }, this.props))
	      );
	    }
	  }]);
	
	  return SelfManagedAccounts;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SelfManagedAccounts')(SelfManagedAccounts);

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressBar = function (_React$Component) {
	  _inherits(ProgressBar, _React$Component);
	
	  function ProgressBar(props) {
	    _classCallCheck(this, ProgressBar);
	
	    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props));
	
	    _this.minimumValue = _this.props.minimumValue || 0;
	    _this.maximumValue = _this.props.maximumValue || 100;
	    return _this;
	  }
	
	  _createClass(ProgressBar, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "panel panel--md panel--solo" },
	        _react2.default.createElement("h1", { className: "panel__title" }),
	        _react2.default.createElement(
	          "div",
	          { className: "progress-bar" },
	          _react2.default.createElement("progress", {
	            className: "progress-bar__bar",
	            max: this.maximumValue,
	            min: this.minimumValue,
	            value: this.props.value,
	            "aria-label": "progress-value"
	          }),
	          _react2.default.createElement("output", { className: "progress-bar__value", id: "progress-value" })
	        )
	      );
	    }
	  }]);
	
	  return ProgressBar;
	}(_react2.default.Component);
	
	exports.default = ProgressBar;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _ProgressBar = __webpack_require__(832);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*global chrome*/
	
	// Translations
	
	
	var SessionEndAutomated = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionEndAutomated, _React$Component);
	
	  function SessionEndAutomated() {
	    _classCallCheck(this, SessionEndAutomated);
	
	    var _this = _possibleConstructorReturn(this, (SessionEndAutomated.__proto__ || Object.getPrototypeOf(SessionEndAutomated)).call(this));
	
	    _this.uninstall = function () {
	      var translation = _this.props.translation;
	      var SessionStore = _this.props.store.SessionStore;
	      var extensionInfo = _this.props.store.SessionStore.extensionInfo;
	
	
	      chrome.runtime.sendMessage(extensionInfo.extensionId, { message: 'uninstall' }, function (response) {
	        if (response && response.status) {
	          console.log('Did not uninstall');
	        } else {
	          SessionStore.showDialog(translation.uninstalled);
	        }
	      });
	    };
	
	    _this.renderActions = function () {
	      var translation = _this.props.translation;
	      var session = _this.state.session;
	
	
	      if (!session) return _react2.default.createElement('div', null);
	
	      var _session$user = session.user,
	          email = _session$user.email,
	          firstName = _session$user.firstName,
	          lastName = _session$user.lastName;
	
	      var sessionSid = session.session.sid;
	      var extVersion = session.extVersion;
	      var installSid = session.session.installSid;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'actions' },
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'btn btn--inline',
	            href: 'https://smarterservices.typeform.com/to/uNlipH?email=' + email + '&sessionsid=' + sessionSid + '&firstname=' + firstName + '&lastname=' + lastName + '&extensionversion=' + extVersion + '&installsid=' + installSid
	          },
	          translation.survey
	        )
	      );
	    };
	
	    _this.getUploadPercentage = function () {
	      return (_this.state.totalUploadCount - _this.state.currentUploadCount > 0 ? (_this.state.totalUploadCount - _this.state.currentUploadCount) / _this.state.totalUploadCount * 100 : 0).toFixed(0);
	    };
	
	    _this.isUploading = function () {
	      if (!_this.state.totalUploadCount) return false;
	      return _this.getUploadPercentage() > -1 && _this.getUploadPercentage() < 100;
	    };
	
	    _this.isUploadingFinished = function () {
	      return _this.getUploadPercentage() >= 100;
	    };
	
	    _this.renderEndContent = function () {
	      return _this.state.session ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          _this.props.translation.body
	        ),
	        _this.renderActions()
	      ) : _react2.default.createElement(
	        'p',
	        null,
	        _this.props.translation.body_alt,
	        ' '
	      );
	    };
	
	    _this.state = {
	      extensionId: null,
	      sessionData: null,
	      currentUploadCount: null,
	      totalUploadCount: null
	    };
	
	    var receiveMessage = function receiveMessage(event) {
	      if (!event.data.message) return;
	
	      switch (event.data.message) {
	        case 'eventsStillUploading':
	          _this.setState({
	            totalUploadCount: event.data.totalCount,
	            currentUploadCount: event.data.totalCount,
	            extensionId: event.data.extensionId
	          });
	          break;
	
	        case 'sendQueueCount':
	          _this.setState({
	            currentUploadCount: event.data.queueCount,
	            extensionId: event.data.extensionId,
	            totalUploadCount: _this.state.totalUploadCount ? _this.state.totalUploadCount : event.data.queueCount * 2
	          });
	          if (event.data.queueCount === 0) clearInterval(_this.checkUploadsInterval);
	          break;
	
	        default:
	          break;
	      }
	    };
	
	    window.addEventListener('message', receiveMessage, false);
	
	    _this.checkUploadsInterval = setInterval(function () {
	      if (_this.state.extensionId && _this.state.totalUploadCount) chrome.runtime.sendMessage(_this.state.extensionId, {
	        message: 'getEventsToUploadCount'
	      });
	    }, 250);
	    return _this;
	  }
	
	  _createClass(SessionEndAutomated, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      SessionStore.hideHeader = true;
	      SessionStore.hideFooter = true;
	
	      // Wait for extension info to be retrieved
	      var extensionDelay = setInterval(function () {
	        if (SessionStore.extensionInfo) {
	          clearInterval(extensionDelay);
	          _this2.getSessionData(SessionStore.extensionInfo.extensionId);
	        }
	      }, 100);
	    }
	  }, {
	    key: 'getSessionData',
	    value: function getSessionData(extensionId) {
	      var _this3 = this;
	
	      chrome.runtime.sendMessage(extensionId, { message: 'getSessionStart' }, function (response) {
	        if (response) {
	          _this3.setState({
	            session: response
	          });
	
	          _this3.stopSession(extensionId);
	        }
	      });
	    }
	  }, {
	    key: 'stopSession',
	    value: function stopSession(extensionId) {
	      chrome.runtime.sendMessage(extensionId, { message: 'stopSession' }, function (response) {
	        if (response.status === 'ERROR' || response.errorMessage) {
	          alert(response.errorMessage);
	          return;
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	        this.isUploading() ? _react2.default.createElement(
	          'div',
	          { className: 'panel--medium' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title panel__title--alt' },
	            translation.uploading_heading
	          ),
	          _react2.default.createElement(_ProgressBar2.default, { value: this.getUploadPercentage() }),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.uploading
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'panel--medium' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title panel__title--alt' },
	            translation.heading
	          ),
	          this.renderEndContent()
	        )
	      );
	    }
	  }]);
	
	  return SessionEndAutomated;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionEndAutomated')(SessionEndAutomated);

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var SessionExpired = function (_React$Component) {
	  _inherits(SessionExpired, _React$Component);
	
	  function SessionExpired() {
	    _classCallCheck(this, SessionExpired);
	
	    return _possibleConstructorReturn(this, (SessionExpired.__proto__ || Object.getPrototypeOf(SessionExpired)).apply(this, arguments));
	  }
	
	  _createClass(SessionExpired, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'i',
	            { className: 'page--error__icon' },
	            _react2.default.createElement(icons.iconClock, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.message
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SessionExpired;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('SessionExpired')(SessionExpired);

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mobx = __webpack_require__(13);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Begin = function (_React$Component) {
	  _inherits(Begin, _React$Component);
	
	  function Begin() {
	    _classCallCheck(this, Begin);
	
	    return _possibleConstructorReturn(this, (Begin.__proto__ || Object.getPrototypeOf(Begin)).apply(this, arguments));
	  }
	
	  _createClass(Begin, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props = this.props,
	          button = _props.button,
	          nextStep = _props.nextStep,
	          parent = _props.parent,
	          statusClass = _props.statusClass;
	      var SessionStore = this.props.store.SessionStore;
	
	      var translation = this.props.translation.begin;
	
	      if (statusClass === 'slide-active' && parent.state.next !== nextStep) {
	        parent.setState({
	          next: nextStep
	        });
	
	        // Don't let the user continue if there are background loading calls
	        button.disabled = SessionStore.backgroundLoading;
	
	        if (SessionStore.backgroundLoading) {
	          button.textContent = translation.loading;
	
	          var disposer = (0, _mobx.observe)(SessionStore, 'backgroundLoading', function (change) {
	            if (change.newValue === false) {
	              button.disabled = false;
	              button.textContent = translation.button;
	              disposer();
	            }
	          });
	        } else {
	          button.textContent = translation.button;
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var statusClass = this.props.statusClass;
	
	      var translation = this.props.translation.begin;
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'panel panel--medium ' + statusClass, 'aria-labelledby': 'step1' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title panel__title--alt', id: 'step1' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.body
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'note note--prominent' },
	          translation.note
	        )
	      );
	    }
	  }]);
	
	  return Begin;
	}(_react2.default.Component);
	
	exports.default = Begin;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Config
	
	
	var Consent = function (_React$Component) {
	  _inherits(Consent, _React$Component);
	
	  function Consent() {
	    _classCallCheck(this, Consent);
	
	    // Set the initial state
	    var _this = _possibleConstructorReturn(this, (Consent.__proto__ || Object.getPrototypeOf(Consent)).call(this));
	
	    _this.checked = function () {
	      if (_this.state.multipleAgreements) {
	        return;
	      }
	
	      _this.setState({
	        agreementsChecked: true
	      });
	
	      _this.button.disabled = false;
	
	      _this.enableNext();
	    };
	
	    _this.unchecked = function () {
	      if (_this.state.multipleAgreements) {
	        return;
	      }
	
	      var parent = _this.props.parent;
	
	
	      _this.setState({
	        agreementsChecked: false
	      });
	
	      parent.setState({
	        next: null
	      });
	
	      _this.button.disabled = true;
	    };
	
	    _this.complete = function () {
	      var nextStep = _this.props.nextStep;
	
	
	      if (!_this.noAgreements) {
	        _this.setState({
	          agreementsFetched: false
	        });
	
	        window.Agreements.agrFetched = false;
	
	        document.removeEventListener('agreementsComplete', _this.complete);
	
	        nextStep();
	      }
	    };
	
	    _this.fetched = function () {
	      var parent = _this.props.parent;
	
	
	      if (window.Agreements.agrArr && window.Agreements.agrArr.length === 0) {
	        _this.noAgreements = true;
	
	        parent.setState({
	          unsupported: true,
	          unsupportedDetails: _this.props.translation.unsupported_msg.consent
	        });
	      } else if (window.Agreements.agrArr && window.Agreements.agrArr.length > 1) {
	        _this.setState({
	          multipleAgreements: true
	        });
	      }
	    };
	
	    _this.state = {
	      agreementsFetched: false,
	      agreementsChecked: false
	    };
	
	    // Empty agreements handler
	    _this.noAgreements = false;
	    return _this;
	  }
	
	  _createClass(Consent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Enable the continue button when agreements are checked
	      document.addEventListener('agreementsChecked', this.checked);
	
	      // Disable the continue button when agreements are unchecked
	      document.addEventListener('agreementsUnchecked', this.unchecked);
	
	      // Move on when the agreements have been completed
	      document.addEventListener('agreementsComplete', this.complete);
	
	      // Stop onboarding if there are no agreements to sign
	      document.addEventListener('agreementsFetched', this.fetched);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('agreementsChecked', this.checked);
	      document.removeEventListener('agreementsUnchecked', this.unchecked);
	      document.removeEventListener('agreementsComplete', this.complete);
	      document.removeEventListener('agreementsFetched', this.fetched);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props = this.props,
	          agreements = _props.agreements,
	          button = _props.button,
	          statusClass = _props.statusClass;
	      var SessionStore = this.props.store.SessionStore;
	      var userData = SessionStore.userData;
	
	
	      if (button) {
	        this.button = button;
	      }
	
	      var location = '';
	      var hideButton = true;
	
	      if (agreements && agreements.recordingConsent) {
	        location = agreements.recordingConsent;
	      }
	
	      if (_config.config.dmvInstallSids.indexOf(userData.installSid) > -1) {
	        location = 'dmv-hybrid-check-in';
	        hideButton = false;
	      }
	
	      if (button && statusClass === 'slide-active' && !this.state.agreementsChecked) {
	        button.disabled = true;
	      }
	
	      // Get recording consent agreement
	      if (window.Agreements && !this.state.agreementsFetched && statusClass === 'slide-active') {
	        window.Agreements.agrFetched = false;
	
	        var agrOpts = {
	          mode: 'inline',
	          containerId: 'agreement-container',
	          location: location || 'extension-recording-consent',
	          target: Date.now(),
	          account: userData.deploymentSid || sessionStorage.getItem('installSid'),
	          application: 'AP6800b9e2e1794dbbbf6ad866194821d3',
	          hideButton: hideButton
	        };
	
	        window.Agreements.setup(agrOpts);
	
	        this.setState({
	          agreementsFetched: true
	        });
	      }
	    }
	  }, {
	    key: 'enableNext',
	    value: function enableNext() {
	      var _props2 = this.props,
	          onComplete = _props2.onComplete,
	          parent = _props2.parent;
	
	
	      var next = function next() {
	        if (onComplete) {
	          var mediaDevices = {
	            audio: parent.state.microphone,
	            video: parent.state.webcam
	          };
	
	          onComplete(mediaDevices);
	        }
	
	        window.Agreements.submit();
	      };
	
	      parent.setState({
	        next: next
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var statusClass = this.props.statusClass;
	
	      var translation = this.props.translation.consent;
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'panel panel--medium ' + statusClass, 'aria-labelledby': 'step2' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'meta' },
	          translation.heading
	        ),
	        _react2.default.createElement('div', {
	          className: 'loader--async panel__agreement',
	          id: 'agreement-container'
	        })
	      );
	    }
	  }]);
	
	  return Consent;
	}(_react2.default.Component);
	
	exports.default = Consent;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var minutesAgoToCheck = 5;
	
	var DesktopApp = function (_React$Component) {
	  _inherits(DesktopApp, _React$Component);
	
	  function DesktopApp(props) {
	    _classCallCheck(this, DesktopApp);
	
	    var _this = _possibleConstructorReturn(this, (DesktopApp.__proto__ || Object.getPrototypeOf(DesktopApp)).call(this, props));
	
	    _this.state = {
	      finished: false,
	      retryCount: 1,
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(DesktopApp, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var _props = this.props,
	          button = _props.button,
	          parent = _props.parent,
	          statusClass = _props.statusClass,
	          sessionStartData = _props.sessionStartData,
	          syncDocumentData = _props.syncDocumentData,
	          store = _props.store,
	          sessionSid = _props.sessionSid;
	      var SessionStore = store.SessionStore;
	      var desktopAppConnected = SessionStore.desktopAppConnected,
	          desktopAppRequestLoading = SessionStore.desktopAppRequestLoading;
	
	      var token = SessionStore.token;
	      var installSid = sessionStartData.session.installSid;
	
	      var examSid = sessionStartData.exam.sid;
	
	      if (!token) {
	        token = sessionStorage.getItem('token');
	      }
	
	      if (statusClass === 'slide-active') {
	        // Skip if not enabled
	        if (!sessionStartData.modalityOptions.desktopAppCheck) {
	          parent.nextStep();
	          button.disabled = false;
	          return;
	        }
	        // If we have not connected to the desktop app continue
	        // to retry pining the desktop app until connected
	        if (!desktopAppConnected && !desktopAppRequestLoading) {
	          SessionStore.connectWithDesktopApp(token, sessionSid, installSid, examSid);
	          // Setup the retry interval
	          setTimeout(function () {
	            // Incrementing the retry count will call this method again until
	            // the UI connects to the desktop app directly
	            _this2.setState({ retryCount: _this2.state.retryCount + 1 });
	          }, 5000);
	        }
	        // Check if we are running apps that are not allowed
	        var hasBlockedApps = syncDocumentData && syncDocumentData.blockedApplications && syncDocumentData.blockedApplications.applications && syncDocumentData.blockedApplications.applications.length > 0;
	
	        // Check if we are running on a vm
	        var isRunningOnVm = syncDocumentData && syncDocumentData.vmDetected && syncDocumentData.vmDetected.vm === true;
	
	        var timeAgo = (0, _moment2.default)().subtract(minutesAgoToCheck, 'minutes');
	        // Check if the desktop app wrote to the sync doc at all
	        // If we dont have the time stamps the desktop app didnt do the checks yet
	        var desktopAppChecksReady = syncDocumentData && syncDocumentData.vmDetected && syncDocumentData.vmDetected.timestamp && (0, _moment2.default)(syncDocumentData.vmDetected.timestamp).isAfter(timeAgo) && syncDocumentData.blockedApplications && (0, _moment2.default)(syncDocumentData.blockedApplications.timestamp).isAfter(timeAgo);
	
	        // Disable button if the desktop app is not ready, we are on vm or have blocked apps
	        button.disabled = !desktopAppChecksReady || isRunningOnVm || hasBlockedApps || !desktopAppConnected;
	      }
	    }
	  }, {
	    key: 'renderInstructions',
	    value: function renderInstructions() {
	      var translation = this.props.translation.desktopApp;
	      var opSys = (0, _helpers.getCurrentOS)();
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title panel__title--alt' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.body
	        ),
	        _react2.default.createElement(
	          'ol',
	          { className: 'panel__list' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.steps.one
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                onClick: function onClick() {
	                  var config = (0, _helpers.getDesktopAppConfigForPlatform)();
	                  (0, _helpers.downloadURI)(config.url, config.name);
	                }
	              },
	              translation.buttons.download
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.steps.two
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', {
	                alt: translation.completed_download,
	                className: 'img',
	                src: opSys !== "Mac" ? './static/img/windows_pinned_utility.png' : './static/img/pinned_utility_download.png'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.steps.three[opSys]
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', {
	                alt: translation.installed_app,
	                className: 'img',
	                src: opSys !== "Mac" ? './static/img/windows_utility_installation.jpeg' : "./static/img/utility_preview.png"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.steps.four[opSys]
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.steps.five[opSys]
	            )
	          ),
	          opSys === "Windows" && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.steps.six
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderIsOnVM',
	    value: function renderIsOnVM() {
	      var translation = this.props.translation.desktopApp;
	      return _react2.default.createElement(
	        'div',
	        null,
	        translation.vmIsOn.body
	      );
	    }
	  }, {
	    key: 'renderHasBlockedApps',
	    value: function renderHasBlockedApps() {
	      var _this3 = this;
	
	      var translation = this.props.translation.desktopApp;
	      var _props2 = this.props,
	          syncDocumentData = _props2.syncDocumentData,
	          store = _props2.store;
	      var SessionStore = store.SessionStore;
	      // Check if we are running apps that are not allowed
	
	      var blockedApps = [];
	      var blockedAppsNames = [];
	      if (syncDocumentData && syncDocumentData.blockedApplications && syncDocumentData.blockedApplications.applications) {
	        blockedApps = syncDocumentData.blockedApplications.applications;
	        if (blockedApps.length > 0) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = blockedApps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var blockedApp = _step.value;
	
	              if (blockedAppsNames.indexOf(blockedApp.applicationName) === -1) {
	                blockedAppsNames.push(blockedApp.applicationName);
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      }
	      if (this.state.loading) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          translation.blockedApps.closingMessage
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.blockedApps.body,
	          ' '
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn',
	            style: { width: 300, margin: '10px 0' },
	            onClick: function onClick() {
	              _this3.setState({ loading: true });
	              SessionStore.desktopAppCloseBlockedApps(function () {
	                // Force update and timeout is to make sure we don't blink the blocked apps screen
	                // after the close has taken place
	                _this3.forceUpdate();
	                setTimeout(function () {
	                  return _this3.setState({ loading: false });
	                }, 1000);
	              });
	            } },
	          translation.blockedApps.button
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.blockedApps.listTitle,
	          ' '
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          blockedAppsNames.map(function (applicationName) {
	            return _react2.default.createElement(
	              'li',
	              null,
	              applicationName
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderSuccess',
	    value: function renderSuccess() {
	      var translation = this.props.translation.desktopApp;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.success.body,
	          ' '
	        )
	      );
	    }
	  }, {
	    key: 'renderFragment',
	    value: function renderFragment() {
	      var _props3 = this.props,
	          syncDocumentData = _props3.syncDocumentData,
	          store = _props3.store;
	      var SessionStore = store.SessionStore;
	      var desktopAppConnected = SessionStore.desktopAppConnected;
	      // Check if we are running apps that are not allowed
	
	      var hasBlockedApps = syncDocumentData && syncDocumentData.blockedApplications && syncDocumentData.blockedApplications.applications && syncDocumentData.blockedApplications.applications.length > 0;
	
	      // Check if we are running on a vm
	      var isRunningOnVm = syncDocumentData && syncDocumentData.vmDetected && syncDocumentData.vmDetected.vm === true;
	
	      var timeAgo = (0, _moment2.default)().subtract(minutesAgoToCheck, 'minutes');
	      // Check if the desktop app wrote to the sync doc at all
	      // If we dont have the time stamps the desktop app didnt do the checks yet
	      var desktopAppChecksReady = syncDocumentData && syncDocumentData.vmDetected && syncDocumentData.vmDetected.timestamp && (0, _moment2.default)(syncDocumentData.vmDetected.timestamp).isAfter(timeAgo) && syncDocumentData.blockedApplications && (0, _moment2.default)(syncDocumentData.blockedApplications.timestamp).isAfter(timeAgo) && desktopAppConnected;
	
	      if (!desktopAppChecksReady) {
	        return this.renderInstructions();
	      }
	
	      if (isRunningOnVm) {
	        return this.renderIsOnVM();
	      }
	
	      if (hasBlockedApps) {
	        return this.renderHasBlockedApps();
	      }
	
	      return this.renderSuccess();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var statusClass = this.props.statusClass;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel panel--medium ' + statusClass },
	        this.renderFragment()
	      );
	    }
	  }]);
	
	  return DesktopApp;
	}(_react2.default.Component);
	
	exports.default = DesktopApp;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Example = function (_React$Component) {
	  _inherits(Example, _React$Component);
	
	  function Example() {
	    _classCallCheck(this, Example);
	
	    return _possibleConstructorReturn(this, (Example.__proto__ || Object.getPrototypeOf(Example)).apply(this, arguments));
	  }
	
	  _createClass(Example, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          parent = _props.parent,
	          nextStep = _props.nextStep;
	
	
	      parent.setState({
	        next: nextStep
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props2 = this.props,
	          parent = _props2.parent,
	          nextStep = _props2.nextStep,
	          statusClass = _props2.statusClass;
	
	
	      if (statusClass === 'slide-active' && parent.state.next !== nextStep) {
	        parent.setState({
	          next: nextStep
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var statusClass = this.props.statusClass;
	
	      var translation = this.props.translation.example;
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'panel panel--medium ' + statusClass, 'aria-labelledby': 'step3' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title panel__title--alt', id: 'step3' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.body
	        ),
	        statusClass === 'slide-active' && _react2.default.createElement(
	          'div',
	          { className: 'vid__wrap vid__wrap--wide' },
	          _react2.default.createElement('iframe', {
	            className: 'vid__video',
	            src: 'https://player.vimeo.com/video/404603947?byline=0&portrait=0&autoplay=1',
	            width: '640',
	            height: '455',
	            frameBorder: '0',
	            allow: 'autoplay; fullscreen',
	            allowFullScreen: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return Example;
	}(_react2.default.Component);
	
	exports.default = Example;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(5);
	
	var _Webcam = __webpack_require__(150);
	
	var _Webcam2 = _interopRequireDefault(_Webcam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Components
	
	
	var IDVerification = function (_React$Component) {
	  _inherits(IDVerification, _React$Component);
	
	  function IDVerification() {
	    _classCallCheck(this, IDVerification);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (IDVerification.__proto__ || Object.getPrototypeOf(IDVerification)).call(this));
	
	    _this.acceptPhoto = _this.acceptPhoto.bind(_this);
	    _this.next = _this.next.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      ready: false,
	      headshot: null,
	      idFront: null,
	      mediaChecked: false,
	      getUserMedia: true,
	      photo: 1,
	      verifying: false,
	      finished: false
	    };
	    return _this;
	  }
	
	  _createClass(IDVerification, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props = this.props,
	          button = _props.button,
	          parent = _props.parent,
	          sessionStartData = _props.sessionStartData,
	          statusClass = _props.statusClass;
	
	
	      if (statusClass === 'slide-active') {
	        // Skip if not enabled
	        if (!sessionStartData.modalityOptions.verifyId) {
	          parent.nextStep();
	        }
	
	        if (!button.disabled && !this.state.finished) {
	          // Disable the continue button
	          button.disabled = true;
	
	          parent.setState({
	            next: null
	          });
	        }
	
	        // Check if getUserMedia is supported
	        if (!this.state.mediaChecked) {
	          var getUserMediaSupported = (0, _helpers.testGetUserMedia)();
	
	          if (!getUserMediaSupported) {
	            this.setState({
	              getUserMedia: false
	            });
	          }
	
	          this.setState({
	            mediaChecked: true
	          });
	        }
	
	        // If getUserMedia has been checked and is available, set ready to true
	        if (this.state.mediaChecked && this.state.getUserMedia && !this.state.ready) {
	          this.setState({
	            ready: true
	          });
	        }
	      } else if (this.state.ready) {
	        this.setState({
	          ready: false
	        });
	      }
	    }
	  }, {
	    key: 'acceptPhoto',
	    value: function acceptPhoto(type) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          examSid = _props2.examSid,
	          onAccept = _props2.onAccept,
	          nextStep = _props2.nextStep,
	          sessionSid = _props2.sessionSid,
	          sessionStartData = _props2.sessionStartData,
	          smarterId = _props2.smarterId;
	      var _props$store = this.props.store,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore,
	          SmarterIDStore = _props$store.SmarterIDStore;
	
	      var translation = this.props.translation.id_verification;
	
	      var data = {
	        type: type,
	        photo: this.state[type].src
	      };
	
	      var errorCallback = function errorCallback() {
	        var _this2$setState;
	
	        var photo = 1;
	
	        if (_this2.state.photo !== 1 || smarterId) {
	          photo = 1;
	
	          // Undo verification state to go back to retake headshots
	          _this2.setState({
	            verifying: false
	          });
	
	          // Show an error message
	          SessionStore.showDialog(translation.failed);
	
	          // Initiate retake
	          var btn = document.querySelector('#SessionStartAutomated .webcam__retake');
	
	          if (btn) {
	            btn.click();
	          }
	        }
	
	        _this2.setState((_this2$setState = {}, _defineProperty(_this2$setState, type, null), _defineProperty(_this2$setState, 'finished', false), _defineProperty(_this2$setState, 'photo', photo), _this2$setState));
	      };
	      // Logic for handling the response of uploading the headshots
	      var responseCallback = function responseCallback(boolean) {
	        var button = _this2.props.button;
	
	
	        _this2.setState({
	          finished: boolean
	        });
	        button.disabled = !boolean;
	      };
	
	      if (smarterId) {
	        SmarterIDStore.authenticateUser(sessionStartData.smarterId, data, errorCallback, nextStep);
	      } else {
	        ScheduleStore.uploadSessionPhoto(examSid, sessionSid, data, errorCallback, responseCallback, this.state.photo);
	
	        if (this.state.photo === 2) {
	          this.setState({ verifying: true });
	        }
	      }
	
	      onAccept(type, type === 'headshot' ? this.state[type].src : null);
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.setState({
	        photo: this.state.photo + 1
	      });
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      var _props3 = this.props,
	          parent = _props3.parent,
	          nextStep = _props3.nextStep;
	
	
	      this.setState({
	        finished: false
	      });
	
	      parent.setState({
	        next: nextStep
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          onCapture = _props4.onCapture,
	          smarterId = _props4.smarterId,
	          statusClass = _props4.statusClass;
	
	      var translation = this.props.translation.id_verification;
	
	      if (this.state.getUserMedia) {
	        return _react2.default.createElement(
	          'main',
	          { className: 'panel panel--medium ' + statusClass, 'aria-labelledby': 'step4' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__title panel__title--alt', id: 'step4' },
	            translation.heading
	          ),
	          this.state.ready && this.state.photo === 1 && _react2.default.createElement(_Webcam2.default, Object.assign({}, this.props, {
	            allowCapture: true,
	            onCapture: onCapture,
	            onAccept: function onAccept() {
	              return _this3.acceptPhoto('headshot');
	            },
	            name: 'headshot',
	            camera: 'user',
	            type: 'portrait',
	            parent: this,
	            caption: translation.headshot,
	            disableFullScreen: true,
	            callback: smarterId ? this.complete : this.next,
	            complete: this.state.finished,
	            completeText: translation.verifying,
	            photo: this.state.photo
	          })),
	          this.state.ready && this.state.photo === 2 && _react2.default.createElement(_Webcam2.default, Object.assign({}, this.props, {
	            allowCapture: true,
	            onCapture: onCapture,
	            onAccept: function onAccept() {
	              return _this3.acceptPhoto('idFront');
	            },
	            name: 'idFront',
	            camera: 'user',
	            type: 'landscape',
	            parent: this,
	            caption: translation.id,
	            disableFullScreen: true,
	            callback: this.complete,
	            complete: this.state.finished,
	            completeText: !this.state.finished ? translation.verifying : translation.complete,
	            verifying: this.state.verifying,
	            photo: this.state.photo
	          }))
	        );
	      } else {
	        // Webcam recording not supported by the browser
	        return _react2.default.createElement(
	          'div',
	          { className: 'panel panel--medium ' + statusClass },
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__title panel__title--alt' },
	            translation.unsupported.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.unsupported.body
	          )
	        );
	      }
	    }
	  }]);
	
	  return IDVerification;
	}(_react2.default.Component);
	
	exports.default = IDVerification;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(5);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Components
	
	
	var Intro = function (_React$Component) {
	  _inherits(Intro, _React$Component);
	
	  function Intro() {
	    _classCallCheck(this, Intro);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (Intro.__proto__ || Object.getPrototypeOf(Intro)).call(this));
	
	    _this.handleNext = _this.handleNext.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      permittedItems: [],
	      showPreparation: false
	    };
	    return _this;
	  }
	
	  _createClass(Intro, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.parsePermittedItems();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props = this.props,
	          button = _props.button,
	          nextStep = _props.nextStep,
	          parent = _props.parent,
	          statusClass = _props.statusClass;
	
	
	      if (statusClass === 'slide-active' && parent.state.next !== this.handleNext) {
	        parent.setState({
	          next: this.handleNext
	        });
	      }
	
	      if (statusClass === 'slide-active' && parent.state.next !== nextStep) {
	        button.disabled = false;
	      }
	    }
	  }, {
	    key: 'handleNext',
	    value: function handleNext() {
	      var nextStep = this.props.nextStep;
	
	
	      if (!this.state.showPreparation) {
	        this.setState({
	          showPreparation: true
	        });
	      } else {
	        nextStep();
	      }
	    }
	  }, {
	    key: 'parsePermittedItems',
	    value: function parsePermittedItems() {
	      var SessionStore = this.props.store.SessionStore;
	
	      var translation = SessionStore.translation.PermittedItems;
	      var examConfiguration = this.props.examConfiguration;
	
	      var permittedItems = [];
	
	      if (examConfiguration.permittedBathroomBreak) {
	        permittedItems.push({
	          title: translation.bathroomBreak,
	          details: examConfiguration.permittedBathroomBreakInformation
	        });
	      }
	
	      if (examConfiguration.permittedBlankPaper) {
	        permittedItems.push({
	          title: translation.blankPaper,
	          details: examConfiguration.permittedBlankPaperInformation
	        });
	      }
	
	      if (examConfiguration.permittedCalculator) {
	        permittedItems.push({
	          title: translation.calculator,
	          details: examConfiguration.permittedCalculatorInformation
	        });
	      }
	
	      if (examConfiguration.permittedDictionary) {
	        permittedItems.push({
	          title: translation.dictionary,
	          details: examConfiguration.permittedDictionaryInformation
	        });
	      }
	
	      if (examConfiguration.permittedEarplugs) {
	        permittedItems.push({
	          title: translation.earplugs,
	          details: examConfiguration.permittedEarplugsInformation
	        });
	      }
	
	      if (examConfiguration.permittedFormulaSheet) {
	        permittedItems.push({
	          title: translation.formulaSheet,
	          details: examConfiguration.permittedFormulaSheetInformation
	        });
	      }
	
	      if (examConfiguration.permittedNotes) {
	        permittedItems.push({
	          title: translation.notes,
	          details: examConfiguration.permittedNotesInformation
	        });
	      }
	
	      if (examConfiguration.permittedTextBook) {
	        permittedItems.push({
	          title: translation.textbook,
	          details: examConfiguration.permittedTextBookInformation
	        });
	      }
	
	      if (examConfiguration.permittedWebsites) {
	        permittedItems.push({
	          title: translation.websites,
	          details: examConfiguration.permittedWebsitesInformation
	        });
	      }
	
	      if (examConfiguration.permittedOtherItems) {
	        permittedItems.push({
	          title: translation.other,
	          details: examConfiguration.permittedOtherItems
	        });
	      }
	
	      this.setState({
	        permittedItems: permittedItems
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          exam = _props2.exam,
	          examConfiguration = _props2.examConfiguration,
	          statusClass = _props2.statusClass;
	
	      var translation = this.props.translation.intro;
	      var verifyId = examConfiguration.modalityOptions.verifyId;
	
	      if (!this.state.showPreparation) {
	        return _react2.default.createElement(
	          'main',
	          { className: 'panel panel--medium ' + statusClass, 'aria-labelledby': 'step5' },
	          _react2.default.createElement(
	            'section',
	            { className: 'panel__section' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title panel__title--alt', id: 'step5' },
	              translation.exam_details_heading
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'data--alt' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  translation.exam_details.name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  exam.title
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  translation.exam_details.duration
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  (0, _helpers.toHours)(examConfiguration.duration, false, false, false)
	                )
	              ),
	              examConfiguration.studentNotes && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  translation.exam_details.notes
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  examConfiguration.studentNotes
	                )
	              )
	            ),
	            this.state.permittedItems.length > 0 && _react2.default.createElement(
	              'ul',
	              { className: 'data--alt data--separator' },
	              _react2.default.createElement(
	                'li',
	                { className: 'data__separator' },
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  translation.exam_details.permitted_items
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'data--inner' },
	                  this.state.permittedItems.map(function (item, i) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: i },
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        item.title
	                      ),
	                      item.details && _react2.default.createElement(
	                        'p',
	                        null,
	                        item.details
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'panel__section' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title panel__title--alt' },
	              translation.process_heading
	            ),
	            _react2.default.createElement(
	              'ol',
	              { className: 'flow' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(icons.iconUser, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'flow__title' },
	                  translation.process.onboard
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(icons.icon_text, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'flow__title' },
	                  translation.process.exam
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(icons.iconCheckCircle, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'flow__title' },
	                  translation.process.complete
	                )
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'panel panel--medium ' + statusClass },
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__title panel__title--alt' },
	            translation.preparation.heading
	          ),
	          verifyId ? _react2.default.createElement(
	            'p',
	            null,
	            translation.preparation.intro
	          ) : _react2.default.createElement(
	            'p',
	            null,
	            translation.preparation.intro_no_id
	          ),
	          _react2.default.createElement(
	            'ol',
	            { className: 'flow flow--nonsequential' },
	            verifyId && _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(icons.iconID, null)
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(icons.iconLightbulb, null)
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(icons.iconCoffee, null)
	            )
	          ),
	          _react2.default.createElement(
	            'strong',
	            null,
	            translation.preparation.break
	          )
	        );
	      }
	    }
	  }]);
	
	  return Intro;
	}(_react2.default.Component);
	
	exports.default = Intro;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(56);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mobxReact = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*global chrome*/
	
	var ProctorPause = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProctorPause, _React$Component);
	
	  function ProctorPause() {
	    _classCallCheck(this, ProctorPause);
	
	    var _this = _possibleConstructorReturn(this, (ProctorPause.__proto__ || Object.getPrototypeOf(ProctorPause)).call(this));
	
	    _this.checkConnectionAndApproval = _this.checkConnectionAndApproval.bind(_this);
	
	    _this.state = {
	      proctorConnected: false,
	      ghostRunning: false
	    };
	    return _this;
	  }
	
	  _createClass(ProctorPause, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.automated) {
	        this.checkConnectionAndApproval();
	      }
	      this.checkGhost();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props = this.props,
	          button = _props.button,
	          nextStep = _props.nextStep,
	          parent = _props.parent,
	          skipProctorPause = _props.skipProctorPause,
	          statusClass = _props.statusClass,
	          proctorApproved = _props.proctorApproved,
	          automated = _props.automated;
	
	
	      if (statusClass === 'slide-active') {
	        // Skip if not enabled
	        if (skipProctorPause) {
	          parent.nextStep();
	          button.disabled = false;
	          return;
	        }
	
	        parent.setState({
	          next: nextStep
	        });
	
	        // Don't let the user continue if they haven't been approved
	        if (automated) {
	          button.disabled = !this.state.ghostRunning;
	        } else {
	          button.disabled = !proctorApproved || !this.state.ghostRunning;
	        }
	      }
	    }
	  }, {
	    key: 'checkConnectionAndApproval',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var SessionStore, _props2, proctorApproved, setProctorApproved;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                SessionStore = this.props.store.SessionStore;
	                _props2 = this.props, proctorApproved = _props2.proctorApproved, setProctorApproved = _props2.setProctorApproved;
	
	                setInterval(function () {
	                  chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'checkConnectionAndApproval' }, function (response) {
	                    if (response.connectionStatus === 'true' && _this2.state.proctorConnected !== true) {
	                      _this2.setState({ proctorConnected: true });
	                    }
	                    if (response.approvalStatus === 'true' && proctorApproved !== true) {
	                      setProctorApproved(true);
	                    }
	                    if (response.connectionStatus === 'undefined' && _this2.state.proctorConnected !== false) {
	                      _this2.setState({ proctorConnected: false });
	                    }
	                    if (response.approvalStatus === 'undefined' && proctorApproved !== false) {
	                      setProctorApproved(false);
	                    }
	                  });
	                }, 1000);
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function checkConnectionAndApproval() {
	        return _ref.apply(this, arguments);
	      }
	
	      return checkConnectionAndApproval;
	    }()
	  }, {
	    key: 'checkGhost',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this3 = this;
	
	        var MessageStore, ghostInterval;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                MessageStore = this.props.store.MessageStore;
	                ghostInterval = setInterval(function () {
	                  if (MessageStore.ghostRunning) {
	                    clearInterval(ghostInterval);
	                    _this3.setState({ ghostRunning: true });
	                  }
	                }, 1000);
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function checkGhost() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return checkGhost;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          statusClass = _props3.statusClass,
	          proctorApproved = _props3.proctorApproved,
	          automated = _props3.automated;
	
	      var translation = this.props.translation.proctorPause;
	
	      if (automated) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'panel panel--medium ' + statusClass },
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__title panel__title--alt' },
	            translation.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.alt_body
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tally-loader' },
	            _react2.default.createElement(
	              'div',
	              { className: 'tally' },
	              _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'tally__title' },
	                  translation.ghost
	                ),
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'tally__status ' + (this.state.ghostRunning ? 'completed' : 'in-progress')
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation[status]
	                  )
	                )
	              )
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel panel--medium ' + statusClass },
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title panel__title--alt' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.body
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tally-loader' },
	          _react2.default.createElement(
	            'ol',
	            { className: 'tally' },
	            _react2.default.createElement(
	              'li',
	              { key: 1 },
	              _react2.default.createElement(
	                'strong',
	                { className: 'tally__title' },
	                translation.assigned
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'tally__status ' + (this.state.proctorConnected ? 'completed' : 'in-progress')
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation[status]
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { key: 2 },
	              _react2.default.createElement(
	                'strong',
	                { className: 'tally__title' },
	                translation.approved
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'tally__status ' + (proctorApproved ? 'completed' : 'in-progress')
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation[status]
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { key: 3 },
	              _react2.default.createElement(
	                'strong',
	                { className: 'tally__title' },
	                translation.ghost
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'tally__status ' + (this.state.ghostRunning ? 'completed' : 'in-progress')
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation[status]
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProctorPause;
	}(_react2.default.Component));
	
	exports.default = ProctorPause;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Webcam = __webpack_require__(150);
	
	var _Webcam2 = _interopRequireDefault(_Webcam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var RoomScan = function (_React$Component) {
	  _inherits(RoomScan, _React$Component);
	
	  function RoomScan() {
	    _classCallCheck(this, RoomScan);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (RoomScan.__proto__ || Object.getPrototypeOf(RoomScan)).call(this));
	
	    _this.complete = _this.complete.bind(_this);
	    _this.showExampleVideo = _this.showExampleVideo.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      ready: false,
	      mediaChecked: false,
	      getUserMedia: true
	    };
	    return _this;
	  }
	
	  _createClass(RoomScan, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props = this.props,
	          button = _props.button,
	          parent = _props.parent,
	          sessionStartData = _props.sessionStartData,
	          statusClass = _props.statusClass;
	
	      if (statusClass === 'slide-active') {
	        if (!sessionStartData.modalityOptions.roomScan) {
	          parent.nextStep();
	        }
	
	        if (!button.disabled && !this.state.finished) {
	          // Disable the continue button
	          button.disabled = true;
	
	          parent.setState({
	            next: null
	          });
	        }
	      }
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      var _props2 = this.props,
	          button = _props2.button,
	          parent = _props2.parent,
	          nextStep = _props2.nextStep;
	
	
	      this.setState({
	        finished: true
	      });
	
	      button.disabled = false;
	
	      parent.setState({
	        next: nextStep
	      });
	    }
	  }, {
	    key: 'showExampleVideo',
	    value: function showExampleVideo(e) {
	      var SessionStore = this.props.store.SessionStore;
	
	      var lastFocused = e.target;
	
	      var example = _react2.default.createElement(
	        'div',
	        { className: 'vid__wrap vid__wrap--wide' },
	        _react2.default.createElement('iframe', {
	          title: 'Example Video of a Room Scan - No audio',
	          src: 'https://player.vimeo.com/video/240038653?byline=0&portrait=0&autoplay=1',
	          className: 'vid__video',
	          width: '640',
	          height: '360',
	          frameBorder: '0',
	          allow: 'autoplay; fullscreen',
	          allowFullScreen: true
	        })
	      );
	
	      SessionStore.showModal = true;
	      SessionStore.modalContent = example;
	      SessionStore.modalLoaded = true;
	      SessionStore.lastFocused = lastFocused;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          onStart = _props3.onStart,
	          onStop = _props3.onStop,
	          statusClass = _props3.statusClass;
	
	      var translation = this.props.translation.room_scan;
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'panel panel--medium ' + statusClass, 'aria-labelledby': 'step6' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title panel__title--alt', id: 'step6' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.body,
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn--link',
	              onClick: function onClick(e) {
	                return _this2.showExampleVideo(e);
	              }
	            },
	            translation.example
	          )
	        ),
	        statusClass === 'slide-active' && _react2.default.createElement(_Webcam2.default, Object.assign({}, this.props, {
	          allowRecord: true,
	          camera: 'user',
	          parent: this,
	          disableFullScreen: true,
	          callback: this.complete,
	          recordStart: onStart,
	          recordStop: onStop
	        }))
	      );
	    }
	  }]);
	
	  return RoomScan;
	}(_react2.default.Component);
	
	exports.default = RoomScan;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _SessionStartAutomated = __webpack_require__(220);
	
	var _SessionStartAutomated2 = _interopRequireDefault(_SessionStartAutomated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global chrome */
	
	
	// Config
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var SessionStart = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionStart, _React$Component);
	
	  function SessionStart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SessionStart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SessionStart.__proto__ || Object.getPrototypeOf(SessionStart)).call.apply(_ref, [this].concat(args))), _this), _this.renderUninstall = function () {
	      var SessionStore = _this.props.store.SessionStore;
	
	      var forceUninstall = false;
	
	      // If we have not already sent the uninstall message to
	      // the extension, send the message, mark it in sessionStorage
	      // and set the force uninstall boolean flag to true
	      if (!sessionStorage.getItem('extensionUninstalled')) {
	        sessionStorage.setItem('extensionUninstalled', true);
	        forceUninstall = true;
	
	        chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'uninstallExtension' }, function (response) {
	          return console.log(response);
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _this.renderView(forceUninstall)
	      );
	    }, _this.renderView = function (forceUninstall) {
	      return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	        flagKey: 'hybrid',
	        renderFeatureCallback: function renderFeatureCallback(e) {
	          return _this.renderStart(e, forceUninstall);
	        },
	        renderDefaultCallback: function renderDefaultCallback(e) {
	          return _this.renderStart(e, forceUninstall);
	        }
	      });
	    }, _this.renderStart = function (hybrid, forceUninstall) {
	      var ExamStore = _this.props.store.ExamStore;
	
	
	      return _react2.default.createElement(_SessionStartAutomated2.default, Object.assign({}, _this.props, {
	        exam: ExamStore.exam,
	        examSid: ExamStore.exam.configuration.examSid,
	        external: true,
	        sessionSid: ExamStore.examSession.sid,
	        hybrid: hybrid,
	        uninstall: forceUninstall ? true : false
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SessionStart, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore;
	
	      // Hide the header and footer
	
	      SessionStore.hideHeader = true;
	      SessionStore.hideFooter = true;
	
	      // Get session details from sid in query params
	      var examSid = this.props.routing.location.query.examSid;
	      var sessionSid = this.props.routing.location.query.sessionSid;
	      var courseSid = this.props.routing.location.query.courseSid;
	      var installSid = this.props.routing.location.query.installSid;
	      var token = this.props.routing.location.query.token;
	
	      // If this user is coming from outside of an LMS (like from the DMV)
	      // we need to get an installSid and a token from the url and store
	      // those for use with exam provisioning.
	      if (installSid && token) {
	        SessionStore.userData.installSid = installSid;
	
	        sessionStorage.setItem('courseSid', courseSid);
	        sessionStorage.setItem('installSid', installSid);
	        sessionStorage.setItem('token', token);
	
	        SessionStore.token = token;
	
	        (0, _config.setToken)(token, true);
	
	        SessionStore.getExtensionInfo();
	      }
	
	      if (examSid && courseSid) {
	        ExamStore.getExam(examSid, courseSid);
	      }
	
	      if (examSid && sessionSid) {
	        ExamStore.getExamSession(examSid, sessionSid);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	          flagKey: 'extension-force-uninstall',
	          renderFeatureCallback: this.renderUninstall,
	          renderDefaultCallback: this.renderView
	        });
	      }
	
	      return null;
	    }
	  }]);
	
	  return SessionStart;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionStart')(SessionStart);

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	var SessionStartHybrid = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionStartHybrid, _React$Component);
	
	  function SessionStartHybrid() {
	    _classCallCheck(this, SessionStartHybrid);
	
	    // Set the initial state
	    var _this = _possibleConstructorReturn(this, (SessionStartHybrid.__proto__ || Object.getPrototypeOf(SessionStartHybrid)).call(this));
	
	    _this.checkTime = function (examUrl) {
	      var exam = _this.props.exam;
	      var examSession = exam.examSession;
	
	
	      var now = (0, _moment2.default)(_this.props.store.SessionStore.currentTime);
	      var sessionTime = (0, _moment2.default)(examSession.appointmentDate);
	      var timeToSession = _moment2.default.duration(sessionTime.diff(now)).asMinutes();
	      var sessionEnd = (0, _moment2.default)(examSession.appointmentDate).add(30, 'minutes');
	      var timeToSessionEnd = _moment2.default.duration(sessionEnd.diff(now)).asMinutes();
	
	      var late = timeToSessionEnd <= 0;
	      var early = timeToSession >= 10;
	
	      if (late || early) {
	        _this.setState({
	          late: late,
	          early: early
	        });
	      } else {
	        window.open(examUrl, '_top');
	
	        (0, _helpers.closeDrawer)(null, _this.props.parent);
	      }
	    };
	
	    _this.state = {
	      late: false,
	      early: false
	    };
	    return _this;
	  }
	
	  _createClass(SessionStartHybrid, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          exam = _props.exam,
	          store = _props.store;
	      var installSid = store.SessionStore.userData.installSid;
	      var examSession = exam.examSession;
	
	
	      (0, _helpers.openExamDirect)(installSid, exam.sid, examSession.sid).then(function (response) {
	        _this2.checkTime(response.redirectUrl);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          exam = _props2.exam,
	          store = _props2.store,
	          translation = _props2.translation;
	      var _state = this.state,
	          early = _state.early,
	          late = _state.late;
	      var examSession = exam.examSession;
	      var userTimezone = store.SessionStore.userTimezone;
	
	
	      if (late) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'slide-wrap wrap' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'panel panel--brief slide-active'
	            },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.late.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.late.body.replace('%date%', _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                onClick: function onClick(e) {
	                  (0, _helpers.closeDrawer)(e, _this3.props.parent);
	                }
	              },
	              translation.late.button
	            )
	          )
	        );
	      } else if (early) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'slide-wrap wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief slide-active' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.early.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.early.body.replace('%date%', _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                onClick: function onClick(e) {
	                  (0, _helpers.closeDrawer)(e, _this3.props.parent);
	                }
	              },
	              translation.early.button
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SessionStartHybrid;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionStartHybrid')(SessionStartHybrid);

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _screenShare = __webpack_require__(1667);
	
	var _screenShare2 = _interopRequireDefault(_screenShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*global chrome*/
	
	// Components
	
	
	var ShareScreen = function (_React$Component) {
	  _inherits(ShareScreen, _React$Component);
	
	  function ShareScreen() {
	    _classCallCheck(this, ShareScreen);
	
	    // Set the initial state
	    var _this = _possibleConstructorReturn(this, (ShareScreen.__proto__ || Object.getPrototypeOf(ShareScreen)).call(this));
	
	    _this.state = {
	      finished: false
	    };
	    return _this;
	  }
	
	  _createClass(ShareScreen, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var _props = this.props,
	          button = _props.button,
	          nextStep = _props.nextStep,
	          parent = _props.parent,
	          sessionStartData = _props.sessionStartData,
	          statusClass = _props.statusClass,
	          proctorApproved = _props.proctorApproved;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (statusClass === 'slide-active' && parent.state.next !== nextStep) {
	        // Skip if not enabled
	        if (!sessionStartData.modalityOptions.recordScreen) {
	          nextStep();
	        }
	
	        if (!button.disabled && !this.state.finished) {
	          // Disable the continue button
	          button.disabled = true;
	
	          parent.setState({
	            next: null
	          });
	        }
	
	        // Listen for sharing complete
	        var shareDelay = setInterval(function () {
	          chrome.runtime.sendMessage(SessionStore.extensionInfo.extensionId, { message: 'isRecording' }, function (response) {
	            if (response.isScreenRecording) {
	              clearInterval(shareDelay);
	
	              if (!_this2.state.finished) {
	                _this2.setState({
	                  finished: true
	                }, function () {
	                  nextStep();
	                });
	              }
	            }
	          });
	        }, 1000);
	      }
	      // Case for enabling continue button if student gets stuck on ScreenShare while still being
	      if (statusClass === 'slide-active' && button.disabled && proctorApproved) {
	        button.disabled = false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          onShowPopup = _props2.onShowPopup,
	          statusClass = _props2.statusClass;
	
	      var translation = this.props.translation.share_screen;
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'panel panel--medium ' + statusClass, 'aria-labelledby': 'step7' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title panel__title--alt', id: 'step7' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.body
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'note' },
	          translation.screen_share_note
	        ),
	        _react2.default.createElement('img', { className: 'img', role: 'presentation', src: _screenShare2.default, alt: 'Steps for successful Screen Share' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'note' },
	          _react2.default.createElement(
	            'b',
	            null,
	            translation.keyboard_note
	          ),
	          translation.keyboard_note2
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn', onClick: onShowPopup },
	          translation.button
	        )
	      );
	    }
	  }]);
	
	  return ShareScreen;
	}(_react2.default.Component);
	
	exports.default = ShareScreen;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(56);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(5);
	
	var _config = __webpack_require__(9);
	
	var _Webcam = __webpack_require__(150);
	
	var _Webcam2 = _interopRequireDefault(_Webcam);
	
	var _Microphone = __webpack_require__(880);
	
	var _Microphone2 = _interopRequireDefault(_Microphone);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*global chrome*/
	
	// Helpers
	
	
	// Components
	
	
	var SystemCheck = function (_React$Component) {
	  _inherits(SystemCheck, _React$Component);
	
	  function SystemCheck() {
	    _classCallCheck(this, SystemCheck);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (SystemCheck.__proto__ || Object.getPrototypeOf(SystemCheck)).call(this));
	
	    _this.complete = _this.complete.bind(_this);
	    _this.checkOptions = _this.checkOptions.bind(_this);
	    _this.isCameraBlank = _this.isCameraBlank.bind(_this);
	    _this.startFaceCheck = _this.startFaceCheck.bind(_this);
	
	    // Set the initial state
	    _this.state = {
	      audioDetected: false,
	      ready: false,
	      mediaChecked: false,
	      getUserMedia: false,
	      devicesChecked: false,
	      optionsChecked: false,
	      webcams: [],
	      microphones: [],
	      averageBrightness: 0,
	      unacceptableBrightness: false
	    };
	    return _this;
	  }
	
	  _createClass(SystemCheck, [{
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(prevProps, prevState) {
	        var _this2 = this;
	
	        var _props, nextStep, parent, setDevice, statusClass, button, translation, getUserMediaSupported;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _props = this.props, nextStep = _props.nextStep, parent = _props.parent, setDevice = _props.setDevice, statusClass = _props.statusClass, button = _props.button;
	                translation = this.props.translation.system_check;
	
	                if (!(statusClass === 'slide-active' && parent.state.next !== nextStep)) {
	                  _context.next = 11;
	                  break;
	                }
	
	                if (this.props.runFaceCheck) {
	                  // Wait for Face Check
	                  button.disabled = true;
	                  button.textContent = translation.waiting_for_face_detection;
	                }
	
	                // Check if getUserMedia is supported
	
	                if (this.state.mediaChecked) {
	                  _context.next = 11;
	                  break;
	                }
	
	                _context.next = 7;
	                return (0, _helpers.testGetUserMedia)();
	
	              case 7:
	                getUserMediaSupported = _context.sent;
	
	                this.getUserMediaSupported = getUserMediaSupported;
	
	                if (!getUserMediaSupported) {
	                  this.setState({
	                    getUserMedia: false
	                  });
	
	                  this.disableNext();
	                } else {
	                  this.setState({
	                    getUserMedia: true
	                  });
	                }
	
	                this.setState({
	                  mediaChecked: true
	                });
	
	              case 11:
	
	                // Get user devices
	                if (this.state.mediaChecked && this.state.getUserMedia && !this.state.devicesChecked) {
	                  navigator.mediaDevices.enumerateDevices().then(function (devices) {
	                    var webcams = [];
	                    var microphones = [];
	
	                    devices.forEach(function (device) {
	                      if (device.kind === 'videoinput') {
	                        webcams.push(device);
	                      } else if (device.kind === 'audioinput') {
	                        microphones.push(device);
	                      }
	                    });
	
	                    // Set the webcam to the first one
	                    setDevice('webcam', webcams[0].deviceId + ',' + webcams[0].label);
	
	                    // Set the microphone to the first one
	                    setDevice('microphone', microphones[0].deviceId + ',' + microphones[0].label);
	
	                    _this2.setState({
	                      webcams: webcams,
	                      microphones: microphones
	                    });
	
	                    _this2.startFaceCheck();
	                  }).catch(function (error) {
	                    console.error(error);
	                  });
	
	                  this.setState({
	                    devicesChecked: true
	                  });
	                }
	
	                if (statusClass === 'slide-active' && this.state.webcams.length > 0) {
	                  this.startFaceCheck();
	                }
	
	                // If getUserMedia has been checked and is available, set ready to true
	                if (statusClass === 'slide-active' && this.state.mediaChecked && this.state.getUserMedia && !this.state.ready) {
	                  this.setState({
	                    ready: true
	                  }, this.checkOptions);
	                }
	
	                // Remove the webcam preview after proceeding
	                if (statusClass !== 'slide-active' && this.state.ready) {
	                  this.setState({
	                    ready: false
	                  });
	                }
	
	                if (statusClass === 'slide-active' && !this.state.optionsChecked || prevProps.displayCount !== this.props.displayCount && statusClass === 'slide-active') {
	                  if (this.state.getUserMedia) {
	                    this.disableNext();
	                    this.checkOptions();
	                  }
	                }
	
	              case 16:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidUpdate(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'startFaceCheck',
	    value: function startFaceCheck() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          button = _props2.button,
	          faceCheck = _props2.faceCheck,
	          runFaceCheck = _props2.runFaceCheck,
	          store = _props2.store;
	      var displayCountValid = this.state.displayCountValid;
	      var SessionStore = store.SessionStore;
	
	      var translation = this.props.translation.system_check;
	      var checkCount = 0;
	
	      clearInterval(this.faceCheckInterval);
	
	      // If face check is disabled, enable the button,
	      // update the text, and return.
	      if (!runFaceCheck && displayCountValid && this.getUserMediaSupported) {
	        button.disabled = false;
	        button.textContent = translation.button;
	        return;
	      }
	
	      var faceCheckInterval = setInterval(function () {
	        return faceCheck(function (faceDetected) {
	          checkCount += 1;
	
	          console.log('Face detected: ' + faceDetected);
	
	          if (checkCount === 6) {
	            SessionStore.showToaster(translation.face_not_found, 'error', 100000, 'toaster--lg');
	          }
	
	          if (faceDetected) {
	            clearInterval(_this3.faceCheckInterval);
	            SessionStore.closeNotification();
	
	            if (displayCountValid) {
	              button.disabled = false;
	              button.textContent = translation.button;
	            }
	          }
	        });
	      }, 1000);
	      this.faceCheckInterval = faceCheckInterval;
	    }
	  }, {
	    key: 'getAverageBrightness',
	    value: function getAverageBrightness(imgData) {
	      var d = imgData.data;
	      var rgb = { r: 0, g: 0, b: 0 };
	      for (var i = 0; i < d.length; i += 4) {
	        rgb.r += d[i];
	        rgb.g += d[i + 1];
	        rgb.b += d[i + 2];
	      }
	
	      rgb.r = ~~(rgb.r / (d.length / 4));
	      rgb.g = ~~(rgb.g / (d.length / 4));
	      rgb.b = ~~(rgb.b / (d.length / 4));
	
	      return (
	        // https://en.wikipedia.org/wiki/Relative_luminance
	        Math.round((0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255 * 100 * 100) / 100
	      );
	    }
	  }, {
	    key: 'isCameraBlank',
	    value: function isCameraBlank() {
	      try {
	        var video = document.getElementsByClassName('webcam__stream').item(0);
	        var canvas = document.createElement('canvas');
	        canvas.width = video.videoWidth;
	        canvas.height = video.videoHeight;
	        canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
	        var context = canvas.getContext('2d');
	        var averageBrightness = this.getAverageBrightness(context.getImageData(0, 0, 1, 1));
	        this.setState({ averageBrightness: averageBrightness });
	        return averageBrightness < _config.config.averageBrightnessMin;
	      } catch (_) {
	        return true;
	      }
	    }
	  }, {
	    key: 'checkOptions',
	    value: function checkOptions() {
	      var _props3 = this.props,
	          button = _props3.button,
	          displayCount = _props3.displayCount,
	          examConfiguration = _props3.examConfiguration,
	          parent = _props3.parent;
	      var modalityOptions = examConfiguration.modalityOptions;
	
	
	      this.setState({
	        optionsChecked: true,
	        displayCountValid: !modalityOptions.onlyOneScreen || modalityOptions.onlyOneScreen && displayCount === 1 ? true : false
	      });
	
	      var isScreenCountNotAllowed = typeof modalityOptions.onlyOneScreen !== 'undefined' && displayCount > 1;
	
	      var isScreenBrightnessUnacceptable = modalityOptions.recordWebcam !== 'undefined' && this.state.ready && this.isCameraBlank();
	
	      if (isScreenBrightnessUnacceptable !== this.state.unacceptableBrightness) {
	        this.setState({
	          unacceptableBrightness: isScreenBrightnessUnacceptable
	        });
	      }
	
	      if (!modalityOptions.recordWebcam) {
	        isScreenBrightnessUnacceptable = false;
	
	        this.setState({
	          unacceptableBrightness: false
	        });
	      }
	
	      if ((isScreenCountNotAllowed || isScreenBrightnessUnacceptable) && (parent.state.next !== null || !button.disabled) || !this.state.audioDetected) {
	        this.disableNext();
	      } else if (parent.state.next === null || button.disabled) {
	        this.enableNext();
	      }
	
	      if (modalityOptions.recordWebcam && this.state.ready) {
	        if (this.state.webcams.length === 0) {
	          clearTimeout(this.webcamRecheck);
	          this.webcamRecheck = setTimeout(this.checkOptions, 500);
	          this.disableNext();
	        }
	      }
	
	      if (modalityOptions.recordAudio && this.state.ready) {
	        if (this.state.microphones.length === 0) {
	          clearTimeout(this.micRecheck);
	          this.micRecheck = setTimeout(this.checkOptions, 500);
	          this.disableNext();
	        }
	      }
	    }
	  }, {
	    key: 'disableNext',
	    value: function disableNext() {
	      var button = this.props.button;
	
	
	      button.disabled = true;
	    }
	  }, {
	    key: 'enableNext',
	    value: function enableNext() {
	      var _props4 = this.props,
	          button = _props4.button,
	          parent = _props4.parent;
	
	
	      button.disabled = false;
	
	      parent.setState({
	        next: this.complete
	      });
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      var nextStep = this.props.nextStep;
	
	
	      this.setState({
	        optionsChecked: false
	      });
	
	      nextStep();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props5 = this.props,
	          displayCount = _props5.displayCount,
	          examConfiguration = _props5.examConfiguration,
	          setDevice = _props5.setDevice,
	          statusClass = _props5.statusClass;
	      var _state = this.state,
	          microphones = _state.microphones,
	          unacceptableBrightness = _state.unacceptableBrightness,
	          webcams = _state.webcams;
	      var modalityOptions = examConfiguration.modalityOptions;
	
	      var translation = this.props.translation.system_check;
	
	      return _react2.default.createElement(
	        'main',
	        {
	          className: 'panel panel--medium system-check ' + statusClass,
	          'aria-labelledby': 'step8'
	        },
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title panel__title--alt', id: 'step8' },
	          translation.heading
	        ),
	        this.state.ready && modalityOptions.recordWebcam && statusClass === 'slide-active' && _react2.default.createElement(_Webcam2.default, Object.assign({}, this.props, {
	          name: 'preview',
	          camera: 'user',
	          parent: this,
	          disableFullScreen: true,
	          hideTools: true,
	          caption: translation.body
	        })),
	        unacceptableBrightness && _react2.default.createElement(
	          'span',
	          { className: 'note note--prominent note--alt system-check__note' },
	          translation.unacceptable_brightness
	        ),
	        modalityOptions.recordWebcam && modalityOptions.recordAudio && (webcams.length === 0 || microphones.length === 0) && _react2.default.createElement(
	          'span',
	          { className: 'note note--prominent note--alt system-check__note' },
	          translation.no_devices
	        ),
	        modalityOptions.recordWebcam && !modalityOptions.recordAudio && webcams.length === 0 && _react2.default.createElement(
	          'span',
	          { className: 'note note--prominent note--alt system-check__note' },
	          translation.no_webcam
	        ),
	        !modalityOptions.recordWebcam && modalityOptions.recordAudio && microphones.length === 0 && _react2.default.createElement(
	          'span',
	          { className: 'note note--prominent note--alt system-check__note' },
	          translation.no_microphone
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'grid system-check__grid' },
	          modalityOptions.recordWebcam && _react2.default.createElement(
	            'li',
	            { className: 'grid__cell media--alt media--alt-top' },
	            _react2.default.createElement(icons.iconVideoCamera, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'media__copy' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'check-webcam' },
	                translation.webcam
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    id: 'check-webcam',
	                    onChange: function onChange(e) {
	                      _this4.startFaceCheck();
	                      setDevice('webcam', e.target.value);
	                    }
	                  },
	                  this.state.webcams.map(function (webcam, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: webcam.deviceId + ',' + webcam.label, key: i },
	                      webcam.label
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          modalityOptions.recordAudio && _react2.default.createElement(
	            'li',
	            { className: 'grid__cell media--alt media--alt-top' },
	            this.state.ready && _react2.default.createElement(_Microphone2.default, Object.assign({}, this.props, {
	              onAudioDetected: function onAudioDetected() {
	                _this4.setState({ audioDetected: true }, function () {
	                  _this4.checkOptions();
	                });
	              }
	            })),
	            _react2.default.createElement(
	              'div',
	              { className: 'media__copy' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'check-microphone' },
	                translation.microphone
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    id: 'check-microphone',
	                    onChange: function onChange(e) {
	                      setDevice('microphone', e.target.value);
	
	                      _this4.setState({ audioDetected: false }, function () {
	                        _this4.props.button.disabled = true;
	                      });
	                    }
	                  },
	                  this.state.microphones.map(function (microphone, i) {
	                    return _react2.default.createElement(
	                      'option',
	                      {
	                        value: microphone.deviceId + ',' + microphone.label,
	                        key: i
	                      },
	                      microphone.label
	                    );
	                  })
	                )
	              ),
	              !this.state.audioDetected && _react2.default.createElement(
	                'span',
	                { className: 'media__note' },
	                translation.microphone_helper
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'grid__cell media--alt' },
	            _react2.default.createElement(icons.iconWifi, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'media__copy' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'media__heading' },
	                translation.connection
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'tally__status tally__status--alt completed' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  'Pass'
	                )
	              )
	            )
	          ),
	          modalityOptions.onlyOneScreen && _react2.default.createElement(
	            'li',
	            { className: 'grid__cell media--alt' },
	            _react2.default.createElement(icons.iconDesktop, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'media__copy' },
	              _react2.default.createElement(
	                'strong',
	                { className: 'media__heading' },
	                translation.displays.heading,
	                ': ',
	                displayCount
	              ),
	              displayCount === 1 && _react2.default.createElement(
	                'span',
	                { className: 'tally__status tally__status--alt completed' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  'Pass'
	                )
	              ),
	              displayCount !== 1 && _react2.default.createElement(
	                'span',
	                null,
	                translation.displays.error_msg
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SystemCheck;
	}(_react2.default.Component);
	
	exports.default = SystemCheck;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Config
	
	
	var SmarterElements = (0, _config.getSmarterElementsInstance)();
	
	// Translations
	
	
	var AutomatedReview = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AutomatedReview, _React$Component);
	
	  function AutomatedReview() {
	    _classCallCheck(this, AutomatedReview);
	
	    return _possibleConstructorReturn(this, (AutomatedReview.__proto__ || Object.getPrototypeOf(AutomatedReview)).apply(this, arguments));
	  }
	
	  _createClass(AutomatedReview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var examSession = this.props.store.ExamStore.examSession;
	      var SessionStore = this.props.store.SessionStore;
	      var userSid = SessionStore.userData.userSid;
	      var token = SessionStore.token;
	
	
	      if (examSession.platformVersion === "3") {
	
	        var SessionViewer = null;
	
	        // get the position of the session viewer container
	        // wait for the dom to be ready
	        //document.addEventListener('DOMContentLoaded', function() {
	        if (this && this.refs && this.refs["v3-container"] && SmarterElements) {
	          var resizeContainer = function resizeContainer() {
	
	            var scontainer = document.getElementById('v3-container');
	            var containerRect = scontainer.getBoundingClientRect();
	
	            var containerTop = containerRect.top + 10;
	            // get the px amoutn for the vh
	            var vh = window.innerHeight;
	            scontainer.style.height = vh - containerTop + 'px';
	
	            if (SessionViewer) {
	              SessionViewer.updateConstraints({
	                maxHeight: vh - containerTop
	              });
	              SessionViewer.recalculateSize();
	            }
	          };
	
	          resizeContainer();
	
	          // ensure that the resizing is performat...
	          var debouncedResize = window.SmarterElements.throttle(function () {
	            resizeContainer();
	          }, 250);
	
	          // add a lisenter that will run on document resize to resize the contaner
	          window.addEventListener('resize', debouncedResize);
	        }
	
	        // Determine if the session is currently live
	        var isLiveSession = ['in progress', 'onboarding', 'checked in'].includes(examSession.status.toLowerCase());
	
	        // Create a session viewer
	        var viewerProperties = {
	          sessionSid: examSession.sid,
	          installSid: examSession.installSid,
	          examSid: examSession.examSid,
	          token: token,
	          identity: userSid,
	          roomId: examSession.sid,
	          viewMode: 'instructor',
	          allowPopout: true,
	          enabledComponents: {
	            controls: true,
	            sessionDetails: {
	              tabs: ['info', 'identity', 'flags']
	            },
	            annotations: true,
	            timeline: true,
	            sharing: true,
	            chat: false,
	            videoPlayer: true,
	            remoteControl: false
	          },
	          video: {
	            sources: isLiveSession ? ['live', 'recorded'] : ['recorded'],
	            default: isLiveSession ? 'live' : 'recorded'
	          },
	          elementId: 'v3-container',
	          autoResize: true,
	          resizeOffset: 10
	        };
	
	        SessionViewer = SmarterElements.create('proctoring/session-viewer', viewerProperties);
	        SessionViewer.mount(this.refs["v3-container"]);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	      var installSid = SessionStore.userData.installSid;
	      var _props = this.props,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	      var token = SessionStore.token;
	
	      var examSession = this.props.store.ExamStore.examSession;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        examSession.platformVersion === "3" ? _react2.default.createElement(
	          'div',
	          { className: 'iframe-wrap', style: { margin: '-15px', width: '100%', height: '100vh' } },
	          _react2.default.createElement(
	            'style',
	            null,
	            '\n                .drawer__header {\n                  top: 0;\n                  position: sticky;\n                }\n                .drawer__content {\n                  overflow: hidden;\n                }\n              '
	          ),
	          _react2.default.createElement('div', { id: 'v3-container', ref: 'v3-container', style: { width: '100%', height: 'calc(100vh - 62px)' } })
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'iframe-wrap', style: { marginTop: '0px', width: '100%', height: '100%' } },
	          _react2.default.createElement('iframe', {
	            className: 'iframe--full',
	            allowFullScreen: 'true',
	            src: _config.config.playbackUrl + '/#/?installSid=' + installSid + '&examSid=' + examSid + '&sessionSid=' + sessionSid + '&token=' + token + '&embed=true'
	          })
	        )
	      );
	    }
	  }]);
	
	  return AutomatedReview;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AutomatedReview')(AutomatedReview);

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Video = __webpack_require__(810);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var BVReview = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(BVReview, _React$Component);
	
	  function BVReview() {
	    _classCallCheck(this, BVReview);
	
	    return _possibleConstructorReturn(this, (BVReview.__proto__ || Object.getPrototypeOf(BVReview)).apply(this, arguments));
	  }
	
	  _createClass(BVReview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          StepInStore = _props$store.StepInStore;
	
	
	      if (SessionStore.loadingCalls.indexOf('BVData') < 0) {
	        StepInStore.getBVData(this.props.examSid, this.props.sessionSid);
	      }
	    }
	  }, {
	    key: 'initials',
	    value: function initials(name, className) {
	      var names = name.split(' ');
	      var firstInitial = names[0].charAt(0);
	      var secondInitial = names[1].charAt(0);
	
	      if (className) {
	        return '' + firstInitial.toLowerCase();
	      }
	
	      return firstInitial + secondInitial;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	      var metadata = this.props.store.StepInStore.metadata;
	
	
	      if (!SessionStore.loading && metadata) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'videos' },
	          _react2.default.createElement(
	            'section',
	            { className: 'panel__section panel__section--half' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__heading' },
	              translation.desktop
	            ),
	            _react2.default.createElement(_Video2.default, Object.assign({
	              src: 'https://s3.amazonaws.com/' + metadata.bucket + metadata.bomgar_video_path,
	              controls: true,
	              autoplay: false
	            }, this.props))
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'panel__section panel__section--half' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__heading' },
	              translation.chat
	            ),
	            _react2.default.createElement(
	              'ol',
	              { className: 'chat conversation' },
	              metadata.chat.map(function (message, i) {
	                var fromUser = message.performed_by.name.split(' ');
	
	                if (fromUser.length === 1) {
	                  fromUser.push(' ');
	                }
	
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  _react2.default.createElement(
	                    'blockquote',
	                    { className: '\n                        conversation__message\n                        ' + (message.performed_by.type === 'customer' ? 'sent' : 'received') + '\n                      ' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'conversation__body' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'conversation__content' },
	                        _react2.default.createElement('div', { dangerouslySetInnerHTML: {
	                            __html: _dompurify2.default.sanitize(message.body.replace(/\r?\n|\r/g, ' ')) } })
	                      ),
	                      _react2.default.createElement(
	                        'time',
	                        { className: 'conversation__timestamp' },
	                        _moment2.default.unix(message.timestamp).tz(userTimezone).format('M/D/YYYY h:mma z')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'cite',
	                      { className: 'conversation__author conversation__author--sm' },
	                      _react2.default.createElement(
	                        'abbr',
	                        {
	                          className: '\n                              avatar--initials conversation__avatar ' + _this2.initials(fromUser[0] + ' ' + fromUser[1], true) + '\n                            ',
	                          title: fromUser[0] + ' ' + fromUser[1] },
	                        fromUser[0].charAt(0),
	                        fromUser[1].charAt(0)
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'panel__section' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__heading' },
	              translation.webcams
	            ),
	            metadata.mega_meeting && _react2.default.createElement(
	              'div',
	              { className: 'vid-holder' },
	              metadata.mega_meeting.map(function (video, i) {
	                return _react2.default.createElement(_Video2.default, Object.assign({
	                  key: i,
	                  src: 'https://s3.amazonaws.com/' + video.bucket + video.path,
	                  controls: true,
	                  autoplay: false
	                }, _this2.props));
	              })
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return BVReview;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('BVReview')(BVReview);

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var ExamityReview = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamityReview, _React$Component);
	
	  function ExamityReview() {
	    _classCallCheck(this, ExamityReview);
	
	    return _possibleConstructorReturn(this, (ExamityReview.__proto__ || Object.getPrototypeOf(ExamityReview)).apply(this, arguments));
	  }
	
	  _createClass(ExamityReview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          StepInStore = _props$store.StepInStore;
	      var _props = this.props,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	
	
	      if (SessionStore.loadingCalls.indexOf('getReviewUrl') < 0) {
	        StepInStore.getReviewUrl(examSid, sessionSid);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          SessionStore = _props$store2.SessionStore,
	          StepInStore = _props$store2.StepInStore;
	
	
	      if (SessionStore.backgroundLoadingCalls.indexOf('getReviewUrl') < 0) {
	        return _react2.default.createElement(
	          'article',
	          { className: 'frame-wrap' },
	          _react2.default.createElement(
	            'header',
	            { className: 'frame-wrap__head' },
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'btn btn--inverse btn--icn-right',
	                target: '_blank',
	                href: StepInStore.reviewUrl
	              },
	              translation.pop_out,
	              _react2.default.createElement(icons.iconExternal, null)
	            )
	          ),
	          _react2.default.createElement('iframe', {
	            className: 'review-frame',
	            src: StepInStore.reviewUrl
	          })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ExamityReview;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamityReview')(ExamityReview);

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var ProctorUReview = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProctorUReview, _React$Component);
	
	  function ProctorUReview() {
	    _classCallCheck(this, ProctorUReview);
	
	    return _possibleConstructorReturn(this, (ProctorUReview.__proto__ || Object.getPrototypeOf(ProctorUReview)).apply(this, arguments));
	  }
	
	  _createClass(ProctorUReview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          StepInStore = _props$store.StepInStore;
	      var _props = this.props,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	
	
	      if (SessionStore.loadingCalls.indexOf('getReviewPayload') < 0 && !StepInStore.formData) {
	        StepInStore.getReviewPayload(examSid, sessionSid);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var StepInStore = this.props.store.StepInStore;
	
	
	      StepInStore.formData = null;
	    }
	  }, {
	    key: 'getLogin',
	    value: function getLogin() {
	      var StepInStore = this.props.store.StepInStore;
	      var formData = StepInStore.formData;
	
	
	      var formDelay = setInterval(function () {
	        var launchForm = document.querySelector('#review-form');
	
	        if (launchForm) {
	          clearInterval(formDelay);
	
	          launchForm.method = formData.method;
	          launchForm.action = formData.url;
	
	          Object.keys(formData.fields).forEach(function (field) {
	            var inputField = document.createElement('input');
	            inputField.name = field;
	            inputField.type = 'text';
	            inputField.value = formData.fields[field];
	            launchForm.appendChild(inputField);
	          });
	
	          var button = document.createElement('button');
	          button.text = 'Submit';
	          launchForm.appendChild(button);
	
	          launchForm.submit();
	        }
	      }, 100);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$store2 = this.props.store,
	          SessionStore = _props$store2.SessionStore,
	          StepInStore = _props$store2.StepInStore;
	
	
	      if (SessionStore.backgroundLoadingCalls.indexOf('getReviewPayload') < 0) {
	        if (StepInStore.reviewUrl) {
	          return _react2.default.createElement('iframe', {
	            className: 'review-frame',
	            src: StepInStore.reviewUrl
	          });
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('iframe', {
	              className: 'review-frame',
	              name: 'review-frame'
	            }),
	            _react2.default.createElement('form', {
	              className: 'meta',
	              id: 'review-form',
	              target: 'review-frame'
	            }),
	            this.getLogin()
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return ProctorUReview;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProctorUReview')(ProctorUReview);

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mobxReact = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(980);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _reactTabs = __webpack_require__(195);
	
	var _reactTextareaAutosize = __webpack_require__(74);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	var InstitutionSettings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(InstitutionSettings, _React$Component);
	
	  function InstitutionSettings() {
	    _classCallCheck(this, InstitutionSettings);
	
	    var _this = _possibleConstructorReturn(this, (InstitutionSettings.__proto__ || Object.getPrototypeOf(InstitutionSettings)).call(this));
	
	    _this.handleTabs = _this.handleTabs.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    _this.toggleOption = _this.toggleOption.bind(_this);
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handlePermittedItem = _this.handlePermittedItem.bind(_this);
	    _this.handleProctorTypeInput = _this.handleProctorTypeStatusInput.bind(_this);
	    _this.subKeyIndex = _this.subKeyIndex.bind(_this);
	    _this.renderApproveOption = _this.renderApproveOption.bind(_this);
	    _this.renderProctorTypesEnabled = _this.renderProctorTypesEnabled.bind(_this);
	    _this.renderProctorTypesDisabled = _this.renderProctorTypesDisabled.bind(_this);
	    _this.renderReconnectionFields = _this.renderReconnectionFields.bind(_this);
	    _this.renderSessionConfigurationDropdown = _this.renderSessionConfigurationDropdown.bind(_this);
	    _this.renderModalityPresetDropdown = _this.renderModalityPresetDropdown.bind(_this);
	    _this.handleSessionConfigurationInput = _this.handleSessionConfigurationInput.bind(_this);
	    _this.handleModalityPresetInput = _this.handleModalityPresetInput.bind(_this);
	    _this.handleReconnectionInput = _this.handleReconnectionInput.bind(_this);
	    _this.subCategories = {};
	    return _this;
	  }
	
	  _createClass(InstitutionSettings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          AdminStore = _props$store.AdminStore,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	
	
	      SessionStore.getTimezones();
	      SessionStore.getCurrencies();
	      SessionStore.getSessionConfigurations();
	      SessionStore.getProctorTypes();
	      ExamStore.getModalityPresets();
	      AdminStore.getCourseOfferings();
	      SettingsStore.getInstituteSettings(this);
	
	      this.state = {
	        settings: {
	          facialProcessing: '',
	          timeZone: '',
	          defaultCurrencyCode: '',
	          proctorTypes: [],
	          examNotes: '',
	          requireManagerProctorApproval: false,
	          requireManagerExamApproval: false,
	          hidePermittedItemFields: [],
	          pauseForProctorReview: false
	        },
	        activeTab: 1
	
	        // Select tab if present in url
	      };var urlTab = 1;
	
	      switch ((0, _helpers.getURLSegment)(this, 3)) {
	        case 'exams':
	          urlTab = 2;
	          break;
	
	        case 'proctors':
	          urlTab = 3;
	          break;
	
	        default:
	          urlTab = 1;
	      }
	
	      this.setState({
	        activeTab: urlTab
	      });
	    }
	  }, {
	    key: 'handleTabs',
	    value: function handleTabs(index) {
	      this.setState({
	        activeTab: index + 1
	      });
	
	      // Update url
	      var newPath = '/settings/institution/general';
	
	      switch (index + 1) {
	        case 2:
	          newPath = '/settings/institution/exams';
	          break;
	
	        case 3:
	          newPath = '/settings/institution/proctors';
	          break;
	
	        default:
	          newPath = '/settings/institution/general';
	      }
	
	      this.props.routing.push(newPath);
	    }
	  }, {
	    key: 'toggleOption',
	    value: function toggleOption(e, key) {
	      var settings = Object.assign({}, this.state.settings);
	
	      if (e.target.value === 'false') {
	        settings[key] = false;
	      } else {
	        settings[key] = true;
	      }
	
	      this.setState({
	        settings: settings
	      });
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(e) {
	      var settings = Object.assign({}, this.state.settings);
	
	      settings.defaultTimezone = this.defaultTimezone.value || '';
	      settings.defaultCurrencyCode = this.defaultCurrencyCode.value || '';
	      settings.examNotes = this.examNotes.value || '';
	      settings.enableWrittenExams = this.enableWrittenExams.checked;
	      settings.defaultCourseOfferingSid = this.defaultCourseOfferingSid.value || '';
	      settings.pauseForProctorReview = this.pauseForProctorReview.checked;
	      //settings.facialProcessing = this.facialProcessing.checked;
	
	      //Temporary fix while facialProcessing is just a toggle
	      settings.facialProcessing = this.facialProcessing.checked ? 'detection' : 'off';
	
	      if (this.defaultNewExamType) {
	        settings.defaultNewExamType = this.defaultNewExamType.value || '';
	      }
	
	      this.setState({
	        settings: settings
	      });
	    }
	  }, {
	    key: 'handlePermittedItem',
	    value: function handlePermittedItem(e, item) {
	      var settings = Object.assign({}, this.state.settings);
	
	      if (e.target.checked) {
	        // Show item and remove from array
	        var index = settings.hidePermittedItemFields.indexOf(item);
	        settings.hidePermittedItemFields.splice(index, 1);
	      } else {
	        // Hide item and add to array
	        settings.hidePermittedItemFields.push(item);
	      }
	
	      this.setState({
	        settings: settings
	      });
	    }
	  }, {
	    key: 'handleProctorTypeStatusInput',
	    value: function handleProctorTypeStatusInput(e, subKeySid) {
	      var settings = Object.assign({}, this.state.settings);
	      var index = this.subKeyIndex(subKeySid);
	      if (~index) {
	        settings.proctorTypes[index].status = e.target.value;
	      } else {
	        settings.proctorTypes.push({
	          status: e.target.value,
	          proctorTypeSubCategorySid: subKeySid,
	          automaticallyApprove: true
	        });
	      }
	      this.setState({
	        settings: settings
	      });
	    }
	  }, {
	    key: 'handleProctorTypeApproveInput',
	    value: function handleProctorTypeApproveInput(e, index) {
	      var settings = Object.assign({}, this.state.settings);
	      settings.proctorTypes[index].automaticallyApprove = e.target.checked;
	
	      this.setState({
	        settings: settings
	      });
	    }
	  }, {
	    key: 'handleReconnectionInput',
	    value: function handleReconnectionInput(e, subKeySid, fieldName) {
	      var settings = Object.assign({}, this.state.settings);
	      var index = this.subKeyIndex(subKeySid);
	
	      if (~index) {
	        settings.proctorTypes[index][fieldName] = parseInt(e.target.value, 10) || null;
	      } else {
	        var newProctorType = {
	          status: 'disabled',
	          proctorTypeSubCategorySid: subKeySid,
	          automaticallyApprove: true
	        };
	        newProctorType[fieldName] = parseInt(e.target.value, 10) || null;
	        settings.proctorTypes.push(newProctorType);
	      }
	
	      this.setState({
	        settings: settings
	      });
	    }
	  }, {
	    key: 'handleModalityPresetInput',
	    value: function handleModalityPresetInput(e, subKeySid) {
	      var settings = Object.assign({}, this.state.settings);
	      var index = this.subKeyIndex(subKeySid);
	
	      if (~index) {
	        if (settings.proctorTypes[index].status === 'disabled') {
	          settings.proctorTypes[index].modalityOptionPresetSid = null;
	        } else {
	          settings.proctorTypes[index].modalityOptionPresetSid = e.target.value || null;
	        }
	      } else {
	        settings.proctorTypes.push({
	          status: 'disabled',
	          proctorTypeSubCategorySid: subKeySid,
	          automaticallyApprove: true,
	          modalityOptionPresetSid: null
	        });
	      }
	
	      this.setState({ settings: settings });
	    }
	  }, {
	    key: 'handleSessionConfigurationInput',
	    value: function handleSessionConfigurationInput(e, subKeySid) {
	      var settings = Object.assign({}, this.state.settings);
	      var index = this.subKeyIndex(subKeySid);
	
	      if (~index) {
	
	        if (settings.proctorTypes[index].status === 'disabled') {
	          settings.proctorTypes[index].sessionConfigurationSid = null;
	        } else {
	          // If enabled, proceed with setting the session configuration
	          settings.proctorTypes[index].sessionConfigurationSid = e.target.value || null;
	        }
	      } else {
	        var newProctorType = {
	          status: 'disabled',
	          proctorTypeSubCategorySid: subKeySid,
	          automaticallyApprove: true,
	          sessionConfigurationSid: null
	        };
	        settings.proctorTypes.push(newProctorType);
	      }
	
	      this.setState({
	        settings: settings
	      });
	    }
	  }, {
	    key: 'subKeyIndex',
	    value: function subKeyIndex(subKeySid) {
	      for (var i = 0; i < this.state.settings.proctorTypes.length; i++) {
	        if (this.state.settings.proctorTypes[i].proctorTypeSubCategorySid === subKeySid) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }, {
	    key: 'renderApproveOption',
	    value: function renderApproveOption(index, translation, disabled) {
	      var _this2 = this;
	
	      if (~index && this.state.settings.proctorTypes[index].status !== 'disabled') {
	        var proctorType = this.state.settings.proctorTypes[index];
	        return _react2.default.createElement(
	          'div',
	          { className: 'switch-list__option' },
	          _react2.default.createElement(
	            'label',
	            {
	              htmlFor: proctorType.proctorTypeSubCategorySid + '-auto'
	            },
	            translation.proctor_types.options.auto_approve
	          ),
	          disabled && _react2.default.createElement('input', {
	            type: 'checkbox',
	            id: proctorType.proctorTypeSubCategorySid + '-auto',
	            className: 'switch-input',
	            value: proctorType.automaticallyApprove ? "1" : "0",
	            checked: proctorType.automaticallyApprove,
	            disabled: true
	          }),
	          !disabled && _react2.default.createElement('input', {
	            type: 'checkbox',
	            id: proctorType.proctorTypeSubCategorySid + '-auto',
	            className: 'switch-input',
	            value: proctorType.automaticallyApprove ? "1" : "0",
	            checked: proctorType.automaticallyApprove,
	            onChange: function onChange(e) {
	              return _this2.handleProctorTypeApproveInput(e, index);
	            },
	            onKeyDown: _helpers.handleSwitchInputKeys
	          }),
	          _react2.default.createElement(
	            'label',
	            {
	              className: 'switch-label',
	              htmlFor: proctorType.proctorTypeSubCategorySid + '-auto'
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.proctor_types.options.auto_approve
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderReconnectionFields',
	    value: function renderReconnectionFields(index, subKeySid, proctorType, sessionConfigurationType, translation) {
	      var _this3 = this;
	
	      // Return early if index is invalid
	      if (!~index) {
	        return null;
	      }
	
	      var currentProctorType = this.state.settings.proctorTypes[index];
	
	      // Safety check: ensure currentProctorType exists
	      if (!currentProctorType) {
	        return null;
	      }
	
	      // Only show if proctor type status is not 'disabled'
	      if (currentProctorType.status === 'disabled') {
	        return null;
	      }
	
	      // Check if there are session configurations for this subtype
	      if (sessionConfigurationType && sessionConfigurationType[subKeySid] && sessionConfigurationType[subKeySid].length > 0) {
	
	        var renderReconnectionField = function renderReconnectionField(fieldName, subKeySid, currentProctorType, translation, config) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'switch-list__option', key: fieldName },
	            _react2.default.createElement(
	              'label',
	              { htmlFor: subKeySid + '-' + config.idSuffix },
	              config.label,
	              config.tooltip_text && _react2.default.createElement(
	                'div',
	                { className: 'tooltip' },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    className: 'tooltip__label',
	                    role: 'presentation',
	                    'aria-hidden': 'true'
	                  },
	                  '(?)'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    id: 'course-offering',
	                    className: 'tooltip__body',
	                    role: 'tooltip'
	                  },
	                  config.tooltip_text
	                )
	              )
	            ),
	            _react2.default.createElement('input', {
	              type: 'number',
	              id: subKeySid + '-' + config.idSuffix,
	              min: '0',
	              value: currentProctorType[fieldName] || '',
	              onChange: function onChange(e) {
	                return _this3.handleReconnectionInput(e, subKeySid, fieldName);
	              }
	            })
	          );
	        };
	
	        // Configuration for reconnection fields
	        var reconnectionFieldConfigs = [{
	          fieldName: 'maxReconnectionAttempts',
	          idSuffix: 'max-reconnection',
	          label: translation.proctor_types.reconnection.max_attempts,
	          tooltip_text: translation.proctor_types.reconnection.max_attempts_tooltip
	        }, {
	          fieldName: 'reconnectionInSessionLockoutPeriod',
	          idSuffix: 'in-session-lockout',
	          label: translation.proctor_types.reconnection.in_session_lockout,
	          tooltip_text: translation.proctor_types.reconnection.in_session_lockout_tooltip
	        }, {
	          fieldName: 'reconnectionLockoutPeriod',
	          idSuffix: 'lockout-period',
	          label: translation.proctor_types.reconnection.lockout_period,
	          tooltip_text: translation.proctor_types.reconnection.lockout_period_tooltip
	        }];
	
	        var fields = reconnectionFieldConfigs.map(function (config) {
	          return renderReconnectionField(config.fieldName, subKeySid, currentProctorType, translation, config);
	        });
	
	        return fields.length > 0 ? fields : null;
	      }
	      return null;
	    }
	  }, {
	    key: 'renderSessionConfigurationDropdown',
	    value: function renderSessionConfigurationDropdown(subKeySid, sessionConfigurationType, translation) {
	      var _this4 = this;
	
	      var index = this.subKeyIndex(subKeySid);
	
	      // Return early if index is invalid
	      if (!~index) {
	        return null;
	      }
	
	      var currentProctorType = this.state.settings.proctorTypes[index];
	
	      // Safety check: ensure currentProctorType exists
	      if (!currentProctorType) {
	        return null;
	      }
	
	      // Only show if proctor type status is not 'disabled'
	      if (currentProctorType.status === 'disabled') {
	        return null;
	      }
	
	      // Check if there are session configurations for this subtype
	      if (sessionConfigurationType && sessionConfigurationType[subKeySid] && sessionConfigurationType[subKeySid].length > 0) {
	        var configurations = sessionConfigurationType[subKeySid];
	        var currentSessionConfigSid = currentProctorType.sessionConfigurationSid || '';
	
	        // Set default to first configuration if none is selected
	        if (!currentSessionConfigSid && configurations.length > 0) {
	          currentSessionConfigSid = configurations[0].sid;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'switch-list__option session-configuration-dropdown' },
	          _react2.default.createElement(
	            'label',
	            { htmlFor: subKeySid + '-session-config' },
	            translation.proctor_types.session_configuration,
	            _react2.default.createElement(
	              'div',
	              { className: 'tooltip' },
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'tooltip__label',
	                  role: 'presentation',
	                  'aria-hidden': 'true'
	                },
	                '(?)'
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  id: 'session-configuration-tooltip',
	                  className: 'tooltip__body',
	                  role: 'tooltip'
	                },
	                translation.proctor_types.session_configuration_tooltip
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            { className: 'select', htmlFor: subKeySid + '-session-config' },
	            _react2.default.createElement(
	              'select',
	              {
	                id: subKeySid + '-session-config',
	                ref: function ref(input) {
	                  _this4.sessionConfigurations = _this4.sessionConfigurations || {};_this4.sessionConfigurations['' + subKeySid] = input;
	                },
	                onChange: function onChange(e) {
	                  return _this4.handleSessionConfigurationInput(e, subKeySid);
	                },
	                value: currentSessionConfigSid
	              },
	              configurations.map(function (config) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: config.sid, value: config.sid },
	                  config.name
	                );
	              })
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderModalityPresetDropdown',
	    value: function renderModalityPresetDropdown(subKeySid, translation) {
	      var _this5 = this;
	
	      var REMOTE_PROCTOR_TYPE_SIDS = ['TS4b894875d26194988853e490dfb9bc41', 'TS6d6011935f4646848ea4f7a29b4f61a5', 'TS9531c6b112f145018dae3cd2a9f60c4c', 'TS63dda27a6ba54c218449b934b7bb1ba8'];
	
	      if (!REMOTE_PROCTOR_TYPE_SIDS.includes(subKeySid)) {
	        return null;
	      }
	
	      var index = this.subKeyIndex(subKeySid);
	
	      if (!~index) {
	        return null;
	      }
	
	      var currentProctorType = this.state.settings.proctorTypes[index];
	
	      if (!currentProctorType || currentProctorType.status === 'disabled') {
	        return null;
	      }
	
	      var ExamStore = this.props.store.ExamStore;
	
	      var presets = ExamStore.modalityPresets || [];
	      var currentPresetSid = currentProctorType.modalityOptionPresetSid || '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'switch-list__option session-configuration-dropdown' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: subKeySid + '-modality-preset' },
	          translation.proctor_types.modality_preset
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'select', htmlFor: subKeySid + '-modality-preset' },
	          _react2.default.createElement(
	            'select',
	            {
	              id: subKeySid + '-modality-preset',
	              onChange: function onChange(e) {
	                return _this5.handleModalityPresetInput(e, subKeySid);
	              },
	              value: currentPresetSid,
	              required: currentProctorType.status === 'enabled' || currentProctorType.status === 'required' || currentProctorType.status === 'enabled-default'
	            },
	            _react2.default.createElement(
	              'option',
	              { value: '' },
	              translation.proctor_types.select_preset
	            ),
	            presets.map(function (preset) {
	              return _react2.default.createElement(
	                'option',
	                { key: preset.sid, value: preset.sid },
	                preset.title
	              );
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var settings = Object.assign({}, this.state.settings);
	
	      if (settings.sid) {
	        delete settings.sid;
	      }
	
	      if (settings.createdDate) {
	        delete settings.createdDate;
	      }
	
	      if (settings.editDate) {
	        delete settings.editDate;
	      }
	
	      var REMOTE_PROCTOR_TYPE_SIDS = ['TS4b894875d26194988853e490dfb9bc41', 'TS6d6011935f4646848ea4f7a29b4f61a5', 'TS9531c6b112f145018dae3cd2a9f60c4c', 'TS63dda27a6ba54c218449b934b7bb1ba8'];
	
	      var fieldsToCleanup = ['sessionConfigurationSid', 'modalityOptionPresetSid', 'maxReconnectionAttempts', 'reconnectionLockoutPeriod', 'reconnectionInSessionLockoutPeriod'];
	
	      var _loop = function _loop(i) {
	        if (settings.proctorTypes[i].sid) delete settings.proctorTypes[i].sid;
	
	        fieldsToCleanup.forEach(function (field) {
	          if (settings.proctorTypes[i][field] === null || settings.proctorTypes[i][field] === undefined) {
	            delete settings.proctorTypes[i][field];
	          }
	        });
	
	        if (settings.proctorTypes[i].status === 'disabled') {
	          delete settings.proctorTypes[i].maxReconnectionAttempts;
	          delete settings.proctorTypes[i].reconnectionLockoutPeriod;
	          delete settings.proctorTypes[i].reconnectionInSessionLockoutPeriod;
	          delete settings.proctorTypes[i].modalityOptionPresetSid;
	        }
	
	        // Remove modalityOptionPresetSid for non-remote proctor types
	        if (!REMOTE_PROCTOR_TYPE_SIDS.includes(settings.proctorTypes[i].proctorTypeSubCategorySid)) {
	          delete settings.proctorTypes[i].modalityOptionPresetSid;
	        }
	      };
	
	      for (var i = 0; i < settings.proctorTypes.length; i++) {
	        _loop(i);
	      }
	
	      // The API returns defaultNewExamType as lowercase
	      // but requires it as capitalized………………
	      if (settings.defaultNewExamType) {
	        settings.defaultNewExamType = settings.defaultNewExamType[0].toUpperCase() + settings.defaultNewExamType.substring(1);
	      }
	
	      // If written is disabled, set defaultNewExamType to Online
	      if (!settings.enableWrittenExams) {
	        settings.defaultNewExamType = 'Online';
	      }
	
	      this.props.store.SettingsStore.putInstituteSettings(settings, this, this.complete);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      this.props.store.SessionStore.showToaster(this.props.translation.settings_saved, 'success');
	    }
	  }, {
	    key: 'renderProctorTypesEnabled',
	    value: function renderProctorTypesEnabled() {
	      var _this6 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var settings = this.props.store.SettingsStore.settings;
	
	      var proctorTypes = {};
	
	      if (settings.proctorTypes) settings.proctorTypes.forEach(function (proctorType) {
	        if (proctorType.proctorTypeSubCategorySid) {
	          proctorTypes[proctorType.proctorTypeSubCategorySid] = proctorType;
	        }
	      });
	
	      var sessionConfigurationType = {};
	
	      if (SessionStore.sessionConfigurations) {
	        SessionStore.sessionConfigurations.forEach(function (config) {
	          var subTypeSid = config.subCategoryType && config.subCategoryType.sid;
	          if (subTypeSid) {
	            sessionConfigurationType[subTypeSid] = sessionConfigurationType[subTypeSid] || [];
	            sessionConfigurationType[subTypeSid].push(config);
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        'fieldset',
	        { className: 'form-section' },
	        SessionStore.proctorTypeList.map(function (key, i) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'form-subgroup', key: i },
	            _react2.default.createElement(
	              'strong',
	              { className: 'form-subheading proctor-type-heading' },
	              key.title
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'switch-list switch-list--wrap' },
	              key.subCategories.map(function (subKey, j) {
	                return _react2.default.createElement(
	                  'li',
	                  { className: 'proctor-type-subcategory', key: j },
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      htmlFor: subKey.sid, className: 'proctor-type-subcategory-label' },
	                    subKey.title
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select', htmlFor: key.sid },
	                    _react2.default.createElement(
	                      'select',
	                      { id: subKey.sid,
	                        ref: function ref(input) {
	                          _this6.subCategories['' + subKey.sid] = input;
	                        },
	                        onChange: function onChange(e) {
	                          return _this6.handleProctorTypeStatusInput(e, subKey.sid);
	                        },
	                        defaultValue: proctorTypes[subKey.sid] ? proctorTypes[subKey.sid].status : 'disabled'
	                      },
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'disabled' },
	                        translation.proctor_types.options.disabled
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'enabled' },
	                        translation.proctor_types.options.enabled
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'enabled-default' },
	                        translation.proctor_types.options.enabled_default
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'required' },
	                        translation.proctor_types.options.required
	                      )
	                    )
	                  ),
	                  //this.subKeyIndex(subKey.sid) !== -1 &&
	                  _this6.renderApproveOption(_this6.subKeyIndex(subKey.sid), translation),
	                  _this6.renderModalityPresetDropdown(subKey.sid, translation),
	                  _this6.renderSessionConfigurationDropdown(subKey.sid, sessionConfigurationType, translation),
	                  _this6.renderReconnectionFields(_this6.subKeyIndex(subKey.sid), subKey.sid, proctorTypes[subKey.sid], sessionConfigurationType, translation)
	                );
	              })
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderProctorTypesDisabled',
	    value: function renderProctorTypesDisabled() {
	      var _this7 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var settings = this.props.store.SettingsStore.settings;
	
	      var proctorTypes = {};
	
	      if (settings.proctorTypes) settings.proctorTypes.forEach(function (proctorType) {
	        if (proctorType.proctorTypeSubCategorySid) {
	          proctorTypes[proctorType.proctorTypeSubCategorySid] = proctorType;
	        }
	      });
	
	      return _react2.default.createElement(
	        'fieldset',
	        { className: 'form-section' },
	        _react2.default.createElement(
	          'p',
	          { className: 'note note--prominent' },
	          translation.proctor_types.disabled
	        ),
	        SessionStore.proctorTypeList.map(function (key, i) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'form-subgroup', key: i },
	            _react2.default.createElement(
	              'strong',
	              { className: 'form-subheading' },
	              key.title
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'switch-list switch-list--wrap' },
	              key.subCategories.map(function (subKey, j) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: j },
	                  _react2.default.createElement(
	                    'label',
	                    { htmlFor: subKey.sid },
	                    subKey.title
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select', htmlFor: key.sid },
	                    _react2.default.createElement(
	                      'select',
	                      { id: subKey.sid,
	                        ref: function ref(input) {
	                          _this7.subCategories['' + subKey.sid] = input;
	                        },
	                        defaultValue: proctorTypes[subKey.sid] ? proctorTypes[subKey.sid].status : 'disabled',
	                        disabled: true
	                      },
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'disabled' },
	                        translation.proctor_types.options.disabled
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'enabled' },
	                        translation.proctor_types.options.enabled
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'required' },
	                        translation.proctor_types.options.required
	                      )
	                    )
	                  ),
	                  //this.subKeyIndex(subKey.sid) !== -1 &&
	                  _this7.renderApproveOption(_this7.subKeyIndex(subKey.sid), translation, true)
	                );
	              })
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          AdminStore = _props$store2.AdminStore,
	          SessionStore = _props$store2.SessionStore;
	
	      // Don’t use the default tab styles
	
	      _reactTabs.Tabs.setUseDefaultStyles(false);
	
	      if (SessionStore.loadingCalls.indexOf('InstitutionSettings') < 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form' },
	          _react2.default.createElement(
	            'form',
	            { className: 'panel', onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this8.handleSubmit);
	              }, noValidate: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__header' },
	              _react2.default.createElement(
	                'h3',
	                { className: 'panel__title' },
	                _react2.default.createElement(
	                  'legend',
	                  null,
	                  translation.heading
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__body' },
	              _react2.default.createElement(
	                _reactTabs.Tabs,
	                {
	                  onSelect: this.handleTabs,
	                  forceRenderTabPanel: true,
	                  selectedIndex: this.state.activeTab - 1
	                },
	                _react2.default.createElement(
	                  _reactTabs.TabList,
	                  { className: 'tabs-enabled' },
	                  _react2.default.createElement(
	                    _reactTabs.Tab,
	                    null,
	                    translation.general
	                  ),
	                  _react2.default.createElement(
	                    _reactTabs.Tab,
	                    null,
	                    translation.exam
	                  ),
	                  _react2.default.createElement(
	                    _reactTabs.Tab,
	                    null,
	                    translation.proctor_types.heading
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactTabs.TabPanel,
	                  null,
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'meta' },
	                    translation.general
	                  ),
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: 'form-section' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'settings-timezone'
	                          },
	                          translation.timezone.label
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'select',
	                            htmlFor: 'settings-timezone'
	                          },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'settings-timezone',
	                              required: true,
	                              'aria-required': 'true',
	                              ref: function ref(input) {
	                                _this8.defaultTimezone = input;
	                              },
	                              value: this.state.settings.defaultTimezone,
	                              onChange: function onChange(e) {
	                                return _this8.handleInput(e);
	                              }
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.timezone.helper
	                            ),
	                            SessionStore.timezoneList.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.sid },
	                                key.name
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'settings-currency'
	                          },
	                          translation.currency.label
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'select',
	                            htmlFor: 'settings-currency'
	                          },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'settings-currency',
	                              required: true,
	                              'aria-required': 'true',
	                              ref: function ref(input) {
	                                _this8.defaultCurrencyCode = input;
	                              },
	                              value: this.state.settings.defaultCurrencyCode,
	                              onChange: function onChange(e) {
	                                return _this8.handleInput(e);
	                              }
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.currency.helper
	                            ),
	                            SessionStore.currencyList.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.code },
	                                key.name
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'settings-course-offering',
	                            'aria-describedby': 'course-offering-tooltip'
	                          },
	                          translation.course_offering.label,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tooltip' },
	                            _react2.default.createElement(
	                              'span',
	                              {
	                                className: 'tooltip__label',
	                                role: 'presentation',
	                                'aria-hidden': 'true'
	                              },
	                              '(?)'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                id: 'course-offering',
	                                className: 'tooltip__body',
	                                role: 'tooltip'
	                              },
	                              translation.course_offering.tooltip
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'select',
	                            htmlFor: 'settings-course-offering'
	                          },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'settings-course-offering',
	                              ref: function ref(input) {
	                                _this8.defaultCourseOfferingSid = input;
	                              },
	                              value: this.state.settings.defaultCourseOfferingSid || '',
	                              onChange: function onChange(e) {
	                                return _this8.handleInput(e);
	                              }
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.course_offering.helper
	                            ),
	                            AdminStore.courseOfferings.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.sid },
	                                key.title
	                              );
	                            })
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactTabs.TabPanel,
	                  null,
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'meta' },
	                    translation.exam
	                  ),
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: 'form-section' },
	                    _react2.default.createElement(
	                      'strong',
	                      { className: 'form-section__heading' },
	                      translation.written_exams.heading
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'checkbox',
	                          id: 'enable-written',
	                          className: 'switch-input',
	                          ref: function ref(input) {
	                            return _this8.enableWrittenExams = input;
	                          },
	                          value: true,
	                          defaultChecked: this.state.settings.enableWrittenExams,
	                          onChange: function onChange(e) {
	                            return _this8.handleInput(e);
	                          },
	                          onKeyDown: _helpers.handleSwitchInputKeys
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'switch-label',
	                            htmlFor: 'enable-written'
	                          },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            translation.enable_written.label
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'switch-label--alt',
	                            htmlFor: 'enable-written',
	                            'aria-describedby': 'enable-written-tooltip'
	                          },
	                          translation.enable_written.label,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tooltip' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'tooltip__label' },
	                              '(?)'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'enable-written-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                              translation.enable_written.tooltip
	                            )
	                          )
	                        )
	                      ),
	                      this.state.settings.enableWrittenExams && _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'exam-type' },
	                          translation.exam_type.label
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select', htmlFor: 'exam-type' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'exam-type',
	                              ref: function ref(input) {
	                                return _this8.defaultNewExamType = input;
	                              },
	                              defaultValue: this.state.settings.defaultNewExamType,
	                              required: true,
	                              'aria-required': 'true',
	                              onChange: function onChange(e) {
	                                return _this8.handleInput(e);
	                              }
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'online' },
	                              translation.exam_type.online
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: 'written' },
	                              translation.exam_type.written
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: 'form-section' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'field--separator' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-optional', htmlFor: 'settings-exam-notes', 'aria-describedby': 'exam-notes-tooltip' },
	                          translation.exam_notes.label,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'tooltip' },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                              '(?)'
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { id: 'exam-notes-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                              translation.exam_notes.tooltip
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(_reactTextareaAutosize2.default, {
	                          id: 'settings-exam-notes',
	                          className: 'textarea-grow',
	                          onChange: function onChange(e) {
	                            return _this8.handleInput(e);
	                          },
	                          ref: function ref(input) {
	                            _this8.examNotes = input;
	                          },
	                          value: this.state.settings.examNotes || '' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: 'form-section' },
	                    _react2.default.createElement(
	                      'strong',
	                      { className: 'form-section__heading' },
	                      translation.permitted_items.label,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'exam-notes-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                          translation.permitted_items.helper
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'switch-list' },
	                      Object.keys(translation.permitted_items.options).map(function (key) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: key },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: key },
	                            translation.permitted_items.options[key]
	                          ),
	                          _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            id: key,
	                            className: 'switch-input',
	                            onChange: function onChange(e) {
	                              return _this8.handlePermittedItem(e, key);
	                            },
	                            onKeyDown: _helpers.handleSwitchInputKeys,
	                            defaultChecked: _this8.state.settings.hidePermittedItemFields.indexOf(key) < 0
	                          }),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'switch-label', htmlFor: key },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              translation.permitted_items.options[key]
	                            )
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: 'form-section' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required' },
	                          translation.exam_approval.label
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          name: 'examApproval[]',
	                          id: 'settings-exam-approval-01',
	                          value: true,
	                          checked: this.state.settings.requireManagerExamApproval,
	                          onChange: function onChange(e) {
	                            _this8.toggleOption(e, 'requireManagerExamApproval');
	                          },
	                          required: true,
	                          'aria-required': 'true'
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'radio-alt', htmlFor: 'settings-exam-approval-01' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            translation.exam_approval.yes
	                          ),
	                          '\u2013',
	                          translation.exam_approval.yes_body
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          name: 'examApproval[]',
	                          id: 'settings-exam-approval-02',
	                          value: false,
	                          checked: !this.state.settings.requireManagerExamApproval,
	                          onChange: function onChange(e) {
	                            _this8.toggleOption(e, 'requireManagerExamApproval');
	                          },
	                          required: true,
	                          'aria-required': 'true'
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'radio-alt', htmlFor: 'settings-exam-approval-02' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            translation.exam_approval.no
	                          ),
	                          '\u2013',
	                          translation.exam_approval.no_body
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required' },
	                          translation.proctor_approval.label
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          name: 'adminApproval[]',
	                          id: 'settings-proctor-approval-01',
	                          value: true,
	                          checked: this.state.settings.requireManagerProctorApproval,
	                          onChange: function onChange(e) {
	                            _this8.toggleOption(e, 'requireManagerProctorApproval');
	                          },
	                          required: true,
	                          'aria-required': 'true'
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'radio-alt', htmlFor: 'settings-proctor-approval-01' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            translation.proctor_approval.yes
	                          ),
	                          '\u2013',
	                          translation.proctor_approval.yes_body
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'radio',
	                          name: 'adminApproval[]',
	                          id: 'settings-proctor-approval-02',
	                          value: false,
	                          checked: !this.state.settings.requireManagerProctorApproval,
	                          onChange: function onChange(e) {
	                            _this8.toggleOption(e, 'requireManagerProctorApproval');
	                          },
	                          required: true,
	                          'aria-required': 'true'
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'radio-alt', htmlFor: 'settings-proctor-approval-02' },
	                          _react2.default.createElement(
	                            'strong',
	                            null,
	                            translation.proctor_approval.no
	                          ),
	                          '\u2013',
	                          translation.proctor_approval.no_body
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'form-section' },
	                        _react2.default.createElement(
	                          'strong',
	                          { className: 'form-section__heading' },
	                          translation.AI.heading
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'checkbox',
	                          id: 'ai-toggle',
	                          defaultChecked: this.state.settings.facialProcessing && this.state.settings.facialProcessing !== 'off',
	                          ref: function ref(input) {
	                            return _this8.facialProcessing = input;
	                          },
	                          className: 'switch-input',
	                          onKeyDown: _helpers.handleSwitchInputKeys,
	                          onChange: function onChange(e) {
	                            return _this8.handleInput(e);
	                          }
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'switch-label', htmlFor: 'ai-toggle' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            translation.AI.label
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'switch-label--alt', htmlFor: 'ai-toggle' },
	                          translation.AI.label
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement('input', {
	                          type: 'checkbox',
	                          defaultChecked: this.state.settings.pauseForProctorReview,
	                          id: 'student-verification',
	                          ref: function ref(input) {
	                            return _this8.pauseForProctorReview = input;
	                          },
	                          className: 'switch-input',
	                          onKeyDown: _helpers.handleSwitchInputKeys,
	                          onChange: function onChange(e) {
	                            return _this8.handleInput(e);
	                          }
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'switch-label',
	                            htmlFor: 'student-verification'
	                          },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            translation.student_verification
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'switch-label--alt',
	                            htmlFor: 'student-verification'
	                          },
	                          translation.student_verification
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactTabs.TabPanel,
	                  null,
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'meta' },
	                    translation.proctor_types.heading
	                  ),
	                  _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                    flagKey: 'institution-proctor-types',
	                    renderFeatureCallback: this.renderProctorTypesEnabled,
	                    renderDefaultCallback: this.renderProctorTypesDisabled
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel__actions actions' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary',
	                    type: 'submit'
	                  },
	                  translation.save
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return InstitutionSettings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('InstitutionSettings')(InstitutionSettings);

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _reactQuill = __webpack_require__(575);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	var _reactSortableHoc = __webpack_require__(1380);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ProctorGroups = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProctorGroups, _React$Component);
	
	  function ProctorGroups() {
	    var _this3 = this;
	
	    _classCallCheck(this, ProctorGroups);
	
	    var _this2 = _possibleConstructorReturn(this, (ProctorGroups.__proto__ || Object.getPrototypeOf(ProctorGroups)).call(this));
	
	    _this2.sortGroups = function (_ref) {
	      var oldIndex = _ref.oldIndex,
	          newIndex = _ref.newIndex;
	
	      _this2.setState({
	        groups: (0, _reactSortableHoc.arrayMove)(_this2.state.groups, oldIndex, newIndex)
	      });
	    };
	
	    _this2.DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
	      var translation = _this2.props.translation;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'draggable__handle' },
	        _react2.default.createElement(
	          'span',
	          { className: 'draggable__handle__tooltip' },
	          translation.reorder
	        )
	      );
	    });
	    _this2.SortableItem = (0, _reactSortableHoc.SortableElement)(function (props) {
	      var i = props.i,
	          value = props.value,
	          onInputChange = props.onInputChange;
	      var translation = _this2.props.translation;
	      var SessionStore = _this2.props.store.SessionStore;
	
	
	      function subCategoryLength(subCategories) {
	        var enabledSubcategories = subCategories.filter(function (subCategory) {
	          return subCategory.status !== 'disabled';
	        });
	
	        if (enabledSubcategories.length > 0) {
	          return true;
	        }
	
	        return false;
	      }
	
	      // Quill text editor toolbar options
	      var modules = {
	        toolbar: [['bold', 'italic', 'underline'], [{ 'list': 'bullet' }, { 'list': 'ordered' }]]
	      };
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'draggable-element' },
	        _react2.default.createElement(
	          'div',
	          { className: 'block-list__block media--alt proctor-group draggable' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields proctor-group__icon' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-required', htmlFor: 'group' + i + '-icon' },
	                translation.icon.label
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    id: 'group' + i + '-icon',
	                    value: value.icon,
	                    onChange: function onChange(e) {
	                      _this2.updateIcon(e, i);
	                    },
	                    ref: function ref(input) {
	                      _this2['icon' + i] = input;
	                    },
	                    required: true,
	                    'aria-required': 'true'
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    translation.icon.helper
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'person' },
	                    translation.icon.options.person
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'instructor' },
	                    translation.icon.options.instructor
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'attended' },
	                    translation.icon.options.attended_virtual
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'unattended' },
	                    translation.icon.options.unattended_virtual
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'testing_centers' },
	                    translation.icon.options.building
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'testing_centers_individuals' },
	                    translation.icon.options.building_person
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'examity' },
	                    translation.icon.options.examity
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'proctoru' },
	                    translation.icon.options.proctoru
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _this2.renderIcon(value.icon)
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                {
	                  className: 'lbl-required',
	                  htmlFor: 'group' + i + '-workflow'
	                },
	                translation.workflow.label
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    id: 'group' + i + '-workflow',
	                    value: value.workflowModule,
	                    onChange: function onChange(e) {
	                      return onInputChange(e.target.value, i, 'workflowModule');
	                    }
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    translation.workflow.helper
	                  ),
	                  Object.keys(translation.workflow.options).map(function (key) {
	                    return _react2.default.createElement(
	                      'option',
	                      { value: key },
	                      translation.workflow.options[key]
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'media__copy' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'group' + i + '-title' },
	                  translation.title
	                ),
	                _react2.default.createElement('input', {
	                  id: 'group' + i + '-title',
	                  type: 'text',
	                  value: value.title,
	                  ref: function ref(input) {
	                    _this2['title' + i] = input;
	                  },
	                  onChange: function onChange(e) {
	                    return onInputChange(e.target.value, i, 'title');
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                { key: value.sid },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'group' + i + '-description' },
	                  translation.description
	                ),
	                _react2.default.createElement(_reactQuill2.default, {
	                  modules: modules,
	                  value: value.description,
	                  onChange: function onChange(e) {
	                    return onInputChange(e, i, 'description');
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'group' + i + '-button' },
	                  translation.button_text
	                ),
	                _react2.default.createElement('input', {
	                  id: 'group' + i + '-button',
	                  type: 'text',
	                  value: value.buttonText || translation.default_button_text,
	                  ref: function ref(input) {
	                    _this2['buttonText{i}'] = input;
	                  },
	                  onChange: function onChange(e) {
	                    return onInputChange(e.target.value, i, 'buttonText');
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                })
	              ),
	              value.workflowModule !== 'hybrid-tiered-scheduling' && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'group' + i + '-approved', 'aria-describedby': 'suggest-times-tooltip' },
	                  translation.only_approved.label,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip tooltip--right' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'suggest-times-tooltip', className: 'tooltip__body',
	                        role: 'tooltip' },
	                      translation.only_approved.tooltip
	                    )
	                  )
	                ),
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  id: 'group' + i + '-approved',
	                  className: 'switch-input',
	                  checked: value.includeOnlyApproved,
	                  onKeyDown: _helpers.handleSwitchInputKeys,
	                  onChange: function onChange(e) {
	                    return onInputChange(e.target.value, i, 'includeOnlyApproved', e.target.checked);
	                  }
	                }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'switch-label', htmlFor: 'group' + i + '-approved' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'meta' },
	                    translation.only_approved.label
	                  )
	                )
	              ),
	              value.workflowModule !== 'hybrid-tiered-scheduling' && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'group' + i + '-always', 'aria-describedby': 'always-show-tooltip' },
	                  translation.always_show.label,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip tooltip--right' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'always-show-tooltip', className: 'tooltip__body',
	                        role: 'tooltip' },
	                      translation.always_show.tooltip
	                    )
	                  )
	                ),
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  id: 'group' + i + '-always',
	                  className: 'switch-input',
	                  checked: value.alwaysShow,
	                  onKeyDown: _helpers.handleSwitchInputKeys,
	                  onChange: function onChange(e) {
	                    return onInputChange(e.target.value, i, 'alwaysShow', e.target.checked);
	                  }
	                }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'switch-label', htmlFor: 'group' + i + '-always' },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'meta' },
	                    translation.always_show.label
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-optional' },
	                  value.proctorTypes.length || 'No',
	                  '\xA0',
	                  value.proctorTypes.length === 1 && _react2.default.createElement(
	                    'span',
	                    null,
	                    translation.proctor_types.label.replace('types', 'type')
	                  ),
	                  value.proctorTypes.length !== 1 && _react2.default.createElement(
	                    'span',
	                    null,
	                    translation.proctor_types.label
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn--link', type: 'button', onClick: function onClick() {
	                      _this2.toggleTypes(i);
	                    } },
	                  translation.proctor_types.edit
	                )
	              ),
	              value.workflowModule !== 'hybrid-tiered-scheduling' && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-optional' },
	                  value.proctorLocationSids && _react2.default.createElement(
	                    'span',
	                    null,
	                    value.proctorLocationSids.length || 'No',
	                    '\xA0',
	                    value.proctorLocationSids.length === 1 && _react2.default.createElement(
	                      'span',
	                      null,
	                      translation.proctor_locations.label.replace('locations', 'location')
	                    ),
	                    value.proctorLocationSids.length !== 1 && _react2.default.createElement(
	                      'span',
	                      null,
	                      translation.proctor_locations.label
	                    )
	                  ),
	                  !value.proctorLocationSids && _react2.default.createElement(
	                    'span',
	                    null,
	                    'No ',
	                    translation.proctor_locations.label
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn--link', type: 'button', onClick: function onClick() {
	                      _this2.toggleLocations(i);
	                    } },
	                  translation.proctor_locations.edit
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'media__tools proctor-group__tools' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn--delete proctor-group__delete', type: 'button', onClick: function onClick() {
	                  _this2.removeGroup(i);
	                } },
	              _react2.default.createElement(icons.iconTrash, null),
	              _react2.default.createElement(
	                'span',
	                { className: 'meta' },
	                translation.delete_group
	              )
	            )
	          ),
	          _react2.default.createElement(_this3.DragHandle, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'slideout group-types' },
	          SessionStore.proctorTypeList.map(function (key, j) {
	            if (subCategoryLength(key.subCategories)) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'form-subgroup', key: j },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'form-subheading' },
	                  key.title
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'switch-list' },
	                  key.subCategories.map(function (subKey, k) {
	                    if (subKey.status === 'disabled') {
	                      return '';
	                    } else {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: k },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: subKey.sid + '-' + i },
	                          subKey.title
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'checkbox',
	                          id: subKey.sid + '-' + i,
	                          className: 'switch-input ' + (subKey.mutuallyExclusiveInProctorGroup ? 'exclusive' : 'inexclusive'),
	                          value: subKey.sid,
	                          onKeyDown: _helpers.handleSwitchInputKeys,
	                          onChange: function onChange(e) {
	                            _this2.selectProctorType(e, i, subKey.mutuallyExclusiveInProctorGroup, subKey.requireLocationInProctorGroup);
	                          },
	                          checked: value.proctorTypes.indexOf(subKey.sid) > -1,
	                          disabled: _this2.disableProctorType(i, subKey.sid),
	                          'data-require': subKey.requireLocationInProctorGroup
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'switch-label', htmlFor: subKey.sid + '-' + i },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            subKey.title
	                          )
	                        ),
	                        subKey.requireLocationInProctorGroup && _react2.default.createElement(
	                          'label',
	                          { className: 'select select--required switch-list__select', htmlFor: subKey.sid + '-l-' + i },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: subKey.sid + '-l-' + i,
	                              value: value.proctorLocationSid || '',
	                              onChange: function onChange(e) {
	                                _this2.selectLocation(e, i);
	                              },
	                              required: value.proctorTypes.indexOf(subKey.sid) > -1,
	                              'aria-required': 'true'
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.select_location
	                            ),
	                            value.proctorTypes.indexOf(subKey.sid) > -1 && _this2.searchProctors(subKey.sid, i),
	                            value.locations && value.locations.map(function (location, l) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: l, value: location.location.sid },
	                                location.proctor.accountName,
	                                ' - ',
	                                location.location.name
	                              );
	                            })
	                          )
	                        )
	                      );
	                    }
	                  })
	                )
	              );
	            }
	
	            return '';
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'slideout slideout--alt group-locations' },
	          value.proctorLocationSids && _react2.default.createElement(
	            'div',
	            { className: 'tags' },
	            value.proctorLocationSids.map(function (sid) {
	              if (_this2.state.groups[i].proctorLocationDetails && _this2.state.groups[i].proctorLocationDetails[sid]) {
	                return _react2.default.createElement(
	                  'button',
	                  {
	                    key: sid,
	                    className: 'tag tag--removable tag--alt',
	                    type: 'button',
	                    onClick: function onClick() {
	                      return _this2.removeProctorLocation(i, sid);
	                    }
	                  },
	                  _this2.state.groups[i].proctorLocationDetails[sid].proctor.accountName,
	                  ' \u2013 ',
	                  _this2.state.groups[i].proctorLocationDetails[sid].location.name
	                );
	              }
	
	              return null;
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'suggestion-wrap' },
	            _react2.default.createElement('input', {
	              type: 'text',
	              className: 'suggestion-inp',
	              ref: function ref(input) {
	                _this2['location' + i] = input;
	              },
	              placeholder: translation.proctor_locations.search_proctors,
	              onChange: function onChange(e) {
	                return _this2.searchProctorLocations(e, i);
	              }
	            }),
	            _this2['location' + i] && _this2['location' + i].value && _react2.default.createElement(
	              'button',
	              {
	                className: 'suggestion-cancel',
	                type: 'button',
	                onClick: function onClick(e) {
	                  return _this2.resetProctorLocations(i);
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'meta' },
	                translation.cancel
	              )
	            ),
	            _this2.state.groups[i].proctorLocations && _react2.default.createElement(
	              'ul',
	              { className: 'suggestion-list' },
	              _this2.state.groups[i].proctorLocations.map(function (key, j) {
	                if (_this2.state.groups[i].proctorLocationSids && _this2.state.groups[i].proctorLocationSids.indexOf(key.location.sid) < 0) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: j },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'suggestion btn--reset',
	                        type: 'button',
	                        onClick: function onClick() {
	                          return _this2.addProctorLocation(i, key);
	                        },
	                        disabled: _this2.state.groups[i].proctorLocationSids && _this2.state.groups[i].proctorLocationSids.indexOf(key.location.sid) >= 0
	                      },
	                      key.proctor.accountName,
	                      key.location.name && _react2.default.createElement(
	                        'span',
	                        { className: 'suggestion__subtitle' },
	                        key.location.name
	                      ),
	                      key.location.name && _react2.default.createElement(
	                        'span',
	                        { className: 'suggestion__subtitle' },
	                        key.location.address1
	                      ),
	                      key.location.schedulingModule === 'register-blast' && _react2.default.createElement('img', { className: 'suggestion__icn', src: './static/img/icn-registerblast.png', height: '20', alt: 'RegisterBlast', role: 'presentation' })
	                    )
	                  );
	                } else {
	                  return null;
	                }
	              })
	            )
	          )
	        )
	      );
	    });
	    _this2.SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
	      var items = _ref2.items,
	          onInputChange = _ref2.onInputChange;
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'block-list fields' },
	        items.map(function (key, i) {
	          return _react2.default.createElement(_this3.SortableItem, { key: i, index: i, value: key, i: i, onInputChange: onInputChange });
	        })
	      );
	    });
	
	    _this2.addGroup = _this2.addGroup.bind(_this2);
	    _this2.sortGroups = _this2.sortGroups.bind(_this2);
	    _this2.editGroups = _this2.editGroups.bind(_this2);
	    _this2.removeGroup = _this2.removeGroup.bind(_this2);
	    _this2.selectProctorType = _this2.selectProctorType.bind(_this2);
	    _this2.disableProctorType = _this2.disableProctorType.bind(_this2);
	    _this2.checkProctorTypes = _this2.checkProctorTypes.bind(_this2);
	    _this2.setLocations = _this2.setLocations.bind(_this2);
	    _this2.selectLocation = _this2.selectLocation.bind(_this2);
	    _this2.searchProctorLocations = _this2.searchProctorLocations.bind(_this2);
	    _this2.resetProctorLocations = _this2.resetProctorLocations.bind(_this2);
	    _this2.addProctorLocation = _this2.addProctorLocation.bind(_this2);
	    _this2.removeProctorLocation = _this2.removeProctorLocation.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.complete = _this2.complete.bind(_this2);
	    _this2.updateIcon = _this2.updateIcon.bind(_this2);
	    _this2.expandInvalid = _this2.expandInvalid.bind(_this2);
	    _this2.renderForm = _this2.renderForm.bind(_this2);
	    _this2.renderDisabled = _this2.renderDisabled.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ProctorGroups, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.state = {
	        groups: []
	
	        // Get enabled proctor types
	      };SessionStore.getFilteredProctorTypes();
	
	      // Get existing proctor groups
	      this.getProctorGroups();
	    }
	  }, {
	    key: 'getProctorGroups',
	    value: function getProctorGroups() {
	      this.props.store.ProctorStore.getProctorGroups(this);
	    }
	  }, {
	    key: 'addGroup',
	    value: function addGroup() {
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	      var newGroup = {
	        title: '',
	        description: '',
	        buttonText: '',
	        icon: '',
	        includeOnlyApproved: false,
	        proctorTypes: [],
	        proctorLocationSids: [],
	        proctorLocationDetails: [],
	        sid: new Date().getTime()
	      };
	
	      groups.push(newGroup);
	
	      this.setState({
	        groups: groups
	      });
	    }
	  }, {
	    key: 'editGroups',
	    value: function editGroups(text, i, key, boolean) {
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	      groups[i][key] = text;
	
	      // If it’s a boolean value
	      if (typeof boolean !== 'undefined') {
	        groups[i][key] = boolean;
	      }
	
	      this.setState({
	        groups: groups
	      });
	
	      this.forceUpdate();
	    }
	  }, {
	    key: 'removeGroup',
	    value: function removeGroup(i) {
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	
	      groups.splice(i, 1);
	
	      this.setState({
	        groups: groups
	      });
	    }
	  }, {
	    key: 'toggleTypes',
	    value: function toggleTypes(i) {
	      if (typeof i !== 'undefined') {
	        var group = document.querySelectorAll('.proctor-group')[i];
	        group.classList.toggle('open');
	
	        var types = group.nextSibling;
	        types.classList.toggle('open');
	      } else {
	        var groups = document.querySelectorAll('.proctor-group');
	
	        for (var _i = 0; _i < groups.length; _i++) {
	          groups[_i].classList.remove('open');
	
	          var _types = groups[_i].nextSibling;
	          _types.classList.remove('open');
	        }
	      }
	    }
	  }, {
	    key: 'selectProctorType',
	    value: function selectProctorType(e, i, exclusive, requireLocation) {
	      var SessionStore = this.props.store.SessionStore;
	
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	
	      if (e.target.checked) {
	        if (exclusive) {
	          // If this is an exclusive type, make sure there are no others selected
	          groups[i].proctorTypes.length = 0;
	        }
	
	        groups[i].proctorTypes.push(e.target.value);
	      } else {
	        var index = groups[i].proctorTypes.indexOf(e.target.value);
	        groups[i].proctorTypes.splice(index, 1);
	        groups[i].proctorLocationSid = '';
	      }
	
	      // If this is an exclusive proctor type, disable others on check
	      // and enable others on uncheck
	      if (exclusive) {
	        var thisGroup = document.querySelectorAll('.block-list .slideout')[i];
	        var thisSwitches = thisGroup.querySelectorAll('input.switch-input:not(:checked)');
	
	        if (e.target.checked) {
	          var dialogContent = this.props.translation.exclusive;
	          SessionStore.showDialog(dialogContent);
	
	          for (var _i2 = 0; _i2 < thisSwitches.length; _i2++) {
	            thisSwitches[_i2].disabled = true;
	          }
	        } else {
	          for (var _i3 = 0; _i3 < thisSwitches.length; _i3++) {
	            thisSwitches[_i3].disabled = false;
	          }
	        }
	
	        // Otherwise disable exclusive types when non-exclusives are selected
	      } else {
	        var _thisGroup = document.querySelectorAll('.block-list .slideout')[i];
	        var thisExclusives = _thisGroup.querySelectorAll('input.switch-input.exclusive');
	
	        if (e.target.checked) {
	          for (var _i4 = 0; _i4 < thisExclusives.length; _i4++) {
	            thisExclusives[_i4].disabled = true;
	          }
	        } else {
	          for (var _i5 = 0; _i5 < thisExclusives.length; _i5++) {
	            thisExclusives[_i5].disabled = false;
	          }
	        }
	      }
	
	      // If a location is required, clear out the current locations array and get a new one
	      // from the API
	      if (requireLocation) {
	        groups[i].locations = [];
	
	        var query = '?proctorSubcategories=' + e.target.value;
	        this.props.store.ProctorStore.searchProctors(query, this.setLocations, i);
	      }
	
	      // If the proctor group has locations set,
	      // get the details for those locations from the API
	      if (groups[i].proctorLocationSids && groups[i].proctorLocationSids.length > 0) {
	        groups[i].proctorLocationDetails = {};
	
	        var _query = '?';
	
	        // Get all the location sids for the query
	        for (var li = 0; li < groups[i].proctorLocationSids.length; li++) {
	          if (li > 0) {
	            _query += '&';
	          }
	
	          _query += 'proctorLocationSids=' + groups[i].proctorLocationSids[li];
	        }
	
	        // Callback function that adds the data to the group’s state
	        var callback = function callback(i, results) {
	          results.forEach(function (result) {
	            groups[i].proctorLocationDetails[result.location.sid] = result;
	          });
	        };
	
	        // Make the API call
	        this.props.store.ProctorStore.searchProctors(_query, callback, i);
	      }
	
	      this.setState({
	        groups: groups
	      });
	    }
	  }, {
	    key: 'searchProctors',
	    value: function searchProctors(sid, i) {
	      var _this = this;
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	
	      setTimeout(function () {
	        if (typeof groups[i].locations === 'undefined' && !groups[i].gotLocations) {
	          groups[i].gotLocations = true;
	          var query = '?proctorSubcategories=' + sid;
	          _this.props.store.ProctorStore.searchProctors(query, _this.setLocations, i);
	        }
	      });
	    }
	  }, {
	    key: 'setLocations',
	    value: function setLocations(i, locations) {
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	
	      groups[i].locations = locations;
	
	      this.setState({
	        groups: groups
	      });
	    }
	  }, {
	    key: 'selectLocation',
	    value: function selectLocation(e, i) {
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	
	      groups[i].proctorLocationSid = e.target.value;
	
	      this.setState({
	        groups: groups
	      });
	    }
	
	    // Disable proctor type selection if an exclusive one is already selected
	
	  }, {
	    key: 'disableProctorType',
	    value: function disableProctorType(i, typeKey) {
	      var proctorTypeList = this.props.store.SessionStore.proctorTypeList;
	
	      var disable = false;
	      var exclusiveProctorTypes = [];
	
	      // First loop through the allowable proctor types and make an array exclusive subcategories
	      proctorTypeList.forEach(function (type) {
	        if (type.subCategories.length > 0) {
	          type.subCategories.forEach(function (subType) {
	            if (subType.mutuallyExclusiveInProctorGroup) {
	              exclusiveProctorTypes.push(subType.sid);
	            }
	          });
	        }
	      });
	
	      // Get the selected types
	      var selectedProctorTypes = this.state.groups[i].proctorTypes;
	
	      // Then loop through them and check if they are exclusive
	      selectedProctorTypes.forEach(function (type) {
	        if (exclusiveProctorTypes.indexOf(type) > -1) {
	          disable = true;
	        }
	      });
	
	      // If this is the exclusive type, don’t disable it
	      if (exclusiveProctorTypes.indexOf(typeKey) > -1 && selectedProctorTypes.indexOf(typeKey) > -1) {
	        disable = false;
	      }
	
	      return disable;
	    }
	  }, {
	    key: 'checkProctorTypes',
	    value: function checkProctorTypes() {
	      var proctorTypeList = this.props.store.SessionStore.proctorTypeList;
	
	      // Check if all allowable proctor types are assigned
	
	      var allProctorTypes = [];
	      var selectedProctorTypes = [];
	      var unselectedProctorTypes = [];
	
	      // First loop through the allowable proctor types and make an array of the subcategories
	      proctorTypeList.forEach(function (type) {
	        if (type.subCategories.length > 0) {
	          type.subCategories.forEach(function (subType) {
	            if (subType.status !== 'disabled') {
	              allProctorTypes.push(subType);
	            }
	          });
	        }
	      });
	
	      // Then loop through all of the selected proctor types and make an array
	      this.state.groups.forEach(function (group) {
	        if (group.proctorTypes.length > 0) {
	          group.proctorTypes.forEach(function (subType) {
	            if (subType) {
	              selectedProctorTypes.push(subType);
	            }
	          });
	        }
	      });
	
	      // Then loop through all of the proctor types and check if they are selected
	      allProctorTypes.forEach(function (type) {
	        selectedProctorTypes.indexOf(type.sid);
	
	        if (selectedProctorTypes.indexOf(type.sid) < 0) {
	          unselectedProctorTypes.push(type);
	        }
	      });
	
	      if (unselectedProctorTypes.length > 0) {
	        var unselectedList = '';
	
	        unselectedProctorTypes.forEach(function (type) {
	          unselectedList += '<li>' + type.title + '</li>';
	        });
	
	        var message = this.props.translation.not_selected;
	        message.data = unselectedList;
	
	        (0, _helpers.confirm)(message, this.handleSubmit);
	      } else {
	        this.handleSubmit();
	      }
	    }
	  }, {
	    key: 'expandInvalid',
	    value: function expandInvalid() {
	      var invalidSelects = document.querySelectorAll('.submitted select:invalid');
	
	      for (var i = 0; i < invalidSelects.length; i++) {
	        var parent = (0, _helpers.findAncestor)(invalidSelects[i], 'slideout');
	
	        if (!parent.classList.contains('open')) {
	          parent.className += ' open';
	        }
	      }
	    }
	  }, {
	    key: 'getElement',
	    value: function getElement(parent, cls) {
	      var el = null;
	      var elements = parent.childNodes;
	
	      for (var e = 0; e < elements.length; e++) {
	        if (elements[e].className.indexOf(cls) >= 0) {
	          el = elements[e];
	        }
	      }
	
	      return el;
	    }
	  }, {
	    key: 'toggleLocations',
	    value: function toggleLocations(i) {
	      if (typeof i !== 'undefined') {
	        var group = document.querySelectorAll('.proctor-group')[i];
	        group.classList.toggle('open');
	
	        var locationsEl = this.getElement(group.parentNode, 'group-locations');
	
	        if (locationsEl) {
	          locationsEl.classList.toggle('open');
	        }
	      } else {
	        var groups = document.querySelectorAll('.proctor-group');
	
	        for (var _i6 = 0; _i6 < groups.length; _i6++) {
	          groups[_i6].classList.remove('open');
	
	          var _locationsEl = this.getElement(groups[_i6].parentNode, 'group-locations');
	
	          if (_locationsEl) {
	            _locationsEl.classList.remove('open');
	          }
	        }
	      }
	
	      // If the location details are not already present, get them
	      if (!this.state.groups[i].proctorLocationDetails && this.state.groups[i].proctorLocationSids.length > 0) {
	        this.props.store.ProctorStore.getLocationDetails(this.state.groups[i].proctorLocationSids, i, this);
	      }
	    }
	  }, {
	    key: 'searchProctorLocations',
	    value: function searchProctorLocations(e, i) {
	      var _this4 = this;
	
	      var keyword = e.target.value;
	      var query = '?keyword=*' + keyword + '*&limit=100';
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	
	      var callback = function callback(i, results) {
	        groups[i].proctorLocations = results;
	
	        _this4.setState({
	          groups: groups
	        });
	      };
	
	      if (keyword) {
	        this.props.store.ProctorStore.searchProctors(query, callback, i, true);
	      } else {
	        groups[i].proctorLocations = [];
	
	        this.setState({
	          groups: groups
	        });
	      }
	    }
	  }, {
	    key: 'resetProctorLocations',
	    value: function resetProctorLocations(i) {
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	
	      // Reset the text field
	      this['location' + i].value = '';
	
	      // Remove the search results
	      groups[i].proctorLocations = [];
	
	      // Update the state
	      this.setState({
	        groups: groups
	      });
	    }
	  }, {
	    key: 'addProctorLocation',
	    value: function addProctorLocation(i, location) {
	      var locationSid = location.location.sid;
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	
	      // Add the sid
	      if (groups[i].proctorLocationSids) {
	        groups[i].proctorLocationSids.push(location.location.sid);
	      } else {
	        groups[i].proctorLocationSids = [location.location.sid];
	      }
	
	      // Add the details
	      if (!groups[i].proctorLocationDetails) {
	        groups[i].proctorLocationDetails = {};
	      }
	
	      groups[i].proctorLocationDetails[locationSid] = location;
	
	      // Update the state
	      this.setState({
	        groups: groups
	      });
	
	      // Reset the location form
	      // this.resetProctorLocations(i);
	    }
	  }, {
	    key: 'removeProctorLocation',
	    value: function removeProctorLocation(i, locationSid) {
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	      var index = 0;
	
	      // Loop through this group’s location sids
	      // to get the index of the one we’re removing
	      groups[i].proctorLocationSids.forEach(function (sid, thisIndex) {
	        if (sid === locationSid) {
	          index = thisIndex;
	        }
	      });
	
	      // Remove the selected sid
	      groups[i].proctorLocationSids.splice(index, 1);
	
	      // Update the state
	      this.setState({
	        groups: groups
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var translation = this.props.translation;
	
	
	      this.toggleTypes();
	
	      var data = [];
	
	      for (var i = 0; i < this.state.groups.length; i++) {
	        var obj = {
	          buttonText: this.state.groups[i].buttonText,
	          description: this.state.groups[i].description,
	          icon: this.state.groups[i].icon,
	          includeOnlyApproved: this.state.groups[i].includeOnlyApproved,
	          proctorLocationSid: this.state.groups[i].proctorLocationSid,
	          proctorLocationSids: this.state.groups[i].proctorLocationSids,
	          proctorTypes: this.state.groups[i].proctorTypes,
	          sid: this.state.groups[i].sid,
	          title: this.state.groups[i].title,
	          workflowModule: this.state.groups[i].workflowModule,
	          alwaysShow: this.state.groups[i].alwaysShow
	        };
	
	        data.push(obj);
	      }
	
	      data.forEach(function (group) {
	        if (!group.buttonText) {
	          group.buttonText = translation.default_button_text;
	        }
	
	        // Remove temporary sid
	        if (typeof group.sid !== 'string') {
	          delete group.sid;
	        }
	      });
	
	      this.props.store.ProctorStore.updateProctorGroups(data, this.complete);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      this.props.store.SessionStore.showToaster(this.props.translation.groups_saved, 'success');
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(icon) {
	      switch (icon) {
	        case 'person':
	          return _react2.default.createElement(icons.iconIndividual, null);
	
	        case 'attended':
	          return _react2.default.createElement(icons.iconAttended, null);
	
	        case 'unattended':
	          return _react2.default.createElement(icons.iconUnattended, null);
	
	        case 'instructor':
	          return _react2.default.createElement(icons.iconInstructor, null);
	
	        case 'testing_centers':
	          return _react2.default.createElement(icons.iconTestingCenters, null);
	
	        case 'testing_centers_individuals':
	          return _react2.default.createElement(icons.iconCentersIndivuals, null);
	
	        case 'examity':
	          return _react2.default.createElement(icons.iconExamity, null);
	
	        case 'proctoru':
	          return _react2.default.createElement(icons.iconProctorU, null);
	
	        default:
	          return '';
	      }
	    }
	  }, {
	    key: 'updateIcon',
	    value: function updateIcon(e, i) {
	      var icon = this['icon' + i].value;
	      var groups = [].concat(_toConsumableArray(this.state.groups));
	
	      groups[i].icon = icon;
	
	      this.setState({
	        groups: groups
	      });
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'proctor-group-form', onSubmit: function onSubmit(e) {
	            return (0, _helpers.checkValidity)(e, _this5.checkProctorTypes, 'form.proctor-group-form', _this5.expandInvalid);
	          }, noValidate: true },
	        _react2.default.createElement(this.SortableList, {
	          items: this.state.groups,
	          onSortEnd: this.sortGroups,
	          axis: 'y',
	          lockAxis: 'y',
	          helperClass: 'dragging',
	          useDragHandle: true,
	          onInputChange: function onInputChange(text, i, key, boolean) {
	            return _this5.editGroups(text, i, key, boolean);
	          },
	          useWindowAsScrollContainer: true
	        }),
	        _react2.default.createElement(
	          'button',
	          { className: 'block-list__add', type: 'button', onClick: this.addGroup },
	          _react2.default.createElement(icons.iconPlus, null),
	          translation.add_group
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn--large', type: 'submit' },
	          translation.button
	        )
	      );
	    }
	  }, {
	    key: 'renderDisabled',
	    value: function renderDisabled() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel panel--brief' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title' },
	          translation.disabled.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.disabled.body,
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:jason@smarterservices.com' },
	            translation.disabled.contact
	          ),
	          '.'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // const { translation } = this.props;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (!SessionStore.loading || this.state.groups.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'wrap wrap--brief' },
	          _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'disable-proctor-groups',
	            renderFeatureCallback: this.renderDisabled,
	            renderDefaultCallback: this.renderForm
	          })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ProctorGroups;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProctorGroups')(ProctorGroups);

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _InstitutionSettings = __webpack_require__(851);
	
	var _InstitutionSettings2 = _interopRequireDefault(_InstitutionSettings);
	
	var _ProctorGroups = __webpack_require__(852);
	
	var _ProctorGroups2 = _interopRequireDefault(_ProctorGroups);
	
	var _UserSettings = __webpack_require__(221);
	
	var _UserSettings2 = _interopRequireDefault(_UserSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Settings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Settings, _React$Component);
	
	  function Settings() {
	    _classCallCheck(this, Settings);
	
	    return _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).apply(this, arguments));
	  }
	
	  _createClass(Settings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        pageContent: null
	
	        // Determine which settings page to show
	      };if (this.props.content === 'Institution') {
	        this.setState({
	          pageContent: _react2.default.createElement(_InstitutionSettings2.default, this.props)
	        });
	      } else if (this.props.content === 'ProctorGroups') {
	        this.setState({
	          pageContent: _react2.default.createElement(_ProctorGroups2.default, this.props)
	        });
	      } else {
	        this.setState({
	          pageContent: _react2.default.createElement(_UserSettings2.default, this.props)
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          )
	        ),
	        this.state.pageContent
	      );
	    }
	  }]);
	
	  return Settings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Settings')(Settings);

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	var SignOut = function (_React$Component) {
	  _inherits(SignOut, _React$Component);
	
	  function SignOut() {
	    _classCallCheck(this, SignOut);
	
	    return _possibleConstructorReturn(this, (SignOut.__proto__ || Object.getPrototypeOf(SignOut)).apply(this, arguments));
	  }
	
	  _createClass(SignOut, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      var isAdmin = false;
	
	      if (SessionStore.hasSessionStorage) {
	        isAdmin = JSON.parse(sessionStorage.getItem('userData')).role.toLowerCase() === 'administrator';
	      } else {
	        isAdmin = JSON.parse((0, _helpers.getCookie)('userData')).role.toLowerCase() === 'administrator';
	      }
	
	      if (isAdmin) {
	        this.props.store.SessionStore.logout();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.message
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignOut;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('SignOut')(SignOut);

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var SignedOut = function (_React$Component) {
	  _inherits(SignedOut, _React$Component);
	
	  function SignedOut() {
	    _classCallCheck(this, SignedOut);
	
	    return _possibleConstructorReturn(this, (SignedOut.__proto__ || Object.getPrototypeOf(SignedOut)).apply(this, arguments));
	  }
	
	  _createClass(SignedOut, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.message
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignedOut;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('SignedOut')(SignedOut);

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ExamDetails = __webpack_require__(79);
	
	var _ExamDetails2 = _interopRequireDefault(_ExamDetails);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ChooseExam = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ChooseExam, _React$Component);
	
	  function ChooseExam() {
	    _classCallCheck(this, ChooseExam);
	
	    var _this = _possibleConstructorReturn(this, (ChooseExam.__proto__ || Object.getPrototypeOf(ChooseExam)).call(this));
	
	    _this.initSchedule = _this.initSchedule.bind(_this);
	    _this.setProctorTypes = _this.setProctorTypes.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChooseExam, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        proctorGroup: null,
	        status: 'Needs Proctor'
	
	        // Get all proctor types so we can determine what type this group is
	      };this.props.store.SessionStore.getProctorTypes();
	
	      // Get proctor group sid from url
	      var proctorGroupSid = (0, _helpers.getURLSegment)(this, 3);
	
	      // Get student exams
	      this.props.store.StudentStore.getStudentExams(true);
	
	      // Get proctor group
	      this.props.store.StudentStore.getProctorGroup(proctorGroupSid, this);
	
	      // Get the current time from the server
	      this.props.store.SessionStore.getCurrentTime();
	    }
	
	    // Output the correct module
	
	  }, {
	    key: 'proctorTypeModule',
	    value: function proctorTypeModule(thisType) {
	      var SessionStore = this.props.store.SessionStore;
	
	      var module = '';
	
	      // If this group only has one type
	      if (thisType.length === 1) {
	        // Loop through parent categories
	        SessionStore.proctorTypeList.map(function (key, i) {
	          return (
	            // Loop through subcategories and this proctor type category
	            key.subCategories.filter(function (obj) {
	              return obj.sid === thisType[0];
	            }).map(function (subCategory, i) {
	              module = subCategory.module;
	              return module;
	            })
	          );
	        });
	      }
	
	      return module;
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton(module, proctorTypes, groupSid, proctorLocationSid, buttonText, examSid, sessionSid, configurationSid, exam) {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	      // Figure out which button to show
	
	      switch (module) {
	        case 'bvirtual-attended':
	        case 'online-attended':
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--action btn--icn-right',
	              onClick: function onClick(e) {
	                _this2.initSchedule(e, 'ScheduleOnline', proctorLocationSid, sessionSid, examSid, exam);
	              },
	              'data-location': proctorLocationSid
	            },
	            translation.button,
	            _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	          );
	
	        case 'instructor':
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--action btn--icn-right',
	              onClick: function onClick(e) {
	                _this2.initSchedule(e, 'ScheduleInstructor', proctorLocationSid, sessionSid, examSid, exam);
	              }
	            },
	            translation.button,
	            _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	          );
	
	        case 'vtc':
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--action btn--icn-right',
	              onClick: function onClick(e) {
	                _this2.initSchedule(e, 'ScheduleVTC', proctorLocationSid, sessionSid, examSid, exam);
	              }
	            },
	            translation.button,
	            _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	          );
	
	        default:
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              className: 'btn btn--action btn--icn-right',
	              to: 'schedule-session/exam/' + examSid + '/session/' + sessionSid + '/configuration/' + configurationSid + '/search/group/' + groupSid,
	              onClick: function onClick() {
	                _this2.setProctorTypes(proctorTypes);
	              }
	            },
	            translation.button,
	            _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	          );
	      }
	    }
	  }, {
	    key: 'initSchedule',
	    value: function initSchedule(e, type, proctorLocationSid, sessionSid, examSid, exam) {
	      this.props.store.ExamStore.exam = exam;
	      this.props.store.ExamStore.examSession = exam.examSession;
	
	      this.setState({
	        proctorLocationSid: proctorLocationSid
	      });
	
	      if (sessionSid) {
	        this.setState({
	          sessionSid: sessionSid
	        });
	      }
	
	      if (examSid) {
	        this.setState({
	          examSid: examSid
	        });
	      }
	
	      (0, _helpers.toggleDrawer)(e, this, type);
	
	      this.props.store.ProctorStore.proctorLocationSid = proctorLocationSid;
	    }
	  }, {
	    key: 'setProctorTypes',
	    value: function setProctorTypes(proctorTypes) {
	      this.props.store.ProctorStore.proctorCategories = proctorTypes;
	    }
	
	    // Check if any of the proctor types in this group
	    // are allowed by the exam session configuration
	
	  }, {
	    key: 'validProctorType',
	    value: function validProctorType(exam, proctorTypes) {
	      var valid = false;
	      var sessionProctorTypes = exam.examSession.examConfiguration.proctorTypes;
	
	      // Loop through the session configuration’s proctor types
	      // and return true if any of them are in the proctor group’s types
	      for (var i = 0; i < sessionProctorTypes.length; i++) {
	        if (proctorTypes.indexOf(sessionProctorTypes[i]) >= 0) {
	          valid = true;
	        }
	      }
	
	      return valid;
	    }
	
	    // Check if scheduling is closed
	
	  }, {
	    key: 'schedulingClosed',
	    value: function schedulingClosed(exam) {
	      var closed = false;
	
	      var configuration = exam.examSession.examConfiguration;
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      var scheduleCloseDate = configuration.scheduleCloseDate;
	
	      if ((0, _moment2.default)(scheduleCloseDate).format('M-D-YYYY') === '1-1-2070') {
	        // If there’s no scheduling window set, use the exam close date
	        scheduleCloseDate = configuration.examCloseDate;
	      }
	
	      var closeDate = (0, _moment2.default)(scheduleCloseDate);
	      var closeDiff = _moment2.default.duration(closeDate.diff(now)).asHours();
	
	      if (closeDiff < 0) {
	        closed = true;
	      }
	
	      return closed;
	    }
	
	    // Check if scheduling has opened
	
	  }, {
	    key: 'schedulingOpen',
	    value: function schedulingOpen(exam) {
	      var open = true;
	
	      var configuration = exam.examSession.examConfiguration;
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	
	      var scheduleOpenDate = configuration.scheduleOpenDate;
	
	      var openDate = (0, _moment2.default)(scheduleOpenDate);
	      var openDiff = _moment2.default.duration(openDate.diff(now)).asHours();
	
	      if (openDiff >= 0) {
	        open = false;
	      }
	
	      return open;
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          StudentStore = _props$store.StudentStore;
	
	
	      if (!SessionStore.loading) {
	        if (StudentStore.exams.length === 0) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'no-results' },
	            translation.no_results,
	            _react2.default.createElement(
	              'span',
	              { className: 'no-results__sub' },
	              translation.no_results_sub
	            )
	          );
	        } else if (StudentStore.exams.length > 0 && this.state.proctorGroup) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'wrap wrap--brief' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'block-list' },
	              StudentStore.exams.map(function (key, i) {
	                if (_this3.validProctorType(key, _this3.state.proctorGroup.proctorTypes) && !_this3.schedulingClosed(key) && key.examSession.status.toLowerCase() === 'needs proctor') {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: i, className: 'block-list__block' },
	                    _react2.default.createElement(
	                      'h2',
	                      { className: 'block-list__title' },
	                      key.title
	                    ),
	                    _react2.default.createElement(_ExamDetails2.default, Object.assign({ scheduleWindow: true, exam: key, compact: true }, _this3.props)),
	                    _this3.schedulingOpen(key) && _this3.renderButton(_this3.proctorTypeModule(_this3.state.proctorGroup.proctorTypes), _this3.state.proctorGroup.proctorTypes, _this3.state.proctorGroup.sid, _this3.state.proctorGroup.proctorLocationSid, translation.buttonText, key.sid, key.examSession.sid, key.configuration.sid, key),
	                    !_this3.schedulingOpen(key) && _react2.default.createElement(
	                      'p',
	                      { className: 'note' },
	                      translation.not_open
	                    )
	                  );
	                }
	
	                return null;
	              })
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          )
	        ),
	        this.renderResults(),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          proctorLocationSid: this.state.proctorLocationSid,
	          examSid: this.state.examSid,
	          sessionSid: this.state.sessionSid,
	          status: this.state.status,
	          skipUrl: true
	        }, this.props))
	      );
	    }
	  }]);
	
	  return ChooseExam;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ChooseExam')(ChooseExam);

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _ScheduleAutomated = __webpack_require__(372);
	
	var _ScheduleAutomated2 = _interopRequireDefault(_ScheduleAutomated);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Config
	
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ChooseProctorType = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ChooseProctorType, _React$Component);
	
	  function ChooseProctorType() {
	    _classCallCheck(this, ChooseProctorType);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (ChooseProctorType.__proto__ || Object.getPrototypeOf(ChooseProctorType)).call(this));
	
	    _this.initSchedule = _this.initSchedule.bind(_this);
	    _this.setStatus = _this.setStatus.bind(_this);
	    _this.messageInstructor = _this.messageInstructor.bind(_this);
	    _this.setProctorLocationSid = _this.setProctorLocationSid.bind(_this);
	    return _this;
	  }
	
	  _createClass(ChooseProctorType, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        proctorLocationSid: null,
	        proctorTypeSubCategorySid: null,
	        examSid: null,
	        sessionSid: null,
	        status: null,
	        accessCode: null,
	        messageSid: null,
	        schedulingOpen: true
	      };
	
	      var examSid = (0, _helpers.getURLSegment)(this, 3);
	      var sessionSid = (0, _helpers.getURLSegment)(this, 5);
	
	      SessionStore.getProctorTypes();
	      this.getProctorGroups(examSid, sessionSid);
	      this.getExam(examSid, sessionSid);
	    }
	  }, {
	    key: 'getProctorGroups',
	    value: function getProctorGroups(examSid, sessionSid) {
	      this.props.store.ProctorStore.getSessionProctorGroups(examSid, sessionSid, null, this.setProctorLocationSid);
	    }
	  }, {
	    key: 'getExam',
	    value: function getExam(examSid, sessionSid) {
	      // Get exam
	      this.props.store.ExamStore.getExam(examSid);
	
	      // Get exam session
	      this.props.store.ExamStore.getExamSession(examSid, sessionSid, this.setStatus);
	    }
	  }, {
	    key: 'setStatus',
	    value: function setStatus(response) {
	      var _props$store = this.props.store,
	          BlackoutStore = _props$store.BlackoutStore,
	          ExamStore = _props$store.ExamStore,
	          ScheduleStore = _props$store.ScheduleStore;
	      var examConfiguration = ExamStore.examSession.examConfiguration;
	
	
	      this.setState({
	        status: response.data.status
	      });
	
	      if (response.data.accessKey) {
	        this.setState({
	          accessCode: response.data.accessKey
	        });
	      }
	
	      // Cancel pre-existing reservations
	      if (response.data.externalReservedAppointmentId) {
	        ScheduleStore.cancelReservation(response.data.examSid, response.data.sid);
	      }
	
	      // Check for blackout dates
	      var query = {
	        startDate: examConfiguration.examOpenDate,
	        endDate: examConfiguration.examCloseDate
	      };
	
	      BlackoutStore.listBlackoutDates(query);
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(icon) {
	      switch (icon) {
	        case 'person':
	          return _react2.default.createElement(icons.iconIndividual, null);
	
	        case 'attended':
	          return _react2.default.createElement(icons.iconAttended, null);
	
	        case 'unattended':
	          return _react2.default.createElement(icons.iconUnattended, null);
	
	        case 'instructor':
	          return _react2.default.createElement(icons.iconInstructor, null);
	
	        case 'testing_centers':
	          return _react2.default.createElement(icons.iconTestingCenters, null);
	
	        case 'testing_centers_individuals':
	          return _react2.default.createElement(icons.iconCentersIndivuals, null);
	
	        case 'examity':
	          return _react2.default.createElement(icons.iconExamity, null);
	
	        case 'proctoru':
	          return _react2.default.createElement(icons.iconProctorU, null);
	
	        case 'hybrid':
	          return _react2.default.createElement(icons.iconLaptop, null);
	
	        default:
	          return '';
	      }
	    }
	
	    // Output the correct module
	
	  }, {
	    key: 'proctorTypeModule',
	    value: function proctorTypeModule(thisType) {
	      var SessionStore = this.props.store.SessionStore;
	
	      var module = '';
	
	      // If this group only has one type
	      if (thisType.length === 1) {
	        // Loop through parent categories
	        SessionStore.proctorTypeList.map(function (key, i) {
	          return (
	            // Loop through subcategories and this proctor type category
	            key.subCategories.filter(function (obj) {
	              return obj.sid === thisType[0];
	            }).map(function (subCategory, i) {
	              module = subCategory.module;
	              return module;
	            })
	          );
	        });
	      }
	      return module;
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton(schedulingModule, proctorGroup) {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var proctorTypes = proctorGroup.proctorTypes,
	          proctorLocationSid = proctorGroup.proctorLocationSid,
	          buttonText = proctorGroup.buttonText,
	          workflowModule = proctorGroup.workflowModule;
	
	      var groupSid = proctorGroup.sid;
	
	      // Get url segments
	      var segment1 = (0, _helpers.getURLSegment)(this, 1);
	      var segment2 = (0, _helpers.getURLSegment)(this, 2);
	      var examSid = (0, _helpers.getURLSegment)(this, 3);
	      var segment4 = (0, _helpers.getURLSegment)(this, 4);
	      var sessionSid = (0, _helpers.getURLSegment)(this, 5);
	      var segment6 = (0, _helpers.getURLSegment)(this, 6);
	      var configurationSid = (0, _helpers.getURLSegment)(this, 7);
	
	      if (workflowModule && workflowModule === 'hybrid') {
	        // If the proctor group has a hybrid workflow module
	        return _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn--action btn--icn-right',
	            onClick: function onClick(e) {
	              _this2.initSchedule(e, 'ScheduleAutomated', proctorGroup.proctorLocationSids[0], sessionSid, examSid, null, proctorTypes[0]);
	            }
	          },
	          buttonText || translation.button,
	          _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	        );
	      } else {
	        // Figure out which button to show
	        switch (schedulingModule) {
	          case 'bvirtual-attended':
	          case 'online-attended':
	            return _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--action btn--icn-right',
	                onClick: function onClick(e) {
	                  _this2.initSchedule(e, 'ScheduleOnline', proctorLocationSid);
	                },
	                'data-location': proctorLocationSid
	              },
	              buttonText || translation.button,
	              _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	            );
	
	          case 'instructor':
	            return _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--action btn--icn-right',
	                onClick: function onClick(e) {
	                  _this2.initSchedule(e, 'ScheduleInstructor', proctorLocationSid);
	                }
	              },
	              buttonText || translation.button,
	              _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	            );
	
	          case 'vtc':
	            return _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--action btn--icn-right',
	                onClick: function onClick(e) {
	                  _this2.initSchedule(e, 'ScheduleVTC', proctorLocationSid, sessionSid, examSid);
	                }
	              },
	              buttonText || translation.button,
	              _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	            );
	
	          case 'automated':
	            return _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--action btn--icn-right',
	                onClick: function onClick(e) {
	                  _this2.initSchedule(e, 'ScheduleAutomated', proctorLocationSid, sessionSid, examSid, null, proctorTypes[0]);
	                }
	              },
	              buttonText || translation.button,
	              _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	            );
	
	          case 'hybrid_scheduling':
	            return _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--action btn--icn-right',
	                onClick: function onClick(e) {
	                  _this2.initSchedule(e, 'ScheduleHybrid', proctorLocationSid, sessionSid, examSid, groupSid, proctorTypes[0]);
	                }
	              },
	              buttonText || translation.button,
	              _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	            );
	
	          case 'hybrid_tiered_scheduling':
	            return _react2.default.createElement(
	              'button',
	              {
	                className: 'btn btn--action btn--icn-right',
	                onClick: function onClick(e) {
	                  _this2.initSchedule(e, 'ScheduleHybrid', proctorLocationSid, sessionSid, examSid, groupSid, proctorTypes[0]);
	                }
	              },
	              buttonText || translation.button,
	              _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	            );
	
	          default:
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'btn btn--action btn--icn-right',
	                to: segment1 + '/' + segment2 + '/' + examSid + '/' + segment4 + '/' + sessionSid + '/' + segment6 + '/' + configurationSid + '/search/group/' + groupSid,
	                onClick: function onClick() {
	                  _this2.setProctorTypes(proctorTypes);
	                }
	              },
	              buttonText || translation.button,
	              _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	            );
	        }
	      }
	    }
	  }, {
	    key: 'initSchedule',
	    value: function initSchedule(e, type, proctorLocationSid, sessionSid, examSid, proctorGroupSid, proctorTypeSubCategorySid) {
	      this.setState({
	        proctorLocationSid: proctorLocationSid
	      });
	
	      if (sessionSid) {
	        this.setState({
	          sessionSid: sessionSid
	        });
	      }
	
	      if (examSid) {
	        this.setState({
	          examSid: examSid
	        });
	      }
	
	      if (proctorGroupSid) {
	        this.setState({
	          proctorGroupSid: proctorGroupSid
	        });
	      }
	
	      if (proctorTypeSubCategorySid) {
	        this.setState({
	          proctorTypeSubCategorySid: proctorTypeSubCategorySid
	        });
	      }
	
	      (0, _helpers.toggleDrawer)(e, this, type);
	
	      this.props.store.ProctorStore.proctorLocationSid = proctorLocationSid;
	    }
	  }, {
	    key: 'setProctorTypes',
	    value: function setProctorTypes(proctorTypes) {
	      this.props.store.ProctorStore.proctorCategories = proctorTypes;
	    }
	  }, {
	    key: 'messageInstructor',
	    value: function messageInstructor() {
	      var examSid = (0, _helpers.getURLSegment)(this, 3);
	
	      this.setState({
	        examSid: examSid,
	        messageSid: null
	      });
	
	      (0, _helpers.toggleDrawer)(null, this, 'MessageThread');
	    }
	  }, {
	    key: 'setProctorLocationSid',
	    value: function setProctorLocationSid(proctorGroups) {
	      var _this3 = this;
	
	      var automatedProctorTypeSids = _config.config.automatedProctorTypeSids;
	      var automatedOnly = this.props.automatedOnly;
	
	      var automatedProctorGroups = [];
	
	      // If this is automated only, get the proctorLocationSid
	      if (proctorGroups.length > 0 && automatedOnly) {
	        proctorGroups.forEach(function (group) {
	          if (group.proctorTypes.length === 1 && automatedProctorTypeSids.indexOf(group.proctorTypes[0]) > -1) {
	            automatedProctorGroups.push(group);
	          }
	
	          if (_this3.props.scheduleClosed) {
	            if (group.workflowModule === 'automated') {
	              _this3.setState({ proctorLocationSid: group.proctorLocationSid });
	            }
	          }
	        });
	
	        // Make sure there is only one automated proctor group
	        // before setting the proctorLocationSid. If there is
	        // more than one, the user will see the choose proctor
	        // type view. Otherwise, they will go straight to
	        // automated scheduling.
	
	        if (automatedProctorGroups.length === 1) {
	          this.setState({
	            proctorLocationSid: automatedProctorGroups[0].proctorLocationSid
	          });
	        } else {
	          this.setState({
	            multipleAutomatedGroups: true
	          });
	        }
	      } else if (proctorGroups.length === 0) {
	        this.setState({
	          noAutomatedGroup: true
	        });
	      }
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          ProctorStore = _props$store2.ProctorStore,
	          SessionStore = _props$store2.SessionStore;
	
	
	      if (!SessionStore.loading) {
	        if (ProctorStore.proctorGroups.length > 0) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'wrap wrap--brief' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'block-list' },
	              ProctorStore.proctorGroups.map(function (key, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i, className: 'block-list__block media--alt' },
	                  _this4.renderIcon(key.icon),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'media__copy' },
	                    _react2.default.createElement(
	                      'strong',
	                      { className: 'block-list__title' },
	                      key.title
	                    ),
	                    _react2.default.createElement('div', {
	                      className: 'block-list__description',
	                      dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(key.description) }
	                    }),
	                    _this4.renderButton(_this4.proctorTypeModule(key.proctorTypes), key)
	                  )
	                );
	              })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'span',
	              { className: 'no-results' },
	              translation.no_groups,
	              ' ',
	              _react2.default.createElement(
	                'button',
	                { className: 'btn--link', onClick: this.messageInstructor },
	                translation.no_groups_button
	              )
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          automatedOnly = _props.automatedOnly,
	          translation = _props.translation,
	          scheduleClosed = _props.scheduleClosed;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      var toUserSid = null;
	
	      if (SessionStore.courseData.instructor) {
	        toUserSid = SessionStore.courseData.instructor.sid;
	      } else {
	        if (SessionStore.hasSessionStorage) {
	          toUserSid = JSON.parse(sessionStorage.getItem('courseData')).instructor.sid;
	        } else {
	          toUserSid = JSON.parse((0, _helpers.getCookie)('courseData')).instructor.sid;
	        }
	      }
	
	      if (!automatedOnly || this.state.multipleAutomatedGroups && !scheduleClosed) {
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '-1', id: 'main-content', className: 'page', 'aria-labelledby': 'page-title' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { id: 'page-title', className: 'page__title' },
	                translation.page_title
	              )
	            )
	          ),
	          this.renderResults(),
	          _react2.default.createElement(_Drawer2.default, Object.assign({
	            content: this.state.drawerContent,
	            isOpen: this.state.drawerOpen,
	            parent: this,
	            proctorGroupSid: this.state.proctorGroupSid,
	            proctorLocationSid: this.state.proctorLocationSid,
	            proctorTypeSubCategorySid: this.state.proctorTypeSubCategorySid,
	            examSid: this.state.examSid,
	            sessionSid: this.state.sessionSid,
	            status: this.state.status,
	            accessCode: this.state.accessCode,
	            messageSid: this.state.messageSid,
	            toUserSid: toUserSid,
	            contextType: 'examSid',
	            contextId: this.state.examSid
	          }, this.props))
	        );
	      } else if (automatedOnly && this.state.noAutomatedGroup) {
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '-1', id: 'main-content', className: 'page' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--medium' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title panel__title--alt' },
	              translation.no_automated_group.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.no_automated_group.body
	            )
	          )
	        );
	      } else if (automatedOnly && this.state.status && this.state.proctorLocationSid) {
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '-1', id: 'main-content', className: 'page' },
	          _react2.default.createElement(_ScheduleAutomated2.default, Object.assign({
	            parent: this,
	            examSid: (0, _helpers.getURLSegment)(this, 3),
	            sessionSid: (0, _helpers.getURLSegment)(this, 5),
	            status: this.state.status,
	            proctorLocationSid: this.state.proctorLocationSid
	          }, this.props))
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ChooseProctorType;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ChooseProctorType')(ChooseProctorType);
	
	// Questions
	// * Should instructor as proctor be mutually exclusive?
	// * Should anything that is not mutually exclusive always go to the find a proctor page?

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _ExamDetailsCompleted = __webpack_require__(803);
	
	var _ExamDetailsCompleted2 = _interopRequireDefault(_ExamDetailsCompleted);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExamCardClosed = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamCardClosed, _React$Component);
	
	  function ExamCardClosed() {
	    _classCallCheck(this, ExamCardClosed);
	
	    return _possibleConstructorReturn(this, (ExamCardClosed.__proto__ || Object.getPrototypeOf(ExamCardClosed)).apply(this, arguments));
	  }
	
	  _createClass(ExamCardClosed, [{
	    key: 'startRetake',
	    value: function startRetake(e) {
	      e.preventDefault();
	
	      this.props.store.ScheduleStore.retakeSession(this.props.exam.sid, this.props.exam.examSession.sid, e.target.href);
	    }
	  }, {
	    key: 'renderMessageButton',
	    value: function renderMessageButton(examSid) {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: 'btn btn--inverse--alt',
	          onClick: function onClick() {
	            _this2.props.messageInstructor(examSid);
	          }
	        },
	        _react2.default.createElement(icons.iconEnvelope, null),
	        translation.message_button
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          translation = _props.translation,
	          exam = _props.exam;
	      var attemptsRemaining = exam.examSession.examConfiguration.attemptsRemaining;
	
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'panel' },
	        _react2.default.createElement(
	          'header',
	          { className: 'panel__header panel__header--closed' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            exam.type.toLowerCase() === 'online' && _react2.default.createElement(
	              'i',
	              { className: 'panel__icn' },
	              _react2.default.createElement(icons.iconLaptop, null)
	            ),
	            exam.type.toLowerCase() === 'written' && _react2.default.createElement(
	              'i',
	              { className: 'panel__icn' },
	              _react2.default.createElement(icons.iconPencilPaper, null)
	            ),
	            exam.title,
	            ' (',
	            translation.closed,
	            ')'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__tools' },
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'message-instructor',
	              renderFeatureCallback: function renderFeatureCallback() {
	                return _this3.renderMessageButton(exam.sid);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          attemptsRemaining >= 1 && !this.props.schedulingClosed && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            attemptsRemaining > 1 && _react2.default.createElement(
	              'strong',
	              {
	                className: 'cta__copy'
	              },
	              translation.retake_cta.heading_plural.replace('%remaining%', attemptsRemaining)
	            ),
	            attemptsRemaining === 1 && _react2.default.createElement(
	              'strong',
	              {
	                className: 'cta__copy'
	              },
	              translation.retake_cta.heading.replace('%remaining%', attemptsRemaining)
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'cta__btn', to: 'schedule-session/exam/' + exam.sid + '/session/' + exam.examSession.sid + '/configuration/' + exam.configuration.sid,
	                onClick: function onClick(e) {
	                  _this3.startRetake(e);
	                }
	              },
	              _react2.default.createElement(icons.iconRefresh, { className: 'icon' }),
	              translation.retake_cta.button
	            )
	          ),
	          _react2.default.createElement(_ExamDetailsCompleted2.default, this.props)
	        )
	      );
	    }
	  }]);
	
	  return ExamCardClosed;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamCardClosed')(ExamCardClosed);

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _ExamDetails = __webpack_require__(79);
	
	var _ExamDetails2 = _interopRequireDefault(_ExamDetails);
	
	var _RequestedDates = __webpack_require__(356);
	
	var _RequestedDates2 = _interopRequireDefault(_RequestedDates);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExamCardNeedsProctor = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamCardNeedsProctor, _React$Component);
	
	  function ExamCardNeedsProctor() {
	    _classCallCheck(this, ExamCardNeedsProctor);
	
	    return _possibleConstructorReturn(this, (ExamCardNeedsProctor.__proto__ || Object.getPrototypeOf(ExamCardNeedsProctor)).apply(this, arguments));
	  }
	
	  _createClass(ExamCardNeedsProctor, [{
	    key: 'renderMessageButton',
	    value: function renderMessageButton(examSid) {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: 'btn btn--inverse--alt',
	          onClick: function onClick() {
	            _this2.props.messageInstructor(examSid);
	          }
	        },
	        _react2.default.createElement(icons.iconEnvelope, null),
	        translation.message_button
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          translation = _props.translation,
	          exam = _props.exam;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'panel', 'aria-labelledby': 'exam-title-heading' },
	        _react2.default.createElement(
	          'header',
	          { className: 'panel__header panel__header--ready' },
	          _react2.default.createElement(
	            'h3',
	            { id: 'exam-title-heading', className: 'panel__title' },
	            exam.type.toLowerCase() === 'online' && _react2.default.createElement(
	              'i',
	              { className: 'panel__icn' },
	              _react2.default.createElement(icons.iconLaptop, null)
	            ),
	            exam.type.toLowerCase() === 'written' && _react2.default.createElement(
	              'i',
	              { className: 'panel__icn' },
	              _react2.default.createElement(icons.iconPencilPaper, null)
	            ),
	            exam.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__tools' },
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'message-instructor',
	              renderFeatureCallback: function renderFeatureCallback() {
	                return _this3.renderMessageButton(exam.sid);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          !this.props.schedulingClosed && this.props.schedulingOpen && exam.examSession.examConfiguration.approved && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            !this.props.showWarning && _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.proctor_cta.heading
	            ),
	            this.props.showWarning && Math.floor(this.props.daysLeft) >= 1 && _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.closing_soon_cta.heading.replace('%remaining%', Math.floor(this.props.daysLeft)),
	              ' ',
	              _moment2.default.utc(this.props.scheduleCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'),
	              '.'
	            ),
	            this.props.showWarning && Math.floor(this.props.daysLeft) <= 0 && _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.closing_soon_cta.heading_today,
	              ' ',
	              _moment2.default.utc(this.props.scheduleCloseDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'),
	              '.'
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'cta__btn btn--icn-right',
	                to: 'schedule-session/exam/' + exam.sid + '/session/' + exam.examSession.sid + '/configuration/' + exam.examSession.examConfiguration.sid
	              },
	              translation.proctor_cta.button,
	              _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	            )
	          ),
	          (!this.props.schedulingOpen && !this.props.schedulingClosed || !this.props.schedulingClosed && this.props.schedulingOpen && !exam.examSession.examConfiguration.approved) && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.not_open_cta.heading
	            )
	          ),
	          this.props.schedulingClosed && !this.props.hasAutomated && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.closed_cta.heading
	            )
	          ),
	          exam.examSession.messagingConfirmations && !this.props.schedulingClosed && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__heading' },
	              translation.accepted_dates
	            ),
	            exam.examSession.messagingConfirmations.map(function (confirmation, i) {
	              return _react2.default.createElement(_RequestedDates2.default, Object.assign({
	                key: i,
	                external: 'true',
	                confirmedDate: confirmation.confirmedDate,
	                confirmedDateExpiration: confirmation.confirmedDateExpiration,
	                thisExamSid: exam.sid,
	                thisSessionSid: exam.examSession.sid,
	                proctor: confirmation.proctorAccountName,
	                proctorAccountLocationSid: confirmation.proctorAccountLocationSid,
	                messageSid: confirmation.sid
	              }, _this3.props));
	            })
	          ),
	          exam.examSession.examConfiguration.approved && _react2.default.createElement(_ExamDetails2.default, Object.assign({ scheduleWindow: true }, this.props))
	        )
	      );
	    }
	  }]);
	
	  return ExamCardNeedsProctor;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamCardNeedsProctor')(ExamCardNeedsProctor);

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _ExamDetails = __webpack_require__(79);
	
	var _ExamDetails2 = _interopRequireDefault(_ExamDetails);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExamCardScheduled = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamCardScheduled, _React$Component);
	
	  function ExamCardScheduled() {
	    _classCallCheck(this, ExamCardScheduled);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (ExamCardScheduled.__proto__ || Object.getPrototypeOf(ExamCardScheduled)).call(this));
	
	    _this2.updateReconnectTime = function () {
	      // Force re-render to update the countdown
	      _this2.forceUpdate();
	    };
	
	    _this2.setAccessCode = _this2.setAccessCode.bind(_this2);
	    _this2.cancelSession = _this2.cancelSession.bind(_this2);
	    _this2.startReschedule = _this2.startReschedule.bind(_this2);
	    _this2.startSession = _this2.startSession.bind(_this2);
	    _this2.setCancelReason = _this2.setCancelReason.bind(_this2);
	    _this2.renderRBDisabled = _this2.renderRBDisabled.bind(_this2);
	    _this2.renderRBEnabled = _this2.renderRBEnabled.bind(_this2);
	    _this2.toggleChat = _this2.toggleChat.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ExamCardScheduled, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      var _props = this.props,
	          exam = _props.exam,
	          store = _props.store;
	      var examSession = exam.examSession;
	
	      var now = (0, _moment2.default)(store.SessionStore.currentTime);
	
	      this.state = {
	        accessCode: null,
	        examUrl: '',
	        onboardingVersion: 'old',
	        now: now
	
	        // If it’s a VTC session, we need to get the access code
	        // because for some reason the API response doesn’t have it
	      };if (examSession.schedulingModule === 'vtc') {
	        store.ExamStore.getExamSession(exam.sid, examSession.sid, this.setAccessCode);
	      }
	
	      // Get the current time
	      // (Uses background loading to prevent re-rendering)
	      var backgroundLoad = true;
	      store.SessionStore.getCurrentTime(backgroundLoad);
	
	      setInterval(function () {
	        var stateNow = _this3.state.now;
	
	        _this3.setState({ now: (0, _moment2.default)(stateNow).add(30, 'seconds') });
	      }, 30000);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          exam = _props2.exam,
	          store = _props2.store;
	      var SessionStore = store.SessionStore;
	      var examSession = exam.examSession;
	      var installSid = SessionStore.userData.installSid;
	
	
	      (0, _helpers.openExamDirect)(installSid, exam.sid, examSession.sid).then(function (response) {
	        _this4.setState({ examUrl: response.redirectUrl, onboardingVersion: response.version });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Clean up interval when component unmounts
	      if (this.reconnectTimer) {
	        clearInterval(this.reconnectTimer);
	      }
	    }
	  }, {
	    key: 'setAccessCode',
	    value: function setAccessCode(response) {
	      this.setState({
	        accessCode: response.data.accessKey
	      });
	    }
	  }, {
	    key: 'cancelSession',
	    value: function cancelSession(examSid, sessionSid, schedulingModule) {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	
	      var msg = {};
	
	      if (!this.props.schedulingClosed) {
	        msg = {
	          heading: translation.cancel_session.heading,
	          body: translation.cancel_session.body,
	          button: translation.cancel_session.button
	        };
	      } else {
	        msg = {
	          heading: translation.cancel_session_closed.heading,
	          body: translation.cancel_session_closed.body,
	          button: translation.cancel_session_closed.button
	        };
	      }
	
	      (0, _helpers.confirm)(msg, function () {
	        return _this5.cancelSessionReason(examSid, sessionSid, schedulingModule);
	      });
	    }
	  }, {
	    key: 'cancelSessionReason',
	    value: function cancelSessionReason(examSid, sessionSid, schedulingModule) {
	      var _this6 = this;
	
	      var _props3 = this.props,
	          store = _props3.store,
	          translation = _props3.translation;
	      var ScheduleStore = store.ScheduleStore;
	
	
	      var options = [{
	        label: translation.cancel_options.helper,
	        value: ''
	      }, {
	        label: translation.cancel_options.time.label,
	        value: 'changed-time'
	      }, {
	        label: translation.cancel_options.technical.label,
	        value: 'technical-issue'
	      }, {
	        label: translation.cancel_options.other.label,
	        value: 'other'
	      }];
	
	      var msg = {
	        heading: translation.cancel_reason.heading,
	        options: options,
	        button: translation.cancel_reason.button
	      };
	
	      var selectFunc = this.setCancelReason;
	      var callback = function callback() {
	        return ScheduleStore.cancelSession(examSid, sessionSid, schedulingModule, null, _this6.props.routing);
	      };
	
	      (0, _helpers.promptUser)(msg, selectFunc, callback);
	    }
	  }, {
	    key: 'setCancelReason',
	    value: function setCancelReason(cancellationMemo) {
	      this.props.store.ScheduleStore.cancellationMemo = cancellationMemo;
	    }
	  }, {
	    key: 'startReschedule',
	    value: function startReschedule(e, schedulingModule, proctorLocationSid, examSid, examSessionSid, courseSid) {
	      var tiered = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	
	      e.preventDefault();
	
	      var _this = this;
	
	      var callback = function callback() {
	        if (schedulingModule === 'b-virtual' || schedulingModule === 'examity' || schedulingModule === 'proctoru') {
	          _this.props.store.ProctorStore.proctorLocationSid = proctorLocationSid;
	          _this.props.parent.setState({ proctorGroupSid: null });
	          _this.props.toggleDrawer(null, _this.props.parent, 'ScheduleOnline');
	        } else if (schedulingModule === 'smarter-scheduling' && tiered) {
	          var proctorGroupSid = _this.props.exam.examSession.proctorGroupSid;
	          _this.props.parent.setState({ proctorGroupSid: proctorGroupSid });
	          _this.props.toggleDrawer(null, _this.props.parent, 'ScheduleHybrid');
	        } else if (schedulingModule === 'smarter-scheduling') {
	          _this.props.parent.setState({
	            proctorGroupSid: null,
	            proctorLocationSid: proctorLocationSid
	          });
	          _this.props.store.ProctorStore.proctorLocationSid = proctorLocationSid;
	          _this.props.toggleDrawer(null, _this.props.parent, 'ScheduleOnline');
	        } else if (schedulingModule === 'register-blast') {
	          _this.props.parent.setState({ proctorGroupSid: null });
	          _this.props.toggleDrawer(null, _this.props.parent, 'ScheduleRB');
	        } else {
	          _this.props.store.ExamStore.getExam(examSid, courseSid);
	          _this.props.parent.setState({ proctorGroupSid: null });
	          _this.props.toggleDrawer(null, _this.props.parent, 'ScheduleInstructor');
	        }
	      };
	
	      this.props.store.ExamStore.getExamSession(examSid, examSessionSid, callback);
	
	      this.props.parent.setState({
	        examSid: this.props.exam.sid,
	        sessionSid: this.props.exam.examSession.sid
	      });
	    }
	
	    /**
	     * Start an exam session
	     *
	     * @param {string} schedulingModule
	     * @param {string} workflowModule
	     */
	
	  }, {
	    key: 'startSession',
	    value: function startSession(schedulingModule, workflowModule) {
	      var exam = this.props.exam;
	
	      var examSid = exam.sid;
	      var sessionSid = exam.examSession.sid;
	      var drawerContent = null;
	
	      this.props.parent.setState({
	        exam: exam,
	        examSid: examSid,
	        sessionSid: sessionSid
	      });
	
	      if (schedulingModule === 'b-virtual') {
	        drawerContent = 'SessionStartBV';
	      } else if (schedulingModule === 'proctoru') {
	        drawerContent = 'SessionStartProctorU';
	      } else if (schedulingModule === 'examity') {
	        drawerContent = 'SessionStartExamity';
	      } else if (schedulingModule === 'automated') {
	        drawerContent = 'SessionStartAutomated';
	      } else if (workflowModule === 'hybrid-scheduling') {
	        drawerContent = 'SessionStartHybrid';
	      } else if (schedulingModule === 'vtc') {
	        drawerContent = 'SessionStartVTC';
	      } else {
	        drawerContent = 'SessionDetailStudent';
	      }
	
	      this.props.toggleDrawer(null, this.props.parent, drawerContent);
	    }
	  }, {
	    key: 'renderRBDisabled',
	    value: function renderRBDisabled() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'cta__subcopy' },
	        translation.rb_disabled
	      );
	    }
	  }, {
	    key: 'renderRBEnabled',
	    value: function renderRBEnabled() {
	      var _this7 = this;
	
	      var _props4 = this.props,
	          translation = _props4.translation,
	          exam = _props4.exam;
	
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: 'cta__btn btn--outline btn--negative',
	          onClick: function onClick() {
	            _this7.cancelSession(exam.sid, exam.examSession.sid, exam.examSession.schedulingModule);
	          }
	        },
	        _react2.default.createElement(icons.iconTimesCircle, null),
	        translation.reschedule_cta.cancel_button
	      );
	    }
	  }, {
	    key: 'toggleChat',
	    value: function toggleChat() {
	      if (!this.state.chat) {
	        this.setState({
	          chat: true
	        });
	      } else {
	        this.chat.show_full_view();
	      }
	    }
	  }, {
	    key: 'renderMessageButton',
	    value: function renderMessageButton(examSid) {
	      var _this8 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: 'btn btn--inverse--success',
	          onClick: function onClick() {
	            _this8.props.messageInstructor(examSid);
	          }
	        },
	        _react2.default.createElement(icons.iconEnvelope, null),
	        translation.message_button
	      );
	    }
	  }, {
	    key: 'renderRBReschedule',
	    value: function renderRBReschedule(schedulingModule, locationSid, examSid, sessionSid, courseSid) {
	      var _this9 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: 'cta__btn btn--outline',
	          onClick: function onClick(e) {
	            _this9.startReschedule(e, schedulingModule, locationSid, examSid, sessionSid, courseSid);
	          }
	        },
	        _react2.default.createElement(icons.iconCalendar, null),
	        translation.reschedule_cta.reschedule_button
	      );
	    }
	  }, {
	    key: 'renderSystemCheckAutomated',
	    value: function renderSystemCheckAutomated(showButton) {
	      var translation = this.props.translation;
	
	
	      if (showButton) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'btn-group__no-flex' },
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'btn  btn--outline btn--icn-right',
	              href: this.state.examUrl + '&systemCheck=true',
	              target: '_blank',
	              rel: 'opener'
	            },
	            translation.system_check,
	            _react2.default.createElement(icons.iconCircleRight, null)
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'btn btn--success btn--icn-right',
	              href: this.state.examUrl,
	              target: '_top',
	              rel: 'opener'
	            },
	            translation.start_exam,
	            _react2.default.createElement(icons.iconCircleRight, null)
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'a',
	          {
	            className: 'btn btn--success btn--icn-right',
	            href: this.state.examUrl,
	            target: '_top',
	            rel: 'opener'
	          },
	          translation.start_exam,
	          _react2.default.createElement(icons.iconCircleRight, null)
	        );
	      }
	    }
	  }, {
	    key: 'renderSystemCheckHybrid',
	    value: function renderSystemCheckHybrid(showButton, timeToSessionEnd, workflowModule) {
	      var _this10 = this;
	
	      var _props5 = this.props,
	          exam = _props5.exam,
	          translation = _props5.translation;
	
	
	      if (showButton && workflowModule !== 'hybrid-scheduling') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'btn-group__no-flex' },
	          timeToSessionEnd > 0 && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--success btn--icn-right',
	              onClick: function onClick() {
	                return _this10.startSession(exam.examSession.schedulingModule, workflowModule);
	              }
	            },
	            translation.start_exam,
	            _react2.default.createElement(icons.iconCircleRight, null)
	          )
	        );
	      } else if (timeToSessionEnd > 0) {
	        return _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn--success btn--icn-right',
	            onClick: function onClick() {
	              return _this10.startSession(exam.examSession.schedulingModule, workflowModule);
	            }
	          },
	          translation.start_exam,
	          _react2.default.createElement(icons.iconCircleRight, null)
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'RenderSessionPendingReconnect',
	    value: function RenderSessionPendingReconnect() {
	      var _this11 = this;
	
	      var _props6 = this.props,
	          exam = _props6.exam,
	          translation = _props6.translation;
	      var examSession = exam.examSession;
	
	      var reconnection = examSession.series.reconnection;
	      console.log(translation.session_pending_reconnect);
	      // Calculate remaining time
	      var now = (0, _moment2.default)().tz('UTC');
	      var endTime = (0, _moment2.default)(reconnection.attemptUntilDate).tz('UTC');
	      var duration = _moment2.default.duration(endTime.diff(now));
	
	      // Start/update the timer if not already running
	      if (!this.reconnectTimer && duration.asMilliseconds() > 0) {
	        this.reconnectTimer = setInterval(this.updateReconnectTime, 1000);
	      }
	
	      // Format the remaining time
	      var formatTime = function formatTime(duration) {
	        if (duration.asMilliseconds() <= 0) {
	          clearInterval(_this11.reconnectTimer);
	          return '00:00:00';
	        }
	
	        var hours = Math.floor(duration.asHours());
	        var minutes = duration.minutes();
	        var seconds = duration.seconds();
	
	        var _timeRemaining = '';
	        if (hours > 0) {
	          _timeRemaining += hours + ' hour' + (hours > 1 ? 's' : '') + ' ';
	        }
	        if (minutes > 0) {
	          _timeRemaining += minutes + ' minute' + (minutes > 1 ? 's' : '') + ' ';
	        }
	        if (seconds > 0) {
	          _timeRemaining += seconds + ' second' + (seconds > 1 ? 's' : '') + ' ';
	        }
	
	        return _timeRemaining.trim();
	      };
	
	      var timeRemaining = formatTime(duration);
	
	      if (duration.asMilliseconds() > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'reconnect-timer', style: { textAlign: 'center' } },
	          _react2.default.createElement(
	            'strong',
	            { className: 'cta__copy' },
	            translation.session_pending_reconnect.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'reconnect-timer__label cta__subcopy' },
	            translation.session_pending_reconnect.message
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'reconnect-timer__label cta__subcopy' },
	            translation.session_pending_reconnect.expires.replace('%timeRemaining%', timeRemaining)
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'btn btn--success btn--icn-right',
	              href: this.state.examUrl,
	              target: '_top',
	              rel: 'opener'
	            },
	            translation.session_pending_reconnect.button,
	            _react2.default.createElement(icons.iconCircleRight, null)
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'reconnect-timer', style: { textAlign: 'center' } },
	          _react2.default.createElement(
	            'strong',
	            { className: 'cta__copy' },
	            translation.session_pending_reconnect.title_expired
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'reconnect-timer__label cta__subcopy' },
	            translation.session_pending_reconnect.message_expired
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this12 = this;
	
	      var _props7 = this.props,
	          translation = _props7.translation,
	          store = _props7.store,
	          exam = _props7.exam;
	      var now = this.state.now;
	      var location = exam.examSession.location;
	      var userTimezone = store.SessionStore.userTimezone;
	      var examConfiguration = exam.examSession.examConfiguration;
	
	      var examOpen = false;
	      var sessionInProgress = false;
	      var sessionPendingReconnection = false;
	
	      var sessionTime = (0, _moment2.default)(exam.examSession.appointmentDate);
	      var sessionStartTime = (0, _moment2.default)(sessionTime).subtract(10, 'minutes');
	      var formattedTime = _moment2.default.utc(sessionStartTime).tz(userTimezone).format('M/D/YYYY [at] h:mma z');
	      var timeToSession = _moment2.default.duration(sessionTime.diff(now)).asMinutes();
	      var sessionEnd = (0, _moment2.default)(sessionTime).add(examConfiguration.duration, 'minutes').add(30, 'minutes');
	      var hybridSessionEnd = (0, _moment2.default)(sessionTime).add(30, 'minutes');
	      var timeToSessionEnd = _moment2.default.duration(sessionEnd.diff(now)).asMinutes();
	      var hybridTimeToSessionEnd = _moment2.default.duration(hybridSessionEnd.diff(now)).asMinutes();
	
	      // Max and min dates, used to make sure rescheduling is still allowed
	      var maxDate = (0, _moment2.default)(examConfiguration.examCloseDate).subtract(30, 'minutes').subtract(examConfiguration.duration, 'minutes').tz(userTimezone);
	
	      var minDate = null;
	      minDate = (0, _moment2.default)(examConfiguration.examOpenDate);
	      var timeDiff = _moment2.default.duration(minDate.diff(now)).asHours();
	
	      if (timeDiff < 0) {
	        minDate = now;
	      }
	
	      // Make sure the maxDate isn’t before the minDate
	      var maxDiff = _moment2.default.duration(maxDate.diff(minDate)).asMinutes();
	
	      // Make sure the exam is open
	      if (now.diff((0, _moment2.default)(examConfiguration.examOpenDate)) >= 0) {
	        examOpen = true;
	      }
	
	      var workflowModule = null;
	
	      if (exam && exam.examSession && exam.examSession.location) {
	        workflowModule = exam.examSession.location.workflowModule;
	      }
	
	      // If the exam session is automated or hybrid/hybrid scheduling
	      // and the session’s status is In Progress, we don’t want to allow
	      // the user to try to start again.
	      if (exam && exam.examSession && exam.examSession.status.toLowerCase() === 'in progress' && (exam.examSession.schedulingModule === 'automated' || exam.examSession.location.workflowModule === 'hybrid' || exam.examSession.location.workflowModule === 'hybrid-scheduling')) {
	        sessionInProgress = true;
	      }
	
	      // If the exam session is automated or hybrid/hybrid scheduling
	      // and the session’s status is Pending Reconnection, need to surface the reconnection link
	      if (exam && exam.examSession && exam.examSession.status.toLowerCase() === 'pending reconnection' && (exam.examSession.schedulingModule === 'automated' || exam.examSession.location.workflowModule === 'hybrid' || exam.examSession.location.workflowModule === 'hybrid-scheduling')) {
	        sessionPendingReconnection = true;
	      }
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'panel' },
	        _react2.default.createElement(
	          'header',
	          { className: 'panel__header panel__header--success' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            exam.type.toLowerCase() === 'online' && _react2.default.createElement(
	              'i',
	              { className: 'panel__icn' },
	              _react2.default.createElement(icons.iconLaptop, null)
	            ),
	            exam.type.toLowerCase() === 'written' && _react2.default.createElement(
	              'i',
	              { className: 'panel__icn' },
	              _react2.default.createElement(icons.iconPencilPaper, null)
	            ),
	            exam.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__tools' },
	            _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	              flagKey: 'message-instructor',
	              renderFeatureCallback: function renderFeatureCallback() {
	                return _this12.renderMessageButton(exam.sid);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          workflowModule === 'hybrid-scheduling' && now < sessionStartTime && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'cta__copy' },
	                translation.hybrid.upcoming_session,
	                '  ',
	                exam.examSession ? 'by ' + exam.examSession.location.friendlyName : ""
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'cta__subcopy' },
	                translation.hybrid.start_exam_button_appear.replace('%sessionStartTime%', formattedTime)
	              )
	            )
	          ),
	          workflowModule === 'hybrid-scheduling' && hybridTimeToSessionEnd <= 0 && _react2.default.createElement(
	            'div',
	            { className: 'cta missed' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'cta__copy' },
	                translation.hybrid.missed_session,
	                ' ',
	                exam.examSession ? 'by ' + exam.examSession.location.friendlyName + ' ' : "",
	                ' ',
	                translation.hybrid.missed_session_2
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'cta__subcopy' },
	                translation.hybrid.missed_sessionB
	              )
	            )
	          ),
	          sessionInProgress && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'cta__copy' },
	                translation.in_progress.generic.heading
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'cta__subcopy' },
	                translation.in_progress.generic.body
	              )
	            )
	          ),
	          sessionPendingReconnection && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'div',
	              null,
	              this.RenderSessionPendingReconnect()
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'panel__section' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__heading' },
	              sessionPendingReconnection ? translation.session_pending_reconnect.heading : translation.scheduled.heading,
	              exam.examSession.schedulingModule === 'automated' && examOpen && !sessionInProgress && !sessionPendingReconnection && this.state.onboardingVersion === 'new' && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: 'system-check',
	                renderFeatureCallback: function renderFeatureCallback() {
	                  return _this12.renderSystemCheckAutomated(true);
	                },
	                renderDefaultCallback: function renderDefaultCallback() {
	                  return _this12.renderSystemCheckAutomated(false);
	                }
	              }),
	              exam.examSession.schedulingModule === 'automated' && examOpen && !sessionInProgress && !sessionPendingReconnection && this.state.onboardingVersion !== 'new' && _react2.default.createElement(
	                'a',
	                {
	                  className: 'btn btn--success btn--icn-right',
	                  href: this.state.examUrl,
	                  target: '_top',
	                  rel: 'opener'
	                },
	                translation.start_exam,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              ),
	              workflowModule === 'hybrid-scheduling' && now >= sessionStartTime && !sessionInProgress && !sessionPendingReconnection && this.state.onboardingVersion === 'new' && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: 'system-check',
	                renderFeatureCallback: function renderFeatureCallback() {
	                  return _this12.renderSystemCheckHybrid(true, hybridTimeToSessionEnd, workflowModule);
	                },
	                renderDefaultCallback: function renderDefaultCallback() {
	                  return _this12.renderSystemCheckHybrid(false, hybridTimeToSessionEnd, workflowModule);
	                }
	              }),
	              workflowModule === 'hybrid-scheduling' && now >= sessionStartTime && !sessionInProgress && !sessionPendingReconnection && this.state.onboardingVersion !== 'new' && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--success btn--icn-right',
	                  onClick: function onClick() {
	                    return _this12.startSession(exam.examSession.schedulingModule, workflowModule);
	                  }
	                  // Disables Start button if session was missed
	                  , disabled: timeToSessionEnd <= 0 ? true : false
	                },
	                translation.start_exam,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              ),
	              exam.examSession.schedulingModule !== 'automated' && workflowModule !== 'hybrid-scheduling' && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--success btn--icn-right',
	                  onClick: function onClick() {
	                    _this12.startSession(exam.examSession.schedulingModule);
	                  }
	                },
	                (exam.examSession.schedulingModule === 'b-virtual' || exam.examSession.schedulingModule === 'examity' || exam.examSession.schedulingModule === 'proctoru') && _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.start_exam
	                ),
	                exam.examSession.schedulingModule !== 'b-virtual' && exam.examSession.schedulingModule !== 'examity' && exam.examSession.schedulingModule !== 'proctoru' && _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.session_details
	                ),
	                _react2.default.createElement(icons.iconCircleRight, null)
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'data' },
	              exam.examSession.schedulingModule !== 'vtc' && exam.examSession.schedulingModule !== 'automated' && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.scheduled.date
	                ),
	                _moment2.default.utc(exam.examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	              ),
	              (exam.examSession.schedulingModule === 'b-virtual' || exam.examSession.schedulingModule === 'examity' || exam.examSession.schedulingModule === 'proctoru' || exam.examSession.schedulingModule === 'automated' || workflowModule === 'hybrid-scheduling') && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.scheduled.type
	                ),
	                translation.scheduled[exam.examSession.schedulingModule] || translation.scheduled[workflowModule]
	              ),
	              exam.examSession.schedulingModule === 'vtc' && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.scheduled.type
	                ),
	                translation.scheduled.vtc
	              ),
	              exam.examSession.schedulingModule === 'instructor-as-proctor' && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.scheduled.proctor
	                ),
	                translation.scheduled.instructor
	              ),
	              exam.examSession.schedulingModule !== 'b-virtual' && exam.examSession.schedulingModule !== 'examity' && exam.examSession.schedulingModule !== 'proctoru' && exam.examSession.schedulingModule !== 'vtc' && exam.examSession.schedulingModule !== 'automated' && workflowModule !== 'hybrid-scheduling' && location && _react2.default.createElement(
	                'li',
	                { className: 'adr' },
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.scheduled.location
	                ),
	                location.name && _react2.default.createElement(
	                  'span',
	                  { className: 'fn org' },
	                  location.name
	                ),
	                (location.address1 || location.address2) && _react2.default.createElement(
	                  'span',
	                  { className: 'street-address' },
	                  location.address1,
	                  _react2.default.createElement('br', null),
	                  location.address2 || ''
	                ),
	                location.place && _react2.default.createElement(
	                  'span',
	                  { className: 'locality' },
	                  location.place,
	                  ', '
	                ),
	                location.region && _react2.default.createElement(
	                  'span',
	                  { className: 'region' },
	                  location.region,
	                  ' '
	                ),
	                location.postalCode && _react2.default.createElement(
	                  'span',
	                  { className: 'postal-code' },
	                  location.postalCode
	                ),
	                location.country && _react2.default.createElement(
	                  'span',
	                  { className: 'country' },
	                  location.country
	                )
	              ),
	              exam.examSession.schedulingModule !== 'b-virtual' && exam.examSession.schedulingModule !== 'examity' && exam.examSession.schedulingModule !== 'instructor-as-proctor' && exam.examSession.schedulingModule !== 'proctoru' && exam.examSession.schedulingModule !== 'vtc' && workflowModule !== 'hybrid-scheduling' && exam.examSession.proctor && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  { className: 'subtitle' },
	                  translation.scheduled.proctor
	                ),
	                exam.examSession.proctor.accountName && exam.examSession.proctor.accountName,
	                !exam.examSession.proctor.accountName && exam.examSession.proctor.firstName && exam.examSession.proctor.firstName
	              ),
	              exam.examSession.schedulingModule !== 'b-virtual' && exam.examSession.schedulingModule !== 'examity' && exam.examSession.schedulingModule !== 'proctoru' && !sessionInProgress && !sessionPendingReconnection && (timeToSession > 0 || exam.examSession.schedulingModule === 'smarter-scheduling') && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.reschedule.heading
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex' },
	                    exam.examSession.schedulingModule !== 'ad-hoc' && exam.examSession.schedulingModule !== 'messaging' && exam.examSession.schedulingModule !== 'vtc' && exam.examSession.schedulingModule !== 'instructor-as-proctor' && exam.examSession.schedulingModule !== 'automated' && exam.examSession.schedulingModule !== 'register-blast' &&
	                    //workflowModule !== 'hybrid-scheduling' &&
	                    !this.props.schedulingClosed && _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'cta__btn btn--outline flex-1',
	                        onClick: function onClick(e) {
	                          _this12.startReschedule(e, exam.examSession.schedulingModule, exam.examSession.location.sid, exam.sid, exam.examSession.sid, exam.courseSid, workflowModule === 'hybrid-scheduling');
	                        }
	                      },
	                      _react2.default.createElement(icons.iconCalendar, null),
	                      translation.reschedule.reschedule_button
	                    ),
	                    exam.examSession.schedulingModule === 'register-blast' && workflowModule !== 'hybrid-scheduling' && !this.props.schedulingClosed && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                      flagKey: 'register-blast-reschedule',
	                      renderFeatureCallback: function renderFeatureCallback() {
	                        return _this12.renderRBReschedule(exam.examSession.schedulingModule, exam.examSession.location.sid, exam.sid, exam.examSession.sid, exam.courseSid);
	                      }
	                    }),
	                    exam.examSession.schedulingModule !== 'register-blast' && _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'cta__btn btn--outline btn--negative flex-1',
	                        onClick: function onClick() {
	                          _this12.cancelSession(exam.sid, exam.examSession.sid, exam.examSession.schedulingModule);
	                        }
	                      },
	                      _react2.default.createElement(icons.iconTimesCircle, null),
	                      translation.reschedule.cancel_button
	                    ),
	                    exam.examSession.schedulingModule === 'register-blast' && _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                      flagKey: 'disable-register-blast',
	                      renderFeatureCallback: this.renderRBDisabled,
	                      renderDefaultCallback: this.renderRBEnabled
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_ExamDetails2.default, Object.assign({ scheduleWindow: true }, this.props)),
	          (exam.examSession.schedulingModule === 'b-virtual' || exam.examSession.schedulingModule === 'examity' || exam.examSession.schedulingModule === 'proctoru' && exam.examSession.status.toLowerCase() !== 'in progress') && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            timeToSession <= 0 && timeToSession > -15 && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'cta__copy' },
	                translation.reschedule_cta.heading_late
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'cta__subcopy' },
	                translation.reschedule_cta.body_late.replace('%time%', _moment2.default.utc(exam.examSession.appointmentDate).tz(userTimezone).add(15, 'minutes').format('h:mma z'))
	              )
	            ),
	            (timeToSession > 0 || timeToSession < -15) && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'cta__copy' },
	                translation.reschedule_cta.heading
	              ),
	              !this.props.schedulingClosed && maxDiff > 0 && _react2.default.createElement(
	                'button',
	                {
	                  className: 'cta__btn btn--outline',
	                  onClick: function onClick(e) {
	                    _this12.startReschedule(e, exam.examSession.schedulingModule, exam.examSession.location.sid, exam.sid, exam.examSession.sid, exam.courseSid);
	                  }
	                },
	                _react2.default.createElement(icons.iconCalendar, null),
	                translation.reschedule_cta.reschedule_button
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'cta__btn btn--outline btn--negative',
	                  onClick: function onClick() {
	                    _this12.cancelSession(exam.sid, exam.examSession.sid, exam.examSession.schedulingModule);
	                  }
	                },
	                _react2.default.createElement(icons.iconTimesCircle, null),
	                translation.reschedule_cta.cancel_button
	              )
	            )
	          ),
	          exam.examSession.schedulingModule === 'proctoru' && exam.examSession.status.toLowerCase() === 'in progress' && timeToSessionEnd > 0 && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.in_progress.proctoru.heading
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'cta__subcopy' },
	              translation.in_progress.proctoru.body
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'cta__btn btn--outline btn--icn-right',
	                onClick: function onClick() {
	                  _this12.startSession(exam.examSession.schedulingModule);
	                }
	              },
	              translation.in_progress.proctoru.button,
	              _react2.default.createElement(icons.iconCircleRight, null)
	            )
	          ),
	          exam.examSession.schedulingModule === 'proctoru' && exam.examSession.status.toLowerCase() === 'in progress' && timeToSessionEnd <= 0 && _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.done.proctoru.heading
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'cta__subcopy' },
	              translation.done.proctoru.body
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                className: 'cta__btn btn--outline btn--icn-right',
	                to: 'support/add'
	              },
	              translation.done.proctoru.button,
	              _react2.default.createElement(icons.iconCircleRight, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExamCardScheduled;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamCardScheduled')(ExamCardScheduled);

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _currencyFormatter = __webpack_require__(71);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var PricingProctorCollected = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PricingProctorCollected, _React$Component);
	
	  function PricingProctorCollected() {
	    _classCallCheck(this, PricingProctorCollected);
	
	    return _possibleConstructorReturn(this, (PricingProctorCollected.__proto__ || Object.getPrototypeOf(PricingProctorCollected)).apply(this, arguments));
	  }
	
	  _createClass(PricingProctorCollected, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          fees = _props.fees,
	          translation = _props.translation;
	
	      var userTotal = _currencyFormatter2.default.format(fees.userTotal, { code: fees.currencyCode });
	
	      if (fees) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__title' },
	            translation.title
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.body.replace('%fees%', userTotal)
	          ),
	          _react2.default.createElement('span', null)
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return PricingProctorCollected;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PricingProctorCollected')(PricingProctorCollected);

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(56);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _BlackoutList = __webpack_require__(146);
	
	var _BlackoutList2 = _interopRequireDefault(_BlackoutList);
	
	var _Payments = __webpack_require__(99);
	
	var _Payments2 = _interopRequireDefault(_Payments);
	
	var _Pricing = __webpack_require__(123);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	var _ScheduleDate = __webpack_require__(362);
	
	var _ScheduleDate2 = _interopRequireDefault(_ScheduleDate);
	
	var _ScheduleTable = __webpack_require__(363);
	
	var _ScheduleTable2 = _interopRequireDefault(_ScheduleTable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	// import DOMPurify from 'dompurify';
	
	// Components
	
	
	// import ssLogo from '../../../img/logo-alt.png';
	
	var ScheduleHybrid = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleHybrid, _React$Component);
	
	  function ScheduleHybrid() {
	    var _this2 = this;
	
	    _classCallCheck(this, ScheduleHybrid);
	
	    // Set initial state
	    var _this = _possibleConstructorReturn(this, (ScheduleHybrid.__proto__ || Object.getPrototypeOf(ScheduleHybrid)).call(this));
	
	    _this.setLocation = function (i, data) {
	      var ScheduleStore = _this.props.store.ScheduleStore;
	
	
	      ScheduleStore.onlineLocation = data[0].location.sid;
	    };
	
	    _this.getSid = function (segment) {
	      // Get the exam sid from the URL
	      var pathname = '';
	
	      if (typeof _this.props !== 'undefined') {
	        pathname = _this.props.routing.location.pathname;
	      } else {
	        pathname = _this.routing.location.pathname;
	      }
	
	      var pathArray = pathname.split('/');
	
	      if (pathArray[0] === '') {
	        pathArray.splice(0, 1);
	      }
	
	      var sid = pathArray[segment];
	      return sid;
	    };
	
	    _this.setStep = function (e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      _this.setState({
	        step: step
	      }, function () {
	        // Hide the close button on the last step so the
	        // student has to click the return to dashboard button
	        if (this.state.step === 4) {
	          this.props.store.SessionStore.hideDrawerClose = true;
	        }
	      });
	    };
	
	    _this.nextStep = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      _this.setState({
	        step: _this.state.step + 1
	      });
	    };
	
	    _this.statusClass = function (step) {
	      if (_this.state.step === step) {
	        return 'slide-active';
	      } else if (_this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    };
	
	    _this.setSlot = function (appointmentStartDate, appointmentEndDate, proctorLocationSid, schedulingModule, calendarSid) {
	      var fees = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	      var ScheduleStore = _this.props.store.ScheduleStore;
	
	
	      if (fees) {
	        _this.setState({ fees: fees });
	      }
	
	      _this.setState({
	        appointmentStartDate: appointmentStartDate,
	        appointmentEndDate: appointmentEndDate,
	        proctorLocationSid: proctorLocationSid,
	        calendarSid: calendarSid,
	        schedulingModule: schedulingModule
	      }, function () {
	        if (schedulingModule === 'register-blast') {
	          // If this is a RegisterBlast location
	          // get a RB scheduling token.
	          ScheduleStore.getSchedulingToken(_this.state.examSid, _this.state.sessionSid, proctorLocationSid, appointmentStartDate);
	        }
	      });
	    };
	
	    _this.confirmSlot = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	        var _this$props, reschedule, store, proctorGroupSid, _this$state, appointmentStartDate, appointmentEndDate, calendarSid, examSid, proctorLocationSid, schedulingModule, sessionSid, ExamStore, ScheduleStore, StudentStore, duration, schedulingURL, win, int, payload;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this$props = _this.props, reschedule = _this$props.reschedule, store = _this$props.store, proctorGroupSid = _this$props.proctorGroupSid;
	                _this$state = _this.state, appointmentStartDate = _this$state.appointmentStartDate, appointmentEndDate = _this$state.appointmentEndDate, calendarSid = _this$state.calendarSid, examSid = _this$state.examSid, proctorLocationSid = _this$state.proctorLocationSid, schedulingModule = _this$state.schedulingModule, sessionSid = _this$state.sessionSid;
	                ExamStore = store.ExamStore, ScheduleStore = store.ScheduleStore, StudentStore = store.StudentStore;
	                duration = ExamStore.examSession.examConfiguration.duration;
	                schedulingURL = ScheduleStore.schedulingURL;
	
	
	                if (schedulingModule === 'register-blast') {
	                  try {
	                    win = window.open(reschedule ? schedulingURL.replace('/schedule', '/reschedule') : schedulingURL);
	
	
	                    e.preventDefault();
	
	                    int = setInterval(function () {
	                      try {
	                        if (win.closed) {
	                          clearInterval(int);
	                          (0, _helpers.closeDrawer)(null, _this.props.parent, '/', StudentStore.getStudentExams);
	                        }
	                      } catch (err) {}
	                    }, 1000);
	                  } catch (err) {
	                    console.warn('window.open didn’t work.');
	                  }
	                } else {
	                  payload = {
	                    appointmentStartDateTime: appointmentStartDate,
	                    appointmentEndDateTime: appointmentEndDate,
	                    type: schedulingModule,
	                    proctorLocationSid: proctorLocationSid
	                  };
	
	
	                  if (!payload.appointmentEndDateTime) {
	                    payload.appointmentEndDateTime = (0, _moment2.default)(appointmentStartDate).add(duration, 'minutes');
	                  }
	
	                  if (calendarSid) {
	                    payload.calendarSid = calendarSid;
	                  }
	
	                  if (!reschedule) {
	                    // When scheduling a SmarterScheduling
	                    // session, the API expects an external
	                    // reservation ID, so we need to make one.
	                    payload.proctorGroupSid = proctorGroupSid;
	                    ScheduleStore.createReservation(payload, examSid, sessionSid, function () {
	                      return _this.nextStep(null);
	                    });
	                  } else {
	                    ScheduleStore.rescheduleAppointment(examSid, sessionSid, payload, function () {
	                      _this.setStep(null, 6);
	                    }, function () {
	                      _this.setStep(null, 7);
	                    });
	                  }
	                }
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.toggleSubmitButton = function () {
	      _this.setState(function (prevState) {
	        return {
	          isSubmitDisabled: !prevState.isSubmitDisabled
	        };
	      });
	    };
	
	    _this.renderFeeDescriptions = function () {
	      var translation = _this.props.translation;
	      var fees = _this.state.fees;
	      var PaymentStore = _this.props.store.PaymentStore;
	
	
	      if (PaymentStore.schedulingRuleInformation.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'scheduling-rule--terms' },
	            _react2.default.createElement(
	              'b',
	              null,
	              translation.scheduling_fees.terms
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'table-list', id: 'dash-bullet' },
	            PaymentStore.schedulingRuleInformation.map(function (rule, i) {
	              if (rule.feeAmount > 0) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    key: i,
	                    className: 'scheduling-rule--list-item'
	                  },
	                  rule.isRefundEligible ? '' + translation.scheduling_fees.refundable.replace('%feeName%', rule.name) : '' + translation.scheduling_fees.nonrefundable.replace('%feeName%', rule.name)
	                );
	              }
	              return null;
	            }),
	            _react2.default.createElement(
	              'li',
	              {
	                key: 'default',
	                className: 'scheduling-rule--list-item'
	              },
	              translation.scheduling_fees.default_terms
	            )
	          )
	        );
	      } else if (fees && fees.userTotal > 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'scheduling-rule--terms' },
	            _react2.default.createElement(
	              'b',
	              null,
	              translation.scheduling_fees.terms
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'table-list', id: 'dash-bullet' },
	            _react2.default.createElement(
	              'li',
	              {
	                key: 'default',
	                className: 'scheduling-rule--list-item'
	              },
	              translation.scheduling_fees.default_terms
	            )
	          )
	        );
	      }
	      return null;
	    };
	
	    _this.renderPricingButton = function () {
	      var translation = _this.props.translation;
	      var fees = _this.state.fees;
	      var PaymentStore = _this.props.store.PaymentStore;
	
	
	      if (fees) {
	        if (fees.userTotal > 0) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { id: 'scheduling-fee-agreement--div' },
	              _react2.default.createElement(
	                'span',
	                { id: 'scheduling-fee-agreement--toggle' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  id: 'scheduling-fee-agreement',
	                  className: 'switch-input',
	                  defaultChecked: false,
	                  onChange: _this.toggleSubmitButton,
	                  onKeyDown: _helpers.handleSwitchInputKeys
	                }),
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'switch-label',
	                    htmlFor: 'scheduling-fee-agreement'
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.scheduling_fees.meta
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'scheduling-fee-agreement' },
	                translation.scheduling_fees.confirmation
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                disabled: _this.state.isSubmitDisabled,
	                className: 'btn',
	                onClick: function onClick(e) {
	                  _this.nextStep(e);
	                }
	              },
	              translation.next
	            )
	          );
	        }
	
	        if (fees.userTotal === 0 && PaymentStore.schedulingRuleInformation.length > 0) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { id: 'scheduling-fee-agreement--div' },
	              _react2.default.createElement(
	                'span',
	                { id: 'scheduling-fee-agreement--toggle' },
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  id: 'scheduling-fee-agreement',
	                  className: 'switch-input',
	                  defaultChecked: false,
	                  onChange: _this.toggleSubmitButton,
	                  onKeyDown: _helpers.handleSwitchInputKeys
	                }),
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'switch-label',
	                    htmlFor: 'scheduling-fee-agreement'
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.scheduling_fees.meta
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'scheduling-fee-agreement' },
	                translation.scheduling_fees.confirmation
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                onClick: _this.submitSchedule,
	                disabled: _this.state.isSubmitDisabled
	              },
	              translation.schedule
	            )
	          );
	        } else if (fees.userTotal === 0) {
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: _this.submitSchedule
	            },
	            translation.schedule
	          );
	        }
	      }
	    };
	
	    _this.submitSchedule = function () {
	      var _this$state2 = _this.state,
	          appointmentStartDate = _this$state2.appointmentStartDate,
	          examSid = _this$state2.examSid,
	          fees = _this$state2.fees,
	          proctorLocationSid = _this$state2.proctorLocationSid,
	          schedulingModule = _this$state2.schedulingModule,
	          sessionSid = _this$state2.sessionSid;
	      var _this$props2 = _this.props,
	          store = _this$props2.store,
	          proctorTypeSubCategorySid = _this$props2.proctorTypeSubCategorySid;
	      var ScheduleStore = store.ScheduleStore;
	
	
	      var payload = {
	        appointmentDateTime: appointmentStartDate,
	        amount: fees.userTotal,
	        currency: fees.currencyCode,
	        proctorTypeSubCategorySid: proctorTypeSubCategorySid,
	        proctorLocationSid: proctorLocationSid,
	        type: schedulingModule
	      };
	
	      ScheduleStore.createAppointment(examSid, sessionSid, payload, function () {
	        _this.setStep(null, 6);
	      });
	    };
	
	    _this.startOver = function () {
	      var ScheduleStore = _this.props.store.ScheduleStore;
	
	
	      ScheduleStore.checkOnlineReservation(_this.state.examSid, _this.state.sessionSid, function () {
	        _this.setStep(null, 1);
	      }, _this);
	    };
	
	    _this.state = {
	      step: 1,
	      appointmentStartDate: null,
	      appointmentEndDate: null,
	      examSid: null,
	      sessionSid: null,
	      complete: false,
	      isSubmitDisabled: true
	    };
	    return _this;
	  }
	
	  _createClass(ScheduleHybrid, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var PaymentStore = this.props.store.PaymentStore;
	      var fees = prevState.fees;
	
	
	      var newFees = this.state.fees;
	
	      if (fees && fees.schedulingRuleInformation && newFees && newFees.schedulingRuleInformation) {
	        // No-op
	      } else if (fees && fees.schedulingRuleInformation && !newFees) {
	        // If the fees object goes away, remove the rule info
	        PaymentStore.schedulingRuleInformation = [];
	      } else if (newFees && newFees.schedulingRuleInformation) {
	        // Else, update it
	        PaymentStore.schedulingRuleInformation = newFees.schedulingRuleInformation;
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	      ScheduleStore.onlineDate = null;
	
	      // Set the examSid and sessionSid
	      if (!this.props.reschedule && !this.props.skipUrl) {
	        this.setState({
	          examSid: this.getSid(2),
	          sessionSid: this.getSid(4)
	        });
	      } else {
	        this.setState({
	          examSid: this.props.examSid,
	          sessionSid: this.props.sessionSid
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	      // Get Session Proctor info that is needed for getting and displaying cost on splash page
	      /*
	      if (!this.state.proctorLocationSid) {
	        ProctorStore.getSessionProctorGroups(this.state.examSid, this.state.sessionSid, null, this.initialFee)
	      }
	        */
	      // Reset any old schedule data
	
	      ScheduleStore.resetData();
	
	      // TODO: may remove this as we are not supporting register blast in the first go
	      // Setup window listener to find when scheduling is complete
	      window.addEventListener('message', function (event) {
	        if (event.origin === _config.config.domain && event.data === "SpRbScheduled__Confirmed") {
	          _this3.setState({
	            complete: true
	          });
	        }
	      });
	    }
	
	    // Next two functions set fees to state for displaying before scheduling an exam
	    /*
	    initialFee = (data) => {
	      const { ProctorStore } = this.props.store;
	      let proctorLocationList = data.filter(location => location.workflowModule === 'hybrid-scheduling')
	      let proctorLocation = proctorLocationList[0].proctorLocationSids;
	       proctorLocationList.forEach(location => {
	        if (location.sid === this.props.proctorGroupSid) {
	          proctorLocation = location.proctorLocationSids;
	        }
	      })
	       this.setState({
	        initialProctorLocationSid: proctorLocation
	      })
	      // Api was not liking how proctorLocationSids were given so we have to encode and then stringify it for it work properly
	      const arrayString = encodeURIComponent(JSON.stringify(proctorLocation))
	       const query = `?proctorLocationSids=${arrayString}&examSessionSid=${this.state.sessionSid}`;
	      const backgroundLoad = true;
	       ProctorStore.searchProctors(query, this.setInitialFee, null, backgroundLoad);
	    }
	     setInitialFee = (i, data) => {
	      if(data[0] && data[0].fees && !data[0].fees.userTotal) {
	        // Sometimes the API won’t include a
	        // value for userTotal, but if you
	        // send a request without a total, it
	        // will throw a fit. So we need to set it
	        // to 0 if it isn’t present.
	        data[0].fees.userTotal = 0;
	      }
	       this.setState({
	        initialFees: data[0].fees.userTotal
	      });
	    }
	     */
	
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var ScheduleStore = store.ScheduleStore,
	          SessionStore = store.SessionStore,
	          StudentStore = store.StudentStore,
	          UserStore = store.UserStore;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (!SessionStore.loading || ScheduleStore.onlineAvailability.length > 0) {
	        if (UserStore.liveProctoringBlocked) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'page page--error wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel--brief' },
	              _react2.default.createElement(
	                'i',
	                { className: 'page--error__icon' },
	                _react2.default.createElement(icons.iconLock, null)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'panel__title' },
	                  translation.blocked.heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.blocked.message
	                )
	              )
	            )
	          );
	        } else if (!this.state.complete) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'drawer__content' },
	            _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.intro.heading
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'slide-wrap slide-wrap--sticky wrap' },
	              _react2.default.createElement(
	                'div',
	                { className: 'panel panel--medium ' + this.statusClass(1) },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text-block' },
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      translation.heading
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    null,
	                    translation.requirements.map(function (requirement, i) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: i },
	                        requirement
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      translation.record_reminder
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn', onClick: function onClick(e) {
	                      _this4.nextStep(e);
	                    } },
	                  _react2.default.createElement(icons.iconCalendar, null),
	                  translation.intro.button
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel panel--large media--alt media--alt-top ' + this.statusClass(2) },
	                _react2.default.createElement(_ScheduleDate2.default, Object.assign({}, this.props, {
	                  combined: true,
	                  hybrid: true,
	                  examSid: this.state.examSid,
	                  sessionSid: this.state.sessionSid,
	                  setStep: this.setStep,
	                  step: this.state.step
	                })),
	                !ScheduleStore.onlineDate && ScheduleStore.onlineAvailability.length === 0 && _react2.default.createElement(
	                  'div',
	                  { className: 'media__copy' },
	                  _react2.default.createElement(_BlackoutList2.default, this.props),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'no-results' },
	                    translation.select_date
	                  )
	                ),
	                (ScheduleStore.onlineDate || ScheduleStore.onlineAvailability.length > 0) && _react2.default.createElement(
	                  'div',
	                  { className: 'media__copy' },
	                  _react2.default.createElement(_BlackoutList2.default, this.props),
	                  _react2.default.createElement(_ScheduleTable2.default, Object.assign({
	                    step: this.state.step,
	                    setStep: this.setStep,
	                    getSid: this.getSid,
	                    routing: this.props.routing,
	                    setSlot: this.setSlot,
	                    parent: this
	                  }, this.props, {
	                    sessionSid: this.state.sessionSid
	                  }))
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel panel--brief ' + this.statusClass(3) },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.confirm.heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.confirm.body_pre
	                ),
	                _react2.default.createElement(
	                  'time',
	                  { className: 'text-code' },
	                  (0, _moment2.default)(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.confirm.body_post
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn',
	                    onClick: function onClick(e) {
	                      return _this4.confirmSlot(e);
	                    }
	                  },
	                  _react2.default.createElement(icons.iconCalendarPlus, null),
	                  translation.confirm.button
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'preposition--vertical' },
	                  translation.confirm.or
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--link',
	                    onClick: function onClick(e) {
	                      return _this4.setStep(e, 2);
	                    }
	                  },
	                  translation.confirm.change_time
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel panel--brief ' + this.statusClass(4) },
	                _react2.default.createElement(_Pricing2.default, Object.assign({ fees: this.state.fees, scheduler: this, isSubmitDisabled: this.state.isSubmitDisabled }, this.props)),
	                this.renderFeeDescriptions(),
	                this.renderPricingButton(),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'preposition--vertical' },
	                  translation.confirm.or
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--link',
	                    onClick: function onClick(e) {
	                      return _this4.setStep(e, 3);
	                    }
	                  },
	                  translation.go_back
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel panel--brief ' + this.statusClass(5) },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.payment.heading
	                ),
	                _react2.default.createElement(_Payments2.default, Object.assign({ submit: this.submitSchedule }, this.props))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel panel--brief ' + this.statusClass(6) },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.confirmed.heading,
	                  '!'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.confirmed.body
	                ),
	                _react2.default.createElement(
	                  'time',
	                  { className: 'text-code' },
	                  (0, _moment2.default)(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')
	                ),
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'btn btn--icn-right',
	                    href: '#app',
	                    onClick: function onClick(e) {
	                      (0, _helpers.closeDrawer)(e, _this4.props.parent, '/', StudentStore.getStudentExams);
	                    }
	                  },
	                  translation.confirmed.button,
	                  _react2.default.createElement(icons.iconCircleRight, null)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'panel panel--brief ' + this.statusClass(7) },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'panel__title' },
	                  translation.refresh.heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.refresh.body
	                ),
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'btn btn--icn-right',
	                    href: '#app',
	                    onClick: function onClick(e) {
	                      (0, _helpers.closeDrawer)(e, _this4.props.parent, '/', StudentStore.getStudentExams);
	                    }
	                  },
	                  translation.confirmed.button,
	                  _react2.default.createElement(icons.iconCircleRight, null)
	                )
	              )
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'drawer__content' },
	            _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.heading
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief' },
	              _react2.default.createElement('img', { className: 'panel__img', src: './static/img/logo-registerblast.png', width: '200', alt: 'RegisterBlast' }),
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.confirmed.heading,
	                '!'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirmed.body
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'btn btn--icn-right',
	                  href: '#app',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this4.props.parent, '/', StudentStore.getStudentExams);
	                  }
	                },
	                translation.confirmed.button,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              )
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScheduleHybrid;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleHybrid')(ScheduleHybrid);

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BlackoutList = __webpack_require__(146);
	
	var _BlackoutList2 = _interopRequireDefault(_BlackoutList);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	// Dependencies
	
	
	// Components
	
	
	var ScheduleInstructor = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleInstructor, _React$Component);
	
	  function ScheduleInstructor() {
	    _classCallCheck(this, ScheduleInstructor);
	
	    var _this2 = _possibleConstructorReturn(this, (ScheduleInstructor.__proto__ || Object.getPrototypeOf(ScheduleInstructor)).call(this));
	
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.prevStep = _this2.prevStep.bind(_this2);
	    _this2.selectTime = _this2.selectTime.bind(_this2);
	    _this2.changeTime = _this2.changeTime.bind(_this2);
	    _this2.createAppointment = _this2.createAppointment.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ScheduleInstructor, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var times = [];
	
	      this.props.store.ExamStore.exam.configuration.instructorAsProctor.forEach(function (session) {
	        times.push(null);
	      });
	
	      this.state = {
	        step: 1,
	        times: times,
	        examSid: null,
	        sessionSid: null,
	        appointmentStartDate: null,
	        instructorProctorSid: null
	      };
	
	      if (!this.props.reschedule && !this.props.skipUrl) {
	        this.setState({
	          examSid: (0, _helpers.getURLSegment)(this, 3),
	          sessionSid: (0, _helpers.getURLSegment)(this, 5)
	        });
	      } else {
	        this.setState({
	          examSid: this.props.examSid,
	          sessionSid: this.props.sessionSid
	        });
	      }
	
	      this.props.store.SessionStore.getCurrentTime();
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      }, function () {
	        // Hide the close button on the last step so the
	        // student has to click the return to dashboard button
	        if (this.state.step === 3) {
	          this.props.store.SessionStore.hideDrawerClose = true;
	        }
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'selectTime',
	    value: function selectTime(i, startTime, isRange, sid) {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      this.setState({
	        instructorProctorSid: sid
	      });
	
	      if (isRange) {
	        var date = (0, _moment2.default)(startTime).tz(userTimezone).format('YYYY-MM-DD Z');
	        var time = this['time' + i].value;
	        var formattedTime = (0, _moment2.default)(date + ' ' + time, 'YYYY-MM-DD Z HH:mm').toISOString();
	
	        if (time) {
	          this.setState({
	            appointmentStartDate: formattedTime
	          });
	        } else {
	          this.setState({
	            appointmentStartDate: null
	          });
	        }
	      } else {
	        this.setState({
	          appointmentStartDate: startTime
	        });
	
	        var _this = this;
	
	        setTimeout(function () {
	          _this.nextStep();
	        });
	      }
	    }
	  }, {
	    key: 'changeTime',
	    value: function changeTime() {
	      this.setState({
	        appointmentStartDate: null,
	        instructorProctorSid: null
	      });
	
	      var timeSelects = document.querySelectorAll('.instructor-time');
	
	      for (var i = 0; i < timeSelects.length; i++) {
	        timeSelects[i].value = '';
	      }
	
	      var _this = this;
	
	      setTimeout(function () {
	        _this.prevStep();
	      });
	    }
	  }, {
	    key: 'createAppointment',
	    value: function createAppointment() {
	      var _this3 = this;
	
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	
	      var data = {
	        type: 'instructor-as-proctor',
	        appointmentDateTime: this.state.appointmentStartDate,
	        instructorProctorSid: this.state.instructorProctorSid
	      };
	
	      ScheduleStore.createAppointment(this.state.examSid, this.state.sessionSid, data, function () {
	        _this3.nextStep(null);
	      });
	    }
	  }, {
	    key: 'renderTimes',
	    value: function renderTimes(startTime, endTime) {
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var startHour = parseInt(_moment2.default.utc(startTime).tz(userTimezone).format('H'), 10);
	      var startMinute = parseInt(_moment2.default.utc(startTime).tz(userTimezone).format('m'), 10);
	      var endHour = parseInt(_moment2.default.utc(endTime).tz(userTimezone).format('H'), 10);
	      var endMinute = parseInt(_moment2.default.utc(endTime).tz(userTimezone).format('m'), 10);
	      var timeDiff = endHour - startHour;
	
	      var options = [];
	
	      for (var i = 0; i <= timeDiff; i++) {
	        var hour = startHour + i;
	        var ampm = 'am';
	
	        if (hour > 12) {
	          hour -= 12;
	          ampm = 'pm';
	        } else if (hour === 12) {
	          ampm = 'pm';
	        }
	
	        var hourOption = _react2.default.createElement('option', { key: i + '-hour', value: startHour + i + ':00' }, hour + ':00' + ampm);
	
	        var halfOption = _react2.default.createElement('option', { key: i + '-half', value: startHour + i + ':30' }, hour + ':30' + ampm);
	
	        if (i !== 0 || startMinute !== 30) {
	          options.push(hourOption);
	        }
	
	        if (startHour + i !== endHour || endMinute === 30) {
	          options.push(halfOption);
	        }
	      }
	
	      var optgroup = _react2.default.createElement('optgroup', null, options);
	
	      return optgroup;
	    }
	  }, {
	    key: 'hideEmptyTable',
	    value: function hideEmptyTable(dateOpts) {
	      var table = document.querySelector('.iap-dates');
	
	      setTimeout(function () {
	        if (dateOpts === 0 && table) {
	          table.className += ' hidden';
	        } else if (dateOpts > 0 && table) {
	          table.className = table.className.replace('hidden', '');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var examSession = this.props.store.ExamStore.examSession;
	      var StudentStore = this.props.store.StudentStore;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var dateOpts = 0;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.intro.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'slide-wrap wrap' },
	          _react2.default.createElement(_BlackoutList2.default, this.props),
	          _react2.default.createElement(
	            'div',
	            { className: '' + this.statusClass(1) },
	            _react2.default.createElement(
	              'table',
	              { className: 'iap-dates' },
	              _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'th',
	                    { scope: 'col' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      translation.date
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { scope: 'col' },
	                    _react2.default.createElement(
	                      'strong',
	                      { className: 'subtitle' },
	                      translation.time
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { scope: 'col' },
	                    _react2.default.createElement(
	                      'strong',
	                      { className: 'subtitle' },
	                      translation.location
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { scope: 'col' },
	                    _react2.default.createElement(
	                      'strong',
	                      { className: 'subtitle' },
	                      translation.actions
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'tbody',
	                null,
	                examSession.examConfiguration.instructorAsProctor.map(function (key, i) {
	                  var now = (0, _moment2.default)(_this4.props.store.SessionStore.currentTime);
	                  var endDate = null;
	
	                  if (key.endTime) {
	                    endDate = (0, _moment2.default)(key.endTime).tz(userTimezone);
	                  } else {
	                    endDate = (0, _moment2.default)(key.startTime).tz(userTimezone);
	                  }
	
	                  var endDiff = _moment2.default.duration(endDate.diff(now)).asHours();
	
	                  if (endDiff > 0) {
	                    dateOpts++;
	
	                    return _react2.default.createElement(
	                      'tr',
	                      { key: i },
	                      _react2.default.createElement(
	                        'th',
	                        { scope: 'row' },
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          _moment2.default.utc(key.startTime).tz(userTimezone).format('dddd, MMMM D')
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        null,
	                        key.endTime && _react2.default.createElement(
	                          'span',
	                          null,
	                          _moment2.default.utc(key.startTime).tz(userTimezone).format('h:mma'),
	                          '\u2013',
	                          _moment2.default.utc(key.endTime).tz(userTimezone).format('h:mma z')
	                        ),
	                        !key.endTime && _react2.default.createElement(
	                          'span',
	                          null,
	                          _moment2.default.utc(key.startTime).tz(userTimezone).format('h:mma z')
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'td',
	                        { className: 'addr' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          key.location
	                        )
	                      ),
	                      key.endTime && _react2.default.createElement(
	                        'td',
	                        { className: 'actions' },
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select select--sm', htmlFor: 'time-' + i },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'time-' + i,
	                              className: 'instructor-time',
	                              ref: function ref(input) {
	                                _this4['time' + i] = input;
	                              },
	                              onChange: function onChange() {
	                                _this4.selectTime(i, key.startTime, true, key.sid);
	                              },
	                              disabled: _this4.state.appointmentStartDate && !_this4['time' + i].value
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.time
	                            ),
	                            _this4.renderTimes(key.startTime, key.endTime)
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            className: 'btn--outline',
	                            disabled: !_this4.state.appointmentStartDate || !_this4['time' + i].value,
	                            onClick: function onClick(e) {
	                              _this4.nextStep();
	                            }
	                          },
	                          translation.button
	                        )
	                      ),
	                      !key.endTime && _react2.default.createElement(
	                        'td',
	                        { className: 'actions' },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            className: 'btn--outline btn--full',
	                            onClick: function onClick() {
	                              _this4.selectTime(i, key.startTime, false, key.sid);
	                            }
	                          },
	                          translation.button
	                        )
	                      )
	                    );
	                  }
	                  return null;
	                })
	              )
	            ),
	            this.hideEmptyTable(dateOpts),
	            dateOpts === 0 && _react2.default.createElement(
	              'span',
	              { className: 'no-results' },
	              translation.no_dates
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief ' + this.statusClass(2) },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.confirm.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.confirm.body_pre
	            ),
	            _react2.default.createElement(
	              'time',
	              { className: 'text-code' },
	              (0, _moment2.default)(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.confirm.body_post
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn', onClick: this.createAppointment },
	              _react2.default.createElement(icons.iconCalendarPlus, null),
	              translation.confirm.button
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'preposition--vertical' },
	              translation.confirm.or
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--link',
	                onClick: this.changeTime
	              },
	              translation.confirm.change_time
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief ' + this.statusClass(3) },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.confirmed.heading,
	              '!'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.confirmed.body
	            ),
	            _react2.default.createElement(
	              'time',
	              { dateTime: '2017-03-06t00:00', className: 'text-code' },
	              (0, _moment2.default)(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')
	            ),
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'btn btn--icn-right',
	                href: '#app',
	                onClick: function onClick(e) {
	                  (0, _helpers.closeDrawer)(e, _this4.props.parent, '/', StudentStore.getStudentExams);
	                }
	              },
	              translation.confirmed.button,
	              _react2.default.createElement(icons.iconCircleRight, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ScheduleInstructor;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleInstructor')(ScheduleInstructor);

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Pricing = __webpack_require__(123);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	var _PricingProctorCollected = __webpack_require__(861);
	
	var _PricingProctorCollected2 = _interopRequireDefault(_PricingProctorCollected);
	
	var _Payments = __webpack_require__(99);
	
	var _Payments2 = _interopRequireDefault(_Payments);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ScheduleMessaging = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleMessaging, _React$Component);
	
	  function ScheduleMessaging() {
	    _classCallCheck(this, ScheduleMessaging);
	
	    var _this2 = _possibleConstructorReturn(this, (ScheduleMessaging.__proto__ || Object.getPrototypeOf(ScheduleMessaging)).call(this));
	
	    _this2.setFees = _this2.setFees.bind(_this2);
	    _this2.renderPricingButton = _this2.renderPricingButton.bind(_this2);
	    _this2.submitSchedule = _this2.submitSchedule.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ScheduleMessaging, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      var _props$store = this.props.store,
	          PaymentStore = _props$store.PaymentStore,
	          ProctorStore = _props$store.ProctorStore;
	
	
	      this.state = {
	        step: 1,
	        fees: null,
	        voucherCode: null,
	        disabled: false
	
	        // Set payment callback
	      };PaymentStore.setAfterPayment(function (event) {
	        return _this3.nextStep(event);
	      });
	
	      // Get the pricing data
	      var _this = this;
	      setTimeout(function () {
	        var query = '?proctorLocationSids=' + _this.props.proctorLocationSid + '&examSessionSid=' + _this.props.sessionSid;
	
	        ProctorStore.searchProctors(query, _this.setFees, null);
	      });
	    }
	  }, {
	    key: 'setFees',
	    value: function setFees(i, data) {
	      if (data.length === 0) {
	        this.setState({
	          disabled: true
	        });
	      } else {
	        this.setState({
	          disabled: false,
	          fees: data[0].fees
	        });
	      }
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      }, function () {
	        // Hide the close button on the last step so the
	        // student has to click the return to dashboard button
	        if (this.state.step === 4) {
	          this.props.store.SessionStore.hideDrawerClose = true;
	        }
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'submitSchedule',
	    value: function submitSchedule() {
	      var _this4 = this;
	
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	
	      var data = {
	        amount: this.state.fees.userTotal,
	        currency: this.state.fees.currencyCode,
	        type: 'messaging',
	        messageSid: this.props.messageSid
	      };
	
	      if (this.state.fees.proctorCollected) {
	        data.amount = 0;
	      }
	
	      ScheduleStore.createAppointment(this.props.examSid, this.props.sessionSid, data, function () {
	        _this4.setStep(null, 4);
	      });
	    }
	  }, {
	    key: 'renderPricingButton',
	    value: function renderPricingButton() {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	
	
	      if (this.state.fees) {
	        if (this.state.fees.userTotal > 0 && !this.state.fees.proctorCollected) {
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: function onClick(e) {
	                _this5.nextStep(e);
	              }
	            },
	            translation.next
	          );
	        }
	
	        if (this.state.fees.userTotal === 0 || this.state.fees.userTotal === null || this.state.fees.proctorCollected) {
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: this.submitSchedule
	            },
	            translation.schedule
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          MessageStore = _props$store2.MessageStore,
	          SessionStore = _props$store2.SessionStore,
	          StudentStore = _props$store2.StudentStore;
	      var threadObject = MessageStore.threadObject;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      var confirmedDate = null;
	
	      if (this.props.external) {
	        confirmedDate = this.props.confirmedDate;
	      } else if (MessageStore.confirmedDate) {
	        confirmedDate = MessageStore.confirmedDate;
	      } else {
	        confirmedDate = threadObject.confirmedDate;
	      }
	
	      if (!SessionStore.backgroundLoading) {
	        if (this.state.disabled) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'drawer__content' },
	            _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.heading
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.disabled_msg.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.disabled_msg.body
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'btn btn--icn-right',
	                  href: '#app',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this6.props.parent, '/messages');
	                  }
	                },
	                translation.disabled_msg.button
	              )
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'drawer__content' },
	            _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.heading
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(1) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.confirm.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirm.body_pre
	              ),
	              _react2.default.createElement(
	                'time',
	                { className: 'text-code' },
	                (0, _moment2.default)(confirmedDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirm.body_post
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick(e) {
	                    _this6.nextStep(e);
	                  }
	                },
	                _react2.default.createElement(icons.iconCalendarPlus, null),
	                translation.confirm.button
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(2) },
	              this.state.fees && !this.state.fees.proctorCollected && _react2.default.createElement(_Pricing2.default, Object.assign({
	                fees: this.state.fees,
	                scheduler: this
	              }, this.props)),
	              this.state.fees && this.state.fees.proctorCollected && _react2.default.createElement(_PricingProctorCollected2.default, Object.assign({
	                fees: this.state.fees,
	                scheduler: this
	              }, this.props)),
	              this.renderPricingButton(),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition--vertical' },
	                translation.confirm.or
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--link',
	                  onClick: function onClick(e) {
	                    _this6.prevStep(e);
	                  }
	                },
	                translation.go_back
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(3) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.payment.heading
	              ),
	              _react2.default.createElement(_Payments2.default, Object.assign({ submit: this.submitSchedule }, this.props))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(4) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.confirmed.heading,
	                '!'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirmed.body
	              ),
	              _react2.default.createElement(
	                'time',
	                { dateTime: '2017-03-06t00:00', className: 'text-code' },
	                (0, _moment2.default)(confirmedDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'btn btn--icn-right',
	                  href: '#app',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this6.props.parent, '/', StudentStore.getStudentExams);
	                  }
	                },
	                translation.confirmed.button,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              )
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScheduleMessaging;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleMessaging')(ScheduleMessaging);

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _currencyFormatter = __webpack_require__(71);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _ScheduleTable = __webpack_require__(363);
	
	var _ScheduleTable2 = _interopRequireDefault(_ScheduleTable);
	
	var _ScheduleDate = __webpack_require__(362);
	
	var _ScheduleDate2 = _interopRequireDefault(_ScheduleDate);
	
	var _Payments = __webpack_require__(99);
	
	var _Payments2 = _interopRequireDefault(_Payments);
	
	var _Counter = __webpack_require__(346);
	
	var _Counter2 = _interopRequireDefault(_Counter);
	
	var _Pricing = __webpack_require__(123);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	var _BlackoutList = __webpack_require__(146);
	
	var _BlackoutList2 = _interopRequireDefault(_BlackoutList);
	
	var _ExamityRequirements = __webpack_require__(370);
	
	var _ExamityRequirements2 = _interopRequireDefault(_ExamityRequirements);
	
	var _ProctorURequirements = __webpack_require__(371);
	
	var _ProctorURequirements2 = _interopRequireDefault(_ProctorURequirements);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ScheduleOnline = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleOnline, _React$Component);
	
	  function ScheduleOnline() {
	    _classCallCheck(this, ScheduleOnline);
	
	    // Set initial state
	    var _this2 = _possibleConstructorReturn(this, (ScheduleOnline.__proto__ || Object.getPrototypeOf(ScheduleOnline)).call(this));
	
	    _this2.setLocation = function (i, data) {
	      var ScheduleStore = _this2.props.store.ScheduleStore;
	
	
	      ScheduleStore.onlineLocation = data[0].location.sid;
	    };
	
	    _this2.setFees = function (i, data) {
	      var ScheduleStore = _this2.props.store.ScheduleStore;
	
	
	      if (data[0] && data[0].fees && !data[0].fees.userTotal) {
	        data[0].fees.userTotal = 0;
	      }
	
	      _this2.setState({
	        fees: data[0].fees
	      });
	
	      // Store the online location sid
	      ScheduleStore.onlineLocation = data[0].location.sid;
	    };
	
	    _this2.getSid = function (segment) {
	      // Get the exam sid from the URL
	      var pathname = '';
	
	      if (typeof _this2.props !== 'undefined') {
	        pathname = _this2.props.routing.location.pathname;
	      } else {
	        pathname = _this2.routing.location.pathname;
	      }
	
	      var pathArray = pathname.split('/');
	
	      if (pathArray[0] === '') {
	        pathArray.splice(0, 1);
	      }
	
	      var sid = pathArray[segment];
	
	      return sid;
	    };
	
	    _this2.setStep = function (e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      _this2.setState({
	        step: step
	      }, function () {
	        // Hide the close button on the last step so the
	        // student has to click the return to dashboard button
	        if (this.state.step === 7) {
	          this.props.store.SessionStore.hideDrawerClose = true;
	        }
	      });
	    };
	
	    _this2.nextStep = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      _this2.setState({
	        step: _this2.state.step + 1
	      });
	    };
	
	    _this2.statusClass = function (step) {
	      if (_this2.state.step === step) {
	        return 'slide-active';
	      } else if (_this2.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    };
	
	    _this2.setSlot = function (appointmentStartDate, appointmentEndDate) {
	      _this2.setState({
	        appointmentStartDate: appointmentStartDate,
	        appointmentEndDate: appointmentEndDate
	      });
	    };
	
	    _this2.confirmSlot = function () {
	      var _this2$props$store = _this2.props.store,
	          ExamStore = _this2$props$store.ExamStore,
	          ProctorStore = _this2$props$store.ProctorStore,
	          ScheduleStore = _this2$props$store.ScheduleStore;
	      var duration = ExamStore.examSession.examConfiguration.duration;
	
	
	      var data = {
	        appointmentStartDateTime: _this2.state.appointmentStartDate,
	        appointmentEndDateTime: _this2.state.appointmentEndDate,
	        type: ProctorStore.proctors[0].location.schedulingModule,
	        proctorLocationSid: _this2.props.proctorLocationSid
	      };
	
	      if (!data.appointmentEndDateTime) {
	        data.appointmentEndDateTime = (0, _moment2.default)(data.appointmentStartDateTime).add(duration, 'minutes');
	      }
	      if (!_this2.props.reschedule) {
	        if (data.type === 'smarter-scheduling') {
	          // We have to first reserve an appointment if we are using SmarterScheduling
	          ScheduleStore.createReservation(data, _this2.state.examSid, _this2.state.sessionSid, function () {
	            return _this2.nextStep(null);
	          });
	        } else {
	          _this2.nextStep(null);
	        }
	      } else {
	        _this2.props.store.ScheduleStore.rescheduleAppointment(_this2.state.examSid, _this2.state.sessionSid, data, function () {
	          _this2.setStep(null, 7);
	        }, function () {
	          _this2.setStep(null, 9);
	        });
	      }
	    };
	
	    _this2.submitSchedule = function () {
	      var _this2$props$store2 = _this2.props.store,
	          ProctorStore = _this2$props$store2.ProctorStore,
	          ScheduleStore = _this2$props$store2.ScheduleStore;
	
	
	      var data = {
	        appointmentDateTime: _this2.state.appointmentStartDate,
	        amount: _this2.state.fees.userTotal,
	        currency: _this2.state.fees.currencyCode,
	        type: ProctorStore.proctors[0].location.schedulingModule,
	        proctorLocationSid: ProctorStore.proctorLocationSid
	      };
	
	      ScheduleStore.createAppointment(_this2.state.examSid, _this2.state.sessionSid, data, function () {
	        _this2.setStep(null, 7);
	      });
	    };
	
	    _this2.renderPricingButton = function () {
	      var translation = _this2.props.translation;
	
	
	      if (_this2.state.fees) {
	        if (_this2.state.fees.userTotal > 0) {
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: function onClick(e) {
	                _this2.nextStep(e);
	              }
	            },
	            translation.next
	          );
	        }
	
	        if (_this2.state.fees.userTotal === 0) {
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: _this2.submitSchedule
	            },
	            translation.schedule
	          );
	        }
	      }
	
	      return null;
	    };
	
	    _this2.countdownExpired = function () {
	      var ScheduleStore = _this2.props.store.ScheduleStore;
	
	
	      ScheduleStore.resetData();
	
	      var callback = function callback() {
	        _this2.setStep(null, 8);
	      };
	
	      ScheduleStore.cancelReservation(_this2.state.examSid, _this2.state.sessionSid, callback);
	    };
	
	    _this2.startOver = function () {
	      var ScheduleStore = _this2.props.store.ScheduleStore;
	
	
	      ScheduleStore.checkOnlineReservation(_this2.state.examSid, _this2.state.sessionSid, function () {
	        _this2.setStep(null, 1);
	      }, _this2);
	    };
	
	    _this2.state = {
	      step: 1,
	      appointmentStartDate: null,
	      appointmentEndDate: null,
	      examSid: null,
	      sessionSid: null,
	      time: null,
	      fees: null,
	      voucherCode: null
	    };
	    return _this2;
	  }
	
	  _createClass(ScheduleOnline, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      var _props$store = this.props.store,
	          PaymentStore = _props$store.PaymentStore,
	          ProctorStore = _props$store.ProctorStore,
	          ScheduleStore = _props$store.ScheduleStore;
	
	      ScheduleStore.onlineDate = null;
	
	      this.props.store.SessionStore.getCurrentTime();
	
	      if (!this.props.reschedule && !this.props.skipUrl) {
	        this.setState({
	          examSid: this.getSid(2),
	          sessionSid: this.getSid(4)
	        });
	      } else {
	        this.setState({
	          examSid: this.props.examSid,
	          sessionSid: this.props.sessionSid
	        });
	      }
	
	      PaymentStore.setAfterPayment(function (event) {
	        return _this3.nextStep(event);
	      });
	
	      // Reset any old schedule data
	      ScheduleStore.resetData();
	
	      // Check if there’s already a reservation
	      var _this = this;
	      setTimeout(function () {
	        ScheduleStore.checkOnlineReservation(_this.state.examSid, _this.state.sessionSid, function () {
	          _this.setStep(null, 4);
	        }, _this);
	      });
	
	      if (!this.props.reschedule) {
	        // Get the pricing data if we’re not rescheduling
	        setTimeout(function () {
	          var query = '?proctorLocationSids=' + ProctorStore.proctorLocationSid + '&examSessionSid=' + _this.state.sessionSid;
	
	          ProctorStore.searchProctors(query, _this.setFees, null, true, false, false);
	        });
	      } else {
	        // Otherwise, just get the location data
	        setTimeout(function () {
	          var query = '?proctorLocationSids=' + ProctorStore.proctorLocationSid + '&examSessionSid=' + _this.state.sessionSid;
	
	          ProctorStore.searchProctors(query, _this.setLocation, null);
	        });
	      }
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var ProctorStore = store.ProctorStore,
	          ScheduleStore = store.ScheduleStore,
	          SessionStore = store.SessionStore,
	          StudentStore = store.StudentStore;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (!SessionStore.loading || ScheduleStore.onlineAvailability.length > 0) {
	        // If we are using smarter-scheduling, we want to skip the payment screen
	        // as the pricing is already on the location
	        var schedulingModule = ProctorStore.proctors && ProctorStore.proctors[0] && ProctorStore.proctors[0].location && ProctorStore.proctors[0].location.schedulingModule ? ProctorStore.proctors[0].location.schedulingModule : null;
	        if (schedulingModule === 'smarter-scheduling' && this.state.step === 1) {
	          this.setStep(null, 2);
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.intro.heading
	              ),
	              ScheduleStore.externalReservedAppointmentExpires && _react2.default.createElement(_Counter2.default, Object.assign({
	                endDate: ScheduleStore.externalReservedAppointmentExpires,
	                callback: this.countdownExpired
	              }, this.props))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap slide-wrap--sticky wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--medium ' + this.statusClass(1) },
	              this.state.step === 1 && schedulingModule === 'examity' && _react2.default.createElement('img', { className: 'panel__img', src: './static/img/logo-examity.png', width: '200', alt: 'Examity' }),
	              this.state.step === 1 && schedulingModule === 'proctoru' && _react2.default.createElement('img', { className: 'panel__img', src: './static/img/logo-proctoru.png', width: '200', alt: 'ProctorU' }),
	              this.state.step === 1 && _react2.default.createElement('div', {
	                className: 'schedule-intro',
	                dangerouslySetInnerHTML: {
	                  __html: _dompurify2.default.sanitize(translation.intro.body[schedulingModule])
	                }
	              }),
	              this.state.step === 1 && schedulingModule === 'examity' && _react2.default.createElement(_ExamityRequirements2.default, this.props),
	              this.state.step === 1 && schedulingModule === 'proctoru' && _react2.default.createElement(_ProctorURequirements2.default, this.props),
	              this.state.step === 1 && this.state.fees && _react2.default.createElement(
	                'div',
	                { className: 'note' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.intro.pricing.heading
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.intro.pricing.total,
	                  ' ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    _currencyFormatter2.default.format(this.state.fees.userTotal, { code: this.state.fees.currencyCode }),
	                    ' ',
	                    this.state.fees.currencyCode
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.intro.pricing.body
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn', onClick: function onClick(e) {
	                    _this4.nextStep(e);
	                  } },
	                _react2.default.createElement(icons.iconCalendar, null),
	                translation.intro.button
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--large media--alt media--alt-top ' + this.statusClass(2) },
	              _react2.default.createElement(_ScheduleDate2.default, Object.assign({
	                combined: false,
	                setStep: this.setStep
	              }, this.props, {
	                examSid: this.state.examSid,
	                sessionSid: this.state.sessionSid,
	                step: this.state.step
	              })),
	              !ScheduleStore.onlineDate && ScheduleStore.onlineAvailability.length === 0 && _react2.default.createElement(
	                'div',
	                { className: 'media__copy' },
	                _react2.default.createElement(_BlackoutList2.default, this.props),
	                _react2.default.createElement('p', {
	                  className: 'note',
	                  dangerouslySetInnerHTML: {
	                    __html: _dompurify2.default.sanitize(translation.intro.time_note)
	                  }
	                }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'no-results' },
	                  translation.select_date
	                )
	              ),
	              (ScheduleStore.onlineDate || ScheduleStore.onlineAvailability.length > 0) && _react2.default.createElement(
	                'div',
	                { className: 'media__copy' },
	                _react2.default.createElement(_BlackoutList2.default, this.props),
	                _react2.default.createElement(_ScheduleTable2.default, Object.assign({
	                  combined: false,
	                  setStep: this.setStep,
	                  getSid: this.getSid,
	                  routing: this.props.routing,
	                  setSlot: this.setSlot,
	                  parent: this
	                }, this.props, {
	                  sessionSid: this.state.sessionSid
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(4) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.confirm.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirm.body_pre
	              ),
	              _react2.default.createElement(
	                'time',
	                { className: 'text-code' },
	                (0, _moment2.default)(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirm.body_post
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: this.confirmSlot
	                },
	                _react2.default.createElement(icons.iconCalendarPlus, null),
	                translation.confirm.button
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition--vertical' },
	                translation.confirm.or
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--link',
	                  onClick: function onClick(e) {
	                    return _this4.setStep(e, 2);
	                  }
	                },
	                translation.confirm.change_time
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(5) },
	              _react2.default.createElement(_Pricing2.default, Object.assign({ fees: this.state.fees, scheduler: this }, this.props)),
	              this.renderPricingButton(),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition--vertical' },
	                translation.confirm.or
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--link',
	                  onClick: function onClick(e) {
	                    return _this4.setStep(e, 4);
	                  }
	                },
	                translation.go_back
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(6) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.payment.heading
	              ),
	              _react2.default.createElement(_Payments2.default, Object.assign({ submit: this.submitSchedule }, this.props))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(7) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.confirmed.heading,
	                '!'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirmed.body
	              ),
	              _react2.default.createElement(
	                'time',
	                { className: 'text-code' },
	                (0, _moment2.default)(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'btn btn--icn-right',
	                  href: '#app',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this4.props.parent, '/', StudentStore.getStudentExams);
	                  }
	                },
	                translation.confirmed.button,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(8) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.expired.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.expired.body
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn--icn-right',
	                  onClick: this.startOver
	                },
	                translation.expired.button,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(9) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.refresh.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.refresh.body
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'btn btn--icn-right',
	                  href: '#app',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this4.props.parent, '/', StudentStore.getStudentExams);
	                  }
	                },
	                translation.confirmed.button,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScheduleOnline;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleOnline')(ScheduleOnline);

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ScheduleRB = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleRB, _React$Component);
	
	  function ScheduleRB() {
	    _classCallCheck(this, ScheduleRB);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (ScheduleRB.__proto__ || Object.getPrototypeOf(ScheduleRB)).call(this));
	
	    _this2.complete = _this2.complete.bind(_this2);
	    _this2.renderDisabled = _this2.renderDisabled.bind(_this2);
	    _this2.renderEnabled = _this2.renderEnabled.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ScheduleRB, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          reschedule = _props.reschedule,
	          store = _props.store;
	      var ExamStore = store.ExamStore;
	
	
	      this.state = {
	        complete: false
	      };
	
	      var examSid = void 0,
	          sessionSid = void 0,
	          proctorLocationSid = void 0;
	
	      if (!reschedule) {
	        examSid = (0, _helpers.getURLSegment)(this, 3);
	        sessionSid = (0, _helpers.getURLSegment)(this, 5);
	        proctorLocationSid = this.props.proctorLocationSid;
	      } else {
	        examSid = ExamStore.examSession.examSid;
	        sessionSid = ExamStore.examSession.sid;
	        proctorLocationSid = ExamStore.examSession.location.sid;
	      }
	
	      this.props.store.ScheduleStore.getSchedulingToken(examSid, sessionSid, proctorLocationSid);
	    }
	  }, {
	    key: 'complete',
	    value: function complete(e) {
	      // In some cases, MS Edge seems to have a problem with opening
	      // the new window, so we’re wrapping this in a try…catch to hopefully
	      // allow the natural link element to just open if the JS open fails
	      try {
	        var _this = this;
	        var win = window.open(e.target.getAttribute('href'));
	
	        e.preventDefault();
	
	        var int = setInterval(function () {
	          try {
	            // If the created window has been redirected to the domain
	            // close the window, clear the interval, and set the state
	            if (win.location.href && win.location.href === _config.config.rbRedirect) {
	              win.close();
	              clearInterval(int);
	              _this.setState({
	                complete: true
	              });
	
	              // Hide the close button so the student has to click
	              // the return to dashboard button
	              _this.props.store.SessionStore.hideDrawerClose = true;
	            } else if (win === null || win.closed) {
	              clearInterval(int);
	            }
	          } catch (e) {}
	        }, 1000);
	      } catch (e) {
	        // Let the natural link do its thing
	        console.warn('window.open didn’t work.');
	      }
	    }
	  }, {
	    key: 'renderDisabled',
	    value: function renderDisabled() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.disabled.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel panel--medium' },
	          _react2.default.createElement('img', { className: 'panel__img', src: './static/img/logo-registerblast.png', width: '200', alt: 'RegisterBlast' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.disabled.body
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEnabled',
	    value: function renderEnabled() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          reschedule = _props2.reschedule,
	          translation = _props2.translation;
	      var _props$store = this.props.store,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore,
	          StudentStore = _props$store.StudentStore;
	
	
	      if (!SessionStore.backgroundLoading) {
	        if (!this.state.complete) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'drawer__content' },
	            _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                !reschedule && _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.heading
	                ),
	                reschedule && _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.heading_reschedule
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--medium' },
	              _react2.default.createElement('img', { className: 'panel__img', src: './static/img/logo-registerblast.png', width: '200', alt: 'RegisterBlast' }),
	              !reschedule && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.intro
	                ),
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'drawer__subheading' },
	                  translation.next_steps
	                ),
	                _react2.default.createElement(
	                  'ol',
	                  null,
	                  translation.steps.map(function (step, i) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: i },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        step.body
	                      ),
	                      step.note && _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          step.note
	                        )
	                      )
	                    );
	                  })
	                )
	              ),
	              reschedule && _react2.default.createElement(
	                'p',
	                null,
	                translation.intro_reschedule
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'btn btn--icn-right',
	                  href: reschedule ? ScheduleStore.schedulingURL.replace('/schedule', '/reschedule') : ScheduleStore.schedulingURL,
	                  target: '_blank',
	                  onClick: function onClick(e) {
	                    return _this3.complete(e);
	                  }
	                },
	                translation.button,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              )
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'drawer__content' },
	            _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  translation.heading
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief' },
	              _react2.default.createElement('img', { className: 'panel__img', src: './static/img/logo-registerblast.png', width: '200', alt: 'RegisterBlast' }),
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.confirmed.heading,
	                '!'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.confirmed.body
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'btn btn--icn-right',
	                  href: '#app',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this3.props.parent, '/', StudentStore.getStudentExams);
	                  }
	                },
	                translation.confirmed.button,
	                _react2.default.createElement(icons.iconCircleRight, null)
	              )
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	        flagKey: 'disable-register-blast',
	        renderFeatureCallback: this.renderDisabled,
	        renderDefaultCallback: this.renderEnabled
	      });
	    }
	  }]);
	
	  return ScheduleRB;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleRB')(ScheduleRB);

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Pricing = __webpack_require__(123);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	var _Payments = __webpack_require__(99);
	
	var _Payments2 = _interopRequireDefault(_Payments);
	
	var _StartVTC = __webpack_require__(222);
	
	var _StartVTC2 = _interopRequireDefault(_StartVTC);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ScheduleVTC = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleVTC, _React$Component);
	
	  function ScheduleVTC() {
	    _classCallCheck(this, ScheduleVTC);
	
	    var _this2 = _possibleConstructorReturn(this, (ScheduleVTC.__proto__ || Object.getPrototypeOf(ScheduleVTC)).call(this));
	
	    _this2.setFees = _this2.setFees.bind(_this2);
	    _this2.renderPricingButton = _this2.renderPricingButton.bind(_this2);
	    _this2.submitSchedule = _this2.submitSchedule.bind(_this2);
	    _this2.showConfirmation = _this2.showConfirmation.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ScheduleVTC, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      var _props$store = this.props.store,
	          PaymentStore = _props$store.PaymentStore,
	          ProctorStore = _props$store.ProctorStore;
	
	
	      this.state = {
	        fees: null,
	        voucherCode: null,
	        accessCode: null,
	        initialFee: null
	      };
	
	      if (this.props.status.toLowerCase() !== 'scheduled') {
	        this.setState({
	          step: 1
	        });
	      } else {
	        this.setState({
	          step: 4
	        });
	      }
	
	      if (this.props.accessCode) {
	        this.setState({
	          accessCode: this.props.accessCode
	        });
	      }
	
	      // Set payment callback
	      PaymentStore.setAfterPayment(function (event) {
	        return _this3.nextStep(event);
	      });
	
	      // Get the pricing data
	      var _this = this;
	      setTimeout(function () {
	        var query = '?proctorLocationSids=' + _this.props.proctorLocationSid + '&examSessionSid=' + _this.props.sessionSid;
	
	        ProctorStore.searchProctors(query, _this.setFees, null);
	      });
	
	      this.props.store.SessionStore.getCurrentTime();
	    }
	  }, {
	    key: 'setFees',
	    value: function setFees(i, data) {
	      this.setState({
	        fees: data[0].fees,
	        initialFees: data[0].fees.userTotal
	      });
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      }, function () {
	        // Hide the close button on the last step so the
	        // student has to click the return to dashboard button
	        if (this.state.step === 4) {
	          this.props.store.SessionStore.hideDrawerClose = true;
	        }
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'renderPricingButton',
	    value: function renderPricingButton() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	
	      if (this.state.fees) {
	        if (this.state.fees.userTotal > 0) {
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: function onClick(e) {
	                _this4.nextStep(e);
	              }
	            },
	            translation.next
	          );
	        }
	
	        if (this.state.fees.userTotal === 0) {
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              onClick: this.submitSchedule
	            },
	            translation.schedule
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'submitSchedule',
	    value: function submitSchedule() {
	      var _props$store2 = this.props.store,
	          ExamStore = _props$store2.ExamStore,
	          ScheduleStore = _props$store2.ScheduleStore;
	      var duration = ExamStore.examSession.examConfiguration.duration;
	
	
	      var data = {
	        amount: this.state.fees.userTotal,
	        currency: this.state.fees.currencyCode,
	        type: 'vtc',
	        appointmentDateTime: (0, _moment2.default)(ExamStore.examSession.examConfiguration.examCloseDate).subtract(duration, 'minutes').subtract(1, 'hours').toISOString(),
	        proctorLocationSid: this.props.proctorLocationSid
	      };
	
	      ScheduleStore.createAppointment(this.props.examSid, this.props.sessionSid, data, this.showConfirmation);
	    }
	  }, {
	    key: 'showConfirmation',
	    value: function showConfirmation(response) {
	      this.setStep(null, 4);
	
	      this.setState({
	        accessCode: response.data.accessKey
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          ExamStore = _props$store3.ExamStore,
	          SessionStore = _props$store3.SessionStore;
	
	
	      var examOpen = true;
	
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      var openDate = (0, _moment2.default)(ExamStore.examSession.examConfiguration.examOpenDate);
	      var openDiff = _moment2.default.duration(openDate.diff(now)).asHours();
	
	      if (openDiff >= 0) {
	        examOpen = false;
	      }
	
	      if (!SessionStore.backgroundLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap slide-wrap--sticky wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--medium ' + this.statusClass(1) },
	              _react2.default.createElement(
	                'h1',
	                { className: 'panel__title--alt' },
	                translation.title
	              ),
	              _react2.default.createElement('div', {
	                className: 'schedule-intro',
	                dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.body) }
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'text-block' },
	                _react2.default.createElement(
	                  'h5',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.requirements.heading
	                  )
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  translation.requirements.requirement_list.map(function (requirement, i) {
	                    return _react2.default.createElement(
	                      'li',
	                      { key: i },
	                      requirement
	                    );
	                  }),
	                  _react2.default.createElement('li', {
	                    dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.requirements.headphone_note) }
	                  }),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    translation.requirements.system_check,
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'https://system-test.smarterproctoring.com/', target: '_blank' },
	                      translation.system_check_link
	                    )
	                  ),
	                  _react2.default.createElement('li', {
	                    dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.requirements.cellphone_note) }
	                  })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.record_reminder
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'note' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    translation.cost_heading
	                  )
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '$',
	                  this.state.initialFees
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.cost_info
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick(e) {
	                    _this5.nextStep(e);
	                  }
	                },
	                _react2.default.createElement(icons.iconCalendarPlus, null),
	                translation.requirements.button
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(2) },
	              _react2.default.createElement(_Pricing2.default, Object.assign({ fees: this.state.fees, scheduler: this }, this.props)),
	              this.renderPricingButton(),
	              _react2.default.createElement(
	                'span',
	                { className: 'preposition--vertical' },
	                translation.pricing.or
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--link',
	                  onClick: function onClick(e) {
	                    _this5.prevStep(e);
	                  }
	                },
	                translation.go_back
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(3) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.payment.heading
	              ),
	              _react2.default.createElement(_Payments2.default, Object.assign({ submit: this.submitSchedule }, this.props))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(4) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.confirmed.heading
	              ),
	              examOpen && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.confirmed.body_open
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'actions panel__actions' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn actions__btn',
	                      onClick: function onClick(e) {
	                        return _this5.nextStep(e);
	                      }
	                    },
	                    translation.confirmed.start_now
	                  ),
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                      className: 'btn btn--outline actions__btn',
	                      to: '/',
	                      onClick: function onClick() {
	                        SessionStore.hideDrawerClose = false;
	                      }
	                    },
	                    translation.confirmed.start_later
	                  )
	                )
	              ),
	              !examOpen && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  translation.confirmed.body_closed
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  {
	                    className: 'btn--link',
	                    to: '/',
	                    onClick: function onClick() {
	                      SessionStore.hideDrawerClose = false;
	                    }
	                  },
	                  translation.confirmed.dashboard
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  className: 'btn--link',
	                  to: '/',
	                  onClick: function onClick() {
	                    SessionStore.hideDrawerClose = false;
	                  }
	                },
	                translation.confirmed.button
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.statusClass(5) },
	              this.state.step === 5 && _react2.default.createElement(_StartVTC2.default, Object.assign({}, this.props, {
	                accessCode: ExamStore.examSession.accessKey
	              }))
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScheduleVTC;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleVTC')(ScheduleVTC);

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var SessionStartBV = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionStartBV, _React$Component);
	
	  function SessionStartBV() {
	    _classCallCheck(this, SessionStartBV);
	
	    var _this = _possibleConstructorReturn(this, (SessionStartBV.__proto__ || Object.getPrototypeOf(SessionStartBV)).call(this));
	
	    _this.setStep = _this.setStep.bind(_this);
	    _this.nextStep = _this.nextStep.bind(_this);
	    _this.prevStep = _this.prevStep.bind(_this);
	    _this.checkTime = _this.checkTime.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionStartBV, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        step: 1
	      };
	
	      var _props = this.props,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	
	
	      this.props.store.ExamStore.getExam(examSid);
	      this.props.store.ExamStore.getExamSession(examSid, sessionSid, this.checkTime);
	      this.props.store.SessionStore.getCurrentTime();
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'checkTime',
	    value: function checkTime() {
	      var examSession = this.props.store.ExamStore.examSession;
	
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      var sessionTime = (0, _moment2.default)(examSession.appointmentDate);
	      var timeToSession = _moment2.default.duration(sessionTime.diff(now)).asMinutes();
	
	      if (timeToSession < -30) {
	        this.setState({
	          step: 5
	        });
	      } else if (timeToSession > 30) {
	        this.setState({
	          step: 4
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          store = _props2.store,
	          translation = _props2.translation;
	      var ExamStore = store.ExamStore,
	          SessionStore = store.SessionStore;
	      var exam = ExamStore.exam,
	          examSession = ExamStore.examSession;
	      var _props$store$SessionS = this.props.store.SessionStore,
	          profile = _props$store$SessionS.profile,
	          userTimezone = _props$store$SessionS.userTimezone;
	
	      var proctorManagerUrl = encodeURIComponent('https://app.smarterproctoring.com/#/bvirtual-manager');
	
	      var launchURL = 'https://smarterservices.onlineproctornow.com/api/start_session.ns';
	      launchURL += '?issue_menu=1';
	      launchURL += '&id=14';
	      launchURL += '&external_key=' + examSession.sid + '-SmarterProctoring';
	      launchURL += '&customer_name=' + SessionStore.profile.firstName.replace('#', '') + ' ' + SessionStore.profile.lastName.replace('#', '');
	      launchURL += '&customer_company=' + SessionStore.userData.installSid;
	      launchURL += '&customer_desc=' + SessionStore.courseData.title.replace('#', '') + ' | ' + exam.title.replace('#', '');
	      launchURL += '&session.custom.proctor_manager_url=' + proctorManagerUrl;
	      launchURL += '&session.custom.access_key=' + examSession.accessKey;
	      launchURL += '&session.custom.email=' + profile.email;
	
	      if (!SessionStore.loading && exam && examSession.examConfiguration) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(1) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.confirm.heading
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'data--alt' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.confirm.title
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    exam.title
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.confirm.session_date
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.confirm.duration
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    (0, _helpers.toHours)(examSession.examConfiguration.duration, false, false, false)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn', onClick: function onClick(e) {
	                    _this2.nextStep(e);
	                  } },
	                translation.continue
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(2) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.test.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.test.body
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'panel__link--alt', href: 'https://onlineproctornow.com/systemtest.php', target: '_blank' },
	                translation.test.link
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn', onClick: function onClick(e) {
	                    _this2.nextStep(e);
	                  }
	                },
	                translation.continue
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(3) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.download.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.download.body
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'btn',
	                  href: launchURL
	                },
	                _react2.default.createElement(icons.iconDownload, null),
	                translation.download.button
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(4) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.early.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.early.body.replace('%date%', _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'panel__link--alt', href: 'https://onlineproctornow.com/systemtest.php', target: '_blank' },
	                translation.test.link
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this2.props.parent);
	                  }
	                },
	                translation.early.button
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(5) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.late.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.late.body.replace('%date%', _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this2.props.parent);
	                  }
	                },
	                translation.late.button
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SessionStartBV;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionStartBV')(SessionStartBV);

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactLaunchDarkly = __webpack_require__(18);
	
	var _ExamityRequirements = __webpack_require__(370);
	
	var _ExamityRequirements2 = _interopRequireDefault(_ExamityRequirements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Config
	
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var SessionStartExamity = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionStartExamity, _React$Component);
	
	  function SessionStartExamity() {
	    _classCallCheck(this, SessionStartExamity);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (SessionStartExamity.__proto__ || Object.getPrototypeOf(SessionStartExamity)).call(this));
	
	    _this.setStep = _this.setStep.bind(_this);
	    _this.nextStep = _this.nextStep.bind(_this);
	    _this.prevStep = _this.prevStep.bind(_this);
	    _this.checkTime = _this.checkTime.bind(_this);
	    _this.renderLate = _this.renderLate.bind(_this);
	    _this.renderOnTime = _this.renderOnTime.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionStartExamity, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        step: 1
	      };
	
	      var _props = this.props,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	
	
	      this.props.store.ExamStore.getExam(examSid);
	      this.props.store.ExamStore.getExamSession(examSid, sessionSid, this.checkTime);
	      this.props.store.SessionStore.getCurrentTime();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.StudentStore.getStudentExams();
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'checkTime',
	    value: function checkTime() {
	      var examSession = this.props.store.ExamStore.examSession;
	
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      var sessionTime = (0, _moment2.default)(examSession.appointmentDate);
	      var timeToSession = _moment2.default.duration(sessionTime.diff(now)).asMinutes();
	
	      if (timeToSession < -15) {
	        this.setState({
	          step: 3
	        });
	      } else if (timeToSession > 15) {
	        this.setState({
	          step: 2
	        });
	      }
	    }
	  }, {
	    key: 'renderLate',
	    value: function renderLate() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          store = _props2.store,
	          translation = _props2.translation;
	      var ExamStore = store.ExamStore;
	      var examSession = ExamStore.examSession;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title' },
	          translation.late.heading
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          translation.late.body.replace('%date%', _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn',
	            onClick: function onClick(e) {
	              (0, _helpers.closeDrawer)(e, _this2.props.parent);
	            }
	          },
	          translation.late.button
	        )
	      );
	    }
	  }, {
	    key: 'renderOnTime',
	    value: function renderOnTime() {
	      var _props3 = this.props,
	          store = _props3.store,
	          translation = _props3.translation;
	      var ExamStore = store.ExamStore,
	          SessionStore = store.SessionStore;
	      var exam = ExamStore.exam,
	          examSession = ExamStore.examSession;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'panel__title' },
	          translation.start.heading
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'data--alt' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.start.title
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              exam.title
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.start.session_date
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              { className: 'subtitle' },
	              translation.start.duration
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              (0, _helpers.toHours)(examSession.examConfiguration.duration, false, false, false)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: _config.config.apiUrl + '/installs/' + SessionStore.userData.installSid + '/exams/' + exam.sid + '/sessions/' + examSession.sid + '/start',
	            className: 'btn',
	            target: '_blank'
	          },
	          translation.continue
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          store = _props4.store,
	          translation = _props4.translation;
	      var ExamStore = store.ExamStore,
	          SessionStore = store.SessionStore;
	      var exam = ExamStore.exam,
	          examSession = ExamStore.examSession;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (!SessionStore.loading && exam && examSession.examConfiguration) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(1) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.start.heading
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'data--alt' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.start.title
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    exam.title
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.start.session_date
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.start.duration
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    (0, _helpers.toHours)(examSession.examConfiguration.duration, false, false, false)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  href: _config.config.apiUrl + '/installs/' + SessionStore.userData.installSid + '/exams/' + exam.sid + '/sessions/' + examSession.sid + '/start',
	                  className: 'btn',
	                  target: '_blank'
	                },
	                translation.continue
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(2) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.early.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.early.body.replace('%date%', _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))
	              ),
	              _react2.default.createElement(_ExamityRequirements2.default, this.props),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this3.props.parent);
	                  }
	                },
	                translation.early.button
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(3) },
	              _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: 'examity-late-start',
	                renderFeatureCallback: this.renderOnTime,
	                renderDefaultCallback: this.renderLate
	              })
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SessionStartExamity;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionStartExamity')(SessionStartExamity);

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ProctorURequirements = __webpack_require__(371);
	
	var _ProctorURequirements2 = _interopRequireDefault(_ProctorURequirements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var SessionStartProctorU = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionStartProctorU, _React$Component);
	
	  function SessionStartProctorU() {
	    _classCallCheck(this, SessionStartProctorU);
	
	    var _this = _possibleConstructorReturn(this, (SessionStartProctorU.__proto__ || Object.getPrototypeOf(SessionStartProctorU)).call(this));
	
	    _this.setStep = _this.setStep.bind(_this);
	    _this.nextStep = _this.nextStep.bind(_this);
	    _this.prevStep = _this.prevStep.bind(_this);
	    _this.checkTime = _this.checkTime.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionStartProctorU, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        step: 1
	      };
	
	      var _props = this.props,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	
	
	      this.props.store.ExamStore.getExam(examSid);
	      this.props.store.ExamStore.getExamSession(examSid, sessionSid, this.checkTime);
	      this.props.store.SessionStore.getCurrentTime();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.StudentStore.getStudentExams();
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.setState({
	        step: this.state.step + 1
	      });
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(step) {
	      if (this.state.step === step) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(step) {
	      if (this.state.step === step) {
	        return 'slide-active';
	      } else if (this.state.step > step) {
	        return 'slide-hidden-before';
	      } else {
	        return 'slide-hidden-after';
	      }
	    }
	  }, {
	    key: 'checkTime',
	    value: function checkTime() {
	      var examSession = this.props.store.ExamStore.examSession;
	
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      var sessionTime = (0, _moment2.default)(examSession.appointmentDate);
	      var timeToSession = _moment2.default.duration(sessionTime.diff(now)).asMinutes();
	      var sessionEnd = (0, _moment2.default)(examSession.appointmentDate).add(examSession.examConfiguration.duration, 'minutes').add(30, 'minutes');
	      var timeToSessionEnd = _moment2.default.duration(sessionEnd.diff(now)).asMinutes();
	      var sessionMissed = (0, _moment2.default)(examSession.appointmentDate).add(15, 'minutes');
	      var timeToSessionMissed = _moment2.default.duration(sessionMissed.diff(now)).asMinutes();
	
	      if (timeToSessionEnd <= 0) {
	        this.setState({
	          step: 3
	        });
	      } else if (timeToSession > 1) {
	        this.setState({
	          step: 2
	        });
	      }
	
	      // If the session is not in progress
	      // and the sessionMissed time is in the past
	      if (examSession.status.toLowerCase() === 'scheduled' && timeToSessionMissed <= 0) {
	        this.setState({
	          step: 4
	        });
	      }
	    }
	  }, {
	    key: 'startSession',
	    value: function startSession(examSid, sessionSid) {
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	      var sessionWindow = window.open();
	
	      var callback = function callback(url) {
	        sessionWindow.location.href = url;
	      };
	
	      ScheduleStore.startOnlineSession(examSid, sessionSid, callback, sessionWindow);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          store = _props2.store,
	          translation = _props2.translation;
	      var ExamStore = store.ExamStore,
	          SessionStore = store.SessionStore;
	      var exam = ExamStore.exam,
	          examSession = ExamStore.examSession;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	
	      if (!SessionStore.loading && exam && examSession.examConfiguration) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(1) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.start.heading
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'data--alt' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.start.title
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    exam.title
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.start.session_date
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    { className: 'subtitle' },
	                    translation.start.duration
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    (0, _helpers.toHours)(examSession.examConfiguration.duration, false, false, false)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick() {
	                    return _this2.startSession(exam.sid, examSession.sid);
	                  }
	                },
	                translation.continue
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(2) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.early.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.early.body.replace('%date%', _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))
	              ),
	              _react2.default.createElement(_ProctorURequirements2.default, this.props),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this2.props.parent);
	                  }
	                },
	                translation.early.button
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(3) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.expired.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.expired.body
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this2.props.parent);
	                  }
	                },
	                translation.expired.button
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slide-wrap wrap' },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel panel--brief ' + this.statusClass(4) },
	              _react2.default.createElement(
	                'h2',
	                { className: 'panel__title' },
	                translation.late.heading
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                translation.late.body.replace('%date%', _moment2.default.utc(examSession.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z'))
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn',
	                  onClick: function onClick(e) {
	                    (0, _helpers.closeDrawer)(e, _this2.props.parent);
	                  }
	                },
	                translation.late.button
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SessionStartProctorU;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionStartProctorU')(SessionStartProctorU);

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _StartVTC = __webpack_require__(222);
	
	var _StartVTC2 = _interopRequireDefault(_StartVTC);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var SessionStartVTC = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionStartVTC, _React$Component);
	
	  function SessionStartVTC() {
	    _classCallCheck(this, SessionStartVTC);
	
	    var _this = _possibleConstructorReturn(this, (SessionStartVTC.__proto__ || Object.getPrototypeOf(SessionStartVTC)).call(this));
	
	    _this.setAccessCode = _this.setAccessCode.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionStartVTC, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        accessCode: null
	      };
	
	      var _props = this.props,
	          examSid = _props.examSid,
	          sessionSid = _props.sessionSid;
	
	
	      this.props.store.ExamStore.getExam(examSid);
	      this.props.store.ExamStore.getExamSession(examSid, sessionSid, this.setAccessCode);
	    }
	  }, {
	    key: 'setAccessCode',
	    value: function setAccessCode(response) {
	      this.setState({
	        accessCode: response.data.accessKey
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          store = _props2.store,
	          translation = _props2.translation;
	      var ExamStore = store.ExamStore,
	          SessionStore = store.SessionStore;
	      var exam = ExamStore.exam,
	          examSession = ExamStore.examSession;
	
	
	      if (!SessionStore.loading && exam && examSession.examConfiguration) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(_StartVTC2.default, Object.assign({
	            accessCode: this.state.accessCode
	          }, this.props))
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SessionStartVTC;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionStartVTC')(SessionStartVTC);

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _StudentExamCard = __webpack_require__(873);
	
	var _StudentExamCard2 = _interopRequireDefault(_StudentExamCard);
	
	var _AutomatedExamCard = __webpack_require__(369);
	
	var _AutomatedExamCard2 = _interopRequireDefault(_AutomatedExamCard);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _config = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var StudentDashboard = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(StudentDashboard, _React$Component);
	
	  function StudentDashboard() {
	    _classCallCheck(this, StudentDashboard);
	
	    return _possibleConstructorReturn(this, (StudentDashboard.__proto__ || Object.getPrototypeOf(StudentDashboard)).apply(this, arguments));
	  }
	
	  _createClass(StudentDashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        examSid: null,
	        sessionSid: null,
	        proctorLocationSid: null,
	        confirmedDate: null,
	        messageSid: null
	      };
	
	      this.getStudentExams();
	      this.props.store.SessionStore.getCurrentTime();
	      this.props.store.SettingsStore.getInstituteSettings();
	    }
	  }, {
	    key: 'getStudentExams',
	    value: function getStudentExams() {
	      var _props$store = this.props.store,
	          StudentStore = _props$store.StudentStore,
	          ScheduleStore = _props$store.ScheduleStore;
	      var examSessionSid = ScheduleStore.examSessionSid;
	
	
	      StudentStore.getOrderedStudentExams(true, examSessionSid);
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var StudentStore = store.StudentStore;
	      var orderedExams = StudentStore.orderedExams;
	      var active = orderedExams.active,
	          upcoming = orderedExams.upcoming,
	          closed = orderedExams.closed;
	
	      var examStatuses = ['active', 'upcoming', 'closed'];
	
	      if (!orderedExams || active.length === 0 && upcoming.length === 0 && closed.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'no-results' },
	          translation.no_results,
	          _react2.default.createElement(
	            'span',
	            { className: 'no-results__sub' },
	            translation.no_results_sub
	          )
	        );
	      } else if (orderedExams) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          examStatuses.map(function (status) {
	            if (orderedExams[status] && orderedExams[status].length > 0) {
	              return _react2.default.createElement(
	                'section',
	                {
	                  className: 'page__section exam-section',
	                  key: status
	                },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'exam-section__heading' },
	                  translation.exam_sections[status]
	                ),
	                _react2.default.createElement(
	                  'ol',
	                  { className: 'exam-section__list' },
	                  orderedExams[status].map(function (exam) {
	                    var _exam$examSession = exam.examSession,
	                        proctorGroups = _exam$examSession.proctorGroups,
	                        schedulingModule = _exam$examSession.schedulingModule;
	                    var proctorTypes = exam.examSession.examConfiguration.proctorTypes;
	
	                    var status = exam.examSession.status.toLowerCase();
	
	                    // We need to determine if this exam is automated-only.
	                    // If it is, we can show a more streamlined exam card
	                    // because scheduling doesn’t really matter.
	                    var hasAutomated = false;
	                    var hasUnautomated = false;
	                    var isAutomatedOnly = false;
	                    var scheduledElsewhere = false;
	                    var isReconnect = status === 'pending reconnection';
	
	                    if (proctorGroups) {
	                      if (proctorGroups.length && proctorGroups[0].proctorGroups) {
	                        proctorGroups = proctorGroups[0].proctorGroups;
	                      }
	                      // Check if this session has anything other than
	                      // automated proctor groups enabled
	                      proctorGroups.forEach(function (proctorGroup) {
	                        // leaving this as the individual proctor groups can also be returned nested in single item arrays
	                        if (proctorGroup.workflowModule !== 'automated' && proctorGroup[0].workflowModule !== 'automated') {
	                          hasUnautomated = true;
	                        } else {
	                          hasAutomated = true;
	                        }
	                      });
	                    } else if (proctorTypes) {
	                      // Check if any automated proctor types
	                      // are enabled for this exam session
	                      proctorTypes.forEach(function (type) {
	                        if (_config.config.automatedProctorTypeSids.indexOf(type) > -1) {
	                          hasAutomated = true;
	                        } else {
	                          hasUnautomated = true;
	                        }
	                      });
	                    }
	
	                    if (hasAutomated && !hasUnautomated) {
	                      isAutomatedOnly = true;
	                    }
	
	                    // We also need to check if the exam was already
	                    // scheduled with another modality (which is an edge case)
	                    if (status === 'scheduled' && schedulingModule && schedulingModule !== 'automated') {
	                      scheduledElsewhere = true;
	                    }
	
	                    if (!isAutomatedOnly || scheduledElsewhere || isReconnect) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: exam.sid },
	                        _react2.default.createElement(_StudentExamCard2.default, Object.assign({}, _this2.props, {
	                          exam: exam,
	                          toggleDrawer: _helpers.toggleDrawer,
	                          parent: _this2,
	                          reschedule: true,
	                          hasAutomated: hasAutomated
	                        }))
	                      );
	                    } else {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: exam.sid },
	                        _react2.default.createElement(_AutomatedExamCard2.default, Object.assign({}, _this2.props, {
	                          exam: exam,
	                          toggleDrawer: _helpers.toggleDrawer,
	                          parent: _this2
	                        }))
	                      );
	                    }
	                  })
	                )
	              );
	            }
	
	            return null;
	          })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          SessionStore = _props$store2.SessionStore,
	          StudentStore = _props$store2.StudentStore;
	
	
	      if (typeof SessionStore.courseData.instructor !== 'undefined') {
	        return _react2.default.createElement(
	          'main',
	          { tabIndex: '-1', id: 'main-content', 'aria-labelledby': 'page-title', className: 'page' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { id: 'page-title', className: 'page__title' },
	                translation.page_title
	              )
	            )
	          ),
	          !SessionStore.loading && this.renderResults(),
	          _react2.default.createElement(_Drawer2.default, Object.assign({
	            content: this.state.drawerContent,
	            isOpen: this.state.drawerOpen,
	            parent: this,
	            exam: this.state.exam,
	            examSid: this.state.examSid,
	            sessionSid: this.state.sessionSid,
	            reschedule: true,
	            callback: StudentStore.getOrderedStudentExams,
	            toUserSid: SessionStore.courseData.instructor.sid,
	            contextType: 'examSid',
	            contextId: this.state.examSid,
	            proctorLocationSid: this.state.proctorLocationSid,
	            confirmedDate: this.state.confirmedDate,
	            messageSid: this.state.messageSid,
	            proctorGroupSid: this.state.proctorGroupSid,
	            external: true
	          }, this.props))
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return StudentDashboard;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('StudentDashboard')(StudentDashboard);

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ExamCardClosed = __webpack_require__(858);
	
	var _ExamCardClosed2 = _interopRequireDefault(_ExamCardClosed);
	
	var _ExamCardNeedsProctor = __webpack_require__(859);
	
	var _ExamCardNeedsProctor2 = _interopRequireDefault(_ExamCardNeedsProctor);
	
	var _ExamCardScheduled = __webpack_require__(860);
	
	var _ExamCardScheduled2 = _interopRequireDefault(_ExamCardScheduled);
	
	var _AutomatedExamCard = __webpack_require__(369);
	
	var _AutomatedExamCard2 = _interopRequireDefault(_AutomatedExamCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var StudentExamCard = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(StudentExamCard, _React$Component);
	
	  function StudentExamCard() {
	    _classCallCheck(this, StudentExamCard);
	
	    var _this = _possibleConstructorReturn(this, (StudentExamCard.__proto__ || Object.getPrototypeOf(StudentExamCard)).call(this));
	
	    _this.messageInstructor = _this.messageInstructor.bind(_this);
	    return _this;
	  }
	
	  _createClass(StudentExamCard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.store.SessionStore.getCurrentTime(true);
	    }
	  }, {
	    key: 'messageInstructor',
	    value: function messageInstructor(sid) {
	      this.props.parent.setState({
	        examSid: sid,
	        messageSid: null
	      });
	
	      (0, _helpers.toggleDrawer)(null, this.props.parent, 'MessageThread');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var configuration = this.props.exam.examSession.examConfiguration;
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      var defaultScheduleClose = false;
	      var closeDatesEqual = false;
	
	      // Check if scheduling is closed
	      var scheduleCloseDate = configuration.scheduleCloseDate;
	
	      if ((0, _moment2.default)(scheduleCloseDate).diff((0, _moment2.default)(configuration.examCloseDate)) === 0) {
	        closeDatesEqual = true;
	      }
	
	      if ((0, _moment2.default)(scheduleCloseDate).format('M-D-YYYY') === '1-1-2070' || (0, _moment2.default)(scheduleCloseDate).diff((0, _moment2.default)(configuration.examCloseDate)) >= 0) {
	        // If there’s no scheduling window set
	        // or the scheduling close date is after the exam close date,
	        // use the exam close date
	        scheduleCloseDate = configuration.examCloseDate;
	        defaultScheduleClose = true;
	      }
	
	      var closeDate = (0, _moment2.default)(scheduleCloseDate);
	
	      if (defaultScheduleClose) {
	        closeDate = (0, _moment2.default)(scheduleCloseDate);
	      }
	
	      if (closeDatesEqual) {
	        scheduleCloseDate = (0, _moment2.default)(scheduleCloseDate);
	      }
	
	      var closeDiff = _moment2.default.duration(closeDate.diff(now)).asHours();
	      var daysLeft = _moment2.default.duration(closeDate.diff(now)).asDays();
	      var schedulingClosed = false;
	      var showWarning = false;
	
	      if (closeDiff < 0) {
	        schedulingClosed = true;
	      }
	
	      if (daysLeft <= 10) {
	        showWarning = true;
	      }
	
	      // Check if scheduling is open yet
	      var scheduleOpenDate = configuration.scheduleOpenDate;
	
	      var openDate = (0, _moment2.default)(scheduleOpenDate);
	      var openDiff = _moment2.default.duration(openDate.diff(now)).asHours();
	      var schedulingOpen = true;
	
	      if (openDiff >= 0) {
	        schedulingOpen = false;
	      }
	
	      var _props = this.props,
	          store = _props.store,
	          exam = _props.exam;
	      var _store$SessionStore = store.SessionStore,
	          courseData = _store$SessionStore.courseData,
	          currentTime = _store$SessionStore.currentTime;
	
	
	      if ((exam.examSession.status.toLowerCase() === 'scheduled' || exam.examSession.status.toLowerCase() === 'in progress' || exam.examSession.status.toLowerCase() === 'pending reconnection' || exam.examSession.status.toLowerCase() === 'onboarding') && courseData.instructor && exam.examSession.examConfiguration.examCloseDate > currentTime) {
	        return _react2.default.createElement(_ExamCardScheduled2.default, Object.assign({
	          schedulingOpen: schedulingOpen,
	          schedulingClosed: schedulingClosed,
	          scheduleCloseDate: scheduleCloseDate,
	          messageInstructor: this.messageInstructor
	        }, this.props));
	      } else if (exam.examSession.status.toLowerCase() === 'closed' || exam.examSession.status.toLowerCase() === 'processing') {
	
	        return _react2.default.createElement(_ExamCardClosed2.default, Object.assign({
	          schedulingOpen: schedulingOpen,
	          schedulingClosed: schedulingClosed,
	          scheduleCloseDate: scheduleCloseDate,
	          messageInstructor: this.messageInstructor
	        }, this.props));
	      } else if (schedulingClosed && this.props.hasAutomated && exam.examSession.examConfiguration.examCloseDate > currentTime) {
	
	        return _react2.default.createElement(_AutomatedExamCard2.default, Object.assign({}, this.props, {
	          exam: exam,
	          toggleDrawer: _helpers.toggleDrawer,
	          parent: this
	        }, this.props, {
	          schedulingClosed: true
	        }));
	      }
	
	      return _react2.default.createElement(_ExamCardNeedsProctor2.default, Object.assign({
	        hasAutomated: this.props.hasAutomated,
	        schedulingOpen: schedulingOpen,
	        schedulingClosed: schedulingClosed,
	        showWarning: showWarning,
	        daysLeft: daysLeft,
	        scheduleCloseDate: scheduleCloseDate,
	        messageInstructor: this.messageInstructor,
	        defaultScheduleClose: defaultScheduleClose
	      }, this.props, {
	        configuration: configuration
	      }));
	    }
	  }]);
	
	  return StudentExamCard;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('StudentExamCard')(StudentExamCard);

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _TicketForm = __webpack_require__(373);
	
	var _TicketForm2 = _interopRequireDefault(_TicketForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var AddSupportTicket = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AddSupportTicket, _React$Component);
	
	  function AddSupportTicket() {
	    _classCallCheck(this, AddSupportTicket);
	
	    return _possibleConstructorReturn(this, (AddSupportTicket.__proto__ || Object.getPrototypeOf(AddSupportTicket)).apply(this, arguments));
	  }
	
	  _createClass(AddSupportTicket, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form' },
	          _react2.default.createElement(_TicketForm2.default, Object.assign({}, this.props, { newTicket: true }))
	        )
	      );
	    }
	  }]);
	
	  return AddSupportTicket;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AddSupportTicket')(AddSupportTicket);

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _helpers = __webpack_require__(5);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(36);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _TicketForm = __webpack_require__(373);
	
	var _TicketForm2 = _interopRequireDefault(_TicketForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var SupportTicketDetail = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SupportTicketDetail, _React$Component);
	
	  function SupportTicketDetail() {
	    _classCallCheck(this, SupportTicketDetail);
	
	    var _this = _possibleConstructorReturn(this, (SupportTicketDetail.__proto__ || Object.getPrototypeOf(SupportTicketDetail)).call(this));
	
	    _this.renderConversation = _this.renderConversation.bind(_this);
	    return _this;
	  }
	
	  _createClass(SupportTicketDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var TicketStore = this.props.store.TicketStore;
	
	      var ticketSid = (0, _helpers.getURLSegment)(this, 3);
	
	      TicketStore.getTicket(ticketSid);
	    }
	  }, {
	    key: 'initials',
	    value: function initials(name, className) {
	      var names = name.split(' ');
	      var firstInitial = names[0].charAt(0);
	      var secondInitial = names[1].charAt(0);
	
	      if (className) {
	        return '' + firstInitial.toLowerCase();
	      }
	
	      return firstInitial + secondInitial;
	    }
	  }, {
	    key: 'renderConversation',
	    value: function renderConversation() {
	      var _this2 = this;
	
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var SessionStore = store.SessionStore,
	          TicketStore = store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'ol',
	          { className: 'conversation' },
	          activeTicket.conversations.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'blockquote',
	                { className: 'conversation__message ' + (key.jobTitle !== null ? 'received' : 'sent') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'conversation__body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'conversation__content' },
	                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(key.body) } })
	                  ),
	                  _react2.default.createElement(
	                    'time',
	                    { className: 'conversation__timestamp' },
	                    (0, _moment2.default)(key.created_at).format('M/D/YYYY h:mma')
	                  )
	                ),
	                _react2.default.createElement(
	                  'cite',
	                  { className: 'conversation__author conversation__author--sm' },
	                  _react2.default.createElement(
	                    'abbr',
	                    {
	                      className: '\n                      avatar--initials\n                      conversation__avatar\n                      ' + _this2.initials(key.name, true) + '\n                    ',
	                      title: '' + key.name },
	                    _this2.initials(key.name, false)
	                  ),
	                  key.jobTitle !== null && _react2.default.createElement(
	                    'em',
	                    { className: 'conversation__tag' },
	                    translation.admin
	                  )
	                )
	              )
	            );
	          })
	        );
	      }
	
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          store = _props2.store,
	          translation = _props2.translation;
	      var SessionStore = store.SessionStore,
	          TicketStore = store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading,
	                activeTicket.ticketNumber
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'article',
	              { className: 'ticket' },
	              _react2.default.createElement(
	                'header',
	                { className: 'ticket__header' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  activeTicket.subject
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pill pill--' + activeTicket.status.toLowerCase() },
	                  activeTicket.status
	                )
	              ),
	              this.renderConversation()
	            ),
	            _react2.default.createElement(_TicketForm2.default, Object.assign({ activeTicket: activeTicket }, this.props))
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SupportTicketDetail;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SupportTicketDetail')(SupportTicketDetail);

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Components
	
	// import Paginate from '../Common/Paginate';
	
	
	// Dependencies
	
	
	var SupportTickets = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SupportTickets, _React$Component);
	
	  function SupportTickets() {
	    _classCallCheck(this, SupportTickets);
	
	    var _this2 = _possibleConstructorReturn(this, (SupportTickets.__proto__ || Object.getPrototypeOf(SupportTickets)).call(this));
	
	    _this2.handleDrawer = _this2.handleDrawer.bind(_this2);
	    _this2.filterTickets = _this2.filterTickets.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(SupportTickets, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          TicketStore = _props$store.TicketStore;
	
	
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        dataReceived: false
	      };
	      TicketStore.getTickets(SessionStore.userData.enrollmentSid);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.routing.location.pathname;
	
	
	      if (pathname.indexOf('/view') > -1) {
	        (0, _helpers.toggleDrawer)(null, this, 'SupportTicketDetail');
	      } else if (pathname.indexOf('/add') > -1) {
	        (0, _helpers.toggleDrawer)(null, this, 'AddSupportTicket');
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props$store2 = this.props.store,
	          SessionStore = _props$store2.SessionStore,
	          TicketStore = _props$store2.TicketStore;
	
	      // Set the state’s filtered tickets to all the tickets received from the API
	      // then set the state dataReceived to true to prevent this from running again
	
	      if (!SessionStore.loading && !this.state.dataReceived) {
	        this.setState({
	          filteredTickets: TicketStore.tickets,
	          dataReceived: true
	        });
	      }
	    }
	  }, {
	    key: 'handleDrawer',
	    value: function handleDrawer(e) {
	      e.preventDefault();
	
	      // Update url
	      var path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');
	
	      if (this.props.routing.location.pathname !== path) {
	        this.props.routing.push(path);
	      }
	    }
	  }, {
	    key: 'filterTickets',
	    value: function filterTickets() {
	      var _this = this;
	      var tickets = this.props.store.TicketStore.tickets;
	
	
	      if (this.filter.value) {
	        var newFilteredTickets = tickets.filter(function (key) {
	          return key.statusId.toString() === _this.filter.value;
	        });
	
	        this.setState({
	          filter: this.filter.value
	        });
	
	        this.props.store.TicketStore.filterTickets(newFilteredTickets);
	      } else {
	        this.setState({
	          filter: null
	        });
	
	        this.props.store.TicketStore.filterTickets(tickets);
	      }
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var TicketStore = this.props.store.TicketStore;
	      var filteredTickets = TicketStore.filteredTickets;
	      var userTimezone = this.props.store.SessionStore.userTimezone;
	
	      var segment1 = (0, _helpers.getURLSegment)(this, 1);
	
	      if (filteredTickets.length > 0) {
	        // const paginate = {
	        //   total: 10,
	        //   first: '#',
	        //   next: '#',
	        //   prev: '#',
	        //   last: '#',
	        //   count: 1,
	        //   limit: 1,
	        //   current: 1
	        // }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', className: 'subtitle' },
	                  translation.ticket_id
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', className: 'subtitle' },
	                  translation.subject
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', className: 'subtitle' },
	                  translation.status
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', className: 'subtitle' },
	                  translation.last_update
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              filteredTickets.map(function (key, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: i },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'title-link--alt', to: segment1 + '/view/' + key.sid, onClick: function onClick(e) {
	                          _this3.handleDrawer(e);
	                        } },
	                      key.ticketNumber
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouter.Link,
	                      { className: 'title-link--alt', to: segment1 + '/view/' + key.sid, onClick: function onClick(e) {
	                          _this3.handleDrawer(e);
	                        } },
	                      key.subject
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'pill pill--' + key.status.toLowerCase() },
	                      key.status
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _moment2.default.utc(key.ticketLastUpdated).tz(userTimezone).format('M/D/YYYY h:mma')
	                  )
	                );
	              })
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	      var segment1 = (0, _helpers.getURLSegment)(this, 1);
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page__actions actions' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: segment1 + '/add', className: 'btn--outline', onClick: function onClick(e) {
	                    _this4.handleDrawer(e);
	                  } },
	                _react2.default.createElement(icons.iconPlus, null),
	                translation.button
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'filter' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'filter__filters' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--inline' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.show,
	                    ':'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select' },
	                    _react2.default.createElement(
	                      'select',
	                      { onChange: this.filterTickets, ref: function ref(input) {
	                          _this4.filter = input;
	                        } },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        translation.filters.all
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '2' },
	                        translation.filters.open
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '4' },
	                        translation.filters.resolved
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '5' },
	                        translation.filters.closed
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '3' },
	                        translation.filters.pending
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({ content: this.state.drawerContent, isOpen: this.state.drawerOpen, parent: this }, this.props))
	      );
	    }
	  }]);
	
	  return SupportTickets;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SupportTickets')(SupportTickets);

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(15);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _jwtDecode = __webpack_require__(247);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _UserStore = __webpack_require__(383);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Unauthorized = function (_React$Component) {
	  _inherits(Unauthorized, _React$Component);
	
	  function Unauthorized() {
	    _classCallCheck(this, Unauthorized);
	
	    return _possibleConstructorReturn(this, (Unauthorized.__proto__ || Object.getPrototypeOf(Unauthorized)).apply(this, arguments));
	  }
	
	  _createClass(Unauthorized, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var token = this.props.routing.location.search.split('token=')[1];
	      if (token) {
	        this.payload = (0, _jwtDecode2.default)(token);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var blockedUser = _UserStore2.default.blockedUser;
	
	
	      console.log(this.payload);
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'i',
	            { className: 'page--error__icon' },
	            _react2.default.createElement(icons.iconLock, null)
	          ),
	          blockedUser && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation.blocked_user.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.blocked_user.message
	            )
	          ),
	          typeof this.payload !== 'undefined' && !blockedUser && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation.has_code.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.has_code.message
	            ),
	            _react2.default.createElement(
	              'code',
	              { className: 'text-code' },
	              this.payload.errorMessage
	            )
	          ),
	          typeof this.payload === 'undefined' && !blockedUser && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation.default.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.default.message
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: 'btn--outline', to: '/' },
	              translation.default.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Unauthorized;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('Unauthorized')(Unauthorized);

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrameHeadshot = function (_React$Component) {
	  _inherits(FrameHeadshot, _React$Component);
	
	  function FrameHeadshot() {
	    _classCallCheck(this, FrameHeadshot);
	
	    return _possibleConstructorReturn(this, (FrameHeadshot.__proto__ || Object.getPrototypeOf(FrameHeadshot)).apply(this, arguments));
	  }
	
	  _createClass(FrameHeadshot, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("img", {
	        className: "webcam__frame webcam__frame--portrait",
	        src: "data:image/gif;base64,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",
	        role: "presentation"
	      });
	    }
	  }]);
	
	  return FrameHeadshot;
	}(_react2.default.Component);
	
	exports.default = FrameHeadshot;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FrameID = function (_React$Component) {
	  _inherits(FrameID, _React$Component);
	
	  function FrameID() {
	    _classCallCheck(this, FrameID);
	
	    return _possibleConstructorReturn(this, (FrameID.__proto__ || Object.getPrototypeOf(FrameID)).apply(this, arguments));
	  }
	
	  _createClass(FrameID, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("img", {
	        className: "webcam__frame webcam__frame--landscape",
	        src: "data:image/gif;base64,R0lGODdh8wN9AvAAAAAAACZFySH5BAEAAAEALAAAAADzA30CAAL/jI+py+0Po5y02ouz3rz7D4biSJbmiabqyrbuC8fyTNf2jef6zvf+DwwKh8Si8YhMKpfMpvMJjUqn1Kr1is1qt9yu9wsOi8fksvmMTqvX7Lb7DY/L5/S6/Y7P6/f8vv8PGCg4SFhoeIiYqLjI2Oj4CBkpOUlZaXmJmam5ydnp+QkaKjpKWmp6ipqqusra6voKGys7S1tre4ubq7vL2+v7CxwsPExcbHyMnKy8zNzs/AwdLT1NXW19jZ2tvc3d7f0NHi4+Tl5ufo6err7O3u7+Dh8vP09fb3+Pn6+/z9/v/w8woMCBBAsaPIgwocKFDBs6fAgxosSJFCtavIgxo8aN/xw7evwIMqTIkSRLmjyJMqXKlSxbunwJM6bMmTRr2ryJM6fOnTx7+vwJNKjQoUSLGj2KNKnSpUybOn0KNarUqVSrWr2KNavWrVy7ev0KNqzYsWTLmj2LNq3atWzbun0LN67cuXTr2r2LN6/evXz7+v0LOLDgwYQLGz6MOLHixYwbO34MObLkyZQrW76MObPmzZw7e/4MOrTo0aRLmz6NOrXq1axbu34NO7bs2bRr276NO7fu3bx7+/4NPLjw4cSLGz+OPLny5cybO38OPbr06dSrW7+OPbv27dy7e/8OPrz48eTLmz+PPr369ezbu38PP778+fTr27+PP7/+/fz7+///D2CAAg5IYIEGHohgggouyGCDDj4IYYQSTkhhhRZeiGGGGm7IYYcefghiiCKOSGKJJp6IYooqrshiiy6+CGOMMs5IY4023ohjjjruyGOPPv4IZJBCDklkkUYeiWSSSi7JZJNOPglllFJOSWWVVl6JZZZabslll15+CWaYYo5JZplmnolmmmquyWabbr4JZ5xyzklnnXbeiWeeeu7JZ59+/glooIIOSmihhh6KaKKKLspoo44+Cmmkkk5KaaWWXopppppuymmnnn4Kaqiijkpqqaaeimqqqq7KaquuvgprrLLOSmuttt6Ka6667sprr77+Cmywwg5LbLHGHotsssr/Lstss84+C2200k5LbbXWXottttpuy2233n4Lbrjijktuueaei2666q7LbrvuvgtvvPLOS2+99t6Lb7767stvv/7+C3DAAg9McMEGH4xwwgovzHDDDj8MccQST0xxxRZfjHHGGm/McccefwxyyCKPTHLJJp+Mcsoqr8xyyy6/DHPMMs9Mc80234xzzjrvzHPPPv8MdNBCD0100UYfjXTSSi/NdNNOPw111FJPTXXVVl+NddZab811115/DXbYYo9Ndtlmn4122mqvzXbbbr8Nd9xyz0133XbfjXfeeu/Nd99+/w144IIPTnjhhh+OeOKKL854444/Dnnkkk9OeeWW/1+Oeeaab855555/Dnrooo9Oeummn4566qqvznrrrr8Oe+yyz0577bbfjnvuuu/Oe+++/w588MIPT3zxxh+PfPLKL898884/D3300k9PffXWX4999tpvz3333n8Pfvjij09++eafj3766q/Pfvvuvw9//PLPT3/99t+Pf/76789///7/D8AACnCABCygAQ+IwAQqcIEMbKADHwjBCEpwghSsoAUviMEManCDHOygBz8IwhCKcIQkLKEJT4jCFKpwhSxsoQtfCMMYynCGNKyhDW+IwxzqcIc87KEPfwjEIApxiEQsohGPiMQkKnGJTGyiE58IxShKcYpUrKIVr4jFLCZqcYtc7KIXvwjGMIpxjGQsoxnPiMY0qnGNbGyjG98IxzjKUToFAAA7",
	        role: "presentation"
	      });
	    }
	  }]);
	
	  return FrameID;
	}(_react2.default.Component);
	
	exports.default = FrameID;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _VolumeMeter = __webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Audio functions
	
	
	var Microphone = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Microphone, _React$Component);
	
	  function Microphone() {
	    _classCallCheck(this, Microphone);
	
	    return _possibleConstructorReturn(this, (Microphone.__proto__ || Object.getPrototypeOf(Microphone)).apply(this, arguments));
	  }
	
	  _createClass(Microphone, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initMicrophone();
	      this.props.button.disabled = true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.killMicrophone();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var microphone = this.props.microphone;
	
	      // Change webcam
	
	      if (microphone !== prevProps.microphone) {
	        this.initMicrophone();
	      }
	    }
	  }, {
	    key: 'killMicrophone',
	    value: function killMicrophone() {
	      // Kill the camera stream on unmount
	      if (this.stream) {
	        this.stream.getTracks().forEach(function (track) {
	          track.stop();
	        });
	      }
	    }
	  }, {
	    key: 'initMicrophone',
	    value: function initMicrophone() {
	      var _this = this;
	      var microphone = this.props.microphone;
	
	
	      this.killMicrophone();
	
	      var constraints = {
	        audio: true
	      };
	
	      if (microphone) {
	        constraints.audio = {
	          deviceId: microphone
	        };
	      }
	
	      navigator.mediaDevices.getUserMedia(constraints).then(function (media) {
	        _this.stream = media;
	
	        _this.visualize();
	
	        // Stream the media to the video element
	        // const audioEl = document.querySelector('.microphone__stream');
	        // audioEl.srcObject = media;
	        // audioEl.onloadedmetadata = function(e) {
	        //   audioEl.play();
	        // };
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'visualize',
	    value: function visualize() {
	      var _this3 = this;
	
	      var audioCtx = new window.AudioContext();
	      var src = audioCtx.createMediaStreamSource(this.stream);
	      var meter = (0, _VolumeMeter.createAudioMeter)(audioCtx);
	
	      src.connect(meter);
	
	      var canvas = document.querySelector('.microphone__visualizer');
	      var canvasCtx = canvas.getContext('2d');
	      var width = canvas.width;
	      var height = canvas.height;
	
	      var volumeCheck = setInterval(function () {
	        var audioLevel = meter.volume * 100;
	        var hasAudio = audioLevel >= 1;
	
	        if (hasAudio) {
	          _this3.props.onAudioDetected();
	          clearInterval(volumeCheck);
	        }
	      }, 100);
	
	      draw();
	
	      function draw() {
	        canvasCtx.clearRect(0, 0, width, height);
	        canvasCtx.fillStyle = 'lime';
	
	        canvasCtx.fillRect(0, 0, width, meter.volume * height * 5);
	
	        requestAnimationFrame(draw);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'microphone' },
	        _react2.default.createElement('audio', { className: 'microphone__stream', muted: 'true' }),
	        _react2.default.createElement('canvas', { className: 'microphone__visualizer' })
	      );
	    }
	  }]);
	
	  return Microphone;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Microphone')(Microphone);

/***/ },
/* 881 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.createAudioMeter = createAudioMeter;
	exports.volumeAudioProcess = volumeAudioProcess;
	/*
	The MIT License (MIT)
	Copyright (c) 2014 Chris Wilson
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	SOFTWARE.
	*/
	
	/*
	Usage:
	audioNode = createAudioMeter(audioContext,clipLevel,averaging,clipLag);
	audioContext: the AudioContext you're using.
	clipLevel: the level (0 to 1) that you would consider "clipping".
	   Defaults to 0.98.
	averaging: how "smoothed" you would like the meter to be over time.
	   Should be between 0 and less than 1.  Defaults to 0.95.
	clipLag: how long you would like the "clipping" indicator to show
	   after clipping has occured, in milliseconds.  Defaults to 750ms.
	Access the clipping through node.checkClipping(); use node.shutdown to get rid of it.
	*/
	
	function createAudioMeter(audioContext, clipLevel, averaging, clipLag) {
		var processor = audioContext.createScriptProcessor(512);
		processor.onaudioprocess = volumeAudioProcess;
		processor.clipping = false;
		processor.lastClip = 0;
		processor.volume = 0;
		processor.clipLevel = clipLevel || 0.98;
		processor.averaging = averaging || 0.95;
		processor.clipLag = clipLag || 750;
	
		// this will have no effect, since we don't copy the input to the output,
		// but works around a current Chrome bug.
		processor.connect(audioContext.destination);
	
		processor.checkClipping = function () {
			if (!this.clipping) return false;
			if (this.lastClip + this.clipLag < window.performance.now()) this.clipping = false;
			return this.clipping;
		};
	
		processor.shutdown = function () {
			this.disconnect();
			this.onaudioprocess = null;
		};
	
		return processor;
	}
	
	function volumeAudioProcess(event) {
		var buf = event.inputBuffer.getChannelData(0);
		var bufLength = buf.length;
		var sum = 0;
		var x;
	
		// Do a root-mean-square on the samples: sum up the squares...
		for (var i = 0; i < bufLength; i++) {
			x = buf[i];
			if (Math.abs(x) >= this.clipLevel) {
				this.clipping = true;
				this.lastClip = window.performance.now();
			}
			sum += x * x;
		}
	
		// ... then take the square root of the sum.
		var rms = Math.sqrt(sum / bufLength);
	
		// Now smooth this out with the averaging factor applied
		// to the previous sample - take the max here because we
		// want "fast attack, slow release."
		this.volume = Math.max(rms, this.volume * this.averaging);
	}

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Media = function Media(props) {
	  var media = props.media;
	
	
	  if (media.kind === 'video') {
	    return _react2.default.createElement(
	      'div',
	      { className: 'vid' },
	      _react2.default.createElement('div', { className: 'vid__wrap', id: 'track-' + media.id })
	    );
	  } else {
	    return _react2.default.createElement('div', { id: 'track-' + media.id });
	  }
	};
	
	exports.default = Media;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactNotifyToast = __webpack_require__(573);
	
	var _reactNotifyToast2 = _interopRequireDefault(_reactNotifyToast);
	
	var _reactTextMask = __webpack_require__(1492);
	
	var _reactTextMask2 = _interopRequireDefault(_reactTextMask);
	
	var _Media = __webpack_require__(882);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _logo = __webpack_require__(686);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var StepIn = (0, _mobxReact.observer)(function (_Component) {
	  _inherits(StepIn, _Component);
	
	  function StepIn() {
	    _classCallCheck(this, StepIn);
	
	    var _this = _possibleConstructorReturn(this, (StepIn.__proto__ || Object.getPrototypeOf(StepIn)).call(this));
	
	    _this.editSession = _this.editSession.bind(_this);
	    _this.submitForm = _this.submitForm.bind(_this);
	    return _this;
	  }
	
	  _createClass(StepIn, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        sessionInput: null
	      };
	
	      if (this.props.accessCode) {
	        this.props.store.StepInStore.lookupSession(this.props.accessCode);
	      }
	    }
	  }, {
	    key: 'editSession',
	    value: function editSession(input) {
	      this.setState({
	        sessionInput: input
	      });
	    }
	  }, {
	    key: 'submitForm',
	    value: function submitForm(e) {
	      e.preventDefault();
	      this.props.store.StepInStore.lookupSession(this.state.sessionInput);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var StepInStore = this.props.store.StepInStore;
	      var tracks = StepInStore.tracks;
	
	
	      var media = this.props.store.StepInStore.tracks.map(function (media, i) {
	        return _react2.default.createElement(_Media2.default, { key: i, media: media });
	      });
	
	      // const _this = this;
	      //
	      // setTimeout(function(){
	      //   _this.props.store.StepInStore.tracks.map(
	      //     (media, i) => {
	      //     const track = document.querySelector(`#track-${i}`);
	      //     console.log(track);
	      //     track.appendChild(media);
	      //     return null;
	      //   });
	      // }, 5000);
	
	      if (this.props.sessionDetail) {
	        if (tracks.length === 0) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'cta' },
	            _react2.default.createElement(_reactNotifyToast2.default, null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'cta__copy' },
	              translation.not_started.heading
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'cta_subcopy' },
	              translation.not_started.body
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            { className: 'session-viewer' },
	            _react2.default.createElement(_reactNotifyToast2.default, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'session-viewer__media wrap' },
	              media
	            )
	          );
	        }
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content session-viewer' },
	          _react2.default.createElement(_reactNotifyToast2.default, null),
	          _react2.default.createElement(
	            'header',
	            { className: 'session-viewer__header' },
	            _react2.default.createElement('img', { className: 'session-viewer__logo', src: _logo2.default, alt: 'smarterproctoring' })
	          ),
	          !this.props.accessCode && _react2.default.createElement(
	            'form',
	            { className: 'filter session-viewer__form', onSubmit: function onSubmit(e) {
	                return _this2.submitForm(e);
	              } },
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields--inline' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'session-id' },
	                  translation.access_code
	                ),
	                _react2.default.createElement(_reactTextMask2.default, {
	                  mask: [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
	                  guide: false,
	                  type: 'text',
	                  id: 'session-id',
	                  placeholder: '123-456-789',
	                  required: true,
	                  autoFocus: true,
	                  onKeyUp: function onKeyUp(e) {
	                    return _this2.editSession(e.target.value);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'btn' },
	                  translation.connect
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'session-viewer__media wrap' },
	            media
	          )
	        );
	      }
	    }
	  }]);
	
	  return StepIn;
	}(_react.Component));
	
	exports.default = (0, _Translate2.default)('StepIn')(StepIn);

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	var NotFound = function (_React$Component) {
	  _inherits(NotFound, _React$Component);
	
	  function NotFound() {
	    _classCallCheck(this, NotFound);
	
	    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	  }
	
	  _createClass(NotFound, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var ua = document.querySelector('html').getAttribute('data-ua');
	      var examTitle = ua.split('Exam Title:')[1];
	
	      if (!examTitle) {
	        examTitle = 'your exam';
	      } else {
	        examTitle = '\u201C' + examTitle + '\u201D';
	      }
	
	      this.state = {
	        examTitle: examTitle
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            'Start VTC Session'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'To start your session, please navigate to ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              this.state.examTitle
	            ),
	            ' in your online course.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NotFound;
	}(_react2.default.Component);
	
	exports.default = NotFound;

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	var EditVoucher = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditVoucher, _React$Component);
	
	  function EditVoucher() {
	    _classCallCheck(this, EditVoucher);
	
	    var _this = _possibleConstructorReturn(this, (EditVoucher.__proto__ || Object.getPrototypeOf(EditVoucher)).call(this));
	
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditVoucher, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        voucherData: {
	          tag: null,
	          memo: null
	        }
	      };
	
	      this.getVoucher();
	    }
	  }, {
	    key: 'getVoucher',
	    value: function getVoucher() {
	      this.props.store.VoucherStore.getVoucher(this.props.voucherSid);
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var voucherData = Object.assign({}, this.state.voucherData);
	
	      voucherData.tag = this.tag.value || '';
	      voucherData.memo = this.memo.value || '';
	
	      this.setState({
	        voucherData: voucherData
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var _this2 = this;
	
	      var payload = {};
	
	      Object.keys(this.state.voucherData).forEach(function (prop) {
	        if (_this2.state.voucherData[prop]) payload[prop] = _this2.state.voucherData[prop];
	      });
	
	      this.props.store.VoucherStore.updateVoucher(this.props.voucherSid, payload, this.complete);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      (0, _helpers.closeDrawer)(null, this.props.parent, (0, _helpers.getURLSegment)(this, 1));
	
	      this.props.store.SessionStore.showToaster(this.props.translation.voucher_saved, 'success');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var voucherData = this.props.store.VoucherStore.voucherData;
	
	
	      if (Object.keys(voucherData).length > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.page_title
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap block-form' },
	            _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'div',
	                { className: 'panel--medium' },
	                _react2.default.createElement(
	                  'fieldset',
	                  null,
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'fields' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-optional', htmlFor: 'vouchers-tag', 'aria-describedby': 'vouchers-tag-tooltip' },
	                        translation.tag.label,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'tooltip' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                            '(?)'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { id: 'vouchers-tag-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                            translation.tag.tooltip
	                          )
	                        )
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        id: 'vouchers-tag',
	                        ref: function ref(input) {
	                          _this3.tag = input;
	                        },
	                        onChange: this.handleInput,
	                        defaultValue: voucherData.tag
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'lbl-optional', htmlFor: 'vouchers-memo', 'aria-describedby': 'vouchers-memo-tooltip' },
	                        translation.memo.label,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'tooltip' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                            '(?)'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { id: 'vouchers-memo-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                            translation.memo.tooltip
	                          )
	                        )
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        id: 'vouchers-memo',
	                        ref: function ref(input) {
	                          _this3.memo = input;
	                        },
	                        onChange: this.handleInput,
	                        defaultValue: voucherData.memo
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'panel__actions actions' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'actions__btn actions__btn--primary' },
	                      translation.button
	                    )
	                  )
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return EditVoucher;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('EditVoucher')(EditVoucher);

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(5);
	
	var _reactDelayed = __webpack_require__(112);
	
	var _reactDelayed2 = _interopRequireDefault(_reactDelayed);
	
	var _Drawer = __webpack_require__(25);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Icons = __webpack_require__(6);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _VoucherList = __webpack_require__(376);
	
	var _VoucherList2 = _interopRequireDefault(_VoucherList);
	
	var _Toolbar = __webpack_require__(98);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var Vouchers = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Vouchers, _React$Component);
	
	  function Vouchers() {
	    _classCallCheck(this, Vouchers);
	
	    var _this2 = _possibleConstructorReturn(this, (Vouchers.__proto__ || Object.getPrototypeOf(Vouchers)).call(this));
	
	    _this2.deleteVouchers = _this2.deleteVouchers.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Vouchers, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        selectedRows: []
	      };
	      this.getVouchers();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.routing.location.pathname;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if ((0, _helpers.getURLSegment)(this, 2) === 'edit') {
	        SessionStore.loading = false;
	        (0, _helpers.toggleDrawer)(null, this, 'EditVoucher');
	        var voucherSid = pathname.substr(pathname.lastIndexOf('/') + 1);
	
	        this.setState({
	          voucherSid: voucherSid
	        });
	      }
	    }
	  }, {
	    key: 'getVouchers',
	    value: function getVouchers() {
	      this.props.store.VoucherStore.getVouchers();
	    }
	  }, {
	    key: 'deleteVouchers',
	    value: function deleteVouchers() {
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.delete_confirm.heading_singular,
	        body: translation.delete_confirm.body_singular,
	        button: translation.delete_confirm.button
	      };
	
	      if (this.state.selectedRows.length > 1) {
	        msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
	        msg.body = translation.delete_confirm.body_plural;
	      }
	
	      // Loop through all the selected funding rules and send delete API request
	      var _this = this;
	
	      (0, _helpers.confirm)(msg, function () {
	        for (var i = 0; i < _this.state.selectedRows.length; i++) {
	          _this.props.store.VoucherStore.deleteVoucher(_this.state.selectedRows[i]);
	        }
	
	        _this.setState({
	          selectedRows: []
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var VoucherStore = this.props.store.VoucherStore;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page__actions actions' },
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--secondary', onClick: function onClick(e) {
	                    return (0, _helpers.toggleDrawer)(e, _this3, 'AddVoucher');
	                  } },
	                _react2.default.createElement(icons.iconPlus, null),
	                translation.create_vouchers
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_VoucherList2.default, Object.assign({}, this.props, {
	          vouchers: VoucherStore.vouchers,
	          parent: this,
	          toggleDrawer: _helpers.toggleDrawer,
	          selectedRows: this.state.selectedRows
	        })),
	        _react2.default.createElement(
	          _reactDelayed2.default,
	          {
	            mounted: this.state.selectedRows.length > 0,
	            unmountAfter: 250
	          },
	          _react2.default.createElement(_Toolbar2.default, Object.assign({
	            selectedRows: this.state.selectedRows,
	            deleteText: translation.delete,
	            deleteFunction: this.deleteVouchers
	          }, this.props))
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this
	        }, this.props, {
	          voucherSid: this.state.voucherSid
	        }))
	      );
	    }
	  }]);
	
	  return Vouchers;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Vouchers')(Vouchers);

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(2);
	
	var _config = __webpack_require__(9);
	
	var _Translate = __webpack_require__(4);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Renders a view for the student while the exam is provisioned
	
	// Config
	
	
	// Translation
	
	
	var ProvisionExam = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProvisionExam, _React$Component);
	
	  function ProvisionExam() {
	    _classCallCheck(this, ProvisionExam);
	
	    return _possibleConstructorReturn(this, (ProvisionExam.__proto__ || Object.getPrototypeOf(ProvisionExam)).apply(this, arguments));
	  }
	
	  _createClass(ProvisionExam, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ProctorStore = this.props.store.ProctorStore;
	
	      // This gets the query params, if any, from the url
	      // Extract query string from hash (e.g., /#/provision?param=value)
	
	      var queryString = window.location.hash.includes('?') ? window.location.hash.split('?')[1] : window.location.search.substring(1);
	      var params = new Proxy(new URLSearchParams(queryString), {
	        get: function get(searchParams, prop) {
	          return searchParams.get(prop);
	        }
	      });
	
	      var examSid = params.exam_sid || params.examSid || sessionStorage.getItem('examSid');
	      var installSid = params.install_sid || params.installSid || sessionStorage.getItem('installSid');
	      var sessionSid = params.session_sid || params.sessionSid || sessionStorage.getItem('sessionSid');
	
	      var data = {
	        examSid: examSid,
	        installSid: installSid,
	        sessionSid: sessionSid,
	        status: 'Checked In'
	      };
	
	      var callback = function callback(url) {
	        window.location.href = url;
	      };
	
	      // If there is a token in sessionStorage, make sure
	      // we are using it for API calls. (This may be redundant).
	      if (sessionStorage.getItem('token')) {
	        (0, _config.setToken)(sessionStorage.getItem('token'), true);
	      }
	
	      ProctorStore.provisionOnlineSession(data, callback);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'page wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'form-brief' },
	            translation.message
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProvisionExam;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProvisionExam')(ProvisionExam);

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Helpers
	var obx = (0, _mobx.observable)({
	  // List blackout dates
	  blackoutDatesNext: null,
	  blackoutDates: [],
	  listBlackoutDates: (0, _mobx.action)(function (query) {
	    _SessionStore2.default.startLoading('Loading…', 'listBlackoutDates');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/blackoutDates' + (0, _helpers.convertObjToQuery)(query)).then(function (response) {
	      obx.blackoutDates = response.data.results;
	
	      // Set pagination next url
	      if (response.data.next) {
	        // API returns a url with a different domain for the next link
	        // so create an anchor element and set its href to the next link
	        // and then grab the pathname and query from that
	        var nextUrl = (0, _helpers.getPath)(response.data.next);
	        nextUrl = nextUrl.replace('/v1', '');
	        obx.blackoutDatesNext = nextUrl;
	      } else {
	        obx.blackoutDatesNext = null;
	      }
	
	      _SessionStore2.default.finishLoading('listBlackoutDates');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get blackout date
	  blackoutDate: null,
	  getBlackoutDate: (0, _mobx.action)(function (blackoutDateSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'getBlackoutDate');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/blackoutDates/' + blackoutDateSid).then(function (response) {
	      obx.blackoutDate = response.data;
	
	      if (callback) {
	        callback(response);
	      }
	
	      _SessionStore2.default.finishLoading('getBlackoutDate');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete blackout date
	  deleteBlackoutDate: (0, _mobx.action)(function (blackoutDateSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'deleteBlackoutDate');
	
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/blackoutDates/' + blackoutDateSid).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('deleteBlackoutDate');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create blackout date
	  createBlackoutDate: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'createBlackoutDate');
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/blackoutDates', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('createBlackoutDate');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update blackout date
	  updateBlackoutDate: (0, _mobx.action)(function (blackoutDateSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'updateBlackoutDate');
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/blackoutDates/' + blackoutDateSid, data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('updateBlackoutDate');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(56);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Dependencies
	
	
	// Components
	
	
	var obx = (0, _mobx.observable)({
	  getCourseSid: (0, _mobx.action)(function (courseSid) {
	    if (courseSid) {
	      var userData = {};
	
	      if (_SessionStore2.default.hasSessionStorage) {
	        userData = JSON.parse(sessionStorage.getItem('userData'));
	      } else {
	        userData = JSON.parse((0, _helpers.getCookie)('userData'));
	      }
	
	      userData.courseSid = courseSid;
	
	      if (_SessionStore2.default.hasSessionStorage) {
	        sessionStorage.setItem('userData', JSON.stringify(userData));
	      } else {
	        document.cookie = 'userData=' + JSON.stringify(userData);
	      }
	
	      _SessionStore2.default.setUserData(userData);
	    }
	  }),
	  exams: {},
	
	  /**
	   * Get all exams for a course
	   * 
	   * @function getExams
	   * @param {string} courseSid
	   * @param {boolean} hideSummary
	   */
	  getExams: (0, _mobx.action)(function (courseSid, hideSummary) {
	    _SessionStore2.default.startLoading('Loading…', 'CourseExams');
	
	    obx.getCourseSid();
	
	    var includeSummary = true;
	
	    if (hideSummary) {
	      includeSummary = false;
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + (courseSid || _SessionStore2.default.userData.courseSid) + '/exams?includeStatusSummary=' + includeSummary + '&sortKeys=examOpenDate').then(function (response) {
	      obx.exams = response.data.results;
	      _SessionStore2.default.finishLoading('CourseExams');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  /**
	   * Get all exams for a course, sorted and grouped by status
	   * 
	   * @function getOrderedExams
	   * @param {string} courseSid
	   * @param {boolean} hideSummary
	   */
	  orderedExams: [],
	
	  getOrderedExams: (0, _mobx.action)(function (courseSid, hideSummary) {
	    _SessionStore2.default.startLoading('Loading…', 'CourseExams');
	
	    obx.getCourseSid();
	
	    var includeSummary = true;
	
	    if (hideSummary) {
	      includeSummary = false;
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + (courseSid || _SessionStore2.default.userData.courseSid) + '/exams/ordered?includeStatusSummary=' + includeSummary + '&sortKeys=examOpenDate').then(function (response) {
	      obx.orderedExams = response.data.exams;
	      _SessionStore2.default.finishLoading('CourseExams');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  instructorAppointments: [],
	  getInstructorAppointments: (0, _mobx.action)(function (courseSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetInstructorAppointments');
	
	    obx.instructorAppointments = [];
	
	    obx.getCourseSid();
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/reports/appointments?courseSid=' + (courseSid || _SessionStore2.default.userData.courseSid) + '&type=instructor-as-proctor&appointmentAfter=' + (0, _moment2.default)().toISOString()).then(function (response) {
	      obx.instructorAppointments = response.data.results;
	
	      _SessionStore2.default.finishLoading('GetInstructorAppointments');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get exams as admin
	  getExamsAsAdmin: (0, _mobx.action)(function (courseSid) {
	    _SessionStore2.default.startLoading('Loading…', 'CourseExamsAdmin');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + courseSid + '/exams?includeStatusSummary=true&sortKeys=title&sortKeys=examOpenDate').then(function (response) {
	      obx.exams = response.data.results;
	      _SessionStore2.default.finishLoading('CourseExamsAdmin');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get course offerings
	  courseOfferings: [],
	  getCourseOfferings: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetCourseOfferings');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courseOfferings').then(function (response) {
	      obx.courseOfferings = response.data.results;
	      _SessionStore2.default.finishLoading('GetCourseOfferings');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get a single course offering
	  offering: {},
	  getCourseOffering: (0, _mobx.action)(function (sid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetCourseOffering');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courseOfferings/' + sid).then(function (response) {
	      obx.offering = response.data;
	      _SessionStore2.default.finishLoading('GetCourseOffering');
	
	      if (component) {
	        component.setState({
	          startDate: response.data.startDate,
	          endDate: response.data.endDate
	        });
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create course offering
	  createCourseOffering: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateCourseOffering');
	
	    var data = obx.offering;
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/courseOfferings', data).then(function (response) {
	      obx.offering = response.data;
	
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('CreateCourseOffering');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update course offering data
	  updateOfferingData: (0, _mobx.action)(function (data) {
	    var newData = null;
	
	    for (var key in data) {
	      if (key) {
	        newData = data[key];
	        obx.offering[key] = newData;
	      }
	    }
	  }),
	  // Update course offering
	  updateCourseOffering: (0, _mobx.action)(function (sid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateCourseOffering');
	
	    var data = obx.offering;
	
	    for (var prop in data) {
	      if (prop !== 'title' && prop !== 'matchStrings' && prop !== 'startDate' && prop !== 'endDate') {
	        delete data[prop];
	      }
	    }
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/courseOfferings/' + sid, data).then(function (response) {
	      obx.offering = response.data;
	
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('UpdateCourseOffering');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete course offering
	  deleteCourseOffering: (0, _mobx.action)(function (sid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteCourseOffering');
	
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/courseOfferings/' + sid).then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteCourseOffering');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  checkLastCourseSync: (0, _mobx.action)(function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(syncInitTime) {
	      var _this = this;
	
	      var attempt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var callback = arguments[2];
	      var response, courseSynced;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (_SessionStore2.default.loadingCalls.indexOf('scheduleSyncCheck') === -1) {
	                _SessionStore2.default.startLoading('Loading...', 'scheduleSyncCheck');
	              }
	
	              if (!(attempt >= 24)) {
	                _context2.next = 5;
	                break;
	              }
	
	              _SessionStore2.default.finishLoading('scheduleSyncCheck', true);
	              if (callback) {
	                callback();
	              }
	              return _context2.abrupt('return');
	
	            case 5:
	              _context2.prev = 5;
	              _context2.next = 8;
	              return _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid);
	
	            case 8:
	              response = _context2.sent;
	
	              if (!(response.data.synchronization.enrollment && syncInitTime)) {
	                _context2.next = 18;
	                break;
	              }
	
	              courseSynced = (0, _moment2.default)(response.data.synchronization.enrollment.lastRun).isSameOrAfter((0, _moment2.default)(syncInitTime));
	
	              if (courseSynced) {
	                _context2.next = 16;
	                break;
	              }
	
	              setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        _context.next = 2;
	                        return obx.checkLastCourseSync(syncInitTime, ++attempt, callback);
	
	                      case 2:
	                        return _context.abrupt('return', _context.sent);
	
	                      case 3:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this);
	              })), 5000);
	              return _context2.abrupt('return');
	
	            case 16:
	              _SessionStore2.default.finishLoading('scheduleSyncCheck');
	              if (callback) {
	                callback();
	              }
	
	            case 18:
	              _context2.next = 23;
	              break;
	
	            case 20:
	              _context2.prev = 20;
	              _context2.t0 = _context2['catch'](5);
	
	              _SessionStore2.default.throwError(_context2.t0);
	
	            case 23:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this, [[5, 20]]);
	    }));
	
	    return function (_x2) {
	      return _ref.apply(this, arguments);
	    };
	  }())
	});
	
	exports.default = obx;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _helpers = __webpack_require__(5);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Helpers
	var obx = (0, _mobx.observable)({
	  filterParams: {
	    fname: "",
	    lname: ""
	  },
	  rosterTotal: null,
	  courseRoster: [],
	  rosterNext: null,
	  examSession: {},
	  // Get roster
	  getCourseRoster: (0, _mobx.action)(function (query, installSid, courseSid, backgroundLoad) {
	    if (!backgroundLoad) {
	      obx.courseRoster = [];
	      _SessionStore2.default.startLoading('Loading…', 'getCourseRoster');
	    } else {
	      _SessionStore2.default.startBackgroundLoading('getCourseRoster');
	    }
	
	    if (typeof installSid === 'undefined' || !installSid) {
	      installSid = _SessionStore2.default.userData.installSid;
	    }
	
	    if (typeof courseSid === 'undefined' || !courseSid) {
	      courseSid = _SessionStore2.default.userData.courseSid;
	    }
	
	    if (!query) {
	      query = '';
	    }
	
	    _config.api.get('/installs/' + installSid + '/courses/' + courseSid + '/enrollments' + query).then(function (response) {
	      obx.courseRoster = response.data.results;
	
	      // Set pagination next url
	      if (response.data.next) {
	        // API returns a url with a different domain for the next link
	        // so create an anchor element and set its href to the next link
	        // and then grab the pathname and query from that
	        var nextUrl = (0, _helpers.getPath)(response.data.next);
	        nextUrl = nextUrl.replace('/v1', '');
	        obx.rosterNext = nextUrl;
	      } else {
	        obx.rosterNext = null;
	      }
	
	      //we want the total to be the actual total of students enrolled so when we get the initial get request we want to keep that number the same
	      if (response.data.total) {
	        obx.rosterTotal = response.data.total;
	      } else {
	        obx.rosterTotal = 0;
	      }
	
	      if (!backgroundLoad) {
	        _SessionStore2.default.finishLoading('getCourseRoster');
	      } else {
	        _SessionStore2.default.finishBackgroundLoading('getCourseRoster');
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Assign a proctor
	  // assignProctor: action(function (examSid, enrollmentSid, data, func) {
	  //   SessionStore.startLoading('Loading…', 'AssignProctor');
	  //   let { userData } = SessionStore;
	  //
	  //   api.put(`/installs/${userData.installSid}/courses/${userData.courseSid}/exams/${examSid}/enrollments/${enrollmentSid}/assignProctor`, data)
	  //     .then(response => {
	  //       SessionStore.finishLoading('AssignProctor');
	  //       func();
	  //     })
	  //     .catch(error => {
	  //       SessionStore.throwError(error);
	  //     });
	  // }),
	  // Get session data
	  getExamSession: (0, _mobx.action)(function (examSid, sessionSid, component, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'GetExamSessionData');
	    var installSid = _SessionStore2.default.userData.installSid;
	
	
	    obx.examSession = {};
	
	    _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid).then(function (response) {
	      obx.examSession = response.data;
	      _SessionStore2.default.finishLoading('GetExamSessionData');
	
	      var proctorData = response.data.proctor;
	      var location = response.data.location;
	
	      if (proctorData) {
	        proctorData.appointmentDateTime = response.data.appointmentDate;
	        proctorData.company = response.data.location.accountName;
	        obx.examSession.proctor.company = proctorData.company;
	      }
	
	      if (callback) {
	        callback();
	      }
	
	      if (location && proctorData) {
	        Object.keys(location).forEach(function (prop) {
	          if (prop !== 'latitude' && prop !== 'longitude') {
	            proctorData[prop] = location[prop];
	          } else if (prop === 'latitude') {
	            proctorData.locationLatitude = location[prop];
	          } else if (prop === 'longitude') {
	            proctorData.locationLongitude = location[prop];
	          }
	        });
	      }
	
	      if (component) {
	        component.setState({
	          proctorData: proctorData
	        });
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get admin users
	  adminUsers: [],
	  getAdminUsers: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetAdminUsers');
	
	    obx.adminUsers = [];
	    obx.admin = {};
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/users?admin=true').then(function (response) {
	      obx.adminUsers = response.data.results;
	      _SessionStore2.default.finishLoading('GetAdminUsers');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get installation users
	  installUsers: [],
	  usersNext: null,
	  getUsers: (0, _mobx.action)(function (filters) {
	    _SessionStore2.default.startLoading('Loading…', 'GetUsers');
	
	    var query = '?limit=50&sortKeys=lastName';
	
	    if (filters) {
	      for (var key in filters) {
	        if (filters[key]) {
	          query += '&' + key + '=' + filters[key];
	        }
	      }
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/users' + query).then(function (response) {
	      obx.installUsers = response.data.results;
	
	      // Set pagination next url
	      if (response.data.next) {
	        // API returns a url with a different domain for the next link
	        // so create an anchor element and set its href to the next link
	        // and then grab the pathname and query from that
	        var nextUrl = (0, _helpers.getPath)(response.data.next);
	        nextUrl = nextUrl.replace('/v1', '');
	        obx.usersNext = nextUrl;
	      } else {
	        obx.usersNext = null;
	      }
	
	      _SessionStore2.default.finishLoading('GetUsers');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get individual user
	  user: null,
	  getUser: (0, _mobx.action)(function (userSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetUser');
	
	    obx.user = null;
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + userSid + '/profile').then(function (response) {
	      obx.user = response.data;
	      _SessionStore2.default.finishLoading('GetUser');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get install enrollments
	  installEnrollments: [],
	  getInstallEnrollments: (0, _mobx.action)(function (query) {
	    _SessionStore2.default.startLoading('Loading…', 'GetInstallEnrollments');
	
	    obx.installEnrollments = [];
	
	    if (!query) {
	      query = '';
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/enrollments' + query).then(function (response) {
	      obx.installEnrollments = response.data.results;
	      _SessionStore2.default.finishLoading('GetInstallEnrollments');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get user enrollments
	  userEnrollments: [],
	  getUserEnrollments: (0, _mobx.action)(function (userSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'GetUserEnrollments');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/enrollments?userSid=' + userSid).then(function (response) {
	      obx.userEnrollments[userSid] = response.data.results;
	
	      if (callback) {
	        callback();
	      }
	
	      // Get exam configurations for each enrollment
	      response.data.results.forEach(function (enrollment) {
	        obx.getEnrollmentConfigurations(userSid, enrollment.enrollmentSid);
	      });
	
	      _SessionStore2.default.finishLoading('GetUserEnrollments');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get exam configurations for enrollment
	  getEnrollmentConfigurations: (0, _mobx.action)(function (userSid, enrollmentSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetEnrollmentConfigurations');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/examConfigurations?enrollmentSid=' + enrollmentSid).then(function (response) {
	      var examConfiguration = {};
	
	      // Only use configurations that don’t apply to an exam
	      response.data.results.forEach(function (configuration) {
	        if (!configuration.examSid) {
	          examConfiguration = configuration;
	        }
	      });
	
	      // Set the configurations for the given enrollment
	      obx.userEnrollments[userSid].filter(function (enrollment) {
	        if (enrollment.enrollmentSid === enrollmentSid) {
	          enrollment.examConfiguration = examConfiguration;
	        }
	
	        return true;
	      });
	
	      _SessionStore2.default.finishLoading('GetEnrollmentConfigurations');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update enrollment configuration data
	  enrollmentConfiguration: {
	    requiredSoftware: '',
	    studentNotes: '',
	    proctorNotes: '',
	    proctorTypes: [],
	    permittedBathroomBreak: false,
	    permittedBathroomBreakInformation: '',
	    permittedBlankPaper: false,
	    permittedBlankPaperInformation: '',
	    permittedCalculator: false,
	    permittedCalculatorInformation: '',
	    permittedDictionary: false,
	    permittedDictionaryInformation: '',
	    permittedEarplugs: false,
	    permittedEarplugsInformation: '',
	    permittedFormulaSheet: false,
	    permittedFormulaSheetInformation: '',
	    permittedNotes: false,
	    permittedNotesInformation: '',
	    permittedOtherItems: '',
	    permittedTextbook: false,
	    permittedTextbookInformation: '',
	    permittedWebsites: false,
	    permittedWebsitesInformation: '',
	    instructorAsProctor: []
	  },
	  updateConfigurationData: (0, _mobx.action)(function (data, func) {
	    var newData = null;
	
	    for (var key in data) {
	      if (key) {
	        newData = data[key];
	        obx.enrollmentConfiguration[key] = newData;
	      }
	    }
	  }),
	  // Create exam configuration for enrollment
	  createEnrollmentConfiguration: (0, _mobx.action)(function (userSid, enrollmentSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateEnrollmentConfiguration');
	
	    var data = obx.enrollmentConfiguration;
	
	    data.userSid = userSid;
	    data.enrollmentSid = enrollmentSid;
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/examConfigurations', data).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateEnrollmentConfiguration');
	
	      // Get updated configurations for the enrollment
	      obx.getEnrollmentConfigurations(userSid, enrollmentSid);
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update exam configuration for enrollment
	  updateEnrollmentConfiguration: (0, _mobx.action)(function (userSid, enrollmentSid, configurationSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateEnrollmentConfiguration');
	
	    var data = obx.enrollmentConfiguration;
	
	    data.userSid = userSid;
	    data.enrollmentSid = enrollmentSid;
	    data.instructorAsProctor = [];
	
	    delete data.examOpenDate;
	    delete data.examCloseDate;
	    delete data.scheduleOpenDate;
	    delete data.scheduleCloseDate;
	    delete data.password;
	    delete data.duration;
	    delete data.examSid;
	    delete data.sid;
	    delete data.attemptsRemaining;
	    delete data.locked;
	    delete data.approved;
	    delete data.approvedBy;
	    delete data.createdDate;
	    delete data.editDate;
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/examConfigurations/' + configurationSid, data).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateEnrollmentConfiguration');
	
	      // Get updated configurations for the enrollment
	      obx.getEnrollmentConfigurations(userSid, enrollmentSid);
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete exam configuration for enrollment
	  deleteEnrollmentConfiguration: (0, _mobx.action)(function (userSid, enrollmentSid, configurationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteEnrollmentConfiguration');
	
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/examConfigurations/' + configurationSid + '?enrollmentSid=' + enrollmentSid).then(function (response) {
	      // Get updated configurations for the enrollment
	      obx.getEnrollmentConfigurations(userSid, enrollmentSid);
	      _SessionStore2.default.finishLoading('DeleteEnrollmentConfiguration');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get individual admin user
	  admin: {},
	  getAdminUser: (0, _mobx.action)(function (userSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetAdminUser');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + userSid + '/profile').then(function (response) {
	      obx.admin = response.data;
	      _SessionStore2.default.finishLoading('GetAdminUser');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete admin user
	  deleteAdminUser: (0, _mobx.action)(function (userSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteAdminUser');
	
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + userSid).then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteAdminUser');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update admin data
	  updateAdminData: (0, _mobx.action)(function (data) {
	    var newData = null;
	
	    for (var key in data) {
	      if (key) {
	        newData = data[key];
	        obx.admin[key] = newData;
	      }
	    }
	  }),
	  // Update user API call
	  updateAdmin: (0, _mobx.action)(function (userSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateAdmin');
	
	    var data = obx.admin;
	
	    for (var prop in data) {
	      if (prop !== 'firstName' && prop !== 'lastName' && prop !== 'email' && prop !== 'homePhone' && prop !== 'mobilePhone' && prop !== 'currencyCode' && prop !== 'timeZoneSid' && prop !== 'username' && prop !== 'password' && prop !== 'enabled') {
	        delete data[prop];
	      }
	    }
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + userSid, data).then(function (response) {
	      obx.admin = response.data;
	
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('UpdateAdmin');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create admin user
	  createAdmin: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateAdmin');
	
	    var data = obx.admin;
	
	    data.enabled = true;
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/users', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('CreateAdmin');
	
	      obx.getAdminUsers();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var obx = (0, _mobx.observable)({
	  fundingRules: [],
	  fundingRuleData: {},
	  resetFundingRule: (0, _mobx.action)(function () {
	    obx.fundingRuleData = {};
	  }),
	  // Get all funding rules
	  getFundingRules: (0, _mobx.action)(function (onlyInstitution) {
	    _SessionStore2.default.startLoading('Loading…', 'FundingRules');
	    obx.resetFundingRule();
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/fundingRules').then(function (response) {
	      if (onlyInstitution) {
	        // Only show rules that are institution-wide
	        var filteredFundingRules = [];
	
	        response.data.results.forEach(function (rule) {
	          if (!rule.courseSid && !rule.examSid && !rule.enrollmentSid && !rule.userSid && !rule.courseOfferingSid) {
	            filteredFundingRules.push(rule);
	          }
	        });
	
	        obx.fundingRules = filteredFundingRules;
	      } else {
	        // Otherwise show everything
	        obx.fundingRules = response.data.results;
	      }
	
	      _SessionStore2.default.finishLoading('FundingRules');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get filtered funding rules (i.e. filter by course, exam, enrollment)
	  getFilteredFundingRules: (0, _mobx.action)(function (scope, sid) {
	    obx.resetFundingRule();
	
	    _SessionStore2.default.startLoading('Loading…', 'FundingRules');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/fundingRules?' + scope + '=' + sid).then(function (response) {
	      obx.fundingRules = response.data.results;
	      _SessionStore2.default.finishLoading('FundingRules');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get a single funding rule
	  getFundingRule: (0, _mobx.action)(function (sid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'FundingRule');
	    obx.resetFundingRule();
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/fundingRules/' + sid).then(function (response) {
	      obx.fundingRuleData = response.data;
	      _SessionStore2.default.finishLoading('FundingRule');
	
	      // Update the component state
	      component.setState({
	        fundingRuleData: response.data,
	        startDate: (0, _moment2.default)(response.data.effectiveDate),
	        endDate: (0, _moment2.default)(response.data.expirationDate)
	      });
	
	      // Make sure dates are formatted correctly
	      var fundingRuleData = Object.assign({}, component.state.fundingRuleData);
	      fundingRuleData.effectiveDate = _moment2.default.utc(response.data.effectiveDate).local().format('YYYY/MM/DD');
	      fundingRuleData.expirationDate = _moment2.default.utc(response.data.expirationDate).local().format('YYYY/MM/DD');
	
	      component.setState({
	        fundingRuleData: fundingRuleData
	      });
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  createFundingRule: (0, _mobx.action)(function (data, func) {
	    _SessionStore2.default.startLoading('Loading…', 'AddFundingRules');
	    // Remove empty SIDs
	    if (!data.courseSid.length) {
	      delete data.courseSid;
	    }
	
	    if (!data.examSid.length) {
	      delete data.examSid;
	    }
	
	    if (!data.enrollmentSid.length) {
	      delete data.enrollmentSid;
	    }
	
	    if (!data.userSid.length) {
	      delete data.userSid;
	    }
	
	    if (!data.courseOfferingSid.length) {
	      delete data.courseOfferingSid;
	    }
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/fundingRules', data).then(function (response) {
	      _SessionStore2.default.finishLoading('AddFundingRule');
	
	      // Run the callback (close drawer)
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  updateFundingRule: (0, _mobx.action)(function (sid, data, func) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateFundingRules');
	    // Remove empty sid properties
	    if (!data.courseOfferingSid) {
	      delete data.courseOfferingSid;
	    }
	    if (!data.courseSid) {
	      delete data.courseSid;
	    }
	    if (!data.examSid) {
	      delete data.examSid;
	    }
	    if (!data.enrollmentSid) {
	      delete data.enrollmentSid;
	    }
	    if (!data.userSid) {
	      delete data.userSid;
	    }
	
	    if (!data.description) {
	      data.description = '';
	    }
	
	    // Remove unnecessary properties
	    delete data.sid;
	    delete data.applicationInstallSid;
	    delete data.createdDate;
	    delete data.lastModifiedDate;
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/fundingRules/' + sid, data).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateFundingRules');
	      // Run the callback (close drawer)
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  deleteFundingRule: (0, _mobx.action)(function (sid, func) {
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/fundingRules/' + sid).then(function (response) {
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Dependencies
	exports.default = obx;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _axios = __webpack_require__(211);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  feature: null,
	  help: null,
	  helpLoaded: false,
	  getHelp: (0, _mobx.action)(function () {
	    if (!obx.helpLoaded) {
	      var timestamp = new Date().getTime();
	
	      _axios2.default.get('https://raw.githubusercontent.com/SmarterServices/smarterproctoring-docs/master/docs.json?t=' + timestamp).then(function (response) {
	        obx.help = response.data;
	        obx.helpLoaded = true;
	      });
	    }
	  })
	});
	
	exports.default = obx;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _mobx2 = _interopRequireDefault(_mobx);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _ProctorStore = __webpack_require__(151);
	
	var _ProctorStore2 = _interopRequireDefault(_ProctorStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var obx = (0, _mobx.observable)({
	  locations: [],
	  locationSid: null,
	  locationData: {
	    name: null,
	    address1: null,
	    address2: null,
	    place: null,
	    region: null,
	    country: null,
	    postalCode: null,
	    locationLatitude: 0,
	    locationLongitude: 0,
	    notes: null,
	    smokeFree: false,
	    parkingInformation: null,
	    hasComputerAvailable: false,
	    hasPrinterAvailable: false,
	    hasCopierAvailable: false,
	    hasFaxAvailable: false,
	    hasElevator: false,
	    hasWheelchairRamp: false,
	    hasAlternativeKeyboards: false,
	    hasScreenEnlarger: false,
	    hasScreenReader: false,
	    hasSpeechRecognition: false,
	    hasTextToSpeech: false,
	    hasDistractionFreeRooms: false,
	    timeZoneSid: 'TZ356c0b38525c4d94a1b60e76ded97066',
	    currencyCode: 'USD',
	    proctorLocationTypeSid: 'LT5e18eda572134379939dd2ef766ebf43'
	  },
	  locationAvailability: [],
	  locationAvailabilityData: {
	    accountSid: null,
	    lateSchedulingLeadTime: 0,
	    enabled: true
	  },
	  locationTypesList: [],
	  getLocationTypes: (0, _mobx.action)(function () {
	    _config.api.get('/proctors/locations/types').then(function (response) {
	      obx.locationTypesList = response.data.results;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  renderMap: true,
	  getLocations: (0, _mobx.action)(function (proctorSid) {
	    _SessionStore2.default.startLoading('Loading…', 'Locations');
	
	    var sid = _ProctorStore2.default.proctorSid;
	
	    if (proctorSid) {
	      sid = proctorSid;
	    }
	
	    _config.api.get('/proctors/' + sid + '/locations').then(function (response) {
	      _SessionStore2.default.finishLoading('Locations');
	      obx.locations = response.data.results;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  updateLocationData: (0, _mobx.action)(function (data) {
	    if (data.preventRender) {
	      obx.renderMap = false;
	    } else {
	      obx.resetLocation();
	    }
	
	    for (var key in data) {
	      if (data[key]) {
	        var newData = data[key];
	        obx.locationData[key] = newData;
	      }
	    }
	
	    // sessionStorage.setItem('registerData', JSON.stringify(obx.registerData));
	  }),
	  cleanData: (0, _mobx.action)(function () {
	    delete obx.locationData.sid;
	    delete obx.locationData.proctorSid;
	    delete obx.locationData.createdDate;
	    delete obx.locationData.lastModifiedDate;
	    delete obx.locationData.preventRender;
	    delete obx.locationData.schedulingModule;
	    delete obx.locationData.distance;
	  }),
	  getLocation: (0, _mobx.action)(function (locationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'Location');
	    obx.resetLocation();
	    obx.locationSid = locationSid;
	    obx.renderMap = false;
	
	    _config.api.get('/proctors/' + _ProctorStore2.default.proctorSid + '/locations/' + locationSid).then(function (response) {
	      _SessionStore2.default.finishLoading('Location');
	      obx.renderMap = false;
	      obx.locationData = response.data;
	
	      // Tell map to render after data is received
	      obx.renderMap = true;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  createLocation: (0, _mobx.action)(function (func, component) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateLocation');
	
	    obx.cleanData();
	
	    _config.api.post('/proctors/' + _ProctorStore2.default.proctorSid + '/locations', obx.locationData).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateLocation');
	      obx.locationSid = response.data.sid;
	      component.state.locationSid = obx.locationSid;
	      obx.getLocationAvailability(component);
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  updateLocation: (0, _mobx.action)(function (func, locationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateLocation');
	
	    obx.cleanData();
	
	    _config.api.put('/proctors/' + _ProctorStore2.default.proctorSid + '/locations/' + locationSid, obx.locationData).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateLocation');
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  resetLocation: (0, _mobx.action)(function () {
	    obx.locationData.name = null;
	    obx.locationData.address1 = null;
	    obx.locationData.address2 = null;
	    obx.locationData.place = null;
	    obx.locationData.region = null;
	    obx.locationData.country = null;
	    obx.locationData.postalCode = null;
	    obx.locationData.locationLatitude = 0;
	    obx.locationData.locationLongitude = 0;
	    obx.locationData.notes = null;
	    obx.locationData.smokeFree = false;
	    obx.locationData.parkingInformation = null;
	    obx.locationData.hasComputerAvailable = false;
	    obx.locationData.hasPrinterAvailable = false;
	    obx.locationData.hasCopierAvailable = false;
	    obx.locationData.hasFaxAvailable = false;
	    obx.locationData.hasElevator = false;
	    obx.locationData.hasWheelchairRamp = false;
	    obx.locationData.hasAlternativeKeyboards = false;
	    obx.locationData.hasScreenEnlarger = false;
	    obx.locationData.hasScreenReader = false;
	    obx.locationData.hasSpeechRecognition = false;
	    obx.locationData.hasTextToSpeech = false;
	    obx.locationData.hasDistractionFreeRooms = false;
	    obx.locationData.timeZoneSid = 'TZ356c0b38525c4d94a1b60e76ded97066';
	    obx.locationData.currencyCode = 'USD';
	    obx.locationData.proctorLocationTypeSid = 'LT5e18eda572134379939dd2ef766ebf43';
	  }),
	  deleteLocation: (0, _mobx.action)(function (locationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteLocation');
	
	    _config.api.delete('/proctors/' + _ProctorStore2.default.proctorSid + '/locations/' + locationSid, obx.locationData).then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteLocation');
	      obx.getLocations();
	    }).catch(function (error) {
	      console.log(error);
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  getLocationAvailability: (0, _mobx.action)(function (component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetLocationAvailability');
	
	    _config.api.get('/proctors/' + _ProctorStore2.default.proctorSid + '/location/' + obx.locationSid + '/availability').then(function (response) {
	      _SessionStore2.default.finishLoading('GetLocationAvailability');
	      obx.locationAvailability = response.data.results;
	      obx.locationAvailability.forEach(function (element) {
	        // Set the default price model
	        if (element.fees.length < 2 && element.fees[0].maximumSessionLength === 480) {
	          element.priceModel = 'flat';
	        } else {
	          element.priceModel = 'tiered';
	        }
	
	        // Set the default currencies
	        element.currencies = [];
	
	        Object.keys(element.fees[0].amounts).map(function (key) {
	          return element.currencies.push(key);
	        });
	
	        // If session lengths are null, it’s a new location and we need to
	        // set some defaults
	        if (element.fees[0].minimumSessionLength === null) {
	          element.fees[0].minimumSessionLength = 0;
	          element.fees[0].maximumSessionLength = 480;
	          element.fees[0].amounts = {
	            USD: {
	              service: 0,
	              late: 0
	            }
	          };
	          element.currencies = ['USD'];
	        }
	
	        // Set array of session lengths
	        element.sessionLength = [];
	        element.fees.forEach(function (sessionTime) {
	          element.sessionLength.push(sessionTime.minimumSessionLength);
	        });
	        element.sessionLength.push(element.fees[element.fees.length - 1].maximumSessionLength);
	      });
	
	      component.setState({
	        priceGroups: _mobx2.default.toJS(obx.locationAvailability)
	      });
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  createLocationAvailability: (0, _mobx.action)(function (sid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateLocationAvailability');
	    obx.locationAvailabilityData.accountSid = sid;
	
	    _config.api.post('/proctors/' + _ProctorStore2.default.proctorSid + '/location/' + obx.locationSid + '/availability', obx.locationAvailabilityData).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateLocationAvailability');
	
	      // Set up new availability object
	      obx.locationAvailability = component.state.priceGroups;
	      var newAvailability = Object.assign({}, obx.locationAvailability[0]);
	      newAvailability.sid = response.data.sid;
	      newAvailability.account = {};
	      newAvailability.account.sid = response.data.account.sid;
	      newAvailability.account.name = response.data.account.name;
	      newAvailability.fees = [_mobx2.default.toJS(newAvailability.fees[0])];
	      newAvailability.fees[0].minimumSessionLength = 0;
	      newAvailability.fees[0].maximumSessionLength = 480;
	      newAvailability.sessionLength = [0, 480];
	      newAvailability.lateSchedulingLeadTime = 0;
	      obx.locationAvailability.push(newAvailability);
	
	      component.setState({
	        priceGroups: _mobx2.default.toJS(obx.locationAvailability)
	      });
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  removeLocationAvailability: (0, _mobx.action)(function (sid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteLocationAvailability');
	
	    _config.api.delete('/proctors/' + _ProctorStore2.default.proctorSid + '/location/' + obx.locationSid + '/availability/' + sid).then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteLocationAvailability');
	      obx.getLocationAvailability(component);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  toggleLocationAvailability: (0, _mobx.action)(function (i) {
	    obx.locationAvailability[i].enabled = !obx.locationAvailability[i].enabled;
	    obx.updateLocationAvailability(i);
	  }),
	  setPriceGroupModel: (0, _mobx.action)(function (i, value) {
	    obx.locationAvailability[i].priceModel = value;
	  }),
	  updateAvailabilityLead: (0, _mobx.action)(function (i, data) {
	    obx.locationAvailability[i].lateSchedulingLeadTime = data;
	
	    for (var key in data) {
	      if (data[key]) {
	        var newData = data[key];
	        obx.locationAvailability[i][key] = newData;
	      }
	    }
	
	    obx.updateLocationAvailability(i);
	  }),
	  updateLocationAvailability: (0, _mobx.action)(function (i) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateLocationAvailability');
	
	    var payload = {};
	
	    if (obx.locationAvailability[i].account) {
	      payload.accountSid = obx.locationAvailability[i].account.sid;
	    } else {
	      payload.accountSid = null;
	    }
	    payload.lateSchedulingLeadTime = obx.locationAvailability[i].lateSchedulingLeadTime;
	    payload.enabled = obx.locationAvailability[i].enabled;
	
	    _config.api.put('/proctors/' + _ProctorStore2.default.proctorSid + '/location/' + obx.locationSid + '/availability/' + obx.locationAvailability[i].sid, payload).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateLocationAvailability');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  updateFeeData: (0, _mobx.action)(function (value, availabilityIndex, feeIndex, currency, fieldType) {
	    obx.locationAvailability[availabilityIndex].fees[feeIndex].amounts[currency][fieldType] = parseInt(value, 10);
	  }),
	  updateFees: (0, _mobx.action)(function (availabilityGroups, func) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateFees');
	
	    var _loop = function _loop(i) {
	      // API expects different property names than what the get API provides
	      availabilityGroups[i].fees.forEach(function (element) {
	
	        if (element.hasOwnProperty('minimumSessionLength')) {
	          element.minimumLength = element.minimumSessionLength;
	          element.maximumLength = element.maximumSessionLength;
	          delete element.minimumSessionLength;
	          delete element.maximumSessionLength;
	        }
	      });
	
	      _config.api.put('/proctors/' + _ProctorStore2.default.proctorSid + '/locations/' + obx.locationSid + '/availability/' + obx.locationAvailability[i].sid + '/fees', availabilityGroups[i].fees).then(function (response) {
	        _SessionStore2.default.finishLoading('UpdateFees');
	        if (i + 1 === obx.locationAvailability.length) {
	          func();
	        }
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    };
	
	    for (var i = 0; i < availabilityGroups.length; i++) {
	      _loop(i);
	    }
	  }),
	  // Get self managed location sid
	  getSelfManagedAccountLocation: (0, _mobx.action)(function (proctorSid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetSelfManagedLocation');
	
	    _config.api.get('/proctors/' + proctorSid + '/locations').then(function (response) {
	      // Make sure result array has location
	      if (response.data.results.length) {
	        // Self managed proctor has only one location, so take the first element
	        component.setState({
	          locationSid: response.data.results[0].sid
	        });
	      }
	
	      _SessionStore2.default.finishLoading('GetSelfManagedLocation');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	exports.default = obx;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _ExamStore = __webpack_require__(223);
	
	var _ExamStore2 = _interopRequireDefault(_ExamStore);
	
	var _ProctorStore = __webpack_require__(151);
	
	var _ProctorStore2 = _interopRequireDefault(_ProctorStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  threads: [],
	  // Get all message threads
	  getThreads: (0, _mobx.action)(function (backgroundLoad) {
	    if (backgroundLoad) {
	      _SessionStore2.default.startBackgroundLoading('GetThreads');
	    } else {
	      _SessionStore2.default.startLoading('Loading…', 'GetThreads');
	    }
	
	    _config.api.get('/messages?userSid=' + _SessionStore2.default.userData.userSid + '&courseSid=' + _SessionStore2.default.courseData.sid).then(function (response) {
	      obx.threads = response.data.results;
	
	      if (backgroundLoad) {
	        _SessionStore2.default.finishBackgroundLoading('GetThreads');
	      } else {
	        _SessionStore2.default.finishLoading('GetThreads');
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get thread ID
	  activeThread: {},
	  getThreadId: (0, _mobx.action)(function (toUserSid, contextType, contextId, toProctor, component, preventReload, proctorLocationSid) {
	    obx.activeThread = {};
	    obx.threadObject = {};
	
	    _config.api.get('/messages?userSid=' + _SessionStore2.default.userData.userSid).then(function (response) {
	      var threadId = null;
	
	      // Filter the result by recipient, context type (e.g. examSid), and context id
	      var existingThread = response.data.results.filter(function (thread) {
	        if (toProctor) {
	          if (thread.proctorAccountLocation) {
	            return thread.proctorAccountUserSid === toUserSid && thread.proctorAccountLocation.sid === proctorLocationSid && thread[contextType] === contextId;
	          } else {
	            return thread.proctorAccountUserSid === toUserSid && thread[contextType] === contextId;
	          }
	        } else {
	          if (contextType === 'courseSid') {
	            return thread.courseSid === contextId && thread.examConfiguration === null && thread.examSessionEventReportSid === null && thread.examSid === null && thread.proctorApproval === null && thread.userSid === toUserSid;
	          } else {
	            return thread[contextType] === contextId && thread.userSid === toUserSid;
	          }
	        }
	      });
	
	      if (existingThread.length > 0) {
	        threadId = existingThread[0].sid;
	        obx.activeThread = existingThread[0];
	      }
	
	      if (threadId) {
	        // Get the actual thread
	        obx.getThread(threadId, component, preventReload);
	      } else {
	        // Otherwise if no thread matches, reset the thread message array
	        obx.threadMessages = [];
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get an individual thread
	  threadMessages: [],
	  threadObject: {},
	  getThread: (0, _mobx.action)(function (sid, component, preventReload) {
	    obx.activeThread = {};
	    obx.threadObject = {};
	    obx.threadMessages = [];
	
	    _SessionStore2.default.startBackgroundLoading('GetThread');
	
	    _config.api.get('/messages/' + sid + '?includeItems=true').then(function (response) {
	      obx.threadMessages = response.data.items;
	      obx.threadObject = response.data;
	
	      // If there’s a configuration sid, get that data
	      if (response.data.examConfigurationSid) {
	        _ExamStore2.default.getConfigurationData(response.data.examSid, response.data.examConfigurationSid);
	      }
	
	      // If there’s an exam sid, get that data
	      if (response.data.examSid && !preventReload) {
	        _ExamStore2.default.getExam(response.data.examSid);
	      }
	
	      // If there’s a component, give it the messageSid
	      if (component) {
	        component.setState({
	          messageSid: response.data.sid
	        });
	      }
	
	      // If there’s a proctor location, get the proctor data
	      if (response.data.proctorAccountLocation) {
	        _ProctorStore2.default.getProctor(response.data.proctorAccountLocation.proctorSid, component);
	      }
	
	      _SessionStore2.default.finishBackgroundLoading('GetThread');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	
	    // Mark the thread as read
	    var readUser = {
	      userSid: _SessionStore2.default.userData.userSid
	    };
	
	    _config.api.put('/messages/' + sid + '/read', readUser).then(function (response) {
	      _SessionStore2.default.getUnreadCount();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create a thread
	  createThread: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startBackgroundLoading('CreateThread');
	
	    _config.api.post('/messages', data).then(function (response) {
	      _SessionStore2.default.finishBackgroundLoading('CreateThread');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Reply to a thread
	  newDates: {},
	  replyToThread: (0, _mobx.action)(function (sid, data) {
	    _SessionStore2.default.startBackgroundLoading('ReplyToThread');
	
	    obx.newDates = {};
	
	    if (data.dateOption1) {
	      obx.newDates.dateOption1 = data.dateOption1;
	      delete data.dateOption1;
	    }
	
	    if (data.dateOption2) {
	      obx.newDates.dateOption2 = data.dateOption2;
	      delete data.dateOption2;
	    }
	
	    if (data.dateOption3) {
	      obx.newDates.dateOption3 = data.dateOption3;
	      delete data.dateOption3;
	    }
	
	    _config.api.post('/messages/' + sid + '/items', data).then(function (response) {
	      _SessionStore2.default.finishBackgroundLoading('ReplyToThread');
	
	      if (Object.keys(obx.newDates).length > 0 && (obx.newDates.dateOption1 !== obx.threadObject.dateOption1 || obx.newDates.dateOption2 !== obx.threadObject.dateOption2 || obx.newDates.dateOption3 !== obx.threadObject.dateOption3)) {
	        obx.updateDates(sid, response.data.messageThreadSid);
	      } else {
	        obx.getThread(response.data.messageThreadSid);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update requested session dates
	  updateDates: (0, _mobx.action)(function (sid, threadSid) {
	    _SessionStore2.default.startBackgroundLoading('UpdateThreadDates');
	
	    _config.api.put('/messages/' + sid + '/dates', obx.newDates).then(function (response) {
	      _SessionStore2.default.finishBackgroundLoading('UpdateThreadDates');
	      obx.newDates = {};
	      obx.getThread(threadSid);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Cancel request/clear schedule dates
	  cancelRequest: (0, _mobx.action)(function (sid, datesEl) {
	    _SessionStore2.default.startBackgroundLoading('DeleteRequest');
	
	    _config.api.delete('/messages/' + sid + '/dates').then(function (response) {
	      if (datesEl) {
	        // Fade the request out
	        datesEl.className += ' fade-out';
	
	        // Then remove it after the fade
	        // IE doesn’t support remove, though
	        if (document.querySelector('html').className.indexOf('ie-true') < 0) {
	          setTimeout(function () {
	            datesEl.remove();
	          }, 250);
	        }
	
	        // Remove the requested dates from the stored thread
	        obx.getThread(sid);
	      }
	
	      _SessionStore2.default.finishBackgroundLoading('DeleteRequest');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  // START EXTENSION MESSAGES
	  // Listen for Chrome Extension messages
	  ghostRunning: false,
	  chromeExtensionMessageListener: function chromeExtensionMessageListener(event) {
	    switch (event.data.message) {
	      case 'faceProcessorStarted':
	        obx.ghostRunning = true;
	        var ghostInterval = setInterval(function () {
	          chrome.runtime.sendMessage(_SessionStore2.default.extensionInfo.extensionId, { message: 'ghostStarted_acknowledgement' }, function (response) {
	            if (response) {
	              clearInterval(ghostInterval);
	            }
	          });
	        }, 1000);
	        break;
	      default:
	        break;
	    }
	    return;
	  }
	});
	
	// Components
	/*global chrome*/
	
	
	window.addEventListener('message', obx.chromeExtensionMessageListener, false);
	
	exports.default = obx;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  registerData: {
	    accountData: {
	      accountName: null,
	      type: 'individual-proctor',
	      firstName: null,
	      lastName: null,
	      email: null,
	      username: null,
	      password: null,
	      description: null
	    }
	  },
	  getLocalStorage: (0, _mobx.action)(function (data) {
	    obx.registerData = data;
	  }),
	  updateAccountInfo: (0, _mobx.action)(function (data) {
	    for (var key in data) {
	      if (data[key]) {
	        var newData = data[key];
	        obx.registerData.accountData[key] = newData;
	        obx.registerData.accountData.username = obx.registerData.accountData.email;
	      }
	    }
	
	    if (_SessionStore2.default.hasSessionStorage) {
	      sessionStorage.setItem('registerData', JSON.stringify(obx.registerData));
	    } else {
	      document.cookie = 'userData=' + JSON.stringify(obx.registerData);
	    }
	  }),
	  createProctor: (0, _mobx.action)(function (func) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateProctor');
	
	    var data = obx.registerData.accountData;
	
	    delete data.metadata;
	
	    _config.api.post('/proctors', data).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateProctor');
	      _SessionStore2.default.login(obx.registerData.accountData.username, obx.registerData.accountData.password, func);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _index = __webpack_require__(224);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// Components
	
	
	var obx = (0, _mobx.observable)({
	  enrollment: {
	    ipAddress: '127.0.0.1' // Temporarily hard code IP because API requires it
	  },
	  links: {},
	  sids: {},
	  enrollmentSid: null,
	  // Add enrollment data
	  updateEnrollment: (0, _mobx.action)(function (value, name) {
	    if (name === 'dob') {
	      // If it’s the date of birth, we need to split it into month and day
	      var dobArr = value.split('/');
	      obx.enrollment.birthDay = parseInt(dobArr[0], 10);
	      obx.enrollment.birthMonth = parseInt(dobArr[1], 10);
	    } else {
	      // Otherwise, just add the data to the enrollment object
	      obx.enrollment[name] = value;
	    }
	  }),
	  // Create user in SmarterID
	  createSIDUser: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'CreateSIDUser');
	
	    var data = {
	      externalId: _SessionStore2.default.userData.userSid,
	      firstName: _SessionStore2.default.profile.firstName,
	      lastName: _SessionStore2.default.profile.lastName,
	      email: _SessionStore2.default.profile.email,
	      mobilePhone: _SessionStore2.default.profile.mobilePhone,
	      latitude: _SessionStore2.default.profile.latitude,
	      longitude: _SessionStore2.default.profile.longitude,
	      address: _SessionStore2.default.profile.address
	
	      // Remove empty data values because the API won’t accept them
	    };Object.keys(data).forEach(function (key, i) {
	      if (!data[key]) {
	        delete data[key];
	      }
	    });
	
	    // Send the API call
	    _config.sidApi.post('/installs/' + _SessionStore2.default.userData.smarterIdInstallSid + '/users', data).then(function (response) {
	      obx.updateSIDSid(response.data.sid);
	      _SessionStore2.default.finishLoading('CreateSIDUser');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Add SmarterID user id to profile data
	  updateSIDSid: (0, _mobx.action)(function (smarterId) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateSIDSid');
	
	    var data = Object.assign({}, _SessionStore2.default.profile);
	
	    // Remove disallowed or empty values
	    Object.keys(data).forEach(function (key, i) {
	      if (!data[key] || key !== 'address' && key !== 'currencyCode' && key !== 'homePhone' && key !== 'latitude' && key !== 'longitude' && key !== 'maxTravelDistance' && key !== 'maxTravelDistanceUnits' && key !== 'mobilePhone' && key !== 'smarterId' && key !== 'timeZoneSid') {
	        delete data[key];
	      }
	    });
	
	    data.smarterId = smarterId;
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/users/' + _SessionStore2.default.userData.userSid + '/profile', data).then(function (response) {
	      _SessionStore2.default.profile = response.data;
	      obx.checkSIDEnrollment(data.smarterId.userSid);
	      _SessionStore2.default.finishLoading('UpdateSIDSid');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Check if SmarterID enrollment exists and redirect if not
	  checkSIDEnrollment: (0, _mobx.action)(function (sid) {
	    _SessionStore2.default.startLoading('Loading…', 'CheckSIDEnrollment');
	
	    var userSid = _SessionStore2.default.profile.smarterId.userSid;
	
	    if (sid) {
	      userSid = sid;
	    }
	
	    _config.sidApi.get('/installs/' + _SessionStore2.default.userData.smarterIdInstallSid + '/users/' + userSid + '/enrollments').then(function (response) {
	      var activeEnrollment = false;
	
	      // Loop through results to see if any enrollments are active
	      for (var i = 0; i < response.data.results.length; i++) {
	        if (response.data.results[i].status.toLowerCase() === 'active') {
	          activeEnrollment = true;
	        }
	      }
	
	      if ((response.data.results.length === 0 || !activeEnrollment) && _SessionStore2.default.settings.smarterIdEnabled) {
	        _index.routingStore.push({
	          pathname: '/enroll'
	        });
	      }
	
	      _SessionStore2.default.finishLoading('CheckSIDEnrollment');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create enrollment in SmarterID
	  createSIDEnrollment: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateSIDEnrollment');
	
	    _config.sidApi.post('/installs/' + _SessionStore2.default.userData.smarterIdInstallSid + '/users/' + _SessionStore2.default.profile.smarterId.userSid + '/enrollments', obx.enrollment).then(function (response) {
	      obx.links = response.data;
	      obx.enrollmentSid = response.data.sid;
	
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('CreateSIDEnrollment');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get sids by tiny id
	  getSids: (0, _mobx.action)(function (tinyId) {
	    _SessionStore2.default.startLoading('Loading…', 'GetSids');
	
	    _config.sidApi.get('/tiny/' + tinyId).then(function (response) {
	      obx.sids = response.data;
	      _SessionStore2.default.finishLoading('GetSids');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Add images
	  uploadSIDImage: (0, _mobx.action)(function (file, type, callback, component) {
	    _SessionStore2.default.startLoading('Loading…', 'UploadSIDImage');
	
	    var formData = new FormData();
	
	    formData.append('type', type);
	
	    formData.append('image', file, obx.enrollmentSid + '-' + type + '.jpg');
	
	    _config.sidApi.put('/installs/' + _SessionStore2.default.userData.smarterIdInstallSid + '/enrollments/' + obx.enrollmentSid + '/images', formData).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('UploadSIDImage');
	    }).catch(function (error) {
	      console.error(error);
	
	      // Determine which image errored so we can alert the user of it
	      // and remove the selected image so they have to choose a new one
	      var imgDescription = null;
	      var imgName = null;
	
	      switch (type) {
	        case 'id-front':
	          imgDescription = 'front of ID';
	          imgName = 'idFront';
	          break;
	
	        case 'id-back':
	          imgDescription = 'back of ID';
	          imgName = 'idBack';
	          break;
	
	        case 'selfie':
	          imgDescription = 'headshot';
	          imgName = 'headshot';
	          break;
	
	        default:
	          imgDescription = 'photo';
	
	      }
	
	      var imgError = {
	        response: {
	          data: {
	            message: 'Sorry, there was an error uploading your ' + imgDescription + '. Please try again.'
	          }
	        }
	      };
	
	      if (component) {
	        var _component$setState;
	
	        // Remove the errored ID from the list of accepted photos
	        var acceptedPhotos = [].concat(_toConsumableArray(component.state.acceptedPhotos));
	        var index = acceptedPhotos.indexOf(imgName);
	        acceptedPhotos.splice(index, 1);
	
	        // Remove the selected photos and set the state
	        component.setState((_component$setState = {}, _defineProperty(_component$setState, imgName, null), _defineProperty(_component$setState, 'acceptedPhotos', acceptedPhotos), _component$setState));
	      }
	
	      _SessionStore2.default.throwError(imgError);
	    });
	  }),
	  // Get Images
	  getSIDPhotos: (0, _mobx.action)(function (component) {
	    _config.sidApi.get('/installs/' + _SessionStore2.default.userData.smarterIdInstallSid + '/enrollments/' + obx.enrollmentSid + '/images').then(function (response) {
	      if (component) {
	        var photoCount = 0;
	
	        if (response.data.frontPhoto) {
	          photoCount++;
	        }
	
	        if (response.data.backPhoto) {
	          photoCount++;
	        }
	
	        if (response.data.selfiePhoto) {
	          photoCount++;
	        }
	
	        component.setState({
	          photoCount: photoCount
	        });
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get Enrollment
	  getSIDEnrollment: (0, _mobx.action)(function () {
	    _config.sidApi.get('/installs/' + _SessionStore2.default.userData.smarterIdInstallSid + '/users/' + _SessionStore2.default.profile.smarterId.userSid + '/enrollments/' + obx.enrollmentSid).then(function (response) {
	      obx.enrollment = response.data;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Validate enrollment
	  validationPassed: false,
	  validationFailed: false,
	  validationError: null,
	  validateEnrollment: (0, _mobx.action)(function (callback) {
	    obx.validationFailed = false;
	    obx.validationError = null;
	
	    _config.sidApi.get('/installs/' + _SessionStore2.default.userData.smarterIdInstallSid + '/enrollments/' + obx.enrollmentSid + '/validate').then(function (response) {
	      // If confirm.io validation is still pending, wait 3 seconds then send again
	      // to trigger the facial recognition
	      if (response.data.status.toLowerCase() === 'pending') {
	        setTimeout(function () {
	          obx.validateEnrollment(callback);
	        }, 3000);
	      } else if (response.data.status.toLowerCase() === 'pass') {
	        obx.validationPassed = true;
	
	        if (callback) {
	          callback();
	        }
	      }
	    }).catch(function (error) {
	      obx.validationFailed = true;
	      obx.validationError = error.response.data.code;
	
	      if (error.response.data.code === '1213' || error.response.data.code === '1210') {
	        // confirm.io validation failed
	      } else if (error.response.data.code === '1214') {
	        // Facial match failed
	      } else {
	        _SessionStore2.default.throwError(error);
	      }
	    });
	  }),
	
	  /**
	   * authenticateUser
	   * @param {object} sids
	   * @param {object} data
	   * @param {function} errorCallback
	   */
	  authenticateUser: (0, _mobx.action)(function (sids, data, errorCallback, successCallback) {
	    _SessionStore2.default.startLoading('authenticateUser');
	
	    var installSid = sids.installSid,
	        userSid = sids.userSid;
	
	
	    var formData = new FormData();
	
	    formData.append('ipAddress', '127.0.0.1');
	    formData.append('image', data.photo);
	
	    _config.sidApi.post('/installs/' + installSid + '/users/' + userSid + '/authentication', formData).then(function () {
	      _SessionStore2.default.finishLoading('authenticateUser');
	
	      if (successCallback) {
	        successCallback();
	      }
	    }).catch(function (error) {
	      if (errorCallback) {
	        errorCallback();
	
	        _SessionStore2.default.finishLoading('authenticateUser');
	      }
	
	      if (error.response.data.code !== '1210') {
	        _SessionStore2.default.throwError(error);
	      }
	    });
	  })
	});
	
	exports.default = obx;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _uuid = __webpack_require__(1671);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _config = __webpack_require__(9);
	
	var _reactNotifyToast = __webpack_require__(573);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Dependencies
	var obx = (0, _mobx.observable)({
	  client: null,
	  localMedia: {},
	  room: null,
	  mediaSrc: [],
	  tracks: [],
	  sessionObj: {},
	  lookupSession: (0, _mobx.action)(function (input) {
	    if (input.length !== 9 && input.length !== 11) {
	      _reactNotifyToast.notify.show('Access code should be 11 characters', 'error');
	    } else if (input.length === 9) {
	      var temp = input.split('');
	      var newTemp = [];
	      temp.forEach(function (x, index) {
	        if (index === 3 || index === 6) {
	          newTemp.push('-');
	          newTemp.push(x);
	        } else {
	          newTemp.push(x);
	        }
	      });
	      var inputStr = newTemp.join('');
	      obx.joinSession(inputStr);
	    } else if (input.length === 11) {
	      obx.joinSession(input);
	    }
	  }),
	  setUpClient: (0, _mobx.action)(function (token) {
	    // obx.setUpLocalMedia();
	    obx.joinRoom(token);
	  }),
	  setUpLocalMedia: (0, _mobx.action)(function () {
	    try {
	      obx.localMedia = new window.Twilio.Video.LocalMedia();
	    } catch (e) {
	      console.error(e);
	    }
	  }),
	  sendParticipantMedia: (0, _mobx.action)(function (participant) {
	    participant.on('trackAdded', function (track) {
	      // Create an array of track data which will be used to identify elements
	      // to attach the media tracks to
	      var trackData = {
	        kind: track.kind,
	        id: track.id
	      };
	
	      obx.tracks.push(trackData);
	
	      // Wait until the elements exist and then attach the media tracks
	      setTimeout(function () {
	        var trackContainer = document.querySelector('#track-' + track.id);
	        trackContainer.appendChild(track.attach());
	      });
	    });
	  }),
	  registerTrackEvents: (0, _mobx.action)(function (room) {
	    room.on('participantConnected', function (participant) {
	      _reactNotifyToast.notify.show(participant.identity + ' connected', 'success');
	    });
	    room.on('participantDisconnected', function (participant) {
	      _reactNotifyToast.notify.show(participant.identity + ' disconnected', 'error');
	      participant.media.tracks.forEach(function (track) {
	        return obx.removeTrack(track.id);
	      });
	    });
	  }),
	  removeTrack: (0, _mobx.action)(function (id) {
	    obx.mediaSrc = obx.mediaSrc.filter(function (x) {
	      return x.id !== id;
	    });
	  }),
	  joinRoom: (0, _mobx.action)(function (token) {
	    // Create a dummy audio track to prevent the browser from asking for permission
	    // const audioContext = typeof AudioContext !== 'undefined'
	    //   ? new window.AudioContext()
	    //   : new window.webkitAudioContext()
	    // const node = audioContext.createMediaStreamDestination()
	    // const stream = node.stream
	    // const dummyTrack = stream.getAudioTracks()[0]
	    // const audioTrack = new window.Twilio.Video.LocalAudioTrack(dummyTrack);
	    //
	    // console.log(audioTrack);
	
	    window.Twilio.Video.connect(token, {
	      name: obx.sessionObj.session.sessionId,
	      tracks: []
	    }).then(function onJoin(room) {
	      room.participants.forEach(function (participant) {
	        obx.sendParticipantMedia(participant);
	      });
	
	      room.on('participantConnected', function (participant) {
	        obx.sendParticipantMedia(participant);
	      });
	
	      // obx.registerTrackEvents(room);
	    }).catch(function (error) {
	      console.error(error);
	    });
	  }),
	  joinSession: (0, _mobx.action)(function (id) {
	    var url = 'https://newapi.smarterservices.com/smarterproctoring-api/v1/sessions/' + id + '/join';
	    // const data = JSON.stringify({ user_id: uuid.v1() })
	    // const headers = { 'Content-Type': 'application/json' };
	
	    // axios.post(url, data, headers)
	
	    fetch(url, {
	      method: 'POST',
	      headers: { 'Content-Type': 'application/json' },
	      body: JSON.stringify({ user_id: _uuid2.default.v1() })
	    }).then(function (response) {
	      return response.json();
	    }).then(function (body) {
	      obx.setSessionObj(body);
	      obx.setUpClient(body.configuration.twilio.token);
	      if (body.err) {
	        _reactNotifyToast.notify.show('Error connecting to session', 'error');
	      } else {
	        _reactNotifyToast.notify.show('Connected to session', 'success');
	      }
	    }).catch(function (e) {});
	  }),
	  setSessionObj: (0, _mobx.action)(function (obj) {
	    obx.sessionObj = obj;
	  }),
	  bvData: {},
	  metadata: null,
	  getBVData: (0, _mobx.action)(function (examSid, sessionSid) {
	    _SessionStore2.default.startLoading('Loading…', 'BVData');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/meta').then(function (response) {
	      obx.bvData = response.data;
	
	      obx.metadata = response.data.metadata;
	
	      _SessionStore2.default.finishLoading('BVData');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get exam review URL
	  getReviewUrl: (0, _mobx.action)(function (examSid, sessionSid) {
	    _SessionStore2.default.startBackgroundLoading('getReviewUrl');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/review').then(function (response) {
	      obx.reviewUrl = response.data.redirectUrl;
	
	      if (obx.reviewUrl && obx.reviewUrl.indexOf('http:') >= 0) {
	        obx.reviewUrl = obx.reviewUrl.replace('http:', 'https:');
	      }
	
	      _SessionStore2.default.finishBackgroundLoading('getReviewUrl');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get ProctorU exam review payload
	  formData: null,
	  getReviewPayload: (0, _mobx.action)(function (examSid, sessionSid) {
	    _SessionStore2.default.startBackgroundLoading('getReviewPayload');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/review').then(function (response) {
	      if (response.data.type === 'form') {
	        obx.formData = response.data.formData;
	      } else {
	        obx.reviewUrl = response.data.redirectUrl;
	
	        if (obx.reviewUrl && obx.reviewUrl.indexOf('http:') >= 0) {
	          obx.reviewUrl = obx.reviewUrl.replace('http:', 'https:');
	        }
	      }
	
	      _SessionStore2.default.finishBackgroundLoading('getReviewPayload');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	// var urlBase = 'http://localhost:8000';
	// var myLocation = 'http://localhost:3000';
	
	// Components
	exports.default = obx;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  // Schedule sync
	  scheduleSync: (0, _mobx.action)(function (data, callback, failCallback) {
	    var allowError = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    _SessionStore2.default.startLoading('Loading…', 'scheduleSync');
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/sync', data).then(function (response) {
	      _SessionStore2.default.finishLoading('scheduleSync');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      if (allowError && error.response.data.code === '1529') {
	        _SessionStore2.default.finishLoading('scheduleSync', true);
	        if (failCallback) {
	          failCallback();
	        }
	      } else {
	        _SessionStore2.default.throwError(error);
	      }
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  // Get ticket types
	  ticketTypes: [],
	  getTicketTypes: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetTicketTypes');
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/ticketFields').then(function (response) {
	      obx.ticketTypes = response.data.ticketType;
	
	      // Finish loading
	      _SessionStore2.default.finishLoading('GetTicketTypes');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get tickets
	  tickets: [],
	  filteredTickets: [],
	  getTickets: (0, _mobx.action)(function (enrollmentSid, examSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetTickets');
	
	    var query = '?';
	
	    if (typeof enrollmentSid !== 'undefined') {
	      query += 'enrollmentSid=' + enrollmentSid;
	    }
	
	    if (typeof examSid !== 'undefined') {
	      query += '&examSid=' + examSid;
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/tickets' + query).then(function (response) {
	      obx.tickets = response.data.results;
	      obx.filteredTickets = response.data.results;
	
	      // Finish loading
	      _SessionStore2.default.finishLoading('GetTickets');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Filter tickets
	  filterTickets: (0, _mobx.action)(function (newFilteredTickets) {
	    obx.filteredTickets = newFilteredTickets;
	  }),
	  // Get individual ticket
	  activeTicket: {},
	  getTicket: (0, _mobx.action)(function (ticketSid, bypassLoad) {
	    if (!bypassLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'GetTicket');
	      obx.activeTicket = {};
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/tickets/' + ticketSid).then(function (response) {
	      obx.activeTicket = response.data;
	
	      // Finish loading
	      if (!bypassLoad) {
	        _SessionStore2.default.finishLoading('GetTicket');
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Post ticket
	  postTicket: (0, _mobx.action)(function (data, func) {
	    _SessionStore2.default.startLoading('Loading…', 'PostTicket');
	
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/tickets', data).then(function (response) {
	      // Finish loading
	      func();
	      _SessionStore2.default.finishLoading('PostTicket');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Post reply
	  postReply: (0, _mobx.action)(function (ticketSid, data, func) {
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/tickets/' + ticketSid, data).then(function (response) {
	      // Finish loading
	      obx.getTicket(ticketSid, true);
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update ticket status
	  updateTicket: (0, _mobx.action)(function (ticketSid, status) {
	    var data = {
	      status: status
	    };
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/tickets/' + ticketSid, data).then(function (response) {
	      // Finish loading
	      obx.getTicket(ticketSid, true);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(13);
	
	var _config = __webpack_require__(9);
	
	var _SessionStore = __webpack_require__(24);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  vouchers: [],
	  filters: {},
	  getVouchers: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'Vouchers');
	
	    var query = '?limit=500';
	
	    if (Object.keys(obx.filters).length > 0) {
	      for (var key in obx.filters) {
	        if (obx.filters[key]) {
	          query += '&' + key + '=' + obx.filters[key];
	        }
	      }
	    }
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/vouchers' + query).then(function (response) {
	      obx.vouchers = response.data.results;
	
	      _SessionStore2.default.finishLoading('Vouchers');
	    }).catch(function (error) {
	      console.log(error.stack || error);
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  voucherData: {},
	  resetVoucher: (0, _mobx.action)(function () {
	    obx.voucherData = {};
	  }),
	  getVoucher: (0, _mobx.action)(function (sid) {
	    _SessionStore2.default.startBackgroundLoading('GetVoucher');
	    obx.resetVoucher();
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/vouchers/' + sid).then(function (response) {
	      obx.voucherData = response.data;
	      _SessionStore2.default.finishBackgroundLoading('GetVoucher');
	    }).catch(function (error) {
	      console.log(error.stack || error);
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  deleteVoucher: (0, _mobx.action)(function (sid) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteVoucher');
	    _config.api.delete('/installs/' + _SessionStore2.default.userData.installSid + '/vouchers/' + sid).then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteVoucher');
	      obx.getVouchers();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  createVoucher: (0, _mobx.action)(function (data, func) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateVoucher');
	    if (data.nonTransferable) {
	      data.assignedToUserSid = sessionStorage.userData.userSid;
	    }
	    _config.api.post('/installs/' + _SessionStore2.default.userData.installSid + '/vouchers', data).then(function (response) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = response.data.results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var voucher = _step.value;
	
	          // reassigning obx.vouchers to response.data.results does not trigger the filterVouchers method
	          // so we are modifying the existing array
	          obx.vouchers.push(voucher);
	        }
	        // trigger the callback
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      func();
	      _SessionStore2.default.finishLoading('CreateVoucher');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  updateVoucher: (0, _mobx.action)(function (sid, data, func) {
	    _SessionStore2.default.startBackgroundLoading('UpdateVoucher');
	
	    _config.api.put('/installs/' + _SessionStore2.default.userData.installSid + '/vouchers/' + sid, data).then(function (response) {
	      // set the updated data to list element
	      obx.getVouchers();
	      func();
	      _SessionStore2.default.finishBackgroundLoading('UpdateVoucher');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(902);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 902 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(911), __esModule: true };

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(913), __esModule: true };

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(914), __esModule: true };

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(915), __esModule: true };

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(918), __esModule: true };

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(919), __esModule: true };

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(920), __esModule: true };

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(921), __esModule: true };

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157);
	__webpack_require__(943);
	module.exports = __webpack_require__(35).Array.from;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(239);
	__webpack_require__(157);
	module.exports = __webpack_require__(941);


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(239);
	__webpack_require__(157);
	module.exports = __webpack_require__(942);


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(945);
	module.exports = __webpack_require__(35).Object.assign;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(946);
	var $Object = __webpack_require__(35).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(947);
	var $Object = __webpack_require__(35).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(948);
	module.exports = __webpack_require__(35).Object.getPrototypeOf;


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(949);
	module.exports = __webpack_require__(35).Object.keys;


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(950);
	module.exports = __webpack_require__(35).Object.setPrototypeOf;


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(952);
	__webpack_require__(951);
	__webpack_require__(953);
	__webpack_require__(954);
	module.exports = __webpack_require__(35).Symbol;


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157);
	__webpack_require__(239);
	module.exports = __webpack_require__(238).f('iterator');


/***/ },
/* 922 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 923 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(106);
	var toLength = __webpack_require__(398);
	var toAbsoluteIndex = __webpack_require__(940);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(70);
	var createDesc = __webpack_require__(125);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(124);
	var gOPS = __webpack_require__(231);
	var pIE = __webpack_require__(155);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(69).document;
	module.exports = document && document.documentElement;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(105);
	var ITERATOR = __webpack_require__(50)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(226);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(83);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(230);
	var descriptor = __webpack_require__(125);
	var setToStringTag = __webpack_require__(232);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(103)(IteratorPrototype, __webpack_require__(50)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(50)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 933 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(156)('meta');
	var isObject = __webpack_require__(104);
	var has = __webpack_require__(84);
	var setDesc = __webpack_require__(70).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(102)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(67);
	var getKeys = __webpack_require__(124);
	var gOPS = __webpack_require__(231);
	var pIE = __webpack_require__(155);
	var toObject = __webpack_require__(107);
	var IObject = __webpack_require__(390);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(102)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(70);
	var anObject = __webpack_require__(83);
	var getKeys = __webpack_require__(124);
	
	module.exports = __webpack_require__(67) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(106);
	var gOPN = __webpack_require__(393).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(104);
	var anObject = __webpack_require__(83);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(227)(Function.call, __webpack_require__(392).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(235);
	var defined = __webpack_require__(228);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(235);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(83);
	var get = __webpack_require__(399);
	module.exports = __webpack_require__(35).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(387);
	var ITERATOR = __webpack_require__(50)('iterator');
	var Iterators = __webpack_require__(105);
	module.exports = __webpack_require__(35).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(227);
	var $export = __webpack_require__(68);
	var toObject = __webpack_require__(107);
	var call = __webpack_require__(930);
	var isArrayIter = __webpack_require__(928);
	var toLength = __webpack_require__(398);
	var createProperty = __webpack_require__(925);
	var getIterFn = __webpack_require__(399);
	
	$export($export.S + $export.F * !__webpack_require__(932)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(923);
	var step = __webpack_require__(933);
	var Iterators = __webpack_require__(105);
	var toIObject = __webpack_require__(106);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(391)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(68);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(935) });


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(68);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(230) });


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(68);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(67), 'Object', { defineProperty: __webpack_require__(70).f });


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(107);
	var $getPrototypeOf = __webpack_require__(394);
	
	__webpack_require__(396)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(107);
	var $keys = __webpack_require__(124);
	
	__webpack_require__(396)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(68);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(938).set });


/***/ },
/* 951 */
/***/ function(module, exports) {



/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(69);
	var has = __webpack_require__(84);
	var DESCRIPTORS = __webpack_require__(67);
	var $export = __webpack_require__(68);
	var redefine = __webpack_require__(397);
	var META = __webpack_require__(934).KEY;
	var $fails = __webpack_require__(102);
	var shared = __webpack_require__(234);
	var setToStringTag = __webpack_require__(232);
	var uid = __webpack_require__(156);
	var wks = __webpack_require__(50);
	var wksExt = __webpack_require__(238);
	var wksDefine = __webpack_require__(237);
	var enumKeys = __webpack_require__(926);
	var isArray = __webpack_require__(929);
	var anObject = __webpack_require__(83);
	var isObject = __webpack_require__(104);
	var toObject = __webpack_require__(107);
	var toIObject = __webpack_require__(106);
	var toPrimitive = __webpack_require__(236);
	var createDesc = __webpack_require__(125);
	var _create = __webpack_require__(230);
	var gOPNExt = __webpack_require__(937);
	var $GOPD = __webpack_require__(392);
	var $GOPS = __webpack_require__(231);
	var $DP = __webpack_require__(70);
	var $keys = __webpack_require__(124);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(393).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(155).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(154)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(103)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(237)('asyncIterator');


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(237)('observable');


/***/ },
/* 955 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 956 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(956)
	var ieee754 = __webpack_require__(999)
	var isArray = __webpack_require__(1007)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 958 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(401);
	} catch (err) {
	  var index = __webpack_require__(401);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Compressor.js v1.1.1
	 * https://fengyuanchen.github.io/compressorjs
	 *
	 * Copyright 2018-present Chen Fengyuan
	 * Released under the MIT license
	 *
	 * Date: 2021-10-05T02:32:40.212Z
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Compressor = factory());
	})(this, (function () { 'use strict';
	
	  function ownKeys(object, enumerableOnly) {
	    var keys = Object.keys(object);
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(object);
	
	      if (enumerableOnly) {
	        symbols = symbols.filter(function (sym) {
	          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	        });
	      }
	
	      keys.push.apply(keys, symbols);
	    }
	
	    return keys;
	  }
	
	  function _objectSpread2(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i] != null ? arguments[i] : {};
	
	      if (i % 2) {
	        ownKeys(Object(source), true).forEach(function (key) {
	          _defineProperty(target, key, source[key]);
	        });
	      } else if (Object.getOwnPropertyDescriptors) {
	        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	      } else {
	        ownKeys(Object(source)).forEach(function (key) {
	          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	        });
	      }
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _extends() {
	    _extends = Object.assign || function (target) {
	      for (var i = 1; i < arguments.length; i++) {
	        var source = arguments[i];
	
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	
	      return target;
	    };
	
	    return _extends.apply(this, arguments);
	  }
	
	  var canvasToBlob = {exports: {}};
	
	  /*
	   * JavaScript Canvas to Blob
	   * https://github.com/blueimp/JavaScript-Canvas-to-Blob
	   *
	   * Copyright 2012, Sebastian Tschan
	   * https://blueimp.net
	   *
	   * Licensed under the MIT license:
	   * https://opensource.org/licenses/MIT
	   *
	   * Based on stackoverflow user Stoive's code snippet:
	   * http://stackoverflow.com/q/4998908
	   */
	
	  (function (module) {
	  if (typeof window === 'undefined') {
	    return;
	  }
	
	    (function (window) {
	
	      var CanvasPrototype = window.HTMLCanvasElement && window.HTMLCanvasElement.prototype;
	
	      var hasBlobConstructor = window.Blob && function () {
	        try {
	          return Boolean(new Blob());
	        } catch (e) {
	          return false;
	        }
	      }();
	
	      var hasArrayBufferViewSupport = hasBlobConstructor && window.Uint8Array && function () {
	        try {
	          return new Blob([new Uint8Array(100)]).size === 100;
	        } catch (e) {
	          return false;
	        }
	      }();
	
	      var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	      var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
	
	      var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window.atob && window.ArrayBuffer && window.Uint8Array && function (dataURI) {
	        var matches, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i, bb; // Parse the dataURI components as per RFC 2397
	
	        matches = dataURI.match(dataURIPattern);
	
	        if (!matches) {
	          throw new Error('invalid data URI');
	        } // Default to text/plain;charset=US-ASCII
	
	
	        mediaType = matches[2] ? matches[1] : 'text/plain' + (matches[3] || ';charset=US-ASCII');
	        isBase64 = !!matches[4];
	        dataString = dataURI.slice(matches[0].length);
	
	        if (isBase64) {
	          // Convert base64 to raw binary data held in a string:
	          byteString = atob(dataString);
	        } else {
	          // Convert base64/URLEncoded data component to raw binary:
	          byteString = decodeURIComponent(dataString);
	        } // Write the bytes of the string to an ArrayBuffer:
	
	
	        arrayBuffer = new ArrayBuffer(byteString.length);
	        intArray = new Uint8Array(arrayBuffer);
	
	        for (i = 0; i < byteString.length; i += 1) {
	          intArray[i] = byteString.charCodeAt(i);
	        } // Write the ArrayBuffer (or ArrayBufferView) to a blob:
	
	
	        if (hasBlobConstructor) {
	          return new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], {
	            type: mediaType
	          });
	        }
	
	        bb = new BlobBuilder();
	        bb.append(arrayBuffer);
	        return bb.getBlob(mediaType);
	      };
	
	      if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
	        if (CanvasPrototype.mozGetAsFile) {
	          CanvasPrototype.toBlob = function (callback, type, quality) {
	            var self = this;
	            setTimeout(function () {
	              if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
	                callback(dataURLtoBlob(self.toDataURL(type, quality)));
	              } else {
	                callback(self.mozGetAsFile('blob', type));
	              }
	            });
	          };
	        } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
	          if (CanvasPrototype.msToBlob) {
	            CanvasPrototype.toBlob = function (callback, type, quality) {
	              var self = this;
	              setTimeout(function () {
	                if ((type && type !== 'image/png' || quality) && CanvasPrototype.toDataURL && dataURLtoBlob) {
	                  callback(dataURLtoBlob(self.toDataURL(type, quality)));
	                } else {
	                  callback(self.msToBlob(type));
	                }
	              });
	            };
	          } else {
	            CanvasPrototype.toBlob = function (callback, type, quality) {
	              var self = this;
	              setTimeout(function () {
	                callback(dataURLtoBlob(self.toDataURL(type, quality)));
	              });
	            };
	          }
	        }
	      }
	
	      if (module.exports) {
	        module.exports = dataURLtoBlob;
	      } else {
	        window.dataURLtoBlob = dataURLtoBlob;
	      }
	    })(window);
	  })(canvasToBlob);
	
	  var toBlob = canvasToBlob.exports;
	
	  var isBlob = function isBlob(value) {
	    if (typeof Blob === 'undefined') {
	      return false;
	    }
	
	    return value instanceof Blob || Object.prototype.toString.call(value) === '[object Blob]';
	  };
	
	  var DEFAULTS = {
	    /**
	     * Indicates if output the original image instead of the compressed one
	     * when the size of the compressed image is greater than the original one's
	     * @type {boolean}
	     */
	    strict: true,
	
	    /**
	     * Indicates if read the image's Exif Orientation information,
	     * and then rotate or flip the image automatically.
	     * @type {boolean}
	     */
	    checkOrientation: true,
	
	    /**
	     * The max width of the output image.
	     * @type {number}
	     */
	    maxWidth: Infinity,
	
	    /**
	     * The max height of the output image.
	     * @type {number}
	     */
	    maxHeight: Infinity,
	
	    /**
	     * The min width of the output image.
	     * @type {number}
	     */
	    minWidth: 0,
	
	    /**
	     * The min height of the output image.
	     * @type {number}
	     */
	    minHeight: 0,
	
	    /**
	     * The width of the output image.
	     * If not specified, the natural width of the source image will be used.
	     * @type {number}
	     */
	    width: undefined,
	
	    /**
	     * The height of the output image.
	     * If not specified, the natural height of the source image will be used.
	     * @type {number}
	     */
	    height: undefined,
	
	    /**
	     * Sets how the size of the image should be resized to the container
	     * specified by the `width` and `height` options.
	     * @type {string}
	     */
	    resize: 'none',
	
	    /**
	     * The quality of the output image.
	     * It must be a number between `0` and `1`,
	     * and only available for `image/jpeg` and `image/webp` images.
	     * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
	     * @type {number}
	     */
	    quality: 0.8,
	
	    /**
	     * The mime type of the output image.
	     * By default, the original mime type of the source image file will be used.
	     * @type {string}
	     */
	    mimeType: 'auto',
	
	    /**
	     * Files whose file type is included in this list,
	     * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
	     * @type {string｜Array}
	     */
	    convertTypes: ['image/png'],
	
	    /**
	     * PNG files over this size (5 MB by default) will be converted to JPEGs.
	     * To disable this, just set the value to `Infinity`.
	     * @type {number}
	     */
	    convertSize: 5000000,
	
	    /**
	     * The hook function to execute before draw the image into the canvas for compression.
	     * @type {Function}
	     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
	     * @param {HTMLCanvasElement} canvas - The canvas for compression.
	     * @example
	     * function (context, canvas) {
	     *   context.fillStyle = '#fff';
	     * }
	     */
	    beforeDraw: null,
	
	    /**
	     * The hook function to execute after drew the image into the canvas for compression.
	     * @type {Function}
	     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
	     * @param {HTMLCanvasElement} canvas - The canvas for compression.
	     * @example
	     * function (context, canvas) {
	     *   context.filter = 'grayscale(100%)';
	     * }
	     */
	    drew: null,
	
	    /**
	     * The hook function to execute when success to compress the image.
	     * @type {Function}
	     * @param {File} file - The compressed image File object.
	     * @example
	     * function (file) {
	     *   console.log(file);
	     * }
	     */
	    success: null,
	
	    /**
	     * The hook function to execute when fail to compress the image.
	     * @type {Function}
	     * @param {Error} err - An Error object.
	     * @example
	     * function (err) {
	     *   console.log(err.message);
	     * }
	     */
	    error: null
	  };
	
	  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
	  var WINDOW = IS_BROWSER ? window : {};
	
	  /**
	   * Check if the given value is a positive number.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
	   */
	
	  var isPositiveNumber = function isPositiveNumber(value) {
	    return value > 0 && value < Infinity;
	  };
	  var slice = Array.prototype.slice;
	  /**
	   * Convert array-like or iterable object to an array.
	   * @param {*} value - The value to convert.
	   * @returns {Array} Returns a new array.
	   */
	
	  function toArray(value) {
	    return Array.from ? Array.from(value) : slice.call(value);
	  }
	  var REGEXP_IMAGE_TYPE = /^image\/.+$/;
	  /**
	   * Check if the given value is a mime type of image.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given is a mime type of image, else `false`.
	   */
	
	  function isImageType(value) {
	    return REGEXP_IMAGE_TYPE.test(value);
	  }
	  /**
	   * Convert image type to extension.
	   * @param {string} value - The image type to convert.
	   * @returns {boolean} Returns the image extension.
	   */
	
	  function imageTypeToExtension(value) {
	    var extension = isImageType(value) ? value.substr(6) : '';
	
	    if (extension === 'jpeg') {
	      extension = 'jpg';
	    }
	
	    return ".".concat(extension);
	  }
	  var fromCharCode = String.fromCharCode;
	  /**
	   * Get string from char code in data view.
	   * @param {DataView} dataView - The data view for read.
	   * @param {number} start - The start index.
	   * @param {number} length - The read length.
	   * @returns {string} The read result.
	   */
	
	  function getStringFromCharCode(dataView, start, length) {
	    var str = '';
	    var i;
	    length += start;
	
	    for (i = start; i < length; i += 1) {
	      str += fromCharCode(dataView.getUint8(i));
	    }
	
	    return str;
	  }
	  var btoa = WINDOW.btoa;
	  /**
	   * Transform array buffer to Data URL.
	   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
	   * @param {string} mimeType - The mime type of the Data URL.
	   * @returns {string} The result Data URL.
	   */
	
	  function arrayBufferToDataURL(arrayBuffer, mimeType) {
	    var chunks = [];
	    var chunkSize = 8192;
	    var uint8 = new Uint8Array(arrayBuffer);
	
	    while (uint8.length > 0) {
	      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
	      // eslint-disable-next-line prefer-spread
	      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
	      uint8 = uint8.subarray(chunkSize);
	    }
	
	    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
	  }
	  /**
	   * Get orientation value from given array buffer.
	   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
	   * @returns {number} The read orientation value.
	   */
	
	  function resetAndGetOrientation(arrayBuffer) {
	    var dataView = new DataView(arrayBuffer);
	    var orientation; // Ignores range error when the image does not have correct Exif information
	
	    try {
	      var littleEndian;
	      var app1Start;
	      var ifdStart; // Only handle JPEG image (start by 0xFFD8)
	
	      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
	        var length = dataView.byteLength;
	        var offset = 2;
	
	        while (offset + 1 < length) {
	          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
	            app1Start = offset;
	            break;
	          }
	
	          offset += 1;
	        }
	      }
	
	      if (app1Start) {
	        var exifIDCode = app1Start + 4;
	        var tiffOffset = app1Start + 10;
	
	        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
	          var endianness = dataView.getUint16(tiffOffset);
	          littleEndian = endianness === 0x4949;
	
	          if (littleEndian || endianness === 0x4D4D
	          /* bigEndian */
	          ) {
	            if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
	              var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
	
	              if (firstIFDOffset >= 0x00000008) {
	                ifdStart = tiffOffset + firstIFDOffset;
	              }
	            }
	          }
	        }
	      }
	
	      if (ifdStart) {
	        var _length = dataView.getUint16(ifdStart, littleEndian);
	
	        var _offset;
	
	        var i;
	
	        for (i = 0; i < _length; i += 1) {
	          _offset = ifdStart + i * 12 + 2;
	
	          if (dataView.getUint16(_offset, littleEndian) === 0x0112
	          /* Orientation */
	          ) {
	            // 8 is the offset of the current tag's value
	            _offset += 8; // Get the original orientation value
	
	            orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value
	
	            dataView.setUint16(_offset, 1, littleEndian);
	            break;
	          }
	        }
	      }
	    } catch (e) {
	      orientation = 1;
	    }
	
	    return orientation;
	  }
	  /**
	   * Parse Exif Orientation value.
	   * @param {number} orientation - The orientation to parse.
	   * @returns {Object} The parsed result.
	   */
	
	  function parseOrientation(orientation) {
	    var rotate = 0;
	    var scaleX = 1;
	    var scaleY = 1;
	
	    switch (orientation) {
	      // Flip horizontal
	      case 2:
	        scaleX = -1;
	        break;
	      // Rotate left 180°
	
	      case 3:
	        rotate = -180;
	        break;
	      // Flip vertical
	
	      case 4:
	        scaleY = -1;
	        break;
	      // Flip vertical and rotate right 90°
	
	      case 5:
	        rotate = 90;
	        scaleY = -1;
	        break;
	      // Rotate right 90°
	
	      case 6:
	        rotate = 90;
	        break;
	      // Flip horizontal and rotate right 90°
	
	      case 7:
	        rotate = 90;
	        scaleX = -1;
	        break;
	      // Rotate left 90°
	
	      case 8:
	        rotate = -90;
	        break;
	    }
	
	    return {
	      rotate: rotate,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
	  /**
	   * Normalize decimal number.
	   * Check out {@link https://0.30000000000000004.com/}
	   * @param {number} value - The value to normalize.
	   * @param {number} [times=100000000000] - The times for normalizing.
	   * @returns {number} Returns the normalized number.
	   */
	
	  function normalizeDecimalNumber(value) {
	    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
	    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
	  }
	  /**
	   * Get the max sizes in a rectangle under the given aspect ratio.
	   * @param {Object} data - The original sizes.
	   * @param {string} [type='contain'] - The adjust type.
	   * @returns {Object} The result sizes.
	   */
	
	  function getAdjustedSizes(_ref) {
	    var aspectRatio = _ref.aspectRatio,
	        height = _ref.height,
	        width = _ref.width;
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
	    var isValidWidth = isPositiveNumber(width);
	    var isValidHeight = isPositiveNumber(height);
	
	    if (isValidWidth && isValidHeight) {
	      var adjustedWidth = height * aspectRatio;
	
	      if ((type === 'contain' || type === 'none') && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
	        height = width / aspectRatio;
	      } else {
	        width = height * aspectRatio;
	      }
	    } else if (isValidWidth) {
	      height = width / aspectRatio;
	    } else if (isValidHeight) {
	      width = height * aspectRatio;
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  }
	
	  var ArrayBuffer$1 = WINDOW.ArrayBuffer,
	      FileReader = WINDOW.FileReader;
	  var URL = WINDOW.URL || WINDOW.webkitURL;
	  var REGEXP_EXTENSION = /\.\w+$/;
	  var AnotherCompressor = WINDOW.Compressor;
	  /**
	   * Creates a new image compressor.
	   * @class
	   */
	
	  var Compressor = /*#__PURE__*/function () {
	    /**
	     * The constructor of Compressor.
	     * @param {File|Blob} file - The target image file for compressing.
	     * @param {Object} [options] - The options for compressing.
	     */
	    function Compressor(file, options) {
	      _classCallCheck(this, Compressor);
	
	      this.file = file;
	      this.image = new Image();
	      this.options = _objectSpread2(_objectSpread2({}, DEFAULTS), options);
	      this.aborted = false;
	      this.result = null;
	      this.init();
	    }
	
	    _createClass(Compressor, [{
	      key: "init",
	      value: function init() {
	        var _this = this;
	
	        var file = this.file,
	            options = this.options;
	
	        if (!isBlob(file)) {
	          this.fail(new Error('The first argument must be a File or Blob object.'));
	          return;
	        }
	
	        var mimeType = file.type;
	
	        if (!isImageType(mimeType)) {
	          this.fail(new Error('The first argument must be an image File or Blob object.'));
	          return;
	        }
	
	        if (!URL || !FileReader) {
	          this.fail(new Error('The current browser does not support image compression.'));
	          return;
	        }
	
	        if (!ArrayBuffer$1) {
	          options.checkOrientation = false;
	        }
	
	        if (URL && !options.checkOrientation) {
	          this.load({
	            url: URL.createObjectURL(file)
	          });
	        } else {
	          var reader = new FileReader();
	          var checkOrientation = options.checkOrientation && mimeType === 'image/jpeg';
	          this.reader = reader;
	
	          reader.onload = function (_ref) {
	            var target = _ref.target;
	            var result = target.result;
	            var data = {};
	
	            if (checkOrientation) {
	              // Reset the orientation value to its default value 1
	              // as some iOS browsers will render image with its orientation
	              var orientation = resetAndGetOrientation(result);
	
	              if (orientation > 1 || !URL) {
	                // Generate a new URL which has the default orientation value
	                data.url = arrayBufferToDataURL(result, mimeType);
	
	                if (orientation > 1) {
	                  _extends(data, parseOrientation(orientation));
	                }
	              } else {
	                data.url = URL.createObjectURL(file);
	              }
	            } else {
	              data.url = result;
	            }
	
	            _this.load(data);
	          };
	
	          reader.onabort = function () {
	            _this.fail(new Error('Aborted to read the image with FileReader.'));
	          };
	
	          reader.onerror = function () {
	            _this.fail(new Error('Failed to read the image with FileReader.'));
	          };
	
	          reader.onloadend = function () {
	            _this.reader = null;
	          };
	
	          if (checkOrientation) {
	            reader.readAsArrayBuffer(file);
	          } else {
	            reader.readAsDataURL(file);
	          }
	        }
	      }
	    }, {
	      key: "load",
	      value: function load(data) {
	        var _this2 = this;
	
	        var file = this.file,
	            image = this.image;
	
	        image.onload = function () {
	          _this2.draw(_objectSpread2(_objectSpread2({}, data), {}, {
	            naturalWidth: image.naturalWidth,
	            naturalHeight: image.naturalHeight
	          }));
	        };
	
	        image.onabort = function () {
	          _this2.fail(new Error('Aborted to load the image.'));
	        };
	
	        image.onerror = function () {
	          _this2.fail(new Error('Failed to load the image.'));
	        }; // Match all browsers that use WebKit as the layout engine in iOS devices,
	        // such as Safari for iOS, Chrome for iOS, and in-app browsers.
	
	
	        if (WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent)) {
	          // Fix the `The operation is insecure` error (#57)
	          image.crossOrigin = 'anonymous';
	        }
	
	        image.alt = file.name;
	        image.src = data.url;
	      }
	    }, {
	      key: "draw",
	      value: function draw(_ref2) {
	        var _this3 = this;
	
	        var naturalWidth = _ref2.naturalWidth,
	            naturalHeight = _ref2.naturalHeight,
	            _ref2$rotate = _ref2.rotate,
	            rotate = _ref2$rotate === void 0 ? 0 : _ref2$rotate,
	            _ref2$scaleX = _ref2.scaleX,
	            scaleX = _ref2$scaleX === void 0 ? 1 : _ref2$scaleX,
	            _ref2$scaleY = _ref2.scaleY,
	            scaleY = _ref2$scaleY === void 0 ? 1 : _ref2$scaleY;
	        var file = this.file,
	            image = this.image,
	            options = this.options;
	        var canvas = document.createElement('canvas');
	        var context = canvas.getContext('2d');
	        var is90DegreesRotated = Math.abs(rotate) % 180 === 90;
	        var resizable = (options.resize === 'contain' || options.resize === 'cover') && isPositiveNumber(options.width) && isPositiveNumber(options.height);
	        var maxWidth = Math.max(options.maxWidth, 0) || Infinity;
	        var maxHeight = Math.max(options.maxHeight, 0) || Infinity;
	        var minWidth = Math.max(options.minWidth, 0) || 0;
	        var minHeight = Math.max(options.minHeight, 0) || 0;
	        var aspectRatio = naturalWidth / naturalHeight;
	        var width = options.width,
	            height = options.height;
	
	        if (is90DegreesRotated) {
	          var _ref3 = [maxHeight, maxWidth];
	          maxWidth = _ref3[0];
	          maxHeight = _ref3[1];
	          var _ref4 = [minHeight, minWidth];
	          minWidth = _ref4[0];
	          minHeight = _ref4[1];
	          var _ref5 = [height, width];
	          width = _ref5[0];
	          height = _ref5[1];
	        }
	
	        if (resizable) {
	          aspectRatio = width / height;
	        }
	
	        var _getAdjustedSizes = getAdjustedSizes({
	          aspectRatio: aspectRatio,
	          width: maxWidth,
	          height: maxHeight
	        }, 'contain');
	
	        maxWidth = _getAdjustedSizes.width;
	        maxHeight = _getAdjustedSizes.height;
	
	        var _getAdjustedSizes2 = getAdjustedSizes({
	          aspectRatio: aspectRatio,
	          width: minWidth,
	          height: minHeight
	        }, 'cover');
	
	        minWidth = _getAdjustedSizes2.width;
	        minHeight = _getAdjustedSizes2.height;
	
	        if (resizable) {
	          var _getAdjustedSizes3 = getAdjustedSizes({
	            aspectRatio: aspectRatio,
	            width: width,
	            height: height
	          }, options.resize);
	
	          width = _getAdjustedSizes3.width;
	          height = _getAdjustedSizes3.height;
	        } else {
	          var _getAdjustedSizes4 = getAdjustedSizes({
	            aspectRatio: aspectRatio,
	            width: width,
	            height: height
	          });
	
	          var _getAdjustedSizes4$wi = _getAdjustedSizes4.width;
	          width = _getAdjustedSizes4$wi === void 0 ? naturalWidth : _getAdjustedSizes4$wi;
	          var _getAdjustedSizes4$he = _getAdjustedSizes4.height;
	          height = _getAdjustedSizes4$he === void 0 ? naturalHeight : _getAdjustedSizes4$he;
	        }
	
	        width = Math.floor(normalizeDecimalNumber(Math.min(Math.max(width, minWidth), maxWidth)));
	        height = Math.floor(normalizeDecimalNumber(Math.min(Math.max(height, minHeight), maxHeight)));
	        var destX = -width / 2;
	        var destY = -height / 2;
	        var destWidth = width;
	        var destHeight = height;
	        var params = [];
	
	        if (resizable) {
	          var srcX = 0;
	          var srcY = 0;
	          var srcWidth = naturalWidth;
	          var srcHeight = naturalHeight;
	
	          var _getAdjustedSizes5 = getAdjustedSizes({
	            aspectRatio: aspectRatio,
	            width: naturalWidth,
	            height: naturalHeight
	          }, {
	            contain: 'cover',
	            cover: 'contain'
	          }[options.resize]);
	
	          srcWidth = _getAdjustedSizes5.width;
	          srcHeight = _getAdjustedSizes5.height;
	          srcX = (naturalWidth - srcWidth) / 2;
	          srcY = (naturalHeight - srcHeight) / 2;
	          params.push(srcX, srcY, srcWidth, srcHeight);
	        }
	
	        params.push(destX, destY, destWidth, destHeight);
	
	        if (is90DegreesRotated) {
	          var _ref6 = [height, width];
	          width = _ref6[0];
	          height = _ref6[1];
	        }
	
	        canvas.width = width;
	        canvas.height = height;
	
	        if (!isImageType(options.mimeType)) {
	          options.mimeType = file.type;
	        }
	
	        var fillStyle = 'transparent'; // Converts PNG files over the `convertSize` to JPEGs.
	
	        if (file.size > options.convertSize && options.convertTypes.indexOf(options.mimeType) >= 0) {
	          options.mimeType = 'image/jpeg';
	        }
	
	        if (options.mimeType === 'image/jpeg') {
	          fillStyle = '#fff';
	        } // Override the default fill color (#000, black)
	
	
	        context.fillStyle = fillStyle;
	        context.fillRect(0, 0, width, height);
	
	        if (options.beforeDraw) {
	          options.beforeDraw.call(this, context, canvas);
	        }
	
	        if (this.aborted) {
	          return;
	        }
	
	        context.save();
	        context.translate(width / 2, height / 2);
	        context.rotate(rotate * Math.PI / 180);
	        context.scale(scaleX, scaleY);
	        context.drawImage.apply(context, [image].concat(params));
	        context.restore();
	
	        if (options.drew) {
	          options.drew.call(this, context, canvas);
	        }
	
	        if (this.aborted) {
	          return;
	        }
	
	        var done = function done(result) {
	          if (!_this3.aborted) {
	            _this3.done({
	              naturalWidth: naturalWidth,
	              naturalHeight: naturalHeight,
	              result: result
	            });
	          }
	        };
	
	        if (canvas.toBlob) {
	          canvas.toBlob(done, options.mimeType, options.quality);
	        } else {
	          done(toBlob(canvas.toDataURL(options.mimeType, options.quality)));
	        }
	      }
	    }, {
	      key: "done",
	      value: function done(_ref7) {
	        var naturalWidth = _ref7.naturalWidth,
	            naturalHeight = _ref7.naturalHeight,
	            result = _ref7.result;
	        var file = this.file,
	            image = this.image,
	            options = this.options;
	
	        if (URL && !options.checkOrientation) {
	          URL.revokeObjectURL(image.src);
	        }
	
	        if (result) {
	          // Returns original file if the result is greater than it and without size related options
	          if (options.strict && result.size > file.size && options.mimeType === file.type && !(options.width > naturalWidth || options.height > naturalHeight || options.minWidth > naturalWidth || options.minHeight > naturalHeight || options.maxWidth < naturalWidth || options.maxHeight < naturalHeight)) {
	            result = file;
	          } else {
	            var date = new Date();
	            result.lastModified = date.getTime();
	            result.lastModifiedDate = date;
	            result.name = file.name; // Convert the extension to match its type
	
	            if (result.name && result.type !== file.type) {
	              result.name = result.name.replace(REGEXP_EXTENSION, imageTypeToExtension(result.type));
	            }
	          }
	        } else {
	          // Returns original file if the result is null in some cases.
	          result = file;
	        }
	
	        this.result = result;
	
	        if (options.success) {
	          options.success.call(this, result);
	        }
	      }
	    }, {
	      key: "fail",
	      value: function fail(err) {
	        var options = this.options;
	
	        if (options.error) {
	          options.error.call(this, err);
	        } else {
	          throw err;
	        }
	      }
	    }, {
	      key: "abort",
	      value: function abort() {
	        if (!this.aborted) {
	          this.aborted = true;
	
	          if (this.reader) {
	            this.reader.abort();
	          } else if (!this.image.complete) {
	            this.image.onload = null;
	            this.image.onabort();
	          } else {
	            this.fail(new Error('The compression process has been aborted.'));
	          }
	        }
	      }
	      /**
	       * Get the no conflict compressor class.
	       * @returns {Compressor} The compressor class.
	       */
	
	    }], [{
	      key: "noConflict",
	      value: function noConflict() {
	        window.Compressor = AnotherCompressor;
	        return Compressor;
	      }
	      /**
	       * Change the default options.
	       * @param {Object} options - The new default options.
	       */
	
	    }, {
	      key: "setDefaults",
	      value: function setDefaults(options) {
	        _extends(DEFAULTS, options);
	      }
	    }]);
	
	    return Compressor;
	  }();
	
	  return Compressor;
	
	}));


/***/ },
/* 961 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var START_EVENT_NAME_MAP = {
	  transitionstart: {
	    transition: 'transitionstart',
	    WebkitTransition: 'webkitTransitionStart',
	    MozTransition: 'mozTransitionStart',
	    OTransition: 'oTransitionStart',
	    msTransition: 'MSTransitionStart'
	  },
	
	  animationstart: {
	    animation: 'animationstart',
	    WebkitAnimation: 'webkitAnimationStart',
	    MozAnimation: 'mozAnimationStart',
	    OAnimation: 'oAnimationStart',
	    msAnimation: 'MSAnimationStart'
	  }
	};
	
	var END_EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var startEvents = [];
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete START_EVENT_NAME_MAP.animationstart.animation;
	    delete END_EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete START_EVENT_NAME_MAP.transitionstart.transition;
	    delete END_EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  function process(EVENT_NAME_MAP, events) {
	    for (var baseEventName in EVENT_NAME_MAP) {
	      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	        var baseEvents = EVENT_NAME_MAP[baseEventName];
	        for (var styleName in baseEvents) {
	          if (styleName in style) {
	            events.push(baseEvents[styleName]);
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  process(START_EVENT_NAME_MAP, startEvents);
	  process(END_EVENT_NAME_MAP, endEvents);
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  // Start events
	  startEvents: startEvents,
	
	  addStartEventListener: function addStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      addEventListener(node, startEvent, eventListener);
	    });
	  },
	  removeStartEventListener: function removeStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      removeEventListener(node, startEvent, eventListener);
	    });
	  },
	
	
	  // End events
	  endEvents: endEvents,
	
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(153);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(961);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(959);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ },
/* 963 */
/***/ function(module, exports) {

	function _registerEvent(target, eventType, cb) {
	    if (target.addEventListener) {
	        target.addEventListener(eventType, cb);
	        return {
	            remove: function () {
	                target.removeEventListener(eventType, cb);
	            }
	        };
	    } else {
	        target.attachEvent(eventType, cb);
	        return {
	            remove: function () {
	                target.detachEvent(eventType, cb);
	            }
	        };
	    }
	}
	
	function _createHiddenIframe(target, uri) {
	    var iframe = document.createElement("iframe");
	    iframe.src = uri;
	    iframe.id = "hiddenIframe";
	    iframe.style.display = "none";
	    target.appendChild(iframe);
	
	    return iframe;
	}
	
	function openUriWithHiddenFrame(uri, failCb, successCb) {
	
	    var timeout = setTimeout(function () {
	        failCb();
	        handler.remove();
	    }, 1000);
	
	    var iframe = document.querySelector("#hiddenIframe");
	    if (!iframe) {
	        iframe = _createHiddenIframe(document.body, "about:blank");
	    }
	
	    var handler = _registerEvent(window, "blur", onBlur);
	
	    function onBlur() {
	        clearTimeout(timeout);
	        handler.remove();
	        successCb();
	    }
	
	    iframe.contentWindow.location.href = uri;
	}
	
	function openUriWithTimeoutHack(uri, failCb, successCb) {
	    
	    var timeout = setTimeout(function () {
	        failCb();
	        handler.remove();
	    }, 1000);
	
	    //handle page running in an iframe (blur must be registered with top level window)
	    var target = window;
	    while (target != target.parent) {
	        target = target.parent;
	    }
	
	    var handler = _registerEvent(target, "blur", onBlur);
	
	    function onBlur() {
	        clearTimeout(timeout);
	        handler.remove();
	        successCb();
	    }
	
	    window.location = uri;
	}
	
	function openUriUsingFirefox(uri, failCb, successCb) {
	    var iframe = document.querySelector("#hiddenIframe");
	
	    if (!iframe) {
	        iframe = _createHiddenIframe(document.body, "about:blank");
	    }
	
	    try {
	        iframe.contentWindow.location.href = uri;
	        successCb();
	    } catch (e) {
	        if (e.name == "NS_ERROR_UNKNOWN_PROTOCOL") {
	            failCb();
	        }
	    }
	}
	
	function openUriUsingIEInOlderWindows(uri, failCb, successCb) {
	    if (getInternetExplorerVersion() === 10) {
	        openUriUsingIE10InWindows7(uri, failCb, successCb);
	    } else if (getInternetExplorerVersion() === 9 || getInternetExplorerVersion() === 11) {
	        openUriWithHiddenFrame(uri, failCb, successCb);
	    } else {
	        openUriInNewWindowHack(uri, failCb, successCb);
	    }
	}
	
	function openUriUsingIE10InWindows7(uri, failCb, successCb) {
	    var timeout = setTimeout(failCb, 1000);
	    window.addEventListener("blur", function () {
	        clearTimeout(timeout);
	        successCb();
	    });
	
	    var iframe = document.querySelector("#hiddenIframe");
	    if (!iframe) {
	        iframe = _createHiddenIframe(document.body, "about:blank");
	    }
	    try {
	        iframe.contentWindow.location.href = uri;
	    } catch (e) {
	        failCb();
	        clearTimeout(timeout);
	    }
	}
	
	function openUriInNewWindowHack(uri, failCb, successCb) {
	    var myWindow = window.open('', '', 'width=0,height=0');
	
	    myWindow.document.write("<iframe src='" + uri + "'></iframe>");
	
	    setTimeout(function () {
	        try {
	            myWindow.location.href;
	            myWindow.setTimeout("window.close()", 1000);
	            successCb();
	        } catch (e) {
	            myWindow.close();
	            failCb();
	        }
	    }, 1000);
	}
	
	function openUriWithMsLaunchUri(uri, failCb, successCb) {
	    navigator.msLaunchUri(uri,
	        successCb,
	        failCb
	    );
	}
	
	function checkBrowser() {
	    var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
	    var ua = navigator.userAgent.toLowerCase();
	    return {
	        isOpera   : isOpera,
	        isFirefox : typeof InstallTrigger !== 'undefined',
	        isSafari  : (~ua.indexOf('safari') && !~ua.indexOf('chrome')) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0,
	        isIOS     : /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
	        isChrome  : !!window.chrome && !isOpera,
	        isIE      : /*@cc_on!@*/false || !!document.documentMode // At least IE6
	    }
	}
	
	function getInternetExplorerVersion() {
	    var rv = -1;
	    if (navigator.appName === "Microsoft Internet Explorer") {
	        var ua = navigator.userAgent;
	        var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
	        if (re.exec(ua) != null)
	            rv = parseFloat(RegExp.$1);
	    }
	    else if (navigator.appName === "Netscape") {
	        var ua = navigator.userAgent;
	        var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
	        if (re.exec(ua) != null) {
	            rv = parseFloat(RegExp.$1);
	        }
	    }
	    return rv;
	}
	
	module.exports = function(uri, failCb, successCb, unsupportedCb) {
	    function failCallback() {
	        failCb && failCb();
	    }
	
	    function successCallback() {
	        successCb && successCb();
	    }
	
	    if (navigator.msLaunchUri) { //for IE and Edge in Win 8 and Win 10
	        openUriWithMsLaunchUri(uri, failCb, successCb);
	    } else {
	        var browser = checkBrowser();
	
	        if (browser.isFirefox) {
	            openUriUsingFirefox(uri, failCallback, successCallback);
	        } else if (browser.isChrome || browser.isIOS) {
	            openUriWithTimeoutHack(uri, failCallback, successCallback);
	        } else if (browser.isIE) {
	            openUriUsingIEInOlderWindows(uri, failCallback, successCallback);
	        } else if (browser.isSafari) {
	            openUriWithHiddenFrame(uri, failCallback, successCallback);
	        } else {
	            unsupportedCb();
	            //not supported, implement please
	        }
	    }
	}


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.4.5 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.d3 = global.d3 || {}));
	}(this, (function (exports) { 'use strict';
	
	function formatDecimal(x) {
	  return Math.abs(x = Math.round(x)) >= 1e21
	      ? x.toLocaleString("en").replace(/,/g, "")
	      : x.toString(10);
	}
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimalParts(1.23) returns ["123", 0].
	function formatDecimalParts(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  return new FormatSpecifier({
	    fill: match[1],
	    align: match[2],
	    sign: match[3],
	    symbol: match[4],
	    zero: match[5],
	    width: match[6],
	    comma: match[7],
	    precision: match[8] && match[8].slice(1),
	    trim: match[9],
	    type: match[10]
	  });
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
	  this.align = specifier.align === undefined ? ">" : specifier.align + "";
	  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
	  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
	  this.zero = !!specifier.zero;
	  this.width = specifier.width === undefined ? undefined : +specifier.width;
	  this.comma = !!specifier.comma;
	  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
	  this.trim = !!specifier.trim;
	  this.type = specifier.type === undefined ? "" : specifier.type + "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": formatDecimal,
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var map = Array.prototype.map,
	    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
	      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
	      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
	      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
	      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
	      percent = locale.percent === undefined ? "%" : locale.percent + "",
	      minus = locale.minus === undefined ? "-" : locale.minus + "",
	      nan = locale.nan === undefined ? "NaN" : locale.nan + "";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision === undefined ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
	        var valueNegative = value < 0 || 1 / value < 0;
	
	        // Perform the initial formatting.
	        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
	        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""],
	  minus: "-"
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.FormatSpecifier = FormatSpecifier;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(403)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function numberArray(a, b) {
	  if (!b) b = [];
	  var n = a ? Math.min(b.length, a.length) : 0,
	      c = b.slice(),
	      i;
	  return function(t) {
	    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
	    return c;
	  };
	}
	
	function isNumberArray(x) {
	  return ArrayBuffer.isView(x) && !(x instanceof DataView);
	}
	
	function array(a, b) {
	  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
	}
	
	function genericArray(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b = +b, function(t) {
	    return d.setTime(a * (1 - t) + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b = +b, function(t) {
	    return a * (1 - t) + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : isNumberArray(b) ? numberArray
	      : Array.isArray(b) ? genericArray
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b = +b, function(t) {
	    return Math.round(a * (1 - t) + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateHue = hue$1;
	exports.interpolateLab = lab;
	exports.interpolateNumber = number;
	exports.interpolateNumberArray = numberArray;
	exports.interpolateObject = object;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.9 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r, ccw = !!ccw;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.3.0 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(404)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newDate(y, m, d) {
	  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "g": formatYearISO,
	    "G": formatFullYearISO,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "q": formatQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "g": formatUTCYearISO,
	    "G": formatUTCFullYearISO,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "q": formatUTCQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "g": parseYear,
	    "G": parseFullYear,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "q": parseQuarter,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, Z) {
	    return function(string) {
	      var d = newDate(1900, undefined, 1),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
	
	      // If this is utcParse, never use the local timezone.
	      if (Z && !("Z" in d)) d.Z = 0;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // If the month was not specified, inherit from the quarter.
	      if (d.m === undefined) d.m = "q" in d ? d.q : 0;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return localDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatQuarter(d) {
	    return 1 + ~~(d.getMonth() / 3);
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  function formatUTCQuarter(d) {
	    return 1 + ~~(d.getUTCMonth() / 3);
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", false);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier += "", true);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseQuarter(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.s = +n[0], i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function dISO(d) {
	  var day = d.getDay();
	  return (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	}
	
	function formatWeekNumberISO(d, p) {
	  d = dISO(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatYearISO(d, p) {
	  d = dISO(d);
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatFullYearISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function UTCdISO(d) {
	  var day = d.getUTCDay();
	  return (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCYearISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCFullYearISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 970 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendorPrefix;
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
	}
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	
	  if (name) {
	    node.style[name] = value;
	
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	
	  if (name) {
	    node.style[name] = value;
	
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return {
	      x: parseFloat(matrix[12] || matrix[4], 0),
	      y: parseFloat(matrix[13] || matrix[5], 0)
	    };
	  }
	
	  return {
	    x: 0,
	    y: 0
	  };
	}
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	
	  if (transform && transform !== 'none') {
	    var arr;
	    var match2d = transform.match(matrix2d);
	
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, "matrix(".concat(arr.join(','), ")"));
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
	    }
	  } else {
	    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
	  }
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605
	
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	
	  elem.style.display = originalStyle;
	}
	
	function css(el, name, v) {
	  var value = v;
	
	  if (_typeof(name) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	
	    return undefined;
	  }
	
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = "".concat(value, "px");
	    }
	
	    el.style[name] = value;
	    return undefined;
	  }
	
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box;
	  var x;
	  var y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	
	  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = Math.floor(box.left);
	  y = Math.floor(box.top); // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
	  var method = "scroll".concat(top ? 'Top' : 'Left');
	
	  if (typeof ret !== 'number') {
	    var d = w.document; // ie6,7,8 standard mode
	
	    ret = d.documentElement[method];
	
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	
	
	function isWindow(obj) {
	  // must use == for ie8
	
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	
	  if (node.nodeType === 9) {
	    return node;
	  }
	
	  return node.ownerDocument;
	}
	
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61
	
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
	
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content
	
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out
	
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX; // Revert the changed values
	
	    style[LEFT] = left;
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	} // 设置 elem 相对 elem.ownerDocument 的坐标
	
	
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = getTransitionProperty(elem) || '';
	    setTransitionProperty(elem, 'none');
	  }
	
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = "".concat(presetH, "px");
	  }
	
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = "".concat(presetV, "px");
	  } // force relayout
	
	
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	
	  css(elem, originalStyle); // force relayout
	
	  forceRelayout(elem);
	
	  if ('left' in offset || 'top' in offset) {
	    setTransitionProperty(elem, originalTransition);
	  }
	
	  var ret = {};
	
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	
	      var _off = offset[_key] - originalOffset[_key];
	
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	
	  css(elem, ret);
	}
	
	function setTransform$1(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = getTransformXY(elem);
	  var resultXY = {
	    x: originalXY.x,
	    y: originalXY.y
	  };
	
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	
	  setTransformXY(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);
	
	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }
	
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && getTransformName() in document.body.style) {
	    setTransform$1(elem, offset);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name; // Remember the old values, and insert the new ones
	
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem); // Revert the old values
	
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop;
	  var j;
	  var i;
	
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	
	        if (prop === 'border') {
	          cssProp = "".concat(prop).concat(which[i], "Width");
	        } else {
	          cssProp = prop + which[i];
	        }
	
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	
	  return value;
	}
	
	var domUtils = {
	  getParent: function getParent(element) {
	    var parent = element;
	
	    do {
	      if (parent.nodeType === 11 && parent.host) {
	        parent = parent.host;
	      } else {
	        parent = parent.parentNode;
	      }
	    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
	
	    return parent;
	  }
	};
	each(['Width', 'Height'], function (name) {
	  domUtils["doc".concat(name)] = function (refWin) {
	    var d = refWin.document;
	    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
	  };
	
	  domUtils["viewport".concat(name)] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = "client".concat(name);
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
	    // backcompat 取 body
	
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	
	function getWH(elem, name, ex) {
	  var extra = ex;
	
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
	  var isBorderBox = isBorderBoxFn(elem);
	  var cssBoxValue = 0;
	
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary
	
	    cssBoxValue = getComputedStyleX(elem, name);
	
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    } // Normalize '', auto, and prepare for extra
	
	
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which);
	    }
	
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
	  }
	
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	}; // fix #119 : https://github.com/kissyteam/kissy/issues/119
	
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val;
	  var elem = args[0]; // in case elem is window
	  // elem.offsetWidth === undefined
	
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	
	  domUtils["outer".concat(first)] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	
	    if (val !== undefined) {
	      if (elem) {
	        var isBorderBox = isBorderBoxFn(elem);
	
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which);
	        }
	
	        return css(elem, name, val);
	      }
	
	      return undefined;
	    }
	
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i;
	    var ret = {};
	
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	
	    var overflow = obj.overflow;
	
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	
	    return ret;
	  },
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var i = 0; i < arguments.length; i++) {
	      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
	    }
	
	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	mix(utils, domUtils);
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	var getParent = utils.getParent;
	
	function getOffsetParent(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return null;
	  } // ie 这个也不是完全可行
	
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	
	
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent;
	  var positionStyle = utils.css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
	  }
	
	  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
	    positionStyle = utils.css(parent, 'position');
	
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	
	  return null;
	}
	
	var getParent$1 = utils.getParent;
	function isAncestorFixed(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent = null;
	
	  for (parent = getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
	  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
	    var positionStyle = utils.css(parent, 'position');
	
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * 获得元素的显示部分的区域
	 */
	
	function getVisibleRectForElement(element, alwaysByViewport) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = getOffsetParent(element);
	  var doc = utils.getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
	      var pos = utils.offset(el); // add border
	
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	
	    el = getOffsetParent(el);
	  } // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	
	
	  var originalPosition = null;
	
	  if (!utils.isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = utils.css(element, 'position');
	
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
	  // We should cut this ourself.
	
	  var bodyStyle = window.getComputedStyle(body);
	
	  if (bodyStyle.overflowX === 'hidden') {
	    documentWidth = win.innerWidth;
	  }
	
	  if (bodyStyle.overflowY === 'hidden') {
	    documentHeight = win.innerHeight;
	  } // Reset element position after calculate the visible area
	
	
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	
	  if (alwaysByViewport || isAncestorFixed(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = utils.clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  } // Left edge inside and right edge outside viewport, try to resize it.
	
	
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  } // Right edge outside viewport, try to move it.
	
	
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  } // Top edge outside viewport, try to move it.
	
	
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  } // Top edge inside and bottom edge outside viewport, try to resize it.
	
	
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  } // Bottom edge outside viewport, try to move it.
	
	
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return utils.mix(pos, size);
	}
	
	function getRegion(node) {
	  var offset;
	  var w;
	  var h;
	
	  if (!utils.isWindow(node) && node.nodeType !== 9) {
	    offset = utils.offset(node);
	    w = utils.outerWidth(node);
	    h = utils.outerHeight(node);
	  } else {
	    var win = utils.getWindow(node);
	    offset = {
	      left: utils.getWindowScrollLeft(win),
	      top: utils.getWindowScrollTop(win)
	    };
	    w = utils.viewportWidth(win);
	    h = utils.viewportHeight(win);
	  }
	
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = region.left;
	  var y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = getAlignOffset(refNodeRegion, points[1]);
	  var p2 = getAlignOffset(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	  return {
	    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
	    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
	  };
	}
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  utils.each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n;
	
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */
	
	
	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域
	
	  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height
	
	  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比
	
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置
	
	  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域
	
	  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整
	
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        }); // 偏移量也反下
	
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
	
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        }); // 偏移量也反下
	
	
	        var _newOffset = flipOffset(offset, 1);
	
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	
	        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
	
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    } // 如果失败，重新计算当前节点将要被放置的位置
	
	
	    if (fail) {
	      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	      utils.mix(newElRegion, elFuturePos);
	    }
	
	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数
	
	    if (isStillFailX || isStillFailY) {
	      var _newPoints2 = points; // 重置对应部分的翻转逻辑
	
	      if (isStillFailX) {
	        _newPoints2 = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	      }
	
	      if (isStillFailY) {
	        _newPoints2 = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	      }
	
	      points = _newPoints2;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    } // 2. 只有指定了可以调整当前方向才调整
	
	
	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度
	
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  } // need judge to in case set fixed with in css on height auto element
	
	
	  if (newElRegion.width !== elRegion.width) {
	    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
	  } // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	
	
	  utils.offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	function isOutOfVisibleRect(target, alwaysByViewport) {
	  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
	  var targetRegion = getRegion(target);
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	
	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = getRegion(target);
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
	  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}
	
	alignElement.__getOffsetParent = getOffsetParent;
	alignElement.__getVisibleRectForElement = getVisibleRectForElement;
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */
	
	function alignPoint(el, tgtPoint, align) {
	  var pageX;
	  var pageY;
	  var doc = utils.getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	
	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }
	
	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }
	
	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point
	
	  var points = [align.points[0], 'cc'];
	  return doAlign(el, tgtRegion, _objectSpread(_objectSpread({}, align), {}, {
	    points: points
	  }), pointInView);
	}
	
	exports.alignElement = alignElement;
	exports.alignPoint = alignPoint;
	exports.default = alignElement;
	//# sourceMappingURL=index.js.map


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(210);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(972));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 972 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 973 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(210);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(405));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(210);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(405));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 976 */
/***/ function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ },
/* 977 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
	
	    var debug = false;
	
	    var root = this;
	
	    var EXIF = function(obj) {
	        if (obj instanceof EXIF) return obj;
	        if (!(this instanceof EXIF)) return new EXIF(obj);
	        this.EXIFwrapped = obj;
	    };
	
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = EXIF;
	        }
	        exports.EXIF = EXIF;
	    } else {
	        root.EXIF = EXIF;
	    }
	
	    var ExifTags = EXIF.Tags = {
	
	        // version tags
	        0x9000 : "ExifVersion",             // EXIF version
	        0xA000 : "FlashpixVersion",         // Flashpix format version
	
	        // colorspace tags
	        0xA001 : "ColorSpace",              // Color space information tag
	
	        // image configuration
	        0xA002 : "PixelXDimension",         // Valid width of meaningful image
	        0xA003 : "PixelYDimension",         // Valid height of meaningful image
	        0x9101 : "ComponentsConfiguration", // Information about channels
	        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel
	
	        // user information
	        0x927C : "MakerNote",               // Any desired information written by the manufacturer
	        0x9286 : "UserComment",             // Comments by user
	
	        // related file
	        0xA004 : "RelatedSoundFile",        // Name of related sound file
	
	        // date and time
	        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
	        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
	        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
	        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
	        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized
	
	        // picture-taking conditions
	        0x829A : "ExposureTime",            // Exposure time (in seconds)
	        0x829D : "FNumber",                 // F number
	        0x8822 : "ExposureProgram",         // Exposure program
	        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
	        0x8827 : "ISOSpeedRatings",         // ISO speed rating
	        0x8828 : "OECF",                    // Optoelectric conversion factor
	        0x9201 : "ShutterSpeedValue",       // Shutter speed
	        0x9202 : "ApertureValue",           // Lens aperture
	        0x9203 : "BrightnessValue",         // Value of brightness
	        0x9204 : "ExposureBias",            // Exposure bias
	        0x9205 : "MaxApertureValue",        // Smallest F number of lens
	        0x9206 : "SubjectDistance",         // Distance to subject in meters
	        0x9207 : "MeteringMode",            // Metering mode
	        0x9208 : "LightSource",             // Kind of light source
	        0x9209 : "Flash",                   // Flash status
	        0x9214 : "SubjectArea",             // Location and area of main subject
	        0x920A : "FocalLength",             // Focal length of the lens in mm
	        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
	        0xA20C : "SpatialFrequencyResponse",    //
	        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
	        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
	        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
	        0xA214 : "SubjectLocation",         // Location of subject in image
	        0xA215 : "ExposureIndex",           // Exposure index selected on camera
	        0xA217 : "SensingMethod",           // Image sensor type
	        0xA300 : "FileSource",              // Image source (3 == DSC)
	        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
	        0xA302 : "CFAPattern",              // Color filter array geometric pattern
	        0xA401 : "CustomRendered",          // Special processing
	        0xA402 : "ExposureMode",            // Exposure mode
	        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
	        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
	        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
	        0xA406 : "SceneCaptureType",        // Type of scene
	        0xA407 : "GainControl",             // Degree of overall image gain adjustment
	        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
	        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
	        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
	        0xA40B : "DeviceSettingDescription",    //
	        0xA40C : "SubjectDistanceRange",    // Distance to subject
	
	        // other tags
	        0xA005 : "InteroperabilityIFDPointer",
	        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
	    };
	
	    var TiffTags = EXIF.TiffTags = {
	        0x0100 : "ImageWidth",
	        0x0101 : "ImageHeight",
	        0x8769 : "ExifIFDPointer",
	        0x8825 : "GPSInfoIFDPointer",
	        0xA005 : "InteroperabilityIFDPointer",
	        0x0102 : "BitsPerSample",
	        0x0103 : "Compression",
	        0x0106 : "PhotometricInterpretation",
	        0x0112 : "Orientation",
	        0x0115 : "SamplesPerPixel",
	        0x011C : "PlanarConfiguration",
	        0x0212 : "YCbCrSubSampling",
	        0x0213 : "YCbCrPositioning",
	        0x011A : "XResolution",
	        0x011B : "YResolution",
	        0x0128 : "ResolutionUnit",
	        0x0111 : "StripOffsets",
	        0x0116 : "RowsPerStrip",
	        0x0117 : "StripByteCounts",
	        0x0201 : "JPEGInterchangeFormat",
	        0x0202 : "JPEGInterchangeFormatLength",
	        0x012D : "TransferFunction",
	        0x013E : "WhitePoint",
	        0x013F : "PrimaryChromaticities",
	        0x0211 : "YCbCrCoefficients",
	        0x0214 : "ReferenceBlackWhite",
	        0x0132 : "DateTime",
	        0x010E : "ImageDescription",
	        0x010F : "Make",
	        0x0110 : "Model",
	        0x0131 : "Software",
	        0x013B : "Artist",
	        0x8298 : "Copyright"
	    };
	
	    var GPSTags = EXIF.GPSTags = {
	        0x0000 : "GPSVersionID",
	        0x0001 : "GPSLatitudeRef",
	        0x0002 : "GPSLatitude",
	        0x0003 : "GPSLongitudeRef",
	        0x0004 : "GPSLongitude",
	        0x0005 : "GPSAltitudeRef",
	        0x0006 : "GPSAltitude",
	        0x0007 : "GPSTimeStamp",
	        0x0008 : "GPSSatellites",
	        0x0009 : "GPSStatus",
	        0x000A : "GPSMeasureMode",
	        0x000B : "GPSDOP",
	        0x000C : "GPSSpeedRef",
	        0x000D : "GPSSpeed",
	        0x000E : "GPSTrackRef",
	        0x000F : "GPSTrack",
	        0x0010 : "GPSImgDirectionRef",
	        0x0011 : "GPSImgDirection",
	        0x0012 : "GPSMapDatum",
	        0x0013 : "GPSDestLatitudeRef",
	        0x0014 : "GPSDestLatitude",
	        0x0015 : "GPSDestLongitudeRef",
	        0x0016 : "GPSDestLongitude",
	        0x0017 : "GPSDestBearingRef",
	        0x0018 : "GPSDestBearing",
	        0x0019 : "GPSDestDistanceRef",
	        0x001A : "GPSDestDistance",
	        0x001B : "GPSProcessingMethod",
	        0x001C : "GPSAreaInformation",
	        0x001D : "GPSDateStamp",
	        0x001E : "GPSDifferential"
	    };
	
	     // EXIF 2.3 Spec
	    var IFD1Tags = EXIF.IFD1Tags = {
	        0x0100: "ImageWidth",
	        0x0101: "ImageHeight",
	        0x0102: "BitsPerSample",
	        0x0103: "Compression",
	        0x0106: "PhotometricInterpretation",
	        0x0111: "StripOffsets",
	        0x0112: "Orientation",
	        0x0115: "SamplesPerPixel",
	        0x0116: "RowsPerStrip",
	        0x0117: "StripByteCounts",
	        0x011A: "XResolution",
	        0x011B: "YResolution",
	        0x011C: "PlanarConfiguration",
	        0x0128: "ResolutionUnit",
	        0x0201: "JpegIFOffset",    // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
	        0x0202: "JpegIFByteCount", // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
	        0x0211: "YCbCrCoefficients",
	        0x0212: "YCbCrSubSampling",
	        0x0213: "YCbCrPositioning",
	        0x0214: "ReferenceBlackWhite"
	    };
	
	    var StringValues = EXIF.StringValues = {
	        ExposureProgram : {
	            0 : "Not defined",
	            1 : "Manual",
	            2 : "Normal program",
	            3 : "Aperture priority",
	            4 : "Shutter priority",
	            5 : "Creative program",
	            6 : "Action program",
	            7 : "Portrait mode",
	            8 : "Landscape mode"
	        },
	        MeteringMode : {
	            0 : "Unknown",
	            1 : "Average",
	            2 : "CenterWeightedAverage",
	            3 : "Spot",
	            4 : "MultiSpot",
	            5 : "Pattern",
	            6 : "Partial",
	            255 : "Other"
	        },
	        LightSource : {
	            0 : "Unknown",
	            1 : "Daylight",
	            2 : "Fluorescent",
	            3 : "Tungsten (incandescent light)",
	            4 : "Flash",
	            9 : "Fine weather",
	            10 : "Cloudy weather",
	            11 : "Shade",
	            12 : "Daylight fluorescent (D 5700 - 7100K)",
	            13 : "Day white fluorescent (N 4600 - 5400K)",
	            14 : "Cool white fluorescent (W 3900 - 4500K)",
	            15 : "White fluorescent (WW 3200 - 3700K)",
	            17 : "Standard light A",
	            18 : "Standard light B",
	            19 : "Standard light C",
	            20 : "D55",
	            21 : "D65",
	            22 : "D75",
	            23 : "D50",
	            24 : "ISO studio tungsten",
	            255 : "Other"
	        },
	        Flash : {
	            0x0000 : "Flash did not fire",
	            0x0001 : "Flash fired",
	            0x0005 : "Strobe return light not detected",
	            0x0007 : "Strobe return light detected",
	            0x0009 : "Flash fired, compulsory flash mode",
	            0x000D : "Flash fired, compulsory flash mode, return light not detected",
	            0x000F : "Flash fired, compulsory flash mode, return light detected",
	            0x0010 : "Flash did not fire, compulsory flash mode",
	            0x0018 : "Flash did not fire, auto mode",
	            0x0019 : "Flash fired, auto mode",
	            0x001D : "Flash fired, auto mode, return light not detected",
	            0x001F : "Flash fired, auto mode, return light detected",
	            0x0020 : "No flash function",
	            0x0041 : "Flash fired, red-eye reduction mode",
	            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
	            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
	            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
	            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
	            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
	            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
	            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
	            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
	        },
	        SensingMethod : {
	            1 : "Not defined",
	            2 : "One-chip color area sensor",
	            3 : "Two-chip color area sensor",
	            4 : "Three-chip color area sensor",
	            5 : "Color sequential area sensor",
	            7 : "Trilinear sensor",
	            8 : "Color sequential linear sensor"
	        },
	        SceneCaptureType : {
	            0 : "Standard",
	            1 : "Landscape",
	            2 : "Portrait",
	            3 : "Night scene"
	        },
	        SceneType : {
	            1 : "Directly photographed"
	        },
	        CustomRendered : {
	            0 : "Normal process",
	            1 : "Custom process"
	        },
	        WhiteBalance : {
	            0 : "Auto white balance",
	            1 : "Manual white balance"
	        },
	        GainControl : {
	            0 : "None",
	            1 : "Low gain up",
	            2 : "High gain up",
	            3 : "Low gain down",
	            4 : "High gain down"
	        },
	        Contrast : {
	            0 : "Normal",
	            1 : "Soft",
	            2 : "Hard"
	        },
	        Saturation : {
	            0 : "Normal",
	            1 : "Low saturation",
	            2 : "High saturation"
	        },
	        Sharpness : {
	            0 : "Normal",
	            1 : "Soft",
	            2 : "Hard"
	        },
	        SubjectDistanceRange : {
	            0 : "Unknown",
	            1 : "Macro",
	            2 : "Close view",
	            3 : "Distant view"
	        },
	        FileSource : {
	            3 : "DSC"
	        },
	
	        Components : {
	            0 : "",
	            1 : "Y",
	            2 : "Cb",
	            3 : "Cr",
	            4 : "R",
	            5 : "G",
	            6 : "B"
	        }
	    };
	
	    function addEvent(element, event, handler) {
	        if (element.addEventListener) {
	            element.addEventListener(event, handler, false);
	        } else if (element.attachEvent) {
	            element.attachEvent("on" + event, handler);
	        }
	    }
	
	    function imageHasData(img) {
	        return !!(img.exifdata);
	    }
	
	
	    function base64ToArrayBuffer(base64, contentType) {
	        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
	        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
	        var binary = atob(base64);
	        var len = binary.length;
	        var buffer = new ArrayBuffer(len);
	        var view = new Uint8Array(buffer);
	        for (var i = 0; i < len; i++) {
	            view[i] = binary.charCodeAt(i);
	        }
	        return buffer;
	    }
	
	    function objectURLToBlob(url, callback) {
	        var http = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.responseType = "blob";
	        http.onload = function(e) {
	            if (this.status == 200 || this.status === 0) {
	                callback(this.response);
	            }
	        };
	        http.send();
	    }
	
	    function getImageData(img, callback) {
	        function handleBinaryFile(binFile) {
	            var data = findEXIFinJPEG(binFile);
	            img.exifdata = data || {};
	            var iptcdata = findIPTCinJPEG(binFile);
	            img.iptcdata = iptcdata || {};
	            if (EXIF.isXmpEnabled) {
	               var xmpdata= findXMPinJPEG(binFile);
	               img.xmpdata = xmpdata || {};               
	            }
	            if (callback) {
	                callback.call(img);
	            }
	        }
	
	        if (img.src) {
	            if (/^data\:/i.test(img.src)) { // Data URI
	                var arrayBuffer = base64ToArrayBuffer(img.src);
	                handleBinaryFile(arrayBuffer);
	
	            } else if (/^blob\:/i.test(img.src)) { // Object URL
	                var fileReader = new FileReader();
	                fileReader.onload = function(e) {
	                    handleBinaryFile(e.target.result);
	                };
	                objectURLToBlob(img.src, function (blob) {
	                    fileReader.readAsArrayBuffer(blob);
	                });
	            } else {
	                var http = new XMLHttpRequest();
	                http.onload = function() {
	                    if (this.status == 200 || this.status === 0) {
	                        handleBinaryFile(http.response);
	                    } else {
	                        throw "Could not load image";
	                    }
	                    http = null;
	                };
	                http.open("GET", img.src, true);
	                http.responseType = "arraybuffer";
	                http.send(null);
	            }
	        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
	            var fileReader = new FileReader();
	            fileReader.onload = function(e) {
	                if (debug) console.log("Got file of length " + e.target.result.byteLength);
	                handleBinaryFile(e.target.result);
	            };
	
	            fileReader.readAsArrayBuffer(img);
	        }
	    }
	
	    function findEXIFinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            marker;
	
	        while (offset < length) {
	            if (dataView.getUint8(offset) != 0xFF) {
	                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
	                return false; // not a valid marker, something is wrong
	            }
	
	            marker = dataView.getUint8(offset + 1);
	            if (debug) console.log(marker);
	
	            // we could implement handling for other markers here,
	            // but we're only looking for 0xFFE1 for EXIF data
	
	            if (marker == 225) {
	                if (debug) console.log("Found 0xFFE1 marker");
	
	                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
	
	                // offset += 2 + file.getShortAt(offset+2, true);
	
	            } else {
	                offset += 2 + dataView.getUint16(offset+2);
	            }
	
	        }
	
	    }
	
	    function findIPTCinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength;
	
	
	        var isFieldSegmentStart = function(dataView, offset){
	            return (
	                dataView.getUint8(offset) === 0x38 &&
	                dataView.getUint8(offset+1) === 0x42 &&
	                dataView.getUint8(offset+2) === 0x49 &&
	                dataView.getUint8(offset+3) === 0x4D &&
	                dataView.getUint8(offset+4) === 0x04 &&
	                dataView.getUint8(offset+5) === 0x04
	            );
	        };
	
	        while (offset < length) {
	
	            if ( isFieldSegmentStart(dataView, offset )){
	
	                // Get the length of the name header (which is padded to an even number of bytes)
	                var nameHeaderLength = dataView.getUint8(offset+7);
	                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
	                // Check for pre photoshop 6 format
	                if(nameHeaderLength === 0) {
	                    // Always 4
	                    nameHeaderLength = 4;
	                }
	
	                var startOffset = offset + 8 + nameHeaderLength;
	                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
	
	                return readIPTCData(file, startOffset, sectionLength);
	
	                break;
	
	            }
	
	
	            // Not the marker, continue searching
	            offset++;
	
	        }
	
	    }
	    var IptcFieldMap = {
	        0x78 : 'caption',
	        0x6E : 'credit',
	        0x19 : 'keywords',
	        0x37 : 'dateCreated',
	        0x50 : 'byline',
	        0x55 : 'bylineTitle',
	        0x7A : 'captionWriter',
	        0x69 : 'headline',
	        0x74 : 'copyright',
	        0x0F : 'category'
	    };
	    function readIPTCData(file, startOffset, sectionLength){
	        var dataView = new DataView(file);
	        var data = {};
	        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
	        var segmentStartPos = startOffset;
	        while(segmentStartPos < startOffset+sectionLength) {
	            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
	                segmentType = dataView.getUint8(segmentStartPos+2);
	                if(segmentType in IptcFieldMap) {
	                    dataSize = dataView.getInt16(segmentStartPos+3);
	                    segmentSize = dataSize + 5;
	                    fieldName = IptcFieldMap[segmentType];
	                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
	                    // Check if we already stored a value with this name
	                    if(data.hasOwnProperty(fieldName)) {
	                        // Value already stored with this name, create multivalue field
	                        if(data[fieldName] instanceof Array) {
	                            data[fieldName].push(fieldValue);
	                        }
	                        else {
	                            data[fieldName] = [data[fieldName], fieldValue];
	                        }
	                    }
	                    else {
	                        data[fieldName] = fieldValue;
	                    }
	                }
	
	            }
	            segmentStartPos++;
	        }
	        return data;
	    }
	
	
	
	    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
	        var entries = file.getUint16(dirStart, !bigEnd),
	            tags = {},
	            entryOffset, tag,
	            i;
	
	        for (i=0;i<entries;i++) {
	            entryOffset = dirStart + i*12 + 2;
	            tag = strings[file.getUint16(entryOffset, !bigEnd)];
	            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
	            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
	        }
	        return tags;
	    }
	
	
	    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
	        var type = file.getUint16(entryOffset+2, !bigEnd),
	            numValues = file.getUint32(entryOffset+4, !bigEnd),
	            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
	            offset,
	            vals, val, n,
	            numerator, denominator;
	
	        switch (type) {
	            case 1: // byte, 8-bit unsigned int
	            case 7: // undefined, 8-bit byte, value depending on field
	                if (numValues == 1) {
	                    return file.getUint8(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint8(offset + n);
	                    }
	                    return vals;
	                }
	
	            case 2: // ascii, 8-bit byte
	                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                return getStringFromDB(file, offset, numValues-1);
	
	            case 3: // short, 16 bit int
	                if (numValues == 1) {
	                    return file.getUint16(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 4: // long, 32 bit int
	                if (numValues == 1) {
	                    return file.getUint32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 5:    // rational = two long values, first is numerator, second is denominator
	                if (numValues == 1) {
	                    numerator = file.getUint32(valueOffset, !bigEnd);
	                    denominator = file.getUint32(valueOffset+4, !bigEnd);
	                    val = new Number(numerator / denominator);
	                    val.numerator = numerator;
	                    val.denominator = denominator;
	                    return val;
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
	                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
	                        vals[n] = new Number(numerator / denominator);
	                        vals[n].numerator = numerator;
	                        vals[n].denominator = denominator;
	                    }
	                    return vals;
	                }
	
	            case 9: // slong, 32 bit signed int
	                if (numValues == 1) {
	                    return file.getInt32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 10: // signed rational, two slongs, first is numerator, second is denominator
	                if (numValues == 1) {
	                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
	                    }
	                    return vals;
	                }
	        }
	    }
	
	    /**
	    * Given an IFD (Image File Directory) start offset
	    * returns an offset to next IFD or 0 if it's the last IFD.
	    */
	    function getNextIFDOffset(dataView, dirStart, bigEnd){
	        //the first 2bytes means the number of directory entries contains in this IFD
	        var entries = dataView.getUint16(dirStart, !bigEnd);
	
	        // After last directory entry, there is a 4bytes of data,
	        // it means an offset to next IFD.
	        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.
	
	        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
	    }
	
	    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd){
	        // get the IFD1 offset
	        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart+firstIFDOffset, bigEnd);
	
	        if (!IFD1OffsetPointer) {
	            // console.log('******** IFD1Offset is empty, image thumb not found ********');
	            return {};
	        }
	        else if (IFD1OffsetPointer > dataView.byteLength) { // this should not happen
	            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
	            return {};
	        }
	        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);
	
	        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd)
	
	        // EXIF 2.3 specification for JPEG format thumbnail
	
	        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
	        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
	        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
	        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
	        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.
	
	        if (thumbTags['Compression']) {
	            // console.log('Thumbnail image found!');
	
	            switch (thumbTags['Compression']) {
	                case 6:
	                    // console.log('Thumbnail image format is JPEG');
	                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
	                    // extract the thumbnail
	                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
	                        var tLength = thumbTags.JpegIFByteCount;
	                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
	                            type: 'image/jpeg'
	                        });
	                    }
	                break;
	
	            case 1:
	                console.log("Thumbnail image format is TIFF, which is not implemented.");
	                break;
	            default:
	                console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
	            }
	        }
	        else if (thumbTags['PhotometricInterpretation'] == 2) {
	            console.log("Thumbnail image format is RGB, which is not implemented.");
	        }
	        return thumbTags;
	    }
	
	    function getStringFromDB(buffer, start, length) {
	        var outstr = "";
	        for (n = start; n < start+length; n++) {
	            outstr += String.fromCharCode(buffer.getUint8(n));
	        }
	        return outstr;
	    }
	
	    function readEXIFData(file, start) {
	        if (getStringFromDB(file, start, 4) != "Exif") {
	            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
	            return false;
	        }
	
	        var bigEnd,
	            tags, tag,
	            exifData, gpsData,
	            tiffOffset = start + 6;
	
	        // test for TIFF validity and endianness
	        if (file.getUint16(tiffOffset) == 0x4949) {
	            bigEnd = false;
	        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
	            bigEnd = true;
	        } else {
	            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
	            return false;
	        }
	
	        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
	            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
	            return false;
	        }
	
	        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);
	
	        if (firstIFDOffset < 0x00000008) {
	            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
	            return false;
	        }
	
	        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);
	
	        if (tags.ExifIFDPointer) {
	            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
	            for (tag in exifData) {
	                switch (tag) {
	                    case "LightSource" :
	                    case "Flash" :
	                    case "MeteringMode" :
	                    case "ExposureProgram" :
	                    case "SensingMethod" :
	                    case "SceneCaptureType" :
	                    case "SceneType" :
	                    case "CustomRendered" :
	                    case "WhiteBalance" :
	                    case "GainControl" :
	                    case "Contrast" :
	                    case "Saturation" :
	                    case "Sharpness" :
	                    case "SubjectDistanceRange" :
	                    case "FileSource" :
	                        exifData[tag] = StringValues[tag][exifData[tag]];
	                        break;
	
	                    case "ExifVersion" :
	                    case "FlashpixVersion" :
	                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
	                        break;
	
	                    case "ComponentsConfiguration" :
	                        exifData[tag] =
	                            StringValues.Components[exifData[tag][0]] +
	                            StringValues.Components[exifData[tag][1]] +
	                            StringValues.Components[exifData[tag][2]] +
	                            StringValues.Components[exifData[tag][3]];
	                        break;
	                }
	                tags[tag] = exifData[tag];
	            }
	        }
	
	        if (tags.GPSInfoIFDPointer) {
	            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
	            for (tag in gpsData) {
	                switch (tag) {
	                    case "GPSVersionID" :
	                        gpsData[tag] = gpsData[tag][0] +
	                            "." + gpsData[tag][1] +
	                            "." + gpsData[tag][2] +
	                            "." + gpsData[tag][3];
	                        break;
	                }
	                tags[tag] = gpsData[tag];
	            }
	        }
	
	        // extract thumbnail
	        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);
	
	        return tags;
	    }
	
	   function findXMPinJPEG(file) {
	
	        if (!('DOMParser' in self)) {
	            // console.warn('XML parsing not supported without DOMParser');
	            return;
	        }
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	           if (debug) console.log("Not a valid JPEG");
	           return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            dom = new DOMParser();
	
	        while (offset < (length-4)) {
	            if (getStringFromDB(dataView, offset, 4) == "http") {
	                var startOffset = offset - 1;
	                var sectionLength = dataView.getUint16(offset - 2) - 1;
	                var xmpString = getStringFromDB(dataView, startOffset, sectionLength)
	                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
	                xmpString = xmpString.substring( xmpString.indexOf( '<x:xmpmeta' ), xmpEndIndex );
	
	                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10
	                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
	                //Without these namespaces, XML is thought to be invalid by parsers
	                xmpString = xmpString.slice(0, indexOfXmp)
	                            + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" '
	                            + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
	                            + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" '
	                            + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" '
	                            + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" '
	                            + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" '
	                            + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" '
	                            + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" '
	                            + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" '
	                            + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" '
	                            + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '
	                            + xmpString.slice(indexOfXmp)
	
	                var domDocument = dom.parseFromString( xmpString, 'text/xml' );
	                return xml2Object(domDocument);
	            } else{
	             offset++;
	            }
	        }
	    }
	
	    function xml2json(xml) {
	        var json = {};
	      
	        if (xml.nodeType == 1) { // element node
	          if (xml.attributes.length > 0) {
	            json['@attributes'] = {};
	            for (var j = 0; j < xml.attributes.length; j++) {
	              var attribute = xml.attributes.item(j);
	              json['@attributes'][attribute.nodeName] = attribute.nodeValue;
	            }
	          }
	        } else if (xml.nodeType == 3) { // text node
	          return xml.nodeValue;
	        }
	      
	        // deal with children
	        if (xml.hasChildNodes()) {
	          for(var i = 0; i < xml.childNodes.length; i++) {
	            var child = xml.childNodes.item(i);
	            var nodeName = child.nodeName;
	            if (json[nodeName] == null) {
	              json[nodeName] = xml2json(child);
	            } else {
	              if (json[nodeName].push == null) {
	                var old = json[nodeName];
	                json[nodeName] = [];
	                json[nodeName].push(old);
	              }
	              json[nodeName].push(xml2json(child));
	            }
	          }
	        }
	        
	        return json;
	    }
	
	    function xml2Object(xml) {
	        try {
	            var obj = {};
	            if (xml.children.length > 0) {
	              for (var i = 0; i < xml.children.length; i++) {
	                var item = xml.children.item(i);
	                var attributes = item.attributes;
	                for(var idx in attributes) {
	                    var itemAtt = attributes[idx];
	                    var dataKey = itemAtt.nodeName;
	                    var dataValue = itemAtt.nodeValue;
	
	                    if(dataKey !== undefined) {
	                        obj[dataKey] = dataValue;
	                    }
	                }
	                var nodeName = item.nodeName;
	
	                if (typeof (obj[nodeName]) == "undefined") {
	                  obj[nodeName] = xml2json(item);
	                } else {
	                  if (typeof (obj[nodeName].push) == "undefined") {
	                    var old = obj[nodeName];
	
	                    obj[nodeName] = [];
	                    obj[nodeName].push(old);
	                  }
	                  obj[nodeName].push(xml2json(item));
	                }
	              }
	            } else {
	              obj = xml.textContent;
	            }
	            return obj;
	          } catch (e) {
	              console.log(e.message);
	          }
	    }
	
	    EXIF.enableXmp = function() {
	        EXIF.isXmpEnabled = true;
	    }
	
	    EXIF.disableXmp = function() {
	        EXIF.isXmpEnabled = false;
	    }
	
	    EXIF.getData = function(img, callback) {
	        if (((self.Image && img instanceof self.Image)
	            || (self.HTMLImageElement && img instanceof self.HTMLImageElement))
	            && !img.complete)
	            return false;
	
	        if (!imageHasData(img)) {
	            getImageData(img, callback);
	        } else {
	            if (callback) {
	                callback.call(img);
	            }
	        }
	        return true;
	    }
	
	    EXIF.getTag = function(img, tag) {
	        if (!imageHasData(img)) return;
	        return img.exifdata[tag];
	    }
	    
	    EXIF.getIptcTag = function(img, tag) {
	        if (!imageHasData(img)) return;
	        return img.iptcdata[tag];
	    }
	
	    EXIF.getAllTags = function(img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.exifdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    }
	    
	    EXIF.getAllIptcTags = function(img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.iptcdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    }
	
	    EXIF.pretty = function(img) {
	        if (!imageHasData(img)) return "";
	        var a,
	            data = img.exifdata,
	            strPretty = "";
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                if (typeof data[a] == "object") {
	                    if (data[a] instanceof Number) {
	                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
	                    } else {
	                        strPretty += a + " : [" + data[a].length + " values]\r\n";
	                    }
	                } else {
	                    strPretty += a + " : " + data[a] + "\r\n";
	                }
	            }
	        }
	        return strPretty;
	    }
	
	    EXIF.readFromBinaryFile = function(file) {
	        return findEXIFinJPEG(file);
	    }
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return EXIF;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}.call(this));
	


/***/ },
/* 979 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 980 */
979,
/* 981 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(981);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(991);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var createArrayFromMixed = __webpack_require__(984);
	var getMarkupWrap = __webpack_require__(986);
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 987 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 988 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(988);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 990 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(990);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 992 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 993 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(242);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(108);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _DOMStateStorage = __webpack_require__(409);
	
	var _PathUtils = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(242);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(108);
	
	var _PathUtils = __webpack_require__(72);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(243);
	
	var _BrowserProtocol = __webpack_require__(242);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(995);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _createHistory = __webpack_require__(244);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(243);
	
	var _DOMUtils = __webpack_require__(160);
	
	var _HashProtocol = __webpack_require__(994);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(244);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(108);
	
	var _PathUtils = __webpack_require__(72);
	
	var _createHistory = __webpack_require__(244);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 999 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = close_braces;
	
	var _helpers = __webpack_require__(246);
	
	function close_braces(retained_template, template) {
		var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
		var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
	
		var cut_before = retained_template.length;
	
		var opening_braces = (0, _helpers.count_occurences)('(', retained_template);
		var closing_braces = (0, _helpers.count_occurences)(')', retained_template);
	
		var dangling_braces = opening_braces - closing_braces;
	
		while (dangling_braces > 0 && cut_before < template.length) {
			retained_template += template[cut_before].replace(placeholder, empty_placeholder);
	
			if (template[cut_before] === ')') {
				dangling_braces--;
			}
	
			cut_before++;
		}
	
		return retained_template;
	}
	//# sourceMappingURL=close braces.js.map

/***/ },
/* 1001 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getSelection = getSelection;
	exports.getOperation = getOperation;
	exports.getCaretPosition = getCaretPosition;
	exports.setCaretPosition = setCaretPosition;
	// Gets <input/> selection bounds
	function getSelection(element) {
		// If no selection, return nothing
		if (element.selectionStart === element.selectionEnd) {
			return;
		}
	
		return { start: element.selectionStart, end: element.selectionEnd };
	}
	
	// Key codes
	var Keys = {
		Backspace: 8,
		Delete: 46
	};
	
	// Finds out the operation to be intercepted and performed
	// based on the key down event `keyCode`.
	function getOperation(event) {
		switch (event.keyCode) {
			case Keys.Backspace:
				return 'Backspace';
	
			case Keys.Delete:
				return 'Delete';
		}
	}
	
	// Gets <input/> caret position
	function getCaretPosition(element) {
		return element.selectionStart;
	}
	
	// Sets <input/> caret position
	function setCaretPosition(element, caret_position) {
		// Sanity check
		if (caret_position === undefined) {
			return;
		}
	
		// Set caret position
		element.setSelectionRange(caret_position, caret_position);
	}
	//# sourceMappingURL=dom.js.map

/***/ },
/* 1002 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = edit;
	// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
	//
	// Example:
	//
	// value - '88005553535'
	// caret - 2 // starting from 0; is positioned before the first zero
	// operation - 'Backspace'
	//
	// Returns
	// {
	// 	value: '8005553535'
	// 	caret: 1
	// }
	//
	// Currently supports just 'Delete' and 'Backspace' operations
	//
	function edit(value, caret, operation) {
		switch (operation) {
			case 'Backspace':
				// If there exists the previous character,
				// then erase it and reposition the caret.
				if (caret > 0) {
					// Remove the previous character
					value = value.slice(0, caret - 1) + value.slice(caret);
					// Position the caret where the previous (erased) character was
					caret--;
				}
				break;
	
			case 'Delete':
				// Remove current digit (if any)
				value = value.slice(0, caret) + value.slice(caret + 1);
				break;
		}
	
		return { value: value, caret: caret };
	}
	//# sourceMappingURL=edit.js.map

/***/ },
/* 1003 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (character, value) {
		return DIGITS[character];
	};
	
	// Copied from `libphonenumber-js`:
	// https://github.com/catamphetamine/libphonenumber-js/blob/master/source/parse.js
	//
	// These mappings map a character (key) to a specific digit that should
	// replace it for normalization purposes. Non-European digits that
	// may be used in phone numbers are mapped to a European equivalent.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	var DIGITS = exports.DIGITS = {
		'0': '0',
		'1': '1',
		'2': '2',
		'3': '3',
		'4': '4',
		'5': '5',
		'6': '6',
		'7': '7',
		'8': '8',
		'9': '9',
		'\uFF10': '0', // Fullwidth digit 0
		'\uFF11': '1', // Fullwidth digit 1
		'\uFF12': '2', // Fullwidth digit 2
		'\uFF13': '3', // Fullwidth digit 3
		'\uFF14': '4', // Fullwidth digit 4
		'\uFF15': '5', // Fullwidth digit 5
		'\uFF16': '6', // Fullwidth digit 6
		'\uFF17': '7', // Fullwidth digit 7
		'\uFF18': '8', // Fullwidth digit 8
		'\uFF19': '9', // Fullwidth digit 9
		'\u0660': '0', // Arabic-indic digit 0
		'\u0661': '1', // Arabic-indic digit 1
		'\u0662': '2', // Arabic-indic digit 2
		'\u0663': '3', // Arabic-indic digit 3
		'\u0664': '4', // Arabic-indic digit 4
		'\u0665': '5', // Arabic-indic digit 5
		'\u0666': '6', // Arabic-indic digit 6
		'\u0667': '7', // Arabic-indic digit 7
		'\u0668': '8', // Arabic-indic digit 8
		'\u0669': '9', // Arabic-indic digit 9
		'\u06F0': '0', // Eastern-Arabic digit 0
		'\u06F1': '1', // Eastern-Arabic digit 1
		'\u06F2': '2', // Eastern-Arabic digit 2
		'\u06F3': '3', // Eastern-Arabic digit 3
		'\u06F4': '4', // Eastern-Arabic digit 4
		'\u06F5': '5', // Eastern-Arabic digit 5
		'\u06F6': '6', // Eastern-Arabic digit 6
		'\u06F7': '7', // Eastern-Arabic digit 7
		'\u06F8': '8', // Eastern-Arabic digit 8
		'\u06F9': '9' // Eastern-Arabic digit 9
	};
	//# sourceMappingURL=parse digit.js.map

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(82);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(225);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(66);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _inputController = __webpack_require__(413);
	
	var _inputController2 = _interopRequireDefault(_inputController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Usage:
	//
	// <ReactInput
	// 	value={this.state.phone}
	// 	onChange={phone => this.setState({ phone })}
	// 	parse={character => character}
	// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
	//
	var ReactInput = function (_React$Component) {
		(0, _inherits3.default)(ReactInput, _React$Component);
	
		function ReactInput(props) {
			(0, _classCallCheck3.default)(this, ReactInput);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, (ReactInput.__proto__ || (0, _getPrototypeOf2.default)(ReactInput)).call(this, props));
	
			_this.store_instance = function (instance) {
				_this.input = instance;
			};
	
			_this.get_input_element = function () {
				return _reactDom2.default.findDOMNode(_this.input);
			};
	
			_this.on_blur = function (event) {
				var onBlur = _this.props.onBlur;
	
				// This `onBlur` interceptor is a workaround for `redux-form`,
				// so that it gets the right (parsed, not the formatted one)
				// `event.target.value` in its `onBlur` handler.
	
				if (onBlur) {
					var _event = (0, _extends3.default)({}, event, {
						target: (0, _extends3.default)({}, event.target, {
							value: _this.input_controller.getParsedValue().value
						})
					});
	
					// For `redux-form` event detection.
					// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
					_event.stopPropagation = event.stopPropagation;
					_event.preventDefault = event.preventDefault;
	
					onBlur(_event);
				}
			};
	
			_this.on_key_down = function (event) {
				var onKeyDown = _this.props.onKeyDown;
	
	
				if (onKeyDown) {
					onKeyDown(event);
				}
	
				_this.input_controller.onKeyDown(event);
			};
	
			var _this$props = _this.props,
			    parse = _this$props.parse,
			    format = _this$props.format,
			    onChange = _this$props.onChange;
	
	
			_this.input_controller = new _inputController2.default(_this.get_input_element, parse, format, onChange);
			return _this;
		}
	
		(0, _createClass3.default)(ReactInput, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    value = _props.value,
				    parse = _props.parse,
				    format = _props.format,
				    inputComponent = _props.inputComponent,
				    rest = (0, _objectWithoutProperties3.default)(_props, ['value', 'parse', 'format', 'inputComponent']);
	
				// Non-string `inputComponent`s would work in this case
				// but it would also introduce a caret reset bug:
				// the caret position would reset on each input.
				// The origins of this bug are unknown, they may be
				// somehow related to the `ref` property
				// being intercepted by React here.
	
				return _react2.default.createElement(inputComponent, (0, _extends3.default)({}, rest, {
					ref: this.store_instance,
					value: format(is_empty(value) ? '' : value).text,
					onKeyDown: this.on_key_down,
					onChange: this.input_controller.onChange,
					onPaste: this.input_controller.onPaste,
					onCut: this.input_controller.onCut,
					onBlur: this.on_blur
				}));
			}
	
			// Returns <input/> DOM Element
	
	
			// This handler is a workaround for `redux-form`
	
		}, {
			key: 'focus',
			value: function focus() {
				this.get_input_element().focus();
			}
		}]);
		return ReactInput;
	}(_react2.default.Component);
	
	ReactInput.propTypes = {
		// Parses a single characher of `<input/>` text
		parse: _propTypes2.default.func.isRequired,
	
		// Formats `value` into `<input/>` text
		format: _propTypes2.default.func.isRequired,
	
		// Renders `<input/>` by default
		inputComponent: _propTypes2.default.string.isRequired,
	
		// `<input/>` `type` attribute
		type: _propTypes2.default.string.isRequired,
	
		// Is parsed from <input/> text
		value: _propTypes2.default.string,
	
		// This handler is called each time `<input/>` text is changed
		onChange: _propTypes2.default.func.isRequired,
	
		// This `onBlur` interceptor is a workaround for `redux-form`,
		// so that it gets the parsed `value` in its `onBlur` handler,
		// not the formatted text.
		onBlur: _propTypes2.default.func,
	
		// Passthrough
		onKeyDown: _propTypes2.default.func
	};
	ReactInput.defaultProps = {
		// Renders `<input/>` by default
		inputComponent: 'input',
	
		// `<input/>` `type` attribute
		type: 'text'
	};
	exports.default = ReactInput;
	
	
	function is_empty(value) {
		return value === undefined || value === null;
	}
	//# sourceMappingURL=react input.js.map

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = template_parser;
	
	var _helpers = __webpack_require__(246);
	
	function template_parser(template, placeholder, parse) {
		if (typeof placeholder === 'function') {
			parse = placeholder;
			placeholder = 'x';
		}
	
		var max_characters = (0, _helpers.count_occurences)(placeholder, template);
	
		return function parse_character(character, value) {
			if (value.length >= max_characters) {
				return;
			}
	
			return parse(character, value);
		};
	}
	//# sourceMappingURL=template parser.js.map

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	exports = module.exports = {}
	
	exports.InputController = __webpack_require__(413).default
	exports.ReactInput = __webpack_require__(1004).default
	exports.templateParser = __webpack_require__(1005).default
	exports.templateFormatter = __webpack_require__(415).default
	exports.parseDigit = __webpack_require__(1003).default
	exports.parse = __webpack_require__(414).default
	exports.format = __webpack_require__(412).default
	
	// exports['default'] = ...

/***/ },
/* 1007 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	!(function() {
	  function jss(blocks) {
	    var css = [];
	    for (var block in blocks)
	      css.push(createStyleBlock(block, blocks[block]));
	    injectCSS(css);
	  }
	
	  function createStyleBlock(selector, rules) {
	    return selector + ' {\n' + parseRules(rules) + '\n}';
	  }
	
	  function parseRules(rules) {
	    var css = [];
	    for (var rule in rules)
	      css.push('  '+rule+': '+rules[rule]+';');
	    return css.join('\n');
	  }
	
	  function injectCSS(css) {
	    var style = document.getElementById('jss-styles');
	    if (!style) {
	      style = document.createElement('style');
	      style.setAttribute('id', 'jss-styles');
	      var head = document.getElementsByTagName('head')[0];
	      head.insertBefore(style, head.firstChild);
	    }
	    var node = document.createTextNode(css.join('\n\n'));
	    style.appendChild(node);
	  }
	
	  if (true)
	    module.exports = jss;
	  else
	    window.jss = jss;
	
	})();
	


/***/ },
/* 1009 */
/***/ function(module, exports) {

	module.exports = {
		"AED": {
			"code": "AED",
			"symbol": "د.إ.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"AFN": {
			"code": "AFN",
			"symbol": "؋",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ALL": {
			"code": "ALL",
			"symbol": "Lek",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AMD": {
			"code": "AMD",
			"symbol": "֏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ANG": {
			"code": "ANG",
			"symbol": "ƒ",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AOA": {
			"code": "AOA",
			"symbol": "Kz",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ARS": {
			"code": "ARS",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"AUD": {
			"code": "AUD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AWG": {
			"code": "AWG",
			"symbol": "ƒ",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AZN": {
			"code": "AZN",
			"symbol": "₼",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BAM": {
			"code": "BAM",
			"symbol": "КМ",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BBD": {
			"code": "BBD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BDT": {
			"code": "BDT",
			"symbol": "৳",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 0
		},
		"BGN": {
			"code": "BGN",
			"symbol": "лв.",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BHD": {
			"code": "BHD",
			"symbol": "د.ب.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"BIF": {
			"code": "BIF",
			"symbol": "FBu",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"BMD": {
			"code": "BMD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BND": {
			"code": "BND",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"BOB": {
			"code": "BOB",
			"symbol": "Bs",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BRL": {
			"code": "BRL",
			"symbol": "R$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BSD": {
			"code": "BSD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BTC": {
			"code": "BTC",
			"symbol": "Ƀ",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BTN": {
			"code": "BTN",
			"symbol": "Nu.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 1
		},
		"BWP": {
			"code": "BWP",
			"symbol": "P",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BYR": {
			"code": "BYR",
			"symbol": "р.",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BZD": {
			"code": "BZD",
			"symbol": "BZ$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CAD": {
			"code": "CAD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CDF": {
			"code": "CDF",
			"symbol": "FC",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CHF": {
			"code": "CHF",
			"symbol": "CHF",
			"thousandsSeparator": "'",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"CLP": {
			"code": "CLP",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"CNY": {
			"code": "CNY",
			"symbol": "¥",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"COP": {
			"code": "COP",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"CRC": {
			"code": "CRC",
			"symbol": "₡",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CUC": {
			"code": "CUC",
			"symbol": "CUC",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CUP": {
			"code": "CUP",
			"symbol": "$MN",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CVE": {
			"code": "CVE",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CZK": {
			"code": "CZK",
			"symbol": "Kč",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"DJF": {
			"code": "DJF",
			"symbol": "Fdj",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"DKK": {
			"code": "DKK",
			"symbol": "kr.",
			"thousandsSeparator": "",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"DOP": {
			"code": "DOP",
			"symbol": "RD$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"DZD": {
			"code": "DZD",
			"symbol": "د.ج.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"EGP": {
			"code": "EGP",
			"symbol": "ج.م.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ERN": {
			"code": "ERN",
			"symbol": "Nfk",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ETB": {
			"code": "ETB",
			"symbol": "ETB",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"EUR": {
			"code": "EUR",
			"symbol": "€",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"FJD": {
			"code": "FJD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"FKP": {
			"code": "FKP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GBP": {
			"code": "GBP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GEL": {
			"code": "GEL",
			"symbol": "Lari",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"GHS": {
			"code": "GHS",
			"symbol": "₵",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GIP": {
			"code": "GIP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GMD": {
			"code": "GMD",
			"symbol": "D",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GNF": {
			"code": "GNF",
			"symbol": "FG",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"GTQ": {
			"code": "GTQ",
			"symbol": "Q",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GYD": {
			"code": "GYD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"HKD": {
			"code": "HKD",
			"symbol": "HK$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"HNL": {
			"code": "HNL",
			"symbol": "L.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"HRK": {
			"code": "HRK",
			"symbol": "kn",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"HTG": {
			"code": "HTG",
			"symbol": "G",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"HUF": {
			"code": "HUF",
			"symbol": "Ft",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"IDR": {
			"code": "IDR",
			"symbol": "Rp",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"ILS": {
			"code": "ILS",
			"symbol": "₪",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"INR": {
			"code": "INR",
			"symbol": "₹",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"IQD": {
			"code": "IQD",
			"symbol": "د.ع.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"IRR": {
			"code": "IRR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": "/",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ISK": {
			"code": "ISK",
			"symbol": "kr.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 0
		},
		"JMD": {
			"code": "JMD",
			"symbol": "J$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"JOD": {
			"code": "JOD",
			"symbol": "د.ا.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"JPY": {
			"code": "JPY",
			"symbol": "¥",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KES": {
			"code": "KES",
			"symbol": "S",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"KGS": {
			"code": "KGS",
			"symbol": "сом",
			"thousandsSeparator": " ",
			"decimalSeparator": "-",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"KHR": {
			"code": "KHR",
			"symbol": "៛",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KMF": {
			"code": "KMF",
			"symbol": "CF",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"KPW": {
			"code": "KPW",
			"symbol": "₩",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KRW": {
			"code": "KRW",
			"symbol": "₩",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KWD": {
			"code": "KWD",
			"symbol": "د.ك.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"KYD": {
			"code": "KYD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"KZT": {
			"code": "KZT",
			"symbol": "₸",
			"thousandsSeparator": " ",
			"decimalSeparator": "-",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"LAK": {
			"code": "LAK",
			"symbol": "₭",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"LBP": {
			"code": "LBP",
			"symbol": "ل.ل.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"LKR": {
			"code": "LKR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 0
		},
		"LRD": {
			"code": "LRD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"LSL": {
			"code": "LSL",
			"symbol": "M",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"LYD": {
			"code": "LYD",
			"symbol": "د.ل.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 3
		},
		"MAD": {
			"code": "MAD",
			"symbol": "د.م.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"MDL": {
			"code": "MDL",
			"symbol": "lei",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"MGA": {
			"code": "MGA",
			"symbol": "Ar",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"MKD": {
			"code": "MKD",
			"symbol": "ден.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"MMK": {
			"code": "MMK",
			"symbol": "K",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MNT": {
			"code": "MNT",
			"symbol": "₮",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MOP": {
			"code": "MOP",
			"symbol": "MOP$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MRO": {
			"code": "MRO",
			"symbol": "UM",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MTL": {
			"code": "MTL",
			"symbol": "₤",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MUR": {
			"code": "MUR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MVR": {
			"code": "MVR",
			"symbol": "MVR",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 1
		},
		"MWK": {
			"code": "MWK",
			"symbol": "MK",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MXN": {
			"code": "MXN",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MYR": {
			"code": "MYR",
			"symbol": "RM",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MZN": {
			"code": "MZN",
			"symbol": "MT",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"NAD": {
			"code": "NAD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"NGN": {
			"code": "NGN",
			"symbol": "₦",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"NIO": {
			"code": "NIO",
			"symbol": "C$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"NOK": {
			"code": "NOK",
			"symbol": "kr",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"NPR": {
			"code": "NPR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"NZD": {
			"code": "NZD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"OMR": {
			"code": "OMR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"PAB": {
			"code": "PAB",
			"symbol": "B/.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"PEN": {
			"code": "PEN",
			"symbol": "S/.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"PGK": {
			"code": "PGK",
			"symbol": "K",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"PHP": {
			"code": "PHP",
			"symbol": "₱",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"PKR": {
			"code": "PKR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"PLN": {
			"code": "PLN",
			"symbol": "zł",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"PYG": {
			"code": "PYG",
			"symbol": "₲",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"QAR": {
			"code": "QAR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RON": {
			"code": "RON",
			"symbol": "lei",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RSD": {
			"code": "RSD",
			"symbol": "Дин.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RUB": {
			"code": "RUB",
			"symbol": "₽",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RWF": {
			"code": "RWF",
			"symbol": "RWF",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SAR": {
			"code": "SAR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SBD": {
			"code": "SBD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SCR": {
			"code": "SCR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SDD": {
			"code": "SDD",
			"symbol": "LSd",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SDG": {
			"code": "SDG",
			"symbol": "£‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SEK": {
			"code": "SEK",
			"symbol": "kr",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SGD": {
			"code": "SGD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SHP": {
			"code": "SHP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SLL": {
			"code": "SLL",
			"symbol": "Le",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SOS": {
			"code": "SOS",
			"symbol": "S",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SRD": {
			"code": "SRD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"STD": {
			"code": "STD",
			"symbol": "Db",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SVC": {
			"code": "SVC",
			"symbol": "₡",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SYP": {
			"code": "SYP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SZL": {
			"code": "SZL",
			"symbol": "E",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"THB": {
			"code": "THB",
			"symbol": "฿",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TJS": {
			"code": "TJS",
			"symbol": "TJS",
			"thousandsSeparator": " ",
			"decimalSeparator": ";",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"TMT": {
			"code": "TMT",
			"symbol": "m",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"TND": {
			"code": "TND",
			"symbol": "د.ت.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"TOP": {
			"code": "TOP",
			"symbol": "T$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TRY": {
			"code": "TRY",
			"symbol": "TL",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"TTD": {
			"code": "TTD",
			"symbol": "TT$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TVD": {
			"code": "TVD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TWD": {
			"code": "TWD",
			"symbol": "NT$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TZS": {
			"code": "TZS",
			"symbol": "TSh",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"UAH": {
			"code": "UAH",
			"symbol": "₴",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"UGX": {
			"code": "UGX",
			"symbol": "USh",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"USD": {
			"code": "USD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"UYU": {
			"code": "UYU",
			"symbol": "$U",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"UZS": {
			"code": "UZS",
			"symbol": "сўм",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"VEB": {
			"code": "VEB",
			"symbol": "Bs.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"VEF": {
			"code": "VEF",
			"symbol": "Bs. F.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"VND": {
			"code": "VND",
			"symbol": "₫",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 1
		},
		"VUV": {
			"code": "VUV",
			"symbol": "VT",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"WST": {
			"code": "WST",
			"symbol": "WS$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XAF": {
			"code": "XAF",
			"symbol": "F",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XCD": {
			"code": "XCD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XOF": {
			"code": "XOF",
			"symbol": "F",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XPF": {
			"code": "XPF",
			"symbol": "F",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"YER": {
			"code": "YER",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ZAR": {
			"code": "ZAR",
			"symbol": "R",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ZMW": {
			"code": "ZMW",
			"symbol": "ZK",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"WON": {
			"code": "WON",
			"symbol": "₩",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		}
	};

/***/ },
/* 1010 */
/***/ function(module, exports) {

	module.exports = {
		"de-AT": {
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"el-GR": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		},
		"en-IE": {
			"symbolOnLeft": true,
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"es-ES": {
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"it-IT": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		},
		"nl-NL": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		},
		"nl-BE": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		}
	};

/***/ },
/* 1011 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2017c",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
			"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|01213454545454545454545454545454545454545454545454543|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
			"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
			"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0",
			"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0",
			"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0",
			"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0",
			"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
			"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0",
			"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0",
			"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
			"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
			"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
			"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
			"Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
			"Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|-02|20|0||30",
			"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"EST|EST|50|0|",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Etc/GMT+0|GMT|0|0|",
			"Etc/GMT+1|-01|10|0|",
			"Etc/GMT+10|-10|a0|0|",
			"Etc/GMT+11|-11|b0|0|",
			"Etc/GMT+12|-12|c0|0|",
			"Etc/GMT+3|-03|30|0|",
			"Etc/GMT+4|-04|40|0|",
			"Etc/GMT+5|-05|50|0|",
			"Etc/GMT+6|-06|60|0|",
			"Etc/GMT+7|-07|70|0|",
			"Etc/GMT+8|-08|80|0|",
			"Etc/GMT+9|-09|90|0|",
			"Etc/GMT-1|+01|-10|0|",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Pacific/Pohnpei|+11|-b0|0||34e3",
			"Pacific/Tarawa|+12|-c0|0||29e3",
			"Etc/GMT-13|+13|-d0|0|",
			"Etc/GMT-14|+14|-e0|0|",
			"Etc/GMT-2|+02|-20|0|",
			"Etc/GMT-3|+03|-30|0|",
			"Etc/GMT-4|+04|-40|0|",
			"Etc/GMT-5|+05|-50|0|",
			"Etc/GMT-6|+06|-60|0|",
			"Indian/Christmas|+07|-70|0||21e2",
			"Etc/GMT-8|+08|-80|0|",
			"Pacific/Palau|+09|-90|0||21e3",
			"Etc/UCT|UCT|0|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0|",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Cocos|+0630|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"MST|MST|70|0|",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1",
			"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
			"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
			"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2",
			"Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2",
			"Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
			"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
			"Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
			"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Sao_Tome",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Atlantic/South_Georgia|Etc/GMT+2",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT+0|Etc/GMT",
			"Etc/GMT+0|Etc/GMT-0",
			"Etc/GMT+0|Etc/GMT0",
			"Etc/GMT+0|Etc/Greenwich",
			"Etc/GMT+0|GMT",
			"Etc/GMT+0|GMT+0",
			"Etc/GMT+0|GMT-0",
			"Etc/GMT+0|GMT0",
			"Etc/GMT+0|Greenwich",
			"Etc/UCT|UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Christmas|Etc/GMT-7",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Palau|Etc/GMT-9",
			"Pacific/Pohnpei|Etc/GMT-11",
			"Pacific/Pohnpei|Pacific/Ponape",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Port_Moresby|Pacific/Chuuk",
			"Pacific/Port_Moresby|Pacific/Truk",
			"Pacific/Port_Moresby|Pacific/Yap",
			"Pacific/Tarawa|Etc/GMT-12",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		]
	};

/***/ },
/* 1012 */
/***/ function(module, exports) {

	module.exports = [
		[
			"af",
			"Afghanistan (‫افغانستان‬‎)"
		],
		[
			"ax",
			"Åland Islands"
		],
		[
			"al",
			"Albania (Shqipëri)"
		],
		[
			"dz",
			"Algeria (‫الجزائر‬‎)"
		],
		[
			"as",
			"American Samoa (Amerika Sāmoa)"
		],
		[
			"ad",
			"Andorra"
		],
		[
			"ao",
			"Angola"
		],
		[
			"ai",
			"Anguilla"
		],
		[
			"ag",
			"Antigua and Barbuda"
		],
		[
			"ar",
			"Argentina"
		],
		[
			"am",
			"Armenia (Հայաստան)"
		],
		[
			"aw",
			"Aruba"
		],
		[
			"au",
			"Australia"
		],
		[
			"at",
			"Austria (Österreich)"
		],
		[
			"az",
			"Azerbaijan (Azərbaycan)"
		],
		[
			"bs",
			"Bahamas"
		],
		[
			"bh",
			"Bahrain (‫البحرين‬‎)"
		],
		[
			"bd",
			"Bangladesh (বাংলাদেশ)"
		],
		[
			"bb",
			"Barbados"
		],
		[
			"by",
			"Belarus (Беларусь)"
		],
		[
			"be",
			"Belgium (België)"
		],
		[
			"bz",
			"Belize"
		],
		[
			"bj",
			"Benin (Bénin)"
		],
		[
			"bm",
			"Bermuda"
		],
		[
			"bt",
			"Bhutan (འབྲུག)"
		],
		[
			"bo",
			"Bolivia"
		],
		[
			"ba",
			"Bosnia and Herzegovina"
		],
		[
			"bw",
			"Botswana"
		],
		[
			"br",
			"Brazil (Brasil)"
		],
		[
			"io",
			"British Indian Ocean Territory"
		],
		[
			"vg",
			"British Virgin Islands"
		],
		[
			"bn",
			"Brunei (Negara Brunei Darussalam)"
		],
		[
			"bg",
			"Bulgaria (България)"
		],
		[
			"bf",
			"Burkina Faso"
		],
		[
			"bi",
			"Burundi (Uburundi)"
		],
		[
			"kh",
			"Cambodia (កម្ពុជា)"
		],
		[
			"cm",
			"Cameroon (Cameroun)"
		],
		[
			"ca",
			"Canada"
		],
		[
			"cv",
			"Cape Verde (Kabu Verdi)"
		],
		[
			"bq",
			"Caribbean Netherlands"
		],
		[
			"ky",
			"Cayman Islands"
		],
		[
			"cf",
			"Central African Republic"
		],
		[
			"td",
			"Chad (Tchad)"
		],
		[
			"cl",
			"Chile"
		],
		[
			"cn",
			"China (中国)"
		],
		[
			"cx",
			"Christmas Island"
		],
		[
			"cc",
			"Cocos (Keeling) Islands"
		],
		[
			"co",
			"Colombia"
		],
		[
			"km",
			"Comoros (‫جزر القمر‬‎)"
		],
		[
			"cd",
			"Congo (DRC) (Kongo)"
		],
		[
			"cg",
			"Congo (Republic) (Congo-Brazzaville)"
		],
		[
			"ck",
			"Cook Islands"
		],
		[
			"cr",
			"Costa Rica"
		],
		[
			"ci",
			"Côte d’Ivoire"
		],
		[
			"hr",
			"Croatia (Hrvatska)"
		],
		[
			"cu",
			"Cuba"
		],
		[
			"cw",
			"Curaçao"
		],
		[
			"cy",
			"Cyprus (Κύπρος)"
		],
		[
			"cz",
			"Czech Republic (Česká republika)"
		],
		[
			"dk",
			"Denmark (Danmark)"
		],
		[
			"dj",
			"Djibouti"
		],
		[
			"dm",
			"Dominica"
		],
		[
			"do",
			"Dominican Republic"
		],
		[
			"ec",
			"Ecuador"
		],
		[
			"eg",
			"Egypt (‫مصر‬‎)"
		],
		[
			"sv",
			"El Salvador"
		],
		[
			"gq",
			"Equatorial Guinea (Guinea Ecuatorial)"
		],
		[
			"er",
			"Eritrea"
		],
		[
			"ee",
			"Estonia (Eesti)"
		],
		[
			"et",
			"Ethiopia"
		],
		[
			"fk",
			"Falkland Islands (Islas Malvinas)"
		],
		[
			"fo",
			"Faroe Islands (Føroyar)"
		],
		[
			"fj",
			"Fiji (Matanitu Tugalala o Viti)"
		],
		[
			"fi",
			"Finland (Suomi)"
		],
		[
			"fr",
			"France (République française)"
		],
		[
			"gf",
			"French Guiana (Guyane française)"
		],
		[
			"pf",
			"French Polynesia (Polynésie française)"
		],
		[
			"ga",
			"Gabon (République gabonaise)"
		],
		[
			"gm",
			"Gambia"
		],
		[
			"ge",
			"Georgia (საქართველო)"
		],
		[
			"de",
			"Germany (Deutschland)"
		],
		[
			"gh",
			"Ghana (Gaana)"
		],
		[
			"gi",
			"Gibraltar"
		],
		[
			"gr",
			"Greece (Ελλάδα)"
		],
		[
			"gl",
			"Greenland (Kalaallit Nunaat)"
		],
		[
			"gd",
			"Grenada"
		],
		[
			"gp",
			"Guadeloupe"
		],
		[
			"gu",
			"Guam (Guåhån)"
		],
		[
			"gt",
			"Guatemala"
		],
		[
			"gg",
			"Guernsey"
		],
		[
			"gn",
			"Guinea (Guinée)"
		],
		[
			"gw",
			"Guinea-Bissau (Guiné Bissau)"
		],
		[
			"gy",
			"Guyana"
		],
		[
			"ht",
			"Haiti (République d'Haïti)"
		],
		[
			"hn",
			"Honduras"
		],
		[
			"hk",
			"Hong Kong (香港)"
		],
		[
			"hu",
			"Hungary (Magyarország)"
		],
		[
			"is",
			"Iceland (Ísland)"
		],
		[
			"in",
			"India (भारत)"
		],
		[
			"id",
			"Indonesia"
		],
		[
			"ir",
			"Iran (‫ایران‬‎)"
		],
		[
			"iq",
			"Iraq (‫العراق‬‎)"
		],
		[
			"ie",
			"Ireland"
		],
		[
			"im",
			"Isle of Man"
		],
		[
			"il",
			"Israel (‫ישראל‬‎)"
		],
		[
			"it",
			"Italy (Italia)"
		],
		[
			"jm",
			"Jamaica"
		],
		[
			"jp",
			"Japan (日本)"
		],
		[
			"je",
			"Jersey"
		],
		[
			"jo",
			"Jordan (‫الأردن‬‎)"
		],
		[
			"kz",
			"Kazakhstan (Казахстан)"
		],
		[
			"ke",
			"Kenya"
		],
		[
			"ki",
			"Kiribati"
		],
		[
			"kw",
			"Kuwait (‫الكويت‬‎)"
		],
		[
			"kg",
			"Kyrgyzstan (Кыргызстан)"
		],
		[
			"la",
			"Laos (ລາວ)"
		],
		[
			"lv",
			"Latvia (Latvija)"
		],
		[
			"lb",
			"Lebanon (‫لبنان‬‎)"
		],
		[
			"ls",
			"Lesotho"
		],
		[
			"lr",
			"Liberia"
		],
		[
			"ly",
			"Libya (‫ليبيا‬‎)"
		],
		[
			"li",
			"Liechtenstein"
		],
		[
			"lt",
			"Lithuania (Lietuva)"
		],
		[
			"lu",
			"Luxembourg (Lëtzebuerg)"
		],
		[
			"mo",
			"Macau (澳門)"
		],
		[
			"mk",
			"Macedonia (FYROM) (Македонија)"
		],
		[
			"mg",
			"Madagascar (Madagasikara)"
		],
		[
			"mw",
			"Malawi (Malaŵi)"
		],
		[
			"my",
			"Malaysia"
		],
		[
			"mv",
			"Maldives"
		],
		[
			"ml",
			"Mali"
		],
		[
			"mt",
			"Malta"
		],
		[
			"mh",
			"Marshall Islands"
		],
		[
			"mq",
			"Martinique"
		],
		[
			"mr",
			"Mauritania (‫موريتانيا‬‎)"
		],
		[
			"mu",
			"Mauritius (Moris)"
		],
		[
			"yt",
			"Mayotte"
		],
		[
			"mx",
			"Mexico (México)"
		],
		[
			"fm",
			"Micronesia"
		],
		[
			"md",
			"Moldova (Republica Moldova)"
		],
		[
			"mc",
			"Monaco"
		],
		[
			"mn",
			"Mongolia (Монгол)"
		],
		[
			"me",
			"Montenegro (Crna Gora)"
		],
		[
			"ms",
			"Montserrat"
		],
		[
			"ma",
			"Morocco (‫المغرب‬‎)"
		],
		[
			"mz",
			"Mozambique (Moçambique)"
		],
		[
			"mm",
			"Myanmar (Burma) (မြန်မာ)"
		],
		[
			"na",
			"Namibia (Namibië)"
		],
		[
			"nr",
			"Nauru (Repubrikin Naoero)"
		],
		[
			"np",
			"Nepal (नेपाल)"
		],
		[
			"nl",
			"Netherlands (Nederland)"
		],
		[
			"nc",
			"New Caledonia (Nouvelle-Calédonie)"
		],
		[
			"nz",
			"New Zealand"
		],
		[
			"ni",
			"Nicaragua"
		],
		[
			"ne",
			"Niger (Nijar)"
		],
		[
			"ng",
			"Nigeria"
		],
		[
			"nu",
			"Niue (Niuē)"
		],
		[
			"nf",
			"Norfolk Island"
		],
		[
			"kp",
			"North Korea (조선 민주주의 인민 공화국)"
		],
		[
			"mp",
			"Northern Mariana Islands"
		],
		[
			"no",
			"Norway (Norge)"
		],
		[
			"om",
			"Oman (‫عُمان‬‎)"
		],
		[
			"pk",
			"Pakistan (‫پاکستان‬‎)"
		],
		[
			"pw",
			"Palau (Beluu er a Belau)"
		],
		[
			"ps",
			"Palestine (‫فلسطين‬‎)"
		],
		[
			"pa",
			"Panama (Panamá)"
		],
		[
			"pg",
			"Papua New Guinea"
		],
		[
			"py",
			"Paraguay (Tetã Paraguái)"
		],
		[
			"pe",
			"Peru (Perú)"
		],
		[
			"ph",
			"Philippines (Republika ng Pilipinas)"
		],
		[
			"pl",
			"Poland (Polska)"
		],
		[
			"pt",
			"Portugal (República Portuguesa)"
		],
		[
			"pr",
			"Puerto Rico"
		],
		[
			"qa",
			"Qatar (‫قطر‬‎)"
		],
		[
			"re",
			"Réunion (La Réunion)"
		],
		[
			"ro",
			"Romania (România)"
		],
		[
			"ru",
			"Russia (Россия)"
		],
		[
			"rw",
			"Rwanda"
		],
		[
			"bl",
			"Saint Barthélemy (Saint-Barthélemy)"
		],
		[
			"sh",
			"Saint Helena"
		],
		[
			"kn",
			"Saint Kitts and Nevis"
		],
		[
			"lc",
			"Saint Lucia"
		],
		[
			"mf",
			"Saint Martin (Saint-Martin)"
		],
		[
			"pm",
			"Saint Pierre and Miquelon"
		],
		[
			"vc",
			"Saint Vincent and the Grenadines"
		],
		[
			"ws",
			"Samoa (Sāmoa)"
		],
		[
			"sm",
			"San Marino"
		],
		[
			"st",
			"São Tomé and Príncipe"
		],
		[
			"sa",
			"Saudi Arabia (‫المملكة العربية السعودية‬‎)"
		],
		[
			"sn",
			"Senegal (Sénégal)"
		],
		[
			"rs",
			"Serbia (Србија)"
		],
		[
			"sc",
			"Seychelles (Repiblik Sesel)"
		],
		[
			"sl",
			"Sierra Leone"
		],
		[
			"sg",
			"Singapore (Singapura) (新加坡共和国)"
		],
		[
			"sx",
			"Sint Maarten"
		],
		[
			"sk",
			"Slovakia (Slovensko)"
		],
		[
			"si",
			"Slovenia (Slovenija)"
		],
		[
			"sb",
			"Solomon Islands"
		],
		[
			"so",
			"Somalia (Soomaaliya)"
		],
		[
			"za",
			"South Africa"
		],
		[
			"kr",
			"South Korea (대한민국)"
		],
		[
			"ss",
			"South Sudan (‫جنوب السودان‬‎)"
		],
		[
			"es",
			"Spain (España)"
		],
		[
			"lk",
			"Sri Lanka (ශ්‍රී ලංකාව)"
		],
		[
			"sd",
			"Sudan (‫السودان‬‎)"
		],
		[
			"sr",
			"Suriname"
		],
		[
			"sj",
			"Svalbard and Jan Mayen"
		],
		[
			"sz",
			"Swaziland (Umbuso weSwatini)"
		],
		[
			"se",
			"Sweden (Sverige)"
		],
		[
			"ch",
			"Switzerland (Schweiz)"
		],
		[
			"sy",
			"Syria (‫سوريا‬‎)"
		],
		[
			"tw",
			"Taiwan (台灣)"
		],
		[
			"tj",
			"Tajikistan (Ҷумҳурии Тоҷикистон)"
		],
		[
			"tz",
			"Tanzania"
		],
		[
			"th",
			"Thailand (ไทย)"
		],
		[
			"tl",
			"Timor-Leste (Timór-Leste)"
		],
		[
			"tg",
			"Togo (République togolaise)"
		],
		[
			"tk",
			"Tokelau"
		],
		[
			"to",
			"Tonga"
		],
		[
			"tt",
			"Trinidad and Tobago"
		],
		[
			"tn",
			"Tunisia (‫تونس‬‎)"
		],
		[
			"tr",
			"Turkey (Türkiye)"
		],
		[
			"tm",
			"Turkmenistan (Türkmenistan)"
		],
		[
			"tc",
			"Turks and Caicos Islands"
		],
		[
			"tv",
			"Tuvalu"
		],
		[
			"vi",
			"U.S. Virgin Islands"
		],
		[
			"ug",
			"Uganda"
		],
		[
			"ua",
			"Ukraine (Україна)"
		],
		[
			"ae",
			"United Arab Emirates (‫الإمارات العربية المتحدة‬‎)"
		],
		[
			"gb",
			"United Kingdom"
		],
		[
			"us",
			"United States"
		],
		[
			"uy",
			"Uruguay"
		],
		[
			"uz",
			"Uzbekistan (Oʻzbekiston)"
		],
		[
			"vu",
			"Vanuatu"
		],
		[
			"va",
			"Vatican City (Città del Vaticano)"
		],
		[
			"ve",
			"Venezuela"
		],
		[
			"vn",
			"Vietnam (Việt Nam)"
		],
		[
			"wf",
			"Wallis and Futuna (Wallis-et-Futuna)"
		],
		[
			"eh",
			"Western Sahara (‫الصحراء الغربية‬‎)"
		],
		[
			"ye",
			"Yemen (‫اليمن‬‎)"
		],
		[
			"zm",
			"Zambia"
		],
		[
			"zw",
			"Zimbabwe"
		]
	];

/***/ },
/* 1013 */
/***/ function(module, exports) {

	/**
	 * The code was extracted from:
	 * https://github.com/davidchambers/Base64.js
	 */
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	
	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function polyfill (input) {
	  var str = String(input).replace(/=+$/, '');
	  if (str.length % 4 == 1) {
	    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (
	    // initialize result and counters
	    var bc = 0, bs, buffer, idx = 0, output = '';
	    // get next character
	    buffer = str.charAt(idx++);
	    // character found in table? initialize bit storage and add its ascii value;
	    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	      // and if not first of each 4 characters,
	      // convert the first 8 bits to one ascii character
	      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	  ) {
	    // try to find character in table (0-63, not found => -1)
	    buffer = chars.indexOf(buffer);
	  }
	  return output;
	}
	
	
	module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	var atob = __webpack_require__(1013);
	
	function b64DecodeUnicode(str) {
	  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
	    var code = p.charCodeAt(0).toString(16).toUpperCase();
	    if (code.length < 2) {
	      code = '0' + code;
	    }
	    return '%' + code;
	  }));
	}
	
	module.exports = function(str) {
	  var output = str.replace(/-/g, "+").replace(/_/g, "/");
	  switch (output.length % 4) {
	    case 0:
	      break;
	    case 2:
	      output += "==";
	      break;
	    case 3:
	      output += "=";
	      break;
	    default:
	      throw "Illegal base64url string!";
	  }
	
	  try{
	    return b64DecodeUnicode(output);
	  } catch (err) {
	    return atob(output);
	  }
	};


/***/ },
/* 1015 */
/***/ function(module, exports) {

	function EventEmitter() {
	  var emitter = {};
	  var events = {};
	  
	  emitter.on = function(event, handler, context) {
	    events[event] = events[event] || [];
	    events[event] = events[event].concat({handler: handler, context: context});
	  };
	  
	  emitter.off = function(event, handler, context) {
	    if (!events[event]) { return; }
	    for (var i = 0; i < events[event].length ; i++) {
	      if (events[event][i].handler === handler && events[event][i].context === context) {
	        events[event] = events[event].slice(0, i).concat(events[event].slice(i + 1));
	      }
	    }
	  };
	  
	  emitter.emit = function(event) { 
	    if (!events[event]) { return; }
	    for (var i = 0; i < events[event].length; i++) {
	      events[event][i].handler.apply(events[event][i].context, Array.prototype.slice.call(arguments, 1));
	    }
	  };
	  
	  return emitter;
	}
	
	module.exports = EventEmitter;


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(161);
	
	function EventProcessor(eventsUrl) {
	  var processor = {};
	  var queue = [];
	  var initialFlush = true;
	  
	  processor.enqueue = function(event) {
	    queue.push(event);
	  };
	  
	  processor.flush = function(user, sync) {
	    var maxLength = 2000 - eventsUrl.length;
	    var data = [];
	    
	    if (!user) {
	      if (initialFlush) {
	        console && console.warn && console.warn('Be sure to call `identify` in the LaunchDarkly client: http://docs.launchdarkly.com/docs/running-an-ab-test#include-the-client-side-snippet');
	      }
	      return false;
	    }
	    
	    initialFlush = false;
	    while (maxLength > 0 && queue.length > 0) {
	      var event = queue.pop();
	      event.user = user;
	      maxLength = maxLength - utils.base64URLEncode(JSON.stringify(event)).length;
	      // If we are over the max size, put this one back on the queue
	      // to try in the next round, unless this event alone is larger 
	      // than the limit, in which case, screw it, and try it anyway.
	      if (maxLength < 0 && data.length > 0) {
	        queue.push(event);
	      } else {
	        data.push(event);
	      }
	    }
	    
	    if (data.length > 0) {
	      var src = eventsUrl + '?d=' + utils.base64URLEncode(JSON.stringify(data));
	      //Detect browser support for CORS
	      if ('withCredentials' in new XMLHttpRequest()) {
	        /* supports cross-domain requests */
	        var xhr = new XMLHttpRequest();
	        xhr.open('GET', src, !sync);
	        xhr.send();
	      } else {
	        var img = new Image();
	        img.src = src;
	      }
	    }
	
	    // if the queue is not empty, call settimeout to flush it again 
	    // with a 0 timeout (stack-less recursion)
	    // Or, just recursively call flush_queue with the remaining elements
	    // if we're doing this on unload
	    if (queue.length > 0) {
	      if (sync) {
	        processor.flush(user, sync);
	      }
	      else {
	        setTimeout(function() {
	          processor.flush(user);
	        }, 0);
	      }
	    }
	    return false;
	  };
	  
	  return processor;
	}
	
	module.exports = EventProcessor;


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	var escapeStringRegexp = __webpack_require__(976);
	
	function doesUrlMatch(matcher, href, search, hash) {
	  var canonicalUrl = href.replace(search, '').replace(hash, '');
	  var regex;
	  var testUrl;
	  
	  switch (matcher.kind) {
	  case 'exact':
	    testUrl = href;
	    regex = new RegExp('^' + escapeStringRegexp(matcher.url) + '/?$');
	    break;
	  case 'canonical':
	    testUrl = canonicalUrl;
	    regex = new RegExp('^' + escapeStringRegexp(matcher.url) + '/?$');
	    break;
	  case 'substring':
	    testUrl = canonicalUrl;
	    regex = new RegExp('.*' + escapeStringRegexp(matcher.substring) + '.*$');
	    break;
	  case 'regex':
	    testUrl = canonicalUrl;
	    regex = new RegExp(matcher.pattern);
	    break;
	  default:
	    return false;
	  }
	  return regex.test(testUrl);
	}
	
	function findGoalsForClick(event, clickGoals) {
	  var matches = [];
	  
	  for (var i = 0; i < clickGoals.length; i++) {
	    var target = event.target;
	    var goal = clickGoals[i];
	    var selector = goal.selector;
	    var elements = document.querySelectorAll(selector);
	    while (target && elements.length > 0) {
	      for (var j = 0; j < elements.length; j++) {
	        if (target === elements[j])
	          matches.push(goal);
	      }
	      target = target.parentNode;
	    }
	  }
	  
	  return matches;
	}
	
	function GoalTracker(goals, onEvent) {
	  var tracker = {};
	  var goals = goals;
	  var listenerFn = null;
	  
	  var clickGoals = [];
	  
	  for (var i = 0; i < goals.length; i++) {
	    var goal = goals[i];
	    var urls = goal.urls || [];
	    
	    for (var j = 0; j < urls.length; j++) {
	      if (doesUrlMatch(urls[j], location.href, location.search, location.hash)) {
	        if (goal.kind === 'pageview') {
	          onEvent('pageview', goal);
	        } else {
	          clickGoals.push(goal);
	          onEvent('click_pageview', goal);
	        }
	        break;
	      }
	    }
	  }
	  
	  if (clickGoals.length > 0) {
	    listenerFn = function(event) {
	      var goals = findGoalsForClick(event, clickGoals);
	      for (var i = 0; i < goals.length; i++) {
	        onEvent('click', goals[i]);
	      }
	    };
	
	    document.addEventListener('click', listenerFn);
	  }
	
	  tracker.dispose = function() {
	    document.removeEventListener('click', listenerFn);
	  }
	  
	  return tracker;
	}
	
	module.exports = GoalTracker;


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(161);
	
	function sanitizeUser(u) {
	  var sane = utils.clone(u);
	  if (sane.key) {
	    sane.key = sane.key.toString();
	  }
	  return sane;
	}
	
	function Identity(initialUser, onChange) {
	  var ident = {};
	  var user;
	  
	  ident.setUser = function(u) {
	    user = sanitizeUser(u);
	    onChange(utils.clone(user));
	  };
	  
	  ident.getUser = function() {
	    return utils.clone(user);
	  };
	  
	  if (initialUser) {
	    ident.setUser(initialUser);
	  }
	  
	  return ident;
	}
	
	module.exports = Identity;


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	var utils = __webpack_require__(161);
	
	var json = 'application/json';
	
	function fetchJSON(endpoint, callback) {
	  var xhr = new XMLHttpRequest();
	  
	  xhr.addEventListener('load', function() {
	    if (xhr.status === 200 && xhr.getResponseHeader('Content-type') === json) {
	      callback(null, JSON.parse(xhr.responseText));
	    } else {
	      callback(xhr.statusText);
	    }
	  });
	  
	  xhr.addEventListener('error', function() {
	    callback(xhr.statusText);
	  });
	  
	  xhr.open('GET', endpoint);
	  xhr.send();
	  
	  return xhr;
	}
	
	var flagSettingsRequest;
	var lastFlagSettingsCallback;
	
	function Requestor(baseUrl, environment) {
	  var requestor = {};
	  
	  requestor.fetchFlagSettings = function(user, hash, callback) {
	    var data = utils.base64URLEncode(JSON.stringify(user));
	    var endpoint = [baseUrl, '/sdk/eval/', environment,  '/users/', data, hash ? '?h=' + hash : ''].join('');
	    var cb;
	
	    var wrappedCallback = (function(currentCallback) {
	      return function() {
	        currentCallback.apply(null, arguments);
	        flagSettingsRequest = null;
	        lastFlagSettingsCallback = null;
	      };
	    })(callback);
	    
	
	    if (flagSettingsRequest) {
	      flagSettingsRequest.abort();
	      cb = (function(prevCallback) {
	        return function() {
	          prevCallback && prevCallback.apply(null, arguments);
	          wrappedCallback.apply(null, arguments);
	        };
	      })(lastFlagSettingsCallback);
	    } else {
	      cb = wrappedCallback;
	    }
	
	    lastFlagSettingsCallback = cb;
	    flagSettingsRequest = fetchJSON(endpoint, cb);
	  };
	  
	  requestor.fetchGoals = function(callback) {
	    var endpoint = [baseUrl, '/sdk/goals/', environment].join('');
	    fetchJSON(endpoint, callback);
	  };
	  
	  return requestor;
	}
	
	module.exports = Requestor;


/***/ },
/* 1020 */
/***/ function(module, exports) {

	function Stream(url, environment) {
	  var stream = {};
	  var url = url + '/ping/' + environment;
	  var es = null;
	
	  stream.connect = function(onPing) {
	    if (typeof EventSource !== 'undefined') {
	      es = new window.EventSource(url);
	      es.addEventListener('ping', onPing);
	    }
	  }
	
	  stream.disconnect = function() {
	    es && es.close();
	  }
	
	  stream.isConnected = function() {
	    return es && (es.readyState === EventSource.OPEN || es.readyState === EventSource.CONNECTING);
	  }
	
	  return stream;
	}
	
	module.exports = Stream;


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	var EventProcessor = __webpack_require__(1016);
	var EventEmitter = __webpack_require__(1015);
	var GoalTracker = __webpack_require__(1017);
	var Stream = __webpack_require__(1020);
	var Requestor = __webpack_require__(1019);
	var Identity = __webpack_require__(1018);
	var utils = __webpack_require__(161);
	var messages = __webpack_require__(1022);
	
	var flags = {};
	var environment;
	var events;
	var requestor;
	var stream;
	var emitter;
	var hash;
	var ident;
	var baseUrl;
	var eventsUrl;
	var streamUrl;
	var goalTracker;
	var useLocalStorage;
	var goals;
	
	var readyEvent = 'ready';
	var changeEvent = 'change';
	
	var flushInterval = 2000;
	
	var seenRequests = {};
	
	function sendIdentifyEvent(user) {
	  events.enqueue({
	    kind: 'identify',
	    key: user.key,
	    user: user,
	    creationDate: (new Date()).getTime()
	  });
	}
	
	function sendFlagEvent(key, value, defaultValue) {
	  var user = ident.getUser();
	  var cacheKey = JSON.stringify(value) + (user && user.key ? user.key : '') + key;
	  var now = new Date();
	  var cached = seenRequests[cacheKey];
	
	  if (cached && (now - cached) < 300000 /* five minutes, in ms */) {
	    return;
	  }
	
	  seenRequests[cacheKey] = now;
	
	  events.enqueue({
	    kind: 'feature',
	    key: key,
	    user: user,
	    value: value,
	    'default': defaultValue,
	    creationDate: now.getTime()
	  });
	}
	
	function sendGoalEvent(kind, goal) {
	  var event = {
	    kind: kind,
	    key: goal.key,
	    data: null,
	    url: window.location.href,
	    creationDate: (new Date()).getTime()
	  };
	
	  if (kind === 'click') {
	    event.selector = goal.selector;
	  }
	
	  return events.enqueue(event);
	}
	
	function identify(user, hash, onDone) {
	  ident.setUser(user);
	  requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
	    if (err) {
	      console.warn('Error fetching flag settings: ', err);
	    }
	    if (settings) {
	      updateSettings(settings);
	    }
	    onDone && onDone();
	  });
	}
	
	function variation(key, defaultValue) {
	  var value;
	
	  if (flags && flags.hasOwnProperty(key)) {
	    value = flags[key] === null ? defaultValue : flags[key];
	  } else {
	    value = defaultValue;
	  }
	
	  sendFlagEvent(key, value, defaultValue);
	
	  return value;
	}
	
	function allFlags() {
	  var results = {};
	
	  if (!flags) { return results; }
	
	  for (var key in flags) {
	    if (flags.hasOwnProperty(key)) {
	      results[key] = variation(key, null);
	    }
	  }
	
	  return results;
	}
	
	function customEventExists(key) {
	  if (!goals || goals.length === 0) { return false; }
	
	  for (var i=0 ; i < goals.length ; i++) {
	    if (goals[i].kind === 'custom' && goals[i].key === key) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function track(key, data) {
	  if (typeof key !== 'string') {
	    throw messages.invalidKey();
	  }
	
	  // Validate key if we have goals
	  if (!!goals && !customEventExists(key)) {
	    console.warn(messages.unknownCustomEventKey(key));
	  }
	
	  events.enqueue({
	    kind: 'custom',
	    key: key,
	    data: data,
	    url: window.location.href,
	    creationDate: (new Date()).getTime()
	  });
	}
	
	function connectStream() {
	  stream.connect(function() {
	    requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
	      if (err) {
	        console.warn('Error fetching flag settings: ', err);
	      }      
	      updateSettings(settings);
	    });
	  });
	}
	
	function updateSettings(settings) {
	  var changes;
	  var keys;
	
	  if (!settings) { return; }
	
	  changes = utils.modifications(flags, settings);
	  keys = Object.keys(changes);
	
	  flags = settings;
	
	  if (useLocalStorage) {
	    localStorage.setItem(lsKey(environment, ident.getUser()), JSON.stringify(flags));
	  }
	
	  if (keys.length > 0) {
	    keys.forEach(function(key) {
	      emitter.emit(changeEvent + ':' + key, changes[key].current, changes[key].previous);
	    });
	
	    emitter.emit(changeEvent, changes);
	
	    keys.forEach(function(key) {
	      sendFlagEvent(key, changes[key].current);
	    });
	  }
	}
	
	function on(event, handler, context) {
	  if (event.substr(0, changeEvent.length) === changeEvent) {
	    if (!stream.isConnected()) {
	      connectStream();
	    }
	    emitter.on.apply(emitter, [event, handler, context]);
	  } else {
	    emitter.on.apply(emitter, Array.prototype.slice.call(arguments));
	  }
	}
	
	function off() {
	  emitter.off.apply(emitter, Array.prototype.slice.call(arguments));
	}
	
	function handleMessage(event) {
	  if (event.origin !== baseUrl) { return; }
	  if (event.data.type === 'SYN') {
	    window.editorClientBaseUrl = baseUrl;
	    var editorTag = document.createElement('script');
	    editorTag.type = 'text/javascript';
	    editorTag.async = true;
	    editorTag.src = baseUrl + event.data.editorClientUrl;
	    var s = document.getElementsByTagName('script')[0];
	    s.parentNode.insertBefore(editorTag, s);
	  }
	}
	
	var client = {
	  identify: identify,
	  variation: variation,
	  track: track,
	  on: on,
	  off: off,
	  allFlags: allFlags
	};
	
	function lsKey(env, user) {
	  var uKey = '';
	  if (user && user.key) {
	    uKey = user.key;
	  }
	  return 'ld:' + env + ':' + uKey;
	}
	
	function initialize(env, user, options) {
	  var localStorageKey;
	  options = options || {};
	  environment = env;
	  flags = typeof(options.bootstrap) === 'object' ? options.bootstrap : {};
	  hash = options.hash;
	  baseUrl = options.baseUrl || 'https://app.launchdarkly.com';
	  eventsUrl = options.eventsUrl || 'https://events.launchdarkly.com';
	  streamUrl = options.streamUrl || 'https://clientstream.launchdarkly.com';
	  stream = Stream(streamUrl, environment);
	  events = EventProcessor(eventsUrl + '/a/' + environment + '.gif');
	  emitter = EventEmitter();
	  ident = Identity(user, sendIdentifyEvent);
	  requestor = Requestor(baseUrl, environment);
	  localStorageKey = lsKey(environment, ident.getUser());
	
	  if (typeof options.bootstrap === 'object') {
	    // Emitting the event here will happen before the consumer
	    // can register a listener, so defer to next tick.
	    setTimeout(function() { emitter.emit(readyEvent); }, 0);
	  }
	  else if (typeof(options.bootstrap) === 'string' && options.bootstrap.toUpperCase() === 'LOCALSTORAGE' && typeof(Storage) !== 'undefined') {
	    useLocalStorage = true;
	    // check if localstorage data is corrupted, if so clear it
	    try {
	      flags = JSON.parse(localStorage.getItem(localStorageKey));
	    } catch (error) {
	      localStorage.setItem(localStorageKey, null);
	    }
	
	    if (flags === null) {
	      requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
	        if (err) {
	          console.warn('Error fetching flag settings: ', err);
	        }        
	        flags = settings;
	        settings && localStorage.setItem(localStorageKey, JSON.stringify(flags));
	        emitter.emit(readyEvent);
	      });
	    } else {
	      // We're reading the flags from local storage. Signal that we're ready,
	      // then update localStorage for the next page load. We won't signal changes or update
	      // the in-memory flags unless you subscribe for changes
	      setTimeout(function() { emitter.emit(readyEvent); }, 0);
	      requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
	        if (err) {
	          console.warn('Error fetching flag settings: ', err);
	        }
	        settings && localStorage.setItem(localStorageKey, JSON.stringify(settings));
	      });
	    }
	  }
	  else {
	    requestor.fetchFlagSettings(ident.getUser(), hash, function(err, settings) {
	      if (err) {
	        console.warn('Error fetching flag settings: ', err);
	      }
	      
	      flags = settings;
	      emitter.emit(readyEvent);
	    });
	  }
	
	  requestor.fetchGoals(function(err, g) {
	    if (err) { 
	      console.warn('Error fetching goals: ', err);
	    }
	    if (g && g.length > 0) {
	      goals = g;
	      goalTracker = GoalTracker(goals, sendGoalEvent);
	    }
	  });
	
	  function start() {
	    setTimeout(function tick() {
	      events.flush(ident.getUser());
	      setTimeout(tick, flushInterval);
	    }, flushInterval);
	  }
	
	  if (document.readyState !== 'complete') {
	    window.addEventListener('load', start);
	  } else {
	    start();
	  }
	
	  window.addEventListener('beforeunload', function() {
	    events.flush(ident.getUser(), true);
	  });
	
	  function refreshGoalTracker() {
	    if (goalTracker) {
	      goalTracker.dispose();
	    }
	    if (goals && goals.length) {
	      goalTracker = GoalTracker(goals, sendGoalEvent);
	    }
	  }
	
	  if (goals && goals.length > 0) {
	    if (!!(window.history && history.pushState)) {
	      window.addEventListener('popstate', refreshGoalTracker);
	    } else {
	      window.addEventListener('hashchange', refreshGoalTracker);
	    }
	  }
	
	  window.addEventListener('message', handleMessage);
	
	  return client;
	}
	
	module.exports = {
	  initialize: initialize
	};
	
	if(typeof VERSION !== 'undefined') {
	  module.exports.version = VERSION;
	}


/***/ },
/* 1022 */
/***/ function(module, exports) {

	module.exports ={
	  invalidKey: function() {
	    return 'Event key must be a string';
	  },
	  unknownCustomEventKey: function(key) {
	    return 'Custom event "' + key + '" does not exist'
	  }
	};


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = is_valid;
	
	var _parse = __webpack_require__(110);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _types = __webpack_require__(249);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _metadata = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Checks if a given phone number is valid
	//
	// Example use cases:
	//
	// ```js
	// is_valid('8005553535', 'RU')
	// is_valid('8005553535', 'RU', metadata)
	// is_valid({ phone: '8005553535', country: 'RU' })
	// is_valid({ phone: '8005553535', country: 'RU' }, metadata)
	// is_valid('+78005553535')
	// is_valid('+78005553535', metadata)
	// ```
	//
	function is_valid(arg_1, arg_2, arg_3) {
		var _sort_out_arguments = (0, _types.sort_out_arguments)(arg_1, arg_2, arg_3),
		    input = _sort_out_arguments.input,
		    metadata = _sort_out_arguments.metadata;
	
		if (!input) {
			return false;
		}
	
		if (!input.country) {
			return false;
		}
	
		var country_metadata = metadata.countries[input.country];
	
		if ((0, _metadata.get_types)(country_metadata)) {
			if (!(0, _types2.default)(input, metadata)) {
				return false;
			}
		}
	
		return true;
	}
	//# sourceMappingURL=validate.js.map

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	var custom   = __webpack_require__(418)
	var metadata = __webpack_require__(416)
	
	exports = module.exports = {}
	
	exports.parse = function parse()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.parse.apply(this, parameters)
	}
	
	exports.format = function format()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.format.apply(this, parameters)
	}
	
	exports.getNumberType = function getNumberType()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.getNumberType.apply(this, parameters)
	}
	
	exports.isValidNumber = function isValidNumber()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.isValidNumber.apply(this, parameters)
	}
	
	exports.AsYouType = function AsYouType(country)
	{
		custom.AsYouType.call(this, country, metadata)
	}
	
	exports.AsYouType.prototype = Object.create(custom.AsYouType.prototype, {})
	exports.AsYouType.prototype.constructor = exports.AsYouType
	
	exports.DIGIT_PLACEHOLDER = custom.DIGIT_PLACEHOLDER
	exports.DIGITS            = custom.DIGITS
	
	// camelCase aliases
	// `get_number_type` name is deprecated
	exports.get_number_type = exports.getNumberType
	// `is_valid_number` name is deprecated
	exports.is_valid_number = exports.isValidNumber
	// `as_you_type` name is deprecated
	exports.as_you_type = exports.AsYouType
	// `asYouType` name is deprecated
	exports.asYouType = exports.AsYouType
	
	exports.getPhoneCode = function(country)
	{
		return custom.getPhoneCode(country, metadata)
	}

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	var map = __webpack_require__(1026);
	
	var getCountryCode = function(localeString) {
	    var components = localeString.split("_");
	    if (components.length == 2) {
	        return components.pop();
	    }
	    components = localeString.split("-");
	    if (components.length == 2) {
	        return components.pop();
	    }
	    return localeString;
	}
	
	exports.getCurrency = function(locale) {
	    var countryCode = getCountryCode(locale).toUpperCase();
	    if (countryCode in map) {
	        return map[countryCode];
	    }
	    return null;
	}
	
	exports.getLocales = function(currencyCode) {
	    currencyCode = currencyCode.toUpperCase();
	    var locales = [];
	    for (countryCode in map) {
	        if (map[countryCode] === currencyCode) {
	            locales.push(countryCode);
	        }
	    }
	    return locales;
	}

/***/ },
/* 1026 */
/***/ function(module, exports) {

	// Generated using ShowCurrencies.java
	var map = {
	AD: 'EUR',
	AE: 'AED',
	AF: 'AFN',
	AG: 'XCD',
	AI: 'XCD',
	AL: 'ALL',
	AM: 'AMD',
	AN: 'ANG',
	AO: 'AOA',
	AR: 'ARS',
	AS: 'USD',
	AT: 'EUR',
	AU: 'AUD',
	AW: 'AWG',
	AX: 'EUR',
	AZ: 'AZN',
	BA: 'BAM',
	BB: 'BBD',
	BD: 'BDT',
	BE: 'EUR',
	BF: 'XOF',
	BG: 'BGN',
	BH: 'BHD',
	BI: 'BIF',
	BJ: 'XOF',
	BL: 'EUR',
	BM: 'BMD',
	BN: 'BND',
	BO: 'BOB',
	BQ: 'USD',
	BR: 'BRL',
	BS: 'BSD',
	BT: 'BTN',
	BV: 'NOK',
	BW: 'BWP',
	BY: 'BYR',
	BZ: 'BZD',
	CA: 'CAD',
	CC: 'AUD',
	CD: 'CDF',
	CF: 'XAF',
	CG: 'XAF',
	CH: 'CHF',
	CI: 'XOF',
	CK: 'NZD',
	CL: 'CLP',
	CM: 'XAF',
	CN: 'CNY',
	CO: 'COP',
	CR: 'CRC',
	CU: 'CUP',
	CV: 'CVE',
	CW: 'ANG',
	CX: 'AUD',
	CY: 'EUR',
	CZ: 'CZK',
	DE: 'EUR',
	DJ: 'DJF',
	DK: 'DKK',
	DM: 'XCD',
	DO: 'DOP',
	DZ: 'DZD',
	EC: 'USD',
	EE: 'EUR',
	EG: 'EGP',
	EH: 'MAD',
	ER: 'ERN',
	ES: 'EUR',
	ET: 'ETB',
	FI: 'EUR',
	FJ: 'FJD',
	FK: 'FKP',
	FM: 'USD',
	FO: 'DKK',
	FR: 'EUR',
	GA: 'XAF',
	GB: 'GBP',
	GD: 'XCD',
	GE: 'GEL',
	GF: 'EUR',
	GG: 'GBP',
	GH: 'GHS',
	GI: 'GIP',
	GL: 'DKK',
	GM: 'GMD',
	GN: 'GNF',
	GP: 'EUR',
	GQ: 'XAF',
	GR: 'EUR',
	GS: 'GBP',
	GT: 'GTQ',
	GU: 'USD',
	GW: 'XOF',
	GY: 'GYD',
	HK: 'HKD',
	HM: 'AUD',
	HN: 'HNL',
	HR: 'HRK',
	HT: 'HTG',
	HU: 'HUF',
	ID: 'IDR',
	IE: 'EUR',
	IL: 'ILS',
	IM: 'GBP',
	IN: 'INR',
	IO: 'USD',
	IQ: 'IQD',
	IR: 'IRR',
	IS: 'ISK',
	IT: 'EUR',
	JE: 'GBP',
	JM: 'JMD',
	JO: 'JOD',
	JP: 'JPY',
	KE: 'KES',
	KG: 'KGS',
	KH: 'KHR',
	KI: 'AUD',
	KM: 'KMF',
	KN: 'XCD',
	KP: 'KPW',
	KR: 'KRW',
	KW: 'KWD',
	KY: 'KYD',
	KZ: 'KZT',
	LA: 'LAK',
	LB: 'LBP',
	LC: 'XCD',
	LI: 'CHF',
	LK: 'LKR',
	LR: 'LRD',
	LS: 'LSL',
	LT: 'LTL',
	LU: 'EUR',
	LV: 'LVL',
	LY: 'LYD',
	MA: 'MAD',
	MC: 'EUR',
	MD: 'MDL',
	ME: 'EUR',
	MF: 'EUR',
	MG: 'MGA',
	MH: 'USD',
	MK: 'MKD',
	ML: 'XOF',
	MM: 'MMK',
	MN: 'MNT',
	MO: 'MOP',
	MP: 'USD',
	MQ: 'EUR',
	MR: 'MRO',
	MS: 'XCD',
	MT: 'EUR',
	MU: 'MUR',
	MV: 'MVR',
	MW: 'MWK',
	MX: 'MXN',
	MY: 'MYR',
	MZ: 'MZN',
	NA: 'NAD',
	NC: 'XPF',
	NE: 'XOF',
	NF: 'AUD',
	NG: 'NGN',
	NI: 'NIO',
	NL: 'EUR',
	NO: 'NOK',
	NP: 'NPR',
	NR: 'AUD',
	NU: 'NZD',
	NZ: 'NZD',
	OM: 'OMR',
	PA: 'PAB',
	PE: 'PEN',
	PF: 'XPF',
	PG: 'PGK',
	PH: 'PHP',
	PK: 'PKR',
	PL: 'PLN',
	PM: 'EUR',
	PN: 'NZD',
	PR: 'USD',
	PS: 'ILS',
	PT: 'EUR',
	PW: 'USD',
	PY: 'PYG',
	QA: 'QAR',
	RE: 'EUR',
	RO: 'RON',
	RS: 'RSD',
	RU: 'RUB',
	RW: 'RWF',
	SA: 'SAR',
	SB: 'SBD',
	SC: 'SCR',
	SD: 'SDG',
	SE: 'SEK',
	SG: 'SGD',
	SH: 'SHP',
	SI: 'EUR',
	SJ: 'NOK',
	SK: 'EUR',
	SL: 'SLL',
	SM: 'EUR',
	SN: 'XOF',
	SO: 'SOS',
	SR: 'SRD',
	ST: 'STD',
	SV: 'SVC',
	SX: 'ANG',
	SY: 'SYP',
	SZ: 'SZL',
	TC: 'USD',
	TD: 'XAF',
	TF: 'EUR',
	TG: 'XOF',
	TH: 'THB',
	TJ: 'TJS',
	TK: 'NZD',
	TL: 'USD',
	TM: 'TMT',
	TN: 'TND',
	TO: 'TOP',
	TR: 'TRY',
	TT: 'TTD',
	TV: 'AUD',
	TW: 'TWD',
	TZ: 'TZS',
	UA: 'UAH',
	UG: 'UGX',
	UM: 'USD',
	US: 'USD',
	UY: 'UYU',
	UZ: 'UZS',
	VA: 'EUR',
	VC: 'XCD',
	VE: 'VEF',
	VG: 'USD',
	VI: 'USD',
	VN: 'VND',
	VU: 'VUV',
	WF: 'XPF',
	WS: 'WST',
	YE: 'YER',
	YT: 'EUR',
	ZA: 'ZAR',
	ZM: 'ZMK',
	ZW: 'ZWL'
	};
	
	module.exports = map;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module), (function() { return this; }())))

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(1032);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	var Mexp = __webpack_require__(1030)
	function inc(arr, val) {
		for (var i = 0; i < arr.length; i++) {
			arr[i] += val
		}
		return arr
	}
	var tokens = [
		{ token: 'sin', show: 'sin', type: 0, value: Mexp.math.sin },
		{ token: 'cos', show: 'cos', type: 0, value: Mexp.math.cos },
		{ token: 'tan', show: 'tan', type: 0, value: Mexp.math.tan },
		{ token: 'pi', show: '&pi;', type: 3, value: 'PI' },
		{ token: '(', show: '(', type: 4, value: '(' },
		{ token: ')', show: ')', type: 5, value: ')' },
		{ token: 'P', show: 'P', type: 10, value: Mexp.math.P },
		{ token: 'C', show: 'C', type: 10, value: Mexp.math.C },
		{ token: ' ', show: ' ', type: 14, value: ' '.anchor },
		{ token: 'asin', show: 'asin', type: 0, value: Mexp.math.asin },
		{ token: 'acos', show: 'acos', type: 0, value: Mexp.math.acos },
		{ token: 'atan', show: 'atan', type: 0, value: Mexp.math.atan },
		{ token: '7', show: '7', type: 1, value: '7' },
		{ token: '8', show: '8', type: 1, value: '8' },
		{ token: '9', show: '9', type: 1, value: '9' },
		{ token: 'int', show: 'Int', type: 0, value: Math.floor },
		{ token: 'cosh', show: 'cosh', type: 0, value: Mexp.math.cosh },
		{ token: 'acosh', show: 'acosh', type: 0, value: Mexp.math.acosh },
		{ token: 'ln', show: ' ln', type: 0, value: Math.log },
		{ token: '^', show: '^', type: 10, value: Math.pow },
		{ token: 'root', show: 'root', type: 0, value: Math.sqrt },
		{ token: '4', show: '4', type: 1, value: '4' },
		{ token: '5', show: '5', type: 1, value: '5' },
		{ token: '6', show: '6', type: 1, value: '6' },
		{ token: '/', show: '&divide;', type: 2, value: Mexp.math.div },
		{ token: '!', show: '!', type: 7, value: Mexp.math.fact },
		{ token: 'tanh', show: 'tanh', type: 0, value: Mexp.math.tanh },
		{ token: 'atanh', show: 'atanh', type: 0, value: Mexp.math.atanh },
		{ token: 'Mod', show: ' Mod ', type: 2, value: Mexp.math.mod },
		{ token: '1', show: '1', type: 1, value: '1' },
		{ token: '2', show: '2', type: 1, value: '2' },
		{ token: '3', show: '3', type: 1, value: '3' },
		{ token: '*', show: '&times;', type: 2, value: Mexp.math.mul },
		{ token: 'sinh', show: 'sinh', type: 0, value: Mexp.math.sinh },
		{ token: 'asinh', show: 'asinh', type: 0, value: Mexp.math.asinh },
		{ token: 'e', show: 'e', type: 3, value: 'E' },
		{ token: 'log', show: ' log', type: 0, value: Mexp.math.log },
		{ token: '0', show: '0', type: 1, value: '0' },
		{ token: '.', show: '.', type: 6, value: '.' },
		{ token: '+', show: '+', type: 9, value: Mexp.math.add },
		{ token: '-', show: '-', type: 9, value: Mexp.math.sub },
		{ token: ',', show: ',', type: 11, value: ',' },
		{ token: 'Sigma', show: '&Sigma;', type: 12, value: Mexp.math.sigma },
		{ token: 'n', show: 'n', type: 13, value: 'n' },
		{ token: 'Pi', show: '&Pi;', type: 12, value: Mexp.math.Pi },
		{ token: 'pow', show: 'pow', type: 8, value: Math.pow, numberOfArguments: 2 },
		{ token: '&', show: '&', type: 9, value: Mexp.math.and },
	]
	var preced = {
		0: 11,
		1: 0,
		2: 3,
		3: 0,
		4: 0,
		5: 0,
		6: 0,
		7: 11,
		8: 11,
		9: 1,
		10: 10,
		11: 0,
		12: 11,
		13: 0,
		14: -1,
		15: 11, // will be filtered after lexer
	} // stores precedence by types
	for (var i = 0; i < tokens.length; i++) {
		tokens[i].precedence = preced[tokens[i].type]
	}
	var type0 = {
		0: true,
		1: true,
		3: true,
		4: true,
		6: true,
		8: true,
		9: true,
		12: true,
		13: true,
		14: true,
		15: true,
	} // type2:true,type4:true,type9:true,type11:true,type21:true,type22
	var type1 = {
		0: true,
		1: true,
		2: true,
		3: true,
		4: true,
		5: true,
		6: true,
		7: true,
		8: true,
		9: true,
		10: true,
		11: true,
		12: true,
		13: true,
		15: true,
	} // type3:true,type5:true,type7:true,type23
	var type1Asterick = {
		0: true,
		3: true,
		4: true,
		8: true,
		12: true,
		13: true,
		15: true,
	}
	var empty = {}
	var type3Asterick = {
		0: true,
		1: true,
		3: true,
		4: true,
		6: true,
		8: true,
		12: true,
		13: true,
		15: true,
	} // type_5:true,type_7:true,type_23
	var type6 = {
		1: true,
	}
	var newAr = [
		[],
		[
			'1',
			'2',
			'3',
			'7',
			'8',
			'9',
			'4',
			'5',
			'6',
			'+',
			'-',
			'*',
			'/',
			'(',
			')',
			'^',
			'!',
			'P',
			'C',
			'e',
			'0',
			'.',
			',',
			'n',
			' ',
			'&',
		],
		['pi', 'ln', 'Pi'],
		['sin', 'cos', 'tan', 'Del', 'int', 'Mod', 'log', 'pow'],
		['asin', 'acos', 'atan', 'cosh', 'root', 'tanh', 'sinh'],
		['acosh', 'atanh', 'asinh', 'Sigma'],
	]
	
	function match(str1, str2, i, x) {
		for (var f = 0; f < x; f++) {
			if (str1[i + f] !== str2[f]) {
				return false
			}
		}
		return true
	}
	Mexp.tokenTypes = {
		FUNCTION_WITH_ONE_ARG: 0,
		NUMBER: 1,
		BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
		CONSTANT: 3,
		OPENING_PARENTHESIS: 4,
		CLOSING_PARENTHESIS: 5,
		DECIMAL: 6,
		POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
		FUNCTION_WITH_N_ARGS: 8,
		BINARY_OPERATOR_LOW_PRECENDENCE: 9,
		BINARY_OPERATOR_PERMUTATION: 10,
		COMMA: 11,
		EVALUATED_FUNCTION: 12,
		EVALUATED_FUNCTION_PARAMETER: 13,
		SPACE: 14,
	}
	/**
	  
	  0 : function with syntax function_name(Maths_exp)
	  1 : numbers
	  2 : binary operators like * / Mod left associate and same precedence
	  3 : Math constant values like e,pi,Cruncher ans
	  4 : opening bracket
	  5 : closing bracket
	  6 : decimal
	  7 : function with syntax (Math_exp)function_name
	  8: function with syntax function_name(Math_exp1,Math_exp2)
	  9 : binary operator like +,-
	  10: binary operator like P C or ^
	  11: ,
	  12: function with , seperated three parameters and third parameter is a string that will be mexp string
	  13: variable of Sigma function
	 */
	Mexp.addToken = function (newTokens) {
		for (var i = 0; i < newTokens.length; i++) {
			var x = newTokens[i].token.length
			var temp = -1
			if (newTokens[i].type === Mexp.tokenTypes.FUNCTION_WITH_N_ARGS && newTokens[i].numberOfArguments === undefined) {
				newTokens[i].numberOfArguments = 2
			}
	
			// newAr is a specially designed data structure index of 1d array = length of tokens
			newAr[x] = newAr[x] || []
			for (var y = 0; y < newAr[x].length; y++) {
				if (newTokens[i].token === newAr[x][y]) {
					temp = indexOfToken(newAr[x][y], tokens)
					break
				}
			}
			if (temp === -1) {
				tokens.push(newTokens[i])
				newTokens[i].precedence = preced[newTokens[i].type]
				if (newAr.length <= newTokens[i].token.length) {
					newAr[newTokens[i].token.length] = []
				}
				newAr[newTokens[i].token.length].push(newTokens[i].token)
			} else {
				// overwrite
				tokens[temp] = newTokens[i]
				newTokens[i].precedence = preced[newTokens[i].type]
			}
		}
	}
	
	function indexOfToken(key, tokens) {
		for (var search = 0; search < tokens.length; search++) {
			if (tokens[search].token === key) return search
		}
		return -1
	}
	function tokenize(string) {
		var nodes = []
		var length = string.length
		var key, x, y
		for (var i = 0; i < length; i++) {
			if (i < length - 1 && string[i] === ' ' && string[i + 1] === ' ') {
				continue
			}
			key = ''
			for (x = string.length - i > newAr.length - 2 ? newAr.length - 1 : string.length - i; x > 0; x--) {
				if (newAr[x] === undefined) continue
				for (y = 0; y < newAr[x].length; y++) {
					if (match(string, newAr[x][y], i, x)) {
						key = newAr[x][y]
						y = newAr[x].length
						x = 0
					}
				}
			}
			i += key.length - 1
			if (key === '') {
				throw new Mexp.Exception("Can't understand after " + string.slice(i))
			}
			nodes.push(tokens[indexOfToken(key, tokens)])
		}
		return nodes
	}
	
	var changeSignObj = {
		value: Mexp.math.changeSign,
		type: 0,
		pre: 21,
		show: '-',
	}
	var closingParObj = {
		value: ')',
		show: ')',
		type: 5,
		pre: 0,
	}
	var openingParObj = {
		value: '(',
		type: 4,
		pre: 0,
		show: '(',
	}
	Mexp.lex = function (inp, tokens) {
		'use strict'
	
		var str = [openingParObj]
	
		var ptc = [] // Parenthesis to close at the beginning is after one token
		var inpStr = inp
		var allowed = type0
		var bracToClose = 0
		var asterick = empty
		var prevKey = ''
		var i
		if (typeof tokens !== 'undefined') {
			Mexp.addToken(tokens)
		}
		var obj = {}
		var nodes = tokenize(inpStr)
		for (i = 0; i < nodes.length; i++) {
			var node = nodes[i]
			if (node.type === 14) {
				if (
					i > 0 &&
					i < nodes.length - 1 &&
					nodes[i + 1].type === 1 &&
					(nodes[i - 1].type === 1 || nodes[i - 1].type === 6)
				) {
					throw new Mexp.Exception('Unexpected Space')
				}
				continue
			}
			var cToken = node.token
			var cType = node.type
			var cEv = node.value
			var cPre = node.precedence
			var cShow = node.show
			var pre = str[str.length - 1]
			var j
			for (j = ptc.length; j--; ) {
				// loop over ptc
				if (ptc[j] === 0) {
					if ([0, 2, 3, 4, 5, 9, 11, 12, 13].indexOf(cType) !== -1) {
						if (allowed[cType] !== true) {
							throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
						}
						str.push(closingParObj)
						allowed = type1
						asterick = type3Asterick
						ptc.pop()
					}
				} else break
			}
			if (allowed[cType] !== true) {
				throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
			}
			if (asterick[cType] === true) {
				cType = 2
				cEv = Mexp.math.mul
				cShow = '&times;'
				cPre = 3
				i = i - 1
			}
			obj = {
				value: cEv,
				type: cType,
				pre: cPre,
				show: cShow,
				numberOfArguments: node.numberOfArguments,
			}
			if (cType === 0) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(2)
				}
				// bracToClose++
			} else if (cType === 1) {
				if (pre.type === 1) {
					pre.value += cEv
					inc(ptc, 1)
				} else {
					str.push(obj)
				}
				allowed = type1
				asterick = type1Asterick
			} else if (cType === 2) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
			} else if (cType === 3) {
				// constant
				str.push(obj)
				allowed = type1
				asterick = type3Asterick
			} else if (cType === 4) {
				inc(ptc, 1)
				bracToClose++
				allowed = type0
				asterick = empty
				str.push(obj)
			} else if (cType === 5) {
				if (!bracToClose) {
					throw new Mexp.Exception('Closing parenthesis are more than opening one, wait What!!!')
				}
				bracToClose--
				allowed = type1
				asterick = type3Asterick
				str.push(obj)
				inc(ptc, 1)
			} else if (cType === 6) {
				if (pre.hasDec) {
					throw new Mexp.Exception('Two decimals are not allowed in one number')
				}
				if (pre.type !== 1) {
					pre = {
						value: 0,
						type: 1,
						pre: 0,
					} // pre needs to be changed as it will the last value now to be safe in later code
					str.push(pre)
					// inc(ptc, 1)
				}
				allowed = type6
				inc(ptc, 1)
				asterick = empty
				pre.value += cEv
				pre.hasDec = true
			} else if (cType === 7) {
				allowed = type1
				asterick = type3Asterick
				inc(ptc, 1)
				str.push(obj)
			}
			if (cType === 8) {
				allowed = type0
				asterick = empty
				inc(ptc, node.numberOfArguments + 2)
				str.push(obj)
				// str.push(openingParObj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(node.numberOfArguments + 2)
				}
			} else if (cType === 9) {
				if (pre.type === 9) {
					if (pre.value === Mexp.math.add) {
						pre.value = cEv
						pre.show = cShow
						inc(ptc, 1)
					} else if (pre.value === Mexp.math.sub && cShow === '-') {
						pre.value = Mexp.math.add
						pre.show = '+'
						inc(ptc, 1)
					}
				} else if (pre.type !== 5 && pre.type !== 7 && pre.type !== 1 && pre.type !== 3 && pre.type !== 13) {
					// changesign only when negative is found
					if (cToken === '-') {
						// do nothing for + token
						// don't add with the above if statement as that will run the else statement of parent if on Ctoken +
						allowed = type0
						asterick = empty
						inc(ptc, 2).push(2)
						str.push(changeSignObj)
						str.push(openingParObj)
					}
				} else {
					str.push(obj)
					inc(ptc, 2)
				}
				allowed = type0
				asterick = empty
			} else if (cType === 10) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
			} else if (cType === 11) {
				allowed = type0
				asterick = empty
				str.push(obj)
			} else if (cType === 12) {
				allowed = type0
				asterick = empty
				inc(ptc, 6)
				str.push(obj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(6)
				}
			} else if (cType === 13) {
				allowed = type1
				asterick = type3Asterick
				str.push(obj)
			}
	
			inc(ptc, -1)
			prevKey = cToken
		}
		for (j = ptc.length; j--; ) {
			// loop over ptc
			str.push(closingParObj)
		}
		if (allowed[5] !== true) {
			throw new Mexp.Exception('complete the expression')
		}
		while (bracToClose--) {
			str.push(closingParObj)
		}
	
		str.push(closingParObj)
		//        console.log(str);
		return new Mexp(str)
	}
	module.exports = Mexp


/***/ },
/* 1030 */
/***/ function(module, exports) {

	"use strict";
	var Mexp = function (parsed) {
	  this.value = parsed
	}
	
	Mexp.math = {
	  isDegree: true, // mode of calculator
	  acos: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.acos(x) : Math.acos(x))
	  },
	  add: function (a, b) {
	    return a + b
	  },
	  asin: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.asin(x) : Math.asin(x))
	  },
	  atan: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.atan(x) : Math.atan(x))
	  },
	  acosh: function (x) {
	    return Math.log(x + Math.sqrt(x * x - 1))
	  },
	  asinh: function (x) {
	    return Math.log(x + Math.sqrt(x * x + 1))
	  },
	  atanh: function (x) {
	    return Math.log((1 + x) / (1 - x))
	  },
	  C: function (n, r) {
	    var pro = 1
	    var other = n - r
	    var choice = r
	    if (choice < other) {
	      choice = other
	      other = r
	    }
	    for (var i = choice + 1; i <= n; i++) {
	      pro *= i
	    }
	    return pro / Mexp.math.fact(other)
	  },
	  changeSign: function (x) {
	    return -x
	  },
	  cos: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.cos(x)
	  },
	  cosh: function (x) {
	    return (Math.pow(Math.E, x) + Math.pow(Math.E, -1 * x)) / 2
	  },
	  div: function (a, b) {
	    return a / b
	  },
	  fact: function (n) {
	    if (n % 1 !== 0) return 'NaN'
	    var pro = 1
	    for (var i = 2; i <= n; i++) {
	      pro *= i
	    }
	    return pro
	  },
	  inverse: function (x) {
	    return 1 / x
	  },
	  log: function (i) {
	    return Math.log(i) / Math.log(10)
	  },
	  mod: function (a, b) {
	    return a % b
	  },
	  mul: function (a, b) {
	    return a * b
	  },
	  P: function (n, r) {
	    var pro = 1
	    for (var i = Math.floor(n) - Math.floor(r) + 1; i <= Math.floor(n); i++) {
	      pro *= i
	    }
	    return pro
	  },
	  Pi: function (low, high, ex) {
	    var pro = 1
	    for (var i = low; i <= high; i++) {
	      pro *= Number(ex.postfixEval({
	        n: i
	      }))
	    }
	    return pro
	  },
	  pow10x: function (e) {
	    var x = 1
	    while (e--) {
	      x *= 10
	    }
	    return x
	  },
	  sigma: function (low, high, ex) {
	    var sum = 0
	    for (var i = low; i <= high; i++) {
	      sum += Number(ex.postfixEval({
	        n: i
	      }))
	    }
	    return sum
	  },
	  sin: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.sin(x)
	  },
	  sinh: function (x) {
	    return (Math.pow(Math.E, x) - Math.pow(Math.E, -1 * x)) / 2
	  },
	  sub: function (a, b) {
	    return a - b
	  },
	  tan: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.tan(x)
	  },
	  tanh: function (x) {
	    return Mexp.sinha(x) / Mexp.cosha(x)
	  },
	  toRadian: function (x) {
	    return x * Math.PI / 180
	  },
	  and: function (a, b) {
	    return a & b
	  }
	}
	Mexp.Exception = function (message) {
	  this.message = message
	}
	module.exports = Mexp


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	
	var Mexp = __webpack_require__(1029);
	
	Mexp.prototype.toPostfix = function () {
		'use strict';
		var post = [], elem, popped, prep, pre, ele;
		var stack = [{ value: "(", type: 4, pre: 0 }];
		var arr = this.value;
		for (var i = 1; i < arr.length; i++) {
			if (arr[i].type === 1 || arr[i].type === 3 || arr[i].type === 13) {	//if token is number,constant,or n(which is also a special constant in our case)
				if (arr[i].type === 1)
					arr[i].value = Number(arr[i].value);
				post.push(arr[i]);
			}
			else if (arr[i].type === 4) {
				stack.push(arr[i]);
			}
			else if (arr[i].type === 5) {
				while ((popped = stack.pop()).type !== 4) {
					post.push(popped);
				}
			}
			else if (arr[i].type === 11) {
				while ((popped = stack.pop()).type !== 4) {
					post.push(popped);
				}
				stack.push(popped);
			}
			else {
				elem = arr[i];
				pre = elem.pre;
				ele = stack[stack.length - 1];
				prep = ele.pre;
				var flag = ele.value == 'Math.pow' && elem.value == 'Math.pow';
				if (pre > prep) stack.push(elem);
				else {
					while (prep >= pre && !flag || flag && pre < prep) {
						popped = stack.pop();
						ele = stack[stack.length - 1];
						post.push(popped);
						prep = ele.pre;
						flag = elem.value == 'Math.pow' && ele.value == 'Math.pow';
					}
					stack.push(elem);
				}
			}
		}
		return new Mexp(post);
	};
	module.exports = Mexp;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp = __webpack_require__(1031)
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict'
		UserDefined = UserDefined || {}
		UserDefined.PI = Math.PI
		UserDefined.E = Math.E
		var stack = [],
			pop1,
			pop2,
			pop3
		var disp = []
		var temp = ''
		var arr = this.value
		var bool = typeof UserDefined.n !== 'undefined'
		for (var i = 0; i < arr.length; i++) {
			if (arr[i].type === 1) {
				stack.push({ value: arr[i].value, type: 1 })
			} else if (arr[i].type === 3) {
				stack.push({ value: UserDefined[arr[i].value], type: 1 })
			} else if (arr[i].type === 0) {
				if (typeof stack[stack.length - 1].type === 'undefined') {
					stack[stack.length - 1].value.push(arr[i])
				} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
			} else if (arr[i].type === 7) {
				if (typeof stack[stack.length - 1].type === 'undefined') {
					stack[stack.length - 1].value.push(arr[i])
				} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
			} else if (arr[i].type === 8) {
				var popped = []
				for (var x = 0; x < arr[i].numberOfArguments; x++) {
					popped.push(stack.pop().value)
				}
				stack.push({ type: 1, value: arr[i].value.apply(arr[i], popped.reverse()) })
			} else if (arr[i].type === 10) {
				pop1 = stack.pop()
				pop2 = stack.pop()
				if (typeof pop2.type === 'undefined') {
					pop2.value = pop2.concat(pop1)
					pop2.value.push(arr[i])
					stack.push(pop2)
				} else if (typeof pop1.type === 'undefined') {
					pop1.unshift(pop2)
					pop1.push(arr[i])
					stack.push(pop1)
				} else {
					stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
				}
			} else if (arr[i].type === 2 || arr[i].type === 9) {
				pop1 = stack.pop()
				pop2 = stack.pop()
				if (typeof pop2.type === 'undefined') {
					pop2 = pop2.concat(pop1)
					pop2.push(arr[i])
					stack.push(pop2)
				} else if (typeof pop1.type === 'undefined') {
					pop1.unshift(pop2)
					pop1.push(arr[i])
					stack.push(pop1)
				} else {
					stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
				}
			} else if (arr[i].type === 12) {
				pop1 = stack.pop()
				if (typeof pop1.type !== 'undefined') {
					pop1 = [pop1]
				}
				pop2 = stack.pop()
				pop3 = stack.pop()
				stack.push({ type: 1, value: arr[i].value(pop3.value, pop2.value, new Mexp(pop1)) })
			} else if (arr[i].type === 13) {
				if (bool) {
					stack.push({ value: UserDefined[arr[i].value], type: 3 })
				} else stack.push([arr[i]])
			}
		}
		if (stack.length > 1) {
			throw new Mexp.Exception('Uncaught Syntax error')
		}
		return stack[0].value > 1000000000000000 ? 'Infinity' : parseFloat(stack[0].value.toFixed(15))
	}
	Mexp.eval = function (str, tokens, obj) {
		if (typeof tokens === 'undefined') {
			return this.lex(str).toPostfix().postfixEval()
		} else if (typeof obj === 'undefined') {
			if (typeof tokens.length !== 'undefined') return this.lex(str, tokens).toPostfix().postfixEval()
			else return this.lex(str).toPostfix().postfixEval(tokens)
		} else return this.lex(str, tokens).toPostfix().postfixEval(obj)
	}
	module.exports = Mexp


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(13));
		else if(typeof define === 'function' && define.amd)
			define("MobxReactRouter", ["mobx"], factory);
		else if(typeof exports === 'object')
			exports["MobxReactRouter"] = factory(require("mobx"));
		else
			root["MobxReactRouter"] = factory(root["Mobx"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmory imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmory exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		Object.defineProperty(exports, name, {
	/******/ 			configurable: false,
	/******/ 			enumerable: true,
	/******/ 			get: getter
	/******/ 		});
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 4);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(2);
	
	Object.keys(_store).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _store[key];
	    }
	  });
	});
	
	var _sync = __webpack_require__(3);
	
	Object.keys(_sync).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sync[key];
	    }
	  });
	});
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RouterStore = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class, _descriptor;
	
	var _mobx = __webpack_require__(0);
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  Object.defineProperty(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	var RouterStore = exports.RouterStore = (_class = function () {
	  function RouterStore() {
	    _classCallCheck(this, RouterStore);
	
	    _initDefineProp(this, 'location', _descriptor, this);
	
	    this.history = null;
	
	    this.push = this.push.bind(this);
	    this.replace = this.replace.bind(this);
	    this.go = this.go.bind(this);
	    this.goBack = this.goBack.bind(this);
	    this.goForward = this.goForward.bind(this);
	  }
	
	  _createClass(RouterStore, [{
	    key: '_updateLocation',
	    value: function _updateLocation(newState) {
	      this.location = newState;
	    }
	
	    /*
	     * History methods
	     */
	
	  }, {
	    key: 'push',
	    value: function push(location) {
	      this.history.push(location);
	    }
	  }, {
	    key: 'replace',
	    value: function replace(location) {
	      this.history.replace(location);
	    }
	  }, {
	    key: 'go',
	    value: function go(n) {
	      this.history.go(n);
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this.history.goBack();
	    }
	  }, {
	    key: 'goForward',
	    value: function goForward() {
	      this.history.goForward();
	    }
	  }]);
	
	  return RouterStore;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'location', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _applyDecoratedDescriptor(_class.prototype, '_updateLocation', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, '_updateLocation'), _class.prototype)), _class);
	;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.syncHistoryWithStore = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mobx = __webpack_require__(0);
	
	var syncHistoryWithStore = exports.syncHistoryWithStore = function syncHistoryWithStore(history, store) {
	  // Initialise store
	  store.history = history;
	
	  // Handle update from history object
	  var handleLocationChange = function handleLocationChange(location) {
	    store._updateLocation(location);
	  };
	
	  var unsubscribeFromHistory = history.listen(handleLocationChange);
	  handleLocationChange(history.getCurrentLocation());
	
	  return _extends({}, history, {
	    // User can subscribe to history changes
	    listen: function listen(listener) {
	      var onStoreChange = function onStoreChange(change) {
	        listener(store.location);
	      };
	
	      // Listen for changes to location state in store
	      var unsubscribeFromStore = (0, _mobx.observe)(store, 'location', onStoreChange);
	
	      listener(store.location);
	
	      return function () {
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // Provide way to unsubscribe from history
	    unsubscribe: function unsubscribe() {
	      unsubscribeFromHistory();
	    }
	  });
	};
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(1);
	
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=mobx-react-router.js.map

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1035);
	moment.tz.load(__webpack_require__(1011));


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.14
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else if (typeof module === 'object' && module.exports) {
			module.exports = factory(require('moment')); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.14",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess,
	
			momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 419,
		"./af.js": 419,
		"./ar": 426,
		"./ar-dz": 420,
		"./ar-dz.js": 420,
		"./ar-kw": 421,
		"./ar-kw.js": 421,
		"./ar-ly": 422,
		"./ar-ly.js": 422,
		"./ar-ma": 423,
		"./ar-ma.js": 423,
		"./ar-sa": 424,
		"./ar-sa.js": 424,
		"./ar-tn": 425,
		"./ar-tn.js": 425,
		"./ar.js": 426,
		"./az": 427,
		"./az.js": 427,
		"./be": 428,
		"./be.js": 428,
		"./bg": 429,
		"./bg.js": 429,
		"./bn": 430,
		"./bn.js": 430,
		"./bo": 431,
		"./bo.js": 431,
		"./br": 432,
		"./br.js": 432,
		"./bs": 433,
		"./bs.js": 433,
		"./ca": 434,
		"./ca.js": 434,
		"./cs": 435,
		"./cs.js": 435,
		"./cv": 436,
		"./cv.js": 436,
		"./cy": 437,
		"./cy.js": 437,
		"./da": 438,
		"./da.js": 438,
		"./de": 441,
		"./de-at": 439,
		"./de-at.js": 439,
		"./de-ch": 440,
		"./de-ch.js": 440,
		"./de.js": 441,
		"./dv": 442,
		"./dv.js": 442,
		"./el": 443,
		"./el.js": 443,
		"./en-au": 444,
		"./en-au.js": 444,
		"./en-ca": 445,
		"./en-ca.js": 445,
		"./en-gb": 446,
		"./en-gb.js": 446,
		"./en-ie": 447,
		"./en-ie.js": 447,
		"./en-nz": 448,
		"./en-nz.js": 448,
		"./eo": 449,
		"./eo.js": 449,
		"./es": 451,
		"./es-do": 450,
		"./es-do.js": 450,
		"./es.js": 451,
		"./et": 452,
		"./et.js": 452,
		"./eu": 453,
		"./eu.js": 453,
		"./fa": 454,
		"./fa.js": 454,
		"./fi": 455,
		"./fi.js": 455,
		"./fo": 456,
		"./fo.js": 456,
		"./fr": 459,
		"./fr-ca": 457,
		"./fr-ca.js": 457,
		"./fr-ch": 458,
		"./fr-ch.js": 458,
		"./fr.js": 459,
		"./fy": 460,
		"./fy.js": 460,
		"./gd": 461,
		"./gd.js": 461,
		"./gl": 462,
		"./gl.js": 462,
		"./gom-latn": 463,
		"./gom-latn.js": 463,
		"./he": 464,
		"./he.js": 464,
		"./hi": 465,
		"./hi.js": 465,
		"./hr": 466,
		"./hr.js": 466,
		"./hu": 467,
		"./hu.js": 467,
		"./hy-am": 468,
		"./hy-am.js": 468,
		"./id": 469,
		"./id.js": 469,
		"./is": 470,
		"./is.js": 470,
		"./it": 471,
		"./it.js": 471,
		"./ja": 472,
		"./ja.js": 472,
		"./jv": 473,
		"./jv.js": 473,
		"./ka": 474,
		"./ka.js": 474,
		"./kk": 475,
		"./kk.js": 475,
		"./km": 476,
		"./km.js": 476,
		"./kn": 477,
		"./kn.js": 477,
		"./ko": 478,
		"./ko.js": 478,
		"./ky": 479,
		"./ky.js": 479,
		"./lb": 480,
		"./lb.js": 480,
		"./lo": 481,
		"./lo.js": 481,
		"./lt": 482,
		"./lt.js": 482,
		"./lv": 483,
		"./lv.js": 483,
		"./me": 484,
		"./me.js": 484,
		"./mi": 485,
		"./mi.js": 485,
		"./mk": 486,
		"./mk.js": 486,
		"./ml": 487,
		"./ml.js": 487,
		"./mr": 488,
		"./mr.js": 488,
		"./ms": 490,
		"./ms-my": 489,
		"./ms-my.js": 489,
		"./ms.js": 490,
		"./my": 491,
		"./my.js": 491,
		"./nb": 492,
		"./nb.js": 492,
		"./ne": 493,
		"./ne.js": 493,
		"./nl": 495,
		"./nl-be": 494,
		"./nl-be.js": 494,
		"./nl.js": 495,
		"./nn": 496,
		"./nn.js": 496,
		"./pa-in": 497,
		"./pa-in.js": 497,
		"./pl": 498,
		"./pl.js": 498,
		"./pt": 500,
		"./pt-br": 499,
		"./pt-br.js": 499,
		"./pt.js": 500,
		"./ro": 501,
		"./ro.js": 501,
		"./ru": 502,
		"./ru.js": 502,
		"./sd": 503,
		"./sd.js": 503,
		"./se": 504,
		"./se.js": 504,
		"./si": 505,
		"./si.js": 505,
		"./sk": 506,
		"./sk.js": 506,
		"./sl": 507,
		"./sl.js": 507,
		"./sq": 508,
		"./sq.js": 508,
		"./sr": 510,
		"./sr-cyrl": 509,
		"./sr-cyrl.js": 509,
		"./sr.js": 510,
		"./ss": 511,
		"./ss.js": 511,
		"./sv": 512,
		"./sv.js": 512,
		"./sw": 513,
		"./sw.js": 513,
		"./ta": 514,
		"./ta.js": 514,
		"./te": 515,
		"./te.js": 515,
		"./tet": 516,
		"./tet.js": 516,
		"./th": 517,
		"./th.js": 517,
		"./tl-ph": 518,
		"./tl-ph.js": 518,
		"./tlh": 519,
		"./tlh.js": 519,
		"./tr": 520,
		"./tr.js": 520,
		"./tzl": 521,
		"./tzl.js": 521,
		"./tzm": 523,
		"./tzm-latn": 522,
		"./tzm-latn.js": 522,
		"./tzm.js": 523,
		"./uk": 524,
		"./uk.js": 524,
		"./ur": 525,
		"./ur.js": 525,
		"./uz": 527,
		"./uz-latn": 526,
		"./uz-latn.js": 526,
		"./uz.js": 527,
		"./vi": 528,
		"./vi.js": 528,
		"./x-pseudo": 529,
		"./x-pseudo.js": 529,
		"./yo": 530,
		"./yo.js": 530,
		"./zh-cn": 531,
		"./zh-cn.js": 531,
		"./zh-hk": 532,
		"./zh-hk.js": 532,
		"./zh-tw": 533,
		"./zh-tw.js": 533
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1036;


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	
	    'use strict';
	
	    var _ = __webpack_require__(1027);
	
	    function createRegExPatternForResource (input)
	    {
	        return input.replace(/\*/,'([0-9A-Za-z_]+/?)*')
	    }
	
	    function createRegExPatternForAction (input)
	    {
	        return input.replace(/\*/g,'([0-9A-Za-z\:])*')
	    }
	
	    // process iam file
	    function processIamData( data ) {
	
	        for (var i in data.Statement) {
	
	            var stmt = data.Statement[i];
	
	            stmt.ResourceRegex = [];
	            if (_.has(stmt, 'Resource') && stmt.Resource instanceof  Array) {
	
	                for (var j in stmt.Resource) {
	                    stmt.ResourceRegex.push(createRegExPatternForResource(stmt.Resource[j]));
	                }
	            }
	            else {
	                stmt.ResourceRegex.push(createRegExPatternForResource(stmt.Resource));
	            }
	
	            stmt.ActionRegex = [];
	            if (_.has(stmt, 'Action') && stmt.Action instanceof  Array) {
	
	                for (var j in stmt.Action) {
	                    stmt.ActionRegex.push(createRegExPatternForAction(stmt.Action[j]));
	                }
	            }
	            else {
	                stmt.ActionRegex.push(createRegExPatternForAction(stmt.Action));
	            }
	        }
	
	        return data;
	    }
	
	    // processed json data as input
	    function seperateStmts( stmts ) {
	
	        var allowString = 'Allow';
	        var denyString = 'Deny';
	
	        var allowStmts = [];
	        var denyStmts = [];
	
	        for (var i in stmts) {
	
	            var stmt = stmts[i];
	
	            if (_.has(stmt, 'Effect'))
	                if (stmt.Effect === allowString) {
	                    allowStmts.push(stmt);
	                }
	                else if (stmt.Effect === denyString) {
	                    denyStmts.push(stmt);
	                }
	        }
	
	        return {
	            denyStmts: denyStmts,
	            allowStmts: allowStmts
	        };
	
	    }
	
	    function processBlock(isAllow,stm,def) {
	        if(isAllow === false && stm === true) {
	            def = false
	        }
	        else if(isAllow === true && stm === true) {
	            def = true
	        }
	        return def
	    }
	    // authorize a resource for an action
	    function authorize( resource, action, data ) {
	        var defaultDeny = false;
	
	        if(Array.isArray(resource)) {
	            defaultDeny = resource.every(function(res) {
	                var localDDeny = false;
	                data.Statement.forEach(function(stm) {
	                    localDDeny = processBlock(stm.Effect === 'Allow',findActionForResource( res,  action, [stm] ),localDDeny)
	                })
	                return localDDeny
	            })
	        } else {
	
	            var localDDeny = false
	            data.Statement.forEach(function(stm) {
	                localDDeny = processBlock(stm.Effect === 'Allow',findActionForResource( resource,  action, [stm] ),localDDeny)
	            })
	            defaultDeny = localDDeny
	        }
	        return defaultDeny;
	    }
	
	    function getActionCriteria( action, data ) {
	
	        // seperate processed allow and deny stmts
	        var statements =  seperateStmts(data.Statement);
	
	        // default deny
	        var defaultDeny = false;
	        var accounts = {};
	        var permissions = {};
	
	        for(var a = 0; a < statements.allowStmts.length; a++){
	            if (_.has(statements.allowStmts[a], 'ActionRegex') && statements.allowStmts[a].ActionRegex instanceof  Array) {
	                for (var r in statements.allowStmts[a].ActionRegex) {
	                    if( new RegExp(statements.allowStmts[a].ActionRegex[r]).test(action) ){
	                        for(var t in statements.allowStmts[a].Resource){
	                            var AccountId = statements.allowStmts[a].Resource[t].split(':')[4];
	                            var arn_resource = statements.allowStmts[a].Resource[t].split(':')[5];
	
	                            if(!accounts[AccountId]){
	                                accounts[AccountId] = {allow: [], deny:[]};
	                            }
	
	                            accounts[AccountId].allow.push({
	                                Action: statements.allowStmts[a].Action[r],
	                                Resource: statements.allowStmts[a].Resource,
	                                ResourceRegex: statements.allowStmts[a].ResourceRegex,
	                                ArnResource: arn_resource
	                            });
	                        }
	                    }
	                }
	            }else{
	
	            }
	
	        }
	
	        for(var a = 0; a < statements.denyStmts.length; a++){
	            if (_.has(statements.denyStmts[a], 'ActionRegex') && statements.denyStmts[a].ActionRegex instanceof  Array) {
	                for (var r in statements.denyStmts[a].ActionRegex) {
	                    if( new RegExp(statements.denyStmts[a].ActionRegex[r]).test(action) ){
	                        for(var t in statements.denyStmts[a].Resource){
	                            var AccountId = statements.denyStmts[a].Resource[t].split(':')[4];
	                            var arn_resource = statements.denyStmts[a].Resource[t].split(':')[5];
	                            if(!accounts[AccountId]){
	                                accounts[AccountId] = {allow: [], deny:[]};
	                            }
	                            accounts[AccountId].deny.push({
	                                Action: statements.denyStmts[a].Action[r],
	                                Resource: statements.denyStmts[a].Resource,
	                                ResourceRegex: statements.denyStmts[a].ResourceRegex,
	                                ArnResource: arn_resource
	                            });
	                        }
	                    }
	                }
	            }else{
	
	            }
	        }
	
	        for(var a in accounts){
	            permissions[a] = {Must:[], MustNot:[]};
	        }
	
	        for(var p in permissions){
	            if(accounts[p]){
	                for(var a in accounts[p].allow){
	                    if(accounts[p].allow[a].ArnResource !== '*'){
	                        permissions[p].Must.push({type: accounts[p].allow[a].ArnResource.split('/')[0], id: accounts[p].allow[a].ArnResource.split('/')[1]});
	                    }
	                }
	                for(var d in accounts[p].deny){
	                    if(accounts[p].deny[d].ArnResource !== '*') {
	                        permissions[p].MustNot.push({type: accounts[p].deny[d].ArnResource.split('/')[0], id: accounts[p].deny[d].ArnResource.split('/')[1]});
	                    }else{
	                        // the deny is explict for all resources in the account...so delete it...
	                        delete permissions[p];
	                    }
	                }
	            }
	        }
	        return permissions;
	    }
	
	
	    function findActionForResource( resource, action, stmts ) {
	            var stmt = stmts[0];
	
	            for ( var j in stmt.ResourceRegex ) {
	                //need to swap any empty :: with a catch all '([0-9A-Za-z\-]+)*'
	                var localStatment = stmt.ResourceRegex[j].split(':').map(function(x){return x === "" ? "([0-9A-Za-z\-])*" : x}).join(":")
	                var regex = new RegExp(localStatment);
	                var resource_parts = resource.split(':');
	                var regex_resource_parts = stmt.Resource[0].split(':');
	                var resource = resource.split(':').map(function(x){return x === "" ? "PREFILL" : x}  ).join(":")
	                if ( regex.test(resource)  && _.has(stmt,'ActionRegex')) {
	                    var actions = stmt.ActionRegex;
	                    if( actions instanceof  Array ){
	
	                        for( var k in actions ) {
	                            if( new RegExp(actions[k]).test(action) ){
	                                return true;
	                            }
	                        }
	                    }else {
	                        if( new RegExp(actions).test(action) ){
	                            return true;
	                        }
	                    }
	                }
	            }
	        return false;
	    }
	
	
	    var iam = {
	        processIamData: processIamData,
	        authorize: authorize,
	        getActionCriteria: getActionCriteria
	    };
	
	    module.exports = iam;
	
	})();


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)))

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*!
	 * Platform.js v1.3.6
	 * Copyright 2014-2020 Benjamin Tan
	 * Copyright 2011-2013 John-David Dalton
	 * Available under MIT license
	 */
	;(function() {
	  'use strict';
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used as a reference to the global object. */
	  var root = (objectTypes[typeof window] && window) || this;
	
	  /** Backup possible global object. */
	  var oldRoot = root;
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
	  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  /**
	   * Used as the maximum length of an array-like object.
	   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	   * for more details.
	   */
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	
	  /** Regular expression to detect Opera. */
	  var reOpera = /\bOpera/;
	
	  /** Possible global object. */
	  var thisBinding = this;
	
	  /** Used for native method references. */
	  var objectProto = Object.prototype;
	
	  /** Used to check for own properties of an object. */
	  var hasOwnProperty = objectProto.hasOwnProperty;
	
	  /** Used to resolve the internal `[[Class]]` of values. */
	  var toString = objectProto.toString;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Capitalizes a string value.
	   *
	   * @private
	   * @param {string} string The string to capitalize.
	   * @returns {string} The capitalized string.
	   */
	  function capitalize(string) {
	    string = String(string);
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  /**
	   * A utility function to clean up the OS name.
	   *
	   * @private
	   * @param {string} os The OS name to clean up.
	   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
	   * @param {string} [label] A label for the OS.
	   */
	  function cleanupOS(os, pattern, label) {
	    // Platform tokens are defined at:
	    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    var data = {
	      '10.0': '10',
	      '6.4':  '10 Technical Preview',
	      '6.3':  '8.1',
	      '6.2':  '8',
	      '6.1':  'Server 2008 R2 / 7',
	      '6.0':  'Server 2008 / Vista',
	      '5.2':  'Server 2003 / XP 64-bit',
	      '5.1':  'XP',
	      '5.01': '2000 SP1',
	      '5.0':  '2000',
	      '4.0':  'NT',
	      '4.90': 'ME'
	    };
	    // Detect Windows version from platform tokens.
	    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
	        (data = data[/[\d.]+$/.exec(os)])) {
	      os = 'Windows ' + data;
	    }
	    // Correct character case and cleanup string.
	    os = String(os);
	
	    if (pattern && label) {
	      os = os.replace(RegExp(pattern, 'i'), label);
	    }
	
	    os = format(
	      os.replace(/ ce$/i, ' CE')
	        .replace(/\bhpw/i, 'web')
	        .replace(/\bMacintosh\b/, 'Mac OS')
	        .replace(/_PowerPC\b/i, ' OS')
	        .replace(/\b(OS X) [^ \d]+/i, '$1')
	        .replace(/\bMac (OS X)\b/, '$1')
	        .replace(/\/(\d)/, ' $1')
	        .replace(/_/g, '.')
	        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
	        .replace(/\bx86\.64\b/gi, 'x86_64')
	        .replace(/\b(Windows Phone) OS\b/, '$1')
	        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
	        .split(' on ')[0]
	    );
	
	    return os;
	  }
	
	  /**
	   * An iteration utility for arrays and objects.
	   *
	   * @private
	   * @param {Array|Object} object The object to iterate over.
	   * @param {Function} callback The function called per iteration.
	   */
	  function each(object, callback) {
	    var index = -1,
	        length = object ? object.length : 0;
	
	    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
	      while (++index < length) {
	        callback(object[index], index, object);
	      }
	    } else {
	      forOwn(object, callback);
	    }
	  }
	
	  /**
	   * Trim and conditionally capitalize string values.
	   *
	   * @private
	   * @param {string} string The string to format.
	   * @returns {string} The formatted string.
	   */
	  function format(string) {
	    string = trim(string);
	    return /^(?:webOS|i(?:OS|P))/.test(string)
	      ? string
	      : capitalize(string);
	  }
	
	  /**
	   * Iterates over an object's own properties, executing the `callback` for each.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} callback The function executed per own property.
	   */
	  function forOwn(object, callback) {
	    for (var key in object) {
	      if (hasOwnProperty.call(object, key)) {
	        callback(object[key], key, object);
	      }
	    }
	  }
	
	  /**
	   * Gets the internal `[[Class]]` of a value.
	   *
	   * @private
	   * @param {*} value The value.
	   * @returns {string} The `[[Class]]`.
	   */
	  function getClassOf(value) {
	    return value == null
	      ? capitalize(value)
	      : toString.call(value).slice(8, -1);
	  }
	
	  /**
	   * Host objects can return type values that are different from their actual
	   * data type. The objects we are concerned with usually return non-primitive
	   * types of "object", "function", or "unknown".
	   *
	   * @private
	   * @param {*} object The owner of the property.
	   * @param {string} property The property to check.
	   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
	   */
	  function isHostType(object, property) {
	    var type = object != null ? typeof object[property] : 'number';
	    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
	      (type == 'object' ? !!object[property] : true);
	  }
	
	  /**
	   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
	   *
	   * @private
	   * @param {string} string The string to qualify.
	   * @returns {string} The qualified string.
	   */
	  function qualify(string) {
	    return String(string).replace(/([ -])(?!$)/g, '$1?');
	  }
	
	  /**
	   * A bare-bones `Array#reduce` like utility function.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} callback The function called per iteration.
	   * @returns {*} The accumulated result.
	   */
	  function reduce(array, callback) {
	    var accumulator = null;
	    each(array, function(value, index) {
	      accumulator = callback(accumulator, value, index, array);
	    });
	    return accumulator;
	  }
	
	  /**
	   * Removes leading and trailing whitespace from a string.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} The trimmed string.
	   */
	  function trim(string) {
	    return String(string).replace(/^ +| +$/g, '');
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a new platform object.
	   *
	   * @memberOf platform
	   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
	   *  context object.
	   * @returns {Object} A platform object.
	   */
	  function parse(ua) {
	
	    /** The environment context object. */
	    var context = root;
	
	    /** Used to flag when a custom context is provided. */
	    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';
	
	    // Juggle arguments.
	    if (isCustomContext) {
	      context = ua;
	      ua = null;
	    }
	
	    /** Browser navigator object. */
	    var nav = context.navigator || {};
	
	    /** Browser user agent string. */
	    var userAgent = nav.userAgent || '';
	
	    ua || (ua = userAgent);
	
	    /** Used to flag when `thisBinding` is the [ModuleScope]. */
	    var isModuleScope = isCustomContext || thisBinding == oldRoot;
	
	    /** Used to detect if browser is like Chrome. */
	    var likeChrome = isCustomContext
	      ? !!nav.likeChrome
	      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
	
	    /** Internal `[[Class]]` value shortcuts. */
	    var objectClass = 'Object',
	        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
	        enviroClass = isCustomContext ? objectClass : 'Environment',
	        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
	        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';
	
	    /** Detect Java environments. */
	    var java = /\bJava/.test(javaClass) && context.java;
	
	    /** Detect Rhino. */
	    var rhino = java && getClassOf(context.environment) == enviroClass;
	
	    /** A character to represent alpha. */
	    var alpha = java ? 'a' : '\u03b1';
	
	    /** A character to represent beta. */
	    var beta = java ? 'b' : '\u03b2';
	
	    /** Browser document object. */
	    var doc = context.document || {};
	
	    /**
	     * Detect Opera browser (Presto-based).
	     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
	     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
	     */
	    var opera = context.operamini || context.opera;
	
	    /** Opera `[[Class]]`. */
	    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
	      ? operaClass
	      : (opera = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /** Temporary variable used over the script's lifetime. */
	    var data;
	
	    /** The CPU architecture. */
	    var arch = ua;
	
	    /** Platform description array. */
	    var description = [];
	
	    /** Platform alpha/beta indicator. */
	    var prerelease = null;
	
	    /** A flag to indicate that environment features should be used to resolve the platform. */
	    var useFeatures = ua == userAgent;
	
	    /** The browser/environment version. */
	    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();
	
	    /** A flag to indicate if the OS ends with "/ Version" */
	    var isSpecialCasedOS;
	
	    /* Detectable layout engines (order is important). */
	    var layout = getLayout([
	      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
	      'Trident',
	      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
	      'iCab',
	      'Presto',
	      'NetFront',
	      'Tasman',
	      'KHTML',
	      'Gecko'
	    ]);
	
	    /* Detectable browser names (order is important). */
	    var name = getName([
	      'Adobe AIR',
	      'Arora',
	      'Avant Browser',
	      'Breach',
	      'Camino',
	      'Electron',
	      'Epiphany',
	      'Fennec',
	      'Flock',
	      'Galeon',
	      'GreenBrowser',
	      'iCab',
	      'Iceweasel',
	      'K-Meleon',
	      'Konqueror',
	      'Lunascape',
	      'Maxthon',
	      { 'label': 'Microsoft Edge', 'pattern': '(?:Edge|Edg|EdgA|EdgiOS)' },
	      'Midori',
	      'Nook Browser',
	      'PaleMoon',
	      'PhantomJS',
	      'Raven',
	      'Rekonq',
	      'RockMelt',
	      { 'label': 'Samsung Internet', 'pattern': 'SamsungBrowser' },
	      'SeaMonkey',
	      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Sleipnir',
	      'SlimBrowser',
	      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
	      'Sunrise',
	      'Swiftfox',
	      'Vivaldi',
	      'Waterfox',
	      'WebPositive',
	      { 'label': 'Yandex Browser', 'pattern': 'YaBrowser' },
	      { 'label': 'UC Browser', 'pattern': 'UCBrowser' },
	      'Opera Mini',
	      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
	      'Opera',
	      { 'label': 'Opera', 'pattern': 'OPR' },
	      'Chromium',
	      'Chrome',
	      { 'label': 'Chrome', 'pattern': '(?:HeadlessChrome)' },
	      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
	      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
	      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
	      { 'label': 'IE', 'pattern': 'IEMobile' },
	      { 'label': 'IE', 'pattern': 'MSIE' },
	      'Safari'
	    ]);
	
	    /* Detectable products (order is important). */
	    var product = getProduct([
	      { 'label': 'BlackBerry', 'pattern': 'BB10' },
	      'BlackBerry',
	      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
	      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
	      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
	      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
	      { 'label': 'Galaxy S5', 'pattern': 'SM-G900' },
	      { 'label': 'Galaxy S6', 'pattern': 'SM-G920' },
	      { 'label': 'Galaxy S6 Edge', 'pattern': 'SM-G925' },
	      { 'label': 'Galaxy S7', 'pattern': 'SM-G930' },
	      { 'label': 'Galaxy S7 Edge', 'pattern': 'SM-G935' },
	      'Google TV',
	      'Lumia',
	      'iPad',
	      'iPod',
	      'iPhone',
	      'Kindle',
	      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Nexus',
	      'Nook',
	      'PlayBook',
	      'PlayStation Vita',
	      'PlayStation',
	      'TouchPad',
	      'Transformer',
	      { 'label': 'Wii U', 'pattern': 'WiiU' },
	      'Wii',
	      'Xbox One',
	      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
	      'Xoom'
	    ]);
	
	    /* Detectable manufacturers. */
	    var manufacturer = getManufacturer({
	      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
	      'Alcatel': {},
	      'Archos': {},
	      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
	      'Asus': { 'Transformer': 1 },
	      'Barnes & Noble': { 'Nook': 1 },
	      'BlackBerry': { 'PlayBook': 1 },
	      'Google': { 'Google TV': 1, 'Nexus': 1 },
	      'HP': { 'TouchPad': 1 },
	      'HTC': {},
	      'Huawei': {},
	      'Lenovo': {},
	      'LG': {},
	      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
	      'Motorola': { 'Xoom': 1 },
	      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
	      'Nokia': { 'Lumia': 1 },
	      'Oppo': {},
	      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
	      'Sony': { 'PlayStation': 1, 'PlayStation Vita': 1 },
	      'Xiaomi': { 'Mi': 1, 'Redmi': 1 }
	    });
	
	    /* Detectable operating systems (order is important). */
	    var os = getOS([
	      'Windows Phone',
	      'KaiOS',
	      'Android',
	      'CentOS',
	      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
	      'Debian',
	      { 'label': 'DragonFly BSD', 'pattern': 'DragonFly' },
	      'Fedora',
	      'FreeBSD',
	      'Gentoo',
	      'Haiku',
	      'Kubuntu',
	      'Linux Mint',
	      'OpenBSD',
	      'Red Hat',
	      'SuSE',
	      'Ubuntu',
	      'Xubuntu',
	      'Cygwin',
	      'Symbian OS',
	      'hpwOS',
	      'webOS ',
	      'webOS',
	      'Tablet OS',
	      'Tizen',
	      'Linux',
	      'Mac OS X',
	      'Macintosh',
	      'Mac',
	      'Windows 98;',
	      'Windows '
	    ]);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Picks the layout engine from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected layout engine.
	     */
	    function getLayout(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the manufacturer from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An object of guesses.
	     * @returns {null|string} The detected manufacturer.
	     */
	    function getManufacturer(guesses) {
	      return reduce(guesses, function(result, value, key) {
	        // Lookup the manufacturer by product or scan the UA for the manufacturer.
	        return result || (
	          value[product] ||
	          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
	          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
	        ) && key;
	      });
	    }
	
	    /**
	     * Picks the browser name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected browser name.
	     */
	    function getName(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the OS name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected OS name.
	     */
	    function getOS(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
	            )) {
	          result = cleanupOS(result, pattern, guess.label || guess);
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Picks the product name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected product name.
	     */
	    function getProduct(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
	            )) {
	          // Split by forward slash and append product version if needed.
	          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
	            result[0] += ' ' + result[1];
	          }
	          // Correct character case and cleanup string.
	          guess = guess.label || guess;
	          result = format(result[0]
	            .replace(RegExp(pattern, 'i'), guess)
	            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
	            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Resolves the version using an array of UA patterns.
	     *
	     * @private
	     * @param {Array} patterns An array of UA patterns.
	     * @returns {null|string} The detected version.
	     */
	    function getVersion(patterns) {
	      return reduce(patterns, function(result, pattern) {
	        return result || (RegExp(pattern +
	          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
	      });
	    }
	
	    /**
	     * Returns `platform.description` when the platform object is coerced to a string.
	     *
	     * @name toString
	     * @memberOf platform
	     * @returns {string} Returns `platform.description` if available, else an empty string.
	     */
	    function toStringPlatform() {
	      return this.description || '';
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Convert layout to an array so we can add extra details.
	    layout && (layout = [layout]);
	
	    // Detect Android products.
	    // Browsers on Android devices typically provide their product IDS after "Android;"
	    // up to "Build" or ") AppleWebKit".
	    // Example:
	    // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
	    // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
	    if (/\bAndroid\b/.test(os) && !product &&
	        (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) {
	      product = trim(data[1])
	        // Replace any language codes (eg. "en-US").
	        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '')
	        || null;
	    }
	    // Detect product names that contain their manufacturer's name.
	    if (manufacturer && !product) {
	      product = getProduct([manufacturer]);
	    } else if (manufacturer && product) {
	      product = product
	        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ')
	        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
	    }
	    // Clean up Google TV.
	    if ((data = /\bGoogle TV\b/.exec(product))) {
	      product = data[0];
	    }
	    // Detect simulators.
	    if (/\bSimulator\b/i.test(ua)) {
	      product = (product ? product + ' ' : '') + 'Simulator';
	    }
	    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
	    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
	      description.push('running in Turbo/Uncompressed mode');
	    }
	    // Detect IE Mobile 11.
	    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
	      data = parse(ua.replace(/like iPhone OS/, ''));
	      manufacturer = data.manufacturer;
	      product = data.product;
	    }
	    // Detect iOS.
	    else if (/^iP/.test(product)) {
	      name || (name = 'Safari');
	      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
	        ? ' ' + data[1].replace(/_/g, '.')
	        : '');
	    }
	    // Detect Kubuntu.
	    else if (name == 'Konqueror' && /^Linux\b/i.test(os)) {
	      os = 'Kubuntu';
	    }
	    // Detect Android browsers.
	    else if ((manufacturer && manufacturer != 'Google' &&
	        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
	        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
	      name = 'Android Browser';
	      os = /\bAndroid\b/.test(os) ? os : 'Android';
	    }
	    // Detect Silk desktop/accelerated modes.
	    else if (name == 'Silk') {
	      if (!/\bMobi/i.test(ua)) {
	        os = 'Android';
	        description.unshift('desktop mode');
	      }
	      if (/Accelerated *= *true/i.test(ua)) {
	        description.unshift('accelerated');
	      }
	    }
	    // Detect UC Browser speed mode.
	    else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) {
	      description.push('speed mode');
	    }
	    // Detect PaleMoon identifying as Firefox.
	    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
	      description.push('identifying as Firefox ' + data[1]);
	    }
	    // Detect Firefox OS and products running Firefox.
	    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
	      os || (os = 'Firefox OS');
	      product || (product = data[1]);
	    }
	    // Detect false positives for Firefox/Safari.
	    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
	      // Escape the `/` for Firefox 1.
	      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
	        // Clear name of false positives.
	        name = null;
	      }
	      // Reassign a generic name.
	      if ((data = product || manufacturer || os) &&
	          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
	        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
	      }
	    }
	    // Add Chrome version to description for Electron.
	    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
	      description.push('Chromium ' + data);
	    }
	    // Detect non-Opera (Presto-based) versions (order is important).
	    if (!version) {
	      version = getVersion([
	        '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
	        'Version',
	        qualify(name),
	        '(?:Firefox|Minefield|NetFront)'
	      ]);
	    }
	    // Detect stubborn layout engines.
	    if ((data =
	          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
	          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
	          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
	          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
	          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
	        )) {
	      layout = [data];
	    }
	    // Detect Windows Phone 7 desktop mode.
	    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
	      name += ' Mobile';
	      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
	      description.unshift('desktop mode');
	    }
	    // Detect Windows Phone 8.x desktop mode.
	    else if (/\bWPDesktop\b/i.test(ua)) {
	      name = 'IE Mobile';
	      os = 'Windows Phone 8.x';
	      description.unshift('desktop mode');
	      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
	    }
	    // Detect IE 11 identifying as other browsers.
	    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
	      if (name) {
	        description.push('identifying as ' + name + (version ? ' ' + version : ''));
	      }
	      name = 'IE';
	      version = data[1];
	    }
	    // Leverage environment features.
	    if (useFeatures) {
	      // Detect server-side environments.
	      // Rhino has a global function while others have a global object.
	      if (isHostType(context, 'global')) {
	        if (java) {
	          data = java.lang.System;
	          arch = data.getProperty('os.arch');
	          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
	        }
	        if (rhino) {
	          try {
	            version = context.require('ringo/engine').version.join('.');
	            name = 'RingoJS';
	          } catch(e) {
	            if ((data = context.system) && data.global.system == context.system) {
	              name = 'Narwhal';
	              os || (os = data[0].os || null);
	            }
	          }
	          if (!name) {
	            name = 'Rhino';
	          }
	        }
	        else if (
	          typeof context.process == 'object' && !context.process.browser &&
	          (data = context.process)
	        ) {
	          if (typeof data.versions == 'object') {
	            if (typeof data.versions.electron == 'string') {
	              description.push('Node ' + data.versions.node);
	              name = 'Electron';
	              version = data.versions.electron;
	            } else if (typeof data.versions.nw == 'string') {
	              description.push('Chromium ' + version, 'Node ' + data.versions.node);
	              name = 'NW.js';
	              version = data.versions.nw;
	            }
	          }
	          if (!name) {
	            name = 'Node.js';
	            arch = data.arch;
	            os = data.platform;
	            version = /[\d.]+/.exec(data.version);
	            version = version ? version[0] : null;
	          }
	        }
	      }
	      // Detect Adobe AIR.
	      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
	        name = 'Adobe AIR';
	        os = data.flash.system.Capabilities.os;
	      }
	      // Detect PhantomJS.
	      else if (getClassOf((data = context.phantom)) == phantomClass) {
	        name = 'PhantomJS';
	        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
	      }
	      // Detect IE compatibility modes.
	      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
	        // We're in compatibility mode when the Trident version + 4 doesn't
	        // equal the document mode.
	        version = [version, doc.documentMode];
	        if ((data = +data[1] + 4) != version[1]) {
	          description.push('IE ' + version[1] + ' mode');
	          layout && (layout[1] = '');
	          version[1] = data;
	        }
	        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
	      }
	      // Detect IE 11 masking as other browsers.
	      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
	        description.push('masking as ' + name + ' ' + version);
	        name = 'IE';
	        version = '11.0';
	        layout = ['Trident'];
	        os = 'Windows';
	      }
	      os = os && format(os);
	    }
	    // Detect prerelease phases.
	    if (version && (data =
	          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
	          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
	          /\bMinefield\b/i.test(ua) && 'a'
	        )) {
	      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
	      version = version.replace(RegExp(data + '\\+?$'), '') +
	        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
	    }
	    // Detect Firefox Mobile.
	    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) {
	      name = 'Firefox Mobile';
	    }
	    // Obscure Maxthon's unreliable version.
	    else if (name == 'Maxthon' && version) {
	      version = version.replace(/\.[\d.]+/, '.x');
	    }
	    // Detect Xbox 360 and Xbox One.
	    else if (/\bXbox\b/i.test(product)) {
	      if (product == 'Xbox 360') {
	        os = null;
	      }
	      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
	        description.unshift('mobile mode');
	      }
	    }
	    // Add mobile postfix.
	    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
	        (os == 'Windows CE' || /Mobi/i.test(ua))) {
	      name += ' Mobile';
	    }
	    // Detect IE platform preview.
	    else if (name == 'IE' && useFeatures) {
	      try {
	        if (context.external === null) {
	          description.unshift('platform preview');
	        }
	      } catch(e) {
	        description.unshift('embedded');
	      }
	    }
	    // Detect BlackBerry OS version.
	    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
	    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
	          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
	          version
	        )) {
	      data = [data, /BB10/.test(ua)];
	      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
	      version = null;
	    }
	    // Detect Opera identifying/masking itself as another browser.
	    // http://www.opera.com/support/kb/view/843/
	    else if (this != forOwn && product != 'Wii' && (
	          (useFeatures && opera) ||
	          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
	          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
	          (name == 'IE' && (
	            (os && !/^Win/.test(os) && version > 5.5) ||
	            /\bWindows XP\b/.test(os) && version > 8 ||
	            version == 8 && !/\bTrident\b/.test(ua)
	          ))
	        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
	      // When "identifying", the UA contains both Opera and the other browser's name.
	      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
	      if (reOpera.test(name)) {
	        if (/\bIE\b/.test(data) && os == 'Mac OS') {
	          os = null;
	        }
	        data = 'identify' + data;
	      }
	      // When "masking", the UA contains only the other browser's name.
	      else {
	        data = 'mask' + data;
	        if (operaClass) {
	          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
	        } else {
	          name = 'Opera';
	        }
	        if (/\bIE\b/.test(data)) {
	          os = null;
	        }
	        if (!useFeatures) {
	          version = null;
	        }
	      }
	      layout = ['Presto'];
	      description.push(data);
	    }
	    // Detect WebKit Nightly and approximate Chrome/Safari versions.
	    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	      // Correct build number for numeric comparison.
	      // (e.g. "532.5" becomes "532.05")
	      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
	      // Nightly builds are postfixed with a "+".
	      if (name == 'Safari' && data[1].slice(-1) == '+') {
	        name = 'WebKit Nightly';
	        prerelease = 'alpha';
	        version = data[1].slice(0, -1);
	      }
	      // Clear incorrect browser versions.
	      else if (version == data[1] ||
	          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	        version = null;
	      }
	      // Use the full Chrome version when available.
	      data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
	      // Detect Blink layout engine.
	      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
	        layout = ['Blink'];
	      }
	      // Detect JavaScriptCore.
	      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
	      if (!useFeatures || (!likeChrome && !data[1])) {
	        layout && (layout[1] = 'like Safari');
	        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
	      } else {
	        layout && (layout[1] = 'like Chrome');
	        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
	      }
	      // Add the postfix of ".x" or "+" for approximate versions.
	      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
	      // Obscure version for some Safari 1-2 releases.
	      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
	        version = data;
	      } else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) {
	        description.unshift('headless');
	      }
	    }
	    // Detect Opera desktop modes.
	    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
	      name += ' ';
	      description.unshift('desktop mode');
	      if (data == 'zvav') {
	        name += 'Mini';
	        version = null;
	      } else {
	        name += 'Mobile';
	      }
	      os = os.replace(RegExp(' *' + data + '$'), '');
	    }
	    // Detect Chrome desktop mode.
	    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
	      description.unshift('desktop mode');
	      name = 'Chrome Mobile';
	      version = null;
	
	      if (/\bOS X\b/.test(os)) {
	        manufacturer = 'Apple';
	        os = 'iOS 4.3+';
	      } else {
	        os = null;
	      }
	    }
	    // Newer versions of SRWare Iron uses the Chrome tag to indicate its version number.
	    else if (/\bSRWare Iron\b/.test(name) && !version) {
	      version = getVersion('Chrome');
	    }
	    // Strip incorrect OS versions.
	    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
	        ua.indexOf('/' + data + '-') > -1) {
	      os = trim(os.replace(data, ''));
	    }
	    // Ensure OS does not include the browser name.
	    if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) {
	      os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
	    }
	    // Add layout engine.
	    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
	        /Browser|Lunascape|Maxthon/.test(name) ||
	        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
	        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) {
	      // Don't add layout details to description if they are falsey.
	      (data = layout[layout.length - 1]) && description.push(data);
	    }
	    // Combine contextual information.
	    if (description.length) {
	      description = ['(' + description.join('; ') + ')'];
	    }
	    // Append manufacturer to description.
	    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
	      description.push('on ' + manufacturer);
	    }
	    // Append product to description.
	    if (product) {
	      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
	    }
	    // Parse the OS into an object.
	    if (os) {
	      data = / ([\d.+]+)$/.exec(os);
	      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
	      os = {
	        'architecture': 32,
	        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
	        'version': data ? data[1] : null,
	        'toString': function() {
	          var version = this.version;
	          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
	        }
	      };
	    }
	    // Add browser/OS architecture.
	    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
	      if (os) {
	        os.architecture = 64;
	        os.family = os.family.replace(RegExp(' *' + data), '');
	      }
	      if (
	          name && (/\bWOW64\b/i.test(ua) ||
	          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
	      ) {
	        description.unshift('32-bit');
	      }
	    }
	    // Chrome 39 and above on OS X is always 64-bit.
	    else if (
	        os && /^OS X/.test(os.family) &&
	        name == 'Chrome' && parseFloat(version) >= 39
	    ) {
	      os.architecture = 64;
	    }
	
	    ua || (ua = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The platform object.
	     *
	     * @name platform
	     * @type Object
	     */
	    var platform = {};
	
	    /**
	     * The platform description.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.description = ua;
	
	    /**
	     * The name of the browser's layout engine.
	     *
	     * The list of common layout engines include:
	     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.layout = layout && layout[0];
	
	    /**
	     * The name of the product's manufacturer.
	     *
	     * The list of manufacturers include:
	     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
	     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
	     * "Nokia", "Samsung" and "Sony"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.manufacturer = manufacturer;
	
	    /**
	     * The name of the browser/environment.
	     *
	     * The list of common browser names include:
	     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
	     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
	     * "Opera Mini" and "Opera"
	     *
	     * Mobile versions of some browsers have "Mobile" appended to their name:
	     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.name = name;
	
	    /**
	     * The alpha/beta release indicator.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.prerelease = prerelease;
	
	    /**
	     * The name of the product hosting the browser.
	     *
	     * The list of common products include:
	     *
	     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
	     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.product = product;
	
	    /**
	     * The browser's user agent string.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.ua = ua;
	
	    /**
	     * The browser/environment version.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.version = name && version;
	
	    /**
	     * The name of the operating system.
	     *
	     * @memberOf platform
	     * @type Object
	     */
	    platform.os = os || {
	
	      /**
	       * The CPU architecture the OS is built for.
	       *
	       * @memberOf platform.os
	       * @type number|null
	       */
	      'architecture': null,
	
	      /**
	       * The family of the OS.
	       *
	       * Common values include:
	       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
	       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
	       * "SuSE", "Android", "iOS" and "Windows Phone"
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'family': null,
	
	      /**
	       * The version of the OS.
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'version': null,
	
	      /**
	       * Returns the OS string.
	       *
	       * @memberOf platform.os
	       * @returns {string} The OS string.
	       */
	      'toString': function() { return 'null'; }
	    };
	
	    platform.parse = parse;
	    platform.toString = toStringPlatform;
	
	    if (platform.version) {
	      description.unshift(version);
	    }
	    if (platform.name) {
	      description.unshift(name);
	    }
	    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
	      description.push(product ? '(' + os + ')' : 'on ' + os);
	    }
	    if (description.length) {
	      platform.description = description.join(' ');
	    }
	    return platform;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export platform.
	  var platform = parse();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
	  if (true) {
	    // Expose platform on the global object to prevent errors when platform is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    root.platform = platform;
	
	    // Define as an anonymous module so platform can be aliased through path mapping.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return platform;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for CommonJS support.
	    forOwn(platform, function(value, key) {
	      freeExports[key] = value;
	    });
	  }
	  else {
	    // Export to the global object.
	    root.platform = platform;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module), (function() { return this; }())))

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = require('./lib/has');
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1043);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(534);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(271);
	var assign = __webpack_require__(17);
	
	var ReactPropTypesSecret = __webpack_require__(534);
	var has = __webpack_require__(1044);
	var checkPropTypes = __webpack_require__(1040);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1044 */
/***/ function(module, exports) {

	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1666);
	var objectAssign = __webpack_require__(17);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1046 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 1047 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(1046);
	exports.encode = exports.stringify = __webpack_require__(1047);


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(66);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(970);
	
	var _addEventListener = __webpack_require__(252);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _util = __webpack_require__(1051);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElement(func) {
	  if (typeof func !== 'function' || !func) return null;
	  return func();
	}
	
	function getPoint(point) {
	  if (typeof point !== 'object' || !point) return null;
	  return point;
	}
	
	var Align = function (_Component) {
	  (0, _inherits3['default'])(Align, _Component);
	
	  function Align() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Align);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          target = _this$props.target,
	          align = _this$props.align,
	          onAlign = _this$props.onAlign;
	
	      if (!disabled && target) {
	        var source = _reactDom2['default'].findDOMNode(_this);
	
	        var result = void 0;
	        var element = getElement(target);
	        var point = getPoint(target);
	
	        // IE lose focus after element realign
	        // We should record activeElement and restore later
	        var activeElement = document.activeElement;
	
	        if (element) {
	          result = (0, _domAlign.alignElement)(source, element, align);
	        } else if (point) {
	          result = (0, _domAlign.alignPoint)(source, point, align);
	        }
	
	        (0, _util.restoreFocus)(activeElement, source);
	
	        if (onAlign) {
	          onAlign(source, result);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Align, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var props = this.props;
	      // if parent ref not attached .... use document.getElementById
	      this.forceAlign();
	      if (!props.disabled && props.monitorWindowResize) {
	        this.startMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var reAlign = false;
	      var props = this.props;
	
	      if (!props.disabled) {
	        var source = _reactDom2['default'].findDOMNode(this);
	        var sourceRect = source ? source.getBoundingClientRect() : null;
	
	        if (prevProps.disabled) {
	          reAlign = true;
	        } else {
	          var lastElement = getElement(prevProps.target);
	          var currentElement = getElement(props.target);
	          var lastPoint = getPoint(prevProps.target);
	          var currentPoint = getPoint(props.target);
	
	          if ((0, _util.isWindow)(lastElement) && (0, _util.isWindow)(currentElement)) {
	            // Skip if is window
	            reAlign = false;
	          } else if (lastElement !== currentElement || // Element change
	          lastElement && !currentElement && currentPoint || // Change from element to point
	          lastPoint && currentPoint && currentElement || // Change from point to element
	          currentPoint && !(0, _util.isSamePoint)(lastPoint, currentPoint)) {
	            reAlign = true;
	          }
	
	          // If source element size changed
	          var preRect = this.sourceRect || {};
	          if (!reAlign && source && (!(0, _util.isSimilarValue)(preRect.width, sourceRect.width) || !(0, _util.isSimilarValue)(preRect.height, sourceRect.height))) {
	            reAlign = true;
	          }
	        }
	
	        this.sourceRect = sourceRect;
	      }
	
	      if (reAlign) {
	        this.forceAlign();
	      }
	
	      if (props.monitorWindowResize && !props.disabled) {
	        this.startMonitorWindowResize();
	      } else {
	        this.stopMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopMonitorWindowResize();
	    }
	  }, {
	    key: 'startMonitorWindowResize',
	    value: function startMonitorWindowResize() {
	      if (!this.resizeHandler) {
	        this.bufferMonitor = (0, _util.buffer)(this.forceAlign, this.props.monitorBufferTime);
	        this.resizeHandler = (0, _addEventListener2['default'])(window, 'resize', this.bufferMonitor);
	      }
	    }
	  }, {
	    key: 'stopMonitorWindowResize',
	    value: function stopMonitorWindowResize() {
	      if (this.resizeHandler) {
	        this.bufferMonitor.clear();
	        this.resizeHandler.remove();
	        this.resizeHandler = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          childrenProps = _props.childrenProps,
	          children = _props.children;
	
	      var child = _react2['default'].Children.only(children);
	      if (childrenProps) {
	        var newProps = {};
	        var propList = Object.keys(childrenProps);
	        propList.forEach(function (prop) {
	          newProps[prop] = _this2.props[childrenProps[prop]];
	        });
	
	        return _react2['default'].cloneElement(child, newProps);
	      }
	      return child;
	    }
	  }]);
	  return Align;
	}(_react.Component);
	
	Align.propTypes = {
	  childrenProps: _propTypes2['default'].object,
	  align: _propTypes2['default'].object.isRequired,
	  target: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].shape({
	    clientX: _propTypes2['default'].number,
	    clientY: _propTypes2['default'].number,
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })]),
	  onAlign: _propTypes2['default'].func,
	  monitorBufferTime: _propTypes2['default'].number,
	  monitorWindowResize: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any
	};
	Align.defaultProps = {
	  target: function target() {
	    return window;
	  },
	  monitorBufferTime: 50,
	  monitorWindowResize: false,
	  disabled: false
	};
	exports['default'] = Align;
	module.exports = exports['default'];

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Align = __webpack_require__(1049);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Align2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffer = buffer;
	exports.isSamePoint = isSamePoint;
	exports.isWindow = isWindow;
	exports.isSimilarValue = isSimilarValue;
	exports.restoreFocus = restoreFocus;
	
	var _contains = __webpack_require__(542);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;
	
	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }
	
	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }
	
	  return false;
	}
	
	function isWindow(obj) {
	  return obj && typeof obj === 'object' && obj.window === obj;
	}
	
	function isSimilarValue(val1, val2) {
	  var int1 = Math.floor(val1);
	  var int2 = Math.floor(val2);
	  return Math.abs(int1 - int2) <= 1;
	}
	
	function restoreFocus(activeElement, container) {
	  // Focus back if is in the container
	  if (activeElement !== document.activeElement && (0, _contains2['default'])(container, activeElement)) {
	    activeElement.focus();
	  }
	}

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(66);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _unsafeLifecyclesPolyfill = __webpack_require__(1070);
	
	var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
	
	var _ChildrenUtils = __webpack_require__(1054);
	
	var _AnimateChild = __webpack_require__(1053);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _animate = __webpack_require__(537);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  // eslint-disable-line
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.propTypes = {
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = (0, _unsafeLifecyclesPolyfill2['default'])(Animate);
	module.exports = exports['default'];

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(66);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(962);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(537);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any,
	  animation: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(386);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Track = __webpack_require__(538);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(539);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(251);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Range = function (_React$Component) {
	  (0, _inherits3["default"])(Range, _React$Component);
	
	  function Range(props) {
	    (0, _classCallCheck3["default"])(this, Range);
	
	    var _this = (0, _possibleConstructorReturn3["default"])(this, _React$Component.call(this, props));
	
	    _this.onEnd = function () {
	      _this.setState({ handle: null });
	      _this.removeDocumentEvents();
	      _this.props.onAfterChange(_this.getValue());
	    };
	
	    var count = props.count,
	        min = props.min,
	        max = props.max;
	
	    var initialValue = Array.apply(null, Array(count + 1)).map(function () {
	      return min;
	    });
	    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
	    var value = props.value !== undefined ? props.value : defaultValue;
	    var bounds = value.map(function (v) {
	      return _this.trimAlignValue(v);
	    });
	    var recent = bounds[0] === max ? 0 : bounds.length - 1;
	
	    _this.state = {
	      handle: null,
	      recent: recent,
	      bounds: bounds
	    };
	    return _this;
	  }
	
	  Range.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
	    var bounds = this.state.bounds;
	
	    var value = nextProps.value || bounds;
	    var nextBounds = value.map(function (v) {
	      return _this2.trimAlignValue(v, nextProps);
	    });
	    if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
	      return v === bounds[i];
	    })) return;
	
	    this.setState({ bounds: nextBounds });
	    if (bounds.some(function (v) {
	      return utils.isValueOutOfRange(v, nextProps);
	    })) {
	      this.props.onChange(nextBounds);
	    }
	  };
	
	  Range.prototype.onChange = function onChange(state) {
	    var props = this.props;
	    var isNotControlled = !('value' in props);
	    if (isNotControlled) {
	      this.setState(state);
	    } else if (state.handle !== undefined) {
	      this.setState({ handle: state.handle });
	    }
	
	    var data = (0, _extends3["default"])({}, this.state, state);
	    var changedValue = data.bounds;
	    props.onChange(changedValue);
	  };
	
	  Range.prototype.onStart = function onStart(position) {
	    var props = this.props;
	    var state = this.state;
	    var bounds = this.getValue();
	    props.onBeforeChange(bounds);
	
	    var value = this.calcValueByPos(position);
	    this.startValue = value;
	    this.startPosition = position;
	
	    var closestBound = this.getClosestBound(value);
	    var boundNeedMoving = this.getBoundNeedMoving(value, closestBound);
	
	    this.setState({
	      handle: boundNeedMoving,
	      recent: boundNeedMoving
	    });
	
	    var prevValue = bounds[boundNeedMoving];
	    if (value === prevValue) return;
	
	    var nextBounds = [].concat((0, _toConsumableArray3["default"])(state.bounds));
	    nextBounds[boundNeedMoving] = value;
	    this.onChange({ bounds: nextBounds });
	  };
	
	  Range.prototype.onMove = function onMove(e, position) {
	    utils.pauseEvent(e);
	    var props = this.props;
	    var state = this.state;
	
	    var value = this.calcValueByPos(position);
	    var oldValue = state.bounds[state.handle];
	    if (value === oldValue) return;
	
	    var nextBounds = [].concat((0, _toConsumableArray3["default"])(state.bounds));
	    nextBounds[state.handle] = value;
	    var nextHandle = state.handle;
	    if (props.pushable !== false) {
	      var originalValue = state.bounds[nextHandle];
	      this.pushSurroundingHandles(nextBounds, nextHandle, originalValue);
	    } else if (props.allowCross) {
	      nextBounds.sort(function (a, b) {
	        return a - b;
	      });
	      nextHandle = nextBounds.indexOf(value);
	    }
	    this.onChange({
	      handle: nextHandle,
	      bounds: nextBounds
	    });
	  };
	
	  Range.prototype.getValue = function getValue() {
	    return this.state.bounds;
	  };
	
	  Range.prototype.getClosestBound = function getClosestBound(value) {
	    var bounds = this.state.bounds;
	
	    var closestBound = 0;
	    for (var i = 1; i < bounds.length - 1; ++i) {
	      if (value > bounds[i]) {
	        closestBound = i;
	      }
	    }
	    if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
	      closestBound = closestBound + 1;
	    }
	    return closestBound;
	  };
	
	  Range.prototype.getBoundNeedMoving = function getBoundNeedMoving(value, closestBound) {
	    var _state = this.state,
	        bounds = _state.bounds,
	        recent = _state.recent;
	
	    var boundNeedMoving = closestBound;
	    var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
	    if (isAtTheSamePoint) {
	      boundNeedMoving = recent;
	    }
	
	    if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
	      boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
	    }
	    return boundNeedMoving;
	  };
	
	  Range.prototype.getLowerBound = function getLowerBound() {
	    return this.state.bounds[0];
	  };
	
	  Range.prototype.getUpperBound = function getUpperBound() {
	    var bounds = this.state.bounds;
	
	    return bounds[bounds.length - 1];
	  };
	
	  /**
	   * Returns an array of possible slider points, taking into account both
	   * `marks` and `step`. The result is cached.
	   */
	
	
	  Range.prototype.getPoints = function getPoints() {
	    var _props = this.props,
	        marks = _props.marks,
	        step = _props.step,
	        min = _props.min,
	        max = _props.max;
	
	    var cache = this._getPointsCache;
	    if (!cache || cache.marks !== marks || cache.step !== step) {
	      var pointsObject = (0, _extends3["default"])({}, marks);
	      if (step !== null) {
	        for (var point = min; point <= max; point += step) {
	          pointsObject[point] = point;
	        }
	      }
	      var points = Object.keys(pointsObject).map(parseFloat);
	      points.sort(function (a, b) {
	        return a - b;
	      });
	      this._getPointsCache = { marks: marks, step: step, points: points };
	    }
	    return this._getPointsCache.points;
	  };
	
	  Range.prototype.pushSurroundingHandles = function pushSurroundingHandles(bounds, handle, originalValue) {
	    var threshold = this.props.pushable;
	
	    var value = bounds[handle];
	
	    var direction = 0;
	    if (bounds[handle + 1] - value < threshold) {
	      direction = +1; // push to right
	    }
	    if (value - bounds[handle - 1] < threshold) {
	      direction = -1; // push to left
	    }
	
	    if (direction === 0) {
	      return;
	    }
	
	    var nextHandle = handle + direction;
	    var diffToNext = direction * (bounds[nextHandle] - value);
	    if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	      // revert to original value if pushing is impossible
	      bounds[handle] = originalValue;
	    }
	  };
	
	  Range.prototype.pushHandle = function pushHandle(bounds, handle, direction, amount) {
	    var originalValue = bounds[handle];
	    var currentValue = bounds[handle];
	    while (direction * (currentValue - originalValue) < amount) {
	      if (!this.pushHandleOnePoint(bounds, handle, direction)) {
	        // can't push handle enough to create the needed `amount` gap, so we
	        // revert its position to the original value
	        bounds[handle] = originalValue;
	        return false;
	      }
	      currentValue = bounds[handle];
	    }
	    // the handle was pushed enough to create the needed `amount` gap
	    return true;
	  };
	
	  Range.prototype.pushHandleOnePoint = function pushHandleOnePoint(bounds, handle, direction) {
	    var points = this.getPoints();
	    var pointIndex = points.indexOf(bounds[handle]);
	    var nextPointIndex = pointIndex + direction;
	    if (nextPointIndex >= points.length || nextPointIndex < 0) {
	      // reached the minimum or maximum available point, can't push anymore
	      return false;
	    }
	    var nextHandle = handle + direction;
	    var nextValue = points[nextPointIndex];
	    var threshold = this.props.pushable;
	
	    var diffToNext = direction * (bounds[nextHandle] - nextValue);
	    if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	      // couldn't push next handle, so we won't push this one either
	      return false;
	    }
	    // push the handle
	    bounds[handle] = nextValue;
	    return true;
	  };
	
	  Range.prototype.trimAlignValue = function trimAlignValue(v) {
	    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var mergedProps = (0, _extends3["default"])({}, this.props, nextProps);
	    var valInRange = utils.ensureValueInRange(v, mergedProps);
	    var valNotConflict = this.ensureValueNotConflict(valInRange, mergedProps);
	    return utils.ensureValuePrecision(valNotConflict, mergedProps);
	  };
	
	  Range.prototype.ensureValueNotConflict = function ensureValueNotConflict(val, _ref) {
	    var allowCross = _ref.allowCross;
	
	    var state = this.state || {};
	    var handle = state.handle,
	        bounds = state.bounds;
	    /* eslint-disable eqeqeq */
	
	    if (!allowCross && handle != null) {
	      if (handle > 0 && val <= bounds[handle - 1]) {
	        return bounds[handle - 1];
	      }
	      if (handle < bounds.length - 1 && val >= bounds[handle + 1]) {
	        return bounds[handle + 1];
	      }
	    }
	    /* eslint-enable eqeqeq */
	    return val;
	  };
	
	  Range.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state2 = this.state,
	        handle = _state2.handle,
	        bounds = _state2.bounds;
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        vertical = _props2.vertical,
	        included = _props2.included,
	        disabled = _props2.disabled,
	        handleGenerator = _props2.handle;
	
	
	    var offsets = bounds.map(function (v) {
	      return _this3.calcOffset(v);
	    });
	
	    var handleClassName = prefixCls + '-handle';
	    var handles = bounds.map(function (v, i) {
	      var _classNames;
	
	      return handleGenerator({
	        className: (0, _classnames2["default"])((_classNames = {}, (0, _defineProperty3["default"])(_classNames, handleClassName, true), (0, _defineProperty3["default"])(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
	        vertical: vertical,
	        offset: offsets[i],
	        value: v,
	        dragging: handle === i,
	        index: i,
	        disabled: disabled,
	        ref: function ref(h) {
	          return _this3.saveHandle(i, h);
	        }
	      });
	    });
	
	    var tracks = bounds.slice(0, -1).map(function (_, index) {
	      var _classNames2;
	
	      var i = index + 1;
	      var trackClassName = (0, _classnames2["default"])((_classNames2 = {}, (0, _defineProperty3["default"])(_classNames2, prefixCls + '-track', true), (0, _defineProperty3["default"])(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
	      return _react2["default"].createElement(_Track2["default"], {
	        className: trackClassName,
	        vertical: vertical,
	        included: included,
	        offset: offsets[i - 1],
	        length: offsets[i] - offsets[i - 1],
	        key: i
	      });
	    });
	
	    return { tracks: tracks, handles: handles };
	  };
	
	  return Range;
	}(_react2["default"].Component); /* eslint-disable react/prop-types */
	
	
	Range.displayName = 'Range';
	Range.propTypes = {
	  defaultValue: _react.PropTypes.arrayOf(_react.PropTypes.number),
	  value: _react.PropTypes.arrayOf(_react.PropTypes.number),
	  count: _react.PropTypes.number,
	  pushable: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.number]),
	  allowCross: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool
	};
	Range.defaultProps = {
	  count: 1,
	  allowCross: true,
	  pushable: false
	};
	exports["default"] = (0, _createSlider2["default"])(Range);
	module.exports = exports['default'];

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Track = __webpack_require__(538);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(539);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(251);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/* eslint-disable react/prop-types */
	var Slider = function (_React$Component) {
	  (0, _inherits3["default"])(Slider, _React$Component);
	
	  function Slider(props) {
	    (0, _classCallCheck3["default"])(this, Slider);
	
	    var _this = (0, _possibleConstructorReturn3["default"])(this, _React$Component.call(this, props));
	
	    _this.onEnd = function () {
	      _this.setState({ dragging: false });
	      _this.removeDocumentEvents();
	      _this.props.onAfterChange(_this.getValue());
	    };
	
	    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
	    var value = props.value !== undefined ? props.value : defaultValue;
	
	    _this.state = {
	      value: _this.trimAlignValue(value),
	      dragging: false
	    };
	    return _this;
	  }
	
	  Slider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
	
	    var prevValue = this.state.value;
	    var value = nextProps.value !== undefined ? nextProps.value : prevValue;
	    var nextValue = this.trimAlignValue(value, nextProps);
	    if (nextValue === prevValue) return;
	
	    this.setState({ value: nextValue });
	    if (utils.isValueOutOfRange(value, nextProps)) {
	      this.props.onChange(nextValue);
	    }
	  };
	
	  Slider.prototype.onChange = function onChange(state) {
	    var props = this.props;
	    var isNotControlled = !('value' in props);
	    if (isNotControlled) {
	      this.setState(state);
	    }
	
	    var changedValue = state.value;
	    props.onChange(changedValue);
	  };
	
	  Slider.prototype.onStart = function onStart(position) {
	    this.setState({ dragging: true });
	    var props = this.props;
	    var prevValue = this.getValue();
	    props.onBeforeChange(prevValue);
	
	    var value = this.calcValueByPos(position);
	    this.startValue = value;
	    this.startPosition = position;
	
	    if (value === prevValue) return;
	
	    this.onChange({ value: value });
	  };
	
	  Slider.prototype.onMove = function onMove(e, position) {
	    utils.pauseEvent(e);
	    var state = this.state;
	    var value = this.calcValueByPos(position);
	    var oldValue = state.value;
	    if (value === oldValue) return;
	
	    this.onChange({ value: value });
	  };
	
	  Slider.prototype.getValue = function getValue() {
	    return this.state.value;
	  };
	
	  Slider.prototype.getLowerBound = function getLowerBound() {
	    return this.props.min;
	  };
	
	  Slider.prototype.getUpperBound = function getUpperBound() {
	    return this.state.value;
	  };
	
	  Slider.prototype.trimAlignValue = function trimAlignValue(v) {
	    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var mergedProps = (0, _extends3["default"])({}, this.props, nextProps);
	    var val = utils.ensureValueInRange(v, mergedProps);
	    return utils.ensureValuePrecision(val, mergedProps);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        vertical = _props.vertical,
	        included = _props.included,
	        disabled = _props.disabled,
	        minimumTrackTintColor = _props.minimumTrackTintColor,
	        handleGenerator = _props.handle;
	    var _state = this.state,
	        value = _state.value,
	        dragging = _state.dragging;
	
	    var offset = this.calcOffset(value);
	    var handle = handleGenerator({
	      className: prefixCls + '-handle',
	      vertical: vertical,
	      offset: offset,
	      value: value,
	      dragging: dragging,
	      disabled: disabled,
	      minimumTrackTintColor: minimumTrackTintColor,
	      ref: function ref(h) {
	        return _this2.saveHandle(0, h);
	      }
	    });
	    var track = _react2["default"].createElement(_Track2["default"], {
	      className: prefixCls + '-track',
	      vertical: vertical,
	      included: included,
	      offset: 0,
	      disabled: disabled,
	      length: offset,
	      minimumTrackTintColor: minimumTrackTintColor
	    });
	
	    return { tracks: track, handles: handle };
	  };
	
	  return Slider;
	}(_react2["default"].Component);
	
	Slider.displayName = 'Slider';
	Slider.propTypes = {
	  defaultValue: _react.PropTypes.number,
	  value: _react.PropTypes.number,
	  disabled: _react.PropTypes.bool
	};
	Slider.defaultProps = {};
	exports["default"] = (0, _createSlider2["default"])(Slider);
	module.exports = exports['default'];

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(153);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Marks = function Marks(_ref) {
	  var className = _ref.className,
	      vertical = _ref.vertical,
	      marks = _ref.marks,
	      included = _ref.included,
	      upperBound = _ref.upperBound,
	      lowerBound = _ref.lowerBound,
	      max = _ref.max,
	      min = _ref.min;
	
	  var marksKeys = Object.keys(marks);
	  var marksCount = marksKeys.length;
	  var unit = 100 / (marksCount - 1);
	  var markWidth = unit * 0.9;
	
	  var range = max - min;
	  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
	    return a - b;
	  }).map(function (point) {
	    var _classNames;
	
	    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var markClassName = (0, _classnames2["default"])((_classNames = {}, (0, _defineProperty3["default"])(_classNames, className + '-text', true), (0, _defineProperty3["default"])(_classNames, className + '-text-active', isActive), _classNames));
	
	    var bottomStyle = {
	      marginBottom: '-50%',
	      bottom: (point - min) / range * 100 + '%'
	    };
	
	    var leftStyle = {
	      width: markWidth + '%',
	      marginLeft: -markWidth / 2 + '%',
	      left: (point - min) / range * 100 + '%'
	    };
	
	    var style = vertical ? bottomStyle : leftStyle;
	
	    var markPoint = marks[point];
	    var markPointIsObject = (typeof markPoint === 'undefined' ? 'undefined' : (0, _typeof3["default"])(markPoint)) === 'object' && !_react2["default"].isValidElement(markPoint);
	    var markLabel = markPointIsObject ? markPoint.label : markPoint;
	    var markStyle = markPointIsObject ? (0, _extends3["default"])({}, style, markPoint.style) : style;
	    return _react2["default"].createElement(
	      'span',
	      {
	        className: markClassName,
	        style: markStyle,
	        key: point
	      },
	      markLabel
	    );
	  });
	
	  return _react2["default"].createElement(
	    'div',
	    { className: className },
	    elements
	  );
	};
	
	exports["default"] = Marks;
	module.exports = exports['default'];

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(52);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
	  (0, _warning2["default"])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
	  var points = Object.keys(marks).map(parseFloat);
	  if (dots) {
	    for (var i = min; i <= max; i = i + step) {
	      if (points.indexOf(i) >= 0) continue;
	      points.push(i);
	    }
	  }
	  return points;
	};
	
	var Steps = function Steps(_ref) {
	  var prefixCls = _ref.prefixCls,
	      vertical = _ref.vertical,
	      marks = _ref.marks,
	      dots = _ref.dots,
	      step = _ref.step,
	      included = _ref.included,
	      lowerBound = _ref.lowerBound,
	      upperBound = _ref.upperBound,
	      max = _ref.max,
	      min = _ref.min;
	
	  var range = max - min;
	  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
	    var _classNames;
	
	    var offset = Math.abs(point - min) / range * 100 + '%';
	    var style = vertical ? { bottom: offset } : { left: offset };
	
	    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var pointClassName = (0, _classnames2["default"])((_classNames = {}, (0, _defineProperty3["default"])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3["default"])(_classNames, prefixCls + '-dot-active', isActived), _classNames));
	
	    return _react2["default"].createElement('span', { className: pointClassName, style: style, key: point });
	  });
	
	  return _react2["default"].createElement(
	    'div',
	    { className: prefixCls + '-step' },
	    elements
	  );
	};
	
	exports["default"] = Steps;
	module.exports = exports['default'];

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(82);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(101);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(33);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports["default"] = createSliderWithTooltip;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rcTooltip = __webpack_require__(1063);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _Handle = __webpack_require__(250);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function createSliderWithTooltip(Component) {
	  var _class, _temp;
	
	  return _temp = _class = function (_React$Component) {
	    (0, _inherits3["default"])(ComponentWrapper, _React$Component);
	
	    function ComponentWrapper(props) {
	      (0, _classCallCheck3["default"])(this, ComponentWrapper);
	
	      var _this = (0, _possibleConstructorReturn3["default"])(this, _React$Component.call(this, props));
	
	      _this.handleTooltipVisibleChange = function (index, visible) {
	        _this.setState({
	          visibles: (0, _extends4["default"])({}, _this.state.visibles, (0, _defineProperty3["default"])({}, index, visible))
	        });
	      };
	
	      _this.handleWithTooltip = function (_ref) {
	        var value = _ref.value,
	            dragging = _ref.dragging,
	            index = _ref.index,
	            disabled = _ref.disabled,
	            restProps = (0, _objectWithoutProperties3["default"])(_ref, ['value', 'dragging', 'index', 'disabled']);
	        var tipFormatter = _this.props.tipFormatter;
	
	        return _react2["default"].createElement(
	          _rcTooltip2["default"],
	          {
	            prefixCls: 'rc-slider-tooltip',
	            overlay: tipFormatter(value),
	            visible: !disabled && (_this.state.visibles[index] || dragging),
	            placement: 'top',
	            key: index
	          },
	          _react2["default"].createElement(_Handle2["default"], (0, _extends4["default"])({}, restProps, {
	            onMouseEnter: function onMouseEnter() {
	              return _this.handleTooltipVisibleChange(index, true);
	            },
	            onMouseLeave: function onMouseLeave() {
	              return _this.handleTooltipVisibleChange(index, false);
	            }
	          }))
	        );
	      };
	
	      _this.state = { visibles: {} };
	      return _this;
	    }
	
	    ComponentWrapper.prototype.render = function render() {
	      return _react2["default"].createElement(Component, (0, _extends4["default"])({}, this.props, { handle: this.handleWithTooltip }));
	    };
	
	    return ComponentWrapper;
	  }(_react2["default"].Component), _class.propTypes = {
	    tipFormatter: _react2["default"].PropTypes.func
	  }, _class.defaultProps = {
	    tipFormatter: function tipFormatter(value) {
	      return value;
	    }
	  }, _temp;
	}
	module.exports = exports['default'];

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Slider = __webpack_require__(1056);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Range = __webpack_require__(1055);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	var _Handle = __webpack_require__(250);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _createSliderWithTooltip = __webpack_require__(1059);
	
	var _createSliderWithTooltip2 = _interopRequireDefault(_createSliderWithTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Slider2["default"].Range = _Range2["default"];
	_Slider2["default"].Handle = _Handle2["default"];
	_Slider2["default"].createSliderWithTooltip = _createSliderWithTooltip2["default"];
	exports["default"] = _Slider2["default"];
	module.exports = exports['default'];

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Content = function (_React$Component) {
	  (0, _inherits3['default'])(Content, _React$Component);
	
	  function Content() {
	    (0, _classCallCheck3['default'])(this, Content);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Content.prototype.componentDidUpdate = function componentDidUpdate() {
	    var trigger = this.props.trigger;
	
	    if (trigger) {
	      trigger.forcePopupAlign();
	    }
	  };
	
	  Content.prototype.render = function render() {
	    var _props = this.props,
	        overlay = _props.overlay,
	        prefixCls = _props.prefixCls,
	        id = _props.id;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
	      typeof overlay === 'function' ? overlay() : overlay
	    );
	  };
	
	  return Content;
	}(_react2['default'].Component);
	
	Content.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  id: _propTypes2['default'].string,
	  trigger: _propTypes2['default'].any
	};
	exports['default'] = Content;
	module.exports = exports['default'];

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(82);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(1067);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _placements = __webpack_require__(1064);
	
	var _Content = __webpack_require__(1061);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tooltip = function (_Component) {
	  (0, _inherits3['default'])(Tooltip, _Component);
	
	  function Tooltip() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
	      var _this$props = _this.props,
	          arrowContent = _this$props.arrowContent,
	          overlay = _this$props.overlay,
	          prefixCls = _this$props.prefixCls,
	          id = _this$props.id;
	
	      return [_react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-arrow', key: 'arrow' },
	        arrowContent
	      ), _react2['default'].createElement(_Content2['default'], {
	        key: 'content',
	        trigger: _this.trigger,
	        prefixCls: prefixCls,
	        id: id,
	        overlay: overlay
	      })];
	    }, _this.saveTrigger = function (node) {
	      _this.trigger = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Tooltip.prototype.render = function render() {
	    var _props = this.props,
	        overlayClassName = _props.overlayClassName,
	        trigger = _props.trigger,
	        mouseEnterDelay = _props.mouseEnterDelay,
	        mouseLeaveDelay = _props.mouseLeaveDelay,
	        overlayStyle = _props.overlayStyle,
	        prefixCls = _props.prefixCls,
	        children = _props.children,
	        onVisibleChange = _props.onVisibleChange,
	        afterVisibleChange = _props.afterVisibleChange,
	        transitionName = _props.transitionName,
	        animation = _props.animation,
	        placement = _props.placement,
	        align = _props.align,
	        destroyTooltipOnHide = _props.destroyTooltipOnHide,
	        defaultVisible = _props.defaultVisible,
	        getTooltipContainer = _props.getTooltipContainer,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = (0, _extends3['default'])({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      (0, _extends3['default'])({
	        popupClassName: overlayClassName,
	        ref: this.saveTrigger,
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        afterPopupVisibleChange: afterVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  };
	
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
	  trigger: _propTypes2['default'].any,
	  children: _propTypes2['default'].any,
	  defaultVisible: _propTypes2['default'].bool,
	  visible: _propTypes2['default'].bool,
	  placement: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  animation: _propTypes2['default'].any,
	  onVisibleChange: _propTypes2['default'].func,
	  afterVisibleChange: _propTypes2['default'].func,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  overlayStyle: _propTypes2['default'].object,
	  overlayClassName: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  getTooltipContainer: _propTypes2['default'].func,
	  destroyTooltipOnHide: _propTypes2['default'].bool,
	  align: _propTypes2['default'].object,
	  arrowContent: _propTypes2['default'].any,
	  id: _propTypes2['default'].string
	};
	Tooltip.defaultProps = {
	  prefixCls: 'rc-tooltip',
	  mouseEnterDelay: 0,
	  destroyTooltipOnHide: false,
	  mouseLeaveDelay: 0.1,
	  align: {},
	  placement: 'right',
	  trigger: ['hover'],
	  arrowContent: null
	};
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Tooltip = __webpack_require__(1062);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tooltip2['default'];
	module.exports = exports['default'];

/***/ },
/* 1064 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(1050);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(1052);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(1066);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(540);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(541);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Used for stretch
	      stretchChecked: false,
	      targetWidth: undefined,
	      targetHeight: undefined
	    };
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	    this.setStretchSize();
	  };
	
	  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setStretchSize();
	  };
	
	  // Record size if stretch needed
	
	
	  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
	    return _reactDom2['default'].findDOMNode(this.popupInstance);
	  };
	
	  // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align
	
	
	  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getTransitionName = function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  };
	
	  Popup.prototype.getPopupElement = function getPopupElement() {
	    var _this2 = this;
	
	    var savePopupRef = this.savePopupRef;
	    var _state = this.state,
	        stretchChecked = _state.stretchChecked,
	        targetHeight = _state.targetHeight,
	        targetWidth = _state.targetWidth;
	    var _props = this.props,
	        align = _props.align,
	        visible = _props.visible,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        getClassNameFromAlign = _props.getClassNameFromAlign,
	        destroyPopupOnHide = _props.destroyPopupOnHide,
	        stretch = _props.stretch,
	        children = _props.children,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseLeave = _props.onMouseLeave,
	        onMouseDown = _props.onMouseDown,
	        onTouchStart = _props.onTouchStart;
	
	    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	
	    var sizeStyle = {};
	    if (stretch) {
	      // Stretch with target
	      if (stretch.indexOf('height') !== -1) {
	        sizeStyle.height = targetHeight;
	      } else if (stretch.indexOf('minHeight') !== -1) {
	        sizeStyle.minHeight = targetHeight;
	      }
	      if (stretch.indexOf('width') !== -1) {
	        sizeStyle.width = targetWidth;
	      } else if (stretch.indexOf('minWidth') !== -1) {
	        sizeStyle.minWidth = targetWidth;
	      }
	
	      // Delay force align to makes ui smooth
	      if (!stretchChecked) {
	        sizeStyle.visibility = 'hidden';
	        setTimeout(function () {
	          if (_this2.alignInstance) {
	            _this2.alignInstance.forceAlign();
	          }
	        }, 0);
	      }
	    }
	
	    var newStyle = (0, _extends3['default'])({}, sizeStyle, style, this.getZIndexStyle());
	
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: savePopupRef,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseDown: onMouseDown,
	      onTouchStart: onTouchStart,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getAlignTarget(),
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              visible: true
	            }, popupInnerProps),
	            children
	          )
	        ) : null
	      );
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2['default'].createElement(
	        _rcAlign2['default'],
	        {
	          target: this.getAlignTarget(),
	          key: 'popup',
	          ref: this.saveAlignRef,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2['default'].createElement(
	          _PopupInner2['default'],
	          (0, _extends3['default'])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          children
	        )
	      )
	    );
	  };
	
	  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  };
	
	  Popup.prototype.getMaskElement = function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  };
	
	  Popup.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  };
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  stretch: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  point: _propTypes2['default'].shape({
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this3.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this3.currentAlignClassName !== currentAlignClassName) {
	      _this3.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this3.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.setStretchSize = function () {
	    var _props2 = _this3.props,
	        stretch = _props2.stretch,
	        getRootDomNode = _props2.getRootDomNode,
	        visible = _props2.visible;
	    var _state2 = _this3.state,
	        stretchChecked = _state2.stretchChecked,
	        targetHeight = _state2.targetHeight,
	        targetWidth = _state2.targetWidth;
	
	
	    if (!stretch || !visible) {
	      if (stretchChecked) {
	        _this3.setState({ stretchChecked: false });
	      }
	      return;
	    }
	
	    var $ele = getRootDomNode();
	    if (!$ele) return;
	
	    var height = $ele.offsetHeight;
	    var width = $ele.offsetWidth;
	
	    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
	      _this3.setState({
	        stretchChecked: true,
	        targetHeight: height,
	        targetWidth: width
	      });
	    }
	  };
	
	  this.getTargetElement = function () {
	    return _this3.props.getRootDomNode();
	  };
	
	  this.getAlignTarget = function () {
	    var point = _this3.props.point;
	
	    if (point) {
	      return point;
	    }
	    return _this3.getTargetElement;
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(540);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  PopupInner.prototype.render = function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        onMouseDown: props.onMouseDown,
	        onTouchStart: props.onTouchStart,
	        style: props.style
	      },
	      _react2['default'].createElement(
	        _LazyRenderBox2['default'],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  };
	
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactLifecyclesCompat = __webpack_require__(1139);
	
	var _contains = __webpack_require__(542);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(252);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ContainerRender = __webpack_require__(1068);
	
	var _ContainerRender2 = _interopRequireDefault(_ContainerRender);
	
	var _Portal = __webpack_require__(1069);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(541);
	
	var _Popup = __webpack_require__(1065);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var contextTypes = {
	  rcTrigger: _propTypes2['default'].shape({
	    onPopupMouseDown: _propTypes2['default'].func
	  })
	};
	
	var Trigger = function (_React$Component) {
	  (0, _inherits3['default'])(Trigger, _React$Component);
	
	  function Trigger(props) {
	    (0, _classCallCheck3['default'])(this, Trigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	
	    _this.state = {
	      prevPopupVisible: popupVisible,
	      popupVisible: popupVisible
	    };
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	    return _this;
	  }
	
	  Trigger.prototype.getChildContext = function getChildContext() {
	    return {
	      rcTrigger: {
	        onPopupMouseDown: this.onPopupMouseDown
	      }
	    };
	  };
	
	  Trigger.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  };
	
	  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    };
	    if (!IS_REACT_16) {
	      this.renderComponent(null, triggerAfterPopupVisibleChange);
	    }
	
	    // We must listen to `mousedown` or `touchstart`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	        currentDocument = currentDocument || props.getDocument();
	        this.contextMenuOutsideHandler1 = (0, _addEventListener2['default'])(currentDocument, 'scroll', this.onContextMenuClose);
	      }
	      // close popup when trigger type contains 'onContextMenu' and window is blur.
	      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	        this.contextMenuOutsideHandler2 = (0, _addEventListener2['default'])(window, 'blur', this.onContextMenuClose);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  };
	
	  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	    clearTimeout(this.mouseDownTimeout);
	  };
	
	  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var popupVisible = _ref.popupVisible;
	
	    var newState = {};
	
	    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
	      newState.popupVisible = popupVisible;
	      newState.prevPopupVisible = prevState.popupVisible;
	    }
	
	    return newState;
	  };
	
	  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  };
	
	  Trigger.prototype.getPopupAlign = function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  };
	
	  /**
	   * @param popupVisible    Show or not the popup element
	   * @param event           SyntheticEvent, used for `pointAlign`
	   */
	  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
	    var alignPoint = this.props.alignPoint;
	    var prevPopupVisible = this.state.popupVisible;
	
	
	    this.clearDelayTimer();
	
	    if (prevPopupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	
	    // Always record the point position since mouseEnterDelay will delay the show
	    if (alignPoint && event) {
	      this.setPoint(event);
	    }
	  };
	
	  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible, point);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible, event);
	    }
	  };
	
	  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  };
	
	  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.contextMenuOutsideHandler1) {
	      this.contextMenuOutsideHandler1.remove();
	      this.contextMenuOutsideHandler1 = null;
	    }
	
	    if (this.contextMenuOutsideHandler2) {
	      this.contextMenuOutsideHandler2.remove();
	      this.contextMenuOutsideHandler2 = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  };
	
	  Trigger.prototype.createTwoChains = function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  };
	
	  Trigger.prototype.isClickToShow = function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
	    var _props2 = this.props,
	        action = _props2.action,
	        showAction = _props2.showAction;
	
	    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	  };
	
	  Trigger.prototype.isClickToHide = function isClickToHide() {
	    var _props3 = this.props,
	        action = _props3.action,
	        hideAction = _props3.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
	    var _props4 = this.props,
	        action = _props4.action,
	        showAction = _props4.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  };
	
	  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
	    var _props5 = this.props,
	        action = _props5.action,
	        hideAction = _props5.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  };
	
	  Trigger.prototype.isFocusToShow = function isFocusToShow() {
	    var _props6 = this.props,
	        action = _props6.action,
	        showAction = _props6.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  };
	
	  Trigger.prototype.isBlurToHide = function isBlurToHide() {
	    var _props7 = this.props,
	        action = _props7.action,
	        hideAction = _props7.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  };
	
	  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  };
	
	  Trigger.prototype.fireEvents = function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  };
	
	  Trigger.prototype.close = function close() {
	    this.setPopupVisible(false);
	  };
	
	  Trigger.prototype.render = function render() {
	    var _this3 = this;
	
	    var popupVisible = this.state.popupVisible;
	    var _props8 = this.props,
	        children = _props8.children,
	        forceRender = _props8.forceRender,
	        alignPoint = _props8.alignPoint,
	        className = _props8.className;
	
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = { key: 'trigger' };
	
	    if (this.isContextMenuToShow()) {
	      newChildProps.onContextMenu = this.onContextMenu;
	    } else {
	      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	    }
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	      if (alignPoint) {
	        newChildProps.onMouseMove = this.onMouseMove;
	      }
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    var childrenClassName = (0, _classnames2['default'])(child && child.props && child.props.className, className);
	    if (childrenClassName) {
	      newChildProps.className = childrenClassName;
	    }
	    var trigger = _react2['default'].cloneElement(child, newChildProps);
	
	    if (!IS_REACT_16) {
	      return _react2['default'].createElement(
	        _ContainerRender2['default'],
	        {
	          parent: this,
	          visible: popupVisible,
	          autoMount: false,
	          forceRender: forceRender,
	          getComponent: this.getComponent,
	          getContainer: this.getContainer
	        },
	        function (_ref2) {
	          var renderComponent = _ref2.renderComponent;
	
	          _this3.renderComponent = renderComponent;
	          return trigger;
	        }
	      );
	    }
	
	    var portal = void 0;
	    // prevent unmounting after it's rendered
	    if (popupVisible || this._component || forceRender) {
	      portal = _react2['default'].createElement(
	        _Portal2['default'],
	        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
	        this.getComponent()
	      );
	    }
	
	    return [trigger, portal];
	  };
	
	  return Trigger;
	}(_react2['default'].Component);
	
	Trigger.propTypes = {
	  children: _propTypes2['default'].any,
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  showAction: _propTypes2['default'].any,
	  hideAction: _propTypes2['default'].any,
	  getPopupClassNameFromAlign: _propTypes2['default'].any,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  afterPopupVisibleChange: _propTypes2['default'].func,
	  popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  popupStyle: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  builtinPlacements: _propTypes2['default'].object,
	  popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  popupAnimation: _propTypes2['default'].any,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  zIndex: _propTypes2['default'].number,
	  focusDelay: _propTypes2['default'].number,
	  blurDelay: _propTypes2['default'].number,
	  getPopupContainer: _propTypes2['default'].func,
	  getDocument: _propTypes2['default'].func,
	  forceRender: _propTypes2['default'].bool,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  mask: _propTypes2['default'].bool,
	  maskClosable: _propTypes2['default'].bool,
	  onPopupAlign: _propTypes2['default'].func,
	  popupAlign: _propTypes2['default'].object,
	  popupVisible: _propTypes2['default'].bool,
	  defaultPopupVisible: _propTypes2['default'].bool,
	  maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  maskAnimation: _propTypes2['default'].string,
	  stretch: _propTypes2['default'].string,
	  alignPoint: _propTypes2['default'].bool // Maybe we can support user pass position in the future
	};
	Trigger.contextTypes = contextTypes;
	Trigger.childContextTypes = contextTypes;
	Trigger.defaultProps = {
	  prefixCls: 'rc-trigger-popup',
	  getPopupClassNameFromAlign: returnEmptyString,
	  getDocument: returnDocument,
	  onPopupVisibleChange: noop,
	  afterPopupVisibleChange: noop,
	  onPopupAlign: noop,
	  popupClassName: '',
	  mouseEnterDelay: 0,
	  mouseLeaveDelay: 0.1,
	  focusDelay: 0,
	  blurDelay: 0.15,
	  popupStyle: {},
	  destroyPopupOnHide: false,
	  popupAlign: {},
	  defaultPopupVisible: false,
	  mask: false,
	  maskClosable: true,
	  action: [],
	  showAction: [],
	  hideAction: []
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.onMouseEnter = function (e) {
	    var mouseEnterDelay = _this4.props.mouseEnterDelay;
	
	    _this4.fireEvents('onMouseEnter', e);
	    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	  };
	
	  this.onMouseMove = function (e) {
	    _this4.fireEvents('onMouseMove', e);
	    _this4.setPoint(e);
	  };
	
	  this.onMouseLeave = function (e) {
	    _this4.fireEvents('onMouseLeave', e);
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onPopupMouseEnter = function () {
	    _this4.clearDelayTimer();
	  };
	
	  this.onPopupMouseLeave = function (e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && (0, _contains2['default'])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onFocus = function (e) {
	    _this4.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    _this4.clearDelayTimer();
	    if (_this4.isFocusToShow()) {
	      _this4.focusTime = Date.now();
	      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
	    }
	  };
	
	  this.onMouseDown = function (e) {
	    _this4.fireEvents('onMouseDown', e);
	    _this4.preClickTime = Date.now();
	  };
	
	  this.onTouchStart = function (e) {
	    _this4.fireEvents('onTouchStart', e);
	    _this4.preTouchTime = Date.now();
	  };
	
	  this.onBlur = function (e) {
	    _this4.fireEvents('onBlur', e);
	    _this4.clearDelayTimer();
	    if (_this4.isBlurToHide()) {
	      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
	    }
	  };
	
	  this.onContextMenu = function (e) {
	    e.preventDefault();
	    _this4.fireEvents('onContextMenu', e);
	    _this4.setPopupVisible(true, e);
	  };
	
	  this.onContextMenuClose = function () {
	    if (_this4.isContextMenuToShow()) {
	      _this4.close();
	    }
	  };
	
	  this.onClick = function (event) {
	    _this4.fireEvents('onClick', event);
	    // focus will trigger click
	    if (_this4.focusTime) {
	      var preTime = void 0;
	      if (_this4.preClickTime && _this4.preTouchTime) {
	        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
	      } else if (_this4.preClickTime) {
	        preTime = _this4.preClickTime;
	      } else if (_this4.preTouchTime) {
	        preTime = _this4.preTouchTime;
	      }
	      if (Math.abs(preTime - _this4.focusTime) < 20) {
	        return;
	      }
	      _this4.focusTime = 0;
	    }
	    _this4.preClickTime = 0;
	    _this4.preTouchTime = 0;
	
	    // Only prevent default when all the action is click.
	    // https://github.com/ant-design/ant-design/issues/17043
	    // https://github.com/ant-design/ant-design/issues/17291
	    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
	      event.preventDefault();
	    }
	    var nextVisible = !_this4.state.popupVisible;
	    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
	      _this4.setPopupVisible(!_this4.state.popupVisible, event);
	    }
	  };
	
	  this.onPopupMouseDown = function () {
	    var _context$rcTrigger = _this4.context.rcTrigger,
	        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
	
	    _this4.hasPopupMouseDown = true;
	
	    clearTimeout(_this4.mouseDownTimeout);
	    _this4.mouseDownTimeout = setTimeout(function () {
	      _this4.hasPopupMouseDown = false;
	    }, 0);
	
	    if (rcTrigger.onPopupMouseDown) {
	      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
	    }
	  };
	
	  this.onDocumentClick = function (event) {
	    if (_this4.props.mask && !_this4.props.maskClosable) {
	      return;
	    }
	
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(_this4);
	    if (!(0, _contains2['default'])(root, target) && !_this4.hasPopupMouseDown) {
	      _this4.close();
	    }
	  };
	
	  this.getRootDomNode = function () {
	    return (0, _reactDom.findDOMNode)(_this4);
	  };
	
	  this.getPopupClassNameFromAlign = function (align) {
	    var className = [];
	    var _props9 = _this4.props,
	        popupPlacement = _props9.popupPlacement,
	        builtinPlacements = _props9.builtinPlacements,
	        prefixCls = _props9.prefixCls,
	        alignPoint = _props9.alignPoint,
	        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
	    }
	    if (getPopupClassNameFromAlign) {
	      className.push(getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  };
	
	  this.getComponent = function () {
	    var _props10 = _this4.props,
	        prefixCls = _props10.prefixCls,
	        destroyPopupOnHide = _props10.destroyPopupOnHide,
	        popupClassName = _props10.popupClassName,
	        action = _props10.action,
	        onPopupAlign = _props10.onPopupAlign,
	        popupAnimation = _props10.popupAnimation,
	        popupTransitionName = _props10.popupTransitionName,
	        popupStyle = _props10.popupStyle,
	        mask = _props10.mask,
	        maskAnimation = _props10.maskAnimation,
	        maskTransitionName = _props10.maskTransitionName,
	        zIndex = _props10.zIndex,
	        popup = _props10.popup,
	        stretch = _props10.stretch,
	        alignPoint = _props10.alignPoint;
	    var _state = _this4.state,
	        popupVisible = _state.popupVisible,
	        point = _state.point;
	
	
	    var align = _this4.getPopupAlign();
	
	    var mouseProps = {};
	    if (_this4.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
	    }
	    if (_this4.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
	    }
	
	    mouseProps.onMouseDown = _this4.onPopupMouseDown;
	    mouseProps.onTouchStart = _this4.onPopupMouseDown;
	
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: prefixCls,
	        destroyPopupOnHide: destroyPopupOnHide,
	        visible: popupVisible,
	        point: alignPoint && point,
	        className: popupClassName,
	        action: action,
	        align: align,
	        onAlign: onPopupAlign,
	        animation: popupAnimation,
	        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
	      }, mouseProps, {
	        stretch: stretch,
	        getRootDomNode: _this4.getRootDomNode,
	        style: popupStyle,
	        mask: mask,
	        zIndex: zIndex,
	        transitionName: popupTransitionName,
	        maskAnimation: maskAnimation,
	        maskTransitionName: maskTransitionName,
	        ref: _this4.savePopup
	      }),
	      typeof popup === 'function' ? popup() : popup
	    );
	  };
	
	  this.getContainer = function () {
	    var props = _this4.props;
	
	    var popupContainer = document.createElement('div');
	    // Make sure default popup container will never cause scrollbar appearing
	    // https://github.com/react-component/trigger/issues/41
	    popupContainer.style.position = 'absolute';
	    popupContainer.style.top = '0';
	    popupContainer.style.left = '0';
	    popupContainer.style.width = '100%';
	    var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(_this4)) : props.getDocument().body;
	    mountNode.appendChild(popupContainer);
	    return popupContainer;
	  };
	
	  this.setPoint = function (point) {
	    var alignPoint = _this4.props.alignPoint;
	
	    if (!alignPoint || !point) return;
	
	    _this4.setState({
	      point: {
	        pageX: point.pageX,
	        pageY: point.pageY
	      }
	    });
	  };
	
	  this.handlePortalUpdate = function () {
	    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
	      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
	    }
	  };
	
	  this.savePopup = function (node) {
	    _this4._component = node;
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Trigger);
	
	exports['default'] = Trigger;
	module.exports = exports['default'];

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ContainerRender = /*#__PURE__*/function (_React$Component) {
	  _inherits(ContainerRender, _React$Component);
	
	  var _super = _createSuper(ContainerRender);
	
	  function ContainerRender() {
	    var _this;
	
	    _classCallCheck(this, ContainerRender);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _this.removeContainer = function () {
	      if (_this.container) {
	        _reactDom.default.unmountComponentAtNode(_this.container);
	
	        _this.container.parentNode.removeChild(_this.container);
	
	        _this.container = null;
	      }
	    };
	
	    _this.renderComponent = function (props, ready) {
	      var _this$props = _this.props,
	          visible = _this$props.visible,
	          getComponent = _this$props.getComponent,
	          forceRender = _this$props.forceRender,
	          getContainer = _this$props.getContainer,
	          parent = _this$props.parent;
	
	      if (visible || parent._component || forceRender) {
	        if (!_this.container) {
	          _this.container = getContainer();
	        }
	
	        _reactDom.default.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
	          if (ready) {
	            ready.call(this);
	          }
	        });
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(ContainerRender, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.props.autoDestroy) {
	        this.removeContainer();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children({
	        renderComponent: this.renderComponent,
	        removeContainer: this.removeContainer
	      });
	    }
	  }]);
	
	  return ContainerRender;
	}(_react.default.Component);
	
	exports.default = ContainerRender;
	ContainerRender.propTypes = {
	  autoMount: _propTypes.default.bool,
	  autoDestroy: _propTypes.default.bool,
	  visible: _propTypes.default.bool,
	  forceRender: _propTypes.default.bool,
	  parent: _propTypes.default.any,
	  getComponent: _propTypes.default.func.isRequired,
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.func.isRequired
	};
	ContainerRender.defaultProps = {
	  autoMount: true,
	  autoDestroy: true,
	  forceRender: false
	};

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(22));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(8));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Portal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  var _super = _createSuper(Portal);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Portal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.createContainer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var didUpdate = this.props.didUpdate;
	
	      if (didUpdate) {
	        didUpdate(prevProps);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeContainer();
	    }
	  }, {
	    key: "createContainer",
	    value: function createContainer() {
	      this._container = this.props.getContainer();
	      this.forceUpdate();
	    }
	  }, {
	    key: "removeContainer",
	    value: function removeContainer() {
	      if (this._container) {
	        this._container.parentNode.removeChild(this._container);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this._container) {
	        return _reactDom.default.createPortal(this.props.children, this._container);
	      }
	
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.default.Component);
	
	exports.default = Portal;
	Portal.propTypes = {
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.node.isRequired,
	  didUpdate: _propTypes.default.func
	};

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  } // only handle componentWillReceiveProps
	
	
	  if (typeof prototype.componentWillReceiveProps !== 'function') {
	    return Component;
	  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
	  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler
	
	
	  if (!_react.default.Profiler) {
	    return Component;
	  } // Here polyfill get started
	
	
	  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
	  delete prototype.componentWillReceiveProps;
	  return Component;
	};
	
	var _default = unsafeLifecyclesPolyfill;
	exports.default = _default;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = [];
	  var currentState = initialState;
	
	  var getState = function getState() {
	    return currentState;
	  };
	
	  var setState = function setState(state) {
	    currentState = state;
	    listeners.forEach(function (listener) {
	      return listener(currentState);
	    });
	  };
	
	  var subscribe = function subscribe(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  return {
	    getState: getState,
	    setState: setState,
	    subscribe: subscribe
	  };
	};
	
	/**
	 * A <Broadcast> provides a generic way for descendants to "subscribe"
	 * to some value that changes over time, bypassing any intermediate
	 * shouldComponentUpdate's in the hierarchy. It puts all subscription
	 * functions on context.broadcasts, keyed by "channel".
	 *
	 * To use it, a subscriber must opt-in to context.broadcasts. See the
	 * <Subscriber> component for a reference implementation.
	 */
	
	var Broadcast = function (_React$Component) {
	  _inherits(Broadcast, _React$Component);
	
	  function Broadcast() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Broadcast);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.broadcast = createBroadcast(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Broadcast.prototype.getChildContext = function getChildContext() {
	    var _extends2;
	
	    return {
	      broadcasts: _extends({}, this.context.broadcasts, (_extends2 = {}, _extends2[this.props.channel] = this.broadcast, _extends2))
	    };
	  };
	
	  Broadcast.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _invariant2.default)(this.props.channel === nextProps.channel, 'You cannot change <Broadcast channel>');
	
	    if (this.props.value !== nextProps.value) this.broadcast.setState(nextProps.value);
	  };
	
	  Broadcast.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Broadcast;
	}(_react2.default.Component);
	
	Broadcast.propTypes = {
	  channel: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node.isRequired,
	  value: _propTypes2.default.any
	};
	Broadcast.contextTypes = {
	  broadcasts: _propTypes2.default.object
	};
	Broadcast.childContextTypes = {
	  broadcasts: _propTypes2.default.object.isRequired
	};
	exports.default = Broadcast;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A <Subscriber> pulls the value for a channel off of context.broadcasts
	 * and passes it to its children function.
	 */
	var Subscriber = function (_React$Component) {
	  _inherits(Subscriber, _React$Component);
	
	  function Subscriber() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Subscriber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      value: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Subscriber.prototype.getBroadcast = function getBroadcast() {
	    var broadcast = this.context.broadcasts[this.props.channel];
	
	    (0, _invariant2.default)(broadcast, '<Subscriber channel="%s"> must be rendered in the context of a <Broadcast channel="%s">', this.props.channel, this.props.channel);
	
	    return broadcast;
	  };
	
	  Subscriber.prototype.componentWillMount = function componentWillMount() {
	    var broadcast = this.getBroadcast();
	
	    this.setState({
	      value: broadcast.getState()
	    });
	  };
	
	  Subscriber.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var broadcast = this.getBroadcast();
	
	    this.unsubscribe = broadcast.subscribe(function (value) {
	      _this2.setState({ value: value });
	    });
	  };
	
	  Subscriber.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribe();
	  };
	
	  Subscriber.prototype.render = function render() {
	    return this.props.children(this.state.value);
	  };
	
	  return Subscriber;
	}(_react2.default.Component);
	
	Subscriber.propTypes = {
	  channel: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.func.isRequired
	};
	Subscriber.contextTypes = {
	  broadcasts: _propTypes2.default.object
	};
	exports.default = Subscriber;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxGroup = exports.Checkbox = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkbox = exports.Checkbox = function (_Component) {
	  _inherits(Checkbox, _Component);
	
	  function Checkbox() {
	    _classCallCheck(this, Checkbox);
	
	    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	  }
	
	  _createClass(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!(this.context && this.context.checkboxGroup)) {
	        throw new Error('The `Checkbox` component must be used as a child of `CheckboxGroup`.');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$checkboxGrou = this.context.checkboxGroup,
	          name = _context$checkboxGrou.name,
	          checkedValues = _context$checkboxGrou.checkedValues,
	          onChange = _context$checkboxGrou.onChange;
	
	      var optional = {};
	      if (checkedValues) {
	        optional.checked = checkedValues.indexOf(this.props.value) >= 0;
	      }
	      if (typeof onChange === 'function') {
	        optional.onChange = onChange.bind(null, this.props.value);
	      }
	
	      return _react2.default.createElement('input', _extends({}, this.props, {
	        type: 'checkbox',
	        name: name,
	        disabled: this.props.disabled
	      }, optional));
	    }
	  }]);
	
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.contextTypes = {
	  checkboxGroup: _propTypes2.default.object.isRequired
	};
	
	var CheckboxGroup = exports.CheckboxGroup = function (_Component2) {
	  _inherits(CheckboxGroup, _Component2);
	
	  function CheckboxGroup(props) {
	    _classCallCheck(this, CheckboxGroup);
	
	    var _this2 = _possibleConstructorReturn(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).call(this, props));
	
	    _this2._isControlledComponent = _this2._isControlledComponent.bind(_this2);
	    _this2._onCheckboxChange = _this2._onCheckboxChange.bind(_this2);
	    _this2.getChildContext = _this2.getChildContext.bind(_this2);
	    _this2.getValue = _this2.getValue.bind(_this2);
	    _this2.state = {
	      value: _this2.props.value || _this2.props.defaultValue || []
	    };
	    return _this2;
	  }
	
	  _createClass(CheckboxGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var checkboxGroup = {
	        name: this.props.name,
	        checkedValues: this.state.value,
	        onChange: this._onCheckboxChange
	      };
	      return { checkboxGroup: checkboxGroup };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.value) {
	        this.setState({
	          value: newProps.value
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.Component,
	          name = _props.name,
	          value = _props.value,
	          onChange = _props.onChange,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['Component', 'name', 'value', 'onChange', 'children']);
	
	      return _react2.default.createElement(
	        Component,
	        rest,
	        children
	      );
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.value;
	    }
	  }, {
	    key: '_isControlledComponent',
	    value: function _isControlledComponent() {
	      return Boolean(this.props.value);
	    }
	  }, {
	    key: '_onCheckboxChange',
	    value: function _onCheckboxChange(checkboxValue, event) {
	      var newValue = void 0;
	      if (event.target.checked) {
	        newValue = this.state.value.concat(checkboxValue);
	      } else {
	        newValue = this.state.value.filter(function (v) {
	          return v !== checkboxValue;
	        });
	      }
	
	      if (this._isControlledComponent()) {
	        this.setState({ value: this.props.value });
	      } else {
	        this.setState({ value: newValue });
	      }
	
	      if (typeof this.props.onChange === 'function') {
	        this.props.onChange(newValue, event, this.props.name);
	      }
	    }
	  }]);
	
	  return CheckboxGroup;
	}(_react.Component);
	
	CheckboxGroup.childContextTypes = {
	  checkboxGroup: _propTypes2.default.object.isRequired
	};
	CheckboxGroup.propTypes = {
	  name: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.array,
	  value: _propTypes2.default.array,
	  onChange: _propTypes2.default.func,
	  children: _propTypes2.default.node.isRequired,
	  Component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object])
	};
	CheckboxGroup.defaultProps = {
	  Component: "div"
	};


/***/ },
/* 1074 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(26);
	
	var focusNode = __webpack_require__(407);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(127);
	var ExecutionEnvironment = __webpack_require__(37);
	var FallbackCompositionState = __webpack_require__(1082);
	var SyntheticCompositionEvent = __webpack_require__(1116);
	var SyntheticInputEvent = __webpack_require__(1119);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(545);
	var ExecutionEnvironment = __webpack_require__(37);
	var ReactInstrumentation = __webpack_require__(44);
	
	var camelizeStyleName = __webpack_require__(982);
	var dangerousStyleValue = __webpack_require__(1125);
	var hyphenateStyleName = __webpack_require__(989);
	var memoizeStringOnly = __webpack_require__(992);
	var warning = __webpack_require__(14);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(126);
	var EventPropagators = __webpack_require__(127);
	var ExecutionEnvironment = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactUpdates = __webpack_require__(51);
	var SyntheticEvent = __webpack_require__(57);
	
	var getEventTarget = __webpack_require__(265);
	var isEventSupported = __webpack_require__(267);
	var isTextInputElement = __webpack_require__(567);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var DOMLazyTree = __webpack_require__(113);
	var ExecutionEnvironment = __webpack_require__(37);
	
	var createNodesFromMarkup = __webpack_require__(985);
	var emptyFunction = __webpack_require__(38);
	var invariant = __webpack_require__(10);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 1080 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(127);
	var ReactDOMComponentTree = __webpack_require__(26);
	var SyntheticMouseEvent = __webpack_require__(165);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var PooledClass = __webpack_require__(86);
	
	var getTextContentAccessor = __webpack_require__(566);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(114);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(87);
	
	var instantiateReactComponent = __webpack_require__(266);
	var KeyEscapeUtils = __webpack_require__(257);
	var shouldUpdateReactComponent = __webpack_require__(268);
	var traverseAllChildren = __webpack_require__(569);
	var warning = __webpack_require__(14);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":".","REACT_APP_ENVIRONMENT":"production","REACT_APP_REVISION":"a7d11e8"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(640);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)))

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(253);
	var ReactDOMIDOperations = __webpack_require__(1091);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(17);
	
	var React = __webpack_require__(91);
	var ReactComponentEnvironment = __webpack_require__(259);
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactErrorUtils = __webpack_require__(260);
	var ReactInstanceMap = __webpack_require__(128);
	var ReactInstrumentation = __webpack_require__(44);
	var ReactNodeTypes = __webpack_require__(559);
	var ReactReconciler = __webpack_require__(87);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(85);
	var invariant = __webpack_require__(10);
	var shallowEqual = __webpack_require__(241);
	var shouldUpdateReactComponent = __webpack_require__(268);
	var warning = __webpack_require__(14);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'childContext');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactDefaultInjection = __webpack_require__(552);
	var ReactMount = __webpack_require__(558);
	var ReactReconciler = __webpack_require__(87);
	var ReactUpdates = __webpack_require__(51);
	var ReactVersion = __webpack_require__(561);
	
	var findDOMNode = __webpack_require__(1126);
	var getHostComponentFromComposite = __webpack_require__(565);
	var renderSubtreeIntoContainer = __webpack_require__(1134);
	var warning = __webpack_require__(14);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(17);
	
	var AutoFocusUtils = __webpack_require__(1075);
	var CSSPropertyOperations = __webpack_require__(1077);
	var DOMLazyTree = __webpack_require__(113);
	var DOMNamespaces = __webpack_require__(254);
	var DOMProperty = __webpack_require__(114);
	var DOMPropertyOperations = __webpack_require__(547);
	var EventPluginHub = __webpack_require__(126);
	var EventPluginRegistry = __webpack_require__(255);
	var ReactBrowserEventEmitter = __webpack_require__(164);
	var ReactDOMComponentFlags = __webpack_require__(548);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactDOMInput = __webpack_require__(1092);
	var ReactDOMOption = __webpack_require__(1093);
	var ReactDOMSelect = __webpack_require__(550);
	var ReactDOMTextarea = __webpack_require__(1097);
	var ReactInstrumentation = __webpack_require__(44);
	var ReactMultiChild = __webpack_require__(1103);
	var ReactServerRenderingTransaction = __webpack_require__(560);
	
	var emptyFunction = __webpack_require__(38);
	var escapeTextContentForBrowser = __webpack_require__(167);
	var invariant = __webpack_require__(10);
	var isEventSupported = __webpack_require__(267);
	var shallowEqual = __webpack_require__(241);
	var validateDOMNesting = __webpack_require__(269);
	var warning = __webpack_require__(14);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var DOMLazyTree = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(26);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1090 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(253);
	var ReactDOMComponentTree = __webpack_require__(26);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(17);
	
	var DOMPropertyOperations = __webpack_require__(547);
	var LinkedValueUtils = __webpack_require__(258);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactUpdates = __webpack_require__(51);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var React = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactDOMSelect = __webpack_require__(550);
	
	var warning = __webpack_require__(14);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	var getNodeForCharacterOffset = __webpack_require__(1131);
	var getTextContentAccessor = __webpack_require__(566);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(552);
	var ReactServerRendering = __webpack_require__(1109);
	var ReactVersion = __webpack_require__(561);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(17);
	
	var DOMChildrenOperations = __webpack_require__(253);
	var DOMLazyTree = __webpack_require__(113);
	var ReactDOMComponentTree = __webpack_require__(26);
	
	var escapeTextContentForBrowser = __webpack_require__(167);
	var invariant = __webpack_require__(10);
	var validateDOMNesting = __webpack_require__(269);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19),
	    _assign = __webpack_require__(17);
	
	var LinkedValueUtils = __webpack_require__(258);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactUpdates = __webpack_require__(51);
	
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1099 */
641,
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(126);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var EventListener = __webpack_require__(406);
	var ExecutionEnvironment = __webpack_require__(37);
	var PooledClass = __webpack_require__(86);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactUpdates = __webpack_require__(51);
	
	var getEventTarget = __webpack_require__(265);
	var getUnboundedScrollPosition = __webpack_require__(987);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(114);
	var EventPluginHub = __webpack_require__(126);
	var EventPluginUtils = __webpack_require__(256);
	var ReactComponentEnvironment = __webpack_require__(259);
	var ReactEmptyComponent = __webpack_require__(553);
	var ReactBrowserEventEmitter = __webpack_require__(164);
	var ReactHostComponent = __webpack_require__(555);
	var ReactUpdates = __webpack_require__(51);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactComponentEnvironment = __webpack_require__(259);
	var ReactInstanceMap = __webpack_require__(128);
	var ReactInstrumentation = __webpack_require__(44);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactReconciler = __webpack_require__(87);
	var ReactChildReconciler = __webpack_require__(1084);
	
	var emptyFunction = __webpack_require__(38);
	var flattenChildren = __webpack_require__(1127);
	var invariant = __webpack_require__(10);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1105 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var CallbackQueue = __webpack_require__(546);
	var PooledClass = __webpack_require__(86);
	var ReactBrowserEventEmitter = __webpack_require__(164);
	var ReactInputSelection = __webpack_require__(556);
	var ReactInstrumentation = __webpack_require__(44);
	var Transaction = __webpack_require__(166);
	var ReactUpdateQueue = __webpack_require__(261);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1104);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1108 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var React = __webpack_require__(91);
	var ReactDOMContainerInfo = __webpack_require__(549);
	var ReactDefaultBatchingStrategy = __webpack_require__(551);
	var ReactInstrumentation = __webpack_require__(44);
	var ReactMarkupChecksum = __webpack_require__(557);
	var ReactReconciler = __webpack_require__(87);
	var ReactServerBatchingStrategy = __webpack_require__(1108);
	var ReactServerRenderingTransaction = __webpack_require__(560);
	var ReactUpdates = __webpack_require__(51);
	
	var emptyObject = __webpack_require__(85);
	var instantiateReactComponent = __webpack_require__(266);
	var invariant = __webpack_require__(10);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(261);
	
	var warning = __webpack_require__(14);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1111 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(127);
	var ExecutionEnvironment = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactInputSelection = __webpack_require__(556);
	var SyntheticEvent = __webpack_require__(57);
	
	var getActiveElement = __webpack_require__(408);
	var isTextInputElement = __webpack_require__(567);
	var shallowEqual = __webpack_require__(241);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var EventListener = __webpack_require__(406);
	var EventPropagators = __webpack_require__(127);
	var ReactDOMComponentTree = __webpack_require__(26);
	var SyntheticAnimationEvent = __webpack_require__(1114);
	var SyntheticClipboardEvent = __webpack_require__(1115);
	var SyntheticEvent = __webpack_require__(57);
	var SyntheticFocusEvent = __webpack_require__(1118);
	var SyntheticKeyboardEvent = __webpack_require__(1120);
	var SyntheticMouseEvent = __webpack_require__(165);
	var SyntheticDragEvent = __webpack_require__(1117);
	var SyntheticTouchEvent = __webpack_require__(1121);
	var SyntheticTransitionEvent = __webpack_require__(1122);
	var SyntheticUIEvent = __webpack_require__(129);
	var SyntheticWheelEvent = __webpack_require__(1123);
	
	var emptyFunction = __webpack_require__(38);
	var getEventCharCode = __webpack_require__(263);
	var invariant = __webpack_require__(10);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(57);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(57);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(57);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(165);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(129);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(57);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(129);
	
	var getEventCharCode = __webpack_require__(263);
	var getEventKey = __webpack_require__(1128);
	var getEventModifierState = __webpack_require__(264);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(129);
	
	var getEventModifierState = __webpack_require__(264);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(57);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(165);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1124 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(545);
	var warning = __webpack_require__(14);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(19);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var ReactDOMComponentTree = __webpack_require__(26);
	var ReactInstanceMap = __webpack_require__(128);
	
	var getHostComponentFromComposite = __webpack_require__(565);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(257);
	var traverseAllChildren = __webpack_require__(569);
	var warning = __webpack_require__(14);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":".","REACT_APP_ENVIRONMENT":"production","REACT_APP_REVISION":"a7d11e8"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(640);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(163)))

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(263);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1129 */
644,
/* 1130 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1131 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(37);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(167);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(558);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1095);


/***/ },
/* 1136 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _utils = __webpack_require__(572);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeatureFlagRenderer = function (_Component) {
	  _inherits(FeatureFlagRenderer, _Component);
	
	  function FeatureFlagRenderer(props) {
	    _classCallCheck(this, FeatureFlagRenderer);
	
	    var _this = _possibleConstructorReturn(this, (FeatureFlagRenderer.__proto__ || Object.getPrototypeOf(FeatureFlagRenderer)).call(this, props));
	
	    var _this$props = _this.props,
	        flagKey = _this$props.flagKey,
	        clientOptions = _this$props.clientOptions;
	
	    var bootstrap = clientOptions && clientOptions.bootstrap;
	
	    _this.state = {
	      checkFeatureFlagComplete: false,
	      flagValue: bootstrap && (typeof bootstrap === "undefined" ? "undefined" : _typeof(bootstrap)) === "object" && bootstrap.hasOwnProperty(flagKey) ? bootstrap[flagKey] : false
	    };
	    return _this;
	  }
	
	  _createClass(FeatureFlagRenderer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props = this.props,
	          clientId = _props.clientId,
	          user = _props.user,
	          clientOptions = _props.clientOptions;
	
	
	      this._isMounted = true;
	
	      if (clientOptions && clientOptions.disableClient) {
	        return;
	      }
	
	      // Only initialize the launch darkly js-client when in browser,
	      // can not be initialized on SSR due to dependency on XMLHttpRequest.
	      var ldClient = (0, _utils.ldClientWrapper)(clientId, user, clientOptions);
	
	      this.checkFeatureFlag(ldClient);
	      this.listenFlagChangeEvent(ldClient);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderLogic();
	    }
	  }, {
	    key: "renderLogic",
	    value: function renderLogic() {
	      var _state = this.state,
	          flagValue = _state.flagValue,
	          checkFeatureFlagComplete = _state.checkFeatureFlagComplete;
	      var _props2 = this.props,
	          renderFeatureCallback = _props2.renderFeatureCallback,
	          renderDefaultCallback = _props2.renderDefaultCallback,
	          initialRenderCallback = _props2.initialRenderCallback;
	
	
	      if (flagValue) {
	        return renderFeatureCallback(flagValue);
	      } else if (checkFeatureFlagComplete && renderDefaultCallback) {
	        return renderDefaultCallback();
	      }
	
	      if (initialRenderCallback) {
	        return initialRenderCallback();
	      }
	
	      return null;
	    }
	  }, {
	    key: "checkFeatureFlag",
	    value: function checkFeatureFlag(ldClient) {
	      var _this2 = this;
	
	      var flagKey = this.props.flagKey;
	
	
	      ldClient.onReady(function () {
	        var flagValue = ldClient.variation(flagKey, false);
	        _this2.setStateFlagValue(flagValue);
	      });
	    }
	  }, {
	    key: "listenFlagChangeEvent",
	    value: function listenFlagChangeEvent(ldClient) {
	      var _this3 = this;
	
	      var flagKey = this.props.flagKey;
	
	
	      ldClient.on("change:" + flagKey, function (value) {
	        _this3.setStateFlagValue(value);
	      });
	    }
	  }, {
	    key: "setStateFlagValue",
	    value: function setStateFlagValue(flagValue) {
	      var flagKey = this.props.flagKey;
	
	      var typeFlagValue = typeof flagValue === "undefined" ? "undefined" : _typeof(flagValue);
	      var defaultState = { checkFeatureFlagComplete: true };
	      var override = (0, _utils.ldOverrideFlag)(flagKey, typeFlagValue);
	
	      // Due to this function being called within a callback, we can run into issues
	      // where we try to set the state for an unmounted component. Since `isMounted()` is deprecated
	      // as part of a React class, we can create our own way to manage it within the protoype.
	      // See https://github.com/facebook/react/issues/5465#issuecomment-157888325 for more info
	      if (!this._isMounted) {
	        return;
	      }
	
	      if (typeof override !== "undefined") {
	        // Override is set for this flag key, use override instead
	        this.setState(_extends({ flagValue: override }, defaultState));
	      } else if (flagValue) {
	        this.setState(_extends({ flagValue: flagValue }, defaultState));
	      } else {
	        this.setState(_extends({ flagValue: false }, defaultState));
	      }
	    }
	  }]);
	
	  return FeatureFlagRenderer;
	}(_react.Component);
	
	exports.default = FeatureFlagRenderer;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LaunchDarkly;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBroadcast = __webpack_require__(543);
	
	var _LaunchDarkly = __webpack_require__(571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LaunchDarkly(props) {
	  var clientId = props.clientId,
	      user = props.user,
	      children = props.children,
	      clientOptions = props.clientOptions;
	
	
	  var config = null;
	
	  // if clientId or user do not exist we still want to
	  // render the Broadcast component but we want value
	  // to be null.
	  if (clientId && user) {
	    config = {
	      clientId: clientId,
	      user: user,
	      clientOptions: clientOptions
	    };
	  }
	
	  return _react2.default.createElement(
	    _reactBroadcast.Broadcast,
	    { channel: _LaunchDarkly.BROADCAST_CHANNEL, value: config },
	    children
	  );
	}

/***/ },
/* 1139 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 1140 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A higher-order-component for handling onClickOutside for React components.
	 */
	(function(root) {
	
	  // administrative
	  var registeredComponents = [];
	  var handlers = [];
	  var IGNORE_CLASS = 'ignore-react-onclickoutside';
	  var DEFAULT_EVENTS = ['mousedown', 'touchstart'];
	
	  /**
	   * Check whether some DOM node is our Component's node.
	   */
	  var isNodeFound = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	    // SVG <use/> elements do not technically reside in the rendered DOM, so
	    // they do not have classList directly, but they offer a link to their
	    // corresponding element, which can have classList. This extra check is for
	    // that case.
	    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	    if (current.correspondingElement) {
	      return current.correspondingElement.classList.contains(ignoreClass);
	    }
	    return current.classList.contains(ignoreClass);
	  };
	
	  /**
	   * Try to find our node in a hierarchy of nodes, returning the document
	   * node as highest noode if our node is not found in the path up.
	   */
	  var findHighest = function(current, componentNode, ignoreClass) {
	    if (current === componentNode) {
	      return true;
	    }
	
	    // If source=local then this event came from 'somewhere'
	    // inside and should be ignored. We could handle this with
	    // a layered approach, too, but that requires going back to
	    // thinking in terms of Dom node nesting, running counter
	    // to React's 'you shouldn't care about the DOM' philosophy.
	    while(current.parentNode) {
	      if (isNodeFound(current, componentNode, ignoreClass)) {
	        return true;
	      }
	      current = current.parentNode;
	    }
	    return current;
	  };
	
	  /**
	   * Check if the browser scrollbar was clicked
	   */
	  var clickedScrollbar = function(evt) {
	    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	  };
	
	  /**
	   * Generate the event handler that checks whether a clicked DOM node
	   * is inside of, or lives outside of, our Component's node tree.
	   */
	  var generateOutsideCheck = function(componentNode, componentInstance, eventHandler, ignoreClass, excludeScrollbar, preventDefault, stopPropagation) {
	    return function(evt) {
	      if (preventDefault) {
	        evt.preventDefault();
	      }
	      if (stopPropagation) {
	        evt.stopPropagation();
	      }
	      var current = evt.target;
	      if((excludeScrollbar && clickedScrollbar(evt)) || (findHighest(current, componentNode, ignoreClass) !== document)) {
	        return;
	      }
	      eventHandler(evt);
	    };
	  };
	
	  /**
	   * This function generates the HOC function that you'll use
	   * in order to impart onOutsideClick listening to an
	   * arbitrary component. It gets called at the end of the
	   * bootstrapping code to yield an instance of the
	   * onClickOutsideHOC function defined inside setupHOC().
	   */
	  function setupHOC(root, React, ReactDOM, createReactClass) {
	
	    // The actual Component-wrapping HOC:
	    return function onClickOutsideHOC(Component, config) {
	      var wrapComponentWithOnClickOutsideHandling = createReactClass({
	        statics: {
	          /**
	           * Access the wrapped Component's class.
	           */
	          getClass: function() {
	            if (Component.getClass) {
	              return Component.getClass();
	            }
	            return Component;
	          }
	        },
	
	        /**
	         * Access the wrapped Component's instance.
	         */
	        getInstance: function() {
	          return Component.prototype.isReactComponent ? this.refs.instance : this;
	        },
	
	        // this is given meaning in componentDidMount
	        __outsideClickHandler: function() {},
	
	        getDefaultProps: function() {
	          return {
	            excludeScrollbar: config && config.excludeScrollbar
	          };
	        },
	
	        /**
	         * Add click listeners to the current document,
	         * linked to this component's state.
	         */
	        componentDidMount: function() {
	          // If we are in an environment without a DOM such
	          // as shallow rendering or snapshots then we exit
	          // early to prevent any unhandled errors being thrown.
	          if (typeof document === 'undefined' || !document.createElement){
	            return;
	          }
	
	          var instance = this.getInstance();
	          var clickOutsideHandler;
	
	          if(config && typeof config.handleClickOutside === 'function') {
	            clickOutsideHandler = config.handleClickOutside(instance);
	            if(typeof clickOutsideHandler !== 'function') {
	              throw new Error('Component lacks a function for processing outside click events specified by the handleClickOutside config option.');
	            }
	          } else if(typeof instance.handleClickOutside === 'function') {
	            if (React.Component.prototype.isPrototypeOf(instance)) {
	              clickOutsideHandler = instance.handleClickOutside.bind(instance);
	            } else {
	              clickOutsideHandler = instance.handleClickOutside;
	            }
	          } else if(typeof instance.props.handleClickOutside === 'function') {
	            clickOutsideHandler = instance.props.handleClickOutside;
	          } else {
	            throw new Error('Component lacks a handleClickOutside(event) function for processing outside click events.');
	          }
	
	          var componentNode = ReactDOM.findDOMNode(instance);
	          if (componentNode === null) {
	            console.warn('Antipattern warning: there was no DOM node associated with the component that is being wrapped by outsideClick.');
	            console.warn([
	              'This is typically caused by having a component that starts life with a render function that',
	              'returns `null` (due to a state or props value), so that the component \'exist\' in the React',
	              'chain of components, but not in the DOM.\n\nInstead, you need to refactor your code so that the',
	              'decision of whether or not to show your component is handled by the parent, in their render()',
	              'function.\n\nIn code, rather than:\n\n  A{render(){return check? <.../> : null;}\n  B{render(){<A check=... />}\n\nmake sure that you',
	              'use:\n\n  A{render(){return <.../>}\n  B{render(){return <...>{ check ? <A/> : null }<...>}}\n\nThat is:',
	              'the parent is always responsible for deciding whether or not to render any of its children.',
	              'It is not the child\'s responsibility to decide whether a render instruction from above should',
	              'get ignored or not by returning `null`.\n\nWhen any component gets its render() function called,',
	              'that is the signal that it should be rendering its part of the UI. It may in turn decide not to',
	              'render all of *its* children, but it should never return `null` for itself. It is not responsible',
	              'for that decision.'
	            ].join(' '));
	          }
	
	          var fn = this.__outsideClickHandler = generateOutsideCheck(
	            componentNode,
	            instance,
	            clickOutsideHandler,
	            this.props.outsideClickIgnoreClass || IGNORE_CLASS,
	            this.props.excludeScrollbar, // fallback not needed, prop always exists because of getDefaultProps
	            this.props.preventDefault || false,
	            this.props.stopPropagation || false
	          );
	
	          var pos = registeredComponents.length;
	          registeredComponents.push(this);
	          handlers[pos] = fn;
	
	          // If there is a truthy disableOnClickOutside property for this
	          // component, don't immediately start listening for outside events.
	          if (!this.props.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          }
	        },
	
	        /**
	        * Track for disableOnClickOutside props changes and enable/disable click outside
	        */
	        componentWillReceiveProps: function(nextProps) {
	          if (this.props.disableOnClickOutside && !nextProps.disableOnClickOutside) {
	            this.enableOnClickOutside();
	          } else if (!this.props.disableOnClickOutside && nextProps.disableOnClickOutside) {
	            this.disableOnClickOutside();
	          }
	        },
	
	        /**
	         * Remove the document's event listeners
	         */
	        componentWillUnmount: function() {
	          this.disableOnClickOutside();
	          this.__outsideClickHandler = false;
	          var pos = registeredComponents.indexOf(this);
	          if( pos>-1) {
	            // clean up so we don't leak memory
	            if (handlers[pos]) { handlers.splice(pos, 1); }
	            registeredComponents.splice(pos, 1);
	          }
	        },
	
	        /**
	         * Can be called to explicitly enable event listening
	         * for clicks and touches outside of this element.
	         */
	        enableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.addEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Can be called to explicitly disable event listening
	         * for clicks and touches outside of this element.
	         */
	        disableOnClickOutside: function() {
	          var fn = this.__outsideClickHandler;
	          if (typeof document !== 'undefined') {
	            var events = this.props.eventTypes || DEFAULT_EVENTS;
	            if (!events.forEach) {
	              events = [events];
	            }
	            events.forEach(function (eventName) {
	              document.removeEventListener(eventName, fn);
	            });
	          }
	        },
	
	        /**
	         * Pass-through render
	         */
	        render: function() {
	          var passedProps = this.props;
	          var props = {};
	          Object.keys(this.props).forEach(function(key) {
	            if (key !== 'excludeScrollbar') {
	              props[key] = passedProps[key];
	            }
	          });
	          if (Component.prototype.isReactComponent) {
	            props.ref = 'instance';
	          }
	          props.disableOnClickOutside = this.disableOnClickOutside;
	          props.enableOnClickOutside = this.enableOnClickOutside;
	          return React.createElement(Component, props);
	        }
	      });
	
	      // Add display name for React devtools
	      (function bindWrappedComponentName(c, wrapper) {
	        var componentName = c.displayName || c.name || 'Component';
	        wrapper.displayName = 'OnClickOutside(' + componentName + ')';
	      }(Component, wrapComponentWithOnClickOutsideHandling));
	
	      return wrapComponentWithOnClickOutsideHandling;
	    };
	  }
	
	  /**
	   * This function sets up the library in ways that
	   * work with the various modulde loading solutions
	   * used in JavaScript land today.
	   */
	  function setupBinding(root, factory) {
	    if (true) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1),__webpack_require__(22),__webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function(React, ReactDom, createReactClass) {
	        if (!createReactClass) createReactClass = React.createClass;
	        return factory(root, React, ReactDom, createReactClass);
	      }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	      // Node. Note that this does not work with strict
	      // CommonJS, but only CommonJS-like environments
	      // that support module.exports
	      module.exports = factory(root, require('react'), require('react-dom'), require('create-react-class'));
	    } else {
	      // Browser globals (root is window)
	      var createReactClass = React.createClass ? React.createClass : window.createReactClass;
	      root.onClickOutside = factory(root, React, ReactDOM, createReactClass);
	    }
	  }
	
	  // Make it all happen
	  setupBinding(root, setupHOC);
	
	}(this));


/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = International_icon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function International_icon() {
		var markup = _react2.default.createElement(
			"svg",
			{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink",
				viewBox: "0 0 356.926 356.926" },
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { d: "M211.89,213.669c0-10.475-8.521-18.997-18.996-18.997c-0.401,0-0.799,0.017-1.193,0.041v2.406 c0.396-0.028,0.79-0.061,1.193-0.061c9.158,0,16.608,7.452,16.608,16.611s-7.45,16.61-16.608,16.61 c-0.269,0-0.53-0.027-0.795-0.041v0.897v1.509v4.723H186.2v3.182h13.388v-3.182h-5.104v-4.774 C204.218,231.781,211.89,223.607,211.89,213.669z" }),
					_react2.default.createElement(
						"g",
						null,
						_react2.default.createElement("polygon", { points: "260.072,79.408 260.398,82.045 256.447,82.882 255.913,88.517 260.677,88.517 266.998,87.913 270.251,84.021 266.788,82.678 264.883,80.488 262.024,75.858 260.677,69.329 255.286,70.409 253.799,72.721 253.799,75.312 256.378,77.084 " }),
						_react2.default.createElement("polygon", { points: "255.495,81.569 255.773,78.037 252.637,76.683 248.233,77.706 244.945,82.94 244.945,86.344 248.768,86.344 " }),
						_react2.default.createElement("path", { d: "M164.852,96.598l-0.976,2.498h-4.7v2.428h1.121c0,0,0.07,0.511,0.168,1.191l2.876-0.238l1.783-1.121l0.465-2.248 l2.335-0.204l0.912-1.888l-2.138-0.442L164.852,96.598z" }),
						_react2.default.createElement("polygon", { points: "152.739,101.001 152.565,103.366 155.976,103.081 156.324,100.705 154.279,99.096 \t\t\t" }),
						_react2.default.createElement("path", { d: "M356.868,176.633c-0.047-5.223-0.313-10.398-0.802-15.505c-1.662-17.01-5.717-33.311-11.828-48.589 c-0.441-1.127-0.859-2.283-1.336-3.41c-8.121-19.183-19.531-36.646-33.474-51.721c-0.906-0.987-1.835-1.952-2.765-2.916 c-2.649-2.736-5.333-5.415-8.156-7.971C266.788,17.631,224.642,0,178.463,0C131.896,0,89.447,17.957,57.635,47.271 c-7.413,6.832-14.221,14.303-20.408,22.285C13.919,99.717,0,137.49,0,178.463c0,98.398,80.059,178.463,178.463,178.463 c69.225,0,129.316-39.643,158.897-97.399c6.32-12.327,11.247-25.491,14.569-39.294c0.837-3.486,1.58-7.018,2.208-10.585 c1.801-10.137,2.788-20.56,2.788-31.196C356.902,177.859,356.868,177.249,356.868,176.633z M323.278,105.306l1.022-1.162 c1.359,2.637,2.649,5.304,3.846,8.028l-1.708-0.07l-3.172,0.436v-7.233H323.278z M297.484,74.156l0.023-7.971 c2.812,2.975,5.508,6.036,8.087,9.214l-3.207,4.781l-11.247-0.111l-0.696-2.341L297.484,74.156z M82.214,54.364v-0.302h3.567 l0.325-1.226h5.838v2.55l-1.691,2.236h-8.052v-3.259H82.214z M87.925,62.323c0,0,3.578-0.61,3.892-0.61c0.296,0,0,3.573,0,3.573 l-8.081,0.511l-1.534-1.847L87.925,62.323z M334.642,133.156h-13.06l-7.971-5.92l-8.365,0.808v5.112h-2.648l-2.848-2.033 l-14.512-3.671v-9.4l-18.38,1.423l-5.705,3.062h-7.285l-3.59-0.36l-8.854,4.926v9.254l-18.097,13.065l1.5,5.583h3.677 l-0.964,5.315l-2.58,0.953l-0.133,13.884l15.633,17.823h6.819l0.407-1.081h12.246l3.531-3.265h6.948l3.812,3.811l10.328,1.069 l-1.359,13.757l11.503,20.28l-6.064,11.572l0.406,5.438l4.775,4.752v13.095l6.251,8.412v10.897h5.391 c-30.046,36.913-75.823,60.534-127.026,60.534c-90.312,0-163.783-73.454-163.783-163.777c0-22.732,4.665-44.401,13.077-64.089 v-5.106l5.855-7.11c2.033-3.846,4.212-7.582,6.542-11.235l0.25,2.974l-6.791,8.261c-2.108,3.985-4.084,8.052-5.855,12.217v9.312 l6.791,3.276v12.955l6.535,11.136l5.316,0.808l0.68-3.817l-6.245-9.661l-1.237-9.388h3.677l1.557,9.673l9.051,13.193l-2.33,4.27 l5.734,8.795l14.291,3.532v-2.306l5.711,0.808l-0.534,4.078l4.484,0.825l6.948,1.888l9.8,11.171l12.507,0.941l1.237,10.207 l-8.58,5.984l-0.39,9.115l-1.237,5.588l12.386,15.5l0.947,5.32c0,0,4.49,1.209,5.048,1.209c0.535,0,10.062,7.227,10.062,7.227 v28.024l3.393,0.964l-2.294,12.92l5.71,7.634l-1.068,12.827l7.563,13.269l9.696,8.47l9.731,0.197l0.952-3.148l-7.163-6.029 l0.418-2.986l1.272-3.684l0.273-3.741l-4.839-0.14l-2.44-3.066l4.021-3.881l0.546-2.916l-4.496-1.29l0.261-2.719l6.402-0.976 l9.73-4.672l3.265-6.006l10.196-13.06l-2.312-10.213l3.131-5.438l9.399,0.278l6.327-5.02l2.051-19.693l7.04-8.877l1.237-5.704 l-6.39-2.045l-4.224-6.942l-14.419-0.145l-11.444-4.351l-0.534-8.162l-3.811-6.675l-10.335-0.145l-5.995-9.382l-5.298-2.585 l-0.273,2.858l-9.672,0.569l-3.532-4.926l-10.079-2.045l-8.302,9.603l-13.065-2.23l-0.953-14.727l-9.527-1.632l3.805-7.221 l-1.092-4.148l-12.531,8.371l-7.877-0.964l-2.817-6.158l1.737-6.355l4.339-8.005l9.998-5.072h19.322l-0.064,5.891l6.948,3.235 l-0.558-10.062l5.007-5.037l10.103-6.64l0.703-4.659l10.068-10.486l10.707-5.937l-0.941-0.773l7.256-6.826l2.655,0.703 l1.214,1.522l2.76-3.062l0.68-0.296l-3.021-0.43l-3.084-0.987v-2.963l1.632-1.33h3.579l1.655,0.726l1.418,2.858l1.737-0.267 v-0.244l0.5,0.163l5.02-0.772l0.714-2.463l2.852,0.726v2.667l-2.666,1.818h0.018l0.377,2.928l9.115,2.794c0,0,0,0.035,0.023,0.11 l2.079-0.18l0.146-3.939l-7.209-3.282l-0.396-1.894l5.972-2.033l0.273-5.722l-6.245-3.805l-0.412-9.667l-8.581,4.218h-3.143 l0.837-7.355l-11.688-2.748l-4.816,3.654v11.119l-8.673,2.754l-3.486,7.244l-3.758,0.604v-9.277l-8.162-1.133l-4.096-2.667 l-1.639-6.007l14.611-8.54l7.14-2.179l0.72,4.804l3.991-0.215l0.308-2.411l4.166-0.599l0.07-0.842l-1.784-0.738l-0.407-2.544 l5.118-0.43l3.091-3.213l0.18-0.238l0.035,0.012l0.941-0.976l10.753-1.354l4.746,4.032l-12.467,6.64l15.871,3.747l2.045-5.31 h6.948l2.44-4.625l-4.903-1.226v-5.856l-15.359-6.803l-10.62,1.226l-6.001,3.125l0.407,7.628l-6.257-0.953l-0.964-4.212 l6.007-5.449l-10.898-0.535l-3.125,0.953l-1.359,3.677l4.084,0.686l-0.813,4.084l-6.936,0.406l-1.092,2.725L118.987,52.4 c0,0-0.273-5.711-0.703-5.711c-0.389,0,7.901-0.145,7.901-0.145l5.995-5.85l-3.271-1.632l-4.339,4.223l-7.222-0.406l-4.403-6.019 h-9.254L94.03,44.07h8.848l0.796,2.597l-2.307,2.172l9.807,0.279l1.487,3.532l-11.032-0.407l-0.546-2.725l-6.925-1.499 l-3.689-2.033l-8.255,0.069c27.043-19.699,60.284-31.358,96.226-31.358c41.403,0,79.263,15.476,108.124,40.915l-1.929,3.474 l-7.564,2.962l-3.194,3.462l0.743,4.02l3.893,0.546l2.358,5.867l6.704-2.713l1.127,7.86h-2.045l-5.519-0.819l-6.111,1.022 l-5.926,8.377l-8.458,1.319l-1.221,7.25l3.579,0.842l-1.046,4.665l-8.412-1.69l-7.703,1.69l-1.639,4.293l1.325,9.01l4.531,2.115 l7.61-0.046l5.123-0.465l1.58-4.078l8.018-10.422l5.264,1.081l5.193-4.7l0.976,3.678l12.78,8.621l-1.557,2.108l-5.763-0.308 l2.23,3.137l3.556,0.79l4.159-1.737l-0.093-5.002l1.859-0.923l-1.487-1.575l-8.528-4.758l-2.254-6.314h7.099l2.243,2.248 l6.134,5.257l0.244,6.367l6.332,6.733l2.348-9.231l4.392-2.394l0.802,7.552l4.287,4.7l8.54-0.139 c1.661,4.247,3.148,8.563,4.427,12.978L334.642,133.156z M97.324,81.092l4.27-2.044l3.881,0.929l-1.324,5.211l-4.183,1.319 L97.324,81.092z M120.073,93.35v3.37h-9.783l-3.689-1.028l0.918-2.341l4.7-1.94h6.437v1.94H120.073z M124.582,98.05v3.259 l-2.463,1.58l-3.044,0.575c0,0,0-4.903,0-5.415H124.582z M121.822,96.72v-3.893l3.363,3.067L121.822,96.72z M123.355,104.568 v3.178l-2.347,2.347h-5.211l0.813-3.573l2.463-0.215l0.5-1.226L123.355,104.568z M110.39,98.05h5.408l-6.948,9.696l-2.852-1.534 l0.616-4.084L110.39,98.05z M132.529,103.464v3.166h-5.211l-1.417-2.062v-2.951h0.406L132.529,103.464z M127.748,99.096 l1.475-1.557l2.498,1.557l-1.999,1.656L127.748,99.096z M337.291,141.428l0.511-0.61c0.232,0.93,0.441,1.859,0.662,2.789 L337.291,141.428z" }),
						_react2.default.createElement("path", { d: "M27.734,109.268v5.106c1.771-4.177,3.747-8.231,5.855-12.223L27.734,109.268z" })
					)
				)
			)
		);
	
		return markup;
	}
	//# sourceMappingURL=international icon.js.map

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _select = __webpack_require__(1145);
	
	Object.defineProperty(exports, 'Select', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_select).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ },
/* 1144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.submit_parent_form = submit_parent_form;
	exports.get_scrollbar_width = get_scrollbar_width;
	// https://github.com/catamphetamine/react-responsive-ui/blob/master/source/misc/dom.js
	
	function submit_parent_form(node) {
		while (node.parentElement) {
			node = node.parentElement;
			if (node instanceof HTMLFormElement) {
				// Won't use `node.submit()` because it bypasses `onSubmit`.
				// Will click the submit button instead.
				var submit = node.querySelector('button[type=submit]');
				if (submit) {
					submit.click();
					return true;
				}
			}
		}
	}
	
	function get_scrollbar_width() {
		// // `window.innerWidth` has a bug:
		// // it's decreases as the page scale is increased.
		// // Therefore not using it.
		// // (Full width) - (Width minus scrollbar)
		// return document.body.clientWidth - window.innerWidth
	
		return 17;
	}
	//# sourceMappingURL=dom.js.map

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(33);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(225);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(28);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(66);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(31);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(30);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _scrollIntoViewIfNeeded = __webpack_require__(1665);
	
	var _scrollIntoViewIfNeeded2 = _interopRequireDefault(_scrollIntoViewIfNeeded);
	
	var _dom = __webpack_require__(1144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Possible enhancements:
	//
	//  * If the menu is close to a screen edge,
	//    automatically reposition it so that it fits on the screen
	//  * Maybe show menu immediately above the toggler
	//    (like in Material design), not below it.
	//
	// https://material.google.com/components/menus.html
	
	var Empty_value_option_value = '';
	
	var value_prop_type = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]);
	
	var Select = function (_PureComponent) {
		(0, _inherits3.default)(Select, _PureComponent);
	
		function Select(props) {
			(0, _classCallCheck3.default)(this, Select);
	
			// Shouldn't memory leak because
			// the set of options is assumed to be constant.
			var _this = (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).call(this, props));
	
			_initialiseProps.call(_this);
	
			_this.options = {};
	
			var _this$props = _this.props;
			var value = _this$props.value;
			var autocomplete = _this$props.autocomplete;
			var options = _this$props.options;
			var children = _this$props.children;
			var menu = _this$props.menu;
			var toggler = _this$props.toggler;
			var onChange = _this$props.onChange;
	
	
			if (autocomplete) {
				if (!options) {
					throw new Error('"options" property is required for an "autocomplete" select');
				}
	
				_this.state.matching_options = _this.get_matching_options(options, value);
			}
	
			if (children && !menu) {
				_react2.default.Children.forEach(children, function (element) {
					if (!element.props.value) {
						throw new Error('You must specify "value" prop on each child of <Select/>');
					}
	
					if (!element.props.label) {
						throw new Error('You must specify "label" prop on each child of <Select/>');
					}
				});
			}
	
			if (menu && !toggler) {
				throw new Error('Supply a "toggler" component when enabling "menu" in <Select/>');
			}
	
			if (!menu && !onChange) {
				throw new Error('"onChange" property must be specified for a non-menu <Select/>');
			}
			return _this;
		}
	
		// Client side rendering, javascript is enabled
	
	
		(0, _createClass3.default)(Select, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _props = this.props;
				var fallback = _props.fallback;
				var nativeExpanded = _props.nativeExpanded;
	
	
				document.addEventListener('click', this.document_clicked);
	
				if (fallback) {
					this.setState({ javascript: true });
				}
	
				if (nativeExpanded) {
					this.resize_native_expanded_select();
					window.addEventListener('resize', this.resize_native_expanded_select);
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(previous_props, previous_state) {
				var _props2 = this.props;
				var nativeExpanded = _props2.nativeExpanded;
				var value = _props2.value;
				var _state = this.state;
				var expanded = _state.expanded;
				var height = _state.height;
	
	
				if (expanded !== previous_state.expanded) {
					if (expanded && this.should_animate()) {
						if (height === undefined) {
							this.calculate_height();
						}
					}
				}
	
				// If the `value` changed then resize the native expanded `<select/>`
				if (nativeExpanded && value !== previous_props.value) {
					this.resize_native_expanded_select();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var nativeExpanded = this.props.nativeExpanded;
	
	
				document.removeEventListener('click', this.document_clicked);
	
				if (nativeExpanded) {
					window.removeEventListener('resize', this.resize_native_expanded_select);
				}
	
				if (this.toggle_timeout) {
					clearTimeout(this.toggle_timeout);
					this.toggle_timeout = undefined;
				}
	
				if (this.scroll_into_view_timeout) {
					clearTimeout(this.scroll_into_view_timeout);
					this.scroll_into_view_timeout = undefined;
				}
	
				if (this.restore_focus_on_collapse_timeout) {
					clearTimeout(this.restore_focus_on_collapse_timeout);
					this.restore_focus_on_collapse_timeout = undefined;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props3 = this.props;
				var id = _props3.id;
				var upward = _props3.upward;
				var scroll = _props3.scroll;
				var children = _props3.children;
				var menu = _props3.menu;
				var toggler = _props3.toggler;
				var alignment = _props3.alignment;
				var autocomplete = _props3.autocomplete;
				var saveOnIcons = _props3.saveOnIcons;
				var fallback = _props3.fallback;
				var native = _props3.native;
				var nativeExpanded = _props3.nativeExpanded;
				var disabled = _props3.disabled;
				var required = _props3.required;
				var placeholder = _props3.placeholder;
				var label = _props3.label;
				var value = _props3.value;
				var error = _props3.error;
				var style = _props3.style;
				var className = _props3.className;
				var _state2 = this.state;
				var expanded = _state2.expanded;
				var list_height = _state2.list_height;
	
	
				var options = this.get_options();
	
				var list_style = void 0;
	
				// Makes the options list scrollable (only when not in `autocomplete` mode).
				if (this.is_scrollable() && this.state.list_height !== undefined) {
					list_style = { maxHeight: list_height + 'px' };
				}
	
				var overflow = scroll && options && this.overflown();
	
				var list_items = void 0;
	
				// If a list of options is supplied as an array of `{ value, label }`,
				// then transform those elements to <buttons/>
				if (options) {
					list_items = options.map(function (_ref, index) {
						var value = _ref.value;
						var label = _ref.label;
						var icon = _ref.icon;
	
						return _this2.render_list_item({ index: index, value: value, label: label, icon: !saveOnIcons && icon, overflow: overflow });
					});
				}
				// Else, if a list of options is supplied as a set of child React elements,
				// then render those elements.
				else {
						list_items = _react2.default.Children.map(children, function (element, index) {
							if (!element) {
								return;
							}
	
							return _this2.render_list_item({ index: index, element: element });
						});
					}
	
				var wrapper_style = { textAlign: alignment };
	
				var selected = this.get_selected_option();
	
				var markup = _react2.default.createElement(
					'div',
					{
						ref: function ref(_ref3) {
							return _this2.select = _ref3;
						},
						onKeyDown: this.on_key_down_in_container,
						onBlur: this.on_blur,
						style: style ? (0, _extends3.default)({}, wrapper_style, style) : wrapper_style,
						className: (0, _classnames2.default)('rrui__select', {
							'rrui__rich': fallback,
							'rrui__select--upward': upward,
							'rrui__select--expanded': expanded,
							'rrui__select--collapsed': !expanded,
							'rrui__select--disabled': disabled
						}, className) },
					_react2.default.createElement(
						'div',
						{
							className: (0, _classnames2.default)({
								'rrui__input': !toggler
							}) },
						!menu && !native && this.render_selected_item(),
						label && (this.get_selected_option() || placeholder) && _react2.default.createElement(
							'label',
							{
								htmlFor: id,
								className: (0, _classnames2.default)('rrui__input-label', {
									'rrui__input-label--required': required && value_is_empty(value),
									'rrui__input-label--invalid': this.should_indicate_invalid()
								}) },
							label
						),
						menu && this.render_toggler(),
						!native && !nativeExpanded && list_items.length > 0 && _react2.default.createElement(
							'ul',
							{
								ref: function ref(_ref2) {
									return _this2.list = _ref2;
								},
								style: list_style,
								className: (0, _classnames2.default)('rrui__expandable', 'rrui__expandable--overlay', 'rrui__select__options', 'rrui__shadow', {
									'rrui__select__options--menu': menu,
									'rrui__expandable--expanded': expanded,
									'rrui__select__options--expanded': expanded,
									'rrui__expandable--left-aligned': alignment === 'left',
									'rrui__expandable--right-aligned': alignment === 'right',
									'rrui__select__options--left-aligned': !children && alignment === 'left',
									'rrui__select__options--right-aligned': !children && alignment === 'right',
									// CSS selector performance optimization
									'rrui__select__options--upward': upward,
									'rrui__select__options--downward': !upward
								}) },
							list_items
						),
						(native || fallback && !this.state.javascript) && this.render_static()
					),
					this.should_indicate_invalid() && _react2.default.createElement(
						'div',
						{ className: 'rrui__input-error' },
						error
					)
				);
	
				return markup;
			}
		}, {
			key: 'render_list_item',
			value: function render_list_item(_ref4) // , first, last
			{
				var _this3 = this;
	
				var index = _ref4.index;
				var element = _ref4.element;
				var value = _ref4.value;
				var label = _ref4.label;
				var icon = _ref4.icon;
				var overflow = _ref4.overflow;
				var _props4 = this.props;
				var disabled = _props4.disabled;
				var menu = _props4.menu;
				var scrollbarPadding = _props4.scrollbarPadding;
				var _state3 = this.state;
				var focused_option_value = _state3.focused_option_value;
				var expanded = _state3.expanded;
	
				// If a list of options is supplied as a set of child React elements,
				// then extract values from their props.
	
				if (element) {
					value = element.props.value;
				}
	
				var is_focused = !menu && value === focused_option_value;
	
				var item_style = void 0;
	
				// on overflow the vertical scrollbar will take up space
				// reducing padding-right and the only way to fix that
				// is to add additional padding-right
				//
				// a hack to restore padding-right taken up by a vertical scrollbar
				if (overflow && scrollbarPadding) {
					item_style = { marginRight: (0, _dom.get_scrollbar_width)() + 'px' };
				}
	
				var button = void 0;
	
				// If a list of options is supplied as a set of child React elements,
				// then enhance those elements with extra props.
				if (element) {
					(function () {
						var extra_props = {
							style: item_style ? (0, _extends3.default)({}, item_style, element.props.style) : element.props.style,
							className: (0, _classnames2.default)('rrui__select__option', {
								'rrui__select__option--focused': is_focused
							}, element.props.className)
						};
	
						var onClick = element.props.onClick;
	
						extra_props.onClick = function (event) {
							if (menu) {
								_this3.toggle();
							} else {
								_this3.item_clicked(value, event);
							}
	
							if (onClick) {
								onClick(event);
							}
						};
	
						button = _react2.default.cloneElement(element, extra_props);
					})();
				}
				// Else, if a list of options is supplied as an array of `{ value, label }`,
				// then transform those options to <buttons/>
				else {
						button = _react2.default.createElement(
							'button',
							{
								type: 'button',
								onClick: function onClick(event) {
									return _this3.item_clicked(value, event);
								},
								disabled: disabled,
								tabIndex: '-1',
								className: (0, _classnames2.default)('rrui__select__option', {
									'rrui__select__option--focused': is_focused,
									// CSS selector performance optimization
									'rrui__select__option--disabled': disabled
								}),
								style: item_style },
							icon && _react2.default.cloneElement(icon, { className: (0, _classnames2.default)(icon.props.className, 'rrui__select__option-icon') }),
							label
						);
					}
	
				var markup = _react2.default.createElement(
					'li',
					{
						key: get_option_key(value),
						ref: function ref(_ref5) {
							return _this3.options[get_option_key(value)] = _ref5;
						},
						className: (0, _classnames2.default)('rrui__expandable__content', 'rrui__select__options-list-item', {
							'rrui__select__separator-option': element && element.type === Select.Separator,
							'rrui__expandable__content--expanded': expanded,
							// CSS selector performance optimization
							'rrui__select__options-list-item--expanded': expanded
						}) },
					button
				);
	
				return markup;
			}
	
			// Renders the selected option
			// and possibly a transparent native `<select/>` above it
			// so that the native `<select/>` expands upon click
			// on the selected option
			// (in case of `nativeExpanded` setting).
	
		}, {
			key: 'render_selected_item',
			value: function render_selected_item() {
				var _props5 = this.props;
				var nativeExpanded = _props5.nativeExpanded;
				var toggler = _props5.toggler;
	
	
				if (toggler) {
					return this.render_toggler();
				}
	
				var selected = this.render_selected_item_only();
	
				if (nativeExpanded) {
					return _react2.default.createElement(
						'div',
						{ style: native_expanded_select_container_style },
						this.render_static(),
						selected
					);
				}
	
				return selected;
			}
		}, {
			key: 'render_selected_item_only',
			value: function render_selected_item_only() {
				var _this4 = this;
	
				var _props6 = this.props;
				var children = _props6.children;
				var value = _props6.value;
				var placeholder = _props6.placeholder;
				var label = _props6.label;
				var disabled = _props6.disabled;
				var autocomplete = _props6.autocomplete;
				var concise = _props6.concise;
				var nativeExpanded = _props6.nativeExpanded;
				var tabIndex = _props6.tabIndex;
				var onFocus = _props6.onFocus;
				var title = _props6.title;
				var inputClassName = _props6.inputClassName;
				var _state4 = this.state;
				var expanded = _state4.expanded;
				var autocomplete_width = _state4.autocomplete_width;
				var autocomplete_input_value = _state4.autocomplete_input_value;
	
	
				var selected = this.get_selected_option();
				var selected_label = this.get_selected_option_label();
	
				var selected_text = selected ? selected_label : placeholder || label;
	
				var selected_style_classes = {
					'rrui__input-field': true,
					'rrui__select__selected': true,
					'rrui__select__selected--nothing': !selected_label,
					// CSS selector performance optimization
					'rrui__select__selected--expanded': expanded,
					'rrui__select__selected--disabled': disabled
				};
	
				if (autocomplete && expanded) {
					// style = { ...style, width: autocomplete_width + 'px' }
	
					var _markup = _react2.default.createElement('input', {
						type: 'text',
						ref: function ref(_ref6) {
							return _this4.autocomplete = _ref6;
						},
						placeholder: selected_text,
						value: autocomplete_input_value,
						onChange: this.on_autocomplete_input_change,
						onKeyDown: this.on_key_down,
						onFocus: onFocus,
						tabIndex: tabIndex,
						title: title,
						className: (0, _classnames2.default)(selected_style_classes, 'rrui__select__selected--autocomplete', inputClassName) });
	
					return _markup;
				}
	
				var markup = _react2.default.createElement(
					'button',
					{
						ref: function ref(_ref7) {
							return _this4.selected = _ref7;
						},
						type: 'button',
						disabled: disabled,
						onClick: this.toggle,
						onKeyDown: this.on_key_down,
						onFocus: onFocus,
						tabIndex: nativeExpanded ? -1 : tabIndex,
						title: title,
						className: (0, _classnames2.default)(selected_style_classes, {
							'rrui__input-field--invalid': this.should_indicate_invalid()
						}) },
					_react2.default.createElement(
						'div',
						{ className: 'rrui__select__selected-content' },
						_react2.default.createElement(
							'div',
							{ className: 'rrui__select__selected-label' },
							concise && selected && selected.icon ? _react2.default.cloneElement(selected.icon, { title: selected_label }) : selected_text
						),
						_react2.default.createElement('div', {
							className: (0, _classnames2.default)('rrui__select__arrow', {
								// CSS selector performance optimization
								'rrui__select__arrow--expanded': expanded,
								'rrui__select__arrow--disabled': disabled
							}) })
					)
				);
	
				return markup;
			}
		}, {
			key: 'render_toggler',
			value: function render_toggler() {
				var _this5 = this;
	
				var toggler = this.props.toggler;
	
	
				return _react2.default.createElement(
					'div',
					{ className: 'rrui__select__toggler' },
					_react2.default.cloneElement(toggler, {
						ref: function ref(_ref8) {
							return _this5.selected = _ref8;
						},
						onClick: this.toggle,
						onKeyDown: this.on_key_down
					})
				);
			}
	
			// supports disabled javascript
	
		}, {
			key: 'render_static',
			value: function render_static() {
				var _this6 = this;
	
				var _props7 = this.props;
				var id = _props7.id;
				var name = _props7.name;
				var value = _props7.value;
				var label = _props7.label;
				var disabled = _props7.disabled;
				var options = _props7.options;
				var menu = _props7.menu;
				var toggler = _props7.toggler;
				var fallback = _props7.fallback;
				var native = _props7.native;
				var nativeExpanded = _props7.nativeExpanded;
				var tabIndex = _props7.tabIndex;
				var children = _props7.children;
	
	
				if (menu) {
					var _markup2 = _react2.default.createElement(
						'div',
						{
							className: (0, _classnames2.default)({
								'rrui__rich__fallback': fallback
							}) },
						toggler
					);
	
					return _markup2;
				}
	
				var markup = _react2.default.createElement(
					'select',
					{
						ref: function ref(_ref9) {
							return _this6.native = _ref9;
						},
						id: id,
						name: name,
						value: value_is_empty(value) ? Empty_value_option_value : value,
						disabled: disabled,
						onChange: this.native_select_on_change,
						tabIndex: native || nativeExpanded ? tabIndex : undefined,
						className: (0, _classnames2.default)('rrui__input', 'rrui__select__native', {
							'rrui__select__native-expanded': nativeExpanded,
							'rrui__rich__fallback': fallback
						}) },
					options ? this.render_native_select_options(options, value_is_empty(value)) : _react2.default.Children.map(children, function (child) {
						if (!child) {
							return;
						}
	
						var markup = _react2.default.createElement(
							'option',
							{
								className: 'rrui__select__native-option',
								key: child.props.value,
								value: child.props.value },
							child.props.label
						);
	
						return markup;
					})
				);
	
				return markup;
			}
		}, {
			key: 'render_native_select_options',
			value: function render_native_select_options(options, empty_option_is_selected) {
				var placeholder = this.props.placeholder;
	
	
				var empty_option_present = false;
	
				var rendered_options = options.map(function (option) {
					var value = option.value;
					var label = option.label;
	
	
					if (value_is_empty(value)) {
						empty_option_present = true;
						value = Empty_value_option_value;
					}
	
					var markup = _react2.default.createElement(
						'option',
						{
							className: 'rrui__select__native-option',
							key: get_option_key(value),
							value: value },
						label
					);
	
					return markup;
				});
	
				if (empty_option_is_selected && !empty_option_present) {
					rendered_options.unshift(_react2.default.createElement(
						'option',
						{
							className: 'rrui__select__native-option',
							key: get_option_key(undefined),
							value: '' },
						placeholder
					));
				}
	
				return rendered_options;
			}
	
			// Whether should indicate that the input value is invalid
	
		}, {
			key: 'should_indicate_invalid',
			value: function should_indicate_invalid() {
				var _props8 = this.props;
				var indicateInvalid = _props8.indicateInvalid;
				var error = _props8.error;
	
	
				return indicateInvalid && error;
			}
		}, {
			key: 'get_selected_option',
			value: function get_selected_option() {
				var value = this.props.value;
	
	
				return this.get_option(value);
			}
		}, {
			key: 'get_option',
			value: function get_option(value) {
				var _props9 = this.props;
				var options = _props9.options;
				var children = _props9.children;
	
	
				if (options) {
					return options.filter(function (x) {
						return x.value === value;
					})[0];
				}
	
				var option = void 0;
	
				_react2.default.Children.forEach(children, function (child) {
					if (child.props.value === value) {
						option = child;
					}
				});
	
				return option;
			}
		}, {
			key: 'get_option_index',
			value: function get_option_index(option) {
				var _props10 = this.props;
				var options = _props10.options;
				var children = _props10.children;
	
	
				if (options) {
					return options.indexOf(option);
				}
	
				var option_index = void 0;
	
				_react2.default.Children.forEach(children, function (child, index) {
					if (child.props.value === option.value) {
						option_index = index;
					}
				});
	
				return option_index;
			}
		}, {
			key: 'get_selected_option_label',
			value: function get_selected_option_label() {
				var options = this.props.options;
	
	
				var selected = this.get_selected_option();
	
				if (!selected) {
					return;
				}
	
				if (options) {
					return selected.label;
				}
	
				return selected.props.label;
			}
		}, {
			key: 'overflown',
			value: function overflown() {
				var _props11 = this.props;
				var options = _props11.options;
				var maxItems = _props11.maxItems;
	
	
				return options.length > maxItems;
			}
		}, {
			key: 'scrollable_list_height',
			value: function scrollable_list_height() {
				var state = arguments.length <= 0 || arguments[0] === undefined ? this.state : arguments[0];
				var maxItems = this.props.maxItems;
	
				// (Adding vertical padding so that it shows these `maxItems` options fully)
	
				return (state.height - 2 * state.vertical_padding) * (maxItems / this.get_options().length) + state.vertical_padding;
			}
		}, {
			key: 'should_animate',
			value: function should_animate() {
				return true;
	
				// return this.props.options.length >= this.props.transition_item_count_min
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (this.autocomplete) {
					this.autocomplete.focus();
				} else {
					this.selected.focus();
				}
			}
	
			// Would have used `onBlur={...}` event handler here
			// with `if (container.contains(event.relatedTarget))` condition,
			// but it doesn't work in IE in React.
			// https://github.com/facebook/react/issues/3751
			//
			// Therefore, using the hacky `document.onClick` handlers
			// and this `onKeyDown` Tab handler
			// until `event.relatedTarget` support is consistent in React.
			//
	
	
			// This handler is a workaround for `redux-form`
	
		}, {
			key: 'get_options',
			value: function get_options() {
				var _props12 = this.props;
				var autocomplete = _props12.autocomplete;
				var autocompleteShowAll = _props12.autocompleteShowAll;
				var maxItems = _props12.maxItems;
				var options = _props12.options;
				var matching_options = this.state.matching_options;
	
	
				if (!autocomplete) {
					return options;
				}
	
				if (autocompleteShowAll) {
					return matching_options;
				}
	
				return matching_options.slice(0, maxItems);
			}
	
			// Get the previous option (relative to the currently focused option)
	
		}, {
			key: 'previous_focusable_option',
			value: function previous_focusable_option() {
				var options = this.get_options();
				var focused_option_value = this.state.focused_option_value;
	
	
				var i = 0;
				while (i < options.length) {
					if (options[i].value === focused_option_value) {
						if (i - 1 >= 0) {
							return options[i - 1];
						}
					}
					i++;
				}
			}
	
			// Get the next option (relative to the currently focused option)
	
		}, {
			key: 'next_focusable_option',
			value: function next_focusable_option() {
				var options = this.get_options();
				var focused_option_value = this.state.focused_option_value;
	
	
				var i = 0;
				while (i < options.length) {
					if (options[i].value === focused_option_value) {
						if (i + 1 < options.length) {
							return options[i + 1];
						}
					}
					i++;
				}
			}
	
			// Scrolls to an option having the value
	
		}, {
			key: 'scroll_to',
			value: function scroll_to(value) {
				var vertical_padding = this.state.vertical_padding;
	
	
				var option_element = _reactDom2.default.findDOMNode(this.options[get_option_key(value)]);
				var list = _reactDom2.default.findDOMNode(this.list);
	
				// If this option isn't even shown
				// (e.g. autocomplete)
				// then don't scroll to it because there's nothing to scroll to.
				if (!option_element) {
					return;
				}
	
				var offset_top = option_element.offsetTop;
	
				var is_first_option = list.firstChild === option_element;
	
				// If it's the first one - then scroll to list top
				if (is_first_option) {
					offset_top -= vertical_padding;
				}
	
				list.scrollTop = offset_top;
			}
	
			// Fully shows an option having the `value` (scrolls to it if neccessary)
	
		}, {
			key: 'show_option',
			value: function show_option(value, gravity) {
				var vertical_padding = this.state.vertical_padding;
	
	
				var option_element = _reactDom2.default.findDOMNode(this.options[get_option_key(value)]);
				var list = _reactDom2.default.findDOMNode(this.list);
	
				var is_first_option = list.firstChild === option_element;
				var is_last_option = list.lastChild === option_element;
	
				switch (gravity) {
					case 'top':
						var top_line = option_element.offsetTop;
	
						if (is_first_option) {
							top_line -= vertical_padding;
						}
	
						if (top_line < list.scrollTop) {
							list.scrollTop = top_line;
						}
	
						return;
	
					case 'bottom':
						var bottom_line = option_element.offsetTop + option_element.offsetHeight;
	
						if (is_last_option) {
							bottom_line += vertical_padding;
						}
	
						if (bottom_line > list.scrollTop + list.offsetHeight) {
							list.scrollTop = bottom_line - list.offsetHeight;
						}
	
						return;
				}
			}
	
			// Calculates height of the expanded item list
	
		}, {
			key: 'calculate_height',
			value: function calculate_height() {
				var options = this.props.options;
	
	
				var list_dom_node = _reactDom2.default.findDOMNode(this.list);
				var border = parseInt(window.getComputedStyle(list_dom_node).borderTopWidth);
				var height = list_dom_node.scrollHeight;
	
				var vertical_padding = parseInt(window.getComputedStyle(list_dom_node).paddingTop);
	
				// For things like "accordeon".
				//
				// const images = list_dom_node.querySelectorAll('img')
				//
				// if (images.length > 0)
				// {
				// 	return this.preload_images(list_dom_node, images)
				// }
	
				var state = { height: height, vertical_padding: vertical_padding, border: border };
	
				if (this.is_scrollable() && options && this.overflown()) {
					state.list_height = this.scrollable_list_height(state);
				}
	
				this.setState(state);
			}
		}, {
			key: 'is_scrollable',
			value: function is_scrollable() {
				var _props13 = this.props;
				var menu = _props13.menu;
				var autocomplete = _props13.autocomplete;
				var autocompleteShowAll = _props13.autocompleteShowAll;
				var scroll = _props13.scroll;
	
	
				return !menu && (autocomplete && autocompleteShowAll || !autocomplete) && scroll;
			}
	
			// This turned out not to work for `autocomplete`
			// because not all options are ever shown.
			// get_widest_label_width()
			// {
			// 	// <ul/> -> <li/> -> <button/>
			// 	const label = ReactDOM.findDOMNode(this.list).firstChild.firstChild
			//
			// 	const style = getComputedStyle(label)
			//
			// 	const width = parseFloat(style.width)
			// 	const side_padding = parseFloat(style.paddingLeft)
			//
			// 	return width - 2 * side_padding
			// }
	
		}, {
			key: 'get_matching_options',
	
	
			// // https://github.com/daviferreira/react-sanfona/blob/master/src/AccordionItem/index.jsx#L54
			// // Wait for images to load before calculating maxHeight
			// preload_images(node, images)
			// {
			// 	let images_loaded = 0
			//
			// 	const image_loaded = () =>
			// 	{
			// 		images_loaded++
			//
			// 		if (images_loaded === images.length)
			// 		{
			// 			this.setState
			// 			({
			// 				height: this.props.expanded ? node.scrollHeight : 0
			// 			})
			// 		}
			// 	}
			//
			// 	for (let i = 0; i < images.length; i += 1)
			// 	{
			// 		const image = new Image()
			// 		image.src = images[i].src
			// 		image.onload = image.onerror = image_loaded
			// 	}
			// }
			value: function get_matching_options(options, value) {
				// If the autocomplete value is `undefined` or empty
				if (!value) {
					return options;
				}
	
				value = value.toLowerCase();
	
				return options.filter(function (_ref10) {
					var label = _ref10.label;
					var verbose = _ref10.verbose;
	
					return (verbose || label).toLowerCase().indexOf(value) >= 0;
				});
			}
		}]);
		return Select;
	}(_react.PureComponent);
	
	Select.propTypes = {
		// A list of selectable options
		options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			// Option value (may be `undefined`)
			value: value_prop_type,
			// Option label (may be `undefined`)
			label: _propTypes2.default.string,
			// Option icon
			icon: _propTypes2.default.node
		})),
	
		// HTML form input `name` attribute
		name: _propTypes2.default.string,
	
		// Label which is placed above the select
		label: _propTypes2.default.string,
	
		// Placeholder (like "Choose")
		placeholder: _propTypes2.default.string,
	
		// Whether to use native `<select/>`
		native: _propTypes2.default.bool.isRequired,
	
		// Whether to use native `<select/>` when expanded
		nativeExpanded: _propTypes2.default.bool.isRequired,
	
		// Show icon only for selected item,
		// and only if `concise` is `true`.
		saveOnIcons: _propTypes2.default.bool,
	
		// Disables this control
		disabled: _propTypes2.default.bool,
	
		// Set to `true` to mark the field as required
		required: _propTypes2.default.bool.isRequired,
	
		// Selected option value
		value: value_prop_type,
	
		// Is called when an option is selected
		onChange: _propTypes2.default.func,
	
		// Is called when the select is focused
		onFocus: _propTypes2.default.func,
	
		// Is called when the select is blurred.
		// This `onBlur` interceptor is a workaround for `redux-form`,
		// so that it gets the parsed `value` in its `onBlur` handler,
		// not the formatted text.
		onBlur: _propTypes2.default.func,
	
		// (exotic use case)
		// Falls back to a plain HTML input
		// when javascript is disabled (e.g. Tor)
		fallback: _propTypes2.default.bool.isRequired,
	
		// Component CSS class
		className: _propTypes2.default.string,
	
		// Autocomplete `<input/>` CSS class
		inputClassName: _propTypes2.default.string,
	
		// CSS style object
		style: _propTypes2.default.object,
	
		// If this flag is set to `true`,
		// and `icon` is specified for a selected option,
		// then the selected option will be displayed
		// as icon only, without the label.
		concise: _propTypes2.default.bool,
	
		// HTML `tabindex` attribute
		tabIndex: _propTypes2.default.number,
	
		// If set to `true`, autocompletion is available
		// upon expanding the options list.
		autocomplete: _propTypes2.default.bool,
	
		// If set to `true`, autocomple will show all
		// matching options instead of just `maxItems`.
		autocompleteShowAll: _propTypes2.default.bool,
	
		// Options list alignment ("left", "right")
		alignment: _propTypes2.default.oneOf(['left', 'right']),
	
		// If `menu` flag is set to `true`
		// then it's gonna be a dropdown menu
		// with `children` elements inside
		// and therefore `onChange` won't be called
		// on menu item click.
		menu: _propTypes2.default.bool,
	
		// If `menu` flag is set to `true`
		// then `toggler` is the dropdown menu button.
		toggler: _propTypes2.default.element,
	
		// If `scroll` is `false`, then options list
		// is not limited in height.
		// Is `true` by default (scrollable).
		scroll: _propTypes2.default.bool.isRequired,
	
		// If this flag is set to `true`,
		// then the dropdown expands itself upward.
		// (as opposed to the default downward)
		upward: _propTypes2.default.bool,
	
		// Maximum items fitting the options list height (scrollable).
		// In case of `autocomplete` that's the maximum number of matched items shown.
		// Is `6` by default.
		maxItems: _propTypes2.default.number.isRequired,
	
		// Is `true` by default (only when the list of options is scrollable)
		scrollbarPadding: _propTypes2.default.bool,
	
		focusUponSelection: _propTypes2.default.bool.isRequired,
	
		// When the `<Select/>` is expanded
		// the options list may not fit on the screen.
		// If `scrollIntoView` is `true` (which is the default)
		// then the browser will automatically scroll
		// so that the expanded options list fits on the screen.
		scrollIntoView: _propTypes2.default.bool.isRequired,
	
		// If `scrollIntoView` is `true` (which is the default)
		// then this is gonna be the delay after which it scrolls into view.
		expandAnimationDuration: _propTypes2.default.number.isRequired,
	
		onTabOut: _propTypes2.default.func,
	
		onToggle: _propTypes2.default.func
	
		// transition_item_count_min : PropTypes.number,
		// transition_duration_min : PropTypes.number,
		// transition_duration_max : PropTypes.number
	};
	Select.defaultProps = {
		alignment: 'left',
		scroll: true,
		maxItems: 6,
		scrollbarPadding: true,
		focusUponSelection: true,
		fallback: false,
		native: false,
		nativeExpanded: false,
		scrollIntoView: true,
		expandAnimationDuration: 150,
	
		// Set to `true` to mark the field as required
		required: false
	
	};
	
	var _initialiseProps = function _initialiseProps() {
		var _this7 = this;
	
		this.state = {
			// Is initialized during the first `componentDidUpdate()` call
			vertical_padding: 0
		};
	
		this.native_select_on_change = function (event) {
			var onChange = _this7.props.onChange;
	
	
			var value = event.target.value;
	
			// Convert back from an empty string to `undefined`
			if (value === Empty_value_option_value) {
				// `null` is not accounted for, use `undefined` instead.
				value = undefined;
			}
	
			onChange(value);
		};
	
		this.resize_native_expanded_select = function () {
			// For some strange reason 1px on the right side of the `<select/>`
			// still falls through to the underlying selected option label.
			_reactDom2.default.findDOMNode(_this7.native).style.width = _reactDom2.default.findDOMNode(_this7.selected).offsetWidth + 1 + 'px';
		};
	
		this.toggle = function (event) {
			var toggle_options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
			if (event) {
				// Don't navigate away when clicking links
				event.preventDefault();
	
				// Not discarding the click event because
				// other expanded selects may be listening to it.
				// // Discard the click event so that it won't reach `document` click listener
				// event.stopPropagation() // doesn't work
				// event.nativeEvent.stopImmediatePropagation()
			}
	
			var _props14 = _this7.props;
			var toggler = _props14.toggler;
			var disabled = _props14.disabled;
			var autocomplete = _props14.autocomplete;
			var options = _props14.options;
			var value = _props14.value;
			var focusUponSelection = _props14.focusUponSelection;
			var onToggle = _props14.onToggle;
			var nativeExpanded = _props14.nativeExpanded;
			var scrollIntoView = _props14.scrollIntoView;
			var expandAnimationDuration = _props14.expandAnimationDuration;
	
	
			if (nativeExpanded) {
				return;
			}
	
			if (disabled) {
				return;
			}
	
			if (_this7.toggle_timeout) {
				clearTimeout(_this7.toggle_timeout);
				_this7.toggle_timeout = undefined;
			}
	
			if (_this7.scroll_into_view_timeout) {
				clearTimeout(_this7.scroll_into_view_timeout);
				_this7.scroll_into_view_timeout = undefined;
			}
	
			var expanded = _this7.state.expanded;
	
	
			if (!expanded && autocomplete) {
				_this7.setState({
					// The input value can't be `undefined`
					// because in that case React would complain
					// about it being an "uncontrolled input"
					autocomplete_input_value: '',
					matching_options: options
				});
	
				// if (!this.state.autocomplete_width)
				// {
				// 	this.setState({ autocomplete_width: this.get_widest_label_width() })
				// }
			}
	
			// Deferring expanding the select upon click
			// because `document.onClick(event)` should fire first,
			// otherwise `event.target` in that handler will be detached
			// from the document and so `this.document_clicked()` handler will
			// immediately toggle the select back to collapsed state.
			_this7.toggle_timeout = setTimeout(function () {
				_this7.toggle_timeout = undefined;
	
				_this7.setState({
					expanded: !expanded
				}, function () {
					var is_now_expanded = _this7.state.expanded;
	
					if (!toggle_options.dont_focus_after_toggle) {
						// If it's autocomplete, then focus <input/> field
						// upon toggling the select component.
						if (autocomplete) {
							if (is_now_expanded) {
								// Focus the input after the select is expanded
								_this7.autocomplete.focus();
							} else if (focusUponSelection) {
								// Focus the toggler after the select is collapsed
								_this7.selected.focus();
							}
						} else {
							// For some reason Firefox loses focus
							// upon select expansion via a click,
							// so this extra `.focus()` works around that issue.
							_this7.selected.focus();
						}
					}
	
					_this7.scroll_into_view_timeout = setTimeout(function () {
						_this7.scroll_into_view_timeout = undefined;
	
						var is_still_expanded = _this7.state.expanded;
	
						if (is_still_expanded && _this7.list && scrollIntoView) {
							var element = _reactDom2.default.findDOMNode(_this7.list);
	
							// https://developer.mozilla.org/ru/docs/Web/API/Element/scrollIntoViewIfNeeded
							if (element.scrollIntoViewIfNeeded) {
								element.scrollIntoViewIfNeeded(false);
							} else {
								// https://github.com/stipsan/scroll-into-view-if-needed
								(0, _scrollIntoViewIfNeeded2.default)(element, false, { duration: 800 });
							}
						}
					}, expandAnimationDuration * 1.1);
				});
	
				if (!expanded && options) {
					// Focus either the selected option
					// or the first option in the list.
	
					var focused_option_value = value || options[0].value;
	
					_this7.setState({ focused_option_value: focused_option_value });
	
					// Scroll down to the focused option
					_this7.scroll_to(focused_option_value);
				}
	
				if (onToggle) {
					onToggle(!expanded);
				}
	
				if (toggle_options.callback) {
					toggle_options.callback();
				}
			}, 0);
		};
	
		this.item_clicked = function (value, event) {
			if (event) {
				event.preventDefault();
			}
	
			var onChange = _this7.props.onChange;
	
	
			_this7.toggle(undefined, { callback: function callback() {
					return onChange(value);
				} });
		};
	
		this.document_clicked = function (event) {
			var autocomplete = _reactDom2.default.findDOMNode(_this7.autocomplete);
			var selected_option = _reactDom2.default.findDOMNode(_this7.selected);
			var options_list = _reactDom2.default.findDOMNode(_this7.list);
	
			// Don't close the select if its expander button has been clicked,
			// or if autocomplete has been clicked,
			// or if an option was selected from the list.
			if (options_list && options_list.contains(event.target) || autocomplete && autocomplete.contains(event.target) || selected_option && selected_option.contains(event.target)) {
				return;
			}
	
			_this7.setState({ expanded: false });
	
			var onToggle = _this7.props.onToggle;
	
	
			if (onToggle) {
				onToggle(false);
			}
		};
	
		this.on_key_down_in_container = function (event) {
			if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
				return;
			}
	
			var expanded = _this7.state.expanded;
	
	
			switch (event.keyCode) {
				// Toggle on Tab out
				case 9:
					if (expanded) {
						_this7.toggle(undefined, { dont_focus_after_toggle: true });
	
						var onTabOut = _this7.props.onTabOut;
	
	
						if (onTabOut) {
							onTabOut(event);
						}
					}
					return;
			}
		};
	
		this.on_key_down = function (event) {
			if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
				return;
			}
	
			var _props15 = _this7.props;
			var options = _props15.options;
			var value = _props15.value;
			var autocomplete = _props15.autocomplete;
			var _state5 = _this7.state;
			var expanded = _state5.expanded;
			var focused_option_value = _state5.focused_option_value;
	
			// Maybe add support for `children` arrow navigation in future
	
			if (options) {
				switch (event.keyCode) {
					// Select the previous option (if present) on up arrow
					case 38:
						event.preventDefault();
	
						var previous = _this7.previous_focusable_option();
	
						if (previous) {
							_this7.show_option(previous.value, 'top');
							return _this7.setState({ focused_option_value: previous.value });
						}
	
						return;
	
					// Select the next option (if present) on down arrow
					case 40:
						event.preventDefault();
	
						var next = _this7.next_focusable_option();
	
						if (next) {
							_this7.show_option(next.value, 'bottom');
							return _this7.setState({ focused_option_value: next.value });
						}
	
						return;
	
					// Collapse on Escape
					//
					// Maybe add this kind of support for "Escape" key in some future:
					//  hiding the item list, cancelling current item selection process
					//  and restoring the selection present before the item list was toggled.
					//
					case 27:
						// Collapse the list if it's expanded
						if (_this7.state.expanded) {
							_this7.toggle();
	
							// Restore focus when the list is collapsed
							_this7.restore_focus_on_collapse_timeout = setTimeout(function () {
								_this7.restore_focus_on_collapse_timeout = undefined;
	
								_this7.selected.focus();
							}, 0);
						}
	
						return;
	
					// on Enter
					case 13:
						// Choose the focused item on Enter
						if (expanded) {
							event.preventDefault();
	
							// If an item is focused
							// (which may not be a case
							//  when autocomplete is matching no items)
							// (still for non-autocomplete select
							//  it is valid to have a default option)
							if (_this7.get_options() && _this7.get_options().length > 0) {
								// Choose the focused item
								_this7.item_clicked(focused_option_value);
							}
						}
						// Else it should have just submitted the form on Enter,
						// but it wouldn't because the select element activator is a <button/>
						// therefore hitting Enter while being focused on it just pushes that button.
						// So submit the enclosing form manually.
						else {
								if ((0, _dom.submit_parent_form)(_reactDom2.default.findDOMNode(_this7.select))) {
									event.preventDefault();
								}
							}
	
						return;
	
					// on Spacebar
					case 32:
						// Choose the focused item on Enter
						if (expanded) {
							// only if it it's an `options` select
							// and also if it's not an autocomplete
							if (_this7.get_options() && !autocomplete) {
								event.preventDefault();
	
								// `focused_option_value` could be non-existent
								// in case of `autocomplete`, but since
								// we're explicitly not handling autocomplete here
								// it is valid to select any options including the default ones.
								_this7.item_clicked(focused_option_value);
							}
						}
						// Otherwise, the spacebar keydown event on a `<button/>`
						// will trigger `onClick` and `.toggle()` will be called.
	
						return;
				}
			}
		};
	
		this.on_blur = function (event) {
			var _props16 = _this7.props;
			var onBlur = _props16.onBlur;
			var value = _props16.value;
	
			// If clicked on a select option then don't trigger "blur" event
	
			if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
				return;
			}
	
			// This `onBlur` interceptor is a workaround for `redux-form`,
			// so that it gets the right (parsed, not the formatted one)
			// `event.target.value` in its `onBlur` handler.
			if (onBlur) {
				var _event = (0, _extends3.default)({}, event, {
					target: (0, _extends3.default)({}, event.target, {
						value: value
					})
				});
	
				// For `redux-form` event detection.
				// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
				_event.stopPropagation = event.stopPropagation;
				_event.preventDefault = event.preventDefault;
	
				onBlur(_event);
			}
		};
	
		this.on_autocomplete_input_change = function (event) {
			var options = _this7.props.options;
	
			var input = event.target.value;
			var matching_options = _this7.get_matching_options(options, input);
	
			_this7.setState({
				autocomplete_input_value: input,
				matching_options: matching_options,
				focused_option_value: matching_options.length > 0 ? matching_options[0].value : undefined
			});
		};
	};
	
	exports.default = Select;
	
	
	Select.Separator = function (props) {
		return _react2.default.createElement('div', { className: 'rrui__select__separator' });
	};
	
	var native_expanded_select_container_style = {
		display: 'inline-block'
	};
	
	// There can be an `undefined` value,
	// so just `{ value }` won't do here.
	function get_option_key(value) {
		return value_is_empty(value) ? '@@rrui/select/undefined' : value;
	}
	
	function value_is_empty(value) {
		return value === null || value === undefined;
	}
	//# sourceMappingURL=select.js.map

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	exports = module.exports = __webpack_require__(574).default
	
	module.exports['default'] = __webpack_require__(574).default

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(22);
	var createClass = __webpack_require__(34);
	var QuillMixin = __webpack_require__(576);
	var find = __webpack_require__(586);
	var some = __webpack_require__(1236);
	var isEqual = __webpack_require__(589);
	var T = __webpack_require__(8);
	var DOM = __webpack_require__(544);
	
	var QuillComponent = createClass({
	
		displayName: 'Quill',
	
		mixins: [ QuillMixin ],
	
		propTypes: {
			id: T.string,
			className: T.string,
			theme: T.string,
			style: T.object,
			readOnly: T.bool,
			value: T.oneOfType([T.string, T.shape({ops: T.array})]),
			defaultValue: T.oneOfType([T.string, T.shape({ops: T.array})]),
			placeholder: T.string,
			tabIndex: T.number,
			bounds: T.oneOfType([T.string, T.element]),
			onChange: T.func,
			onChangeSelection: T.func,
			onFocus: T.func,
			onBlur: T.func,
			onKeyPress: T.func,
			onKeyDown: T.func,
			onKeyUp: T.func,
			preserveWhitespace: T.bool,
	
			modules: function(props) {
				var isNotObject = T.object.apply(this, arguments);
				if (isNotObject) return isNotObject;
	
				if (
					props.modules && 
					props.modules.toolbar &&
					props.modules.toolbar[0] &&
					props.modules.toolbar[0].type
				) return new Error(
					'Since v1.0.0, React Quill will not create a custom toolbar for you ' +
					'anymore. Create a toolbar explictly, or let Quill create one. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			toolbar: function(props) {
				if ('toolbar' in props) return new Error(
					'The `toolbar` prop has been deprecated. Use `modules.toolbar` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			formats: function(props) {
				var isNotArrayOfString = T.arrayOf(T.string).apply(this, arguments);
	
				if (isNotArrayOfString) return new Error(
					'You cannot specify custom `formats` anymore. Use Parchment instead.  ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			styles: function(props) {
				if ('styles' in props) return new Error(
					'The `styles` prop has been deprecated. Use custom stylesheets instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			pollInterval: function(props) {
				if ('pollInterval' in props) return new Error(
					'The `pollInterval` property does not have any effect anymore. ' +
					'You can safely remove it from your props.' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			children: function(props) {
				// Validate that the editor has only one child element and it is not a <textarea>
				var isNotASingleElement = T.element.apply(this, arguments);
				if (isNotASingleElement) return new Error(
					'The Quill editing area can only be composed of a single React element.'
				);
	
				if (React.Children.count(props.children)) {
					var child = React.Children.only(props.children);
					if (child.type === 'textarea') return new Error(
						'Quill does not support editing on a <textarea>. Use a <div> instead.'
					);
				}
			}
		},
			
		/*
		Changing one of these props should cause a full re-render.
		*/
		dirtyProps: [
			'modules',
			'formats',
			'bounds',
			'theme',
			'children',
		],
	
		/*
		Changing one of these props should cause a regular update.
		*/
		cleanProps: [
			'id',
			'className',
			'style',
			'placeholder',
			'tabIndex',
			'onChange',
			'onChangeSelection',
			'onFocus',
			'onBlur',
			'onKeyPress',
			'onKeyDown',
			'onKeyUp',
		],
	
		getDefaultProps: function() {
			return {
				theme: 'snow',
				modules: {},
			};
		},
	
		/*
		We consider the component to be controlled if `value` is being sent in props.
		*/
		isControlled: function() {
			return 'value' in this.props;
		},
	
		getInitialState: function() {
			return {
				generation: 0,
				value: this.isControlled()
					? this.props.value
					: this.props.defaultValue
			};
		},
	
		componentWillReceiveProps: function(nextProps, nextState) {
			var editor = this.editor;
	
			// If the component is unmounted and mounted too quickly
			// an error is thrown in setEditorContents since editor is
			// still undefined. Must check if editor is undefined
			// before performing this call.
			if (!editor) return;
			
			// Update only if we've been passed a new `value`.
			// This leaves components using `defaultValue` alone.
			if ('value' in nextProps) {
				var currentContents = this.getEditorContents();
				var nextContents = nextProps.value;
	
				if (nextContents === this.lastDeltaChangeSet) throw new Error(
					'You are passing the `delta` object from the `onChange` event back ' +
					'as `value`. You most probably want `editor.getContents()` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#using-deltas'
				);
	
				// NOTE: Seeing that Quill is missing a way to prevent
				//       edits, we have to settle for a hybrid between
				//       controlled and uncontrolled mode. We can't prevent
				//       the change, but we'll still override content
				//       whenever `value` differs from current state.
				// NOTE: Comparing an HTML string and a Quill Delta will always trigger 
				//       a change, regardless of whether they represent the same document.
				if (!this.isEqualValue(nextContents, currentContents)) {
					this.setEditorContents(editor, nextContents);
				}
			}
			
			// We can update readOnly state in-place.
			if ('readOnly' in nextProps) {
				if (nextProps.readOnly !== this.props.readOnly) {
					this.setEditorReadOnly(editor, nextProps.readOnly);
				}
			}
	
			// If we need to regenerate the component, we can avoid a detailed
			// in-place update step, and just let everything rerender.
			if (this.shouldComponentRegenerate(nextProps, nextState)) {
				return this.regenerate();
			}
		},
	
		componentDidMount: function() {
			this.editor = this.createEditor(
				this.getEditingArea(),
				this.getEditorConfig()
			);
			// Restore editor from Quill's native formats in regeneration scenario
			if (this.quillDelta) {
				this.editor.setContents(this.quillDelta);
				this.editor.setSelection(this.quillSelection);		
				this.editor.focus();
				this.quillDelta = this.quillSelection = null;
				return;
			}
			if (this.state.value) {
				this.setEditorContents(this.editor, this.state.value);
				return;
			}
		},
	
		componentWillUnmount: function() {
			var editor; if ((editor = this.getEditor())) {
				this.unhookEditor(editor);
				this.editor = null;
			}
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			var self = this;
	
			// If the component has been regenerated, we already know we should update.
			if (this.state.generation !== nextState.generation) {
				return true;
			}
			
			// Compare props that require React updating the DOM.
			return some(this.cleanProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		shouldComponentRegenerate: function(nextProps, nextState) {
			var self = this;
			// Whenever a `dirtyProp` changes, the editor needs reinstantiation.
			return some(this.dirtyProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		/*
		If we could not update settings from the new props in-place, we have to tear
		down everything and re-render from scratch.
		*/
		componentWillUpdate: function(nextProps, nextState) {
			if (this.state.generation !== nextState.generation) {
				this.componentWillUnmount();
			}
		},
	
		componentDidUpdate: function(prevProps, prevState) {
			if (this.state.generation !== prevState.generation) {
				this.componentDidMount();
			}
		},
	
		getEditorConfig: function() {
			return {
				bounds:       this.props.bounds,
				formats:      this.props.formats,
				modules:      this.props.modules,
				placeholder:  this.props.placeholder,
				readOnly:     this.props.readOnly,
	      			scrollingContainer: this.props.scrollingContainer,
				tabIndex:     this.props.tabIndex,
				theme:        this.props.theme,
			};
		},
	
		getEditor: function() {
			return this.editor;
		},
	
		getEditingArea: function () {
			return ReactDOM.findDOMNode(this.editingArea);
		},
	
		getEditorContents: function() {
			return this.state.value;
		},
	
		getEditorSelection: function() {
			return this.state.selection;
		},
	
		/*
		True if the value is a Delta instance or a Delta look-alike.
		*/
		isDelta: function(value) {
			return value && value.ops;
		},
	
		/*
		Special comparison function that knows how to compare Deltas.
		*/
		isEqualValue: function(value, nextValue) {
			if (this.isDelta(value) && this.isDelta(nextValue)) {
				return isEqual(value.ops, nextValue.ops);
			} else {
				return isEqual(value, nextValue);
			}
		},
	
		/*
		Regenerating the editor will cause the whole tree, including the container,
		to be cleaned up and re-rendered from scratch.
		*/
		regenerate: function() {
			// Cache selection and contents in Quill's native format to be restored later
			this.quillDelta = this.editor.getContents();
			this.quillSelection = this.editor.getSelection();
			this.setState({
				generation: this.state.generation + 1,
			});
		},
	
		/*
		Renders an editor area, unless it has been provided one to clone.
		*/
		renderEditingArea: function() {
			var self = this;
			var children = this.props.children;
			var preserveWhitespace = this.props.preserveWhitespace;
	
			var properties = {
				key: this.state.generation,
				tabIndex: this.props.tabIndex,
				ref: function(element) { self.editingArea = element },
			};
	
			var customElement = React.Children.count(children)
				? React.Children.only(children)
				: null;
			var defaultElement = preserveWhitespace ? DOM.pre : DOM.div;
			var editingArea = customElement
				? React.cloneElement(customElement, properties)
				: defaultElement(properties);
	
			return editingArea;
		},
	
		render: function() {
			return DOM.div({
				id: this.props.id,
				style: this.props.style,
				key: this.state.generation,
				className: ['quill'].concat(this.props.className).join(' '),
				onKeyPress: this.props.onKeyPress,
				onKeyDown: this.props.onKeyDown,
				onKeyUp: this.props.onKeyUp },
				this.renderEditingArea()
			);
		},
	
		onEditorChangeText: function(value, delta, source, editor) {
			var currentContents = this.getEditorContents();
	
			// We keep storing the same type of value as what the user gives us,
			// so that value comparisons will be more stable and predictable.
			var nextContents = this.isDelta(currentContents)
				? editor.getContents()
				: editor.getHTML();
			
			if (!this.isEqualValue(nextContents, currentContents)) {
				// Taint this `delta` object, so we can recognize whether the user
				// is trying to send it back as `value`, preventing a likely loop.
				this.lastDeltaChangeSet = delta;
	
				this.setState({ value: nextContents });
	
				if (this.props.onChange) {
					this.props.onChange(value, delta, source, editor);
				}
			}
		},
	
		onEditorChangeSelection: function(nextSelection, source, editor) {
			var currentSelection = this.getEditorSelection();
			var hasGainedFocus = !currentSelection && nextSelection;
			var hasLostFocus = currentSelection && !nextSelection;
	
			if (isEqual(nextSelection, currentSelection)) {
				return;
			}
			
			this.setState({ selection: nextSelection });
			
			if (this.props.onChangeSelection) {
				this.props.onChangeSelection(nextSelection, source, editor);
			}
	
			if (hasGainedFocus && this.props.onFocus) {
				this.props.onFocus(nextSelection, source, editor);
			} else if (hasLostFocus && this.props.onBlur) {
				this.props.onBlur(currentSelection, source, editor);
			}
		},
	
		focus: function() {
			this.editor.focus();
		},
	
		blur: function() {
			this.setEditorSelection(this.editor, null);
		}
	
	});
	
	module.exports = QuillComponent;


/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	/*
	QuillToolbar is deprecated. Consider switching to the official Quill
	toolbar format, or providing your own toolbar instead. 
	See https://quilljs.com/docs/modules/toolbar
	*/
	
	'use strict';
	
	var React = __webpack_require__(1);
	var ReactDOMServer = __webpack_require__(1135);
	var createClass = __webpack_require__(34);
	var find = __webpack_require__(586);
	var isEqual = __webpack_require__(589);
	var T = __webpack_require__(8);
	var DOM = __webpack_require__(544);
	
	var defaultColors = [
		'rgb(  0,   0,   0)', 'rgb(230,   0,   0)', 'rgb(255, 153,   0)',
		'rgb(255, 255,   0)', 'rgb(  0, 138,   0)', 'rgb(  0, 102, 204)',
		'rgb(153,  51, 255)', 'rgb(255, 255, 255)', 'rgb(250, 204, 204)',
		'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(204, 232, 204)',
		'rgb(204, 224, 245)', 'rgb(235, 214, 255)', 'rgb(187, 187, 187)',
		'rgb(240, 102, 102)', 'rgb(255, 194, 102)', 'rgb(255, 255, 102)',
		'rgb(102, 185, 102)', 'rgb(102, 163, 224)', 'rgb(194, 133, 255)',
		'rgb(136, 136, 136)', 'rgb(161,   0,   0)', 'rgb(178, 107,   0)',
		'rgb(178, 178,   0)', 'rgb(  0,  97,   0)', 'rgb(  0,  71, 178)',
		'rgb(107,  36, 178)', 'rgb( 68,  68,  68)', 'rgb( 92,   0,   0)',
		'rgb(102,  61,   0)', 'rgb(102, 102,   0)', 'rgb(  0,  55,   0)',
		'rgb(  0,  41, 102)', 'rgb( 61,  20,  10)',
	].map(function(color){ return { value: color } });
	
	var defaultItems = [
	
		{ label:'Formats', type:'group', items: [
			{ label:'Font', type:'font', items: [
				{ label:'Sans Serif',  value:'sans-serif', selected:true },
				{ label:'Serif',       value:'serif' },
				{ label:'Monospace',   value:'monospace' }
			]},
			{ label:'Size', type:'size', items: [
				{ label:'Small',  value:'10px' },
				{ label:'Normal', value:'13px', selected:true },
				{ label:'Large',  value:'18px' },
				{ label:'Huge',   value:'32px' }
			]},
			{ label:'Alignment', type:'align', items: [
				{ label:'', value:'', selected:true },
				{ label:'', value:'center' },
				{ label:'', value:'right' },
				{ label:'', value:'justify' }
			]}
		]},
	
		{ label:'Text', type:'group', items: [
			{ type:'bold', label:'Bold' },
			{ type:'italic', label:'Italic' },
			{ type:'strike', label:'Strike' },
			{ type:'underline', label:'Underline' },
			{ type:'color', label:'Color', items:defaultColors },
			{ type:'background', label:'Background color', items:defaultColors },
			{ type:'link', label:'Link' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'list', value:'bullet' },
			{ type:'list', value:'ordered' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'image', label:'Image' }
		]}
	
	];
	
	var QuillToolbar = createClass({
	
		displayName: 'Quill Toolbar',
	
		propTypes: {
			id:        T.string,
			className: T.string,
			style:     T.object,
			items:     T.array
		},
	
		getDefaultProps: function() {
			return {
				items: defaultItems
			};
		},
	
		componentDidMount: function() {
			console.warn(
				'QuillToolbar is deprecated. Consider switching to the official Quill ' +
				'toolbar format, or providing your own toolbar instead. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v1-0-0'
			);
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			return !isEqual(nextProps, this.props);
		},
	
		renderGroup: function(item, key) {
			return DOM.span({
				key: item.label || key,
				className:'ql-formats' },
				item.items.map(this.renderItem)
			);
		},
	
		renderChoiceItem: function(item, key) {
			return DOM.option({
				key: item.label || item.value || key,
				value: item.value },
				item.label
			);
		},
	
		renderChoices: function(item, key) {
			var choiceItems = item.items.map(this.renderChoiceItem);
			var selectedItem = find(item.items, function(item){ return item.selected });
			var attrs = {
				key: item.label || key,
				title: item.label,
				className: 'ql-'+item.type,
				value: selectedItem.value,
			};
			return DOM.select(attrs, choiceItems);
		},
	
		renderButton: function(item, key) {
			return DOM.button({
				type: 'button',
				key: item.label || item.value || key,
				value: item.value,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		renderAction: function(item, key) {
			return DOM.button({
				key: item.label || item.value || key,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		/* jshint maxcomplexity: false */
		renderItem: function(item, key) {
			switch (item.type) {
				case 'group':
					return this.renderGroup(item, key);
				case 'font':
				case 'header':
				case 'align':
				case 'size':
				case 'color':
				case 'background':
					return this.renderChoices(item, key);
				case 'bold':
				case 'italic':
				case 'underline':
				case 'strike':
				case 'link':
				case 'list':
				case 'bullet':
				case 'ordered':
				case 'indent':
				case 'image':
				case 'video':
					return this.renderButton(item, key);
				default:
					return this.renderAction(item, key);
			}
		},
	
		getClassName: function() {
			return 'quill-toolbar ' + (this.props.className||'');
		},
	
		render: function() {
			var children = this.props.items.map(this.renderItem);
			var html = children.map(ReactDOMServer.renderToStaticMarkup).join('');
			return DOM.div({
				id: this.props.id,
				className: this.getClassName(),
				style: this.props.style,
				dangerouslySetInnerHTML: { __html:html }
			});
		},
	
	});
	
	module.exports = QuillToolbar;
	QuillToolbar.defaultItems = defaultItems;
	QuillToolbar.defaultColors = defaultColors;


/***/ },
/* 1149 */
[1676, 115, 58],
/* 1150 */
[1677, 1195, 1196, 1197, 1198, 1199],
/* 1151 */
[1681, 115, 58],
/* 1152 */
[1682, 115, 58],
/* 1153 */
[1683, 273, 1220, 1221],
/* 1154 */
[1686, 58],
/* 1155 */
[1687, 115, 58],
/* 1156 */
605,
/* 1157 */
[1688, 1177, 587, 59, 588, 276, 591],
/* 1158 */
286,
/* 1159 */
625,
/* 1160 */
[1690, 1163, 1183],
/* 1161 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 1162 */
[1691, 1184],
/* 1163 */
[1692, 1162, 177],
/* 1164 */
[1694, 1159, 59],
/* 1165 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1166 */
[1696, 130, 132],
/* 1167 */
[1698, 577, 581, 1186, 1187, 1192, 59, 588, 591],
/* 1168 */
[1699, 577, 274],
/* 1169 */
[1700, 590, 1202, 131, 585],
/* 1170 */
[1701, 130, 279, 132],
/* 1171 */
[1703, 1203, 1216],
/* 1172 */
[1704, 1168, 1189, 584],
/* 1173 */
[1705, 274, 1231, 1232, 277, 583, 584, 174],
/* 1174 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1175 */
[1706, 579],
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1160);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 1177 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1178 */
[1707, 170, 1158, 59, 176],
/* 1179 */
[1708, 1229],
/* 1180 */
607,
/* 1181 */
608,
/* 1182 */
[1710, 58],
/* 1183 */
[1711, 175],
/* 1184 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1185 */
[1712, 275, 175, 177],
/* 1186 */
[1714, 170, 1154, 278, 581, 1214, 1222],
/* 1187 */
[1715, 1188],
/* 1188 */
[1716, 1164, 1191, 177],
/* 1189 */
[1718, 583, 177],
/* 1190 */
[1720, 170],
/* 1191 */
[1721, 1156, 1237],
/* 1192 */
[1722, 1149, 272, 1151, 1152, 1155, 130, 585],
/* 1193 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1194 */
[1723, 580, 587, 59, 276, 279, 174],
/* 1195 */
[1724, 173],
/* 1196 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1197 */
[1725, 173],
/* 1198 */
[1726, 173],
/* 1199 */
[1727, 173],
/* 1200 */
[1728, 278, 175, 276, 131],
/* 1201 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1202 */
[1730, 1182],
/* 1203 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 1204 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1205 */
[1732, 171],
/* 1206 */
[1733, 171],
/* 1207 */
[1734, 171],
/* 1208 */
[1735, 171],
/* 1209 */
[1736, 1150, 169, 272],
/* 1210 */
[1737, 172],
/* 1211 */
[1738, 172],
/* 1212 */
[1739, 172],
/* 1213 */
[1740, 172],
/* 1214 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1215 */
[1741, 1234],
/* 1216 */
[1743, 1219],
/* 1217 */
[1744, 582],
/* 1218 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1219 */
615,
/* 1220 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1221 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1222 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1223 */
[1746, 169],
/* 1224 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1225 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1226 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1227 */
[1747, 169, 272, 273],
/* 1228 */
[1748, 1215],
/* 1229 */
/***/ function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ },
/* 1230 */
[1751, 1161, 275, 1240],
/* 1231 */
[1752, 579],
/* 1232 */
[1753, 1165, 1194],
/* 1233 */
144,
/* 1234 */
[1762, 273],
/* 1235 */
[1763, 1174, 1175, 277, 174],
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(578),
	    baseIteratee = __webpack_require__(275),
	    baseSome = __webpack_require__(1176),
	    isArray = __webpack_require__(59),
	    isIterateeCall = __webpack_require__(1200);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 1237 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1238 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1239 */
[1764, 1241],
/* 1240 */
[1765, 1239],
/* 1241 */
[1766, 1179, 131, 176],
/* 1242 */
[1767, 1178],
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Radio = _react2['default'].createClass({
	  displayName: 'Radio',
	
	  contextTypes: {
	    radioGroup: _react2['default'].PropTypes.object
	  },
	
	  render: function render() {
	    var _context$radioGroup = this.context.radioGroup;
	    var name = _context$radioGroup.name;
	    var selectedValue = _context$radioGroup.selectedValue;
	    var onChange = _context$radioGroup.onChange;
	
	    var optional = {};
	    if (selectedValue !== undefined) {
	      optional.checked = this.props.value === selectedValue;
	    }
	    if (typeof onChange === 'function') {
	      optional.onChange = onChange.bind(null, this.props.value);
	    }
	
	    return _react2['default'].createElement('input', _extends({}, this.props, {
	      type: 'radio',
	      name: name
	    }, optional));
	  }
	});
	
	exports.Radio = Radio;
	var RadioGroup = _react2['default'].createClass({
	  displayName: 'RadioGroup',
	
	  propTypes: {
	    name: _react.PropTypes.string,
	    selectedValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.bool]),
	    onChange: _react.PropTypes.func,
	    children: _react.PropTypes.node.isRequired,
	    Component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.object])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      Component: "div"
	    };
	  },
	
	  childContextTypes: {
	    radioGroup: _react2['default'].PropTypes.object
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var name = _props.name;
	    var selectedValue = _props.selectedValue;
	    var onChange = _props.onChange;
	
	    return {
	      radioGroup: {
	        name: name, selectedValue: selectedValue, onChange: onChange
	      }
	    };
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var Component = _props2.Component;
	    var name = _props2.name;
	    var selectedValue = _props2.selectedValue;
	    var onChange = _props2.onChange;
	    var children = _props2.children;
	
	    var rest = _objectWithoutProperties(_props2, ['Component', 'name', 'selectedValue', 'onChange', 'children']);
	
	    return _react2['default'].createElement(
	      Component,
	      rest,
	      children
	    );
	  }
	});
	exports.RadioGroup = RadioGroup;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeDetectorStyles = __webpack_require__(1245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResizeDetector = function (_Component) {
	  _inherits(ResizeDetector, _Component);
	
	  function ResizeDetector() {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));
	
	    _this.state = {
	      expandChildHeight: 0,
	      expandChildWidth: 0,
	      expandScrollLeft: 0,
	      expandScrollTop: 0,
	      shrinkScrollTop: 0,
	      shrinkScrollLeft: 0,
	      lastWidth: 0,
	      lastHeight: 0
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _containerSize = this.containerSize(),
	          _containerSize2 = _slicedToArray(_containerSize, 2),
	          width = _containerSize2[0],
	          height = _containerSize2[1];
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.expand.scrollLeft = this.expand.scrollWidth;
	      this.expand.scrollTop = this.expand.scrollHeight;
	
	      this.shrink.scrollLeft = this.shrink.scrollWidth;
	      this.shrink.scrollTop = this.shrink.scrollHeight;
	    }
	  }, {
	    key: 'containerSize',
	    value: function containerSize() {
	      return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
	    }
	  }, {
	    key: 'reset',
	    value: function reset(containerWidth, containerHeight) {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var parent = this.container.parentElement;
	
	      var position = 'static';
	      if (parent.currentStyle) {
	        position = parent.currentStyle.position;
	      } else if (window.getComputedStyle) {
	        position = window.getComputedStyle(parent).position;
	      }
	      if (position === 'static') {
	        parent.style.position = 'relative';
	      }
	
	      this.setState({
	        expandChildHeight: this.expand.offsetHeight + 10,
	        expandChildWidth: this.expand.offsetWidth + 10,
	        lastWidth: containerWidth,
	        lastHeight: containerHeight
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var state = this.state;
	
	      var _containerSize3 = this.containerSize(),
	          _containerSize4 = _slicedToArray(_containerSize3, 2),
	          width = _containerSize4[0],
	          height = _containerSize4[1];
	
	      if (width !== state.lastWidth || height !== state.lastHeight) {
	        this.props.onResize(width, height);
	      }
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var state = this.state;
	
	
	      var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
	        width: state.expandChildWidth,
	        height: state.expandChildHeight
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
	            _this2.container = e;
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.expand = e;
	            } },
	          _react2.default.createElement('div', { style: expandStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.shrink = e;
	            } },
	          _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })
	        )
	      );
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.Component);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ },
/* 1245 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var parentStyle = exports.parentStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  right: 0,
	  bottom: 0,
	  overflow: 'scroll',
	  zIndex: -1,
	  visibility: 'hidden'
	};
	
	var shrinkChildStyle = exports.shrinkChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '200%',
	  height: '200%'
	};
	
	var expandChildStyle = exports.expandChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(1244);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(592);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _routerWarning = __webpack_require__(117);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(594);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _routerWarning = __webpack_require__(117);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _InternalPropTypes = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _InternalPropTypes = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(8);
	
	var _createTransitionManager2 = __webpack_require__(598);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(133);
	
	var _RouterContext = __webpack_require__(283);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _RouterUtils = __webpack_require__(595);
	
	var _routerWarning = __webpack_require__(117);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(280);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(283);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(117);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(996);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(597);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(116);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(280);
	
	var _PromiseUtils = __webpack_require__(593);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(116);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(997);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(597);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(116);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(159);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(596);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(598);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(73);
	
	var _RouterUtils = __webpack_require__(595);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(280);
	
	var _PromiseUtils = __webpack_require__(593);
	
	var _PatternUtils = __webpack_require__(116);
	
	var _routerWarning = __webpack_require__(117);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(1263);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(281);
	
	var _PropTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(271);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1266).enable();
	  window.Promise = __webpack_require__(1265);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1267);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(17);


/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(600);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(600);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1267 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownContent = function (_Component) {
	  _inherits(DropdownContent, _Component);
	
	  function DropdownContent() {
	    _classCallCheck(this, DropdownContent);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(DropdownContent).apply(this, arguments));
	  }
	
	  _createClass(DropdownContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	
	      var dropdownContentProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      dropdownContentProps.className = 'dropdown__content ' + className;
	
	      return _react2.default.createElement(
	        'div',
	        dropdownContentProps,
	        children
	      );
	    }
	  }]);
	
	  return DropdownContent;
	}(_react.Component);
	
	DropdownContent.displayName = 'DropdownContent';
	
	DropdownContent.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	DropdownContent.defaultProps = {
	  className: ''
	};
	
	exports.default = DropdownContent;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownTrigger = function (_Component) {
	  _inherits(DropdownTrigger, _Component);
	
	  function DropdownTrigger() {
	    _classCallCheck(this, DropdownTrigger);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(DropdownTrigger).apply(this, arguments));
	  }
	
	  _createClass(DropdownTrigger, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	
	      var dropdownTriggerProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      dropdownTriggerProps.className = 'dropdown__trigger ' + className;
	
	      return _react2.default.createElement(
	        'a',
	        dropdownTriggerProps,
	        children
	      );
	    }
	  }]);
	
	  return DropdownTrigger;
	}(_react.Component);
	
	DropdownTrigger.displayName = 'DropdownTrigger';
	
	DropdownTrigger.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	DropdownTrigger.defaultProps = {
	  className: ''
	};
	
	exports.default = DropdownTrigger;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(1496);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateGroupChild = __webpack_require__(1271);
	
	var _AnimateGroupChild2 = _interopRequireDefault(_AnimateGroupChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroup = (_temp = _class = function (_Component) {
	  _inherits(AnimateGroup, _Component);
	
	  function AnimateGroup() {
	    _classCallCheck(this, AnimateGroup);
	
	    return _possibleConstructorReturn(this, (AnimateGroup.__proto__ || Object.getPrototypeOf(AnimateGroup)).apply(this, arguments));
	  }
	
	  _createClass(AnimateGroup, [{
	    key: 'wrapChild',
	    value: function wrapChild(child) {
	      var _props = this.props,
	          appear = _props.appear,
	          leave = _props.leave,
	          enter = _props.enter;
	
	
	      return _react2.default.createElement(
	        _AnimateGroupChild2.default,
	        {
	          appear: appear,
	          leave: leave,
	          enter: enter
	        },
	        child
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          children = _props2.children;
	
	
	      return _react2.default.createElement(
	        _reactTransitionGroup.TransitionGroup,
	        {
	          component: component,
	          childFactory: this.wrapChild.bind(this)
	        },
	        children
	      );
	    }
	  }]);
	
	  return AnimateGroup;
	}(_react.Component), _class.propTypes = {
	  appear: _propTypes2.default.object,
	  leave: _propTypes2.default.object,
	  enter: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
	  component: _propTypes2.default.any
	}, _class.defaultProps = {
	  component: 'span'
	}, _temp);
	exports.default = AnimateGroup;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Animate = __webpack_require__(601);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroupChild = (_temp2 = _class = function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimateGroupChild.__proto__ || Object.getPrototypeOf(AnimateGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isActive: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: 'handleStyleActive',
	    value: function handleStyleActive(style, done) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	          done();
	        } : done;
	
	        this.setState(_extends({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      this.handleStyleActive(this.props.appear, done);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      this.handleStyleActive(this.props.enter, done);
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      this.handleStyleActive(this.props.leave, done);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Animate2.default,
	        this.state,
	        _react.Children.only(this.props.children)
	      );
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component), _class.propTypes = {
	  appear: _propTypes2.default.object,
	  leave: _propTypes2.default.object,
	  enter: _propTypes2.default.object,
	  children: _propTypes2.default.element
	}, _temp2);
	exports.default = AnimateGroupChild;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = createAnimateManager;
	
	var _setRafTimeout = __webpack_require__(1275);
	
	var _setRafTimeout2 = _interopRequireDefault(_setRafTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function createAnimateManager() {
	  var currStyle = {};
	  var handleChange = function handleChange() {
	    return null;
	  };
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles), curr);
	
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if ((typeof _style === 'undefined' ? 'undefined' : _typeof(_style)) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = undefined;
	
	var _isPlainObject2 = __webpack_require__(1370);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isEqual2 = __webpack_require__(620);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isArray2 = __webpack_require__(53);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    var keyA = keysA[i];
	
	    if (objA[keyA] === objB[keyA]) {
	      continue;
	    }
	
	    // special diff with Array or Object
	    if ((0, _isArray3.default)(objA[keyA])) {
	      if (!(0, _isArray3.default)(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
	        return false;
	      } else if (!(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if ((0, _isPlainObject3.default)(objA[keyA])) {
	      if (!(0, _isPlainObject3.default)(objB[keyA]) || !(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	function shouldComponentUpdate(nextProps, nextState) {
	  return shallowCompare(this, nextProps, nextState);
	}
	/* eslint-disable no-param-reassign */
	function pureRenderDecorator(component) {
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filter2 = __webpack_require__(1365);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _raf = __webpack_require__(536);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _util = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _extends({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _extends({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	};
	
	// configure update function
	
	exports.default = function (from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime = void 0;
	  var beginTime = void 0;
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter3.default)(stepperStyle, needContinue).length;
	  };
	
	  // stepper timing function like spring
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	
	    stepperStyle = calStepperVals(easing, stepperStyle, steps);
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, getCurrStyle(stepperStyle)));
	
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf2.default)(update);
	    }
	  };
	
	  // t => val timing function like cubic-bezier
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(undefined, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle);
	
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf2.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(undefined, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	
	      render(_extends({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate;
	
	  // return start animation method
	  return function () {
	    (0, _raf2.default)(update);
	
	    // return stop animation method
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = __webpack_require__(536);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf2.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf2.default)(shouldUpdate);
	}

/***/ },
/* 1276 */
[1676, 88, 60],
/* 1277 */
[1677, 1328, 1329, 1330, 1331, 1332],
/* 1278 */
[1681, 88, 60],
/* 1279 */
[1682, 88, 60],
/* 1280 */
[1686, 60],
/* 1281 */
[1687, 88, 60],
/* 1282 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1295);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 1284 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 1285 */
[1688, 1311, 618, 53, 619, 612, 622],
/* 1286 */
625,
/* 1287 */
578,
/* 1288 */
[1690, 1292, 1315],
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1288);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 1290 */
1161,
/* 1291 */
[1691, 1316],
/* 1292 */
[1692, 1291, 294],
/* 1293 */
[1694, 1286, 53],
/* 1294 */
1165,
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1290),
	    baseIsNaN = __webpack_require__(1300),
	    strictIndexOf = __webpack_require__(1362);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(603),
	    arrayIncludes = __webpack_require__(1283),
	    arrayIncludesWith = __webpack_require__(1284),
	    arrayMap = __webpack_require__(286),
	    baseUnary = __webpack_require__(607),
	    cacheHas = __webpack_require__(608);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 1297 */
[1696, 118, 89],
/* 1298 */
[1698, 604, 610, 1318, 1319, 1325, 53, 619, 622],
/* 1299 */
[1699, 604, 287],
/* 1300 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1301 */
[1700, 621, 1334, 292, 616],
/* 1302 */
[1701, 118, 291, 89],
/* 1303 */
[1702, 1305, 1306, 289, 53, 1372],
/* 1304 */
[1703, 1335, 1348],
/* 1305 */
[1704, 1299, 1321, 614],
/* 1306 */
[1705, 287, 1366, 1367, 288, 613, 614, 185],
/* 1307 */
1174,
/* 1308 */
[1706, 606],
/* 1309 */
[1768, 289, 1351, 1355],
/* 1310 */
[1769, 1364, 1317, 289],
/* 1311 */
1177,
/* 1312 */
[1707, 181, 286, 53, 293],
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(1369);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 1314 */
[1710, 60],
/* 1315 */
[1711, 290],
/* 1316 */
1184,
/* 1317 */
[1770, 88],
/* 1318 */
[1714, 181, 1280, 617, 610, 1346, 1354],
/* 1319 */
[1715, 1320],
/* 1320 */
[1716, 1293, 1324, 294],
/* 1321 */
[1718, 613, 294],
/* 1322 */
[1771, 615],
/* 1323 */
[1720, 181],
/* 1324 */
[1721, 605, 1373],
/* 1325 */
[1722, 1276, 284, 1278, 1279, 1281, 118, 616],
/* 1326 */
1193,
/* 1327 */
[1723, 609, 618, 53, 612, 291, 185],
/* 1328 */
[1724, 184],
/* 1329 */
1196,
/* 1330 */
[1725, 184],
/* 1331 */
[1726, 184],
/* 1332 */
[1727, 184],
/* 1333 */
1201,
/* 1334 */
[1730, 1314],
/* 1335 */
1203,
/* 1336 */
1204,
/* 1337 */
[1732, 182],
/* 1338 */
[1733, 182],
/* 1339 */
[1734, 182],
/* 1340 */
[1735, 182],
/* 1341 */
[1736, 1277, 180, 284],
/* 1342 */
[1737, 183],
/* 1343 */
[1738, 183],
/* 1344 */
[1739, 183],
/* 1345 */
[1740, 183],
/* 1346 */
1214,
/* 1347 */
[1741, 1371],
/* 1348 */
[1743, 615],
/* 1349 */
[1744, 611],
/* 1350 */
1218,
/* 1351 */
[1772, 1282],
/* 1352 */
1220,
/* 1353 */
1221,
/* 1354 */
1222,
/* 1355 */
[1773, 1310, 1356],
/* 1356 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1357 */
[1746, 180],
/* 1358 */
1224,
/* 1359 */
1225,
/* 1360 */
1226,
/* 1361 */
[1747, 180, 284, 285],
/* 1362 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 1363 */
[1748, 1347],
/* 1364 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(605),
	    baseFilter = __webpack_require__(1289),
	    baseIteratee = __webpack_require__(1303),
	    isArray = __webpack_require__(53);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 1366 */
[1752, 606],
/* 1367 */
[1753, 1294, 1327],
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(286),
	    baseIntersection = __webpack_require__(1296),
	    baseRest = __webpack_require__(1309),
	    castArrayLikeObject = __webpack_require__(1313);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(290),
	    isObjectLike = __webpack_require__(89);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 1370 */
[1774, 118, 1322, 89],
/* 1371 */
[1762, 285],
/* 1372 */
[1763, 1307, 1308, 288, 185],
/* 1373 */
1237,
/* 1374 */
1238,
/* 1375 */
[1767, 1312],
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _find = __webpack_require__(1474);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _sortBy = __webpack_require__(1480);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Manager = function () {
	  function Manager() {
	    _classCallCheck(this, Manager);
	
	    this.refs = {};
	  }
	
	  _createClass(Manager, [{
	    key: 'add',
	    value: function add(collection, ref) {
	      if (!this.refs[collection]) {
	        this.refs[collection] = [];
	      }
	
	      this.refs[collection].push(ref);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(collection, ref) {
	      var index = this.getIndex(collection, ref);
	
	      if (index !== -1) {
	        this.refs[collection].splice(index, 1);
	      }
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive() {
	      return this.active;
	    }
	  }, {
	    key: 'getActive',
	    value: function getActive() {
	      var _this = this;
	
	      return (0, _find2.default)(this.refs[this.active.collection],
	      // eslint-disable-next-line eqeqeq
	      function (_ref) {
	        var node = _ref.node;
	        return node.sortableInfo.index == _this.active.index;
	      });
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(collection, ref) {
	      return this.refs[collection].indexOf(ref);
	    }
	  }, {
	    key: 'getOrderedRefs',
	    value: function getOrderedRefs() {
	      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
	
	      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
	        var node = _ref2.node;
	        return node.sortableInfo.index;
	      });
	    }
	  }]);
	
	  return Manager;
	}();
	
	exports.default = Manager;

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableContainer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Manager = __webpack_require__(1376);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _utils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Container Component
	function sortableContainer(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class(props) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	      _this.handleStart = function (e) {
	        var _this$props = _this.props,
	            distance = _this$props.distance,
	            shouldCancelStart = _this$props.shouldCancelStart;
	
	
	        if (e.button === 2 || shouldCancelStart(e)) {
	          return false;
	        }
	
	        _this._touched = true;
	        _this._pos = {
	          x: e.pageX,
	          y: e.pageY
	        };
	
	        var node = (0, _utils.closest)(e.target, function (el) {
	          return el.sortableInfo != null;
	        });
	
	        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
	          var useDragHandle = _this.props.useDragHandle;
	          var _node$sortableInfo = node.sortableInfo,
	              index = _node$sortableInfo.index,
	              collection = _node$sortableInfo.collection;
	
	
	          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
	            return el.sortableHandle != null;
	          })) return;
	
	          _this.manager.active = { index: index, collection: collection };
	
	          /*
	          * Fixes a bug in Firefox where the :active state of anchor tags
	          * prevent subsequent 'mousemove' events from being fired
	          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
	          */
	          if (e.target.tagName.toLowerCase() === 'a') {
	            e.preventDefault();
	          }
	
	          if (!distance) {
	            if (_this.props.pressDelay === 0) {
	              _this.handlePress(e);
	            } else {
	              _this.pressTimer = setTimeout(function () {
	                return _this.handlePress(e);
	              }, _this.props.pressDelay);
	            }
	          }
	        }
	      };
	
	      _this.nodeIsChild = function (node) {
	        return node.sortableInfo.manager === _this.manager;
	      };
	
	      _this.handleMove = function (e) {
	        var _this$props2 = _this.props,
	            distance = _this$props2.distance,
	            pressThreshold = _this$props2.pressThreshold;
	
	
	        if (!_this.state.sorting && _this._touched) {
	          _this._delta = {
	            x: _this._pos.x - e.pageX,
	            y: _this._pos.y - e.pageY
	          };
	          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);
	
	          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
	            clearTimeout(_this.cancelTimer);
	            _this.cancelTimer = setTimeout(_this.cancel, 0);
	          } else if (distance && delta >= distance && _this.manager.isActive()) {
	            _this.handlePress(e);
	          }
	        }
	      };
	
	      _this.handleEnd = function () {
	        var distance = _this.props.distance;
	
	
	        _this._touched = false;
	
	        if (!distance) {
	          _this.cancel();
	        }
	      };
	
	      _this.cancel = function () {
	        if (!_this.state.sorting) {
	          clearTimeout(_this.pressTimer);
	          _this.manager.active = null;
	        }
	      };
	
	      _this.handlePress = function (e) {
	        var active = _this.manager.getActive();
	
	        if (active) {
	          var _this$props3 = _this.props,
	              axis = _this$props3.axis,
	              getHelperDimensions = _this$props3.getHelperDimensions,
	              helperClass = _this$props3.helperClass,
	              hideSortableGhost = _this$props3.hideSortableGhost,
	              onSortStart = _this$props3.onSortStart,
	              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
	          var node = active.node,
	              collection = active.collection;
	          var index = node.sortableInfo.index;
	
	          var margin = (0, _utils.getElementMargin)(node);
	
	          var containerBoundingRect = _this.container.getBoundingClientRect();
	          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });
	
	          _this.node = node;
	          _this.margin = margin;
	          _this.width = dimensions.width;
	          _this.height = dimensions.height;
	          _this.marginOffset = {
	            x: _this.margin.left + _this.margin.right,
	            y: Math.max(_this.margin.top, _this.margin.bottom)
	          };
	          _this.boundingClientRect = node.getBoundingClientRect();
	          _this.containerBoundingRect = containerBoundingRect;
	          _this.index = index;
	          _this.newIndex = index;
	
	          _this.axis = {
	            x: axis.indexOf('x') >= 0,
	            y: axis.indexOf('y') >= 0
	          };
	          _this.offsetEdge = _this.getEdgeOffset(node);
	          _this.initialOffset = _this.getOffset(e);
	          _this.initialScroll = {
	            top: _this.scrollContainer.scrollTop,
	            left: _this.scrollContainer.scrollLeft
	          };
	
	          _this.initialWindowScroll = {
	            top: window.pageYOffset,
	            left: window.pageXOffset
	          };
	
	          var fields = node.querySelectorAll('input, textarea, select');
	          var clonedNode = node.cloneNode(true);
	          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array
	
	          clonedFields.forEach(function (field, index) {
	            if (field.type !== 'file' && fields[index]) {
	              field.value = fields[index].value;
	            }
	          });
	
	          _this.helper = _this.document.body.appendChild(clonedNode);
	
	          _this.helper.style.position = 'fixed';
	          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
	          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
	          _this.helper.style.width = _this.width + 'px';
	          _this.helper.style.height = _this.height + 'px';
	          _this.helper.style.boxSizing = 'border-box';
	          _this.helper.style.pointerEvents = 'none';
	
	          if (hideSortableGhost) {
	            _this.sortableGhost = node;
	            node.style.visibility = 'hidden';
	            node.style.opacity = 0;
	          }
	
	          _this.minTranslate = {};
	          _this.maxTranslate = {};
	          if (_this.axis.x) {
	            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
	            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
	          }
	          if (_this.axis.y) {
	            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
	            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
	          }
	
	          if (helperClass) {
	            var _this$helper$classLis;
	
	            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
	          }
	
	          _this.listenerNode = e.touches ? node : _this.contentWindow;
	          _utils.events.move.forEach(function (eventName) {
	            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
	          });
	          _utils.events.end.forEach(function (eventName) {
	            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
	          });
	
	          _this.setState({
	            sorting: true,
	            sortingIndex: index
	          });
	
	          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
	        }
	      };
	
	      _this.handleSortMove = function (e) {
	        var onSortMove = _this.props.onSortMove;
	
	        e.preventDefault(); // Prevent scrolling on mobile
	
	        _this.updatePosition(e);
	        _this.animateNodes();
	        _this.autoscroll();
	
	        if (onSortMove) onSortMove(e);
	      };
	
	      _this.handleSortEnd = function (e) {
	        var _this$props4 = _this.props,
	            hideSortableGhost = _this$props4.hideSortableGhost,
	            onSortEnd = _this$props4.onSortEnd;
	        var collection = _this.manager.active.collection;
	
	        // Remove the event listeners if the node is still in the DOM
	
	        if (_this.listenerNode) {
	          _utils.events.move.forEach(function (eventName) {
	            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
	          });
	          _utils.events.end.forEach(function (eventName) {
	            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
	          });
	        }
	
	        // Remove the helper from the DOM
	        _this.helper.parentNode.removeChild(_this.helper);
	
	        if (hideSortableGhost && _this.sortableGhost) {
	          _this.sortableGhost.style.visibility = '';
	          _this.sortableGhost.style.opacity = '';
	        }
	
	        var nodes = _this.manager.refs[collection];
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          var node = nodes[i];
	          var el = node.node;
	
	          // Clear the cached offsetTop / offsetLeft value
	          node.edgeOffset = null;
	
	          // Remove the transforms / transitions
	          el.style[_utils.vendorPrefix + 'Transform'] = '';
	          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
	        }
	
	        // Stop autoscroll
	        clearInterval(_this.autoscrollInterval);
	        _this.autoscrollInterval = null;
	
	        // Update state
	        _this.manager.active = null;
	
	        _this.setState({
	          sorting: false,
	          sortingIndex: null
	        });
	
	        if (typeof onSortEnd === 'function') {
	          onSortEnd({
	            oldIndex: _this.index,
	            newIndex: _this.newIndex,
	            collection: collection
	          }, e);
	        }
	
	        _this._touched = false;
	      };
	
	      _this.autoscroll = function () {
	        var translate = _this.translate;
	        var direction = {
	          x: 0,
	          y: 0
	        };
	        var speed = {
	          x: 1,
	          y: 1
	        };
	        var acceleration = {
	          x: 10,
	          y: 10
	        };
	
	        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
	          direction.y = 1; // Scroll Down
	          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
	        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
	          direction.x = 1; // Scroll Right
	          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
	        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
	          direction.y = -1; // Scroll Up
	          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
	        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
	          direction.x = -1; // Scroll Left
	          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
	        }
	
	        if (_this.autoscrollInterval) {
	          clearInterval(_this.autoscrollInterval);
	          _this.autoscrollInterval = null;
	          _this.isAutoScrolling = false;
	        }
	
	        if (direction.x !== 0 || direction.y !== 0) {
	          _this.autoscrollInterval = setInterval(function () {
	            _this.isAutoScrolling = true;
	            var offset = {
	              left: 1 * speed.x * direction.x,
	              top: 1 * speed.y * direction.y
	            };
	            _this.scrollContainer.scrollTop += offset.top;
	            _this.scrollContainer.scrollLeft += offset.left;
	            _this.translate.x += offset.left;
	            _this.translate.y += offset.top;
	            _this.animateNodes();
	          }, 5);
	        }
	      };
	
	      _this.manager = new _Manager2.default();
	      _this.events = {
	        start: _this.handleStart,
	        move: _this.handleMove,
	        end: _this.handleEnd
	      };
	
	      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
	
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return {
	          manager: this.manager
	        };
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        var _props = this.props,
	            getContainer = _props.getContainer,
	            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;
	
	        /*
	         *  Set our own default rather than using defaultProps because Jest
	         *  snapshots will serialize window, causing a RangeError
	         *  https://github.com/clauderic/react-sortable-hoc/issues/249
	         */
	
	        var contentWindow = this.props.contentWindow || window;
	
	        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
	        this.document = this.container.ownerDocument || document;
	        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
	        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
	
	        var _loop = function _loop(key) {
	          if (_this2.events.hasOwnProperty(key)) {
	            _utils.events[key].forEach(function (eventName) {
	              return _this2.container.addEventListener(eventName, _this2.events[key], false);
	            });
	          }
	        };
	
	        for (var key in this.events) {
	          _loop(key);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _this3 = this;
	
	        var _loop2 = function _loop2(key) {
	          if (_this3.events.hasOwnProperty(key)) {
	            _utils.events[key].forEach(function (eventName) {
	              return _this3.container.removeEventListener(eventName, _this3.events[key]);
	            });
	          }
	        };
	
	        for (var key in this.events) {
	          _loop2(key);
	        }
	      }
	    }, {
	      key: 'getEdgeOffset',
	      value: function getEdgeOffset(node) {
	        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };
	
	        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
	        if (node) {
	          var nodeOffset = {
	            top: offset.top + node.offsetTop,
	            left: offset.left + node.offsetLeft
	          };
	          if (node.parentNode !== this.container) {
	            return this.getEdgeOffset(node.parentNode, nodeOffset);
	          } else {
	            return nodeOffset;
	          }
	        }
	      }
	    }, {
	      key: 'getOffset',
	      value: function getOffset(e) {
	        return {
	          x: e.touches ? e.touches[0].pageX : e.pageX,
	          y: e.touches ? e.touches[0].pageY : e.pageY
	        };
	      }
	    }, {
	      key: 'getLockPixelOffsets',
	      value: function getLockPixelOffsets() {
	        var lockOffset = this.props.lockOffset;
	
	
	        if (!Array.isArray(lockOffset)) {
	          lockOffset = [lockOffset, lockOffset];
	        }
	
	        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);
	
	        var _lockOffset = lockOffset,
	            _lockOffset2 = _slicedToArray(_lockOffset, 2),
	            minLockOffset = _lockOffset2[0],
	            maxLockOffset = _lockOffset2[1];
	
	        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
	      }
	    }, {
	      key: 'getLockPixelOffset',
	      value: function getLockPixelOffset(lockOffset) {
	        var offsetX = lockOffset;
	        var offsetY = lockOffset;
	        var unit = 'px';
	
	        if (typeof lockOffset === 'string') {
	          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
	
	          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
	
	          offsetX = offsetY = parseFloat(lockOffset);
	          unit = match[1];
	        }
	
	        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
	
	        if (unit === '%') {
	          offsetX = offsetX * this.width / 100;
	          offsetY = offsetY * this.height / 100;
	        }
	
	        return {
	          x: offsetX,
	          y: offsetY
	        };
	      }
	    }, {
	      key: 'updatePosition',
	      value: function updatePosition(e) {
	        var _props2 = this.props,
	            lockAxis = _props2.lockAxis,
	            lockToContainerEdges = _props2.lockToContainerEdges;
	
	
	        var offset = this.getOffset(e);
	        var translate = {
	          x: offset.x - this.initialOffset.x,
	          y: offset.y - this.initialOffset.y
	        };
	        // Adjust for window scroll
	        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
	        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
	
	        this.translate = translate;
	
	        if (lockToContainerEdges) {
	          var _getLockPixelOffsets = this.getLockPixelOffsets(),
	              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
	              minLockOffset = _getLockPixelOffsets2[0],
	              maxLockOffset = _getLockPixelOffsets2[1];
	
	          var minOffset = {
	            x: this.width / 2 - minLockOffset.x,
	            y: this.height / 2 - minLockOffset.y
	          };
	          var maxOffset = {
	            x: this.width / 2 - maxLockOffset.x,
	            y: this.height / 2 - maxLockOffset.y
	          };
	
	          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
	          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
	        }
	
	        if (lockAxis === 'x') {
	          translate.y = 0;
	        } else if (lockAxis === 'y') {
	          translate.x = 0;
	        }
	
	        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
	      }
	    }, {
	      key: 'animateNodes',
	      value: function animateNodes() {
	        var _props3 = this.props,
	            transitionDuration = _props3.transitionDuration,
	            hideSortableGhost = _props3.hideSortableGhost;
	
	        var nodes = this.manager.getOrderedRefs();
	        var deltaScroll = {
	          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
	          top: this.scrollContainer.scrollTop - this.initialScroll.top
	        };
	        var sortingOffset = {
	          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
	          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
	        };
	        var scrollDifference = {
	          top: window.pageYOffset - this.initialWindowScroll.top,
	          left: window.pageXOffset - this.initialWindowScroll.left
	        };
	        this.newIndex = null;
	
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          var node = nodes[i].node;
	
	          var index = node.sortableInfo.index;
	          var width = node.offsetWidth;
	          var height = node.offsetHeight;
	          var offset = {
	            width: this.width > width ? width / 2 : this.width / 2,
	            height: this.height > height ? height / 2 : this.height / 2
	          };
	
	          var translate = {
	            x: 0,
	            y: 0
	          };
	          var edgeOffset = nodes[i].edgeOffset;
	
	          // If we haven't cached the node's offsetTop / offsetLeft value
	
	          if (!edgeOffset) {
	            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
	          }
	
	          // Get a reference to the next and previous node
	          var nextNode = i < nodes.length - 1 && nodes[i + 1];
	          var prevNode = i > 0 && nodes[i - 1];
	
	          // Also cache the next node's edge offset if needed.
	          // We need this for calculating the animation in a grid setup
	          if (nextNode && !nextNode.edgeOffset) {
	            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
	          }
	
	          // If the node is the one we're currently animating, skip it
	          if (index === this.index) {
	            if (hideSortableGhost) {
	              /*
	              * With windowing libraries such as `react-virtualized`, the sortableGhost
	              * node may change while scrolling down and then back up (or vice-versa),
	              * so we need to update the reference to the new node just to be safe.
	              */
	              this.sortableGhost = node;
	              node.style.visibility = 'hidden';
	              node.style.opacity = 0;
	            }
	            continue;
	          }
	
	          if (transitionDuration) {
	            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
	          }
	
	          if (this.axis.x) {
	            if (this.axis.y) {
	              // Calculations for a grid setup
	              if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
	                // If the current node is to the left on the same row, or above the node that's being dragged
	                // then move it to the right
	                translate.x = this.width + this.marginOffset.x;
	                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
	                  // If it moves passed the right bounds, then animate it to the first position of the next row.
	                  // We just use the offset of the next node to calculate where to move, because that node's original position
	                  // is exactly where we want to go
	                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
	                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
	                }
	                if (this.newIndex === null) {
	                  this.newIndex = index;
	                }
	              } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
	                // If the current node is to the right on the same row, or below the node that's being dragged
	                // then move it to the left
	                translate.x = -(this.width + this.marginOffset.x);
	                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
	                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
	                  // We just use the offset of the previous node to calculate where to move, because that node's original position
	                  // is exactly where we want to go
	                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
	                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
	                }
	                this.newIndex = index;
	              }
	            } else {
	              if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
	                translate.x = -(this.width + this.marginOffset.x);
	                this.newIndex = index;
	              } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
	                translate.x = this.width + this.marginOffset.x;
	                if (this.newIndex == null) {
	                  this.newIndex = index;
	                }
	              }
	            }
	          } else if (this.axis.y) {
	            if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
	              translate.y = -(this.height + this.marginOffset.y);
	              this.newIndex = index;
	            } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
	              translate.y = this.height + this.marginOffset.y;
	              if (this.newIndex == null) {
	                this.newIndex = index;
	              }
	            }
	          }
	          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
	        }
	
	        if (this.newIndex == null) {
	          this.newIndex = this.index;
	        }
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({
	          ref: ref
	        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
	    axis: 'y',
	    transitionDuration: 300,
	    pressDelay: 0,
	    pressThreshold: 5,
	    distance: 0,
	    useWindowAsScrollContainer: false,
	    hideSortableGhost: true,
	    shouldCancelStart: function shouldCancelStart(e) {
	      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
	      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];
	
	      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
	        return true; // Return true to cancel sorting
	      }
	    },
	    lockToContainerEdges: false,
	    lockOffset: '50%',
	    getHelperDimensions: function getHelperDimensions(_ref) {
	      var node = _ref.node;
	      return {
	        width: node.offsetWidth,
	        height: node.offsetHeight
	      };
	    }
	  }, _class.propTypes = {
	    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
	    distance: _propTypes2.default.number,
	    lockAxis: _propTypes2.default.string,
	    helperClass: _propTypes2.default.string,
	    transitionDuration: _propTypes2.default.number,
	    contentWindow: _propTypes2.default.any,
	    onSortStart: _propTypes2.default.func,
	    onSortMove: _propTypes2.default.func,
	    onSortEnd: _propTypes2.default.func,
	    shouldCancelStart: _propTypes2.default.func,
	    pressDelay: _propTypes2.default.number,
	    useDragHandle: _propTypes2.default.bool,
	    useWindowAsScrollContainer: _propTypes2.default.bool,
	    hideSortableGhost: _propTypes2.default.bool,
	    lockToContainerEdges: _propTypes2.default.bool,
	    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
	    getContainer: _propTypes2.default.func,
	    getHelperDimensions: _propTypes2.default.func
	  }, _class.childContextTypes = {
	    manager: _propTypes2.default.object.isRequired
	  }, _temp;
	}

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableElement;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Element Component
	function sortableElement(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _props = this.props,
	            collection = _props.collection,
	            disabled = _props.disabled,
	            index = _props.index;
	
	
	        if (!disabled) {
	          this.setDraggable(collection, index);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.index !== nextProps.index && this.node) {
	          this.node.sortableInfo.index = nextProps.index;
	        }
	        if (this.props.disabled !== nextProps.disabled) {
	          var collection = nextProps.collection,
	              disabled = nextProps.disabled,
	              index = nextProps.index;
	
	          if (disabled) {
	            this.removeDraggable(collection);
	          } else {
	            this.setDraggable(collection, index);
	          }
	        } else if (this.props.collection !== nextProps.collection) {
	          this.removeDraggable(this.props.collection);
	          this.setDraggable(nextProps.collection, nextProps.index);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _props2 = this.props,
	            collection = _props2.collection,
	            disabled = _props2.disabled;
	
	
	        if (!disabled) this.removeDraggable(collection);
	      }
	    }, {
	      key: 'setDraggable',
	      value: function setDraggable(collection, index) {
	        var node = this.node = (0, _reactDom.findDOMNode)(this);
	
	        node.sortableInfo = {
	          index: index,
	          collection: collection,
	          manager: this.context.manager
	        };
	
	        this.ref = { node: node };
	        this.context.manager.add(collection, this.ref);
	      }
	    }, {
	      key: 'removeDraggable',
	      value: function removeDraggable(collection) {
	        this.context.manager.remove(collection, this.ref);
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({
	          ref: ref
	        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
	    manager: _propTypes2.default.object.isRequired
	  }, _class.propTypes = {
	    index: _propTypes2.default.number.isRequired,
	    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    disabled: _propTypes2.default.bool
	  }, _class.defaultProps = {
	    collection: 0
	  }, _temp;
	}

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableHandle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Element Component
	function sortableHandle(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var node = (0, _reactDom.findDOMNode)(this);
	        node.sortableHandle = true;
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
	}

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;
	
	var _utils = __webpack_require__(186);
	
	Object.defineProperty(exports, 'arrayMove', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayMove;
	  }
	});
	
	var _SortableContainer2 = __webpack_require__(1377);
	
	var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);
	
	var _SortableElement2 = __webpack_require__(1378);
	
	var _SortableElement3 = _interopRequireDefault(_SortableElement2);
	
	var _SortableHandle2 = __webpack_require__(1379);
	
	var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SortableContainer = _SortableContainer3.default;
	exports.SortableElement = _SortableElement3.default;
	exports.SortableHandle = _SortableHandle3.default;
	exports.sortableContainer = _SortableContainer3.default;
	exports.sortableElement = _SortableElement3.default;
	exports.sortableHandle = _SortableHandle3.default;

/***/ },
/* 1381 */
[1676, 90, 61],
/* 1382 */
[1677, 1434, 1435, 1436, 1437, 1438],
/* 1383 */
[1681, 90, 61],
/* 1384 */
[1682, 90, 61],
/* 1385 */
[1683, 296, 1461, 1462],
/* 1386 */
[1686, 61],
/* 1387 */
[1687, 90, 61],
/* 1388 */
1282,
/* 1389 */
605,
/* 1390 */
[1688, 1414, 302, 54, 634, 299, 636],
/* 1391 */
578,
/* 1392 */
[1690, 1396, 1421],
/* 1393 */
1161,
/* 1394 */
[1775, 625, 1439],
/* 1395 */
[1691, 1422],
/* 1396 */
[1692, 1395, 193],
/* 1397 */
[1694, 625, 54],
/* 1398 */
1165,
/* 1399 */
[1696, 135, 138],
/* 1400 */
[1698, 623, 629, 1425, 1426, 1431, 54, 634, 636],
/* 1401 */
[1699, 623, 626],
/* 1402 */
[1700, 635, 1442, 137, 633],
/* 1403 */
[1701, 135, 303, 138],
/* 1404 */
[1703, 1443, 1456],
/* 1405 */
[1776, 1392, 136],
/* 1406 */
[1704, 1401, 1428, 632],
/* 1407 */
[1705, 626, 1476, 1477, 300, 631, 632, 191],
/* 1408 */
[1777, 624, 297, 298, 1405, 1413, 627, 1419, 192, 54],
/* 1409 */
1174,
/* 1410 */
[1706, 297],
/* 1411 */
[1768, 192, 1460, 1464],
/* 1412 */
[1769, 1473, 1424, 192],
/* 1413 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 1414 */
1177,
/* 1415 */
[1707, 134, 624, 54, 139],
/* 1416 */
[1708, 1472],
/* 1417 */
608,
/* 1418 */
[1778, 139],
/* 1419 */
[1779, 1418],
/* 1420 */
[1710, 61],
/* 1421 */
[1711, 136],
/* 1422 */
1184,
/* 1423 */
[1712, 298, 136, 193],
/* 1424 */
[1770, 90],
/* 1425 */
[1714, 134, 1386, 301, 629, 1454, 1463],
/* 1426 */
[1715, 1427],
/* 1427 */
[1716, 1397, 1430, 193],
/* 1428 */
[1718, 631, 193],
/* 1429 */
[1720, 134],
/* 1430 */
[1721, 1389, 1481],
/* 1431 */
[1722, 1381, 295, 1383, 1384, 1387, 135, 633],
/* 1432 */
1193,
/* 1433 */
[1723, 628, 302, 54, 299, 303, 191],
/* 1434 */
[1724, 190],
/* 1435 */
1196,
/* 1436 */
[1725, 190],
/* 1437 */
[1726, 190],
/* 1438 */
[1727, 190],
/* 1439 */
[1780, 134, 302, 54],
/* 1440 */
[1728, 301, 136, 299, 137],
/* 1441 */
1201,
/* 1442 */
[1730, 1420],
/* 1443 */
1203,
/* 1444 */
1204,
/* 1445 */
[1732, 188],
/* 1446 */
[1733, 188],
/* 1447 */
[1734, 188],
/* 1448 */
[1735, 188],
/* 1449 */
[1736, 1382, 187, 295],
/* 1450 */
[1737, 189],
/* 1451 */
[1738, 189],
/* 1452 */
[1739, 189],
/* 1453 */
[1740, 189],
/* 1454 */
1214,
/* 1455 */
[1741, 1478],
/* 1456 */
[1743, 1459],
/* 1457 */
[1744, 630],
/* 1458 */
1218,
/* 1459 */
615,
/* 1460 */
[1772, 1388],
/* 1461 */
1220,
/* 1462 */
1221,
/* 1463 */
1222,
/* 1464 */
[1773, 1412, 1465],
/* 1465 */
1356,
/* 1466 */
[1746, 187],
/* 1467 */
1224,
/* 1468 */
1225,
/* 1469 */
1226,
/* 1470 */
[1747, 187, 295, 296],
/* 1471 */
[1748, 1455],
/* 1472 */
1229,
/* 1473 */
1364,
/* 1474 */
[1750, 1423, 1475],
/* 1475 */
[1751, 1393, 298, 1484],
/* 1476 */
[1752, 297],
/* 1477 */
[1753, 1398, 1433],
/* 1478 */
[1762, 296],
/* 1479 */
[1763, 1409, 1410, 300, 191],
/* 1480 */
[1781, 1394, 1408, 1411, 1440],
/* 1481 */
1237,
/* 1482 */
1238,
/* 1483 */
[1764, 1485],
/* 1484 */
[1765, 1483],
/* 1485 */
[1766, 1416, 137, 139],
/* 1486 */
[1767, 1415],
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'TabPanel',
	
	  propTypes: {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string]),
	    className: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    selected: _propTypes2.default.bool,
	    style: _propTypes2.default.object,
	    tabId: _propTypes2.default.string
	  },
	
	  contextTypes: {
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selected: false,
	      id: null,
	      tabId: null
	    };
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        selected = _props.selected,
	        id = _props.id,
	        tabId = _props.tabId,
	        style = _props.style,
	        attributes = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'id', 'tabId', 'style']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__TabPanel', className, {
	          'ReactTabs__TabPanel--selected': selected
	        }),
	        role: 'tabpanel',
	        id: id,
	        'aria-labelledby': tabId,
	        style: _extends({}, style, { display: selected ? null : 'none' })
	      }),
	      this.context.forceRenderTabPanel || selected ? children : null
	    );
	  }
	});

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactDom = __webpack_require__(22);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jsStylesheet = __webpack_require__(1008);
	
	var _jsStylesheet2 = _interopRequireDefault(_jsStylesheet);
	
	var _uuid = __webpack_require__(1491);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _childrenPropType = __webpack_require__(1489);
	
	var _childrenPropType2 = _interopRequireDefault(_childrenPropType);
	
	var _Tab = __webpack_require__(194);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Determine if a node from event.target is a Tab element
	function isTabNode(node) {
	  return node.nodeName === 'LI' && node.getAttribute('role') === 'tab';
	}
	
	// Determine if a tab node is disabled
	function isTabDisabled(node) {
	  return node.getAttribute('aria-disabled') === 'true';
	}
	
	var useDefaultStyles = true;
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'Tabs',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    selectedIndex: _propTypes2.default.number,
	    onSelect: _propTypes2.default.func,
	    focus: _propTypes2.default.bool,
	    children: _childrenPropType2.default,
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  childContextTypes: {
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  statics: {
	    setUseDefaultStyles: function setUseDefaultStyles(use) {
	      useDefaultStyles = use;
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selectedIndex: -1,
	      focus: false,
	      forceRenderTabPanel: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.copyPropsToState(this.props, this.state);
	  },
	  getChildContext: function getChildContext() {
	    return {
	      forceRenderTabPanel: this.props.forceRenderTabPanel
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (useDefaultStyles) {
	      (0, _jsStylesheet2.default)(__webpack_require__(1490)); // eslint-disable-line global-require
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var _this = this;
	
	    // Use a transactional update to prevent race conditions
	    // when reading the state in copyPropsToState
	    // See https://github.com/reactjs/react-tabs/issues/51
	    this.setState(function (state) {
	      return _this.copyPropsToState(newProps, state);
	    });
	  },
	  setSelected: function setSelected(index, focus) {
	    // Don't do anything if nothing has changed
	    if (index === this.state.selectedIndex) return;
	    // Check index boundary
	    if (index < 0 || index >= this.getTabsCount()) return;
	
	    // Keep reference to last index for event handler
	    var last = this.state.selectedIndex;
	
	    // Check if the change event handler cancels the tab change
	    var cancel = false;
	
	    // Call change event handler
	    if (typeof this.props.onSelect === 'function') {
	      cancel = this.props.onSelect(index, last) === false;
	    }
	
	    if (!cancel) {
	      // Update selected index
	      this.setState({ selectedIndex: index, focus: focus === true });
	    }
	  },
	  getNextTab: function getNextTab(index) {
	    var count = this.getTabsCount();
	
	    // Look for non-disabled tab from index to the last tab on the right
	    for (var i = index + 1; i < count; i++) {
	      var tab = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(tab))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from first on left to index
	    for (var _i = 0; _i < index; _i++) {
	      var _tab = this.getTab(_i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(_tab))) {
	        return _i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  },
	  getPrevTab: function getPrevTab(index) {
	    var i = index;
	
	    // Look for non-disabled tab from index to first tab on the left
	    while (i--) {
	      var tab = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(tab))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from last tab on right to index
	    i = this.getTabsCount();
	    while (i-- > index) {
	      var _tab2 = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(_tab2))) {
	        return i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  },
	  getTabsCount: function getTabsCount() {
	    return this.props.children && this.props.children[0] ? _react2.default.Children.count(this.props.children[0].props.children) : 0;
	  },
	  getPanelsCount: function getPanelsCount() {
	    return _react2.default.Children.count(this.props.children.slice(1));
	  },
	  getTabList: function getTabList() {
	    return this.refs.tablist;
	  },
	  getTab: function getTab(index) {
	    return this.refs['tabs-' + index];
	  },
	  getPanel: function getPanel(index) {
	    return this.refs['panels-' + index];
	  },
	  getChildren: function getChildren() {
	    var index = 0;
	    var count = 0;
	    var children = this.props.children;
	    var state = this.state;
	    var tabIds = this.tabIds = this.tabIds || [];
	    var panelIds = this.panelIds = this.panelIds || [];
	    var diff = this.tabIds.length - this.getTabsCount();
	
	    // Add ids if new tabs have been added
	    // Don't bother removing ids, just keep them in case they are added again
	    // This is more efficient, and keeps the uuid counter under control
	    while (diff++ < 0) {
	      tabIds.push((0, _uuid2.default)());
	      panelIds.push((0, _uuid2.default)());
	    }
	
	    // Map children to dynamically setup refs
	    return _react2.default.Children.map(children, function (child) {
	      // null happens when conditionally rendering TabPanel/Tab
	      // see https://github.com/reactjs/react-tabs/issues/37
	      if (child === null) {
	        return null;
	      }
	
	      var result = null;
	
	      // Clone TabList and Tab components to have refs
	      if (count++ === 0) {
	        // TODO try setting the uuid in the "constructor" for `Tab`/`TabPanel`
	        result = (0, _react.cloneElement)(child, {
	          ref: 'tablist',
	          children: _react2.default.Children.map(child.props.children, function (tab) {
	            // null happens when conditionally rendering TabPanel/Tab
	            // see https://github.com/reactjs/react-tabs/issues/37
	            if (tab === null) {
	              return null;
	            }
	
	            var ref = 'tabs-' + index;
	            var id = tabIds[index];
	            var panelId = panelIds[index];
	            var selected = state.selectedIndex === index;
	            var focus = selected && state.focus;
	
	            index++;
	
	            if (tab.type === _Tab2.default) {
	              return (0, _react.cloneElement)(tab, {
	                ref: ref,
	                id: id,
	                panelId: panelId,
	                selected: selected,
	                focus: focus
	              });
	            }
	
	            return tab;
	          })
	        });
	
	        // Reset index for panels
	        index = 0;
	      }
	      // Clone TabPanel components to have refs
	      else {
	          var ref = 'panels-' + index;
	          var id = panelIds[index];
	          var tabId = tabIds[index];
	          var selected = state.selectedIndex === index;
	
	          index++;
	
	          result = (0, _react.cloneElement)(child, {
	            ref: ref,
	            id: id,
	            tabId: tabId,
	            selected: selected
	          });
	        }
	
	      return result;
	    });
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    if (this.isTabFromContainer(e.target)) {
	      var index = this.state.selectedIndex;
	      var preventDefault = false;
	
	      // Select next tab to the left
	      if (e.keyCode === 37 || e.keyCode === 38) {
	        index = this.getPrevTab(index);
	        preventDefault = true;
	      }
	      // Select next tab to the right
	      /* eslint brace-style:0 */
	      else if (e.keyCode === 39 || e.keyCode === 40) {
	          index = this.getNextTab(index);
	          preventDefault = true;
	        }
	
	      // This prevents scrollbars from moving around
	      if (preventDefault) {
	        e.preventDefault();
	      }
	
	      this.setSelected(index, true);
	    }
	  },
	  handleClick: function handleClick(e) {
	    var node = e.target;
	    do {
	      // eslint-disable-line no-cond-assign
	      if (this.isTabFromContainer(node)) {
	        if (isTabDisabled(node)) {
	          return;
	        }
	
	        var index = [].slice.call(node.parentNode.children).indexOf(node);
	        this.setSelected(index);
	        return;
	      }
	    } while ((node = node.parentNode) !== null);
	  },
	
	
	  // This is an anti-pattern, so sue me
	  copyPropsToState: function copyPropsToState(props, state) {
	    var selectedIndex = props.selectedIndex;
	
	    // If no selectedIndex prop was supplied, then try
	    // preserving the existing selectedIndex from state.
	    // If the state has not selectedIndex, default
	    // to the first tab in the TabList.
	    //
	    // TODO: Need automation testing around this
	    // Manual testing can be done using examples/focus
	    // See 'should preserve selectedIndex when typing' in specs/Tabs.spec.js
	    if (selectedIndex === -1) {
	      if (state && state.selectedIndex) {
	        selectedIndex = state.selectedIndex;
	      } else {
	        selectedIndex = 0;
	      }
	    }
	
	    return {
	      selectedIndex: selectedIndex,
	      focus: props.focus
	    };
	  },
	
	
	  /**
	   * Determine if a node from event.target is a Tab element for the current Tabs container.
	   * If the clicked element is not a Tab, it returns false.
	   * If it finds another Tabs container between the Tab and `this`, it returns false.
	   */
	  isTabFromContainer: function isTabFromContainer(node) {
	    // return immediately if the clicked element is not a Tab.
	    if (!isTabNode(node)) {
	      return false;
	    }
	
	    // Check if the first occurrence of a Tabs container is `this` one.
	    var nodeAncestor = node.parentElement;
	    var tabsNode = (0, _reactDom.findDOMNode)(this);
	    do {
	      if (nodeAncestor === tabsNode) return true;else if (nodeAncestor.getAttribute('data-tabs')) break;
	
	      nodeAncestor = nodeAncestor.parentElement;
	    } while (nodeAncestor);
	
	    return false;
	  },
	  render: function render() {
	    var _this2 = this;
	
	    // This fixes an issue with focus management.
	    //
	    // Ultimately, when focus is true, and an input has focus,
	    // and any change on that input causes a state change/re-render,
	    // focus gets sent back to the active tab, and input loses focus.
	    //
	    // Since the focus state only needs to be remembered
	    // for the current render, we can reset it once the
	    // render has happened.
	    //
	    // Don't use setState, because we don't want to re-render.
	    //
	    // See https://github.com/reactjs/react-tabs/pull/7
	    if (this.state.focus) {
	      setTimeout(function () {
	        _this2.state.focus = false;
	      }, 0);
	    }
	
	    var _props = this.props,
	        className = _props.className,
	        attributes = _objectWithoutProperties(_props, ['className']);
	
	    // Delete all known props, so they don't get added to DOM
	
	
	    delete attributes.selectedIndex;
	    delete attributes.onSelect;
	    delete attributes.focus;
	    delete attributes.children;
	    delete attributes.forceRenderTabPanel;
	    delete attributes.onClick;
	    delete attributes.onKeyDown;
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs', 'react-tabs', className),
	        onClick: this.handleClick,
	        onKeyDown: this.handleKeyDown,
	        'data-tabs': true
	      }),
	      this.getChildren()
	    );
	  }
	});

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tab = __webpack_require__(194);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabList = __webpack_require__(637);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function childrenPropTypes(props, propName) {
	  var error = void 0;
	  var tabsCount = 0;
	  var panelsCount = 0;
	  var children = props[propName];
	
	  _react2.default.Children.forEach(children, function (child) {
	    // null happens when conditionally rendering TabPanel/Tab
	    // see https://github.com/reactjs/react-tabs/issues/37
	    if (child === null) {
	      return;
	    }
	
	    if (child.type === _TabList2.default) {
	      _react2.default.Children.forEach(child.props.children, function (c) {
	        // null happens when conditionally rendering TabPanel/Tab
	        // see https://github.com/reactjs/react-tabs/issues/37
	        if (c === null) {
	          return;
	        }
	
	        if (c.type === _Tab2.default) {
	          tabsCount++;
	        }
	      });
	    } else if (child.type.displayName === 'TabPanel') {
	      panelsCount++;
	    } else {
	      error = new Error('Expected \'TabList\' or \'TabPanel\' but found \'' + (child.type.displayName || child.type) + '\'');
	    }
	  });
	
	  if (tabsCount !== panelsCount) {
	    error = new Error("There should be an equal number of 'Tabs' and 'TabPanels'." + ('Received ' + tabsCount + ' \'Tabs\' and ' + panelsCount + ' \'TabPanels\'.'));
	  }
	
	  return error;
	};

/***/ },
/* 1490 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  '.react-tabs [role=tablist]': {
	    'border-bottom': '1px solid #aaa',
	    margin: '0 0 10px',
	    padding: '0'
	  },
	
	  '.react-tabs [role=tab]': {
	    display: 'inline-block',
	    border: '1px solid transparent',
	    'border-bottom': 'none',
	    bottom: '-1px',
	    position: 'relative',
	    'list-style': 'none',
	    padding: '6px 12px',
	    cursor: 'pointer'
	  },
	
	  '.react-tabs [role=tab][aria-selected=true]': {
	    background: '#fff',
	    'border-color': '#aaa',
	    color: 'black',
	    'border-radius': '5px 5px 0 0',
	    '-moz-border-radius': '5px 5px 0 0',
	    '-webkit-border-radius': '5px 5px 0 0'
	  },
	
	  '.react-tabs [role=tab][aria-disabled=true]': {
	    color: 'GrayText',
	    cursor: 'default'
	  },
	
	  '.react-tabs [role=tab]:focus': {
	    'box-shadow': '0 0 5px hsl(208, 99%, 50%)',
	    'border-color': 'hsl(208, 99%, 50%)',
	    outline: 'none'
	  },
	
	  '.react-tabs [role=tab]:focus:after': {
	    content: '""',
	    position: 'absolute',
	    height: '5px',
	    left: '-4px',
	    right: '-4px',
	    bottom: '-5px',
	    background: '#fff'
	  }
	};

/***/ },
/* 1491 */
/***/ function(module, exports) {

	"use strict";
	
	// Get a universally unique identifier
	var count = 0;
	module.exports = function uuid() {
	  return "react-tabs-" + count++;
	};

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ },
/* 1493 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculateNodeHeight;
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	var browser = typeof window !== 'undefined' && typeof document !== 'undefined';
	var isIE = browser ? !!document.documentElement.currentStyle : false;
	var boxSizingProp = function () {
	  if (!browser) {
	    return 'box-sizing';
	  }
	  var documentStyle = window.getComputedStyle(document.documentElement);
	  // TODO: remove prefixed - they are probably obsolete, were introduced in by df79cf502630744d40233b64cad01770e5584610 in 2014
	  return documentStyle.getPropertyValue('box-sizing') ? 'box-sizing' : documentStyle.getPropertyValue('-moz-box-sizing') ? '-moz-box-sizing' : documentStyle.getPropertyValue('-webkit-box-sizing') ? '-webkit-box-sizing' : 'box-sizing';
	}();
	
	var HIDDEN_TEXTAREA_STYLE = {
	  'min-height': '0',
	  'max-height': 'none',
	  'height': '0',
	  'visibility': 'hidden',
	  'overflow': 'hidden',
	  'position': 'absolute',
	  'z-index': '-1000',
	  'top': '0',
	  'right': '0'
	};
	
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', boxSizingProp];
	
	var computedStyleCache = {};
	var hiddenTextarea = void 0;
	
	function calculateNodeHeight(uiTextNode) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  } else if (hiddenTextarea.parentNode === null) {
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      sizingStyle = _calculateNodeStyling.sizingStyle;
	
	  // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	
	  Object.keys(sizingStyle).map(function (key) {
	    hiddenTextarea.style[key] = sizingStyle[key];
	  });
	  Object.keys(HIDDEN_TEXTAREA_STYLE).map(function (key) {
	    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
	  });
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
	
	  var minHeight = -Infinity;
	  var maxHeight = Infinity;
	  var height = hiddenTextarea.scrollHeight;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height = height - paddingSize;
	  }
	
	  if (minRows !== null || maxRows !== null) {
	    // measure height of a textarea with a single row
	    hiddenTextarea.value = 'x';
	    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	      height = Math.max(minHeight, height);
	    }
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	      height = Math.min(maxHeight, height);
	    }
	  }
	  return { height: height, minHeight: minHeight, maxHeight: maxHeight };
	}
	
	function calculateNodeStyling(node) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  // TODO: generate id in constructor + clear cache in componentWillUnmount
	  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	
	  if (useCache && computedStyleCache[nodeRef]) {
	    return computedStyleCache[nodeRef];
	  }
	
	  var style = window.getComputedStyle(node);
	
	  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
	    obj[name] = style.getPropertyValue(name);
	    return obj;
	  }, {});
	
	  var boxSizing = sizingStyle[boxSizingProp];
	
	  // IE (Edge has already correct behaviour) returns content width as computed width
	  // so we need to add manually padding and border widths
	  if (isIE && boxSizing === 'border-box') {
	    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
	  }
	
	  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
	
	  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
	
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache && nodeRef) {
	    computedStyleCache[nodeRef] = nodeInfo;
	  }
	
	  return nodeInfo;
	}

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(638);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(1495);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(639);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(971);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(973);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(975);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(974);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(22);
	
	var _PropTypes = __webpack_require__(639);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransitionGroup = __webpack_require__(1494);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _TransitionGroup = __webpack_require__(638);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransitionGroup: _CSSTransitionGroup2.default
	};

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 1498 */
257,
/* 1499 */
[1675, 120],
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1499);
	var ReactElement = __webpack_require__(119);
	
	var emptyFunction = __webpack_require__(38);
	var traverseAllChildren = __webpack_require__(1508);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(120),
	    _assign = __webpack_require__(17);
	
	var ReactComponent = __webpack_require__(304);
	var ReactElement = __webpack_require__(119);
	var ReactPropTypeLocationNames = __webpack_require__(642);
	var ReactNoopUpdateQueue = __webpack_require__(305);
	
	var emptyObject = __webpack_require__(85);
	var invariant = __webpack_require__(10);
	var warning = __webpack_require__(14);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(119);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(119);
	var ReactPropTypeLocationNames = __webpack_require__(642);
	var ReactPropTypesSecret = __webpack_require__(1504);
	
	var emptyFunction = __webpack_require__(38);
	var getIteratorFn = __webpack_require__(644);
	var warning = __webpack_require__(14);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        if (props[propName] === null) {
	          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	        }
	        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 1504 */
1105,
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(17);
	
	var ReactComponent = __webpack_require__(304);
	var ReactNoopUpdateQueue = __webpack_require__(305);
	
	var emptyObject = __webpack_require__(85);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 1506 */
561,
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(120);
	
	var ReactElement = __webpack_require__(119);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(120);
	
	var ReactCurrentOwner = __webpack_require__(62);
	var REACT_ELEMENT_TYPE = __webpack_require__(641);
	
	var getIteratorFn = __webpack_require__(644);
	var invariant = __webpack_require__(10);
	var KeyEscapeUtils = __webpack_require__(1498);
	var warning = __webpack_require__(14);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @fileOverview calculate tick values of scale
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @author xile611, arcthur
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @date 2015-09-17
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
	
	var _utils = __webpack_require__(646);
	
	var _arithmetic = __webpack_require__(1510);
	
	var _arithmetic2 = _interopRequireDefault(_arithmetic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max;
	
	  // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Number}  roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Number}  The step which is easy to understand between two ticks
	 */
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep <= 0) {
	    return 0;
	  }
	
	  var digitCount = _arithmetic2.default.getDigitCount(roughStep);
	  // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	  var stepRatio = roughStep / Math.pow(10, digitCount);
	  // When an integer and a float multiplied, the accuracy of result may be wrong
	  var amendStepRatio = digitCount !== 1 ? _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.05) + correctionFactor, 0.05) : _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.1) + correctionFactor, 0.1);
	
	  var formatStep = _arithmetic2.default.multiply(amendStepRatio, Math.pow(10, digitCount));
	
	  return allowDecimals ? formatStep : Math.ceil(formatStep);
	}
	
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var isFlt = _arithmetic2.default.isFloat(value);
	  var step = 1;
	  // calculate the middle value of ticks
	  var middle = value;
	
	  if (isFlt && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = Math.pow(10, _arithmetic2.default.getDigitCount(value) - 1);
	
	      middle = _arithmetic2.default.multiply(Math.floor(value / step), step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = Math.floor(value);
	    }
	  } else if (value === 0) {
	    middle = Math.floor((tickCount - 1) / 2);
	  } else if (!allowDecimals) {
	    middle = Math.floor(value);
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(n - middleIndex, step));
	  }), _utils.range);
	
	  return fn(0, tickCount);
	}
	
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // The step which is easy to understand between two ticks
	  var step = getFormatStep((max - min) / (tickCount - 1), allowDecimals, correctionFactor);
	  // A medial value of ticks
	  var middle = void 0;
	
	  // When 0 is inside the interval, 0 should be a tick
	  if (min <= 0 && max >= 0) {
	    middle = 0;
	  } else {
	    middle = _arithmetic2.default.divide(_arithmetic2.default.sum(min, max), 2);
	    middle = _arithmetic2.default.minus(middle, _arithmetic2.default.modulo(middle, step));
	  }
	
	  var belowCount = Math.ceil((middle - min) / step);
	  var upCount = Math.ceil((max - middle) / step);
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  } else if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: _arithmetic2.default.minus(middle, _arithmetic2.default.multiply(belowCount, step)),
	    tickMax: _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(upCount, step))
	  };
	}
	/**
	 * Calculate the ticks of an interval
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  // Get the step between two ticks
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic2.default.rangeStep(tickMin, tickMax + 0.1 * step, step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return cormin + n * step;
	  }), _utils.range);
	
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	  var values = [].concat(_toConsumableArray(_arithmetic2.default.rangeStep(cormin, cormax - 0.99 * step, step)), [cormax]);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = exports.getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	var getTickValues = exports.getTickValues = (0, _utils.memoize)(getTickValuesFn);
	var getTickValuesFixedDomain = exports.getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(646);
	
	/**
	 * 判断数据是否为浮点类型
	 *
	 * @param {Number} num 输入值
	 * @return {Boolean} 是否是浮点类型
	 */
	function isFloat(num) {
	  return (/^([+-]?)\d*\.\d+$/.test(num)
	  );
	}
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	function getDigitCount(value) {
	  var abs = Math.abs(value);
	  var result = void 0;
	
	  if (value === 0) {
	    result = 1;
	  } else if (abs < 1) {
	    result = Math.floor(Math.log(abs) / Math.log(10)) + 1;
	  } else {
	    var str = '' + value;
	    var ary = str.split('.');
	
	    result = ary[0].length;
	  }
	
	  return result;
	}
	/**
	 * 计算数值的小数点后的位数
	 * @param  {Number} a 数值，可能为整数，也可能为浮点数
	 * @return {Integer}   位数
	 */
	function getDecimalDigitCount(a) {
	  var str = a ? '' + a : '';
	  var ary = str.split('.');
	
	  return ary.length > 1 ? ary[1].length : 0;
	}
	/**
	 * 乘法运算，解决了js运算的精度问题
	 * @param  {Number} a 被乘数
	 * @param  {Number} b 乘数
	 * @return {Number}   积
	 */
	function multiply(a, b) {
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	  var count = getDecimalDigitCount(a) + getDecimalDigitCount(b);
	
	  return intA * intB / Math.pow(10, count);
	}
	/**
	 * 加法运算，解决了js运算的精度问题
	 * @param  {Number} a 被加数
	 * @param  {Number} b 加数
	 * @return {Number}   和
	 */
	function sum(a, b) {
	  var count = Math.max(getDecimalDigitCount(a), getDecimalDigitCount(b));
	
	  count = Math.pow(10, count);
	
	  return (multiply(a, count) + multiply(b, count)) / count;
	}
	/**
	 * 减法运算，解决了js运算的精度问题
	 * @param  {Number} a 被减数
	 * @param  {Number} b 减数
	 * @return {Number}   差
	 */
	function minus(a, b) {
	  return sum(a, -b);
	}
	/**
	 * 除法运算，解决了js运算的精度问题
	 * @param  {Number} a 被除数
	 * @param  {Number} b 除数
	 * @return {Number}   结果
	 */
	function divide(a, b) {
	  var ca = getDecimalDigitCount(a);
	  var cb = getDecimalDigitCount(b);
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	
	  return intA / intB * Math.pow(10, cb - ca);
	}
	
	function modulo(a, b) {
	  var mod = Math.abs(b);
	
	  if (b <= 0) {
	    return a;
	  }
	
	  var cnt = Math.floor(a / mod);
	
	  return minus(a, multiply(mod, cnt));
	}
	
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Number} start 起点
	 * @param  {Number} end   终点，不包含该值
	 * @param  {Number} step  步长
	 * @return {Array}        若干数值
	 */
	function rangeStep(start, end, step) {
	  var num = start;
	  var result = [];
	
	  while (num < end) {
	    result.push(num);
	
	    num = sum(num, step);
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	
	exports.default = {
	  rangeStep: rangeStep,
	  isFloat: isFloat,
	  getDigitCount: getDigitCount,
	  getDecimalDigitCount: getDecimalDigitCount,
	
	  sum: sum,
	  minus: minus,
	  multiply: multiply,
	  divide: divide,
	  modulo: modulo,
	
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /**
	                                   * @fileOverview Composed Chart
	                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Line = __webpack_require__(310);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _Bar = __webpack_require__(307);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _Area = __webpack_require__(306);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _Rectangle = __webpack_require__(94);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _generateCategoricalChart = __webpack_require__(200);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _DataUtils = __webpack_require__(16);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _AreaChart = __webpack_require__(650);
	
	var _LineChart = __webpack_require__(652);
	
	var _BarChart = __webpack_require__(651);
	
	var _ComposedDataDecorator = __webpack_require__(141);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GRAPHICAL_TYPES = ['Area', 'Bar', 'Line'];
	var GRAPHICAL_MAP = { Area: _AreaChart.AreaChart, Bar: _BarChart.BarChart, Line: _LineChart.LineChart };
	
	var ComposedChart = (_dec = (0, _ComposedDataDecorator2.default)({}), (0, _PureRender2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ComposedChart, _Component);
	
	  function ComposedChart() {
	    _classCallCheck(this, ComposedChart);
	
	    return _possibleConstructorReturn(this, (ComposedChart.__proto__ || Object.getPrototypeOf(ComposedChart)).apply(this, arguments));
	  }
	
	  _createClass(ComposedChart, [{
	    key: 'filterGraphicalItems',
	    value: function filterGraphicalItems() {
	      var graphicalItems = this.props.graphicalItems;
	
	      var record = {};
	      var result = [];
	
	      for (var i = 0, len = graphicalItems.length; i < len; i++) {
	        var item = graphicalItems[i];
	        var displayName = item.type.displayName;
	
	        if (GRAPHICAL_TYPES.indexOf(displayName) >= 0) {
	          if (!(0, _isNil3.default)(record[displayName])) {
	            var index = record[displayName];
	
	            result[index].items = [].concat(_toConsumableArray(result[index].items), [item]);
	          } else {
	            record[displayName] = result.length;
	            result.push({ items: [item], type: displayName });
	          }
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderCursor',
	    value: function renderCursor(_ref) {
	      var xAxisMap = _ref.xAxisMap,
	          yAxisMap = _ref.yAxisMap,
	          offset = _ref.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
	      var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var bandSize = (0, _DataUtils.getBandSizeOfAxis)(axis);
	      var start = ticks[activeTooltipIndex].coordinate;
	      var cursorProps = _extends({
	        fill: '#f1f1f1'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        x: layout === 'horizontal' ? start : offset.left + 0.5,
	        y: layout === 'horizontal' ? offset.top + 0.5 : start,
	        width: layout === 'horizontal' ? bandSize : offset.width - 1,
	        height: layout === 'horizontal' ? offset.height - 1 : bandSize
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Rectangle2.default, cursorProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          xAxisMap = _props2.xAxisMap,
	          yAxisMap = _props2.yAxisMap,
	          offset = _props2.offset;
	
	      var filteredItems = this.filterGraphicalItems();
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-composed' },
	        this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
	        filteredItems.map(function (_ref2) {
	          var items = _ref2.items,
	              type = _ref2.type;
	
	          var Chart = GRAPHICAL_MAP[type];
	
	          return _react2.default.createElement(Chart, _extends({ key: type }, _this2.props, { graphicalItems: items, isComposed: true }));
	        })
	      );
	    }
	  }]);
	
	  return ComposedChart;
	}(_react.Component), _class2.displayName = 'ComposedChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  axisTicks: _propTypes2.default.array,
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _propTypes2.default.number,
	  dataEndIndex: _propTypes2.default.number,
	  isTooltipActive: _propTypes2.default.bool,
	  activeTooltipIndex: _propTypes2.default.number,
	  xAxisMap: _propTypes2.default.object,
	  yAxisMap: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  graphicalItems: _propTypes2.default.array,
	  stackGroups: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(ComposedChart, [_Line2.default, _Area2.default, _Bar2.default]);

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PieChart = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Pie Chart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(63);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Legend = __webpack_require__(92);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Pie = __webpack_require__(654);
	
	var _Pie2 = _interopRequireDefault(_Pie);
	
	var _Cell = __webpack_require__(140);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataUtils = __webpack_require__(16);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _PolarUtils = __webpack_require__(64);
	
	var _ComposedDataDecorator = __webpack_require__(141);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getComposedData = function getComposedData(_ref) {
	  var item = _ref.item;
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _extends({
	        payload: entry
	      }, presentationProps, entry, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _extends({}, presentationProps, cell.props);
	    });
	  }
	
	  return [];
	};
	
	var PieChart = exports.PieChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData, ChildComponent: _Pie2.default }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(PieChart, _Component);
	
	  function PieChart() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PieChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = PieChart.__proto__ || Object.getPrototypeOf(PieChart)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      activeTooltipLabel: '',
	      activeTooltipCoord: { x: 0, y: 0 },
	      activeTooltipPayload: [],
	      isTooltipActive: false
	    }, _this.handleMouseEnter = function (el) {
	      var children = _this.props.children;
	      var cx = el.cx,
	          cy = el.cy,
	          outerRadius = el.outerRadius,
	          midAngle = el.midAngle;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: true,
	          activeTooltipCoord: (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, midAngle),
	          activeTooltipPayload: [el]
	        });
	      }
	    }, _this.handleMouseLeave = function () {
	      var children = _this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: false
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PieChart, [{
	    key: 'renderLegend',
	
	    /**
	     * Draw legend
	     * @param  {Array} items             The instances of Pie
	     * @return {ReactElement}            The instance of Legend
	     */
	    value: function renderLegend(items) {
	      var _props = this.props,
	          children = _props.children,
	          allComposedData = _props.allComposedData;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	      if (!legendItem) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height,
	          margin = _props2.margin;
	
	      var legendData = legendItem.props && legendItem.props.payload || items.reduce(function (result, child, i) {
	        var nameKey = child.props.nameKey;
	
	        var data = allComposedData[i];
	
	        return result.concat(data.map(function (entry) {
	          return {
	            type: legendItem.props.iconType || child.props.legendType,
	            value: entry[nameKey],
	            color: entry.fill,
	            payload: entry
	          };
	        }));
	      }, []);
	
	      return _react2.default.cloneElement(legendItem, _extends({}, _Legend2.default.getWithHeight(legendItem, width), {
	        payload: legendData,
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin
	      }));
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          width = _props3.width,
	          height = _props3.height;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeTooltipLabel = _state.activeTooltipLabel,
	          activeTooltipCoord = _state.activeTooltipCoord,
	          activeTooltipPayload = _state.activeTooltipPayload;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: activeTooltipLabel,
	        payload: activeTooltipPayload,
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw the main part of bar chart
	     * @param  {Array} items    All the instance of Pie
	     * @return {ReactComponent} All the instance of Pie
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          margin = _props4.margin,
	          allComposedData = _props4.allComposedData,
	          onMouseEnter = _props4.onMouseEnter,
	          onMouseLeave = _props4.onMouseLeave,
	          onClick = _props4.onClick;
	
	
	      return items.map(function (child, i) {
	        var _child$props = child.props,
	            innerRadius = _child$props.innerRadius,
	            outerRadius = _child$props.outerRadius,
	            childOnMouseEnter = _child$props.onMouseEnter,
	            childOnMouseLeave = _child$props.onMouseLeave,
	            childOnClick = _child$props.onClick;
	
	        var cx = (0, _DataUtils.getPercentValue)(child.props.cx, width, width / 2);
	        var cy = (0, _DataUtils.getPercentValue)(child.props.cy, height, height / 2);
	        var maxRadius = (0, _PolarUtils.getMaxRadius)(width, height, margin);
	
	        return _react2.default.cloneElement(child, {
	          key: child.key || 'recharts-pie-' + i,
	          cx: cx,
	          cy: cy,
	          maxRadius: child.props.maxRadius || Math.sqrt(width * width + height * height) / 2,
	          innerRadius: (0, _DataUtils.getPercentValue)(innerRadius, maxRadius, 0),
	          outerRadius: (0, _DataUtils.getPercentValue)(outerRadius, maxRadius, maxRadius * 0.8),
	          composedData: allComposedData[i],
	          onMouseEnter: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
	          onMouseLeave: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
	          onClick: (0, _DataUtils.combineEventHandlers)(null, onClick, childOnClick)
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          style = _props5.style,
	          children = _props5.children,
	          className = _props5.className,
	          width = _props5.width,
	          height = _props5.height,
	          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);
	
	      var items = (0, _ReactUtils.findAllByType)(children, _Pie2.default);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderItems(items),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(items),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return PieChart;
	}(_react.Component), _class2.displayName = 'PieChart', _class2.propTypes = {
	  allComposedData: _propTypes2.default.array,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	  title: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  style: {},
	  margin: { top: 0, right: 0, bottom: 0, left: 0 }
	}, _temp2)) || _class);
	exports.default = PieChart;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(209);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar Chart
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(158);
	
	var _rechartsScale = __webpack_require__(645);
	
	var _Surface = __webpack_require__(63);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Legend = __webpack_require__(92);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Radar = __webpack_require__(658);
	
	var _Radar2 = _interopRequireDefault(_Radar);
	
	var _PolarGrid = __webpack_require__(656);
	
	var _PolarGrid2 = _interopRequireDefault(_PolarGrid);
	
	var _PolarAngleAxis = __webpack_require__(655);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(657);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DOMUtils = __webpack_require__(142);
	
	var _PolarUtils = __webpack_require__(64);
	
	var _DataUtils = __webpack_require__(16);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _AnimationDecorator = __webpack_require__(121);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadarChart = (0, _AnimationDecorator2.default)(_class = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadarChart, _Component);
	
	  function RadarChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadarChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadarChart.__proto__ || Object.getPrototypeOf(RadarChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (itemProps, e) {
	      var children = _this.props.children;
	      var points = itemProps.points;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem && points.length) {
	        var container = _this.container;
	        var containerOffset = (0, _DOMUtils.getOffset)(container);
	        var ne = (0, _DOMUtils.calculateChartCoordinate)(e, containerOffset);
	
	        _this.setState({
	          isTooltipActive: true,
	          activeTooltipLabel: itemProps.name || itemProps.dataKey,
	          activeTooltipCoord: { x: ne.chartX, y: ne.chartY },
	          activeTooltipPayload: _this.getTooltipContent(itemProps)
	        });
	      }
	    }, _this.handleMouseLeave = function () {
	      var children = _this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: false
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadarChart, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent(itemProps) {
	      var points = itemProps.points,
	          dataKey = itemProps.dataKey,
	          unit = itemProps.unit;
	
	
	      return points.map(function (entry) {
	        var name = entry.name,
	            value = entry.value,
	            payload = entry.payload;
	
	
	        return _extends({}, (0, _ReactUtils.getPresentationAttributes)(itemProps), {
	          dataKey: dataKey, unit: unit, name: name, value: value, payload: payload
	        });
	      });
	    }
	  }, {
	    key: 'getRadiusAxisCfg',
	    value: function getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius) {
	      var props = radiusAxis ? radiusAxis.props : _PolarRadiusAxis2.default.defaultProps;
	      var domain = void 0,
	          tickCount = void 0,
	          ticks = void 0;
	
	      if (radiusAxis && radiusAxis.props.ticks) {
	        ticks = radiusAxis.props.ticks;
	
	        tickCount = ticks.length;
	        domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	      } else {
	        tickCount = Math.max(radiusAxis && radiusAxis.props.tickCount || _PolarRadiusAxis2.default.defaultProps.tickCount, 2);
	        ticks = this.getTicksByItems(radiusAxis, tickCount);
	
	        domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	      }
	
	      return {
	        tickCount: tickCount,
	        ticks: ticks,
	        scale: (0, _DataUtils.parseScale)(props).domain(domain).range([innerRadius, outerRadius])
	      };
	    }
	  }, {
	    key: 'getTicksByItems',
	    value: function getTicksByItems(axisItem, tickCount) {
	      var _props = this.props,
	          data = _props.data,
	          children = _props.children;
	
	      var _ref2 = axisItem ? axisItem.props : _PolarRadiusAxis2.default.defaultProps,
	          domain = _ref2.domain,
	          allowDataOverflow = _ref2.allowDataOverflow;
	
	      var radarItems = (0, _ReactUtils.findAllByType)(children, _Radar2.default);
	      var dataKeys = radarItems.map(function (item) {
	        return item.props.dataKey;
	      });
	      var extent = data.reduce(function (prev, current) {
	        var values = dataKeys.map(function (v) {
	          return (0, _DataUtils.getValueByDataKey)(current, v, 0);
	        });
	        var currentMax = Math.max.apply(null, values);
	        var currentMin = Math.min.apply(null, values);
	
	        return [Math.min(prev[0], currentMin), Math.max(prev[1], currentMax)];
	      }, [Infinity, -Infinity]);
	      var finalDomain = (0, _DataUtils.parseSpecifiedDomain)(domain, extent, allowDataOverflow);
	
	      if (domain && (domain[0] === 'auto' || domain[1] === 'auto')) {
	        return (0, _rechartsScale.getNiceTickValues)(finalDomain, tickCount);
	      }
	
	      return finalDomain;
	    }
	  }, {
	    key: 'getGridRadius',
	    value: function getGridRadius(gridCount, innerRadius, outerRadius) {
	      var domain = (0, _range3.default)(0, gridCount);
	      var scale = (0, _d3Scale.scalePoint)().domain(domain).range([innerRadius, outerRadius]);
	
	      return domain.map(function (v) {
	        return scale(v);
	      });
	    }
	  }, {
	    key: 'getAngle',
	    value: function getAngle(index, dataLength, startAngle, clockWise) {
	      var sign = clockWise ? -1 : 1;
	      var angleInterval = 360 / dataLength;
	
	      return startAngle + index * sign * angleInterval;
	    }
	  }, {
	    key: 'getAngleTicks',
	    value: function getAngleTicks(dataLength, startAngle, clockWise) {
	      var angles = [];
	
	      for (var i = 0; i < dataLength; i++) {
	        angles.push(this.getAngle(i, dataLength, startAngle, clockWise));
	      }
	
	      return angles;
	    }
	  }, {
	    key: 'getRadiusTicks',
	    value: function getRadiusTicks(axisCfg) {
	      var ticks = axisCfg.ticks,
	          scale = axisCfg.scale;
	
	
	      if (ticks && ticks.length) {
	        return ticks.map(function (entry) {
	          return {
	            radius: scale(entry),
	            value: entry
	          };
	        });
	      }
	      var tickCount = axisCfg.tickCount;
	
	      var domain = scale.domain();
	
	      return (0, _range3.default)(0, tickCount).map(function (v, i) {
	        var value = domain[0] + i * (domain[1] - domain[0]) / (tickCount - 1);
	        return {
	          value: value,
	          radius: scale(value)
	        };
	      });
	    }
	  }, {
	    key: 'getComposedData',
	    value: function getComposedData(item, scale, cx, cy) {
	      var _this2 = this;
	
	      var dataKey = item.props.dataKey;
	      var _props2 = this.props,
	          data = _props2.data,
	          startAngle = _props2.startAngle,
	          clockWise = _props2.clockWise,
	          children = _props2.children;
	
	      var angleAxis = (0, _ReactUtils.findChildByType)(children, _PolarAngleAxis2.default);
	      var nameKey = angleAxis && angleAxis.props.dataKey;
	      var len = data.length;
	
	      return data.map(function (entry, i) {
	        var value = (0, _DataUtils.getValueByDataKey)(entry, dataKey, 0);
	        var angle = _this2.getAngle(i, len, startAngle, clockWise);
	        var radius = scale(value);
	
	        return _extends({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	          value: value,
	          name: nameKey ? entry[nameKey] || i : i,
	          cx: cx, cy: cy, radius: radius, angle: angle,
	          payload: entry
	        });
	      });
	    }
	    /**
	     * Returns default, reset state for the radar chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        activeTooltipLabel: '',
	        activeTooltipCoord: { x: 0, y: 0 },
	        isTooltipActive: false
	      };
	    }
	  }, {
	    key: 'renderRadars',
	    value: function renderRadars(items, scale, cx, cy) {
	      var _this3 = this;
	
	      if (!items || !items.length) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onClick = _props3.onClick;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return items.map(function (el, index) {
	        return _react2.default.cloneElement(el, _extends({}, baseProps, (0, _ReactUtils.getPresentationAttributes)(el), {
	          animationId: _this3.props.animationId,
	          points: _this3.getComposedData(el, scale, cx, cy),
	          key: el.key || 'radar-' + index,
	          onMouseEnter: (0, _DataUtils.combineEventHandlers)(_this3.handleMouseEnter, onMouseEnter, el.props.onMouseEnter),
	          onMouseLeave: (0, _DataUtils.combineEventHandlers)(_this3.handleMouseLeave, onMouseLeave, el.props.onMouseLeave),
	          onClick: (0, _DataUtils.combineEventHandlers)(null, onClick, el.props.onClick)
	        }));
	      });
	    }
	  }, {
	    key: 'renderGrid',
	    value: function renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius) {
	      var children = this.props.children;
	
	      var grid = (0, _ReactUtils.findChildByType)(children, _PolarGrid2.default);
	
	      if (!grid) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          startAngle = _props4.startAngle,
	          clockWise = _props4.clockWise,
	          data = _props4.data;
	
	      var len = data.length;
	      var gridCount = radiusAxisCfg.tickCount;
	
	      return _react2.default.cloneElement(grid, {
	        polarAngles: this.getAngleTicks(len, startAngle, clockWise),
	        polarRadius: this.getGridRadius(gridCount, innerRadius, outerRadius),
	        cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	        key: 'layer-grid'
	      });
	    }
	  }, {
	    key: 'renderAngleAxis',
	    value: function renderAngleAxis(cx, cy, outerRadius, maxRadius) {
	      var _this4 = this;
	
	      var children = this.props.children;
	
	      var angleAxis = (0, _ReactUtils.findChildByType)(children, _PolarAngleAxis2.default);
	
	      if (!angleAxis || angleAxis.props.hide) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          data = _props5.data,
	          startAngle = _props5.startAngle,
	          clockWise = _props5.clockWise;
	
	      var len = data.length;
	      var grid = (0, _ReactUtils.findChildByType)(children, _PolarGrid2.default);
	      var radius = (0, _DataUtils.getPercentValue)(angleAxis.props.radius, maxRadius, outerRadius);
	      var dataKey = angleAxis.props.dataKey;
	
	
	      return _react2.default.cloneElement(angleAxis, {
	        ticks: data.map(function (v, i) {
	          return {
	            value: (0, _DataUtils.getValueByDataKey)(v, dataKey, i),
	            angle: _this4.getAngle(i, len, startAngle, clockWise)
	          };
	        }),
	        cx: cx, cy: cy, radius: radius,
	        axisLineType: grid && grid.props && grid.props.gridType || _PolarGrid2.default.defaultProps.gridType,
	        key: 'layer-angle-axis'
	      });
	    }
	  }, {
	    key: 'renderRadiusAxis',
	    value: function renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy) {
	      if (!radiusAxis || radiusAxis.props.hide) {
	        return null;
	      }
	
	      var startAngle = this.props.startAngle;
	
	      return _react2.default.cloneElement(radiusAxis, {
	        angle: radiusAxis.props.angle || startAngle,
	        ticks: this.getRadiusTicks(radiusAxisCfg),
	        cx: cx, cy: cy
	      });
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeTooltipLabel = _state.activeTooltipLabel,
	          activeTooltipCoord = _state.activeTooltipCoord,
	          activeTooltipPayload = _state.activeTooltipPayload;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: activeTooltipLabel,
	        payload: activeTooltipPayload,
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw legend
	     * @param  {Array} items             The instances of item
	     * @return {ReactElement}            The instance of Legend
	     */
	
	  }, {
	    key: 'renderLegend',
	    value: function renderLegend(items) {
	      var children = this.props.children;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	      if (!legendItem) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          margin = _props7.margin;
	
	      var legendData = legendItem.props && legendItem.props.payload || items.map(function (child) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            name = _child$props.name,
	            legendType = _child$props.legendType;
	
	
	        return {
	          dataKey: dataKey,
	          type: legendItem.props.iconType || legendType || 'square',
	          color: child.props.stroke || child.props.fill,
	          value: name || dataKey,
	          payload: child.props
	        };
	      }, this);
	
	      return _react2.default.cloneElement(legendItem, _extends({}, _Legend2.default.getWithHeight(legendItem, width), {
	        payload: legendData,
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props8 = this.props,
	          className = _props8.className,
	          data = _props8.data,
	          width = _props8.width,
	          height = _props8.height,
	          margin = _props8.margin,
	          children = _props8.children,
	          style = _props8.style,
	          others = _objectWithoutProperties(_props8, ['className', 'data', 'width', 'height', 'margin', 'children', 'style']);
	
	      var cx = (0, _DataUtils.getPercentValue)(this.props.cx, width, width / 2);
	      var cy = (0, _DataUtils.getPercentValue)(this.props.cy, height, height / 2);
	      var maxRadius = (0, _PolarUtils.getMaxRadius)(width, height, margin);
	      var innerRadius = (0, _DataUtils.getPercentValue)(this.props.innerRadius, maxRadius, 0);
	      var outerRadius = (0, _DataUtils.getPercentValue)(this.props.outerRadius, maxRadius, maxRadius * 0.8);
	
	      if (outerRadius <= 0 || !data || !data.length) {
	        return null;
	      }
	
	      var items = (0, _ReactUtils.findAllByType)(children, _Radar2.default);
	      var radiusAxis = (0, _ReactUtils.findChildByType)(children, _PolarRadiusAxis2.default);
	      var radiusAxisCfg = this.getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height }),
	          ref: function ref(node) {
	            _this5.container = node;
	          }
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius),
	          this.renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy),
	          this.renderAngleAxis(cx, cy, outerRadius, maxRadius),
	          this.renderRadars(items, radiusAxisCfg.scale, cx, cy),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(items),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return RadarChart;
	}(_react.Component), _class2.displayName = 'RadarChart', _class2.propTypes = {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	
	  cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  startAngle: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  clockWise: _propTypes2.default.bool,
	
	  data: _propTypes2.default.array,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  animationId: _propTypes2.default.number,
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  width: 0,
	  height: 0,
	  cx: '50%',
	  cy: '50%',
	  innerRadius: 0,
	  outerRadius: '80%',
	
	  startAngle: 90,
	  clockWise: true,
	  data: [],
	  margin: { top: 0, right: 0, bottom: 0, left: 0 }
	}, _temp2)) || _class) || _class;
	
	exports.default = RadarChart;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(209);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar Bar Chart
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(158);
	
	var _Surface = __webpack_require__(63);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _RadialBar = __webpack_require__(659);
	
	var _RadialBar2 = _interopRequireDefault(_RadialBar);
	
	var _DataUtils = __webpack_require__(16);
	
	var _Cell = __webpack_require__(140);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _Legend = __webpack_require__(92);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _PolarUtils = __webpack_require__(64);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadialBarChart = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadialBarChart, _Component);
	
	  function RadialBarChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadialBarChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBarChart.__proto__ || Object.getPrototypeOf(RadialBarChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (el) {
	      var children = _this.props.children;
	      var cx = el.cx,
	          cy = el.cy,
	          endAngle = el.endAngle,
	          outerRadius = el.outerRadius;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: true,
	          activeTooltipCoord: (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, endAngle),
	          activeTooltipPayload: [el.payload]
	        });
	      }
	    }, _this.handleMouseLeave = function () {
	      var children = _this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: false
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadialBarChart, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	    /**
	     * Compose the data of each group
	     * @param  {Object} item        An instance of RadialBar
	     * @param  {Array}  barPosition The offset and size of each bar
	     * @param  {Object} radiusScale The scale function of radius of bars
	     * @param  {Object} center      The coordinate of center
	     * @param  {String} dataKey     The unique key of a group
	     * @return {Array}              Composed data
	     */
	
	  }, {
	    key: 'getComposedData',
	    value: function getComposedData(item, barPosition, radiusScale, center, dataKey) {
	      var data = this.props.data;
	
	      var pos = (0, _DataUtils.findPositionOfBar)(barPosition, item);
	      var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell2.default);
	
	      return data.map(function (entry, index) {
	        var value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	        var radius = radiusScale(index);
	
	        return _extends({}, entry, center, {
	          value: value,
	          innerRadius: radius - pos.offset,
	          outerRadius: radius - pos.offset + pos.radius,
	          payload: entry
	        }, cells && cells[index] && cells[index].props);
	      });
	    }
	    /**
	     * Calculate the size of all groups
	     * @param  {Array} items All the instance of RadialBar
	     * @return {Object} The size of all groups
	     */
	
	  }, {
	    key: 'getRadiusList',
	    value: function getRadiusList(items) {
	      var barSize = this.props.barSize;
	
	
	      return items.map(function (child) {
	        return _extends({}, child.props, {
	          item: child,
	          barSize: child.props.barSize || barSize
	        });
	      });
	    }
	
	    /**
	     * Calculate the scale function of radius
	     * @param {Number} innerRadius The outer radius
	     * @param {Number} outerRadius The inner radius
	     * @return {Object}            A scale function
	     */
	
	  }, {
	    key: 'getRadiusScale',
	    value: function getRadiusScale(innerRadius, outerRadius) {
	      var data = this.props.data;
	
	      var bandCount = Math.max(data.length, 1);
	      var range = [outerRadius, innerRadius];
	      var scale = (0, _d3Scale.scaleBand)().domain((0, _range3.default)(0, bandCount)).range(range);
	
	      return scale;
	    }
	
	    /**
	     * Calculate the size of each bar and the gap between two bars
	     * @param  {Number} bandRadius  The radius of each category
	     * @param  {Array} radiusList   The radius of all groups
	     * @return {Number} The size of each bar and the gap between two bars
	     */
	
	  }, {
	    key: 'getBarPosition',
	    value: function getBarPosition(bandRadius, radiusList) {
	      var _props = this.props,
	          barGap = _props.barGap,
	          barCategoryGap = _props.barCategoryGap;
	
	      var len = radiusList.length;
	      var result = void 0;
	
	      // whether or not is barSize setted by user
	      if (len && radiusList[0].barSize === +radiusList[0].barSize) {
	        (function () {
	          var sum = radiusList.reduce(function (res, entry) {
	            return res + entry.barSize;
	          }, 0);
	          sum += (len - 1) * barGap;
	          var offset = -sum / 2 >> 0;
	          var prev = { offset: offset - barGap, radius: 0 };
	
	          result = radiusList.reduce(function (res, entry) {
	            prev = {
	              offset: prev.offset + prev.radius + barGap,
	              radius: entry.barSize
	            };
	
	            return [].concat(_toConsumableArray(res), [{ item: entry.item, position: prev }]);
	          }, []);
	        })();
	      } else {
	        (function () {
	          var offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandRadius);
	          var radius = (bandRadius - 2 * offset - (len - 1) * barGap) / len >> 0;
	          offset = -Math.max((radius * len + (len - 1) * barGap) / 2 >> 0, 0);
	
	          result = radiusList.reduce(function (res, entry, i) {
	            return [].concat(_toConsumableArray(res), [{
	              item: entry.item,
	              position: {
	                offset: offset + (radius + barGap) * i,
	                radius: radius
	              }
	            }]);
	          }, []);
	        })();
	      }
	
	      return result;
	    }
	    /**
	     * Returns default, reset state for the radial bar chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        activeTooltipLabel: '',
	        activeTooltipPayload: [],
	        activeTooltipCoord: { x: 0, y: 0 },
	        isTooltipActive: false
	      };
	    }
	  }, {
	    key: 'renderLegend',
	
	
	    /**
	     * Draw legend
	     * @param  {ReactElement} legendItem The instance of Legend
	     * @return {ReactElement}            The instance of Legend
	     */
	    value: function renderLegend() {
	      var children = this.props.children;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	      if (!legendItem) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          data = _props2.data,
	          width = _props2.width,
	          height = _props2.height,
	          margin = _props2.margin;
	
	
	      var legendData = legendItem.props && legendItem.props.payload || data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || 'square',
	          color: entry.fill || '#000',
	          value: entry.name,
	          payload: entry
	        };
	      });
	
	      return _react2.default.cloneElement(legendItem, _extends({}, _Legend2.default.getWithHeight(legendItem, width), {
	        payload: legendData,
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin
	      }));
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          width = _props3.width,
	          height = _props3.height;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeTooltipLabel = _state.activeTooltipLabel,
	          activeTooltipCoord = _state.activeTooltipCoord,
	          activeTooltipPayload = _state.activeTooltipPayload;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: activeTooltipLabel,
	        payload: activeTooltipPayload,
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw the main part of bar chart
	     * @param  {Array} items     All the instance of RadialBar
	     * @param  {Object} radiusScale The scale function of radius of bars
	     * @param  {Object} center      The coordinate of center
	     * @return {ReactComponent}  All the instances of RadialBar
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, radiusScale, center) {
	      var _this2 = this;
	
	      if (!items || !items.length) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          onMouseEnter = _props4.onMouseEnter,
	          onMouseLeave = _props4.onMouseLeave,
	          onClick = _props4.onClick;
	
	      var radiusList = this.getRadiusList(items);
	      var bandRadius = radiusScale.bandwidth();
	      var barPosition = this.getBarPosition(bandRadius, radiusList);
	
	      return items.map(function (child, i) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            childOnMouseEnter = _child$props.onMouseEnter,
	            childOnMouseLeave = _child$props.onMouseLeave,
	            childOnClick = _child$props.onClick;
	
	
	        return _react2.default.cloneElement(child, _extends({}, center, {
	          key: child.key || 'radial-bar-' + i,
	          onMouseEnter: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
	          onMouseLeave: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
	          onClick: (0, _DataUtils.combineEventHandlers)(null, onClick, childOnClick),
	          data: _this2.getComposedData(child, barPosition, radiusScale, center, dataKey)
	        }));
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      if (!(0, _ReactUtils.validateWidthHeight)(this) || !data || !data.length) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          style = _props5.style,
	          children = _props5.children,
	          className = _props5.className,
	          width = _props5.width,
	          height = _props5.height,
	          margin = _props5.margin,
	          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height', 'margin']);
	
	      var items = (0, _ReactUtils.findAllByType)(children, _RadialBar2.default);
	      var cx = (0, _DataUtils.getPercentValue)(this.props.cx, width, width / 2);
	      var cy = (0, _DataUtils.getPercentValue)(this.props.cy, height, height / 2);
	      var maxRadius = (0, _PolarUtils.getMaxRadius)(width, height, margin);
	      var innerRadius = (0, _DataUtils.getPercentValue)(this.props.innerRadius, maxRadius, 0);
	      var outerRadius = (0, _DataUtils.getPercentValue)(this.props.outerRadius, maxRadius, maxRadius * 0.8);
	      var radiusScale = this.getRadiusScale(innerRadius, outerRadius);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { cursor: 'default', position: 'relative', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderItems(items, radiusScale, { cx: cx, cy: cy }),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(),
	        this.renderTooltip(items)
	      );
	    }
	  }]);
	
	  return RadialBarChart;
	}(_react.Component), _class2.displayName = 'RadialBarChart', _class2.propTypes = {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	  cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  data: _propTypes2.default.array,
	  innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  // The offset radius between two categorys
	  barCategoryGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  // The gap radius of two radial bar in one category
	  barGap: _propTypes2.default.number,
	  // The radius of each radial bar
	  barSize: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string
	}, _class2.defaultProps = {
	  cx: '50%',
	  cy: '50%',
	  innerRadius: '30%',
	  outerRadius: '90%',
	  barGap: 2,
	  barCategoryGap: '10%',
	  style: {},
	  margin: { top: 0, right: 0, bottom: 0, left: 0 }
	}, _temp2)) || _class;
	
	exports.default = RadialBarChart;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _sumBy2 = __webpack_require__(1656);
	
	var _sumBy3 = _interopRequireDefault(_sumBy2);
	
	var _min2 = __webpack_require__(1651);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _maxBy2 = __webpack_require__(683);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @file TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(63);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Rectangle = __webpack_require__(94);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultCoordinateOfTooltip = { x: 0, y: 0 };
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return { sourceNodes: sourceNodes, sourceLinks: sourceLinks, targetLinks: targetLinks, targetNodes: targetNodes };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	
	    return _extends({}, entry, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	  var maxDepth = (0, _maxBy3.default)(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return { tree: tree, maxDepth: maxDepth };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min3.default)(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy3.default)(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _extends({}, link, { dy: getValue(link) * yRatio });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length;
	
	    // Sort by the value of y
	    nodes.sort(ascendingY);
	
	    var y0 = 0;
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	
	  resolveCollisions(depthTree, height, nodePadding);
	
	  var alpha = 1;
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	
	    resolveCollisions(depthTree, height, nodePadding);
	
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	
	  return { nodes: tree, links: newLinks };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return { x: el.x + el.width / 2, y: el.y + el.height / 2 };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _DataUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _DataUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	  if (payload.source && payload.target) {
	    var sourceName = (0, _DataUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _DataUtils.getValueByDataKey)(payload.target, nameKey, '');
	
	    return [{
	      payload: el,
	      name: sourceName + ' - ' + targetName,
	      value: (0, _DataUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey(props) {
	    _classCallCheck(this, Sankey);
	
	    var _this = _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).call(this, props));
	
	    _this.state = _this.createDefaultState(props);
	    return _this;
	  }
	
	  _createClass(Sankey, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          iterations = _props.iterations,
	          nodeWidth = _props.nodeWidth,
	          nodePadding = _props.nodePadding,
	          nameKey = _props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _PureRender.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.createDefaultState(this.props));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations, nodeWidth: nodeWidth, nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes, links: links
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(el, type, e) {
	      var _props2 = this.props,
	          onMouseEnter = _props2.onMouseEnter,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(el, type, e) {
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          children = _props3.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: 'renderLinkItem',
	    value: function renderLinkItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth']);
	
	      return _react2.default.createElement('path', _extends({
	        className: 'recharts-sankey-link',
	        d: '\n          M' + sourceX + ',' + sourceY + '\n          C' + sourceControlX + ',' + sourceY + ' ' + targetControlX + ',' + targetY + ' ' + targetX + ',' + targetY + '\n        ',
	        fill: 'none',
	        stroke: '#333',
	        strokeWidth: linkWidth,
	        strokeOpacity: '0.2'
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: 'renderLinks',
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          linkCurvature = _props4.linkCurvature,
	          linkContent = _props4.link,
	          margin = _props4.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-links', key: 'recharts-sankey-links' },
	        links.map(function (link, i) {
	          var sourceRelativeY = link.sy,
	              targetRelativeY = link.ty,
	              linkWidth = link.dy;
	
	          var source = nodes[link.source];
	          var target = nodes[link.target];
	          var sourceX = source.x + source.dx + left;
	          var targetX = target.x + left;
	          var interpolationFunc = interpolationGenerator(sourceX, targetX);
	          var sourceControlX = interpolationFunc(linkCurvature);
	          var targetControlX = interpolationFunc(1 - linkCurvature);
	          var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	          var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	          var linkProps = _extends({
	            sourceX: sourceX, targetX: targetX,
	            sourceY: sourceY, targetY: targetY,
	            sourceControlX: sourceControlX, targetControlX: targetControlX,
	            sourceRelativeY: sourceRelativeY, targetRelativeY: targetRelativeY,
	            linkWidth: linkWidth,
	            index: i,
	            payload: _extends({}, link, { source: source, target: target })
	          }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	          var events = {
	            onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	            onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'link' + i }, events),
	            _this2.renderLinkItem(linkContent, linkProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderNodeItem',
	    value: function renderNodeItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        className: 'recharts-sankey-node',
	        fill: '#0088fe',
	        fillOpacity: '0.8'
	      }, props));
	    }
	  }, {
	    key: 'renderNodes',
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          nodeContent = _props5.node,
	          margin = _props5.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-nodes', key: 'recharts-sankey-nodes' },
	        nodes.map(function (node, i) {
	          var x = node.x,
	              y = node.y,
	              dx = node.dx,
	              dy = node.dy;
	
	          var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	            x: x + left,
	            y: y + top,
	            width: dx,
	            height: dy,
	            index: i,
	            payload: node
	          });
	          var events = {
	            onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	            onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'node' + i }, events),
	            _this3.renderNodeItem(nodeContent, nodeProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props6 = this.props,
	          children = _props6.children,
	          width = _props6.width,
	          height = _props6.height,
	          nameKey = _props6.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeElement = _state.activeElement,
	          activeElementType = _state.activeElementType;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var _state2 = this.state,
	          links = _state2.links,
	          nodes = _state2.nodes;
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          (0, _ReactUtils.filterSvgElements)(children),
	          this.renderLinks(links, nodes),
	          this.renderNodes(nodes)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component), _class2.displayName = 'Sankey', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.shape({
	    nodes: _propTypes2.default.array,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      target: _propTypes2.default.number,
	      source: _propTypes2.default.number,
	      value: _propTypes2.default.number
	    }))
	  }),
	
	  nodePadding: _propTypes2.default.number,
	  nodeWidth: _propTypes2.default.number,
	  linkCurvature: _propTypes2.default.number,
	  iterations: _propTypes2.default.number,
	
	  node: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  link: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  })
	}), _class2.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: { top: 5, right: 5, bottom: 5, left: 5 }
	}, _temp)) || _class;
	
	exports.default = Sankey;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Scatter Chart
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(63);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Cell = __webpack_require__(140);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _Legend = __webpack_require__(92);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Cross = __webpack_require__(660);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _CartesianAxis = __webpack_require__(308);
	
	var _CartesianAxis2 = _interopRequireDefault(_CartesianAxis);
	
	var _CartesianGrid = __webpack_require__(309);
	
	var _CartesianGrid2 = _interopRequireDefault(_CartesianGrid);
	
	var _Scatter = __webpack_require__(648);
	
	var _Scatter2 = _interopRequireDefault(_Scatter);
	
	var _XAxis = __webpack_require__(311);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(312);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _ZAxis = __webpack_require__(649);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _ReferenceLine = __webpack_require__(199);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceDot = __webpack_require__(198);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceArea = __webpack_require__(197);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(16);
	
	var _LogUtils = __webpack_require__(316);
	
	var _CartesianUtils = __webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScatterChart = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(ScatterChart, _Component);
	
	  function ScatterChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScatterChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScatterChart.__proto__ || Object.getPrototypeOf(ScatterChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      activeTooltipCoord: { x: 0, y: 0 },
	      isTooltipActive: false,
	      activeItem: null
	    }, _this.handleLegendBBoxUpdate = function (box) {
	      if (box && _this.legendInstance) {
	        _this.forceUpdate();
	      }
	    }, _this.handleScatterMouseEnter = function (el) {
	      _this.setState({
	        isTooltipActive: true,
	        activeItem: el,
	        activeTooltipCoord: { x: el.cx, y: el.cy }
	      });
	    }, _this.handleScatterMouseLeave = function () {
	      _this.setState({
	        isTooltipActive: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScatterChart, [{
	    key: 'getComposedData',
	
	    /**
	     * Compose the data of each group
	     * @param  {Object} item        An instance of Scatter
	     * @param  {Array}  data        The original data
	     * @param  {Object} xAxis       The configuration of x-axis
	     * @param  {Object} yAxis       The configuration of y-axis
	     * @param  {Object} zAxis       The configuration of z-axis
	     * @return {Array} Composed data
	     */
	    value: function getComposedData(item, data, xAxis, yAxis, zAxis) {
	      var children = item.props.children;
	
	      var xAxisDataKey = xAxis.dataKey;
	      var yAxisDataKey = yAxis.dataKey;
	      var zAxisDataKey = zAxis.dataKey;
	      var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	      return data.map(function (entry, index) {
	        return _extends({}, entry, {
	          cx: (0, _DataUtils.isNumber)(entry[xAxisDataKey]) ? xAxis.scale(entry[xAxisDataKey]) : null,
	          cy: (0, _DataUtils.isNumber)(entry[yAxisDataKey]) ? yAxis.scale(entry[yAxisDataKey]) : null,
	          size: zAxisDataKey !== undefined && (0, _DataUtils.isNumber)(entry[zAxisDataKey]) ? zAxis.scale(entry[zAxisDataKey]) : zAxis.range[0],
	          node: {
	            x: entry[xAxisDataKey],
	            y: entry[yAxisDataKey],
	            z: zAxisDataKey !== undefined && entry[zAxisDataKey] || '-'
	          },
	          payload: entry
	        }, cells && cells[index] && cells[index].props);
	      });
	    }
	  }, {
	    key: 'getDomain',
	    value: function getDomain(items, dataKey, axisId, axisType) {
	      var domain = items.reduce(function (result, item) {
	        return result.concat(item.props.data.map(function (entry) {
	          return (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	        }));
	      }, []);
	
	      if (axisType === 'xAxis' || axisType === 'yAxis') {
	        domain = (0, _CartesianUtils.detectReferenceElementsDomain)(this.props.children, domain, axisId, axisType);
	      }
	
	      return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
	    }
	
	    /**
	     * Get the configuration of x-axis or y-axis
	     * @param  {String} axisType The type of axis
	     * @param  {Array} items     The instances of item
	     * @return {Object}          Configuration
	     */
	
	  }, {
	    key: 'getAxis',
	    value: function getAxis() {
	      var axisType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xAxis';
	      var items = arguments[1];
	      var children = this.props.children;
	
	      var Axis = axisType === 'xAxis' ? _XAxis2.default : _YAxis2.default;
	      var axis = (0, _ReactUtils.findChildByType)(children, Axis);
	
	      (0, _LogUtils.warn)(axis, 'recharts: ScatterChart must has %s', Axis.displayName);
	
	      if (axis) {
	        var domain = (0, _DataUtils.parseSpecifiedDomain)(axis.props.domain, this.getDomain(items, axis.props.dataKey, axis.props[axisType + 'Id'], axisType), axis.props.allowDataOverflow);
	
	        return _extends({}, axis.props, {
	          axisType: axisType,
	          domain: domain,
	          type: 'number',
	          originalDomain: axis.props.domain
	        });
	      }
	
	      return null;
	    }
	
	    /**
	     * Get the configuration of z-axis
	     * @param  {Array} items The instances of item
	     * @return {Object}      Configuration
	     */
	
	  }, {
	    key: 'getZAxis',
	    value: function getZAxis(items) {
	      var children = this.props.children;
	
	      var axisItem = (0, _ReactUtils.findChildByType)(children, _ZAxis2.default);
	      var axisProps = axisItem && axisItem.props || _ZAxis2.default.defaultProps;
	      var domain = axisProps.dataKey ? this.getDomain(items, axisProps.dataKey) : [-1, 1];
	
	      return _extends({}, axisProps, {
	        domain: domain,
	        scale: (0, _DataUtils.parseScale)(axisProps).domain(domain).range(axisProps.range)
	      });
	    }
	  }, {
	    key: 'getOffset',
	    value: function getOffset(items, xAxis, yAxis) {
	      var _props = this.props,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          children = _props.children;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	      var offset = {
	        left: margin.left || 0, right: margin.right || 0,
	        top: margin.top || 0, bottom: margin.bottom || 0
	      };
	
	      if (!xAxis.hide && !xAxis.mirror) {
	        offset[xAxis.orientation] += xAxis.height;
	      }
	      if (!yAxis.hide && !yAxis.mirror) {
	        offset[yAxis.orientation] += yAxis.width;
	      }
	
	      if (legendItem && this.legendInstance) {
	        var legendBox = this.legendInstance.getBBox();
	        offset = (0, _CartesianUtils.appendOffsetOfLegend)(offset, items, this.props, legendBox);
	      }
	
	      return _extends({}, offset, {
	        width: width - offset.left - offset.right,
	        height: height - offset.top - offset.bottom
	      });
	    }
	    /**
	     * Calculate the scale function, position, width, height of axes
	     * @param  {Object} axis     The configuration of axis
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @param  {Object} axisType The type of axis, x-axis or y-axis
	     * @return {Object} Configuration
	     */
	
	  }, {
	    key: 'getFormatAxis',
	    value: function getFormatAxis(axis, offset, axisType) {
	      var orientation = axis.orientation,
	          domain = axis.domain,
	          mirror = axis.mirror,
	          tickFormat = axis.tickFormat,
	          _axis$padding = axis.padding,
	          padding = _axis$padding === undefined ? {} : _axis$padding;
	
	      var position = {
	        left: offset.left,
	        right: offset.left + offset.width,
	        top: offset.top,
	        bottom: offset.top + offset.height
	      };
	      var range = axisType === 'xAxis' ? [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)] : [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)];
	
	      var scale = (0, _DataUtils.parseScale)(axis).domain(domain).range(range);
	      var ticks = (0, _CartesianUtils.getTicksOfScale)(scale, axis);
	      if (tickFormat) {
	        scale.tickFormat(tickFormat);
	      }
	
	      var x = void 0,
	          y = void 0;
	
	      if (axisType === 'xAxis') {
	        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        x = offset.left;
	        y = position[orientation] - needSpace * axis.height;
	      } else {
	        var _needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        x = position[orientation] - _needSpace * axis.width;
	        y = offset.top;
	      }
	
	      return _extends({}, axis, ticks, {
	        scale: scale,
	        width: axisType === 'xAxis' ? offset.width : axis.width,
	        height: axisType === 'yAxis' ? offset.height : axis.height,
	        x: x, y: y
	      });
	    }
	
	    /**
	     * Get the content to be displayed in the tooltip
	     * @param  {Object} data  The data of active item
	     * @param  {Object} xAxis The configuration of x-axis
	     * @param  {Object} yAxis The configuration of y-axis
	     * @param  {Object} zAxis The configuration of z-axis
	     * @return {Array}        The content of tooltip
	     */
	
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent(data, xAxis, yAxis, zAxis) {
	      if (!data) {
	        return null;
	      }
	
	      var payload = data.payload,
	          node = data.node;
	
	
	      var content = [{
	        name: xAxis.name || xAxis.dataKey,
	        unit: xAxis.unit || '',
	        value: node.x,
	        payload: payload
	      }, {
	        name: yAxis.name || yAxis.dataKey,
	        unit: yAxis.unit || '',
	        value: node.y,
	        payload: payload
	      }];
	
	      if (node.z && node.z !== '-') {
	        content.push({
	          name: zAxis.name || zAxis.dataKey,
	          unit: zAxis.unit || '',
	          value: node.z,
	          payload: payload
	        });
	      }
	
	      return content;
	    }
	    /**
	     * The handler of mouse entering a scatter
	     * @param {Object} el The active scatter
	     * @param {Object} e  Event object
	     * @return {Object} no return
	     */
	
	
	    /**
	     * The handler of mouse leaving a scatter
	     * @return {Object} no return
	     */
	
	  }, {
	    key: 'renderTooltip',
	
	
	    /**
	     * Draw Tooltip
	     * @param  {Array} items   The instances of Scatter
	     * @param  {Object} xAxis  The configuration of x-axis
	     * @param  {Object} yAxis  The configuration of y-axis
	     * @param  {Object} zAxis  The configuration of z-axis
	     * @param  {Object} offset The offset of main part in the svg element
	     * @return {ReactElement}  The instance of Tooltip
	     */
	    value: function renderTooltip(items, xAxis, yAxis, zAxis, offset) {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeItem = _state.activeItem,
	          activeTooltipCoord = _state.activeTooltipCoord;
	
	      var viewBox = {
	        x: offset.left,
	        y: offset.top,
	        width: offset.width,
	        height: offset.height
	      };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: '',
	        payload: this.getTooltipContent(activeItem, xAxis, yAxis, zAxis),
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw grid
	     * @param  {Object} xAxis  The configuration of x-axis
	     * @param  {Object} yAxis  The configuration of y-axis
	     * @param  {Object} offset The offset of main part in the svg element
	     * @return {ReactElement} The instance of grid
	     */
	
	  }, {
	    key: 'renderGrid',
	    value: function renderGrid(xAxis, yAxis, offset) {
	      var _props2 = this.props,
	          children = _props2.children,
	          width = _props2.width,
	          height = _props2.height;
	
	      var gridItem = (0, _ReactUtils.findChildByType)(children, _CartesianGrid2.default);
	
	      if (!gridItem) {
	        return null;
	      }
	
	      var verticalPoints = (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, xAxis, {
	        ticks: (0, _CartesianUtils.getTicksOfAxis)(xAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.left, offset.left + offset.width);
	
	      var horizontalPoints = (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, yAxis, {
	        ticks: (0, _CartesianUtils.getTicksOfAxis)(yAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.top, offset.top + offset.height);
	
	      return _react2.default.cloneElement(gridItem, {
	        key: 'grid',
	        x: offset.left,
	        y: offset.top,
	        width: offset.width,
	        height: offset.height,
	        verticalPoints: verticalPoints,
	        horizontalPoints: horizontalPoints
	      });
	    }
	    /**
	     * Draw legend
	     * @param  {Array} items     The instances of Scatters
	     * @return {ReactElement}    The instance of Legend
	     */
	
	  }, {
	    key: 'renderLegend',
	    value: function renderLegend(items) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          children = _props3.children,
	          width = _props3.width,
	          height = _props3.height,
	          margin = _props3.margin;
	
	      var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	      var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	      var props = (0, _CartesianUtils.getLegendProps)(children, items, legendWidth, legendHeight);
	
	      if (!props) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Legend2.default, _extends({}, props, {
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin,
	        ref: function ref(legend) {
	          _this2.legendInstance = legend;
	        },
	        onBBoxUpdate: this.handleLegendBBoxUpdate
	      }));
	    }
	
	    /**
	     * Draw axis
	     * @param {Object} axis     The configuration of axis
	     * @param {String} layerKey The key of layer
	     * @return {ReactElement}   The instance of axis
	     */
	
	  }, {
	    key: 'renderAxis',
	    value: function renderAxis(axis, layerKey) {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height;
	
	
	      if (axis && !axis.hide) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          { key: layerKey, className: layerKey },
	          _react2.default.createElement(_CartesianAxis2.default, _extends({}, axis, {
	            viewBox: { x: 0, y: 0, width: width, height: height },
	            ticks: (0, _CartesianUtils.getTicksOfAxis)(axis, true)
	          }))
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderCursor',
	    value: function renderCursor(xAxis, yAxis, offset) {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem || !tooltipItem.props.cursor || !this.state.isTooltipActive) {
	        return null;
	      }
	      var activeItem = this.state.activeItem;
	
	
	      var cursorProps = _extends({
	        stroke: '#ccc',
	        strokeDasharray: '5 5'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), offset, {
	        x: activeItem.cx,
	        y: activeItem.cy,
	        payload: activeItem
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Cross2.default, cursorProps);
	    }
	
	    /**
	     * Draw the main part of scatter chart
	     * @param  {Array} items   All the instance of Scatter
	     * @param  {Object} xAxis  The configuration of all x-axis
	     * @param  {Object} yAxis  The configuration of all y-axis
	     * @param  {Object} zAxis  The configuration of all z-axis
	     * @param  {Object} offset The offset of main part in the svg element
	     * @return {ReactComponent}  All the instances of Scatter
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, xAxis, yAxis, zAxis, offset) {
	      var _this3 = this;
	
	      var activeGroupId = this.state.activeGroupId;
	
	      return items.map(function (child, i) {
	        var _child$props = child.props,
	            strokeWidth = _child$props.strokeWidth,
	            data = _child$props.data;
	
	
	        var finalStrokeWidth = strokeWidth === +strokeWidth ? strokeWidth : 1;
	        finalStrokeWidth = activeGroupId === 'scatter-' + i ? finalStrokeWidth + 2 : finalStrokeWidth;
	
	        return _react2.default.cloneElement(child, _extends({
	          key: child.key || 'scatter-' + i,
	          groupId: 'scatter-' + i,
	          strokeWidth: finalStrokeWidth,
	          onMouseLeave: _this3.handleScatterMouseLeave,
	          onMouseEnter: _this3.handleScatterMouseEnter,
	          points: _this3.getComposedData(child, data, xAxis, yAxis, zAxis)
	        }, offset, {
	          xAxis: xAxis,
	          yAxis: yAxis
	        }));
	      }, this);
	    }
	  }, {
	    key: 'renderReferenceElements',
	    value: function renderReferenceElements(xAxis, yAxis, offset, isFront, Compt) {
	      var children = this.props.children;
	
	      var elements = (0, _ReactUtils.findAllByType)(children, Compt);
	
	      if (!elements || !elements.length) {
	        return null;
	      }
	
	      var keyPrefix = (0, _ReactUtils.getDisplayName)(Compt) + '-' + (isFront ? 'front' : 'back');
	
	      return elements.filter(function (entry) {
	        return isFront === entry.props.isFront;
	      }).map(function (entry, i) {
	        return _react2.default.cloneElement(entry, {
	          key: keyPrefix + '-' + i,
	          xAxis: xAxis, yAxis: yAxis,
	          viewBox: {
	            x: offset.left,
	            y: offset.top,
	            width: offset.width,
	            height: offset.height
	          }
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      // eslint-disable-next-line no-unused-vars
	
	      var _props5 = this.props,
	          style = _props5.style,
	          children = _props5.children,
	          className = _props5.className,
	          width = _props5.width,
	          height = _props5.height,
	          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);
	
	      var items = (0, _ReactUtils.findAllByType)(children, _Scatter2.default);
	      var zAxis = this.getZAxis(items);
	      var xAxis = this.getAxis('xAxis', items);
	      var yAxis = this.getAxis('yAxis', items);
	
	      var offset = this.getOffset(items, xAxis, yAxis);
	      xAxis = this.getFormatAxis(xAxis, offset, 'xAxis');
	      yAxis = this.getFormatAxis(yAxis, offset, 'yAxis');
	      var events = (0, _ReactUtils.filterEventAttributes)(this.props);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: { position: 'relative', cursor: 'default', width: width, height: height }
	        }, events),
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderGrid(xAxis, yAxis, offset),
	          this.renderReferenceElements(xAxis, yAxis, offset, false, _ReferenceArea2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, false, _ReferenceLine2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, false, _ReferenceDot2.default),
	          this.renderAxis(xAxis, 'recharts-x-axis'),
	          this.renderAxis(yAxis, 'recharts-y-axis'),
	          this.renderCursor(xAxis, yAxis, offset),
	          this.renderItems(items, xAxis, yAxis, zAxis, offset),
	          this.renderReferenceElements(xAxis, yAxis, offset, true, _ReferenceArea2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, true, _ReferenceLine2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, true, _ReferenceDot2.default),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(items),
	        this.renderTooltip(items, xAxis, yAxis, zAxis, offset)
	      );
	    }
	  }]);
	
	  return ScatterChart;
	}(_react.Component), _class2.displayName = 'ScatterChart', _class2.propTypes = _extends({}, _ReactUtils.EVENT_ATTRIBUTES, {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	  title: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string
	}), _class2.defaultProps = {
	  style: {},
	  margin: { top: 5, right: 5, bottom: 5, left: 5 }
	}, _temp2)) || _class;
	
	exports.default = ScatterChart;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(20);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(46);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(21);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(63);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(23);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Rectangle = __webpack_require__(94);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _ReactUtils = __webpack_require__(11);
	
	var _Tooltip = __webpack_require__(47);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({ depth: childDepth, node: child, index: i, valueKey: valueKey });
	  }) : null;
	  var value = void 0;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = isNaN(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _extends({}, node, {
	    children: computedChildren,
	    value: value, depth: depth, index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return { x: node.x, y: node.y, width: node.width, height: node.height };
	};
	
	// Compute the area for each child based on value & scale.
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	
	  return children.map(function (child) {
	    var area = child.value * ratio;
	
	    return _extends({}, child, {
	      area: isNaN(area) || area <= 0 ? 0 : area
	    });
	  });
	};
	
	// Computes the score for the specified row, as the worst aspect ratio.
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, { min: Infinity, max: 0 }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  }
	  // what's z
	  child.z = true;
	  // add the remain x to the last one of row
	  child.width += parentRect.x + parentRect.width - curX;
	
	  return _extends({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	
	  return _extends({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	};
	
	// Recursively arranges the specified node's children into squarified rows.
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	    var child = void 0,
	        score = void 0; // the current row score
	    var size = Math.min(rect.width, rect.height); // initial orientation
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	
	      score = getWorstScore(row, size, aspectRatio);
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _extends({}, node, { children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      }) });
	  }
	
	  return node;
	};
	
	var Treemap = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Treemap, _Component);
	
	  function Treemap() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Treemap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        activeNode: null
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(node, e) {
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          children = _props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(node, e) {
	      var _props2 = this.props,
	          onMouseLeave = _props2.onMouseLeave,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(node) {
	      var onClick = this.props.onClick;
	
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: 'renderAnimatedItem',
	    value: function renderAnimatedItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          isUpdateAnimationActive = _props3.isUpdateAnimationActive;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y;
	
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf) {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: { x: x, y: y, width: width, height: height },
	          to: { x: x, y: y, width: width, height: height },
	          duration: animationDuration,
	          easing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref3) {
	          var currX = _ref3.x,
	              currY = _ref3.y,
	              currWidth = _ref3.width,
	              currHeight = _ref3.height;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              from: 'translate(' + translateX + 'px, ' + translateX + 'px)',
	              to: 'translate(0, 0)',
	              attributeName: 'transform',
	              begin: animationBegin,
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration
	            },
	            _react2.default.createElement(
	              _Layer2.default,
	              event,
	              _this2.renderContentItem(content, _extends({}, nodeProps, {
	                isAnimationActive: isAnimationActive,
	                isUpdateAnimationActive: !isUpdateAnimationActive,
	                width: currWidth,
	                height: currHeight,
	                x: currX,
	                y: currY
	              }))
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderContentItem',
	    value: function renderContentItem(content, nodeProps) {
	      if (_react2.default.isValidElement(content)) {
	        return _react2.default.cloneElement(content, nodeProps);
	      } else if ((0, _isFunction3.default)(content)) {
	        return content(nodeProps);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        fill: '#fff',
	        stroke: '#000'
	      }, nodeProps));
	    }
	  }, {
	    key: 'renderNode',
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var content = this.props.content;
	
	      var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), node, { root: root });
	      var isLeaf = !node.children || !node.children.length;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { key: 'recharts-treemap-node-' + i, className: 'recharts-treemap-depth-' + node.depth },
	        this.renderAnimatedItem(content, nodeProps, isLeaf),
	        node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null
	      );
	    }
	  }, {
	    key: 'renderAllNodes',
	    value: function renderAllNodes() {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          data = _props4.data,
	          dataKey = _props4.dataKey,
	          aspectRatio = _props4.aspectRatio;
	
	
	      var root = computeNode({
	        depth: 0,
	        node: { children: data, x: 0, y: 0, width: width, height: height },
	        index: 0,
	        valueKey: dataKey
	      });
	
	      var formatRoot = squarify(root, aspectRatio);
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props5 = this.props,
	          children = _props5.children,
	          nameKey = _props5.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height,
	          dataKey = _props6.dataKey;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeNode = _state.activeNode;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _DataUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _DataUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderAllNodes(),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Treemap;
	}(_react.Component), _class2.displayName = 'Treemap', _class2.propTypes = {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  style: _propTypes2.default.object,
	  aspectRatio: _propTypes2.default.number,
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}, _class2.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear'
	}, _temp2)) || _class;
	
	exports.default = Treemap;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Legend Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Surface = __webpack_require__(63);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Symbols = __webpack_require__(315);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ReactUtils = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SIZE = 32;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultLegendContent, _Component);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, (DefaultLegendContent.__proto__ || Object.getPrototypeOf(DefaultLegendContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: 'renderIcon',
	
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var color = data.color;
	
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	
	      if (data.type === 'line') {
	        return _react2.default.createElement('path', {
	          strokeWidth: 4,
	          fill: 'none',
	          stroke: color,
	          d: 'M0,' + halfSize + 'h' + thirdSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + 2 * thirdSize + ',' + halfSize + '\n            H' + SIZE + 'M' + 2 * thirdSize + ',' + halfSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + thirdSize + ',' + halfSize,
	          className: 'recharts-legend-icon'
	        });
	      } else if (data.type === 'rect') {
	        return _react2.default.createElement('path', {
	          stroke: 'none',
	          fill: color,
	          d: 'M0,' + SIZE / 8 + 'h' + SIZE + 'v' + SIZE * 3 / 4 + 'h' + -SIZE + 'z',
	          className: 'recharts-legend-icon'
	        });
	      }
	
	      return _react2.default.createElement(_Symbols2.default, {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: 'diameter',
	        type: data.type
	      });
	    }
	
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          iconSize = _props.iconSize,
	          layout = _props.layout,
	          formatter = _props.formatter;
	
	      var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };
	
	      return payload.map(function (entry, i) {
	        var finalFormatter = entry.formatter || formatter;
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'li',
	          _extends({
	            className: 'recharts-legend-item legend-item-' + i,
	            style: itemStyle,
	            key: 'legend-item-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _react2.default.createElement(
	            _Surface2.default,
	            { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle },
	            _this2.renderIcon(entry, iconSize)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'recharts-legend-item-text' },
	            finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          payload = _props2.payload,
	          layout = _props2.layout,
	          align = _props2.align;
	
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'recharts-default-legend', style: finalStyle },
	        this.renderItems()
	      );
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.element,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle'
	}, _temp)) || _class;
	
	exports.default = DefaultLegendContent;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(41);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(27);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Tooltip Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(12);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray3.default)(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultTooltipContent, _Component);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, (DefaultTooltipContent.__proto__ || Object.getPrototypeOf(DefaultTooltipContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props = this.props,
	          payload = _props.payload,
	          separator = _props.separator,
	          formatter = _props.formatter,
	          itemStyle = _props.itemStyle,
	          itemSorter = _props.itemSorter;
	
	
	      if (payload && payload.length) {
	        var listStyle = { padding: 0, margin: 0 };
	
	        var items = payload.filter(function (entry) {
	          return !(0, _isNil3.default)(entry.value);
	        }).sort(itemSorter).map(function (entry, i) {
	          var finalItemStyle = _extends({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	
	          return _react2.default.createElement(
	            'li',
	            { className: 'recharts-tooltip-item', key: 'tooltip-item-' + i, style: finalItemStyle },
	            entry.name ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-name' },
	              entry.name
	            ) : null,
	            entry.name ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-separator' },
	              separator
	            ) : null,
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-value' },
	              finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-unit' },
	              entry.unit || ''
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          'ul',
	          { className: 'recharts-tooltip-item-list', style: listStyle },
	          items
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          labelStyle = _props2.labelStyle,
	          label = _props2.label,
	          labelFormatter = _props2.labelFormatter,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var finalStyle = _extends({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, wrapperStyle);
	      var finalLabelStyle = _extends({
	        margin: 0
	      }, labelStyle);
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'recharts-default-tooltip', style: finalStyle },
	        _react2.default.createElement(
	          'p',
	          { className: 'recharts-tooltip-label', style: finalLabelStyle },
	          finalLabel
	        ),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.Component), _class2.displayName = 'DefaultTooltipContent', _class2.propTypes = {
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  wrapperStyle: _propTypes2.default.object,
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  labelFormatter: _propTypes2.default.func,
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	  itemSorter: _propTypes2.default.func
	}, _class2.defaultProps = {
	  separator: ' : ',
	  itemStyle: {},
	  labelStyle: {}
	}, _temp)) || _class;
	
	exports.default = DefaultTooltipContent;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(677);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResizeDetector = __webpack_require__(1246);
	
	var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);
	
	var _DataUtils = __webpack_require__(16);
	
	var _LogUtils = __webpack_require__(316);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResponsiveContainer = (_temp = _class = function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    _classCallCheck(this, ResponsiveContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResponsiveContainer.__proto__ || Object.getPrototypeOf(ResponsiveContainer)).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	
	    _this.handleResize = props.debounce > 0 ? (0, _debounce3.default)(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'getContainerSize',
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: 'renderChart',
	    value: function renderChart() {
	      var _state = this.state,
	          containerWidth = _state.containerWidth,
	          containerHeight = _state.containerHeight;
	
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _props = this.props,
	          aspect = _props.aspect,
	          width = _props.width,
	          height = _props.height,
	          minWidth = _props.minWidth,
	          minHeight = _props.minHeight,
	          maxHeight = _props.maxHeight,
	          children = _props.children;
	
	
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), 'The width(%s) and height(%s) are both fixed numbers,\n       maybe you don\'t need to use a ResponsiveContainer.', width, height);
	
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        calculatedHeight = calculatedWidth / aspect;
	        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 && calculatedHeight > 0, 'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.', calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	
	      return _react2.default.cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          minWidth = _props2.minWidth,
	          minHeight = _props2.minHeight,
	          width = _props2.width,
	          height = _props2.height,
	          maxHeight = _props2.maxHeight;
	
	      var style = { width: width, height: height, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-responsive-container',
	          style: style,
	          ref: function ref(node) {
	            _this2.container = node;
	          }
	        },
	        this.renderChart(),
	        _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, handleHeight: true, onResize: this.handleResize })
	      );
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component), _class.displayName = 'ResponsiveContainer', _class.propTypes = {
	  aspect: _propTypes2.default.number,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  minHeight: _propTypes2.default.number,
	  minWidth: _propTypes2.default.number,
	  maxHeight: _propTypes2.default.number,
	  children: _propTypes2.default.node.isRequired,
	  debounce: _propTypes2.default.number
	}, _class.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	}, _temp);
	exports.default = ResponsiveContainer;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1523);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  (function () {
	    var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	    Object.getPrototypeOf = function (object) {
	      if (object.__proto__) {
	        return object.__proto__;
	      }
	
	      return nativeGetPrototypeOf.call(Object, object);
	    };
	  })();
	}

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = undefined;
	
	var _events = __webpack_require__(977);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventCenter = new _events2.default();
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	exports.eventCenter = eventCenter;
	var SYNC_EVENT = exports.SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1535);
	__webpack_require__(1536);
	__webpack_require__(1537);
	__webpack_require__(1538);
	__webpack_require__(1539);
	__webpack_require__(1540);
	__webpack_require__(1541);
	__webpack_require__(1542);
	__webpack_require__(1543);
	__webpack_require__(1544);
	__webpack_require__(1545);
	__webpack_require__(1546);
	__webpack_require__(1547);
	__webpack_require__(1548);
	__webpack_require__(1549);
	__webpack_require__(1550);
	__webpack_require__(1551);
	module.exports = __webpack_require__(317).Math;

/***/ },
/* 1524 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(320);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(1524);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(320)
	  , document = __webpack_require__(319).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 1528 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(318) && !__webpack_require__(202)(function(){
	  return Object.defineProperty(__webpack_require__(1527)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(1525)
	  , IE8_DOM_DEFINE = __webpack_require__(1529)
	  , toPrimitive    = __webpack_require__(1533)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(318) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 1531 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(319)
	  , hide      = __webpack_require__(661)
	  , has       = __webpack_require__(1528)
	  , SRC       = __webpack_require__(1534)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(317).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(320);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 1534 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(32)
	  , log1p   = __webpack_require__(662)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(32)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(32)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(32)
	  , sign    = __webpack_require__(322);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(32)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(32)
	  , $expm1  = __webpack_require__(321);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(32)
	  , sign      = __webpack_require__(322)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(32)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(32)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(202)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(662)});

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {sign: __webpack_require__(322)});

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(32)
	  , expm1   = __webpack_require__(321)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(202)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(32)
	  , expm1   = __webpack_require__(321)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 1552 */
[1676, 95, 55],
/* 1553 */
[1677, 1609, 1610, 1611, 1612, 1613],
/* 1554 */
[1681, 95, 55],
/* 1555 */
[1682, 95, 55],
/* 1556 */
[1683, 324, 1634, 1635],
/* 1557 */
[1686, 55],
/* 1558 */
[1687, 95, 55],
/* 1559 */
1282,
/* 1560 */
605,
/* 1561 */
[1688, 1588, 330, 27, 679, 327, 682],
/* 1562 */
578,
/* 1563 */
[1690, 1566, 1595],
/* 1564 */
[1775, 665, 1614],
/* 1565 */
[1691, 1596],
/* 1566 */
[1692, 1565, 332],
/* 1567 */
[1694, 665, 27],
/* 1568 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ },
/* 1569 */
1165,
/* 1570 */
[1696, 76, 78],
/* 1571 */
[1698, 663, 670, 1599, 1600, 1606, 27, 679, 682],
/* 1572 */
[1699, 663, 667],
/* 1573 */
[1700, 20, 1616, 77, 676],
/* 1574 */
[1701, 76, 331, 78],
/* 1575 */
[1703, 1617, 1630],
/* 1576 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 1577 */
[1776, 1563, 208],
/* 1578 */
[1704, 1572, 1602, 674],
/* 1579 */
[1705, 667, 678, 1647, 328, 673, 674, 207],
/* 1580 */
[1777, 664, 325, 326, 1577, 1586, 668, 1593, 144, 27],
/* 1581 */
1174,
/* 1582 */
[1706, 325],
/* 1583 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 1584 */
[1768, 144, 1633, 1637],
/* 1585 */
[1769, 1646, 1598, 144],
/* 1586 */
1413,
/* 1587 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 1588 */
1177,
/* 1589 */
[1707, 143, 664, 27, 122],
/* 1590 */
[1708, 1645],
/* 1591 */
608,
/* 1592 */
[1778, 122],
/* 1593 */
[1779, 1592],
/* 1594 */
[1710, 55],
/* 1595 */
[1711, 208],
/* 1596 */
1184,
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(1583),
	    isIterateeCall = __webpack_require__(672),
	    toFinite = __webpack_require__(1658);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 1598 */
[1770, 95],
/* 1599 */
[1714, 143, 1557, 329, 670, 1628, 1636],
/* 1600 */
[1715, 1601],
/* 1601 */
[1716, 1567, 1605, 332],
/* 1602 */
[1718, 673, 332],
/* 1603 */
[1771, 675],
/* 1604 */
[1720, 143],
/* 1605 */
[1721, 1560, 1654],
/* 1606 */
[1722, 1552, 323, 1554, 1555, 1558, 76, 676],
/* 1607 */
1193,
/* 1608 */
[1723, 669, 330, 27, 327, 331, 207],
/* 1609 */
[1724, 206],
/* 1610 */
1196,
/* 1611 */
[1725, 206],
/* 1612 */
[1726, 206],
/* 1613 */
[1727, 206],
/* 1614 */
[1780, 143, 330, 27],
/* 1615 */
1201,
/* 1616 */
[1730, 1594],
/* 1617 */
1203,
/* 1618 */
1204,
/* 1619 */
[1732, 204],
/* 1620 */
[1733, 204],
/* 1621 */
[1734, 204],
/* 1622 */
[1735, 204],
/* 1623 */
[1736, 1553, 203, 323],
/* 1624 */
[1737, 205],
/* 1625 */
[1738, 205],
/* 1626 */
[1739, 205],
/* 1627 */
[1740, 205],
/* 1628 */
1214,
/* 1629 */
[1741, 1650],
/* 1630 */
[1743, 675],
/* 1631 */
[1744, 671],
/* 1632 */
1218,
/* 1633 */
[1772, 1559],
/* 1634 */
1220,
/* 1635 */
1221,
/* 1636 */
1222,
/* 1637 */
[1773, 1585, 1638],
/* 1638 */
1356,
/* 1639 */
[1746, 203],
/* 1640 */
1224,
/* 1641 */
1225,
/* 1642 */
1226,
/* 1643 */
[1747, 203, 323, 324],
/* 1644 */
[1748, 1629],
/* 1645 */
1229,
/* 1646 */
1364,
/* 1647 */
[1753, 1569, 1608],
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(680);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 1649 */
[1774, 76, 1603, 78],
/* 1650 */
[1762, 324],
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(666),
	    baseLt = __webpack_require__(1576),
	    identity = __webpack_require__(144);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(55);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 1653 */
[1763, 1581, 1582, 328, 207],
/* 1654 */
1237,
/* 1655 */
1238,
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(326),
	    baseSum = __webpack_require__(1587);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(677),
	    isObject = __webpack_require__(77);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 1658 */
[1764, 685],
/* 1659 */
[1767, 1589],
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(38);
	var invariant = __webpack_require__(10);
	var ReactPropTypesSecret = __webpack_require__(1661);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1661 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(955)
	var reduceFunctionCall = __webpack_require__(1663)
	var mexp = __webpack_require__(1028)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(1664)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 1664 */
/***/ function(module, exports) {

	'use strict';
	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    if(a===b) {
	      return [ai, bi];
	    }
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.scrollIntoViewIfNeeded = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * https://github.com/gre/bezier-easing
	 * BezierEasing - use bezier curve for transition easing function
	 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	 */
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }
	
	function binarySubdivide (aX, aA, aB, mX1, mX2) {
	  var currentX, currentT, i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	   var currentSlope = getSlope(aGuessT, mX1, mX2);
	   if (currentSlope === 0.0) {
	     return aGuessT;
	   }
	   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	   aGuessT -= currentX / currentSlope;
	 }
	 return aGuessT;
	}
	
	var src = function bezier (mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  if (mX1 !== mY1 || mX2 !== mY2) {
	    for (var i = 0; i < kSplineTableSize; ++i) {
	      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  function getTForX (aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing (x) {
	    if (mX1 === mY1 && mX2 === mY2) {
	      return x; // linear
	    }
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};
	
	// Predefined set of animations. Similar to CSS easing functions
	var animations = {
	  ease:  src(0.25, 0.1, 0.25, 1),
	  easeIn: src(0.42, 0, 1, 1),
	  easeOut: src(0, 0, 0.58, 1),
	  easeInOut: src(0.42, 0, 0.58, 1),
	  linear: src(0, 0, 1, 1)
	};
	
	
	var amator = animate;
	
	function animate(source, target, options) {
	  var start= Object.create(null);
	  var diff = Object.create(null);
	  options = options || {};
	  // We let clients specify their own easing function
	  var easing = (typeof options.easing === 'function') ? options.easing : animations[options.easing];
	
	  // if nothing is specified, default to ease (similar to CSS animations)
	  if (!easing) {
	    if (options.easing) {
	      console.warn('Unknown easing function in amator: ' + options.easing);
	    }
	    easing = animations.ease;
	  }
	
	  var step = typeof options.step === 'function' ? options.step : noop;
	  var done = typeof options.done === 'function' ? options.done : noop;
	
	  var scheduler = getScheduler(options.scheduler);
	
	  var keys = Object.keys(target);
	  keys.forEach(function(key) {
	    start[key] = source[key];
	    diff[key] = target[key] - source[key];
	  });
	
	  var durationInMs = options.duration || 400;
	  var durationInFrames = Math.max(1, durationInMs * 0.06); // 0.06 because 60 frames pers 1,000 ms
	  var previousAnimationId;
	  var frame = 0;
	
	  previousAnimationId = scheduler.next(loop);
	
	  return {
	    cancel: cancel
	  }
	
	  function cancel() {
	    scheduler.cancel(previousAnimationId);
	    previousAnimationId = 0;
	  }
	
	  function loop() {
	    var t = easing(frame/durationInFrames);
	    frame += 1;
	    setValues(t);
	    if (frame <= durationInFrames) {
	      previousAnimationId = scheduler.next(loop);
	      step(source);
	    } else {
	      previousAnimationId = 0;
	      setTimeout(function() { done(source); }, 0);
	    }
	  }
	
	  function setValues(t) {
	    keys.forEach(function(key) {
	      source[key] = diff[key] * t + start[key];
	    });
	  }
	}
	
	function noop() { }
	
	function getScheduler(scheduler) {
	  if (!scheduler) {
	    var canRaf = typeof window !== 'undefined' && window.requestAnimationFrame;
	    return canRaf ? rafScheduler() : timeoutScheduler()
	  }
	  if (typeof scheduler.next !== 'function') throw new Error('Scheduler is supposed to have next(cb) function')
	  if (typeof scheduler.cancel !== 'function') throw new Error('Scheduler is supposed to have cancel(handle) function')
	
	  return scheduler
	}
	
	function rafScheduler() {
	  return {
	    next: window.requestAnimationFrame.bind(window),
	    cancel: window.cancelAnimationFrame.bind(window)
	  }
	}
	
	function timeoutScheduler() {
	  return {
	    next: function(cb) {
	      return setTimeout(cb, 1000/60)
	    },
	    cancel: function (id) {
	      return clearTimeout(id)
	    }
	  }
	}
	
	var __assign$1 = (undefined && undefined.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var handleScroll$1 = function (parent, _a) {
	    var scrollLeft = _a.scrollLeft, scrollTop = _a.scrollTop;
	    parent.scrollLeft = scrollLeft;
	    parent.scrollTop = scrollTop;
	};
	function calculate(target, options) {
	    if (!target || !(target instanceof HTMLElement))
	        throw new Error('Element is required in scrollIntoViewIfNeeded');
	    var config = __assign$1({ handleScroll: handleScroll$1 }, options);
	    var defaultOffset = { top: 0, right: 0, bottom: 0, left: 0 };
	    config.offset = config.offset
	        ? __assign$1({}, defaultOffset, config.offset) : defaultOffset;
	    function withinBounds(value, min, max, extent) {
	        if (config.centerIfNeeded === false ||
	            (max <= value + extent && value <= min + extent)) {
	            return Math.min(max, Math.max(min, value));
	        }
	        else {
	            return (min + max) / 2;
	        }
	    }
	    var offset = config.offset;
	    var offsetTop = offset.top;
	    var offsetLeft = offset.left;
	    var offsetBottom = offset.bottom;
	    var offsetRight = offset.right;
	    function makeArea(left, top, width, height) {
	        return {
	            left: left + offsetLeft,
	            top: top + offsetTop,
	            width: width,
	            height: height,
	            right: left + offsetLeft + width + offsetRight,
	            bottom: top + offsetTop + height + offsetBottom,
	            translate: function (x, y) {
	                return makeArea(x + left + offsetLeft, y + top + offsetTop, width, height);
	            },
	            relativeFromTo: function (lhs, rhs) {
	                var newLeft = left + offsetLeft, newTop = top + offsetTop;
	                lhs = lhs.offsetParent;
	                rhs = rhs.offsetParent;
	                if (lhs === rhs) {
	                    return area;
	                }
	                for (; lhs; lhs = lhs.offsetParent) {
	                    newLeft += lhs.offsetLeft + lhs.clientLeft;
	                    newTop += lhs.offsetTop + lhs.clientTop;
	                }
	                for (; rhs; rhs = rhs.offsetParent) {
	                    newLeft -= rhs.offsetLeft + rhs.clientLeft;
	                    newTop -= rhs.offsetTop + rhs.clientTop;
	                }
	                return makeArea(newLeft, newTop, width, height);
	            },
	        };
	    }
	    var parent, area = makeArea(target.offsetLeft, target.offsetTop, target.offsetWidth, target.offsetHeight);
	    while ((parent = target.parentNode) instanceof HTMLElement &&
	        target !== config.boundary) {
	        var clientLeft = parent.offsetLeft + parent.clientLeft;
	        var clientTop = parent.offsetTop + parent.clientTop;
	        // Make area relative to parent's client area.
	        area = area
	            .relativeFromTo(target, parent)
	            .translate(-clientLeft, -clientTop);
	        var scrollLeft = withinBounds(parent.scrollLeft, area.right - parent.clientWidth, area.left, parent.clientWidth);
	        var scrollTop = withinBounds(parent.scrollTop, area.bottom - parent.clientHeight, area.top, parent.clientHeight);
	        // Pass the new coordinates to the handleScroll callback
	        config.handleScroll(parent, { scrollLeft: scrollLeft, scrollTop: scrollTop }, config);
	        // Determine actual scroll amount by reading back scroll properties.
	        area = area.translate(clientLeft - parent.scrollLeft, clientTop - parent.scrollTop);
	        target = parent;
	    }
	}
	
	var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var handleScroll = function (parent, _a, config) {
	    var scrollLeft = _a.scrollLeft, scrollTop = _a.scrollTop;
	    if (config.duration) {
	        amator(parent, {
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	        }, { duration: config.duration, easing: config.easing });
	    }
	    else {
	        parent.scrollLeft = scrollLeft;
	        parent.scrollTop = scrollTop;
	    }
	};
	function isBoolean(options) {
	    return typeof options === 'boolean';
	}
	function scrollIntoViewIfNeeded(target, options, animateOptions, finalElement, offsetOptions) {
	    if (offsetOptions === void 0) { offsetOptions = {}; }
	    if (!target || !(target instanceof HTMLElement))
	        throw new Error('Element is required in scrollIntoViewIfNeeded');
	    var config = { centerIfNeeded: false, handleScroll: handleScroll };
	    if (isBoolean(options)) {
	        config.centerIfNeeded = options;
	    }
	    else {
	        config = __assign({}, config, options);
	    }
	    var defaultOffset = { top: 0, right: 0, bottom: 0, left: 0 };
	    config.offset = config.offset
	        ? __assign({}, defaultOffset, config.offset) : defaultOffset;
	    if (animateOptions) {
	        config.duration = animateOptions.duration;
	        config.easing = animateOptions.easing;
	    }
	    if (finalElement) {
	        config.boundary = finalElement;
	    }
	    if (offsetOptions.offsetTop) {
	        config.offset.top = offsetOptions.offsetTop;
	    }
	    if (offsetOptions.offsetRight) {
	        config.offset.right = offsetOptions.offsetRight;
	    }
	    if (offsetOptions.offsetBottom) {
	        config.offset.bottom = offsetOptions.offsetBottom;
	    }
	    if (offsetOptions.offsetLeft) {
	        config.offset.left = offsetOptions.offsetLeft;
	    }
	    return calculate(target, config);
	}
	
	return scrollIntoViewIfNeeded;
	
	})));


/***/ },
/* 1666 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/screen-share.cbf02c39.jpeg";

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module), (function() { return this; }())))

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(1668);
	var util = __webpack_require__(1670);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(1048);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ },
/* 1670 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(1672);
	var v4 = __webpack_require__(1673);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(688);
	var bytesToUuid = __webpack_require__(687);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/uuidjs/uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(688);
	var bytesToUuid = __webpack_require__(687);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(10);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var hashClear = __webpack_require__(__webpack_module_template_argument_0__),
	    hashDelete = __webpack_require__(__webpack_module_template_argument_1__),
	    hashGet = __webpack_require__(__webpack_module_template_argument_2__),
	    hashHas = __webpack_require__(__webpack_module_template_argument_3__),
	    hashSet = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var listCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
	    listCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
	    listCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
	    listCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
	    listCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var mapCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
	    mapCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
	    mapCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
	    mapCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
	    mapCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var MapCache = __webpack_require__(__webpack_module_template_argument_0__),
	    setCacheAdd = __webpack_require__(__webpack_module_template_argument_1__),
	    setCacheHas = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__),
	    stackClear = __webpack_require__(__webpack_module_template_argument_1__),
	    stackDelete = __webpack_require__(__webpack_module_template_argument_2__),
	    stackGet = __webpack_require__(__webpack_module_template_argument_3__),
	    stackHas = __webpack_require__(__webpack_module_template_argument_4__),
	    stackSet = __webpack_require__(__webpack_module_template_argument_5__);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var baseTimes = __webpack_require__(__webpack_module_template_argument_0__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_3__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_4__),
	    isTypedArray = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var eq = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseForOwn = __webpack_require__(__webpack_module_template_argument_0__),
	    createBaseEach = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var createBaseFor = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseFor = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var castPath = __webpack_require__(__webpack_module_template_argument_0__),
	    toKey = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayPush = __webpack_require__(__webpack_module_template_argument_0__),
	    isArray = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsEqualDeep = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	var Stack = __webpack_require__(__webpack_module_template_argument_0__),
	    equalArrays = __webpack_require__(__webpack_module_template_argument_1__),
	    equalByTag = __webpack_require__(__webpack_module_template_argument_2__),
	    equalObjects = __webpack_require__(__webpack_module_template_argument_3__),
	    getTag = __webpack_require__(__webpack_module_template_argument_4__),
	    isArray = __webpack_require__(__webpack_module_template_argument_5__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_6__),
	    isTypedArray = __webpack_require__(__webpack_module_template_argument_7__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var Stack = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIsEqual = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
	    isMasked = __webpack_require__(__webpack_module_template_argument_1__),
	    isObject = __webpack_require__(__webpack_module_template_argument_2__),
	    toSource = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isLength = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var baseMatches = __webpack_require__(__webpack_module_template_argument_0__),
	    baseMatchesProperty = __webpack_require__(__webpack_module_template_argument_1__),
	    identity = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__),
	    property = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isPrototype = __webpack_require__(__webpack_module_template_argument_0__),
	    nativeKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsMatch = __webpack_require__(__webpack_module_template_argument_0__),
	    getMatchData = __webpack_require__(__webpack_module_template_argument_1__),
	    matchesStrictComparable = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var baseIsEqual = __webpack_require__(__webpack_module_template_argument_0__),
	    get = __webpack_require__(__webpack_module_template_argument_1__),
	    hasIn = __webpack_require__(__webpack_module_template_argument_2__),
	    isKey = __webpack_require__(__webpack_module_template_argument_3__),
	    isStrictComparable = __webpack_require__(__webpack_module_template_argument_4__),
	    matchesStrictComparable = __webpack_require__(__webpack_module_template_argument_5__),
	    toKey = __webpack_require__(__webpack_module_template_argument_6__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    arrayMap = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_3__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var trimmedEndIndex = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var isArray = __webpack_require__(__webpack_module_template_argument_0__),
	    isKey = __webpack_require__(__webpack_module_template_argument_1__),
	    stringToPath = __webpack_require__(__webpack_module_template_argument_2__),
	    toString = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isArrayLike = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIteratee = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__),
	    keys = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var SetCache = __webpack_require__(__webpack_module_template_argument_0__),
	    arraySome = __webpack_require__(__webpack_module_template_argument_1__),
	    cacheHas = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    Uint8Array = __webpack_require__(__webpack_module_template_argument_1__),
	    eq = __webpack_require__(__webpack_module_template_argument_2__),
	    equalArrays = __webpack_require__(__webpack_module_template_argument_3__),
	    mapToArray = __webpack_require__(__webpack_module_template_argument_4__),
	    setToArray = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getAllKeys = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetAllKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    getSymbols = __webpack_require__(__webpack_module_template_argument_1__),
	    keys = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isKeyable = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isStrictComparable = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsNative = __webpack_require__(__webpack_module_template_argument_0__),
	    getValue = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayFilter = __webpack_require__(__webpack_module_template_argument_0__),
	    stubArray = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var DataView = __webpack_require__(__webpack_module_template_argument_0__),
	    Map = __webpack_require__(__webpack_module_template_argument_1__),
	    Promise = __webpack_require__(__webpack_module_template_argument_2__),
	    Set = __webpack_require__(__webpack_module_template_argument_3__),
	    WeakMap = __webpack_require__(__webpack_module_template_argument_4__),
	    baseGetTag = __webpack_require__(__webpack_module_template_argument_5__),
	    toSource = __webpack_require__(__webpack_module_template_argument_6__);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var castPath = __webpack_require__(__webpack_module_template_argument_0__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_3__),
	    isLength = __webpack_require__(__webpack_module_template_argument_4__),
	    toKey = __webpack_require__(__webpack_module_template_argument_5__);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var eq = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_2__),
	    isObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isArray = __webpack_require__(__webpack_module_template_argument_0__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var coreJsData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Hash = __webpack_require__(__webpack_module_template_argument_0__),
	    ListCache = __webpack_require__(__webpack_module_template_argument_1__),
	    Map = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var memoize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__),
	    Map = __webpack_require__(__webpack_module_template_argument_1__),
	    MapCache = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var memoizeCapped = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isSymbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var createFind = __webpack_require__(__webpack_module_template_argument_0__),
	    findIndex = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseFindIndex = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_1__),
	    toInteger = __webpack_require__(__webpack_module_template_argument_2__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseHasIn = __webpack_require__(__webpack_module_template_argument_0__),
	    hasPath = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsArguments = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
	    isLength = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(__webpack_module_template_argument_0__),
	    stubFalse = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)(module)))

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseIsEqual = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsTypedArray = __webpack_require__(__webpack_module_template_argument_0__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_1__),
	    nodeUtil = __webpack_require__(__webpack_module_template_argument_2__);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var arrayLikeKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    baseKeys = __webpack_require__(__webpack_module_template_argument_1__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var MapCache = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseProperty = __webpack_require__(__webpack_module_template_argument_0__),
	    basePropertyDeep = __webpack_require__(__webpack_module_template_argument_1__),
	    isKey = __webpack_require__(__webpack_module_template_argument_2__),
	    toKey = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toNumber = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toFinite = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseTrim = __webpack_require__(__webpack_module_template_argument_0__),
	    isObject = __webpack_require__(__webpack_module_template_argument_1__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseToString = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var identity = __webpack_require__(__webpack_module_template_argument_0__),
	    overRest = __webpack_require__(__webpack_module_template_argument_1__),
	    setToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var constant = __webpack_require__(__webpack_module_template_argument_0__),
	    defineProperty = __webpack_require__(__webpack_module_template_argument_1__),
	    identity = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var apply = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseSetToString = __webpack_require__(__webpack_module_template_argument_0__),
	    shortOut = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayPush = __webpack_require__(__webpack_module_template_argument_0__),
	    isFlattenable = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseEach = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	var arrayMap = __webpack_require__(__webpack_module_template_argument_0__),
	    baseGet = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__),
	    baseMap = __webpack_require__(__webpack_module_template_argument_3__),
	    baseSortBy = __webpack_require__(__webpack_module_template_argument_4__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_5__),
	    compareMultiple = __webpack_require__(__webpack_module_template_argument_6__),
	    identity = __webpack_require__(__webpack_module_template_argument_7__),
	    isArray = __webpack_require__(__webpack_module_template_argument_8__);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isSymbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var compareAscending = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseFlatten = __webpack_require__(__webpack_module_template_argument_0__),
	    baseOrderBy = __webpack_require__(__webpack_module_template_argument_1__),
	    baseRest = __webpack_require__(__webpack_module_template_argument_2__),
	    isIterateeCall = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.25de07c8.js